
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5cJUx", function(module, exports) {

$parcel$export(module.exports, "register", () => $3ca1afb3709d0cd0$export$6503ec6e8aabbaf, (v) => $3ca1afb3709d0cd0$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $3ca1afb3709d0cd0$export$f7ad0328861e2f03, (v) => $3ca1afb3709d0cd0$export$f7ad0328861e2f03 = v);
var $3ca1afb3709d0cd0$export$6503ec6e8aabbaf;
var $3ca1afb3709d0cd0$export$f7ad0328861e2f03;
"use strict";
var $3ca1afb3709d0cd0$var$mapping = new Map();
function $3ca1afb3709d0cd0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$3ca1afb3709d0cd0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $3ca1afb3709d0cd0$var$resolve(id) {
    var resolved = $3ca1afb3709d0cd0$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$3ca1afb3709d0cd0$export$6503ec6e8aabbaf = $3ca1afb3709d0cd0$var$register;
$3ca1afb3709d0cd0$export$f7ad0328861e2f03 = $3ca1afb3709d0cd0$var$resolve;

});

parcelRegister("hp8un", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $cabb5b2e254b7e33$export$bdfd709ae4826697, (v) => $cabb5b2e254b7e33$export$bdfd709ae4826697 = v);
var $cabb5b2e254b7e33$export$bdfd709ae4826697;
var $cabb5b2e254b7e33$export$c9e73fbda7da57b6;
var $cabb5b2e254b7e33$export$5a759dc7a1cfb72a;
"use strict";
var $cabb5b2e254b7e33$var$bundleURL = {};
function $cabb5b2e254b7e33$var$getBundleURLCached(id) {
    var value = $cabb5b2e254b7e33$var$bundleURL[id];
    if (!value) {
        value = $cabb5b2e254b7e33$var$getBundleURL();
        $cabb5b2e254b7e33$var$bundleURL[id] = value;
    }
    return value;
}
function $cabb5b2e254b7e33$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $cabb5b2e254b7e33$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $cabb5b2e254b7e33$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $cabb5b2e254b7e33$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$cabb5b2e254b7e33$export$bdfd709ae4826697 = $cabb5b2e254b7e33$var$getBundleURLCached;
$cabb5b2e254b7e33$export$c9e73fbda7da57b6 = $cabb5b2e254b7e33$var$getBaseURL;
$cabb5b2e254b7e33$export$5a759dc7a1cfb72a = $cabb5b2e254b7e33$var$getOrigin;

});

parcelRegister("lu5Mq", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $fa40e2170e1d4764$export$ffb0004e005737fa, (v) => $fa40e2170e1d4764$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $fa40e2170e1d4764$export$34b9dba7ce09269b, (v) => $fa40e2170e1d4764$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $fa40e2170e1d4764$export$25062201e9e25d76, (v) => $fa40e2170e1d4764$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa40e2170e1d4764$export$ffb0004e005737fa;
var $fa40e2170e1d4764$export$34b9dba7ce09269b;
var $fa40e2170e1d4764$export$25062201e9e25d76;
'use strict';

(function() {
    'use strict';
    var React = (parcelRequire("jMaZ8"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = '' + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = '' + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, 'key')) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== 'key';
            });
            var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $fa40e2170e1d4764$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $fa40e2170e1d4764$export$34b9dba7ce09269b = jsx;
    $fa40e2170e1d4764$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("jMaZ8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aEOcU"));

});
parcelRegister("aEOcU", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = '18.3.1';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ''; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || '';
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== 'object' && typeof partialState !== 'function' && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
    };
    var deprecatedAPIs = {
        isMounted: [
            'isMounted',
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            'replaceState',
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = '.';
    var SUBSEPARATOR = ':';
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            '=': '=0',
            ':': '=2'
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return '$' + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, '$&/');
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === 'object' && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape('' + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case 'string':
            case 'number':
                invokeCallback = true;
                break;
            case 'object':
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = '';
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + '/';
                mapIntoArray(mappedChild, array, escapedChildKey, '', function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === 'function') {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === 'object') {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, '', '', function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error('React.Children.only expected to receive a single React element child.');
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!('default' in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'defaultProps', {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'propTypes', {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== 'function') error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
        else if (render.length !== 0 && render.length !== 2) error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? 'null' : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, 'type', {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ('require' + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, 'timers').setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === 'undefined') error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === 'object' && typeof result.then === 'function') {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== 'undefined') // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("cEcQP", function(module, exports) {
function $9353306486c22219$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9353306486c22219$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9353306486c22219$var$_typeof(o);
}
module.exports = $9353306486c22219$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("17meZ", function(module, exports) {

var $giHIY = parcelRequire("giHIY");
function $0d07b27085fbdf22$var$_defineProperty(e, r, t) {
    return (r = $giHIY(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $0d07b27085fbdf22$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("giHIY", function(module, exports) {

var $cEcQP = parcelRequire("cEcQP");
var $bde03e89ab3f2e03$var$_typeof = $cEcQP.default;

var $k5sv2 = parcelRequire("k5sv2");
function $bde03e89ab3f2e03$var$toPropertyKey(t) {
    var i = $k5sv2(t, "string");
    return "symbol" == $bde03e89ab3f2e03$var$_typeof(i) ? i : i + "";
}
module.exports = $bde03e89ab3f2e03$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k5sv2", function(module, exports) {

var $cEcQP = parcelRequire("cEcQP");
var $e9fa61b0bb512d9f$var$_typeof = $cEcQP.default;
function $e9fa61b0bb512d9f$var$toPrimitive(t, r) {
    if ("object" != $e9fa61b0bb512d9f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e9fa61b0bb512d9f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $e9fa61b0bb512d9f$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fEEQL", function(module, exports) {

var $akltj = parcelRequire("akltj");

var $1ktV1 = parcelRequire("1ktV1");

var $de4uR = parcelRequire("de4uR");

var $bhST4 = parcelRequire("bhST4");
function $b65a47690347493b$var$_slicedToArray(r, e) {
    return $akltj(r) || $1ktV1(r, e) || $de4uR(r, e) || $bhST4();
}
module.exports = $b65a47690347493b$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("akltj", function(module, exports) {
function $784c6d7b66ddf722$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $784c6d7b66ddf722$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1ktV1", function(module, exports) {
function $0f7edded4084568a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $0f7edded4084568a$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("de4uR", function(module, exports) {

var $ihHBD = parcelRequire("ihHBD");
function $9a10121c905bc2ff$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ihHBD(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ihHBD(r, a) : void 0;
    }
}
module.exports = $9a10121c905bc2ff$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ihHBD", function(module, exports) {
function $d4fba3cb3e25080f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $d4fba3cb3e25080f$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bhST4", function(module, exports) {
function $837bdbba16de0f4f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $837bdbba16de0f4f$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6UWRi", function(module, exports) {
'use strict';
function $5095a123d44d6449$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

module.exports = (parcelRequire("66Gdy"));

});
parcelRegister("66Gdy", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $47240d2cf7efb5e7$export$ae55be85d98224ed, (v) => $47240d2cf7efb5e7$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $47240d2cf7efb5e7$export$d39a5bbd09211389, (v) => $47240d2cf7efb5e7$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $47240d2cf7efb5e7$export$882461b6382ed46c, (v) => $47240d2cf7efb5e7$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $47240d2cf7efb5e7$export$466bfc07425424d5, (v) => $47240d2cf7efb5e7$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $47240d2cf7efb5e7$export$cd75ccfd720a3cd4, (v) => $47240d2cf7efb5e7$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $47240d2cf7efb5e7$export$fa8d919ba61d84db, (v) => $47240d2cf7efb5e7$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $47240d2cf7efb5e7$export$757ceba2d55c277e, (v) => $47240d2cf7efb5e7$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $47240d2cf7efb5e7$export$b3890eb0ae9dca99, (v) => $47240d2cf7efb5e7$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $47240d2cf7efb5e7$export$502457920280e6be, (v) => $47240d2cf7efb5e7$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $47240d2cf7efb5e7$export$c78a37762a8d58e1, (v) => $47240d2cf7efb5e7$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $47240d2cf7efb5e7$export$dc54d992c10e8a18, (v) => $47240d2cf7efb5e7$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $47240d2cf7efb5e7$export$83d89fbfd8236492, (v) => $47240d2cf7efb5e7$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $47240d2cf7efb5e7$export$ae55be85d98224ed;
var $47240d2cf7efb5e7$export$d39a5bbd09211389;
var $47240d2cf7efb5e7$export$882461b6382ed46c;
var $47240d2cf7efb5e7$export$466bfc07425424d5;
var $47240d2cf7efb5e7$export$cd75ccfd720a3cd4;
var $47240d2cf7efb5e7$export$fa8d919ba61d84db;
var $47240d2cf7efb5e7$export$757ceba2d55c277e;
var $47240d2cf7efb5e7$export$b3890eb0ae9dca99;
var $47240d2cf7efb5e7$export$502457920280e6be;
var $47240d2cf7efb5e7$export$c78a37762a8d58e1;
var $47240d2cf7efb5e7$export$dc54d992c10e8a18;
var $47240d2cf7efb5e7$export$83d89fbfd8236492;
'use strict';


(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("jMaZ8"));
    var Scheduler = (parcelRequire("dWHZ7"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning('warn', format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning('error', format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === 'onDoubleClick') possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'disableRemotePlayback',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL('' + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === '') return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === '' + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === '' + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === '' + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, '' + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : '';
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = '' + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_SCOPE_TYPE = Symbol.for('react.scope');
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for('react.debug_trace_mode');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for('react.legacy_hidden');
    var REACT_CACHE_TYPE = Symbol.for('react.cache');
    var REACT_TRACING_MARKER_TYPE = Symbol.for('react.tracing_marker');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame('Lazy');
            case SuspenseComponent:
                return describeBuiltInComponentFrame('Suspense');
            case SuspenseListComponent:
                return describeBuiltInComponentFrame('SuspenseList');
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return '';
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = '';
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || 'Context';
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return 'Cache';
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + '.Consumer';
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + '.Provider';
            case DehydratedFragment:
                return 'DehydratedFragment';
            case ForwardRef:
                return getWrappedName$1(type, type.render, 'ForwardRef');
            case Fragment:
                return 'Fragment';
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return 'Portal';
            case HostRoot:
                return 'Root';
            case HostText:
                return 'Text';
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return 'StrictMode';
                return 'Mode';
            case OffscreenComponent:
                return 'Offscreen';
            case Profiler:
                return 'Profiler';
            case ScopeComponent:
                return 'Scope';
            case SuspenseComponent:
                return 'Suspense';
            case SuspenseListComponent:
                return 'SuspenseList';
            case TracingMarkerComponent:
                return 'TracingMarker';
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === 'function') return type.displayName || type.name || null;
                if (typeof type === 'string') return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
                return value;
            case 'object':
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return '';
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = '';
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? 'true' : 'false';
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps('input', props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, 'checked', checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === 'number') {
                if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty('value')) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty('defaultValue')) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== '') node.name = '';
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== '') node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, 'name');
            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === 'object' && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === 'string' || typeof child === 'number') return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute('value', toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return '\n\nCheck the render method of `' + ownerName + '`.';
        return '';
    }
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps('select', props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps('textarea', props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
                if (isArray(children)) {
                    if (children.length > 1) throw new Error('<textarea> can only have at most one child.');
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = '';
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg'; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!('innerHTML' in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimingFunction'
        ],
        background: [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ],
        backgroundPosition: [
            'backgroundPositionX',
            'backgroundPositionY'
        ],
        border: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderBlockEnd: [
            'borderBlockEndColor',
            'borderBlockEndStyle',
            'borderBlockEndWidth'
        ],
        borderBlockStart: [
            'borderBlockStartColor',
            'borderBlockStartStyle',
            'borderBlockStartWidth'
        ],
        borderBottom: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ],
        borderColor: [
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor'
        ],
        borderImage: [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ],
        borderInlineEnd: [
            'borderInlineEndColor',
            'borderInlineEndStyle',
            'borderInlineEndWidth'
        ],
        borderInlineStart: [
            'borderInlineStartColor',
            'borderInlineStartStyle',
            'borderInlineStartWidth'
        ],
        borderLeft: [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ],
        borderRadius: [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ],
        borderRight: [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ],
        borderStyle: [
            'borderBottomStyle',
            'borderLeftStyle',
            'borderRightStyle',
            'borderTopStyle'
        ],
        borderTop: [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderWidth: [
            'borderBottomWidth',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth'
        ],
        columnRule: [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ],
        columns: [
            'columnCount',
            'columnWidth'
        ],
        flex: [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ],
        flexFlow: [
            'flexDirection',
            'flexWrap'
        ],
        font: [
            'fontFamily',
            'fontFeatureSettings',
            'fontKerning',
            'fontLanguageOverride',
            'fontSize',
            'fontSizeAdjust',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition',
            'fontWeight',
            'lineHeight'
        ],
        fontVariant: [
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition'
        ],
        gap: [
            'columnGap',
            'rowGap'
        ],
        grid: [
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        gridArea: [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ],
        gridColumn: [
            'gridColumnEnd',
            'gridColumnStart'
        ],
        gridColumnGap: [
            'columnGap'
        ],
        gridGap: [
            'columnGap',
            'rowGap'
        ],
        gridRow: [
            'gridRowEnd',
            'gridRowStart'
        ],
        gridRowGap: [
            'rowGap'
        ],
        gridTemplate: [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        listStyle: [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ],
        margin: [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ],
        marker: [
            'markerEnd',
            'markerMid',
            'markerStart'
        ],
        mask: [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPositionX',
            'maskPositionY',
            'maskRepeat',
            'maskSize'
        ],
        maskPosition: [
            'maskPositionX',
            'maskPositionY'
        ],
        outline: [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ],
        overflow: [
            'overflowX',
            'overflowY'
        ],
        padding: [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ],
        placeContent: [
            'alignContent',
            'justifyContent'
        ],
        placeItems: [
            'alignItems',
            'justifyItems'
        ],
        placeSelf: [
            'alignSelf',
            'justifySelf'
        ],
        textDecoration: [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle'
        ],
        textEmphasis: [
            'textEmphasisColor',
            'textEmphasisStyle'
        ],
        transition: [
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ],
        wordWrap: [
            'overflowWrap'
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
            if (typeof props.dangerouslySetInnerHTML !== 'object' || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== 'object') throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        imagesizes: 'imageSizes',
        imagesrcset: 'imageSrcSet',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-description': 0,
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== 'function') throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== 'function') throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, 'passive', {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === 'undefined' || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event');
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === 'object') try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error('Unable to find node on an unmounted component.');
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error('Unable to find node on an unmounted component.');
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error('Unable to find node on an unmounted component.');
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error('Unable to find node on an unmounted component.');
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error('React instrumentation encountered an error: %s.', err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === 'function') try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === 'function') {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === 'function') try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === 'function') injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === 'function') injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === 'function') injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === 'function') injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === 'function') injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === 'function') injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === 'function') injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === 'function') injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === 'function') injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === 'function') injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === 'function') injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === 'function') injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === 'function') injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === 'function') injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === 'function') injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === 'function') injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return 'Sync';
        if (lane & InputContinuousHydrationLane) return 'InputContinuousHydration';
        if (lane & InputContinuousLane) return 'InputContinuous';
        if (lane & DefaultHydrationLane) return 'DefaultHydration';
        if (lane & DefaultLane) return 'Default';
        if (lane & TransitionHydrationLane) return 'TransitionHydration';
        if (lane & TransitionLanes) return 'Transition';
        if (lane & RetryLanes) return 'Retry';
        if (lane & SelectiveHydrationLane) return 'SelectiveHydration';
        if (lane & IdleHydrationLane) return 'IdleHydration';
        if (lane & IdleLane) return 'Idle';
        if (lane & OffscreenLane) return 'Offscreen';
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        'mousedown',
        'mouseup',
        'touchcancel',
        'touchend',
        'touchstart',
        'auxclick',
        'dblclick',
        'pointercancel',
        'pointerdown',
        'pointerup',
        'dragend',
        'dragstart',
        'drop',
        'compositionend',
        'compositionstart',
        'keydown',
        'keypress',
        'keyup',
        'input',
        'textInput',
        'copy',
        'cut',
        'paste',
        'click',
        'change',
        'contextmenu',
        'reset',
        'submit'
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case 'focusin':
            case 'focusout':
                queuedFocus = null;
                break;
            case 'dragenter':
            case 'dragleave':
                queuedDrag = null;
                break;
            case 'mouseover':
            case 'mouseout':
                queuedMouse = null;
                break;
            case 'pointerover':
            case 'pointerout':
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case 'focusin':
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case 'dragenter':
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case 'mouseover':
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case 'pointerover':
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case 'gotpointercapture':
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            // eslint-disable-next-line no-fallthrough
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            // eslint-disable-next-line no-fallthrough
            case 'beforeblur':
            case 'afterblur':
            // eslint-disable-next-line no-fallthrough
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
                return DiscreteEventPriority;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'toggle':
            case 'touchmove':
            case 'wheel':
            // eslint-disable-next-line no-fallthrough
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
                return ContinuousEventPriority;
            case 'message':
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ('value' in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== 'unknown') event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== 'unknown') // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === 'mousemove') {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ('movementX' in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ('movementY' in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== 'Unidentified') return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        return '';
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') return getEventCharCode(event);
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
    var documentMode = null;
    if (canUseDOM && 'documentMode' in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste'
        ]);
        registerTwoPhaseEvent('onCompositionEnd', [
            'compositionend',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionStart', [
            'compositionstart',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionUpdate', [
            'compositionupdate',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case 'compositionstart':
                return 'onCompositionStart';
            case 'compositionend':
                return 'onCompositionEnd';
            case 'compositionupdate':
                return 'onCompositionUpdate';
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case 'keyup':
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case 'keydown':
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = 'onCompositionStart';
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = 'onCompositionEnd';
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === 'onCompositionStart') isComposing = initialize(nativeEventTarget);
            else if (eventType === 'onCompositionEnd') {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case 'compositionend':
                return getDataFromCustomEvent(nativeEvent);
            case 'keypress':
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case 'textInput':
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case 'paste':
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case 'keypress':
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case 'compositionend':
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') return !!supportedInputTypes[elem.type];
        if (nodeName === 'textarea') return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent('onChange', [
            'change',
            'click',
            'focusin',
            'focusout',
            'input',
            'keydown',
            'keyup',
            'selectionchange'
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');
        if (listeners.length > 0) {
            var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, 'number', node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === 'focusout') handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent('onMouseEnter', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onMouseLeave', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onPointerEnter', [
            'pointerout',
            'pointerover'
        ]);
        registerDirectEvent('onPointerLeave', [
            'pointerout',
            'pointerover'
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';
        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = 'onPointerLeave';
            enterEventType = 'onPointerEnter';
            eventTypePrefix = 'pointer';
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ('contains' in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === 'function') priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ('selectionStart' in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', [
            'focusout',
            'contextmenu',
            'dragend',
            'focusin',
            'keydown',
            'keyup',
            'mousedown',
            'mouseup',
            'selectionchange'
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');
            if (listeners.length > 0) {
                var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case 'focusin':
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case 'focusout':
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case 'mousedown':
                mouseDown = true;
                break;
            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case 'selectionchange':
                if (skipSelectionChangeEvent) break;
            // falls through
            case 'keydown':
            case 'keyup':
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!('TransitionEvent' in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName('animationend');
    var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
    var ANIMATION_START = getVendorPrefixedEventName('animationstart');
    var TRANSITION_END = getVendorPrefixedEventName('transitionend');
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        'abort',
        'auxClick',
        'cancel',
        'canPlay',
        'canPlayThrough',
        'click',
        'close',
        'contextMenu',
        'copy',
        'cut',
        'drag',
        'dragEnd',
        'dragEnter',
        'dragExit',
        'dragLeave',
        'dragOver',
        'dragStart',
        'drop',
        'durationChange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'gotPointerCapture',
        'input',
        'invalid',
        'keyDown',
        'keyPress',
        'keyUp',
        'load',
        'loadedData',
        'loadedMetadata',
        'loadStart',
        'lostPointerCapture',
        'mouseDown',
        'mouseMove',
        'mouseOut',
        'mouseOver',
        'mouseUp',
        'paste',
        'pause',
        'play',
        'playing',
        'pointerCancel',
        'pointerDown',
        'pointerMove',
        'pointerOut',
        'pointerOver',
        'pointerUp',
        'progress',
        'rateChange',
        'reset',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'submit',
        'suspend',
        'timeUpdate',
        'touchCancel',
        'touchEnd',
        'touchStart',
        'volumeChange',
        'scroll',
        'toggle',
        'touchMove',
        'waiting',
        'wheel'
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, 'on' + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, 'onAnimationEnd');
        registerSimpleEvent(ANIMATION_ITERATION, 'onAnimationIteration');
        registerSimpleEvent(ANIMATION_START, 'onAnimationStart');
        registerSimpleEvent('dblclick', 'onDoubleClick');
        registerSimpleEvent('focusin', 'onFocus');
        registerSimpleEvent('focusout', 'onBlur');
        registerSimpleEvent(TRANSITION_END, 'onTransitionEnd');
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case 'keypress':
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case 'keydown':
            case 'keyup':
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case 'focusin':
                reactEventType = 'focus';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'focusout':
                reactEventType = 'blur';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'beforeblur':
            case 'afterblur':
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'click':
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            /* falls through */ case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case 'scroll':
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case 'wheel':
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case 'copy':
            case 'cut':
            case 'paste':
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === 'scroll';
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        'abort',
        'canplay',
        'canplaythrough',
        'durationchange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'loadeddata',
        'loadedmetadata',
        'loadstart',
        'pause',
        'play',
        'playing',
        'progress',
        'ratechange',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'suspend',
        'timeupdate',
        'volumechange',
        'waiting'
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        'cancel',
        'close',
        'invalid',
        'load',
        'scroll',
        'toggle'
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== 'selectionchange') {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent('selectionchange', false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
    var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
    var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
    var AUTOFOCUS = 'autoFocus';
    var CHILDREN = 'children';
    var STYLE = 'style';
    var HTML$1 = '__html';
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error('Extra attributes from the server: %s', names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error('Text content does not match server-rendered HTML.');
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string') {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === 'number') setTextContent(domElement, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === 'script') {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement('div');
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === 'select') {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                props = rawProps;
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = '';
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = '';
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string' || typeof nextProp === 'number') (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case 'input':
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case 'value':
                    break;
                case 'checked':
                    break;
                case 'selected':
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === 'string') {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === 'number') {
                    if (domElement.textContent !== '' + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            '' + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === 'boolean') {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute('style');
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === '') // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'base',
        'basefont',
        'bgsound',
        'blockquote',
        'body',
        'br',
        'button',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dir',
        'div',
        'dl',
        'dt',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'iframe',
        'img',
        'input',
        'isindex',
        'li',
        'link',
        'listing',
        'main',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'nav',
        'noembed',
        'noframes',
        'noscript',
        'object',
        'ol',
        'p',
        'param',
        'plaintext',
        'pre',
        'script',
        'section',
        'select',
        'source',
        'style',
        'summary',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul',
        'wbr',
        'xmp'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        'applet',
        'caption',
        'html',
        'table',
        'td',
        'th',
        'marquee',
        'object',
        'template',
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject',
        'desc',
        'title'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        'button'
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        'dd',
        'dt',
        'li',
        'option',
        'optgroup',
        'p',
        'rp',
        'rt'
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === 'form') ancestorInfo.formTag = info;
        if (tag === 'a') ancestorInfo.aTagInScope = info;
        if (tag === 'button') ancestorInfo.buttonTagInScope = info;
        if (tag === 'nobr') ancestorInfo.nobrTagInScope = info;
        if (tag === 'p') ancestorInfo.pTagInButtonScope = info;
        if (tag === 'li') ancestorInfo.listItemTagAutoclosing = info;
        if (tag === 'dd' || tag === 'dt') ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
                return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case 'option':
                return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case 'tbody':
            case 'thead':
            case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case 'colgroup':
                return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
                return tag === 'frame';
            case '#document':
                return tag === 'html';
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return ancestorInfo.pTagInButtonScope;
            case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
                return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
                return ancestorInfo.buttonTagInScope;
            case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case 'nobr':
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error('validateDOMNesting: when childText is passed, childTag should be null');
            childTag = '#text';
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = '';
        if (childTag === '#text') {
            if (/\S/.test(childText)) tagDisplayName = 'Text nodes';
            else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = '<' + childTag + '>';
        if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
    var SUSPENSE_START_DATA = '$';
    var SUSPENSE_END_DATA = '/$';
    var SUSPENSE_PENDING_START_DATA = '$?';
    var SUSPENSE_FALLBACK_START_DATA = '$!';
    var STYLE$1 = 'style';
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
            case 'img':
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === 'function' ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : typeof localPromise !== 'undefined' ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                if (newProps.autoFocus) domElement.focus();
                return;
            case 'img':
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, '');
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') style.setProperty('display', 'none', 'important');
        else style.display = 'none';
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = '';
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== 'head' && parentType !== 'body';
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error('An error occurred during hydration. The server HTML was replaced with client content in <%s>.', parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = '__reactFiber$' + randomKey;
    var internalPropsKey = '__reactProps$' + randomKey;
    var internalContainerInstanceKey = '__reactContainer$' + randomKey;
    var internalEventHandlersKey = '__reactEvents$' + randomKey;
    var internalEventHandlerListenersKey = '__reactListeners$' + randomKey;
    var internalEventHandlesSetKey = '__reactHandles$' + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error('getNodeFromInstance: Invalid argument.');
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error('Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) error('Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || 'Unknown';
        checkPropTypes(contextTypes, context, 'context', name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== 'function') {
            var componentName = getComponentNameFromFiber(fiber) || 'Unknown';
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
        }
        var name = getComponentNameFromFiber(fiber) || 'Unknown';
        checkPropTypes(childContextTypes, childContext, 'child context', name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = '';
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error('We should not be hydrating here. This is a bug in React. Please file a bug.');
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== 'object') throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === 'function' && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + 'bug in React. Please file an issue.');
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, 'ref');
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== 'string') throw new Error('Expected ref to be a function, a string, an object returned by React.createRef(), or null.');
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + ' the following reasons:\n' + '1. You may be adding a ref to a function component\n' + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + '3. You have multiple copies of React loaded\n' + 'See https://reactjs.org/link/refs-must-have-owner for more information.');
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== 'function') throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error('An iterable object provided no iterator.');
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error('Resuming work not yet implemented.');
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error('We just came from a parent so we must have had a parent. This is a bug in React.');
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== 'function') throw new Error('Invalid argument passed as callback. Expected a function. Instead ' + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error('Rendered more hooks than during the previous render.');
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error('The result of getServerSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error('The result of getSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error('The result of getSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty('current')) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ':' + identifierPrefix + 'R' + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += 'H' + localId.toString(32);
            id += ':';
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ':' + identifierPrefix + 'r' + globalClientId.toString(32) + ':';
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + '_' + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === 'function') error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || 'A pure component');
        if (typeof instance.componentDidUnmount === 'function') error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === 'function') error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === 'function') error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === 'function') error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === 'function') error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === 'function') error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray(_state))) error('%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || 'Anonymous';
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console['error'](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== 'function') // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || 'Unknown');
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || 'Unknown';
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === 'hidden' || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error('Simulated error coming from DevTools');
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error('Should have a current fiber. This is a bug in React.');
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = '';
        if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        }
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error('%s: Function components do not support contextType.', _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: 'visible',
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === 'function';
        if (isAnArray || isIterable) {
            var type = isAnArray ? 'array' : 'iterable';
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== 'function') error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== 'function') {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = 'useLayoutEffect';
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = 'useInsertionEffect';
                        else hookName = 'useEffect';
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === 'function') addendum = '\n\nIt looks like you wrote ' + hookName + '(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + hookName + '(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                        else addendum = ' You returned: ' + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onPostCommit === 'function') onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onRender === 'function') onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === 'function') onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === 'function') safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === 'function') {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty('current')) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error('Expected finished root and lanes to be set. This is a bug in React.');
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor('selector.role');
        TEST_NAME_TYPE = symbolFor('selector.test_id');
        TEXT_TYPE = symbolFor('selector.text');
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== 'undefined';
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error('useInsertionEffect must not schedule updates.');
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error('Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.');
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error('Root did not complete. This is a bug in React.');
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error('Unknown root exit status.');
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error('Root did not complete. This is a bug in React.');
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Cannot flush passive effects while already rendering.');
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || 'ReactComponent';
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === 'object' && replayError !== null && replayError._suppressLogging && typeof originalError === 'object' && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || 'Unknown';
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== 'string') error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = 'DELETED';
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? 'hydrateRoot()' : 'createRoot()';
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? 'hydrate()' : 'render()';
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = '18.3.1';
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw new Error('Unable to find node on an unmounted component.');
            else {
                var keys = Object.keys(component).join(',');
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || 'Unknown');
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== 'function') error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === 'function' ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console['error'](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error('Cannot update an unmounted root.');
        if (typeof arguments[1] === 'function') error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== 'undefined') error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === 'function') error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error('createRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn('hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.');
            else if (typeof options === 'object' && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error('hydrateRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === 'function') {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== 'function') error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || 'A component');
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error('Target container is not a DOM element.');
        if (parentComponent == null || !has(parentComponent)) throw new Error('parentComponent must be a valid React Component');
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error('unmountComponentAtNode(...): Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error('Target container is not a DOM element.');
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === 'file:' ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ''), 'font-weight:bold');
        }
    }
    $47240d2cf7efb5e7$export$ae55be85d98224ed = Internals;
    $47240d2cf7efb5e7$export$d39a5bbd09211389 = createPortal$1;
    $47240d2cf7efb5e7$export$882461b6382ed46c = createRoot$1;
    $47240d2cf7efb5e7$export$466bfc07425424d5 = findDOMNode;
    $47240d2cf7efb5e7$export$cd75ccfd720a3cd4 = flushSync$1;
    $47240d2cf7efb5e7$export$fa8d919ba61d84db = hydrate;
    $47240d2cf7efb5e7$export$757ceba2d55c277e = hydrateRoot$1;
    $47240d2cf7efb5e7$export$b3890eb0ae9dca99 = render;
    $47240d2cf7efb5e7$export$502457920280e6be = unmountComponentAtNode;
    $47240d2cf7efb5e7$export$c78a37762a8d58e1 = batchedUpdates$1;
    $47240d2cf7efb5e7$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $47240d2cf7efb5e7$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("dWHZ7", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g6hEz"));

});
parcelRegister("g6hEz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bb8ae6727a83a684$export$c4744153514ff05d, (v) => $bb8ae6727a83a684$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bb8ae6727a83a684$export$3e506c1ccc9cc1a7, (v) => $bb8ae6727a83a684$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bb8ae6727a83a684$export$e26fe2ed2fa76875, (v) => $bb8ae6727a83a684$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bb8ae6727a83a684$export$502329bbf4b505b1, (v) => $bb8ae6727a83a684$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bb8ae6727a83a684$export$6e3807111c4874c4, (v) => $bb8ae6727a83a684$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bb8ae6727a83a684$export$c27134553091fb3a, (v) => $bb8ae6727a83a684$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bb8ae6727a83a684$export$33ee1acdc04fd2a2, (v) => $bb8ae6727a83a684$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bb8ae6727a83a684$export$b00a404bbd5edef2, (v) => $bb8ae6727a83a684$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bb8ae6727a83a684$export$8352ce38b91d0c62, (v) => $bb8ae6727a83a684$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bb8ae6727a83a684$export$d66a1c1c77bd778b, (v) => $bb8ae6727a83a684$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bb8ae6727a83a684$export$d3dfb8e4810cb555, (v) => $bb8ae6727a83a684$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bb8ae6727a83a684$export$839f9183b0465a69, (v) => $bb8ae6727a83a684$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bb8ae6727a83a684$export$72fdf0e06517287b, (v) => $bb8ae6727a83a684$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bb8ae6727a83a684$export$4b844e58a3e414b4, (v) => $bb8ae6727a83a684$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bb8ae6727a83a684$export$816d2913ae6b83b1, (v) => $bb8ae6727a83a684$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bb8ae6727a83a684$export$61bcfe829111a1d0, (v) => $bb8ae6727a83a684$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bb8ae6727a83a684$export$7ee8c9beb337bc3f, (v) => $bb8ae6727a83a684$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bb8ae6727a83a684$export$b5836b71941fa3ed, (v) => $bb8ae6727a83a684$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bb8ae6727a83a684$export$cf845f2c119da08a, (v) => $bb8ae6727a83a684$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb8ae6727a83a684$export$c4744153514ff05d;
var $bb8ae6727a83a684$export$3e506c1ccc9cc1a7;
var $bb8ae6727a83a684$export$e26fe2ed2fa76875;
var $bb8ae6727a83a684$export$502329bbf4b505b1;
var $bb8ae6727a83a684$export$6e3807111c4874c4;
var $bb8ae6727a83a684$export$c27134553091fb3a;
var $bb8ae6727a83a684$export$33ee1acdc04fd2a2;
var $bb8ae6727a83a684$export$b00a404bbd5edef2;
var $bb8ae6727a83a684$export$8352ce38b91d0c62;
var $bb8ae6727a83a684$export$d66a1c1c77bd778b;
var $bb8ae6727a83a684$export$d3dfb8e4810cb555;
var $bb8ae6727a83a684$export$839f9183b0465a69;
var $bb8ae6727a83a684$export$72fdf0e06517287b;
var $bb8ae6727a83a684$export$4b844e58a3e414b4;
var $bb8ae6727a83a684$export$816d2913ae6b83b1;
var $bb8ae6727a83a684$export$61bcfe829111a1d0;
var $bb8ae6727a83a684$export$7ee8c9beb337bc3f;
var $bb8ae6727a83a684$export$b5836b71941fa3ed;
var $bb8ae6727a83a684$export$cf845f2c119da08a;
'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $bb8ae6727a83a684$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $bb8ae6727a83a684$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === 'function' ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === 'function' ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== 'undefined' ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== 'undefined' && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $bb8ae6727a83a684$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === 'function') {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $bb8ae6727a83a684$export$c4744153514ff05d();
                if (typeof continuationCallback === 'function') currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $bb8ae6727a83a684$export$c4744153514ff05d();
        var startTime;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $bb8ae6727a83a684$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console['error']("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $bb8ae6727a83a684$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === 'function') // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== 'undefined') {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($bb8ae6727a83a684$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $bb8ae6727a83a684$export$3e506c1ccc9cc1a7 = IdlePriority;
    $bb8ae6727a83a684$export$e26fe2ed2fa76875 = ImmediatePriority;
    $bb8ae6727a83a684$export$502329bbf4b505b1 = LowPriority;
    $bb8ae6727a83a684$export$6e3807111c4874c4 = NormalPriority;
    $bb8ae6727a83a684$export$c27134553091fb3a = unstable_Profiling;
    $bb8ae6727a83a684$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $bb8ae6727a83a684$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $bb8ae6727a83a684$export$8352ce38b91d0c62 = unstable_continueExecution;
    $bb8ae6727a83a684$export$d66a1c1c77bd778b = forceFrameRate;
    $bb8ae6727a83a684$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $bb8ae6727a83a684$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $bb8ae6727a83a684$export$72fdf0e06517287b = unstable_next;
    $bb8ae6727a83a684$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $bb8ae6727a83a684$export$816d2913ae6b83b1 = unstable_requestPaint;
    $bb8ae6727a83a684$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $bb8ae6727a83a684$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $bb8ae6727a83a684$export$b5836b71941fa3ed = shouldYieldToHost;
    $bb8ae6727a83a684$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});




parcelRegister("3dJIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $25860da39cb77004$export$2e2bcd8739ae039);
function useProdHMR() {
    return false;
}
var webpackHMR = false;
function useDevHMR() {
    return webpackHMR;
}
var $25860da39cb77004$export$2e2bcd8739ae039 = useDevHMR;
// Webpack `module.hot.accept` do not support any deps update trigger
// We have to hack handler to force mark as HRM
if (module && module.hot && typeof window !== 'undefined') {
    // Use `globalThis` first, and `window` for older browsers
    // const win = globalThis as any;
    var win = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : null;
    if (win && typeof win.webpackHotUpdate === 'function') {
        var originWebpackHotUpdate = win.webpackHotUpdate;
        win.webpackHotUpdate = function() {
            webpackHMR = true;
            setTimeout(function() {
                webpackHMR = false;
            }, 0);
            return originWebpackHotUpdate.apply(void 0, arguments);
        };
    }
}

});

parcelRegister("giSak", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("eCnss", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $aa46cf8bffef68e8$export$a7c73072b1a182ae, (v) => $aa46cf8bffef68e8$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $aa46cf8bffef68e8$export$9f27bc3417b4524d, (v) => $aa46cf8bffef68e8$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $aa46cf8bffef68e8$export$db77ccec0bb4ccac, (v) => $aa46cf8bffef68e8$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $aa46cf8bffef68e8$export$8392c0c9d3dcbd35, (v) => $aa46cf8bffef68e8$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $aa46cf8bffef68e8$export$ffb0004e005737fa, (v) => $aa46cf8bffef68e8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $aa46cf8bffef68e8$export$b624eff549462981, (v) => $aa46cf8bffef68e8$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $aa46cf8bffef68e8$export$7897aa7841a5380c, (v) => $aa46cf8bffef68e8$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $aa46cf8bffef68e8$export$602eac185826482c, (v) => $aa46cf8bffef68e8$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $aa46cf8bffef68e8$export$e2c29f18771995cb, (v) => $aa46cf8bffef68e8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $aa46cf8bffef68e8$export$5f8d39834fd61797, (v) => $aa46cf8bffef68e8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $aa46cf8bffef68e8$export$74bf444e3cd11ea5, (v) => $aa46cf8bffef68e8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $aa46cf8bffef68e8$export$998bcd577473dd93, (v) => $aa46cf8bffef68e8$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $aa46cf8bffef68e8$export$92387174baf9b227, (v) => $aa46cf8bffef68e8$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $aa46cf8bffef68e8$export$ec112efeb987d9c6, (v) => $aa46cf8bffef68e8$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $aa46cf8bffef68e8$export$b706b080d889d2c9, (v) => $aa46cf8bffef68e8$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $aa46cf8bffef68e8$export$5be5a87408f70ddc, (v) => $aa46cf8bffef68e8$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $aa46cf8bffef68e8$export$45a5e7f76e0caa8d, (v) => $aa46cf8bffef68e8$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $aa46cf8bffef68e8$export$455c2e768291efa6, (v) => $aa46cf8bffef68e8$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $aa46cf8bffef68e8$export$9522e17588c12572, (v) => $aa46cf8bffef68e8$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $aa46cf8bffef68e8$export$2110ac352bb060b9, (v) => $aa46cf8bffef68e8$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $aa46cf8bffef68e8$export$56885ab8b9c456ab, (v) => $aa46cf8bffef68e8$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $aa46cf8bffef68e8$export$d927fcb6adf8f9de, (v) => $aa46cf8bffef68e8$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $aa46cf8bffef68e8$export$b82d16f27459e05a, (v) => $aa46cf8bffef68e8$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $aa46cf8bffef68e8$export$522c17b4f5e123e8, (v) => $aa46cf8bffef68e8$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $aa46cf8bffef68e8$export$1aabd8a0274ecfd6, (v) => $aa46cf8bffef68e8$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $aa46cf8bffef68e8$export$3d6c20d97e46b957, (v) => $aa46cf8bffef68e8$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $aa46cf8bffef68e8$export$9b621391a187a31a, (v) => $aa46cf8bffef68e8$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $aa46cf8bffef68e8$export$f5bbd400c2f4426f, (v) => $aa46cf8bffef68e8$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa46cf8bffef68e8$export$a7c73072b1a182ae;
var $aa46cf8bffef68e8$export$9f27bc3417b4524d;
var $aa46cf8bffef68e8$export$db77ccec0bb4ccac;
var $aa46cf8bffef68e8$export$8392c0c9d3dcbd35;
var $aa46cf8bffef68e8$export$ffb0004e005737fa;
var $aa46cf8bffef68e8$export$b624eff549462981;
var $aa46cf8bffef68e8$export$7897aa7841a5380c;
var $aa46cf8bffef68e8$export$602eac185826482c;
var $aa46cf8bffef68e8$export$e2c29f18771995cb;
var $aa46cf8bffef68e8$export$5f8d39834fd61797;
var $aa46cf8bffef68e8$export$74bf444e3cd11ea5;
var $aa46cf8bffef68e8$export$998bcd577473dd93;
var $aa46cf8bffef68e8$export$92387174baf9b227;
var $aa46cf8bffef68e8$export$ec112efeb987d9c6;
var $aa46cf8bffef68e8$export$b706b080d889d2c9;
var $aa46cf8bffef68e8$export$5be5a87408f70ddc;
var $aa46cf8bffef68e8$export$45a5e7f76e0caa8d;
var $aa46cf8bffef68e8$export$455c2e768291efa6;
var $aa46cf8bffef68e8$export$9522e17588c12572;
var $aa46cf8bffef68e8$export$2110ac352bb060b9;
var $aa46cf8bffef68e8$export$56885ab8b9c456ab;
var $aa46cf8bffef68e8$export$d927fcb6adf8f9de;
var $aa46cf8bffef68e8$export$b82d16f27459e05a;
var $aa46cf8bffef68e8$export$522c17b4f5e123e8;
var $aa46cf8bffef68e8$export$1aabd8a0274ecfd6;
var $aa46cf8bffef68e8$export$3d6c20d97e46b957;
var $aa46cf8bffef68e8$export$9b621391a187a31a;
var $aa46cf8bffef68e8$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $aa46cf8bffef68e8$export$a7c73072b1a182ae = ContextConsumer;
    $aa46cf8bffef68e8$export$9f27bc3417b4524d = ContextProvider;
    $aa46cf8bffef68e8$export$db77ccec0bb4ccac = Element;
    $aa46cf8bffef68e8$export$8392c0c9d3dcbd35 = ForwardRef;
    $aa46cf8bffef68e8$export$ffb0004e005737fa = Fragment;
    $aa46cf8bffef68e8$export$b624eff549462981 = Lazy;
    $aa46cf8bffef68e8$export$7897aa7841a5380c = Memo;
    $aa46cf8bffef68e8$export$602eac185826482c = Portal;
    $aa46cf8bffef68e8$export$e2c29f18771995cb = Profiler;
    $aa46cf8bffef68e8$export$5f8d39834fd61797 = StrictMode;
    $aa46cf8bffef68e8$export$74bf444e3cd11ea5 = Suspense;
    $aa46cf8bffef68e8$export$998bcd577473dd93 = SuspenseList;
    $aa46cf8bffef68e8$export$92387174baf9b227 = isAsyncMode;
    $aa46cf8bffef68e8$export$ec112efeb987d9c6 = isConcurrentMode;
    $aa46cf8bffef68e8$export$b706b080d889d2c9 = isContextConsumer;
    $aa46cf8bffef68e8$export$5be5a87408f70ddc = isContextProvider;
    $aa46cf8bffef68e8$export$45a5e7f76e0caa8d = isElement;
    $aa46cf8bffef68e8$export$455c2e768291efa6 = isForwardRef;
    $aa46cf8bffef68e8$export$9522e17588c12572 = isFragment;
    $aa46cf8bffef68e8$export$2110ac352bb060b9 = isLazy;
    $aa46cf8bffef68e8$export$56885ab8b9c456ab = isMemo;
    $aa46cf8bffef68e8$export$d927fcb6adf8f9de = isPortal;
    $aa46cf8bffef68e8$export$b82d16f27459e05a = isProfiler;
    $aa46cf8bffef68e8$export$522c17b4f5e123e8 = isStrictMode;
    $aa46cf8bffef68e8$export$1aabd8a0274ecfd6 = isSuspense;
    $aa46cf8bffef68e8$export$3d6c20d97e46b957 = isSuspenseList;
    $aa46cf8bffef68e8$export$9b621391a187a31a = isValidElementType;
    $aa46cf8bffef68e8$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("6wVix", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4c122d6a5ceefec3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Field", () => (parcelRequire("g3ui7")).default);
$parcel$export(module.exports, "List", () => (parcelRequire("eGP8A")).default);
$parcel$export(module.exports, "useForm", () => (parcelRequire("4sljH")).default);
$parcel$export(module.exports, "FormProvider", () => (parcelRequire("jAqyT")).FormProvider);
$parcel$export(module.exports, "FieldContext", () => (parcelRequire("9PKWp")).default);
$parcel$export(module.exports, "ListContext", () => (parcelRequire("lapVt")).default);
$parcel$export(module.exports, "useWatch", () => (parcelRequire("4440P")).default);

var $jMaZ8 = parcelRequire("jMaZ8");

var $g3ui7 = parcelRequire("g3ui7");

var $eGP8A = parcelRequire("eGP8A");

var $4sljH = parcelRequire("4sljH");

var $7sRVt = parcelRequire("7sRVt");

var $jAqyT = parcelRequire("jAqyT");

var $9PKWp = parcelRequire("9PKWp");

var $lapVt = parcelRequire("lapVt");

var $4440P = parcelRequire("4440P");
var $4c122d6a5ceefec3$var$InternalForm = /*#__PURE__*/ $jMaZ8.forwardRef((0, $7sRVt.default));
var $4c122d6a5ceefec3$var$RefForm = $4c122d6a5ceefec3$var$InternalForm;
$4c122d6a5ceefec3$var$RefForm.FormProvider = (0, $jAqyT.FormProvider);
$4c122d6a5ceefec3$var$RefForm.Field = (0, $g3ui7.default);
$4c122d6a5ceefec3$var$RefForm.List = (0, $eGP8A.default);
$4c122d6a5ceefec3$var$RefForm.useForm = (0, $4sljH.default);
$4c122d6a5ceefec3$var$RefForm.useWatch = (0, $4440P.default);
var $4c122d6a5ceefec3$export$2e2bcd8739ae039 = $4c122d6a5ceefec3$var$RefForm;

});
parcelRegister("g3ui7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb046c5a20242aaf$export$2e2bcd8739ae039);

var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $c1hLi = parcelRequire("c1hLi");

var $18vmN = parcelRequire("18vmN");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $a6yuN = parcelRequire("a6yuN");

var $9O5K3 = parcelRequire("9O5K3");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $9PKWp = parcelRequire("9PKWp");

var $lapVt = parcelRequire("lapVt");

var $9tjNt = parcelRequire("9tjNt");

var $5SvzS = parcelRequire("5SvzS");

var $6CxJR = parcelRequire("6CxJR");
var $k19OO = parcelRequire("k19OO");
var $bb046c5a20242aaf$var$_excluded = [
    "name"
];
var $bb046c5a20242aaf$var$EMPTY_ERRORS = [];
function $bb046c5a20242aaf$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $bb046c5a20242aaf$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $7eK0y.default)(Field, _React$Component);
    var _super = (0, $fwNdX.default)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $klxbl.default)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "state", {
            resetCount: 0
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "cancelRegisterFunc", null);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $eq8kl.default)((0, $e4nJa.default)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $eq8kl.default)((0, $e4nJa.default)(_this), "dirty", false);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "validatePromise", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "prevValidating", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "errors", $bb046c5a20242aaf$var$EMPTY_ERRORS);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "warnings", $bb046c5a20242aaf$var$EMPTY_ERRORS);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $6CxJR.getNamePath)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $fvBso.default)(prefixName), (0, $fvBso.default)(name)) : [];
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === 'function') return rule(fieldContext);
                return rule;
            });
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "metaCache", null);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $8u3qN.default)((0, $8u3qN.default)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $9O5K3.default)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $6CxJR.containsNamePath)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $9O5K3.default)(prevValue, curValue)) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $bb046c5a20242aaf$var$EMPTY_ERRORS;
                _this.warnings = $bb046c5a20242aaf$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case 'reset':
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $bb046c5a20242aaf$var$EMPTY_ERRORS;
                        _this.warnings = $bb046c5a20242aaf$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case 'remove':
                    if (shouldUpdate && $bb046c5a20242aaf$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'setField':
                    var data = info.data;
                    if (namePathMatch) {
                        if ('touched' in data) _this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) _this.errors = data.errors || $bb046c5a20242aaf$var$EMPTY_ERRORS;
                        if ('warnings' in data) _this.warnings = data.warnings || $bb046c5a20242aaf$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ('value' in data && (0, $6CxJR.containsNamePath)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $bb046c5a20242aaf$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'dependenciesUpdate':
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $6CxJR.getNamePath));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $6CxJR.containsNamePath)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $bb046c5a20242aaf$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $c1hLi.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $9tjNt.toArray)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $5SvzS.validateRules)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $bb046c5a20242aaf$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $bb046c5a20242aaf$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $fvBso.default)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $fvBso.default)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $bb046c5a20242aaf$var$EMPTY_ERRORS;
            _this.warnings = $bb046c5a20242aaf$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $9PKWp.HOOK_MARK)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === 'function') {
                var _meta2 = _this.getMeta();
                return (0, $8u3qN.default)((0, $8u3qN.default)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $a6yuN.default)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $jMaZ8.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $k19OO.default)(store || getFieldsValue(true), namePath);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, name = _this$props6.name, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $9PKWp.HOOK_MARK)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $eq8kl.default)({}, valuePropName, val);
            };
            var originTriggerFunc = childProps[trigger];
            var valueProps = name !== undefined ? mergedGetValueProps(value) : {};
            // warning when prop value is function
            if (valueProps) Object.keys(valueProps).forEach(function(key) {
                (0, $2bFmQ.default)(typeof valueProps[key] !== 'function', "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(key, ")"));
            });
            var control = (0, $8u3qN.default)((0, $8u3qN.default)({}, childProps), valueProps);
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $6CxJR.defaultGetValueFromEvent).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                if (newValue !== value) dispatch({
                    type: 'updateValue',
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $9tjNt.toArray)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: 'validateField',
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $9PKWp.HOOK_MARK)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $e4nJa.default)(_this));
        }
        return _this;
    }
    (0, $9O7LJ.default)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $9PKWp.HOOK_MARK)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $jMaZ8.isValidElement(child)) returnChildNode = /*#__PURE__*/ $jMaZ8.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $2bFmQ.default)(!child, '`children` of Field is not validate ReactElement.');
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($jMaZ8.Component);
(0, $eq8kl.default)($bb046c5a20242aaf$var$Field, "contextType", (0, $9PKWp.default));
(0, $eq8kl.default)($bb046c5a20242aaf$var$Field, "defaultProps", {
    trigger: 'onChange',
    valuePropName: 'value'
});
function $bb046c5a20242aaf$var$WrapperField(_ref6) {
    var _restProps$isListFiel;
    var name = _ref6.name, restProps = (0, $4b02Q.default)(_ref6, $bb046c5a20242aaf$var$_excluded);
    var fieldContext = $jMaZ8.useContext((0, $9PKWp.default));
    var listContext = $jMaZ8.useContext((0, $lapVt.default));
    var namePath = name !== undefined ? (0, $6CxJR.getNamePath)(name) : undefined;
    var isMergedListField = (_restProps$isListFiel = restProps.isListField) !== null && _restProps$isListFiel !== void 0 ? _restProps$isListFiel : !!listContext;
    var key = 'keep';
    if (!isMergedListField) key = "_".concat((namePath || []).join('_'));
    // Warning if it's a directly list field.
    // We can still support multiple level field preserve.
    if (restProps.preserve === false && isMergedListField && namePath.length <= 1) (0, $2bFmQ.default)(false, '`preserve` should not apply on Form.List fields.');
    return /*#__PURE__*/ $jMaZ8.createElement($bb046c5a20242aaf$var$Field, (0, $hH60s.default)({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $bb046c5a20242aaf$export$2e2bcd8739ae039 = $bb046c5a20242aaf$var$WrapperField;

});
parcelRegister("hH60s", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1b1c93693134bb$export$2e2bcd8739ae039);
function $ce1b1c93693134bb$export$2e2bcd8739ae039() {
    return $ce1b1c93693134bb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce1b1c93693134bb$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4b02Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $30a839670aea44cc$export$2e2bcd8739ae039);

var $dadfS = parcelRequire("dadfS");
function $30a839670aea44cc$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $dadfS.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("dadfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $99567db2a9424d95$export$2e2bcd8739ae039);
function $99567db2a9424d95$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("c1hLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c035b3022ee6e91$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");
function $8c035b3022ee6e91$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $8c035b3022ee6e91$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $1Esi2.default)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $1Esi2.default)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}

});
parcelRegister("1Esi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $133f78a6d544542c$export$2e2bcd8739ae039);
function $133f78a6d544542c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $133f78a6d544542c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $133f78a6d544542c$export$2e2bcd8739ae039(o);
}

});


parcelRegister("18vmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d3ede96a7ce4068$export$2e2bcd8739ae039);
function $0d3ede96a7ce4068$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $0d3ede96a7ce4068$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $0d3ede96a7ce4068$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $0d3ede96a7ce4068$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("8u3qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d3c96a82a4fccb$export$2e2bcd8739ae039);

var $eq8kl = parcelRequire("eq8kl");
function $62d3c96a82a4fccb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62d3c96a82a4fccb$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62d3c96a82a4fccb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eq8kl.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62d3c96a82a4fccb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("eq8kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7f9f3f942161125$export$2e2bcd8739ae039);

var $hcRMF = parcelRequire("hcRMF");
function $a7f9f3f942161125$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hcRMF.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("hcRMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86d4707531ba24e$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $g4AjV = parcelRequire("g4AjV");
function $c86d4707531ba24e$export$2e2bcd8739ae039(t) {
    var i = (0, $g4AjV.default)(t, "string");
    return "symbol" == (0, $1Esi2.default)(i) ? i : i + "";
}

});
parcelRegister("g4AjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb39318654b3a9a6$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");
function $bb39318654b3a9a6$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1Esi2.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1Esi2.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("fvBso", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4a6ce75530028dc$export$2e2bcd8739ae039);

var $3Q2sd = parcelRequire("3Q2sd");

var $3OwDc = parcelRequire("3OwDc");

var $kLtvf = parcelRequire("kLtvf");

var $1xF1F = parcelRequire("1xF1F");
function $b4a6ce75530028dc$export$2e2bcd8739ae039(r) {
    return (0, $3Q2sd.default)(r) || (0, $3OwDc.default)(r) || (0, $kLtvf.default)(r) || (0, $1xF1F.default)();
}

});
parcelRegister("3Q2sd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cb821c67ad0d4a0$export$2e2bcd8739ae039);

var $9l4YU = parcelRequire("9l4YU");
function $2cb821c67ad0d4a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9l4YU.default)(r);
}

});
parcelRegister("9l4YU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cc9f070b367b2db$export$2e2bcd8739ae039);
function $6cc9f070b367b2db$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("3OwDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6f5a82b26775e4$export$2e2bcd8739ae039);
function $2c6f5a82b26775e4$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("kLtvf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1df1522d34f7ede$export$2e2bcd8739ae039);

var $9l4YU = parcelRequire("9l4YU");
function $f1df1522d34f7ede$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9l4YU.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9l4YU.default)(r, a) : void 0;
    }
}

});

parcelRegister("1xF1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f8b2612855fd1c$export$2e2bcd8739ae039);
function $11f8b2612855fd1c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("klxbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecff8212d52dbed9$export$2e2bcd8739ae039);
function $ecff8212d52dbed9$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9O7LJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $723ecf4ab0b1b7ac$export$2e2bcd8739ae039);

var $hcRMF = parcelRequire("hcRMF");
function $723ecf4ab0b1b7ac$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $hcRMF.default)(o.key), o);
    }
}
function $723ecf4ab0b1b7ac$export$2e2bcd8739ae039(e, r, t) {
    return r && $723ecf4ab0b1b7ac$var$_defineProperties(e.prototype, r), t && $723ecf4ab0b1b7ac$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("e4nJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3d82ea0e8655e$export$2e2bcd8739ae039);
function $a3e3d82ea0e8655e$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("7eK0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $544d876bebe338da$export$2e2bcd8739ae039);

var $kZK98 = parcelRequire("kZK98");
function $544d876bebe338da$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $kZK98.default)(t, e);
}

});
parcelRegister("kZK98", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48d4cdf74fd4252$export$2e2bcd8739ae039);
function $f48d4cdf74fd4252$export$2e2bcd8739ae039(t, e) {
    return $f48d4cdf74fd4252$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f48d4cdf74fd4252$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("fwNdX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4e00708ae02562b$export$2e2bcd8739ae039);

var $59qU0 = parcelRequire("59qU0");

var $f2BOs = parcelRequire("f2BOs");

var $fe5yO = parcelRequire("fe5yO");
function $b4e00708ae02562b$export$2e2bcd8739ae039(t) {
    var r = (0, $f2BOs.default)();
    return function() {
        var e, o = (0, $59qU0.default)(t);
        if (r) {
            var s = (0, $59qU0.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $fe5yO.default)(this, e);
    };
}

});
parcelRegister("59qU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c02a93eacafc6c2$export$2e2bcd8739ae039);
function $3c02a93eacafc6c2$export$2e2bcd8739ae039(t) {
    return $3c02a93eacafc6c2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $3c02a93eacafc6c2$export$2e2bcd8739ae039(t);
}

});

parcelRegister("f2BOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $af345fc2afa88130$export$2e2bcd8739ae039);
function $af345fc2afa88130$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($af345fc2afa88130$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("fe5yO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b15c7a0919aebf7c$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $e4nJa = parcelRequire("e4nJa");
function $b15c7a0919aebf7c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $1Esi2.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $e4nJa.default)(t);
}

});


parcelRegister("a6yuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b53906ac239d1c$export$2e2bcd8739ae039);

var $5tavl = parcelRequire("5tavl");

var $jMaZ8 = parcelRequire("jMaZ8");
function $75b53906ac239d1c$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($75b53906ac239d1c$export$2e2bcd8739ae039(child));
        else if ((0, $5tavl.default)(child) && child.props) ret = ret.concat($75b53906ac239d1c$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

});
parcelRegister("5tavl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb7cf2aaf8279e0$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");
var $3fb7cf2aaf8279e0$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $3fb7cf2aaf8279e0$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $3fb7cf2aaf8279e0$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $3fb7cf2aaf8279e0$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $1Esi2.default)(object) === 'object' && // React Element type
    (object.$$typeof === $3fb7cf2aaf8279e0$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $3fb7cf2aaf8279e0$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $3fb7cf2aaf8279e0$var$REACT_FRAGMENT_TYPE);
}

});


parcelRegister("9O5K3", function(module, exports) {

$parcel$export(module.exports, "default", () => $723d3cc50e841ad3$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $2bFmQ = parcelRequire("2bFmQ");
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $723d3cc50e841ad3$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $2bFmQ.default)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $1Esi2.default)(a) === 'object' && (0, $1Esi2.default)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $723d3cc50e841ad3$export$2e2bcd8739ae039 = $723d3cc50e841ad3$var$isEqual;

});
parcelRegister("2bFmQ", function(module, exports) {

$parcel$export(module.exports, "warning", () => $197cb292c374bdc5$export$491112666e282270);
$parcel$export(module.exports, "resetWarned", () => $197cb292c374bdc5$export$60eef1277fe463e4);
$parcel$export(module.exports, "noteOnce", () => $197cb292c374bdc5$export$89ff31684837bbbf);
$parcel$export(module.exports, "default", () => $197cb292c374bdc5$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $197cb292c374bdc5$var$warned = {};
var $197cb292c374bdc5$var$preWarningFns = [];
var $197cb292c374bdc5$export$61616f168f0e5a05 = function preMessage(fn) {
    $197cb292c374bdc5$var$preWarningFns.push(fn);
};
function $197cb292c374bdc5$export$491112666e282270(valid, message) {
    if (!valid && console !== undefined) {
        var finalMessage = $197cb292c374bdc5$var$preWarningFns.reduce(function(msg, preMessageFn) {
            return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'warning');
        }, message);
        if (finalMessage) console.error("Warning: ".concat(finalMessage));
    }
}
function $197cb292c374bdc5$export$a92e4c44d367d0af(valid, message) {
    if (!valid && console !== undefined) {
        var finalMessage = $197cb292c374bdc5$var$preWarningFns.reduce(function(msg, preMessageFn) {
            return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'note');
        }, message);
        if (finalMessage) console.warn("Note: ".concat(finalMessage));
    }
}
function $197cb292c374bdc5$export$60eef1277fe463e4() {
    $197cb292c374bdc5$var$warned = {};
}
function $197cb292c374bdc5$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$197cb292c374bdc5$var$warned[message]) {
        method(false, message);
        $197cb292c374bdc5$var$warned[message] = true;
    }
}
function $197cb292c374bdc5$export$82934adf09101657(valid, message) {
    $197cb292c374bdc5$export$848feb93d8f32b9b($197cb292c374bdc5$export$491112666e282270, valid, message);
}
function $197cb292c374bdc5$export$89ff31684837bbbf(valid, message) {
    $197cb292c374bdc5$export$848feb93d8f32b9b($197cb292c374bdc5$export$a92e4c44d367d0af, valid, message);
}
$197cb292c374bdc5$export$82934adf09101657.preMessage = $197cb292c374bdc5$export$61616f168f0e5a05;
$197cb292c374bdc5$export$82934adf09101657.resetWarned = $197cb292c374bdc5$export$60eef1277fe463e4;
$197cb292c374bdc5$export$82934adf09101657.noteOnce = $197cb292c374bdc5$export$89ff31684837bbbf;
var $197cb292c374bdc5$export$2e2bcd8739ae039 = $197cb292c374bdc5$export$82934adf09101657;

});


parcelRegister("9PKWp", function(module, exports) {

$parcel$export(module.exports, "HOOK_MARK", () => $728d4a040d758bba$export$24829b7c0e49e9f7);
$parcel$export(module.exports, "default", () => $728d4a040d758bba$export$2e2bcd8739ae039);

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");
var $728d4a040d758bba$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $728d4a040d758bba$var$warningFunc = function warningFunc() {
    (0, $2bFmQ.default)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var $728d4a040d758bba$var$Context = /*#__PURE__*/ $jMaZ8.createContext({
    getFieldValue: $728d4a040d758bba$var$warningFunc,
    getFieldsValue: $728d4a040d758bba$var$warningFunc,
    getFieldError: $728d4a040d758bba$var$warningFunc,
    getFieldWarning: $728d4a040d758bba$var$warningFunc,
    getFieldsError: $728d4a040d758bba$var$warningFunc,
    isFieldsTouched: $728d4a040d758bba$var$warningFunc,
    isFieldTouched: $728d4a040d758bba$var$warningFunc,
    isFieldValidating: $728d4a040d758bba$var$warningFunc,
    isFieldsValidating: $728d4a040d758bba$var$warningFunc,
    resetFields: $728d4a040d758bba$var$warningFunc,
    setFields: $728d4a040d758bba$var$warningFunc,
    setFieldValue: $728d4a040d758bba$var$warningFunc,
    setFieldsValue: $728d4a040d758bba$var$warningFunc,
    validateFields: $728d4a040d758bba$var$warningFunc,
    submit: $728d4a040d758bba$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $728d4a040d758bba$var$warningFunc();
        return {
            dispatch: $728d4a040d758bba$var$warningFunc,
            initEntityValue: $728d4a040d758bba$var$warningFunc,
            registerField: $728d4a040d758bba$var$warningFunc,
            useSubscribe: $728d4a040d758bba$var$warningFunc,
            setInitialValues: $728d4a040d758bba$var$warningFunc,
            destroyForm: $728d4a040d758bba$var$warningFunc,
            setCallbacks: $728d4a040d758bba$var$warningFunc,
            registerWatch: $728d4a040d758bba$var$warningFunc,
            getFields: $728d4a040d758bba$var$warningFunc,
            setValidateMessages: $728d4a040d758bba$var$warningFunc,
            setPreserve: $728d4a040d758bba$var$warningFunc,
            getInitialValue: $728d4a040d758bba$var$warningFunc
        };
    }
});
var $728d4a040d758bba$export$2e2bcd8739ae039 = $728d4a040d758bba$var$Context;

});

parcelRegister("lapVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68ea486d60882d5$export$2e2bcd8739ae039);

var $jMaZ8 = parcelRequire("jMaZ8");
var $f68ea486d60882d5$var$ListContext = /*#__PURE__*/ $jMaZ8.createContext(null);
var $f68ea486d60882d5$export$2e2bcd8739ae039 = $f68ea486d60882d5$var$ListContext;

});

parcelRegister("9tjNt", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $6e562dbd2195d685$export$45b10814cc054894);
$parcel$export(module.exports, "isFormInstance", () => $6e562dbd2195d685$export$717b316e73068e8d);
function $6e562dbd2195d685$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $6e562dbd2195d685$export$717b316e73068e8d(form) {
    return form && !!form._init;
}

});

parcelRegister("5SvzS", function(module, exports) {

$parcel$export(module.exports, "validateRules", () => $447a7d8d92584080$export$e1fc4b442d0297dd);

var $fvBso = parcelRequire("fvBso");

var $eq8kl = parcelRequire("eq8kl");

var $c1hLi = parcelRequire("c1hLi");

var $8u3qN = parcelRequire("8u3qN");

var $18vmN = parcelRequire("18vmN");

var $4iUiX = parcelRequire("4iUiX");

var $jMaZ8 = parcelRequire("jMaZ8");

var $2bFmQ = parcelRequire("2bFmQ");

var $i63mZ = parcelRequire("i63mZ");

var $3hbWa = parcelRequire("3hbWa");
// Remove incorrect original ts define
var $447a7d8d92584080$var$AsyncValidator = (0, $4iUiX.default);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $447a7d8d92584080$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, function(str) {
        if (str.startsWith('\\')) return str.slice(1);
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $447a7d8d92584080$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
function $447a7d8d92584080$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $447a7d8d92584080$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $447a7d8d92584080$var$_validateRule() {
    $447a7d8d92584080$var$_validateRule = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $c1hLi.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $8u3qN.default)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $447a7d8d92584080$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($447a7d8d92584080$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $447a7d8d92584080$var$AsyncValidator((0, $eq8kl.default)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $3hbWa.merge)((0, $i63mZ.defaultValidateMessages), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $eq8kl.default)({}, name, value), (0, $8u3qN.default)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $447a7d8d92584080$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $jMaZ8.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $jMaZ8.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $447a7d8d92584080$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $fvBso.default)(prev), (0, $fvBso.default)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $8u3qN.default)((0, $8u3qN.default)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(', ')
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === 'string') return $447a7d8d92584080$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $447a7d8d92584080$var$_validateRule.apply(this, arguments);
}
function $447a7d8d92584080$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join('.');
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $8u3qN.default)((0, $8u3qN.default)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $2bFmQ.default)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $2bFmQ.default)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $c1hLi.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $447a7d8d92584080$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $447a7d8d92584080$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $447a7d8d92584080$var$finishOnFirstFailed(rulePromises) : $447a7d8d92584080$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $447a7d8d92584080$var$finishOnAllFailed(_x8) {
    return $447a7d8d92584080$var$_finishOnAllFailed.apply(this, arguments);
}
function $447a7d8d92584080$var$_finishOnAllFailed() {
    $447a7d8d92584080$var$_finishOnAllFailed = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee3(rulePromises) {
        return (0, $c1hLi.default)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $fvBso.default)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $447a7d8d92584080$var$_finishOnAllFailed.apply(this, arguments);
}
function $447a7d8d92584080$var$finishOnFirstFailed(_x9) {
    return $447a7d8d92584080$var$_finishOnFirstFailed.apply(this, arguments);
}
function $447a7d8d92584080$var$_finishOnFirstFailed() {
    $447a7d8d92584080$var$_finishOnFirstFailed = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $c1hLi.default)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $447a7d8d92584080$var$_finishOnFirstFailed.apply(this, arguments);
}

});
parcelRegister("4iUiX", function(module, exports) {

$parcel$export(module.exports, "default", () => $322484d709e4b74a$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $1Esi2 = parcelRequire("1Esi2");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");

var $klZWH = parcelRequire("klZWH");

var $6BP2j = parcelRequire("6BP2j");

var $2gcmV = parcelRequire("2gcmV");
parcelRequire("ecFGR");
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $322484d709e4b74a$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $klxbl.default)(this, Schema);
        // ======================== Instance ========================
        (0, $eq8kl.default)(this, "rules", null);
        (0, $eq8kl.default)(this, "_messages", (0, $klZWH.messages));
        this.define(descriptor);
    }
    (0, $9O7LJ.default)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, $1Esi2.default)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $6BP2j.deepMerge)((0, $klZWH.newMessages)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $fvBso.default)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $6BP2j.convertFieldsError)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $klZWH.messages)) messages = (0, $klZWH.newMessages)();
                    (0, $6BP2j.deepMerge)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, $8u3qN.default)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, $1Esi2.default)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, $8u3qN.default)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $6BP2j.asyncMap)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, $1Esi2.default)(rule.fields) === 'object' || (0, $1Esi2.default)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $8u3qN.default)((0, $8u3qN.default)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $fvBso.default)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $6BP2j.complementError)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $6BP2j.complementError)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $6BP2j.format)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $8u3qN.default)((0, $8u3qN.default)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $fvBso.default)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $fvBso.default)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, $2gcmV.default).hasOwnProperty(rule.type)) throw new Error((0, $6BP2j.format)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, $2gcmV.default).required;
                return (0, $2gcmV.default)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $eq8kl.default)($322484d709e4b74a$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, $2gcmV.default)[type] = validator;
});
(0, $eq8kl.default)($322484d709e4b74a$var$Schema, "warning", (0, $6BP2j.warning));
(0, $eq8kl.default)($322484d709e4b74a$var$Schema, "messages", (0, $klZWH.messages));
(0, $eq8kl.default)($322484d709e4b74a$var$Schema, "validators", (0, $2gcmV.default));
var $322484d709e4b74a$export$2e2bcd8739ae039 = $322484d709e4b74a$var$Schema;

});
parcelRegister("klZWH", function(module, exports) {

$parcel$export(module.exports, "newMessages", () => $ed15d1f46c0ea327$export$f77fd0c3b25d8534);
$parcel$export(module.exports, "messages", () => $ed15d1f46c0ea327$export$defe85febe8b728c);
function $ed15d1f46c0ea327$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $ed15d1f46c0ea327$export$defe85febe8b728c = $ed15d1f46c0ea327$export$f77fd0c3b25d8534();

});

parcelRegister("6BP2j", function(module, exports) {

$parcel$export(module.exports, "warning", () => $4cfdc987d9ba6b43$export$491112666e282270);
$parcel$export(module.exports, "convertFieldsError", () => $4cfdc987d9ba6b43$export$e85887f5ceeacced);
$parcel$export(module.exports, "format", () => $4cfdc987d9ba6b43$export$d9468344d3651243);
$parcel$export(module.exports, "isEmptyValue", () => $4cfdc987d9ba6b43$export$141eca273a04dc3e);
$parcel$export(module.exports, "asyncMap", () => $4cfdc987d9ba6b43$export$707ee4c4c95d39e3);
$parcel$export(module.exports, "complementError", () => $4cfdc987d9ba6b43$export$34d5fe50d2616cee);
$parcel$export(module.exports, "deepMerge", () => $4cfdc987d9ba6b43$export$6969335ea1e4e77c);

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");

var $9O7LJ = parcelRequire("9O7LJ");

var $klxbl = parcelRequire("klxbl");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $8sxks = parcelRequire("8sxks");

var $eq8kl = parcelRequire("eq8kl");

var $fvBso = parcelRequire("fvBso");

var $0yIMy = parcelRequire("0yIMy");
/* eslint no-console:0 */ var $4cfdc987d9ba6b43$var$formatRegExp = /%[sdj%]/g;
var $4cfdc987d9ba6b43$export$491112666e282270 = function warning() {};
// don't print warning message when in production env or node runtime
if (typeof $0yIMy !== 'undefined' && $0yIMy.env && true && typeof window !== 'undefined' && typeof document !== 'undefined') $4cfdc987d9ba6b43$export$491112666e282270 = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === 'undefined') {
        if (errors.every(function(e) {
            return typeof e === 'string';
        })) console.warn(type, errors);
    }
};
function $4cfdc987d9ba6b43$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $4cfdc987d9ba6b43$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($4cfdc987d9ba6b43$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $4cfdc987d9ba6b43$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function $4cfdc987d9ba6b43$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($4cfdc987d9ba6b43$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $4cfdc987d9ba6b43$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $4cfdc987d9ba6b43$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $fvBso.default)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $4cfdc987d9ba6b43$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $4cfdc987d9ba6b43$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $fvBso.default)(objArr[k] || []));
    });
    return ret;
}
var $4cfdc987d9ba6b43$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $7eK0y.default)(AsyncValidationError, _Error);
    var _super = (0, $fwNdX.default)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $klxbl.default)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "errors", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $9O7LJ.default)(AsyncValidationError);
}(/*#__PURE__*/ (0, $8sxks.default)(Error));
function $4cfdc987d9ba6b43$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $4cfdc987d9ba6b43$export$188f48b73534b6f0(errors, $4cfdc987d9ba6b43$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $4cfdc987d9ba6b43$var$flattenObjArr(objArr);
            $4cfdc987d9ba6b43$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $4cfdc987d9ba6b43$export$188f48b73534b6f0(results, $4cfdc987d9ba6b43$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $4cfdc987d9ba6b43$var$asyncSerialArray(arr, func, next);
            else $4cfdc987d9ba6b43$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $4cfdc987d9ba6b43$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $4cfdc987d9ba6b43$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $4cfdc987d9ba6b43$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $4cfdc987d9ba6b43$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($4cfdc987d9ba6b43$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $4cfdc987d9ba6b43$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $1Esi2.default)(value) === 'object' && (0, $1Esi2.default)(target[s]) === 'object') target[s] = (0, $8u3qN.default)((0, $8u3qN.default)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}

});
parcelRegister("8sxks", function(module, exports) {

$parcel$export(module.exports, "default", () => $628acab44784855e$export$2e2bcd8739ae039);

var $59qU0 = parcelRequire("59qU0");

var $kZK98 = parcelRequire("kZK98");

var $i0egn = parcelRequire("i0egn");

var $jpWdl = parcelRequire("jpWdl");
function $628acab44784855e$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $628acab44784855e$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $i0egn.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $jpWdl.default)(t, arguments, (0, $59qU0.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $kZK98.default)(Wrapper, t);
    }, $628acab44784855e$export$2e2bcd8739ae039(t);
}

});
parcelRegister("i0egn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b34a6f55ca33ab$export$2e2bcd8739ae039);
function $d1b34a6f55ca33ab$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("jpWdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22d823ef995c62e$export$2e2bcd8739ae039);

var $f2BOs = parcelRequire("f2BOs");

var $kZK98 = parcelRequire("kZK98");
function $e22d823ef995c62e$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $f2BOs.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $kZK98.default)(p, r.prototype), p;
}

});


parcelRegister("0yIMy", function(module, exports) {
// shim for using process in browser
var $001aef20a216cda7$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $001aef20a216cda7$var$cachedSetTimeout;
var $001aef20a216cda7$var$cachedClearTimeout;
function $001aef20a216cda7$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $001aef20a216cda7$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $001aef20a216cda7$var$cachedSetTimeout = setTimeout;
        else $001aef20a216cda7$var$cachedSetTimeout = $001aef20a216cda7$var$defaultSetTimout;
    } catch (e) {
        $001aef20a216cda7$var$cachedSetTimeout = $001aef20a216cda7$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $001aef20a216cda7$var$cachedClearTimeout = clearTimeout;
        else $001aef20a216cda7$var$cachedClearTimeout = $001aef20a216cda7$var$defaultClearTimeout;
    } catch (e) {
        $001aef20a216cda7$var$cachedClearTimeout = $001aef20a216cda7$var$defaultClearTimeout;
    }
})();
function $001aef20a216cda7$var$runTimeout(fun) {
    if ($001aef20a216cda7$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($001aef20a216cda7$var$cachedSetTimeout === $001aef20a216cda7$var$defaultSetTimout || !$001aef20a216cda7$var$cachedSetTimeout) && setTimeout) {
        $001aef20a216cda7$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $001aef20a216cda7$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $001aef20a216cda7$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $001aef20a216cda7$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $001aef20a216cda7$var$runClearTimeout(marker) {
    if ($001aef20a216cda7$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($001aef20a216cda7$var$cachedClearTimeout === $001aef20a216cda7$var$defaultClearTimeout || !$001aef20a216cda7$var$cachedClearTimeout) && clearTimeout) {
        $001aef20a216cda7$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $001aef20a216cda7$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $001aef20a216cda7$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $001aef20a216cda7$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $001aef20a216cda7$var$queue = [];
var $001aef20a216cda7$var$draining = false;
var $001aef20a216cda7$var$currentQueue;
var $001aef20a216cda7$var$queueIndex = -1;
function $001aef20a216cda7$var$cleanUpNextTick() {
    if (!$001aef20a216cda7$var$draining || !$001aef20a216cda7$var$currentQueue) return;
    $001aef20a216cda7$var$draining = false;
    if ($001aef20a216cda7$var$currentQueue.length) $001aef20a216cda7$var$queue = $001aef20a216cda7$var$currentQueue.concat($001aef20a216cda7$var$queue);
    else $001aef20a216cda7$var$queueIndex = -1;
    if ($001aef20a216cda7$var$queue.length) $001aef20a216cda7$var$drainQueue();
}
function $001aef20a216cda7$var$drainQueue() {
    if ($001aef20a216cda7$var$draining) return;
    var timeout = $001aef20a216cda7$var$runTimeout($001aef20a216cda7$var$cleanUpNextTick);
    $001aef20a216cda7$var$draining = true;
    var len = $001aef20a216cda7$var$queue.length;
    while(len){
        $001aef20a216cda7$var$currentQueue = $001aef20a216cda7$var$queue;
        $001aef20a216cda7$var$queue = [];
        while(++$001aef20a216cda7$var$queueIndex < len)if ($001aef20a216cda7$var$currentQueue) $001aef20a216cda7$var$currentQueue[$001aef20a216cda7$var$queueIndex].run();
        $001aef20a216cda7$var$queueIndex = -1;
        len = $001aef20a216cda7$var$queue.length;
    }
    $001aef20a216cda7$var$currentQueue = null;
    $001aef20a216cda7$var$draining = false;
    $001aef20a216cda7$var$runClearTimeout(timeout);
}
$001aef20a216cda7$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $001aef20a216cda7$var$queue.push(new $001aef20a216cda7$var$Item(fun, args));
    if ($001aef20a216cda7$var$queue.length === 1 && !$001aef20a216cda7$var$draining) $001aef20a216cda7$var$runTimeout($001aef20a216cda7$var$drainQueue);
};
// v8 likes predictible objects
function $001aef20a216cda7$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$001aef20a216cda7$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$001aef20a216cda7$var$process.title = 'browser';
$001aef20a216cda7$var$process.browser = true;
$001aef20a216cda7$var$process.env = {};
$001aef20a216cda7$var$process.argv = [];
$001aef20a216cda7$var$process.version = ''; // empty string to avoid regexp issues
$001aef20a216cda7$var$process.versions = {};
function $001aef20a216cda7$var$noop() {}
$001aef20a216cda7$var$process.on = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.addListener = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.once = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.off = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.removeListener = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.removeAllListeners = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.emit = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.prependListener = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.prependOnceListener = $001aef20a216cda7$var$noop;
$001aef20a216cda7$var$process.listeners = function(name) {
    return [];
};
$001aef20a216cda7$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$001aef20a216cda7$var$process.cwd = function() {
    return '/';
};
$001aef20a216cda7$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$001aef20a216cda7$var$process.umask = function() {
    return 0;
};

});


parcelRegister("2gcmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a56ab90f9d5901f$export$2e2bcd8739ae039);

var $9u80S = parcelRequire("9u80S");

var $cVR6U = parcelRequire("cVR6U");

var $ioIV9 = parcelRequire("ioIV9");

var $h7HZo = parcelRequire("h7HZo");

var $cqyer = parcelRequire("cqyer");

var $7uaBV = parcelRequire("7uaBV");

var $2xkLL = parcelRequire("2xkLL");

var $9XeCU = parcelRequire("9XeCU");

var $fks2s = parcelRequire("fks2s");

var $2rmV2 = parcelRequire("2rmV2");

var $fNe9s = parcelRequire("fNe9s");

var $5HFk3 = parcelRequire("5HFk3");

var $jMtFA = parcelRequire("jMtFA");

var $4Ldas = parcelRequire("4Ldas");

var $gJw0F = parcelRequire("gJw0F");
var $1a56ab90f9d5901f$export$2e2bcd8739ae039 = {
    string: (0, $4Ldas.default),
    method: (0, $9XeCU.default),
    number: (0, $fks2s.default),
    boolean: (0, $ioIV9.default),
    regexp: (0, $5HFk3.default),
    integer: (0, $2xkLL.default),
    float: (0, $7uaBV.default),
    array: (0, $cVR6U.default),
    object: (0, $2rmV2.default),
    enum: (0, $cqyer.default),
    pattern: (0, $fNe9s.default),
    date: (0, $h7HZo.default),
    url: (0, $gJw0F.default),
    hex: (0, $gJw0F.default),
    email: (0, $gJw0F.default),
    required: (0, $jMtFA.default),
    any: (0, $9u80S.default)
};

});
parcelRegister("9u80S", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7d21aa3508dd4b$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $6e7d21aa3508dd4b$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $6e7d21aa3508dd4b$export$2e2bcd8739ae039 = $6e7d21aa3508dd4b$var$any;

});
parcelRegister("592V7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf00eed966c1b23$export$2e2bcd8739ae039);

var $71VR3 = parcelRequire("71VR3");

var $iy9o6 = parcelRequire("iy9o6");

var $dza6c = parcelRequire("dza6c");

var $9sozb = parcelRequire("9sozb");

var $iYFl7 = parcelRequire("iYFl7");

var $VfXU7 = parcelRequire("VfXU7");
var $3bf00eed966c1b23$export$2e2bcd8739ae039 = {
    required: (0, $9sozb.default),
    whitespace: (0, $VfXU7.default),
    type: (0, $iYFl7.default),
    range: (0, $dza6c.default),
    enum: (0, $71VR3.default),
    pattern: (0, $iy9o6.default)
};

});
parcelRegister("71VR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e5811f5e3f7e1a$export$2e2bcd8739ae039);

var $6BP2j = parcelRequire("6BP2j");
var $51e5811f5e3f7e1a$var$ENUM = 'enum';
var $51e5811f5e3f7e1a$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$51e5811f5e3f7e1a$var$ENUM] = Array.isArray(rule[$51e5811f5e3f7e1a$var$ENUM]) ? rule[$51e5811f5e3f7e1a$var$ENUM] : [];
    if (rule[$51e5811f5e3f7e1a$var$ENUM].indexOf(value) === -1) errors.push((0, $6BP2j.format)(options.messages[$51e5811f5e3f7e1a$var$ENUM], rule.fullField, rule[$51e5811f5e3f7e1a$var$ENUM].join(', ')));
};
var $51e5811f5e3f7e1a$export$2e2bcd8739ae039 = $51e5811f5e3f7e1a$var$enumerable;

});

parcelRegister("iy9o6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d812af3050803a38$export$2e2bcd8739ae039);

var $6BP2j = parcelRequire("6BP2j");
var $d812af3050803a38$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $6BP2j.format)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $6BP2j.format)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $d812af3050803a38$export$2e2bcd8739ae039 = $d812af3050803a38$var$pattern;

});

parcelRegister("dza6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0660b5b30923d4$export$2e2bcd8739ae039);

var $6BP2j = parcelRequire("6BP2j");
var $9e0660b5b30923d4$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $6BP2j.format)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $6BP2j.format)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $6BP2j.format)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $6BP2j.format)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $9e0660b5b30923d4$export$2e2bcd8739ae039 = $9e0660b5b30923d4$var$range;

});

parcelRegister("9sozb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e29c8fe2226ce2c$export$2e2bcd8739ae039);

var $6BP2j = parcelRequire("6BP2j");
var $6e29c8fe2226ce2c$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $6BP2j.isEmptyValue)(value, type || rule.type))) errors.push((0, $6BP2j.format)(options.messages.required, rule.fullField));
};
var $6e29c8fe2226ce2c$export$2e2bcd8739ae039 = $6e29c8fe2226ce2c$var$required;

});

parcelRegister("iYFl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0de5c8e324efd7$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $6BP2j = parcelRequire("6BP2j");

var $9sozb = parcelRequire("9sozb");

var $3lSkc = parcelRequire("3lSkc");
/* eslint max-len:0 */ var $dd0de5c8e324efd7$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $dd0de5c8e324efd7$var$types = {
    integer: function integer(value) {
        return $dd0de5c8e324efd7$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $dd0de5c8e324efd7$var$types.number(value) && !$dd0de5c8e324efd7$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, $1Esi2.default)(value) === 'object' && !$dd0de5c8e324efd7$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($dd0de5c8e324efd7$var$pattern.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $3lSkc.default)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($dd0de5c8e324efd7$var$pattern.hex);
    }
};
var $dd0de5c8e324efd7$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $9sozb.default)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$dd0de5c8e324efd7$var$types[ruleType](value)) errors.push((0, $6BP2j.format)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $1Esi2.default)(value) !== rule.type) errors.push((0, $6BP2j.format)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $dd0de5c8e324efd7$export$2e2bcd8739ae039 = $dd0de5c8e324efd7$var$type;

});
parcelRegister("3lSkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $270d790505ffa356$export$2e2bcd8739ae039);
// https://github.com/kevva/url-regex/blob/master/index.js
var $270d790505ffa356$var$urlReg;
var $270d790505ffa356$export$2e2bcd8739ae039 = function() {
    if ($270d790505ffa356$var$urlReg) return $270d790505ffa356$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $270d790505ffa356$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return $270d790505ffa356$var$urlReg;
};

});


parcelRegister("VfXU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ac1b55752e966c8$export$2e2bcd8739ae039);

var $6BP2j = parcelRequire("6BP2j");
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $0ac1b55752e966c8$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, $6BP2j.format)(options.messages.whitespace, rule.fullField));
};
var $0ac1b55752e966c8$export$2e2bcd8739ae039 = $0ac1b55752e966c8$var$whitespace;

});



parcelRegister("cVR6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a4018331100149$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");
var $96a4018331100149$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $592V7.default).type(rule, value, source, errors, options);
            (0, $592V7.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $96a4018331100149$export$2e2bcd8739ae039 = $96a4018331100149$var$array;

});

parcelRegister("ioIV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64d50356fbe67e4$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $d64d50356fbe67e4$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $592V7.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $d64d50356fbe67e4$export$2e2bcd8739ae039 = $d64d50356fbe67e4$var$boolean;

});

parcelRegister("h7HZo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c77536796b511c79$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $c77536796b511c79$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value, 'date') && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (!(0, $6BP2j.isEmptyValue)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $592V7.default).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $592V7.default).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $c77536796b511c79$export$2e2bcd8739ae039 = $c77536796b511c79$var$date;

});

parcelRegister("cqyer", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c2777fbc2f54e6$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $90c2777fbc2f54e6$var$ENUM = 'enum';
var $90c2777fbc2f54e6$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $592V7.default)[$90c2777fbc2f54e6$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $90c2777fbc2f54e6$export$2e2bcd8739ae039 = $90c2777fbc2f54e6$var$enumerable;

});

parcelRegister("7uaBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $573390d1aea7b99f$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $573390d1aea7b99f$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $592V7.default).type(rule, value, source, errors, options);
            (0, $592V7.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $573390d1aea7b99f$export$2e2bcd8739ae039 = $573390d1aea7b99f$var$floatFn;

});

parcelRegister("2xkLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8ec630e06d6b1c$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $1d8ec630e06d6b1c$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $592V7.default).type(rule, value, source, errors, options);
            (0, $592V7.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $1d8ec630e06d6b1c$export$2e2bcd8739ae039 = $1d8ec630e06d6b1c$var$integer;

});

parcelRegister("9XeCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $73f4f84bf32bd053$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $73f4f84bf32bd053$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $592V7.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $73f4f84bf32bd053$export$2e2bcd8739ae039 = $73f4f84bf32bd053$var$method;

});

parcelRegister("fks2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28e79272bbd87d6$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $b28e79272bbd87d6$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $592V7.default).type(rule, value, source, errors, options);
            (0, $592V7.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b28e79272bbd87d6$export$2e2bcd8739ae039 = $b28e79272bbd87d6$var$number;

});

parcelRegister("2rmV2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6fe1a02d2d3e92$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $1c6fe1a02d2d3e92$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $592V7.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $1c6fe1a02d2d3e92$export$2e2bcd8739ae039 = $1c6fe1a02d2d3e92$var$object;

});

parcelRegister("fNe9s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7f668cbd948d94b$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $b7f668cbd948d94b$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value, 'string') && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (!(0, $6BP2j.isEmptyValue)(value, 'string')) (0, $592V7.default).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b7f668cbd948d94b$export$2e2bcd8739ae039 = $b7f668cbd948d94b$var$pattern;

});

parcelRegister("5HFk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $427105ad69c8a608$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $427105ad69c8a608$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options);
        if (!(0, $6BP2j.isEmptyValue)(value)) (0, $592V7.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $427105ad69c8a608$export$2e2bcd8739ae039 = $427105ad69c8a608$var$regexp;

});

parcelRegister("jMtFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66983d491f5215c$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $592V7 = parcelRequire("592V7");
var $e66983d491f5215c$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, $1Esi2.default)(value);
    (0, $592V7.default).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $e66983d491f5215c$export$2e2bcd8739ae039 = $e66983d491f5215c$var$required;

});

parcelRegister("4Ldas", function(module, exports) {

$parcel$export(module.exports, "default", () => $3775c407219819bf$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $3775c407219819bf$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value, 'string') && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options, 'string');
        if (!(0, $6BP2j.isEmptyValue)(value, 'string')) {
            (0, $592V7.default).type(rule, value, source, errors, options);
            (0, $592V7.default).range(rule, value, source, errors, options);
            (0, $592V7.default).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $592V7.default).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $3775c407219819bf$export$2e2bcd8739ae039 = $3775c407219819bf$var$string;

});

parcelRegister("gJw0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e9adc1f2971213$export$2e2bcd8739ae039);

var $592V7 = parcelRequire("592V7");

var $6BP2j = parcelRequire("6BP2j");
var $c2e9adc1f2971213$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6BP2j.isEmptyValue)(value, ruleType) && !rule.required) return callback();
        (0, $592V7.default).required(rule, value, source, errors, options, ruleType);
        if (!(0, $6BP2j.isEmptyValue)(value, ruleType)) (0, $592V7.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $c2e9adc1f2971213$export$2e2bcd8739ae039 = $c2e9adc1f2971213$var$type;

});


parcelRegister("ecFGR", function(module, exports) {

});


parcelRegister("i63mZ", function(module, exports) {

$parcel$export(module.exports, "defaultValidateMessages", () => $d2cb66b21ff23f41$export$c86b939816b8fbf8);
var $d2cb66b21ff23f41$var$typeTemplate = "'${name}' is not a valid ${type}";
var $d2cb66b21ff23f41$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $d2cb66b21ff23f41$var$typeTemplate,
        method: $d2cb66b21ff23f41$var$typeTemplate,
        array: $d2cb66b21ff23f41$var$typeTemplate,
        object: $d2cb66b21ff23f41$var$typeTemplate,
        number: $d2cb66b21ff23f41$var$typeTemplate,
        date: $d2cb66b21ff23f41$var$typeTemplate,
        boolean: $d2cb66b21ff23f41$var$typeTemplate,
        integer: $d2cb66b21ff23f41$var$typeTemplate,
        float: $d2cb66b21ff23f41$var$typeTemplate,
        regexp: $d2cb66b21ff23f41$var$typeTemplate,
        email: $d2cb66b21ff23f41$var$typeTemplate,
        url: $d2cb66b21ff23f41$var$typeTemplate,
        hex: $d2cb66b21ff23f41$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};

});

parcelRegister("3hbWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $262c381b09b0f838$export$2e2bcd8739ae039);
$parcel$export(module.exports, "merge", () => $262c381b09b0f838$export$4950aa0f605343fb);

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $eGaoM = parcelRequire("eGaoM");

var $k19OO = parcelRequire("k19OO");
function $262c381b09b0f838$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $eGaoM.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $fvBso.default)(entity);
    else clone = (0, $8u3qN.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $262c381b09b0f838$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $262c381b09b0f838$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $k19OO.default)(entity, paths.slice(0, -1))) return entity;
    return $262c381b09b0f838$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $262c381b09b0f838$var$isObject(obj) {
    return (0, $1Esi2.default)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $262c381b09b0f838$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $262c381b09b0f838$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $262c381b09b0f838$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $262c381b09b0f838$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $k19OO.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $262c381b09b0f838$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $k19OO.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $262c381b09b0f838$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $1Esi2.default)(originValue) !== 'object') // Init container if not exist
                    clone = $262c381b09b0f838$export$2e2bcd8739ae039(clone, path, $262c381b09b0f838$var$createEmpty(value));
                    $262c381b09b0f838$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $fvBso.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $262c381b09b0f838$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});
parcelRegister("eGaoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aafd0dde7e1bf87f$export$2e2bcd8739ae039);

var $7GpR8 = parcelRequire("7GpR8");

var $3OwDc = parcelRequire("3OwDc");

var $kLtvf = parcelRequire("kLtvf");

var $8ugGL = parcelRequire("8ugGL");
function $aafd0dde7e1bf87f$export$2e2bcd8739ae039(r) {
    return (0, $7GpR8.default)(r) || (0, $3OwDc.default)(r) || (0, $kLtvf.default)(r) || (0, $8ugGL.default)();
}

});
parcelRegister("7GpR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5980831bba73dec0$export$2e2bcd8739ae039);
function $5980831bba73dec0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("8ugGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $62de121fff835e24$export$2e2bcd8739ae039);
function $62de121fff835e24$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("k19OO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92b8466a87c071d$export$2e2bcd8739ae039);
function $e92b8466a87c071d$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});



parcelRegister("6CxJR", function(module, exports) {

$parcel$export(module.exports, "getNamePath", () => $4d20767aa1d1c951$export$f877b3cb4cb4ccf9);
$parcel$export(module.exports, "cloneByNamePathList", () => $4d20767aa1d1c951$export$f5be6dfb30403c59);
$parcel$export(module.exports, "containsNamePath", () => $4d20767aa1d1c951$export$646d5504364ae55b);
$parcel$export(module.exports, "matchNamePath", () => $4d20767aa1d1c951$export$325a4bd0e71bdc3a);
$parcel$export(module.exports, "isSimilar", () => $4d20767aa1d1c951$export$dfcec05bb7372a54);
$parcel$export(module.exports, "defaultGetValueFromEvent", () => $4d20767aa1d1c951$export$6eeac3c5b406fb30);
$parcel$export(module.exports, "move", () => $4d20767aa1d1c951$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "getValue", () => (parcelRequire("k19OO")).default);
$parcel$export(module.exports, "setValue", () => (parcelRequire("3hbWa")).default);

var $fvBso = parcelRequire("fvBso");

var $1Esi2 = parcelRequire("1Esi2");

var $k19OO = parcelRequire("k19OO");

var $3hbWa = parcelRequire("3hbWa");

var $9tjNt = parcelRequire("9tjNt");
function $4d20767aa1d1c951$export$f877b3cb4cb4ccf9(path) {
    return (0, $9tjNt.toArray)(path);
}
function $4d20767aa1d1c951$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $k19OO.default)(store, namePath);
        newStore = (0, $3hbWa.default)(newStore, namePath, value);
    });
    return newStore;
}
function $4d20767aa1d1c951$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $4d20767aa1d1c951$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $4d20767aa1d1c951$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $4d20767aa1d1c951$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $1Esi2.default)(source) !== 'object' || (0, $1Esi2.default)(target) !== 'object') return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $fvBso.default)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $4d20767aa1d1c951$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $1Esi2.default)(event.target) === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $4d20767aa1d1c951$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $fvBso.default)(array.slice(0, toIndex)), [
        item
    ], (0, $fvBso.default)(array.slice(toIndex, moveIndex)), (0, $fvBso.default)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $fvBso.default)(array.slice(0, moveIndex)), (0, $fvBso.default)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $fvBso.default)(array.slice(toIndex + 1, length)));
    return array;
}

});


parcelRegister("eGP8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab1ca7c140983141$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $2bFmQ = parcelRequire("2bFmQ");

var $9PKWp = parcelRequire("9PKWp");

var $g3ui7 = parcelRequire("g3ui7");

var $6CxJR = parcelRequire("6CxJR");

var $lapVt = parcelRequire("lapVt");
function $ab1ca7c140983141$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $jMaZ8.useContext((0, $9PKWp.default));
    var wrapperListContext = $jMaZ8.useContext((0, $lapVt.default));
    var keyRef = $jMaZ8.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $jMaZ8.useMemo(function() {
        var parentPrefixName = (0, $6CxJR.getNamePath)(context.prefixName) || [];
        return [].concat((0, $fvBso.default)(parentPrefixName), (0, $fvBso.default)((0, $6CxJR.getNamePath)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $jMaZ8.useMemo(function() {
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $jMaZ8.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $2bFmQ.default)(false, 'Form.List only accepts function as children.');
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $jMaZ8.createElement((0, $lapVt.default).Provider, {
        value: listContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $9PKWp.default).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $g3ui7.default), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $fvBso.default)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $fvBso.default)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $fvBso.default)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $fvBso.default)(newValue.slice(index))));
                } else {
                    if (index < 0 || index > newValue.length) (0, $2bFmQ.default)(false, 'The second parameter of the add function should be a valid positive number.');
                    keyManager.keys = [].concat((0, $fvBso.default)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $fvBso.default)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $6CxJR.move)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $6CxJR.move)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) {
            listValue = [];
            (0, $2bFmQ.default)(false, "Current value of '".concat(prefixName.join(' > '), "' is not an array type."));
        }
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $ab1ca7c140983141$export$2e2bcd8739ae039 = $ab1ca7c140983141$var$List;

});

parcelRegister("4sljH", function(module, exports) {

$parcel$export(module.exports, "default", () => $33ea5001c2655114$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $fvBso = parcelRequire("fvBso");

var $1Esi2 = parcelRequire("1Esi2");

var $9O7LJ = parcelRequire("9O7LJ");

var $klxbl = parcelRequire("klxbl");

var $eq8kl = parcelRequire("eq8kl");

var $3hbWa = parcelRequire("3hbWa");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $9PKWp = parcelRequire("9PKWp");

var $bavD0 = parcelRequire("bavD0");

var $i63mZ = parcelRequire("i63mZ");

var $anXxT = parcelRequire("anXxT");

var $6CxJR = parcelRequire("6CxJR");
var $k19OO = parcelRequire("k19OO");
var $3hbWa = parcelRequire("3hbWa");
var $33ea5001c2655114$var$_excluded = [
    "name"
];
var $33ea5001c2655114$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $9O7LJ.default)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $klxbl.default)(this, FormStore);
    (0, $eq8kl.default)(this, "formHooked", false);
    (0, $eq8kl.default)(this, "forceRootUpdate", void 0);
    (0, $eq8kl.default)(this, "subscribable", true);
    (0, $eq8kl.default)(this, "store", {});
    (0, $eq8kl.default)(this, "fieldEntities", []);
    (0, $eq8kl.default)(this, "initialValues", {});
    (0, $eq8kl.default)(this, "callbacks", {});
    (0, $eq8kl.default)(this, "validateMessages", null);
    (0, $eq8kl.default)(this, "preserve", null);
    (0, $eq8kl.default)(this, "lastValidatePromise", null);
    (0, $eq8kl.default)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $eq8kl.default)(this, "getInternalHooks", function(key) {
        if (key === (0, $9PKWp.HOOK_MARK)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $2bFmQ.default)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    });
    (0, $eq8kl.default)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $eq8kl.default)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $eq8kl.default)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $3hbWa.merge)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $3hbWa.default)(nextStore, namePath, (0, $k19OO.default)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $eq8kl.default)(this, "destroyForm", function(clearOnDestroy) {
        if (clearOnDestroy) // destroy form reset store
        _this.updateStore({});
        else {
            // Fill preserve fields
            var prevWithoutPreserves = new (0, $anXxT.default)();
            _this.getFieldEntities(true).forEach(function(entity) {
                if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            _this.prevWithoutPreserves = prevWithoutPreserves;
        }
    });
    (0, $eq8kl.default)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $k19OO.default)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $3hbWa.merge)(initValue) : initValue;
    });
    (0, $eq8kl.default)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $eq8kl.default)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $eq8kl.default)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $eq8kl.default)(this, "watchList", []);
    (0, $eq8kl.default)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $eq8kl.default)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $eq8kl.default)(this, "timeoutId", null);
    (0, $eq8kl.default)(this, "warningUnhooked", function() {
        if (!_this.timeoutId && typeof window !== 'undefined') _this.timeoutId = setTimeout(function() {
            _this.timeoutId = null;
            if (!_this.formHooked) (0, $2bFmQ.default)(false, 'Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?');
        });
    });
    // ============================ Store =============================
    (0, $eq8kl.default)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $eq8kl.default)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $eq8kl.default)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $anXxT.default)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $eq8kl.default)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $6CxJR.getNamePath)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $6CxJR.getNamePath)(name)
            };
        });
    });
    (0, $eq8kl.default)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $1Esi2.default)(nameList) === 'object') {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $6CxJR.cloneByNamePathList)(_this.store, filteredNameList.map((0, $6CxJR.getNamePath)));
    });
    (0, $eq8kl.default)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $6CxJR.getNamePath)(name);
        return (0, $k19OO.default)(_this.store, namePath);
    });
    (0, $eq8kl.default)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !('INVALIDATE_NAME_PATH' in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $6CxJR.getNamePath)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $eq8kl.default)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $6CxJR.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $eq8kl.default)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $6CxJR.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $eq8kl.default)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $6CxJR.getNamePath));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $6CxJR.getNamePath));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(function(entity) {
            return isFieldTouched(entity) || entity.isList();
        }) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $anXxT.default)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $fvBso.default)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $eq8kl.default)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $eq8kl.default)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $6CxJR.getNamePath));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $6CxJR.containsNamePath)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $eq8kl.default)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $eq8kl.default)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $anXxT.default)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $2bFmQ.default)(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $2bFmQ.default)(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            var isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) _this.updateStore((0, $3hbWa.default)(_this.store, namePath, (0, $fvBso.default)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $fvBso.default)((0, $fvBso.default)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $eq8kl.default)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $3hbWa.merge)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $6CxJR.getNamePath));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $3hbWa.default)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        _this.notifyWatch(namePathList);
    });
    (0, $eq8kl.default)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $4b02Q.default)(fieldData, $33ea5001c2655114$var$_excluded);
            var namePath = (0, $6CxJR.getNamePath)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) _this.updateStore((0, $3hbWa.default)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $eq8kl.default)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $8u3qN.default)((0, $8u3qN.default)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $eq8kl.default)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $k19OO.default)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $3hbWa.default)(_this.store, namePath, initialValue));
        }
    });
    (0, $eq8kl.default)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $eq8kl.default)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $6CxJR.matchNamePath)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $3hbWa.default)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $eq8kl.default)(this, "dispatch", function(action) {
        switch(action.type){
            case 'updateValue':
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case 'validateField':
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $eq8kl.default)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $8u3qN.default)((0, $8u3qN.default)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $eq8kl.default)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath
            ].concat((0, $fvBso.default)(childrenFields))
        });
        return childrenFields;
    });
    (0, $eq8kl.default)(this, "updateValue", function(name, value) {
        var namePath = (0, $6CxJR.getNamePath)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $3hbWa.default)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $6CxJR.cloneByNamePathList)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $fvBso.default)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $eq8kl.default)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $3hbWa.merge)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        _this.notifyWatch();
    });
    (0, $eq8kl.default)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: []
            }
        ]);
    });
    (0, $eq8kl.default)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $anXxT.default)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $6CxJR.getNamePath)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $eq8kl.default)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $anXxT.default)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $6CxJR.containsNamePath)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $eq8kl.default)(this, "validateFields", function(arg1, arg2) {
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $6CxJR.getNamePath)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $6CxJR.containsNamePath)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $8u3qN.default)({
                    validateMessages: (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $i63mZ.defaultValidateMessages)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
                        var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $fvBso.default)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $fvBso.default)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $bavD0.allPromiseFinish)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref10) {
                var name = _ref10.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $eq8kl.default)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $33ea5001c2655114$var$useForm(form) {
    var formRef = $jMaZ8.useRef();
    var _React$useState = $jMaZ8.useState({}), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $33ea5001c2655114$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $33ea5001c2655114$export$2e2bcd8739ae039 = $33ea5001c2655114$var$useForm;

});
parcelRegister("3fkx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d2b33df0f0e716$export$2e2bcd8739ae039);

var $7GpR8 = parcelRequire("7GpR8");

var $h9DPh = parcelRequire("h9DPh");

var $kLtvf = parcelRequire("kLtvf");

var $8ugGL = parcelRequire("8ugGL");
function $25d2b33df0f0e716$export$2e2bcd8739ae039(r, e) {
    return (0, $7GpR8.default)(r) || (0, $h9DPh.default)(r, e) || (0, $kLtvf.default)(r, e) || (0, $8ugGL.default)();
}

});
parcelRegister("h9DPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d22b9083b5ee94$export$2e2bcd8739ae039);
function $c7d22b9083b5ee94$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});


parcelRegister("bavD0", function(module, exports) {

$parcel$export(module.exports, "allPromiseFinish", () => $8219298b26711e08$export$6152adfdcc6be2b5);
function $8219298b26711e08$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}

});

parcelRegister("anXxT", function(module, exports) {

$parcel$export(module.exports, "default", () => $78fa3de32f59c940$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $fvBso = parcelRequire("fvBso");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");

var $1Esi2 = parcelRequire("1Esi2");
var $78fa3de32f59c940$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $78fa3de32f59c940$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $1Esi2.default)(cell), ":").concat(cell);
    })// Magic split
    .join($78fa3de32f59c940$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $78fa3de32f59c940$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $klxbl.default)(this, NameMap);
        (0, $eq8kl.default)(this, "kvs", new Map());
    }
    (0, $9O7LJ.default)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($78fa3de32f59c940$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($78fa3de32f59c940$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($78fa3de32f59c940$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $fvBso.default)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $3fkx6.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($78fa3de32f59c940$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $3fkx6.default)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === 'number' ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join('.')] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $78fa3de32f59c940$export$2e2bcd8739ae039 = $78fa3de32f59c940$var$NameMap;

});


parcelRegister("7sRVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f4fa835799bbc7$export$2e2bcd8739ae039);

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $4sljH = parcelRequire("4sljH");

var $9PKWp = parcelRequire("9PKWp");

var $jAqyT = parcelRequire("jAqyT");

var $6CxJR = parcelRequire("6CxJR");

var $lapVt = parcelRequire("lapVt");
var $56f4fa835799bbc7$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed",
    "clearOnDestroy"
];
var $56f4fa835799bbc7$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? 'form' : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, clearOnDestroy = _ref.clearOnDestroy, restProps = (0, $4b02Q.default)(_ref, $56f4fa835799bbc7$var$_excluded);
    var nativeElementRef = $jMaZ8.useRef(null);
    var formContext = $jMaZ8.useContext((0, $jAqyT.default));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $4sljH.default)(form), _useForm2 = (0, $3fkx6.default)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $9PKWp.HOOK_MARK)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $jMaZ8.useImperativeHandle(ref, function() {
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, formInstance), {}, {
            nativeElement: nativeElementRef.current
        });
    });
    // Register form into Context
    $jMaZ8.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $8u3qN.default)((0, $8u3qN.default)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $jMaZ8.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $jMaZ8.useEffect(function() {
        return function() {
            return destroyForm(clearOnDestroy);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $jMaZ8.useRef();
    $jMaZ8.useEffect(function() {
        if (!(0, $6CxJR.isSimilar)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $jMaZ8.useMemo(function() {
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $jMaZ8.createElement((0, $lapVt.default).Provider, {
        value: null
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $9PKWp.default).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({}, restProps, {
        ref: nativeElementRef,
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $56f4fa835799bbc7$export$2e2bcd8739ae039 = $56f4fa835799bbc7$var$Form;

});
parcelRegister("jAqyT", function(module, exports) {

$parcel$export(module.exports, "FormProvider", () => $e425fbba214261a7$export$8ce1ff4f94d08846);
$parcel$export(module.exports, "default", () => $e425fbba214261a7$export$2e2bcd8739ae039);

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
var $e425fbba214261a7$var$FormContext = /*#__PURE__*/ $jMaZ8.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $e425fbba214261a7$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $jMaZ8.useContext($e425fbba214261a7$var$FormContext);
    var formsRef = $jMaZ8.useRef({});
    return /*#__PURE__*/ $jMaZ8.createElement($e425fbba214261a7$var$FormContext.Provider, {
        value: (0, $8u3qN.default)((0, $8u3qN.default)({}, formContext), {}, {
            validateMessages: (0, $8u3qN.default)((0, $8u3qN.default)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $8u3qN.default)((0, $8u3qN.default)({}, formsRef.current), {}, (0, $eq8kl.default)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $8u3qN.default)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $e425fbba214261a7$export$2e2bcd8739ae039 = $e425fbba214261a7$var$FormContext;

});


parcelRegister("4440P", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5aa5ec257cf76e$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $9PKWp = parcelRequire("9PKWp");

var $9tjNt = parcelRequire("9tjNt");

var $6CxJR = parcelRequire("6CxJR");
var $k19OO = parcelRequire("k19OO");
function $2f5aa5ec257cf76e$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $2f5aa5ec257cf76e$var$useWatchWarning = function(namePath) {
    var fullyStr = namePath.join('__RC_FIELD_FORM_SPLIT__');
    var nameStrRef = (0, $jMaZ8.useRef)(fullyStr);
    (0, $2bFmQ.default)(nameStrRef.current === fullyStr, '`useWatch` is not support dynamic `namePath`. Please provide static instead.');
};
// ------- selector type -------
// ------- selector type end -------
function $2f5aa5ec257cf76e$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
    var options = (0, $9tjNt.isFormInstance)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $jMaZ8.useState)(), _useState2 = (0, $3fkx6.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $jMaZ8.useMemo)(function() {
        return $2f5aa5ec257cf76e$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $jMaZ8.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $jMaZ8.useContext)((0, $9PKWp.default));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    (0, $2bFmQ.default)(args.length === 2 ? form ? isValidForm : true : isValidForm, 'useWatch requires a form instance since it can not auto detect from context.');
    var namePath = (0, $6CxJR.getNamePath)(dependencies);
    var namePathRef = (0, $jMaZ8.useRef)(namePath);
    namePathRef.current = namePath;
    $2f5aa5ec257cf76e$var$useWatchWarning(namePath);
    (0, $jMaZ8.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $9PKWp.HOOK_MARK)), registerWatch = _getInternalHooks.registerWatch;
        var getWatchValue = function getWatchValue(values, allValues) {
            var watchValue = options.preserve ? allValues : values;
            return typeof dependencies === 'function' ? dependencies(watchValue) : (0, $k19OO.default)(watchValue, namePathRef.current);
        };
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = getWatchValue(values, allValues);
            var nextValueStr = $2f5aa5ec257cf76e$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $2f5aa5ec257cf76e$export$2e2bcd8739ae039 = $2f5aa5ec257cf76e$var$useWatch;

});


parcelRegister("7PWCI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5b4ac53aae777cb2$export$2e2bcd8739ae039);

var $7QIZv = parcelRequire("7QIZv");
const $5b4ac53aae777cb2$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $5b4ac53aae777cb2$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $7QIZv.compute)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $7QIZv.compute)(e, $5b4ac53aae777cb2$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}

});
parcelRegister("7QIZv", function(module, exports) {

$parcel$export(module.exports, "compute", () => $01798d94ca3b3847$export$3b12cb22b12b954b);
const $01798d94ca3b3847$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $01798d94ca3b3847$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $01798d94ca3b3847$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $01798d94ca3b3847$var$e(o.overflowY, n) || $01798d94ca3b3847$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $01798d94ca3b3847$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $01798d94ca3b3847$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $01798d94ca3b3847$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$01798d94ca3b3847$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $01798d94ca3b3847$var$t(W) && p(W);){
        if (W = $01798d94ca3b3847$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $01798d94ca3b3847$var$n(W) && !$01798d94ca3b3847$var$n(document.documentElement) || null != W && $01798d94ca3b3847$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$01798d94ca3b3847$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $01798d94ca3b3847$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $01798d94ca3b3847$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $01798d94ca3b3847$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $01798d94ca3b3847$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};

});


parcelRegister("29zSp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1918405974635286$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseInput", () => (parcelRequire("lCJre")).default);

var $lCJre = parcelRequire("lCJre");

var $2AjmG = parcelRequire("2AjmG");
var $1918405974635286$export$2e2bcd8739ae039 = (0, $2AjmG.default);

});
parcelRegister("lCJre", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbe064aeedb1dcb4$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $1Esi2 = parcelRequire("1Esi2");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");

var $lULOl = parcelRequire("lULOl");
var $fbe064aeedb1dcb4$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef(function(props, ref) {
    var _props, _props2, _props3;
    var inputEl = props.inputElement, children = props.children, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components, onClear = props.onClear;
    var inputElement = children !== null && children !== void 0 ? children : inputEl;
    var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || 'span';
    var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || 'span';
    var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || 'span';
    var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || 'span';
    var containerRef = (0, $jMaZ8.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    };
    var hasAffix = (0, $lULOl.hasPrefixSuffix)(props);
    var element = /*#__PURE__*/ (0, $jMaZ8.cloneElement)(inputElement, {
        value: value,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_props = inputElement.props) === null || _props === void 0 ? void 0 : _props.className, !hasAffix && (classNames === null || classNames === void 0 ? void 0 : classNames.variant)) || null
    });
    // ======================== Ref ======================== //
    var groupRef = (0, $jMaZ8.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useImperativeHandle(ref, function() {
        return {
            nativeElement: groupRef.current || containerRef.current
        };
    });
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        var clearIcon = null;
        if (allowClear) {
            var needClear = !disabled && !readOnly && value;
            var clearIconCls = "".concat(prefixCls, "-clear-icon");
            var iconNode = (0, $1Esi2.default)(allowClear) === 'object' && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("button", {
                type: "button",
                onClick: function onClick(event) {
                    handleReset === null || handleReset === void 0 || handleReset(event);
                    onClear === null || onClear === void 0 || onClear();
                },
                onMouseDown: function onMouseDown(e) {
                    return e.preventDefault();
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(clearIconCls, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(clearIconCls, "-hidden"), !needClear), "".concat(clearIconCls, "-has-suffix"), !!suffix))
            }, iconNode);
        }
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(affixWrapperPrefixCls, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-focused"), focused), "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.variant);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
            style: styles === null || styles === void 0 ? void 0 : styles.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(AffixWrapperComponent, (0, $hH60s.default)({
            className: affixWrapperCls,
            style: styles === null || styles === void 0 ? void 0 : styles.affixWrapper,
            onClick: onInputClick
        }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
            style: styles === null || styles === void 0 ? void 0 : styles.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $lULOl.hasAddon)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames === null || classNames === void 0 ? void 0 : classNames.wrapper);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(groupWrapperCls, (0, $eq8kl.default)({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames === null || classNames === void 0 ? void 0 : classNames.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(element, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_props2 = element.props) === null || _props2 === void 0 ? void 0 : _props2.className, className) || null,
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, (_props3 = element.props) === null || _props3 === void 0 ? void 0 : _props3.style), style),
        hidden: hidden
    });
});
var $fbe064aeedb1dcb4$export$2e2bcd8739ae039 = $fbe064aeedb1dcb4$var$BaseInput;

});
parcelRegister("lULOl", function(module, exports) {

$parcel$export(module.exports, "hasAddon", () => $041dffa6128ca508$export$ae6255aa850a31d1);
$parcel$export(module.exports, "hasPrefixSuffix", () => $041dffa6128ca508$export$a19010aeeaa0c7a);
$parcel$export(module.exports, "resolveOnChange", () => $041dffa6128ca508$export$c28984794956ddc0);
$parcel$export(module.exports, "triggerFocus", () => $041dffa6128ca508$export$2b92016deb0b7aad);
function $041dffa6128ca508$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $041dffa6128ca508$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $041dffa6128ca508$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    var currentTarget = target.cloneNode(true);
    // click clear icon
    var newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = function() {
        target.setSelectionRange.apply(target, arguments);
    };
    return newEvent;
}
function $041dffa6128ca508$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $041dffa6128ca508$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $041dffa6128ca508$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}
function $041dffa6128ca508$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}

});


parcelRegister("2AjmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1df703ebb0e28c$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");

var $hvG6u = parcelRequire("hvG6u");

var $jMaZ8 = parcelRequire("jMaZ8");

var $lCJre = parcelRequire("lCJre");

var $liU8U = parcelRequire("liU8U");

var $lULOl = parcelRequire("lULOl");
var $1e1df703ebb0e28c$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "onKeyUp",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "count",
    "type",
    "classes",
    "classNames",
    "styles",
    "onCompositionStart",
    "onCompositionEnd"
];
var $1e1df703ebb0e28c$var$Input = /*#__PURE__*/ (0, $jMaZ8.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input' : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, classes = props.classes, classNames = props.classNames, styles = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = (0, $4b02Q.default)(props, $1e1df703ebb0e28c$var$_excluded);
    var _useState = (0, $jMaZ8.useState)(false), _useState2 = (0, $3fkx6.default)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var compositionRef = (0, $jMaZ8.useRef)(false);
    var keyLockRef = (0, $jMaZ8.useRef)(false);
    var inputRef = (0, $jMaZ8.useRef)(null);
    var holderRef = (0, $jMaZ8.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $lULOl.triggerFocus)(inputRef.current, option);
    };
    // ====================== Value =======================
    var _useMergedState = (0, $eGh7a.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? '' : String(value);
    // =================== Select Range ===================
    var _useState3 = (0, $jMaZ8.useState)(null), _useState4 = (0, $3fkx6.default)(_useState3, 2), selection = _useState4[0], setSelection = _useState4[1];
    // ====================== Count =======================
    var countConfig = (0, $liU8U.default)(count, showCount);
    var mergedMax = countConfig.max || maxLength;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $jMaZ8.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current,
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || inputRef.current
        };
    });
    (0, $jMaZ8.useEffect)(function() {
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var triggerChange = function triggerChange(e, currentValue, info) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) {
                var _inputRef$current4, _inputRef$current5;
                setSelection([
                    ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0,
                    ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0
                ]);
            }
        } else if (info.source === 'compositionEnd') // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $lULOl.resolveOnChange)(inputRef.current, e, onChange, cutValue);
    };
    (0, $jMaZ8.useEffect)(function() {
        if (selection) {
            var _inputRef$current6;
            (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, (0, $fvBso.default)(selection));
        }
    }, [
        selection
    ]);
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleKeyUp = function handleKeyUp(e) {
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        if (inputRef.current) (0, $lULOl.resolveOnChange)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $hvG6u.default)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("input", (0, $hH60s.default)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, (0, $eq8kl.default)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: function onCompositionStart(e) {
                compositionRef.current = true;
                _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-show-count-suffix"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
                style: (0, $8u3qN.default)({}, styles === null || styles === void 0 ? void 0 : styles.count)
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $lCJre.default), (0, $hH60s.default)({}, rest, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles
    }), getInputElement());
});
var $1e1df703ebb0e28c$export$2e2bcd8739ae039 = $1e1df703ebb0e28c$var$Input;

});
parcelRegister("eGh7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab024384bee39cdc$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $ktS49 = parcelRequire("ktS49");

var $jLTp6 = parcelRequire("jLTp6");

var $9SyO6 = parcelRequire("9SyO6");
/** We only think `undefined` is empty */ function $ab024384bee39cdc$var$hasValue(value) {
    return value !== undefined;
}
function $ab024384bee39cdc$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $9SyO6.default)(function() {
        if ($ab024384bee39cdc$var$hasValue(value)) return value;
        else if ($ab024384bee39cdc$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $3fkx6.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $ktS49.default)(onChange);
    var _useState3 = (0, $9SyO6.default)([
        mergedValue
    ]), _useState4 = (0, $3fkx6.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $jLTp6.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $jLTp6.useLayoutUpdateEffect)(function() {
        if (!$ab024384bee39cdc$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $ktS49.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

});
parcelRegister("ktS49", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee907473dff669c0$export$2e2bcd8739ae039);

var $jMaZ8 = parcelRequire("jMaZ8");
function $ee907473dff669c0$export$2e2bcd8739ae039(callback) {
    var fnRef = $jMaZ8.useRef();
    fnRef.current = callback;
    var memoFn = $jMaZ8.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

});

parcelRegister("jLTp6", function(module, exports) {

$parcel$export(module.exports, "useLayoutUpdateEffect", () => $e64d62267e027e4f$export$9283e56bae2f7b0f);
$parcel$export(module.exports, "default", () => $e64d62267e027e4f$export$2e2bcd8739ae039);

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("h9ujZ");
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $e64d62267e027e4f$var$useInternalLayoutEffect = (0, $jMaZ8.useEffect);
var $e64d62267e027e4f$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $jMaZ8.useRef(true);
    $e64d62267e027e4f$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $e64d62267e027e4f$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $e64d62267e027e4f$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $e64d62267e027e4f$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $e64d62267e027e4f$export$2e2bcd8739ae039 = $e64d62267e027e4f$var$useLayoutEffect;

});
parcelRegister("h9ujZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7cacc22ce988ad4$export$2e2bcd8739ae039);
function $c7cacc22ce988ad4$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

});


parcelRegister("9SyO6", function(module, exports) {

$parcel$export(module.exports, "default", () => $73142827f6a2e3f6$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $73142827f6a2e3f6$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $jMaZ8.useRef(false);
    var _React$useState = $jMaZ8.useState(defaultValue), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $jMaZ8.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

});


parcelRegister("hvG6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf5fdcef6ab5b4b$export$2e2bcd8739ae039);
function $cbf5fdcef6ab5b4b$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

});

parcelRegister("liU8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $f826d433731c4a21$export$2e2bcd8739ae039);

var $4b02Q = parcelRequire("4b02Q");

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");
var $f826d433731c4a21$var$_excluded = [
    "show"
];
function $f826d433731c4a21$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    var count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $f826d433731c4a21$export$2e2bcd8739ae039(count, showCount) {
    return $jMaZ8.useMemo(function() {
        var mergedConfig = {};
        if (showCount) mergedConfig.show = (0, $1Esi2.default)(showCount) === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = (0, $8u3qN.default)((0, $8u3qN.default)({}, mergedConfig), count);
        var _ref = mergedConfig, show = _ref.show, rest = (0, $4b02Q.default)(_ref, $f826d433731c4a21$var$_excluded);
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, rest), {}, {
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || function(value) {
                return value.length;
            }
        });
    }, [
        count,
        showCount
    ]);
}

});



parcelRegister("7NxHX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5ad741bc844a791b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ResizableTextArea", () => (parcelRequire("2Wvri")).default);

var $82B4J = parcelRequire("82B4J");

var $2Wvri = parcelRequire("2Wvri");
var $5ad741bc844a791b$export$2e2bcd8739ae039 = (0, $82B4J.default);

});
parcelRegister("82B4J", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dab4508baaf0c95$export$2e2bcd8739ae039);

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");
parcelRequire("29zSp");
var $lCJre = parcelRequire("lCJre");

var $liU8U = parcelRequire("liU8U");

var $lULOl = parcelRequire("lULOl");

var $eGh7a = parcelRequire("eGh7a");

var $jMaZ8 = parcelRequire("jMaZ8");

var $2Wvri = parcelRequire("2Wvri");
var $5dab4508baaf0c95$var$_excluded = [
    "defaultValue",
    "value",
    "onFocus",
    "onBlur",
    "onChange",
    "allowClear",
    "maxLength",
    "onCompositionStart",
    "onCompositionEnd",
    "suffix",
    "prefixCls",
    "showCount",
    "count",
    "className",
    "style",
    "disabled",
    "hidden",
    "classNames",
    "styles",
    "onResize",
    "onClear",
    "onPressEnter",
    "readOnly",
    "autoSize",
    "onKeyDown"
];
var $5dab4508baaf0c95$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef(function(_ref, ref) {
    var _countConfig$max;
    var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-textarea' : _ref$prefixCls, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames = _ref.classNames, styles = _ref.styles, onResize = _ref.onResize, onClear = _ref.onClear, onPressEnter = _ref.onPressEnter, readOnly = _ref.readOnly, autoSize = _ref.autoSize, onKeyDown = _ref.onKeyDown, rest = (0, $4b02Q.default)(_ref, $5dab4508baaf0c95$var$_excluded);
    var _useMergedState = (0, $eGh7a.default)(defaultValue, {
        value: customValue,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? '' : String(value);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(false);
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(null), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
    // =============================== Ref ================================
    var holderRef = (0, $jMaZ8.useRef)(null);
    var resizableTextAreaRef = (0, $jMaZ8.useRef)(null);
    var getTextArea = function getTextArea() {
        var _resizableTextAreaRef;
        return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
    };
    var focus = function focus() {
        getTextArea().focus();
    };
    (0, $jMaZ8.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: function blur() {
                getTextArea().blur();
            },
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || getTextArea()
        };
    });
    (0, $jMaZ8.useEffect)(function() {
        setFocused(function(prev) {
            return !disabled && prev;
        });
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(null), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(function() {
        if (selection) {
            var _getTextArea;
            (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, (0, $fvBso.default)(selection));
        }
    }, [
        selection
    ]);
    // ============================== Count ===============================
    var countConfig = (0, $liU8U.default)(count, showCount);
    var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
    // Max length value
    var hasMaxLength = Number(mergedMax) > 0;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $lULOl.resolveOnChange)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        compositionRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && onPressEnter) onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        (0, $lULOl.resolveOnChange)(getTextArea(), e, onChange);
    };
    var suffixNode = suffix;
    var dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-data-count"), classNames === null || classNames === void 0 ? void 0 : classNames.count),
            style: styles === null || styles === void 0 ? void 0 : styles.count
        }, dataCount));
    }
    var handleResize = function handleResize(size) {
        var _getTextArea2;
        onResize === null || onResize === void 0 || onResize(size);
        if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) setTextareaResized(true);
    };
    var isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $lCJre.default), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: (0, $8u3qN.default)((0, $8u3qN.default)({}, classNames), {}, {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-show-count"), showCount), "".concat(prefixCls, "-textarea-allow-clear"), allowClear))
        }),
        disabled: disabled,
        focused: focused,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, style), textareaResized && !isPureTextArea ? {
            height: 'auto'
        } : {}),
        dataAttrs: {
            affixWrapper: {
                'data-count': typeof dataCount === 'string' ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $2Wvri.default), (0, $hH60s.default)({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(classNames === null || classNames === void 0 ? void 0 : classNames.textarea),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
            resize: style === null || style === void 0 ? void 0 : style.resize
        }),
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $5dab4508baaf0c95$export$2e2bcd8739ae039 = $5dab4508baaf0c95$var$TextArea;

});
parcelRegister("2Wvri", function(module, exports) {

$parcel$export(module.exports, "default", () => $224962bba8bb485b$export$2e2bcd8739ae039);

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");

var $jLTp6 = parcelRequire("jLTp6");

var $eGh7a = parcelRequire("eGh7a");

var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");

var $dpH4B = parcelRequire("dpH4B");
var $224962bba8bb485b$var$_excluded = [
    "prefixCls",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $224962bba8bb485b$var$RESIZE_START = 0;
var $224962bba8bb485b$var$RESIZE_MEASURING = 1;
var $224962bba8bb485b$var$RESIZE_STABLE = 2;
var $224962bba8bb485b$var$ResizableTextArea = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var _ref = props, prefixCls = _ref.prefixCls, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize = _ref.onResize, className = _ref.className, style = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = (0, $4b02Q.default)(_ref, $224962bba8bb485b$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $eGh7a.default)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : '';
        }
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $jMaZ8.useRef();
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $jMaZ8.useMemo(function() {
        if (autoSize && (0, $1Esi2.default)(autoSize) === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $3fkx6.default)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $jMaZ8.useState($224962bba8bb485b$var$RESIZE_STABLE), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($224962bba8bb485b$var$RESIZE_START);
        onInternalAutoSize === null || onInternalAutoSize === void 0 || onInternalAutoSize();
    };
    // Change to trigger resize measure
    (0, $jLTp6.default)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $jLTp6.default)(function() {
        if (resizeState === $224962bba8bb485b$var$RESIZE_START) setResizeState($224962bba8bb485b$var$RESIZE_MEASURING);
        else if (resizeState === $224962bba8bb485b$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $dpH4B.default)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($224962bba8bb485b$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $jMaZ8.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $aZxvk.default).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $224962bba8bb485b$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $aZxvk.default)(function() {
                    startResize();
                });
            }
        }
    };
    $jMaZ8.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $8u3qN.default)((0, $8u3qN.default)({}, style), mergedAutoSizeStyle);
    if (resizeState === $224962bba8bb485b$var$RESIZE_START || resizeState === $224962bba8bb485b$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $jMaZ8.createElement("textarea", (0, $hH60s.default)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (0, $eq8kl.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $224962bba8bb485b$export$2e2bcd8739ae039 = $224962bba8bb485b$var$ResizableTextArea;

});
parcelRegister("bAXx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $87113c3232bfdcca$export$2e2bcd8739ae039);

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");

var $a6yuN = parcelRequire("a6yuN");

var $2bFmQ = parcelRequire("2bFmQ");

var $eiZEQ = parcelRequire("eiZEQ");

var $a21ad = parcelRequire("a21ad");

var $avaH0 = parcelRequire("avaH0");
var $87113c3232bfdcca$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $87113c3232bfdcca$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $a6yuN.default)(children);
    if (childNodes.length > 1) (0, $2bFmQ.warning)(false, 'Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.');
    else if (childNodes.length === 0) (0, $2bFmQ.warning)(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($87113c3232bfdcca$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $eiZEQ.default), (0, $hH60s.default)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $87113c3232bfdcca$var$RefResizeObserver = /*#__PURE__*/ $jMaZ8.forwardRef($87113c3232bfdcca$var$ResizeObserver);
$87113c3232bfdcca$var$RefResizeObserver.displayName = 'ResizeObserver';
$87113c3232bfdcca$var$RefResizeObserver.Collection = (0, $a21ad.Collection);
var $87113c3232bfdcca$export$2e2bcd8739ae039 = $87113c3232bfdcca$var$RefResizeObserver;

});
parcelRegister("eiZEQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6a2931b0bb4a6b7$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");

var $cYkhj = parcelRequire("cYkhj");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");

var $a21ad = parcelRequire("a21ad");

var $avaH0 = parcelRequire("avaH0");

var $j0zGt = parcelRequire("j0zGt");
function $a6a2931b0bb4a6b7$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $jMaZ8.useRef(null);
    var wrapperRef = $jMaZ8.useRef(null);
    var onCollectionResize = $jMaZ8.useContext((0, $a21ad.CollectionContext));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $jMaZ8.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $jMaZ8.isValidElement(mergedChildren) && (0, $1cfGC.supportRef)(mergedChildren);
    var originRef = canRef ? (0, $1cfGC.getNodeRef)(mergedChildren) : null;
    var mergedRef = (0, $1cfGC.useComposeRef)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $cYkhj.default)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $1Esi2.default)(elementRef.current) === 'object' ? (0, $cYkhj.default)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $cYkhj.default)(wrapperRef.current);
    };
    $jMaZ8.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $jMaZ8.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $jMaZ8.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $8u3qN.default)((0, $8u3qN.default)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $jMaZ8.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $avaH0.observe)(currentElement, onInternalResize);
        return function() {
            return (0, $avaH0.unobserve)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $j0zGt.default), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $jMaZ8.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $a6a2931b0bb4a6b7$var$RefSingleObserver = /*#__PURE__*/ $jMaZ8.forwardRef($a6a2931b0bb4a6b7$var$SingleObserver);
$a6a2931b0bb4a6b7$var$RefSingleObserver.displayName = 'SingleObserver';
var $a6a2931b0bb4a6b7$export$2e2bcd8739ae039 = $a6a2931b0bb4a6b7$var$RefSingleObserver;

});
parcelRegister("cYkhj", function(module, exports) {

$parcel$export(module.exports, "isDOM", () => $971ad175dddfa9d9$export$41e30d8dd0ba7a50);
$parcel$export(module.exports, "getDOM", () => $971ad175dddfa9d9$export$9aa546fdc20ae5b3);
$parcel$export(module.exports, "default", () => $971ad175dddfa9d9$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");
function $971ad175dddfa9d9$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $971ad175dddfa9d9$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $1Esi2.default)(node) === 'object' && $971ad175dddfa9d9$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($971ad175dddfa9d9$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $971ad175dddfa9d9$export$2e2bcd8739ae039(node) {
    var domNode = $971ad175dddfa9d9$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($6UWRi))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($6UWRi))), node);
    }
    return null;
}

});

parcelRegister("1cfGC", function(module, exports) {

$parcel$export(module.exports, "fillRef", () => $0df3146f964ed9d0$export$f17fd18fa51dcb5b);
$parcel$export(module.exports, "composeRef", () => $0df3146f964ed9d0$export$ab452c34e8e05029);
$parcel$export(module.exports, "useComposeRef", () => $0df3146f964ed9d0$export$1d1c999670a1285d);
$parcel$export(module.exports, "supportRef", () => $0df3146f964ed9d0$export$c1cec34af06bcf7);
$parcel$export(module.exports, "supportNodeRef", () => $0df3146f964ed9d0$export$b51ae67c7882a242);
$parcel$export(module.exports, "getNodeRef", () => $0df3146f964ed9d0$export$7465e5c0bf44f19a);

var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");

var $39k9r = parcelRequire("39k9r");

var $hBgfL = parcelRequire("hBgfL");

var $5tavl = parcelRequire("5tavl");
var $0df3146f964ed9d0$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $1Esi2.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $0df3146f964ed9d0$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $0df3146f964ed9d0$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $0df3146f964ed9d0$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $hBgfL.default)(function() {
        return $0df3146f964ed9d0$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $0df3146f964ed9d0$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($0df3146f964ed9d0$var$isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) return true;
    var type = (0, $39k9r.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $39k9r.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $39k9r.ForwardRef)) return false;
    return true;
};
function $0df3146f964ed9d0$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $jMaZ8.isValidElement)(node) && !(0, $5tavl.default)(node);
}
var $0df3146f964ed9d0$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $0df3146f964ed9d0$var$isReactElement(node) && $0df3146f964ed9d0$export$c1cec34af06bcf7(node);
};
var $0df3146f964ed9d0$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $0df3146f964ed9d0$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

});
parcelRegister("39k9r", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eCnss"));

});

parcelRegister("hBgfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd027fe9df83bf1f$export$2e2bcd8739ae039);

var $jMaZ8 = parcelRequire("jMaZ8");
function $cd027fe9df83bf1f$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $jMaZ8.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});


parcelRegister("a21ad", function(module, exports) {

$parcel$export(module.exports, "CollectionContext", () => $74dafe5ebd4e1396$export$db36075d98ba73d3);
$parcel$export(module.exports, "Collection", () => $74dafe5ebd4e1396$export$fb8073518f34e6ec);

var $jMaZ8 = parcelRequire("jMaZ8");
var $74dafe5ebd4e1396$export$db36075d98ba73d3 = /*#__PURE__*/ $jMaZ8.createContext(null);
function $74dafe5ebd4e1396$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $jMaZ8.useRef(0);
    var resizeInfosRef = $jMaZ8.useRef([]);
    var onCollectionResize = $jMaZ8.useContext($74dafe5ebd4e1396$export$db36075d98ba73d3);
    var onResize = $jMaZ8.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement($74dafe5ebd4e1396$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}

});

parcelRegister("avaH0", function(module, exports) {

$parcel$export(module.exports, "observe", () => $7a5517f3a0be91da$export$d1203567a167490e);
$parcel$export(module.exports, "unobserve", () => $7a5517f3a0be91da$export$23a2283368c55ea2);

var $dABuY = parcelRequire("dABuY");
// =============================== Const ===============================
var $7a5517f3a0be91da$var$elementListeners = new Map();
function $7a5517f3a0be91da$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $7a5517f3a0be91da$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $7a5517f3a0be91da$var$resizeObserver = new (0, $dABuY.default)($7a5517f3a0be91da$var$onResize);
var $7a5517f3a0be91da$export$3fbe5a08fd9e4702 = $7a5517f3a0be91da$var$elementListeners; // eslint-disable-line
var $7a5517f3a0be91da$export$524f0fd3b47831a = $7a5517f3a0be91da$var$onResize; // eslint-disable-line
function $7a5517f3a0be91da$export$d1203567a167490e(element, callback) {
    if (!$7a5517f3a0be91da$var$elementListeners.has(element)) {
        $7a5517f3a0be91da$var$elementListeners.set(element, new Set());
        $7a5517f3a0be91da$var$resizeObserver.observe(element);
    }
    $7a5517f3a0be91da$var$elementListeners.get(element).add(callback);
}
function $7a5517f3a0be91da$export$23a2283368c55ea2(element, callback) {
    if ($7a5517f3a0be91da$var$elementListeners.has(element)) {
        $7a5517f3a0be91da$var$elementListeners.get(element).delete(callback);
        if (!$7a5517f3a0be91da$var$elementListeners.get(element).size) {
            $7a5517f3a0be91da$var$resizeObserver.unobserve(element);
            $7a5517f3a0be91da$var$elementListeners.delete(element);
        }
    }
}

});
parcelRegister("dABuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $028d9bc477e1314f$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $028d9bc477e1314f$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $028d9bc477e1314f$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $028d9bc477e1314f$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $028d9bc477e1314f$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($028d9bc477e1314f$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $028d9bc477e1314f$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $028d9bc477e1314f$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $028d9bc477e1314f$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $028d9bc477e1314f$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $028d9bc477e1314f$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $028d9bc477e1314f$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $028d9bc477e1314f$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $028d9bc477e1314f$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $028d9bc477e1314f$var$throttle(this.refresh.bind(this), $028d9bc477e1314f$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$028d9bc477e1314f$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($028d9bc477e1314f$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$028d9bc477e1314f$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $028d9bc477e1314f$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $028d9bc477e1314f$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $028d9bc477e1314f$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $028d9bc477e1314f$var$global$1;
};
// Placeholder of an empty content rectangle.
var $028d9bc477e1314f$var$emptyRect = $028d9bc477e1314f$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $028d9bc477e1314f$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $028d9bc477e1314f$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $028d9bc477e1314f$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $028d9bc477e1314f$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $028d9bc477e1314f$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $028d9bc477e1314f$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $028d9bc477e1314f$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $028d9bc477e1314f$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $028d9bc477e1314f$var$emptyRect;
    var styles = $028d9bc477e1314f$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $028d9bc477e1314f$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $028d9bc477e1314f$var$toFloat(styles.width), height = $028d9bc477e1314f$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $028d9bc477e1314f$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $028d9bc477e1314f$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$028d9bc477e1314f$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $028d9bc477e1314f$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $028d9bc477e1314f$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $028d9bc477e1314f$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $028d9bc477e1314f$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $028d9bc477e1314f$var$isDocumentElement(target) {
    return target === $028d9bc477e1314f$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $028d9bc477e1314f$var$getContentRect(target) {
    if (!$028d9bc477e1314f$var$isBrowser) return $028d9bc477e1314f$var$emptyRect;
    if ($028d9bc477e1314f$var$isSVGGraphicsElement(target)) return $028d9bc477e1314f$var$getSVGContentRect(target);
    return $028d9bc477e1314f$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $028d9bc477e1314f$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $028d9bc477e1314f$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $028d9bc477e1314f$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $028d9bc477e1314f$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $028d9bc477e1314f$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $028d9bc477e1314f$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $028d9bc477e1314f$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $028d9bc477e1314f$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $028d9bc477e1314f$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $028d9bc477e1314f$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $028d9bc477e1314f$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $028d9bc477e1314f$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $028d9bc477e1314f$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $028d9bc477e1314f$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $028d9bc477e1314f$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $028d9bc477e1314f$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $028d9bc477e1314f$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $028d9bc477e1314f$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $028d9bc477e1314f$var$ResizeObserverController.getInstance();
        var observer = new $028d9bc477e1314f$var$ResizeObserverSPI(callback, controller, this);
        $028d9bc477e1314f$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $028d9bc477e1314f$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $028d9bc477e1314f$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $028d9bc477e1314f$var$index = function() {
    // Export existing implementation if available.
    if (typeof $028d9bc477e1314f$var$global$1.ResizeObserver !== 'undefined') return $028d9bc477e1314f$var$global$1.ResizeObserver;
    return $028d9bc477e1314f$var$ResizeObserver;
}();
var $028d9bc477e1314f$export$2e2bcd8739ae039 = $028d9bc477e1314f$var$index;

});


parcelRegister("j0zGt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd69b2852f900f2c$export$2e2bcd8739ae039);

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $jMaZ8 = parcelRequire("jMaZ8");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $dd69b2852f900f2c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $7eK0y.default)(DomWrapper, _React$Component);
    var _super = (0, $fwNdX.default)(DomWrapper);
    function DomWrapper() {
        (0, $klxbl.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $9O7LJ.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($jMaZ8.Component);

});



parcelRegister("aZxvk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8009972ad31d94cc$export$2e2bcd8739ae039);
var $8009972ad31d94cc$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $8009972ad31d94cc$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $8009972ad31d94cc$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $8009972ad31d94cc$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $8009972ad31d94cc$var$rafUUID = 0;
var $8009972ad31d94cc$var$rafIds = new Map();
function $8009972ad31d94cc$var$cleanup(id) {
    $8009972ad31d94cc$var$rafIds.delete(id);
}
var $8009972ad31d94cc$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $8009972ad31d94cc$var$rafUUID += 1;
    var id = $8009972ad31d94cc$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $8009972ad31d94cc$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $8009972ad31d94cc$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $8009972ad31d94cc$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$8009972ad31d94cc$var$wrapperRaf.cancel = function(id) {
    var realId = $8009972ad31d94cc$var$rafIds.get(id);
    $8009972ad31d94cc$var$cleanup(id);
    return $8009972ad31d94cc$var$caf(realId);
};
$8009972ad31d94cc$var$wrapperRaf.ids = function() {
    return $8009972ad31d94cc$var$rafIds;
};
var $8009972ad31d94cc$export$2e2bcd8739ae039 = $8009972ad31d94cc$var$wrapperRaf;

});

parcelRegister("dpH4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c3f059d12bf846e$export$2e2bcd8739ae039);
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $9c3f059d12bf846e$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $9c3f059d12bf846e$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
var $9c3f059d12bf846e$var$computedStyleCache = {};
var $9c3f059d12bf846e$var$hiddenTextarea;
function $9c3f059d12bf846e$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $9c3f059d12bf846e$var$computedStyleCache[nodeRef]) return $9c3f059d12bf846e$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    var sizingStyle = $9c3f059d12bf846e$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $9c3f059d12bf846e$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $9c3f059d12bf846e$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$9c3f059d12bf846e$var$hiddenTextarea) {
        $9c3f059d12bf846e$var$hiddenTextarea = document.createElement('textarea');
        $9c3f059d12bf846e$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $9c3f059d12bf846e$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $9c3f059d12bf846e$var$hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild($9c3f059d12bf846e$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $9c3f059d12bf846e$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $9c3f059d12bf846e$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $9c3f059d12bf846e$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $9c3f059d12bf846e$var$hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat($9c3f059d12bf846e$var$HIDDEN_TEXTAREA_STYLE));
    $9c3f059d12bf846e$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $9c3f059d12bf846e$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $9c3f059d12bf846e$var$hiddenTextarea.value = ' ';
        var singleRowHeight = $9c3f059d12bf846e$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}

});




parcelRegister("k81ih", function(module, exports) {
/* global window */ 
var $hsGAf = parcelRequire("hsGAf");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $hsGAf.default)(root);
var $ea758eec6ff38c7f$export$2e2bcd8739ae039 = result;

});
parcelRegister("hsGAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb66156fe0f7a4ca$export$2e2bcd8739ae039);
function $cb66156fe0f7a4ca$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("4FUh6", function(module, exports) {
"use strict";
var $3676a4c3667b8dd6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3676a4c3667b8dd6$var$PostgrestQueryBuilder_1 = $3676a4c3667b8dd6$var$__importDefault((parcelRequire("bqqNG")));

const $3676a4c3667b8dd6$var$PostgrestFilterBuilder_1 = $3676a4c3667b8dd6$var$__importDefault((parcelRequire("3o7cE")));

var $4EUnf = parcelRequire("4EUnf");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $3676a4c3667b8dd6$var$PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $4EUnf.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $3676a4c3667b8dd6$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $3676a4c3667b8dd6$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $3676a4c3667b8dd6$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $3676a4c3667b8dd6$var$PostgrestClient;

});
parcelRegister("bqqNG", function(module, exports) {
"use strict";
var $8516e96b6aa8059a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $8516e96b6aa8059a$var$PostgrestFilterBuilder_1 = $8516e96b6aa8059a$var$__importDefault((parcelRequire("3o7cE")));
class $8516e96b6aa8059a$var$PostgrestQueryBuilder {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $8516e96b6aa8059a$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $8516e96b6aa8059a$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $8516e96b6aa8059a$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $8516e96b6aa8059a$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $8516e96b6aa8059a$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $8516e96b6aa8059a$var$PostgrestQueryBuilder;

});
parcelRegister("3o7cE", function(module, exports) {
"use strict";
var $2779336216994393$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2779336216994393$var$PostgrestTransformBuilder_1 = $2779336216994393$var$__importDefault((parcelRequire("iSKkH")));
class $2779336216994393$var$PostgrestFilterBuilder extends $2779336216994393$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $2779336216994393$var$PostgrestFilterBuilder;

});
parcelRegister("iSKkH", function(module, exports) {
"use strict";
var $dbf135e81741b6e3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $dbf135e81741b6e3$var$PostgrestBuilder_1 = $dbf135e81741b6e3$var$__importDefault((parcelRequire("awOWX")));
class $dbf135e81741b6e3$var$PostgrestTransformBuilder extends $dbf135e81741b6e3$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */ returns() {
        return this;
    }
}
module.exports.default = $dbf135e81741b6e3$var$PostgrestTransformBuilder;

});
parcelRegister("awOWX", function(module, exports) {
"use strict";
var $7aa46a233b2eaa56$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $7aa46a233b2eaa56$var$node_fetch_1 = $7aa46a233b2eaa56$var$__importDefault((parcelRequire("h44DG")));

const $7aa46a233b2eaa56$var$PostgrestError_1 = $7aa46a233b2eaa56$var$__importDefault((parcelRequire("hgnOq")));
class $7aa46a233b2eaa56$var$PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $7aa46a233b2eaa56$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $7aa46a233b2eaa56$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
}
module.exports.default = $7aa46a233b2eaa56$var$PostgrestBuilder;

});
parcelRegister("h44DG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", () => $0334bf9f7bbe3e69$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "default", () => $0334bf9f7bbe3e69$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Headers", () => $0334bf9f7bbe3e69$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $0334bf9f7bbe3e69$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $0334bf9f7bbe3e69$export$9f633d56d7ec90d3);
"use strict";
// ref: https://github.com/tc39/proposal-global
var $0334bf9f7bbe3e69$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $0334bf9f7bbe3e69$var$globalObject = $0334bf9f7bbe3e69$var$getGlobal();
const $0334bf9f7bbe3e69$export$e7aa7bc5c1b3cfb3 = $0334bf9f7bbe3e69$var$globalObject.fetch;
var $0334bf9f7bbe3e69$export$2e2bcd8739ae039 = $0334bf9f7bbe3e69$var$globalObject.fetch.bind($0334bf9f7bbe3e69$var$globalObject);
const $0334bf9f7bbe3e69$export$79b704688b15c0f4 = $0334bf9f7bbe3e69$var$globalObject.Headers;
const $0334bf9f7bbe3e69$export$7fa6c5b6f8193917 = $0334bf9f7bbe3e69$var$globalObject.Request;
const $0334bf9f7bbe3e69$export$9f633d56d7ec90d3 = $0334bf9f7bbe3e69$var$globalObject.Response;

});

parcelRegister("hgnOq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $c91666f08215274b$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $c91666f08215274b$var$PostgrestError;

});





parcelRegister("4EUnf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $lQwq9 = parcelRequire("lQwq9");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$lQwq9.version}`
};

});
parcelRegister("lQwq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("cO9vY", function(module, exports) {

var $8XoTT = parcelRequire("8XoTT");
module.exports = $8XoTT("lmUdb").then(()=>parcelRequire('fqHOd'));

});
parcelRegister("8XoTT", function(module, exports) {
"use strict";

function $68572627de5d4f8d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5cJUx")).resolve(id));
}
module.exports = $68572627de5d4f8d$var$load;

});


parcelRegister("jzGiR", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("cYHIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $972cff4ddedbc807$export$2e2bcd8739ae039);

var $l5SVI = parcelRequire("l5SVI");
var $972cff4ddedbc807$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $972cff4ddedbc807$var$index = (0, $l5SVI.default)(function(prop) {
    return $972cff4ddedbc807$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $972cff4ddedbc807$export$2e2bcd8739ae039 = $972cff4ddedbc807$var$index;

});
parcelRegister("l5SVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b4ac8a59bb5c43$export$2e2bcd8739ae039);
function $f5b4ac8a59bb5c43$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f5b4ac8a59bb5c43$export$2e2bcd8739ae039 = $f5b4ac8a59bb5c43$var$memoize;

});


parcelRegister("62LIg", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("3hsAy", function(module, exports) {

var $18oEd = parcelRequire("18oEd");

var $1vKue = parcelRequire("1vKue");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $18oEd.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1vKue;
module.exports = isBuffer;

});
parcelRegister("18oEd", function(module, exports) {

var $aCzFJ = parcelRequire("aCzFJ");
/** Detect free variable `self`. */ var $0d39a8502464cf78$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0d39a8502464cf78$var$root = $aCzFJ || $0d39a8502464cf78$var$freeSelf || Function('return this')();
module.exports = $0d39a8502464cf78$var$root;

});
parcelRegister("aCzFJ", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $7bb91fbdfbd7b232$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $7bb91fbdfbd7b232$var$freeGlobal;

});


parcelRegister("1vKue", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $119cbef635399961$var$stubFalse() {
    return false;
}
module.exports = $119cbef635399961$var$stubFalse;

});


parcelRegister("6Zhl9", function(module, exports) {

var $aCzFJ = parcelRequire("aCzFJ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $aCzFJ.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("ckUzF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jMaZ8 = parcelRequire("jMaZ8");
var $8fb33cbde6e1d5a4$var$IconContext = /*#__PURE__*/ (0, $jMaZ8.createContext)({});
var $8fb33cbde6e1d5a4$var$_default = module.exports.default = $8fb33cbde6e1d5a4$var$IconContext;

});

parcelRegister("1C33x", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $12cbb5eaaabb3ce0$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $12cbb5eaaabb3ce0$var$useMemo;

var $12cbb5eaaabb3ce0$var$React = $12cbb5eaaabb3ce0$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
function $12cbb5eaaabb3ce0$var$useMemo(getValue, condition, shouldUpdate) {
    var cacheRef = $12cbb5eaaabb3ce0$var$React.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});
parcelRegister("ffW2x", function(module, exports) {

var $cEcQP = parcelRequire("cEcQP");
var $b1b54746f54a7fab$var$_typeof = $cEcQP.default;
function $b1b54746f54a7fab$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b1b54746f54a7fab$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b1b54746f54a7fab$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $b1b54746f54a7fab$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $b1b54746f54a7fab$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = $b1b54746f54a7fab$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4MICP", function(module, exports) {

var $17meZ = parcelRequire("17meZ");
function $37be42c008e51984$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37be42c008e51984$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37be42c008e51984$var$ownKeys(Object(t), !0).forEach(function(r) {
            $17meZ(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37be42c008e51984$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $37be42c008e51984$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dCUrJ", function(module, exports) {

var $9HVAD = parcelRequire("9HVAD");

var $cFJ6o = parcelRequire("cFJ6o");

var $de4uR = parcelRequire("de4uR");

var $6Y1lH = parcelRequire("6Y1lH");
function $9eba9c028ac87206$var$_toConsumableArray(r) {
    return $9HVAD(r) || $cFJ6o(r) || $de4uR(r) || $6Y1lH();
}
module.exports = $9eba9c028ac87206$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9HVAD", function(module, exports) {

var $ihHBD = parcelRequire("ihHBD");
function $7114cd5a0ffd2e4f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ihHBD(r);
}
module.exports = $7114cd5a0ffd2e4f$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cFJ6o", function(module, exports) {
function $939c4cb4c9f156d2$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $939c4cb4c9f156d2$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6Y1lH", function(module, exports) {
function $51296490a8227b70$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $51296490a8227b70$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2ULpd", function(module, exports) {

var $akltj = parcelRequire("akltj");

var $cFJ6o = parcelRequire("cFJ6o");

var $de4uR = parcelRequire("de4uR");

var $bhST4 = parcelRequire("bhST4");
function $21f595893f3f5529$var$_toArray(r) {
    return $akltj(r) || $cFJ6o(r) || $de4uR(r) || $bhST4();
}
module.exports = $21f595893f3f5529$var$_toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hzvfn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccadf18f6e01ee25$var$get;
function $ccadf18f6e01ee25$var$get(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});

parcelRegister("dw0yD", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $9d6eb23b88daaf9b$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.devUseWarning = module.exports.default = module.exports.WarningContext = void 0;
module.exports.noop = $9d6eb23b88daaf9b$var$noop;
module.exports.resetWarned = $9d6eb23b88daaf9b$var$resetWarned;

var $9d6eb23b88daaf9b$var$React = $9d6eb23b88daaf9b$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $9d6eb23b88daaf9b$var$_warning = $9d6eb23b88daaf9b$require$_interopRequireWildcard((parcelRequire("jtk8Y")));
function $9d6eb23b88daaf9b$var$noop() {}
let $9d6eb23b88daaf9b$var$deprecatedWarnList = null;
function $9d6eb23b88daaf9b$var$resetWarned() {
    $9d6eb23b88daaf9b$var$deprecatedWarnList = null;
    (0, $9d6eb23b88daaf9b$var$_warning.resetWarned)();
}
// eslint-disable-next-line import/no-mutable-exports
let $9d6eb23b88daaf9b$var$warning = $9d6eb23b88daaf9b$var$noop;
$9d6eb23b88daaf9b$var$warning = (valid, component, message)=>{
    (0, $9d6eb23b88daaf9b$var$_warning.default)(valid, `[antd: ${component}] ${message}`);
    $9d6eb23b88daaf9b$var$resetWarned();
};
const $9d6eb23b88daaf9b$var$WarningContext = module.exports.WarningContext = /*#__PURE__*/ $9d6eb23b88daaf9b$var$React.createContext({});
/**
 * This is a hook but we not named as `useWarning`
 * since this is only used in development.
 * We should always wrap this in `if (process.env.NODE_ENV !== 'production')` condition
 */ const $9d6eb23b88daaf9b$var$devUseWarning = module.exports.devUseWarning = (component)=>{
    const { strict: strict } = $9d6eb23b88daaf9b$var$React.useContext($9d6eb23b88daaf9b$var$WarningContext);
    const typeWarning = (valid, type, message)=>{
        if (!valid) {
            if (strict === false && type === 'deprecated') {
                const existWarning = $9d6eb23b88daaf9b$var$deprecatedWarnList;
                if (!$9d6eb23b88daaf9b$var$deprecatedWarnList) $9d6eb23b88daaf9b$var$deprecatedWarnList = {};
                $9d6eb23b88daaf9b$var$deprecatedWarnList[component] = $9d6eb23b88daaf9b$var$deprecatedWarnList[component] || [];
                if (!$9d6eb23b88daaf9b$var$deprecatedWarnList[component].includes(message || '')) $9d6eb23b88daaf9b$var$deprecatedWarnList[component].push(message || '');
                // Warning for the first time
                if (!existWarning) console.warn('[antd] There exists deprecated usage in your code:', $9d6eb23b88daaf9b$var$deprecatedWarnList);
            } else $9d6eb23b88daaf9b$var$warning(valid, component, message);
        }
    };
    typeWarning.deprecated = (valid, oldProp, newProp, message)=>{
        typeWarning(valid, 'deprecated', `\`${oldProp}\` is deprecated. Please use \`${newProp}\` instead.${message ? ` ${message}` : ''}`);
    };
    return typeWarning;
};
var $9d6eb23b88daaf9b$var$_default = module.exports.default = $9d6eb23b88daaf9b$var$warning;

});
parcelRegister("jtk8Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.call = $e2d059de7b1f7bd8$var$call;
module.exports.default = void 0;
module.exports.note = $e2d059de7b1f7bd8$var$note;
module.exports.noteOnce = $e2d059de7b1f7bd8$var$noteOnce;
module.exports.preMessage = void 0;
module.exports.resetWarned = $e2d059de7b1f7bd8$var$resetWarned;
module.exports.warning = $e2d059de7b1f7bd8$var$warning;
module.exports.warningOnce = $e2d059de7b1f7bd8$var$warningOnce;
/* eslint-disable no-console */ var $e2d059de7b1f7bd8$var$warned = {};
var $e2d059de7b1f7bd8$var$preWarningFns = [];
/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */ var $e2d059de7b1f7bd8$var$preMessage = module.exports.preMessage = function preMessage(fn) {
    $e2d059de7b1f7bd8$var$preWarningFns.push(fn);
};
/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */ function $e2d059de7b1f7bd8$var$warning(valid, message) {
    if (!valid && console !== undefined) {
        var finalMessage = $e2d059de7b1f7bd8$var$preWarningFns.reduce(function(msg, preMessageFn) {
            return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'warning');
        }, message);
        if (finalMessage) console.error("Warning: ".concat(finalMessage));
    }
}
/** @see Similar to {@link warning} */ function $e2d059de7b1f7bd8$var$note(valid, message) {
    if (!valid && console !== undefined) {
        var finalMessage = $e2d059de7b1f7bd8$var$preWarningFns.reduce(function(msg, preMessageFn) {
            return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'note');
        }, message);
        if (finalMessage) console.warn("Note: ".concat(finalMessage));
    }
}
function $e2d059de7b1f7bd8$var$resetWarned() {
    $e2d059de7b1f7bd8$var$warned = {};
}
function $e2d059de7b1f7bd8$var$call(method, valid, message) {
    if (!valid && !$e2d059de7b1f7bd8$var$warned[message]) {
        method(false, message);
        $e2d059de7b1f7bd8$var$warned[message] = true;
    }
}
/** @see Same as {@link warning}, but only warn once for the same message */ function $e2d059de7b1f7bd8$var$warningOnce(valid, message) {
    $e2d059de7b1f7bd8$var$call($e2d059de7b1f7bd8$var$warning, valid, message);
}
/** @see Same as {@link warning}, but only warn once for the same message */ function $e2d059de7b1f7bd8$var$noteOnce(valid, message) {
    $e2d059de7b1f7bd8$var$call($e2d059de7b1f7bd8$var$note, valid, message);
}
$e2d059de7b1f7bd8$var$warningOnce.preMessage = $e2d059de7b1f7bd8$var$preMessage;
$e2d059de7b1f7bd8$var$warningOnce.resetWarned = $e2d059de7b1f7bd8$var$resetWarned;
$e2d059de7b1f7bd8$var$warningOnce.noteOnce = $e2d059de7b1f7bd8$var$noteOnce;
var $e2d059de7b1f7bd8$var$_default = module.exports.default = $e2d059de7b1f7bd8$var$warningOnce;

});


parcelRegister("eoEJS", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jMaZ8 = parcelRequire("jMaZ8");
// ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
var $a7b2e87f58e135d7$var$_default = module.exports.default = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);

});

parcelRegister("2FeQp", function(module, exports) {
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $1f0aecdff6221fe2$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $1f0aecdff6221fe2$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ANT_MARK = void 0;
Object.defineProperty(module.exports, "useLocale", {
    enumerable: true,
    get: function() {
        return $1f0aecdff6221fe2$var$_useLocale.default;
    }
});

var $1f0aecdff6221fe2$var$React = $1f0aecdff6221fe2$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $dw0yD = parcelRequire("dw0yD");

var $dBEbR = parcelRequire("dBEbR");

var $1f0aecdff6221fe2$var$_context = $1f0aecdff6221fe2$require$_interopRequireDefault((parcelRequire("aTcK8")));

var $1f0aecdff6221fe2$var$_useLocale = $1f0aecdff6221fe2$require$_interopRequireDefault((parcelRequire("12mlp")));
const $1f0aecdff6221fe2$var$ANT_MARK = module.exports.ANT_MARK = 'internalMark';
const $1f0aecdff6221fe2$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    {
        const warning = (0, $dw0yD.devUseWarning)('LocaleProvider');
        warning(_ANT_MARK__ === $1f0aecdff6221fe2$var$ANT_MARK, 'deprecated', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    }
    $1f0aecdff6221fe2$var$React.useEffect(()=>{
        const clearLocale = (0, $dBEbR.changeConfirmLocale)(locale === null || locale === void 0 ? void 0 : locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $1f0aecdff6221fe2$var$React.useMemo(()=>Object.assign(Object.assign({}, locale), {
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $1f0aecdff6221fe2$var$React.createElement($1f0aecdff6221fe2$var$_context.default.Provider, {
        value: getMemoizedContextValue
    }, children);
};
$1f0aecdff6221fe2$var$LocaleProvider.displayName = 'LocaleProvider';
var $1f0aecdff6221fe2$var$_default = module.exports.default = $1f0aecdff6221fe2$var$LocaleProvider;

});
parcelRegister("4d0me", function(module, exports) {
function $3108a7560afa7105$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $3108a7560afa7105$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dBEbR", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $9e7de804bd45dc39$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.changeConfirmLocale = $9e7de804bd45dc39$var$changeConfirmLocale;
module.exports.getConfirmLocale = $9e7de804bd45dc39$var$getConfirmLocale;

var $9e7de804bd45dc39$var$_en_US = $9e7de804bd45dc39$require$_interopRequireDefault((parcelRequire("3O4C3")));
let $9e7de804bd45dc39$var$runtimeLocale = Object.assign({}, $9e7de804bd45dc39$var$_en_US.default.Modal);
let $9e7de804bd45dc39$var$localeList = [];
const $9e7de804bd45dc39$var$generateLocale = ()=>$9e7de804bd45dc39$var$localeList.reduce((merged, locale)=>Object.assign(Object.assign({}, merged), locale), $9e7de804bd45dc39$var$_en_US.default.Modal);
function $9e7de804bd45dc39$var$changeConfirmLocale(newLocale) {
    if (newLocale) {
        const cloneLocale = Object.assign({}, newLocale);
        $9e7de804bd45dc39$var$localeList.push(cloneLocale);
        $9e7de804bd45dc39$var$runtimeLocale = $9e7de804bd45dc39$var$generateLocale();
        return ()=>{
            $9e7de804bd45dc39$var$localeList = $9e7de804bd45dc39$var$localeList.filter((locale)=>locale !== cloneLocale);
            $9e7de804bd45dc39$var$runtimeLocale = $9e7de804bd45dc39$var$generateLocale();
        };
    }
    $9e7de804bd45dc39$var$runtimeLocale = Object.assign({}, $9e7de804bd45dc39$var$_en_US.default.Modal);
}
function $9e7de804bd45dc39$var$getConfirmLocale() {
    return $9e7de804bd45dc39$var$runtimeLocale;
}

});
parcelRegister("3O4C3", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $2c599e97c88a9c87$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c599e97c88a9c87$var$_en_US = $2c599e97c88a9c87$require$_interopRequireDefault((parcelRequire("6BRFB")));

var $2c599e97c88a9c87$var$_en_US2 = $2c599e97c88a9c87$require$_interopRequireDefault((parcelRequire("l4EvL")));

var $2c599e97c88a9c87$var$_en_US3 = $2c599e97c88a9c87$require$_interopRequireDefault((parcelRequire("1drmC")));

var $2c599e97c88a9c87$var$_en_US4 = $2c599e97c88a9c87$require$_interopRequireDefault((parcelRequire("aojtY")));
const $2c599e97c88a9c87$var$typeTemplate = '${label} is not a valid ${type}';
const $2c599e97c88a9c87$var$localeValues = {
    locale: 'en',
    Pagination: $2c599e97c88a9c87$var$_en_US.default,
    DatePicker: $2c599e97c88a9c87$var$_en_US3.default,
    TimePicker: $2c599e97c88a9c87$var$_en_US4.default,
    Calendar: $2c599e97c88a9c87$var$_en_US2.default,
    global: {
        placeholder: 'Please select'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckall: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $2c599e97c88a9c87$var$typeTemplate,
                method: $2c599e97c88a9c87$var$typeTemplate,
                array: $2c599e97c88a9c87$var$typeTemplate,
                object: $2c599e97c88a9c87$var$typeTemplate,
                number: $2c599e97c88a9c87$var$typeTemplate,
                date: $2c599e97c88a9c87$var$typeTemplate,
                boolean: $2c599e97c88a9c87$var$typeTemplate,
                integer: $2c599e97c88a9c87$var$typeTemplate,
                float: $2c599e97c88a9c87$var$typeTemplate,
                regexp: $2c599e97c88a9c87$var$typeTemplate,
                email: $2c599e97c88a9c87$var$typeTemplate,
                url: $2c599e97c88a9c87$var$typeTemplate,
                hex: $2c599e97c88a9c87$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $2c599e97c88a9c87$var$_default = module.exports.default = $2c599e97c88a9c87$var$localeValues;

});
parcelRegister("6BRFB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4cffd483d0a5eca1$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $4cffd483d0a5eca1$var$_default = module.exports.default = $4cffd483d0a5eca1$var$locale;

});

parcelRegister("l4EvL", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $f5796569f0f194ba$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5796569f0f194ba$var$_en_US = $f5796569f0f194ba$require$_interopRequireDefault((parcelRequire("1drmC")));
var $f5796569f0f194ba$var$_default = module.exports.default = $f5796569f0f194ba$var$_en_US.default;

});
parcelRegister("1drmC", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $0e2c3b3da172a983$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e2c3b3da172a983$var$_en_US = $0e2c3b3da172a983$require$_interopRequireDefault((parcelRequire("7LPer")));

var $0e2c3b3da172a983$var$_en_US2 = $0e2c3b3da172a983$require$_interopRequireDefault((parcelRequire("aojtY")));
// Merge into a locale object
const $0e2c3b3da172a983$var$locale = {
    lang: Object.assign({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, $0e2c3b3da172a983$var$_en_US.default),
    timePickerLocale: Object.assign({}, $0e2c3b3da172a983$var$_en_US2.default)
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
var $0e2c3b3da172a983$var$_default = module.exports.default = $0e2c3b3da172a983$var$locale;

});
parcelRegister("7LPer", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $5a84a9cea7ac9efe$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a84a9cea7ac9efe$var$_objectSpread2 = $5a84a9cea7ac9efe$require$_interopRequireDefault((parcelRequire("4MICP")));

var $486tP = parcelRequire("486tP");
var $5a84a9cea7ac9efe$var$locale = (0, $5a84a9cea7ac9efe$var$_objectSpread2.default)((0, $5a84a9cea7ac9efe$var$_objectSpread2.default)({}, $486tP.commonLocale), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    dateFormat: 'M/D/YYYY',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $5a84a9cea7ac9efe$var$_default = module.exports.default = $5a84a9cea7ac9efe$var$locale;

});
parcelRegister("486tP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.commonLocale = void 0;
var $301cef9b245209b7$var$commonLocale = module.exports.commonLocale = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};

});


parcelRegister("aojtY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $790b42193087ec1b$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $790b42193087ec1b$var$_default = module.exports.default = $790b42193087ec1b$var$locale;

});





parcelRegister("aTcK8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jMaZ8 = parcelRequire("jMaZ8");
const $7ed8ecf5a3348970$var$LocaleContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);
var $7ed8ecf5a3348970$var$_default = module.exports.default = $7ed8ecf5a3348970$var$LocaleContext;

});

parcelRegister("12mlp", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $0c174f789e378153$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $0c174f789e378153$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c174f789e378153$var$React = $0c174f789e378153$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $0c174f789e378153$var$_context = $0c174f789e378153$require$_interopRequireDefault((parcelRequire("aTcK8")));

var $0c174f789e378153$var$_en_US = $0c174f789e378153$require$_interopRequireDefault((parcelRequire("3O4C3")));
const $0c174f789e378153$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $0c174f789e378153$var$React.useContext($0c174f789e378153$var$_context.default);
    const getLocale = $0c174f789e378153$var$React.useMemo(()=>{
        var _a;
        const locale = defaultLocale || $0c174f789e378153$var$_en_US.default[componentName];
        const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $0c174f789e378153$var$React.useMemo(()=>{
        const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return $0c174f789e378153$var$_en_US.default.locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $0c174f789e378153$var$_default = module.exports.default = $0c174f789e378153$var$useLocale;

});


parcelRegister("lCXqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultPresetColors = module.exports.default = void 0;
const $fbeb3eb68cd5ea30$var$defaultPresetColors = module.exports.defaultPresetColors = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $fbeb3eb68cd5ea30$var$seedToken = Object.assign(Object.assign({}, $fbeb3eb68cd5ea30$var$defaultPresetColors), {
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $fbeb3eb68cd5ea30$var$_default = module.exports.default = $fbeb3eb68cd5ea30$var$seedToken;

});

parcelRegister("6PPgr", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $4f9f45799c8ad9d6$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("gedkv");
var $9Bzxi = parcelRequire("9Bzxi");

var $4f9f45799c8ad9d6$var$_index = $4f9f45799c8ad9d6$require$_interopRequireDefault((parcelRequire("1Ly4M")));
const $4f9f45799c8ad9d6$var$defaultTheme = (0, $9Bzxi.default)($4f9f45799c8ad9d6$var$_index.default);
var $4f9f45799c8ad9d6$var$_default = module.exports.default = $4f9f45799c8ad9d6$var$defaultTheme;

});
parcelRegister("gedkv", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => (parcelRequire("9Bzxi")).default);
$parcel$export(module.exports, "useStyleRegister", () => (parcelRequire("gofJe")).default);
$parcel$export(module.exports, "useCSSVarRegister", () => (parcelRequire("atLsZ")).default);
$parcel$export(module.exports, "useCacheToken", () => (parcelRequire("e3Z3v")).default);
$parcel$export(module.exports, "StyleContext", () => (parcelRequire("jANP6")).default);
$parcel$export(module.exports, "Keyframes", () => (parcelRequire("kB90R")).default);
$parcel$export(module.exports, "token2CSSVar", () => (parcelRequire("f0tZ5")).token2CSSVar);
$parcel$export(module.exports, "unit", () => (parcelRequire("4g3I0")).unit);

var $6pTKb = parcelRequire("6pTKb");

var $e3Z3v = parcelRequire("e3Z3v");

var $atLsZ = parcelRequire("atLsZ");

var $gofJe = parcelRequire("gofJe");

var $kB90R = parcelRequire("kB90R");
parcelRequire("eNDWU");
var $ajcak = parcelRequire("ajcak");
var $kaDqo = parcelRequire("kaDqo");
var $2UJnn = parcelRequire("2UJnn");
var $iUl6X = parcelRequire("iUl6X");

var $jANP6 = parcelRequire("jANP6");
parcelRequire("rxRcW");
var $9Bzxi = parcelRequire("9Bzxi");

var $8LBQX = parcelRequire("8LBQX");

var $jzC0v = parcelRequire("jzC0v");

var $4g3I0 = parcelRequire("4g3I0");

var $f0tZ5 = parcelRequire("f0tZ5");
var $bd084b217e1d0e2c$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $4g3I0.supportWhere)() && (0, $4g3I0.supportLogicProps)();
    }
};

});
parcelRegister("6pTKb", function(module, exports) {

var $3fkx6 = parcelRequire("3fkx6");

var $eq8kl = parcelRequire("eq8kl");

var $e3Z3v = parcelRequire("e3Z3v");

var $atLsZ = parcelRequire("atLsZ");

var $gofJe = parcelRequire("gofJe");

var $4g3I0 = parcelRequire("4g3I0");

var $iwtUh = parcelRequire("iwtUh");
var $4ac0516e069c75a0$var$_ExtractStyleFns;
var $4ac0516e069c75a0$var$ExtractStyleFns = ($4ac0516e069c75a0$var$_ExtractStyleFns = {}, (0, $eq8kl.default)($4ac0516e069c75a0$var$_ExtractStyleFns, (0, $gofJe.STYLE_PREFIX), (0, $gofJe.extract)), (0, $eq8kl.default)($4ac0516e069c75a0$var$_ExtractStyleFns, (0, $e3Z3v.TOKEN_PREFIX), (0, $e3Z3v.extract)), (0, $eq8kl.default)($4ac0516e069c75a0$var$_ExtractStyleFns, (0, $atLsZ.CSS_VAR_PREFIX), (0, $atLsZ.extract)), $4ac0516e069c75a0$var$_ExtractStyleFns);
function $4ac0516e069c75a0$var$isNotNull(value) {
    return value !== null;
}
function $4ac0516e069c75a0$export$2e2bcd8739ae039(cache, options) {
    var _ref = typeof options === 'boolean' ? {
        plain: options
    } : options || {}, _ref$plain = _ref.plain, plain = _ref$plain === void 0 ? false : _ref$plain, _ref$types = _ref.types, types = _ref$types === void 0 ? [
        'style',
        'token',
        'cssVar'
    ] : _ref$types;
    var matchPrefixRegexp = new RegExp("^(".concat((typeof types === 'string' ? [
        types
    ] : types).join('|'), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = '';
    styleKeys.map(function(key) {
        var cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        var _key$split = key.split('%'), _key$split2 = (0, $3fkx6.default)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $4ac0516e069c75a0$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $3fkx6.default)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        return [
            order,
            styleStr
        ];
    }).filter($4ac0516e069c75a0$var$isNotNull).sort(function(_ref2, _ref3) {
        var _ref4 = (0, $3fkx6.default)(_ref2, 1), o1 = _ref4[0];
        var _ref5 = (0, $3fkx6.default)(_ref3, 1), o2 = _ref5[0];
        return o1 - o2;
    }).forEach(function(_ref6) {
        var _ref7 = (0, $3fkx6.default)(_ref6, 2), style = _ref7[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $4g3I0.toStyleStr)(".".concat((0, $iwtUh.ATTR_CACHE_MAP), "{content:\"").concat((0, $iwtUh.serialize)(cachePathMap), "\";}"), undefined, undefined, (0, $eq8kl.default)({}, (0, $iwtUh.ATTR_CACHE_MAP), (0, $iwtUh.ATTR_CACHE_MAP)), plain);
    return styleText;
}

});
parcelRegister("e3Z3v", function(module, exports) {

$parcel$export(module.exports, "TOKEN_PREFIX", () => $a3d0b4e1b88328a2$export$270fba097347f4fa);
$parcel$export(module.exports, "default", () => $a3d0b4e1b88328a2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extract", () => $a3d0b4e1b88328a2$export$f9380c9a627682d3);

var $3fkx6 = parcelRequire("3fkx6");

var $fvBso = parcelRequire("fvBso");

var $8u3qN = parcelRequire("8u3qN");

var $ismqa = parcelRequire("ismqa");

var $lfFyj = parcelRequire("lfFyj");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jANP6 = parcelRequire("jANP6");

var $4g3I0 = parcelRequire("4g3I0");

var $f0tZ5 = parcelRequire("f0tZ5");

var $53ALy = parcelRequire("53ALy");
var $a3d0b4e1b88328a2$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $a3d0b4e1b88328a2$var$hashPrefix = 'css-dev-only-do-not-override';
var $a3d0b4e1b88328a2$var$tokenKeys = new Map();
function $a3d0b4e1b88328a2$var$recordCleanToken(tokenKey) {
    $a3d0b4e1b88328a2$var$tokenKeys.set(tokenKey, ($a3d0b4e1b88328a2$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $a3d0b4e1b88328a2$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        var styles = document.querySelectorAll("style[".concat((0, $jANP6.ATTR_TOKEN), "=\"").concat(key, "\"]"));
        styles.forEach(function(style) {
            if (style[0, $jANP6.CSS_IN_JS_INSTANCE] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $a3d0b4e1b88328a2$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $a3d0b4e1b88328a2$var$cleanTokenStyle(tokenKey, instanceId) {
    $a3d0b4e1b88328a2$var$tokenKeys.set(tokenKey, ($a3d0b4e1b88328a2$var$tokenKeys.get(tokenKey) || 0) - 1);
    var tokenKeyList = Array.from($a3d0b4e1b88328a2$var$tokenKeys.keys());
    var cleanableKeyList = tokenKeyList.filter(function(key) {
        var count = $a3d0b4e1b88328a2$var$tokenKeys.get(key) || 0;
        return count <= 0;
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeyList.length - cleanableKeyList.length > $a3d0b4e1b88328a2$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $a3d0b4e1b88328a2$var$removeStyleTags(key, instanceId);
        $a3d0b4e1b88328a2$var$tokenKeys.delete(key);
    });
}
var $a3d0b4e1b88328a2$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $8u3qN.default)((0, $8u3qN.default)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $a3d0b4e1b88328a2$export$270fba097347f4fa = 'token';
function $a3d0b4e1b88328a2$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $jMaZ8.useContext)((0, $jANP6.default)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? '' : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $a3d0b4e1b88328a2$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $4g3I0.memoResult)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $fvBso.default)(tokens)));
    }, tokens);
    var tokenStr = (0, $4g3I0.flattenToken)(mergedToken);
    var overrideTokenStr = (0, $4g3I0.flattenToken)(override);
    var cssVarStr = cssVar ? (0, $4g3I0.flattenToken)(cssVar) : '';
    var cachedToken = (0, $53ALy.default)($a3d0b4e1b88328a2$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $a3d0b4e1b88328a2$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $8u3qN.default)({}, mergedDerivativeToken);
        var cssVarsStr = '';
        if (!!cssVar) {
            var _transformToken = (0, $f0tZ5.transformToken)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $3fkx6.default)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $4g3I0.token2key)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $4g3I0.token2key)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $a3d0b4e1b88328a2$var$recordCleanToken(themeKey);
        var hashId = "".concat($a3d0b4e1b88328a2$var$hashPrefix, "-").concat((0, $ismqa.default)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ''
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $a3d0b4e1b88328a2$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $3fkx6.default)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $lfFyj.updateCSS)(cssVarsStr, (0, $ismqa.default)("css-variables-".concat(token._themeKey)), {
                mark: (0, $jANP6.ATTR_MARK),
                prepend: 'queue',
                attachTo: container,
                priority: -999
            });
            style[0, $jANP6.CSS_IN_JS_INSTANCE] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $jANP6.ATTR_TOKEN), token._themeKey);
        }
    });
    return cachedToken;
}
var $a3d0b4e1b88328a2$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $3fkx6.default)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $4g3I0.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};

});
parcelRegister("ismqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6fc3bdd18ec56e6$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $d6fc3bdd18ec56e6$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $d6fc3bdd18ec56e6$export$2e2bcd8739ae039 = $d6fc3bdd18ec56e6$var$murmur2;

});

parcelRegister("lfFyj", function(module, exports) {

$parcel$export(module.exports, "removeCSS", () => $f78b3b1cfde15086$export$2232e336aecaa80a);
$parcel$export(module.exports, "updateCSS", () => $f78b3b1cfde15086$export$4d99a2890bb989f0);

var $8u3qN = parcelRequire("8u3qN");

var $h9ujZ = parcelRequire("h9ujZ");

var $eN1T8 = parcelRequire("eN1T8");
var $f78b3b1cfde15086$var$APPEND_ORDER = 'data-rc-order';
var $f78b3b1cfde15086$var$APPEND_PRIORITY = 'data-rc-priority';
var $f78b3b1cfde15086$var$MARK_KEY = "rc-util-key";
var $f78b3b1cfde15086$var$containerCache = new Map();
function $f78b3b1cfde15086$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $f78b3b1cfde15086$var$MARK_KEY;
}
function $f78b3b1cfde15086$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $f78b3b1cfde15086$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $f78b3b1cfde15086$var$findStyles(container) {
    return Array.from(($f78b3b1cfde15086$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $f78b3b1cfde15086$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $h9ujZ.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $f78b3b1cfde15086$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($f78b3b1cfde15086$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($f78b3b1cfde15086$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $f78b3b1cfde15086$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $f78b3b1cfde15086$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($f78b3b1cfde15086$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($f78b3b1cfde15086$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $f78b3b1cfde15086$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $f78b3b1cfde15086$var$getContainer(option);
    return (option.styles || $f78b3b1cfde15086$var$findStyles(container)).find(function(node) {
        return node.getAttribute($f78b3b1cfde15086$var$getMark(option)) === key;
    });
}
function $f78b3b1cfde15086$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $f78b3b1cfde15086$var$findExistNode(key, option);
    if (existNode) {
        var container = $f78b3b1cfde15086$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $f78b3b1cfde15086$var$syncRealContainer(container, option) {
    var cachedRealContainer = $f78b3b1cfde15086$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $eN1T8.default)(document, cachedRealContainer)) {
        var placeholderStyle = $f78b3b1cfde15086$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $f78b3b1cfde15086$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $f78b3b1cfde15086$export$f80df667f2f5a272() {
    $f78b3b1cfde15086$var$containerCache.clear();
}
function $f78b3b1cfde15086$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $f78b3b1cfde15086$var$getContainer(originOption);
    var styles = $f78b3b1cfde15086$var$findStyles(container);
    var option = (0, $8u3qN.default)((0, $8u3qN.default)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $f78b3b1cfde15086$var$syncRealContainer(container, option);
    var existNode = $f78b3b1cfde15086$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $f78b3b1cfde15086$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($f78b3b1cfde15086$var$getMark(option), key);
    return newNode;
}

});
parcelRegister("eN1T8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac471b466ff824e8$export$2e2bcd8739ae039);
function $ac471b466ff824e8$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

});


parcelRegister("jANP6", function(module, exports) {

$parcel$export(module.exports, "ATTR_TOKEN", () => $e43806f827796f0a$export$5d99297dcd5476ac);
$parcel$export(module.exports, "ATTR_MARK", () => $e43806f827796f0a$export$89ce1123b3c0bd9e);
$parcel$export(module.exports, "ATTR_CACHE_PATH", () => $e43806f827796f0a$export$36f8a6c9fa24262a);
$parcel$export(module.exports, "CSS_IN_JS_INSTANCE", () => $e43806f827796f0a$export$4c16a0c02134a7dc);
$parcel$export(module.exports, "default", () => $e43806f827796f0a$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $hBgfL = parcelRequire("hBgfL");

var $9O5K3 = parcelRequire("9O5K3");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jbZrs = parcelRequire("jbZrs");
var $e43806f827796f0a$var$_excluded = [
    "children"
];
var $e43806f827796f0a$export$5d99297dcd5476ac = 'data-token-hash';
var $e43806f827796f0a$export$89ce1123b3c0bd9e = 'data-css-hash';
var $e43806f827796f0a$export$36f8a6c9fa24262a = 'data-cache-path';
var $e43806f827796f0a$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $e43806f827796f0a$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($e43806f827796f0a$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$e43806f827796f0a$export$4c16a0c02134a7dc] = style[$e43806f827796f0a$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$e43806f827796f0a$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($e43806f827796f0a$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($e43806f827796f0a$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$e43806f827796f0a$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $jbZrs.default)(cssinjsInstanceId);
}
var $e43806f827796f0a$var$StyleContext = /*#__PURE__*/ $jMaZ8.createContext({
    hashPriority: 'low',
    cache: $e43806f827796f0a$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $e43806f827796f0a$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $4b02Q.default)(props, $e43806f827796f0a$var$_excluded);
    var parentContext = $jMaZ8.useContext($e43806f827796f0a$var$StyleContext);
    var context = (0, $hBgfL.default)(function() {
        var mergedContext = (0, $8u3qN.default)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $e43806f827796f0a$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $9O5K3.default)(prev[0], next[0], true) || !(0, $9O5K3.default)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $jMaZ8.createElement($e43806f827796f0a$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $e43806f827796f0a$export$2e2bcd8739ae039 = $e43806f827796f0a$var$StyleContext;

});
parcelRegister("jbZrs", function(module, exports) {

$parcel$export(module.exports, "pathKey", () => $df8eb47349fa09c3$export$1d14e1d8187b9aad);
$parcel$export(module.exports, "default", () => $df8eb47349fa09c3$export$2e2bcd8739ae039);

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");
// [times, realValue]
var $df8eb47349fa09c3$var$SPLIT = '%';
function $df8eb47349fa09c3$export$1d14e1d8187b9aad(keys) {
    return keys.join($df8eb47349fa09c3$var$SPLIT);
}
var $df8eb47349fa09c3$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $klxbl.default)(this, Entity);
        (0, $eq8kl.default)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $eq8kl.default)(this, "cache", new Map());
        this.instanceId = instanceId;
    }
    (0, $9O7LJ.default)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.opGet($df8eb47349fa09c3$export$1d14e1d8187b9aad(keys));
            }
        },
        {
            key: "opGet",
            value: function opGet(keyPathStr) {
                return this.cache.get(keyPathStr) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                return this.opUpdate($df8eb47349fa09c3$export$1d14e1d8187b9aad(keys), valueFn);
            }
        },
        {
            key: "opUpdate",
            value: function opUpdate(keyPathStr, valueFn) {
                var prevValue = this.cache.get(keyPathStr);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache.delete(keyPathStr);
                else this.cache.set(keyPathStr, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $df8eb47349fa09c3$export$2e2bcd8739ae039 = $df8eb47349fa09c3$var$Entity;

});


parcelRegister("4g3I0", function(module, exports) {

$parcel$export(module.exports, "memoResult", () => $319b888986ee26f1$export$6aabcc1951563d93);
$parcel$export(module.exports, "flattenToken", () => $319b888986ee26f1$export$597374558a261efc);
$parcel$export(module.exports, "token2key", () => $319b888986ee26f1$export$6c82d0ebe8f2ea2c);
$parcel$export(module.exports, "supportWhere", () => $319b888986ee26f1$export$f51d3b8ac4ac9ed1);
$parcel$export(module.exports, "supportLogicProps", () => $319b888986ee26f1$export$64a912f57d5de48e);
$parcel$export(module.exports, "isClientSide", () => $319b888986ee26f1$export$9542afab8c2a5f48);
$parcel$export(module.exports, "unit", () => $319b888986ee26f1$export$523c0b569236b342);
$parcel$export(module.exports, "toStyleStr", () => $319b888986ee26f1$export$71c98ec84f0481d3);

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");

var $ismqa = parcelRequire("ismqa");

var $h9ujZ = parcelRequire("h9ujZ");

var $lfFyj = parcelRequire("lfFyj");

var $jANP6 = parcelRequire("jANP6");
parcelRequire("rxRcW");
var $jLVQy = parcelRequire("jLVQy");
// Create a cache for memo concat
var $319b888986ee26f1$var$resultCache = new WeakMap();
var $319b888986ee26f1$var$RESULT_VALUE = {};
function $319b888986ee26f1$export$6aabcc1951563d93(callback, deps) {
    var current = $319b888986ee26f1$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($319b888986ee26f1$var$RESULT_VALUE)) current.set($319b888986ee26f1$var$RESULT_VALUE, callback());
    return current.get($319b888986ee26f1$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $319b888986ee26f1$var$flattenTokenCache = new WeakMap();
function $319b888986ee26f1$export$597374558a261efc(token) {
    var str = $319b888986ee26f1$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $jLVQy.default)) str += value.id;
            else if (value && (0, $1Esi2.default)(value) === 'object') str += $319b888986ee26f1$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $ismqa.default)(str);
        // Put in cache
        $319b888986ee26f1$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $319b888986ee26f1$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $ismqa.default)("".concat(salt, "_").concat($319b888986ee26f1$export$597374558a261efc(token)));
}
var $319b888986ee26f1$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, '');
// Magic `content` for detect selector support
var $319b888986ee26f1$var$checkContent = '_bAmBoO_';
function $319b888986ee26f1$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $h9ujZ.default)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $lfFyj.updateCSS)(styleStr, $319b888986ee26f1$var$randomSelectorKey);
        var _ele = document.createElement('div');
        _ele.style.position = 'fixed';
        _ele.style.left = '0';
        _ele.style.top = '0';
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        _ele.innerHTML = 'Test';
        _ele.style.zIndex = '9999999';
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($319b888986ee26f1$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $lfFyj.removeCSS)($319b888986ee26f1$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $319b888986ee26f1$var$canLayer = undefined;
function $319b888986ee26f1$export$ac8d3fd9840e20dd() {
    if ($319b888986ee26f1$var$canLayer === undefined) $319b888986ee26f1$var$canLayer = $319b888986ee26f1$var$supportSelector("@layer ".concat($319b888986ee26f1$var$randomSelectorKey, " { .").concat($319b888986ee26f1$var$randomSelectorKey, " { content: \"").concat($319b888986ee26f1$var$checkContent, "\"!important; } }"), function(ele) {
        ele.className = $319b888986ee26f1$var$randomSelectorKey;
    });
    return $319b888986ee26f1$var$canLayer;
}
var $319b888986ee26f1$var$canWhere = undefined;
function $319b888986ee26f1$export$f51d3b8ac4ac9ed1() {
    if ($319b888986ee26f1$var$canWhere === undefined) $319b888986ee26f1$var$canWhere = $319b888986ee26f1$var$supportSelector(":where(.".concat($319b888986ee26f1$var$randomSelectorKey, ") { content: \"").concat($319b888986ee26f1$var$checkContent, "\"!important; }"), function(ele) {
        ele.className = $319b888986ee26f1$var$randomSelectorKey;
    });
    return $319b888986ee26f1$var$canWhere;
}
var $319b888986ee26f1$var$canLogic = undefined;
function $319b888986ee26f1$export$64a912f57d5de48e() {
    if ($319b888986ee26f1$var$canLogic === undefined) $319b888986ee26f1$var$canLogic = $319b888986ee26f1$var$supportSelector(".".concat($319b888986ee26f1$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $319b888986ee26f1$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === '93px';
    });
    return $319b888986ee26f1$var$canLogic;
}
var $319b888986ee26f1$export$9542afab8c2a5f48 = (0, $h9ujZ.default)();
function $319b888986ee26f1$export$523c0b569236b342(num) {
    if (typeof num === 'number') return "".concat(num, "px");
    return num;
}
function $319b888986ee26f1$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var _objectSpread2;
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $8u3qN.default)((0, $8u3qN.default)({}, customizeAttrs), {}, (_objectSpread2 = {}, (0, $eq8kl.default)(_objectSpread2, (0, $jANP6.ATTR_TOKEN), tokenKey), (0, $eq8kl.default)(_objectSpread2, (0, $jANP6.ATTR_MARK), styleId), _objectSpread2));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, "=\"").concat(val, "\"") : null;
    }).filter(function(v) {
        return v;
    }).join(' ');
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}

});
parcelRegister("rxRcW", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => (parcelRequire("9Bzxi")).default);
$parcel$export(module.exports, "Theme", () => (parcelRequire("jLVQy")).default);

var $3778c = parcelRequire("3778c");

var $9Bzxi = parcelRequire("9Bzxi");

var $jLVQy = parcelRequire("jLVQy");

var $dgqYD = parcelRequire("dgqYD");

});
parcelRegister("3778c", function(module, exports) {

var $ifnKu = parcelRequire("ifnKu");

var $3AM4d = parcelRequire("3AM4d");
var $24478ea85ff0e72a$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $ifnKu.default) : (0, $3AM4d.default);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $24478ea85ff0e72a$export$2e2bcd8739ae039 = $24478ea85ff0e72a$var$genCalc;

});
parcelRegister("ifnKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d48c0cbb8ad21205$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $dGS0J = parcelRequire("dGS0J");
var $d48c0cbb8ad21205$var$CALC_UNIT = 'CALC_UNIT';
var $d48c0cbb8ad21205$var$regexp = new RegExp($d48c0cbb8ad21205$var$CALC_UNIT, 'g');
function $d48c0cbb8ad21205$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($d48c0cbb8ad21205$var$CALC_UNIT);
    return value;
}
var $d48c0cbb8ad21205$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $7eK0y.default)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $fwNdX.default)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $klxbl.default)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "result", '');
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "unitlessCssVar", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "lowPriority", void 0);
        var numType = (0, $1Esi2.default)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $d48c0cbb8ad21205$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $9O7LJ.default)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($d48c0cbb8ad21205$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($d48c0cbb8ad21205$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($d48c0cbb8ad21205$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $dGS0J.default));

});
parcelRegister("dGS0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f791804324fce2e$export$2e2bcd8739ae039);

var $9O7LJ = parcelRequire("9O7LJ");

var $klxbl = parcelRequire("klxbl");
var $9f791804324fce2e$var$AbstractCalculator = /*#__PURE__*/ (0, $9O7LJ.default)(function AbstractCalculator() {
    (0, $klxbl.default)(this, AbstractCalculator);
});
var $9f791804324fce2e$export$2e2bcd8739ae039 = $9f791804324fce2e$var$AbstractCalculator;

});


parcelRegister("3AM4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $29da04fbc1e6b9f9$export$2e2bcd8739ae039);

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $dGS0J = parcelRequire("dGS0J");
var $29da04fbc1e6b9f9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $7eK0y.default)(NumCalculator, _AbstractCalculator);
    var _super = (0, $fwNdX.default)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $klxbl.default)(this, NumCalculator);
        _this = _super.call(this);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $9O7LJ.default)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $dGS0J.default));

});


parcelRegister("9Bzxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe3227dc4abcd87$export$2e2bcd8739ae039);

var $dgqYD = parcelRequire("dgqYD");

var $jLVQy = parcelRequire("jLVQy");
var $6fe3227dc4abcd87$var$cacheThemes = new (0, $dgqYD.default)();
function $6fe3227dc4abcd87$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$6fe3227dc4abcd87$var$cacheThemes.has(derivativeArr)) $6fe3227dc4abcd87$var$cacheThemes.set(derivativeArr, new (0, $jLVQy.default)(derivativeArr));
    // Get theme from cache and return
    return $6fe3227dc4abcd87$var$cacheThemes.get(derivativeArr);
}

});
parcelRegister("dgqYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a81b207e2c0d1f5$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");
function $9a81b207e2c0d1f5$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $9a81b207e2c0d1f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $klxbl.default)(this, ThemeCache);
        (0, $eq8kl.default)(this, "cache", void 0);
        (0, $eq8kl.default)(this, "keys", void 0);
        (0, $eq8kl.default)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $9O7LJ.default)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $3fkx6.default)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $3fkx6.default)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this.delete(targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache.delete(derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$9a81b207e2c0d1f5$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $eq8kl.default)($9a81b207e2c0d1f5$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $eq8kl.default)($9a81b207e2c0d1f5$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);

});

parcelRegister("jLVQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64f47440763625a$export$2e2bcd8739ae039);

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");

var $2bFmQ = parcelRequire("2bFmQ");
var $e64f47440763625a$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $e64f47440763625a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $klxbl.default)(this, Theme);
        (0, $eq8kl.default)(this, "derivatives", void 0);
        (0, $eq8kl.default)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $e64f47440763625a$var$uuid;
        if (derivatives.length === 0) (0, $2bFmQ.warning)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $e64f47440763625a$var$uuid += 1;
    }
    (0, $9O7LJ.default)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();

});




parcelRegister("f0tZ5", function(module, exports) {

$parcel$export(module.exports, "token2CSSVar", () => $aece1d55392381a7$export$309b3b095f0c7662);
$parcel$export(module.exports, "transformToken", () => $aece1d55392381a7$export$67858afe85bce49f);

var $3fkx6 = parcelRequire("3fkx6");
var $aece1d55392381a7$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "--".concat(prefix ? "".concat(prefix, "-") : '').concat(token).replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
var $aece1d55392381a7$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return '';
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : '', "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $3fkx6.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(''), "}");
};
var $aece1d55392381a7$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $3fkx6.default)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $aece1d55392381a7$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === 'number' && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $aece1d55392381a7$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};

});

parcelRegister("53ALy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae9c08673a311ae$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jbZrs = parcelRequire("jbZrs");

var $jANP6 = parcelRequire("jANP6");

var $yk5pC = parcelRequire("yk5pC");

var $gxMvC = parcelRequire("gxMvC");

var $3dJIT = parcelRequire("3dJIT");
function $3ae9c08673a311ae$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $jMaZ8.useContext((0, $jANP6.default)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $fvBso.default)(keyPath));
    var fullPathStr = (0, $jbZrs.pathKey)(fullPath);
    var register = (0, $gxMvC.default)([
        fullPathStr
    ]);
    var HMRUpdate = (0, $3dJIT.default)();
    var buildCache = function buildCache(updater) {
        globalCache.opUpdate(fullPathStr, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $3fkx6.default)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            if (cache && HMRUpdate) {
                onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(tmpCache, HMRUpdate);
                tmpCache = null;
            }
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $jMaZ8.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    var cacheEntity = globalCache.opGet(fullPathStr);
    // HMR clean the cache but not trigger `useMemo` again
    // Let's fallback of this
    // ref https://github.com/ant-design/cssinjs/issues/127
    if (!cacheEntity) {
        buildCache();
        cacheEntity = globalCache.opGet(fullPathStr);
    }
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $yk5pC.default)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $3fkx6.default)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.opUpdate(fullPathStr, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $3fkx6.default)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.opGet(fullPathStr)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}

});
parcelRegister("yk5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0672c1cf5cfd36f9$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $0672c1cf5cfd36f9$var$fullClone = (0, $8u3qN.default)({}, $jMaZ8);
var $0672c1cf5cfd36f9$var$useInsertionEffect = $0672c1cf5cfd36f9$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $0672c1cf5cfd36f9$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $jMaZ8.useMemo(renderEffect, deps);
    (0, $jLTp6.default)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $0672c1cf5cfd36f9$var$useCompatibleInsertionEffect = $0672c1cf5cfd36f9$var$useInsertionEffect ? function(renderEffect, effect, deps) {
    return $0672c1cf5cfd36f9$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $0672c1cf5cfd36f9$var$useInsertionEffectPolyfill;
var $0672c1cf5cfd36f9$export$2e2bcd8739ae039 = $0672c1cf5cfd36f9$var$useCompatibleInsertionEffect;

});

parcelRegister("gxMvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0b55b4a506d10ef$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");
var $c0b55b4a506d10ef$var$fullClone = (0, $8u3qN.default)({}, $jMaZ8);
var $c0b55b4a506d10ef$var$useInsertionEffect = $c0b55b4a506d10ef$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $c0b55b4a506d10ef$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) {
            (0, $2bFmQ.warning)(false, '[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.');
            return;
        }
        effectCleanups.push(fn);
    }
    $jMaZ8.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $c0b55b4a506d10ef$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $c0b55b4a506d10ef$var$useEffectCleanupRegister = typeof $c0b55b4a506d10ef$var$useInsertionEffect !== 'undefined' ? $c0b55b4a506d10ef$var$useCleanupRegister : $c0b55b4a506d10ef$var$useRun;
var $c0b55b4a506d10ef$export$2e2bcd8739ae039 = $c0b55b4a506d10ef$var$useEffectCleanupRegister;

});



parcelRegister("atLsZ", function(module, exports) {

$parcel$export(module.exports, "CSS_VAR_PREFIX", () => $7a116eb31abcc393$export$d96c342855c5e1fc);
$parcel$export(module.exports, "extract", () => $7a116eb31abcc393$export$f9380c9a627682d3);
$parcel$export(module.exports, "default", () => $7a116eb31abcc393$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $fvBso = parcelRequire("fvBso");

var $lfFyj = parcelRequire("lfFyj");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jANP6 = parcelRequire("jANP6");

var $4g3I0 = parcelRequire("4g3I0");

var $f0tZ5 = parcelRequire("f0tZ5");

var $53ALy = parcelRequire("53ALy");

var $gofJe = parcelRequire("gofJe");
var $7a116eb31abcc393$export$d96c342855c5e1fc = 'cssVar';
var $7a116eb31abcc393$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? '' : _config$scope;
    var _useContext = (0, $jMaZ8.useContext)((0, $jANP6.default)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $fvBso.default)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $53ALy.default)($7a116eb31abcc393$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $f0tZ5.transformToken)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $3fkx6.default)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $gofJe.uniqueHash)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $3fkx6.default)(_ref, 3), styleId = _ref2[2];
        if (0, $4g3I0.isClientSide) (0, $lfFyj.removeCSS)(styleId, {
            mark: (0, $jANP6.ATTR_MARK)
        });
    }, function(_ref3) {
        var _ref4 = (0, $3fkx6.default)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $lfFyj.updateCSS)(cssVarsStr, styleId, {
            mark: (0, $jANP6.ATTR_MARK),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $jANP6.CSS_IN_JS_INSTANCE] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $jANP6.ATTR_TOKEN), key);
    });
    return cache;
};
var $7a116eb31abcc393$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $3fkx6.default)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $4g3I0.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $7a116eb31abcc393$export$2e2bcd8739ae039 = $7a116eb31abcc393$var$useCSSVarRegister;

});
parcelRegister("gofJe", function(module, exports) {

$parcel$export(module.exports, "uniqueHash", () => $beeb169bb4e4e005$export$412618713057f6ca);
$parcel$export(module.exports, "STYLE_PREFIX", () => $beeb169bb4e4e005$export$1e6d9f0d06c7ec14);
$parcel$export(module.exports, "default", () => $beeb169bb4e4e005$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extract", () => $beeb169bb4e4e005$export$f9380c9a627682d3);

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $fvBso = parcelRequire("fvBso");

var $1Esi2 = parcelRequire("1Esi2");

var $ismqa = parcelRequire("ismqa");

var $lfFyj = parcelRequire("lfFyj");

var $jMaZ8 = parcelRequire("jMaZ8");

var $8y3rA = parcelRequire("8y3rA");

var $dS00V = parcelRequire("dS00V");
parcelRequire("eNDWU");
var $aTf2g = parcelRequire("aTf2g");
var $7Pezf = parcelRequire("7Pezf");

var $jANP6 = parcelRequire("jANP6");

var $4g3I0 = parcelRequire("4g3I0");

var $iwtUh = parcelRequire("iwtUh");

var $53ALy = parcelRequire("53ALy");
var $beeb169bb4e4e005$var$SKIP_CHECK = '_skip_check_';
var $beeb169bb4e4e005$var$MULTI_VALUE = '_multi_value_';
function $beeb169bb4e4e005$export$8756898546458274(styleStr) {
    var serialized = (0, $dS00V.serialize)((0, $dS00V.compile)(styleStr), (0, $dS00V.stringify));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $beeb169bb4e4e005$var$isCompoundCSSProperty(value) {
    return (0, $1Esi2.default)(value) === 'object' && value && ($beeb169bb4e4e005$var$SKIP_CHECK in value || $beeb169bb4e4e005$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $beeb169bb4e4e005$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === 'low' ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(',').map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || '';
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || '';
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $fvBso.default)(fullPath.slice(1))).join(' ');
    });
    return keys.join(',');
}
var $beeb169bb4e4e005$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = '';
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $3fkx6.default)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $1Esi2.default)(value) === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$beeb169bb4e4e005$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $beeb169bb4e4e005$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $beeb169bb4e4e005$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $fvBso.default)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $3fkx6.default)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $8u3qN.default)((0, $8u3qN.default)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var _value;
                    function appendStyle(cssKey, cssValue) {
                        if ((0, $1Esi2.default)(value) !== 'object' || !(value !== null && value !== void 0 && value[$beeb169bb4e4e005$var$SKIP_CHECK])) [
                            (0, $aTf2g.default),
                            (0, $7Pezf.default)
                        ].concat((0, $fvBso.default)(linters)).forEach(function(linter) {
                            return linter(cssKey, cssValue, {
                                path: path,
                                hashId: hashId,
                                parentSelectors: parentSelectors
                            });
                        });
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $8y3rA.default)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    }
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $1Esi2.default)(value) === 'object' && value !== null && value !== void 0 && value[$beeb169bb4e4e005$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
        if (layer.dependencies) effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
            return "@layer ".concat(deps, ", ").concat(layer.name, ";");
        }).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $beeb169bb4e4e005$export$412618713057f6ca(path, styleStr) {
    return (0, $ismqa.default)("".concat(path.join('%')).concat(styleStr));
}
function $beeb169bb4e4e005$var$Empty() {
    return null;
}
var $beeb169bb4e4e005$export$1e6d9f0d06c7ec14 = 'style';
function $beeb169bb4e4e005$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $jMaZ8.useContext((0, $jANP6.default)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache, enableLayer = _React$useContext.layer;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push.apply(fullPath, (0, $fvBso.default)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $4g3I0.isClientSide);
    if (mock !== undefined) isMergedClientSide = mock === 'client';
    var _useGlobalCache = (0, $53ALy.default)($beeb169bb4e4e005$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $iwtUh.existPath)(cachePath)) {
            var _getStyleAndHash = (0, $iwtUh.getStyleAndHash)(cachePath), _getStyleAndHash2 = (0, $3fkx6.default)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $beeb169bb4e4e005$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $3fkx6.default)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $beeb169bb4e4e005$export$8756898546458274(parsedStyle);
        var styleId = $beeb169bb4e4e005$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $3fkx6.default)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $4g3I0.isClientSide)) (0, $lfFyj.removeCSS)(styleId, {
            mark: (0, $jANP6.ATTR_MARK)
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $3fkx6.default)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $iwtUh.CSS_FILE_STYLE)) {
            var mergedCSSConfig = {
                mark: (0, $jANP6.ATTR_MARK),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            var effectLayerKeys = [];
            var effectRestKeys = [];
            Object.keys(effectStyle).forEach(function(key) {
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach(function(effectKey) {
                (0, $lfFyj.updateCSS)($beeb169bb4e4e005$export$8756898546458274(effectStyle[effectKey]), "_layer-".concat(effectKey), (0, $8u3qN.default)((0, $8u3qN.default)({}, mergedCSSConfig), {}, {
                    prepend: true
                }));
            });
            // ==================== Inject Style ====================
            // Inject style
            var style = (0, $lfFyj.updateCSS)(styleStr, styleId, mergedCSSConfig);
            style[0, $jANP6.CSS_IN_JS_INSTANCE] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $jANP6.ATTR_TOKEN), tokenKey);
            style.setAttribute((0, $jANP6.ATTR_CACHE_PATH), fullPath.join('|'));
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach(function(effectKey) {
                (0, $lfFyj.updateCSS)($beeb169bb4e4e005$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $3fkx6.default)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $jMaZ8.createElement($beeb169bb4e4e005$var$Empty, null);
        else {
            var _ref6;
            styleNode = /*#__PURE__*/ $jMaZ8.createElement("style", (0, $hH60s.default)({}, (_ref6 = {}, (0, $eq8kl.default)(_ref6, (0, $jANP6.ATTR_TOKEN), cachedTokenKey), (0, $eq8kl.default)(_ref6, (0, $jANP6.ATTR_MARK), cachedStyleId), _ref6), {
                dangerouslySetInnerHTML: {
                    __html: cachedStyleStr
                }
            }));
        }
        return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, styleNode, node);
    };
}
var $beeb169bb4e4e005$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $3fkx6.default)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    // ====================== Style ======================
    keyStyleText = (0, $4g3I0.toStyleStr)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $beeb169bb4e4e005$export$8756898546458274(effectStyle[effectKey]);
            var effectStyleHTML = (0, $4g3I0.toStyleStr)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};

});
parcelRegister("8y3rA", function(module, exports) {

$parcel$export(module.exports, "default", () => $63942b9cb0f913c5$export$2e2bcd8739ae039);
var $63942b9cb0f913c5$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $63942b9cb0f913c5$export$2e2bcd8739ae039 = $63942b9cb0f913c5$var$unitlessKeys;

});

parcelRegister("dS00V", function(module, exports) {

$parcel$export(module.exports, "compile", () => $458cecba9b94c540$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $458cecba9b94c540$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $458cecba9b94c540$export$fac44ee5b035f737);
var $458cecba9b94c540$export$71ad59f2e432cfe8 = "-ms-";
var $458cecba9b94c540$export$2c0f367103c8d01c = "-moz-";
var $458cecba9b94c540$export$39dfd62a25e0fe93 = "-webkit-";
var $458cecba9b94c540$export$a29989082612d0d9 = "comm";
var $458cecba9b94c540$export$aa3a2e812ca8570d = "rule";
var $458cecba9b94c540$export$527d108ccf083c2b = "decl";
var $458cecba9b94c540$export$d3d35020fa5b54f0 = "@page";
var $458cecba9b94c540$export$500415a86c544f73 = "@media";
var $458cecba9b94c540$export$a763edbf796b780a = "@import";
var $458cecba9b94c540$export$2790aeb8b4e5c826 = "@charset";
var $458cecba9b94c540$export$1cc683e23b84b133 = "@viewport";
var $458cecba9b94c540$export$9447a5efea57e862 = "@supports";
var $458cecba9b94c540$export$ef011b4e114b1fba = "@document";
var $458cecba9b94c540$export$6aad947bda0f3f46 = "@namespace";
var $458cecba9b94c540$export$b44a8529a35fcb60 = "@keyframes";
var $458cecba9b94c540$export$2c16de31893252e6 = "@font-face";
var $458cecba9b94c540$export$3d846dd52e150c6f = "@counter-style";
var $458cecba9b94c540$export$22314bfbb57653fe = "@font-feature-values";
var $458cecba9b94c540$export$d773506282b3cfe6 = "@layer";
var $458cecba9b94c540$export$1c5a554c78c0cd12 = "@scope";
var $458cecba9b94c540$export$2335f513bbd82c6d = Math.abs;
var $458cecba9b94c540$export$6788812c4e6611e6 = String.fromCharCode;
var $458cecba9b94c540$export$e6e34fd1f2686227 = Object.assign;
function $458cecba9b94c540$export$d6af199866bfb566(e, r) {
    return $458cecba9b94c540$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $458cecba9b94c540$export$a9db5e087081082d(e, 0)) << 2 ^ $458cecba9b94c540$export$a9db5e087081082d(e, 1)) << 2 ^ $458cecba9b94c540$export$a9db5e087081082d(e, 2)) << 2 ^ $458cecba9b94c540$export$a9db5e087081082d(e, 3) : 0;
}
function $458cecba9b94c540$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $458cecba9b94c540$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $458cecba9b94c540$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $458cecba9b94c540$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $458cecba9b94c540$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $458cecba9b94c540$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $458cecba9b94c540$export$36776f635604f274(e) {
    return e.length;
}
function $458cecba9b94c540$export$f9084667e487ed46(e) {
    return e.length;
}
function $458cecba9b94c540$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $458cecba9b94c540$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $458cecba9b94c540$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$458cecba9b94c540$export$4659b591c19bdf3d(e, r);
    });
}
var $458cecba9b94c540$export$53f1d5ea8de3d7c = 1;
var $458cecba9b94c540$export$4e0c71f277ca26b3 = 1;
var $458cecba9b94c540$export$f24224f1c91d8156 = 0;
var $458cecba9b94c540$export$5880b8b5730aff45 = 0;
var $458cecba9b94c540$export$c0306caf338ac095 = 0;
var $458cecba9b94c540$export$30a86d91af8ff6e6 = "";
function $458cecba9b94c540$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $458cecba9b94c540$export$53f1d5ea8de3d7c,
        column: $458cecba9b94c540$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $458cecba9b94c540$export$784d13d8ee351f07(e, r) {
    return $458cecba9b94c540$export$e6e34fd1f2686227($458cecba9b94c540$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $458cecba9b94c540$export$590e8b2c435046d9(e) {
    while(e.root)e = $458cecba9b94c540$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $458cecba9b94c540$export$10d8903dec122b9d(e, e.siblings);
}
function $458cecba9b94c540$export$eba6f6f03b0a92e7() {
    return $458cecba9b94c540$export$c0306caf338ac095;
}
function $458cecba9b94c540$export$232faf9add678146() {
    $458cecba9b94c540$export$c0306caf338ac095 = $458cecba9b94c540$export$5880b8b5730aff45 > 0 ? $458cecba9b94c540$export$a9db5e087081082d($458cecba9b94c540$export$30a86d91af8ff6e6, --$458cecba9b94c540$export$5880b8b5730aff45) : 0;
    if ($458cecba9b94c540$export$4e0c71f277ca26b3--, $458cecba9b94c540$export$c0306caf338ac095 === 10) $458cecba9b94c540$export$4e0c71f277ca26b3 = 1, $458cecba9b94c540$export$53f1d5ea8de3d7c--;
    return $458cecba9b94c540$export$c0306caf338ac095;
}
function $458cecba9b94c540$export$48cfd1e771a65c4f() {
    $458cecba9b94c540$export$c0306caf338ac095 = $458cecba9b94c540$export$5880b8b5730aff45 < $458cecba9b94c540$export$f24224f1c91d8156 ? $458cecba9b94c540$export$a9db5e087081082d($458cecba9b94c540$export$30a86d91af8ff6e6, $458cecba9b94c540$export$5880b8b5730aff45++) : 0;
    if ($458cecba9b94c540$export$4e0c71f277ca26b3++, $458cecba9b94c540$export$c0306caf338ac095 === 10) $458cecba9b94c540$export$4e0c71f277ca26b3 = 1, $458cecba9b94c540$export$53f1d5ea8de3d7c++;
    return $458cecba9b94c540$export$c0306caf338ac095;
}
function $458cecba9b94c540$export$4d3fb11e950abb9e() {
    return $458cecba9b94c540$export$a9db5e087081082d($458cecba9b94c540$export$30a86d91af8ff6e6, $458cecba9b94c540$export$5880b8b5730aff45);
}
function $458cecba9b94c540$export$e88cb2efb12ae807() {
    return $458cecba9b94c540$export$5880b8b5730aff45;
}
function $458cecba9b94c540$export$58adb3bec8346d0f(e, r) {
    return $458cecba9b94c540$export$2f35ab04d2335697($458cecba9b94c540$export$30a86d91af8ff6e6, e, r);
}
function $458cecba9b94c540$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $458cecba9b94c540$export$2de70f21292aac9e(e) {
    return $458cecba9b94c540$export$53f1d5ea8de3d7c = $458cecba9b94c540$export$4e0c71f277ca26b3 = 1, $458cecba9b94c540$export$f24224f1c91d8156 = $458cecba9b94c540$export$36776f635604f274($458cecba9b94c540$export$30a86d91af8ff6e6 = e), $458cecba9b94c540$export$5880b8b5730aff45 = 0, [];
}
function $458cecba9b94c540$export$45918ac1574455b1(e) {
    return $458cecba9b94c540$export$30a86d91af8ff6e6 = "", e;
}
function $458cecba9b94c540$export$410ac95b9ec204b8(e) {
    return $458cecba9b94c540$export$87c2784dc9fc4ab($458cecba9b94c540$export$58adb3bec8346d0f($458cecba9b94c540$export$5880b8b5730aff45 - 1, $458cecba9b94c540$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $458cecba9b94c540$export$660b2ee2d4fb4eff(e) {
    return $458cecba9b94c540$export$45918ac1574455b1($458cecba9b94c540$export$5f8c09e3ae6f64e1($458cecba9b94c540$export$2de70f21292aac9e(e)));
}
function $458cecba9b94c540$export$7af1228ff777d175(e) {
    while($458cecba9b94c540$export$c0306caf338ac095 = $458cecba9b94c540$export$4d3fb11e950abb9e())if ($458cecba9b94c540$export$c0306caf338ac095 < 33) $458cecba9b94c540$export$48cfd1e771a65c4f();
    else break;
    return $458cecba9b94c540$export$9e1725a4cfeada27(e) > 2 || $458cecba9b94c540$export$9e1725a4cfeada27($458cecba9b94c540$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $458cecba9b94c540$export$5f8c09e3ae6f64e1(e) {
    while($458cecba9b94c540$export$48cfd1e771a65c4f())switch($458cecba9b94c540$export$9e1725a4cfeada27($458cecba9b94c540$export$c0306caf338ac095)){
        case 0:
            $458cecba9b94c540$export$10d8903dec122b9d($458cecba9b94c540$export$c2ab62c7bf24634($458cecba9b94c540$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $458cecba9b94c540$export$10d8903dec122b9d($458cecba9b94c540$export$410ac95b9ec204b8($458cecba9b94c540$export$c0306caf338ac095), e);
            break;
        default:
            $458cecba9b94c540$export$10d8903dec122b9d($458cecba9b94c540$export$6788812c4e6611e6($458cecba9b94c540$export$c0306caf338ac095), e);
    }
    return e;
}
function $458cecba9b94c540$export$955ba06d119e085e(e, r) {
    while(--r && $458cecba9b94c540$export$48cfd1e771a65c4f())if ($458cecba9b94c540$export$c0306caf338ac095 < 48 || $458cecba9b94c540$export$c0306caf338ac095 > 102 || $458cecba9b94c540$export$c0306caf338ac095 > 57 && $458cecba9b94c540$export$c0306caf338ac095 < 65 || $458cecba9b94c540$export$c0306caf338ac095 > 70 && $458cecba9b94c540$export$c0306caf338ac095 < 97) break;
    return $458cecba9b94c540$export$58adb3bec8346d0f(e, $458cecba9b94c540$export$e88cb2efb12ae807() + (r < 6 && $458cecba9b94c540$export$4d3fb11e950abb9e() == 32 && $458cecba9b94c540$export$48cfd1e771a65c4f() == 32));
}
function $458cecba9b94c540$export$c889f2fcc19dbf12(e) {
    while($458cecba9b94c540$export$48cfd1e771a65c4f())switch($458cecba9b94c540$export$c0306caf338ac095){
        case e:
            return $458cecba9b94c540$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $458cecba9b94c540$export$c889f2fcc19dbf12($458cecba9b94c540$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $458cecba9b94c540$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $458cecba9b94c540$export$48cfd1e771a65c4f();
            break;
    }
    return $458cecba9b94c540$export$5880b8b5730aff45;
}
function $458cecba9b94c540$export$4254d4e2b3745c4c(e, r) {
    while($458cecba9b94c540$export$48cfd1e771a65c4f())if (e + $458cecba9b94c540$export$c0306caf338ac095 === 57) break;
    else if (e + $458cecba9b94c540$export$c0306caf338ac095 === 84 && $458cecba9b94c540$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $458cecba9b94c540$export$58adb3bec8346d0f(r, $458cecba9b94c540$export$5880b8b5730aff45 - 1) + "*" + $458cecba9b94c540$export$6788812c4e6611e6(e === 47 ? e : $458cecba9b94c540$export$48cfd1e771a65c4f());
}
function $458cecba9b94c540$export$c2ab62c7bf24634(e) {
    while(!$458cecba9b94c540$export$9e1725a4cfeada27($458cecba9b94c540$export$4d3fb11e950abb9e()))$458cecba9b94c540$export$48cfd1e771a65c4f();
    return $458cecba9b94c540$export$58adb3bec8346d0f(e, $458cecba9b94c540$export$5880b8b5730aff45);
}
function $458cecba9b94c540$export$ef7acd7185315e22(e) {
    return $458cecba9b94c540$export$45918ac1574455b1($458cecba9b94c540$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $458cecba9b94c540$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $458cecba9b94c540$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $458cecba9b94c540$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $458cecba9b94c540$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($458cecba9b94c540$export$f8e21b1e77979a08(z += $458cecba9b94c540$export$77ad94ebf1c2b9ed($458cecba9b94c540$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $458cecba9b94c540$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $458cecba9b94c540$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $458cecba9b94c540$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $458cecba9b94c540$export$955ba06d119e085e($458cecba9b94c540$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($458cecba9b94c540$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $458cecba9b94c540$export$10d8903dec122b9d($458cecba9b94c540$export$4a34f930e789283c($458cecba9b94c540$export$4254d4e2b3745c4c($458cecba9b94c540$export$48cfd1e771a65c4f(), $458cecba9b94c540$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($458cecba9b94c540$export$9e1725a4cfeada27(b || 1) == 5 || $458cecba9b94c540$export$9e1725a4cfeada27($458cecba9b94c540$export$4d3fb11e950abb9e() || 1) == 5) && $458cecba9b94c540$export$36776f635604f274(z) && $458cecba9b94c540$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $458cecba9b94c540$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $458cecba9b94c540$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($458cecba9b94c540$export$36776f635604f274(z) - l || h === 0 && b === 47)) $458cecba9b94c540$export$10d8903dec122b9d(v > 32 ? $458cecba9b94c540$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $458cecba9b94c540$export$f8483753829ec8f3($458cecba9b94c540$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $458cecba9b94c540$export$10d8903dec122b9d(j = $458cecba9b94c540$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $458cecba9b94c540$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($458cecba9b94c540$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($458cecba9b94c540$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $458cecba9b94c540$export$98e6a39c04603d36(e, j, j, c && $458cecba9b94c540$export$10d8903dec122b9d($458cecba9b94c540$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $458cecba9b94c540$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $458cecba9b94c540$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $458cecba9b94c540$export$232faf9add678146() == 125) continue;
            }
            switch(z += $458cecba9b94c540$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($458cecba9b94c540$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($458cecba9b94c540$export$4d3fb11e950abb9e() === 45) z += $458cecba9b94c540$export$410ac95b9ec204b8($458cecba9b94c540$export$48cfd1e771a65c4f());
                    p = $458cecba9b94c540$export$4d3fb11e950abb9e(), o = l = $458cecba9b94c540$export$36776f635604f274(k = z += $458cecba9b94c540$export$c2ab62c7bf24634($458cecba9b94c540$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $458cecba9b94c540$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $458cecba9b94c540$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $458cecba9b94c540$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $458cecba9b94c540$export$2f35ab04d2335697(e, v + 1, v = $458cecba9b94c540$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $458cecba9b94c540$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $458cecba9b94c540$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $458cecba9b94c540$export$35059013cd4a06db(e, r, a, s === 0 ? $458cecba9b94c540$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $458cecba9b94c540$export$4a34f930e789283c(e, r, a, n) {
    return $458cecba9b94c540$export$35059013cd4a06db(e, r, a, $458cecba9b94c540$export$a29989082612d0d9, $458cecba9b94c540$export$6788812c4e6611e6($458cecba9b94c540$export$eba6f6f03b0a92e7()), $458cecba9b94c540$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $458cecba9b94c540$export$f8483753829ec8f3(e, r, a, c, n) {
    return $458cecba9b94c540$export$35059013cd4a06db(e, r, a, $458cecba9b94c540$export$527d108ccf083c2b, $458cecba9b94c540$export$2f35ab04d2335697(e, 0, c), $458cecba9b94c540$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $458cecba9b94c540$export$82e9f45cca5ba907(c, n, s) {
    switch($458cecba9b94c540$export$d6af199866bfb566(c, n)){
        case 5103:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $458cecba9b94c540$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$2c0f367103c8d01c + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($458cecba9b94c540$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $458cecba9b94c540$export$39dfd62a25e0fe93 + "box-$1$2" + $458cecba9b94c540$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + "flex-item-" + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$458cecba9b94c540$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $458cecba9b94c540$export$71ad59f2e432cfe8 + "grid-row-" + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + "flex-line-pack" + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + "box-" + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "-grow", "") + $458cecba9b94c540$export$39dfd62a25e0fe93 + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $458cecba9b94c540$export$39dfd62a25e0fe93 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $458cecba9b94c540$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $458cecba9b94c540$export$77ad94ebf1c2b9ed($458cecba9b94c540$export$77ad94ebf1c2b9ed($458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $458cecba9b94c540$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $458cecba9b94c540$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $458cecba9b94c540$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $458cecba9b94c540$export$77ad94ebf1c2b9ed($458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $458cecba9b94c540$export$39dfd62a25e0fe93 + "box-pack:$3" + $458cecba9b94c540$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $458cecba9b94c540$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$458cecba9b94c540$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $458cecba9b94c540$export$71ad59f2e432cfe8 + "grid-column-align" + $458cecba9b94c540$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $458cecba9b94c540$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$458cecba9b94c540$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $458cecba9b94c540$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$458cecba9b94c540$export$f8e21b1e77979a08(s, "span", 0) ? $458cecba9b94c540$export$4659b591c19bdf3d(s, /\d+/) : +$458cecba9b94c540$export$4659b591c19bdf3d(s, /\d+/) - +$458cecba9b94c540$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $458cecba9b94c540$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $458cecba9b94c540$export$71ad59f2e432cfe8 + $458cecba9b94c540$export$77ad94ebf1c2b9ed($458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $458cecba9b94c540$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($458cecba9b94c540$export$36776f635604f274(c) - 1 - n > 6) switch($458cecba9b94c540$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($458cecba9b94c540$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $458cecba9b94c540$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $458cecba9b94c540$export$2c0f367103c8d01c + ($458cecba9b94c540$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$458cecba9b94c540$export$f8e21b1e77979a08(c, "stretch", 0) ? $458cecba9b94c540$export$82e9f45cca5ba907($458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $458cecba9b94c540$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $458cecba9b94c540$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($458cecba9b94c540$export$a9db5e087081082d(c, n + 6) === 121) return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, ":", ":" + $458cecba9b94c540$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($458cecba9b94c540$export$a9db5e087081082d(c, $458cecba9b94c540$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $458cecba9b94c540$export$39dfd62a25e0fe93 + ($458cecba9b94c540$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $458cecba9b94c540$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $458cecba9b94c540$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, ":", ":" + $458cecba9b94c540$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $458cecba9b94c540$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $458cecba9b94c540$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $458cecba9b94c540$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $458cecba9b94c540$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $458cecba9b94c540$export$a763edbf796b780a:
        case $458cecba9b94c540$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $458cecba9b94c540$export$a29989082612d0d9:
            return "";
        case $458cecba9b94c540$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $458cecba9b94c540$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $458cecba9b94c540$export$aa3a2e812ca8570d:
            if (!$458cecba9b94c540$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $458cecba9b94c540$export$36776f635604f274(a = $458cecba9b94c540$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $458cecba9b94c540$export$5a7767152ae0305f(e) {
    var r = $458cecba9b94c540$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $458cecba9b94c540$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $458cecba9b94c540$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $458cecba9b94c540$export$527d108ccf083c2b:
                c.return = $458cecba9b94c540$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $458cecba9b94c540$export$b44a8529a35fcb60:
                return $458cecba9b94c540$export$dfdc1655ccc5b9cb([
                    $458cecba9b94c540$export$784d13d8ee351f07(c, {
                        value: $458cecba9b94c540$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $458cecba9b94c540$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $458cecba9b94c540$export$aa3a2e812ca8570d:
                if (c.length) return $458cecba9b94c540$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($458cecba9b94c540$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $458cecba9b94c540$export$590e8b2c435046d9($458cecba9b94c540$export$784d13d8ee351f07(c, {
                                props: [
                                    $458cecba9b94c540$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $458cecba9b94c540$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $458cecba9b94c540$export$590e8b2c435046d9($458cecba9b94c540$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $458cecba9b94c540$export$e6e34fd1f2686227(c, {
                                props: $458cecba9b94c540$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $458cecba9b94c540$export$590e8b2c435046d9($458cecba9b94c540$export$784d13d8ee351f07(c, {
                                props: [
                                    $458cecba9b94c540$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $458cecba9b94c540$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $458cecba9b94c540$export$590e8b2c435046d9($458cecba9b94c540$export$784d13d8ee351f07(c, {
                                props: [
                                    $458cecba9b94c540$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $458cecba9b94c540$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $458cecba9b94c540$export$590e8b2c435046d9($458cecba9b94c540$export$784d13d8ee351f07(c, {
                                props: [
                                    $458cecba9b94c540$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $458cecba9b94c540$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $458cecba9b94c540$export$590e8b2c435046d9($458cecba9b94c540$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $458cecba9b94c540$export$e6e34fd1f2686227(c, {
                                props: $458cecba9b94c540$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $458cecba9b94c540$export$76a88f7de6507443(e) {
    switch(e.type){
        case $458cecba9b94c540$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $458cecba9b94c540$export$1be1fc439b849fdf($458cecba9b94c540$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($458cecba9b94c540$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $458cecba9b94c540$export$2f35ab04d2335697(r, 1, $458cecba9b94c540$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $458cecba9b94c540$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $458cecba9b94c540$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $458cecba9b94c540$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("eNDWU", function(module, exports) {

$parcel$export(module.exports, "contentQuotesLinter", () => (parcelRequire("aTf2g")).default);
$parcel$export(module.exports, "hashedAnimationLinter", () => (parcelRequire("7Pezf")).default);

var $aTf2g = parcelRequire("aTf2g");

var $7Pezf = parcelRequire("7Pezf");

var $kaDqo = parcelRequire("kaDqo");

var $ajcak = parcelRequire("ajcak");

var $iUl6X = parcelRequire("iUl6X");

var $2UJnn = parcelRequire("2UJnn");

});
parcelRegister("aTf2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $7edab42f9973c42d$export$2e2bcd8739ae039);

var $6lfha = parcelRequire("6lfha");
var $7edab42f9973c42d$var$linter = function linter(key, value, info) {
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $6lfha.lintWarning)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $7edab42f9973c42d$export$2e2bcd8739ae039 = $7edab42f9973c42d$var$linter;

});
parcelRegister("6lfha", function(module, exports) {

$parcel$export(module.exports, "lintWarning", () => $49e08db66d38fecc$export$e7b7955c4f1f8c03);

var $2bFmQ = parcelRequire("2bFmQ");
function $49e08db66d38fecc$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $2bFmQ.default)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : '').concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(' | ')) : ''));
}

});


parcelRegister("7Pezf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b28989c705ed2ca$export$2e2bcd8739ae039);

var $6lfha = parcelRequire("6lfha");
var $5b28989c705ed2ca$var$linter = function linter(key, value, info) {
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $6lfha.lintWarning)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $5b28989c705ed2ca$export$2e2bcd8739ae039 = $5b28989c705ed2ca$var$linter;

});

parcelRegister("kaDqo", function(module, exports) {

var $6lfha = parcelRequire("6lfha");
function $eaf352bba1116eca$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $eaf352bba1116eca$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, '');
}
var $eaf352bba1116eca$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $eaf352bba1116eca$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($eaf352bba1116eca$var$isConcatSelector)) (0, $6lfha.lintWarning)("Concat ':not' selector not support in legacy browsers.", info);
};
var $eaf352bba1116eca$export$2e2bcd8739ae039 = $eaf352bba1116eca$var$linter;

});

parcelRegister("ajcak", function(module, exports) {

var $6lfha = parcelRequire("6lfha");
var $78151d8f1bd4ccd2$var$linter = function linter(key, value, info) {
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $6lfha.lintWarning)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                var valueArr = value.split(' ').map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $6lfha.lintWarning)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $6lfha.lintWarning)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                var radiusGroups = value.split('/').map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(' ').map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $6lfha.lintWarning)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $78151d8f1bd4ccd2$export$2e2bcd8739ae039 = $78151d8f1bd4ccd2$var$linter;

});

parcelRegister("iUl6X", function(module, exports) {

var $6lfha = parcelRequire("6lfha");
var $dc3dd53604db4e18$var$linter = function linter(key, value, info) {
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $6lfha.lintWarning)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $dc3dd53604db4e18$export$2e2bcd8739ae039 = $dc3dd53604db4e18$var$linter;

});

parcelRegister("2UJnn", function(module, exports) {

var $6lfha = parcelRequire("6lfha");
var $21f40272b2c038e2$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(',');
        return selectors.some(function(item) {
            return item.split('&').length > 2;
        });
    })) (0, $6lfha.lintWarning)('Should not use more than one `&` in a selector.', info);
};
var $21f40272b2c038e2$export$2e2bcd8739ae039 = $21f40272b2c038e2$var$linter;

});


parcelRegister("iwtUh", function(module, exports) {

$parcel$export(module.exports, "ATTR_CACHE_MAP", () => $d7c269ffba07735c$export$1c054aa01963e47e);
$parcel$export(module.exports, "CSS_FILE_STYLE", () => $d7c269ffba07735c$export$e0a2f8ff7fc63361);
$parcel$export(module.exports, "serialize", () => $d7c269ffba07735c$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "existPath", () => $d7c269ffba07735c$export$5aa0d776d676ab98);
$parcel$export(module.exports, "getStyleAndHash", () => $d7c269ffba07735c$export$d3851dfd3659b2ce);

var $3fkx6 = parcelRequire("3fkx6");

var $h9ujZ = parcelRequire("h9ujZ");

var $jANP6 = parcelRequire("jANP6");
var $d7c269ffba07735c$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
var $d7c269ffba07735c$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $d7c269ffba07735c$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(';');
}
var $d7c269ffba07735c$var$cachePathMap;
var $d7c269ffba07735c$var$fromCSSFile = true;
function $d7c269ffba07735c$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $d7c269ffba07735c$var$cachePathMap = mockCache;
    $d7c269ffba07735c$var$fromCSSFile = fromFile;
}
function $d7c269ffba07735c$export$18298bb220d85216() {
    if (!$d7c269ffba07735c$var$cachePathMap) {
        $d7c269ffba07735c$var$cachePathMap = {};
        if ((0, $h9ujZ.default)()) {
            var div = document.createElement('div');
            div.className = $d7c269ffba07735c$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach(function(item) {
                var _item$split = item.split(':'), _item$split2 = (0, $3fkx6.default)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $d7c269ffba07735c$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($d7c269ffba07735c$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $d7c269ffba07735c$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $d7c269ffba07735c$export$5aa0d776d676ab98(path) {
    $d7c269ffba07735c$export$18298bb220d85216();
    return !!$d7c269ffba07735c$var$cachePathMap[path];
}
function $d7c269ffba07735c$export$d3851dfd3659b2ce(path) {
    var hash = $d7c269ffba07735c$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $h9ujZ.default)()) {
        if ($d7c269ffba07735c$var$fromCSSFile) styleStr = $d7c269ffba07735c$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $jANP6.ATTR_MARK), "=\"").concat($d7c269ffba07735c$var$cachePathMap[path], "\"]"));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $d7c269ffba07735c$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}

});




parcelRegister("kB90R", function(module, exports) {

$parcel$export(module.exports, "default", () => $efee411c3db34716$export$2e2bcd8739ae039);

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");
var $efee411c3db34716$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $klxbl.default)(this, Keyframe);
        (0, $eq8kl.default)(this, "name", void 0);
        (0, $eq8kl.default)(this, "style", void 0);
        (0, $eq8kl.default)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $9O7LJ.default)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $efee411c3db34716$export$2e2bcd8739ae039 = $efee411c3db34716$var$Keyframe;

});

parcelRegister("8LBQX", function(module, exports) {

var $3fkx6 = parcelRequire("3fkx6");
function $662013606a068ea4$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = [];
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes('(') || item.includes(')')) {
                var left = item.split('(').length - 1;
                var right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $662013606a068ea4$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $662013606a068ea4$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $662013606a068ea4$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $662013606a068ea4$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $662013606a068ea4$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $662013606a068ea4$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $662013606a068ea4$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $662013606a068ea4$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $662013606a068ea4$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $662013606a068ea4$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $662013606a068ea4$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                var _splitValues = $662013606a068ea4$var$splitValues(value), _splitValues2 = (0, $3fkx6.default)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $662013606a068ea4$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $662013606a068ea4$var$wrapImportantAndSkipCheck(_values[0], _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $662013606a068ea4$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $662013606a068ea4$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $662013606a068ea4$export$2e2bcd8739ae039 = $662013606a068ea4$var$transform;

});

parcelRegister("jzC0v", function(module, exports) {

var $3fkx6 = parcelRequire("3fkx6");

var $8u3qN = parcelRequire("8u3qN");

var $8y3rA = parcelRequire("8y3rA");
var $e3fec4a54f0fa2fb$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $e3fec4a54f0fa2fb$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $e3fec4a54f0fa2fb$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $e3fec4a54f0fa2fb$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $8u3qN.default)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $3fkx6.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === 'string' && value.includes('px')) {
                var newValue = value.replace($e3fec4a54f0fa2fb$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $8y3rA.default)[key] && typeof value === 'number' && value !== 0) clone[key] = "".concat(value, "px").replace($e3fec4a54f0fa2fb$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                var newKey = key.replace($e3fec4a54f0fa2fb$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $e3fec4a54f0fa2fb$export$2e2bcd8739ae039 = $e3fec4a54f0fa2fb$var$transform;

});


parcelRegister("1Ly4M", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $14949d0eb5bd48de$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $14949d0eb5bd48de$var$derivative;
parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");
var $lvl2c = parcelRequire("lvl2c");

var $lCXqA = parcelRequire("lCXqA");

var $14949d0eb5bd48de$var$_genColorMapToken = $14949d0eb5bd48de$require$_interopRequireDefault((parcelRequire("96Xlm")));

var $14949d0eb5bd48de$var$_genCommonMapToken = $14949d0eb5bd48de$require$_interopRequireDefault((parcelRequire("d9auM")));

var $14949d0eb5bd48de$var$_genControlHeight = $14949d0eb5bd48de$require$_interopRequireDefault((parcelRequire("fxvxf")));

var $14949d0eb5bd48de$var$_genFontMapToken = $14949d0eb5bd48de$require$_interopRequireDefault((parcelRequire("6Zqq2")));

var $14949d0eb5bd48de$var$_genSizeMapToken = $14949d0eb5bd48de$require$_interopRequireDefault((parcelRequire("4yckB")));

var $1QVjC = parcelRequire("1QVjC");
function $14949d0eb5bd48de$var$derivative(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    $lvl2c.presetPrimaryColors.pink = $lvl2c.presetPrimaryColors.magenta;
    $lvl2c.presetPalettes.pink = $lvl2c.presetPalettes.magenta;
    const colorPalettes = Object.keys($lCXqA.defaultPresetColors).map((colorKey)=>{
        const colors = token[colorKey] === $lvl2c.presetPrimaryColors[colorKey] ? $lvl2c.presetPalettes[colorKey] : (0, $9Mx90.default)(token[colorKey]);
        return new Array(10).fill(1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        // biome-ignore lint/style/noParameterAssign: it is a reduce
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $14949d0eb5bd48de$var$_genColorMapToken.default)(token, {
        generateColorPalettes: $1QVjC.generateColorPalettes,
        generateNeutralColorPalettes: $1QVjC.generateNeutralColorPalettes
    })), (0, $14949d0eb5bd48de$var$_genFontMapToken.default)(token.fontSize)), (0, $14949d0eb5bd48de$var$_genSizeMapToken.default)(token)), (0, $14949d0eb5bd48de$var$_genControlHeight.default)(token)), (0, $14949d0eb5bd48de$var$_genCommonMapToken.default)(token));
}

});
parcelRegister("1T8KD", function(module, exports) {
$parcel$export(module.exports, "blue", () => (parcelRequire("lvl2c")).blue);
$parcel$export(module.exports, "gold", () => (parcelRequire("lvl2c")).gold);
$parcel$export(module.exports, "presetPalettes", () => (parcelRequire("lvl2c")).presetPalettes);
$parcel$export(module.exports, "presetPrimaryColors", () => (parcelRequire("lvl2c")).presetPrimaryColors);

$parcel$export(module.exports, "generate", () => (parcelRequire("9Mx90")).default);

var $9Mx90 = parcelRequire("9Mx90");
parcelRequire("lvl2c");
parcelRequire("6NEc9");

});
parcelRegister("9Mx90", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f24e858a0b1214$export$2e2bcd8739ae039);
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
var $71f24e858a0b1214$var$hueStep = 2; // 色相阶梯
var $71f24e858a0b1214$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $71f24e858a0b1214$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $71f24e858a0b1214$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $71f24e858a0b1214$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $71f24e858a0b1214$var$lightColorCount = 5; // 浅色数量，主色上
var $71f24e858a0b1214$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $71f24e858a0b1214$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $71f24e858a0b1214$var$getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $71f24e858a0b1214$var$hueStep * i : Math.round(hsv.h) + $71f24e858a0b1214$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $71f24e858a0b1214$var$hueStep * i : Math.round(hsv.h) - $71f24e858a0b1214$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $71f24e858a0b1214$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $71f24e858a0b1214$var$saturationStep * i;
    else if (i === $71f24e858a0b1214$var$darkColorCount) saturation = hsv.s + $71f24e858a0b1214$var$saturationStep;
    else saturation = hsv.s + $71f24e858a0b1214$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $71f24e858a0b1214$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $71f24e858a0b1214$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $71f24e858a0b1214$var$brightnessStep1 * i;
    else value = hsv.v - $71f24e858a0b1214$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $71f24e858a0b1214$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = new (0, $6xABB.FastColor)(color);
    var hsv = pColor.toHsv();
    for(var i = $71f24e858a0b1214$var$lightColorCount; i > 0; i -= 1){
        var c = new (0, $6xABB.FastColor)({
            h: $71f24e858a0b1214$var$getHue(hsv, i, true),
            s: $71f24e858a0b1214$var$getSaturation(hsv, i, true),
            v: $71f24e858a0b1214$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(var _i = 1; _i <= $71f24e858a0b1214$var$darkColorCount; _i += 1){
        var _c = new (0, $6xABB.FastColor)({
            h: $71f24e858a0b1214$var$getHue(hsv, _i),
            s: $71f24e858a0b1214$var$getSaturation(hsv, _i),
            v: $71f24e858a0b1214$var$getValue(hsv, _i)
        });
        patterns.push(_c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $71f24e858a0b1214$var$darkColorMap.map(function(_ref) {
        var index = _ref.index, amount = _ref.amount;
        return new (0, $6xABB.FastColor)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString();
    });
    return patterns.map(function(c) {
        return c.toHexString();
    });
}

});
parcelRegister("ks6TL", function(module, exports) {
$parcel$export(module.exports, "FastColor", () => (parcelRequire("6xABB")).FastColor);
parcelRequire("6xABB");
parcelRequire("9pPq4");

});
parcelRegister("6xABB", function(module, exports) {

$parcel$export(module.exports, "FastColor", () => $4c3238383cf8c0bc$export$2c4f38d6c0ecc25a);

var $eq8kl = parcelRequire("eq8kl");
const $4c3238383cf8c0bc$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $4c3238383cf8c0bc$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $4c3238383cf8c0bc$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $4c3238383cf8c0bc$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $4c3238383cf8c0bc$export$2c4f38d6c0ecc25a {
    constructor(input){
        /**
     * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
     */ (0, $eq8kl.default)(this, "isValid", true);
        /**
     * Red, R in RGB
     */ (0, $eq8kl.default)(this, "r", 0);
        /**
     * Green, G in RGB
     */ (0, $eq8kl.default)(this, "g", 0);
        /**
     * Blue, B in RGB
     */ (0, $eq8kl.default)(this, "b", 0);
        /**
     * Alpha/Opacity, A in RGBA/HSLA
     */ (0, $eq8kl.default)(this, "a", 1);
        // HSV privates
        (0, $eq8kl.default)(this, "_h", void 0);
        (0, $eq8kl.default)(this, "_s", void 0);
        (0, $eq8kl.default)(this, "_l", void 0);
        (0, $eq8kl.default)(this, "_v", void 0);
        // intermediate variables to calculate HSL/HSV
        (0, $eq8kl.default)(this, "_max", void 0);
        (0, $eq8kl.default)(this, "_min", void 0);
        (0, $eq8kl.default)(this, "_brightness", void 0);
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
        } else if (input instanceof $4c3238383cf8c0bc$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $4c3238383cf8c0bc$var$limitRange(input.r);
            this.g = $4c3238383cf8c0bc$var$limitRange(input.g);
            this.b = $4c3238383cf8c0bc$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $4c3238383cf8c0bc$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $4c3238383cf8c0bc$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $4c3238383cf8c0bc$var$round(calc('r')),
            g: $4c3238383cf8c0bc$var$round(calc('g')),
            b: $4c3238383cf8c0bc$var$round(calc('b')),
            a: $4c3238383cf8c0bc$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $4c3238383cf8c0bc$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $4c3238383cf8c0bc$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $4c3238383cf8c0bc$var$round(this.getSaturation() * 100);
        const l = $4c3238383cf8c0bc$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $4c3238383cf8c0bc$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: h, s: s, l: l, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $4c3238383cf8c0bc$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $4c3238383cf8c0bc$var$round((r + lightnessModification) * 255);
        this.g = $4c3238383cf8c0bc$var$round((g + lightnessModification) * 255);
        this.b = $4c3238383cf8c0bc$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: h, s: s, v: v, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $4c3238383cf8c0bc$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $4c3238383cf8c0bc$var$round(v * (1.0 - s) * 255);
        const q = $4c3238383cf8c0bc$var$round(v * (1.0 - s * ff) * 255);
        const t = $4c3238383cf8c0bc$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $4c3238383cf8c0bc$var$splitColorStr(trimStr, $4c3238383cf8c0bc$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $4c3238383cf8c0bc$var$splitColorStr(trimStr, $4c3238383cf8c0bc$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $4c3238383cf8c0bc$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $4c3238383cf8c0bc$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}

});

parcelRegister("9pPq4", function(module, exports) {

});



parcelRegister("lvl2c", function(module, exports) {

$parcel$export(module.exports, "presetPrimaryColors", () => $fa7ccf380ef09b01$export$3968a3afc810b5f5);
$parcel$export(module.exports, "gold", () => $fa7ccf380ef09b01$export$c24201f7fe3571d8);
$parcel$export(module.exports, "blue", () => $fa7ccf380ef09b01$export$2aa0182783e7e9de);
$parcel$export(module.exports, "presetPalettes", () => $fa7ccf380ef09b01$export$36ad6df0f83f284d);
// Generated by script. Do NOT modify!
var $fa7ccf380ef09b01$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
var $fa7ccf380ef09b01$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$fa7ccf380ef09b01$export$a90204d1394caf30.primary = $fa7ccf380ef09b01$export$a90204d1394caf30[5];
var $fa7ccf380ef09b01$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$fa7ccf380ef09b01$export$e63a1643b2f79b16.primary = $fa7ccf380ef09b01$export$e63a1643b2f79b16[5];
var $fa7ccf380ef09b01$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$fa7ccf380ef09b01$export$ad766f34ace1cafd.primary = $fa7ccf380ef09b01$export$ad766f34ace1cafd[5];
var $fa7ccf380ef09b01$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$fa7ccf380ef09b01$export$c24201f7fe3571d8.primary = $fa7ccf380ef09b01$export$c24201f7fe3571d8[5];
var $fa7ccf380ef09b01$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$fa7ccf380ef09b01$export$594c5a8758200c32.primary = $fa7ccf380ef09b01$export$594c5a8758200c32[5];
var $fa7ccf380ef09b01$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$fa7ccf380ef09b01$export$221d31baf2636aad.primary = $fa7ccf380ef09b01$export$221d31baf2636aad[5];
var $fa7ccf380ef09b01$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$fa7ccf380ef09b01$export$955a2ebd2fb142ae.primary = $fa7ccf380ef09b01$export$955a2ebd2fb142ae[5];
var $fa7ccf380ef09b01$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$fa7ccf380ef09b01$export$7474046f446842ee.primary = $fa7ccf380ef09b01$export$7474046f446842ee[5];
var $fa7ccf380ef09b01$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$fa7ccf380ef09b01$export$2aa0182783e7e9de.primary = $fa7ccf380ef09b01$export$2aa0182783e7e9de[5];
var $fa7ccf380ef09b01$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$fa7ccf380ef09b01$export$4138d3aeddcbf415.primary = $fa7ccf380ef09b01$export$4138d3aeddcbf415[5];
var $fa7ccf380ef09b01$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$fa7ccf380ef09b01$export$e13cce2a2d16a9d4.primary = $fa7ccf380ef09b01$export$e13cce2a2d16a9d4[5];
var $fa7ccf380ef09b01$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$fa7ccf380ef09b01$export$2a9ca2e383622e18.primary = $fa7ccf380ef09b01$export$2a9ca2e383622e18[5];
var $fa7ccf380ef09b01$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$fa7ccf380ef09b01$export$e4c89085febbc618.primary = $fa7ccf380ef09b01$export$e4c89085febbc618[5];
var $fa7ccf380ef09b01$export$3e2c219d3ab79d01 = $fa7ccf380ef09b01$export$e4c89085febbc618;
var $fa7ccf380ef09b01$export$36ad6df0f83f284d = {
    red: $fa7ccf380ef09b01$export$a90204d1394caf30,
    volcano: $fa7ccf380ef09b01$export$e63a1643b2f79b16,
    orange: $fa7ccf380ef09b01$export$ad766f34ace1cafd,
    gold: $fa7ccf380ef09b01$export$c24201f7fe3571d8,
    yellow: $fa7ccf380ef09b01$export$594c5a8758200c32,
    lime: $fa7ccf380ef09b01$export$221d31baf2636aad,
    green: $fa7ccf380ef09b01$export$955a2ebd2fb142ae,
    cyan: $fa7ccf380ef09b01$export$7474046f446842ee,
    blue: $fa7ccf380ef09b01$export$2aa0182783e7e9de,
    geekblue: $fa7ccf380ef09b01$export$4138d3aeddcbf415,
    purple: $fa7ccf380ef09b01$export$e13cce2a2d16a9d4,
    magenta: $fa7ccf380ef09b01$export$2a9ca2e383622e18,
    grey: $fa7ccf380ef09b01$export$e4c89085febbc618
};
var $fa7ccf380ef09b01$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$fa7ccf380ef09b01$export$e984d34fc144caa1.primary = $fa7ccf380ef09b01$export$e984d34fc144caa1[5];
var $fa7ccf380ef09b01$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$fa7ccf380ef09b01$export$360e10f78e17a865.primary = $fa7ccf380ef09b01$export$360e10f78e17a865[5];
var $fa7ccf380ef09b01$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$fa7ccf380ef09b01$export$d5a12c698b31fa45.primary = $fa7ccf380ef09b01$export$d5a12c698b31fa45[5];
var $fa7ccf380ef09b01$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$fa7ccf380ef09b01$export$2330427fb6a6af6f.primary = $fa7ccf380ef09b01$export$2330427fb6a6af6f[5];
var $fa7ccf380ef09b01$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$fa7ccf380ef09b01$export$67d203119f0ecec.primary = $fa7ccf380ef09b01$export$67d203119f0ecec[5];
var $fa7ccf380ef09b01$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$fa7ccf380ef09b01$export$51ed2a10d86576ed.primary = $fa7ccf380ef09b01$export$51ed2a10d86576ed[5];
var $fa7ccf380ef09b01$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$fa7ccf380ef09b01$export$76a3d804058f9b5f.primary = $fa7ccf380ef09b01$export$76a3d804058f9b5f[5];
var $fa7ccf380ef09b01$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$fa7ccf380ef09b01$export$dee6c7c6683c0d88.primary = $fa7ccf380ef09b01$export$dee6c7c6683c0d88[5];
var $fa7ccf380ef09b01$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$fa7ccf380ef09b01$export$10e0fd027e632624.primary = $fa7ccf380ef09b01$export$10e0fd027e632624[5];
var $fa7ccf380ef09b01$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$fa7ccf380ef09b01$export$abdd57ab473bba66.primary = $fa7ccf380ef09b01$export$abdd57ab473bba66[5];
var $fa7ccf380ef09b01$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$fa7ccf380ef09b01$export$7a65e68792738764.primary = $fa7ccf380ef09b01$export$7a65e68792738764[5];
var $fa7ccf380ef09b01$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$fa7ccf380ef09b01$export$d260a9321db4ab86.primary = $fa7ccf380ef09b01$export$d260a9321db4ab86[5];
var $fa7ccf380ef09b01$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$fa7ccf380ef09b01$export$515283ba400ffa6c.primary = $fa7ccf380ef09b01$export$515283ba400ffa6c[5];
var $fa7ccf380ef09b01$export$24617255e4daf647 = {
    red: $fa7ccf380ef09b01$export$e984d34fc144caa1,
    volcano: $fa7ccf380ef09b01$export$360e10f78e17a865,
    orange: $fa7ccf380ef09b01$export$d5a12c698b31fa45,
    gold: $fa7ccf380ef09b01$export$2330427fb6a6af6f,
    yellow: $fa7ccf380ef09b01$export$67d203119f0ecec,
    lime: $fa7ccf380ef09b01$export$51ed2a10d86576ed,
    green: $fa7ccf380ef09b01$export$76a3d804058f9b5f,
    cyan: $fa7ccf380ef09b01$export$dee6c7c6683c0d88,
    blue: $fa7ccf380ef09b01$export$10e0fd027e632624,
    geekblue: $fa7ccf380ef09b01$export$abdd57ab473bba66,
    purple: $fa7ccf380ef09b01$export$7a65e68792738764,
    magenta: $fa7ccf380ef09b01$export$d260a9321db4ab86,
    grey: $fa7ccf380ef09b01$export$515283ba400ffa6c
};

});

parcelRegister("6NEc9", function(module, exports) {

});


parcelRegister("96Xlm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a22b4f8e4a7e628$var$genColorMapToken;
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
function $6a22b4f8e4a7e628$var$genColorMapToken(seed, _ref) {
    let { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes } = _ref;
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new $6xABB.FastColor(errorColors[1]).mix(new $6xABB.FastColor(errorColors[3]), 50).toHexString();
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new $6xABB.FastColor('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    });
}

});

parcelRegister("d9auM", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $992441c972e972bb$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $992441c972e972bb$var$genCommonMapToken;

var $992441c972e972bb$var$_genRadius = $992441c972e972bb$require$_interopRequireDefault((parcelRequire("fmghv")));
function $992441c972e972bb$var$genCommonMapToken(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return Object.assign({
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $992441c972e972bb$var$_genRadius.default)(borderRadius));
}

});
parcelRegister("fmghv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $b2e58a3b98f619fc$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $b2e58a3b98f619fc$var$_default = module.exports.default = $b2e58a3b98f619fc$var$genRadius;

});


parcelRegister("fxvxf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $b5026658be59f8c7$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $b5026658be59f8c7$var$_default = module.exports.default = $b5026658be59f8c7$var$genControlHeight;

});

parcelRegister("6Zqq2", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $516ceed847e79603$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $516ceed847e79603$var$_genFontSizes = $516ceed847e79603$require$_interopRequireDefault((parcelRequire("f3EGY")));
const $516ceed847e79603$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $516ceed847e79603$var$_genFontSizes.default)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $516ceed847e79603$var$_default = module.exports.default = $516ceed847e79603$var$genFontMapToken;

});
parcelRegister("f3EGY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af66b3729104ea02$var$getFontSizes;
module.exports.getLineHeight = $af66b3729104ea02$var$getLineHeight;
function $af66b3729104ea02$var$getLineHeight(fontSize) {
    return (fontSize + 8) / fontSize;
}
// https://zhuanlan.zhihu.com/p/32746810
function $af66b3729104ea02$var$getFontSizes(base) {
    const fontSizes = new Array(10).fill(null).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.pow(Math.E, i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $af66b3729104ea02$var$getLineHeight(size)
        }));
}

});


parcelRegister("4yckB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3503e71ef2b685ab$var$genSizeMapToken;
function $3503e71ef2b685ab$var$genSizeMapToken(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}

});

parcelRegister("1QVjC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateNeutralColorPalettes = module.exports.generateColorPalettes = void 0;
parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");

var $iIxHc = parcelRequire("iIxHc");
const $15971b6f4dfbacb2$var$generateColorPalettes = (baseColor)=>{
    const colors = (0, $9Mx90.default)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
module.exports.generateColorPalettes = $15971b6f4dfbacb2$var$generateColorPalettes;
const $15971b6f4dfbacb2$var$generateNeutralColorPalettes = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.88),
        colorTextSecondary: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.65),
        colorTextTertiary: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.25),
        colorFill: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.15),
        colorFillSecondary: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.06),
        colorFillTertiary: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.02),
        colorBgSolid: (0, $iIxHc.getAlphaColor)(colorTextBase, 1),
        colorBgSolidHover: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.95),
        colorBgLayout: (0, $iIxHc.getSolidColor)(colorBgBase, 4),
        colorBgContainer: (0, $iIxHc.getSolidColor)(colorBgBase, 0),
        colorBgElevated: (0, $iIxHc.getSolidColor)(colorBgBase, 0),
        colorBgSpotlight: (0, $iIxHc.getAlphaColor)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $iIxHc.getSolidColor)(colorBgBase, 15),
        colorBorderSecondary: (0, $iIxHc.getSolidColor)(colorBgBase, 6)
    };
};
module.exports.generateNeutralColorPalettes = $15971b6f4dfbacb2$var$generateNeutralColorPalettes;

});
parcelRegister("iIxHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSolidColor = module.exports.getAlphaColor = void 0;
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
const $da06794fa94c714d$var$getAlphaColor = (baseColor, alpha)=>new $6xABB.FastColor(baseColor).setA(alpha).toRgbString();
module.exports.getAlphaColor = $da06794fa94c714d$var$getAlphaColor;
const $da06794fa94c714d$var$getSolidColor = (baseColor, brightness)=>{
    const instance = new $6xABB.FastColor(baseColor);
    return instance.darken(brightness).toHexString();
};
module.exports.getSolidColor = $da06794fa94c714d$var$getSolidColor;

});




parcelRegister("5ft6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d24ed02757fd299$var$canUseDom;
function $3d24ed02757fd299$var$canUseDom() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

});

parcelRegister("7Quse", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b6503517d9dfe5b$var$contains;
function $5b6503517d9dfe5b$var$contains(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

});

parcelRegister("8zNsY", function(module, exports) {
"use strict";
"use client";

var $ffW2x = parcelRequire("ffW2x");
var $63e7f69c5aaf530d$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.DisabledContextProvider = void 0;

var $63e7f69c5aaf530d$var$React = $63e7f69c5aaf530d$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
const $63e7f69c5aaf530d$var$DisabledContext = /*#__PURE__*/ $63e7f69c5aaf530d$var$React.createContext(false);
const $63e7f69c5aaf530d$var$DisabledContextProvider = (_ref)=>{
    let { children: children, disabled: disabled } = _ref;
    const originDisabled = $63e7f69c5aaf530d$var$React.useContext($63e7f69c5aaf530d$var$DisabledContext);
    return /*#__PURE__*/ $63e7f69c5aaf530d$var$React.createElement($63e7f69c5aaf530d$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
module.exports.DisabledContextProvider = $63e7f69c5aaf530d$var$DisabledContextProvider;
var $63e7f69c5aaf530d$var$_default = module.exports.default = $63e7f69c5aaf530d$var$DisabledContext;

});

parcelRegister("l8tCV", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $f6315398506e418e$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jMaZ8 = parcelRequire("jMaZ8");

var $f6315398506e418e$var$_DisabledContext = $f6315398506e418e$require$_interopRequireDefault((parcelRequire("8zNsY")));

var $f6315398506e418e$var$_SizeContext = $f6315398506e418e$require$_interopRequireDefault((parcelRequire("7hz7I")));
function $f6315398506e418e$var$useConfig() {
    const componentDisabled = (0, $jMaZ8.useContext)($f6315398506e418e$var$_DisabledContext.default);
    const componentSize = (0, $jMaZ8.useContext)($f6315398506e418e$var$_SizeContext.default);
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $f6315398506e418e$var$_default = module.exports.default = $f6315398506e418e$var$useConfig;

});
parcelRegister("7hz7I", function(module, exports) {
"use strict";
"use client";

var $ffW2x = parcelRequire("ffW2x");
var $54d55db63d4b2ceb$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.SizeContextProvider = void 0;

var $54d55db63d4b2ceb$var$React = $54d55db63d4b2ceb$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
const $54d55db63d4b2ceb$var$SizeContext = /*#__PURE__*/ $54d55db63d4b2ceb$var$React.createContext(undefined);
const $54d55db63d4b2ceb$var$SizeContextProvider = (_ref)=>{
    let { children: children, size: size } = _ref;
    const originSize = $54d55db63d4b2ceb$var$React.useContext($54d55db63d4b2ceb$var$SizeContext);
    return /*#__PURE__*/ $54d55db63d4b2ceb$var$React.createElement($54d55db63d4b2ceb$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
module.exports.SizeContextProvider = $54d55db63d4b2ceb$var$SizeContextProvider;
var $54d55db63d4b2ceb$var$_default = module.exports.default = $54d55db63d4b2ceb$var$SizeContext;

});


parcelRegister("30OpA", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $231879ea38583eac$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $231879ea38583eac$var$useTheme;

var $231879ea38583eac$var$_useMemo = $231879ea38583eac$require$_interopRequireDefault((parcelRequire("1C33x")));

var $231879ea38583eac$var$_isEqual = $231879ea38583eac$require$_interopRequireDefault((parcelRequire("ljYgH")));

var $dw0yD = parcelRequire("dw0yD");

var $LXVdy = parcelRequire("LXVdy");

var $231879ea38583eac$var$_useThemeKey = $231879ea38583eac$require$_interopRequireDefault((parcelRequire("hLaaN")));
function $231879ea38583eac$var$useTheme(theme, parentTheme, config) {
    var _a, _b;
    const warning = (0, $dw0yD.devUseWarning)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, $LXVdy.defaultConfig), {
        hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : $LXVdy.defaultConfig.hashed,
        cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
    }) : parentTheme;
    const themeKey = (0, $231879ea38583eac$var$_useThemeKey.default)();
    {
        const cssVarEnabled = themeConfig.cssVar || parentThemeConfig.cssVar;
        const validKey = !!(typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || themeKey);
        warning(!cssVarEnabled || validKey, 'breaking', 'Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.');
    }
    return (0, $231879ea38583eac$var$_useMemo.default)(()=>{
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: config === null || config === void 0 ? void 0 : config.prefixCls
        }, typeof parentThemeConfig.cssVar === 'object' ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === 'object' ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $231879ea38583eac$var$_isEqual.default)(prevTheme, nextTheme, true);
        }));
}

});
parcelRegister("ljYgH", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $f85a1f60cc87b0a2$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f85a1f60cc87b0a2$var$_typeof2 = $f85a1f60cc87b0a2$require$_interopRequireDefault((parcelRequire("cEcQP")));

var $f85a1f60cc87b0a2$var$_warning = $f85a1f60cc87b0a2$require$_interopRequireDefault((parcelRequire("jtk8Y")));
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $f85a1f60cc87b0a2$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $f85a1f60cc87b0a2$var$_warning.default)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $f85a1f60cc87b0a2$var$_typeof2.default)(a) === 'object' && (0, $f85a1f60cc87b0a2$var$_typeof2.default)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $f85a1f60cc87b0a2$var$_default = module.exports.default = $f85a1f60cc87b0a2$var$isEqual;

});

parcelRegister("LXVdy", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $0902df2295c7610f$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DesignTokenContext", {
    enumerable: true,
    get: function() {
        return $3Y34g.DesignTokenContext;
    }
});
Object.defineProperty(module.exports, "PresetColors", {
    enumerable: true,
    get: function() {
        return $yi9zi.PresetColors;
    }
});
Object.defineProperty(module.exports, "calc", {
    enumerable: true,
    get: function() {
        return $1i4mh.default;
    }
});
Object.defineProperty(module.exports, "defaultConfig", {
    enumerable: true,
    get: function() {
        return $3Y34g.defaultConfig;
    }
});
Object.defineProperty(module.exports, "genComponentStyleHook", {
    enumerable: true,
    get: function() {
        return $4jHXi.genComponentStyleHook;
    }
});
Object.defineProperty(module.exports, "genPresetColor", {
    enumerable: true,
    get: function() {
        return $0902df2295c7610f$var$_genPresetColor.default;
    }
});
Object.defineProperty(module.exports, "genStyleHooks", {
    enumerable: true,
    get: function() {
        return $4jHXi.genStyleHooks;
    }
});
Object.defineProperty(module.exports, "genSubStyleComponent", {
    enumerable: true,
    get: function() {
        return $4jHXi.genSubStyleComponent;
    }
});
Object.defineProperty(module.exports, "getLineHeight", {
    enumerable: true,
    get: function() {
        return $f3EGY.getLineHeight;
    }
});
Object.defineProperty(module.exports, "mergeToken", {
    enumerable: true,
    get: function() {
        return $8APUt.merge;
    }
});
Object.defineProperty(module.exports, "statistic", {
    enumerable: true,
    get: function() {
        return $8APUt.statistic;
    }
});
Object.defineProperty(module.exports, "statisticToken", {
    enumerable: true,
    get: function() {
        return $8APUt.default;
    }
});
Object.defineProperty(module.exports, "useResetIconStyle", {
    enumerable: true,
    get: function() {
        return $0902df2295c7610f$var$_useResetIconStyle.default;
    }
});
Object.defineProperty(module.exports, "useStyleRegister", {
    enumerable: true,
    get: function() {
        return $gofJe.default;
    }
});
Object.defineProperty(module.exports, "useToken", {
    enumerable: true,
    get: function() {
        return $0902df2295c7610f$var$_useToken.default;
    }
});
parcelRequire("gedkv");
var $gofJe = parcelRequire("gofJe");
parcelRequire("a1kuN");
var $1i4mh = parcelRequire("1i4mh");
var $8APUt = parcelRequire("8APUt");

var $yi9zi = parcelRequire("yi9zi");

var $f3EGY = parcelRequire("f3EGY");

var $0902df2295c7610f$var$_useToken = $0902df2295c7610f$require$_interopRequireDefault((parcelRequire("f5JHL")));

var $4jHXi = parcelRequire("4jHXi");

var $0902df2295c7610f$var$_genPresetColor = $0902df2295c7610f$require$_interopRequireDefault((parcelRequire("gfFx6")));

var $0902df2295c7610f$var$_useResetIconStyle = $0902df2295c7610f$require$_interopRequireDefault((parcelRequire("iwpir")));

var $3Y34g = parcelRequire("3Y34g");

});
parcelRegister("a1kuN", function(module, exports) {

$parcel$export(module.exports, "genStyleUtils", () => (parcelRequire("m8UpB")).default);
$parcel$export(module.exports, "genCalc", () => (parcelRequire("1i4mh")).default);
$parcel$export(module.exports, "statisticToken", () => (parcelRequire("8APUt")).default);
$parcel$export(module.exports, "mergeToken", () => (parcelRequire("8APUt")).merge);
$parcel$export(module.exports, "statistic", () => (parcelRequire("8APUt")).statistic);

var $m8UpB = parcelRequire("m8UpB");

var $1i4mh = parcelRequire("1i4mh");

var $8APUt = parcelRequire("8APUt");

});
parcelRegister("m8UpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0428f74de8395640$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $3fkx6 = parcelRequire("3fkx6");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("gedkv");
var $f0tZ5 = parcelRequire("f0tZ5");
var $atLsZ = parcelRequire("atLsZ");
var $gofJe = parcelRequire("gofJe");

var $1i4mh = parcelRequire("1i4mh");

var $bLe3R = parcelRequire("bLe3R");

var $rfDzn = parcelRequire("rfDzn");

var $eMNtz = parcelRequire("eMNtz");

var $i3ala = parcelRequire("i3ala");

var $8APUt = parcelRequire("8APUt");

var $1XXpg = parcelRequire("1XXpg");

var $2Vnoz = parcelRequire("2Vnoz");
function $0428f74de8395640$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $2Vnoz.default) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $8u3qN.default)((0, $8u3qN.default)({}, originCompUnitless), {}, (0, $eq8kl.default)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $8u3qN.default)((0, $8u3qN.default)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useStyle = useStyle(prefixCls, rootCls), _useStyle2 = (0, $3fkx6.default)(_useStyle, 2), hashId = _useStyle2[1];
            var _useCSSVar = useCSSVar(rootCls), _useCSSVar2 = (0, $3fkx6.default)(_useCSSVar, 2), wrapCSSVar = _useCSSVar2[0], cssVarCls = _useCSSVar2[1];
            return [
                wrapCSSVar,
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, _options$injectStyle = options.injectStyle, injectStyle = _options$injectStyle === void 0 ? true : _options$injectStyle, prefixToken = options.prefixToken, ignore = options.ignore;
        var CSSVarRegister = function CSSVarRegister(_ref) {
            var rootCls = _ref.rootCls, _ref$cssVar = _ref.cssVar, cssVar = _ref$cssVar === void 0 ? {} : _ref$cssVar;
            var _useToken = useToken(), realToken = _useToken.realToken;
            (0, $atLsZ.default)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls
            }, function() {
                var defaultToken = (0, $eMNtz.default)(component, realToken, getDefaultToken);
                var componentToken = (0, $rfDzn.default)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return null;
        };
        var useCSSVar = function useCSSVar(rootCls) {
            var _useToken2 = useToken(), cssVar = _useToken2.cssVar;
            return [
                function(node) {
                    return injectStyle && cssVar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(CSSVarRegister, {
                        rootCls: rootCls,
                        cssVar: cssVar,
                        component: component
                    }), node) : node;
                },
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.key
            ];
        };
        return useCSSVar;
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $3fkx6.default)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken3 = useToken(), theme = _useToken3.theme, realToken = _useToken3.realToken, hashId = _useToken3.hashId, token = _useToken3.token, cssVar = _useToken3.cssVar;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = cssVar ? 'css' : 'js';
            // Use unique memo to share the result across all instances
            var calc = (0, $1XXpg.default)(function() {
                var unitlessCssVar = new Set();
                if (cssVar) Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $f0tZ5.token2CSSVar)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $f0tZ5.token2CSSVar)(key, (0, $bLe3R.default)(component, cssVar.prefix)));
                });
                return (0, $1i4mh.default)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $i3ala.default)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $gofJe.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            var wrapSSR = (0, $gofJe.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $8APUt.default)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $eMNtz.default)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $rfDzn.default)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (cssVar && defaultComponentToken && (0, $1Esi2.default)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $f0tZ5.token2CSSVar)(key, (0, $bLe3R.default)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $8APUt.merge)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    // @ts-ignore
                    max: max,
                    // @ts-ignore
                    min: min
                }, cssVar ? defaultComponentToken : componentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return [
                wrapSSR,
                hashId
            ];
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $8u3qN.default)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref2) {
            var prefixCls = _ref2.prefixCls, _ref2$rootCls = _ref2.rootCls, rootCls = _ref2$rootCls === void 0 ? prefixCls : _ref2$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        StyledComponent.displayName = "SubStyle_".concat(String(Array.isArray(componentName) ? componentName.join('.') : componentName));
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $0428f74de8395640$export$2e2bcd8739ae039 = $0428f74de8395640$var$genStyleUtils;

});
parcelRegister("1i4mh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f0ada57bcd5db69$export$2e2bcd8739ae039);

var $eC61H = parcelRequire("eC61H");

var $hVife = parcelRequire("hVife");
var $0f0ada57bcd5db69$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $eC61H.default) : (0, $hVife.default);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $0f0ada57bcd5db69$export$2e2bcd8739ae039 = $0f0ada57bcd5db69$var$genCalc;

});
parcelRegister("eC61H", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa394a0b0a17c6ac$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $avJyj = parcelRequire("avJyj");
var $aa394a0b0a17c6ac$var$CALC_UNIT = 'CALC_UNIT';
var $aa394a0b0a17c6ac$var$regexp = new RegExp($aa394a0b0a17c6ac$var$CALC_UNIT, 'g');
function $aa394a0b0a17c6ac$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($aa394a0b0a17c6ac$var$CALC_UNIT);
    return value;
}
var $aa394a0b0a17c6ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $7eK0y.default)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $fwNdX.default)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $klxbl.default)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "result", '');
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "unitlessCssVar", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "lowPriority", void 0);
        var numType = (0, $1Esi2.default)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $aa394a0b0a17c6ac$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $9O7LJ.default)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($aa394a0b0a17c6ac$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($aa394a0b0a17c6ac$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($aa394a0b0a17c6ac$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $avJyj.default));

});
parcelRegister("avJyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a70226bb87a7b9f$export$2e2bcd8739ae039);

var $9O7LJ = parcelRequire("9O7LJ");

var $klxbl = parcelRequire("klxbl");
var $7a70226bb87a7b9f$var$AbstractCalculator = /*#__PURE__*/ (0, $9O7LJ.default)(function AbstractCalculator() {
    (0, $klxbl.default)(this, AbstractCalculator);
});
var $7a70226bb87a7b9f$export$2e2bcd8739ae039 = $7a70226bb87a7b9f$var$AbstractCalculator;

});


parcelRegister("hVife", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c5e99230e5ad59$export$2e2bcd8739ae039);

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $avJyj = parcelRequire("avJyj");
var $d0c5e99230e5ad59$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $7eK0y.default)(NumCalculator, _AbstractCalculator);
    var _super = (0, $fwNdX.default)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $klxbl.default)(this, NumCalculator);
        _this = _super.call(this);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $9O7LJ.default)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $avJyj.default));
var $d0c5e99230e5ad59$export$2e2bcd8739ae039 = $d0c5e99230e5ad59$var$NumCalculator;

});


parcelRegister("bLe3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $88fefdc9089394fa$export$2e2bcd8739ae039);
var $88fefdc9089394fa$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $88fefdc9089394fa$export$2e2bcd8739ae039 = $88fefdc9089394fa$var$getCompVarPrefix;

});

parcelRegister("rfDzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $051ea6f4f8785d7b$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $8u3qN = parcelRequire("8u3qN");
parcelRequire("1CVs1");
var $2bFmQ = parcelRequire("2bFmQ");
function $051ea6f4f8785d7b$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $8u3qN.default)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $3fkx6.default)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            (0, $2bFmQ.default)(!(customToken !== null && customToken !== void 0 && customToken[oldTokenKey]), "Component Token `".concat(String(oldTokenKey), "` of ").concat(String(component), " is deprecated. Please use `").concat(String(newTokenKey), "` instead."));
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $8u3qN.default)((0, $8u3qN.default)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $051ea6f4f8785d7b$export$2e2bcd8739ae039 = $051ea6f4f8785d7b$var$getComponentToken;

});
parcelRegister("1CVs1", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => (parcelRequire("ktS49")).default);
$parcel$export(module.exports, "useMergedState", () => (parcelRequire("eGh7a")).default);
$parcel$export(module.exports, "get", () => (parcelRequire("k19OO")).default);
$parcel$export(module.exports, "set", () => (parcelRequire("3hbWa")).default);
$parcel$export(module.exports, "warning", () => (parcelRequire("2bFmQ")).default);

var $ktS49 = parcelRequire("ktS49");

var $eGh7a = parcelRequire("eGh7a");

var $1cfGC = parcelRequire("1cfGC");

var $k19OO = parcelRequire("k19OO");

var $3hbWa = parcelRequire("3hbWa");

var $2bFmQ = parcelRequire("2bFmQ");

});


parcelRegister("eMNtz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac3bed44a117d795$export$2e2bcd8739ae039);

var $8APUt = parcelRequire("8APUt");
function $ac3bed44a117d795$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $8APUt.merge)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $ac3bed44a117d795$export$2e2bcd8739ae039 = $ac3bed44a117d795$var$getDefaultComponentToken;

});
parcelRegister("8APUt", function(module, exports) {

$parcel$export(module.exports, "merge", () => $6419f3bd7457c270$export$4950aa0f605343fb);
$parcel$export(module.exports, "statistic", () => $6419f3bd7457c270$export$754a5e2d36c5fa7a);
$parcel$export(module.exports, "default", () => $6419f3bd7457c270$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");
var $6419f3bd7457c270$var$enableStatistic = true;
var $6419f3bd7457c270$var$recording = true;
function $6419f3bd7457c270$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$6419f3bd7457c270$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $6419f3bd7457c270$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $1Esi2.default)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $6419f3bd7457c270$var$recording = true;
    return ret;
}
var $6419f3bd7457c270$export$754a5e2d36c5fa7a = {};
var $6419f3bd7457c270$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $6419f3bd7457c270$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $6419f3bd7457c270$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $6419f3bd7457c270$var$noop;
    if ($6419f3bd7457c270$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($6419f3bd7457c270$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $6419f3bd7457c270$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $8u3qN.default)((0, $8u3qN.default)({}, (_statistic$componentN = $6419f3bd7457c270$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $6419f3bd7457c270$export$2e2bcd8739ae039 = $6419f3bd7457c270$var$statisticToken;

});


parcelRegister("i3ala", function(module, exports) {

$parcel$export(module.exports, "default", () => $d240873862b8505d$export$2e2bcd8739ae039);
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
function $d240873862b8505d$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $4g3I0.unit)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $4g3I0.unit)(value);
            }).join(','), ")");
        }
    };
}
var $d240873862b8505d$export$2e2bcd8739ae039 = $d240873862b8505d$var$genMaxMin;

});

parcelRegister("1XXpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $16e96201a2f5161b$export$2e2bcd8739ae039);

var $1Esi2 = parcelRequire("1Esi2");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");

var $jMaZ8 = parcelRequire("jMaZ8");
var $16e96201a2f5161b$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $16e96201a2f5161b$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $klxbl.default)(this, ArrayKeyMap);
        (0, $eq8kl.default)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $eq8kl.default)(this, "objectIDMap", new WeakMap());
        (0, $eq8kl.default)(this, "nextID", 0);
        (0, $eq8kl.default)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $eq8kl.default)(this, "accessBeat", 0);
    }
    (0, $9O7LJ.default)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $1Esi2.default)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $1Esi2.default)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $16e96201a2f5161b$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $16e96201a2f5161b$var$uniqueMap = new $16e96201a2f5161b$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $16e96201a2f5161b$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        var cachedValue = $16e96201a2f5161b$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $16e96201a2f5161b$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $16e96201a2f5161b$export$2e2bcd8739ae039 = $16e96201a2f5161b$var$useUniqueMemo;

});

parcelRegister("2Vnoz", function(module, exports) {

$parcel$export(module.exports, "default", () => $22130d78c1fa6f56$export$2e2bcd8739ae039);
/**
 * Provide a default hook since not everyone needs to config this.
 */ var $22130d78c1fa6f56$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $22130d78c1fa6f56$export$2e2bcd8739ae039 = $22130d78c1fa6f56$var$useDefaultCSP;

});



parcelRegister("yi9zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PresetColors", {
    enumerable: true,
    get: function() {
        return $f5hRE.PresetColors;
    }
});

var $f5hRE = parcelRequire("f5hRE");

});
parcelRegister("f5hRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PresetColors = void 0;
const $afb52e26faea7f1c$var$PresetColors = module.exports.PresetColors = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];

});


parcelRegister("f5JHL", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $afcac6ae54aba0cd$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afcac6ae54aba0cd$var$useToken;
module.exports.unitless = module.exports.ignore = module.exports.getComputedToken = void 0;

var $afcac6ae54aba0cd$var$_react = $afcac6ae54aba0cd$require$_interopRequireDefault((parcelRequire("jMaZ8")));
parcelRequire("gedkv");
var $e3Z3v = parcelRequire("e3Z3v");

var $afcac6ae54aba0cd$var$_version = $afcac6ae54aba0cd$require$_interopRequireDefault((parcelRequire("AQiOP")));

var $3Y34g = parcelRequire("3Y34g");

var $afcac6ae54aba0cd$var$_seed = $afcac6ae54aba0cd$require$_interopRequireDefault((parcelRequire("lCXqA")));

var $afcac6ae54aba0cd$var$_alias = $afcac6ae54aba0cd$require$_interopRequireDefault((parcelRequire("1uqbJ")));
var $afcac6ae54aba0cd$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $afcac6ae54aba0cd$var$unitless = module.exports.unitless = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $afcac6ae54aba0cd$var$ignore = module.exports.ignore = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
};
const $afcac6ae54aba0cd$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $afcac6ae54aba0cd$var$getComputedToken = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override } = overrideToken, components = $afcac6ae54aba0cd$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $afcac6ae54aba0cd$var$_alias.default)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach((_ref)=>{
        let [key, value] = _ref;
        const { theme: componentTheme } = value, componentTokens = $afcac6ae54aba0cd$var$__rest(value, [
            "theme"
        ]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $afcac6ae54aba0cd$var$getComputedToken(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
// ================================== Hook ==================================
module.exports.getComputedToken = $afcac6ae54aba0cd$var$getComputedToken;
function $afcac6ae54aba0cd$var$useToken() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: cssVar } = $afcac6ae54aba0cd$var$_react.default.useContext($3Y34g.DesignTokenContext);
    const salt = `${$afcac6ae54aba0cd$var$_version.default}-${hashed || ''}`;
    const mergedTheme = theme || $3Y34g.defaultTheme;
    const [token, hashId, realToken] = (0, $e3Z3v.default)(mergedTheme, [
        $afcac6ae54aba0cd$var$_seed.default,
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $afcac6ae54aba0cd$var$getComputedToken,
        // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        formatToken: $afcac6ae54aba0cd$var$_alias.default,
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $afcac6ae54aba0cd$var$unitless,
            ignore: $afcac6ae54aba0cd$var$ignore,
            preserve: $afcac6ae54aba0cd$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar
    ];
}

});
parcelRegister("AQiOP", function(module, exports) {
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $06ebef19c9056649$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06ebef19c9056649$var$_version = $06ebef19c9056649$require$_interopRequireDefault((parcelRequire("hvhAX")));
var $06ebef19c9056649$var$_default = module.exports.default = $06ebef19c9056649$var$_version.default;

});
parcelRegister("hvhAX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $cbe2faf27027100f$var$_default = module.exports.default = '5.23.3';

});


parcelRegister("3Y34g", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $2e395ae09bae1a01$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports.DesignTokenContext = void 0;
Object.defineProperty(module.exports, "defaultTheme", {
    enumerable: true,
    get: function() {
        return $2e395ae09bae1a01$var$_theme.default;
    }
});

var $2e395ae09bae1a01$var$_react = $2e395ae09bae1a01$require$_interopRequireDefault((parcelRequire("jMaZ8")));

var $2e395ae09bae1a01$var$_seed = $2e395ae09bae1a01$require$_interopRequireDefault((parcelRequire("lCXqA")));

var $2e395ae09bae1a01$var$_theme = $2e395ae09bae1a01$require$_interopRequireDefault((parcelRequire("6PPgr")));
// ================================ Context =================================
// To ensure snapshot stable. We disable hashed in test env.
const $2e395ae09bae1a01$var$defaultConfig = module.exports.defaultConfig = {
    token: $2e395ae09bae1a01$var$_seed.default,
    override: {
        override: $2e395ae09bae1a01$var$_seed.default
    },
    hashed: true
};
const $2e395ae09bae1a01$var$DesignTokenContext = module.exports.DesignTokenContext = /*#__PURE__*/ $2e395ae09bae1a01$var$_react.default.createContext($2e395ae09bae1a01$var$defaultConfig);

});

parcelRegister("1uqbJ", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $115ce832f329cacb$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $115ce832f329cacb$var$formatToken;
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

var $115ce832f329cacb$var$_seed = $115ce832f329cacb$require$_interopRequireDefault((parcelRequire("lCXqA")));

var $115ce832f329cacb$var$_getAlphaColor = $115ce832f329cacb$require$_interopRequireDefault((parcelRequire("lPLtN")));
var $115ce832f329cacb$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Seed (designer) > Derivative (designer) > Alias (developer).
 *
 * Merge seed & derivative & override token and generate alias token for developer.
 */ function $115ce832f329cacb$var$formatToken(derivativeToken) {
    const { override: override } = derivativeToken, restToken = $115ce832f329cacb$var$__rest(derivativeToken, [
        "override"
    ]);
    const overrideTokens = Object.assign({}, override);
    Object.keys($115ce832f329cacb$var$_seed.default).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $115ce832f329cacb$var$_getAlphaColor.default)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $115ce832f329cacb$var$_getAlphaColor.default)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $115ce832f329cacb$var$_getAlphaColor.default)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $115ce832f329cacb$var$_getAlphaColor.default)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new $6xABB.FastColor('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new $6xABB.FastColor('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new $6xABB.FastColor('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)'
    }), overrideTokens);
    return aliasToken;
}

});
parcelRegister("lPLtN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
function $fe5330d69cf0a710$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $fe5330d69cf0a710$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new $6xABB.FastColor(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new $6xABB.FastColor(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($fe5330d69cf0a710$var$isStableColor(r) && $fe5330d69cf0a710$var$isStableColor(g) && $fe5330d69cf0a710$var$isStableColor(b)) return new $6xABB.FastColor({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new $6xABB.FastColor({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $fe5330d69cf0a710$var$_default = module.exports.default = $fe5330d69cf0a710$var$getAlphaColor;

});



parcelRegister("4jHXi", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $324b08691e9c5def$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.genSubStyleComponent = module.exports.genStyleHooks = module.exports.genComponentStyleHook = void 0;

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("a1kuN");
var $m8UpB = parcelRequire("m8UpB");

var $kh8n9 = parcelRequire("kh8n9");

var $GMiWH = parcelRequire("GMiWH");

var $324b08691e9c5def$var$_useToken = $324b08691e9c5def$require$_interopRequireWildcard((parcelRequire("f5JHL")));
const { genStyleHooks: $324b08691e9c5def$var$genStyleHooks, genComponentStyleHook: $324b08691e9c5def$var$genComponentStyleHook, genSubStyleComponent: $324b08691e9c5def$var$genSubStyleComponent } = (0, $m8UpB.default)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $jMaZ8.useContext)($kh8n9.ConfigContext);
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar] = (0, $324b08691e9c5def$var$_useToken.default)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $jMaZ8.useContext)($kh8n9.ConfigContext);
        return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: (token, config)=>{
        var _a;
        return [
            {
                '&': (0, $GMiWH.genLinkStyle)(token)
            },
            (0, $GMiWH.genIconStyle)((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : $kh8n9.defaultIconPrefixCls)
        ];
    },
    getCommonStyle: $GMiWH.genCommonStyle,
    getCompUnitless: ()=>$324b08691e9c5def$var$_useToken.unitless
});
module.exports.genSubStyleComponent = $324b08691e9c5def$var$genSubStyleComponent;
module.exports.genComponentStyleHook = $324b08691e9c5def$var$genComponentStyleHook;
module.exports.genStyleHooks = $324b08691e9c5def$var$genStyleHooks;

});
parcelRegister("kh8n9", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $ec2be3c39dba942b$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultPrefixCls = module.exports.defaultIconPrefixCls = module.exports.Variants = module.exports.ConfigContext = module.exports.ConfigConsumer = void 0;

var $ec2be3c39dba942b$var$React = $ec2be3c39dba942b$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
const $ec2be3c39dba942b$var$defaultPrefixCls = module.exports.defaultPrefixCls = 'ant';
const $ec2be3c39dba942b$var$defaultIconPrefixCls = module.exports.defaultIconPrefixCls = 'anticon';
const $ec2be3c39dba942b$var$Variants = module.exports.Variants = [
    'outlined',
    'borderless',
    'filled'
];
const $ec2be3c39dba942b$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$ec2be3c39dba942b$var$defaultPrefixCls}-${suffixCls}` : $ec2be3c39dba942b$var$defaultPrefixCls;
};
// zombieJ: 🚨 Do not pass `defaultRenderEmpty` here since it will cause circular dependency.
const $ec2be3c39dba942b$var$ConfigContext = module.exports.ConfigContext = /*#__PURE__*/ $ec2be3c39dba942b$var$React.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $ec2be3c39dba942b$var$defaultGetPrefixCls,
    iconPrefixCls: $ec2be3c39dba942b$var$defaultIconPrefixCls
});
const { Consumer: $ec2be3c39dba942b$var$ConfigConsumer } = $ec2be3c39dba942b$var$ConfigContext;
module.exports.ConfigConsumer = $ec2be3c39dba942b$var$ConfigConsumer;

});

parcelRegister("GMiWH", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.textEllipsis = module.exports.resetIcon = module.exports.resetComponent = module.exports.operationUnit = module.exports.genLinkStyle = module.exports.genIconStyle = module.exports.genFocusStyle = module.exports.genFocusOutline = module.exports.genCommonStyle = module.exports.clearFix = void 0;
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $080964a413c944e3$var$textEllipsis = module.exports.textEllipsis = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $080964a413c944e3$var$resetComponent = function(token) {
    let needInheritFontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    };
};
module.exports.resetComponent = $080964a413c944e3$var$resetComponent;
const $080964a413c944e3$var$resetIcon = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
module.exports.resetIcon = $080964a413c944e3$var$resetIcon;
const $080964a413c944e3$var$clearFix = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
module.exports.clearFix = $080964a413c944e3$var$clearFix;
const $080964a413c944e3$var$genLinkStyle = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
module.exports.genLinkStyle = $080964a413c944e3$var$genLinkStyle;
const $080964a413c944e3$var$genCommonStyle = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
            [prefixSelector]: resetStyle
        })
    };
};
module.exports.genCommonStyle = $080964a413c944e3$var$genCommonStyle;
const $080964a413c944e3$var$genFocusOutline = (token, offset)=>({
        outline: `${(0, $4g3I0.unit)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
        transition: 'outline-offset 0s, outline 0s'
    });
module.exports.genFocusOutline = $080964a413c944e3$var$genFocusOutline;
const $080964a413c944e3$var$genFocusStyle = (token, offset)=>({
        '&:focus-visible': Object.assign({}, $080964a413c944e3$var$genFocusOutline(token, offset))
    });
module.exports.genFocusStyle = $080964a413c944e3$var$genFocusStyle;
const $080964a413c944e3$var$genIconStyle = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, $080964a413c944e3$var$resetIcon()), {
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        })
    });
module.exports.genIconStyle = $080964a413c944e3$var$genIconStyle;
const $080964a413c944e3$var$operationUnit = (token)=>Object.assign(Object.assign({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none'
    }, $080964a413c944e3$var$genFocusStyle(token)), {
        '&:focus, &:hover': {
            color: token.colorLinkHover
        },
        '&:active': {
            color: token.colorLinkActive
        }
    });
module.exports.operationUnit = $080964a413c944e3$var$operationUnit;

});


parcelRegister("gfFx6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd4e43a29cd1950f$var$genPresetColor;

var $yi9zi = parcelRequire("yi9zi");
function $bd4e43a29cd1950f$var$genPresetColor(token, genCss) {
    return $yi9zi.PresetColors.reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), genCss(colorKey, {
            lightColor: lightColor,
            lightBorderColor: lightBorderColor,
            darkColor: darkColor,
            textColor: textColor
        }));
    }, {});
}

});

parcelRegister("iwpir", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $d7bed685d768fdbc$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("gedkv");
var $gofJe = parcelRequire("gofJe");

var $GMiWH = parcelRequire("GMiWH");

var $d7bed685d768fdbc$var$_useToken = $d7bed685d768fdbc$require$_interopRequireDefault((parcelRequire("f5JHL")));
const $d7bed685d768fdbc$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $d7bed685d768fdbc$var$_useToken.default)();
    // Generate style for icons
    return (0, $gofJe.default)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>[
            (0, $GMiWH.genIconStyle)(iconPrefixCls)
        ]);
};
var $d7bed685d768fdbc$var$_default = module.exports.default = $d7bed685d768fdbc$var$useResetIconStyle;

});


parcelRegister("hLaaN", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $cedeb79daaccd37d$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cedeb79daaccd37d$var$React = $cedeb79daaccd37d$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
const $cedeb79daaccd37d$var$fullClone = Object.assign({}, $cedeb79daaccd37d$var$React);
const { useId: $cedeb79daaccd37d$var$useId } = $cedeb79daaccd37d$var$fullClone;
const $cedeb79daaccd37d$var$useEmptyId = ()=>'';
const $cedeb79daaccd37d$var$useThemeKey = typeof $cedeb79daaccd37d$var$useId === 'undefined' ? $cedeb79daaccd37d$var$useEmptyId : $cedeb79daaccd37d$var$useId;
var $cedeb79daaccd37d$var$_default = module.exports.default = $cedeb79daaccd37d$var$useThemeKey;

});


parcelRegister("gxDzm", function(module, exports) {
"use strict";
"use client";

var $ffW2x = parcelRequire("ffW2x");
var $c0ae6c0daabdf431$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0ae6c0daabdf431$var$MotionWrapper;

var $c0ae6c0daabdf431$var$React = $c0ae6c0daabdf431$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
parcelRequire("lsVqZ");
var $7CAII = parcelRequire("7CAII");

var $LXVdy = parcelRequire("LXVdy");
function $c0ae6c0daabdf431$var$MotionWrapper(props) {
    const { children: children } = props;
    const [, token] = (0, $LXVdy.useToken)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $c0ae6c0daabdf431$var$React.useRef(false);
    needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion === false;
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $c0ae6c0daabdf431$var$React.createElement($7CAII.default, {
        motion: motion
    }, children);
    return children;
}

});
parcelRegister("lsVqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa08c3bb9a756866$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Provider", () => (parcelRequire("7CAII")).default);
$parcel$export(module.exports, "CSSMotionList", () => (parcelRequire("iCAxj")).default);

var $6rGMa = parcelRequire("6rGMa");

var $iCAxj = parcelRequire("iCAxj");

var $7CAII = parcelRequire("7CAII");
var $fa08c3bb9a756866$export$2e2bcd8739ae039 = (0, $6rGMa.default);

});
parcelRegister("6rGMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b16721bc3cbe6a0$export$2e2bcd8739ae039);

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $1Esi2 = parcelRequire("1Esi2");

var $giSak = parcelRequire("giSak");

var $cYkhj = parcelRequire("cYkhj");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");

var $7CAII = parcelRequire("7CAII");

var $ejbNV = parcelRequire("ejbNV");

var $fotEt = parcelRequire("fotEt");

var $2hhYs = parcelRequire("2hhYs");

var $iTys6 = parcelRequire("iTys6");

var $3xSFe = parcelRequire("3xSFe");
function $4b16721bc3cbe6a0$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $1Esi2.default)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $jMaZ8.useContext((0, $7CAII.Context)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $jMaZ8.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $jMaZ8.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $cYkhj.default)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $fotEt.default)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $3fkx6.default)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $jMaZ8.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $jMaZ8.useCallback(function(node) {
            nodeRef.current = node;
            (0, $1cfGC.fillRef)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $8u3qN.default)((0, $8u3qN.default)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $iTys6.STATUS_NONE)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $8u3qN.default)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $8u3qN.default)((0, $8u3qN.default)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $8u3qN.default)((0, $8u3qN.default)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $iTys6.STEP_PREPARE)) statusSuffix = 'prepare';
            else if ((0, $2hhYs.isActive)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $iTys6.STEP_START)) statusSuffix = 'start';
            var motionCls = (0, $3xSFe.getTransitionName)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $8u3qN.default)((0, $8u3qN.default)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((0, $3xSFe.getTransitionName)(motionName, status), (0, $eq8kl.default)((0, $eq8kl.default)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $jMaZ8.isValidElement(motionChildren) && (0, $1cfGC.supportRef)(motionChildren)) {
            var originNodeRef = (0, $1cfGC.getNodeRef)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $jMaZ8.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $jMaZ8.createElement((0, $ejbNV.default), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $4b16721bc3cbe6a0$export$2e2bcd8739ae039 = $4b16721bc3cbe6a0$export$e265d52a86a9f199((0, $3xSFe.supportTransition));

});
parcelRegister("7CAII", function(module, exports) {

$parcel$export(module.exports, "Context", () => $58c890ddadc5b53e$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $58c890ddadc5b53e$export$2e2bcd8739ae039);

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");
var $58c890ddadc5b53e$var$_excluded = [
    "children"
];
var $58c890ddadc5b53e$export$841858b892ce1f4c = /*#__PURE__*/ $jMaZ8.createContext({});
function $58c890ddadc5b53e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $4b02Q.default)(_ref, $58c890ddadc5b53e$var$_excluded);
    return /*#__PURE__*/ $jMaZ8.createElement($58c890ddadc5b53e$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}

});

parcelRegister("ejbNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6abff1de45dd0c2$export$2e2bcd8739ae039);

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $jMaZ8 = parcelRequire("jMaZ8");
var $a6abff1de45dd0c2$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $7eK0y.default)(DomWrapper, _React$Component);
    var _super = (0, $fwNdX.default)(DomWrapper);
    function DomWrapper() {
        (0, $klxbl.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $9O7LJ.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($jMaZ8.Component);
var $a6abff1de45dd0c2$export$2e2bcd8739ae039 = $a6abff1de45dd0c2$var$DomWrapper;

});

parcelRegister("fotEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3501924df4ffaa3$export$2e2bcd8739ae039);

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");
parcelRequire("1CVs1");
var $ktS49 = parcelRequire("ktS49");

var $9SyO6 = parcelRequire("9SyO6");

var $adGsd = parcelRequire("adGsd");

var $jMaZ8 = parcelRequire("jMaZ8");

var $iTys6 = parcelRequire("iTys6");

var $iLPlj = parcelRequire("iLPlj");

var $jm8vA = parcelRequire("jm8vA");

var $2hhYs = parcelRequire("2hhYs");
function $b3501924df4ffaa3$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $9SyO6.default)(), _useState2 = (0, $3fkx6.default)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $adGsd.default)((0, $iTys6.STATUS_NONE)), _useSyncState2 = (0, $3fkx6.default)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $9SyO6.default)(null), _useState4 = (0, $3fkx6.default)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $jMaZ8.useRef)(false);
    var deadlineRef = (0, $jMaZ8.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $jMaZ8.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $iTys6.STATUS_NONE));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $ktS49.default)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $iTys6.STATUS_NONE)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $iTys6.STATUS_APPEAR) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $iTys6.STATUS_ENTER) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $iTys6.STATUS_LEAVE) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $iLPlj.default)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $3fkx6.default)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $iTys6.STATUS_APPEAR:
                return (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, (0, $iTys6.STEP_PREPARE), onAppearPrepare), (0, $iTys6.STEP_START), onAppearStart), (0, $iTys6.STEP_ACTIVE), onAppearActive);
            case 0, $iTys6.STATUS_ENTER:
                return (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, (0, $iTys6.STEP_PREPARE), onEnterPrepare), (0, $iTys6.STEP_START), onEnterStart), (0, $iTys6.STEP_ACTIVE), onEnterActive);
            case 0, $iTys6.STATUS_LEAVE:
                return (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, (0, $iTys6.STEP_PREPARE), onLeavePrepare), (0, $iTys6.STEP_START), onLeaveStart), (0, $iTys6.STEP_ACTIVE), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $jMaZ8.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $2hhYs.default)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $iTys6.STEP_PREPARE)) {
            var onPrepare = eventHandlers[0, $iTys6.STEP_PREPARE];
            if (!onPrepare) return 0, $2hhYs.SkipStep;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $iTys6.STEP_ACTIVE) && currentStatus !== (0, $iTys6.STATUS_NONE)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $iTys6.STEP_PREPARED)) updateMotionEndStatus();
        return 0, $2hhYs.DoStep;
    }), _useStepQueue2 = (0, $3fkx6.default)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $2hhYs.isActive)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $jMaZ8.useRef)(null);
    // Update with new status
    (0, $jm8vA.default)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $iTys6.STATUS_APPEAR);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $iTys6.STATUS_ENTER);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $iTys6.STATUS_LEAVE);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $iTys6.STEP_PREPARE])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $iTys6.STATUS_NONE));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $jMaZ8.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $iTys6.STATUS_APPEAR) && !motionAppear || // Cancel enter
        currentStatus === (0, $iTys6.STATUS_ENTER) && !motionEnter || // Cancel leave
        currentStatus === (0, $iTys6.STATUS_LEAVE) && !motionLeave) setStatus((0, $iTys6.STATUS_NONE));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $jMaZ8.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $jMaZ8.useRef(false);
    (0, $jMaZ8.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $iTys6.STATUS_NONE)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $iTys6.STEP_PREPARE] && step === (0, $iTys6.STEP_START)) mergedStyle = (0, $8u3qN.default)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}

});
parcelRegister("adGsd", function(module, exports) {

$parcel$export(module.exports, "default", () => $770c0ccd728815b5$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $ktS49 = parcelRequire("ktS49");
function $770c0ccd728815b5$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $jMaZ8.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $3fkx6.default)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $jMaZ8.useRef(defaultValue);
    var getValue = (0, $ktS49.default)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $ktS49.default)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}

});

parcelRegister("iTys6", function(module, exports) {

$parcel$export(module.exports, "STATUS_NONE", () => $dc18168d54265429$export$de71442bbf2143da);
$parcel$export(module.exports, "STATUS_APPEAR", () => $dc18168d54265429$export$4fc3521687bcacd2);
$parcel$export(module.exports, "STATUS_ENTER", () => $dc18168d54265429$export$5d6af549241fe2e8);
$parcel$export(module.exports, "STATUS_LEAVE", () => $dc18168d54265429$export$59b1c493d29f68e4);
$parcel$export(module.exports, "STEP_NONE", () => $dc18168d54265429$export$40b34dd77d5522bf);
$parcel$export(module.exports, "STEP_PREPARE", () => $dc18168d54265429$export$1b792916a5fac4fc);
$parcel$export(module.exports, "STEP_START", () => $dc18168d54265429$export$9563153dd25a3ce8);
$parcel$export(module.exports, "STEP_ACTIVE", () => $dc18168d54265429$export$e205886172277ec6);
$parcel$export(module.exports, "STEP_ACTIVATED", () => $dc18168d54265429$export$3a846c3d2fac10b8);
$parcel$export(module.exports, "STEP_PREPARED", () => $dc18168d54265429$export$98351fa4e6b4f204);
var $dc18168d54265429$export$de71442bbf2143da = 'none';
var $dc18168d54265429$export$4fc3521687bcacd2 = 'appear';
var $dc18168d54265429$export$5d6af549241fe2e8 = 'enter';
var $dc18168d54265429$export$59b1c493d29f68e4 = 'leave';
var $dc18168d54265429$export$40b34dd77d5522bf = 'none';
var $dc18168d54265429$export$1b792916a5fac4fc = 'prepare';
var $dc18168d54265429$export$9563153dd25a3ce8 = 'start';
var $dc18168d54265429$export$e205886172277ec6 = 'active';
var $dc18168d54265429$export$3a846c3d2fac10b8 = 'end';
var $dc18168d54265429$export$98351fa4e6b4f204 = 'prepared';

});

parcelRegister("iLPlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $daa471658ff6f24d$export$2e2bcd8739ae039);

var $jMaZ8 = parcelRequire("jMaZ8");

var $3xSFe = parcelRequire("3xSFe");
var $daa471658ff6f24d$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $jMaZ8.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $3xSFe.transitionEndName), onInternalMotionEnd);
            element.removeEventListener((0, $3xSFe.animationEndName), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $3xSFe.transitionEndName), onInternalMotionEnd);
            element.addEventListener((0, $3xSFe.animationEndName), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $jMaZ8.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};

});
parcelRegister("3xSFe", function(module, exports) {

$parcel$export(module.exports, "supportTransition", () => $294edb51f660aaf9$export$d28133ed3ad06c8b);
$parcel$export(module.exports, "animationEndName", () => $294edb51f660aaf9$export$760cc9769c51b738);
$parcel$export(module.exports, "transitionEndName", () => $294edb51f660aaf9$export$44baea64b8602e3c);
$parcel$export(module.exports, "getTransitionName", () => $294edb51f660aaf9$export$27c72201b1d09951);

var $1Esi2 = parcelRequire("1Esi2");

var $h9ujZ = parcelRequire("h9ujZ");
// ================= Transition =================
// Event wrapper. Copy from react source code
function $294edb51f660aaf9$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $294edb51f660aaf9$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $294edb51f660aaf9$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $294edb51f660aaf9$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $294edb51f660aaf9$var$vendorPrefixes = $294edb51f660aaf9$export$6e8b350b1a8958a0((0, $h9ujZ.default)(), typeof window !== 'undefined' ? window : {});
var $294edb51f660aaf9$var$style = {};
if ((0, $h9ujZ.default)()) {
    var $294edb51f660aaf9$var$_document$createEleme = document.createElement('div');
    $294edb51f660aaf9$var$style = $294edb51f660aaf9$var$_document$createEleme.style;
}
var $294edb51f660aaf9$var$prefixedEventNames = {};
function $294edb51f660aaf9$export$a032e4f39350c1d8(eventName) {
    if ($294edb51f660aaf9$var$prefixedEventNames[eventName]) return $294edb51f660aaf9$var$prefixedEventNames[eventName];
    var prefixMap = $294edb51f660aaf9$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $294edb51f660aaf9$var$style) {
                $294edb51f660aaf9$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $294edb51f660aaf9$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $294edb51f660aaf9$var$internalAnimationEndName = $294edb51f660aaf9$export$a032e4f39350c1d8('animationend');
var $294edb51f660aaf9$var$internalTransitionEndName = $294edb51f660aaf9$export$a032e4f39350c1d8('transitionend');
var $294edb51f660aaf9$export$d28133ed3ad06c8b = !!($294edb51f660aaf9$var$internalAnimationEndName && $294edb51f660aaf9$var$internalTransitionEndName);
var $294edb51f660aaf9$export$760cc9769c51b738 = $294edb51f660aaf9$var$internalAnimationEndName || 'animationend';
var $294edb51f660aaf9$export$44baea64b8602e3c = $294edb51f660aaf9$var$internalTransitionEndName || 'transitionend';
function $294edb51f660aaf9$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $1Esi2.default)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}

});


parcelRegister("jm8vA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e176abff57fb890e$export$2e2bcd8739ae039);

var $h9ujZ = parcelRequire("h9ujZ");

var $jMaZ8 = parcelRequire("jMaZ8");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $e176abff57fb890e$var$useIsomorphicLayoutEffect = (0, $h9ujZ.default)() ? (0, $jMaZ8.useLayoutEffect) : (0, $jMaZ8.useEffect);
var $e176abff57fb890e$export$2e2bcd8739ae039 = $e176abff57fb890e$var$useIsomorphicLayoutEffect;

});

parcelRegister("2hhYs", function(module, exports) {

$parcel$export(module.exports, "SkipStep", () => $1a8b1c9b63be8e5c$export$c2029bf6cfdbc28a);
$parcel$export(module.exports, "DoStep", () => $1a8b1c9b63be8e5c$export$dbee1e282e8c4830);
$parcel$export(module.exports, "isActive", () => $1a8b1c9b63be8e5c$export$39e04e72f972b885);
$parcel$export(module.exports, "default", () => $1a8b1c9b63be8e5c$export$2e2bcd8739ae039);

var $3fkx6 = parcelRequire("3fkx6");

var $9SyO6 = parcelRequire("9SyO6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $iTys6 = parcelRequire("iTys6");

var $jm8vA = parcelRequire("jm8vA");

var $39IG1 = parcelRequire("39IG1");
var $1a8b1c9b63be8e5c$var$FULL_STEP_QUEUE = [
    (0, $iTys6.STEP_PREPARE),
    (0, $iTys6.STEP_START),
    (0, $iTys6.STEP_ACTIVE),
    (0, $iTys6.STEP_ACTIVATED)
];
var $1a8b1c9b63be8e5c$var$SIMPLE_STEP_QUEUE = [
    (0, $iTys6.STEP_PREPARE),
    (0, $iTys6.STEP_PREPARED)
];
var $1a8b1c9b63be8e5c$export$c2029bf6cfdbc28a = false;
var $1a8b1c9b63be8e5c$export$dbee1e282e8c4830 = true;
function $1a8b1c9b63be8e5c$export$39e04e72f972b885(step) {
    return step === (0, $iTys6.STEP_ACTIVE) || step === (0, $iTys6.STEP_ACTIVATED);
}
var $1a8b1c9b63be8e5c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $9SyO6.default)((0, $iTys6.STEP_NONE)), _useState2 = (0, $3fkx6.default)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $39IG1.default)(), _useNextFrame2 = (0, $3fkx6.default)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $iTys6.STEP_PREPARE), true);
    }
    var STEP_QUEUE = prepareOnly ? $1a8b1c9b63be8e5c$var$SIMPLE_STEP_QUEUE : $1a8b1c9b63be8e5c$var$FULL_STEP_QUEUE;
    (0, $jm8vA.default)(function() {
        if (step !== (0, $iTys6.STEP_NONE) && step !== (0, $iTys6.STEP_ACTIVATED)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $1a8b1c9b63be8e5c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $jMaZ8.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};

});
parcelRegister("39IG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c4de3a2e393ddd$export$2e2bcd8739ae039);

var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");
var $24c4de3a2e393ddd$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $jMaZ8.useRef(null);
    function cancelNextFrame() {
        (0, $aZxvk.default).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $aZxvk.default)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $jMaZ8.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};

});




parcelRegister("iCAxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e81df58a30c96d$export$2e2bcd8739ae039);

var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $8u3qN = parcelRequire("8u3qN");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6rGMa = parcelRequire("6rGMa");

var $gzHIL = parcelRequire("gzHIL");

var $3xSFe = parcelRequire("3xSFe");
var $d8e81df58a30c96d$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $d8e81df58a30c96d$var$_excluded2 = [
    "status"
];
var $d8e81df58a30c96d$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $d8e81df58a30c96d$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6rGMa.default);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $7eK0y.default)(CSSMotionList, _React$Component);
        var _super = (0, $fwNdX.default)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $klxbl.default)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $eq8kl.default)((0, $e4nJa.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $eq8kl.default)((0, $e4nJa.default)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $8u3qN.default)((0, $8u3qN.default)({}, entity), {}, {
                            status: (0, $gzHIL.STATUS_REMOVED)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $gzHIL.STATUS_REMOVED);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $9O7LJ.default)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $4b02Q.default)(_this$props, $d8e81df58a30c96d$var$_excluded);
                    var Component = component || $jMaZ8.Fragment;
                    var motionProps = {};
                    $d8e81df58a30c96d$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $jMaZ8.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $4b02Q.default)(_ref2, $d8e81df58a30c96d$var$_excluded2);
                        var visible = status === (0, $gzHIL.STATUS_ADD) || status === (0, $gzHIL.STATUS_KEEP);
                        return /*#__PURE__*/ $jMaZ8.createElement(CSSMotion, (0, $hH60s.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $gzHIL.parseKeys)(keys);
                    var mixedKeyEntities = (0, $gzHIL.diffKeys)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $gzHIL.STATUS_REMOVED) && entity.status === (0, $gzHIL.STATUS_REMOVE)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($jMaZ8.Component);
    (0, $eq8kl.default)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $d8e81df58a30c96d$export$2e2bcd8739ae039 = $d8e81df58a30c96d$export$fcfc62c1d33d5e2e((0, $3xSFe.supportTransition));

});
parcelRegister("gzHIL", function(module, exports) {

$parcel$export(module.exports, "STATUS_ADD", () => $c111d44dfbff144a$export$3904baa009bc026e);
$parcel$export(module.exports, "STATUS_KEEP", () => $c111d44dfbff144a$export$851162f0adad2cbc);
$parcel$export(module.exports, "STATUS_REMOVE", () => $c111d44dfbff144a$export$c8b3fb08b68cfc85);
$parcel$export(module.exports, "STATUS_REMOVED", () => $c111d44dfbff144a$export$2ac1bd1808d2e43a);
$parcel$export(module.exports, "parseKeys", () => $c111d44dfbff144a$export$84bd7bd42ccc0f72);
$parcel$export(module.exports, "diffKeys", () => $c111d44dfbff144a$export$14527669107aa301);

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");
var $c111d44dfbff144a$export$3904baa009bc026e = 'add';
var $c111d44dfbff144a$export$851162f0adad2cbc = 'keep';
var $c111d44dfbff144a$export$c8b3fb08b68cfc85 = 'remove';
var $c111d44dfbff144a$export$2ac1bd1808d2e43a = 'removed';
function $c111d44dfbff144a$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $1Esi2.default)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $8u3qN.default)((0, $8u3qN.default)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $c111d44dfbff144a$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($c111d44dfbff144a$export$c47fd798e598c85c);
}
function $c111d44dfbff144a$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $c111d44dfbff144a$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $c111d44dfbff144a$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $8u3qN.default)((0, $8u3qN.default)({}, obj), {}, {
                            status: $c111d44dfbff144a$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $8u3qN.default)((0, $8u3qN.default)({}, currentKeyObj), {}, {
                    status: $c111d44dfbff144a$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $8u3qN.default)((0, $8u3qN.default)({}, keyObj), {}, {
            status: $c111d44dfbff144a$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, obj), {}, {
            status: $c111d44dfbff144a$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $c111d44dfbff144a$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $c111d44dfbff144a$export$851162f0adad2cbc;
        });
    });
    return list;
}

});




parcelRegister("h7fTZ", function(module, exports) {
"use strict";
"use client";

var $ffW2x = parcelRequire("ffW2x");
var $c75f6cf14fb6720f$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c75f6cf14fb6720f$var$React = $c75f6cf14fb6720f$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $dw0yD = parcelRequire("dw0yD");
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $c75f6cf14fb6720f$var$PropWarning = /*#__PURE__*/ $c75f6cf14fb6720f$var$React.memo((_ref)=>{
    let { dropdownMatchSelectWidth: dropdownMatchSelectWidth } = _ref;
    const warning = (0, $dw0yD.devUseWarning)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
$c75f6cf14fb6720f$var$PropWarning.displayName = 'PropWarning';
var $c75f6cf14fb6720f$var$_default = module.exports.default = $c75f6cf14fb6720f$var$PropWarning;

});

parcelRegister("3vkfI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $LXVdy.useResetIconStyle;
    }
});

var $LXVdy = parcelRequire("LXVdy");

});

parcelRegister("39NP9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $LXVdy = parcelRequire("LXVdy");
/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $24c8dc5da7bed619$var$useCSSVarCls = (prefixCls)=>{
    const [, , , , cssVar] = (0, $LXVdy.useToken)();
    return cssVar ? `${prefixCls}-css-var` : '';
};
var $24c8dc5da7bed619$var$_default = module.exports.default = $24c8dc5da7bed619$var$useCSSVarCls;

});

parcelRegister("jRzZI", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $e75ee349397b2aa9$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75ee349397b2aa9$var$_react = $e75ee349397b2aa9$require$_interopRequireDefault((parcelRequire("jMaZ8")));

var $e75ee349397b2aa9$var$_SizeContext = $e75ee349397b2aa9$require$_interopRequireDefault((parcelRequire("7hz7I")));
const $e75ee349397b2aa9$var$useSize = (customSize)=>{
    const size = $e75ee349397b2aa9$var$_react.default.useContext($e75ee349397b2aa9$var$_SizeContext.default);
    const mergedSize = $e75ee349397b2aa9$var$_react.default.useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize !== null && customSize !== void 0 ? customSize : size;
        if (customSize instanceof Function) return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $e75ee349397b2aa9$var$_default = module.exports.default = $e75ee349397b2aa9$var$useSize;

});

parcelRegister("cv4PZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $919c21e58839082f$var$omit;
function $919c21e58839082f$var$omit(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

});

parcelRegister("jR3c7", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $e74571e76d68b842$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $e74571e76d68b842$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e74571e76d68b842$var$useForm;

var $e74571e76d68b842$var$React = $e74571e76d68b842$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
parcelRequire("6wVix");
var $4sljH = parcelRequire("4sljH");

var $26es5 = parcelRequire("26es5");

var $e74571e76d68b842$var$_scrollIntoViewIfNeeded = $e74571e76d68b842$require$_interopRequireDefault((parcelRequire("7PWCI")));

var $kKxYM = parcelRequire("kKxYM");
function $e74571e76d68b842$var$toNamePathStr(name) {
    const namePath = (0, $kKxYM.toArray)(name);
    return namePath.join('_');
}
function $e74571e76d68b842$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $26es5.getDOM)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $kKxYM.getFieldId)((0, $kKxYM.toArray)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $e74571e76d68b842$var$useForm(form) {
    const [rcForm] = (0, $4sljH.default)();
    const itemsRef = $e74571e76d68b842$var$React.useRef({});
    const wrapForm = $e74571e76d68b842$var$React.useMemo(()=>form !== null && form !== void 0 ? form : Object.assign(Object.assign({}, rcForm), {
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $e74571e76d68b842$var$toNamePathStr(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: function(name) {
                let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const node = $e74571e76d68b842$var$getFieldDOMNode(name, wrapForm);
                if (node) (0, $e74571e76d68b842$var$_scrollIntoViewIfNeeded.default)(node, Object.assign({
                    scrollMode: 'if-needed',
                    block: 'nearest'
                }, options));
            },
            focusField: (name)=>{
                var _a;
                const node = $e74571e76d68b842$var$getFieldDOMNode(name, wrapForm);
                if (node) (_a = node.focus) === null || _a === void 0 || _a.call(node);
            },
            getFieldInstance: (name)=>{
                const namePathStr = $e74571e76d68b842$var$toNamePathStr(name);
                return itemsRef.current[namePathStr];
            }
        }), [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}

});
parcelRegister("26es5", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $18775a3350b830ef$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18775a3350b830ef$var$findDOMNode;
module.exports.getDOM = $18775a3350b830ef$var$getDOM;
module.exports.isDOM = $18775a3350b830ef$var$isDOM;

var $18775a3350b830ef$var$_typeof2 = $18775a3350b830ef$require$_interopRequireDefault((parcelRequire("cEcQP")));

var $18775a3350b830ef$var$_react = $18775a3350b830ef$require$_interopRequireDefault((parcelRequire("jMaZ8")));

var $18775a3350b830ef$var$_reactDom = $18775a3350b830ef$require$_interopRequireDefault((parcelRequire("6UWRi")));
function $18775a3350b830ef$var$isDOM(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */ function $18775a3350b830ef$var$getDOM(node) {
    if (node && (0, $18775a3350b830ef$var$_typeof2.default)(node) === 'object' && $18775a3350b830ef$var$isDOM(node.nativeElement)) return node.nativeElement;
    if ($18775a3350b830ef$var$isDOM(node)) return node;
    return null;
}
/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */ function $18775a3350b830ef$var$findDOMNode(node) {
    var domNode = $18775a3350b830ef$var$getDOM(node);
    if (domNode) return domNode;
    if (node instanceof $18775a3350b830ef$var$_react.default.Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = $18775a3350b830ef$var$_reactDom.default.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call($18775a3350b830ef$var$_reactDom.default, node);
    }
    return null;
}

});

parcelRegister("kKxYM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFieldId = $f1b2761a71191bfa$var$getFieldId;
module.exports.getStatus = $f1b2761a71191bfa$var$getStatus;
module.exports.toArray = $f1b2761a71191bfa$var$toArray;
// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $f1b2761a71191bfa$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $f1b2761a71191bfa$var$defaultItemNamePrefixCls = 'form_item';
function $f1b2761a71191bfa$var$toArray(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $f1b2761a71191bfa$var$getFieldId(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $f1b2761a71191bfa$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$f1b2761a71191bfa$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
/**
 * Get merged status by meta or passed `validateStatus`.
 */ function $f1b2761a71191bfa$var$getStatus(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}

});


parcelRegister("5oPNh", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $3ee75ed6e6f81a0b$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ee75ed6e6f81a0b$var$useFormWarning;

var $3ee75ed6e6f81a0b$var$React = $3ee75ed6e6f81a0b$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $dw0yD = parcelRequire("dw0yD");
const $3ee75ed6e6f81a0b$var$names = {};
function $3ee75ed6e6f81a0b$var$useFormWarning(_ref) {
    let { name: name } = _ref;
    const warning = (0, $dw0yD.devUseWarning)('Form');
    $3ee75ed6e6f81a0b$var$React.useEffect(()=>{
        if (name) {
            $3ee75ed6e6f81a0b$var$names[name] = ($3ee75ed6e6f81a0b$var$names[name] || 0) + 1;
            warning($3ee75ed6e6f81a0b$var$names[name] <= 1, 'usage', 'There exist multiple Form with same `name`.');
            return ()=>{
                $3ee75ed6e6f81a0b$var$names[name] -= 1;
            };
        }
    }, [
        name
    ]);
}

});

parcelRegister("fU12E", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $b93ce4ddbcdfc2c1$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepareToken = module.exports.prepareComponentToken = module.exports.default = void 0;
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

var $GMiWH = parcelRequire("GMiWH");

var $dGUg4 = parcelRequire("dGUg4");

var $LXVdy = parcelRequire("LXVdy");

var $b93ce4ddbcdfc2c1$var$_explain = $b93ce4ddbcdfc2c1$require$_interopRequireDefault((parcelRequire("atkmv")));
const $b93ce4ddbcdfc2c1$var$resetForm = (token)=>({
        legend: {
            display: 'block',
            width: '100%',
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: 'inherit',
            border: 0,
            borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: 'border-box'
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: 'normal'
        },
        'input[type="file"]': {
            display: 'block'
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: 'block',
            width: '100%'
        },
        // Make multiple select elements height not fixed
        'select[multiple], select[size]': {
            height: 'auto'
        },
        // Focus for file, radio, and checkbox
        [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $4g3I0.unit)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: 'block',
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $b93ce4ddbcdfc2c1$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $b93ce4ddbcdfc2c1$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [token.componentCls]: Object.assign(Object.assign(Object.assign({}, (0, $GMiWH.resetComponent)(token)), $b93ce4ddbcdfc2c1$var$resetForm(token)), {
            [`${componentCls}-text`]: {
                display: 'inline-block',
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            '&-small': Object.assign({}, $b93ce4ddbcdfc2c1$var$genFormSize(token, token.controlHeightSM)),
            '&-large': Object.assign({}, $b93ce4ddbcdfc2c1$var$genFormSize(token, token.controlHeightLG))
        })
    };
};
const $b93ce4ddbcdfc2c1$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, componentCls: componentCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    return {
        [formItemCls]: Object.assign(Object.assign({}, (0, $GMiWH.resetComponent)(token)), {
            marginBottom: itemMarginBottom,
            verticalAlign: 'top',
            '&-with-help': {
                transition: 'none'
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: 'none'
            },
            '&-has-warning': {
                [`${formItemCls}-split`]: {
                    color: token.colorError
                }
            },
            '&-has-error': {
                [`${formItemCls}-split`]: {
                    color: token.colorWarning
                }
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textAlign: 'end',
                verticalAlign: 'middle',
                '&-left': {
                    textAlign: 'start'
                },
                '&-wrap': {
                    overflow: 'unset',
                    lineHeight: token.lineHeight,
                    whiteSpace: 'unset'
                },
                '> label': {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    maxWidth: '100%',
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: 'top'
                    },
                    // Required mark
                    [`&${formItemCls}-required:not(${formItemCls}-required-mark-optional)::before`]: {
                        display: 'inline-block',
                        marginInlineEnd: token.marginXXS,
                        color: labelRequiredMarkColor,
                        fontSize: token.fontSize,
                        fontFamily: 'SimSun, sans-serif',
                        lineHeight: 1,
                        content: '"*"',
                        [`${componentCls}-hide-required-mark &`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: 'inline-block',
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`${componentCls}-hide-required-mark &`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: 'help',
                        writingMode: 'horizontal-tb',
                        marginInlineStart: token.marginXXS
                    },
                    '&::after': {
                        content: '":"',
                        position: 'relative',
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                ['--ant-display']: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: '100%'
                },
                '&-input': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: token.controlHeight,
                    '&-content': {
                        flex: 'auto',
                        maxWidth: '100%'
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                '&-additional': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '&-explain, &-extra': {
                    clear: 'both',
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                '&-explain-connected': {
                    width: '100%'
                },
                '&-extra': {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                '&-explain': {
                    '&-error': {
                        color: token.colorError
                    },
                    '&-warning': {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: 'auto',
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: 'center',
                visibility: 'visible',
                animationName: $dGUg4.zoomIn,
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: 'none',
                '&-success': {
                    color: token.colorSuccess
                },
                '&-error': {
                    color: token.colorError
                },
                '&-warning': {
                    color: token.colorWarning
                },
                '&-validating': {
                    color: token.colorPrimary
                }
            }
        })
    };
};
const $b93ce4ddbcdfc2c1$var$genHorizontalStyle = (token, className)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [`${className}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: '1 1 0',
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: 'unset'
                }
            }
        }
    };
};
const $b93ce4ddbcdfc2c1$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: 'flex',
            flexWrap: 'wrap',
            [formItemCls]: {
                flex: 'none',
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                '&-row': {
                    flexWrap: 'nowrap'
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                [`> ${formItemCls}-label`]: {
                    flex: 'none'
                },
                [`${componentCls}-text`]: {
                    display: 'inline-block'
                },
                [`${formItemCls}-has-feedback`]: {
                    display: 'inline-block'
                }
            }
        }
    };
};
const $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: 'initial',
        textAlign: 'start',
        '> label': {
            margin: 0,
            '&::after': {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: 'hidden'
            }
        }
    });
const $b93ce4ddbcdfc2c1$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: 'wrap',
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: '0 0 100%',
                        maxWidth: '100%'
                    }
                }
            }
        }
    };
};
const $b93ce4ddbcdfc2c1$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                [`${formItemCls}-row`]: {
                    flexDirection: 'column'
                },
                [`${formItemCls}-label > label`]: {
                    height: 'auto'
                },
                [`${formItemCls}-control`]: {
                    width: '100%'
                },
                [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenXSMax)})`]: [
            $b93ce4ddbcdfc2c1$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $b93ce4ddbcdfc2c1$var$genItemVerticalStyle = (token)=>{
    const { formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: 'column'
            },
            [`${formItemCls}-label > label`]: {
                height: 'auto'
            },
            [`${formItemCls}-control`]: {
                width: '100%'
            }
        },
        [`${formItemCls}-vertical ${formItemCls}-label,
      ${antCls}-col-24${formItemCls}-label,
      ${antCls}-col-xl-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token),
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenXSMax)})`]: [
            $b93ce4ddbcdfc2c1$var$makeVerticalLayout(token),
            {
                [formItemCls]: {
                    [`${antCls}-col-xs-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
                }
            }
        ],
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenSMMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-sm-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenMDMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-md-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenLGMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-lg-24${formItemCls}-label`]: $b93ce4ddbcdfc2c1$var$makeVerticalLayoutLabel(token)
            }
        }
    };
};
// ============================== Export ==============================
const $b93ce4ddbcdfc2c1$var$prepareComponentToken = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
module.exports.prepareComponentToken = $b93ce4ddbcdfc2c1$var$prepareComponentToken;
const $b93ce4ddbcdfc2c1$var$prepareToken = (token, rootPrefixCls)=>{
    const formToken = (0, $LXVdy.mergeToken)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
module.exports.prepareToken = $b93ce4ddbcdfc2c1$var$prepareToken;
var $b93ce4ddbcdfc2c1$var$_default = module.exports.default = (0, $LXVdy.genStyleHooks)('Form', (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const formToken = $b93ce4ddbcdfc2c1$var$prepareToken(token, rootPrefixCls);
    return [
        $b93ce4ddbcdfc2c1$var$genFormStyle(formToken),
        $b93ce4ddbcdfc2c1$var$genFormItemStyle(formToken),
        (0, $b93ce4ddbcdfc2c1$var$_explain.default)(formToken),
        $b93ce4ddbcdfc2c1$var$genHorizontalStyle(formToken, formToken.componentCls),
        $b93ce4ddbcdfc2c1$var$genHorizontalStyle(formToken, formToken.formItemCls),
        $b93ce4ddbcdfc2c1$var$genInlineStyle(formToken),
        $b93ce4ddbcdfc2c1$var$genVerticalStyle(formToken),
        $b93ce4ddbcdfc2c1$var$genItemVerticalStyle(formToken),
        (0, $dGUg4.genCollapseMotion)(formToken),
        $dGUg4.zoomIn
    ];
}, $b93ce4ddbcdfc2c1$var$prepareComponentToken, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});

});
parcelRegister("dGUg4", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $9f7ad64e783aab2f$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "fadeIn", {
    enumerable: true,
    get: function() {
        return $eGp8f.fadeIn;
    }
});
Object.defineProperty(module.exports, "fadeOut", {
    enumerable: true,
    get: function() {
        return $eGp8f.fadeOut;
    }
});
Object.defineProperty(module.exports, "genCollapseMotion", {
    enumerable: true,
    get: function() {
        return $9f7ad64e783aab2f$var$_collapse.default;
    }
});
Object.defineProperty(module.exports, "initFadeMotion", {
    enumerable: true,
    get: function() {
        return $eGp8f.initFadeMotion;
    }
});
Object.defineProperty(module.exports, "initMoveMotion", {
    enumerable: true,
    get: function() {
        return $j57Y0.initMoveMotion;
    }
});
Object.defineProperty(module.exports, "initSlideMotion", {
    enumerable: true,
    get: function() {
        return $4Yfp9.initSlideMotion;
    }
});
Object.defineProperty(module.exports, "initZoomMotion", {
    enumerable: true,
    get: function() {
        return $hhZzA.initZoomMotion;
    }
});
Object.defineProperty(module.exports, "moveDownIn", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveDownIn;
    }
});
Object.defineProperty(module.exports, "moveDownOut", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveDownOut;
    }
});
Object.defineProperty(module.exports, "moveLeftIn", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveLeftIn;
    }
});
Object.defineProperty(module.exports, "moveLeftOut", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveLeftOut;
    }
});
Object.defineProperty(module.exports, "moveRightIn", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveRightIn;
    }
});
Object.defineProperty(module.exports, "moveRightOut", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveRightOut;
    }
});
Object.defineProperty(module.exports, "moveUpIn", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveUpIn;
    }
});
Object.defineProperty(module.exports, "moveUpOut", {
    enumerable: true,
    get: function() {
        return $j57Y0.moveUpOut;
    }
});
Object.defineProperty(module.exports, "slideDownIn", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideDownIn;
    }
});
Object.defineProperty(module.exports, "slideDownOut", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideDownOut;
    }
});
Object.defineProperty(module.exports, "slideLeftIn", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideLeftIn;
    }
});
Object.defineProperty(module.exports, "slideLeftOut", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideLeftOut;
    }
});
Object.defineProperty(module.exports, "slideRightIn", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideRightIn;
    }
});
Object.defineProperty(module.exports, "slideRightOut", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideRightOut;
    }
});
Object.defineProperty(module.exports, "slideUpIn", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideUpIn;
    }
});
Object.defineProperty(module.exports, "slideUpOut", {
    enumerable: true,
    get: function() {
        return $4Yfp9.slideUpOut;
    }
});
Object.defineProperty(module.exports, "zoomBigIn", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomBigIn;
    }
});
Object.defineProperty(module.exports, "zoomBigOut", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomBigOut;
    }
});
Object.defineProperty(module.exports, "zoomDownIn", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomDownIn;
    }
});
Object.defineProperty(module.exports, "zoomDownOut", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomDownOut;
    }
});
Object.defineProperty(module.exports, "zoomIn", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomIn;
    }
});
Object.defineProperty(module.exports, "zoomLeftIn", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomLeftIn;
    }
});
Object.defineProperty(module.exports, "zoomLeftOut", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomLeftOut;
    }
});
Object.defineProperty(module.exports, "zoomOut", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomOut;
    }
});
Object.defineProperty(module.exports, "zoomRightIn", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomRightIn;
    }
});
Object.defineProperty(module.exports, "zoomRightOut", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomRightOut;
    }
});
Object.defineProperty(module.exports, "zoomUpIn", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomUpIn;
    }
});
Object.defineProperty(module.exports, "zoomUpOut", {
    enumerable: true,
    get: function() {
        return $hhZzA.zoomUpOut;
    }
});

var $9f7ad64e783aab2f$var$_collapse = $9f7ad64e783aab2f$require$_interopRequireDefault((parcelRequire("kPLIY")));

var $eGp8f = parcelRequire("eGp8f");

var $j57Y0 = parcelRequire("j57Y0");

var $4Yfp9 = parcelRequire("4Yfp9");

var $hhZzA = parcelRequire("hhZzA");

});
parcelRegister("kPLIY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f2ad971d2912ec82$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $f2ad971d2912ec82$var$_default = module.exports.default = $f2ad971d2912ec82$var$genCollapseMotion;

});

parcelRegister("eGp8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initFadeMotion = module.exports.fadeOut = module.exports.fadeIn = void 0;
parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

var $jxHKw = parcelRequire("jxHKw");
const $ab087ba1378c7a4a$var$fadeIn = module.exports.fadeIn = new $kB90R.default('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $ab087ba1378c7a4a$var$fadeOut = module.exports.fadeOut = new $kB90R.default('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $ab087ba1378c7a4a$var$initFadeMotion = function(token) {
    let sameLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $jxHKw.initMotion)(motionCls, $ab087ba1378c7a4a$var$fadeIn, $ab087ba1378c7a4a$var$fadeOut, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};
module.exports.initFadeMotion = $ab087ba1378c7a4a$var$initFadeMotion;

});
parcelRegister("jxHKw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initMotion = void 0;
const $e3a309153b89eba2$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $e3a309153b89eba2$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $e3a309153b89eba2$var$initMotion = function(motionCls, inKeyframes, outKeyframes, duration) {
    let sameLevel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, $e3a309153b89eba2$var$initMotionCommon(duration)), {
            animationPlayState: 'paused'
        }),
        [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, $e3a309153b89eba2$var$initMotionCommonLeave(duration)), {
            animationPlayState: 'paused'
        }),
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};
module.exports.initMotion = $e3a309153b89eba2$var$initMotion;

});


parcelRegister("j57Y0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.moveUpOut = module.exports.moveUpIn = module.exports.moveRightOut = module.exports.moveRightIn = module.exports.moveLeftOut = module.exports.moveLeftIn = module.exports.moveDownOut = module.exports.moveDownIn = module.exports.initMoveMotion = void 0;
parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

var $jxHKw = parcelRequire("jxHKw");
const $de44aa02953a11db$var$moveDownIn = module.exports.moveDownIn = new $kB90R.default('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $de44aa02953a11db$var$moveDownOut = module.exports.moveDownOut = new $kB90R.default('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $de44aa02953a11db$var$moveLeftIn = module.exports.moveLeftIn = new $kB90R.default('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $de44aa02953a11db$var$moveLeftOut = module.exports.moveLeftOut = new $kB90R.default('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $de44aa02953a11db$var$moveRightIn = module.exports.moveRightIn = new $kB90R.default('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $de44aa02953a11db$var$moveRightOut = module.exports.moveRightOut = new $kB90R.default('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $de44aa02953a11db$var$moveUpIn = module.exports.moveUpIn = new $kB90R.default('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $de44aa02953a11db$var$moveUpOut = module.exports.moveUpOut = new $kB90R.default('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $de44aa02953a11db$var$moveMotion = {
    'move-up': {
        inKeyframes: $de44aa02953a11db$var$moveUpIn,
        outKeyframes: $de44aa02953a11db$var$moveUpOut
    },
    'move-down': {
        inKeyframes: $de44aa02953a11db$var$moveDownIn,
        outKeyframes: $de44aa02953a11db$var$moveDownOut
    },
    'move-left': {
        inKeyframes: $de44aa02953a11db$var$moveLeftIn,
        outKeyframes: $de44aa02953a11db$var$moveLeftOut
    },
    'move-right': {
        inKeyframes: $de44aa02953a11db$var$moveRightIn,
        outKeyframes: $de44aa02953a11db$var$moveRightOut
    }
};
const $de44aa02953a11db$var$initMoveMotion = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $de44aa02953a11db$var$moveMotion[motionName];
    return [
        (0, $jxHKw.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};
module.exports.initMoveMotion = $de44aa02953a11db$var$initMoveMotion;

});

parcelRegister("4Yfp9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slideUpOut = module.exports.slideUpIn = module.exports.slideRightOut = module.exports.slideRightIn = module.exports.slideLeftOut = module.exports.slideLeftIn = module.exports.slideDownOut = module.exports.slideDownIn = module.exports.initSlideMotion = void 0;
parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

var $jxHKw = parcelRequire("jxHKw");
const $39e8b70bf6916be0$var$slideUpIn = module.exports.slideUpIn = new $kB90R.default('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $39e8b70bf6916be0$var$slideUpOut = module.exports.slideUpOut = new $kB90R.default('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $39e8b70bf6916be0$var$slideDownIn = module.exports.slideDownIn = new $kB90R.default('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $39e8b70bf6916be0$var$slideDownOut = module.exports.slideDownOut = new $kB90R.default('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $39e8b70bf6916be0$var$slideLeftIn = module.exports.slideLeftIn = new $kB90R.default('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $39e8b70bf6916be0$var$slideLeftOut = module.exports.slideLeftOut = new $kB90R.default('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $39e8b70bf6916be0$var$slideRightIn = module.exports.slideRightIn = new $kB90R.default('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $39e8b70bf6916be0$var$slideRightOut = module.exports.slideRightOut = new $kB90R.default('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $39e8b70bf6916be0$var$slideMotion = {
    'slide-up': {
        inKeyframes: $39e8b70bf6916be0$var$slideUpIn,
        outKeyframes: $39e8b70bf6916be0$var$slideUpOut
    },
    'slide-down': {
        inKeyframes: $39e8b70bf6916be0$var$slideDownIn,
        outKeyframes: $39e8b70bf6916be0$var$slideDownOut
    },
    'slide-left': {
        inKeyframes: $39e8b70bf6916be0$var$slideLeftIn,
        outKeyframes: $39e8b70bf6916be0$var$slideLeftOut
    },
    'slide-right': {
        inKeyframes: $39e8b70bf6916be0$var$slideRightIn,
        outKeyframes: $39e8b70bf6916be0$var$slideRightOut
    }
};
const $39e8b70bf6916be0$var$initSlideMotion = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $39e8b70bf6916be0$var$slideMotion[motionName];
    return [
        (0, $jxHKw.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};
module.exports.initSlideMotion = $39e8b70bf6916be0$var$initSlideMotion;

});

parcelRegister("hhZzA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zoomUpOut = module.exports.zoomUpIn = module.exports.zoomRightOut = module.exports.zoomRightIn = module.exports.zoomOut = module.exports.zoomLeftOut = module.exports.zoomLeftIn = module.exports.zoomIn = module.exports.zoomDownOut = module.exports.zoomDownIn = module.exports.zoomBigOut = module.exports.zoomBigIn = module.exports.initZoomMotion = void 0;
parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

var $jxHKw = parcelRequire("jxHKw");
const $c963c94b1c91bd8e$var$zoomIn = module.exports.zoomIn = new $kB90R.default('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $c963c94b1c91bd8e$var$zoomOut = module.exports.zoomOut = new $kB90R.default('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $c963c94b1c91bd8e$var$zoomBigIn = module.exports.zoomBigIn = new $kB90R.default('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $c963c94b1c91bd8e$var$zoomBigOut = module.exports.zoomBigOut = new $kB90R.default('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $c963c94b1c91bd8e$var$zoomUpIn = module.exports.zoomUpIn = new $kB90R.default('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $c963c94b1c91bd8e$var$zoomUpOut = module.exports.zoomUpOut = new $kB90R.default('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $c963c94b1c91bd8e$var$zoomLeftIn = module.exports.zoomLeftIn = new $kB90R.default('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $c963c94b1c91bd8e$var$zoomLeftOut = module.exports.zoomLeftOut = new $kB90R.default('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $c963c94b1c91bd8e$var$zoomRightIn = module.exports.zoomRightIn = new $kB90R.default('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $c963c94b1c91bd8e$var$zoomRightOut = module.exports.zoomRightOut = new $kB90R.default('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $c963c94b1c91bd8e$var$zoomDownIn = module.exports.zoomDownIn = new $kB90R.default('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $c963c94b1c91bd8e$var$zoomDownOut = module.exports.zoomDownOut = new $kB90R.default('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $c963c94b1c91bd8e$var$zoomMotion = {
    zoom: {
        inKeyframes: $c963c94b1c91bd8e$var$zoomIn,
        outKeyframes: $c963c94b1c91bd8e$var$zoomOut
    },
    'zoom-big': {
        inKeyframes: $c963c94b1c91bd8e$var$zoomBigIn,
        outKeyframes: $c963c94b1c91bd8e$var$zoomBigOut
    },
    'zoom-big-fast': {
        inKeyframes: $c963c94b1c91bd8e$var$zoomBigIn,
        outKeyframes: $c963c94b1c91bd8e$var$zoomBigOut
    },
    'zoom-left': {
        inKeyframes: $c963c94b1c91bd8e$var$zoomLeftIn,
        outKeyframes: $c963c94b1c91bd8e$var$zoomLeftOut
    },
    'zoom-right': {
        inKeyframes: $c963c94b1c91bd8e$var$zoomRightIn,
        outKeyframes: $c963c94b1c91bd8e$var$zoomRightOut
    },
    'zoom-up': {
        inKeyframes: $c963c94b1c91bd8e$var$zoomUpIn,
        outKeyframes: $c963c94b1c91bd8e$var$zoomUpOut
    },
    'zoom-down': {
        inKeyframes: $c963c94b1c91bd8e$var$zoomDownIn,
        outKeyframes: $c963c94b1c91bd8e$var$zoomDownOut
    }
};
const $c963c94b1c91bd8e$var$initZoomMotion = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $c963c94b1c91bd8e$var$zoomMotion[motionName];
    return [
        (0, $jxHKw.initMotion)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};
module.exports.initZoomMotion = $c963c94b1c91bd8e$var$initZoomMotion;

});


parcelRegister("atkmv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $79fc684326cee2bc$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
            '&-appear, &-enter': {
                opacity: 0,
                '&-active': {
                    opacity: 1
                }
            },
            '&-leave': {
                opacity: 1,
                '&-active': {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationFast} ${token.motionEaseInOut},
                     opacity ${token.motionDurationFast} ${token.motionEaseInOut},
                     transform ${token.motionDurationFast} ${token.motionEaseInOut} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    '&-active': {
                        transform: 'translateY(0)',
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $79fc684326cee2bc$var$_default = module.exports.default = $79fc684326cee2bc$var$genFormValidateMotionStyle;

});


parcelRegister("kO5DT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f25cdaa4b9991e0a$var$inspect;

var $f25cdaa4b9991e0a$var$_nodejsCustomInspectSymbol = $f25cdaa4b9991e0a$var$_interopRequireDefault((parcelRequire("fCFWU")));
function $f25cdaa4b9991e0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f25cdaa4b9991e0a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f25cdaa4b9991e0a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f25cdaa4b9991e0a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f25cdaa4b9991e0a$var$_typeof(obj);
}
var $f25cdaa4b9991e0a$var$MAX_ARRAY_LENGTH = 10;
var $f25cdaa4b9991e0a$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $f25cdaa4b9991e0a$var$inspect(value) {
    return $f25cdaa4b9991e0a$var$formatValue(value, []);
}
function $f25cdaa4b9991e0a$var$formatValue(value, seenValues) {
    switch($f25cdaa4b9991e0a$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $f25cdaa4b9991e0a$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $f25cdaa4b9991e0a$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $f25cdaa4b9991e0a$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $f25cdaa4b9991e0a$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $f25cdaa4b9991e0a$var$formatArray(value, seenValues);
    return $f25cdaa4b9991e0a$var$formatObject(value, seenValues);
}
function $f25cdaa4b9991e0a$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $f25cdaa4b9991e0a$var$MAX_RECURSIVE_DEPTH) return '[' + $f25cdaa4b9991e0a$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $f25cdaa4b9991e0a$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $f25cdaa4b9991e0a$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $f25cdaa4b9991e0a$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($f25cdaa4b9991e0a$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($f25cdaa4b9991e0a$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $f25cdaa4b9991e0a$var$getCustomFn(object) {
    var customInspectFn = object[String($f25cdaa4b9991e0a$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $f25cdaa4b9991e0a$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("fCFWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $b5faf1ddaa73281a$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $b5faf1ddaa73281a$var$_default = $b5faf1ddaa73281a$var$nodejsCustomInspectSymbol;
module.exports.default = $b5faf1ddaa73281a$var$_default;

});


parcelRegister("hXIc6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d13a3a69e877124f$var$defineInspect;

var $d13a3a69e877124f$var$_invariant = $d13a3a69e877124f$var$_interopRequireDefault((parcelRequire("4mJjW")));

var $d13a3a69e877124f$var$_nodejsCustomInspectSymbol = $d13a3a69e877124f$var$_interopRequireDefault((parcelRequire("fCFWU")));
function $d13a3a69e877124f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */ function $d13a3a69e877124f$var$defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $d13a3a69e877124f$var$_invariant.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if ($d13a3a69e877124f$var$_nodejsCustomInspectSymbol.default) classObject.prototype[$d13a3a69e877124f$var$_nodejsCustomInspectSymbol.default] = fn;
}

});
parcelRegister("4mJjW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32dc5f3c3832b403$var$invariant;
function $32dc5f3c3832b403$var$invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});


parcelRegister("lTpS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff02cd8b728822d1$export$2e2bcd8739ae039);
/* global window */ 
var $9I6rE = parcelRequire("9I6rE");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $9I6rE.default)(root);
var $ff02cd8b728822d1$export$2e2bcd8739ae039 = result;

});
parcelRegister("9I6rE", function(module, exports) {

$parcel$export(module.exports, "default", () => $711d38f7321d7769$export$2e2bcd8739ae039);
function $711d38f7321d7769$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("i4vhP", function(module, exports) {
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $d280de9601b01996$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d280de9601b01996$var$_react = $d280de9601b01996$require$_interopRequireDefault((parcelRequire("jMaZ8")));

var $d280de9601b01996$var$_CloseCircleFilled = $d280de9601b01996$require$_interopRequireDefault((parcelRequire("dwlC2")));
const $d280de9601b01996$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ $d280de9601b01996$var$_react.default.createElement($d280de9601b01996$var$_CloseCircleFilled.default, null)
    };
    return mergedAllowClear;
};
var $d280de9601b01996$var$_default = module.exports.default = $d280de9601b01996$var$getAllowClear;

});
parcelRegister("dwlC2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

const $9d7f0750ff6cf236$var$_CloseCircleFilled = $9d7f0750ff6cf236$var$_interopRequireDefault((parcelRequire("lDq0l")));
function $9d7f0750ff6cf236$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
const $9d7f0750ff6cf236$var$_default = $9d7f0750ff6cf236$var$_CloseCircleFilled;
module.exports.default = $9d7f0750ff6cf236$var$_default;
module.exports = $9d7f0750ff6cf236$var$_default;

});
parcelRegister("lDq0l", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $fc01696fa51d03c7$require$_interopRequireWildcard = $ffW2x.default;

var $4d0me = parcelRequire("4d0me");
var $fc01696fa51d03c7$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc01696fa51d03c7$var$_extends2 = $fc01696fa51d03c7$require$_interopRequireDefault((parcelRequire("99K9J")));

var $fc01696fa51d03c7$var$React = $fc01696fa51d03c7$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $fc01696fa51d03c7$var$_CloseCircleFilled = $fc01696fa51d03c7$require$_interopRequireDefault((parcelRequire("1iF9v")));

var $fc01696fa51d03c7$var$_AntdIcon = $fc01696fa51d03c7$require$_interopRequireDefault((parcelRequire("e5UFi")));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $fc01696fa51d03c7$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $fc01696fa51d03c7$var$React.createElement($fc01696fa51d03c7$var$_AntdIcon.default, (0, $fc01696fa51d03c7$var$_extends2.default)({}, props, {
        ref: ref,
        icon: $fc01696fa51d03c7$var$_CloseCircleFilled.default
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ var $fc01696fa51d03c7$var$RefIcon = /*#__PURE__*/ $fc01696fa51d03c7$var$React.forwardRef($fc01696fa51d03c7$var$CloseCircleFilled);
$fc01696fa51d03c7$var$RefIcon.displayName = 'CloseCircleFilled';
var $fc01696fa51d03c7$var$_default = module.exports.default = $fc01696fa51d03c7$var$RefIcon;

});
parcelRegister("99K9J", function(module, exports) {
function $6aa8c1f167513810$var$_extends() {
    return module.exports = $6aa8c1f167513810$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6aa8c1f167513810$var$_extends.apply(null, arguments);
}
module.exports = $6aa8c1f167513810$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1iF9v", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0f2764df62761b7a$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
module.exports.default = $0f2764df62761b7a$var$CloseCircleFilled;

});

parcelRegister("e5UFi", function(module, exports) {
"use strict";
'use client';

var $4d0me = parcelRequire("4d0me");
var $a42d7cd6f5e2d798$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $a42d7cd6f5e2d798$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a42d7cd6f5e2d798$var$_extends2 = $a42d7cd6f5e2d798$require$_interopRequireDefault((parcelRequire("99K9J")));

var $a42d7cd6f5e2d798$var$_slicedToArray2 = $a42d7cd6f5e2d798$require$_interopRequireDefault((parcelRequire("fEEQL")));

var $a42d7cd6f5e2d798$var$_defineProperty2 = $a42d7cd6f5e2d798$require$_interopRequireDefault((parcelRequire("17meZ")));

var $a42d7cd6f5e2d798$var$_objectWithoutProperties2 = $a42d7cd6f5e2d798$require$_interopRequireDefault((parcelRequire("kbh0R")));

var $a42d7cd6f5e2d798$var$React = $a42d7cd6f5e2d798$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $a42d7cd6f5e2d798$var$_classnames = $a42d7cd6f5e2d798$require$_interopRequireDefault((parcelRequire("giSak")));
parcelRequire("1T8KD");
var $lvl2c = parcelRequire("lvl2c");

var $a42d7cd6f5e2d798$var$_Context = $a42d7cd6f5e2d798$require$_interopRequireDefault((parcelRequire("ckUzF")));

var $a42d7cd6f5e2d798$var$_IconBase = $a42d7cd6f5e2d798$require$_interopRequireDefault((parcelRequire("59C2F")));

var $fiaXk = parcelRequire("fiaXk");

var $k3KnH = parcelRequire("k3KnH");
var $a42d7cd6f5e2d798$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $fiaXk.setTwoToneColor)($lvl2c.blue.primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $a42d7cd6f5e2d798$var$Icon = /*#__PURE__*/ $a42d7cd6f5e2d798$var$React.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $a42d7cd6f5e2d798$var$_objectWithoutProperties2.default)(props, $a42d7cd6f5e2d798$var$_excluded);
    var _React$useContext = $a42d7cd6f5e2d798$var$React.useContext($a42d7cd6f5e2d798$var$_Context.default), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, $a42d7cd6f5e2d798$var$_classnames.default)(rootClassName, prefixCls, (0, $a42d7cd6f5e2d798$var$_defineProperty2.default)((0, $a42d7cd6f5e2d798$var$_defineProperty2.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $k3KnH.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $a42d7cd6f5e2d798$var$_slicedToArray2.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $a42d7cd6f5e2d798$var$React.createElement("span", (0, $a42d7cd6f5e2d798$var$_extends2.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $a42d7cd6f5e2d798$var$React.createElement($a42d7cd6f5e2d798$var$_IconBase.default, {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$a42d7cd6f5e2d798$var$Icon.displayName = 'AntdIcon';
$a42d7cd6f5e2d798$var$Icon.getTwoToneColor = $fiaXk.getTwoToneColor;
$a42d7cd6f5e2d798$var$Icon.setTwoToneColor = $fiaXk.setTwoToneColor;
var $a42d7cd6f5e2d798$var$_default = module.exports.default = $a42d7cd6f5e2d798$var$Icon;

});
parcelRegister("kbh0R", function(module, exports) {

var $4Y8yb = parcelRequire("4Y8yb");
function $eb12081cdb61d1f9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4Y8yb(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $eb12081cdb61d1f9$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4Y8yb", function(module, exports) {
function $39e365efc0b2f771$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $39e365efc0b2f771$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("59C2F", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $3c0b4d5bbdf4c505$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $3c0b4d5bbdf4c505$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c0b4d5bbdf4c505$var$_objectWithoutProperties2 = $3c0b4d5bbdf4c505$require$_interopRequireDefault((parcelRequire("kbh0R")));

var $3c0b4d5bbdf4c505$var$_objectSpread2 = $3c0b4d5bbdf4c505$require$_interopRequireDefault((parcelRequire("4MICP")));

var $3c0b4d5bbdf4c505$var$React = $3c0b4d5bbdf4c505$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $k3KnH = parcelRequire("k3KnH");
var $3c0b4d5bbdf4c505$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $3c0b4d5bbdf4c505$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $3c0b4d5bbdf4c505$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $3c0b4d5bbdf4c505$var$twoToneColorPalette.primaryColor = primaryColor;
    $3c0b4d5bbdf4c505$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $k3KnH.getSecondaryColor)(primaryColor);
    $3c0b4d5bbdf4c505$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $3c0b4d5bbdf4c505$var$getTwoToneColors() {
    return (0, $3c0b4d5bbdf4c505$var$_objectSpread2.default)({}, $3c0b4d5bbdf4c505$var$twoToneColorPalette);
}
var $3c0b4d5bbdf4c505$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $3c0b4d5bbdf4c505$var$_objectWithoutProperties2.default)(props, $3c0b4d5bbdf4c505$var$_excluded);
    var svgRef = $3c0b4d5bbdf4c505$var$React.useRef();
    var colors = $3c0b4d5bbdf4c505$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $k3KnH.getSecondaryColor)(primaryColor)
    };
    (0, $k3KnH.useInsertStyles)(svgRef);
    (0, $k3KnH.warning)((0, $k3KnH.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $k3KnH.isIconDefinition)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $3c0b4d5bbdf4c505$var$_objectSpread2.default)((0, $3c0b4d5bbdf4c505$var$_objectSpread2.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $k3KnH.generate)(target.icon, "svg-".concat(target.name), (0, $3c0b4d5bbdf4c505$var$_objectSpread2.default)((0, $3c0b4d5bbdf4c505$var$_objectSpread2.default)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps), {}, {
        ref: svgRef
    }));
};
$3c0b4d5bbdf4c505$var$IconBase.displayName = 'IconReact';
$3c0b4d5bbdf4c505$var$IconBase.getTwoToneColors = $3c0b4d5bbdf4c505$var$getTwoToneColors;
$3c0b4d5bbdf4c505$var$IconBase.setTwoToneColors = $3c0b4d5bbdf4c505$var$setTwoToneColors;
var $3c0b4d5bbdf4c505$var$_default = module.exports.default = $3c0b4d5bbdf4c505$var$IconBase;

});
parcelRegister("k3KnH", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $e9a810d29d45641a$require$_interopRequireWildcard = $ffW2x.default;

var $4d0me = parcelRequire("4d0me");
var $e9a810d29d45641a$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generate = $e9a810d29d45641a$var$generate;
module.exports.getSecondaryColor = $e9a810d29d45641a$var$getSecondaryColor;
module.exports.iconStyles = void 0;
module.exports.isIconDefinition = $e9a810d29d45641a$var$isIconDefinition;
module.exports.normalizeAttrs = $e9a810d29d45641a$var$normalizeAttrs;
module.exports.normalizeTwoToneColors = $e9a810d29d45641a$var$normalizeTwoToneColors;
module.exports.useInsertStyles = module.exports.svgBaseProps = void 0;
module.exports.warning = $e9a810d29d45641a$var$warning;

var $e9a810d29d45641a$var$_objectSpread2 = $e9a810d29d45641a$require$_interopRequireDefault((parcelRequire("4MICP")));

var $e9a810d29d45641a$var$_typeof2 = $e9a810d29d45641a$require$_interopRequireDefault((parcelRequire("cEcQP")));
parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");

var $026Cp = parcelRequire("026Cp");

var $lGB2B = parcelRequire("lGB2B");

var $e9a810d29d45641a$var$_warning = $e9a810d29d45641a$require$_interopRequireDefault((parcelRequire("jtk8Y")));

var $e9a810d29d45641a$var$_react = $e9a810d29d45641a$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $e9a810d29d45641a$var$_Context = $e9a810d29d45641a$require$_interopRequireDefault((parcelRequire("ckUzF")));
function $e9a810d29d45641a$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $e9a810d29d45641a$var$warning(valid, message) {
    (0, $e9a810d29d45641a$var$_warning.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $e9a810d29d45641a$var$isIconDefinition(target) {
    return (0, $e9a810d29d45641a$var$_typeof2.default)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $e9a810d29d45641a$var$_typeof2.default)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $e9a810d29d45641a$var$normalizeAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$e9a810d29d45641a$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $e9a810d29d45641a$var$generate(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ $e9a810d29d45641a$var$_react.default.createElement(node.tag, (0, $e9a810d29d45641a$var$_objectSpread2.default)({
        key: key
    }, $e9a810d29d45641a$var$normalizeAttrs(node.attrs)), (node.children || []).map(function(child, index) {
        return $e9a810d29d45641a$var$generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ $e9a810d29d45641a$var$_react.default.createElement(node.tag, (0, $e9a810d29d45641a$var$_objectSpread2.default)((0, $e9a810d29d45641a$var$_objectSpread2.default)({
        key: key
    }, $e9a810d29d45641a$var$normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $e9a810d29d45641a$var$generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $e9a810d29d45641a$var$getSecondaryColor(primaryColor) {
    // choose the second color
    return (0, $9Mx90.default)(primaryColor)[0];
}
function $e9a810d29d45641a$var$normalizeTwoToneColors(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var $e9a810d29d45641a$var$svgBaseProps = module.exports.svgBaseProps = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $e9a810d29d45641a$var$iconStyles = module.exports.iconStyles = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $e9a810d29d45641a$var$useInsertStyles = module.exports.useInsertStyles = function useInsertStyles(eleRef) {
    var _useContext = (0, $e9a810d29d45641a$var$_react.useContext)($e9a810d29d45641a$var$_Context.default), csp = _useContext.csp, prefixCls = _useContext.prefixCls, layer = _useContext.layer;
    var mergedStyleStr = $e9a810d29d45641a$var$iconStyles;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
    (0, $e9a810d29d45641a$var$_react.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $lGB2B.getShadowRoot)(ele);
        (0, $026Cp.updateCSS)(mergedStyleStr, '@ant-design-icons', {
            prepend: true,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};

});
parcelRegister("026Cp", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $0065524d28d35ea4$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearContainerCache = $0065524d28d35ea4$var$clearContainerCache;
module.exports.injectCSS = $0065524d28d35ea4$var$injectCSS;
module.exports.removeCSS = $0065524d28d35ea4$var$removeCSS;
module.exports.updateCSS = $0065524d28d35ea4$var$updateCSS;

var $0065524d28d35ea4$var$_objectSpread2 = $0065524d28d35ea4$require$_interopRequireDefault((parcelRequire("4MICP")));

var $0065524d28d35ea4$var$_canUseDom = $0065524d28d35ea4$require$_interopRequireDefault((parcelRequire("5ft6e")));

var $0065524d28d35ea4$var$_contains = $0065524d28d35ea4$require$_interopRequireDefault((parcelRequire("7Quse")));
var $0065524d28d35ea4$var$APPEND_ORDER = 'data-rc-order';
var $0065524d28d35ea4$var$APPEND_PRIORITY = 'data-rc-priority';
var $0065524d28d35ea4$var$MARK_KEY = "rc-util-key";
var $0065524d28d35ea4$var$containerCache = new Map();
function $0065524d28d35ea4$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $0065524d28d35ea4$var$MARK_KEY;
}
function $0065524d28d35ea4$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $0065524d28d35ea4$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $0065524d28d35ea4$var$findStyles(container) {
    return Array.from(($0065524d28d35ea4$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $0065524d28d35ea4$var$injectCSS(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $0065524d28d35ea4$var$_canUseDom.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $0065524d28d35ea4$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($0065524d28d35ea4$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($0065524d28d35ea4$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $0065524d28d35ea4$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $0065524d28d35ea4$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($0065524d28d35ea4$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($0065524d28d35ea4$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $0065524d28d35ea4$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $0065524d28d35ea4$var$getContainer(option);
    return (option.styles || $0065524d28d35ea4$var$findStyles(container)).find(function(node) {
        return node.getAttribute($0065524d28d35ea4$var$getMark(option)) === key;
    });
}
function $0065524d28d35ea4$var$removeCSS(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $0065524d28d35ea4$var$findExistNode(key, option);
    if (existNode) {
        var container = $0065524d28d35ea4$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $0065524d28d35ea4$var$syncRealContainer(container, option) {
    var cachedRealContainer = $0065524d28d35ea4$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $0065524d28d35ea4$var$_contains.default)(document, cachedRealContainer)) {
        var placeholderStyle = $0065524d28d35ea4$var$injectCSS('', option);
        var parentNode = placeholderStyle.parentNode;
        $0065524d28d35ea4$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
/**
 * manually clear container cache to avoid global cache in unit testes
 */ function $0065524d28d35ea4$var$clearContainerCache() {
    $0065524d28d35ea4$var$containerCache.clear();
}
function $0065524d28d35ea4$var$updateCSS(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $0065524d28d35ea4$var$getContainer(originOption);
    var styles = $0065524d28d35ea4$var$findStyles(container);
    var option = (0, $0065524d28d35ea4$var$_objectSpread2.default)((0, $0065524d28d35ea4$var$_objectSpread2.default)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $0065524d28d35ea4$var$syncRealContainer(container, option);
    var existNode = $0065524d28d35ea4$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $0065524d28d35ea4$var$injectCSS(css, option);
    newNode.setAttribute($0065524d28d35ea4$var$getMark(option), key);
    return newNode;
}

});

parcelRegister("lGB2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getShadowRoot = $fc9a40c4f9fcdd86$var$getShadowRoot;
module.exports.inShadow = $fc9a40c4f9fcdd86$var$inShadow;
function $fc9a40c4f9fcdd86$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
/**
 * Check if is in shadowRoot
 */ function $fc9a40c4f9fcdd86$var$inShadow(ele) {
    return $fc9a40c4f9fcdd86$var$getRoot(ele) instanceof ShadowRoot;
}
/**
 * Return shadowRoot if possible
 */ function $fc9a40c4f9fcdd86$var$getShadowRoot(ele) {
    return $fc9a40c4f9fcdd86$var$inShadow(ele) ? $fc9a40c4f9fcdd86$var$getRoot(ele) : null;
}

});



parcelRegister("fiaXk", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $b221090f93a3c2f2$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTwoToneColor = $b221090f93a3c2f2$var$getTwoToneColor;
module.exports.setTwoToneColor = $b221090f93a3c2f2$var$setTwoToneColor;

var $b221090f93a3c2f2$var$_slicedToArray2 = $b221090f93a3c2f2$require$_interopRequireDefault((parcelRequire("fEEQL")));

var $b221090f93a3c2f2$var$_IconBase = $b221090f93a3c2f2$require$_interopRequireDefault((parcelRequire("59C2F")));

var $k3KnH = parcelRequire("k3KnH");
function $b221090f93a3c2f2$var$setTwoToneColor(twoToneColor) {
    var _normalizeTwoToneColo = (0, $k3KnH.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $b221090f93a3c2f2$var$_slicedToArray2.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return $b221090f93a3c2f2$var$_IconBase.default.setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $b221090f93a3c2f2$var$getTwoToneColor() {
    var colors = $b221090f93a3c2f2$var$_IconBase.default.getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}

});





parcelRegister("cYCF3", function(module, exports) {
"use strict";

var $ffW2x = parcelRequire("ffW2x");
var $0270257b891abf15$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0270257b891abf15$var$React = $0270257b891abf15$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $6htaW = parcelRequire("6htaW");

var $bv7tF = parcelRequire("bv7tF");
/**
 * Compatible for legacy `bordered` prop.
 */ const $0270257b891abf15$var$useVariant = function(component, variant) {
    let legacyBordered = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var _a, _b;
    const { variant: configVariant, [component]: componentConfig } = $0270257b891abf15$var$React.useContext($bv7tF.ConfigContext);
    const ctxVariant = $0270257b891abf15$var$React.useContext($6htaW.VariantContext);
    const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = (_b = (_a = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a !== void 0 ? _a : configVariant) !== null && _b !== void 0 ? _b : 'outlined';
    const enableVariantCls = $bv7tF.Variants.includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $0270257b891abf15$var$_default = module.exports.default = $0270257b891abf15$var$useVariant;

});
parcelRegister("6htaW", function(module, exports) {
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $492af63c4eaca2df$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $492af63c4eaca2df$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VariantContext = module.exports.NoStyleItemContext = module.exports.NoFormStyle = module.exports.FormProvider = module.exports.FormItemPrefixContext = module.exports.FormItemInputContext = module.exports.FormContext = void 0;

var $492af63c4eaca2df$var$React = $492af63c4eaca2df$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
parcelRequire("6wVix");
var $jAqyT = parcelRequire("jAqyT");

var $492af63c4eaca2df$var$_omit = $492af63c4eaca2df$require$_interopRequireDefault((parcelRequire("cv4PZ")));
const $492af63c4eaca2df$var$FormContext = module.exports.FormContext = /*#__PURE__*/ $492af63c4eaca2df$var$React.createContext({
    labelAlign: 'right',
    vertical: false,
    itemRef: ()=>{}
});
const $492af63c4eaca2df$var$NoStyleItemContext = module.exports.NoStyleItemContext = /*#__PURE__*/ $492af63c4eaca2df$var$React.createContext(null);
const $492af63c4eaca2df$var$FormProvider = (props)=>{
    const providerProps = (0, $492af63c4eaca2df$var$_omit.default)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $492af63c4eaca2df$var$React.createElement($jAqyT.FormProvider, Object.assign({}, providerProps));
};
module.exports.FormProvider = $492af63c4eaca2df$var$FormProvider;
const $492af63c4eaca2df$var$FormItemPrefixContext = module.exports.FormItemPrefixContext = /*#__PURE__*/ $492af63c4eaca2df$var$React.createContext({
    prefixCls: ''
});
const $492af63c4eaca2df$var$FormItemInputContext = module.exports.FormItemInputContext = /*#__PURE__*/ $492af63c4eaca2df$var$React.createContext({});
$492af63c4eaca2df$var$FormItemInputContext.displayName = 'FormItemInputContext';
const $492af63c4eaca2df$var$NoFormStyle = (_ref)=>{
    let { children: children, status: status, override: override } = _ref;
    const formItemInputContext = $492af63c4eaca2df$var$React.useContext($492af63c4eaca2df$var$FormItemInputContext);
    const newFormItemInputContext = $492af63c4eaca2df$var$React.useMemo(()=>{
        const newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $492af63c4eaca2df$var$React.createElement($492af63c4eaca2df$var$FormItemInputContext.Provider, {
        value: newFormItemInputContext
    }, children);
};
module.exports.NoFormStyle = $492af63c4eaca2df$var$NoFormStyle;
const $492af63c4eaca2df$var$VariantContext = module.exports.VariantContext = /*#__PURE__*/ $492af63c4eaca2df$var$React.createContext(undefined);

});

parcelRegister("bv7tF", function(module, exports) {
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $85f863d06c688936$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $85f863d06c688936$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ConfigConsumer", {
    enumerable: true,
    get: function() {
        return $kh8n9.ConfigConsumer;
    }
});
Object.defineProperty(module.exports, "ConfigContext", {
    enumerable: true,
    get: function() {
        return $kh8n9.ConfigContext;
    }
});
Object.defineProperty(module.exports, "Variants", {
    enumerable: true,
    get: function() {
        return $kh8n9.Variants;
    }
});
module.exports.default = module.exports.configConsumerProps = void 0;
Object.defineProperty(module.exports, "defaultIconPrefixCls", {
    enumerable: true,
    get: function() {
        return $kh8n9.defaultIconPrefixCls;
    }
});
Object.defineProperty(module.exports, "defaultPrefixCls", {
    enumerable: true,
    get: function() {
        return $kh8n9.defaultPrefixCls;
    }
});
module.exports.warnContext = module.exports.globalConfig = void 0;

var $85f863d06c688936$var$React = $85f863d06c688936$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
parcelRequire("gedkv");
var $9Bzxi = parcelRequire("9Bzxi");
var $jANP6 = parcelRequire("jANP6");

var $85f863d06c688936$var$_Context = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("ckUzF")));

var $85f863d06c688936$var$_useMemo = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("1C33x")));

var $4F16D = parcelRequire("4F16D");

var $85f863d06c688936$var$_warning = $85f863d06c688936$require$_interopRequireWildcard((parcelRequire("dw0yD")));

var $85f863d06c688936$var$_validateMessagesContext = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("eoEJS")));

var $85f863d06c688936$var$_locale = $85f863d06c688936$require$_interopRequireWildcard((parcelRequire("2FeQp")));

var $85f863d06c688936$var$_context = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("aTcK8")));

var $85f863d06c688936$var$_en_US = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("3O4C3")));

var $3Y34g = parcelRequire("3Y34g");

var $85f863d06c688936$var$_seed = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("lCXqA")));

var $kh8n9 = parcelRequire("kh8n9");

var $9zIjM = parcelRequire("9zIjM");

var $8zNsY = parcelRequire("8zNsY");

var $85f863d06c688936$var$_useConfig = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("l8tCV")));

var $85f863d06c688936$var$_useTheme = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("30OpA")));

var $85f863d06c688936$var$_MotionWrapper = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("gxDzm")));

var $85f863d06c688936$var$_PropWarning = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("h7fTZ")));

var $85f863d06c688936$var$_SizeContext = $85f863d06c688936$require$_interopRequireWildcard((parcelRequire("7hz7I")));

var $85f863d06c688936$var$_style = $85f863d06c688936$require$_interopRequireDefault((parcelRequire("3vkfI")));
var $85f863d06c688936$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $85f863d06c688936$var$existThemeConfig = false;
const $85f863d06c688936$var$warnContext = module.exports.warnContext = (componentName)=>{
    (0, $85f863d06c688936$var$_warning.default)(!$85f863d06c688936$var$existThemeConfig, componentName, `Static function can not consume context like dynamic theme. Please use 'App' component instead.`);
};
const $85f863d06c688936$var$configConsumerProps = module.exports.configConsumerProps = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $85f863d06c688936$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $85f863d06c688936$var$globalPrefixCls;
let $85f863d06c688936$var$globalIconPrefixCls;
let $85f863d06c688936$var$globalTheme;
let $85f863d06c688936$var$globalHolderRender;
function $85f863d06c688936$var$getGlobalPrefixCls() {
    return $85f863d06c688936$var$globalPrefixCls || $kh8n9.defaultPrefixCls;
}
function $85f863d06c688936$var$getGlobalIconPrefixCls() {
    return $85f863d06c688936$var$globalIconPrefixCls || $kh8n9.defaultIconPrefixCls;
}
function $85f863d06c688936$var$isLegacyTheme(theme) {
    return Object.keys(theme).some((key)=>key.endsWith('Color'));
}
const $85f863d06c688936$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $85f863d06c688936$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $85f863d06c688936$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $85f863d06c688936$var$globalHolderRender = holderRender;
    if (theme) {
        if ($85f863d06c688936$var$isLegacyTheme(theme)) {
            (0, $85f863d06c688936$var$_warning.default)(false, 'ConfigProvider', '`config` of css variable theme is not work in v5. Please use new `theme` config instead.');
            (0, $9zIjM.registerTheme)($85f863d06c688936$var$getGlobalPrefixCls(), theme);
        } else $85f863d06c688936$var$globalTheme = theme;
    }
};
const $85f863d06c688936$var$globalConfig = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$85f863d06c688936$var$getGlobalPrefixCls()}-${suffixCls}` : $85f863d06c688936$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $85f863d06c688936$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($85f863d06c688936$var$globalPrefixCls) return $85f863d06c688936$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $85f863d06c688936$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$85f863d06c688936$var$globalTheme,
        holderRender: $85f863d06c688936$var$globalHolderRender
    });
module.exports.globalConfig = $85f863d06c688936$var$globalConfig;
const $85f863d06c688936$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, menu: menu, pagination: pagination, input: input, textArea: textArea, empty: empty, badge: badge, radio: radio, rate: rate, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect } = props;
    // =================================== Context ===================================
    const getPrefixCls = $85f863d06c688936$var$React.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || $kh8n9.defaultIconPrefixCls;
    const csp = customCsp || parentContext.csp;
    (0, $85f863d06c688936$var$_style.default)(iconPrefixCls, csp);
    const mergedTheme = (0, $85f863d06c688936$var$_useTheme.default)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    $85f863d06c688936$var$existThemeConfig = $85f863d06c688936$var$existThemeConfig || !!mergedTheme;
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect
    };
    {
        const warningFn = (0, $85f863d06c688936$var$_warning.devUseWarning)('ConfigProvider');
        warningFn(!('autoInsertSpaceInButton' in props), 'deprecated', '`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.');
    }
    const config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $85f863d06c688936$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = Object.assign({
        autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $85f863d06c688936$var$_useMemo.default)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $85f863d06c688936$var$React.useContext($jANP6.default);
    const memoIconContextValue = $85f863d06c688936$var$React.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$React.Fragment, null, /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$_PropWarning.default, {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $85f863d06c688936$var$React.useMemo(()=>{
        var _a, _b, _c, _d;
        return (0, $4F16D.merge)(((_a = $85f863d06c688936$var$_en_US.default.Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$_validateMessagesContext.default.Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$_locale.default, {
        locale: locale,
        _ANT_MARK__: $85f863d06c688936$var$_locale.ANT_MARK
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$_Context.default.Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$_SizeContext.SizeContextProvider, {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$_MotionWrapper.default, null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $85f863d06c688936$var$React.useMemo(()=>{
        const _a = mergedTheme || {}, { algorithm: algorithm, token: token, components: components, cssVar: cssVar } = _a, rest = $85f863d06c688936$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $9Bzxi.default)(algorithm) : $3Y34g.defaultTheme;
        const parsedComponents = {};
        Object.entries(components || {}).forEach((_ref)=>{
            let [componentName, componentToken] = _ref;
            const parsedToken = Object.assign({}, componentToken);
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $9Bzxi.default)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, $85f863d06c688936$var$_seed.default), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($3Y34g.DesignTokenContext.Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$_warning.WarningContext.Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $85f863d06c688936$var$React.createElement($8zNsY.DisabledContextProvider, {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $85f863d06c688936$var$React.createElement($kh8n9.ConfigContext.Provider, {
        value: memoedConfig
    }, childNode);
};
const $85f863d06c688936$var$ConfigProvider = (props)=>{
    const context = $85f863d06c688936$var$React.useContext($kh8n9.ConfigContext);
    const antLocale = $85f863d06c688936$var$React.useContext($85f863d06c688936$var$_context.default);
    return /*#__PURE__*/ $85f863d06c688936$var$React.createElement($85f863d06c688936$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$85f863d06c688936$var$ConfigProvider.ConfigContext = $kh8n9.ConfigContext;
$85f863d06c688936$var$ConfigProvider.SizeContext = $85f863d06c688936$var$_SizeContext.default;
$85f863d06c688936$var$ConfigProvider.config = $85f863d06c688936$var$setGlobalConfig;
$85f863d06c688936$var$ConfigProvider.useConfig = $85f863d06c688936$var$_useConfig.default;
Object.defineProperty($85f863d06c688936$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        (0, $85f863d06c688936$var$_warning.default)(false, 'ConfigProvider', 'ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead.');
        return $85f863d06c688936$var$_SizeContext.default;
    }
});
$85f863d06c688936$var$ConfigProvider.displayName = 'ConfigProvider';
var $85f863d06c688936$var$_default = module.exports.default = $85f863d06c688936$var$ConfigProvider;

});
parcelRegister("4F16D", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $364bd95e36cf451d$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $364bd95e36cf451d$var$set;
module.exports.merge = $364bd95e36cf451d$var$merge;

var $364bd95e36cf451d$var$_typeof2 = $364bd95e36cf451d$require$_interopRequireDefault((parcelRequire("cEcQP")));

var $364bd95e36cf451d$var$_objectSpread2 = $364bd95e36cf451d$require$_interopRequireDefault((parcelRequire("4MICP")));

var $364bd95e36cf451d$var$_toConsumableArray2 = $364bd95e36cf451d$require$_interopRequireDefault((parcelRequire("dCUrJ")));

var $364bd95e36cf451d$var$_toArray2 = $364bd95e36cf451d$require$_interopRequireDefault((parcelRequire("2ULpd")));

var $364bd95e36cf451d$var$_get = $364bd95e36cf451d$require$_interopRequireDefault((parcelRequire("hzvfn")));
function $364bd95e36cf451d$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $364bd95e36cf451d$var$_toArray2.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $364bd95e36cf451d$var$_toConsumableArray2.default)(entity);
    else clone = (0, $364bd95e36cf451d$var$_objectSpread2.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $364bd95e36cf451d$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $364bd95e36cf451d$var$set(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $364bd95e36cf451d$var$_get.default)(entity, paths.slice(0, -1))) return entity;
    return $364bd95e36cf451d$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $364bd95e36cf451d$var$isObject(obj) {
    return (0, $364bd95e36cf451d$var$_typeof2.default)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $364bd95e36cf451d$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $364bd95e36cf451d$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
/**
 * Merge objects which will create
 */ function $364bd95e36cf451d$var$merge() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $364bd95e36cf451d$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $364bd95e36cf451d$var$_get.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $364bd95e36cf451d$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $364bd95e36cf451d$var$_get.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $364bd95e36cf451d$var$set(clone, path, []);
                    else if (!originValue || (0, $364bd95e36cf451d$var$_typeof2.default)(originValue) !== 'object') // Init container if not exist
                    clone = $364bd95e36cf451d$var$set(clone, path, $364bd95e36cf451d$var$createEmpty(value));
                    $364bd95e36cf451d$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $364bd95e36cf451d$var$_toConsumableArray2.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $364bd95e36cf451d$var$set(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});

parcelRegister("9zIjM", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $6f89c292c4306d86$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getStyle = $6f89c292c4306d86$var$getStyle;
module.exports.registerTheme = $6f89c292c4306d86$var$registerTheme;
parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

var $6f89c292c4306d86$var$_canUseDom = $6f89c292c4306d86$require$_interopRequireDefault((parcelRequire("5ft6e")));

var $026Cp = parcelRequire("026Cp");

var $6f89c292c4306d86$var$_warning = $6f89c292c4306d86$require$_interopRequireDefault((parcelRequire("dw0yD")));
const $6f89c292c4306d86$var$dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function $6f89c292c4306d86$var$getStyle(globalPrefixCls, theme) {
    const variables = {};
    const formatColor = (color, updater)=>{
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    const fillColor = (colorVal, type)=>{
        const baseColor = new $6xABB.FastColor(colorVal);
        const colorPalettes = (0, $9Mx90.default)(baseColor.toRgbString());
        variables[`${type}-color`] = formatColor(baseColor);
        variables[`${type}-color-disabled`] = colorPalettes[1];
        variables[`${type}-color-hover`] = colorPalettes[4];
        variables[`${type}-color-active`] = colorPalettes[6];
        variables[`${type}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
        variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
        variables[`${type}-color-deprecated-border`] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        const primaryColor = new $6xABB.FastColor(theme.primaryColor);
        const primaryColors = (0, $9Mx90.default)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach((color, index)=>{
            variables[`primary-${index + 1}`] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, (c)=>c.lighten(35));
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, (c)=>c.lighten(20));
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, (c)=>c.tint(20));
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, (c)=>c.tint(50));
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, (c)=>c.setA(c.a * 0.12));
        const primaryActiveColor = new $6xABB.FastColor(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, (c)=>c.setA(c.a * 0.3));
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, (c)=>c.darken(2));
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    const cssList = Object.keys(variables).map((key)=>`--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join('\n')}
  }
  `.trim();
}
function $6f89c292c4306d86$var$registerTheme(globalPrefixCls, theme) {
    const style = $6f89c292c4306d86$var$getStyle(globalPrefixCls, theme);
    if ((0, $6f89c292c4306d86$var$_canUseDom.default)()) (0, $026Cp.updateCSS)(style, `${$6f89c292c4306d86$var$dynamicStyleMark}-dynamic-theme`);
    else (0, $6f89c292c4306d86$var$_warning.default)(false, 'ConfigProvider', 'SSR do not support dynamic theme with css variables.');
}

});



parcelRegister("fGVpj", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $b6c74f1ec6557bcd$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6c74f1ec6557bcd$var$isFragment;

var $b6c74f1ec6557bcd$var$_typeof2 = $b6c74f1ec6557bcd$require$_interopRequireDefault((parcelRequire("cEcQP")));
var $b6c74f1ec6557bcd$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $b6c74f1ec6557bcd$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $b6c74f1ec6557bcd$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
/**
 * Compatible with React 18 or 19 to check if node is a Fragment.
 */ function $b6c74f1ec6557bcd$var$isFragment(object) {
    return(// Base object type
    object && (0, $b6c74f1ec6557bcd$var$_typeof2.default)(object) === 'object' && // React Element type
    (object.$$typeof === $b6c74f1ec6557bcd$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $b6c74f1ec6557bcd$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $b6c74f1ec6557bcd$var$REACT_FRAGMENT_TYPE);
}

});

parcelRegister("8Jb6G", function(module, exports) {
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $65ab244ac75f30d9$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65ab244ac75f30d9$var$_react = $65ab244ac75f30d9$require$_interopRequireDefault((parcelRequire("jMaZ8")));

var $6htaW = parcelRequire("6htaW");

var $e3K18 = parcelRequire("e3K18");
const $65ab244ac75f30d9$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (children === undefined || children === null) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ $65ab244ac75f30d9$var$_react.default.createElement($6htaW.NoFormStyle, {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ $65ab244ac75f30d9$var$_react.default.createElement($e3K18.NoCompactStyle, null, result);
    return result;
};
var $65ab244ac75f30d9$var$_default = module.exports.default = $65ab244ac75f30d9$var$ContextIsolator;

});
parcelRegister("e3K18", function(module, exports) {
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $a3c50a936760fbea$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $a3c50a936760fbea$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useCompactItemContext = module.exports.default = module.exports.SpaceCompactItemContext = module.exports.NoCompactStyle = void 0;

var $a3c50a936760fbea$var$React = $a3c50a936760fbea$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $a3c50a936760fbea$var$_classnames = $a3c50a936760fbea$require$_interopRequireDefault((parcelRequire("giSak")));

var $a3c50a936760fbea$var$_toArray = $a3c50a936760fbea$require$_interopRequireDefault((parcelRequire("gIfF4")));

var $bv7tF = parcelRequire("bv7tF");

var $a3c50a936760fbea$var$_useSize = $a3c50a936760fbea$require$_interopRequireDefault((parcelRequire("jRzZI")));

var $a3c50a936760fbea$var$_style = $a3c50a936760fbea$require$_interopRequireDefault((parcelRequire("l04OA")));
var $a3c50a936760fbea$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a3c50a936760fbea$var$SpaceCompactItemContext = module.exports.SpaceCompactItemContext = /*#__PURE__*/ $a3c50a936760fbea$var$React.createContext(null);
const $a3c50a936760fbea$var$useCompactItemContext = (prefixCls, direction)=>{
    const compactItemContext = $a3c50a936760fbea$var$React.useContext($a3c50a936760fbea$var$SpaceCompactItemContext);
    const compactItemClassnames = $a3c50a936760fbea$var$React.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, $a3c50a936760fbea$var$_classnames.default)(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
module.exports.useCompactItemContext = $a3c50a936760fbea$var$useCompactItemContext;
const $a3c50a936760fbea$var$NoCompactStyle = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $a3c50a936760fbea$var$React.createElement($a3c50a936760fbea$var$SpaceCompactItemContext.Provider, {
        value: null
    }, children);
};
module.exports.NoCompactStyle = $a3c50a936760fbea$var$NoCompactStyle;
const $a3c50a936760fbea$var$CompactItem = (props)=>{
    const { children: children } = props, others = $a3c50a936760fbea$var$__rest(props, [
        "children"
    ]);
    return /*#__PURE__*/ $a3c50a936760fbea$var$React.createElement($a3c50a936760fbea$var$SpaceCompactItemContext.Provider, {
        value: $a3c50a936760fbea$var$React.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $a3c50a936760fbea$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $a3c50a936760fbea$var$React.useContext($bv7tF.ConfigContext);
    const { size: size, direction: direction, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children } = props, restProps = $a3c50a936760fbea$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    const mergedSize = (0, $a3c50a936760fbea$var$_useSize.default)((ctx)=>size !== null && size !== void 0 ? size : ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $a3c50a936760fbea$var$_style.default)(prefixCls);
    const clx = (0, $a3c50a936760fbea$var$_classnames.default)(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === 'vertical'
    }, className, rootClassName);
    const compactItemContext = $a3c50a936760fbea$var$React.useContext($a3c50a936760fbea$var$SpaceCompactItemContext);
    const childNodes = (0, $a3c50a936760fbea$var$_toArray.default)(children);
    const nodes = $a3c50a936760fbea$var$React.useMemo(()=>childNodes.map((child, i)=>{
            const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $a3c50a936760fbea$var$React.createElement($a3c50a936760fbea$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        }), [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $a3c50a936760fbea$var$React.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $a3c50a936760fbea$var$_default = module.exports.default = $a3c50a936760fbea$var$Compact;

});
parcelRegister("gIfF4", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $c2ace76c3393e7d0$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2ace76c3393e7d0$var$toArray;

var $c2ace76c3393e7d0$var$_isFragment = $c2ace76c3393e7d0$require$_interopRequireDefault((parcelRequire("fGVpj")));

var $c2ace76c3393e7d0$var$_react = $c2ace76c3393e7d0$require$_interopRequireDefault((parcelRequire("jMaZ8")));
function $c2ace76c3393e7d0$var$toArray(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    $c2ace76c3393e7d0$var$_react.default.Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($c2ace76c3393e7d0$var$toArray(child));
        else if ((0, $c2ace76c3393e7d0$var$_isFragment.default)(child) && child.props) ret = ret.concat($c2ace76c3393e7d0$var$toArray(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

});

parcelRegister("l04OA", function(module, exports) {
"use strict";

var $4d0me = parcelRequire("4d0me");
var $f49d55369b454650$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepareComponentToken = module.exports.default = void 0;

var $LXVdy = parcelRequire("LXVdy");

var $f49d55369b454650$var$_compact = $f49d55369b454650$require$_interopRequireDefault((parcelRequire("gG2fH")));
const $f49d55369b454650$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $f49d55369b454650$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
// ============================== Export ==============================
const $f49d55369b454650$var$prepareComponentToken = ()=>({});
module.exports.prepareComponentToken = $f49d55369b454650$var$prepareComponentToken;
var $f49d55369b454650$var$_default = module.exports.default = (0, $LXVdy.genStyleHooks)('Space', (token)=>{
    const spaceToken = (0, $LXVdy.mergeToken)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $f49d55369b454650$var$genSpaceStyle(spaceToken),
        $f49d55369b454650$var$genSpaceGapStyle(spaceToken),
        (0, $f49d55369b454650$var$_compact.default)(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});

});
parcelRegister("gG2fH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $c24250ce4422c610$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            }
        }
    };
};
// ============================== Export ==============================
var $c24250ce4422c610$var$_default = module.exports.default = $c24250ce4422c610$var$genSpaceCompactStyle;

});




parcelRegister("aJ2F9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7cf02c1e67a6f08d$var$useRemovePasswordTimeout;

var $jMaZ8 = parcelRequire("jMaZ8");
function $7cf02c1e67a6f08d$var$useRemovePasswordTimeout(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $jMaZ8.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute('value');
        }));
    };
    (0, $jMaZ8.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}

});

parcelRegister("ee5oX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.genPlaceholderStyle = module.exports.genInputSmallStyle = module.exports.genInputGroupStyle = module.exports.genBasicInputStyle = module.exports.genActiveStyle = module.exports.default = void 0;
Object.defineProperty(module.exports, "initComponentToken", {
    enumerable: true,
    get: function() {
        return $3zNqI.initComponentToken;
    }
});
Object.defineProperty(module.exports, "initInputToken", {
    enumerable: true,
    get: function() {
        return $3zNqI.initInputToken;
    }
});
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

var $GMiWH = parcelRequire("GMiWH");

var $4JxVU = parcelRequire("4JxVU");

var $LXVdy = parcelRequire("LXVdy");

var $3zNqI = parcelRequire("3zNqI");

var $2MlTS = parcelRequire("2MlTS");
const $a5b6901a8108793d$var$genPlaceholderStyle = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
module.exports.genPlaceholderStyle = $a5b6901a8108793d$var$genPlaceholderStyle;
const $a5b6901a8108793d$var$genActiveStyle = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
module.exports.genActiveStyle = $a5b6901a8108793d$var$genActiveStyle;
const $a5b6901a8108793d$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $4g3I0.unit)(paddingBlockLG)} ${(0, $4g3I0.unit)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $a5b6901a8108793d$var$genInputSmallStyle = (token)=>({
        padding: `${(0, $4g3I0.unit)(token.paddingBlockSM)} ${(0, $4g3I0.unit)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
module.exports.genInputSmallStyle = $a5b6901a8108793d$var$genInputSmallStyle;
const $a5b6901a8108793d$var$genBasicInputStyle = (token)=>Object.assign(Object.assign({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $4g3I0.unit)(token.paddingBlock)} ${(0, $4g3I0.unit)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`
    }, $a5b6901a8108793d$var$genPlaceholderStyle(token.colorTextPlaceholder)), {
        // Reset height for `textarea`s
        'textarea&': {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}, height 0s`,
            resize: 'vertical'
        },
        // Size
        '&-lg': Object.assign({}, $a5b6901a8108793d$var$genInputLargeStyle(token)),
        '&-sm': Object.assign({}, $a5b6901a8108793d$var$genInputSmallStyle(token)),
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
module.exports.genBasicInputStyle = $a5b6901a8108793d$var$genBasicInputStyle;
const $a5b6901a8108793d$var$genInputGroupStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, $a5b6901a8108793d$var$genInputLargeStyle(token)),
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, $a5b6901a8108793d$var$genInputSmallStyle(token)),
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $4g3I0.unit)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $4g3I0.unit)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $4g3I0.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        [`${antCls}-select-selector`]: {
                            backgroundColor: 'inherit',
                            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} transparent`,
                            boxShadow: 'none'
                        }
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $4g3I0.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
                [`${componentCls}-search &`]: {
                    borderStartStartRadius: token.borderRadius,
                    borderEndStartRadius: token.borderRadius
                }
            },
            [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
            display: 'block'
        }, (0, $GMiWH.clearFix)()), {
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                    borderRadius: 0
                }
            },
            [`${componentCls}-group-wrapper:not(:last-child)`]: {
                [`&${componentCls}-search > ${componentCls}-group`]: {
                    [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
                        borderRadius: 0
                    },
                    [`& > ${componentCls}`]: {
                        borderStartStartRadius: token.borderRadius,
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0,
                        borderEndStartRadius: token.borderRadius
                    }
                }
            }
        })
    };
};
module.exports.genInputGroupStyle = $a5b6901a8108793d$var$genInputGroupStyle;
const $a5b6901a8108793d$var$genInputStyle = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $GMiWH.resetComponent)(token)), $a5b6901a8108793d$var$genBasicInputStyle(token)), (0, $2MlTS.genOutlinedStyle)(token)), (0, $2MlTS.genFilledStyle)(token)), (0, $2MlTS.genBorderlessStyle)(token)), {
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                '-webkit-appearance': 'none'
            }
        })
    };
};
const $a5b6901a8108793d$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorTextTertiary
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $4g3I0.unit)(token.inputAffixPadding)}`
            }
        }
    };
};
const $a5b6901a8108793d$var$genAffixStyle = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, $a5b6901a8108793d$var$genBasicInputStyle(token)), {
            display: 'inline-flex',
            [`&:not(${componentCls}-disabled):hover`]: {
                zIndex: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            },
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            }
        }), $a5b6901a8108793d$var$genAllowClearStyle(token)), {
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        }),
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $a5b6901a8108793d$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, (0, $GMiWH.resetComponent)(token)), $a5b6901a8108793d$var$genInputGroupStyle(token)), {
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': Object.assign(Object.assign(Object.assign({
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                }
            }, (0, $2MlTS.genOutlinedGroupStyle)(token)), (0, $2MlTS.genFilledGroupStyle)(token)), {
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            })
        })
    };
};
const $a5b6901a8108793d$var$genSearchInputStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const searchPrefixCls = `${componentCls}-search`;
    return {
        [searchPrefixCls]: {
            [componentCls]: {
                '&:hover, &:focus': {
                    [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        borderInlineStartColor: token.colorPrimaryHover
                    }
                }
            },
            [`${componentCls}-affix-wrapper`]: {
                height: token.controlHeight,
                borderRadius: 0
            },
            // fix slight height diff in Firefox:
            // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
            [`${componentCls}-lg`]: {
                lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal()
            },
            [`> ${componentCls}-group`]: {
                [`> ${componentCls}-group-addon:last-child`]: {
                    insetInlineStart: -1,
                    padding: 0,
                    border: 0,
                    [`${searchPrefixCls}-button`]: {
                        // Fix https://github.com/ant-design/ant-design/issues/47150
                        marginInlineEnd: -1,
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0,
                        boxShadow: 'none'
                    },
                    [`${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        color: token.colorTextDescription,
                        '&:hover': {
                            color: token.colorPrimaryHover
                        },
                        '&:active': {
                            color: token.colorPrimaryActive
                        },
                        [`&${antCls}-btn-loading::before`]: {
                            insetInlineStart: 0,
                            insetInlineEnd: 0,
                            insetBlockStart: 0,
                            insetBlockEnd: 0
                        }
                    }
                }
            },
            [`${searchPrefixCls}-button`]: {
                height: token.controlHeight,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            '&-large': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightLG
                }
            },
            '&-small': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightSM
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            // ===================== Compact Item Customized Styles =====================
            [`&${componentCls}-compact-item`]: {
                [`&:not(${componentCls}-compact-last-item)`]: {
                    [`${componentCls}-group-addon`]: {
                        [`${componentCls}-search-button`]: {
                            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                            borderRadius: 0
                        }
                    }
                },
                [`&:not(${componentCls}-compact-first-item)`]: {
                    [`${componentCls},${componentCls}-affix-wrapper`]: {
                        borderRadius: 0
                    }
                },
                [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    }
                },
                [`> ${componentCls}-affix-wrapper-focused`]: {
                    zIndex: 2
                }
            }
        }
    };
};
const $a5b6901a8108793d$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                // https://github.com/ant-design/ant-design/issues/33049
                [`> ${componentCls}`]: {
                    height: '100%'
                },
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $a5b6901a8108793d$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
// ============================== Export ==============================
var $a5b6901a8108793d$var$_default = module.exports.default = (0, $LXVdy.genStyleHooks)('Input', (token)=>{
    const inputToken = (0, $LXVdy.mergeToken)(token, (0, $3zNqI.initInputToken)(token));
    return [
        $a5b6901a8108793d$var$genInputStyle(inputToken),
        $a5b6901a8108793d$var$genTextAreaStyle(inputToken),
        $a5b6901a8108793d$var$genAffixStyle(inputToken),
        $a5b6901a8108793d$var$genGroupStyle(inputToken),
        $a5b6901a8108793d$var$genSearchInputStyle(inputToken),
        $a5b6901a8108793d$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $4JxVU.genCompactItemStyle)(inputToken)
    ];
}, $3zNqI.initComponentToken, {
    resetFont: false
});

});
parcelRegister("4JxVU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.genCompactItemStyle = $3725afc4574aea20$var$genCompactItemStyle;
// handle border collapse
function $3725afc4574aea20$var$compactItemBorder(token, parentCls, options) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        '&-item': Object.assign(Object.assign({
            [hoverEffects]: {
                zIndex: 2
            }
        }, focusElCls ? {
            [`&${focusElCls}`]: {
                zIndex: 2
            }
        } : {}), {
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        })
    };
}
// handle border-radius
function $3725afc4574aea20$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $3725afc4574aea20$var$genCompactItemStyle(token) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
    };
    const { componentCls: componentCls } = token;
    const compactCls = `${componentCls}-compact`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $3725afc4574aea20$var$compactItemBorder(token, compactCls, options)), $3725afc4574aea20$var$compactItemBorderRadius(componentCls, compactCls, options))
    };
}

});

parcelRegister("3zNqI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initComponentToken = void 0;
module.exports.initInputToken = $29aafbbc08b9360e$var$initInputToken;

var $LXVdy = parcelRequire("LXVdy");
function $29aafbbc08b9360e$var$initInputToken(token) {
    return (0, $LXVdy.mergeToken)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $29aafbbc08b9360e$var$initComponentToken = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer } = token;
    return {
        paddingBlock: Math.max(Math.round((controlHeight - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockSM: Math.max(Math.round((controlHeightSM - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockLG: Math.ceil((controlHeightLG - fontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth,
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: fontSize,
        inputFontSizeLG: fontSizeLG,
        inputFontSizeSM: fontSize
    };
};
module.exports.initComponentToken = $29aafbbc08b9360e$var$initComponentToken;

});

parcelRegister("2MlTS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.genOutlinedStyle = module.exports.genOutlinedGroupStyle = module.exports.genHoverStyle = module.exports.genFilledStyle = module.exports.genFilledGroupStyle = module.exports.genDisabledStyle = module.exports.genBorderlessStyle = module.exports.genBaseOutlinedStyle = void 0;
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

var $LXVdy = parcelRequire("LXVdy");
const $20610d6bd1986585$var$genHoverStyle = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
module.exports.genHoverStyle = $20610d6bd1986585$var$genHoverStyle;
const $20610d6bd1986585$var$genDisabledStyle = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': Object.assign({}, $20610d6bd1986585$var$genHoverStyle((0, $LXVdy.mergeToken)(token, {
            hoverBorderColor: token.colorBorder,
            hoverBg: token.colorBgContainerDisabled
        })))
    });
/* ============== Outlined ============== */ module.exports.genDisabledStyle = $20610d6bd1986585$var$genDisabledStyle;
const $20610d6bd1986585$var$genBaseOutlinedStyle = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
module.exports.genBaseOutlinedStyle = $20610d6bd1986585$var$genBaseOutlinedStyle;
const $20610d6bd1986585$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $20610d6bd1986585$var$genBaseOutlinedStyle(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }),
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $20610d6bd1986585$var$genOutlinedStyle = (token, extraStyles)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $20610d6bd1986585$var$genBaseOutlinedStyle(token, {
            borderColor: token.colorBorder,
            hoverBorderColor: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeShadow: token.activeShadow
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $20610d6bd1986585$var$genDisabledStyle(token))
        }), $20610d6bd1986585$var$genOutlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderColor: token.colorErrorBorderHover,
            activeBorderColor: token.colorError,
            activeShadow: token.errorActiveShadow,
            affixColor: token.colorError
        })), $20610d6bd1986585$var$genOutlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderColor: token.colorWarningBorderHover,
            activeBorderColor: token.colorWarning,
            activeShadow: token.warningActiveShadow,
            affixColor: token.colorWarning
        })), extraStyles)
    });
module.exports.genOutlinedStyle = $20610d6bd1986585$var$genOutlinedStyle;
const $20610d6bd1986585$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $20610d6bd1986585$var$genOutlinedGroupStyle = (token)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            }
        }, $20610d6bd1986585$var$genOutlinedGroupStatusStyle(token, {
            status: 'error',
            addonBorderColor: token.colorError,
            addonColor: token.colorErrorText
        })), $20610d6bd1986585$var$genOutlinedGroupStatusStyle(token, {
            status: 'warning',
            addonBorderColor: token.colorWarning,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: Object.assign({}, $20610d6bd1986585$var$genDisabledStyle(token))
            }
        })
    });
/* ============ Borderless ============ */ module.exports.genOutlinedGroupStyle = $20610d6bd1986585$var$genOutlinedGroupStyle;
const $20610d6bd1986585$var$genBorderlessStyle = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': Object.assign({
            background: 'transparent',
            border: 'none',
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            }
        }, extraStyles)
    };
};
/* ============== Filled ============== */ module.exports.genBorderlessStyle = $20610d6bd1986585$var$genBorderlessStyle;
const $20610d6bd1986585$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: options === null || options === void 0 ? void 0 : options.inputColor
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $20610d6bd1986585$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $20610d6bd1986585$var$genBaseFilledStyle(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        })
    });
const $20610d6bd1986585$var$genFilledStyle = (token, extraStyles)=>({
        '&-filled': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $20610d6bd1986585$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.activeBorderColor
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $20610d6bd1986585$var$genDisabledStyle(token))
        }), $20610d6bd1986585$var$genFilledStatusStyle(token, {
            status: 'error',
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            inputColor: token.colorErrorText,
            affixColor: token.colorError
        })), $20610d6bd1986585$var$genFilledStatusStyle(token, {
            status: 'warning',
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            inputColor: token.colorWarningText,
            affixColor: token.colorWarning
        })), extraStyles)
    });
module.exports.genFilledStyle = $20610d6bd1986585$var$genFilledStyle;
const $20610d6bd1986585$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $20610d6bd1986585$var$genFilledGroupStyle = (token)=>({
        '&-filled': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.colorFillTertiary
                },
                [`${token.componentCls}-filled:not(:focus):not(:focus-within)`]: {
                    '&:not(:first-child)': {
                        borderInlineStart: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    },
                    '&:not(:last-child)': {
                        borderInlineEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    }
                }
            }
        }, $20610d6bd1986585$var$genFilledGroupStatusStyle(token, {
            status: 'error',
            addonBg: token.colorErrorBg,
            addonColor: token.colorErrorText
        })), $20610d6bd1986585$var$genFilledGroupStatusStyle(token, {
            status: 'warning',
            addonBg: token.colorWarningBg,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        })
    });
module.exports.genFilledGroupStyle = $20610d6bd1986585$var$genFilledGroupStyle;

});


parcelRegister("dTWGV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a1edf051ac45e2c1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $jMaZ8 = parcelRequire("jMaZ8");
var $a1edf051ac45e2c1$var$_react2 = $a1edf051ac45e2c1$var$_interopRequireDefault($jMaZ8);

var $3XAKw = parcelRequire("3XAKw");
var $a1edf051ac45e2c1$var$_propTypes2 = $a1edf051ac45e2c1$var$_interopRequireDefault($3XAKw);
function $a1edf051ac45e2c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a1edf051ac45e2c1$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a1edf051ac45e2c1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a1edf051ac45e2c1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a1edf051ac45e2c1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a1edf051ac45e2c1$var$InfiniteScroll = function(_Component) {
    $a1edf051ac45e2c1$var$_inherits(InfiniteScroll, _Component);
    function InfiniteScroll(props) {
        $a1edf051ac45e2c1$var$_classCallCheck(this, InfiniteScroll);
        var _this = $a1edf051ac45e2c1$var$_possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));
        _this.scrollListener = _this.scrollListener.bind(_this);
        _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
        _this.mousewheelListener = _this.mousewheelListener.bind(_this);
        return _this;
    }
    $a1edf051ac45e2c1$var$_createClass(InfiniteScroll, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.pageLoaded = this.props.pageStart;
                this.options = this.eventListenerOptions();
                this.attachScrollListener();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.props.isReverse && this.loadMore) {
                    var parentElement = this.getParentElement(this.scrollComponent);
                    parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
                    this.loadMore = false;
                }
                this.attachScrollListener();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.detachScrollListener();
                this.detachMousewheelListener();
            }
        },
        {
            key: 'isPassiveSupported',
            value: function isPassiveSupported() {
                var passive = false;
                var testOptions = {
                    get passive () {
                        passive = true;
                    }
                };
                try {
                    document.addEventListener('test', null, testOptions);
                    document.removeEventListener('test', null, testOptions);
                } catch (e) {
                // ignore
                }
                return passive;
            }
        },
        {
            key: 'eventListenerOptions',
            value: function eventListenerOptions() {
                var options = this.props.useCapture;
                if (this.isPassiveSupported()) options = {
                    useCapture: this.props.useCapture,
                    passive: true
                };
                else options = {
                    passive: false
                };
                return options;
            }
        },
        {
            key: 'setDefaultLoader',
            value: function setDefaultLoader(loader) {
                this.defaultLoader = loader;
            }
        },
        {
            key: 'detachMousewheelListener',
            value: function detachMousewheelListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.scrollComponent.parentNode;
                scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: 'detachScrollListener',
            value: function detachScrollListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.getParentElement(this.scrollComponent);
                scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: 'getParentElement',
            value: function getParentElement(el) {
                var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
                if (scrollParent != null) return scrollParent;
                return el && el.parentNode;
            }
        },
        {
            key: 'filterProps',
            value: function filterProps(props) {
                return props;
            }
        },
        {
            key: 'attachScrollListener',
            value: function attachScrollListener() {
                var parentElement = this.getParentElement(this.scrollComponent);
                if (!this.props.hasMore || !parentElement) return;
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = parentElement;
                scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
                if (this.props.initialLoad) this.scrollListener();
            }
        },
        {
            key: 'mousewheelListener',
            value: function mousewheelListener(e) {
                // Prevents Chrome hangups
                // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
                if (e.deltaY === 1 && !this.isPassiveSupported()) e.preventDefault();
            }
        },
        {
            key: 'scrollListener',
            value: function scrollListener() {
                var el = this.scrollComponent;
                var scrollEl = window;
                var parentNode = this.getParentElement(el);
                var offset = void 0;
                if (this.props.useWindow) {
                    var doc = document.documentElement || document.body.parentNode || document.body;
                    var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
                    if (this.props.isReverse) offset = scrollTop;
                    else offset = this.calculateOffset(el, scrollTop);
                } else if (this.props.isReverse) offset = parentNode.scrollTop;
                else offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
                // Here we make sure the element is visible as well as checking the offset
                if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
                    this.detachScrollListener();
                    this.beforeScrollHeight = parentNode.scrollHeight;
                    this.beforeScrollTop = parentNode.scrollTop;
                    // Call loadMore after detachScrollListener to allow for non-async loadMore functions
                    if (typeof this.props.loadMore === 'function') {
                        this.props.loadMore(this.pageLoaded += 1);
                        this.loadMore = true;
                    }
                }
            }
        },
        {
            key: 'calculateOffset',
            value: function calculateOffset(el, scrollTop) {
                if (!el) return 0;
                return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
            }
        },
        {
            key: 'calculateTopPosition',
            value: function calculateTopPosition(el) {
                if (!el) return 0;
                return el.offsetTop + this.calculateTopPosition(el.offsetParent);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var renderProps = this.filterProps(this.props);
                var children = renderProps.children, element = renderProps.element, hasMore = renderProps.hasMore, initialLoad = renderProps.initialLoad, isReverse = renderProps.isReverse, loader = renderProps.loader, loadMore = renderProps.loadMore, pageStart = renderProps.pageStart, ref = renderProps.ref, threshold = renderProps.threshold, useCapture = renderProps.useCapture, useWindow = renderProps.useWindow, getScrollParent = renderProps.getScrollParent, props = $a1edf051ac45e2c1$var$_objectWithoutProperties(renderProps, [
                    'children',
                    'element',
                    'hasMore',
                    'initialLoad',
                    'isReverse',
                    'loader',
                    'loadMore',
                    'pageStart',
                    'ref',
                    'threshold',
                    'useCapture',
                    'useWindow',
                    'getScrollParent'
                ]);
                props.ref = function(node) {
                    _this2.scrollComponent = node;
                    if (ref) ref(node);
                };
                var childrenArray = [
                    children
                ];
                if (hasMore) {
                    if (loader) isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
                    else if (this.defaultLoader) isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
                }
                return $a1edf051ac45e2c1$var$_react2.default.createElement(element, props, childrenArray);
            }
        }
    ]);
    return InfiniteScroll;
}($jMaZ8.Component);
$a1edf051ac45e2c1$var$InfiniteScroll.propTypes = {
    children: $a1edf051ac45e2c1$var$_propTypes2.default.node.isRequired,
    element: $a1edf051ac45e2c1$var$_propTypes2.default.node,
    hasMore: $a1edf051ac45e2c1$var$_propTypes2.default.bool,
    initialLoad: $a1edf051ac45e2c1$var$_propTypes2.default.bool,
    isReverse: $a1edf051ac45e2c1$var$_propTypes2.default.bool,
    loader: $a1edf051ac45e2c1$var$_propTypes2.default.node,
    loadMore: $a1edf051ac45e2c1$var$_propTypes2.default.func.isRequired,
    pageStart: $a1edf051ac45e2c1$var$_propTypes2.default.number,
    ref: $a1edf051ac45e2c1$var$_propTypes2.default.func,
    getScrollParent: $a1edf051ac45e2c1$var$_propTypes2.default.func,
    threshold: $a1edf051ac45e2c1$var$_propTypes2.default.number,
    useCapture: $a1edf051ac45e2c1$var$_propTypes2.default.bool,
    useWindow: $a1edf051ac45e2c1$var$_propTypes2.default.bool
};
$a1edf051ac45e2c1$var$InfiniteScroll.defaultProps = {
    element: 'div',
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    ref: null,
    threshold: 250,
    useWindow: true,
    isReverse: false,
    useCapture: false,
    loader: null,
    getScrollParent: null
};
module.exports.default = $a1edf051ac45e2c1$var$InfiniteScroll;
module.exports = module.exports['default'];

});
parcelRegister("3XAKw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $d0jmj = parcelRequire("d0jmj");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $2e236370db985a48$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("kzNba"))($d0jmj.isElement, $2e236370db985a48$var$throwOnDirectAccess);

});
parcelRegister("d0jmj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("91mX9"));

});
parcelRegister("91mX9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $69160311b73e6752$export$2b8d127b894957b9, (v) => $69160311b73e6752$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $69160311b73e6752$export$cea3a54a6425200c, (v) => $69160311b73e6752$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $69160311b73e6752$export$a7c73072b1a182ae, (v) => $69160311b73e6752$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $69160311b73e6752$export$9f27bc3417b4524d, (v) => $69160311b73e6752$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $69160311b73e6752$export$db77ccec0bb4ccac, (v) => $69160311b73e6752$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $69160311b73e6752$export$8392c0c9d3dcbd35, (v) => $69160311b73e6752$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $69160311b73e6752$export$ffb0004e005737fa, (v) => $69160311b73e6752$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $69160311b73e6752$export$b624eff549462981, (v) => $69160311b73e6752$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $69160311b73e6752$export$7897aa7841a5380c, (v) => $69160311b73e6752$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $69160311b73e6752$export$602eac185826482c, (v) => $69160311b73e6752$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $69160311b73e6752$export$e2c29f18771995cb, (v) => $69160311b73e6752$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $69160311b73e6752$export$5f8d39834fd61797, (v) => $69160311b73e6752$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $69160311b73e6752$export$74bf444e3cd11ea5, (v) => $69160311b73e6752$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $69160311b73e6752$export$92387174baf9b227, (v) => $69160311b73e6752$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $69160311b73e6752$export$ec112efeb987d9c6, (v) => $69160311b73e6752$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $69160311b73e6752$export$b706b080d889d2c9, (v) => $69160311b73e6752$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $69160311b73e6752$export$5be5a87408f70ddc, (v) => $69160311b73e6752$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $69160311b73e6752$export$45a5e7f76e0caa8d, (v) => $69160311b73e6752$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $69160311b73e6752$export$455c2e768291efa6, (v) => $69160311b73e6752$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $69160311b73e6752$export$9522e17588c12572, (v) => $69160311b73e6752$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $69160311b73e6752$export$2110ac352bb060b9, (v) => $69160311b73e6752$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $69160311b73e6752$export$56885ab8b9c456ab, (v) => $69160311b73e6752$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $69160311b73e6752$export$d927fcb6adf8f9de, (v) => $69160311b73e6752$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $69160311b73e6752$export$b82d16f27459e05a, (v) => $69160311b73e6752$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $69160311b73e6752$export$522c17b4f5e123e8, (v) => $69160311b73e6752$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $69160311b73e6752$export$1aabd8a0274ecfd6, (v) => $69160311b73e6752$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $69160311b73e6752$export$9b621391a187a31a, (v) => $69160311b73e6752$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $69160311b73e6752$export$f5bbd400c2f4426f, (v) => $69160311b73e6752$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $69160311b73e6752$export$2b8d127b894957b9;
var $69160311b73e6752$export$cea3a54a6425200c;
var $69160311b73e6752$export$a7c73072b1a182ae;
var $69160311b73e6752$export$9f27bc3417b4524d;
var $69160311b73e6752$export$db77ccec0bb4ccac;
var $69160311b73e6752$export$8392c0c9d3dcbd35;
var $69160311b73e6752$export$ffb0004e005737fa;
var $69160311b73e6752$export$b624eff549462981;
var $69160311b73e6752$export$7897aa7841a5380c;
var $69160311b73e6752$export$602eac185826482c;
var $69160311b73e6752$export$e2c29f18771995cb;
var $69160311b73e6752$export$5f8d39834fd61797;
var $69160311b73e6752$export$74bf444e3cd11ea5;
var $69160311b73e6752$export$92387174baf9b227;
var $69160311b73e6752$export$ec112efeb987d9c6;
var $69160311b73e6752$export$b706b080d889d2c9;
var $69160311b73e6752$export$5be5a87408f70ddc;
var $69160311b73e6752$export$45a5e7f76e0caa8d;
var $69160311b73e6752$export$455c2e768291efa6;
var $69160311b73e6752$export$9522e17588c12572;
var $69160311b73e6752$export$2110ac352bb060b9;
var $69160311b73e6752$export$56885ab8b9c456ab;
var $69160311b73e6752$export$d927fcb6adf8f9de;
var $69160311b73e6752$export$b82d16f27459e05a;
var $69160311b73e6752$export$522c17b4f5e123e8;
var $69160311b73e6752$export$1aabd8a0274ecfd6;
var $69160311b73e6752$export$9b621391a187a31a;
var $69160311b73e6752$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $69160311b73e6752$export$2b8d127b894957b9 = AsyncMode;
    $69160311b73e6752$export$cea3a54a6425200c = ConcurrentMode;
    $69160311b73e6752$export$a7c73072b1a182ae = ContextConsumer;
    $69160311b73e6752$export$9f27bc3417b4524d = ContextProvider;
    $69160311b73e6752$export$db77ccec0bb4ccac = Element;
    $69160311b73e6752$export$8392c0c9d3dcbd35 = ForwardRef;
    $69160311b73e6752$export$ffb0004e005737fa = Fragment;
    $69160311b73e6752$export$b624eff549462981 = Lazy;
    $69160311b73e6752$export$7897aa7841a5380c = Memo;
    $69160311b73e6752$export$602eac185826482c = Portal;
    $69160311b73e6752$export$e2c29f18771995cb = Profiler;
    $69160311b73e6752$export$5f8d39834fd61797 = StrictMode;
    $69160311b73e6752$export$74bf444e3cd11ea5 = Suspense;
    $69160311b73e6752$export$92387174baf9b227 = isAsyncMode;
    $69160311b73e6752$export$ec112efeb987d9c6 = isConcurrentMode;
    $69160311b73e6752$export$b706b080d889d2c9 = isContextConsumer;
    $69160311b73e6752$export$5be5a87408f70ddc = isContextProvider;
    $69160311b73e6752$export$45a5e7f76e0caa8d = isElement;
    $69160311b73e6752$export$455c2e768291efa6 = isForwardRef;
    $69160311b73e6752$export$9522e17588c12572 = isFragment;
    $69160311b73e6752$export$2110ac352bb060b9 = isLazy;
    $69160311b73e6752$export$56885ab8b9c456ab = isMemo;
    $69160311b73e6752$export$d927fcb6adf8f9de = isPortal;
    $69160311b73e6752$export$b82d16f27459e05a = isProfiler;
    $69160311b73e6752$export$522c17b4f5e123e8 = isStrictMode;
    $69160311b73e6752$export$1aabd8a0274ecfd6 = isSuspense;
    $69160311b73e6752$export$9b621391a187a31a = isValidElementType;
    $69160311b73e6752$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("kzNba", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $d0jmj = parcelRequire("d0jmj");

var $13w7U = parcelRequire("13w7U");

var $fmMNZ = parcelRequire("fmMNZ");

var $2GECt = parcelRequire("2GECt");

var $lAjEb = parcelRequire("lAjEb");
var $efad397d7e51244d$var$printWarning = function() {};
$efad397d7e51244d$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $efad397d7e51244d$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $fmMNZ) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $efad397d7e51244d$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($efad397d7e51244d$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $fmMNZ);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$d0jmj.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $efad397d7e51244d$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $efad397d7e51244d$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $efad397d7e51244d$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($2GECt(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $fmMNZ);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $efad397d7e51244d$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $efad397d7e51244d$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $efad397d7e51244d$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $efad397d7e51244d$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $fmMNZ);
                if (checkerResult == null) return null;
                if (checkerResult.data && $2GECt(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $fmMNZ);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $13w7U({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($2GECt(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $fmMNZ);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $lAjEb;
    ReactPropTypes.resetWarningCache = $lAjEb.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("13w7U", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $0c4efde8a17014e6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0c4efde8a17014e6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $0c4efde8a17014e6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $0c4efde8a17014e6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $0c4efde8a17014e6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $0c4efde8a17014e6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $0c4efde8a17014e6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($0c4efde8a17014e6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($0c4efde8a17014e6$var$getOwnPropertySymbols) {
            symbols = $0c4efde8a17014e6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($0c4efde8a17014e6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("fmMNZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $b2fec4cd395b6689$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $b2fec4cd395b6689$var$ReactPropTypesSecret;

});

parcelRegister("2GECt", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("lAjEb", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fb6c3341b9c00590$var$printWarning = function() {};

var $fmMNZ = parcelRequire("fmMNZ");
var $fb6c3341b9c00590$var$loggedTypeFailures = {};

var $2GECt = parcelRequire("2GECt");
$fb6c3341b9c00590$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $fb6c3341b9c00590$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($2GECt(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $fmMNZ);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $fb6c3341b9c00590$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $fb6c3341b9c00590$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $fb6c3341b9c00590$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $fb6c3341b9c00590$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $fb6c3341b9c00590$var$checkPropTypes.resetWarningCache = function() {
    $fb6c3341b9c00590$var$loggedTypeFailures = {};
};
module.exports = $fb6c3341b9c00590$var$checkPropTypes;

});




parcelRegister("gwAXn", function(module, exports) {

module.exports = (parcelRequire("15vyw"));

});
parcelRegister("15vyw", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0caebc61a6e9372a$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $0caebc61a6e9372a$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $0caebc61a6e9372a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($0caebc61a6e9372a$var$runtime);
}

});


parcelRegister("9R0na", function(module, exports) {
function $72c95a4a460fd1b7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $72c95a4a460fd1b7$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $72c95a4a460fd1b7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $72c95a4a460fd1b7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $72c95a4a460fd1b7$var$_asyncToGenerator;

});

parcelRegister("fgROT", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $b1e219214e21edc7$export$bf730a2d8bf68b42, (v) => $b1e219214e21edc7$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1e219214e21edc7$export$bf730a2d8bf68b42;
"use strict";


(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("jMaZ8")), shim = (parcelRequire("2MJsr")), objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
    $b1e219214e21edc7$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        var instRef = useRef(null);
        if (null === instRef.current) {
            var inst = {
                hasValue: !1,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        instRef = useMemo(function() {
            function memoizedSelector(nextSnapshot) {
                if (!hasMemo) {
                    hasMemo = !0;
                    memoizedSnapshot = nextSnapshot;
                    nextSnapshot = selector(nextSnapshot);
                    if (void 0 !== isEqual && inst.hasValue) {
                        var currentSelection = inst.value;
                        if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                    }
                    return memoizedSelection = nextSnapshot;
                }
                currentSelection = memoizedSelection;
                if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
                var nextSelection = selector(nextSnapshot);
                if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
                memoizedSnapshot = nextSnapshot;
                return memoizedSelection = nextSelection;
            }
            var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
            return [
                function() {
                    return memoizedSelector(getSnapshot());
                },
                null === maybeGetServerSnapshot ? void 0 : function() {
                    return memoizedSelector(maybeGetServerSnapshot());
                }
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]);
        var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
        useEffect(function() {
            inst.hasValue = !0;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});
parcelRegister("2MJsr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5CQEf"));

});
parcelRegister("5CQEf", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $4189572cae929c89$export$306c0aa65ff9ec16, (v) => $4189572cae929c89$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4189572cae929c89$export$306c0aa65ff9ec16;
"use strict";

(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React.startTransition || (didWarnOld18Alpha = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            objectIs(value, cachedValue) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        cachedValue = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
            return subscribe(function() {
                checkIfSnapshotChanged(inst) && forceUpdate({
                    inst: inst
                });
            });
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("jMaZ8")), objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    $4189572cae929c89$export$306c0aa65ff9ec16 = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



var $4dd4f3cd4c7bf135$exports = {};


(parcelRequire("5cJUx")).register((parcelRequire("hp8un")).getBundleURL('3c0qg'), JSON.parse("[\"3c0qg\",\"index.2da373d9.js\",\"lmUdb\",\"browser.c34197bc.js\",\"grSSn\",\"index.a89ad4c7.css\"]"));

var $954e0e3ebeee9f2b$exports = {};
'use strict';

$954e0e3ebeee9f2b$exports = (parcelRequire("lu5Mq"));




const $940b6a1915fd8540$var$isString = (obj)=>typeof obj === 'string';
const $940b6a1915fd8540$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $940b6a1915fd8540$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $940b6a1915fd8540$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $940b6a1915fd8540$var$lastOfPathSeparatorRegExp = /###/g;
const $940b6a1915fd8540$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($940b6a1915fd8540$var$lastOfPathSeparatorRegExp, '.') : key;
const $940b6a1915fd8540$var$canNotTraverseDeeper = (object)=>!object || $940b6a1915fd8540$var$isString(object);
const $940b6a1915fd8540$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$940b6a1915fd8540$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($940b6a1915fd8540$var$canNotTraverseDeeper(object)) return {};
        const key = $940b6a1915fd8540$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($940b6a1915fd8540$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $940b6a1915fd8540$var$cleanKey(stack[stackIndex])
    };
};
const $940b6a1915fd8540$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $940b6a1915fd8540$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $940b6a1915fd8540$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $940b6a1915fd8540$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $940b6a1915fd8540$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $940b6a1915fd8540$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $940b6a1915fd8540$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $940b6a1915fd8540$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $940b6a1915fd8540$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $940b6a1915fd8540$var$getPath(data, key);
    if (value !== undefined) return value;
    return $940b6a1915fd8540$var$getPath(defaultData, key);
};
const $940b6a1915fd8540$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($940b6a1915fd8540$var$isString(target[prop]) || target[prop] instanceof String || $940b6a1915fd8540$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $940b6a1915fd8540$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $940b6a1915fd8540$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $940b6a1915fd8540$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $940b6a1915fd8540$var$escape = (data)=>{
    if ($940b6a1915fd8540$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$940b6a1915fd8540$var$_entityMap[s]);
    return data;
};
class $940b6a1915fd8540$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $940b6a1915fd8540$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $940b6a1915fd8540$var$looksLikeObjectPathRegExpCache = new $940b6a1915fd8540$var$RegExpCache(20);
const $940b6a1915fd8540$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $940b6a1915fd8540$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $940b6a1915fd8540$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $940b6a1915fd8540$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $940b6a1915fd8540$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $940b6a1915fd8540$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $940b6a1915fd8540$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $940b6a1915fd8540$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($940b6a1915fd8540$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $940b6a1915fd8540$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $940b6a1915fd8540$var$Logger(this.logger, options);
    }
}
var $940b6a1915fd8540$var$baseLogger = new $940b6a1915fd8540$var$Logger();
class $940b6a1915fd8540$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $940b6a1915fd8540$var$ResourceStore extends $940b6a1915fd8540$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($940b6a1915fd8540$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $940b6a1915fd8540$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$940b6a1915fd8540$var$isString(key)) return result;
        return $940b6a1915fd8540$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $940b6a1915fd8540$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($940b6a1915fd8540$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $940b6a1915fd8540$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $940b6a1915fd8540$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $940b6a1915fd8540$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $940b6a1915fd8540$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $940b6a1915fd8540$var$checkedLoadedFor = {};
const $940b6a1915fd8540$var$shouldHandleAsObject = (res)=>!$940b6a1915fd8540$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $940b6a1915fd8540$var$Translator extends $940b6a1915fd8540$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $940b6a1915fd8540$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $940b6a1915fd8540$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key == null) return false;
        const resolved = this.resolve(key, options);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$940b6a1915fd8540$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $940b6a1915fd8540$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $940b6a1915fd8540$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys == null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = options.count !== undefined && !$940b6a1915fd8540$var$isString(options.count);
        const hasDefaultValue = $940b6a1915fd8540$var$Translator.hasDefaultValue(options);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
        const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $940b6a1915fd8540$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($940b6a1915fd8540$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...options,
                        defaultValue: $940b6a1915fd8540$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $940b6a1915fd8540$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $940b6a1915fd8540$var$isString(res) && (options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$940b6a1915fd8540$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey?.[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $940b6a1915fd8540$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && options.applyPostProcessor !== false) res = $940b6a1915fd8540$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($940b6a1915fd8540$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$940b6a1915fd8540$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
            const needsContextHandling = options.context !== undefined && ($940b6a1915fd8540$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$940b6a1915fd8540$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $940b6a1915fd8540$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$940b6a1915fd8540$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $940b6a1915fd8540$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $940b6a1915fd8540$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $940b6a1915fd8540$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $940b6a1915fd8540$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($940b6a1915fd8540$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($940b6a1915fd8540$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($940b6a1915fd8540$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($940b6a1915fd8540$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $940b6a1915fd8540$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $940b6a1915fd8540$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $940b6a1915fd8540$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $940b6a1915fd8540$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const cleanedCode = $940b6a1915fd8540$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $940b6a1915fd8540$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $940b6a1915fd8540$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$940b6a1915fd8540$var$suffixesOrder[pluralCategory1] - $940b6a1915fd8540$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $940b6a1915fd8540$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $940b6a1915fd8540$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $940b6a1915fd8540$var$isString(key)) {
        path = $940b6a1915fd8540$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $940b6a1915fd8540$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $940b6a1915fd8540$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $940b6a1915fd8540$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $940b6a1915fd8540$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $940b6a1915fd8540$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $940b6a1915fd8540$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $940b6a1915fd8540$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $940b6a1915fd8540$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $940b6a1915fd8540$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $940b6a1915fd8540$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $940b6a1915fd8540$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $940b6a1915fd8540$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($940b6a1915fd8540$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$940b6a1915fd8540$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $940b6a1915fd8540$var$regexSafe(this.escape(val)) : $940b6a1915fd8540$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $940b6a1915fd8540$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$940b6a1915fd8540$var$isString(value) && !this.useRawValueToEscape) value = $940b6a1915fd8540$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$940b6a1915fd8540$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$940b6a1915fd8540$var$isString(value)) return value;
            if (!$940b6a1915fd8540$var$isString(value)) value = $940b6a1915fd8540$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $940b6a1915fd8540$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $940b6a1915fd8540$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($940b6a1915fd8540$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $940b6a1915fd8540$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $940b6a1915fd8540$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $940b6a1915fd8540$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $940b6a1915fd8540$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $940b6a1915fd8540$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $940b6a1915fd8540$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $940b6a1915fd8540$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $940b6a1915fd8540$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $940b6a1915fd8540$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $940b6a1915fd8540$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $940b6a1915fd8540$var$Connector extends $940b6a1915fd8540$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $940b6a1915fd8540$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $940b6a1915fd8540$var$pushPath(q.loaded, [
                lng
            ], ns);
            $940b6a1915fd8540$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($940b6a1915fd8540$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($940b6a1915fd8540$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $940b6a1915fd8540$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($940b6a1915fd8540$var$isString(args[1])) ret.defaultValue = args[1];
            if ($940b6a1915fd8540$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $940b6a1915fd8540$var$transformOptions = (options)=>{
    if ($940b6a1915fd8540$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($940b6a1915fd8540$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($940b6a1915fd8540$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $940b6a1915fd8540$var$noop = ()=>{};
const $940b6a1915fd8540$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $940b6a1915fd8540$var$I18n extends $940b6a1915fd8540$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $940b6a1915fd8540$var$transformOptions(options);
        this.services = {};
        this.logger = $940b6a1915fd8540$var$baseLogger;
        this.modules = {
            external: []
        };
        $940b6a1915fd8540$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($940b6a1915fd8540$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $940b6a1915fd8540$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$940b6a1915fd8540$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $940b6a1915fd8540$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $940b6a1915fd8540$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $940b6a1915fd8540$var$Formatter;
            const lu = new $940b6a1915fd8540$var$LanguageUtil(this.options);
            this.store = new $940b6a1915fd8540$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $940b6a1915fd8540$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $940b6a1915fd8540$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $940b6a1915fd8540$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $940b6a1915fd8540$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $940b6a1915fd8540$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $940b6a1915fd8540$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $940b6a1915fd8540$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $940b6a1915fd8540$var$noop;
        let usedCallback = callback;
        const usedLng = $940b6a1915fd8540$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $940b6a1915fd8540$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $940b6a1915fd8540$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $940b6a1915fd8540$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $940b6a1915fd8540$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $940b6a1915fd8540$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($940b6a1915fd8540$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.translator?.translate(...args);
    }
    exists() {
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $940b6a1915fd8540$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($940b6a1915fd8540$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $940b6a1915fd8540$var$defer();
        if ($940b6a1915fd8540$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $940b6a1915fd8540$var$LanguageUtil($940b6a1915fd8540$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $940b6a1915fd8540$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $940b6a1915fd8540$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $940b6a1915fd8540$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                return Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, {});
            }, {});
            clone.store = new $940b6a1915fd8540$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $940b6a1915fd8540$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $940b6a1915fd8540$export$2e2bcd8739ae039 = $940b6a1915fd8540$var$I18n.createInstance();
$940b6a1915fd8540$export$2e2bcd8739ae039.createInstance = $940b6a1915fd8540$var$I18n.createInstance;
const $940b6a1915fd8540$export$99152e8d49ca4e7d = $940b6a1915fd8540$export$2e2bcd8739ae039.createInstance;
const $940b6a1915fd8540$export$147ec2801e896265 = $940b6a1915fd8540$export$2e2bcd8739ae039.dir;
const $940b6a1915fd8540$export$2cd8252107eb640b = $940b6a1915fd8540$export$2e2bcd8739ae039.init;
const $940b6a1915fd8540$export$d3d08d944062d7e = $940b6a1915fd8540$export$2e2bcd8739ae039.loadResources;
const $940b6a1915fd8540$export$a5d9bf5d83fcab09 = $940b6a1915fd8540$export$2e2bcd8739ae039.reloadResources;
const $940b6a1915fd8540$export$1f96ae73734a86cc = $940b6a1915fd8540$export$2e2bcd8739ae039.use;
const $940b6a1915fd8540$export$61465194746e7fd2 = $940b6a1915fd8540$export$2e2bcd8739ae039.changeLanguage;
const $940b6a1915fd8540$export$f90d180fc7da3b3b = $940b6a1915fd8540$export$2e2bcd8739ae039.getFixedT;
const $940b6a1915fd8540$export$625550452a3fa3ec = $940b6a1915fd8540$export$2e2bcd8739ae039.t;
const $940b6a1915fd8540$export$f7e9f41ea797a17 = $940b6a1915fd8540$export$2e2bcd8739ae039.exists;
const $940b6a1915fd8540$export$2b4b218e406d2d00 = $940b6a1915fd8540$export$2e2bcd8739ae039.setDefaultNamespace;
const $940b6a1915fd8540$export$93d9ee97c1ad3f31 = $940b6a1915fd8540$export$2e2bcd8739ae039.hasLoadedNamespace;
const $940b6a1915fd8540$export$83be934b53fff43b = $940b6a1915fd8540$export$2e2bcd8739ae039.loadNamespaces;
const $940b6a1915fd8540$export$8cd7e7a54fa865bc = $940b6a1915fd8540$export$2e2bcd8739ae039.loadLanguages;


const { slice: $80c641d65f99e090$var$slice, forEach: $80c641d65f99e090$var$forEach } = [];
function $80c641d65f99e090$var$defaults(obj) {
    $80c641d65f99e090$var$forEach.call($80c641d65f99e090$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
const $80c641d65f99e090$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $80c641d65f99e090$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$80c641d65f99e090$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$80c641d65f99e090$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
const $80c641d65f99e090$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $80c641d65f99e090$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name) {
        this.create(name, '', -1);
    }
};
var $80c641d65f99e090$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $80c641d65f99e090$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $80c641d65f99e090$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $80c641d65f99e090$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
let $80c641d65f99e090$var$hasLocalStorageSupport = null;
const $80c641d65f99e090$var$localStorageAvailable = ()=>{
    if ($80c641d65f99e090$var$hasLocalStorageSupport !== null) return $80c641d65f99e090$var$hasLocalStorageSupport;
    try {
        $80c641d65f99e090$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $80c641d65f99e090$var$hasLocalStorageSupport = false;
    }
    return $80c641d65f99e090$var$hasLocalStorageSupport;
};
var $80c641d65f99e090$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $80c641d65f99e090$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $80c641d65f99e090$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $80c641d65f99e090$var$hasSessionStorageSupport = null;
const $80c641d65f99e090$var$sessionStorageAvailable = ()=>{
    if ($80c641d65f99e090$var$hasSessionStorageSupport !== null) return $80c641d65f99e090$var$hasSessionStorageSupport;
    try {
        $80c641d65f99e090$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $80c641d65f99e090$var$hasSessionStorageSupport = false;
    }
    return $80c641d65f99e090$var$hasSessionStorageSupport;
};
var $80c641d65f99e090$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $80c641d65f99e090$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $80c641d65f99e090$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $80c641d65f99e090$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $80c641d65f99e090$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $80c641d65f99e090$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $80c641d65f99e090$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $80c641d65f99e090$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $80c641d65f99e090$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $80c641d65f99e090$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$80c641d65f99e090$var$canCookies) $80c641d65f99e090$var$order.splice(1, 1);
const $80c641d65f99e090$var$getDefaults = ()=>({
        order: $80c641d65f99e090$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $80c641d65f99e090$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $80c641d65f99e090$var$defaults(options, this.options || {}, $80c641d65f99e090$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($80c641d65f99e090$var$cookie$1);
        this.addDetector($80c641d65f99e090$var$querystring);
        this.addDetector($80c641d65f99e090$var$localStorage);
        this.addDetector($80c641d65f99e090$var$sessionStorage);
        this.addDetector($80c641d65f99e090$var$navigator$1);
        this.addDetector($80c641d65f99e090$var$htmlTag);
        this.addDetector($80c641d65f99e090$var$path);
        this.addDetector($80c641d65f99e090$var$subdomain);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$80c641d65f99e090$export$2e2bcd8739ae039.type = 'languageDetector';


var $b2328b5afe5d8205$exports = {};
function $b2328b5afe5d8205$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$b2328b5afe5d8205$exports = $b2328b5afe5d8205$var$_classCallCheck, $b2328b5afe5d8205$exports.__esModule = true, $b2328b5afe5d8205$exports["default"] = $b2328b5afe5d8205$exports;


var $3f67b36b2deed136$exports = {};

var $giHIY = parcelRequire("giHIY");
function $3f67b36b2deed136$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $giHIY(o.key), o);
    }
}
function $3f67b36b2deed136$var$_createClass(e, r, t) {
    return r && $3f67b36b2deed136$var$_defineProperties(e.prototype, r), t && $3f67b36b2deed136$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$3f67b36b2deed136$exports = $3f67b36b2deed136$var$_createClass, $3f67b36b2deed136$exports.__esModule = true, $3f67b36b2deed136$exports["default"] = $3f67b36b2deed136$exports;



var $17meZ = parcelRequire("17meZ");

var $jMaZ8 = parcelRequire("jMaZ8");
var $ff61399ec7a60bbe$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $ff61399ec7a60bbe$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $ff61399ec7a60bbe$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $ff61399ec7a60bbe$var$htmlEntities[m];
};
var $ff61399ec7a60bbe$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($ff61399ec7a60bbe$var$matchHtmlEntity, $ff61399ec7a60bbe$var$unescapeHtmlEntity);
};


function $484ec22414fe72b1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $484ec22414fe72b1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $484ec22414fe72b1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($17meZ)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $484ec22414fe72b1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $484ec22414fe72b1$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $ff61399ec7a60bbe$export$e8bacd2802a88316)
};
var $484ec22414fe72b1$var$i18nInstance;
var $484ec22414fe72b1$export$5603ab5ced17ce64 = (0, $jMaZ8.createContext)();
function $484ec22414fe72b1$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $484ec22414fe72b1$var$defaultOptions = $484ec22414fe72b1$var$_objectSpread($484ec22414fe72b1$var$_objectSpread({}, $484ec22414fe72b1$var$defaultOptions), options);
}
function $484ec22414fe72b1$export$212bb2fc580a90a8() {
    return $484ec22414fe72b1$var$defaultOptions;
}
var $484ec22414fe72b1$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b2328b5afe5d8205$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($3f67b36b2deed136$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $484ec22414fe72b1$export$a039134f2fc7e0(instance) {
    $484ec22414fe72b1$var$i18nInstance = instance;
}
function $484ec22414fe72b1$export$64af334f494c2f47() {
    return $484ec22414fe72b1$var$i18nInstance;
}
var $484ec22414fe72b1$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        $484ec22414fe72b1$export$2e2366488d12e20d(instance.options.react);
        $484ec22414fe72b1$export$a039134f2fc7e0(instance);
    }
};
function $484ec22414fe72b1$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $484ec22414fe72b1$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($484ec22414fe72b1$var$_objectSpread($484ec22414fe72b1$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $484ec22414fe72b1$export$704200e5d0b9e8f() {
    var i18n = $484ec22414fe72b1$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $fEEQL = parcelRequire("fEEQL");

var $17meZ = parcelRequire("17meZ");

var $jMaZ8 = parcelRequire("jMaZ8");

function $a964fc94c5cf2678$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $a964fc94c5cf2678$var$alreadyWarned = {};
function $a964fc94c5cf2678$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $a964fc94c5cf2678$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $a964fc94c5cf2678$var$alreadyWarned[args[0]] = new Date();
    $a964fc94c5cf2678$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $a964fc94c5cf2678$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function $a964fc94c5cf2678$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $a964fc94c5cf2678$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $a964fc94c5cf2678$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $a964fc94c5cf2678$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $a964fc94c5cf2678$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


function $2dea202f423e126f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2dea202f423e126f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2dea202f423e126f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($17meZ)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2dea202f423e126f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2dea202f423e126f$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $jMaZ8.useRef)();
    (0, $jMaZ8.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $2dea202f423e126f$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $jMaZ8.useContext)((0, $484ec22414fe72b1$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $484ec22414fe72b1$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $484ec22414fe72b1$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $a964fc94c5cf2678$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $a964fc94c5cf2678$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $2dea202f423e126f$var$_objectSpread($2dea202f423e126f$var$_objectSpread($2dea202f423e126f$var$_objectSpread({}, (0, $484ec22414fe72b1$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $a964fc94c5cf2678$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $jMaZ8.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($fEEQL)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $2dea202f423e126f$var$usePrevious(joinedNS);
    var isMounted = (0, $jMaZ8.useRef)(true);
    (0, $jMaZ8.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $a964fc94c5cf2678$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $jMaZ8.useRef)(true);
    (0, $jMaZ8.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $a964fc94c5cf2678$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}


var $87cac0e08838a3a2$exports = {};
$87cac0e08838a3a2$exports = JSON.parse('{"authentication":{"SignInWidget":{"text":"Connecter avec Google"}},"library":{"index":{"newProject":{"title":"Ajouter un livre"},"projectCard":{"menu":{"modifies":"Modifier","export":" Exporter le projet","exportNarration":"Exporter le projet pour la narration","invite":"Inviter un collaborateur","delete":"Supprimer","exportEPub":"Export du projet (epub)","viewExports":"Voir les exports","resync":"Lancer une re-synchro audio"},"button":{"date":"Todo Date Format","title":"Acc\xe9der au texte"}},"menu":{"signOut":"Se d\xe9connecter"},"default":{"export":{"message":"Export du projet {{name}} en cours","serverErrorMessage":"Le serveur a renvoy\xe9 une erreur","successNotification":"T\xe9l\xe9charger {{name}}","type":"octet/stream","errorNotification":"Une erreur est survenue \xe0 l\'export","colorationOptions":"Options de coloration","audioOption":"Audios","audioOptionCheckbox":"Inclure les audios"},"exportNarration":{"message":"Export (narration) du projet {{name}} en cours","serverErrorMessage":"Le serveur a renvoy\xe9 une erreur","successNotification":"T\xe9l\xe9charger {{name}}","type":"octet/stream","errorNotification":"Une erreur est survenue \xe0 l\'export","exportsTabLabel":"Exports"},"project":{"errorMessage":"L\'import du livre \xe0 \xe9chou\xe9","successMessage":"Le livre est en cours d\'import"},"navBar":{"title":"Biblioth\xe8que","tabTitle":"Tous","errorMessage":"Une erreur est survenue, il est impossible de retrouver la liste des projets pour l\'instant"}}},"inviteModal":{"title":"Inviter un collaborateur","email":"Email du collaborateur","invite":"Inviter"}},"project":{"a4Page":{"placeholder":"Nommez votre chapitre","showMore":"Afficher plus"},"actionBar":{"stepComp":{"raw":"Brut","inProgress":"En pr\xe9paration","toReview":"\xc0 corriger","done":"Termin\xe9"},"getStepLabel":{"formatting":"Segmentation","definition":"D\xe9finitions","syllables":"Syllabation","rhese":"Rh\xe9sage","dialogues":"Dialogues","narration":"Narration"},"projectInfo":{"title":"Informations","description":"Informations num\xe9riques","charsNumber":"Nombre de caract\xe8res:","defsNumber":"Nombre de d\xe9finitions:","imagesNumber":"Nombre d\'images:","pageNumber":"Nombre de pages:","rhesesNumber":"Nombre de rh\xe8ses:","wordsNumber":"Nombre de mots:","listTitle":"Types de paragraphes","export":"Exporter en CSV"},"checklist":{"title":"Checklist"},"userAccess":{"title":"Collaborateurs"},"default":{"tabPaneTitle":{"preview":"Vue g\xe9n\xe9rale","rhese":"Rh\xe9sage","formatting":"Mise en Page","definitions":"Mode D\xe9finitions","dialogues":"Mode Dialogues","syllables":"Mode Syllables","narration":"Mode Narration"}},"projectTabs":{"info":"Informations","checklist":"Checklist","access":"Collaborateurs","config":"Configuration","progress":"Avancement"},"config":{"title":"Configuration des cl\xe9s","customColoration":{"title":"Configuration de la coloration personnalis\xe9e","add":"Ajouter une nouvelle cl\xe9e de coloration"},"customParagraphTag":{"title":"Configuration des \xe9tiquettes de paragraphes","add":"Ajouter une nouvelle \xe9tiquette"}},"progress":{"title_state_preparation":"En cours de pr\xe9paration","title_state_narration":"En cours de narration","title_state_narrationComplete":"Narration compl\xe8te","title_state_narrationAndFixComplete":"Narration et correction compl\xe8tes","title_state_bookCompleted":"Livre marqu\xe9 comme \xe9tant termin\xe9","preparing":{"title":"En pr\xe9paration","legendReadyToNarrate":"Les t\xe2ches n\xe9cessaires pour la narration sont en cours de pr\xe9paration","buttonReadyToNarrate":"Valider pour narration","legendPreparationComplete":"Les t\xe2ches compl\xe9mentaires sont en cours de pr\xe9paration","buttonPreparationComplete":"Valider la pr\xe9paration"},"prepared":{"title":"Pr\xe9par\xe9","legendTasksForNarrationComplete":"Les t\xe2ches n\xe9cessaires pour la narration sont termin\xe9es","buttonReadyToNarrate":"Pr\xeat \xe0 narrer","legendPreparationComplete":"Toutes les t\xe2ches de pr\xe9paration sont termin\xe9es","buttonPreparationComplete":"Pr\xe9paration termin\xe9e"},"narration":{"title":"En narration","narratedPages":"Pages narr\xe9es","narratedDefinitions":"D\xe9finitions narr\xe9es","proofListening":"Proof Listening","remainingCorrections":"Corrections restantes","buttonDone":"Marquer le livre comme \xe9tant termin\xe9","markNarrationDone":"Valider la narration","narrationDone":"Narration valid\xe9e"},"preparationAndNarration":{"markBookComplete":"Marquer le livre comme \xe9tant termin\xe9"},"bookCompleted":{"legend":"Un livre archiv\xe9 est supprim\xe9 \xe0 l\'affichage dahs la biblioth\xe8que des diff\xe9rents acteurs.","legendBis":"Pour le d\xe9sarchiver, contacter le d\xe9veloppeur.","button":"Archiver"},"bookStateStatus":{"not_ready":"En pr\xe9paration","ready_for_narration":"En narration","narration_complete":"Narration compl\xe8te","complete":"Pr\xeat pour la validation","complete_book":"Termin\xe9","archived":"Archiv\xe9","resync":"En re-synchro"},"archived":{"title":"Archiv\xe9","buttonUnarchive":"D\xe9sarchiver"}}},"existing":{"bookRenderer":{"paraghapLabel":{"citation":"Citation","dialogue":"dialogue","didascalie":"Didascalie","email":"Email","intro":"Intro","normal":"Normal","note":"Note","resume":"R\xe9sum\xe9","vers":"Vers","center":"Centre","mail":"Courrier","right":"Droite","space":"Espace","bold":"Gras","text":"Texto","title1":"Titre1","title2":"Titre2","title3":"Titre3","title4":"Titre4","title5":"Titre5","title6":"Titre6","listUnordered":"Liste non ordonn\xe9e","listOrdered":"Liste ordonn\xe9e","listDefinition":"Liste de d\xe9finitions"}},"index":{"syllableComponent":{"syllables":"Syllabes","phonemes":"Phon\xe8mes","custom":"Personnalis\xe9e"},"pageBar":{"mutePage":"Page(s) muette(s)"},"goToPage":{"nav":"Aller \xe0 ...","validation":"OK"}},"editingMode":{"definition":{"buildDefinitionMenu":{"associates":"Associer \xe0 la d\xe9finition","modifies":" Modifier la d\xe9finition","add":"Ajouter une d\xe9finition","dissociate":"Dissocier de la d\xe9finition"},"content":{"all":"Toutes les d\xe9finitions","explicit":"D\xe9finitions explicites","implicit":"D\xe9finitions implicites","foot_note":"Notes de bas de page","image":"Avec image"},"definitionModal":{"message":{"assign":"Assigner \xe0 la d\xe9finition","update":"Enregistrer les modifications","create":"Cr\xe9er une d\xe9finition"},"radioButton":{"explicit":"D\xe9finitions explicites","implicit":"D\xe9finitions implicites","foot_note":"Notes de bas de page","image":"Avec image"},"textArea":{"placeholder":"R\xe9digez la d\xe9finition..."},"imageName":{"placeholder":"Nom de l\'image"}}},"formatting":{"dropZone":"Ajouter une image","menu":{"titre_1":"Titre de niveau 1","titre_2":"Titre de niveau 2","titre_3":"Titre de niveau 3","titre_4":"Titre de niveau 4","normal":"Normal","dialogue":"Dialogue","intro":"Introduction","resume":"R\xe9sum\xe9","email":"Email","citation":"Citation","vers":"Vers","didascalie":"Didascalie","note":"Note","subMenuTitleTransformsTitle":"Transformer en titre...","subMenuTitleAlign":"Aligner...","space":"Espace","center":"Au centre","right":"\xc0 droite","subMenuTitleTransformsParagraph":"Transformer en paragraphe...","subMenuTitleException":"Exceptions...","bold":"Gras","text":"Texto","mail":"Courrier","rheseAction":"Segmenter apr\xe8s la rh\xe8se","spaceAction":{"normal":"Transformer en espace","unbreakable":"Transformer en espace ins\xe9cable"},"lineSuppression":{"normal":"Supprimer le retour \xe0 la ligne","afterRhese":"Retourner \xe0 la ligne apr\xe8s la rh\xe8se"},"titre_5":"Titre de niveau 5","titre_6":"Titre de niveau 6","subMenuList":"Listes...","listUnordered":"Non ordonn\xe9e","listOrdered":"Ordonn\xe9e","listDefinition":"D\xe9finitions","list":"Liste","addClassesAction":"Ajouter des classes css custom","removeClassesAction":"Supprimer les classes css custom"},"lettersCount":{"form":{"name":"basic","item":{"imageNaming":{"label":"Nom de l\'image","name":"fileName"},"validation":"Valider","imageDescription":{"label":"Description de l\'image","name":"description"},"radioButton":{"normal":"Normal","popup":"Popup"}}},"result":"{{lettersCount}} caract\xe8res"},"default":{"modal":{"title":"Ajouter une image"},"form":{"imageNaming":{"label":"Nom de l\'image","name":"name"},"validation":"Valider","imageDescription":{"label":"Description de l\'image","name":"author"},"radioButton":{"normal":"Normal","popup":"Popup"},"figcaption":{"label":"L\xe9gende de l\'image","name":"figcaption"}},"tooltip":{"title":"Ajouter une image"}},"associateToSpeaker":{"title":"Associer au locuteur","name":"Nom du locuteur","alphaNumError":"La valeur saisie doit \xeatre alphanum\xe9rique","dissociate":"Dissocier du locuteur"},"modalCustomCss":{"title":"Custom CSS classes","modalOkLabel":"Mettre \xe0 jour","ovverideWarning":"Les \xe9l\xe9ments s\xe9lectionn\xe9s ne partagent pas les m\xeames classes. La validation d\'une nouvelle entr\xe9e entra\xeenera la perte des anciennes.","inputPlaceholder":"ma-classe1, ma-classe2"}},"narration":{"section":{"minutes":"minutes"},"default":{"title":"Segments audio"}},"rhese":{"index":{"rhesesRenderer":{"menu":{"merge":"Fusionner les rhese","creat":"Cr\xe9er une rhese","split":"Scinder la rhese"},"edit":"\xc9diter"}}},"syllable":{"buildSyllableMenu":{"creat":"Cr\xe9er une syllabe","transformMute":"Transformer en lettre(s) muette(s)","transformNoMute":"Transformer en lettre(s) non muette(s)","ignore":"Ignorer la syllabe"},"buildPhonemeMenu":{"title":"Assigner \xe0 un phon\xe8me","vowel":"Voyelle","consonant":"Consonne","complex":"Complexe","transformMute":"Transformer en lettre(s) muette(s)","transformNoMute":"Transformer en lettre(s) non muette(s)","ignore":"Ignorer la phon\xe9mique"},"buildCustomColorsMenu":{"assignCustomColor":"Assigner comme","removeCustomColor":"Enlever la coloration"}}}},"search":{"getSearchModeLabel":{"id":"Identifiant","text":"Text"},"nbResults":{"loading":"En cours de chargement","result":"r\xe9sultat","results":"r\xe9sultats"}},"edit":{"modalTitle":"\xc9diter un livre","form":{"bookName":"Nom du livre","bookAuthor":"Nom de l\'autheur","locale":"Language","modifies":"Modifier"}},"new":{"stepOne":{"title":"Texte du livre","importType":"Type d\'import","successMessage":": fichier import\xe9 avec succ\xe8s.","errorMessage":":  \xe9chec lors de l\'import du fichier..","uploadOutlined":"Rechercher sur votre ordinateur...","import":"Importer","rhesedText":"Texte rhes\xe9","text":"Texte","htmlBook":"HTML","locale":"Langue du livre","jsonImport":"JSON","disableColorationOnSimpleWords":"D\xe9sactiver la coloration sur les mots simples"},"stepTwo":{"title":"Titre","titlePlaceholder":"ex. La Peste","author":"Auteur","authorPlaceholder":"ex. Albert Camus","ean":"EAN","eanPlaceholder":"9782070360420","create":"Cr\xe9er"},"modalTitle":"Ajouter un livre"},"importStatus":{"failed":{"title":"Projet inaccessible","message":"L\'import du projet a \xe9chou\xe9","action":"Retourner \xe0 la liste des projets"},"inProgress":{"title":"Projet inaccessible","message":"L\'import du projet est toujours en cours","action":"Retourner \xe0 la liste des projets"},"loading":{"title":"Chargement en cours","message":"Merci de patientier quelques instants"}}},"userAccess":{"userTable":{"title":"R\xf4le","preparer":"Pr\xe9parateur","correction":"Correcteur"},"tasksLabels":{"definition":"D\xe9finition","dialogues":"Dialogues","formatting":"Mise en page","narration":"Narration","rhese":"Rh\xe8sage","syllables":"Syllabation"}},"locale":{"fr_FR":"Fran\xe7ais","en_GB":"Anglais","it_IT":"Italien","sv_SE":"Su\xe9dois"},"page":"PAGE","paragraphe":"Paragraphe","on":"sur","tagTheParagraph":"\xc9tiquetter","removeTagFromParagraph":"Enlever l\'\xe9tiquette","selectADefinition":"S\xe9lectionner une d\xe9finition","associateToDefinition":"Associer \xe0 la d\xe9finition","editor":"Editeur","narrator":"Narrateur","prooflistener":"Contr\xf4leur audio","audioLibrarty":"Biblioth\xe8que audio","GQLError.cannotUpdateRheseContent.message":"Impossible de modifier la rh\xe8se","GQLError.cannotUpdateRheseContent.description":"La rh\xe8se est d\xe9j\xe0 associ\xe9e \xe0 un fichier audio et ne peut pas \xeatre modifi\xe9e","select_recorgind_issue_type":"S\xe9lectionner le type de remarque","audioReview.bad_speech":"Prononciation","audioReview.bad_text":"Mauvais texte","audioReview.recording":"Probl\xe8me d\'enregistrement","audioReview.valid":"Ok","audioReview.comment":"Commenter","audioReview.typeYourComment":"Ajouter votre commentaire","audioReview.addAReviewToSelectedRheses":"Ajouter une remarque aux rh\xe8ses s\xe9lectionn\xe9es","cancel":"Annuler","apply":"Appliquer","reset":"R\xe9initialiser","validate":"Valider","confirm":"Confirmer","warning":"Attention","startOffset":"D\xe9calage du d\xe9but","endOffset":"D\xe9calage de la fin","audioOffset":"D\xe9caler l\'audio","listen":"\xc9couter","offsetConfigIsInvalid":"Le r\xe9glage est invalide","listenToTheRecording":"\xc9couter l\'enregistrement","proofListening.pageNotFullyRecordedTitle":"Cette page du livre n\'a pas encore \xe9t\xe9 narr\xe9e.","proofListening.pageNotFullyRecordedButtonLabel":"Retour","definitions":"D\xe9finitions","rheses":"Rh\xe8ses","loadingError":"Une erreur s\'est produite lors du chargement","customCssClassesUsed":"Classes CSS personnalis\xe9es utilis\xe9es","audioReview.bad_text_and_narration":"Pb texte+narration","audioReview.commentName":"Commentaire","audioReview.resetStatusBtn":"Supprimer les remarques","audioReview.resetStatusModalTitle":"\xcates-vous s\xfbr ?","audioReview.resetStatusModalText":"Attention, cette action va supprimer les statuts des rheses s\xe9lectionn\xe9es, mais aussi leurs commentaires.","audioReview.resetStatusModalBtn":"Supprimer","definitionRecordedAudioUploadSuccess":"Le fichier a bien \xe9t\xe9 enregistr\xe9","definitionRecordedAudioUploadError":"Erreur, le fichier n\'a pas \xe9t\xe9 enregistr\xe9","definitionAudioUploadSuccess":"Le fichier a bien \xe9t\xe9 enregistr\xe9","definitionAudioUploadError":"Erreur, le fichier n\'a pas \xe9t\xe9 enregistr\xe9","definitionAudioUploadErrorSize":"Le fichier ne doit pas d\xe9passer","definitionAudioUploadErrorExtension":"Extension non support\xe9e. Veuillez utiliser les extensions suivantes","filterWithIssues":"Avec probl\xe8mes","filterAudioComplete":"Avec audio complet","filterRenarrated":"Renarr\xe9","filterNotAudioSynced":"Audio d\xe9synchronis\xe9 du texte","audioReview.renarrated":"Renarr\xe9","rheseIgnoreSyncroMenuItemLabel":"Ignorer cette rh\xe8se en synchronisation","rheseUseSyncroMenuItemLabel":"Ok pour synchronisation","rheseUseSyncroDialogTitle":"Validez-vous cette op\xe9ration ?","rheseUseSyncroDialogOk":"Valider","rheseUseSyncroDialogCancel":"Annuler","rheseIconSyncroTooltip":"Rh\xe8se non synchronis\xe9e","forceChange":"Forcer la modification","adminCanForceChange":"Vous pouvez forcer la modification","forcedUpdateWillDeleteAssociatedAudio":"Forcer la mise \xe0 jour va supprimer les audios associ\xe9s","serverHasSentError":"Le serveur a renvoy\xe9 une erreur","errorHasBeenSentToTechStaff":"Elle a automatiquement \xe9t\xe9 transmise \xe0 l\'\xe9quipe technique","downloadErrorReport":"T\xe9l\xe9charger le rapport d\'erreur","tabArchivesLabel":"Archives","exportType_DEFINITIONS":"D\xe9finitions","exportType_FULL":"Complet","exportType_HTML":"HTML","exportType_INTO_IMPORTED_EPUB":"ePub","exportType_NARRATION":"Simplifi\xe9","exportType_SIMPLE":"Simplifi\xe9","tableExportsColumnStatus":"Statut","tableExportsColumnType":"Type","tableExportsColumnProjectName":"Livre","tableExportsColumnAuthor":"Utilisateur","tableExportsColumnCreatedAt":"D\xe9marr\xe9 \xe0","tableExportsColumnCompletedAt":"Termin\xe9 \xe0","tableExportsColumnDuration":"Dur\xe9e","tableExportsColumnIncludeAudio":"Audio inclus","tableExportsColumnConfig":"Config","tableExportsColumnAction":"Action","tableExportsRetentionInfo":"Les exports r\xe9ussis restent affich\xe9s pour une p\xe9riode de 24h","modalConfirmReSync":"La re-synchronisation audio d\'un projet entra\xeene son blocage durant tout le traitement.\\nConfirmez-vous l\'action ?","modalConfirmDelete":"Est-ce que vous confirmez la suppression de ce projet ?","overlayReSync":"Projet en cours de re-synchronisation","tabArchivesNoResult":"Pas de livres archiv\xe9s","proofListeningDataChanged":"R\xe9initialisation du lecteur audio, d\xfb \xe0 un changement de fichier(s) audios","revokeUserAccess":"R\xe9voquer l\'acc\xe8s d\'un utilisateur","userEmail":"Email de l\'utilisateur","revokeUser":"R\xe9voquer l\'utilisateur","filterLabelWith":"Avec","filterLabelWithout":"Sans","proofListening.pageOnlyAccessibleToAdmin":"Cette page n\'est accessible qu\'aux narrateurs et aux administrateurs car la narration n\'est pas termin\xe9e.","project.existing.bookRenderer.paraghapLabel.r\xe9sum\xe9":"R\xe9sum\xe9","reload.project":"Recharger le projet","recording.automaticGainControl":"Gain automatique","recording.noiseCancelling":"R\xe9duction du bruit","recording.echoReduction":"R\xe9duction de l\'\xe9cho","project.syllables.applyingToAll":"Application de toutes les syllabes","project.syllables.applyingToAllSuccess":"Les {{syllablesCount}} syllabes ont \xe9t\xe9 appliqu\xe9es","project.syllables.applyError":"Erreur lors de l\'application des syllabes","project.syllables.title":"Extracteur de syllabes","project.syllables.applyToAll":"Appliquer \xe0 toutes les syllabes","project.syllables.noResults":"Aucun r\xe9sultat trouv\xe9","project.syllables.helpText":"Utilisez une expression r\xe9guli\xe8re pour extraire les syllabes.","project.syllables.caseSensitivity":"Sensibilit\xe9 \xe0 la casse","project.syllables.searchButton":"Rechercher","project.syllables.remove":"Suppression","project.syllables.add":"Ajout","project.syllables.loading":"Chargement","project.syllables.results":"R\xe9sultats","project.syllables.result":"R\xe9sultat","project.phonemes.applyingToAll":"Application de tous les phon\xe8mes","project.phonemes.applyingToAllSuccess":"Les {{phonemesCount}} phon\xe8mes ont \xe9t\xe9 appliqu\xe9s","project.phonemes.applyError":"Erreur lors de l\'application des phon\xe8mes","project.phonemes.title":"Extracteur de phon\xe8mes","project.phonemes.applyToAll":"Appliquer \xe0 tous les phon\xe8mes","project.phonemes.noResults":"Aucun r\xe9sultat trouv\xe9","project.phonemes.helpText":"Utilisez une expression r\xe9guli\xe8re pour extraire les phon\xe8mes.","project.phonemes.caseSensitivity":"Sensibilit\xe9 \xe0 la casse","project.phonemes.searchButton":"Rechercher","project.phonemes.remove":"Suppression","project.phonemes.add":"Ajout","project.phonemes.loading":"Chargement","project.phonemes.results":"R\xe9sultats","project.phonemes.result":"R\xe9sultat"}');


var $4807a32193977e74$exports = {};
$4807a32193977e74$exports = JSON.parse('{"authentication":{"SignInWidget":{"text":"Connect with Google"}},"library":{"index":{"newProject":{"title":"Add a book"},"projectCard":{"menu":{"modifies":"Edit","export":"Export the project","exportNarration":"Export the project for Narration","invite":"Invite a collaborator","delete":"Delete","exportEPub":"Export (epub)","viewExports":"Voir les exports","resync":"Lancer une re-synchro audio"},"button":{"date":"Todo Date Format","title":"Go the text"}},"menu":{"signOut":"Logout"},"default":{"export":{"message":"Project {{name}} export on-going","serverErrorMessage":"Internal server error","successNotification":"Download {{name}}","type":"octet/stream","errorNotification":"An error occurred in the export","colorationOptions":"Coloring options","audioOption":"Audio","audioOptionCheckbox":"Include audio"},"exportNarration":{"message":"Export (narrative) of the current {{name}} project","serverErrorMessage":"The server returned an error","successNotification":"Download {{name}}","type":"octet/stream","errorNotification":"An error occurred in the export","exportsTabLabel":"Exports"},"project":{"errorMessage":"The book import failed","successMessage":"The book is being imported"},"navBar":{"title":"Shelf","tabTitle":"All","errorMessage":"An error has occurred, it is impossible to find the list of projects for the moment"}}},"inviteModal":{"title":"Invite a colleague","email":"Colleague\'s email","invite":"Invite"}},"project":{"a4Page":{"placeholder":"Name the chapter","showMore":"View more"},"actionBar":{"stepComp":{"raw":"Raw","inProgress":"In preparation","toReview":"To be corrected","done":"Completed"},"getStepLabel":{"formatting":"Segmentation","definition":"Definitions","syllables":"Syllabification","rhese":"Division into units of meaning","dialogues":"Dialogs","narration":"Narration"},"projectInfo":{"title":"Informations","description":"Figures and parameters","charsNumber":"Number of signs:","defsNumber":"Number of definitions:","imagesNumber":"Number of pictures:","pageNumber":"Number of pages:","rhesesNumber":"Number of units of meaning:","wordsNumber":"Number of words:","listTitle":"Paragraph types","export":"CSV export"},"checklist":{"title":"Checklist"},"userAccess":{"title":"Colleagues"},"default":{"tabPaneTitle":{"preview":"General view","rhese":"Division in meaning units","formatting":"Page layout","definitions":"Definitions mode","dialogues":"Dialog mode","syllables":"Syllable mode","narration":"Narration mode"}},"projectTabs":{"info":"Info","checklist":"Checklist","access":"Colleagues","config":"Setup","progress":"Progress"},"config":{"title":"Configuration des cl\xe9s","customColoration":{"title":"Custom coloring setup","add":"Add a new color distinction"},"customParagraphTag":{"title":"Custom the paragraph tags","add":"Add a new paragraph tag"}},"progress":{"title_state_preparation":"in preparation","title_state_narration":"In narration","title_state_narrationComplete":"Narration completed","title_state_narrationAndFixComplete":"Narration et correction compl\xe8tes","title_state_bookCompleted":"Book marked as completed","preparing":{"title":"In preparation","legendReadyToNarrate":"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium\\n","buttonReadyToNarrate":"Valider pour narration","legendPreparationComplete":"Les t\xe2ches compl\xe9mentaires sont en cours de pr\xe9paration","buttonPreparationComplete":"Valider la pr\xe9paration"},"prepared":{"title":"Pr\xe9par\xe9","legendTasksForNarrationComplete":"Les t\xe2ches n\xe9cessaires pour la narration sont termin\xe9es","buttonReadyToNarrate":"Ready to be narrated","legendPreparationComplete":"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium","buttonPreparationComplete":"Preparation completed"},"narration":{"title":"In narration","narratedPages":"Narrated pages","narratedDefinitions":"Narrated definitions","proofListening":"Proof Listening","remainingCorrections":"Remaining corrections","buttonDone":"Mark the book as completed","markNarrationDone":"Valider la narration","narrationDone":"Narration valid\xe9e"},"preparationAndNarration":{"markBookComplete":"Marquer le livre comme \xe9tant termin\xe9"},"bookCompleted":{"legend":"Un livre archiv\xe9 est supprim\xe9 \xe0 l\'affichage dahs la biblioth\xe8que des diff\xe9rents acteurs.","legendBis":"Pour le d\xe9sarchiver, contacter le d\xe9veloppeur.","button":"Archive"},"bookStateStatus":{"not_ready":"In preparation","ready_for_narration":"In narration","narration_complete":"Narration completed","complete":"Ready for validation","complete_book":"Complete","archived":"Archived","resync":"En re-synchro"},"archived":{"title":"Archiv\xe9","buttonUnarchive":"D\xe9sarchiver"}}},"existing":{"bookRenderer":{"paraghapLabel":{"citation":"Quotes","dialogue":"Dialog","didascalie":"Didascalia","email":"Email","intro":"Intro","normal":"Regular","note":"Note","resume":"Summary","vers":"Verses","center":"Center","mail":"Letter","right":"Right","space":"Space","bold":"Bold","text":"Short message","title1":"Titel 1","title2":"Titel 2","title3":"Titel 3","title4":"Titel 4","title5":"Title5","title6":"Title6","listUnordered":"Unordered list","listOrdered":"Ordered list","listDefinition":"Definition list"}},"index":{"syllableComponent":{"syllables":"Syllables","phonemes":"Phonems","custom":"Customized"},"pageBar":{"mutePage":"Dummy page(s)"},"goToPage":{"nav":"Go to...","validation":"OK"}},"editingMode":{"definition":{"buildDefinitionMenu":{"associates":"Link to the definition","modifies":"Edit the definition","add":"Insert a definition","dissociate":"Suppress the definition"},"content":{"all":"All defintions","explicit":"Explicit definitions","implicit":"Implicit definitions","foot_note":"Footnotes","image":"With image"},"definitionModal":{"message":{"assign":"Insert a definition","update":"Save","create":"Insert a definition"},"radioButton":{"explicit":"E","implicit":"Implicit definitions","foot_note":"Footnotes","image":"With image"},"textArea":{"placeholder":"Write the definition..."},"imageName":{"placeholder":"Image name"}}},"formatting":{"dropZone":"Insert a picture","menu":{"titre_1":"Titel 1","titre_2":"Titel 2","titre_3":"Titel 3","titre_4":"Titel 4","normal":"Regular","dialogue":"Dialog","intro":"Introduction","resume":"Summary","email":"Email","citation":"Quotes","vers":"Verses","didascalie":"Didascalia","note":"Note","subMenuTitleTransformsTitle":"Turn into a titel...","subMenuTitleAlign":"Paragraph align...","space":"Space","center":"Center","right":"Right","subMenuTitleTransformsParagraph":"Turn into a paragraph","subMenuTitleException":"Exceptions","bold":"Bold","text":"Short Message","mail":"Letter","rheseAction":"Insert a pagebreak after this unit of meaning","spaceAction":{"normal":"Turn into space","unbreakable":"Turn into an unbreakable space"},"lineSuppression":{"normal":"Remove the line break","afterRhese":"Line break after this unit of meaning"},"titre_5":"Title level 5","titre_6":"Title level 6","subMenuList":"Lists...","listUnordered":"unordered","listOrdered":"ordered","listDefinition":"definitions","list":"List","addClassesAction":"Add custom css classes","removeClassesAction":"Delete custom css classes"},"lettersCount":{"form":{"name":"basic","item":{"imageNaming":{"label":"Picture name","name":"File name"},"validation":"Save","imageDescription":{"label":"Picture details","name":"Details"},"radioButton":{"normal":"Regular","popup":"Popup"}}},"result":"{{lettersCount}} signs"},"default":{"modal":{"title":"Insert a picture"},"form":{"imageNaming":{"label":"Picture name","name":"Name"},"validation":"Save","imageDescription":{"label":"Picture details","name":"author"},"radioButton":{"normal":"Regular","popup":"Popup"},"figcaption":{"label":"Picture legend","name":"caption"}},"tooltip":{"title":"Add a picture"}},"associateToSpeaker":{"title":"Link to a speaker mark","name":"Speaker name","alphaNumError":"The value must be alphanumeric","dissociate":"Remove the speaker"},"modalCustomCss":{"title":"Custom css classes","modalOkLabel":"Update","ovverideWarning":"The selected elements do not share the same classes. Validating a new entry will cause the old ones to be lost.","inputPlaceholder":"my-class1, my-class2"}},"narration":{"section":{"minutes":"minutes"},"default":{"title":"audio fragments"}},"rhese":{"index":{"rhesesRenderer":{"menu":{"merge":"Merge the units of meaning","creat":"create a unit of meaning","split":"Split the unit of meaning"},"edit":"Edit"}}},"syllable":{"buildSyllableMenu":{"creat":"Define a syllable","transformMute":"Turn into mute letter(s)","transformNoMute":"Turn into a non-mute letter(s)","ignore":"Ignore syllable"},"buildPhonemeMenu":{"title":"Define as a phonem","vowel":"Voyel","consonant":"Consonant","complex":"Complex","transformMute":"Turn into mute letter(s)","transformNoMute":"Turn into a non-mute letter(s)","ignore":"Remove the phonemic coloration"},"buildCustomColorsMenu":{"assignCustomColor":"Define as","removeCustomColor":"Remove coloration"}}}},"search":{"getSearchModeLabel":{"id":"Id","text":"Text"},"nbResults":{"loading":"Loading...","result":"Result","results":"Results"}},"edit":{"modalTitle":"Edit a book","form":{"bookName":"Book name","bookAuthor":"Author\'s name","locale":"Language","modifies":"Edit"}},"new":{"stepOne":{"title":"Book text","importType":"Load type","successMessage":": file successfully imported.","errorMessage":": failed to import the file.","uploadOutlined":"Search on your computer...","import":"Import","rhesedText":"Text devided in units of meaning","text":"Text","htmlBook":"HTML","locale":"Book language","jsonImport":"JSON","disableColorationOnSimpleWords":"Disable coloring on simple words"},"stepTwo":{"title":"Titel","titlePlaceholder":"eg. To be, or not to be","author":"Author","authorPlaceholder":"eg. William Shakespeare","ean":"EAN","eanPlaceholder":"9782070360420","create":"Create"},"modalTitle":"Add a book"},"importStatus":{"failed":{"title":"Inaccessible project","message":"Project import failed","action":"Return to the list of projects"},"inProgress":{"title":"Inaccessible project ","message":"The import of the project is still in progress","action":"Back to the list of projects"},"loading":{"title":"Loading...","message":"Please wait..."}}},"userAccess":{"userTable":{"title":"Role","preparer":"Preparator","correction":"Corrector"},"tasksLabels":{"definition":"Definition","dialogues":"Dialogs","formatting":"Page layout ","narration":"Narration","rhese":"Division in units of meaning","syllables":"Syllable coloration"}},"locale":{"fr_FR":"French","en_GB":"English","it_IT":"Italian","sv_SE":"Swedish"},"page":"Page","paragraphe":"Paragraph","on":"on","tagTheParagraph":"Tag the paragraph","removeTagFromParagraph":"Remove the tag","selectADefinition":"Select a definition","associateToDefinition":"Associate to a definition","editor":"Editor","narrator":"Narrator","prooflistener":"Audio controller","audioLibrarty":"Audio library","GQLError.cannotUpdateRheseContent.message":"impossible to modify the rhesis","GQLError.cannotUpdateRheseContent.description":"The text is already associated with an audio file and cannot be modified","select_recorgind_issue_type":"Select the type of remark","audioReview.bad_speech":"Prononciation","audioReview.bad_text":"Wrong text","audioReview.recording":"Recording issue","audioReview.valid":"Ok","audioReview.comment":"Comment","audioReview.typeYourComment":"Add your comment","audioReview.addAReviewToSelectedRheses":"Add a remark to the selected rhesis","cancel":"Cancel","apply":"Apply","reset":"Reset","validate":"Valider","confirm":"Confirmer","warning":"Attention","startOffset":"Start time shift","endOffset":"End time shift","audioOffset":"Shift audio","listen":"Listen","offsetConfigIsInvalid":"Setting is invalid","listenToTheRecording":"Listen to the recording","proofListening.pageNotFullyRecordedTitle":"This page of the book has not yet been narrated.","proofListening.pageNotFullyRecordedButtonLabel":"Back","definitions":"Definitions","rheses":"Rhesis","loadingError":"Loading error","customCssClassesUsed":"Custom css classes used","audioReview.bad_text_and_narration":"Problem text+narration","audioReview.commentName":"Comments","audioReview.resetStatusBtn":"Delete comments","audioReview.resetStatusModalTitle":"Are you sure ?","audioReview.resetStatusModalText":"Please note that this action will delete the statuses of the selected rheses, but also their comments.","audioReview.resetStatusModalBtn":"Delete","definitionRecordedAudioUploadSuccess":"The file has been successfully saved","definitionRecordedAudioUploadError":"Error, the file has not been saved","definitionAudioUploadSuccess":"The file has been successfully saved","definitionAudioUploadError":"Error, the file has not been saved","definitionAudioUploadErrorSize":"The file must not exceed","definitionAudioUploadErrorExtension":"Extension not supported. Please use the following extensions","filterWithIssues":"With issues","filterAudioComplete":"With full audio","filterRenarrated":"Reviewed","audioReview.renarrated":"Reviewed","filterNotAudioSynced":"Audio not synchronized on text","rheseIgnoreSyncroMenuItemLabel":"Ignore this rhesis in synchronisation","rheseUseSyncroMenuItemLabel":"OK to synchronise","rheseUseSyncroDialogTitle":"Do you validate this operation?","rheseUseSyncroDialogOk":"Validate","rheseUseSyncroDialogCancel":"Cancel","rheseIconSyncroTooltip":"Non-synchronised rhesis","forceChange":"Force change","adminCanForceChange":"You can force the change","forcedUpdateWillDeleteAssociatedAudio":"Forcing the update will delete the associated audio files","serverHasSentError":"The server returned an error","errorHasBeenSentToTechStaff":"It was automatically forwarded to the technical team","downloadErrorReport":"Download the error report","tabArchivesLabel":"Archives","exportType_DEFINITIONS":"D\xe9finitions","exportType_FULL":"Complet","exportType_HTML":"HTML","exportType_INTO_IMPORTED_EPUB":"ePub","exportType_NARRATION":"Simplifi\xe9","exportType_SIMPLE":"Simplifi\xe9","tableExportsColumnStatus":"Statut","tableExportsColumnType":"Type","tableExportsColumnProjectName":"Livre","tableExportsColumnAuthor":"Utilisateur","tableExportsColumnCreatedAt":"D\xe9marr\xe9 \xe0","tableExportsColumnCompletedAt":"Termin\xe9 \xe0","tableExportsColumnDuration":"Dur\xe9e","tableExportsColumnIncludeAudio":"Audio inclus","tableExportsColumnConfig":"Config","tableExportsColumnAction":"Action","tableExportsRetentionInfo":"Les exports r\xe9ussis restent affich\xe9s pour une p\xe9riode de 24h","modalConfirmReSync":"La re-synchronisation audio d\'un projet entra\xeene son blocage durant tout le traitement.\\nConfirmez-vous l\'action ?","modalConfirmDelete":"Est-ce que vous confirmez la suppression de ce projet ?","overlayReSync":"Projet en cours de re-synchronisation","tabArchivesNoResult":"Pas de livres archiv\xe9s","proofListeningDataChanged":"R\xe9initialisation du lecteur audio, d\xfb \xe0 un changement de fichier(s) audios","revokeUserAccess":"R\xe9voquer l\'acc\xe8s d\'un utilisateur","userEmail":"Email de l\'utilisateur","revokeUser":"R\xe9voquer l\'utilisateur","filterLabelWith":"Avec","filterLabelWithout":"Sans","proofListening.pageOnlyAccessibleToAdmin":"Cette page n\'est accessible qu\'aux narrateurs et aux administrateurs car la narration n\'est pas termin\xe9e.","project.existing.bookRenderer.paraghapLabel.r\xe9sum\xe9":"R\xe9sum\xe9","reload.project":"Reload projet","recording.automaticGainControl":"Automatic gain control","recording.noiseCancelling":"Noise cancelling","recording.echoReduction":"Echo reduction"}');


var $063f01a19e7a2efe$exports = {};
$063f01a19e7a2efe$exports = JSON.parse('{"authentication":{"SignInWidget":{"text":"Anslut med Google"}},"library":{"index":{"newProject":{"title":"L\xe4gg till en bok"},"projectCard":{"menu":{"modifies":"Redigera","export":"Exportera projektet","exportNarration":"Exportera projektet f\xf6r ber\xe4ttelse","invite":"Bjuda in en kollega","delete":"Radera","exportEPub":"Exportera projektet (epub)","viewExports":"Voir les exports","resync":"Lancer une re-synchro audio"},"button":{"date":"Todo Date Format","title":"Tillg\xe5ng till texten"}},"menu":{"signOut":"Koppla bort"},"default":{"export":{"message":"Export av det aktuella projektet {{name}}","serverErrorMessage":"Servern returnerade ett fel","successNotification":"Ladda ner {{name}}","type":"octet/stream","errorNotification":"Ett fel intr\xe4ffade under exporten","colorationOptions":"F\xe4rgningsalternativ","audioOption":"Ljudfiler","audioOptionCheckbox":"Inkludera ljud"},"exportNarration":{"message":"Export (narration) du projet {{name}} en cours","serverErrorMessage":"Servern returnerade ett fel","successNotification":"Ladda ner {{name}}","type":"octet/stream","errorNotification":"Ett fel intr\xe4ffade under exporten","exportsTabLabel":"Exports"},"project":{"errorMessage":"Importen av b\xf6cker misslyckades","successMessage":"Boken importeras"},"navBar":{"title":"Bibliotek","tabTitle":"Alla","errorMessage":"Ett fel har intr\xe4ffat, det \xe4r om\xf6jligt att hitta listan \xf6ver projekt f\xf6r tillf\xe4llet."}}},"inviteModal":{"title":"Bjuda in en kollega","email":"Den anst\xe4lldes e-postadress.","invite":"Bjuda in"}},"project":{"a4Page":{"placeholder":"Namnge din sektion","showMore":"Visa mer"},"actionBar":{"stepComp":{"raw":"Brutto","inProgress":"Under f\xf6rberedelse","toReview":"som ska korrigeras","done":"Slutf\xf6rd"},"getStepLabel":{"formatting":"Segmentering","definition":"Definitioner","syllables":"Stavels\xe4ttning","rhese":"Uppdelning i ordgrupper med betydelse","dialogues":"Dialoger","narration":"Ber\xe4ttelse"},"projectInfo":{"title":"Information","description":"Information","charsNumber":"Antal tecken","defsNumber":"Antal definitioner","imagesNumber":"Antal bilder","pageNumber":"Antal sidor","rhesesNumber":"Antal ordgrupper med en betydelse","wordsNumber":"Antal ord","listTitle":"Typer av stycken","export":"Exportera till CSV"},"checklist":{"title":"Checklist"},"userAccess":{"title":"Personal"},"default":{"tabPaneTitle":{"preview":"Allm\xe4nt","rhese":"Uppdelning i ordgrupper med betydelse ","formatting":"Layout","definitions":"Definitionsl\xe4ge","dialogues":"Dialogsl\xe4ge","syllables":"Stavelsel\xe4ge","narration":"Ber\xe4ttande l\xe4ge"}},"projectTabs":{"info":"Information","checklist":"Checklist","access":"Personal","config":"Konfigurering","progress":"Avancemang"},"config":{"title":"Configuration des cl\xe9s","customColoration":{"title":"Skapa ett personligt f\xe4rgs\xe4ttningssystem","add":"L\xe4gg till en ny f\xe4rgskillnad"},"customParagraphTag":{"title":"Konfigurera etiketter f\xf6r stycken","add":"L\xe4gga till en ny etikett"}},"progress":{"title_state_preparation":"Under f\xf6rberedelse","title_state_narration":"Under ber\xe4ttandet","title_state_narrationComplete":"Inspelningen av ber\xe4ttelsen \xe4r avslutad","title_state_narrationAndFixComplete":"Narration et correction compl\xe8tes","title_state_bookCompleted":"Boken \xe4r markerad som f\xe4rdig","preparing":{"title":"Under f\xf6rberedelse","legendReadyToNarrate":"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium\\n","buttonReadyToNarrate":"Valider pour narration","legendPreparationComplete":"Les t\xe2ches compl\xe9mentaires sont en cours de pr\xe9paration","buttonPreparationComplete":"Valider la pr\xe9paration"},"prepared":{"title":"Pr\xe9par\xe9","legendTasksForNarrationComplete":"Les t\xe2ches n\xe9cessaires pour la narration sont termin\xe9es","buttonReadyToNarrate":"Redo att ber\xe4tta","legendPreparationComplete":"Toutes les t\xe2ches de pr\xe9paration sont termin\xe9es","buttonPreparationComplete":"F\xf6rberedelse slutf\xf6rd"},"narration":{"title":"Under ber\xe4ttandet","narratedPages":"Ber\xe4ttade sidor","narratedDefinitions":"Ber\xe4ttade definitioner","proofListening":"Kontrollera ljudinspelningen","remainingCorrections":"\xc5terst\xe5ende korrigeringar","buttonDone":"Markera boken som avslutad","markNarrationDone":"Valider la narration","narrationDone":"Narration valid\xe9e"},"preparationAndNarration":{"markBookComplete":"Marquer le livre comme \xe9tant termin\xe9"},"bookCompleted":{"legend":"Un livre archiv\xe9 est supprim\xe9 \xe0 l\'affichage dahs la biblioth\xe8que des diff\xe9rents acteurs.","legendBis":"Pour le d\xe9sarchiver, contacter le d\xe9veloppeur.","button":"Arkiv"},"bookStateStatus":{"not_ready":"Under f\xf6rberedelse","ready_for_narration":"Under ber\xe4ttandet","narration_complete":"Fullst\xe4ndig ljudinspelning","complete":"Redo f\xf6r validering","complete_book":"Slutf\xf6rt","archived":"Arkiverad","resync":"En re-synchro"},"archived":{"title":"Archiv\xe9","buttonUnarchive":"D\xe9sarchiver"}}},"existing":{"bookRenderer":{"paraghapLabel":{"citation":"Citat","dialogue":"Dialog","didascalie":"Didascalia","email":"E-post","intro":"Introduktion","normal":"Normal","note":"Obs","resume":"Sammanfattning","vers":"Vers","center":"Centrum","mail":"Post","right":"H\xf6ger","space":"Mellanslag","bold":"Fett","text":"Meddelande","title1":"Titel1","title2":"Titel2","title3":"Titel3","title4":"Titel4","title5":"Titel5","title6":"Titel6","listUnordered":"Oordnad lista","listOrdered":"Ordnad lista","listDefinition":"Lista \xf6ver definitioner"}},"index":{"syllableComponent":{"syllables":"Stavelser","phonemes":"Fonemes","custom":"Personlig"},"pageBar":{"mutePage":"Osynlig(a) sida(n)"},"goToPage":{"nav":"G\xe5 till","validation":"OK"}},"editingMode":{"definition":{"buildDefinitionMenu":{"associates":"L\xe4nk till definitionen","modifies":"\xc4ndra definitionen","add":"L\xe4gg till en definition","dissociate":"Inte l\xe4ngre kopplad till definitionen"},"content":{"all":"Alla definitioner","explicit":"Tydliga definitioner","implicit":"Implicita definitioner","foot_note":"Fotnoter","image":"With image"},"definitionModal":{"message":{"assign":"Tilldela en definition","update":"Spara \xe4ndringar","create":"Skapa en definition"},"radioButton":{"explicit":"Tydliga definitioner","implicit":"Implicita definitioner","foot_note":"Fotnoter","image":"With image"},"textArea":{"placeholder":"Att skriva en definition"},"imageName":{"placeholder":"Image name"}}},"formatting":{"dropZone":"L\xe4gg till en bild","menu":{"titre_1":"Niv\xe5 1 titel","titre_2":"Niv\xe5 2 titel","titre_3":"Niv\xe5 3 titel","titre_4":"Niv\xe5 4 titel","normal":"Normal","dialogue":"Dialog","intro":"Introduktion","resume":"Sammanfattning","email":"E-post","citation":"Citat","vers":"Vers","didascalie":"Didascalia","note":"Obs","subMenuTitleTransformsTitle":"V\xe4xla till en titel","subMenuTitleAlign":"Justera...","space":"Mellanslag","center":"I centrum","right":"Till h\xf6ger","subMenuTitleTransformsParagraph":"V\xe4xla till et stycke","subMenuTitleException":"Undantag","bold":"Fett","text":"Meddelande","mail":"Post","rheseAction":"Sidbrytning efter ordgruppen","spaceAction":{"normal":"F\xf6rvandla till mellanslag","unbreakable":"Omvandla till h\xe5rt mellanslag"},"lineSuppression":{"normal":"Radera radbrytningen","afterRhese":"Radbrytning efter ordgruppen"},"titre_5":"niv\xe5 5 titel","titre_6":"niv\xe5 6 titel","subMenuList":"Lista","listUnordered":"oordnad","listOrdered":"ordnad","listDefinition":"Definitioner","list":"Lista","addClassesAction":"L\xe4gga till anpassade css-klasser","removeClassesAction":"Ta bort anpassade css-klasser"},"lettersCount":{"form":{"name":"grundl\xe4ggande","item":{"imageNaming":{"label":"Bildens namn","name":"Filnamm"},"validation":"Validera","imageDescription":{"label":"Beskrivning av bilden","name":"Beskrivning"},"radioButton":{"normal":"Normal","popup":"Popup"}}},"result":"{{lettersCount}} tecken"},"default":{"modal":{"title":"L\xe4gg till en bild"},"form":{"imageNaming":{"label":"Bildens namn","name":"Namm"},"validation":"Validera","imageDescription":{"label":"Beskrivning av bilden","name":"F\xf6rfattare"},"radioButton":{"normal":"Normal","popup":"Popup"},"figcaption":{"label":"Bildtext","name":"legende"}},"tooltip":{"title":"L\xe4gg till en bild"}},"associateToSpeaker":{"title":"Associera med en karakt\xe4r","name":"Karakt\xe4rens namn","alphaNumError":"Det angivna v\xe4rdet m\xe5ste vara alfanumeriskt","dissociate":"Ta bort talarens namn"},"modalCustomCss":{"title":"anpassade css-klasser","modalOkLabel":"uppdatering","ovverideWarning":"De valda objekten har inte samma klass. Om du validerar en ny post kommer de gamla posterna att g\xe5 f\xf6rlorade.","inputPlaceholder":"min-klass1, min-klass2"}},"narration":{"section":{"minutes":"minuter"},"default":{"title":"Ljudinslagen"}},"rhese":{"index":{"rhesesRenderer":{"menu":{"merge":"Sl\xe5 samman ordgrupper med betydelse ","creat":"Skapa en ordgrupp med betydelse ","split":"Dela upp ordgruppen med betydelse "},"edit":"Redigera"}}},"syllable":{"buildSyllableMenu":{"creat":"Skapa en stavelse","transformMute":"F\xf6rvandlas till tysta bokst\xe4ver","transformNoMute":"F\xf6rvandlas till icke-tysta bokst\xe4ver","ignore":"Ignorera stavelsen"},"buildPhonemeMenu":{"title":"Tilldelning av en fonem","vowel":"Vokal","consonant":"Konsonant","complex":"Komplex","transformMute":"F\xf6rvandlas till tysta bokst\xe4ver","transformNoMute":"F\xf6rvandlas till icke-tysta bokst\xe4ver","ignore":"Ignorera fonem"},"buildCustomColorsMenu":{"assignCustomColor":"Tilldela som","removeCustomColor":"Ta bort f\xe4rger"}}}},"search":{"getSearchModeLabel":{"id":"Identifierare","text":"Text"},"nbResults":{"loading":"Laddas","result":"resultat","results":"resultaten"}},"edit":{"modalTitle":"Redigera en bok","form":{"bookName":"Bokens namn","bookAuthor":"F\xf6rfattarens namn","locale":"Language","modifies":"Redigera"}},"new":{"stepOne":{"title":"Bokens text","importType":"Importtyp","successMessage":"filen har importerats","errorMessage":": misslyckande med att importera filen...","uploadOutlined":"S\xf6k p\xe5 din dator...","import":"Importera","rhesedText":"Text uppdelad i ordgrupper med betydelse","text":"Text","htmlBook":"HTML","locale":"Bokens spr\xe5k","jsonImport":"JSON","disableColorationOnSimpleWords":"Inaktivera f\xe4rgning av enskilda ord"},"stepTwo":{"title":"Titel","titlePlaceholder":"t.ex. Nils Holgerssons underbara resa genom Sverige","author":"F\xf6rfattare","authorPlaceholder":"t.ex.Selma Lagerl\xf6f","ean":"EAN","eanPlaceholder":"9782070360420","create":"Skapa"},"modalTitle":"L\xe4gg till bok"},"importStatus":{"failed":{"title":"Projekt otillg\xe4ngligt","message":"Projektimport misslyckades","action":"\xc5terg\xe5 till listan \xf6ver projekt"},"inProgress":{"title":"Projekt otillg\xe4ngligt","message":"Importen av projektet p\xe5g\xe5r fortfarande","action":"\xc5terg\xe5 till listan \xf6ver projekt"},"loading":{"title":"Laddar v\xe4nligen v\xe4nta","message":"Tack f\xf6r ditt t\xe5lamod"}}},"userAccess":{"userTable":{"title":"Roll","preparer":"F\xf6rberedare","correction":"R\xe4ttelse"},"tasksLabels":{"definition":"Definition","dialogues":"Dialoger","formatting":"Layout","narration":"Ber\xe4ttelse","rhese":"Uppdelning i ordgrupper med betydelse","syllables":"Stavels\xe4ttning"}},"locale":{"fr_FR":"Franska","en_GB":"Engelska","it_IT":"Italienska","sv_SE":"Svenska"},"page":"Sidan","paragraphe":"Stycken","on":"p\xe5","tagTheParagraph":"koppla en etikett","removeTagFromParagraph":"Ta bort en etikett","selectADefinition":"V\xe4lj en definition","associateToDefinition":"L\xe4nk till definition","editor":"Beredare","narrator":"Ber\xe4ttare","prooflistener":"Ljudkontroller","audioLibrarty":"Ljudbibliotek","GQLError.cannotUpdateRheseContent.message":"Det \xe4r om\xf6jligt att \xe4ndra ordgruppen","GQLError.cannotUpdateRheseContent.description":"Ordgruppen \xe4r redan associerad med en ljudfil och kan inte \xe4ndras","select_recorgind_issue_type":"V\xe4lj typ av anm\xe4rkning","audioReview.bad_speech":"Uttryck","audioReview.bad_text":"Felaktig text","audioReview.recording":"Problem med registrering","audioReview.valid":"OK","audioReview.comment":"Kommentar","audioReview.typeYourComment":"L\xe4gg till din kommentar","audioReview.addAReviewToSelectedRheses":"L\xe4gg till en anm\xe4rkning till de valda ordgruppen","cancel":"Avbryt","apply":"Ans\xf6k p\xe5","reset":"\xc5terst\xe4ll","validate":"Valider","confirm":"Confirmer","warning":"Attention","startOffset":"flytta starttiden","endOffset":"flytta sluttiden","audioOffset":"flytta ljudet","listen":"Lyssna p\xe5","offsetConfigIsInvalid":"Inst\xe4llningen \xe4r ogiltig","listenToTheRecording":"Lyssna p\xe5 inspelningen","proofListening.pageNotFullyRecordedTitle":"Den h\xe4r sidan i boken har \xe4nnu inte ber\xe4ttats.","proofListening.pageNotFullyRecordedButtonLabel":"Tillbaka","definitions":"Definitioner","rheses":"Ordgrupper med betydelse","loadingError":"Ett fel intr\xe4ffade under laddningen","customCssClassesUsed":"Anpassade CSS-klasser som anv\xe4nds","audioReview.bad_text_and_narration":"Problem med text och ber\xe4ttelser","audioReview.commentName":"Kommentar","audioReview.resetStatusBtn":"Radera recensioner","audioReview.resetStatusModalTitle":"\xc4r du s\xe4ker?","audioReview.resetStatusModalText":"Observera att denna \xe5tg\xe4rd tar bort statusen f\xf6r de valda ordgrupperna, samt deras kommentarer","audioReview.resetStatusModalBtn":"Ta bort","definitionRecordedAudioUploadSuccess":"Filen har sparats framg\xe5ngsrikt","definitionRecordedAudioUploadError":"Fel, filen har inte sparats","definitionAudioUploadSuccess":"Filen har sparats framg\xe5ngsrikt","definitionAudioUploadError":"Fel, filen har inte sparats","definitionAudioUploadErrorSize":"Filen f\xe5r inte \xf6verstiga","definitionAudioUploadErrorExtension":"Till\xe4gget st\xf6ds inte. Anv\xe4nd f\xf6ljande till\xe4gg","filterWithIssues":"Med problem","filterAudioComplete":"Med fullst\xe4ndigt ljud","filterRenarrated":"Ominspelad","audioReview.renarrated":"Ominspelad","rheseIgnoreSyncroMenuItemLabel":"Ignorera denna ordgrupp vid synkronisering","rheseUseSyncroMenuItemLabel":"OK f\xf6r att synkronisera","rheseUseSyncroDialogTitle":"Bekr\xe4ftar du denna \xe5tg\xe4rd?","rheseUseSyncroDialogOk":"Bekr\xe4fta","rheseUseSyncroDialogCancel":"Avbryt","rheseIconSyncroTooltip":"Osynkroniserad ordgruppen","forceChange":"Att tvinga fram f\xf6r\xe4ndringar","adminCanForceChange":"Du kan tvinga fram en f\xf6r\xe4ndring","forcedUpdateWillDeleteAssociatedAudio":"Om du tvingar fram uppdateringen raderas de tillh\xf6rande ljudfilerna","serverHasSentError":"Servern returnerade ett felmeddelande","errorHasBeenSentToTechStaff":"Det vidarebefordrades automatiskt till det tekniska teamet","downloadErrorReport":"Ladda ner felrapporten","tabArchivesLabel":"Archives","exportType_DEFINITIONS":"D\xe9finitions","exportType_FULL":"Complet","exportType_HTML":"HTML","exportType_INTO_IMPORTED_EPUB":"ePub","exportType_NARRATION":"Simplifi\xe9","exportType_SIMPLE":"Simplifi\xe9","tableExportsColumnStatus":"Statut","tableExportsColumnType":"Type","tableExportsColumnProjectName":"Livre","tableExportsColumnAuthor":"Utilisateur","tableExportsColumnCreatedAt":"D\xe9marr\xe9 \xe0","tableExportsColumnCompletedAt":"Termin\xe9 \xe0","tableExportsColumnDuration":"Dur\xe9e","tableExportsColumnIncludeAudio":"Audio inclus","tableExportsColumnConfig":"Config","tableExportsColumnAction":"Action","tableExportsRetentionInfo":"Les exports r\xe9ussis restent affich\xe9s pour une p\xe9riode de 24h","modalConfirmReSync":"La re-synchronisation audio d\'un projet entra\xeene son blocage durant tout le traitement.\\nConfirmez-vous l\'action ?","modalConfirmDelete":"Est-ce que vous confirmez la suppression de ce projet ?","overlayReSync":"Projet en cours de re-synchronisation","tabArchivesNoResult":"Pas de livres archiv\xe9s","proofListeningDataChanged":"R\xe9initialisation du lecteur audio, d\xfb \xe0 un changement de fichier(s) audios","revokeUserAccess":"R\xe9voquer l\'acc\xe8s d\'un utilisateur","userEmail":"Email de l\'utilisateur","revokeUser":"R\xe9voquer l\'utilisateur","filterLabelWith":"Avec","filterLabelWithout":"Sans","proofListening.pageOnlyAccessibleToAdmin":"Cette page n\'est accessible qu\'aux narrateurs et aux administrateurs car la narration n\'est pas termin\xe9e.","project.existing.bookRenderer.paraghapLabel.r\xe9sum\xe9":"R\xe9sum\xe9","reload.project":"Reload projet"}');


var $cb4ce4bc7bce6166$exports = {};
$cb4ce4bc7bce6166$exports = JSON.parse('{"authentication":{"SignInWidget":{"text":"Collegati con Google"}},"library":{"index":{"newProject":{"title":"Aggiungi un libro"},"projectCard":{"menu":{"modifies":"Modifica","export":"Esporta il progetto","exportNarration":"Esporta il projetto por fare la narrazione","invite":"Invita un collega","delete":"Cancella","exportEPub":"Esportazione (epub)","viewExports":"Voir les exports","resync":"Lancer une re-synchro audio"},"button":{"date":"Di fare Date Format","title":"Accedi al testo"}},"menu":{"signOut":"Scollega"},"default":{"export":{"message":"Esportazione del projetto {{name}} in corso","serverErrorMessage":"Il server ha restituito un errore","successNotification":"Scarica {{name}}","type":"octet/stream","errorNotification":"Errore durante l\'esportazione","colorationOptions":"Opzioni di colorazione","audioOption":"Audios","audioOptionCheckbox":"Includete l\'audio"},"exportNarration":{"message":"Esportazione (narrazione) del progetto {{name}} in corso","serverErrorMessage":"Il server ha restituito un errore","successNotification":"Scarica {{name}}","type":"octet/stream","errorNotification":"Errore durante l\'esportazione","exportsTabLabel":"Exports"},"project":{"errorMessage":"Importazione del libro non riuscita","successMessage":"Il libro \xe8 in fase di importazione"},"navBar":{"title":"Biblioteca","tabTitle":"Tutti","errorMessage":"Errore. Non \xe8 possibile trovare la lista dei progetti al momento"}}},"inviteModal":{"title":"Invita un collega","email":"Email del collega","invite":"Invita"}},"project":{"a4Page":{"placeholder":"Dai un nome al tuo capitolo","showMore":"Vedere di pi\xf9"},"actionBar":{"stepComp":{"raw":"Crudo","inProgress":"In preparazione","toReview":"Da correggere","done":"Completato"},"getStepLabel":{"formatting":"Segmentazione","definition":"Definizioni","syllables":"Sillabazione","rhese":"Ripartizione in unit\xe0 significative","dialogues":"Dialoghi","narration":"Narrazione"},"projectInfo":{"title":"Informazioni","description":"Cifre","charsNumber":"Numero di caraterri","defsNumber":"Numero di definizioni","imagesNumber":"Numero di immagine","pageNumber":"Numero di pagine","rhesesNumber":"Numero di unita significative","wordsNumber":"Numero di parole","listTitle":"Tipo di paragrafi","export":"Esporta nel formato CSV"},"checklist":{"title":"Checklist"},"userAccess":{"title":"Collaboratori"},"default":{"tabPaneTitle":{"preview":"Vista generale","rhese":"Ripartizione in unit\xe0 significative","formatting":"Layout","definitions":"Modo Definizioni","dialogues":"Modo Dialoghi","syllables":"Modo Sillabazione","narration":"Narrazione preparation"}},"projectTabs":{"info":"Informazioni","checklist":"Checklist","access":"Collaboratori","config":"Configurazione","progress":"Avanzamento"},"config":{"title":"Configuration des cl\xe9s","customColoration":{"title":"Configurazione della colorazione personalizzata","add":"Aggiungi una nuova chiave di colorazione"},"customParagraphTag":{"title":"Impostare le etichette dei paragrafi","add":"Aggiungere una etichetta"}},"progress":{"title_state_preparation":"In preparazione","title_state_narration":"In narrazione","title_state_narrationComplete":"Narrazione completa","title_state_narrationAndFixComplete":"Narration et correction compl\xe8tes","title_state_bookCompleted":"Libro segnato come finito","preparing":{"title":"In preparazione","legendReadyToNarrate":"Les t\xe2ches n\xe9cessaires pour la narration sont en cours de pr\xe9paration","buttonReadyToNarrate":"Valider pour narration","legendPreparationComplete":"Les t\xe2ches compl\xe9mentaires sont en cours de pr\xe9paration","buttonPreparationComplete":"Valider la pr\xe9paration"},"prepared":{"title":"Pr\xe9par\xe9","legendTasksForNarrationComplete":"Les t\xe2ches n\xe9cessaires pour la narration sont termin\xe9es","buttonReadyToNarrate":"Pronto per la narrazione","legendPreparationComplete":"Toutes les t\xe2ches de pr\xe9paration sont termin\xe9es","buttonPreparationComplete":"Preparazione completata"},"narration":{"title":"In narrazione","narratedPages":"Pagine narrate","narratedDefinitions":"Definizioni narrate","proofListening":"Controllo della qualit\xe0 audio","remainingCorrections":"Correzioni rimanenti","buttonDone":"Segna il libro come finito","markNarrationDone":"Valider la narration","narrationDone":"Narration valid\xe9e"},"preparationAndNarration":{"markBookComplete":"Marquer le livre comme \xe9tant termin\xe9"},"bookCompleted":{"legend":"Un livre archiv\xe9 est supprim\xe9 \xe0 l\'affichage dahs la biblioth\xe8que des diff\xe9rents acteurs.","legendBis":"Pour le d\xe9sarchiver, contacter le d\xe9veloppeur.","button":"Archiviare il progetto"},"bookStateStatus":{"not_ready":"In preparazione","ready_for_narration":"In narrazione","narration_complete":"Narrazione completa","complete":"Pronto per la validazione","complete_book":"Completato","archived":"Archiviato","resync":"En re-synchro"},"archived":{"title":"Archiv\xe9","buttonUnarchive":"D\xe9sarchiver"}}},"existing":{"bookRenderer":{"paraghapLabel":{"citation":"Citazione","dialogue":"dialogo","didascalie":"Didascalia","email":"Email","intro":"Intro","normal":"Normale","note":"Nota","resume":"Riassunto","vers":"Verso","center":"Centro","mail":"Lettera","right":"Destra","space":"Spazio","bold":"Grassetto","text":"Messagio","title1":"Tittolo1","title2":"Tittolo2","title3":"Tittolo3","title4":"Tittolo4","title5":"Titolo 5","title6":"Titolo 6","listUnordered":"Lista non ordinata","listOrdered":"Lista ordinata","listDefinition":"Lista di definizioni"}},"index":{"syllableComponent":{"syllables":"Sillabe","phonemes":"Fonema","custom":"Personalizzato"},"pageBar":{"mutePage":"Pagina invisibile"},"goToPage":{"nav":"Vai a...","validation":"OK"}},"editingMode":{"definition":{"buildDefinitionMenu":{"associates":"Associa una definizione","modifies":"Modifica la definizione","add":"Aggiungi una definizione","dissociate":"Elimina la definizione"},"content":{"all":"Tutte le definizioni","explicit":"Definizioni esplicite","implicit":"Definizioni implicite","foot_note":"Note a pi\xe8 di pagina","image":"With image"},"definitionModal":{"message":{"assign":"Assegna alla definizione","update":"Salva i cambiamenti","create":"Crea una definizione"},"radioButton":{"explicit":"Definizioni esplicite","implicit":"Definizioni implicite","foot_note":"Note a pi\xe8 di pagina","image":"With image"},"textArea":{"placeholder":"Scrivere la definizione"},"imageName":{"placeholder":"Image name"}}},"formatting":{"dropZone":"Aggiungi un\'immagine","menu":{"titre_1":"Titolo livello1","titre_2":"Titolo livello2","titre_3":"Titolo livello3","titre_4":"Titolo livello 4","normal":"Normale","dialogue":"Dialogo","intro":"Introduzione","resume":"Riassunto","email":"Email","citation":"Citazione","vers":"Verso","didascalie":"Legenda","note":"Nota","subMenuTitleTransformsTitle":"Trasforma in titolo","subMenuTitleAlign":"Allineare...","space":"Spazio","center":"In centro","right":"A destra","subMenuTitleTransformsParagraph":"Trasforma in paragrofo...","subMenuTitleException":"Eccezioni...","bold":"Grassetto","text":"Messagio","mail":"Lettera","rheseAction":"Segmentare dopo unit\xe0 significative","spaceAction":{"normal":"Trasforma in spazio","unbreakable":"Trasforma in spazio non secatibile"},"lineSuppression":{"normal":"Rimuovere il ritorno a capo","afterRhese":"Ritorna alla riga dopo l\'unit\xe0 significative"},"titre_5":"Titolo livello 5","titre_6":"Titolo livello 6","subMenuList":"Liste","listUnordered":"Non ordinata","listOrdered":"ordinata","listDefinition":"definizioni","list":"Lista","addClassesAction":"Aggiunta di classi css personalizzate","removeClassesAction":"Eliminare le classi css personalizzate"},"lettersCount":{"form":{"name":"di base","item":{"imageNaming":{"label":"Nome dell\'immagine","name":"Nome del file"},"validation":"Convalidare","imageDescription":{"label":"Descrizione dell\'immagine","name":"descrizione"},"radioButton":{"normal":"Normale","popup":"Popup"}}},"result":"{{lettersCount}} caratteri"},"default":{"modal":{"title":"Agiungia un\'immagine"},"form":{"imageNaming":{"label":"Nome dell\'immagine","name":"Nome"},"validation":"Convalidare","imageDescription":{"label":"Descrizione dell\'immagine","name":"Autore"},"radioButton":{"normal":"Normale","popup":"Popup"},"figcaption":{"label":"Didascalia immagine","name":"didascalia"}},"tooltip":{"title":"Aggiungi un\'immagine"}},"associateToSpeaker":{"title":"Link a un personnagio","name":"Nome del personaggio","alphaNumError":"Il valore inserito deve essere alfanumerico","dissociate":"Dissociarsi da chi parla"},"modalCustomCss":{"title":"Classi css personalizzate","modalOkLabel":"Aggiornamento","ovverideWarning":"Gli elementi selezionati non condividono le stesse classi. La convalida di una nuova voce comporta la perdita di quelle precedenti.","inputPlaceholder":"la-mia-classe-1, la-mia-classe-2"}},"narration":{"section":{"minutes":"minuti"},"default":{"title":"Segmenti audio"}},"rhese":{"index":{"rhesesRenderer":{"menu":{"merge":"Unisci unit\xe0 significative","creat":"Crea una unit\xe0 significative","split":"Dividere l\'unit\xe0 significative"},"edit":"Modificare"}}},"syllable":{"buildSyllableMenu":{"creat":"Creare una sillaba","transformMute":"Converti in lettere silenziose","transformNoMute":"Converti in lettere non silenziose","ignore":"Ignora una sillaba"},"buildPhonemeMenu":{"title":"Assegna a un fonema","vowel":"Vocale","consonant":"Consonante","complex":"Fonema complesso","transformMute":"Converti in lettere silenziose","transformNoMute":"Converti in lettere non silenziose","ignore":"Ignora la fonema"},"buildCustomColorsMenu":{"assignCustomColor":"Assegna come","removeCustomColor":"Rimuovere le macchie"}}}},"search":{"getSearchModeLabel":{"id":"Identificativo","text":"Testo"},"nbResults":{"loading":"Caricamento in corso","result":"risultato","results":"risultati"}},"edit":{"modalTitle":"Modificare un libro","form":{"bookName":"Nome del libro","bookAuthor":"Nome dell\'autore","locale":"Language","modifies":"Modifica"}},"new":{"stepOne":{"title":"Testo del libro","importType":"Tipo d\'importazione","successMessage":": file importato con successo","errorMessage":": mancata importazione del file...","uploadOutlined":"Cerca sul tuo computer...","import":"Importa","rhesedText":"Testo scomposto in unit\xe0 significative","text":"Testo","htmlBook":"HTML","locale":"Lingua del libro","jsonImport":"JSON","disableColorationOnSimpleWords":"Disattivare la colorazione delle semplici parole"},"stepTwo":{"title":"Tittolo","titlePlaceholder":"esempio : Pinocchio","author":"Autore","authorPlaceholder":"esempio : Carlo Collodi","ean":"EAN","eanPlaceholder":"9782070360420","create":"Crea"},"modalTitle":"Aggiungi un libro"},"importStatus":{"failed":{"title":"Il progetto non \xe8 accessibile","message":"Importazione del progetto fallita","action":"Torna all\'elenco dei progetti"},"inProgress":{"title":"Progetto inaccessibile","message":"L\'importazione del progetto \xe8 ancora in corso","action":"Torna all\'elenco dei progetti"},"loading":{"title":"Caricamento in corso","message":"Per favore aspetta qualche istante"}}},"userAccess":{"userTable":{"title":"Ruolo","preparer":"Preparatore","correction":"Correttore"},"tasksLabels":{"definition":"Definizione","dialogues":"Dialoghi","formatting":"Layout","narration":"Narrazione","rhese":"Ripartizione in unit\xe0 significative","syllables":"Sillabazione"}},"locale":{"fr_FR":"Francese","en_GB":"Inglese","it_IT":"Italian","sv_SE":"Svedese"},"page":"Pagina","paragraphe":"Paragrafo","on":"sul","tagTheParagraph":"Etichetta","removeTagFromParagraph":"rimuovi l\'etichetta","selectADefinition":"Scegli una definizione","associateToDefinition":"link a una definizione","editor":"Editore","narrator":"Narratore","prooflistener":"Controllore audio","audioLibrarty":"Biblioteca audio","GQLError.cannotUpdateRheseContent.message":"Impossibile cambiare l\'unit\xe0 di significato","GQLError.cannotUpdateRheseContent.description":"L\'unit\xe0 di significato \xe8 gi\xe0 associata a un file audio e non pu\xf2 essere modificata.","select_recorgind_issue_type":"Selezionare il tipo di osservazione","audioReview.bad_speech":"Pronuncia","audioReview.bad_text":"Testo sbagliato","audioReview.recording":"Problema di registrazione","audioReview.valid":"OK","audioReview.comment":"Commento","audioReview.typeYourComment":"Aggiungi il tuo commento","audioReview.addAReviewToSelectedRheses":"Aggiungere un\'osservazione alle unit\xe0 di significato selezionate","cancel":"Annullamento","apply":"Applicare","reset":"Reset","validate":"Valider","confirm":"Confirmer","warning":"Attention","startOffset":"Spostare l\'ora di inizio","endOffset":"Spostare l\'ora della fine","audioOffset":"Audio del turno","listen":"Spostare l\'audio","offsetConfigIsInvalid":"L\'impostazione non \xe8 valida","listenToTheRecording":"Ascolta la registrazione","proofListening.pageNotFullyRecordedTitle":"Questa pagina del libro non \xe8 ancora stata narrata","proofListening.pageNotFullyRecordedButtonLabel":"Indietro","definitions":"Definizioni","rheses":"Unit\xe0 di significato","loadingError":"Si \xe8 verificato un errore durante il caricamento","customCssClassesUsed":"Classi CSS personalizzate utilizzate","audioReview.bad_text_and_narration":"Problema testo+narrazione","audioReview.commentName":"Commento","audioReview.resetStatusBtn":"Cancella le osservazioni","audioReview.resetStatusModalTitle":"Certo ?","audioReview.resetStatusModalText":"Si noti che questa azione canceller\xe0 gli stati delle unit\xe0 di significato selezionate, ma anche i loro commenti.","audioReview.resetStatusModalBtn":"Cancella","definitionRecordedAudioUploadSuccess":"Il file \xe8 stato salvato con successo","definitionRecordedAudioUploadError":"Errore, il file non \xe8 stato salvato","definitionAudioUploadSuccess":"Il file \xe8 stato salvato con successo","definitionAudioUploadError":"Errore, il file non \xe8 stato salvato","definitionAudioUploadErrorSize":"Il file non deve superare","definitionAudioUploadErrorExtension":"Estensione non supportata. Utilizzare le seguenti estensioni","filterWithIssues":"Con problemi","filterAudioComplete":"Con audio completo","filterRenarrated":"Registrato di nuovo","filterNotAudioSynced":"Audio non sincronizzato con il testo","audioReview.renarrated":"Registrato di nuovo","rheseIgnoreSyncroMenuItemLabel":"Ignorare questa unit\xe0 di significato nella sincronizzazione","rheseUseSyncroMenuItemLabel":"OK per sincronizzare","rheseUseSyncroDialogTitle":"Convalidate questa operazione?","rheseUseSyncroDialogOk":"Confermare","rheseUseSyncroDialogCancel":"Annullare","rheseIconSyncroTooltip":"Unit\xe0 di significato non sincronizzata","forceChange":"Costringere questa modifica","adminCanForceChange":"\xc8 possibile forzare la modifica","forcedUpdateWillDeleteAssociatedAudio":"La forzatura dell\'aggiornamento comporta l\'eliminazione dei file audio associati","serverHasSentError":"Il server ha restituito un errore","errorHasBeenSentToTechStaff":"\xc8 stata inoltrata automaticamente al team tecnico","downloadErrorReport":"Scarica il rapporto sugli errori","tabArchivesLabel":"Archives","exportType_DEFINITIONS":"D\xe9finitions","exportType_FULL":"Complet","exportType_HTML":"HTML","exportType_INTO_IMPORTED_EPUB":"ePub","exportType_NARRATION":"Simplifi\xe9","exportType_SIMPLE":"Simplifi\xe9","tableExportsColumnStatus":"Statut","tableExportsColumnType":"Type","tableExportsColumnProjectName":"Livre","tableExportsColumnAuthor":"Utilisateur","tableExportsColumnCreatedAt":"D\xe9marr\xe9 \xe0","tableExportsColumnCompletedAt":"Termin\xe9 \xe0","tableExportsColumnDuration":"Dur\xe9e","tableExportsColumnIncludeAudio":"Audio inclus","tableExportsColumnConfig":"Config","tableExportsColumnAction":"Action","tableExportsRetentionInfo":"Les exports r\xe9ussis restent affich\xe9s pour une p\xe9riode de 24h","modalConfirmReSync":"La re-synchronisation audio d\'un projet entra\xeene son blocage durant tout le traitement.\\nConfirmez-vous l\'action ?","modalConfirmDelete":"Est-ce que vous confirmez la suppression de ce projet ?","overlayReSync":"Projet en cours de re-synchronisation","tabArchivesNoResult":"Pas de livres archiv\xe9s","proofListeningDataChanged":"R\xe9initialisation du lecteur audio, d\xfb \xe0 un changement de fichier(s) audios","revokeUserAccess":"R\xe9voquer l\'acc\xe8s d\'un utilisateur","userEmail":"Email de l\'utilisateur","revokeUser":"R\xe9voquer l\'utilisateur","filterLabelWith":"Avec","filterLabelWithout":"Sans","proofListening.pageOnlyAccessibleToAdmin":"Cette page n\'est accessible qu\'aux narrateurs et aux administrateurs car la narration n\'est pas termin\xe9e.","project.existing.bookRenderer.paraghapLabel.r\xe9sum\xe9":"R\xe9sum\xe9","reload.project":"Reload projet"}');



var $jMaZ8 = parcelRequire("jMaZ8");
const $19ed0b6abada9941$export$a7357cdd1f0b0168 = (0, $940b6a1915fd8540$export$2e2bcd8739ae039).createInstance();
const $19ed0b6abada9941$var$namespace = "translation";
const $19ed0b6abada9941$var$fallbackLng = "fr";
const $19ed0b6abada9941$export$d73ee8ef04f5226a = $19ed0b6abada9941$export$a7357cdd1f0b0168.use((0, $80c641d65f99e090$export$2e2bcd8739ae039)).use((0, $484ec22414fe72b1$export$ae7e14d40d89f296)).init({
    defaultNS: $19ed0b6abada9941$var$namespace,
    fallbackLng: $19ed0b6abada9941$var$fallbackLng,
    returnEmptyString: false,
    resources: {
        en: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($4807a32193977e74$exports)))
        },
        fr: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($87cac0e08838a3a2$exports)))
        },
        sv: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($063f01a19e7a2efe$exports)))
        },
        it: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($cb4ce4bc7bce6166$exports)))
        }
    },
    interpolation: {
        escapeValue: false
    }
});
const $19ed0b6abada9941$export$3f3caade1c12f8c9 = ()=>{
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    return [
        t
    ];
};
const $19ed0b6abada9941$export$a6484047d53fa2be = (path)=>{
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    const result = (0, $jMaZ8.useMemo)(()=>t(path, {
            returnObjects: true
        }), [
        path,
        t
    ]);
    return result;
};
var $19ed0b6abada9941$export$2e2bcd8739ae039 = $19ed0b6abada9941$export$a7357cdd1f0b0168;



var $jMaZ8 = parcelRequire("jMaZ8");

'use client';
var $74b43854045dae71$var$se = ({ as: r = "div", ...c }, o)=>(0, $954e0e3ebeee9f2b$exports.jsx)(r, {
        ...c,
        ref: o
    }), $74b43854045dae71$var$V = (0, $jMaZ8.forwardRef)($74b43854045dae71$var$se);
var $74b43854045dae71$export$f87af7f569aace70 = "https://challenges.cloudflare.com/turnstile/v0/api.js", $74b43854045dae71$export$2eea204f6220c925 = "cf-turnstile-script", $74b43854045dae71$export$2ce14c6f26d19d0f = "cf-turnstile", $74b43854045dae71$export$da1f91a396bc4872 = "onloadTurnstileCallback", $74b43854045dae71$var$D = (r)=>!!document.getElementById(r), $74b43854045dae71$var$q = ({ render: r = "explicit", onLoadCallbackName: c = $74b43854045dae71$export$da1f91a396bc4872, scriptOptions: { nonce: o = "", defer: e = !0, async: p = !0, id: x = "", appendTo: C, onError: v, crossOrigin: I = "" } = {} })=>{
    let R = x || $74b43854045dae71$export$2eea204f6220c925;
    if ($74b43854045dae71$var$D(R)) return;
    let i = document.createElement("script");
    if (i.id = R, i.src = `${$74b43854045dae71$export$f87af7f569aace70}?onload=${c}&render=${r}`, document.querySelector(`script[src="${i.src}"]`)) return;
    i.defer = !!e, i.async = !!p, o && (i.nonce = o), I && (i.crossOrigin = I), v && (i.onerror = v, delete window[c]), (C === "body" ? document.body : document.getElementsByTagName("head")[0]).appendChild(i);
}, $74b43854045dae71$var$l = {
    normal: {
        width: 300,
        height: 65
    },
    compact: {
        width: 150,
        height: 140
    },
    invisible: {
        width: 0,
        height: 0,
        overflow: "hidden"
    },
    flexible: {
        minWidth: 300,
        width: "100%",
        height: 65
    },
    interactionOnly: {
        width: "fit-content",
        height: "auto",
        display: "flex"
    }
};
function $74b43854045dae71$var$J(r) {
    if (r !== "invisible" && r !== "interactionOnly") return r;
}
function $74b43854045dae71$var$O(r = $74b43854045dae71$export$2eea204f6220c925) {
    let [c, o] = (0, $jMaZ8.useState)(!1);
    return (0, $jMaZ8.useEffect)(()=>{
        let e = ()=>{
            $74b43854045dae71$var$D(r) && o(!0);
        }, p = new MutationObserver(e);
        return p.observe(document, {
            childList: !0,
            subtree: !0
        }), e(), ()=>{
            p.disconnect();
        };
    }, [
        r
    ]), c;
}
var $74b43854045dae71$var$b = "unloaded", $74b43854045dae71$var$G, $74b43854045dae71$var$fe = new Promise((r, c)=>{
    $74b43854045dae71$var$G = {
        resolve: r,
        reject: c
    }, $74b43854045dae71$var$b === "ready" && r(void 0);
}), $74b43854045dae71$var$me = (r = $74b43854045dae71$export$da1f91a396bc4872)=>($74b43854045dae71$var$b === "unloaded" && ($74b43854045dae71$var$b = "loading", window[r] = ()=>{
        $74b43854045dae71$var$G.resolve(), $74b43854045dae71$var$b = "ready", delete window[r];
    }), $74b43854045dae71$var$fe), $74b43854045dae71$export$9370f0117bf9debc = (0, $jMaZ8.forwardRef)((r, c)=>{
    let { scriptOptions: o, options: e = {}, siteKey: p, onWidgetLoad: x, onSuccess: C, onExpire: v, onError: I, onBeforeInteractive: R, onAfterInteractive: i, onUnsupported: N, onTimeout: Q, onLoadScript: U, id: Z, style: ee, as: te = "div", injectScript: M = !0, ...re } = r, s = e.size, z = (0, $jMaZ8.useCallback)(()=>typeof s > "u" ? {} : e.execution === "execute" ? $74b43854045dae71$var$l.invisible : e.appearance === "interaction-only" ? $74b43854045dae71$var$l.interactionOnly : $74b43854045dae71$var$l[s], [
        e.execution,
        s,
        e.appearance
    ]), [ne, y] = (0, $jMaZ8.useState)(z()), a = (0, $jMaZ8.useRef)(null), [f, W] = (0, $jMaZ8.useState)(!1), t = (0, $jMaZ8.useRef)(), h = (0, $jMaZ8.useRef)(!1), $ = Z || $74b43854045dae71$export$2ce14c6f26d19d0f, P = o?.id || $74b43854045dae71$export$2eea204f6220c925, L = $74b43854045dae71$var$O(P), j = o?.onLoadCallbackName || $74b43854045dae71$export$da1f91a396bc4872, oe = e.appearance || "always", g = (0, $jMaZ8.useMemo)(()=>({
            sitekey: p,
            action: e.action,
            cData: e.cData,
            callback: (n)=>{
                h.current = !0, C?.(n);
            },
            "error-callback": I,
            "expired-callback": v,
            "before-interactive-callback": R,
            "after-interactive-callback": i,
            "unsupported-callback": N,
            theme: e.theme || "auto",
            language: e.language || "auto",
            tabindex: e.tabIndex,
            "response-field": e.responseField,
            "response-field-name": e.responseFieldName,
            size: $74b43854045dae71$var$J(s),
            retry: e.retry || "auto",
            "retry-interval": e.retryInterval || 8e3,
            "refresh-expired": e.refreshExpired || "auto",
            "refresh-timeout": e.refreshTimeout || "auto",
            execution: e.execution || "render",
            appearance: e.appearance || "always",
            "feedback-enabled": e.feedbackEnabled || !0,
            "timeout-callback": Q
        }), [
        e.action,
        e.appearance,
        e.cData,
        e.execution,
        e.language,
        e.refreshExpired,
        e.responseField,
        e.responseFieldName,
        e.retry,
        e.retryInterval,
        e.tabIndex,
        e.theme,
        e.feedbackEnabled,
        e.refreshTimeout,
        p,
        s
    ]), m = (0, $jMaZ8.useCallback)(()=>typeof window < "u" && !!window.turnstile, []);
    return (0, $jMaZ8.useEffect)(function() {
        M && !f && $74b43854045dae71$var$q({
            onLoadCallbackName: j,
            scriptOptions: {
                ...o,
                id: P
            }
        });
    }, [
        M,
        f,
        o,
        P
    ]), (0, $jMaZ8.useEffect)(function() {
        $74b43854045dae71$var$b !== "ready" && $74b43854045dae71$var$me(j).then(()=>W(!0)).catch(console.error);
    }, []), (0, $jMaZ8.useEffect)(function() {
        if (!a.current || !f) return;
        let u = !1;
        return (async ()=>{
            if (u || !a.current) return;
            let _ = window.turnstile.render(a.current, g);
            t.current = _, t.current && x?.(t.current);
        })(), ()=>{
            u = !0, t.current && (window.turnstile.remove(t.current), h.current = !1);
        };
    }, [
        $,
        f,
        g
    ]), (0, $jMaZ8.useImperativeHandle)(c, ()=>{
        let { turnstile: n } = window;
        return {
            getResponse () {
                if (!n?.getResponse || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                return n.getResponse(t.current);
            },
            async getResponsePromise (u = 3e4, B = 100) {
                return new Promise((_, k)=>{
                    let d, H = async ()=>{
                        if (h.current && window.turnstile && t.current) try {
                            let T = window.turnstile.getResponse(t.current);
                            return d && clearTimeout(d), T ? _(T) : k(new Error("No response received"));
                        } catch (T) {
                            return d && clearTimeout(d), console.warn("Failed to get response", T), k(new Error("Failed to get response"));
                        }
                        d || (d = setTimeout(()=>{
                            d && clearTimeout(d), k(new Error("Timeout"));
                        }, u)), await new Promise((T)=>setTimeout(T, B)), await H();
                    };
                    H();
                });
            },
            reset () {
                if (!n?.reset || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                e.execution === "execute" && y($74b43854045dae71$var$l.invisible);
                try {
                    h.current = !1, n.reset(t.current);
                } catch (u) {
                    console.warn(`Failed to reset Turnstile widget ${t}`, u);
                }
            },
            remove () {
                if (!n?.remove || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                y($74b43854045dae71$var$l.invisible), h.current = !1, n.remove(t.current), t.current = null;
            },
            render () {
                if (!n?.render || !a.current || !m() || t.current) {
                    console.warn("Turnstile has not been loaded or container not found");
                    return;
                }
                let u = n.render(a.current, g);
                return t.current = u, t.current && x?.(t.current), e.execution !== "execute" && y(s ? $74b43854045dae71$var$l[s] : {}), u;
            },
            execute () {
                if (e.execution !== "execute") {
                    console.warn('Execution mode is not set to "execute"');
                    return;
                }
                if (!n?.execute || !a.current || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded or container not found");
                    return;
                }
                n.execute(a.current, g), y(s ? $74b43854045dae71$var$l[s] : {});
            },
            isExpired () {
                return !n?.isExpired || !t.current || !m() ? (console.warn("Turnstile has not been loaded"), !1) : n.isExpired(t.current);
            }
        };
    }, [
        t,
        e.execution,
        s,
        g,
        a,
        m,
        f,
        x
    ]), (0, $jMaZ8.useEffect)(()=>{
        L && !f && window.turnstile && W(!0);
    }, [
        f,
        L
    ]), (0, $jMaZ8.useEffect)(()=>{
        y(z());
    }, [
        e.execution,
        s,
        oe
    ]), (0, $jMaZ8.useEffect)(()=>{
        !L || typeof U != "function" || U();
    }, [
        L
    ]), (0, $954e0e3ebeee9f2b$exports.jsx)($74b43854045dae71$var$V, {
        ref: a,
        as: te,
        id: $,
        style: {
            ...ne,
            ...ee
        },
        ...re
    });
});
$74b43854045dae71$export$9370f0117bf9debc.displayName = "Turnstile";


/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");
/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1ce15dc420cde622$var$_extends() {
    $1ce15dc420cde622$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ce15dc420cde622$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1ce15dc420cde622$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1ce15dc420cde622$export$e19cd5f9376f8cee || ($1ce15dc420cde622$export$e19cd5f9376f8cee = {}));
const $1ce15dc420cde622$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1ce15dc420cde622$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1ce15dc420cde622$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1ce15dc420cde622$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1ce15dc420cde622$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1ce15dc420cde622$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1ce15dc420cde622$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1ce15dc420cde622$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1ce15dc420cde622$export$fe53371bee54353d(to);
    }
    return $1ce15dc420cde622$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1ce15dc420cde622$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1ce15dc420cde622$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1ce15dc420cde622$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1ce15dc420cde622$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1ce15dc420cde622$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1ce15dc420cde622$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1ce15dc420cde622$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1ce15dc420cde622$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1ce15dc420cde622$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1ce15dc420cde622$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1ce15dc420cde622$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1ce15dc420cde622$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1ce15dc420cde622$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1ce15dc420cde622$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1ce15dc420cde622$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1ce15dc420cde622$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1ce15dc420cde622$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1ce15dc420cde622$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Push;
        let location = $1ce15dc420cde622$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1ce15dc420cde622$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1ce15dc420cde622$export$e19cd5f9376f8cee.Replace;
        let location = $1ce15dc420cde622$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1ce15dc420cde622$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1ce15dc420cde622$export$fe53371bee54353d(to);
        $1ce15dc420cde622$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1ce15dc420cde622$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1ce15dc420cde622$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1ce15dc420cde622$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1ce15dc420cde622$var$ResultType || ($1ce15dc420cde622$var$ResultType = {}));
const $1ce15dc420cde622$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1ce15dc420cde622$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1ce15dc420cde622$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1ce15dc420cde622$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1ce15dc420cde622$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1ce15dc420cde622$var$isIndexRoute(route)) {
            let indexRoute = $1ce15dc420cde622$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1ce15dc420cde622$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1ce15dc420cde622$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1ce15dc420cde622$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1ce15dc420cde622$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1ce15dc420cde622$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1ce15dc420cde622$var$flattenRoutes(routes);
    $1ce15dc420cde622$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1ce15dc420cde622$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1ce15dc420cde622$var$safelyDecodeURI(pathname));
    return matches;
}
function $1ce15dc420cde622$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1ce15dc420cde622$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1ce15dc420cde622$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1ce15dc420cde622$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1ce15dc420cde622$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1ce15dc420cde622$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1ce15dc420cde622$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1ce15dc420cde622$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1ce15dc420cde622$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1ce15dc420cde622$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1ce15dc420cde622$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1ce15dc420cde622$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1ce15dc420cde622$var$paramRe = /^:[\w-]+$/;
const $1ce15dc420cde622$var$dynamicSegmentValue = 3;
const $1ce15dc420cde622$var$indexRouteValue = 2;
const $1ce15dc420cde622$var$emptySegmentValue = 1;
const $1ce15dc420cde622$var$staticSegmentValue = 10;
const $1ce15dc420cde622$var$splatPenalty = -2;
const $1ce15dc420cde622$var$isSplat = (s)=>s === "*";
function $1ce15dc420cde622$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1ce15dc420cde622$var$isSplat)) initialScore += $1ce15dc420cde622$var$splatPenalty;
    if (index) initialScore += $1ce15dc420cde622$var$indexRouteValue;
    return segments.filter((s)=>!$1ce15dc420cde622$var$isSplat(s)).reduce((score, segment)=>score + ($1ce15dc420cde622$var$paramRe.test(segment) ? $1ce15dc420cde622$var$dynamicSegmentValue : segment === "" ? $1ce15dc420cde622$var$emptySegmentValue : $1ce15dc420cde622$var$staticSegmentValue), initialScore);
}
function $1ce15dc420cde622$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1ce15dc420cde622$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1ce15dc420cde622$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1ce15dc420cde622$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1ce15dc420cde622$export$a5c6d149b50c1d86($1ce15dc420cde622$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1ce15dc420cde622$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1ce15dc420cde622$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1ce15dc420cde622$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1ce15dc420cde622$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1ce15dc420cde622$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1ce15dc420cde622$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1ce15dc420cde622$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1ce15dc420cde622$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1ce15dc420cde622$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1ce15dc420cde622$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1ce15dc420cde622$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1ce15dc420cde622$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1ce15dc420cde622$export$c0e02632e14916fd(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1ce15dc420cde622$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1ce15dc420cde622$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1ce15dc420cde622$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1ce15dc420cde622$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1ce15dc420cde622$var$normalizeSearch(search),
        hash: $1ce15dc420cde622$var$normalizeHash(hash)
    };
}
function $1ce15dc420cde622$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1ce15dc420cde622$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1ce15dc420cde622$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1ce15dc420cde622$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1ce15dc420cde622$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1ce15dc420cde622$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1ce15dc420cde622$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1ce15dc420cde622$var$_extends({}, toArg);
        $1ce15dc420cde622$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1ce15dc420cde622$var$getInvalidPathError("?", "pathname", "search", to));
        $1ce15dc420cde622$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1ce15dc420cde622$var$getInvalidPathError("#", "pathname", "hash", to));
        $1ce15dc420cde622$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1ce15dc420cde622$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1ce15dc420cde622$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1ce15dc420cde622$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1ce15dc420cde622$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1ce15dc420cde622$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1ce15dc420cde622$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1ce15dc420cde622$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1ce15dc420cde622$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1ce15dc420cde622$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1ce15dc420cde622$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1ce15dc420cde622$export$42a99a7a4bc0e76a extends Error {
}
class $1ce15dc420cde622$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1ce15dc420cde622$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1ce15dc420cde622$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1ce15dc420cde622$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1ce15dc420cde622$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1ce15dc420cde622$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1ce15dc420cde622$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1ce15dc420cde622$var$unwrapTrackedPromise(value) {
    if (!$1ce15dc420cde622$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1ce15dc420cde622$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1ce15dc420cde622$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ce15dc420cde622$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1ce15dc420cde622$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ce15dc420cde622$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1ce15dc420cde622$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1ce15dc420cde622$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1ce15dc420cde622$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1ce15dc420cde622$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1ce15dc420cde622$var$validMutationMethods = new Set($1ce15dc420cde622$var$validMutationMethodsArr);
const $1ce15dc420cde622$var$validRequestMethodsArr = [
    "get",
    ...$1ce15dc420cde622$var$validMutationMethodsArr
];
const $1ce15dc420cde622$var$validRequestMethods = new Set($1ce15dc420cde622$var$validRequestMethodsArr);
const $1ce15dc420cde622$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1ce15dc420cde622$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1ce15dc420cde622$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1ce15dc420cde622$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1ce15dc420cde622$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1ce15dc420cde622$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1ce15dc420cde622$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1ce15dc420cde622$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1ce15dc420cde622$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1ce15dc420cde622$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1ce15dc420cde622$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1ce15dc420cde622$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1ce15dc420cde622$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1ce15dc420cde622$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1ce15dc420cde622$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1ce15dc420cde622$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1ce15dc420cde622$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1ce15dc420cde622$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1ce15dc420cde622$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1ce15dc420cde622$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1ce15dc420cde622$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1ce15dc420cde622$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1ce15dc420cde622$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1ce15dc420cde622$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1ce15dc420cde622$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1ce15dc420cde622$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1ce15dc420cde622$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1ce15dc420cde622$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1ce15dc420cde622$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1ce15dc420cde622$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1ce15dc420cde622$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1ce15dc420cde622$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1ce15dc420cde622$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1ce15dc420cde622$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1ce15dc420cde622$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1ce15dc420cde622$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1ce15dc420cde622$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1ce15dc420cde622$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1ce15dc420cde622$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1ce15dc420cde622$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1ce15dc420cde622$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1ce15dc420cde622$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1ce15dc420cde622$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1ce15dc420cde622$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1ce15dc420cde622$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1ce15dc420cde622$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1ce15dc420cde622$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1ce15dc420cde622$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1ce15dc420cde622$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1ce15dc420cde622$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1ce15dc420cde622$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1ce15dc420cde622$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1ce15dc420cde622$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1ce15dc420cde622$var$ResultType.error,
            error: $1ce15dc420cde622$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1ce15dc420cde622$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1ce15dc420cde622$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1ce15dc420cde622$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1ce15dc420cde622$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1ce15dc420cde622$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1ce15dc420cde622$var$isDeferredResult(result)) throw $1ce15dc420cde622$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1ce15dc420cde622$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1ce15dc420cde622$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1ce15dc420cde622$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1ce15dc420cde622$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1ce15dc420cde622$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1ce15dc420cde622$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1ce15dc420cde622$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1ce15dc420cde622$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1ce15dc420cde622$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1ce15dc420cde622$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1ce15dc420cde622$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1ce15dc420cde622$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1ce15dc420cde622$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1ce15dc420cde622$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1ce15dc420cde622$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1ce15dc420cde622$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1ce15dc420cde622$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1ce15dc420cde622$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1ce15dc420cde622$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1ce15dc420cde622$var$isRedirectResult(actionResult) || $1ce15dc420cde622$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1ce15dc420cde622$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1ce15dc420cde622$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1ce15dc420cde622$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1ce15dc420cde622$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1ce15dc420cde622$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1ce15dc420cde622$var$isDeferredResult(actionResult)) throw $1ce15dc420cde622$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1ce15dc420cde622$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1ce15dc420cde622$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1ce15dc420cde622$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1ce15dc420cde622$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1ce15dc420cde622$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1ce15dc420cde622$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1ce15dc420cde622$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1ce15dc420cde622$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1ce15dc420cde622$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1ce15dc420cde622$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1ce15dc420cde622$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1ce15dc420cde622$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1ce15dc420cde622$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1ce15dc420cde622$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1ce15dc420cde622$var$isDeferredResult(result)) result = await $1ce15dc420cde622$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1ce15dc420cde622$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1ce15dc420cde622$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1ce15dc420cde622$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1ce15dc420cde622$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1ce15dc420cde622$export$3e9cee6b33872309(!$1ce15dc420cde622$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1ce15dc420cde622$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1ce15dc420cde622$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1ce15dc420cde622$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1ce15dc420cde622$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1ce15dc420cde622$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1ce15dc420cde622$export$e19cd5f9376f8cee.Replace : $1ce15dc420cde622$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1ce15dc420cde622$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1ce15dc420cde622$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1ce15dc420cde622$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1ce15dc420cde622$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1ce15dc420cde622$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1ce15dc420cde622$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1ce15dc420cde622$var$callLoaderOrAction("loader", $1ce15dc420cde622$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $1ce15dc420cde622$var$ResultType.error,
                        error: $1ce15dc420cde622$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1ce15dc420cde622$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1ce15dc420cde622$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1ce15dc420cde622$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1ce15dc420cde622$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1ce15dc420cde622$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1ce15dc420cde622$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1ce15dc420cde622$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1ce15dc420cde622$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1ce15dc420cde622$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1ce15dc420cde622$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1ce15dc420cde622$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1ce15dc420cde622$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1ce15dc420cde622$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1ce15dc420cde622$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1ce15dc420cde622$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1ce15dc420cde622$export$4d0306f8f6a4585b = Symbol("deferred");
function $1ce15dc420cde622$export$3336b097a6fbc59a(routes, opts) {
    $1ce15dc420cde622$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1ce15dc420cde622$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1ce15dc420cde622$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1ce15dc420cde622$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1ce15dc420cde622$var$createLocation("", $1ce15dc420cde622$export$fe53371bee54353d(url), null, "default");
        let matches = $1ce15dc420cde622$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1ce15dc420cde622$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1ce15dc420cde622$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1ce15dc420cde622$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1ce15dc420cde622$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1ce15dc420cde622$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1ce15dc420cde622$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1ce15dc420cde622$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1ce15dc420cde622$var$createLocation("", $1ce15dc420cde622$export$fe53371bee54353d(url), null, "default");
        let matches = $1ce15dc420cde622$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1ce15dc420cde622$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1ce15dc420cde622$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1ce15dc420cde622$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1ce15dc420cde622$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1ce15dc420cde622$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1ce15dc420cde622$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1ce15dc420cde622$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1ce15dc420cde622$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1ce15dc420cde622$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1ce15dc420cde622$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1ce15dc420cde622$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1ce15dc420cde622$var$isResponse(result) ? result : $1ce15dc420cde622$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1ce15dc420cde622$var$isQueryRouteResponse(e)) {
                if (e.type === $1ce15dc420cde622$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1ce15dc420cde622$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1ce15dc420cde622$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1ce15dc420cde622$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1ce15dc420cde622$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $1ce15dc420cde622$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1ce15dc420cde622$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1ce15dc420cde622$var$isDeferredResult(result)) {
            let error = $1ce15dc420cde622$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1ce15dc420cde622$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1ce15dc420cde622$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1ce15dc420cde622$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1ce15dc420cde622$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1ce15dc420cde622$var$_extends({}, context, {
                statusCode: $1ce15dc420cde622$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1ce15dc420cde622$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1ce15dc420cde622$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1ce15dc420cde622$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1ce15dc420cde622$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1ce15dc420cde622$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1ce15dc420cde622$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $1ce15dc420cde622$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1ce15dc420cde622$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1ce15dc420cde622$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1ce15dc420cde622$export$fec11da027c70692(routes, context, error) {
    let newContext = $1ce15dc420cde622$var$_extends({}, context, {
        statusCode: $1ce15dc420cde622$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1ce15dc420cde622$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1ce15dc420cde622$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1ce15dc420cde622$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1ce15dc420cde622$export$cae722b0cc860f13(to ? to : ".", $1ce15dc420cde622$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1ce15dc420cde622$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1ce15dc420cde622$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1ce15dc420cde622$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1ce15dc420cde622$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1ce15dc420cde622$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1ce15dc420cde622$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1ce15dc420cde622$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1ce15dc420cde622$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1ce15dc420cde622$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1ce15dc420cde622$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1ce15dc420cde622$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1ce15dc420cde622$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1ce15dc420cde622$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1ce15dc420cde622$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1ce15dc420cde622$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1ce15dc420cde622$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1ce15dc420cde622$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1ce15dc420cde622$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1ce15dc420cde622$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1ce15dc420cde622$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1ce15dc420cde622$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1ce15dc420cde622$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1ce15dc420cde622$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1ce15dc420cde622$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1ce15dc420cde622$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1ce15dc420cde622$var$shouldRevalidateLoader(match, $1ce15dc420cde622$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1ce15dc420cde622$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1ce15dc420cde622$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1ce15dc420cde622$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1ce15dc420cde622$var$shouldRevalidateLoader(fetcherMatch, $1ce15dc420cde622$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1ce15dc420cde622$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1ce15dc420cde622$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1ce15dc420cde622$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1ce15dc420cde622$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1ce15dc420cde622$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1ce15dc420cde622$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1ce15dc420cde622$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1ce15dc420cde622$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1ce15dc420cde622$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1ce15dc420cde622$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1ce15dc420cde622$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1ce15dc420cde622$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1ce15dc420cde622$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1ce15dc420cde622$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1ce15dc420cde622$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1ce15dc420cde622$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1ce15dc420cde622$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1ce15dc420cde622$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1ce15dc420cde622$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1ce15dc420cde622$var$ABSOLUTE_URL_REGEX.test(location)) location = $1ce15dc420cde622$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1ce15dc420cde622$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1ce15dc420cde622$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1ce15dc420cde622$var$ResultType.error ? $1ce15dc420cde622$var$ResultType.error : $1ce15dc420cde622$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1ce15dc420cde622$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $1ce15dc420cde622$var$ResultType.error) return {
            type: resultType,
            error: new $1ce15dc420cde622$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1ce15dc420cde622$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1ce15dc420cde622$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1ce15dc420cde622$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1ce15dc420cde622$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1ce15dc420cde622$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1ce15dc420cde622$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1ce15dc420cde622$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1ce15dc420cde622$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1ce15dc420cde622$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1ce15dc420cde622$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1ce15dc420cde622$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1ce15dc420cde622$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1ce15dc420cde622$export$3e9cee6b33872309(!$1ce15dc420cde622$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1ce15dc420cde622$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1ce15dc420cde622$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1ce15dc420cde622$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1ce15dc420cde622$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1ce15dc420cde622$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1ce15dc420cde622$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1ce15dc420cde622$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1ce15dc420cde622$var$isErrorResult(result)) {
            let boundaryMatch = $1ce15dc420cde622$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1ce15dc420cde622$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1ce15dc420cde622$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1ce15dc420cde622$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1ce15dc420cde622$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1ce15dc420cde622$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1ce15dc420cde622$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1ce15dc420cde622$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1ce15dc420cde622$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1ce15dc420cde622$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1ce15dc420cde622$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1ce15dc420cde622$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1ce15dc420cde622$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1ce15dc420cde622$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1ce15dc420cde622$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1ce15dc420cde622$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1ce15dc420cde622$export$8ccf933b0513f8d0(path) : path;
    return $1ce15dc420cde622$export$fe53371bee54353d($1ce15dc420cde622$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1ce15dc420cde622$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1ce15dc420cde622$var$isDeferredResult(result) {
    return result.type === $1ce15dc420cde622$var$ResultType.deferred;
}
function $1ce15dc420cde622$var$isErrorResult(result) {
    return result.type === $1ce15dc420cde622$var$ResultType.error;
}
function $1ce15dc420cde622$var$isRedirectResult(result) {
    return (result && result.type) === $1ce15dc420cde622$var$ResultType.redirect;
}
function $1ce15dc420cde622$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1ce15dc420cde622$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1ce15dc420cde622$var$isRedirectResponse(result) {
    if (!$1ce15dc420cde622$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1ce15dc420cde622$var$isQueryRouteResponse(obj) {
    return obj && $1ce15dc420cde622$var$isResponse(obj.response) && (obj.type === $1ce15dc420cde622$var$ResultType.data || obj.type === $1ce15dc420cde622$var$ResultType.error);
}
function $1ce15dc420cde622$var$isValidMethod(method) {
    return $1ce15dc420cde622$var$validRequestMethods.has(method.toLowerCase());
}
function $1ce15dc420cde622$var$isMutationMethod(method) {
    return $1ce15dc420cde622$var$validMutationMethods.has(method.toLowerCase());
}
async function $1ce15dc420cde622$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1ce15dc420cde622$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1ce15dc420cde622$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1ce15dc420cde622$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1ce15dc420cde622$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1ce15dc420cde622$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1ce15dc420cde622$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1ce15dc420cde622$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1ce15dc420cde622$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1ce15dc420cde622$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1ce15dc420cde622$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1ce15dc420cde622$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1ce15dc420cde622$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1ce15dc420cde622$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1ce15dc420cde622$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1ce15dc420cde622$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1ce15dc420cde622$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1ce15dc420cde622$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1ce15dc420cde622$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1ce15dc420cde622$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1ce15dc420cde622$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1ce15dc420cde622$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1ce15dc420cde622$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1ce15dc420cde622$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1ce15dc420cde622$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jMaZ8 = parcelRequire("jMaZ8");

function $5c84a101a4932c49$var$_extends() {
    $5c84a101a4932c49$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5c84a101a4932c49$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $5c84a101a4932c49$export$3add0d5dce533e2e = /*#__PURE__*/ $jMaZ8.createContext(null);
$5c84a101a4932c49$export$3add0d5dce533e2e.displayName = "DataRouter";
const $5c84a101a4932c49$export$145dfa71566a64dc = /*#__PURE__*/ $jMaZ8.createContext(null);
$5c84a101a4932c49$export$145dfa71566a64dc.displayName = "DataRouterState";
const $5c84a101a4932c49$var$AwaitContext = /*#__PURE__*/ $jMaZ8.createContext(null);
$5c84a101a4932c49$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $5c84a101a4932c49$export$26749e8557646306 = /*#__PURE__*/ $jMaZ8.createContext(null);
$5c84a101a4932c49$export$26749e8557646306.displayName = "Navigation";
const $5c84a101a4932c49$export$c7914228fb69b0f5 = /*#__PURE__*/ $jMaZ8.createContext(null);
$5c84a101a4932c49$export$c7914228fb69b0f5.displayName = "Location";
const $5c84a101a4932c49$export$9072aa6dd1f93057 = /*#__PURE__*/ $jMaZ8.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$5c84a101a4932c49$export$9072aa6dd1f93057.displayName = "Route";
const $5c84a101a4932c49$var$RouteErrorContext = /*#__PURE__*/ $jMaZ8.createContext(null);
$5c84a101a4932c49$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $5c84a101a4932c49$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5c84a101a4932c49$export$9c954a9d03d32f4a() && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $jMaZ8.useContext($5c84a101a4932c49$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5c84a101a4932c49$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1ce15dc420cde622$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $5c84a101a4932c49$export$9c954a9d03d32f4a() {
    return $jMaZ8.useContext($5c84a101a4932c49$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $5c84a101a4932c49$export$45d76561a5302f2b() {
    !$5c84a101a4932c49$export$9c954a9d03d32f4a() && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $jMaZ8.useContext($5c84a101a4932c49$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $5c84a101a4932c49$export$1b3f31771c5d07c() {
    return $jMaZ8.useContext($5c84a101a4932c49$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $5c84a101a4932c49$export$6c330e8992e8a295(pattern) {
    !$5c84a101a4932c49$export$9c954a9d03d32f4a() && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $5c84a101a4932c49$export$45d76561a5302f2b();
    return $jMaZ8.useMemo(()=>(0, $1ce15dc420cde622$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $5c84a101a4932c49$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $5c84a101a4932c49$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $jMaZ8.useContext($5c84a101a4932c49$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $jMaZ8.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $5c84a101a4932c49$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $5c84a101a4932c49$var$useNavigateStable() : $5c84a101a4932c49$var$useNavigateUnstable();
}
function $5c84a101a4932c49$var$useNavigateUnstable() {
    !$5c84a101a4932c49$export$9c954a9d03d32f4a() && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $jMaZ8.useContext($5c84a101a4932c49$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $jMaZ8.useContext($5c84a101a4932c49$export$26749e8557646306);
    let { matches: matches } = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5c84a101a4932c49$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ce15dc420cde622$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $jMaZ8.useRef(false);
    $5c84a101a4932c49$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jMaZ8.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1ce15dc420cde622$export$c0e02632e14916fd)(activeRef.current, $5c84a101a4932c49$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1ce15dc420cde622$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ce15dc420cde622$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $5c84a101a4932c49$var$OutletContext = /*#__PURE__*/ $jMaZ8.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $5c84a101a4932c49$export$4138103a3ae699cc() {
    return $jMaZ8.useContext($5c84a101a4932c49$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $5c84a101a4932c49$export$a3be3530d8e40d0b(context) {
    let outlet = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $5c84a101a4932c49$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $5c84a101a4932c49$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $jMaZ8.useContext($5c84a101a4932c49$export$26749e8557646306);
    let { matches: matches } = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5c84a101a4932c49$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ce15dc420cde622$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $jMaZ8.useMemo(()=>(0, $1ce15dc420cde622$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $5c84a101a4932c49$export$5d3fca4a98652595(routes, locationArg) {
    return $5c84a101a4932c49$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $5c84a101a4932c49$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$5c84a101a4932c49$export$9c954a9d03d32f4a() && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $jMaZ8.useContext($5c84a101a4932c49$export$26749e8557646306);
    let { matches: parentMatches } = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $5c84a101a4932c49$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ("\"" + parentPathname + "\" (under <Route path=\"" + parentPath + "\">) but the ") + "parent route path has no trailing \"*\". This means if you navigate " + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ("Please change the parent <Route path=\"" + parentPath + "\"> to <Route ") + ("path=\"" + (parentPath === "/" ? "*" : parentPath + "/*") + "\">."));
    }
    let locationFromContext = $5c84a101a4932c49$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1ce15dc420cde622$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ("matched by all parent routes. The current pathname base is \"" + parentPathnameBase + "\" ") + ("but pathname \"" + parsedLocationArg.pathname + "\" was given in the `location` prop."));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1ce15dc420cde622$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $1ce15dc420cde622$export$c0e02632e14916fd)(parentRoute || matches != null, "No routes matched location \"" + location.pathname + location.search + location.hash + "\" ");
    (0, $1ce15dc420cde622$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, "Matched leaf route at location \"" + location.pathname + location.search + location.hash + "\" " + "does not have an element or Component. This means it will render an <Outlet /> with a " + "null value by default resulting in an \"empty\" page.");
    let renderedMatches = $5c84a101a4932c49$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1ce15dc420cde622$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1ce15dc420cde622$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5c84a101a4932c49$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1ce15dc420cde622$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5c84a101a4932c49$var$DefaultErrorComponent() {
    let error = $5c84a101a4932c49$export$ed527bf60f6e05f2();
    let message = (0, $1ce15dc420cde622$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $jMaZ8.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $jMaZ8.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $jMaZ8.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $jMaZ8.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $jMaZ8.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $5c84a101a4932c49$var$defaultErrorElement = /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$DefaultErrorComponent, null);
class $5c84a101a4932c49$var$RenderErrorBoundary extends $jMaZ8.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $5c84a101a4932c49$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $jMaZ8.useContext($5c84a101a4932c49$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5c84a101a4932c49$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $5c84a101a4932c49$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5c84a101a4932c49$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $jMaZ8.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $5c84a101a4932c49$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($5c84a101a4932c49$var$DataRouterHook || {});
var $5c84a101a4932c49$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($5c84a101a4932c49$var$DataRouterStateHook || {});
function $5c84a101a4932c49$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5c84a101a4932c49$var$useDataRouterContext(hookName) {
    let ctx = $jMaZ8.useContext($5c84a101a4932c49$export$3add0d5dce533e2e);
    !ctx && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, $5c84a101a4932c49$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $5c84a101a4932c49$var$useDataRouterState(hookName) {
    let state = $jMaZ8.useContext($5c84a101a4932c49$export$145dfa71566a64dc);
    !state && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, $5c84a101a4932c49$var$getDataRouterConsoleError(hookName));
    return state;
}
function $5c84a101a4932c49$var$useRouteContext(hookName) {
    let route = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057);
    !route && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, $5c84a101a4932c49$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $5c84a101a4932c49$var$useCurrentRouteId(hookName) {
    let route = $5c84a101a4932c49$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, hookName + " can only be used on routes that contain a unique \"id\"");
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $5c84a101a4932c49$export$5fc8298006ad9e58() {
    return $5c84a101a4932c49$var$useCurrentRouteId($5c84a101a4932c49$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5c84a101a4932c49$export$d0fd4b7106de2769() {
    let state = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5c84a101a4932c49$export$600dc272ed516c15() {
    let dataRouterContext = $5c84a101a4932c49$var$useDataRouterContext($5c84a101a4932c49$var$DataRouterHook.UseRevalidator);
    let state = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseRevalidator);
    return $jMaZ8.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5c84a101a4932c49$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseMatches);
    return $jMaZ8.useMemo(()=>matches.map((m)=>(0, $1ce15dc420cde622$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5c84a101a4932c49$export$1448a5050d252c4d() {
    let state = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseLoaderData);
    let routeId = $5c84a101a4932c49$var$useCurrentRouteId($5c84a101a4932c49$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5c84a101a4932c49$export$fd5d37484eab868d(routeId) {
    let state = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5c84a101a4932c49$export$fdc00f3f26066d5e() {
    let state = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseActionData);
    let routeId = $5c84a101a4932c49$var$useCurrentRouteId($5c84a101a4932c49$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $5c84a101a4932c49$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $jMaZ8.useContext($5c84a101a4932c49$var$RouteErrorContext);
    let state = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseRouteError);
    let routeId = $5c84a101a4932c49$var$useCurrentRouteId($5c84a101a4932c49$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $5c84a101a4932c49$export$78a72ddb39bdd145() {
    let value = $jMaZ8.useContext($5c84a101a4932c49$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $5c84a101a4932c49$export$17f53340677d5831() {
    let value = $jMaZ8.useContext($5c84a101a4932c49$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $5c84a101a4932c49$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $5c84a101a4932c49$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5c84a101a4932c49$var$useDataRouterContext($5c84a101a4932c49$var$DataRouterHook.UseBlocker);
    let state = $5c84a101a4932c49$var$useDataRouterState($5c84a101a4932c49$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $jMaZ8.useState("");
    let blockerFunction = $jMaZ8.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $5c84a101a4932c49$var$_extends({}, currentLocation, {
                pathname: (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $5c84a101a4932c49$var$_extends({}, nextLocation, {
                pathname: (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $jMaZ8.useEffect(()=>{
        let key = String(++$5c84a101a4932c49$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $jMaZ8.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1ce15dc420cde622$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $5c84a101a4932c49$var$useNavigateStable() {
    let { router: router } = $5c84a101a4932c49$var$useDataRouterContext($5c84a101a4932c49$var$DataRouterHook.UseNavigateStable);
    let id = $5c84a101a4932c49$var$useCurrentRouteId($5c84a101a4932c49$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $jMaZ8.useRef(false);
    $5c84a101a4932c49$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jMaZ8.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1ce15dc420cde622$export$c0e02632e14916fd)(activeRef.current, $5c84a101a4932c49$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $5c84a101a4932c49$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $5c84a101a4932c49$var$alreadyWarned = {};
function $5c84a101a4932c49$var$warningOnce(key, cond, message) {
    if (!cond && !$5c84a101a4932c49$var$alreadyWarned[key]) {
        $5c84a101a4932c49$var$alreadyWarned[key] = true;
        (0, $1ce15dc420cde622$export$c0e02632e14916fd)(false, message);
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5c84a101a4932c49$var$START_TRANSITION = "startTransition";
const $5c84a101a4932c49$var$startTransitionImpl = $jMaZ8[$5c84a101a4932c49$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5c84a101a4932c49$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $jMaZ8.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jMaZ8.useCallback((newState)=>{
        if (v7_startTransition && $5c84a101a4932c49$var$startTransitionImpl) $5c84a101a4932c49$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $jMaZ8.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $jMaZ8.useEffect(()=>{
        (0, $1ce15dc420cde622$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $jMaZ8.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jMaZ8.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $5c84a101a4932c49$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $5c84a101a4932c49$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $5c84a101a4932c49$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $jMaZ8.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ce15dc420cde622$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jMaZ8.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jMaZ8.useCallback((newState)=>{
        v7_startTransition && $5c84a101a4932c49$var$startTransitionImpl ? $5c84a101a4932c49$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jMaZ8.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $5c84a101a4932c49$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$5c84a101a4932c49$export$9c954a9d03d32f4a() && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    let { future: future, static: isStatic } = $jMaZ8.useContext($5c84a101a4932c49$export$26749e8557646306);
    (0, $1ce15dc420cde622$export$c0e02632e14916fd)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $jMaZ8.useContext($5c84a101a4932c49$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5c84a101a4932c49$export$45d76561a5302f2b();
    let navigate = $5c84a101a4932c49$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1ce15dc420cde622$export$cae722b0cc860f13)(to, (0, $1ce15dc420cde622$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $jMaZ8.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $5c84a101a4932c49$export$910ae8079b2c2852(props) {
    return $5c84a101a4932c49$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $5c84a101a4932c49$export$e7b0ac011bb776c6(_props) {
    (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $5c84a101a4932c49$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1ce15dc420cde622$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$5c84a101a4932c49$export$9c954a9d03d32f4a() && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $jMaZ8.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $5c84a101a4932c49$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1ce15dc420cde622$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $jMaZ8.useMemo(()=>{
        let trailingPathname = (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $1ce15dc420cde622$export$c0e02632e14916fd)(locationContext != null, "<Router basename=\"" + basename + "\"> is not able to match the URL " + ("\"" + pathname + search + hash + "\" because it does not start with the ") + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $5c84a101a4932c49$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $5c84a101a4932c49$export$5d3fca4a98652595($5c84a101a4932c49$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5c84a101a4932c49$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$ResolveAwait, null, children));
}
var $5c84a101a4932c49$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($5c84a101a4932c49$var$AwaitRenderStatus || {});
const $5c84a101a4932c49$var$neverSettledPromise = new Promise(()=>{});
class $5c84a101a4932c49$var$AwaitErrorBoundary extends $jMaZ8.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5c84a101a4932c49$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5c84a101a4932c49$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5c84a101a4932c49$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $5c84a101a4932c49$var$AwaitRenderStatus.error : promise._data !== undefined ? $5c84a101a4932c49$var$AwaitRenderStatus.success : $5c84a101a4932c49$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5c84a101a4932c49$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5c84a101a4932c49$var$AwaitRenderStatus.error && promise._error instanceof (0, $1ce15dc420cde622$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $5c84a101a4932c49$var$neverSettledPromise;
        if (status === $5c84a101a4932c49$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5c84a101a4932c49$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5c84a101a4932c49$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $jMaZ8.createElement($5c84a101a4932c49$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $5c84a101a4932c49$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $5c84a101a4932c49$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $5c84a101a4932c49$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $jMaZ8.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $jMaZ8.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $jMaZ8.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5c84a101a4932c49$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $5c84a101a4932c49$export$e7b0ac011bb776c6) && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5c84a101a4932c49$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5c84a101a4932c49$export$daf73786167a7f72(matches) {
    return $5c84a101a4932c49$var$_renderMatches(matches);
}
function $5c84a101a4932c49$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $1ce15dc420cde622$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $jMaZ8.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, $1ce15dc420cde622$export$c0e02632e14916fd)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ $jMaZ8.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $1ce15dc420cde622$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $jMaZ8.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $5c84a101a4932c49$export$f30f7e456d254e83(routes, opts) {
    return (0, $1ce15dc420cde622$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5c84a101a4932c49$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ce15dc420cde622$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $5c84a101a4932c49$export$52b333d321859367
    }).initialize();
}



function $54720e62f7bfcab9$var$_extends() {
    $54720e62f7bfcab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $54720e62f7bfcab9$var$_extends.apply(this, arguments);
}
function $54720e62f7bfcab9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $54720e62f7bfcab9$var$defaultMethod = "get";
const $54720e62f7bfcab9$var$defaultEncType = "application/x-www-form-urlencoded";
function $54720e62f7bfcab9$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $54720e62f7bfcab9$var$isButtonElement(object) {
    return $54720e62f7bfcab9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $54720e62f7bfcab9$var$isFormElement(object) {
    return $54720e62f7bfcab9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $54720e62f7bfcab9$var$isInputElement(object) {
    return $54720e62f7bfcab9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $54720e62f7bfcab9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $54720e62f7bfcab9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$54720e62f7bfcab9$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $54720e62f7bfcab9$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $54720e62f7bfcab9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $54720e62f7bfcab9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $54720e62f7bfcab9$var$_formDataSupportsSubmitter = null;
function $54720e62f7bfcab9$var$isFormDataSubmitterSupported() {
    if ($54720e62f7bfcab9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $54720e62f7bfcab9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $54720e62f7bfcab9$var$_formDataSupportsSubmitter = true;
    }
    return $54720e62f7bfcab9$var$_formDataSupportsSubmitter;
}
const $54720e62f7bfcab9$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $54720e62f7bfcab9$var$getFormEncType(encType) {
    if (encType != null && !$54720e62f7bfcab9$var$supportedFormEncTypes.has(encType)) {
        (0, $1ce15dc420cde622$export$c0e02632e14916fd)(false, "\"" + encType + "\" is not a valid `encType` for `<Form>`/`<fetcher.Form>` " + ("and will default to \"" + $54720e62f7bfcab9$var$defaultEncType + "\""));
        return null;
    }
    return encType;
}
function $54720e62f7bfcab9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($54720e62f7bfcab9$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $54720e62f7bfcab9$var$defaultMethod;
        encType = $54720e62f7bfcab9$var$getFormEncType(target.getAttribute("enctype")) || $54720e62f7bfcab9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($54720e62f7bfcab9$var$isButtonElement(target) || $54720e62f7bfcab9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $54720e62f7bfcab9$var$defaultMethod;
        encType = $54720e62f7bfcab9$var$getFormEncType(target.getAttribute("formenctype")) || $54720e62f7bfcab9$var$getFormEncType(form.getAttribute("enctype")) || $54720e62f7bfcab9$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$54720e62f7bfcab9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($54720e62f7bfcab9$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $54720e62f7bfcab9$var$defaultMethod;
        action = null;
        encType = $54720e62f7bfcab9$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $54720e62f7bfcab9$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $54720e62f7bfcab9$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $54720e62f7bfcab9$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $54720e62f7bfcab9$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $54720e62f7bfcab9$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $54720e62f7bfcab9$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1ce15dc420cde622$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $54720e62f7bfcab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ce15dc420cde622$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $54720e62f7bfcab9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5c84a101a4932c49$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $54720e62f7bfcab9$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1ce15dc420cde622$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $54720e62f7bfcab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ce15dc420cde622$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $54720e62f7bfcab9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5c84a101a4932c49$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $54720e62f7bfcab9$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $54720e62f7bfcab9$var$_extends({}, state, {
        errors: $54720e62f7bfcab9$var$deserializeErrors(state.errors)
    });
    return state;
}
function $54720e62f7bfcab9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1ce15dc420cde622$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $54720e62f7bfcab9$export$7ad602f0e94e62d1 = /*#__PURE__*/ $jMaZ8.createContext({
    isTransitioning: false
});
$54720e62f7bfcab9$export$7ad602f0e94e62d1.displayName = "ViewTransition";
const $54720e62f7bfcab9$export$148fd98d095596d4 = /*#__PURE__*/ $jMaZ8.createContext(new Map());
$54720e62f7bfcab9$export$148fd98d095596d4.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $54720e62f7bfcab9$var$START_TRANSITION = "startTransition";
const $54720e62f7bfcab9$var$startTransitionImpl = $jMaZ8[$54720e62f7bfcab9$var$START_TRANSITION];
const $54720e62f7bfcab9$var$FLUSH_SYNC = "flushSync";
const $54720e62f7bfcab9$var$flushSyncImpl = $6UWRi[$54720e62f7bfcab9$var$FLUSH_SYNC];
const $54720e62f7bfcab9$var$USE_ID = "useId";
const $54720e62f7bfcab9$var$useIdImpl = $jMaZ8[$54720e62f7bfcab9$var$USE_ID];
function $54720e62f7bfcab9$var$startTransitionSafe(cb) {
    if ($54720e62f7bfcab9$var$startTransitionImpl) $54720e62f7bfcab9$var$startTransitionImpl(cb);
    else cb();
}
function $54720e62f7bfcab9$var$flushSyncSafe(cb) {
    if ($54720e62f7bfcab9$var$flushSyncImpl) $54720e62f7bfcab9$var$flushSyncImpl(cb);
    else cb();
}
class $54720e62f7bfcab9$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $54720e62f7bfcab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $jMaZ8.useState(router.state);
    let [pendingState, setPendingState] = $jMaZ8.useState();
    let [vtContext, setVtContext] = $jMaZ8.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $jMaZ8.useState();
    let [transition, setTransition] = $jMaZ8.useState();
    let [interruption, setInterruption] = $jMaZ8.useState();
    let fetcherData = $jMaZ8.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $jMaZ8.useCallback((cb)=>{
        if (v7_startTransition) $54720e62f7bfcab9$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $jMaZ8.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $54720e62f7bfcab9$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $54720e62f7bfcab9$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $54720e62f7bfcab9$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $54720e62f7bfcab9$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $54720e62f7bfcab9$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $jMaZ8.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $jMaZ8.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $54720e62f7bfcab9$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $jMaZ8.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $jMaZ8.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $jMaZ8.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $jMaZ8.useEffect(()=>{
        (0, $1ce15dc420cde622$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $jMaZ8.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jMaZ8.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement((0, $5c84a101a4932c49$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $5c84a101a4932c49$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $jMaZ8.createElement($54720e62f7bfcab9$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $jMaZ8.createElement($54720e62f7bfcab9$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $5c84a101a4932c49$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $jMaZ8.createElement($54720e62f7bfcab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $54720e62f7bfcab9$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5c84a101a4932c49$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $54720e62f7bfcab9$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $jMaZ8.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ce15dc420cde622$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jMaZ8.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jMaZ8.useCallback((newState)=>{
        v7_startTransition && $54720e62f7bfcab9$var$startTransitionImpl ? $54720e62f7bfcab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jMaZ8.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $5c84a101a4932c49$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $54720e62f7bfcab9$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $jMaZ8.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ce15dc420cde622$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jMaZ8.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jMaZ8.useCallback((newState)=>{
        v7_startTransition && $54720e62f7bfcab9$var$startTransitionImpl ? $54720e62f7bfcab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jMaZ8.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $5c84a101a4932c49$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $54720e62f7bfcab9$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $jMaZ8.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jMaZ8.useCallback((newState)=>{
        v7_startTransition && $54720e62f7bfcab9$var$startTransitionImpl ? $54720e62f7bfcab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jMaZ8.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $5c84a101a4932c49$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
$54720e62f7bfcab9$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $54720e62f7bfcab9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $54720e62f7bfcab9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $54720e62f7bfcab9$export$a6c7ac8248d6e38a = /*#__PURE__*/ $jMaZ8.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $54720e62f7bfcab9$var$_objectWithoutPropertiesLoose(_ref7, $54720e62f7bfcab9$var$_excluded);
    let { basename: basename } = $jMaZ8.useContext((0, $5c84a101a4932c49$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $54720e62f7bfcab9$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($54720e62f7bfcab9$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $1ce15dc420cde622$export$c0e02632e14916fd)(false, "<Link to=\"" + to + "\"> contains an invalid URL which will probably break " + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5c84a101a4932c49$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $54720e62f7bfcab9$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $jMaZ8.createElement("a", $54720e62f7bfcab9$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$54720e62f7bfcab9$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $54720e62f7bfcab9$export$b0d92dbee9b5b60d = /*#__PURE__*/ $jMaZ8.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $54720e62f7bfcab9$var$_objectWithoutPropertiesLoose(_ref8, $54720e62f7bfcab9$var$_excluded2);
    let path = (0, $5c84a101a4932c49$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    let routerState = $jMaZ8.useContext((0, $5c84a101a4932c49$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $jMaZ8.useContext((0, $5c84a101a4932c49$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $54720e62f7bfcab9$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $jMaZ8.createElement($54720e62f7bfcab9$export$a6c7ac8248d6e38a, $54720e62f7bfcab9$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$54720e62f7bfcab9$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $54720e62f7bfcab9$export$a7fed597f4b8afd8 = /*#__PURE__*/ $jMaZ8.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $54720e62f7bfcab9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $54720e62f7bfcab9$var$_objectWithoutPropertiesLoose(_ref9, $54720e62f7bfcab9$var$_excluded3);
    let submit = $54720e62f7bfcab9$export$47c85c6e3a081d3();
    let formAction = $54720e62f7bfcab9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $jMaZ8.createElement("form", $54720e62f7bfcab9$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$54720e62f7bfcab9$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $54720e62f7bfcab9$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $54720e62f7bfcab9$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$54720e62f7bfcab9$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $54720e62f7bfcab9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($54720e62f7bfcab9$var$DataRouterHook || ($54720e62f7bfcab9$var$DataRouterHook = {}));
var $54720e62f7bfcab9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($54720e62f7bfcab9$var$DataRouterStateHook || ($54720e62f7bfcab9$var$DataRouterStateHook = {}));
// Internal hooks
function $54720e62f7bfcab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $54720e62f7bfcab9$var$useDataRouterContext(hookName) {
    let ctx = $jMaZ8.useContext((0, $5c84a101a4932c49$export$3add0d5dce533e2e));
    !ctx && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, $54720e62f7bfcab9$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $54720e62f7bfcab9$var$useDataRouterState(hookName) {
    let state = $jMaZ8.useContext((0, $5c84a101a4932c49$export$145dfa71566a64dc));
    !state && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, $54720e62f7bfcab9$var$getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $54720e62f7bfcab9$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    let location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    let path = (0, $5c84a101a4932c49$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $jMaZ8.useCallback((event)=>{
        if ($54720e62f7bfcab9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1ce15dc420cde622$export$fe53371bee54353d)(location) === (0, $1ce15dc420cde622$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $54720e62f7bfcab9$export$f1a78c17382fe22a(defaultInit) {
    (0, $1ce15dc420cde622$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params\n\nIf you're unsure how to load polyfills, we recommend you check out https://polyfill.io/v3/ which provides some recommendations about how to load polyfills only for users that need them, instead of for every user.");
    let defaultSearchParamsRef = $jMaZ8.useRef($54720e62f7bfcab9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $jMaZ8.useRef(false);
    let location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    let searchParams = $jMaZ8.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $54720e62f7bfcab9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    let setSearchParams = $jMaZ8.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $54720e62f7bfcab9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $54720e62f7bfcab9$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $54720e62f7bfcab9$var$fetcherId = 0;
let $54720e62f7bfcab9$var$getUniqueFetcherId = ()=>"__" + String(++$54720e62f7bfcab9$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $54720e62f7bfcab9$export$47c85c6e3a081d3() {
    let { router: router } = $54720e62f7bfcab9$var$useDataRouterContext($54720e62f7bfcab9$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $jMaZ8.useContext((0, $5c84a101a4932c49$export$26749e8557646306));
    let currentRouteId = (0, $5c84a101a4932c49$export$5fc8298006ad9e58)();
    return $jMaZ8.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $54720e62f7bfcab9$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $54720e62f7bfcab9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $54720e62f7bfcab9$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $54720e62f7bfcab9$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $jMaZ8.useContext((0, $5c84a101a4932c49$export$26749e8557646306));
    let routeContext = $jMaZ8.useContext((0, $5c84a101a4932c49$export$9072aa6dd1f93057));
    !routeContext && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $54720e62f7bfcab9$var$_extends({}, (0, $5c84a101a4932c49$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ce15dc420cde622$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1ce15dc420cde622$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $54720e62f7bfcab9$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $54720e62f7bfcab9$var$useDataRouterContext($54720e62f7bfcab9$var$DataRouterHook.UseFetcher);
    let state = $54720e62f7bfcab9$var$useDataRouterState($54720e62f7bfcab9$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $jMaZ8.useContext($54720e62f7bfcab9$export$148fd98d095596d4);
    let route = $jMaZ8.useContext((0, $5c84a101a4932c49$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "useFetcher can only be used on routes that contain a unique \"id\"");
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $54720e62f7bfcab9$var$useIdImpl ? $54720e62f7bfcab9$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $jMaZ8.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($54720e62f7bfcab9$var$getUniqueFetcherId());
    // Registration/cleanup
    $jMaZ8.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $jMaZ8.useCallback((href, opts)=>{
        !routeId && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $54720e62f7bfcab9$export$47c85c6e3a081d3();
    let submit = $jMaZ8.useCallback((target, opts)=>{
        submitImpl(target, $54720e62f7bfcab9$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $jMaZ8.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $jMaZ8.createElement($54720e62f7bfcab9$export$a7fed597f4b8afd8, $54720e62f7bfcab9$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1ce15dc420cde622$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $jMaZ8.useMemo(()=>$54720e62f7bfcab9$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $54720e62f7bfcab9$export$fa996778a3a31087() {
    let state = $54720e62f7bfcab9$var$useDataRouterState($54720e62f7bfcab9$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $54720e62f7bfcab9$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $54720e62f7bfcab9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $54720e62f7bfcab9$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $54720e62f7bfcab9$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $54720e62f7bfcab9$var$useDataRouterContext($54720e62f7bfcab9$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $54720e62f7bfcab9$var$useDataRouterState($54720e62f7bfcab9$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $jMaZ8.useContext((0, $5c84a101a4932c49$export$26749e8557646306));
    let location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    let matches = (0, $5c84a101a4932c49$export$2378eb7f5ff86053)();
    let navigation = (0, $5c84a101a4932c49$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $jMaZ8.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $54720e62f7bfcab9$var$usePageHide($jMaZ8.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $54720e62f7bfcab9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $54720e62f7bfcab9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($54720e62f7bfcab9$var$savedScrollPositions));
        } catch (error) {
            (0, $1ce15dc420cde622$export$c0e02632e14916fd)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jMaZ8.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $54720e62f7bfcab9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $54720e62f7bfcab9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jMaZ8.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($54720e62f7bfcab9$var$_extends({}, location, {
                    pathname: (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($54720e62f7bfcab9$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jMaZ8.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $54720e62f7bfcab9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jMaZ8.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $54720e62f7bfcab9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jMaZ8.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $54720e62f7bfcab9$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5c84a101a4932c49$export$b273b3273281a049)(when);
    $jMaZ8.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $jMaZ8.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $54720e62f7bfcab9$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $jMaZ8.useContext($54720e62f7bfcab9$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1ce15dc420cde622$export$3e9cee6b33872309)(false, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $54720e62f7bfcab9$var$useDataRouterContext($54720e62f7bfcab9$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5c84a101a4932c49$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1ce15dc420cde622$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1ce15dc420cde622$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1ce15dc420cde622$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("gedkv");
var $9Bzxi = parcelRequire("9Bzxi");
var $jANP6 = parcelRequire("jANP6");

var $jMaZ8 = parcelRequire("jMaZ8");
var $9fb8f1262d04698f$var$IconContext = /*#__PURE__*/ (0, $jMaZ8.createContext)({});
var $9fb8f1262d04698f$export$2e2bcd8739ae039 = $9fb8f1262d04698f$var$IconContext;



var $hBgfL = parcelRequire("hBgfL");

var $3hbWa = parcelRequire("3hbWa");

var $jMaZ8 = parcelRequire("jMaZ8");

var $2bFmQ = parcelRequire("2bFmQ");
function $e55cfce129297019$export$8793edee2d425525() {}
let $e55cfce129297019$var$deprecatedWarnList = null;
function $e55cfce129297019$export$60eef1277fe463e4() {
    $e55cfce129297019$var$deprecatedWarnList = null;
    (0, $2bFmQ.resetWarned)();
}
// eslint-disable-next-line import/no-mutable-exports
let $e55cfce129297019$var$warning = $e55cfce129297019$export$8793edee2d425525;
$e55cfce129297019$var$warning = (valid, component, message)=>{
    (0, $2bFmQ.default)(valid, `[antd: ${component}] ${message}`);
    $e55cfce129297019$export$60eef1277fe463e4();
};
const $e55cfce129297019$export$11b88c75b33aa1fd = /*#__PURE__*/ $jMaZ8.createContext({});
const $e55cfce129297019$export$cf977aa92c751e61 = (component)=>{
    const { strict: strict } = $jMaZ8.useContext($e55cfce129297019$export$11b88c75b33aa1fd);
    const typeWarning = (valid, type, message)=>{
        if (!valid) {
            if (strict === false && type === 'deprecated') {
                const existWarning = $e55cfce129297019$var$deprecatedWarnList;
                if (!$e55cfce129297019$var$deprecatedWarnList) $e55cfce129297019$var$deprecatedWarnList = {};
                $e55cfce129297019$var$deprecatedWarnList[component] = $e55cfce129297019$var$deprecatedWarnList[component] || [];
                if (!$e55cfce129297019$var$deprecatedWarnList[component].includes(message || '')) $e55cfce129297019$var$deprecatedWarnList[component].push(message || '');
                // Warning for the first time
                if (!existWarning) console.warn('[antd] There exists deprecated usage in your code:', $e55cfce129297019$var$deprecatedWarnList);
            } else $e55cfce129297019$var$warning(valid, component, message);
        }
    };
    typeWarning.deprecated = (valid, oldProp, newProp, message)=>{
        typeWarning(valid, 'deprecated', `\`${oldProp}\` is deprecated. Please use \`${newProp}\` instead.${message ? ` ${message}` : ''}`);
    };
    return typeWarning;
};
var $e55cfce129297019$export$2e2bcd8739ae039 = $e55cfce129297019$var$warning;



var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$16feb78216c100f4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);



var $jMaZ8 = parcelRequire("jMaZ8");

var $417359c043c5c735$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $417359c043c5c735$export$2e2bcd8739ae039 = $417359c043c5c735$var$locale;



var $8u3qN = parcelRequire("8u3qN");
var $2804835a90bd00b1$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};


var $e72d0ade03306267$var$locale = (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $2804835a90bd00b1$export$bdd78c3fd9633c1e)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    dateFormat: 'M/D/YYYY',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $e72d0ade03306267$export$2e2bcd8739ae039 = $e72d0ade03306267$var$locale;


const $0e6defc4fd43335f$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $0e6defc4fd43335f$export$2e2bcd8739ae039 = $0e6defc4fd43335f$var$locale;


// Merge into a locale object
const $d1a2785b07ed238d$var$locale = {
    lang: Object.assign({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, (0, $e72d0ade03306267$export$2e2bcd8739ae039)),
    timePickerLocale: Object.assign({}, (0, $0e6defc4fd43335f$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$d1a2785b07ed238d$export$2e2bcd8739ae039 = $d1a2785b07ed238d$var$locale;


var $8e76d413b8a07e27$export$2e2bcd8739ae039 = (0, $d1a2785b07ed238d$export$2e2bcd8739ae039);




const $44fbc0e8f4cce6cb$var$typeTemplate = '${label} is not a valid ${type}';
const $44fbc0e8f4cce6cb$var$localeValues = {
    locale: 'en',
    Pagination: $417359c043c5c735$export$2e2bcd8739ae039,
    DatePicker: $d1a2785b07ed238d$export$2e2bcd8739ae039,
    TimePicker: $0e6defc4fd43335f$export$2e2bcd8739ae039,
    Calendar: $8e76d413b8a07e27$export$2e2bcd8739ae039,
    global: {
        placeholder: 'Please select'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckall: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $44fbc0e8f4cce6cb$var$typeTemplate,
                method: $44fbc0e8f4cce6cb$var$typeTemplate,
                array: $44fbc0e8f4cce6cb$var$typeTemplate,
                object: $44fbc0e8f4cce6cb$var$typeTemplate,
                number: $44fbc0e8f4cce6cb$var$typeTemplate,
                date: $44fbc0e8f4cce6cb$var$typeTemplate,
                boolean: $44fbc0e8f4cce6cb$var$typeTemplate,
                integer: $44fbc0e8f4cce6cb$var$typeTemplate,
                float: $44fbc0e8f4cce6cb$var$typeTemplate,
                regexp: $44fbc0e8f4cce6cb$var$typeTemplate,
                email: $44fbc0e8f4cce6cb$var$typeTemplate,
                url: $44fbc0e8f4cce6cb$var$typeTemplate,
                hex: $44fbc0e8f4cce6cb$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $44fbc0e8f4cce6cb$export$2e2bcd8739ae039 = $44fbc0e8f4cce6cb$var$localeValues;


let $699cf533d6ec795e$var$runtimeLocale = Object.assign({}, (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).Modal);
let $699cf533d6ec795e$var$localeList = [];
const $699cf533d6ec795e$var$generateLocale = ()=>$699cf533d6ec795e$var$localeList.reduce((merged, locale)=>Object.assign(Object.assign({}, merged), locale), (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).Modal);
function $699cf533d6ec795e$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = Object.assign({}, newLocale);
        $699cf533d6ec795e$var$localeList.push(cloneLocale);
        $699cf533d6ec795e$var$runtimeLocale = $699cf533d6ec795e$var$generateLocale();
        return ()=>{
            $699cf533d6ec795e$var$localeList = $699cf533d6ec795e$var$localeList.filter((locale)=>locale !== cloneLocale);
            $699cf533d6ec795e$var$runtimeLocale = $699cf533d6ec795e$var$generateLocale();
        };
    }
    $699cf533d6ec795e$var$runtimeLocale = Object.assign({}, (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).Modal);
}
function $699cf533d6ec795e$export$1b6004afda18cd51() {
    return $699cf533d6ec795e$var$runtimeLocale;
}



var $jMaZ8 = parcelRequire("jMaZ8");
const $23d73f648f990f47$var$LocaleContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);
var $23d73f648f990f47$export$2e2bcd8739ae039 = $23d73f648f990f47$var$LocaleContext;



var $jMaZ8 = parcelRequire("jMaZ8");


const $e878be222e86ee4b$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $jMaZ8.useContext((0, $23d73f648f990f47$export$2e2bcd8739ae039));
    const getLocale = $jMaZ8.useMemo(()=>{
        var _a;
        const locale = defaultLocale || (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $jMaZ8.useMemo(()=>{
        const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $e878be222e86ee4b$export$2e2bcd8739ae039 = $e878be222e86ee4b$var$useLocale;


"use client";
const $6e95b73a7c076079$export$b2f162cd5c15ea3e = 'internalMark';
const $6e95b73a7c076079$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('LocaleProvider');
        warning(_ANT_MARK__ === $6e95b73a7c076079$export$b2f162cd5c15ea3e, 'deprecated', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    }
    $jMaZ8.useEffect(()=>{
        const clearLocale = (0, $699cf533d6ec795e$export$9485ecb9d81a550c)(locale === null || locale === void 0 ? void 0 : locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $jMaZ8.useMemo(()=>Object.assign(Object.assign({}, locale), {
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $23d73f648f990f47$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
$6e95b73a7c076079$var$LocaleProvider.displayName = 'LocaleProvider';
var $6e95b73a7c076079$export$2e2bcd8739ae039 = $6e95b73a7c076079$var$LocaleProvider;




parcelRequire("gedkv");
var $9Bzxi = parcelRequire("9Bzxi");
parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");
var $lvl2c = parcelRequire("lvl2c");
const $bb041746840fc195$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $bb041746840fc195$var$seedToken = Object.assign(Object.assign({}, $bb041746840fc195$export$37e27b43af4d16eb), {
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $bb041746840fc195$export$2e2bcd8739ae039 = $bb041746840fc195$var$seedToken;


parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
function $aace9c683062c80f$export$2e2bcd8739ae039(seed, _ref) {
    let { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes } = _ref;
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $6xABB.FastColor)(errorColors[1]).mix(new (0, $6xABB.FastColor)(errorColors[3]), 50).toHexString();
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $6xABB.FastColor)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    });
}


const $570e1eb6746d5214$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $570e1eb6746d5214$export$2e2bcd8739ae039 = $570e1eb6746d5214$var$genRadius;


function $c810d1ebb15553dd$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return Object.assign({
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $570e1eb6746d5214$export$2e2bcd8739ae039)(borderRadius));
}


const $31b41ac71fff8f3e$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $31b41ac71fff8f3e$export$2e2bcd8739ae039 = $31b41ac71fff8f3e$var$genControlHeight;


function $a781ce02464c6480$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $a781ce02464c6480$export$2e2bcd8739ae039(base) {
    const fontSizes = new Array(10).fill(null).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.pow(Math.E, i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $a781ce02464c6480$export$56204a27a2958a55(size)
        }));
}


const $3f1bed99b357a24d$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $a781ce02464c6480$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $3f1bed99b357a24d$export$2e2bcd8739ae039 = $3f1bed99b357a24d$var$genFontMapToken;


function $93549b3fe0f5ecfa$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}


parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
const $1fef4dd362af7765$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $6xABB.FastColor)(baseColor).setA(alpha).toRgbString();
const $1fef4dd362af7765$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $6xABB.FastColor)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $90fe904849f4a159$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $9Mx90.default)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $90fe904849f4a159$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $1fef4dd362af7765$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $1fef4dd362af7765$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $1fef4dd362af7765$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $1fef4dd362af7765$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $1fef4dd362af7765$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $1fef4dd362af7765$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $43c8058cdea2e9d8$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $lvl2c.presetPrimaryColors).pink = (0, $lvl2c.presetPrimaryColors).magenta;
    (0, $lvl2c.presetPalettes).pink = (0, $lvl2c.presetPalettes).magenta;
    const colorPalettes = Object.keys((0, $bb041746840fc195$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $lvl2c.presetPrimaryColors)[colorKey] ? (0, $lvl2c.presetPalettes)[colorKey] : (0, $9Mx90.default)(token[colorKey]);
        return new Array(10).fill(1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        // biome-ignore lint/style/noParameterAssign: it is a reduce
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $aace9c683062c80f$export$2e2bcd8739ae039)(token, {
        generateColorPalettes: $90fe904849f4a159$export$da275153033f4ec1,
        generateNeutralColorPalettes: $90fe904849f4a159$export$3e0cb0c1d9c1b691
    })), (0, $3f1bed99b357a24d$export$2e2bcd8739ae039)(token.fontSize)), (0, $93549b3fe0f5ecfa$export$2e2bcd8739ae039)(token)), (0, $31b41ac71fff8f3e$export$2e2bcd8739ae039)(token)), (0, $c810d1ebb15553dd$export$2e2bcd8739ae039)(token));
}


const $40212f1ebd0bde99$var$defaultTheme = (0, $9Bzxi.default)((0, $43c8058cdea2e9d8$export$2e2bcd8739ae039));
var $40212f1ebd0bde99$export$2e2bcd8739ae039 = $40212f1ebd0bde99$var$defaultTheme;


var $jMaZ8 = parcelRequire("jMaZ8");


const $714185e40796ef14$export$f84bd70098573c5c = {
    token: (0, $bb041746840fc195$export$2e2bcd8739ae039),
    override: {
        override: (0, $bb041746840fc195$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $714185e40796ef14$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext($714185e40796ef14$export$f84bd70098573c5c);




var $jMaZ8 = parcelRequire("jMaZ8");
const $3613812083e7312f$export$e4ec87ea71f29b41 = 'ant';
const $3613812083e7312f$export$eaca8ee5ed21b4e9 = 'anticon';
const $3613812083e7312f$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled'
];
const $3613812083e7312f$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$3613812083e7312f$export$e4ec87ea71f29b41}-${suffixCls}` : $3613812083e7312f$export$e4ec87ea71f29b41;
};
const $3613812083e7312f$export$a92f85ab3e9ad68b = /*#__PURE__*/ $jMaZ8.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $3613812083e7312f$var$defaultGetPrefixCls,
    iconPrefixCls: $3613812083e7312f$export$eaca8ee5ed21b4e9
});
const { Consumer: $3613812083e7312f$export$cd5442f2b8da7663 } = $3613812083e7312f$export$a92f85ab3e9ad68b;


parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

var $h9ujZ = parcelRequire("h9ujZ");

var $lfFyj = parcelRequire("lfFyj");

const $b95893487fae4279$var$dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function $b95893487fae4279$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    const variables = {};
    const formatColor = (color, updater)=>{
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    const fillColor = (colorVal, type)=>{
        const baseColor = new (0, $6xABB.FastColor)(colorVal);
        const colorPalettes = (0, $9Mx90.default)(baseColor.toRgbString());
        variables[`${type}-color`] = formatColor(baseColor);
        variables[`${type}-color-disabled`] = colorPalettes[1];
        variables[`${type}-color-hover`] = colorPalettes[4];
        variables[`${type}-color-active`] = colorPalettes[6];
        variables[`${type}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
        variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
        variables[`${type}-color-deprecated-border`] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        const primaryColor = new (0, $6xABB.FastColor)(theme.primaryColor);
        const primaryColors = (0, $9Mx90.default)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach((color, index)=>{
            variables[`primary-${index + 1}`] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, (c)=>c.lighten(35));
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, (c)=>c.lighten(20));
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, (c)=>c.tint(20));
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, (c)=>c.tint(50));
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, (c)=>c.setA(c.a * 0.12));
        const primaryActiveColor = new (0, $6xABB.FastColor)(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, (c)=>c.setA(c.a * 0.3));
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, (c)=>c.darken(2));
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    const cssList = Object.keys(variables).map((key)=>`--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join('\n')}
  }
  `.trim();
}
function $b95893487fae4279$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    const style = $b95893487fae4279$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $h9ujZ.default)()) (0, $lfFyj.updateCSS)(style, `${$b95893487fae4279$var$dynamicStyleMark}-dynamic-theme`);
    else (0, $e55cfce129297019$export$2e2bcd8739ae039)(false, 'ConfigProvider', 'SSR do not support dynamic theme with css variables.');
}



var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $fb8ef783ef39e103$var$DisabledContext = /*#__PURE__*/ $jMaZ8.createContext(false);
const $fb8ef783ef39e103$export$6adb5f3b918b11bb = (_ref)=>{
    let { children: children, disabled: disabled } = _ref;
    const originDisabled = $jMaZ8.useContext($fb8ef783ef39e103$var$DisabledContext);
    return /*#__PURE__*/ $jMaZ8.createElement($fb8ef783ef39e103$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $fb8ef783ef39e103$export$2e2bcd8739ae039 = $fb8ef783ef39e103$var$DisabledContext;



var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $1497fcac08ca2dc1$var$SizeContext = /*#__PURE__*/ $jMaZ8.createContext(undefined);
const $1497fcac08ca2dc1$export$dbc92d89fabc8ebe = (_ref)=>{
    let { children: children, size: size } = _ref;
    const originSize = $jMaZ8.useContext($1497fcac08ca2dc1$var$SizeContext);
    return /*#__PURE__*/ $jMaZ8.createElement($1497fcac08ca2dc1$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $1497fcac08ca2dc1$export$2e2bcd8739ae039 = $1497fcac08ca2dc1$var$SizeContext;


function $5489b1ea09c04514$var$useConfig() {
    const componentDisabled = (0, $jMaZ8.useContext)((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const componentSize = (0, $jMaZ8.useContext)((0, $1497fcac08ca2dc1$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $5489b1ea09c04514$export$2e2bcd8739ae039 = $5489b1ea09c04514$var$useConfig;



var $hBgfL = parcelRequire("hBgfL");

var $9O5K3 = parcelRequire("9O5K3");



var $jMaZ8 = parcelRequire("jMaZ8");
const $1ab60a08339e3b63$var$fullClone = Object.assign({}, $jMaZ8);
const { useId: $1ab60a08339e3b63$var$useId } = $1ab60a08339e3b63$var$fullClone;
const $1ab60a08339e3b63$var$useEmptyId = ()=>'';
const $1ab60a08339e3b63$var$useThemeKey = typeof $1ab60a08339e3b63$var$useId === 'undefined' ? $1ab60a08339e3b63$var$useEmptyId : $1ab60a08339e3b63$var$useId;
var $1ab60a08339e3b63$export$2e2bcd8739ae039 = $1ab60a08339e3b63$var$useThemeKey;


function $bc4ef572b47f7021$export$2e2bcd8739ae039(theme, parentTheme, config) {
    var _a, _b;
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, (0, $714185e40796ef14$export$f84bd70098573c5c)), {
        hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : (0, $714185e40796ef14$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
    }) : parentTheme;
    const themeKey = (0, $1ab60a08339e3b63$export$2e2bcd8739ae039)();
    {
        const cssVarEnabled = themeConfig.cssVar || parentThemeConfig.cssVar;
        const validKey = !!(typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || themeKey);
        warning(!cssVarEnabled || validKey, 'breaking', 'Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.');
    }
    return (0, $hBgfL.default)(()=>{
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: config === null || config === void 0 ? void 0 : config.prefixCls
        }, typeof parentThemeConfig.cssVar === 'object' ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === 'object' ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $9O5K3.default)(prevTheme, nextTheme, true);
        }));
}



var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("lsVqZ");
var $7CAII = parcelRequire("7CAII");

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("gedkv");
var $e3Z3v = parcelRequire("e3Z3v");
var $1b01156f9671d1c4$export$2e2bcd8739ae039 = '5.23.3';


"use client";
var $18de2aa178496d47$export$2e2bcd8739ae039 = (0, $1b01156f9671d1c4$export$2e2bcd8739ae039);




parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
function $1d6de466584cd301$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $1d6de466584cd301$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $6xABB.FastColor)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $6xABB.FastColor)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($1d6de466584cd301$var$isStableColor(r) && $1d6de466584cd301$var$isStableColor(g) && $1d6de466584cd301$var$isStableColor(b)) return new (0, $6xABB.FastColor)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $6xABB.FastColor)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $1d6de466584cd301$export$2e2bcd8739ae039 = $1d6de466584cd301$var$getAlphaColor;


var $23a9717051227777$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $23a9717051227777$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override } = derivativeToken, restToken = $23a9717051227777$var$__rest(derivativeToken, [
        "override"
    ]);
    const overrideTokens = Object.assign({}, override);
    Object.keys((0, $bb041746840fc195$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $1d6de466584cd301$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $1d6de466584cd301$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $1d6de466584cd301$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $1d6de466584cd301$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $6xABB.FastColor)('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new (0, $6xABB.FastColor)('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new (0, $6xABB.FastColor)('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)'
    }), overrideTokens);
    return aliasToken;
}


var $5a87977658f50271$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5a87977658f50271$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $5a87977658f50271$export$738b109e247a462c = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
};
const $5a87977658f50271$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $5a87977658f50271$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override } = overrideToken, components = $5a87977658f50271$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $23a9717051227777$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach((_ref)=>{
        let [key, value] = _ref;
        const { theme: componentTheme } = value, componentTokens = $5a87977658f50271$var$__rest(value, [
            "theme"
        ]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $5a87977658f50271$export$18602cb46ae80b62(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $5a87977658f50271$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: cssVar } = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $714185e40796ef14$export$69b0ebb9efcddb30));
    const salt = `${(0, $18de2aa178496d47$export$2e2bcd8739ae039)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $40212f1ebd0bde99$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $e3Z3v.default)(mergedTheme, [
        (0, $bb041746840fc195$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $5a87977658f50271$export$18602cb46ae80b62,
        formatToken: // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        $23a9717051227777$export$2e2bcd8739ae039,
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $5a87977658f50271$export$c6b9faa6b723d31a,
            ignore: $5a87977658f50271$export$738b109e247a462c,
            preserve: $5a87977658f50271$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar
    ];
}


"use client";
function $098a50bcfeea99ed$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $jMaZ8.useRef(false);
    needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion === false;
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $jMaZ8.createElement((0, $7CAII.default), {
        motion: motion
    }, children);
    return children;
}



var $jMaZ8 = parcelRequire("jMaZ8");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $adf1cf7d71dc08df$var$PropWarning = /*#__PURE__*/ $jMaZ8.memo((_ref)=>{
    let { dropdownMatchSelectWidth: dropdownMatchSelectWidth } = _ref;
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
$adf1cf7d71dc08df$var$PropWarning.displayName = 'PropWarning';
var $adf1cf7d71dc08df$export$2e2bcd8739ae039 = $adf1cf7d71dc08df$var$PropWarning;



parcelRequire("gedkv");
var $gofJe = parcelRequire("gofJe");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
"use client";
const $134f73cf3485ce91$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $134f73cf3485ce91$export$23997c3e44cc1c59 = function(token) {
    let needInheritFontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    };
};
const $134f73cf3485ce91$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const $134f73cf3485ce91$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $134f73cf3485ce91$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $134f73cf3485ce91$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
            [prefixSelector]: resetStyle
        })
    };
};
const $134f73cf3485ce91$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $4g3I0.unit)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
        transition: 'outline-offset 0s, outline 0s'
    });
const $134f73cf3485ce91$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': Object.assign({}, $134f73cf3485ce91$export$6539948f0a737e39(token, offset))
    });
const $134f73cf3485ce91$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, $134f73cf3485ce91$export$171ccda7bc085e59()), {
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        })
    });
const $134f73cf3485ce91$export$9a16e7694a707ab4 = (token)=>Object.assign(Object.assign({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none'
    }, $134f73cf3485ce91$export$a44db842bcb28231(token)), {
        '&:focus, &:hover': {
            color: token.colorLinkHover
        },
        '&:active': {
            color: token.colorLinkActive
        }
    });



const $66d72a9525841e55$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $gofJe.default)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>[
            (0, $134f73cf3485ce91$export$f1a0b31dfb234e7e)(iconPrefixCls)
        ]);
};
var $66d72a9525841e55$export$2e2bcd8739ae039 = $66d72a9525841e55$var$useResetIconStyle;


"use client";
var $cf928c204584b9b8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $cf928c204584b9b8$var$existThemeConfig = false;
const $cf928c204584b9b8$export$7c4f6da0f9434a77 = (componentName)=>{
    (0, $e55cfce129297019$export$2e2bcd8739ae039)(!$cf928c204584b9b8$var$existThemeConfig, componentName, `Static function can not consume context like dynamic theme. Please use 'App' component instead.`);
};
const $cf928c204584b9b8$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $cf928c204584b9b8$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $cf928c204584b9b8$var$globalPrefixCls;
let $cf928c204584b9b8$var$globalIconPrefixCls;
let $cf928c204584b9b8$var$globalTheme;
let $cf928c204584b9b8$var$globalHolderRender;
function $cf928c204584b9b8$var$getGlobalPrefixCls() {
    return $cf928c204584b9b8$var$globalPrefixCls || (0, $3613812083e7312f$export$e4ec87ea71f29b41);
}
function $cf928c204584b9b8$var$getGlobalIconPrefixCls() {
    return $cf928c204584b9b8$var$globalIconPrefixCls || (0, $3613812083e7312f$export$eaca8ee5ed21b4e9);
}
function $cf928c204584b9b8$var$isLegacyTheme(theme) {
    return Object.keys(theme).some((key)=>key.endsWith('Color'));
}
const $cf928c204584b9b8$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $cf928c204584b9b8$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $cf928c204584b9b8$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $cf928c204584b9b8$var$globalHolderRender = holderRender;
    if (theme) {
        if ($cf928c204584b9b8$var$isLegacyTheme(theme)) {
            (0, $e55cfce129297019$export$2e2bcd8739ae039)(false, 'ConfigProvider', '`config` of css variable theme is not work in v5. Please use new `theme` config instead.');
            (0, $b95893487fae4279$export$f9c59eed5de5ff80)($cf928c204584b9b8$var$getGlobalPrefixCls(), theme);
        } else $cf928c204584b9b8$var$globalTheme = theme;
    }
};
const $cf928c204584b9b8$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$cf928c204584b9b8$var$getGlobalPrefixCls()}-${suffixCls}` : $cf928c204584b9b8$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $cf928c204584b9b8$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($cf928c204584b9b8$var$globalPrefixCls) return $cf928c204584b9b8$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $cf928c204584b9b8$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$cf928c204584b9b8$var$globalTheme,
        holderRender: $cf928c204584b9b8$var$globalHolderRender
    });
const $cf928c204584b9b8$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, menu: menu, pagination: pagination, input: input, textArea: textArea, empty: empty, badge: badge, radio: radio, rate: rate, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect } = props;
    // =================================== Context ===================================
    const getPrefixCls = $jMaZ8.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $3613812083e7312f$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    (0, $66d72a9525841e55$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    const mergedTheme = (0, $bc4ef572b47f7021$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    $cf928c204584b9b8$var$existThemeConfig = $cf928c204584b9b8$var$existThemeConfig || !!mergedTheme;
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect
    };
    {
        const warningFn = (0, $e55cfce129297019$export$cf977aa92c751e61)('ConfigProvider');
        warningFn(!('autoInsertSpaceInButton' in props), 'deprecated', '`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.');
    }
    const config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $cf928c204584b9b8$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = Object.assign({
        autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $hBgfL.default)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $jMaZ8.useContext((0, $jANP6.default));
    const memoIconContextValue = $jMaZ8.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement((0, $adf1cf7d71dc08df$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $jMaZ8.useMemo(()=>{
        var _a, _b, _c, _d;
        return (0, $3hbWa.merge)(((_a = (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $16feb78216c100f4$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $6e95b73a7c076079$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $6e95b73a7c076079$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $9fb8f1262d04698f$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $1497fcac08ca2dc1$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $098a50bcfeea99ed$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $jMaZ8.useMemo(()=>{
        const _a = mergedTheme || {}, { algorithm: algorithm, token: token, components: components, cssVar: cssVar } = _a, rest = $cf928c204584b9b8$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $9Bzxi.default)(algorithm) : (0, $40212f1ebd0bde99$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach((_ref)=>{
            let [componentName, componentToken] = _ref;
            const parsedToken = Object.assign({}, componentToken);
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $9Bzxi.default)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, (0, $bb041746840fc195$export$2e2bcd8739ae039)), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $714185e40796ef14$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $e55cfce129297019$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $jMaZ8.createElement((0, $fb8ef783ef39e103$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $3613812083e7312f$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $cf928c204584b9b8$var$ConfigProvider = (props)=>{
    const context = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const antLocale = $jMaZ8.useContext((0, $23d73f648f990f47$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $jMaZ8.createElement($cf928c204584b9b8$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$cf928c204584b9b8$var$ConfigProvider.ConfigContext = (0, $3613812083e7312f$export$a92f85ab3e9ad68b);
$cf928c204584b9b8$var$ConfigProvider.SizeContext = (0, $1497fcac08ca2dc1$export$2e2bcd8739ae039);
$cf928c204584b9b8$var$ConfigProvider.config = $cf928c204584b9b8$var$setGlobalConfig;
$cf928c204584b9b8$var$ConfigProvider.useConfig = (0, $5489b1ea09c04514$export$2e2bcd8739ae039);
Object.defineProperty($cf928c204584b9b8$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        (0, $e55cfce129297019$export$2e2bcd8739ae039)(false, 'ConfigProvider', 'ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead.');
        return 0, $1497fcac08ca2dc1$export$2e2bcd8739ae039;
    }
});
$cf928c204584b9b8$var$ConfigProvider.displayName = 'ConfigProvider';
var $cf928c204584b9b8$export$2e2bcd8739ae039 = $cf928c204584b9b8$var$ConfigProvider;


var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");


var $jMaZ8 = parcelRequire("jMaZ8");
const $234e838177158441$export$964282a2c3979546 = /*#__PURE__*/ $jMaZ8.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});



var $a6yuN = parcelRequire("a6yuN");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $590b7b33a8de1289$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $590b7b33a8de1289$export$2e2bcd8739ae039 = $590b7b33a8de1289$var$BarsOutlined;



var $hH60s = parcelRequire("hH60s");

var $3fkx6 = parcelRequire("3fkx6");

var $eq8kl = parcelRequire("eq8kl");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
parcelRequire("1T8KD");
var $lvl2c = parcelRequire("lvl2c");


var $4b02Q = parcelRequire("4b02Q");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");

var $1Esi2 = parcelRequire("1Esi2");
parcelRequire("1T8KD");
var $9Mx90 = parcelRequire("9Mx90");

var $lfFyj = parcelRequire("lfFyj");
function $184337e1baf06507$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $184337e1baf06507$export$cca82218ea4431a(ele) {
    return $184337e1baf06507$var$getRoot(ele) instanceof ShadowRoot;
}
function $184337e1baf06507$export$70e8259662bb498b(ele) {
    return $184337e1baf06507$export$cca82218ea4431a(ele) ? $184337e1baf06507$var$getRoot(ele) : null;
}



var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

function $793846bd9b9de197$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $793846bd9b9de197$export$491112666e282270(valid, message) {
    (0, $2bFmQ.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $793846bd9b9de197$export$ab652842c37578f4(target) {
    return (0, $1Esi2.default)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $1Esi2.default)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $793846bd9b9de197$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$793846bd9b9de197$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $793846bd9b9de197$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(node.tag, (0, $8u3qN.default)({
        key: key
    }, $793846bd9b9de197$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $793846bd9b9de197$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(node.tag, (0, $8u3qN.default)((0, $8u3qN.default)({
        key: key
    }, $793846bd9b9de197$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $793846bd9b9de197$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $793846bd9b9de197$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $9Mx90.default)(primaryColor)[0];
}
function $793846bd9b9de197$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $793846bd9b9de197$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $793846bd9b9de197$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $793846bd9b9de197$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $jMaZ8.useContext)((0, $9fb8f1262d04698f$export$2e2bcd8739ae039)), csp = _useContext.csp, prefixCls = _useContext.prefixCls, layer = _useContext.layer;
    var mergedStyleStr = $793846bd9b9de197$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
    (0, $jMaZ8.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $184337e1baf06507$export$70e8259662bb498b)(ele);
        (0, $lfFyj.updateCSS)(mergedStyleStr, '@ant-design-icons', {
            prepend: true,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


var $df46dd2788165c9f$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $df46dd2788165c9f$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $df46dd2788165c9f$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $df46dd2788165c9f$var$twoToneColorPalette.primaryColor = primaryColor;
    $df46dd2788165c9f$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $793846bd9b9de197$export$b71c93f469694483)(primaryColor);
    $df46dd2788165c9f$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $df46dd2788165c9f$var$getTwoToneColors() {
    return (0, $8u3qN.default)({}, $df46dd2788165c9f$var$twoToneColorPalette);
}
var $df46dd2788165c9f$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $4b02Q.default)(props, $df46dd2788165c9f$var$_excluded);
    var svgRef = $jMaZ8.useRef();
    var colors = $df46dd2788165c9f$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $793846bd9b9de197$export$b71c93f469694483)(primaryColor)
    };
    (0, $793846bd9b9de197$export$938b1f86b61613d0)(svgRef);
    (0, $793846bd9b9de197$export$491112666e282270)((0, $793846bd9b9de197$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $793846bd9b9de197$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $8u3qN.default)((0, $8u3qN.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $793846bd9b9de197$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $8u3qN.default)((0, $8u3qN.default)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps), {}, {
        ref: svgRef
    }));
};
$df46dd2788165c9f$var$IconBase.displayName = 'IconReact';
$df46dd2788165c9f$var$IconBase.getTwoToneColors = $df46dd2788165c9f$var$getTwoToneColors;
$df46dd2788165c9f$var$IconBase.setTwoToneColors = $df46dd2788165c9f$var$setTwoToneColors;
var $df46dd2788165c9f$export$2e2bcd8739ae039 = $df46dd2788165c9f$var$IconBase;



var $3fkx6 = parcelRequire("3fkx6");


function $55b7ef0255a6c8dc$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $793846bd9b9de197$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $3fkx6.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $df46dd2788165c9f$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $55b7ef0255a6c8dc$export$abc7c554784cb4a7() {
    var colors = (0, $df46dd2788165c9f$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
var $21cff4a9cafa1819$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $55b7ef0255a6c8dc$export$8a145f34580ff02b)((0, $lvl2c.blue).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $21cff4a9cafa1819$var$Icon = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $4b02Q.default)(props, $21cff4a9cafa1819$var$_excluded);
    var _React$useContext = $jMaZ8.useContext((0, $9fb8f1262d04698f$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(rootClassName, prefixCls, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $793846bd9b9de197$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $3fkx6.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $jMaZ8.createElement("span", (0, $hH60s.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $df46dd2788165c9f$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$21cff4a9cafa1819$var$Icon.displayName = 'AntdIcon';
$21cff4a9cafa1819$var$Icon.getTwoToneColor = (0, $55b7ef0255a6c8dc$export$abc7c554784cb4a7);
$21cff4a9cafa1819$var$Icon.setTwoToneColor = (0, $55b7ef0255a6c8dc$export$8a145f34580ff02b);
var $21cff4a9cafa1819$export$2e2bcd8739ae039 = $21cff4a9cafa1819$var$Icon;


var $d92fdea97e3a2550$var$BarsOutlined = function BarsOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $590b7b33a8de1289$export$2e2bcd8739ae039)
    }));
};
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ var $d92fdea97e3a2550$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($d92fdea97e3a2550$var$BarsOutlined);
$d92fdea97e3a2550$var$RefIcon.displayName = 'BarsOutlined';
var $d92fdea97e3a2550$export$2e2bcd8739ae039 = $d92fdea97e3a2550$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $87a81b8c9b7e0d01$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $87a81b8c9b7e0d01$export$2e2bcd8739ae039 = $87a81b8c9b7e0d01$var$LeftOutlined;



var $d4dfb236e126b509$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $87a81b8c9b7e0d01$export$2e2bcd8739ae039)
    }));
};
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ var $d4dfb236e126b509$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($d4dfb236e126b509$var$LeftOutlined);
$d4dfb236e126b509$var$RefIcon.displayName = 'LeftOutlined';
var $d4dfb236e126b509$export$2e2bcd8739ae039 = $d4dfb236e126b509$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $963b22443b0a9243$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $963b22443b0a9243$export$2e2bcd8739ae039 = $963b22443b0a9243$var$RightOutlined;



var $467563d24654b2cc$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $963b22443b0a9243$export$2e2bcd8739ae039)
    }));
};
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ var $467563d24654b2cc$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($467563d24654b2cc$var$RightOutlined);
$467563d24654b2cc$var$RefIcon.displayName = 'RightOutlined';
var $467563d24654b2cc$export$2e2bcd8739ae039 = $467563d24654b2cc$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("a1kuN");
var $m8UpB = parcelRequire("m8UpB");



const { genStyleHooks: $263539dacc5f409d$export$51ec95de45185b42, genComponentStyleHook: $263539dacc5f409d$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $263539dacc5f409d$export$1537386bc155ea56 } = (0, $m8UpB.default)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
        return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: (token, config)=>{
        var _a;
        return [
            {
                '&': (0, $134f73cf3485ce91$export$905d771977096614)(token)
            },
            (0, $134f73cf3485ce91$export$f1a0b31dfb234e7e)((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : (0, $3613812083e7312f$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $134f73cf3485ce91$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $5a87977658f50271$export$c6b9faa6b723d31a)
});


const $2cf670a99462864f$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, footerBg: footerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, fontSize: fontSize, bodyBg: bodyBg, headerBg: headerBg } = token;
    return {
        [componentCls]: {
            display: 'flex',
            flex: 'auto',
            flexDirection: 'column',
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            '&, *': {
                boxSizing: 'border-box'
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: 'row',
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: '0 0 auto'
            },
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $4g3I0.unit)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: 'inherit'
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: 'auto',
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $2cf670a99462864f$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: '#001529',
        colorBgBody: colorBgLayout,
        colorBgTrigger: '#002140',
        bodyBg: colorBgLayout,
        headerBg: '#001529',
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: '#001529',
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: '#002140',
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const $2cf670a99462864f$export$da0be9ab56e785fc = [
    [
        'colorBgBody',
        'bodyBg'
    ],
    [
        'colorBgHeader',
        'headerBg'
    ],
    [
        'colorBgTrigger',
        'triggerBg'
    ]
];
var $2cf670a99462864f$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Layout', (token)=>[
        $2cf670a99462864f$var$genLayoutStyle(token)
    ], $2cf670a99462864f$export$9ca1be8807fe0675, {
    deprecatedTokens: $2cf670a99462864f$export$da0be9ab56e785fc
});



const $b872df6d0b7db618$var$genSiderStyle = (token)=>{
    const { componentCls: componentCls, siderBg: siderBg, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, antCls: antCls, triggerHeight: triggerHeight, triggerColor: triggerColor, triggerBg: triggerBg, headerHeight: headerHeight, zeroTriggerWidth: zeroTriggerWidth, zeroTriggerHeight: zeroTriggerHeight, borderRadiusLG: borderRadiusLG, lightSiderBg: lightSiderBg, lightTriggerColor: lightTriggerColor, lightTriggerBg: lightTriggerBg, bodyBg: bodyBg } = token;
    return {
        [componentCls]: {
            position: 'relative',
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            '&-has-trigger': {
                paddingBottom: triggerHeight
            },
            '&-right': {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: '100%',
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: 'auto'
                }
            },
            [`${componentCls}-trigger`]: {
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, $4g3I0.unit)(triggerHeight),
                textAlign: 'center',
                background: triggerBg,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width`]: {
                '> *': {
                    overflow: 'hidden'
                },
                '&-trigger': {
                    position: 'absolute',
                    top: headerHeight,
                    insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    zIndex: 1,
                    width: zeroTriggerWidth,
                    height: zeroTriggerHeight,
                    color: triggerColor,
                    fontSize: token.fontSizeXL,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: siderBg,
                    borderRadius: `0 ${(0, $4g3I0.unit)(borderRadiusLG)} ${(0, $4g3I0.unit)(borderRadiusLG)} 0`,
                    cursor: 'pointer',
                    transition: `background ${motionDurationSlow} ease`,
                    '&::after': {
                        position: 'absolute',
                        inset: 0,
                        background: 'transparent',
                        transition: `all ${motionDurationSlow}`,
                        content: '""'
                    },
                    '&:hover::after': {
                        background: `rgba(255, 255, 255, 0.2)`
                    },
                    '&-right': {
                        insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                        borderRadius: `${(0, $4g3I0.unit)(borderRadiusLG)} 0 0 ${(0, $4g3I0.unit)(borderRadiusLG)}`
                    }
                }
            },
            // Light
            '&-light': {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `1px solid ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
var $b872df6d0b7db618$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)([
    'Layout',
    'Sider'
], (token)=>[
        $b872df6d0b7db618$var$genSiderStyle(token)
    ], (0, $2cf670a99462864f$export$9ca1be8807fe0675), {
    deprecatedTokens: (0, $2cf670a99462864f$export$da0be9ab56e785fc)
});


"use client";
var $9e668e80febfb5a2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9e668e80febfb5a2$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
const $9e668e80febfb5a2$var$isNumeric = (value)=>!Number.isNaN(Number.parseFloat(value)) && isFinite(value);
const $9e668e80febfb5a2$export$63554aebd2a6d54c = /*#__PURE__*/ $jMaZ8.createContext({});
const $9e668e80febfb5a2$var$generateId = (()=>{
    let i = 0;
    return function() {
        let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $9e668e80febfb5a2$var$Sider = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = 'dark', style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint } = props, otherProps = $9e668e80febfb5a2$var$__rest(props, [
        "prefixCls",
        "className",
        "trigger",
        "children",
        "defaultCollapsed",
        "theme",
        "style",
        "collapsible",
        "reverseArrow",
        "width",
        "collapsedWidth",
        "zeroWidthTriggerStyle",
        "breakpoint",
        "onCollapse",
        "onBreakpoint"
    ]);
    const { siderHook: siderHook } = (0, $jMaZ8.useContext)((0, $234e838177158441$export$964282a2c3979546));
    const [collapsed, setCollapsed] = (0, $jMaZ8.useState)('collapsed' in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, $jMaZ8.useState)(false);
    (0, $jMaZ8.useEffect)(()=>{
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse === null || onCollapse === void 0 || onCollapse(value, type);
    };
    // =========================== Prefix ===========================
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b872df6d0b7db618$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $jMaZ8.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint === null || onBreakpoint === void 0 || onBreakpoint(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $jMaZ8.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current(mql);
        }
        let mql;
        if (typeof window !== 'undefined') {
            const { matchMedia: matchMedia } = window;
            if (matchMedia && breakpoint && breakpoint in $9e668e80febfb5a2$var$dimensionMaxMap) {
                mql = matchMedia(`screen and (max-width: ${$9e668e80febfb5a2$var$dimensionMaxMap[breakpoint]})`);
                try {
                    mql.addEventListener('change', responsiveHandler);
                } catch (_a) {
                    mql.addListener(responsiveHandler);
                }
                responsiveHandler(mql);
            }
        }
        return ()=>{
            try {
                mql === null || mql === void 0 || mql.removeEventListener('change', responsiveHandler);
            } catch (_a) {
                mql === null || mql === void 0 || mql.removeListener(responsiveHandler);
            }
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $jMaZ8.useEffect)(()=>{
        const uniqueId = $9e668e80febfb5a2$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    const divProps = (0, $hvG6u.default)(otherProps, [
        'collapsed'
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = $9e668e80febfb5a2$var$isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $jMaZ8.createElement("span", {
        onClick: toggle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ $jMaZ8.createElement((0, $d92fdea97e3a2550$export$2e2bcd8739ae039), null)) : null;
    const reverseIcon = direction === 'rtl' === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ $jMaZ8.createElement((0, $467563d24654b2cc$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $d4dfb236e126b509$export$2e2bcd8739ae039), null),
        collapsed: reverseIcon ? /*#__PURE__*/ $jMaZ8.createElement((0, $d4dfb236e126b509$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $467563d24654b2cc$export$2e2bcd8739ae039), null)
    };
    const status = collapsed ? 'collapsed' : 'expanded';
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = Object.assign(Object.assign({}, style), {
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        minWidth: siderWidth,
        width: siderWidth
    });
    const siderCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: parseFloat(siderWidth) === 0
    }, className, hashId, cssVarCls);
    const contextValue = $jMaZ8.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement($9e668e80febfb5a2$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $jMaZ8.createElement("aside", Object.assign({
        className: siderCls
    }, divProps, {
        style: divStyle,
        ref: ref
    }), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-children`
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null)));
});
$9e668e80febfb5a2$var$Sider.displayName = 'Sider';
var $9e668e80febfb5a2$export$2e2bcd8739ae039 = $9e668e80febfb5a2$var$Sider;


function $b3f84faa04fbc294$export$2e2bcd8739ae039(siders, children, hasSider) {
    if (typeof hasSider === 'boolean') return hasSider;
    if (siders.length) return true;
    const childNodes = (0, $a6yuN.default)(children);
    return childNodes.some((node)=>node.type === (0, $9e668e80febfb5a2$export$2e2bcd8739ae039));
}



"use client";
var $886bcbb2c9b0ead8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $886bcbb2c9b0ead8$var$generator(_ref) {
    let { suffixCls: suffixCls, tagName: tagName, displayName: displayName } = _ref;
    return (BasicComponent)=>{
        const Adapter = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>/*#__PURE__*/ $jMaZ8.createElement(BasicComponent, Object.assign({
                ref: ref,
                suffixCls: suffixCls,
                tagName: tagName
            }, props)));
        Adapter.displayName = displayName;
        return Adapter;
    };
}
const $886bcbb2c9b0ead8$var$Basic = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, suffixCls: suffixCls, className: className, tagName: TagName } = props, others = $886bcbb2c9b0ead8$var$__rest(props, [
        "prefixCls",
        "suffixCls",
        "className",
        "tagName"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const [wrapSSR, hashId, cssVarCls] = (0, $2cf670a99462864f$export$2e2bcd8739ae039)(prefixCls);
    const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
    return wrapSSR(/*#__PURE__*/ $jMaZ8.createElement(TagName, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(customizePrefixCls || prefixWithSuffixCls, className, hashId, cssVarCls),
        ref: ref
    }, others)));
});
const $886bcbb2c9b0ead8$var$BasicLayout = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const [siders, setSiders] = $jMaZ8.useState([]);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, hasSider: hasSider, tagName: Tag, style: style } = props, others = $886bcbb2c9b0ead8$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "children",
        "hasSider",
        "tagName",
        "style"
    ]);
    const passedProps = (0, $hvG6u.default)(others, [
        'suffixCls'
    ]);
    const { getPrefixCls: getPrefixCls, layout: layout } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const mergedHasSider = (0, $b3f84faa04fbc294$export$2e2bcd8739ae039)(siders, children, hasSider);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2cf670a99462864f$export$2e2bcd8739ae039)(prefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
        [`${prefixCls}-has-sider`]: mergedHasSider,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, layout === null || layout === void 0 ? void 0 : layout.className, className, rootClassName, hashId, cssVarCls);
    const contextValue = $jMaZ8.useMemo(()=>({
            siderHook: {
                addSider: (id)=>{
                    setSiders((prev)=>[].concat((0, $fvBso.default)(prev), [
                            id
                        ]));
                },
                removeSider: (id)=>{
                    setSiders((prev)=>prev.filter((currentId)=>currentId !== id));
                }
            }
        }), []);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $234e838177158441$export$964282a2c3979546).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $jMaZ8.createElement(Tag, Object.assign({
        ref: ref,
        className: classString,
        style: Object.assign(Object.assign({}, layout === null || layout === void 0 ? void 0 : layout.style), style)
    }, passedProps), children)));
});
const $886bcbb2c9b0ead8$var$Layout = $886bcbb2c9b0ead8$var$generator({
    tagName: 'div',
    displayName: 'Layout'
})($886bcbb2c9b0ead8$var$BasicLayout);
const $886bcbb2c9b0ead8$export$8b251419efc915eb = $886bcbb2c9b0ead8$var$generator({
    suffixCls: 'header',
    tagName: 'header',
    displayName: 'Header'
})($886bcbb2c9b0ead8$var$Basic);
const $886bcbb2c9b0ead8$export$a06f1c675e846f6f = $886bcbb2c9b0ead8$var$generator({
    suffixCls: 'footer',
    tagName: 'footer',
    displayName: 'Footer'
})($886bcbb2c9b0ead8$var$Basic);
const $886bcbb2c9b0ead8$export$7c6e2c02157bb7d2 = $886bcbb2c9b0ead8$var$generator({
    suffixCls: 'content',
    tagName: 'main',
    displayName: 'Content'
})($886bcbb2c9b0ead8$var$Basic);
var $886bcbb2c9b0ead8$export$2e2bcd8739ae039 = $886bcbb2c9b0ead8$var$Layout;



"use client";
const $a3bb6174129512e9$var$Layout = (0, $886bcbb2c9b0ead8$export$2e2bcd8739ae039);
$a3bb6174129512e9$var$Layout.Header = (0, $886bcbb2c9b0ead8$export$8b251419efc915eb);
$a3bb6174129512e9$var$Layout.Footer = (0, $886bcbb2c9b0ead8$export$a06f1c675e846f6f);
$a3bb6174129512e9$var$Layout.Content = (0, $886bcbb2c9b0ead8$export$7c6e2c02157bb7d2);
$a3bb6174129512e9$var$Layout.Sider = (0, $9e668e80febfb5a2$export$2e2bcd8739ae039);
$a3bb6174129512e9$var$Layout._InternalSiderContext = (0, $9e668e80febfb5a2$export$63554aebd2a6d54c);
var $a3bb6174129512e9$export$2e2bcd8739ae039 = $a3bb6174129512e9$var$Layout;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $fcf1ddc4ac014517$var$extendStatics = function(d, b) {
    $fcf1ddc4ac014517$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fcf1ddc4ac014517$var$extendStatics(d, b);
};
function $fcf1ddc4ac014517$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fcf1ddc4ac014517$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fcf1ddc4ac014517$export$18ce0697a983be9b = function() {
    $fcf1ddc4ac014517$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fcf1ddc4ac014517$export$18ce0697a983be9b.apply(this, arguments);
};
function $fcf1ddc4ac014517$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fcf1ddc4ac014517$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fcf1ddc4ac014517$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fcf1ddc4ac014517$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fcf1ddc4ac014517$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fcf1ddc4ac014517$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $fcf1ddc4ac014517$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fcf1ddc4ac014517$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fcf1ddc4ac014517$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fcf1ddc4ac014517$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fcf1ddc4ac014517$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fcf1ddc4ac014517$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fcf1ddc4ac014517$export$45d3717a4c69092e(o, m, p);
}
function $fcf1ddc4ac014517$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fcf1ddc4ac014517$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fcf1ddc4ac014517$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fcf1ddc4ac014517$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fcf1ddc4ac014517$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fcf1ddc4ac014517$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fcf1ddc4ac014517$export$10c90e4f7922046c(v) {
    return this instanceof $fcf1ddc4ac014517$export$10c90e4f7922046c ? (this.v = v, this) : new $fcf1ddc4ac014517$export$10c90e4f7922046c(v);
}
function $fcf1ddc4ac014517$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fcf1ddc4ac014517$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fcf1ddc4ac014517$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fcf1ddc4ac014517$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fcf1ddc4ac014517$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fcf1ddc4ac014517$export$19a8beecd37a4c45 === "function" ? $fcf1ddc4ac014517$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fcf1ddc4ac014517$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fcf1ddc4ac014517$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $fcf1ddc4ac014517$var$ownKeys = function(o) {
    $fcf1ddc4ac014517$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $fcf1ddc4ac014517$var$ownKeys(o);
};
function $fcf1ddc4ac014517$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $fcf1ddc4ac014517$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $fcf1ddc4ac014517$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $fcf1ddc4ac014517$var$__setModuleDefault(result, mod);
    return result;
}
function $fcf1ddc4ac014517$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fcf1ddc4ac014517$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fcf1ddc4ac014517$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fcf1ddc4ac014517$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fcf1ddc4ac014517$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fcf1ddc4ac014517$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fcf1ddc4ac014517$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fcf1ddc4ac014517$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $fcf1ddc4ac014517$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $fcf1ddc4ac014517$export$2e2bcd8739ae039 = {
    __extends: $fcf1ddc4ac014517$export$a8ba968b8961cb8a,
    __assign: $fcf1ddc4ac014517$export$18ce0697a983be9b,
    __rest: $fcf1ddc4ac014517$export$3c9a16f847548506,
    __decorate: $fcf1ddc4ac014517$export$29e00dfd3077644b,
    __param: $fcf1ddc4ac014517$export$d5ad3fd78186038f,
    __esDecorate: $fcf1ddc4ac014517$export$3a84e1ae4e97e9b0,
    __runInitializers: $fcf1ddc4ac014517$export$d831c04e792af3d,
    __propKey: $fcf1ddc4ac014517$export$6a2a36740a146cb8,
    __setFunctionName: $fcf1ddc4ac014517$export$d1a06452d3489bc7,
    __metadata: $fcf1ddc4ac014517$export$f1db080c865becb9,
    __awaiter: $fcf1ddc4ac014517$export$1050f835b63b671e,
    __generator: $fcf1ddc4ac014517$export$67ebef60e6f28a6,
    __createBinding: $fcf1ddc4ac014517$export$45d3717a4c69092e,
    __exportStar: $fcf1ddc4ac014517$export$f33643c0debef087,
    __values: $fcf1ddc4ac014517$export$19a8beecd37a4c45,
    __read: $fcf1ddc4ac014517$export$8d051b38c9118094,
    __spread: $fcf1ddc4ac014517$export$afc72e2116322959,
    __spreadArrays: $fcf1ddc4ac014517$export$6388937ca91ccae8,
    __spreadArray: $fcf1ddc4ac014517$export$1216008129fb82ed,
    __await: $fcf1ddc4ac014517$export$10c90e4f7922046c,
    __asyncGenerator: $fcf1ddc4ac014517$export$e427f37a30a4de9b,
    __asyncDelegator: $fcf1ddc4ac014517$export$bbd80228419bb833,
    __asyncValues: $fcf1ddc4ac014517$export$e3b29a3d6162315f,
    __makeTemplateObject: $fcf1ddc4ac014517$export$4fb47efe1390b86f,
    __importStar: $fcf1ddc4ac014517$export$c21735bcef00d192,
    __importDefault: $fcf1ddc4ac014517$export$da59b14a69baef04,
    __classPrivateFieldGet: $fcf1ddc4ac014517$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fcf1ddc4ac014517$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fcf1ddc4ac014517$export$81fdc39f203e4e04,
    __addDisposableResource: $fcf1ddc4ac014517$export$88ac25d8e944e405,
    __disposeResources: $fcf1ddc4ac014517$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $fcf1ddc4ac014517$export$889dfb5d17574b0b
};



var $fa8e86f49ae3840d$var$genericMessage = "Invariant Violation";
var $fa8e86f49ae3840d$var$_a = Object.setPrototypeOf, $fa8e86f49ae3840d$var$setPrototypeOf = $fa8e86f49ae3840d$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $fa8e86f49ae3840d$var$_a;
var $fa8e86f49ae3840d$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $fa8e86f49ae3840d$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $fa8e86f49ae3840d$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $fa8e86f49ae3840d$var$genericMessage;
        $fa8e86f49ae3840d$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $fa8e86f49ae3840d$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $fa8e86f49ae3840d$export$cea12affaee22fe8(message);
}
var $fa8e86f49ae3840d$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $fa8e86f49ae3840d$var$verbosityLevel = $fa8e86f49ae3840d$var$verbosityLevels.indexOf("log");
function $fa8e86f49ae3840d$var$wrapConsoleMethod(name) {
    return function() {
        if ($fa8e86f49ae3840d$var$verbosityLevels.indexOf(name) >= $fa8e86f49ae3840d$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $fa8e86f49ae3840d$var$wrapConsoleMethod("debug");
    invariant.log = $fa8e86f49ae3840d$var$wrapConsoleMethod("log");
    invariant.warn = $fa8e86f49ae3840d$var$wrapConsoleMethod("warn");
    invariant.error = $fa8e86f49ae3840d$var$wrapConsoleMethod("error");
})($fa8e86f49ae3840d$export$f5708dca728d7177 || ($fa8e86f49ae3840d$export$f5708dca728d7177 = {}));
function $fa8e86f49ae3840d$export$a80e09f2cd325fb8(level) {
    var old = $fa8e86f49ae3840d$var$verbosityLevels[$fa8e86f49ae3840d$var$verbosityLevel];
    $fa8e86f49ae3840d$var$verbosityLevel = Math.max(0, $fa8e86f49ae3840d$var$verbosityLevels.indexOf(level));
    return old;
}
var $fa8e86f49ae3840d$export$2e2bcd8739ae039 = $fa8e86f49ae3840d$export$f5708dca728d7177;


var $23ecff8bd5ab6c93$export$83d89fbfd8236492 = "3.12.8";


function $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $d1410d7c5cd7e720$export$2e2bcd8739ae039 = (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $78235a8d3a48b5b8$var$prefixCounts = new Map();
function $78235a8d3a48b5b8$export$d0c8ec0fe1b18b70(prefix) {
    var count = $78235a8d3a48b5b8$var$prefixCounts.get(prefix) || 1;
    $78235a8d3a48b5b8$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $b155c7d2c29bed03$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $78235a8d3a48b5b8$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $13e6b16068d1c6dc$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $13e6b16068d1c6dc$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $13e6b16068d1c6dc$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $13e6b16068d1c6dc$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $fa8e86f49ae3840d$export$f5708dca728d7177)(condition, $13e6b16068d1c6dc$var$getHandledErrorMsg(message, args) || $13e6b16068d1c6dc$var$getFallbackErrorMsg(message, args));
}, {
    debug: $13e6b16068d1c6dc$var$wrap((0, $fa8e86f49ae3840d$export$f5708dca728d7177).debug),
    log: $13e6b16068d1c6dc$var$wrap((0, $fa8e86f49ae3840d$export$f5708dca728d7177).log),
    warn: $13e6b16068d1c6dc$var$wrap((0, $fa8e86f49ae3840d$export$f5708dca728d7177).warn),
    error: $13e6b16068d1c6dc$var$wrap((0, $fa8e86f49ae3840d$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $13e6b16068d1c6dc$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $fa8e86f49ae3840d$export$cea12affaee22fe8)($13e6b16068d1c6dc$var$getHandledErrorMsg(message, optionalParams) || $13e6b16068d1c6dc$var$getFallbackErrorMsg(message, optionalParams));
}
var $13e6b16068d1c6dc$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $23ecff8bd5ab6c93$export$83d89fbfd8236492));
function $13e6b16068d1c6dc$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $b155c7d2c29bed03$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $13e6b16068d1c6dc$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $d1410d7c5cd7e720$export$2e2bcd8739ae039)[$13e6b16068d1c6dc$export$b8ca975fa04efdf3] && (0, $d1410d7c5cd7e720$export$2e2bcd8739ae039)[$13e6b16068d1c6dc$export$b8ca975fa04efdf3](message, messageArgs.map($13e6b16068d1c6dc$var$stringify));
}
function $13e6b16068d1c6dc$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $23ecff8bd5ab6c93$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($13e6b16068d1c6dc$var$stringify)
    })));
}




var $7f23e214e110bf99$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;


var $cecb01ade82788f9$exports = {};
"use strict";
// We don't want bundlers to error when they encounter usage of any of these exports.
// It's up to the package author to ensure that if they access React internals,
// they do so in a safe way that won't break if React changes how they use these internals.
// (e.g. only access them in development, and only in an optional way that won't
// break if internals are not there or do not have the expected structure)
// @ts-ignore
$cecb01ade82788f9$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = undefined;
// @ts-ignore
$cecb01ade82788f9$exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;
// @ts-ignore
$cecb01ade82788f9$exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;

// Here we actually pull in the React library and add everything
// it exports to our own `module.exports`.
// If React suddenly were to add one of the above "polyfilled" exports,
// the React version would overwrite our version, so this should be
// future-proof.
Object.assign($cecb01ade82788f9$exports, (parcelRequire("jMaZ8")));




var $72d024d8344a7591$var$isReactNative = (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) == "ReactNative";
var $72d024d8344a7591$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !($72d024d8344a7591$var$isReactNative && !$parcel$global.HermesInternal);
var $72d024d8344a7591$export$7293b8a0b474028d = typeof WeakSet === "function";
var $72d024d8344a7591$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $72d024d8344a7591$export$c34f882e9f1c1637 = $72d024d8344a7591$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $72d024d8344a7591$export$71594e8a50f746f4 = typeof (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $72d024d8344a7591$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $72d024d8344a7591$export$4001f6cd4a62405b = ($72d024d8344a7591$export$71594e8a50f746f4 || $72d024d8344a7591$var$isReactNative) && !$72d024d8344a7591$var$usingJSDOM;



// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $75a491f8196648b1$var$contextKey = (0, $72d024d8344a7591$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $75a491f8196648b1$export$a47505d961ee3a1() {
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)("createContext" in $cecb01ade82788f9$exports, 54);
    var context = $cecb01ade82788f9$exports.createContext[$75a491f8196648b1$var$contextKey];
    if (!context) {
        Object.defineProperty($cecb01ade82788f9$exports.createContext, $75a491f8196648b1$var$contextKey, {
            value: context = $cecb01ade82788f9$exports.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $75a491f8196648b1$export$c2ee824bcc89ca6a = $75a491f8196648b1$export$a47505d961ee3a1;


var $a89d690244472cec$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $75a491f8196648b1$export$a47505d961ee3a1)();
    var parentContext = $cecb01ade82788f9$exports.useContext(ApolloContext);
    var context = $cecb01ade82788f9$exports.useMemo(function() {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(context.client, 55);
    return $cecb01ade82788f9$exports.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};




var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");




var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");


"use client";
const $bbae4fec7b556b8e$var$Empty = ()=>{
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const [locale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Empty');
    const bgColor = new (0, $6xABB.FastColor)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $jMaZ8.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $jMaZ8.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/ $jMaZ8.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $jMaZ8.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $jMaZ8.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $jMaZ8.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $jMaZ8.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
$bbae4fec7b556b8e$var$Empty.displayName = 'EmptyImage';
var $bbae4fec7b556b8e$export$2e2bcd8739ae039 = $bbae4fec7b556b8e$var$Empty;



var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");


"use client";
const $84bb1c4f9d2229de$var$Simple = ()=>{
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const [locale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Empty');
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $jMaZ8.useMemo)(()=>({
            borderColor: new (0, $6xABB.FastColor)(colorFill).onBackground(colorBgContainer).toHexString(),
            shadowColor: new (0, $6xABB.FastColor)(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
            contentColor: new (0, $6xABB.FastColor)(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $jMaZ8.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/ $jMaZ8.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $jMaZ8.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $jMaZ8.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
$84bb1c4f9d2229de$var$Simple.displayName = 'SimpleImage';
var $84bb1c4f9d2229de$export$2e2bcd8739ae039 = $84bb1c4f9d2229de$var$Simple;


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// ============================== Shared ==============================
const $37609c493dbfcb3d$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: 'center',
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: '100%'
                },
                svg: {
                    maxWidth: '100%',
                    height: '100%',
                    margin: 'auto'
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            '&-normal': {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            '&-small': {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$37609c493dbfcb3d$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Empty', (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $8APUt.merge)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return [
        $37609c493dbfcb3d$var$genSharedEmptyStyle(emptyToken)
    ];
});


"use client";
var $2e81825c370cda5d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $2e81825c370cda5d$var$defaultEmptyImg = /*#__PURE__*/ $jMaZ8.createElement((0, $bbae4fec7b556b8e$export$2e2bcd8739ae039), null);
const $2e81825c370cda5d$var$simpleEmptyImg = /*#__PURE__*/ $jMaZ8.createElement((0, $84bb1c4f9d2229de$export$2e2bcd8739ae039), null);
const $2e81825c370cda5d$var$Empty = (props)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image = $2e81825c370cda5d$var$defaultEmptyImg, description: description, children: children, imageStyle: imageStyle, style: style, classNames: emptyClassNames, styles: styles } = props, restProps = $2e81825c370cda5d$var$__rest(props, [
        "className",
        "rootClassName",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle",
        "style",
        "classNames",
        "styles"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, empty: empty } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('empty', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $37609c493dbfcb3d$export$2e2bcd8739ae039)(prefixCls);
    const [locale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Empty');
    const des = typeof description !== 'undefined' ? description : locale === null || locale === void 0 ? void 0 : locale.description;
    const alt = typeof des === 'string' ? des : 'empty';
    let imageNode = null;
    if (typeof image === 'string') imageNode = /*#__PURE__*/ $jMaZ8.createElement("img", {
        alt: alt,
        src: image
    });
    else imageNode = image;
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Empty');
        [
            [
                'imageStyle',
                'styles: { image: {} }'
            ]
        ].forEach((_ref)=>{
            let [deprecatedName, newName] = _ref;
            warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
        });
    }
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, cssVarCls, prefixCls, empty === null || empty === void 0 ? void 0 : empty.className, {
            [`${prefixCls}-normal`]: image === $2e81825c370cda5d$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, (_a = empty === null || empty === void 0 ? void 0 : empty.classNames) === null || _a === void 0 ? void 0 : _a.root, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.root),
        style: Object.assign(Object.assign(Object.assign(Object.assign({}, (_b = empty === null || empty === void 0 ? void 0 : empty.styles) === null || _b === void 0 ? void 0 : _b.root), empty === null || empty === void 0 ? void 0 : empty.style), styles === null || styles === void 0 ? void 0 : styles.root), style)
    }, restProps), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-image`, (_c = empty === null || empty === void 0 ? void 0 : empty.classNames) === null || _c === void 0 ? void 0 : _c.image, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.image),
        style: Object.assign(Object.assign(Object.assign({}, imageStyle), (_d = empty === null || empty === void 0 ? void 0 : empty.styles) === null || _d === void 0 ? void 0 : _d.image), styles === null || styles === void 0 ? void 0 : styles.image)
    }, imageNode), des && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-description`, (_e = empty === null || empty === void 0 ? void 0 : empty.classNames) === null || _e === void 0 ? void 0 : _e.description, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.description),
        style: Object.assign(Object.assign({}, (_f = empty === null || empty === void 0 ? void 0 : empty.styles) === null || _f === void 0 ? void 0 : _f.description), styles === null || styles === void 0 ? void 0 : styles.description)
    }, des), children && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-footer`, (_g = empty === null || empty === void 0 ? void 0 : empty.classNames) === null || _g === void 0 ? void 0 : _g.footer, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.footer),
        style: Object.assign(Object.assign({}, (_h = empty === null || empty === void 0 ? void 0 : empty.styles) === null || _h === void 0 ? void 0 : _h.footer), styles === null || styles === void 0 ? void 0 : styles.footer)
    }, children)));
};
$2e81825c370cda5d$var$Empty.PRESENTED_IMAGE_DEFAULT = $2e81825c370cda5d$var$defaultEmptyImg;
$2e81825c370cda5d$var$Empty.PRESENTED_IMAGE_SIMPLE = $2e81825c370cda5d$var$simpleEmptyImg;
$2e81825c370cda5d$var$Empty.displayName = 'Empty';
var $2e81825c370cda5d$export$2e2bcd8739ae039 = $2e81825c370cda5d$var$Empty;


var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
const $eed7b8e1d0775da5$export$264c6064649f9206 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext({});
const $eed7b8e1d0775da5$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $eed7b8e1d0775da5$export$2e2bcd8739ae039 = $eed7b8e1d0775da5$var$AppContext;




var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

var $c1hLi = parcelRequire("c1hLi");

var $18vmN = parcelRequire("18vmN");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $6UWRi = parcelRequire("6UWRi");
// Let compiler not to search module usage
var $6815a1d56c3226ec$var$fullClone = (0, $8u3qN.default)({}, $6UWRi);
var $6815a1d56c3226ec$var$version = $6815a1d56c3226ec$var$fullClone.version, $6815a1d56c3226ec$var$reactRender = $6815a1d56c3226ec$var$fullClone.render, $6815a1d56c3226ec$var$unmountComponentAtNode = $6815a1d56c3226ec$var$fullClone.unmountComponentAtNode;
var $6815a1d56c3226ec$var$createRoot;
try {
    var $6815a1d56c3226ec$var$mainVersion = Number(($6815a1d56c3226ec$var$version || '').split('.')[0]);
    if ($6815a1d56c3226ec$var$mainVersion >= 18) $6815a1d56c3226ec$var$createRoot = $6815a1d56c3226ec$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $6815a1d56c3226ec$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $6815a1d56c3226ec$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $1Esi2.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $6815a1d56c3226ec$var$MARK = '__rc_react_root__';
// ========================== Render ==========================
function $6815a1d56c3226ec$var$modernRender(node, container) {
    $6815a1d56c3226ec$var$toggleWarning(true);
    var root = container[$6815a1d56c3226ec$var$MARK] || $6815a1d56c3226ec$var$createRoot(container);
    $6815a1d56c3226ec$var$toggleWarning(false);
    root.render(node);
    container[$6815a1d56c3226ec$var$MARK] = root;
}
function $6815a1d56c3226ec$var$legacyRender(node, container) {
    $6815a1d56c3226ec$var$reactRender === null || $6815a1d56c3226ec$var$reactRender === void 0 || $6815a1d56c3226ec$var$reactRender(node, container);
}
function $6815a1d56c3226ec$export$892c6608f54d7438(node, container) {
    return $6815a1d56c3226ec$var$legacyRender(node, container);
}
function $6815a1d56c3226ec$export$b3890eb0ae9dca99(node, container) {
    if ($6815a1d56c3226ec$var$createRoot) {
        $6815a1d56c3226ec$var$modernRender(node, container);
        return;
    }
    $6815a1d56c3226ec$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $6815a1d56c3226ec$var$modernUnmount(_x) {
    return $6815a1d56c3226ec$var$_modernUnmount.apply(this, arguments);
}
function $6815a1d56c3226ec$var$_modernUnmount() {
    $6815a1d56c3226ec$var$_modernUnmount = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee(container) {
        return (0, $c1hLi.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$6815a1d56c3226ec$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$6815a1d56c3226ec$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $6815a1d56c3226ec$var$_modernUnmount.apply(this, arguments);
}
function $6815a1d56c3226ec$var$legacyUnmount(container) {
    $6815a1d56c3226ec$var$unmountComponentAtNode(container);
}
function $6815a1d56c3226ec$export$fd39fe14445b207a(container) {
    return $6815a1d56c3226ec$var$legacyUnmount(container);
}
function $6815a1d56c3226ec$export$121e2d597d222bad(_x2) {
    return $6815a1d56c3226ec$var$_unmount.apply(this, arguments);
}
function $6815a1d56c3226ec$var$_unmount() {
    $6815a1d56c3226ec$var$_unmount = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee2(container) {
        return (0, $c1hLi.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($6815a1d56c3226ec$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $6815a1d56c3226ec$var$modernUnmount(container));
                case 2:
                    $6815a1d56c3226ec$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $6815a1d56c3226ec$var$_unmount.apply(this, arguments);
}



"use client";
const $49fd731f963d0354$var$defaultReactRender = (node, container)=>{
    {
        const majorVersion = parseInt($jMaZ8.version.split('.')[0], 10);
        const fullKeys = Object.keys($6UWRi);
        (0, $e55cfce129297019$export$2e2bcd8739ae039)(majorVersion < 19 || fullKeys.includes('createRoot'), 'compatible', 'antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.');
    }
    (0, $6815a1d56c3226ec$export$b3890eb0ae9dca99)(node, container);
    return ()=>{
        return (0, $6815a1d56c3226ec$export$121e2d597d222bad)(container);
    };
};
let $49fd731f963d0354$var$unstableRender = $49fd731f963d0354$var$defaultReactRender;
function $49fd731f963d0354$export$4d4bf8843d204cca(render) {
    $49fd731f963d0354$var$unstableRender = render;
}
function $49fd731f963d0354$export$1c4a73059151cd3e() {
    return $49fd731f963d0354$var$unstableRender;
}



var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $5022b414d04d372e$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $5022b414d04d372e$export$2e2bcd8739ae039 = $5022b414d04d372e$var$CheckCircleFilled;



var $0c6fc91d0a76dd61$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $5022b414d04d372e$export$2e2bcd8739ae039)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ var $0c6fc91d0a76dd61$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($0c6fc91d0a76dd61$var$CheckCircleFilled);
$0c6fc91d0a76dd61$var$RefIcon.displayName = 'CheckCircleFilled';
var $0c6fc91d0a76dd61$export$2e2bcd8739ae039 = $0c6fc91d0a76dd61$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $a6e8835d28de28fa$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $a6e8835d28de28fa$export$2e2bcd8739ae039 = $a6e8835d28de28fa$var$CloseCircleFilled;



var $93361570ffc8bbe1$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $a6e8835d28de28fa$export$2e2bcd8739ae039)
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ var $93361570ffc8bbe1$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($93361570ffc8bbe1$var$CloseCircleFilled);
$93361570ffc8bbe1$var$RefIcon.displayName = 'CloseCircleFilled';
var $93361570ffc8bbe1$export$2e2bcd8739ae039 = $93361570ffc8bbe1$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $81813784fc11aa52$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $81813784fc11aa52$export$2e2bcd8739ae039 = $81813784fc11aa52$var$CloseOutlined;



var $15b3ead07edba509$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $81813784fc11aa52$export$2e2bcd8739ae039)
    }));
};
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ var $15b3ead07edba509$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($15b3ead07edba509$var$CloseOutlined);
$15b3ead07edba509$var$RefIcon.displayName = 'CloseOutlined';
var $15b3ead07edba509$export$2e2bcd8739ae039 = $15b3ead07edba509$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $e1b3e4a83ba7a764$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $e1b3e4a83ba7a764$export$2e2bcd8739ae039 = $e1b3e4a83ba7a764$var$ExclamationCircleFilled;



var $5244cb05538dbe0c$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $e1b3e4a83ba7a764$export$2e2bcd8739ae039)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $5244cb05538dbe0c$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($5244cb05538dbe0c$var$ExclamationCircleFilled);
$5244cb05538dbe0c$var$RefIcon.displayName = 'ExclamationCircleFilled';
var $5244cb05538dbe0c$export$2e2bcd8739ae039 = $5244cb05538dbe0c$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $253a177207c43c07$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $253a177207c43c07$export$2e2bcd8739ae039 = $253a177207c43c07$var$InfoCircleFilled;



var $510ddd97f52e903f$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $253a177207c43c07$export$2e2bcd8739ae039)
    }));
};
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $510ddd97f52e903f$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($510ddd97f52e903f$var$InfoCircleFilled);
$510ddd97f52e903f$var$RefIcon.displayName = 'InfoCircleFilled';
var $510ddd97f52e903f$export$2e2bcd8739ae039 = $510ddd97f52e903f$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $4273b0115b7ca84a$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $4273b0115b7ca84a$export$2e2bcd8739ae039 = $4273b0115b7ca84a$var$LoadingOutlined;



var $d05b96ef0838a5b9$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $4273b0115b7ca84a$export$2e2bcd8739ae039)
    }));
};
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ var $d05b96ef0838a5b9$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($d05b96ef0838a5b9$var$LoadingOutlined);
$d05b96ef0838a5b9$var$RefIcon.displayName = 'LoadingOutlined';
var $d05b96ef0838a5b9$export$2e2bcd8739ae039 = $d05b96ef0838a5b9$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

var $hH60s = parcelRequire("hH60s");

var $fvBso = parcelRequire("fvBso");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
parcelRequire("lsVqZ");
var $iCAxj = parcelRequire("iCAxj");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $1Esi2 = parcelRequire("1Esi2");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $0d32d7154f3e80e4$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $0d32d7154f3e80e4$var$KeyCode.F1 && keyCode <= $0d32d7154f3e80e4$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $0d32d7154f3e80e4$var$KeyCode.ALT:
            case $0d32d7154f3e80e4$var$KeyCode.CAPS_LOCK:
            case $0d32d7154f3e80e4$var$KeyCode.CONTEXT_MENU:
            case $0d32d7154f3e80e4$var$KeyCode.CTRL:
            case $0d32d7154f3e80e4$var$KeyCode.DOWN:
            case $0d32d7154f3e80e4$var$KeyCode.END:
            case $0d32d7154f3e80e4$var$KeyCode.ESC:
            case $0d32d7154f3e80e4$var$KeyCode.HOME:
            case $0d32d7154f3e80e4$var$KeyCode.INSERT:
            case $0d32d7154f3e80e4$var$KeyCode.LEFT:
            case $0d32d7154f3e80e4$var$KeyCode.MAC_FF_META:
            case $0d32d7154f3e80e4$var$KeyCode.META:
            case $0d32d7154f3e80e4$var$KeyCode.NUMLOCK:
            case $0d32d7154f3e80e4$var$KeyCode.NUM_CENTER:
            case $0d32d7154f3e80e4$var$KeyCode.PAGE_DOWN:
            case $0d32d7154f3e80e4$var$KeyCode.PAGE_UP:
            case $0d32d7154f3e80e4$var$KeyCode.PAUSE:
            case $0d32d7154f3e80e4$var$KeyCode.PRINT_SCREEN:
            case $0d32d7154f3e80e4$var$KeyCode.RIGHT:
            case $0d32d7154f3e80e4$var$KeyCode.SHIFT:
            case $0d32d7154f3e80e4$var$KeyCode.UP:
            case $0d32d7154f3e80e4$var$KeyCode.WIN_KEY:
            case $0d32d7154f3e80e4$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $0d32d7154f3e80e4$var$KeyCode.ZERO && keyCode <= $0d32d7154f3e80e4$var$KeyCode.NINE) return true;
        if (keyCode >= $0d32d7154f3e80e4$var$KeyCode.NUM_ZERO && keyCode <= $0d32d7154f3e80e4$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $0d32d7154f3e80e4$var$KeyCode.A && keyCode <= $0d32d7154f3e80e4$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $0d32d7154f3e80e4$var$KeyCode.SPACE:
            case $0d32d7154f3e80e4$var$KeyCode.QUESTION_MARK:
            case $0d32d7154f3e80e4$var$KeyCode.NUM_PLUS:
            case $0d32d7154f3e80e4$var$KeyCode.NUM_MINUS:
            case $0d32d7154f3e80e4$var$KeyCode.NUM_PERIOD:
            case $0d32d7154f3e80e4$var$KeyCode.NUM_DIVISION:
            case $0d32d7154f3e80e4$var$KeyCode.SEMICOLON:
            case $0d32d7154f3e80e4$var$KeyCode.DASH:
            case $0d32d7154f3e80e4$var$KeyCode.EQUALS:
            case $0d32d7154f3e80e4$var$KeyCode.COMMA:
            case $0d32d7154f3e80e4$var$KeyCode.PERIOD:
            case $0d32d7154f3e80e4$var$KeyCode.SLASH:
            case $0d32d7154f3e80e4$var$KeyCode.APOSTROPHE:
            case $0d32d7154f3e80e4$var$KeyCode.SINGLE_QUOTE:
            case $0d32d7154f3e80e4$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $0d32d7154f3e80e4$var$KeyCode.BACKSLASH:
            case $0d32d7154f3e80e4$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $0d32d7154f3e80e4$export$2e2bcd8739ae039 = $0d32d7154f3e80e4$var$KeyCode;



var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");
var $d4c090a6558ff028$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $d4c090a6558ff028$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $d4c090a6558ff028$var$propList = "".concat($d4c090a6558ff028$var$attributes, " ").concat($d4c090a6558ff028$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $d4c090a6558ff028$var$ariaPrefix = 'aria-';
var $d4c090a6558ff028$var$dataPrefix = 'data-';
function $d4c090a6558ff028$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $d4c090a6558ff028$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $8u3qN.default)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $d4c090a6558ff028$var$match(key, $d4c090a6558ff028$var$ariaPrefix)) || // Data
        mergedConfig.data && $d4c090a6558ff028$var$match(key, $d4c090a6558ff028$var$dataPrefix) || // Attr
        mergedConfig.attr && $d4c090a6558ff028$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


var $a85ed01a53b666b0$var$Notify = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, className = props.className, _props$duration = props.duration, duration = _props$duration === void 0 ? 4.5 : _props$duration, showProgress = props.showProgress, _props$pauseOnHover = props.pauseOnHover, pauseOnHover = _props$pauseOnHover === void 0 ? true : _props$pauseOnHover, eventKey = props.eventKey, content = props.content, closable = props.closable, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? 'x' : _props$closeIcon, divProps = props.props, onClick = props.onClick, onNoticeClose = props.onNoticeClose, times = props.times, forcedHovering = props.hovering;
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), hovering = _React$useState2[0], setHovering = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(0), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), percent = _React$useState4[0], setPercent = _React$useState4[1];
    var _React$useState5 = $jMaZ8.useState(0), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), spentTime = _React$useState6[0], setSpentTime = _React$useState6[1];
    var mergedHovering = forcedHovering || hovering;
    var mergedShowProgress = duration > 0 && showProgress;
    // ======================== Close =========================
    var onInternalClose = function onInternalClose() {
        onNoticeClose(eventKey);
    };
    var onCloseKeyDown = function onCloseKeyDown(e) {
        if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    $jMaZ8.useEffect(function() {
        if (!mergedHovering && duration > 0) {
            var start = Date.now() - spentTime;
            var timeout = setTimeout(function() {
                onInternalClose();
            }, duration * 1000 - spentTime);
            return function() {
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        mergedHovering,
        times
    ]);
    $jMaZ8.useEffect(function() {
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            var start = performance.now();
            var animationFrame;
            var calculate = function calculate() {
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame(function(timestamp) {
                    var runtime = timestamp + spentTime - start;
                    var progress = Math.min(runtime / (duration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return function() {
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    var closableObj = $jMaZ8.useMemo(function() {
        if ((0, $1Esi2.default)(closable) === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon
        };
        return {};
    }, [
        closable,
        closeIcon
    ]);
    var ariaProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(closableObj, true);
    // ======================== Progress ========================
    var validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    var noticePrefixCls = "".concat(prefixCls, "-notice");
    return /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({}, divProps, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(noticePrefixCls, className, (0, $eq8kl.default)({}, "".concat(noticePrefixCls, "-closable"), closable)),
        style: style,
        onMouseEnter: function onMouseEnter(e) {
            var _divProps$onMouseEnte;
            setHovering(true);
            divProps === null || divProps === void 0 || (_divProps$onMouseEnte = divProps.onMouseEnter) === null || _divProps$onMouseEnte === void 0 || _divProps$onMouseEnte.call(divProps, e);
        },
        onMouseLeave: function onMouseLeave(e) {
            var _divProps$onMouseLeav;
            setHovering(false);
            divProps === null || divProps === void 0 || (_divProps$onMouseLeav = divProps.onMouseLeave) === null || _divProps$onMouseLeav === void 0 || _divProps$onMouseLeav.call(divProps, e);
        },
        onClick: onClick
    }), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(noticePrefixCls, "-content")
    }, content), closable && /*#__PURE__*/ $jMaZ8.createElement("a", (0, $hH60s.default)({
        tabIndex: 0,
        className: "".concat(noticePrefixCls, "-close"),
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon), mergedShowProgress && /*#__PURE__*/ $jMaZ8.createElement("progress", {
        className: "".concat(noticePrefixCls, "-progress"),
        max: "100",
        value: validPercent
    }, validPercent + '%'));
});
var $a85ed01a53b666b0$export$2e2bcd8739ae039 = $a85ed01a53b666b0$var$Notify;



var $jMaZ8 = parcelRequire("jMaZ8");
var $931a4f49d98ab7a5$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext({});
var $931a4f49d98ab7a5$var$NotificationProvider = function NotificationProvider(_ref) {
    var children = _ref.children, classNames = _ref.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($931a4f49d98ab7a5$export$a6e93d8cb5d50678.Provider, {
        value: {
            classNames: classNames
        }
    }, children);
};
var $931a4f49d98ab7a5$export$2e2bcd8739ae039 = $931a4f49d98ab7a5$var$NotificationProvider;



var $1Esi2 = parcelRequire("1Esi2");
var $ea5ac9d096b649c1$var$DEFAULT_OFFSET = 8;
var $ea5ac9d096b649c1$var$DEFAULT_THRESHOLD = 3;
var $ea5ac9d096b649c1$var$DEFAULT_GAP = 16;
var $ea5ac9d096b649c1$var$useStack = function useStack(config) {
    var result = {
        offset: $ea5ac9d096b649c1$var$DEFAULT_OFFSET,
        threshold: $ea5ac9d096b649c1$var$DEFAULT_THRESHOLD,
        gap: $ea5ac9d096b649c1$var$DEFAULT_GAP
    };
    if (config && (0, $1Esi2.default)(config) === 'object') {
        var _config$offset, _config$threshold, _config$gap;
        result.offset = (_config$offset = config.offset) !== null && _config$offset !== void 0 ? _config$offset : $ea5ac9d096b649c1$var$DEFAULT_OFFSET;
        result.threshold = (_config$threshold = config.threshold) !== null && _config$threshold !== void 0 ? _config$threshold : $ea5ac9d096b649c1$var$DEFAULT_THRESHOLD;
        result.gap = (_config$gap = config.gap) !== null && _config$gap !== void 0 ? _config$gap : $ea5ac9d096b649c1$var$DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
var $ea5ac9d096b649c1$export$2e2bcd8739ae039 = $ea5ac9d096b649c1$var$useStack;


var $fb63a7a2009ad287$var$_excluded = [
    "className",
    "style",
    "classNames",
    "styles"
];
var $fb63a7a2009ad287$var$NoticeList = function NoticeList(props) {
    var configList = props.configList, placement = props.placement, prefixCls = props.prefixCls, className = props.className, style = props.style, motion = props.motion, onAllNoticeRemoved = props.onAllNoticeRemoved, onNoticeClose = props.onNoticeClose, stackConfig = props.stack;
    var _useContext = (0, $jMaZ8.useContext)((0, $931a4f49d98ab7a5$export$a6e93d8cb5d50678)), ctxCls = _useContext.classNames;
    var dictRef = (0, $jMaZ8.useRef)({});
    var _useState = (0, $jMaZ8.useState)(null), _useState2 = (0, $3fkx6.default)(_useState, 2), latestNotice = _useState2[0], setLatestNotice = _useState2[1];
    var _useState3 = (0, $jMaZ8.useState)([]), _useState4 = (0, $3fkx6.default)(_useState3, 2), hoverKeys = _useState4[0], setHoverKeys = _useState4[1];
    var keys = configList.map(function(config) {
        return {
            config: config,
            key: String(config.key)
        };
    });
    var _useStack = (0, $ea5ac9d096b649c1$export$2e2bcd8739ae039)(stackConfig), _useStack2 = (0, $3fkx6.default)(_useStack, 2), stack = _useStack2[0], _useStack2$ = _useStack2[1], offset = _useStack2$.offset, threshold = _useStack2$.threshold, gap = _useStack2$.gap;
    var expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    var placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // Clean hover key
    (0, $jMaZ8.useEffect)(function() {
        if (stack && hoverKeys.length > 1) setHoverKeys(function(prev) {
            return prev.filter(function(key) {
                return keys.some(function(_ref) {
                    var dataKey = _ref.key;
                    return key === dataKey;
                });
            });
        });
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, $jMaZ8.useEffect)(function() {
        var _keys;
        if (stack && dictRef.current[(_keys = keys[keys.length - 1]) === null || _keys === void 0 ? void 0 : _keys.key]) {
            var _keys2;
            setLatestNotice(dictRef.current[(_keys2 = keys[keys.length - 1]) === null || _keys2 === void 0 ? void 0 : _keys2.key]);
        }
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $iCAxj.default), (0, $hH60s.default)({
        key: placement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, "".concat(prefixCls, "-").concat(placement), ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.list, className, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-stack"), !!stack), "".concat(prefixCls, "-stack-expanded"), expanded)),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: function onAllRemoved() {
            onAllNoticeRemoved(placement);
        }
    }), function(_ref2, nodeRef) {
        var config = _ref2.config, motionClassName = _ref2.className, motionStyle = _ref2.style, motionIndex = _ref2.index;
        var _ref3 = config, key = _ref3.key, times = _ref3.times;
        var strKey = String(key);
        var _ref4 = config, configClassName = _ref4.className, configStyle = _ref4.style, configClassNames = _ref4.classNames, configStyles = _ref4.styles, restConfig = (0, $4b02Q.default)(_ref4, $fb63a7a2009ad287$var$_excluded);
        var dataIndex = keys.findIndex(function(item) {
            return item.key === strKey;
        });
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        var stackStyle = {};
        if (stack) {
            var index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            var transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
            if (index > 0) {
                var _dictRef$current$strK, _dictRef$current$strK2, _dictRef$current$strK3;
                stackStyle.height = expanded ? (_dictRef$current$strK = dictRef.current[strKey]) === null || _dictRef$current$strK === void 0 ? void 0 : _dictRef$current$strK.offsetHeight : latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetHeight;
                // Transform
                var verticalOffset = 0;
                for(var i = 0; i < index; i++){
                    var _dictRef$current$keys;
                    verticalOffset += ((_dictRef$current$keys = dictRef.current[keys[keys.length - 1 - i].key]) === null || _dictRef$current$keys === void 0 ? void 0 : _dictRef$current$keys.offsetHeight) + gap;
                }
                var transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
                var scaleX = !expanded && latestNotice !== null && latestNotice !== void 0 && latestNotice.offsetWidth && (_dictRef$current$strK2 = dictRef.current[strKey]) !== null && _dictRef$current$strK2 !== void 0 && _dictRef$current$strK2.offsetWidth ? ((latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetWidth) - offset * 2 * (index < 3 ? index : 3)) / ((_dictRef$current$strK3 = dictRef.current[strKey]) === null || _dictRef$current$strK3 === void 0 ? void 0 : _dictRef$current$strK3.offsetWidth) : 1;
                stackStyle.transform = "translate3d(".concat(transformX, ", ").concat(transformY, "px, 0) scaleX(").concat(scaleX, ")");
            } else stackStyle.transform = "translate3d(".concat(transformX, ", 0, 0)");
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
            ref: nodeRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-notice-wrapper"), motionClassName, configClassNames === null || configClassNames === void 0 ? void 0 : configClassNames.wrapper),
            style: (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, motionStyle), stackStyle), configStyles === null || configStyles === void 0 ? void 0 : configStyles.wrapper),
            onMouseEnter: function onMouseEnter() {
                return setHoverKeys(function(prev) {
                    return prev.includes(strKey) ? prev : [].concat((0, $fvBso.default)(prev), [
                        strKey
                    ]);
                });
            },
            onMouseLeave: function onMouseLeave() {
                return setHoverKeys(function(prev) {
                    return prev.filter(function(k) {
                        return k !== strKey;
                    });
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $a85ed01a53b666b0$export$2e2bcd8739ae039), (0, $hH60s.default)({}, restConfig, {
            ref: function ref(node) {
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(configClassName, ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
$fb63a7a2009ad287$var$NoticeList.displayName = 'NoticeList';
var $fb63a7a2009ad287$export$2e2bcd8739ae039 = $fb63a7a2009ad287$var$NoticeList;


// ant-notification ant-notification-topRight
var $51f5ae14d00348a1$var$Notifications = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-notification' : _props$prefixCls, container = props.container, motion = props.motion, maxCount = props.maxCount, className = props.className, style = props.style, onAllRemoved = props.onAllRemoved, stack = props.stack, renderNotifications = props.renderNotifications;
    var _React$useState = $jMaZ8.useState([]), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), configList = _React$useState2[0], setConfigList = _React$useState2[1];
    // ======================== Close =========================
    var onNoticeClose = function onNoticeClose(key) {
        var _config$onClose;
        // Trigger close event
        var config = configList.find(function(item) {
            return item.key === key;
        });
        config === null || config === void 0 || (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
        setConfigList(function(list) {
            return list.filter(function(item) {
                return item.key !== key;
            });
        });
    };
    // ========================= Refs =========================
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            open: function open(config) {
                setConfigList(function(list) {
                    var clone = (0, $fvBso.default)(list);
                    // Replace if exist
                    var index = clone.findIndex(function(item) {
                        return item.key === config.key;
                    });
                    var innerConfig = (0, $8u3qN.default)({}, config);
                    if (index >= 0) {
                        var _list$index;
                        innerConfig.times = (((_list$index = list[index]) === null || _list$index === void 0 ? void 0 : _list$index.times) || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: function close(key) {
                onNoticeClose(key);
            },
            destroy: function destroy() {
                setConfigList([]);
            }
        };
    });
    // ====================== Placements ======================
    var _React$useState3 = $jMaZ8.useState({}), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), placements = _React$useState4[0], setPlacements = _React$useState4[1];
    $jMaZ8.useEffect(function() {
        var nextPlacements = {};
        configList.forEach(function(config) {
            var _config$placement = config.placement, placement = _config$placement === void 0 ? 'topRight' : _config$placement;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach(function(placement) {
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    var onAllNoticeRemoved = function onAllNoticeRemoved(placement) {
        setPlacements(function(originPlacements) {
            var clone = (0, $8u3qN.default)({}, originPlacements);
            var list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    var emptyRef = $jMaZ8.useRef(false);
    $jMaZ8.useEffect(function() {
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved === null || onAllRemoved === void 0 || onAllRemoved();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    var placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $6UWRi.createPortal)(/*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, placementList.map(function(placement) {
        var placementConfigList = placements[placement];
        var list = /*#__PURE__*/ $jMaZ8.createElement((0, $fb63a7a2009ad287$export$2e2bcd8739ae039), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className === null || className === void 0 ? void 0 : className(placement),
            style: style === null || style === void 0 ? void 0 : style(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }) : list;
    })), container);
});
$51f5ae14d00348a1$var$Notifications.displayName = 'Notifications';
var $51f5ae14d00348a1$export$2e2bcd8739ae039 = $51f5ae14d00348a1$var$Notifications;


var $7f32c9b14d453529$var$_excluded = [
    "getContainer",
    "motion",
    "prefixCls",
    "maxCount",
    "className",
    "style",
    "onAllRemoved",
    "stack",
    "renderNotifications"
];
var $7f32c9b14d453529$var$defaultGetContainer = function defaultGetContainer() {
    return document.body;
};
var $7f32c9b14d453529$var$uniqueKey = 0;
function $7f32c9b14d453529$var$mergeConfig() {
    var clone = {};
    for(var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++)objList[_key] = arguments[_key];
    objList.forEach(function(obj) {
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function $7f32c9b14d453529$export$2e2bcd8739ae039() {
    var rootConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _rootConfig$getContai = rootConfig.getContainer, getContainer = _rootConfig$getContai === void 0 ? $7f32c9b14d453529$var$defaultGetContainer : _rootConfig$getContai, motion = rootConfig.motion, prefixCls = rootConfig.prefixCls, maxCount = rootConfig.maxCount, className = rootConfig.className, style = rootConfig.style, onAllRemoved = rootConfig.onAllRemoved, stack = rootConfig.stack, renderNotifications = rootConfig.renderNotifications, shareConfig = (0, $4b02Q.default)(rootConfig, $7f32c9b14d453529$var$_excluded);
    var _React$useState = $jMaZ8.useState(), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), container = _React$useState2[0], setContainer = _React$useState2[1];
    var notificationsRef = $jMaZ8.useRef();
    var contextHolder = /*#__PURE__*/ $jMaZ8.createElement((0, $51f5ae14d00348a1$export$2e2bcd8739ae039), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    var _React$useState3 = $jMaZ8.useState([]), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), taskQueue = _React$useState4[0], setTaskQueue = _React$useState4[1];
    // ========================= Refs =========================
    var api = $jMaZ8.useMemo(function() {
        return {
            open: function open(config) {
                var mergedConfig = $7f32c9b14d453529$var$mergeConfig(shareConfig, config);
                if (mergedConfig.key === null || mergedConfig.key === undefined) {
                    mergedConfig.key = "rc-notification-".concat($7f32c9b14d453529$var$uniqueKey);
                    $7f32c9b14d453529$var$uniqueKey += 1;
                }
                setTaskQueue(function(queue) {
                    return [].concat((0, $fvBso.default)(queue), [
                        {
                            type: 'open',
                            config: mergedConfig
                        }
                    ]);
                });
            },
            close: function close(key) {
                setTaskQueue(function(queue) {
                    return [].concat((0, $fvBso.default)(queue), [
                        {
                            type: 'close',
                            key: key
                        }
                    ]);
                });
            },
            destroy: function destroy() {
                setTaskQueue(function(queue) {
                    return [].concat((0, $fvBso.default)(queue), [
                        {
                            type: 'destroy'
                        }
                    ]);
                });
            }
        };
    }, []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $jMaZ8.useEffect(function() {
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    $jMaZ8.useEffect(function() {
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach(function(task) {
                switch(task.type){
                    case 'open':
                        notificationsRef.current.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue(function(oriQueue) {
                return oriQueue.filter(function(task) {
                    return !taskQueue.includes(task);
                });
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}








/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $aecc7c07ac00a064$var$useCSSVarCls = (prefixCls)=>{
    const [, , , , cssVar] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    return cssVar ? `${prefixCls}-css-var` : '';
};
var $aecc7c07ac00a064$export$2e2bcd8739ae039 = $aecc7c07ac00a064$var$useCSSVarCls;


parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");
var $4g3I0 = parcelRequire("4g3I0");

var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");
const $215be6e5138b7346$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext(undefined);
$215be6e5138b7346$var$zIndexContext.displayName = 'zIndexContext';
var $215be6e5138b7346$export$2e2bcd8739ae039 = $215be6e5138b7346$var$zIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET = 100;
const $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $5f1c4f12ab1f6aec$export$33ada7d8845f7e5 = $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET * $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $5f1c4f12ab1f6aec$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $5f1c4f12ab1f6aec$export$33ada7d8845f7e5 + $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET;
const $5f1c4f12ab1f6aec$export$1658852af8bb2a55 = {
    Modal: $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET,
    Drawer: $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET,
    Popover: $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET,
    Popconfirm: $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET,
    Tooltip: $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET,
    Tour: $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET,
    FloatButton: $5f1c4f12ab1f6aec$var$CONTAINER_OFFSET
};
const $5f1c4f12ab1f6aec$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
function $5f1c4f12ab1f6aec$var$isContainerType(type) {
    return type in $5f1c4f12ab1f6aec$export$1658852af8bb2a55;
}
const $5f1c4f12ab1f6aec$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $215be6e5138b7346$export$2e2bcd8739ae039));
    const isContainer = $5f1c4f12ab1f6aec$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $5f1c4f12ab1f6aec$export$1658852af8bb2a55[componentType];
        else zIndex += $5f1c4f12ab1f6aec$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)(componentType);
        const maxZIndex = token.zIndexPopupBase + $5f1c4f12ab1f6aec$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN;
        const currentZIndex = result[0] || 0;
        warning(customZIndex !== undefined || currentZIndex <= maxZIndex, 'usage', '`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.');
    }
    return result;
};



parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");
const $9b7990729b573de5$var$genNotificationPlacementStyle = (token)=>{
    const { componentCls: componentCls, notificationMarginEdge: notificationMarginEdge, animationMaxHeight: animationMaxHeight } = token;
    const noticeCls = `${componentCls}-notice`;
    const rightFadeIn = new (0, $kB90R.default)('antNotificationFadeIn', {
        '0%': {
            transform: `translate3d(100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    const topFadeIn = new (0, $kB90R.default)('antNotificationTopFadeIn', {
        '0%': {
            top: -animationMaxHeight,
            opacity: 0
        },
        '100%': {
            top: 0,
            opacity: 1
        }
    });
    const bottomFadeIn = new (0, $kB90R.default)('antNotificationBottomFadeIn', {
        '0%': {
            bottom: token.calc(animationMaxHeight).mul(-1).equal(),
            opacity: 0
        },
        '100%': {
            bottom: 0,
            opacity: 1
        }
    });
    const leftFadeIn = new (0, $kB90R.default)('antNotificationLeftFadeIn', {
        '0%': {
            transform: `translate3d(-100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    return {
        [componentCls]: {
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                marginInline: 0,
                [noticeCls]: {
                    marginInline: 'auto auto'
                }
            },
            [`&${componentCls}-top`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: topFadeIn
                }
            },
            [`&${componentCls}-bottom`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: bottomFadeIn
                }
            },
            [`&${componentCls}-topRight, &${componentCls}-bottomRight`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: rightFadeIn
                }
            },
            [`&${componentCls}-topLeft, &${componentCls}-bottomLeft`]: {
                marginRight: {
                    value: 0,
                    _skip_check_: true
                },
                marginLeft: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [noticeCls]: {
                    marginInlineEnd: 'auto',
                    marginInlineStart: 0
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: leftFadeIn
                }
            }
        }
    };
};
var $9b7990729b573de5$export$2e2bcd8739ae039 = $9b7990729b573de5$var$genNotificationPlacementStyle;


const $5f7f1e0a0abeb10e$export$617a29b5d3b30216 = [
    'top',
    'topLeft',
    'topRight',
    'bottom',
    'bottomLeft',
    'bottomRight'
];


const $c1808a6f809a6884$var$placementAlignProperty = {
    topLeft: 'left',
    topRight: 'right',
    bottomLeft: 'left',
    bottomRight: 'right',
    top: 'left',
    bottom: 'left'
};
const $c1808a6f809a6884$var$genPlacementStackStyle = (token, placement)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-${placement}`]: {
            [`&${componentCls}-stack > ${componentCls}-notice-wrapper`]: {
                [placement.startsWith('top') ? 'top' : 'bottom']: 0,
                [$c1808a6f809a6884$var$placementAlignProperty[placement]]: {
                    value: 0,
                    _skip_check_: true
                }
            }
        }
    };
};
const $c1808a6f809a6884$var$genStackChildrenStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        overflow: 'hidden',
        [`& > ${token.componentCls}-notice`]: {
            opacity: 0,
            transition: `opacity ${token.motionDurationMid}`
        }
    };
    return Object.assign({
        [`&:not(:nth-last-child(-n+${token.notificationStackLayer}))`]: {
            opacity: 0,
            overflow: 'hidden',
            color: 'transparent',
            pointerEvents: 'none'
        }
    }, childrenStyle);
};
const $c1808a6f809a6884$var$genStackedNoticeStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        background: token.colorBgBlur,
        backdropFilter: 'blur(10px)',
        '-webkit-backdrop-filter': 'blur(10px)'
    };
    return Object.assign({}, childrenStyle);
};
const $c1808a6f809a6884$var$genStackStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return Object.assign({
        [`${componentCls}-stack`]: {
            [`& > ${componentCls}-notice-wrapper`]: Object.assign({
                transition: `transform ${token.motionDurationSlow}, backdrop-filter 0s`,
                willChange: 'transform, opacity',
                position: 'absolute'
            }, $c1808a6f809a6884$var$genStackChildrenStyle(token))
        },
        [`${componentCls}-stack:not(${componentCls}-stack-expanded)`]: {
            [`& > ${componentCls}-notice-wrapper`]: Object.assign({}, $c1808a6f809a6884$var$genStackedNoticeStyle(token))
        },
        [`${componentCls}-stack${componentCls}-stack-expanded`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                '&:not(:nth-last-child(-n + 1))': {
                    opacity: 1,
                    overflow: 'unset',
                    color: 'inherit',
                    pointerEvents: 'auto',
                    [`& > ${token.componentCls}-notice`]: {
                        opacity: 1
                    }
                },
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    height: token.margin,
                    width: '100%',
                    insetInline: 0,
                    bottom: token.calc(token.margin).mul(-1).equal(),
                    background: 'transparent',
                    pointerEvents: 'auto'
                }
            }
        }
    }, (0, $5f7f1e0a0abeb10e$export$617a29b5d3b30216).map((placement)=>$c1808a6f809a6884$var$genPlacementStackStyle(token, placement)).reduce((acc, cur)=>Object.assign(Object.assign({}, acc), cur), {}));
};
var $c1808a6f809a6884$export$2e2bcd8739ae039 = $c1808a6f809a6884$var$genStackStyle;


const $6aedc6f9582ca157$export$341e3ef8ee9ea7d6 = (token)=>{
    const { iconCls: iconCls, componentCls: componentCls, boxShadow: // .ant-notification
    boxShadow, fontSizeLG: fontSizeLG, notificationMarginBottom: notificationMarginBottom, borderRadiusLG: borderRadiusLG, colorSuccess: colorSuccess, colorInfo: colorInfo, colorWarning: colorWarning, colorError: colorError, colorTextHeading: colorTextHeading, notificationBg: notificationBg, notificationPadding: notificationPadding, notificationMarginEdge: notificationMarginEdge, notificationProgressBg: notificationProgressBg, notificationProgressHeight: notificationProgressHeight, fontSize: fontSize, lineHeight: lineHeight, width: width, notificationIconSize: notificationIconSize, colorText: colorText } = token;
    const noticeCls = `${componentCls}-notice`;
    return {
        position: 'relative',
        marginBottom: notificationMarginBottom,
        marginInlineStart: 'auto',
        background: notificationBg,
        borderRadius: borderRadiusLG,
        boxShadow: boxShadow,
        [noticeCls]: {
            padding: notificationPadding,
            width: width,
            maxWidth: `calc(100vw - ${(0, $4g3I0.unit)(token.calc(notificationMarginEdge).mul(2).equal())})`,
            overflow: 'hidden',
            lineHeight: lineHeight,
            wordWrap: 'break-word'
        },
        [`${noticeCls}-message`]: {
            marginBottom: token.marginXS,
            color: colorTextHeading,
            fontSize: fontSizeLG,
            lineHeight: token.lineHeightLG
        },
        [`${noticeCls}-description`]: {
            fontSize: fontSize,
            color: colorText
        },
        [`${noticeCls}-closable ${noticeCls}-message`]: {
            paddingInlineEnd: token.paddingLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-message`]: {
            marginBottom: token.marginXS,
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize: fontSizeLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-description`]: {
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize: fontSize
        },
        // Icon & color style in different selector level
        // https://github.com/ant-design/ant-design/issues/16503
        // https://github.com/ant-design/ant-design/issues/15512
        [`${noticeCls}-icon`]: {
            position: 'absolute',
            fontSize: notificationIconSize,
            lineHeight: 1,
            // icon-font
            [`&-success${iconCls}`]: {
                color: colorSuccess
            },
            [`&-info${iconCls}`]: {
                color: colorInfo
            },
            [`&-warning${iconCls}`]: {
                color: colorWarning
            },
            [`&-error${iconCls}`]: {
                color: colorError
            }
        },
        [`${noticeCls}-close`]: Object.assign({
            position: 'absolute',
            top: token.notificationPaddingVertical,
            insetInlineEnd: token.notificationPaddingHorizontal,
            color: token.colorIcon,
            outline: 'none',
            width: token.notificationCloseButtonSize,
            height: token.notificationCloseButtonSize,
            borderRadius: token.borderRadiusSM,
            transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&:hover': {
                color: token.colorIconHover,
                backgroundColor: token.colorBgTextHover
            },
            '&:active': {
                backgroundColor: token.colorBgTextActive
            }
        }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)),
        [`${noticeCls}-progress`]: {
            position: 'absolute',
            display: 'block',
            appearance: 'none',
            WebkitAppearance: 'none',
            inlineSize: `calc(100% - ${(0, $4g3I0.unit)(borderRadiusLG)} * 2)`,
            left: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            right: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            bottom: 0,
            blockSize: notificationProgressHeight,
            border: 0,
            '&, &::-webkit-progress-bar': {
                borderRadius: borderRadiusLG,
                backgroundColor: `rgba(0, 0, 0, 0.04)`
            },
            '&::-moz-progress-bar': {
                background: notificationProgressBg
            },
            '&::-webkit-progress-value': {
                borderRadius: borderRadiusLG,
                background: notificationProgressBg
            }
        },
        [`${noticeCls}-btn`]: {
            float: 'right',
            marginTop: token.marginSM
        }
    };
};
const $6aedc6f9582ca157$var$genNotificationStyle = (token)=>{
    const { componentCls: componentCls, notificationMarginBottom: // .ant-notification
    notificationMarginBottom, notificationMarginEdge: notificationMarginEdge, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut } = token;
    const noticeCls = `${componentCls}-notice`;
    const fadeOut = new (0, $kB90R.default)('antNotificationFadeOut', {
        '0%': {
            maxHeight: token.animationMaxHeight,
            marginBottom: notificationMarginBottom
        },
        '100%': {
            maxHeight: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            opacity: 0
        }
    });
    return [
        // ============================ Holder ============================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                position: 'fixed',
                zIndex: token.zIndexPopup,
                marginRight: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [`${componentCls}-hook-holder`]: {
                    position: 'relative'
                },
                //  animation
                [`${componentCls}-fade-appear-prepare`]: {
                    opacity: '0 !important'
                },
                [`${componentCls}-fade-enter, ${componentCls}-fade-appear`]: {
                    animationDuration: token.motionDurationMid,
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    opacity: 0,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-leave`]: {
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    animationDuration: motionDurationMid,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-fade-leave${componentCls}-fade-leave-active`]: {
                    animationName: fadeOut,
                    animationPlayState: 'running'
                },
                // RTL
                '&-rtl': {
                    direction: 'rtl',
                    [`${noticeCls}-btn`]: {
                        float: 'left'
                    }
                }
            })
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: Object.assign({}, $6aedc6f9582ca157$export$341e3ef8ee9ea7d6(token))
            }
        }
    ];
};
const $6aedc6f9582ca157$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $5f1c4f12ab1f6aec$export$33ada7d8845f7e5) + 50,
        width: 384
    });
const $6aedc6f9582ca157$export$9e25a4f60ca05a04 = (token)=>{
    const notificationPaddingVertical = token.paddingMD;
    const notificationPaddingHorizontal = token.paddingLG;
    const notificationToken = (0, $8APUt.merge)(token, {
        notificationBg: token.colorBgElevated,
        notificationPaddingVertical: notificationPaddingVertical,
        notificationPaddingHorizontal: notificationPaddingHorizontal,
        notificationIconSize: token.calc(token.fontSizeLG).mul(token.lineHeightLG).equal(),
        notificationCloseButtonSize: token.calc(token.controlHeightLG).mul(0.55).equal(),
        notificationMarginBottom: token.margin,
        notificationPadding: `${(0, $4g3I0.unit)(token.paddingMD)} ${(0, $4g3I0.unit)(token.paddingContentHorizontalLG)}`,
        notificationMarginEdge: token.marginLG,
        animationMaxHeight: 150,
        notificationStackLayer: 3,
        notificationProgressHeight: 2,
        notificationProgressBg: `linear-gradient(90deg, ${token.colorPrimaryBorderHover}, ${token.colorPrimary})`
    });
    return notificationToken;
};
var $6aedc6f9582ca157$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Notification', (token)=>{
    const notificationToken = $6aedc6f9582ca157$export$9e25a4f60ca05a04(token);
    return [
        $6aedc6f9582ca157$var$genNotificationStyle(notificationToken),
        (0, $9b7990729b573de5$export$2e2bcd8739ae039)(notificationToken),
        (0, $c1808a6f809a6884$export$2e2bcd8739ae039)(notificationToken)
    ];
}, $6aedc6f9582ca157$export$9ca1be8807fe0675);


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");


var $30c56bd80c93d601$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$1537386bc155ea56)([
    'Notification',
    'PurePanel'
], (token)=>{
    const noticeCls = `${token.componentCls}-notice`;
    const notificationToken = (0, $6aedc6f9582ca157$export$9e25a4f60ca05a04)(token);
    return {
        [`${noticeCls}-pure-panel`]: Object.assign(Object.assign({}, (0, $6aedc6f9582ca157$export$341e3ef8ee9ea7d6)(notificationToken)), {
            width: notificationToken.width,
            maxWidth: `calc(100vw - ${(0, $4g3I0.unit)(token.calc(notificationToken.notificationMarginEdge).mul(2).equal())})`,
            margin: 0
        })
    };
}, (0, $6aedc6f9582ca157$export$9ca1be8807fe0675));


"use client";
var $d2c026d6b09fbfb3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d2c026d6b09fbfb3$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $jMaZ8.createElement((0, $510ddd97f52e903f$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $jMaZ8.createElement((0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $jMaZ8.createElement((0, $93361570ffc8bbe1$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $jMaZ8.createElement((0, $5244cb05538dbe0c$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), null)
};
function $d2c026d6b09fbfb3$export$a6cccece9dc8d76a(prefixCls, closeIcon) {
    if (closeIcon === null || closeIcon === false) return null;
    return closeIcon || /*#__PURE__*/ $jMaZ8.createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    });
}
const $d2c026d6b09fbfb3$var$typeToIcon = {
    success: (0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039),
    info: (0, $510ddd97f52e903f$export$2e2bcd8739ae039),
    error: (0, $93361570ffc8bbe1$export$2e2bcd8739ae039),
    warning: (0, $5244cb05538dbe0c$export$2e2bcd8739ae039)
};
const $d2c026d6b09fbfb3$export$429c001938db3a78 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, type: type, message: message, description: description, btn: btn, role: role = 'alert' } = props;
    let iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-icon`
    }, icon);
    else if (type) iconNode = /*#__PURE__*/ $jMaZ8.createElement($d2c026d6b09fbfb3$var$typeToIcon[type] || null, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-icon`, `${prefixCls}-icon-${type}`)
    });
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-with-icon`]: iconNode
        }),
        role: role
    }, iconNode, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-message`
    }, message), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-description`
    }, description), btn && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-btn`
    }, btn));
};
/** @private Internal Component. Do not use in your production. */ const $d2c026d6b09fbfb3$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, icon: icon, type: type, message: message, description: description, btn: btn, closable: closable = true, closeIcon: closeIcon, className: notificationClassName } = props, restProps = $d2c026d6b09fbfb3$var$__rest(props, [
        "prefixCls",
        "className",
        "icon",
        "type",
        "message",
        "description",
        "btn",
        "closable",
        "closeIcon",
        "className"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    const noticePrefixCls = `${prefixCls}-notice`;
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6aedc6f9582ca157$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${noticePrefixCls}-pure-panel`, hashId, className, cssVarCls, rootCls)
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $30c56bd80c93d601$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $a85ed01a53b666b0$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        prefixCls: prefixCls,
        eventKey: "pure",
        duration: null,
        closable: closable,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            notificationClassName: notificationClassName
        }),
        closeIcon: $d2c026d6b09fbfb3$export$a6cccece9dc8d76a(prefixCls, closeIcon),
        content: /*#__PURE__*/ $jMaZ8.createElement($d2c026d6b09fbfb3$export$429c001938db3a78, {
            prefixCls: noticePrefixCls,
            icon: icon,
            type: type,
            message: message,
            description: description,
            btn: btn
        })
    }))));
};
var $d2c026d6b09fbfb3$export$2e2bcd8739ae039 = $d2c026d6b09fbfb3$var$PurePanel;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");







function $00a07a52b21cc1c7$export$c3e7864cecc29b16(placement, top, bottom) {
    let style;
    switch(placement){
        case 'top':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topLeft':
            style = {
                left: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'bottom':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: 'auto',
                bottom: bottom
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
    }
    return style;
}
function $00a07a52b21cc1c7$export$7b8936ddc277a29a(prefixCls) {
    return {
        motionName: `${prefixCls}-fade`
    };
}
function $00a07a52b21cc1c7$export$2c2219e7042654(closeIcon, notificationConfig, notification) {
    if (typeof closeIcon !== 'undefined') return closeIcon;
    if (typeof (notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.closeIcon) !== 'undefined') return notificationConfig.closeIcon;
    return notification === null || notification === void 0 ? void 0 : notification.closeIcon;
}


"use client";
var $c11dfdfe999a757b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c11dfdfe999a757b$var$DEFAULT_OFFSET = 24;
const $c11dfdfe999a757b$var$DEFAULT_DURATION = 4.5;
const $c11dfdfe999a757b$var$DEFAULT_PLACEMENT = 'topRight';
const $c11dfdfe999a757b$var$Wrapper = (_ref)=>{
    let { children: children, prefixCls: prefixCls } = _ref;
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6aedc6f9582ca157$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $931a4f49d98ab7a5$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, cssVarCls, rootCls)
        }
    }, children));
};
const $c11dfdfe999a757b$var$renderNotifications = (node, _ref2)=>{
    let { prefixCls: prefixCls, key: key } = _ref2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($c11dfdfe999a757b$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
};
const $c11dfdfe999a757b$var$Holder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((props, ref)=>{
    const { top: top, bottom: bottom, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, rtl: rtl, onAllRemoved: onAllRemoved, stack: stack, duration: duration, pauseOnHover: pauseOnHover = true, showProgress: showProgress } = props;
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, notification: notification, direction: direction } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    // =============================== Style ===============================
    const getStyle = (placement)=>(0, $00a07a52b21cc1c7$export$c3e7864cecc29b16)(placement, top !== null && top !== void 0 ? top : $c11dfdfe999a757b$var$DEFAULT_OFFSET, bottom !== null && bottom !== void 0 ? bottom : $c11dfdfe999a757b$var$DEFAULT_OFFSET);
    const getClassName = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $00a07a52b21cc1c7$export$7b8936ddc277a29a)(prefixCls);
    // ============================== Origin ===============================
    const [api, holder] = (0, $7f32c9b14d453529$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: true,
        closeIcon: (0, $d2c026d6b09fbfb3$export$a6cccece9dc8d76a)(prefixCls),
        duration: duration !== null && duration !== void 0 ? duration : $c11dfdfe999a757b$var$DEFAULT_DURATION,
        getContainer: ()=>(staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
        maxCount: maxCount,
        pauseOnHover: pauseOnHover,
        showProgress: showProgress,
        onAllRemoved: onAllRemoved,
        renderNotifications: $c11dfdfe999a757b$var$renderNotifications,
        stack: stack === false ? false : {
            threshold: typeof stack === 'object' ? stack === null || stack === void 0 ? void 0 : stack.threshold : undefined,
            offset: 8,
            gap: token.margin
        }
    });
    // ================================ Ref ================================
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useImperativeHandle(ref, ()=>Object.assign(Object.assign({}, api), {
            prefixCls: prefixCls,
            notification: notification
        }));
    return holder;
});
function $c11dfdfe999a757b$export$c5a84bd16043292a(notificationConfig) {
    const holderRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(null);
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Notification');
    // ================================ API ================================
    const wrapAPI = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>{
        // Wrap with notification content
        // >>> Open
        const open = (config)=>{
            var _a;
            if (!holderRef.current) {
                warning(false, 'usage', 'You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.');
                return;
            }
            const { open: originOpen, prefixCls: prefixCls, notification: notification } = holderRef.current;
            const noticePrefixCls = `${prefixCls}-notice`;
            const { message: message, description: description, icon: icon, type: type, btn: btn, className: className, style: style, role: role = 'alert', closeIcon: closeIcon, closable: closable } = config, restConfig = $c11dfdfe999a757b$var$__rest(config, [
                "message",
                "description",
                "icon",
                "type",
                "btn",
                "className",
                "style",
                "role",
                "closeIcon",
                "closable"
            ]);
            const realCloseIcon = (0, $d2c026d6b09fbfb3$export$a6cccece9dc8d76a)(noticePrefixCls, (0, $00a07a52b21cc1c7$export$2c2219e7042654)(closeIcon, notificationConfig, notification));
            return originOpen(Object.assign(Object.assign({
                // use placement from props instead of hard-coding "topRight"
                placement: (_a = notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.placement) !== null && _a !== void 0 ? _a : $c11dfdfe999a757b$var$DEFAULT_PLACEMENT
            }, restConfig), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $d2c026d6b09fbfb3$export$429c001938db3a78), {
                    prefixCls: noticePrefixCls,
                    icon: icon,
                    type: type,
                    message: message,
                    description: description,
                    btn: btn,
                    role: role
                }),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(type && `${noticePrefixCls}-${type}`, className, notification === null || notification === void 0 ? void 0 : notification.className),
                style: Object.assign(Object.assign({}, notification === null || notification === void 0 ? void 0 : notification.style), style),
                closeIcon: realCloseIcon,
                closable: closable !== null && closable !== void 0 ? closable : !!realCloseIcon
            }));
        };
        // >>> destroy
        const destroy = (key)=>{
            var _a, _b;
            if (key !== undefined) (_a = holderRef.current) === null || _a === void 0 || _a.close(key);
            else (_b = holderRef.current) === null || _b === void 0 || _b.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'success',
            'info',
            'warning',
            'error'
        ];
        keys.forEach((type)=>{
            clone[type] = (config)=>open(Object.assign(Object.assign({}, config), {
                    type: type
                }));
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($c11dfdfe999a757b$var$Holder, Object.assign({
            key: "notification-holder"
        }, notificationConfig, {
            ref: holderRef
        }))
    ];
}
function $c11dfdfe999a757b$export$2e2bcd8739ae039(notificationConfig) {
    return $c11dfdfe999a757b$export$c5a84bd16043292a(notificationConfig);
}


"use client";
let $f3ffaa2f307cbe47$var$notification = null;
let $f3ffaa2f307cbe47$var$act = (callback)=>callback();
let $f3ffaa2f307cbe47$var$taskQueue = [];
let $f3ffaa2f307cbe47$var$defaultGlobalConfig = {};
function $f3ffaa2f307cbe47$var$getGlobalContext() {
    const { getContainer: getContainer, rtl: rtl, maxCount: maxCount, top: top, bottom: bottom, showProgress: showProgress, pauseOnHover: pauseOnHover } = $f3ffaa2f307cbe47$var$defaultGlobalConfig;
    const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
    return {
        getContainer: ()=>mergedContainer,
        rtl: rtl,
        maxCount: maxCount,
        top: top,
        bottom: bottom,
        showProgress: showProgress,
        pauseOnHover: pauseOnHover
    };
}
const $f3ffaa2f307cbe47$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((props, ref)=>{
    const { notificationConfig: notificationConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = $f3ffaa2f307cbe47$var$defaultGlobalConfig.prefixCls || getPrefixCls('notification');
    const appConfig = (0, $jMaZ8.useContext)((0, $eed7b8e1d0775da5$export$264c6064649f9206));
    const [api, holder] = (0, $c11dfdfe999a757b$export$c5a84bd16043292a)(Object.assign(Object.assign(Object.assign({}, notificationConfig), {
        prefixCls: prefixCls
    }), appConfig.notification));
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(sync, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useImperativeHandle(ref, ()=>{
        const instance = Object.assign({}, api);
        Object.keys(instance).forEach((method)=>{
            instance[method] = function() {
                sync();
                return api[method].apply(api, arguments);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $f3ffaa2f307cbe47$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((_, ref)=>{
    const [notificationConfig, setNotificationConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState($f3ffaa2f307cbe47$var$getGlobalContext);
    const sync = ()=>{
        setNotificationConfig($f3ffaa2f307cbe47$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(sync, []);
    const global = (0, $cf928c204584b9b8$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($f3ffaa2f307cbe47$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        notificationConfig: notificationConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $cf928c204584b9b8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
function $f3ffaa2f307cbe47$var$flushNotice() {
    if (!$f3ffaa2f307cbe47$var$notification) {
        const holderFragment = document.createDocumentFragment();
        const newNotification = {
            fragment: holderFragment
        };
        $f3ffaa2f307cbe47$var$notification = newNotification;
        // Delay render to avoid sync issue
        $f3ffaa2f307cbe47$var$act(()=>{
            const reactRender = (0, $49fd731f963d0354$export$1c4a73059151cd3e)();
            reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($f3ffaa2f307cbe47$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    Promise.resolve().then(()=>{
                        if (!newNotification.instance && instance) {
                            newNotification.instance = instance;
                            newNotification.sync = sync;
                            $f3ffaa2f307cbe47$var$flushNotice();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$f3ffaa2f307cbe47$var$notification.instance) return;
    // >>> Execute task
    $f3ffaa2f307cbe47$var$taskQueue.forEach((task)=>{
        switch(task.type){
            case 'open':
                $f3ffaa2f307cbe47$var$act(()=>{
                    $f3ffaa2f307cbe47$var$notification.instance.open(Object.assign(Object.assign({}, $f3ffaa2f307cbe47$var$defaultGlobalConfig), task.config));
                });
                break;
            case 'destroy':
                $f3ffaa2f307cbe47$var$act(()=>{
                    $f3ffaa2f307cbe47$var$notification === null || $f3ffaa2f307cbe47$var$notification === void 0 || $f3ffaa2f307cbe47$var$notification.instance.destroy(task.key);
                });
                break;
        }
    });
    // Clean up
    $f3ffaa2f307cbe47$var$taskQueue = [];
}
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $f3ffaa2f307cbe47$var$setNotificationGlobalConfig(config) {
    $f3ffaa2f307cbe47$var$defaultGlobalConfig = Object.assign(Object.assign({}, $f3ffaa2f307cbe47$var$defaultGlobalConfig), config);
    // Trigger sync for it
    $f3ffaa2f307cbe47$var$act(()=>{
        var _a;
        (_a = $f3ffaa2f307cbe47$var$notification === null || $f3ffaa2f307cbe47$var$notification === void 0 ? void 0 : $f3ffaa2f307cbe47$var$notification.sync) === null || _a === void 0 || _a.call($f3ffaa2f307cbe47$var$notification);
    });
}
function $f3ffaa2f307cbe47$var$open(config) {
    const global = (0, $cf928c204584b9b8$export$f9cd1e43211d8a4a)();
    if (!global.holderRender) (0, $cf928c204584b9b8$export$7c4f6da0f9434a77)('notification');
    $f3ffaa2f307cbe47$var$taskQueue.push({
        type: 'open',
        config: config
    });
    $f3ffaa2f307cbe47$var$flushNotice();
}
const $f3ffaa2f307cbe47$var$destroy = (key)=>{
    $f3ffaa2f307cbe47$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $f3ffaa2f307cbe47$var$flushNotice();
};
const $f3ffaa2f307cbe47$var$methods = [
    'success',
    'info',
    'warning',
    'error'
];
const $f3ffaa2f307cbe47$var$baseStaticMethods = {
    open: $f3ffaa2f307cbe47$var$open,
    destroy: $f3ffaa2f307cbe47$var$destroy,
    config: $f3ffaa2f307cbe47$var$setNotificationGlobalConfig,
    useNotification: $c11dfdfe999a757b$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $d2c026d6b09fbfb3$export$2e2bcd8739ae039)
};
const $f3ffaa2f307cbe47$var$staticMethods = $f3ffaa2f307cbe47$var$baseStaticMethods;
$f3ffaa2f307cbe47$var$methods.forEach((type)=>{
    $f3ffaa2f307cbe47$var$staticMethods[type] = (config)=>$f3ffaa2f307cbe47$var$open(Object.assign(Object.assign({}, config), {
            type: type
        }));
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $f3ffaa2f307cbe47$var$noop = ()=>{};
let $f3ffaa2f307cbe47$export$71ceb3dabb09f455 = $f3ffaa2f307cbe47$var$noop;
$f3ffaa2f307cbe47$export$71ceb3dabb09f455 = (wrapper)=>{
    $f3ffaa2f307cbe47$var$act = wrapper;
};
let $f3ffaa2f307cbe47$export$43de32c50edff050 = $f3ffaa2f307cbe47$var$noop;
$f3ffaa2f307cbe47$export$43de32c50edff050 = ()=>{
    $f3ffaa2f307cbe47$var$notification = null;
};
var $f3ffaa2f307cbe47$export$2e2bcd8739ae039 = $f3ffaa2f307cbe47$var$staticMethods;


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");

const $5717c0f052400f03$export$15e5fca53711d340 = (propValue)=>{
    if (!propValue) return null;
    return typeof propValue === 'function' ? propValue() : propValue;
};



// ================== Collapse Motion ==================
const $230791b6f61cb981$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $230791b6f61cb981$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $230791b6f61cb981$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $230791b6f61cb981$var$skipOpacityTransition = (_, event)=>(event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const $230791b6f61cb981$var$initCollapseMotion = function() {
    let rootCls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $3613812083e7312f$export$e4ec87ea71f29b41);
    return {
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $230791b6f61cb981$var$getCollapsedHeight,
        onEnterStart: $230791b6f61cb981$var$getCollapsedHeight,
        onAppearActive: $230791b6f61cb981$var$getRealHeight,
        onEnterActive: $230791b6f61cb981$var$getRealHeight,
        onLeaveStart: $230791b6f61cb981$var$getCurrentHeight,
        onLeaveActive: $230791b6f61cb981$var$getCollapsedHeight,
        onAppearEnd: $230791b6f61cb981$var$skipOpacityTransition,
        onEnterEnd: $230791b6f61cb981$var$skipOpacityTransition,
        onLeaveEnd: $230791b6f61cb981$var$skipOpacityTransition,
        motionDeadline: 500
    };
};
const $230791b6f61cb981$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $230791b6f61cb981$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $230791b6f61cb981$export$2e2bcd8739ae039 = $230791b6f61cb981$var$initCollapseMotion;



var $jMaZ8 = parcelRequire("jMaZ8");
function $e4daa5bbe3988c87$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment;
}
const $e4daa5bbe3988c87$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function $e4daa5bbe3988c87$export$e530037191fcd5d7(element, props) {
    return $e4daa5bbe3988c87$export$2dfe578f95754f6a(element, element, props);
}




var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
function $eeb8cc21e635cb51$export$2e2bcd8739ae039(props) {
    var children = props.children, prefixCls = props.prefixCls, id = props.id, innerStyle = props.overlayInnerStyle, bodyClassName = props.bodyClassName, className = props.className, style = props.style;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content"), className),
        style: style
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-inner"), bodyClassName),
        id: id,
        role: "tooltip",
        style: innerStyle
    }, typeof children === 'function' ? children() : children));
}



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

var $h9ujZ = parcelRequire("h9ujZ");

var $2bFmQ = parcelRequire("2bFmQ");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");
var $28626fee6b8f3070$var$OrderContext = /*#__PURE__*/ $jMaZ8.createContext(null);
var $28626fee6b8f3070$export$2e2bcd8739ae039 = $28626fee6b8f3070$var$OrderContext;



var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jLTp6 = parcelRequire("jLTp6");

var $h9ujZ = parcelRequire("h9ujZ");

var $b527bd02dae2d12c$var$EMPTY_LIST = [];
function $b527bd02dae2d12c$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $jMaZ8.useState(function() {
        if (!(0, $h9ujZ.default)()) return null;
        var defaultEle = document.createElement('div');
        if (debug) defaultEle.setAttribute('data-debug', debug);
        return defaultEle;
    }), _React$useState2 = (0, $3fkx6.default)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $jMaZ8.useRef(false);
    var queueCreate = $jMaZ8.useContext((0, $28626fee6b8f3070$export$2e2bcd8739ae039));
    var _React$useState3 = $jMaZ8.useState($b527bd02dae2d12c$var$EMPTY_LIST), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $fvBso.default)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $jLTp6.default)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $jLTp6.default)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($b527bd02dae2d12c$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $lfFyj = parcelRequire("lfFyj");

var $jLTp6 = parcelRequire("jLTp6");
/* eslint-disable no-param-reassign */ 
var $lfFyj = parcelRequire("lfFyj");
var $fb3b2752ae6984c6$var$cached;
function $fb3b2752ae6984c6$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
            (0, $lfFyj.updateCSS)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $lfFyj.removeCSS)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $fb3b2752ae6984c6$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $fb3b2752ae6984c6$var$cached === undefined) $fb3b2752ae6984c6$var$cached = $fb3b2752ae6984c6$var$measureScrollbarSize();
    return $fb3b2752ae6984c6$var$cached.width;
}
function $fb3b2752ae6984c6$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $fb3b2752ae6984c6$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $ed18f5b49d8ff423$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $aabd126c3af3e3f5$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $aabd126c3af3e3f5$var$uuid = 0;
function $aabd126c3af3e3f5$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $jMaZ8.useState(function() {
        $aabd126c3af3e3f5$var$uuid += 1;
        return "".concat($aabd126c3af3e3f5$var$UNIQUE_ID, "_").concat($aabd126c3af3e3f5$var$uuid);
    }), _React$useState2 = (0, $3fkx6.default)(_React$useState, 1), id = _React$useState2[0];
    (0, $jLTp6.default)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $fb3b2752ae6984c6$export$4f3ef2310365b56a)(document.body).width;
            var isOverflow = (0, $ed18f5b49d8ff423$export$31b5c8f1131a3a52)();
            (0, $lfFyj.updateCSS)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
        } else (0, $lfFyj.removeCSS)(id);
        return function() {
            (0, $lfFyj.removeCSS)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $5202fd08a407762f$export$18c8ad048e32c7d5 = false;
function $5202fd08a407762f$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $5202fd08a407762f$export$18c8ad048e32c7d5 = nextInline;
    return $5202fd08a407762f$export$18c8ad048e32c7d5;
}


var $09aae5b42de0c1a8$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $h9ujZ.default)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
var $09aae5b42de0c1a8$var$Portal = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $jMaZ8.useState(open), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    (0, $2bFmQ.default)((0, $h9ujZ.default)() || !open, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR.");
    // ====================== Should Render ======================
    $jMaZ8.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $jMaZ8.useState(function() {
        return $09aae5b42de0c1a8$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $jMaZ8.useEffect(function() {
        var customizeContainer = $09aae5b42de0c1a8$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $b527bd02dae2d12c$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $3fkx6.default)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $aabd126c3af3e3f5$export$2e2bcd8739ae039)(autoLock && open && (0, $h9ujZ.default)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $1cfGC.supportRef)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $1cfGC.useComposeRef)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $h9ujZ.default)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $5202fd08a407762f$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $jMaZ8.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $28626fee6b8f3070$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $6UWRi.createPortal)(reffedChildren, mergedContainer));
});
$09aae5b42de0c1a8$var$Portal.displayName = 'Portal';
var $09aae5b42de0c1a8$export$2e2bcd8739ae039 = $09aae5b42de0c1a8$var$Portal;



var $11a2eab5458a1b52$export$2e2bcd8739ae039 = (0, $09aae5b42de0c1a8$export$2e2bcd8739ae039);



var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");

var $cYkhj = parcelRequire("cYkhj");


var $ktS49 = parcelRequire("ktS49");

var $3fkx6 = parcelRequire("3fkx6");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
function $715c60aee4cde1e6$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $8u3qN.default)({}, $jMaZ8);
    return fullClone.useId;
}
var $715c60aee4cde1e6$var$uuid = 0;
function $715c60aee4cde1e6$export$2f0435a662835942() {
    $715c60aee4cde1e6$var$uuid = 0;
}
var $715c60aee4cde1e6$var$useOriginId = $715c60aee4cde1e6$var$getUseId();
var $715c60aee4cde1e6$export$2e2bcd8739ae039 = $715c60aee4cde1e6$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $715c60aee4cde1e6$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return 'test-id';
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $jMaZ8.useState('ssr-id'), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $jMaZ8.useEffect(function() {
        var nextId = $715c60aee4cde1e6$var$uuid;
        $715c60aee4cde1e6$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    return 'test-id';
};



var $jLTp6 = parcelRequire("jLTp6");
var $e5dc72d643143115$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");

var $bAXx0 = parcelRequire("bAXx0");

var $jLTp6 = parcelRequire("jLTp6");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
function $4fbae194110ef4d6$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $jMaZ8.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}



var $hH60s = parcelRequire("hH60s");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");

var $jMaZ8 = parcelRequire("jMaZ8");
function $652547af72a56486$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), (0, $hH60s.default)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $jMaZ8 = parcelRequire("jMaZ8");
var $c5105fa10a27c955$var$PopupContent = /*#__PURE__*/ $jMaZ8.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
$c5105fa10a27c955$var$PopupContent.displayName = 'PopupContent';
var $c5105fa10a27c955$export$2e2bcd8739ae039 = $c5105fa10a27c955$var$PopupContent;


var $3ffb89f4cbaae832$var$Popup = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, onPointerDownCapture = props.onPointerDownCapture, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $jMaZ8.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $jLTp6.default)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = 'auto';
    var offsetStyle = {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === 'r';
        var alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $jMaZ8.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $652547af72a56486$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), (0, $hH60s.default)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $jMaZ8.createElement("div", {
                ref: (0, $1cfGC.composeRef)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({
                    '--arrow-x': "".concat(arrowPos.x || 0, "px"),
                    '--arrow-y': "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: 'border-box',
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ $jMaZ8.createElement((0, $4fbae194110ef4d6$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $jMaZ8.createElement((0, $c5105fa10a27c955$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
$3ffb89f4cbaae832$var$Popup.displayName = 'Popup';
var $3ffb89f4cbaae832$export$2e2bcd8739ae039 = $3ffb89f4cbaae832$var$Popup;



var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");
var $1755469b8eb70eba$var$TriggerWrapper = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $1cfGC.supportRef)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $jMaZ8.useCallback(function(node) {
        (0, $1cfGC.fillRef)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $1cfGC.useComposeRef)(setRef, (0, $1cfGC.getNodeRef)(children));
    return canUseRef ? /*#__PURE__*/ $jMaZ8.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
$1755469b8eb70eba$var$TriggerWrapper.displayName = 'TriggerWrapper';
var $1755469b8eb70eba$export$2e2bcd8739ae039 = $1755469b8eb70eba$var$TriggerWrapper;



var $jMaZ8 = parcelRequire("jMaZ8");
var $b8b9c1643be12c67$var$TriggerContext = /*#__PURE__*/ $jMaZ8.createContext(null);
var $b8b9c1643be12c67$export$2e2bcd8739ae039 = $b8b9c1643be12c67$var$TriggerContext;



var $jMaZ8 = parcelRequire("jMaZ8");
function $b55ffd904aaabfbf$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $b55ffd904aaabfbf$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $jMaZ8.useMemo(function() {
        var mergedShowAction = $b55ffd904aaabfbf$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $b55ffd904aaabfbf$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has('hover')) {
                showActionSet.delete('hover');
                showActionSet.add('click');
            }
            if (hideActionSet.has('hover')) {
                hideActionSet.delete('hover');
                hideActionSet.add('click');
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}



var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $cYkhj = parcelRequire("cYkhj");
var $f0dd1e7e6ce84933$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};



var $ktS49 = parcelRequire("ktS49");

var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");
function $cd3b1729363f2945$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $cd3b1729363f2945$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($cd3b1729363f2945$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}
function $cd3b1729363f2945$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $cd3b1729363f2945$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $cd3b1729363f2945$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        var _getWin$getComputedSt = $cd3b1729363f2945$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $cd3b1729363f2945$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $cd3b1729363f2945$var$getPxValue(val) {
    return $cd3b1729363f2945$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $cd3b1729363f2945$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $8u3qN.default)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $cd3b1729363f2945$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $cd3b1729363f2945$var$getPxValue(borderTopWidth);
        var borderBottomNum = $cd3b1729363f2945$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $cd3b1729363f2945$var$getPxValue(borderLeftWidth);
        var borderRightNum = $cd3b1729363f2945$var$getPxValue(borderRightWidth);
        var scaleX = $cd3b1729363f2945$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $cd3b1729363f2945$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === 'clip') {
            var clipNum = $cd3b1729363f2945$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $bb50ef35edc225c0$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $bb50ef35edc225c0$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $3fkx6.default)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $bb50ef35edc225c0$var$getUnitOffset(rect.width, offsetX),
        $bb50ef35edc225c0$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $bb50ef35edc225c0$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        points[0],
        points[1]
    ];
}
function $bb50ef35edc225c0$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $bb50ef35edc225c0$var$reversePoints(points, index) {
    var reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || 'c';
        return point;
    }).join('');
}
function $bb50ef35edc225c0$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $jMaZ8.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $jMaZ8.useRef(0);
    var scrollerList = $jMaZ8.useMemo(function() {
        if (!popupEle) return [];
        return (0, $cd3b1729363f2945$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $jMaZ8.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $ktS49.default)(function() {
        if (popupEle && target && open) {
            var _popupElement$parentE, _popupRect$x, _popupRect$y, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $cd3b1729363f2945$export$9c0584a7cc24d9e)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $8u3qN.default)((0, $8u3qN.default)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement('div');
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var _rect$x, _rect$y;
                var rect = target.getBoundingClientRect();
                rect.x = (_rect$x = rect.x) !== null && _rect$x !== void 0 ? _rect$x : rect.left;
                rect.y = (_rect$y = rect.y) !== null && _rect$y !== void 0 ? _rect$y : rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            popupRect.x = (_popupRect$x = popupRect.x) !== null && _popupRect$x !== void 0 ? _popupRect$x : popupRect.left;
            popupRect.y = (_popupRect$y = popupRect.y) !== null && _popupRect$y !== void 0 ? _popupRect$y : popupRect.top;
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = 'visible';
            var VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $cd3b1729363f2945$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $cd3b1729363f2945$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $cd3b1729363f2945$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $cd3b1729363f2945$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $cYkhj.isDOM)(target) && !(0, $f0dd1e7e6ce84933$export$2e2bcd8739ae039)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $bb50ef35edc225c0$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $3fkx6.default)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $bb50ef35edc225c0$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $3fkx6.default)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $3fkx6.default)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $bb50ef35edc225c0$var$splitPoints(targetPoint);
            var popupPoints = $bb50ef35edc225c0$var$splitPoints(popupPoint);
            var targetAlignPoint = $bb50ef35edc225c0$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $bb50ef35edc225c0$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $8u3qN.default)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $bb50ef35edc225c0$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            var popupAlignPointTL = $bb50ef35edc225c0$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            var targetAlignPointBR = $bb50ef35edc225c0$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            var popupAlignPointBR = $bb50ef35edc225c0$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $bb50ef35edc225c0$var$reversePoints(popupPoints, 0),
                        $bb50ef35edc225c0$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $bb50ef35edc225c0$var$reversePoints(popupPoints, 0),
                        $bb50ef35edc225c0$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $bb50ef35edc225c0$var$reversePoints(popupPoints, 1),
                        $bb50ef35edc225c0$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $bb50ef35edc225c0$var$reversePoints(popupPoints, 1),
                        $bb50ef35edc225c0$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (_scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (_scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            var nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $8u3qN.default)((0, $8u3qN.default)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $jLTp6.default)(resetReady, [
        placement
    ]);
    (0, $jLTp6.default)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}



var $fvBso = parcelRequire("fvBso");

var $jLTp6 = parcelRequire("jLTp6");

function $188964cbbf4e2553$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $jLTp6.default)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $cd3b1729363f2945$export$ba21ed9400ca485b)(targetElement);
            var popupScrollList = (0, $cd3b1729363f2945$export$ba21ed9400ca485b)(popupElement);
            var win = (0, $cd3b1729363f2945$export$9c0584a7cc24d9e)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $fvBso.default)(targetScrollList), (0, $fvBso.default)(popupScrollList)));
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}




var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

function $02c54a8a0265caca$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $jMaZ8.useRef(open);
    openRef.current = open;
    var popupPointerDownRef = $jMaZ8.useRef(false);
    // Click to hide is special action since click popup element should not hide
    $jMaZ8.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var onPointerDown = function onPointerDown() {
                popupPointerDownRef.current = false;
            };
            var onTriggerClose = function onTriggerClose(e) {
                var _e$composedPath;
                if (openRef.current && !inPopupOrChild(((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 || (_e$composedPath = _e$composedPath.call(e)) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath[0]) || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            var win = (0, $cd3b1729363f2945$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener('pointerdown', onPointerDown, true);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            var targetShadowRoot = (0, $184337e1baf06507$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode;
            var targetRoot = targetEle === null || targetEle === void 0 || (_targetEle$getRootNod = targetEle.getRootNode) === null || _targetEle$getRootNod === void 0 ? void 0 : _targetEle$getRootNod.call(targetEle);
            var popupRoot = (_popupEle$getRootNode = popupEle.getRootNode) === null || _popupEle$getRootNode === void 0 ? void 0 : _popupEle$getRootNode.call(popupEle);
            (0, $2bFmQ.warning)(targetRoot === popupRoot, "trigger element and popup element should in same shadow root.");
            return function() {
                win.removeEventListener('pointerdown', onPointerDown, true);
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}



var $3e6696c575106f0d$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $3e6696c575106f0d$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $11a2eab5458a1b52$export$2e2bcd8739ae039);
    var Trigger = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-trigger-popup' : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? 'hover' : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $4b02Q.default)(props, $3e6696c575106f0d$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $jLTp6.default)(function() {
            setMobile((0, $e5dc72d643143115$export$2e2bcd8739ae039)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $jMaZ8.useRef({});
        var parentContext = $jMaZ8.useContext((0, $b8b9c1643be12c67$export$2e2bcd8739ae039));
        var context = $jMaZ8.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $715c60aee4cde1e6$export$2e2bcd8739ae039)();
        var _React$useState3 = $jMaZ8.useState(null), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        // Used for forwardRef popup. Not use internal
        var externalPopupRef = $jMaZ8.useRef(null);
        var setPopupRef = (0, $ktS49.default)(function(node) {
            externalPopupRef.current = node;
            if ((0, $cYkhj.isDOM)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $jMaZ8.useState(null), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $jMaZ8.useRef(null);
        var setTargetRef = (0, $ktS49.default)(function(node) {
            if ((0, $cYkhj.isDOM)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $jMaZ8.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $ktS49.default)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $184337e1baf06507$export$70e8259662bb498b)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $184337e1baf06507$export$70e8259662bb498b)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $cd3b1729363f2945$export$7b8936ddc277a29a)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $cd3b1729363f2945$export$7b8936ddc277a29a)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $jMaZ8.useState(defaultPopupVisible || false), _React$useState8 = (0, $3fkx6.default)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $ktS49.default)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $jLTp6.default)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $jMaZ8.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $jMaZ8.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $ktS49.default)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $jMaZ8.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $jMaZ8.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $jMaZ8.useState(false), _React$useState10 = (0, $3fkx6.default)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $jLTp6.default)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $jMaZ8.useState(null), _React$useState12 = (0, $3fkx6.default)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $jMaZ8.useState(null), _React$useState14 = (0, $3fkx6.default)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $bb50ef35edc225c0$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $3fkx6.default)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $b55ffd904aaabfbf$export$2e2bcd8739ae039)(mobile, action, showAction, hideAction), _useAction2 = (0, $3fkx6.default)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has('click');
        var clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        var triggerAlign = (0, $ktS49.default)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $188964cbbf4e2553$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $jLTp6.default)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $jLTp6.default)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $jMaZ8.useMemo(function() {
            var baseClassName = (0, $cd3b1729363f2945$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $jMaZ8.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $jMaZ8.useState(0), _React$useState16 = (0, $3fkx6.default)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $jMaZ8.useState(0), _React$useState18 = (0, $3fkx6.default)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $jLTp6.default)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        var onPopupPointerDown = (0, $02c54a8a0265caca$export$2e2bcd8739ae039)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has('hover');
        var hoverToHide = hideActions.has('hover');
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction('onPointerEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter(event) {
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $8u3qN.default)((0, $8u3qN.default)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $jMaZ8.cloneElement(child, (0, $8u3qN.default)((0, $8u3qN.default)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $8u3qN.default)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $jMaZ8.createElement((0, $1755469b8eb70eba$export$2e2bcd8739ae039), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $jMaZ8.createElement((0, $b8b9c1643be12c67$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $jMaZ8.createElement((0, $3ffb89f4cbaae832$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    Trigger.displayName = 'Trigger';
    return Trigger;
}
var $3e6696c575106f0d$export$2e2bcd8739ae039 = $3e6696c575106f0d$export$55e99723d7f71b47((0, $11a2eab5458a1b52$export$2e2bcd8739ae039));



var $jMaZ8 = parcelRequire("jMaZ8");
var $bbbbeebd99d25a6c$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
var $bbbbeebd99d25a6c$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
var $bbbbeebd99d25a6c$var$targetOffset = [
    0,
    0
];
var $bbbbeebd99d25a6c$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $bbbbeebd99d25a6c$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $bbbbeebd99d25a6c$var$targetOffset
    }
};
var $bbbbeebd99d25a6c$export$2e2bcd8739ae039 = $bbbbeebd99d25a6c$export$803cd8101b6c182b;




var $giSak = parcelRequire("giSak");
var $c8cf424a5d4b09b1$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow",
    "classNames",
    "styles"
];
var $c8cf424a5d4b09b1$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, tooltipClassNames = props.classNames, tooltipStyles = props.styles, restProps = (0, $4b02Q.default)(props, $c8cf424a5d4b09b1$var$_excluded);
    var triggerRef = (0, $jMaZ8.useRef)(null);
    (0, $jMaZ8.useImperativeHandle)(ref, function() {
        return triggerRef.current;
    });
    var extraProps = (0, $8u3qN.default)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $jMaZ8.createElement((0, $eeb8cc21e635cb51$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: id,
            bodyClassName: tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body,
            overlayInnerStyle: (0, $8u3qN.default)((0, $8u3qN.default)({}, overlayInnerStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.body)
        }, overlay);
    };
    return /*#__PURE__*/ $jMaZ8.createElement((0, $3e6696c575106f0d$export$2e2bcd8739ae039), (0, $hH60s.default)({
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(overlayClassName, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root),
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $bbbbeebd99d25a6c$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: (0, $8u3qN.default)((0, $8u3qN.default)({}, overlayStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.root),
        mouseEnterDelay: mouseEnterDelay,
        arrow: showArrow
    }, extraProps), children);
};
var $c8cf424a5d4b09b1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jMaZ8.forwardRef)($c8cf424a5d4b09b1$var$Tooltip);


var $82f47bd46ebd5894$export$2e2bcd8739ae039 = (0, $c8cf424a5d4b09b1$export$2e2bcd8739ae039);



var $eGh7a = parcelRequire("eGh7a");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("6wVix");
var $jAqyT = parcelRequire("jAqyT");

var $hvG6u = parcelRequire("hvG6u");
"use client";
const $ee23d3c241510852$export$c24727297075ec6a = /*#__PURE__*/ $jMaZ8.createContext({
    labelAlign: 'right',
    vertical: false,
    itemRef: ()=>{}
});
const $ee23d3c241510852$export$d718247e9f9b0b9e = /*#__PURE__*/ $jMaZ8.createContext(null);
const $ee23d3c241510852$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $hvG6u.default)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $jAqyT.FormProvider), Object.assign({}, providerProps));
};
const $ee23d3c241510852$export$fb6582d3042cc879 = /*#__PURE__*/ $jMaZ8.createContext({
    prefixCls: ''
});
const $ee23d3c241510852$export$bbb5553c6c7a14ed = /*#__PURE__*/ $jMaZ8.createContext({});
$ee23d3c241510852$export$bbb5553c6c7a14ed.displayName = 'FormItemInputContext';
const $ee23d3c241510852$export$80e4c53cb85dcab1 = (_ref)=>{
    let { children: children, status: status, override: override } = _ref;
    const formItemInputContext = $jMaZ8.useContext($ee23d3c241510852$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $jMaZ8.useMemo(()=>{
        const newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement($ee23d3c241510852$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $ee23d3c241510852$export$6f0555dad42725fb = /*#__PURE__*/ $jMaZ8.createContext(undefined);



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $a6yuN = parcelRequire("a6yuN");


var $jMaZ8 = parcelRequire("jMaZ8");

const $ddebbaa055df4f38$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $1497fcac08ca2dc1$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize !== null && customSize !== void 0 ? customSize : size;
        if (customSize instanceof Function) return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $ddebbaa055df4f38$export$2e2bcd8739ae039 = $ddebbaa055df4f38$var$useSize;


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $96eb62cb2a0d1025$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            }
        }
    };
};
var // ============================== Export ==============================
$96eb62cb2a0d1025$export$2e2bcd8739ae039 = $96eb62cb2a0d1025$var$genSpaceCompactStyle;


const $9b653ab488fb14ee$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $9b653ab488fb14ee$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $9b653ab488fb14ee$export$9ca1be8807fe0675 = ()=>({});
var $9b653ab488fb14ee$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Space', (token)=>{
    const spaceToken = (0, $8APUt.merge)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $9b653ab488fb14ee$var$genSpaceStyle(spaceToken),
        $9b653ab488fb14ee$var$genSpaceGapStyle(spaceToken),
        (0, $96eb62cb2a0d1025$export$2e2bcd8739ae039)(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
var $b481086641a221d4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b481086641a221d4$export$8d1c486ac0db0a7d = /*#__PURE__*/ $jMaZ8.createContext(null);
const $b481086641a221d4$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $jMaZ8.useContext($b481086641a221d4$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $jMaZ8.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $b481086641a221d4$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $jMaZ8.createElement($b481086641a221d4$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $b481086641a221d4$var$CompactItem = (props)=>{
    const { children: children } = props, others = $b481086641a221d4$var$__rest(props, [
        "children"
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement($b481086641a221d4$export$8d1c486ac0db0a7d.Provider, {
        value: $jMaZ8.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $b481086641a221d4$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children } = props, restProps = $b481086641a221d4$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctx)=>size !== null && size !== void 0 ? size : ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $9b653ab488fb14ee$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === 'vertical'
    }, className, rootClassName);
    const compactItemContext = $jMaZ8.useContext($b481086641a221d4$export$8d1c486ac0db0a7d);
    const childNodes = (0, $a6yuN.default)(children);
    const nodes = $jMaZ8.useMemo(()=>childNodes.map((child, i)=>{
            const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $jMaZ8.createElement($b481086641a221d4$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        }), [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $b481086641a221d4$export$2e2bcd8739ae039 = $b481086641a221d4$var$Compact;


"use client";
const $1f8ddc944c83959d$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (children === undefined || children === null) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $ee23d3c241510852$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $b481086641a221d4$export$5f56e610a4afb685), null, result);
    return result;
};
var $1f8ddc944c83959d$export$2e2bcd8739ae039 = $1f8ddc944c83959d$var$ContextIsolator;




parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
function $86b31e2653f1279c$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $86b31e2653f1279c$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: 'auto',
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $4g3I0.unit)(borderRadiusXS)} 0`
            },
            transform: 'translateY(50%) rotate(-135deg)',
            boxShadow: boxShadow,
            zIndex: 0,
            background: 'transparent'
        }
    };
};


const $118f758c39257d0a$export$de6e4ffc9ec3c089 = 8;
function $118f758c39257d0a$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $118f758c39257d0a$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $118f758c39257d0a$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $118f758c39257d0a$export$2e2bcd8739ae039(token, colorBg, options) {
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal } = token;
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                Object.assign(Object.assign({
                    position: 'absolute',
                    zIndex: 1,
                    display: 'block'
                }, (0, $86b31e2653f1279c$export$601fa0375eb80eec)(token, colorBg, boxShadowPopoverArrow)), {
                    '&:before': {
                        background: colorBg
                    }
                })
            ]
        }, $118f758c39257d0a$var$isInject(!!arrowPlacement.top, {
            [[
                `&-placement-top > ${componentCls}-arrow`,
                `&-placement-topLeft > ${componentCls}-arrow`,
                `&-placement-topRight > ${componentCls}-arrow`
            ].join(',')]: {
                bottom: arrowDistance,
                transform: 'translateY(100%) rotate(180deg)'
            },
            [`&-placement-top > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
            },
            '&-placement-topLeft': {
                '--arrow-offset-horizontal': arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-topRight': {
                '--arrow-offset-horizontal': `calc(100% - ${(0, $4g3I0.unit)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            }
        })), $118f758c39257d0a$var$isInject(!!arrowPlacement.bottom, {
            [[
                `&-placement-bottom > ${componentCls}-arrow`,
                `&-placement-bottomLeft > ${componentCls}-arrow`,
                `&-placement-bottomRight > ${componentCls}-arrow`
            ].join(',')]: {
                top: arrowDistance,
                transform: `translateY(-100%)`
            },
            [`&-placement-bottom > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: `translateX(-50%) translateY(-100%)`
            },
            '&-placement-bottomLeft': {
                '--arrow-offset-horizontal': arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-bottomRight': {
                '--arrow-offset-horizontal': `calc(100% - ${(0, $4g3I0.unit)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            }
        })), $118f758c39257d0a$var$isInject(!!arrowPlacement.left, {
            [[
                `&-placement-left > ${componentCls}-arrow`,
                `&-placement-leftTop > ${componentCls}-arrow`,
                `&-placement-leftBottom > ${componentCls}-arrow`
            ].join(',')]: {
                right: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(100%) rotate(90deg)'
            },
            [`&-placement-left > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
            },
            [`&-placement-leftTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        })), $118f758c39257d0a$var$isInject(!!arrowPlacement.right, {
            [[
                `&-placement-right > ${componentCls}-arrow`,
                `&-placement-rightTop > ${componentCls}-arrow`,
                `&-placement-rightBottom > ${componentCls}-arrow`
            ].join(',')]: {
                left: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-right > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-rightTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        }))
    };
}


function $7302df8ea39a81cd$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $7302df8ea39a81cd$var$PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const $7302df8ea39a81cd$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const $7302df8ea39a81cd$var$DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function $7302df8ea39a81cd$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    Object.keys($7302df8ea39a81cd$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $7302df8ea39a81cd$var$ArrowCenterPlacementAlignMap[key] || $7302df8ea39a81cd$var$PlacementAlignMap[key];
        const placementInfo = Object.assign(Object.assign({}, template), {
            offset: [
                0,
                0
            ],
            dynamicInset: true
        });
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($7302df8ea39a81cd$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        // Dynamic offset
        const arrowOffset = (0, $118f758c39257d0a$export$bddc192327bb9823)({
            contentRadius: borderRadius,
            limitVerticalRadius: true
        });
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $7302df8ea39a81cd$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}








var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");
const $7d04c31aa62562e0$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $7d04c31aa62562e0$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $7d04c31aa62562e0$export$83e1da9e09ec9112 = function(motionCls, inKeyframes, outKeyframes, duration) {
    let sameLevel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, $7d04c31aa62562e0$var$initMotionCommon(duration)), {
            animationPlayState: 'paused'
        }),
        [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, $7d04c31aa62562e0$var$initMotionCommonLeave(duration)), {
            animationPlayState: 'paused'
        }),
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};


const $90d7c1b8e663dcab$export$3b71758b3ed5255f = new (0, $kB90R.default)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $90d7c1b8e663dcab$export$9fdb0a49c6b4b521 = new (0, $kB90R.default)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $90d7c1b8e663dcab$export$be061d573c42e33a = new (0, $kB90R.default)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $90d7c1b8e663dcab$export$582d93d613303da3 = new (0, $kB90R.default)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $90d7c1b8e663dcab$export$45eddd18c599b827 = new (0, $kB90R.default)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $90d7c1b8e663dcab$export$a85c97750adaa37a = new (0, $kB90R.default)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $90d7c1b8e663dcab$export$bd2378f7814f5f1a = new (0, $kB90R.default)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $90d7c1b8e663dcab$export$e58f88c751c4f04e = new (0, $kB90R.default)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $90d7c1b8e663dcab$export$fee1456954aef331 = new (0, $kB90R.default)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $90d7c1b8e663dcab$export$811ba6d3e2adb730 = new (0, $kB90R.default)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $90d7c1b8e663dcab$export$633a68aa72dec21c = new (0, $kB90R.default)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $90d7c1b8e663dcab$export$1cf46a906e8dede4 = new (0, $kB90R.default)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $90d7c1b8e663dcab$var$zoomMotion = {
    zoom: {
        inKeyframes: $90d7c1b8e663dcab$export$3b71758b3ed5255f,
        outKeyframes: $90d7c1b8e663dcab$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $90d7c1b8e663dcab$export$be061d573c42e33a,
        outKeyframes: $90d7c1b8e663dcab$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $90d7c1b8e663dcab$export$be061d573c42e33a,
        outKeyframes: $90d7c1b8e663dcab$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $90d7c1b8e663dcab$export$bd2378f7814f5f1a,
        outKeyframes: $90d7c1b8e663dcab$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $90d7c1b8e663dcab$export$fee1456954aef331,
        outKeyframes: $90d7c1b8e663dcab$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $90d7c1b8e663dcab$export$45eddd18c599b827,
        outKeyframes: $90d7c1b8e663dcab$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $90d7c1b8e663dcab$export$633a68aa72dec21c,
        outKeyframes: $90d7c1b8e663dcab$export$1cf46a906e8dede4
    }
};
const $90d7c1b8e663dcab$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $90d7c1b8e663dcab$var$zoomMotion[motionName];
    return [
        (0, $7d04c31aa62562e0$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};




const $eb2ddc4f321ac793$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];


function $d62c7bfa6f08fa0e$export$2e2bcd8739ae039(token, genCss) {
    return (0, $eb2ddc4f321ac793$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), genCss(colorKey, {
            lightColor: lightColor,
            lightBorderColor: lightBorderColor,
            darkColor: darkColor,
            textColor: textColor
        }));
    }, {});
}

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $500cc7458b511697$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow } = token;
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '&-hidden': {
                    display: 'none'
                },
                '--antd-arrow-background-color': tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-inner`]: {
                    minWidth: centerAlignMinWidth,
                    minHeight: controlHeight,
                    padding: `${(0, $4g3I0.unit)(token.calc(paddingSM).div(2).equal())} ${(0, $4g3I0.unit)(paddingXS)}`,
                    color: tooltipColor,
                    textAlign: 'start',
                    textDecoration: 'none',
                    wordWrap: 'break-word',
                    backgroundColor: tooltipBg,
                    borderRadius: tooltipBorderRadius,
                    boxShadow: boxShadowSecondary,
                    boxSizing: 'border-box'
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $118f758c39257d0a$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                }
            }), (0, $d62c7bfa6f08fa0e$export$2e2bcd8739ae039)(token, (colorKey, _ref)=>{
                let { darkColor: darkColor } = _ref;
                return {
                    [`&${componentCls}-${colorKey}`]: {
                        [`${componentCls}-inner`]: {
                            backgroundColor: darkColor
                        },
                        [`${componentCls}-arrow`]: {
                            '--antd-arrow-background-color': darkColor
                        }
                    }
                };
            })), {
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            })
        },
        // Arrow Style
        (0, $118f758c39257d0a$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        }
    ];
};
const $500cc7458b511697$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 70
    }, (0, $118f758c39257d0a$export$bddc192327bb9823)({
        contentRadius: token.borderRadius,
        limitVerticalRadius: true
    })), (0, $86b31e2653f1279c$export$87e38ee403661ccc)((0, $8APUt.merge)(token, {
        borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
    })));
var $500cc7458b511697$export$2e2bcd8739ae039 = function(prefixCls) {
    let injectStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const useStyle = (0, $263539dacc5f409d$export$51ec95de45185b42)('Tooltip', (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight } = token;
        const TooltipToken = (0, $8APUt.merge)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $500cc7458b511697$var$genTooltipStyle(TooltipToken),
            (0, $90d7c1b8e663dcab$export$f5d123412490d9dc)(token, 'zoom-big-fast')
        ];
    }, $500cc7458b511697$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls);
};



var $giSak = parcelRequire("giSak");

var $fvBso = parcelRequire("fvBso");

const $f2300e2eec81713c$var$inverseColors = (0, $eb2ddc4f321ac793$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $f2300e2eec81713c$export$bb684163c94c55ae = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function $f2300e2eec81713c$export$ee62ebd6a58c4884(color) {
    let includeInverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (includeInverse) return [].concat((0, $fvBso.default)($f2300e2eec81713c$var$inverseColors), (0, $fvBso.default)((0, $eb2ddc4f321ac793$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $eb2ddc4f321ac793$export$6d4fe3a00a1811ad).includes(color);
}
function $f2300e2eec81713c$export$88a0ba1f7d1ea40e(color) {
    return $f2300e2eec81713c$export$bb684163c94c55ae.includes(color);
}


function $0fe6c2867fde7125$export$6e865ea70d7724f(prefixCls, color) {
    const isInternalColor = (0, $f2300e2eec81713c$export$ee62ebd6a58c4884)(color);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        // @ts-ignore
        arrowStyle['--antd-arrow-background-color'] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}


"use client";
/** @private Internal Component. Do not use in your production. */ const $ce868bfb1afe8110$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = 'top', title: title, color: color, overlayInnerStyle: overlayInnerStyle } = props;
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $500cc7458b511697$export$2e2bcd8739ae039)(prefixCls);
    // Color
    const colorInfo = (0, $0fe6c2867fde7125$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls,
        style: arrowContentStyle
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $eeb8cc21e635cb51$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls,
        overlayInnerStyle: formattedOverlayInnerStyle
    }), title)));
};
var $ce868bfb1afe8110$export$2e2bcd8739ae039 = $ce868bfb1afe8110$var$PurePanel;




"use client";
var $b4ff9094bcb218d9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b4ff9094bcb218d9$var$InternalTooltip = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    var _a, _b, _c, _d, _e, _f;
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, overlayInnerStyle: overlayInnerStyle, children: children, afterOpenChange: afterOpenChange, afterVisibleChange: afterVisibleChange, destroyTooltipOnHide: destroyTooltipOnHide, arrow: arrow = true, title: title, overlay: overlay, builtinPlacements: builtinPlacements, arrowPointAtCenter: arrowPointAtCenter = false, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = 'top', mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, overlayStyle: overlayStyle, rootClassName: rootClassName, overlayClassName: overlayClassName, styles: styles, classNames: tooltipClassNames } = props, restProps = $b4ff9094bcb218d9$var$__rest(props, [
        "prefixCls",
        "openClassName",
        "getTooltipContainer",
        "color",
        "overlayInnerStyle",
        "children",
        "afterOpenChange",
        "afterVisibleChange",
        "destroyTooltipOnHide",
        "arrow",
        "title",
        "overlay",
        "builtinPlacements",
        "arrowPointAtCenter",
        "autoAdjustOverflow",
        "motion",
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "rootClassName",
        "overlayClassName",
        "styles",
        "classNames"
    ]);
    const mergedShowArrow = !!arrow;
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, tooltip: tooltip } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    // ============================== Ref ===============================
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Tooltip');
    const tooltipRef = $jMaZ8.useRef(null);
    const forceAlign = ()=>{
        var _a;
        (_a = tooltipRef.current) === null || _a === void 0 || _a.forceAlign();
    };
    $jMaZ8.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            forceAlign: forceAlign,
            forcePopupAlign: ()=>{
                warning.deprecated(false, 'forcePopupAlign', 'forceAlign');
                forceAlign();
            },
            nativeElement: (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
        };
    });
    [
        [
            'visible',
            'open'
        ],
        [
            'defaultVisible',
            'defaultOpen'
        ],
        [
            'onVisibleChange',
            'onOpenChange'
        ],
        [
            'afterVisibleChange',
            'afterOpenChange'
        ],
        [
            'arrowPointAtCenter',
            'arrow={{ pointAtCenter: true }}'
        ],
        [
            'overlayStyle',
            'styles={{ root: {} }}'
        ],
        [
            'overlayInnerStyle',
            'styles={{ body: {} }}'
        ],
        [
            'overlayClassName',
            'classNames={{ root: {} }}'
        ]
    ].forEach((_ref)=>{
        let [deprecatedName, newName] = _ref;
        warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
    warning(!destroyTooltipOnHide || typeof destroyTooltipOnHide === 'boolean', 'usage', '`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly.');
    warning(!arrow || typeof arrow === 'boolean' || !('arrowPointAtCenter' in arrow), 'deprecated', '`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead.');
    // ============================== Open ==============================
    const [open, setOpen] = (0, $eGh7a.default)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    });
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onOpenChange = (vis)=>{
        var _a, _b;
        setOpen(noTitle ? false : vis);
        if (!noTitle) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    const tooltipPlacements = $jMaZ8.useMemo(()=>{
        var _a, _b;
        let mergedArrowPointAtCenter = arrowPointAtCenter;
        if (typeof arrow === 'object') mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
        return builtinPlacements || (0, $7302df8ea39a81cd$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        arrowPointAtCenter,
        arrow,
        builtinPlacements,
        token
    ]);
    const memoOverlay = $jMaZ8.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $jMaZ8.createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
        space: true
    }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props['data-popover-inject'];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && !('visible' in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $jMaZ8.isValidElement(children) && !(0, $e4daa5bbe3988c87$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $jMaZ8.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $500cc7458b511697$export$2e2bcd8739ae039)(prefixCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $0fe6c2867fde7125$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const rootClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, hashId, cssVarCls, tooltip === null || tooltip === void 0 ? void 0 : tooltip.className, (_c = tooltip === null || tooltip === void 0 ? void 0 : tooltip.classNames) === null || _c === void 0 ? void 0 : _c.root, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root);
    const bodyClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_d = tooltip === null || tooltip === void 0 ? void 0 : tooltip.classNames) === null || _d === void 0 ? void 0 : _d.body, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $5f1c4f12ab1f6aec$export$3e7906d4075187a4)('Tooltip', restProps.zIndex);
    const content = /*#__PURE__*/ $jMaZ8.createElement((0, $82f47bd46ebd5894$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            body: bodyClassNames
        },
        styles: {
            root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, arrowContentStyle), (_e = tooltip === null || tooltip === void 0 ? void 0 : tooltip.styles) === null || _e === void 0 ? void 0 : _e.root), tooltip === null || tooltip === void 0 ? void 0 : tooltip.style), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
            body: Object.assign(Object.assign(Object.assign(Object.assign({}, (_f = tooltip === null || tooltip === void 0 ? void 0 : tooltip.styles) === null || _f === void 0 ? void 0 : _f.body), overlayInnerStyle), styles === null || styles === void 0 ? void 0 : styles.body), colorInfo.overlayStyle)
        },
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        arrowContent: /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', props.transitionName),
            motionDeadline: 1000
        },
        destroyTooltipOnHide: !!destroyTooltipOnHide
    }), tempOpen ? (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $215be6e5138b7346$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content));
});
const $b4ff9094bcb218d9$var$Tooltip = $b4ff9094bcb218d9$var$InternalTooltip;
$b4ff9094bcb218d9$var$Tooltip.displayName = 'Tooltip';
$b4ff9094bcb218d9$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $ce868bfb1afe8110$export$2e2bcd8739ae039);
var $b4ff9094bcb218d9$export$2e2bcd8739ae039 = $b4ff9094bcb218d9$var$Tooltip;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");







parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $184fe49679d81c61$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, boxShadowSecondary: boxShadowSecondary, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                position: 'absolute',
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: 'normal',
                whiteSpace: 'normal',
                textAlign: 'start',
                cursor: 'auto',
                userSelect: 'text',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '--antd-arrow-background-color': colorBgElevated,
                width: 'max-content',
                maxWidth: '100vw',
                '&-rtl': {
                    direction: 'rtl'
                },
                '&-hidden': {
                    display: 'none'
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                [`${componentCls}-inner`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: 'padding-box',
                    borderRadius: borderRadiusLG,
                    boxShadow: boxShadowSecondary,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-inner-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            })
        },
        // Arrow Style
        (0, $118f758c39257d0a$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow,
                display: 'inline-block',
                [`${componentCls}-content`]: {
                    display: 'inline-block'
                }
            }
        }
    ];
};
const $184fe49679d81c61$var$genColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: (0, $eb2ddc4f321ac793$export$6d4fe3a00a1811ad).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    '--antd-arrow-background-color': lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: 'transparent'
                    }
                }
            };
        })
    };
};
const $184fe49679d81c61$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return Object.assign(Object.assign(Object.assign({
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30
    }, (0, $86b31e2653f1279c$export$87e38ee403661ccc)(token)), (0, $118f758c39257d0a$export$bddc192327bb9823)({
        contentRadius: borderRadiusLG,
        limitVerticalRadius: true
    })), {
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    });
};
var $184fe49679d81c61$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Popover', (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $8APUt.merge)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $184fe49679d81c61$var$genBaseStyle(popoverToken),
        $184fe49679d81c61$var$genColorStyle(popoverToken),
        (0, $90d7c1b8e663dcab$export$f5d123412490d9dc)(popoverToken, 'zoom-big')
    ];
}, $184fe49679d81c61$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            'width',
            'titleMinWidth'
        ],
        [
            'minWidth',
            'titleMinWidth'
        ]
    ]
});


"use client";
var $b0d029c807639a81$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b0d029c807639a81$export$c6fdb837b070b4ff = (_ref)=>{
    let { title: title, content: content, prefixCls: prefixCls } = _ref;
    if (!title && !content) return null;
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, title && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-title`
    }, title), content && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-inner-content`
    }, content));
};
const $b0d029c807639a81$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = 'top', title: title, content: content, children: children } = props;
    const titleNode = (0, $5717c0f052400f03$export$15e5fca53711d340)(title);
    const contentNode = (0, $5717c0f052400f03$export$15e5fca53711d340)(content);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls,
        style: style
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $eeb8cc21e635cb51$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls
    }), children || /*#__PURE__*/ $jMaZ8.createElement($b0d029c807639a81$export$c6fdb837b070b4ff, {
        prefixCls: prefixCls,
        title: titleNode,
        content: contentNode
    })));
};
const $b0d029c807639a81$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className } = props, restProps = $b0d029c807639a81$var$__rest(props, [
        "prefixCls",
        "className"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $184fe49679d81c61$export$2e2bcd8739ae039)(prefixCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement($b0d029c807639a81$export$c40925af82c95d5b, Object.assign({}, restProps, {
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, cssVarCls)
    })));
};
var $b0d029c807639a81$export$2e2bcd8739ae039 = $b0d029c807639a81$var$PurePanel;



"use client";
var $c5aa6d63acebb2d0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c5aa6d63acebb2d0$var$InternalPopover = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    var _a, _b, _c, _d, _e, _f;
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = 'top', trigger: trigger = 'hover', children: children, mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, onOpenChange: onOpenChange, overlayStyle: overlayStyle = {}, styles: styles, classNames: popoverClassNames } = props, otherProps = $c5aa6d63acebb2d0$var$__rest(props, [
        "prefixCls",
        "title",
        "content",
        "overlayClassName",
        "placement",
        "trigger",
        "children",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "onOpenChange",
        "overlayStyle",
        "styles",
        "classNames"
    ]);
    const { popover: popover, getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $184fe49679d81c61$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const rootClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(overlayClassName, hashId, cssVarCls, (_a = popover === null || popover === void 0 ? void 0 : popover.classNames) === null || _a === void 0 ? void 0 : _a.root, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.root);
    const bodyClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_b = popover === null || popover === void 0 ? void 0 : popover.classNames) === null || _b === void 0 ? void 0 : _b.body, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.body);
    const [open, setOpen] = (0, $eGh7a.default)(false, {
        value: (_c = props.open) !== null && _c !== void 0 ? _c : props.visible,
        defaultValue: (_d = props.defaultOpen) !== null && _d !== void 0 ? _d : props.defaultVisible
    });
    const settingOpen = (value, e)=>{
        setOpen(value, true);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(value, e);
    };
    const onKeyDown = (e)=>{
        if (e.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC) settingOpen(false, e);
    };
    const onInternalOpenChange = (value)=>{
        settingOpen(value);
    };
    const titleNode = (0, $5717c0f052400f03$export$15e5fca53711d340)(title);
    const contentNode = (0, $5717c0f052400f03$export$15e5fca53711d340)(content);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), Object.assign({
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay
    }, otherProps, {
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            body: bodyClassNames
        },
        styles: {
            root: Object.assign(Object.assign(Object.assign(Object.assign({}, (_e = popover === null || popover === void 0 ? void 0 : popover.styles) === null || _e === void 0 ? void 0 : _e.root), popover === null || popover === void 0 ? void 0 : popover.style), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
            body: Object.assign(Object.assign({}, (_f = popover === null || popover === void 0 ? void 0 : popover.styles) === null || _f === void 0 ? void 0 : _f.body), styles === null || styles === void 0 ? void 0 : styles.body)
        },
        ref: ref,
        open: open,
        onOpenChange: onInternalOpenChange,
        overlay: titleNode || contentNode ? /*#__PURE__*/ $jMaZ8.createElement((0, $b0d029c807639a81$export$c6fdb837b070b4ff), {
            prefixCls: prefixCls,
            title: titleNode,
            content: contentNode
        }) : null,
        transitionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big', otherProps.transitionName),
        "data-popover-inject": true
    }), (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(children, {
        onKeyDown: (e)=>{
            var _a, _b;
            if (/*#__PURE__*/ $jMaZ8.isValidElement(children)) (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 || _b.call(_a, e);
            onKeyDown(e);
        }
    })));
});
const $c5aa6d63acebb2d0$var$Popover = $c5aa6d63acebb2d0$var$InternalPopover;
$c5aa6d63acebb2d0$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $b0d029c807639a81$export$2e2bcd8739ae039);
$c5aa6d63acebb2d0$var$Popover.displayName = 'Popover';
var $c5aa6d63acebb2d0$export$2e2bcd8739ae039 = $c5aa6d63acebb2d0$var$Popover;


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $8aff9380083baae2$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $8aff9380083baae2$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $8aff9380083baae2$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}





var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $jLTp6 = parcelRequire("jLTp6");
"use client";
const $5b3a39fcefef4fd4$var$viewSize = 100;
const $5b3a39fcefef4fd4$var$borderWidth = $5b3a39fcefef4fd4$var$viewSize / 5;
const $5b3a39fcefef4fd4$var$radius = $5b3a39fcefef4fd4$var$viewSize / 2 - $5b3a39fcefef4fd4$var$borderWidth / 2;
const $5b3a39fcefef4fd4$var$circumference = $5b3a39fcefef4fd4$var$radius * 2 * Math.PI;
const $5b3a39fcefef4fd4$var$position = 50;
const $5b3a39fcefef4fd4$var$CustomCircle = (props)=>{
    const { dotClassName: dotClassName, style: style, hasCircleCls: hasCircleCls } = props;
    return /*#__PURE__*/ $jMaZ8.createElement("circle", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: $5b3a39fcefef4fd4$var$radius,
        cx: $5b3a39fcefef4fd4$var$position,
        cy: $5b3a39fcefef4fd4$var$position,
        strokeWidth: $5b3a39fcefef4fd4$var$borderWidth,
        style: style
    });
};
const $5b3a39fcefef4fd4$var$Progress = (_ref)=>{
    let { percent: percent, prefixCls: prefixCls } = _ref;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $jMaZ8.useState(false);
    // ==================== Visible =====================
    (0, $jLTp6.default)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent !== 0
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${$5b3a39fcefef4fd4$var$circumference / 4}`,
        strokeDasharray: `${$5b3a39fcefef4fd4$var$circumference * safePtg / 100} ${$5b3a39fcefef4fd4$var$circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
    }, /*#__PURE__*/ $jMaZ8.createElement("svg", {
        viewBox: `0 0 ${$5b3a39fcefef4fd4$var$viewSize} ${$5b3a39fcefef4fd4$var$viewSize}`,
        // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ $jMaZ8.createElement($5b3a39fcefef4fd4$var$CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ $jMaZ8.createElement($5b3a39fcefef4fd4$var$CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
var $5b3a39fcefef4fd4$export$2e2bcd8739ae039 = $5b3a39fcefef4fd4$var$Progress;


"use client";
function $3392a8bc0ea6c439$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0 } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(holderClassName, percent > 0 && hideClassName)
    }, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $jMaZ8.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $jMaZ8.createElement((0, $5b3a39fcefef4fd4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    }));
}


"use client";
function $e8589e51051765ff$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $jMaZ8.isValidElement(indicator)) return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(indicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(indicator.props.className, dotClassName),
        percent: percent
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $3392a8bc0ea6c439$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    });
}


parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $a6455daac353b6f9$var$antSpinMove = new (0, $kB90R.default)('antSpinMove', {
    to: {
        opacity: 1
    }
});
const $a6455daac353b6f9$var$antRotate = new (0, $kB90R.default)('antRotate', {
    to: {
        transform: 'rotate(405deg)'
    }
});
const $a6455daac353b6f9$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'absolute',
            display: 'none',
            color: token.colorPrimary,
            fontSize: 0,
            textAlign: 'center',
            verticalAlign: 'middle',
            opacity: 0,
            transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
            '&-spinning': {
                position: 'relative',
                display: 'inline-block',
                opacity: 1
            },
            [`${componentCls}-text`]: {
                fontSize: token.fontSize,
                paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
            },
            '&-fullscreen': {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                opacity: 0,
                visibility: 'hidden',
                transition: `all ${token.motionDurationMid}`,
                '&-show': {
                    opacity: 1,
                    visibility: 'visible'
                },
                [componentCls]: {
                    [`${componentCls}-dot-holder`]: {
                        color: token.colorWhite
                    },
                    [`${componentCls}-text`]: {
                        color: token.colorTextLightSolid
                    }
                }
            },
            '&-nested-loading': {
                position: 'relative',
                [`> div > ${componentCls}`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    zIndex: 4,
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    maxHeight: token.contentHeight,
                    [`${componentCls}-dot`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '50%',
                        margin: calc(token.dotSize).mul(-1).div(2).equal()
                    },
                    [`${componentCls}-text`]: {
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
                    },
                    [`&${componentCls}-show-text ${componentCls}-dot`]: {
                        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
                    },
                    '&-sm': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
                        }
                    },
                    '&-lg': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
                        }
                    }
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    transition: `opacity ${token.motionDurationSlow}`,
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        zIndex: 10,
                        width: '100%',
                        height: '100%',
                        background: token.colorBgContainer,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '""',
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-blur`]: {
                    clear: 'both',
                    opacity: 0.5,
                    userSelect: 'none',
                    pointerEvents: 'none',
                    '&::after': {
                        opacity: 0.4,
                        pointerEvents: 'auto'
                    }
                }
            },
            // tip
            // ------------------------------
            '&-tip': {
                color: token.spinDotDefault
            },
            // holder
            // ------------------------------
            [`${componentCls}-dot-holder`]: {
                width: '1em',
                height: '1em',
                fontSize: token.dotSize,
                display: 'inline-block',
                transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
                transformOrigin: '50% 50%',
                lineHeight: 1,
                color: token.colorPrimary,
                '&-hidden': {
                    transform: 'scale(0.3)',
                    opacity: 0
                }
            },
            // progress
            // ------------------------------
            [`${componentCls}-dot-progress`]: {
                position: 'absolute',
                inset: 0
            },
            // dots
            // ------------------------------
            [`${componentCls}-dot`]: {
                position: 'relative',
                display: 'inline-block',
                fontSize: token.dotSize,
                width: '1em',
                height: '1em',
                '&-item': {
                    position: 'absolute',
                    display: 'block',
                    width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    background: 'currentColor',
                    borderRadius: '100%',
                    transform: 'scale(0.75)',
                    transformOrigin: '50% 50%',
                    opacity: 0.3,
                    animationName: $a6455daac353b6f9$var$antSpinMove,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationDirection: 'alternate',
                    '&:nth-child(1)': {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: '0s'
                    },
                    '&:nth-child(2)': {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: '0.4s'
                    },
                    '&:nth-child(3)': {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: '0.8s'
                    },
                    '&:nth-child(4)': {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: '1.2s'
                    }
                },
                '&-spin': {
                    transform: 'rotate(45deg)',
                    animationName: $a6455daac353b6f9$var$antRotate,
                    animationDuration: '1.2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                },
                '&-circle': {
                    strokeLinecap: 'round',
                    transition: [
                        'stroke-dashoffset',
                        'stroke-dasharray',
                        'stroke',
                        'stroke-width',
                        'opacity'
                    ].map((item)=>`${item} ${token.motionDurationSlow} ease`).join(','),
                    fillOpacity: 0,
                    stroke: 'currentcolor'
                },
                '&-circle-bg': {
                    stroke: token.colorFillSecondary
                }
            },
            // small
            [`&-sm ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeSM
                }
            },
            [`&-sm ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
                    height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
                }
            },
            // large
            [`&-lg ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeLG
                }
            },
            [`&-lg ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
                    height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
                }
            },
            [`&${componentCls}-show-text ${componentCls}-text`]: {
                display: 'block'
            }
        })
    };
};
const $a6455daac353b6f9$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$a6455daac353b6f9$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Spin', (token)=>{
    const spinToken = (0, $8APUt.merge)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $a6455daac353b6f9$var$genSpinStyle(spinToken)
    ];
}, $a6455daac353b6f9$export$9ca1be8807fe0675);



var $jMaZ8 = parcelRequire("jMaZ8");
const $411792c74a2e3d65$var$AUTO_INTERVAL = 200;
const $411792c74a2e3d65$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $411792c74a2e3d65$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $jMaZ8.useState(0);
    const mockIntervalRef = $jMaZ8.useRef(null);
    const isAuto = percent === 'auto';
    $jMaZ8.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $411792c74a2e3d65$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $411792c74a2e3d65$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $411792c74a2e3d65$var$AUTO_INTERVAL);
        }
        return ()=>{
            clearInterval(mockIntervalRef.current);
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}


"use client";
var $dee5cc896ba0ca8a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $dee5cc896ba0ca8a$var$_SpinSizes = [
    'small',
    'default',
    'large'
];
// Render indicator
let $dee5cc896ba0ca8a$var$defaultIndicator;
function $dee5cc896ba0ca8a$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const $dee5cc896ba0ca8a$var$Spin = (props)=>{
    var _a;
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size = 'default', tip: tip, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent } = props, restProps = $dee5cc896ba0ca8a$var$__rest(props, [
        "prefixCls",
        "spinning",
        "delay",
        "className",
        "rootClassName",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children",
        "fullscreen",
        "indicator",
        "percent"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, spin: spin } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $a6455daac353b6f9$export$2e2bcd8739ae039)(prefixCls);
    const [spinning, setSpinning] = $jMaZ8.useState(()=>customSpinning && !$dee5cc896ba0ca8a$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $411792c74a2e3d65$export$2e2bcd8739ae039)(spinning, percent);
    $jMaZ8.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $8aff9380083baae2$export$61fc7d43ac8f84b0)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                var _a;
                (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 || _a.call(showSpinning);
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    const isNestedPattern = $jMaZ8.useMemo(()=>typeof children !== 'undefined' && !fullscreen, [
        children,
        fullscreen
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Spin');
        warning(!tip || isNestedPattern || fullscreen, 'usage', '`tip` only work in nest or fullscreen pattern.');
    }
    const spinClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, spin === null || spin === void 0 ? void 0 : spin.className, {
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, !fullscreen && rootClassName, hashId, cssVarCls);
    const containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-container`, {
        [`${prefixCls}-blur`]: spinning
    });
    const mergedIndicator = (_a = indicator !== null && indicator !== void 0 ? indicator : spin === null || spin === void 0 ? void 0 : spin.indicator) !== null && _a !== void 0 ? _a : $dee5cc896ba0ca8a$var$defaultIndicator;
    const mergedStyle = Object.assign(Object.assign({}, spin === null || spin === void 0 ? void 0 : spin.style), style);
    const spinElement = /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, restProps, {
        style: mergedStyle,
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $e8589e51051765ff$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-text`
    }, tip) : null);
    if (isNestedPattern) return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, restProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-nested-loading`, wrapperClassName, hashId, cssVarCls)
    }), spinning && /*#__PURE__*/ $jMaZ8.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children)));
    if (fullscreen) return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-fullscreen`, {
            [`${prefixCls}-fullscreen-show`]: spinning
        }, rootClassName, hashId, cssVarCls)
    }, spinElement));
    return wrapCSSVar(spinElement);
};
$dee5cc896ba0ca8a$var$Spin.setDefaultIndicator = (indicator)=>{
    $dee5cc896ba0ca8a$var$defaultIndicator = indicator;
};
$dee5cc896ba0ca8a$var$Spin.displayName = 'Spin';
var $dee5cc896ba0ca8a$export$2e2bcd8739ae039 = $dee5cc896ba0ca8a$var$Spin;


var $jMaZ8 = parcelRequire("jMaZ8");


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $9b26f40270d08edc$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $9b26f40270d08edc$export$2e2bcd8739ae039 = $9b26f40270d08edc$var$EllipsisOutlined;



var $49848ec5154332ea$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $9b26f40270d08edc$export$2e2bcd8739ae039)
    }));
};
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ var $49848ec5154332ea$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($49848ec5154332ea$var$EllipsisOutlined);
$49848ec5154332ea$var$RefIcon.displayName = 'EllipsisOutlined';
var $49848ec5154332ea$export$2e2bcd8739ae039 = $49848ec5154332ea$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $f4a90ffe7f747b1e$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $f4a90ffe7f747b1e$export$2e2bcd8739ae039 = $f4a90ffe7f747b1e$var$PlusOutlined;



var $4773bfa339fdb113$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $f4a90ffe7f747b1e$export$2e2bcd8739ae039)
    }));
};
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ var $4773bfa339fdb113$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($4773bfa339fdb113$var$PlusOutlined);
$4773bfa339fdb113$var$RefIcon.displayName = 'PlusOutlined';
var $4773bfa339fdb113$export$2e2bcd8739ae039 = $4773bfa339fdb113$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $1Esi2 = parcelRequire("1Esi2");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");


var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
var $f11dc1150de29c3e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jMaZ8.createContext)(null);



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $fvBso = parcelRequire("fvBso");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");

var $ktS49 = parcelRequire("ktS49");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");


var $3fkx6 = parcelRequire("3fkx6");

var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");
var $0658c6601d9e077d$var$useIndicator = function useIndicator(options) {
    var activeTabOffset = options.activeTabOffset, horizontal = options.horizontal, rtl = options.rtl, _options$indicator = options.indicator, indicator = _options$indicator === void 0 ? {} : _options$indicator;
    var size = indicator.size, _indicator$align = indicator.align, align = _indicator$align === void 0 ? 'center' : _indicator$align;
    var _useState = (0, $jMaZ8.useState)(), _useState2 = (0, $3fkx6.default)(_useState, 2), inkStyle = _useState2[0], setInkStyle = _useState2[1];
    var inkBarRafRef = (0, $jMaZ8.useRef)();
    var getLength = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useCallback(function(origin) {
        if (typeof size === 'function') return size(origin);
        if (typeof size === 'number') return size;
        return origin;
    }, [
        size
    ]);
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $aZxvk.default).cancel(inkBarRafRef.current);
    }
    (0, $jMaZ8.useEffect)(function() {
        var newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                newInkStyle.width = getLength(activeTabOffset.width);
                var key = rtl ? 'right' : 'left';
                if (align === 'start') newInkStyle[key] = activeTabOffset[key];
                if (align === 'center') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width / 2;
                    newInkStyle.transform = rtl ? 'translateX(50%)' : 'translateX(-50%)';
                }
                if (align === 'end') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width;
                    newInkStyle.transform = 'translateX(-100%)';
                }
            } else {
                newInkStyle.height = getLength(activeTabOffset.height);
                if (align === 'start') newInkStyle.top = activeTabOffset.top;
                if (align === 'center') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                    newInkStyle.transform = 'translateY(-50%)';
                }
                if (align === 'end') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
                    newInkStyle.transform = 'translateY(-100%)';
                }
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $aZxvk.default)(function() {
            setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        activeTabOffset,
        horizontal,
        rtl,
        align,
        getLength
    ]);
    return {
        style: inkStyle
    };
};
var $0658c6601d9e077d$export$2e2bcd8739ae039 = $0658c6601d9e077d$var$useIndicator;



var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
var $dc069e2f35db9d88$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $dc069e2f35db9d88$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $jMaZ8.useMemo)(function() {
        var _tabs$;
        var map = new Map();
        var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || $dc069e2f35db9d88$var$DEFAULT_SIZE;
        var rightOffset = lastOffset.left + lastOffset.width;
        for(var i = 0; i < tabs.length; i += 1){
            var key = tabs[i].key;
            var data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) {
                var _tabs;
                data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || $dc069e2f35db9d88$var$DEFAULT_SIZE;
            }
            var entity = map.get(key) || (0, $8u3qN.default)({}, data);
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        tabSizes,
        holderScrollWidth
    ]);
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $5a3dcdb59e5494cc$export$2e2bcd8739ae039(defaultState, onChange) {
    var stateRef = $jMaZ8.useRef(defaultState);
    var _React$useState = $jMaZ8.useState({}), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    function setState(updater) {
        var newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
var $99a673ceb1e29b66$var$MIN_SWIPE_DISTANCE = 0.1;
var $99a673ceb1e29b66$var$STOP_SWIPE_DISTANCE = 0.01;
var $99a673ceb1e29b66$var$REFRESH_INTERVAL = 20;
var $99a673ceb1e29b66$var$SPEED_OFF_MULTIPLE = Math.pow(0.995, $99a673ceb1e29b66$var$REFRESH_INTERVAL);
function $99a673ceb1e29b66$export$2e2bcd8739ae039(ref, onOffset) {
    var _useState = (0, $jMaZ8.useState)(), _useState2 = (0, $3fkx6.default)(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
    var _useState3 = (0, $jMaZ8.useState)(0), _useState4 = (0, $3fkx6.default)(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
    var _useState5 = (0, $jMaZ8.useState)(0), _useState6 = (0, $3fkx6.default)(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
    var _useState7 = (0, $jMaZ8.useState)(), _useState8 = (0, $3fkx6.default)(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
    var motionRef = (0, $jMaZ8.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        var _e$touches$ = e.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        // e.preventDefault();
        var _e$touches$2 = e.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        var offsetX = screenX - touchPosition.x;
        var offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        var now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            var distanceX = lastOffset.x / lastTimeDiff;
            var distanceY = lastOffset.y / lastTimeDiff;
            var absX = Math.abs(distanceX);
            var absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $99a673ceb1e29b66$var$MIN_SWIPE_DISTANCE) return;
            var currentX = distanceX;
            var currentY = distanceY;
            motionRef.current = window.setInterval(function() {
                if (Math.abs(currentX) < $99a673ceb1e29b66$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $99a673ceb1e29b66$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $99a673ceb1e29b66$var$SPEED_OFF_MULTIPLE;
                currentY *= $99a673ceb1e29b66$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $99a673ceb1e29b66$var$REFRESH_INTERVAL, currentY * $99a673ceb1e29b66$var$REFRESH_INTERVAL);
            }, $99a673ceb1e29b66$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    var lastWheelDirectionRef = (0, $jMaZ8.useRef)();
    function onWheel(e) {
        var deltaX = e.deltaX, deltaY = e.deltaY;
        // Convert both to x & y since wheel only happened on PC
        var mixed = 0;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = 'x';
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = 'y';
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    var touchEventsRef = (0, $jMaZ8.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $jMaZ8.useEffect(function() {
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener('touchmove', onProxyTouchMove, {
            passive: false
        });
        document.addEventListener('touchend', onProxyTouchEnd, {
            passive: true
        });
        // No need to clean up since element removed
        ref.current.addEventListener('touchstart', onProxyTouchStart, {
            passive: true
        });
        ref.current.addEventListener('wheel', onProxyWheel, {
            passive: false
        });
        return function() {
            document.removeEventListener('touchmove', onProxyTouchMove);
            document.removeEventListener('touchend', onProxyTouchEnd);
        };
    }, []);
}



var $3fkx6 = parcelRequire("3fkx6");

var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $73b7747ed999888f$export$2e2bcd8739ae039(callback) {
    var _useState = (0, $jMaZ8.useState)(0), _useState2 = (0, $3fkx6.default)(_useState, 2), count = _useState2[0], setCount = _useState2[1];
    var effectRef = (0, $jMaZ8.useRef)(0);
    var callbackRef = (0, $jMaZ8.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $jLTp6.useLayoutUpdateEffect)(function() {
        var _callbackRef$current;
        (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
    }, [
        count
    ]);
    // Trigger to update count
    return function() {
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $73b7747ed999888f$export$aefd2a30eb6d999e(defaultState) {
    var batchRef = (0, $jMaZ8.useRef)([]);
    var _useState3 = (0, $jMaZ8.useState)({}), _useState4 = (0, $3fkx6.default)(_useState3, 2), forceUpdate = _useState4[1];
    var state = (0, $jMaZ8.useRef)(typeof defaultState === 'function' ? defaultState() : defaultState);
    var flushUpdate = $73b7747ed999888f$export$2e2bcd8739ae039(function() {
        var current = state.current;
        batchRef.current.forEach(function(callback) {
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $jMaZ8 = parcelRequire("jMaZ8");
var $4da6fe0d0b5d3b3a$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $4da6fe0d0b5d3b3a$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
    var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl = _ref.rtl;
    var charUnit;
    var position;
    var transformSize;
    if ([
        'top',
        'bottom'
    ].includes(tabPosition)) {
        charUnit = 'width';
        position = rtl ? 'right' : 'left';
        transformSize = Math.abs(transform);
    } else {
        charUnit = 'height';
        position = 'top';
        transformSize = -transform;
    }
    return (0, $jMaZ8.useMemo)(function() {
        if (!tabs.length) return [
            0,
            0
        ];
        var len = tabs.length;
        var endIndex = len;
        for(var i = 0; i < len; i += 1){
            var offset = tabOffsets.get(tabs[i].key) || $4da6fe0d0b5d3b3a$var$DEFAULT_SIZE;
            if (Math.floor(offset[position] + offset[charUnit]) > Math.floor(transformSize + visibleTabContentValue)) {
                endIndex = i - 1;
                break;
            }
        }
        var startIndex = 0;
        for(var _i = len - 1; _i >= 0; _i -= 1){
            var _offset = tabOffsets.get(tabs[_i].key) || $4da6fe0d0b5d3b3a$var$DEFAULT_SIZE;
            if (_offset[position] < transformSize) {
                startIndex = _i + 1;
                break;
            }
        }
        return startIndex >= endIndex ? [
            0,
            0
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        rtl
    ]);
}


/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $fe114a8290e39582$export$fac44ee5b035f737(obj) {
    var tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach(function(v, k) {
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
var $fe114a8290e39582$var$RC_TABS_DOUBLE_QUOTE = 'TABS_DQ';
function $fe114a8290e39582$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $fe114a8290e39582$var$RC_TABS_DOUBLE_QUOTE);
}
function $fe114a8290e39582$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}



var $jMaZ8 = parcelRequire("jMaZ8");
var $49bd0dc7fb6cbb9b$var$AddButton = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, editable = props.editable, locale = props.locale, style = props.style;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $jMaZ8.createElement("button", {
        ref: ref,
        type: "button",
        className: "".concat(prefixCls, "-nav-add"),
        style: style,
        "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || 'Add tab',
        onClick: function onClick(event) {
            editable.onEdit('add', {
                event: event
            });
        }
    }, editable.addIcon || '+');
});
var $49bd0dc7fb6cbb9b$export$2e2bcd8739ae039 = $49bd0dc7fb6cbb9b$var$AddButton;



var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");
var $289e78a381db8a06$var$ExtraContent = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var position = props.position, prefixCls = props.prefixCls, extra = props.extra;
    if (!extra) return null;
    var content;
    // Parse extra
    var assertExtra = {};
    if ((0, $1Esi2.default)(extra) === 'object' && !/*#__PURE__*/ $jMaZ8.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === 'right') content = assertExtra.right;
    if (position === 'left') content = assertExtra.left;
    return content ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(prefixCls, "-extra-content"),
        ref: ref
    }, content) : null;
});
$289e78a381db8a06$var$ExtraContent.displayName = 'ExtraContent';
var $289e78a381db8a06$export$2e2bcd8739ae039 = $289e78a381db8a06$var$ExtraContent;



var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");


var $giSak = parcelRequire("giSak");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");


var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");
var $abe002a1a4cb52b3$var$ESC = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC, $abe002a1a4cb52b3$var$TAB = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).TAB;
function $abe002a1a4cb52b3$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus, overlayRef = _ref.overlayRef;
    var focusMenuRef = $jMaZ8.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible) {
            var _triggerRef$current, _triggerRef$current$f;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _overlayRef$current;
        if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $abe002a1a4cb52b3$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $abe002a1a4cb52b3$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $jMaZ8.useEffect(function() {
        if (visible) {
            window.addEventListener("keydown", handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $aZxvk.default)(focusMenu, 3);
            return function() {
                window.removeEventListener("keydown", handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}



var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");
var $48acafcf96012261$var$Overlay = /*#__PURE__*/ (0, $jMaZ8.forwardRef)(function(props, ref) {
    var overlay = props.overlay, arrow = props.arrow, prefixCls = props.prefixCls;
    var overlayNode = (0, $jMaZ8.useMemo)(function() {
        var overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    var composedRef = (0, $1cfGC.composeRef)(ref, (0, $1cfGC.getNodeRef)(overlayNode));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(overlayNode, {
        ref: (0, $1cfGC.supportRef)(overlayNode) ? composedRef : undefined
    }));
});
var $48acafcf96012261$export$2e2bcd8739ae039 = $48acafcf96012261$var$Overlay;


var $39583c93d4af9b8c$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $39583c93d4af9b8c$var$targetOffset = [
    0,
    0
];
var $39583c93d4af9b8c$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $39583c93d4af9b8c$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $39583c93d4af9b8c$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $39583c93d4af9b8c$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $39583c93d4af9b8c$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $39583c93d4af9b8c$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $39583c93d4af9b8c$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $39583c93d4af9b8c$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $39583c93d4af9b8c$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $39583c93d4af9b8c$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $39583c93d4af9b8c$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $39583c93d4af9b8c$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $39583c93d4af9b8c$var$targetOffset
    }
};
var $39583c93d4af9b8c$export$2e2bcd8739ae039 = $39583c93d4af9b8c$var$placements;


var $5bdcabb440e2bbff$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus",
    "overlay",
    "children",
    "onVisibleChange"
];
function $5bdcabb440e2bbff$var$Dropdown(props, ref) {
    var _children$props;
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dropdown' : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottomLeft' : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $39583c93d4af9b8c$export$2e2bcd8739ae039) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, autoFocus = props.autoFocus, overlay = props.overlay, children = props.children, onVisibleChange = props.onVisibleChange, otherProps = (0, $4b02Q.default)(props, $5bdcabb440e2bbff$var$_excluded);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = 'visible' in props ? visible : triggerVisible;
    var triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(null);
    var overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(null);
    var childRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    var handleVisibleChange = function handleVisibleChange(newVisible) {
        setTriggerVisible(newVisible);
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
    };
    (0, $abe002a1a4cb52b3$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var getMenuElement = function getMenuElement() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $48acafcf96012261$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(children, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
        ref: (0, $1cfGC.supportRef)(children) ? (0, $1cfGC.composeRef)(childRef, (0, $1cfGC.getNodeRef)(children)) : undefined
    });
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $3e6696c575106f0d$export$2e2bcd8739ae039), (0, $hH60s.default)({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(overlayClassName, (0, $eq8kl.default)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
}
var $5bdcabb440e2bbff$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef($5bdcabb440e2bbff$var$Dropdown);


var $5b2f2e9aebf27f9d$export$2e2bcd8739ae039 = (0, $5bdcabb440e2bbff$export$2e2bcd8739ae039);



var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");

var $jLTp6 = parcelRequire("jLTp6");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");
var $6a15d30aefb35283$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $6a15d30aefb35283$var$UNDEFINED = undefined;
function $6a15d30aefb35283$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, restProps = (0, $4b02Q.default)(props, $6a15d30aefb35283$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $jMaZ8.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $6a15d30aefb35283$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $6a15d30aefb35283$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $6a15d30aefb35283$var$UNDEFINED,
        order: responsive ? order : $6a15d30aefb35283$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $6a15d30aefb35283$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $6a15d30aefb35283$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    var itemNode = /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(!invalidate && prefixCls, className),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $6a15d30aefb35283$var$Item = /*#__PURE__*/ $jMaZ8.forwardRef($6a15d30aefb35283$var$InternalItem);
$6a15d30aefb35283$var$Item.displayName = 'Item';
var $6a15d30aefb35283$export$2e2bcd8739ae039 = $6a15d30aefb35283$var$Item;



var $3fkx6 = parcelRequire("3fkx6");

var $ktS49 = parcelRequire("ktS49");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

var $aZxvk = parcelRequire("aZxvk");
function $365ad4115be980cf$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $aZxvk.default)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}


function $32fee7f1f4d9cbf7$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $jMaZ8.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $365ad4115be980cf$export$2e2bcd8739ae039)(function() {
                (0, $6UWRi.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $32fee7f1f4d9cbf7$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $jMaZ8.useState(defaultValue), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $ktS49.default)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}



var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $jMaZ8 = parcelRequire("jMaZ8");
var $89c7c0967908c254$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext(null);


var $e80173500b7cd558$var$_excluded = [
    "component"
], $e80173500b7cd558$var$_excluded2 = [
    "className"
], $e80173500b7cd558$var$_excluded3 = [
    "className"
];
var $e80173500b7cd558$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $jMaZ8.useContext((0, $89c7c0967908c254$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _restProps = (0, $4b02Q.default)(props, $e80173500b7cd558$var$_excluded);
        return /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $4b02Q.default)(context, $e80173500b7cd558$var$_excluded2);
    var className = props.className, restProps = (0, $4b02Q.default)(props, $e80173500b7cd558$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $jMaZ8.createElement((0, $89c7c0967908c254$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $6a15d30aefb35283$export$2e2bcd8739ae039), (0, $hH60s.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(contextClassName, className)
    }, restContext, restProps)));
};
var $e80173500b7cd558$var$RawItem = /*#__PURE__*/ $jMaZ8.forwardRef($e80173500b7cd558$var$InternalRawItem);
$e80173500b7cd558$var$RawItem.displayName = 'RawItem';
var $e80173500b7cd558$export$2e2bcd8739ae039 = $e80173500b7cd558$var$RawItem;



var $db173c1790bf88f4$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $db173c1790bf88f4$var$RESPONSIVE = 'responsive';
var $db173c1790bf88f4$var$INVALIDATE = 'invalidate';
function $db173c1790bf88f4$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $db173c1790bf88f4$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $4b02Q.default)(props, $db173c1790bf88f4$var$_excluded);
    var fullySSR = ssr === 'full';
    var notifyEffectUpdate = (0, $32fee7f1f4d9cbf7$export$eedf51fe9d751c7a)();
    var _useEffectState = (0, $32fee7f1f4d9cbf7$export$2e2bcd8739ae039)(notifyEffectUpdate, null), _useEffectState2 = (0, $3fkx6.default)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $32fee7f1f4d9cbf7$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $3fkx6.default)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $32fee7f1f4d9cbf7$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState6 = (0, $3fkx6.default)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $32fee7f1f4d9cbf7$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState8 = (0, $3fkx6.default)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $32fee7f1f4d9cbf7$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState10 = (0, $3fkx6.default)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $jMaZ8.useState)(null), _useState2 = (0, $3fkx6.default)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $jMaZ8.useState)(null), _useState4 = (0, $3fkx6.default)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $jMaZ8.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $jMaZ8.useState)(false), _useState6 = (0, $3fkx6.default)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $db173c1790bf88f4$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $db173c1790bf88f4$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    var mergedData = (0, $jMaZ8.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $jMaZ8.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $jMaZ8.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === 'function') return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $jMaZ8.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $jLTp6.default)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $89c7c0967908c254$export$79f16dd643143c25).Provider, {
            key: key,
            value: (0, $8u3qN.default)((0, $8u3qN.default)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $6a15d30aefb35283$export$2e2bcd8739ae039), (0, $hH60s.default)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    var mergedRenderRest = renderRest || $db173c1790bf88f4$var$defaultRenderRest;
    var restNode = renderRawRest ? /*#__PURE__*/ $jMaZ8.createElement((0, $89c7c0967908c254$export$79f16dd643143c25).Provider, {
        value: (0, $8u3qN.default)((0, $8u3qN.default)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $jMaZ8.createElement((0, $6a15d30aefb35283$export$2e2bcd8739ae039), (0, $hH60s.default)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    var overflowNode = /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $jMaZ8.createElement((0, $6a15d30aefb35283$export$2e2bcd8739ae039), (0, $hH60s.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
var $db173c1790bf88f4$var$ForwardOverflow = /*#__PURE__*/ $jMaZ8.forwardRef($db173c1790bf88f4$var$Overflow);
$db173c1790bf88f4$var$ForwardOverflow.displayName = 'Overflow';
$db173c1790bf88f4$var$ForwardOverflow.Item = (0, $e80173500b7cd558$export$2e2bcd8739ae039);
$db173c1790bf88f4$var$ForwardOverflow.RESPONSIVE = $db173c1790bf88f4$var$RESPONSIVE;
$db173c1790bf88f4$var$ForwardOverflow.INVALIDATE = $db173c1790bf88f4$var$INVALIDATE;
var // Convert to generic type
$db173c1790bf88f4$export$2e2bcd8739ae039 = $db173c1790bf88f4$var$ForwardOverflow;


var $7c61136bd8e14ae0$export$2e2bcd8739ae039 = (0, $db173c1790bf88f4$export$2e2bcd8739ae039);



var $eGh7a = parcelRequire("eGh7a");

var $9O5K3 = parcelRequire("9O5K3");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

var $jMaZ8 = parcelRequire("jMaZ8");
var $507b8095eddad637$export$26537912ea160acd = /*#__PURE__*/ $jMaZ8.createContext(null);
function $507b8095eddad637$export$80c871fe8d6b896(uuid, eventKey) {
    if (uuid === undefined) return null;
    return "".concat(uuid, "-").concat(eventKey);
}
function $507b8095eddad637$export$a276eb4e9be640f8(eventKey) {
    var id = $jMaZ8.useContext($507b8095eddad637$export$26537912ea160acd);
    return $507b8095eddad637$export$80c871fe8d6b896(id, eventKey);
}



var $4b02Q = parcelRequire("4b02Q");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hBgfL = parcelRequire("hBgfL");

var $9O5K3 = parcelRequire("9O5K3");
var $dfa6c5a76212936b$var$_excluded = [
    "children",
    "locked"
];
var $dfa6c5a76212936b$export$c7e742effb1c51e2 = /*#__PURE__*/ $jMaZ8.createContext(null);
function $dfa6c5a76212936b$var$mergeProps(origin, target) {
    var clone = (0, $8u3qN.default)({}, origin);
    Object.keys(target).forEach(function(key) {
        var value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $dfa6c5a76212936b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, locked = _ref.locked, restProps = (0, $4b02Q.default)(_ref, $dfa6c5a76212936b$var$_excluded);
    var context = $jMaZ8.useContext($dfa6c5a76212936b$export$c7e742effb1c51e2);
    var inheritableContext = (0, $hBgfL.default)(function() {
        return $dfa6c5a76212936b$var$mergeProps(context, restProps);
    }, [
        context,
        restProps
    ], function(prev, next) {
        return !locked && (prev[0] !== next[0] || !(0, $9O5K3.default)(prev[1], next[1], true));
    });
    return /*#__PURE__*/ $jMaZ8.createElement($dfa6c5a76212936b$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");
var $69440eab1161c178$var$EmptyList = [];
var $69440eab1161c178$export$d9ffb5bfd108b003 = /*#__PURE__*/ $jMaZ8.createContext(null);
function $69440eab1161c178$export$e295b0c537d32d7d() {
    return $jMaZ8.useContext($69440eab1161c178$export$d9ffb5bfd108b003);
}
var $69440eab1161c178$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $jMaZ8.createContext($69440eab1161c178$var$EmptyList);
function $69440eab1161c178$export$d3d2d0a05677870a(eventKey) {
    var parentKeyPath = $jMaZ8.useContext($69440eab1161c178$export$54d9e16aa4c8a7fa);
    return $jMaZ8.useMemo(function() {
        return eventKey !== undefined ? [].concat((0, $fvBso.default)(parentKeyPath), [
            eventKey
        ]) : parentKeyPath;
    }, [
        parentKeyPath,
        eventKey
    ]);
}
var $69440eab1161c178$export$f0b9e0db98edfa53 = /*#__PURE__*/ $jMaZ8.createContext(null);



var $jMaZ8 = parcelRequire("jMaZ8");
var $7f088c8c7eb1abb0$var$PrivateContext = /*#__PURE__*/ $jMaZ8.createContext({});
var $7f088c8c7eb1abb0$export$2e2bcd8739ae039 = $7f088c8c7eb1abb0$var$PrivateContext;



var $eq8kl = parcelRequire("eq8kl");

var $fvBso = parcelRequire("fvBso");

function $a65eb172dbc3079c$var$focusable(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0, $f0dd1e7e6ce84933$export$2e2bcd8739ae039)(node)) {
        var nodeName = node.nodeName.toLowerCase();
        var isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        var tabIndexAttr = node.getAttribute('tabindex');
        var tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        var tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $a65eb172dbc3079c$export$bbc7b5f11aba534b(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var res = (0, $fvBso.default)(node.querySelectorAll('*')).filter(function(child) {
        return $a65eb172dbc3079c$var$focusable(child, includePositive);
    });
    if ($a65eb172dbc3079c$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
var $a65eb172dbc3079c$var$lastFocusElement = null;
function $a65eb172dbc3079c$export$79fea02f7a83293d() {
    $a65eb172dbc3079c$var$lastFocusElement = document.activeElement;
}
function $a65eb172dbc3079c$export$8785654047fe7352() {
    $a65eb172dbc3079c$var$lastFocusElement = null;
}
function $a65eb172dbc3079c$export$fac0a9974415d98f() {
    if ($a65eb172dbc3079c$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $a65eb172dbc3079c$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $a65eb172dbc3079c$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        var tabNodeList = $a65eb172dbc3079c$export$bbc7b5f11aba534b(node);
        var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}




var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");

// destruct to reduce minify size
var $ca370a65762bf56a$var$LEFT = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).LEFT, $ca370a65762bf56a$var$RIGHT = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).RIGHT, $ca370a65762bf56a$var$UP = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP, $ca370a65762bf56a$var$DOWN = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN, $ca370a65762bf56a$var$ENTER = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER, $ca370a65762bf56a$var$ESC = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC, $ca370a65762bf56a$var$HOME = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).HOME, $ca370a65762bf56a$var$END = (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).END;
var $ca370a65762bf56a$var$ArrowKeys = [
    $ca370a65762bf56a$var$UP,
    $ca370a65762bf56a$var$DOWN,
    $ca370a65762bf56a$var$LEFT,
    $ca370a65762bf56a$var$RIGHT
];
function $ca370a65762bf56a$var$getOffset(mode, isRootLevel, isRtl, which) {
    var _offsets;
    var prev = 'prev';
    var next = 'next';
    var children = 'children';
    var parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $ca370a65762bf56a$var$ENTER) return {
        inlineTrigger: true
    };
    var inline = (0, $eq8kl.default)((0, $eq8kl.default)({}, $ca370a65762bf56a$var$UP, prev), $ca370a65762bf56a$var$DOWN, next);
    var horizontal = (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, $ca370a65762bf56a$var$LEFT, isRtl ? next : prev), $ca370a65762bf56a$var$RIGHT, isRtl ? prev : next), $ca370a65762bf56a$var$DOWN, children), $ca370a65762bf56a$var$ENTER, children);
    var vertical = (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, $ca370a65762bf56a$var$UP, prev), $ca370a65762bf56a$var$DOWN, next), $ca370a65762bf56a$var$ENTER, children), $ca370a65762bf56a$var$ESC, parent), $ca370a65762bf56a$var$LEFT, isRtl ? children : parent), $ca370a65762bf56a$var$RIGHT, isRtl ? parent : children);
    var offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? '' : 'Sub')]) === null || _offsets === void 0 ? void 0 : _offsets[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $ca370a65762bf56a$var$findContainerUL(element) {
    var current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $ca370a65762bf56a$var$getFocusElement(activeElement, elements) {
    var current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $ca370a65762bf56a$export$433aaa1f216cf32d(container, elements) {
    var list = (0, $a65eb172dbc3079c$export$bbc7b5f11aba534b)(container, true);
    return list.filter(function(ele) {
        return elements.has(ele);
    });
}
function $ca370a65762bf56a$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    var sameLevelFocusableMenuElementList = $ca370a65762bf56a$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    var count = sameLevelFocusableMenuElementList.length;
    var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
        return focusMenuElement === ele;
    });
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
var $ca370a65762bf56a$export$20827b68c762d23 = function refreshElements(keys, id) {
    var elements = new Set();
    var key2element = new Map();
    var element2key = new Map();
    keys.forEach(function(key) {
        var element = document.querySelector("[data-menu-id='".concat((0, $507b8095eddad637$export$80c871fe8d6b896)(id, key), "']"));
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $ca370a65762bf56a$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    var rafRef = $jMaZ8.useRef();
    var activeRef = $jMaZ8.useRef();
    activeRef.current = activeKey;
    var cleanRaf = function cleanRaf() {
        (0, $aZxvk.default).cancel(rafRef.current);
    };
    $jMaZ8.useEffect(function() {
        return function() {
            cleanRaf();
        };
    }, []);
    return function(e) {
        var which = e.which;
        if ([].concat($ca370a65762bf56a$var$ArrowKeys, [
            $ca370a65762bf56a$var$ENTER,
            $ca370a65762bf56a$var$ESC,
            $ca370a65762bf56a$var$HOME,
            $ca370a65762bf56a$var$END
        ]).includes(which)) {
            var keys = getKeys();
            var refreshedElements = $ca370a65762bf56a$export$20827b68c762d23(keys, id);
            var _refreshedElements = refreshedElements, elements = _refreshedElements.elements, key2element = _refreshedElements.key2element, element2key = _refreshedElements.element2key;
            // First we should find current focused MenuItem/SubMenu element
            var activeElement = key2element.get(activeKey);
            var focusMenuElement = $ca370a65762bf56a$var$getFocusElement(activeElement, elements);
            var focusMenuKey = element2key.get(focusMenuElement);
            var offsetObj = $ca370a65762bf56a$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $ca370a65762bf56a$var$HOME && which !== $ca370a65762bf56a$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($ca370a65762bf56a$var$ArrowKeys.includes(which) || [
                $ca370a65762bf56a$var$HOME,
                $ca370a65762bf56a$var$END
            ].includes(which)) e.preventDefault();
            var tryFocus = function tryFocus(menuElement) {
                if (menuElement) {
                    var focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    var link = menuElement.querySelector('a');
                    if (link !== null && link !== void 0 && link.getAttribute('href')) focusTargetElement = link;
                    var targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $aZxvk.default)(function() {
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $ca370a65762bf56a$var$HOME,
                $ca370a65762bf56a$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                var parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $ca370a65762bf56a$var$findContainerUL(focusMenuElement);
                // Get next focus element
                var targetElement;
                var focusableElements = $ca370a65762bf56a$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $ca370a65762bf56a$var$HOME) targetElement = focusableElements[0];
                else if (which === $ca370a65762bf56a$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $ca370a65762bf56a$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $aZxvk.default)(function() {
                    // Async should resync elements
                    refreshedElements = $ca370a65762bf56a$export$20827b68c762d23(keys, id);
                    var controlId = focusMenuElement.getAttribute('aria-controls');
                    var subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    var targetElement = $ca370a65762bf56a$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                var keyPath = getKeyPath(focusMenuKey, true);
                var parentKey = keyPath[keyPath.length - 2];
                var parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
    };
}



var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $2bFmQ = parcelRequire("2bFmQ");
function $9929ec192f07b229$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


var $11cdd9e432f43aef$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
var $11cdd9e432f43aef$var$getPathStr = function getPathStr(keyPath) {
    return keyPath.join($11cdd9e432f43aef$var$PATH_SPLIT);
};
var $11cdd9e432f43aef$var$getPathKeys = function getPathKeys(keyPathStr) {
    return keyPathStr.split($11cdd9e432f43aef$var$PATH_SPLIT);
};
var $11cdd9e432f43aef$export$20a0132c46ce5b04 = 'rc-menu-more';
function $11cdd9e432f43aef$export$2e2bcd8739ae039() {
    var _React$useState = $jMaZ8.useState({}), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), internalForceUpdate = _React$useState2[1];
    var key2pathRef = (0, $jMaZ8.useRef)(new Map());
    var path2keyRef = (0, $jMaZ8.useRef)(new Map());
    var _React$useState3 = $jMaZ8.useState([]), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
    var updateRef = (0, $jMaZ8.useRef)(0);
    var destroyRef = (0, $jMaZ8.useRef)(false);
    var forceUpdate = function forceUpdate() {
        if (!destroyRef.current) internalForceUpdate({});
    };
    var registerPath = (0, $jMaZ8.useCallback)(function(key, keyPath) {
        (0, $2bFmQ.default)(!key2pathRef.current.has(key), "Duplicated key '".concat(key, "' used in Menu by path [").concat(keyPath.join(' > '), "]"));
        // Fill map
        var connectedPath = $11cdd9e432f43aef$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        var id = updateRef.current;
        (0, $9929ec192f07b229$export$7693db51ef834b40)(function() {
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    var unregisterPath = (0, $jMaZ8.useCallback)(function(key, keyPath) {
        var connectedPath = $11cdd9e432f43aef$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    var refreshOverflowKeys = (0, $jMaZ8.useCallback)(function(keys) {
        setOverflowKeys(keys);
    }, []);
    var getKeyPath = (0, $jMaZ8.useCallback)(function(eventKey, includeOverflow) {
        var fullPath = key2pathRef.current.get(eventKey) || '';
        var keys = $11cdd9e432f43aef$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($11cdd9e432f43aef$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    var isSubPathKey = (0, $jMaZ8.useCallback)(function(pathKeys, eventKey) {
        return pathKeys.filter(function(item) {
            return item !== undefined;
        }).some(function(pathKey) {
            var pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        });
    }, [
        getKeyPath
    ]);
    var getKeys = function getKeys() {
        var keys = (0, $fvBso.default)(key2pathRef.current.keys());
        if (overflowKeys.length) keys.push($11cdd9e432f43aef$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ var getSubPathKeys = (0, $jMaZ8.useCallback)(function(key) {
        var connectedPath = "".concat(key2pathRef.current.get(key)).concat($11cdd9e432f43aef$var$PATH_SPLIT);
        var pathKeys = new Set();
        (0, $fvBso.default)(path2keyRef.current.keys()).forEach(function(pathKey) {
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $jMaZ8.useEffect(function() {
        return function() {
            destroyRef.current = true;
        };
    }, []);
    return {
        // Register
        registerPath: registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        // Util
        isSubPathKey: isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $jMaZ8 = parcelRequire("jMaZ8");
function $490280689706561b$export$2e2bcd8739ae039(func) {
    var funRef = $jMaZ8.useRef(func);
    funRef.current = func;
    var callback = $jMaZ8.useCallback(function() {
        var _funRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [
            funRef
        ].concat(args));
    }, []);
    return func ? callback : undefined;
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $eGh7a = parcelRequire("eGh7a");
var $7a483875f364afaa$var$uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var $7a483875f364afaa$var$internalId = 0;
function $7a483875f364afaa$export$2e2bcd8739ae039(id) {
    var _useMergedState = (0, $eGh7a.default)(id, {
        value: id
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), uuid = _useMergedState2[0], setUUID = _useMergedState2[1];
    $jMaZ8.useEffect(function() {
        $7a483875f364afaa$var$internalId += 1;
        var newId = 'test';
        setUUID("rc-menu-uuid-".concat(newId));
    }, []);
    return uuid;
}



var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $giSak = parcelRequire("giSak");



var $hvG6u = parcelRequire("hvG6u");

var $1cfGC = parcelRequire("1cfGC");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");





var $jMaZ8 = parcelRequire("jMaZ8");

function $9fc80eab149024b3$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
    var ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = function(domEvent) {
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = function(domEvent) {
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $jMaZ8 = parcelRequire("jMaZ8");

function $c251d787306e74c8$export$2e2bcd8739ae039(level) {
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
    if (mode !== 'inline') return null;
    var len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}



var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
function $cd65dc3cb30ec71f$export$2e2bcd8739ae039(_ref) {
    var icon = _ref.icon, props = _ref.props, children = _ref.children;
    var iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $jMaZ8.createElement(icon, (0, $8u3qN.default)({}, props));
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}



var $4b02Q = parcelRequire("4b02Q");

var $2bFmQ = parcelRequire("2bFmQ");
var $90fddad3b9b7f015$var$_excluded = [
    "item"
];
function $90fddad3b9b7f015$export$e189bcd94b66c1db(_ref) {
    var item = _ref.item, restInfo = (0, $4b02Q.default)(_ref, $90fddad3b9b7f015$var$_excluded);
    Object.defineProperty(restInfo, 'item', {
        get: function get() {
            (0, $2bFmQ.default)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}


var $77bbeaacfd0ea5eb$var$_excluded = [
    "title",
    "attribute",
    "elementRef"
], $77bbeaacfd0ea5eb$var$_excluded2 = [
    "style",
    "className",
    "eventKey",
    "warnKey",
    "disabled",
    "itemIcon",
    "children",
    "role",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onKeyDown",
    "onFocus"
], $77bbeaacfd0ea5eb$var$_excluded3 = [
    "active"
];
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var $77bbeaacfd0ea5eb$var$LegacyMenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, $7eK0y.default)(LegacyMenuItem, _React$Component);
    var _super = (0, $fwNdX.default)(LegacyMenuItem);
    function LegacyMenuItem() {
        (0, $klxbl.default)(this, LegacyMenuItem);
        return _super.apply(this, arguments);
    }
    (0, $9O7LJ.default)(LegacyMenuItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = (0, $4b02Q.default)(_this$props, $77bbeaacfd0ea5eb$var$_excluded);
                // Here the props are eventually passed to the DOM element.
                // React does not recognize non-standard attributes.
                // Therefore, remove the props that is not used here.
                // ref: https://github.com/ant-design/ant-design/issues/41395
                var passedProps = (0, $hvG6u.default)(restProps, [
                    'eventKey',
                    'popupClassName',
                    'popupOffset',
                    'onTitleClick'
                ]);
                (0, $2bFmQ.default)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
                return /*#__PURE__*/ $jMaZ8.createElement((0, $7c61136bd8e14ae0$export$2e2bcd8739ae039).Item, (0, $hH60s.default)({}, attribute, {
                    title: typeof title === 'string' ? title : undefined
                }, passedProps, {
                    ref: elementRef
                }));
            }
        }
    ]);
    return LegacyMenuItem;
}($jMaZ8.Component);
/**
 * Real Menu Item component
 */ var $77bbeaacfd0ea5eb$var$InternalMenuItem = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var style = props.style, className = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onFocus = props.onFocus, restProps = (0, $4b02Q.default)(props, $77bbeaacfd0ea5eb$var$_excluded2);
    var domDataId = (0, $507b8095eddad637$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
    var _React$useContext2 = $jMaZ8.useContext((0, $7f088c8c7eb1abb0$export$2e2bcd8739ae039)), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
    var itemCls = "".concat(prefixCls, "-item");
    var legacyMenuItemRef = $jMaZ8.useRef();
    var elementRef = $jMaZ8.useRef();
    var mergedDisabled = contextDisabled || disabled;
    var mergedEleRef = (0, $1cfGC.useComposeRef)(ref, elementRef);
    var connectedKeys = (0, $69440eab1161c178$export$d3d2d0a05677870a)(eventKey);
    // ================================ Warn ================================
    if (warnKey) (0, $2bFmQ.default)(false, 'MenuItem should not leave undefined `key`.');
    // ============================= Info =============================
    var getEventInfo = function getEventInfo(e) {
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: (0, $fvBso.default)(connectedKeys).reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    var mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    var _useActive = (0, $9fc80eab149024b3$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = (0, $4b02Q.default)(_useActive, $77bbeaacfd0ea5eb$var$_excluded3);
    // ============================ Select ============================
    var selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    var directionStyle = (0, $c251d787306e74c8$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    var onInternalClick = function onInternalClick(e) {
        if (mergedDisabled) return;
        var info = getEventInfo(e);
        onClick === null || onClick === void 0 || onClick((0, $90fddad3b9b7f015$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    var onInternalKeyDown = function onInternalKeyDown(e) {
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
        if (e.which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) {
            var info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick === null || onClick === void 0 || onClick((0, $90fddad3b9b7f015$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus(e) {
        onActive(eventKey);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    // ============================ Render ============================
    var optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    var renderNode = /*#__PURE__*/ $jMaZ8.createElement($77bbeaacfd0ea5eb$var$LegacyMenuItem, (0, $hH60s.default)({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, $hvG6u.default)(restProps, [
        'extra'
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, directionStyle), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(itemCls, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(itemCls, "-active"), active), "".concat(itemCls, "-selected"), selected), "".concat(itemCls, "-disabled"), mergedDisabled), className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $jMaZ8.createElement((0, $cd65dc3cb30ec71f$export$2e2bcd8739ae039), {
        props: (0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
            isSelected: selected
        }),
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $77bbeaacfd0ea5eb$var$MenuItem(props, ref) {
    var eventKey = props.eventKey;
    // ==================== Record KeyPath ====================
    var measure = (0, $69440eab1161c178$export$e295b0c537d32d7d)();
    var connectedKeyPath = (0, $69440eab1161c178$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $jMaZ8.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $jMaZ8.createElement($77bbeaacfd0ea5eb$var$InternalMenuItem, (0, $hH60s.default)({}, props, {
        ref: ref
    }));
}
var $77bbeaacfd0ea5eb$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.forwardRef($77bbeaacfd0ea5eb$var$MenuItem);



var $eq8kl = parcelRequire("eq8kl");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $2bFmQ = parcelRequire("2bFmQ");

var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $9d736aaa28ebe29f$var$_excluded = [
    "className",
    "children"
];
var $9d736aaa28ebe29f$var$InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
    var className = _ref.className, children = _ref.children, restProps = (0, $4b02Q.default)(_ref, $9d736aaa28ebe29f$var$_excluded);
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
    return /*#__PURE__*/ $jMaZ8.createElement("ul", (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === 'inline' ? 'inline' : 'vertical'), className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
var $9d736aaa28ebe29f$var$SubMenuList = /*#__PURE__*/ $jMaZ8.forwardRef($9d736aaa28ebe29f$var$InternalSubMenuList);
$9d736aaa28ebe29f$var$SubMenuList.displayName = 'SubMenuList';
var $9d736aaa28ebe29f$export$2e2bcd8739ae039 = $9d736aaa28ebe29f$var$SubMenuList;



var $fvBso = parcelRequire("fvBso");

var $a6yuN = parcelRequire("a6yuN");

var $jMaZ8 = parcelRequire("jMaZ8");
function $ac3abc9b856e9614$export$cd230e97e668be9(children, keyPath) {
    return (0, $a6yuN.default)(children).map(function(child, index) {
        if (/*#__PURE__*/ $jMaZ8.isValidElement(child)) {
            var _eventKey, _child$props;
            var key = child.key;
            var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
            var emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = "tmp_key-".concat([].concat((0, $fvBso.default)(keyPath), [
                index
            ]).join('-'));
            var cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            if (emptyKey) cloneProps.warnKey = true;
            return /*#__PURE__*/ $jMaZ8.cloneElement(child, cloneProps);
        }
        return child;
    });
}





var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");

var $aZxvk = parcelRequire("aZxvk");

var $5cef93da389181d4$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $5cef93da389181d4$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    }
};
var $5cef93da389181d4$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $5cef93da389181d4$var$autoAdjustOverflow
    }
};
var $5cef93da389181d4$export$2e2bcd8739ae039 = $5cef93da389181d4$export$803cd8101b6c182b;


function $1e002b9f85307a3d$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


var $913c5f1272f57dd8$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $913c5f1272f57dd8$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
    var placement = rtl ? (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $5cef93da389181d4$export$e2b3f69b0a16e1f)), builtinPlacements) : (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $5cef93da389181d4$export$803cd8101b6c182b)), builtinPlacements);
    var popupPlacement = $913c5f1272f57dd8$var$popupPlacementMap[mode];
    var targetMotion = (0, $1e002b9f85307a3d$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    var targetMotionRef = $jMaZ8.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    var mergedMotion = (0, $8u3qN.default)((0, $8u3qN.default)({}, targetMotionRef.current), {}, {
        leavedClassName: "".concat(prefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: true
    });
    // Delay to change visible
    var visibleRef = $jMaZ8.useRef();
    $jMaZ8.useEffect(function() {
        visibleRef.current = (0, $aZxvk.default)(function() {
            setInnerVisible(visible);
        });
        return function() {
            (0, $aZxvk.default).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $3e6696c575106f0d$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-popup"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}







var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $lsVqZ = parcelRequire("lsVqZ");



function $f2ab04577cee69a8$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, open = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
    var fixedMode = 'inline';
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
    // Always use latest mode check
    var sameModeRef = $jMaZ8.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    var _React$useState = $jMaZ8.useState(!sameModeRef.current), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), destroy = _React$useState2[0], setDestroy = _React$useState2[1];
    var mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $jMaZ8.useEffect(function() {
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    var mergedMotion = (0, $8u3qN.default)({}, (0, $1e002b9f85307a3d$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions));
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    var originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = function(newVisible) {
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $dfa6c5a76212936b$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), (0, $hH60s.default)({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $9d736aaa28ebe29f$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





var $c8557bbeba2653ba$var$_excluded = [
    "style",
    "className",
    "title",
    "eventKey",
    "warnKey",
    "disabled",
    "internalPopupClose",
    "children",
    "itemIcon",
    "expandIcon",
    "popupClassName",
    "popupOffset",
    "popupStyle",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onTitleClick",
    "onTitleMouseEnter",
    "onTitleMouseLeave"
], $c8557bbeba2653ba$var$_excluded2 = [
    "active"
];
var $c8557bbeba2653ba$var$InternalSubMenu = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var style = props.style, className = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, popupStyle = props.popupStyle, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = (0, $4b02Q.default)(props, $c8557bbeba2653ba$var$_excluded);
    var domDataId = (0, $507b8095eddad637$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
    var _React$useContext2 = $jMaZ8.useContext((0, $7f088c8c7eb1abb0$export$2e2bcd8739ae039)), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
    var _React$useContext3 = $jMaZ8.useContext((0, $69440eab1161c178$export$f0b9e0db98edfa53)), isSubPathKey = _React$useContext3.isSubPathKey;
    var connectedPath = (0, $69440eab1161c178$export$d3d2d0a05677870a)();
    var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
    var mergedDisabled = contextDisabled || disabled;
    var elementRef = $jMaZ8.useRef();
    var popupRef = $jMaZ8.useRef();
    // ================================ Warn ================================
    if (warnKey) (0, $2bFmQ.default)(false, 'SubMenu should not leave undefined `key`.');
    // ================================ Icon ================================
    var mergedItemIcon = itemIcon !== null && itemIcon !== void 0 ? itemIcon : contextItemIcon;
    var mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    // ================================ Open ================================
    var originOpen = openKeys.includes(eventKey);
    var open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    var childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    var _useActive = (0, $9fc80eab149024b3$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = (0, $4b02Q.default)(_useActive, $c8557bbeba2653ba$var$_excluded2);
    // Fallback of active check to avoid hover on menu title or disabled item
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
    var triggerChildrenActive = function triggerChildrenActive(newActive) {
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
        triggerChildrenActive(true);
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
        triggerChildrenActive(false);
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var mergedActive = $jMaZ8.useMemo(function() {
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    var directionStyle = (0, $c251d787306e74c8$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    var onInternalTitleClick = function onInternalTitleClick(e) {
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick === null || onTitleClick === void 0 || onTitleClick({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    var onMergedItemClick = (0, $490280689706561b$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $90fddad3b9b7f015$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus() {
        onActive(eventKey);
    };
    // =============================== Render ===============================
    var popupId = domDataId && "".concat(domDataId, "-popup");
    // >>>>> Title
    var titleNode = /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        role: "menuitem",
        style: directionStyle,
        className: "".concat(subMenuPrefixCls, "-title"),
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, /*#__PURE__*/ $jMaZ8.createElement((0, $cd65dc3cb30ec71f$export$2e2bcd8739ae039), {
        icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
        props: (0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
            isOpen: open,
            // [Legacy] Not sure why need this mark
            isSubMenu: true
        })
    }, /*#__PURE__*/ $jMaZ8.createElement("i", {
        className: "".concat(subMenuPrefixCls, "-arrow")
    })));
    // Cache mode if it change to `inline` which do not have popup motion
    var triggerModeRef = $jMaZ8.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    if (!overflowDisabled) {
        var triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $jMaZ8.createElement((0, $913c5f1272f57dd8$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: /*#__PURE__*/ $jMaZ8.createElement((0, $dfa6c5a76212936b$export$2e2bcd8739ae039), {
                mode: triggerMode === 'horizontal' ? 'vertical' : triggerMode
            }, /*#__PURE__*/ $jMaZ8.createElement((0, $9d736aaa28ebe29f$export$2e2bcd8739ae039), {
                id: popupId,
                ref: popupRef
            }, children)),
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    var listNode = /*#__PURE__*/ $jMaZ8.createElement((0, $7c61136bd8e14ae0$export$2e2bcd8739ae039).Item, (0, $hH60s.default)({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(subMenuPrefixCls, "-open"), open), "".concat(subMenuPrefixCls, "-active"), mergedActive), "".concat(subMenuPrefixCls, "-selected"), childrenSelected), "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled)),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $jMaZ8.createElement((0, $f2ab04577cee69a8$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $jMaZ8.createElement((0, $dfa6c5a76212936b$export$2e2bcd8739ae039), {
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
var $c8557bbeba2653ba$var$SubMenu = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $69440eab1161c178$export$d3d2d0a05677870a)(eventKey);
    var childList = (0, $ac3abc9b856e9614$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    var measure = (0, $69440eab1161c178$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $jMaZ8.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    var renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $jMaZ8.createElement($c8557bbeba2653ba$var$InternalSubMenu, (0, $hH60s.default)({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $69440eab1161c178$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
$c8557bbeba2653ba$var$SubMenu.displayName = 'SubMenu';
var $c8557bbeba2653ba$export$2e2bcd8739ae039 = $c8557bbeba2653ba$var$SubMenu;



var $8u3qN = parcelRequire("8u3qN");

var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


function $8c61135cfe4c0efa$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, style = _ref.style;
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var measure = (0, $69440eab1161c178$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $jMaZ8.createElement("li", {
        role: "separator",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-item-divider"), className),
        style: style
    });
}




var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");

var $jMaZ8 = parcelRequire("jMaZ8");



var $caf0f58125b0bd87$var$_excluded = [
    "className",
    "title",
    "eventKey",
    "children"
];
var $caf0f58125b0bd87$var$InternalMenuItemGroup = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var className = props.className, title = props.title, eventKey = props.eventKey, children = props.children, restProps = (0, $4b02Q.default)(props, $caf0f58125b0bd87$var$_excluded);
    var _React$useContext = $jMaZ8.useContext((0, $dfa6c5a76212936b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var groupPrefixCls = "".concat(prefixCls, "-item-group");
    return /*#__PURE__*/ $jMaZ8.createElement("li", (0, $hH60s.default)({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $jMaZ8.createElement("div", {
        role: "presentation",
        className: "".concat(groupPrefixCls, "-title"),
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $jMaZ8.createElement("ul", {
        role: "group",
        className: "".concat(groupPrefixCls, "-list")
    }, children));
});
var $caf0f58125b0bd87$var$MenuItemGroup = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $69440eab1161c178$export$d3d2d0a05677870a)(eventKey);
    var childList = (0, $ac3abc9b856e9614$export$cd230e97e668be9)(children, connectedKeyPath);
    var measure = (0, $69440eab1161c178$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $jMaZ8.createElement($caf0f58125b0bd87$var$InternalMenuItemGroup, (0, $hH60s.default)({
        ref: ref
    }, (0, $hvG6u.default)(props, [
        'warnKey'
    ])), childList);
});
$caf0f58125b0bd87$var$MenuItemGroup.displayName = 'MenuItemGroup';
var $caf0f58125b0bd87$export$2e2bcd8739ae039 = $caf0f58125b0bd87$var$MenuItemGroup;




var $39772a0b3c27000b$var$_excluded = [
    "label",
    "children",
    "key",
    "type",
    "extra"
];
function $39772a0b3c27000b$var$convertItemsToNodes(list, components, prefixCls) {
    var MergedMenuItem = components.item, MergedMenuItemGroup = components.group, MergedSubMenu = components.submenu, MergedDivider = components.divider;
    return (list || []).map(function(opt, index) {
        if (opt && (0, $1Esi2.default)(opt) === 'object') {
            var _ref = opt, label = _ref.label, children = _ref.children, key = _ref.key, type = _ref.type, extra = _ref.extra, restProps = (0, $4b02Q.default)(_ref, $39772a0b3c27000b$var$_excluded);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $jMaZ8.createElement(MergedMenuItemGroup, (0, $hH60s.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $39772a0b3c27000b$var$convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                return /*#__PURE__*/ $jMaZ8.createElement(MergedSubMenu, (0, $hH60s.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $39772a0b3c27000b$var$convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $jMaZ8.createElement(MergedDivider, (0, $hH60s.default)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $jMaZ8.createElement(MergedMenuItem, (0, $hH60s.default)({
                key: mergedKey
            }, restProps, {
                extra: extra
            }), label, (!!extra || extra === 0) && /*#__PURE__*/ $jMaZ8.createElement("span", {
                className: "".concat(prefixCls, "-item-extra")
            }, extra));
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $39772a0b3c27000b$export$50458dc1a9a0f894(children, items, keyPath, components, prefixCls) {
    var childNodes = children;
    var mergedComponents = (0, $8u3qN.default)({
        divider: (0, $8c61135cfe4c0efa$export$2e2bcd8739ae039),
        item: (0, $77bbeaacfd0ea5eb$export$2e2bcd8739ae039),
        group: (0, $caf0f58125b0bd87$export$2e2bcd8739ae039),
        submenu: (0, $c8557bbeba2653ba$export$2e2bcd8739ae039)
    }, components);
    if (items) childNodes = $39772a0b3c27000b$var$convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, $ac3abc9b856e9614$export$cd230e97e668be9)(childNodes, keyPath);
}



var $7c9e1bb1fd6e7723$var$_excluded = [
    "prefixCls",
    "rootClassName",
    "style",
    "className",
    "tabIndex",
    "items",
    "children",
    "direction",
    "id",
    "mode",
    "inlineCollapsed",
    "disabled",
    "disabledOverflow",
    "subMenuOpenDelay",
    "subMenuCloseDelay",
    "forceSubMenuRender",
    "defaultOpenKeys",
    "openKeys",
    "activeKey",
    "defaultActiveFirst",
    "selectable",
    "multiple",
    "defaultSelectedKeys",
    "selectedKeys",
    "onSelect",
    "onDeselect",
    "inlineIndent",
    "motion",
    "defaultMotions",
    "triggerSubMenuAction",
    "builtinPlacements",
    "itemIcon",
    "expandIcon",
    "overflowedIndicator",
    "overflowedIndicatorPopupClassName",
    "getPopupContainer",
    "onClick",
    "onOpenChange",
    "onKeyDown",
    "openAnimation",
    "openTransitionName",
    "_internalRenderMenuItem",
    "_internalRenderSubMenuItem",
    "_internalComponents"
];
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
var $7c9e1bb1fd6e7723$var$EMPTY_LIST = [];
var $7c9e1bb1fd6e7723$var$Menu = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var _childList$;
    var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-menu' : _ref$prefixCls, rootClassName = _ref.rootClassName, style = _ref.style, className = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'vertical' : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? 'hover' : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? '...' : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, _internalComponents = _ref._internalComponents, restProps = (0, $4b02Q.default)(_ref, $7c9e1bb1fd6e7723$var$_excluded);
    var _React$useMemo = $jMaZ8.useMemo(function() {
        return [
            (0, $39772a0b3c27000b$export$50458dc1a9a0f894)(children, items, $7c9e1bb1fd6e7723$var$EMPTY_LIST, _internalComponents, prefixCls),
            (0, $39772a0b3c27000b$export$50458dc1a9a0f894)(children, items, $7c9e1bb1fd6e7723$var$EMPTY_LIST, {}, prefixCls)
        ];
    }, [
        children,
        items,
        _internalComponents
    ]), _React$useMemo2 = (0, $3fkx6.default)(_React$useMemo, 2), childList = _React$useMemo2[0], measureChildList = _React$useMemo2[1];
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
    var containerRef = $jMaZ8.useRef();
    var uuid = (0, $7a483875f364afaa$export$2e2bcd8739ae039)(id);
    var isRtl = direction === 'rtl';
    (0, $2bFmQ.default)(!openAnimation && !openTransitionName, '`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.');
    // ========================= Open =========================
    var _useMergedState = (0, $eGh7a.default)(defaultOpenKeys, {
        value: openKeys,
        postState: function postState(keys) {
            return keys || $7c9e1bb1fd6e7723$var$EMPTY_LIST;
        }
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    var triggerOpenKeys = function triggerOpenKeys(keys) {
        var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
        }
        if (forceFlush) (0, $6UWRi.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    var _React$useState3 = $jMaZ8.useState(mergedOpenKeys), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
    var mountRef = $jMaZ8.useRef(false);
    // ========================= Mode =========================
    var _React$useMemo3 = $jMaZ8.useMemo(function() {
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]), _React$useMemo4 = (0, $3fkx6.default)(_React$useMemo3, 2), mergedMode = _React$useMemo4[0], mergedInlineCollapsed = _React$useMemo4[1];
    var isInlineMode = mergedMode === 'inline';
    var _React$useState5 = $jMaZ8.useState(mergedMode), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
    var _React$useState7 = $jMaZ8.useState(mergedInlineCollapsed), _React$useState8 = (0, $3fkx6.default)(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
    $jMaZ8.useEffect(function() {
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($7c9e1bb1fd6e7723$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    var _React$useState9 = $jMaZ8.useState(0), _React$useState10 = (0, $3fkx6.default)(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
    var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $jMaZ8.useEffect(function() {
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $jMaZ8.useEffect(function() {
        mountRef.current = true;
        return function() {
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    var _useKeyRecords = (0, $11cdd9e432f43aef$export$2e2bcd8739ae039)(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
    var registerPathContext = $jMaZ8.useMemo(function() {
        return {
            registerPath: registerPath,
            unregisterPath: unregisterPath
        };
    }, [
        registerPath,
        unregisterPath
    ]);
    var pathUserContext = $jMaZ8.useMemo(function() {
        return {
            isSubPathKey: isSubPathKey
        };
    }, [
        isSubPathKey
    ]);
    $jMaZ8.useEffect(function() {
        refreshOverflowKeys(allVisible ? $7c9e1bb1fd6e7723$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function(child) {
            return child.key;
        }));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    var _useMergedState3 = (0, $eGh7a.default)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
        value: activeKey
    }), _useMergedState4 = (0, $3fkx6.default)(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
    var onActive = (0, $490280689706561b$export$2e2bcd8739ae039)(function(key) {
        setMergedActiveKey(key);
    });
    var onInactive = (0, $490280689706561b$export$2e2bcd8739ae039)(function() {
        setMergedActiveKey(undefined);
    });
    (0, $jMaZ8.useImperativeHandle)(ref, function() {
        return {
            list: containerRef.current,
            focus: function focus(options) {
                var _childList$find;
                var keys = getKeys();
                var _refreshElements = (0, $ca370a65762bf56a$export$20827b68c762d23)(keys, uuid), elements = _refreshElements.elements, key2element = _refreshElements.key2element, element2key = _refreshElements.element2key;
                var focusableElements = (0, $ca370a65762bf56a$export$433aaa1f216cf32d)(containerRef.current, elements);
                var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : focusableElements[0] ? element2key.get(focusableElements[0]) : (_childList$find = childList.find(function(node) {
                    return !node.props.disabled;
                })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
                var elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) {
                    var _elementToFocus$focus;
                    elementToFocus === null || elementToFocus === void 0 || (_elementToFocus$focus = elementToFocus.focus) === null || _elementToFocus$focus === void 0 || _elementToFocus$focus.call(elementToFocus, options);
                }
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    var _useMergedState5 = (0, $eGh7a.default)(defaultSelectedKeys || [], {
        value: selectedKeys,
        // Legacy convert key to array
        postState: function postState(keys) {
            if (Array.isArray(keys)) return keys;
            if (keys === null || keys === undefined) return $7c9e1bb1fd6e7723$var$EMPTY_LIST;
            return [
                keys
            ];
        }
    }), _useMergedState6 = (0, $3fkx6.default)(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
    // >>>>> Trigger select
    var triggerSelection = function triggerSelection(info) {
        if (selectable) {
            // Insert or Remove
            var targetKey = info.key;
            var exist = mergedSelectKeys.includes(targetKey);
            var newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter(function(key) {
                    return key !== targetKey;
                });
                else newSelectKeys = [].concat((0, $fvBso.default)(mergedSelectKeys), [
                    targetKey
                ]);
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            var selectInfo = (0, $8u3qN.default)((0, $8u3qN.default)({}, info), {}, {
                selectedKeys: newSelectKeys
            });
            if (exist) onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
            else onSelect === null || onSelect === void 0 || onSelect(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($7c9e1bb1fd6e7723$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ var onInternalClick = (0, $490280689706561b$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $90fddad3b9b7f015$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    var onInternalOpenChange = (0, $490280689706561b$export$2e2bcd8739ae039)(function(key, open) {
        var newOpenKeys = mergedOpenKeys.filter(function(k) {
            return k !== key;
        });
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            var subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter(function(k) {
                return !subPathKeys.has(k);
            });
        }
        if (!(0, $9O5K3.default)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
        var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    var onInternalKeyDown = (0, $ca370a65762bf56a$export$aa6de64279d64603)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $jMaZ8.useEffect(function() {
        setMounted(true);
    }, []);
    // ======================= Context ========================
    var privateContext = $jMaZ8.useMemo(function() {
        return {
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        };
    }, [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    var wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index) {
        return(/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $jMaZ8.createElement((0, $dfa6c5a76212936b$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex
        }, child));
    });
    // >>>>> Container
    var container = /*#__PURE__*/ $jMaZ8.createElement((0, $7c61136bd8e14ae0$export$2e2bcd8739ae039), (0, $hH60s.default)({
        id: id,
        ref: containerRef,
        prefixCls: "".concat(prefixCls, "-overflow"),
        component: "ul",
        itemComponent: (0, $77bbeaacfd0ea5eb$export$2e2bcd8739ae039),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), "".concat(prefixCls, "-rtl"), isRtl), rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: function renderRawItem(node) {
            return node;
        },
        renderRawRest: function renderRawRest(omitItems) {
            // We use origin list since wrapped list use context to prevent open
            var len = omitItems.length;
            var originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $jMaZ8.createElement((0, $c8557bbeba2653ba$export$2e2bcd8739ae039), {
                eventKey: (0, $11cdd9e432f43aef$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $7c61136bd8e14ae0$export$2e2bcd8739ae039).INVALIDATE : (0, $7c61136bd8e14ae0$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: function onVisibleChange(newLastIndex) {
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $jMaZ8.createElement((0, $7f088c8c7eb1abb0$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $507b8095eddad637$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $dfa6c5a76212936b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $69440eab1161c178$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $69440eab1161c178$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $7c9e1bb1fd6e7723$export$2e2bcd8739ae039 = $7c9e1bb1fd6e7723$var$Menu;







var $f8c4d030e21306d3$var$ExportMenu = (0, $7c9e1bb1fd6e7723$export$2e2bcd8739ae039);
$f8c4d030e21306d3$var$ExportMenu.Item = (0, $77bbeaacfd0ea5eb$export$2e2bcd8739ae039);
$f8c4d030e21306d3$var$ExportMenu.SubMenu = (0, $c8557bbeba2653ba$export$2e2bcd8739ae039);
$f8c4d030e21306d3$var$ExportMenu.ItemGroup = (0, $caf0f58125b0bd87$export$2e2bcd8739ae039);
$f8c4d030e21306d3$var$ExportMenu.Divider = (0, $8c61135cfe4c0efa$export$2e2bcd8739ae039);
var $f8c4d030e21306d3$export$2e2bcd8739ae039 = $f8c4d030e21306d3$var$ExportMenu;




var $jMaZ8 = parcelRequire("jMaZ8");


var $9999881682428ae7$var$OperationNode = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, id = props.id, tabs = props.tabs, locale = props.locale, mobile = props.mobile, _props$more = props.more, moreProps = _props$more === void 0 ? {} : _props$more, style = props.style, className = props.className, editable = props.editable, tabBarGutter = props.tabBarGutter, rtl = props.rtl, removeAriaLabel = props.removeAriaLabel, onTabClick = props.onTabClick, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName;
    // ======================== Dropdown ========================
    var _useState = (0, $jMaZ8.useState)(false), _useState2 = (0, $3fkx6.default)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, $jMaZ8.useState)(null), _useState4 = (0, $3fkx6.default)(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
    var _moreProps$icon = moreProps.icon, moreIcon = _moreProps$icon === void 0 ? 'More' : _moreProps$icon;
    var popupId = "".concat(id, "-more-popup");
    var dropdownPrefix = "".concat(prefixCls, "-dropdown");
    var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
    var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    var menu = /*#__PURE__*/ $jMaZ8.createElement((0, $f8c4d030e21306d3$export$2e2bcd8739ae039), {
        onClick: function onClick(_ref) {
            var key = _ref.key, domEvent = _ref.domEvent;
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: "".concat(dropdownPrefix, "-menu"),
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
    }, tabs.map(function(tab) {
        var closable = tab.closable, disabled = tab.disabled, closeIcon = tab.closeIcon, key = tab.key, label = tab.label;
        var removable = (0, $fe114a8290e39582$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $77bbeaacfd0ea5eb$export$2e2bcd8739ae039), {
            key: key,
            id: "".concat(popupId, "-").concat(key),
            role: "option",
            "aria-controls": id && "".concat(id, "-panel-").concat(key),
            disabled: disabled
        }, /*#__PURE__*/ $jMaZ8.createElement("span", null, label), removable && /*#__PURE__*/ $jMaZ8.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || 'remove',
            tabIndex: 0,
            className: "".concat(dropdownPrefix, "-menu-item-remove"),
            onClick: function onClick(e) {
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        var enabledTabs = tabs.filter(function(tab) {
            return !tab.disabled;
        });
        var selectedIndex = enabledTabs.findIndex(function(tab) {
            return tab.key === selectedKey;
        }) || 0;
        var len = enabledTabs.length;
        for(var i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            var tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        var which = e.which;
        if (!open) {
            if ([
                (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN,
                (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).SPACE,
                (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).SPACE:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $jMaZ8.useEffect)(function() {
        // We use query element here to avoid React strict warning
        var ele = document.getElementById(selectedItemId);
        if (ele && ele.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedKey
    ]);
    (0, $jMaZ8.useEffect)(function() {
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    var moreStyle = (0, $eq8kl.default)({}, rtl ? 'marginRight' : 'marginLeft', tabBarGutter);
    if (!tabs.length) {
        moreStyle.visibility = 'hidden';
        moreStyle.order = 1;
    }
    var overlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((0, $eq8kl.default)({}, "".concat(dropdownPrefix, "-rtl"), rtl));
    var moreNode = mobile ? null : /*#__PURE__*/ $jMaZ8.createElement((0, $5b2f2e9aebf27f9d$export$2e2bcd8739ae039), (0, $hH60s.default)({
        prefixCls: dropdownPrefix,
        overlay: menu,
        visible: tabs.length ? open : false,
        onVisibleChange: setOpen,
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(overlayClassName, popupClassName),
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, moreProps), /*#__PURE__*/ $jMaZ8.createElement("button", {
        type: "button",
        className: "".concat(prefixCls, "-nav-more"),
        style: moreStyle,
        tabIndex: -1,
        "aria-hidden": "true",
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: "".concat(id, "-more"),
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-nav-operations"), className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $jMaZ8.createElement((0, $49bd0dc7fb6cbb9b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $9999881682428ae7$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.memo($9999881682428ae7$var$OperationNode, function(_, next) {
    return(// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);
});



var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");

var $ca2d5408e930724b$var$TabNode = function TabNode(props) {
    var prefixCls = props.prefixCls, id = props.id, active = props.active, focus = props.focus, _props$tab = props.tab, key = _props$tab.key, label = _props$tab.label, disabled = _props$tab.disabled, closeIcon = _props$tab.closeIcon, icon = _props$tab.icon, closable = props.closable, renderWrapper = props.renderWrapper, removeAriaLabel = props.removeAriaLabel, editable = props.editable, onClick = props.onClick, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, style = props.style, tabCount = props.tabCount, currentPosition = props.currentPosition;
    var tabPrefix = "".concat(prefixCls, "-tab");
    var removable = (0, $fe114a8290e39582$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    var labelNode = $jMaZ8.useMemo(function() {
        return icon && typeof label === 'string' ? /*#__PURE__*/ $jMaZ8.createElement("span", null, label) : label;
    }, [
        label,
        icon
    ]);
    var btnRef = $jMaZ8.useRef(null);
    $jMaZ8.useEffect(function() {
        if (focus && btnRef.current) btnRef.current.focus();
    }, [
        focus
    ]);
    var node = /*#__PURE__*/ $jMaZ8.createElement("div", {
        key: key,
        "data-node-key": (0, $fe114a8290e39582$export$c55417729a96230c)(key),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(tabPrefix, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(tabPrefix, "-with-remove"), removable), "".concat(tabPrefix, "-active"), active), "".concat(tabPrefix, "-disabled"), disabled), "".concat(tabPrefix, "-focus"), focus)),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: btnRef,
        role: "tab",
        "aria-selected": active,
        id: id && "".concat(id, "-tab-").concat(key),
        className: "".concat(tabPrefix, "-btn"),
        "aria-controls": id && "".concat(id, "-panel-").concat(key),
        "aria-disabled": disabled,
        tabIndex: disabled ? null : active ? 0 : -1,
        onClick: function onClick(e) {
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onFocus: onFocus,
        onBlur: onBlur
    }, focus && /*#__PURE__*/ $jMaZ8.createElement("div", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, "Tab ".concat(currentPosition, " of ").concat(tabCount)), icon && /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(tabPrefix, "-icon")
    }, icon), label && labelNode), removable && /*#__PURE__*/ $jMaZ8.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || 'remove',
        tabIndex: active ? 0 : -1,
        className: "".concat(tabPrefix, "-remove"),
        onClick: function onClick(e) {
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $ca2d5408e930724b$export$2e2bcd8739ae039 = $ca2d5408e930724b$var$TabNode;


var $40f380d4f9cce4c8$var$getTabSize = function getTabSize(tab, containerRect) {
    // tabListRef
    var offsetWidth = tab.offsetWidth, offsetHeight = tab.offsetHeight, offsetTop = tab.offsetTop, offsetLeft = tab.offsetLeft;
    var _tab$getBoundingClien = tab.getBoundingClientRect(), width = _tab$getBoundingClien.width, height = _tab$getBoundingClien.height, left = _tab$getBoundingClien.left, top = _tab$getBoundingClien.top;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        left - containerRect.left,
        top - containerRect.top
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
var $40f380d4f9cce4c8$var$getSize = function getSize(refObj) {
    var _ref = refObj.current || {}, _ref$offsetWidth = _ref.offsetWidth, offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth, _ref$offsetHeight = _ref.offsetHeight, offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        var _refObj$current$getBo = refObj.current.getBoundingClientRect(), width = _refObj$current$getBo.width, height = _refObj$current$getBo.height;
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ var $40f380d4f9cce4c8$var$getUnitValue = function getUnitValue(size, tabPositionTopOrBottom) {
    return size[tabPositionTopOrBottom ? 0 : 1];
};
var $40f380d4f9cce4c8$var$TabNavList = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var className = props.className, style = props.style, id = props.id, animated = props.animated, activeKey = props.activeKey, rtl = props.rtl, extra = props.extra, editable = props.editable, locale = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, indicator = props.indicator;
    var _React$useContext = $jMaZ8.useContext((0, $f11dc1150de29c3e$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var containerRef = (0, $jMaZ8.useRef)(null);
    var extraLeftRef = (0, $jMaZ8.useRef)(null);
    var extraRightRef = (0, $jMaZ8.useRef)(null);
    var tabsWrapperRef = (0, $jMaZ8.useRef)(null);
    var tabListRef = (0, $jMaZ8.useRef)(null);
    var operationsRef = (0, $jMaZ8.useRef)(null);
    var innerAddButtonRef = (0, $jMaZ8.useRef)(null);
    var tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';
    var _useSyncState = (0, $5a3dcdb59e5494cc$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'left' : 'right'
        });
    }), _useSyncState2 = (0, $3fkx6.default)(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
    var _useSyncState3 = (0, $5a3dcdb59e5494cc$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'top' : 'bottom'
        });
    }), _useSyncState4 = (0, $3fkx6.default)(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
    var _useState = (0, $jMaZ8.useState)([
        0,
        0
    ]), _useState2 = (0, $3fkx6.default)(_useState, 2), containerExcludeExtraSize = _useState2[0], setContainerExcludeExtraSize = _useState2[1];
    var _useState3 = (0, $jMaZ8.useState)([
        0,
        0
    ]), _useState4 = (0, $3fkx6.default)(_useState3, 2), tabContentSize = _useState4[0], setTabContentSize = _useState4[1];
    var _useState5 = (0, $jMaZ8.useState)([
        0,
        0
    ]), _useState6 = (0, $3fkx6.default)(_useState5, 2), addSize = _useState6[0], setAddSize = _useState6[1];
    var _useState7 = (0, $jMaZ8.useState)([
        0,
        0
    ]), _useState8 = (0, $3fkx6.default)(_useState7, 2), operationSize = _useState8[0], setOperationSize = _useState8[1];
    var _useUpdateState = (0, $73b7747ed999888f$export$aefd2a30eb6d999e)(new Map()), _useUpdateState2 = (0, $3fkx6.default)(_useUpdateState, 2), tabSizes = _useUpdateState2[0], setTabSizes = _useUpdateState2[1];
    var tabOffsets = (0, $dc069e2f35db9d88$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    var containerExcludeExtraSizeValue = $40f380d4f9cce4c8$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    var tabContentSizeValue = $40f380d4f9cce4c8$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    var addSizeValue = $40f380d4f9cce4c8$var$getUnitValue(addSize, tabPositionTopOrBottom);
    var operationSizeValue = $40f380d4f9cce4c8$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    var needScroll = Math.floor(containerExcludeExtraSizeValue) < Math.floor(tabContentSizeValue + addSizeValue);
    var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
    var transformMin = 0;
    var transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    var touchMovingRef = (0, $jMaZ8.useRef)(null);
    var _useState9 = (0, $jMaZ8.useState)(), _useState10 = (0, $3fkx6.default)(_useState9, 2), lockAnimation = _useState10[0], setLockAnimation = _useState10[1];
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $99a673ceb1e29b66$export$2e2bcd8739ae039)(tabsWrapperRef, function(offsetX, offsetY) {
        function doMove(setState, offset) {
            setState(function(value) {
                var newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $jMaZ8.useEffect)(function() {
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(function() {
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    var _useVisibleRange = (0, $4da6fe0d0b5d3b3a$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, (0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
        tabs: tabs
    })), _useVisibleRange2 = (0, $3fkx6.default)(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
    // ========================= Scroll ========================
    var scrollToTab = (0, $ktS49.default)(function() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
        var tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            var newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            var _newTransform = transformTop;
            if (tabOffset.top < -transformTop) _newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(_newTransform));
        }
    });
    // ========================= Focus =========================
    var _useState11 = (0, $jMaZ8.useState)(), _useState12 = (0, $3fkx6.default)(_useState11, 2), focusKey = _useState12[0], setFocusKey = _useState12[1];
    var _useState13 = (0, $jMaZ8.useState)(false), _useState14 = (0, $3fkx6.default)(_useState13, 2), isMouse = _useState14[0], setIsMouse = _useState14[1];
    var enabledTabs = tabs.filter(function(tab) {
        return !tab.disabled;
    }).map(function(tab) {
        return tab.key;
    });
    var onOffset = function onOffset(offset) {
        var currentIndex = enabledTabs.indexOf(focusKey || activeKey);
        var len = enabledTabs.length;
        var nextIndex = (currentIndex + offset + len) % len;
        var newKey = enabledTabs[nextIndex];
        setFocusKey(newKey);
    };
    var handleKeyDown = function handleKeyDown(e) {
        var code = e.code;
        var isRTL = rtl && tabPositionTopOrBottom;
        var firstEnabledTab = enabledTabs[0];
        var lastEnabledTab = enabledTabs[enabledTabs.length - 1];
        switch(code){
            // LEFT
            case 'ArrowLeft':
                if (tabPositionTopOrBottom) onOffset(isRTL ? 1 : -1);
                break;
            // RIGHT
            case 'ArrowRight':
                if (tabPositionTopOrBottom) onOffset(isRTL ? -1 : 1);
                break;
            // UP
            case 'ArrowUp':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(-1);
                break;
            // DOWN
            case 'ArrowDown':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(1);
                break;
            // HOME
            case 'Home':
                e.preventDefault();
                setFocusKey(firstEnabledTab);
                break;
            // END
            case 'End':
                e.preventDefault();
                setFocusKey(lastEnabledTab);
                break;
            // Enter & Space
            case 'Enter':
            case 'Space':
                e.preventDefault();
                onTabClick(focusKey, e);
                break;
            // Backspace
            case 'Backspace':
            case 'Delete':
                var removeIndex = enabledTabs.indexOf(focusKey);
                var removeTab = tabs.find(function(tab) {
                    return tab.key === focusKey;
                });
                var removable = (0, $fe114a8290e39582$export$eab31ca11b8b073)(removeTab === null || removeTab === void 0 ? void 0 : removeTab.closable, removeTab === null || removeTab === void 0 ? void 0 : removeTab.closeIcon, editable, removeTab === null || removeTab === void 0 ? void 0 : removeTab.disabled);
                if (removable) {
                    e.preventDefault();
                    e.stopPropagation();
                    editable.onEdit('remove', {
                        key: focusKey,
                        event: e
                    });
                    // when remove last tab, focus previous tab
                    if (removeIndex === enabledTabs.length - 1) onOffset(-1);
                    else onOffset(1);
                }
                break;
        }
    };
    // ========================== Tab ==========================
    var tabNodeStyle = {};
    if (tabPositionTopOrBottom) tabNodeStyle[rtl ? 'marginRight' : 'marginLeft'] = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    var tabNodes = tabs.map(function(tab, i) {
        var key = tab.key;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $ca2d5408e930724b$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            style: i === 0 ? undefined : tabNodeStyle,
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            focus: key === focusKey,
            renderWrapper: children,
            removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
            tabCount: enabledTabs.length,
            currentPosition: i + 1,
            onClick: function onClick(e) {
                onTabClick(key, e);
            },
            onKeyDown: handleKeyDown,
            onFocus: function onFocus() {
                if (!isMouse) setFocusKey(key);
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            },
            onBlur: function onBlur() {
                setFocusKey(undefined);
            },
            onMouseDown: function onMouseDown() {
                setIsMouse(true);
            },
            onMouseUp: function onMouseUp() {
                setIsMouse(false);
            }
        });
    });
    // Update buttons records
    var updateTabSizes = function updateTabSizes() {
        return setTabSizes(function() {
            var _tabListRef$current;
            var newSizes = new Map();
            var listRect = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.getBoundingClientRect();
            tabs.forEach(function(_ref2) {
                var _tabListRef$current2;
                var key = _ref2.key;
                var btnNode = (_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.querySelector("[data-node-key=\"".concat((0, $fe114a8290e39582$export$c55417729a96230c)(key), "\"]"));
                if (btnNode) {
                    var _getTabSize = $40f380d4f9cce4c8$var$getTabSize(btnNode, listRect), _getTabSize2 = (0, $3fkx6.default)(_getTabSize, 4), width = _getTabSize2[0], height = _getTabSize2[1], left = _getTabSize2[2], top = _getTabSize2[3];
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    };
    (0, $jMaZ8.useEffect)(function() {
        updateTabSizes();
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_')
    ]);
    var onListHolderResize = (0, $73b7747ed999888f$export$2e2bcd8739ae039)(function() {
        // Update wrapper records
        var containerSize = $40f380d4f9cce4c8$var$getSize(containerRef);
        var extraLeftSize = $40f380d4f9cce4c8$var$getSize(extraLeftRef);
        var extraRightSize = $40f380d4f9cce4c8$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        var newAddSize = $40f380d4f9cce4c8$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        var newOperationSize = $40f380d4f9cce4c8$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        var tabContentFullSize = $40f380d4f9cce4c8$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    var startHiddenTabs = tabs.slice(0, visibleStart);
    var endHiddenTabs = tabs.slice(visibleEnd + 1);
    var hiddenTabs = [].concat((0, $fvBso.default)(startHiddenTabs), (0, $fvBso.default)(endHiddenTabs));
    // =================== Link & Operations ===================
    var activeTabOffset = tabOffsets.get(activeKey);
    var _useIndicator = (0, $0658c6601d9e077d$export$2e2bcd8739ae039)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        indicator: indicator,
        rtl: rtl
    }), indicatorStyle = _useIndicator.style;
    // ========================= Effect ========================
    (0, $jMaZ8.useEffect)(function() {
        scrollToTab();
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $fe114a8290e39582$export$fac44ee5b035f737)(activeTabOffset),
        (0, $fe114a8290e39582$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $jMaZ8.useEffect)(function() {
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    var hasDropdown = !!hiddenTabs.length;
    var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
    var pingLeft;
    var pingRight;
    var pingTop;
    var pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: (0, $1cfGC.useComposeRef)(ref, containerRef),
        role: "tablist",
        "aria-orientation": tabPositionTopOrBottom ? 'horizontal' : 'vertical',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-nav"), className),
        style: style,
        onKeyDown: function onKeyDown() {
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $289e78a381db8a06$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(wrapPrefix, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(wrapPrefix, "-ping-left"), pingLeft), "".concat(wrapPrefix, "-ping-right"), pingRight), "".concat(wrapPrefix, "-ping-top"), pingTop), "".concat(wrapPrefix, "-ping-bottom"), pingBottom)),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: tabListRef,
        className: "".concat(prefixCls, "-nav-list"),
        style: {
            transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
            transition: lockAnimation ? 'none' : undefined
        }
    }, tabNodes, /*#__PURE__*/ $jMaZ8.createElement((0, $49bd0dc7fb6cbb9b$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, tabNodes.length === 0 ? undefined : tabNodeStyle), {}, {
            visibility: hasDropdown ? 'hidden' : null
        })
    }), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-ink-bar"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
        style: indicatorStyle
    }))))), /*#__PURE__*/ $jMaZ8.createElement((0, $9999881682428ae7$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $jMaZ8.createElement((0, $289e78a381db8a06$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $40f380d4f9cce4c8$export$2e2bcd8739ae039 = $40f380d4f9cce4c8$var$TabNavList;




var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $4a9db5d12cdf93e0$var$TabPane = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, id = props.id, active = props.active, tabKey = props.tabKey, children = props.children;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        id: id && "".concat(id, "-panel-").concat(tabKey),
        role: "tabpanel",
        tabIndex: active ? 0 : -1,
        "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
        "aria-hidden": !active,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, active && "".concat(prefixCls, "-active"), className),
        ref: ref
    }, children);
});
$4a9db5d12cdf93e0$var$TabPane.displayName = 'TabPane';
var $4a9db5d12cdf93e0$export$2e2bcd8739ae039 = $4a9db5d12cdf93e0$var$TabPane;


var $af769fe8ccfec0f1$var$_excluded = [
    "renderTabBar"
], $af769fe8ccfec0f1$var$_excluded2 = [
    "label",
    "key"
];
// We have to create a TabNavList components.
var $af769fe8ccfec0f1$var$TabNavListWrapper = function TabNavListWrapper(_ref) {
    var renderTabBar = _ref.renderTabBar, restProps = (0, $4b02Q.default)(_ref, $af769fe8ccfec0f1$var$_excluded);
    var _React$useContext = $jMaZ8.useContext((0, $f11dc1150de29c3e$export$2e2bcd8739ae039)), tabs = _React$useContext.tabs;
    if (renderTabBar) {
        var tabNavBarProps = (0, $8u3qN.default)((0, $8u3qN.default)({}, restProps), {}, {
            // Legacy support. We do not use this actually
            panes: tabs.map(function(_ref2) {
                var label = _ref2.label, key = _ref2.key, restTabProps = (0, $4b02Q.default)(_ref2, $af769fe8ccfec0f1$var$_excluded2);
                return /*#__PURE__*/ $jMaZ8.createElement((0, $4a9db5d12cdf93e0$export$2e2bcd8739ae039), (0, $hH60s.default)({
                    tab: label,
                    key: key,
                    tabKey: key
                }, restTabProps));
            })
        });
        return renderTabBar(tabNavBarProps, (0, $40f380d4f9cce4c8$export$2e2bcd8739ae039));
    }
    return /*#__PURE__*/ $jMaZ8.createElement((0, $40f380d4f9cce4c8$export$2e2bcd8739ae039), restProps);
};
$af769fe8ccfec0f1$var$TabNavListWrapper.displayName = 'TabNavListWrapper';
var $af769fe8ccfec0f1$export$2e2bcd8739ae039 = $af769fe8ccfec0f1$var$TabNavListWrapper;



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");

var $jMaZ8 = parcelRequire("jMaZ8");


var $9e67a2181309f69a$var$_excluded = [
    "key",
    "forceRender",
    "style",
    "className",
    "destroyInactiveTabPane"
];
var $9e67a2181309f69a$var$TabPanelList = function TabPanelList(props) {
    var id = props.id, activeKey = props.activeKey, animated = props.animated, tabPosition = props.tabPosition, destroyInactiveTabPane = props.destroyInactiveTabPane;
    var _React$useContext = $jMaZ8.useContext((0, $f11dc1150de29c3e$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var tabPaneAnimated = animated.tabPane;
    var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content-holder"))
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), (0, $eq8kl.default)({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
    }, tabs.map(function(item) {
        var key = item.key, forceRender = item.forceRender, paneStyle = item.style, paneClassName = item.className, itemDestroyInactiveTabPane = item.destroyInactiveTabPane, restTabProps = (0, $4b02Q.default)(item, $9e67a2181309f69a$var$_excluded);
        var active = key === activeKey;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), (0, $hH60s.default)({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyInactiveTabPane || itemDestroyInactiveTabPane),
            leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
        }, animated.tabPaneMotion), function(_ref, ref) {
            var motionStyle = _ref.style, motionClassName = _ref.className;
            return /*#__PURE__*/ $jMaZ8.createElement((0, $4a9db5d12cdf93e0$export$2e2bcd8739ae039), (0, $hH60s.default)({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: (0, $8u3qN.default)((0, $8u3qN.default)({}, paneStyle), motionStyle),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(paneClassName, motionClassName),
                ref: ref
            }));
        });
    })));
};
var $9e67a2181309f69a$export$2e2bcd8739ae039 = $9e67a2181309f69a$var$TabPanelList;



var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $2bFmQ = parcelRequire("2bFmQ");
function $16cc92fce7de9bc7$export$2e2bcd8739ae039() {
    var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = (0, $8u3qN.default)({
        inkBar: true
    }, (0, $1Esi2.default)(animated) === 'object' ? animated : {});
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) {
        (0, $2bFmQ.default)(false, '`animated.tabPane` is true but `animated.tabPaneMotion` is not provided. Motion will not work.');
        mergedAnimated.tabPane = false;
    }
    return mergedAnimated;
}


var $54e7c8284494f1a4$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "items",
    "direction",
    "activeKey",
    "defaultActiveKey",
    "editable",
    "animated",
    "tabPosition",
    "tabBarGutter",
    "tabBarStyle",
    "tabBarExtraContent",
    "locale",
    "more",
    "destroyInactiveTabPane",
    "renderTabBar",
    "onChange",
    "onTabClick",
    "onTabScroll",
    "getPopupContainer",
    "popupClassName",
    "indicator"
];
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
var $54e7c8284494f1a4$var$uuid = 0;
var $54e7c8284494f1a4$var$Tabs = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var id = props.id, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tabs' : _props$prefixCls, className = props.className, items = props.items, direction = props.direction, activeKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, editable = props.editable, animated = props.animated, _props$tabPosition = props.tabPosition, tabPosition = _props$tabPosition === void 0 ? 'top' : _props$tabPosition, tabBarGutter = props.tabBarGutter, tabBarStyle = props.tabBarStyle, tabBarExtraContent = props.tabBarExtraContent, locale = props.locale, more = props.more, destroyInactiveTabPane = props.destroyInactiveTabPane, renderTabBar = props.renderTabBar, onChange = props.onChange, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName, indicator = props.indicator, restProps = (0, $4b02Q.default)(props, $54e7c8284494f1a4$var$_excluded);
    var tabs = $jMaZ8.useMemo(function() {
        return (items || []).filter(function(item) {
            return item && (0, $1Esi2.default)(item) === 'object' && 'key' in item;
        });
    }, [
        items
    ]);
    var rtl = direction === 'rtl';
    var mergedAnimated = (0, $16cc92fce7de9bc7$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    var _useState = (0, $jMaZ8.useState)(false), _useState2 = (0, $3fkx6.default)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $jMaZ8.useEffect)(function() {
        // Only update on the client side
        setMobile((0, $e5dc72d643143115$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    var _useMergedState = (0, $eGh7a.default)(function() {
        var _tabs$;
        return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
    }, {
        value: activeKey,
        defaultValue: defaultActiveKey
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
    var _useState3 = (0, $jMaZ8.useState)(function() {
        return tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
    }), _useState4 = (0, $3fkx6.default)(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
    // Reset active key if not exist anymore
    (0, $jMaZ8.useEffect)(function() {
        var newActiveIndex = tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
        if (newActiveIndex === -1) {
            var _tabs$newActiveIndex;
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    var _useMergedState3 = (0, $eGh7a.default)(null, {
        value: id
    }), _useMergedState4 = (0, $3fkx6.default)(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
    // Async generate id to avoid ssr mapping failed
    (0, $jMaZ8.useEffect)(function() {
        if (!id) {
            setMergedId("rc-tabs-".concat('test'));
            $54e7c8284494f1a4$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick === null || onTabClick === void 0 || onTabClick(key, e);
        var isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange === null || onChange === void 0 || onChange(key);
    }
    // ======================== Render ========================
    var sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    var tabNavBarProps = (0, $8u3qN.default)((0, $8u3qN.default)({}, sharedProps), {}, {
        editable: editable,
        locale: locale,
        more: more,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        panes: null,
        getPopupContainer: getPopupContainer,
        popupClassName: popupClassName,
        indicator: indicator
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $f11dc1150de29c3e$export$2e2bcd8739ae039).Provider, {
        value: {
            tabs: tabs,
            prefixCls: prefixCls
        }
    }, /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        ref: ref,
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-mobile"), mobile), "".concat(prefixCls, "-editable"), editable), "".concat(prefixCls, "-rtl"), rtl), className)
    }, restProps), /*#__PURE__*/ $jMaZ8.createElement((0, $af769fe8ccfec0f1$export$2e2bcd8739ae039), (0, $hH60s.default)({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $jMaZ8.createElement((0, $9e67a2181309f69a$export$2e2bcd8739ae039), (0, $hH60s.default)({
        destroyInactiveTabPane: destroyInactiveTabPane
    }, sharedProps, {
        animated: mergedAnimated
    }))));
});
$54e7c8284494f1a4$var$Tabs.displayName = 'Tabs';
var $54e7c8284494f1a4$export$2e2bcd8739ae039 = $54e7c8284494f1a4$var$Tabs;


var $63d357fb510cbbb1$export$2e2bcd8739ae039 = (0, $54e7c8284494f1a4$export$2e2bcd8739ae039);







const $2e7abdc5db52ac56$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $2e7abdc5db52ac56$export$2e2bcd8739ae039(prefixCls) {
    let animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        inkBar: true,
        tabPane: false
    };
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = Object.assign({
        inkBar: true
    }, typeof animated === 'object' ? animated : {});
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = Object.assign(Object.assign({}, $2e7abdc5db52ac56$var$motion), {
        motionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(prefixCls, 'switch')
    });
    return mergedAnimated;
}



var $jMaZ8 = parcelRequire("jMaZ8");

var $a6yuN = parcelRequire("a6yuN");

var $e808b8fd9c5f2653$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e808b8fd9c5f2653$var$filter(items) {
    return items.filter((item)=>item);
}
function $e808b8fd9c5f2653$export$2e2bcd8739ae039(items, children) {
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Tabs');
        warning.deprecated(!children, 'Tabs.TabPane', 'items');
    }
    if (items) return items;
    const childrenItems = (0, $a6yuN.default)(children).map((node)=>{
        if (/*#__PURE__*/ $jMaZ8.isValidElement(node)) {
            const { key: key, props: props } = node;
            const _a = props || {}, { tab: tab } = _a, restProps = $e808b8fd9c5f2653$var$__rest(_a, [
                "tab"
            ]);
            const item = Object.assign(Object.assign({
                key: String(key)
            }, restProps), {
                label: tab
            });
            return item;
        }
        return null;
    });
    return $e808b8fd9c5f2653$var$filter(childrenItems);
}


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

const $a33dc8ffa22f5459$export$e801b802b037de6a = new (0, $kB90R.default)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $a33dc8ffa22f5459$export$f40f41df328ebc38 = new (0, $kB90R.default)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $a33dc8ffa22f5459$export$dd9f089fa5e819fe = new (0, $kB90R.default)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $a33dc8ffa22f5459$export$f7243fdb9c27c3b7 = new (0, $kB90R.default)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $a33dc8ffa22f5459$export$2ad3a07c3513a54 = new (0, $kB90R.default)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $a33dc8ffa22f5459$export$486fbda27512d5a9 = new (0, $kB90R.default)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $a33dc8ffa22f5459$export$dd03ad46dbbcd7e0 = new (0, $kB90R.default)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $a33dc8ffa22f5459$export$db8e3c9b93664f34 = new (0, $kB90R.default)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $a33dc8ffa22f5459$var$slideMotion = {
    'slide-up': {
        inKeyframes: $a33dc8ffa22f5459$export$e801b802b037de6a,
        outKeyframes: $a33dc8ffa22f5459$export$f40f41df328ebc38
    },
    'slide-down': {
        inKeyframes: $a33dc8ffa22f5459$export$dd9f089fa5e819fe,
        outKeyframes: $a33dc8ffa22f5459$export$f7243fdb9c27c3b7
    },
    'slide-left': {
        inKeyframes: $a33dc8ffa22f5459$export$2ad3a07c3513a54,
        outKeyframes: $a33dc8ffa22f5459$export$486fbda27512d5a9
    },
    'slide-right': {
        inKeyframes: $a33dc8ffa22f5459$export$dd03ad46dbbcd7e0,
        outKeyframes: $a33dc8ffa22f5459$export$db8e3c9b93664f34
    }
};
const $a33dc8ffa22f5459$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $a33dc8ffa22f5459$var$slideMotion[motionName];
    return [
        (0, $7d04c31aa62562e0$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};


const $e37e4e4486931075$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return [
        {
            [componentCls]: {
                [`${componentCls}-switch`]: {
                    '&-appear, &-enter': {
                        transition: 'none',
                        '&-start': {
                            opacity: 0
                        },
                        '&-active': {
                            opacity: 1,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    },
                    '&-leave': {
                        position: 'absolute',
                        transition: 'none',
                        inset: 0,
                        '&-start': {
                            opacity: 1
                        },
                        '&-active': {
                            opacity: 0,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(token, 'slide-down')
        ]
    ];
};
var $e37e4e4486931075$export$2e2bcd8739ae039 = $e37e4e4486931075$var$genMotionStyle;


const $d555459ffab23e08$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardBg: cardBg, cardGutter: cardGutter, colorBorderSecondary: colorBorderSecondary, itemSelectedColor: itemSelectedColor } = token;
    return {
        [`${componentCls}-card`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: 0,
                    padding: tabsCardPadding,
                    background: cardBg,
                    border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
                },
                [`${componentCls}-tab-active`]: {
                    color: itemSelectedColor,
                    background: token.colorBgContainer
                },
                [`${componentCls}-tab-focus`]: Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token, -3)),
                [`${componentCls}-ink-bar`]: {
                    visibility: 'hidden'
                },
                [`& ${componentCls}-tab${componentCls}-tab-focus ${componentCls}-tab-btn`]: {
                    outline: 'none'
                }
            },
            // ========================== Top & Bottom ==========================
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $4g3I0.unit)(cardGutter)
                        }
                    }
                }
            },
            [`&${componentCls}-top`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)} 0 0`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderBottomColor: token.colorBgContainer
                    }
                }
            },
            [`&${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)}`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderTopColor: token.colorBgContainer
                    }
                }
            },
            // ========================== Left & Right ==========================
            [`&${componentCls}-left, &${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginTop: (0, $4g3I0.unit)(cardGutter)
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $4g3I0.unit)(token.borderRadiusLG)} 0 0 ${(0, $4g3I0.unit)(token.borderRadiusLG)}`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderRightColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)} 0`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderLeftColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            }
        }
    };
};
const $d555459ffab23e08$var$genDropdownStyle = (token)=>{
    const { componentCls: componentCls, itemHoverColor: itemHoverColor, dropdownEdgeChildVerticalPadding: dropdownEdgeChildVerticalPadding } = token;
    return {
        [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'absolute',
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: token.zIndexPopup,
            display: 'block',
            '&-hidden': {
                display: 'none'
            },
            [`${componentCls}-dropdown-menu`]: {
                maxHeight: token.tabsDropdownHeight,
                margin: 0,
                padding: `${(0, $4g3I0.unit)(dropdownEdgeChildVerticalPadding)} 0`,
                overflowX: 'hidden',
                overflowY: 'auto',
                textAlign: {
                    _skip_check_: true,
                    value: 'left'
                },
                listStyleType: 'none',
                backgroundColor: token.colorBgContainer,
                backgroundClip: 'padding-box',
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                '&-item': Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: token.tabsDropdownWidth,
                    margin: 0,
                    padding: `${(0, $4g3I0.unit)(token.paddingXXS)} ${(0, $4g3I0.unit)(token.paddingSM)}`,
                    color: token.colorText,
                    fontWeight: 'normal',
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    cursor: 'pointer',
                    transition: `all ${token.motionDurationSlow}`,
                    '> span': {
                        flex: 1,
                        whiteSpace: 'nowrap'
                    },
                    '&-remove': {
                        flex: 'none',
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        },
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        background: 'transparent',
                        border: 0,
                        cursor: 'pointer',
                        '&:hover': {
                            color: itemHoverColor
                        }
                    },
                    '&:hover': {
                        background: token.controlItemBgHover
                    },
                    '&-disabled': {
                        '&, &:hover': {
                            color: token.colorTextDisabled,
                            background: 'transparent',
                            cursor: 'not-allowed'
                        }
                    }
                })
            }
        })
    };
};
const $d555459ffab23e08$var$genPositionStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, colorBorderSecondary: colorBorderSecondary, horizontalMargin: horizontalMargin, verticalItemPadding: verticalItemPadding, verticalItemMargin: verticalItemMargin, calc: calc } = token;
    return {
        // ========================== Top & Bottom ==========================
        [`${componentCls}-top, ${componentCls}-bottom`]: {
            flexDirection: 'column',
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                margin: horizontalMargin,
                '&::before': {
                    position: 'absolute',
                    right: {
                        _skip_check_: true,
                        value: 0
                    },
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    content: "''"
                },
                [`${componentCls}-ink-bar`]: {
                    height: token.lineWidthBold,
                    '&-animated': {
                        transition: `width ${token.motionDurationSlow}, left ${token.motionDurationSlow},
            right ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-wrap`]: {
                    '&::before, &::after': {
                        top: 0,
                        bottom: 0,
                        width: token.controlHeight
                    },
                    '&::before': {
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowLeft
                    },
                    '&::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowRight
                    },
                    [`&${componentCls}-nav-wrap-ping-left::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-right::after`]: {
                        opacity: 1
                    }
                }
            }
        },
        [`${componentCls}-top`]: {
            [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
                '&::before': {
                    bottom: 0
                },
                [`${componentCls}-ink-bar`]: {
                    bottom: 0
                }
            }
        },
        [`${componentCls}-bottom`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                marginTop: margin,
                marginBottom: 0,
                '&::before': {
                    top: 0
                },
                [`${componentCls}-ink-bar`]: {
                    top: 0
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0
            }
        },
        // ========================== Left & Right ==========================
        [`${componentCls}-left, ${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                flexDirection: 'column',
                minWidth: calc(token.controlHeight).mul(1.25).equal(),
                // >>>>>>>>>>> Tab
                [`${componentCls}-tab`]: {
                    padding: verticalItemPadding,
                    textAlign: 'center'
                },
                [`${componentCls}-tab + ${componentCls}-tab`]: {
                    margin: verticalItemMargin
                },
                // >>>>>>>>>>> Nav
                [`${componentCls}-nav-wrap`]: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.controlHeight
                    },
                    '&::before': {
                        top: 0,
                        boxShadow: token.boxShadowTabsOverflowTop
                    },
                    '&::after': {
                        bottom: 0,
                        boxShadow: token.boxShadowTabsOverflowBottom
                    },
                    [`&${componentCls}-nav-wrap-ping-top::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
                        opacity: 1
                    }
                },
                // >>>>>>>>>>> Ink Bar
                [`${componentCls}-ink-bar`]: {
                    width: token.lineWidthBold,
                    '&-animated': {
                        transition: `height ${token.motionDurationSlow}, top ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
                    flex: '1 0 auto',
                    // fix safari scroll problem
                    flexDirection: 'column'
                }
            }
        },
        [`${componentCls}-left`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-ink-bar`]: {
                    right: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                marginLeft: {
                    _skip_check_: true,
                    value: (0, $4g3I0.unit)(calc(token.lineWidth).mul(-1).equal())
                },
                borderLeft: {
                    _skip_check_: true,
                    value: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingLeft: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        },
        [`${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                [`${componentCls}-ink-bar`]: {
                    left: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0,
                marginRight: {
                    _skip_check_: true,
                    value: calc(token.lineWidth).mul(-1).equal()
                },
                borderRight: {
                    _skip_check_: true,
                    value: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingRight: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        }
    };
};
const $d555459ffab23e08$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, cardPaddingLG: cardPaddingLG, horizontalItemPaddingSM: horizontalItemPaddingSM, horizontalItemPaddingLG: horizontalItemPaddingLG } = token;
    return {
        [componentCls]: {
            '&-small': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingSM,
                        fontSize: token.titleFontSizeSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingLG,
                        fontSize: token.titleFontSizeLG
                    }
                }
            }
        },
        [`${componentCls}-card`]: {
            [`&${componentCls}-small`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingSM
                    }
                },
                [`&${componentCls}-bottom`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $4g3I0.unit)(token.borderRadius)} ${(0, $4g3I0.unit)(token.borderRadius)}`
                    }
                },
                [`&${componentCls}-top`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `${(0, $4g3I0.unit)(token.borderRadius)} ${(0, $4g3I0.unit)(token.borderRadius)} 0 0`
                    }
                },
                [`&${componentCls}-right`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $4g3I0.unit)(token.borderRadius)} ${(0, $4g3I0.unit)(token.borderRadius)} 0`
                        }
                    }
                },
                [`&${componentCls}-left`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $4g3I0.unit)(token.borderRadius)} 0 0 ${(0, $4g3I0.unit)(token.borderRadius)}`
                        }
                    }
                }
            },
            [`&${componentCls}-large`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingLG
                    }
                }
            }
        }
    };
};
const $d555459ffab23e08$var$genTabStyle = (token)=>{
    const { componentCls: componentCls, itemActiveColor: itemActiveColor, itemHoverColor: itemHoverColor, iconCls: iconCls, tabsHorizontalItemMargin: tabsHorizontalItemMargin, horizontalItemPadding: horizontalItemPadding, itemSelectedColor: itemSelectedColor, itemColor: itemColor } = token;
    const tabCls = `${componentCls}-tab`;
    return {
        [tabCls]: {
            position: 'relative',
            WebkitTouchCallout: 'none',
            WebkitTapHighlightColor: 'transparent',
            display: 'inline-flex',
            alignItems: 'center',
            padding: horizontalItemPadding,
            fontSize: token.titleFontSize,
            background: 'transparent',
            border: 0,
            outline: 'none',
            cursor: 'pointer',
            color: itemColor,
            '&-btn, &-remove': {
                '&:focus:not(:focus-visible), &:active': {
                    color: itemActiveColor
                }
            },
            '&-btn': {
                outline: 'none',
                transition: `all ${token.motionDurationSlow}`,
                [`${tabCls}-icon:not(:last-child)`]: {
                    marginInlineEnd: token.marginSM
                }
            },
            '&-remove': Object.assign({
                flex: 'none',
                marginRight: {
                    _skip_check_: true,
                    value: token.calc(token.marginXXS).mul(-1).equal()
                },
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginXS
                },
                color: token.colorTextDescription,
                fontSize: token.fontSizeSM,
                background: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                '&:hover': {
                    color: token.colorTextHeading
                }
            }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)),
            '&:hover': {
                color: itemHoverColor
            },
            [`&${tabCls}-active ${tabCls}-btn`]: {
                color: itemSelectedColor,
                textShadow: token.tabsActiveTextShadow
            },
            [`&${tabCls}-focus ${tabCls}-btn`]: Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token)),
            [`&${tabCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
                '&:focus, &:active': {
                    color: token.colorTextDisabled
                }
            },
            [`& ${tabCls}-remove ${iconCls}`]: {
                margin: 0
            },
            [`${iconCls}:not(:last-child)`]: {
                marginRight: {
                    _skip_check_: true,
                    value: token.marginSM
                }
            }
        },
        [`${tabCls} + ${tabCls}`]: {
            margin: {
                _skip_check_: true,
                value: tabsHorizontalItemMargin
            }
        }
    };
};
const $d555459ffab23e08$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls, tabsHorizontalItemMarginRTL: tabsHorizontalItemMarginRTL, iconCls: iconCls, cardGutter: cardGutter, calc: calc } = token;
    const rtlCls = `${componentCls}-rtl`;
    return {
        [rtlCls]: {
            direction: 'rtl',
            [`${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: {
                        _skip_check_: true,
                        value: tabsHorizontalItemMarginRTL
                    },
                    [`${componentCls}-tab:last-of-type`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    },
                    [iconCls]: {
                        marginRight: {
                            _skip_check_: true,
                            value: 0
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $4g3I0.unit)(token.marginSM)
                        }
                    },
                    [`${componentCls}-tab-remove`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: (0, $4g3I0.unit)(token.marginXS)
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $4g3I0.unit)(calc(token.marginXXS).mul(-1).equal())
                        },
                        [iconCls]: {
                            margin: 0
                        }
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav`]: {
                    order: 1
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 0
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav`]: {
                    order: 0
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 1
                }
            },
            // ====================== Card ======================
            [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: cardGutter
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    }
                }
            }
        },
        [`${componentCls}-dropdown-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-menu-item`]: {
            [`${componentCls}-dropdown-rtl`]: {
                textAlign: {
                    _skip_check_: true,
                    value: 'right'
                }
            }
        }
    };
};
const $d555459ffab23e08$var$genTabsStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardHeight: cardHeight, cardGutter: cardGutter, itemHoverColor: itemHoverColor, itemActiveColor: itemActiveColor, colorBorderSecondary: colorBorderSecondary } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            display: 'flex',
            // ========================== Navigation ==========================
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                position: 'relative',
                display: 'flex',
                flex: 'none',
                alignItems: 'center',
                [`${componentCls}-nav-wrap`]: {
                    position: 'relative',
                    display: 'flex',
                    flex: 'auto',
                    alignSelf: 'stretch',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    transform: 'translate(0)',
                    // Fix chrome render bug
                    // >>>>> Ping shadow
                    '&::before, &::after': {
                        position: 'absolute',
                        zIndex: 1,
                        opacity: 0,
                        transition: `opacity ${token.motionDurationSlow}`,
                        content: "''",
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-nav-list`]: {
                    position: 'relative',
                    display: 'flex',
                    transition: `opacity ${token.motionDurationSlow}`
                },
                // >>>>>>>> Operations
                [`${componentCls}-nav-operations`]: {
                    display: 'flex',
                    alignSelf: 'stretch'
                },
                [`${componentCls}-nav-operations-hidden`]: {
                    position: 'absolute',
                    visibility: 'hidden',
                    pointerEvents: 'none'
                },
                [`${componentCls}-nav-more`]: {
                    position: 'relative',
                    padding: tabsCardPadding,
                    background: 'transparent',
                    border: 0,
                    color: token.colorText,
                    '&::after': {
                        position: 'absolute',
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        bottom: 0,
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.calc(token.controlHeightLG).div(8).equal(),
                        transform: 'translateY(100%)',
                        content: "''"
                    }
                },
                [`${componentCls}-nav-add`]: Object.assign({
                    minWidth: cardHeight,
                    marginLeft: {
                        _skip_check_: true,
                        value: cardGutter
                    },
                    padding: (0, $4g3I0.unit)(token.paddingXS),
                    background: 'transparent',
                    border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    borderRadius: `${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)} 0 0`,
                    outline: 'none',
                    cursor: 'pointer',
                    color: token.colorText,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                    '&:hover': {
                        color: itemHoverColor
                    },
                    '&:active, &:focus:not(:focus-visible)': {
                        color: itemActiveColor
                    }
                }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token, -3))
            },
            [`${componentCls}-extra-content`]: {
                flex: 'none'
            },
            // ============================ InkBar ============================
            [`${componentCls}-ink-bar`]: {
                position: 'absolute',
                background: token.inkBarColor,
                pointerEvents: 'none'
            }
        }), $d555459ffab23e08$var$genTabStyle(token)), {
            // =========================== TabPanes ===========================
            [`${componentCls}-content`]: {
                position: 'relative',
                width: '100%'
            },
            [`${componentCls}-content-holder`]: {
                flex: 'auto',
                minWidth: 0,
                minHeight: 0
            },
            [`${componentCls}-tabpane`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)), {
                '&-hidden': {
                    display: 'none'
                }
            })
        }),
        [`${componentCls}-centered`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-nav-wrap`]: {
                    [`&:not([class*='${componentCls}-nav-wrap-ping']) > ${componentCls}-nav-list`]: {
                        margin: 'auto'
                    }
                }
            }
        }
    };
};
const $d555459ffab23e08$export$9ca1be8807fe0675 = (token)=>{
    const cardHeight = token.controlHeightLG;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        cardHeight: cardHeight,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: `${(cardHeight - Math.round(token.fontSize * token.lineHeight)) / 2 - token.lineWidth}px ${token.padding}px`,
        cardPaddingSM: `${token.paddingXXS * 1.5}px ${token.padding}px`,
        cardPaddingLG: `${token.paddingXS}px ${token.padding}px ${token.paddingXXS * 1.5}px`,
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: `0 0 ${token.margin}px 0`,
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: ``,
        horizontalItemMarginRTL: ``,
        horizontalItemPadding: `${token.paddingSM}px 0`,
        horizontalItemPaddingSM: `${token.paddingXS}px 0`,
        horizontalItemPaddingLG: `${token.padding}px 0`,
        verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
        verticalItemMargin: `${token.margin}px 0 0 0`,
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$d555459ffab23e08$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Tabs', (token)=>{
    const tabsToken = (0, $8APUt.merge)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsActiveTextShadow: '0 0 0.25px currentcolor',
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: `0 0 0 ${(0, $4g3I0.unit)(token.horizontalItemGutter)}`,
        tabsHorizontalItemMarginRTL: `0 0 0 ${(0, $4g3I0.unit)(token.horizontalItemGutter)}`
    });
    return [
        $d555459ffab23e08$var$genSizeStyle(tabsToken),
        $d555459ffab23e08$var$genRtlStyle(tabsToken),
        $d555459ffab23e08$var$genPositionStyle(tabsToken),
        $d555459ffab23e08$var$genDropdownStyle(tabsToken),
        $d555459ffab23e08$var$genCardStyle(tabsToken),
        $d555459ffab23e08$var$genTabsStyle(tabsToken),
        (0, $e37e4e4486931075$export$2e2bcd8739ae039)(tabsToken)
    ];
}, $d555459ffab23e08$export$9ca1be8807fe0675);


const $02e71ac89f1baf1d$var$TabPane = ()=>null;
$02e71ac89f1baf1d$var$TabPane.displayName = 'DeprecatedTabPane';
var $02e71ac89f1baf1d$export$2e2bcd8739ae039 = $02e71ac89f1baf1d$var$TabPane;


"use client";
var $3d078c5b7a14a8e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3d078c5b7a14a8e5$var$Tabs = (props)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { type: type, className: className, rootClassName: rootClassName, size: customSize, onEdit: onEdit, hideAdd: hideAdd, centered: centered, addIcon: addIcon, removeIcon: removeIcon, moreIcon: moreIcon, more: more, popupClassName: popupClassName, children: children, items: items, animated: animated, style: style, indicatorSize: indicatorSize, indicator: indicator } = props, otherProps = $3d078c5b7a14a8e5$var$__rest(props, [
        "type",
        "className",
        "rootClassName",
        "size",
        "onEdit",
        "hideAdd",
        "centered",
        "addIcon",
        "removeIcon",
        "moreIcon",
        "more",
        "popupClassName",
        "children",
        "items",
        "animated",
        "style",
        "indicatorSize",
        "indicator"
    ]);
    const { prefixCls: customizePrefixCls } = otherProps;
    const { direction: direction, tabs: tabs, getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $d555459ffab23e08$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let editable;
    if (type === 'editable-card') editable = {
        onEdit: (editType, _ref)=>{
            let { key: key, event: event } = _ref;
            onEdit === null || onEdit === void 0 || onEdit(editType === 'add' ? event : key, editType);
        },
        removeIcon: (_a = removeIcon !== null && removeIcon !== void 0 ? removeIcon : tabs === null || tabs === void 0 ? void 0 : tabs.removeIcon) !== null && _a !== void 0 ? _a : /*#__PURE__*/ $jMaZ8.createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), null),
        addIcon: (addIcon !== null && addIcon !== void 0 ? addIcon : tabs === null || tabs === void 0 ? void 0 : tabs.addIcon) || /*#__PURE__*/ $jMaZ8.createElement((0, $4773bfa339fdb113$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    const rootPrefixCls = getPrefixCls();
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Tabs');
        warning(!('onPrevClick' in props) && !('onNextClick' in props), 'breaking', '`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.');
        warning(!(indicatorSize || (tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize)), 'deprecated', '`indicatorSize` has been deprecated. Please use `indicator={{ size: ... }}` instead.');
    }
    const size = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customSize);
    const mergedItems = (0, $e808b8fd9c5f2653$export$2e2bcd8739ae039)(items, children);
    const mergedAnimated = (0, $2e7abdc5db52ac56$export$2e2bcd8739ae039)(prefixCls, animated);
    const mergedStyle = Object.assign(Object.assign({}, tabs === null || tabs === void 0 ? void 0 : tabs.style), style);
    const mergedIndicator = {
        align: (_b = indicator === null || indicator === void 0 ? void 0 : indicator.align) !== null && _b !== void 0 ? _b : (_c = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _c === void 0 ? void 0 : _c.align,
        size: (_g = (_e = (_d = indicator === null || indicator === void 0 ? void 0 : indicator.size) !== null && _d !== void 0 ? _d : indicatorSize) !== null && _e !== void 0 ? _e : (_f = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _f === void 0 ? void 0 : _f.size) !== null && _g !== void 0 ? _g : tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize
    };
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $63d357fb510cbbb1$export$2e2bcd8739ae039), Object.assign({
        direction: direction,
        getPopupContainer: getPopupContainer
    }, otherProps, {
        items: mergedItems,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-card`]: [
                'card',
                'editable-card'
            ].includes(type),
            [`${prefixCls}-editable-card`]: type === 'editable-card',
            [`${prefixCls}-centered`]: centered
        }, tabs === null || tabs === void 0 ? void 0 : tabs.className, className, rootClassName, hashId, cssVarCls, rootCls),
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(popupClassName, hashId, cssVarCls, rootCls),
        style: mergedStyle,
        editable: editable,
        more: Object.assign({
            icon: (_l = (_k = (_j = (_h = tabs === null || tabs === void 0 ? void 0 : tabs.more) === null || _h === void 0 ? void 0 : _h.icon) !== null && _j !== void 0 ? _j : tabs === null || tabs === void 0 ? void 0 : tabs.moreIcon) !== null && _k !== void 0 ? _k : moreIcon) !== null && _l !== void 0 ? _l : /*#__PURE__*/ $jMaZ8.createElement((0, $49848ec5154332ea$export$2e2bcd8739ae039), null),
            transitionName: `${rootPrefixCls}-slide-up`
        }, more),
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicator: mergedIndicator
    })));
};
$3d078c5b7a14a8e5$var$Tabs.TabPane = (0, $02e71ac89f1baf1d$export$2e2bcd8739ae039);
$3d078c5b7a14a8e5$var$Tabs.displayName = 'Tabs';
var $3d078c5b7a14a8e5$export$2e2bcd8739ae039 = $3d078c5b7a14a8e5$var$Tabs;





var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");

var $1cfGC = parcelRequire("1cfGC");


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $1cfGC = parcelRequire("1cfGC");



const $ff96d532443ca338$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(',')
                }
            }
        }
    };
};
var $ff96d532443ca338$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$b8cc4ee2ee8cfbc8)('Wave', (token)=>[
        $ff96d532443ca338$var$genWaveStyle(token)
    ]);



var $jMaZ8 = parcelRequire("jMaZ8");

var $ktS49 = parcelRequire("ktS49");

var $aZxvk = parcelRequire("aZxvk");



const $eb107cfcd5a0fca6$export$23466a5792b7a5d3 = `${(0, $3613812083e7312f$export$e4ec87ea71f29b41)}-wave-target`;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");

var $aZxvk = parcelRequire("aZxvk");

var $1cfGC = parcelRequire("1cfGC");


function $8a97bcf2aba9678f$export$9d61ea039e87eb91(color) {
    return color && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent';
}
function $8a97bcf2aba9678f$export$651d8e9c80304fc8(node) {
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = getComputedStyle(node);
    if ($8a97bcf2aba9678f$export$9d61ea039e87eb91(borderTopColor)) return borderTopColor;
    if ($8a97bcf2aba9678f$export$9d61ea039e87eb91(borderColor)) return borderColor;
    if ($8a97bcf2aba9678f$export$9d61ea039e87eb91(backgroundColor)) return backgroundColor;
    return null;
}


"use client";
function $64dc7a94e42985eb$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $64dc7a94e42985eb$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, registerUnmount: registerUnmount } = props;
    const divRef = $jMaZ8.useRef(null);
    // ====================== Refs ======================
    const unmountRef = $jMaZ8.useRef(null);
    $jMaZ8.useEffect(()=>{
        unmountRef.current = registerUnmount();
    }, []);
    // ===================== Effect =====================
    const [color, setWaveColor] = $jMaZ8.useState(null);
    const [borderRadius, setBorderRadius] = $jMaZ8.useState([]);
    const [left, setLeft] = $jMaZ8.useState(0);
    const [top, setTop] = $jMaZ8.useState(0);
    const [width, setWidth] = $jMaZ8.useState(0);
    const [height, setHeight] = $jMaZ8.useState(0);
    const [enabled, setEnabled] = $jMaZ8.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (color) waveStyle['--wave-color'] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $8a97bcf2aba9678f$export$651d8e9c80304fc8)(target));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $64dc7a94e42985eb$var$validateNum(-parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $64dc7a94e42985eb$var$validateNum(-parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$64dc7a94e42985eb$var$validateNum(parseFloat(radius))));
    }
    $jMaZ8.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $aZxvk.default)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $aZxvk.default).cancel(id);
                resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
            };
        }
    }, []);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains((0, $eb107cfcd5a0fca6$export$23466a5792b7a5d3)));
    return /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            var _a, _b;
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
                (_b = unmountRef.current) === null || _b === void 0 || _b.call(unmountRef).then(()=>{
                    holder === null || holder === void 0 || holder.remove();
                });
            }
            return false;
        }
    }, (_ref, ref)=>{
        let { className: motionClassName } = _ref;
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            ref: (0, $1cfGC.composeRef)(divRef, ref),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        });
    });
};
const $64dc7a94e42985eb$var$showWaveEffect = (target, info)=>{
    var _a;
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !((_a = target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.checked)) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    const reactRender = (0, $49fd731f963d0354$export$1c4a73059151cd3e)();
    let unmountCallback = null;
    function registerUnmount() {
        return unmountCallback;
    }
    unmountCallback = reactRender(/*#__PURE__*/ $jMaZ8.createElement($64dc7a94e42985eb$var$WaveEffect, Object.assign({}, info, {
        target: target,
        registerUnmount: registerUnmount
    })), holder);
};
var $64dc7a94e42985eb$export$2e2bcd8739ae039 = $64dc7a94e42985eb$var$showWaveEffect;


const $d4ae9dbe6984ef91$var$useWave = (nodeRef, className, component)=>{
    const { wave: wave } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const showWave = (0, $ktS49.default)((event)=>{
        const node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) return;
        const targetNode = node.querySelector(`.${(0, $eb107cfcd5a0fca6$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $64dc7a94e42985eb$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId
        });
    });
    const rafId = $jMaZ8.useRef(null);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $aZxvk.default).cancel(rafId.current);
        rafId.current = (0, $aZxvk.default)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $d4ae9dbe6984ef91$export$2e2bcd8739ae039 = $d4ae9dbe6984ef91$var$useWave;


const $de29c1080c02bd8d$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component } = props;
    const { getPrefixCls: getPrefixCls } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const containerRef = (0, $jMaZ8.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const [, hashId] = (0, $ff96d532443ca338$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $d4ae9dbe6984ef91$export$2e2bcd8739ae039)(containerRef, (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, hashId), component);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== 1 || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $f0dd1e7e6ce84933$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).isValidElement(children)) return children !== null && children !== void 0 ? children : null;
    const ref = (0, $1cfGC.supportRef)(children) ? (0, $1cfGC.composeRef)((0, $1cfGC.getNodeRef)(children), containerRef) : containerRef;
    return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
$de29c1080c02bd8d$var$Wave.displayName = 'Wave';
var $de29c1080c02bd8d$export$2e2bcd8739ae039 = $de29c1080c02bd8d$var$Wave;







var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");



"use client";
var $fb0e0a37019421f1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fb0e0a37019421f1$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $jMaZ8.createContext(undefined);
const $fb0e0a37019421f1$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className } = props, others = $fb0e0a37019421f1$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const sizeCls = $jMaZ8.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Button.Group');
        warning(!size || [
            'large',
            'small',
            'middle'
        ].includes(size), 'usage', 'Invalid prop `size`.');
    }
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $jMaZ8.createElement($fb0e0a37019421f1$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, others, {
        className: classes
    })));
};
var $fb0e0a37019421f1$export$2e2bcd8739ae039 = $fb0e0a37019421f1$var$ButtonGroup;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");


"use client";
const $e4847c5f9a9fd582$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $e4847c5f9a9fd582$export$c5dca2bf412dea0d = $e4847c5f9a9fd582$var$rxTwoCNChar.test.bind($e4847c5f9a9fd582$var$rxTwoCNChar);
function $e4847c5f9a9fd582$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $e4847c5f9a9fd582$export$844ec244b1367d54(str) {
    return typeof str === 'string';
}
function $e4847c5f9a9fd582$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $e4847c5f9a9fd582$var$splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === undefined) return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && $e4847c5f9a9fd582$export$844ec244b1367d54(child.type) && $e4847c5f9a9fd582$export$c5dca2bf412dea0d(child.props.children)) return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(child, {
        children: child.props.children.split('').join(SPACE)
    });
    if ($e4847c5f9a9fd582$export$844ec244b1367d54(child)) return $e4847c5f9a9fd582$export$c5dca2bf412dea0d(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", null, child);
    if ((0, $e4daa5bbe3988c87$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", null, child);
    return child;
}
function $e4847c5f9a9fd582$export$b6ee00a7e7908bc(children, needInserted) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Children.map(childList, (child)=>$e4847c5f9a9fd582$var$splitCNCharsBySpace(child, needInserted));
}
const $e4847c5f9a9fd582$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $e4847c5f9a9fd582$var$_ButtonShapes = [
    'default',
    'circle',
    'round'
];
const $e4847c5f9a9fd582$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $e4847c5f9a9fd582$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $e4847c5f9a9fd582$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $fvBso.default)((0, $eb2ddc4f321ac793$export$6d4fe3a00a1811ad)));



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
"use client";
const $0694ae187f492140$var$IconWrapper = /*#__PURE__*/ (0, $jMaZ8.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $0694ae187f492140$export$2e2bcd8739ae039 = $0694ae187f492140$var$IconWrapper;



var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");

"use client";
const $2643ed47118c83df$var$InnerLoadingIcon = /*#__PURE__*/ (0, $jMaZ8.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $0694ae187f492140$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $2643ed47118c83df$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $2643ed47118c83df$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $2643ed47118c83df$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($2643ed47118c83df$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $lsVqZ.default), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $2643ed47118c83df$var$getCollapsedWidth,
        onAppearActive: $2643ed47118c83df$var$getRealWidth,
        onEnterStart: $2643ed47118c83df$var$getCollapsedWidth,
        onEnterActive: $2643ed47118c83df$var$getRealWidth,
        onLeaveStart: $2643ed47118c83df$var$getRealWidth,
        onLeaveActive: $2643ed47118c83df$var$getCollapsedWidth
    }, (_ref, ref)=>{
        let { className: motionCls, style: motionStyle } = _ref;
        const mergedStyle = Object.assign(Object.assign({}, style), motionStyle);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($2643ed47118c83df$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $2643ed47118c83df$export$2e2bcd8739ae039 = $2643ed47118c83df$var$DefaultLoadingIcon;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $bb28462c069ee011$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $bb28462c069ee011$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $bb28462c069ee011$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $bb28462c069ee011$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $bb28462c069ee011$export$2e2bcd8739ae039 = $bb28462c069ee011$var$genGroupStyle;



var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $1Esi2 = parcelRequire("1Esi2");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");
var $6ed18c751601c2fb$var$_excluded = [
    "b"
], $6ed18c751601c2fb$var$_excluded2 = [
    "v"
];
var $6ed18c751601c2fb$export$8d6531175688484b = function getRoundNumber(value) {
    return Math.round(Number(value || 0));
};
var $6ed18c751601c2fb$var$convertHsb2Hsv = function convertHsb2Hsv(color) {
    if (color instanceof (0, $6xABB.FastColor)) return color;
    if (color && (0, $1Esi2.default)(color) === 'object' && 'h' in color && 'b' in color) {
        var _ref = color, b = _ref.b, resets = (0, $4b02Q.default)(_ref, $6ed18c751601c2fb$var$_excluded);
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, resets), {}, {
            v: b
        });
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
var $6ed18c751601c2fb$export$892596cec99bc70e = /*#__PURE__*/ function(_FastColor) {
    (0, $7eK0y.default)(Color, _FastColor);
    var _super = (0, $fwNdX.default)(Color);
    function Color(color) {
        (0, $klxbl.default)(this, Color);
        return _super.call(this, $6ed18c751601c2fb$var$convertHsb2Hsv(color));
    }
    (0, $9O7LJ.default)(Color, [
        {
            key: "toHsbString",
            value: function toHsbString() {
                var hsb = this.toHsb();
                var saturation = $6ed18c751601c2fb$export$8d6531175688484b(hsb.s * 100);
                var lightness = $6ed18c751601c2fb$export$8d6531175688484b(hsb.b * 100);
                var hue = $6ed18c751601c2fb$export$8d6531175688484b(hsb.h);
                var alpha = hsb.a;
                var hsbString = "hsb(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
                var hsbaString = "hsba(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%, ").concat(alpha.toFixed(alpha === 0 ? 0 : 2), ")");
                return alpha === 1 ? hsbString : hsbaString;
            }
        },
        {
            key: "toHsb",
            value: function toHsb() {
                var _this$toHsv = this.toHsv(), v = _this$toHsv.v, resets = (0, $4b02Q.default)(_this$toHsv, $6ed18c751601c2fb$var$_excluded2);
                return (0, $8u3qN.default)((0, $8u3qN.default)({}, resets), {}, {
                    b: v,
                    a: this.a
                });
            }
        }
    ]);
    return Color;
}((0, $6xABB.FastColor));


var $3433f256d6eeb7cf$export$90004e2badfbdf1f = 'rc-color-picker';
var $3433f256d6eeb7cf$export$c844f5d21427d1ab = function generateColor(color) {
    if (color instanceof (0, $6ed18c751601c2fb$export$892596cec99bc70e)) return color;
    return new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(color);
};
var $3433f256d6eeb7cf$export$f705f0fde43a55a = $3433f256d6eeb7cf$export$c844f5d21427d1ab('#1677ff');
var $3433f256d6eeb7cf$export$3a7095e9fd85a71d = function calculateColor(props) {
    var offset = props.offset, targetRef = props.targetRef, containerRef = props.containerRef, color = props.color, type = props.type;
    var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
    var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
    var centerOffsetX = targetWidth / 2;
    var centerOffsetY = targetHeight / 2;
    var saturation = (offset.x + centerOffsetX) / width;
    var bright = 1 - (offset.y + centerOffsetY) / height;
    var hsb = color.toHsb();
    var alphaOffset = saturation;
    var hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $3433f256d6eeb7cf$export$c844f5d21427d1ab((0, $8u3qN.default)((0, $8u3qN.default)({}, hsb), {}, {
                h: hueOffset <= 0 ? 0 : hueOffset
            }));
        case 'alpha':
            return $3433f256d6eeb7cf$export$c844f5d21427d1ab((0, $8u3qN.default)((0, $8u3qN.default)({}, hsb), {}, {
                a: alphaOffset <= 0 ? 0 : alphaOffset
            }));
    }
    return $3433f256d6eeb7cf$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
var $3433f256d6eeb7cf$export$20165527867cbf14 = function calcOffset(color, type) {
    var hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};



var $giSak = parcelRequire("giSak");


var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $255d83ff6e76c1b9$var$ColorBlock = function ColorBlock(_ref) {
    var color = _ref.color, prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, onClick = _ref.onClick;
    var colorBlockCls = "".concat(prefixCls, "-color-block");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(colorBlockCls, "-inner"),
        style: {
            background: color
        }
    }));
};
var $255d83ff6e76c1b9$export$2e2bcd8739ae039 = $255d83ff6e76c1b9$var$ColorBlock;



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $d3d6bb73d2d3c398$var$getPosition(e) {
    var obj = 'touches' in e ? e.touches[0] : e;
    var scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    var scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $d3d6bb73d2d3c398$var$useColorDrag(props) {
    var targetRef = props.targetRef, containerRef = props.containerRef, direction = props.direction, onDragChange = props.onDragChange, onDragChangeComplete = props.onDragChangeComplete, calculate = props.calculate, color = props.color, disabledDrag = props.disabledDrag;
    var _useState = (0, $jMaZ8.useState)({
        x: 0,
        y: 0
    }), _useState2 = (0, $3fkx6.default)(_useState, 2), offsetValue = _useState2[0], setOffsetValue = _useState2[1];
    var mouseMoveRef = (0, $jMaZ8.useRef)(null);
    var mouseUpRef = (0, $jMaZ8.useRef)(null);
    // Always get position from `color`
    (0, $jMaZ8.useEffect)(function() {
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $jMaZ8.useEffect)(function() {
        return function() {
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        };
    }, []);
    var updateOffset = function updateOffset(e) {
        var _getPosition = $d3d6bb73d2d3c398$var$getPosition(e), pageX = _getPosition.pageX, pageY = _getPosition.pageY;
        var _containerRef$current = containerRef.current.getBoundingClientRect(), rectX = _containerRef$current.x, rectY = _containerRef$current.y, width = _containerRef$current.width, height = _containerRef$current.height;
        var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
        var centerOffsetX = targetWidth / 2;
        var centerOffsetY = targetHeight / 2;
        var offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        var offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        var calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange === null || onDragChange === void 0 || onDragChange(calcOffset);
    };
    var onDragMove = function onDragMove(e) {
        e.preventDefault();
        updateOffset(e);
    };
    var onDragStop = function onDragStop(e) {
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete === null || onDragChangeComplete === void 0 || onDragChangeComplete();
    };
    var onDragStart = function onDragStart(e) {
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $d3d6bb73d2d3c398$export$2e2bcd8739ae039 = $d3d6bb73d2d3c398$var$useColorDrag;



parcelRequire("1CVs1");
var $ktS49 = parcelRequire("ktS49");

var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $75505d7454508cc7$var$Handler = function Handler(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'default' : _ref$size, color = _ref.color, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-handler"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-handler-sm"), size === 'small')),
        style: {
            backgroundColor: color
        }
    });
};
var $75505d7454508cc7$export$2e2bcd8739ae039 = $75505d7454508cc7$var$Handler;



var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
var $87be010a48e0508c$var$Palette = function Palette(_ref) {
    var children = _ref.children, style = _ref.style, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(prefixCls, "-palette"),
        style: (0, $8u3qN.default)({
            position: 'relative'
        }, style)
    }, children);
};
var $87be010a48e0508c$export$2e2bcd8739ae039 = $87be010a48e0508c$var$Palette;



var $jMaZ8 = parcelRequire("jMaZ8");
var $312533cbb5a6a48f$var$Transform = /*#__PURE__*/ (0, $jMaZ8.forwardRef)(function(props, ref) {
    var children = props.children, x = props.x, y = props.y;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: "".concat(x, "%"),
            top: "".concat(y, "%"),
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $312533cbb5a6a48f$export$2e2bcd8739ae039 = $312533cbb5a6a48f$var$Transform;


var $490f47636cb86cdb$var$Picker = function Picker(_ref) {
    var color = _ref.color, onChange = _ref.onChange, prefixCls = _ref.prefixCls, onChangeComplete = _ref.onChangeComplete, disabled = _ref.disabled;
    var pickerRef = (0, $jMaZ8.useRef)();
    var transformRef = (0, $jMaZ8.useRef)();
    var colorRef = (0, $jMaZ8.useRef)(color);
    var onDragChange = (0, $ktS49.default)(function(offsetValue) {
        var calcColor = (0, $3433f256d6eeb7cf$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    var _useColorDrag = (0, $d3d6bb73d2d3c398$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: function calculate() {
            return (0, $3433f256d6eeb7cf$export$20165527867cbf14)(color);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            return onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorRef.current);
        },
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $3fkx6.default)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        ref: pickerRef,
        className: "".concat(prefixCls, "-select"),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $87be010a48e0508c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $312533cbb5a6a48f$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $75505d7454508cc7$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(prefixCls, "-saturation"),
        style: {
            backgroundColor: "hsl(".concat(color.toHsb().h, ",100%, 50%)"),
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $490f47636cb86cdb$export$2e2bcd8739ae039 = $490f47636cb86cdb$var$Picker;



var $3fkx6 = parcelRequire("3fkx6");
parcelRequire("1CVs1");
var $eGh7a = parcelRequire("eGh7a");

var $jMaZ8 = parcelRequire("jMaZ8");

var $78e55fb12a176c3d$var$useColorState = function useColorState(defaultValue, value) {
    var _useMergedState = (0, $eGh7a.default)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var color = (0, $jMaZ8.useMemo)(function() {
        return (0, $3433f256d6eeb7cf$export$c844f5d21427d1ab)(mergedValue);
    }, [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $78e55fb12a176c3d$export$2e2bcd8739ae039 = $78e55fb12a176c3d$var$useColorState;



var $jMaZ8 = parcelRequire("jMaZ8");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");



var $giSak = parcelRequire("giSak");
parcelRequire("1CVs1");
var $ktS49 = parcelRequire("ktS49");



var $jMaZ8 = parcelRequire("jMaZ8");


var $66b3fa40b06a61df$var$Gradient = function Gradient(_ref) {
    var colors = _ref.colors, children = _ref.children, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'to right' : _ref$direction, type = _ref.type, prefixCls = _ref.prefixCls;
    var gradientColors = (0, $jMaZ8.useMemo)(function() {
        return colors.map(function(color, idx) {
            var result = (0, $3433f256d6eeb7cf$export$c844f5d21427d1ab)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(',');
    }, [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(prefixCls, "-gradient"),
        style: {
            position: 'absolute',
            inset: 0,
            background: "linear-gradient(".concat(direction, ", ").concat(gradientColors, ")")
        }
    }, children);
};
var $66b3fa40b06a61df$export$2e2bcd8739ae039 = $66b3fa40b06a61df$var$Gradient;




var $c4cc98f9d5c2f030$var$Slider = function Slider(props) {
    var prefixCls = props.prefixCls, colors = props.colors, disabled = props.disabled, onChange = props.onChange, onChangeComplete = props.onChangeComplete, color = props.color, type = props.type;
    var sliderRef = (0, $jMaZ8.useRef)();
    var transformRef = (0, $jMaZ8.useRef)();
    var colorRef = (0, $jMaZ8.useRef)(color);
    var getValue = function getValue(c) {
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    var onDragChange = (0, $ktS49.default)(function(offsetValue) {
        var calcColor = (0, $3433f256d6eeb7cf$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    var _useColorDrag = (0, $d3d6bb73d2d3c398$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: function calculate() {
            return (0, $3433f256d6eeb7cf$export$20165527867cbf14)(color, type);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $3fkx6.default)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    var handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        if (type === 'hue') {
            var hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            var lightColor = new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    var gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        return colors.map(function(info) {
            return "".concat(info.color, " ").concat(info.percent, "%");
        });
    }, [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        ref: sliderRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-slider"), "".concat(prefixCls, "-slider-").concat(type)),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $87be010a48e0508c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $312533cbb5a6a48f$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $75505d7454508cc7$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $66b3fa40b06a61df$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $c4cc98f9d5c2f030$export$2e2bcd8739ae039 = $c4cc98f9d5c2f030$var$Slider;


function $48f4e4ce3e3f19a7$export$2e2bcd8739ae039(components) {
    return $jMaZ8.useMemo(function() {
        var _ref = components || {}, slider = _ref.slider;
        return [
            slider || (0, $c4cc98f9d5c2f030$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


var $884752d6206fce3b$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
var $884752d6206fce3b$var$ColorPicker = /*#__PURE__*/ (0, $jMaZ8.forwardRef)(function(props, ref) {
    var value = props.value, defaultValue = props.defaultValue, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? (0, $3433f256d6eeb7cf$export$90004e2badfbdf1f) : _props$prefixCls, onChange = props.onChange, onChangeComplete = props.onChangeComplete, className = props.className, style = props.style, panelRender = props.panelRender, _props$disabledAlpha = props.disabledAlpha, disabledAlpha = _props$disabledAlpha === void 0 ? false : _props$disabledAlpha, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, components = props.components;
    // ========================== Components ==========================
    var _useComponent = (0, $48f4e4ce3e3f19a7$export$2e2bcd8739ae039)(components), _useComponent2 = (0, $3fkx6.default)(_useComponent, 1), Slider = _useComponent2[0];
    // ============================ Color =============================
    var _useColorState = (0, $78e55fb12a176c3d$export$2e2bcd8739ae039)(defaultValue || (0, $3433f256d6eeb7cf$export$f705f0fde43a55a), value), _useColorState2 = (0, $3fkx6.default)(_useColorState, 2), colorValue = _useColorState2[0], setColorValue = _useColorState2[1];
    var alphaColor = (0, $jMaZ8.useMemo)(function() {
        return colorValue.setA(1).toRgbString();
    }, [
        colorValue
    ]);
    // ============================ Events ============================
    var handleChange = function handleChange(data, type) {
        if (!value) setColorValue(data);
        onChange === null || onChange === void 0 || onChange(data, type);
    };
    // Convert
    var getHueColor = function getHueColor(hue) {
        return new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(colorValue.setHue(hue));
    };
    var getAlphaColor = function getAlphaColor(alpha) {
        return new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    };
    // Slider change
    var onHueChange = function onHueChange(hue) {
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    var onAlphaChange = function onAlphaChange(alpha) {
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    var onHueChangeComplete = function onHueChangeComplete(hue) {
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    var onAlphaChangeComplete = function onAlphaChangeComplete(alpha) {
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    var mergeCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-panel"), className, (0, $eq8kl.default)({}, "".concat(prefixCls, "-panel-disabled"), disabled));
    var sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    var defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $490f47636cb86cdb$export$2e2bcd8739ae039), (0, $hH60s.default)({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(prefixCls, "-slider-container")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-slider-group"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-slider-group-disabled-alpha"), disabledAlpha))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(Slider, (0, $hH60s.default)({}, sharedSliderProps, {
        type: "hue",
        colors: $884752d6206fce3b$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(Slider, (0, $hH60s.default)({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $255d83ff6e76c1b9$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
$884752d6206fce3b$var$ColorPicker.displayName = 'ColorPicker';
var $884752d6206fce3b$export$2e2bcd8739ae039 = $884752d6206fce3b$var$ColorPicker;






var $cef54a958c1a6785$export$2e2bcd8739ae039 = (0, $884752d6206fce3b$export$2e2bcd8739ae039);


const $d2c5d5c89b8a5d3a$export$d0aa8b5e56c9af06 = (value, alpha)=>(value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6)) || '';
const $d2c5d5c89b8a5d3a$export$6c90ef703dcfba25 = (value, alpha)=>value ? $d2c5d5c89b8a5d3a$export$d0aa8b5e56c9af06(value, alpha) : '';
let $d2c5d5c89b8a5d3a$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $klxbl.default)(this, AggregationColor);
        var _a;
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = (_a = color.colors) === null || _a === void 0 ? void 0 : _a.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map((_ref)=>{
                let { color: c, percent: percent } = _ref;
                return {
                    color: new AggregationColor(c),
                    percent: percent
                };
            });
            this.metaColor = new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $9O7LJ.default)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $d2c5d5c89b8a5d3a$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();



var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");

var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $1Esi2 = parcelRequire("1Esi2");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $a6yuN = parcelRequire("a6yuN");

var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");


var $jMaZ8 = parcelRequire("jMaZ8");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $f9696d522d8184cc$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style = props.style, children = props.children, isActive = props.isActive, role = props.role, customizeClassNames = props.classNames, styles = props.styles;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(isActive || forceRender), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(function() {
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content"), (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-content-active"), isActive), "".concat(prefixCls, "-content-inactive"), !isActive), className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content-box"), customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames.body),
        style: styles === null || styles === void 0 ? void 0 : styles.body
    }, children));
});
$f9696d522d8184cc$var$PanelContent.displayName = 'PanelContent';
var $f9696d522d8184cc$export$2e2bcd8739ae039 = $f9696d522d8184cc$var$PanelContent;


var $b1072c5724cff2ff$var$_excluded = [
    "showArrow",
    "headerClass",
    "isActive",
    "onItemClick",
    "forceRender",
    "className",
    "classNames",
    "styles",
    "prefixCls",
    "collapsible",
    "accordion",
    "panelKey",
    "extra",
    "header",
    "expandIcon",
    "openMotion",
    "destroyInactivePanel",
    "children"
];
var $b1072c5724cff2ff$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef(function(props, ref) {
    var _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, headerClass = props.headerClass, isActive = props.isActive, onItemClick = props.onItemClick, forceRender = props.forceRender, className = props.className, _props$classNames = props.classNames, customizeClassNames = _props$classNames === void 0 ? {} : _props$classNames, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, prefixCls = props.prefixCls, collapsible = props.collapsible, accordion = props.accordion, panelKey = props.panelKey, extra = props.extra, header = props.header, expandIcon = props.expandIcon, openMotion = props.openMotion, destroyInactivePanel = props.destroyInactivePanel, children = props.children, resetProps = (0, $4b02Q.default)(props, $b1072c5724cff2ff$var$_excluded);
    var disabled = collapsible === 'disabled';
    var ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    var collapsibleProps = (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({
        onClick: function onClick() {
            onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER || e.which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        role: accordion ? 'tab' : 'button'
    }, 'aria-expanded', isActive), 'aria-disabled', disabled), "tabIndex", disabled ? -1 : 0);
    // ======================== Icon ========================
    var iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("i", {
        className: "arrow"
    });
    var iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", (0, $hH60s.default)({
        className: "".concat(prefixCls, "-expand-icon")
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    var collapsePanelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-item"), (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-item-active"), isActive), "".concat(prefixCls, "-item-disabled"), disabled), className);
    var headerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(headerClass, "".concat(prefixCls, "-header"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-collapsible-").concat(collapsible), !!collapsible), customizeClassNames.header);
    // ======================== HeaderProps ========================
    var headerProps = (0, $8u3qN.default)({
        className: headerClassName,
        style: styles.header
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? {} : collapsibleProps);
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", (0, $hH60s.default)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", (0, $hH60s.default)({
        className: "".concat(prefixCls, "-header-text")
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(prefixCls, "-extra")
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $lsVqZ.default), (0, $hH60s.default)({
        visible: isActive,
        leavedClassName: "".concat(prefixCls, "-content-hidden")
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyInactivePanel
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $f9696d522d8184cc$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : void 0
        }, children);
    }));
});
var $b1072c5724cff2ff$export$2e2bcd8739ae039 = $b1072c5724cff2ff$var$CollapsePanel;


var $5e4177123e4aae7b$var$_excluded = [
    "children",
    "label",
    "key",
    "collapsible",
    "onItemClick",
    "destroyInactivePanel"
];
var $5e4177123e4aae7b$var$convertItemsToNodes = function convertItemsToNodes(items, props) {
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    return items.map(function(item, index) {
        var children = item.children, label = item.label, rawKey = item.key, rawCollapsible = item.collapsible, rawOnItemClick = item.onItemClick, rawDestroyInactivePanel = item.destroyInactivePanel, restProps = (0, $4b02Q.default)(item, $5e4177123e4aae7b$var$_excluded);
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        var key = String(rawKey !== null && rawKey !== void 0 ? rawKey : index);
        var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
        var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
        var handleItemClick = function handleItemClick(value) {
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
        };
        var isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $b1072c5724cff2ff$export$2e2bcd8739ae039), (0, $hH60s.default)({}, restProps, {
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyInactivePanel: mergeDestroyInactivePanel
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ var $5e4177123e4aae7b$var$getNewChild = function getNewChild(child, index, props) {
    if (!child) return null;
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    var key = child.key || String(index);
    var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, childDestroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible, childOnItemClick = _child$props.onItemClick;
    var isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
    var handleItemClick = function handleItemClick(value) {
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
    };
    var childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach(function(propName) {
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(child, childProps);
};
function $5e4177123e4aae7b$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $5e4177123e4aae7b$var$convertItemsToNodes(items, props);
    return (0, $a6yuN.default)(rawChildren).map(function(child, index) {
        return $5e4177123e4aae7b$var$getNewChild(child, index, props);
    });
}
var $5e4177123e4aae7b$export$2e2bcd8739ae039 = $5e4177123e4aae7b$var$useItems;




function $ef2cf0c0b3bee89c$var$getActiveKeysArray(activeKey) {
    var currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        var activeKeyType = (0, $1Esi2.default)(currentActiveKey);
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map(function(key) {
        return String(key);
    });
}
var $ef2cf0c0b3bee89c$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-collapse' : _props$prefixCls, _props$destroyInactiv = props.destroyInactivePanel, destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv, style = props.style, accordion = props.accordion, className = props.className, children = props.children, collapsible = props.collapsible, openMotion = props.openMotion, expandIcon = props.expandIcon, rawActiveKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, _onChange = props.onChange, items = props.items;
    var collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className);
    var _useMergedState = (0, $eGh7a.default)([], {
        value: rawActiveKey,
        onChange: function onChange(v) {
            return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
        },
        defaultValue: defaultActiveKey,
        postState: $ef2cf0c0b3bee89c$var$getActiveKeysArray
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), activeKey = _useMergedState2[0], setActiveKey = _useMergedState2[1];
    var onItemClick = function onItemClick(key) {
        return setActiveKey(function() {
            if (accordion) return activeKey[0] === key ? [] : [
                key
            ];
            var index = activeKey.indexOf(key);
            var isActive = index > -1;
            if (isActive) return activeKey.filter(function(item) {
                return item !== key;
            });
            return [].concat((0, $fvBso.default)(activeKey), [
                key
            ]);
        });
    };
    // ======================== Children ========================
    (0, $2bFmQ.default)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    var mergedChildren = (0, $5e4177123e4aae7b$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyInactivePanel: destroyInactivePanel,
        onItemClick: onItemClick,
        activeKey: activeKey
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", (0, $hH60s.default)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $ef2cf0c0b3bee89c$export$2e2bcd8739ae039 = Object.assign($ef2cf0c0b3bee89c$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $b1072c5724cff2ff$export$2e2bcd8739ae039)
});


var $14be7df18ca9ce0b$export$2e2bcd8739ae039 = (0, $ef2cf0c0b3bee89c$export$2e2bcd8739ae039);
/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */ var $14be7df18ca9ce0b$export$2ddb90ad54e5f587 = (0, $ef2cf0c0b3bee89c$export$2e2bcd8739ae039).Panel;



var $a6yuN = parcelRequire("a6yuN");

var $hvG6u = parcelRequire("hvG6u");






var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");



"use client";
const $88d0291aac805d45$var$CollapsePanel = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Collapse.Panel');
        warning.deprecated(!('disabled' in props), 'disabled', 'collapsible="disabled"');
    }
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $14be7df18ca9ce0b$export$2e2bcd8739ae039).Panel, Object.assign({
        ref: ref
    }, props, {
        prefixCls: prefixCls,
        className: collapsePanelClassName
    }));
});
var $88d0291aac805d45$export$2e2bcd8739ae039 = $88d0291aac805d45$var$CollapsePanel;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $86923e4ddcddee59$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $86923e4ddcddee59$export$2e2bcd8739ae039 = $86923e4ddcddee59$var$genCollapseMotion;


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $b263abe74039804d$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $4g3I0.unit)(collapsePanelBorderRadius)} ${(0, $4g3I0.unit)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $4g3I0.unit)(collapsePanelBorderRadius)} ${(0, $4g3I0.unit)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: Object.assign(Object.assign({
                    position: 'relative',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`
                }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)), {
                    [`> ${componentCls}-header-text`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        paddingInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$171ccda7bc085e59)()), {
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    }),
                    // >>>>> Text
                    [`${componentCls}-header-text`]: {
                        marginInlineEnd: 'auto'
                    }
                }),
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-header-text`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-content`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-content-box`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    borderRadius: `0 0 ${(0, $4g3I0.unit)(collapsePanelBorderRadius)} ${(0, $4g3I0.unit)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Position ==========================
            [`&${componentCls}-icon-position-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            paddingInlineEnd: 0,
                            paddingInlineStart: marginSM
                        }
                    }
                }
            }
        })
    };
};
const $b263abe74039804d$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $b263abe74039804d$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, paddingXXS: paddingXXS, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content`]: {
                backgroundColor: 'transparent',
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
                paddingTop: paddingXXS
            }
        }
    };
};
const $b263abe74039804d$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-content-box`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $b263abe74039804d$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer
    });
var $b263abe74039804d$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Collapse', (token)=>{
    const collapseToken = (0, $8APUt.merge)(token, {
        collapseHeaderPaddingSM: `${(0, $4g3I0.unit)(token.paddingXS)} ${(0, $4g3I0.unit)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $4g3I0.unit)(token.padding)} ${(0, $4g3I0.unit)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $b263abe74039804d$export$5ca74f7be820a85(collapseToken),
        $b263abe74039804d$var$genBorderlessStyle(collapseToken),
        $b263abe74039804d$var$genGhostStyle(collapseToken),
        $b263abe74039804d$var$genArrowStyle(collapseToken),
        (0, $86923e4ddcddee59$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $b263abe74039804d$export$9ca1be8807fe0675);


"use client";
const $8e4d794579cb4bd6$var$Collapse = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, collapse: collapse } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPosition: expandIconPosition = 'start', children: children, expandIcon: expandIcon } = props;
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a !== void 0 ? _a : 'middle';
    });
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b263abe74039804d$export$2e2bcd8739ae039)(prefixCls);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Collapse');
        // Warning if use legacy type `expandIconPosition`
        warning(expandIconPosition !== 'left' && expandIconPosition !== 'right', 'deprecated', '`expandIconPosition` with `left` or `right` is deprecated. Please use `start` or `end` instead.');
    }
    // Align with logic position
    const mergedExpandIconPosition = $jMaZ8.useMemo(()=>{
        if (expandIconPosition === 'left') return 'start';
        return expandIconPosition === 'right' ? 'end' : expandIconPosition;
    }, [
        expandIconPosition
    ]);
    const mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : collapse === null || collapse === void 0 ? void 0 : collapse.expandIcon;
    const renderExpandIcon = $jMaZ8.useCallback(function() {
        let panelProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $jMaZ8.createElement((0, $467563d24654b2cc$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(icon, ()=>{
            var _a;
            return {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_a = icon === null || icon === void 0 ? void 0 : icon.props) === null || _a === void 0 ? void 0 : _a.className, `${prefixCls}-arrow`)
            };
        });
    }, [
        mergedExpandIcon,
        prefixCls
    ]);
    const collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
    }, collapse === null || collapse === void 0 ? void 0 : collapse.className, className, rootClassName, hashId, cssVarCls);
    const openMotion = Object.assign(Object.assign({}, (0, $230791b6f61cb981$export$2e2bcd8739ae039)(rootPrefixCls)), {
        motionAppear: false,
        leavedClassName: `${prefixCls}-content-hidden`
    });
    const items = $jMaZ8.useMemo(()=>{
        if (children) return (0, $a6yuN.default)(children).map((child, index)=>{
            var _a, _b;
            const childProps = child.props;
            if (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) {
                const key = (_a = child.key) !== null && _a !== void 0 ? _a : String(index);
                const mergedChildProps = Object.assign(Object.assign({}, (0, $hvG6u.default)(child.props, [
                    'disabled'
                ])), {
                    key: key,
                    collapsible: (_b = childProps.collapsible) !== null && _b !== void 0 ? _b : 'disabled'
                });
                return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(child, mergedChildProps);
            }
            return child;
        });
        return null;
    }, [
        children
    ]);
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    $jMaZ8.createElement((0, $14be7df18ca9ce0b$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        openMotion: openMotion
    }, (0, $hvG6u.default)(props, [
        'rootClassName'
    ]), {
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: Object.assign(Object.assign({}, collapse === null || collapse === void 0 ? void 0 : collapse.style), style)
    }), items));
});
$8e4d794579cb4bd6$var$Collapse.displayName = 'Collapse';
var $8e4d794579cb4bd6$export$2e2bcd8739ae039 = Object.assign($8e4d794579cb4bd6$var$Collapse, {
    Panel: (0, $88d0291aac805d45$export$2e2bcd8739ae039)
});


"use client";
var $55afc521486ca598$export$2e2bcd8739ae039 = (0, $8e4d794579cb4bd6$export$2e2bcd8739ae039);





var $fvBso = parcelRequire("fvBso");


const $0bf76fc60ccce859$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $d2c5d5c89b8a5d3a$export$e8cc8a2e87e145b4)) return color;
    return new (0, $d2c5d5c89b8a5d3a$export$e8cc8a2e87e145b4)(color);
};
const $0bf76fc60ccce859$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $0bf76fc60ccce859$export$3c8ae3c73ab0e52a = (color)=>$0bf76fc60ccce859$export$8d6531175688484b(color.toHsb().a * 100);
const $0bf76fc60ccce859$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $0bf76fc60ccce859$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $0bf76fc60ccce859$export$c844f5d21427d1ab(rgba);
};
const $0bf76fc60ccce859$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $fvBso.default)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};


"use client";
const $c7b09b0947e9b980$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $0bf76fc60ccce859$export$c844f5d21427d1ab));
        return value;
    });
const $c7b09b0947e9b980$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $6ed18c751601c2fb$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $c7b09b0947e9b980$var$genCollapsePanelKey = (preset, index)=>{
    var _a;
    const mergedKey = (_a = preset.key) !== null && _a !== void 0 ? _a : index;
    return `panel-${mergedKey}`;
};
const $c7b09b0947e9b980$var$ColorPresets = (_ref)=>{
    let { prefixCls: prefixCls, presets: presets, value: color, onChange: onChange } = _ref;
    const [locale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('ColorPicker');
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const [presetsValue] = (0, $eGh7a.default)($c7b09b0947e9b980$var$genPresetColor(presets), {
        value: $c7b09b0947e9b980$var$genPresetColor(presets),
        postState: $c7b09b0947e9b980$var$genPresetColor
    });
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $jMaZ8.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($c7b09b0947e9b980$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange === null || onChange === void 0 || onChange(colorValue);
    };
    const items = presetsValue.map((preset, index)=>{
        var _a;
        return {
            key: $c7b09b0947e9b980$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset === null || preset === void 0 ? void 0 : preset.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset === null || preset === void 0 ? void 0 : preset.colors) && ((_a = preset.colors) === null || _a === void 0 ? void 0 : _a.length) > 0 ? preset.colors.map((presetColor, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $255d83ff6e76c1b9$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: (0, $0bf76fc60ccce859$export$c844f5d21427d1ab)(presetColor).toRgbString(),
                    prefixCls: prefixCls,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toHexString() === (color === null || color === void 0 ? void 0 : color.toHexString()),
                        [`${colorPresetsPrefixCls}-color-bright`]: $c7b09b0947e9b980$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $55afc521486ca598$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $c7b09b0947e9b980$export$2e2bcd8739ae039 = $c7b09b0947e9b980$var$ColorPresets;


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $369f5a8eefeb26ed$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize } = token;
    const buttonToken = (0, $8APUt.merge)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
};
const $369f5a8eefeb26ed$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c, _d, _e, _f;
    const contentFontSize = (_a = token.contentFontSize) !== null && _a !== void 0 ? _a : token.fontSize;
    const contentFontSizeSM = (_b = token.contentFontSizeSM) !== null && _b !== void 0 ? _b : token.fontSize;
    const contentFontSizeLG = (_c = token.contentFontSizeLG) !== null && _c !== void 0 ? _c : token.fontSizeLG;
    const contentLineHeight = (_d = token.contentLineHeight) !== null && _d !== void 0 ? _d : (0, $a781ce02464c6480$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = (_e = token.contentLineHeightSM) !== null && _e !== void 0 ? _e : (0, $a781ce02464c6480$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = (_f = token.contentLineHeightLG) !== null && _f !== void 0 ? _f : (0, $a781ce02464c6480$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $c7b09b0947e9b980$export$6341b37cb79161da)(new (0, $d2c5d5c89b8a5d3a$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    return {
        fontWeight: 400,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorder,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0)
    };
};


// ============================== Shared ==============================
const $6cc0f3f6146caf68$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, marginXS: marginXS, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: token.marginXS,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            background: 'transparent',
            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} transparent`,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            color: token.colorText,
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $134f73cf3485ce91$export$171ccda7bc085e59)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $134f73cf3485ce91$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                },
                [`&${componentCls}-round`]: {
                    width: 'auto'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((transition)=>`${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPosition
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(marginXS).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(marginXS).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(marginXS).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(marginXS).mul(-1).equal()
                    }
                }
            }
        }
    };
};
const $6cc0f3f6146caf68$var$genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle)=>({
        [`&:not(:disabled):not(${btnCls}-disabled)`]: {
            '&:hover': hoverStyle,
            '&:active': activeStyle
        }
    });
// ============================== Shape ===============================
const $6cc0f3f6146caf68$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        borderRadius: '50%'
    });
const $6cc0f3f6146caf68$var$genRoundButtonStyle = (token)=>({
        borderRadius: token.controlHeight,
        paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
        paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
    });
const $6cc0f3f6146caf68$var$genDisabledStyle = (token)=>({
        cursor: 'not-allowed',
        borderColor: token.borderColorDisabled,
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        boxShadow: 'none'
    });
const $6cc0f3f6146caf68$var$genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle)=>({
        [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
            color: textColor || undefined,
            background: background,
            borderColor: borderColor || undefined,
            boxShadow: 'none'
        }, $6cc0f3f6146caf68$var$genHoverActiveButtonStyle(btnCls, Object.assign({
            background: background
        }, hoverStyle), Object.assign({
            background: background
        }, activeStyle))), {
            '&:disabled': {
                cursor: 'not-allowed',
                color: textColorDisabled || undefined,
                borderColor: borderColorDisabled || undefined
            }
        })
    });
const $6cc0f3f6146caf68$var$genSolidDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, $6cc0f3f6146caf68$var$genDisabledStyle(token))
    });
const $6cc0f3f6146caf68$var$genPureDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: {
            cursor: 'not-allowed',
            color: token.colorTextDisabled
        }
    });
// ============================== Variant =============================
const $6cc0f3f6146caf68$var$genVariantButtonStyle = (token, hoverStyle, activeStyle, variant)=>{
    const isPureDisabled = variant && [
        'link',
        'text'
    ].includes(variant);
    const genDisabledButtonStyle = isPureDisabled ? $6cc0f3f6146caf68$var$genPureDisabledButtonStyle : $6cc0f3f6146caf68$var$genSolidDisabledButtonStyle;
    return Object.assign(Object.assign({}, genDisabledButtonStyle(token)), $6cc0f3f6146caf68$var$genHoverActiveButtonStyle(token.componentCls, hoverStyle, activeStyle));
};
const $6cc0f3f6146caf68$var$genSolidButtonStyle = (token, textColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-solid`]: Object.assign({
            color: textColor,
            background: background
        }, $6cc0f3f6146caf68$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $6cc0f3f6146caf68$var$genOutlinedDashedButtonStyle = (token, borderColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-outlined, &${token.componentCls}-variant-dashed`]: Object.assign({
            borderColor: borderColor,
            background: background
        }, $6cc0f3f6146caf68$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $6cc0f3f6146caf68$var$genDashedButtonStyle = (token)=>({
        [`&${token.componentCls}-variant-dashed`]: {
            borderStyle: 'dashed'
        }
    });
const $6cc0f3f6146caf68$var$genFilledButtonStyle = (token, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-filled`]: Object.assign({
            boxShadow: 'none',
            background: background
        }, $6cc0f3f6146caf68$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $6cc0f3f6146caf68$var$genTextLinkButtonStyle = (token, textColor, variant, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-${variant}`]: Object.assign({
            color: textColor,
            boxShadow: 'none'
        }, $6cc0f3f6146caf68$var$genVariantButtonStyle(token, hoverStyle, activeStyle, variant))
    });
// =============================== Color ==============================
const $6cc0f3f6146caf68$var$genPresetColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return (0, $eb2ddc4f321ac793$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const darkColor = token[`${colorKey}6`];
        const lightColor = token[`${colorKey}1`];
        const hoverColor = token[`${colorKey}5`];
        const lightHoverColor = token[`${colorKey}2`];
        const lightBorderColor = token[`${colorKey}3`];
        const activeColor = token[`${colorKey}7`];
        const boxShadow = `0 ${(0, $4g3I0.unit)(token.controlOutlineWidth)} 0 ${token[`${colorKey}1`]}`;
        return Object.assign(Object.assign({}, prev), {
            [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                color: darkColor,
                boxShadow: boxShadow
            }, $6cc0f3f6146caf68$var$genSolidButtonStyle(token, token.colorTextLightSolid, darkColor, {
                background: hoverColor
            }, {
                background: activeColor
            })), $6cc0f3f6146caf68$var$genOutlinedDashedButtonStyle(token, darkColor, token.colorBgContainer, {
                color: hoverColor,
                borderColor: hoverColor,
                background: token.colorBgContainer
            }, {
                color: activeColor,
                borderColor: activeColor,
                background: token.colorBgContainer
            })), $6cc0f3f6146caf68$var$genDashedButtonStyle(token)), $6cc0f3f6146caf68$var$genFilledButtonStyle(token, lightColor, {
                background: lightHoverColor
            }, {
                background: lightBorderColor
            })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, darkColor, 'link', {
                color: hoverColor
            }, {
                color: activeColor
            })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, darkColor, 'text', {
                color: hoverColor,
                background: lightColor
            }, {
                color: activeColor,
                background: lightBorderColor
            }))
        });
    }, {});
};
const $6cc0f3f6146caf68$var$genDefaultButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.defaultColor,
        boxShadow: token.defaultShadow
    }, $6cc0f3f6146caf68$var$genSolidButtonStyle(token, token.solidTextColor, token.colorBgSolid, {
        color: token.solidTextColor,
        background: token.colorBgSolidHover
    }, {
        color: token.solidTextColor,
        background: token.colorBgSolidActive
    })), $6cc0f3f6146caf68$var$genDashedButtonStyle(token)), $6cc0f3f6146caf68$var$genFilledButtonStyle(token, token.colorFillTertiary, {
        background: token.colorFillSecondary
    }, {
        background: token.colorFill
    })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, token.textTextColor, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    })), $6cc0f3f6146caf68$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder));
const $6cc0f3f6146caf68$var$genPrimaryButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorPrimary,
        boxShadow: token.primaryShadow
    }, $6cc0f3f6146caf68$var$genOutlinedDashedButtonStyle(token, token.colorPrimary, token.colorBgContainer, {
        color: token.colorPrimaryTextHover,
        borderColor: token.colorPrimaryHover,
        background: token.colorBgContainer
    }, {
        color: token.colorPrimaryTextActive,
        borderColor: token.colorPrimaryActive,
        background: token.colorBgContainer
    })), $6cc0f3f6146caf68$var$genDashedButtonStyle(token)), $6cc0f3f6146caf68$var$genFilledButtonStyle(token, token.colorPrimaryBg, {
        background: token.colorPrimaryBgHover
    }, {
        background: token.colorPrimaryBorder
    })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, token.colorLink, 'text', {
        color: token.colorPrimaryTextHover,
        background: token.colorPrimaryBg
    }, {
        color: token.colorPrimaryTextActive,
        background: token.colorPrimaryBorder
    })), $6cc0f3f6146caf68$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    }));
const $6cc0f3f6146caf68$var$genDangerousStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorError,
        boxShadow: token.dangerShadow
    }, $6cc0f3f6146caf68$var$genSolidButtonStyle(token, token.dangerColor, token.colorError, {
        background: token.colorErrorHover
    }, {
        background: token.colorErrorActive
    })), $6cc0f3f6146caf68$var$genOutlinedDashedButtonStyle(token, token.colorError, token.colorBgContainer, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorBorderHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    })), $6cc0f3f6146caf68$var$genDashedButtonStyle(token)), $6cc0f3f6146caf68$var$genFilledButtonStyle(token, token.colorErrorBg, {
        background: token.colorErrorBgFilledHover
    }, {
        background: token.colorErrorBgActive
    })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, token.colorError, 'text', {
        color: token.colorErrorHover,
        background: token.colorErrorBg
    }, {
        color: token.colorErrorHover,
        background: token.colorErrorBgActive
    })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, token.colorError, 'link', {
        color: token.colorErrorHover
    }, {
        color: token.colorErrorActive
    })), $6cc0f3f6146caf68$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    }));
const $6cc0f3f6146caf68$var$genColorButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return Object.assign({
        [`${componentCls}-color-default`]: $6cc0f3f6146caf68$var$genDefaultButtonStyle(token),
        [`${componentCls}-color-primary`]: $6cc0f3f6146caf68$var$genPrimaryButtonStyle(token),
        [`${componentCls}-color-dangerous`]: $6cc0f3f6146caf68$var$genDangerousStyle(token)
    }, $6cc0f3f6146caf68$var$genPresetColorStyle(token));
};
// =========== Compatible with versions earlier than 5.21.0 ===========
const $6cc0f3f6146caf68$var$genCompatibleButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign({}, $6cc0f3f6146caf68$var$genOutlinedDashedButtonStyle(token, token.defaultBorderColor, token.defaultBg, {
        color: token.defaultHoverColor,
        borderColor: token.defaultHoverBorderColor,
        background: token.defaultHoverBg
    }, {
        color: token.defaultActiveColor,
        borderColor: token.defaultActiveBorderColor,
        background: token.defaultActiveBg
    })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, token.textTextColor, 'text', {
        color: token.textTextHoverColor,
        background: token.textHoverBg
    }, {
        color: token.textTextActiveColor,
        background: token.colorBgTextActive
    })), $6cc0f3f6146caf68$var$genSolidButtonStyle(token, token.primaryColor, token.colorPrimary, {
        background: token.colorPrimaryHover,
        color: token.primaryColor
    }, {
        background: token.colorPrimaryActive,
        color: token.primaryColor
    })), $6cc0f3f6146caf68$var$genTextLinkButtonStyle(token, token.colorLink, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    }));
// =============================== Size ===============================
const $6cc0f3f6146caf68$var$genButtonStyle = function(token) {
    let prefixCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $4g3I0.unit)(buttonPaddingVertical)} ${(0, $4g3I0.unit)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $6cc0f3f6146caf68$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: $6cc0f3f6146caf68$var$genRoundButtonStyle(token)
        }
    ];
};
const $6cc0f3f6146caf68$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $8APUt.merge)(token, {
        fontSize: token.contentFontSize
    });
    return $6cc0f3f6146caf68$var$genButtonStyle(baseToken, token.componentCls);
};
const $6cc0f3f6146caf68$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $8APUt.merge)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $6cc0f3f6146caf68$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $6cc0f3f6146caf68$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $8APUt.merge)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $6cc0f3f6146caf68$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $6cc0f3f6146caf68$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$6cc0f3f6146caf68$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Button', (token)=>{
    const buttonToken = (0, $369f5a8eefeb26ed$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $6cc0f3f6146caf68$var$genSharedButtonStyle(buttonToken),
        // Size
        $6cc0f3f6146caf68$var$genSizeBaseButtonStyle(buttonToken),
        $6cc0f3f6146caf68$var$genSizeSmallButtonStyle(buttonToken),
        $6cc0f3f6146caf68$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $6cc0f3f6146caf68$var$genBlockButtonStyle(buttonToken),
        // Color
        $6cc0f3f6146caf68$var$genColorButtonStyle(buttonToken),
        // https://github.com/ant-design/ant-design/issues/50969
        $6cc0f3f6146caf68$var$genCompatibleButtonStyle(buttonToken),
        // Button Group
        (0, $bb28462c069ee011$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $369f5a8eefeb26ed$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// handle border collapse
function $2bdaa96870b686b7$var$compactItemBorder(token, parentCls, options) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        '&-item': Object.assign(Object.assign({
            [hoverEffects]: {
                zIndex: 2
            }
        }, focusElCls ? {
            [`&${focusElCls}`]: {
                zIndex: 2
            }
        } : {}), {
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        })
    };
}
// handle border-radius
function $2bdaa96870b686b7$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $2bdaa96870b686b7$export$b1208b23589b4b73(token) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
    };
    const { componentCls: componentCls } = token;
    const compactCls = `${componentCls}-compact`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $2bdaa96870b686b7$var$compactItemBorder(token, compactCls, options)), $2bdaa96870b686b7$var$compactItemBorderRadius(componentCls, compactCls, options))
    };
}


function $a081f93b9cb7b661$var$compactItemVerticalBorder(token, parentCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 2
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $a081f93b9cb7b661$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $a081f93b9cb7b661$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $a081f93b9cb7b661$var$compactItemVerticalBorder(token, compactCls)), $a081f93b9cb7b661$var$compactItemBorderVerticalRadius(token.componentCls, compactCls))
    };
}




const $8a32e6b5d29c66df$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, colorPrimaryHover: colorPrimaryHover, lineWidth: lineWidth, calc: calc } = token;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical)=>{
        const selector = `${componentCls}-compact${vertical ? '-vertical' : ''}-item${componentCls}-primary:not([disabled])`;
        return {
            [`${selector} + ${selector}::before`]: {
                position: 'absolute',
                top: vertical ? insetOffset : 0,
                insetInlineStart: vertical ? 0 : insetOffset,
                backgroundColor: colorPrimaryHover,
                content: '""',
                width: vertical ? '100%' : lineWidth,
                height: vertical ? lineWidth : '100%'
            }
        };
    };
    // Special styles for Primary Button
    return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
};
var // ============================== Export ==============================
$8a32e6b5d29c66df$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$1537386bc155ea56)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $369f5a8eefeb26ed$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $2bdaa96870b686b7$export$b1208b23589b4b73)(buttonToken),
        (0, $a081f93b9cb7b661$export$4dc87cb8ebf78ac6)(buttonToken),
        $8a32e6b5d29c66df$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $369f5a8eefeb26ed$export$9ca1be8807fe0675));


"use client";
var $e1880e6c28c7965b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e1880e6c28c7965b$var$getLoadingConfig(loading) {
    if (typeof loading === 'object' && loading) {
        let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
        delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $e1880e6c28c7965b$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    link: [
        'primary',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $e1880e6c28c7965b$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((props, ref)=>{
    var _a, _b, _c, _d;
    const { loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: shape = 'default', size: customizeSize, styles: styles, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition = 'start', ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: customClassNames, style: customStyle = {}, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus } = props, rest = $e1880e6c28c7965b$var$__rest(props, [
        "loading",
        "prefixCls",
        "color",
        "variant",
        "type",
        "danger",
        "shape",
        "size",
        "styles",
        "disabled",
        "className",
        "rootClassName",
        "children",
        "icon",
        "iconPosition",
        "ghost",
        "block",
        "htmlType",
        "classNames",
        "style",
        "autoInsertSpace",
        "autoFocus"
    ]);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const [mergedColor, mergedVariant] = (0, $jMaZ8.useMemo)(()=>{
        if (color && variant) return [
            color,
            variant
        ];
        const colorVariantPair = $e1880e6c28c7965b$var$ButtonTypeMap[mergedType] || [];
        if (danger) return [
            'danger',
            colorVariantPair[1]
        ];
        return colorVariantPair;
    }, [
        type,
        color,
        variant,
        danger
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const { getPrefixCls: getPrefixCls, direction: direction, button: button } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : button === null || button === void 0 ? void 0 : button.autoInsertSpace) !== null && _a !== void 0 ? _a : true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6cc0f3f6146caf68$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $jMaZ8.useContext)((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const groupSize = (0, $jMaZ8.useContext)((0, $fb0e0a37019421f1$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $jMaZ8.useMemo)(()=>$e1880e6c28c7965b$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $jMaZ8.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $jMaZ8.useState)(false);
    const buttonRef = (0, $jMaZ8.useRef)(null);
    const mergedRef = (0, $1cfGC.useComposeRef)(ref, buttonRef);
    const needInserted = (0, $jMaZ8.Children).count(children) === 1 && !icon && !(0, $e4847c5f9a9fd582$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $jMaZ8.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading
    (0, $jMaZ8.useEffect)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay
    ]);
    // Two chinese characters check
    (0, $jMaZ8.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $e4847c5f9a9fd582$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, $jMaZ8.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useCallback((e)=>{
        var _a;
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        (_a = props.onClick) === null || _a === void 0 || _a.call(props, e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Button');
        warning(!(typeof icon === 'string' && icon.length > 2), 'breaking', `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`);
        warning(!(ghost && (0, $e4847c5f9a9fd582$export$b120bc11c0d9c214)(mergedVariant)), 'usage', "`link` or `text` button can't be a `ghost` button.");
    }
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $b481086641a221d4$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    const sizeFullName = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctxSize)=>{
        var _a, _b;
        return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
    });
    const sizeCls = sizeFullName ? (_b = sizeClassNameMap[sizeFullName]) !== null && _b !== void 0 ? _b : '' : '';
    const iconType = innerLoading ? 'loading' : icon;
    const linkButtonRestProps = (0, $hvG6u.default)(rest, [
        'navigate'
    ]);
    // ========================= Render =========================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== 'default' && shape,
        // line(253 - 254): Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $e4847c5f9a9fd582$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: iconPosition === 'end'
    }, compactItemClassnames, className, rootClassName, button === null || button === void 0 ? void 0 : button.className);
    const fullStyle = Object.assign(Object.assign({}, button === null || button === void 0 ? void 0 : button.style), customStyle);
    const iconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, (_c = button === null || button === void 0 ? void 0 : button.classNames) === null || _c === void 0 ? void 0 : _c.icon);
    const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), ((_d = button === null || button === void 0 ? void 0 : button.styles) === null || _d === void 0 ? void 0 : _d.icon) || {});
    const iconNode = icon && !innerLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $0694ae187f492140$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, icon) : loading && typeof loading === 'object' && loading.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $0694ae187f492140$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, loading.icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $2643ed47118c83df$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current
    });
    const kids = children || children === 0 ? (0, $e4847c5f9a9fd582$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("button", Object.assign({}, rest, {
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }), iconNode, kids, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $8a32e6b5d29c66df$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $e4847c5f9a9fd582$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $de29c1080c02bd8d$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return wrapCSSVar(buttonNode);
});
const $e1880e6c28c7965b$var$Button = $e1880e6c28c7965b$var$InternalCompoundedButton;
$e1880e6c28c7965b$var$Button.Group = (0, $fb0e0a37019421f1$export$2e2bcd8739ae039);
$e1880e6c28c7965b$var$Button.__ANT_BUTTON = true;
$e1880e6c28c7965b$var$Button.displayName = 'Button';
var $e1880e6c28c7965b$export$2e2bcd8739ae039 = $e1880e6c28c7965b$var$Button;



"use client";
var $db1677af4d8cff50$export$2e2bcd8739ae039 = (0, $e1880e6c28c7965b$export$2e2bcd8739ae039);




var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
parcelRequire("lsVqZ");
var $iCAxj = parcelRequire("iCAxj");
var $lsVqZ = parcelRequire("lsVqZ");




var $jMaZ8 = parcelRequire("jMaZ8");
function $408ad1e85f1cb2fa$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = $jMaZ8.useState(value);
    $jMaZ8.useEffect(()=>{
        const timeout = setTimeout(()=>{
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $78a4550be43d31f2$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
            '&-appear, &-enter': {
                opacity: 0,
                '&-active': {
                    opacity: 1
                }
            },
            '&-leave': {
                opacity: 1,
                '&-active': {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationFast} ${token.motionEaseInOut},
                     opacity ${token.motionDurationFast} ${token.motionEaseInOut},
                     transform ${token.motionDurationFast} ${token.motionEaseInOut} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    '&-active': {
                        transform: 'translateY(0)',
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $78a4550be43d31f2$export$2e2bcd8739ae039 = $78a4550be43d31f2$var$genFormValidateMotionStyle;


const $b0ebdf17cc7e6c79$var$resetForm = (token)=>({
        legend: {
            display: 'block',
            width: '100%',
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: 'inherit',
            border: 0,
            borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: 'border-box'
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: 'normal'
        },
        'input[type="file"]': {
            display: 'block'
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: 'block',
            width: '100%'
        },
        // Make multiple select elements height not fixed
        'select[multiple], select[size]': {
            height: 'auto'
        },
        // Focus for file, radio, and checkbox
        [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $4g3I0.unit)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: 'block',
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $b0ebdf17cc7e6c79$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $b0ebdf17cc7e6c79$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [token.componentCls]: Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), $b0ebdf17cc7e6c79$var$resetForm(token)), {
            [`${componentCls}-text`]: {
                display: 'inline-block',
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            '&-small': Object.assign({}, $b0ebdf17cc7e6c79$var$genFormSize(token, token.controlHeightSM)),
            '&-large': Object.assign({}, $b0ebdf17cc7e6c79$var$genFormSize(token, token.controlHeightLG))
        })
    };
};
const $b0ebdf17cc7e6c79$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, componentCls: componentCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    return {
        [formItemCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            marginBottom: itemMarginBottom,
            verticalAlign: 'top',
            '&-with-help': {
                transition: 'none'
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: 'none'
            },
            '&-has-warning': {
                [`${formItemCls}-split`]: {
                    color: token.colorError
                }
            },
            '&-has-error': {
                [`${formItemCls}-split`]: {
                    color: token.colorWarning
                }
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textAlign: 'end',
                verticalAlign: 'middle',
                '&-left': {
                    textAlign: 'start'
                },
                '&-wrap': {
                    overflow: 'unset',
                    lineHeight: token.lineHeight,
                    whiteSpace: 'unset'
                },
                '> label': {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    maxWidth: '100%',
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: 'top'
                    },
                    // Required mark
                    [`&${formItemCls}-required:not(${formItemCls}-required-mark-optional)::before`]: {
                        display: 'inline-block',
                        marginInlineEnd: token.marginXXS,
                        color: labelRequiredMarkColor,
                        fontSize: token.fontSize,
                        fontFamily: 'SimSun, sans-serif',
                        lineHeight: 1,
                        content: '"*"',
                        [`${componentCls}-hide-required-mark &`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: 'inline-block',
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`${componentCls}-hide-required-mark &`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: 'help',
                        writingMode: 'horizontal-tb',
                        marginInlineStart: token.marginXXS
                    },
                    '&::after': {
                        content: '":"',
                        position: 'relative',
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                ['--ant-display']: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: '100%'
                },
                '&-input': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: token.controlHeight,
                    '&-content': {
                        flex: 'auto',
                        maxWidth: '100%'
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                '&-additional': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '&-explain, &-extra': {
                    clear: 'both',
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                '&-explain-connected': {
                    width: '100%'
                },
                '&-extra': {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                '&-explain': {
                    '&-error': {
                        color: token.colorError
                    },
                    '&-warning': {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: 'auto',
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: 'center',
                visibility: 'visible',
                animationName: (0, $90d7c1b8e663dcab$export$3b71758b3ed5255f),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: 'none',
                '&-success': {
                    color: token.colorSuccess
                },
                '&-error': {
                    color: token.colorError
                },
                '&-warning': {
                    color: token.colorWarning
                },
                '&-validating': {
                    color: token.colorPrimary
                }
            }
        })
    };
};
const $b0ebdf17cc7e6c79$var$genHorizontalStyle = (token, className)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [`${className}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: '1 1 0',
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: 'unset'
                }
            }
        }
    };
};
const $b0ebdf17cc7e6c79$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: 'flex',
            flexWrap: 'wrap',
            [formItemCls]: {
                flex: 'none',
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                '&-row': {
                    flexWrap: 'nowrap'
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                [`> ${formItemCls}-label`]: {
                    flex: 'none'
                },
                [`${componentCls}-text`]: {
                    display: 'inline-block'
                },
                [`${formItemCls}-has-feedback`]: {
                    display: 'inline-block'
                }
            }
        }
    };
};
const $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: 'initial',
        textAlign: 'start',
        '> label': {
            margin: 0,
            '&::after': {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: 'hidden'
            }
        }
    });
const $b0ebdf17cc7e6c79$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: 'wrap',
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: '0 0 100%',
                        maxWidth: '100%'
                    }
                }
            }
        }
    };
};
const $b0ebdf17cc7e6c79$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                [`${formItemCls}-row`]: {
                    flexDirection: 'column'
                },
                [`${formItemCls}-label > label`]: {
                    height: 'auto'
                },
                [`${formItemCls}-control`]: {
                    width: '100%'
                },
                [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenXSMax)})`]: [
            $b0ebdf17cc7e6c79$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $b0ebdf17cc7e6c79$var$genItemVerticalStyle = (token)=>{
    const { formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: 'column'
            },
            [`${formItemCls}-label > label`]: {
                height: 'auto'
            },
            [`${formItemCls}-control`]: {
                width: '100%'
            }
        },
        [`${formItemCls}-vertical ${formItemCls}-label,
      ${antCls}-col-24${formItemCls}-label,
      ${antCls}-col-xl-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token),
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenXSMax)})`]: [
            $b0ebdf17cc7e6c79$var$makeVerticalLayout(token),
            {
                [formItemCls]: {
                    [`${antCls}-col-xs-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
                }
            }
        ],
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenSMMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-sm-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenMDMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-md-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $4g3I0.unit)(token.screenLGMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-lg-24${formItemCls}-label`]: $b0ebdf17cc7e6c79$var$makeVerticalLayoutLabel(token)
            }
        }
    };
};
const $b0ebdf17cc7e6c79$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $b0ebdf17cc7e6c79$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $8APUt.merge)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $b0ebdf17cc7e6c79$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Form', (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const formToken = $b0ebdf17cc7e6c79$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $b0ebdf17cc7e6c79$var$genFormStyle(formToken),
        $b0ebdf17cc7e6c79$var$genFormItemStyle(formToken),
        (0, $78a4550be43d31f2$export$2e2bcd8739ae039)(formToken),
        $b0ebdf17cc7e6c79$var$genHorizontalStyle(formToken, formToken.componentCls),
        $b0ebdf17cc7e6c79$var$genHorizontalStyle(formToken, formToken.formItemCls),
        $b0ebdf17cc7e6c79$var$genInlineStyle(formToken),
        $b0ebdf17cc7e6c79$var$genVerticalStyle(formToken),
        $b0ebdf17cc7e6c79$var$genItemVerticalStyle(formToken),
        (0, $86923e4ddcddee59$export$2e2bcd8739ae039)(formToken),
        (0, $90d7c1b8e663dcab$export$3b71758b3ed5255f)
    ];
}, $b0ebdf17cc7e6c79$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});


"use client";
const $32422ef2e04db442$var$EMPTY_LIST = [];
function $32422ef2e04db442$var$toErrorEntity(error, prefix, errorStatus) {
    let index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return {
        key: typeof error === 'string' ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $32422ef2e04db442$var$ErrorList = (_ref)=>{
    let { help: help, helpStatus: helpStatus, errors: errors = $32422ef2e04db442$var$EMPTY_LIST, warnings: warnings = $32422ef2e04db442$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged } = _ref;
    const { prefixCls: prefixCls } = $jMaZ8.useContext((0, $ee23d3c241510852$export$fb6582d3042cc879));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b0ebdf17cc7e6c79$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const collapseMotion = $jMaZ8.useMemo(()=>(0, $230791b6f61cb981$export$2e2bcd8739ae039)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $408ad1e85f1cb2fa$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $408ad1e85f1cb2fa$export$2e2bcd8739ae039)(warnings);
    const fullKeyList = $jMaZ8.useMemo(()=>{
        if (help !== undefined && help !== null) return [
            $32422ef2e04db442$var$toErrorEntity(help, 'help', helpStatus)
        ];
        return [].concat((0, $fvBso.default)(debounceErrors.map((error, index)=>$32422ef2e04db442$var$toErrorEntity(error, 'error', 'error', index))), (0, $fvBso.default)(debounceWarnings.map((warning, index)=>$32422ef2e04db442$var$toErrorEntity(warning, 'warning', 'warning', index))));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    const filledKeyFullKeyList = $jMaZ8.useMemo(()=>{
        const keysCount = {};
        fullKeyList.forEach((_ref2)=>{
            let { key: key } = _ref2;
            keysCount[key] = (keysCount[key] || 0) + 1;
        });
        return fullKeyList.map((entity, index)=>Object.assign(Object.assign({}, entity), {
                key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
            }));
    }, [
        fullKeyList
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!filledKeyFullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, helpProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(baseClassName, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
            style: holderStyle,
            role: "alert"
        }), /*#__PURE__*/ $jMaZ8.createElement((0, $iCAxj.default), Object.assign({
            keys: filledKeyFullKeyList
        }, (0, $230791b6f61cb981$export$2e2bcd8739ae039)(prefixCls), {
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }), (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $jMaZ8.createElement("div", {
                key: key,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(itemClassName, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: itemStyle
            }, error);
        }));
    }));
};
var $32422ef2e04db442$export$2e2bcd8739ae039 = $32422ef2e04db442$var$ErrorList;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $6wVix = parcelRequire("6wVix");
var $4440P = parcelRequire("4440P");







var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("6wVix");
var $4sljH = parcelRequire("4sljH");

var $cYkhj = parcelRequire("cYkhj");

var $7PWCI = parcelRequire("7PWCI");
// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $a98819dd0f313b11$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $a98819dd0f313b11$var$defaultItemNamePrefixCls = 'form_item';
function $a98819dd0f313b11$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $a98819dd0f313b11$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $a98819dd0f313b11$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$a98819dd0f313b11$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $a98819dd0f313b11$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}


function $5da403be341a20aa$var$toNamePathStr(name) {
    const namePath = (0, $a98819dd0f313b11$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $5da403be341a20aa$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $cYkhj.getDOM)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $a98819dd0f313b11$export$f4457e83c74ac000)((0, $a98819dd0f313b11$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $5da403be341a20aa$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $4sljH.default)();
    const itemsRef = $jMaZ8.useRef({});
    const wrapForm = $jMaZ8.useMemo(()=>form !== null && form !== void 0 ? form : Object.assign(Object.assign({}, rcForm), {
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $5da403be341a20aa$var$toNamePathStr(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: function(name) {
                let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const node = $5da403be341a20aa$var$getFieldDOMNode(name, wrapForm);
                if (node) (0, $7PWCI.default)(node, Object.assign({
                    scrollMode: 'if-needed',
                    block: 'nearest'
                }, options));
            },
            focusField: (name)=>{
                var _a;
                const node = $5da403be341a20aa$var$getFieldDOMNode(name, wrapForm);
                if (node) (_a = node.focus) === null || _a === void 0 || _a.call(node);
            },
            getFieldInstance: (name)=>{
                const namePathStr = $5da403be341a20aa$var$toNamePathStr(name);
                return itemsRef.current[namePathStr];
            }
        }), [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}



var $jMaZ8 = parcelRequire("jMaZ8");

const $562b0b307d278d09$var$names = {};
function $562b0b307d278d09$export$2e2bcd8739ae039(_ref) {
    let { name: name } = _ref;
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Form');
    $jMaZ8.useEffect(()=>{
        if (name) {
            $562b0b307d278d09$var$names[name] = ($562b0b307d278d09$var$names[name] || 0) + 1;
            warning($562b0b307d278d09$var$names[name] <= 1, 'usage', 'There exist multiple Form with same `name`.');
            return ()=>{
                $562b0b307d278d09$var$names[name] -= 1;
            };
        }
    }, [
        name
    ]);
}




"use client";
var $4d7ab18e165eff28$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4d7ab18e165eff28$var$InternalForm = (props, ref)=>{
    const contextDisabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const { getPrefixCls: getPrefixCls, direction: direction, form: contextForm } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, hideRequiredMark: hideRequiredMark, layout: layout = 'horizontal', scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant } = props, restFormProps = $4d7ab18e165eff28$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "size",
        "disabled",
        "form",
        "colon",
        "labelAlign",
        "labelWrap",
        "labelCol",
        "wrapperCol",
        "hideRequiredMark",
        "layout",
        "scrollToFirstError",
        "requiredMark",
        "onFinishFailed",
        "name",
        "style",
        "feedbackIcons",
        "variant"
    ]);
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(size);
    const contextValidateMessages = $jMaZ8.useContext((0, $16feb78216c100f4$export$2e2bcd8739ae039));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $562b0b307d278d09$export$2e2bcd8739ae039)(props);
    const mergedRequiredMark = $jMaZ8.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (hideRequiredMark) return false;
        if (contextForm && contextForm.requiredMark !== undefined) return contextForm.requiredMark;
        return true;
    }, [
        hideRequiredMark,
        requiredMark,
        contextForm
    ]);
    const mergedColon = colon !== null && colon !== void 0 ? colon : contextForm === null || contextForm === void 0 ? void 0 : contextForm.colon;
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b0ebdf17cc7e6c79$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const formClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, cssVarCls, rootCls, hashId, contextForm === null || contextForm === void 0 ? void 0 : contextForm.className, className, rootClassName);
    const [wrapForm] = (0, $5da403be341a20aa$export$2e2bcd8739ae039)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $jMaZ8.useMemo(()=>({
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            vertical: layout === 'vertical',
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons
        }), [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons
    ]);
    const nativeElementRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, ()=>{
        var _a;
        return Object.assign(Object.assign({}, wrapForm), {
            nativeElement: (_a = nativeElementRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
        });
    });
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: 'nearest'
            };
            if (typeof options === 'object') defaultScrollToFirstError = Object.assign(Object.assign({}, defaultScrollToFirstError), options);
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
            if (defaultScrollToFirstError.focus) wrapForm.focusField(fieldName);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed === null || onFinishFailed === void 0 || onFinishFailed(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextForm && contextForm.scrollToFirstError !== undefined) scrollToField(contextForm.scrollToFirstError, fieldName);
        }
    };
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$6f0555dad42725fb).Provider, {
        value: variant
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $fb8ef783ef39e103$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $1497fcac08ca2dc1$export$2e2bcd8739ae039).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$8ce1ff4f94d08846), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $6wVix.default), Object.assign({
        id: name
    }, restFormProps, {
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: Object.assign(Object.assign({}, contextForm === null || contextForm === void 0 ? void 0 : contextForm.style), style),
        className: formClassName
    }))))))));
};
const $4d7ab18e165eff28$var$Form = /*#__PURE__*/ $jMaZ8.forwardRef($4d7ab18e165eff28$var$InternalForm);
$4d7ab18e165eff28$var$Form.displayName = 'Form';
var $4d7ab18e165eff28$export$2e2bcd8739ae039 = $4d7ab18e165eff28$var$Form;

parcelRequire("6wVix");
var $4440P = parcelRequire("4440P");

var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
parcelRequire("6wVix");
var $g3ui7 = parcelRequire("g3ui7");
var $9PKWp = parcelRequire("9PKWp");
var $lapVt = parcelRequire("lapVt");

var $9SyO6 = parcelRequire("9SyO6");

var $1cfGC = parcelRequire("1cfGC");






var $a6yuN = parcelRequire("a6yuN");
function $4bdc143f02173d9e$export$2e2bcd8739ae039(children) {
    if (typeof children === 'function') return children;
    const childList = (0, $a6yuN.default)(children);
    return childList.length <= 1 ? childList[0] : childList;
}



var $jMaZ8 = parcelRequire("jMaZ8");


const $7a29d845bc02963b$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Form.Item');
        warning(status !== undefined, 'usage', 'Form.Item.useStatus should be used under Form.Item component. For more information: https://u.ant.design/form-item-usestatus');
    }
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$7a29d845bc02963b$var$useFormItemStatus.Context = (0, $ee23d3c241510852$export$bbb5553c6c7a14ed);
var $7a29d845bc02963b$export$2e2bcd8739ae039 = $7a29d845bc02963b$var$useFormItemStatus;



var $jMaZ8 = parcelRequire("jMaZ8");

var $aZxvk = parcelRequire("aZxvk");
function $691d578f82cea178$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $jMaZ8.useState(defaultValue);
    const frameRef = $jMaZ8.useRef(null);
    const batchRef = $jMaZ8.useRef([]);
    const destroyRef = $jMaZ8.useRef(false);
    $jMaZ8.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $aZxvk.default).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $aZxvk.default)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $jMaZ8 = parcelRequire("jMaZ8");

var $1cfGC = parcelRequire("1cfGC");

function $9b94d85849b10a63$export$2e2bcd8739ae039() {
    const { itemRef: itemRef } = $jMaZ8.useContext((0, $ee23d3c241510852$export$c24727297075ec6a));
    const cacheRef = $jMaZ8.useRef({});
    function getRef(name, children) {
        // Outer caller already check the `supportRef`
        const childrenRef = children && typeof children === 'object' && (0, $1cfGC.getNodeRef)(children);
        const nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $1cfGC.composeRef)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}





var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $jLTp6 = parcelRequire("jLTp6");

var $hvG6u = parcelRequire("hvG6u");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");

const $85a8a338db7581cb$export$74c1bf8296b1541f = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $85a8a338db7581cb$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $85a8a338db7581cb$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($85a8a338db7581cb$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
function $85a8a338db7581cb$export$2e2bcd8739ae039() {
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const responsiveMap = $85a8a338db7581cb$var$getResponsiveMap($85a8a338db7581cb$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>func(screens));
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            unregister () {
                Object.keys(responsiveMap).forEach((screen)=>{
                    const matchMediaQuery = responsiveMap[screen];
                    const handler = this.matchHandlers[matchMediaQuery];
                    handler === null || handler === void 0 || handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
                });
                subscribers.clear();
            },
            register () {
                Object.keys(responsiveMap).forEach((screen)=>{
                    const matchMediaQuery = responsiveMap[screen];
                    const listener = (_ref)=>{
                        let { matches: matches } = _ref;
                        this.dispatch(Object.assign(Object.assign({}, screens), {
                            [screen]: matches
                        }));
                    };
                    const mql = window.matchMedia(matchMediaQuery);
                    mql.addListener(listener);
                    this.matchHandlers[matchMediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            responsiveMap: responsiveMap
        };
    }, [
        token
    ]);
}
const $85a8a338db7581cb$export$862220c15691d248 = (screens, screenSizes)=>{
    if (screenSizes && typeof screenSizes === 'object') for(let i = 0; i < $85a8a338db7581cb$export$74c1bf8296b1541f.length; i++){
        const breakpoint = $85a8a338db7581cb$export$74c1bf8296b1541f[i];
        if (screens[breakpoint] && screenSizes[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};




var $jMaZ8 = parcelRequire("jMaZ8");
const $dc63e3f6168db60a$var$RowContext = /*#__PURE__*/ (0, $jMaZ8.createContext)({});
var $dc63e3f6168db60a$export$2e2bcd8739ae039 = $dc63e3f6168db60a$var$RowContext;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// ============================== Row-Shared ==============================
const $e029ba939422c8b3$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $e029ba939422c8b3$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $e029ba939422c8b3$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls: prefixCls, componentCls: componentCls, gridColumns: gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ['--ant-display']: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: 'var(--ant-display)',
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const $e029ba939422c8b3$var$genGridStyle = (token, sizeCls)=>$e029ba939422c8b3$var$genLoopGridColumnsStyle(token, sizeCls);
const $e029ba939422c8b3$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $4g3I0.unit)(screenSize)})`]: Object.assign({}, $e029ba939422c8b3$var$genGridStyle(token, sizeCls))
    });
const $e029ba939422c8b3$export$519f4f378a4f8e85 = ()=>({});
const $e029ba939422c8b3$export$5504d86ab3175593 = ()=>({});
const $e029ba939422c8b3$export$b0d9c6b8be4e14cd = (0, $263539dacc5f409d$export$51ec95de45185b42)('Grid', $e029ba939422c8b3$var$genGridRowStyle, $e029ba939422c8b3$export$519f4f378a4f8e85);
const $e029ba939422c8b3$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin
    };
    return mediaSizesMap;
};
const $e029ba939422c8b3$export$4d3e83959861592f = (0, $263539dacc5f409d$export$51ec95de45185b42)('Grid', (token)=>{
    const gridToken = (0, $8APUt.merge)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $e029ba939422c8b3$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $e029ba939422c8b3$var$genGridColStyle(gridToken),
        $e029ba939422c8b3$var$genGridStyle(gridToken, ''),
        $e029ba939422c8b3$var$genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>$e029ba939422c8b3$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>Object.assign(Object.assign({}, pre), cur), {})
    ];
}, $e029ba939422c8b3$export$5504d86ab3175593);


"use client";
var $d1e533474e668570$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d1e533474e668570$var$_RowAligns = [
    'top',
    'middle',
    'bottom',
    'stretch'
];
const $d1e533474e668570$var$_RowJustify = [
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
    'space-evenly'
];
function $d1e533474e668570$var$useMergedPropByScreen(oriProp, screen) {
    const [prop, setProp] = $jMaZ8.useState(typeof oriProp === 'string' ? oriProp : '');
    const calcMergedAlignOrJustify = ()=>{
        if (typeof oriProp === 'string') setProp(oriProp);
        if (typeof oriProp !== 'object') return;
        for(let i = 0; i < (0, $85a8a338db7581cb$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $85a8a338db7581cb$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen[breakpoint]) continue;
            const curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $jMaZ8.useEffect(()=>{
        calcMergedAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
const $d1e533474e668570$var$Row = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap } = props, others = $d1e533474e668570$var$__rest(props, [
        "prefixCls",
        "justify",
        "align",
        "className",
        "style",
        "children",
        "gutter",
        "wrap"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const [screens, setScreens] = $jMaZ8.useState({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    });
    // to save screens info when responsiveObserve callback had been call
    const [curScreens, setCurScreens] = $jMaZ8.useState({
        xs: false,
        sm: false,
        md: false,
        lg: false,
        xl: false,
        xxl: false
    });
    // ================================== calc responsive data ==================================
    const mergedAlign = $d1e533474e668570$var$useMergedPropByScreen(align, curScreens);
    const mergedJustify = $d1e533474e668570$var$useMergedPropByScreen(justify, curScreens);
    const gutterRef = $jMaZ8.useRef(gutter);
    const responsiveObserver = (0, $85a8a338db7581cb$export$2e2bcd8739ae039)();
    // ================================== Effect ==================================
    $jMaZ8.useEffect(()=>{
        const token = responsiveObserver.subscribe((screen)=>{
            setCurScreens(screen);
            const currentGutter = gutterRef.current || 0;
            if (!Array.isArray(currentGutter) && typeof currentGutter === 'object' || Array.isArray(currentGutter) && (typeof currentGutter[0] === 'object' || typeof currentGutter[1] === 'object')) setScreens(screen);
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    // ================================== Render ==================================
    const getGutter = ()=>{
        const results = [
            undefined,
            undefined
        ];
        const normalizedGutter = Array.isArray(gutter) ? gutter : [
            gutter,
            undefined
        ];
        normalizedGutter.forEach((g, index)=>{
            if (typeof g === 'object') for(let i = 0; i < (0, $85a8a338db7581cb$export$74c1bf8296b1541f).length; i++){
                const breakpoint = (0, $85a8a338db7581cb$export$74c1bf8296b1541f)[i];
                if (screens[breakpoint] && g[breakpoint] !== undefined) {
                    results[index] = g[breakpoint];
                    break;
                }
            }
            else results[index] = g;
        });
        return results;
    };
    const prefixCls = getPrefixCls('row', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $e029ba939422c8b3$export$b0d9c6b8be4e14cd)(prefixCls);
    const gutters = getGutter();
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    const horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $jMaZ8.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $dc63e3f6168db60a$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, others, {
        className: classes,
        style: Object.assign(Object.assign({}, rowStyle), style),
        ref: ref
    }), children)));
});
$d1e533474e668570$var$Row.displayName = 'Row';
var $d1e533474e668570$export$2e2bcd8739ae039 = $d1e533474e668570$var$Row;




var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
parcelRequire("1CVs1");
var $k19OO = parcelRequire("k19OO");
var $3hbWa = parcelRequire("3hbWa");

var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");



"use client";
var $f6b871da920d79b3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f6b871da920d79b3$var$parseFlex(flex) {
    if (typeof flex === 'number') return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $f6b871da920d79b3$var$sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
const $f6b871da920d79b3$var$Col = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { gutter: gutter, wrap: wrap } = $jMaZ8.useContext((0, $dc63e3f6168db60a$export$2e2bcd8739ae039));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style } = props, others = $f6b871da920d79b3$var$__rest(props, [
        "prefixCls",
        "span",
        "order",
        "offset",
        "push",
        "pull",
        "className",
        "children",
        "flex",
        "style"
    ]);
    const prefixCls = getPrefixCls('col', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $e029ba939422c8b3$export$4d3e83959861592f)(prefixCls);
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    $f6b871da920d79b3$var$sizes.forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === 'number') sizeProps.span = propSize;
        else if (typeof propSize === 'object') sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
            [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        });
        // Responsive flex layout
        if (sizeProps.flex) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[`--${prefixCls}-${size}-flex`] = $f6b871da920d79b3$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        const horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    if (flex) {
        mergedStyle.flex = $f6b871da920d79b3$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, others, {
        style: Object.assign(Object.assign(Object.assign({}, mergedStyle), style), sizeStyle),
        className: classes,
        ref: ref
    }), children));
});
$f6b871da920d79b3$var$Col.displayName = 'Col';
var $f6b871da920d79b3$export$2e2bcd8739ae039 = $f6b871da920d79b3$var$Col;




/**
 * Fallback of IE.
 * Safe to remove.
 */ // Style as inline component


// ============================= Fallback =============================
const $de3113763b1dd617$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: 'flex'
            }
        }
    };
};
var // ============================== Export ==============================
$de3113763b1dd617$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$1537386bc155ea56)([
    'Form',
    'item-item'
], (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const formToken = (0, $b0ebdf17cc7e6c79$export$362fb92a8f81bbf9)(token, rootPrefixCls);
    return [
        $de3113763b1dd617$var$genFallbackStyle(formToken)
    ];
});


"use client";
var $e2f3e19ee800fab5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e2f3e19ee800fab5$var$GRID_MAX = 24;
const $e2f3e19ee800fab5$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, labelCol: labelCol, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged, label: label } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $jMaZ8.useContext((0, $ee23d3c241510852$export$c24727297075ec6a));
    const mergedWrapperCol = $jMaZ8.useMemo(()=>{
        let mergedWrapper = Object.assign({}, wrapperCol || formContext.wrapperCol || {});
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [
                undefined,
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'xxl'
            ];
            list.forEach((size)=>{
                const _size = size ? [
                    size
                ] : [];
                const formLabel = (0, $k19OO.default)(formContext.labelCol, _size);
                const formLabelObj = typeof formLabel === 'object' ? formLabel : {};
                const wrapper = (0, $k19OO.default)(mergedWrapper, _size);
                const wrapperObj = typeof wrapper === 'object' ? wrapper : {};
                if ('span' in formLabelObj && !('offset' in wrapperObj) && formLabelObj.span < $e2f3e19ee800fab5$var$GRID_MAX) mergedWrapper = (0, $3hbWa.default)(mergedWrapper, [].concat(_size, [
                    'offset'
                ]), formLabelObj.span);
            });
        }
        return mergedWrapper;
    }, [
        wrapperCol,
        formContext
    ]);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $jMaZ8.useMemo(()=>{
        const { labelCol: labelCol, wrapperCol: wrapperCol } = formContext, rest = $e2f3e19ee800fab5$var$__rest(formContext, [
            "labelCol",
            "wrapperCol"
        ]);
        return rest;
    }, [
        formContext
    ]);
    const extraRef = $jMaZ8.useRef(null);
    const [extraHeight, setExtraHeight] = $jMaZ8.useState(0);
    (0, $jLTp6.default)(()=>{
        if (extra && extraRef.current) setExtraHeight(extraRef.current.clientHeight);
        else setExtraHeight(0);
    }, [
        extra
    ]);
    const inputDom = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${baseClassName}-control-input-content`
    }, children));
    const formItemContext = $jMaZ8.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $32422ef2e04db442$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, extraProps, {
        className: `${baseClassName}-extra`,
        ref: extraRef
    }), extra) : null;
    const additionalDom = errorListDom || extraDom ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${baseClassName}-additional`,
        style: marginBottom ? {
            minHeight: marginBottom + extraHeight
        } : {}
    }, errorListDom, extraDom) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, inputDom, additionalDom);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $f6b871da920d79b3$export$2e2bcd8739ae039), Object.assign({}, mergedWrapperCol, {
        className: className
    }), dom), /*#__PURE__*/ $jMaZ8.createElement((0, $de3113763b1dd617$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
var $e2f3e19ee800fab5$export$2e2bcd8739ae039 = $e2f3e19ee800fab5$var$FormItemInput;



var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $367aaa3e87d7f19d$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $367aaa3e87d7f19d$export$2e2bcd8739ae039 = $367aaa3e87d7f19d$var$QuestionCircleOutlined;



var $c781de0cbf3f9890$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $367aaa3e87d7f19d$export$2e2bcd8739ae039)
    }));
};
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ var $c781de0cbf3f9890$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($c781de0cbf3f9890$var$QuestionCircleOutlined);
$c781de0cbf3f9890$var$RefIcon.displayName = 'QuestionCircleOutlined';
var $c781de0cbf3f9890$export$2e2bcd8739ae039 = $c781de0cbf3f9890$var$RefIcon;



var $giSak = parcelRequire("giSak");





"use client";
var $bb0e7b42380d0181$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $bb0e7b42380d0181$var$toTooltipProps(tooltip) {
    if (!tooltip) return null;
    if (typeof tooltip === 'object' && !/*#__PURE__*/ $jMaZ8.isValidElement(tooltip)) return tooltip;
    return {
        title: tooltip
    };
}
const $bb0e7b42380d0181$var$FormItemLabel = (_ref)=>{
    let { prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical } = _ref;
    var _a;
    const [formLocale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Form');
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon } = $jMaZ8.useContext((0, $ee23d3c241510852$export$c24727297075ec6a));
    if (!label) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === 'string' && label.trim()) labelChildren = label.replace(/[:|：]\s*$/, '');
    // Tooltip
    const tooltipProps = $bb0e7b42380d0181$var$toTooltipProps(tooltip);
    if (tooltipProps) {
        const { icon: icon = /*#__PURE__*/ $jMaZ8.createElement((0, $c781de0cbf3f9890$export$2e2bcd8739ae039), null) } = tooltipProps, restTooltipProps = $bb0e7b42380d0181$var$__rest(tooltipProps, [
            "icon"
        ]);
        const tooltipNode = /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), Object.assign({}, restTooltipProps), /*#__PURE__*/ $jMaZ8.cloneElement(icon, {
            className: `${prefixCls}-item-tooltip`,
            title: '',
            onClick: (e)=>{
                // Prevent label behavior in tooltip icon
                // https://github.com/ant-design/ant-design/issues/46154
                e.preventDefault();
            },
            tabIndex: null
        }));
        labelChildren = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === 'optional';
    const isRenderMark = typeof requiredMark === 'function';
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, labelChildren, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-item-optional`,
        title: ""
    }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.optional)));
    const labelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-optional`]: isOptionalMark || isRenderMark,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $f6b871da920d79b3$export$2e2bcd8739ae039), Object.assign({}, mergedLabelCol, {
        className: labelColClassName
    }), /*#__PURE__*/ $jMaZ8.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        title: typeof label === 'string' ? label : ''
    }, labelChildren));
};
var $bb0e7b42380d0181$export$2e2bcd8739ae039 = $bb0e7b42380d0181$var$FormItemLabel;





var $jMaZ8 = parcelRequire("jMaZ8");





var $giSak = parcelRequire("giSak");


"use client";
const $58a6e8f2a11a2a01$var$iconMap = {
    success: (0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039),
    warning: (0, $5244cb05538dbe0c$export$2e2bcd8739ae039),
    error: (0, $93361570ffc8bbe1$export$2e2bcd8739ae039),
    validating: (0, $d05b96ef0838a5b9$export$2e2bcd8739ae039)
};
function $58a6e8f2a11a2a01$export$2e2bcd8739ae039(_ref) {
    let { children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle } = _ref;
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $jMaZ8.useContext((0, $ee23d3c241510852$export$c24727297075ec6a));
    const mergedValidateStatus = (0, $a98819dd0f313b11$export$b70265791d2079d4)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon } = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    // ====================== Context =======================
    const formItemStatusContext = $jMaZ8.useMemo(()=>{
        var _a;
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && ((_a = customIcons === null || customIcons === void 0 ? void 0 : customIcons({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })) === null || _a === void 0 ? void 0 : _a[mergedValidateStatus]);
            const IconNode = mergedValidateStatus && $58a6e8f2a11a2a01$var$iconMap[mergedValidateStatus];
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $jMaZ8.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $jMaZ8.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || '',
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus !== null && mergedValidateStatus !== void 0 ? mergedValidateStatus : parentStatus) || '';
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback !== null && hasFeedback !== void 0 ? hasFeedback : parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
        }
        return context;
    }, [
        mergedValidateStatus,
        hasFeedback,
        noStyle,
        parentIsFormItemInput,
        parentStatus
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children);
}


"use client";
var $de691829eb659a56$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $de691829eb659a56$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: layout } = props, restProps = $de691829eb659a56$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "help",
        "errors",
        "warnings",
        "validateStatus",
        "meta",
        "hasFeedback",
        "hidden",
        "children",
        "fieldId",
        "required",
        "isRequired",
        "onSubItemMetaChange",
        "layout"
    ]);
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, vertical: formVertical } = $jMaZ8.useContext((0, $ee23d3c241510852$export$c24727297075ec6a));
    const vertical = formVertical || layout === 'vertical';
    // ======================== Margin ========================
    const itemRef = $jMaZ8.useRef(null);
    const debounceErrors = (0, $408ad1e85f1cb2fa$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $408ad1e85f1cb2fa$export$2e2bcd8739ae039)(warnings);
    const hasHelp = help !== undefined && help !== null;
    const hasError = !!(hasHelp || errors.length || warnings.length);
    const isOnScreen = !!itemRef.current && (0, $f0dd1e7e6ce84933$export$2e2bcd8739ae039)(itemRef.current);
    const [marginBottom, setMarginBottom] = $jMaZ8.useState(null);
    (0, $jLTp6.default)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = function() {
        let isDebounce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $a98819dd0f313b11$export$b70265791d2079d4)(_errors, _warnings, meta, '', !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === 'success',
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === 'warning',
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === 'error',
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === 'validating',
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $d1e533474e668570$export$2e2bcd8739ae039), Object.assign({
        className: `${itemPrefixCls}-row`
    }, (0, $hvG6u.default)(restProps, [
        '_internalItemRender',
        'colon',
        'dependencies',
        'extra',
        'fieldKey',
        'getValueFromEvent',
        'getValueProps',
        'htmlFor',
        'id',
        // It is deprecated because `htmlFor` is its replacement.
        'initialValue',
        'isListField',
        'label',
        'labelAlign',
        'labelCol',
        'labelWrap',
        'messageVariables',
        'name',
        'normalize',
        'noStyle',
        'preserve',
        'requiredMark',
        'rules',
        'shouldUpdate',
        'trigger',
        'tooltip',
        'validateFirst',
        'validateTrigger',
        'valuePropName',
        'wrapperCol',
        'validateDebounce'
    ])), /*#__PURE__*/ $jMaZ8.createElement((0, $bb0e7b42380d0181$export$2e2bcd8739ae039), Object.assign({
        htmlFor: fieldId
    }, props, {
        requiredMark: requiredMark,
        required: required !== null && required !== void 0 ? required : isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    })), /*#__PURE__*/ $jMaZ8.createElement((0, $e2f3e19ee800fab5$export$2e2bcd8739ae039), Object.assign({}, props, meta, {
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $58a6e8f2a11a2a01$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus
    }, children)))), !!marginBottom && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}



"use client";
const $10f371119a6a3196$var$NAME_SPLIT = '__SPLIT__';
const $10f371119a6a3196$var$_ValidateStatuses = [
    'success',
    'warning',
    'error',
    'validating',
    ''
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $10f371119a6a3196$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || typeof propValueA === 'function' || typeof propValueB === 'function';
    });
}
const $10f371119a6a3196$var$MemoInput = /*#__PURE__*/ $jMaZ8.memo((_ref)=>{
    let { children: children } = _ref;
    return children;
}, (prev, next)=>$10f371119a6a3196$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $10f371119a6a3196$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $10f371119a6a3196$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = 'onChange', validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { name: formName } = $jMaZ8.useContext((0, $ee23d3c241510852$export$c24727297075ec6a));
    const mergedChildren = (0, $4bdc143f02173d9e$export$2e2bcd8739ae039)(children);
    const isRenderProps = typeof mergedChildren === 'function';
    const notifyParentMetaChange = $jMaZ8.useContext((0, $ee23d3c241510852$export$d718247e9f9b0b9e));
    const { validateTrigger: contextValidateTrigger } = $jMaZ8.useContext((0, $9PKWp.default));
    const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
    const hasName = !(name === undefined || name === null);
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b0ebdf17cc7e6c79$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Form.Item');
    warning(name !== null, 'usage', '`null` is passed as `name` property');
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $jMaZ8.useContext((0, $lapVt.default));
    const fieldKeyPathRef = $jMaZ8.useRef(null);
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $691d578f82cea178$export$2e2bcd8739ae039)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $9SyO6.default)(()=>$10f371119a6a3196$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $10f371119a6a3196$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $fvBso.default)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = Object.assign({}, prevSubFieldErrors);
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $fvBso.default)(subMeta.name.slice(0, -1)), (0, $fvBso.default)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($10f371119a6a3196$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $jMaZ8.useMemo(()=>{
        const errorList = (0, $fvBso.default)(meta.errors);
        const warningList = (0, $fvBso.default)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $fvBso.default)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $fvBso.default)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $9b94d85849b10a63$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $jMaZ8.createElement((0, $58a6e8f2a11a2a01$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true
        }, baseChildren);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $de691829eb659a56$export$2e2bcd8739ae039), Object.assign({
            key: "row"
        }, props, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout
        }), baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return wrapCSSVar(renderLayout(mergedChildren));
    let variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = Object.assign(Object.assign({}, variables), messageVariables);
    // >>>>> With Field
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $g3ui7.default), Object.assign({}, props, {
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }), (control, renderMeta, context)=>{
        const mergedName = (0, $a98819dd0f313b11$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $a98819dd0f313b11$export$f4457e83c74ac000)(mergedName, formName);
        const isRequired = required !== undefined ? required : !!(rules === null || rules === void 0 ? void 0 : rules.some((rule)=>{
            if (rule && typeof rule === 'object' && rule.required && !rule.warningOnly) return true;
            if (typeof rule === 'function') {
                const ruleEntity = rule(context);
                return (ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.required) && !(ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.warningOnly);
            }
            return false;
        }));
        // ======================= Children =======================
        const mergedControl = Object.assign({}, control);
        let childNode = null;
        warning(!(shouldUpdate && dependencies), 'usage', "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps.");
        if (Array.isArray(mergedChildren) && hasName) {
            warning(false, 'usage', 'A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item.');
            childNode = mergedChildren;
        } else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) {
            warning(!!(shouldUpdate || dependencies), 'usage', 'A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`.');
            warning(!hasName, 'usage', 'A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.');
        } else if (dependencies && !isRenderProps && !hasName) warning(false, 'usage', 'Must set `name` or use a render function when `dependencies` is set.');
        else if (/*#__PURE__*/ $jMaZ8.isValidElement(mergedChildren)) {
            warning(mergedChildren.props.defaultValue === undefined, 'usage', '`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.');
            const childProps = Object.assign(Object.assign({}, mergedChildren.props), mergedControl);
            if (!childProps.id) childProps.id = fieldId;
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (props.extra) describedbyArr.push(`${fieldId}_extra`);
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $1cfGC.supportRef)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $fvBso.default)((0, $a98819dd0f313b11$export$45b10814cc054894)(trigger)), (0, $fvBso.default)((0, $a98819dd0f313b11$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = function() {
                    var _a2, _c2;
                    var _a, _b, _c;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    (_a = mergedControl[eventName]) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        mergedControl
                    ].concat(args));
                    (_c = (_b = mergedChildren.props)[eventName]) === null || _c === void 0 || (_c2 = _c).call.apply(_c2, [
                        _b
                    ].concat(args));
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $jMaZ8.createElement($10f371119a6a3196$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else {
            warning(!mergedName.length || !!noStyle, 'usage', '`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead.');
            childNode = mergedChildren;
        }
        return renderLayout(childNode, fieldId, isRequired);
    }));
}
const $10f371119a6a3196$var$FormItem = $10f371119a6a3196$var$InternalFormItem;
$10f371119a6a3196$var$FormItem.useStatus = (0, $7a29d845bc02963b$export$2e2bcd8739ae039);
var $10f371119a6a3196$export$2e2bcd8739ae039 = $10f371119a6a3196$var$FormItem;



var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("6wVix");
var $eGP8A = parcelRequire("eGP8A");



"use client";
var $04916fba4ad689f9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $04916fba4ad689f9$var$FormList = (_a)=>{
    var { prefixCls: customizePrefixCls, children: children } = _a, props = $04916fba4ad689f9$var$__rest(_a, [
        "prefixCls",
        "children"
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Form.List');
        warning(typeof props.name === 'number' || (Array.isArray(props.name) ? !!props.name.length : !!props.name), 'usage', 'Miss `name` prop.');
    }
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    const contextValue = $jMaZ8.useMemo(()=>({
            prefixCls: prefixCls,
            status: 'error'
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $eGP8A.default), Object.assign({}, props), (fields, operation, meta)=>/*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map((field)=>Object.assign(Object.assign({}, field), {
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $04916fba4ad689f9$export$2e2bcd8739ae039 = $04916fba4ad689f9$var$FormList;



var $jMaZ8 = parcelRequire("jMaZ8");

function $76b7b88c9194d7d6$export$2e2bcd8739ae039() {
    const { form: form } = $jMaZ8.useContext((0, $ee23d3c241510852$export$c24727297075ec6a));
    return form;
}


"use client";
const $c0d3168732410fde$var$Form = (0, $4d7ab18e165eff28$export$2e2bcd8739ae039);
$c0d3168732410fde$var$Form.Item = (0, $10f371119a6a3196$export$2e2bcd8739ae039);
$c0d3168732410fde$var$Form.List = (0, $04916fba4ad689f9$export$2e2bcd8739ae039);
$c0d3168732410fde$var$Form.ErrorList = (0, $32422ef2e04db442$export$2e2bcd8739ae039);
$c0d3168732410fde$var$Form.useForm = (0, $5da403be341a20aa$export$2e2bcd8739ae039);
$c0d3168732410fde$var$Form.useFormInstance = (0, $76b7b88c9194d7d6$export$2e2bcd8739ae039);
$c0d3168732410fde$var$Form.useWatch = (0, $4440P.default);
$c0d3168732410fde$var$Form.Provider = (0, $ee23d3c241510852$export$8ce1ff4f94d08846);
$c0d3168732410fde$var$Form.create = ()=>{
    (0, $e55cfce129297019$export$2e2bcd8739ae039)(false, 'Form', 'antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.');
};
var $c0d3168732410fde$export$2e2bcd8739ae039 = $c0d3168732410fde$var$Form;


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");



parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
function $10e799cdff4a390c$export$a157d95850191a12(token) {
    return (0, $8APUt.merge)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $10e799cdff4a390c$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer } = token;
    return {
        paddingBlock: Math.max(Math.round((controlHeight - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockSM: Math.max(Math.round((controlHeightSM - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockLG: Math.ceil((controlHeightLG - fontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth,
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: fontSize,
        inputFontSizeLG: fontSizeLG,
        inputFontSizeSM: fontSize
    };
};


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $e02010b1a8d4cc87$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $e02010b1a8d4cc87$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': Object.assign({}, $e02010b1a8d4cc87$export$bf820fba296f2fd8((0, $8APUt.merge)(token, {
            hoverBorderColor: token.colorBorder,
            hoverBg: token.colorBgContainerDisabled
        })))
    });
const $e02010b1a8d4cc87$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $e02010b1a8d4cc87$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $e02010b1a8d4cc87$export$8c569e4cc3fd115f(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }),
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $e02010b1a8d4cc87$export$53795bafd774ce02 = (token, extraStyles)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $e02010b1a8d4cc87$export$8c569e4cc3fd115f(token, {
            borderColor: token.colorBorder,
            hoverBorderColor: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeShadow: token.activeShadow
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $e02010b1a8d4cc87$export$12789f962d420a93(token))
        }), $e02010b1a8d4cc87$var$genOutlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderColor: token.colorErrorBorderHover,
            activeBorderColor: token.colorError,
            activeShadow: token.errorActiveShadow,
            affixColor: token.colorError
        })), $e02010b1a8d4cc87$var$genOutlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderColor: token.colorWarningBorderHover,
            activeBorderColor: token.colorWarning,
            activeShadow: token.warningActiveShadow,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $e02010b1a8d4cc87$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $e02010b1a8d4cc87$export$8f88f32c046ff727 = (token)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            }
        }, $e02010b1a8d4cc87$var$genOutlinedGroupStatusStyle(token, {
            status: 'error',
            addonBorderColor: token.colorError,
            addonColor: token.colorErrorText
        })), $e02010b1a8d4cc87$var$genOutlinedGroupStatusStyle(token, {
            status: 'warning',
            addonBorderColor: token.colorWarning,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: Object.assign({}, $e02010b1a8d4cc87$export$12789f962d420a93(token))
            }
        })
    });
const $e02010b1a8d4cc87$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': Object.assign({
            background: 'transparent',
            border: 'none',
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            }
        }, extraStyles)
    };
};
/* ============== Filled ============== */ const $e02010b1a8d4cc87$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: options === null || options === void 0 ? void 0 : options.inputColor
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $e02010b1a8d4cc87$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $e02010b1a8d4cc87$var$genBaseFilledStyle(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        })
    });
const $e02010b1a8d4cc87$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        '&-filled': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $e02010b1a8d4cc87$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.activeBorderColor
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $e02010b1a8d4cc87$export$12789f962d420a93(token))
        }), $e02010b1a8d4cc87$var$genFilledStatusStyle(token, {
            status: 'error',
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            inputColor: token.colorErrorText,
            affixColor: token.colorError
        })), $e02010b1a8d4cc87$var$genFilledStatusStyle(token, {
            status: 'warning',
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            inputColor: token.colorWarningText,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $e02010b1a8d4cc87$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $e02010b1a8d4cc87$export$542c0fce51b1d515 = (token)=>({
        '&-filled': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.colorFillTertiary
                },
                [`${token.componentCls}-filled:not(:focus):not(:focus-within)`]: {
                    '&:not(:first-child)': {
                        borderInlineStart: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    },
                    '&:not(:last-child)': {
                        borderInlineEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    }
                }
            }
        }, $e02010b1a8d4cc87$var$genFilledGroupStatusStyle(token, {
            status: 'error',
            addonBg: token.colorErrorBg,
            addonColor: token.colorErrorText
        })), $e02010b1a8d4cc87$var$genFilledGroupStatusStyle(token, {
            status: 'warning',
            addonBg: token.colorWarningBg,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        })
    });


const $47d23157ef40b741$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const $47d23157ef40b741$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $47d23157ef40b741$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $4g3I0.unit)(paddingBlockLG)} ${(0, $4g3I0.unit)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $47d23157ef40b741$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $4g3I0.unit)(token.paddingBlockSM)} ${(0, $4g3I0.unit)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $47d23157ef40b741$export$8c9a381315f3ebcd = (token)=>Object.assign(Object.assign({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $4g3I0.unit)(token.paddingBlock)} ${(0, $4g3I0.unit)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`
    }, $47d23157ef40b741$export$92095d0f4c77bd56(token.colorTextPlaceholder)), {
        // Reset height for `textarea`s
        'textarea&': {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}, height 0s`,
            resize: 'vertical'
        },
        // Size
        '&-lg': Object.assign({}, $47d23157ef40b741$var$genInputLargeStyle(token)),
        '&-sm': Object.assign({}, $47d23157ef40b741$export$bb047f62c5a56f90(token)),
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const $47d23157ef40b741$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, $47d23157ef40b741$var$genInputLargeStyle(token)),
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, $47d23157ef40b741$export$bb047f62c5a56f90(token)),
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $4g3I0.unit)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $4g3I0.unit)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $4g3I0.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        [`${antCls}-select-selector`]: {
                            backgroundColor: 'inherit',
                            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} transparent`,
                            boxShadow: 'none'
                        }
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $4g3I0.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
                [`${componentCls}-search &`]: {
                    borderStartStartRadius: token.borderRadius,
                    borderEndStartRadius: token.borderRadius
                }
            },
            [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
            display: 'block'
        }, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                    borderRadius: 0
                }
            },
            [`${componentCls}-group-wrapper:not(:last-child)`]: {
                [`&${componentCls}-search > ${componentCls}-group`]: {
                    [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
                        borderRadius: 0
                    },
                    [`& > ${componentCls}`]: {
                        borderStartStartRadius: token.borderRadius,
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0,
                        borderEndStartRadius: token.borderRadius
                    }
                }
            }
        })
    };
};
const $47d23157ef40b741$var$genInputStyle = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), $47d23157ef40b741$export$8c9a381315f3ebcd(token)), (0, $e02010b1a8d4cc87$export$53795bafd774ce02)(token)), (0, $e02010b1a8d4cc87$export$b8365cd7e6671d79)(token)), (0, $e02010b1a8d4cc87$export$b6de5da7f39edfcb)(token)), {
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                '-webkit-appearance': 'none'
            }
        })
    };
};
const $47d23157ef40b741$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorTextTertiary
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $4g3I0.unit)(token.inputAffixPadding)}`
            }
        }
    };
};
const $47d23157ef40b741$var$genAffixStyle = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, $47d23157ef40b741$export$8c9a381315f3ebcd(token)), {
            display: 'inline-flex',
            [`&:not(${componentCls}-disabled):hover`]: {
                zIndex: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            },
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            }
        }), $47d23157ef40b741$var$genAllowClearStyle(token)), {
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        }),
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $47d23157ef40b741$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), $47d23157ef40b741$export$ffe8b2a9bd2e5cfe(token)), {
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': Object.assign(Object.assign(Object.assign({
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                }
            }, (0, $e02010b1a8d4cc87$export$8f88f32c046ff727)(token)), (0, $e02010b1a8d4cc87$export$542c0fce51b1d515)(token)), {
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            })
        })
    };
};
const $47d23157ef40b741$var$genSearchInputStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const searchPrefixCls = `${componentCls}-search`;
    return {
        [searchPrefixCls]: {
            [componentCls]: {
                '&:hover, &:focus': {
                    [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        borderInlineStartColor: token.colorPrimaryHover
                    }
                }
            },
            [`${componentCls}-affix-wrapper`]: {
                height: token.controlHeight,
                borderRadius: 0
            },
            // fix slight height diff in Firefox:
            // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
            [`${componentCls}-lg`]: {
                lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal()
            },
            [`> ${componentCls}-group`]: {
                [`> ${componentCls}-group-addon:last-child`]: {
                    insetInlineStart: -1,
                    padding: 0,
                    border: 0,
                    [`${searchPrefixCls}-button`]: {
                        // Fix https://github.com/ant-design/ant-design/issues/47150
                        marginInlineEnd: -1,
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0,
                        boxShadow: 'none'
                    },
                    [`${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        color: token.colorTextDescription,
                        '&:hover': {
                            color: token.colorPrimaryHover
                        },
                        '&:active': {
                            color: token.colorPrimaryActive
                        },
                        [`&${antCls}-btn-loading::before`]: {
                            insetInlineStart: 0,
                            insetInlineEnd: 0,
                            insetBlockStart: 0,
                            insetBlockEnd: 0
                        }
                    }
                }
            },
            [`${searchPrefixCls}-button`]: {
                height: token.controlHeight,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            '&-large': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightLG
                }
            },
            '&-small': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightSM
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            // ===================== Compact Item Customized Styles =====================
            [`&${componentCls}-compact-item`]: {
                [`&:not(${componentCls}-compact-last-item)`]: {
                    [`${componentCls}-group-addon`]: {
                        [`${componentCls}-search-button`]: {
                            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                            borderRadius: 0
                        }
                    }
                },
                [`&:not(${componentCls}-compact-first-item)`]: {
                    [`${componentCls},${componentCls}-affix-wrapper`]: {
                        borderRadius: 0
                    }
                },
                [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    }
                },
                [`> ${componentCls}-affix-wrapper-focused`]: {
                    zIndex: 2
                }
            }
        }
    };
};
const $47d23157ef40b741$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                // https://github.com/ant-design/ant-design/issues/33049
                [`> ${componentCls}`]: {
                    height: '100%'
                },
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $47d23157ef40b741$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
var // ============================== Export ==============================
$47d23157ef40b741$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Input', (token)=>{
    const inputToken = (0, $8APUt.merge)(token, (0, $10e799cdff4a390c$export$a157d95850191a12)(token));
    return [
        $47d23157ef40b741$var$genInputStyle(inputToken),
        $47d23157ef40b741$var$genTextAreaStyle(inputToken),
        $47d23157ef40b741$var$genAffixStyle(inputToken),
        $47d23157ef40b741$var$genGroupStyle(inputToken),
        $47d23157ef40b741$var$genSearchInputStyle(inputToken),
        $47d23157ef40b741$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $2bdaa96870b686b7$export$b1208b23589b4b73)(inputToken)
    ];
}, (0, $10e799cdff4a390c$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
const $d65939bc554f661a$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [wrapCSSVar, hashId] = (0, $47d23157ef40b741$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, $jMaZ8.useContext)((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $jMaZ8.useMemo)(()=>Object.assign(Object.assign({}, formItemContext), {
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Input.Group');
        warning.deprecated(false, 'Input.Group', 'Space.Compact');
    }
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, props.children)));
};
var $d65939bc554f661a$export$2e2bcd8739ae039 = $d65939bc554f661a$var$Group;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $29zSp = parcelRequire("29zSp");

var $lULOl = parcelRequire("lULOl");

var $1cfGC = parcelRequire("1cfGC");


var $jMaZ8 = parcelRequire("jMaZ8");

"use client";
const $2d18f75229ee6335$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $93361570ffc8bbe1$export$2e2bcd8739ae039), null)
    };
    return mergedAllowClear;
};
var $2d18f75229ee6335$export$2e2bcd8739ae039 = $2d18f75229ee6335$var$getAllowClear;



var $giSak = parcelRequire("giSak");
const $8d2ac7a62116451d$var$_InputStatuses = [
    'warning',
    'error',
    ''
];
function $8d2ac7a62116451d$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
}
const $8d2ac7a62116451d$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;









var $jMaZ8 = parcelRequire("jMaZ8");


/**
 * Compatible for legacy `bordered` prop.
 */ const $6883392ce3b89ee5$var$useVariant = function(component, variant) {
    let legacyBordered = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var _a, _b;
    const { variant: configVariant, [component]: componentConfig } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const ctxVariant = $jMaZ8.useContext((0, $ee23d3c241510852$export$6f0555dad42725fb));
    const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = (_b = (_a = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a !== void 0 ? _a : configVariant) !== null && _b !== void 0 ? _b : 'outlined';
    const enableVariantCls = (0, $3613812083e7312f$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $6883392ce3b89ee5$export$2e2bcd8739ae039 = $6883392ce3b89ee5$var$useVariant;




var $jMaZ8 = parcelRequire("jMaZ8");
function $dccb987ebb8837f0$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $jMaZ8.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute('value');
        }));
    };
    (0, $jMaZ8.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}



function $3285de8765149c19$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
var $a50a09a915375e3d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a50a09a915375e3d$var$Input = /*#__PURE__*/ (0, $jMaZ8.forwardRef)((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classes, variant: customVariant } = props, rest = $a50a09a915375e3d$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "style",
        "styles",
        "rootClassName",
        "onChange",
        "classNames",
        "variant"
    ]);
    {
        const { deprecated: deprecated } = (0, $e55cfce129297019$export$cf977aa92c751e61)('Input');
        deprecated(!('bordered' in props), 'bordered', 'variant');
    }
    const { getPrefixCls: getPrefixCls, direction: direction, input: input } = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $jMaZ8.useRef)(null);
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $47d23157ef40b741$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $b481086641a221d4$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $jMaZ8.useContext)((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $8d2ac7a62116451d$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $3285de8765149c19$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $jMaZ8.useRef)(inputHasPrefixSuffix);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Input');
        (0, $jMaZ8.useEffect)(()=>{
            var _a;
            if (inputHasPrefixSuffix && !prevHasPrefixSuffix.current) warning(document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input), 'usage', `When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ`);
            prevHasPrefixSuffix.current = inputHasPrefixSuffix;
        }, [
            inputHasPrefixSuffix
        ]);
    }
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $dccb987ebb8837f0$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $2d18f75229ee6335$export$2e2bcd8739ae039)(allowClear !== null && allowClear !== void 0 ? allowClear : input === null || input === void 0 ? void 0 : input.allowClear);
    const [variant, enableVariantCls] = (0, $6883392ce3b89ee5$export$2e2bcd8739ae039)('input', customVariant, bordered);
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $29zSp.default), Object.assign({
        ref: (0, $1cfGC.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.style), style),
        styles: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.styles), styles),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, input === null || input === void 0 ? void 0 : input.className),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), input === null || input === void 0 ? void 0 : input.classNames), {
            input: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, classes === null || classes === void 0 ? void 0 : classes.input, (_a = input === null || input === void 0 ? void 0 : input.classNames) === null || _a === void 0 ? void 0 : _a.input, hashId),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $8d2ac7a62116451d$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $8d2ac7a62116451d$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        })
    })));
});
$a50a09a915375e3d$var$Input.displayName = 'Input';
var $a50a09a915375e3d$export$2e2bcd8739ae039 = $a50a09a915375e3d$var$Input;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $ktS49 = parcelRequire("ktS49");







parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");

// =============================== OTP ================================
const $16adf7e6c887c95a$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$16adf7e6c887c95a$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, $8APUt.merge)(token, (0, $10e799cdff4a390c$export$a157d95850191a12)(token));
    return [
        $16adf7e6c887c95a$var$genOTPStyle(inputToken)
    ];
}, (0, $10e799cdff4a390c$export$bd8b682992bc9781));



var $jMaZ8 = parcelRequire("jMaZ8");

var $aZxvk = parcelRequire("aZxvk");

"use client";
var $3e47cea902f0cefd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3e47cea902f0cefd$var$OTPInput = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask } = props, restProps = $3e47cea902f0cefd$var$__rest(props, [
        "value",
        "onChange",
        "onActiveChange",
        "index",
        "mask"
    ]);
    const internalValue = value && typeof mask === 'string' ? mask : value;
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================== Ref ===========================
    const inputRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $aZxvk.default)(()=>{
            var _a;
            const inputEle = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        syncSelection();
    };
    const onInternalKeyUp = (e)=>{
        if (e.key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $a50a09a915375e3d$export$2e2bcd8739ae039), Object.assign({
        type: mask === true ? 'password' : 'text'
    }, restProps, {
        ref: inputRef,
        value: internalValue,
        onInput: onInternalChange,
        onFocus: syncSelection,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection
    }));
});
var $3e47cea902f0cefd$export$2e2bcd8739ae039 = $3e47cea902f0cefd$var$OTPInput;


"use client";
var $d5c177bb9cdbaafa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d5c177bb9cdbaafa$var$strToArr(str) {
    return (str || '').split('');
}
const $d5c177bb9cdbaafa$var$OTP = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, variant: variant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, onInput: onInput, inputMode: inputMode } = props, restProps = $d5c177bb9cdbaafa$var$__rest(props, [
        "prefixCls",
        "length",
        "size",
        "defaultValue",
        "value",
        "onChange",
        "formatter",
        "variant",
        "disabled",
        "status",
        "autoFocus",
        "mask",
        "type",
        "onInput",
        "inputMode"
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Input.OTP');
        warning(!(typeof mask === 'string' && mask.length > 1), 'usage', '`mask` prop should be a single character.');
    }
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const domAttrs = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $16adf7e6c887c95a$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Size =========================
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctx)=>customSize !== null && customSize !== void 0 ? customSize : ctx);
    // ======================== Status ========================
    const formContext = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $8d2ac7a62116451d$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $jMaZ8.useMemo(()=>Object.assign(Object.assign({}, formContext), {
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $jMaZ8.useRef(null);
    const refs = $jMaZ8.useRef({});
    $jMaZ8.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _a;
                (_a = refs.current[0]) === null || _a === void 0 || _a.focus();
            },
            blur: ()=>{
                var _a;
                for(let i = 0; i < length; i += 1)(_a = refs.current[i]) === null || _a === void 0 || _a.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $jMaZ8.useState($d5c177bb9cdbaafa$var$strToArr(internalFormatter(defaultValue || '')));
    $jMaZ8.useEffect(()=>{
        if (value !== undefined) setValueCells($d5c177bb9cdbaafa$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $ktS49.default)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, $ktS49.default)((index, txt)=>{
        let nextCells = (0, $fvBso.default)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($d5c177bb9cdbaafa$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = $d5c177bb9cdbaafa$var$strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        var _a;
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        var _a;
        (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode
    };
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, domAttrs, {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId)
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $ee23d3c241510852$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ $jMaZ8.createElement((0, $3e47cea902f0cefd$export$2e2bcd8739ae039), Object.assign({
            ref: (inputEle)=>{
                refs.current[index] = inputEle;
            },
            key: key,
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: `${prefixCls}-input`,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus
        }, inputSharedProps));
    }))));
});
var $d5c177bb9cdbaafa$export$2e2bcd8739ae039 = $d5c177bb9cdbaafa$var$OTP;



var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $9b57bd4d2e9874ee$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $9b57bd4d2e9874ee$export$2e2bcd8739ae039 = $9b57bd4d2e9874ee$var$EyeInvisibleOutlined;



var $ba3f11331eb24cc1$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $9b57bd4d2e9874ee$export$2e2bcd8739ae039)
    }));
};
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ var $ba3f11331eb24cc1$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($ba3f11331eb24cc1$var$EyeInvisibleOutlined);
$ba3f11331eb24cc1$var$RefIcon.displayName = 'EyeInvisibleOutlined';
var $ba3f11331eb24cc1$export$2e2bcd8739ae039 = $ba3f11331eb24cc1$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $adcee3cd377781e8$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $adcee3cd377781e8$export$2e2bcd8739ae039 = $adcee3cd377781e8$var$EyeOutlined;



var $7943495b95953283$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $adcee3cd377781e8$export$2e2bcd8739ae039)
    }));
};
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ var $7943495b95953283$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($7943495b95953283$var$EyeOutlined);
$7943495b95953283$var$RefIcon.displayName = 'EyeOutlined';
var $7943495b95953283$export$2e2bcd8739ae039 = $7943495b95953283$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");

var $1cfGC = parcelRequire("1cfGC");




"use client";
var $76031e085d6feec0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $76031e085d6feec0$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $jMaZ8.createElement((0, $7943495b95953283$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $ba3f11331eb24cc1$export$2e2bcd8739ae039), null);
const $76031e085d6feec0$var$actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const $76031e085d6feec0$var$Password = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = 'click', visibilityToggle: visibilityToggle = true, iconRender: iconRender = $76031e085d6feec0$var$defaultIconRender } = props;
    // ===================== Disabled =====================
    const disabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $jMaZ8.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $jMaZ8.useRef)(null);
    $jMaZ8.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $dccb987ebb8837f0$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        var _a;
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if (typeof visibilityToggle === 'object') (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $76031e085d6feec0$var$actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: 'passwordIcon',
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $jMaZ8.cloneElement(/*#__PURE__*/ $jMaZ8.isValidElement(icon) ? icon : /*#__PURE__*/ $jMaZ8.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size } = props, restProps = $76031e085d6feec0$var$__rest(props, [
        "className",
        "prefixCls",
        "inputPrefixCls",
        "size"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = Object.assign(Object.assign({}, (0, $hvG6u.default)(restProps, [
        'suffix',
        'iconRender',
        'visibilityToggle'
    ])), {
        type: visible ? 'text' : 'password',
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon
    });
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $a50a09a915375e3d$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $1cfGC.composeRef)(ref, inputRef)
    }, omittedProps));
});
$76031e085d6feec0$var$Password.displayName = 'Input.Password';
var $76031e085d6feec0$export$2e2bcd8739ae039 = $76031e085d6feec0$var$Password;



var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $bddac4dffd50e494$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $bddac4dffd50e494$export$2e2bcd8739ae039 = $bddac4dffd50e494$var$SearchOutlined;



var $7707703e157f8963$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $bddac4dffd50e494$export$2e2bcd8739ae039)
    }));
};
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ var $7707703e157f8963$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($7707703e157f8963$var$SearchOutlined);
$7707703e157f8963$var$RefIcon.displayName = 'SearchOutlined';
var $7707703e157f8963$export$2e2bcd8739ae039 = $7707703e157f8963$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $1cfGC = parcelRequire("1cfGC");






"use client";
var $73b9bfe71b2def11$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $73b9bfe71b2def11$var$Search = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, suffix: suffix, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd } = props, restProps = $73b9bfe71b2def11$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const composedRef = $jMaZ8.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const { compactSize: compactSize } = (0, $b481086641a221d4$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    const inputRef = $jMaZ8.useRef(null);
    const onChange = (e)=>{
        if ((e === null || e === void 0 ? void 0 : e.target) && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange === null || customOnChange === void 0 || customOnChange(e);
    };
    const onMouseDown = (e)=>{
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    const onSearch = (e)=>{
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $jMaZ8.createElement((0, $7707703e157f8963$export$2e2bcd8739ae039), null) : null;
    const btnClassName = `${prefixCls}-button`;
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(enterButtonAsElement, Object.assign({
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: 'enterButton'
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
        className: btnClassName,
        type: enterButton ? 'primary' : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className);
    const newProps = Object.assign(Object.assign({}, restProps), {
        className: cls,
        prefixCls: inputPrefixCls,
        type: 'search'
    });
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $jMaZ8.createElement((0, $a50a09a915375e3d$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $1cfGC.composeRef)(inputRef, ref),
        onPressEnter: onPressEnter
    }, newProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        disabled: disabled
    }));
});
$73b9bfe71b2def11$var$Search.displayName = 'Search';
var $73b9bfe71b2def11$export$2e2bcd8739ae039 = $73b9bfe71b2def11$var$Search;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $7NxHX = parcelRequire("7NxHX");










var $lULOl = parcelRequire("lULOl");

"use client";
var $c701e4577fe78359$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c701e4577fe78359$var$TextArea = /*#__PURE__*/ (0, $jMaZ8.forwardRef)((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classes, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant } = props, rest = $c701e4577fe78359$var$__rest(props, [
        "prefixCls",
        "bordered",
        "size",
        "disabled",
        "status",
        "allowClear",
        "classNames",
        "rootClassName",
        "className",
        "style",
        "styles",
        "variant"
    ]);
    {
        const { deprecated: deprecated } = (0, $e55cfce129297019$export$cf977aa92c751e61)('TextArea');
        deprecated(!('bordered' in props), 'bordered', 'variant');
    }
    const { getPrefixCls: getPrefixCls, direction: direction, textArea: textArea } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    // ===================== Size =====================
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customizeSize);
    // ===================== Disabled =====================
    const disabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $8d2ac7a62116451d$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Ref =====================
    const innerRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: (option)=>{
                var _a, _b;
                (0, $lULOl.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: ()=>{
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ===================== Style =====================
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $47d23157ef40b741$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [variant, enableVariantCls] = (0, $6883392ce3b89ee5$export$2e2bcd8739ae039)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $2d18f75229ee6335$export$2e2bcd8739ae039)(allowClear !== null && allowClear !== void 0 ? allowClear : textArea === null || textArea === void 0 ? void 0 : textArea.allowClear);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $7NxHX.default), Object.assign({
        autoComplete: textArea === null || textArea === void 0 ? void 0 : textArea.autoComplete
    }, rest, {
        style: Object.assign(Object.assign({}, textArea === null || textArea === void 0 ? void 0 : textArea.style), style),
        styles: Object.assign(Object.assign({}, textArea === null || textArea === void 0 ? void 0 : textArea.styles), styles),
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(cssVarCls, rootCls, className, rootClassName, textArea === null || textArea === void 0 ? void 0 : textArea.className),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), textArea === null || textArea === void 0 ? void 0 : textArea.classNames), {
            textarea: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, (_a = textArea === null || textArea === void 0 ? void 0 : textArea.classNames) === null || _a === void 0 ? void 0 : _a.textarea),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $8d2ac7a62116451d$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: props.showCount || ((_b = props.count) === null || _b === void 0 ? void 0 : _b.show)
            }, hashId)
        }),
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        ref: innerRef
    })));
});
var $c701e4577fe78359$export$2e2bcd8739ae039 = $c701e4577fe78359$var$TextArea;


"use client";
const $33ddf20ce3e4db52$var$Input = (0, $a50a09a915375e3d$export$2e2bcd8739ae039);
$33ddf20ce3e4db52$var$Input.Group = (0, $d65939bc554f661a$export$2e2bcd8739ae039);
$33ddf20ce3e4db52$var$Input.Search = (0, $73b9bfe71b2def11$export$2e2bcd8739ae039);
$33ddf20ce3e4db52$var$Input.TextArea = (0, $c701e4577fe78359$export$2e2bcd8739ae039);
$33ddf20ce3e4db52$var$Input.Password = (0, $76031e085d6feec0$export$2e2bcd8739ae039);
$33ddf20ce3e4db52$var$Input.OTP = (0, $d5c177bb9cdbaafa$export$2e2bcd8739ae039);
var $33ddf20ce3e4db52$export$2e2bcd8739ae039 = $33ddf20ce3e4db52$var$Input;


var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");




var $jMaZ8 = parcelRequire("jMaZ8");






var $giSak = parcelRequire("giSak");



parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $0435d7372766c673$var$genMessageStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, boxShadow: boxShadow, colorText: colorText, colorSuccess: colorSuccess, colorError: colorError, colorWarning: colorWarning, colorInfo: colorInfo, fontSizeLG: fontSizeLG, motionEaseInOutCirc: motionEaseInOutCirc, motionDurationSlow: motionDurationSlow, marginXS: marginXS, paddingXS: paddingXS, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, contentPadding: // Custom token
    contentPadding, contentBg: contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, $kB90R.default)('MessageMoveIn', {
        '0%': {
            padding: 0,
            transform: 'translateY(-100%)',
            opacity: 0
        },
        '100%': {
            padding: paddingXS,
            transform: 'translateY(0)',
            opacity: 1
        }
    });
    const messageMoveOut = new (0, $kB90R.default)('MessageMoveOut', {
        '0%': {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        '100%': {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: 'center',
        [`${componentCls}-custom-content`]: {
            display: 'flex',
            alignItems: 'center'
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: 'inline-block',
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            pointerEvents: 'all'
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                color: colorText,
                position: 'fixed',
                top: marginXS,
                width: '100%',
                pointerEvents: 'none',
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: 'forwards'
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: 'running'
                },
                '&-rtl': {
                    direction: 'rtl',
                    span: {
                        direction: 'rtl'
                    }
                }
            })
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: Object.assign({}, noticeStyle)
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: Object.assign(Object.assign({}, noticeStyle), {
                padding: 0,
                textAlign: 'start'
            })
        }
    ];
};
const $0435d7372766c673$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $5f1c4f12ab1f6aec$export$33ada7d8845f7e5) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
var // ============================== Export ==============================
$0435d7372766c673$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Message', (token)=>{
    // Gen-style functions here
    const combinedToken = (0, $8APUt.merge)(token, {
        height: 150
    });
    return [
        $0435d7372766c673$var$genMessageStyle(combinedToken)
    ];
}, $0435d7372766c673$export$9ca1be8807fe0675);


"use client";
var $960d8b45ee89af48$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $960d8b45ee89af48$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $jMaZ8.createElement((0, $510ddd97f52e903f$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $jMaZ8.createElement((0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $jMaZ8.createElement((0, $93361570ffc8bbe1$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $jMaZ8.createElement((0, $5244cb05538dbe0c$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), null)
};
const $960d8b45ee89af48$export$429c001938db3a78 = (_ref)=>{
    let { prefixCls: prefixCls, type: type, icon: icon, children: children } = _ref;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, icon || $960d8b45ee89af48$export$ad8f8fc3bcd61b4a[type], /*#__PURE__*/ $jMaZ8.createElement("span", null, children));
};
/** @private Internal Component. Do not use in your production. */ const $960d8b45ee89af48$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, type: type, icon: icon, content: content } = props, restProps = $960d8b45ee89af48$var$__rest(props, [
        "prefixCls",
        "className",
        "type",
        "icon",
        "content"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $0435d7372766c673$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $a85ed01a53b666b0$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ $jMaZ8.createElement($960d8b45ee89af48$export$429c001938db3a78, {
            prefixCls: prefixCls,
            type: type,
            icon: icon
        }, content)
    })));
};
var $960d8b45ee89af48$export$2e2bcd8739ae039 = $960d8b45ee89af48$var$PurePanel;



var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");






function $72897d824a4e5e23$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName !== null && transitionName !== void 0 ? transitionName : `${prefixCls}-move-up`
    };
}
function $72897d824a4e5e23$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn === null || closeFn === void 0 || closeFn();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}


"use client";
var $1d92c8ef29d6f80a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1d92c8ef29d6f80a$var$DEFAULT_OFFSET = 8;
const $1d92c8ef29d6f80a$var$DEFAULT_DURATION = 3;
const $1d92c8ef29d6f80a$var$Wrapper = (_ref)=>{
    let { children: children, prefixCls: prefixCls } = _ref;
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $0435d7372766c673$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $931a4f49d98ab7a5$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, cssVarCls, rootCls)
        }
    }, children));
};
const $1d92c8ef29d6f80a$var$renderNotifications = (node, _ref2)=>{
    let { prefixCls: prefixCls, key: key } = _ref2;
    return /*#__PURE__*/ $jMaZ8.createElement($1d92c8ef29d6f80a$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
};
const $1d92c8ef29d6f80a$var$Holder = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { top: top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $1d92c8ef29d6f80a$var$DEFAULT_DURATION, rtl: rtl, transitionName: transitionName, onAllRemoved: onAllRemoved } = props;
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, message: message, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: '50%',
            transform: 'translateX(-50%)',
            top: top !== null && top !== void 0 ? top : $1d92c8ef29d6f80a$var$DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $72897d824a4e5e23$export$7b8936ddc277a29a)(prefixCls, transitionName);
    // ============================ Close Icon =============================
    const mergedCloseIcon = /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-close-x`
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
    // ============================== Origin ===============================
    const [api, holder] = (0, $7f32c9b14d453529$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: false,
        closeIcon: mergedCloseIcon,
        duration: duration,
        getContainer: ()=>(staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        renderNotifications: $1d92c8ef29d6f80a$var$renderNotifications
    });
    // ================================ Ref ================================
    $jMaZ8.useImperativeHandle(ref, ()=>Object.assign(Object.assign({}, api), {
            prefixCls: prefixCls,
            message: message
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $1d92c8ef29d6f80a$var$keyIndex = 0;
function $1d92c8ef29d6f80a$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $jMaZ8.useRef(null);
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Message');
    // ================================ API ================================
    const wrapAPI = $jMaZ8.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            var _a;
            (_a = holderRef.current) === null || _a === void 0 || _a.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                warning(false, 'usage', 'You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.');
                const fakeResult = ()=>{};
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message } = holderRef.current;
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose } = config, restConfig = $1d92c8ef29d6f80a$var$__rest(config, [
                "content",
                "icon",
                "type",
                "key",
                "className",
                "style",
                "onClose"
            ]);
            let mergedKey = key;
            if (mergedKey === undefined || mergedKey === null) {
                $1d92c8ef29d6f80a$var$keyIndex += 1;
                mergedKey = `antd-message-${$1d92c8ef29d6f80a$var$keyIndex}`;
            }
            return (0, $72897d824a4e5e23$export$52ce770daa307a45)((resolve)=>{
                originOpen(Object.assign(Object.assign({}, restConfig), {
                    key: mergedKey,
                    content: /*#__PURE__*/ $jMaZ8.createElement((0, $960d8b45ee89af48$export$429c001938db3a78), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon
                    }, content),
                    placement: 'top',
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(type && `${noticePrefixCls}-${type}`, className, message === null || message === void 0 ? void 0 : message.className),
                    style: Object.assign(Object.assign({}, message === null || message === void 0 ? void 0 : message.style), style),
                    onClose: ()=>{
                        onClose === null || onClose === void 0 || onClose();
                        resolve();
                    }
                }));
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            var _a;
            if (key !== undefined) close(key);
            else (_a = holderRef.current) === null || _a === void 0 || _a.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if (jointContent && typeof jointContent === 'object' && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === 'function') mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = Object.assign(Object.assign({
                    onClose: mergedOnClose,
                    duration: mergedDuration
                }, config), {
                    type: type
                });
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $jMaZ8.createElement($1d92c8ef29d6f80a$var$Holder, Object.assign({
            key: "message-holder"
        }, messageConfig, {
            ref: holderRef
        }))
    ];
}
function $1d92c8ef29d6f80a$export$2e2bcd8739ae039(messageConfig) {
    return $1d92c8ef29d6f80a$export$1689db33b6c27d9e(messageConfig);
}



"use client";
let $cff19b71ca14530c$var$message = null;
let $cff19b71ca14530c$var$act = (callback)=>callback();
let $cff19b71ca14530c$var$taskQueue = [];
let $cff19b71ca14530c$var$defaultGlobalConfig = {};
function $cff19b71ca14530c$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top } = $cff19b71ca14530c$var$defaultGlobalConfig;
    const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top
    };
}
const $cff19b71ca14530c$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = $cff19b71ca14530c$var$defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, $jMaZ8.useContext)((0, $eed7b8e1d0775da5$export$264c6064649f9206));
    const [api, holder] = (0, $1d92c8ef29d6f80a$export$1689db33b6c27d9e)(Object.assign(Object.assign(Object.assign({}, messageConfig), {
        prefixCls: prefixCls
    }), appConfig.message));
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useImperativeHandle(ref, ()=>{
        const instance = Object.assign({}, api);
        Object.keys(instance).forEach((method)=>{
            instance[method] = function() {
                sync();
                return api[method].apply(api, arguments);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $cff19b71ca14530c$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState($cff19b71ca14530c$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($cff19b71ca14530c$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(sync, []);
    const global = (0, $cf928c204584b9b8$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($cff19b71ca14530c$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $cf928c204584b9b8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
function $cff19b71ca14530c$var$flushNotice() {
    if (!$cff19b71ca14530c$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $cff19b71ca14530c$var$message = newMessage;
        // Delay render to avoid sync issue
        $cff19b71ca14530c$var$act(()=>{
            const reactRender = (0, $49fd731f963d0354$export$1c4a73059151cd3e)();
            reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($cff19b71ca14530c$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $cff19b71ca14530c$var$flushNotice();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$cff19b71ca14530c$var$message.instance) return;
    // >>> Execute task
    $cff19b71ca14530c$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                $cff19b71ca14530c$var$act(()=>{
                    const closeFn = $cff19b71ca14530c$var$message.instance.open(Object.assign(Object.assign({}, $cff19b71ca14530c$var$defaultGlobalConfig), task.config));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                $cff19b71ca14530c$var$act(()=>{
                    $cff19b71ca14530c$var$message === null || $cff19b71ca14530c$var$message === void 0 || $cff19b71ca14530c$var$message.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $cff19b71ca14530c$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $cff19b71ca14530c$var$message.instance)[type].apply(_message$instance, (0, $fvBso.default)(task.args));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $cff19b71ca14530c$var$taskQueue = [];
}
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $cff19b71ca14530c$var$setMessageGlobalConfig(config) {
    $cff19b71ca14530c$var$defaultGlobalConfig = Object.assign(Object.assign({}, $cff19b71ca14530c$var$defaultGlobalConfig), config);
    // Trigger sync for it
    $cff19b71ca14530c$var$act(()=>{
        var _a;
        (_a = $cff19b71ca14530c$var$message === null || $cff19b71ca14530c$var$message === void 0 ? void 0 : $cff19b71ca14530c$var$message.sync) === null || _a === void 0 || _a.call($cff19b71ca14530c$var$message);
    });
}
function $cff19b71ca14530c$var$open(config) {
    const result = (0, $72897d824a4e5e23$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $cff19b71ca14530c$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $cff19b71ca14530c$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $cff19b71ca14530c$var$flushNotice();
    return result;
}
function $cff19b71ca14530c$var$typeOpen(type, args) {
    const global = (0, $cf928c204584b9b8$export$f9cd1e43211d8a4a)();
    if (!global.holderRender) (0, $cf928c204584b9b8$export$7c4f6da0f9434a77)('message');
    const result = (0, $72897d824a4e5e23$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $cff19b71ca14530c$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $cff19b71ca14530c$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $cff19b71ca14530c$var$flushNotice();
    return result;
}
const $cff19b71ca14530c$var$destroy = (key)=>{
    $cff19b71ca14530c$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $cff19b71ca14530c$var$flushNotice();
};
const $cff19b71ca14530c$var$methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const $cff19b71ca14530c$var$baseStaticMethods = {
    open: $cff19b71ca14530c$var$open,
    destroy: $cff19b71ca14530c$var$destroy,
    config: $cff19b71ca14530c$var$setMessageGlobalConfig,
    useMessage: $1d92c8ef29d6f80a$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $960d8b45ee89af48$export$2e2bcd8739ae039)
};
const $cff19b71ca14530c$var$staticMethods = $cff19b71ca14530c$var$baseStaticMethods;
$cff19b71ca14530c$var$methods.forEach((type)=>{
    $cff19b71ca14530c$var$staticMethods[type] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $cff19b71ca14530c$var$typeOpen(type, args);
    };
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $cff19b71ca14530c$var$noop = ()=>{};
let $cff19b71ca14530c$export$71ceb3dabb09f455 = $cff19b71ca14530c$var$noop;
$cff19b71ca14530c$export$71ceb3dabb09f455 = (wrapper)=>{
    $cff19b71ca14530c$var$act = wrapper;
};
let $cff19b71ca14530c$export$43de32c50edff050 = $cff19b71ca14530c$var$noop;
$cff19b71ca14530c$export$43de32c50edff050 = ()=>{
    $cff19b71ca14530c$var$message = null;
};
var $cff19b71ca14530c$export$2e2bcd8739ae039 = $cff19b71ca14530c$var$staticMethods;


var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");




var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");





var $giSak = parcelRequire("giSak");







var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");

var $9SyO6 = parcelRequire("9SyO6");


"use client";
function $6186cf368cb79e21$var$isThenable(thing) {
    return !!(thing === null || thing === void 0 ? void 0 : thing.then);
}
const $6186cf368cb79e21$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $jMaZ8.useRef(false);
    const buttonRef = $jMaZ8.useRef(null);
    const [loading, setLoading] = (0, $9SyO6.default)(false);
    const onInternalClose = function() {
        close === null || close === void 0 || close.apply(void 0, arguments);
    };
    $jMaZ8.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!$6186cf368cb79e21$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then(function() {
            setLoading(false, true);
            onInternalClose.apply(void 0, arguments);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$6186cf368cb79e21$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!$6186cf368cb79e21$var$isThenable(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), Object.assign({}, (0, $e4847c5f9a9fd582$export$19bc9a290855952)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: buttonRef
    }), children);
};
var $6186cf368cb79e21$export$2e2bcd8739ae039 = $6186cf368cb79e21$var$ActionButton;



var $jMaZ8 = parcelRequire("jMaZ8");
const $09e3858c077c8130$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext({});
const { Provider: $09e3858c077c8130$export$7c9538f5f3c365e9 } = $09e3858c077c8130$export$ab57792b9b6974a6;


"use client";
const $25af039ced615a5d$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm } = (0, $jMaZ8.useContext)((0, $09e3858c077c8130$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $6186cf368cb79e21$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: function() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $25af039ced615a5d$export$2e2bcd8739ae039 = $25af039ced615a5d$var$ConfirmCancelBtn;



var $jMaZ8 = parcelRequire("jMaZ8");


"use client";
const $8bc7656953ad918a$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk } = (0, $jMaZ8.useContext)((0, $09e3858c077c8130$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $6186cf368cb79e21$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || 'primary',
        actionFn: onOk,
        close: function() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(true);
        },
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $8bc7656953ad918a$export$2e2bcd8739ae039 = $8bc7656953ad918a$var$ConfirmOkBtn;




var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $3fkx6 = parcelRequire("3fkx6");


var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
var $5418a623ba4bf613$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $jMaZ8.createContext({});



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $eN1T8 = parcelRequire("eN1T8");




var $jMaZ8 = parcelRequire("jMaZ8");
// =============================== Motion ===============================
function $af8f6fb25815b691$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $af8f6fb25815b691$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $af8f6fb25815b691$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $af8f6fb25815b691$var$getScroll(w);
    pos.top += $af8f6fb25815b691$var$getScroll(w, true);
    return pos;
}



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");


var $hH60s = parcelRequire("hH60s");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $giSak = parcelRequire("giSak");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");
var $243c6f9128727b8d$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});



var $eec8580e845ab066$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
var $eec8580e845ab066$var$entityStyle = {
    outline: 'none'
};
var $eec8580e845ab066$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
    // ================================= Refs =================================
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $5418a623ba4bf613$export$ee4e38b469b6f5d1)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $1cfGC.useComposeRef)(holderRef, panelRef);
    var sentinelStartRef = (0, $jMaZ8.useRef)();
    var sentinelEndRef = (0, $jMaZ8.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                    preventScroll: true
                });
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode = footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
        style: (0, $8u3qN.default)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
    }, footer) : null;
    var headerNode = title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
        style: (0, $8u3qN.default)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title)) : null;
    var closableObj = (0, $jMaZ8.useMemo)(function() {
        if ((0, $1Esi2.default)(closable) === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
                className: "".concat(prefixCls, "-close-x")
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    var ariaProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(closableObj, true);
    var closeBtnIsDisabled = (0, $1Esi2.default)(closable) === 'object' && closable.disabled;
    var closerNode = closable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("button", (0, $hH60s.default)({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: "".concat(prefixCls, "-close"),
        disabled: closeBtnIsDisabled
    }), closableObj.closeIcon) : null;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
        style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
    }, closerNode, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        ref: sentinelStartRef,
        tabIndex: 0,
        style: $eec8580e845ab066$var$entityStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $243c6f9128727b8d$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $eec8580e845ab066$var$sentinelStyle
    }));
});
$eec8580e845ab066$var$Panel.displayName = 'Panel';
var $eec8580e845ab066$export$2e2bcd8739ae039 = $eec8580e845ab066$var$Panel;


var $5e2891f919878440$var$Content = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $jMaZ8.useRef)();
    // ============================= Style ==============================
    var _React$useState = $jMaZ8.useState(), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $af8f6fb25815b691$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $eec8580e845ab066$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, motionClassName)
        }));
    });
});
$5e2891f919878440$var$Content.displayName = 'Content';
var $5e2891f919878440$export$2e2bcd8739ae039 = $5e2891f919878440$var$Content;



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");
var $7a01975a7bab256b$var$Mask = function Mask(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className = props.className;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
            ref: ref,
            style: (0, $8u3qN.default)((0, $8u3qN.default)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-mask"), motionClassName, className)
        }, maskProps));
    });
};
var $7a01975a7bab256b$export$2e2bcd8739ae039 = $7a01975a7bab256b$var$Mask;



var $2bFmQ = parcelRequire("2bFmQ");
var $adb81ce29e886dea$var$Dialog = function Dialog(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
    [
        'wrapStyle',
        'bodyStyle',
        'maskStyle'
    ].forEach(function(prop) {
        // (prop in props) && console.error(`Warning: ${prop} is deprecated, please use styles instead.`)
        (0, $2bFmQ.warning)(!(prop in props), "".concat(prop, " is deprecated, please use styles instead."));
    });
    if ('wrapClassName' in props) (0, $2bFmQ.warning)(false, "wrapClassName is deprecated, please use classNames instead.");
    var lastOutSideActiveElementRef = (0, $jMaZ8.useRef)();
    var wrapperRef = (0, $jMaZ8.useRef)();
    var contentRef = (0, $jMaZ8.useRef)();
    var _React$useState = $jMaZ8.useState(visible), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $715c60aee4cde1e6$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $eN1T8.default)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $eN1T8.default)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $jMaZ8.useRef)(false);
    var contentTimeoutRef = (0, $jMaZ8.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $jMaZ8.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $jMaZ8.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    var mergedStyle = (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({
        zIndex: zIndex
    }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
        display: !animatedVisible ? 'none' : null
    });
    // ========================= Render =========================
    return /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $jMaZ8.createElement((0, $7a01975a7bab256b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $af8f6fb25815b691$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({
            zIndex: zIndex
        }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
        maskProps: maskProps,
        className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
    }), /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $jMaZ8.createElement((0, $5e2891f919878440$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $af8f6fb25815b691$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
};
var $adb81ce29e886dea$export$2e2bcd8739ae039 = $adb81ce29e886dea$var$Dialog;


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $6cbdf80da14d9576$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
    var _React$useState = $jMaZ8.useState(visible), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    var refContext = $jMaZ8.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    $jMaZ8.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $5418a623ba4bf613$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $11a2eab5458a1b52$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $adb81ce29e886dea$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    }))));
};
$6cbdf80da14d9576$var$DialogWrap.displayName = 'Dialog';
var $6cbdf80da14d9576$export$2e2bcd8739ae039 = $6cbdf80da14d9576$var$DialogWrap;



var $236c8316fc410342$export$2e2bcd8739ae039 = (0, $6cbdf80da14d9576$export$2e2bcd8739ae039);




var $jMaZ8 = parcelRequire("jMaZ8");


"use client";
function $547f96b25a48e540$export$51ad9c30389f050b(context) {
    if (!context) return undefined;
    return {
        closable: context.closable,
        closeIcon: context.closeIcon
    };
}
/** Convert `closable` and `closeIcon` to config object */ function $547f96b25a48e540$var$useClosableConfig(closableCollection) {
    const { closable: closable, closeIcon: closeIcon } = closableCollection || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>{
        if (// If `closable`, whatever rest be should be true
        !closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
        if (closable === undefined && closeIcon === undefined) return null;
        let closableConfig = {
            closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
        };
        if (closable && typeof closable === 'object') closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
        return closableConfig;
    }, [
        closable,
        closeIcon
    ]);
}
/**
 * Assign object without `undefined` field. Will skip if is `false`.
 * This helps to handle both closableConfig or false
 */ function $547f96b25a48e540$var$assignWithoutUndefined() {
    const target = {};
    for(var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++)objList[_key] = arguments[_key];
    objList.forEach((obj)=>{
        if (obj) Object.keys(obj).forEach((key)=>{
            if (obj[key] !== undefined) target[key] = obj[key];
        });
    });
    return target;
}
/** Use same object to support `useMemo` optimization */ const $547f96b25a48e540$var$EmptyFallbackCloseCollection = {};
function $547f96b25a48e540$export$2e2bcd8739ae039(propCloseCollection, contextCloseCollection) {
    let fallbackCloseCollection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $547f96b25a48e540$var$EmptyFallbackCloseCollection;
    // Align the `props`, `context` `fallback` to config object first
    const propCloseConfig = $547f96b25a48e540$var$useClosableConfig(propCloseCollection);
    const contextCloseConfig = $547f96b25a48e540$var$useClosableConfig(contextCloseCollection);
    const closeBtnIsDisabled = typeof propCloseConfig !== 'boolean' ? !!(propCloseConfig === null || propCloseConfig === void 0 ? void 0 : propCloseConfig.disabled) : false;
    const mergedFallbackCloseCollection = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>Object.assign({
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), null)
        }, fallbackCloseCollection), [
        fallbackCloseCollection
    ]);
    // Use fallback logic to fill the config
    const mergedClosableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>{
        // ================ Props First ================
        // Skip if prop is disabled
        if (propCloseConfig === false) return false;
        if (propCloseConfig) return $547f96b25a48e540$var$assignWithoutUndefined(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
        // =============== Context Second ==============
        // Skip if context is disabled
        if (contextCloseConfig === false) return false;
        if (contextCloseConfig) return $547f96b25a48e540$var$assignWithoutUndefined(mergedFallbackCloseCollection, contextCloseConfig);
        // ============= Fallback Default ==============
        return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
    }, [
        propCloseConfig,
        contextCloseConfig,
        mergedFallbackCloseCollection
    ]);
    // Calculate the final closeIcon
    return (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>{
        if (mergedClosableConfig === false) return [
            false,
            null,
            closeBtnIsDisabled
        ];
        const { closeIconRender: closeIconRender } = mergedFallbackCloseCollection;
        const { closeIcon: closeIcon } = mergedClosableConfig;
        let mergedCloseIcon = closeIcon;
        if (mergedCloseIcon !== null && mergedCloseIcon !== undefined) {
            // Wrap the closeIcon if needed
            if (closeIconRender) mergedCloseIcon = closeIconRender(closeIcon);
            // Wrap the closeIcon with aria props
            const ariaProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(mergedClosableConfig, true);
            if (Object.keys(ariaProps).length) mergedCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).isValidElement(mergedCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(mergedCloseIcon, ariaProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", Object.assign({}, ariaProps), mergedCloseIcon);
        }
        return [
            true,
            mergedCloseIcon,
            closeBtnIsDisabled
        ];
    }, [
        mergedClosableConfig,
        mergedFallbackCloseCollection
    ]);
}





var $h9ujZ = parcelRequire("h9ujZ");

var $h9ujZ = parcelRequire("h9ujZ");
var $cf512cb263ad7ac0$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $h9ujZ.default)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $cf512cb263ad7ac0$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$cf512cb263ad7ac0$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement('div');
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $cf512cb263ad7ac0$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $cf512cb263ad7ac0$var$isStyleValueSupport(styleName, styleValue);
    return $cf512cb263ad7ac0$var$isStyleNameSupport(styleName);
}


const $cd054eee77ca9f3e$export$7dbdadf5e9653129 = ()=>(0, $h9ujZ.default)() && window.document.documentElement;







var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
"use client";
const $2ce21f5e4c6d118e$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = $jMaZ8.useMemo(()=>typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, sizeCls, shapeCls, className),
        style: Object.assign(Object.assign({}, sizeStyle), style)
    });
};
var $2ce21f5e4c6d118e$export$2e2bcd8739ae039 = $2ce21f5e4c6d118e$var$Element;


parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $b1d171bd843a9ef1$var$skeletonClsLoading = new (0, $kB90R.default)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const $b1d171bd843a9ef1$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $4g3I0.unit)(size)
    });
const $b1d171bd843a9ef1$var$genSkeletonElementAvatarSize = (size)=>Object.assign({
        width: size
    }, $b1d171bd843a9ef1$var$genSkeletonElementCommonSize(size));
const $b1d171bd843a9ef1$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: $b1d171bd843a9ef1$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const $b1d171bd843a9ef1$var$genSkeletonElementInputSize = (size, calc)=>Object.assign({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal()
    }, $b1d171bd843a9ef1$var$genSkeletonElementCommonSize(size));
const $b1d171bd843a9ef1$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor
        }, $b1d171bd843a9ef1$var$genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementAvatarSize(controlHeightSM))
    };
};
const $b1d171bd843a9ef1$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $b1d171bd843a9ef1$var$genSkeletonElementInputSize(controlHeight, calc)),
        [`${skeletonInputCls}-lg`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementInputSize(controlHeightLG, calc)),
        [`${skeletonInputCls}-sm`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementInputSize(controlHeightSM, calc))
    };
};
const $b1d171bd843a9ef1$var$genSkeletonElementImageSize = (size)=>Object.assign({
        width: size
    }, $b1d171bd843a9ef1$var$genSkeletonElementCommonSize(size));
const $b1d171bd843a9ef1$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, calc: calc } = token;
    return {
        [skeletonImageCls]: Object.assign(Object.assign({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            verticalAlign: 'middle',
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $b1d171bd843a9ef1$var$genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementImageSize(imageSizeBase)), {
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            }),
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        }),
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const $b1d171bd843a9ef1$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $b1d171bd843a9ef1$var$genSkeletonElementButtonSize = (size, calc)=>Object.assign({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal()
    }, $b1d171bd843a9ef1$var$genSkeletonElementCommonSize(size));
const $b1d171bd843a9ef1$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        [skeletonButtonCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal()
        }, $b1d171bd843a9ef1$var$genSkeletonElementButtonSize(controlHeight, calc))
    }, $b1d171bd843a9ef1$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), {
        [`${skeletonButtonCls}-lg`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementButtonSize(controlHeightLG, calc))
    }), $b1d171bd843a9ef1$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`)), {
        [`${skeletonButtonCls}-sm`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementButtonSize(controlHeightSM, calc))
    }), $b1d171bd843a9ef1$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`));
};
// =============================== Base ===============================
const $b1d171bd843a9ef1$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: Object.assign({
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor
                }, $b1d171bd843a9ef1$var$genSkeletonElementAvatarSize(controlHeight)),
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementAvatarSize(controlHeightLG)),
                [`${skeletonAvatarCls}-sm`]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonElementAvatarSize(controlHeightSM))
            },
            [`${componentCls}-content`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-content`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-content`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton element
        [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
            display: 'inline-block',
            width: 'auto'
        }, $b1d171bd843a9ef1$var$genSkeletonElementButton(token)), $b1d171bd843a9ef1$var$genSkeletonElementAvatar(token)), $b1d171bd843a9ef1$var$genSkeletonElementInput(token)), $b1d171bd843a9ef1$var$genSkeletonElementImage(token)),
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, $b1d171bd843a9ef1$var$genSkeletonColor(token))
        }
    };
};
const $b1d171bd843a9ef1$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $b1d171bd843a9ef1$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Skeleton', (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $8APUt.merge)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return [
        $b1d171bd843a9ef1$var$genBaseStyle(skeletonToken)
    ];
}, $b1d171bd843a9ef1$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});


"use client";
const $d1e685b722d561e3$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, shape: shape = 'circle', size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b1d171bd843a9ef1$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $hvG6u.default)(props, [
        'prefixCls',
        'className'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $2ce21f5e4c6d118e$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-avatar`,
        shape: shape,
        size: size
    }, otherProps))));
};
var $d1e685b722d561e3$export$2e2bcd8739ae039 = $d1e685b722d561e3$var$SkeletonAvatar;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");



"use client";
const $603d9824403226da$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block = false, size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b1d171bd843a9ef1$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $hvG6u.default)(props, [
        'prefixCls'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $2ce21f5e4c6d118e$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-button`,
        size: size
    }, otherProps))));
};
var $603d9824403226da$export$2e2bcd8739ae039 = $603d9824403226da$var$SkeletonButton;




var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


"use client";
const $b017d697db427bf0$var$path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const $b017d697db427bf0$var$SkeletonImage = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active } = props;
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b1d171bd843a9ef1$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-image`, className),
        style: style
    }, /*#__PURE__*/ $jMaZ8.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $jMaZ8.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: $b017d697db427bf0$var$path,
        className: `${prefixCls}-image-path`
    })))));
};
var $b017d697db427bf0$export$2e2bcd8739ae039 = $b017d697db427bf0$var$SkeletonImage;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");



"use client";
const $4695e6a2e2752e38$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block, size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b1d171bd843a9ef1$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $hvG6u.default)(props, [
        'prefixCls'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $2ce21f5e4c6d118e$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-input`,
        size: size
    }, otherProps))));
};
var $4695e6a2e2752e38$export$2e2bcd8739ae039 = $4695e6a2e2752e38$var$SkeletonInput;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


"use client";
const $5e86ae2d22161462$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b1d171bd843a9ef1$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, className, rootClassName, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-image`, className),
        style: style
    }, children)));
};
var $5e86ae2d22161462$export$2e2bcd8739ae039 = $5e86ae2d22161462$var$SkeletonNode;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
"use client";
const $e1276631b41bc48b$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $e1276631b41bc48b$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows } = props;
    const rowList = (0, $fvBso.default)(new Array(rows)).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $jMaZ8.createElement("li", {
            key: index,
            style: {
                width: $e1276631b41bc48b$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $jMaZ8.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className),
        style: style
    }, rowList);
};
var $e1276631b41bc48b$export$2e2bcd8739ae039 = $e1276631b41bc48b$var$Paragraph;




var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
"use client";
const $b2016ebb0e18fb2a$var$Title = (_ref)=>{
    let { prefixCls: prefixCls, className: className, width: width, style: style } = _ref;
    return(/*#__PURE__*/ // biome-ignore lint/a11y/useHeadingContent: HOC here
    $jMaZ8.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className),
        style: Object.assign({
            width: width
        }, style)
    }));
};
var $b2016ebb0e18fb2a$export$2e2bcd8739ae039 = $b2016ebb0e18fb2a$var$Title;


"use client";
function $3fb40601ab168cf6$var$getComponentProps(prop) {
    if (prop && typeof prop === 'object') return prop;
    return {};
}
function $3fb40601ab168cf6$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $3fb40601ab168cf6$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $3fb40601ab168cf6$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
const $3fb40601ab168cf6$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, style: style, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, skeleton: skeleton } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b1d171bd843a9ef1$export$2e2bcd8739ae039)(prefixCls);
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = Object.assign(Object.assign({
                prefixCls: `${prefixCls}-avatar`
            }, $3fb40601ab168cf6$var$getAvatarBasicProps(hasTitle, hasParagraph)), $3fb40601ab168cf6$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $jMaZ8.createElement("div", {
                className: `${prefixCls}-header`
            }, /*#__PURE__*/ $jMaZ8.createElement((0, $2ce21f5e4c6d118e$export$2e2bcd8739ae039), Object.assign({}, avatarProps)));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-title`
                }, $3fb40601ab168cf6$var$getTitleBasicProps(hasAvatar, hasParagraph)), $3fb40601ab168cf6$var$getComponentProps(title));
                $title = /*#__PURE__*/ $jMaZ8.createElement((0, $b2016ebb0e18fb2a$export$2e2bcd8739ae039), Object.assign({}, titleProps));
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-paragraph`
                }, $3fb40601ab168cf6$var$getParagraphBasicProps(hasAvatar, hasTitle)), $3fb40601ab168cf6$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $jMaZ8.createElement((0, $e1276631b41bc48b$export$2e2bcd8739ae039), Object.assign({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $jMaZ8.createElement("div", {
                className: `${prefixCls}-content`
            }, $title, paragraphNode);
        }
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, skeleton === null || skeleton === void 0 ? void 0 : skeleton.className, className, rootClassName, hashId, cssVarCls);
        return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
            className: cls,
            style: Object.assign(Object.assign({}, skeleton === null || skeleton === void 0 ? void 0 : skeleton.style), style)
        }, avatarNode, contentNode));
    }
    return children !== null && children !== void 0 ? children : null;
};
$3fb40601ab168cf6$var$Skeleton.Button = (0, $603d9824403226da$export$2e2bcd8739ae039);
$3fb40601ab168cf6$var$Skeleton.Avatar = (0, $d1e685b722d561e3$export$2e2bcd8739ae039);
$3fb40601ab168cf6$var$Skeleton.Input = (0, $4695e6a2e2752e38$export$2e2bcd8739ae039);
$3fb40601ab168cf6$var$Skeleton.Image = (0, $b017d697db427bf0$export$2e2bcd8739ae039);
$3fb40601ab168cf6$var$Skeleton.Node = (0, $5e86ae2d22161462$export$2e2bcd8739ae039);
$3fb40601ab168cf6$var$Skeleton.displayName = 'Skeleton';
var $3fb40601ab168cf6$export$2e2bcd8739ae039 = $3fb40601ab168cf6$var$Skeleton;


"use client";
var $069691000a77b0e1$export$2e2bcd8739ae039 = (0, $3fb40601ab168cf6$export$2e2bcd8739ae039);



var $jMaZ8 = parcelRequire("jMaZ8");

var $ktS49 = parcelRequire("ktS49");
function $75e1b8460fa96589$var$voidFunc() {}
const $75e1b8460fa96589$var$WatermarkContext = /*#__PURE__*/ $jMaZ8.createContext({
    add: $75e1b8460fa96589$var$voidFunc,
    remove: $75e1b8460fa96589$var$voidFunc
});
function $75e1b8460fa96589$export$94ab53417567be34(panelSelector) {
    const watermark = $jMaZ8.useContext($75e1b8460fa96589$var$WatermarkContext);
    const panelEleRef = $jMaZ8.useRef(null);
    const panelRef = (0, $ktS49.default)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            watermark.add(innerContentEle);
            panelEleRef.current = innerContentEle;
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $75e1b8460fa96589$export$2e2bcd8739ae039 = $75e1b8460fa96589$var$WatermarkContext;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");




var $jMaZ8 = parcelRequire("jMaZ8");


"use client";
const $dfb17af89b05320d$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $jMaZ8.useContext)((0, $09e3858c077c8130$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), Object.assign({
        onClick: onCancel
    }, cancelButtonProps), cancelTextLocale);
};
var $dfb17af89b05320d$export$2e2bcd8739ae039 = $dfb17af89b05320d$var$NormalCancelBtn;



var $jMaZ8 = parcelRequire("jMaZ8");



"use client";
const $2906e2ea9deda5ed$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $jMaZ8.useContext)((0, $09e3858c077c8130$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), Object.assign({}, (0, $e4847c5f9a9fd582$export$19bc9a290855952)(okType), {
        loading: confirmLoading,
        onClick: onOk
    }, okButtonProps), okTextLocale);
};
var $2906e2ea9deda5ed$export$2e2bcd8739ae039 = $2906e2ea9deda5ed$var$NormalOkBtn;




"use client";
function $6b398ee3f08e606d$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
}
const $6b398ee3f08e606d$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = 'primary', cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Modal', (0, $699cf533d6ec795e$export$1b6004afda18cd51)());
    // ================== Locale Text ==================
    const okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
    const cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = {
        confirmLoading: confirmLoading,
        okButtonProps: okButtonProps,
        cancelButtonProps: cancelButtonProps,
        okTextLocale: okTextLocale,
        cancelTextLocale: cancelTextLocale,
        okType: okType,
        onOk: onOk,
        onCancel: onCancel
    };
    const btnCtxValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>btnCtxValue, (0, $fvBso.default)(Object.values(btnCtxValue)));
    let footerNode;
    if (typeof footer === 'function' || typeof footer === 'undefined') {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $dfb17af89b05320d$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $2906e2ea9deda5ed$export$2e2bcd8739ae039), null));
        if (typeof footer === 'function') footerNode = footer(footerNode, {
            OkBtn: (0, $2906e2ea9deda5ed$export$2e2bcd8739ae039),
            CancelBtn: (0, $dfb17af89b05320d$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $09e3858c077c8130$export$7c9538f5f3c365e9), {
            value: btnCtxValueMemo
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $fb8ef783ef39e103$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};



var $fvBso = parcelRequire("fvBso");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");


parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

const $97e15ec2e21e35be$export$82e6205b15e6c637 = new (0, $kB90R.default)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $97e15ec2e21e35be$export$c091916f1530334c = new (0, $kB90R.default)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $97e15ec2e21e35be$export$2909268c8354a12 = function(token) {
    let sameLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $7d04c31aa62562e0$export$83e1da9e09ec9112)(motionCls, $97e15ec2e21e35be$export$82e6205b15e6c637, $97e15ec2e21e35be$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
function $d5deaaf64bfa7773$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $d5deaaf64bfa7773$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: 'none',
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: 'none'
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask`]: Object.assign(Object.assign({}, $d5deaaf64bfa7773$var$box('fixed')), {
                    zIndex: token.zIndexPopupBase,
                    height: '100%',
                    backgroundColor: token.colorBgMask,
                    pointerEvents: 'none',
                    [`${componentCls}-hidden`]: {
                        display: 'none'
                    }
                }),
                [`${componentCls}-wrap`]: Object.assign(Object.assign({}, $d5deaaf64bfa7773$var$box('fixed')), {
                    zIndex: token.zIndexPopupBase,
                    overflow: 'auto',
                    outline: 0,
                    WebkitOverflowScrolling: 'touch'
                })
            }
        },
        {
            [`${componentCls}-root`]: (0, $97e15ec2e21e35be$export$2909268c8354a12)(token)
        }
    ];
};
const $d5deaaf64bfa7773$var$genModalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: 'rtl'
                },
                [`${componentCls}-centered`]: {
                    textAlign: 'center',
                    '&::before': {
                        display: 'inline-block',
                        width: 0,
                        height: '100%',
                        verticalAlign: 'middle',
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: 'inline-block',
                        paddingBottom: 0,
                        textAlign: 'start',
                        verticalAlign: 'middle'
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: 'calc(100vw - 16px)',
                        margin: `${(0, $4g3I0.unit)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                pointerEvents: 'none',
                position: 'relative',
                top: 100,
                width: 'auto',
                maxWidth: `calc(100vw - ${(0, $4g3I0.unit)(token.calc(token.margin).mul(2).equal())})`,
                margin: '0 auto',
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: 'break-word'
                },
                [`${componentCls}-content`]: {
                    position: 'relative',
                    backgroundColor: token.contentBg,
                    backgroundClip: 'padding-box',
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: 'auto',
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: Object.assign({
                    position: 'absolute',
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: 'none',
                    background: 'transparent',
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: 'pointer',
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    '&-x': {
                        display: 'flex',
                        fontSize: token.fontSizeLG,
                        fontStyle: 'normal',
                        lineHeight: (0, $4g3I0.unit)(token.modalCloseBtnSize),
                        justifyContent: 'center',
                        textTransform: 'none',
                        textRendering: 'auto'
                    },
                    '&:disabled': {
                        pointerEvents: 'none'
                    },
                    '&:hover': {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: 'none'
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    }
                }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)),
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: 'break-word',
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: `${(0, $4g3I0.unit)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: 'end',
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: 'hidden'
                }
            })
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: 'auto',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 'auto'
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: 'auto'
                }
            }
        }
    ];
};
const $d5deaaf64bfa7773$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: 'rtl',
                [`${componentCls}-confirm-body`]: {
                    direction: 'rtl'
                }
            }
        }
    };
};
const $d5deaaf64bfa7773$var$genResponsiveWidthStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const gridMediaSizesMap = (0, $e029ba939422c8b3$export$6353f655434817c5)(token);
    delete gridMediaSizesMap.xs;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, $4g3I0.unit)(gridMediaSizesMap[key])})`]: {
                width: `var(--${componentCls.replace('.', '')}-${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [
                {
                    width: `var(--${componentCls.replace('.', '')}-xs-width)`
                }
            ].concat((0, $fvBso.default)(responsiveStyles))
        }
    };
};
const $d5deaaf64bfa7773$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $8APUt.merge)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $d5deaaf64bfa7773$export$9ca1be8807fe0675 = (token)=>({
        footerBg: 'transparent',
        headerBg: token.colorBgElevated,
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $4g3I0.unit)(token.paddingMD)} ${(0, $4g3I0.unit)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $4g3I0.unit)(token.padding)} ${(0, $4g3I0.unit)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $4g3I0.unit)(token.paddingXS)} ${(0, $4g3I0.unit)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $4g3I0.unit)(token.padding * 2)} ${(0, $4g3I0.unit)(token.padding * 2)} ${(0, $4g3I0.unit)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
    });
var $d5deaaf64bfa7773$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Modal', (token)=>{
    const modalToken = $d5deaaf64bfa7773$export$362fb92a8f81bbf9(token);
    return [
        $d5deaaf64bfa7773$var$genModalStyle(modalToken),
        $d5deaaf64bfa7773$var$genRTLStyle(modalToken),
        $d5deaaf64bfa7773$export$8bb6dada04673ddd(modalToken),
        (0, $90d7c1b8e663dcab$export$f5d123412490d9dc)(modalToken, 'zoom'),
        $d5deaaf64bfa7773$var$genResponsiveWidthStyle(modalToken)
    ];
}, $d5deaaf64bfa7773$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});


"use client";
var $92628feafcd06c86$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $92628feafcd06c86$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $92628feafcd06c86$var$getClickPosition = (e)=>{
    $92628feafcd06c86$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $92628feafcd06c86$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $cd054eee77ca9f3e$export$7dbdadf5e9653129)()) document.documentElement.addEventListener('click', $92628feafcd06c86$var$getClickPosition, true);
const $92628feafcd06c86$var$Modal = (props)=>{
    var _a;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, modal: modalContext } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const handleCancel = (e)=>{
        const { onCancel: onCancel } = props;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    const handleOk = (e)=>{
        const { onOk: onOk } = props;
        onOk === null || onOk === void 0 || onOk(e);
    };
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Modal');
        [
            [
                'visible',
                'open'
            ],
            [
                'bodyStyle',
                'styles.body'
            ],
            [
                'maskStyle',
                'styles.mask'
            ]
        ].forEach((_ref)=>{
            let [deprecatedName, newName] = _ref;
            warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
        });
    }
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, focusTriggerAfterClose: focusTriggerAfterClose = true, style: style, visible: // Deprecated
    visible, width: width = 520, footer: footer, classNames: modalClassNames, styles: modalStyles, children: children, loading: loading } = props, restProps = $92628feafcd06c86$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "focusTriggerAfterClose",
        "style",
        "visible",
        "width",
        "footer",
        "classNames",
        "styles",
        "children",
        "loading"
    ]);
    const prefixCls = getPrefixCls('modal', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $d5deaaf64bfa7773$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(wrapClassName, {
        [`${prefixCls}-centered`]: !!centered,
        [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $jMaZ8.createElement((0, $6b398ee3f08e606d$export$a06f1c675e846f6f), Object.assign({}, props, {
        onOk: handleOk,
        onCancel: handleCancel
    })) : null;
    const [mergedClosable, mergedCloseIcon, closeBtnIsDisabled] = (0, $547f96b25a48e540$export$2e2bcd8739ae039)((0, $547f96b25a48e540$export$51ad9c30389f050b)(props), (0, $547f96b25a48e540$export$51ad9c30389f050b)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $jMaZ8.createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $6b398ee3f08e606d$export$97c34646962d356e)(prefixCls, icon)
    });
    // ============================ Refs ============================
    // Select `ant-modal-content` by `panelRef`
    const panelRef = (0, $75e1b8460fa96589$export$94ab53417567be34)(`.${prefixCls}-content`);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $5f1c4f12ab1f6aec$export$3e7906d4075187a4)('Modal', restProps.zIndex);
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = $jMaZ8.useMemo(()=>{
        if (width && typeof width === 'object') return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = $jMaZ8.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if (breakpointWidth !== undefined) vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $215be6e5138b7346$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $236c8316fc410342$export$2e2bcd8739ae039), Object.assign({
        width: numWidth
    }, restProps, {
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, rootClassName, cssVarCls, rootCls),
        footer: dialogFooter,
        visible: open !== null && open !== void 0 ? open : visible,
        mousePosition: (_a = restProps.mousePosition) !== null && _a !== void 0 ? _a : $92628feafcd06c86$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable ? {
            disabled: closeBtnIsDisabled,
            closeIcon: mergedCloseIcon
        } : mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, className, modalContext === null || modalContext === void 0 ? void 0 : modalContext.className),
        style: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.style), style), responsiveWidthVars),
        classNames: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.classNames), modalClassNames), {
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(wrapClassNameExtended, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper)
        }),
        styles: Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.styles), modalStyles),
        panelRef: panelRef
    }), loading ? /*#__PURE__*/ $jMaZ8.createElement((0, $069691000a77b0e1$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : children))));
};
var $92628feafcd06c86$export$2e2bcd8739ae039 = $92628feafcd06c86$var$Modal;


// Style as confirm component
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");



// ============================= Confirm ==============================
const $fd5126d93763a0dd$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            '&-rtl': {
                direction: 'rtl'
            },
            [`${token.antCls}-modal-header`]: {
                display: 'none'
            },
            [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()),
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${token.iconCls}`]: {
                    flex: 'none',
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: 'flex',
                flexDirection: 'column',
                flex: 'auto',
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, $4g3I0.unit)(token.marginSM)})`
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $4g3I0.unit)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-content`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: 'end',
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$fd5126d93763a0dd$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$1537386bc155ea56)([
    'Modal',
    'confirm'
], (token)=>{
    const modalToken = (0, $d5deaaf64bfa7773$export$362fb92a8f81bbf9)(token);
    return [
        $fd5126d93763a0dd$var$genModalConfirmStyle(modalToken)
    ];
}, (0, $d5deaaf64bfa7773$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
var $9e73d04fba566d4a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $9e73d04fba566d4a$export$78cf841dc2c9f0b5(props) {
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale } = props, resetProps = $9e73d04fba566d4a$var$__rest(props, [
        "prefixCls",
        "icon",
        "okText",
        "cancelText",
        "confirmPrefixCls",
        "type",
        "okCancel",
        "footer",
        "locale"
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Modal');
        warning(!(typeof icon === 'string' && icon.length > 2), 'breaking', `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`);
    }
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case 'info':
            mergedIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $510ddd97f52e903f$export$2e2bcd8739ae039), null);
            break;
        case 'success':
            mergedIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039), null);
            break;
        case 'error':
            mergedIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $93361570ffc8bbe1$export$2e2bcd8739ae039), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $5244cb05538dbe0c$export$2e2bcd8739ae039), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === 'confirm';
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    const [locale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Modal');
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
    const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = Object.assign({
        autoFocusButton: autoFocusButton,
        cancelTextLocale: cancelTextLocale,
        okTextLocale: okTextLocale,
        mergedOkCancel: mergedOkCancel
    }, resetProps);
    const btnCtxValueMemo = $jMaZ8.useMemo(()=>btnCtxValue, (0, $fvBso.default)(Object.values(btnCtxValue)));
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement((0, $25af039ced615a5d$export$2e2bcd8739ae039), null), /*#__PURE__*/ $jMaZ8.createElement((0, $8bc7656953ad918a$export$2e2bcd8739ae039), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === 'function' ? /*#__PURE__*/ $jMaZ8.createElement((0, $09e3858c077c8130$export$7c9538f5f3c365e9), {
        value: btnCtxValueMemo
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === 'function' ? footer(footerOriginNode, {
        OkBtn: $8bc7656953ad918a$export$2e2bcd8739ae039,
        CancelBtn: $25af039ced615a5d$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $jMaZ8.createElement((0, $fd5126d93763a0dd$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
}
const $9e73d04fba566d4a$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, onConfirm: onConfirm, styles: styles } = props;
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Modal');
        [
            [
                'visible',
                'open'
            ],
            [
                'bodyStyle',
                'styles.body'
            ],
            [
                'maskStyle',
                'styles.mask'
            ]
        ].forEach((_ref)=>{
            let [deprecatedName, newName] = _ref;
            warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
        });
    }
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    const mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const mergedZIndex = $jMaZ8.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $5f1c4f12ab1f6aec$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $92628feafcd06c86$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close === null || close === void 0 || close({
                triggerCancel: true
            });
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        title: "",
        footer: null,
        transitionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(rootPrefixCls || '', 'zoom', props.transitionName),
        maskTransitionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(rootPrefixCls || '', 'fade', props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        style: style,
        styles: Object.assign({
            body: bodyStyle,
            mask: maskStyle
        }, styles),
        width: width,
        zIndex: mergedZIndex,
        closable: closable
    }), /*#__PURE__*/ $jMaZ8.createElement($9e73d04fba566d4a$export$78cf841dc2c9f0b5, Object.assign({}, props, {
        confirmPrefixCls: confirmPrefixCls
    })));
};
const $9e73d04fba566d4a$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $cf928c204584b9b8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $jMaZ8.createElement($9e73d04fba566d4a$var$ConfirmDialog, Object.assign({}, props)));
};
$9e73d04fba566d4a$var$ConfirmDialog.displayName = 'ConfirmDialog';
$9e73d04fba566d4a$var$ConfirmDialogWrapper.displayName = 'ConfirmDialogWrapper';
var $9e73d04fba566d4a$export$2e2bcd8739ae039 = $9e73d04fba566d4a$var$ConfirmDialogWrapper;


const $28251aa9e67c99b7$var$destroyFns = [];
var $28251aa9e67c99b7$export$2e2bcd8739ae039 = $28251aa9e67c99b7$var$destroyFns;



"use client";
let $423e368e6737112e$var$defaultRootPrefixCls = '';
function $423e368e6737112e$var$getRootPrefixCls() {
    return $423e368e6737112e$var$defaultRootPrefixCls;
}
const $423e368e6737112e$var$ConfirmDialogWrapper = (props)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $699cf533d6ec795e$export$1b6004afda18cd51)();
    const config = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const rootPrefixCls = $423e368e6737112e$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) {
        mergedGetContainer = undefined;
        (0, $e55cfce129297019$export$2e2bcd8739ae039)(false, 'Modal', 'Static method not support `getContainer` to be `false` since it do not have context env.');
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $9e73d04fba566d4a$export$2e2bcd8739ae039), Object.assign({}, props, {
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction !== null && direction !== void 0 ? direction : config.direction,
        locale: (_b = (_a = config.locale) === null || _a === void 0 ? void 0 : _a.Modal) !== null && _b !== void 0 ? _b : runtimeLocale,
        getContainer: mergedGetContainer
    }));
};
function $423e368e6737112e$export$2e2bcd8739ae039(config) {
    const global = (0, $cf928c204584b9b8$export$f9cd1e43211d8a4a)();
    if (!global.holderRender) (0, $cf928c204584b9b8$export$7c4f6da0f9434a77)('Modal');
    const container = document.createDocumentFragment();
    let currentConfig = Object.assign(Object.assign({}, config), {
        close: close,
        open: true
    });
    let timeoutId;
    let reactUnmount;
    function destroy() {
        var _a;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = config.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                config,
                ()=>{}
            ].concat((0, $fvBso.default)(args.slice(1))));
        }
        for(let i = 0; i < (0, $28251aa9e67c99b7$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $28251aa9e67c99b7$export$2e2bcd8739ae039)[i];
            if (fn === close) {
                (0, $28251aa9e67c99b7$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        reactUnmount();
    }
    function render(props) {
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $423e368e6737112e$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement($423e368e6737112e$var$ConfirmDialogWrapper, Object.assign({}, props));
            const reactRender = (0, $49fd731f963d0354$export$1c4a73059151cd3e)();
            reactUnmount = reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $cf928c204584b9b8$export$2e2bcd8739ae039), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, global.holderRender ? global.holderRender(dom) : dom), container);
        });
    }
    function close() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        currentConfig = Object.assign(Object.assign({}, currentConfig), {
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === 'function') config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
        render(currentConfig);
    }
    render(currentConfig);
    (0, $28251aa9e67c99b7$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $423e368e6737112e$export$503fa8fed137d104(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'warning'
    });
}
function $423e368e6737112e$export$2f728eab0dacbb2e(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'info'
    });
}
function $423e368e6737112e$export$2b5f8d7f29c805d4(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'success'
    });
}
function $423e368e6737112e$export$60e9e0884ce12b55(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'error'
    });
}
function $423e368e6737112e$export$665b64399d4af99c(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'confirm'
    });
}
function $423e368e6737112e$export$ff0b30c638ae2396(_ref) {
    let { rootPrefixCls: rootPrefixCls } = _ref;
    (0, $e55cfce129297019$export$2e2bcd8739ae039)(false, 'Modal', 'Modal.config is deprecated. Please use ConfigProvider.config instead.');
    $423e368e6737112e$var$defaultRootPrefixCls = rootPrefixCls;
}





var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $jMaZ8 = parcelRequire("jMaZ8");

var $eGh7a = parcelRequire("eGh7a");

"use client";
function $122b6ffb60331d40$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $jMaZ8.createElement((0, $cf928c204584b9b8$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $jMaZ8.createElement(Component, Object.assign({}, props)));
}
/* istanbul ignore next */ const $122b6ffb60331d40$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $jMaZ8.useRef(null);
        const [popupHeight, setPopupHeight] = $jMaZ8.useState(0);
        const [popupWidth, setPopupWidth] = $jMaZ8.useState(0);
        const [open, setOpen] = (0, $eGh7a.default)(false, {
            value: props.open
        });
        const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $jMaZ8.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    var _a;
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, []);
        let mergedProps = Object.assign(Object.assign({}, props), {
            style: Object.assign(Object.assign({}, style), {
                margin: 0
            }),
            open: open,
            visible: open,
            getPopupContainer: ()=>holderRef.current
        });
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) Object.assign(mergedProps, {
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        });
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $jMaZ8.createElement(Component, Object.assign({}, mergedProps)));
    };
    return $122b6ffb60331d40$export$29e2a8c3cdb34b03(PurePanel);
};
var $122b6ffb60331d40$export$2e2bcd8739ae039 = $122b6ffb60331d40$var$genPurePanel;







"use client";
var $a056c603889143e7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a056c603889143e7$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer } = props, restProps = $a056c603889143e7$var$__rest(props, [
        "prefixCls",
        "className",
        "closeIcon",
        "closable",
        "type",
        "title",
        "children",
        "footer"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls('modal');
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(rootPrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $d5deaaf64bfa7773$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : false,
        title: '',
        footer: '',
        children: /*#__PURE__*/ $jMaZ8.createElement((0, $9e73d04fba566d4a$export$78cf841dc2c9f0b5), Object.assign({}, props, {
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        }))
    };
    else additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $jMaZ8.createElement((0, $6b398ee3f08e606d$export$a06f1c675e846f6f), Object.assign({}, props)),
        children: children
    };
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $eec8580e845ab066$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls)
    }, restProps, {
        closeIcon: (0, $6b398ee3f08e606d$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable
    }, additionalProps)));
};
var $a056c603889143e7$export$2e2bcd8739ae039 = (0, $122b6ffb60331d40$export$29e2a8c3cdb34b03)($a056c603889143e7$var$PurePanel);



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");
function $a51fc78916ed727d$export$2e2bcd8739ae039() {
    const [elements, setElements] = $jMaZ8.useState([]);
    const patchElement = $jMaZ8.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $fvBso.default)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
}





var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");




"use client";
var $a09ed0769ccc7754$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a09ed0769ccc7754$var$HookModal = (_a, ref)=>{
    var _b;
    var { afterClose: hookAfterClose, config: config } = _a, restProps = $a09ed0769ccc7754$var$__rest(_a, [
        "afterClose",
        "config"
    ]);
    const [open, setOpen] = $jMaZ8.useState(true);
    const [innerConfig, setInnerConfig] = $jMaZ8.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('modal');
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        var _a;
        hookAfterClose();
        (_a = innerConfig.afterClose) === null || _a === void 0 || _a.call(innerConfig);
    };
    const close = function() {
        var _a;
        setOpen(false);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = innerConfig.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                innerConfig,
                ()=>{}
            ].concat((0, $fvBso.default)(args.slice(1))));
        }
    };
    $jMaZ8.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>Object.assign(Object.assign({}, originConfig), newConfig));
            }
        }));
    const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === 'confirm';
    const [contextLocale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Modal', (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).Modal);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $9e73d04fba566d4a$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls
    }, innerConfig, {
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
    }, restProps));
};
var $a09ed0769ccc7754$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.forwardRef($a09ed0769ccc7754$var$HookModal);


"use client";
let $26cd84a4414406be$var$uuid = 0;
const $26cd84a4414406be$var$ElementsHolder = /*#__PURE__*/ $jMaZ8.memo(/*#__PURE__*/ $jMaZ8.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $a51fc78916ed727d$export$2e2bcd8739ae039)();
    $jMaZ8.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), []);
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, elements);
}));
function $26cd84a4414406be$var$useModal() {
    const holderRef = $jMaZ8.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $jMaZ8.useState([]);
    $jMaZ8.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $fvBso.default)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $jMaZ8.useCallback((withFunc)=>function hookConfirm(config) {
            var _a;
            $26cd84a4414406be$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $jMaZ8.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $jMaZ8.createElement((0, $a09ed0769ccc7754$export$2e2bcd8739ae039), {
                key: `modal-${$26cd84a4414406be$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            if (closeFunc) (0, $28251aa9e67c99b7$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $fvBso.default)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $fvBso.default)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $jMaZ8.useMemo(()=>({
            info: getConfirmFunc((0, $423e368e6737112e$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $423e368e6737112e$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $423e368e6737112e$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $423e368e6737112e$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $423e368e6737112e$export$665b64399d4af99c))
        }), []);
    return [
        fns,
        /*#__PURE__*/ $jMaZ8.createElement($26cd84a4414406be$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $26cd84a4414406be$export$2e2bcd8739ae039 = $26cd84a4414406be$var$useModal;


"use client";
function $f57978dfa9715a4c$var$modalWarn(props) {
    return (0, $423e368e6737112e$export$2e2bcd8739ae039)((0, $423e368e6737112e$export$503fa8fed137d104)(props));
}
const $f57978dfa9715a4c$var$Modal = (0, $92628feafcd06c86$export$2e2bcd8739ae039);
$f57978dfa9715a4c$var$Modal.useModal = (0, $26cd84a4414406be$export$2e2bcd8739ae039);
$f57978dfa9715a4c$var$Modal.info = function infoFn(props) {
    return (0, $423e368e6737112e$export$2e2bcd8739ae039)((0, $423e368e6737112e$export$2f728eab0dacbb2e)(props));
};
$f57978dfa9715a4c$var$Modal.success = function successFn(props) {
    return (0, $423e368e6737112e$export$2e2bcd8739ae039)((0, $423e368e6737112e$export$2b5f8d7f29c805d4)(props));
};
$f57978dfa9715a4c$var$Modal.error = function errorFn(props) {
    return (0, $423e368e6737112e$export$2e2bcd8739ae039)((0, $423e368e6737112e$export$60e9e0884ce12b55)(props));
};
$f57978dfa9715a4c$var$Modal.warning = $f57978dfa9715a4c$var$modalWarn;
$f57978dfa9715a4c$var$Modal.warn = $f57978dfa9715a4c$var$modalWarn;
$f57978dfa9715a4c$var$Modal.confirm = function confirmFn(props) {
    return (0, $423e368e6737112e$export$2e2bcd8739ae039)((0, $423e368e6737112e$export$665b64399d4af99c)(props));
};
$f57978dfa9715a4c$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $28251aa9e67c99b7$export$2e2bcd8739ae039).length){
        const close = (0, $28251aa9e67c99b7$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$f57978dfa9715a4c$var$Modal.config = (0, $423e368e6737112e$export$ff0b30c638ae2396);
$f57978dfa9715a4c$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $a056c603889143e7$export$2e2bcd8739ae039);
$f57978dfa9715a4c$var$Modal.displayName = 'Modal';
var $f57978dfa9715a4c$export$2e2bcd8739ae039 = $f57978dfa9715a4c$var$Modal;


var $jMaZ8 = parcelRequire("jMaZ8");


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $51bf5e3bc9af079d$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $51bf5e3bc9af079d$export$2e2bcd8739ae039 = $51bf5e3bc9af079d$var$CheckOutlined;



var $c1c1d6d80357382d$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $51bf5e3bc9af079d$export$2e2bcd8739ae039)
    }));
};
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ var $c1c1d6d80357382d$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($c1c1d6d80357382d$var$CheckOutlined);
$c1c1d6d80357382d$var$RefIcon.displayName = 'CheckOutlined';
var $c1c1d6d80357382d$export$2e2bcd8739ae039 = $c1c1d6d80357382d$var$RefIcon;




parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $469ed3e0b2ed72ca$export$9c21a3269931e1e6 = {
    percent: 0,
    prefixCls: 'rc-progress',
    strokeColor: '#2db7f5',
    strokeLinecap: 'round',
    strokeWidth: 1,
    trailColor: '#D9D9D9',
    trailWidth: 1,
    gapPosition: 'bottom'
};
var $469ed3e0b2ed72ca$export$7685006d504ecf0b = function useTransitionDuration() {
    var pathsRef = (0, $jMaZ8.useRef)([]);
    var prevTimeStamp = (0, $jMaZ8.useRef)(null);
    (0, $jMaZ8.useEffect)(function() {
        var now = Date.now();
        var updated = false;
        pathsRef.current.forEach(function(path) {
            if (!path) return;
            updated = true;
            var pathStyle = path.style;
            pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
            if (prevTimeStamp.current && now - prevTimeStamp.current < 100) pathStyle.transitionDuration = '0s, 0s';
        });
        if (updated) prevTimeStamp.current = Date.now();
    });
    return pathsRef.current;
};


var $2574a87a4992b3fc$var$_excluded = [
    "className",
    "percent",
    "prefixCls",
    "strokeColor",
    "strokeLinecap",
    "strokeWidth",
    "style",
    "trailColor",
    "trailWidth",
    "transition"
];
var $2574a87a4992b3fc$var$Line = function Line(props) {
    var _defaultProps$props = (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $469ed3e0b2ed72ca$export$9c21a3269931e1e6)), props), className = _defaultProps$props.className, percent = _defaultProps$props.percent, prefixCls = _defaultProps$props.prefixCls, strokeColor = _defaultProps$props.strokeColor, strokeLinecap = _defaultProps$props.strokeLinecap, strokeWidth = _defaultProps$props.strokeWidth, style = _defaultProps$props.style, trailColor = _defaultProps$props.trailColor, trailWidth = _defaultProps$props.trailWidth, transition = _defaultProps$props.transition, restProps = (0, $4b02Q.default)(_defaultProps$props, $2574a87a4992b3fc$var$_excluded);
    // eslint-disable-next-line no-param-reassign
    delete restProps.gapPosition;
    var percentList = Array.isArray(percent) ? percent : [
        percent
    ];
    var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [
        strokeColor
    ];
    var paths = (0, $469ed3e0b2ed72ca$export$7685006d504ecf0b)();
    var center = strokeWidth / 2;
    var right = 100 - strokeWidth / 2;
    var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n         L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
    var viewBoxString = "0 0 100 ".concat(strokeWidth);
    var stackPtg = 0;
    return /*#__PURE__*/ $jMaZ8.createElement("svg", (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-line"), className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
    }, restProps), /*#__PURE__*/ $jMaZ8.createElement("path", {
        className: "".concat(prefixCls, "-line-trail"),
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0"
    }), percentList.map(function(ptg, index) {
        var dashPercent = 1;
        switch(strokeLinecap){
            case 'round':
                dashPercent = 1 - strokeWidth / 100;
                break;
            case 'square':
                dashPercent = 1 - strokeWidth / 2 / 100;
                break;
            default:
                dashPercent = 1;
                break;
        }
        var pathStyle = {
            strokeDasharray: "".concat(ptg * dashPercent, "px, 100px"),
            strokeDashoffset: "-".concat(stackPtg, "px"),
            transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
        };
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return /*#__PURE__*/ $jMaZ8.createElement("path", {
            key: index,
            className: "".concat(prefixCls, "-line-path"),
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: color,
            strokeWidth: strokeWidth,
            fillOpacity: "0",
            ref: function ref(elem) {
                // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                // React will call the ref callback with the DOM element when the component mounts,
                // and call it with `null` when it unmounts.
                // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                paths[index] = elem;
            },
            style: pathStyle
        });
    }));
};
$2574a87a4992b3fc$var$Line.displayName = 'Line';
var $2574a87a4992b3fc$export$2e2bcd8739ae039 = $2574a87a4992b3fc$var$Line;



var $hH60s = parcelRequire("hH60s");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("h9ujZ");
var $83826a58fdf1bc0a$var$uuid = 0;
var $83826a58fdf1bc0a$export$df7146797a248522 = false;
/** Get unique id for accessibility usage */ function $83826a58fdf1bc0a$var$getUUID() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($83826a58fdf1bc0a$export$df7146797a248522) {
        retId = $83826a58fdf1bc0a$var$uuid;
        $83826a58fdf1bc0a$var$uuid += 1;
    } else retId = 'TEST_OR_SSR';
    return retId;
}
var $83826a58fdf1bc0a$export$2e2bcd8739ae039 = function(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $jMaZ8.useState(), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $jMaZ8.useEffect(function() {
        setInnerId("rc_progress_".concat($83826a58fdf1bc0a$var$getUUID()));
    }, []);
    return id || innerId;
};



var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");
var $9503e4b46df7bc39$var$Block = function Block(_ref) {
    var bg = _ref.bg, children = _ref.children;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: {
            width: '100%',
            height: '100%',
            background: bg
        }
    }, children);
};
function $9503e4b46df7bc39$var$getPtgColors(color, scale) {
    return Object.keys(color).map(function(key) {
        var parsedKey = parseFloat(key);
        var ptgKey = "".concat(Math.floor(parsedKey * scale), "%");
        return "".concat(color[key], " ").concat(ptgKey);
    });
}
var $9503e4b46df7bc39$var$PtgCircle = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, color = props.color, gradientId = props.gradientId, radius = props.radius, circleStyleForStack = props.style, ptg = props.ptg, strokeLinecap = props.strokeLinecap, strokeWidth = props.strokeWidth, size = props.size, gapDegree = props.gapDegree;
    var isGradient = color && (0, $1Esi2.default)(color) === 'object';
    var stroke = isGradient ? "#FFF" : undefined;
    // ========================== Circle ==========================
    var halfSize = size / 2;
    var circleNode = /*#__PURE__*/ $jMaZ8.createElement("circle", {
        className: "".concat(prefixCls, "-circle-path"),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: stroke,
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth,
        opacity: ptg === 0 ? 0 : 1,
        style: circleStyleForStack,
        ref: ref
    });
    // ========================== Render ==========================
    if (!isGradient) return circleNode;
    var maskId = "".concat(gradientId, "-conic");
    var fromDeg = gapDegree ? "".concat(180 + gapDegree / 2, "deg") : '0deg';
    var conicColors = $9503e4b46df7bc39$var$getPtgColors(color, (360 - gapDegree) / 360);
    var linearColors = $9503e4b46df7bc39$var$getPtgColors(color, 1);
    var conicColorBg = "conic-gradient(from ".concat(fromDeg, ", ").concat(conicColors.join(', '), ")");
    var linearColorBg = "linear-gradient(to ".concat(gapDegree ? 'bottom' : 'top', ", ").concat(linearColors.join(', '), ")");
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement("mask", {
        id: maskId
    }, circleNode), /*#__PURE__*/ $jMaZ8.createElement("foreignObject", {
        x: 0,
        y: 0,
        width: size,
        height: size,
        mask: "url(#".concat(maskId, ")")
    }, /*#__PURE__*/ $jMaZ8.createElement($9503e4b46df7bc39$var$Block, {
        bg: linearColorBg
    }, /*#__PURE__*/ $jMaZ8.createElement($9503e4b46df7bc39$var$Block, {
        bg: conicColorBg
    }))));
});
$9503e4b46df7bc39$var$PtgCircle.displayName = 'PtgCircle';
var $9503e4b46df7bc39$export$2e2bcd8739ae039 = $9503e4b46df7bc39$var$PtgCircle;


var $236cbaeb935af12e$export$b8239b3abadfb141 = 100;
var $236cbaeb935af12e$export$b0aaf64d8cc0f6db = function getCircleStyle(perimeter, perimeterWithoutGap, offset, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth) {
    var stepSpace = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;
    var offsetDeg = offset / 100 * 360 * ((360 - gapDegree) / 360);
    var positionDeg = gapDegree === 0 ? 0 : ({
        bottom: 0,
        top: 180,
        left: 90,
        right: -90
    })[gapPosition];
    var strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
    // Fix percent accuracy when strokeLinecap is round
    // https://github.com/ant-design/ant-design/issues/35009
    if (strokeLinecap === 'round' && percent !== 100) {
        strokeDashoffset += strokeWidth / 2;
        // when percent is small enough (<= 1%), keep smallest value to avoid it's disappearance
        if (strokeDashoffset >= perimeterWithoutGap) strokeDashoffset = perimeterWithoutGap - 0.01;
    }
    var halfSize = $236cbaeb935af12e$export$b8239b3abadfb141 / 2;
    return {
        stroke: typeof strokeColor === 'string' ? strokeColor : undefined,
        strokeDasharray: "".concat(perimeterWithoutGap, "px ").concat(perimeter),
        strokeDashoffset: strokeDashoffset + stepSpace,
        transform: "rotate(".concat(rotateDeg + offsetDeg + positionDeg, "deg)"),
        transformOrigin: "".concat(halfSize, "px ").concat(halfSize, "px"),
        transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s',
        fillOpacity: 0
    };
};


var $99f82cd96997ecae$var$_excluded = [
    "id",
    "prefixCls",
    "steps",
    "strokeWidth",
    "trailWidth",
    "gapDegree",
    "gapPosition",
    "trailColor",
    "strokeLinecap",
    "style",
    "className",
    "strokeColor",
    "percent"
];
function $99f82cd96997ecae$var$toArray(value) {
    var mergedValue = value !== null && value !== void 0 ? value : [];
    return Array.isArray(mergedValue) ? mergedValue : [
        mergedValue
    ];
}
var $99f82cd96997ecae$var$Circle = function Circle(props) {
    var _defaultProps$props = (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $469ed3e0b2ed72ca$export$9c21a3269931e1e6)), props), id = _defaultProps$props.id, prefixCls = _defaultProps$props.prefixCls, steps = _defaultProps$props.steps, strokeWidth = _defaultProps$props.strokeWidth, trailWidth = _defaultProps$props.trailWidth, _defaultProps$props$g = _defaultProps$props.gapDegree, gapDegree = _defaultProps$props$g === void 0 ? 0 : _defaultProps$props$g, gapPosition = _defaultProps$props.gapPosition, trailColor = _defaultProps$props.trailColor, strokeLinecap = _defaultProps$props.strokeLinecap, style = _defaultProps$props.style, className = _defaultProps$props.className, strokeColor = _defaultProps$props.strokeColor, percent = _defaultProps$props.percent, restProps = (0, $4b02Q.default)(_defaultProps$props, $99f82cd96997ecae$var$_excluded);
    var halfSize = (0, $236cbaeb935af12e$export$b8239b3abadfb141) / 2;
    var mergedId = (0, $83826a58fdf1bc0a$export$2e2bcd8739ae039)(id);
    var gradientId = "".concat(mergedId, "-gradient");
    var radius = halfSize - strokeWidth / 2;
    var perimeter = Math.PI * 2 * radius;
    var rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
    var perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
    var _ref = (0, $1Esi2.default)(steps) === 'object' ? steps : {
        count: steps,
        gap: 2
    }, stepCount = _ref.count, stepGap = _ref.gap;
    var percentList = $99f82cd96997ecae$var$toArray(percent);
    var strokeColorList = $99f82cd96997ecae$var$toArray(strokeColor);
    var gradient = strokeColorList.find(function(color) {
        return color && (0, $1Esi2.default)(color) === 'object';
    });
    var isConicGradient = gradient && (0, $1Esi2.default)(gradient) === 'object';
    var mergedStrokeLinecap = isConicGradient ? 'butt' : strokeLinecap;
    var circleStyle = (0, $236cbaeb935af12e$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, trailColor, mergedStrokeLinecap, strokeWidth);
    var paths = (0, $469ed3e0b2ed72ca$export$7685006d504ecf0b)();
    var getStokeList = function getStokeList() {
        var stackPtg = 0;
        return percentList.map(function(ptg, index) {
            var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
            var circleStyleForStack = (0, $236cbaeb935af12e$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, mergedStrokeLinecap, strokeWidth);
            stackPtg += ptg;
            return /*#__PURE__*/ $jMaZ8.createElement((0, $9503e4b46df7bc39$export$2e2bcd8739ae039), {
                key: index,
                color: color,
                ptg: ptg,
                radius: radius,
                prefixCls: prefixCls,
                gradientId: gradientId,
                style: circleStyleForStack,
                strokeLinecap: mergedStrokeLinecap,
                strokeWidth: strokeWidth,
                gapDegree: gapDegree,
                ref: function ref(elem) {
                    // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                    // React will call the ref callback with the DOM element when the component mounts,
                    // and call it with `null` when it unmounts.
                    // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                    paths[index] = elem;
                },
                size: (0, $236cbaeb935af12e$export$b8239b3abadfb141)
            });
        }).reverse();
    };
    var getStepStokeList = function getStepStokeList() {
        // only show the first percent when pass steps
        var current = Math.round(stepCount * (percentList[0] / 100));
        var stepPtg = 100 / stepCount;
        var stackPtg = 0;
        return new Array(stepCount).fill(null).map(function(_, index) {
            var color = index <= current - 1 ? strokeColorList[0] : trailColor;
            var stroke = color && (0, $1Esi2.default)(color) === 'object' ? "url(#".concat(gradientId, ")") : undefined;
            var circleStyleForStack = (0, $236cbaeb935af12e$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, 'butt', strokeWidth, stepGap);
            stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepGap) * 100 / perimeterWithoutGap;
            return /*#__PURE__*/ $jMaZ8.createElement("circle", {
                key: index,
                className: "".concat(prefixCls, "-circle-path"),
                r: radius,
                cx: halfSize,
                cy: halfSize,
                stroke: stroke,
                strokeWidth: strokeWidth,
                opacity: 1,
                style: circleStyleForStack,
                ref: function ref(elem) {
                    paths[index] = elem;
                }
            });
        });
    };
    return /*#__PURE__*/ $jMaZ8.createElement("svg", (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-circle"), className),
        viewBox: "0 0 ".concat((0, $236cbaeb935af12e$export$b8239b3abadfb141), " ").concat((0, $236cbaeb935af12e$export$b8239b3abadfb141)),
        style: style,
        id: id,
        role: "presentation"
    }, restProps), !stepCount && /*#__PURE__*/ $jMaZ8.createElement("circle", {
        className: "".concat(prefixCls, "-circle-trail"),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: trailColor,
        strokeLinecap: mergedStrokeLinecap,
        strokeWidth: trailWidth || strokeWidth,
        style: circleStyle
    }), stepCount ? getStepStokeList() : getStokeList());
};
$99f82cd96997ecae$var$Circle.displayName = 'Circle';
var $99f82cd96997ecae$export$2e2bcd8739ae039 = $99f82cd96997ecae$var$Circle;


var $b3e803cc80f8df84$export$2e2bcd8739ae039 = {
    Line: (0, $2574a87a4992b3fc$export$2e2bcd8739ae039),
    Circle: (0, $99f82cd96997ecae$export$2e2bcd8739ae039)
};



parcelRequire("1T8KD");
var $lvl2c = parcelRequire("lvl2c");
function $a232916295496e6a$export$2caef35201f951a0(progress) {
    if (!progress || progress < 0) return 0;
    if (progress > 100) return 100;
    return progress;
}
function $a232916295496e6a$export$4ab1c09ce4ee99b(_ref) {
    let { success: success, successPercent: successPercent } = _ref;
    let percent = successPercent;
    /** @deprecated Use `percent` instead */ if (success && 'progress' in success) percent = success.progress;
    if (success && 'percent' in success) percent = success.percent;
    return percent;
}
const $a232916295496e6a$export$6712e0f6cd0ea03 = (_ref2)=>{
    let { percent: percent, success: success, successPercent: successPercent } = _ref2;
    const realSuccessPercent = $a232916295496e6a$export$2caef35201f951a0($a232916295496e6a$export$4ab1c09ce4ee99b({
        success: success,
        successPercent: successPercent
    }));
    return [
        realSuccessPercent,
        $a232916295496e6a$export$2caef35201f951a0($a232916295496e6a$export$2caef35201f951a0(percent) - realSuccessPercent)
    ];
};
const $a232916295496e6a$export$a73db48ef11a2bc3 = (_ref3)=>{
    let { success: success = {}, strokeColor: strokeColor } = _ref3;
    const { strokeColor: successColor } = success;
    return [
        successColor || (0, $lvl2c.presetPrimaryColors).green,
        strokeColor || null
    ];
};
const $a232916295496e6a$export$31b21d0167753bb4 = (size, type, extra)=>{
    var _a, _b, _c, _d;
    let width = -1;
    let height = -1;
    if (type === 'step') {
        const steps = extra.steps;
        const strokeWidth = extra.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') {
            width = size === 'small' ? 2 : 14;
            height = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 8;
        } else if (typeof size === 'number') [width, height] = [
            size,
            size
        ];
        else [width = 14, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
        width *= steps;
    } else if (type === 'line') {
        const strokeWidth = extra === null || extra === void 0 ? void 0 : extra.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') height = strokeWidth || (size === 'small' ? 6 : 8);
        else if (typeof size === 'number') [width, height] = [
            size,
            size
        ];
        else [width = -1, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
    } else if (type === 'circle' || type === 'dashboard') {
        if (typeof size === 'string' || typeof size === 'undefined') [width, height] = size === 'small' ? [
            60,
            60
        ] : [
            120,
            120
        ];
        else if (typeof size === 'number') [width, height] = [
            size,
            size
        ];
        else if (Array.isArray(size)) {
            width = (_b = (_a = size[0]) !== null && _a !== void 0 ? _a : size[1]) !== null && _b !== void 0 ? _b : 120;
            height = (_d = (_c = size[0]) !== null && _c !== void 0 ? _c : size[1]) !== null && _d !== void 0 ? _d : 120;
        }
    }
    return [
        width,
        height
    ];
};


"use client";
const $8d5bb48293c87494$var$CIRCLE_MIN_STROKE_WIDTH = 3;
const $8d5bb48293c87494$var$getMinPercent = (width)=>$8d5bb48293c87494$var$CIRCLE_MIN_STROKE_WIDTH / width * 100;
const $8d5bb48293c87494$var$Circle = (props)=>{
    const { prefixCls: prefixCls, trailColor: trailColor = null, strokeLinecap: strokeLinecap = 'round', gapPosition: gapPosition, gapDegree: gapDegree, width: originWidth = 120, type: type, children: children, success: success, size: size = originWidth, steps: steps } = props;
    const [width, height] = (0, $a232916295496e6a$export$31b21d0167753bb4)(size, 'circle');
    let { strokeWidth: strokeWidth } = props;
    if (strokeWidth === undefined) strokeWidth = Math.max($8d5bb48293c87494$var$getMinPercent(width), 6);
    const circleStyle = {
        width: width,
        height: height,
        fontSize: width * 0.15 + 6
    };
    const realGapDegree = $jMaZ8.useMemo(()=>{
        // Support gapDeg = 0 when type = 'dashboard'
        if (gapDegree || gapDegree === 0) return gapDegree;
        if (type === 'dashboard') return 75;
        return undefined;
    }, [
        gapDegree,
        type
    ]);
    const percentArray = (0, $a232916295496e6a$export$6712e0f6cd0ea03)(props);
    const gapPos = gapPosition || type === 'dashboard' && 'bottom' || undefined;
    // using className to style stroke color
    const isGradient = Object.prototype.toString.call(props.strokeColor) === '[object Object]';
    const strokeColor = (0, $a232916295496e6a$export$a73db48ef11a2bc3)({
        success: success,
        strokeColor: props.strokeColor
    });
    const wrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-inner`, {
        [`${prefixCls}-circle-gradient`]: isGradient
    });
    const circleContent = /*#__PURE__*/ $jMaZ8.createElement((0, $99f82cd96997ecae$export$2e2bcd8739ae039), {
        steps: steps,
        percent: steps ? percentArray[1] : percentArray,
        strokeWidth: strokeWidth,
        trailWidth: strokeWidth,
        strokeColor: steps ? strokeColor[1] : strokeColor,
        strokeLinecap: strokeLinecap,
        trailColor: trailColor,
        prefixCls: prefixCls,
        gapDegree: realGapDegree,
        gapPosition: gapPos
    });
    const smallCircle = width <= 20;
    const node = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: wrapperClassName,
        style: circleStyle
    }, circleContent, !smallCircle && children);
    if (smallCircle) return /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
        title: children
    }, node);
    return node;
};
var $8d5bb48293c87494$export$2e2bcd8739ae039 = $8d5bb48293c87494$var$Circle;



var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("1T8KD");
var $lvl2c = parcelRequire("lvl2c");

var $giSak = parcelRequire("giSak");

parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $127b9bb49070dd08$export$ce7447cfda329128 = '--progress-line-stroke-color';
const $127b9bb49070dd08$export$cbc348af47898b5e = '--progress-percent';
const $127b9bb49070dd08$var$genAntProgressActive = (isRtl)=>{
    const direction = isRtl ? '100%' : '-100%';
    return new (0, $kB90R.default)(`antProgress${isRtl ? 'RTL' : 'LTR'}Active`, {
        '0%': {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.1
        },
        '20%': {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.5
        },
        to: {
            transform: 'translateX(0) scaleX(1)',
            opacity: 0
        }
    });
};
const $127b9bb49070dd08$var$genBaseStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            display: 'inline-block',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-line': {
                position: 'relative',
                width: '100%',
                fontSize: token.fontSize
            },
            [`${progressCls}-outer`]: {
                display: 'inline-flex',
                alignItems: 'center',
                width: '100%'
            },
            [`${progressCls}-inner`]: {
                position: 'relative',
                display: 'inline-block',
                width: '100%',
                flex: 1,
                overflow: 'hidden',
                verticalAlign: 'middle',
                backgroundColor: token.remainingColor,
                borderRadius: token.lineBorderRadius
            },
            [`${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.defaultColor
                }
            },
            [`${progressCls}-success-bg, ${progressCls}-bg`]: {
                position: 'relative',
                background: token.defaultColor,
                borderRadius: token.lineBorderRadius,
                transition: `all ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`
            },
            [`${progressCls}-layout-bottom`]: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                [`${progressCls}-text`]: {
                    width: 'max-content',
                    marginInlineStart: 0,
                    marginTop: token.marginXXS
                }
            },
            [`${progressCls}-bg`]: {
                overflow: 'hidden',
                '&::after': {
                    content: '""',
                    background: {
                        _multi_value_: true,
                        value: [
                            'inherit',
                            `var(${$127b9bb49070dd08$export$ce7447cfda329128})`
                        ]
                    },
                    height: '100%',
                    width: `calc(1 / var(${$127b9bb49070dd08$export$cbc348af47898b5e}) * 100%)`,
                    display: 'block'
                },
                [`&${progressCls}-bg-inner`]: {
                    minWidth: 'max-content',
                    '&::after': {
                        content: 'none'
                    },
                    [`${progressCls}-text-inner`]: {
                        color: token.colorWhite,
                        [`&${progressCls}-text-bright`]: {
                            color: 'rgba(0, 0, 0, 0.45)'
                        }
                    }
                }
            },
            [`${progressCls}-success-bg`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                backgroundColor: token.colorSuccess
            },
            [`${progressCls}-text`]: {
                display: 'inline-block',
                marginInlineStart: token.marginXS,
                color: token.colorText,
                lineHeight: 1,
                width: '2em',
                whiteSpace: 'nowrap',
                textAlign: 'start',
                verticalAlign: 'middle',
                wordBreak: 'normal',
                [iconPrefixCls]: {
                    fontSize: token.fontSize
                },
                [`&${progressCls}-text-outer`]: {
                    width: 'max-content'
                },
                [`&${progressCls}-text-outer${progressCls}-text-start`]: {
                    width: 'max-content',
                    marginInlineStart: 0,
                    marginInlineEnd: token.marginXS
                }
            },
            [`${progressCls}-text-inner`]: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                marginInlineStart: 0,
                padding: `0 ${(0, $4g3I0.unit)(token.paddingXXS)}`,
                [`&${progressCls}-text-start`]: {
                    justifyContent: 'start'
                },
                [`&${progressCls}-text-end`]: {
                    justifyContent: 'end'
                }
            },
            [`&${progressCls}-status-active`]: {
                [`${progressCls}-bg::before`]: {
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: token.colorBgContainer,
                    borderRadius: token.lineBorderRadius,
                    opacity: 0,
                    animationName: $127b9bb49070dd08$var$genAntProgressActive(),
                    animationDuration: token.progressActiveMotionDuration,
                    animationTimingFunction: token.motionEaseOutQuint,
                    animationIterationCount: 'infinite',
                    content: '""'
                }
            },
            [`&${progressCls}-rtl${progressCls}-status-active`]: {
                [`${progressCls}-bg::before`]: {
                    animationName: $127b9bb49070dd08$var$genAntProgressActive(true)
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-bg`]: {
                    backgroundColor: token.colorError
                },
                [`${progressCls}-text`]: {
                    color: token.colorError
                }
            },
            [`&${progressCls}-status-exception ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.colorError
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-bg`]: {
                    backgroundColor: token.colorSuccess
                },
                [`${progressCls}-text`]: {
                    color: token.colorSuccess
                }
            },
            [`&${progressCls}-status-success ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.colorSuccess
                }
            }
        })
    };
};
const $127b9bb49070dd08$var$genCircleStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-circle-trail`]: {
                stroke: token.remainingColor
            },
            [`&${progressCls}-circle ${progressCls}-inner`]: {
                position: 'relative',
                lineHeight: 1,
                backgroundColor: 'transparent'
            },
            [`&${progressCls}-circle ${progressCls}-text`]: {
                position: 'absolute',
                insetBlockStart: '50%',
                insetInlineStart: 0,
                width: '100%',
                margin: 0,
                padding: 0,
                color: token.circleTextColor,
                fontSize: token.circleTextFontSize,
                lineHeight: 1,
                whiteSpace: 'normal',
                textAlign: 'center',
                transform: 'translateY(-50%)',
                [iconPrefixCls]: {
                    fontSize: token.circleIconFontSize
                }
            },
            [`${progressCls}-circle&-status-exception`]: {
                [`${progressCls}-text`]: {
                    color: token.colorError
                }
            },
            [`${progressCls}-circle&-status-success`]: {
                [`${progressCls}-text`]: {
                    color: token.colorSuccess
                }
            }
        },
        [`${progressCls}-inline-circle`]: {
            lineHeight: 1,
            [`${progressCls}-inner`]: {
                verticalAlign: 'bottom'
            }
        }
    };
};
const $127b9bb49070dd08$var$genStepStyle = (token)=>{
    const { componentCls: progressCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-steps`]: {
                display: 'inline-block',
                '&-outer': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                },
                '&-item': {
                    flexShrink: 0,
                    minWidth: token.progressStepMinWidth,
                    marginInlineEnd: token.progressStepMarginInlineEnd,
                    backgroundColor: token.remainingColor,
                    transition: `all ${token.motionDurationSlow}`,
                    '&-active': {
                        backgroundColor: token.defaultColor
                    }
                }
            }
        }
    };
};
const $127b9bb49070dd08$var$genSmallLine = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-text ${iconPrefixCls}`]: {
                fontSize: token.fontSizeSM
            }
        }
    };
};
const $127b9bb49070dd08$export$9ca1be8807fe0675 = (token)=>({
        circleTextColor: token.colorText,
        defaultColor: token.colorInfo,
        remainingColor: token.colorFillSecondary,
        lineBorderRadius: 100,
        // magic for capsule shape, should be a very large number
        circleTextFontSize: '1em',
        circleIconFontSize: `${token.fontSize / token.fontSizeSM}em`
    });
var $127b9bb49070dd08$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Progress', (token)=>{
    const progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
    const progressToken = (0, $8APUt.merge)(token, {
        progressStepMarginInlineEnd: progressStepMarginInlineEnd,
        progressStepMinWidth: progressStepMarginInlineEnd,
        progressActiveMotionDuration: '2.4s'
    });
    return [
        $127b9bb49070dd08$var$genBaseStyle(progressToken),
        $127b9bb49070dd08$var$genCircleStyle(progressToken),
        $127b9bb49070dd08$var$genStepStyle(progressToken),
        $127b9bb49070dd08$var$genSmallLine(progressToken)
    ];
}, $127b9bb49070dd08$export$9ca1be8807fe0675);



"use client";
var $73d6eb31277029e8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $73d6eb31277029e8$export$8947b167cf78cbe = (gradients)=>{
    let tempArr = [];
    Object.keys(gradients).forEach((key)=>{
        const formattedKey = parseFloat(key.replace(/%/g, ''));
        if (!Number.isNaN(formattedKey)) tempArr.push({
            key: formattedKey,
            value: gradients[key]
        });
    });
    tempArr = tempArr.sort((a, b)=>a.key - b.key);
    return tempArr.map((_ref)=>{
        let { key: key, value: value } = _ref;
        return `${value} ${key}%`;
    }).join(', ');
};
const $73d6eb31277029e8$export$22b6122229807a9f = (strokeColor, directionConfig)=>{
    const { from: from = (0, $lvl2c.presetPrimaryColors).blue, to: to = (0, $lvl2c.presetPrimaryColors).blue, direction: direction = directionConfig === 'rtl' ? 'to left' : 'to right' } = strokeColor, rest = $73d6eb31277029e8$var$__rest(strokeColor, [
        "from",
        "to",
        "direction"
    ]);
    if (Object.keys(rest).length !== 0) {
        const sortedGradients = $73d6eb31277029e8$export$8947b167cf78cbe(rest);
        const background = `linear-gradient(${direction}, ${sortedGradients})`;
        return {
            background: background,
            [(0, $127b9bb49070dd08$export$ce7447cfda329128)]: background
        };
    }
    const background = `linear-gradient(${direction}, ${from}, ${to})`;
    return {
        background: background,
        [(0, $127b9bb49070dd08$export$ce7447cfda329128)]: background
    };
};
const $73d6eb31277029e8$var$Line = (props)=>{
    const { prefixCls: prefixCls, direction: directionConfig, percent: percent, size: size, strokeWidth: strokeWidth, strokeColor: strokeColor, strokeLinecap: strokeLinecap = 'round', children: children, trailColor: trailColor = null, percentPosition: percentPosition, success: success } = props;
    const { align: infoAlign, type: infoPosition } = percentPosition;
    const backgroundProps = strokeColor && typeof strokeColor !== 'string' ? $73d6eb31277029e8$export$22b6122229807a9f(strokeColor, directionConfig) : {
        [(0, $127b9bb49070dd08$export$ce7447cfda329128)]: strokeColor,
        background: strokeColor
    };
    const borderRadius = strokeLinecap === 'square' || strokeLinecap === 'butt' ? 0 : undefined;
    const mergedSize = size !== null && size !== void 0 ? size : [
        -1,
        strokeWidth || (size === 'small' ? 6 : 8)
    ];
    const [width, height] = (0, $a232916295496e6a$export$31b21d0167753bb4)(mergedSize, 'line', {
        strokeWidth: strokeWidth
    });
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Progress');
        warning.deprecated(!('strokeWidth' in props), 'strokeWidth', 'size');
    }
    const trailStyle = {
        backgroundColor: trailColor || undefined,
        borderRadius: borderRadius
    };
    const percentStyle = Object.assign(Object.assign({
        width: `${(0, $a232916295496e6a$export$2caef35201f951a0)(percent)}%`,
        height: height,
        borderRadius: borderRadius
    }, backgroundProps), {
        [(0, $127b9bb49070dd08$export$cbc348af47898b5e)]: (0, $a232916295496e6a$export$2caef35201f951a0)(percent) / 100
    });
    const successPercent = (0, $a232916295496e6a$export$4ab1c09ce4ee99b)(props);
    const successPercentStyle = {
        width: `${(0, $a232916295496e6a$export$2caef35201f951a0)(successPercent)}%`,
        height: height,
        borderRadius: borderRadius,
        backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
    };
    const outerStyle = {
        width: width < 0 ? '100%' : width
    };
    const lineInner = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-inner`,
        style: trailStyle
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-bg`, `${prefixCls}-bg-${infoPosition}`),
        style: percentStyle
    }, infoPosition === 'inner' && children), successPercent !== undefined && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-success-bg`,
        style: successPercentStyle
    }));
    const isOuterStart = infoPosition === 'outer' && infoAlign === 'start';
    const isOuterEnd = infoPosition === 'outer' && infoAlign === 'end';
    return infoPosition === 'outer' && infoAlign === 'center' ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-layout-bottom`
    }, lineInner, children) : /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-outer`,
        style: outerStyle
    }, isOuterStart && children, lineInner, isOuterEnd && children);
};
var $73d6eb31277029e8$export$2e2bcd8739ae039 = $73d6eb31277029e8$var$Line;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

"use client";
const $5a2ff06078c584a1$var$Steps = (props)=>{
    const { size: size, steps: steps, percent: percent = 0, strokeWidth: strokeWidth = 8, strokeColor: strokeColor, trailColor: trailColor = null, prefixCls: prefixCls, children: children } = props;
    const current = Math.round(steps * (percent / 100));
    const stepWidth = size === 'small' ? 2 : 14;
    const mergedSize = size !== null && size !== void 0 ? size : [
        stepWidth,
        strokeWidth
    ];
    const [width, height] = (0, $a232916295496e6a$export$31b21d0167753bb4)(mergedSize, 'step', {
        steps: steps,
        strokeWidth: strokeWidth
    });
    const unitWidth = width / steps;
    const styledSteps = new Array(steps);
    for(let i = 0; i < steps; i++){
        const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
        styledSteps[i] = /*#__PURE__*/ $jMaZ8.createElement("div", {
            key: i,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-steps-item`, {
                [`${prefixCls}-steps-item-active`]: i <= current - 1
            }),
            style: {
                backgroundColor: i <= current - 1 ? color : trailColor,
                width: unitWidth,
                height: height
            }
        });
    }
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-steps-outer`
    }, styledSteps, children);
};
var $5a2ff06078c584a1$export$2e2bcd8739ae039 = $5a2ff06078c584a1$var$Steps;




"use client";
var $c7471984ffc59345$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c7471984ffc59345$export$e54ebc7fe4b5dc4e = [
    'line',
    'circle',
    'dashboard'
];
const $c7471984ffc59345$var$ProgressStatuses = [
    'normal',
    'exception',
    'active',
    'success'
];
const $c7471984ffc59345$var$Progress = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, steps: steps, strokeColor: strokeColor, percent: percent = 0, size: size = 'default', showInfo: showInfo = true, type: type = 'line', status: status, format: format, style: style, percentPosition: percentPosition = {} } = props, restProps = $c7471984ffc59345$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "steps",
        "strokeColor",
        "percent",
        "size",
        "showInfo",
        "type",
        "status",
        "format",
        "style",
        "percentPosition"
    ]);
    const { align: infoAlign = 'end', type: infoPosition = 'outer' } = percentPosition;
    const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
    const strokeColorNotGradient = typeof strokeColor === 'string' || Array.isArray(strokeColor) ? strokeColor : undefined;
    const strokeColorIsBright = $jMaZ8.useMemo(()=>{
        if (strokeColorNotArray) {
            const color = typeof strokeColorNotArray === 'string' ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
            return new (0, $6xABB.FastColor)(color).isLight();
        }
        return false;
    }, [
        strokeColor
    ]);
    const percentNumber = $jMaZ8.useMemo(()=>{
        var _a, _b;
        const successPercent = (0, $a232916295496e6a$export$4ab1c09ce4ee99b)(props);
        return parseInt(successPercent !== undefined ? (_a = successPercent !== null && successPercent !== void 0 ? successPercent : 0) === null || _a === void 0 ? void 0 : _a.toString() : (_b = percent !== null && percent !== void 0 ? percent : 0) === null || _b === void 0 ? void 0 : _b.toString(), 10);
    }, [
        percent,
        props.success,
        props.successPercent
    ]);
    const progressStatus = $jMaZ8.useMemo(()=>{
        if (!$c7471984ffc59345$var$ProgressStatuses.includes(status) && percentNumber >= 100) return 'success';
        return status || 'normal';
    }, [
        status,
        percentNumber
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, progress: progressStyle } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('progress', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $127b9bb49070dd08$export$2e2bcd8739ae039)(prefixCls);
    const isLineType = type === 'line';
    const isPureLineType = isLineType && !steps;
    const progressInfo = $jMaZ8.useMemo(()=>{
        if (!showInfo) return null;
        const successPercent = (0, $a232916295496e6a$export$4ab1c09ce4ee99b)(props);
        let text;
        const textFormatter = format || ((number)=>`${number}%`);
        const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === 'inner';
        if (infoPosition === 'inner' || format || progressStatus !== 'exception' && progressStatus !== 'success') text = textFormatter((0, $a232916295496e6a$export$2caef35201f951a0)(percent), (0, $a232916295496e6a$export$2caef35201f951a0)(successPercent));
        else if (progressStatus === 'exception') text = isLineType ? /*#__PURE__*/ $jMaZ8.createElement((0, $93361570ffc8bbe1$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), null);
        else if (progressStatus === 'success') text = isLineType ? /*#__PURE__*/ $jMaZ8.createElement((0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $c1c1d6d80357382d$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-text`, {
                [`${prefixCls}-text-bright`]: isBrightInnerColor,
                [`${prefixCls}-text-${infoAlign}`]: isPureLineType,
                [`${prefixCls}-text-${infoPosition}`]: isPureLineType
            }),
            title: typeof text === 'string' ? text : undefined
        }, text);
    }, [
        showInfo,
        percent,
        percentNumber,
        progressStatus,
        type,
        prefixCls,
        format
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Progress');
        warning.deprecated(!('successPercent' in props), 'successPercent', 'success.percent');
        warning.deprecated(!('width' in props), 'width', 'size');
        if (type === 'circle' || type === 'dashboard') {
            if (Array.isArray(size)) warning(false, 'usage', 'Type "circle" and "dashboard" do not accept array as `size`, please use number or preset size instead.');
            else if (typeof size === 'object') warning(false, 'usage', 'Type "circle" and "dashboard" do not accept object as `size`, please use number or preset size instead.');
        }
        if (props.success && 'progress' in props.success) warning.deprecated(false, 'success.progress', 'success.percent');
    }
    let progress;
    // Render progress shape
    if (type === 'line') progress = steps ? /*#__PURE__*/ $jMaZ8.createElement((0, $5a2ff06078c584a1$export$2e2bcd8739ae039), Object.assign({}, props, {
        strokeColor: strokeColorNotGradient,
        prefixCls: prefixCls,
        steps: typeof steps === 'object' ? steps.count : steps
    }), progressInfo) : /*#__PURE__*/ $jMaZ8.createElement((0, $73d6eb31277029e8$export$2e2bcd8739ae039), Object.assign({}, props, {
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        direction: direction,
        percentPosition: {
            align: infoAlign,
            type: infoPosition
        }
    }), progressInfo);
    else if (type === 'circle' || type === 'dashboard') progress = /*#__PURE__*/ $jMaZ8.createElement((0, $8d5bb48293c87494$export$2e2bcd8739ae039), Object.assign({}, props, {
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        progressStatus: progressStatus
    }), progressInfo);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-status-${progressStatus}`, {
        [`${prefixCls}-${type === 'dashboard' && 'circle' || type}`]: type !== 'line',
        [`${prefixCls}-inline-circle`]: type === 'circle' && (0, $a232916295496e6a$export$31b21d0167753bb4)(size, 'circle')[0] <= 20,
        [`${prefixCls}-line`]: isPureLineType,
        [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
        [`${prefixCls}-steps`]: steps,
        [`${prefixCls}-show-info`]: showInfo,
        [`${prefixCls}-${size}`]: typeof size === 'string',
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.className, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        ref: ref,
        style: Object.assign(Object.assign({}, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.style), style),
        className: classString,
        role: "progressbar",
        "aria-valuenow": percentNumber,
        "aria-valuemin": 0,
        "aria-valuemax": 100
    }, (0, $hvG6u.default)(restProps, [
        'trailColor',
        'strokeWidth',
        'width',
        'gapDegree',
        'gapPosition',
        'strokeLinecap',
        'success',
        'successPercent'
    ])), progress));
});
$c7471984ffc59345$var$Progress.displayName = 'Progress';
var $c7471984ffc59345$export$2e2bcd8739ae039 = $c7471984ffc59345$var$Progress;


"use client";
var $eef464bb94d68b8c$export$2e2bcd8739ae039 = (0, $c7471984ffc59345$export$2e2bcd8739ae039);


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");





var $jMaZ8 = parcelRequire("jMaZ8");
const $578f5d82db12b18e$var$RadioGroupContext = /*#__PURE__*/ $jMaZ8.createContext(null);
const $578f5d82db12b18e$export$67d4730aee04efd2 = $578f5d82db12b18e$var$RadioGroupContext.Provider;
var $578f5d82db12b18e$export$2e2bcd8739ae039 = $578f5d82db12b18e$var$RadioGroupContext;
const $578f5d82db12b18e$export$4fbd9581b41e971f = /*#__PURE__*/ $jMaZ8.createContext(null);
const $578f5d82db12b18e$export$1b5d1f64a577990e = $578f5d82db12b18e$export$4fbd9581b41e971f.Provider;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");

var $jMaZ8 = parcelRequire("jMaZ8");
var $86220ccac903f90f$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "checked",
    "disabled",
    "defaultChecked",
    "type",
    "title",
    "onChange"
];
var $86220ccac903f90f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $jMaZ8.forwardRef)(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-checkbox' : _props$prefixCls, className = props.className, style = props.style, checked = props.checked, disabled = props.disabled, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$type = props.type, type = _props$type === void 0 ? 'checkbox' : _props$type, title = props.title, onChange = props.onChange, inputProps = (0, $4b02Q.default)(props, $86220ccac903f90f$var$_excluded);
    var inputRef = (0, $jMaZ8.useRef)(null);
    var holderRef = (0, $jMaZ8.useRef)(null);
    var _useMergedState = (0, $eGh7a.default)(defaultChecked, {
        value: checked
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), rawValue = _useMergedState2[0], setRawValue = _useMergedState2[1];
    (0, $jMaZ8.useImperativeHandle)(ref, function() {
        return {
            focus: function focus(options) {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
            },
            blur: function blur() {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        };
    });
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-checked"), rawValue), "".concat(prefixCls, "-disabled"), disabled));
    var handleChange = function handleChange(e) {
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange === null || onChange === void 0 || onChange({
            target: (0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
                type: type,
                checked: e.target.checked
            }),
            stopPropagation: function stopPropagation() {
                e.stopPropagation();
            },
            preventDefault: function preventDefault() {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ $jMaZ8.createElement("input", (0, $hH60s.default)({}, inputProps, {
        className: "".concat(prefixCls, "-input"),
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }));
});
var $86220ccac903f90f$export$2e2bcd8739ae039 = $86220ccac903f90f$export$48513f6b9f8ce62d;



var $1cfGC = parcelRequire("1cfGC");




var $jMaZ8 = parcelRequire("jMaZ8");

var $aZxvk = parcelRequire("aZxvk");
function $17a96173768e811a$export$2e2bcd8739ae039(onOriginInputClick) {
    const labelClickLockRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(null);
    const clearLock = ()=>{
        (0, $aZxvk.default).cancel(labelClickLockRef.current);
        labelClickLockRef.current = null;
    };
    const onLabelClick = ()=>{
        clearLock();
        labelClickLockRef.current = (0, $aZxvk.default)(()=>{
            labelClickLockRef.current = null;
        });
    };
    const onInputClick = (e)=>{
        if (labelClickLockRef.current) {
            e.stopPropagation();
            clearLock();
        }
        onOriginInputClick === null || onOriginInputClick === void 0 || onOriginInputClick(e);
    };
    return [
        onLabelClick,
        onInputClick
    ];
}







parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// ============================== Styles ==============================
// styles from RadioGroup only
const $2d04ef3a01ceb0bb$var$getGroupRadioStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const groupPrefixCls = `${componentCls}-group`;
    return {
        [groupPrefixCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            display: 'inline-block',
            fontSize: 0,
            // RTL
            [`&${groupPrefixCls}-rtl`]: {
                direction: 'rtl'
            },
            [`&${groupPrefixCls}-block`]: {
                display: 'flex'
            },
            [`${antCls}-badge ${antCls}-badge-count`]: {
                zIndex: 1
            },
            [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
                borderInlineStart: 'none'
            }
        })
    };
};
// Styles from radio-wrapper
const $2d04ef3a01ceb0bb$var$getRadioBasicStyle = (token)=>{
    const { componentCls: componentCls, wrapperMarginInlineEnd: wrapperMarginInlineEnd, colorPrimary: colorPrimary, radioSize: radioSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOutCirc: motionEaseInOutCirc, colorBgContainer: colorBgContainer, colorBorder: colorBorder, lineWidth: lineWidth, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, paddingXS: paddingXS, dotColorDisabled: dotColorDisabled, lineType: lineType, radioColor: radioColor, radioBgColor: radioBgColor, calc: calc } = token;
    const radioInnerPrefixCls = `${componentCls}-inner`;
    const dotPadding = 4;
    const radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
    const radioSizeCalc = calc(1).mul(radioSize).equal({
        unit: true
    });
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            display: 'inline-flex',
            alignItems: 'baseline',
            marginInlineStart: 0,
            marginInlineEnd: wrapperMarginInlineEnd,
            cursor: 'pointer',
            '&:last-child': {
                marginInlineEnd: 0
            },
            // RTL
            [`&${componentCls}-wrapper-rtl`]: {
                direction: 'rtl'
            },
            '&-disabled': {
                cursor: 'not-allowed',
                color: token.colorTextDisabled
            },
            '&::after': {
                display: 'inline-block',
                width: 0,
                overflow: 'hidden',
                content: '"\\a0"'
            },
            '&-block': {
                flex: 1,
                justifyContent: 'center'
            },
            // hashId 在 wrapper 上，只能铺平
            [`${componentCls}-checked::after`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                width: '100%',
                height: '100%',
                border: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: '50%',
                visibility: 'hidden',
                opacity: 0,
                content: '""'
            },
            [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                position: 'relative',
                display: 'inline-block',
                outline: 'none',
                cursor: 'pointer',
                alignSelf: 'center',
                borderRadius: '50%'
            }),
            [`${componentCls}-wrapper:hover &,
        &:hover ${radioInnerPrefixCls}`]: {
                borderColor: colorPrimary
            },
            [`${componentCls}-input:focus-visible + ${radioInnerPrefixCls}`]: Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token)),
            [`${componentCls}:hover::after, ${componentCls}-wrapper:hover &::after`]: {
                visibility: 'visible'
            },
            [`${componentCls}-inner`]: {
                '&::after': {
                    boxSizing: 'border-box',
                    position: 'absolute',
                    insetBlockStart: '50%',
                    insetInlineStart: '50%',
                    display: 'block',
                    width: radioSizeCalc,
                    height: radioSizeCalc,
                    marginBlockStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    marginInlineStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    backgroundColor: radioColor,
                    borderBlockStart: 0,
                    borderInlineStart: 0,
                    borderRadius: radioSizeCalc,
                    transform: 'scale(0)',
                    opacity: 0,
                    transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`,
                    content: '""'
                },
                boxSizing: 'border-box',
                position: 'relative',
                insetBlockStart: 0,
                insetInlineStart: 0,
                display: 'block',
                width: radioSizeCalc,
                height: radioSizeCalc,
                backgroundColor: colorBgContainer,
                borderColor: colorBorder,
                borderStyle: 'solid',
                borderWidth: lineWidth,
                borderRadius: '50%',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-input`]: {
                position: 'absolute',
                inset: 0,
                zIndex: 1,
                cursor: 'pointer',
                opacity: 0
            },
            // 选中状态
            [`${componentCls}-checked`]: {
                [radioInnerPrefixCls]: {
                    borderColor: colorPrimary,
                    backgroundColor: radioBgColor,
                    '&::after': {
                        transform: `scale(${token.calc(token.dotSize).div(radioSize).equal()})`,
                        opacity: 1,
                        transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
                    }
                }
            },
            [`${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [radioInnerPrefixCls]: {
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder,
                    cursor: 'not-allowed',
                    '&::after': {
                        backgroundColor: dotColorDisabled
                    }
                },
                [`${componentCls}-input`]: {
                    cursor: 'not-allowed'
                },
                [`${componentCls}-disabled + span`]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                },
                [`&${componentCls}-checked`]: {
                    [radioInnerPrefixCls]: {
                        '&::after': {
                            transform: `scale(${calc(radioDotDisabledSize).div(radioSize).equal()})`
                        }
                    }
                }
            },
            [`span${componentCls} + *`]: {
                paddingInlineStart: paddingXS,
                paddingInlineEnd: paddingXS
            }
        })
    };
};
// Styles from radio-button
const $2d04ef3a01ceb0bb$var$getRadioButtonStyle = (token)=>{
    const { buttonColor: buttonColor, controlHeight: controlHeight, componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, buttonPaddingInline: buttonPaddingInline, fontSize: fontSize, buttonBg: buttonBg, fontSizeLG: fontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, paddingXS: paddingXS, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, buttonCheckedBg: buttonCheckedBg, buttonSolidCheckedColor: buttonSolidCheckedColor, colorTextDisabled: colorTextDisabled, colorBgContainerDisabled: colorBgContainerDisabled, buttonCheckedBgDisabled: buttonCheckedBgDisabled, buttonCheckedColorDisabled: buttonCheckedColorDisabled, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, buttonSolidCheckedBg: buttonSolidCheckedBg, buttonSolidCheckedHoverBg: buttonSolidCheckedHoverBg, buttonSolidCheckedActiveBg: buttonSolidCheckedActiveBg, calc: calc } = token;
    return {
        [`${componentCls}-button-wrapper`]: {
            position: 'relative',
            display: 'inline-block',
            height: controlHeight,
            margin: 0,
            paddingInline: buttonPaddingInline,
            paddingBlock: 0,
            color: buttonColor,
            fontSize: fontSize,
            lineHeight: (0, $4g3I0.unit)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
            background: buttonBg,
            border: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${colorBorder}`,
            // strange align fix for chrome but works
            // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
            borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
            borderInlineStartWidth: 0,
            borderInlineEndWidth: lineWidth,
            cursor: 'pointer',
            transition: [
                `color ${motionDurationMid}`,
                `background ${motionDurationMid}`,
                `box-shadow ${motionDurationMid}`
            ].join(','),
            a: {
                color: buttonColor
            },
            [`> ${componentCls}-button`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                zIndex: -1,
                width: '100%',
                height: '100%'
            },
            '&:not(:first-child)': {
                '&::before': {
                    position: 'absolute',
                    insetBlockStart: calc(lineWidth).mul(-1).equal(),
                    insetInlineStart: calc(lineWidth).mul(-1).equal(),
                    display: 'block',
                    boxSizing: 'content-box',
                    width: 1,
                    height: '100%',
                    paddingBlock: lineWidth,
                    paddingInline: 0,
                    backgroundColor: colorBorder,
                    transition: `background-color ${motionDurationSlow}`,
                    content: '""'
                }
            },
            '&:first-child': {
                borderInlineStart: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${colorBorder}`,
                borderStartStartRadius: borderRadius,
                borderEndStartRadius: borderRadius
            },
            '&:last-child': {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            '&:first-child:last-child': {
                borderRadius: borderRadius
            },
            [`${componentCls}-group-large &`]: {
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: (0, $4g3I0.unit)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusLG,
                    borderEndStartRadius: borderRadiusLG
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-small &`]: {
                height: controlHeightSM,
                paddingInline: calc(paddingXS).sub(lineWidth).equal(),
                paddingBlock: 0,
                lineHeight: (0, $4g3I0.unit)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusSM,
                    borderEndStartRadius: borderRadiusSM
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                }
            },
            '&:hover': {
                position: 'relative',
                color: colorPrimary
            },
            '&:has(:focus-visible)': Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token)),
            [`${componentCls}-inner, input[type='checkbox'], input[type='radio']`]: {
                width: 0,
                height: 0,
                opacity: 0,
                pointerEvents: 'none'
            },
            [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                zIndex: 1,
                color: colorPrimary,
                background: buttonCheckedBg,
                borderColor: colorPrimary,
                '&::before': {
                    backgroundColor: colorPrimary
                },
                '&:first-child': {
                    borderColor: colorPrimary
                },
                '&:hover': {
                    color: colorPrimaryHover,
                    borderColor: colorPrimaryHover,
                    '&::before': {
                        backgroundColor: colorPrimaryHover
                    }
                },
                '&:active': {
                    color: colorPrimaryActive,
                    borderColor: colorPrimaryActive,
                    '&::before': {
                        backgroundColor: colorPrimaryActive
                    }
                }
            },
            [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                color: buttonSolidCheckedColor,
                background: buttonSolidCheckedBg,
                borderColor: buttonSolidCheckedBg,
                '&:hover': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedHoverBg,
                    borderColor: buttonSolidCheckedHoverBg
                },
                '&:active': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedActiveBg,
                    borderColor: buttonSolidCheckedActiveBg
                }
            },
            '&-disabled': {
                color: colorTextDisabled,
                backgroundColor: colorBgContainerDisabled,
                borderColor: colorBorder,
                cursor: 'not-allowed',
                '&:first-child, &:hover': {
                    color: colorTextDisabled,
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder
                }
            },
            [`&-disabled${componentCls}-button-wrapper-checked`]: {
                color: buttonCheckedColorDisabled,
                backgroundColor: buttonCheckedBgDisabled,
                borderColor: colorBorder,
                boxShadow: 'none'
            },
            '&-block': {
                flex: 1,
                textAlign: 'center'
            }
        }
    };
};
const $2d04ef3a01ceb0bb$export$9ca1be8807fe0675 = (token)=>{
    const { wireframe: wireframe, padding: padding, marginXS: marginXS, lineWidth: lineWidth, fontSizeLG: fontSizeLG, colorText: colorText, colorBgContainer: colorBgContainer, colorTextDisabled: colorTextDisabled, controlItemBgActiveDisabled: controlItemBgActiveDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, colorWhite: colorWhite } = token;
    const dotPadding = 4; // Fixed value
    const radioSize = fontSizeLG;
    const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
    return {
        radioSize: // Radio
        radioSize,
        dotSize: radioDotSize,
        dotColorDisabled: colorTextDisabled,
        // Radio buttons
        buttonSolidCheckedColor: colorTextLightSolid,
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimaryHover,
        buttonSolidCheckedActiveBg: colorPrimaryActive,
        buttonBg: colorBgContainer,
        buttonCheckedBg: colorBgContainer,
        buttonColor: colorText,
        buttonCheckedBgDisabled: controlItemBgActiveDisabled,
        buttonCheckedColorDisabled: colorTextDisabled,
        buttonPaddingInline: padding - lineWidth,
        wrapperMarginInlineEnd: marginXS,
        // internal
        radioColor: wireframe ? colorPrimary : colorWhite,
        radioBgColor: wireframe ? colorBgContainer : colorPrimary
    };
};
var $2d04ef3a01ceb0bb$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Radio', (token)=>{
    const { controlOutline: controlOutline, controlOutlineWidth: controlOutlineWidth } = token;
    const radioFocusShadow = `0 0 0 ${(0, $4g3I0.unit)(controlOutlineWidth)} ${controlOutline}`;
    const radioButtonFocusShadow = radioFocusShadow;
    const radioToken = (0, $8APUt.merge)(token, {
        radioFocusShadow: radioFocusShadow,
        radioButtonFocusShadow: radioButtonFocusShadow
    });
    return [
        $2d04ef3a01ceb0bb$var$getGroupRadioStyle(radioToken),
        $2d04ef3a01ceb0bb$var$getRadioBasicStyle(radioToken),
        $2d04ef3a01ceb0bb$var$getRadioButtonStyle(radioToken)
    ];
}, $2d04ef3a01ceb0bb$export$9ca1be8807fe0675, {
    unitless: {
        radioSize: true,
        dotSize: true
    }
});


"use client";
var $13d628c0fd18a84e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $13d628c0fd18a84e$var$InternalRadio = (props, ref)=>{
    var _a, _b;
    const groupContext = $jMaZ8.useContext((0, $578f5d82db12b18e$export$2e2bcd8739ae039));
    const radioOptionTypeContext = $jMaZ8.useContext((0, $578f5d82db12b18e$export$4fbd9581b41e971f));
    const { getPrefixCls: getPrefixCls, direction: direction, radio: radio } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const innerRef = $jMaZ8.useRef(null);
    const mergedRef = (0, $1cfGC.composeRef)(ref, innerRef);
    const { isFormItemInput: isFormItemInput } = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Radio');
        warning(!('optionType' in props), 'usage', '`optionType` is only support in Radio.Group.');
    }
    const onChange = (e)=>{
        var _a, _b;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e);
        (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b === void 0 || _b.call(groupContext, e);
    };
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, style: style, title: title } = props, restProps = $13d628c0fd18a84e$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "children",
        "style",
        "title"
    ]);
    const radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    const isButtonType = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === 'button';
    const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(radioPrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2d04ef3a01ceb0bb$export$2e2bcd8739ae039)(radioPrefixCls, rootCls);
    const radioProps = Object.assign({}, restProps);
    // ===================== Disabled =====================
    const disabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
    }
    radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
    const wrapperClassString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: radioProps.checked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
        [`${prefixCls}-wrapper-block`]: !!(groupContext === null || groupContext === void 0 ? void 0 : groupContext.block)
    }, radio === null || radio === void 0 ? void 0 : radio.className, className, rootClassName, hashId, cssVarCls, rootCls);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $17a96173768e811a$export$2e2bcd8739ae039)(radioProps.onClick);
    // ============================== Render ==============================
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $de29c1080c02bd8d$export$2e2bcd8739ae039), {
        component: "Radio",
        disabled: radioProps.disabled
    }, /*#__PURE__*/ $jMaZ8.createElement("label", {
        className: wrapperClassString,
        style: Object.assign(Object.assign({}, radio === null || radio === void 0 ? void 0 : radio.style), style),
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        title: title,
        onClick: onLabelClick
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $86220ccac903f90f$export$2e2bcd8739ae039), Object.assign({}, radioProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(radioProps.className, {
            [(0, $eb107cfcd5a0fca6$export$23466a5792b7a5d3)]: !isButtonType
        }),
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef,
        onClick: onInputClick
    })), children !== undefined ? /*#__PURE__*/ $jMaZ8.createElement("span", null, children) : null)));
};
const $13d628c0fd18a84e$var$Radio = /*#__PURE__*/ $jMaZ8.forwardRef($13d628c0fd18a84e$var$InternalRadio);
$13d628c0fd18a84e$var$Radio.displayName = 'Radio';
var $13d628c0fd18a84e$export$2e2bcd8739ae039 = $13d628c0fd18a84e$var$Radio;




"use client";
const $0daa9adb87aea826$var$RadioGroup = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const defaultName = (0, $715c60aee4cde1e6$export$2e2bcd8739ae039)();
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, options: options, buttonStyle: buttonStyle = 'outline', disabled: disabled, children: children, size: customizeSize, style: style, id: id, optionType: optionType, name: name = defaultName, defaultValue: defaultValue, value: customizedValue, block: block = false, onChange: onChange, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = props;
    const [value, setValue] = (0, $eGh7a.default)(defaultValue, {
        value: customizedValue
    });
    const onRadioChange = $jMaZ8.useCallback((event)=>{
        const lastValue = value;
        const val = event.target.value;
        if (!('value' in props)) setValue(val);
        if (val !== lastValue) onChange === null || onChange === void 0 || onChange(event);
    }, [
        value,
        setValue,
        onChange
    ]);
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2d04ef3a01ceb0bb$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map((option)=>{
        if (typeof option === 'string' || typeof option === 'number') // 此处类型自动推导为 string
        return /*#__PURE__*/ $jMaZ8.createElement((0, $13d628c0fd18a84e$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $jMaZ8.createElement((0, $13d628c0fd18a84e$export$2e2bcd8739ae039), {
            key: `radio-group-value-options-${option.value}`,
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            title: option.title,
            style: option.style,
            id: option.id,
            required: option.required
        }, option.label);
    });
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customizeSize);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
        [`${groupPrefixCls}-${mergedSize}`]: mergedSize,
        [`${groupPrefixCls}-rtl`]: direction === 'rtl',
        [`${groupPrefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls, rootCls);
    const memoizedValue = $jMaZ8.useMemo(()=>({
            onChange: onRadioChange,
            value: value,
            disabled: disabled,
            name: name,
            optionType: optionType,
            block: block
        }), [
        onRadioChange,
        value,
        disabled,
        name,
        optionType,
        block
    ]);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    }), {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $578f5d82db12b18e$export$67d4730aee04efd2), {
        value: memoizedValue
    }, childrenToRender)));
});
var $0daa9adb87aea826$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.memo($0daa9adb87aea826$var$RadioGroup);




var $jMaZ8 = parcelRequire("jMaZ8");



"use client";
var $200128cdddfa2db0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $200128cdddfa2db0$var$RadioButton = (props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls } = props, radioProps = $200128cdddfa2db0$var$__rest(props, [
        "prefixCls"
    ]);
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $578f5d82db12b18e$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $13d628c0fd18a84e$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls
    }, radioProps, {
        type: "radio",
        ref: ref
    })));
};
var $200128cdddfa2db0$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.forwardRef($200128cdddfa2db0$var$RadioButton);


"use client";
const $41c1392b19ea6316$var$Radio = (0, $13d628c0fd18a84e$export$2e2bcd8739ae039);
$41c1392b19ea6316$var$Radio.Button = (0, $200128cdddfa2db0$export$2e2bcd8739ae039);
$41c1392b19ea6316$var$Radio.Group = (0, $0daa9adb87aea826$export$2e2bcd8739ae039);
$41c1392b19ea6316$var$Radio.__ANT_RADIO = true;
var $41c1392b19ea6316$export$2e2bcd8739ae039 = $41c1392b19ea6316$var$Radio;


"use client";
var $f8244435bdab5821$export$2e2bcd8739ae039 = (0, $d1e533474e668570$export$2e2bcd8739ae039);


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $fvBso = parcelRequire("fvBso");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $1Esi2 = parcelRequire("1Esi2");

var $eGh7a = parcelRequire("eGh7a");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $jLTp6 = parcelRequire("jLTp6");

var $eGh7a = parcelRequire("eGh7a");


var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");

var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
var $f538d52946440c39$var$TransBtn = function TransBtn(props) {
    var className = props.className, customizeIcon = props.customizeIcon, customizeIconProps = props.customizeIconProps, children = props.children, _onMouseDown = props.onMouseDown, onClick = props.onClick;
    var icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none'
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $f538d52946440c39$export$2e2bcd8739ae039 = $f538d52946440c39$var$TransBtn;



var $jMaZ8 = parcelRequire("jMaZ8");
var $3c010b1e5fcaed5d$export$9ea6397a890aa3e5 = function useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
    var disabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var mergedSearchValue = arguments.length > 6 ? arguments[6] : undefined;
    var mode = arguments.length > 7 ? arguments[7] : undefined;
    var mergedClearIcon = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        if ((0, $1Esi2.default)(allowClear) === 'object') return allowClear.clearIcon;
        if (clearIcon) return clearIcon;
    }, [
        allowClear,
        clearIcon
    ]);
    var mergedAllowClear = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '')) return true;
        return false;
    }, [
        allowClear,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
    return {
        allowClear: mergedAllowClear,
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $f538d52946440c39$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-clear"),
            onMouseDown: onClearMouseDown,
            customizeIcon: mergedClearIcon
        }, "\xD7")
    };
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $jMaZ8 = parcelRequire("jMaZ8");
var $7ef519882a07e57d$export$8234047c0aea33cf = /*#__PURE__*/ $jMaZ8.createContext(null);
function $7ef519882a07e57d$export$2e2bcd8739ae039() {
    return $jMaZ8.useContext($7ef519882a07e57d$export$8234047c0aea33cf);
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $cc7a1277debc7c7d$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $jMaZ8.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $jMaZ8.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}



var $jMaZ8 = parcelRequire("jMaZ8");
function $b280c0d0e59e8747$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $jMaZ8.useRef(null);
    var timeoutRef = $jMaZ8.useRef(null);
    // Clean up
    $jMaZ8.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}



var $jMaZ8 = parcelRequire("jMaZ8");
function $95547844dfc4af50$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $jMaZ8.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $jMaZ8.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener('mousedown', onGlobalMouseDown);
        return function() {
            return window.removeEventListener('mousedown', onGlobalMouseDown);
        };
    }, []);
}



var $hH60s = parcelRequire("hH60s");

var $3fkx6 = parcelRequire("3fkx6");


var $jMaZ8 = parcelRequire("jMaZ8");


function $39cc85ae4f2b1f81$export$48ac81d4a07c29c(currentKeyCode) {
    return(// Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
        // System function button
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).SHIFT,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).BACKSPACE,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).TAB,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).WIN_KEY,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ALT,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).META,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).CTRL,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).SEMICOLON,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).EQUALS,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).CONTEXT_MENU,
        // F1-F12
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F1,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F2,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F3,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F4,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F5,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F6,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F7,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F8,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F9,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F10,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F11,
        (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode));
}



var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");




var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $1cfGC = parcelRequire("1cfGC");

var $2bFmQ = parcelRequire("2bFmQ");
var $58791bc5bed601b9$var$Input = function Input(props, ref) {
    var _inputNode2;
    var prefixCls = props.prefixCls, id = props.id, inputElement = props.inputElement, disabled = props.disabled, tabIndex = props.tabIndex, autoFocus = props.autoFocus, autoComplete = props.autoComplete, editable = props.editable, activeDescendantId = props.activeDescendantId, value = props.value, maxLength = props.maxLength, _onKeyDown = props.onKeyDown, _onMouseDown = props.onMouseDown, _onChange = props.onChange, onPaste = props.onPaste, _onCompositionStart = props.onCompositionStart, _onCompositionEnd = props.onCompositionEnd, _onBlur = props.onBlur, open = props.open, attrs = props.attrs;
    var inputNode = inputElement || /*#__PURE__*/ $jMaZ8.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, onOriginBlur = originProps.onBlur, style = originProps.style;
    (0, $2bFmQ.warning)(!('maxLength' in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $jMaZ8.cloneElement(inputNode, (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({
        type: 'search'
    }, originProps), {}, {
        // Override over origin props
        id: id,
        ref: (0, $1cfGC.composeRef)(ref, originRef),
        disabled: disabled,
        tabIndex: tabIndex,
        autoComplete: autoComplete || 'off',
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 || (_inputNode2 = _inputNode2.props) === null || _inputNode2 === void 0 ? void 0 : _inputNode2.className),
        role: 'combobox',
        'aria-expanded': open || false,
        'aria-haspopup': 'listbox',
        'aria-owns': "".concat(id, "_list"),
        'aria-autocomplete': 'list',
        'aria-controls': "".concat(id, "_list"),
        'aria-activedescendant': open ? activeDescendantId : undefined
    }, attrs), {}, {
        value: editable ? value : '',
        maxLength: maxLength,
        readOnly: !editable,
        unselectable: !editable ? 'on' : null,
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, style), {}, {
            opacity: editable ? null : 0
        }),
        onKeyDown: function onKeyDown(event) {
            _onKeyDown(event);
            if (onOriginKeyDown) onOriginKeyDown(event);
        },
        onMouseDown: function onMouseDown(event) {
            _onMouseDown(event);
            if (onOriginMouseDown) onOriginMouseDown(event);
        },
        onChange: function onChange(event) {
            _onChange(event);
            if (onOriginChange) onOriginChange(event);
        },
        onCompositionStart: function onCompositionStart(event) {
            _onCompositionStart(event);
            if (onOriginCompositionStart) onOriginCompositionStart(event);
        },
        onCompositionEnd: function onCompositionEnd(event) {
            _onCompositionEnd(event);
            if (onOriginCompositionEnd) onOriginCompositionEnd(event);
        },
        onPaste: onPaste,
        onBlur: function onBlur(event) {
            _onBlur(event);
            if (onOriginBlur) onOriginBlur(event);
        }
    }));
    return inputNode;
};
var $58791bc5bed601b9$var$RefInput = /*#__PURE__*/ $jMaZ8.forwardRef($58791bc5bed601b9$var$Input);
$58791bc5bed601b9$var$RefInput.displayName = 'Input';
var $58791bc5bed601b9$export$2e2bcd8739ae039 = $58791bc5bed601b9$var$RefInput;


/* eslint-disable react-hooks/rules-of-hooks */ 
var $jMaZ8 = parcelRequire("jMaZ8");

var $1Esi2 = parcelRequire("1Esi2");
function $4339bba5d7f527a0$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $4339bba5d7f527a0$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
var $4339bba5d7f527a0$export$df7146797a248522 = false;
function $4339bba5d7f527a0$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $4339bba5d7f527a0$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $4339bba5d7f527a0$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes((0, $1Esi2.default)(title));
}
function $4339bba5d7f527a0$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($4339bba5d7f527a0$var$isTitleType(item.title)) title = item.title.toString();
        else if ($4339bba5d7f527a0$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $b51235637e6c4426$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $4339bba5d7f527a0$export$df7146797a248522) /* istanbul ignore next */ $jMaZ8.useLayoutEffect(effect, deps);
    else $jMaZ8.useEffect(effect, deps);
} /* eslint-enable */ 



function $5500d3a20e8d9adb$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $5500d3a20e8d9adb$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $5500d3a20e8d9adb$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, onInputBlur = props.onInputBlur;
    var measureRef = $jMaZ8.useRef(null);
    var _useState = (0, $jMaZ8.useState)(0), _useState2 = (0, $3fkx6.default)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $jMaZ8.useState)(false), _useState4 = (0, $3fkx6.default)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === 'multiple' && autoClearSearchValue === false || mode === 'tags' ? searchValue : '';
    var inputEditable = mode === 'tags' || mode === 'multiple' && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $b51235637e6c4426$export$2e2bcd8739ae039)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    var defaultRenderSelector = function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $jMaZ8.createElement("span", {
            title: (0, $4339bba5d7f527a0$export$70d1bf7729efff40)(item),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(selectionPrefixCls, "-item"), (0, $eq8kl.default)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
        }, /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $jMaZ8.createElement((0, $f538d52946440c39$export$2e2bcd8739ae039), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $5500d3a20e8d9adb$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    };
    var customizeRenderSelector = function customizeRenderSelector(value, content, itemDisabled, closable, onClose, isMaxTag) {
        var onMouseDown = function onMouseDown(e) {
            $5500d3a20e8d9adb$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $jMaZ8.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    var renderItem = function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    var renderRest = function renderRest(omittedValues) {
        // https://github.com/ant-design/ant-design/issues/48930
        if (!values.length) return null;
        var content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $58791bc5bed601b9$export$2e2bcd8739ae039), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        onBlur: onInputBlur,
        tabIndex: tabIndex,
        attrs: (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, true)
    }), /*#__PURE__*/ $jMaZ8.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xA0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $jMaZ8.createElement((0, $7c61136bd8e14ae0$export$2e2bcd8739ae039), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $5500d3a20e8d9adb$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(selectionPrefixCls, "-wrap")
    }, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $5500d3a20e8d9adb$export$2e2bcd8739ae039 = $5500d3a20e8d9adb$var$SelectSelector;



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");



var $d22d3196620093e6$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, onInputBlur = props.onInputBlur, title = props.title;
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === 'combobox';
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || '';
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $jMaZ8.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== 'combobox' && !open && !showSearch ? false : !!inputValue;
    // Get title of selection item
    var selectionTitle = title === undefined ? (0, $4339bba5d7f527a0$export$70d1bf7729efff40)(item) : title;
    var placeholderNode = $jMaZ8.useMemo(function() {
        if (item) return null;
        return /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hasTextInput ? {
                visibility: 'hidden'
            } : undefined
        }, placeholder);
    }, [
        item,
        hasTextInput,
        placeholder,
        prefixCls
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(prefixCls, "-selection-wrap")
    }, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $58791bc5bed601b9$export$2e2bcd8739ae039), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        onBlur: onInputBlur,
        tabIndex: tabIndex,
        attrs: (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: selectionTitle,
        style: hasTextInput ? {
            visibility: 'hidden'
        } : undefined
    }, item.label) : null, placeholderNode);
};
var $d22d3196620093e6$export$2e2bcd8739ae039 = $d22d3196620093e6$var$SingleSelector;


var $8f9e5fedee2e9d08$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $jMaZ8.useRef)(null);
    var compositionStatusRef = (0, $jMaZ8.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, disabled = props.disabled, prefix = props.prefix, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, onInputBlur = props.onInputBlur, domRef = props.domRef;
    // ======================= Ref =======================
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            focus: function focus(options) {
                inputRef.current.focus(options);
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $b280c0d0e59e8747$export$2e2bcd8739ae039)(0), _useLock2 = (0, $3fkx6.default)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        // Compatible with multiple lines in TextArea
        var isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
        if (!isTextAreaElement && open && (which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP || which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN)) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER && mode === 'tags' && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        // Move within the text box
        if (isTextAreaElement && !open && ~[
            (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP,
            (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN,
            (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).LEFT,
            (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).RIGHT
        ].indexOf(which)) return;
        if ((0, $39cc85ae4f2b1f81$export$48ac81d4a07c29c)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $jMaZ8.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== 'combobox') triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData('text');
        pastedTextRef.current = value || '';
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox and it is disabled, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        // https://github.com/ant-design/ant-design/issues/48281
        if (event.target !== inputRef.current && !inputMouseDown && !(mode === 'combobox' && disabled)) event.preventDefault();
        if (mode !== 'combobox' && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch('', true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd,
        onInputBlur: onInputBlur
    };
    var selectNode = mode === 'multiple' || mode === 'tags' ? /*#__PURE__*/ $jMaZ8.createElement((0, $5500d3a20e8d9adb$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, sharedProps)) : /*#__PURE__*/ $jMaZ8.createElement((0, $d22d3196620093e6$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, sharedProps));
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, prefix && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(prefixCls, "-prefix")
    }, prefix), selectNode);
};
var $8f9e5fedee2e9d08$var$ForwardSelector = /*#__PURE__*/ $jMaZ8.forwardRef($8f9e5fedee2e9d08$var$Selector);
$8f9e5fedee2e9d08$var$ForwardSelector.displayName = 'Selector';
var $8f9e5fedee2e9d08$export$2e2bcd8739ae039 = $8f9e5fedee2e9d08$var$ForwardSelector;



var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");


var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $bb08cef9f15060c9$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "builtinPlacements",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $bb08cef9f15060c9$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        }
    };
};
var $bb08cef9f15060c9$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? 'ltr' : _props$direction, placement = props.placement, builtinPlacements = props.builtinPlacements, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $4b02Q.default)(props, $bb08cef9f15060c9$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var mergedBuiltinPlacements = $jMaZ8.useMemo(function() {
        return builtinPlacements || $bb08cef9f15060c9$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        builtinPlacements,
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // =================== Popup Width ===================
    var isNumberPopupWidth = typeof dropdownMatchSelectWidth === 'number';
    var stretch = $jMaZ8.useMemo(function() {
        if (isNumberPopupWidth) return null;
        return dropdownMatchSelectWidth === false ? 'minWidth' : 'width';
    }, [
        dropdownMatchSelectWidth,
        isNumberPopupWidth
    ]);
    var popupStyle = dropdownStyle;
    if (isNumberPopupWidth) popupStyle = (0, $8u3qN.default)((0, $8u3qN.default)({}, popupStyle), {}, {
        width: dropdownMatchSelectWidth
    });
    // ======================= Ref =======================
    var triggerPopupRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                var _triggerPopupRef$curr;
                return (_triggerPopupRef$curr = triggerPopupRef.current) === null || _triggerPopupRef$curr === void 0 ? void 0 : _triggerPopupRef$curr.popupElement;
            }
        };
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $3e6696c575106f0d$export$2e2bcd8739ae039), (0, $hH60s.default)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $jMaZ8.createElement("div", {
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(dropdownClassName, (0, $eq8kl.default)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $bb08cef9f15060c9$var$RefSelectTrigger = /*#__PURE__*/ $jMaZ8.forwardRef($bb08cef9f15060c9$var$SelectTrigger);
$bb08cef9f15060c9$var$RefSelectTrigger.displayName = 'SelectTrigger';
var $bb08cef9f15060c9$export$2e2bcd8739ae039 = $bb08cef9f15060c9$var$RefSelectTrigger;




var $fvBso = parcelRequire("fvBso");

var $eGaoM = parcelRequire("eGaoM");

var $8u3qN = parcelRequire("8u3qN");

var $2bFmQ = parcelRequire("2bFmQ");
function $ec3aff0dba75cb6e$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ('value' in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $ec3aff0dba75cb6e$export$be48fd776273e509(value) {
    return typeof value !== 'undefined' && !Number.isNaN(value);
}
function $ec3aff0dba75cb6e$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options, groupLabel = _ref.groupLabel;
    var mergedLabel = label || (childrenAsData ? 'children' : 'label');
    return {
        label: mergedLabel,
        value: value || 'value',
        options: options || 'options',
        groupLabel: groupLabel || mergedLabel
    };
}
function $ec3aff0dba75cb6e$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $ec3aff0dba75cb6e$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options, groupLabel = _fillFieldNames.groupLabel;
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach(function(data) {
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $ec3aff0dba75cb6e$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                var grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $ec3aff0dba75cb6e$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $ec3aff0dba75cb6e$export$d0b21b213c8c013c(option) {
    var newOption = (0, $8u3qN.default)({}, option);
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get: function get() {
            (0, $2bFmQ.default)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
var $ec3aff0dba75cb6e$export$a09ca2a89e052b14 = function getSeparatedContent(text, tokens, end) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    var separate = function separate(str, _ref3) {
        var _ref4 = (0, $eGaoM.default)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $fvBso.default)(prevList), (0, $fvBso.default)(separate(unitStr, restTokens)));
        }, []).filter(Boolean);
    };
    var list = separate(text, tokens);
    if (match) return typeof end !== 'undefined' ? list.slice(0, end) : list;
    else return null;
};



var $jMaZ8 = parcelRequire("jMaZ8");
// Use any here since we do not get the type during compilation
var $9f601c14a2948b0b$var$SelectContext = /*#__PURE__*/ $jMaZ8.createContext(null);
var $9f601c14a2948b0b$export$2e2bcd8739ae039 = $9f601c14a2948b0b$var$SelectContext;



var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");
function $a350af2860be31e2$export$2e2bcd8739ae039(props) {
    var visible = props.visible, values = props.values;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    var MAX_COUNT = 50;
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, "".concat(values.slice(0, MAX_COUNT).map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            'number',
            'string'
        ].includes((0, $1Esi2.default)(label)) ? label : value;
    }).join(', ')), values.length > MAX_COUNT ? ', ...' : null);
}


var $d9b36639a0b7be3f$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "prefix",
    "suffixIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "builtinPlacements",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $d9b36639a0b7be3f$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'autoFocus',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex'
];
var $d9b36639a0b7be3f$export$7f654ad2a77ad2ac = function isMultiple(mode) {
    return mode === 'tags' || mode === 'multiple';
};
var $d9b36639a0b7be3f$var$BaseSelect = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var _customizeRawInputEle;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, prefix = props.prefix, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, builtinPlacements = props.builtinPlacements, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $4b02Q.default)(props, $d9b36639a0b7be3f$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $d9b36639a0b7be3f$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === 'combobox';
    var domProps = (0, $8u3qN.default)({}, restProps);
    $d9b36639a0b7be3f$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $jMaZ8.useEffect(function() {
        // Only update on the client side
        setMobile((0, $e5dc72d643143115$export$2e2bcd8739ae039)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $jMaZ8.useRef(null);
    var selectorDomRef = $jMaZ8.useRef(null);
    var triggerRef = $jMaZ8.useRef(null);
    var selectorRef = $jMaZ8.useRef(null);
    var listRef = $jMaZ8.useRef(null);
    var blurRef = $jMaZ8.useRef(false);
    /** Used for component focused management */ var _useDelayReset = (0, $cc7a1277debc7c7d$export$2e2bcd8739ae039)(), _useDelayReset2 = (0, $3fkx6.default)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $jMaZ8.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            },
            nativeElement: containerRef.current || selectorDomRef.current
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $jMaZ8.useMemo(function() {
        var _displayValues$;
        if (mode !== 'combobox') return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === 'function' && getRawInputElement();
    var customizeRawInputRef = (0, $1cfGC.useComposeRef)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    // SSR not support Portal which means we need delay `open` for the first time render
    var _React$useState3 = $jMaZ8.useState(false), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), rendered = _React$useState4[0], setRendered = _React$useState4[1];
    (0, $jLTp6.default)(function() {
        setRendered(true);
    }, []);
    var _useMergedState = (0, $eGh7a.default)(false, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = rendered ? innerOpen : false;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === 'combobox') mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $jMaZ8.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $jMaZ8.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                '\n',
                '\r\n'
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var _ref = $jMaZ8.useContext((0, $9f601c14a2948b0b$export$2e2bcd8739ae039)) || {}, maxCount = _ref.maxCount, rawValues = _ref.rawValues;
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        if (multiple && (0, $ec3aff0dba75cb6e$export$be48fd776273e509)(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount) return;
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        var separatedList = (0, $ec3aff0dba75cb6e$export$a09ca2a89e052b14)(searchText, tokenSeparators, (0, $ec3aff0dba75cb6e$export$be48fd776273e509)(maxCount) ? maxCount - rawValues.size : undefined);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : separatedList;
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Close will clean up single mode search text
    $jMaZ8.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $jMaZ8.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled && !blurRef.current) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $b280c0d0e59e8747$export$2e2bcd8739ae039)(), _useLock2 = (0, $3fkx6.default)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    var keyLockRef = $jMaZ8.useRef(false);
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var key = event.key;
        var isEnterKey = key === 'Enter';
        if (isEnterKey) {
            // Do not submit form when type in the input
            if (mode !== 'combobox') event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $fvBso.default)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen && (!isEnterKey || !keyLockRef.current)) {
            var _listRef$current2;
            // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
            if (isEnterKey) keyLockRef.current = true;
            (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        if (event.key === 'Enter') keyLockRef.current = false;
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    };
    var onInputBlur = function onInputBlur() {
        // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
        keyLockRef.current = false;
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $jMaZ8.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        blurRef.current = true;
        setMockFocused(false, function() {
            focusRef.current = false;
            blurRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $jMaZ8.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState5 = $jMaZ8.useState({}), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $95547844dfc4af50$export$2e2bcd8739ae039)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $jMaZ8.useMemo(function() {
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var showSuffixIcon = !!suffixIcon || loading;
    var arrowNode;
    if (showSuffixIcon) arrowNode = /*#__PURE__*/ $jMaZ8.createElement((0, $f538d52946440c39$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-arrow"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: suffixIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    var _useAllowClear = (0, $3c010b1e5fcaed5d$export$9ea6397a890aa3e5)(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode), mergedAllowClear = _useAllowClear.allowClear, clearNode = _useAllowClear.clearIcon;
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $jMaZ8.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-focused"), mockFocused), "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-single"), !multiple), "".concat(prefixCls, "-allow-clear"), allowClear), "".concat(prefixCls, "-show-arrow"), showSuffixIcon), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-open"), mergedOpen), "".concat(prefixCls, "-customize-input"), customizeInputElement), "".concat(prefixCls, "-show-search"), mergedShowSearch));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $jMaZ8.createElement((0, $bb08cef9f15060c9$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode(node) {
            return(// TODO: This is workaround and should be removed in `rc-select`
            // And use new standard `nativeElement` for ref.
            // But we should update `rc-resize-observer` first.
            selectorDomRef.current || node);
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $jMaZ8.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $jMaZ8.createElement((0, $8f9e5fedee2e9d08$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        prefix: prefix,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter,
        onInputBlur: onInputBlur
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $a350af2860be31e2$export$2e2bcd8739ae039), {
        visible: mockFocused && !mergedOpen,
        values: displayValues
    }), selectorNode, arrowNode, mergedAllowClear && clearNode);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $7ef519882a07e57d$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, renderNode);
});
$d9b36639a0b7be3f$var$BaseSelect.displayName = 'BaseSelect';
var $d9b36639a0b7be3f$export$2e2bcd8739ae039 = $d9b36639a0b7be3f$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $a0d60f95fee9f290$var$OptGroup = function OptGroup() {
    return null;
};
$a0d60f95fee9f290$var$OptGroup.isSelectOptGroup = true;
var $a0d60f95fee9f290$export$2e2bcd8739ae039 = $a0d60f95fee9f290$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $fa42b1ff8784fafa$var$Option = function Option() {
    return null;
};
$fa42b1ff8784fafa$var$Option.isSelectOption = true;
var $fa42b1ff8784fafa$export$2e2bcd8739ae039 = $fa42b1ff8784fafa$var$Option;



var $eq8kl = parcelRequire("eq8kl");

var $4b02Q = parcelRequire("4b02Q");

var $hH60s = parcelRequire("hH60s");

var $3fkx6 = parcelRequire("3fkx6");

var $fvBso = parcelRequire("fvBso");

var $giSak = parcelRequire("giSak");


var $hBgfL = parcelRequire("hBgfL");

var $hvG6u = parcelRequire("hvG6u");


var $hH60s = parcelRequire("hH60s");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");
parcelRequire("1CVs1");
var $ktS49 = parcelRequire("ktS49");

var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");

var $bAXx0 = parcelRequire("bAXx0");

var $giSak = parcelRequire("giSak");
/**
 * Fill component to provided the scroll content real height.
 */ var $960c9fcce000b487$var$Filler = /*#__PURE__*/ $jMaZ8.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = (0, $8u3qN.default)((0, $8u3qN.default)({}, innerStyle), {}, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((0, $eq8kl.default)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$960c9fcce000b487$var$Filler.displayName = 'Filler';
var $960c9fcce000b487$export$2e2bcd8739ae039 = $960c9fcce000b487$var$Filler;



var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
function $dd6a5370d559bc5a$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $jMaZ8.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $jMaZ8.cloneElement(children, {
        ref: refFunc
    });
}


function $8a06341a3c411cf5$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $dd6a5370d559bc5a$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $4173ee6c54804692$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $4173ee6c54804692$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $9015dc91d583cb7d$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $jMaZ8.useState(data), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(null), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $jMaZ8.useEffect(function() {
        var diff = (0, $4173ee6c54804692$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}



var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");

var $1Esi2 = parcelRequire("1Esi2");
var $2d8f74812713e225$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $1Esi2.default)(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
var $2d8f74812713e225$export$2e2bcd8739ae039 = $2d8f74812713e225$var$isFF;



var $jMaZ8 = parcelRequire("jMaZ8");
var $1a6ae184e7aa1683$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $jMaZ8.useRef)(false);
    var lockTimeoutRef = (0, $jMaZ8.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $jMaZ8.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $f2d9b4698dd4d7f7$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $jMaZ8.useRef)(0);
    var nextFrameRef = (0, $jMaZ8.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $jMaZ8.useRef)(null);
    var isMouseScrollRef = (0, $jMaZ8.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $1a6ae184e7aa1683$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $aZxvk.default).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $2d8f74812713e225$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $aZxvk.default)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $2d8f74812713e225$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $jMaZ8.useRef)(null);
    var wheelDirectionCleanRef = (0, $jMaZ8.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $aZxvk.default).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $aZxvk.default)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $30faf583bb00db40$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $jMaZ8.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $3fkx6.default)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}



var $3fkx6 = parcelRequire("3fkx6");

var $cYkhj = parcelRequire("cYkhj");

var $jMaZ8 = parcelRequire("jMaZ8");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");
// Firefox has low performance of map.
var $5b19571e741d8fbe$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $klxbl.default)(this, CacheMap);
        (0, $eq8kl.default)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $eq8kl.default)(this, "id", 0);
        (0, $eq8kl.default)(this, "diffKeys", new Set());
        this.maps = Object.create(null);
    }
    (0, $9O7LJ.default)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
                this.diffKeys.add(key);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        },
        {
            key: "resetRecord",
            value: function resetRecord() {
                this.diffKeys.clear();
            }
        },
        {
            key: "getRecord",
            value: function getRecord() {
                return this.diffKeys;
            }
        }
    ]);
    return CacheMap;
}();
var $5b19571e741d8fbe$export$2e2bcd8739ae039 = $5b19571e741d8fbe$var$CacheMap;


function $90b9962c0d15f02a$var$parseNumber(value) {
    var num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $90b9962c0d15f02a$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $jMaZ8.useState(0), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $jMaZ8.useRef)(new Map());
    var heightsRef = (0, $jMaZ8.useRef)(new (0, $5b19571e741d8fbe$export$2e2bcd8739ae039)());
    var promiseIdRef = (0, $jMaZ8.useRef)(0);
    function cancelRaf() {
        promiseIdRef.current += 1;
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            var changed = false;
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var htmlElement = (0, $cYkhj.default)(element);
                    var offsetHeight = htmlElement.offsetHeight;
                    var _getComputedStyle = getComputedStyle(htmlElement), marginTop = _getComputedStyle.marginTop, marginBottom = _getComputedStyle.marginBottom;
                    var marginTopNum = $90b9962c0d15f02a$var$parseNumber(marginTop);
                    var marginBottomNum = $90b9962c0d15f02a$var$parseNumber(marginBottom);
                    var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) {
                        heightsRef.current.set(key, totalHeight);
                        changed = true;
                    }
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            if (changed) setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else {
            promiseIdRef.current += 1;
            var id = promiseIdRef.current;
            Promise.resolve().then(function() {
                if (id === promiseIdRef.current) doCollect();
            });
        }
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $jMaZ8.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}



var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");
var $fb788a4f64f8ff3d$var$SMOOTH_PTG = 14 / 15;
function $fb788a4f64f8ff3d$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $jMaZ8.useRef)(false);
    var touchXRef = (0, $jMaZ8.useRef)(0);
    var touchYRef = (0, $jMaZ8.useRef)(0);
    var elementRef = (0, $jMaZ8.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $jMaZ8.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $fb788a4f64f8ff3d$var$SMOOTH_PTG;
                else offsetY *= $fb788a4f64f8ff3d$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $jLTp6.default)(function() {
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}




var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");
function $923c7d8f1c9e0a1e$var$smoothScrollOffset(offset) {
    return Math.floor(Math.pow(offset, 0.5));
}
function $923c7d8f1c9e0a1e$export$dbd0143e191dc2e5(e, horizontal) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function $923c7d8f1c9e0a1e$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $jMaZ8.useEffect(function() {
        var ele = componentRef.current;
        if (inVirtual && ele) {
            var mouseDownLock = false;
            var rafId;
            var _offset;
            var stopScroll = function stopScroll() {
                (0, $aZxvk.default).cancel(rafId);
            };
            var continueScroll = function continueScroll() {
                stopScroll();
                rafId = (0, $aZxvk.default)(function() {
                    onScrollOffset(_offset);
                    continueScroll();
                });
            };
            var onMouseDown = function onMouseDown(e) {
                // Skip if nest List has handled this event
                var event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            var onMouseUp = function onMouseUp() {
                mouseDownLock = false;
                stopScroll();
            };
            var onMouseMove = function onMouseMove(e) {
                if (mouseDownLock) {
                    var mouseY = $923c7d8f1c9e0a1e$export$dbd0143e191dc2e5(e, false);
                    var _ele$getBoundingClien = ele.getBoundingClientRect(), top = _ele$getBoundingClien.top, bottom = _ele$getBoundingClien.bottom;
                    if (mouseY <= top) {
                        var diff = top - mouseY;
                        _offset = -$923c7d8f1c9e0a1e$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        var _diff = mouseY - bottom;
                        _offset = $923c7d8f1c9e0a1e$var$smoothScrollOffset(_diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener('mousedown', onMouseDown);
            ele.ownerDocument.addEventListener('mouseup', onMouseUp);
            ele.ownerDocument.addEventListener('mousemove', onMouseMove);
            return function() {
                ele.removeEventListener('mousedown', onMouseDown);
                ele.ownerDocument.removeEventListener('mouseup', onMouseUp);
                ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}



var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $aZxvk = parcelRequire("aZxvk");

var $jLTp6 = parcelRequire("jLTp6");
parcelRequire("1CVs1");
var $2bFmQ = parcelRequire("2bFmQ");
var $464f8edb03d8ae4b$var$MAX_TIMES = 10;
function $464f8edb03d8ae4b$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $jMaZ8.useRef();
    var _React$useState = $jMaZ8.useState(null), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $jLTp6.default)(function() {
        if (syncState && syncState.times < $464f8edb03d8ae4b$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $8u3qN.default)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = 'top';
                        else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $8u3qN.default)((0, $8u3qN.default)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        } else if ((syncState === null || syncState === void 0 ? void 0 : syncState.times) === $464f8edb03d8ae4b$var$MAX_TIMES) (0, $2bFmQ.default)(false, 'Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.');
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $aZxvk.default).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && (0, $1Esi2.default)(arg) === 'object') {
            var index;
            var align = arg.align;
            if ('index' in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}



var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $aZxvk = parcelRequire("aZxvk");

var $jMaZ8 = parcelRequire("jMaZ8");

var $04a5615fba40bd49$var$ScrollBar = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle, showScrollBar = props.showScrollBar;
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(null), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $jMaZ8.useState(null), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $jMaZ8.useRef();
    var thumbRef = $jMaZ8.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $jMaZ8.useState(showScrollBar), _React$useState8 = (0, $3fkx6.default)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $jMaZ8.useRef();
    var delayHidden = function delayHidden() {
        if (showScrollBar === true || showScrollBar === false) return;
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $jMaZ8.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $jMaZ8.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY((0, $923c7d8f1c9e0a1e$export$dbd0143e191dc2e5)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $jMaZ8.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $jMaZ8.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $jMaZ8.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $jMaZ8.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $aZxvk.default).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ((0, $923c7d8f1c9e0a1e$export$dbd0143e191dc2e5)(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $aZxvk.default)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $aZxvk.default).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $jMaZ8.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    var thumbStyle = {
        position: 'absolute',
        background: 'rgba(0, 0, 0, 0.5)',
        borderRadius: 99,
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = '100%';
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = '100%';
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(scrollbarPrefixCls, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $eq8kl.default)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
$04a5615fba40bd49$var$ScrollBar.displayName = 'ScrollBar';
var $04a5615fba40bd49$export$2e2bcd8739ae039 = $04a5615fba40bd49$var$ScrollBar;


var $56df143fc141adb1$var$MIN_SIZE = 20;
function $56df143fc141adb1$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $56df143fc141adb1$var$MIN_SIZE);
    return Math.floor(baseSize);
}


var $1dd5425265b50efc$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles",
    "showScrollBar"
];
var $1dd5425265b50efc$var$EMPTY_DATA = [];
var $1dd5425265b50efc$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $1dd5425265b50efc$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, _props$showScrollBar = props.showScrollBar, showScrollBar = _props$showScrollBar === void 0 ? 'optional' : _props$showScrollBar, restProps = (0, $4b02Q.default)(props, $1dd5425265b50efc$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $jMaZ8.useCallback(function(item) {
        if (typeof itemKey === 'function') return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $90b9962c0d15f02a$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $3fkx6.default)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $jMaZ8.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === 'rtl';
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, (0, $eq8kl.default)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $1dd5425265b50efc$var$EMPTY_DATA;
    var componentRef = (0, $jMaZ8.useRef)();
    var fillerInnerRef = (0, $jMaZ8.useRef)();
    var containerRef = (0, $jMaZ8.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $jMaZ8.useState)(0), _useState2 = (0, $3fkx6.default)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $jMaZ8.useState)(0), _useState4 = (0, $3fkx6.default)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $jMaZ8.useState)(false), _useState6 = (0, $3fkx6.default)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $jMaZ8.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $jMaZ8.useRef)();
    var _useDiffItem = (0, $9015dc91d583cb7d$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $3fkx6.default)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $jMaZ8.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // When scroll up, first visible item get real height may not same as `itemHeight`,
    // Which will make scroll jump.
    // Let's sync scroll top to avoid jump
    $jMaZ8.useLayoutEffect(function() {
        var changedRecord = heights.getRecord();
        if (changedRecord.size === 1) {
            var recordKey = Array.from(changedRecord)[0];
            var startIndexKey = getKey(mergedData[start]);
            if (startIndexKey === recordKey) {
                var realStartHeight = heights.get(recordKey);
                var diffHeight = realStartHeight - itemHeight;
                syncScrollTop(function(ori) {
                    return ori + diffHeight;
                });
            }
        }
        heights.resetRecord();
    }, [
        scrollHeight
    ]);
    // ================================= Size =================================
    var _React$useState = $jMaZ8.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $jMaZ8.useRef)();
    var horizontalScrollBarRef = (0, $jMaZ8.useRef)();
    var horizontalScrollBarSpinSize = $jMaZ8.useMemo(function() {
        return (0, $56df143fc141adb1$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $jMaZ8.useMemo(function() {
        return (0, $56df143fc141adb1$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $jMaZ8.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $1a6ae184e7aa1683$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $jMaZ8.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $ktS49.default)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $8u3qN.default)((0, $8u3qN.default)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $6UWRi.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $ktS49.default)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            (0, $6UWRi.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $f2d9b4698dd4d7f7$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $3fkx6.default)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $fb788a4f64f8ff3d$export$2e2bcd8739ae039)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset, e) {
        var event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault: function preventDefault() {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $923c7d8f1c9e0a1e$export$2e2bcd8739ae039)(inVirtual, componentRef, function(offset) {
        syncScrollTop(function(top) {
            return top + offset;
        });
    });
    (0, $jLTp6.default)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $jLTp6.default)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $464f8edb03d8ae4b$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $1Esi2.default)(arg) === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $jLTp6.default)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $30faf583bb00db40$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $8a06341a3c411cf5$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $8u3qN.default)((0, $eq8kl.default)({}, fullHeight ? 'height' : 'maxHeight', height), $1dd5425265b50efc$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        ref: containerRef,
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, style), {}, {
            position: 'relative'
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $jMaZ8.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $960c9fcce000b487$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $jMaZ8.createElement((0, $04a5615fba40bd49$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb,
        showScrollBar: showScrollBar
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $jMaZ8.createElement((0, $04a5615fba40bd49$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb,
        showScrollBar: showScrollBar
    }));
}
var $1dd5425265b50efc$var$List = /*#__PURE__*/ $jMaZ8.forwardRef($1dd5425265b50efc$export$cc3be4e46e8486ed);
$1dd5425265b50efc$var$List.displayName = 'List';
var $1dd5425265b50efc$export$2e2bcd8739ae039 = $1dd5425265b50efc$var$List;


var $d69541228a77891f$export$2e2bcd8739ae039 = (0, $1dd5425265b50efc$export$2e2bcd8739ae039);



var $jMaZ8 = parcelRequire("jMaZ8");



/* istanbul ignore file */ function $dd45fdad9cdd08ed$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



var $53518e6df36a40ba$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $53518e6df36a40ba$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $53518e6df36a40ba$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $7ef519882a07e57d$export$2e2bcd8739ae039)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $jMaZ8.useContext((0, $9f601c14a2948b0b$export$2e2bcd8739ae039)), maxCount = _React$useContext.maxCount, flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, direction = _React$useContext.direction, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, optionRender = _React$useContext.optionRender;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $hBgfL.default)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $jMaZ8.useRef(null);
    var overMaxCount = $jMaZ8.useMemo(function() {
        return multiple && (0, $ec3aff0dba75cb6e$export$be48fd776273e509)(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount;
    }, [
        multiple,
        maxCount,
        rawValues === null || rawValues === void 0 ? void 0 : rawValues.size
    ]);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        var _listRef$current;
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $jMaZ8.useCallback(function(value) {
        if (mode === 'combobox') return false;
        return rawValues.has(value);
    }, [
        mode,
        (0, $fvBso.default)(rawValues).toString(),
        rawValues.size
    ]);
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _ref = memoFlattenOptions[current] || {}, group = _ref.group, data = _ref.data;
            if (!group && !(data !== null && data !== void 0 && data.disabled) && (isSelected(data.value) || !overMaxCount)) return current;
        }
        return -1;
    };
    var _React$useState = $jMaZ8.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $jMaZ8.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/48036
    var isAriaSelected = $jMaZ8.useCallback(function(value) {
        if (mode === 'combobox') return String(value).toLowerCase() === searchValue.toLowerCase();
        return rawValues.has(value);
    }, [
        mode,
        searchValue,
        (0, $fvBso.default)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $jMaZ8.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                var index = memoFlattenOptions.findIndex(function(_ref2) {
                    var data = _ref2.data;
                    return data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).N:
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).P:
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP:
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN:
                        var offset = 0;
                        if (which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP) offset = -1;
                        else if (which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN) offset = 1;
                        else if ((0, $dd45fdad9cdd08ed$export$3bbcfec016973a77)() && ctrlKey) {
                            if (which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).N) offset = 1;
                            else if (which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select (Tab / Enter)
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).TAB:
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER:
                        var _item$data;
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !(item !== null && item !== void 0 && (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled) && !overMaxCount) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $jMaZ8.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    function getItemAriaProps(item, index) {
        var group = item.group;
        return {
            role: group ? 'presentation' : 'option',
            id: "".concat(id, "_list_").concat(index)
        };
    }
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isAriaSelected(value)
        }), value) : null;
    };
    var a11yProps = {
        role: 'listbox',
        id: "".concat(id, "_list")
    };
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, virtual && /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $jMaZ8.createElement((0, $d69541228a77891f$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps
    }, function(item, itemIndex) {
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $53518e6df36a40ba$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $jMaZ8.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(itemPrefixCls, "".concat(itemPrefixCls, "-group"), data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $4b02Q.default)(data, $53518e6df36a40ba$var$_excluded);
        var passedProps = (0, $hvG6u.default)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var mergedDisabled = disabled || !selected && overMaxCount;
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(itemPrefixCls, optionPrefixCls, className, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(optionPrefixCls, "-grouped"), groupOption), "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !mergedDisabled), "".concat(optionPrefixCls, "-disabled"), mergedDisabled), "".concat(optionPrefixCls, "-selected"), selected));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $53518e6df36a40ba$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({}, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": isAriaSelected(value),
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!mergedDisabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, typeof optionRender === 'function' ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $jMaZ8.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $jMaZ8.createElement((0, $f538d52946440c39$export$2e2bcd8739ae039), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $53518e6df36a40ba$var$RefOptionList = /*#__PURE__*/ $jMaZ8.forwardRef($53518e6df36a40ba$var$OptionList);
$53518e6df36a40ba$var$RefOptionList.displayName = 'OptionList';
var $53518e6df36a40ba$export$2e2bcd8739ae039 = $53518e6df36a40ba$var$RefOptionList;




var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
var /**
 * Cache `value` related LabeledValue & options.
 */ $1a9e3dafc2a1ae54$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $jMaZ8.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $jMaZ8.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $8u3qN.default)((0, $8u3qN.default)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $jMaZ8.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};



var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");


function $537f27f33ab53309$var$includes(test, search) {
    return (0, $4339bba5d7f527a0$export$45b10814cc054894)(test).join('').toUpperCase().includes(search);
}
var $537f27f33ab53309$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $jMaZ8.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === 'function';
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $537f27f33ab53309$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $537f27f33ab53309$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $537f27f33ab53309$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function(opt) {
            return (0, $ec3aff0dba75cb6e$export$d0b21b213c8c013c)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $8u3qN.default)((0, $8u3qN.default)({}, item), {}, (0, $eq8kl.default)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
parcelRequire("h9ujZ");
var $94908389367d1be5$var$uuid = 0;
var $94908389367d1be5$export$df7146797a248522 = false;
function $94908389367d1be5$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($94908389367d1be5$export$df7146797a248522) {
        retId = $94908389367d1be5$var$uuid;
        $94908389367d1be5$var$uuid += 1;
    } else retId = 'TEST_OR_SSR';
    return retId;
}
function $94908389367d1be5$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $jMaZ8.useState(), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $jMaZ8.useEffect(function() {
        setInnerId("rc_select_".concat($94908389367d1be5$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}



var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $a6yuN = parcelRequire("a6yuN");
var $7c73b30c094f8432$var$_excluded = [
    "children",
    "value"
], $7c73b30c094f8432$var$_excluded2 = [
    "children"
];
function $7c73b30c094f8432$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $4b02Q.default)(_ref$props, $7c73b30c094f8432$var$_excluded);
    return (0, $8u3qN.default)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $7c73b30c094f8432$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $a6yuN.default)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $jMaZ8.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $4b02Q.default)(_ref2$props, $7c73b30c094f8432$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $7c73b30c094f8432$var$convertNodeToOption(node);
        return (0, $8u3qN.default)((0, $8u3qN.default)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $7c73b30c094f8432$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ var $0f7f0daf0b9ef3f2$var$useOptions = function useOptions(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $jMaZ8.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $7c73b30c094f8432$export$3beca35db74c3985)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        var dig = function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $0f7f0daf0b9ef3f2$export$2e2bcd8739ae039 = $0f7f0daf0b9ef3f2$var$useOptions;



var $jMaZ8 = parcelRequire("jMaZ8");
function $9795002da4cbe4d8$export$2e2bcd8739ae039(callback) {
    var funcRef = $jMaZ8.useRef();
    funcRef.current = callback;
    var cacheFn = $jMaZ8.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}





var $1Esi2 = parcelRequire("1Esi2");

var $a6yuN = parcelRequire("a6yuN");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");



function $f83df2c700abe6d3$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $d9b36639a0b7be3f$export$7f654ad2a77ad2ac)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    var mergedOptions = options || (0, $7c73b30c094f8432$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $2bFmQ.default)(mode !== 'tags' || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ('value' in opt ? opt.value : opt.key) === 'number';
            });
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $2bFmQ.default)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $2bFmQ.default)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $2bFmQ.default)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $2bFmQ.default)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $2bFmQ.noteOnce)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $2bFmQ.default)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $2bFmQ.noteOnce)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        var values = (0, $4339bba5d7f527a0$export$45b10814cc054894)(value);
        (0, $2bFmQ.default)(!labelInValue || values.every(function(val) {
            return (0, $1Esi2.default)(val) === 'object' && ('key' in val || 'value' in val);
        }), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $2bFmQ.default)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $a6yuN.default)(children).some(function(node) {
            if (!/*#__PURE__*/ $jMaZ8.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $a6yuN.default)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $jMaZ8.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $2bFmQ.default)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $2bFmQ.default)(inputValue === undefined, '`inputValue` is deprecated, please use `searchValue` instead.');
    }
}
function $f83df2c700abe6d3$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $2bFmQ.default)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $f83df2c700abe6d3$export$2e2bcd8739ae039 = $f83df2c700abe6d3$var$warningProps;


var $1dbc3b904685164c$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "optionRender",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "direction",
    "listHeight",
    "listItemHeight",
    "labelRender",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange",
    "maxCount"
];
var $1dbc3b904685164c$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $1dbc3b904685164c$var$isRawValue(value) {
    return !value || (0, $1Esi2.default)(value) !== 'object';
}
var $1dbc3b904685164c$var$Select = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-select' : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, optionRender = props.optionRender, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, direction = props.direction, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, labelRender = props.labelRender, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, maxCount = props.maxCount, restProps = (0, $4b02Q.default)(props, $1dbc3b904685164c$var$_excluded);
    var mergedId = (0, $94908389367d1be5$export$2e2bcd8739ae039)(id);
    var multiple = (0, $d9b36639a0b7be3f$export$7f654ad2a77ad2ac)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $jMaZ8.useMemo(function() {
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $jMaZ8.useMemo(function() {
        return (0, $ec3aff0dba75cb6e$export$6c519d302dced239)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $eGh7a.default)('', {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || '';
        }
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $0f7f0daf0b9ef3f2$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $jMaZ8.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $4339bba5d7f527a0$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($1dbc3b904685164c$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                // Warning if label not same as provided
                if (!optionLabelProp) {
                    var optionLabel = option === null || option === void 0 ? void 0 : option[mergedFieldNames.label];
                    if (optionLabel !== undefined && !/*#__PURE__*/ $jMaZ8.isValidElement(optionLabel) && !/*#__PURE__*/ $jMaZ8.isValidElement(rawLabel) && optionLabel !== rawLabel) (0, $2bFmQ.default)(false, '`label` of `value` is not same as `label` in Select options.');
                }
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $eGh7a.default)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $3fkx6.default)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $jMaZ8.useMemo(function() {
        var _values$;
        var newInternalValue = multiple && internalValue === null ? [] : internalValue;
        var values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === 'combobox' && (0, $4339bba5d7f527a0$export$9d186c3672bb89c6)((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $1a9e3dafc2a1ae54$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions), _useCache2 = (0, $3fkx6.default)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $jMaZ8.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _ref;
            return (0, $8u3qN.default)((0, $8u3qN.default)({}, item), {}, {
                label: (_ref = typeof labelRender === 'function' ? labelRender(item) : item.label) !== null && _ref !== void 0 ? _ref : item.value
            });
        });
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $jMaZ8.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $jMaZ8.useEffect(function() {
        if (mode === 'combobox') {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $4339bba5d7f527a0$export$96bdbc84526f3739)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $9795002da4cbe4d8$export$2e2bcd8739ae039)(function(val, label) {
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return (0, $eq8kl.default)((0, $eq8kl.default)({}, mergedFieldNames.value, val), mergedFieldNames.label, mergedLabel);
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $jMaZ8.useMemo(function() {
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $fvBso.default)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $fvBso.default)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $537f27f33ab53309$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $jMaZ8.useMemo(function() {
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || 'value'] === mergedSearchValue;
        })) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some(function(item) {
            return item[mergedFieldNames.value] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $fvBso.default)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    var sorter = function sorter(inputOptions) {
        var sortedOptions = (0, $fvBso.default)(inputOptions).sort(function(a, b) {
            return filterSort(a, b, {
                searchValue: mergedSearchValue
            });
        });
        return sortedOptions.map(function(item) {
            if (Array.isArray(item.options)) return (0, $8u3qN.default)((0, $8u3qN.default)({}, item), {}, {
                options: item.options.length > 0 ? sorter(item.options) : item.options
            });
            return item;
        });
    };
    var orderedFilteredOptions = $jMaZ8.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return sorter(filledSearchOptions);
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    var displayOptions = $jMaZ8.useMemo(function() {
        return (0, $ec3aff0dba75cb6e$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $ec3aff0dba75cb6e$export$d0b21b213c8c013c)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $jMaZ8.useState(null), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(0), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    var onActiveValue = $jMaZ8.useCallback(function(active, index) {
        var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? 'keyboard' : _ref3$source;
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $ec3aff0dba75cb6e$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $3fkx6.default)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== 'clear') {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $3fkx6.default)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $9795002da4cbe4d8$export$2e2bcd8739ae039)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $fvBso.default)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') // setSearchValue(String(val));
        setActiveValue('');
        else if (!(0, $d9b36639a0b7be3f$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === 'remove' || type === 'clear') values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            var formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $fvBso.default)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== 'tags') patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $fvBso.default)(rawValues), (0, $fvBso.default)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $jMaZ8.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender
        });
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender
    ]);
    (0, $f83df2c700abe6d3$export$2e2bcd8739ae039)(props);
    (0, $f83df2c700abe6d3$export$c33a1be4de1ec2c)(mergedOptions, mergedFieldNames);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $9f601c14a2948b0b$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $d9b36639a0b7be3f$export$2e2bcd8739ae039), (0, $hH60s.default)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $1dbc3b904685164c$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        direction: direction,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $53518e6df36a40ba$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
$1dbc3b904685164c$var$Select.displayName = 'Select';
var $1dbc3b904685164c$var$TypedSelect = $1dbc3b904685164c$var$Select;
$1dbc3b904685164c$var$TypedSelect.Option = (0, $fa42b1ff8784fafa$export$2e2bcd8739ae039);
$1dbc3b904685164c$var$TypedSelect.OptGroup = (0, $a0d60f95fee9f290$export$2e2bcd8739ae039);
var $1dbc3b904685164c$export$2e2bcd8739ae039 = $1dbc3b904685164c$var$TypedSelect;






var $0c275de2b003b545$export$2e2bcd8739ae039 = (0, $1dbc3b904685164c$export$2e2bcd8739ae039);



var $hvG6u = parcelRequire("hvG6u");







var $jMaZ8 = parcelRequire("jMaZ8");


"use client";
const $4de21af32a83dbc2$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('empty');
    switch(componentName){
        case 'Table':
        case 'List':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $2e81825c370cda5d$export$2e2bcd8739ae039), {
                image: (0, $2e81825c370cda5d$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $2e81825c370cda5d$export$2e2bcd8739ae039), {
                image: (0, $2e81825c370cda5d$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */ case 'Table.filter':
            // why `null`? legacy react16 node type `undefined` is not allowed.
            return null;
        default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $2e81825c370cda5d$export$2e2bcd8739ae039), null);
    }
};
var $4de21af32a83dbc2$export$2e2bcd8739ae039 = $4de21af32a83dbc2$var$DefaultRenderEmpty;









const $0b0bd736996a12a7$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ]
        }),
        bottomRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ]
        }),
        topLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ]
        }),
        topRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ]
        })
    };
};
function $0b0bd736996a12a7$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $0b0bd736996a12a7$var$getBuiltInPlacements(popupOverflow);
}
var $0b0bd736996a12a7$export$2e2bcd8739ae039 = $0b0bd736996a12a7$var$mergedBuiltinPlacements;




parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");

parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

const $d516976ac142085d$export$c81b62e088da1305 = new (0, $kB90R.default)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $d516976ac142085d$export$6c1eca72ac4f6672 = new (0, $kB90R.default)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $d516976ac142085d$export$8dd54688d033571 = new (0, $kB90R.default)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $d516976ac142085d$export$be161c4e647bea9b = new (0, $kB90R.default)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $d516976ac142085d$export$a984c43131c7d145 = new (0, $kB90R.default)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $d516976ac142085d$export$e141ac6798b476df = new (0, $kB90R.default)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $d516976ac142085d$export$ab676201eaaca05 = new (0, $kB90R.default)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $d516976ac142085d$export$ec1b91b8ec2f6331 = new (0, $kB90R.default)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $d516976ac142085d$var$moveMotion = {
    'move-up': {
        inKeyframes: $d516976ac142085d$export$ab676201eaaca05,
        outKeyframes: $d516976ac142085d$export$ec1b91b8ec2f6331
    },
    'move-down': {
        inKeyframes: $d516976ac142085d$export$c81b62e088da1305,
        outKeyframes: $d516976ac142085d$export$6c1eca72ac4f6672
    },
    'move-left': {
        inKeyframes: $d516976ac142085d$export$8dd54688d033571,
        outKeyframes: $d516976ac142085d$export$be161c4e647bea9b
    },
    'move-right': {
        inKeyframes: $d516976ac142085d$export$a984c43131c7d145,
        outKeyframes: $d516976ac142085d$export$e141ac6798b476df
    }
};
const $d516976ac142085d$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $d516976ac142085d$var$moveMotion[motionName];
    return [
        (0, $7d04c31aa62562e0$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};


const $33b4d22d18e9bfe9$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: 'relative',
        display: 'block',
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: 'normal',
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: 'border-box'
    };
};
const $33b4d22d18e9bfe9$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    const selectedItemCls = `${selectItemCls}-option-selected`;
    return [
        {
            [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                position: 'absolute',
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: 'border-box',
                padding: token.paddingXXS,
                overflow: 'hidden',
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: 'initial',
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $a33dc8ffa22f5459$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $a33dc8ffa22f5459$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $a33dc8ffa22f5459$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $a33dc8ffa22f5459$export$f7243fdb9c27c3b7)
                },
                '&-hidden': {
                    display: 'none'
                },
                [selectItemCls]: Object.assign(Object.assign({}, $33b4d22d18e9bfe9$var$genItemStyle(token)), {
                    cursor: 'pointer',
                    transition: `background ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    '&-group': {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: 'default'
                    },
                    // =========== Option ===========
                    '&-option': {
                        display: 'flex',
                        '&-content': Object.assign({
                            flex: 'auto'
                        }, (0, $134f73cf3485ce91$export$b2b65df0d0824629)),
                        '&-state': {
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center'
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        '&-disabled': {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: 'not-allowed'
                        },
                        '&-grouped': {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    '&-empty': Object.assign(Object.assign({}, $33b4d22d18e9bfe9$var$genItemStyle(token)), {
                        color: token.colorTextDisabled
                    })
                }),
                // https://github.com/ant-design/ant-design/pull/46646
                [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0,
                    [`& + ${selectedItemCls}`]: {
                        borderStartStartRadius: 0,
                        borderStartEndRadius: 0
                    }
                },
                // =========================== RTL ===========================
                '&-rtl': {
                    direction: 'rtl'
                }
            })
        },
        // Follow code may reuse in other components
        (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(token, 'slide-up'),
        (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(token, 'slide-down'),
        (0, $d516976ac142085d$export$913b1b7e3288c319)(token, 'move-up'),
        (0, $d516976ac142085d$export$913b1b7e3288c319)(token, 'move-down')
    ];
};
var $33b4d22d18e9bfe9$export$2e2bcd8739ae039 = $33b4d22d18e9bfe9$var$genSingleStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $b1604fbc0356803b$export$aaa3604bfe071829 = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, paddingXXS: paddingXXS, lineWidth: lineWidth, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const basePadding = token.max(token.calc(paddingXXS).sub(lineWidth).equal(), 0);
    const containerPadding = token.max(token.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
    return {
        basePadding: basePadding,
        containerPadding: containerPadding,
        itemHeight: (0, $4g3I0.unit)(multipleSelectItemHeight),
        itemLineHeight: (0, $4g3I0.unit)(token.calc(multipleSelectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal())
    };
};
const $b1604fbc0356803b$var$getSelectItemStyle = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, selectHeight: selectHeight, lineWidth: lineWidth } = token;
    const selectItemDist = token.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
    return selectItemDist;
};
const $b1604fbc0356803b$export$b4ab9d1500d7d856 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, borderRadiusSM: borderRadiusSM, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, multipleItemColorDisabled: multipleItemColorDisabled, multipleItemBorderColorDisabled: multipleItemBorderColorDisabled, colorIcon: colorIcon, colorIconHover: colorIconHover, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    return {
        /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */ // =========================== Overflow ===========================
        [selectOverflowPrefixCls]: {
            position: 'relative',
            display: 'flex',
            flex: 'auto',
            flexWrap: 'wrap',
            maxWidth: '100%',
            '&-item': {
                flex: 'none',
                alignSelf: 'center',
                maxWidth: '100%',
                display: 'inline-flex'
            },
            // ======================== Selections ==========================
            [`${componentCls}-selection-item`]: {
                display: 'flex',
                alignSelf: 'center',
                flex: 'none',
                boxSizing: 'border-box',
                maxWidth: '100%',
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                borderRadius: borderRadiusSM,
                cursor: 'default',
                transition: `font-size ${motionDurationSlow}, line-height ${motionDurationSlow}, height ${motionDurationSlow}`,
                marginInlineEnd: token.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                paddingInlineStart: paddingXS,
                paddingInlineEnd: token.calc(paddingXS).div(2).equal(),
                [`${componentCls}-disabled&`]: {
                    color: multipleItemColorDisabled,
                    borderColor: multipleItemBorderColorDisabled,
                    cursor: 'not-allowed'
                },
                // It's ok not to do this, but 24px makes bottom narrow in view should adjust
                '&-content': {
                    display: 'inline-block',
                    marginInlineEnd: token.calc(paddingXS).div(2).equal(),
                    overflow: 'hidden',
                    whiteSpace: 'pre',
                    // fix whitespace wrapping. custom tags display all whitespace within.
                    textOverflow: 'ellipsis'
                },
                '&-remove': Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$171ccda7bc085e59)()), {
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: colorIcon,
                    fontWeight: 'bold',
                    fontSize: 10,
                    lineHeight: 'inherit',
                    cursor: 'pointer',
                    [`> ${iconCls}`]: {
                        verticalAlign: '-0.2em'
                    },
                    '&:hover': {
                        color: colorIconHover
                    }
                })
            }
        }
    };
};
const $b1604fbc0356803b$var$genSelectionStyle = (token, suffix)=>{
    const { componentCls: componentCls, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    const selectItemHeight = token.multipleSelectItemHeight;
    const selectItemDist = $b1604fbc0356803b$var$getSelectItemStyle(token);
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    const multipleSelectorUnit = $b1604fbc0356803b$export$aaa3604bfe071829(token);
    return {
        [`${componentCls}-multiple${suffixCls}`]: Object.assign(Object.assign({}, $b1604fbc0356803b$export$b4ab9d1500d7d856(token)), {
            // ========================= Selector =========================
            [`${componentCls}-selector`]: {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                // Multiple is little different that horizontal is follow the vertical
                paddingInline: multipleSelectorUnit.basePadding,
                paddingBlock: multipleSelectorUnit.containerPadding,
                borderRadius: token.borderRadius,
                [`${componentCls}-disabled&`]: {
                    background: token.multipleSelectorBgDisabled,
                    cursor: 'not-allowed'
                },
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    margin: `${(0, $4g3I0.unit)(INTERNAL_FIXED_ITEM_MARGIN)} 0`,
                    lineHeight: (0, $4g3I0.unit)(selectItemHeight),
                    visibility: 'hidden',
                    content: '"\\a0"'
                }
            },
            // ======================== Selections ========================
            [`${componentCls}-selection-item`]: {
                height: multipleSelectorUnit.itemHeight,
                lineHeight: (0, $4g3I0.unit)(multipleSelectorUnit.itemLineHeight)
            },
            // ========================== Wrap ===========================
            [`${componentCls}-selection-wrap`]: {
                alignSelf: 'flex-start',
                '&:after': {
                    lineHeight: (0, $4g3I0.unit)(selectItemHeight),
                    marginBlock: INTERNAL_FIXED_ITEM_MARGIN
                }
            },
            // ========================== Input ==========================
            [`${componentCls}-prefix`]: {
                marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal()
            },
            [`${selectOverflowPrefixCls}-item + ${selectOverflowPrefixCls}-item,
        ${componentCls}-prefix + ${componentCls}-selection-wrap
      `]: {
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 0
                },
                [`${componentCls}-selection-placeholder`]: {
                    insetInlineStart: 0
                }
            },
            // https://github.com/ant-design/ant-design/issues/44754
            // Same as `wrap:after`
            [`${selectOverflowPrefixCls}-item-suffix`]: {
                minHeight: multipleSelectorUnit.itemHeight,
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN
            },
            [`${componentCls}-selection-search`]: {
                display: 'inline-flex',
                position: 'relative',
                maxWidth: '100%',
                marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(selectItemDist).equal(),
                [`
          &-input,
          &-mirror
        `]: {
                    height: selectItemHeight,
                    fontFamily: token.fontFamily,
                    lineHeight: (0, $4g3I0.unit)(selectItemHeight),
                    transition: `all ${token.motionDurationSlow}`
                },
                '&-input': {
                    width: '100%',
                    minWidth: 4.1 // fix search cursor missing
                },
                '&-mirror': {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    insetInlineEnd: 'auto',
                    zIndex: 999,
                    whiteSpace: 'pre',
                    // fix whitespace wrapping caused width calculation bug
                    visibility: 'hidden'
                }
            },
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal(),
                insetInlineEnd: token.inputPaddingHorizontalBase,
                transform: 'translateY(-50%)',
                transition: `all ${token.motionDurationSlow}`
            }
        })
    };
};
function $b1604fbc0356803b$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls } = token;
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    const rawStyle = {
        [`${componentCls}-multiple${suffixCls}`]: {
            fontSize: token.fontSize,
            // ========================= Selector =========================
            [`${componentCls}-selector`]: {
                [`${componentCls}-show-search&`]: {
                    cursor: 'text'
                }
            },
            [`
        &${componentCls}-show-arrow ${componentCls}-selector,
        &${componentCls}-allow-clear ${componentCls}-selector
      `]: {
                paddingInlineEnd: token.calc(token.fontSizeIcon).add(token.controlPaddingHorizontal).equal()
            }
        }
    };
    return [
        $b1604fbc0356803b$var$genSelectionStyle(token, suffix),
        rawStyle
    ];
}
const $b1604fbc0356803b$var$genMultipleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const smallToken = (0, $8APUt.merge)(token, {
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.multipleItemHeightSM,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS
    });
    const largeToken = (0, $8APUt.merge)(token, {
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius
    });
    return [
        $b1604fbc0356803b$var$genSizeStyle(token),
        // ======================== Small ========================
        $b1604fbc0356803b$var$genSizeStyle(smallToken, 'sm'),
        // Padding
        {
            [`${componentCls}-multiple${componentCls}-sm`]: {
                [`${componentCls}-selection-placeholder`]: {
                    insetInline: token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal()
                },
                // https://github.com/ant-design/ant-design/issues/29559
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 2 // Magic Number
                }
            }
        },
        // ======================== Large ========================
        $b1604fbc0356803b$var$genSizeStyle(largeToken, 'lg')
    ];
};
var $b1604fbc0356803b$export$2e2bcd8739ae039 = $b1604fbc0356803b$var$genMultipleStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
function $f74f5f77aab76f05$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, borderRadius: borderRadius } = token;
    const selectHeightWithoutBorder = token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal();
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    return {
        [`${componentCls}-single${suffixCls}`]: {
            fontSize: token.fontSize,
            height: token.controlHeight,
            // ========================= Selector =========================
            [`${componentCls}-selector`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token, true)), {
                display: 'flex',
                borderRadius: borderRadius,
                flex: '1 1 auto',
                [`${componentCls}-selection-search`]: {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    '&-input': {
                        width: '100%',
                        WebkitAppearance: 'textfield'
                    }
                },
                [`
          ${componentCls}-selection-item,
          ${componentCls}-selection-placeholder
        `]: {
                    display: 'block',
                    padding: 0,
                    lineHeight: (0, $4g3I0.unit)(selectHeightWithoutBorder),
                    transition: `all ${token.motionDurationSlow}, visibility 0s`,
                    alignSelf: 'center'
                },
                [`${componentCls}-selection-placeholder`]: {
                    transition: 'none',
                    pointerEvents: 'none'
                },
                // For common baseline align
                [[
                    '&:after',
                    /* For '' value baseline align */ `${componentCls}-selection-item:empty:after`,
                    /* For undefined value baseline align */ `${componentCls}-selection-placeholder:empty:after`
                ].join(',')]: {
                    display: 'inline-block',
                    width: 0,
                    visibility: 'hidden',
                    content: '"\\a0"'
                }
            }),
            [`
        &${componentCls}-show-arrow ${componentCls}-selection-item,
        &${componentCls}-show-arrow ${componentCls}-selection-search,
        &${componentCls}-show-arrow ${componentCls}-selection-placeholder
      `]: {
                paddingInlineEnd: token.showArrowPaddingInlineEnd
            },
            // Opacity selection if open
            [`&${componentCls}-open ${componentCls}-selection-item`]: {
                color: token.colorTextPlaceholder
            },
            // ========================== Input ==========================
            // We only change the style of non-customize input which is only support by `combobox` mode.
            // Not customize
            [`&:not(${componentCls}-customize-input)`]: {
                [`${componentCls}-selector`]: {
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    padding: `0 ${(0, $4g3I0.unit)(inputPaddingHorizontalBase)}`,
                    [`${componentCls}-selection-search-input`]: {
                        height: selectHeightWithoutBorder
                    },
                    '&:after': {
                        lineHeight: (0, $4g3I0.unit)(selectHeightWithoutBorder)
                    }
                }
            },
            [`&${componentCls}-customize-input`]: {
                [`${componentCls}-selector`]: {
                    '&:after': {
                        display: 'none'
                    },
                    [`${componentCls}-selection-search`]: {
                        position: 'static',
                        width: '100%'
                    },
                    [`${componentCls}-selection-placeholder`]: {
                        position: 'absolute',
                        insetInlineStart: 0,
                        insetInlineEnd: 0,
                        padding: `0 ${(0, $4g3I0.unit)(inputPaddingHorizontalBase)}`,
                        '&:after': {
                            display: 'none'
                        }
                    }
                }
            }
        }
    };
}
function $f74f5f77aab76f05$export$2e2bcd8739ae039(token) {
    const { componentCls: componentCls } = token;
    const inputPaddingHorizontalSM = token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal();
    return [
        $f74f5f77aab76f05$var$genSizeStyle(token),
        // ======================== Small ========================
        // Shared
        $f74f5f77aab76f05$var$genSizeStyle((0, $8APUt.merge)(token, {
            controlHeight: token.controlHeightSM,
            borderRadius: token.borderRadiusSM
        }), 'sm'),
        // padding
        {
            [`${componentCls}-single${componentCls}-sm`]: {
                [`&:not(${componentCls}-customize-input)`]: {
                    [`${componentCls}-selector`]: {
                        padding: `0 ${(0, $4g3I0.unit)(inputPaddingHorizontalSM)}`
                    },
                    // With arrow should provides `padding-right` to show the arrow
                    [`&${componentCls}-show-arrow ${componentCls}-selection-search`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalSM).add(token.calc(token.fontSize).mul(1.5)).equal()
                    },
                    [`
            &${componentCls}-show-arrow ${componentCls}-selection-item,
            &${componentCls}-show-arrow ${componentCls}-selection-placeholder
          `]: {
                        paddingInlineEnd: token.calc(token.fontSize).mul(1.5).equal()
                    }
                }
            }
        },
        // ======================== Large ========================
        // Shared
        $f74f5f77aab76f05$var$genSizeStyle((0, $8APUt.merge)(token, {
            controlHeight: token.singleItemHeightLG,
            fontSize: token.fontSizeLG,
            borderRadius: token.borderRadiusLG
        }), 'lg')
    ];
}


const $d7afe1643ce4d98a$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutline: controlOutline } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    return {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent',
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
        hoverBorderColor: colorPrimaryHover,
        activeBorderColor: colorPrimary,
        activeOutlineColor: controlOutline,
        selectAffixPadding: paddingXXS
    };
};


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
// =====================================================
// ==                  Outlined                       ==
// =====================================================
const $e2691aafc949645f$var$genBaseOutlinedStyle = (token, options)=>{
    const { componentCls: componentCls, antCls: antCls, controlOutlineWidth: controlOutlineWidth } = token;
    return {
        [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${options.borderColor}`,
            background: token.selectorBg
        },
        [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`&:hover ${componentCls}-selector`]: {
                borderColor: options.hoverBorderHover
            },
            [`${componentCls}-focused& ${componentCls}-selector`]: {
                borderColor: options.activeBorderColor,
                boxShadow: `0 0 0 ${(0, $4g3I0.unit)(controlOutlineWidth)} ${options.activeOutlineColor}`,
                outline: 0
            },
            [`${componentCls}-prefix`]: {
                color: options.color
            }
        }
    };
};
const $e2691aafc949645f$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, $e2691aafc949645f$var$genBaseOutlinedStyle(token, options))
    });
const $e2691aafc949645f$var$genOutlinedStyle = (token)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign({}, $e2691aafc949645f$var$genBaseOutlinedStyle(token, {
            borderColor: token.colorBorder,
            hoverBorderHover: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeOutlineColor: token.activeOutlineColor,
            color: token.colorText
        })), $e2691aafc949645f$var$genOutlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderHover: token.colorErrorHover,
            activeBorderColor: token.colorError,
            activeOutlineColor: token.colorErrorOutline,
            color: token.colorError
        })), $e2691aafc949645f$var$genOutlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderHover: token.colorWarningHover,
            activeBorderColor: token.colorWarning,
            activeOutlineColor: token.colorWarningOutline,
            color: token.colorWarning
        })), {
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.multipleItemBg,
                border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
            }
        })
    });
// =====================================================
// ==                   Filled                        ==
// =====================================================
const $e2691aafc949645f$var$genBaseFilledStyle = (token, options)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
            background: options.bg,
            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} transparent`,
            color: options.color
        },
        [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`&:hover ${componentCls}-selector`]: {
                background: options.hoverBg
            },
            [`${componentCls}-focused& ${componentCls}-selector`]: {
                background: token.selectorBg,
                borderColor: options.activeBorderColor,
                outline: 0
            }
        }
    };
};
const $e2691aafc949645f$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, $e2691aafc949645f$var$genBaseFilledStyle(token, options))
    });
const $e2691aafc949645f$var$genFilledStyle = (token)=>({
        '&-filled': Object.assign(Object.assign(Object.assign(Object.assign({}, $e2691aafc949645f$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.activeBorderColor,
            color: token.colorText
        })), $e2691aafc949645f$var$genFilledStatusStyle(token, {
            status: 'error',
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            color: token.colorError
        })), $e2691aafc949645f$var$genFilledStatusStyle(token, {
            status: 'warning',
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            color: token.colorWarning
        })), {
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    borderColor: token.colorBorder,
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.colorBgContainer,
                border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
            }
        })
    });
// =====================================================
// ==                 Borderless                      ==
// =====================================================
const $e2691aafc949645f$var$genBorderlessStyle = (token)=>({
        '&-borderless': {
            [`${token.componentCls}-selector`]: {
                background: 'transparent',
                border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} transparent`
            },
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.multipleItemBg,
                border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
            },
            // Status
            [`&${token.componentCls}-status-error`]: {
                [`${token.componentCls}-prefix, ${token.componentCls}-selection-item`]: {
                    color: token.colorError
                }
            },
            [`&${token.componentCls}-status-warning`]: {
                [`${token.componentCls}-prefix, ${token.componentCls}-selection-item`]: {
                    color: token.colorWarning
                }
            }
        }
    });
const $e2691aafc949645f$var$genVariantsStyle = (token)=>({
        [token.componentCls]: Object.assign(Object.assign(Object.assign({}, $e2691aafc949645f$var$genOutlinedStyle(token)), $e2691aafc949645f$var$genFilledStyle(token)), $e2691aafc949645f$var$genBorderlessStyle(token))
    });
var $e2691aafc949645f$export$2e2bcd8739ae039 = $e2691aafc949645f$var$genVariantsStyle;


// ============================= Selector =============================
const $e4f68b1db9603a2e$var$genSelectorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        position: 'relative',
        transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
        input: {
            cursor: 'pointer'
        },
        [`${componentCls}-show-search&`]: {
            cursor: 'text',
            input: {
                cursor: 'auto',
                color: 'inherit',
                height: '100%'
            }
        },
        [`${componentCls}-disabled&`]: {
            cursor: 'not-allowed',
            input: {
                cursor: 'not-allowed'
            }
        }
    };
};
// ============================== Styles ==============================
// /* Reset search input style */
const $e4f68b1db9603a2e$var$getSearchInputWithoutBorderStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-selection-search-input`]: {
            margin: 0,
            padding: 0,
            background: 'transparent',
            border: 'none',
            outline: 'none',
            appearance: 'none',
            fontFamily: 'inherit',
            '&::-webkit-search-cancel-button': {
                display: 'none',
                '-webkit-appearance': 'none'
            }
        }
    };
};
// =============================== Base ===============================
const $e4f68b1db9603a2e$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, iconCls: iconCls } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'relative',
            display: 'inline-flex',
            cursor: 'pointer',
            [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: Object.assign(Object.assign({}, $e4f68b1db9603a2e$var$genSelectorStyle(token)), $e4f68b1db9603a2e$var$getSearchInputWithoutBorderStyle(token)),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: Object.assign(Object.assign({
                flex: 1,
                fontWeight: 'normal',
                position: 'relative',
                userSelect: 'none'
            }, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: 'inline'
                }
            }),
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
                flex: 1,
                color: token.colorTextPlaceholder,
                pointerEvents: 'none'
            }),
            // ========================== Arrow ==========================
            [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$171ccda7bc085e59)()), {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                lineHeight: 1,
                textAlign: 'center',
                pointerEvents: 'none',
                display: 'flex',
                alignItems: 'center',
                transition: `opacity ${token.motionDurationSlow} ease`,
                [iconCls]: {
                    verticalAlign: 'top',
                    transition: `transform ${token.motionDurationSlow}`,
                    '> svg': {
                        verticalAlign: 'top'
                    },
                    [`&:not(${componentCls}-suffix)`]: {
                        pointerEvents: 'auto'
                    }
                },
                [`${componentCls}-disabled &`]: {
                    cursor: 'not-allowed'
                },
                '> *:not(:last-child)': {
                    marginInlineEnd: 8 // FIXME: magic
                }
            }),
            // ========================== Wrap ===========================
            [`${componentCls}-selection-wrap`]: {
                display: 'flex',
                width: '100%',
                position: 'relative',
                minWidth: 0,
                // https://github.com/ant-design/ant-design/issues/51669
                '&:after': {
                    content: '"\\a0"',
                    width: 0,
                    overflow: 'hidden'
                }
            },
            // ========================= Prefix ==========================
            [`${componentCls}-prefix`]: {
                flex: 'none',
                marginInlineEnd: token.selectAffixPadding
            },
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: 'inline-block',
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                cursor: 'pointer',
                opacity: 0,
                transition: `color ${token.motionDurationMid} ease, opacity ${token.motionDurationSlow} ease`,
                textRendering: 'auto',
                '&:before': {
                    display: 'block'
                },
                '&:hover': {
                    color: token.colorTextTertiary
                }
            },
            [`&:hover ${componentCls}-clear`]: {
                opacity: 1,
                background: token.colorBgBase,
                borderRadius: '50%'
            }
        }),
        // ========================= Feedback ==========================
        [`${componentCls}-status`]: {
            '&-error, &-warning, &-success, &-validating': {
                [`&${componentCls}-has-feedback`]: {
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
                    }
                }
            }
        }
    };
};
// ============================== Styles ==============================
const $e4f68b1db9603a2e$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: '100%'
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $e4f68b1db9603a2e$var$genBaseStyle(token),
        // Single
        (0, $f74f5f77aab76f05$export$2e2bcd8739ae039)(token),
        // Multiple
        (0, $b1604fbc0356803b$export$2e2bcd8739ae039)(token),
        // Dropdown
        (0, $33b4d22d18e9bfe9$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $2bdaa96870b686b7$export$b1208b23589b4b73)(token, {
            borderElCls: `${componentCls}-selector`,
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$e4f68b1db9603a2e$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Select', (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const selectToken = (0, $8APUt.merge)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $e4f68b1db9603a2e$var$genSelectStyle(selectToken),
        (0, $e2691aafc949645f$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $d7afe1643ce4d98a$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});



var $jMaZ8 = parcelRequire("jMaZ8");




var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $102f1e7294c0aef1$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $102f1e7294c0aef1$export$2e2bcd8739ae039 = $102f1e7294c0aef1$var$DownOutlined;



var $159430c34bfeb8bb$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $102f1e7294c0aef1$export$2e2bcd8739ae039)
    }));
};
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ var $159430c34bfeb8bb$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($159430c34bfeb8bb$var$DownOutlined);
$159430c34bfeb8bb$var$RefIcon.displayName = 'DownOutlined';
var $159430c34bfeb8bb$export$2e2bcd8739ae039 = $159430c34bfeb8bb$var$RefIcon;





"use client";
function $b763382cea850315$export$2e2bcd8739ae039(_ref) {
    let { suffixIcon: suffixIcon, clearIcon: clearIcon, menuItemSelectedIcon: menuItemSelectedIcon, removeIcon: removeIcon, loading: loading, multiple: multiple, hasFeedback: hasFeedback, prefixCls: prefixCls, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName } = _ref;
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)(componentName);
        warning.deprecated(!clearIcon, 'clearIcon', 'allowClear={{ clearIcon: React.ReactNode }}');
    }
    // Clear Icon
    const mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $jMaZ8.createElement((0, $93361570ffc8bbe1$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), {
        spin: true
    }));
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = (_ref2)=>{
            let { open: open, showSearch: showSearch } = _ref2;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $jMaZ8.createElement((0, $7707703e157f8963$export$2e2bcd8739ae039), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $jMaZ8.createElement((0, $159430c34bfeb8bb$export$2e2bcd8739ae039), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $c1c1d6d80357382d$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $e4f0d99fd5c89f91$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
var $71df08955277779f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $71df08955277779f$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const $71df08955277779f$var$InternalSelect = (props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount, prefix: prefix } = props, rest = $71df08955277779f$var$__rest(props, [
        "prefixCls",
        "bordered",
        "className",
        "rootClassName",
        "getPopupContainer",
        "popupClassName",
        "dropdownClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "builtinPlacements",
        "dropdownMatchSelectWidth",
        "popupMatchSelectWidth",
        "direction",
        "style",
        "allowClear",
        "variant",
        "dropdownStyle",
        "transitionName",
        "tagRender",
        "maxCount",
        "prefix"
    ]);
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow, select: select } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : token === null || token === void 0 ? void 0 : token.controlHeight;
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $b481086641a221d4$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $6883392ce3b89ee5$export$2e2bcd8739ae039)('select', customizeVariant, bordered);
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $e4f68b1db9603a2e$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $jMaZ8.useMemo(()=>{
        const { mode: m } = props;
        if (m === 'combobox') return undefined;
        if (m === $71df08955277779f$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === 'multiple' || mode === 'tags';
    const showSuffixIcon = (0, $e4f0d99fd5c89f91$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = (_a = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : contextPopupMatchSelectWidth;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $8d2ac7a62116451d$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Select')) || /*#__PURE__*/ $jMaZ8.createElement((0, $4de21af32a83dbc2$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon } = (0, $b763382cea850315$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, rest), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: 'Select'
    }));
    const mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    const selectProps = (0, $hvG6u.default)(rest, [
        'suffixIcon',
        'itemIcon'
    ]);
    const mergedPopupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(popupClassName || dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl'
    }, rootClassName, cssVarCls, rootCls, hashId);
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $8d2ac7a62116451d$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, select === null || select === void 0 ? void 0 : select.className, className, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $jMaZ8.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }, [
        placement,
        direction
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Select');
        warning.deprecated(!dropdownClassName, 'dropdownClassName', 'popupClassName');
        warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
        warning(!('showArrow' in props), 'deprecated', '`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null.');
        warning.deprecated(!('bordered' in props), 'bordered', 'variant');
        warning(!(typeof maxCount !== 'undefined' && !isMultiple), 'usage', '`maxCount` only works with mode `multiple` or `tags`');
    }
    // ====================== zIndex =========================
    const [zIndex] = (0, $5f1c4f12ab1f6aec$export$3e7906d4075187a4)('SelectLike', dropdownStyle === null || dropdownStyle === void 0 ? void 0 : dropdownStyle.zIndex);
    // ====================== Render =======================
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $0c275de2b003b545$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        virtual: virtual,
        showSearch: select === null || select === void 0 ? void 0 : select.showSearch
    }, selectProps, {
        style: Object.assign(Object.assign({}, select === null || select === void 0 ? void 0 : select.style), style),
        dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(rootPrefixCls, 'slide-up', transitionName),
        builtinPlacements: (0, $0b0bd736996a12a7$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        prefix: prefix,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        dropdownStyle: Object.assign(Object.assign({}, dropdownStyle), {
            zIndex: zIndex
        }),
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined
    })));
};
$71df08955277779f$var$InternalSelect.displayName = 'Select';
const $71df08955277779f$var$Select = /*#__PURE__*/ $jMaZ8.forwardRef($71df08955277779f$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $71df08955277779f$var$PurePanel = (0, $122b6ffb60331d40$export$2e2bcd8739ae039)($71df08955277779f$var$Select, 'dropdownAlign');
$71df08955277779f$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $71df08955277779f$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$71df08955277779f$var$Select.Option = (0, $fa42b1ff8784fafa$export$2e2bcd8739ae039);
$71df08955277779f$var$Select.OptGroup = (0, $a0d60f95fee9f290$export$2e2bcd8739ae039);
$71df08955277779f$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $71df08955277779f$var$PurePanel;
$71df08955277779f$var$Select.displayName = 'Select';
var $71df08955277779f$export$2e2bcd8739ae039 = $71df08955277779f$var$Select;


var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");

var $e28a1826bc388c31$var$_excluded = [
    "prefixCls",
    "className",
    "checked",
    "defaultChecked",
    "disabled",
    "loadingIcon",
    "checkedChildren",
    "unCheckedChildren",
    "onClick",
    "onChange",
    "onKeyDown"
];
var $e28a1826bc388c31$var$Switch = /*#__PURE__*/ $jMaZ8.forwardRef(function(_ref, ref) {
    var _classNames;
    var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-switch' : _ref$prefixCls, className = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, restProps = (0, $4b02Q.default)(_ref, $e28a1826bc388c31$var$_excluded);
    var _useMergedState = (0, $eGh7a.default)(false, {
        value: checked,
        defaultValue: defaultChecked
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
    function triggerChange(newChecked, event) {
        var mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange === null || onChange === void 0 || onChange(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).LEFT) triggerChange(false, e);
        else if (e.which === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).RIGHT) triggerChange(true, e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }
    function onInternalClick(e) {
        var ret = triggerChange(!innerChecked, e);
        // [Legacy] trigger onClick with value
        onClick === null || onClick === void 0 || onClick(ret, e);
    }
    var switchClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (_classNames = {}, (0, $eq8kl.default)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0, $eq8kl.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    return /*#__PURE__*/ $jMaZ8.createElement("button", (0, $hH60s.default)({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(prefixCls, "-inner-checked")
    }, checkedChildren), /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(prefixCls, "-inner-unchecked")
    }, unCheckedChildren)));
});
$e28a1826bc388c31$var$Switch.displayName = 'Switch';
var $e28a1826bc388c31$export$2e2bcd8739ae039 = $e28a1826bc388c31$var$Switch;



var $eGh7a = parcelRequire("eGh7a");




parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $8a3ae3a543242fe2$var$genSwitchSmallStyle = (token)=>{
    const { componentCls: componentCls, trackHeightSM: trackHeightSM, trackPadding: trackPadding, trackMinWidthSM: trackMinWidthSM, innerMinMarginSM: innerMinMarginSM, innerMaxMarginSM: innerMaxMarginSM, handleSizeSM: handleSizeSM, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $4g3I0.unit)(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $4g3I0.unit)(calc(innerMaxMarginSM).mul(2).equal());
    return {
        [componentCls]: {
            [`&${componentCls}-small`]: {
                minWidth: trackMinWidthSM,
                height: trackHeightSM,
                lineHeight: (0, $4g3I0.unit)(trackHeightSM),
                [`${componentCls}-inner`]: {
                    paddingInlineStart: innerMaxMarginSM,
                    paddingInlineEnd: innerMinMarginSM,
                    [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                        minHeight: trackHeightSM
                    },
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                        marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                    },
                    [`${switchInnerCls}-unchecked`]: {
                        marginTop: calc(trackHeightSM).mul(-1).equal(),
                        marginInlineStart: 0,
                        marginInlineEnd: 0
                    }
                },
                [`${componentCls}-handle`]: {
                    width: handleSizeSM,
                    height: handleSizeSM
                },
                [`${componentCls}-loading-icon`]: {
                    top: calc(calc(handleSizeSM).sub(token.switchLoadingIconSize)).div(2).equal(),
                    fontSize: token.switchLoadingIconSize
                },
                [`&${componentCls}-checked`]: {
                    [`${componentCls}-inner`]: {
                        paddingInlineStart: innerMinMarginSM,
                        paddingInlineEnd: innerMaxMarginSM,
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: 0,
                            marginInlineEnd: 0
                        },
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                            marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                        }
                    },
                    [`${componentCls}-handle`]: {
                        insetInlineStart: `calc(100% - ${(0, $4g3I0.unit)(calc(handleSizeSM).add(trackPadding).equal())})`
                    }
                },
                [`&:not(${componentCls}-disabled):active`]: {
                    [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: calc(token.marginXXS).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).mul(-1).div(2).equal()
                        }
                    },
                    [`&${componentCls}-checked ${switchInnerCls}`]: {
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: calc(token.marginXXS).mul(-1).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).div(2).equal()
                        }
                    }
                }
            }
        }
    };
};
const $8a3ae3a543242fe2$var$genSwitchLoadingStyle = (token)=>{
    const { componentCls: componentCls, handleSize: handleSize, calc: calc } = token;
    return {
        [componentCls]: {
            [`${componentCls}-loading-icon${token.iconCls}`]: {
                position: 'relative',
                top: calc(calc(handleSize).sub(token.fontSize)).div(2).equal(),
                color: token.switchLoadingIconColor,
                verticalAlign: 'top'
            },
            [`&${componentCls}-checked ${componentCls}-loading-icon`]: {
                color: token.switchColor
            }
        }
    };
};
const $8a3ae3a543242fe2$var$genSwitchHandleStyle = (token)=>{
    const { componentCls: componentCls, trackPadding: trackPadding, handleBg: handleBg, handleShadow: handleShadow, handleSize: handleSize, calc: calc } = token;
    const switchHandleCls = `${componentCls}-handle`;
    return {
        [componentCls]: {
            [switchHandleCls]: {
                position: 'absolute',
                top: trackPadding,
                insetInlineStart: trackPadding,
                width: handleSize,
                height: handleSize,
                transition: `all ${token.switchDuration} ease-in-out`,
                '&::before': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    backgroundColor: handleBg,
                    borderRadius: calc(handleSize).div(2).equal(),
                    boxShadow: handleShadow,
                    transition: `all ${token.switchDuration} ease-in-out`,
                    content: '""'
                }
            },
            [`&${componentCls}-checked ${switchHandleCls}`]: {
                insetInlineStart: `calc(100% - ${(0, $4g3I0.unit)(calc(handleSize).add(trackPadding).equal())})`
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`${switchHandleCls}::before`]: {
                    insetInlineEnd: token.switchHandleActiveInset,
                    insetInlineStart: 0
                },
                [`&${componentCls}-checked ${switchHandleCls}::before`]: {
                    insetInlineEnd: 0,
                    insetInlineStart: token.switchHandleActiveInset
                }
            }
        }
    };
};
const $8a3ae3a543242fe2$var$genSwitchInnerStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackPadding: trackPadding, innerMinMargin: innerMinMargin, innerMaxMargin: innerMaxMargin, handleSize: handleSize, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $4g3I0.unit)(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $4g3I0.unit)(calc(innerMaxMargin).mul(2).equal());
    return {
        [componentCls]: {
            [switchInnerCls]: {
                display: 'block',
                overflow: 'hidden',
                borderRadius: 100,
                height: '100%',
                paddingInlineStart: innerMaxMargin,
                paddingInlineEnd: innerMinMargin,
                transition: `padding-inline-start ${token.switchDuration} ease-in-out, padding-inline-end ${token.switchDuration} ease-in-out`,
                [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                    display: 'block',
                    color: token.colorTextLightSolid,
                    fontSize: token.fontSizeSM,
                    transition: `margin-inline-start ${token.switchDuration} ease-in-out, margin-inline-end ${token.switchDuration} ease-in-out`,
                    pointerEvents: 'none',
                    minHeight: trackHeight
                },
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginTop: calc(trackHeight).mul(-1).equal(),
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                }
            },
            [`&${componentCls}-checked ${switchInnerCls}`]: {
                paddingInlineStart: innerMinMargin,
                paddingInlineEnd: innerMaxMargin,
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                }
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                    [`${switchInnerCls}-unchecked`]: {
                        marginInlineStart: calc(trackPadding).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
                    }
                },
                [`&${componentCls}-checked ${switchInnerCls}`]: {
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(2).equal()
                    }
                }
            }
        }
    };
};
const $8a3ae3a543242fe2$var$genSwitchStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackMinWidth: trackMinWidth } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'relative',
            display: 'inline-block',
            boxSizing: 'border-box',
            minWidth: trackMinWidth,
            height: trackHeight,
            lineHeight: (0, $4g3I0.unit)(trackHeight),
            verticalAlign: 'middle',
            background: token.colorTextQuaternary,
            border: '0',
            borderRadius: 100,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`,
            userSelect: 'none',
            [`&:hover:not(${componentCls}-disabled)`]: {
                background: token.colorTextTertiary
            }
        }), (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)), {
            [`&${componentCls}-checked`]: {
                background: token.switchColor,
                [`&:hover:not(${componentCls}-disabled)`]: {
                    background: token.colorPrimaryHover
                }
            },
            [`&${componentCls}-loading, &${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                opacity: token.switchDisabledOpacity,
                '*': {
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                }
            },
            // rtl style
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        })
    };
};
const $8a3ae3a543242fe2$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, controlHeight: controlHeight, colorWhite: colorWhite } = token;
    const height = fontSize * lineHeight;
    const heightSM = controlHeight / 2;
    const padding = 2; // Fixed value
    const handleSize = height - padding * 2;
    const handleSizeSM = heightSM - padding * 2;
    return {
        trackHeight: height,
        trackHeightSM: heightSM,
        trackMinWidth: handleSize * 2 + padding * 4,
        trackMinWidthSM: handleSizeSM * 2 + padding * 2,
        trackPadding: padding,
        // Fixed value
        handleBg: colorWhite,
        handleSize: handleSize,
        handleSizeSM: handleSizeSM,
        handleShadow: `0 2px 4px 0 ${new (0, $6xABB.FastColor)('#00230b').setA(0.2).toRgbString()}`,
        innerMinMargin: handleSize / 2,
        innerMaxMargin: handleSize + padding + padding * 2,
        innerMinMarginSM: handleSizeSM / 2,
        innerMaxMarginSM: handleSizeSM + padding + padding * 2
    };
};
var $8a3ae3a543242fe2$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Switch', (token)=>{
    const switchToken = (0, $8APUt.merge)(token, {
        switchDuration: token.motionDurationMid,
        switchColor: token.colorPrimary,
        switchDisabledOpacity: token.opacityLoading,
        switchLoadingIconSize: token.calc(token.fontSizeIcon).mul(0.75).equal(),
        switchLoadingIconColor: `rgba(0, 0, 0, ${token.opacityLoading})`,
        switchHandleActiveInset: '-30%'
    });
    return [
        $8a3ae3a543242fe2$var$genSwitchStyle(switchToken),
        // inner style
        $8a3ae3a543242fe2$var$genSwitchInnerStyle(switchToken),
        // handle style
        $8a3ae3a543242fe2$var$genSwitchHandleStyle(switchToken),
        // loading style
        $8a3ae3a543242fe2$var$genSwitchLoadingStyle(switchToken),
        // small style
        $8a3ae3a543242fe2$var$genSwitchSmallStyle(switchToken)
    ];
}, $8a3ae3a543242fe2$export$9ca1be8807fe0675);


"use client";
var $b968d364906a5d60$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b968d364906a5d60$var$InternalSwitch = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, size: customizeSize, disabled: customDisabled, loading: loading, className: className, rootClassName: rootClassName, style: style, checked: checkedProp, value: value, defaultChecked: defaultCheckedProp, defaultValue: defaultValue, onChange: onChange } = props, restProps = $b968d364906a5d60$var$__rest(props, [
        "prefixCls",
        "size",
        "disabled",
        "loading",
        "className",
        "rootClassName",
        "style",
        "checked",
        "value",
        "defaultChecked",
        "defaultValue",
        "onChange"
    ]);
    const [checked, setChecked] = (0, $eGh7a.default)(false, {
        value: checkedProp !== null && checkedProp !== void 0 ? checkedProp : value,
        defaultValue: defaultCheckedProp !== null && defaultCheckedProp !== void 0 ? defaultCheckedProp : defaultValue
    });
    const { getPrefixCls: getPrefixCls, direction: direction, switch: SWITCH } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    // ===================== Disabled =====================
    const disabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = (customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled) || loading;
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    const loadingIcon = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-handle`
    }, loading && /*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), {
        className: `${prefixCls}-loading-icon`
    }));
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8a3ae3a543242fe2$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customizeSize);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.className, {
        [`${prefixCls}-small`]: mergedSize === 'small',
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.style), style);
    const changeHandler = function() {
        setChecked(arguments.length <= 0 ? undefined : arguments[0]);
        onChange === null || onChange === void 0 || onChange.apply(void 0, arguments);
    };
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $de29c1080c02bd8d$export$2e2bcd8739ae039), {
        component: "Switch"
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $e28a1826bc388c31$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        checked: checked,
        onChange: changeHandler,
        prefixCls: prefixCls,
        className: classes,
        style: mergedStyle,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    }))));
});
const $b968d364906a5d60$var$Switch = $b968d364906a5d60$var$InternalSwitch;
$b968d364906a5d60$var$Switch.__ANT_SWITCH = true;
$b968d364906a5d60$var$Switch.displayName = 'Switch';
var $b968d364906a5d60$export$2e2bcd8739ae039 = $b968d364906a5d60$var$Switch;


var $jMaZ8 = parcelRequire("jMaZ8");

var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $1Esi2 = parcelRequire("1Esi2");

var $c1hLi = parcelRequire("c1hLi");

var $18vmN = parcelRequire("18vmN");

var $fvBso = parcelRequire("fvBso");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");


var $jMaZ8 = parcelRequire("jMaZ8");

var $2bFmQ = parcelRequire("2bFmQ");
var $81ff6401a0a4ac14$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        var fileName = file.name || '';
        var mimeType = file.type || '';
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim();
            // This is something like */*,*  allow all files
            if (/^\*(\/\*)?$/.test(type)) return true;
            // like .jpg, .png
            if (validType.charAt(0) === '.') {
                var lowerFileName = fileName.toLowerCase();
                var lowerType = validType.toLowerCase();
                var affixList = [
                    lowerType
                ];
                if (lowerType === '.jpg' || lowerType === '.jpeg') affixList = [
                    '.jpg',
                    '.jpeg'
                ];
                return affixList.some(function(affix) {
                    return lowerFileName.endsWith(affix);
                });
            }
            // This is something like a image/* mime type
            if (/\/\*$/.test(validType)) return baseMimeType === validType.replace(/\/.*$/, '');
            // Full match
            if (mimeType === validType) return true;
            // Invalidate type should skip
            if (/^\w+$/.test(validType)) {
                (0, $2bFmQ.default)(false, "Upload takes an invalidate 'accept' type '".concat(validType, "'.Skip for check."));
                return true;
            }
            return false;
        });
    }
    return true;
};


function $030d2de186d33d55$var$getError(option, xhr) {
    var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
    var err = new Error(msg);
    err.status = xhr.status;
    err.method = option.method;
    err.url = option.action;
    return err;
}
function $030d2de186d33d55$var$getBody(xhr) {
    var text = xhr.responseText || xhr.response;
    if (!text) return text;
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}
function $030d2de186d33d55$export$2e2bcd8739ae039(option) {
    // eslint-disable-next-line no-undef
    var xhr = new XMLHttpRequest();
    if (option.onProgress && xhr.upload) xhr.upload.onprogress = function progress(e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        option.onProgress(e);
    };
    // eslint-disable-next-line no-undef
    var formData = new FormData();
    if (option.data) Object.keys(option.data).forEach(function(key) {
        var value = option.data[key];
        // support key-value array data
        if (Array.isArray(value)) {
            value.forEach(function(item) {
                // { list: [ 11, 22 ] }
                // formData.append('list[]', 11);
                formData.append("".concat(key, "[]"), item);
            });
            return;
        }
        formData.append(key, value);
    });
    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) formData.append(option.filename, option.file, option.file.name);
    else formData.append(option.filename, option.file);
    xhr.onerror = function error(e) {
        option.onError(e);
    };
    xhr.onload = function onload() {
        // allow success when 2xx status
        // see https://github.com/react-component/upload/issues/34
        if (xhr.status < 200 || xhr.status >= 300) return option.onError($030d2de186d33d55$var$getError(option, xhr), $030d2de186d33d55$var$getBody(xhr));
        return option.onSuccess($030d2de186d33d55$var$getBody(xhr), xhr);
    };
    xhr.open(option.method, option.action, true);
    // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
    if (option.withCredentials && 'withCredentials' in xhr) xhr.withCredentials = true;
    var headers = option.headers || {};
    // when set headers['X-Requested-With'] = null , can close default XHR header
    // see https://github.com/react-component/upload/issues/33
    if (headers['X-Requested-With'] !== null) xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    Object.keys(headers).forEach(function(h) {
        if (headers[h] !== null) xhr.setRequestHeader(h, headers[h]);
    });
    xhr.send(formData);
    return {
        abort: function abort() {
            xhr.abort();
        }
    };
}



var $c1hLi = parcelRequire("c1hLi");

var $fvBso = parcelRequire("fvBso");

var $18vmN = parcelRequire("18vmN");
// https://github.com/ant-design/ant-design/issues/50080
var $3449eb4af2591a4e$var$traverseFileTree = /*#__PURE__*/ function() {
    var _ref = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee4(files, isAccepted) {
        var flattenFileList, progressFileList, readDirectory, _readDirectory, readFile, _readFile, _traverseFileTree, wipIndex;
        return (0, $c1hLi.default)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    _readFile = function _readFile3() {
                        _readFile = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee3(item) {
                            return (0, $c1hLi.default)().wrap(function _callee3$(_context3) {
                                while(true)switch(_context3.prev = _context3.next){
                                    case 0:
                                        return _context3.abrupt("return", new Promise(function(reslove) {
                                            item.file(function(file) {
                                                if (isAccepted(file)) {
                                                    // https://github.com/ant-design/ant-design/issues/16426
                                                    if (item.fullPath && !file.webkitRelativePath) {
                                                        Object.defineProperties(file, {
                                                            webkitRelativePath: {
                                                                writable: true
                                                            }
                                                        });
                                                        // eslint-disable-next-line no-param-reassign
                                                        file.webkitRelativePath = item.fullPath.replace(/^\//, '');
                                                        Object.defineProperties(file, {
                                                            webkitRelativePath: {
                                                                writable: false
                                                            }
                                                        });
                                                    }
                                                    reslove(file);
                                                } else reslove(null);
                                            });
                                        }));
                                    case 1:
                                    case "end":
                                        return _context3.stop();
                                }
                            }, _callee3);
                        }));
                        return _readFile.apply(this, arguments);
                    };
                    readFile = function _readFile2(_x4) {
                        return _readFile.apply(this, arguments);
                    };
                    _readDirectory = function _readDirectory3() {
                        _readDirectory = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee2(directory) {
                            var dirReader, entries, results, n, i;
                            return (0, $c1hLi.default)().wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        dirReader = directory.createReader();
                                        entries = [];
                                    case 2:
                                        _context2.next = 5;
                                        return new Promise(function(resolve) {
                                            dirReader.readEntries(resolve, function() {
                                                return resolve([]);
                                            });
                                        });
                                    case 5:
                                        results = _context2.sent;
                                        n = results.length;
                                        if (n) {
                                            _context2.next = 9;
                                            break;
                                        }
                                        return _context2.abrupt("break", 12);
                                    case 9:
                                        for(i = 0; i < n; i++)entries.push(results[i]);
                                        _context2.next = 2;
                                        break;
                                    case 12:
                                        return _context2.abrupt("return", entries);
                                    case 13:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }));
                        return _readDirectory.apply(this, arguments);
                    };
                    readDirectory = function _readDirectory2(_x3) {
                        return _readDirectory.apply(this, arguments);
                    };
                    flattenFileList = [];
                    progressFileList = [];
                    files.forEach(function(file) {
                        return progressFileList.push(file.webkitGetAsEntry());
                    });
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    _traverseFileTree = /*#__PURE__*/ function() {
                        var _ref2 = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee(item, path) {
                            var _file, entries;
                            return (0, $c1hLi.default)().wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        if (item) {
                                            _context.next = 2;
                                            break;
                                        }
                                        return _context.abrupt("return");
                                    case 2:
                                        // eslint-disable-next-line no-param-reassign
                                        item.path = path || '';
                                        if (!item.isFile) {
                                            _context.next = 10;
                                            break;
                                        }
                                        _context.next = 6;
                                        return readFile(item);
                                    case 6:
                                        _file = _context.sent;
                                        if (_file) flattenFileList.push(_file);
                                        _context.next = 15;
                                        break;
                                    case 10:
                                        if (!item.isDirectory) {
                                            _context.next = 15;
                                            break;
                                        }
                                        _context.next = 13;
                                        return readDirectory(item);
                                    case 13:
                                        entries = _context.sent;
                                        progressFileList.push.apply(progressFileList, (0, $fvBso.default)(entries));
                                    case 15:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function _traverseFileTree(_x5, _x6) {
                            return _ref2.apply(this, arguments);
                        };
                    }();
                    wipIndex = 0;
                case 9:
                    if (!(wipIndex < progressFileList.length)) {
                        _context4.next = 15;
                        break;
                    }
                    _context4.next = 12;
                    return _traverseFileTree(progressFileList[wipIndex]);
                case 12:
                    wipIndex++;
                    _context4.next = 9;
                    break;
                case 15:
                    return _context4.abrupt("return", flattenFileList);
                case 16:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function traverseFileTree(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $3449eb4af2591a4e$export$2e2bcd8739ae039 = $3449eb4af2591a4e$var$traverseFileTree;


var $e8d727eefd5b5513$var$now = +new Date();
var $e8d727eefd5b5513$var$index = 0;
function $e8d727eefd5b5513$export$2e2bcd8739ae039() {
    // eslint-disable-next-line no-plusplus
    return "rc-upload-".concat($e8d727eefd5b5513$var$now, "-").concat(++$e8d727eefd5b5513$var$index);
}


var $6ce64ffb827399e9$var$_excluded = [
    "component",
    "prefixCls",
    "className",
    "classNames",
    "disabled",
    "id",
    "name",
    "style",
    "styles",
    "multiple",
    "accept",
    "capture",
    "children",
    "directory",
    "openFileDialogOnClick",
    "onMouseEnter",
    "onMouseLeave",
    "hasControlInside"
];
var $6ce64ffb827399e9$var$AjaxUploader = /*#__PURE__*/ function(_Component) {
    (0, $7eK0y.default)(AjaxUploader, _Component);
    var _super = (0, $fwNdX.default)(AjaxUploader);
    function AjaxUploader() {
        var _this;
        (0, $klxbl.default)(this, AjaxUploader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "state", {
            uid: (0, $e8d727eefd5b5513$export$2e2bcd8739ae039)()
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "reqs", {});
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "fileInput", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "_isMounted", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onChange", function(e) {
            var _this$props = _this.props, accept = _this$props.accept, directory = _this$props.directory;
            var files = e.target.files;
            var acceptedFiles = (0, $fvBso.default)(files).filter(function(file) {
                return !directory || (0, $81ff6401a0a4ac14$export$2e2bcd8739ae039)(file, accept);
            });
            _this.uploadFiles(acceptedFiles);
            _this.reset();
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onClick", function(event) {
            var el = _this.fileInput;
            if (!el) return;
            var target = event.target;
            var onClick = _this.props.onClick;
            if (target && target.tagName === 'BUTTON') {
                var parent = el.parentNode;
                parent.focus();
                target.blur();
            }
            el.click();
            if (onClick) onClick(event);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onKeyDown", function(e) {
            if (e.key === 'Enter') _this.onClick(e);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onFileDrop", /*#__PURE__*/ function() {
            var _ref = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee(e) {
                var multiple, files, _files;
                return (0, $c1hLi.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            multiple = _this.props.multiple;
                            e.preventDefault();
                            if (!(e.type === 'dragover')) {
                                _context.next = 4;
                                break;
                            }
                            return _context.abrupt("return");
                        case 4:
                            if (!_this.props.directory) {
                                _context.next = 11;
                                break;
                            }
                            _context.next = 7;
                            return (0, $3449eb4af2591a4e$export$2e2bcd8739ae039)(Array.prototype.slice.call(e.dataTransfer.items), function(_file) {
                                return (0, $81ff6401a0a4ac14$export$2e2bcd8739ae039)(_file, _this.props.accept);
                            });
                        case 7:
                            files = _context.sent;
                            _this.uploadFiles(files);
                            _context.next = 14;
                            break;
                        case 11:
                            _files = (0, $fvBso.default)(e.dataTransfer.files).filter(function(file) {
                                return (0, $81ff6401a0a4ac14$export$2e2bcd8739ae039)(file, _this.props.accept);
                            });
                            if (multiple === false) _files = _files.slice(0, 1);
                            _this.uploadFiles(_files);
                        case 14:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "uploadFiles", function(files) {
            var originFiles = (0, $fvBso.default)(files);
            var postFiles = originFiles.map(function(file) {
                // eslint-disable-next-line no-param-reassign
                file.uid = (0, $e8d727eefd5b5513$export$2e2bcd8739ae039)();
                return _this.processFile(file, originFiles);
            });
            // Batch upload files
            Promise.all(postFiles).then(function(fileList) {
                var onBatchStart = _this.props.onBatchStart;
                onBatchStart === null || onBatchStart === void 0 || onBatchStart(fileList.map(function(_ref2) {
                    var origin = _ref2.origin, parsedFile = _ref2.parsedFile;
                    return {
                        file: origin,
                        parsedFile: parsedFile
                    };
                }));
                fileList.filter(function(file) {
                    return file.parsedFile !== null;
                }).forEach(function(file) {
                    _this.post(file);
                });
            });
        });
        /**
     * Process file before upload. When all the file is ready, we start upload.
     */ (0, $eq8kl.default)((0, $e4nJa.default)(_this), "processFile", /*#__PURE__*/ function() {
            var _ref3 = (0, $18vmN.default)(/*#__PURE__*/ (0, $c1hLi.default)().mark(function _callee2(file, fileList) {
                var beforeUpload, transformedFile, action, mergedAction, data, mergedData, parsedData, parsedFile, mergedParsedFile;
                return (0, $c1hLi.default)().wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            beforeUpload = _this.props.beforeUpload;
                            transformedFile = file;
                            if (!beforeUpload) {
                                _context2.next = 14;
                                break;
                            }
                            _context2.prev = 3;
                            _context2.next = 6;
                            return beforeUpload(file, fileList);
                        case 6:
                            transformedFile = _context2.sent;
                            _context2.next = 12;
                            break;
                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2["catch"](3);
                            // Rejection will also trade as false
                            transformedFile = false;
                        case 12:
                            if (!(transformedFile === false)) {
                                _context2.next = 14;
                                break;
                            }
                            return _context2.abrupt("return", {
                                origin: file,
                                parsedFile: null,
                                action: null,
                                data: null
                            });
                        case 14:
                            // Get latest action
                            action = _this.props.action;
                            if (!(typeof action === 'function')) {
                                _context2.next = 21;
                                break;
                            }
                            _context2.next = 18;
                            return action(file);
                        case 18:
                            mergedAction = _context2.sent;
                            _context2.next = 22;
                            break;
                        case 21:
                            mergedAction = action;
                        case 22:
                            // Get latest data
                            data = _this.props.data;
                            if (!(typeof data === 'function')) {
                                _context2.next = 29;
                                break;
                            }
                            _context2.next = 26;
                            return data(file);
                        case 26:
                            mergedData = _context2.sent;
                            _context2.next = 30;
                            break;
                        case 29:
                            mergedData = data;
                        case 30:
                            parsedData = // string type is from legacy `transformFile`.
                            // Not sure if this will work since no related test case works with it
                            ((0, $1Esi2.default)(transformedFile) === 'object' || typeof transformedFile === 'string') && transformedFile ? transformedFile : file;
                            if (parsedData instanceof File) parsedFile = parsedData;
                            else parsedFile = new File([
                                parsedData
                            ], file.name, {
                                type: file.type
                            });
                            mergedParsedFile = parsedFile;
                            mergedParsedFile.uid = file.uid;
                            return _context2.abrupt("return", {
                                origin: file,
                                data: mergedData,
                                parsedFile: mergedParsedFile,
                                action: mergedAction
                            });
                        case 35:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2, null, [
                    [
                        3,
                        9
                    ]
                ]);
            }));
            return function(_x2, _x3) {
                return _ref3.apply(this, arguments);
            };
        }());
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "saveFileInput", function(node) {
            _this.fileInput = node;
        });
        return _this;
    }
    (0, $9O7LJ.default)(AjaxUploader, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
                this.abort();
            }
        },
        {
            key: "post",
            value: function post(_ref4) {
                var _this2 = this;
                var data = _ref4.data, origin = _ref4.origin, action = _ref4.action, parsedFile = _ref4.parsedFile;
                if (!this._isMounted) return;
                var _this$props2 = this.props, onStart = _this$props2.onStart, customRequest = _this$props2.customRequest, name = _this$props2.name, headers = _this$props2.headers, withCredentials = _this$props2.withCredentials, method = _this$props2.method;
                var uid = origin.uid;
                var request = customRequest || (0, $030d2de186d33d55$export$2e2bcd8739ae039);
                var requestOption = {
                    action: action,
                    filename: name,
                    data: data,
                    file: parsedFile,
                    headers: headers,
                    withCredentials: withCredentials,
                    method: method || 'post',
                    onProgress: function onProgress(e) {
                        var onProgress = _this2.props.onProgress;
                        onProgress === null || onProgress === void 0 || onProgress(e, parsedFile);
                    },
                    onSuccess: function onSuccess(ret, xhr) {
                        var onSuccess = _this2.props.onSuccess;
                        onSuccess === null || onSuccess === void 0 || onSuccess(ret, parsedFile, xhr);
                        delete _this2.reqs[uid];
                    },
                    onError: function onError(err, ret) {
                        var onError = _this2.props.onError;
                        onError === null || onError === void 0 || onError(err, ret, parsedFile);
                        delete _this2.reqs[uid];
                    }
                };
                onStart(origin);
                this.reqs[uid] = request(requestOption);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.setState({
                    uid: (0, $e8d727eefd5b5513$export$2e2bcd8739ae039)()
                });
            }
        },
        {
            key: "abort",
            value: function abort(file) {
                var reqs = this.reqs;
                if (file) {
                    var uid = file.uid ? file.uid : file;
                    if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
                    delete reqs[uid];
                } else Object.keys(reqs).forEach(function(uid) {
                    if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
                    delete reqs[uid];
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, Tag = _this$props3.component, prefixCls = _this$props3.prefixCls, className = _this$props3.className, _this$props3$classNam = _this$props3.classNames, classNames = _this$props3$classNam === void 0 ? {} : _this$props3$classNam, disabled = _this$props3.disabled, id = _this$props3.id, name = _this$props3.name, style = _this$props3.style, _this$props3$styles = _this$props3.styles, styles = _this$props3$styles === void 0 ? {} : _this$props3$styles, multiple = _this$props3.multiple, accept = _this$props3.accept, capture = _this$props3.capture, children = _this$props3.children, directory = _this$props3.directory, openFileDialogOnClick = _this$props3.openFileDialogOnClick, onMouseEnter = _this$props3.onMouseEnter, onMouseLeave = _this$props3.onMouseLeave, hasControlInside = _this$props3.hasControlInside, otherProps = (0, $4b02Q.default)(_this$props3, $6ce64ffb827399e9$var$_excluded);
                var cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, prefixCls, true), "".concat(prefixCls, "-disabled"), disabled), className, className));
                // because input don't have directory/webkitdirectory type declaration
                var dirProps = directory ? {
                    directory: 'directory',
                    webkitdirectory: 'webkitdirectory'
                } : {};
                var events = disabled ? {} : {
                    onClick: openFileDialogOnClick ? this.onClick : function() {},
                    onKeyDown: openFileDialogOnClick ? this.onKeyDown : function() {},
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onDrop: this.onFileDrop,
                    onDragOver: this.onFileDrop,
                    tabIndex: hasControlInside ? undefined : '0'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(Tag, (0, $hH60s.default)({}, events, {
                    className: cls,
                    role: hasControlInside ? undefined : 'button',
                    style: style
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("input", (0, $hH60s.default)({}, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(otherProps, {
                    aria: true,
                    data: true
                }), {
                    id: id,
                    name: name,
                    disabled: disabled,
                    type: "file",
                    ref: this.saveFileInput,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    } // https://github.com/ant-design/ant-design/issues/19948
                    ,
                    key: this.state.uid,
                    style: (0, $8u3qN.default)({
                        display: 'none'
                    }, styles.input),
                    className: classNames.input,
                    accept: accept
                }, dirProps, {
                    multiple: multiple,
                    onChange: this.onChange
                }, capture != null ? {
                    capture: capture
                } : {})), children);
            }
        }
    ]);
    return AjaxUploader;
}((0, $jMaZ8.Component));
var $6ce64ffb827399e9$export$2e2bcd8739ae039 = $6ce64ffb827399e9$var$AjaxUploader;


function $3dea3610dd6c30d8$var$empty() {}
var $3dea3610dd6c30d8$var$Upload = /*#__PURE__*/ function(_Component) {
    (0, $7eK0y.default)(Upload, _Component);
    var _super = (0, $fwNdX.default)(Upload);
    function Upload() {
        var _this;
        (0, $klxbl.default)(this, Upload);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "uploader", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "saveUploader", function(node) {
            _this.uploader = node;
        });
        return _this;
    }
    (0, $9O7LJ.default)(Upload, [
        {
            key: "abort",
            value: function abort(file) {
                this.uploader.abort(file);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $6ce64ffb827399e9$export$2e2bcd8739ae039), (0, $hH60s.default)({}, this.props, {
                    ref: this.saveUploader
                }));
            }
        }
    ]);
    return Upload;
}((0, $jMaZ8.Component));
(0, $eq8kl.default)($3dea3610dd6c30d8$var$Upload, "defaultProps", {
    component: 'span',
    prefixCls: 'rc-upload',
    data: {},
    headers: {},
    name: 'file',
    multipart: false,
    onStart: $3dea3610dd6c30d8$var$empty,
    onError: $3dea3610dd6c30d8$var$empty,
    onSuccess: $3dea3610dd6c30d8$var$empty,
    multiple: false,
    beforeUpload: null,
    customRequest: null,
    withCredentials: false,
    openFileDialogOnClick: true,
    hasControlInside: false
});
var $3dea3610dd6c30d8$export$2e2bcd8739ae039 = $3dea3610dd6c30d8$var$Upload;


var $2075b3716f0f8e69$export$2e2bcd8739ae039 = (0, $3dea3610dd6c30d8$export$2e2bcd8739ae039);



var $eGh7a = parcelRequire("eGh7a");







parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $81ae0b39565a0e23$var$genDraggerStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-drag`]: {
                position: 'relative',
                width: '100%',
                height: '100%',
                textAlign: 'center',
                background: token.colorFillAlter,
                border: `${(0, $4g3I0.unit)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                [componentCls]: {
                    padding: token.padding
                },
                [`${componentCls}-btn`]: {
                    display: 'table',
                    width: '100%',
                    height: '100%',
                    outline: 'none',
                    borderRadius: token.borderRadiusLG,
                    '&:focus-visible': {
                        outline: `${(0, $4g3I0.unit)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`
                    }
                },
                [`${componentCls}-drag-container`]: {
                    display: 'table-cell',
                    verticalAlign: 'middle'
                },
                [`
          &:not(${componentCls}-disabled):hover,
          &-hover:not(${componentCls}-disabled)
        `]: {
                    borderColor: token.colorPrimaryHover
                },
                [`p${componentCls}-drag-icon`]: {
                    marginBottom: token.margin,
                    [iconCls]: {
                        color: token.colorPrimary,
                        fontSize: token.uploadThumbnailSize
                    }
                },
                [`p${componentCls}-text`]: {
                    margin: `0 0 ${(0, $4g3I0.unit)(token.marginXXS)}`,
                    color: token.colorTextHeading,
                    fontSize: token.fontSizeLG
                },
                [`p${componentCls}-hint`]: {
                    color: token.colorTextDescription,
                    fontSize: token.fontSize
                },
                // ===================== Disabled =====================
                [`&${componentCls}-disabled`]: {
                    [`p${componentCls}-drag-icon ${iconCls},
            p${componentCls}-text,
            p${componentCls}-hint
          `]: {
                        color: token.colorTextDisabled
                    }
                }
            }
        }
    };
};
var $81ae0b39565a0e23$export$2e2bcd8739ae039 = $81ae0b39565a0e23$var$genDraggerStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $44f7852be4d67267$var$genListStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSize: fontSize, lineHeight: lineHeight, calc: calc } = token;
    const itemCls = `${componentCls}-list-item`;
    const actionsCls = `${itemCls}-actions`;
    const actionCls = `${itemCls}-action`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-list`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
                lineHeight: token.lineHeight,
                [itemCls]: {
                    position: 'relative',
                    height: calc(token.lineHeight).mul(fontSize).equal(),
                    marginTop: token.marginXS,
                    fontSize: fontSize,
                    display: 'flex',
                    alignItems: 'center',
                    transition: `background-color ${token.motionDurationSlow}`,
                    borderRadius: token.borderRadiusSM,
                    '&:hover': {
                        backgroundColor: token.controlItemBgHover
                    },
                    [`${itemCls}-name`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
                        padding: `0 ${(0, $4g3I0.unit)(token.paddingXS)}`,
                        lineHeight: lineHeight,
                        flex: 'auto',
                        transition: `all ${token.motionDurationSlow}`
                    }),
                    [actionsCls]: {
                        whiteSpace: 'nowrap',
                        [actionCls]: {
                            opacity: 0
                        },
                        [iconCls]: {
                            color: token.actionsColor,
                            transition: `all ${token.motionDurationSlow}`
                        },
                        [`
              ${actionCls}:focus-visible,
              &.picture ${actionCls}
            `]: {
                            opacity: 1
                        }
                    },
                    [`${componentCls}-icon ${iconCls}`]: {
                        color: token.colorTextDescription,
                        fontSize: fontSize
                    },
                    [`${itemCls}-progress`]: {
                        position: 'absolute',
                        bottom: token.calc(token.uploadProgressOffset).mul(-1).equal(),
                        width: '100%',
                        paddingInlineStart: calc(fontSize).add(token.paddingXS).equal(),
                        fontSize: fontSize,
                        lineHeight: 0,
                        pointerEvents: 'none',
                        '> div': {
                            margin: 0
                        }
                    }
                },
                [`${itemCls}:hover ${actionCls}`]: {
                    opacity: 1
                },
                [`${itemCls}-error`]: {
                    color: token.colorError,
                    [`${itemCls}-name, ${componentCls}-icon ${iconCls}`]: {
                        color: token.colorError
                    },
                    [actionsCls]: {
                        [`${iconCls}, ${iconCls}:hover`]: {
                            color: token.colorError
                        },
                        [actionCls]: {
                            opacity: 1
                        }
                    }
                },
                [`${componentCls}-list-item-container`]: {
                    transition: `opacity ${token.motionDurationSlow}, height ${token.motionDurationSlow}`,
                    // For smooth removing animation
                    '&::before': {
                        display: 'table',
                        width: 0,
                        height: 0,
                        content: '""'
                    }
                }
            })
        }
    };
};
var $44f7852be4d67267$export$2e2bcd8739ae039 = $44f7852be4d67267$var$genListStyle;


parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");

// =========================== Motion ===========================
const $c382263d20b7baeb$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const uploadAnimateInlineIn = new (0, $kB90R.default)('uploadAnimateInlineIn', {
        from: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const uploadAnimateInlineOut = new (0, $kB90R.default)('uploadAnimateInlineOut', {
        to: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const inlineCls = `${componentCls}-animate-inline`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${inlineCls}-appear, ${inlineCls}-enter, ${inlineCls}-leave`]: {
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseInOutCirc,
                    animationFillMode: 'forwards'
                },
                [`${inlineCls}-appear, ${inlineCls}-enter`]: {
                    animationName: uploadAnimateInlineIn
                },
                [`${inlineCls}-leave`]: {
                    animationName: uploadAnimateInlineOut
                }
            }
        },
        {
            [`${componentCls}-wrapper`]: (0, $97e15ec2e21e35be$export$2909268c8354a12)(token)
        },
        uploadAnimateInlineIn,
        uploadAnimateInlineOut
    ];
};
var $c382263d20b7baeb$export$2e2bcd8739ae039 = $c382263d20b7baeb$var$genMotionStyle;


parcelRequire("1T8KD");
var $lvl2c = parcelRequire("lvl2c");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $84f82e1195d98948$export$353fdbacdd19997a = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, uploadThumbnailSize: uploadThumbnailSize, uploadProgressOffset: uploadProgressOffset, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    return {
        [`${componentCls}-wrapper`]: {
            // ${listCls} 增加优先级
            [`
        ${listCls}${listCls}-picture,
        ${listCls}${listCls}-picture-card,
        ${listCls}${listCls}-picture-circle
      `]: {
                [itemCls]: {
                    position: 'relative',
                    height: calc(uploadThumbnailSize).add(calc(token.lineWidth).mul(2)).add(calc(token.paddingXS).mul(2)).equal(),
                    padding: token.paddingXS,
                    border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusLG,
                    '&:hover': {
                        background: 'transparent'
                    },
                    [`${itemCls}-thumbnail`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
                        width: uploadThumbnailSize,
                        height: uploadThumbnailSize,
                        lineHeight: (0, $4g3I0.unit)(calc(uploadThumbnailSize).add(token.paddingSM).equal()),
                        textAlign: 'center',
                        flex: 'none',
                        [iconCls]: {
                            fontSize: token.fontSizeHeading2,
                            color: token.colorPrimary
                        },
                        img: {
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden'
                        }
                    }),
                    [`${itemCls}-progress`]: {
                        bottom: uploadProgressOffset,
                        width: `calc(100% - ${(0, $4g3I0.unit)(calc(token.paddingSM).mul(2).equal())})`,
                        marginTop: 0,
                        paddingInlineStart: calc(uploadThumbnailSize).add(token.paddingXS).equal()
                    }
                },
                [`${itemCls}-error`]: {
                    borderColor: token.colorError,
                    // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
                    [`${itemCls}-thumbnail ${iconCls}`]: {
                        [`svg path[fill='${(0, $lvl2c.blue)[0]}']`]: {
                            fill: token.colorErrorBg
                        },
                        [`svg path[fill='${(0, $lvl2c.blue).primary}']`]: {
                            fill: token.colorError
                        }
                    }
                },
                [`${itemCls}-uploading`]: {
                    borderStyle: 'dashed',
                    [`${itemCls}-name`]: {
                        marginBottom: uploadProgressOffset
                    }
                }
            },
            [`${listCls}${listCls}-picture-circle ${itemCls}`]: {
                [`&, &::before, ${itemCls}-thumbnail`]: {
                    borderRadius: '50%'
                }
            }
        }
    };
};
const $84f82e1195d98948$export$31311f200c99910f = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    const uploadPictureCardSize = token.uploadPicCardSize;
    return {
        [`
      ${componentCls}-wrapper${componentCls}-picture-card-wrapper,
      ${componentCls}-wrapper${componentCls}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
            display: 'block',
            [`${componentCls}${componentCls}-select`]: {
                width: uploadPictureCardSize,
                height: uploadPictureCardSize,
                textAlign: 'center',
                verticalAlign: 'top',
                backgroundColor: token.colorFillAlter,
                border: `${(0, $4g3I0.unit)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                [`> ${componentCls}`]: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    textAlign: 'center'
                },
                [`&:not(${componentCls}-disabled):hover`]: {
                    borderColor: token.colorPrimary
                }
            },
            // list
            [`${listCls}${listCls}-picture-card, ${listCls}${listCls}-picture-circle`]: {
                display: 'flex',
                flexWrap: 'wrap',
                '@supports not (gap: 1px)': {
                    '& > *': {
                        marginBlockEnd: token.marginXS,
                        marginInlineEnd: token.marginXS
                    }
                },
                '@supports (gap: 1px)': {
                    gap: token.marginXS
                },
                [`${listCls}-item-container`]: {
                    display: 'inline-block',
                    width: uploadPictureCardSize,
                    height: uploadPictureCardSize,
                    verticalAlign: 'top'
                },
                '&::after': {
                    display: 'none'
                },
                '&::before': {
                    display: 'none'
                },
                [itemCls]: {
                    height: '100%',
                    margin: 0,
                    '&::before': {
                        position: 'absolute',
                        zIndex: 1,
                        width: `calc(100% - ${(0, $4g3I0.unit)(calc(token.paddingXS).mul(2).equal())})`,
                        height: `calc(100% - ${(0, $4g3I0.unit)(calc(token.paddingXS).mul(2).equal())})`,
                        backgroundColor: token.colorBgMask,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '" "'
                    }
                },
                [`${itemCls}:hover`]: {
                    [`&::before, ${itemCls}-actions`]: {
                        opacity: 1
                    }
                },
                [`${itemCls}-actions`]: {
                    position: 'absolute',
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: '100%',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    [`
            ${iconCls}-eye,
            ${iconCls}-download,
            ${iconCls}-delete
          `]: {
                        zIndex: 10,
                        width: fontSizeLG,
                        margin: `0 ${(0, $4g3I0.unit)(token.marginXXS)}`,
                        fontSize: fontSizeLG,
                        cursor: 'pointer',
                        transition: `all ${token.motionDurationSlow}`,
                        color: colorTextLightSolid,
                        '&:hover': {
                            color: colorTextLightSolid
                        },
                        svg: {
                            verticalAlign: 'baseline'
                        }
                    }
                },
                [`${itemCls}-thumbnail, ${itemCls}-thumbnail img`]: {
                    position: 'static',
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                },
                [`${itemCls}-name`]: {
                    display: 'none',
                    textAlign: 'center'
                },
                [`${itemCls}-file + ${itemCls}-name`]: {
                    position: 'absolute',
                    bottom: token.margin,
                    display: 'block',
                    width: `calc(100% - ${(0, $4g3I0.unit)(calc(token.paddingXS).mul(2).equal())})`
                },
                [`${itemCls}-uploading`]: {
                    [`&${itemCls}`]: {
                        backgroundColor: token.colorFillAlter
                    },
                    [`&::before, ${iconCls}-eye, ${iconCls}-download, ${iconCls}-delete`]: {
                        display: 'none'
                    }
                },
                [`${itemCls}-progress`]: {
                    bottom: token.marginXL,
                    width: `calc(100% - ${(0, $4g3I0.unit)(calc(token.paddingXS).mul(2).equal())})`,
                    paddingInlineStart: 0
                }
            }
        }),
        [`${componentCls}-wrapper${componentCls}-picture-circle-wrapper`]: {
            [`${componentCls}${componentCls}-select`]: {
                borderRadius: '50%'
            }
        }
    };
};


// =========================== Motion ===========================
const $5d386517471f8c08$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
var $5d386517471f8c08$export$2e2bcd8739ae039 = $5d386517471f8c08$var$genRtlStyle;


const $5aedd76ccc8873a8$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, colorTextDisabled: colorTextDisabled } = token;
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            [componentCls]: {
                outline: 0,
                "input[type='file']": {
                    cursor: 'pointer'
                }
            },
            [`${componentCls}-select`]: {
                display: 'inline-block'
            },
            [`${componentCls}-hidden`]: {
                display: 'none'
            },
            [`${componentCls}-disabled`]: {
                color: colorTextDisabled,
                cursor: 'not-allowed'
            }
        })
    };
};
const $5aedd76ccc8873a8$export$9ca1be8807fe0675 = (token)=>({
        actionsColor: token.colorTextDescription
    });
var // ============================== Export ==============================
$5aedd76ccc8873a8$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Upload', (token)=>{
    const { fontSizeHeading3: fontSizeHeading3, fontHeight: fontHeight, lineWidth: lineWidth, controlHeightLG: controlHeightLG, calc: calc } = token;
    const uploadToken = (0, $8APUt.merge)(token, {
        uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
        uploadProgressOffset: calc(calc(fontHeight).div(2)).add(lineWidth).equal(),
        uploadPicCardSize: calc(controlHeightLG).mul(2.55).equal()
    });
    return [
        $5aedd76ccc8873a8$var$genBaseStyle(uploadToken),
        (0, $81ae0b39565a0e23$export$2e2bcd8739ae039)(uploadToken),
        (0, $84f82e1195d98948$export$353fdbacdd19997a)(uploadToken),
        (0, $84f82e1195d98948$export$31311f200c99910f)(uploadToken),
        (0, $44f7852be4d67267$export$2e2bcd8739ae039)(uploadToken),
        (0, $c382263d20b7baeb$export$2e2bcd8739ae039)(uploadToken),
        (0, $5d386517471f8c08$export$2e2bcd8739ae039)(uploadToken),
        (0, $86923e4ddcddee59$export$2e2bcd8739ae039)(uploadToken)
    ];
}, $5aedd76ccc8873a8$export$9ca1be8807fe0675);



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $b07c21a391395f4c$var$FileTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "file",
    "theme": "twotone"
};
var $b07c21a391395f4c$export$2e2bcd8739ae039 = $b07c21a391395f4c$var$FileTwoTone;



var $a9a1b810f5b74777$var$FileTwoTone = function FileTwoTone(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $b07c21a391395f4c$export$2e2bcd8739ae039)
    }));
};
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzNCAzNTJWMTM2SDIzMnY3NTJoNTYwVjM5NEg1NzZhNDIgNDIgMCAwMS00Mi00MnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTYwMiAxMzcuOEw3OTAuMiAzMjZINjAyVjEzNy44ek03OTIgODg4SDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIGZpbGw9IiMxNjc3ZmYiIC8+PC9zdmc+) */ var $a9a1b810f5b74777$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($a9a1b810f5b74777$var$FileTwoTone);
$a9a1b810f5b74777$var$RefIcon.displayName = 'FileTwoTone';
var $a9a1b810f5b74777$export$2e2bcd8739ae039 = $a9a1b810f5b74777$var$RefIcon;




var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $76c550eaeba6ca1d$var$PaperClipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    },
    "name": "paper-clip",
    "theme": "outlined"
};
var $76c550eaeba6ca1d$export$2e2bcd8739ae039 = $76c550eaeba6ca1d$var$PaperClipOutlined;



var $ba3f7efdbb404e69$var$PaperClipOutlined = function PaperClipOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $76c550eaeba6ca1d$export$2e2bcd8739ae039)
    }));
};
/**![paper-clip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc3OS4zIDE5Ni42Yy05NC4yLTk0LjItMjQ3LjYtOTQuMi0zNDEuNyAwbC0yNjEgMjYwLjhjLTEuNyAxLjctMi42IDQtMi42IDYuNHMuOSA0LjcgMi42IDYuNGwzNi45IDM2LjlhOSA5IDAgMDAxMi43IDBsMjYxLTI2MC44YzMyLjQtMzIuNCA3NS41LTUwLjIgMTIxLjMtNTAuMnM4OC45IDE3LjggMTIxLjIgNTAuMmMzMi40IDMyLjQgNTAuMiA3NS41IDUwLjIgMTIxLjIgMCA0NS44LTE3LjggODguOC01MC4yIDEyMS4ybC0yNjYgMjY1LjktNDMuMSA0My4xYy00MC4zIDQwLjMtMTA1LjggNDAuMy0xNDYuMSAwLTE5LjUtMTkuNS0zMC4yLTQ1LjQtMzAuMi03M3MxMC43LTUzLjUgMzAuMi03M2wyNjMuOS0yNjMuOGM2LjctNi42IDE1LjUtMTAuMyAyNC45LTEwLjNoLjFjOS40IDAgMTguMSAzLjcgMjQuNyAxMC4zIDYuNyA2LjcgMTAuMyAxNS41IDEwLjMgMjQuOSAwIDkuMy0zLjcgMTguMS0xMC4zIDI0LjdMMzcyLjQgNjUzYy0xLjcgMS43LTIuNiA0LTIuNiA2LjRzLjkgNC43IDIuNiA2LjRsMzYuOSAzNi45YTkgOSAwIDAwMTIuNyAwbDIxNS42LTIxNS42YzE5LjktMTkuOSAzMC44LTQ2LjMgMzAuOC03NC40cy0xMS01NC42LTMwLjgtNzQuNGMtNDEuMS00MS4xLTEwNy45LTQxLTE0OSAwTDQ2MyAzNjQgMjI0LjggNjAyLjFBMTcyLjIyIDE3Mi4yMiAwIDAwMTc0IDcyNC44YzAgNDYuMyAxOC4xIDg5LjggNTAuOCAxMjIuNSAzMy45IDMzLjggNzguMyA1MC43IDEyMi43IDUwLjcgNDQuNCAwIDg4LjgtMTYuOSAxMjIuNi01MC43bDMwOS4yLTMwOUM4MjQuOCA0OTIuNyA4NTAgNDMyIDg1MCAzNjcuNWMuMS02NC42LTI1LjEtMTI1LjMtNzAuNy0xNzAuOXoiIC8+PC9zdmc+) */ var $ba3f7efdbb404e69$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($ba3f7efdbb404e69$var$PaperClipOutlined);
$ba3f7efdbb404e69$var$RefIcon.displayName = 'PaperClipOutlined';
var $ba3f7efdbb404e69$export$2e2bcd8739ae039 = $ba3f7efdbb404e69$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $f3ed1aa60fb74c65$var$PictureTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "picture",
    "theme": "twotone"
};
var $f3ed1aa60fb74c65$export$2e2bcd8739ae039 = $f3ed1aa60fb74c65$var$PictureTwoTone;



var $d57dc44ac781aa2e$var$PictureTwoTone = function PictureTwoTone(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $f3ed1aa60fb74c65$export$2e2bcd8739ae039)
    }));
};
/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNnYtMzkuOWwxMzguNS0xNjQuMyAxNTAuMSAxNzhMNjU4LjEgNDg5IDg4OCA3NjEuNlY3OTJ6bTAtMTI5LjhMNjY0LjIgMzk2LjhjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDQyNC42IDY2Ni40bC0xNDQtMTcwLjdjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDEzNiA2NTIuN1YyMzJoNzUydjQzMC4yeiIgZmlsbD0iIzE2NzdmZiIgLz48cGF0aCBkPSJNNDI0LjYgNzY1LjhsLTE1MC4xLTE3OEwxMzYgNzUyLjFWNzkyaDc1MnYtMzAuNEw2NTguMSA0ODl6IiBmaWxsPSIjZTZmNGZmIiAvPjxwYXRoIGQ9Ik0xMzYgNjUyLjdsMTMyLjQtMTU3YzMuMi0zLjggOS0zLjggMTIuMiAwbDE0NCAxNzAuN0w2NTIgMzk2LjhjMy4yLTMuOCA5LTMuOCAxMi4yIDBMODg4IDY2Mi4yVjIzMkgxMzZ2NDIwLjd6TTMwNCAyODBhODggODggMCAxMTAgMTc2IDg4IDg4IDAgMDEwLTE3NnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTI3NiAzNjhhMjggMjggMCAxMDU2IDAgMjggMjggMCAxMC01NiAweiIgZmlsbD0iI2U2ZjRmZiIgLz48cGF0aCBkPSJNMzA0IDQ1NmE4OCA4OCAwIDEwMC0xNzYgODggODggMCAwMDAgMTc2em0wLTExNmMxNS41IDAgMjggMTIuNSAyOCAyOHMtMTIuNSAyOC0yOCAyOC0yOC0xMi41LTI4LTI4IDEyLjUtMjggMjgtMjh6IiBmaWxsPSIjMTY3N2ZmIiAvPjwvc3ZnPg==) */ var $d57dc44ac781aa2e$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($d57dc44ac781aa2e$var$PictureTwoTone);
$d57dc44ac781aa2e$var$RefIcon.displayName = 'PictureTwoTone';
var $d57dc44ac781aa2e$export$2e2bcd8739ae039 = $d57dc44ac781aa2e$var$RefIcon;



var $giSak = parcelRequire("giSak");
parcelRequire("lsVqZ");
var $iCAxj = parcelRequire("iCAxj");
var $lsVqZ = parcelRequire("lsVqZ");

var $hvG6u = parcelRequire("hvG6u");

var $jMaZ8 = parcelRequire("jMaZ8");
function $3b33849fb1ac9a25$export$2e2bcd8739ae039() {
    const [, forceUpdate] = $jMaZ8.useReducer((x)=>x + 1, 0);
    return forceUpdate;
}







var $fvBso = parcelRequire("fvBso");
function $a73ed13c6461f0ed$export$6dc848fd109e803d(file) {
    return Object.assign(Object.assign({}, file), {
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        size: file.size,
        type: file.type,
        uid: file.uid,
        percent: 0,
        originFileObj: file
    });
}
function $a73ed13c6461f0ed$export$65c2063f64290f37(file, fileList) {
    const nextFileList = (0, $fvBso.default)(fileList);
    const fileIndex = nextFileList.findIndex((_ref)=>{
        let { uid: uid } = _ref;
        return uid === file.uid;
    });
    if (fileIndex === -1) nextFileList.push(file);
    else nextFileList[fileIndex] = file;
    return nextFileList;
}
function $a73ed13c6461f0ed$export$1165ac073f485fae(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    return fileList.filter((item)=>item[matchKey] === file[matchKey])[0];
}
function $a73ed13c6461f0ed$export$f3bced642db28a96(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    const removed = fileList.filter((item)=>item[matchKey] !== file[matchKey]);
    if (removed.length === fileList.length) return null;
    return removed;
}
// ==================== Default Image Preview ====================
const $a73ed13c6461f0ed$var$extname = function() {
    let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const temp = url.split('/');
    const filename = temp[temp.length - 1];
    const filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [
        ''
    ])[0];
};
const $a73ed13c6461f0ed$var$isImageFileType = (type)=>type.indexOf('image/') === 0;
const $a73ed13c6461f0ed$export$431d13c2db3f6781 = (file)=>{
    if (file.type && !file.thumbUrl) return $a73ed13c6461f0ed$var$isImageFileType(file.type);
    const url = file.thumbUrl || file.url || '';
    const extension = $a73ed13c6461f0ed$var$extname(url);
    if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(extension)) return true;
    if (/^data:/.test(url)) // other file types of base64
    return false;
    if (extension) // other file types which have extension
    return false;
    return true;
};
const $a73ed13c6461f0ed$var$MEASURE_SIZE = 200;
function $a73ed13c6461f0ed$export$b5db251096956c0d(file) {
    return new Promise((resolve)=>{
        if (!file.type || !$a73ed13c6461f0ed$var$isImageFileType(file.type)) {
            resolve('');
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = $a73ed13c6461f0ed$var$MEASURE_SIZE;
        canvas.height = $a73ed13c6461f0ed$var$MEASURE_SIZE;
        canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${$a73ed13c6461f0ed$var$MEASURE_SIZE}px; height: ${$a73ed13c6461f0ed$var$MEASURE_SIZE}px; z-index: 9999; display: none;`;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.onload = ()=>{
            const { width: width, height: height } = img;
            let drawWidth = $a73ed13c6461f0ed$var$MEASURE_SIZE;
            let drawHeight = $a73ed13c6461f0ed$var$MEASURE_SIZE;
            let offsetX = 0;
            let offsetY = 0;
            if (width > height) {
                drawHeight = height * ($a73ed13c6461f0ed$var$MEASURE_SIZE / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            } else {
                drawWidth = width * ($a73ed13c6461f0ed$var$MEASURE_SIZE / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            const dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);
            window.URL.revokeObjectURL(img.src);
            resolve(dataURL);
        };
        img.crossOrigin = 'anonymous';
        if (file.type.startsWith('image/svg+xml')) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result && typeof reader.result === 'string') img.src = reader.result;
            };
            reader.readAsDataURL(file);
        } else if (file.type.startsWith('image/gif')) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result) resolve(reader.result);
            };
            reader.readAsDataURL(file);
        } else img.src = window.URL.createObjectURL(file);
    });
}



var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $8df3dbde0b15683b$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
var $8df3dbde0b15683b$export$2e2bcd8739ae039 = $8df3dbde0b15683b$var$DeleteOutlined;



var $add96a083ff0f53e$var$DeleteOutlined = function DeleteOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $8df3dbde0b15683b$export$2e2bcd8739ae039)
    }));
};
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ var $add96a083ff0f53e$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($add96a083ff0f53e$var$DeleteOutlined);
$add96a083ff0f53e$var$RefIcon.displayName = 'DeleteOutlined';
var $add96a083ff0f53e$export$2e2bcd8739ae039 = $add96a083ff0f53e$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $8322162910b5ae6c$var$DownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "download",
    "theme": "outlined"
};
var $8322162910b5ae6c$export$2e2bcd8739ae039 = $8322162910b5ae6c$var$DownloadOutlined;



var $3b2623359dc2ca06$var$DownloadOutlined = function DownloadOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $8322162910b5ae6c$export$2e2bcd8739ae039)
    }));
};
/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ var $3b2623359dc2ca06$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($3b2623359dc2ca06$var$DownloadOutlined);
$3b2623359dc2ca06$var$RefIcon.displayName = 'DownloadOutlined';
var $3b2623359dc2ca06$export$2e2bcd8739ae039 = $3b2623359dc2ca06$var$RefIcon;




var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");



"use client";
const $6704965ea9f42d2f$var$ListItem = /*#__PURE__*/ $jMaZ8.forwardRef((_ref, ref)=>{
    let { prefixCls: prefixCls, className: className, style: style, locale: locale, listType: listType, file: file, items: items, progress: progressProps, iconRender: iconRender, actionIconRender: actionIconRender, itemRender: itemRender, isImgUrl: isImgUrl, showPreviewIcon: showPreviewIcon, showRemoveIcon: showRemoveIcon, showDownloadIcon: showDownloadIcon, previewIcon: customPreviewIcon, removeIcon: customRemoveIcon, downloadIcon: customDownloadIcon, extra: customExtra, onPreview: onPreview, onDownload: onDownload, onClose: onClose } = _ref;
    var _a, _b;
    // Status: which will ignore `removed` status
    const { status: status } = file;
    const [mergedStatus, setMergedStatus] = $jMaZ8.useState(status);
    $jMaZ8.useEffect(()=>{
        if (status !== 'removed') setMergedStatus(status);
    }, [
        status
    ]);
    // Delay to show the progress bar
    const [showProgress, setShowProgress] = $jMaZ8.useState(false);
    $jMaZ8.useEffect(()=>{
        const timer = setTimeout(()=>{
            setShowProgress(true);
        }, 300);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    const iconNode = iconRender(file);
    let icon = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-icon`
    }, iconNode);
    if (listType === 'picture' || listType === 'picture-card' || listType === 'picture-circle') {
        if (mergedStatus === 'uploading' || !file.thumbUrl && !file.url) {
            const uploadingClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: mergedStatus !== 'uploading'
            });
            icon = /*#__PURE__*/ $jMaZ8.createElement("div", {
                className: uploadingClassName
            }, iconNode);
        } else {
            const thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /*#__PURE__*/ $jMaZ8.createElement("img", {
                src: file.thumbUrl || file.url,
                alt: file.name,
                className: `${prefixCls}-list-item-image`,
                crossOrigin: file.crossOrigin
            }) : iconNode;
            const aClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: isImgUrl && !isImgUrl(file)
            });
            icon = /*#__PURE__*/ $jMaZ8.createElement("a", {
                className: aClassName,
                onClick: (e)=>onPreview(file, e),
                href: file.url || file.thumbUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, thumbnail);
        }
    }
    const listItemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list-item`, `${prefixCls}-list-item-${mergedStatus}`);
    const linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
    const removeIcon = (typeof showRemoveIcon === 'function' ? showRemoveIcon(file) : showRemoveIcon) ? actionIconRender((typeof customRemoveIcon === 'function' ? customRemoveIcon(file) : customRemoveIcon) || /*#__PURE__*/ $jMaZ8.createElement((0, $add96a083ff0f53e$export$2e2bcd8739ae039), null), ()=>onClose(file), prefixCls, locale.removeFile, // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    true) : null;
    const downloadIcon = (typeof showDownloadIcon === 'function' ? showDownloadIcon(file) : showDownloadIcon) && mergedStatus === 'done' ? actionIconRender((typeof customDownloadIcon === 'function' ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/ $jMaZ8.createElement((0, $3b2623359dc2ca06$export$2e2bcd8739ae039), null), ()=>onDownload(file), prefixCls, locale.downloadFile) : null;
    const downloadOrDelete = listType !== 'picture-card' && listType !== 'picture-circle' && /*#__PURE__*/ $jMaZ8.createElement("span", {
        key: "download-delete",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list-item-actions`, {
            picture: listType === 'picture'
        })
    }, downloadIcon, removeIcon);
    const extraContent = typeof customExtra === 'function' ? customExtra(file) : customExtra;
    const extra = extraContent && /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-list-item-extra`
    }, extraContent);
    const listItemNameClass = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list-item-name`);
    const fileName = file.url ? /*#__PURE__*/ $jMaZ8.createElement("a", Object.assign({
        key: "view",
        target: "_blank",
        rel: "noopener noreferrer",
        className: listItemNameClass,
        title: file.name
    }, linkProps, {
        href: file.url,
        onClick: (e)=>onPreview(file, e)
    }), file.name, extra) : /*#__PURE__*/ $jMaZ8.createElement("span", {
        key: "view",
        className: listItemNameClass,
        onClick: (e)=>onPreview(file, e),
        title: file.name
    }, file.name, extra);
    const previewIcon = (typeof showPreviewIcon === 'function' ? showPreviewIcon(file) : showPreviewIcon) && (file.url || file.thumbUrl) ? /*#__PURE__*/ $jMaZ8.createElement("a", {
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (e)=>onPreview(file, e),
        title: locale.previewFile
    }, typeof customPreviewIcon === 'function' ? customPreviewIcon(file) : customPreviewIcon || /*#__PURE__*/ $jMaZ8.createElement((0, $7943495b95953283$export$2e2bcd8739ae039), null)) : null;
    const pictureCardActions = (listType === 'picture-card' || listType === 'picture-circle') && mergedStatus !== 'uploading' && /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-list-item-actions`
    }, previewIcon, mergedStatus === 'done' && downloadIcon, removeIcon);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const dom = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: listItemClassName
    }, icon, fileName, downloadOrDelete, pictureCardActions, showProgress && /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), {
        motionName: `${rootPrefixCls}-fade`,
        visible: mergedStatus === 'uploading',
        motionDeadline: 2000
    }, (_ref2)=>{
        let { className: motionClassName } = _ref2;
        // show loading icon if upload progress listener is disabled
        const loadingProgress = 'percent' in file ? /*#__PURE__*/ $jMaZ8.createElement((0, $eef464bb94d68b8c$export$2e2bcd8739ae039), Object.assign({}, progressProps, {
            type: "line",
            percent: file.percent,
            "aria-label": file['aria-label'],
            "aria-labelledby": file['aria-labelledby']
        })) : null;
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list-item-progress`, motionClassName)
        }, loadingProgress);
    }));
    const message = file.response && typeof file.response === 'string' ? file.response : ((_a = file.error) === null || _a === void 0 ? void 0 : _a.statusText) || ((_b = file.error) === null || _b === void 0 ? void 0 : _b.message) || locale.uploadError;
    const item = mergedStatus === 'error' ? /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
        title: message,
        getPopupContainer: (node)=>node.parentNode
    }, dom) : dom;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list-item-container`, className),
        style: style,
        ref: ref
    }, itemRender ? itemRender(item, file, items, {
        download: onDownload.bind(null, file),
        preview: onPreview.bind(null, file),
        remove: onClose.bind(null, file)
    }) : item);
});
var $6704965ea9f42d2f$export$2e2bcd8739ae039 = $6704965ea9f42d2f$var$ListItem;


"use client";
const $c5c82bb661cca3d6$var$InternalUploadList = (props, ref)=>{
    const { listType: listType = 'text', previewFile: previewFile = (0, $a73ed13c6461f0ed$export$b5db251096956c0d), onPreview: onPreview, onDownload: onDownload, onRemove: onRemove, locale: locale, iconRender: iconRender, isImageUrl: isImgUrl = (0, $a73ed13c6461f0ed$export$431d13c2db3f6781), prefixCls: customizePrefixCls, items: items = [], showPreviewIcon: showPreviewIcon = true, showRemoveIcon: showRemoveIcon = true, showDownloadIcon: showDownloadIcon = false, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra, progress: progress = {
        size: [
            -1,
            2
        ],
        showInfo: false
    }, appendAction: appendAction, appendActionVisible: appendActionVisible = true, itemRender: itemRender, disabled: disabled } = props;
    const forceUpdate = (0, $3b33849fb1ac9a25$export$2e2bcd8739ae039)();
    const [motionAppear, setMotionAppear] = $jMaZ8.useState(false);
    const isPictureCardOrCirle = [
        'picture-card',
        'picture-circle'
    ].includes(listType);
    // ============================= Effect =============================
    $jMaZ8.useEffect(()=>{
        if (!listType.startsWith('picture')) return;
        (items || []).forEach((file)=>{
            if (!(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) return;
            file.thumbUrl = '';
            previewFile === null || previewFile === void 0 || previewFile(file.originFileObj).then((previewDataUrl)=>{
                // Need append '' to avoid dead loop
                file.thumbUrl = previewDataUrl || '';
                forceUpdate();
            });
        });
    }, [
        listType,
        items,
        previewFile
    ]);
    $jMaZ8.useEffect(()=>{
        setMotionAppear(true);
    }, []);
    // ============================= Events =============================
    const onInternalPreview = (file, e)=>{
        if (!onPreview) return;
        e === null || e === void 0 || e.preventDefault();
        return onPreview(file);
    };
    const onInternalDownload = (file)=>{
        if (typeof onDownload === 'function') onDownload(file);
        else if (file.url) window.open(file.url);
    };
    const onInternalClose = (file)=>{
        onRemove === null || onRemove === void 0 || onRemove(file);
    };
    const internalIconRender = (file)=>{
        if (iconRender) return iconRender(file, listType);
        const isLoading = file.status === 'uploading';
        if (listType.startsWith('picture')) {
            const loadingIcon = listType === 'picture' ? /*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), null) : locale.uploading;
            const fileIcon = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /*#__PURE__*/ $jMaZ8.createElement((0, $d57dc44ac781aa2e$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $a9a1b810f5b74777$export$2e2bcd8739ae039), null);
            return isLoading ? loadingIcon : fileIcon;
        }
        return isLoading ? /*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $ba3f7efdbb404e69$export$2e2bcd8739ae039), null);
    };
    const actionIconRender = (customIcon, callback, prefixCls, title, acceptUploadDisabled)=>{
        const btnProps = {
            type: 'text',
            size: 'small',
            title: title,
            onClick: (e)=>{
                var _a, _b;
                callback();
                if (/*#__PURE__*/ $jMaZ8.isValidElement(customIcon)) (_b = (_a = customIcon.props).onClick) === null || _b === void 0 || _b.call(_a, e);
            },
            className: `${prefixCls}-list-item-action`
        };
        if (acceptUploadDisabled) btnProps.disabled = disabled;
        return /*#__PURE__*/ $jMaZ8.isValidElement(customIcon) ? /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), Object.assign({}, btnProps, {
            icon: (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(customIcon, Object.assign(Object.assign({}, customIcon.props), {
                onClick: ()=>{}
            }))
        })) : /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), Object.assign({}, btnProps), /*#__PURE__*/ $jMaZ8.createElement("span", null, customIcon));
    };
    // ============================== Ref ===============================
    // Test needs
    $jMaZ8.useImperativeHandle(ref, ()=>({
            handlePreview: onInternalPreview,
            handleDownload: onInternalDownload
        }));
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    // ============================= Render =============================
    const prefixCls = getPrefixCls('upload', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const listClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-list`, `${prefixCls}-list-${listType}`);
    const listItemMotion = $jMaZ8.useMemo(()=>(0, $hvG6u.default)((0, $230791b6f61cb981$export$2e2bcd8739ae039)(rootPrefixCls), [
            'onAppearEnd',
            'onEnterEnd',
            'onLeaveEnd'
        ]), [
        rootPrefixCls
    ]);
    const motionConfig = Object.assign(Object.assign({}, isPictureCardOrCirle ? {} : listItemMotion), {
        motionDeadline: 2000,
        motionName: `${prefixCls}-${isPictureCardOrCirle ? 'animate-inline' : 'animate'}`,
        keys: (0, $fvBso.default)(items.map((file)=>({
                key: file.uid,
                file: file
            }))),
        motionAppear: motionAppear
    });
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: listClassNames
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $iCAxj.default), Object.assign({}, motionConfig, {
        component: false
    }), (_ref)=>{
        let { key: key, file: file, className: motionClassName, style: motionStyle } = _ref;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $6704965ea9f42d2f$export$2e2bcd8739ae039), {
            key: key,
            locale: locale,
            prefixCls: prefixCls,
            className: motionClassName,
            style: motionStyle,
            file: file,
            items: items,
            progress: progress,
            listType: listType,
            isImgUrl: isImgUrl,
            showPreviewIcon: showPreviewIcon,
            showRemoveIcon: showRemoveIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            extra: extra,
            iconRender: internalIconRender,
            actionIconRender: actionIconRender,
            itemRender: itemRender,
            onPreview: onInternalPreview,
            onDownload: onInternalDownload,
            onClose: onInternalClose
        });
    }), appendAction && /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), Object.assign({}, motionConfig, {
        visible: appendActionVisible,
        forceRender: true
    }), (_ref2)=>{
        let { className: motionClassName, style: motionStyle } = _ref2;
        return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(appendAction, (oriProps)=>({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(oriProps.className, motionClassName),
                style: Object.assign(Object.assign(Object.assign({}, motionStyle), {
                    // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
                    pointerEvents: motionClassName ? 'none' : undefined
                }), oriProps.style)
            }));
    }));
};
const $c5c82bb661cca3d6$var$UploadList = /*#__PURE__*/ $jMaZ8.forwardRef($c5c82bb661cca3d6$var$InternalUploadList);
$c5c82bb661cca3d6$var$UploadList.displayName = 'UploadList';
var $c5c82bb661cca3d6$export$2e2bcd8739ae039 = $c5c82bb661cca3d6$var$UploadList;



"use client";
var $6e2e88bcb84c3167$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6e2e88bcb84c3167$export$8f9bb9ff126b1bf5 = `__LIST_IGNORE_${Date.now()}__`;
const $6e2e88bcb84c3167$var$InternalUpload = (props, ref)=>{
    const { fileList: fileList, defaultFileList: defaultFileList, onRemove: onRemove, showUploadList: showUploadList = true, listType: listType = 'text', onPreview: onPreview, onDownload: onDownload, onChange: onChange, onDrop: onDrop, previewFile: previewFile, disabled: customDisabled, locale: propLocale, iconRender: iconRender, isImageUrl: isImageUrl, progress: progress, prefixCls: customizePrefixCls, className: className, type: type = 'select', children: children, style: style, itemRender: itemRender, maxCount: maxCount, data: data = {}, multiple: multiple = false, hasControlInside: hasControlInside = true, action: action = '', accept: accept = '', supportServerRender: supportServerRender = true, rootClassName: rootClassName } = props;
    // ===================== Disabled =====================
    const disabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const [mergedFileList, setMergedFileList] = (0, $eGh7a.default)(defaultFileList || [], {
        value: fileList,
        postState: (list)=>list !== null && list !== void 0 ? list : []
    });
    const [dragState, setDragState] = $jMaZ8.useState('drop');
    const upload = $jMaZ8.useRef(null);
    const wrapRef = $jMaZ8.useRef(null);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Upload');
        warning('fileList' in props || !('value' in props), 'usage', '`value` is not a valid prop, do you mean `fileList`?');
        warning.deprecated(!('transformFile' in props), 'transformFile', 'beforeUpload');
    }
    // Control mode will auto fill file uid if not provided
    $jMaZ8.useMemo(()=>{
        const timestamp = Date.now();
        (fileList || []).forEach((file, index)=>{
            if (!file.uid && !Object.isFrozen(file)) file.uid = `__AUTO__${timestamp}_${index}__`;
        });
    }, [
        fileList
    ]);
    const onInternalChange = (file, changedFileList, event)=>{
        let cloneList = (0, $fvBso.default)(changedFileList);
        let exceedMaxCount = false;
        // Cut to match count
        if (maxCount === 1) cloneList = cloneList.slice(-1);
        else if (maxCount) {
            exceedMaxCount = cloneList.length > maxCount;
            cloneList = cloneList.slice(0, maxCount);
        }
        // Prevent React18 auto batch since input[upload] trigger process at same time
        // which makes fileList closure problem
        (0, $6UWRi.flushSync)(()=>{
            setMergedFileList(cloneList);
        });
        const changeInfo = {
            file: file,
            fileList: cloneList
        };
        if (event) changeInfo.event = event;
        if (!exceedMaxCount || file.status === 'removed' || // We should ignore event if current file is exceed `maxCount`
        cloneList.some((f)=>f.uid === file.uid)) (0, $6UWRi.flushSync)(()=>{
            onChange === null || onChange === void 0 || onChange(changeInfo);
        });
    };
    const mergedBeforeUpload = (file, fileListArgs)=>$6e2e88bcb84c3167$var$__awaiter(void 0, void 0, void 0, function*() {
            const { beforeUpload: beforeUpload, transformFile: transformFile } = props;
            let parsedFile = file;
            if (beforeUpload) {
                const result = yield beforeUpload(file, fileListArgs);
                if (result === false) return false;
                // Hack for LIST_IGNORE, we add additional info to remove from the list
                delete file[$6e2e88bcb84c3167$export$8f9bb9ff126b1bf5];
                if (result === $6e2e88bcb84c3167$export$8f9bb9ff126b1bf5) {
                    Object.defineProperty(file, $6e2e88bcb84c3167$export$8f9bb9ff126b1bf5, {
                        value: true,
                        configurable: true
                    });
                    return false;
                }
                if (typeof result === 'object' && result) parsedFile = result;
            }
            if (transformFile) parsedFile = yield transformFile(parsedFile);
            return parsedFile;
        });
    const onBatchStart = (batchFileInfoList)=>{
        // Skip file which marked as `LIST_IGNORE`, these file will not add to file list
        const filteredFileInfoList = batchFileInfoList.filter((info)=>!info.file[$6e2e88bcb84c3167$export$8f9bb9ff126b1bf5]);
        // Nothing to do since no file need upload
        if (!filteredFileInfoList.length) return;
        const objectFileList = filteredFileInfoList.map((info)=>(0, $a73ed13c6461f0ed$export$6dc848fd109e803d)(info.file));
        // Concat new files with prev files
        let newFileList = (0, $fvBso.default)(mergedFileList);
        objectFileList.forEach((fileObj)=>{
            // Replace file if exist
            newFileList = (0, $a73ed13c6461f0ed$export$65c2063f64290f37)(fileObj, newFileList);
        });
        objectFileList.forEach((fileObj, index)=>{
            // Repeat trigger `onChange` event for compatible
            let triggerFileObj = fileObj;
            if (!filteredFileInfoList[index].parsedFile) {
                // `beforeUpload` return false
                const { originFileObj: originFileObj } = fileObj;
                let clone;
                try {
                    clone = new File([
                        originFileObj
                    ], originFileObj.name, {
                        type: originFileObj.type
                    });
                } catch (_a) {
                    clone = new Blob([
                        originFileObj
                    ], {
                        type: originFileObj.type
                    });
                    clone.name = originFileObj.name;
                    clone.lastModifiedDate = new Date();
                    clone.lastModified = new Date().getTime();
                }
                clone.uid = fileObj.uid;
                triggerFileObj = clone;
            } else // Inject `uploading` status
            fileObj.status = 'uploading';
            onInternalChange(triggerFileObj, newFileList);
        });
    };
    const onSuccess = (response, file, xhr)=>{
        try {
            if (typeof response === 'string') // biome-ignore lint/style/noParameterAssign: we need to modify response
            response = JSON.parse(response);
        } catch (_a) {
        /* do nothing */ }
        // removed
        if (!(0, $a73ed13c6461f0ed$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $a73ed13c6461f0ed$export$6dc848fd109e803d)(file);
        targetItem.status = 'done';
        targetItem.percent = 100;
        targetItem.response = response;
        targetItem.xhr = xhr;
        const nextFileList = (0, $a73ed13c6461f0ed$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const onProgress = (e, file)=>{
        // removed
        if (!(0, $a73ed13c6461f0ed$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $a73ed13c6461f0ed$export$6dc848fd109e803d)(file);
        targetItem.status = 'uploading';
        targetItem.percent = e.percent;
        const nextFileList = (0, $a73ed13c6461f0ed$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList, e);
    };
    const onError = (error, response, file)=>{
        // removed
        if (!(0, $a73ed13c6461f0ed$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $a73ed13c6461f0ed$export$6dc848fd109e803d)(file);
        targetItem.error = error;
        targetItem.response = response;
        targetItem.status = 'error';
        const nextFileList = (0, $a73ed13c6461f0ed$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const handleRemove = (file)=>{
        let currentFile;
        Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then((ret)=>{
            var _a;
            // Prevent removing file
            if (ret === false) return;
            const removedFileList = (0, $a73ed13c6461f0ed$export$f3bced642db28a96)(file, mergedFileList);
            if (removedFileList) {
                currentFile = Object.assign(Object.assign({}, file), {
                    status: 'removed'
                });
                mergedFileList === null || mergedFileList === void 0 || mergedFileList.forEach((item)=>{
                    const matchKey = currentFile.uid !== undefined ? 'uid' : 'name';
                    if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) item.status = 'removed';
                });
                (_a = upload.current) === null || _a === void 0 || _a.abort(currentFile);
                onInternalChange(currentFile, removedFileList);
            }
        });
    };
    const onFileDrop = (e)=>{
        setDragState(e.type);
        if (e.type === 'drop') onDrop === null || onDrop === void 0 || onDrop(e);
    };
    // Test needs
    $jMaZ8.useImperativeHandle(ref, ()=>({
            onBatchStart: onBatchStart,
            onSuccess: onSuccess,
            onProgress: onProgress,
            onError: onError,
            fileList: mergedFileList,
            upload: upload.current,
            nativeElement: wrapRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, upload: ctxUpload } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('upload', customizePrefixCls);
    const rcUploadProps = Object.assign(Object.assign({
        onBatchStart: onBatchStart,
        onError: onError,
        onProgress: onProgress,
        onSuccess: onSuccess
    }, props), {
        data: data,
        multiple: multiple,
        action: action,
        accept: accept,
        supportServerRender: supportServerRender,
        prefixCls: prefixCls,
        disabled: mergedDisabled,
        beforeUpload: mergedBeforeUpload,
        onChange: undefined,
        hasControlInside: hasControlInside
    });
    delete rcUploadProps.className;
    delete rcUploadProps.style;
    // Remove id to avoid open by label when trigger is hidden
    // !children: https://github.com/ant-design/ant-design/issues/14298
    // disabled: https://github.com/ant-design/ant-design/issues/16478
    //           https://github.com/ant-design/ant-design/issues/24197
    if (!children || mergedDisabled) delete rcUploadProps.id;
    const wrapperCls = `${prefixCls}-wrapper`;
    const [wrapCSSVar, hashId, cssVarCls] = (0, $5aedd76ccc8873a8$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    const [contextLocale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Upload', (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039).Upload);
    const { showRemoveIcon: showRemoveIcon, showPreviewIcon: showPreviewIcon, showDownloadIcon: showDownloadIcon, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra } = typeof showUploadList === 'boolean' ? {} : showUploadList;
    // use showRemoveIcon if it is specified explicitly
    const realShowRemoveIcon = typeof showRemoveIcon === 'undefined' ? !mergedDisabled : showRemoveIcon;
    const renderUploadList = (button, buttonVisible)=>{
        if (!showUploadList) return button;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $c5c82bb661cca3d6$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            listType: listType,
            items: mergedFileList,
            previewFile: previewFile,
            onPreview: onPreview,
            onDownload: onDownload,
            onRemove: handleRemove,
            showRemoveIcon: realShowRemoveIcon,
            showPreviewIcon: showPreviewIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            iconRender: iconRender,
            extra: extra,
            locale: Object.assign(Object.assign({}, contextLocale), propLocale),
            isImageUrl: isImageUrl,
            progress: progress,
            appendAction: button,
            appendActionVisible: buttonVisible,
            itemRender: itemRender,
            disabled: mergedDisabled
        });
    };
    const mergedCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(wrapperCls, className, rootClassName, hashId, cssVarCls, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.className, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-picture-card-wrapper`]: listType === 'picture-card',
        [`${prefixCls}-picture-circle-wrapper`]: listType === 'picture-circle'
    });
    const mergedStyle = Object.assign(Object.assign({}, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.style), style);
    // ======================== Render ========================
    if (type === 'drag') {
        const dragCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(hashId, prefixCls, `${prefixCls}-drag`, {
            [`${prefixCls}-drag-uploading`]: mergedFileList.some((file)=>file.status === 'uploading'),
            [`${prefixCls}-drag-hover`]: dragState === 'dragover',
            [`${prefixCls}-disabled`]: mergedDisabled,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        });
        return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("span", {
            className: mergedCls,
            ref: wrapRef
        }, /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: dragCls,
            style: mergedStyle,
            onDrop: onFileDrop,
            onDragOver: onFileDrop,
            onDragLeave: onFileDrop
        }, /*#__PURE__*/ $jMaZ8.createElement((0, $2075b3716f0f8e69$export$2e2bcd8739ae039), Object.assign({}, rcUploadProps, {
            ref: upload,
            className: `${prefixCls}-btn`
        }), /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-drag-container`
        }, children))), renderUploadList()));
    }
    const uploadBtnCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-select`, {
        [`${prefixCls}-disabled`]: mergedDisabled,
        [`${prefixCls}-hidden`]: !children
    });
    const uploadButton = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: uploadBtnCls
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $2075b3716f0f8e69$export$2e2bcd8739ae039), Object.assign({}, rcUploadProps, {
        ref: upload
    })));
    if (listType === 'picture-card' || listType === 'picture-circle') return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("span", {
        className: mergedCls,
        ref: wrapRef
    }, renderUploadList(uploadButton, !!children)));
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("span", {
        className: mergedCls,
        ref: wrapRef
    }, uploadButton, renderUploadList()));
};
const $6e2e88bcb84c3167$var$Upload = /*#__PURE__*/ $jMaZ8.forwardRef($6e2e88bcb84c3167$var$InternalUpload);
$6e2e88bcb84c3167$var$Upload.displayName = 'Upload';
var $6e2e88bcb84c3167$export$2e2bcd8739ae039 = $6e2e88bcb84c3167$var$Upload;


"use client";
var $8a8aa3af7b61ebfb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8a8aa3af7b61ebfb$var$Dragger = /*#__PURE__*/ $jMaZ8.forwardRef((_a, ref)=>{
    var { style: style, height: height, hasControlInside: hasControlInside = false } = _a, restProps = $8a8aa3af7b61ebfb$var$__rest(_a, [
        "style",
        "height",
        "hasControlInside"
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $6e2e88bcb84c3167$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        hasControlInside: hasControlInside
    }, restProps, {
        type: "drag",
        style: Object.assign(Object.assign({}, style), {
            height: height
        })
    }));
});
$8a8aa3af7b61ebfb$var$Dragger.displayName = 'Dragger';
var $8a8aa3af7b61ebfb$export$2e2bcd8739ae039 = $8a8aa3af7b61ebfb$var$Dragger;



"use client";
const $d4ae1c238156c9e2$var$Upload = (0, $6e2e88bcb84c3167$export$2e2bcd8739ae039);
$d4ae1c238156c9e2$var$Upload.Dragger = (0, $8a8aa3af7b61ebfb$export$2e2bcd8739ae039);
$d4ae1c238156c9e2$var$Upload.LIST_IGNORE = (0, $6e2e88bcb84c3167$export$8f9bb9ff126b1bf5);
var $d4ae1c238156c9e2$export$2e2bcd8739ae039 = $d4ae1c238156c9e2$var$Upload;



var $jMaZ8 = parcelRequire("jMaZ8");

function $09e949c946c9ba35$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $09e949c946c9ba35$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $09e949c946c9ba35$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $09e949c946c9ba35$var$_typeof(obj);
}
function $09e949c946c9ba35$export$2e2bcd8739ae039(value) {
    return $09e949c946c9ba35$var$_typeof(value) == 'object' && value !== null;
}


// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $83b7b7dc094e74d5$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $83b7b7dc094e74d5$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $83b7b7dc094e74d5$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $2ca642a4b0eb6648$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $a27ffd0ec8e83e1c$export$96a9681e539deed(location) {
    return $a27ffd0ec8e83e1c$export$867940333fd9f869(location.source, (0, $2ca642a4b0eb6648$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $a27ffd0ec8e83e1c$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $a27ffd0ec8e83e1c$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a27ffd0ec8e83e1c$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $a27ffd0ec8e83e1c$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $a27ffd0ec8e83e1c$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $a27ffd0ec8e83e1c$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $a27ffd0ec8e83e1c$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $a27ffd0ec8e83e1c$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $a27ffd0ec8e83e1c$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $a27ffd0ec8e83e1c$var$leftPad(len, str) {
    return $a27ffd0ec8e83e1c$var$whitespace(len - str.length) + str;
}


function $98041fa0b82346f3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $98041fa0b82346f3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $98041fa0b82346f3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $98041fa0b82346f3$var$_typeof(obj);
}
function $98041fa0b82346f3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $98041fa0b82346f3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $98041fa0b82346f3$var$ownKeys(Object(source), true).forEach(function(key) {
            $98041fa0b82346f3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $98041fa0b82346f3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $98041fa0b82346f3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $98041fa0b82346f3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $98041fa0b82346f3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $98041fa0b82346f3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $98041fa0b82346f3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $98041fa0b82346f3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $98041fa0b82346f3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $98041fa0b82346f3$var$_setPrototypeOf(subClass, superClass);
}
function $98041fa0b82346f3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $98041fa0b82346f3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $98041fa0b82346f3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $98041fa0b82346f3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $98041fa0b82346f3$var$_possibleConstructorReturn(this, result);
    };
}
function $98041fa0b82346f3$var$_possibleConstructorReturn(self, call) {
    if (call && ($98041fa0b82346f3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $98041fa0b82346f3$var$_assertThisInitialized(self);
}
function $98041fa0b82346f3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $98041fa0b82346f3$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $98041fa0b82346f3$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$98041fa0b82346f3$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $98041fa0b82346f3$var$_construct(Class, arguments, $98041fa0b82346f3$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $98041fa0b82346f3$var$_setPrototypeOf(Wrapper, Class);
    };
    return $98041fa0b82346f3$var$_wrapNativeSuper(Class);
}
function $98041fa0b82346f3$var$_construct(Parent, args, Class) {
    if ($98041fa0b82346f3$var$_isNativeReflectConstruct()) $98041fa0b82346f3$var$_construct = Reflect.construct;
    else $98041fa0b82346f3$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $98041fa0b82346f3$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $98041fa0b82346f3$var$_construct.apply(null, arguments);
}
function $98041fa0b82346f3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $98041fa0b82346f3$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $98041fa0b82346f3$var$_setPrototypeOf(o, p) {
    $98041fa0b82346f3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $98041fa0b82346f3$var$_setPrototypeOf(o, p);
}
function $98041fa0b82346f3$var$_getPrototypeOf(o) {
    $98041fa0b82346f3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $98041fa0b82346f3$var$_getPrototypeOf(o);
}
var $98041fa0b82346f3$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $98041fa0b82346f3$var$_inherits(GraphQLError, _Error);
    var _super = $98041fa0b82346f3$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $98041fa0b82346f3$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $98041fa0b82346f3$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $98041fa0b82346f3$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $2ca642a4b0eb6648$export$e7fd20fad3cf4b5f)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $2ca642a4b0eb6648$export$e7fd20fad3cf4b5f)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $09e949c946c9ba35$export$2e2bcd8739ae039)(originalExtensions)) _this.extensions = $98041fa0b82346f3$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($98041fa0b82346f3$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($98041fa0b82346f3$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $98041fa0b82346f3$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($98041fa0b82346f3$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($98041fa0b82346f3$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $98041fa0b82346f3$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $98041fa0b82346f3$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $83b7b7dc094e74d5$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $98041fa0b82346f3$var$_wrapNativeSuper(Error));
function $98041fa0b82346f3$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $98041fa0b82346f3$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $a27ffd0ec8e83e1c$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $a27ffd0ec8e83e1c$export$867940333fd9f869)(error.source, location);
    }
    return output;
}


function $2d76783bf6a7ac51$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $98041fa0b82346f3$export$92d6ed0888e7cb7f)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}


/**
 * The set of allowed kind values for AST nodes.
 */ var $38005e35e9207b1b$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 


function $9cbc268b16623d12$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $80a7376e282764fb$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $80a7376e282764fb$export$2e2bcd8739ae039 = $80a7376e282764fb$var$nodejsCustomInspectSymbol;


function $a5fd25e7b0498d08$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $9cbc268b16623d12$export$2e2bcd8739ae039)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $80a7376e282764fb$export$2e2bcd8739ae039) classObject.prototype[0, $80a7376e282764fb$export$2e2bcd8739ae039] = fn;
}


var $83bbfab21ea3efd5$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $a5fd25e7b0498d08$export$2e2bcd8739ae039)($83bbfab21ea3efd5$export$18a2be9195644f38);
var $83bbfab21ea3efd5$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $a5fd25e7b0498d08$export$2e2bcd8739ae039)($83bbfab21ea3efd5$export$50792b0e93539fde);
function $83bbfab21ea3efd5$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $052b64dbd01dbe0d$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 




function $c26b043c89ca158f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c26b043c89ca158f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c26b043c89ca158f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c26b043c89ca158f$var$_typeof(obj);
}
var $c26b043c89ca158f$var$MAX_ARRAY_LENGTH = 10;
var $c26b043c89ca158f$var$MAX_RECURSIVE_DEPTH = 2;
function $c26b043c89ca158f$export$2e2bcd8739ae039(value) {
    return $c26b043c89ca158f$var$formatValue(value, []);
}
function $c26b043c89ca158f$var$formatValue(value, seenValues) {
    switch($c26b043c89ca158f$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $c26b043c89ca158f$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $c26b043c89ca158f$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $c26b043c89ca158f$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $c26b043c89ca158f$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $c26b043c89ca158f$var$formatArray(value, seenValues);
    return $c26b043c89ca158f$var$formatObject(value, seenValues);
}
function $c26b043c89ca158f$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $c26b043c89ca158f$var$MAX_RECURSIVE_DEPTH) return '[' + $c26b043c89ca158f$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $c26b043c89ca158f$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $c26b043c89ca158f$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $c26b043c89ca158f$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($c26b043c89ca158f$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($c26b043c89ca158f$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $c26b043c89ca158f$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $80a7376e282764fb$export$2e2bcd8739ae039))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $c26b043c89ca158f$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


function $bcc5ddb3cf39533e$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}



function $250bfff619dcbb75$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $250bfff619dcbb75$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $250bfff619dcbb75$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $250bfff619dcbb75$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$250bfff619dcbb75$export$2e2bcd8739ae039 = function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if ($250bfff619dcbb75$var$_typeof(value) === 'object' && value !== null) {
        var _value$constructor;
        var className = constructor.prototype[Symbol.toStringTag];
        var valueClassName = Symbol.toStringTag in value ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            var stringifiedValue = (0, $c26b043c89ca158f$export$2e2bcd8739ae039)(value);
            throw new Error("Cannot use ".concat(className, " \"").concat(stringifiedValue, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
        }
    }
    return false;
};


function $c54728276ecd480f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c54728276ecd480f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c54728276ecd480f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c54728276ecd480f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $c54728276ecd480f$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $bcc5ddb3cf39533e$export$2e2bcd8739ae039)(0, "Body must be a string. Received: ".concat((0, $c26b043c89ca158f$export$2e2bcd8739ae039)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $bcc5ddb3cf39533e$export$2e2bcd8739ae039)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $bcc5ddb3cf39533e$export$2e2bcd8739ae039)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $c54728276ecd480f$var$_createClass(Source, [
        {
            key: (0, $83b7b7dc094e74d5$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $c54728276ecd480f$export$75135ee9ed6e435b(source) {
    return (0, $250bfff619dcbb75$export$2e2bcd8739ae039)(source, $c54728276ecd480f$export$1d2df86270c81ecb);
}


/**
 * The set of allowed directive location values.
 */ var $1dd8848cd870b8d3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 





/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $a09f77d2f3f4bca5$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $a09f77d2f3f4bca5$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $a09f77d2f3f4bca5$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $a09f77d2f3f4bca5$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $a09f77d2f3f4bca5$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $a09f77d2f3f4bca5$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $a09f77d2f3f4bca5$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


var $b05bc761a718c0ce$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $b05bc761a718c0ce$var$readToken(this, token);
        }while (token.kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COMMENT);
        return token;
    };
    return Lexer;
}();
function $b05bc761a718c0ce$export$59ac0f4da287406a(kind) {
    return kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BANG || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).DOLLAR || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AMP || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_L || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_R || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SPREAD || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EQUALS || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AT || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_L || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_R || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PIPE || kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R;
}
function $b05bc761a718c0ce$var$printCharCode(code) {
    return isNaN(code) ? (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $b05bc761a718c0ce$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $b05bc761a718c0ce$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $b05bc761a718c0ce$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $b05bc761a718c0ce$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $b05bc761a718c0ce$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $b05bc761a718c0ce$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, pos, $b05bc761a718c0ce$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $b05bc761a718c0ce$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($b05bc761a718c0ce$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($b05bc761a718c0ce$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $b05bc761a718c0ce$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $b05bc761a718c0ce$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($b05bc761a718c0ce$var$printCharCode(code), "."));
    } else {
        position = $b05bc761a718c0ce$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $b05bc761a718c0ce$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $b05bc761a718c0ce$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $b05bc761a718c0ce$var$isNameStart(code)) throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($b05bc761a718c0ce$var$printCharCode(code), "."));
    return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)(isFloat ? (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).FLOAT : (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $b05bc761a718c0ce$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($b05bc761a718c0ce$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $b05bc761a718c0ce$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($b05bc761a718c0ce$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $b05bc761a718c0ce$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $b05bc761a718c0ce$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, line, col, prev, (0, $a09f77d2f3f4bca5$export$fd88c0b652c46ccc)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($b05bc761a718c0ce$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $b05bc761a718c0ce$var$uniCharCode(a, b, c, d) {
    return $b05bc761a718c0ce$var$char2hex(a) << 12 | $b05bc761a718c0ce$var$char2hex(b) << 8 | $b05bc761a718c0ce$var$char2hex(c) << 4 | $b05bc761a718c0ce$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $b05bc761a718c0ce$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $b05bc761a718c0ce$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $83bbfab21ea3efd5$export$50792b0e93539fde)((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $b05bc761a718c0ce$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $26b2c0816db0f0d5$export$98e6a39c04603d36(source, options) {
    var parser = new $26b2c0816db0f0d5$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $26b2c0816db0f0d5$export$5303528d1070ff6f(source, options) {
    var parser = new $26b2c0816db0f0d5$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EOF);
    return value;
}
function $26b2c0816db0f0d5$export$28b8f402ccc88182(source, options) {
    var parser = new $26b2c0816db0f0d5$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EOF);
    return type;
}
var $26b2c0816db0f0d5$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $c54728276ecd480f$export$75135ee9ed6e435b)(source) ? source : new (0, $c54728276ecd480f$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $b05bc761a718c0ce$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L)) return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).DOLLAR);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_L, item, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME)) return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).INT:
                this._lexer.advance();
                return {
                    kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).STRING:
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).LIST,
            values: this.any((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_L, item, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, item, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AT);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACKET_R);
            type = {
                kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BANG)) return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).STRING) || this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AMP) || this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME));
            return types;
        }
        return this.delimitedMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L) && this._lexer.lookahead().kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $052b64dbd01dbe0d$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $1dd8848cd870b8d3$export$b45ffd2948484c41)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $83bbfab21ea3efd5$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($26b2c0816db0f0d5$var$getTokenKindDesc(kind), ", found ").concat($26b2c0816db0f0d5$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME && token.value === value) this._lexer.advance();
        else throw (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($26b2c0816db0f0d5$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $052b64dbd01dbe0d$export$8b9d26ab11394711).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $2d76783bf6a7ac51$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($26b2c0816db0f0d5$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $26b2c0816db0f0d5$var$getTokenDesc(token) {
    var value = token.value;
    return $26b2c0816db0f0d5$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $26b2c0816db0f0d5$var$getTokenKindDesc(kind) {
    return (0, $b05bc761a718c0ce$export$59ac0f4da287406a)(kind) ? "\"".concat(kind, "\"") : kind;
}


var $f013a28d70124837$var$docCache = new Map();
var $f013a28d70124837$var$fragmentSourceMap = new Map();
var $f013a28d70124837$var$printFragmentWarnings = true;
var $f013a28d70124837$var$experimentalFragmentVariables = false;
function $f013a28d70124837$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $f013a28d70124837$var$cacheKeyFromLoc(loc) {
    return $f013a28d70124837$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $f013a28d70124837$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $f013a28d70124837$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $f013a28d70124837$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($f013a28d70124837$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $f013a28d70124837$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $f013a28d70124837$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $f013a28d70124837$var$parseDocument(source) {
    var cacheKey = $f013a28d70124837$var$normalize(source);
    if (!$f013a28d70124837$var$docCache.has(cacheKey)) {
        var parsed = (0, $26b2c0816db0f0d5$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $f013a28d70124837$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $f013a28d70124837$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $f013a28d70124837$var$docCache.set(cacheKey, $f013a28d70124837$var$stripLoc($f013a28d70124837$var$processFragments(parsed)));
    }
    return $f013a28d70124837$var$docCache.get(cacheKey);
}
function $f013a28d70124837$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $f013a28d70124837$var$parseDocument(result);
}
function $f013a28d70124837$export$657554ef4dc7ac2d() {
    $f013a28d70124837$var$docCache.clear();
    $f013a28d70124837$var$fragmentSourceMap.clear();
}
function $f013a28d70124837$export$e4294e638636c6ab() {
    $f013a28d70124837$var$printFragmentWarnings = false;
}
function $f013a28d70124837$export$78cf889af350c840() {
    $f013a28d70124837$var$experimentalFragmentVariables = true;
}
function $f013a28d70124837$export$5290df9bbbd3cfa() {
    $f013a28d70124837$var$experimentalFragmentVariables = false;
}
var $f013a28d70124837$var$extras = {
    gql: $f013a28d70124837$export$72e4926bf8358653,
    resetCaches: $f013a28d70124837$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $f013a28d70124837$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $f013a28d70124837$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $f013a28d70124837$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $f013a28d70124837$var$extras.gql, gql_1.resetCaches = $f013a28d70124837$var$extras.resetCaches, gql_1.disableFragmentWarnings = $f013a28d70124837$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $f013a28d70124837$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $f013a28d70124837$var$extras.disableExperimentalFragmentVariables;
})($f013a28d70124837$export$72e4926bf8358653 || ($f013a28d70124837$export$72e4926bf8358653 = {}));
$f013a28d70124837$export$72e4926bf8358653["default"] = $f013a28d70124837$export$72e4926bf8358653;
var $f013a28d70124837$export$2e2bcd8739ae039 = $f013a28d70124837$export$72e4926bf8358653;




/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $3f2db0b032f9aed0$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}


function $35685e6ff291993f$export$235b7fc70b9fc359(defaults, options) {
    return (0, $3f2db0b032f9aed0$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $3f2db0b032f9aed0$export$8e16b83750b44988)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables))
    });
}








var $9d9469bb012ba645$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $9d9469bb012ba645$var$uSESKey = "useSyncExternalStore";
var $9d9469bb012ba645$var$realHook = $cecb01ade82788f9$exports[$9d9469bb012ba645$var$uSESKey];
var $9d9469bb012ba645$export$306c0aa65ff9ec16 = $9d9469bb012ba645$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$9d9469bb012ba645$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $9d9469bb012ba645$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).error(68);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $cecb01ade82788f9$exports.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $72d024d8344a7591$export$4001f6cd4a62405b) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $cecb01ade82788f9$exports.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($9d9469bb012ba645$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    // React Hook React.useLayoutEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $cecb01ade82788f9$exports.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($9d9469bb012ba645$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($9d9469bb012ba645$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    // React Hook React.useEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    return value;
};
function $9d9469bb012ba645$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}


const { toString: $dc3b7a513585078b$var$toString, hasOwnProperty: $dc3b7a513585078b$var$hasOwnProperty } = Object.prototype;
const $dc3b7a513585078b$var$fnToStr = Function.prototype.toString;
const $dc3b7a513585078b$var$previousComparisons = new Map();
function $dc3b7a513585078b$export$411ce8e5a71e3069(a, b) {
    try {
        return $dc3b7a513585078b$var$check(a, b);
    } finally{
        $dc3b7a513585078b$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$dc3b7a513585078b$export$2e2bcd8739ae039 = $dc3b7a513585078b$export$411ce8e5a71e3069;
function $dc3b7a513585078b$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $dc3b7a513585078b$var$toString.call(a);
    const bTag = $dc3b7a513585078b$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($dc3b7a513585078b$var$previouslyCompared(a, b)) return true;
                const aKeys = $dc3b7a513585078b$var$definedKeys(a);
                const bKeys = $dc3b7a513585078b$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$dc3b7a513585078b$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$dc3b7a513585078b$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($dc3b7a513585078b$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$dc3b7a513585078b$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $dc3b7a513585078b$var$fnToStr.call(a);
                if (aCode !== $dc3b7a513585078b$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$dc3b7a513585078b$var$endsWith(aCode, $dc3b7a513585078b$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $dc3b7a513585078b$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($dc3b7a513585078b$var$isDefinedKey, obj);
}
function $dc3b7a513585078b$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $dc3b7a513585078b$var$nativeCodeSuffix = "{ [native code] }";
function $dc3b7a513585078b$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $dc3b7a513585078b$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $dc3b7a513585078b$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $dc3b7a513585078b$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}


// A version of Array.isArray that works better with readonly arrays.
var $70621a0f16abefe5$export$43bee75e5e14138e = Array.isArray;
function $70621a0f16abefe5$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

function $28bb6a3d2161c7ef$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $28bb6a3d2161c7ef$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}


function $051c3a1fe8fb825e$export$7e32b29e1cb162e1(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(obj) && $051c3a1fe8fb825e$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $051c3a1fe8fb825e$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $051c3a1fe8fb825e$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $051c3a1fe8fb825e$export$7e32b29e1cb162e1(obj);
    return obj;
}






var $9b257430d46c4ca9$export$4995664c1b49842e = Symbol();
function $9b257430d46c4ca9$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$9b257430d46c4ca9$export$4995664c1b49842e]);
    return false;
}
function $9b257430d46c4ca9$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $9b257430d46c4ca9$var$generateErrorMessage = function(err) {
    var errors = (0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $9b257430d46c4ca9$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $9b257430d46c4ca9$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause = (0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)([
            networkError
        ], graphQLErrors || [], true), protocolErrors || [], true), clientErrors || [], true).find(function(e) {
            return !!e;
        }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);


/**
 * The current status of a query’s execution in our system.
 */ var $65cb694a13dd958e$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($65cb694a13dd958e$export$bd096ddbd246c79c || ($65cb694a13dd958e$export$bd096ddbd246c79c = {}));
function $65cb694a13dd958e$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $65cb694a13dd958e$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}



function $197ae32819081743$var$defaultDispose() {}
class $197ae32819081743$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $197ae32819081743$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

function $41d8f6344e8a4837$var$noop() {}
const $41d8f6344e8a4837$var$defaultDispose = $41d8f6344e8a4837$var$noop;
const $41d8f6344e8a4837$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $41d8f6344e8a4837$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $41d8f6344e8a4837$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $41d8f6344e8a4837$var$noop,
        unregister: $41d8f6344e8a4837$var$noop
    };
};
const $41d8f6344e8a4837$var$finalizationBatchSize = 10024;
class $41d8f6344e8a4837$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $41d8f6344e8a4837$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $41d8f6344e8a4837$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $41d8f6344e8a4837$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $41d8f6344e8a4837$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $41d8f6344e8a4837$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $b8955c60f2fefc81$var$scheduledCleanup = new WeakSet();
function $b8955c60f2fefc81$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$b8955c60f2fefc81$var$scheduledCleanup.has(cache)) {
        $b8955c60f2fefc81$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $b8955c60f2fefc81$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $b8955c60f2fefc81$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $41d8f6344e8a4837$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $41d8f6344e8a4837$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $b8955c60f2fefc81$var$schedule(this);
        return ret;
    };
    return cache;
};
var $b8955c60f2fefc81$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $197ae32819081743$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $197ae32819081743$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $b8955c60f2fefc81$var$schedule(this);
        return ret;
    };
    return cache;
};



var $2d6dd17bfab74a36$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $2d6dd17bfab74a36$export$f29926b23b28936b = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, (0, $d1410d7c5cd7e720$export$2e2bcd8739ae039)[$2d6dd17bfab74a36$var$cacheSizeSymbol]);




var $6d39cfba9615c908$var$globalCaches = {};
function $6d39cfba9615c908$export$a8fcd406d9e37621(name, getSize) {
    $6d39cfba9615c908$var$globalCaches[name] = getSize;
}
var $6d39cfba9615c908$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $6d39cfba9615c908$var$_getApolloClientMemoryInternals : undefined;
var $6d39cfba9615c908$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $6d39cfba9615c908$var$_getInMemoryCacheMemoryInternals : undefined;
var $6d39cfba9615c908$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $6d39cfba9615c908$var$_getApolloCacheMemoryInternals : undefined;
function $6d39cfba9615c908$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $2d6dd17bfab74a36$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $6d39cfba9615c908$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $6d39cfba9615c908$var$getCurrentCacheSizes(),
        sizes: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
            print: (_a = $6d39cfba9615c908$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($6d39cfba9615c908$var$globalCaches),
            parser: (_b = $6d39cfba9615c908$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($6d39cfba9615c908$var$globalCaches),
            canonicalStringify: (_c = $6d39cfba9615c908$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($6d39cfba9615c908$var$globalCaches),
            links: $6d39cfba9615c908$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $6d39cfba9615c908$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $6d39cfba9615c908$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $6d39cfba9615c908$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $6d39cfba9615c908$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, $6d39cfba9615c908$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $6d39cfba9615c908$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $6d39cfba9615c908$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $6d39cfba9615c908$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $6d39cfba9615c908$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $6d39cfba9615c908$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $6d39cfba9615c908$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $6d39cfba9615c908$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $6d39cfba9615c908$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $6d39cfba9615c908$var$getWrapperInformation(f) {
    return $6d39cfba9615c908$var$isWrapper(f) ? f.size : undefined;
}
function $6d39cfba9615c908$var$isDefined(value) {
    return value != null;
}
function $6d39cfba9615c908$var$transformInfo(transform) {
    return $6d39cfba9615c908$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $6d39cfba9615c908$var$recurseTransformInfo(transform) {
    return transform ? (0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)([
        $6d39cfba9615c908$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $6d39cfba9615c908$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $6d39cfba9615c908$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($6d39cfba9615c908$var$isDefined) : [];
}
function $6d39cfba9615c908$var$linkInfo(link) {
    var _a;
    return link ? (0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $6d39cfba9615c908$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $6d39cfba9615c908$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($6d39cfba9615c908$var$isDefined) : [];
}


var $4b7201da001f4bdf$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($4b7201da001f4bdf$export$d1d99cf900472499 || ($4b7201da001f4bdf$export$d1d99cf900472499 = {}));
var $4b7201da001f4bdf$var$cache;
function $4b7201da001f4bdf$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $4b7201da001f4bdf$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $4b7201da001f4bdf$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $4b7201da001f4bdf$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $4b7201da001f4bdf$export$8f49e4af10703ce3(document) {
    if (!$4b7201da001f4bdf$var$cache) $4b7201da001f4bdf$var$cache = new (0, $b8955c60f2fefc81$export$8dbad6f439bb2331)((0, $2d6dd17bfab74a36$export$f29926b23b28936b).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $4b7201da001f4bdf$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!!document && !!document.kind, 70, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 71);
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 72, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $4b7201da001f4bdf$export$d1d99cf900472499.Query : $4b7201da001f4bdf$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $4b7201da001f4bdf$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(definitions.length === 1, 73, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $4b7201da001f4bdf$var$cache.set(document, payload);
    return payload;
}
$4b7201da001f4bdf$export$8f49e4af10703ce3.resetCache = function() {
    $4b7201da001f4bdf$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $6d39cfba9615c908$export$a8fcd406d9e37621)("parser", function() {
    return $4b7201da001f4bdf$var$cache ? $4b7201da001f4bdf$var$cache.size : 0;
});
function $4b7201da001f4bdf$export$6dfb8732f737404c(document, type) {
    var operation = $4b7201da001f4bdf$export$8f49e4af10703ce3(document);
    var requiredOperationName = $4b7201da001f4bdf$export$5db520940cf00715(type);
    var usedOperationName = $4b7201da001f4bdf$export$5db520940cf00715(operation.type);
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(operation.type === type, 74, requiredOperationName, requiredOperationName, usedOperationName);
}





function $2937cd197ec1708e$export$eb9a56e7a29e494(override) {
    var context = $cecb01ade82788f9$exports.useContext((0, $75a491f8196648b1$export$a47505d961ee3a1)());
    var client = override || context.client;
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!!client, 58);
    return client;
}


var $e4e22c5c121a47b2$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $e4e22c5c121a47b2$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$e4e22c5c121a47b2$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}


var $7fa797a3751877df$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $7fa797a3751877df$var$noop() {}
var $7fa797a3751877df$export$163a98bed2d8d099 = Symbol();
function $7fa797a3751877df$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $e4e22c5c121a47b2$export$7f12579c79e39619)("useQuery", // eslint-disable-next-line react-compiler/react-compiler
    $7fa797a3751877df$var$useQuery_, (0, $2937cd197ec1708e$export$eb9a56e7a29e494)(options && options.client))(query, options);
}
function $7fa797a3751877df$var$useQuery_(query, options) {
    var _a = $7fa797a3751877df$export$5c23c59ff7f655a8(query, options), result = _a.result, obsQueryFields = _a.obsQueryFields;
    return $cecb01ade82788f9$exports.useMemo(function() {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result), obsQueryFields);
    }, [
        result,
        obsQueryFields
    ]);
}
function $7fa797a3751877df$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions) {
    function createInternalState(previous) {
        var _a;
        (0, $4b7201da001f4bdf$export$6dfb8732f737404c)(query, (0, $4b7201da001f4bdf$export$d1d99cf900472499).Query);
        var internalState = {
            client: client,
            query: query,
            observable: // See if there is an existing observable that was used to fetch the same
            // data and if so, use it instead since it will contain the proper queryId
            // to fetch the result set. This is used during SSR.
            renderPromises && renderPromises.getSSRObservable(makeWatchQueryOptions()) || client.watchQuery($7fa797a3751877df$export$2167b7db3cd527f2(void 0, client, options, makeWatchQueryOptions())),
            resultData: {
                // Reuse previousData from previous InternalState (if any) to provide
                // continuity of previousData even if/when the query or client changes.
                previousData: (_a = previous === null || previous === void 0 ? void 0 : previous.resultData.current) === null || _a === void 0 ? void 0 : _a.data
            }
        };
        return internalState;
    }
    var _a = $cecb01ade82788f9$exports.useState(createInternalState), internalState = _a[0], updateInternalState = _a[1];
    /**
     * Used by `useLazyQuery` when a new query is executed.
     * We keep this logic here since it needs to update things in unsafe
     * ways and here we at least can keep track of that in a single place.
     */ function onQueryExecuted(watchQueryOptions) {
        var _a;
        var _b;
        // this needs to be set to prevent an immediate `resubscribe` in the
        // next rerender of the `useQuery` internals
        Object.assign(internalState.observable, (_a = {}, _a[$7fa797a3751877df$export$163a98bed2d8d099] = watchQueryOptions, _a));
        var resultData = internalState.resultData;
        updateInternalState((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, internalState), {
            // might be a different query
            query: watchQueryOptions.query,
            resultData: Object.assign(resultData, {
                // We need to modify the previous `resultData` object as we rely on the
                // object reference in other places
                previousData: ((_b = resultData.current) === null || _b === void 0 ? void 0 : _b.data) || resultData.previousData,
                current: undefined
            })
        }));
    }
    if (client !== internalState.client || query !== internalState.query) {
        // If the client or query have changed, we need to create a new InternalState.
        // This will trigger a re-render with the new state, but it will also continue
        // to run the current render function to completion.
        // Since we sometimes trigger some side-effects in the render function, we
        // re-assign `state` to the new state to ensure that those side-effects are
        // triggered with the new state.
        var newInternalState = createInternalState(internalState);
        updateInternalState(newInternalState);
        return [
            newInternalState,
            onQueryExecuted
        ];
    }
    return [
        internalState,
        onQueryExecuted
    ];
}
function $7fa797a3751877df$export$5c23c59ff7f655a8(query, options) {
    var client = (0, $2937cd197ec1708e$export$eb9a56e7a29e494)(options.client);
    var renderPromises = $cecb01ade82788f9$exports.useContext((0, $75a491f8196648b1$export$a47505d961ee3a1)()).renderPromises;
    var isSyncSSR = !!renderPromises;
    var disableNetworkFetches = client.disableNetworkFetches;
    var ssrAllowed = options.ssr !== false && !options.skip;
    var partialRefetch = options.partialRefetch;
    var makeWatchQueryOptions = $7fa797a3751877df$export$63539d93836ebf9c(client, query, options, isSyncSSR);
    var _a = $7fa797a3751877df$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions), _b = _a[0], observable = _b.observable, resultData = _b.resultData, onQueryExecuted = _a[1];
    var watchQueryOptions = makeWatchQueryOptions(observable);
    $7fa797a3751877df$var$useResubscribeIfNecessary(resultData, observable, client, options, watchQueryOptions);
    var obsQueryFields = $cecb01ade82788f9$exports.useMemo(function() {
        return $7fa797a3751877df$var$bindObservableMethods(observable);
    }, [
        observable
    ]);
    $7fa797a3751877df$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed);
    var result = $7fa797a3751877df$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, {
        onCompleted: options.onCompleted || $7fa797a3751877df$var$noop,
        onError: options.onError || $7fa797a3751877df$var$noop
    });
    return {
        result: result,
        obsQueryFields: obsQueryFields,
        observable: observable,
        resultData: resultData,
        client: client,
        onQueryExecuted: onQueryExecuted
    };
}
function $7fa797a3751877df$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, callbacks) {
    var callbackRef = $cecb01ade82788f9$exports.useRef(callbacks);
    $cecb01ade82788f9$exports.useEffect(function() {
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        // eslint-disable-next-line react-compiler/react-compiler
        callbackRef.current = callbacks;
    });
    var resultOverride = (isSyncSSR || disableNetworkFetches) && options.ssr === false && !options.skip ? // If SSR has been explicitly disabled, and this function has been called
    // on the server side, return the default loading state.
    $7fa797a3751877df$var$ssrDisabledResult : options.skip || watchQueryOptions.fetchPolicy === "standby" ? // When skipping a query (ie. we're not querying for data but still want to
    // render children), make sure the `data` is cleared out and `loading` is
    // set to `false` (since we aren't loading anything).
    //
    // NOTE: We no longer think this is the correct behavior. Skipping should
    // not automatically set `data` to `undefined`, but instead leave the
    // previous data in place. In other words, skipping should not mandate that
    // previously received data is all of a sudden removed. Unfortunately,
    // changing this is breaking, so we'll have to wait until Apollo Client 4.0
    // to address this.
    $7fa797a3751877df$var$skipStandbyResult : void 0;
    var previousData = resultData.previousData;
    var currentResultOverride = $cecb01ade82788f9$exports.useMemo(function() {
        return resultOverride && $7fa797a3751877df$export$de3acc9431f1695e(resultOverride, previousData, observable, client);
    }, [
        client,
        observable,
        resultOverride,
        previousData
    ]);
    return (0, $9d9469bb012ba645$export$306c0aa65ff9ec16)($cecb01ade82788f9$exports.useCallback(function(handleStoreChange) {
        // reference `disableNetworkFetches` here to ensure that the rules of hooks
        // keep it as a dependency of this effect, even though it's not used
        disableNetworkFetches;
        if (isSyncSSR) return function() {};
        var onNext = function() {
            var previousResult = resultData.current;
            // We use `getCurrentResult()` instead of the onNext argument because
            // the values differ slightly. Specifically, loading results will have
            // an empty object for data instead of `undefined` for some reason.
            var result = observable.getCurrentResult();
            // Make sure we're not attempting to re-render similar results
            if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $dc3b7a513585078b$export$411ce8e5a71e3069)(previousResult.data, result.data)) return;
            $7fa797a3751877df$var$setResult(result, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        var onError = function(error) {
            subscription.current.unsubscribe();
            subscription.current = observable.resubscribeAfterError(onNext, onError);
            if (!$7fa797a3751877df$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
            throw error;
            var previousResult = resultData.current;
            if (!previousResult || previousResult && previousResult.loading || !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(error, previousResult.error)) $7fa797a3751877df$var$setResult({
                data: previousResult && previousResult.data,
                error: error,
                loading: false,
                networkStatus: (0, $65cb694a13dd958e$export$bd096ddbd246c79c).error
            }, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        // TODO evaluate if we keep this in
        // React Compiler cannot handle scoped `let` access, but a mutable object
        // like this is fine.
        // was:
        // let subscription = observable.subscribe(onNext, onError);
        var subscription = {
            current: observable.subscribe(onNext, onError)
        };
        // Do the "unsubscribe" with a short delay.
        // This way, an existing subscription can be reused without an additional
        // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
        // happen in very fast succession.
        return function() {
            setTimeout(function() {
                return subscription.current.unsubscribe();
            });
        };
    }, [
        disableNetworkFetches,
        isSyncSSR,
        observable,
        resultData,
        partialRefetch,
        client
    ]), function() {
        return currentResultOverride || $7fa797a3751877df$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    }, function() {
        return currentResultOverride || $7fa797a3751877df$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    });
}
function $7fa797a3751877df$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed) {
    if (renderPromises && ssrAllowed) {
        renderPromises.registerSSRObservable(observable);
        if (observable.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
        renderPromises.addObservableQueryPromise(observable);
    }
}
// this hook is not compatible with any rules of React, and there's no good way to rewrite it.
// it should stay a separate hook that will not be optimized by the compiler
function $7fa797a3751877df$var$useResubscribeIfNecessary(/** this hook will mutate properties on `resultData` */ resultData, /** this hook will mutate properties on `observable` */ observable, client, options, watchQueryOptions) {
    var _a;
    if (observable[$7fa797a3751877df$export$163a98bed2d8d099] && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(observable[$7fa797a3751877df$export$163a98bed2d8d099], watchQueryOptions)) {
        // Though it might be tempting to postpone this reobserve call to the
        // useEffect block, we need getCurrentResult to return an appropriate
        // loading:true result synchronously (later within the same call to
        // useQuery). Since we already have this.observable here (not true for
        // the very first call to useQuery), we are not initiating any new
        // subscriptions, though it does feel less than ideal that reobserve
        // (potentially) kicks off a network request (for example, when the
        // variables have changed), which is technically a side-effect.
        observable.reobserve($7fa797a3751877df$export$2167b7db3cd527f2(observable, client, options, watchQueryOptions));
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        resultData.previousData = ((_a = resultData.current) === null || _a === void 0 ? void 0 : _a.data) || resultData.previousData;
        resultData.current = void 0;
    }
    observable[$7fa797a3751877df$export$163a98bed2d8d099] = watchQueryOptions;
}
function $7fa797a3751877df$export$63539d93836ebf9c(client, query, _a, isSyncSSR) {
    if (_a === void 0) _a = {};
    var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
    // makes otherOptions almost a WatchQueryOptions object, except for the
    // query property that we add below.
    otherOptions = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(_a, [
        "skip",
        "ssr",
        "onCompleted",
        "onError",
        "defaultOptions"
    ]);
    return function(observable) {
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: query
        });
        if (isSyncSSR && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            watchQueryOptions.initialFetchPolicy = watchQueryOptions.initialFetchPolicy || watchQueryOptions.fetchPolicy || $7fa797a3751877df$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
            watchQueryOptions.fetchPolicy = "standby";
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = (observable === null || observable === void 0 ? void 0 : observable.options.initialFetchPolicy) || $7fa797a3751877df$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
        return watchQueryOptions;
    };
}
function $7fa797a3751877df$export$2167b7db3cd527f2(observable, client, queryHookOptions, watchQueryOptions) {
    var toMerge = [];
    var globalDefaults = client.defaultOptions.watchQuery;
    if (globalDefaults) toMerge.push(globalDefaults);
    if (queryHookOptions.defaultOptions) toMerge.push(queryHookOptions.defaultOptions);
    // We use compact rather than mergeOptions for this part of the merge,
    // because we want watchQueryOptions.variables (if defined) to replace
    // this.observable.options.variables whole. This replacement allows
    // removing variables by removing them from the variables input to
    // useQuery. If the variables were always merged together (rather than
    // replaced), there would be no way to remove existing variables.
    // However, the variables from options.defaultOptions and globalDefaults
    // (if provided) should be merged, to ensure individual defaulted
    // variables always have values, if not otherwise defined in
    // observable.options or watchQueryOptions.
    toMerge.push((0, $3f2db0b032f9aed0$export$8e16b83750b44988)(observable && observable.options, watchQueryOptions));
    return toMerge.reduce((0, $35685e6ff291993f$export$235b7fc70b9fc359));
}
function $7fa797a3751877df$var$setResult(nextResult, resultData, observable, client, partialRefetch, forceUpdate, callbacks) {
    var previousResult = resultData.current;
    if (previousResult && previousResult.data) resultData.previousData = previousResult.data;
    if (!nextResult.error && (0, $70621a0f16abefe5$export$d307f5934e447d0e)(nextResult.errors)) // Until a set naming convention for networkError and graphQLErrors is
    // decided upon, we map errors (graphQLErrors) to the error options.
    // TODO: Is it possible for both result.error and result.errors to be
    // defined here?
    nextResult.error = new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
        graphQLErrors: nextResult.errors
    });
    resultData.current = $7fa797a3751877df$export$de3acc9431f1695e($7fa797a3751877df$var$unsafeHandlePartialRefetch(nextResult, observable, partialRefetch), resultData.previousData, observable, client);
    // Calling state.setResult always triggers an update, though some call sites
    // perform additional equality checks before committing to an update.
    forceUpdate();
    $7fa797a3751877df$var$handleErrorOrCompleted(nextResult, previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus, callbacks);
}
function $7fa797a3751877df$var$handleErrorOrCompleted(result, previousNetworkStatus, callbacks) {
    if (!result.loading) {
        var error_1 = $7fa797a3751877df$export$b2c90f1874ba96bf(result);
        // wait a tick in case we are in the middle of rendering a component
        Promise.resolve().then(function() {
            if (error_1) callbacks.onError(error_1);
            else if (result.data && previousNetworkStatus !== result.networkStatus && result.networkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).ready) callbacks.onCompleted(result.data);
        }).catch(function(error) {
            globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(error);
        });
    }
}
function $7fa797a3751877df$var$getCurrentResult(resultData, observable, callbacks, partialRefetch, client) {
    // Using this.result as a cache ensures getCurrentResult continues returning
    // the same (===) result object, unless state.setResult has been called, or
    // we're doing server rendering and therefore override the result below.
    if (!resultData.current) // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
    // this could call unsafeHandlePartialRefetch
    $7fa797a3751877df$var$setResult(observable.getCurrentResult(), resultData, observable, client, partialRefetch, function() {}, callbacks);
    return resultData.current;
}
function $7fa797a3751877df$export$e700754533d2c94f(queryHookDefaultOptions, clientDefaultOptions) {
    var _a;
    return (queryHookDefaultOptions === null || queryHookDefaultOptions === void 0 ? void 0 : queryHookDefaultOptions.fetchPolicy) || ((_a = clientDefaultOptions === null || clientDefaultOptions === void 0 ? void 0 : clientDefaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
}
function $7fa797a3751877df$export$b2c90f1874ba96bf(result) {
    return (0, $70621a0f16abefe5$export$d307f5934e447d0e)(result.errors) ? new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
        graphQLErrors: result.errors
    }) : result.error;
}
function $7fa797a3751877df$export$de3acc9431f1695e(result, previousData, observable, client) {
    var data = result.data, partial = result.partial, resultWithoutPartial = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(result, [
        "data",
        "partial"
    ]);
    var queryResult = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
        data: data
    }, resultWithoutPartial), {
        client: client,
        observable: observable,
        variables: observable.variables,
        called: result !== $7fa797a3751877df$var$ssrDisabledResult && result !== $7fa797a3751877df$var$skipStandbyResult,
        previousData: previousData
    });
    return queryResult;
}
function $7fa797a3751877df$var$unsafeHandlePartialRefetch(result, observable, partialRefetch) {
    // TODO: This code should be removed when the partialRefetch option is
    // removed. I was unable to get this hook to behave reasonably in certain
    // edge cases when this block was put in an effect.
    if (result.partial && partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && observable.options.fetchPolicy !== "cache-only") {
        observable.refetch();
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result), {
            loading: true,
            networkStatus: (0, $65cb694a13dd958e$export$bd096ddbd246c79c).refetch
        });
    }
    return result;
}
var $7fa797a3751877df$var$ssrDisabledResult = (0, $051c3a1fe8fb825e$export$7f9c177735b71f18)({
    loading: true,
    data: void 0,
    error: void 0,
    networkStatus: (0, $65cb694a13dd958e$export$bd096ddbd246c79c).loading
});
var $7fa797a3751877df$var$skipStandbyResult = (0, $051c3a1fe8fb825e$export$7f9c177735b71f18)({
    loading: false,
    data: void 0,
    error: void 0,
    networkStatus: (0, $65cb694a13dd958e$export$bd096ddbd246c79c).ready
});
function $7fa797a3751877df$var$bindObservableMethods(observable) {
    return {
        refetch: observable.refetch.bind(observable),
        reobserve: observable.reobserve.bind(observable),
        fetchMore: observable.fetchMore.bind(observable),
        updateQuery: observable.updateQuery.bind(observable),
        startPolling: observable.startPolling.bind(observable),
        stopPolling: observable.stopPolling.bind(observable),
        subscribeToMore: observable.subscribeToMore.bind(observable)
    };
}




var $2765a5c5d3be04a4$export$700979bc83e7db82 = (0, $72d024d8344a7591$export$71594e8a50f746f4) ? $cecb01ade82788f9$exports.useLayoutEffect : $cecb01ade82788f9$exports.useEffect;


// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var $6aa6af800883504c$var$EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "stopPolling",
    "subscribeToMore"
];
function $6aa6af800883504c$export$fd83eea6ecd2d8fa(query, options) {
    var _a;
    var execOptionsRef = $cecb01ade82788f9$exports.useRef(void 0);
    var optionsRef = $cecb01ade82788f9$exports.useRef(void 0);
    var queryRef = $cecb01ade82788f9$exports.useRef(void 0);
    var merged = (0, $35685e6ff291993f$export$235b7fc70b9fc359)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = options;
    queryRef.current = document;
    var queryHookOptions = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, merged), {
        skip: !execOptionsRef.current
    });
    var _b = (0, $7fa797a3751877df$export$5c23c59ff7f655a8)(document, queryHookOptions), obsQueryFields = _b.obsQueryFields, useQueryResult = _b.result, client = _b.client, resultData = _b.resultData, observable = _b.observable, onQueryExecuted = _b.onQueryExecuted;
    var initialFetchPolicy = observable.options.initialFetchPolicy || (0, $7fa797a3751877df$export$e700754533d2c94f)(queryHookOptions.defaultOptions, client.defaultOptions);
    var forceUpdateState = $cecb01ade82788f9$exports.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = $cecb01ade82788f9$exports.useMemo(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = obsQueryFields[key];
            eagerMethods[key] = function() {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = $6aa6af800883504c$var$EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, [
        forceUpdateState,
        obsQueryFields
    ]);
    var called = !!execOptionsRef.current;
    var result = $cecb01ade82788f9$exports.useMemo(function() {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, useQueryResult), eagerMethods), {
            called: called
        });
    }, [
        useQueryResult,
        eagerMethods,
        called
    ]);
    var execute = $cecb01ade82788f9$exports.useCallback(function(executeOptions) {
        execOptionsRef.current = executeOptions ? (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var options = (0, $35685e6ff291993f$export$235b7fc70b9fc359)(optionsRef.current, (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
            query: queryRef.current
        }, execOptionsRef.current));
        var promise = $6aa6af800883504c$var$executeQuery(resultData, observable, client, document, (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            skip: false
        }), onQueryExecuted).then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function() {});
        return promise;
    }, [
        client,
        document,
        eagerMethods,
        initialFetchPolicy,
        observable,
        resultData,
        onQueryExecuted
    ]);
    var executeRef = $cecb01ade82788f9$exports.useRef(execute);
    (0, $2765a5c5d3be04a4$export$700979bc83e7db82)(function() {
        executeRef.current = execute;
    });
    var stableExecute = $cecb01ade82788f9$exports.useCallback(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return executeRef.current.apply(executeRef, args);
    }, []);
    return [
        stableExecute,
        result
    ];
}
function $6aa6af800883504c$var$executeQuery(resultData, observable, client, currentQuery, options, onQueryExecuted) {
    var query = options.query || currentQuery;
    var watchQueryOptions = (0, $7fa797a3751877df$export$63539d93836ebf9c)(client, query, options, false)(observable);
    var concast = observable.reobserveAsConcast((0, $7fa797a3751877df$export$2167b7db3cd527f2)(observable, client, options, watchQueryOptions));
    onQueryExecuted(watchQueryOptions);
    return new Promise(function(resolve) {
        var result;
        // Subscribe to the concast independently of the ObservableQuery in case
        // the component gets unmounted before the promise resolves. This prevents
        // the concast from terminating early and resolving with `undefined` when
        // there are no more subscribers for the concast.
        concast.subscribe({
            next: function(value) {
                result = value;
            },
            error: function() {
                resolve((0, $7fa797a3751877df$export$de3acc9431f1695e)(observable.getCurrentResult(), resultData.previousData, observable, client));
            },
            complete: function() {
                resolve((0, $7fa797a3751877df$export$de3acc9431f1695e)(observable["maskResult"](result), resultData.previousData, observable, client));
            }
        });
    });
}









function $fed59b56f9be1d6c$export$609860bf8b0084c(mutation, options) {
    var client = (0, $2937cd197ec1708e$export$eb9a56e7a29e494)(options === null || options === void 0 ? void 0 : options.client);
    (0, $4b7201da001f4bdf$export$6dfb8732f737404c)(mutation, (0, $4b7201da001f4bdf$export$d1d99cf900472499).Mutation);
    var _a = $cecb01ade82788f9$exports.useState({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = $cecb01ade82788f9$exports.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    (0, $2765a5c5d3be04a4$export$700979bc83e7db82)(function() {
        Object.assign(ref.current, {
            client: client,
            options: options,
            mutation: mutation
        });
    });
    var execute = $cecb01ade82788f9$exports.useCallback(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            mutation: mutation
        });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, $35685e6ff291993f$export$235b7fc70b9fc359)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
                graphQLErrors: errors
            }) : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) onCompleted === null || onCompleted === void 0 || onCompleted(response.data, clientOptions);
            return response;
        }).catch(function(error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = $cecb01ade82788f9$exports.useCallback(function() {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: ref.current.client
            };
            Object.assign(ref.current, {
                mutationId: 0,
                result: result_3
            });
            setResult(result_3);
        }
    }, []);
    $cecb01ade82788f9$exports.useEffect(function() {
        var current = ref.current;
        // eslint-disable-next-line react-compiler/react-compiler
        current.isMounted = true;
        return function() {
            current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
            reset: reset
        }, result)
    ];
}






function $0777c100e78b6582$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0777c100e78b6582$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0777c100e78b6582$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0777c100e78b6582$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0777c100e78b6582$var$_arrayLikeToArray(o, minLen);
}
function $0777c100e78b6582$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0777c100e78b6582$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0777c100e78b6582$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0777c100e78b6582$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0777c100e78b6582$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $0777c100e78b6582$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $0777c100e78b6582$var$hasSymbol = function(name) {
    return $0777c100e78b6582$var$hasSymbols() && Boolean(Symbol[name]);
};
var $0777c100e78b6582$var$getSymbol = function(name) {
    return $0777c100e78b6582$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($0777c100e78b6582$var$hasSymbols() && !$0777c100e78b6582$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $0777c100e78b6582$var$SymbolIterator = $0777c100e78b6582$var$getSymbol('iterator');
var $0777c100e78b6582$var$SymbolObservable = $0777c100e78b6582$var$getSymbol('observable');
var $0777c100e78b6582$var$SymbolSpecies = $0777c100e78b6582$var$getSymbol('species'); // === Abstract Operations ===
function $0777c100e78b6582$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $0777c100e78b6582$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$0777c100e78b6582$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $0777c100e78b6582$export$77cea355fa80b5f4;
}
function $0777c100e78b6582$var$isObservable(x) {
    return x instanceof $0777c100e78b6582$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $0777c100e78b6582$var$hostReportError(e) {
    if ($0777c100e78b6582$var$hostReportError.log) $0777c100e78b6582$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $0777c100e78b6582$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $0777c100e78b6582$var$hostReportError(e);
        }
    });
}
function $0777c100e78b6582$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $0777c100e78b6582$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $0777c100e78b6582$var$hostReportError(e);
    }
}
function $0777c100e78b6582$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $0777c100e78b6582$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $0777c100e78b6582$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $0777c100e78b6582$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $0777c100e78b6582$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $0777c100e78b6582$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $0777c100e78b6582$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $0777c100e78b6582$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $0777c100e78b6582$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $0777c100e78b6582$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $0777c100e78b6582$var$enqueue(function() {
            return $0777c100e78b6582$var$flushSubscription(subscription);
        });
        return;
    }
    $0777c100e78b6582$var$notifySubscription(subscription, type, value);
}
var $0777c100e78b6582$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $0777c100e78b6582$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $0777c100e78b6582$var$closeSubscription(this);
            $0777c100e78b6582$var$cleanupSubscription(this);
        }
    };
    $0777c100e78b6582$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $0777c100e78b6582$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $0777c100e78b6582$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $0777c100e78b6582$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $0777c100e78b6582$var$onNotify(this._subscription, 'complete');
    };
    $0777c100e78b6582$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $0777c100e78b6582$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $0777c100e78b6582$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0777c100e78b6582$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0777c100e78b6582$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0777c100e78b6582$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $0777c100e78b6582$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0777c100e78b6582$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$0777c100e78b6582$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $0777c100e78b6582$var$getMethod(x, $0777c100e78b6582$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($0777c100e78b6582$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($0777c100e78b6582$var$hasSymbol('iterator')) {
            method = $0777c100e78b6582$var$getMethod(x, $0777c100e78b6582$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $0777c100e78b6582$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $0777c100e78b6582$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $0777c100e78b6582$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $0777c100e78b6582$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $0777c100e78b6582$var$_createClass(Observable, null, [
        {
            key: $0777c100e78b6582$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($0777c100e78b6582$var$hasSymbols()) Object.defineProperty($0777c100e78b6582$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $0777c100e78b6582$var$SymbolObservable,
        hostReportError: $0777c100e78b6582$var$hostReportError
    },
    configurable: true
});


parcelRequire("k81ih");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $01b4af894b14a404$var$prototype = (0, $0777c100e78b6582$export$77cea355fa80b5f4).prototype;
var $01b4af894b14a404$var$fakeObsSymbol = "@@observable";
if (!$01b4af894b14a404$var$prototype[$01b4af894b14a404$var$fakeObsSymbol]) // @ts-expect-error
$01b4af894b14a404$var$prototype[$01b4af894b14a404$var$fakeObsSymbol] = function() {
    return this;
};





function $204c9c6e461cffd8$export$722debc0e56fea39(memoFn, deps) {
    var ref = $cecb01ade82788f9$exports.useRef(void 0);
    if (!ref.current || !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(ref.current.deps, deps)) // eslint-disable-next-line react-compiler/react-compiler
    ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
}





function $56ed5432ec247a44$export$368b4214baeb914c(subscription, options) {
    if (options === void 0) options = Object.create(null);
    var hasIssuedDeprecationWarningRef = $cecb01ade82788f9$exports.useRef(false);
    var client = (0, $2937cd197ec1708e$export$eb9a56e7a29e494)(options.client);
    (0, $4b7201da001f4bdf$export$6dfb8732f737404c)(subscription, (0, $4b7201da001f4bdf$export$d1d99cf900472499).Subscription);
    if (!hasIssuedDeprecationWarningRef.current) {
        // eslint-disable-next-line react-compiler/react-compiler
        hasIssuedDeprecationWarningRef.current = true;
        if (options.onSubscriptionData) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(options.onData ? 61 : 62);
        if (options.onSubscriptionComplete) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(options.onComplete ? 63 : 64);
    }
    var skip = options.skip, fetchPolicy = options.fetchPolicy, errorPolicy = options.errorPolicy, shouldResubscribe = options.shouldResubscribe, context = options.context, extensions = options.extensions, ignoreResults = options.ignoreResults;
    var variables = (0, $204c9c6e461cffd8$export$722debc0e56fea39)(function() {
        return options.variables;
    }, [
        options.variables
    ]);
    var recreate = function() {
        return $56ed5432ec247a44$var$createSubscription(client, subscription, variables, fetchPolicy, errorPolicy, context, extensions);
    };
    var _a = $cecb01ade82788f9$exports.useState(options.skip ? null : recreate), observable = _a[0], setObservable = _a[1];
    var recreateRef = $cecb01ade82788f9$exports.useRef(recreate);
    (0, $2765a5c5d3be04a4$export$700979bc83e7db82)(function() {
        recreateRef.current = recreate;
    });
    if (skip) {
        if (observable) setObservable(observable = null);
    } else if (!observable || (client !== observable.__.client || subscription !== observable.__.query || fetchPolicy !== observable.__.fetchPolicy || errorPolicy !== observable.__.errorPolicy || !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(variables, observable.__.variables)) && (typeof shouldResubscribe === "function" ? !!shouldResubscribe(options) : shouldResubscribe) !== false) setObservable(observable = recreate());
    var optionsRef = $cecb01ade82788f9$exports.useRef(options);
    $cecb01ade82788f9$exports.useEffect(function() {
        optionsRef.current = options;
    });
    var fallbackLoading = !skip && !ignoreResults;
    var fallbackResult = $cecb01ade82788f9$exports.useMemo(function() {
        return {
            loading: fallbackLoading,
            error: void 0,
            data: void 0,
            variables: variables
        };
    }, [
        fallbackLoading,
        variables
    ]);
    var ignoreResultsRef = $cecb01ade82788f9$exports.useRef(ignoreResults);
    (0, $2765a5c5d3be04a4$export$700979bc83e7db82)(function() {
        // We cannot reference `ignoreResults` directly in the effect below
        // it would add a dependency to the `useEffect` deps array, which means the
        // subscription would be recreated if `ignoreResults` changes
        // As a result, on resubscription, the last result would be re-delivered,
        // rendering the component one additional time, and re-triggering `onData`.
        // The same applies to `fetchPolicy`, which results in a new `observable`
        // being created. We cannot really avoid it in that case, but we can at least
        // avoid it for `ignoreResults`.
        ignoreResultsRef.current = ignoreResults;
    });
    var ret = (0, $9d9469bb012ba645$export$306c0aa65ff9ec16)($cecb01ade82788f9$exports.useCallback(function(update) {
        if (!observable) return function() {};
        var subscriptionStopped = false;
        var variables = observable.__.variables;
        var client = observable.__.client;
        var subscription = observable.subscribe({
            next: function(fetchResult) {
                var _a, _b;
                if (subscriptionStopped) return;
                var result = {
                    loading: false,
                    // TODO: fetchResult.data can be null but SubscriptionResult.data
                    // expects TData | undefined only
                    data: fetchResult.data,
                    error: (0, $7fa797a3751877df$export$b2c90f1874ba96bf)(fetchResult),
                    variables: variables
                };
                observable.__.setResult(result);
                if (!ignoreResultsRef.current) update();
                if (result.error) (_b = (_a = optionsRef.current).onError) === null || _b === void 0 || _b.call(_a, result.error);
                else if (optionsRef.current.onData) optionsRef.current.onData({
                    client: client,
                    data: result
                });
                else if (optionsRef.current.onSubscriptionData) optionsRef.current.onSubscriptionData({
                    client: client,
                    subscriptionData: result
                });
            },
            error: function(error) {
                var _a, _b;
                error = error instanceof (0, $9b257430d46c4ca9$export$26a337512320b8c6) ? error : new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
                    protocolErrors: [
                        error
                    ]
                });
                if (!subscriptionStopped) {
                    observable.__.setResult({
                        loading: false,
                        data: void 0,
                        error: error,
                        variables: variables
                    });
                    if (!ignoreResultsRef.current) update();
                    (_b = (_a = optionsRef.current).onError) === null || _b === void 0 || _b.call(_a, error);
                }
            },
            complete: function() {
                if (!subscriptionStopped) {
                    if (optionsRef.current.onComplete) optionsRef.current.onComplete();
                    else if (optionsRef.current.onSubscriptionComplete) optionsRef.current.onSubscriptionComplete();
                }
            }
        });
        return function() {
            // immediately stop receiving subscription values, but do not unsubscribe
            // until after a short delay in case another useSubscription hook is
            // reusing the same underlying observable and is about to subscribe
            subscriptionStopped = true;
            setTimeout(function() {
                subscription.unsubscribe();
            });
        };
    }, [
        observable
    ]), function() {
        return observable && !skip && !ignoreResults ? observable.__.result : fallbackResult;
    }, function() {
        return fallbackResult;
    });
    var restart = $cecb01ade82788f9$exports.useCallback(function() {
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!optionsRef.current.skip, 65);
        setObservable(recreateRef.current());
    }, [
        optionsRef,
        recreateRef
    ]);
    return $cecb01ade82788f9$exports.useMemo(function() {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, ret), {
            restart: restart
        });
    }, [
        ret,
        restart
    ]);
}
function $56ed5432ec247a44$var$createSubscription(client, query, variables, fetchPolicy, errorPolicy, context, extensions) {
    var options = {
        query: query,
        variables: variables,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        context: context,
        extensions: extensions
    };
    var __ = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
        client: client,
        result: {
            loading: true,
            data: void 0,
            error: void 0,
            variables: variables
        },
        setResult: function(result) {
            __.result = result;
        }
    });
    var observable = null;
    return Object.assign(new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(function(observer) {
        // lazily start the subscription when the first observer subscribes
        // to get around strict mode
        if (!observable) observable = client.subscribe(options);
        var sub = observable.subscribe(observer);
        return function() {
            return sub.unsubscribe();
        };
    }), {
        /**
         * A tracking object to store details about the observable and the latest result of the subscription.
         */ __: __
    });
}


/** Structural sharing for the editor's immutable JSON-shaped render data. */ function $21ee05de57855177$export$fff6e3d78cde73a4(previous, next) {
    if (previous === next) return next;
    if (!previous || !next || typeof previous !== "object" || typeof next !== "object") return next;
    if (Array.isArray(next)) {
        if (!Array.isArray(previous)) return next;
        let equal = previous.length === next.length;
        const shared = next.map((item, index)=>{
            const value = $21ee05de57855177$export$fff6e3d78cde73a4(previous[index], item);
            if (value !== previous[index]) equal = false;
            return value;
        });
        return equal ? previous : shared;
    }
    if (Array.isArray(previous)) return next;
    const oldRecord = previous;
    const newRecord = next;
    const keys = Object.keys(newRecord);
    let equal = keys.length === Object.keys(oldRecord).length;
    const shared = {};
    for (const key of keys){
        const value = $21ee05de57855177$export$fff6e3d78cde73a4(oldRecord[key], newRecord[key]);
        if (!Object.prototype.hasOwnProperty.call(oldRecord, key) || value !== oldRecord[key]) equal = false;
        shared[key] = value;
    }
    return equal ? previous : shared;
}


function $9d54722198aa259a$export$e129902ff5cdd54b(page) {
    const pageStart = page.page.anchors[0].utf16Start;
    let start = pageStart;
    let end = pageStart + page.textContent.length;
    for (const rhese of page.rhese){
        const anchor = rhese.anchors[0];
        const offset = anchor.utf16Start - pageStart;
        const renderedLength = page.textContent.substring(offset, offset + anchor.utf16Size).length;
        if (renderedLength) {
            start = Math.min(start, anchor.utf16Start);
            end = Math.max(end, anchor.utf16Start + renderedLength);
        }
    }
    const length = end - start;
    const positions = (anchors, visit)=>{
        for (const anchor of anchors){
            const end = Math.min(length, anchor.utf16Start + anchor.utf16Size - start);
            for(let i = Math.max(0, anchor.utf16Start - start); i < end; i++)visit(i);
        }
    };
    const flag = (anchors = [])=>{
        const result = new Uint8Array(length);
        positions(anchors, (i)=>{
            result[i] = 1;
        });
        return result;
    };
    const kinds = new Array(length);
    for (const [items, kind] of [
        [
            page.textCitation,
            "CITATION"
        ],
        [
            page.textWeight,
            "GRAS"
        ],
        [
            page.textItalicization,
            "ITALIQUE"
        ]
    ])positions(items[0]?.anchors || [], (i)=>{
        // Overlapping anchors within the same item still contribute one flag.
        const flags = kinds[i] ||= [];
        if (!flags.includes(kind)) flags.push(kind);
    });
    for (const [items, values, field] of [
        [
            page.textScriptNotation,
            {
                SUBSCRIPT: "INDICE",
                SUPERSCRIPT: "EXPOSANT"
            },
            "textScriptNotation"
        ],
        [
            page.textCase,
            {
                UPPER: "MAJUSCULE",
                LOWER: "MINUSCULE"
            },
            "textCase"
        ]
    ])for (const item of items){
        // Preserve the converter's existing stop-on-empty and item-order semantics.
        if (!item.anchors.length) break;
        const value = item.data[field];
        const kind = values[value];
        if (!kind) continue;
        const covered = new Set();
        positions(item.anchors, (i)=>covered.add(i));
        for (const i of covered)(kinds[i] ||= []).push(kind);
    }
    const first = (items, value)=>{
        const result = new Array(length);
        for (const item of items)// These metadata families historically use only their first anchor.
        if (item.anchors[0]) positions([
            item.anchors[0]
        ], (i)=>{
            if (result[i] === undefined) result[i] = value(item.data);
        });
        return result;
    };
    const phoneme = new Array(length);
    const phonemeKinds = {
        VOWEL: "vowel",
        CONSONANT: "consonant",
        COMPLEX: "complicated"
    };
    for (const item of page.phoneme){
        const kind = phonemeKinds[item.data.kind];
        if (kind) positions(item.anchors, (i)=>{
            phoneme[i] = kind;
        }); // Last matching item wins.
    }
    return {
        start: start,
        kinds: kinds,
        phoneme: phoneme,
        muted: flag(page.textMuted[0]?.anchors),
        syllable: first(page.syllable, (data)=>data.id),
        coloration: first(page.customColoration, (data)=>data.customColorationKey),
        css: first(page.customCss, (data)=>data.customCssClasses)
    };
}


const $d6f8296a78132fd9$var$NO_KINDS = [];
var $d6f8296a78132fd9$export$29e1e7edbd5033fa = /*#__PURE__*/ function($d6f8296a78132fd9$export$29e1e7edbd5033fa) {
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["CITATION"] = "CITATION";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["DEFAULT"] = "DEFAULT";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["EXPOSANT"] = "EXPOSANT";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["GRAS"] = "GRAS";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["INDICE"] = "INDICE";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["ITALIQUE"] = "ITALIQUE";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["MAJUSCULE"] = "MAJUSCULE";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["MINUSCULE"] = "MINUSCULE";
    $d6f8296a78132fd9$export$29e1e7edbd5033fa["MUTE"] = "MUTE";
    return $d6f8296a78132fd9$export$29e1e7edbd5033fa;
}({});
const $d6f8296a78132fd9$export$90646acbacb76625 = (projectId, pageContent)=>{
    const output = {
        __typename: "Page",
        numberOfRheses: pageContent?.rhese.length,
        paragraphs: [],
        rheses: [],
        definitions: []
    };
    pageContent?.definition.forEach((definition)=>{
        output.definitions.push({
            __typename: "Definition",
            id: definition.data.id,
            kind: definition.data.kind,
            definition: definition.data.description,
            imageName: definition.data.imageName,
            audioFile: definition.data.audioFile,
            audioReviewComment: definition.data.audioReviewComment,
            audioReviewStatus: definition.data.audioReviewStatus,
            start: definition.anchors[0].utf16Start,
            size: definition.anchors[0].utf16Size
        });
    });
    pageContent?.paragraph.forEach((paragraph)=>{
        output.paragraphs.push({
            __typename: "Paragraph",
            id: paragraph.anchors[0].externalId,
            kind: paragraph.data.kind,
            tag: paragraph.data.tag?.name,
            dialogueSpeakerId: paragraph.data.speaker?.id,
            projectId: projectId
        });
    });
    const attributes = pageContent && (0, $9d54722198aa259a$export$e129902ff5cdd54b)(pageContent);
    let rhesePosition = 0;
    pageContent?.rhese.forEach((rhese)=>{
        const newRhese = {
            __typename: "SqlxRhese",
            id: rhese.anchors[0].externalId,
            projectId: projectId,
            ignoreTextForAudioSync: rhese.data.ignoreTextForAudioSync,
            lineBreakAfter: rhese.data.lineBreakAfter,
            start: rhese.anchors[0].utf16Start,
            size: rhese.anchors[0].utf16Size,
            paragraphId: null,
            position: rhesePosition++,
            audioRecordingEnd: null,
            audioRecordingStart: null,
            audioRecordingId: null,
            letters: []
        };
        const pageStartOffset = pageContent?.page.anchors[0].utf16Start;
        const start = rhese.anchors[0].utf16Start;
        const offsettedStart = start - pageStartOffset;
        const size = rhese.anchors[0].utf16Size;
        const text = pageContent?.textContent.substring(offsettedStart, offsettedStart + size);
        for (let paragraph of pageContent?.paragraph){
            let paragraphStart = paragraph.anchors[0].utf16Start;
            let paragraphSize = paragraph.anchors[0].utf16Size;
            if (paragraphStart <= start && paragraphStart + paragraphSize >= start + size) {
                newRhese.paragraphId = paragraph.anchors[0].externalId;
                break;
            }
        }
        for(let i = 0; i < text.length; i++){
            const position = start + i - attributes.start;
            const letterKind = [
                "DEFAULT",
                ...attributes.kinds[position] || $d6f8296a78132fd9$var$NO_KINDS
            ];
            const letterIsMuted = !!attributes.muted[position];
            const phonemeKind = attributes.phoneme[position] ?? null;
            const syllableId = attributes.syllable[position] ?? null;
            const customColorationKey = attributes.coloration[position] ?? null;
            const cssClasses = attributes.css[position] ?? null;
            let letter = {
                __typename: "SqlxLetter",
                id: null,
                isMute: letterIsMuted,
                char: text.charAt(i),
                phoneme: phonemeKind,
                absoluteTextPosition: start + i,
                position: i,
                syllableId: syllableId,
                customColoration: customColorationKey,
                kind: letterKind,
                cssClasses: cssClasses
            };
            // @ts-ignore
            newRhese.letters.push(letter);
        }
        // @ts-ignore
        output.rheses.push(newRhese);
    });
    // @ts-ignore
    output.rheses.sort((a, b)=>a.start - b.start);
    return output;
};
function $d6f8296a78132fd9$export$5fe27e00e1af1887() {
    let previous;
    return (projectId, pageContent)=>{
        previous = (0, $21ee05de57855177$export$fff6e3d78cde73a4)(previous, $d6f8296a78132fd9$export$90646acbacb76625(projectId, pageContent));
        return previous;
    };
}
const $d6f8296a78132fd9$export$dfa8e674821d92e7 = (data)=>{
    const output = [];
    const pagesById = new Map();
    for (const page of data.extendedPages)if (!pagesById.has(page.id)) pagesById.set(page.id, page);
    data.computedMetadata?.forEach((computedMetadata)=>{
        const extendedPage = pagesById.get(computedMetadata.externalId);
        if (!extendedPage) return;
        output.push({
            __typename: "Page",
            id: extendedPage.id,
            mutePagesAfter: extendedPage.mutePagesAfter,
            pageNumber: extendedPage.pageNumber.pageNumber,
            lastPageNumber: extendedPage.pageNumber.lastPageNumber,
            partName: extendedPage.partname || null,
            // New infos
            start: computedMetadata.utf16Start,
            size: computedMetadata.utf16Size,
            stringVersion: computedMetadata.stringVersion,
            // Old infos that does not meet current requirements
            numberOfRheses: 0,
            wordsCount: null,
            issuesCount: 0,
            renarratedCount: 0,
            fullyRecorded: false
        });
    });
    return output.sort((a, b)=>a.pageNumber - b.pageNumber);
};



const $e2820f429b7bf591$export$56909a63dceee5e4 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation SetBoldFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        setBoldFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);
const $e2820f429b7bf591$export$dfbb23234410ac77 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UnsetBoldFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        unsetBoldFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);



const $be8ad9aee629aa88$export$c96008beafa95673 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation SetCaseFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $kind: ExtendedTextCase!
      ) {
        setCaseFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          kind: $kind
        )
      }
    `);
const $be8ad9aee629aa88$export$c556b62d366b9791 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UnsetCaseFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $kind: ExtendedTextCase!
      ) {
        unsetCaseFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          kind: $kind
        )
      }
    `);



const $40cac082394d74a9$export$9a8b01557946754d = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation SetCitationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        setCitationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);
const $40cac082394d74a9$export$11ba112db18dde8d = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UnsetCitationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        unsetCitationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);



const $37e93270a3b556ee$export$4dbcd7c069fb54cc = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation SetItalicizationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        setItalicizationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);
const $37e93270a3b556ee$export$d99cb86ed19031f9 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UnsetItalicizationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        unsetItalicizationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);



const $b7be8974895307ad$export$c01896a7be4e05e6 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation SetMuteFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        setMuteFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);
const $b7be8974895307ad$export$26d1265de1014c07 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UnsetMuteFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        unsetMuteFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);



const $90450104ba9a679e$export$9dac96c6d6d500cb = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation SetScriptNotationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $scriptNotation: ExtendedTextScriptNotation!
        $stringVersion: Int!
      ) {
        setScriptNotationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          scriptNotation: $scriptNotation
          stringVersion: $stringVersion
        )
      }
    `);
const $90450104ba9a679e$export$efaaf054478af590 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UnsetScriptNotationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $scriptNotation: ExtendedTextScriptNotation!
        $stringVersion: Int!
      ) {
        unsetScriptNotationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          scriptNotation: $scriptNotation
          stringVersion: $stringVersion
        )
      }
    `);



const $5ca13b1bb5133f96$export$aab3867090efe064 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation SetPhonemeFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $kind: ExtendedPhonemeKind!
      ) {
        setPhonemeFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          kind: $kind
        )
      }
    `);
const $5ca13b1bb5133f96$export$138d955481de2f64 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UnsetPhonemeFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        unsetPhonemeFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);
const $5ca13b1bb5133f96$export$5ee6c43abf88d453 = (0, $f013a28d70124837$export$72e4926bf8358653)`
  query ExtractPhonemesWithRegex($projectId: UUID!, $pattern: String!, $caseSensitive: Boolean!) {
    extractPhonemesWithRegex(
      projectId: $projectId
      pattern: $pattern
      caseSensitive: $caseSensitive
    ) {
      startUtf16
      endUtf16
      text
      context
      contextStartUtf16
      phonemeKind
      removePhoneme
      muting
    }
  }
`;
function $5ca13b1bb5133f96$export$c2654da6314599e4({ projectId: projectId, pattern: pattern, caseSensitive: caseSensitive }, options = {}) {
    return (0, $7fa797a3751877df$export$dd0a697e1782aedd)($5ca13b1bb5133f96$export$5ee6c43abf88d453, {
        variables: {
            projectId: projectId,
            pattern: pattern,
            caseSensitive: caseSensitive
        },
        // Skip the query if pattern is empty
        skip: options.skip || !pattern || !projectId,
        // Fetch policy - adjust as needed
        fetchPolicy: "network-only"
    });
}



const $8933335d77e3c41a$export$53b07caf7d6ad3c4 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation CreatePageFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $mutePagesAfter: Int
        $partname: String
      ) {
        createPageFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          mutePagesAfter: $mutePagesAfter
          partname: $partname
        )
      }
    `);
const $8933335d77e3c41a$export$8505a611e1f1e0e1 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UpdateExtendedPage(
        $projectId: UUID!
        $pageId: UUID!
        $mutePagesAfter: Int!
        $partname: String!
      ) {
        updateExtendedPage(
          projectId: $projectId
          pageId: $pageId
          mutePagesAfter: $mutePagesAfter
          partname: $partname
        )
      }
    `);
const $8933335d77e3c41a$export$69505e0a959c1b09 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UpdateExtendedPagesPartname(
        $projectId: UUID!
        $pageIds: [UUID!]!
        $partname: String!
      ) {
        updateExtendedPagesPartname(projectId: $projectId, pageIds: $pageIds, partname: $partname)
      }
    `);



const $9fbd80a2d225d843$export$5769bc41ec22ace9 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation CreateDefinitionFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $kind: ExtendedDefinitionKind!
        $description: String!
        $imageName: String
      ) {
        createDefinitionFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          kind: $kind
          description: $description
          imageName: $imageName
        )
      }
    `);
const $9fbd80a2d225d843$export$43806d2937c65c73 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation DeleteDefinition($projectId: UUID!, $insertOrder: Int!, $stringVersion: Int!) {
        deleteDefinition(
          projectId: $projectId
          insertOrder: $insertOrder
          stringVersion: $stringVersion
        )
      }
    `);
const $9fbd80a2d225d843$export$1df4105d6bb9fdbe = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UpdateExtendedDefinition(
        $projectId: UUID!
        $definitionId: UUID!
        $kind: ExtendedDefinitionKind!
        $description: String!
        $imageName: String
        $audioFile: UUID!
        $audioReviewStatus: AudioReviewStatus
        $audioReviewComment: String!
      ) {
        updateExtendedDefinition(
          projectId: $projectId
          definitionId: $definitionId
          kind: $kind
          description: $description
          imageName: $imageName
          audioFile: $audioFile
          audioReviewStatus: $audioReviewStatus
          audioReviewComment: $audioReviewComment
        )
      }
    `);



const $e52adb0de4892d08$export$e59ea096342e1f51 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation CreateRheseFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $lineBreakAfter: Boolean!
        $ignoreTextForAudioSync: Boolean!
      ) {
        createRheseFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          lineBreakAfter: $lineBreakAfter
          ignoreTextForAudioSync: $ignoreTextForAudioSync
        )
      }
    `);
const $e52adb0de4892d08$export$2c38ec863e79ad20 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UpdateExtendedRhese(
        $projectId: UUID!
        $rheseId: UUID!
        $lineBreakAfter: Boolean!
        $ignoreTextForAudioSync: Boolean!
      ) {
        updateExtendedRhese(
          projectId: $projectId
          rheseId: $rheseId
          lineBreakAfter: $lineBreakAfter
          ignoreTextForAudioSync: $ignoreTextForAudioSync
        )
      }
    `);



const $e2392b9a58ad59e5$export$7837f15a2af453fd = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation CreateParagraphFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $kind: ExtendedParagraphKind!
        $paragraphTagId: UUID
      ) {
        createParagraphFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          kind: $kind
          paragraphTagId: $paragraphTagId
        )
      }
    `);



const $ad0ed8da91693c22$export$a3f78d789c52e062 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation CreateCssFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $newCss: AddExtendedMetadataCustomCSS!
      ) {
        createCssFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          newCss: $newCss
        )
      }
    `);
const $ad0ed8da91693c22$export$c78059e5858d0847 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation DeleteCssFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        deleteCssFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);



const $96e5d4252dd15814$export$7f84d260e59d12c = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation CreateColorationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $newColoration: AddExtendedMetadataCustomColoration!
      ) {
        createColorationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          newColoration: $newColoration
        )
      }
    `);
const $96e5d4252dd15814$export$c9aaf87a298c13ed = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation DeleteColorationFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        deleteColorationFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);



const $2cbc1e4bffc4bf21$export$7cab5666971b1572 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation CreateSyllableFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        createSyllableFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);
const $2cbc1e4bffc4bf21$export$c6f584713ec549a2 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation DeleteSyllableFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        deleteSyllableFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `);
const $2cbc1e4bffc4bf21$export$a31933b4312d6696 = (0, $f013a28d70124837$export$72e4926bf8358653)`
  query ExtractSyllablesWithRegex($projectId: UUID!, $pattern: String!, $caseSensitive: Boolean!) {
    extractSyllablesWithRegex(
      projectId: $projectId
      pattern: $pattern
      caseSensitive: $caseSensitive
    ) {
      startUtf16
      endUtf16
      text
      context
      contextStartUtf16
      removeSyllable
    }
  }
`;
function $2cbc1e4bffc4bf21$export$60c7652d84285238({ projectId: projectId, pattern: pattern, caseSensitive: caseSensitive }, options = {}) {
    return (0, $7fa797a3751877df$export$dd0a697e1782aedd)($2cbc1e4bffc4bf21$export$a31933b4312d6696, {
        variables: {
            projectId: projectId,
            pattern: pattern,
            caseSensitive: caseSensitive
        },
        // Skip the query if pattern is empty
        skip: options.skip || !pattern || !projectId,
        // Fetch policy - adjust as needed
        fetchPolicy: "network-only"
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");

const $c03d5a64b8e92117$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("h44DG"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $5ecddbeb0e9baf55$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $5ecddbeb0e9baf55$export$14f2b6540d498ce extends $5ecddbeb0e9baf55$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $5ecddbeb0e9baf55$export$d08a45df86040161 extends $5ecddbeb0e9baf55$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $5ecddbeb0e9baf55$export$761f8c0e0fa4624f extends $5ecddbeb0e9baf55$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $5ecddbeb0e9baf55$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($5ecddbeb0e9baf55$export$9b19f1a5abf91e06 || ($5ecddbeb0e9baf55$export$9b19f1a5abf91e06 = {}));


var $1166aba502372688$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $1166aba502372688$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $5ecddbeb0e9baf55$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $c03d5a64b8e92117$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $1166aba502372688$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                if (region && region !== 'any') _headers['x-region'] = region;
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $5ecddbeb0e9baf55$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $5ecddbeb0e9baf55$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $5ecddbeb0e9baf55$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
}


var $fd45b7669321341e$exports = {};
"use strict";
var $fd45b7669321341e$var$__importDefault = $fd45b7669321341e$exports && $fd45b7669321341e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fd45b7669321341e$exports, "__esModule", {
    value: true
});
$fd45b7669321341e$exports.PostgrestError = $fd45b7669321341e$exports.PostgrestBuilder = $fd45b7669321341e$exports.PostgrestTransformBuilder = $fd45b7669321341e$exports.PostgrestFilterBuilder = $fd45b7669321341e$exports.PostgrestQueryBuilder = $fd45b7669321341e$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $fd45b7669321341e$var$PostgrestClient_1 = $fd45b7669321341e$var$__importDefault((parcelRequire("4FUh6")));
$fd45b7669321341e$exports.PostgrestClient = $fd45b7669321341e$var$PostgrestClient_1.default;

const $fd45b7669321341e$var$PostgrestQueryBuilder_1 = $fd45b7669321341e$var$__importDefault((parcelRequire("bqqNG")));
$fd45b7669321341e$exports.PostgrestQueryBuilder = $fd45b7669321341e$var$PostgrestQueryBuilder_1.default;

const $fd45b7669321341e$var$PostgrestFilterBuilder_1 = $fd45b7669321341e$var$__importDefault((parcelRequire("3o7cE")));
$fd45b7669321341e$exports.PostgrestFilterBuilder = $fd45b7669321341e$var$PostgrestFilterBuilder_1.default;

const $fd45b7669321341e$var$PostgrestTransformBuilder_1 = $fd45b7669321341e$var$__importDefault((parcelRequire("iSKkH")));
$fd45b7669321341e$exports.PostgrestTransformBuilder = $fd45b7669321341e$var$PostgrestTransformBuilder_1.default;

const $fd45b7669321341e$var$PostgrestBuilder_1 = $fd45b7669321341e$var$__importDefault((parcelRequire("awOWX")));
$fd45b7669321341e$exports.PostgrestBuilder = $fd45b7669321341e$var$PostgrestBuilder_1.default;

const $fd45b7669321341e$var$PostgrestError_1 = $fd45b7669321341e$var$__importDefault((parcelRequire("hgnOq")));
$fd45b7669321341e$exports.PostgrestError = $fd45b7669321341e$var$PostgrestError_1.default;
$fd45b7669321341e$exports.default = {
    PostgrestClient: $fd45b7669321341e$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $fd45b7669321341e$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $fd45b7669321341e$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $fd45b7669321341e$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $fd45b7669321341e$var$PostgrestBuilder_1.default,
    PostgrestError: $fd45b7669321341e$var$PostgrestError_1.default
};


const { PostgrestClient: $82956af9da08303d$export$796f32e2ee984aaa, PostgrestQueryBuilder: $82956af9da08303d$export$a81993b50ca081ad, PostgrestFilterBuilder: $82956af9da08303d$export$3158317c13bdc93a, PostgrestTransformBuilder: $82956af9da08303d$export$7b4361bb87e3030c, PostgrestBuilder: $82956af9da08303d$export$3106e21688a06353, PostgrestError: $82956af9da08303d$export$445b7e3a323f992f } = (0, (/*@__PURE__*/$parcel$interopDefault($fd45b7669321341e$exports)));
var // compatibility with CJS output
$82956af9da08303d$export$2e2bcd8739ae039 = {
    PostgrestClient: $82956af9da08303d$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $82956af9da08303d$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $82956af9da08303d$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $82956af9da08303d$export$7b4361bb87e3030c,
    PostgrestBuilder: $82956af9da08303d$export$3106e21688a06353,
    PostgrestError: $82956af9da08303d$export$445b7e3a323f992f
};


const $a7b59c65ec3b65a5$export$83d89fbfd8236492 = '2.11.2';


const $792a6e399acf9aef$export$88a84136db6a4b64 = {
    'X-Client-Info': `realtime-js/${(0, $a7b59c65ec3b65a5$export$83d89fbfd8236492)}`
};
const $792a6e399acf9aef$export$df3f558bb9a9c991 = '1.0.0';
const $792a6e399acf9aef$export$7bd623b29ec8e1eb = 10000;
const $792a6e399acf9aef$export$5e80cf62e56a877b = 1000;
var $792a6e399acf9aef$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($792a6e399acf9aef$export$a6d0320a1563d49e || ($792a6e399acf9aef$export$a6d0320a1563d49e = {}));
var $792a6e399acf9aef$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($792a6e399acf9aef$export$b83816118db74fe7 || ($792a6e399acf9aef$export$b83816118db74fe7 = {}));
var $792a6e399acf9aef$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($792a6e399acf9aef$export$8db7548e65d6ea55 || ($792a6e399acf9aef$export$8db7548e65d6ea55 = {}));
var $792a6e399acf9aef$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($792a6e399acf9aef$export$b2688bfb999f5751 || ($792a6e399acf9aef$export$b2688bfb999f5751 = {}));
var $792a6e399acf9aef$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($792a6e399acf9aef$export$deda39003d27273 || ($792a6e399acf9aef$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $aef724c08e0edc12$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $efe351412c91fe95$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $25de206b76d79eee$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($25de206b76d79eee$export$4d213a7d364021dc || ($25de206b76d79eee$export$4d213a7d364021dc = {}));
const $25de206b76d79eee$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $25de206b76d79eee$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $25de206b76d79eee$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $25de206b76d79eee$export$3df02a362b86a91(colType, value);
    return $25de206b76d79eee$var$noop(value);
};
const $25de206b76d79eee$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $25de206b76d79eee$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $25de206b76d79eee$export$4d213a7d364021dc.bool:
            return $25de206b76d79eee$export$3c2e6d1b7583eee6(value);
        case $25de206b76d79eee$export$4d213a7d364021dc.float4:
        case $25de206b76d79eee$export$4d213a7d364021dc.float8:
        case $25de206b76d79eee$export$4d213a7d364021dc.int2:
        case $25de206b76d79eee$export$4d213a7d364021dc.int4:
        case $25de206b76d79eee$export$4d213a7d364021dc.int8:
        case $25de206b76d79eee$export$4d213a7d364021dc.numeric:
        case $25de206b76d79eee$export$4d213a7d364021dc.oid:
            return $25de206b76d79eee$export$a0a81dc3380ce7d3(value);
        case $25de206b76d79eee$export$4d213a7d364021dc.json:
        case $25de206b76d79eee$export$4d213a7d364021dc.jsonb:
            return $25de206b76d79eee$export$d5b7a8bf56ee1fe2(value);
        case $25de206b76d79eee$export$4d213a7d364021dc.timestamp:
            return $25de206b76d79eee$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $25de206b76d79eee$export$4d213a7d364021dc.abstime:
        case $25de206b76d79eee$export$4d213a7d364021dc.date:
        case $25de206b76d79eee$export$4d213a7d364021dc.daterange:
        case $25de206b76d79eee$export$4d213a7d364021dc.int4range:
        case $25de206b76d79eee$export$4d213a7d364021dc.int8range:
        case $25de206b76d79eee$export$4d213a7d364021dc.money:
        case $25de206b76d79eee$export$4d213a7d364021dc.reltime:
        case $25de206b76d79eee$export$4d213a7d364021dc.text:
        case $25de206b76d79eee$export$4d213a7d364021dc.time:
        case $25de206b76d79eee$export$4d213a7d364021dc.timestamptz:
        case $25de206b76d79eee$export$4d213a7d364021dc.timetz:
        case $25de206b76d79eee$export$4d213a7d364021dc.tsrange:
        case $25de206b76d79eee$export$4d213a7d364021dc.tstzrange:
            return $25de206b76d79eee$var$noop(value);
        default:
            // Return the value for remaining types
            return $25de206b76d79eee$var$noop(value);
    }
};
const $25de206b76d79eee$var$noop = (value)=>{
    return value;
};
const $25de206b76d79eee$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $25de206b76d79eee$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $25de206b76d79eee$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $25de206b76d79eee$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$25de206b76d79eee$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $25de206b76d79eee$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $25de206b76d79eee$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};




class $232810aad5ec8ba6$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $792a6e399acf9aef$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $79ecc27b7608d2d0$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($79ecc27b7608d2d0$export$f1ce049df2794fb4 || ($79ecc27b7608d2d0$export$f1ce049df2794fb4 = {}));
class $79ecc27b7608d2d0$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $79ecc27b7608d2d0$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $79ecc27b7608d2d0$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $79ecc27b7608d2d0$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}



var $1b1e83fd303f09c7$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($1b1e83fd303f09c7$export$bc171c571098b6c4 || ($1b1e83fd303f09c7$export$bc171c571098b6c4 = {}));
var $1b1e83fd303f09c7$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($1b1e83fd303f09c7$export$9e3fe8e487ef792e || ($1b1e83fd303f09c7$export$9e3fe8e487ef792e = {}));
var $1b1e83fd303f09c7$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($1b1e83fd303f09c7$export$a6885b926af646a2 || ($1b1e83fd303f09c7$export$a6885b926af646a2 = {}));
const $1b1e83fd303f09c7$export$154db638d9c0559e = (0, $792a6e399acf9aef$export$b83816118db74fe7);
class $1b1e83fd303f09c7$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $792a6e399acf9aef$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $232810aad5ec8ba6$export$2e2bcd8739ae039)(this, (0, $792a6e399acf9aef$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $efe351412c91fe95$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $792a6e399acf9aef$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $792a6e399acf9aef$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $792a6e399acf9aef$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $792a6e399acf9aef$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $792a6e399acf9aef$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $79ecc27b7608d2d0$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $25de206b76d79eee$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($1b1e83fd303f09c7$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($1b1e83fd303f09c7$export$a6885b926af646a2.CLOSED));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($1b1e83fd303f09c7$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback === null || callback === void 0 || callback($1b1e83fd303f09c7$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($1b1e83fd303f09c7$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                callback === null || callback === void 0 || callback($1b1e83fd303f09c7$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($1b1e83fd303f09c7$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $792a6e399acf9aef$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $792a6e399acf9aef$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $232810aad5ec8ba6$export$2e2bcd8739ae039)(this, (0, $792a6e399acf9aef$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        });
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $232810aad5ec8ba6$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $792a6e399acf9aef$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $792a6e399acf9aef$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $792a6e399acf9aef$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $792a6e399acf9aef$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $792a6e399acf9aef$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $1b1e83fd303f09c7$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $792a6e399acf9aef$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $792a6e399acf9aef$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $792a6e399acf9aef$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $25de206b76d79eee$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $25de206b76d79eee$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


const $2041a11cd35514eb$var$noop = ()=>{};
const $2041a11cd35514eb$var$NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== 'undefined';
const $2041a11cd35514eb$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;


class $2041a11cd35514eb$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, $792a6e399acf9aef$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $792a6e399acf9aef$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $2041a11cd35514eb$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $aef724c08e0edc12$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("h44DG"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $792a6e399acf9aef$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $25de206b76d79eee$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $efe351412c91fe95$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (this.transport) {
            this.conn = new this.transport(this.endpointURL(), undefined, {
                headers: this.headers
            });
            return;
        }
        if ($2041a11cd35514eb$var$NATIVE_WEBSOCKET_AVAILABLE) {
            this.conn = new WebSocket(this.endpointURL());
            this.setupConnection();
            return;
        }
        this.conn = new $2041a11cd35514eb$var$WSWebSocketDummy(this.endpointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
        (parcelRequire("cO9vY")).then(({ default: WS })=>{
            this.conn = new WS(this.endpointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
        });
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $792a6e399acf9aef$export$df3f558bb9a9c991)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $792a6e399acf9aef$export$a6d0320a1563d49e).connecting:
                return (0, $792a6e399acf9aef$export$deda39003d27273).Connecting;
            case (0, $792a6e399acf9aef$export$a6d0320a1563d49e).open:
                return (0, $792a6e399acf9aef$export$deda39003d27273).Open;
            case (0, $792a6e399acf9aef$export$a6d0320a1563d49e).closing:
                return (0, $792a6e399acf9aef$export$deda39003d27273).Closing;
            default:
                return (0, $792a6e399acf9aef$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $792a6e399acf9aef$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const chan = new (0, $1b1e83fd303f09c7$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        let tokenToSend = token || this.accessToken && await this.accessToken() || this.accessTokenValue;
        if (tokenToSend) {
            let parsed = null;
            try {
                parsed = JSON.parse(atob(tokenToSend.split('.')[1]));
            } catch (_error) {}
            if (parsed && parsed.exp) {
                let now = Math.floor(Date.now() / 1000);
                let valid = now - parsed.exp < 0;
                if (!valid) {
                    this.log('auth', `InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                    return Promise.reject(`InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                }
            }
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                tokenToSend && channel.updateJoinPayload({
                    access_token: tokenToSend
                });
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $792a6e399acf9aef$export$8db7548e65d6ea55).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $792a6e399acf9aef$export$5e80cf62e56a877b), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth();
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ async _onConnOpen() {
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) {
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
        } else {
            if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
            else this.log('worker', `starting default worker`);
            const objectUrl = this._workerObjectUrl(this.workerUrl);
            this.workerRef = new Worker(objectUrl);
            this.workerRef.onerror = (error)=>{
                this.log('worker', 'worker error', error.message);
                this.workerRef.terminate();
            };
            this.workerRef.onmessage = (event)=>{
                if (event.data.event === 'keepAlive') this.sendHeartbeat();
            };
            this.workerRef.postMessage({
                event: 'start',
                interval: this.heartbeatIntervalMs
            });
        }
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $792a6e399acf9aef$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $2041a11cd35514eb$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
}
class $2041a11cd35514eb$var$WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = 'arraybuffer';
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, $792a6e399acf9aef$export$a6d0320a1563d49e).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}






class $2949f34614e7806c$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $2949f34614e7806c$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $2949f34614e7806c$export$ca9ecfd959b3871c extends $2949f34614e7806c$export$697502632950e9d3 {
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $2949f34614e7806c$export$29127ca2e1a271d extends $2949f34614e7806c$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $982a7f6570d757a4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $982a7f6570d757a4$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("h44DG"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $982a7f6570d757a4$export$ace1d6afc438cf26 = ()=>$982a7f6570d757a4$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("h44DG")))).Response;
        return Response;
    });
const $982a7f6570d757a4$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$982a7f6570d757a4$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $982a7f6570d757a4$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $5a32ee231d0f2679$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5a32ee231d0f2679$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $5a32ee231d0f2679$var$handleError = (error, reject, options)=>$5a32ee231d0f2679$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $982a7f6570d757a4$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, $2949f34614e7806c$export$ca9ecfd959b3871c)($5a32ee231d0f2679$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $2949f34614e7806c$export$29127ca2e1a271d)($5a32ee231d0f2679$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $2949f34614e7806c$export$29127ca2e1a271d)($5a32ee231d0f2679$var$_getErrorMessage(error), error));
    });
const $5a32ee231d0f2679$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $5a32ee231d0f2679$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $5a32ee231d0f2679$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $5a32ee231d0f2679$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$5a32ee231d0f2679$var$handleError(error, reject, options));
        });
    });
}
function $5a32ee231d0f2679$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $5a32ee231d0f2679$var$__awaiter(this, void 0, void 0, function*() {
        return $5a32ee231d0f2679$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $5a32ee231d0f2679$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $5a32ee231d0f2679$var$__awaiter(this, void 0, void 0, function*() {
        return $5a32ee231d0f2679$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $5a32ee231d0f2679$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $5a32ee231d0f2679$var$__awaiter(this, void 0, void 0, function*() {
        return $5a32ee231d0f2679$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $5a32ee231d0f2679$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $5a32ee231d0f2679$var$__awaiter(this, void 0, void 0, function*() {
        return $5a32ee231d0f2679$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $5a32ee231d0f2679$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $5a32ee231d0f2679$var$__awaiter(this, void 0, void 0, function*() {
        return $5a32ee231d0f2679$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f63b4edb84966d93$export$a143d493d941bafc;
var $f63b4edb84966d93$export$e4cf37d7f6fb9e0a;
var $f63b4edb84966d93$export$f99ded8fe4b79145;
var $f63b4edb84966d93$export$599f31c3813fae4d;
'use strict';
var $7dfa4e10f40cbbaf$export$a48f0734ac7c2329;
var $7dfa4e10f40cbbaf$export$d622b2ad8d90c771;
var $7dfa4e10f40cbbaf$export$6100ba28696e12de;
'use strict';
$7dfa4e10f40cbbaf$export$a48f0734ac7c2329 = $7dfa4e10f40cbbaf$var$byteLength;
$7dfa4e10f40cbbaf$export$d622b2ad8d90c771 = $7dfa4e10f40cbbaf$var$toByteArray;
$7dfa4e10f40cbbaf$export$6100ba28696e12de = $7dfa4e10f40cbbaf$var$fromByteArray;
var $7dfa4e10f40cbbaf$var$lookup = [];
var $7dfa4e10f40cbbaf$var$revLookup = [];
var $7dfa4e10f40cbbaf$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $7dfa4e10f40cbbaf$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $7dfa4e10f40cbbaf$var$i = 0, $7dfa4e10f40cbbaf$var$len = $7dfa4e10f40cbbaf$var$code.length; $7dfa4e10f40cbbaf$var$i < $7dfa4e10f40cbbaf$var$len; ++$7dfa4e10f40cbbaf$var$i){
    $7dfa4e10f40cbbaf$var$lookup[$7dfa4e10f40cbbaf$var$i] = $7dfa4e10f40cbbaf$var$code[$7dfa4e10f40cbbaf$var$i];
    $7dfa4e10f40cbbaf$var$revLookup[$7dfa4e10f40cbbaf$var$code.charCodeAt($7dfa4e10f40cbbaf$var$i)] = $7dfa4e10f40cbbaf$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7dfa4e10f40cbbaf$var$revLookup['-'.charCodeAt(0)] = 62;
$7dfa4e10f40cbbaf$var$revLookup['_'.charCodeAt(0)] = 63;
function $7dfa4e10f40cbbaf$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7dfa4e10f40cbbaf$var$byteLength(b64) {
    var lens = $7dfa4e10f40cbbaf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7dfa4e10f40cbbaf$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7dfa4e10f40cbbaf$var$toByteArray(b64) {
    var tmp;
    var lens = $7dfa4e10f40cbbaf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7dfa4e10f40cbbaf$var$Arr($7dfa4e10f40cbbaf$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i)] << 18 | $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i)] << 2 | $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i)] << 10 | $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7dfa4e10f40cbbaf$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7dfa4e10f40cbbaf$var$tripletToBase64(num) {
    return $7dfa4e10f40cbbaf$var$lookup[num >> 18 & 0x3F] + $7dfa4e10f40cbbaf$var$lookup[num >> 12 & 0x3F] + $7dfa4e10f40cbbaf$var$lookup[num >> 6 & 0x3F] + $7dfa4e10f40cbbaf$var$lookup[num & 0x3F];
}
function $7dfa4e10f40cbbaf$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7dfa4e10f40cbbaf$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $7dfa4e10f40cbbaf$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7dfa4e10f40cbbaf$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7dfa4e10f40cbbaf$var$lookup[tmp >> 2] + $7dfa4e10f40cbbaf$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7dfa4e10f40cbbaf$var$lookup[tmp >> 10] + $7dfa4e10f40cbbaf$var$lookup[tmp >> 4 & 0x3F] + $7dfa4e10f40cbbaf$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $45eb6ae44fd4aa27$export$aafa59e2e03f2942;
var $45eb6ae44fd4aa27$export$68d8715fc104d294;
$45eb6ae44fd4aa27$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$45eb6ae44fd4aa27$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $f63b4edb84966d93$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f63b4edb84966d93$export$a143d493d941bafc = $f63b4edb84966d93$var$Buffer;
$f63b4edb84966d93$export$e4cf37d7f6fb9e0a = $f63b4edb84966d93$var$SlowBuffer;
$f63b4edb84966d93$export$f99ded8fe4b79145 = 50;
const $f63b4edb84966d93$var$K_MAX_LENGTH = 0x7fffffff;
$f63b4edb84966d93$export$599f31c3813fae4d = $f63b4edb84966d93$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f63b4edb84966d93$var$Buffer.TYPED_ARRAY_SUPPORT = $f63b4edb84966d93$var$typedArraySupport();
if (!$f63b4edb84966d93$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f63b4edb84966d93$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f63b4edb84966d93$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f63b4edb84966d93$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f63b4edb84966d93$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f63b4edb84966d93$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f63b4edb84966d93$var$createBuffer(length) {
    if (length > $f63b4edb84966d93$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f63b4edb84966d93$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f63b4edb84966d93$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f63b4edb84966d93$var$allocUnsafe(arg);
    }
    return $f63b4edb84966d93$var$from(arg, encodingOrOffset, length);
}
$f63b4edb84966d93$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f63b4edb84966d93$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f63b4edb84966d93$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f63b4edb84966d93$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f63b4edb84966d93$var$isInstance(value, ArrayBuffer) || value && $f63b4edb84966d93$var$isInstance(value.buffer, ArrayBuffer)) return $f63b4edb84966d93$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f63b4edb84966d93$var$isInstance(value, SharedArrayBuffer) || value && $f63b4edb84966d93$var$isInstance(value.buffer, SharedArrayBuffer))) return $f63b4edb84966d93$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f63b4edb84966d93$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f63b4edb84966d93$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f63b4edb84966d93$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f63b4edb84966d93$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f63b4edb84966d93$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f63b4edb84966d93$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f63b4edb84966d93$var$Buffer, Uint8Array);
function $f63b4edb84966d93$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f63b4edb84966d93$var$alloc(size, fill, encoding) {
    $f63b4edb84966d93$var$assertSize(size);
    if (size <= 0) return $f63b4edb84966d93$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f63b4edb84966d93$var$createBuffer(size).fill(fill, encoding) : $f63b4edb84966d93$var$createBuffer(size).fill(fill);
    return $f63b4edb84966d93$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f63b4edb84966d93$var$Buffer.alloc = function(size, fill, encoding) {
    return $f63b4edb84966d93$var$alloc(size, fill, encoding);
};
function $f63b4edb84966d93$var$allocUnsafe(size) {
    $f63b4edb84966d93$var$assertSize(size);
    return $f63b4edb84966d93$var$createBuffer(size < 0 ? 0 : $f63b4edb84966d93$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f63b4edb84966d93$var$Buffer.allocUnsafe = function(size) {
    return $f63b4edb84966d93$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f63b4edb84966d93$var$Buffer.allocUnsafeSlow = function(size) {
    return $f63b4edb84966d93$var$allocUnsafe(size);
};
function $f63b4edb84966d93$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f63b4edb84966d93$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $f63b4edb84966d93$var$byteLength(string, encoding) | 0;
    let buf = $f63b4edb84966d93$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f63b4edb84966d93$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f63b4edb84966d93$var$checked(array.length) | 0;
    const buf = $f63b4edb84966d93$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f63b4edb84966d93$var$fromArrayView(arrayView) {
    if ($f63b4edb84966d93$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f63b4edb84966d93$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f63b4edb84966d93$var$fromArrayLike(arrayView);
}
function $f63b4edb84966d93$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f63b4edb84966d93$var$Buffer.prototype);
    return buf;
}
function $f63b4edb84966d93$var$fromObject(obj) {
    if ($f63b4edb84966d93$var$Buffer.isBuffer(obj)) {
        const len = $f63b4edb84966d93$var$checked(obj.length) | 0;
        const buf = $f63b4edb84966d93$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f63b4edb84966d93$var$numberIsNaN(obj.length)) return $f63b4edb84966d93$var$createBuffer(0);
        return $f63b4edb84966d93$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f63b4edb84966d93$var$fromArrayLike(obj.data);
}
function $f63b4edb84966d93$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f63b4edb84966d93$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f63b4edb84966d93$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f63b4edb84966d93$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f63b4edb84966d93$var$Buffer.alloc(+length);
}
$f63b4edb84966d93$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f63b4edb84966d93$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f63b4edb84966d93$var$Buffer.compare = function compare(a, b) {
    if ($f63b4edb84966d93$var$isInstance(a, Uint8Array)) a = $f63b4edb84966d93$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f63b4edb84966d93$var$isInstance(b, Uint8Array)) b = $f63b4edb84966d93$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f63b4edb84966d93$var$Buffer.isBuffer(a) || !$f63b4edb84966d93$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f63b4edb84966d93$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f63b4edb84966d93$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f63b4edb84966d93$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f63b4edb84966d93$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f63b4edb84966d93$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f63b4edb84966d93$var$Buffer.isBuffer(buf)) buf = $f63b4edb84966d93$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f63b4edb84966d93$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f63b4edb84966d93$var$byteLength(string, encoding) {
    if ($f63b4edb84966d93$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f63b4edb84966d93$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f63b4edb84966d93$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f63b4edb84966d93$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f63b4edb84966d93$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f63b4edb84966d93$var$Buffer.byteLength = $f63b4edb84966d93$var$byteLength;
function $f63b4edb84966d93$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f63b4edb84966d93$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f63b4edb84966d93$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f63b4edb84966d93$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f63b4edb84966d93$var$latin1Slice(this, start, end);
        case 'base64':
            return $f63b4edb84966d93$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f63b4edb84966d93$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f63b4edb84966d93$var$Buffer.prototype._isBuffer = true;
function $f63b4edb84966d93$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f63b4edb84966d93$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$f63b4edb84966d93$var$swap(this, i, i + 1);
    return this;
};
$f63b4edb84966d93$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $f63b4edb84966d93$var$swap(this, i, i + 3);
        $f63b4edb84966d93$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f63b4edb84966d93$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $f63b4edb84966d93$var$swap(this, i, i + 7);
        $f63b4edb84966d93$var$swap(this, i + 1, i + 6);
        $f63b4edb84966d93$var$swap(this, i + 2, i + 5);
        $f63b4edb84966d93$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f63b4edb84966d93$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f63b4edb84966d93$var$utf8Slice(this, 0, length);
    return $f63b4edb84966d93$var$slowToString.apply(this, arguments);
};
$f63b4edb84966d93$var$Buffer.prototype.toLocaleString = $f63b4edb84966d93$var$Buffer.prototype.toString;
$f63b4edb84966d93$var$Buffer.prototype.equals = function equals(b) {
    if (!$f63b4edb84966d93$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f63b4edb84966d93$var$Buffer.compare(this, b) === 0;
};
$f63b4edb84966d93$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $f63b4edb84966d93$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f63b4edb84966d93$var$customInspectSymbol) $f63b4edb84966d93$var$Buffer.prototype[$f63b4edb84966d93$var$customInspectSymbol] = $f63b4edb84966d93$var$Buffer.prototype.inspect;
$f63b4edb84966d93$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f63b4edb84966d93$var$isInstance(target, Uint8Array)) target = $f63b4edb84966d93$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f63b4edb84966d93$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f63b4edb84966d93$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f63b4edb84966d93$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f63b4edb84966d93$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f63b4edb84966d93$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f63b4edb84966d93$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f63b4edb84966d93$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f63b4edb84966d93$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f63b4edb84966d93$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f63b4edb84966d93$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f63b4edb84966d93$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f63b4edb84966d93$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f63b4edb84966d93$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f63b4edb84966d93$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f63b4edb84966d93$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f63b4edb84966d93$var$utf8Write(buf, string, offset, length) {
    return $f63b4edb84966d93$var$blitBuffer($f63b4edb84966d93$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f63b4edb84966d93$var$asciiWrite(buf, string, offset, length) {
    return $f63b4edb84966d93$var$blitBuffer($f63b4edb84966d93$var$asciiToBytes(string), buf, offset, length);
}
function $f63b4edb84966d93$var$base64Write(buf, string, offset, length) {
    return $f63b4edb84966d93$var$blitBuffer($f63b4edb84966d93$var$base64ToBytes(string), buf, offset, length);
}
function $f63b4edb84966d93$var$ucs2Write(buf, string, offset, length) {
    return $f63b4edb84966d93$var$blitBuffer($f63b4edb84966d93$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f63b4edb84966d93$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f63b4edb84966d93$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f63b4edb84966d93$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f63b4edb84966d93$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f63b4edb84966d93$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f63b4edb84966d93$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f63b4edb84966d93$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f63b4edb84966d93$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7dfa4e10f40cbbaf$export$6100ba28696e12de(buf);
    else return $7dfa4e10f40cbbaf$export$6100ba28696e12de(buf.slice(start, end));
}
function $f63b4edb84966d93$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f63b4edb84966d93$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f63b4edb84966d93$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f63b4edb84966d93$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f63b4edb84966d93$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f63b4edb84966d93$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f63b4edb84966d93$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f63b4edb84966d93$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f63b4edb84966d93$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $f63b4edb84966d93$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f63b4edb84966d93$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f63b4edb84966d93$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f63b4edb84966d93$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f63b4edb84966d93$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f63b4edb84966d93$var$Buffer.prototype.readUintLE = $f63b4edb84966d93$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f63b4edb84966d93$var$Buffer.prototype.readUintBE = $f63b4edb84966d93$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f63b4edb84966d93$var$Buffer.prototype.readUint8 = $f63b4edb84966d93$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f63b4edb84966d93$var$Buffer.prototype.readUint16LE = $f63b4edb84966d93$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f63b4edb84966d93$var$Buffer.prototype.readUint16BE = $f63b4edb84966d93$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f63b4edb84966d93$var$Buffer.prototype.readUint32LE = $f63b4edb84966d93$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f63b4edb84966d93$var$Buffer.prototype.readUint32BE = $f63b4edb84966d93$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f63b4edb84966d93$var$Buffer.prototype.readBigUInt64LE = $f63b4edb84966d93$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f63b4edb84966d93$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f63b4edb84966d93$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f63b4edb84966d93$var$Buffer.prototype.readBigUInt64BE = $f63b4edb84966d93$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f63b4edb84966d93$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f63b4edb84966d93$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f63b4edb84966d93$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f63b4edb84966d93$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f63b4edb84966d93$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f63b4edb84966d93$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f63b4edb84966d93$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f63b4edb84966d93$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f63b4edb84966d93$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f63b4edb84966d93$var$Buffer.prototype.readBigInt64LE = $f63b4edb84966d93$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f63b4edb84966d93$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f63b4edb84966d93$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f63b4edb84966d93$var$Buffer.prototype.readBigInt64BE = $f63b4edb84966d93$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f63b4edb84966d93$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f63b4edb84966d93$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f63b4edb84966d93$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 4, this.length);
    return $45eb6ae44fd4aa27$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$f63b4edb84966d93$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 4, this.length);
    return $45eb6ae44fd4aa27$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$f63b4edb84966d93$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 8, this.length);
    return $45eb6ae44fd4aa27$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$f63b4edb84966d93$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkOffset(offset, 8, this.length);
    return $45eb6ae44fd4aa27$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $f63b4edb84966d93$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f63b4edb84966d93$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f63b4edb84966d93$var$Buffer.prototype.writeUintLE = $f63b4edb84966d93$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f63b4edb84966d93$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f63b4edb84966d93$var$Buffer.prototype.writeUintBE = $f63b4edb84966d93$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f63b4edb84966d93$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f63b4edb84966d93$var$Buffer.prototype.writeUint8 = $f63b4edb84966d93$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f63b4edb84966d93$var$Buffer.prototype.writeUint16LE = $f63b4edb84966d93$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f63b4edb84966d93$var$Buffer.prototype.writeUint16BE = $f63b4edb84966d93$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f63b4edb84966d93$var$Buffer.prototype.writeUint32LE = $f63b4edb84966d93$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f63b4edb84966d93$var$Buffer.prototype.writeUint32BE = $f63b4edb84966d93$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f63b4edb84966d93$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f63b4edb84966d93$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f63b4edb84966d93$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f63b4edb84966d93$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f63b4edb84966d93$var$Buffer.prototype.writeBigUInt64LE = $f63b4edb84966d93$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f63b4edb84966d93$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f63b4edb84966d93$var$Buffer.prototype.writeBigUInt64BE = $f63b4edb84966d93$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f63b4edb84966d93$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f63b4edb84966d93$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f63b4edb84966d93$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f63b4edb84966d93$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f63b4edb84966d93$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f63b4edb84966d93$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f63b4edb84966d93$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f63b4edb84966d93$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f63b4edb84966d93$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f63b4edb84966d93$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f63b4edb84966d93$var$Buffer.prototype.writeBigInt64LE = $f63b4edb84966d93$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f63b4edb84966d93$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f63b4edb84966d93$var$Buffer.prototype.writeBigInt64BE = $f63b4edb84966d93$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f63b4edb84966d93$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f63b4edb84966d93$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f63b4edb84966d93$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $45eb6ae44fd4aa27$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f63b4edb84966d93$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f63b4edb84966d93$var$writeFloat(this, value, offset, true, noAssert);
};
$f63b4edb84966d93$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f63b4edb84966d93$var$writeFloat(this, value, offset, false, noAssert);
};
function $f63b4edb84966d93$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f63b4edb84966d93$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $45eb6ae44fd4aa27$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f63b4edb84966d93$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f63b4edb84966d93$var$writeDouble(this, value, offset, true, noAssert);
};
$f63b4edb84966d93$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f63b4edb84966d93$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f63b4edb84966d93$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f63b4edb84966d93$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f63b4edb84966d93$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f63b4edb84966d93$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f63b4edb84966d93$var$Buffer.isBuffer(val) ? val : $f63b4edb84966d93$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f63b4edb84966d93$var$errors = {};
function $f63b4edb84966d93$var$E(sym, getMessage, Base) {
    $f63b4edb84966d93$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$f63b4edb84966d93$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f63b4edb84966d93$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f63b4edb84966d93$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f63b4edb84966d93$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f63b4edb84966d93$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f63b4edb84966d93$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f63b4edb84966d93$var$checkBounds(buf, offset, byteLength) {
    $f63b4edb84966d93$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f63b4edb84966d93$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f63b4edb84966d93$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f63b4edb84966d93$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f63b4edb84966d93$var$checkBounds(buf, offset, byteLength);
}
function $f63b4edb84966d93$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f63b4edb84966d93$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f63b4edb84966d93$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f63b4edb84966d93$var$validateNumber(value, type);
        throw new $f63b4edb84966d93$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f63b4edb84966d93$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f63b4edb84966d93$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f63b4edb84966d93$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f63b4edb84966d93$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f63b4edb84966d93$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f63b4edb84966d93$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f63b4edb84966d93$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f63b4edb84966d93$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f63b4edb84966d93$var$base64ToBytes(str) {
    return $7dfa4e10f40cbbaf$export$d622b2ad8d90c771($f63b4edb84966d93$var$base64clean(str));
}
function $f63b4edb84966d93$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f63b4edb84966d93$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f63b4edb84966d93$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f63b4edb84966d93$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f63b4edb84966d93$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f63b4edb84966d93$var$BufferBigIntNotDefined : fn;
}
function $f63b4edb84966d93$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $c47820c0af852312$require$Buffer = $f63b4edb84966d93$export$a143d493d941bafc;
var $c47820c0af852312$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $c47820c0af852312$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $c47820c0af852312$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $c47820c0af852312$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $982a7f6570d757a4$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $c47820c0af852312$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $c47820c0af852312$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $2949f34614e7806c$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $5a32ee231d0f2679$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $5a32ee231d0f2679$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $982a7f6570d757a4$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $5a32ee231d0f2679$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error) && error instanceof (0, $2949f34614e7806c$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $c47820c0af852312$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $c47820c0af852312$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $c47820c0af852312$require$Buffer !== 'undefined') return $c47820c0af852312$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}


// generated by genversion
const $98f4bb57a1097fcf$export$83d89fbfd8236492 = '2.7.1';


const $ff78acaca8b1bc11$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $98f4bb57a1097fcf$export$83d89fbfd8236492)}`
};





var $326dae2700358002$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $326dae2700358002$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $ff78acaca8b1bc11$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $982a7f6570d757a4$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $326dae2700358002$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $326dae2700358002$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $326dae2700358002$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $326dae2700358002$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $326dae2700358002$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $326dae2700358002$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5a32ee231d0f2679$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $2949f34614e7806c$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $f4b7ac0bf5be9ca9$export$6c85f5032e75eff9 extends (0, $326dae2700358002$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $c47820c0af852312$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


const $da6d3274d5619b06$export$83d89fbfd8236492 = '2.48.1';


let $061712032059ae6f$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $061712032059ae6f$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $061712032059ae6f$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $061712032059ae6f$var$JS_ENV = 'react-native';
else $061712032059ae6f$var$JS_ENV = 'node';
const $061712032059ae6f$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$061712032059ae6f$var$JS_ENV}/${(0, $da6d3274d5619b06$export$83d89fbfd8236492)}`
};
const $061712032059ae6f$export$b63a5c3a2e5becd2 = {
    headers: $061712032059ae6f$export$88a84136db6a4b64
};
const $061712032059ae6f$export$b31378ae815bea6b = {
    schema: 'public'
};
const $061712032059ae6f$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $061712032059ae6f$export$59685507ca0a3912 = {};



var $h44DG = parcelRequire("h44DG");
var $f9b4d500549c1fc0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f9b4d500549c1fc0$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $h44DG.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $f9b4d500549c1fc0$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $h44DG.Headers;
    return Headers;
};
const $f9b4d500549c1fc0$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $f9b4d500549c1fc0$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $f9b4d500549c1fc0$export$3d2cf54f85b7fc8a();
    return (input, init)=>$f9b4d500549c1fc0$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $c8d453927d08f542$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $c8d453927d08f542$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $c8d453927d08f542$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, '');
}
const $c8d453927d08f542$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $c8d453927d08f542$export$da186dc3f8eace71(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions),
        accessToken: ()=>$c8d453927d08f542$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $1aa92462a3a46c26$export$83d89fbfd8236492 = '2.67.3';


const $570b3134cfd76a77$export$7fedf552187f0c3d = 'http://localhost:9999';
const $570b3134cfd76a77$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $570b3134cfd76a77$export$2f9161bad044dacb = '';
const $570b3134cfd76a77$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $1aa92462a3a46c26$export$83d89fbfd8236492)}`
};
const $570b3134cfd76a77$export$7d4b3a66850dd9bd = 10; // in seconds
const $570b3134cfd76a77$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $570b3134cfd76a77$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $570b3134cfd76a77$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};



function $04ef27c59a575fba$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $04ef27c59a575fba$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $04ef27c59a575fba$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $04ef27c59a575fba$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $04ef27c59a575fba$export$9ec034ee80211814 = ()=>{
    if (!$04ef27c59a575fba$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($04ef27c59a575fba$var$localStorageWriteTests.tested) return $04ef27c59a575fba$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $04ef27c59a575fba$var$localStorageWriteTests.tested = true;
        $04ef27c59a575fba$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $04ef27c59a575fba$var$localStorageWriteTests.tested = true;
        $04ef27c59a575fba$var$localStorageWriteTests.writable = false;
    }
    return $04ef27c59a575fba$var$localStorageWriteTests.writable;
};
function $04ef27c59a575fba$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $04ef27c59a575fba$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("h44DG"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $04ef27c59a575fba$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $04ef27c59a575fba$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $04ef27c59a575fba$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $04ef27c59a575fba$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
function $04ef27c59a575fba$export$f0d30a693d94f11c(value) {
    const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let base64 = '';
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    value = value.replace('-', '+').replace('_', '/');
    while(i < value.length){
        enc1 = key.indexOf(value.charAt(i++));
        enc2 = key.indexOf(value.charAt(i++));
        enc3 = key.indexOf(value.charAt(i++));
        enc4 = key.indexOf(value.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        base64 = base64 + String.fromCharCode(chr1);
        if (enc3 != 64 && chr2 != 0) base64 = base64 + String.fromCharCode(chr2);
        if (enc4 != 64 && chr3 != 0) base64 = base64 + String.fromCharCode(chr3);
    }
    return base64;
}
class $04ef27c59a575fba$export$85f6557964517f1a {
    constructor(){
        this.promise = new $04ef27c59a575fba$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$04ef27c59a575fba$export$85f6557964517f1a.promiseConstructor = Promise;
function $04ef27c59a575fba$export$cc1c0b988f7b5577(token) {
    // Regex checks for base64url format
    const base64UrlRegex = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i;
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('JWT is not valid: not a JWT structure');
    if (!base64UrlRegex.test(parts[1])) throw new Error('JWT is not valid: payload is not in base64url format');
    const base64Url = parts[1];
    return JSON.parse($04ef27c59a575fba$export$f0d30a693d94f11c(base64Url));
}
async function $04ef27c59a575fba$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $04ef27c59a575fba$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $04ef27c59a575fba$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $04ef27c59a575fba$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $04ef27c59a575fba$var$dec2hex).join('');
}
async function $04ef27c59a575fba$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
function $04ef27c59a575fba$var$base64urlencode(str) {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $04ef27c59a575fba$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $04ef27c59a575fba$var$sha256(verifier);
    return $04ef27c59a575fba$var$base64urlencode(hashed);
}
async function $04ef27c59a575fba$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $04ef27c59a575fba$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $04ef27c59a575fba$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $04ef27c59a575fba$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $04ef27c59a575fba$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $04ef27c59a575fba$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $570b3134cfd76a77$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($04ef27c59a575fba$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}


class $ad56220fb83af5b5$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $ad56220fb83af5b5$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $ad56220fb83af5b5$export$45fde0b55b14f37b extends $ad56220fb83af5b5$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $ad56220fb83af5b5$export$4fe744aeb810d543(error) {
    return $ad56220fb83af5b5$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $ad56220fb83af5b5$export$f7559805d4a50078 extends $ad56220fb83af5b5$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $ad56220fb83af5b5$export$823c745ae0673c5e extends $ad56220fb83af5b5$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $ad56220fb83af5b5$export$403b3fc0d3ad5f0c extends $ad56220fb83af5b5$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $ad56220fb83af5b5$export$3e849aa4db565c1d(error) {
    return $ad56220fb83af5b5$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $ad56220fb83af5b5$export$7e277b620449c1b4 extends $ad56220fb83af5b5$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $ad56220fb83af5b5$export$9ef583f0381b4cc extends $ad56220fb83af5b5$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $ad56220fb83af5b5$export$bf5df8e043856ef5 extends $ad56220fb83af5b5$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $ad56220fb83af5b5$export$45edea3999507afd(error) {
    return $ad56220fb83af5b5$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $ad56220fb83af5b5$export$39583657eb2a7027 extends $ad56220fb83af5b5$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $ad56220fb83af5b5$export$2423b763f68be1b4 extends $ad56220fb83af5b5$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $ad56220fb83af5b5$export$a77af358da5fb874(error) {
    return $ad56220fb83af5b5$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $ad56220fb83af5b5$export$b034076aa04913a6 extends $ad56220fb83af5b5$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $ad56220fb83af5b5$export$dac36143fd8a46ef(error) {
    return $ad56220fb83af5b5$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}


var $2fa4441f6e7937be$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $2fa4441f6e7937be$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $2fa4441f6e7937be$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $2fa4441f6e7937be$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $04ef27c59a575fba$export$e8ad6599be1036a7)(error)) throw new (0, $ad56220fb83af5b5$export$2423b763f68be1b4)($2fa4441f6e7937be$var$_getErrorMessage(error), 0);
    if ($2fa4441f6e7937be$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $ad56220fb83af5b5$export$2423b763f68be1b4)($2fa4441f6e7937be$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $ad56220fb83af5b5$export$f7559805d4a50078)($2fa4441f6e7937be$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $04ef27c59a575fba$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $570b3134cfd76a77$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $ad56220fb83af5b5$export$b034076aa04913a6)($2fa4441f6e7937be$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $ad56220fb83af5b5$export$b034076aa04913a6)($2fa4441f6e7937be$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)();
    throw new (0, $ad56220fb83af5b5$export$45fde0b55b14f37b)($2fa4441f6e7937be$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $2fa4441f6e7937be$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $2fa4441f6e7937be$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $570b3134cfd76a77$export$e4f5507f88977535]) headers[0, $570b3134cfd76a77$export$e4f5507f88977535] = (0, $570b3134cfd76a77$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $2fa4441f6e7937be$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $2fa4441f6e7937be$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $2fa4441f6e7937be$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $ad56220fb83af5b5$export$2423b763f68be1b4)($2fa4441f6e7937be$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $2fa4441f6e7937be$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $2fa4441f6e7937be$export$d3da1ecaf1206c58(e);
    }
}
function $2fa4441f6e7937be$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($2fa4441f6e7937be$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $04ef27c59a575fba$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $2fa4441f6e7937be$export$db83aade1c2922c7(data) {
    const response = $2fa4441f6e7937be$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $2fa4441f6e7937be$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $2fa4441f6e7937be$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $2fa4441f6e7937be$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $2fa4441f6e7937be$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $2fa4441f6e7937be$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $2fa4441f6e7937be$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $d608b043ec70702f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $d608b043ec70702f$export$2e2bcd8739ae039 {
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $04ef27c59a575fba$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = 'global') {
        try {
            await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $d608b043ec70702f$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $2fa4441f6e7937be$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $2fa4441f6e7937be$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}








const $10eb2cd078f2ea1b$export$bba7b6c94612d04b = {
    getItem: (key)=>{
        if (!(0, $04ef27c59a575fba$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $04ef27c59a575fba$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $04ef27c59a575fba$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $10eb2cd078f2ea1b$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $2e6399f3ac39c415$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $7cdfeee4a0ebc347$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $04ef27c59a575fba$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $7cdfeee4a0ebc347$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $7cdfeee4a0ebc347$export$4aa56776043a4631 extends $7cdfeee4a0ebc347$export$23e9464cc010dff9 {
}
class $7cdfeee4a0ebc347$export$4b982ee840d3d915 extends $7cdfeee4a0ebc347$export$23e9464cc010dff9 {
}
async function $7cdfeee4a0ebc347$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($7cdfeee4a0ebc347$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($7cdfeee4a0ebc347$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if ($7cdfeee4a0ebc347$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($7cdfeee4a0ebc347$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($7cdfeee4a0ebc347$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $7cdfeee4a0ebc347$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($7cdfeee4a0ebc347$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const $7cdfeee4a0ebc347$var$PROCESS_LOCKS = {};
async function $7cdfeee4a0ebc347$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $7cdfeee4a0ebc347$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $7cdfeee4a0ebc347$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $7cdfeee4a0ebc347$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}


(0, $2e6399f3ac39c415$export$ad067ce270531206)(); // Make "globalThis" available
const $74a1eb7091789c46$var$DEFAULT_OPTIONS = {
    url: (0, $570b3134cfd76a77$export$7fedf552187f0c3d),
    storageKey: (0, $570b3134cfd76a77$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $570b3134cfd76a77$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
/** Current session will be checked for refresh at this interval. */ const $74a1eb7091789c46$var$AUTO_REFRESH_TICK_DURATION = 30000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */ const $74a1eb7091789c46$var$AUTO_REFRESH_TICK_THRESHOLD = 3;
async function $74a1eb7091789c46$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $74a1eb7091789c46$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $74a1eb7091789c46$export$2e2bcd8739ae039.nextInstanceID;
        $74a1eb7091789c46$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $04ef27c59a575fba$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $74a1eb7091789c46$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $d608b043ec70702f$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $04ef27c59a575fba$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $74a1eb7091789c46$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $04ef27c59a575fba$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $7cdfeee4a0ebc347$export$f4ff21938fb7af3c);
        else this.lock = $74a1eb7091789c46$var$lockNoOp;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $04ef27c59a575fba$export$9ec034ee80211814)()) this.storage = (0, $10eb2cd078f2ea1b$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $10eb2cd078f2ea1b$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $10eb2cd078f2ea1b$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $04ef27c59a575fba$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $1aa92462a3a46c26$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, $04ef27c59a575fba$export$7a29392fb778224c)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $04ef27c59a575fba$export$4e09c449d6c407f7)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $ad56220fb83af5b5$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $ad56220fb83af5b5$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $2fa4441f6e7937be$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $04ef27c59a575fba$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $2fa4441f6e7937be$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $2fa4441f6e7937be$export$273fe4673a018c2e)
                });
            } else throw new (0, $ad56220fb83af5b5$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $2fa4441f6e7937be$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $2fa4441f6e7937be$export$db83aade1c2922c7)
                });
            } else throw new (0, $ad56220fb83af5b5$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $ad56220fb83af5b5$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $04ef27c59a575fba$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $2fa4441f6e7937be$export$273fe4673a018c2e)
            });
            await (0, $04ef27c59a575fba$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $ad56220fb83af5b5$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $2fa4441f6e7937be$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $ad56220fb83af5b5$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $04ef27c59a575fba$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $ad56220fb83af5b5$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $2fa4441f6e7937be$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $04ef27c59a575fba$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $2fa4441f6e7937be$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $ad56220fb83af5b5$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $04ef27c59a575fba$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            const hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.storage.isServer) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) {
                if ((0, $ad56220fb83af5b5$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $04ef27c59a575fba$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $04ef27c59a575fba$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $2fa4441f6e7937be$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Decodes a JWT (without performing any validation).
     */ _decodeJWT(jwt) {
        return (0, $04ef27c59a575fba$export$cc1c0b988f7b5577)(jwt);
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const payload = (0, $04ef27c59a575fba$export$cc1c0b988f7b5577)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $04ef27c59a575fba$export$4e09c449d6c407f7)()) throw new (0, $ad56220fb83af5b5$export$bf5df8e043856ef5)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $ad56220fb83af5b5$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $ad56220fb83af5b5$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $ad56220fb83af5b5$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $ad56220fb83af5b5$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $ad56220fb83af5b5$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= $74a1eb7091789c46$var$AUTO_REFRESH_TICK_DURATION) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $04ef27c59a575fba$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $ad56220fb83af5b5$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $04ef27c59a575fba$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $04ef27c59a575fba$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $04ef27c59a575fba$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $04ef27c59a575fba$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $04ef27c59a575fba$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $04ef27c59a575fba$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $2fa4441f6e7937be$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $ad56220fb83af5b5$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < $74a1eb7091789c46$var$AUTO_REFRESH_TICK_DURATION;
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $04ef27c59a575fba$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $04ef27c59a575fba$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const timeNow = Math.round(Date.now() / 1000);
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + (0, $570b3134cfd76a77$export$7d4b3a66850dd9bd);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $570b3134cfd76a77$export$7d4b3a66850dd9bd)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $ad56220fb83af5b5$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $04ef27c59a575fba$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $ad56220fb83af5b5$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $ad56220fb83af5b5$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $04ef27c59a575fba$export$e82c36d29078a87f)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $04ef27c59a575fba$export$d35c645d585317ec)(this.storage, this.storageKey);
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $04ef27c59a575fba$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), $74a1eb7091789c46$var$AUTO_REFRESH_TICK_DURATION);
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / $74a1eb7091789c46$var$AUTO_REFRESH_TICK_DURATION);
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${$74a1eb7091789c46$var$AUTO_REFRESH_TICK_DURATION}ms, refresh threshold is ${$74a1eb7091789c46$var$AUTO_REFRESH_TICK_THRESHOLD} ticks`);
                            if (expiresInTicks <= $74a1eb7091789c46$var$AUTO_REFRESH_TICK_THRESHOLD) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $7cdfeee4a0ebc347$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $04ef27c59a575fba$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $04ef27c59a575fba$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $2fa4441f6e7937be$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $ad56220fb83af5b5$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const payload = this._decodeJWT(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
}
$74a1eb7091789c46$export$2e2bcd8739ae039.nextInstanceID = 0;



const $d9c2efcd76c52d44$var$AuthAdminApi = (0, $d608b043ec70702f$export$2e2bcd8739ae039);
var $d9c2efcd76c52d44$export$2e2bcd8739ae039 = $d9c2efcd76c52d44$var$AuthAdminApi;



const $4683133928348eb6$var$AuthClient = (0, $74a1eb7091789c46$export$2e2bcd8739ae039);
var $4683133928348eb6$export$2e2bcd8739ae039 = $4683133928348eb6$var$AuthClient;








class $447ef9abe1bba355$export$8199a418bb09bd56 extends (0, $4683133928348eb6$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $a07570e2cc5d742e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $a07570e2cc5d742e$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $c8d453927d08f542$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, 'ws');
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $061712032059ae6f$export$b31378ae815bea6b),
            realtime: (0, $061712032059ae6f$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $061712032059ae6f$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $061712032059ae6f$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $c8d453927d08f542$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $f9b4d500549c1fc0$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $82956af9da08303d$export$796f32e2ee984aaa)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $1166aba502372688$export$1d0b400bf8a0fa55)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $f4b7ac0bf5be9ca9$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $a07570e2cc5d742e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $447ef9abe1bba355$export$8199a418bb09bd56)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: 'Authorization' in this.headers
        });
    }
    _initRealtimeClient(options) {
        return new (0, $2041a11cd35514eb$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}






const $2dc7df494f0b9631$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $a07570e2cc5d742e$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};



parcelRequire("jMaZ8");
const $76220dd1f6646070$var$LogoFrogEditor = ()=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "117.954",
        height: "11.364",
        viewBox: "0 0 117.954 11.364",
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("defs", {}),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("g", {
                transform: "translate(0 0)",
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("g", {
                        className: "a",
                        transform: "translate(17.718 0.004)",
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("g", {
                                className: "a",
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-260.8,427.094V425.85l1.191-.228v-8.092l-1.191-.228v-1.251h8.69v2.942H-253.7l-.114-1.349h-3.731v3.208h3.905v1.592h-3.905v3.178l1.191.228v1.243Z",
                                        transform: "translate(260.799 -415.893)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-249.176,427.094V425.85l1.191-.228v-8.092l-1.191-.228v-1.251H-244a5.434,5.434,0,0,1,2.15.387,3,3,0,0,1,1.372,1.115,3.124,3.124,0,0,1,.475,1.745,3.137,3.137,0,0,1-.47,1.714,3.21,3.21,0,0,1-1.316,1.165,4.431,4.431,0,0,1-1.96.428l-2.169.008v3.01l1.191.228v1.243Zm3.253-6.074h1.851a2.3,2.3,0,0,0,1.517-.42,1.526,1.526,0,0,0,.493-1.225,1.671,1.671,0,0,0-.486-1.259,2.017,2.017,0,0,0-1.456-.47h-1.919Zm3.891,6.074-1.987-4.929,1.9-.387,1.7,3.86.9.2v1.259Z",
                                        transform: "translate(259.205 -415.893)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-231.373,427.228a4.762,4.762,0,0,1-2.01-.414,4.457,4.457,0,0,1-1.551-1.167,5.334,5.334,0,0,1-1-1.775,6.869,6.869,0,0,1-.349-2.241v-.167a6.859,6.859,0,0,1,.349-2.234,5.368,5.368,0,0,1,1-1.775,4.535,4.535,0,0,1,1.547-1.171,4.709,4.709,0,0,1,2.005-.417,4.818,4.818,0,0,1,2.036.417,4.552,4.552,0,0,1,1.558,1.171,5.264,5.264,0,0,1,1,1.775,6.93,6.93,0,0,1,.345,2.234v.167a6.939,6.939,0,0,1-.345,2.241,5.266,5.266,0,0,1-.993,1.775,4.439,4.439,0,0,1-1.558,1.167A4.853,4.853,0,0,1-231.373,427.228Zm0-1.623a2.543,2.543,0,0,0,1.608-.5,2.959,2.959,0,0,0,.952-1.393,6.286,6.286,0,0,0,.314-2.085v-.182a6.1,6.1,0,0,0-.318-2.062,2.991,2.991,0,0,0-.959-1.388,2.529,2.529,0,0,0-1.6-.5,2.459,2.459,0,0,0-1.57.5,2.978,2.978,0,0,0-.944,1.384,6.193,6.193,0,0,0-.315,2.07v.182a6.3,6.3,0,0,0,.315,2.082,2.967,2.967,0,0,0,.947,1.4A2.478,2.478,0,0,0-231.373,425.605Z",
                                        transform: "translate(257.436 -415.868)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-217.927,427.228a5.31,5.31,0,0,1-2.776-.69,4.583,4.583,0,0,1-1.767-1.911,6.237,6.237,0,0,1-.613-2.836v-.334a6.563,6.563,0,0,1,.613-2.916,4.766,4.766,0,0,1,1.726-1.965,4.757,4.757,0,0,1,2.613-.708,7.389,7.389,0,0,1,2.225.318,5.143,5.143,0,0,1,1.764.94v2.4H-215.7l-.28-1.509a2.34,2.34,0,0,0-.819-.4,4.266,4.266,0,0,0-1.176-.148,2.7,2.7,0,0,0-1.615.5,3.19,3.19,0,0,0-1.066,1.392,5.344,5.344,0,0,0-.375,2.079v.349a5.124,5.124,0,0,0,.368,2.029,2.966,2.966,0,0,0,1.069,1.335,2.991,2.991,0,0,0,1.718.474,5.021,5.021,0,0,0,1.118-.114,3.719,3.719,0,0,0,.83-.28v-2.025l-1.691-.113v-1.464h3.762v4.429a5.9,5.9,0,0,1-1.688.839A7.7,7.7,0,0,1-217.927,427.228Z",
                                        transform: "translate(255.626 -415.868)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("g", {
                                className: "a",
                                transform: "translate(43.588)",
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-210.282,427.094v-.66l1.236-.1v-9.517l-1.236-.1v-.668h7.933v2.419h-.774l-.076-1.669h-4.936v4.179h4.451v.758h-4.451v4.619h5.172l.076-1.684h.765v2.419Z",
                                        transform: "translate(210.282 -415.893)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-198.448,427.094v-.66l1.236-.1v-9.517l-1.236-.1v-.668h4.269a4.424,4.424,0,0,1,2.48.7,4.836,4.836,0,0,1,1.68,1.926,6.21,6.21,0,0,1,.61,2.8v.182a6.272,6.272,0,0,1-.6,2.794,4.772,4.772,0,0,1-1.664,1.931,4.368,4.368,0,0,1-2.469.7Zm2.146-.758h2.123a3.37,3.37,0,0,0,2.017-.619,4.148,4.148,0,0,0,1.354-1.675,5.6,5.6,0,0,0,.489-2.378v-.2a5.581,5.581,0,0,0-.489-2.385,4.076,4.076,0,0,0-1.354-1.658,3.421,3.421,0,0,0-2.017-.607H-196.3Z",
                                        transform: "translate(208.659 -415.893)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-185.868,427.094v-.66l1.236-.1v-9.517l-1.236-.1v-.668h3.382v.668l-1.236.1v9.517l1.236.1v.66Z",
                                        transform: "translate(206.933 -415.893)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-177.294,427.094v-.66l1.236-.1V416.8h-3.1l-.1,1.683H-180v-2.427h8.79v2.427h-.736l-.106-1.683h-3.094v9.539l1.236.1v.66Z",
                                        transform: "translate(206.129 -415.893)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-163.233,427.228a4.383,4.383,0,0,1-1.9-.4,4.155,4.155,0,0,1-1.456-1.145,5.3,5.3,0,0,1-.933-1.771,7.538,7.538,0,0,1-.326-2.286v-.144a7.618,7.618,0,0,1,.322-2.286,5.285,5.285,0,0,1,.929-1.774,4.138,4.138,0,0,1,1.456-1.15,4.387,4.387,0,0,1,1.9-.4,4.463,4.463,0,0,1,1.922.4,4.092,4.092,0,0,1,1.456,1.15,5.219,5.219,0,0,1,.918,1.774,7.792,7.792,0,0,1,.314,2.286v.144a7.8,7.8,0,0,1-.314,2.286,5.218,5.218,0,0,1-.914,1.771,4.082,4.082,0,0,1-1.452,1.145A4.467,4.467,0,0,1-163.233,427.228Zm0-.8a3.348,3.348,0,0,0,2.022-.6,3.683,3.683,0,0,0,1.248-1.684,6.9,6.9,0,0,0,.425-2.525v-.16a6.787,6.787,0,0,0-.429-2.518,3.716,3.716,0,0,0-1.255-1.679,3.324,3.324,0,0,0-2.017-.6,3.246,3.246,0,0,0-1.972.6,3.808,3.808,0,0,0-1.271,1.683,6.593,6.593,0,0,0-.443,2.513v.16a6.647,6.647,0,0,0,.443,2.525,3.779,3.779,0,0,0,1.274,1.684A3.292,3.292,0,0,0-163.233,426.432Z",
                                        transform: "translate(204.461 -415.868)"
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                                        className: "b",
                                        d: "M-155.025,427.1v-.668l1.236-.1v-9.517l-1.236-.1v-.66h4.656a5.113,5.113,0,0,1,2,.349,2.682,2.682,0,0,1,1.248,1.016,2.986,2.986,0,0,1,.429,1.645,2.784,2.784,0,0,1-.444,1.6,2.753,2.753,0,0,1-1.244.99,4.891,4.891,0,0,1-1.877.345l-2.624.022v4.307l1.236.1v.668Zm2.146-5.832h2.419a3.228,3.228,0,0,0,2.168-.607,2.028,2.028,0,0,0,.69-1.6,2.06,2.06,0,0,0-.69-1.658,3.14,3.14,0,0,0-2.078-.588h-2.51Zm5.278,5.832-2.374-5.483.91-.007,2.108,4.754.9.061v.675Z",
                                        transform: "translate(202.703 -415.894)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                        className: "b",
                        d: "M-276.249,417.946a2.543,2.543,0,0,1-.077-1.313,1.231,1.231,0,0,1,1.589-.684,1.32,1.32,0,0,1,.806,1.553c-.232.761-.563,1.5-.739,2.274a3.37,3.37,0,0,0,.086,1.4.944.944,0,0,0,1.072.8l.01,0a1.43,1.43,0,0,0,1.181-1.192,6.522,6.522,0,0,1,.242-1.324,1.189,1.189,0,0,1,1.368-.751,1.327,1.327,0,0,1,1.071,1.035,1.282,1.282,0,0,1-.6,1.313,1.536,1.536,0,0,1-.486.242c-.972.188-1.28.928-1.512,1.744a25.713,25.713,0,0,1-.863,2.761c-.574,1.4-1.391,1.666-2.748.993a12.131,12.131,0,0,1-1.336-.751,1.772,1.772,0,0,0-1.953-.143,1.475,1.475,0,0,1-1.467.122,1.338,1.338,0,0,1-.6-1.765,1.252,1.252,0,0,1,1.672-.582l.016.008c.353.173.64.486.993.673a1.076,1.076,0,0,0,.783.187.963.963,0,0,0,.386-.707,2.21,2.21,0,0,0-1.8-2.45c-.585-.188-1.136-.419-1.3-1.115a1.271,1.271,0,0,1,.875-1.569,1.271,1.271,0,0,1,1.455.6c.166.3.21.662.353.971a6.828,6.828,0,0,0,.717,1.381.938.938,0,0,0,.806.276c.2-.055.375-.419.442-.673a5.34,5.34,0,0,0,.078-1.035A11.527,11.527,0,0,0-276.249,417.946Z",
                        transform: "translate(281.333 -415.864)"
                    })
                ]
            })
        ]
    });
};
var $76220dd1f6646070$export$2e2bcd8739ae039 = $76220dd1f6646070$var$LogoFrogEditor;


var $f6e54159786f6146$export$34e0f9847d4c02dd;
var $f6e54159786f6146$export$fb184b623420d9be;
var $f6e54159786f6146$export$db3c28d99448dcff;
$f6e54159786f6146$export$34e0f9847d4c02dd = "container_30fb83";
$f6e54159786f6146$export$fb184b623420d9be = "title_30fb83";
$f6e54159786f6146$export$db3c28d99448dcff = "logo_30fb83";



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");






var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

"use client";
var $7f6742f7f43f0bdf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $7f6742f7f43f0bdf$var$Grid = (_a)=>{
    var { prefixCls: prefixCls, className: className, hoverable: hoverable = true } = _a, props = $7f6742f7f43f0bdf$var$__rest(_a, [
        "prefixCls",
        "className",
        "hoverable"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('card', prefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefix}-grid`, className, {
        [`${prefix}-grid-hoverable`]: hoverable
    });
    return /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, props, {
        className: classString
    }));
};
var $7f6742f7f43f0bdf$export$2e2bcd8739ae039 = $7f6742f7f43f0bdf$var$Grid;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// ============================== Styles ==============================
// ============================== Head ==============================
const $b806d8eab15663e4$var$genCardHeadStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, headerHeight: headerHeight, headerPadding: headerPadding, tabsMarginBottom: tabsMarginBottom } = token;
    return Object.assign(Object.assign({
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: headerHeight,
        marginBottom: -1,
        padding: `0 ${(0, $4g3I0.unit)(headerPadding)}`,
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: token.headerFontSize,
        background: token.headerBg,
        borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`,
        borderRadius: `${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)} 0 0`
    }, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
        '&-wrapper': {
            width: '100%',
            display: 'flex',
            alignItems: 'center'
        },
        '&-title': Object.assign(Object.assign({
            display: 'inline-block',
            flex: 1
        }, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
            [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
                insetInlineStart: 0,
                marginTop: 0,
                marginBottom: 0
            }
        }),
        [`${antCls}-tabs-top`]: {
            clear: 'both',
            marginBottom: tabsMarginBottom,
            color: token.colorText,
            fontWeight: 'normal',
            fontSize: token.fontSize,
            '&-bar': {
                borderBottom: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`
            }
        }
    });
};
// ============================== Grid ==============================
const $b806d8eab15663e4$var$genCardGridStyle = (token)=>{
    const { cardPaddingBase: cardPaddingBase, colorBorderSecondary: colorBorderSecondary, cardShadow: cardShadow, lineWidth: lineWidth } = token;
    return {
        width: '33.33%',
        padding: cardPaddingBase,
        border: 0,
        borderRadius: 0,
        boxShadow: `
      ${(0, $4g3I0.unit)(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${(0, $4g3I0.unit)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $4g3I0.unit)(lineWidth)} ${(0, $4g3I0.unit)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $4g3I0.unit)(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${(0, $4g3I0.unit)(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
        transition: `all ${token.motionDurationMid}`,
        '&-hoverable:hover': {
            position: 'relative',
            zIndex: 1,
            boxShadow: cardShadow
        }
    };
};
// ============================== Actions ==============================
const $b806d8eab15663e4$var$genCardActionsStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, actionsLiMargin: actionsLiMargin, cardActionsIconSize: cardActionsIconSize, colorBorderSecondary: colorBorderSecondary, actionsBg: actionsBg } = token;
    return Object.assign(Object.assign({
        margin: 0,
        padding: 0,
        listStyle: 'none',
        background: actionsBg,
        borderTop: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
        display: 'flex',
        borderRadius: `0 0 ${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)}`
    }, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
        '& > li': {
            margin: actionsLiMargin,
            color: token.colorTextDescription,
            textAlign: 'center',
            '> span': {
                position: 'relative',
                display: 'block',
                minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                cursor: 'pointer',
                '&:hover': {
                    color: token.colorPrimary,
                    transition: `color ${token.motionDurationMid}`
                },
                [`a:not(${componentCls}-btn), > ${iconCls}`]: {
                    display: 'inline-block',
                    width: '100%',
                    color: token.colorTextDescription,
                    lineHeight: (0, $4g3I0.unit)(token.fontHeight),
                    transition: `color ${token.motionDurationMid}`,
                    '&:hover': {
                        color: token.colorPrimary
                    }
                },
                [`> ${iconCls}`]: {
                    fontSize: cardActionsIconSize,
                    lineHeight: (0, $4g3I0.unit)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
                }
            },
            '&:not(:last-child)': {
                borderInlineEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`
            }
        }
    });
};
// ============================== Meta ==============================
const $b806d8eab15663e4$var$genCardMetaStyle = (token)=>Object.assign(Object.assign({
        margin: `${(0, $4g3I0.unit)(token.calc(token.marginXXS).mul(-1).equal())} 0`,
        display: 'flex'
    }, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
        '&-avatar': {
            paddingInlineEnd: token.padding
        },
        '&-detail': {
            overflow: 'hidden',
            flex: 1,
            '> div:not(:last-child)': {
                marginBottom: token.marginXS
            }
        },
        '&-title': Object.assign({
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            fontSize: token.fontSizeLG
        }, (0, $134f73cf3485ce91$export$b2b65df0d0824629)),
        '&-description': {
            color: token.colorTextDescription
        }
    });
// ============================== Inner ==============================
const $b806d8eab15663e4$var$genCardTypeInnerStyle = (token)=>{
    const { componentCls: componentCls, colorFillAlter: colorFillAlter, headerPadding: headerPadding, bodyPadding: bodyPadding } = token;
    return {
        [`${componentCls}-head`]: {
            padding: `0 ${(0, $4g3I0.unit)(headerPadding)}`,
            background: colorFillAlter,
            '&-title': {
                fontSize: token.fontSize
            }
        },
        [`${componentCls}-body`]: {
            padding: `${(0, $4g3I0.unit)(token.padding)} ${(0, $4g3I0.unit)(bodyPadding)}`
        }
    };
};
// ============================== Loading ==============================
const $b806d8eab15663e4$var$genCardLoadingStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        overflow: 'hidden',
        [`${componentCls}-body`]: {
            userSelect: 'none'
        }
    };
};
// ============================== Basic ==============================
const $b806d8eab15663e4$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, cardShadow: cardShadow, cardHeadPadding: cardHeadPadding, colorBorderSecondary: colorBorderSecondary, boxShadowTertiary: boxShadowTertiary, bodyPadding: bodyPadding, extraColor: extraColor } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'relative',
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            [`&:not(${componentCls}-bordered)`]: {
                boxShadow: boxShadowTertiary
            },
            [`${componentCls}-head`]: $b806d8eab15663e4$var$genCardHeadStyle(token),
            [`${componentCls}-extra`]: {
                // https://stackoverflow.com/a/22429853/3040605
                marginInlineStart: 'auto',
                color: extraColor,
                fontWeight: 'normal',
                fontSize: token.fontSize
            },
            [`${componentCls}-body`]: Object.assign({
                padding: bodyPadding,
                borderRadius: `0 0 ${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)}`
            }, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()),
            [`${componentCls}-grid`]: $b806d8eab15663e4$var$genCardGridStyle(token),
            [`${componentCls}-cover`]: {
                '> *': {
                    display: 'block',
                    width: '100%',
                    borderRadius: `${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)} 0 0`
                }
            },
            [`${componentCls}-actions`]: $b806d8eab15663e4$var$genCardActionsStyle(token),
            [`${componentCls}-meta`]: $b806d8eab15663e4$var$genCardMetaStyle(token)
        }),
        [`${componentCls}-bordered`]: {
            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
            [`${componentCls}-cover`]: {
                marginTop: -1,
                marginInlineStart: -1,
                marginInlineEnd: -1
            }
        },
        [`${componentCls}-hoverable`]: {
            cursor: 'pointer',
            transition: `box-shadow ${token.motionDurationMid}, border-color ${token.motionDurationMid}`,
            '&:hover': {
                borderColor: 'transparent',
                boxShadow: cardShadow
            }
        },
        [`${componentCls}-contain-grid`]: {
            borderRadius: `${(0, $4g3I0.unit)(token.borderRadiusLG)} ${(0, $4g3I0.unit)(token.borderRadiusLG)} 0 0 `,
            [`${componentCls}-body`]: {
                display: 'flex',
                flexWrap: 'wrap'
            },
            [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
                marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                padding: 0
            }
        },
        [`${componentCls}-contain-tabs`]: {
            [`> div${componentCls}-head`]: {
                minHeight: 0,
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: cardHeadPadding
                }
            }
        },
        [`${componentCls}-type-inner`]: $b806d8eab15663e4$var$genCardTypeInnerStyle(token),
        [`${componentCls}-loading`]: $b806d8eab15663e4$var$genCardLoadingStyle(token),
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
// ============================== Size ==============================
const $b806d8eab15663e4$var$genCardSizeStyle = (token)=>{
    const { componentCls: componentCls, bodyPaddingSM: bodyPaddingSM, headerPaddingSM: headerPaddingSM, headerHeightSM: headerHeightSM, headerFontSizeSM: headerFontSizeSM } = token;
    return {
        [`${componentCls}-small`]: {
            [`> ${componentCls}-head`]: {
                minHeight: headerHeightSM,
                padding: `0 ${(0, $4g3I0.unit)(headerPaddingSM)}`,
                fontSize: headerFontSizeSM,
                [`> ${componentCls}-head-wrapper`]: {
                    [`> ${componentCls}-extra`]: {
                        fontSize: token.fontSize
                    }
                }
            },
            [`> ${componentCls}-body`]: {
                padding: bodyPaddingSM
            }
        },
        [`${componentCls}-small${componentCls}-contain-tabs`]: {
            [`> ${componentCls}-head`]: {
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: 0,
                    display: 'flex',
                    alignItems: 'center'
                }
            }
        }
    };
};
const $b806d8eab15663e4$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b;
    return {
        headerBg: 'transparent',
        headerFontSize: token.fontSizeLG,
        headerFontSizeSM: token.fontSize,
        headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
        headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
        actionsBg: token.colorBgContainer,
        actionsLiMargin: `${token.paddingSM}px 0`,
        tabsMarginBottom: -token.padding - token.lineWidth,
        extraColor: token.colorText,
        bodyPaddingSM: 12,
        // Fixed padding.
        headerPaddingSM: 12,
        bodyPadding: (_a = token.bodyPadding) !== null && _a !== void 0 ? _a : token.paddingLG,
        headerPadding: (_b = token.headerPadding) !== null && _b !== void 0 ? _b : token.paddingLG
    };
};
var // ============================== Export ==============================
$b806d8eab15663e4$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Card', (token)=>{
    const cardToken = (0, $8APUt.merge)(token, {
        cardShadow: token.boxShadowCard,
        cardHeadPadding: token.padding,
        cardPaddingBase: token.paddingLG,
        cardActionsIconSize: token.fontSize
    });
    return [
        // Style
        $b806d8eab15663e4$var$genCardStyle(cardToken),
        // Size
        $b806d8eab15663e4$var$genCardSizeStyle(cardToken)
    ];
}, $b806d8eab15663e4$export$9ca1be8807fe0675);


"use client";
var $3f53b399c8d8f5c0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3f53b399c8d8f5c0$var$ActionNode = (props)=>{
    const { actionClasses: actionClasses, actions: actions = [], actionStyle: actionStyle } = props;
    return /*#__PURE__*/ $jMaZ8.createElement("ul", {
        className: actionClasses,
        style: actionStyle
    }, actions.map((action, index)=>{
        // Move this out since eslint not allow index key
        // And eslint-disable makes conflict with rollup
        // ref https://github.com/ant-design/ant-design/issues/46022
        const key = `action-${index}`;
        return /*#__PURE__*/ $jMaZ8.createElement("li", {
            style: {
                width: `${100 / actions.length}%`
            },
            key: key
        }, /*#__PURE__*/ $jMaZ8.createElement("span", null, action));
    }));
};
const $3f53b399c8d8f5c0$var$Card = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, extra: extra, headStyle: headStyle = {}, bodyStyle: bodyStyle = {}, title: title, loading: loading, bordered: bordered = true, size: customizeSize, type: type, cover: cover, actions: actions, tabList: tabList, children: children, activeTabKey: activeTabKey, defaultActiveTabKey: defaultActiveTabKey, tabBarExtraContent: tabBarExtraContent, hoverable: hoverable, tabProps: tabProps = {}, classNames: customClassNames, styles: customStyles } = props, others = $3f53b399c8d8f5c0$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "extra",
        "headStyle",
        "bodyStyle",
        "title",
        "loading",
        "bordered",
        "size",
        "type",
        "cover",
        "actions",
        "tabList",
        "children",
        "activeTabKey",
        "defaultActiveTabKey",
        "tabBarExtraContent",
        "hoverable",
        "tabProps",
        "classNames",
        "styles"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, card: card } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Card');
        [
            [
                'headStyle',
                'styles.header'
            ],
            [
                'bodyStyle',
                'styles.body'
            ]
        ].forEach((_ref)=>{
            let [deprecatedName, newName] = _ref;
            warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
        });
    }
    const onTabChange = (key)=>{
        var _a;
        (_a = props.onTabChange) === null || _a === void 0 || _a.call(props, key);
    };
    const moduleClass = (moduleName)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_a = card === null || card === void 0 ? void 0 : card.classNames) === null || _a === void 0 ? void 0 : _a[moduleName], customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames[moduleName]);
    };
    const moduleStyle = (moduleName)=>{
        var _a;
        return Object.assign(Object.assign({}, (_a = card === null || card === void 0 ? void 0 : card.styles) === null || _a === void 0 ? void 0 : _a[moduleName]), customStyles === null || customStyles === void 0 ? void 0 : customStyles[moduleName]);
    };
    const isContainGrid = $jMaZ8.useMemo(()=>{
        let containGrid = false;
        $jMaZ8.Children.forEach(children, (element)=>{
            if ((element === null || element === void 0 ? void 0 : element.type) === (0, $7f6742f7f43f0bdf$export$2e2bcd8739ae039)) containGrid = true;
        });
        return containGrid;
    }, [
        children
    ]);
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b806d8eab15663e4$export$2e2bcd8739ae039)(prefixCls);
    const loadingBlock = /*#__PURE__*/ $jMaZ8.createElement((0, $069691000a77b0e1$export$2e2bcd8739ae039), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = Object.assign(Object.assign({}, tabProps), {
        [hasActiveTabKey ? 'activeKey' : 'defaultActiveKey']: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
        tabBarExtraContent: tabBarExtraContent
    });
    let head;
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customizeSize);
    const tabSize = !mergedSize || mergedSize === 'default' ? 'large' : mergedSize;
    const tabs = tabList ? /*#__PURE__*/ $jMaZ8.createElement((0, $3d078c5b7a14a8e5$export$2e2bcd8739ae039), Object.assign({
        size: tabSize
    }, extraProps, {
        className: `${prefixCls}-head-tabs`,
        onChange: onTabChange,
        items: tabList.map((_a)=>{
            var { tab: tab } = _a, item = $3f53b399c8d8f5c0$var$__rest(_a, [
                "tab"
            ]);
            return Object.assign({
                label: tab
            }, item);
        })
    })) : null;
    if (title || extra || tabs) {
        const headClasses = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-head`, moduleClass('header'));
        const titleClasses = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-head-title`, moduleClass('title'));
        const extraClasses = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-extra`, moduleClass('extra'));
        const mergedHeadStyle = Object.assign(Object.assign({}, headStyle), moduleStyle('header'));
        head = /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: headClasses,
            style: mergedHeadStyle
        }, /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-head-wrapper`
        }, title && /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: titleClasses,
            style: moduleStyle('title')
        }, title), extra && /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: extraClasses,
            style: moduleStyle('extra')
        }, extra)), tabs);
    }
    const coverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-cover`, moduleClass('cover'));
    const coverDom = cover ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: coverClasses,
        style: moduleStyle('cover')
    }, cover) : null;
    const bodyClasses = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-body`, moduleClass('body'));
    const mergedBodyStyle = Object.assign(Object.assign({}, bodyStyle), moduleStyle('body'));
    const body = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: bodyClasses,
        style: mergedBodyStyle
    }, loading ? loadingBlock : children);
    const actionClasses = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-actions`, moduleClass('actions'));
    const actionDom = (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ $jMaZ8.createElement($3f53b399c8d8f5c0$var$ActionNode, {
        actionClasses: actionClasses,
        actionStyle: moduleStyle('actions'),
        actions: actions
    }) : null;
    const divProps = (0, $hvG6u.default)(others, [
        'onTabChange'
    ]);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, card === null || card === void 0 ? void 0 : card.className, {
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-bordered`]: bordered,
        [`${prefixCls}-hoverable`]: hoverable,
        [`${prefixCls}-contain-grid`]: isContainGrid,
        [`${prefixCls}-contain-tabs`]: tabList === null || tabList === void 0 ? void 0 : tabList.length,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-type-${type}`]: !!type,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, card === null || card === void 0 ? void 0 : card.style), style);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        ref: ref
    }, divProps, {
        className: classString,
        style: mergedStyle
    }), head, coverDom, body, actionDom));
});
var $3f53b399c8d8f5c0$export$2e2bcd8739ae039 = $3f53b399c8d8f5c0$var$Card;




var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

"use client";
var $6dba18af39a4c230$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $6dba18af39a4c230$var$Meta = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description } = props, others = $6dba18af39a4c230$var$__rest(props, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-meta`, className);
    const avatarDom = avatar ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-meta-avatar`
    }, avatar) : null;
    const titleDom = title ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-meta-title`
    }, title) : null;
    const descriptionDom = description ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-meta-description`
    }, description) : null;
    const MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-meta-detail`
    }, titleDom, descriptionDom) : null;
    return /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({}, others, {
        className: classString
    }), avatarDom, MetaDetail);
};
var $6dba18af39a4c230$export$2e2bcd8739ae039 = $6dba18af39a4c230$var$Meta;


"use client";
const $6dc2382ad3cf356d$var$Card = (0, $3f53b399c8d8f5c0$export$2e2bcd8739ae039);
$6dc2382ad3cf356d$var$Card.Grid = (0, $7f6742f7f43f0bdf$export$2e2bcd8739ae039);
$6dc2382ad3cf356d$var$Card.Meta = (0, $6dba18af39a4c230$export$2e2bcd8739ae039);
$6dc2382ad3cf356d$var$Card.displayName = 'Card';
var $6dc2382ad3cf356d$export$2e2bcd8739ae039 = $6dc2382ad3cf356d$var$Card;


var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $a6yuN = parcelRequire("a6yuN");
function $579424a6cd5b547d$export$f5153c3888a6824e(size) {
    return [
        'small',
        'middle',
        'large'
    ].includes(size);
}
function $579424a6cd5b547d$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === 'number' && !Number.isNaN(size);
}





var $jMaZ8 = parcelRequire("jMaZ8");
const $8ed54f2d975c1ac9$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext({
    latestIndex: 0
});
const $8ed54f2d975c1ac9$export$2bbf36e6e96e17f9 = $8ed54f2d975c1ac9$export$853f607fd5cc208b.Provider;



var $jMaZ8 = parcelRequire("jMaZ8");

"use client";
const $20f23d846dc1019d$var$Item = (_ref)=>{
    let { className: className, index: index, children: children, split: split, style: style } = _ref;
    const { latestIndex: latestIndex } = $jMaZ8.useContext((0, $8ed54f2d975c1ac9$export$853f607fd5cc208b));
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && split && /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${className}-split`
    }, split));
};
var $20f23d846dc1019d$export$2e2bcd8739ae039 = $20f23d846dc1019d$var$Item;



"use client";
var $ed1c54faf74fef6b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ed1c54faf74fef6b$var$InternalSpace = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    var _a, _b, _c;
    const { getPrefixCls: getPrefixCls, space: space, direction: directionConfig } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { size: size = (_a = space === null || space === void 0 ? void 0 : space.size) !== null && _a !== void 0 ? _a : 'small', align: align, className: className, rootClassName: rootClassName, children: children, direction: direction = 'horizontal', prefixCls: customizePrefixCls, split: split, style: style, wrap: wrap = false, classNames: customClassNames, styles: styles } = props, otherProps = $ed1c54faf74fef6b$var$__rest(props, [
        "size",
        "align",
        "className",
        "rootClassName",
        "children",
        "direction",
        "prefixCls",
        "split",
        "style",
        "wrap",
        "classNames",
        "styles"
    ]);
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $579424a6cd5b547d$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $579424a6cd5b547d$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $579424a6cd5b547d$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $579424a6cd5b547d$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $a6yuN.default)(children, {
        keepEmpty: true
    });
    const mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $9b653ab488fb14ee$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, space === null || space === void 0 ? void 0 : space.className, hashId, `${prefixCls}-${direction}`, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls);
    const itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-item`, (_b = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.item) !== null && _b !== void 0 ? _b : (_c = space === null || space === void 0 ? void 0 : space.classNames) === null || _c === void 0 ? void 0 : _c.item);
    // Calculate latest one
    let latestIndex = 0;
    const nodes = childNodes.map((child, i)=>{
        var _a, _b;
        if (child !== null && child !== undefined) latestIndex = i;
        const key = (child === null || child === void 0 ? void 0 : child.key) || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $20f23d846dc1019d$export$2e2bcd8739ae039), {
            className: itemClassName,
            key: key,
            index: i,
            split: split,
            style: (_a = styles === null || styles === void 0 ? void 0 : styles.item) !== null && _a !== void 0 ? _a : (_b = space === null || space === void 0 ? void 0 : space.styles) === null || _b === void 0 ? void 0 : _b.item
        }, child);
    });
    const spaceContext = $jMaZ8.useMemo(()=>({
            latestIndex: latestIndex
        }), [
        latestIndex
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = 'wrap';
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        ref: ref,
        className: cls,
        style: Object.assign(Object.assign(Object.assign({}, gapStyle), space === null || space === void 0 ? void 0 : space.style), style)
    }, otherProps), /*#__PURE__*/ $jMaZ8.createElement((0, $8ed54f2d975c1ac9$export$2bbf36e6e96e17f9), {
        value: spaceContext
    }, nodes)));
});
const $ed1c54faf74fef6b$var$Space = $ed1c54faf74fef6b$var$InternalSpace;
$ed1c54faf74fef6b$var$Space.Compact = (0, $b481086641a221d4$export$2e2bcd8739ae039);
$ed1c54faf74fef6b$var$Space.displayName = 'Space';
var $ed1c54faf74fef6b$export$2e2bcd8739ae039 = $ed1c54faf74fef6b$var$Space;


const $b5c1938aaa3155db$export$7dc0a3a835d48dae = (0, $2dc7df494f0b9631$export$5d730b7aed1a3eb0)("https://sooaxmawwjduqtsowbqd.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvb2F4bWF3d2pkdXF0c293YnFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyOTgzNzgsImV4cCI6MjA1Mjg3NDM3OH0.pnajPeXTD7Qi26z2UVlYKF79RpSDxop9vYdiySS8pYc");
const $b5c1938aaa3155db$var$SupabaseContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext(null);
async function $b5c1938aaa3155db$var$signInWithMagicLink(email) {
    const { error: error } = await $b5c1938aaa3155db$export$7dc0a3a835d48dae.auth.signInWithOtp({
        email: email,
        options: {
            emailRedirectTo: window.location.origin
        }
    });
    if (error) throw error;
}
function $b5c1938aaa3155db$export$b2b1b21ad709cbe1() {
    const session = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext($b5c1938aaa3155db$var$SupabaseContext);
    if (!session) throw new Error("useSupabase must be used within a SupabaseProvider");
    return session;
}
function $b5c1938aaa3155db$export$dc3279e47fe4b31c({ children: children }) {
    const [session, setSession] = (0, $jMaZ8.useState)(null);
    const [mailHasBeenSent, setMailHasBeenSent] = (0, $jMaZ8.useState)(false);
    (0, $jMaZ8.useEffect)(()=>{
        $b5c1938aaa3155db$export$7dc0a3a835d48dae.auth.getSession().then(({ data: { session: session } })=>{
            setSession(session);
        });
        const { data: { subscription: subscription } } = $b5c1938aaa3155db$export$7dc0a3a835d48dae.auth.onAuthStateChange((_event, session)=>{
            setSession(session);
        });
        return ()=>subscription.unsubscribe();
    }, []);
    if (!session && !mailHasBeenSent) // add a button to send magic link using antd
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $f6e54159786f6146$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6dc2382ad3cf356d$export$2e2bcd8739ae039), {
            id: "login",
            bordered: true,
            title: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $f6e54159786f6146$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $f6e54159786f6146$export$db3c28d99448dcff,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $76220dd1f6646070$export$2e2bcd8739ae039), {})
                    }),
                    "Please sign in with your email"
                ]
            }),
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $ed1c54faf74fef6b$export$2e2bcd8739ae039), {
                direction: "vertical",
                size: "large",
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        size: "small",
                        id: "email",
                        type: "email",
                        placeholder: "Email"
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end"
                        },
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            size: "large",
                            onClick: ()=>{
                                const input = document.querySelector("#email");
                                $b5c1938aaa3155db$var$signInWithMagicLink(input.value);
                                setMailHasBeenSent(true);
                            },
                            children: "Send Magic Link"
                        })
                    })
                ]
            })
        })
    });
    if (!session && mailHasBeenSent) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $f6e54159786f6146$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                children: "Please check your email and click the Magic link ! Email not received ? Check your spam box\u2026"
            })
        })
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($b5c1938aaa3155db$var$SupabaseContext.Provider, {
        value: session,
        children: children
    });
}


var $d7188398173686a1$export$6ef83aef5283924a = /*#__PURE__*/ function($d7188398173686a1$export$6ef83aef5283924a) {
    $d7188398173686a1$export$6ef83aef5283924a["JSON_IMPORT"] = "JSON_IMPORT";
    $d7188398173686a1$export$6ef83aef5283924a["RHESED_TEXT"] = "RHESED_TEXT";
    $d7188398173686a1$export$6ef83aef5283924a["TEXT"] = "TEXT";
    $d7188398173686a1$export$6ef83aef5283924a["HTML"] = "HTML";
    return $d7188398173686a1$export$6ef83aef5283924a;
}({});
const $d7188398173686a1$export$edff06eee77345ce = ()=>{
    const session = (0, $b5c1938aaa3155db$export$b2b1b21ad709cbe1)();
    return (projectContent, locale, colorationOnComplexWordsOnly)=>{
        const json = JSON.stringify({
            locale: locale
        });
        const jsonBlob = new Blob([
            json
        ], {
            type: "application/json"
        });
        const data = new FormData();
        data.append("jsonPayload", jsonBlob);
        data.append("file", projectContent);
        return fetch("https://test.import-export.mobidys.com" + `/import?type=JSON_IMPORT&colorationOnComplexWordsOnly=${colorationOnComplexWordsOnly}`, {
            method: "POST",
            body: data,
            headers: {
                Authorization: "bearer " + session.access_token,
                Accept: "application/json"
            }
        });
    };
};
const $d7188398173686a1$export$5dbac6ca1d81f28 = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const session = (0, $b5c1938aaa3155db$export$b2b1b21ad709cbe1)();
    return (name, author, EAN, projectContent, importType, locale, colorationOnComplexWordsOnly)=>{
        const json = JSON.stringify({
            name: name,
            author: author,
            EAN: EAN,
            locale: locale
        });
        const jsonBlob = new Blob([
            json
        ], {
            type: "application/json"
        });
        const data = new FormData();
        data.append("jsonPayload", jsonBlob);
        data.append("file", projectContent);
        return fetch("https://test.import-export.mobidys.com" + `/import?type=${importType}&colorationOnComplexWordsOnly=${colorationOnComplexWordsOnly}`, {
            method: "POST",
            body: data,
            headers: {
                Authorization: "bearer " + session.access_token,
                Accept: "application/json"
            }
        });
    };
};
const $d7188398173686a1$export$1fb87fa1fa7c9269 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation RemoveProjectFromCache($projectId: UUID!) {
      removeProjectFromCache(projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$36fbd2350d26e8f6 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation UpdateTextContent(
      $projectId: UUID!
      $stringVersion: Int!
      $operations: [UpdateTextContent!]!
    ) {
      updateTextContent(
        projectId: $projectId
        stringVersion: $stringVersion
        operations: $operations
      )
    }
  `);
const $d7188398173686a1$export$a4be23f8d25de8e7 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation EditProject(
      $id: UUID!
      $name: String!
      $author: String!
      $EAN: String!
      $locale: String
    ) {
      updateProject(projectId: $id, name: $name, author: $author, ean: $EAN, locale: $locale)
    }
  `);
const $d7188398173686a1$export$53a9d6d5a12acdec = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation UpdateCustomColorationConfig($id: UUID!, $customColorationConfig: JSONObject!) {
      updateProject(projectId: $id, customColorationConfig: $customColorationConfig)
    }
  `);
const $d7188398173686a1$export$2fc6744ec4c31d26 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation DeleteProject($id: UUID!) {
      deleteProject(projectId: $id)
    }
  `);
const $d7188398173686a1$export$6f854643897373ca = (variables)=>{
    return (0, $7fa797a3751877df$export$dd0a697e1782aedd)((0, $f013a28d70124837$export$72e4926bf8358653)`
      query SearchForRheses($projectId: UUID!, $query: String!, $mode: RheseSearchMode!) {
        searchForRheses(projectId: $projectId, query: $query, mode: $mode) {
          totalMatchNumber
          results {
            rhese {
              data {
                id
              }
              anchors {
                utf16Start
                utf16Size
                stringVersion
              }
            }
            pageNumber
            content
          }
        }
      }
    `, {
        variables: variables
    });
};
const $d7188398173686a1$export$6ed06f11bf137590 = (variables, options)=>(0, $56ed5432ec247a44$export$368b4214baeb914c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      subscription SubToProject($id: UUID!, $withInfo: Boolean!, $withAudioInfo: Boolean!) {
        project(projectId: $id) {
          id
          createdAt
          stringVersion
          author
          name
          EAN: ean
          userBasedAccess
          importStatus
          kind
          config {
            id
            narrationWordsCountLimit
            locale
          }
          status
          preparationProgress
          isNarrationComplete
          isDoingAudioResync
          rhesesAudioInfo @include(if: $withAudioInfo) {
            count
            withReview
            withAudio
            isReviewValid
            isReviewReNarrated
            pageContainingAudioNotSyncedWithText
            pageId
          }
          definitionsAudioInfo @include(if: $withAudioInfo) {
            count
            withAudio
            withReview
            isReviewValid
            isReviewReNarrated
            pageId
          }
          totalPageNumber
          speakers {
            id
            name
          }
          paragraphTags {
            id
            name
            createdAt
          }
          info @include(if: $withInfo) {
            pageNumber
            rhesesNumber
            wordsNumber
            charsNumber
            defsNumber
            imagesNumber
            usedParagraphsKinds
            usedCustomCssClasses
          }
          roles {
            id
            userRole
            userTask
            userId
            projectId
          }
          customColorationConfig
          isAudiosyncComplete
        }
      }
    `, {
        variables: variables,
        ...options
    });
const $d7188398173686a1$export$b977c921ca1d39c = (variables)=>{
    const { loading: loading, data: data, error: error } = (0, $56ed5432ec247a44$export$368b4214baeb914c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      subscription SubscribeToExtendedPage(
        $projectId: UUID!
        $pageId: UUID!
        $pageSizeFactor: Int
      ) {
        extendedPage(projectId: $projectId, pageId: $pageId, pageSizeFactor: $pageSizeFactor) {
          textContent
          nbOfRheses
          page {
            data {
              id
              pageNumber(projectId: $projectId) {
                pageNumber
                lastPageNumber
              }
            }
            anchors {
              utf16Start
              utf16Size
              stringVersion
            }
          }
          textItalicization {
            anchors {
              utf16Start
              utf16Size
            }
          }
          textCase {
            data {
              textCase
            }
            anchors {
              utf16Start
              utf16Size
            }
          }
          textMuted {
            anchors {
              utf16Start
              utf16Size
            }
          }
          textWeight {
            anchors {
              utf16Start
              utf16Size
            }
          }
          textCitation {
            anchors {
              utf16Start
              utf16Size
            }
          }
          textScriptNotation {
            data {
              textScriptNotation
            }
            anchors {
              utf16Start
              utf16Size
            }
          }
          phoneme {
            data {
              kind
            }
            anchors {
              utf16Start
              utf16Size
            }
          }
          syllable {
            data {
              id
            }
            anchors {
              utf16Start
              utf16Size
            }
          }
          paragraph {
            data {
              id
              kind
              tag {
                id
                name
              }
              speaker {
                id
                name
              }
              images {
                id
                kind
                position
                fileName
                description
                figcaption
              }
            }
            anchors {
              externalId
              insertOrder
              utf16Start
              utf16Size
            }
          }
          rhese {
            data {
              id
              lineBreakAfter
              ignoreTextForAudioSync
              audioInfo {
                id
                reviewId
                start
                end
                confidence
                speechConfidence
                humanStart
                humanEnd
                status
                comment
              }
              audioRecording {
                fileUuid
                syncStatus
              }
            }
            anchors {
              externalId
              insertOrder
              utf16Start
              utf16Size
            }
          }
          definition {
            data {
              id
              kind
              description
              imageName
              audioFile
              audioReviewStatus
              audioReviewComment
            }
            anchors {
              externalId
              utf16Start
              utf16Size
              insertOrder
            }
          }
          customColoration {
            data {
              id
              customColorationKey
            }
            anchors {
              utf16Start
              utf16Size
            }
          }
          customCss {
            data {
              id
              customCssClasses
            }
            anchors {
              utf16Start
              utf16Size
            }
          }
        }
      }
    `, {
        variables: variables,
        // Full snapshots are consumed directly; normalizing them adds no value here.
        fetchPolicy: "no-cache"
    });
    const sortedData = (0, $jMaZ8.useMemo)(()=>{
        const page = data?.extendedPage;
        if (!page) return undefined;
        const byStart = (a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start;
        return {
            extendedPage: {
                ...page,
                rhese: [
                    ...page.rhese
                ].sort(byStart),
                definition: [
                    ...page.definition
                ].sort(byStart),
                paragraph: [
                    ...page.paragraph
                ].sort(byStart)
            }
        };
    }, [
        data?.extendedPage
    ]);
    return {
        loading: loading,
        data: sortedData,
        error: error
    };
};
const $d7188398173686a1$export$48fa4428c82e8a98 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation DeleteParagraphTag($tagId: UUID!) {
        deleteParagraphTag(tagId: $tagId)
      }
    `);
const $d7188398173686a1$export$d9548d661fab1b01 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UpdateAudioRhese(
        $humanStart: Float
        $humanEnd: Float
        $audioRheseId: UUID!
        $projectId: UUID!
      ) {
        updateAudioRhese(
          humanStart: $humanStart
          humanEnd: $humanEnd
          audioRheseId: $audioRheseId
          projectId: $projectId
        )
      }
    `);
const $d7188398173686a1$export$b7e8da276dc353e7 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation GiveAccesToProject($projectId: UUID!, $userId: String!) {
        giveAccessToProject(projectId: $projectId, userId: $userId)
      }
    `);
const $d7188398173686a1$export$62bfc57284147717 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation RevokeAccessToProject($projectId: UUID!, $userId: String!) {
        revokeAccessToProject(projectId: $projectId, userId: $userId)
      }
    `);
const $d7188398173686a1$export$c62fb8c9967915fd = ({ variables: variables, skip: skip })=>{
    const { loading: loading, data: data, error: error } = (0, $56ed5432ec247a44$export$368b4214baeb914c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      subscription SubToPagesExtended($projectId: UUID!) {
        extendedPages(projectId: $projectId) {
          computedMetadata {
            id
            externalId
            insertOrder
            family
            utf16Start
            utf16Size
            stringVersion
          }
          extendedPages {
            id
            mutePagesAfter
            partname
            updatedAt
            pageNumber(projectId: $projectId) {
              pageNumber
              lastPageNumber
            }
          }
        }
      }
    `, {
        variables: variables,
        skip: skip,
        fetchPolicy: "no-cache"
    });
    const pageData = (0, $jMaZ8.useMemo)(()=>({
            pages: data?.extendedPages ? (0, $d6f8296a78132fd9$export$dfa8e674821d92e7)(data.extendedPages) : []
        }), [
        data?.extendedPages
    ]);
    return {
        loading: loading,
        data: pageData,
        error: error
    };
};
const $d7188398173686a1$export$a079f68e1f5fb526 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation SetProjectAsComplete($projectId: UUID!) {
      setProjectAsComplete(projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$6c32ad121c90a9db = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation SetProjectAsArchived($projectId: UUID!) {
      setProjectAsArchived(projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$5d6e3f8cef10142b = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation RestoreProject($projectId: UUID!) {
      restoreProject(projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$cf9e011719de80d1 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation UpdateProjectPreparationProgress(
      $projectId: UUID!
      $preparationProgress: PreparationProgressStatus!
    ) {
      updateProjectPreparationProgress(
        projectId: $projectId
        preparationProgress: $preparationProgress
      )
    }
  `);
const $d7188398173686a1$export$dbf72e488731955d = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation UpdateProjectNarrationCompleteness($projectId: UUID!, $isNarrationComplete: Boolean!) {
      updateProjectNarrationCompleteness(
        projectId: $projectId
        isNarrationComplete: $isNarrationComplete
      )
    }
  `);
const $d7188398173686a1$export$a62de4ae2d356ef = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation UpsertParagraphTag($tagName: String!, $tagId: UUID, $projectId: UUID!) {
      upsertParagraphTag(tagName: $tagName, tagId: $tagId, projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$5c3e97cd89776abf = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation AddImage(
      $kind: ImageKind!
      $position: ImagePosition!
      $fileName: String!
      $description: String!
      $figcaption: String
      $paragraphId: UUID!
      $projectId: UUID!
    ) {
      addImage(
        kind: $kind
        position: $position
        fileName: $fileName
        description: $description
        paragraphId: $paragraphId
        figcaption: $figcaption
        projectId: $projectId
      )
    }
  `);
const $d7188398173686a1$export$88a53f86701e9c60 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation LinkDialogueToSpeaker(
      $speakerId: UUID
      $speakerName: String
      $paragraphId: UUID!
      $projectId: UUID!
    ) {
      linkDialogueToSpeaker(
        speakerId: $speakerId
        speakerName: $speakerName
        paragraphId: $paragraphId
        projectId: $projectId
      )
    }
  `);
const $d7188398173686a1$export$e247a83015ffe6ce = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation UnlinkDialogueAndSpeaker($paragraphId: UUID!, $projectId: UUID!) {
      unlinkDialogueAndSpeaker(paragraphId: $paragraphId, projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$41519f342d0f82fe = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation UpdateImage(
      $imageId: UUID!
      $kind: ImageKind!
      $position: ImagePosition!
      $fileName: String!
      $description: String!
      $figcaption: String
      $projectId: UUID!
    ) {
      updateImage(
        imageId: $imageId
        kind: $kind
        position: $position
        fileName: $fileName
        description: $description
        figcaption: $figcaption
        projectId: $projectId
      )
    }
  `);
const $d7188398173686a1$export$5b3f3a485ee1a285 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation RemoveImage($imageId: UUID!, $projectId: UUID!) {
      removeImage(imageId: $imageId, projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$9b0a4863a3214cf6 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation AssignToNewParagraph(
      $rheses: [UUID!]!
      $paragraphKind: ExtendedParagraphKind!
      $projectId: UUID!
      $paragraphTagId: UUID
    ) {
      createParagraphForRheses(
        projectId: $projectId
        paragraphKind: $paragraphKind
        paragraphTagId: $paragraphTagId
        rheses: $rheses
      )
    }
  `);
const $d7188398173686a1$export$32c546a13f0abf25 = ()=>(0, $56ed5432ec247a44$export$368b4214baeb914c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      subscription SubscribeToExports {
        exports {
          id
          createdAt
          completedAt
          projectId
          author
          exportType
          exportStatus
          comment
          config
          filename
          projectAuthor
          projectName
        }
      }
    `);
const $d7188398173686a1$export$8b0fb4ff6360f2a7 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation ExportProject(
      $projectId: UUID!
      $exportType: ExportType!
      $exportConfig: ExportConfig!
    ) {
      exportProject(projectId: $projectId, exportType: $exportType, exportConfig: $exportConfig)
    }
  `);
const $d7188398173686a1$export$1136e9e8becca14 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation DeleteExport($exports: [ExportRequest!]!) {
      deleteExport(exports: $exports)
    }
  `);
const $d7188398173686a1$export$b77d745274cc19d1 = ()=>(0, $6aa6af800883504c$export$fd83eea6ecd2d8fa)((0, $f013a28d70124837$export$72e4926bf8358653)`
      query ExportDownloadUrl($projectId: UUID!, $exportId: UUID!) {
        exportDownloadUrl(projectId: $projectId, exportId: $exportId)
      }
    `);
const $d7188398173686a1$export$7a505514d2ae74cb = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation LaunchProjectReSync($projectId: UUID!) {
      launchProjectReSync(projectId: $projectId)
    }
  `);
const $d7188398173686a1$export$3fb9275d3845bd5a = ()=>(0, $7fa797a3751877df$export$dd0a697e1782aedd)((0, $f013a28d70124837$export$72e4926bf8358653)`
      query Meta {
        meta {
          serverVersion
        }
      }
    `);



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $368320d4d851eaf8$var$UploadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "upload",
    "theme": "outlined"
};
var $368320d4d851eaf8$export$2e2bcd8739ae039 = $368320d4d851eaf8$var$UploadOutlined;



var $531f7e3ffc07b3bc$var$UploadOutlined = function UploadOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $368320d4d851eaf8$export$2e2bcd8739ae039)
    }));
};
/**![upload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQwMCAzMTcuN2g3My45VjY1NmMwIDQuNCAzLjYgOCA4IDhoNjBjNC40IDAgOC0zLjYgOC04VjMxNy43SDYyNGM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1MTguMyAxNjNhOCA4IDAgMDAtMTIuNiAwbC0xMTIgMTQxLjdjLTQuMSA1LjMtLjQgMTMgNi4zIDEzek04NzggNjI2aC02MGMtNC40IDAtOCAzLjYtOCA4djE1NEgyMTRWNjM0YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYxOThjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjg0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjYzNGMwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */ var $531f7e3ffc07b3bc$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($531f7e3ffc07b3bc$var$UploadOutlined);
$531f7e3ffc07b3bc$var$RefIcon.displayName = 'UploadOutlined';
var $531f7e3ffc07b3bc$export$2e2bcd8739ae039 = $531f7e3ffc07b3bc$var$RefIcon;


var $01659c8baeedd984$export$448e4850cad7c7b0;
var $01659c8baeedd984$export$a943aa9a0fca3f0b;
var $01659c8baeedd984$export$d29552dc8e2357c8;
var $01659c8baeedd984$export$c0f7794fca6691d;
var $01659c8baeedd984$export$96e4b36520c26a2c;
$01659c8baeedd984$export$448e4850cad7c7b0 = "h1_063cb0";
$01659c8baeedd984$export$a943aa9a0fca3f0b = "h2_063cb0";
$01659c8baeedd984$export$d29552dc8e2357c8 = "importType_063cb0";
$01659c8baeedd984$export$c0f7794fca6691d = "disableColorationOnSimpleWords_063cb0";
$01659c8baeedd984$export$96e4b36520c26a2c = "modal_063cb0";



var $e5e32b9fd5d541ac$export$de435b1ae0c975f3 = /*#__PURE__*/ function($e5e32b9fd5d541ac$export$de435b1ae0c975f3) {
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["af-ZA"] = "af-ZA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["am-ET"] = "am-ET";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-AE"] = "ar-AE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-BH"] = "ar-BH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-DZ"] = "ar-DZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-EG"] = "ar-EG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-IQ"] = "ar-IQ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-JO"] = "ar-JO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-KW"] = "ar-KW";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-LB"] = "ar-LB";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-LY"] = "ar-LY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-MA"] = "ar-MA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["arn-CL"] = "arn-CL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-OM"] = "ar-OM";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-QA"] = "ar-QA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-SA"] = "ar-SA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-SD"] = "ar-SD";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-SY"] = "ar-SY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-TN"] = "ar-TN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ar-YE"] = "ar-YE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["as-IN"] = "as-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["az-az"] = "az-az";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["az-Cyrl-AZ"] = "az-Cyrl-AZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["az-Latn-AZ"] = "az-Latn-AZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ba-RU"] = "ba-RU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["be-BY"] = "be-BY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["bg-BG"] = "bg-BG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["bn-BD"] = "bn-BD";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["bn-IN"] = "bn-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["bo-CN"] = "bo-CN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["br-FR"] = "br-FR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["bs-Cyrl-BA"] = "bs-Cyrl-BA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["bs-Latn-BA"] = "bs-Latn-BA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ca-ES"] = "ca-ES";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["co-FR"] = "co-FR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["cs-CZ"] = "cs-CZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["cy-GB"] = "cy-GB";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["da-DK"] = "da-DK";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["de-AT"] = "de-AT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["de-CH"] = "de-CH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["de-DE"] = "de-DE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["de-LI"] = "de-LI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["de-LU"] = "de-LU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["dsb-DE"] = "dsb-DE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["dv-MV"] = "dv-MV";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["el-CY"] = "el-CY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["el-GR"] = "el-GR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-029"] = "en-029";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-AU"] = "en-AU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-BZ"] = "en-BZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-CA"] = "en-CA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-cb"] = "en-cb";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-GB"] = "en-GB";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-IE"] = "en-IE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-IN"] = "en-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-JM"] = "en-JM";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-MT"] = "en-MT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-MY"] = "en-MY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-NZ"] = "en-NZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-PH"] = "en-PH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-SG"] = "en-SG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-TT"] = "en-TT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-US"] = "en-US";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-ZA"] = "en-ZA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["en-ZW"] = "en-ZW";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-AR"] = "es-AR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-BO"] = "es-BO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-CL"] = "es-CL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-CO"] = "es-CO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-CR"] = "es-CR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-DO"] = "es-DO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-EC"] = "es-EC";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-ES"] = "es-ES";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-GT"] = "es-GT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-HN"] = "es-HN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-MX"] = "es-MX";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-NI"] = "es-NI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-PA"] = "es-PA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-PE"] = "es-PE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-PR"] = "es-PR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-PY"] = "es-PY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-SV"] = "es-SV";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-US"] = "es-US";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-UY"] = "es-UY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["es-VE"] = "es-VE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["et-EE"] = "et-EE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["eu-ES"] = "eu-ES";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fa-IR"] = "fa-IR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fi-FI"] = "fi-FI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fil-PH"] = "fil-PH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fo-FO"] = "fo-FO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fr-BE"] = "fr-BE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fr-CA"] = "fr-CA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fr-CH"] = "fr-CH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fr-FR"] = "fr-FR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fr-LU"] = "fr-LU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fr-MC"] = "fr-MC";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["fy-NL"] = "fy-NL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ga-IE"] = "ga-IE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["gd-GB"] = "gd-GB";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["gd-ie"] = "gd-ie";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["gl-ES"] = "gl-ES";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["gsw-FR"] = "gsw-FR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["gu-IN"] = "gu-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ha-Latn-NG"] = "ha-Latn-NG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["he-IL"] = "he-IL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["hi-IN"] = "hi-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["hr-BA"] = "hr-BA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["hr-HR"] = "hr-HR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["hsb-DE"] = "hsb-DE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["hu-HU"] = "hu-HU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["hy-AM"] = "hy-AM";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["id-ID"] = "id-ID";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ig-NG"] = "ig-NG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ii-CN"] = "ii-CN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["in-ID"] = "in-ID";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["is-IS"] = "is-IS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["it-CH"] = "it-CH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["it-IT"] = "it-IT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["iu-Cans-CA"] = "iu-Cans-CA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["iu-Latn-CA"] = "iu-Latn-CA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["iw-IL"] = "iw-IL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ja-JP"] = "ja-JP";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ka-GE"] = "ka-GE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["kk-KZ"] = "kk-KZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["kl-GL"] = "kl-GL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["km-KH"] = "km-KH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["kn-IN"] = "kn-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["kok-IN"] = "kok-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ko-KR"] = "ko-KR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ky-KG"] = "ky-KG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["lb-LU"] = "lb-LU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["lo-LA"] = "lo-LA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["lt-LT"] = "lt-LT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["lv-LV"] = "lv-LV";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["mi-NZ"] = "mi-NZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["mk-MK"] = "mk-MK";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ml-IN"] = "ml-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["mn-MN"] = "mn-MN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["mn-Mong-CN"] = "mn-Mong-CN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["moh-CA"] = "moh-CA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["mr-IN"] = "mr-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ms-BN"] = "ms-BN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ms-MY"] = "ms-MY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["mt-MT"] = "mt-MT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["nb-NO"] = "nb-NO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ne-NP"] = "ne-NP";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["nl-BE"] = "nl-BE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["nl-NL"] = "nl-NL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["nn-NO"] = "nn-NO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["no-no"] = "no-no";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["nso-ZA"] = "nso-ZA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["oc-FR"] = "oc-FR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["or-IN"] = "or-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["pa-IN"] = "pa-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["pl-PL"] = "pl-PL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["prs-AF"] = "prs-AF";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ps-AF"] = "ps-AF";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["pt-BR"] = "pt-BR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["pt-PT"] = "pt-PT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["qut-GT"] = "qut-GT";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["quz-BO"] = "quz-BO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["quz-EC"] = "quz-EC";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["quz-PE"] = "quz-PE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["rm-CH"] = "rm-CH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ro-mo"] = "ro-mo";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ro-RO"] = "ro-RO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ru-mo"] = "ru-mo";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ru-RU"] = "ru-RU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["rw-RW"] = "rw-RW";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sah-RU"] = "sah-RU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sa-IN"] = "sa-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["se-FI"] = "se-FI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["se-NO"] = "se-NO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["se-SE"] = "se-SE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["si-LK"] = "si-LK";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sk-SK"] = "sk-SK";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sl-SI"] = "sl-SI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sma-NO"] = "sma-NO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sma-SE"] = "sma-SE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["smj-NO"] = "smj-NO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["smj-SE"] = "smj-SE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["smn-FI"] = "smn-FI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sms-FI"] = "sms-FI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sq-AL"] = "sq-AL";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-BA"] = "sr-BA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-CS"] = "sr-CS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Cyrl-BA"] = "sr-Cyrl-BA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Cyrl-CS"] = "sr-Cyrl-CS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Cyrl-ME"] = "sr-Cyrl-ME";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Cyrl-RS"] = "sr-Cyrl-RS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Latn-BA"] = "sr-Latn-BA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Latn-CS"] = "sr-Latn-CS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Latn-ME"] = "sr-Latn-ME";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-Latn-RS"] = "sr-Latn-RS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-ME"] = "sr-ME";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-RS"] = "sr-RS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sr-sp"] = "sr-sp";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sv-FI"] = "sv-FI";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sv-SE"] = "sv-SE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["sw-KE"] = "sw-KE";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["syr-SY"] = "syr-SY";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ta-IN"] = "ta-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["te-IN"] = "te-IN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["tg-Cyrl-TJ"] = "tg-Cyrl-TJ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["th-TH"] = "th-TH";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["tk-TM"] = "tk-TM";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["tlh-QS"] = "tlh-QS";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["tn-ZA"] = "tn-ZA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["tr-TR"] = "tr-TR";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["tt-RU"] = "tt-RU";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["tzm-Latn-DZ"] = "tzm-Latn-DZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ug-CN"] = "ug-CN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["uk-UA"] = "uk-UA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["ur-PK"] = "ur-PK";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["uz-Cyrl-UZ"] = "uz-Cyrl-UZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["uz-Latn-UZ"] = "uz-Latn-UZ";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["uz-uz"] = "uz-uz";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["vi-VN"] = "vi-VN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["wo-SN"] = "wo-SN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["xh-ZA"] = "xh-ZA";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["yo-NG"] = "yo-NG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["zh-CN"] = "zh-CN";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["zh-HK"] = "zh-HK";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["zh-MO"] = "zh-MO";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["zh-SG"] = "zh-SG";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["zh-TW"] = "zh-TW";
    $e5e32b9fd5d541ac$export$de435b1ae0c975f3["zu-ZA"] = "zu-ZA";
    return $e5e32b9fd5d541ac$export$de435b1ae0c975f3;
}({});



parcelRequire("jMaZ8");

const $421913d54e9e15b2$export$7f7cbe89f1eacd2 = ({ className: className, style: style, grow: grow, notFlex: notFlex, small: small })=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: className,
        style: {
            display: notFlex ? "" : "flex",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: grow ? 1 : "unset",
            ...style
        },
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), {
            size: small ? "small" : undefined
        })
    });


const { Option: $f1a5fd6446a4180c$var$Option } = (0, $71df08955277779f$export$2e2bcd8739ae039);
const $f1a5fd6446a4180c$var$RadioButton = (0, $41c1392b19ea6316$export$2e2bcd8739ae039).Button;
function $f1a5fd6446a4180c$var$StepOne({ onFinish: onFinish, setFile: setFile, isWaitingUpload: isWaitingUpload, importType: importType, setImportType: setImportType, locale: locale, setLocale: setLocale, setColorationOnComplexWordsOnly: setColorationOnComplexWordsOnly }) {
    const getFileExtension = (importType)=>{
        if (importType === (0, $d7188398173686a1$export$6ef83aef5283924a).JSON_IMPORT) return ".json";
        if (importType === (0, $d7188398173686a1$export$6ef83aef5283924a).HTML) return ".zip";
        return ".txt";
    };
    const translation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.new.stepOne");
    const languageNames = (0, $jMaZ8.useMemo)(()=>new Intl.DisplayNames([
            locale.replace(/_/g, "-")
        ], {
            type: "language"
        }), [
        locale
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
        name: "basic",
        initialValues: {
            remember: true
        },
        onFinish: onFinish,
        layout: "vertical",
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    padding: "0 7em"
                },
                label: translation.importType,
                className: $01659c8baeedd984$export$d29552dc8e2357c8,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $41c1392b19ea6316$export$2e2bcd8739ae039).Group, {
                    value: importType,
                    onChange: (e)=>{
                        setImportType(e.target?.value);
                    },
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$RadioButton, {
                            value: (0, $d7188398173686a1$export$6ef83aef5283924a).RHESED_TEXT,
                            children: translation.rhesedText
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$RadioButton, {
                            value: (0, $d7188398173686a1$export$6ef83aef5283924a).TEXT,
                            children: translation.text
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$RadioButton, {
                            value: (0, $d7188398173686a1$export$6ef83aef5283924a).HTML,
                            children: translation.htmlBook
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$RadioButton, {
                            value: (0, $d7188398173686a1$export$6ef83aef5283924a).JSON_IMPORT,
                            children: translation.jsonImport
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    padding: "0 7em"
                },
                label: translation.disableColorationOnSimpleWords,
                className: $01659c8baeedd984$export$c0f7794fca6691d,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b968d364906a5d60$export$2e2bcd8739ae039), {
                    defaultChecked: false,
                    onChange: (args)=>setColorationOnComplexWordsOnly(args.valueOf()),
                    size: "small" // TODO antd: only "small" allow the switch to display
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    padding: "0 7em"
                },
                label: translation.locale,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $71df08955277779f$export$2e2bcd8739ae039), {
                    showSearch: true,
                    value: locale.replace(/_/g, "-"),
                    style: {
                        width: "100%"
                    },
                    onChange: (value)=>setLocale(value.replace(/-/g, "_")),
                    children: Object.keys((0, $e5e32b9fd5d541ac$export$de435b1ae0c975f3)).map((tag)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$Option, {
                            value: tag,
                            children: languageNames.of(tag.replace(/_/g, "-"))
                        }, tag))
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    padding: "0 7em"
                },
                label: translation.title,
                name: "text",
                valuePropName: "text",
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d4ae1c238156c9e2$export$2e2bcd8739ae039), {
                    accept: getFileExtension(importType),
                    customRequest: ({ file: file, onSuccess: onSuccess })=>{
                        // @ts-ignore
                        setFile(file);
                        // @ts-ignore
                        onSuccess({}, file);
                    },
                    onChange: (info)=>{
                        if (info.file.status === "done") (0, $cff19b71ca14530c$export$2e2bcd8739ae039).success(`${info.file.name} ${translation.successMessage}`);
                        else if (info.file.status === "error") (0, $cff19b71ca14530c$export$2e2bcd8739ae039).error(`${info.file.name} ${translation.errorMessage}`);
                    },
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        style: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $531f7e3ffc07b3bc$export$2e2bcd8739ae039), {}),
                            translation.uploadOutlined
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    margin: 0
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                    justify: "center",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: isWaitingUpload,
                        htmlType: "submit",
                        shape: "round",
                        children: translation.import
                    })
                })
            })
        ]
    });
}
function $f1a5fd6446a4180c$var$StepTwo({ onFinish: onFinish }) {
    const [title, setTitle] = (0, $jMaZ8.useState)("");
    const [author, setAuthor] = (0, $jMaZ8.useState)("");
    const [EAN, setEAN] = (0, $jMaZ8.useState)("");
    const createBook = (0, $jMaZ8.useCallback)(()=>onFinish(title, author, EAN), [
        title,
        author,
        EAN,
        onFinish
    ]);
    const translation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.new.stepTwo");
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
        name: "basic",
        initialValues: {
            remember: true
        },
        onFinish: createBook,
        layout: "vertical",
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    padding: "0 7em"
                },
                label: translation.title,
                name: "title",
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                    placeholder: translation.titlePlaceholder,
                    onChange: (e)=>setTitle(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    padding: "0 7em"
                },
                label: translation.author,
                name: "author",
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                    placeholder: translation.authorPlaceholder,
                    onChange: (e)=>setAuthor(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    padding: "0 7em"
                },
                label: translation.ean,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                    value: EAN,
                    placeholder: translation.eanPlaceholder,
                    onChange: (e)=>setEAN(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                style: {
                    margin: 0
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                    justify: "center",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: title.length === 0 || author.length === 0,
                        htmlType: "submit",
                        shape: "round",
                        children: translation.create
                    })
                })
            })
        ]
    });
}
function $f1a5fd6446a4180c$var$StepThree({ progress: progress }) {
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
        name: "basic",
        layout: "vertical",
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                justify: "center",
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $eef464bb94d68b8c$export$2e2bcd8739ae039), {
                    type: "circle",
                    percent: Math.round(progress * 100)
                })
            })
        })
    });
}
var // eslint-disable-next-line react/display-name
$f1a5fd6446a4180c$export$2e2bcd8739ae039 = ({ container: container, setIsOpen: setIsOpen, onSuccess: onSuccess, onError: onError })=>{
    const [file, setFile] = (0, $jMaZ8.useState)();
    const [isImporting, setIsImporting] = (0, $jMaZ8.useState)(false);
    const [colorationOnComplexWordsOnly, setColorationOnComplexWordsOnly] = (0, $jMaZ8.useState)(false);
    const [step, setStep] = (0, $jMaZ8.useState)(1);
    const [importProgress] = (0, $jMaZ8.useState)(0);
    const [importType, setImportType] = (0, $jMaZ8.useState)((0, $d7188398173686a1$export$6ef83aef5283924a).RHESED_TEXT);
    const [locale, setLocale] = (0, $jMaZ8.useState)("fr_FR");
    const createJsonProject = (0, $d7188398173686a1$export$edff06eee77345ce)();
    const { ok: ok, cancel: cancel } = (0, $jMaZ8.useMemo)(()=>({
            ok: ()=>setIsOpen(false),
            cancel: ()=>setIsOpen(false)
        }), [
        setIsOpen
    ]);
    const handleFirstStepEnd = (0, $jMaZ8.useCallback)(()=>{
        if (!file) return;
        if (importType === (0, $d7188398173686a1$export$6ef83aef5283924a).JSON_IMPORT) try {
            createJsonProject(file, locale, colorationOnComplexWordsOnly);
            onSuccess();
        } catch (e) {
            onError(e);
        }
        else setStep(2);
    }, [
        file,
        locale,
        colorationOnComplexWordsOnly,
        createJsonProject,
        setStep,
        onSuccess,
        onError,
        importType
    ]);
    const createProject = (0, $d7188398173686a1$export$5dbac6ca1d81f28)();
    const create = (0, $jMaZ8.useCallback)(async (title, author, EAN)=>{
        if (!file) throw new Error("File should be set before creating project");
        try {
            const query = createProject(title, author, EAN, file, importType, locale, colorationOnComplexWordsOnly);
            setIsImporting(true);
            const res = await query;
            if (res.ok) onSuccess();
            else throw new Error(await res.text());
        } catch (e) {
            onError(e);
        } finally{
            setIsImporting(false);
        }
    }, [
        file,
        locale,
        colorationOnComplexWordsOnly,
        onSuccess,
        onError,
        importType,
        createProject,
        setIsImporting
    ]);
    let stepComp;
    const translation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.new.modalTitle");
    if (step === 1) stepComp = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$StepOne, {
        setColorationOnComplexWordsOnly: setColorationOnComplexWordsOnly,
        importType: importType,
        locale: locale,
        setImportType: setImportType,
        setLocale: setLocale,
        onFinish: handleFirstStepEnd,
        isWaitingUpload: !file,
        setFile: setFile
    });
    else if (step === 2) stepComp = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$StepTwo, {
        onFinish: create
    });
    else stepComp = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($f1a5fd6446a4180c$var$StepThree, {
        progress: importProgress
    });
    if (isImporting) stepComp = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {});
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        centered: true,
        width: "56.66em",
        title: translation,
        className: $01659c8baeedd984$export$96e4b36520c26a2c,
        open: true,
        onOk: ok,
        onCancel: cancel,
        footer: null,
        getContainer: ()=>container || document.body,
        children: stepComp
    });
};





var $jMaZ8 = parcelRequire("jMaZ8");



function $ef17d3091b920205$export$2e2bcd8739ae039({ cancel: cancel, validate: validate, projectId: projectId, reference: reference }) {
    const [name, setName] = (0, $jMaZ8.useState)("");
    const [author, setAuthor] = (0, $jMaZ8.useState)("");
    const [EAN, setEAN] = (0, $jMaZ8.useState)("");
    const [locale, setLocale] = (0, $jMaZ8.useState)("fr_FR");
    const [editProject] = (0, $d7188398173686a1$export$a4be23f8d25de8e7)();
    const onApply = (0, $jMaZ8.useCallback)(async ()=>{
        await editProject({
            variables: {
                id: projectId,
                name: name,
                author: author,
                EAN: EAN,
                locale: locale
            }
        });
        validate(name, author);
    }, [
        editProject,
        projectId,
        name,
        author,
        EAN,
        locale,
        validate
    ]);
    const { data: data, loading: loading } = (0, $d7188398173686a1$export$6ed06f11bf137590)({
        id: projectId,
        withInfo: false,
        withAudioInfo: false
    });
    const project = (0, $jMaZ8.useMemo)(()=>{
        return data?.project[0];
    }, [
        data
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (project) {
            setName(project.name);
            setEAN(project.EAN || "");
            setAuthor(project.author);
            setLocale(project.config.locale);
        }
    }, [
        project
    ]);
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    const languageNames = (0, $jMaZ8.useMemo)(()=>new Intl.DisplayNames([
            locale.replace(/_/g, "-")
        ], {
            type: "language"
        }), [
        locale
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        centered: true,
        width: "56.66em",
        title: t("project.edit.modalTitle"),
        open: !loading && projectId !== "",
        onCancel: cancel,
        footer: null,
        getContainer: reference?.current,
        children: !loading && projectId !== "" && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
            name: "basic",
            initialValues: {
                remember: true
            },
            onFinish: onApply,
            layout: "vertical",
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t("project.edit.form.bookName"),
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        value: name,
                        onChange: (e)=>setName(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t("project.edit.form.bookAuthor"),
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        value: author,
                        onChange: (e)=>setAuthor(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: "EAN",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        value: EAN,
                        onChange: (e)=>setEAN(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t("project.edit.form.locale"),
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $71df08955277779f$export$2e2bcd8739ae039), {
                        showSearch: true,
                        value: locale.replace(/_/g, "-"),
                        style: {
                            width: "100%"
                        },
                        onChange: setLocale,
                        children: Object.keys((0, $e5e32b9fd5d541ac$export$de435b1ae0c975f3)).map((tag)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $71df08955277779f$export$2e2bcd8739ae039).Option, {
                                value: tag,
                                children: languageNames.of(tag.replace(/_/g, "-"))
                            }, tag))
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        margin: 0
                    },
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            disabled: name.length === 0,
                            htmlType: "submit",
                            shape: "round",
                            children: t("project.edit.form.modifies")
                        })
                    })
                })
            ]
        })
    }, project?.id);
}


var $8937beb26988c737$export$448e4850cad7c7b0;
var $8937beb26988c737$export$a943aa9a0fca3f0b;
var $8937beb26988c737$export$e8e78c978b129247;
var $8937beb26988c737$export$39f5674517ec0000;
var $8937beb26988c737$export$fb184b623420d9be;
var $8937beb26988c737$export$b1e5508a851be14d;
var $8937beb26988c737$export$a7db06668cad9adb;
var $8937beb26988c737$export$b1ba3b667808f37f;
var $8937beb26988c737$export$7ffb29c470bbe0c1;
var $8937beb26988c737$export$87ae8b1388ae34a6;
var $8937beb26988c737$export$5dbac6ca1d81f28;
var $8937beb26988c737$export$39babdfab504f3da;
var $8937beb26988c737$export$4aebd143f31d0c0d;
var $8937beb26988c737$export$e795f858b6a66dc0;
var $8937beb26988c737$export$f00a3f59328e8409;
var $8937beb26988c737$export$a3b9b213fa74e4fd;
var $8937beb26988c737$export$7652f722913b5d7;
var $8937beb26988c737$export$d290fa47940df19d;
var $8937beb26988c737$export$c31d35d5ced5a9d8;
var $8937beb26988c737$export$f2ea4ab276c3e3fa;
var $8937beb26988c737$export$3ce6949f20cea765;
var $8937beb26988c737$export$8360e631d277ea4d;
var $8937beb26988c737$export$b7e3ae3d7c15e42e;
var $8937beb26988c737$export$b31780c78f6e4eb9;
var $8937beb26988c737$export$3015c6563dc2df33;
var $8937beb26988c737$export$d7d0a8179707aa27;
var $8937beb26988c737$export$f8a3198725db5a98;
$8937beb26988c737$export$448e4850cad7c7b0 = "h1_cbc6d7";
$8937beb26988c737$export$a943aa9a0fca3f0b = "h2_cbc6d7";
$8937beb26988c737$export$e8e78c978b129247 = "root_cbc6d7";
$8937beb26988c737$export$39f5674517ec0000 = "tabs_cbc6d7";
$8937beb26988c737$export$fb184b623420d9be = "title_cbc6d7";
$8937beb26988c737$export$b1e5508a851be14d = "menu_cbc6d7";
$8937beb26988c737$export$a7db06668cad9adb = "content_cbc6d7";
$8937beb26988c737$export$b1ba3b667808f37f = "libraryTitle_cbc6d7";
$8937beb26988c737$export$7ffb29c470bbe0c1 = "projectCard_cbc6d7";
$8937beb26988c737$export$87ae8b1388ae34a6 = "isInReSync_cbc6d7";
$8937beb26988c737$export$5dbac6ca1d81f28 = "newProject_cbc6d7";
$8937beb26988c737$export$39babdfab504f3da = "projects_cbc6d7";
$8937beb26988c737$export$4aebd143f31d0c0d = "badge_cbc6d7";
$8937beb26988c737$export$e795f858b6a66dc0 = "countryCode_cbc6d7";
$8937beb26988c737$export$f00a3f59328e8409 = "projectHover_cbc6d7";
$8937beb26988c737$export$a3b9b213fa74e4fd = "buttonWrapper_cbc6d7";
$8937beb26988c737$export$7652f722913b5d7 = "users_cbc6d7";
$8937beb26988c737$export$d290fa47940df19d = "email_cbc6d7";
$8937beb26988c737$export$c31d35d5ced5a9d8 = "breakText_cbc6d7";
$8937beb26988c737$export$f2ea4ab276c3e3fa = "searchBar_cbc6d7";
$8937beb26988c737$export$3ce6949f20cea765 = "open_cbc6d7";
$8937beb26988c737$export$8360e631d277ea4d = "close_cbc6d7";
$8937beb26988c737$export$b7e3ae3d7c15e42e = "input_cbc6d7";
$8937beb26988c737$export$b31780c78f6e4eb9 = "exportCountInPopover_cbc6d7";
$8937beb26988c737$export$3015c6563dc2df33 = "exportItemInPopover_cbc6d7";
$8937beb26988c737$export$d7d0a8179707aa27 = "exportItemLabel_cbc6d7";
$8937beb26988c737$export$f8a3198725db5a98 = "dropdownItemReSync_cbc6d7";



var $jMaZ8 = parcelRequire("jMaZ8");
class $e5306f6c4be7a501$export$b9721ef022f71a68 extends Error {
}
$e5306f6c4be7a501$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $e5306f6c4be7a501$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $e5306f6c4be7a501$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $e5306f6c4be7a501$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $e5306f6c4be7a501$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $e5306f6c4be7a501$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $e5306f6c4be7a501$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $e5306f6c4be7a501$var$base64UrlDecode(part);
    } catch (e) {
        throw new $e5306f6c4be7a501$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $e5306f6c4be7a501$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}




const $dc10a25720c6edc8$export$a2347e5c24cde9c8 = ()=>{
    const session = (0, $b5c1938aaa3155db$export$b2b1b21ad709cbe1)();
    const idToken = session.access_token;
    if (!idToken || session.user.aud !== "authenticated") throw new Error("Shouldn't be called on unauthenticated user");
    const decodedToken = (0, $e5306f6c4be7a501$export$fa1e2fb699b7861e)(idToken);
    return (0, $jMaZ8.useMemo)(()=>({
            ...session.user,
            roles: decodedToken.roles,
            user_profile: decodedToken.user_profile
        }), [
        idToken
    ]);
};
var $dc10a25720c6edc8$export$d1cfdc29cbc61821 = /*#__PURE__*/ function($dc10a25720c6edc8$export$d1cfdc29cbc61821) {
    $dc10a25720c6edc8$export$d1cfdc29cbc61821["CONTENT_ADMINISTRATOR"] = "CONTENT_ADMINISTRATOR";
    $dc10a25720c6edc8$export$d1cfdc29cbc61821["NARRATOR"] = "NARRATOR";
    $dc10a25720c6edc8$export$d1cfdc29cbc61821["PROOF_LISTENER"] = "PROOF_LISTENER";
    $dc10a25720c6edc8$export$d1cfdc29cbc61821["EDITOR"] = "EDITOR";
    return $dc10a25720c6edc8$export$d1cfdc29cbc61821;
}({});
const $dc10a25720c6edc8$export$1b39bc9d16fffc4d = ()=>{
    const identity = $dc10a25720c6edc8$export$a2347e5c24cde9c8();
    return (0, $jMaZ8.useMemo)(()=>!!identity?.roles.find((group)=>group === "CONTENT_ADMINISTRATOR"), [
        identity
    ]);
};
const $dc10a25720c6edc8$var$SelectedRoleContext = (0, $jMaZ8.createContext)(null);
const $dc10a25720c6edc8$export$d0f896e57fc7ea90 = $dc10a25720c6edc8$var$SelectedRoleContext.Provider;
const $dc10a25720c6edc8$export$3e35f158de1d4201 = ()=>{
    const context = (0, $jMaZ8.useContext)($dc10a25720c6edc8$var$SelectedRoleContext);
    if (!context) throw new Error("Selected role context has to be set in a provider");
    return context;
};
var $dc10a25720c6edc8$export$2b6a455aeb488ed6 = /*#__PURE__*/ function($dc10a25720c6edc8$export$2b6a455aeb488ed6) {
    $dc10a25720c6edc8$export$2b6a455aeb488ed6["Narrator"] = "narrator";
    $dc10a25720c6edc8$export$2b6a455aeb488ed6["ProofListener"] = "prooflistener";
    $dc10a25720c6edc8$export$2b6a455aeb488ed6["Editor"] = "editor";
    return $dc10a25720c6edc8$export$2b6a455aeb488ed6;
}({});
var $dc10a25720c6edc8$var$FrogModes = /*#__PURE__*/ function($dc10a25720c6edc8$var$FrogModes) {
    $dc10a25720c6edc8$var$FrogModes["Audio"] = "audio";
    $dc10a25720c6edc8$var$FrogModes["Editor"] = "editor";
    return $dc10a25720c6edc8$var$FrogModes;
}($dc10a25720c6edc8$var$FrogModes || {});
const $dc10a25720c6edc8$var$ROLE_KEY = "ROLE";
function $dc10a25720c6edc8$export$5c61c7f558ce763a() {
    const identity = $dc10a25720c6edc8$export$a2347e5c24cde9c8();
    const roles = identity.roles;
    return roles.length > 1;
}
function $dc10a25720c6edc8$export$99a5e4bc80d231ca() {
    return !!$dc10a25720c6edc8$export$a2347e5c24cde9c8().roles.includes("CONTENT_ADMINISTRATOR");
}
function $dc10a25720c6edc8$export$5fe256569ad95d29() {
    return !!$dc10a25720c6edc8$export$a2347e5c24cde9c8().roles.includes("EDITOR");
}
function $dc10a25720c6edc8$export$f8adf287d3cca566() {
    return !!$dc10a25720c6edc8$export$a2347e5c24cde9c8().roles.includes("NARRATOR");
}
function $dc10a25720c6edc8$export$2b59cb60095d743f() {
    return !!$dc10a25720c6edc8$export$a2347e5c24cde9c8().roles.includes("PROOF_LISTENER");
}
function $dc10a25720c6edc8$var$useStoredRole() {
    return sessionStorage.getItem($dc10a25720c6edc8$var$ROLE_KEY);
}
function $dc10a25720c6edc8$var$useStoreRole(role) {
    (0, $jMaZ8.useEffect)(()=>sessionStorage.setItem($dc10a25720c6edc8$var$ROLE_KEY, role), [
        role
    ]);
}
function $dc10a25720c6edc8$export$8400415b0da2579(role) {
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    (0, $jMaZ8.useEffect)(()=>{
        const newMode = role === "editor" ? "editor" : "audio";
        let currentMode = null;
        if (location.pathname.includes("editor")) currentMode = "editor";
        else if (location.pathname.includes("audio")) currentMode = "audio";
        const pathname = location.pathname;
        const isUsefulToRedirect = currentMode !== null && (pathname.includes("editor") || pathname.includes("audio"));
        if (currentMode !== null && currentMode !== newMode && isUsefulToRedirect) navigate(location.pathname.replace(currentMode, newMode), {
            replace: true
        });
    }, [
        role,
        location.pathname
    ]); // Only depend on role changes, not pathname
}
const $dc10a25720c6edc8$var$useGetRoleFromURL = (storedRole)=>{
    const location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    const isEditor = $dc10a25720c6edc8$export$5fe256569ad95d29();
    const isNarrator = $dc10a25720c6edc8$export$f8adf287d3cca566();
    const isProofListener = $dc10a25720c6edc8$export$2b59cb60095d743f();
    // When launching on home page
    const isHomePage = location.pathname === "/";
    if (isHomePage) {
        if (storedRole) return storedRole;
        // Default role
        if (isEditor) return "editor";
        if (isNarrator) return "narrator";
        if (isProofListener) return "prooflistener";
    }
    // When launching on non-home page, the role will be either given from the stored one, or from from the url
    const modeFromUrl = location.pathname.includes("editor") ? "editor" : "audio";
    if (modeFromUrl === "editor" && isEditor) return "editor";
    if (modeFromUrl === "audio") {
        if (storedRole === "narrator" || storedRole === "prooflistener") return storedRole;
        if (isNarrator) return "narrator";
        if (isProofListener) return "prooflistener";
    }
    return null;
};
function $dc10a25720c6edc8$export$940503e6d676c973() {
    const isEditor = $dc10a25720c6edc8$export$5fe256569ad95d29();
    const isNarrator = $dc10a25720c6edc8$export$f8adf287d3cca566();
    const isProofListener = $dc10a25720c6edc8$export$2b59cb60095d743f();
    const storedRole = $dc10a25720c6edc8$var$useStoredRole();
    const roleFromUrl = $dc10a25720c6edc8$var$useGetRoleFromURL(storedRole);
    if (roleFromUrl) return roleFromUrl;
    if (storedRole) return storedRole;
    if (isEditor) return "editor";
    if (isNarrator) return "narrator";
    if (isProofListener) return "prooflistener";
    throw new Error("Shoulh have at least one role");
}
const $dc10a25720c6edc8$export$3f70b501c7cbbe80 = ()=>{
    const defaultRole = $dc10a25720c6edc8$export$940503e6d676c973();
    const [state, dispatch] = (0, $jMaZ8.useReducer)((_, message)=>message, defaultRole);
    $dc10a25720c6edc8$var$useStoreRole(state);
    return (0, $jMaZ8.useMemo)(()=>({
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
};





var $jMaZ8 = parcelRequire("jMaZ8");


function $f97820cb6d9a09fc$export$2e2bcd8739ae039({ projectId: projectId, close: close }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "library.inviteModal";
    const [email, setEmail] = (0, $jMaZ8.useState)("");
    const [inviteToProject] = (0, $d7188398173686a1$export$b7e8da276dc353e7)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        centered: true,
        width: "56.66em",
        title: t(`${i18nKey}.title`),
        open: projectId !== "",
        onCancel: close,
        footer: null,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
            name: "basic",
            initialValues: {
                remember: true
            },
            onFinish: ()=>{
                inviteToProject({
                    variables: {
                        projectId: projectId,
                        userId: email
                    }
                });
                close();
            },
            layout: "vertical",
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t(`${i18nKey}.email`),
                    name: "name",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        value: email,
                        onChange: (e)=>setEmail(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        margin: 0
                    },
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            disabled: email.length === 0,
                            htmlType: "submit",
                            shape: "round",
                            children: t(`${i18nKey}.invite`)
                        })
                    })
                })
            ]
        })
    }, projectId);
}





var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $1cfGC = parcelRequire("1cfGC");








var $jMaZ8 = parcelRequire("jMaZ8");
const $ff5e747188d34402$var$GroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext(null);
var $ff5e747188d34402$export$2e2bcd8739ae039 = $ff5e747188d34402$var$GroupContext;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $f547958b307dd2c4$export$92a97fe1d1148438 = (token)=>{
    const { checkboxCls: checkboxCls } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                display: 'inline-flex',
                flexWrap: 'wrap',
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            }),
            // Wrapper
            [wrapperCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                display: 'inline-flex',
                alignItems: 'baseline',
                cursor: 'pointer',
                // Fix checkbox & radio in flex align #30260
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    overflow: 'hidden',
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                },
                [`&${wrapperCls}-in-form-item`]: {
                    'input[type="checkbox"]': {
                        width: 14,
                        // FIXME: magic
                        height: 14 // FIXME: magic
                    }
                }
            }),
            // Wrapper > Checkbox
            [checkboxCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                position: 'relative',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                cursor: 'pointer',
                borderRadius: token.borderRadiusSM,
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: 'center',
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: 'absolute',
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: 0,
                    zIndex: 1,
                    cursor: 'pointer',
                    opacity: 0,
                    margin: 0,
                    [`&:focus-visible + ${checkboxCls}-inner`]: Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token))
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    boxSizing: 'border-box',
                    display: 'block',
                    width: token.checkboxSize,
                    height: token.checkboxSize,
                    direction: 'ltr',
                    backgroundColor: token.colorBgContainer,
                    border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusSM,
                    borderCollapse: 'separate',
                    transition: `all ${token.motionDurationSlow}`,
                    '&:after': {
                        boxSizing: 'border-box',
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '25%',
                        display: 'table',
                        width: token.calc(token.checkboxSize).div(14).mul(5).equal(),
                        height: token.calc(token.checkboxSize).div(14).mul(8).equal(),
                        border: `${(0, $4g3I0.unit)(token.lineWidthBold)} solid ${token.colorWhite}`,
                        borderTop: 0,
                        borderInlineStart: 0,
                        transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
                        opacity: 0,
                        content: '""',
                        transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`
                    }
                },
                // Wrapper > Checkbox + Text
                '& + span': {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            })
        },
        // ===================== Hover =====================
        {
            // Wrapper & Wrapper > Checkbox
            [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    borderColor: token.colorPrimary
                }
            },
            [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled) ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                },
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled):after`]: {
                    borderColor: token.colorPrimaryHover
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                [`${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimary,
                    borderColor: token.colorPrimary,
                    '&:after': {
                        opacity: 1,
                        transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                        transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`
                    }
                }
            },
            [`
        ${wrapperCls}-checked:not(${wrapperCls}-disabled),
        ${checkboxCls}-checked:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                '&-indeterminate': {
                    // Wrapper > Checkbox > inner
                    [`${checkboxCls}-inner`]: {
                        backgroundColor: `${token.colorBgContainer} !important`,
                        borderColor: `${token.colorBorder} !important`,
                        '&:after': {
                            top: '50%',
                            insetInlineStart: '50%',
                            width: token.calc(token.fontSizeLG).div(2).equal(),
                            height: token.calc(token.fontSizeLG).div(2).equal(),
                            backgroundColor: token.colorPrimary,
                            border: 0,
                            transform: 'translate(-50%, -50%) scale(1)',
                            opacity: 1,
                            content: '""'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/50074
                    [`&:hover ${checkboxCls}-inner`]: {
                        backgroundColor: `${token.colorBgContainer} !important`,
                        borderColor: `${token.colorPrimary} !important`
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: 'not-allowed'
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: 'not-allowed',
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: 'none'
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    background: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    '&:after': {
                        borderColor: token.colorTextDisabled
                    }
                },
                '&:after': {
                    display: 'none'
                },
                '& + span': {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate ${checkboxCls}-inner::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function $f547958b307dd2c4$export$3d2f074408bd1b82(prefixCls, token) {
    const checkboxToken = (0, $8APUt.merge)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return [
        $f547958b307dd2c4$export$92a97fe1d1148438(checkboxToken)
    ];
}
var $f547958b307dd2c4$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Checkbox', (token, _ref)=>{
    let { prefixCls: prefixCls } = _ref;
    return [
        $f547958b307dd2c4$export$3d2f074408bd1b82(prefixCls, token)
    ];
});



"use client";
var $cc6178938a8c95a5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $cc6178938a8c95a5$var$InternalCheckbox = (props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, indeterminate: indeterminate = false, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, skipGroup: skipGroup = false, disabled: disabled } = props, restProps = $cc6178938a8c95a5$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "disabled"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, checkbox: checkbox } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const checkboxGroup = $jMaZ8.useContext((0, $ff5e747188d34402$export$2e2bcd8739ae039));
    const { isFormItemInput: isFormItemInput } = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    const contextDisabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = (_a = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _a !== void 0 ? _a : contextDisabled;
    const prevValue = $jMaZ8.useRef(restProps.value);
    const checkboxRef = $jMaZ8.useRef(null);
    const mergedRef = (0, $1cfGC.composeRef)(ref, checkboxRef);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Checkbox');
        warning('checked' in restProps || !!checkboxGroup || !('value' in restProps), 'usage', '`value` is not a valid prop, do you mean `checked`?');
    }
    $jMaZ8.useEffect(()=>{
        checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
    }, []);
    $jMaZ8.useEffect(()=>{
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return ()=>checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
    }, [
        restProps.value
    ]);
    $jMaZ8.useEffect(()=>{
        var _a;
        if ((_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.input) checkboxRef.current.input.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f547958b307dd2c4$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const checkboxProps = Object.assign({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            if (restProps.onChange) restProps.onChange.apply(restProps, arguments);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, checkbox === null || checkbox === void 0 ? void 0 : checkbox.className, className, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, $eb107cfcd5a0fca6$export$23466a5792b7a5d3), hashId);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $17a96173768e811a$export$2e2bcd8739ae039)(checkboxProps.onClick);
    // ============================== Render ==============================
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $de29c1080c02bd8d$export$2e2bcd8739ae039), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $jMaZ8.createElement("label", {
        className: classString,
        style: Object.assign(Object.assign({}, checkbox === null || checkbox === void 0 ? void 0 : checkbox.style), style),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onLabelClick
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $86220ccac903f90f$export$2e2bcd8739ae039), Object.assign({}, checkboxProps, {
        onClick: onInputClick,
        prefixCls: prefixCls,
        className: checkboxClass,
        disabled: mergedDisabled,
        ref: mergedRef
    })), children !== undefined && /*#__PURE__*/ $jMaZ8.createElement("span", null, children))));
};
const $cc6178938a8c95a5$var$Checkbox = /*#__PURE__*/ $jMaZ8.forwardRef($cc6178938a8c95a5$var$InternalCheckbox);
$cc6178938a8c95a5$var$Checkbox.displayName = 'Checkbox';
var $cc6178938a8c95a5$export$2e2bcd8739ae039 = $cc6178938a8c95a5$var$Checkbox;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $hvG6u = parcelRequire("hvG6u");





"use client";
var $089254c02d37578d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $089254c02d37578d$var$CheckboxGroup = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { defaultValue: defaultValue, children: children, options: options = [], prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, onChange: onChange } = props, restProps = $089254c02d37578d$var$__rest(props, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "onChange"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const [value, setValue] = $jMaZ8.useState(restProps.value || defaultValue || []);
    const [registeredValues, setRegisteredValues] = $jMaZ8.useState([]);
    $jMaZ8.useEffect(()=>{
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    const memoOptions = $jMaZ8.useMemo(()=>options.map((option)=>{
            if (typeof option === 'string' || typeof option === 'number') return {
                label: option,
                value: option
            };
            return option;
        }), [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, $fvBso.default)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = value.indexOf(option.value);
        const newValue = (0, $fvBso.default)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        onChange === null || onChange === void 0 || onChange(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f547958b307dd2c4$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const domProps = (0, $hvG6u.default)(restProps, [
        'value',
        'disabled'
    ]);
    const childrenNode = options.length ? memoOptions.map((option)=>/*#__PURE__*/ $jMaZ8.createElement((0, $cc6178938a8c95a5$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: `${groupPrefixCls}-item`,
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        registerValue: // https://github.com/ant-design/ant-design/issues/16376
        registerValue,
        cancelValue: cancelValue
    };
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        className: classString,
        style: style
    }, domProps, {
        ref: ref
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $ff5e747188d34402$export$2e2bcd8739ae039).Provider, {
        value: context
    }, childrenNode)));
});
var $089254c02d37578d$export$2e2bcd8739ae039 = $089254c02d37578d$var$CheckboxGroup;


"use client";
const $1e51c82e25088207$var$Checkbox = (0, $cc6178938a8c95a5$export$2e2bcd8739ae039);
$1e51c82e25088207$var$Checkbox.Group = (0, $089254c02d37578d$export$2e2bcd8739ae039);
$1e51c82e25088207$var$Checkbox.__ANT_CHECKBOX = true;
$1e51c82e25088207$var$Checkbox.displayName = 'Checkbox';
var $1e51c82e25088207$export$2e2bcd8739ae039 = $1e51c82e25088207$var$Checkbox;



var $jMaZ8 = parcelRequire("jMaZ8");
/* tslint:disable */ /* eslint-disable */ // @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $b522cf181e75e62d$export$f67d996d1aa82fbb = /*#__PURE__*/ function($b522cf181e75e62d$export$f67d996d1aa82fbb) {
    $b522cf181e75e62d$export$f67d996d1aa82fbb["FAILED"] = "FAILED";
    $b522cf181e75e62d$export$f67d996d1aa82fbb["IN_PROGRESS"] = "IN_PROGRESS";
    $b522cf181e75e62d$export$f67d996d1aa82fbb["SUCCEEDED"] = "SUCCEEDED";
    $b522cf181e75e62d$export$f67d996d1aa82fbb["TO_DO"] = "TO_DO";
    return $b522cf181e75e62d$export$f67d996d1aa82fbb;
}({});
var $b522cf181e75e62d$export$221b784fada1dd4a = /*#__PURE__*/ function($b522cf181e75e62d$export$221b784fada1dd4a) {
    $b522cf181e75e62d$export$221b784fada1dd4a["BAD_SPEECH"] = "BAD_SPEECH";
    $b522cf181e75e62d$export$221b784fada1dd4a["BAD_TEXT"] = "BAD_TEXT";
    $b522cf181e75e62d$export$221b784fada1dd4a["BAD_TEXT_AND_NARRATION"] = "BAD_TEXT_AND_NARRATION";
    $b522cf181e75e62d$export$221b784fada1dd4a["RECORDING"] = "RECORDING";
    $b522cf181e75e62d$export$221b784fada1dd4a["RENARRATED"] = "RENARRATED";
    $b522cf181e75e62d$export$221b784fada1dd4a["VALID"] = "VALID";
    return $b522cf181e75e62d$export$221b784fada1dd4a;
}({});
var $b522cf181e75e62d$export$d38212884f7bc925 = /*#__PURE__*/ function($b522cf181e75e62d$export$d38212884f7bc925) {
    $b522cf181e75e62d$export$d38212884f7bc925["ARCHIVED"] = "ARCHIVED";
    $b522cf181e75e62d$export$d38212884f7bc925["COMPLETE"] = "COMPLETE";
    $b522cf181e75e62d$export$d38212884f7bc925["WIP"] = "WIP";
    return $b522cf181e75e62d$export$d38212884f7bc925;
}({});
var $b522cf181e75e62d$export$602981314f6adf1a = /*#__PURE__*/ function($b522cf181e75e62d$export$602981314f6adf1a) {
    $b522cf181e75e62d$export$602981314f6adf1a["DONE"] = "DONE";
    $b522cf181e75e62d$export$602981314f6adf1a["FAILED"] = "FAILED";
    $b522cf181e75e62d$export$602981314f6adf1a["IN_PROGRESS"] = "IN_PROGRESS";
    $b522cf181e75e62d$export$602981314f6adf1a["WAITING"] = "WAITING";
    return $b522cf181e75e62d$export$602981314f6adf1a;
}({});
var $b522cf181e75e62d$export$7e829f6ef9a7acbf = /*#__PURE__*/ function($b522cf181e75e62d$export$7e829f6ef9a7acbf) {
    $b522cf181e75e62d$export$7e829f6ef9a7acbf["DEFINITIONS"] = "DEFINITIONS";
    $b522cf181e75e62d$export$7e829f6ef9a7acbf["FULL"] = "FULL";
    $b522cf181e75e62d$export$7e829f6ef9a7acbf["HTML"] = "HTML";
    $b522cf181e75e62d$export$7e829f6ef9a7acbf["INTO_IMPORTED_EPUB"] = "INTO_IMPORTED_EPUB";
    $b522cf181e75e62d$export$7e829f6ef9a7acbf["NARRATION"] = "NARRATION";
    $b522cf181e75e62d$export$7e829f6ef9a7acbf["SIMPLE"] = "SIMPLE";
    return $b522cf181e75e62d$export$7e829f6ef9a7acbf;
}({});
var $b522cf181e75e62d$export$2b5d0c623adb8e14 = /*#__PURE__*/ function($b522cf181e75e62d$export$2b5d0c623adb8e14) {
    $b522cf181e75e62d$export$2b5d0c623adb8e14["EXPLICIT"] = "EXPLICIT";
    $b522cf181e75e62d$export$2b5d0c623adb8e14["IMPLICIT"] = "IMPLICIT";
    $b522cf181e75e62d$export$2b5d0c623adb8e14["NDBP"] = "NDBP";
    return $b522cf181e75e62d$export$2b5d0c623adb8e14;
}({});
var $b522cf181e75e62d$export$e5be9b5f8a520e95 = /*#__PURE__*/ function($b522cf181e75e62d$export$e5be9b5f8a520e95) {
    $b522cf181e75e62d$export$e5be9b5f8a520e95["CENTRE"] = "CENTRE";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["CITATION"] = "CITATION";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["COURRIER"] = "COURRIER";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["DIALOGUE"] = "DIALOGUE";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["DIDASCALIE"] = "DIDASCALIE";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["DROITE"] = "DROITE";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["EMAIL"] = "EMAIL";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["ESPACE"] = "ESPACE";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["GRAS"] = "GRAS";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["INTRO"] = "INTRO";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["LIST_DEFINITION"] = "LIST_DEFINITION";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["LIST_ORDERED"] = "LIST_ORDERED";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["LIST_UNORDERED"] = "LIST_UNORDERED";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["NORMAL"] = "NORMAL";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["NOTE"] = "NOTE";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["RESUME"] = "RESUME";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["TEXTO"] = "TEXTO";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["TITRE_1"] = "TITRE_1";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["TITRE_2"] = "TITRE_2";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["TITRE_3"] = "TITRE_3";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["TITRE_4"] = "TITRE_4";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["TITRE_5"] = "TITRE_5";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["TITRE_6"] = "TITRE_6";
    $b522cf181e75e62d$export$e5be9b5f8a520e95["VERS"] = "VERS";
    return $b522cf181e75e62d$export$e5be9b5f8a520e95;
}({});
var $b522cf181e75e62d$export$518871f4dec82d24 = /*#__PURE__*/ function($b522cf181e75e62d$export$518871f4dec82d24) {
    $b522cf181e75e62d$export$518871f4dec82d24["COMPLEX"] = "COMPLEX";
    $b522cf181e75e62d$export$518871f4dec82d24["CONSONANT"] = "CONSONANT";
    $b522cf181e75e62d$export$518871f4dec82d24["VOWEL"] = "VOWEL";
    return $b522cf181e75e62d$export$518871f4dec82d24;
}({});
var $b522cf181e75e62d$export$6b9f2d1513b0c4f2 = /*#__PURE__*/ function($b522cf181e75e62d$export$6b9f2d1513b0c4f2) {
    $b522cf181e75e62d$export$6b9f2d1513b0c4f2["LOWER"] = "LOWER";
    $b522cf181e75e62d$export$6b9f2d1513b0c4f2["UPPER"] = "UPPER";
    return $b522cf181e75e62d$export$6b9f2d1513b0c4f2;
}({});
var $b522cf181e75e62d$export$7e93c17f45cd53fa = /*#__PURE__*/ function($b522cf181e75e62d$export$7e93c17f45cd53fa) {
    $b522cf181e75e62d$export$7e93c17f45cd53fa["SUBSCRIPT"] = "SUBSCRIPT";
    $b522cf181e75e62d$export$7e93c17f45cd53fa["SUPERSCRIPT"] = "SUPERSCRIPT";
    return $b522cf181e75e62d$export$7e93c17f45cd53fa;
}({});
var $b522cf181e75e62d$export$b890e9c15247e0b3 = /*#__PURE__*/ function($b522cf181e75e62d$export$b890e9c15247e0b3) {
    $b522cf181e75e62d$export$b890e9c15247e0b3["NORMAL"] = "NORMAL";
    $b522cf181e75e62d$export$b890e9c15247e0b3["POPUP"] = "POPUP";
    return $b522cf181e75e62d$export$b890e9c15247e0b3;
}({});
var $b522cf181e75e62d$export$a1ccd8e6c4b447b2 = /*#__PURE__*/ function($b522cf181e75e62d$export$a1ccd8e6c4b447b2) {
    $b522cf181e75e62d$export$a1ccd8e6c4b447b2["AFTER"] = "AFTER";
    $b522cf181e75e62d$export$a1ccd8e6c4b447b2["BEFORE"] = "BEFORE";
    return $b522cf181e75e62d$export$a1ccd8e6c4b447b2;
}({});
var $b522cf181e75e62d$export$cf6fc7defa80d203 = /*#__PURE__*/ function($b522cf181e75e62d$export$cf6fc7defa80d203) {
    $b522cf181e75e62d$export$cf6fc7defa80d203["DONE"] = "DONE";
    $b522cf181e75e62d$export$cf6fc7defa80d203["FAILED"] = "FAILED";
    $b522cf181e75e62d$export$cf6fc7defa80d203["IMPORTING_CONTENT"] = "IMPORTING_CONTENT";
    $b522cf181e75e62d$export$cf6fc7defa80d203["WAITING_FOR_CONTENT"] = "WAITING_FOR_CONTENT";
    return $b522cf181e75e62d$export$cf6fc7defa80d203;
}({});
var $b522cf181e75e62d$export$5ae1d041667099bd = /*#__PURE__*/ function($b522cf181e75e62d$export$5ae1d041667099bd) {
    $b522cf181e75e62d$export$5ae1d041667099bd["CASE"] = "CASE";
    $b522cf181e75e62d$export$5ae1d041667099bd["CITATION"] = "CITATION";
    $b522cf181e75e62d$export$5ae1d041667099bd["CUSTOM_COLORATION"] = "CUSTOM_COLORATION";
    $b522cf181e75e62d$export$5ae1d041667099bd["CUSTOM_CSS_CLASSES"] = "CUSTOM_CSS_CLASSES";
    $b522cf181e75e62d$export$5ae1d041667099bd["DEFINITION"] = "DEFINITION";
    $b522cf181e75e62d$export$5ae1d041667099bd["ITALICIZATION"] = "ITALICIZATION";
    $b522cf181e75e62d$export$5ae1d041667099bd["MUTE"] = "MUTE";
    $b522cf181e75e62d$export$5ae1d041667099bd["PAGE"] = "PAGE";
    $b522cf181e75e62d$export$5ae1d041667099bd["PARAGRAPH"] = "PARAGRAPH";
    $b522cf181e75e62d$export$5ae1d041667099bd["PHONEME"] = "PHONEME";
    $b522cf181e75e62d$export$5ae1d041667099bd["RHESE"] = "RHESE";
    $b522cf181e75e62d$export$5ae1d041667099bd["SCRIPT_NOTATION"] = "SCRIPT_NOTATION";
    $b522cf181e75e62d$export$5ae1d041667099bd["SYLLABLE"] = "SYLLABLE";
    $b522cf181e75e62d$export$5ae1d041667099bd["WEIGHT"] = "WEIGHT";
    return $b522cf181e75e62d$export$5ae1d041667099bd;
}({});
var $b522cf181e75e62d$export$a4ee75e327dfb704 = /*#__PURE__*/ function($b522cf181e75e62d$export$a4ee75e327dfb704) {
    $b522cf181e75e62d$export$a4ee75e327dfb704["MUTE"] = "MUTE";
    $b522cf181e75e62d$export$a4ee75e327dfb704["NOTHING"] = "NOTHING";
    $b522cf181e75e62d$export$a4ee75e327dfb704["UNMUTE"] = "UNMUTE";
    return $b522cf181e75e62d$export$a4ee75e327dfb704;
}({});
var $b522cf181e75e62d$export$3f684fc5c7851f91 = /*#__PURE__*/ function($b522cf181e75e62d$export$3f684fc5c7851f91) {
    $b522cf181e75e62d$export$3f684fc5c7851f91["COMPLETE"] = "COMPLETE";
    $b522cf181e75e62d$export$3f684fc5c7851f91["NOT_READY"] = "NOT_READY";
    $b522cf181e75e62d$export$3f684fc5c7851f91["READY_FOR_NARRATION"] = "READY_FOR_NARRATION";
    return $b522cf181e75e62d$export$3f684fc5c7851f91;
}({});
var $b522cf181e75e62d$export$878945baaa13398a = /*#__PURE__*/ function($b522cf181e75e62d$export$878945baaa13398a) {
    $b522cf181e75e62d$export$878945baaa13398a["HTML_TEMPLATE"] = "HTML_TEMPLATE";
    $b522cf181e75e62d$export$878945baaa13398a["JSON_IMPORT"] = "JSON_IMPORT";
    $b522cf181e75e62d$export$878945baaa13398a["TEXT"] = "TEXT";
    return $b522cf181e75e62d$export$878945baaa13398a;
}({});
var $b522cf181e75e62d$export$e228d3e230353c = /*#__PURE__*/ function($b522cf181e75e62d$export$e228d3e230353c) {
    $b522cf181e75e62d$export$e228d3e230353c["CONTENT"] = "CONTENT";
    $b522cf181e75e62d$export$e228d3e230353c["ID"] = "ID";
    return $b522cf181e75e62d$export$e228d3e230353c;
}({});
var $b522cf181e75e62d$export$eb2f7ec705c266a5 = /*#__PURE__*/ function($b522cf181e75e62d$export$eb2f7ec705c266a5) {
    $b522cf181e75e62d$export$eb2f7ec705c266a5["AFTER_INDEX"] = "AFTER_INDEX";
    $b522cf181e75e62d$export$eb2f7ec705c266a5["BEFORE_INDEX"] = "BEFORE_INDEX";
    return $b522cf181e75e62d$export$eb2f7ec705c266a5;
}({});
var $b522cf181e75e62d$export$eb3485a690c2f0b8 = /*#__PURE__*/ function($b522cf181e75e62d$export$eb3485a690c2f0b8) {
    $b522cf181e75e62d$export$eb3485a690c2f0b8["CORRECTOR"] = "CORRECTOR";
    $b522cf181e75e62d$export$eb3485a690c2f0b8["PREPARER"] = "PREPARER";
    return $b522cf181e75e62d$export$eb3485a690c2f0b8;
}({});
var $b522cf181e75e62d$export$7b4fabbf7a6734d3 = /*#__PURE__*/ function($b522cf181e75e62d$export$7b4fabbf7a6734d3) {
    $b522cf181e75e62d$export$7b4fabbf7a6734d3["DEFINITION"] = "DEFINITION";
    $b522cf181e75e62d$export$7b4fabbf7a6734d3["DIALOGUES"] = "DIALOGUES";
    $b522cf181e75e62d$export$7b4fabbf7a6734d3["FORMATTING"] = "FORMATTING";
    $b522cf181e75e62d$export$7b4fabbf7a6734d3["NARRATION"] = "NARRATION";
    $b522cf181e75e62d$export$7b4fabbf7a6734d3["RHESE"] = "RHESE";
    $b522cf181e75e62d$export$7b4fabbf7a6734d3["SYLLABLES"] = "SYLLABLES";
    return $b522cf181e75e62d$export$7b4fabbf7a6734d3;
}({});
 //==============================================================
 // END Enums and Input Objects
 //==============================================================





var $jzGiR = parcelRequire("jzGiR");

var $jMaZ8 = parcelRequire("jMaZ8");
const $faf74e6dbebab232$export$5668bf2a4e05029f = {
    overview: "overview",
    rhese: "rhese",
    format: "format",
    definition: "definition",
    dialogue: "dialogue",
    syllable: "syllable",
    narration: "narration"
};
const $faf74e6dbebab232$export$a0dca76daac4ca4c = {
    [$faf74e6dbebab232$export$5668bf2a4e05029f.overview]: "1",
    [$faf74e6dbebab232$export$5668bf2a4e05029f.rhese]: "2",
    [$faf74e6dbebab232$export$5668bf2a4e05029f.format]: "3",
    [$faf74e6dbebab232$export$5668bf2a4e05029f.definition]: "4",
    [$faf74e6dbebab232$export$5668bf2a4e05029f.dialogue]: "5",
    [$faf74e6dbebab232$export$5668bf2a4e05029f.syllable]: "6",
    [$faf74e6dbebab232$export$5668bf2a4e05029f.narration]: "7"
};


const $7ff84a88030acb67$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $jMaZ8.useRef)();
    (0, $jMaZ8.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
const $7ff84a88030acb67$export$d4bc33f48b610b3b = (str)=>str.normalize("NFD").replace(/\p{Diacritic}/gu, "");
const $7ff84a88030acb67$export$d79de1c00ff6430 = (pathname)=>{
    const tabName = (pathname.match(/[^/]*$/) || [
        ""
    ])[0];
    return tabName === (0, $faf74e6dbebab232$export$5668bf2a4e05029f).format;
};
const $7ff84a88030acb67$export$b7679d1806cb064d = (arr)=>({
        syllable: arr?.includes("syllable"),
        phoneme: arr?.includes("phoneme"),
        custom: arr?.includes("custom")
    });
const $7ff84a88030acb67$export$21f7a88e2aa3d4f5 = (createdAt, completedAt)=>{
    if (!createdAt) return "";
    if (!completedAt) completedAt = new Date().toISOString();
    const durationInSeconds = (0, (/*@__PURE__*/$parcel$interopDefault($jzGiR)))(completedAt).diff(createdAt, "seconds");
    if (durationInSeconds < 60) return `${durationInSeconds}s`;
    const durationInMin = (0, (/*@__PURE__*/$parcel$interopDefault($jzGiR)))(completedAt).diff(createdAt, "minute");
    if (durationInMin < 60) return `${durationInMin}min`;
    const durationInHours = (0, (/*@__PURE__*/$parcel$interopDefault($jzGiR)))(completedAt).diff(createdAt, "hours");
    return `${durationInHours}h`;
};
const $7ff84a88030acb67$export$ac8be1d0bc279ee4 = (completedAt)=>{
    if (!completedAt) return false;
    const durationInHours = (0, (/*@__PURE__*/$parcel$interopDefault($jzGiR)))().diff(completedAt, "hours");
    return durationInHours > 24;
};
const $7ff84a88030acb67$export$97f7a09861f87b46 = (a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start;
const $7ff84a88030acb67$export$4596341c772d96c7 = (metadata, pageMetadata)=>metadata && pageMetadata && pageMetadata.textContent.substring(metadata.anchors[0].utf16Start - pageMetadata.page.anchors[0].utf16Start, metadata.anchors[0].utf16Start - pageMetadata.page.anchors[0].utf16Start + metadata.anchors[0].utf16Size);
function $7ff84a88030acb67$export$f5d4c9ebc7847d5(metadata, selectedTextPosition) {
    return metadata.filter((m)=>// Start is inside the metadata
        selectedTextPosition.start >= m.anchors[0].utf16Start && selectedTextPosition.start < m.anchors[0].utf16Start + m.anchors[0].utf16Size || // End is inside the metadata
        selectedTextPosition.start + selectedTextPosition.size > m.anchors[0].utf16Start && selectedTextPosition.start + selectedTextPosition.size <= m.anchors[0].utf16Start + m.anchors[0].utf16Size || // Rhese is inside the selection
        selectedTextPosition.start <= m.anchors[0].utf16Start && selectedTextPosition.start + selectedTextPosition.size >= m.anchors[0].utf16Start + m.anchors[0].utf16Size);
}


const $686f8972f7d4409a$var$ExportModal = ({ id: id, name: name, isEPubExport: isEPubExport, onExit: onExit })=>{
    const isVisible = !!id && !!name;
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [includeAudio, setIncludeAudio] = (0, $jMaZ8.useState)(true);
    const colorationOptions = [
        {
            value: "syllable",
            label: t("project.existing.index.syllableComponent.syllables")
        },
        {
            value: "phoneme",
            label: t("project.existing.index.syllableComponent.phonemes")
        },
        {
            value: "custom",
            label: t("project.existing.index.syllableComponent.custom")
        }
    ];
    const [selectedColorationsOptions, setSelectedColorationsOptions] = (0, $jMaZ8.useState)(colorationOptions.map((o)=>o.value));
    const [exportProject] = (0, $d7188398173686a1$export$8b0fb4ff6360f2a7)();
    const callExportProject = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            if (!id || !name) return;
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).info({
                message: t("library.index.default.export.message")
            });
            onExit();
            const _includeAudio = isEPubExport ? false : includeAudio;
            await exportProject({
                variables: {
                    projectId: id,
                    exportType: isEPubExport ? (0, $b522cf181e75e62d$export$7e829f6ef9a7acbf).INTO_IMPORTED_EPUB : (0, $b522cf181e75e62d$export$7e829f6ef9a7acbf).FULL,
                    exportConfig: {
                        coloration: (0, $7ff84a88030acb67$export$b7679d1806cb064d)(selectedColorationsOptions),
                        includeAudio: _includeAudio
                    }
                }
            });
        } catch (e) {
            console.error(e);
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                message: t("library.index.default.export.errorNotification")
            });
        }
    }, [
        id,
        name,
        t,
        onExit,
        isEPubExport,
        includeAudio,
        selectedColorationsOptions,
        exportProject
    ]);
    // Effect for default values
    (0, $jMaZ8.useEffect)(()=>{
        if (!isVisible) setIncludeAudio(true);
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        destroyOnClose: true,
        open: isVisible,
        footer: false,
        onCancel: onExit,
        children: !!id && !!name && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
                    name: "basic",
                    initialValues: {
                        remember: false
                    },
                    onFinish: callExportProject,
                    layout: "vertical",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                        style: {
                            padding: "0 7em"
                        },
                        label: t("library.index.default.export.colorationOptions"),
                        name: "title",
                        initialValue: colorationOptions.map((o)=>o.value),
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039).Group, {
                            options: colorationOptions,
                            onChange: (values)=>setSelectedColorationsOptions(values.map((v)=>v.toLocaleString()))
                        })
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
                    name: "basic",
                    initialValues: {
                        remember: false
                    },
                    onFinish: callExportProject,
                    layout: "vertical",
                    children: [
                        !isEPubExport && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                            style: {
                                padding: "0 7em"
                            },
                            label: t("library.index.default.export.audioOption"),
                            name: "title",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                style: {
                                    marginTop: "-1.85em"
                                },
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                                    checked: includeAudio,
                                    onChange: (e)=>setIncludeAudio(e.target.checked),
                                    children: t("library.index.default.export.audioOptionCheckbox")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                            style: {
                                margin: 0
                            },
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                                justify: "center",
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                    htmlType: "submit",
                                    shape: "round",
                                    children: t("library.index.projectCard.menu.export")
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $686f8972f7d4409a$export$2e2bcd8739ae039 = $686f8972f7d4409a$var$ExportModal;





var $jMaZ8 = parcelRequire("jMaZ8");



parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $15e3a7508d138ffe$export$a3579ca508007a95 = (0, $jMaZ8.createContext)({});



var $jMaZ8 = parcelRequire("jMaZ8");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $bd09330c468f7d5e$export$fe4300aa8eebea86(init) {
    const ref = (0, $jMaZ8.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}




var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
/**
 * @public
 */ const $70925b40c3bb5f59$export$f224e4635b6f8ce2 = (0, $jMaZ8.createContext)(null);





var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
/**
 * @public
 */ const $e2022e66f4544c33$export$22a697fb29aac98d = (0, $jMaZ8.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $4e727005ab0b8d21$var$PopChildMeasure extends $jMaZ8.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = parent instanceof HTMLElement ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $4e727005ab0b8d21$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX }) {
    const id = (0, $jMaZ8.useId)();
    const ref = (0, $jMaZ8.useRef)(null);
    const size = (0, $jMaZ8.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce: nonce } = (0, $jMaZ8.useContext)((0, $e2022e66f4544c33$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $jMaZ8.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $954e0e3ebeee9f2b$exports.jsx)($4e727005ab0b8d21$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $jMaZ8.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $be2c1ca2b926e156$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX })=>{
    const presenceChildren = (0, $bd09330c468f7d5e$export$fe4300aa8eebea86)($be2c1ca2b926e156$var$newChildrenMap);
    const id = (0, $jMaZ8.useId)();
    const memoizedOnExitComplete = (0, $jMaZ8.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $jMaZ8.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $jMaZ8.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $jMaZ8.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4e727005ab0b8d21$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        anchorX: anchorX,
        children: children
    });
    return (0, $954e0e3ebeee9f2b$exports.jsx)((0, $70925b40c3bb5f59$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $be2c1ca2b926e156$var$newChildrenMap() {
    return new Map();
}



var $jMaZ8 = parcelRequire("jMaZ8");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $dd1bd76902132a2d$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $jMaZ8.useContext)((0, $70925b40c3bb5f59$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $jMaZ8.useId)();
    (0, $jMaZ8.useEffect)(()=>{
        if (subscribe) register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $jMaZ8.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $dd1bd76902132a2d$export$8249053f690ea39a() {
    return $dd1bd76902132a2d$export$ee27c052bca048fb((0, $jMaZ8.useContext)((0, $70925b40c3bb5f59$export$f224e4635b6f8ce2)));
}
function $dd1bd76902132a2d$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $jMaZ8 = parcelRequire("jMaZ8");
const $2451cf7c221af9ba$export$10e61aed958678dd = (child)=>child.key || "";
function $2451cf7c221af9ba$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $jMaZ8.Children).forEach(children, (child)=>{
        if ((0, $jMaZ8.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



var $jMaZ8 = parcelRequire("jMaZ8");
const $c1ea35d81beb7558$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $275bf53c13de8309$export$700979bc83e7db82 = (0, $c1ea35d81beb7558$export$4e09c449d6c407f7) ? (0, $jMaZ8.useLayoutEffect) : (0, $jMaZ8.useEffect);


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $8043386845b9e569$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left" })=>{
    const [isParentPresent, safeToRemove] = (0, $dd1bd76902132a2d$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $jMaZ8.useMemo)(()=>(0, $2451cf7c221af9ba$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $2451cf7c221af9ba$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $jMaZ8.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $jMaZ8.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $bd09330c468f7d5e$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $jMaZ8.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $jMaZ8.useState)(presentChildren);
    (0, $275bf53c13de8309$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $2451cf7c221af9ba$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $2451cf7c221af9ba$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $2451cf7c221af9ba$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    if (mode === "wait" && renderedChildren.length > 1) console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $jMaZ8.useContext)((0, $15e3a7508d138ffe$export$a3579ca508007a95));
    return (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $2451cf7c221af9ba$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 || safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $954e0e3ebeee9f2b$exports.jsx)((0, $be2c1ca2b926e156$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};

const $b6eedd81c035e31f$var$warned = new Set();
function $b6eedd81c035e31f$export$5b28268982f175ba(condition, message, element) {
    if (condition || $b6eedd81c035e31f$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $b6eedd81c035e31f$var$warned.add(message);
}


function $a14f69f0f51b0645$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        (0, $b6eedd81c035e31f$export$5b28268982f175ba)(false, "motion() is deprecated. Use motion.create() instead.");
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $1c2638ff897fdf82$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $2a4adbe79caa98d1$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $101df3d51443ba02$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $b148483bb755c8e0$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $f23b54c5f89fbd40$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $f23b54c5f89fbd40$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $f23b54c5f89fbd40$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $f23b54c5f89fbd40$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $24cfcff025c1c09b$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $f23b54c5f89fbd40$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $2bfff75dc769cecc$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $2bfff75dc769cecc$export$1405a65085f40b9 = [
    "initial",
    ...$2bfff75dc769cecc$export$16e45afcc206d3a8
];



/*#__NO_SIDE_EFFECTS__*/ const $be2f5e64a7ccd429$export$8793edee2d425525 = (any)=>any;


let $7683130a8f946b90$export$491112666e282270 = (0, $be2f5e64a7ccd429$export$8793edee2d425525);
let $7683130a8f946b90$export$f5708dca728d7177 = (0, $be2f5e64a7ccd429$export$8793edee2d425525);
$7683130a8f946b90$export$491112666e282270 = (check, message)=>{
    if (!check && typeof console !== "undefined") console.warn(message);
};
$7683130a8f946b90$export$f5708dca728d7177 = (check, message)=>{
    if (!check) throw new Error(message);
};


/*#__NO_SIDE_EFFECTS__*/ function $f8d8880916c6001a$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $7e55285dc4fb4246$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;




const $8c270b9b3f976214$export$20d68f04f30763a5 = (0, $f8d8880916c6001a$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $f240d29771bba8c3$export$4d0c371993b9283e {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        // Support for new finished Promise and legacy thennable API
        return Promise.all(this.animations.map((animation)=>"finished" in animation ? animation.finished : animation));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $8c270b9b3f976214$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else if (typeof fallback === "function") return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */ class $c44424735ce2ff07$export$c1e41718f71efe41 extends (0, $f240d29771bba8c3$export$4d0c371993b9283e) {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
}


function $2d0bcc80dbf59ef8$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9279dd71409bd1ca$export$f4ff70a5b4808fd8 = 20000;
function $9279dd71409bd1ca$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $9279dd71409bd1ca$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $9279dd71409bd1ca$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $d986def031c832c2$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $9279dd71409bd1ca$export$cbdd6b3d40ea54e2)(generator), (0, $9279dd71409bd1ca$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(duration)
    };
}


function $751c446f48fe0e49$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}



function $e415b4a6e51179a7$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}


class $294d1bcdbc1b4337$export$a361fbe706f8c9b {
    constructor(animation){
        this.animation = animation;
    }
    get duration() {
        var _a, _b, _c;
        const durationInMs = ((_b = (_a = this.animation) === null || _a === void 0 ? void 0 : _a.effect) === null || _b === void 0 ? void 0 : _b.getComputedTiming().duration) || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.duration) || 300;
        return (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(Number(durationInMs));
    }
    get time() {
        var _a;
        if (this.animation) return (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(((_a = this.animation) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
        return 0;
    }
    set time(newTime) {
        if (this.animation) this.animation.currentTime = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        return this.animation ? this.animation.playbackRate : 1;
    }
    set speed(newSpeed) {
        if (this.animation) this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.animation ? this.animation.playState : "finished";
    }
    get startTime() {
        return this.animation ? this.animation.startTime : null;
    }
    get finished() {
        return this.animation ? this.animation.finished : Promise.resolve();
    }
    play() {
        this.animation && this.animation.play();
    }
    pause() {
        this.animation && this.animation.pause();
    }
    stop() {
        if (!this.animation || this.state === "idle" || this.state === "finished") return;
        if (this.animation.commitStyles) this.animation.commitStyles();
        this.cancel();
    }
    flatten() {
        var _a;
        if (!this.animation) return;
        (_a = this.animation.effect) === null || _a === void 0 || _a.updateTiming({
            easing: "linear"
        });
    }
    attachTimeline(timeline) {
        if (this.animation) (0, $e415b4a6e51179a7$export$5bd0fcbc73622e13)(this.animation, timeline);
        return 0, $be2f5e64a7ccd429$export$8793edee2d425525;
    }
    complete() {
        this.animation && this.animation.finish();
    }
    cancel() {
        try {
            this.animation && this.animation.cancel();
        } catch (e) {}
    }
}



const $2489647a72ea70b7$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $678f630a94e07725$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $8cfefe440a88cf7f$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $f8d8880916c6001a$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $678f630a94e07725$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $50e3e7ace9a0414e$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $8cfefe440a88cf7f$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $bbbfb09cca4264d9$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $7e55285dc4fb4246$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


function $1f20805368abd6f9$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $50e3e7ace9a0414e$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $1f20805368abd6f9$export$2cf569f5e2221176 || (0, $50e3e7ace9a0414e$export$866c1d07a1ac2ab)()) || (0, $2489647a72ea70b7$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($1f20805368abd6f9$export$fcdd8f3f2160beda));
}
const $1f20805368abd6f9$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $1f20805368abd6f9$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $1f20805368abd6f9$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $1f20805368abd6f9$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $1f20805368abd6f9$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $1f20805368abd6f9$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $1f20805368abd6f9$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $50e3e7ace9a0414e$export$866c1d07a1ac2ab)()) return (0, $bbbfb09cca4264d9$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $2489647a72ea70b7$export$ff43f99925d7366b)(easing)) return $1f20805368abd6f9$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$1f20805368abd6f9$export$916ea73bcd3a6030(segmentEasing, duration) || $1f20805368abd6f9$export$2cf569f5e2221176.easeOut);
    else return $1f20805368abd6f9$export$2cf569f5e2221176[easing];
}



const $2437bc029e9e9507$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $2437bc029e9e9507$export$1b3dd616664938e4() {
    return $2437bc029e9e9507$export$9e9bc3c487fccc00.x || $2437bc029e9e9507$export$9e9bc3c487fccc00.y;
}


function $156c90b4dd60898c$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof Element) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $2b05eddb8f0cf190$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $156c90b4dd60898c$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $7b2a1b2aa9f9d6b6$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $2437bc029e9e9507$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $7b2a1b2aa9f9d6b6$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $2b05eddb8f0cf190$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$7b2a1b2aa9f9d6b6$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$7b2a1b2aa9f9d6b6$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $4d3163751dcc0f19$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $4d3163751dcc0f19$export$e841ada32ff745b(parent, child.parentElement);
};


const $6f06c5465a0b6cc0$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};



const $30b4621d79241784$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $30b4621d79241784$export$5f6976e2f961e8b7(element) {
    return $30b4621d79241784$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $45159deca0aa449e$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $e86a3a042fafc775$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $e86a3a042fafc775$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $e86a3a042fafc775$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $e86a3a042fafc775$var$filterEvents(()=>{
        if ((0, $45159deca0aa449e$export$7987404a4e35b84b).has(element)) return;
        $e86a3a042fafc775$var$firePointerEvent(element, "down");
        const handleKeyup = $e86a3a042fafc775$var$filterEvents(()=>{
            $e86a3a042fafc775$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$e86a3a042fafc775$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $6aa7a829ec9e3e84$var$isValidPressEvent(event) {
    return (0, $6f06c5465a0b6cc0$export$a4cf9c8a4b063a6e)(event) && !(0, $2437bc029e9e9507$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $6aa7a829ec9e3e84$export$dbe9198142dace0c(elementOrSelector, onPressStart, options = {}) {
    const [elements, eventOptions, cancelEvents] = (0, $2b05eddb8f0cf190$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const startPress = (startEvent)=>{
        const element = startEvent.currentTarget;
        if (!$6aa7a829ec9e3e84$var$isValidPressEvent(startEvent) || (0, $45159deca0aa449e$export$7987404a4e35b84b).has(element)) return;
        (0, $45159deca0aa449e$export$7987404a4e35b84b).add(element);
        const onPressEnd = onPressStart(element, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$6aa7a829ec9e3e84$var$isValidPressEvent(endEvent) || !(0, $45159deca0aa449e$export$7987404a4e35b84b).has(element)) return;
            (0, $45159deca0aa449e$export$7987404a4e35b84b).delete(element);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, options.useGlobalTarget || (0, $4d3163751dcc0f19$export$e841ada32ff745b)(element, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    elements.forEach((element)=>{
        if (!(0, $30b4621d79241784$export$5f6976e2f961e8b7)(element) && element.getAttribute("tabindex") === null) element.tabIndex = 0;
        const target = options.useGlobalTarget ? window : element;
        target.addEventListener("pointerdown", startPress, eventOptions);
        element.addEventListener("focus", (event)=>(0, $e86a3a042fafc775$export$4b5790288fe12a79)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}


















const $7c18b9786dd185bc$var$defaultEasing = "easeOut";
function $7c18b9786dd185bc$export$a31269144d66b4a(options) {
    var _a;
    if ((0, $751c446f48fe0e49$export$6ab7812f1bac68be)(options.type)) {
        const generatorOptions = (0, $d986def031c832c2$export$7f1511d09ee75a99)(options, 100, options.type);
        options.ease = (0, $50e3e7ace9a0414e$export$866c1d07a1ac2ab)() ? generatorOptions.ease : $7c18b9786dd185bc$var$defaultEasing;
        options.duration = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
        options.type = "keyframes";
    } else {
        options.duration = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)((_a = options.duration) !== null && _a !== void 0 ? _a : 0.3);
        options.ease = options.ease || $7c18b9786dd185bc$var$defaultEasing;
    }
}
// TODO: Reuse for NativeAnimation
function $7c18b9786dd185bc$export$f837a3b7321adfa5(valueName, keyframes, options) {
    var _a;
    const nativeKeyframes = {};
    const nativeOptions = {
        fill: "both",
        easing: "linear",
        composite: "replace"
    };
    nativeOptions.delay = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)((_a = options.delay) !== null && _a !== void 0 ? _a : 0);
    $7c18b9786dd185bc$export$a31269144d66b4a(options);
    nativeOptions.duration = options.duration;
    const { ease: ease, times: times } = options;
    if (times) nativeKeyframes.offset = times;
    nativeKeyframes[valueName] = keyframes;
    const easing = (0, $1f20805368abd6f9$export$916ea73bcd3a6030)(ease, options.duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) nativeKeyframes.easing = easing;
    else nativeOptions.easing = easing;
    return {
        keyframes: nativeKeyframes,
        options: nativeOptions
    };
}


class $685c3706cf977d7c$export$bd39eb4d1b05262c extends (0, $294d1bcdbc1b4337$export$a361fbe706f8c9b) {
    constructor(target, pseudoElement, valueName, keyframes, options){
        const animationOptions = (0, $7c18b9786dd185bc$export$f837a3b7321adfa5)(valueName, keyframes, options);
        const animation = target.animate(animationOptions.keyframes, {
            pseudoElement: pseudoElement,
            ...animationOptions.options
        });
        super(animation);
    }
}




function $2d5bb4cf9ebedd00$export$f156731db478ee9e(valueName) {
    if (valueName === "layout") return "group";
    if (valueName === "enter" || valueName === "new") return "new";
    if (valueName === "exit" || valueName === "old") return "old";
    return "group";
}


let $d903761c0e5cd4aa$var$pendingRules = {};
let $d903761c0e5cd4aa$var$style = null;
const $d903761c0e5cd4aa$export$dbf350e5966cf602 = {
    set: (selector, values)=>{
        $d903761c0e5cd4aa$var$pendingRules[selector] = values;
    },
    commit: ()=>{
        if (!$d903761c0e5cd4aa$var$style) {
            $d903761c0e5cd4aa$var$style = document.createElement("style");
            $d903761c0e5cd4aa$var$style.id = "motion-view";
        }
        let cssText = "";
        for(const selector in $d903761c0e5cd4aa$var$pendingRules){
            const rule = $d903761c0e5cd4aa$var$pendingRules[selector];
            cssText += `${selector} {\n`;
            for (const [property, value] of Object.entries(rule))cssText += `  ${property}: ${value};\n`;
            cssText += "}\n";
        }
        $d903761c0e5cd4aa$var$style.textContent = cssText;
        document.head.appendChild($d903761c0e5cd4aa$var$style);
        $d903761c0e5cd4aa$var$pendingRules = {};
    },
    remove: ()=>{
        if ($d903761c0e5cd4aa$var$style && $d903761c0e5cd4aa$var$style.parentElement) $d903761c0e5cd4aa$var$style.parentElement.removeChild($d903761c0e5cd4aa$var$style);
    }
};


function $8f4bd386406906ed$export$318a4a45ce9f2d6a(pseudoElement) {
    const match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
    if (!match) return null;
    return {
        layer: match[2],
        type: match[1]
    };
}


function $ed422bf370f501ec$var$filterViewAnimations(animation) {
    var _a;
    const { effect: effect } = animation;
    if (!effect) return false;
    return effect.target === document.documentElement && ((_a = effect.pseudoElement) === null || _a === void 0 ? void 0 : _a.startsWith("::view-transition"));
}
function $ed422bf370f501ec$export$8d6316dd934b3f3b() {
    return document.getAnimations().filter($ed422bf370f501ec$var$filterViewAnimations);
}


function $c54c3e093757cc11$export$cb29cf2b8e0a8ae1(target, targets) {
    return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}


const $c2e4b98fb4a00f11$var$definitionNames = [
    "layout",
    "enter",
    "exit",
    "new",
    "old"
];
function $c2e4b98fb4a00f11$export$43cd2edcbb51216c(update, defaultOptions, targets) {
    if (!document.startViewTransition) return new Promise(async (resolve)=>{
        await update();
        resolve(new (0, $f240d29771bba8c3$export$4d0c371993b9283e)([]));
    });
    // TODO: Go over existing targets and ensure they all have ids
    /**
     * If we don't have any animations defined for the root target,
     * remove it from being captured.
     */ if (!(0, $c54c3e093757cc11$export$cb29cf2b8e0a8ae1)("root", targets)) (0, $d903761c0e5cd4aa$export$dbf350e5966cf602).set(":root", {
        "view-transition-name": "none"
    });
    /**
     * Set the timing curve to linear for all view transition layers.
     * This gets baked into the keyframes, which can't be changed
     * without breaking the generated animation.
     *
     * This allows us to set easing via updateTiming - which can be changed.
     */ (0, $d903761c0e5cd4aa$export$dbf350e5966cf602).set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
        "animation-timing-function": "linear !important"
    });
    (0, $d903761c0e5cd4aa$export$dbf350e5966cf602).commit(); // Write
    const transition = document.startViewTransition(async ()=>{
        await update();
    // TODO: Go over new targets and ensure they all have ids
    });
    transition.finished.finally(()=>{
        (0, $d903761c0e5cd4aa$export$dbf350e5966cf602).remove(); // Write
    });
    return new Promise((resolve)=>{
        transition.ready.then(()=>{
            var _a;
            const generatedViewAnimations = (0, $ed422bf370f501ec$export$8d6316dd934b3f3b)();
            const animations = [];
            /**
             * Create animations for our definitions
             */ targets.forEach((definition, target)=>{
                // TODO: If target is not "root", resolve elements
                // and iterate over each
                for (const key of $c2e4b98fb4a00f11$var$definitionNames){
                    if (!definition[key]) continue;
                    const { keyframes: keyframes, options: options } = definition[key];
                    for (let [valueName, valueKeyframes] of Object.entries(keyframes)){
                        if (!valueKeyframes) continue;
                        const valueOptions = {
                            ...(0, $2d0bcc80dbf59ef8$export$7c1391340308742e)(defaultOptions, valueName),
                            ...(0, $2d0bcc80dbf59ef8$export$7c1391340308742e)(options, valueName)
                        };
                        const type = (0, $2d5bb4cf9ebedd00$export$f156731db478ee9e)(key);
                        /**
                         * If this is an opacity animation, and keyframes are not an array,
                         * we need to convert them into an array and set an initial value.
                         */ if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                            const initialValue = type === "new" ? 0 : 1;
                            valueKeyframes = [
                                initialValue,
                                valueKeyframes
                            ];
                        }
                        /**
                         * Resolve stagger function if provided.
                         */ if (typeof valueOptions.delay === "function") valueOptions.delay = valueOptions.delay(0, 1);
                        const animation = new (0, $685c3706cf977d7c$export$bd39eb4d1b05262c)(document.documentElement, `::view-transition-${type}(${target})`, valueName, valueKeyframes, valueOptions);
                        animations.push(animation);
                    }
                }
            });
            /**
             * Handle browser generated animations
             */ for (const animation of generatedViewAnimations){
                if (animation.playState === "finished") continue;
                const { effect: effect } = animation;
                if (!effect || !(effect instanceof KeyframeEffect)) continue;
                const { pseudoElement: pseudoElement } = effect;
                if (!pseudoElement) continue;
                const name = (0, $8f4bd386406906ed$export$318a4a45ce9f2d6a)(pseudoElement);
                if (!name) continue;
                const targetDefinition = targets.get(name.layer);
                if (!targetDefinition) {
                    /**
                     * If transition name is group then update the timing of the animation
                     * whereas if it's old or new then we could possibly replace it using
                     * the above method.
                     */ const transitionName = name.type === "group" ? "layout" : "";
                    const animationTransition = {
                        ...(0, $2d0bcc80dbf59ef8$export$7c1391340308742e)(defaultOptions, transitionName)
                    };
                    (0, $7c18b9786dd185bc$export$a31269144d66b4a)(animationTransition);
                    const easing = (0, $1f20805368abd6f9$export$916ea73bcd3a6030)(animationTransition.ease, animationTransition.duration);
                    effect.updateTiming({
                        delay: (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)((_a = animationTransition.delay) !== null && _a !== void 0 ? _a : 0),
                        duration: animationTransition.duration,
                        easing: easing
                    });
                    animations.push(new (0, $294d1bcdbc1b4337$export$a361fbe706f8c9b)(animation));
                } else if ($c2e4b98fb4a00f11$var$hasOpacity(targetDefinition, "enter") && $c2e4b98fb4a00f11$var$hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some((keyframe)=>keyframe.mixBlendMode)) animations.push(new (0, $294d1bcdbc1b4337$export$a361fbe706f8c9b)(animation));
                else animation.cancel();
            }
            resolve(new (0, $f240d29771bba8c3$export$4d0c371993b9283e)(animations));
        });
    });
}
function $c2e4b98fb4a00f11$var$hasOpacity(target, key) {
    var _a;
    return (_a = target === null || target === void 0 ? void 0 : target[key]) === null || _a === void 0 ? void 0 : _a.keyframes.opacity;
}


/**
 * TODO:
 * - Create view transition on next tick
 * - Replace animations with Motion animations
 * - Return GroupAnimation on next tick
 */ class $ac4d7cb58d8ff625$export$a25c8c3ef5e625d7 {
    constructor(update, options = {}){
        this.currentTarget = "root";
        this.targets = new Map();
        this.notifyReady = (0, $be2f5e64a7ccd429$export$8793edee2d425525);
        this.readyPromise = new Promise((resolve)=>{
            this.notifyReady = resolve;
        });
        queueMicrotask(()=>{
            (0, $c2e4b98fb4a00f11$export$43cd2edcbb51216c)(update, options, this.targets).then((animation)=>this.notifyReady(animation));
        });
    }
    get(selector) {
        this.currentTarget = selector;
        return this;
    }
    layout(keyframes, options) {
        this.updateTarget("layout", keyframes, options);
        return this;
    }
    new(keyframes, options) {
        this.updateTarget("new", keyframes, options);
        return this;
    }
    old(keyframes, options) {
        this.updateTarget("old", keyframes, options);
        return this;
    }
    enter(keyframes, options) {
        this.updateTarget("enter", keyframes, options);
        return this;
    }
    exit(keyframes, options) {
        this.updateTarget("exit", keyframes, options);
        return this;
    }
    crossfade(options) {
        this.updateTarget("enter", {
            opacity: 1
        }, options);
        this.updateTarget("exit", {
            opacity: 0
        }, options);
        return this;
    }
    updateTarget(target, keyframes, options = {}) {
        const { currentTarget: currentTarget, targets: targets } = this;
        if (!targets.has(currentTarget)) targets.set(currentTarget, {});
        const targetData = targets.get(currentTarget);
        targetData[target] = {
            keyframes: keyframes,
            options: options
        };
    }
    then(resolve, reject) {
        return this.readyPromise.then(resolve, reject);
    }
}
function $ac4d7cb58d8ff625$export$c4ddc81c7b2c8d7a(update, defaultOptions = {}) {
    return new $ac4d7cb58d8ff625$export$a25c8c3ef5e625d7(update, defaultOptions);
}




function $e225970da3a726ba$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $2437bc029e9e9507$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $2437bc029e9e9507$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $2437bc029e9e9507$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $2437bc029e9e9507$export$9e9bc3c487fccc00).x || (0, $2437bc029e9e9507$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $2437bc029e9e9507$export$9e9bc3c487fccc00).x = (0, $2437bc029e9e9507$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $2437bc029e9e9507$export$9e9bc3c487fccc00).x = (0, $2437bc029e9e9507$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}






/**
 * Generate a list of every possible transform key.
 */ const $fc041f46f20bc48a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $fc041f46f20bc48a$export$7b42a0094fb00b6e = new Set($fc041f46f20bc48a$export$280dc01950909d86);


const $942f92558e91a7c6$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $fc041f46f20bc48a$export$280dc01950909d86)
]);



const $4762b82c41844aa9$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $4762b82c41844aa9$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $2a4adbe79caa98d1$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


const $9953ced6ae4c074f$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};




function $9648cf1b9105475e$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $7ee971e48c80a55c$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $7ee971e48c80a55c$var$maxElapsed = 40;
function $7ee971e48c80a55c$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $7ee971e48c80a55c$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $9648cf1b9105475e$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $9953ced6ae4c074f$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $7ee971e48c80a55c$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $7ee971e48c80a55c$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $7ee971e48c80a55c$export$71ecace0a033b35a.length; i++)steps[$7ee971e48c80a55c$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $9d7087d3809d752e$export$2cef06c20297c17d, cancel: $9d7087d3809d752e$export$ec99c0ef4978dccb, state: $9d7087d3809d752e$export$fff89137e9e818ce, steps: $9d7087d3809d752e$export$1811c3a7e3af92f0 } = (0, $7ee971e48c80a55c$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $be2f5e64a7ccd429$export$8793edee2d425525), true);


let $227990d67307f8fb$var$now;
function $227990d67307f8fb$var$clearTime() {
    $227990d67307f8fb$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $227990d67307f8fb$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($227990d67307f8fb$var$now === undefined) $227990d67307f8fb$export$2da9be4cfdb689b1.set((0, $9d7087d3809d752e$export$fff89137e9e818ce).isProcessing || (0, $9953ced6ae4c074f$export$dd826089e3c5e502).useManualTiming ? (0, $9d7087d3809d752e$export$fff89137e9e818ce).timestamp : performance.now());
        return $227990d67307f8fb$var$now;
    },
    set: (newTime)=>{
        $227990d67307f8fb$var$now = newTime;
        queueMicrotask($227990d67307f8fb$var$clearTime);
    }
};


function $2511eca7c95e7f14$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $2511eca7c95e7f14$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $2511eca7c95e7f14$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $5d38c151e66a32e7$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $2511eca7c95e7f14$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $2511eca7c95e7f14$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $b3329276cfa0aa25$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $b2e05bc8f4e46155$var$MAX_VELOCITY_DELTA = 30;
const $b2e05bc8f4e46155$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $b2e05bc8f4e46155$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $b2e05bc8f4e46155$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "12.0.6";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $b2e05bc8f4e46155$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        (0, $b6eedd81c035e31f$export$5b28268982f175ba)(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $5d38c151e66a32e7$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $9d7087d3809d752e$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($b2e05bc8f4e46155$export$67fcd818a264039d.current) $b2e05bc8f4e46155$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $b2e05bc8f4e46155$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $b2e05bc8f4e46155$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $b3329276cfa0aa25$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $b2e05bc8f4e46155$export$ce8bdc721e76545f(init, options) {
    return new $b2e05bc8f4e46155$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $2ce8e6a4c5bb6165$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $b2e05bc8f4e46155$export$ce8bdc721e76545f)(value));
}
function $2ce8e6a4c5bb6165$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $24cfcff025c1c09b$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $4762b82c41844aa9$export$5485128c47bd48bb)(target[key]);
        $2ce8e6a4c5bb6165$var$setMotionValue(visualElement, key, value);
    }
}


const $eb312d786dbb7f8f$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $8f36ba918315d400$export$98397f3adbf6259f(value) {
    return Boolean((0, $eb312d786dbb7f8f$export$605d60a2578142d3)(value) && value.add);
}


function $3567723abf70a4dd$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $8f36ba918315d400$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}


/**
 * Convert camelCase to dash-case properties.
 */ const $f22278e68b5dea09$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $ebd1a822610f6e94$export$ed7b8fa9dbf0105d = "framerAppearId";
const $ebd1a822610f6e94$export$8592e1c077c890a6 = "data-" + (0, $f22278e68b5dea09$export$9fd24a634729c672)($ebd1a822610f6e94$export$ed7b8fa9dbf0105d);


function $73b318b85a09107f$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $ebd1a822610f6e94$export$8592e1c077c890a6];
}






const $06a833acceb929a8$export$888a3d84909f9e3d = {
    current: false
};





/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $69ed2f0849390df7$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $69ed2f0849390df7$var$subdivisionPrecision = 0.0000001;
const $69ed2f0849390df7$var$subdivisionMaxIterations = 12;
function $69ed2f0849390df7$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $69ed2f0849390df7$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $69ed2f0849390df7$var$subdivisionPrecision && ++i < $69ed2f0849390df7$var$subdivisionMaxIterations);
    return currentT;
}
function $69ed2f0849390df7$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $be2f5e64a7ccd429$export$8793edee2d425525;
    const getTForX = (aX)=>$69ed2f0849390df7$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $69ed2f0849390df7$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $8ea7c0c3eb728621$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $4167f6559232f870$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $167de2db942225a4$export$77edfce482316a60 = /*@__PURE__*/ (0, $69ed2f0849390df7$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $167de2db942225a4$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $4167f6559232f870$export$2c07eeff45156d4d)($167de2db942225a4$export$77edfce482316a60);
const $167de2db942225a4$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $8ea7c0c3eb728621$export$f946554fb8aeaf0d)($167de2db942225a4$export$b01116c84cdfe1a2);


const $157b7359664dc397$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $167de2db942225a4$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $3d4a3fe7598f131d$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $3d4a3fe7598f131d$export$c8d67a19199d1a50 = (0, $4167f6559232f870$export$2c07eeff45156d4d)($3d4a3fe7598f131d$export$e444123e42d03385);
const $3d4a3fe7598f131d$export$30d3455eee55bed5 = (0, $8ea7c0c3eb728621$export$f946554fb8aeaf0d)($3d4a3fe7598f131d$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $90a2a425120fc644$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $2fdf5a19511742a9$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $90a2a425120fc644$export$ade84c85e44a6cb1)(value);
    else return true;
}



const $21992eb5ecb495f6$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};



const $3e1e86c56b2c75ab$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $3e1e86c56b2c75ab$export$58f0f39f63f3cf42 = {
    ...$3e1e86c56b2c75ab$export$98e628dec113755e,
    transform: (v)=>(0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $3e1e86c56b2c75ab$export$dcdf75081b88279d = {
    ...$3e1e86c56b2c75ab$export$98e628dec113755e,
    default: 1
};


// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $29f5aa631edb43f4$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $f4141d738fdcbc46$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $a8ddeddf6449d62e$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $9ade0e65d06e6eab$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $65284eb4b04be268$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $9ade0e65d06e6eab$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $a8ddeddf6449d62e$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $65284eb4b04be268$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $f4141d738fdcbc46$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $9eb0edbbf3307e4b$var$clampRgbUnit = (v)=>(0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)(0, 255, v);
const $9eb0edbbf3307e4b$export$7a99c86b5b1f4c9e = {
    ...(0, $3e1e86c56b2c75ab$export$98e628dec113755e),
    transform: (v)=>Math.round($9eb0edbbf3307e4b$var$clampRgbUnit(v))
};
const $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $65284eb4b04be268$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $65284eb4b04be268$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $9eb0edbbf3307e4b$export$7a99c86b5b1f4c9e.transform(red) + ", " + $9eb0edbbf3307e4b$export$7a99c86b5b1f4c9e.transform(green) + ", " + $9eb0edbbf3307e4b$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $29f5aa631edb43f4$export$83d2e9e3e4ee39ed)((0, $3e1e86c56b2c75ab$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $690668af4c1f912f$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $690668af4c1f912f$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $65284eb4b04be268$export$2c8400d58aca05e)("#"),
    parse: $690668af4c1f912f$var$parseHex,
    transform: (0, $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b).transform
};



const $d91d0d96a9341543$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $d91d0d96a9341543$export$41fc368e1a942b97 = /*@__PURE__*/ $d91d0d96a9341543$var$createUnitType("deg");
const $d91d0d96a9341543$export$626336c2cd4b14de = /*@__PURE__*/ $d91d0d96a9341543$var$createUnitType("%");
const $d91d0d96a9341543$export$91c0eda1d06bf008 = /*@__PURE__*/ $d91d0d96a9341543$var$createUnitType("px");
const $d91d0d96a9341543$export$f91e8c45a95a32f2 = /*@__PURE__*/ $d91d0d96a9341543$var$createUnitType("vh");
const $d91d0d96a9341543$export$aed3d7b7d206c196 = /*@__PURE__*/ $d91d0d96a9341543$var$createUnitType("vw");
const $d91d0d96a9341543$export$44e2e1705876d7ed = {
    ...$d91d0d96a9341543$export$626336c2cd4b14de,
    parse: (v)=>$d91d0d96a9341543$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$d91d0d96a9341543$export$626336c2cd4b14de.transform(v * 100)
};




const $c582c2b55c740bb9$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $65284eb4b04be268$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $65284eb4b04be268$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $d91d0d96a9341543$export$626336c2cd4b14de).transform((0, $29f5aa631edb43f4$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $d91d0d96a9341543$export$626336c2cd4b14de).transform((0, $29f5aa631edb43f4$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $29f5aa631edb43f4$export$83d2e9e3e4ee39ed)((0, $3e1e86c56b2c75ab$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $de797567df6f757a$export$35e9368ef982300f = {
    test: (v)=>(0, $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b).test(v) || (0, $690668af4c1f912f$export$834dfc94dde4b3d8).test(v) || (0, $c582c2b55c740bb9$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b).test(v)) return (0, $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $c582c2b55c740bb9$export$810b04175080204c).test(v)) return (0, $c582c2b55c740bb9$export$810b04175080204c).parse(v);
        else return (0, $690668af4c1f912f$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b).transform(v) : (0, $c582c2b55c740bb9$export$810b04175080204c).transform(v);
    }
};


const $aaac0d56a67267b0$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $0d4e88e0fd805935$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $f4141d738fdcbc46$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $aaac0d56a67267b0$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $0d4e88e0fd805935$var$NUMBER_TOKEN = "number";
const $0d4e88e0fd805935$var$COLOR_TOKEN = "color";
const $0d4e88e0fd805935$var$VAR_TOKEN = "var";
const $0d4e88e0fd805935$var$VAR_FUNCTION_TOKEN = "var(";
const $0d4e88e0fd805935$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $0d4e88e0fd805935$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $0d4e88e0fd805935$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($0d4e88e0fd805935$var$complexRegex, (parsedValue)=>{
        if ((0, $de797567df6f757a$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($0d4e88e0fd805935$var$COLOR_TOKEN);
            values.push((0, $de797567df6f757a$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($0d4e88e0fd805935$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($0d4e88e0fd805935$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($0d4e88e0fd805935$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $0d4e88e0fd805935$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($0d4e88e0fd805935$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $0d4e88e0fd805935$var$parseComplexValue(v) {
    return $0d4e88e0fd805935$export$b61fc7c44bf646d5(v).values;
}
function $0d4e88e0fd805935$var$createTransformer(source) {
    const { split: split, types: types } = $0d4e88e0fd805935$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $0d4e88e0fd805935$var$NUMBER_TOKEN) output += (0, $29f5aa631edb43f4$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $0d4e88e0fd805935$var$COLOR_TOKEN) output += (0, $de797567df6f757a$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $0d4e88e0fd805935$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $0d4e88e0fd805935$var$getAnimatableNone(v) {
    const parsed = $0d4e88e0fd805935$var$parseComplexValue(v);
    const transformer = $0d4e88e0fd805935$var$createTransformer(v);
    return transformer(parsed.map($0d4e88e0fd805935$var$convertNumbersToZero));
}
const $0d4e88e0fd805935$export$83a0e34f1302825b = {
    test: $0d4e88e0fd805935$var$test,
    parse: $0d4e88e0fd805935$var$parseComplexValue,
    createTransformer: $0d4e88e0fd805935$var$createTransformer,
    getAnimatableNone: $0d4e88e0fd805935$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $4be6735dd2a1cfbe$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $4be6735dd2a1cfbe$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $f4141d738fdcbc46$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $4be6735dd2a1cfbe$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $4be6735dd2a1cfbe$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $4be6735dd2a1cfbe$export$3dea766d36a8935f = {
    ...(0, $0d4e88e0fd805935$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($4be6735dd2a1cfbe$var$functionRegex);
        return functions ? functions.map($4be6735dd2a1cfbe$var$applyDefaultFilter).join(" ") : v;
    }
};







const $5dcd767a0e85626a$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderTopWidth: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderRightWidth: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderRadius: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    radius: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    maxWidth: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    height: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    maxHeight: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    top: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    right: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    bottom: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    left: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    paddingTop: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    paddingRight: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    paddingBottom: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    paddingLeft: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    margin: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    marginTop: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    marginRight: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    marginBottom: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    marginLeft: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $d91d0d96a9341543$export$91c0eda1d06bf008)
};




const $2742969512628b55$export$f2e4285fee37e26 = {
    rotate: (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    rotateX: (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    rotateY: (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    rotateZ: (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    scale: $3e1e86c56b2c75ab$export$dcdf75081b88279d,
    scaleX: (0, $3e1e86c56b2c75ab$export$dcdf75081b88279d),
    scaleY: (0, $3e1e86c56b2c75ab$export$dcdf75081b88279d),
    scaleZ: (0, $3e1e86c56b2c75ab$export$dcdf75081b88279d),
    skew: (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    skewX: (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    skewY: (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    distance: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    translateX: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    translateY: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    translateZ: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    x: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    y: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    z: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    perspective: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    transformPerspective: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    opacity: (0, $3e1e86c56b2c75ab$export$58f0f39f63f3cf42),
    originX: (0, $d91d0d96a9341543$export$44e2e1705876d7ed),
    originY: (0, $d91d0d96a9341543$export$44e2e1705876d7ed),
    originZ: (0, $d91d0d96a9341543$export$91c0eda1d06bf008)
};



const $782577a81ce4d871$export$7d260a2a5f8bc19e = {
    ...(0, $3e1e86c56b2c75ab$export$98e628dec113755e),
    transform: Math.round
};


const $101bef5fa6551d53$export$eec14432cd1cb67b = {
    ...(0, $5dcd767a0e85626a$export$2fb74b0a4e7d7c4a),
    ...(0, $2742969512628b55$export$f2e4285fee37e26),
    zIndex: (0, $782577a81ce4d871$export$7d260a2a5f8bc19e),
    size: (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $3e1e86c56b2c75ab$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $3e1e86c56b2c75ab$export$58f0f39f63f3cf42),
    numOctaves: (0, $782577a81ce4d871$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $5822abf9a95fd029$export$98cd7c72c5a731fb = {
    ...(0, $101bef5fa6551d53$export$eec14432cd1cb67b),
    color: // Color props
    $de797567df6f757a$export$35e9368ef982300f,
    backgroundColor: (0, $de797567df6f757a$export$35e9368ef982300f),
    outlineColor: (0, $de797567df6f757a$export$35e9368ef982300f),
    fill: (0, $de797567df6f757a$export$35e9368ef982300f),
    stroke: (0, $de797567df6f757a$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $de797567df6f757a$export$35e9368ef982300f),
    borderTopColor: (0, $de797567df6f757a$export$35e9368ef982300f),
    borderRightColor: (0, $de797567df6f757a$export$35e9368ef982300f),
    borderBottomColor: (0, $de797567df6f757a$export$35e9368ef982300f),
    borderLeftColor: (0, $de797567df6f757a$export$35e9368ef982300f),
    filter: $4be6735dd2a1cfbe$export$3dea766d36a8935f,
    WebkitFilter: (0, $4be6735dd2a1cfbe$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $5822abf9a95fd029$export$67d1babe0338d23b = (key)=>$5822abf9a95fd029$export$98cd7c72c5a731fb[key];


function $7ae1f0746541b9f1$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5822abf9a95fd029$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $4be6735dd2a1cfbe$export$3dea766d36a8935f)) defaultValueType = (0, $0d4e88e0fd805935$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $f359220a74263832$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $f359220a74263832$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$f359220a74263832$var$invalidTemplates.has(keyframe) && (0, $0d4e88e0fd805935$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $7ae1f0746541b9f1$export$cea0cedcb94873b5)(name, animatableTemplate);
}





const $a6d7abe24216fe93$export$8e5250d1aa9bf370 = (v)=>v === (0, $3e1e86c56b2c75ab$export$98e628dec113755e) || v === (0, $d91d0d96a9341543$export$91c0eda1d06bf008);
const $a6d7abe24216fe93$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a6d7abe24216fe93$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $a6d7abe24216fe93$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $a6d7abe24216fe93$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a6d7abe24216fe93$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a6d7abe24216fe93$var$nonTranslationalTransformKeys = (0, $fc041f46f20bc48a$export$280dc01950909d86).filter((key)=>!$a6d7abe24216fe93$var$transformKeys.has(key));
function $a6d7abe24216fe93$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $a6d7abe24216fe93$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $a6d7abe24216fe93$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a6d7abe24216fe93$var$getTranslateFromMatrix(4, 13),
    y: $a6d7abe24216fe93$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a6d7abe24216fe93$export$781d46a8aa670d52.translateX = $a6d7abe24216fe93$export$781d46a8aa670d52.x;
$a6d7abe24216fe93$export$781d46a8aa670d52.translateY = $a6d7abe24216fe93$export$781d46a8aa670d52.y;



const $40a3c5fe745b0c32$var$toResolve = new Set();
let $40a3c5fe745b0c32$var$isScheduled = false;
let $40a3c5fe745b0c32$var$anyNeedsMeasurement = false;
function $40a3c5fe745b0c32$var$measureAllKeyframes() {
    if ($40a3c5fe745b0c32$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($40a3c5fe745b0c32$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $a6d7abe24216fe93$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $40a3c5fe745b0c32$var$anyNeedsMeasurement = false;
    $40a3c5fe745b0c32$var$isScheduled = false;
    $40a3c5fe745b0c32$var$toResolve.forEach((resolver)=>resolver.complete());
    $40a3c5fe745b0c32$var$toResolve.clear();
}
function $40a3c5fe745b0c32$var$readAllKeyframes() {
    $40a3c5fe745b0c32$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $40a3c5fe745b0c32$var$anyNeedsMeasurement = true;
    });
}
function $40a3c5fe745b0c32$export$78b96d2a12593b05() {
    $40a3c5fe745b0c32$var$readAllKeyframes();
    $40a3c5fe745b0c32$var$measureAllKeyframes();
}
class $40a3c5fe745b0c32$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $40a3c5fe745b0c32$var$toResolve.add(this);
            if (!$40a3c5fe745b0c32$var$isScheduled) {
                $40a3c5fe745b0c32$var$isScheduled = true;
                (0, $9d7087d3809d752e$export$2cef06c20297c17d).read($40a3c5fe745b0c32$var$readAllKeyframes);
                (0, $9d7087d3809d752e$export$2cef06c20297c17d).resolveKeyframes($40a3c5fe745b0c32$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $40a3c5fe745b0c32$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $40a3c5fe745b0c32$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $a935c15e93c92110$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $f01a1c5aa832e546$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f01a1c5aa832e546$export$9de1236619d9e756 = /*@__PURE__*/ $f01a1c5aa832e546$var$checkStringStartsWith("--");
const $f01a1c5aa832e546$var$startsAsVariableToken = /*@__PURE__*/ $f01a1c5aa832e546$var$checkStringStartsWith("var(--");
const $f01a1c5aa832e546$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $f01a1c5aa832e546$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $f01a1c5aa832e546$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $f01a1c5aa832e546$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $a5ab8ecac8582aa6$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $a5ab8ecac8582aa6$export$b9f0c1f373aee2b0(current) {
    const match = $a5ab8ecac8582aa6$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $a5ab8ecac8582aa6$var$maxDepth = 4;
function $a5ab8ecac8582aa6$export$289398774300c991(current, element, depth = 1) {
    (0, $7683130a8f946b90$export$f5708dca728d7177)(depth <= $a5ab8ecac8582aa6$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $a5ab8ecac8582aa6$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $a935c15e93c92110$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $f01a1c5aa832e546$export$31f9caa2600b5723)(fallback) ? $a5ab8ecac8582aa6$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






/**
 * Tests a provided value against a ValueType
 */ const $ae33ef0146ce940f$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $0d89790f37e7517c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $f2793236b62813ee$export$d176691c1998a1f5 = [
    (0, $3e1e86c56b2c75ab$export$98e628dec113755e),
    (0, $d91d0d96a9341543$export$91c0eda1d06bf008),
    (0, $d91d0d96a9341543$export$626336c2cd4b14de),
    (0, $d91d0d96a9341543$export$41fc368e1a942b97),
    (0, $d91d0d96a9341543$export$aed3d7b7d206c196),
    (0, $d91d0d96a9341543$export$f91e8c45a95a32f2),
    (0, $0d89790f37e7517c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $f2793236b62813ee$export$eefdd52e3ccae428 = (v)=>$f2793236b62813ee$export$d176691c1998a1f5.find((0, $ae33ef0146ce940f$export$6eae4d0a6a7ca7cd)(v));


class $85f37dd878bdb11b$export$4983792d11b61017 extends (0, $40a3c5fe745b0c32$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $f01a1c5aa832e546$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $a5ab8ecac8582aa6$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $942f92558e91a7c6$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $f2793236b62813ee$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $f2793236b62813ee$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $a6d7abe24216fe93$export$8e5250d1aa9bf370)(originType) && (0, $a6d7abe24216fe93$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $2fdf5a19511742a9$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $f359220a74263832$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $a6d7abe24216fe93$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $a6d7abe24216fe93$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}








/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $6a39d8665c5fcd9d$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $0d4e88e0fd805935$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $435930a0064274a5$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $435930a0064274a5$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $6a39d8665c5fcd9d$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $6a39d8665c5fcd9d$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $7683130a8f946b90$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $435930a0064274a5$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $751c446f48fe0e49$export$6ab7812f1bac68be)(type)) && velocity;
}


const $1d0e68b204ae62ec$var$isNotNull = (value)=>value !== null;
function $1d0e68b204ae62ec$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($1d0e68b204ae62ec$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $659d22f5dfcc0d7e$var$MAX_RESOLVE_DELAY = 40;
class $659d22f5dfcc0d7e$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $659d22f5dfcc0d7e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $40a3c5fe745b0c32$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $435930a0064274a5$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $06a833acceb929a8$export$888a3d84909f9e3d).current || !delay) {
                onUpdate && onUpdate((0, $1d0e68b204ae62ec$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete && onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}






/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $b3955344ffb14e7d$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $5fbf6cf90258c6ca$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5fbf6cf90258c6ca$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $5fbf6cf90258c6ca$var$hueToRgb(p, q, hue + 1 / 3);
        green = $5fbf6cf90258c6ca$var$hueToRgb(p, q, hue);
        blue = $5fbf6cf90258c6ca$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $812eae10b840cc46$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $2273ded226e1da5c$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $2273ded226e1da5c$var$colorTypes = [
    (0, $690668af4c1f912f$export$834dfc94dde4b3d8),
    (0, $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b),
    (0, $c582c2b55c740bb9$export$810b04175080204c)
];
const $2273ded226e1da5c$var$getColorType = (v)=>$2273ded226e1da5c$var$colorTypes.find((type)=>type.test(v));
function $2273ded226e1da5c$var$asRGBA(color) {
    const type = $2273ded226e1da5c$var$getColorType(color);
    (0, $7683130a8f946b90$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $c582c2b55c740bb9$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $5fbf6cf90258c6ca$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $2273ded226e1da5c$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $2273ded226e1da5c$var$asRGBA(from);
    const toRGBA = $2273ded226e1da5c$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $812eae10b840cc46$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $2273ded226e1da5c$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $2273ded226e1da5c$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $2273ded226e1da5c$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $9eb0edbbf3307e4b$export$4e46ac54fc82cf3b).transform(blended);
    };
};


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $977c68186cb35a92$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $977c68186cb35a92$export$a4627e546088548d = (...transformers)=>transformers.reduce($977c68186cb35a92$var$combineFunctions);






const $c07625fbae41e021$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $c07625fbae41e021$export$fed62ccc3fb1a568(origin, target) {
    if ($c07625fbae41e021$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $35d2e387d68378ef$var$mixNumber(a, b) {
    return (p)=>(0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $35d2e387d68378ef$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $35d2e387d68378ef$var$mixNumber;
    else if (typeof a === "string") return (0, $f01a1c5aa832e546$export$31f9caa2600b5723)(a) ? (0, $812eae10b840cc46$export$a6f92d4bae65c0f1) : (0, $de797567df6f757a$export$35e9368ef982300f).test(a) ? (0, $2273ded226e1da5c$export$51e568cf5c039bac) : $35d2e387d68378ef$export$65516310a87d8205;
    else if (Array.isArray(a)) return $35d2e387d68378ef$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $de797567df6f757a$export$35e9368ef982300f).test(a) ? (0, $2273ded226e1da5c$export$51e568cf5c039bac) : $35d2e387d68378ef$export$ebc23b6840c51ba1;
    return 0, $812eae10b840cc46$export$a6f92d4bae65c0f1;
}
function $35d2e387d68378ef$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$35d2e387d68378ef$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $35d2e387d68378ef$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $35d2e387d68378ef$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $35d2e387d68378ef$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $35d2e387d68378ef$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $0d4e88e0fd805935$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $0d4e88e0fd805935$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $0d4e88e0fd805935$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $c07625fbae41e021$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $c07625fbae41e021$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $c07625fbae41e021$export$fed62ccc3fb1a568)(origin, target);
        return (0, $977c68186cb35a92$export$a4627e546088548d)($35d2e387d68378ef$export$3bbefa2f402845c4($35d2e387d68378ef$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $7683130a8f946b90$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $812eae10b840cc46$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $9a29d18951b95782$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $35d2e387d68378ef$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}







const $4671034d246a5666$var$velocitySampleDuration = 5; // ms
function $4671034d246a5666$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $4671034d246a5666$var$velocitySampleDuration, 0);
    return (0, $b3329276cfa0aa25$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $87202aadf2407e11$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};





const $668e40b414a49914$var$safeMin = 0.001;
function $668e40b414a49914$export$b15f158dc6d6f458({ duration: duration = (0, $87202aadf2407e11$export$86436497e7b05d16).duration, bounce: bounce = (0, $87202aadf2407e11$export$86436497e7b05d16).bounce, velocity: velocity = (0, $87202aadf2407e11$export$86436497e7b05d16).velocity, mass: mass = (0, $87202aadf2407e11$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $7683130a8f946b90$export$491112666e282270)(duration <= (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)((0, $87202aadf2407e11$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)((0, $87202aadf2407e11$export$86436497e7b05d16).minDamping, (0, $87202aadf2407e11$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)((0, $87202aadf2407e11$export$86436497e7b05d16).minDuration, (0, $87202aadf2407e11$export$86436497e7b05d16).maxDuration, (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $668e40b414a49914$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $668e40b414a49914$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $668e40b414a49914$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $668e40b414a49914$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$668e40b414a49914$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $668e40b414a49914$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $87202aadf2407e11$export$86436497e7b05d16).stiffness,
        damping: (0, $87202aadf2407e11$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $668e40b414a49914$var$rootIterations = 12;
function $668e40b414a49914$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $668e40b414a49914$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $668e40b414a49914$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $8c12560f3b269768$var$durationKeys = [
    "duration",
    "bounce"
];
const $8c12560f3b269768$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $8c12560f3b269768$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $8c12560f3b269768$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $87202aadf2407e11$export$86436497e7b05d16).velocity,
        stiffness: (0, $87202aadf2407e11$export$86436497e7b05d16).stiffness,
        damping: (0, $87202aadf2407e11$export$86436497e7b05d16).damping,
        mass: (0, $87202aadf2407e11$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$8c12560f3b269768$var$isSpringType(options, $8c12560f3b269768$var$physicsKeys) && $8c12560f3b269768$var$isSpringType(options, $8c12560f3b269768$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $87202aadf2407e11$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $668e40b414a49914$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $87202aadf2407e11$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $8c12560f3b269768$export$b36281d89752ae66(optionsOrVisualDuration = (0, $87202aadf2407e11$export$86436497e7b05d16).visualDuration, bounce = (0, $87202aadf2407e11$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $8c12560f3b269768$var$getSpringOptions({
        ...options,
        velocity: -(0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $87202aadf2407e11$export$86436497e7b05d16).restSpeed.granular : (0, $87202aadf2407e11$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $87202aadf2407e11$export$86436497e7b05d16).restDelta.granular : (0, $87202aadf2407e11$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $668e40b414a49914$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $4671034d246a5666$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $9279dd71409bd1ca$export$cbdd6b3d40ea54e2)(generator), (0, $9279dd71409bd1ca$export$f4ff70a5b4808fd8));
            const easing = (0, $bbbfb09cca4264d9$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}



function $54c2f976fdb5413e$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $8c12560f3b269768$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $4671034d246a5666$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $19329cc454786073$export$929e5a82286172a6 = /*@__PURE__*/ (0, $69ed2f0849390df7$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $19329cc454786073$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $69ed2f0849390df7$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $19329cc454786073$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $69ed2f0849390df7$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $821737a815fbd265$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};









const $1abba740ff2c0af9$var$easingLookup = {
    linear: (0, $be2f5e64a7ccd429$export$8793edee2d425525),
    easeIn: $19329cc454786073$export$929e5a82286172a6,
    easeInOut: $19329cc454786073$export$c07234257a03d5e9,
    easeOut: $19329cc454786073$export$57636bb43b1ccbb0,
    circIn: $3d4a3fe7598f131d$export$e444123e42d03385,
    circInOut: $3d4a3fe7598f131d$export$30d3455eee55bed5,
    circOut: $3d4a3fe7598f131d$export$c8d67a19199d1a50,
    backIn: $167de2db942225a4$export$b01116c84cdfe1a2,
    backInOut: $167de2db942225a4$export$ddc5fd596f6c71b2,
    backOut: $167de2db942225a4$export$77edfce482316a60,
    anticipate: $157b7359664dc397$export$6b0af63b873d419e
};
const $1abba740ff2c0af9$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $2489647a72ea70b7$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $7683130a8f946b90$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $69ed2f0849390df7$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $7683130a8f946b90$export$f5708dca728d7177)($1abba740ff2c0af9$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $1abba740ff2c0af9$var$easingLookup[definition];
    }
    return definition;
};






function $c4210b70b762c311$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $9a29d18951b95782$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $be2f5e64a7ccd429$export$8793edee2d425525) : ease;
            mixer = (0, $977c68186cb35a92$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $c4210b70b762c311$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $7683130a8f946b90$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $c4210b70b762c311$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $7e55285dc4fb4246$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $896fd5c280629a6a$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $7e55285dc4fb4246$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $5ba2fcb9b6ecb5f1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $896fd5c280629a6a$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d2b843f1f8ea7394$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $67b004a4d47afbb1$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $19329cc454786073$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $67b004a4d47afbb1$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $821737a815fbd265$export$216948827bbdc797)(ease) ? ease.map((0, $1abba740ff2c0af9$export$ef97fe084f156ca4)) : (0, $1abba740ff2c0af9$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d2b843f1f8ea7394$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $5ba2fcb9b6ecb5f1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $c4210b70b762c311$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $67b004a4d47afbb1$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}






const $0c4cf9fe531f3e32$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $9d7087d3809d752e$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $9d7087d3809d752e$export$fff89137e9e818ce).isProcessing ? (0, $9d7087d3809d752e$export$fff89137e9e818ce).timestamp : (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now()
    };
};



const $b7bd6dbf8622f47d$var$generators = {
    decay: (0, $54c2f976fdb5413e$export$ee3ff3a17106998),
    inertia: $54c2f976fdb5413e$export$ee3ff3a17106998,
    tween: (0, $67b004a4d47afbb1$export$d25ddfdf17c3ad3e),
    keyframes: (0, $67b004a4d47afbb1$export$d25ddfdf17c3ad3e),
    spring: $8c12560f3b269768$export$b36281d89752ae66
};
const $b7bd6dbf8622f47d$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $b7bd6dbf8622f47d$export$fd98d9cca67a58bc extends (0, $659d22f5dfcc0d7e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $40a3c5fe745b0c32$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $751c446f48fe0e49$export$6ab7812f1bac68be)(type) ? type : $b7bd6dbf8622f47d$var$generators[type] || (0, $67b004a4d47afbb1$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $67b004a4d47afbb1$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            (0, $7683130a8f946b90$export$f5708dca728d7177)(keyframes$1.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`);
            mapPercentToKeyframes = (0, $977c68186cb35a92$export$a4627e546088548d)($b7bd6dbf8622f47d$var$percentToProgress, (0, $9a29d18951b95782$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $9279dd71409bd1ca$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $1d0e68b204ae62ec$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $0c4cf9fe531f3e32$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $b7bd6dbf8622f47d$export$ee9b76de7353d815(options) {
    return new $b7bd6dbf8622f47d$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $0e4f06e249a98137$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);



function $9981c827c1cc459b$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeInOut", times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $1f20805368abd6f9$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $e18afd90ac9caf8f$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $f8d8880916c6001a$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $74a23925e429daa0$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $74a23925e429daa0$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $74a23925e429daa0$var$requiresPregeneratedKeyframes(options) {
    return (0, $751c446f48fe0e49$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $1f20805368abd6f9$export$fcdd8f3f2160beda)(options.ease);
}
function $74a23925e429daa0$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $b7bd6dbf8622f47d$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $74a23925e429daa0$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $74a23925e429daa0$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $74a23925e429daa0$var$sampleDelta,
        ease: "linear"
    };
}
const $74a23925e429daa0$var$unsupportedEasingFunctions = {
    anticipate: $157b7359664dc397$export$6b0af63b873d419e,
    backInOut: $167de2db942225a4$export$ddc5fd596f6c71b2,
    circInOut: $3d4a3fe7598f131d$export$30d3455eee55bed5
};
function $74a23925e429daa0$var$isUnsupportedEase(key) {
    return key in $74a23925e429daa0$var$unsupportedEasingFunctions;
}
class $74a23925e429daa0$export$2a45abb4e6513325 extends (0, $659d22f5dfcc0d7e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $85f37dd878bdb11b$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!motionValue.owner || !motionValue.owner.current) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $50e3e7ace9a0414e$export$866c1d07a1ac2ab)() && $74a23925e429daa0$var$isUnsupportedEase(ease)) ease = $74a23925e429daa0$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($74a23925e429daa0$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $74a23925e429daa0$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $9981c827c1cc459b$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $e415b4a6e51179a7$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $1d0e68b204ae62ec$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $be2f5e64a7ccd429$export$8793edee2d425525;
            const { animation: animation } = resolved;
            (0, $e415b4a6e51179a7$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $be2f5e64a7ccd429$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $b7bd6dbf8622f47d$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $74a23925e429daa0$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $74a23925e429daa0$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
        const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
        return (0, $e18afd90ac9caf8f$export$51ea9b46fb7a8c5d)() && name && (0, $0e4f06e249a98137$export$a27eefbd8fb5e404).has(name) && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !onUpdate && !transformTemplate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}





const $af755e32d087f14d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $af755e32d087f14d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $af755e32d087f14d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $af755e32d087f14d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $af755e32d087f14d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $af755e32d087f14d$var$keyframesTransition;
    else if ((0, $fc041f46f20bc48a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $af755e32d087f14d$var$criticallyDampedSpring(keyframes[1]) : $af755e32d087f14d$var$underDampedSpring;
    return $af755e32d087f14d$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $92ec1f74b12b0605$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $b52321ae4788c6d8$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $2d0bcc80dbf59ef8$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $92ec1f74b12b0605$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $af755e32d087f14d$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $06a833acceb929a8$export$888a3d84909f9e3d).current || (0, $9953ced6ae4c074f$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $1d0e68b204ae62ec$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $9d7087d3809d752e$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $c44424735ce2ff07$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $74a23925e429daa0$export$2a45abb4e6513325).supports(options)) return new (0, $74a23925e429daa0$export$2a45abb4e6513325)(options);
        else return new (0, $b7bd6dbf8622f47d$export$fd98d9cca67a58bc)(options);
    };



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $a1130a92c4acee1c$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $a1130a92c4acee1c$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $a1130a92c4acee1c$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $2d0bcc80dbf59ef8$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $73b318b85a09107f$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $9d7087d3809d752e$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $3567723abf70a4dd$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $b52321ae4788c6d8$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $942f92558e91a7c6$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $9d7087d3809d752e$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $2ce8e6a4c5bb6165$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $b18a5c8481a2520a$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $24cfcff025c1c09b$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $a1130a92c4acee1c$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $b18a5c8481a2520a$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $b18a5c8481a2520a$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($b18a5c8481a2520a$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($b18a5c8481a2520a$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $b18a5c8481a2520a$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $dfb71f1228b6dde6$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $b18a5c8481a2520a$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $b18a5c8481a2520a$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $24cfcff025c1c09b$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $a1130a92c4acee1c$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




const $e9bcdda883157d68$var$numVariantProps = (0, $2bfff75dc769cecc$export$1405a65085f40b9).length;
function $e9bcdda883157d68$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $e9bcdda883157d68$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $e9bcdda883157d68$var$numVariantProps; i++){
        const name = (0, $2bfff75dc769cecc$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $b148483bb755c8e0$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}


const $abe07e57549aa866$var$reversePriorityOrder = [
    ...(0, $2bfff75dc769cecc$export$16e45afcc206d3a8)
].reverse();
const $abe07e57549aa866$var$numAnimationTypes = (0, $2bfff75dc769cecc$export$16e45afcc206d3a8).length;
function $abe07e57549aa866$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $dfb71f1228b6dde6$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $abe07e57549aa866$export$bb53502b7a672aa8(visualElement) {
    let animate = $abe07e57549aa866$var$animateList(visualElement);
    let state = $abe07e57549aa866$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $24cfcff025c1c09b$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $e9bcdda883157d68$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $abe07e57549aa866$var$numAnimationTypes; i++){
            const type = $abe07e57549aa866$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $b148483bb755c8e0$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1c2638ff897fdf82$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $abe07e57549aa866$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $2a4adbe79caa98d1$export$9153ad4c4999f4a0)(next) && (0, $2a4adbe79caa98d1$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $101df3d51443ba02$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $abe07e57549aa866$var$createState();
            isInitialRender = true;
        }
    };
}
function $abe07e57549aa866$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $101df3d51443ba02$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $abe07e57549aa866$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $abe07e57549aa866$var$createState() {
    return {
        animate: $abe07e57549aa866$var$createTypeState(true),
        whileInView: $abe07e57549aa866$var$createTypeState(),
        whileHover: $abe07e57549aa866$var$createTypeState(),
        whileTap: $abe07e57549aa866$var$createTypeState(),
        whileDrag: $abe07e57549aa866$var$createTypeState(),
        whileFocus: $abe07e57549aa866$var$createTypeState(),
        exit: $abe07e57549aa866$var$createTypeState()
    };
}


class $a2bb7d8f406b956a$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $f65dd2aa3cf4cfcf$export$b45b3fe5caabdca extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $abe07e57549aa866$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $1c2638ff897fdf82$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $9c69325a51516b86$var$id = 0;
class $9c69325a51516b86$export$4989d1eb6104cc6c extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $9c69325a51516b86$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $7852d9457f30a830$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f65dd2aa3cf4cfcf$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $9c69325a51516b86$export$4989d1eb6104cc6c)
    }
};








function $f0fb5baaa86532a6$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $87e11d50a15592d6$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $87e11d50a15592d6$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6f06c5465a0b6cc0$export$a4cf9c8a4b063a6e)(event) && handler(event, $87e11d50a15592d6$export$12f84bb882d06e1a(event));
};


function $250a3ccd1c58dab0$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $f0fb5baaa86532a6$export$b1d829ddf82884aa)(target, eventName, (0, $87e11d50a15592d6$export$c404e80f92c98d29)(handler), options);
}



const $1b7e996b4440141c$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $1b7e996b4440141c$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $1b7e996b4440141c$export$9f17032d917177de(a.x, b.x);
    const yDelta = $1b7e996b4440141c$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $7248ab2adcb59119$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $7248ab2adcb59119$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $1b7e996b4440141c$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $9d7087d3809d752e$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $7248ab2adcb59119$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $9d7087d3809d752e$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $7248ab2adcb59119$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $7248ab2adcb59119$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6f06c5465a0b6cc0$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $87e11d50a15592d6$export$12f84bb882d06e1a)(event);
        const initialInfo = $7248ab2adcb59119$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $9d7087d3809d752e$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $7248ab2adcb59119$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $977c68186cb35a92$export$a4627e546088548d)((0, $250a3ccd1c58dab0$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $250a3ccd1c58dab0$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $250a3ccd1c58dab0$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $7248ab2adcb59119$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $7248ab2adcb59119$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $7248ab2adcb59119$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $7248ab2adcb59119$var$subtractPoint(point, $7248ab2adcb59119$var$lastDevicePoint(history)),
        offset: $7248ab2adcb59119$var$subtractPoint(point, $7248ab2adcb59119$var$startDevicePoint(history)),
        velocity: $7248ab2adcb59119$var$getVelocity(history, 0.1)
    };
}
function $7248ab2adcb59119$var$startDevicePoint(history) {
    return history[0];
}
function $7248ab2adcb59119$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $7248ab2adcb59119$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $7248ab2adcb59119$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $a9ac1afafa43f3e8$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $20717d01fa8f055b$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $38a5b5f417adcfe3$var$SCALE_PRECISION = 0.0001;
const $38a5b5f417adcfe3$var$SCALE_MIN = 1 - $38a5b5f417adcfe3$var$SCALE_PRECISION;
const $38a5b5f417adcfe3$var$SCALE_MAX = 1 + $38a5b5f417adcfe3$var$SCALE_PRECISION;
const $38a5b5f417adcfe3$var$TRANSLATE_PRECISION = 0.01;
const $38a5b5f417adcfe3$var$TRANSLATE_MIN = 0 - $38a5b5f417adcfe3$var$TRANSLATE_PRECISION;
const $38a5b5f417adcfe3$var$TRANSLATE_MAX = 0 + $38a5b5f417adcfe3$var$TRANSLATE_PRECISION;
function $38a5b5f417adcfe3$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $38a5b5f417adcfe3$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $38a5b5f417adcfe3$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $38a5b5f417adcfe3$export$c1c127004b72a37(target) / $38a5b5f417adcfe3$export$c1c127004b72a37(source);
    delta.translate = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $38a5b5f417adcfe3$var$SCALE_MIN && delta.scale <= $38a5b5f417adcfe3$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $38a5b5f417adcfe3$var$TRANSLATE_MIN && delta.translate <= $38a5b5f417adcfe3$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $38a5b5f417adcfe3$export$c0d25e96fc67d310(delta, source, target, origin) {
    $38a5b5f417adcfe3$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $38a5b5f417adcfe3$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $38a5b5f417adcfe3$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $38a5b5f417adcfe3$export$c1c127004b72a37(relative);
}
function $38a5b5f417adcfe3$export$426154f9d100f99(target, relative, parent) {
    $38a5b5f417adcfe3$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $38a5b5f417adcfe3$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $38a5b5f417adcfe3$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $38a5b5f417adcfe3$export$c1c127004b72a37(layout);
}
function $38a5b5f417adcfe3$export$2785bfcc929c5650(target, layout, parent) {
    $38a5b5f417adcfe3$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $38a5b5f417adcfe3$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $267262cd8f886b89$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $267262cd8f886b89$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $267262cd8f886b89$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $267262cd8f886b89$export$690c180aa5775042(layoutBox.x, left, right),
        y: $267262cd8f886b89$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $267262cd8f886b89$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $267262cd8f886b89$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $267262cd8f886b89$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $267262cd8f886b89$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $267262cd8f886b89$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(source);
    const targetLength = (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $7e55285dc4fb4246$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $7e55285dc4fb4246$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $267262cd8f886b89$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $267262cd8f886b89$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $267262cd8f886b89$export$7c5eaef8f4723d22(dragElastic = $267262cd8f886b89$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $267262cd8f886b89$export$a3366d3bac43a742;
    return {
        x: $267262cd8f886b89$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $267262cd8f886b89$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $267262cd8f886b89$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $267262cd8f886b89$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $267262cd8f886b89$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $267262cd8f886b89$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $ba3a6706560e5234$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $ba3a6706560e5234$export$3d227df54007d73a = ()=>({
        x: $ba3a6706560e5234$export$ff25708b37f72782(),
        y: $ba3a6706560e5234$export$ff25708b37f72782()
    });
const $ba3a6706560e5234$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $ba3a6706560e5234$export$6459fc9e86be362e = ()=>({
        x: $ba3a6706560e5234$export$6db76765312617ac(),
        y: $ba3a6706560e5234$export$6db76765312617ac()
    });


function $735fcef5fe28a723$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $ab40185c099678c5$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $ab40185c099678c5$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $ab40185c099678c5$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $b8a2f75118b45b53$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $b8a2f75118b45b53$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$b8a2f75118b45b53$var$isIdentityScale(scale) || !$b8a2f75118b45b53$var$isIdentityScale(scaleX) || !$b8a2f75118b45b53$var$isIdentityScale(scaleY);
}
function $b8a2f75118b45b53$export$a545127cf1fbb600(values) {
    return $b8a2f75118b45b53$export$bdf30dca883ea463(values) || $b8a2f75118b45b53$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $b8a2f75118b45b53$export$bf80f5f8f4dc327f(values) {
    return $b8a2f75118b45b53$var$is2DTranslate(values.x) || $b8a2f75118b45b53$var$is2DTranslate(values.y);
}
function $b8a2f75118b45b53$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $2187c2afbf68f684$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $2187c2afbf68f684$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $2187c2afbf68f684$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $2187c2afbf68f684$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $2187c2afbf68f684$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $2187c2afbf68f684$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $2187c2afbf68f684$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $2187c2afbf68f684$export$d80074982803af5c(box, { x: x, y: y }) {
    $2187c2afbf68f684$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $2187c2afbf68f684$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $2187c2afbf68f684$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $2187c2afbf68f684$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $2187c2afbf68f684$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $2187c2afbf68f684$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $2187c2afbf68f684$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $b8a2f75118b45b53$export$a545127cf1fbb600)(node.latestValues)) $2187c2afbf68f684$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $2187c2afbf68f684$var$TREE_SCALE_SNAP_MAX && treeScale.x > $2187c2afbf68f684$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $2187c2afbf68f684$var$TREE_SCALE_SNAP_MAX && treeScale.y > $2187c2afbf68f684$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $2187c2afbf68f684$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $2187c2afbf68f684$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $2187c2afbf68f684$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $2187c2afbf68f684$export$58b16271041fbfb(box, transform) {
    $2187c2afbf68f684$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $2187c2afbf68f684$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $a33764120dfc7e3f$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $ab40185c099678c5$export$d3955c6a8f65a36b)((0, $ab40185c099678c5$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $a33764120dfc7e3f$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $a33764120dfc7e3f$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $2187c2afbf68f684$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $2187c2afbf68f684$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/motiondivision/motion/issues/2270
const $3520255d57d29c1c$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $bd0859b684d95188$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $bd0859b684d95188$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $87e11d50a15592d6$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $e225970da3a726ba$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $d91d0d96a9341543$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $3567723abf70a4dd$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $bd0859b684d95188$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $7248ab2adcb59119$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $3520255d57d29c1c$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$bd0859b684d95188$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $267262cd8f886b89$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $20717d01fa8f055b$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $267262cd8f886b89$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $267262cd8f886b89$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $267262cd8f886b89$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $20717d01fa8f055b$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $7683130a8f946b90$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $a33764120dfc7e3f$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $267262cd8f886b89$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $ab40185c099678c5$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $ab40185c099678c5$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            if (!$bd0859b684d95188$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $3567723abf70a4dd$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $b52321ae4788c6d8$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$bd0859b684d95188$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $20717d01fa8f055b$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $267262cd8f886b89$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            if (!$bd0859b684d95188$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $bd0859b684d95188$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $250a3ccd1c58dab0$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $20717d01fa8f055b$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $9d7087d3809d752e$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $f0fb5baaa86532a6$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $267262cd8f886b89$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $bd0859b684d95188$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $bd0859b684d95188$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $07c7eda4459e3f10$export$5d97dc2872682820 extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $be2f5e64a7ccd429$export$8793edee2d425525);
        this.removeListeners = (0, $be2f5e64a7ccd429$export$8793edee2d425525);
        this.controls = new (0, $bd0859b684d95188$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $be2f5e64a7ccd429$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $07db5f3d1c741f28$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $07db5f3d1c741f28$export$b4f8f1ee75ce5859 extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $be2f5e64a7ccd429$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $7248ab2adcb59119$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $3520255d57d29c1c$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $07db5f3d1c741f28$var$asyncHandler(onPanSessionStart),
            onStart: $07db5f3d1c741f28$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $250a3ccd1c58dab0$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $58867d16228fe593$export$da5f7b802957459a = (0, $jMaZ8.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $4258f32ac3c52204$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $0a6bc3b8d3f46d44$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $0a6bc3b8d3f46d44$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $d91d0d96a9341543$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $0a6bc3b8d3f46d44$export$fafff692be55225d(latest, node.target.x);
        const y = $0a6bc3b8d3f46d44$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $8ae1abe36cbca0c1$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $0d4e88e0fd805935$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $0d4e88e0fd805935$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



const $ae97d94db7cfdc97$export$91ddd985b97788d1 = {};
function $ae97d94db7cfdc97$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $ae97d94db7cfdc97$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $f01a1c5aa832e546$export$9de1236619d9e756)(key)) $ae97d94db7cfdc97$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}



const { schedule: $68a2237974c23f5b$export$bb76eed83315504c, cancel: $68a2237974c23f5b$export$3252729004b8456e } = (0, $7ee971e48c80a55c$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $c8a70793dbcb6d63$var$MeasureLayoutWithContext extends (0, $jMaZ8.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $ae97d94db7cfdc97$export$de9e7791c71225fd)($c8a70793dbcb6d63$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $4258f32ac3c52204$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $68a2237974c23f5b$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $c8a70793dbcb6d63$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $dd1bd76902132a2d$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $jMaZ8.useContext)((0, $15e3a7508d138ffe$export$a3579ca508007a95));
    return (0, $954e0e3ebeee9f2b$exports.jsx)($c8a70793dbcb6d63$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $jMaZ8.useContext)((0, $58867d16228fe593$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $c8a70793dbcb6d63$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $0a6bc3b8d3f46d44$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $0a6bc3b8d3f46d44$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $0a6bc3b8d3f46d44$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $0a6bc3b8d3f46d44$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $0a6bc3b8d3f46d44$export$5eafb6257a5844c),
    boxShadow: (0, $8ae1abe36cbca0c1$export$eb0bc629e74dcf8)
};







function $ee6acc454a8b1ec5$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $eb312d786dbb7f8f$export$605d60a2578142d3)(value) ? value : (0, $b2e05bc8f4e46155$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b52321ae4788c6d8$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}






function $e7df8d34e5a1eb88$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}



const $be2eedc46d199821$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $fa8e744982b9da45$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $2511eca7c95e7f14$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $2511eca7c95e7f14$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $be2eedc46d199821$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $0cd1439082582deb$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $9d7087d3809d752e$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(checkElapsed);
}
function $0cd1439082582deb$export$fcd451ca460f8a2a(callback, timeout) {
    return $0cd1439082582deb$export$1391212d75b2ee65(callback, (0, $a9ac1afafa43f3e8$export$fc3e7e8557f8c8c7)(timeout));
}






/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $e1e9016b6864599d$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $eb312d786dbb7f8f$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $4762b82c41844aa9$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






const $9d001399aeb0ee22$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $9d001399aeb0ee22$var$numBorders = $9d001399aeb0ee22$var$borders.length;
const $9d001399aeb0ee22$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $9d001399aeb0ee22$var$isPx = (value)=>typeof value === "number" || (0, $d91d0d96a9341543$export$91c0eda1d06bf008).test(value);
function $9d001399aeb0ee22$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $9d001399aeb0ee22$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $9d001399aeb0ee22$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $9d001399aeb0ee22$var$numBorders; i++){
        const borderLabel = `border${$9d001399aeb0ee22$var$borders[i]}Radius`;
        let followRadius = $9d001399aeb0ee22$var$getRadius(follow, borderLabel);
        let leadRadius = $9d001399aeb0ee22$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $9d001399aeb0ee22$var$isPx(followRadius) === $9d001399aeb0ee22$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)($9d001399aeb0ee22$var$asNumber(followRadius), $9d001399aeb0ee22$var$asNumber(leadRadius), progress), 0);
            if ((0, $d91d0d96a9341543$export$626336c2cd4b14de).test(leadRadius) || (0, $d91d0d96a9341543$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $9d001399aeb0ee22$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $9d001399aeb0ee22$var$easeCrossfadeIn = /*@__PURE__*/ $9d001399aeb0ee22$var$compress(0, 0.5, (0, $3d4a3fe7598f131d$export$c8d67a19199d1a50));
const $9d001399aeb0ee22$var$easeCrossfadeOut = /*@__PURE__*/ $9d001399aeb0ee22$var$compress(0.5, 0.95, (0, $be2f5e64a7ccd429$export$8793edee2d425525));
function $9d001399aeb0ee22$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $7e55285dc4fb4246$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $3fcda980cc8db467$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $3fcda980cc8db467$export$c53fd88f45d77e4b(box, originBox) {
    $3fcda980cc8db467$export$a0230ae482601ae8(box.x, originBox.x);
    $3fcda980cc8db467$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $3fcda980cc8db467$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $6970d6a5ee26f2a6$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $2187c2afbf68f684$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $2187c2afbf68f684$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $6970d6a5ee26f2a6$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $d91d0d96a9341543$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $6970d6a5ee26f2a6$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $6970d6a5ee26f2a6$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $6970d6a5ee26f2a6$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $6970d6a5ee26f2a6$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $6970d6a5ee26f2a6$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $6970d6a5ee26f2a6$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $6970d6a5ee26f2a6$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $6970d6a5ee26f2a6$export$42b76f1d0d16d5b(box.x, transforms, $6970d6a5ee26f2a6$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $6970d6a5ee26f2a6$export$42b76f1d0d16d5b(box.y, transforms, $6970d6a5ee26f2a6$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $0614384f253bfe38$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $0614384f253bfe38$export$a7ec7642fe550fb6(delta) {
    return $0614384f253bfe38$var$isAxisDeltaZero(delta.x) && $0614384f253bfe38$var$isAxisDeltaZero(delta.y);
}
function $0614384f253bfe38$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $0614384f253bfe38$export$8d5cf76bb7daff09(a, b) {
    return $0614384f253bfe38$export$7a9a6f114ddd0fdb(a.x, b.x) && $0614384f253bfe38$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $0614384f253bfe38$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $0614384f253bfe38$export$ef641b782d85522(a, b) {
    return $0614384f253bfe38$export$22adf28bfca1c186(a.x, b.x) && $0614384f253bfe38$export$22adf28bfca1c186(a.y, b.y);
}
function $0614384f253bfe38$export$c5706146bc63213(box) {
    return (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(box.x) / (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(box.y);
}
function $0614384f253bfe38$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $4d7452ba8e3152ca$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $2511eca7c95e7f14$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $2511eca7c95e7f14$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $283d6357914acb49$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $79f899324607bbd3$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $79f899324607bbd3$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $79f899324607bbd3$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $79f899324607bbd3$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $79f899324607bbd3$var$animationTarget = 1000;
let $79f899324607bbd3$var$id = 0;
function $79f899324607bbd3$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $79f899324607bbd3$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $73b318b85a09107f$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $9d7087d3809d752e$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $79f899324607bbd3$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $79f899324607bbd3$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $79f899324607bbd3$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($79f899324607bbd3$var$isDebug) $79f899324607bbd3$var$metrics.totalNodes = $79f899324607bbd3$var$metrics.resolvedTargetDeltas = $79f899324607bbd3$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($79f899324607bbd3$export$131f2f0cc5fe9609);
                this.nodes.forEach($79f899324607bbd3$var$resolveTargetDelta);
                this.nodes.forEach($79f899324607bbd3$var$calcProjection);
                this.nodes.forEach($79f899324607bbd3$export$c2664f37bc951031);
                if ($79f899324607bbd3$var$isDebug) window.MotionDebug.record($79f899324607bbd3$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $fa8e744982b9da45$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $5d38c151e66a32e7$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $e7df8d34e5a1eb88$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $0cd1439082582deb$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $4258f32ac3c52204$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $4258f32ac3c52204$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($79f899324607bbd3$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $79f899324607bbd3$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $0614384f253bfe38$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $2d0bcc80dbf59ef8$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $79f899324607bbd3$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($79f899324607bbd3$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $79f899324607bbd3$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($79f899324607bbd3$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($79f899324607bbd3$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($79f899324607bbd3$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($79f899324607bbd3$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($79f899324607bbd3$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
            (0, $9d7087d3809d752e$export$fff89137e9e818ce).delta = (0, $21992eb5ecb495f6$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $9d7087d3809d752e$export$fff89137e9e818ce).timestamp);
            (0, $9d7087d3809d752e$export$fff89137e9e818ce).timestamp = now;
            (0, $9d7087d3809d752e$export$fff89137e9e818ce).isProcessing = true;
            (0, $9d7087d3809d752e$export$1811c3a7e3af92f0).update.process((0, $9d7087d3809d752e$export$fff89137e9e818ce));
            (0, $9d7087d3809d752e$export$1811c3a7e3af92f0).preRender.process((0, $9d7087d3809d752e$export$fff89137e9e818ce));
            (0, $9d7087d3809d752e$export$1811c3a7e3af92f0).render.process((0, $9d7087d3809d752e$export$fff89137e9e818ce));
            (0, $9d7087d3809d752e$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $68a2237974c23f5b$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($79f899324607bbd3$var$clearSnapshot);
            this.sharedNodes.forEach($79f899324607bbd3$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $9d7087d3809d752e$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $38a5b5f417adcfe3$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $38a5b5f417adcfe3$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $0614384f253bfe38$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $b8a2f75118b45b53$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $79f899324607bbd3$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($79f899324607bbd3$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $2187c2afbf68f684$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $2187c2afbf68f684$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $2187c2afbf68f684$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $2187c2afbf68f684$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $2187c2afbf68f684$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $b8a2f75118b45b53$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $2187c2afbf68f684$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $b8a2f75118b45b53$export$a545127cf1fbb600)(this.latestValues)) (0, $2187c2afbf68f684$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $b8a2f75118b45b53$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $b8a2f75118b45b53$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $6970d6a5ee26f2a6$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $b8a2f75118b45b53$export$a545127cf1fbb600)(this.latestValues)) (0, $6970d6a5ee26f2a6$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $9d7087d3809d752e$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $9d7087d3809d752e$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                    (0, $38a5b5f417adcfe3$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $38a5b5f417adcfe3$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $2187c2afbf68f684$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                    (0, $38a5b5f417adcfe3$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($79f899324607bbd3$var$isDebug) $79f899324607bbd3$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $b8a2f75118b45b53$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $b8a2f75118b45b53$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $9d7087d3809d752e$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $2187c2afbf68f684$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $3fcda980cc8db467$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $3fcda980cc8db467$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $38a5b5f417adcfe3$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $0614384f253bfe38$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $0614384f253bfe38$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($79f899324607bbd3$var$isDebug) $79f899324607bbd3$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $ba3a6706560e5234$export$3d227df54007d73a)();
            this.projectionDelta = (0, $ba3a6706560e5234$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $ba3a6706560e5234$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $ba3a6706560e5234$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($79f899324607bbd3$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $79f899324607bbd3$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $79f899324607bbd3$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $38a5b5f417adcfe3$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $79f899324607bbd3$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $0614384f253bfe38$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                    (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $9d001399aeb0ee22$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9d7087d3809d752e$export$2cef06c20297c17d).update(()=>{
                (0, $4258f32ac3c52204$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $ee6acc454a8b1ec5$export$335a17c977067b99)(0, $79f899324607bbd3$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($79f899324607bbd3$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $79f899324607bbd3$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                const xLength = (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $3fcda980cc8db467$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $2187c2afbf68f684$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $38a5b5f417adcfe3$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $4d7452ba8e3152ca$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $79f899324607bbd3$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $79f899324607bbd3$var$transformAxes.length; i++){
                $79f899324607bbd3$var$resetDistortingTransform(`rotate${$79f899324607bbd3$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $79f899324607bbd3$var$resetDistortingTransform(`skew${$79f899324607bbd3$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $79f899324607bbd3$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $e1e9016b6864599d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $e1e9016b6864599d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $b8a2f75118b45b53$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $283d6357914acb49$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $ae97d94db7cfdc97$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $ae97d94db7cfdc97$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $e1e9016b6864599d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($79f899324607bbd3$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $79f899324607bbd3$var$updateLayout(node) {
    node.updateLayout();
}
function $79f899324607bbd3$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($79f899324607bbd3$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $735fcef5fe28a723$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $38a5b5f417adcfe3$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $ba3a6706560e5234$export$3d227df54007d73a)();
        (0, $38a5b5f417adcfe3$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $ba3a6706560e5234$export$3d227df54007d73a)();
        if (isShared) (0, $38a5b5f417adcfe3$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $38a5b5f417adcfe3$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $0614384f253bfe38$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                    (0, $38a5b5f417adcfe3$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
                    (0, $38a5b5f417adcfe3$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $0614384f253bfe38$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $79f899324607bbd3$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($79f899324607bbd3$var$isDebug) $79f899324607bbd3$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $79f899324607bbd3$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $79f899324607bbd3$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $79f899324607bbd3$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $79f899324607bbd3$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $79f899324607bbd3$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $79f899324607bbd3$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $79f899324607bbd3$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $79f899324607bbd3$var$calcProjection(node) {
    node.calcProjection();
}
function $79f899324607bbd3$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $79f899324607bbd3$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $79f899324607bbd3$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $79f899324607bbd3$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $b3955344ffb14e7d$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $79f899324607bbd3$export$6ffd3e6ae339a132(output, from, to, p) {
    $79f899324607bbd3$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $79f899324607bbd3$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $79f899324607bbd3$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $79f899324607bbd3$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $79f899324607bbd3$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $79f899324607bbd3$var$roundPoint = $79f899324607bbd3$var$userAgentContains("applewebkit/") && !$79f899324607bbd3$var$userAgentContains("chrome/") ? Math.round : (0, $be2f5e64a7ccd429$export$8793edee2d425525);
function $79f899324607bbd3$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $79f899324607bbd3$var$roundPoint(axis.min);
    axis.max = $79f899324607bbd3$var$roundPoint(axis.max);
}
function $79f899324607bbd3$var$roundBox(box) {
    $79f899324607bbd3$var$roundAxis(box.x);
    $79f899324607bbd3$var$roundAxis(box.y);
}
function $79f899324607bbd3$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $38a5b5f417adcfe3$export$28d0384c4b79bde2)((0, $0614384f253bfe38$export$c5706146bc63213)(snapshot), (0, $0614384f253bfe38$export$c5706146bc63213)(layout), 0.2);
}
function $79f899324607bbd3$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $156fc1162961445e$export$2d029a49a09b6177 = (0, $79f899324607bbd3$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $f0fb5baaa86532a6$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $53a0c472936b7dbb$export$b91509fcf893b648 = {
    current: undefined
};
const $53a0c472936b7dbb$export$b61a9eb3dbde8858 = (0, $79f899324607bbd3$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$53a0c472936b7dbb$export$b91509fcf893b648.current) {
            const documentNode = new (0, $156fc1162961445e$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $53a0c472936b7dbb$export$b91509fcf893b648.current = documentNode;
        }
        return $53a0c472936b7dbb$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $547d4e07a031358e$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $07db5f3d1c741f28$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $07c7eda4459e3f10$export$5d97dc2872682820),
        ProjectionNode: (0, $53a0c472936b7dbb$export$b61a9eb3dbde8858),
        MeasureLayout: $c8a70793dbcb6d63$export$779f5fb01ad751cd
    }
};






function $258827dccc9cb801$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $87e11d50a15592d6$export$12f84bb882d06e1a)(event)));
}
class $258827dccc9cb801$export$93a81ea037eac456 extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $7b2a1b2aa9f9d6b6$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $258827dccc9cb801$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$258827dccc9cb801$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $b9d40b753650e5f6$export$d4826db40d47595b extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $977c68186cb35a92$export$a4627e546088548d)((0, $f0fb5baaa86532a6$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $f0fb5baaa86532a6$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}






function $912b429381e9660d$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $9d7087d3809d752e$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $87e11d50a15592d6$export$12f84bb882d06e1a)(event)));
}
class $912b429381e9660d$export$f026abdbba7f0c9e extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $6aa7a829ec9e3e84$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $912b429381e9660d$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$912b429381e9660d$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $0c4c45a8493ae34f$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $0c4c45a8493ae34f$var$observers = new WeakMap();
const $0c4c45a8493ae34f$var$fireObserverCallback = (entry)=>{
    const callback = $0c4c45a8493ae34f$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $0c4c45a8493ae34f$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($0c4c45a8493ae34f$var$fireObserverCallback);
};
function $0c4c45a8493ae34f$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$0c4c45a8493ae34f$var$observers.has(lookupRoot)) $0c4c45a8493ae34f$var$observers.set(lookupRoot, {});
    const rootObservers = $0c4c45a8493ae34f$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($0c4c45a8493ae34f$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $0c4c45a8493ae34f$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $0c4c45a8493ae34f$var$initIntersectionObserver(options);
    $0c4c45a8493ae34f$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $0c4c45a8493ae34f$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $d581dd19c5c87d34$var$thresholdNames = {
    some: 0,
    all: 1
};
class $d581dd19c5c87d34$export$150851c8cc2f0c72 extends (0, $a2bb7d8f406b956a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $d581dd19c5c87d34$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $0c4c45a8493ae34f$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($d581dd19c5c87d34$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $d581dd19c5c87d34$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $9b28b400462863af$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $d581dd19c5c87d34$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $912b429381e9660d$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $b9d40b753650e5f6$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $258827dccc9cb801$export$93a81ea037eac456)
    }
};




const $e2a693cb5ff0352a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $53a0c472936b7dbb$export$b61a9eb3dbde8858),
        MeasureLayout: $c8a70793dbcb6d63$export$779f5fb01ad751cd
    }
};





var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $5a842ad7b8a4ea8d$export$40f10139ecf1f171 = (0, $jMaZ8.createContext)({
    strict: false
});




var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $1b92fbaa2218d1ab$export$2285bbca2c666415 = (0, $jMaZ8.createContext)({});



var $jMaZ8 = parcelRequire("jMaZ8");





function $4a1d2fb6cfd8c27e$export$4b3c3bd8d910d78d(props) {
    return (0, $1c2638ff897fdf82$export$aa71198ceeaf53ce)(props.animate) || (0, $2bfff75dc769cecc$export$1405a65085f40b9).some((name)=>(0, $b148483bb755c8e0$export$720b90e312cea233)(props[name]));
}
function $4a1d2fb6cfd8c27e$export$ce46fa4165cdec40(props) {
    return Boolean($4a1d2fb6cfd8c27e$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $7d94bfcabcd6b730$export$12fc32fc096a04a3(props, context) {
    if ((0, $4a1d2fb6cfd8c27e$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $b148483bb755c8e0$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $b148483bb755c8e0$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $57d8837aa004b3eb$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $7d94bfcabcd6b730$export$12fc32fc096a04a3)(props, (0, $jMaZ8.useContext)((0, $1b92fbaa2218d1ab$export$2285bbca2c666415)));
    return (0, $jMaZ8.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $57d8837aa004b3eb$var$variantLabelsAsDependency(initial),
        $57d8837aa004b3eb$var$variantLabelsAsDependency(animate)
    ]);
}
function $57d8837aa004b3eb$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



const $e8f5f9fca2ec6c36$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $e8f5f9fca2ec6c36$export$65570e08d843624d = {};
for(const key in $e8f5f9fca2ec6c36$var$featureProps)$e8f5f9fca2ec6c36$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$e8f5f9fca2ec6c36$var$featureProps[key].some((name)=>!!props[name])
};



function $5a5b4015ca4ec1f8$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $e8f5f9fca2ec6c36$export$65570e08d843624d)[key] = {
        ...(0, $e8f5f9fca2ec6c36$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $00c857744aa9bab9$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $jMaZ8 = parcelRequire("jMaZ8");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $a00a974285f004ab$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $jMaZ8.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $20717d01fa8f055b$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $jMaZ8 = parcelRequire("jMaZ8");









function $4002c4dcaaf675d8$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $jMaZ8.useContext)((0, $1b92fbaa2218d1ab$export$2285bbca2c666415));
    const lazyContext = (0, $jMaZ8.useContext)((0, $5a842ad7b8a4ea8d$export$40f10139ecf1f171));
    const presenceContext = (0, $jMaZ8.useContext)((0, $70925b40c3bb5f59$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $jMaZ8.useContext)((0, $e2022e66f4544c33$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $jMaZ8.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $jMaZ8.useContext)((0, $58867d16228fe593$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $4002c4dcaaf675d8$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $jMaZ8.useRef)(false);
    (0, $jMaZ8.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $ebd1a822610f6e94$export$8592e1c077c890a6];
    const wantsHandoff = (0, $jMaZ8.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $275bf53c13de8309$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $68a2237974c23f5b$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $jMaZ8.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $4002c4dcaaf675d8$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $4002c4dcaaf675d8$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $20717d01fa8f055b$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $4002c4dcaaf675d8$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $4002c4dcaaf675d8$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $cba8afd2dc6beb2a$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    var _a, _b;
    preloadedFeatures && (0, $5a5b4015ca4ec1f8$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $jMaZ8.useContext)((0, $e2022e66f4544c33$export$22a697fb29aac98d)),
            ...props,
            layoutId: $cba8afd2dc6beb2a$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $57d8837aa004b3eb$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $c1ea35d81beb7558$export$4e09c449d6c407f7)) {
            $cba8afd2dc6beb2a$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $cba8afd2dc6beb2a$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $4002c4dcaaf675d8$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $1b92fbaa2218d1ab$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $954e0e3ebeee9f2b$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $a00a974285f004ab$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : ""})`}`;
    const ForwardRefMotionComponent = (0, $jMaZ8.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $00c857744aa9bab9$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $cba8afd2dc6beb2a$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $jMaZ8.useContext)((0, $15e3a7508d138ffe$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $cba8afd2dc6beb2a$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $jMaZ8.useContext)((0, $5a842ad7b8a4ea8d$export$40f10139ecf1f171)).strict;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if (preloadedFeatures && isStrict) {
        const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
        configAndProps.ignoreStrict ? (0, $7683130a8f946b90$export$491112666e282270)(false, strictMessage) : (0, $7683130a8f946b90$export$f5708dca728d7177)(false, strictMessage);
    }
}
function $cba8afd2dc6beb2a$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $e8f5f9fca2ec6c36$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $9cc35b2e5f44a6fa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $b5d04561aec3c998$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $9cc35b2e5f44a6fa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}




var $jMaZ8 = parcelRequire("jMaZ8");







function $b5a687a4c58ebda1$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onUpdate: onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: $b5a687a4c58ebda1$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props: props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const $b5a687a4c58ebda1$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $jMaZ8.useContext)((0, $1b92fbaa2218d1ab$export$2285bbca2c666415));
        const presenceContext = (0, $jMaZ8.useContext)((0, $70925b40c3bb5f59$export$f224e4635b6f8ce2));
        const make = ()=>$b5a687a4c58ebda1$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $bd09330c468f7d5e$export$fe4300aa8eebea86)(make);
    };
function $b5a687a4c58ebda1$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $e1e9016b6864599d$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $4a1d2fb6cfd8c27e$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $4a1d2fb6cfd8c27e$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1c2638ff897fdf82$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $f23b54c5f89fbd40$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}




/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $157403c7a576eee8$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};






const $ba6614626a164b08$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $ba6614626a164b08$var$numTransforms = (0, $fc041f46f20bc48a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $ba6614626a164b08$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $ba6614626a164b08$var$numTransforms; i++){
        const key = (0, $fc041f46f20bc48a$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $157403c7a576eee8$export$453ef540a9a1bd6b)(value, (0, $101bef5fa6551d53$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $ba6614626a164b08$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}



function $fd8b709c65814357$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $fc041f46f20bc48a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $f01a1c5aa832e546$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $157403c7a576eee8$export$453ef540a9a1bd6b)(value, (0, $101bef5fa6551d53$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $ba6614626a164b08$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



const $7fb6be6aa4e0fb93$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $7fb6be6aa4e0fb93$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $7fb6be6aa4e0fb93$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $7fb6be6aa4e0fb93$var$dashKeys : $7fb6be6aa4e0fb93$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $d91d0d96a9341543$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $d91d0d96a9341543$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $d91d0d96a9341543$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}



function $e6c29f91d2c10efd$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $d91d0d96a9341543$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $e6c29f91d2c10efd$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $e6c29f91d2c10efd$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $e6c29f91d2c10efd$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $07414e9980f1deed$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $fd8b709c65814357$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $e6c29f91d2c10efd$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $7fb6be6aa4e0fb93$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $42b113236ba46f80$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $c5bff3be4da61edb$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $42b113236ba46f80$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $f8fad8b4328c4239$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



function $a7ab79dff904cd05$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $bbcdbc7cde0d5866$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $77607f1811236e1b$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a7ab79dff904cd05$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $bbcdbc7cde0d5866$export$28931db5d57958e5).has(key) ? (0, $f22278e68b5dea09$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}






function $6fa4f9e9f808638c$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $fc041f46f20bc48a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $ae97d94db7cfdc97$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $82642d2a14313dad$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $eb312d786dbb7f8f$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $eb312d786dbb7f8f$export$605d60a2578142d3)(prevProps.style[key]) || (0, $6fa4f9e9f808638c$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}


function $570ba2f3f729811f$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $82642d2a14313dad$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $eb312d786dbb7f8f$export$605d60a2578142d3)(props[key]) || (0, $eb312d786dbb7f8f$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $fc041f46f20bc48a$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


function $15e3e2bb43c2215c$var$updateSVGDimensions(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
const $15e3e2bb43c2215c$var$layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const $15e3e2bb43c2215c$export$44dabd3fae512e85 = {
    useVisualState: (0, $b5a687a4c58ebda1$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $570ba2f3f729811f$export$16da615486abaa45),
        createRenderState: (0, $c5bff3be4da61edb$export$41be8b43e1c4d4f9),
        onUpdate: ({ props: props, prevProps: prevProps, current: current, renderState: renderState, latestValues: latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, $fc041f46f20bc48a$export$7b42a0094fb00b6e).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < $15e3e2bb43c2215c$var$layoutProps.length; i++){
                const key = $15e3e2bb43c2215c$var$layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, $9d7087d3809d752e$export$2cef06c20297c17d).read(()=>{
                $15e3e2bb43c2215c$var$updateSVGDimensions(current, renderState);
                (0, $9d7087d3809d752e$export$2cef06c20297c17d).render(()=>{
                    (0, $07414e9980f1deed$export$5475d24f125d7053)(renderState, latestValues, (0, $f8fad8b4328c4239$export$6328ce7565ea1049)(current.tagName), props.transformTemplate);
                    (0, $77607f1811236e1b$export$c5f8399d19a7394b)(current, renderState);
                });
            });
        }
    })
};





const $b3e2347174e764e2$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $b5a687a4c58ebda1$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $82642d2a14313dad$export$16da615486abaa45,
        createRenderState: (0, $42b113236ba46f80$export$8940b483cf52eeda)
    })
};



var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");




function $bac4ec9d1e4c8ccd$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $eb312d786dbb7f8f$export$605d60a2578142d3)(source[key]) && !(0, $6fa4f9e9f808638c$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $bac4ec9d1e4c8ccd$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $jMaZ8.useMemo)(()=>{
        const state = (0, $42b113236ba46f80$export$8940b483cf52eeda)();
        (0, $fd8b709c65814357$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $bac4ec9d1e4c8ccd$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $bac4ec9d1e4c8ccd$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $bac4ec9d1e4c8ccd$var$useInitialMotionValues(props, visualState));
    return style;
}
function $bac4ec9d1e4c8ccd$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $bac4ec9d1e4c8ccd$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $6ea368ae094bfb86$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $6ea368ae094bfb86$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $6ea368ae094bfb86$var$validMotionProps.has(key);
}


let $0e0b22b0cf78b6f8$var$shouldForward = (key)=>!(0, $6ea368ae094bfb86$export$2f9c46555243bf04)(key);
function $0e0b22b0cf78b6f8$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $0e0b22b0cf78b6f8$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $6ea368ae094bfb86$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $0e0b22b0cf78b6f8$export$59d6962c470509a5((parcelRequire("cYHIk")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $0e0b22b0cf78b6f8$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($0e0b22b0cf78b6f8$var$shouldForward(key) || forwardMotionProps === true && (0, $6ea368ae094bfb86$export$2f9c46555243bf04)(key) || !isDom && !(0, $6ea368ae094bfb86$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $jMaZ8 = parcelRequire("jMaZ8");




function $fa7467de4be8a118$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $jMaZ8.useMemo)(()=>{
        const state = (0, $c5bff3be4da61edb$export$41be8b43e1c4d4f9)();
        (0, $07414e9980f1deed$export$5475d24f125d7053)(state, visualState, (0, $f8fad8b4328c4239$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $bac4ec9d1e4c8ccd$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $0483749425852328$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $b5d04561aec3c998$export$88f3fc2fd3766989)(Component) ? (0, $fa7467de4be8a118$export$84309c4f53cb1bd5) : (0, $bac4ec9d1e4c8ccd$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $0e0b22b0cf78b6f8$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $jMaZ8.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $jMaZ8.useMemo)(()=>(0, $eb312d786dbb7f8f$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $jMaZ8.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $cb0c7d7c267938c8$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $b5d04561aec3c998$export$88f3fc2fd3766989)(Component) ? (0, $15e3e2bb43c2215c$export$44dabd3fae512e85) : (0, $b3e2347174e764e2$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $0483749425852328$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $cba8afd2dc6beb2a$export$c3ad4a902bccc2d8)(config);
    };
}



var $jMaZ8 = parcelRequire("jMaZ8");







// Does this device prefer reduced motion? Returns `null` server-side.
const $e69191a567cc6a47$export$ff7706047246b98b = {
    current: null
};
const $e69191a567cc6a47$export$6476d16e2fd2d0db = {
    current: false
};


function $530a751eb61bf84a$export$ca9f41fb23dded3d() {
    (0, $e69191a567cc6a47$export$6476d16e2fd2d0db).current = true;
    if (!(0, $c1ea35d81beb7558$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $e69191a567cc6a47$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $e69191a567cc6a47$export$ff7706047246b98b).current = false;
}













/**
 * A list of all ValueTypes
 */ const $3eb1ff986363ca9c$var$valueTypes = [
    ...(0, $f2793236b62813ee$export$d176691c1998a1f5),
    (0, $de797567df6f757a$export$35e9368ef982300f),
    (0, $0d4e88e0fd805935$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $3eb1ff986363ca9c$export$950e7e59ea1ffed7 = (v)=>$3eb1ff986363ca9c$var$valueTypes.find((0, $ae33ef0146ce940f$export$6eae4d0a6a7ca7cd)(v));



const $aa5cb7a81bd3cb68$export$bc2a978a17abfdde = new WeakMap();







function $e24d3792d74f3a86$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $eb312d786dbb7f8f$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $eb312d786dbb7f8f$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $b2e05bc8f4e46155$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $b2e05bc8f4e46155$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}




const $a9cae59111a571b5$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $a9cae59111a571b5$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $40a3c5fe745b0c32$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $227990d67307f8fb$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $9d7087d3809d752e$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState, onUpdate: onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $4a1d2fb6cfd8c27e$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $4a1d2fb6cfd8c27e$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $eb312d786dbb7f8f$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $aa5cb7a81bd3cb68$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $e69191a567cc6a47$export$6476d16e2fd2d0db).current) (0, $530a751eb61bf84a$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $e69191a567cc6a47$export$ff7706047246b98b).current;
        (0, $b6eedd81c035e31f$export$5b28268982f175ba)(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $aa5cb7a81bd3cb68$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $9d7087d3809d752e$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $fc041f46f20bc48a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $9d7087d3809d752e$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $e8f5f9fca2ec6c36$export$65570e08d843624d){
            const featureDefinition = (0, $e8f5f9fca2ec6c36$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $ba3a6706560e5234$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $a9cae59111a571b5$var$propEventHandlers.length; i++){
            const key = $a9cae59111a571b5$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $e24d3792d74f3a86$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $b2e05bc8f4e46155$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $a935c15e93c92110$export$65583ed5a868f2d9)(value) || (0, $90a2a425120fc644$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $3eb1ff986363ca9c$export$950e7e59ea1ffed7)(value) && (0, $0d4e88e0fd805935$export$83a0e34f1302825b).test(target)) value = (0, $7ae1f0746541b9f1$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $eb312d786dbb7f8f$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $eb312d786dbb7f8f$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $f23b54c5f89fbd40$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $eb312d786dbb7f8f$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $5d38c151e66a32e7$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}




class $22ba4d911eff1656$export$e49735c2a366bdc7 extends (0, $a9cae59111a571b5$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $85f37dd878bdb11b$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $eb312d786dbb7f8f$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}








function $f518c264a408c8cd$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $f518c264a408c8cd$export$23fea75b03ac16b3 extends (0, $22ba4d911eff1656$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $a7ab79dff904cd05$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $fc041f46f20bc48a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5822abf9a95fd029$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $f518c264a408c8cd$export$3735103072e4a80(instance);
            const value = ((0, $f01a1c5aa832e546$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $a33764120dfc7e3f$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $fd8b709c65814357$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $82642d2a14313dad$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}












class $d5bf9ba6019fa248$export$86bcdffbaf733d84 extends (0, $22ba4d911eff1656$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $ba3a6706560e5234$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $fc041f46f20bc48a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5822abf9a95fd029$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $bbcdbc7cde0d5866$export$28931db5d57958e5).has(key) ? (0, $f22278e68b5dea09$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $570ba2f3f729811f$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $07414e9980f1deed$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $77607f1811236e1b$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $f8fad8b4328c4239$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $92e59efd85741171$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $b5d04561aec3c998$export$88f3fc2fd3766989)(Component) ? new (0, $d5bf9ba6019fa248$export$86bcdffbaf733d84)(options) : new (0, $f518c264a408c8cd$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $jMaZ8.Fragment)
    });
};


const $d7915f3b27f0419e$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $cb0c7d7c267938c8$export$d86feac869a7f0d5)({
    ...(0, $7852d9457f30a830$export$7f9953c70dacfd7f),
    ...(0, $9b28b400462863af$export$e5b72898e5a201f1),
    ...(0, $547d4e07a031358e$export$d7d5d435647ed5a0),
    ...(0, $e2a693cb5ff0352a$export$b3219800bda33a1f)
}, (0, $92e59efd85741171$export$56ba0183203348f5));


const $0ad12ec738f3c09f$export$e25e478948902b8b = /*@__PURE__*/ (0, $a14f69f0f51b0645$export$3af29c0efb268f04)((0, $d7915f3b27f0419e$export$46b7e4b9dc6110c3));


var $9bb7f34b4c04d241$exports = {};

$parcel$export($9bb7f34b4c04d241$exports, "sideBarContainer", () => $9bb7f34b4c04d241$export$c1c40efc5ecff0f2, (v) => $9bb7f34b4c04d241$export$c1c40efc5ecff0f2 = v);
$parcel$export($9bb7f34b4c04d241$exports, "background", () => $9bb7f34b4c04d241$export$8ce1fd94bee2f412, (v) => $9bb7f34b4c04d241$export$8ce1fd94bee2f412 = v);
$parcel$export($9bb7f34b4c04d241$exports, "sideBar", () => $9bb7f34b4c04d241$export$2ba7b91161d3f11c, (v) => $9bb7f34b4c04d241$export$2ba7b91161d3f11c = v);
$parcel$export($9bb7f34b4c04d241$exports, "top", () => $9bb7f34b4c04d241$export$1e95b668f3b82d, (v) => $9bb7f34b4c04d241$export$1e95b668f3b82d = v);
$parcel$export($9bb7f34b4c04d241$exports, "bottom", () => $9bb7f34b4c04d241$export$40e543e69a8b3fbb, (v) => $9bb7f34b4c04d241$export$40e543e69a8b3fbb = v);
$parcel$export($9bb7f34b4c04d241$exports, "right", () => $9bb7f34b4c04d241$export$79ffe56a765070d2, (v) => $9bb7f34b4c04d241$export$79ffe56a765070d2 = v);
$parcel$export($9bb7f34b4c04d241$exports, "left", () => $9bb7f34b4c04d241$export$eabcd2c8791e7bf4, (v) => $9bb7f34b4c04d241$export$eabcd2c8791e7bf4 = v);
var $9bb7f34b4c04d241$export$c1c40efc5ecff0f2;
var $9bb7f34b4c04d241$export$8ce1fd94bee2f412;
var $9bb7f34b4c04d241$export$2ba7b91161d3f11c;
var $9bb7f34b4c04d241$export$1e95b668f3b82d;
var $9bb7f34b4c04d241$export$40e543e69a8b3fbb;
var $9bb7f34b4c04d241$export$79ffe56a765070d2;
var $9bb7f34b4c04d241$export$eabcd2c8791e7bf4;
$9bb7f34b4c04d241$export$c1c40efc5ecff0f2 = "sideBarContainer_1db9c4";
$9bb7f34b4c04d241$export$8ce1fd94bee2f412 = "background_1db9c4";
$9bb7f34b4c04d241$export$2ba7b91161d3f11c = "sideBar_1db9c4";
$9bb7f34b4c04d241$export$1e95b668f3b82d = "top_1db9c4";
$9bb7f34b4c04d241$export$40e543e69a8b3fbb = "bottom_1db9c4";
$9bb7f34b4c04d241$export$79ffe56a765070d2 = "right_1db9c4";
$9bb7f34b4c04d241$export$eabcd2c8791e7bf4 = "left_1db9c4";


const $ed31c48a4a41bec7$var$wrapperVariants = {
    opened: {
        opacity: 1
    },
    closed: {
        opacity: 0
    }
};
const $ed31c48a4a41bec7$var$DEFAULT_POSITION = {
    x: "0%",
    y: "0%"
};
const $ed31c48a4a41bec7$var$panelVariantsTable = {
    top: {
        opened: $ed31c48a4a41bec7$var$DEFAULT_POSITION,
        closed: {
            x: "0%",
            y: "-100%"
        }
    },
    right: {
        opened: $ed31c48a4a41bec7$var$DEFAULT_POSITION,
        closed: {
            x: "100%",
            y: "0%"
        }
    },
    bottom: {
        opened: $ed31c48a4a41bec7$var$DEFAULT_POSITION,
        closed: {
            x: "0%",
            y: "100%"
        }
    },
    left: {
        opened: $ed31c48a4a41bec7$var$DEFAULT_POSITION,
        closed: {
            x: "-100%",
            y: "0%"
        }
    }
};
var $ed31c48a4a41bec7$var$SibeBarPosition = /*#__PURE__*/ function($ed31c48a4a41bec7$var$SibeBarPosition) {
    $ed31c48a4a41bec7$var$SibeBarPosition["Top"] = "top";
    $ed31c48a4a41bec7$var$SibeBarPosition["Right"] = "right";
    $ed31c48a4a41bec7$var$SibeBarPosition["Bottom"] = "bottom";
    $ed31c48a4a41bec7$var$SibeBarPosition["Left"] = "left";
    return $ed31c48a4a41bec7$var$SibeBarPosition;
}($ed31c48a4a41bec7$var$SibeBarPosition || {});
const $ed31c48a4a41bec7$var$TRANSITION_CONFIG = {
    duration: 0.2,
    bounce: 0,
    ease: "linear"
};
function $ed31c48a4a41bec7$export$614264b7ca4804e6({ isOpen: isOpen, close: close, children: children, position: position = "right" }) {
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8043386845b9e569$export$3ae376d12526dd6f), {
        exitBeforeEnter: true,
        children: isOpen && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
            transition: $ed31c48a4a41bec7$var$TRANSITION_CONFIG,
            style: isOpen ? {} : {
                pointerEvents: "none"
            },
            className: $9bb7f34b4c04d241$exports.sideBarContainer,
            animate: isOpen ? "opened" : "closed",
            initial: "closed",
            exit: "closed",
            variants: $ed31c48a4a41bec7$var$wrapperVariants,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                    onClick: close,
                    className: $9bb7f34b4c04d241$exports.background
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                    transition: $ed31c48a4a41bec7$var$TRANSITION_CONFIG,
                    variants: $ed31c48a4a41bec7$var$panelVariantsTable[position],
                    className: $9bb7f34b4c04d241$exports.sideBar.concat(" ", $9bb7f34b4c04d241$exports[position]),
                    children: children
                })
            ]
        })
    });
}


var $1d728be83db542e5$export$e32d6388d2a32a35;
var $1d728be83db542e5$export$203008033c83a977;
var $1d728be83db542e5$export$ab1107743aa4affb;
var $1d728be83db542e5$export$949fa18a288d30ba;
var $1d728be83db542e5$export$cb8ee946b786b8e7;
var $1d728be83db542e5$export$1743070e8c1f0442;
var $1d728be83db542e5$export$a3e2eb65c37b106e;
$1d728be83db542e5$export$e32d6388d2a32a35 = "userPanelContainer_8862e6";
$1d728be83db542e5$export$203008033c83a977 = "userFirstLetterContainer_8862e6";
$1d728be83db542e5$export$ab1107743aa4affb = "userFirstLetter_8862e6";
$1d728be83db542e5$export$949fa18a288d30ba = "userInformationContainer_8862e6";
$1d728be83db542e5$export$cb8ee946b786b8e7 = "nameAndEmailContainer_8862e6";
$1d728be83db542e5$export$1743070e8c1f0442 = "roleSwitcher_8862e6";
$1d728be83db542e5$export$a3e2eb65c37b106e = "roleSelector_8862e6";



parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $b3c96a6d653882e9$export$f6902370b6ae9756;
var $b3c96a6d653882e9$export$683472f6198a076e;
$b3c96a6d653882e9$export$f6902370b6ae9756 = "clickableWrapper_262a55";
$b3c96a6d653882e9$export$683472f6198a076e = "disabled_262a55";


const $692b578090014f71$var$tryToAddClassName = (children, disabled = false)=>{
    if (Array.isArray(children)) return children.map((el)=>$692b578090014f71$var$tryToAddClassName(el, disabled));
    else {
        const child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(children, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(children.props.className, $b3c96a6d653882e9$export$f6902370b6ae9756, {
                [$b3c96a6d653882e9$export$683472f6198a076e]: disabled
            })
        });
        return child;
    }
};
const $692b578090014f71$export$a0a862a22f0658d6 = ({ children: children, disabled: disabled })=>{
    try {
        return $692b578090014f71$var$tryToAddClassName(children, disabled);
    } catch (e) {
        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($b3c96a6d653882e9$export$f6902370b6ae9756, {
                [$b3c96a6d653882e9$export$683472f6198a076e]: disabled
            }),
            children: children
        });
    }
};


var $f2316b1ff4b91af5$export$dc57ddd528b7443f;
var $f2316b1ff4b91af5$export$f40d1dfe24afa10b;
var $f2316b1ff4b91af5$export$88d504aa8623c74c;
$f2316b1ff4b91af5$export$dc57ddd528b7443f = "buttonContainer_02230b";
$f2316b1ff4b91af5$export$f40d1dfe24afa10b = "buttonPrimary_02230b";
$f2316b1ff4b91af5$export$88d504aa8623c74c = "buttonAlert_02230b";


var $95bb5c703954dd90$export$9e18203e03cd7448 = /*#__PURE__*/ function($95bb5c703954dd90$export$9e18203e03cd7448) {
    $95bb5c703954dd90$export$9e18203e03cd7448["primary"] = "primary";
    $95bb5c703954dd90$export$9e18203e03cd7448["alert"] = "alert";
    return $95bb5c703954dd90$export$9e18203e03cd7448;
}({});
const $95bb5c703954dd90$var$getClassName = (className)=>{
    if (className === "alert") return $f2316b1ff4b91af5$export$88d504aa8623c74c;
    else return $f2316b1ff4b91af5$export$f40d1dfe24afa10b;
};
const $95bb5c703954dd90$var$UserPanelButton = ({ className: className, text: text, onClick: onClick })=>{
    const selectedClassName = $95bb5c703954dd90$var$getClassName(className);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
            className: $f2316b1ff4b91af5$export$dc57ddd528b7443f,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: selectedClassName,
                children: text
            })
        })
    });
};
var $95bb5c703954dd90$export$2e2bcd8739ae039 = $95bb5c703954dd90$var$UserPanelButton;



const { Option: $3f292fa78e121485$var$Option } = (0, $71df08955277779f$export$2e2bcd8739ae039);
function $3f292fa78e121485$export$bb9c6c1faf7ea682() {
    const [isUserPanelOpened, setIsUserPanelOpened] = (0, $jMaZ8.useState)(false);
    return {
        isUserPanelOpened: isUserPanelOpened,
        closePanel: ()=>setIsUserPanelOpened(false),
        openPanel: ()=>setIsUserPanelOpened(true)
    };
}
const $3f292fa78e121485$export$d02877a6a1957b9b = ({ isUserPanelOpened: isUserPanelOpened, closePanel: closePanel })=>{
    const { state: role, dispatch: setRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    const canUserSwitchRole = (0, $dc10a25720c6edc8$export$5c61c7f558ce763a)();
    const isEditor = (0, $dc10a25720c6edc8$export$5fe256569ad95d29)();
    const isNarrator = (0, $dc10a25720c6edc8$export$f8adf287d3cca566)();
    const isProofListener = (0, $dc10a25720c6edc8$export$2b59cb60095d743f)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const identity = (0, $dc10a25720c6edc8$export$a2347e5c24cde9c8)();
    const { userFirstLetter: userFirstLetter, userName: userName, userEmail: userEmail } = (0, $jMaZ8.useMemo)(()=>{
        return {
            userFirstLetter: identity.user_profile.display_name.slice(0, 1).toUpperCase(),
            userName: identity.user_profile.display_name,
            userEmail: identity.user_profile.email
        };
    }, [
        identity
    ]);
    const logOut = ()=>{
        (0, $b5c1938aaa3155db$export$7dc0a3a835d48dae).auth.signOut();
        sessionStorage.clear();
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ed31c48a4a41bec7$export$614264b7ca4804e6), {
        isOpen: isUserPanelOpened,
        close: closePanel,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            className: $1d728be83db542e5$export$e32d6388d2a32a35,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    className: $1d728be83db542e5$export$949fa18a288d30ba,
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            className: $1d728be83db542e5$export$203008033c83a977,
                            onClick: closePanel,
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                className: $1d728be83db542e5$export$ab1107743aa4affb,
                                children: userFirstLetter
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                            className: $1d728be83db542e5$export$cb8ee946b786b8e7,
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    children: userName
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    children: userEmail
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $95bb5c703954dd90$export$2e2bcd8739ae039), {
                            className: (0, $95bb5c703954dd90$export$9e18203e03cd7448).primary,
                            text: "Modifier mon profil"
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $95bb5c703954dd90$export$2e2bcd8739ae039), {
                            className: (0, $95bb5c703954dd90$export$9e18203e03cd7448).alert,
                            text: "Se d\xe9connecter",
                            onClick: logOut
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    className: $1d728be83db542e5$export$1743070e8c1f0442,
                    children: canUserSwitchRole && role && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $71df08955277779f$export$2e2bcd8739ae039), {
                        className: $1d728be83db542e5$export$a3e2eb65c37b106e,
                        value: role,
                        placeholder: t("select_recorgind_issue_type"),
                        onChange: (value)=>{
                            setRole(value);
                        },
                        children: [
                            isEditor && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($3f292fa78e121485$var$Option, {
                                children: t("editor")
                            }, (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Editor),
                            isNarrator && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($3f292fa78e121485$var$Option, {
                                children: t("narrator")
                            }, (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Narrator),
                            isProofListener && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($3f292fa78e121485$var$Option, {
                                children: t("prooflistener")
                            }, (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).ProofListener)
                        ]
                    })
                })
            ]
        })
    });
};




var $jMaZ8 = parcelRequire("jMaZ8");






var $079b66e63d4d13b3$exports = {};
var $1f021559c45f6f1c$exports = {};
var $28a88767a5e44757$exports = {};
var $ee1caf719581867c$exports = {};
var $ab91e990c401f93e$exports = {};
var $6503f75a59a89952$exports = {};
var $3e5efb3713dbaae7$exports = {};
var $900f7ccfd4d0e9a7$exports = {};
var $2557930d4046fd55$exports = {};
var $b184524734883627$exports = {};
var $6429a69be43b682f$exports = {};
var $1b700ed35fbf4a25$exports = {};
var $c85b8cdc6635697c$exports = {};

var $18oEd = parcelRequire("18oEd");
/** Built-in value references. */ var $c85b8cdc6635697c$var$Symbol = $18oEd.Symbol;
$c85b8cdc6635697c$exports = $c85b8cdc6635697c$var$Symbol;


var $775fa557c7482267$exports = {};

/** Used for built-in method references. */ var $775fa557c7482267$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $775fa557c7482267$var$hasOwnProperty = $775fa557c7482267$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $775fa557c7482267$var$nativeObjectToString = $775fa557c7482267$var$objectProto.toString;
/** Built-in value references. */ var $775fa557c7482267$var$symToStringTag = $c85b8cdc6635697c$exports ? $c85b8cdc6635697c$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $775fa557c7482267$var$getRawTag(value) {
    var isOwn = $775fa557c7482267$var$hasOwnProperty.call(value, $775fa557c7482267$var$symToStringTag), tag = value[$775fa557c7482267$var$symToStringTag];
    try {
        value[$775fa557c7482267$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $775fa557c7482267$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$775fa557c7482267$var$symToStringTag] = tag;
        else delete value[$775fa557c7482267$var$symToStringTag];
    }
    return result;
}
$775fa557c7482267$exports = $775fa557c7482267$var$getRawTag;


var $e5d3346926f3565d$exports = {};
/** Used for built-in method references. */ var $e5d3346926f3565d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e5d3346926f3565d$var$nativeObjectToString = $e5d3346926f3565d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e5d3346926f3565d$var$objectToString(value) {
    return $e5d3346926f3565d$var$nativeObjectToString.call(value);
}
$e5d3346926f3565d$exports = $e5d3346926f3565d$var$objectToString;


/** `Object#toString` result references. */ var $1b700ed35fbf4a25$var$nullTag = '[object Null]', $1b700ed35fbf4a25$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $1b700ed35fbf4a25$var$symToStringTag = $c85b8cdc6635697c$exports ? $c85b8cdc6635697c$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $1b700ed35fbf4a25$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $1b700ed35fbf4a25$var$undefinedTag : $1b700ed35fbf4a25$var$nullTag;
    return $1b700ed35fbf4a25$var$symToStringTag && $1b700ed35fbf4a25$var$symToStringTag in Object(value) ? $775fa557c7482267$exports(value) : $e5d3346926f3565d$exports(value);
}
$1b700ed35fbf4a25$exports = $1b700ed35fbf4a25$var$baseGetTag;


var $b638b78429ec3695$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b638b78429ec3695$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$b638b78429ec3695$exports = $b638b78429ec3695$var$isObject;


/** `Object#toString` result references. */ var $6429a69be43b682f$var$asyncTag = '[object AsyncFunction]', $6429a69be43b682f$var$funcTag = '[object Function]', $6429a69be43b682f$var$genTag = '[object GeneratorFunction]', $6429a69be43b682f$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $6429a69be43b682f$var$isFunction(value) {
    if (!$b638b78429ec3695$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $1b700ed35fbf4a25$exports(value);
    return tag == $6429a69be43b682f$var$funcTag || tag == $6429a69be43b682f$var$genTag || tag == $6429a69be43b682f$var$asyncTag || tag == $6429a69be43b682f$var$proxyTag;
}
$6429a69be43b682f$exports = $6429a69be43b682f$var$isFunction;


var $fe28f6a2afa2d4ba$exports = {};
var $f71575f7e10fc080$exports = {};

var $18oEd = parcelRequire("18oEd");
/** Used to detect overreaching core-js shims. */ var $f71575f7e10fc080$var$coreJsData = $18oEd["__core-js_shared__"];
$f71575f7e10fc080$exports = $f71575f7e10fc080$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $fe28f6a2afa2d4ba$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($f71575f7e10fc080$exports && $f71575f7e10fc080$exports.keys && $f71575f7e10fc080$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $fe28f6a2afa2d4ba$var$isMasked(func) {
    return !!$fe28f6a2afa2d4ba$var$maskSrcKey && $fe28f6a2afa2d4ba$var$maskSrcKey in func;
}
$fe28f6a2afa2d4ba$exports = $fe28f6a2afa2d4ba$var$isMasked;



var $d2076c87afa1d039$exports = {};
/** Used for built-in method references. */ var $d2076c87afa1d039$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $d2076c87afa1d039$var$funcToString = $d2076c87afa1d039$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $d2076c87afa1d039$var$toSource(func) {
    if (func != null) {
        try {
            return $d2076c87afa1d039$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$d2076c87afa1d039$exports = $d2076c87afa1d039$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b184524734883627$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b184524734883627$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $b184524734883627$var$funcProto = Function.prototype, $b184524734883627$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b184524734883627$var$funcToString = $b184524734883627$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b184524734883627$var$hasOwnProperty = $b184524734883627$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $b184524734883627$var$reIsNative = RegExp('^' + $b184524734883627$var$funcToString.call($b184524734883627$var$hasOwnProperty).replace($b184524734883627$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b184524734883627$var$baseIsNative(value) {
    if (!$b638b78429ec3695$exports(value) || $fe28f6a2afa2d4ba$exports(value)) return false;
    var pattern = $6429a69be43b682f$exports(value) ? $b184524734883627$var$reIsNative : $b184524734883627$var$reIsHostCtor;
    return pattern.test($d2076c87afa1d039$exports(value));
}
$b184524734883627$exports = $b184524734883627$var$baseIsNative;


var $f46af10f6d5a53cf$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $f46af10f6d5a53cf$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$f46af10f6d5a53cf$exports = $f46af10f6d5a53cf$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $2557930d4046fd55$var$getNative(object, key) {
    var value = $f46af10f6d5a53cf$exports(object, key);
    return $b184524734883627$exports(value) ? value : undefined;
}
$2557930d4046fd55$exports = $2557930d4046fd55$var$getNative;


/* Built-in method references that are verified to be native. */ var $900f7ccfd4d0e9a7$var$nativeCreate = $2557930d4046fd55$exports(Object, 'create');
$900f7ccfd4d0e9a7$exports = $900f7ccfd4d0e9a7$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3e5efb3713dbaae7$var$hashClear() {
    this.__data__ = $900f7ccfd4d0e9a7$exports ? $900f7ccfd4d0e9a7$exports(null) : {};
    this.size = 0;
}
$3e5efb3713dbaae7$exports = $3e5efb3713dbaae7$var$hashClear;


var $8563af2367454538$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8563af2367454538$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$8563af2367454538$exports = $8563af2367454538$var$hashDelete;


var $a87e95a9221fa763$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $a87e95a9221fa763$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $a87e95a9221fa763$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a87e95a9221fa763$var$hasOwnProperty = $a87e95a9221fa763$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a87e95a9221fa763$var$hashGet(key) {
    var data = this.__data__;
    if ($900f7ccfd4d0e9a7$exports) {
        var result = data[key];
        return result === $a87e95a9221fa763$var$HASH_UNDEFINED ? undefined : result;
    }
    return $a87e95a9221fa763$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$a87e95a9221fa763$exports = $a87e95a9221fa763$var$hashGet;


var $53a60d9fc76819eb$exports = {};

/** Used for built-in method references. */ var $53a60d9fc76819eb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $53a60d9fc76819eb$var$hasOwnProperty = $53a60d9fc76819eb$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $53a60d9fc76819eb$var$hashHas(key) {
    var data = this.__data__;
    return $900f7ccfd4d0e9a7$exports ? data[key] !== undefined : $53a60d9fc76819eb$var$hasOwnProperty.call(data, key);
}
$53a60d9fc76819eb$exports = $53a60d9fc76819eb$var$hashHas;


var $91fc20a12b2f9880$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $91fc20a12b2f9880$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $91fc20a12b2f9880$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $900f7ccfd4d0e9a7$exports && value === undefined ? $91fc20a12b2f9880$var$HASH_UNDEFINED : value;
    return this;
}
$91fc20a12b2f9880$exports = $91fc20a12b2f9880$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6503f75a59a89952$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$6503f75a59a89952$var$Hash.prototype.clear = $3e5efb3713dbaae7$exports;
$6503f75a59a89952$var$Hash.prototype['delete'] = $8563af2367454538$exports;
$6503f75a59a89952$var$Hash.prototype.get = $a87e95a9221fa763$exports;
$6503f75a59a89952$var$Hash.prototype.has = $53a60d9fc76819eb$exports;
$6503f75a59a89952$var$Hash.prototype.set = $91fc20a12b2f9880$exports;
$6503f75a59a89952$exports = $6503f75a59a89952$var$Hash;


var $1a6c88d37ef028db$exports = {};
var $175586938341b38b$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $175586938341b38b$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$175586938341b38b$exports = $175586938341b38b$var$listCacheClear;


var $f37b2fad0b772bc0$exports = {};
var $94b166b9da1b87b2$exports = {};
var $e69790e273490122$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e69790e273490122$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$e69790e273490122$exports = $e69790e273490122$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $94b166b9da1b87b2$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e69790e273490122$exports(array[length][0], key)) return length;
    }
    return -1;
}
$94b166b9da1b87b2$exports = $94b166b9da1b87b2$var$assocIndexOf;


/** Used for built-in method references. */ var $f37b2fad0b772bc0$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $f37b2fad0b772bc0$var$splice = $f37b2fad0b772bc0$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f37b2fad0b772bc0$var$listCacheDelete(key) {
    var data = this.__data__, index = $94b166b9da1b87b2$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $f37b2fad0b772bc0$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$f37b2fad0b772bc0$exports = $f37b2fad0b772bc0$var$listCacheDelete;


var $417cb97c289efd2f$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $417cb97c289efd2f$var$listCacheGet(key) {
    var data = this.__data__, index = $94b166b9da1b87b2$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$417cb97c289efd2f$exports = $417cb97c289efd2f$var$listCacheGet;


var $0df8504a62a10fee$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0df8504a62a10fee$var$listCacheHas(key) {
    return $94b166b9da1b87b2$exports(this.__data__, key) > -1;
}
$0df8504a62a10fee$exports = $0df8504a62a10fee$var$listCacheHas;


var $2472a3be1c59e579$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $2472a3be1c59e579$var$listCacheSet(key, value) {
    var data = this.__data__, index = $94b166b9da1b87b2$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$2472a3be1c59e579$exports = $2472a3be1c59e579$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1a6c88d37ef028db$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$1a6c88d37ef028db$var$ListCache.prototype.clear = $175586938341b38b$exports;
$1a6c88d37ef028db$var$ListCache.prototype['delete'] = $f37b2fad0b772bc0$exports;
$1a6c88d37ef028db$var$ListCache.prototype.get = $417cb97c289efd2f$exports;
$1a6c88d37ef028db$var$ListCache.prototype.has = $0df8504a62a10fee$exports;
$1a6c88d37ef028db$var$ListCache.prototype.set = $2472a3be1c59e579$exports;
$1a6c88d37ef028db$exports = $1a6c88d37ef028db$var$ListCache;


var $a003860332099d58$exports = {};


var $18oEd = parcelRequire("18oEd");
/* Built-in method references that are verified to be native. */ var $a003860332099d58$var$Map = $2557930d4046fd55$exports($18oEd, 'Map');
$a003860332099d58$exports = $a003860332099d58$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ab91e990c401f93e$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $6503f75a59a89952$exports,
        'map': new ($a003860332099d58$exports || $1a6c88d37ef028db$exports),
        'string': new $6503f75a59a89952$exports
    };
}
$ab91e990c401f93e$exports = $ab91e990c401f93e$var$mapCacheClear;


var $118b43e3bc5cf3f9$exports = {};
var $207b1cc9e669b886$exports = {};
var $0110692e3c7cc1c0$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $0110692e3c7cc1c0$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$0110692e3c7cc1c0$exports = $0110692e3c7cc1c0$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $207b1cc9e669b886$var$getMapData(map, key) {
    var data = map.__data__;
    return $0110692e3c7cc1c0$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$207b1cc9e669b886$exports = $207b1cc9e669b886$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $118b43e3bc5cf3f9$var$mapCacheDelete(key) {
    var result = $207b1cc9e669b886$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$118b43e3bc5cf3f9$exports = $118b43e3bc5cf3f9$var$mapCacheDelete;


var $19861348ee323de1$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $19861348ee323de1$var$mapCacheGet(key) {
    return $207b1cc9e669b886$exports(this, key).get(key);
}
$19861348ee323de1$exports = $19861348ee323de1$var$mapCacheGet;


var $2b21cae07c7e4266$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2b21cae07c7e4266$var$mapCacheHas(key) {
    return $207b1cc9e669b886$exports(this, key).has(key);
}
$2b21cae07c7e4266$exports = $2b21cae07c7e4266$var$mapCacheHas;


var $176ec4e4ec7f4f4d$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $176ec4e4ec7f4f4d$var$mapCacheSet(key, value) {
    var data = $207b1cc9e669b886$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$176ec4e4ec7f4f4d$exports = $176ec4e4ec7f4f4d$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ee1caf719581867c$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$ee1caf719581867c$var$MapCache.prototype.clear = $ab91e990c401f93e$exports;
$ee1caf719581867c$var$MapCache.prototype['delete'] = $118b43e3bc5cf3f9$exports;
$ee1caf719581867c$var$MapCache.prototype.get = $19861348ee323de1$exports;
$ee1caf719581867c$var$MapCache.prototype.has = $2b21cae07c7e4266$exports;
$ee1caf719581867c$var$MapCache.prototype.set = $176ec4e4ec7f4f4d$exports;
$ee1caf719581867c$exports = $ee1caf719581867c$var$MapCache;


var $9c20b3d4b3d36936$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $9c20b3d4b3d36936$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $9c20b3d4b3d36936$var$setCacheAdd(value) {
    this.__data__.set(value, $9c20b3d4b3d36936$var$HASH_UNDEFINED);
    return this;
}
$9c20b3d4b3d36936$exports = $9c20b3d4b3d36936$var$setCacheAdd;


var $2f87ad88609c3507$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2f87ad88609c3507$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$2f87ad88609c3507$exports = $2f87ad88609c3507$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $28a88767a5e44757$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $ee1caf719581867c$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$28a88767a5e44757$var$SetCache.prototype.add = $28a88767a5e44757$var$SetCache.prototype.push = $9c20b3d4b3d36936$exports;
$28a88767a5e44757$var$SetCache.prototype.has = $2f87ad88609c3507$exports;
$28a88767a5e44757$exports = $28a88767a5e44757$var$SetCache;


var $13b25753f7f9a158$exports = {};
var $0059592dbb8c36ce$exports = {};
var $d0e747e69b65cc40$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d0e747e69b65cc40$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$d0e747e69b65cc40$exports = $d0e747e69b65cc40$var$baseFindIndex;


var $adf76598d7cca20f$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $adf76598d7cca20f$var$baseIsNaN(value) {
    return value !== value;
}
$adf76598d7cca20f$exports = $adf76598d7cca20f$var$baseIsNaN;


var $564b1e31858c636b$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $564b1e31858c636b$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$564b1e31858c636b$exports = $564b1e31858c636b$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0059592dbb8c36ce$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $564b1e31858c636b$exports(array, value, fromIndex) : $d0e747e69b65cc40$exports(array, $adf76598d7cca20f$exports, fromIndex);
}
$0059592dbb8c36ce$exports = $0059592dbb8c36ce$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $13b25753f7f9a158$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $0059592dbb8c36ce$exports(array, value, 0) > -1;
}
$13b25753f7f9a158$exports = $13b25753f7f9a158$var$arrayIncludes;


var $807a751a82f05d31$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $807a751a82f05d31$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$807a751a82f05d31$exports = $807a751a82f05d31$var$arrayIncludesWith;


var $c70e9634df58d16c$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c70e9634df58d16c$var$cacheHas(cache, key) {
    return cache.has(key);
}
$c70e9634df58d16c$exports = $c70e9634df58d16c$var$cacheHas;


var $e39663202a38412e$exports = {};
var $60f38456f3e305c8$exports = {};


var $18oEd = parcelRequire("18oEd");
/* Built-in method references that are verified to be native. */ var $60f38456f3e305c8$var$Set = $2557930d4046fd55$exports($18oEd, 'Set');
$60f38456f3e305c8$exports = $60f38456f3e305c8$var$Set;


var $8d857175894c243c$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $8d857175894c243c$var$noop() {
// No operation performed.
}
$8d857175894c243c$exports = $8d857175894c243c$var$noop;


var $f7f2e53818a50d3e$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $f7f2e53818a50d3e$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$f7f2e53818a50d3e$exports = $f7f2e53818a50d3e$var$setToArray;


/** Used as references for various `Number` constants. */ var $e39663202a38412e$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $e39663202a38412e$var$createSet = !($60f38456f3e305c8$exports && 1 / $f7f2e53818a50d3e$exports(new $60f38456f3e305c8$exports([
    ,
    -0
]))[1] == $e39663202a38412e$var$INFINITY) ? $8d857175894c243c$exports : function(values) {
    return new $60f38456f3e305c8$exports(values);
};
$e39663202a38412e$exports = $e39663202a38412e$var$createSet;



/** Used as the size to enable large array optimizations. */ var $1f021559c45f6f1c$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $1f021559c45f6f1c$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $13b25753f7f9a158$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $807a751a82f05d31$exports;
    } else if (length >= $1f021559c45f6f1c$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $e39663202a38412e$exports(array);
        if (set) return $f7f2e53818a50d3e$exports(set);
        isCommon = false;
        includes = $c70e9634df58d16c$exports;
        seen = new $28a88767a5e44757$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$1f021559c45f6f1c$exports = $1f021559c45f6f1c$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $079b66e63d4d13b3$var$uniq(array) {
    return array && array.length ? $1f021559c45f6f1c$exports(array) : [];
}
$079b66e63d4d13b3$exports = $079b66e63d4d13b3$var$uniq;


parcelRequire("jMaZ8");



const $a629d37e152c47df$export$7828559fd07e0eb3 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation AddProjectRole(
      $projectId: UUID!
      $userRole: UserRole!
      $userTask: UserTask!
      $userId: String!
    ) {
      addProjectRole(
        userRole: $userRole
        userTask: $userTask
        projectId: $projectId
        userId: $userId
      )
    }
  `);
const $a629d37e152c47df$export$979dadd0a6b7c5e7 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
    mutation DeleteProjectRole($roleId: UUID!) {
      deleteProjectRole(roleId: $roleId)
    }
  `);


var $b9b61e84f1c78626$export$448e4850cad7c7b0;
var $b9b61e84f1c78626$export$a943aa9a0fca3f0b;
var $b9b61e84f1c78626$export$ddb906a32562356c;
var $b9b61e84f1c78626$export$d290fa47940df19d;
var $b9b61e84f1c78626$export$c78f52e017009743;
$b9b61e84f1c78626$export$448e4850cad7c7b0 = "h1_834353";
$b9b61e84f1c78626$export$a943aa9a0fca3f0b = "h2_834353";
$b9b61e84f1c78626$export$ddb906a32562356c = "user_834353";
$b9b61e84f1c78626$export$d290fa47940df19d = "email_834353";
$b9b61e84f1c78626$export$c78f52e017009743 = "userTable_834353";


function $13cde3d375487e0f$var$toColor(str) {
    let hash = 0;
    if (str.length === 0) throw new Error("String shouldn't be empty");
    for(let i = 0; i < str.length; i++){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let i = 0; i < 3; i++){
        const value = hash >> i * 8 & 255;
        color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
}
function $13cde3d375487e0f$var$contrastedTextColor(hex) {
    if (hex.indexOf("#") === 0) hex = hex.slice(1);
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    if (hex.length !== 6) throw new Error("Invalid HEX color.");
    var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
}
const $13cde3d375487e0f$export$a69f017b19597ff5 = ({ userBasedAccess: userBasedAccess = [] })=>{
    const users = (0, (/*@__PURE__*/$parcel$interopDefault($079b66e63d4d13b3$exports)))(userBasedAccess || []).map((user)=>{
        const [first, second] = user.split("@")[0];
        return {
            email: user,
            short: (first + second).toUpperCase(),
            color: $13cde3d375487e0f$var$toColor(user)
        };
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: users.map(({ short: short, email: email, color: color })=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                className: $b9b61e84f1c78626$export$ddb906a32562356c,
                style: {
                    backgroundColor: color,
                    color: $13cde3d375487e0f$var$contrastedTextColor(color)
                },
                initial: "initial",
                whileHover: "hover",
                children: [
                    short,
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                        className: $b9b61e84f1c78626$export$d290fa47940df19d,
                        variants: {
                            initial: {
                                opacity: 0,
                                y: "130%"
                            },
                            hover: {
                                opacity: 1,
                                y: "115%"
                            }
                        },
                        children: email
                    })
                ]
            }, email))
    });
};
const $13cde3d375487e0f$var$UserTable = ({ projectId: projectId, userId: userId, roles: roles })=>{
    const [applyDeleteProjectRole] = (0, $a629d37e152c47df$export$979dadd0a6b7c5e7)();
    const [applyAddProjectRole] = (0, $a629d37e152c47df$export$7828559fd07e0eb3)();
    const translation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("userAccess.userTable");
    const TaskLabelsTranslation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("userAccess.tasksLabels");
    const TaskLabels = {
        DEFINITION: TaskLabelsTranslation.definition,
        DIALOGUES: TaskLabelsTranslation.dialogues,
        FORMATTING: TaskLabelsTranslation.formatting,
        NARRATION: TaskLabelsTranslation.narration,
        RHESE: TaskLabelsTranslation.rhese,
        SYLLABLES: TaskLabelsTranslation.syllables
    };
    const tasksColumns = Object.keys((0, $b522cf181e75e62d$export$7b4fabbf7a6734d3)).map((key)=>({
            key: key,
            dataIndex: key,
            title: TaskLabels[key]
        }));
    const columns = [
        {
            key: "ROLE",
            dataIndex: "ROLE",
            title: translation.title
        }
    ].concat(tasksColumns);
    const preparerRoles = roles.filter((role)=>role.userRole === (0, $b522cf181e75e62d$export$eb3485a690c2f0b8).PREPARER);
    const correctorRoles = roles.filter((role)=>role.userRole === (0, $b522cf181e75e62d$export$eb3485a690c2f0b8).CORRECTOR);
    const preparerColumns = tasksColumns.map((task)=>preparerRoles.find((role)=>role.userTask === task.key));
    const correctorColumns = tasksColumns.map((task)=>correctorRoles.find((role)=>role.userTask === task.key));
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $b9b61e84f1c78626$export$c78f52e017009743,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                children: userId
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("tr", {
                            children: columns.map((column, i)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("th", {
                                    children: column.title
                                }, `${column?.key} ${i}`))
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("td", {
                                        children: translation.preparer
                                    }),
                                    preparerColumns.map((column, i)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                                                checked: !!column,
                                                onChange: (e)=>e.target.checked ? applyAddProjectRole({
                                                        variables: {
                                                            userId: userId,
                                                            projectId: projectId,
                                                            userRole: (0, $b522cf181e75e62d$export$eb3485a690c2f0b8).PREPARER,
                                                            userTask: tasksColumns[i].key
                                                        }
                                                    }) : applyDeleteProjectRole({
                                                        variables: {
                                                            roleId: column?.id
                                                        }
                                                    })
                                            })
                                        }, `${column?.id} ${i}`))
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("td", {
                                        children: translation.correction
                                    }),
                                    correctorColumns.map((column, i)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                                                checked: !!column,
                                                onChange: (e)=>{
                                                    e.target.checked ? applyAddProjectRole({
                                                        variables: {
                                                            userId: userId,
                                                            projectId: projectId,
                                                            userRole: (0, $b522cf181e75e62d$export$eb3485a690c2f0b8).CORRECTOR,
                                                            userTask: tasksColumns[i].key
                                                        }
                                                    }) : applyDeleteProjectRole({
                                                        variables: {
                                                            roleId: column?.id
                                                        }
                                                    });
                                                }
                                            })
                                        }, `${column?.id} ${i}`))
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $13cde3d375487e0f$export$b33b29ea893e70e1 = ({ roles: roles, userBasedAccess: userBasedAccess = [], projectId: projectId })=>{
    const users = userBasedAccess || [];
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: users.map((user, i)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($13cde3d375487e0f$var$UserTable, {
                projectId: projectId,
                userId: user,
                roles: roles.filter((role)=>role.userId === user)
            }, user + i))
    });
};



parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
var $21fd5dec04ec9daa$exports = {};

$parcel$export($21fd5dec04ec9daa$exports, "badgeStatus", () => $21fd5dec04ec9daa$export$c811345782c7e053, (v) => $21fd5dec04ec9daa$export$c811345782c7e053 = v);
$parcel$export($21fd5dec04ec9daa$exports, "indicator", () => $21fd5dec04ec9daa$export$e897cab68364f2de, (v) => $21fd5dec04ec9daa$export$e897cab68364f2de = v);
$parcel$export($21fd5dec04ec9daa$exports, "NOT_READY", () => $21fd5dec04ec9daa$export$2edaf3b7640d3269, (v) => $21fd5dec04ec9daa$export$2edaf3b7640d3269 = v);
$parcel$export($21fd5dec04ec9daa$exports, "READY_FOR_NARRATION", () => $21fd5dec04ec9daa$export$f88be83e4161bc8c, (v) => $21fd5dec04ec9daa$export$f88be83e4161bc8c = v);
$parcel$export($21fd5dec04ec9daa$exports, "NARRATION_COMPLETE", () => $21fd5dec04ec9daa$export$cac7123055ed7ead, (v) => $21fd5dec04ec9daa$export$cac7123055ed7ead = v);
$parcel$export($21fd5dec04ec9daa$exports, "COMPLETE", () => $21fd5dec04ec9daa$export$1660a2d7c2fff354, (v) => $21fd5dec04ec9daa$export$1660a2d7c2fff354 = v);
$parcel$export($21fd5dec04ec9daa$exports, "COMPLETE_BOOK", () => $21fd5dec04ec9daa$export$b32c8b2c03a7d425, (v) => $21fd5dec04ec9daa$export$b32c8b2c03a7d425 = v);
$parcel$export($21fd5dec04ec9daa$exports, "ARCHIVED", () => $21fd5dec04ec9daa$export$c936349447a77fe0, (v) => $21fd5dec04ec9daa$export$c936349447a77fe0 = v);
$parcel$export($21fd5dec04ec9daa$exports, "text", () => $21fd5dec04ec9daa$export$6f093cfa640b7166, (v) => $21fd5dec04ec9daa$export$6f093cfa640b7166 = v);
$parcel$export($21fd5dec04ec9daa$exports, "RESYNC", () => $21fd5dec04ec9daa$export$c25eb0d921a8ddcf, (v) => $21fd5dec04ec9daa$export$c25eb0d921a8ddcf = v);
$parcel$export($21fd5dec04ec9daa$exports, "small", () => $21fd5dec04ec9daa$export$3c17b0e969a90510, (v) => $21fd5dec04ec9daa$export$3c17b0e969a90510 = v);
var $21fd5dec04ec9daa$export$c811345782c7e053;
var $21fd5dec04ec9daa$export$e897cab68364f2de;
var $21fd5dec04ec9daa$export$2edaf3b7640d3269;
var $21fd5dec04ec9daa$export$f88be83e4161bc8c;
var $21fd5dec04ec9daa$export$cac7123055ed7ead;
var $21fd5dec04ec9daa$export$1660a2d7c2fff354;
var $21fd5dec04ec9daa$export$b32c8b2c03a7d425;
var $21fd5dec04ec9daa$export$c936349447a77fe0;
var $21fd5dec04ec9daa$export$6f093cfa640b7166;
var $21fd5dec04ec9daa$export$c25eb0d921a8ddcf;
var $21fd5dec04ec9daa$export$3c17b0e969a90510;
$21fd5dec04ec9daa$export$c811345782c7e053 = "badgeStatus_2ce6be";
$21fd5dec04ec9daa$export$e897cab68364f2de = "indicator_2ce6be";
$21fd5dec04ec9daa$export$2edaf3b7640d3269 = "NOT_READY_2ce6be";
$21fd5dec04ec9daa$export$f88be83e4161bc8c = "READY_FOR_NARRATION_2ce6be";
$21fd5dec04ec9daa$export$cac7123055ed7ead = "NARRATION_COMPLETE_2ce6be";
$21fd5dec04ec9daa$export$1660a2d7c2fff354 = "COMPLETE_2ce6be";
$21fd5dec04ec9daa$export$b32c8b2c03a7d425 = "COMPLETE_BOOK_2ce6be";
$21fd5dec04ec9daa$export$c936349447a77fe0 = "ARCHIVED_2ce6be";
$21fd5dec04ec9daa$export$6f093cfa640b7166 = "text_2ce6be";
$21fd5dec04ec9daa$export$c25eb0d921a8ddcf = "RESYNC_2ce6be";
$21fd5dec04ec9daa$export$3c17b0e969a90510 = "small_2ce6be";




function $978012cac829448d$export$2e2bcd8739ae039({ className: className, bookStatusLabel: bookStatusLabel, small: small }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($21fd5dec04ec9daa$exports.badgeStatus, className, $21fd5dec04ec9daa$exports[`${bookStatusLabel}`], {
            [$21fd5dec04ec9daa$exports.small]: small
        }),
        children: [
            bookStatusLabel === "RESYNC" ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($21fd5dec04ec9daa$exports.indicator, $21fd5dec04ec9daa$exports[`${bookStatusLabel}`])
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $21fd5dec04ec9daa$exports.text,
                children: t("project.actionBar.progress.bookStateStatus." + `${bookStatusLabel.toLowerCase()}`)
            })
        ]
    });
}





var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");


var $ktS49 = parcelRequire("ktS49");

var $eGh7a = parcelRequire("eGh7a");

var $hvG6u = parcelRequire("hvG6u");

const $3d603f10698d8699$var$isPrimitive = (value)=>typeof value !== 'object' && typeof value !== 'function' || value === null;
var $3d603f10698d8699$export$2e2bcd8739ae039 = $3d603f10698d8699$var$isPrimitive;










var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");


var $ktS49 = parcelRequire("ktS49");

var $hvG6u = parcelRequire("hvG6u");






var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $d2cf2437db958736$var$MenuContext = /*#__PURE__*/ (0, $jMaZ8.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false
});
var $d2cf2437db958736$export$2e2bcd8739ae039 = $d2cf2437db958736$var$MenuContext;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


"use client";
var $77926a770e0d1e48$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $77926a770e0d1e48$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed } = props, restProps = $77926a770e0d1e48$var$__rest(props, [
        "prefixCls",
        "className",
        "dashed"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $8c61135cfe4c0efa$export$2e2bcd8739ae039), Object.assign({
        className: classString
    }, restProps));
};
var $77926a770e0d1e48$export$2e2bcd8739ae039 = $77926a770e0d1e48$var$MenuDivider;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $a6yuN = parcelRequire("a6yuN");

var $hvG6u = parcelRequire("hvG6u");




"use client";
const $bffb87c5aab50f89$var$MenuItem = (props)=>{
    var _a;
    const { className: className, children: children, icon: icon, title: title, danger: danger, extra: extra } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, inlineCollapsed: isInlineCollapsed } = $jMaZ8.useContext((0, $d2cf2437db958736$export$2e2bcd8739ae039));
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children === null || children === void 0 ? void 0 : children[0];
        const wrapNode = /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-title-content`, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            })
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $jMaZ8.isValidElement(children) && children.type === 'span') {
            if (children && inlineCollapsed && firstLevel && typeof label === 'string') return /*#__PURE__*/ $jMaZ8.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed: siderCollapsed } = $jMaZ8.useContext((0, $9e668e80febfb5a2$export$63554aebd2a6d54c));
    let tooltipTitle = title;
    if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
    else if (title === false) tooltipTitle = '';
    const tooltipProps = {
        title: tooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, $a6yuN.default)(children).length;
    let returnNode = /*#__PURE__*/ $jMaZ8.createElement((0, $77bbeaacfd0ea5eb$export$2e2bcd8739ae039), Object.assign({}, (0, $hvG6u.default)(props, [
        'title',
        'icon',
        'danger'
    ]), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        title: typeof title === 'string' ? title : undefined
    }), (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(/*#__PURE__*/ $jMaZ8.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', `${prefixCls}-item-icon`)
    }), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
        placement: direction === 'rtl' ? 'left' : 'right',
        classNames: {
            root: `${prefixCls}-inline-collapsed-tooltip`
        }
    }), returnNode);
    return returnNode;
};
var $bffb87c5aab50f89$export$2e2bcd8739ae039 = $bffb87c5aab50f89$var$MenuItem;



var $jMaZ8 = parcelRequire("jMaZ8");

var $1cfGC = parcelRequire("1cfGC");

"use client";
var $c4e5952f5dffa1aa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c4e5952f5dffa1aa$var$OverrideContext = /*#__PURE__*/ $jMaZ8.createContext(null);
const $c4e5952f5dffa1aa$export$9bd434816b0530d0 = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { children: children } = props, restProps = $c4e5952f5dffa1aa$var$__rest(props, [
        "children"
    ]);
    const override = $jMaZ8.useContext($c4e5952f5dffa1aa$var$OverrideContext);
    const context = $jMaZ8.useMemo(()=>Object.assign(Object.assign({}, override), restProps), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $1cfGC.supportNodeRef)(children);
    const mergedRef = (0, $1cfGC.useComposeRef)(ref, canRef ? (0, $1cfGC.getNodeRef)(children) : null);
    return /*#__PURE__*/ $jMaZ8.createElement($c4e5952f5dffa1aa$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
        space: true
    }, canRef ? /*#__PURE__*/ $jMaZ8.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $c4e5952f5dffa1aa$export$2e2bcd8739ae039 = $c4e5952f5dffa1aa$var$OverrideContext;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");


parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $c7cdd3efaa86e69c$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: 'none',
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'bottom',
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color ${motionDurationSlow}`,
                    `background ${motionDurationSlow}`
                ].join(',')
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: 'none'
            }
        }
    };
};
var $c7cdd3efaa86e69c$export$2e2bcd8739ae039 = $c7cdd3efaa86e69c$var$getHorizontalStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $b0ead0c432dab954$var$getRTLStyle = (_ref)=>{
    let { componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc } = _ref;
    return {
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: '100% 0'
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                '&::before': {
                    transform: `rotate(-45deg) translateY(${(0, $4g3I0.unit)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(45deg) translateY(${(0, $4g3I0.unit)(menuArrowOffset)})`
                }
            }
        }
    };
};
var $b0ead0c432dab954$export$2e2bcd8739ae039 = $b0ead0c432dab954$var$getRTLStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $502af2afb77dfe28$var$accessibilityFocus = (token)=>Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token));
const $502af2afb77dfe28$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, subMenuItemSelectedColor: subMenuItemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: Object.assign({}, $502af2afb77dfe28$var$accessibilityFocus(token)),
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                '&-group-title, &-extra': {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: Object.assign({}, $502af2afb77dfe28$var$accessibilityFocus(token))
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                '&, &:hover': {
                    color: 'inherit'
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                'a, a:hover': {
                    color: 'inherit'
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: Object.assign(Object.assign({}, themeSuffix === 'dark' ? {
                borderBottom: 0
            } : {}), {
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    '&::after': {
                        position: 'absolute',
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, $4g3I0.unit)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    '&:hover, &-active, &-open': {
                        background: horizontalItemHoverBg,
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    '&-selected': {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        '&:hover': {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            }),
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $4g3I0.unit)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: 'relative',
                    '&::after': {
                        position: 'absolute',
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $4g3I0.unit)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: 'scaleY(0.0001)',
                        opacity: 0,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseOut}`,
                            `opacity ${motionDurationMid} ${motionEaseOut}`
                        ].join(','),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        '&::after': {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    '&::after': {
                        transform: 'scaleY(1)',
                        opacity: 1,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseInOut}`,
                            `opacity ${motionDurationMid} ${motionEaseInOut}`
                        ].join(',')
                    }
                }
            }
        }
    };
};
var $502af2afb77dfe28$export$2e2bcd8739ae039 = $502af2afb77dfe28$var$getThemeStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $fd64a08923750c44$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth, itemPaddingInline: itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: 'relative',
            overflow: 'hidden'
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $4g3I0.unit)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $4g3I0.unit)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $fd64a08923750c44$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, motionEaseOut: motionEaseOut, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationFast: motionDurationFast, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $4g3I0.unit)(itemHeight),
        listStylePosition: 'inside',
        listStyleType: 'disc'
    };
    return [
        {
            [componentCls]: {
                '&-inline, &-vertical': Object.assign({
                    [`&${componentCls}-root`]: {
                        boxShadow: 'none'
                    }
                }, $fd64a08923750c44$var$getVerticalInlineStyle(token))
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: Object.assign(Object.assign({}, $fd64a08923750c44$var$getVerticalInlineStyle(token)), {
                    boxShadow: boxShadowSecondary
                })
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $4g3I0.unit)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: '0',
                overflow: 'hidden',
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: '100%',
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: 'flex',
                        alignItems: 'center',
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background ${motionDurationSlow}`,
                            `padding ${motionDurationFast} ${motionEaseOut}`
                        ].join(','),
                        [`> ${componentCls}-title-content`]: {
                            flex: 'auto',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        '> *': {
                            flex: 'none'
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: 'center'
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $4g3I0.unit)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, $4g3I0.unit)(itemMarginInline)})`,
                    textOverflow: 'clip',
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $4g3I0.unit)(itemHeight),
                        '+ span': {
                            display: 'inline-block',
                            opacity: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: 'inline-block'
                },
                '&-tooltip': {
                    pointerEvents: 'none',
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: 'none'
                    },
                    'a, a:hover': {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
                    paddingInline: paddingXS
                })
            }
        }
    ];
};
var $fd64a08923750c44$export$2e2bcd8739ae039 = $fd64a08923750c44$var$getVerticalStyle;


const $bcd65640d1cb4035$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: 'relative',
            display: 'block',
            margin: 0,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition: [
                `border-color ${motionDurationSlow}`,
                `background ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(','),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(','),
                '+ span': {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(',')
                }
            },
            [`${componentCls}-item-icon`]: Object.assign({}, (0, $134f73cf3485ce91$export$171ccda7bc085e59)()),
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: 'none !important',
            cursor: 'not-allowed',
            '&::after': {
                borderColor: 'transparent !important'
            },
            a: {
                color: 'inherit !important',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            [`> ${componentCls}-submenu-title`]: {
                color: 'inherit !important',
                cursor: 'not-allowed'
            }
        }
    };
};
const $bcd65640d1cb4035$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            '&-expand-icon, &-arrow': {
                position: 'absolute',
                top: '50%',
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: 'currentcolor',
                transform: 'translateY(-50%)',
                transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
            },
            '&-arrow': {
                // →
                '&::before, &::after': {
                    position: 'absolute',
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: 'currentcolor',
                    borderRadius: borderRadius,
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `transform ${motionDurationSlow} ${motionEaseInOut}`,
                        `top ${motionDurationSlow} ${motionEaseInOut}`,
                        `color ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(','),
                    content: '""'
                },
                '&::before': {
                    transform: `rotate(45deg) translateY(${(0, $4g3I0.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(-45deg) translateY(${(0, $4g3I0.unit)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $bcd65640d1cb4035$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize } = token;
    return [
        // Misc
        {
            '': {
                [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
                    // Hidden
                    '&-hidden': {
                        display: 'none'
                    }
                })
            },
            [`${componentCls}-submenu-hidden`]: {
                display: 'none'
            }
        },
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                listStyle: 'none',
                outline: 'none',
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                'ul, ol': {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                },
                // Overflow ellipsis
                '&-overflow': {
                    display: 'flex',
                    [`${componentCls}-item`]: {
                        flex: 'none'
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $4g3I0.unit)(paddingXS)} ${(0, $4g3I0.unit)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationMid} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: 'initial',
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    '&-with-extra': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: '100%'
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [`> ${antCls}-typography-ellipsis-single-line`]: {
                        display: 'inline',
                        verticalAlign: 'unset'
                    },
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: 'auto',
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item a`]: {
                    '&::before': {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'transparent',
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: 'hidden',
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    '&-dashed': {
                        borderStyle: 'dashed'
                    }
                }
            }), $bcd65640d1cb4035$var$genMenuItemStyle(token)), {
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $4g3I0.unit)(token.calc(fontSize).mul(2).equal())} ${(0, $4g3I0.unit)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                '&-submenu': {
                    '&-popup': {
                        position: 'absolute',
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: 'none',
                        transformOrigin: '0 0',
                        [`&${componentCls}-submenu`]: {
                            background: 'transparent'
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        '&::before': {
                            position: 'absolute',
                            inset: 0,
                            zIndex: -1,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: Object.assign(Object.assign(Object.assign({
                            borderRadius: borderRadiusLG
                        }, $bcd65640d1cb4035$var$genMenuItemStyle(token)), $bcd65640d1cb4035$var$genSubMenuArrowStyle(token)), {
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        })
                    },
                    [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
                        transformOrigin: '100% 0'
                    },
                    [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
                        transformOrigin: '100% 100%'
                    },
                    [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
                        transformOrigin: '0 100%'
                    },
                    [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
                        transformOrigin: '0 0'
                    },
                    [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
                        paddingInlineEnd: token.paddingXS
                    },
                    [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
                        paddingInlineStart: token.paddingXS
                    },
                    [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
                        paddingBottom: token.paddingXS
                    },
                    [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
                        paddingTop: token.paddingXS
                    }
                }
            }), $bcd65640d1cb4035$var$genSubMenuArrowStyle(token)), {
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    '&::before': {
                        transform: `rotate(-45deg) translateX(${(0, $4g3I0.unit)(menuArrowOffset)})`
                    },
                    '&::after': {
                        transform: `rotate(45deg) translateX(${(0, $4g3I0.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $4g3I0.unit)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    '&::after': {
                        transform: `rotate(-45deg) translateX(${(0, $4g3I0.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    '&::before': {
                        transform: `rotate(45deg) translateX(${(0, $4g3I0.unit)(menuArrowOffset)})`
                    }
                }
            })
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: 'inherit'
                }
            }
        }
    ];
};
const $bcd65640d1cb4035$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c;
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = (_a = token.activeBarWidth) !== null && _a !== void 0 ? _a : 0;
    const activeBarBorderWidth = (_b = token.activeBarBorderWidth) !== null && _b !== void 0 ? _b : lineWidth;
    const itemMarginInline = (_c = token.itemMarginInline) !== null && _c !== void 0 ? _c : token.marginXXS;
    const colorTextDark = new (0, $6xABB.FastColor)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: 'transparent',
        horizontalItemSelectedBg: 'transparent',
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: 'transparent',
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $6xABB.FastColor)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: '#001529',
        darkPopupBg: '#001529',
        darkSubMenuItemBg: '#000c17',
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: 'transparent',
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$bcd65640d1cb4035$export$2e2bcd8739ae039 = function(prefixCls) {
    let rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
    let injectStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const useStyle = (0, $263539dacc5f409d$export$51ec95de45185b42)('Menu', (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $8APUt.merge)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $8APUt.merge)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: 'transparent',
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $bcd65640d1cb4035$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $c7cdd3efaa86e69c$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $fd64a08923750c44$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $502af2afb77dfe28$export$2e2bcd8739ae039)(menuToken, 'light'),
            (0, $502af2afb77dfe28$export$2e2bcd8739ae039)(menuDarkToken, 'dark'),
            // RTL
            (0, $b0ead0c432dab954$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $86923e4ddcddee59$export$2e2bcd8739ae039)(menuToken),
            (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(menuToken, 'slide-up'),
            (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(menuToken, 'slide-down'),
            (0, $90d7c1b8e663dcab$export$f5d123412490d9dc)(menuToken, 'zoom-big')
        ];
    }, $bcd65640d1cb4035$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                'colorGroupTitle',
                'groupTitleColor'
            ],
            [
                'radiusItem',
                'itemBorderRadius'
            ],
            [
                'radiusSubMenuItem',
                'subMenuItemBorderRadius'
            ],
            [
                'colorItemText',
                'itemColor'
            ],
            [
                'colorItemTextHover',
                'itemHoverColor'
            ],
            [
                'colorItemTextHoverHorizontal',
                'horizontalItemHoverColor'
            ],
            [
                'colorItemTextSelected',
                'itemSelectedColor'
            ],
            [
                'colorItemTextSelectedHorizontal',
                'horizontalItemSelectedColor'
            ],
            [
                'colorItemTextDisabled',
                'itemDisabledColor'
            ],
            [
                'colorDangerItemText',
                'dangerItemColor'
            ],
            [
                'colorDangerItemTextHover',
                'dangerItemHoverColor'
            ],
            [
                'colorDangerItemTextSelected',
                'dangerItemSelectedColor'
            ],
            [
                'colorDangerItemBgActive',
                'dangerItemActiveBg'
            ],
            [
                'colorDangerItemBgSelected',
                'dangerItemSelectedBg'
            ],
            [
                'colorItemBg',
                'itemBg'
            ],
            [
                'colorItemBgHover',
                'itemHoverBg'
            ],
            [
                'colorSubItemBg',
                'subMenuItemBg'
            ],
            [
                'colorItemBgActive',
                'itemActiveBg'
            ],
            [
                'colorItemBgSelectedHorizontal',
                'horizontalItemSelectedBg'
            ],
            [
                'colorActiveBarWidth',
                'activeBarWidth'
            ],
            [
                'colorActiveBarHeight',
                'activeBarHeight'
            ],
            [
                'colorActiveBarBorderSize',
                'activeBarBorderWidth'
            ],
            [
                'colorItemBgSelected',
                'itemSelectedBg'
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


var $hvG6u = parcelRequire("hvG6u");



"use client";
const $612288af3b4dacc7$var$SubMenu = (props)=>{
    var _a;
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $jMaZ8.useContext((0, $d2cf2437db958736$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme } = context;
    const parentPath = (0, $69440eab1161c178$export$d3d2d0a05677870a)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $jMaZ8.isValidElement(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(/*#__PURE__*/ $jMaZ8.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', `${prefixCls}-item-icon`)
        }), titleIsSpan ? title : /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $jMaZ8.useMemo(()=>Object.assign(Object.assign({}, context), {
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $5f1c4f12ab1f6aec$export$3e7906d4075187a4)('Menu');
    return /*#__PURE__*/ $jMaZ8.createElement((0, $d2cf2437db958736$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $c8557bbeba2653ba$export$2e2bcd8739ae039), Object.assign({}, (0, $hvG6u.default)(props, [
        'icon'
    ]), {
        title: titleNode,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, popupClassName, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: Object.assign({
            zIndex: zIndex
        }, props.popupStyle)
    })));
};
var $612288af3b4dacc7$export$2e2bcd8739ae039 = $612288af3b4dacc7$var$SubMenu;


"use client";
var $70bd6b3cba6faf54$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $70bd6b3cba6faf54$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $70bd6b3cba6faf54$var$MENU_COMPONENTS = {
    item: (0, $bffb87c5aab50f89$export$2e2bcd8739ae039),
    submenu: (0, $612288af3b4dacc7$export$2e2bcd8739ae039),
    divider: (0, $77926a770e0d1e48$export$2e2bcd8739ae039)
};
const $70bd6b3cba6faf54$var$InternalMenu = /*#__PURE__*/ (0, $jMaZ8.forwardRef)((props, ref)=>{
    var _a;
    const override = $jMaZ8.useContext((0, $c4e5952f5dffa1aa$export$2e2bcd8739ae039));
    const overrideObj = override || {};
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, menu: menu } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = 'light', expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName } = props, restProps = $70bd6b3cba6faf54$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "theme",
        "expandIcon",
        "_internalDisableMenuItemTitleTooltip",
        "inlineCollapsed",
        "siderCollapsed",
        "rootClassName",
        "mode",
        "selectable",
        "onClick",
        "overflowedIndicatorPopupClassName"
    ]);
    const passedProps = (0, $hvG6u.default)(restProps, [
        'collapsedWidth'
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Menu');
        warning(!('inlineCollapsed' in props && mode !== 'inline'), 'usage', '`inlineCollapsed` should only be used when `mode` is inline.');
        warning.deprecated('items' in props && !props.children, 'children', 'items');
    }
    (_a = overrideObj.validator) === null || _a === void 0 || _a.call(overrideObj, {
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $ktS49.default)(function() {
        var _a;
        onClick === null || onClick === void 0 || onClick.apply(void 0, arguments);
        (_a = overrideObj.onClick) === null || _a === void 0 || _a.call(overrideObj);
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed !== null && inlineCollapsed !== void 0 ? inlineCollapsed : siderCollapsed;
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $230791b6f61cb981$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $bcd65640d1cb4035$export$2e2bcd8739ae039)(prefixCls, rootCls, !override);
    const menuClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-${theme}`, menu === null || menu === void 0 ? void 0 : menu.className, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $jMaZ8.useMemo(()=>{
        var _a, _b;
        if (typeof expandIcon === 'function' || $70bd6b3cba6faf54$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if (typeof overrideObj.expandIcon === 'function' || $70bd6b3cba6faf54$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if (typeof (menu === null || menu === void 0 ? void 0 : menu.expandIcon) === 'function' || $70bd6b3cba6faf54$var$isEmptyIcon(menu === null || menu === void 0 ? void 0 : menu.expandIcon)) return (menu === null || menu === void 0 ? void 0 : menu.expandIcon) || null;
        const mergedIcon = (_a = expandIcon !== null && expandIcon !== void 0 ? expandIcon : overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon) !== null && _a !== void 0 ? _a : menu === null || menu === void 0 ? void 0 : menu.expandIcon;
        return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(mergedIcon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $jMaZ8.isValidElement(mergedIcon) ? (_b = mergedIcon.props) === null || _b === void 0 ? void 0 : _b.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon,
        menu === null || menu === void 0 ? void 0 : menu.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $jMaZ8.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme
    ]);
    // ========================= Render ==========================
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $c4e5952f5dffa1aa$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $d2cf2437db958736$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $f8c4d030e21306d3$export$2e2bcd8739ae039), Object.assign({
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $jMaZ8.createElement((0, $49848ec5154332ea$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick
    }, passedProps, {
        inlineCollapsed: mergedInlineCollapsed,
        style: Object.assign(Object.assign({}, menu === null || menu === void 0 ? void 0 : menu.style), style),
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls),
        _internalComponents: $70bd6b3cba6faf54$var$MENU_COMPONENTS
    })))));
});
var $70bd6b3cba6faf54$export$2e2bcd8739ae039 = $70bd6b3cba6faf54$var$InternalMenu;





"use client";
const $a1417d0c85becb5c$var$Menu = /*#__PURE__*/ (0, $jMaZ8.forwardRef)((props, ref)=>{
    const menuRef = (0, $jMaZ8.useRef)(null);
    const context = $jMaZ8.useContext((0, $9e668e80febfb5a2$export$63554aebd2a6d54c));
    (0, $jMaZ8.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                var _a;
                (_a = menuRef.current) === null || _a === void 0 || _a.focus(options);
            }
        }));
    return /*#__PURE__*/ $jMaZ8.createElement((0, $70bd6b3cba6faf54$export$2e2bcd8739ae039), Object.assign({
        ref: menuRef
    }, props, context));
});
$a1417d0c85becb5c$var$Menu.Item = (0, $bffb87c5aab50f89$export$2e2bcd8739ae039);
$a1417d0c85becb5c$var$Menu.SubMenu = (0, $612288af3b4dacc7$export$2e2bcd8739ae039);
$a1417d0c85becb5c$var$Menu.Divider = (0, $77926a770e0d1e48$export$2e2bcd8739ae039);
$a1417d0c85becb5c$var$Menu.ItemGroup = (0, $caf0f58125b0bd87$export$2e2bcd8739ae039);
$a1417d0c85becb5c$var$Menu.displayName = 'Menu';
var $a1417d0c85becb5c$export$2e2bcd8739ae039 = $a1417d0c85becb5c$var$Menu;




parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");




parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $1de7f199555348f0$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    '&:hover': {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $1de7f199555348f0$export$2e2bcd8739ae039 = $1de7f199555348f0$var$genStatusStyle;


// =============================== Base ===============================
const $1975249d2bcc7e85$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated } = token;
    return [
        {
            [componentCls]: {
                position: 'absolute',
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: 'block',
                // A placeholder out of dropdown visible range to avoid close when user moving
                '&::before': {
                    position: 'absolute',
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                '&-menu-vertical': {
                    maxHeight: '100vh',
                    overflowY: 'auto'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: 'relative',
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
                    display: 'none'
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $a33dc8ffa22f5459$export$e801b802b037de6a)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $a33dc8ffa22f5459$export$dd9f089fa5e819fe)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $a33dc8ffa22f5459$export$f40f41df328ebc38)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $a33dc8ffa22f5459$export$f7243fdb9c27c3b7)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $118f758c39257d0a$export$2e2bcd8739ae039)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: 'relative',
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                background: 'transparent',
                boxShadow: 'none',
                transformOrigin: '0 0',
                'ul, li': {
                    listStyle: 'none',
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                [menuCls]: Object.assign(Object.assign({
                    padding: dropdownEdgeChildPadding,
                    listStyleType: 'none',
                    backgroundColor: colorBgElevated,
                    backgroundClip: 'padding-box',
                    borderRadius: token.borderRadiusLG,
                    outline: 'none',
                    boxShadow: token.boxShadowSecondary
                }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)), {
                    '&:empty': {
                        padding: 0,
                        boxShadow: 'none'
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $4g3I0.unit)(paddingBlock)} ${(0, $4g3I0.unit)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: 'auto',
                        '&-with-extra': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: '100%'
                        },
                        '> a': {
                            color: 'inherit',
                            transition: `all ${motionDurationMid}`,
                            '&:hover': {
                                color: 'inherit'
                            },
                            '&::after': {
                                position: 'absolute',
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: 'auto',
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: Object.assign(Object.assign({
                        display: 'flex',
                        margin: 0,
                        padding: `${(0, $4g3I0.unit)(paddingBlock)} ${(0, $4g3I0.unit)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: 'normal',
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: 'pointer',
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        '&:hover, &-active': {
                            backgroundColor: token.controlItemBgHover
                        }
                    }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)), {
                        '&-selected': {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            '&:hover, &-active': {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        '&-disabled': {
                            color: colorTextDisabled,
                            cursor: 'not-allowed',
                            '&:hover': {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: 'not-allowed'
                            },
                            a: {
                                pointerEvents: 'none'
                            }
                        },
                        '&-divider': {
                            height: 1,
                            // By design
                            margin: `${(0, $4g3I0.unit)(token.marginXXS)} 0`,
                            overflow: 'hidden',
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: 'absolute',
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: '0 !important',
                                color: token.colorTextDescription,
                                fontSize: fontSizeIcon,
                                fontStyle: 'normal'
                            }
                        }
                    }),
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $4g3I0.unit)(token.marginXS)}`,
                        padding: 0,
                        listStyle: 'none'
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: 'relative'
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: 'not-allowed'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                })
            })
        },
        // Follow code may reuse in other components
        [
            (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $a33dc8ffa22f5459$export$9018e60daecf7a6c)(token, 'slide-down'),
            (0, $d516976ac142085d$export$913b1b7e3288c319)(token, 'move-up'),
            (0, $d516976ac142085d$export$913b1b7e3288c319)(token, 'move-down'),
            (0, $90d7c1b8e663dcab$export$f5d123412490d9dc)(token, 'zoom-big')
        ]
    ];
};
const $1975249d2bcc7e85$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2
    }, (0, $118f758c39257d0a$export$bddc192327bb9823)({
        contentRadius: token.borderRadiusLG,
        limitVerticalRadius: true
    })), (0, $86b31e2653f1279c$export$87e38ee403661ccc)(token));
var $1975249d2bcc7e85$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Dropdown', (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $8APUt.merge)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $1975249d2bcc7e85$var$genBaseStyle(dropdownToken),
        (0, $1de7f199555348f0$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $1975249d2bcc7e85$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $40cb1b7ba27adc3c$var$_Placements = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'top',
    'bottom'
];
const $40cb1b7ba27adc3c$var$Dropdown = (props)=>{
    var _a;
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, visible: // Deprecated
    visible, onVisibleChange: onVisibleChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = '', overlay: overlay, transitionName: transitionName } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, dropdown: dropdown } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    // Warning for deprecated usage
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Dropdown');
    [
        [
            'visible',
            'open'
        ],
        [
            'onVisibleChange',
            'onOpenChange'
        ]
    ].forEach((_ref)=>{
        let [deprecatedName, newName] = _ref;
        warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
    warning.deprecated(!('overlay' in props), 'overlay', 'menu');
    const memoTransitionName = $jMaZ8.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return `${rootPrefixCls}-slide-down`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $jMaZ8.useMemo(()=>{
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) return placement.slice(0, placement.indexOf('Center'));
        return placement;
    }, [
        placement,
        direction
    ]);
    if (placement.includes('Center')) {
        const newPlacement = placement.slice(0, placement.indexOf('Center'));
        warning(!placement.includes('Center'), 'deprecated', `You are using '${placement}' placement in Dropdown, which is deprecated. Try to use '${newPlacement}' instead.`);
    }
    [
        [
            'visible',
            'open'
        ],
        [
            'onVisibleChange',
            'onOpenChange'
        ]
    ].forEach((_ref2)=>{
        let [deprecatedName, newName] = _ref2;
        warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $1975249d2bcc7e85$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const child = $jMaZ8.Children.only((0, $3d603f10698d8699$export$2e2bcd8739ae039)(children) ? /*#__PURE__*/ $jMaZ8.createElement("span", null, children) : children);
    const dropdownTrigger = (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(child, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, child.props.className),
        disabled: (_a = child.props.disabled) !== null && _a !== void 0 ? _a : disabled
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!(triggerActions === null || triggerActions === void 0 ? void 0 : triggerActions.includes('contextMenu'));
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $eGh7a.default)(false, {
        value: open !== null && open !== void 0 ? open : visible
    });
    const onInnerOpenChange = (0, $ktS49.default)((nextOpen)=>{
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen, {
            source: 'trigger'
        });
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(nextOpen);
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, dropdown === null || dropdown === void 0 ? void 0 : dropdown.className, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const builtinPlacements = (0, $7302df8ea39a81cd$export$2e2bcd8739ae039)({
        arrowPointAtCenter: typeof arrow === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = $jMaZ8.useCallback(()=>{
        if ((menu === null || menu === void 0 ? void 0 : menu.selectable) && (menu === null || menu === void 0 ? void 0 : menu.multiple)) return;
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(false, {
            source: 'menu'
        });
        setOpen(false);
    }, [
        menu === null || menu === void 0 ? void 0 : menu.selectable,
        menu === null || menu === void 0 ? void 0 : menu.multiple
    ]);
    const renderOverlay = ()=>{
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        let overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) overlayNode = /*#__PURE__*/ $jMaZ8.createElement((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), Object.assign({}, menu));
        else if (typeof overlay === 'function') overlayNode = overlay();
        else overlayNode = overlay;
        if (dropdownRender) overlayNode = dropdownRender(overlayNode);
        overlayNode = $jMaZ8.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $jMaZ8.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $c4e5952f5dffa1aa$export$9bd434816b0530d0), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $jMaZ8.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, /*#__PURE__*/ $jMaZ8.createElement((0, $467563d24654b2cc$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: (_ref3)=>{
                let { mode: mode } = _ref3;
                // Warning if use other mode
                warning(!mode || mode === 'vertical', 'usage', `mode="${mode}" is not supported for Dropdown's Menu.`);
            }
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $5f1c4f12ab1f6aec$export$3e7906d4075187a4)('Dropdown', overlayStyle === null || overlayStyle === void 0 ? void 0 : overlayStyle.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $jMaZ8.createElement((0, $5b2f2e9aebf27f9d$export$2e2bcd8739ae039), Object.assign({
        alignPoint: alignPoint
    }, (0, $hvG6u.default)(props, [
        'rootClassName'
    ]), {
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: Object.assign(Object.assign(Object.assign({}, dropdown === null || dropdown === void 0 ? void 0 : dropdown.style), overlayStyle), {
            zIndex: zIndex
        })
    }), dropdownTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $jMaZ8.createElement((0, $215be6e5138b7346$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return wrapCSSVar(renderNode);
};
// We don't care debug panel
const $40cb1b7ba27adc3c$var$PurePanel = (0, $122b6ffb60331d40$export$2e2bcd8739ae039)($40cb1b7ba27adc3c$var$Dropdown, 'align', undefined, 'dropdown', (prefixCls)=>prefixCls);
/* istanbul ignore next */ const $40cb1b7ba27adc3c$var$WrapPurePanel = (props)=>/*#__PURE__*/ $jMaZ8.createElement($40cb1b7ba27adc3c$var$PurePanel, Object.assign({}, props), /*#__PURE__*/ $jMaZ8.createElement("span", null));
$40cb1b7ba27adc3c$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $40cb1b7ba27adc3c$var$WrapPurePanel;
$40cb1b7ba27adc3c$var$Dropdown.displayName = 'Dropdown';
var $40cb1b7ba27adc3c$export$2e2bcd8739ae039 = $40cb1b7ba27adc3c$var$Dropdown;



var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");





"use client";
var $5c4a1a40d6d9afc5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5c4a1a40d6d9afc5$var$DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = 'default', danger: danger, disabled: disabled, loading: loading, onClick: onClick, htmlType: htmlType, children: children, className: className, menu: menu, arrow: arrow, autoFocus: autoFocus, overlay: overlay, trigger: trigger, align: align, open: open, onOpenChange: onOpenChange, placement: placement, getPopupContainer: getPopupContainer, href: href, icon: icon = /*#__PURE__*/ $jMaZ8.createElement((0, $49848ec5154332ea$export$2e2bcd8739ae039), null), title: title, buttonsRender: buttonsRender = (buttons)=>buttons, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, destroyPopupOnHide: destroyPopupOnHide, dropdownRender: dropdownRender } = props, restProps = $5c4a1a40d6d9afc5$var$__rest(props, [
        "prefixCls",
        "type",
        "danger",
        "disabled",
        "loading",
        "onClick",
        "htmlType",
        "children",
        "className",
        "menu",
        "arrow",
        "autoFocus",
        "overlay",
        "trigger",
        "align",
        "open",
        "onOpenChange",
        "placement",
        "getPopupContainer",
        "href",
        "icon",
        "title",
        "buttonsRender",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayClassName",
        "overlayStyle",
        "destroyPopupOnHide",
        "dropdownRender"
    ]);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayClassName: overlayClassName,
        overlayStyle: overlayStyle,
        destroyPopupOnHide: destroyPopupOnHide,
        dropdownRender: dropdownRender
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $b481086641a221d4$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(buttonPrefixCls, compactItemClassnames, className);
    if ('overlay' in props) dropdownProps.overlay = overlay;
    if ('open' in props) dropdownProps.open = open;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    const leftButton = /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $ed1c54faf74fef6b$export$2e2bcd8739ae039).Compact, Object.assign({
        className: classes,
        size: compactSize,
        block: true
    }, restProps), leftButtonToRender, /*#__PURE__*/ $jMaZ8.createElement((0, $40cb1b7ba27adc3c$export$2e2bcd8739ae039), Object.assign({}, dropdownProps), rightButtonToRender));
};
$5c4a1a40d6d9afc5$var$DropdownButton.__ANT_BUTTON = true;
var $5c4a1a40d6d9afc5$export$2e2bcd8739ae039 = $5c4a1a40d6d9afc5$var$DropdownButton;


"use client";
const $693847f5969d2a03$var$Dropdown = (0, $40cb1b7ba27adc3c$export$2e2bcd8739ae039);
$693847f5969d2a03$var$Dropdown.Button = (0, $5c4a1a40d6d9afc5$export$2e2bcd8739ae039);
var $693847f5969d2a03$export$2e2bcd8739ae039 = $693847f5969d2a03$var$Dropdown;



parcelRequire("jMaZ8");
const $4fcec2b7f73558f9$var$SvgIcnDots = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 4",
        ...props,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("circle", {
                className: "IcnDots_svg__a",
                cx: 2,
                cy: 2,
                r: 2
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("circle", {
                className: "IcnDots_svg__a",
                cx: 2,
                cy: 2,
                r: 2,
                transform: "translate(6)"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("circle", {
                className: "IcnDots_svg__a",
                cx: 2,
                cy: 2,
                r: 2,
                transform: "translate(12)"
            })
        ]
    });
var $4fcec2b7f73558f9$export$2e2bcd8739ae039 = $4fcec2b7f73558f9$var$SvgIcnDots;





const $1cfea7e7903ec959$export$8f45430ccf837300 = {
    orange: "#e66525",
    grey: "#9093a5",
    lightGrey: "#e2e3ea",
    darkGrey: "#5b6079",
    darkestGrey: "#353a52",
    greyfade10: "rgba(#353a52, 10%)"
};


const $eee5699dd95ae9ac$export$e7937c04a326b18a = {
    hashed: false,
    token: {
        fontFamily: "Roboto",
        colorPrimary: (0, $1cfea7e7903ec959$export$8f45430ccf837300).orange,
        // @ts-expect-error
        fontSize: "1em",
        colorText: (0, $1cfea7e7903ec959$export$8f45430ccf837300).darkestGrey,
        colorTextLabel: (0, $1cfea7e7903ec959$export$8f45430ccf837300).darkGrey
    },
    components: {
        Layout: {
            headerBg: (0, $1cfea7e7903ec959$export$8f45430ccf837300).lightGrey
        },
        Breadcrumb: {},
        Drawer: {
            fontWeightStrong: 500
        },
        Tabs: {
            fontSize: 12
        },
        Dropdown: {
            fontSize: 12,
            paddingContentVertical: 0,
            borderRadius: 2
        },
        Menu: {
            colorItemBgActive: (0, $1cfea7e7903ec959$export$8f45430ccf837300).greyfade10,
            borderRadius: 2
        },
        Switch: {},
        Form: {
            fontSize: 12
        },
        Button: {
            fontSize: 12,
            borderRadius: 2
        },
        Select: {},
        Radio: {
            fontSize: 12
        },
        Input: {},
        Modal: {
            // @ts-expect-error
            padding: "3.33em",
            fontSize: 12
        },
        Tooltip: {
            fontSize: 12,
            colorBgBase: (0, $1cfea7e7903ec959$export$8f45430ccf837300).grey
        },
        Slider: {
            fontSize: 12
        },
        Checkbox: {
            fontSize: 12
        }
    }
};
const $eee5699dd95ae9ac$export$b9a8494deef5900b = ({ key: key, icon: icon, children: children, label: label, onClick: onClick, className: className, danger: danger, disabled: disabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    return {
        key: key,
        icon: icon,
        children: children,
        label: label,
        onClick: onClick,
        className: className,
        danger: danger,
        disabled: disabled,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
};
const $eee5699dd95ae9ac$export$772d7324ba568e6e = ({ key: key, label: label, children: children, className: className, disabled: disabled })=>{
    return {
        key: key,
        children: children,
        label: label,
        className: className,
        disabled: disabled
    };
};


const $f8468b0f04bedac6$var$i18nKey = "library.index";
const $f8468b0f04bedac6$var$DropdownMenu = ({ menuProps: menuProps, project: project, refProp: refProp, projectMethods: projectMethods })=>{
    const projectCardI18nKey = `${$f8468b0f04bedac6$var$i18nKey}.projectCard`;
    const menuI18nKey = `${projectCardI18nKey}.menu`;
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const isProjectAdministrator = (0, $dc10a25720c6edc8$export$1b39bc9d16fffc4d)();
    const ePubExportEnable = project.kind === "HTML_TEMPLATE";
    // Note: using directly a component instead of a useMemo will cause a bug (onHoverEnd related)
    const renderDropdownContent = (0, $jMaZ8.useCallback)(()=>{
        const items = [
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "modifies",
                label: t(`${menuI18nKey}.modifies`),
                onClick: ()=>projectMethods.edit(project.id)
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "export-submenu",
                label: t(`${menuI18nKey}.export`),
                children: [
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "export",
                        label: t(`${menuI18nKey}.export`),
                        onClick: ()=>projectMethods.export(project.id, project.name)
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "exportEPub",
                        label: t(`${menuI18nKey}.exportEPub`),
                        onClick: ()=>projectMethods.export(project.id, project.name, true),
                        disabled: !ePubExportEnable
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "exportNarration",
                        label: t(`${menuI18nKey}.exportNarration`),
                        onClick: ()=>projectMethods.exportNarration(project.id)
                    })
                ]
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "viewExports",
                label: t(`${menuI18nKey}.viewExports`),
                onClick: ()=>projectMethods.viewExports(project.id)
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "invite",
                label: t(`${menuI18nKey}.invite`),
                onClick: ()=>projectMethods.invite(project.id)
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "revoke",
                label: t("revokeUserAccess"),
                onClick: ()=>projectMethods.revoke(project.id)
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "resync",
                label: t(`${menuI18nKey}.resync`),
                onClick: ()=>projectMethods.resync(project.id),
                className: $8937beb26988c737$export$f8a3198725db5a98
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "delete",
                label: t(`${menuI18nKey}.delete`),
                onClick: ()=>projectMethods.delete(project.id),
                danger: true
            })
        ];
        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
            style: {
                zIndex: 999,
                position: "absolute",
                minWidth: "15em"
            },
            items: items
        });
    }, [
        ePubExportEnable,
        menuI18nKey,
        project.id,
        project.name,
        projectMethods,
        t
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        ...menuProps,
        initial: {
            ...menuProps.initial,
            position: "absolute",
            top: "0.9em",
            right: "1.25em",
            lineHeight: "0"
        },
        children: isProjectAdministrator && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
            dropdownRender: renderDropdownContent,
            getPopupContainer: ()=>refProp?.current || document.body,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4fcec2b7f73558f9$export$2e2bcd8739ae039), {
                rotate: 90,
                style: {
                    fill: "white",
                    fontSize: "1.5em"
                }
            })
        })
    });
};
var $f8468b0f04bedac6$export$2e2bcd8739ae039 = $f8468b0f04bedac6$var$DropdownMenu;



var $giSak = parcelRequire("giSak");

const $e51a454b0f0e45e8$export$a83bdb74b02481c = (project)=>{
    if (project?.isDoingAudioResync) return "RESYNC";
    else if (project.status === (0, $b522cf181e75e62d$export$d38212884f7bc925).COMPLETE || project.status === (0, $b522cf181e75e62d$export$d38212884f7bc925).ARCHIVED) {
        if (project.status === (0, $b522cf181e75e62d$export$d38212884f7bc925).COMPLETE) return "COMPLETE_BOOK";
        return project.status;
    } else if (project.isNarrationComplete && project.preparationProgress !== (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE) return "NARRATION_COMPLETE";
    else if (!project.isNarrationComplete && project.preparationProgress !== (0, $b522cf181e75e62d$export$3f684fc5c7851f91).NOT_READY) return "READY_FOR_NARRATION";
    else if (project.preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).NOT_READY || project.preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).READY_FOR_NARRATION || project.preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE) return project.preparationProgress;
    return "";
};


const $631e36d5f79400e2$var$i18nKey = "library.index";
const $631e36d5f79400e2$var$getCountyCode = (str)=>str.split("_")?.[1] || "";
function $631e36d5f79400e2$export$2e2bcd8739ae039({ project: project, projectMethods: projectMethods }) {
    const [isOpen, setIsOpen] = (0, $jMaZ8.useState)(false);
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const projectCardI18nKey = `${$631e36d5f79400e2$var$i18nKey}.projectCard`;
    const countryCode = $631e36d5f79400e2$var$getCountyCode(project.config.locale);
    const bookStatusLabel = (0, $e51a454b0f0e45e8$export$a83bdb74b02481c)(project);
    const ref = (0, $jMaZ8.useRef)(null);
    const titleI18nKey = `${projectCardI18nKey}.button`;
    const textProps = {
        initial: {
            opacity: 1,
            y: "0"
        },
        animate: {
            opacity: isOpen ? 0 : 1,
            y: isOpen ? "20px" : "0"
        }
    };
    const menuProps = {
        animate: {
            y: isOpen ? "0px" : "-20px"
        },
        initial: {
            y: "-20px"
        }
    };
    const isInReSync = project.isDoingAudioResync;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        style: {
            position: "relative"
        },
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($8937beb26988c737$export$7ffb29c470bbe0c1, {
            [$8937beb26988c737$export$87ae8b1388ae34a6]: isInReSync
        }),
        onHoverEnd: isInReSync ? undefined : ()=>setIsOpen(false),
        onHoverStart: isInReSync ? undefined : ()=>setIsOpen(true),
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $978012cac829448d$export$2e2bcd8739ae039), {
                className: $8937beb26988c737$export$4aebd143f31d0c0d,
                bookStatusLabel: bookStatusLabel,
                small: true
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                ...textProps,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                    justify: "center",
                    className: $8937beb26988c737$export$c31d35d5ced5a9d8,
                    children: project.name
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                ...textProps,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                    justify: "center",
                    className: $8937beb26988c737$export$c31d35d5ced5a9d8,
                    children: project.author
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                ...textProps,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                    justify: "center",
                    className: $8937beb26988c737$export$e795f858b6a66dc0,
                    children: countryCode
                })
            }),
            !isInReSync && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                        ...textProps,
                        style: {
                            position: "absolute",
                            bottom: "1em",
                            fontSize: "0.833em",
                            paddingTop: "0.5em",
                            textAlign: "center",
                            width: "100%"
                        },
                        children: new Date(project.createdAt).toLocaleDateString().replace(/\//g, ".")
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                        className: $8937beb26988c737$export$f00a3f59328e8409,
                        animate: {
                            opacity: isOpen ? 1 : 0
                        },
                        initial: {
                            opacity: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                                ...menuProps,
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                        className: $8937beb26988c737$export$a3b9b213fa74e4fd,
                                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).button, {
                                            initial: {
                                                backgroundColor: "rgba(0,0,0,0)",
                                                color: "rgb(255,255,255)"
                                            },
                                            whileHover: {
                                                backgroundColor: "rgba(255,255,255,1)",
                                                color: "rgb(0,0,0)"
                                            },
                                            onClick: ()=>projectMethods.open(String(project.id)),
                                            children: t(`${titleI18nKey}.title`)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                                        style: {
                                            x: "-0.5em"
                                        },
                                        className: $8937beb26988c737$export$7652f722913b5d7,
                                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $13cde3d375487e0f$export$a69f017b19597ff5), {
                                            userBasedAccess: project.userBasedAccess
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8468b0f04bedac6$export$2e2bcd8739ae039), {
                                menuProps: menuProps,
                                project: project,
                                projectMethods: projectMethods,
                                refProp: ref
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");



const $6c59170a575a71c0$var$STORAGE_KEY = "projects_search";
const $6c59170a575a71c0$var$persistance = window.sessionStorage;
var $6c59170a575a71c0$var$SearchState = /*#__PURE__*/ function($6c59170a575a71c0$var$SearchState) {
    $6c59170a575a71c0$var$SearchState["OPENED"] = "opened";
    $6c59170a575a71c0$var$SearchState["CLOSED"] = "closed";
    return $6c59170a575a71c0$var$SearchState;
}($6c59170a575a71c0$var$SearchState || {});
const $6c59170a575a71c0$var$SearchBar = ({ onChange: onChangeProps })=>{
    const [value, setValue] = (0, $jMaZ8.useState)("");
    const [state, setState] = (0, $jMaZ8.useState)("closed");
    const ref = (0, $jMaZ8.useRef)(null);
    // Close handler
    const close = (0, $jMaZ8.useCallback)(()=>{
        setState("closed");
        setValue("");
        $6c59170a575a71c0$var$persistance.setItem($6c59170a575a71c0$var$STORAGE_KEY, "");
    }, []);
    // Change handler
    const onChange = (0, $jMaZ8.useCallback)((e)=>{
        const searchValue = e.target.value;
        setValue(searchValue);
        $6c59170a575a71c0$var$persistance.setItem($6c59170a575a71c0$var$STORAGE_KEY, searchValue);
    }, []);
    // Propagate the search value to the parent
    (0, $jMaZ8.useEffect)(()=>{
        onChangeProps(value);
    }, [
        onChangeProps,
        value
    ]);
    // Rehydrate search value from persisted value (on mount)
    (0, $jMaZ8.useEffect)(()=>{
        const persistedSearchValue = $6c59170a575a71c0$var$persistance.getItem($6c59170a575a71c0$var$STORAGE_KEY);
        if (persistedSearchValue) {
            setState("opened");
            setValue(persistedSearchValue);
            onChangeProps(persistedSearchValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Auto-focus on opening
    (0, $jMaZ8.useEffect)(()=>{
        const input = ref.current;
        if (state === "opened" && input) input.focus();
    }, [
        state,
        ref
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        animate: state,
        className: $8937beb26988c737$export$f2ea4ab276c3e3fa,
        children: [
            state === "closed" && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                whileHover: "hovered",
                className: $8937beb26988c737$export$3ce6949f20cea765,
                variants: {
                    hovered: {
                        scale: 1.1
                    }
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $7707703e157f8963$export$2e2bcd8739ae039), {
                    style: {
                        cursor: "pointer"
                    },
                    onClick: ()=>setState("opened")
                })
            }),
            state === "opened" && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                className: $8937beb26988c737$export$8360e631d277ea4d,
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $15b3ead07edba509$export$2e2bcd8739ae039), {
                    onClick: close
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                className: $8937beb26988c737$export$b7e3ae3d7c15e42e,
                initial: {
                    opacity: 0
                },
                style: {
                    pointerEvents: state === "closed" ? "none" : "initial"
                },
                variants: {
                    opened: {
                        opacity: 1
                    },
                    closed: {
                        opacity: 0
                    }
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                    ref: ref,
                    onChange: onChange,
                    value: value
                })
            })
        ]
    });
};
var $6c59170a575a71c0$export$2e2bcd8739ae039 = $6c59170a575a71c0$var$SearchBar;



parcelRequire("jMaZ8");


parcelRequire("jMaZ8");
const $37273aec52022d4a$var$SvgIcnPlus = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M501.865 446.365h-5.487v-5.487a1.007 1.007 0 1 0-2.013 0v5.487h-5.487a1.007 1.007 0 0 0 0 2.013h5.487v5.487a1.007 1.007 0 1 0 2.013 0v-5.487h5.487a1.007 1.007 0 0 0 0-2.013Z",
            transform: "translate(-487.872 -439.872)",
            style: {
                fill: "#5b6079"
            }
        })
    });
var $37273aec52022d4a$export$2e2bcd8739ae039 = $37273aec52022d4a$var$SvgIcnPlus;




const $ffbeb343de2a9b01$var$NewProjectCard = ({ onClick: onClick, i18nKey: i18nKey })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $8937beb26988c737$export$5dbac6ca1d81f28,
        onClick: ()=>onClick(true),
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                justify: "center",
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $37273aec52022d4a$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                justify: "center",
                children: t(`${i18nKey}.newProject.title`)
            })
        ]
    });
};
var $ffbeb343de2a9b01$export$2e2bcd8739ae039 = $ffbeb343de2a9b01$var$NewProjectCard;



parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");






var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");


var $1cfGC = parcelRequire("1cfGC");



parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");


const $f2207f3543452053$var$genAlertTypeStyle = (bgColor, borderColor, iconColor, token, alertCls)=>({
        background: bgColor,
        border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${borderColor}`,
        [`${alertCls}-icon`]: {
            color: iconColor
        }
    });
const $f2207f3543452053$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: duration, marginXS: marginXS, marginSM: marginSM, fontSize: fontSize, fontSizeLG: fontSizeLG, lineHeight: lineHeight, borderRadiusLG: borderRadius, motionEaseInOutCirc: motionEaseInOutCirc, withDescriptionIconSize: withDescriptionIconSize, colorText: colorText, colorTextHeading: colorTextHeading, withDescriptionPadding: withDescriptionPadding, defaultPadding: defaultPadding } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            padding: defaultPadding,
            wordWrap: 'break-word',
            borderRadius: borderRadius,
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            [`${componentCls}-content`]: {
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-icon`]: {
                marginInlineEnd: marginXS,
                lineHeight: 0
            },
            '&-description': {
                display: 'none',
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            '&-message': {
                color: colorTextHeading
            },
            [`&${componentCls}-motion-leave`]: {
                overflow: 'hidden',
                opacity: 1,
                transition: `max-height ${duration} ${motionEaseInOutCirc}, opacity ${duration} ${motionEaseInOutCirc},
        padding-top ${duration} ${motionEaseInOutCirc}, padding-bottom ${duration} ${motionEaseInOutCirc},
        margin-bottom ${duration} ${motionEaseInOutCirc}`
            },
            [`&${componentCls}-motion-leave-active`]: {
                maxHeight: 0,
                marginBottom: '0 !important',
                paddingTop: 0,
                paddingBottom: 0,
                opacity: 0
            }
        }),
        [`${componentCls}-with-description`]: {
            alignItems: 'flex-start',
            padding: withDescriptionPadding,
            [`${componentCls}-icon`]: {
                marginInlineEnd: marginSM,
                fontSize: withDescriptionIconSize,
                lineHeight: 0
            },
            [`${componentCls}-message`]: {
                display: 'block',
                marginBottom: marginXS,
                color: colorTextHeading,
                fontSize: fontSizeLG
            },
            [`${componentCls}-description`]: {
                display: 'block',
                color: colorText
            }
        },
        [`${componentCls}-banner`]: {
            marginBottom: 0,
            border: '0 !important',
            borderRadius: 0
        }
    };
};
const $f2207f3543452053$export$289eb6d482898146 = (token)=>{
    const { componentCls: componentCls, colorSuccess: colorSuccess, colorSuccessBorder: colorSuccessBorder, colorSuccessBg: colorSuccessBg, colorWarning: colorWarning, colorWarningBorder: colorWarningBorder, colorWarningBg: colorWarningBg, colorError: colorError, colorErrorBorder: colorErrorBorder, colorErrorBg: colorErrorBg, colorInfo: colorInfo, colorInfoBorder: colorInfoBorder, colorInfoBg: colorInfoBg } = token;
    return {
        [componentCls]: {
            '&-success': $f2207f3543452053$var$genAlertTypeStyle(colorSuccessBg, colorSuccessBorder, colorSuccess, token, componentCls),
            '&-info': $f2207f3543452053$var$genAlertTypeStyle(colorInfoBg, colorInfoBorder, colorInfo, token, componentCls),
            '&-warning': $f2207f3543452053$var$genAlertTypeStyle(colorWarningBg, colorWarningBorder, colorWarning, token, componentCls),
            '&-error': Object.assign(Object.assign({}, $f2207f3543452053$var$genAlertTypeStyle(colorErrorBg, colorErrorBorder, colorError, token, componentCls)), {
                [`${componentCls}-description > pre`]: {
                    margin: 0,
                    padding: 0
                }
            })
        }
    };
};
const $f2207f3543452053$export$5ecc051c674d512 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, motionDurationMid: motionDurationMid, marginXS: marginXS, fontSizeIcon: fontSizeIcon, colorIcon: colorIcon, colorIconHover: colorIconHover } = token;
    return {
        [componentCls]: {
            '&-action': {
                marginInlineStart: marginXS
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: marginXS,
                padding: 0,
                overflow: 'hidden',
                fontSize: fontSizeIcon,
                lineHeight: (0, $4g3I0.unit)(fontSizeIcon),
                backgroundColor: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                [`${iconCls}-close`]: {
                    color: colorIcon,
                    transition: `color ${motionDurationMid}`,
                    '&:hover': {
                        color: colorIconHover
                    }
                }
            },
            '&-close-text': {
                color: colorIcon,
                transition: `color ${motionDurationMid}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        }
    };
};
const $f2207f3543452053$export$9ca1be8807fe0675 = (token)=>{
    const paddingHorizontal = 12; // Fixed value here.
    return {
        withDescriptionIconSize: token.fontSizeHeading3,
        defaultPadding: `${token.paddingContentVerticalSM}px ${paddingHorizontal}px`,
        withDescriptionPadding: `${token.paddingMD}px ${token.paddingContentHorizontalLG}px`
    };
};
var $f2207f3543452053$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Alert', (token)=>[
        $f2207f3543452053$export$5ca74f7be820a85(token),
        $f2207f3543452053$export$289eb6d482898146(token),
        $f2207f3543452053$export$5ecc051c674d512(token)
    ], $f2207f3543452053$export$9ca1be8807fe0675);


"use client";
var $18c08aad58a502a5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $18c08aad58a502a5$var$iconMapFilled = {
    success: (0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039),
    info: (0, $510ddd97f52e903f$export$2e2bcd8739ae039),
    error: (0, $93361570ffc8bbe1$export$2e2bcd8739ae039),
    warning: (0, $5244cb05538dbe0c$export$2e2bcd8739ae039)
};
const $18c08aad58a502a5$var$IconNode = (props)=>{
    const { icon: icon, prefixCls: prefixCls, type: type } = props;
    const iconType = $18c08aad58a502a5$var$iconMapFilled[type] || null;
    if (icon) return (0, $e4daa5bbe3988c87$export$2dfe578f95754f6a)(icon, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-icon`
    }, icon), ()=>({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-icon`, icon.props.className)
        }));
    return /*#__PURE__*/ $jMaZ8.createElement(iconType, {
        className: `${prefixCls}-icon`
    });
};
const $18c08aad58a502a5$var$CloseIconNode = (props)=>{
    const { isClosable: isClosable, prefixCls: prefixCls, closeIcon: closeIcon, handleClose: handleClose, ariaProps: ariaProps } = props;
    const mergedCloseIcon = closeIcon === true || closeIcon === undefined ? /*#__PURE__*/ $jMaZ8.createElement((0, $15b3ead07edba509$export$2e2bcd8739ae039), null) : closeIcon;
    return isClosable ? /*#__PURE__*/ $jMaZ8.createElement("button", Object.assign({
        type: "button",
        onClick: handleClose,
        className: `${prefixCls}-close-icon`,
        tabIndex: 0
    }, ariaProps), mergedCloseIcon) : null;
};
const $18c08aad58a502a5$var$Alert = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { description: description, prefixCls: customizePrefixCls, message: message, banner: banner, className: className, rootClassName: rootClassName, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, afterClose: afterClose, showIcon: showIcon, closable: closable, closeText: closeText, closeIcon: closeIcon, action: action, id: id } = props, otherProps = $18c08aad58a502a5$var$__rest(props, [
        "description",
        "prefixCls",
        "message",
        "banner",
        "className",
        "rootClassName",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "onClick",
        "afterClose",
        "showIcon",
        "closable",
        "closeText",
        "closeIcon",
        "action",
        "id"
    ]);
    const [closed, setClosed] = $jMaZ8.useState(false);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Alert');
        warning.deprecated(!closeText, 'closeText', 'closable.closeIcon');
    }
    const internalRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, ()=>({
            nativeElement: internalRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, alert: alert } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('alert', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f2207f3543452053$export$2e2bcd8739ae039)(prefixCls);
    const handleClose = (e)=>{
        var _a;
        setClosed(true);
        (_a = props.onClose) === null || _a === void 0 || _a.call(props, e);
    };
    const type = $jMaZ8.useMemo(()=>{
        if (props.type !== undefined) return props.type;
        // banner mode defaults to 'warning'
        return banner ? 'warning' : 'info';
    }, [
        props.type,
        banner
    ]);
    // closeable when closeText or closeIcon is assigned
    const isClosable = $jMaZ8.useMemo(()=>{
        if (typeof closable === 'object' && closable.closeIcon) return true;
        if (closeText) return true;
        if (typeof closable === 'boolean') return closable;
        // should be true when closeIcon is 0 or ''
        if (closeIcon !== false && closeIcon !== null && closeIcon !== undefined) return true;
        return !!(alert === null || alert === void 0 ? void 0 : alert.closable);
    }, [
        closeText,
        closeIcon,
        closable,
        alert === null || alert === void 0 ? void 0 : alert.closable
    ]);
    // banner mode defaults to Icon
    const isShowIcon = banner && showIcon === undefined ? true : showIcon;
    const alertCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-${type}`, {
        [`${prefixCls}-with-description`]: !!description,
        [`${prefixCls}-no-icon`]: !isShowIcon,
        [`${prefixCls}-banner`]: !!banner,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, alert === null || alert === void 0 ? void 0 : alert.className, className, rootClassName, cssVarCls, hashId);
    const restProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const mergedCloseIcon = $jMaZ8.useMemo(()=>{
        var _a, _b;
        if (typeof closable === 'object' && closable.closeIcon) return closable.closeIcon;
        if (closeText) return closeText;
        if (closeIcon !== undefined) return closeIcon;
        if (typeof (alert === null || alert === void 0 ? void 0 : alert.closable) === 'object' && ((_a = alert === null || alert === void 0 ? void 0 : alert.closable) === null || _a === void 0 ? void 0 : _a.closeIcon)) return (_b = alert === null || alert === void 0 ? void 0 : alert.closable) === null || _b === void 0 ? void 0 : _b.closeIcon;
        return alert === null || alert === void 0 ? void 0 : alert.closeIcon;
    }, [
        closeIcon,
        closable,
        closeText,
        alert === null || alert === void 0 ? void 0 : alert.closeIcon
    ]);
    const mergedAriaProps = $jMaZ8.useMemo(()=>{
        const merged = closable !== null && closable !== void 0 ? closable : alert === null || alert === void 0 ? void 0 : alert.closable;
        if (typeof merged === 'object') {
            const { closeIcon: _ } = merged, ariaProps = $18c08aad58a502a5$var$__rest(merged, [
                "closeIcon"
            ]);
            return ariaProps;
        }
        return {};
    }, [
        closable,
        alert === null || alert === void 0 ? void 0 : alert.closable
    ]);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), {
        visible: !closed,
        motionName: `${prefixCls}-motion`,
        motionAppear: false,
        motionEnter: false,
        onLeaveStart: (node)=>({
                maxHeight: node.offsetHeight
            }),
        onLeaveEnd: afterClose
    }, (_ref, setRef)=>{
        let { className: motionClassName, style: motionStyle } = _ref;
        return /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
            id: id,
            ref: (0, $1cfGC.composeRef)(internalRef, setRef),
            "data-show": !closed,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(alertCls, motionClassName),
            style: Object.assign(Object.assign(Object.assign({}, alert === null || alert === void 0 ? void 0 : alert.style), style), motionStyle),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            role: "alert"
        }, restProps), isShowIcon ? /*#__PURE__*/ $jMaZ8.createElement($18c08aad58a502a5$var$IconNode, {
            description: description,
            icon: props.icon,
            prefixCls: prefixCls,
            type: type
        }) : null, /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-content`
        }, message ? /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-message`
        }, message) : null, description ? /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-description`
        }, description) : null), action ? /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-action`
        }, action) : null, /*#__PURE__*/ $jMaZ8.createElement($18c08aad58a502a5$var$CloseIconNode, {
            isClosable: isClosable,
            prefixCls: prefixCls,
            closeIcon: mergedCloseIcon,
            handleClose: handleClose,
            ariaProps: mergedAriaProps
        }));
    }));
});
$18c08aad58a502a5$var$Alert.displayName = 'Alert';
var $18c08aad58a502a5$export$2e2bcd8739ae039 = $18c08aad58a502a5$var$Alert;



var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $59qU0 = parcelRequire("59qU0");

var $f2BOs = parcelRequire("f2BOs");

var $fe5yO = parcelRequire("fe5yO");
function $3a6fd6a6efbf675d$export$2e2bcd8739ae039(t, o, e) {
    return o = (0, $59qU0.default)(o), (0, $fe5yO.default)(t, (0, $f2BOs.default)() ? Reflect.construct(o, e || [], (0, $59qU0.default)(t).constructor) : o.apply(t, e));
}



var $7eK0y = parcelRequire("7eK0y");

var $jMaZ8 = parcelRequire("jMaZ8");

"use client";
let $b3da3b12f1ed3c3f$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary() {
        var _this;
        (0, $klxbl.default)(this, ErrorBoundary);
        _this = (0, $3a6fd6a6efbf675d$export$2e2bcd8739ae039)(this, ErrorBoundary, arguments);
        _this.state = {
            error: undefined,
            info: {
                componentStack: ''
            }
        };
        return _this;
    }
    (0, $7eK0y.default)(ErrorBoundary, _React$Component);
    return (0, $9O7LJ.default)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                const { message: message, description: description, id: id, children: children } = this.props;
                const { error: error, info: info } = this.state;
                const componentStack = (info === null || info === void 0 ? void 0 : info.componentStack) || null;
                const errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
                const errorDescription = typeof description === 'undefined' ? componentStack : description;
                if (error) return /*#__PURE__*/ $jMaZ8.createElement((0, $18c08aad58a502a5$export$2e2bcd8739ae039), {
                    id: id,
                    type: "error",
                    message: errorMessage,
                    description: /*#__PURE__*/ $jMaZ8.createElement("pre", {
                        style: {
                            fontSize: '0.9em',
                            overflowX: 'auto'
                        }
                    }, errorDescription)
                });
                return children;
            }
        }
    ]);
}($jMaZ8.Component);
var $b3da3b12f1ed3c3f$export$2e2bcd8739ae039 = $b3da3b12f1ed3c3f$var$ErrorBoundary;


"use client";
const $3b184c50062b0fa2$var$Alert = (0, $18c08aad58a502a5$export$2e2bcd8739ae039);
$3b184c50062b0fa2$var$Alert.ErrorBoundary = (0, $b3da3b12f1ed3c3f$export$2e2bcd8739ae039);
var $3b184c50062b0fa2$export$2e2bcd8739ae039 = $3b184c50062b0fa2$var$Alert;



var $jMaZ8 = parcelRequire("jMaZ8");
var $f40867b2b1b9b23f$export$e1053575ddfcb301 = {};
var $f40867b2b1b9b23f$export$91b75cf262680225 = 'rc-table-internal-hook';



var $3fkx6 = parcelRequire("3fkx6");

var $ktS49 = parcelRequire("ktS49");

var $jLTp6 = parcelRequire("jLTp6");

var $9O5K3 = parcelRequire("9O5K3");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");
function $f46c9e4dbdabd86b$export$fd42f52fd3ae1109(defaultValue) {
    var Context = /*#__PURE__*/ $jMaZ8.createContext(undefined);
    var Provider = function Provider(_ref) {
        var value = _ref.value, children = _ref.children;
        var valueRef = $jMaZ8.useRef(value);
        valueRef.current = value;
        var _React$useState = $jMaZ8.useState(function() {
            return {
                getValue: function getValue() {
                    return valueRef.current;
                },
                listeners: new Set()
            };
        }), _React$useState2 = (0, $3fkx6.default)(_React$useState, 1), context = _React$useState2[0];
        (0, $jLTp6.default)(function() {
            (0, $6UWRi.unstable_batchedUpdates)(function() {
                context.listeners.forEach(function(listener) {
                    listener(value);
                });
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $jMaZ8.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider,
        defaultValue: defaultValue
    };
}
function $f46c9e4dbdabd86b$export$fae74005e78b1a27(holder, selector) {
    var eventSelector = (0, $ktS49.default)(typeof selector === 'function' ? selector : function(ctx) {
        if (selector === undefined) return ctx;
        if (!Array.isArray(selector)) return ctx[selector];
        var obj = {};
        selector.forEach(function(key) {
            obj[key] = ctx[key];
        });
        return obj;
    });
    var context = $jMaZ8.useContext(holder === null || holder === void 0 ? void 0 : holder.Context);
    var _ref2 = context || {}, listeners = _ref2.listeners, getValue = _ref2.getValue;
    var valueRef = $jMaZ8.useRef();
    valueRef.current = eventSelector(context ? getValue() : holder === null || holder === void 0 ? void 0 : holder.defaultValue);
    var _React$useState3 = $jMaZ8.useState({}), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), forceUpdate = _React$useState4[1];
    (0, $jLTp6.default)(function() {
        if (!context) return;
        function trigger(nextValue) {
            var nextSelectorValue = eventSelector(nextValue);
            if (!(0, $9O5K3.default)(valueRef.current, nextSelectorValue, true)) forceUpdate({});
        }
        listeners.add(trigger);
        return function() {
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return valueRef.current;
}



var $hH60s = parcelRequire("hH60s");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");
function $96e09034fd52490c$export$2e2bcd8739ae039() {
    var ImmutableContext = /*#__PURE__*/ $jMaZ8.createContext(null);
    /**
   * Get render update mark by `makeImmutable` root.
   * Do not deps on the return value as render times
   * but only use for `useMemo` or `useCallback` deps.
   */ function useImmutableMark() {
        return $jMaZ8.useContext(ImmutableContext);
    }
    /**
  * Wrapped Component will be marked as Immutable.
  * When Component parent trigger render,
  * it will notice children component (use with `responseImmutable`) node that parent has updated.
  * @param Component Passed Component
  * @param triggerRender Customize trigger `responseImmutable` children re-render logic. Default will always trigger re-render when this component re-render.
  */ function makeImmutable(Component, shouldTriggerRender) {
        var refAble = (0, $1cfGC.supportRef)(Component);
        var ImmutableComponent = function ImmutableComponent(props, ref) {
            var refProps = refAble ? {
                ref: ref
            } : {};
            var renderTimesRef = $jMaZ8.useRef(0);
            var prevProps = $jMaZ8.useRef(props);
            // If parent has the context, we do not wrap it
            var mark = useImmutableMark();
            if (mark !== null) return /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({}, props, refProps));
            if (// Always trigger re-render if not provide `notTriggerRender`
            !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)) renderTimesRef.current += 1;
            prevProps.current = props;
            return /*#__PURE__*/ $jMaZ8.createElement(ImmutableContext.Provider, {
                value: renderTimesRef.current
            }, /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({}, props, refProps)));
        };
        ImmutableComponent.displayName = "ImmutableRoot(".concat(Component.displayName || Component.name, ")");
        return refAble ? /*#__PURE__*/ $jMaZ8.forwardRef(ImmutableComponent) : ImmutableComponent;
    }
    /**
   * Wrapped Component with `React.memo`.
   * But will rerender when parent with `makeImmutable` rerender.
   */ function responseImmutable(Component, propsAreEqual) {
        var refAble = (0, $1cfGC.supportRef)(Component);
        var ImmutableComponent = function ImmutableComponent(props, ref) {
            var refProps = refAble ? {
                ref: ref
            } : {};
            useImmutableMark();
            return /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({}, props, refProps));
        };
        ImmutableComponent.displayName = "ImmutableResponse(".concat(Component.displayName || Component.name, ")");
        return refAble ? /*#__PURE__*/ $jMaZ8.memo(/*#__PURE__*/ $jMaZ8.forwardRef(ImmutableComponent), propsAreEqual) : /*#__PURE__*/ $jMaZ8.memo(ImmutableComponent, propsAreEqual);
    }
    return {
        makeImmutable: makeImmutable,
        responseImmutable: responseImmutable,
        useImmutableMark: useImmutableMark
    };
}


// For legacy usage, we export it directly
var $567ec33a1408d0dd$var$_createImmutable = (0, $96e09034fd52490c$export$2e2bcd8739ae039)(), $567ec33a1408d0dd$export$ffd6d5bef5eaf0a4 = $567ec33a1408d0dd$var$_createImmutable.makeImmutable, $567ec33a1408d0dd$export$e9e4cb9eb9e2b4c4 = $567ec33a1408d0dd$var$_createImmutable.responseImmutable, $567ec33a1408d0dd$export$c5d829a463bd3201 = $567ec33a1408d0dd$var$_createImmutable.useImmutableMark;



var $jMaZ8 = parcelRequire("jMaZ8");

var $7be8aaea61012844$var$_createImmutable = (0, $96e09034fd52490c$export$2e2bcd8739ae039)(), $7be8aaea61012844$export$ffd6d5bef5eaf0a4 = $7be8aaea61012844$var$_createImmutable.makeImmutable, $7be8aaea61012844$export$e9e4cb9eb9e2b4c4 = $7be8aaea61012844$var$_createImmutable.responseImmutable, $7be8aaea61012844$export$c5d829a463bd3201 = $7be8aaea61012844$var$_createImmutable.useImmutableMark;
var $7be8aaea61012844$var$TableContext = (0, $f46c9e4dbdabd86b$export$fd42f52fd3ae1109)();
var $7be8aaea61012844$export$2e2bcd8739ae039 = $7be8aaea61012844$var$TableContext;


/* istanbul ignore file */ 
var $jMaZ8 = parcelRequire("jMaZ8");
function $ec02351ae4fda3aa$var$useRenderTimes(props, debug) {
    // Render times
    var timesRef = $jMaZ8.useRef(0);
    timesRef.current += 1;
    // Props changed
    var propsRef = $jMaZ8.useRef(props);
    var keys = [];
    Object.keys(props || {}).map(function(key) {
        var _propsRef$current;
        if ((props === null || props === void 0 ? void 0 : props[key]) !== ((_propsRef$current = propsRef.current) === null || _propsRef$current === void 0 ? void 0 : _propsRef$current[key])) keys.push(key);
    });
    propsRef.current = props;
    // Cache keys since React rerender may cause it lost
    var keysRef = $jMaZ8.useRef([]);
    if (keys.length) keysRef.current = keys;
    $jMaZ8.useDebugValue(timesRef.current);
    $jMaZ8.useDebugValue(keysRef.current.join(', '));
    if (debug) console.log("".concat(debug, ":"), timesRef.current, keysRef.current);
    return timesRef.current;
}
var $ec02351ae4fda3aa$export$2e2bcd8739ae039 = $ec02351ae4fda3aa$var$useRenderTimes;
var $ec02351ae4fda3aa$export$e57c788cafefed4f = /*#__PURE__*/ $jMaZ8.memo(function() {
    var times = $ec02351ae4fda3aa$var$useRenderTimes();
    return /*#__PURE__*/ $jMaZ8.createElement("h1", null, "Render Times: ", times);
});
$ec02351ae4fda3aa$export$e57c788cafefed4f.displayName = 'RenderBlock';



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $3fkx6 = parcelRequire("3fkx6");


var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");



var $3fkx6 = parcelRequire("3fkx6");

var $1Esi2 = parcelRequire("1Esi2");

var $hBgfL = parcelRequire("hBgfL");

var $9O5K3 = parcelRequire("9O5K3");

var $k19OO = parcelRequire("k19OO");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
// TODO: Remove when use `responsiveImmutable`
var $7f77412c600021fd$var$PerfContext = /*#__PURE__*/ $jMaZ8.createContext({
    renderWithProps: false
});
var $7f77412c600021fd$export$2e2bcd8739ae039 = $7f77412c600021fd$var$PerfContext;


var $44c4837b2ae0db52$var$INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function $44c4837b2ae0db52$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $44c4837b2ae0db52$export$fd2ca5407d9be470(columns) {
    var columnKeys = [];
    var keys = {};
    columns.forEach(function(column) {
        var _ref = column || {}, key = _ref.key, dataIndex = _ref.dataIndex;
        var mergedKey = key || $44c4837b2ae0db52$var$toArray(dataIndex).join('-') || $44c4837b2ae0db52$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = "".concat(mergedKey, "_next");
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $44c4837b2ae0db52$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}
function $44c4837b2ae0db52$export$b1cd2bdabe361feb(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}



function $d176d888dbf12ad3$var$isRenderCell(data) {
    return data && (0, $1Esi2.default)(data) === 'object' && !Array.isArray(data) && !/*#__PURE__*/ $jMaZ8.isValidElement(data);
}
function $d176d888dbf12ad3$export$2e2bcd8739ae039(record, dataIndex, renderIndex, children, render, shouldCellUpdate) {
    // TODO: Remove this after next major version
    var perfRecord = $jMaZ8.useContext((0, $7f77412c600021fd$export$2e2bcd8739ae039));
    var mark = (0, $7be8aaea61012844$export$c5d829a463bd3201)();
    // ======================== Render ========================
    var retData = (0, $hBgfL.default)(function() {
        if ((0, $44c4837b2ae0db52$export$b76e9316566cc26e)(children)) return [
            children
        ];
        var path = dataIndex === null || dataIndex === undefined || dataIndex === '' ? [] : Array.isArray(dataIndex) ? dataIndex : [
            dataIndex
        ];
        var value = (0, $k19OO.default)(record, path);
        // Customize render node
        var returnChildNode = value;
        var returnCellProps = undefined;
        if (render) {
            var renderData = render(value, record, renderIndex);
            if ($d176d888dbf12ad3$var$isRenderCell(renderData)) {
                (0, $2bFmQ.default)(false, '`columns.render` return cell props is deprecated with perf issue, please use `onCell` instead.');
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        // Force update deps
        mark,
        // Normal deps
        record,
        children,
        dataIndex,
        render,
        renderIndex
    ], function(prev, next) {
        if (shouldCellUpdate) {
            var _prev = (0, $3fkx6.default)(prev, 2), prevRecord = _prev[1];
            var _next = (0, $3fkx6.default)(next, 2), nextRecord = _next[1];
            return shouldCellUpdate(nextRecord, prevRecord);
        }
        // Legacy mode should always update
        if (perfRecord.renderWithProps) return true;
        return !(0, $9O5K3.default)(prev, next, true);
    });
    return retData;
}




/** Check if cell is in hover range */ function $80d238ec0c8ee023$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    var cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $80d238ec0c8ee023$export$2e2bcd8739ae039(rowIndex, rowSpan) {
    return (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), function(ctx) {
        var hovering = $80d238ec0c8ee023$var$inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
        return [
            hovering,
            ctx.onHover
        ];
    });
}


parcelRequire("1CVs1");
var $ktS49 = parcelRequire("ktS49");
var $a05b829b7a938bc2$var$getTitleFromCellRenderChildren = function getTitleFromCellRenderChildren(_ref) {
    var ellipsis = _ref.ellipsis, rowType = _ref.rowType, children = _ref.children;
    var title;
    var ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
        if (typeof children === 'string' || typeof children === 'number') title = children.toString();
        else if (/*#__PURE__*/ $jMaZ8.isValidElement(children) && typeof children.props.children === 'string') title = children.props.children;
    }
    return title;
};
function $a05b829b7a938bc2$var$Cell(props) {
    var _ref2, _ref3, _legacyCellProps$colS, _ref4, _ref5, _legacyCellProps$rowS, _additionalProps$titl, _classNames;
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    var Component = props.component, children = props.children, ellipsis = props.ellipsis, scope = props.scope, prefixCls = props.prefixCls, className = props.className, align = props.align, record = props.record, render = props.render, dataIndex = props.dataIndex, renderIndex = props.renderIndex, shouldCellUpdate = props.shouldCellUpdate, index = props.index, rowType = props.rowType, colSpan = props.colSpan, rowSpan = props.rowSpan, fixLeft = props.fixLeft, fixRight = props.fixRight, firstFixLeft = props.firstFixLeft, lastFixLeft = props.lastFixLeft, firstFixRight = props.firstFixRight, lastFixRight = props.lastFixRight, appendNode = props.appendNode, _props$additionalProp = props.additionalProps, additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp, isSticky = props.isSticky;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'supportSticky',
        'allColumnsFixedLeft',
        'rowHoverable'
    ]), supportSticky = _useContext.supportSticky, allColumnsFixedLeft = _useContext.allColumnsFixedLeft, rowHoverable = _useContext.rowHoverable;
    // ====================== Value =======================
    var _useCellRender = (0, $d176d888dbf12ad3$export$2e2bcd8739ae039)(record, dataIndex, renderIndex, children, render, shouldCellUpdate), _useCellRender2 = (0, $3fkx6.default)(_useCellRender, 2), childNode = _useCellRender2[0], legacyCellProps = _useCellRender2[1];
    // ====================== Fixed =======================
    var fixedStyle = {};
    var isFixLeft = typeof fixLeft === 'number' && supportSticky;
    var isFixRight = typeof fixRight === 'number' && supportSticky;
    if (isFixLeft) {
        fixedStyle.position = 'sticky';
        fixedStyle.left = fixLeft;
    }
    if (isFixRight) {
        fixedStyle.position = 'sticky';
        fixedStyle.right = fixRight;
    }
    // ================ RowSpan & ColSpan =================
    var mergedColSpan = (_ref2 = (_ref3 = (_legacyCellProps$colS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.colSpan) !== null && _legacyCellProps$colS !== void 0 ? _legacyCellProps$colS : additionalProps.colSpan) !== null && _ref3 !== void 0 ? _ref3 : colSpan) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var mergedRowSpan = (_ref4 = (_ref5 = (_legacyCellProps$rowS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.rowSpan) !== null && _legacyCellProps$rowS !== void 0 ? _legacyCellProps$rowS : additionalProps.rowSpan) !== null && _ref5 !== void 0 ? _ref5 : rowSpan) !== null && _ref4 !== void 0 ? _ref4 : 1;
    // ====================== Hover =======================
    var _useHoverState = (0, $80d238ec0c8ee023$export$2e2bcd8739ae039)(index, mergedRowSpan), _useHoverState2 = (0, $3fkx6.default)(_useHoverState, 2), hovering = _useHoverState2[0], onHover = _useHoverState2[1];
    var onMouseEnter = (0, $ktS49.default)(function(event) {
        var _additionalProps$onMo;
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo = additionalProps.onMouseEnter) === null || _additionalProps$onMo === void 0 || _additionalProps$onMo.call(additionalProps, event);
    });
    var onMouseLeave = (0, $ktS49.default)(function(event) {
        var _additionalProps$onMo2;
        if (record) onHover(-1, -1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo2 = additionalProps.onMouseLeave) === null || _additionalProps$onMo2 === void 0 || _additionalProps$onMo2.call(additionalProps, event);
    });
    // ====================== Render ======================
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
    // >>>>> Title
    var title = (_additionalProps$titl = additionalProps.title) !== null && _additionalProps$titl !== void 0 ? _additionalProps$titl : $a05b829b7a938bc2$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    // >>>>> ClassName
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(cellPrefixCls, className, (_classNames = {}, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-all"), lastFixLeft && allColumnsFixedLeft && supportSticky), "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky), "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky), "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky), "".concat(cellPrefixCls, "-ellipsis"), ellipsis), "".concat(cellPrefixCls, "-with-append"), appendNode), "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky), (0, $eq8kl.default)(_classNames, "".concat(cellPrefixCls, "-row-hover"), !legacyCellProps && hovering)), additionalProps.className, legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.className);
    // >>>>> Style
    var alignStyle = {};
    if (align) alignStyle.textAlign = align;
    // The order is important since user can overwrite style.
    // For example ant-design/ant-design#51763
    var mergedStyle = (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.style), fixedStyle), alignStyle), additionalProps.style);
    // >>>>> Children Node
    var mergedChildNode = childNode;
    // Not crash if final `childNode` is not validate ReactNode
    if ((0, $1Esi2.default)(mergedChildNode) === 'object' && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $jMaZ8.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (lastFixLeft || firstFixRight)) mergedChildNode = /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: "".concat(cellPrefixCls, "-content")
    }, mergedChildNode);
    return /*#__PURE__*/ $jMaZ8.createElement(Component, (0, $hH60s.default)({}, legacyCellProps, additionalProps, {
        className: mergedClassName,
        style: mergedStyle,
        title: title,
        scope: scope,
        onMouseEnter: rowHoverable ? onMouseEnter : undefined,
        onMouseLeave: rowHoverable ? onMouseLeave : undefined,
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
    }), appendNode, mergedChildNode);
}
var $a05b829b7a938bc2$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.memo($a05b829b7a938bc2$var$Cell);




function $66bbefb7242c9d0c$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets, direction) {
    var startColumn = columns[colStart] || {};
    var endColumn = columns[colEnd] || {};
    var fixLeft;
    var fixRight;
    if (startColumn.fixed === 'left') fixLeft = stickyOffsets.left[direction === 'rtl' ? colEnd : colStart];
    else if (endColumn.fixed === 'right') fixRight = stickyOffsets.right[direction === 'rtl' ? colStart : colEnd];
    var lastFixLeft = false;
    var firstFixRight = false;
    var lastFixRight = false;
    var firstFixLeft = false;
    var nextColumn = columns[colEnd + 1];
    var prevColumn = columns[colStart - 1];
    // need show shadow only when canLastFix is true
    var canLastFix = nextColumn && !nextColumn.fixed || prevColumn && !prevColumn.fixed || columns.every(function(col) {
        return col.fixed === 'left';
    });
    if (direction === 'rtl') {
        if (fixLeft !== undefined) {
            var prevFixLeft = prevColumn && prevColumn.fixed === 'left';
            firstFixLeft = !prevFixLeft && canLastFix;
        } else if (fixRight !== undefined) {
            var nextFixRight = nextColumn && nextColumn.fixed === 'right';
            lastFixRight = !nextFixRight && canLastFix;
        }
    } else if (fixLeft !== undefined) {
        var nextFixLeft = nextColumn && nextColumn.fixed === 'left';
        lastFixLeft = !nextFixLeft && canLastFix;
    } else if (fixRight !== undefined) {
        var prevFixRight = prevColumn && prevColumn.fixed === 'right';
        firstFixRight = !prevFixRight && canLastFix;
    }
    return {
        fixLeft: fixLeft,
        fixRight: fixRight,
        lastFixLeft: lastFixLeft,
        firstFixRight: firstFixRight,
        lastFixRight: lastFixRight,
        firstFixLeft: firstFixLeft,
        isSticky: stickyOffsets.isSticky
    };
}



var $jMaZ8 = parcelRequire("jMaZ8");
var $e3823483c3e7cad6$var$SummaryContext = /*#__PURE__*/ $jMaZ8.createContext({});
var $e3823483c3e7cad6$export$2e2bcd8739ae039 = $e3823483c3e7cad6$var$SummaryContext;


function $6f439255b6e5bd46$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, index = _ref.index, children = _ref.children, _ref$colSpan = _ref.colSpan, colSpan = _ref$colSpan === void 0 ? 1 : _ref$colSpan, rowSpan = _ref.rowSpan, align = _ref.align;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'prefixCls',
        'direction'
    ]), prefixCls = _useContext.prefixCls, direction = _useContext.direction;
    var _React$useContext = $jMaZ8.useContext((0, $e3823483c3e7cad6$export$2e2bcd8739ae039)), scrollColumnIndex = _React$useContext.scrollColumnIndex, stickyOffsets = _React$useContext.stickyOffsets, flattenColumns = _React$useContext.flattenColumns;
    var lastIndex = index + colSpan - 1;
    var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    var fixedInfo = (0, $66bbefb7242c9d0c$export$695db918331141f3)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets, direction);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $a05b829b7a938bc2$export$2e2bcd8739ae039), (0, $hH60s.default)({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: function render() {
            return children;
        }
    }, fixedInfo));
}



var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");
var $e22a77ec9475cacd$var$_excluded = [
    "children"
];
function $e22a77ec9475cacd$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $4b02Q.default)(_ref, $e22a77ec9475cacd$var$_excluded);
    return /*#__PURE__*/ $jMaZ8.createElement("tr", props, children);
}


/**
 * Syntactic sugar. Do not support HOC.
 */ function $c82329947872c6f8$var$Summary(_ref) {
    var children = _ref.children;
    return children;
}
$c82329947872c6f8$var$Summary.Row = (0, $e22a77ec9475cacd$export$2e2bcd8739ae039);
$c82329947872c6f8$var$Summary.Cell = (0, $6f439255b6e5bd46$export$2e2bcd8739ae039);
var $c82329947872c6f8$export$2e2bcd8739ae039 = $c82329947872c6f8$var$Summary;



function $b404adcf0f7cd921$var$Footer(props) {
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    var children = props.children, stickyOffsets = props.stickyOffsets, flattenColumns = props.flattenColumns;
    var prefixCls = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), 'prefixCls');
    var lastColumnIndex = flattenColumns.length - 1;
    var scrollColumn = flattenColumns[lastColumnIndex];
    var summaryContext = $jMaZ8.useMemo(function() {
        return {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: scrollColumn !== null && scrollColumn !== void 0 && scrollColumn.scrollbar ? lastColumnIndex : null
        };
    }, [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $e3823483c3e7cad6$export$2e2bcd8739ae039).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $jMaZ8.createElement("tfoot", {
        className: "".concat(prefixCls, "-summary")
    }, children));
}
var $b404adcf0f7cd921$export$2e2bcd8739ae039 = (0, $7be8aaea61012844$export$e9e4cb9eb9e2b4c4)($b404adcf0f7cd921$var$Footer);
var $b404adcf0f7cd921$export$d605f3af09eef683 = (0, $c82329947872c6f8$export$2e2bcd8739ae039);


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $5d243ad92d713269$var$Column(_) {
    return null;
}
var $5d243ad92d713269$export$2e2bcd8739ae039 = $5d243ad92d713269$var$Column;


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $60fa2d40c0304f54$var$ColumnGroup(_) {
    return null;
}
var $60fa2d40c0304f54$export$2e2bcd8739ae039 = $60fa2d40c0304f54$var$ColumnGroup;



var $eq8kl = parcelRequire("eq8kl");

var $hH60s = parcelRequire("hH60s");

var $3fkx6 = parcelRequire("3fkx6");

var $8u3qN = parcelRequire("8u3qN");

var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");




var $ktS49 = parcelRequire("ktS49");


var $k19OO = parcelRequire("k19OO");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");
// recursion (flat tree structure)
function $8bf2575d5b9e236e$var$fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    list.push({
        record: record,
        indent: indent,
        index: index
    });
    var key = getRowKey(record);
    var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(var i = 0; i < record[childrenColumnName].length; i += 1)$8bf2575d5b9e236e$var$fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
}
function $8bf2575d5b9e236e$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    var arr = $jMaZ8.useMemo(function() {
        if (expandedKeys !== null && expandedKeys !== void 0 && expandedKeys.size) {
            var list = [];
            // collect flattened record
            for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i += 1){
                var record = data[i];
                // using array.push or spread operator may cause "Maximum call stack size exceeded" exception if array size is big enough.
                $8bf2575d5b9e236e$var$fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
            }
            return list;
        }
        return data === null || data === void 0 ? void 0 : data.map(function(item, index) {
            return {
                record: item,
                indent: 0,
                index: index
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}





var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");




var $8u3qN = parcelRequire("8u3qN");



parcelRequire("1CVs1");
var $ktS49 = parcelRequire("ktS49");

var $giSak = parcelRequire("giSak");
function $98fa5530be9f0f03$export$2e2bcd8739ae039(record, rowKey, recordIndex, indent) {
    var context = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'prefixCls',
        'fixedInfoList',
        'flattenColumns',
        'expandableType',
        'expandRowByClick',
        'onTriggerExpand',
        'rowClassName',
        'expandedRowClassName',
        'indentSize',
        'expandIcon',
        'expandedRowRender',
        'expandIconColumnIndex',
        'expandedKeys',
        'childrenColumnName',
        'rowExpandable',
        'onRow'
    ]);
    var flattenColumns = context.flattenColumns, expandableType = context.expandableType, expandedKeys = context.expandedKeys, childrenColumnName = context.childrenColumnName, onTriggerExpand = context.onTriggerExpand, rowExpandable = context.rowExpandable, onRow = context.onRow, expandRowByClick = context.expandRowByClick, rowClassName = context.rowClassName;
    // ======================= Expandable =======================
    // Only when row is not expandable and `children` exist in record
    var nestExpandable = expandableType === 'nest';
    var rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record));
    var mergedExpandable = rowSupportExpand || nestExpandable;
    var expanded = expandedKeys && expandedKeys.has(rowKey);
    var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    var onInternalTriggerExpand = (0, $ktS49.default)(onTriggerExpand);
    // ========================= onRow ==========================
    var rowProps = onRow === null || onRow === void 0 ? void 0 : onRow(record, recordIndex);
    var onRowClick = rowProps === null || rowProps === void 0 ? void 0 : rowProps.onClick;
    var onClick = function onClick(event) {
        if (expandRowByClick && mergedExpandable) onTriggerExpand(record, event);
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        onRowClick === null || onRowClick === void 0 || onRowClick.apply(void 0, [
            event
        ].concat(args));
    };
    // ====================== RowClassName ======================
    var computeRowClassName;
    if (typeof rowClassName === 'string') computeRowClassName = rowClassName;
    else if (typeof rowClassName === 'function') computeRowClassName = rowClassName(record, recordIndex, indent);
    // ========================= Column =========================
    var columnsKey = (0, $44c4837b2ae0db52$export$fd2ca5407d9be470)(flattenColumns);
    return (0, $8u3qN.default)((0, $8u3qN.default)({}, context), {}, {
        columnsKey: columnsKey,
        nestExpandable: nestExpandable,
        expanded: expanded,
        hasNestChildren: hasNestChildren,
        record: record,
        onTriggerExpand: onInternalTriggerExpand,
        rowSupportExpand: rowSupportExpand,
        expandable: mergedExpandable,
        rowProps: (0, $8u3qN.default)((0, $8u3qN.default)({}, rowProps), {}, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(computeRowClassName, rowProps === null || rowProps === void 0 ? void 0 : rowProps.className),
            onClick: onClick
        })
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");



function $99810d3402223c12$var$ExpandedRow(props) {
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    var prefixCls = props.prefixCls, children = props.children, Component = props.component, cellComponent = props.cellComponent, className = props.className, expanded = props.expanded, colSpan = props.colSpan, isEmpty = props.isEmpty;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'scrollbarSize',
        'fixHeader',
        'fixColumn',
        'componentWidth',
        'horizonScroll'
    ]), scrollbarSize = _useContext.scrollbarSize, fixHeader = _useContext.fixHeader, fixColumn = _useContext.fixColumn, componentWidth = _useContext.componentWidth, horizonScroll = _useContext.horizonScroll;
    // Cache render node
    var contentNode = children;
    if (isEmpty ? horizonScroll && componentWidth : fixColumn) contentNode = /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: {
            width: componentWidth - (fixHeader && !isEmpty ? scrollbarSize : 0),
            position: 'sticky',
            left: 0,
            overflow: 'hidden'
        },
        className: "".concat(prefixCls, "-expanded-row-fixed")
    }, contentNode);
    return /*#__PURE__*/ $jMaZ8.createElement(Component, {
        className: className,
        style: {
            display: expanded ? null : 'none'
        }
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $a05b829b7a938bc2$export$2e2bcd8739ae039), {
        component: cellComponent,
        prefixCls: prefixCls,
        colSpan: colSpan
    }, contentNode));
}
var $99810d3402223c12$export$2e2bcd8739ae039 = $99810d3402223c12$var$ExpandedRow;



var $eq8kl = parcelRequire("eq8kl");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
function $17ebede92ab776bb$export$ae14373a7f810e33(_ref) {
    var prefixCls = _ref.prefixCls, record = _ref.record, onExpand = _ref.onExpand, expanded = _ref.expanded, expandable = _ref.expandable;
    var expandClassName = "".concat(prefixCls, "-row-expand-icon");
    if (!expandable) return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
    var onClick = function onClick(event) {
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(expandClassName, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-row-expanded"), expanded), "".concat(prefixCls, "-row-collapsed"), !expanded)),
        onClick: onClick
    });
}
function $17ebede92ab776bb$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    var keys = [];
    function dig(list) {
        (list || []).forEach(function(item, index) {
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}
function $17ebede92ab776bb$export$c5c465afb98f57b6(cls, record, index, indent) {
    if (typeof cls === 'string') return cls;
    if (typeof cls === 'function') return cls(record, index, indent);
    return '';
}


function $8965a7fd6345477e$export$16400ac709c56616(rowInfo, column, colIndex, indent, index) {
    var record = rowInfo.record, prefixCls = rowInfo.prefixCls, columnsKey = rowInfo.columnsKey, fixedInfoList = rowInfo.fixedInfoList, expandIconColumnIndex = rowInfo.expandIconColumnIndex, nestExpandable = rowInfo.nestExpandable, indentSize = rowInfo.indentSize, expandIcon = rowInfo.expandIcon, expanded = rowInfo.expanded, hasNestChildren = rowInfo.hasNestChildren, onTriggerExpand = rowInfo.onTriggerExpand;
    var key = columnsKey[colIndex];
    var fixedInfo = fixedInfoList[colIndex];
    // ============= Used for nest expandable =============
    var appendCellNode;
    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement("span", {
        style: {
            paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
    }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
    }));
    var additionalCellProps;
    if (column.onCell) additionalCellProps = column.onCell(record, index);
    return {
        key: key,
        fixedInfo: fixedInfo,
        appendCellNode: appendCellNode,
        additionalCellProps: additionalCellProps || {}
    };
}
// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
function $8965a7fd6345477e$var$BodyRow(props) {
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    var className = props.className, style = props.style, record = props.record, index = props.index, renderIndex = props.renderIndex, rowKey = props.rowKey, _props$indent = props.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props.rowComponent, cellComponent = props.cellComponent, scopeCellComponent = props.scopeCellComponent;
    var rowInfo = (0, $98fa5530be9f0f03$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    var prefixCls = rowInfo.prefixCls, flattenColumns = rowInfo.flattenColumns, expandedRowClassName = rowInfo.expandedRowClassName, expandedRowRender = rowInfo.expandedRowRender, rowProps = rowInfo.rowProps, expanded = rowInfo.expanded, rowSupportExpand = rowInfo.rowSupportExpand;
    // Force render expand row if expanded before
    var expandedRef = $jMaZ8.useRef(false);
    expandedRef.current || (expandedRef.current = expanded);
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    // 若没有 expandedRowRender 参数, 将使用 baseRowNode 渲染 Children
    // 此时如果 level > 1 则说明是 expandedRow, 一样需要附加 computedExpandedRowClassName
    var expandedClsName = (0, $17ebede92ab776bb$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
    // ======================== Base tr row ========================
    var baseRowNode = /*#__PURE__*/ $jMaZ8.createElement(RowComponent, (0, $hH60s.default)({}, rowProps, {
        "data-row-key": rowKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, (0, $eq8kl.default)({}, expandedClsName, indent >= 1)),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, style), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
    }), flattenColumns.map(function(column, colIndex) {
        var render = column.render, dataIndex = column.dataIndex, columnClassName = column.className;
        var _getCellProps = $8965a7fd6345477e$export$16400ac709c56616(rowInfo, column, colIndex, indent, index), key = _getCellProps.key, fixedInfo = _getCellProps.fixedInfo, appendCellNode = _getCellProps.appendCellNode, additionalCellProps = _getCellProps.additionalCellProps;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $a05b829b7a938bc2$export$2e2bcd8739ae039), (0, $hH60s.default)({
            className: columnClassName,
            ellipsis: column.ellipsis,
            align: column.align,
            scope: column.rowScope,
            component: column.rowScope ? scopeCellComponent : cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    }));
    // ======================== Expand Row =========================
    var expandRowNode;
    if (rowSupportExpand && (expandedRef.current || expanded)) {
        var expandContent = expandedRowRender(record, index, indent + 1, expanded);
        expandRowNode = /*#__PURE__*/ $jMaZ8.createElement((0, $99810d3402223c12$export$2e2bcd8739ae039), {
            expanded: expanded,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), expandedClsName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: flattenColumns.length,
            isEmpty: false
        }, expandContent);
    }
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, baseRowNode, expandRowNode);
}
$8965a7fd6345477e$var$BodyRow.displayName = 'BodyRow';
var $8965a7fd6345477e$export$2e2bcd8739ae039 = (0, $7be8aaea61012844$export$e9e4cb9eb9e2b4c4)($8965a7fd6345477e$var$BodyRow);




var $jMaZ8 = parcelRequire("jMaZ8");

var $bAXx0 = parcelRequire("bAXx0");

var $jMaZ8 = parcelRequire("jMaZ8");

var $bAXx0 = parcelRequire("bAXx0");
function $dbe27edaf9b82172$export$2e2bcd8739ae039(_ref) {
    var columnKey = _ref.columnKey, onColumnResize = _ref.onColumnResize;
    var cellRef = $jMaZ8.useRef();
    $jMaZ8.useEffect(function() {
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        data: columnKey
    }, /*#__PURE__*/ $jMaZ8.createElement("td", {
        ref: cellRef,
        style: {
            padding: 0,
            border: 0,
            height: 0
        }
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: {
            height: 0,
            overflow: 'hidden'
        }
    }, "\xA0")));
}


function $fd8f1e035acc39c6$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, columnsKey = _ref.columnsKey, onColumnResize = _ref.onColumnResize;
    return /*#__PURE__*/ $jMaZ8.createElement("tr", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-measure-row"),
        style: {
            height: 0,
            fontSize: 0
        }
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default).Collection, {
        onBatchResize: function onBatchResize(infoList) {
            infoList.forEach(function(_ref2) {
                var columnKey = _ref2.data, size = _ref2.size;
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map(function(columnKey) {
        return /*#__PURE__*/ $jMaZ8.createElement((0, $dbe27edaf9b82172$export$2e2bcd8739ae039), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize
        });
    })));
}


function $ee467adcea733087$var$Body(props) {
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    var data = props.data, measureColumnWidth = props.measureColumnWidth;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent',
        'onColumnResize',
        'flattenColumns',
        'getRowKey',
        'expandedKeys',
        'childrenColumnName',
        'emptyNode'
    ]), prefixCls = _useContext.prefixCls, getComponent = _useContext.getComponent, onColumnResize = _useContext.onColumnResize, flattenColumns = _useContext.flattenColumns, getRowKey = _useContext.getRowKey, expandedKeys = _useContext.expandedKeys, childrenColumnName = _useContext.childrenColumnName, emptyNode = _useContext.emptyNode;
    var flattenData = (0, $8bf2575d5b9e236e$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // =================== Performance ====================
    var perfRef = $jMaZ8.useRef({
        renderWithProps: false
    });
    // ====================== Render ======================
    var WrapperComponent = getComponent([
        'body',
        'wrapper'
    ], 'tbody');
    var trComponent = getComponent([
        'body',
        'row'
    ], 'tr');
    var tdComponent = getComponent([
        'body',
        'cell'
    ], 'td');
    var thComponent = getComponent([
        'body',
        'cell'
    ], 'th');
    var rows;
    if (data.length) rows = flattenData.map(function(item, idx) {
        var record = item.record, indent = item.indent, renderIndex = item.index;
        var key = getRowKey(record, idx);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $8965a7fd6345477e$export$2e2bcd8739ae039), {
            key: key,
            rowKey: key,
            record: record,
            index: idx,
            renderIndex: renderIndex,
            rowComponent: trComponent,
            cellComponent: tdComponent,
            scopeCellComponent: thComponent,
            indent: indent
        });
    });
    else rows = /*#__PURE__*/ $jMaZ8.createElement((0, $99810d3402223c12$export$2e2bcd8739ae039), {
        expanded: true,
        className: "".concat(prefixCls, "-placeholder"),
        prefixCls: prefixCls,
        component: trComponent,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length,
        isEmpty: true
    }, emptyNode);
    var columnsKey = (0, $44c4837b2ae0db52$export$fd2ca5407d9be470)(flattenColumns);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $7f77412c600021fd$export$2e2bcd8739ae039).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $jMaZ8.createElement(WrapperComponent, {
        className: "".concat(prefixCls, "-tbody")
    }, measureColumnWidth && /*#__PURE__*/ $jMaZ8.createElement((0, $fd8f1e035acc39c6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        columnsKey: columnsKey,
        onColumnResize: onColumnResize
    }), rows));
}
$ee467adcea733087$var$Body.displayName = 'Body';
var $ee467adcea733087$export$2e2bcd8739ae039 = (0, $7be8aaea61012844$export$e9e4cb9eb9e2b4c4)($ee467adcea733087$var$Body);



var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $2bFmQ = parcelRequire("2bFmQ");
var $4a3a27f5347ea785$var$_excluded = [
    "expandable"
];
var $4a3a27f5347ea785$export$f8dba99c0d5b6b87 = 'RC_TABLE_INTERNAL_COL_DEFINE';
function $4a3a27f5347ea785$export$e215b9806eacdfb5(props) {
    var expandable = props.expandable, legacyExpandableConfig = (0, $4b02Q.default)(props, $4a3a27f5347ea785$var$_excluded);
    var config;
    if ('expandable' in props) config = (0, $8u3qN.default)((0, $8u3qN.default)({}, legacyExpandableConfig), expandable);
    else {
        if ([
            'indentSize',
            'expandedRowKeys',
            'defaultExpandedRowKeys',
            'defaultExpandAllRows',
            'expandedRowRender',
            'expandRowByClick',
            'expandIcon',
            'onExpand',
            'onExpandedRowsChange',
            'expandedRowClassName',
            'expandIconColumnIndex',
            'showExpandColumn',
            'title'
        ].some(function(prop) {
            return prop in props;
        })) (0, $2bFmQ.default)(false, 'expanded related props have been moved into `expandable`.');
        config = legacyExpandableConfig;
    }
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}




var $4a8127c32b4901f5$var$_excluded = [
    "columnType"
];
function $4a8127c32b4901f5$var$ColGroup(_ref) {
    var colWidths = _ref.colWidths, columns = _ref.columns, columCount = _ref.columCount;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'tableLayout'
    ]), tableLayout = _useContext.tableLayout;
    var cols = [];
    var len = columCount || columns.length;
    // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    var mustInsert = false;
    for(var i = len - 1; i >= 0; i -= 1){
        var width = colWidths[i];
        var column = columns && columns[i];
        var additionalProps = void 0;
        var minWidth = void 0;
        if (column) {
            additionalProps = column[0, $4a3a27f5347ea785$export$f8dba99c0d5b6b87];
            // fixed will cause layout problems
            if (tableLayout === 'auto') minWidth = column.minWidth;
        }
        if (width || minWidth || additionalProps || mustInsert) {
            var _ref2 = additionalProps || {}, columnType = _ref2.columnType, restAdditionalProps = (0, $4b02Q.default)(_ref2, $4a8127c32b4901f5$var$_excluded);
            cols.unshift(/*#__PURE__*/ $jMaZ8.createElement("col", (0, $hH60s.default)({
                key: i,
                style: {
                    width: width,
                    minWidth: minWidth
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return /*#__PURE__*/ $jMaZ8.createElement("colgroup", null, cols);
}
var $4a8127c32b4901f5$export$2e2bcd8739ae039 = $4a8127c32b4901f5$var$ColGroup;





var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $4b02Q = parcelRequire("4b02Q");


var $giSak = parcelRequire("giSak");

var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");



var $f38b02fb595b4071$var$_excluded = [
    "className",
    "noData",
    "columns",
    "flattenColumns",
    "colWidths",
    "columCount",
    "stickyOffsets",
    "direction",
    "fixHeader",
    "stickyTopOffset",
    "stickyBottomOffset",
    "stickyClassName",
    "onScroll",
    "maxContentScroll",
    "children"
];
function $f38b02fb595b4071$var$useColumnWidth(colWidths, columCount) {
    return (0, $jMaZ8.useMemo)(function() {
        var cloneColumns = [];
        for(var i = 0; i < columCount; i += 1){
            var val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join('_'),
        columCount
    ]);
}
var $f38b02fb595b4071$var$FixedHolder = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    var className = props.className, noData = props.noData, columns = props.columns, flattenColumns = props.flattenColumns, colWidths = props.colWidths, columCount = props.columCount, stickyOffsets = props.stickyOffsets, direction = props.direction, fixHeader = props.fixHeader, stickyTopOffset = props.stickyTopOffset, stickyBottomOffset = props.stickyBottomOffset, stickyClassName = props.stickyClassName, onScroll = props.onScroll, maxContentScroll = props.maxContentScroll, children = props.children, restProps = (0, $4b02Q.default)(props, $f38b02fb595b4071$var$_excluded);
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'prefixCls',
        'scrollbarSize',
        'isSticky',
        'getComponent'
    ]), prefixCls = _useContext.prefixCls, scrollbarSize = _useContext.scrollbarSize, isSticky = _useContext.isSticky, getComponent = _useContext.getComponent;
    var TableComponent = getComponent([
        'header',
        'table'
    ], 'table');
    var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
    // Pass wheel to scroll event
    var scrollRef = $jMaZ8.useRef(null);
    var setScrollRef = $jMaZ8.useCallback(function(element) {
        (0, $1cfGC.fillRef)(ref, element);
        (0, $1cfGC.fillRef)(scrollRef, element);
    }, []);
    $jMaZ8.useEffect(function() {
        var _scrollRef$current;
        function onWheel(e) {
            var _ref = e, currentTarget = _ref.currentTarget, deltaX = _ref.deltaX;
            if (deltaX) {
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: currentTarget.scrollLeft + deltaX
                });
                e.preventDefault();
            }
        }
        (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.addEventListener('wheel', onWheel, {
            passive: false
        });
        return function() {
            var _scrollRef$current2;
            (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 || _scrollRef$current2.removeEventListener('wheel', onWheel);
        };
    }, []);
    // Check if all flattenColumns has width
    var allFlattenColumnsWithWidth = $jMaZ8.useMemo(function() {
        return flattenColumns.every(function(column) {
            return column.width;
        });
    }, [
        flattenColumns
    ]);
    // Add scrollbar column
    var lastColumn = flattenColumns[flattenColumns.length - 1];
    var ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: function onHeaderCell() {
            return {
                className: "".concat(prefixCls, "-cell-scrollbar")
            };
        }
    };
    var columnsWithScrollbar = (0, $jMaZ8.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $fvBso.default)(columns), [
            ScrollBarColumn
        ]) : columns;
    }, [
        combinationScrollBarSize,
        columns
    ]);
    var flattenColumnsWithScrollbar = (0, $jMaZ8.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $fvBso.default)(flattenColumns), [
            ScrollBarColumn
        ]) : flattenColumns;
    }, [
        combinationScrollBarSize,
        flattenColumns
    ]);
    // Calculate the sticky offsets
    var headerStickyOffsets = (0, $jMaZ8.useMemo)(function() {
        var right = stickyOffsets.right, left = stickyOffsets.left;
        return (0, $8u3qN.default)((0, $8u3qN.default)({}, stickyOffsets), {}, {
            left: direction === 'rtl' ? [].concat((0, $fvBso.default)(left.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]) : left,
            right: direction === 'rtl' ? right : [].concat((0, $fvBso.default)(right.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]),
            isSticky: isSticky
        });
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    var mergedColumnWidth = $f38b02fb595b4071$var$useColumnWidth(colWidths, columCount);
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: (0, $8u3qN.default)({
            overflow: 'hidden'
        }, isSticky ? {
            top: stickyTopOffset,
            bottom: stickyBottomOffset
        } : {}),
        ref: setScrollRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, (0, $eq8kl.default)({}, stickyClassName, !!stickyClassName))
    }, /*#__PURE__*/ $jMaZ8.createElement(TableComponent, {
        style: {
            tableLayout: 'fixed',
            visibility: noData || mergedColumnWidth ? null : 'hidden'
        }
    }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /*#__PURE__*/ $jMaZ8.createElement((0, $4a8127c32b4901f5$export$2e2bcd8739ae039), {
        colWidths: mergedColumnWidth ? [].concat((0, $fvBso.default)(mergedColumnWidth), [
            combinationScrollBarSize
        ]) : [],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children((0, $8u3qN.default)((0, $8u3qN.default)({}, restProps), {}, {
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    }))));
});
$f38b02fb595b4071$var$FixedHolder.displayName = 'FixedHolder';
var /** Return a table in div as fixed element which contains sticky info */ // export default responseImmutable(FixedHolder);
$f38b02fb595b4071$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.memo($f38b02fb595b4071$var$FixedHolder);






var $jMaZ8 = parcelRequire("jMaZ8");



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");





var $a4dc4fd81df7e435$var$HeaderRow = function HeaderRow(props) {
    var cells = props.cells, stickyOffsets = props.stickyOffsets, flattenColumns = props.flattenColumns, RowComponent = props.rowComponent, CellComponent = props.cellComponent, onHeaderRow = props.onHeaderRow, index = props.index;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'prefixCls',
        'direction'
    ]), prefixCls = _useContext.prefixCls, direction = _useContext.direction;
    var rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map(function(cell) {
        return cell.column;
    }), index);
    var columnsKey = (0, $44c4837b2ae0db52$export$fd2ca5407d9be470)(cells.map(function(cell) {
        return cell.column;
    }));
    return /*#__PURE__*/ $jMaZ8.createElement(RowComponent, rowProps, cells.map(function(cell, cellIndex) {
        var column = cell.column;
        var fixedInfo = (0, $66bbefb7242c9d0c$export$695db918331141f3)(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
        var additionalProps;
        if (column && column.onHeaderCell) additionalProps = cell.column.onHeaderCell(column);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $a05b829b7a938bc2$export$2e2bcd8739ae039), (0, $hH60s.default)({}, cell, {
            scope: column.title ? cell.colSpan > 1 ? 'colgroup' : 'col' : null,
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
};
$a4dc4fd81df7e435$var$HeaderRow.displayName = 'HeaderRow';
var $a4dc4fd81df7e435$export$2e2bcd8739ae039 = $a4dc4fd81df7e435$var$HeaderRow;


function $b919760ed76ef7ae$var$parseHeaderRows(rootColumns) {
    var rows = [];
    function fillRowCells(columns, colIndex) {
        var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        var currentColIndex = colIndex;
        var colSpans = columns.filter(Boolean).map(function(column) {
            var cell = {
                key: column.key,
                className: column.className || '',
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            var colSpan = 1;
            var subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function(total, count) {
                    return total + count;
                }, 0);
                cell.hasSubColumns = true;
            }
            if ('colSpan' in column) colSpan = column.colSpan;
            if ('rowSpan' in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    }
    // Generate `rows` cell data
    fillRowCells(rootColumns, 0);
    // Handle `rowSpan`
    var rowCount = rows.length;
    var _loop = function _loop(rowIndex) {
        rows[rowIndex].forEach(function(cell) {
            if (!('rowSpan' in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
            cell.rowSpan = rowCount - rowIndex;
        });
    };
    for(var rowIndex = 0; rowIndex < rowCount; rowIndex += 1)_loop(rowIndex);
    return rows;
}
var $b919760ed76ef7ae$var$Header = function Header(props) {
    (0, $ec02351ae4fda3aa$export$2e2bcd8739ae039)(props);
    var stickyOffsets = props.stickyOffsets, columns = props.columns, flattenColumns = props.flattenColumns, onHeaderRow = props.onHeaderRow;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent'
    ]), prefixCls = _useContext.prefixCls, getComponent = _useContext.getComponent;
    var rows = $jMaZ8.useMemo(function() {
        return $b919760ed76ef7ae$var$parseHeaderRows(columns);
    }, [
        columns
    ]);
    var WrapperComponent = getComponent([
        'header',
        'wrapper'
    ], 'thead');
    var trComponent = getComponent([
        'header',
        'row'
    ], 'tr');
    var thComponent = getComponent([
        'header',
        'cell'
    ], 'th');
    return /*#__PURE__*/ $jMaZ8.createElement(WrapperComponent, {
        className: "".concat(prefixCls, "-thead")
    }, rows.map(function(row, rowIndex) {
        var rowNode = /*#__PURE__*/ $jMaZ8.createElement((0, $a4dc4fd81df7e435$export$2e2bcd8739ae039), {
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
};
var $b919760ed76ef7ae$export$2e2bcd8739ae039 = (0, $7be8aaea61012844$export$e9e4cb9eb9e2b4c4)($b919760ed76ef7ae$var$Header);



var $3fkx6 = parcelRequire("3fkx6");

var $eq8kl = parcelRequire("eq8kl");

var $fvBso = parcelRequire("fvBso");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $a6yuN = parcelRequire("a6yuN");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");



var $8u3qN = parcelRequire("8u3qN");

var $jMaZ8 = parcelRequire("jMaZ8");
function $c6aed1dbb1844765$var$parseColWidth(totalWidth) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (typeof width === 'number') return width;
    if (width.endsWith('%')) return totalWidth * parseFloat(width) / 100;
    return null;
}
function $c6aed1dbb1844765$export$2e2bcd8739ae039(flattenColumns, scrollWidth, clientWidth) {
    return $jMaZ8.useMemo(function() {
        // Fill width if needed
        if (scrollWidth && scrollWidth > 0) {
            var totalWidth = 0;
            var missWidthCount = 0;
            // collect not given width column
            flattenColumns.forEach(function(col) {
                var colWidth = $c6aed1dbb1844765$var$parseColWidth(scrollWidth, col.width);
                if (colWidth) totalWidth += colWidth;
                else missWidthCount += 1;
            });
            // Fill width
            var maxFitWidth = Math.max(scrollWidth, clientWidth);
            var restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
            var restCount = missWidthCount;
            var avgWidth = restWidth / missWidthCount;
            var realTotal = 0;
            var filledColumns = flattenColumns.map(function(col) {
                var clone = (0, $8u3qN.default)({}, col);
                var colWidth = $c6aed1dbb1844765$var$parseColWidth(scrollWidth, clone.width);
                if (colWidth) clone.width = colWidth;
                else {
                    var colAvgWidth = Math.floor(avgWidth);
                    clone.width = restCount === 1 ? restWidth : colAvgWidth;
                    restWidth -= colAvgWidth;
                    restCount -= 1;
                }
                realTotal += clone.width;
                return clone;
            });
            // If realTotal is less than clientWidth,
            // We need extend column width
            if (realTotal < maxFitWidth) {
                var scale = maxFitWidth / realTotal;
                restWidth = maxFitWidth;
                filledColumns.forEach(function(col, index) {
                    var colWidth = Math.floor(col.width * scale);
                    col.width = index === filledColumns.length - 1 ? restWidth : colWidth;
                    restWidth -= colWidth;
                });
            }
            return [
                filledColumns,
                Math.max(realTotal, maxFitWidth)
            ];
        }
        return [
            flattenColumns,
            scrollWidth
        ];
    }, [
        flattenColumns,
        scrollWidth,
        clientWidth
    ]);
}


var $7831dce2cc3196b6$var$_excluded = [
    "children"
], $7831dce2cc3196b6$var$_excluded2 = [
    "fixed"
];
function $7831dce2cc3196b6$export$d87a97eba44e0f9c(children) {
    return (0, $a6yuN.default)(children).filter(function(node) {
        return /*#__PURE__*/ $jMaZ8.isValidElement(node);
    }).map(function(_ref) {
        var key = _ref.key, props = _ref.props;
        var nodeChildren = props.children, restProps = (0, $4b02Q.default)(props, $7831dce2cc3196b6$var$_excluded);
        var column = (0, $8u3qN.default)({
            key: key
        }, restProps);
        if (nodeChildren) column.children = $7831dce2cc3196b6$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $7831dce2cc3196b6$var$filterHiddenColumns(columns) {
    return columns.filter(function(column) {
        return column && (0, $1Esi2.default)(column) === 'object' && !column.hidden;
    }).map(function(column) {
        var subColumns = column.children;
        if (subColumns && subColumns.length > 0) return (0, $8u3qN.default)((0, $8u3qN.default)({}, column), {}, {
            children: $7831dce2cc3196b6$var$filterHiddenColumns(subColumns)
        });
        return column;
    });
}
function $7831dce2cc3196b6$var$flatColumns(columns) {
    var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
    return columns.filter(function(column) {
        return column && (0, $1Esi2.default)(column) === 'object';
    }).reduce(function(list, column, index) {
        var fixed = column.fixed;
        // Convert `fixed='true'` to `fixed='left'` instead
        var parsedFixed = fixed === true ? 'left' : fixed;
        var mergedKey = "".concat(parentKey, "-").concat(index);
        var subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [].concat((0, $fvBso.default)(list), (0, $fvBso.default)($7831dce2cc3196b6$var$flatColumns(subColumns, mergedKey).map(function(subColum) {
            return (0, $8u3qN.default)({
                fixed: parsedFixed
            }, subColum);
        })));
        return [].concat((0, $fvBso.default)(list), [
            (0, $8u3qN.default)((0, $8u3qN.default)({
                key: mergedKey
            }, column), {}, {
                fixed: parsedFixed
            })
        ]);
    }, []);
}
function $7831dce2cc3196b6$var$revertForRtl(columns) {
    return columns.map(function(column) {
        var fixed = column.fixed, restProps = (0, $4b02Q.default)(column, $7831dce2cc3196b6$var$_excluded2);
        // Convert `fixed='left'` to `fixed='right'` instead
        var parsedFixed = fixed;
        if (fixed === 'left') parsedFixed = 'right';
        else if (fixed === 'right') parsedFixed = 'left';
        return (0, $8u3qN.default)({
            fixed: parsedFixed
        }, restProps);
    });
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $7831dce2cc3196b6$var$useColumns(_ref2, transformColumns) {
    var prefixCls = _ref2.prefixCls, columns = _ref2.columns, children = _ref2.children, expandable = _ref2.expandable, expandedKeys = _ref2.expandedKeys, columnTitle = _ref2.columnTitle, getRowKey = _ref2.getRowKey, onTriggerExpand = _ref2.onTriggerExpand, expandIcon = _ref2.expandIcon, rowExpandable = _ref2.rowExpandable, expandIconColumnIndex = _ref2.expandIconColumnIndex, direction = _ref2.direction, expandRowByClick = _ref2.expandRowByClick, columnWidth = _ref2.columnWidth, fixed = _ref2.fixed, scrollWidth = _ref2.scrollWidth, clientWidth = _ref2.clientWidth;
    var baseColumns = $jMaZ8.useMemo(function() {
        var newColumns = columns || $7831dce2cc3196b6$export$d87a97eba44e0f9c(children) || [];
        return $7831dce2cc3196b6$var$filterHiddenColumns(newColumns.slice());
    }, [
        columns,
        children
    ]);
    // ========================== Expand ==========================
    var withExpandColumns = $jMaZ8.useMemo(function() {
        if (expandable) {
            var cloneColumns = baseColumns.slice();
            // >>> Warning if use `expandIconColumnIndex`
            if (expandIconColumnIndex >= 0) (0, $2bFmQ.default)(false, '`expandIconColumnIndex` is deprecated. Please use `Table.EXPAND_COLUMN` in `columns` instead.');
            // >>> Insert expand column if not exist
            if (!cloneColumns.includes((0, $f40867b2b1b9b23f$export$e1053575ddfcb301))) {
                var expandColIndex = expandIconColumnIndex || 0;
                if (expandColIndex >= 0 && (expandColIndex || fixed === 'left' || !fixed)) cloneColumns.splice(expandColIndex, 0, (0, $f40867b2b1b9b23f$export$e1053575ddfcb301));
                if (fixed === 'right') cloneColumns.splice(baseColumns.length, 0, (0, $f40867b2b1b9b23f$export$e1053575ddfcb301));
            }
            // >>> Deduplicate additional expand column
            if (cloneColumns.filter(function(c) {
                return c === (0, $f40867b2b1b9b23f$export$e1053575ddfcb301);
            }).length > 1) (0, $2bFmQ.default)(false, 'There exist more than one `EXPAND_COLUMN` in `columns`.');
            var expandColumnIndex = cloneColumns.indexOf((0, $f40867b2b1b9b23f$export$e1053575ddfcb301));
            cloneColumns = cloneColumns.filter(function(column, index) {
                return column !== (0, $f40867b2b1b9b23f$export$e1053575ddfcb301) || index === expandColumnIndex;
            });
            // >>> Check if expand column need to fixed
            var prevColumn = baseColumns[expandColumnIndex];
            var fixedColumn;
            if (fixed) fixedColumn = fixed;
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
            // >>> Create expandable column
            var expandColumn = (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, (0, $4a3a27f5347ea785$export$f8dba99c0d5b6b87), {
                className: "".concat(prefixCls, "-expand-icon-col"),
                columnType: 'EXPAND_COLUMN'
            }), "title", columnTitle), "fixed", fixedColumn), "className", "".concat(prefixCls, "-row-expand-icon-cell")), "width", columnWidth), "render", function render(_, record, index) {
                var rowKey = getRowKey(record, index);
                var expanded = expandedKeys.has(rowKey);
                var recordExpandable = rowExpandable ? rowExpandable(record) : true;
                var icon = expandIcon({
                    prefixCls: prefixCls,
                    expanded: expanded,
                    expandable: recordExpandable,
                    record: record,
                    onExpand: onTriggerExpand
                });
                if (expandRowByClick) return /*#__PURE__*/ $jMaZ8.createElement("span", {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    }
                }, icon);
                return icon;
            });
            return cloneColumns.map(function(col) {
                return col === (0, $f40867b2b1b9b23f$export$e1053575ddfcb301) ? expandColumn : col;
            });
        }
        if (baseColumns.includes((0, $f40867b2b1b9b23f$export$e1053575ddfcb301))) (0, $2bFmQ.default)(false, '`expandable` is not config but there exist `EXPAND_COLUMN` in `columns`.');
        return baseColumns.filter(function(col) {
            return col !== (0, $f40867b2b1b9b23f$export$e1053575ddfcb301);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction
    ]);
    // ========================= Transform ========================
    var mergedColumns = $jMaZ8.useMemo(function() {
        var finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
        // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: function render() {
                    return null;
                }
            }
        ];
        return finalColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]);
    // ========================== Flatten =========================
    var flattenColumns = $jMaZ8.useMemo(function() {
        if (direction === 'rtl') return $7831dce2cc3196b6$var$revertForRtl($7831dce2cc3196b6$var$flatColumns(mergedColumns));
        return $7831dce2cc3196b6$var$flatColumns(mergedColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedColumns,
        direction,
        scrollWidth
    ]);
    // ========================= Gap Fixed ========================
    var hasGapFixed = $jMaZ8.useMemo(function() {
        // Fixed: left, since old browser not support `findLastIndex`, we should use reverse loop
        var lastLeftIndex = -1;
        for(var i = flattenColumns.length - 1; i >= 0; i -= 1){
            var colFixed = flattenColumns[i].fixed;
            if (colFixed === 'left' || colFixed === true) {
                lastLeftIndex = i;
                break;
            }
        }
        if (lastLeftIndex >= 0) for(var _i = 0; _i <= lastLeftIndex; _i += 1){
            var _colFixed = flattenColumns[_i].fixed;
            if (_colFixed !== 'left' && _colFixed !== true) return true;
        }
        // Fixed: right
        var firstRightIndex = flattenColumns.findIndex(function(_ref3) {
            var colFixed = _ref3.fixed;
            return colFixed === 'right';
        });
        if (firstRightIndex >= 0) for(var _i2 = firstRightIndex; _i2 < flattenColumns.length; _i2 += 1){
            var _colFixed2 = flattenColumns[_i2].fixed;
            if (_colFixed2 !== 'right') return true;
        }
        return false;
    }, [
        flattenColumns
    ]);
    // ========================= FillWidth ========================
    var _useWidthColumns = (0, $c6aed1dbb1844765$export$2e2bcd8739ae039)(flattenColumns, scrollWidth, clientWidth), _useWidthColumns2 = (0, $3fkx6.default)(_useWidthColumns, 2), filledColumns = _useWidthColumns2[0], realScrollWidth = _useWidthColumns2[1];
    return [
        mergedColumns,
        filledColumns,
        realScrollWidth,
        hasGapFixed
    ];
}
var $7831dce2cc3196b6$export$2e2bcd8739ae039 = $7831dce2cc3196b6$var$useColumns;



var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $1Esi2 = parcelRequire("1Esi2");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");



function $354c24095cffe347$export$2e2bcd8739ae039(props, mergedData, getRowKey) {
    var expandableConfig = (0, $4a3a27f5347ea785$export$e215b9806eacdfb5)(props);
    var expandIcon = expandableConfig.expandIcon, expandedRowKeys = expandableConfig.expandedRowKeys, defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys, defaultExpandAllRows = expandableConfig.defaultExpandAllRows, expandedRowRender = expandableConfig.expandedRowRender, onExpand = expandableConfig.onExpand, onExpandedRowsChange = expandableConfig.onExpandedRowsChange, childrenColumnName = expandableConfig.childrenColumnName;
    var mergedExpandIcon = expandIcon || (0, $17ebede92ab776bb$export$ae14373a7f810e33);
    var mergedChildrenColumnName = childrenColumnName || 'children';
    var expandableType = $jMaZ8.useMemo(function() {
        if (expandedRowRender) return 'row';
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && props.internalHooks === (0, $f40867b2b1b9b23f$export$91b75cf262680225) && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function(record) {
            return record && (0, $1Esi2.default)(record) === 'object' && record[mergedChildrenColumnName];
        })) return 'nest';
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    var _React$useState = $jMaZ8.useState(function() {
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $17ebede92ab776bb$export$49bec56f6055f375)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    }), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), innerExpandedKeys = _React$useState2[0], setInnerExpandedKeys = _React$useState2[1];
    var mergedExpandedKeys = $jMaZ8.useMemo(function() {
        return new Set(expandedRowKeys || innerExpandedKeys || []);
    }, [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    var onTriggerExpand = $jMaZ8.useCallback(function(record) {
        var key = getRowKey(record, mergedData.indexOf(record));
        var newExpandedKeys;
        var hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = (0, $fvBso.default)(mergedExpandedKeys);
        } else newExpandedKeys = [].concat((0, $fvBso.default)(mergedExpandedKeys), [
            key
        ]);
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]);
    // Warning if use `expandedRowRender` and nest children in the same time
    if (expandedRowRender && mergedData.some(function(record) {
        return Array.isArray(record === null || record === void 0 ? void 0 : record[mergedChildrenColumnName]);
    })) (0, $2bFmQ.default)(false, '`expandedRowRender` should not use with nested Table');
    return [
        expandableConfig,
        expandableType,
        mergedExpandedKeys,
        mergedExpandIcon,
        mergedChildrenColumnName,
        onTriggerExpand
    ];
}



var $hBgfL = parcelRequire("hBgfL");

var $9O5K3 = parcelRequire("9O5K3");

function $3d7dc2dcd575dcaa$export$2e2bcd8739ae039(flattenColumns, stickyOffsets, direction) {
    var fixedInfoList = flattenColumns.map(function(_, colIndex) {
        return (0, $66bbefb7242c9d0c$export$695db918331141f3)(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
    });
    return (0, $hBgfL.default)(function() {
        return fixedInfoList;
    }, [
        fixedInfoList
    ], function(prev, next) {
        return !(0, $9O5K3.default)(prev, next);
    });
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $861443e9ccc192cb$export$510e4dd13e0b67dd(defaultState) {
    var stateRef = (0, $jMaZ8.useRef)(defaultState);
    var _useState = (0, $jMaZ8.useState)({}), _useState2 = (0, $3fkx6.default)(_useState, 2), forceUpdate = _useState2[1];
    var lastPromiseRef = (0, $jMaZ8.useRef)(null);
    var updateBatchRef = (0, $jMaZ8.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        var promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(function() {
            if (lastPromiseRef.current === promise) {
                var prevBatch = updateBatchRef.current;
                var prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach(function(batchUpdater) {
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $jMaZ8.useEffect)(function() {
        return function() {
            lastPromiseRef.current = null;
        };
    }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $861443e9ccc192cb$export$d63c72d5e6d02249(defaultState) {
    var frameRef = (0, $jMaZ8.useRef)(defaultState || null);
    var timeoutRef = (0, $jMaZ8.useRef)();
    function cleanUp() {
        window.clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = window.setTimeout(function() {
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $jMaZ8.useEffect)(function() {
        return cleanUp;
    }, []);
    return [
        setState,
        getState
    ];
}



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");
function $6b3438117cd4c78e$export$2e2bcd8739ae039() {
    var _React$useState = $jMaZ8.useState(-1), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), startRow = _React$useState2[0], setStartRow = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(-1), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), endRow = _React$useState4[0], setEndRow = _React$useState4[1];
    var onHover = $jMaZ8.useCallback(function(start, end) {
        setStartRow(start);
        setEndRow(end);
    }, []);
    return [
        startRow,
        endRow,
        onHover
    ];
}



var $1Esi2 = parcelRequire("1Esi2");

var $jMaZ8 = parcelRequire("jMaZ8");

var $h9ujZ = parcelRequire("h9ujZ");
// fix ssr render
var $be132e764e3d3775$var$defaultContainer = (0, $h9ujZ.default)() ? window : null;
function $be132e764e3d3775$export$2e2bcd8739ae039(sticky, prefixCls) {
    var _ref = (0, $1Esi2.default)(sticky) === 'object' ? sticky : {}, _ref$offsetHeader = _ref.offsetHeader, offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader, _ref$offsetSummary = _ref.offsetSummary, offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary, _ref$offsetScroll = _ref.offsetScroll, offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll, _ref$getContainer = _ref.getContainer, getContainer = _ref$getContainer === void 0 ? function() {
        return $be132e764e3d3775$var$defaultContainer;
    } : _ref$getContainer;
    var container = getContainer() || $be132e764e3d3775$var$defaultContainer;
    var isSticky = !!sticky;
    return $jMaZ8.useMemo(function() {
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-holder") : '',
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        isSticky,
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}



var $jMaZ8 = parcelRequire("jMaZ8");
/**
 * Get sticky column offset width
 */ function $efe44810beb29856$var$useStickyOffsets(colWidths, flattenColumns, direction) {
    var stickyOffsets = (0, $jMaZ8.useMemo)(function() {
        var columnCount = flattenColumns.length;
        var getOffsets = function getOffsets(startIndex, endIndex, offset) {
            var offsets = [];
            var total = 0;
            for(var i = startIndex; i !== endIndex; i += offset){
                offsets.push(total);
                if (flattenColumns[i].fixed) total += colWidths[i] || 0;
            }
            return offsets;
        };
        var startOffsets = getOffsets(0, columnCount, 1);
        var endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
        return direction === 'rtl' ? {
            left: endOffsets,
            right: startOffsets
        } : {
            left: startOffsets,
            right: endOffsets
        };
    }, [
        colWidths,
        flattenColumns,
        direction
    ]);
    return stickyOffsets;
}
var $efe44810beb29856$export$2e2bcd8739ae039 = $efe44810beb29856$var$useStickyOffsets;



var $jMaZ8 = parcelRequire("jMaZ8");
function $70fb68edd7d7c576$var$Panel(_ref) {
    var className = _ref.className, children = _ref.children;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: className
    }, children);
}
var $70fb68edd7d7c576$export$2e2bcd8739ae039 = $70fb68edd7d7c576$var$Panel;



var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");


var $giSak = parcelRequire("giSak");

var $6UWRi = parcelRequire("6UWRi");
function $b5bd9913c5785228$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($6UWRi))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6UWRi))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}




var $jMaZ8 = parcelRequire("jMaZ8");



var $aZxvk = parcelRequire("aZxvk");

var $cYkhj = parcelRequire("cYkhj");
function $38758b2da8d4c7f3$export$622cea445a1c5b7d(node) {
    var element = (0, $cYkhj.getDOM)(node);
    var box = element.getBoundingClientRect();
    var docElem = document.documentElement;
    // < ie8 not support win.pageXOffset, use docElem.scrollLeft instead
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}


var $59011ce6b0c75ca8$var$StickyScrollBar = function StickyScrollBar(_ref, ref) {
    var _scrollBodyRef$curren, _scrollBodyRef$curren2;
    var scrollBodyRef = _ref.scrollBodyRef, onScroll = _ref.onScroll, offsetScroll = _ref.offsetScroll, container = _ref.container, direction = _ref.direction;
    var prefixCls = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), 'prefixCls');
    var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
    var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
    var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    var scrollBarRef = $jMaZ8.useRef();
    var _useLayoutState = (0, $861443e9ccc192cb$export$510e4dd13e0b67dd)({
        scrollLeft: 0,
        isHiddenScrollBar: true
    }), _useLayoutState2 = (0, $3fkx6.default)(_useLayoutState, 2), scrollState = _useLayoutState2[0], setScrollState = _useLayoutState2[1];
    var refState = $jMaZ8.useRef({
        delta: 0,
        x: 0
    });
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), isActive = _React$useState2[0], setActive = _React$useState2[1];
    var rafRef = $jMaZ8.useRef(null);
    $jMaZ8.useEffect(function() {
        return function() {
            (0, $aZxvk.default).cancel(rafRef.current);
        };
    }, []);
    var onMouseUp = function onMouseUp() {
        setActive(false);
    };
    var onMouseDown = function onMouseDown(event) {
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    var onMouseMove = function onMouseMove(event) {
        var _window;
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event), buttons = _ref2.buttons;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        var isRTL = direction === 'rtl';
        // Limit scroll range
        left = Math.max(isRTL ? scrollBarWidth - bodyWidth : 0, Math.min(isRTL ? 0 : bodyWidth - scrollBarWidth, left));
        // Calculate the scroll position and update
        var shouldScroll = !isRTL || Math.abs(left) + Math.abs(scrollBarWidth) < bodyWidth;
        if (shouldScroll) {
            onScroll({
                scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
            });
            refState.current.x = event.pageX;
        }
    };
    var checkScrollBarVisible = function checkScrollBarVisible() {
        rafRef.current = (0, $aZxvk.default)(function() {
            if (!scrollBodyRef.current) return;
            var tableOffsetTop = (0, $38758b2da8d4c7f3$export$622cea445a1c5b7d)(scrollBodyRef.current).top;
            var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
            var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $38758b2da8d4c7f3$export$622cea445a1c5b7d)(container).top + container.clientHeight;
            if (tableBottomOffset - (0, $fb3b2752ae6984c6$export$2e2bcd8739ae039)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState(function(state) {
                return (0, $8u3qN.default)((0, $8u3qN.default)({}, state), {}, {
                    isHiddenScrollBar: true
                });
            });
            else setScrollState(function(state) {
                return (0, $8u3qN.default)((0, $8u3qN.default)({}, state), {}, {
                    isHiddenScrollBar: false
                });
            });
        });
    };
    var setScrollLeft = function setScrollLeft(left) {
        setScrollState(function(state) {
            return (0, $8u3qN.default)((0, $8u3qN.default)({}, state), {}, {
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            });
        });
    };
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            setScrollLeft: setScrollLeft,
            checkScrollBarVisible: checkScrollBarVisible
        };
    });
    $jMaZ8.useEffect(function() {
        var onMouseUpListener = (0, $b5bd9913c5785228$export$2e2bcd8739ae039)(document.body, 'mouseup', onMouseUp, false);
        var onMouseMoveListener = (0, $b5bd9913c5785228$export$2e2bcd8739ae039)(document.body, 'mousemove', onMouseMove, false);
        checkScrollBarVisible();
        return function() {
            onMouseUpListener.remove();
            onMouseMoveListener.remove();
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    $jMaZ8.useEffect(function() {
        var onScrollListener = (0, $b5bd9913c5785228$export$2e2bcd8739ae039)(container, 'scroll', checkScrollBarVisible, false);
        var onResizeListener = (0, $b5bd9913c5785228$export$2e2bcd8739ae039)(window, 'resize', checkScrollBarVisible, false);
        return function() {
            onScrollListener.remove();
            onResizeListener.remove();
        };
    }, [
        container
    ]);
    $jMaZ8.useEffect(function() {
        if (!scrollState.isHiddenScrollBar) setScrollState(function(state) {
            var bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return (0, $8u3qN.default)((0, $8u3qN.default)({}, state), {}, {
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            });
        });
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: {
            height: (0, $fb3b2752ae6984c6$export$2e2bcd8739ae039)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: "".concat(prefixCls, "-sticky-scroll")
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-sticky-scroll-bar"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
        style: {
            width: "".concat(scrollBarWidth, "px"),
            transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
        }
    }));
};
var $59011ce6b0c75ca8$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.forwardRef($59011ce6b0c75ca8$var$StickyScrollBar);






var $cYkhj = parcelRequire("cYkhj");
var $d3fe3c728f980334$export$c42ed95a478b1ec5 = 'rc-table';
// Used for conditions cache
var $d3fe3c728f980334$var$EMPTY_DATA = [];
// Used for customize scroll
var $d3fe3c728f980334$var$EMPTY_SCROLL_TARGET = {};
function $d3fe3c728f980334$var$defaultEmpty() {
    return 'No Data';
}
function $d3fe3c728f980334$var$Table(tableProps, ref) {
    var props = (0, $8u3qN.default)({
        rowKey: 'key',
        prefixCls: $d3fe3c728f980334$export$c42ed95a478b1ec5,
        emptyText: $d3fe3c728f980334$var$defaultEmpty
    }, tableProps);
    var prefixCls = props.prefixCls, className = props.className, rowClassName = props.rowClassName, style = props.style, data = props.data, rowKey = props.rowKey, scroll = props.scroll, tableLayout = props.tableLayout, direction = props.direction, title = props.title, footer = props.footer, summary = props.summary, caption = props.caption, id = props.id, showHeader = props.showHeader, components = props.components, emptyText = props.emptyText, onRow = props.onRow, onHeaderRow = props.onHeaderRow, onScroll = props.onScroll, internalHooks = props.internalHooks, transformColumns = props.transformColumns, internalRefs = props.internalRefs, tailor = props.tailor, getContainerWidth = props.getContainerWidth, sticky = props.sticky, _props$rowHoverable = props.rowHoverable, rowHoverable = _props$rowHoverable === void 0 ? true : _props$rowHoverable;
    var mergedData = data || $d3fe3c728f980334$var$EMPTY_DATA;
    var hasData = !!mergedData.length;
    var useInternalHooks = internalHooks === (0, $f40867b2b1b9b23f$export$91b75cf262680225);
    [
        'onRowClick',
        'onRowDoubleClick',
        'onRowContextMenu',
        'onRowMouseEnter',
        'onRowMouseLeave'
    ].forEach(function(name) {
        (0, $2bFmQ.default)(props[name] === undefined, "`".concat(name, "` is removed, please use `onRow` instead."));
    });
    (0, $2bFmQ.default)(!('getBodyWrapper' in props), '`getBodyWrapper` is deprecated, please use custom `components` instead.');
    // ==================== Customize =====================
    var getComponent = $jMaZ8.useCallback(function(path, defaultComponent) {
        return (0, $k19OO.default)(components, path) || defaultComponent;
    }, [
        components
    ]);
    var getRowKey = $jMaZ8.useMemo(function() {
        if (typeof rowKey === 'function') return rowKey;
        return function(record) {
            var key = record && record[rowKey];
            (0, $2bFmQ.default)(key !== undefined, 'Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key.');
            return key;
        };
    }, [
        rowKey
    ]);
    var customizeScrollBody = getComponent([
        'body'
    ]);
    // ====================== Hover =======================
    var _useHover = (0, $6b3438117cd4c78e$export$2e2bcd8739ae039)(), _useHover2 = (0, $3fkx6.default)(_useHover, 3), startRow = _useHover2[0], endRow = _useHover2[1], onHover = _useHover2[2];
    // ====================== Expand ======================
    var _useExpand = (0, $354c24095cffe347$export$2e2bcd8739ae039)(props, mergedData, getRowKey), _useExpand2 = (0, $3fkx6.default)(_useExpand, 6), expandableConfig = _useExpand2[0], expandableType = _useExpand2[1], mergedExpandedKeys = _useExpand2[2], mergedExpandIcon = _useExpand2[3], mergedChildrenColumnName = _useExpand2[4], onTriggerExpand = _useExpand2[5];
    // ====================== Column ======================
    var scrollX = scroll === null || scroll === void 0 ? void 0 : scroll.x;
    var _React$useState = $jMaZ8.useState(0), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), componentWidth = _React$useState2[0], setComponentWidth = _React$useState2[1];
    var _useColumns = (0, $7831dce2cc3196b6$export$2e2bcd8739ae039)((0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, props), expandableConfig), {}, {
        expandable: !!expandableConfig.expandedRowRender,
        columnTitle: expandableConfig.columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand: onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
        direction: direction,
        scrollWidth: useInternalHooks && tailor && typeof scrollX === 'number' ? scrollX : null,
        clientWidth: componentWidth
    }), useInternalHooks ? transformColumns : null), _useColumns2 = (0, $3fkx6.default)(_useColumns, 4), columns = _useColumns2[0], flattenColumns = _useColumns2[1], flattenScrollX = _useColumns2[2], hasGapFixed = _useColumns2[3];
    var mergedScrollX = flattenScrollX !== null && flattenScrollX !== void 0 ? flattenScrollX : scrollX;
    var columnContext = $jMaZ8.useMemo(function() {
        return {
            columns: columns,
            flattenColumns: flattenColumns
        };
    }, [
        columns,
        flattenColumns
    ]);
    // ======================= Refs =======================
    var fullTableRef = $jMaZ8.useRef();
    var scrollHeaderRef = $jMaZ8.useRef();
    var scrollBodyRef = $jMaZ8.useRef();
    var scrollBodyContainerRef = $jMaZ8.useRef();
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            nativeElement: fullTableRef.current,
            scrollTo: function scrollTo(config) {
                var _scrollBodyRef$curren3;
                if (scrollBodyRef.current instanceof HTMLElement) {
                    // Native scroll
                    var index = config.index, top = config.top, key = config.key;
                    if ((0, $44c4837b2ae0db52$export$b1cd2bdabe361feb)(top)) {
                        var _scrollBodyRef$curren;
                        (_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 || _scrollBodyRef$curren.scrollTo({
                            top: top
                        });
                    } else {
                        var _scrollBodyRef$curren2;
                        var mergedKey = key !== null && key !== void 0 ? key : getRowKey(mergedData[index]);
                        (_scrollBodyRef$curren2 = scrollBodyRef.current.querySelector("[data-row-key=\"".concat(mergedKey, "\"]"))) === null || _scrollBodyRef$curren2 === void 0 || _scrollBodyRef$curren2.scrollIntoView();
                    }
                } else if ((_scrollBodyRef$curren3 = scrollBodyRef.current) !== null && _scrollBodyRef$curren3 !== void 0 && _scrollBodyRef$curren3.scrollTo) // Pass to proxy
                scrollBodyRef.current.scrollTo(config);
            }
        };
    });
    // ====================== Scroll ======================
    var scrollSummaryRef = $jMaZ8.useRef();
    var _React$useState3 = $jMaZ8.useState(false), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), pingedLeft = _React$useState4[0], setPingedLeft = _React$useState4[1];
    var _React$useState5 = $jMaZ8.useState(false), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), pingedRight = _React$useState6[0], setPingedRight = _React$useState6[1];
    var _useLayoutState = (0, $861443e9ccc192cb$export$510e4dd13e0b67dd)(new Map()), _useLayoutState2 = (0, $3fkx6.default)(_useLayoutState, 2), colsWidths = _useLayoutState2[0], updateColsWidths = _useLayoutState2[1];
    // Convert map to number width
    var colsKeys = (0, $44c4837b2ae0db52$export$fd2ca5407d9be470)(flattenColumns);
    var pureColWidths = colsKeys.map(function(columnKey) {
        return colsWidths.get(columnKey);
    });
    var colWidths = $jMaZ8.useMemo(function() {
        return pureColWidths;
    }, [
        pureColWidths.join('_')
    ]);
    var stickyOffsets = (0, $efe44810beb29856$export$2e2bcd8739ae039)(colWidths, flattenColumns, direction);
    var fixHeader = scroll && (0, $44c4837b2ae0db52$export$b76e9316566cc26e)(scroll.y);
    var horizonScroll = scroll && (0, $44c4837b2ae0db52$export$b76e9316566cc26e)(mergedScrollX) || Boolean(expandableConfig.fixed);
    var fixColumn = horizonScroll && flattenColumns.some(function(_ref) {
        var fixed = _ref.fixed;
        return fixed;
    });
    // Sticky
    var stickyRef = $jMaZ8.useRef();
    var _useSticky = (0, $be132e764e3d3775$export$2e2bcd8739ae039)(sticky, prefixCls), isSticky = _useSticky.isSticky, offsetHeader = _useSticky.offsetHeader, offsetSummary = _useSticky.offsetSummary, offsetScroll = _useSticky.offsetScroll, stickyClassName = _useSticky.stickyClassName, container = _useSticky.container;
    // Footer (Fix footer must fixed header)
    var summaryNode = $jMaZ8.useMemo(function() {
        return summary === null || summary === void 0 ? void 0 : summary(mergedData);
    }, [
        summary,
        mergedData
    ]);
    var fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $jMaZ8.isValidElement(summaryNode) && summaryNode.type === (0, $c82329947872c6f8$export$2e2bcd8739ae039) && summaryNode.props.fixed;
    // Scroll
    var scrollXStyle;
    var scrollYStyle;
    var scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: hasData ? 'scroll' : 'auto',
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: 'auto'
        };
        // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: 'hidden'
        };
        scrollTableStyle = {
            width: mergedScrollX === true ? 'auto' : mergedScrollX,
            minWidth: '100%'
        };
    }
    var onColumnResize = $jMaZ8.useCallback(function(columnKey, width) {
        if ((0, $f0dd1e7e6ce84933$export$2e2bcd8739ae039)(fullTableRef.current)) updateColsWidths(function(widths) {
            if (widths.get(columnKey) !== width) {
                var newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    var _useTimeoutLock = (0, $861443e9ccc192cb$export$d63c72d5e6d02249)(null), _useTimeoutLock2 = (0, $3fkx6.default)(_useTimeoutLock, 2), setScrollTarget = _useTimeoutLock2[0], getScrollTarget = _useTimeoutLock2[1];
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === 'function') target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) {
            target.scrollLeft = scrollLeft;
            // Delay to force scroll position if not sync
            // ref: https://github.com/ant-design/ant-design/issues/37179
            if (target.scrollLeft !== scrollLeft) setTimeout(function() {
                target.scrollLeft = scrollLeft;
            }, 0);
        }
    }
    var onInternalScroll = (0, $ktS49.default)(function(_ref2) {
        var currentTarget = _ref2.currentTarget, scrollLeft = _ref2.scrollLeft;
        var isRTL = direction === 'rtl';
        var mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
        var compareTarget = currentTarget || $d3fe3c728f980334$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            var _stickyRef$current;
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
        }
        var measureTarget = currentTarget || scrollHeaderRef.current;
        if (measureTarget) {
            var scrollWidth = // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
            useInternalHooks && tailor && typeof mergedScrollX === 'number' ? mergedScrollX : measureTarget.scrollWidth;
            var clientWidth = measureTarget.clientWidth;
            // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setPingedLeft(false);
                setPingedRight(false);
                return;
            }
            if (isRTL) {
                setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
                setPingedRight(-mergedScrollLeft > 0);
            } else {
                setPingedLeft(mergedScrollLeft > 0);
                setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
            }
        }
    });
    var onBodyScroll = (0, $ktS49.default)(function(e) {
        onInternalScroll(e);
        onScroll === null || onScroll === void 0 || onScroll(e);
    });
    var triggerOnScroll = function triggerOnScroll() {
        if (horizonScroll && scrollBodyRef.current) {
            var _scrollBodyRef$curren4;
            onInternalScroll({
                currentTarget: (0, $cYkhj.getDOM)(scrollBodyRef.current),
                scrollLeft: (_scrollBodyRef$curren4 = scrollBodyRef.current) === null || _scrollBodyRef$curren4 === void 0 ? void 0 : _scrollBodyRef$curren4.scrollLeft
            });
        } else {
            setPingedLeft(false);
            setPingedRight(false);
        }
    };
    var onFullTableResize = function onFullTableResize(_ref3) {
        var _stickyRef$current2;
        var width = _ref3.width;
        (_stickyRef$current2 = stickyRef.current) === null || _stickyRef$current2 === void 0 || _stickyRef$current2.checkScrollBarVisible();
        var mergedWidth = fullTableRef.current ? fullTableRef.current.offsetWidth : width;
        if (useInternalHooks && getContainerWidth && fullTableRef.current) mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
        if (mergedWidth !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(mergedWidth);
        }
    };
    // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    var mounted = $jMaZ8.useRef(false);
    $jMaZ8.useEffect(function() {
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $jMaZ8.useEffect(function() {
        mounted.current = true;
    }, []);
    // ===================== Effects ======================
    var _React$useState7 = $jMaZ8.useState(0), _React$useState8 = (0, $3fkx6.default)(_React$useState7, 2), scrollbarSize = _React$useState8[0], setScrollbarSize = _React$useState8[1];
    var _React$useState9 = $jMaZ8.useState(true), _React$useState10 = (0, $3fkx6.default)(_React$useState9, 2), supportSticky = _React$useState10[0], setSupportSticky = _React$useState10[1]; // Only IE not support, we mark as support first
    $jMaZ8.useEffect(function() {
        if (!tailor || !useInternalHooks) {
            if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $fb3b2752ae6984c6$export$4f3ef2310365b56a)(scrollBodyRef.current).width);
            else setScrollbarSize((0, $fb3b2752ae6984c6$export$4f3ef2310365b56a)(scrollBodyContainerRef.current).width);
        }
        setSupportSticky((0, $cf512cb263ad7ac0$export$d616d7831008e86c)('position', 'sticky'));
    }, []);
    // ================== INTERNAL HOOKS ==================
    $jMaZ8.useEffect(function() {
        if (useInternalHooks && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    });
    // ========================================================================
    // ==                               Render                               ==
    // ========================================================================
    // =================== Render: Func ===================
    var renderFixedHeaderTable = $jMaZ8.useCallback(function(fixedHolderPassProps) {
        return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement((0, $b919760ed76ef7ae$export$2e2bcd8739ae039), fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/ $jMaZ8.createElement((0, $b404adcf0f7cd921$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode));
    }, [
        fixFooter,
        summaryNode
    ]);
    var renderFixedFooterTable = $jMaZ8.useCallback(function(fixedHolderPassProps) {
        return /*#__PURE__*/ $jMaZ8.createElement((0, $b404adcf0f7cd921$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode);
    }, [
        summaryNode
    ]);
    // =================== Render: Node ===================
    var TableComponent = getComponent([
        'table'
    ], 'table');
    // Table layout
    var mergedTableLayout = $jMaZ8.useMemo(function() {
        if (tableLayout) return tableLayout;
        // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return mergedScrollX === 'max-content' ? 'auto' : 'fixed';
        if (fixHeader || isSticky || flattenColumns.some(function(_ref4) {
            var ellipsis = _ref4.ellipsis;
            return ellipsis;
        })) return 'fixed';
        return 'auto';
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    var groupTableNode;
    // Header props
    var headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    };
    // Empty
    var emptyNode = $jMaZ8.useMemo(function() {
        if (hasData) return null;
        if (typeof emptyText === 'function') return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]);
    // Body
    var bodyTable = /*#__PURE__*/ $jMaZ8.createElement((0, $ee467adcea733087$export$2e2bcd8739ae039), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky
    });
    var bodyColGroup = /*#__PURE__*/ $jMaZ8.createElement((0, $4a8127c32b4901f5$export$2e2bcd8739ae039), {
        colWidths: flattenColumns.map(function(_ref5) {
            var width = _ref5.width;
            return width;
        }),
        columns: flattenColumns
    });
    var captionElement = caption !== null && caption !== undefined ? /*#__PURE__*/ $jMaZ8.createElement("caption", {
        className: "".concat(prefixCls, "-caption")
    }, caption) : undefined;
    var dataProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
        data: true
    });
    var ariaProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
        aria: true
    });
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        var bodyContent;
        if (typeof customizeScrollBody === 'function') {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onInternalScroll
            });
            headerProps.colWidths = flattenColumns.map(function(_ref6, index) {
                var width = _ref6.width;
                var colWidth = index === flattenColumns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) return colWidth;
                (0, $2bFmQ.default)(props.columns.length === 0, 'When use `components.body` with render props. Each column should have a fixed `width` value.');
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $jMaZ8.createElement("div", {
            style: (0, $8u3qN.default)((0, $8u3qN.default)({}, scrollXStyle), scrollYStyle),
            onScroll: onBodyScroll,
            ref: scrollBodyRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-body"))
        }, /*#__PURE__*/ $jMaZ8.createElement(TableComponent, (0, $hH60s.default)({
            style: (0, $8u3qN.default)((0, $8u3qN.default)({}, scrollTableStyle), {}, {
                tableLayout: mergedTableLayout
            })
        }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $jMaZ8.createElement((0, $b404adcf0f7cd921$export$2e2bcd8739ae039), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
        // Fixed holder share the props
        var fixedHolderProps = (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && mergedScrollX === 'max-content'
        }, headerProps), columnContext), {}, {
            direction: direction,
            stickyClassName: stickyClassName,
            onScroll: onInternalScroll
        });
        groupTableNode = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, showHeader !== false && /*#__PURE__*/ $jMaZ8.createElement((0, $f38b02fb595b4071$export$2e2bcd8739ae039), (0, $hH60s.default)({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: "".concat(prefixCls, "-header"),
            ref: scrollHeaderRef
        }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/ $jMaZ8.createElement((0, $f38b02fb595b4071$export$2e2bcd8739ae039), (0, $hH60s.default)({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: "".concat(prefixCls, "-summary"),
            ref: scrollSummaryRef
        }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /*#__PURE__*/ $jMaZ8.createElement((0, $59011ce6b0c75ca8$export$2e2bcd8739ae039), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onInternalScroll,
            container: container,
            direction: direction
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, scrollXStyle), scrollYStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content")),
        onScroll: onInternalScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $jMaZ8.createElement(TableComponent, (0, $hH60s.default)({
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, scrollTableStyle), {}, {
            tableLayout: mergedTableLayout
        })
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /*#__PURE__*/ $jMaZ8.createElement((0, $b919760ed76ef7ae$export$2e2bcd8739ae039), (0, $hH60s.default)({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $jMaZ8.createElement((0, $b404adcf0f7cd921$export$2e2bcd8739ae039), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    var fullTable = /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-ping-left"), pingedLeft), "".concat(prefixCls, "-ping-right"), pingedRight), "".concat(prefixCls, "-layout-fixed"), tableLayout === 'fixed'), "".concat(prefixCls, "-fixed-header"), fixHeader), "".concat(prefixCls, "-fixed-column"), fixColumn), "".concat(prefixCls, "-fixed-column-gapped"), fixColumn && hasGapFixed), "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === 'right')),
        style: style,
        id: id,
        ref: fullTableRef
    }, dataProps), title && /*#__PURE__*/ $jMaZ8.createElement((0, $70fb68edd7d7c576$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-title")
    }, title(mergedData)), /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: scrollBodyContainerRef,
        className: "".concat(prefixCls, "-container")
    }, groupTableNode), footer && /*#__PURE__*/ $jMaZ8.createElement((0, $70fb68edd7d7c576$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-footer")
    }, footer(mergedData)));
    if (horizonScroll) fullTable = /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onFullTableResize
    }, fullTable);
    var fixedInfoList = (0, $3d7dc2dcd575dcaa$export$2e2bcd8739ae039)(flattenColumns, stickyOffsets, direction);
    var TableContextValue = $jMaZ8.useMemo(function() {
        return {
            // Scroll
            scrollX: mergedScrollX,
            // Table
            prefixCls: prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: fixedInfoList,
            isSticky: isSticky,
            supportSticky: supportSticky,
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll,
            // Body
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandableConfig.expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandableConfig.expandRowByClick,
            expandedRowRender: expandableConfig.expandedRowRender,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
            indentSize: expandableConfig.indentSize,
            allColumnsFixedLeft: flattenColumns.every(function(col) {
                return col.fixed === 'left';
            }),
            emptyNode: emptyNode,
            // Column
            columns: columns,
            flattenColumns: flattenColumns,
            onColumnResize: onColumnResize,
            // Row
            hoverStartRow: startRow,
            hoverEndRow: endRow,
            onHover: onHover,
            rowExpandable: expandableConfig.rowExpandable,
            onRow: onRow,
            getRowKey: getRowKey,
            expandedKeys: mergedExpandedKeys,
            childrenColumnName: mergedChildrenColumnName,
            rowHoverable: rowHoverable
        };
    }, [
        // Scroll
        mergedScrollX,
        // Table
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        fixedInfoList,
        isSticky,
        supportSticky,
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll,
        // Body
        mergedTableLayout,
        rowClassName,
        expandableConfig.expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandableConfig.expandRowByClick,
        expandableConfig.expandedRowRender,
        onTriggerExpand,
        expandableConfig.expandIconColumnIndex,
        expandableConfig.indentSize,
        emptyNode,
        // Column
        columns,
        flattenColumns,
        onColumnResize,
        // Row
        startRow,
        endRow,
        onHover,
        expandableConfig.rowExpandable,
        onRow,
        getRowKey,
        mergedExpandedKeys,
        mergedChildrenColumnName,
        rowHoverable
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $7be8aaea61012844$export$2e2bcd8739ae039).Provider, {
        value: TableContextValue
    }, fullTable);
}
var $d3fe3c728f980334$var$RefTable = /*#__PURE__*/ $jMaZ8.forwardRef($d3fe3c728f980334$var$Table);
$d3fe3c728f980334$var$RefTable.displayName = 'Table';
function $d3fe3c728f980334$export$13da147d1fdf3e3c(shouldTriggerRender) {
    return (0, $7be8aaea61012844$export$ffd6d5bef5eaf0a4)($d3fe3c728f980334$var$RefTable, shouldTriggerRender);
}
var $d3fe3c728f980334$var$ImmutableTable = $d3fe3c728f980334$export$13da147d1fdf3e3c();
$d3fe3c728f980334$var$ImmutableTable.EXPAND_COLUMN = (0, $f40867b2b1b9b23f$export$e1053575ddfcb301);
$d3fe3c728f980334$var$ImmutableTable.INTERNAL_HOOKS = (0, $f40867b2b1b9b23f$export$91b75cf262680225);
$d3fe3c728f980334$var$ImmutableTable.Column = (0, $5d243ad92d713269$export$2e2bcd8739ae039);
$d3fe3c728f980334$var$ImmutableTable.ColumnGroup = (0, $60fa2d40c0304f54$export$2e2bcd8739ae039);
$d3fe3c728f980334$var$ImmutableTable.Summary = (0, $b404adcf0f7cd921$export$d605f3af09eef683);
var $d3fe3c728f980334$export$2e2bcd8739ae039 = $d3fe3c728f980334$var$ImmutableTable;




var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $giSak = parcelRequire("giSak");
parcelRequire("1CVs1");
var $ktS49 = parcelRequire("ktS49");
var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");




var $1Esi2 = parcelRequire("1Esi2");

var $3fkx6 = parcelRequire("3fkx6");



var $jMaZ8 = parcelRequire("jMaZ8");



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $4b02Q = parcelRequire("4b02Q");


var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");




var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");


var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");



var $b7cdef6a298ce493$export$fbb76fda59aa02a2 = (0, $f46c9e4dbdabd86b$export$fd42f52fd3ae1109)(null);
var $b7cdef6a298ce493$export$11cae3e04ab99fae = (0, $f46c9e4dbdabd86b$export$fd42f52fd3ae1109)(null);


function $47f0aa5a9326daec$export$dfa11a34ceba822(colIndex, colSpan, columnsOffset) {
    var mergedColSpan = colSpan || 1;
    return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
function $47f0aa5a9326daec$var$VirtualCell(props) {
    var rowInfo = props.rowInfo, column = props.column, colIndex = props.colIndex, indent = props.indent, index = props.index, component = props.component, renderIndex = props.renderIndex, record = props.record, style = props.style, className = props.className, inverse = props.inverse, getHeight = props.getHeight;
    var render = column.render, dataIndex = column.dataIndex, columnClassName = column.className, colWidth = column.width;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $b7cdef6a298ce493$export$11cae3e04ab99fae), [
        'columnsOffset'
    ]), columnsOffset = _useContext.columnsOffset;
    var _getCellProps = (0, $8965a7fd6345477e$export$16400ac709c56616)(rowInfo, column, colIndex, indent, index), key = _getCellProps.key, fixedInfo = _getCellProps.fixedInfo, appendCellNode = _getCellProps.appendCellNode, additionalCellProps = _getCellProps.additionalCellProps;
    var cellStyle = additionalCellProps.style, _additionalCellProps$ = additionalCellProps.colSpan, colSpan = _additionalCellProps$ === void 0 ? 1 : _additionalCellProps$, _additionalCellProps$2 = additionalCellProps.rowSpan, rowSpan = _additionalCellProps$2 === void 0 ? 1 : _additionalCellProps$2;
    // ========================= ColWidth =========================
    // column width
    var startColIndex = colIndex - 1;
    var concatColWidth = $47f0aa5a9326daec$export$dfa11a34ceba822(startColIndex, colSpan, columnsOffset);
    // margin offset
    var marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;
    // ========================== Style ===========================
    var mergedStyle = (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, cellStyle), style), {}, {
        flex: "0 0 ".concat(concatColWidth, "px"),
        width: "".concat(concatColWidth, "px"),
        marginRight: marginOffset,
        pointerEvents: 'auto'
    });
    // When `colSpan` or `rowSpan` is `0`, should skip render.
    var needHide = $jMaZ8.useMemo(function() {
        if (inverse) return rowSpan <= 1;
        else return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }, [
        rowSpan,
        colSpan,
        inverse
    ]);
    // 0 rowSpan or colSpan should not render
    if (needHide) mergedStyle.visibility = 'hidden';
    else if (inverse) mergedStyle.height = getHeight === null || getHeight === void 0 ? void 0 : getHeight(rowSpan);
    var mergedRender = needHide ? function() {
        return null;
    } : render;
    // ========================== Render ==========================
    var cellSpan = {};
    // Virtual should reset `colSpan` & `rowSpan`
    if (rowSpan === 0 || colSpan === 0) {
        cellSpan.rowSpan = 1;
        cellSpan.colSpan = 1;
    }
    return /*#__PURE__*/ $jMaZ8.createElement((0, $a05b829b7a938bc2$export$2e2bcd8739ae039), (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(columnClassName, className),
        ellipsis: column.ellipsis,
        align: column.align,
        scope: column.rowScope,
        component: component,
        prefixCls: rowInfo.prefixCls,
        key: key,
        record: record,
        index: index,
        renderIndex: renderIndex,
        dataIndex: dataIndex,
        render: mergedRender,
        shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
        appendNode: appendCellNode,
        additionalProps: (0, $8u3qN.default)((0, $8u3qN.default)({}, additionalCellProps), {}, {
            style: mergedStyle
        }, cellSpan)
    }));
}
var $47f0aa5a9326daec$export$2e2bcd8739ae039 = $47f0aa5a9326daec$var$VirtualCell;




var $10712ae5bcae975f$var$_excluded = [
    "data",
    "index",
    "className",
    "rowKey",
    "style",
    "extra",
    "getHeight"
];
var $10712ae5bcae975f$var$BodyLine = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var data = props.data, index = props.index, className = props.className, rowKey = props.rowKey, style = props.style, extra = props.extra, getHeight = props.getHeight, restProps = (0, $4b02Q.default)(props, $10712ae5bcae975f$var$_excluded);
    var record = data.record, indent = data.indent, renderIndex = data.index;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'prefixCls',
        'flattenColumns',
        'fixColumn',
        'componentWidth',
        'scrollX'
    ]), scrollX = _useContext.scrollX, flattenColumns = _useContext.flattenColumns, prefixCls = _useContext.prefixCls, fixColumn = _useContext.fixColumn, componentWidth = _useContext.componentWidth;
    var _useContext2 = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $b7cdef6a298ce493$export$fbb76fda59aa02a2), [
        'getComponent'
    ]), getComponent = _useContext2.getComponent;
    var rowInfo = (0, $98fa5530be9f0f03$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    var RowComponent = getComponent([
        'body',
        'row'
    ], 'div');
    var cellComponent = getComponent([
        'body',
        'cell'
    ], 'div');
    // ========================== Expand ==========================
    var rowSupportExpand = rowInfo.rowSupportExpand, expanded = rowInfo.expanded, rowProps = rowInfo.rowProps, expandedRowRender = rowInfo.expandedRowRender, expandedRowClassName = rowInfo.expandedRowClassName;
    var expandRowNode;
    if (rowSupportExpand && expanded) {
        var expandContent = expandedRowRender(record, index, indent + 1, expanded);
        var expandedClsName = (0, $17ebede92ab776bb$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
        var additionalProps = {};
        if (fixColumn) additionalProps = {
            style: (0, $eq8kl.default)({}, '--virtual-width', "".concat(componentWidth, "px"))
        };
        var rowCellCls = "".concat(prefixCls, "-expanded-row-cell");
        expandRowNode = /*#__PURE__*/ $jMaZ8.createElement(RowComponent, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), expandedClsName)
        }, /*#__PURE__*/ $jMaZ8.createElement((0, $a05b829b7a938bc2$export$2e2bcd8739ae039), {
            component: cellComponent,
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(rowCellCls, (0, $eq8kl.default)({}, "".concat(rowCellCls, "-fixed"), fixColumn)),
            additionalProps: additionalProps
        }, expandContent));
    }
    // ========================== Render ==========================
    var rowStyle = (0, $8u3qN.default)((0, $8u3qN.default)({}, style), {}, {
        width: scrollX
    });
    if (extra) {
        rowStyle.position = 'absolute';
        rowStyle.pointerEvents = 'none';
    }
    var rowNode = /*#__PURE__*/ $jMaZ8.createElement(RowComponent, (0, $hH60s.default)({}, rowProps, restProps, {
        "data-row-key": rowKey,
        ref: rowSupportExpand ? null : ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, "".concat(prefixCls, "-row"), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, (0, $eq8kl.default)({}, "".concat(prefixCls, "-row-extra"), extra)),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, rowStyle), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
    }), flattenColumns.map(function(column, colIndex) {
        return /*#__PURE__*/ $jMaZ8.createElement((0, $47f0aa5a9326daec$export$2e2bcd8739ae039), {
            key: colIndex,
            component: cellComponent,
            rowInfo: rowInfo,
            column: column,
            colIndex: colIndex,
            indent: indent,
            index: index,
            renderIndex: renderIndex,
            record: record,
            inverse: extra,
            getHeight: getHeight
        });
    }));
    if (rowSupportExpand) return /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: ref
    }, rowNode, expandRowNode);
    return rowNode;
});
var $10712ae5bcae975f$var$ResponseBodyLine = (0, $7be8aaea61012844$export$e9e4cb9eb9e2b4c4)($10712ae5bcae975f$var$BodyLine);
$10712ae5bcae975f$var$ResponseBodyLine.displayName = 'BodyLine';
var $10712ae5bcae975f$export$2e2bcd8739ae039 = $10712ae5bcae975f$var$ResponseBodyLine;



var $fdd2030de811efd3$var$Grid = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var data = props.data, onScroll = props.onScroll;
    var _useContext = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $7be8aaea61012844$export$2e2bcd8739ae039), [
        'flattenColumns',
        'onColumnResize',
        'getRowKey',
        'prefixCls',
        'expandedKeys',
        'childrenColumnName',
        'scrollX',
        'direction'
    ]), flattenColumns = _useContext.flattenColumns, onColumnResize = _useContext.onColumnResize, getRowKey = _useContext.getRowKey, expandedKeys = _useContext.expandedKeys, prefixCls = _useContext.prefixCls, childrenColumnName = _useContext.childrenColumnName, scrollX = _useContext.scrollX, direction = _useContext.direction;
    var _useContext2 = (0, $f46c9e4dbdabd86b$export$fae74005e78b1a27)((0, $b7cdef6a298ce493$export$fbb76fda59aa02a2)), sticky = _useContext2.sticky, scrollY = _useContext2.scrollY, listItemHeight = _useContext2.listItemHeight, getComponent = _useContext2.getComponent, onTablePropScroll = _useContext2.onScroll;
    // =========================== Ref ============================
    var listRef = $jMaZ8.useRef();
    // =========================== Data ===========================
    var flattenData = (0, $8bf2575d5b9e236e$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // ========================== Column ==========================
    var columnsWidth = $jMaZ8.useMemo(function() {
        var total = 0;
        return flattenColumns.map(function(_ref) {
            var width = _ref.width, key = _ref.key;
            total += width;
            return [
                key,
                width,
                total
            ];
        });
    }, [
        flattenColumns
    ]);
    var columnsOffset = $jMaZ8.useMemo(function() {
        return columnsWidth.map(function(colWidth) {
            return colWidth[2];
        });
    }, [
        columnsWidth
    ]);
    $jMaZ8.useEffect(function() {
        columnsWidth.forEach(function(_ref2) {
            var _ref3 = (0, $3fkx6.default)(_ref2, 2), key = _ref3[0], width = _ref3[1];
            onColumnResize(key, width);
        });
    }, [
        columnsWidth
    ]);
    // =========================== Ref ============================
    $jMaZ8.useImperativeHandle(ref, function() {
        var _listRef$current2;
        var obj = {
            scrollTo: function scrollTo(config) {
                var _listRef$current;
                (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(config);
            },
            nativeElement: (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.nativeElement
        };
        Object.defineProperty(obj, 'scrollLeft', {
            get: function get() {
                var _listRef$current3;
                return ((_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 ? void 0 : _listRef$current3.getScrollInfo().x) || 0;
            },
            set: function set(value) {
                var _listRef$current4;
                (_listRef$current4 = listRef.current) === null || _listRef$current4 === void 0 || _listRef$current4.scrollTo({
                    left: value
                });
            }
        });
        return obj;
    });
    // ======================= Col/Row Span =======================
    var getRowSpan = function getRowSpan(column, index) {
        var _flattenData$index;
        var record = (_flattenData$index = flattenData[index]) === null || _flattenData$index === void 0 ? void 0 : _flattenData$index.record;
        var onCell = column.onCell;
        if (onCell) {
            var _cellProps$rowSpan;
            var cellProps = onCell(record, index);
            return (_cellProps$rowSpan = cellProps === null || cellProps === void 0 ? void 0 : cellProps.rowSpan) !== null && _cellProps$rowSpan !== void 0 ? _cellProps$rowSpan : 1;
        }
        return 1;
    };
    var extraRender = function extraRender(info) {
        var start = info.start, end = info.end, getSize = info.getSize, offsetY = info.offsetY;
        // Do nothing if no data
        if (end < 0) return null;
        // Find first rowSpan column
        var firstRowSpanColumns = flattenColumns.filter(// rowSpan is 0
        function(column) {
            return getRowSpan(column, start) === 0;
        });
        var startIndex = start;
        var _loop = function _loop(i) {
            firstRowSpanColumns = firstRowSpanColumns.filter(function(column) {
                return getRowSpan(column, i) === 0;
            });
            if (!firstRowSpanColumns.length) {
                startIndex = i;
                return 1; // break
            }
        };
        for(var i = start; i >= 0; i -= 1){
            if (_loop(i)) break;
        }
        // Find last rowSpan column
        var lastRowSpanColumns = flattenColumns.filter(// rowSpan is not 1
        function(column) {
            return getRowSpan(column, end) !== 1;
        });
        var endIndex = end;
        var _loop2 = function _loop2(_i) {
            lastRowSpanColumns = lastRowSpanColumns.filter(function(column) {
                return getRowSpan(column, _i) !== 1;
            });
            if (!lastRowSpanColumns.length) {
                endIndex = Math.max(_i - 1, end);
                return 1; // break
            }
        };
        for(var _i = end; _i < flattenData.length; _i += 1){
            if (_loop2(_i)) break;
        }
        // Collect the line who has rowSpan
        var spanLines = [];
        var _loop3 = function _loop3(_i2) {
            var item = flattenData[_i2];
            // This code will never reach, just incase
            if (!item) return 1; // continue
            if (flattenColumns.some(function(column) {
                return getRowSpan(column, _i2) > 1;
            })) spanLines.push(_i2);
        };
        for(var _i2 = startIndex; _i2 <= endIndex; _i2 += 1){
            if (_loop3(_i2)) continue;
        }
        // Patch extra line on the page
        var nodes = spanLines.map(function(index) {
            var item = flattenData[index];
            var rowKey = getRowKey(item.record, index);
            var getHeight = function getHeight(rowSpan) {
                var endItemIndex = index + rowSpan - 1;
                var endItemKey = getRowKey(flattenData[endItemIndex].record, endItemIndex);
                var sizeInfo = getSize(rowKey, endItemKey);
                return sizeInfo.bottom - sizeInfo.top;
            };
            var sizeInfo = getSize(rowKey);
            return /*#__PURE__*/ $jMaZ8.createElement((0, $10712ae5bcae975f$export$2e2bcd8739ae039), {
                key: index,
                data: item,
                rowKey: rowKey,
                index: index,
                style: {
                    top: -offsetY + sizeInfo.top
                },
                extra: true,
                getHeight: getHeight
            });
        });
        return nodes;
    };
    // ========================= Context ==========================
    var gridContext = $jMaZ8.useMemo(function() {
        return {
            columnsOffset: columnsOffset
        };
    }, [
        columnsOffset
    ]);
    // ========================== Render ==========================
    var tblPrefixCls = "".concat(prefixCls, "-tbody");
    // default 'div' in rc-virtual-list
    var wrapperComponent = getComponent([
        'body',
        'wrapper'
    ]);
    // ========================== Sticky Scroll Bar ==========================
    var horizontalScrollBarStyle = {};
    if (sticky) {
        horizontalScrollBarStyle.position = 'sticky';
        horizontalScrollBarStyle.bottom = 0;
        if ((0, $1Esi2.default)(sticky) === 'object' && sticky.offsetScroll) horizontalScrollBarStyle.bottom = sticky.offsetScroll;
    }
    return /*#__PURE__*/ $jMaZ8.createElement((0, $b7cdef6a298ce493$export$11cae3e04ab99fae).Provider, {
        value: gridContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $d69541228a77891f$export$2e2bcd8739ae039), {
        fullHeight: false,
        ref: listRef,
        prefixCls: "".concat(tblPrefixCls, "-virtual"),
        styles: {
            horizontalScrollBar: horizontalScrollBarStyle
        },
        className: tblPrefixCls,
        height: scrollY,
        itemHeight: listItemHeight || 24,
        data: flattenData,
        itemKey: function itemKey(item) {
            return getRowKey(item.record);
        },
        component: wrapperComponent,
        scrollWidth: scrollX,
        direction: direction,
        onVirtualScroll: function onVirtualScroll(_ref4) {
            var _listRef$current5;
            var x = _ref4.x;
            onScroll({
                currentTarget: (_listRef$current5 = listRef.current) === null || _listRef$current5 === void 0 ? void 0 : _listRef$current5.nativeElement,
                scrollLeft: x
            });
        },
        onScroll: onTablePropScroll,
        extraRender: extraRender
    }, function(item, index, itemProps) {
        var rowKey = getRowKey(item.record, index);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $10712ae5bcae975f$export$2e2bcd8739ae039), {
            data: item,
            rowKey: rowKey,
            index: index,
            style: itemProps.style
        });
    }));
});
var $fdd2030de811efd3$var$ResponseGrid = (0, $7be8aaea61012844$export$e9e4cb9eb9e2b4c4)($fdd2030de811efd3$var$Grid);
$fdd2030de811efd3$var$ResponseGrid.displayName = 'ResponseGrid';
var $fdd2030de811efd3$export$2e2bcd8739ae039 = $fdd2030de811efd3$var$ResponseGrid;




var $k19OO = parcelRequire("k19OO");
var $40609771d67f0e26$var$renderBody = function renderBody(rawData, props) {
    var ref = props.ref, onScroll = props.onScroll;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $fdd2030de811efd3$export$2e2bcd8739ae039), {
        ref: ref,
        data: rawData,
        onScroll: onScroll
    });
};
function $40609771d67f0e26$var$VirtualTable(props, ref) {
    var data = props.data, columns = props.columns, scroll = props.scroll, sticky = props.sticky, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? (0, $d3fe3c728f980334$export$c42ed95a478b1ec5) : _props$prefixCls, className = props.className, listItemHeight = props.listItemHeight, components = props.components, onScroll = props.onScroll;
    var _ref = scroll || {}, scrollX = _ref.x, scrollY = _ref.y;
    // Fill scrollX
    if (typeof scrollX !== 'number') {
        (0, $2bFmQ.default)(!scrollX, '`scroll.x` in virtual table must be number.');
        scrollX = 1;
    }
    // Fill scrollY
    if (typeof scrollY !== 'number') {
        scrollY = 500;
        (0, $2bFmQ.default)(false, '`scroll.y` in virtual table must be number.');
    }
    var getComponent = (0, $ktS49.default)(function(path, defaultComponent) {
        return (0, $k19OO.default)(components, path) || defaultComponent;
    });
    // Memo this
    var onInternalScroll = (0, $ktS49.default)(onScroll);
    // ========================= Context ==========================
    var context = $jMaZ8.useMemo(function() {
        return {
            sticky: sticky,
            scrollY: scrollY,
            listItemHeight: listItemHeight,
            getComponent: getComponent,
            onScroll: onInternalScroll
        };
    }, [
        sticky,
        scrollY,
        listItemHeight,
        getComponent,
        onInternalScroll
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $b7cdef6a298ce493$export$fbb76fda59aa02a2).Provider, {
        value: context
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $d3fe3c728f980334$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, "".concat(prefixCls, "-virtual")),
        scroll: (0, $8u3qN.default)((0, $8u3qN.default)({}, scroll), {}, {
            x: scrollX
        }),
        components: (0, $8u3qN.default)((0, $8u3qN.default)({}, components), {}, {
            // fix https://github.com/ant-design/ant-design/issues/48991
            body: data !== null && data !== void 0 && data.length ? $40609771d67f0e26$var$renderBody : undefined
        }),
        columns: columns,
        internalHooks: (0, $f40867b2b1b9b23f$export$91b75cf262680225),
        tailor: true,
        ref: ref
    })));
}
var $40609771d67f0e26$var$RefVirtualTable = /*#__PURE__*/ $jMaZ8.forwardRef($40609771d67f0e26$var$VirtualTable);
$40609771d67f0e26$var$RefVirtualTable.displayName = 'VirtualTable';
function $40609771d67f0e26$export$4747b79b36862360(shouldTriggerRender) {
    return (0, $7be8aaea61012844$export$ffd6d5bef5eaf0a4)($40609771d67f0e26$var$RefVirtualTable, shouldTriggerRender);
}
var $40609771d67f0e26$export$2e2bcd8739ae039 = $40609771d67f0e26$export$4747b79b36862360();


var $1c9c7e9f800d0f98$export$2e2bcd8739ae039 = (0, $d3fe3c728f980334$export$2e2bcd8739ae039);


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $69ba96c61af3bb29$var$Column = (_)=>null;
var $69ba96c61af3bb29$export$2e2bcd8739ae039 = $69ba96c61af3bb29$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $c9d3c072e2604d00$var$ColumnGroup = (_)=>null;
var $c9d3c072e2604d00$export$2e2bcd8739ae039 = $c9d3c072e2604d00$var$ColumnGroup;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");


var $fvBso = parcelRequire("fvBso");

var $1Esi2 = parcelRequire("1Esi2");

var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ 
var $jMaZ8 = parcelRequire("jMaZ8");
var $ac33c98905104d8a$export$dfae7d399eea2568 = /*#__PURE__*/ $jMaZ8.createContext(null);
var $ac33c98905104d8a$export$e508d6f1a100e5dd = /*#__PURE__*/ $jMaZ8.createContext({});



var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $bc3f9304b6434c0f$var$Indent = function Indent(_ref) {
    var prefixCls = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
    var baseClassName = "".concat(prefixCls, "-indent-unit");
    var list = [];
    for(var i = 0; i < level; i += 1)list.push(/*#__PURE__*/ $jMaZ8.createElement("span", {
        key: i,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(baseClassName, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(baseClassName, "-start"), isStart[i]), "".concat(baseClassName, "-end"), isEnd[i]))
    }));
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-indent")
    }, list);
};
var $bc3f9304b6434c0f$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.memo($bc3f9304b6434c0f$var$Indent);


function $0f4e6a50c0fa4e30$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}



var $1Esi2 = parcelRequire("1Esi2");

var $fvBso = parcelRequire("fvBso");

var $8u3qN = parcelRequire("8u3qN");

var $4b02Q = parcelRequire("4b02Q");

var $a6yuN = parcelRequire("a6yuN");

var $hvG6u = parcelRequire("hvG6u");

var $2bFmQ = parcelRequire("2bFmQ");

var $a2876523b8e415d4$var$_excluded = [
    "children"
];
function $a2876523b8e415d4$export$1690e12b840569b9(level, index) {
    return "".concat(level, "-").concat(index);
}
function $a2876523b8e415d4$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $a2876523b8e415d4$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $a2876523b8e415d4$export$6c519d302dced239(fieldNames) {
    var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key = _ref.key, children = _ref.children;
    var mergedTitle = title || 'title';
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || 'key',
        children: children || 'children'
    };
}
function $a2876523b8e415d4$export$702780ec64d148df(treeData, fieldNames) {
    var keys = new Map();
    function dig(list) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        (list || []).forEach(function(treeNode) {
            var key = treeNode[fieldNames.key];
            var children = treeNode[fieldNames.children];
            (0, $2bFmQ.default)(key !== null && key !== undefined, "Tree node must have a certain key: [".concat(path).concat(key, "]"));
            var recordKey = String(key);
            (0, $2bFmQ.default)(!keys.has(recordKey) || key === null || key === undefined, "Same 'key' exist in the Tree: ".concat(recordKey));
            keys.set(recordKey, true);
            dig(children, "".concat(path).concat(recordKey, " > "));
        });
    }
    dig(treeData);
}
function $a2876523b8e415d4$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        var treeNodes = (0, $a6yuN.default)(node);
        return treeNodes.map(function(treeNode) {
            // Filter invalidate node
            if (!$a2876523b8e415d4$export$1c189858aa1437d7(treeNode)) {
                (0, $2bFmQ.default)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
                return null;
            }
            var key = treeNode.key;
            var _treeNode$props = treeNode.props, children = _treeNode$props.children, rest = (0, $4b02Q.default)(_treeNode$props, $a2876523b8e415d4$var$_excluded);
            var dataNode = (0, $8u3qN.default)({
                key: key
            }, rest);
            var parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter(function(dataNode) {
            return dataNode;
        });
    }
    return dig(rootNodes);
}
function $a2876523b8e415d4$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    var _fillFieldNames = $a2876523b8e415d4$export$6c519d302dced239(fieldNames), fieldTitles = _fillFieldNames._title, fieldKey = _fillFieldNames.key, fieldChildren = _fillFieldNames.children;
    var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    var flattenList = [];
    function dig(list) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return list.map(function(treeNode, index) {
            var pos = $a2876523b8e415d4$export$1690e12b840569b9(parent ? parent.pos : '0', index);
            var mergedKey = $a2876523b8e415d4$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            var mergedTitle;
            for(var i = 0; i < fieldTitles.length; i += 1){
                var fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            // We use `Object.assign` here to save perf since babel's `objectSpread` has perf issue
            var flattenNode = Object.assign((0, $hvG6u.default)(treeNode, [].concat((0, $fvBso.default)(fieldTitles), [
                fieldKey,
                fieldChildren
            ])), {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [].concat((0, $fvBso.default)(parent ? parent.isStart : []), [
                    index === 0
                ]),
                isEnd: [].concat((0, $fvBso.default)(parent ? parent.isEnd : []), [
                    index === list.length - 1
                ])
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $a2876523b8e415d4$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    var mergedConfig = {};
    if ((0, $1Esi2.default)(config) === 'object') mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
    var _fillFieldNames2 = $a2876523b8e415d4$export$6c519d302dced239(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
    var mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    var syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === 'string') syntheticGetKey = function syntheticGetKey(node) {
            return node[externalGetKey];
        };
        else if (typeof externalGetKey === 'function') syntheticGetKey = function syntheticGetKey(node) {
            return externalGetKey(node);
        };
    } else syntheticGetKey = function syntheticGetKey(node, pos) {
        return $a2876523b8e415d4$export$a47fb462a08de82f(node[fieldKey], pos);
    };
    // Process
    function processNode(node, index, parent, pathNodes) {
        var children = node ? node[mergeChildrenPropName] : dataNodes;
        var pos = node ? $a2876523b8e415d4$export$1690e12b840569b9(parent.pos, index) : '0';
        var connectNodes = node ? [].concat((0, $fvBso.default)(pathNodes), [
            node
        ]) : [];
        // Process node if is not root
        if (node) {
            var key = syntheticGetKey(node, pos);
            var _data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(_data);
        }
        // Process children node
        if (children) children.forEach(function(subNode, subIndex) {
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $a2876523b8e415d4$export$e5d831ce033a4615(dataNodes) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
    var /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey = arguments.length > 2 ? arguments[2] : undefined;
    // Init config
    var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    var posEntities = {};
    var keyEntities = {};
    var wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $a2876523b8e415d4$export$4b2e27469b557f9d(dataNodes, function(item) {
        var node = item.node, index = item.index, pos = item.pos, key = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
        var entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        var mergedKey = $a2876523b8e415d4$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $a2876523b8e415d4$export$d961fd523a514db5(key, _ref3) {
    var expandedKeys = _ref3.expandedKeys, selectedKeys = _ref3.selectedKeys, loadedKeys = _ref3.loadedKeys, loadingKeys = _ref3.loadingKeys, checkedKeys = _ref3.checkedKeys, halfCheckedKeys = _ref3.halfCheckedKeys, dragOverNodeKey = _ref3.dragOverNodeKey, dropPosition = _ref3.dropPosition, keyEntities = _ref3.keyEntities;
    var entity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, key);
    var treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ''),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $a2876523b8e415d4$export$7bd1b0fd4a8b540b(props) {
    var data = props.data, expanded = props.expanded, selected = props.selected, checked = props.checked, loaded = props.loaded, loading = props.loading, halfChecked = props.halfChecked, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, pos = props.pos, active = props.active, eventKey = props.eventKey;
    var eventData = (0, $8u3qN.default)((0, $8u3qN.default)({}, data), {}, {
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    });
    if (!('props' in eventData)) Object.defineProperty(eventData, 'props', {
        get: function get() {
            (0, $2bFmQ.default)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
            return props;
        }
    });
    return eventData;
}


var $422a8a4f6c7c8b88$var$_excluded = [
    "eventKey",
    "className",
    "style",
    "dragOver",
    "dragOverGapTop",
    "dragOverGapBottom",
    "isLeaf",
    "isStart",
    "isEnd",
    "expanded",
    "selected",
    "checked",
    "halfChecked",
    "loading",
    "domRef",
    "active",
    "data",
    "onMouseMove",
    "selectable"
];
var $422a8a4f6c7c8b88$var$ICON_OPEN = 'open';
var $422a8a4f6c7c8b88$var$ICON_CLOSE = 'close';
var $422a8a4f6c7c8b88$var$defaultTitle = '---';
var $422a8a4f6c7c8b88$var$TreeNode = function TreeNode(props) {
    var _context$filterTreeNo, _classNames4;
    var eventKey = props.eventKey, className = props.className, style = props.style, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, isLeaf = props.isLeaf, isStart = props.isStart, isEnd = props.isEnd, expanded = props.expanded, selected = props.selected, checked = props.checked, halfChecked = props.halfChecked, loading = props.loading, domRef = props.domRef, active = props.active, data = props.data, onMouseMove = props.onMouseMove, selectable = props.selectable, otherProps = (0, $4b02Q.default)(props, $422a8a4f6c7c8b88$var$_excluded);
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $ac33c98905104d8a$export$dfae7d399eea2568));
    var unstableContext = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $ac33c98905104d8a$export$e508d6f1a100e5dd));
    var selectHandleRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(null);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), dragNodeHighlight = _React$useState2[0], setDragNodeHighlight = _React$useState2[1];
    // ======= State: Disabled State =======
    var isDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        var _unstableContext$node;
        return !!(context.disabled || props.disabled || (_unstableContext$node = unstableContext.nodeDisabled) !== null && _unstableContext$node !== void 0 && _unstableContext$node.call(unstableContext, data));
    }, [
        context.disabled,
        props.disabled,
        unstableContext.nodeDisabled,
        data
    ]);
    var isCheckable = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        // Return false if tree or treeNode is not checkable
        if (!context.checkable || props.checkable === false) return false;
        return context.checkable;
    }, [
        context.checkable,
        props.checkable
    ]);
    // ======= Event Handlers: Selection and Check =======
    var onSelect = function onSelect(e) {
        if (isDisabled) return;
        context.onNodeSelect(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
    };
    var onCheck = function onCheck(e) {
        if (isDisabled) return;
        if (!isCheckable || props.disableCheckbox) return;
        context.onNodeCheck(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props), !checked);
    };
    // ======= State: Selectable Check =======
    var isSelectable = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        // Ignore when selectable is undefined or null
        if (typeof selectable === 'boolean') return selectable;
        return context.selectable;
    }, [
        selectable,
        context.selectable
    ]);
    var onSelectorClick = function onSelectorClick(e) {
        // Click trigger before select/check operation
        context.onNodeClick(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
        if (isSelectable) onSelect(e);
        else onCheck(e);
    };
    var onSelectorDoubleClick = function onSelectorDoubleClick(e) {
        context.onNodeDoubleClick(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
    };
    var onMouseEnter = function onMouseEnter(e) {
        context.onNodeMouseEnter(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
    };
    var onMouseLeave = function onMouseLeave(e) {
        context.onNodeMouseLeave(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
    };
    var onContextMenu = function onContextMenu(e) {
        context.onNodeContextMenu(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= Drag: Drag Enabled =======
    var isDraggable = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        return !!(context.draggable && (!context.draggable.nodeDraggable || context.draggable.nodeDraggable(data)));
    }, [
        context.draggable,
        data
    ]);
    // ======= Drag: Drag Event Handlers =======
    var onDragStart = function onDragStart(e) {
        e.stopPropagation();
        setDragNodeHighlight(true);
        context.onNodeDragStart(e, props);
        try {
            // ie throw error
            // firefox-need-it
            e.dataTransfer.setData('text/plain', '');
        } catch (_unused) {
        // empty
        }
    };
    var onDragEnter = function onDragEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragEnter(e, props);
    };
    var onDragOver = function onDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragOver(e, props);
    };
    var onDragLeave = function onDragLeave(e) {
        e.stopPropagation();
        context.onNodeDragLeave(e, props);
    };
    var onDragEnd = function onDragEnd(e) {
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDragEnd(e, props);
    };
    var onDrop = function onDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDrop(e, props);
    };
    // ======= Expand: Node Expansion =======
    var onExpand = function onExpand(e) {
        if (loading) return;
        context.onNodeExpand(e, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= State: Has Children =======
    var hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        var _ref = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {}, children = _ref.children;
        return Boolean((children || []).length);
    }, [
        context.keyEntities,
        eventKey
    ]);
    // ======= State: Leaf Check =======
    var memoizedIsLeaf = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        if (isLeaf === false) return false;
        return isLeaf || !context.loadData && !hasChildren || context.loadData && props.loaded && !hasChildren;
    }, [
        isLeaf,
        context.loadData,
        hasChildren,
        props.loaded
    ]);
    // ============== Effect ==============
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(function() {
        // Load data to avoid default expanded tree without data
        if (loading) return;
        // read from state to avoid loadData at same time
        if (typeof context.loadData === 'function' && expanded && !memoizedIsLeaf && !props.loaded) // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        context.onNodeLoad((0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props));
    }, [
        loading,
        context.loadData,
        context.onNodeLoad,
        expanded,
        memoizedIsLeaf,
        props
    ]);
    // ==================== Render: Drag Handler ====================
    var dragHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        var _context$draggable;
        if (!((_context$draggable = context.draggable) !== null && _context$draggable !== void 0 && _context$draggable.icon)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: "".concat(context.prefixCls, "-draggable-icon")
        }, context.draggable.icon);
    }, [
        context.draggable
    ]);
    // ====================== Render: Switcher ======================
    var renderSwitcherIconDom = function renderSwitcherIconDom(isInternalLeaf) {
        var switcherIcon = props.switcherIcon || context.switcherIcon;
        // if switcherIconDom is null, no render switcher span
        if (typeof switcherIcon === 'function') return switcherIcon((0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
            isLeaf: isInternalLeaf
        }));
        return switcherIcon;
    };
    // Switcher
    var renderSwitcher = function renderSwitcher() {
        if (memoizedIsLeaf) {
            // if switcherIconDom is null, no render switcher span
            var _switcherIconDom = renderSwitcherIconDom(true);
            return _switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(context.prefixCls, "-switcher"), "".concat(context.prefixCls, "-switcher-noop"))
            }, _switcherIconDom) : null;
        }
        var switcherIconDom = renderSwitcherIconDom(false);
        return switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            onClick: onExpand,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(context.prefixCls, "-switcher"), "".concat(context.prefixCls, "-switcher_").concat(expanded ? $422a8a4f6c7c8b88$var$ICON_OPEN : $422a8a4f6c7c8b88$var$ICON_CLOSE))
        }, switcherIconDom) : null;
    };
    // ====================== Checkbox ======================
    var checkboxNode = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        if (!isCheckable) return null;
        // [Legacy] Custom element should be separate with `checkable` in future
        var $custom = typeof isCheckable !== 'boolean' ? isCheckable : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(context.prefixCls, "-checkbox"), (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(context.prefixCls, "-checkbox-checked"), checked), "".concat(context.prefixCls, "-checkbox-indeterminate"), !checked && halfChecked), "".concat(context.prefixCls, "-checkbox-disabled"), isDisabled || props.disableCheckbox)),
            onClick: onCheck,
            role: "checkbox",
            "aria-checked": halfChecked ? 'mixed' : checked,
            "aria-disabled": isDisabled || props.disableCheckbox,
            "aria-label": "Select ".concat(typeof props.title === 'string' ? props.title : 'tree node')
        }, $custom);
    }, [
        isCheckable,
        checked,
        halfChecked,
        isDisabled,
        props.disableCheckbox,
        props.title
    ]);
    // ============== State: Node State (Open/Close) ==============
    var nodeState = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        if (memoizedIsLeaf) return null;
        return expanded ? $422a8a4f6c7c8b88$var$ICON_OPEN : $422a8a4f6c7c8b88$var$ICON_CLOSE;
    }, [
        memoizedIsLeaf,
        expanded
    ]);
    // ==================== Render: Title + Icon ====================
    var iconNode = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(context.prefixCls, "-iconEle"), "".concat(context.prefixCls, "-icon__").concat(nodeState || 'docu'), (0, $eq8kl.default)({}, "".concat(context.prefixCls, "-icon_loading"), loading))
        });
    }, [
        context.prefixCls,
        nodeState,
        loading
    ]);
    // =================== Drop Indicator ===================
    var dropIndicatorNode = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        var rootDraggable = Boolean(context.draggable);
        // allowDrop is calculated in Tree.tsx, there is no need for calc it here
        var showIndicator = !props.disabled && rootDraggable && context.dragOverNodeKey === eventKey;
        if (!showIndicator) return null;
        return context.dropIndicatorRender({
            dropPosition: context.dropPosition,
            dropLevelOffset: context.dropLevelOffset,
            indent: context.indent,
            prefixCls: context.prefixCls,
            direction: context.direction
        });
    }, [
        context.dropPosition,
        context.dropLevelOffset,
        context.indent,
        context.prefixCls,
        context.direction,
        context.draggable,
        context.dragOverNodeKey,
        context.dropIndicatorRender
    ]);
    // Icon + Title
    var selectorNode = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(function() {
        var _props$title = props.title, title = _props$title === void 0 ? $422a8a4f6c7c8b88$var$defaultTitle : _props$title;
        var wrapClass = "".concat(context.prefixCls, "-node-content-wrapper");
        // Icon - Still show loading icon when loading without showIcon
        var $icon;
        if (context.showIcon) {
            var currentIcon = props.icon || context.icon;
            $icon = currentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(context.prefixCls, "-iconEle"), "".concat(context.prefixCls, "-icon__customize"))
            }, typeof currentIcon === 'function' ? currentIcon(props) : currentIcon) : iconNode;
        } else if (context.loadData && loading) $icon = iconNode;
        // Title
        var titleNode;
        if (typeof title === 'function') titleNode = title(data);
        else if (context.titleRender) titleNode = context.titleRender(data);
        else titleNode = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            ref: selectHandleRef,
            title: typeof title === 'string' ? title : '',
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(wrapClass, "".concat(wrapClass, "-").concat(nodeState || 'normal'), (0, $eq8kl.default)({}, "".concat(context.prefixCls, "-node-selected"), !isDisabled && (selected || dragNodeHighlight))),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onContextMenu: onContextMenu,
            onClick: onSelectorClick,
            onDoubleClick: onSelectorDoubleClick
        }, $icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: "".concat(context.prefixCls, "-title")
        }, titleNode), dropIndicatorNode);
    }, [
        context.prefixCls,
        context.showIcon,
        props,
        context.icon,
        iconNode,
        context.titleRender,
        data,
        nodeState,
        onMouseEnter,
        onMouseLeave,
        onContextMenu,
        onSelectorClick,
        onSelectorDoubleClick
    ]);
    var dataOrAriaAttributeProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    var _ref2 = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {}, level = _ref2.level;
    var isEndNode = isEnd[isEnd.length - 1];
    var draggableWithoutDisabled = !isDisabled && isDraggable;
    var dragging = context.draggingNodeKey === eventKey;
    var ariaSelected = selectable !== undefined ? {
        'aria-selected': !!selectable
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", (0, $hH60s.default)({
        ref: domRef,
        role: "treeitem",
        "aria-expanded": isLeaf ? undefined : expanded,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, "".concat(context.prefixCls, "-treenode"), (_classNames4 = {}, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)(_classNames4, "".concat(context.prefixCls, "-treenode-disabled"), isDisabled), "".concat(context.prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), "".concat(context.prefixCls, "-treenode-checkbox-checked"), checked), "".concat(context.prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), "".concat(context.prefixCls, "-treenode-selected"), selected), "".concat(context.prefixCls, "-treenode-loading"), loading), "".concat(context.prefixCls, "-treenode-active"), active), "".concat(context.prefixCls, "-treenode-leaf-last"), isEndNode), "".concat(context.prefixCls, "-treenode-draggable"), isDraggable), "dragging", dragging), (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)(_classNames4, 'drop-target', context.dropTargetKey === eventKey), 'drop-container', context.dropContainerKey === eventKey), 'drag-over', !isDisabled && dragOver), 'drag-over-gap-top', !isDisabled && dragOverGapTop), 'drag-over-gap-bottom', !isDisabled && dragOverGapBottom), 'filter-node', (_context$filterTreeNo = context.filterTreeNode) === null || _context$filterTreeNo === void 0 ? void 0 : _context$filterTreeNo.call(context, (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(props))), "".concat(context.prefixCls, "-treenode-leaf"), memoizedIsLeaf))),
        style: style,
        draggable: draggableWithoutDisabled,
        onDragStart: draggableWithoutDisabled ? onDragStart : undefined,
        onDragEnter: isDraggable ? onDragEnter : undefined,
        onDragOver: isDraggable ? onDragOver : undefined,
        onDragLeave: isDraggable ? onDragLeave : undefined,
        onDrop: isDraggable ? onDrop : undefined,
        onDragEnd: isDraggable ? onDragEnd : undefined,
        onMouseMove: onMouseMove
    }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $bc3f9304b6434c0f$export$2e2bcd8739ae039), {
        prefixCls: context.prefixCls,
        level: level,
        isStart: isStart,
        isEnd: isEnd
    }), dragHandlerNode, renderSwitcher(), checkboxNode, selectorNode);
};
$422a8a4f6c7c8b88$var$TreeNode.isTreeNode = 1;
$422a8a4f6c7c8b88$var$TreeNode.displayName = 'TreeNode';
var $422a8a4f6c7c8b88$export$2e2bcd8739ae039 = $422a8a4f6c7c8b88$var$TreeNode;




var $9c953ffa830afa28$var$_excluded = [
    "children"
];
function $9c953ffa830afa28$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    var clone = list.slice();
    var index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $9c953ffa830afa28$export$10663f6bbd2fd717(list, value) {
    var clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $9c953ffa830afa28$export$ddaee97dc8907312(pos) {
    return pos.split('-');
}
function $9c953ffa830afa28$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    var dragChildrenKeys = [];
    var entity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, dragNodeKey);
    function dig() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        list.forEach(function(_ref) {
            var key = _ref.key, children = _ref.children;
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $9c953ffa830afa28$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        var posArr = $9c953ffa830afa28$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $9c953ffa830afa28$export$b823688e4155eb8d(treeNodeEntity) {
    var posArr = $9c953ffa830afa28$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $9c953ffa830afa28$export$78a5519d0fb779c3(event, dragNodeProps, targetNodeProps, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    var _abstractDropNodeEnti;
    var clientX = event.clientX, clientY = event.clientY;
    var _getBoundingClientRec = event.target.getBoundingClientRect(), top = _getBoundingClientRec.top, height = _getBoundingClientRec.height;
    // optional chain for testing
    var horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
    var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // Filter the expanded keys to exclude the node that not has children currently (like async nodes).
    var filteredExpandKeys = expandKeys.filter(function(key) {
        var _keyEntities$key;
        return (_keyEntities$key = keyEntities[key]) === null || _keyEntities$key === void 0 || (_keyEntities$key = _keyEntities$key.children) === null || _keyEntities$key === void 0 ? void 0 : _keyEntities$key.length;
    });
    // find abstract drop node by horizontal offset
    var abstractDropNodeEntity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, targetNodeProps.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
            return flattenedNode.key === abstractDropNodeEntity.key;
        });
        var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        var prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, prevNodeKey);
    }
    var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    var abstractDragOverEntity = abstractDropNodeEntity;
    var dragOverNodeKey = abstractDropNodeEntity.key;
    var dropPosition = 0;
    var dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) for(var i = 0; i < rawDropLevelOffset; i += 1){
        if ($9c953ffa830afa28$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    var abstractDragDataNode = dragNodeProps.data;
    var abstractDropDataNode = abstractDropNodeEntity.node;
    var dropAllowed = true;
    if ($9c953ffa830afa28$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNodeProps.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
        dropAllowed: dropAllowed
    };
}
function $9c953ffa830afa28$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    var multiple = props.multiple;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
var $9c953ffa830afa28$var$internalProcessProps = function internalProcessProps(props) {
    return props;
};
function $9c953ffa830afa28$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    var _ref2 = processor || {}, _ref2$processProps = _ref2.processProps, processProps = _ref2$processProps === void 0 ? $9c953ffa830afa28$var$internalProcessProps : _ref2$processProps;
    var list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(function(_ref3) {
        var children = _ref3.children, props = (0, $4b02Q.default)(_ref3, $9c953ffa830afa28$var$_excluded);
        var childrenNodes = $9c953ffa830afa28$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $422a8a4f6c7c8b88$export$2e2bcd8739ae039), (0, $hH60s.default)({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $9c953ffa830afa28$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    var keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if ((0, $1Esi2.default)(keys) === 'object') keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $2bFmQ.default)(false, '`checkedKeys` is not an array or an object');
        return null;
    }
    return keyProps;
}
function $9c953ffa830afa28$export$fac4a40c345ccd80(keyList, keyEntities) {
    var expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        var entity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        var parent = entity.parent, node = entity.node;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach(function(key) {
        conductUp(key);
    });
    return (0, $fvBso.default)(expandedKeys);
}



var $2bFmQ = parcelRequire("2bFmQ");

function $4171d50fadf9ef5d$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    var filteredKeys = new Set();
    halfCheckedKeys.forEach(function(key) {
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $4171d50fadf9ef5d$export$ab01c86170b1dea0(node) {
    var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $4171d50fadf9ef5d$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    var visitedKeys = new Set();
    for(var _level = maxLevel; _level >= 0; _level -= 1){
        var _entities = levelEntities.get(_level) || new Set();
        _entities.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref2) {
                var key = _ref2.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($4171d50fadf9ef5d$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $4171d50fadf9ef5d$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    var visitedKeys = new Set();
    for(var _level2 = maxLevel; _level2 >= 0; _level2 -= 1){
        var _entities2 = levelEntities.get(_level2) || new Set();
        _entities2.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref3) {
                var key = _ref3.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($4171d50fadf9ef5d$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $4171d50fadf9ef5d$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    var warningMissKeys = [];
    var syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $4171d50fadf9ef5d$export$ab01c86170b1dea0;
    // We only handle exist keys
    var keys = new Set(keyList.filter(function(key) {
        var hasEntity = !!(0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    var levelEntities = new Map();
    var maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach(function(key) {
        var entity = keyEntities[key];
        var level = entity.level;
        var levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $2bFmQ.default)(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function(key) {
        return "'".concat(key, "'");
    }).join(', ')));
    var result;
    if (checked === true) result = $4171d50fadf9ef5d$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $4171d50fadf9ef5d$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}




var $eGh7a = parcelRequire("eGh7a");

var $jMaZ8 = parcelRequire("jMaZ8");
function $154afc7edcce77f9$export$2e2bcd8739ae039(getKey) {
    const [prevSelectedIndex, setPrevSelectedIndex] = (0, $jMaZ8.useState)(null);
    const multipleSelect = (0, $jMaZ8.useCallback)((currentSelectedIndex, data, selectedKeys)=>{
        const configPrevSelectedIndex = prevSelectedIndex !== null && prevSelectedIndex !== void 0 ? prevSelectedIndex : currentSelectedIndex;
        // add/delete the selected range
        const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
        const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
        const rangeKeys = data.slice(startIndex, endIndex + 1).map((item)=>getKey(item));
        const shouldSelected = rangeKeys.some((rangeKey)=>!selectedKeys.has(rangeKey));
        const changedKeys = [];
        rangeKeys.forEach((item)=>{
            if (shouldSelected) {
                if (!selectedKeys.has(item)) changedKeys.push(item);
                selectedKeys.add(item);
            } else {
                selectedKeys.delete(item);
                changedKeys.push(item);
            }
        });
        setPrevSelectedIndex(shouldSelected ? endIndex : null);
        return changedKeys;
    }, [
        prevSelectedIndex
    ]);
    const updatePrevSelectedIndex = (val)=>{
        setPrevSelectedIndex(val);
    };
    return [
        multipleSelect,
        updatePrevSelectedIndex
    ];
}






"use client";
const $c2848e6016c49c74$export$ed10248435b8f218 = {};
const $c2848e6016c49c74$export$14159cd9e2a500c8 = 'SELECT_ALL';
const $c2848e6016c49c74$export$625c4f68eaaf8cfd = 'SELECT_INVERT';
const $c2848e6016c49c74$export$c1a725540f5a63bd = 'SELECT_NONE';
const $c2848e6016c49c74$var$EMPTY_LIST = [];
const $c2848e6016c49c74$var$flattenData = (childrenColumnName, data)=>{
    let list = [];
    (data || []).forEach((record)=>{
        list.push(record);
        if (record && typeof record === 'object' && childrenColumnName in record) list = [].concat((0, $fvBso.default)(list), (0, $fvBso.default)($c2848e6016c49c74$var$flattenData(childrenColumnName, record[childrenColumnName])));
    });
    return list;
};
const $c2848e6016c49c74$var$useSelection = (config, rowSelection)=>{
    const { preserveSelectedRowKeys: preserveSelectedRowKeys, selectedRowKeys: selectedRowKeys, defaultSelectedRowKeys: defaultSelectedRowKeys, getCheckboxProps: getCheckboxProps, onChange: onSelectionChange, onSelect: onSelect, onSelectAll: onSelectAll, onSelectInvert: onSelectInvert, onSelectNone: onSelectNone, onSelectMultiple: onSelectMultiple, columnWidth: selectionColWidth, type: selectionType, selections: selections, fixed: fixed, renderCell: customizeRenderCell, hideSelectAll: hideSelectAll, checkStrictly: checkStrictly = true } = rowSelection || {};
    const { prefixCls: prefixCls, data: data, pageData: pageData, getRecordByKey: getRecordByKey, getRowKey: getRowKey, expandType: expandType, childrenColumnName: childrenColumnName, locale: tableLocale, getPopupContainer: getPopupContainer } = config;
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Table');
    // ========================= MultipleSelect =========================
    const [multipleSelect, updatePrevSelectedIndex] = (0, $154afc7edcce77f9$export$2e2bcd8739ae039)((item)=>item);
    // ========================= Keys =========================
    const [mergedSelectedKeys, setMergedSelectedKeys] = (0, $eGh7a.default)(selectedRowKeys || defaultSelectedRowKeys || $c2848e6016c49c74$var$EMPTY_LIST, {
        value: selectedRowKeys
    });
    // ======================== Caches ========================
    const preserveRecordsRef = $jMaZ8.useRef(new Map());
    const updatePreserveRecordsCache = (0, $jMaZ8.useCallback)((keys)=>{
        if (preserveSelectedRowKeys) {
            const newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach((key)=>{
                let record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $jMaZ8.useEffect(()=>{
        updatePreserveRecordsCache(mergedSelectedKeys);
    }, [
        mergedSelectedKeys
    ]);
    // Get flatten data
    const flattedData = (0, $jMaZ8.useMemo)(()=>$c2848e6016c49c74$var$flattenData(childrenColumnName, pageData), [
        childrenColumnName,
        pageData
    ]);
    const { keyEntities: keyEntities } = (0, $jMaZ8.useMemo)(()=>{
        if (checkStrictly) return {
            keyEntities: null
        };
        let convertData = data;
        if (preserveSelectedRowKeys) {
            // use flattedData keys
            const keysSet = new Set(flattedData.map((record, index)=>getRowKey(record, index)));
            // remove preserveRecords that duplicate data
            const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, _ref)=>{
                let [key, value] = _ref;
                return keysSet.has(key) ? total : total.concat(value);
            }, []);
            convertData = [].concat((0, $fvBso.default)(convertData), (0, $fvBso.default)(preserveRecords));
        }
        return (0, $a2876523b8e415d4$export$e5d831ce033a4615)(convertData, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName,
        preserveSelectedRowKeys,
        flattedData
    ]);
    // Get all checkbox props
    const checkboxPropsMap = (0, $jMaZ8.useMemo)(()=>{
        const map = new Map();
        flattedData.forEach((record, index)=>{
            const key = getRowKey(record, index);
            const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
            warning(!('checked' in checkboxProps || 'defaultChecked' in checkboxProps), 'usage', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    const isCheckboxDisabled = (0, $jMaZ8.useCallback)((r)=>{
        const rowKey = getRowKey(r);
        let checkboxProps;
        if (checkboxPropsMap.has(rowKey)) checkboxProps = checkboxPropsMap.get(getRowKey(r));
        else checkboxProps = getCheckboxProps ? getCheckboxProps(r) : undefined;
        return !!(checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.disabled);
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0, $jMaZ8.useMemo)(()=>{
        if (checkStrictly) return [
            mergedSelectedKeys || [],
            []
        ];
        const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $4171d50fadf9ef5d$export$43adf2c483e3e633)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled);
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeys,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]);
    const derivedSelectedKeySet = (0, $jMaZ8.useMemo)(()=>{
        const keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    const derivedHalfSelectedKeySet = (0, $jMaZ8.useMemo)(()=>selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys), [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Reset if rowSelection reset
    $jMaZ8.useEffect(()=>{
        if (!rowSelection) setMergedSelectedKeys($c2848e6016c49c74$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    const setSelectedKeys = (0, $jMaZ8.useCallback)((keys, method)=>{
        let availableKeys;
        let records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map((key)=>preserveRecordsRef.current.get(key));
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach((key)=>{
                const record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    const triggerSingleSelection = (0, $jMaZ8.useCallback)((key, selected, keys, event)=>{
        if (onSelect) {
            const rows = keys.map((k)=>getRecordByKey(k));
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, 'single');
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    const mergedSelections = (0, $jMaZ8.useMemo)(()=>{
        if (!selections || hideSelectAll) return null;
        const selectionList = selections === true ? [
            $c2848e6016c49c74$export$14159cd9e2a500c8,
            $c2848e6016c49c74$export$625c4f68eaaf8cfd,
            $c2848e6016c49c74$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map((selection)=>{
            if (selection === $c2848e6016c49c74$export$14159cd9e2a500c8) return {
                key: 'all',
                text: tableLocale.selectionAll,
                onSelect () {
                    setSelectedKeys(data.map((record, index)=>getRowKey(record, index)).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return !(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled) || derivedSelectedKeySet.has(key);
                    }), 'all');
                }
            };
            if (selection === $c2848e6016c49c74$export$625c4f68eaaf8cfd) return {
                key: 'invert',
                text: tableLocale.selectInvert,
                onSelect () {
                    const keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach((record, index)=>{
                        const key = getRowKey(record, index);
                        const checkProps = checkboxPropsMap.get(key);
                        if (!(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled)) {
                            if (keySet.has(key)) keySet.delete(key);
                            else keySet.add(key);
                        }
                    });
                    const keys = Array.from(keySet);
                    if (onSelectInvert) {
                        warning.deprecated(false, 'onSelectInvert', 'onChange');
                        onSelectInvert(keys);
                    }
                    setSelectedKeys(keys, 'invert');
                }
            };
            if (selection === $c2848e6016c49c74$export$c1a725540f5a63bd) return {
                key: 'none',
                text: tableLocale.selectNone,
                onSelect () {
                    onSelectNone === null || onSelectNone === void 0 || onSelectNone();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled;
                    }), 'none');
                }
            };
            return selection;
        }).map((selection)=>Object.assign(Object.assign({}, selection), {
                onSelect: function() {
                    var _a2;
                    var _a;
                    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
                    (_a = selection.onSelect) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        selection
                    ].concat(rest));
                    updatePrevSelectedIndex(null);
                }
            }));
    }, [
        selections,
        derivedSelectedKeySet,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    const transformColumns = (0, $jMaZ8.useCallback)((columns)=>{
        var _a;
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) {
            warning(!columns.includes($c2848e6016c49c74$export$ed10248435b8f218), 'usage', '`rowSelection` is not config but `SELECTION_COLUMN` exists in the `columns`.');
            return columns.filter((col)=>col !== $c2848e6016c49c74$export$ed10248435b8f218);
        }
        // >>>>>>>>>>> Support selection
        let cloneColumns = (0, $fvBso.default)(columns);
        const keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        const recordKeys = flattedData.map(getRowKey).filter((key)=>!checkboxPropsMap.get(key).disabled);
        const checkedCurrentAll = recordKeys.every((key)=>keySet.has(key));
        const checkedCurrentSome = recordKeys.some((key)=>keySet.has(key));
        const onSelectAllChange = ()=>{
            const changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach((key)=>{
                keySet.delete(key);
                changeKeys.push(key);
            });
            else recordKeys.forEach((key)=>{
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            const keys = Array.from(keySet);
            onSelectAll === null || onSelectAll === void 0 || onSelectAll(!checkedCurrentAll, keys.map((k)=>getRecordByKey(k)), changeKeys.map((k)=>getRecordByKey(k)));
            setSelectedKeys(keys, 'all');
            updatePrevSelectedIndex(null);
        };
        // ===================== Render =====================
        // Title Cell
        let title;
        let columnTitleCheckbox;
        if (selectionType !== 'radio') {
            let customizeSelections;
            if (mergedSelections) {
                const menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map((selection, index)=>{
                        const { key: key, text: text, onSelect: onSelectionClick } = selection;
                        return {
                            key: key !== null && key !== void 0 ? key : index,
                            onClick: ()=>{
                                onSelectionClick === null || onSelectionClick === void 0 || onSelectionClick(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $jMaZ8.createElement("div", {
                    className: `${prefixCls}-selection-extra`
                }, /*#__PURE__*/ $jMaZ8.createElement((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $jMaZ8.createElement("span", null, /*#__PURE__*/ $jMaZ8.createElement((0, $159430c34bfeb8bb$export$2e2bcd8739ae039), null))));
            }
            const allDisabledData = flattedData.map((record, index)=>{
                const key = getRowKey(record, index);
                const checkboxProps = checkboxPropsMap.get(key) || {};
                return Object.assign({
                    checked: keySet.has(key)
                }, checkboxProps);
            }).filter((_ref2)=>{
                let { disabled: disabled } = _ref2;
                return disabled;
            });
            const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            const allDisabledAndChecked = allDisabled && allDisabledData.every((_ref3)=>{
                let { checked: checked } = _ref3;
                return checked;
            });
            const allDisabledSomeChecked = allDisabled && allDisabledData.some((_ref4)=>{
                let { checked: checked } = _ref4;
                return checked;
            });
            columnTitleCheckbox = /*#__PURE__*/ $jMaZ8.createElement((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: onSelectAllChange,
                disabled: flattedData.length === 0 || allDisabled,
                "aria-label": customizeSelections ? 'Custom selection' : 'Select all',
                skipGroup: true
            });
            title = !hideSelectAll && /*#__PURE__*/ $jMaZ8.createElement("div", {
                className: `${prefixCls}-selection`
            }, columnTitleCheckbox, customizeSelections);
        }
        // Body Cell
        let renderCell;
        if (selectionType === 'radio') renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            return {
                node: /*#__PURE__*/ $jMaZ8.createElement((0, $41c1392b19ea6316$export$2e2bcd8739ae039), Object.assign({}, checkboxProps, {
                    checked: checked,
                    onClick: (e)=>{
                        var _a;
                        e.stopPropagation();
                        (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 || _a.call(checkboxProps, e);
                    },
                    onChange: (event)=>{
                        var _a;
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                        (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a === void 0 || _a.call(checkboxProps, event);
                    }
                })),
                checked: checked
            };
        };
        else renderCell = (_, record, index)=>{
            var _a;
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const indeterminate = derivedHalfSelectedKeySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            let mergedIndeterminate;
            if (expandType === 'nest') {
                mergedIndeterminate = indeterminate;
                warning(typeof (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== 'boolean', 'usage', 'set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.');
            } else mergedIndeterminate = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a !== void 0 ? _a : indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $jMaZ8.createElement((0, $1e51c82e25088207$export$2e2bcd8739ae039), Object.assign({}, checkboxProps, {
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: (e)=>{
                        var _a;
                        e.stopPropagation();
                        (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 || _a.call(checkboxProps, e);
                    },
                    onChange: (event)=>{
                        var _a;
                        const { nativeEvent: nativeEvent } = event;
                        const { shiftKey: shiftKey } = nativeEvent;
                        const currentSelectedIndex = recordKeys.findIndex((item)=>item === key);
                        const isMultiple = derivedSelectedKeys.some((item)=>recordKeys.includes(item));
                        if (shiftKey && checkStrictly && isMultiple) {
                            const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                            const keys = Array.from(keySet);
                            onSelectMultiple === null || onSelectMultiple === void 0 || onSelectMultiple(!checked, keys.map((recordKey)=>getRecordByKey(recordKey)), changedKeys.map((recordKey)=>getRecordByKey(recordKey)));
                            setSelectedKeys(keys, 'multiple');
                        } else {
                            // Single record selected
                            const originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                const checkedKeys = checked ? (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(originCheckedKeys, key) : (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                const result = (0, $4171d50fadf9ef5d$export$43adf2c483e3e633)([].concat((0, $fvBso.default)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = result;
                                let nextCheckedKeys = checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    const tempKeySet = new Set(checkedKeys);
                                    tempKeySet.delete(key);
                                    nextCheckedKeys = (0, $4171d50fadf9ef5d$export$43adf2c483e3e633)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) updatePrevSelectedIndex(null);
                        else updatePrevSelectedIndex(currentSelectedIndex);
                        (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a === void 0 || _a.call(checkboxProps, event);
                    }
                })),
                checked: checked
            };
        };
        const renderSelectionCell = (_, record, index)=>{
            const { node: node, checked: checked } = renderCell(_, record, index);
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($c2848e6016c49c74$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex((col)=>{
                var _a;
                return ((_a = col[0, $4a3a27f5347ea785$export$f8dba99c0d5b6b87]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN';
            }) === 0) {
                const [expandColumn, ...restColumns] = cloneColumns;
                cloneColumns = [
                    expandColumn,
                    $c2848e6016c49c74$export$ed10248435b8f218
                ].concat((0, $fvBso.default)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $c2848e6016c49c74$export$ed10248435b8f218
            ].concat((0, $fvBso.default)(cloneColumns));
        }
        // Deduplicate selection column
        const selectionColumnIndex = cloneColumns.indexOf($c2848e6016c49c74$export$ed10248435b8f218);
        warning(cloneColumns.filter((col)=>col === $c2848e6016c49c74$export$ed10248435b8f218).length <= 1, 'usage', 'Multiple `SELECTION_COLUMN` exist in `columns`.');
        cloneColumns = cloneColumns.filter((column, index)=>column !== $c2848e6016c49c74$export$ed10248435b8f218 || index === selectionColumnIndex);
        // Fixed column logic
        const prevCol = cloneColumns[selectionColumnIndex - 1];
        const nextCol = cloneColumns[selectionColumnIndex + 1];
        let mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== undefined) mergedFixed = nextCol.fixed;
            else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && ((_a = prevCol[0, $4a3a27f5347ea785$export$f8dba99c0d5b6b87]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN' && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        const columnCls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-selection-col`, {
            [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === 'checkbox'
        });
        const renderColumnTitle = ()=>{
            if (!(rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.columnTitle)) return title;
            if (typeof rowSelection.columnTitle === 'function') return rowSelection.columnTitle(columnTitleCheckbox);
            return rowSelection.columnTitle;
        };
        // Replace with real selection column
        const selectionColumn = {
            fixed: mergedFixed,
            width: selectionColWidth,
            className: `${prefixCls}-selection-column`,
            title: renderColumnTitle(),
            render: renderSelectionCell,
            onCell: rowSelection.onCell,
            [(0, $4a3a27f5347ea785$export$f8dba99c0d5b6b87)]: {
                className: columnCls
            }
        };
        return cloneColumns.map((col)=>col === $c2848e6016c49c74$export$ed10248435b8f218 ? selectionColumn : col);
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
};
var $c2848e6016c49c74$export$2e2bcd8739ae039 = $c2848e6016c49c74$var$useSelection;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");



var $hvG6u = parcelRequire("hvG6u");
// Proxy the dom ref with `{ nativeElement, otherFn }` type
// ref: https://github.com/ant-design/ant-design/discussions/45242

var $jMaZ8 = parcelRequire("jMaZ8");
function $dc80ff031dcc2ebe$var$fillProxy(element, handler) {
    element._antProxy = element._antProxy || {};
    Object.keys(handler).forEach((key)=>{
        if (!(key in element._antProxy)) {
            const ori = element[key];
            element._antProxy[key] = ori;
            element[key] = handler[key];
        }
    });
    return element;
}
function $dc80ff031dcc2ebe$export$2e2bcd8739ae039(ref, init) {
    return (0, $jMaZ8.useImperativeHandle)(ref, ()=>{
        const refObj = init();
        const { nativeElement: nativeElement } = refObj;
        if (typeof Proxy !== 'undefined') return new Proxy(nativeElement, {
            get (obj, prop) {
                if (refObj[prop]) return refObj[prop];
                return Reflect.get(obj, prop);
            }
        });
        // Fallback of IE
        return $dc80ff031dcc2ebe$var$fillProxy(nativeElement, refObj);
    });
}



var $aZxvk = parcelRequire("aZxvk");
function $d775a2d25fad8da0$export$24656b269d8df7d6(t, b, c, d) {
    const cc = c - b;
    // biome-ignore lint: it is a common easing function
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // biome-ignore lint: it is a common easing function
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}


function $44538d006de4b1c2$export$5a096129d439f843(obj) {
    return obj !== null && obj !== undefined && obj === obj.window;
}
const $44538d006de4b1c2$var$getScroll = (target)=>{
    var _a, _b;
    if (typeof window === 'undefined') return 0;
    let result = 0;
    if ($44538d006de4b1c2$export$5a096129d439f843(target)) result = target.pageYOffset;
    else if (target instanceof Document) result = target.documentElement.scrollTop;
    else if (target instanceof HTMLElement) result = target.scrollTop;
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    /* biome-ignore lint/complexity/useLiteralKeys: target is a never type */ /* eslint-disable-next-line dot-notation */ result = target['scrollTop'];
    if (target && !$44538d006de4b1c2$export$5a096129d439f843(target) && typeof result !== 'number') result = (_b = ((_a = target.ownerDocument) !== null && _a !== void 0 ? _a : target).documentElement) === null || _b === void 0 ? void 0 : _b.scrollTop;
    return result;
};
var $44538d006de4b1c2$export$2e2bcd8739ae039 = $44538d006de4b1c2$var$getScroll;


function $72cb4fa9ea0303f1$export$2e2bcd8739ae039(y) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { getContainer: getContainer = ()=>window, callback: callback, duration: duration = 450 } = options;
    const container = getContainer();
    const scrollTop = (0, $44538d006de4b1c2$export$2e2bcd8739ae039)(container);
    const startTime = Date.now();
    const frameFunc = ()=>{
        const timestamp = Date.now();
        const time = timestamp - startTime;
        const nextScrollTop = (0, $d775a2d25fad8da0$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $44538d006de4b1c2$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === 'HTMLDocument') container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) (0, $aZxvk.default)(frameFunc);
        else if (typeof callback === 'function') callback();
    };
    (0, $aZxvk.default)(frameFunc);
}








var $jMaZ8 = parcelRequire("jMaZ8");

var $jLTp6 = parcelRequire("jLTp6");


"use client";
function $2bc364d47e670ed8$var$useBreakpoint() {
    let refreshOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const screensRef = (0, $jMaZ8.useRef)({});
    const forceUpdate = (0, $3b33849fb1ac9a25$export$2e2bcd8739ae039)();
    const responsiveObserver = (0, $85a8a338db7581cb$export$2e2bcd8739ae039)();
    (0, $jLTp6.default)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    return screensRef.current;
}
var $2bc364d47e670ed8$export$2e2bcd8739ae039 = $2bc364d47e670ed8$var$useBreakpoint;




var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $1e043f9b7c502bf6$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $1e043f9b7c502bf6$export$2e2bcd8739ae039 = $1e043f9b7c502bf6$var$DoubleLeftOutlined;



var $6e46ad2dd0f7d813$var$DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $1e043f9b7c502bf6$export$2e2bcd8739ae039)
    }));
};
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ var $6e46ad2dd0f7d813$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($6e46ad2dd0f7d813$var$DoubleLeftOutlined);
$6e46ad2dd0f7d813$var$RefIcon.displayName = 'DoubleLeftOutlined';
var $6e46ad2dd0f7d813$export$2e2bcd8739ae039 = $6e46ad2dd0f7d813$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $cb37e114514f99cd$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $cb37e114514f99cd$export$2e2bcd8739ae039 = $cb37e114514f99cd$var$DoubleRightOutlined;



var $1199127efb84781f$var$DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $cb37e114514f99cd$export$2e2bcd8739ae039)
    }));
};
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ var $1199127efb84781f$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($1199127efb84781f$var$DoubleRightOutlined);
$1199127efb84781f$var$RefIcon.displayName = 'DoubleRightOutlined';
var $1199127efb84781f$export$2e2bcd8739ae039 = $1199127efb84781f$var$RefIcon;





var $giSak = parcelRequire("giSak");

var $eq8kl = parcelRequire("eq8kl");

var $hH60s = parcelRequire("hH60s");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $eGh7a = parcelRequire("eGh7a");



var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");
var $46b9734627445ae9$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $46b9734627445ae9$export$2e2bcd8739ae039 = $46b9734627445ae9$var$locale;



var $3fkx6 = parcelRequire("3fkx6");


var $jMaZ8 = parcelRequire("jMaZ8");
var $00f15fc86371b572$var$defaultPageSizeOptions = [
    10,
    20,
    50,
    100
];
var $00f15fc86371b572$var$Options = function Options(props) {
    var _props$pageSizeOption = props.pageSizeOptions, pageSizeOptions = _props$pageSizeOption === void 0 ? $00f15fc86371b572$var$defaultPageSizeOptions : _props$pageSizeOption, locale = props.locale, changeSize = props.changeSize, pageSize = props.pageSize, goButton = props.goButton, quickGo = props.quickGo, rootPrefixCls = props.rootPrefixCls, disabled = props.disabled, buildOptionText = props.buildOptionText, showSizeChanger = props.showSizeChanger, sizeChangerRender = props.sizeChangerRender;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(''), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), goInputText = _React$useState2[0], setGoInputText = _React$useState2[1];
    var getValidValue = function getValidValue() {
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    };
    var mergeBuildOptionText = typeof buildOptionText === 'function' ? buildOptionText : function(value) {
        return "".concat(value, " ").concat(locale.items_per_page);
    };
    var handleChange = function handleChange(e) {
        setGoInputText(e.target.value);
    };
    var handleBlur = function handleBlur(e) {
        if (goButton || goInputText === '') return;
        setGoInputText('');
        if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) return;
        quickGo === null || quickGo === void 0 || quickGo(getValidValue());
    };
    var go = function go(e) {
        if (goInputText === '') return;
        if (e.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER || e.type === 'click') {
            setGoInputText('');
            quickGo === null || quickGo === void 0 || quickGo(getValidValue());
        }
    };
    var getPageSizeOptions = function getPageSizeOptions() {
        if (pageSizeOptions.some(function(option) {
            return option.toString() === pageSize.toString();
        })) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize
        ]).sort(function(a, b) {
            var numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            var numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    var prefixCls = "".concat(rootPrefixCls, "-options");
    // ============== render ==============
    if (!showSizeChanger && !quickGo) return null;
    var changeSelect = null;
    var goInput = null;
    var gotoButton = null;
    // >>>>> Size Changer
    if (showSizeChanger && sizeChangerRender) changeSelect = sizeChangerRender({
        disabled: disabled,
        size: pageSize,
        onSizeChange: function onSizeChange(nextValue) {
            changeSize === null || changeSize === void 0 || changeSize(Number(nextValue));
        },
        'aria-label': locale.page_size,
        className: "".concat(prefixCls, "-size-changer"),
        options: getPageSizeOptions().map(function(opt) {
            return {
                label: mergeBuildOptionText(opt),
                value: opt
            };
        })
    });
    // >>>>> Quick Go
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: "".concat(prefixCls, "-quick-jumper-button")
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
            className: "".concat(prefixCls, "-quick-jumper")
        }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
$00f15fc86371b572$var$Options.displayName = 'Options';
var $00f15fc86371b572$export$2e2bcd8739ae039 = $00f15fc86371b572$var$Options;



var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");
var $83e9c526868e97ca$var$Pager = function Pager(props) {
    var _classNames;
    var rootPrefixCls = props.rootPrefixCls, page = props.page, active = props.active, className = props.className, showTitle = props.showTitle, onClick = props.onClick, onKeyPress = props.onKeyPress, itemRender = props.itemRender;
    var prefixCls = "".concat(rootPrefixCls, "-item");
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, "".concat(prefixCls, "-").concat(page), (_classNames = {}, (0, $eq8kl.default)(_classNames, "".concat(prefixCls, "-active"), active), (0, $eq8kl.default)(_classNames, "".concat(prefixCls, "-disabled"), !page), _classNames), className);
    var handleClick = function handleClick() {
        onClick(page);
    };
    var handleKeyPress = function handleKeyPress(e) {
        onKeyPress(e, onClick, page);
    };
    var pager = itemRender(page, 'page', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
$83e9c526868e97ca$var$Pager.displayName = 'Pager';
var $83e9c526868e97ca$export$2e2bcd8739ae039 = $83e9c526868e97ca$var$Pager;


var $2875f86623519288$var$defaultItemRender = function defaultItemRender(page, type, element) {
    return element;
};
function $2875f86623519288$var$noop() {}
function $2875f86623519288$var$isInteger(v) {
    var value = Number(v);
    return typeof value === 'number' && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $2875f86623519288$var$calculatePage(p, pageSize, total) {
    var _pageSize = typeof p === 'undefined' ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
var $2875f86623519288$var$Pagination = function Pagination(props) {
    var _classNames5;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-pagination' : _props$prefixCls, _props$selectPrefixCl = props.selectPrefixCls, selectPrefixCls = _props$selectPrefixCl === void 0 ? 'rc-select' : _props$selectPrefixCl, className = props.className, currentProp = props.current, _props$defaultCurrent = props.defaultCurrent, defaultCurrent = _props$defaultCurrent === void 0 ? 1 : _props$defaultCurrent, _props$total = props.total, total = _props$total === void 0 ? 0 : _props$total, pageSizeProp = props.pageSize, _props$defaultPageSiz = props.defaultPageSize, defaultPageSize = _props$defaultPageSiz === void 0 ? 10 : _props$defaultPageSiz, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? $2875f86623519288$var$noop : _props$onChange, hideOnSinglePage = props.hideOnSinglePage, align = props.align, _props$showPrevNextJu = props.showPrevNextJumpers, showPrevNextJumpers = _props$showPrevNextJu === void 0 ? true : _props$showPrevNextJu, showQuickJumper = props.showQuickJumper, showLessItems = props.showLessItems, _props$showTitle = props.showTitle, showTitle = _props$showTitle === void 0 ? true : _props$showTitle, _props$onShowSizeChan = props.onShowSizeChange, onShowSizeChange = _props$onShowSizeChan === void 0 ? $2875f86623519288$var$noop : _props$onShowSizeChan, _props$locale = props.locale, locale = _props$locale === void 0 ? (0, $46b9734627445ae9$export$2e2bcd8739ae039) : _props$locale, style = props.style, _props$totalBoundaryS = props.totalBoundaryShowSizeChanger, totalBoundaryShowSizeChanger = _props$totalBoundaryS === void 0 ? 50 : _props$totalBoundaryS, disabled = props.disabled, simple = props.simple, showTotal = props.showTotal, _props$showSizeChange = props.showSizeChanger, showSizeChanger = _props$showSizeChange === void 0 ? total > totalBoundaryShowSizeChanger : _props$showSizeChange, sizeChangerRender = props.sizeChangerRender, pageSizeOptions = props.pageSizeOptions, _props$itemRender = props.itemRender, itemRender = _props$itemRender === void 0 ? $2875f86623519288$var$defaultItemRender : _props$itemRender, jumpPrevIcon = props.jumpPrevIcon, jumpNextIcon = props.jumpNextIcon, prevIcon = props.prevIcon, nextIcon = props.nextIcon;
    var paginationRef = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useRef(null);
    var _useMergedState = (0, $eGh7a.default)(10, {
        value: pageSizeProp,
        defaultValue: defaultPageSize
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), pageSize = _useMergedState2[0], setPageSize = _useMergedState2[1];
    var _useMergedState3 = (0, $eGh7a.default)(1, {
        value: currentProp,
        defaultValue: defaultCurrent,
        postState: function postState(c) {
            return Math.max(1, Math.min(c, $2875f86623519288$var$calculatePage(undefined, pageSize, total)));
        }
    }), _useMergedState4 = (0, $3fkx6.default)(_useMergedState3, 2), current = _useMergedState4[0], setCurrent = _useMergedState4[1];
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState(current), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), internalInputVal = _React$useState2[0], setInternalInputVal = _React$useState2[1];
    (0, $jMaZ8.useEffect)(function() {
        setInternalInputVal(current);
    }, [
        current
    ]);
    var hasOnChange = onChange !== $2875f86623519288$var$noop;
    var hasCurrent = 'current' in props;
    (0, $2bFmQ.default)(hasCurrent ? hasOnChange : true, 'You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.');
    var jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    var jumpNextPage = Math.min($2875f86623519288$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        var iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("button", {
            type: "button",
            "aria-label": label,
            className: "".concat(prefixCls, "-item-link")
        });
        if (typeof icon === 'function') iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(icon, (0, $8u3qN.default)({}, props));
        return iconNode;
    }
    function getValidValue(e) {
        var inputValue = e.target.value;
        var allPages = $2875f86623519288$var$calculatePage(undefined, pageSize, total);
        var value;
        if (inputValue === '') value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $2875f86623519288$var$isInteger(page) && page !== current && $2875f86623519288$var$isInteger(total) && total > 0;
    }
    var shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP || event.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        var value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        var newCurrent = $2875f86623519288$var$calculatePage(size, pageSize, total);
        var nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange === null || onShowSizeChange === void 0 || onShowSizeChange(current, size);
        setCurrent(nextCurrent);
        onChange === null || onChange === void 0 || onChange(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            var currentPage = $2875f86623519288$var$calculatePage(undefined, pageSize, total);
            var newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange === null || onChange === void 0 || onChange(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    var hasPrev = current > 1;
    var hasNext = current < $2875f86623519288$var$calculatePage(undefined, pageSize, total);
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback) {
        if (event.key === 'Enter' || event.charCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) {
            for(var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restParams[_key - 2] = arguments[_key];
            callback.apply(void 0, restParams);
        }
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        var prevButton = itemRender(prevPage, 'prev', getItemIcon(prevIcon, 'prev page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).isValidElement(prevButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        var nextButton = itemRender(nextPage, 'next', getItemIcon(nextIcon, 'next page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).isValidElement(nextButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === 'click' || event.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    var jumpPrev = null;
    var dataOrAriaAttributeProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    var totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
        className: "".concat(prefixCls, "-total-text")
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    var jumpNext = null;
    var allPages = $2875f86623519288$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    var pagerList = [];
    var pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1
    };
    var prevPage = current - 1 > 0 ? current - 1 : 0;
    var nextPage = current + 1 < allPages ? current + 1 : allPages;
    var goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    var isReadOnly = (0, $1Esi2.default)(simple) === 'object' ? simple.readOnly : !simple;
    var gotoButton = goButton;
    var simplePager = null;
    if (simple) {
        // ====== Simple quick jump ======
        if (goButton) {
            if (typeof goButton === 'boolean') gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("button", {
                type: "button",
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, locale.jump_to_confirm);
            else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, goButton);
            gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
                title: showTitle ? "".concat(locale.jump_to).concat(current, "/").concat(allPages) : null,
                className: "".concat(prefixCls, "-simple-pager")
            }, gotoButton);
        }
        simplePager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
            title: showTitle ? "".concat(current, "/").concat(allPages) : null,
            className: "".concat(prefixCls, "-simple-pager")
        }, isReadOnly ? internalInputVal : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("input", {
            type: "text",
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: "".concat(prefixCls, "-slash")
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    var pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $83e9c526868e97ca$export$2e2bcd8739ae039), (0, $hH60s.default)({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: "".concat(prefixCls, "-item-disabled")
        })));
        for(var i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $83e9c526868e97ca$export$2e2bcd8739ae039), (0, $hH60s.default)({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        var jumpPrevContent = itemRender(jumpPrevPage, 'jump-prev', getItemIcon(jumpPrevIcon, 'prev page'));
        var jumpNextContent = itemRender(jumpNextPage, 'jump-next', getItemIcon(jumpNextIcon, 'next page'));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-jump-prev"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-jump-next"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
            }, jumpNextContent) : null;
        }
        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        for(var _i = left; _i <= right; _i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $83e9c526868e97ca$export$2e2bcd8739ae039), (0, $hH60s.default)({}, pagerProps, {
            key: _i,
            page: _i,
            active: current === _i
        })));
        if (current - 1 >= pageBufferSize * 2 && current !== 3) {
            pagerList[0] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(pagerList[0], {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-item-after-jump-prev"), pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
            var lastOne = pagerList[pagerList.length - 1];
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(lastOne, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-item-before-jump-next"), lastOne.props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $83e9c526868e97ca$export$2e2bcd8739ae039), (0, $hH60s.default)({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $83e9c526868e97ca$export$2e2bcd8739ae039), (0, $hH60s.default)({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    var prev = renderPrev(prevPage);
    if (prev) {
        var prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-prev"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
            "aria-disabled": prevDisabled
        }, prev);
    }
    var next = renderNext(nextPage);
    if (next) {
        var nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-next"), (0, $eq8kl.default)({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
            "aria-disabled": nextDisabled
        }, next);
    }
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (_classNames5 = {}, (0, $eq8kl.default)(_classNames5, "".concat(prefixCls, "-start"), align === 'start'), (0, $eq8kl.default)(_classNames5, "".concat(prefixCls, "-center"), align === 'center'), (0, $eq8kl.default)(_classNames5, "".concat(prefixCls, "-end"), align === 'end'), (0, $eq8kl.default)(_classNames5, "".concat(prefixCls, "-simple"), simple), (0, $eq8kl.default)(_classNames5, "".concat(prefixCls, "-disabled"), disabled), _classNames5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("ul", (0, $hH60s.default)({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $00f15fc86371b572$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectPrefixCls: selectPrefixCls,
        changeSize: changePageSize,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton,
        showSizeChanger: showSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
$2875f86623519288$var$Pagination.displayName = 'Pagination';
var $2875f86623519288$export$2e2bcd8739ae039 = $2875f86623519288$var$Pagination;












parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");



parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $8e1b7f7b7891b9c8$var$genPaginationDisabledStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-disabled`]: {
            '&, &:hover': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            '&:focus-visible': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            }
        },
        [`&${componentCls}-disabled`]: {
            cursor: 'not-allowed',
            [`${componentCls}-item`]: {
                cursor: 'not-allowed',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                a: {
                    color: token.colorTextDisabled,
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'not-allowed'
                },
                '&-active': {
                    borderColor: token.colorBorder,
                    backgroundColor: token.itemActiveBgDisabled,
                    '&:hover, &:active': {
                        backgroundColor: token.itemActiveBgDisabled
                    },
                    a: {
                        color: token.itemActiveColorDisabled
                    }
                }
            },
            [`${componentCls}-item-link`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                [`${componentCls}-simple&`]: {
                    backgroundColor: 'transparent',
                    '&:hover, &:active': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                color: token.colorTextDisabled
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 0
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 1
                }
            }
        },
        [`&${componentCls}-simple`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&${componentCls}-disabled ${componentCls}-item-link`]: {
                    '&:hover, &:active': {
                        backgroundColor: 'transparent'
                    }
                }
            }
        }
    };
};
const $8e1b7f7b7891b9c8$var$genPaginationMiniStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-mini ${componentCls}-total-text, &${componentCls}-mini ${componentCls}-simple-pager`]: {
            height: token.itemSizeSM,
            lineHeight: (0, $4g3I0.unit)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-item`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $4g3I0.unit)(token.calc(token.itemSizeSM).sub(2).equal())
        },
        [`&${componentCls}-mini:not(${componentCls}-disabled) ${componentCls}-item:not(${componentCls}-item-active)`]: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            '&:hover': {
                backgroundColor: token.colorBgTextHover
            },
            '&:active': {
                backgroundColor: token.colorBgTextActive
            }
        },
        [`&${componentCls}-mini ${componentCls}-prev, &${componentCls}-mini ${componentCls}-next`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $4g3I0.unit)(token.itemSizeSM)
        },
        [`&${componentCls}-mini:not(${componentCls}-disabled)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:hover ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&:active ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextActive
                },
                [`&${componentCls}-disabled:hover ${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`
    &${componentCls}-mini ${componentCls}-prev ${componentCls}-item-link,
    &${componentCls}-mini ${componentCls}-next ${componentCls}-item-link
    `]: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            '&::after': {
                height: token.itemSizeSM,
                lineHeight: (0, $4g3I0.unit)(token.itemSizeSM)
            }
        },
        [`&${componentCls}-mini ${componentCls}-jump-prev, &${componentCls}-mini ${componentCls}-jump-next`]: {
            height: token.itemSizeSM,
            marginInlineEnd: 0,
            lineHeight: (0, $4g3I0.unit)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-options`]: {
            marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
            '&-size-changer': {
                top: token.miniOptionsSizeChangerTop
            },
            '&-quick-jumper': {
                height: token.itemSizeSM,
                lineHeight: (0, $4g3I0.unit)(token.itemSizeSM),
                input: Object.assign(Object.assign({}, (0, $47d23157ef40b741$export$bb047f62c5a56f90)(token)), {
                    width: token.paginationMiniQuickJumperInputWidth,
                    height: token.controlHeightSM
                })
            }
        }
    };
};
const $8e1b7f7b7891b9c8$var$genPaginationSimpleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`
    &${componentCls}-simple ${componentCls}-prev,
    &${componentCls}-simple ${componentCls}-next
    `]: {
            height: token.itemSizeSM,
            lineHeight: (0, $4g3I0.unit)(token.itemSizeSM),
            verticalAlign: 'top',
            [`${componentCls}-item-link`]: {
                height: token.itemSizeSM,
                backgroundColor: 'transparent',
                border: 0,
                '&:hover': {
                    backgroundColor: token.colorBgTextHover
                },
                '&:active': {
                    backgroundColor: token.colorBgTextActive
                },
                '&::after': {
                    height: token.itemSizeSM,
                    lineHeight: (0, $4g3I0.unit)(token.itemSizeSM)
                }
            }
        },
        [`&${componentCls}-simple ${componentCls}-simple-pager`]: {
            display: 'inline-block',
            height: token.itemSizeSM,
            marginInlineEnd: token.marginXS,
            input: {
                boxSizing: 'border-box',
                height: '100%',
                padding: `0 ${(0, $4g3I0.unit)(token.paginationItemPaddingInline)}`,
                textAlign: 'center',
                backgroundColor: token.itemInputBg,
                border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                borderRadius: token.borderRadius,
                outline: 'none',
                transition: `border-color ${token.motionDurationMid}`,
                color: 'inherit',
                '&:hover': {
                    borderColor: token.colorPrimary
                },
                '&:focus': {
                    borderColor: token.colorPrimaryHover,
                    boxShadow: `${(0, $4g3I0.unit)(token.inputOutlineOffset)} 0 ${(0, $4g3I0.unit)(token.controlOutlineWidth)} ${token.controlOutline}`
                },
                '&[disabled]': {
                    color: token.colorTextDisabled,
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    cursor: 'not-allowed'
                }
            }
        }
    };
};
const $8e1b7f7b7891b9c8$var$genPaginationJumpStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
            outline: 0,
            [`${componentCls}-item-container`]: {
                position: 'relative',
                [`${componentCls}-item-link-icon`]: {
                    color: token.colorPrimary,
                    fontSize: token.fontSizeSM,
                    opacity: 0,
                    transition: `all ${token.motionDurationMid}`,
                    '&-svg': {
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        margin: 'auto'
                    }
                },
                [`${componentCls}-item-ellipsis`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    display: 'block',
                    margin: 'auto',
                    color: token.colorTextDisabled,
                    letterSpacing: token.paginationEllipsisLetterSpacing,
                    textAlign: 'center',
                    textIndent: token.paginationEllipsisTextIndent,
                    opacity: 1,
                    transition: `all ${token.motionDurationMid}`
                }
            },
            '&:hover': {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 1
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 0
                }
            }
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            marginInlineEnd: token.marginXS
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            display: 'inline-block',
            minWidth: token.itemSize,
            height: token.itemSize,
            color: token.colorText,
            fontFamily: token.fontFamily,
            lineHeight: (0, $4g3I0.unit)(token.itemSize),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            borderRadius: token.borderRadius,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`
        },
        [`${componentCls}-prev, ${componentCls}-next`]: {
            outline: 0,
            button: {
                color: token.colorText,
                cursor: 'pointer',
                userSelect: 'none'
            },
            [`${componentCls}-item-link`]: {
                display: 'block',
                width: '100%',
                height: '100%',
                padding: 0,
                fontSize: token.fontSizeSM,
                textAlign: 'center',
                backgroundColor: 'transparent',
                border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} transparent`,
                borderRadius: token.borderRadius,
                outline: 'none',
                transition: `all ${token.motionDurationMid}`
            },
            [`&:hover ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextHover
            },
            [`&:active ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextActive
            },
            [`&${componentCls}-disabled:hover`]: {
                [`${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`${componentCls}-slash`]: {
            marginInlineEnd: token.paginationSlashMarginInlineEnd,
            marginInlineStart: token.paginationSlashMarginInlineStart
        },
        [`${componentCls}-options`]: {
            display: 'inline-block',
            marginInlineStart: token.margin,
            verticalAlign: 'middle',
            '&-size-changer': {
                display: 'inline-block',
                width: 'auto'
            },
            '&-quick-jumper': {
                display: 'inline-block',
                height: token.controlHeight,
                marginInlineStart: token.marginXS,
                lineHeight: (0, $4g3I0.unit)(token.controlHeight),
                verticalAlign: 'top',
                input: Object.assign(Object.assign(Object.assign({}, (0, $47d23157ef40b741$export$8c9a381315f3ebcd)(token)), (0, $e02010b1a8d4cc87$export$8c569e4cc3fd115f)(token, {
                    borderColor: token.colorBorder,
                    hoverBorderColor: token.colorPrimaryHover,
                    activeBorderColor: token.colorPrimary,
                    activeShadow: token.activeShadow
                })), {
                    '&[disabled]': Object.assign({}, (0, $e02010b1a8d4cc87$export$12789f962d420a93)(token)),
                    width: token.calc(token.controlHeightLG).mul(1.25).equal(),
                    height: token.controlHeight,
                    boxSizing: 'border-box',
                    margin: 0,
                    marginInlineStart: token.marginXS,
                    marginInlineEnd: token.marginXS
                })
            }
        }
    };
};
const $8e1b7f7b7891b9c8$var$genPaginationItemStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-item`]: {
            display: 'inline-block',
            minWidth: token.itemSize,
            height: token.itemSize,
            marginInlineEnd: token.marginXS,
            fontFamily: token.fontFamily,
            lineHeight: (0, $4g3I0.unit)(token.calc(token.itemSize).sub(2).equal()),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            backgroundColor: token.itemBg,
            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} transparent`,
            borderRadius: token.borderRadius,
            outline: 0,
            cursor: 'pointer',
            userSelect: 'none',
            a: {
                display: 'block',
                padding: `0 ${(0, $4g3I0.unit)(token.paginationItemPaddingInline)}`,
                color: token.colorText,
                '&:hover': {
                    textDecoration: 'none'
                }
            },
            [`&:not(${componentCls}-item-active)`]: {
                '&:hover': {
                    transition: `all ${token.motionDurationMid}`,
                    backgroundColor: token.colorBgTextHover
                },
                '&:active': {
                    backgroundColor: token.colorBgTextActive
                }
            },
            '&-active': {
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.itemActiveBg,
                borderColor: token.colorPrimary,
                a: {
                    color: token.colorPrimary
                },
                '&:hover': {
                    borderColor: token.colorPrimaryHover
                },
                '&:hover a': {
                    color: token.colorPrimaryHover
                }
            }
        }
    };
};
const $8e1b7f7b7891b9c8$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            display: 'flex',
            '&-start': {
                justifyContent: 'start'
            },
            '&-center': {
                justifyContent: 'center'
            },
            '&-end': {
                justifyContent: 'end'
            },
            'ul, ol': {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                overflow: 'hidden',
                visibility: 'hidden',
                content: '""'
            },
            [`${componentCls}-total-text`]: {
                display: 'inline-block',
                height: token.itemSize,
                marginInlineEnd: token.marginXS,
                lineHeight: (0, $4g3I0.unit)(token.calc(token.itemSize).sub(2).equal()),
                verticalAlign: 'middle'
            }
        }), $8e1b7f7b7891b9c8$var$genPaginationItemStyle(token)), $8e1b7f7b7891b9c8$var$genPaginationJumpStyle(token)), $8e1b7f7b7891b9c8$var$genPaginationSimpleStyle(token)), $8e1b7f7b7891b9c8$var$genPaginationMiniStyle(token)), $8e1b7f7b7891b9c8$var$genPaginationDisabledStyle(token)), {
            // media query style
            [`@media only screen and (max-width: ${token.screenLG}px)`]: {
                [`${componentCls}-item`]: {
                    '&-after-jump-prev, &-before-jump-next': {
                        display: 'none'
                    }
                }
            },
            [`@media only screen and (max-width: ${token.screenSM}px)`]: {
                [`${componentCls}-options`]: {
                    display: 'none'
                }
            }
        }),
        // rtl style
        [`&${token.componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
const $8e1b7f7b7891b9c8$var$genPaginationFocusStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled)`]: {
            [`${componentCls}-item`]: Object.assign({}, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)),
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                '&:focus-visible': Object.assign({
                    [`${componentCls}-item-link-icon`]: {
                        opacity: 1
                    },
                    [`${componentCls}-item-ellipsis`]: {
                        opacity: 0
                    }
                }, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token))
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:focus-visible ${componentCls}-item-link`]: Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token))
            }
        }
    };
};
const $8e1b7f7b7891b9c8$export$9ca1be8807fe0675 = (token)=>Object.assign({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemActiveBg: token.colorBgContainer,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0
    }, (0, $10e799cdff4a390c$export$bd8b682992bc9781)(token));
const $8e1b7f7b7891b9c8$export$362fb92a8f81bbf9 = (token)=>(0, $8APUt.merge)(token, {
        inputOutlineOffset: 0,
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginSM,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: '0.13em' // magic for ui experience
    }, (0, $10e799cdff4a390c$export$a157d95850191a12)(token));
var // ============================== Export ==============================
$8e1b7f7b7891b9c8$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Pagination', (token)=>{
    const paginationToken = $8e1b7f7b7891b9c8$export$362fb92a8f81bbf9(token);
    return [
        $8e1b7f7b7891b9c8$var$genPaginationStyle(paginationToken),
        $8e1b7f7b7891b9c8$var$genPaginationFocusStyle(paginationToken)
    ];
}, $8e1b7f7b7891b9c8$export$9ca1be8807fe0675);


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");


const $0788d0539f7ff50e$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
            '&, &:hover': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            '&:focus-visible': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            [`${componentCls}-item, ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    a: {
                        color: token.colorTextDisabled
                    }
                },
                [`&${componentCls}-item-active`]: {
                    backgroundColor: token.itemActiveBgDisabled
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    color: token.colorTextDisabled
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder
                }
            }
        },
        [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    borderColor: token.colorPrimaryHover,
                    backgroundColor: token.itemBg
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.itemLinkBg,
                    borderColor: token.colorBorder
                },
                [`&:hover ${componentCls}-item-link`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    color: token.colorPrimary
                },
                [`&${componentCls}-disabled`]: {
                    [`${componentCls}-item-link`]: {
                        borderColor: token.colorBorder,
                        color: token.colorTextDisabled
                    }
                }
            },
            [`${componentCls}-item`]: {
                backgroundColor: token.itemBg,
                border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    a: {
                        color: token.colorPrimary
                    }
                },
                '&-active': {
                    borderColor: token.colorPrimary
                }
            }
        }
    };
};
var $0788d0539f7ff50e$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$1537386bc155ea56)([
    'Pagination',
    'bordered'
], (token)=>{
    const paginationToken = (0, $8e1b7f7b7891b9c8$export$362fb92a8f81bbf9)(token);
    return [
        $0788d0539f7ff50e$var$genBorderedStyle(paginationToken)
    ];
}, (0, $8e1b7f7b7891b9c8$export$9ca1be8807fe0675));



var $jMaZ8 = parcelRequire("jMaZ8");
function $f958ca86d2f222d5$export$2e2bcd8739ae039(showSizeChanger) {
    return (0, $jMaZ8.useMemo)(()=>{
        if (typeof showSizeChanger === 'boolean') return [
            showSizeChanger,
            {}
        ];
        if (showSizeChanger && typeof showSizeChanger === 'object') return [
            true,
            showSizeChanger
        ];
        return [
            undefined,
            undefined
        ];
    }, [
        showSizeChanger
    ]);
}


"use client";
var $328dd787268866b4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $328dd787268866b4$var$Pagination = (props)=>{
    const { align: align, prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, locale: customLocale, responsive: responsive, showSizeChanger: showSizeChanger, selectComponentClass: selectComponentClass, pageSizeOptions: pageSizeOptions } = props, restProps = $328dd787268866b4$var$__rest(props, [
        "align",
        "prefixCls",
        "selectPrefixCls",
        "className",
        "rootClassName",
        "style",
        "size",
        "locale",
        "responsive",
        "showSizeChanger",
        "selectComponentClass",
        "pageSizeOptions"
    ]);
    const { xs: xs } = (0, $2bc364d47e670ed8$export$2e2bcd8739ae039)(responsive);
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const { getPrefixCls: getPrefixCls, direction: direction, pagination: pagination = {} } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8e1b7f7b7891b9c8$export$2e2bcd8739ae039)(prefixCls);
    // ============================== Size ==============================
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customizeSize);
    const isSmall = mergedSize === 'small' || !!(xs && !mergedSize && responsive);
    // ============================= Locale =============================
    const [contextLocale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Pagination', (0, $417359c043c5c735$export$2e2bcd8739ae039));
    const locale = Object.assign(Object.assign({}, contextLocale), customLocale);
    // ========================== Size Changer ==========================
    // Merge the props showSizeChanger
    const [propShowSizeChanger, propSizeChangerSelectProps] = (0, $f958ca86d2f222d5$export$2e2bcd8739ae039)(showSizeChanger);
    const [contextShowSizeChanger, contextSizeChangerSelectProps] = (0, $f958ca86d2f222d5$export$2e2bcd8739ae039)(pagination.showSizeChanger);
    const mergedShowSizeChanger = propShowSizeChanger !== null && propShowSizeChanger !== void 0 ? propShowSizeChanger : contextShowSizeChanger;
    const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps !== null && propSizeChangerSelectProps !== void 0 ? propSizeChangerSelectProps : contextSizeChangerSelectProps;
    const SizeChanger = selectComponentClass || (0, $71df08955277779f$export$2e2bcd8739ae039);
    // Generate options
    const mergedPageSizeOptions = $jMaZ8.useMemo(()=>{
        return pageSizeOptions ? pageSizeOptions.map((option)=>Number(option)) : undefined;
    }, [
        pageSizeOptions
    ]);
    // Render size changer
    const sizeChangerRender = (info)=>{
        var _a;
        const { disabled: disabled, size: pageSize, onSizeChange: onSizeChange, 'aria-label': ariaLabel, className: sizeChangerClassName, options: options } = info;
        const { className: propSizeChangerClassName, onChange: propSizeChangerOnChange } = mergedShowSizeChangerSelectProps || {};
        // Origin Select is using Select.Option,
        // So it make the option value must be string
        // Just for compatible
        const selectedValue = (_a = options.find((option)=>String(option.value) === String(pageSize))) === null || _a === void 0 ? void 0 : _a.value;
        return /*#__PURE__*/ $jMaZ8.createElement(SizeChanger, Object.assign({
            disabled: disabled,
            showSearch: true,
            popupMatchSelectWidth: false,
            getPopupContainer: (triggerNode)=>triggerNode.parentNode,
            "aria-label": ariaLabel,
            options: options
        }, mergedShowSizeChangerSelectProps, {
            value: selectedValue,
            onChange: (nextSize, option)=>{
                onSizeChange === null || onSizeChange === void 0 || onSizeChange(nextSize);
                propSizeChangerOnChange === null || propSizeChangerOnChange === void 0 || propSizeChangerOnChange(nextSize, option);
            },
            size: isSmall ? 'small' : 'middle',
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(sizeChangerClassName, propSizeChangerClassName)
        }));
    };
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Pagination');
        warning(!selectComponentClass, 'usage', '`selectComponentClass` is not official api which will be removed.');
    }
    // ============================= Render =============================
    const iconsProps = $jMaZ8.useMemo(()=>{
        const ellipsis = /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: `${prefixCls}-item-ellipsis`
        }, "\u2022\u2022\u2022");
        const prevIcon = /*#__PURE__*/ $jMaZ8.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $jMaZ8.createElement((0, $467563d24654b2cc$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $d4dfb236e126b509$export$2e2bcd8739ae039), null));
        const nextIcon = /*#__PURE__*/ $jMaZ8.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $jMaZ8.createElement((0, $d4dfb236e126b509$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $467563d24654b2cc$export$2e2bcd8739ae039), null));
        const jumpPrevIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $jMaZ8.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $jMaZ8.createElement((0, $1199127efb84781f$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $jMaZ8.createElement((0, $6e46ad2dd0f7d813$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        const jumpNextIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $jMaZ8.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $jMaZ8.createElement((0, $6e46ad2dd0f7d813$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $jMaZ8.createElement((0, $1199127efb84781f$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    const extendedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-${align}`]: !!align,
        [`${prefixCls}-mini`]: isSmall,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-bordered`]: token.wireframe
    }, pagination === null || pagination === void 0 ? void 0 : pagination.className, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, pagination === null || pagination === void 0 ? void 0 : pagination.style), style);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, token.wireframe && /*#__PURE__*/ $jMaZ8.createElement((0, $0788d0539f7ff50e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $2875f86623519288$export$2e2bcd8739ae039), Object.assign({}, iconsProps, restProps, {
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        locale: locale,
        pageSizeOptions: mergedPageSizeOptions,
        showSizeChanger: mergedShowSizeChanger,
        sizeChangerRender: sizeChangerRender
    }))));
};
$328dd787268866b4$var$Pagination.displayName = 'Pagination';
var $328dd787268866b4$export$2e2bcd8739ae039 = $328dd787268866b4$var$Pagination;


"use client";
var $029f538dfd4a9bcd$export$2e2bcd8739ae039 = (0, $328dd787268866b4$export$2e2bcd8739ae039);





var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
"use client";
function $1858097c912c7aac$var$renderExpandIcon(locale) {
    return (props)=>{
        const { prefixCls: prefixCls, onExpand: onExpand, record: record, expanded: expanded, expandable: expandable } = props;
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        return /*#__PURE__*/ $jMaZ8.createElement("button", {
            type: "button",
            onClick: (e)=>{
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(iconPrefix, {
                [`${iconPrefix}-spaced`]: !expandable,
                [`${iconPrefix}-expanded`]: expandable && expanded,
                [`${iconPrefix}-collapsed`]: expandable && !expanded
            }),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $1858097c912c7aac$export$2e2bcd8739ae039 = $1858097c912c7aac$var$renderExpandIcon;


function $778958d59a247c34$export$2e2bcd8739ae039(prefixCls) {
    const getContainerWidth = (ele, width)=>{
        const container = ele.querySelector(`.${prefixCls}-container`);
        let returnWidth = width;
        if (container) {
            const style = getComputedStyle(container);
            const borderLeft = parseInt(style.borderLeftWidth, 10);
            const borderRight = parseInt(style.borderRightWidth, 10);
            returnWidth = width - borderLeft - borderRight;
        }
        return returnWidth;
    };
    return getContainerWidth;
}



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

const $9b33cf6cc3cffdfa$export$480219a02f196e72 = (column, defaultKey)=>{
    if ('key' in column && column.key !== undefined && column.key !== null) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
    return defaultKey;
};
function $9b33cf6cc3cffdfa$export$7e4db04adce9b4db(index, pos) {
    return pos ? `${pos}-${index}` : `${index}`;
}
const $9b33cf6cc3cffdfa$export$cfda450db2088de7 = (title, props)=>{
    if (typeof title === 'function') return title(props);
    return title;
};
const $9b33cf6cc3cffdfa$export$1c24e0676a106839 = (title, props)=>{
    const res = $9b33cf6cc3cffdfa$export$cfda450db2088de7(title, props);
    if (Object.prototype.toString.call(res) === '[object Object]') return '';
    return res;
};



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $10d44188391a2ddf$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
var $10d44188391a2ddf$export$2e2bcd8739ae039 = $10d44188391a2ddf$var$FilterFilled;



var $9eb02aef8556d98a$var$FilterFilled = function FilterFilled(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $10d44188391a2ddf$export$2e2bcd8739ae039)
    }));
};
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0OSA4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNjQySDM0OXYxOTZ6bTUzMS4xLTY4NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4bDIyMS4zIDM3NmgzNDguOGwyMjEuMy0zNzZjMTIuMS0yMS4zLTMuMi00OC0yNy43LTQ4eiIgLz48L3N2Zz4=) */ var $9eb02aef8556d98a$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($9eb02aef8556d98a$var$FilterFilled);
$9eb02aef8556d98a$var$RefIcon.displayName = 'FilterFilled';
var $9eb02aef8556d98a$export$2e2bcd8739ae039 = $9eb02aef8556d98a$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $9O5K3 = parcelRequire("9O5K3");
const $d74635dfa3f27b0f$var$extendsObject = function() {
    const result = Object.assign({}, arguments.length <= 0 ? undefined : arguments[0]);
    for(let i = 1; i < arguments.length; i++){
        const obj = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (obj) Object.keys(obj).forEach((key)=>{
            const val = obj[key];
            if (val !== undefined) result[key] = val;
        });
    }
    return result;
};
var $d74635dfa3f27b0f$export$2e2bcd8739ae039 = $d74635dfa3f27b0f$var$extendsObject;



var $jMaZ8 = parcelRequire("jMaZ8");

function $3ce26919fd03658c$export$2e2bcd8739ae039(initialValue) {
    const ref = $jMaZ8.useRef(initialValue);
    const forceUpdate = (0, $3b33849fb1ac9a25$export$2e2bcd8739ae039)();
    return [
        ()=>ref.current,
        (newValue)=>{
            ref.current = newValue;
            // re-render
            forceUpdate();
        }
    ];
}












var $hH60s = parcelRequire("hH60s");

var $1Esi2 = parcelRequire("1Esi2");

var $8u3qN = parcelRequire("8u3qN");

var $fvBso = parcelRequire("fvBso");

var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $e4nJa = parcelRequire("e4nJa");

var $7eK0y = parcelRequire("7eK0y");

var $fwNdX = parcelRequire("fwNdX");

var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");



var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");
var $1ea0a2cc1631a549$var$DropIndicator = function DropIndicator(props) {
    var dropPosition = props.dropPosition, dropLevelOffset = props.dropLevelOffset, indent = props.indent;
    var style = {
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        backgroundColor: 'red',
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        style: style
    });
};
$1ea0a2cc1631a549$var$DropIndicator.displayName = 'DropIndicator';
var $1ea0a2cc1631a549$export$2e2bcd8739ae039 = $1ea0a2cc1631a549$var$DropIndicator;



var $hH60s = parcelRequire("hH60s");
function $3714f1e976001843$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}



var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jLTp6 = parcelRequire("jLTp6");


var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");


var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");

var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");



var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jLTp6 = parcelRequire("jLTp6");
/**
 * Trigger only when component unmount
 */ function $8dd1b9f8b69dee1c$var$useUnmount(triggerStart, triggerEnd) {
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), firstMount = _React$useState2[0], setFirstMount = _React$useState2[1];
    (0, $jLTp6.default)(function() {
        if (firstMount) {
            triggerStart();
            return function() {
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    (0, $jLTp6.default)(function() {
        setFirstMount(true);
        return function() {
            setFirstMount(false);
        };
    }, []);
}
var $8dd1b9f8b69dee1c$export$2e2bcd8739ae039 = $8dd1b9f8b69dee1c$var$useUnmount;



var $6706edb7c48017d8$var$_excluded = [
    "className",
    "style",
    "motion",
    "motionNodes",
    "motionType",
    "onMotionStart",
    "onMotionEnd",
    "active",
    "treeNodeRequiredProps"
];
var $6706edb7c48017d8$var$MotionTreeNode = /*#__PURE__*/ $jMaZ8.forwardRef(function(oriProps, ref) {
    var className = oriProps.className, style = oriProps.style, motion = oriProps.motion, motionNodes = oriProps.motionNodes, motionType = oriProps.motionType, onOriginMotionStart = oriProps.onMotionStart, onOriginMotionEnd = oriProps.onMotionEnd, active = oriProps.active, treeNodeRequiredProps = oriProps.treeNodeRequiredProps, props = (0, $4b02Q.default)(oriProps, $6706edb7c48017d8$var$_excluded);
    var _React$useState = $jMaZ8.useState(true), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    var _React$useContext = $jMaZ8.useContext((0, $ac33c98905104d8a$export$dfae7d399eea2568)), prefixCls = _React$useContext.prefixCls;
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    var targetVisible = motionNodes && motionType !== 'hide';
    (0, $jLTp6.default)(function() {
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    var triggerMotionStart = function triggerMotionStart() {
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    var triggerMotionEndRef = $jMaZ8.useRef(false);
    var triggerMotionEnd = function triggerMotionEnd() {
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $8dd1b9f8b69dee1c$export$2e2bcd8739ae039)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    var onVisibleChanged = function onVisibleChanged(nextVisible) {
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), (0, $hH60s.default)({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === 'show',
        onVisibleChanged: onVisibleChanged
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            ref: motionRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-treenode-motion"), motionClassName),
            style: motionStyle
        }, motionNodes.map(function(treeNode) {
            var restProps = Object.assign({}, ((0, $3714f1e976001843$export$2e2bcd8739ae039)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
            delete restProps.children;
            var treeNodeProps = (0, $a2876523b8e415d4$export$d961fd523a514db5)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $jMaZ8.createElement((0, $422a8a4f6c7c8b88$export$2e2bcd8739ae039), (0, $hH60s.default)({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        }));
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $422a8a4f6c7c8b88$export$2e2bcd8739ae039), (0, $hH60s.default)({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
});
$6706edb7c48017d8$var$MotionTreeNode.displayName = 'MotionTreeNode';
var $6706edb7c48017d8$export$2e2bcd8739ae039 = $6706edb7c48017d8$var$MotionTreeNode;


function $67f5b5b58ecb8907$export$d561f9b5d6be9236() {
    var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var prevLen = prev.length;
    var nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        var cache = new Map();
        shorter.forEach(function(key) {
            cache.set(key, true);
        });
        var keys = longer.filter(function(key) {
            return !cache.has(key);
        });
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $67f5b5b58ecb8907$export$d9cfb1169163442d(shorter, longer, key) {
    var shorterStartIndex = shorter.findIndex(function(data) {
        return data.key === key;
    });
    var shorterEndNode = shorter[shorterStartIndex + 1];
    var longerStartIndex = longer.findIndex(function(data) {
        return data.key === key;
    });
    if (shorterEndNode) {
        var longerEndIndex = longer.findIndex(function(data) {
            return data.key === shorterEndNode.key;
        });
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}



var $eab9beaeaa638f28$var$_excluded = [
    "prefixCls",
    "data",
    "selectable",
    "checkable",
    "expandedKeys",
    "selectedKeys",
    "checkedKeys",
    "loadedKeys",
    "loadingKeys",
    "halfCheckedKeys",
    "keyEntities",
    "disabled",
    "dragging",
    "dragOverNodeKey",
    "dropPosition",
    "motion",
    "height",
    "itemHeight",
    "virtual",
    "scrollWidth",
    "focusable",
    "activeItem",
    "focused",
    "tabIndex",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onActiveChange",
    "onListChangeStart",
    "onListChangeEnd"
];
var $eab9beaeaa638f28$var$HIDDEN_STYLE = {
    width: 0,
    height: 0,
    display: 'flex',
    overflow: 'hidden',
    opacity: 0,
    border: 0,
    padding: 0,
    margin: 0
};
var $eab9beaeaa638f28$var$noop = function noop() {};
var $eab9beaeaa638f28$export$17c02cdd52a7d889 = "RC_TREE_MOTION_".concat(Math.random());
var $eab9beaeaa638f28$var$MotionNode = {
    key: $eab9beaeaa638f28$export$17c02cdd52a7d889
};
var $eab9beaeaa638f28$export$2d18abad5109a402 = {
    key: $eab9beaeaa638f28$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: '0',
    node: $eab9beaeaa638f28$var$MotionNode,
    nodes: [
        $eab9beaeaa638f28$var$MotionNode
    ]
};
var $eab9beaeaa638f28$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $eab9beaeaa638f28$export$2d18abad5109a402.pos,
    data: $eab9beaeaa638f28$var$MotionNode,
    title: null,
    key: $eab9beaeaa638f28$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $eab9beaeaa638f28$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $eab9beaeaa638f28$var$itemKey(item) {
    var key = item.key, pos = item.pos;
    return (0, $a2876523b8e415d4$export$a47fb462a08de82f)(key, pos);
}
function $eab9beaeaa638f28$var$getAccessibilityPath(item) {
    var path = String(item.data.key);
    var current = item;
    while(current.parent){
        current = current.parent;
        path = "".concat(current.data.key, " > ").concat(path);
    }
    return path;
}
var $eab9beaeaa638f28$var$NodeList = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, data = props.data, selectable = props.selectable, checkable = props.checkable, expandedKeys = props.expandedKeys, selectedKeys = props.selectedKeys, checkedKeys = props.checkedKeys, loadedKeys = props.loadedKeys, loadingKeys = props.loadingKeys, halfCheckedKeys = props.halfCheckedKeys, keyEntities = props.keyEntities, disabled = props.disabled, dragging = props.dragging, dragOverNodeKey = props.dragOverNodeKey, dropPosition = props.dropPosition, motion = props.motion, height = props.height, itemHeight = props.itemHeight, virtual = props.virtual, scrollWidth = props.scrollWidth, focusable = props.focusable, activeItem = props.activeItem, focused = props.focused, tabIndex = props.tabIndex, onKeyDown = props.onKeyDown, onFocus = props.onFocus, onBlur = props.onBlur, onActiveChange = props.onActiveChange, onListChangeStart = props.onListChangeStart, onListChangeEnd = props.onListChangeEnd, domProps = (0, $4b02Q.default)(props, $eab9beaeaa638f28$var$_excluded);
    // =============================== Ref ================================
    var listRef = $jMaZ8.useRef(null);
    var indentMeasurerRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            scrollTo: function scrollTo(scroll) {
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: function getIndentWidth() {
                return indentMeasurerRef.current.offsetWidth;
            }
        };
    });
    // ============================== Motion ==============================
    var _React$useState = $jMaZ8.useState(expandedKeys), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), prevExpandedKeys = _React$useState2[0], setPrevExpandedKeys = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(data), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), prevData = _React$useState4[0], setPrevData = _React$useState4[1];
    var _React$useState5 = $jMaZ8.useState(data), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), transitionData = _React$useState6[0], setTransitionData = _React$useState6[1];
    var _React$useState7 = $jMaZ8.useState([]), _React$useState8 = (0, $3fkx6.default)(_React$useState7, 2), transitionRange = _React$useState8[0], setTransitionRange = _React$useState8[1];
    var _React$useState9 = $jMaZ8.useState(null), _React$useState10 = (0, $3fkx6.default)(_React$useState9, 2), motionType = _React$useState10[0], setMotionType = _React$useState10[1];
    // When motion end but data change, this will makes data back to previous one
    var dataRef = $jMaZ8.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        var latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $jLTp6.default)(function() {
        setPrevExpandedKeys(expandedKeys);
        var diffExpanded = (0, $67f5b5b58ecb8907$export$d561f9b5d6be9236)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                var keyIndex = prevData.findIndex(function(_ref) {
                    var key = _ref.key;
                    return key === diffExpanded.key;
                });
                var rangeNodes = $eab9beaeaa638f28$export$435bacc8d7a01e14((0, $67f5b5b58ecb8907$export$d9cfb1169163442d)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                var newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $eab9beaeaa638f28$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('show');
            } else {
                var _keyIndex = data.findIndex(function(_ref2) {
                    var key = _ref2.key;
                    return key === diffExpanded.key;
                });
                var _rangeNodes = $eab9beaeaa638f28$export$435bacc8d7a01e14((0, $67f5b5b58ecb8907$export$d9cfb1169163442d)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                var _newTransitionData = data.slice();
                _newTransitionData.splice(_keyIndex + 1, 0, $eab9beaeaa638f28$var$MotionFlattenData);
                setTransitionData(_newTransitionData);
                setTransitionRange(_rangeNodes);
                setMotionType('hide');
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $jMaZ8.useEffect(function() {
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    var mergedData = motion ? transitionData : data;
    var treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, focused && activeItem && /*#__PURE__*/ $jMaZ8.createElement("span", {
        style: $eab9beaeaa638f28$var$HIDDEN_STYLE,
        "aria-live": "assertive"
    }, $eab9beaeaa638f28$var$getAccessibilityPath(activeItem)), /*#__PURE__*/ $jMaZ8.createElement("div", null, /*#__PURE__*/ $jMaZ8.createElement("input", {
        style: $eab9beaeaa638f28$var$HIDDEN_STYLE,
        disabled: focusable === false || disabled,
        tabIndex: focusable !== false ? tabIndex : null,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        value: "",
        onChange: $eab9beaeaa638f28$var$noop,
        "aria-label": "for screen reader"
    })), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(prefixCls, "-treenode"),
        "aria-hidden": true,
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            visibility: 'hidden',
            height: 0,
            overflow: 'hidden',
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(prefixCls, "-indent")
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: indentMeasurerRef,
        className: "".concat(prefixCls, "-indent-unit")
    }))), /*#__PURE__*/ $jMaZ8.createElement((0, $d69541228a77891f$export$2e2bcd8739ae039), (0, $hH60s.default)({}, domProps, {
        data: mergedData,
        itemKey: $eab9beaeaa638f28$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        scrollWidth: scrollWidth,
        prefixCls: "".concat(prefixCls, "-list"),
        ref: listRef,
        role: "tree",
        onVisibleChange: function onVisibleChange(originList) {
            // The best match is using `fullList` - `originList` = `restList`
            // and check the `restList` to see if has the MOTION_KEY node
            // but this will cause performance issue for long list compare
            // we just check `originList` and repeat trigger `onMotionEnd`
            if (originList.every(function(item) {
                return $eab9beaeaa638f28$var$itemKey(item) !== $eab9beaeaa638f28$export$17c02cdd52a7d889;
            })) onMotionEnd();
        }
    }), function(treeNode) {
        var pos = treeNode.pos, restProps = Object.assign({}, ((0, $3714f1e976001843$export$2e2bcd8739ae039)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
        var mergedKey = (0, $a2876523b8e415d4$export$a47fb462a08de82f)(key, pos);
        delete restProps.key;
        delete restProps.children;
        var treeNodeProps = (0, $a2876523b8e415d4$export$d961fd523a514db5)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $jMaZ8.createElement((0, $6706edb7c48017d8$export$2e2bcd8739ae039), (0, $hH60s.default)({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $eab9beaeaa638f28$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            onMouseMove: function onMouseMove() {
                onActiveChange(null);
            }
        }));
    }));
});
$eab9beaeaa638f28$var$NodeList.displayName = 'NodeList';
var $eab9beaeaa638f28$export$2e2bcd8739ae039 = $eab9beaeaa638f28$var$NodeList;







var $35788aa3d6a30576$var$MAX_RETRY_TIMES = 10;
var $35788aa3d6a30576$var$Tree = /*#__PURE__*/ function(_React$Component) {
    (0, $7eK0y.default)(Tree, _React$Component);
    var _super = (0, $fwNdX.default)(Tree);
    function Tree() {
        var _this;
        (0, $klxbl.default)(this, Tree);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "destroyed", false);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "delayedDragEnterLogic", void 0);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "loadingRetryTimes", {});
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "state", {
            keyEntities: {},
            indent: null,
            selectedKeys: [],
            checkedKeys: [],
            halfCheckedKeys: [],
            loadedKeys: [],
            loadingKeys: [],
            expandedKeys: [],
            draggingNodeKey: null,
            dragChildrenKeys: [],
            // dropTargetKey is the key of abstract-drop-node
            // the abstract-drop-node is the real drop node when drag and drop
            // not the DOM drag over node
            dropTargetKey: null,
            dropPosition: null,
            // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
            dropContainerKey: null,
            // the container key of abstract-drop-node if dropPosition is -1 or 1
            dropLevelOffset: null,
            // the drop level offset of abstract-drag-over-node
            dropTargetPos: null,
            // the pos of abstract-drop-node
            dropAllowed: true,
            // if drop to abstract-drop-node is allowed
            // the abstract-drag-over-node
            // if mouse is on the bottom of top dom node or no the top of the bottom dom node
            // abstract-drag-over-node is the top node
            dragOverNodeKey: null,
            treeData: [],
            flattenNodes: [],
            focused: false,
            activeKey: null,
            listChanging: false,
            prevProps: null,
            fieldNames: (0, $a2876523b8e415d4$export$6c519d302dced239)()
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "dragStartMousePosition", null);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "dragNodeProps", null);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "currentMouseOverDroppableNodeKey", null);
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "listRef", /*#__PURE__*/ $jMaZ8.createRef());
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeDragStart", function(event, nodeProps) {
            var _this$state = _this.state, expandedKeys = _this$state.expandedKeys, keyEntities = _this$state.keyEntities;
            var onDragStart = _this.props.onDragStart;
            var eventKey = nodeProps.eventKey;
            _this.dragNodeProps = nodeProps;
            _this.dragStartMousePosition = {
                x: event.clientX,
                y: event.clientY
            };
            var newExpandedKeys = (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(expandedKeys, eventKey);
            _this.setState({
                draggingNodeKey: eventKey,
                dragChildrenKeys: (0, $9c953ffa830afa28$export$b0610c44bcbb051c)(eventKey, keyEntities),
                indent: _this.listRef.current.getIndentWidth()
            });
            _this.setExpandedKeys(newExpandedKeys);
            window.addEventListener('dragend', _this.onWindowDragEnd);
            onDragStart === null || onDragStart === void 0 || onDragStart({
                event: event,
                node: (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(nodeProps)
            });
        });
        /**
     * [Legacy] Select handler is smaller than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */ (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeDragEnter", function(event, nodeProps) {
            var _this$state2 = _this.state, expandedKeys = _this$state2.expandedKeys, keyEntities = _this$state2.keyEntities, dragChildrenKeys = _this$state2.dragChildrenKeys, flattenNodes = _this$state2.flattenNodes, indent = _this$state2.indent;
            var _this$props = _this.props, onDragEnter = _this$props.onDragEnter, onExpand = _this$props.onExpand, allowDrop = _this$props.allowDrop, direction = _this$props.direction;
            var pos = nodeProps.pos, eventKey = nodeProps.eventKey;
            // record the key of node which is latest entered, used in dragleave event.
            if (_this.currentMouseOverDroppableNodeKey !== eventKey) _this.currentMouseOverDroppableNodeKey = eventKey;
            if (!_this.dragNodeProps) {
                _this.resetDragState();
                return;
            }
            var _calcDropPosition = (0, $9c953ffa830afa28$export$78a5519d0fb779c3)(event, _this.dragNodeProps, nodeProps, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition.dropPosition, dropLevelOffset = _calcDropPosition.dropLevelOffset, dropTargetKey = _calcDropPosition.dropTargetKey, dropContainerKey = _calcDropPosition.dropContainerKey, dropTargetPos = _calcDropPosition.dropTargetPos, dropAllowed = _calcDropPosition.dropAllowed, dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
            if (// don't allow drop inside its children
            dragChildrenKeys.includes(dropTargetKey) || // don't allow drop when drop is not allowed caculated by calcDropPosition
            !dropAllowed) {
                _this.resetDragState();
                return;
            }
            // Side effect for delay drag
            if (!_this.delayedDragEnterLogic) _this.delayedDragEnterLogic = {};
            Object.keys(_this.delayedDragEnterLogic).forEach(function(key) {
                clearTimeout(_this.delayedDragEnterLogic[key]);
            });
            if (_this.dragNodeProps.eventKey !== nodeProps.eventKey) {
                // hoist expand logic here
                // since if logic is on the bottom
                // it will be blocked by abstract dragover node check
                //   => if you dragenter from top, you mouse will still be consider as in the top node
                event.persist();
                _this.delayedDragEnterLogic[pos] = window.setTimeout(function() {
                    if (_this.state.draggingNodeKey === null) return;
                    var newExpandedKeys = (0, $fvBso.default)(expandedKeys);
                    var entity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, nodeProps.eventKey);
                    if (entity && (entity.children || []).length) newExpandedKeys = (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(expandedKeys, nodeProps.eventKey);
                    if (!_this.props.hasOwnProperty('expandedKeys')) _this.setExpandedKeys(newExpandedKeys);
                    onExpand === null || onExpand === void 0 || onExpand(newExpandedKeys, {
                        node: (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(nodeProps),
                        expanded: true,
                        nativeEvent: event.nativeEvent
                    });
                }, 800);
            }
            // Skip if drag node is self
            if (_this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
                _this.resetDragState();
                return;
            }
            // Update drag over node and drag state
            _this.setState({
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed
            });
            onDragEnter === null || onDragEnter === void 0 || onDragEnter({
                event: event,
                node: (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(nodeProps),
                expandedKeys: expandedKeys
            });
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeDragOver", function(event, nodeProps) {
            var _this$state3 = _this.state, dragChildrenKeys = _this$state3.dragChildrenKeys, flattenNodes = _this$state3.flattenNodes, keyEntities = _this$state3.keyEntities, expandedKeys = _this$state3.expandedKeys, indent = _this$state3.indent;
            var _this$props2 = _this.props, onDragOver = _this$props2.onDragOver, allowDrop = _this$props2.allowDrop, direction = _this$props2.direction;
            if (!_this.dragNodeProps) return;
            var _calcDropPosition2 = (0, $9c953ffa830afa28$export$78a5519d0fb779c3)(event, _this.dragNodeProps, nodeProps, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition2.dropPosition, dropLevelOffset = _calcDropPosition2.dropLevelOffset, dropTargetKey = _calcDropPosition2.dropTargetKey, dropContainerKey = _calcDropPosition2.dropContainerKey, dropTargetPos = _calcDropPosition2.dropTargetPos, dropAllowed = _calcDropPosition2.dropAllowed, dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
            if (dragChildrenKeys.includes(dropTargetKey) || !dropAllowed) // don't allow drop inside its children
            // don't allow drop when drop is not allowed calculated by calcDropPosition
            return;
            // Update drag position
            if (_this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
                if (!(_this.state.dropPosition === null && _this.state.dropLevelOffset === null && _this.state.dropTargetKey === null && _this.state.dropContainerKey === null && _this.state.dropTargetPos === null && _this.state.dropAllowed === false && _this.state.dragOverNodeKey === null)) _this.resetDragState();
            } else if (!(dropPosition === _this.state.dropPosition && dropLevelOffset === _this.state.dropLevelOffset && dropTargetKey === _this.state.dropTargetKey && dropContainerKey === _this.state.dropContainerKey && dropTargetPos === _this.state.dropTargetPos && dropAllowed === _this.state.dropAllowed && dragOverNodeKey === _this.state.dragOverNodeKey)) _this.setState({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed,
                dragOverNodeKey: dragOverNodeKey
            });
            onDragOver === null || onDragOver === void 0 || onDragOver({
                event: event,
                node: (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(nodeProps)
            });
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeDragLeave", function(event, nodeProps) {
            // if it is outside the droppable area
            // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
            if (_this.currentMouseOverDroppableNodeKey === nodeProps.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
                _this.resetDragState();
                _this.currentMouseOverDroppableNodeKey = null;
            }
            var onDragLeave = _this.props.onDragLeave;
            onDragLeave === null || onDragLeave === void 0 || onDragLeave({
                event: event,
                node: (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(nodeProps)
            });
        });
        // since stopPropagation() is called in treeNode
        // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onWindowDragEnd", function(event) {
            _this.onNodeDragEnd(event, null, true);
            window.removeEventListener('dragend', _this.onWindowDragEnd);
        });
        // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeDragEnd", function(event, nodeProps) {
            var onDragEnd = _this.props.onDragEnd;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                event: event,
                node: (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(nodeProps)
            });
            _this.dragNodeProps = null;
            window.removeEventListener('dragend', _this.onWindowDragEnd);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeDrop", function(event, _) {
            var _this$getActiveItem;
            var outsideTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var _this$state4 = _this.state, dragChildrenKeys = _this$state4.dragChildrenKeys, dropPosition = _this$state4.dropPosition, dropTargetKey = _this$state4.dropTargetKey, dropTargetPos = _this$state4.dropTargetPos, dropAllowed = _this$state4.dropAllowed;
            if (!dropAllowed) return;
            var onDrop = _this.props.onDrop;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            if (dropTargetKey === null) return;
            var abstractDropNodeProps = (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $a2876523b8e415d4$export$d961fd523a514db5)(dropTargetKey, _this.getTreeNodeRequiredProps())), {}, {
                active: ((_this$getActiveItem = _this.getActiveItem()) === null || _this$getActiveItem === void 0 ? void 0 : _this$getActiveItem.key) === dropTargetKey,
                data: (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(_this.state.keyEntities, dropTargetKey).node
            });
            var dropToChild = dragChildrenKeys.includes(dropTargetKey);
            (0, $2bFmQ.default)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
            var posArr = (0, $9c953ffa830afa28$export$ddaee97dc8907312)(dropTargetPos);
            var dropResult = {
                event: event,
                node: (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(abstractDropNodeProps),
                dragNode: _this.dragNodeProps ? (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)(_this.dragNodeProps) : null,
                dragNodesKeys: [
                    _this.dragNodeProps.eventKey
                ].concat(dragChildrenKeys),
                dropToGap: dropPosition !== 0,
                dropPosition: dropPosition + Number(posArr[posArr.length - 1])
            };
            if (!outsideTree) onDrop === null || onDrop === void 0 || onDrop(dropResult);
            _this.dragNodeProps = null;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "cleanDragState", function() {
            var draggingNodeKey = _this.state.draggingNodeKey;
            if (draggingNodeKey !== null) _this.setState({
                draggingNodeKey: null,
                dropPosition: null,
                dropContainerKey: null,
                dropTargetKey: null,
                dropLevelOffset: null,
                dropAllowed: true,
                dragOverNodeKey: null
            });
            _this.dragStartMousePosition = null;
            _this.currentMouseOverDroppableNodeKey = null;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "triggerExpandActionExpand", function(e, treeNode) {
            var _this$state5 = _this.state, expandedKeys = _this$state5.expandedKeys, flattenNodes = _this$state5.flattenNodes;
            var expanded = treeNode.expanded, key = treeNode.key, isLeaf = treeNode.isLeaf;
            if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
            var node = flattenNodes.filter(function(nodeItem) {
                return nodeItem.key === key;
            })[0];
            var eventNode = (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)((0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $a2876523b8e415d4$export$d961fd523a514db5)(key, _this.getTreeNodeRequiredProps())), {}, {
                data: node.data
            }));
            _this.setExpandedKeys(expanded ? (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(expandedKeys, key) : (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(expandedKeys, key));
            _this.onNodeExpand(e, eventNode);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeClick", function(e, treeNode) {
            var _this$props3 = _this.props, onClick = _this$props3.onClick, expandAction = _this$props3.expandAction;
            if (expandAction === 'click') _this.triggerExpandActionExpand(e, treeNode);
            onClick === null || onClick === void 0 || onClick(e, treeNode);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeDoubleClick", function(e, treeNode) {
            var _this$props4 = _this.props, onDoubleClick = _this$props4.onDoubleClick, expandAction = _this$props4.expandAction;
            if (expandAction === 'doubleClick') _this.triggerExpandActionExpand(e, treeNode);
            onDoubleClick === null || onDoubleClick === void 0 || onDoubleClick(e, treeNode);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeSelect", function(e, treeNode) {
            var selectedKeys = _this.state.selectedKeys;
            var _this$state6 = _this.state, keyEntities = _this$state6.keyEntities, fieldNames = _this$state6.fieldNames;
            var _this$props5 = _this.props, onSelect = _this$props5.onSelect, multiple = _this$props5.multiple;
            var selected = treeNode.selected;
            var key = treeNode[fieldNames.key];
            var targetSelected = !selected;
            // Update selected keys
            if (!targetSelected) selectedKeys = (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(selectedKeys, key);
            else if (!multiple) selectedKeys = [
                key
            ];
            else selectedKeys = (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(selectedKeys, key);
            // [Legacy] Not found related usage in doc or upper libs
            var selectedNodes = selectedKeys.map(function(selectedKey) {
                var entity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, selectedKey);
                return entity ? entity.node : null;
            }).filter(Boolean);
            _this.setUncontrolledState({
                selectedKeys: selectedKeys
            });
            onSelect === null || onSelect === void 0 || onSelect(selectedKeys, {
                event: 'select',
                selected: targetSelected,
                node: treeNode,
                selectedNodes: selectedNodes,
                nativeEvent: e.nativeEvent
            });
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeCheck", function(e, treeNode, checked) {
            var _this$state7 = _this.state, keyEntities = _this$state7.keyEntities, oriCheckedKeys = _this$state7.checkedKeys, oriHalfCheckedKeys = _this$state7.halfCheckedKeys;
            var _this$props6 = _this.props, checkStrictly = _this$props6.checkStrictly, onCheck = _this$props6.onCheck;
            var key = treeNode.key;
            // Prepare trigger arguments
            var checkedObj;
            var eventObj = {
                event: 'check',
                node: treeNode,
                checked: checked,
                nativeEvent: e.nativeEvent
            };
            if (checkStrictly) {
                var checkedKeys = checked ? (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(oriCheckedKeys, key) : (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(oriCheckedKeys, key);
                var halfCheckedKeys = (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(oriHalfCheckedKeys, key);
                checkedObj = {
                    checked: checkedKeys,
                    halfChecked: halfCheckedKeys
                };
                eventObj.checkedNodes = checkedKeys.map(function(checkedKey) {
                    return (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                }).filter(Boolean).map(function(entity) {
                    return entity.node;
                });
                _this.setUncontrolledState({
                    checkedKeys: checkedKeys
                });
            } else {
                // Always fill first
                var _conductCheck = (0, $4171d50fadf9ef5d$export$43adf2c483e3e633)([].concat((0, $fvBso.default)(oriCheckedKeys), [
                    key
                ]), true, keyEntities), _checkedKeys = _conductCheck.checkedKeys, _halfCheckedKeys = _conductCheck.halfCheckedKeys;
                // If remove, we do it again to correction
                if (!checked) {
                    var keySet = new Set(_checkedKeys);
                    keySet.delete(key);
                    var _conductCheck2 = (0, $4171d50fadf9ef5d$export$43adf2c483e3e633)(Array.from(keySet), {
                        checked: false,
                        halfCheckedKeys: _halfCheckedKeys
                    }, keyEntities);
                    _checkedKeys = _conductCheck2.checkedKeys;
                    _halfCheckedKeys = _conductCheck2.halfCheckedKeys;
                }
                checkedObj = _checkedKeys;
                // [Legacy] This is used for `rc-tree-select`
                eventObj.checkedNodes = [];
                eventObj.checkedNodesPositions = [];
                eventObj.halfCheckedKeys = _halfCheckedKeys;
                _checkedKeys.forEach(function(checkedKey) {
                    var entity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                    if (!entity) return;
                    var node = entity.node, pos = entity.pos;
                    eventObj.checkedNodes.push(node);
                    eventObj.checkedNodesPositions.push({
                        node: node,
                        pos: pos
                    });
                });
                _this.setUncontrolledState({
                    checkedKeys: _checkedKeys
                }, false, {
                    halfCheckedKeys: _halfCheckedKeys
                });
            }
            onCheck === null || onCheck === void 0 || onCheck(checkedObj, eventObj);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeLoad", function(treeNode) {
            var _entity$children;
            var key = treeNode.key;
            var keyEntities = _this.state.keyEntities;
            // Skip if has children already
            var entity = (0, $0f4e6a50c0fa4e30$export$2e2bcd8739ae039)(keyEntities, key);
            if (entity !== null && entity !== void 0 && (_entity$children = entity.children) !== null && _entity$children !== void 0 && _entity$children.length) return;
            var loadPromise = new Promise(function(resolve, reject) {
                // We need to get the latest state of loading/loaded keys
                _this.setState(function(_ref) {
                    var _ref$loadedKeys = _ref.loadedKeys, loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys, _ref$loadingKeys = _ref.loadingKeys, loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
                    var _this$props7 = _this.props, loadData = _this$props7.loadData, onLoad = _this$props7.onLoad;
                    if (!loadData || loadedKeys.includes(key) || loadingKeys.includes(key)) return null;
                    // Process load data
                    var promise = loadData(treeNode);
                    promise.then(function() {
                        var currentLoadedKeys = _this.state.loadedKeys;
                        var newLoadedKeys = (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(currentLoadedKeys, key);
                        // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                        // https://github.com/ant-design/ant-design/issues/12464
                        onLoad === null || onLoad === void 0 || onLoad(newLoadedKeys, {
                            event: 'load',
                            node: treeNode
                        });
                        _this.setUncontrolledState({
                            loadedKeys: newLoadedKeys
                        });
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                            };
                        });
                        resolve();
                    }).catch(function(e) {
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                            };
                        });
                        // If exceed max retry times, we give up retry
                        _this.loadingRetryTimes[key] = (_this.loadingRetryTimes[key] || 0) + 1;
                        if (_this.loadingRetryTimes[key] >= $35788aa3d6a30576$var$MAX_RETRY_TIMES) {
                            var currentLoadedKeys = _this.state.loadedKeys;
                            (0, $2bFmQ.default)(false, 'Retry for `loadData` many times but still failed. No more retry.');
                            _this.setUncontrolledState({
                                loadedKeys: (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(currentLoadedKeys, key)
                            });
                            resolve();
                        }
                        reject(e);
                    });
                    return {
                        loadingKeys: (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(loadingKeys, key)
                    };
                });
            });
            // Not care warning if we ignore this
            loadPromise.catch(function() {});
            return loadPromise;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeMouseEnter", function(event, node) {
            var onMouseEnter = _this.props.onMouseEnter;
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                event: event,
                node: node
            });
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeMouseLeave", function(event, node) {
            var onMouseLeave = _this.props.onMouseLeave;
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                event: event,
                node: node
            });
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeContextMenu", function(event, node) {
            var onRightClick = _this.props.onRightClick;
            if (onRightClick) {
                event.preventDefault();
                onRightClick({
                    event: event,
                    node: node
                });
            }
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onFocus", function() {
            var onFocus = _this.props.onFocus;
            _this.setState({
                focused: true
            });
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            onFocus === null || onFocus === void 0 || onFocus.apply(void 0, args);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onBlur", function() {
            var onBlur = _this.props.onBlur;
            _this.setState({
                focused: false
            });
            _this.onActiveChange(null);
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            onBlur === null || onBlur === void 0 || onBlur.apply(void 0, args);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getTreeNodeRequiredProps", function() {
            var _this$state8 = _this.state, expandedKeys = _this$state8.expandedKeys, selectedKeys = _this$state8.selectedKeys, loadedKeys = _this$state8.loadedKeys, loadingKeys = _this$state8.loadingKeys, checkedKeys = _this$state8.checkedKeys, halfCheckedKeys = _this$state8.halfCheckedKeys, dragOverNodeKey = _this$state8.dragOverNodeKey, dropPosition = _this$state8.dropPosition, keyEntities = _this$state8.keyEntities;
            return {
                expandedKeys: expandedKeys || [],
                selectedKeys: selectedKeys || [],
                loadedKeys: loadedKeys || [],
                loadingKeys: loadingKeys || [],
                checkedKeys: checkedKeys || [],
                halfCheckedKeys: halfCheckedKeys || [],
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                keyEntities: keyEntities
            };
        });
        // =========================== Expanded ===========================
        /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ (0, $eq8kl.default)((0, $e4nJa.default)(_this), "setExpandedKeys", function(expandedKeys) {
            var _this$state9 = _this.state, treeData = _this$state9.treeData, fieldNames = _this$state9.fieldNames;
            var flattenNodes = (0, $a2876523b8e415d4$export$215c1b4f1ba88b23)(treeData, expandedKeys, fieldNames);
            _this.setUncontrolledState({
                expandedKeys: expandedKeys,
                flattenNodes: flattenNodes
            }, true);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onNodeExpand", function(e, treeNode) {
            var expandedKeys = _this.state.expandedKeys;
            var _this$state10 = _this.state, listChanging = _this$state10.listChanging, fieldNames = _this$state10.fieldNames;
            var _this$props8 = _this.props, onExpand = _this$props8.onExpand, loadData = _this$props8.loadData;
            var expanded = treeNode.expanded;
            var key = treeNode[fieldNames.key];
            // Do nothing when motion is in progress
            if (listChanging) return;
            // Update selected keys
            var certain = expandedKeys.includes(key);
            var targetExpanded = !expanded;
            (0, $2bFmQ.default)(expanded && certain || !expanded && !certain, 'Expand state not sync with index check');
            expandedKeys = targetExpanded ? (0, $9c953ffa830afa28$export$10663f6bbd2fd717)(expandedKeys, key) : (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(expandedKeys, key);
            _this.setExpandedKeys(expandedKeys);
            onExpand === null || onExpand === void 0 || onExpand(expandedKeys, {
                node: treeNode,
                expanded: targetExpanded,
                nativeEvent: e.nativeEvent
            });
            // Async Load data
            if (targetExpanded && loadData) {
                var loadPromise = _this.onNodeLoad(treeNode);
                if (loadPromise) loadPromise.then(function() {
                    // [Legacy] Refresh logic
                    var newFlattenTreeData = (0, $a2876523b8e415d4$export$215c1b4f1ba88b23)(_this.state.treeData, expandedKeys, fieldNames);
                    _this.setUncontrolledState({
                        flattenNodes: newFlattenTreeData
                    });
                }).catch(function() {
                    var currentExpandedKeys = _this.state.expandedKeys;
                    var expandedKeysToRestore = (0, $9c953ffa830afa28$export$5bfb9ff497fe2298)(currentExpandedKeys, key);
                    _this.setExpandedKeys(expandedKeysToRestore);
                });
            }
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onListChangeStart", function() {
            _this.setUncontrolledState({
                listChanging: true
            });
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onListChangeEnd", function() {
            setTimeout(function() {
                _this.setUncontrolledState({
                    listChanging: false
                });
            });
        });
        // =========================== Keyboard ===========================
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onActiveChange", function(newActiveKey) {
            var activeKey = _this.state.activeKey;
            var _this$props9 = _this.props, onActiveChange = _this$props9.onActiveChange, _this$props9$itemScro = _this$props9.itemScrollOffset, itemScrollOffset = _this$props9$itemScro === void 0 ? 0 : _this$props9$itemScro;
            if (activeKey === newActiveKey) return;
            _this.setState({
                activeKey: newActiveKey
            });
            if (newActiveKey !== null) _this.scrollTo({
                key: newActiveKey,
                offset: itemScrollOffset
            });
            onActiveChange === null || onActiveChange === void 0 || onActiveChange(newActiveKey);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "getActiveItem", function() {
            var _this$state11 = _this.state, activeKey = _this$state11.activeKey, flattenNodes = _this$state11.flattenNodes;
            if (activeKey === null) return null;
            return flattenNodes.find(function(_ref2) {
                var key = _ref2.key;
                return key === activeKey;
            }) || null;
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "offsetActiveKey", function(offset) {
            var _this$state12 = _this.state, flattenNodes = _this$state12.flattenNodes, activeKey = _this$state12.activeKey;
            var index = flattenNodes.findIndex(function(_ref3) {
                var key = _ref3.key;
                return key === activeKey;
            });
            // Align with index
            if (index === -1 && offset < 0) index = flattenNodes.length;
            index = (index + offset + flattenNodes.length) % flattenNodes.length;
            var item = flattenNodes[index];
            if (item) {
                var _key4 = item.key;
                _this.onActiveChange(_key4);
            } else _this.onActiveChange(null);
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "onKeyDown", function(event) {
            var _this$state13 = _this.state, activeKey = _this$state13.activeKey, expandedKeys = _this$state13.expandedKeys, checkedKeys = _this$state13.checkedKeys, fieldNames = _this$state13.fieldNames;
            var _this$props10 = _this.props, onKeyDown = _this$props10.onKeyDown, checkable = _this$props10.checkable, selectable = _this$props10.selectable;
            // >>>>>>>>>> Direction
            switch(event.which){
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP:
                    _this.offsetActiveKey(-1);
                    event.preventDefault();
                    break;
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN:
                    _this.offsetActiveKey(1);
                    event.preventDefault();
                    break;
            }
            // >>>>>>>>>> Expand & Selection
            var activeItem = _this.getActiveItem();
            if (activeItem && activeItem.data) {
                var treeNodeRequiredProps = _this.getTreeNodeRequiredProps();
                var expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
                var eventNode = (0, $a2876523b8e415d4$export$7bd1b0fd4a8b540b)((0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $a2876523b8e415d4$export$d961fd523a514db5)(activeKey, treeNodeRequiredProps)), {}, {
                    data: activeItem.data,
                    active: true
                }));
                switch(event.which){
                    // >>> Expand
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).LEFT:
                        // Collapse if possible
                        if (expandable && expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.parent) _this.onActiveChange(activeItem.parent.key);
                        event.preventDefault();
                        break;
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).RIGHT:
                        // Expand if possible
                        if (expandable && !expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.children && activeItem.children.length) _this.onActiveChange(activeItem.children[0].key);
                        event.preventDefault();
                        break;
                    // Selection
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER:
                    case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).SPACE:
                        if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) _this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                        else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) _this.onNodeSelect({}, eventNode);
                        break;
                }
            }
            onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
        });
        /**
     * Only update the value which is not in props
     */ (0, $eq8kl.default)((0, $e4nJa.default)(_this), "setUncontrolledState", function(state) {
            var atomic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var forceState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (!_this.destroyed) {
                var needSync = false;
                var allPassed = true;
                var newState = {};
                Object.keys(state).forEach(function(name) {
                    if (_this.props.hasOwnProperty(name)) {
                        allPassed = false;
                        return;
                    }
                    needSync = true;
                    newState[name] = state[name];
                });
                if (needSync && (!atomic || allPassed)) _this.setState((0, $8u3qN.default)((0, $8u3qN.default)({}, newState), forceState));
            }
        });
        (0, $eq8kl.default)((0, $e4nJa.default)(_this), "scrollTo", function(scroll) {
            _this.listRef.current.scrollTo(scroll);
        });
        return _this;
    }
    (0, $9O7LJ.default)(Tree, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                this.onUpdated();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.onUpdated();
            }
        },
        {
            key: "onUpdated",
            value: function onUpdated() {
                var _this$props11 = this.props, activeKey = _this$props11.activeKey, _this$props11$itemScr = _this$props11.itemScrollOffset, itemScrollOffset = _this$props11$itemScr === void 0 ? 0 : _this$props11$itemScr;
                if (activeKey !== undefined && activeKey !== this.state.activeKey) {
                    this.setState({
                        activeKey: activeKey
                    });
                    if (activeKey !== null) this.scrollTo({
                        key: activeKey,
                        offset: itemScrollOffset
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('dragend', this.onWindowDragEnd);
                this.destroyed = true;
            }
        },
        {
            key: "resetDragState",
            value: function resetDragState() {
                this.setState({
                    dragOverNodeKey: null,
                    dropPosition: null,
                    dropLevelOffset: null,
                    dropTargetKey: null,
                    dropContainerKey: null,
                    dropTargetPos: null,
                    dropAllowed: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state14 = this.state, focused = _this$state14.focused, flattenNodes = _this$state14.flattenNodes, keyEntities = _this$state14.keyEntities, draggingNodeKey = _this$state14.draggingNodeKey, activeKey = _this$state14.activeKey, dropLevelOffset = _this$state14.dropLevelOffset, dropContainerKey = _this$state14.dropContainerKey, dropTargetKey = _this$state14.dropTargetKey, dropPosition = _this$state14.dropPosition, dragOverNodeKey = _this$state14.dragOverNodeKey, indent = _this$state14.indent;
                var _this$props12 = this.props, prefixCls = _this$props12.prefixCls, className = _this$props12.className, style = _this$props12.style, showLine = _this$props12.showLine, focusable = _this$props12.focusable, _this$props12$tabInde = _this$props12.tabIndex, tabIndex = _this$props12$tabInde === void 0 ? 0 : _this$props12$tabInde, selectable = _this$props12.selectable, showIcon = _this$props12.showIcon, icon = _this$props12.icon, switcherIcon = _this$props12.switcherIcon, draggable = _this$props12.draggable, checkable = _this$props12.checkable, checkStrictly = _this$props12.checkStrictly, disabled = _this$props12.disabled, motion = _this$props12.motion, loadData = _this$props12.loadData, filterTreeNode = _this$props12.filterTreeNode, height = _this$props12.height, itemHeight = _this$props12.itemHeight, scrollWidth = _this$props12.scrollWidth, virtual = _this$props12.virtual, titleRender = _this$props12.titleRender, dropIndicatorRender = _this$props12.dropIndicatorRender, onContextMenu = _this$props12.onContextMenu, onScroll = _this$props12.onScroll, direction = _this$props12.direction, rootClassName = _this$props12.rootClassName, rootStyle = _this$props12.rootStyle;
                var domProps = (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(this.props, {
                    aria: true,
                    data: true
                });
                // It's better move to hooks but we just simply keep here
                var draggableConfig;
                if (draggable) {
                    if ((0, $1Esi2.default)(draggable) === 'object') draggableConfig = draggable;
                    else if (typeof draggable === 'function') draggableConfig = {
                        nodeDraggable: draggable
                    };
                    else draggableConfig = {};
                }
                var contextValue = {
                    prefixCls: prefixCls,
                    selectable: selectable,
                    showIcon: showIcon,
                    icon: icon,
                    switcherIcon: switcherIcon,
                    draggable: draggableConfig,
                    draggingNodeKey: draggingNodeKey,
                    checkable: checkable,
                    checkStrictly: checkStrictly,
                    disabled: disabled,
                    keyEntities: keyEntities,
                    dropLevelOffset: dropLevelOffset,
                    dropContainerKey: dropContainerKey,
                    dropTargetKey: dropTargetKey,
                    dropPosition: dropPosition,
                    dragOverNodeKey: dragOverNodeKey,
                    indent: indent,
                    direction: direction,
                    dropIndicatorRender: dropIndicatorRender,
                    loadData: loadData,
                    filterTreeNode: filterTreeNode,
                    titleRender: titleRender,
                    onNodeClick: this.onNodeClick,
                    onNodeDoubleClick: this.onNodeDoubleClick,
                    onNodeExpand: this.onNodeExpand,
                    onNodeSelect: this.onNodeSelect,
                    onNodeCheck: this.onNodeCheck,
                    onNodeLoad: this.onNodeLoad,
                    onNodeMouseEnter: this.onNodeMouseEnter,
                    onNodeMouseLeave: this.onNodeMouseLeave,
                    onNodeContextMenu: this.onNodeContextMenu,
                    onNodeDragStart: this.onNodeDragStart,
                    onNodeDragEnter: this.onNodeDragEnter,
                    onNodeDragOver: this.onNodeDragOver,
                    onNodeDragLeave: this.onNodeDragLeave,
                    onNodeDragEnd: this.onNodeDragEnd,
                    onNodeDrop: this.onNodeDrop
                };
                return /*#__PURE__*/ $jMaZ8.createElement((0, $ac33c98905104d8a$export$dfae7d399eea2568).Provider, {
                    value: contextValue
                }, /*#__PURE__*/ $jMaZ8.createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, rootClassName, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-show-line"), showLine), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-active-focused"), activeKey !== null)),
                    style: rootStyle
                }, /*#__PURE__*/ $jMaZ8.createElement((0, $eab9beaeaa638f28$export$2e2bcd8739ae039), (0, $hH60s.default)({
                    ref: this.listRef,
                    prefixCls: prefixCls,
                    style: style,
                    data: flattenNodes,
                    disabled: disabled,
                    selectable: selectable,
                    checkable: !!checkable,
                    motion: motion,
                    dragging: draggingNodeKey !== null,
                    height: height,
                    itemHeight: itemHeight,
                    virtual: virtual,
                    focusable: focusable,
                    focused: focused,
                    tabIndex: tabIndex,
                    activeItem: this.getActiveItem(),
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onKeyDown: this.onKeyDown,
                    onActiveChange: this.onActiveChange,
                    onListChangeStart: this.onListChangeStart,
                    onListChangeEnd: this.onListChangeEnd,
                    onContextMenu: onContextMenu,
                    onScroll: onScroll,
                    scrollWidth: scrollWidth
                }, this.getTreeNodeRequiredProps(), domProps))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, prevState) {
                var prevProps = prevState.prevProps;
                var newState = {
                    prevProps: props
                };
                function needSync(name) {
                    return !prevProps && props.hasOwnProperty(name) || prevProps && prevProps[name] !== props[name];
                }
                // ================== Tree Node ==================
                var treeData;
                // fieldNames
                var fieldNames = prevState.fieldNames;
                if (needSync('fieldNames')) {
                    fieldNames = (0, $a2876523b8e415d4$export$6c519d302dced239)(props.fieldNames);
                    newState.fieldNames = fieldNames;
                }
                // Check if `treeData` or `children` changed and save into the state.
                if (needSync('treeData')) treeData = props.treeData;
                else if (needSync('children')) {
                    (0, $2bFmQ.default)(false, '`children` of Tree is deprecated. Please use `treeData` instead.');
                    treeData = (0, $a2876523b8e415d4$export$6d8b10995563b669)(props.children);
                }
                // Save flatten nodes info and convert `treeData` into keyEntities
                if (treeData) {
                    newState.treeData = treeData;
                    var entitiesMap = (0, $a2876523b8e415d4$export$e5d831ce033a4615)(treeData, {
                        fieldNames: fieldNames
                    });
                    newState.keyEntities = (0, $8u3qN.default)((0, $eq8kl.default)({}, (0, $eab9beaeaa638f28$export$17c02cdd52a7d889), (0, $eab9beaeaa638f28$export$2d18abad5109a402)), entitiesMap.keyEntities);
                    (0, $a2876523b8e415d4$export$702780ec64d148df)(treeData, fieldNames);
                }
                var keyEntities = newState.keyEntities || prevState.keyEntities;
                // ================ expandedKeys =================
                if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $9c953ffa830afa28$export$fac4a40c345ccd80)(props.expandedKeys, keyEntities) : props.expandedKeys;
                else if (!prevProps && props.defaultExpandAll) {
                    var cloneKeyEntities = (0, $8u3qN.default)({}, keyEntities);
                    delete cloneKeyEntities[0, $eab9beaeaa638f28$export$17c02cdd52a7d889];
                    // Only take the key who has the children to enhance the performance
                    var nextExpandedKeys = [];
                    Object.keys(cloneKeyEntities).forEach(function(key) {
                        var entity = cloneKeyEntities[key];
                        if (entity.children && entity.children.length) nextExpandedKeys.push(entity.key);
                    });
                    newState.expandedKeys = nextExpandedKeys;
                } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $9c953ffa830afa28$export$fac4a40c345ccd80)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
                if (!newState.expandedKeys) delete newState.expandedKeys;
                // ================ flattenNodes =================
                if (treeData || newState.expandedKeys) {
                    var flattenNodes = (0, $a2876523b8e415d4$export$215c1b4f1ba88b23)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
                    newState.flattenNodes = flattenNodes;
                }
                // ================ selectedKeys =================
                if (props.selectable) {
                    if (needSync('selectedKeys')) newState.selectedKeys = (0, $9c953ffa830afa28$export$fffc10811828fd68)(props.selectedKeys, props);
                    else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $9c953ffa830afa28$export$fffc10811828fd68)(props.defaultSelectedKeys, props);
                }
                // ================= checkedKeys =================
                if (props.checkable) {
                    var checkedKeyEntity;
                    if (needSync('checkedKeys')) checkedKeyEntity = (0, $9c953ffa830afa28$export$29d4989c23990d41)(props.checkedKeys) || {};
                    else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $9c953ffa830afa28$export$29d4989c23990d41)(props.defaultCheckedKeys) || {};
                    else if (treeData) // If `treeData` changed, we also need check it
                    checkedKeyEntity = (0, $9c953ffa830afa28$export$29d4989c23990d41)(props.checkedKeys) || {
                        checkedKeys: prevState.checkedKeys,
                        halfCheckedKeys: prevState.halfCheckedKeys
                    };
                    if (checkedKeyEntity) {
                        var _checkedKeyEntity = checkedKeyEntity, _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys, checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che, _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys, halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
                        if (!props.checkStrictly) {
                            var conductKeys = (0, $4171d50fadf9ef5d$export$43adf2c483e3e633)(checkedKeys, true, keyEntities);
                            checkedKeys = conductKeys.checkedKeys;
                            halfCheckedKeys = conductKeys.halfCheckedKeys;
                        }
                        newState.checkedKeys = checkedKeys;
                        newState.halfCheckedKeys = halfCheckedKeys;
                    }
                }
                // ================= loadedKeys ==================
                if (needSync('loadedKeys')) newState.loadedKeys = props.loadedKeys;
                return newState;
            }
        }
    ]);
    return Tree;
}($jMaZ8.Component);
(0, $eq8kl.default)($35788aa3d6a30576$var$Tree, "defaultProps", {
    prefixCls: 'rc-tree',
    showLine: false,
    showIcon: true,
    selectable: true,
    multiple: false,
    checkable: false,
    disabled: false,
    checkStrictly: false,
    draggable: false,
    defaultExpandParent: true,
    autoExpandParent: false,
    defaultExpandAll: false,
    defaultExpandedKeys: [],
    defaultCheckedKeys: [],
    defaultSelectedKeys: [],
    dropIndicatorRender: (0, $1ea0a2cc1631a549$export$2e2bcd8739ae039),
    allowDrop: function allowDrop() {
        return true;
    },
    expandAction: false
});
(0, $eq8kl.default)($35788aa3d6a30576$var$Tree, "TreeNode", (0, $422a8a4f6c7c8b88$export$2e2bcd8739ae039));
var $35788aa3d6a30576$export$2e2bcd8739ae039 = $35788aa3d6a30576$var$Tree;




var $9320d1c76ee817ad$export$2e2bcd8739ae039 = (0, $35788aa3d6a30576$export$2e2bcd8739ae039);



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $0cd1ab84fb8266f6$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $0cd1ab84fb8266f6$export$2e2bcd8739ae039 = $0cd1ab84fb8266f6$var$FileOutlined;



var $a69c44d4a3256895$var$FileOutlined = function FileOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $0cd1ab84fb8266f6$export$2e2bcd8739ae039)
    }));
};
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ var $a69c44d4a3256895$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($a69c44d4a3256895$var$FileOutlined);
$a69c44d4a3256895$var$RefIcon.displayName = 'FileOutlined';
var $a69c44d4a3256895$export$2e2bcd8739ae039 = $a69c44d4a3256895$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $4a3c9372c4db136b$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $4a3c9372c4db136b$export$2e2bcd8739ae039 = $4a3c9372c4db136b$var$FolderOpenOutlined;



var $304c4145f5752210$var$FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $4a3c9372c4db136b$export$2e2bcd8739ae039)
    }));
};
/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */ var $304c4145f5752210$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($304c4145f5752210$var$FolderOpenOutlined);
$304c4145f5752210$var$RefIcon.displayName = 'FolderOpenOutlined';
var $304c4145f5752210$export$2e2bcd8739ae039 = $304c4145f5752210$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $850d221e594ff1d7$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
var $850d221e594ff1d7$export$2e2bcd8739ae039 = $850d221e594ff1d7$var$FolderOutlined;



var $51f5d3564bc57560$var$FolderOutlined = function FolderOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $850d221e594ff1d7$export$2e2bcd8739ae039)
    }));
};
/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */ var $51f5d3564bc57560$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($51f5d3564bc57560$var$FolderOutlined);
$51f5d3564bc57560$var$RefIcon.displayName = 'FolderOutlined';
var $51f5d3564bc57560$export$2e2bcd8739ae039 = $51f5d3564bc57560$var$RefIcon;



var $giSak = parcelRequire("giSak");




var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $4dbe85e07eef7c51$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
var $4dbe85e07eef7c51$export$2e2bcd8739ae039 = $4dbe85e07eef7c51$var$HolderOutlined;



var $c2c2bcbf2dc1a1dd$var$HolderOutlined = function HolderOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $4dbe85e07eef7c51$export$2e2bcd8739ae039)
    }));
};
/**![holder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwMCAyNzYuNWE1NiA1NiAwIDEwNTYtOTcgNTYgNTYgMCAwMC01NiA5N3ptMCAyODRhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCAyMjhhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDAwLTExMiAwek0zMDAgODQ0LjVhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCA3OTZhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6IiAvPjwvc3ZnPg==) */ var $c2c2bcbf2dc1a1dd$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($c2c2bcbf2dc1a1dd$var$HolderOutlined);
$c2c2bcbf2dc1a1dd$var$RefIcon.displayName = 'HolderOutlined';
var $c2c2bcbf2dc1a1dd$export$2e2bcd8739ae039 = $c2c2bcbf2dc1a1dd$var$RefIcon;



var $giSak = parcelRequire("giSak");




parcelRequire("gedkv");
var $kB90R = parcelRequire("kB90R");
var $4g3I0 = parcelRequire("4g3I0");



parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// ============================ Directory =============================
const $c8541c62e8eecc7e$export$2f47474ee6fcebcf = (_ref)=>{
    let { treeCls: treeCls, treeNodeCls: treeNodeCls, directoryNodeSelectedBg: directoryNodeSelectedBg, directoryNodeSelectedColor: directoryNodeSelectedColor, motionDurationMid: motionDurationMid, borderRadius: borderRadius, controlItemBgHover: controlItemBgHover } = _ref;
    return {
        [`${treeCls}${treeCls}-directory ${treeNodeCls}`]: {
            // >>> Title
            [`${treeCls}-node-content-wrapper`]: {
                position: 'static',
                [`> *:not(${treeCls}-drop-indicator)`]: {
                    position: 'relative'
                },
                '&:hover': {
                    background: 'transparent'
                },
                // Expand interactive area to whole line
                '&:before': {
                    position: 'absolute',
                    inset: 0,
                    transition: `background-color ${motionDurationMid}`,
                    content: '""',
                    borderRadius: borderRadius
                },
                '&:hover:before': {
                    background: controlItemBgHover
                }
            },
            [`${treeCls}-switcher, ${treeCls}-checkbox, ${treeCls}-draggable-icon`]: {
                zIndex: 1
            },
            // ============= Selected =============
            '&-selected': {
                [`${treeCls}-switcher, ${treeCls}-draggable-icon`]: {
                    color: directoryNodeSelectedColor
                },
                // >>> Title
                [`${treeCls}-node-content-wrapper`]: {
                    color: directoryNodeSelectedColor,
                    background: 'transparent',
                    '&:before, &:hover:before': {
                        background: directoryNodeSelectedBg
                    }
                }
            }
        }
    };
};


// ============================ Keyframes =============================
const $f792bdda2489b2b8$var$treeNodeFX = new (0, $kB90R.default)('ant-tree-node-fx-do-not-use', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// ============================== Switch ==============================
const $f792bdda2489b2b8$var$getSwitchStyle = (prefixCls, token)=>({
        [`.${prefixCls}-switcher-icon`]: {
            display: 'inline-block',
            fontSize: 10,
            verticalAlign: 'baseline',
            svg: {
                transition: `transform ${token.motionDurationSlow}`
            }
        }
    });
// =============================== Drop ===============================
const $f792bdda2489b2b8$var$getDropIndicatorStyle = (prefixCls, token)=>({
        [`.${prefixCls}-drop-indicator`]: {
            position: 'absolute',
            // it should displayed over the following node
            zIndex: 1,
            height: 2,
            backgroundColor: token.colorPrimary,
            borderRadius: 1,
            pointerEvents: 'none',
            '&:after': {
                position: 'absolute',
                top: -3,
                insetInlineStart: -6,
                width: 8,
                height: 8,
                backgroundColor: 'transparent',
                border: `${(0, $4g3I0.unit)(token.lineWidthBold)} solid ${token.colorPrimary}`,
                borderRadius: '50%',
                content: '""'
            }
        }
    });
const $f792bdda2489b2b8$export$5ca74f7be820a85 = (prefixCls, token)=>{
    const { treeCls: treeCls, treeNodeCls: treeNodeCls, treeNodePadding: treeNodePadding, titleHeight: titleHeight, indentSize: indentSize, nodeSelectedBg: nodeSelectedBg, nodeHoverBg: nodeHoverBg, colorTextQuaternary: colorTextQuaternary, controlItemBgActiveDisabled: controlItemBgActiveDisabled } = token;
    return {
        [treeCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            background: token.colorBgContainer,
            borderRadius: token.borderRadius,
            transition: `background-color ${token.motionDurationSlow}`,
            '&-rtl': {
                direction: 'rtl'
            },
            [`&${treeCls}-rtl ${treeCls}-switcher_close ${treeCls}-switcher-icon svg`]: {
                transform: 'rotate(90deg)'
            },
            [`&-focused:not(:hover):not(${treeCls}-active-focused)`]: Object.assign({}, (0, $134f73cf3485ce91$export$6539948f0a737e39)(token)),
            // =================== Virtual List ===================
            [`${treeCls}-list-holder-inner`]: {
                alignItems: 'flex-start'
            },
            [`&${treeCls}-block-node`]: {
                [`${treeCls}-list-holder-inner`]: {
                    alignItems: 'stretch',
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        flex: 'auto'
                    },
                    // >>> Drag
                    [`${treeNodeCls}.dragging:after`]: {
                        position: 'absolute',
                        inset: 0,
                        border: `1px solid ${token.colorPrimary}`,
                        opacity: 0,
                        animationName: $f792bdda2489b2b8$var$treeNodeFX,
                        animationDuration: token.motionDurationSlow,
                        animationPlayState: 'running',
                        animationFillMode: 'forwards',
                        content: '""',
                        pointerEvents: 'none',
                        borderRadius: token.borderRadius
                    }
                }
            },
            // ===================== TreeNode =====================
            [treeNodeCls]: {
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: treeNodePadding,
                lineHeight: (0, $4g3I0.unit)(titleHeight),
                position: 'relative',
                // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    zIndex: 1,
                    insetInlineStart: 0,
                    width: '100%',
                    top: '100%',
                    height: treeNodePadding
                },
                // Disabled
                [`&-disabled ${treeCls}-node-content-wrapper`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed',
                    '&:hover': {
                        background: 'transparent'
                    }
                },
                [`${treeCls}-checkbox-disabled + ${treeCls}-node-selected,&${treeNodeCls}-disabled${treeNodeCls}-selected ${treeCls}-node-content-wrapper`]: {
                    backgroundColor: controlItemBgActiveDisabled
                },
                // we can not set pointer-events to none for checkbox in tree
                // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
                [`${treeCls}-checkbox-disabled`]: {
                    pointerEvents: 'unset'
                },
                // not disable
                [`&:not(${treeNodeCls}-disabled)`]: {
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        '&:hover': {
                            color: token.nodeHoverColor
                        }
                    }
                },
                [`&-active ${treeCls}-node-content-wrapper`]: {
                    background: token.controlItemBgHover
                },
                [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
                    color: token.colorPrimary,
                    fontWeight: 500
                },
                '&-draggable': {
                    cursor: 'grab',
                    [`${treeCls}-draggable-icon`]: {
                        // https://github.com/ant-design/ant-design/issues/41915
                        flexShrink: 0,
                        width: titleHeight,
                        textAlign: 'center',
                        visibility: 'visible',
                        color: colorTextQuaternary
                    },
                    [`&${treeNodeCls}-disabled ${treeCls}-draggable-icon`]: {
                        visibility: 'hidden'
                    }
                }
            },
            // >>> Indent
            [`${treeCls}-indent`]: {
                alignSelf: 'stretch',
                whiteSpace: 'nowrap',
                userSelect: 'none',
                '&-unit': {
                    display: 'inline-block',
                    width: indentSize
                }
            },
            // >>> Drag Handler
            [`${treeCls}-draggable-icon`]: {
                visibility: 'hidden'
            },
            // Switcher / Checkbox
            [`${treeCls}-switcher, ${treeCls}-checkbox`]: {
                marginInlineEnd: token.calc(token.calc(titleHeight).sub(token.controlInteractiveSize)).div(2).equal()
            },
            // >>> Switcher
            [`${treeCls}-switcher`]: Object.assign(Object.assign({}, $f792bdda2489b2b8$var$getSwitchStyle(prefixCls, token)), {
                position: 'relative',
                flex: 'none',
                alignSelf: 'stretch',
                width: titleHeight,
                textAlign: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                transition: `all ${token.motionDurationSlow}`,
                '&-noop': {
                    cursor: 'unset'
                },
                '&:before': {
                    pointerEvents: 'none',
                    content: '""',
                    width: titleHeight,
                    height: titleHeight,
                    position: 'absolute',
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    top: 0,
                    borderRadius: token.borderRadius,
                    transition: `all ${token.motionDurationSlow}`
                },
                [`&:not(${treeCls}-switcher-noop):hover:before`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&_close ${treeCls}-switcher-icon svg`]: {
                    transform: 'rotate(-90deg)'
                },
                '&-loading-icon': {
                    color: token.colorPrimary
                },
                '&-leaf-line': {
                    position: 'relative',
                    zIndex: 1,
                    display: 'inline-block',
                    width: '100%',
                    height: '100%',
                    // https://github.com/ant-design/ant-design/issues/31884
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        marginInlineStart: -1,
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&:after': {
                        position: 'absolute',
                        width: token.calc(token.calc(titleHeight).div(2).equal()).mul(0.8).equal(),
                        height: token.calc(titleHeight).div(2).equal(),
                        borderBottom: `1px solid ${token.colorBorder}`,
                        content: '""'
                    }
                }
            }),
            // >>> Title
            // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
            [`${treeCls}-node-content-wrapper`]: Object.assign(Object.assign({
                position: 'relative',
                minHeight: titleHeight,
                paddingBlock: 0,
                paddingInline: token.paddingXS,
                background: 'transparent',
                borderRadius: token.borderRadius,
                cursor: 'pointer',
                transition: `all ${token.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`
            }, $f792bdda2489b2b8$var$getDropIndicatorStyle(prefixCls, token)), {
                '&:hover': {
                    backgroundColor: nodeHoverBg
                },
                [`&${treeCls}-node-selected`]: {
                    color: token.nodeSelectedColor,
                    backgroundColor: nodeSelectedBg
                },
                // Icon
                [`${treeCls}-iconEle`]: {
                    display: 'inline-block',
                    width: titleHeight,
                    height: titleHeight,
                    textAlign: 'center',
                    verticalAlign: 'top',
                    '&:empty': {
                        display: 'none'
                    }
                }
            }),
            // https://github.com/ant-design/ant-design/issues/28217
            [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${treeNodeCls}.drop-container > [draggable]`]: {
                boxShadow: `0 0 0 2px ${token.colorPrimary}`
            },
            // ==================== Show Line =====================
            '&-show-line': {
                // ================ Indent lines ================
                [`${treeCls}-indent-unit`]: {
                    position: 'relative',
                    height: '100%',
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&-end:before': {
                        display: 'none'
                    }
                },
                // ============== Cover Background ==============
                [`${treeCls}-switcher`]: {
                    background: 'transparent',
                    '&-line-icon': {
                        // https://github.com/ant-design/ant-design/issues/32813
                        verticalAlign: '-0.15em'
                    }
                }
            },
            [`${treeNodeCls}-leaf-last ${treeCls}-switcher-leaf-line:before`]: {
                top: 'auto !important',
                bottom: 'auto !important',
                height: `${(0, $4g3I0.unit)(token.calc(titleHeight).div(2).equal())} !important`
            }
        })
    };
};
const $f792bdda2489b2b8$export$6543b952798356f2 = (prefixCls, token)=>{
    const treeCls = `.${prefixCls}`;
    const treeNodeCls = `${treeCls}-treenode`;
    const treeNodePadding = token.calc(token.paddingXS).div(2).equal();
    const treeToken = (0, $8APUt.merge)(token, {
        treeCls: treeCls,
        treeNodeCls: treeNodeCls,
        treeNodePadding: treeNodePadding
    });
    return [
        // Basic
        $f792bdda2489b2b8$export$5ca74f7be820a85(prefixCls, treeToken),
        // Directory
        (0, $c8541c62e8eecc7e$export$2f47474ee6fcebcf)(treeToken)
    ];
};
const $f792bdda2489b2b8$export$bd8b682992bc9781 = (token)=>{
    const { controlHeightSM: controlHeightSM, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive } = token;
    const titleHeight = controlHeightSM;
    return {
        titleHeight: titleHeight,
        indentSize: titleHeight,
        nodeHoverBg: controlItemBgHover,
        nodeHoverColor: token.colorText,
        nodeSelectedBg: controlItemBgActive,
        nodeSelectedColor: token.colorText
    };
};
const $f792bdda2489b2b8$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary } = token;
    return Object.assign(Object.assign({}, $f792bdda2489b2b8$export$bd8b682992bc9781(token)), {
        directoryNodeSelectedColor: colorTextLightSolid,
        directoryNodeSelectedBg: colorPrimary
    });
};
var $f792bdda2489b2b8$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Tree', (token, _ref)=>{
    let { prefixCls: prefixCls } = _ref;
    return [
        {
            [token.componentCls]: (0, $f547958b307dd2c4$export$3d2f074408bd1b82)(`${prefixCls}-checkbox`, token)
        },
        $f792bdda2489b2b8$export$6543b952798356f2(prefixCls, token),
        (0, $86923e4ddcddee59$export$2e2bcd8739ae039)(token)
    ];
}, $f792bdda2489b2b8$export$9ca1be8807fe0675);



var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $a816d9536c2405c7$export$cc800923e997bb8 = 4;
function $a816d9536c2405c7$var$dropIndicatorRender(props) {
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, prefixCls: prefixCls, indent: indent, direction: direction = 'ltr' } = props;
    const startPosition = direction === 'ltr' ? 'left' : 'right';
    const endPosition = direction === 'ltr' ? 'right' : 'left';
    const style = {
        [startPosition]: -dropLevelOffset * indent + $a816d9536c2405c7$export$cc800923e997bb8,
        [endPosition]: 0
    };
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $a816d9536c2405c7$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        style: style,
        className: `${prefixCls}-drop-indicator`
    });
}
var $a816d9536c2405c7$export$2e2bcd8739ae039 = $a816d9536c2405c7$var$dropIndicatorRender;



var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $6e48d4af02ed286d$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
var $6e48d4af02ed286d$export$2e2bcd8739ae039 = $6e48d4af02ed286d$var$CaretDownFilled;



var $c46a105516d65712$var$CaretDownFilled = function CaretDownFilled(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $6e48d4af02ed286d$export$2e2bcd8739ae039)
    }));
};
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ var $c46a105516d65712$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($c46a105516d65712$var$CaretDownFilled);
$c46a105516d65712$var$RefIcon.displayName = 'CaretDownFilled';
var $c46a105516d65712$export$2e2bcd8739ae039 = $c46a105516d65712$var$RefIcon;





var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $474901b20b2170fb$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
var $474901b20b2170fb$export$2e2bcd8739ae039 = $474901b20b2170fb$var$MinusSquareOutlined;



var $b706f3cae48794ab$var$MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $474901b20b2170fb$export$2e2bcd8739ae039)
    }));
};
/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ var $b706f3cae48794ab$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($b706f3cae48794ab$var$MinusSquareOutlined);
$b706f3cae48794ab$var$RefIcon.displayName = 'MinusSquareOutlined';
var $b706f3cae48794ab$export$2e2bcd8739ae039 = $b706f3cae48794ab$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $b86a1c1ac7bf5fde$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
var $b86a1c1ac7bf5fde$export$2e2bcd8739ae039 = $b86a1c1ac7bf5fde$var$PlusSquareOutlined;



var $5155510cf437d43e$var$PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $b86a1c1ac7bf5fde$export$2e2bcd8739ae039)
    }));
};
/**![plus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMTUydjE1MmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjU0NGgxNTJjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ var $5155510cf437d43e$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($5155510cf437d43e$var$PlusSquareOutlined);
$5155510cf437d43e$var$RefIcon.displayName = 'PlusSquareOutlined';
var $5155510cf437d43e$export$2e2bcd8739ae039 = $5155510cf437d43e$var$RefIcon;



var $giSak = parcelRequire("giSak");

"use client";
const $7a0aa719ae393800$var$SwitcherIconCom = (props)=>{
    const { prefixCls: prefixCls, switcherIcon: switcherIcon, treeNodeProps: treeNodeProps, showLine: showLine, switcherLoadingIcon: switcherLoadingIcon } = props;
    const { isLeaf: isLeaf, expanded: expanded, loading: loading } = treeNodeProps;
    if (loading) {
        if (/*#__PURE__*/ $jMaZ8.isValidElement(switcherLoadingIcon)) return switcherLoadingIcon;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-loading-icon`
        });
    }
    let showLeafIcon;
    if (showLine && typeof showLine === 'object') showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            const leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            const leafCls = `${prefixCls}-switcher-line-custom-icon`;
            if (/*#__PURE__*/ $jMaZ8.isValidElement(leafIcon)) return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(leafIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(leafIcon.props.className || '', leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $jMaZ8.createElement((0, $a69c44d4a3256895$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-line-icon`
        }) : /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: `${prefixCls}-switcher-leaf-line`
        });
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if (/*#__PURE__*/ $jMaZ8.isValidElement(switcher)) return (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(switcher, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(switcher.props.className || '', switcherCls)
    });
    if (switcher !== undefined) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $jMaZ8.createElement((0, $b706f3cae48794ab$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/ $jMaZ8.createElement((0, $5155510cf437d43e$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $c46a105516d65712$export$2e2bcd8739ae039), {
        className: switcherCls
    });
};
var $7a0aa719ae393800$export$2e2bcd8739ae039 = $7a0aa719ae393800$var$SwitcherIconCom;


"use client";
const $5d301a6889145219$var$Tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((props, ref)=>{
    var _a;
    const { getPrefixCls: getPrefixCls, direction: direction, virtual: virtual, tree: tree } = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = false, showLine: showLine, switcherIcon: switcherIcon, switcherLoadingIcon: switcherLoadingIcon, blockNode: blockNode = false, children: children, checkable: checkable = false, selectable: selectable = true, draggable: draggable, motion: customMotion, style: style } = props;
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const motion = customMotion !== null && customMotion !== void 0 ? customMotion : Object.assign(Object.assign({}, (0, $230791b6f61cb981$export$2e2bcd8739ae039)(rootPrefixCls)), {
        motionAppear: false
    });
    const newProps = Object.assign(Object.assign({}, props), {
        checkable: checkable,
        selectable: selectable,
        showIcon: showIcon,
        motion: motion,
        blockNode: blockNode,
        showLine: Boolean(showLine),
        dropIndicatorRender: $a816d9536c2405c7$export$2e2bcd8739ae039
    });
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f792bdda2489b2b8$export$2e2bcd8739ae039)(prefixCls);
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const itemHeight = token.paddingXS / 2 + (((_a = token.Tree) === null || _a === void 0 ? void 0 : _a.titleHeight) || token.controlHeightSM);
    const draggableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useMemo(()=>{
        if (!draggable) return false;
        let mergedDraggable = {};
        switch(typeof draggable){
            case 'function':
                mergedDraggable.nodeDraggable = draggable;
                break;
            case 'object':
                mergedDraggable = Object.assign({}, draggable);
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $c2c2bcbf2dc1a1dd$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    const renderSwitcherIcon = (nodeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $7a0aa719ae393800$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            switcherIcon: switcherIcon,
            switcherLoadingIcon: switcherLoadingIcon,
            treeNodeProps: nodeProps,
            showLine: showLine
        });
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $9320d1c76ee817ad$export$2e2bcd8739ae039), Object.assign({
        itemHeight: itemHeight,
        ref: ref,
        virtual: virtual
    }, newProps, {
        // newProps may contain style so declare style below it
        style: Object.assign(Object.assign({}, tree === null || tree === void 0 ? void 0 : tree.style), style),
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-icon-hide`]: !showIcon,
            [`${prefixCls}-block-node`]: blockNode,
            [`${prefixCls}-unselectable`]: !selectable,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, tree === null || tree === void 0 ? void 0 : tree.className, className, hashId, cssVarCls),
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("span", {
            className: `${prefixCls}-checkbox-inner`
        }) : checkable,
        selectable: selectable,
        switcherIcon: renderSwitcherIcon,
        draggable: draggableConfig
    }), children));
});
$5d301a6889145219$var$Tree.displayName = 'Tree';
var $5d301a6889145219$export$2e2bcd8739ae039 = $5d301a6889145219$var$Tree;



var $fvBso = parcelRequire("fvBso");

const $874d3313c359e5f4$var$RECORD_NONE = 0;
const $874d3313c359e5f4$var$RECORD_START = 1;
const $874d3313c359e5f4$var$RECORD_END = 2;
function $874d3313c359e5f4$var$traverseNodesKey(treeData, callback, fieldNames) {
    const { key: fieldKey, children: fieldChildren } = fieldNames;
    function processNode(dataNode) {
        const key = dataNode[fieldKey];
        const children = dataNode[fieldChildren];
        if (callback(key, dataNode) !== false) $874d3313c359e5f4$var$traverseNodesKey(children || [], callback, fieldNames);
    }
    treeData.forEach(processNode);
}
function $874d3313c359e5f4$export$aad0b800290b42ab(_ref) {
    let { treeData: treeData, expandedKeys: expandedKeys, startKey: startKey, endKey: endKey, fieldNames: fieldNames } = _ref;
    const keys = [];
    let record = $874d3313c359e5f4$var$RECORD_NONE;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $874d3313c359e5f4$var$traverseNodesKey(treeData, (key)=>{
        if (record === $874d3313c359e5f4$var$RECORD_END) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $874d3313c359e5f4$var$RECORD_NONE) record = $874d3313c359e5f4$var$RECORD_START;
            else if (record === $874d3313c359e5f4$var$RECORD_START) {
                record = $874d3313c359e5f4$var$RECORD_END;
                return false;
            }
        } else if (record === $874d3313c359e5f4$var$RECORD_START) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    }, (0, $a2876523b8e415d4$export$6c519d302dced239)(fieldNames));
    return keys;
}
function $874d3313c359e5f4$export$7d40a46ab3886826(treeData, keys, fieldNames) {
    const restKeys = (0, $fvBso.default)(keys);
    const nodes = [];
    $874d3313c359e5f4$var$traverseNodesKey(treeData, (key, node)=>{
        const index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    }, (0, $a2876523b8e415d4$export$6c519d302dced239)(fieldNames));
    return nodes;
}


"use client";
var $f15d88f17289cdb2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f15d88f17289cdb2$var$getIcon(props) {
    const { isLeaf: isLeaf, expanded: expanded } = props;
    if (isLeaf) return /*#__PURE__*/ $jMaZ8.createElement((0, $a69c44d4a3256895$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $jMaZ8.createElement((0, $304c4145f5752210$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $51f5d3564bc57560$export$2e2bcd8739ae039), null);
}
function $f15d88f17289cdb2$var$getTreeData(_ref) {
    let { treeData: treeData, children: children } = _ref;
    return treeData || (0, $a2876523b8e415d4$export$6d8b10995563b669)(children);
}
const $f15d88f17289cdb2$var$DirectoryTree = (_a, ref)=>{
    var { defaultExpandAll: defaultExpandAll, defaultExpandParent: defaultExpandParent, defaultExpandedKeys: defaultExpandedKeys } = _a, props = $f15d88f17289cdb2$var$__rest(_a, [
        "defaultExpandAll",
        "defaultExpandParent",
        "defaultExpandedKeys"
    ]);
    // Shift click usage
    const lastSelectedKey = $jMaZ8.useRef(null);
    const cachedSelectedKeys = $jMaZ8.useRef(null);
    const getInitExpandedKeys = ()=>{
        const { keyEntities: keyEntities } = (0, $a2876523b8e415d4$export$e5d831ce033a4615)($f15d88f17289cdb2$var$getTreeData(props));
        let initExpandedKeys;
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $9c953ffa830afa28$export$fac4a40c345ccd80)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
        else initExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
        return initExpandedKeys;
    };
    const [selectedKeys, setSelectedKeys] = $jMaZ8.useState(props.selectedKeys || props.defaultSelectedKeys || []);
    const [expandedKeys, setExpandedKeys] = $jMaZ8.useState(()=>getInitExpandedKeys());
    $jMaZ8.useEffect(()=>{
        if ('selectedKeys' in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $jMaZ8.useEffect(()=>{
        if ('expandedKeys' in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    const onExpand = (keys, info)=>{
        var _a;
        if (!('expandedKeys' in props)) setExpandedKeys(keys);
        // Call origin function
        return (_a = props.onExpand) === null || _a === void 0 ? void 0 : _a.call(props, keys, info);
    };
    const onSelect = (keys, event)=>{
        var _a;
        const { multiple: multiple, fieldNames: fieldNames } = props;
        const { node: node, nativeEvent: nativeEvent } = event;
        const { key: key = '' } = node;
        const treeData = $f15d88f17289cdb2$var$getTreeData(props);
        // const newState: DirectoryTreeState = {};
        // We need wrap this event since some value is not same
        const newEvent = Object.assign(Object.assign({}, event), {
            selected: true
        });
        // Windows / Mac single pick
        const ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
        const shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
        // Generate new selected keys
        let newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $874d3313c359e5f4$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $fvBso.default)(cachedSelectedKeys.current || []), (0, $fvBso.default)((0, $874d3313c359e5f4$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKey.current,
                fieldNames: fieldNames
            })))));
            newEvent.selectedNodes = (0, $874d3313c359e5f4$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $874d3313c359e5f4$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        }
        (_a = props.onSelect) === null || _a === void 0 || _a.call(props, newSelectedKeys, newEvent);
        if (!('selectedKeys' in props)) setSelectedKeys(newSelectedKeys);
    };
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = true, expandAction: expandAction = 'click' } = props, otherProps = $f15d88f17289cdb2$var$__rest(props, [
        "prefixCls",
        "className",
        "showIcon",
        "expandAction"
    ]);
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const connectClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-directory`, {
        [`${prefixCls}-directory-rtl`]: direction === 'rtl'
    }, className);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $5d301a6889145219$export$2e2bcd8739ae039), Object.assign({
        icon: $f15d88f17289cdb2$var$getIcon,
        ref: ref,
        blockNode: true
    }, otherProps, {
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    }));
};
const $f15d88f17289cdb2$var$ForwardDirectoryTree = /*#__PURE__*/ $jMaZ8.forwardRef($f15d88f17289cdb2$var$DirectoryTree);
$f15d88f17289cdb2$var$ForwardDirectoryTree.displayName = 'DirectoryTree';
var $f15d88f17289cdb2$export$2e2bcd8739ae039 = $f15d88f17289cdb2$var$ForwardDirectoryTree;



"use client";
const $e194f5910dfe0ab4$var$Tree = (0, $5d301a6889145219$export$2e2bcd8739ae039);
$e194f5910dfe0ab4$var$Tree.DirectoryTree = (0, $f15d88f17289cdb2$export$2e2bcd8739ae039);
$e194f5910dfe0ab4$var$Tree.TreeNode = (0, $422a8a4f6c7c8b88$export$2e2bcd8739ae039);
var $e194f5910dfe0ab4$export$2e2bcd8739ae039 = $e194f5910dfe0ab4$var$Tree;



var $jMaZ8 = parcelRequire("jMaZ8");


"use client";
const $cefb5596ce9f6ded$var$FilterSearch = (props)=>{
    const { value: value, filterSearch: filterSearch, tablePrefixCls: tablePrefixCls, locale: locale, onChange: onChange } = props;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${tablePrefixCls}-filter-dropdown-search`
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $jMaZ8.createElement((0, $7707703e157f8963$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: `${tablePrefixCls}-filter-dropdown-search-input`
    }));
};
var $cefb5596ce9f6ded$export$2e2bcd8739ae039 = $cefb5596ce9f6ded$var$FilterSearch;



var $jMaZ8 = parcelRequire("jMaZ8");

"use client";
const $a94f8fa33dfaf231$var$onKeyDown = (event)=>{
    const { keyCode: keyCode } = event;
    if (keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) event.stopPropagation();
};
const $a94f8fa33dfaf231$var$FilterDropdownMenuWrapper = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: props.className,
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: $a94f8fa33dfaf231$var$onKeyDown,
        ref: ref
    }, props.children));
$a94f8fa33dfaf231$var$FilterDropdownMenuWrapper.displayName = 'FilterDropdownMenuWrapper';
var $a94f8fa33dfaf231$export$2e2bcd8739ae039 = $a94f8fa33dfaf231$var$FilterDropdownMenuWrapper;


"use client";
function $d8efb47a3aae503f$export$50792ddeed01ab0a(filters) {
    let keys = [];
    (filters || []).forEach((_ref)=>{
        let { value: value, children: children } = _ref;
        keys.push(value);
        if (children) keys = [].concat((0, $fvBso.default)(keys), (0, $fvBso.default)($d8efb47a3aae503f$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $d8efb47a3aae503f$var$hasSubMenu(filters) {
    return filters.some((_ref2)=>{
        let { children: children } = _ref2;
        return children;
    });
}
function $d8efb47a3aae503f$var$searchValueMatched(searchValue, text) {
    if (typeof text === 'string' || typeof text === 'number') return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    return false;
}
function $d8efb47a3aae503f$var$renderFilterItems(_ref3) {
    let { filters: filters, prefixCls: prefixCls, filteredKeys: filteredKeys, filterMultiple: filterMultiple, searchValue: searchValue, filterSearch: filterSearch } = _ref3;
    return filters.map((filter, index)=>{
        const key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: `${prefixCls}-dropdown-submenu`,
            children: $d8efb47a3aae503f$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                filterSearch: filterSearch
            })
        };
        const Component = filterMultiple ? (0, $1e51c82e25088207$export$2e2bcd8739ae039) : (0, $41c1392b19ea6316$export$2e2bcd8739ae039);
        const item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $jMaZ8.createElement("span", null, filter.text))
        };
        if (searchValue.trim()) {
            if (typeof filterSearch === 'function') return filterSearch(searchValue, filter) ? item : null;
            return $d8efb47a3aae503f$var$searchValueMatched(searchValue, filter.text) ? item : null;
        }
        return item;
    });
}
function $d8efb47a3aae503f$var$wrapStringListType(keys) {
    return keys || [];
}
const $d8efb47a3aae503f$var$FilterDropdown = (props)=>{
    var _a, _b, _c, _d;
    const { tablePrefixCls: tablePrefixCls, prefixCls: prefixCls, column: column, dropdownPrefixCls: dropdownPrefixCls, columnKey: columnKey, filterOnClose: filterOnClose, filterMultiple: filterMultiple, filterMode: filterMode = 'menu', filterSearch: filterSearch = false, filterState: filterState, triggerFilter: triggerFilter, locale: locale, children: children, getPopupContainer: getPopupContainer, rootClassName: rootClassName } = props;
    const { filterResetToDefaultFilteredValue: filterResetToDefaultFilteredValue, defaultFilteredValue: defaultFilteredValue, filterDropdownProps: filterDropdownProps = {}, filterDropdownOpen: // Deprecated
    filterDropdownOpen, filterDropdownVisible: filterDropdownVisible, onFilterDropdownVisibleChange: onFilterDropdownVisibleChange, onFilterDropdownOpenChange: onFilterDropdownOpenChange } = column;
    const [visible, setVisible] = $jMaZ8.useState(false);
    const filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
    const triggerVisible = (newVisible)=>{
        var _a;
        setVisible(newVisible);
        (_a = filterDropdownProps.onOpenChange) === null || _a === void 0 || _a.call(filterDropdownProps, newVisible);
        // deprecated
        onFilterDropdownOpenChange === null || onFilterDropdownOpenChange === void 0 || onFilterDropdownOpenChange(newVisible);
        onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 || onFilterDropdownVisibleChange(newVisible);
    };
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Table');
        const deprecatedList = [
            [
                'filterDropdownOpen',
                'filterDropdownProps.open'
            ],
            [
                'filterDropdownVisible',
                'filterDropdownProps.open'
            ],
            [
                'onFilterDropdownOpenChange',
                'filterDropdownProps.onOpenChange'
            ],
            [
                'onFilterDropdownVisibleChange',
                'filterDropdownProps.onOpenChange'
            ]
        ];
        deprecatedList.forEach((_ref4)=>{
            let [deprecatedName, newName] = _ref4;
            warning.deprecated(!(deprecatedName in column), deprecatedName, newName);
        });
    }
    const mergedVisible = (_d = (_c = (_b = filterDropdownProps.open) !== null && _b !== void 0 ? _b : filterDropdownOpen) !== null && _c !== void 0 ? _c : filterDropdownVisible) !== null && _d !== void 0 ? _d : visible; // inner state
    // ===================== Select Keys =====================
    const propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
    const [getFilteredKeysSync, setFilteredKeysSync] = (0, $3ce26919fd03658c$export$2e2bcd8739ae039)($d8efb47a3aae503f$var$wrapStringListType(propFilteredKeys));
    const onSelectKeys = (_ref5)=>{
        let { selectedKeys: selectedKeys } = _ref5;
        setFilteredKeysSync(selectedKeys);
    };
    const onCheck = (keys, _ref6)=>{
        let { node: node, checked: checked } = _ref6;
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $jMaZ8.useEffect(()=>{
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $d8efb47a3aae503f$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    const [openKeys, setOpenKeys] = $jMaZ8.useState([]);
    const onOpenChange = (keys)=>{
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    const [searchValue, setSearchValue] = $jMaZ8.useState('');
    const onSearch = (e)=>{
        const { value: value } = e.target;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $jMaZ8.useEffect(()=>{
        if (!visible) setSearchValue('');
    }, [
        visible
    ]);
    // ======================= Submit ========================
    const internalTriggerFilter = (keys)=>{
        const mergedKeys = (keys === null || keys === void 0 ? void 0 : keys.length) ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, $9O5K3.default)(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys, true)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    const onConfirm = ()=>{
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onReset = function() {
        let { confirm: confirm, closeDropdown: closeDropdown } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            confirm: false,
            closeDropdown: false
        };
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue('');
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map((key)=>String(key)));
        else setFilteredKeysSync([]);
    };
    const doFilter = function() {
        let { closeDropdown: closeDropdown } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            closeDropdown: true
        };
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onVisibleChange = (newVisible, info)=>{
        if (info.source === 'trigger') {
            if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefined)
            setFilteredKeysSync($d8efb47a3aae503f$var$wrapStringListType(propFilteredKeys));
            triggerVisible(newVisible);
            if (!newVisible && !column.filterDropdown && filterOnClose) onConfirm();
        }
    };
    // ======================== Style ========================
    const dropdownMenuClass = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${dropdownPrefixCls}-menu-without-submenu`]: !$d8efb47a3aae503f$var$hasSubMenu(column.filters || [])
    });
    const onCheckAll = (e)=>{
        if (e.target.checked) {
            const allFilterKeys = $d8efb47a3aae503f$export$50792ddeed01ab0a(column === null || column === void 0 ? void 0 : column.filters).map((key)=>String(key));
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    const getTreeData = (_ref7)=>{
        let { filters: filters } = _ref7;
        return (filters || []).map((filter, index)=>{
            const key = String(filter.value);
            const item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    };
    const getFilterData = (node)=>{
        var _a;
        return Object.assign(Object.assign({}, node), {
            text: node.title,
            value: node.key,
            children: ((_a = node.children) === null || _a === void 0 ? void 0 : _a.map((item)=>getFilterData(item))) || []
        });
    };
    let dropdownContent;
    const { direction: direction, renderEmpty: renderEmpty } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    if (typeof column.filterDropdown === 'function') dropdownContent = column.filterDropdown({
        prefixCls: `${dropdownPrefixCls}-custom`,
        setSelectedKeys: (selectedKeys)=>onSelectKeys({
                selectedKeys: selectedKeys
            }),
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: ()=>{
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        const selectedKeys = getFilteredKeysSync() || [];
        const getFilterComponent = ()=>{
            var _a;
            const empty = (_a = renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Table.filter')) !== null && _a !== void 0 ? _a : /*#__PURE__*/ $jMaZ8.createElement((0, $2e81825c370cda5d$export$2e2bcd8739ae039), {
                image: (0, $2e81825c370cda5d$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                styles: {
                    image: {
                        height: 24
                    }
                },
                style: {
                    margin: 0,
                    padding: '16px 0'
                }
            });
            if ((column.filters || []).length === 0) return empty;
            if (filterMode === 'tree') return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement((0, $cefb5596ce9f6ded$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $jMaZ8.createElement("div", {
                className: `${tablePrefixCls}-filter-dropdown-tree`
            }, filterMultiple ? /*#__PURE__*/ $jMaZ8.createElement((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === $d8efb47a3aae503f$export$50792ddeed01ab0a(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < $d8efb47a3aae503f$export$50792ddeed01ab0a(column.filters).length,
                className: `${tablePrefixCls}-filter-dropdown-checkall`,
                onChange: onCheckAll
            }, locale.filterCheckall) : null, /*#__PURE__*/ $jMaZ8.createElement((0, $e194f5910dfe0ab4$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: `${dropdownPrefixCls}-menu`,
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: searchValue.trim() ? (node)=>{
                    if (typeof filterSearch === 'function') return filterSearch(searchValue, getFilterData(node));
                    return $d8efb47a3aae503f$var$searchValueMatched(searchValue, node.title);
                } : undefined
            })));
            const items = $d8efb47a3aae503f$var$renderFilterItems({
                filters: column.filters || [],
                filterSearch: filterSearch,
                prefixCls: prefixCls,
                filteredKeys: getFilteredKeysSync(),
                filterMultiple: filterMultiple,
                searchValue: searchValue
            });
            const isEmpty = items.every((item)=>item === null);
            return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement((0, $cefb5596ce9f6ded$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), isEmpty ? empty : /*#__PURE__*/ $jMaZ8.createElement((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: `${dropdownPrefixCls}-menu`,
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: items
            }));
        };
        const getResetDisabled = ()=>{
            if (filterResetToDefaultFilteredValue) return (0, $9O5K3.default)((defaultFilteredValue || []).map((key)=>String(key)), selectedKeys, true);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, getFilterComponent(), /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-dropdown-btns`
        }, /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: ()=>onReset()
        }, locale.filterReset), /*#__PURE__*/ $jMaZ8.createElement((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $jMaZ8.createElement((0, $c4e5952f5dffa1aa$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    dropdownContent = /*#__PURE__*/ $jMaZ8.createElement((0, $a94f8fa33dfaf231$export$2e2bcd8739ae039), {
        className: `${prefixCls}-dropdown`
    }, dropdownContent);
    const getDropdownTrigger = ()=>{
        let filterIcon;
        if (typeof column.filterIcon === 'function') filterIcon = column.filterIcon(filtered);
        else if (column.filterIcon) filterIcon = column.filterIcon;
        else filterIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $9eb02aef8556d98a$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $jMaZ8.createElement("span", {
            role: "button",
            tabIndex: -1,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-trigger`, {
                active: filtered
            }),
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, filterIcon);
    };
    const mergedDropdownProps = (0, $d74635dfa3f27b0f$export$2e2bcd8739ae039)({
        trigger: [
            'click'
        ],
        placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight',
        children: getDropdownTrigger(),
        getPopupContainer: getPopupContainer
    }, Object.assign(Object.assign({}, filterDropdownProps), {
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(rootClassName, filterDropdownProps.rootClassName),
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        dropdownRender: ()=>{
            if (typeof (filterDropdownProps === null || filterDropdownProps === void 0 ? void 0 : filterDropdownProps.dropdownRender) === 'function') return filterDropdownProps.dropdownRender(dropdownContent);
            return dropdownContent;
        }
    }));
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), /*#__PURE__*/ $jMaZ8.createElement((0, $693847f5969d2a03$export$2e2bcd8739ae039), Object.assign({}, mergedDropdownProps)));
};
var $d8efb47a3aae503f$export$2e2bcd8739ae039 = $d8efb47a3aae503f$var$FilterDropdown;


"use client";
const $d1c35acf386da2d6$var$collectFilterStates = (columns, init, pos)=>{
    let filterStates = [];
    (columns || []).forEach((column, index)=>{
        var _a;
        const columnPos = (0, $9b33cf6cc3cffdfa$export$7e4db04adce9b4db)(index, pos);
        if (column.filters || 'filterDropdown' in column || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                let filteredValues = column.filteredValue;
                if (!('filterDropdown' in column)) filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ('children' in column) filterStates = [].concat((0, $fvBso.default)(filterStates), (0, $fvBso.default)($d1c35acf386da2d6$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
};
function $d1c35acf386da2d6$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale, triggerFilter, getPopupContainer, pos, rootClassName) {
    return columns.map((column, index)=>{
        const columnPos = (0, $9b33cf6cc3cffdfa$export$7e4db04adce9b4db)(index, pos);
        const { filterOnClose: filterOnClose = true, filterMultiple: filterMultiple = true, filterMode: filterMode, filterSearch: filterSearch } = column;
        let newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            const columnKey = (0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(newColumn, columnPos);
            const filterState = filterStates.find((_ref)=>{
                let { key: key } = _ref;
                return columnKey === key;
            });
            newColumn = Object.assign(Object.assign({}, newColumn), {
                title: (renderProps)=>/*#__PURE__*/ $jMaZ8.createElement((0, $d8efb47a3aae503f$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: `${prefixCls}-filter`,
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterOnClose: filterOnClose,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer,
                        rootClassName: rootClassName
                    }, (0, $9b33cf6cc3cffdfa$export$cfda450db2088de7)(column.title, renderProps))
            });
        }
        if ('children' in newColumn) newColumn = Object.assign(Object.assign({}, newColumn), {
            children: $d1c35acf386da2d6$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale, triggerFilter, getPopupContainer, columnPos, rootClassName)
        });
        return newColumn;
    });
}
const $d1c35acf386da2d6$var$generateFilterInfo = (filterStates)=>{
    const currentFilters = {};
    filterStates.forEach((_ref2)=>{
        let { key: key, filteredKeys: filteredKeys, column: column } = _ref2;
        const keyAsString = key;
        const { filters: filters, filterDropdown: filterDropdown } = column;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            const keys = (0, $d8efb47a3aae503f$export$50792ddeed01ab0a)(filters);
            currentFilters[keyAsString] = keys.filter((originKey)=>filteredKeys.includes(String(originKey)));
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
};
const $d1c35acf386da2d6$export$37643bb40f4c1c56 = (data, filterStates, childrenColumnName)=>{
    const filterDatas = filterStates.reduce((currentData, filterState)=>{
        const { column: { onFilter: onFilter, filters: filters }, filteredKeys: filteredKeys } = filterState;
        if (onFilter && filteredKeys && filteredKeys.length) return currentData// shallow copy
        .map((record)=>Object.assign({}, record)).filter((record)=>filteredKeys.some((key)=>{
                const keys = (0, $d8efb47a3aae503f$export$50792ddeed01ab0a)(filters);
                const keyIndex = keys.findIndex((k)=>String(k) === String(key));
                const realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                // filter children
                if (record[childrenColumnName]) record[childrenColumnName] = $d1c35acf386da2d6$export$37643bb40f4c1c56(record[childrenColumnName], filterStates, childrenColumnName);
                return onFilter(realKey, record);
            }));
        return currentData;
    }, data);
    return filterDatas;
};
const $d1c35acf386da2d6$var$getMergedColumns = (rawMergedColumns)=>rawMergedColumns.flatMap((column)=>{
        if ('children' in column) return [
            column
        ].concat((0, $fvBso.default)($d1c35acf386da2d6$var$getMergedColumns(column.children || [])));
        return [
            column
        ];
    });
const $d1c35acf386da2d6$var$useFilter = (props)=>{
    const { prefixCls: prefixCls, dropdownPrefixCls: dropdownPrefixCls, mergedColumns: rawMergedColumns, onFilterChange: onFilterChange, getPopupContainer: getPopupContainer, locale: tableLocale, rootClassName: rootClassName } = props;
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Table');
    const mergedColumns = $jMaZ8.useMemo(()=>$d1c35acf386da2d6$var$getMergedColumns(rawMergedColumns || []), [
        rawMergedColumns
    ]);
    const [filterStates, setFilterStates] = $jMaZ8.useState(()=>$d1c35acf386da2d6$var$collectFilterStates(mergedColumns, true));
    const mergedFilterStates = $jMaZ8.useMemo(()=>{
        const collectedStates = $d1c35acf386da2d6$var$collectFilterStates(mergedColumns, false);
        if (collectedStates.length === 0) return collectedStates;
        let filteredKeysIsAllNotControlled = true;
        let filteredKeysIsAllControlled = true;
        collectedStates.forEach((_ref3)=>{
            let { filteredKeys: filteredKeys } = _ref3;
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) {
            // Filter column may have been removed
            const keyList = (mergedColumns || []).map((column, index)=>(0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(column, (0, $9b33cf6cc3cffdfa$export$7e4db04adce9b4db)(index)));
            return filterStates.filter((_ref4)=>{
                let { key: key } = _ref4;
                return keyList.includes(key);
            }).map((item)=>{
                const col = mergedColumns[keyList.findIndex((key)=>key === item.key)];
                return Object.assign(Object.assign({}, item), {
                    column: Object.assign(Object.assign({}, item.column), col),
                    forceFiltered: col.filtered
                });
            });
        }
        warning(filteredKeysIsAllControlled, 'usage', 'Columns should all contain `filteredValue` or not contain `filteredValue`.');
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    const filters = $jMaZ8.useMemo(()=>$d1c35acf386da2d6$var$generateFilterInfo(mergedFilterStates), [
        mergedFilterStates
    ]);
    const triggerFilter = (filterState)=>{
        const newFilterStates = mergedFilterStates.filter((_ref5)=>{
            let { key: key } = _ref5;
            return key !== filterState.key;
        });
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($d1c35acf386da2d6$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    const transformColumns = (innerColumns)=>$d1c35acf386da2d6$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, undefined, rootClassName);
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
};
var $d1c35acf386da2d6$export$2e2bcd8739ae039 = $d1c35acf386da2d6$var$useFilter;



var $jMaZ8 = parcelRequire("jMaZ8");
const $07f6cd84730d57db$var$useLazyKVMap = (data, childrenColumnName, getRowKey)=>{
    const mapCacheRef = $jMaZ8.useRef({});
    function getRecordByKey(key) {
        var _a;
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            const kvMap = new Map();
            function dig(records) {
                records.forEach((record, index)=>{
                    const rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if (record && typeof record === 'object' && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return (_a = mapCacheRef.current.kvMap) === null || _a === void 0 ? void 0 : _a.get(key);
    }
    return [
        getRecordByKey
    ];
};
var $07f6cd84730d57db$export$2e2bcd8739ae039 = $07f6cd84730d57db$var$useLazyKVMap;



var $jMaZ8 = parcelRequire("jMaZ8");

var $3d80be9dd5919e84$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3d80be9dd5919e84$export$5716e8bcb003888d = 10;
function $3d80be9dd5919e84$export$27eceeed7bf0f4c2(mergedPagination, pagination) {
    const param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
    Object.keys(paginationObj).forEach((pageProp)=>{
        const value = mergedPagination[pageProp];
        if (typeof value !== 'function') param[pageProp] = value;
    });
    return param;
}
function $3d80be9dd5919e84$var$usePagination(total, onChange, pagination) {
    const _a = pagination && typeof pagination === 'object' ? pagination : {}, { total: paginationTotal = 0 } = _a, paginationObj = $3d80be9dd5919e84$var$__rest(_a, [
        "total"
    ]);
    const [innerPagination, setInnerPagination] = (0, $jMaZ8.useState)(()=>({
            current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : $3d80be9dd5919e84$export$5716e8bcb003888d
        }));
    // ============ Basic Pagination Config ============
    const mergedPagination = (0, $d74635dfa3f27b0f$export$2e2bcd8739ae039)(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    const refreshPagination = (current, pageSize)=>{
        setInnerPagination({
            current: current !== null && current !== void 0 ? current : 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    const onInternalChange = (current, pageSize)=>{
        var _a;
        if (pagination) (_a = pagination.onChange) === null || _a === void 0 || _a.call(pagination, current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize));
    };
    if (pagination === false) return [
        {},
        ()=>{}
    ];
    return [
        Object.assign(Object.assign({}, mergedPagination), {
            onChange: onInternalChange
        }),
        refreshPagination
    ];
}
var $3d80be9dd5919e84$export$2e2bcd8739ae039 = $3d80be9dd5919e84$var$usePagination;




var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $d5adc3b8381bec4e$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
var $d5adc3b8381bec4e$export$2e2bcd8739ae039 = $d5adc3b8381bec4e$var$CaretDownOutlined;



var $f7ac4bd931e4a8a4$var$CaretDownOutlined = function CaretDownOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $d5adc3b8381bec4e$export$2e2bcd8739ae039)
    }));
};
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ var $f7ac4bd931e4a8a4$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($f7ac4bd931e4a8a4$var$CaretDownOutlined);
$f7ac4bd931e4a8a4$var$RefIcon.displayName = 'CaretDownOutlined';
var $f7ac4bd931e4a8a4$export$2e2bcd8739ae039 = $f7ac4bd931e4a8a4$var$RefIcon;



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $182df7dc665d6434$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
var $182df7dc665d6434$export$2e2bcd8739ae039 = $182df7dc665d6434$var$CaretUpOutlined;



var $443362591b566bb0$var$CaretUpOutlined = function CaretUpOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $182df7dc665d6434$export$2e2bcd8739ae039)
    }));
};
/**![caret-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC45IDY4OUw1MzAuNSAzMDguMmMtOS40LTEwLjktMjcuNS0xMC45LTM3IDBMMTY1LjEgNjg5Yy0xMi4yIDE0LjItMS4yIDM1IDE4LjUgMzVoNjU2LjhjMTkuNyAwIDMwLjctMjAuOCAxOC41LTM1eiIgLz48L3N2Zz4=) */ var $443362591b566bb0$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($443362591b566bb0$var$CaretUpOutlined);
$443362591b566bb0$var$RefIcon.displayName = 'CaretUpOutlined';
var $443362591b566bb0$export$2e2bcd8739ae039 = $443362591b566bb0$var$RefIcon;



var $giSak = parcelRequire("giSak");



"use client";
const $47cf5b169f7da1ff$var$ASCEND = 'ascend';
const $47cf5b169f7da1ff$var$DESCEND = 'descend';
const $47cf5b169f7da1ff$var$getMultiplePriority = (column)=>{
    if (typeof column.sorter === 'object' && typeof column.sorter.multiple === 'number') return column.sorter.multiple;
    return false;
};
const $47cf5b169f7da1ff$var$getSortFunction = (sorter)=>{
    if (typeof sorter === 'function') return sorter;
    if (sorter && typeof sorter === 'object' && sorter.compare) return sorter.compare;
    return false;
};
const $47cf5b169f7da1ff$var$nextSortDirection = (sortDirections, current)=>{
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
};
const $47cf5b169f7da1ff$var$collectSortStates = (columns, init, pos)=>{
    let sortStates = [];
    const pushState = (column, columnPos)=>{
        sortStates.push({
            column: column,
            key: (0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $47cf5b169f7da1ff$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    };
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $9b33cf6cc3cffdfa$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $fvBso.default)(sortStates), (0, $fvBso.default)($47cf5b169f7da1ff$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $47cf5b169f7da1ff$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
};
const $47cf5b169f7da1ff$var$injectSorter = (prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos)=>{
    const finalColumns = (columns || []).map((column, index)=>{
        const columnPos = (0, $9b33cf6cc3cffdfa$export$7e4db04adce9b4db)(index, pos);
        let newColumn = column;
        if (newColumn.sorter) {
            const sortDirections = newColumn.sortDirections || defaultSortDirections;
            const showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            const columnKey = (0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(newColumn, columnPos);
            const sorterState = sorterStates.find((_ref)=>{
                let { key: key } = _ref;
                return key === columnKey;
            });
            const sortOrder = sorterState ? sorterState.sortOrder : null;
            const nextSortOrder = $47cf5b169f7da1ff$var$nextSortDirection(sortDirections, sortOrder);
            let sorter;
            if (column.sortIcon) sorter = column.sortIcon({
                sortOrder: sortOrder
            });
            else {
                const upNode = sortDirections.includes($47cf5b169f7da1ff$var$ASCEND) && /*#__PURE__*/ $jMaZ8.createElement((0, $443362591b566bb0$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-column-sorter-up`, {
                        active: sortOrder === $47cf5b169f7da1ff$var$ASCEND
                    })
                });
                const downNode = sortDirections.includes($47cf5b169f7da1ff$var$DESCEND) && /*#__PURE__*/ $jMaZ8.createElement((0, $f7ac4bd931e4a8a4$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-column-sorter-down`, {
                        active: sortOrder === $47cf5b169f7da1ff$var$DESCEND
                    })
                });
                sorter = /*#__PURE__*/ $jMaZ8.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-column-sorter`, {
                        [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
                    })
                }, /*#__PURE__*/ $jMaZ8.createElement("span", {
                    className: `${prefixCls}-column-sorter-inner`,
                    "aria-hidden": "true"
                }, upNode, downNode));
            }
            const { cancelSort: cancelSort, triggerAsc: triggerAsc, triggerDesc: triggerDesc } = tableLocale || {};
            let sortTip = cancelSort;
            if (nextSortOrder === $47cf5b169f7da1ff$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $47cf5b169f7da1ff$var$ASCEND) sortTip = triggerAsc;
            const tooltipProps = typeof showSorterTooltip === 'object' ? Object.assign({
                title: sortTip
            }, showSorterTooltip) : {
                title: sortTip
            };
            newColumn = Object.assign(Object.assign({}, newColumn), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(newColumn.className, {
                    [`${prefixCls}-column-sort`]: sortOrder
                }),
                title: (renderProps)=>{
                    const columnSortersClass = `${prefixCls}-column-sorters`;
                    const renderColumnTitleWrapper = /*#__PURE__*/ $jMaZ8.createElement("span", {
                        className: `${prefixCls}-column-title`
                    }, (0, $9b33cf6cc3cffdfa$export$cfda450db2088de7)(column.title, renderProps));
                    const renderSortTitle = /*#__PURE__*/ $jMaZ8.createElement("div", {
                        className: columnSortersClass
                    }, renderColumnTitleWrapper, sorter);
                    if (showSorterTooltip) {
                        if (typeof showSorterTooltip !== 'boolean' && (showSorterTooltip === null || showSorterTooltip === void 0 ? void 0 : showSorterTooltip.target) === 'sorter-icon') return /*#__PURE__*/ $jMaZ8.createElement("div", {
                            className: `${columnSortersClass} ${prefixCls}-column-sorters-tooltip-target-sorter`
                        }, renderColumnTitleWrapper, /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), Object.assign({}, tooltipProps), sorter));
                        return /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), Object.assign({}, tooltipProps), renderSortTitle);
                    }
                    return renderSortTitle;
                },
                onHeaderCell: (col)=>{
                    var _a;
                    const cell = ((_a = column.onHeaderCell) === null || _a === void 0 ? void 0 : _a.call(column, col)) || {};
                    const originOnClick = cell.onClick;
                    const originOKeyDown = cell.onKeyDown;
                    cell.onClick = (event)=>{
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $47cf5b169f7da1ff$var$getMultiplePriority(column)
                        });
                        originOnClick === null || originOnClick === void 0 || originOnClick(event);
                    };
                    cell.onKeyDown = (event)=>{
                        if (event.keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $47cf5b169f7da1ff$var$getMultiplePriority(column)
                            });
                            originOKeyDown === null || originOKeyDown === void 0 || originOKeyDown(event);
                        }
                    };
                    const renderTitle = (0, $9b33cf6cc3cffdfa$export$1c24e0676a106839)(column.title, {});
                    const displayTitle = renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sortOrder) cell['aria-sort'] = sortOrder === 'ascend' ? 'ascending' : 'descending';
                    else cell['aria-label'] = displayTitle || '';
                    cell.className = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(cell.className, `${prefixCls}-column-has-sorters`);
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle !== null && renderTitle !== void 0 ? renderTitle : '').toString();
                    return cell;
                }
            });
        }
        if ('children' in newColumn) newColumn = Object.assign(Object.assign({}, newColumn), {
            children: $47cf5b169f7da1ff$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
        });
        return newColumn;
    });
    return finalColumns;
};
const $47cf5b169f7da1ff$var$stateToInfo = (sorterState)=>{
    const { column: column, sortOrder: sortOrder } = sorterState;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
};
const $47cf5b169f7da1ff$var$generateSorterInfo = (sorterStates)=>{
    const activeSorters = sorterStates.filter((_ref2)=>{
        let { sortOrder: sortOrder } = _ref2;
        return sortOrder;
    }).map($47cf5b169f7da1ff$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (activeSorters.length === 0 && sorterStates.length) {
        const lastIndex = sorterStates.length - 1;
        return Object.assign(Object.assign({}, $47cf5b169f7da1ff$var$stateToInfo(sorterStates[lastIndex])), {
            column: undefined,
            order: undefined,
            field: undefined,
            columnKey: undefined
        });
    }
    if (activeSorters.length <= 1) return activeSorters[0] || {};
    return activeSorters;
};
const $47cf5b169f7da1ff$export$594b2c8da4a70ee = (data, sortStates, childrenColumnName)=>{
    const innerSorterStates = sortStates.slice().sort((a, b)=>b.multiplePriority - a.multiplePriority);
    const cloneData = data.slice();
    const runningSorters = innerSorterStates.filter((_ref3)=>{
        let { column: { sorter: sorter }, sortOrder: sortOrder } = _ref3;
        return $47cf5b169f7da1ff$var$getSortFunction(sorter) && sortOrder;
    });
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort((record1, record2)=>{
        for(let i = 0; i < runningSorters.length; i += 1){
            const sorterState = runningSorters[i];
            const { column: { sorter: sorter }, sortOrder: sortOrder } = sorterState;
            const compareFn = $47cf5b169f7da1ff$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                const compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $47cf5b169f7da1ff$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map((record)=>{
        const subRecords = record[childrenColumnName];
        if (subRecords) return Object.assign(Object.assign({}, record), {
            [childrenColumnName]: $47cf5b169f7da1ff$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)
        });
        return record;
    });
};
const $47cf5b169f7da1ff$var$useFilterSorter = (props)=>{
    const { prefixCls: prefixCls, mergedColumns: mergedColumns, sortDirections: sortDirections, tableLocale: tableLocale, showSorterTooltip: showSorterTooltip, onSorterChange: onSorterChange } = props;
    const [sortStates, setSortStates] = $jMaZ8.useState($47cf5b169f7da1ff$var$collectSortStates(mergedColumns, true));
    const getColumnKeys = (columns, pos)=>{
        const newKeys = [];
        columns.forEach((item, index)=>{
            const columnPos = (0, $9b33cf6cc3cffdfa$export$7e4db04adce9b4db)(index, pos);
            newKeys.push((0, $9b33cf6cc3cffdfa$export$480219a02f196e72)(item, columnPos));
            if (Array.isArray(item.children)) {
                const childKeys = getColumnKeys(item.children, columnPos);
                newKeys.push.apply(newKeys, (0, $fvBso.default)(childKeys));
            }
        });
        return newKeys;
    };
    const mergedSorterStates = $jMaZ8.useMemo(()=>{
        let validate = true;
        const collectedStates = $47cf5b169f7da1ff$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) {
            const mergedColumnsKeys = getColumnKeys(mergedColumns);
            return sortStates.filter((_ref4)=>{
                let { key: key } = _ref4;
                return mergedColumnsKeys.includes(key);
            });
        }
        const validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push(Object.assign(Object.assign({}, state), {
                sortOrder: null
            }));
        }
        let multipleMode = null;
        collectedStates.forEach((state)=>{
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    const columnTitleSorterProps = $jMaZ8.useMemo(()=>{
        var _a, _b;
        const sortColumns = mergedSorterStates.map((_ref5)=>{
            let { column: column, sortOrder: sortOrder } = _ref5;
            return {
                column: column,
                order: sortOrder
            };
        });
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: (_a = sortColumns[0]) === null || _a === void 0 ? void 0 : _a.column,
            sortOrder: (_b = sortColumns[0]) === null || _b === void 0 ? void 0 : _b.order
        };
    }, [
        mergedSorterStates
    ]);
    const triggerSorter = (sortState)=>{
        let newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $fvBso.default)(mergedSorterStates.filter((_ref6)=>{
            let { key: key } = _ref6;
            return key !== sortState.key;
        })), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($47cf5b169f7da1ff$var$generateSorterInfo(newSorterStates), newSorterStates);
    };
    const transformColumns = (innerColumns)=>$47cf5b169f7da1ff$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
    const getSorters = ()=>$47cf5b169f7da1ff$var$generateSorterInfo(mergedSorterStates);
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
};
var $47cf5b169f7da1ff$export$2e2bcd8739ae039 = $47cf5b169f7da1ff$var$useFilterSorter;



var $jMaZ8 = parcelRequire("jMaZ8");

const $7083d7a47d925f49$var$fillTitle = (columns, columnTitleProps)=>{
    const finalColumns = columns.map((column)=>{
        const cloneColumn = Object.assign({}, column);
        cloneColumn.title = (0, $9b33cf6cc3cffdfa$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ('children' in cloneColumn) cloneColumn.children = $7083d7a47d925f49$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
    return finalColumns;
};
const $7083d7a47d925f49$var$useTitleColumns = (columnTitleProps)=>{
    const filledColumns = $jMaZ8.useCallback((columns)=>$7083d7a47d925f49$var$fillTitle(columns, columnTitleProps), [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
};
var $7083d7a47d925f49$export$2e2bcd8739ae039 = $7083d7a47d925f49$var$useTitleColumns;



"use client";
/**
 * Same as `rc-table` but we modify trigger children update logic instead.
 */ const $314cb6087d63a68b$var$RcTable = (0, $d3fe3c728f980334$export$13da147d1fdf3e3c)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $314cb6087d63a68b$export$2e2bcd8739ae039 = $314cb6087d63a68b$var$RcTable;



"use client";
/**
 * Same as `rc-table` but we modify trigger children update logic instead.
 */ const $caaad36872016bf4$var$RcVirtualTable = (0, $40609771d67f0e26$export$4747b79b36862360)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $caaad36872016bf4$export$2e2bcd8739ae039 = $caaad36872016bf4$var$RcVirtualTable;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $a73afda141209644$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableHeaderBg: tableHeaderBg, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    const tableBorder = `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal)=>({
            [`&${componentCls}-${size}`]: {
                [`> ${componentCls}-container`]: {
                    [`> ${componentCls}-content, > ${componentCls}-body`]: {
                        [`
            > table > tbody > tr > th,
            > table > tbody > tr > td
          `]: {
                            [`> ${componentCls}-expanded-row-fixed`]: {
                                margin: `${(0, $4g3I0.unit)(calc(paddingVertical).mul(-1).equal())}
              ${(0, $4g3I0.unit)(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
                            }
                        }
                    }
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}${componentCls}-bordered`]: Object.assign(Object.assign(Object.assign({
                // ============================ Title =============================
                [`> ${componentCls}-title`]: {
                    border: tableBorder,
                    borderBottom: 0
                },
                // ============================ Content ============================
                [`> ${componentCls}-container`]: {
                    borderInlineStart: tableBorder,
                    borderTop: tableBorder,
                    [`
            > ${componentCls}-content,
            > ${componentCls}-header,
            > ${componentCls}-body,
            > ${componentCls}-summary
          `]: {
                        '> table': {
                            // ============================= Cell =============================
                            [`
                > thead > tr > th,
                > thead > tr > td,
                > tbody > tr > th,
                > tbody > tr > td,
                > tfoot > tr > th,
                > tfoot > tr > td
              `]: {
                                borderInlineEnd: tableBorder
                            },
                            // ============================ Header ============================
                            '> thead': {
                                '> tr:not(:last-child) > th': {
                                    borderBottom: tableBorder
                                },
                                '> tr > th::before': {
                                    backgroundColor: 'transparent !important'
                                }
                            },
                            // Fixed right should provides additional border
                            [`
                > thead > tr,
                > tbody > tr,
                > tfoot > tr
              `]: {
                                [`> ${componentCls}-cell-fix-right-first::after`]: {
                                    borderInlineEnd: tableBorder
                                }
                            },
                            // ========================== Expandable ==========================
                            [`
                > tbody > tr > th,
                > tbody > tr > td
              `]: {
                                [`> ${componentCls}-expanded-row-fixed`]: {
                                    margin: `${(0, $4g3I0.unit)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $4g3I0.unit)(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                                    '&::after': {
                                        position: 'absolute',
                                        top: 0,
                                        insetInlineEnd: lineWidth,
                                        bottom: 0,
                                        borderInlineEnd: tableBorder,
                                        content: '""'
                                    }
                                }
                            }
                        }
                    }
                },
                // ============================ Scroll ============================
                [`&${componentCls}-scroll-horizontal`]: {
                    [`> ${componentCls}-container > ${componentCls}-body`]: {
                        '> table > tbody': {
                            [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                                '> th, > td': {
                                    borderInlineEnd: 0
                                }
                            }
                        }
                    }
                }
            }, getSizeBorderStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle)), getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall)), {
                // ============================ Footer ============================
                [`> ${componentCls}-footer`]: {
                    border: tableBorder,
                    borderTop: 0
                }
            }),
            // ============================ Nested ============================
            [`${componentCls}-cell`]: {
                [`${componentCls}-container:first-child`]: {
                    // :first-child to avoid the case when bordered and title is set
                    borderTop: 0
                },
                // https://github.com/ant-design/ant-design/issues/35577
                '&-scrollbar:not([rowspan])': {
                    boxShadow: `0 ${(0, $4g3I0.unit)(lineWidth)} 0 ${(0, $4g3I0.unit)(lineWidth)} ${tableHeaderBg}`
                }
            },
            [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
                borderInlineEnd: tableBorder
            }
        }
    };
};
var $a73afda141209644$export$2e2bcd8739ae039 = $a73afda141209644$var$genBorderedStyle;



const $9f96bf57ad8c109c$var$genEllipsisStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-cell-ellipsis`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$b2b65df0d0824629)), {
                wordBreak: 'keep-all',
                // Fixed first or last should special process
                [`
          &${componentCls}-cell-fix-left-last,
          &${componentCls}-cell-fix-right-first
        `]: {
                    overflow: 'visible',
                    [`${componentCls}-cell-content`]: {
                        display: 'block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                },
                [`${componentCls}-column-title`]: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'keep-all'
                }
            })
        }
    };
};
var $9f96bf57ad8c109c$export$2e2bcd8739ae039 = $9f96bf57ad8c109c$var$genEllipsisStyle;


// ========================= Placeholder ==========================
const $536a2890f0438d8e$var$genEmptyStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
                textAlign: 'center',
                color: token.colorTextDisabled,
                [`
          &:hover > th,
          &:hover > td,
        `]: {
                    background: token.colorBgContainer
                }
            }
        }
    };
};
var $536a2890f0438d8e$export$2e2bcd8739ae039 = $536a2890f0438d8e$var$genEmptyStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $3628de15f7dbe14d$var$genExpandStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, paddingXS: paddingXS, lineType: lineType, tableBorderColor: tableBorderColor, tableExpandIconBg: tableExpandIconBg, tableExpandColumnWidth: tableExpandColumnWidth, borderRadius: borderRadius, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandedRowBg: tableExpandedRowBg, paddingXXS: paddingXXS, expandIconMarginTop: expandIconMarginTop, expandIconSize: expandIconSize, expandIconHalfInner: expandIconHalfInner, expandIconScale: expandIconScale, calc: calc } = token;
    const tableBorder = `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-expand-icon-col`]: {
                width: tableExpandColumnWidth
            },
            [`${componentCls}-row-expand-icon-cell`]: {
                textAlign: 'center',
                [`${componentCls}-row-expand-icon`]: {
                    display: 'inline-flex',
                    float: 'none',
                    verticalAlign: 'sub'
                }
            },
            [`${componentCls}-row-indent`]: {
                height: 1,
                float: 'left'
            },
            [`${componentCls}-row-expand-icon`]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$9a16e7694a707ab4)(token)), {
                position: 'relative',
                float: 'left',
                width: expandIconSize,
                height: expandIconSize,
                color: 'inherit',
                lineHeight: (0, $4g3I0.unit)(expandIconSize),
                background: tableExpandIconBg,
                border: tableBorder,
                borderRadius: borderRadius,
                transform: `scale(${expandIconScale})`,
                '&:focus, &:hover, &:active': {
                    borderColor: 'currentcolor'
                },
                '&::before, &::after': {
                    position: 'absolute',
                    background: 'currentcolor',
                    transition: `transform ${motionDurationSlow} ease-out`,
                    content: '""'
                },
                '&::before': {
                    top: expandIconHalfInner,
                    insetInlineEnd: expandIconLineOffset,
                    insetInlineStart: expandIconLineOffset,
                    height: lineWidth
                },
                '&::after': {
                    top: expandIconLineOffset,
                    bottom: expandIconLineOffset,
                    insetInlineStart: expandIconHalfInner,
                    width: lineWidth,
                    transform: 'rotate(90deg)'
                },
                // Motion effect
                '&-collapsed::before': {
                    transform: 'rotate(-180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                },
                '&-spaced': {
                    '&::before, &::after': {
                        display: 'none',
                        content: 'none'
                    },
                    background: 'transparent',
                    border: 0,
                    visibility: 'hidden'
                }
            }),
            [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
                marginTop: expandIconMarginTop,
                marginInlineEnd: paddingXS
            },
            [`tr${componentCls}-expanded-row`]: {
                '&, &:hover': {
                    '> th, > td': {
                        background: tableExpandedRowBg
                    }
                },
                // https://github.com/ant-design/ant-design/issues/25573
                [`${antCls}-descriptions-view`]: {
                    display: 'flex',
                    table: {
                        flex: 'auto',
                        width: '100%'
                    }
                }
            },
            // With fixed
            [`${componentCls}-expanded-row-fixed`]: {
                position: 'relative',
                margin: `${(0, $4g3I0.unit)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $4g3I0.unit)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                padding: `${(0, $4g3I0.unit)(tablePaddingVertical)} ${(0, $4g3I0.unit)(tablePaddingHorizontal)}`
            }
        }
    };
};
var $3628de15f7dbe14d$export$2e2bcd8739ae039 = $3628de15f7dbe14d$var$genExpandStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $ce26a01df1568ae6$var$genFilterStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, tableFilterDropdownWidth: tableFilterDropdownWidth, tableFilterDropdownSearchWidth: tableFilterDropdownSearchWidth, paddingXXS: paddingXXS, paddingXS: paddingXS, colorText: colorText, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, headerIconColor: headerIconColor, fontSizeSM: fontSizeSM, tablePaddingHorizontal: tablePaddingHorizontal, borderRadius: borderRadius, motionDurationSlow: motionDurationSlow, colorTextDescription: colorTextDescription, colorPrimary: colorPrimary, tableHeaderFilterActiveBg: tableHeaderFilterActiveBg, colorTextDisabled: colorTextDisabled, tableFilterDropdownBg: tableFilterDropdownBg, tableFilterDropdownHeight: tableFilterDropdownHeight, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive, boxShadowSecondary: boxShadowSecondary, filterDropdownMenuBg: filterDropdownMenuBg, calc: calc } = token;
    const dropdownPrefixCls = `${antCls}-dropdown`;
    const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
    const treePrefixCls = `${antCls}-tree`;
    const tableBorder = `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${componentCls}-filter-column`]: {
                    display: 'flex',
                    justifyContent: 'space-between'
                },
                [`${componentCls}-filter-trigger`]: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    marginBlock: calc(paddingXXS).mul(-1).equal(),
                    marginInline: `${(0, $4g3I0.unit)(paddingXXS)} ${(0, $4g3I0.unit)(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
                    padding: `0 ${(0, $4g3I0.unit)(paddingXXS)}`,
                    color: headerIconColor,
                    fontSize: fontSizeSM,
                    borderRadius: borderRadius,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}`,
                    '&:hover': {
                        color: colorTextDescription,
                        background: tableHeaderFilterActiveBg
                    },
                    '&.active': {
                        color: colorPrimary
                    }
                }
            }
        },
        {
            // Dropdown
            [`${antCls}-dropdown`]: {
                [tableFilterDropdownPrefixCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                    minWidth: tableFilterDropdownWidth,
                    backgroundColor: tableFilterDropdownBg,
                    borderRadius: borderRadius,
                    boxShadow: boxShadowSecondary,
                    overflow: 'hidden',
                    // Reset menu
                    [`${dropdownPrefixCls}-menu`]: {
                        // https://github.com/ant-design/ant-design/issues/4916
                        // https://github.com/ant-design/ant-design/issues/19542
                        maxHeight: tableFilterDropdownHeight,
                        overflowX: 'hidden',
                        border: 0,
                        boxShadow: 'none',
                        borderRadius: 'unset',
                        backgroundColor: filterDropdownMenuBg,
                        '&:empty::after': {
                            display: 'block',
                            padding: `${(0, $4g3I0.unit)(paddingXS)} 0`,
                            color: colorTextDisabled,
                            fontSize: fontSizeSM,
                            textAlign: 'center',
                            content: '"Not Found"'
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-tree`]: {
                        paddingBlock: `${(0, $4g3I0.unit)(paddingXS)} 0`,
                        paddingInline: paddingXS,
                        [treePrefixCls]: {
                            padding: 0
                        },
                        [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
                            backgroundColor: controlItemBgHover
                        },
                        [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
                            '&, &:hover': {
                                backgroundColor: controlItemBgActive
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-search`]: {
                        padding: paddingXS,
                        borderBottom: tableBorder,
                        '&-input': {
                            input: {
                                minWidth: tableFilterDropdownSearchWidth
                            },
                            [iconCls]: {
                                color: colorTextDisabled
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-checkall`]: {
                        width: '100%',
                        marginBottom: paddingXXS,
                        marginInlineStart: paddingXXS
                    },
                    // Operation
                    [`${tableFilterDropdownPrefixCls}-btns`]: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: `${(0, $4g3I0.unit)(calc(paddingXS).sub(lineWidth).equal())} ${(0, $4g3I0.unit)(paddingXS)}`,
                        overflow: 'hidden',
                        borderTop: tableBorder
                    }
                })
            }
        },
        // Dropdown Menu & SubMenu
        {
            // submenu of table filter dropdown
            [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
                // Checkbox
                [`${antCls}-checkbox-wrapper + span`]: {
                    paddingInlineStart: paddingXS,
                    color: colorText
                },
                '> ul': {
                    maxHeight: 'calc(100vh - 130px)',
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        }
    ];
};
var $ce26a01df1568ae6$export$2e2bcd8739ae039 = $ce26a01df1568ae6$var$genFilterStyle;


const $f11f28dea42c31ff$var$genFixedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, colorSplit: colorSplit, motionDurationSlow: motionDurationSlow, zIndexTableFixed: zIndexTableFixed, tableBg: tableBg, zIndexTableSticky: zIndexTableSticky, calc: calc } = token;
    const shadowColor = colorSplit;
    // Follow style is magic of shadow which should not follow token:
    return {
        [`${componentCls}-wrapper`]: {
            [`
        ${componentCls}-cell-fix-left,
        ${componentCls}-cell-fix-right
      `]: {
                position: 'sticky !important',
                zIndex: zIndexTableFixed,
                background: tableBg
            },
            [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after
      `]: {
                position: 'absolute',
                top: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                bottom: calc(lineWidth).mul(-1).equal(),
                width: 30,
                transform: 'translateX(100%)',
                transition: `box-shadow ${motionDurationSlow}`,
                content: '""',
                pointerEvents: 'none'
            },
            [`${componentCls}-cell-fix-left-all::after`]: {
                display: 'none'
            },
            [`
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
                position: 'absolute',
                top: 0,
                bottom: calc(lineWidth).mul(-1).equal(),
                left: {
                    _skip_check_: true,
                    value: 0
                },
                width: 30,
                transform: 'translateX(-100%)',
                transition: `box-shadow ${motionDurationSlow}`,
                content: '""',
                pointerEvents: 'none'
            },
            [`${componentCls}-container`]: {
                position: 'relative',
                '&::before, &::after': {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    zIndex: calc(zIndexTableSticky).add(1).equal({
                        unit: false
                    }),
                    width: 30,
                    transition: `box-shadow ${motionDurationSlow}`,
                    content: '""',
                    pointerEvents: 'none'
                },
                '&::before': {
                    insetInlineStart: 0
                },
                '&::after': {
                    insetInlineEnd: 0
                }
            },
            [`${componentCls}-ping-left`]: {
                [`&:not(${componentCls}-has-fix-left) ${componentCls}-container::before`]: {
                    boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
                },
                [`
          ${componentCls}-cell-fix-left-first::after,
          ${componentCls}-cell-fix-left-last::after
        `]: {
                    boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
                },
                [`${componentCls}-cell-fix-left-last::before`]: {
                    backgroundColor: 'transparent !important'
                }
            },
            [`${componentCls}-ping-right`]: {
                [`&:not(${componentCls}-has-fix-right) ${componentCls}-container::after`]: {
                    boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
                },
                [`
          ${componentCls}-cell-fix-right-first::after,
          ${componentCls}-cell-fix-right-last::after
        `]: {
                    boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
                }
            },
            // Gapped fixed Columns do not show the shadow
            [`${componentCls}-fixed-column-gapped`]: {
                [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after,
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
                    boxShadow: 'none'
                }
            }
        }
    };
};
var $f11f28dea42c31ff$export$2e2bcd8739ae039 = $f11f28dea42c31ff$var$genFixedStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $2a68319ae38dab87$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, margin: margin } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Pagination ==========================
            [`${componentCls}-pagination${antCls}-pagination`]: {
                margin: `${(0, $4g3I0.unit)(margin)} 0`
            },
            [`${componentCls}-pagination`]: {
                display: 'flex',
                flexWrap: 'wrap',
                rowGap: token.paddingXS,
                '> *': {
                    flex: 'none'
                },
                '&-left': {
                    justifyContent: 'flex-start'
                },
                '&-center': {
                    justifyContent: 'center'
                },
                '&-right': {
                    justifyContent: 'flex-end'
                }
            }
        }
    };
};
var $2a68319ae38dab87$export$2e2bcd8739ae039 = $2a68319ae38dab87$var$genPaginationStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $cdeed8320eec20e2$var$genRadiusStyle = (token)=>{
    const { componentCls: componentCls, tableRadius: tableRadius } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [componentCls]: {
                // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
                [`${componentCls}-title, ${componentCls}-header`]: {
                    borderRadius: `${(0, $4g3I0.unit)(tableRadius)} ${(0, $4g3I0.unit)(tableRadius)} 0 0`
                },
                [`${componentCls}-title + ${componentCls}-container`]: {
                    borderStartStartRadius: 0,
                    borderStartEndRadius: 0,
                    // https://github.com/ant-design/ant-design/issues/41975
                    [`${componentCls}-header, table`]: {
                        borderRadius: 0
                    },
                    'table > thead > tr:first-child': {
                        'th:first-child, th:last-child, td:first-child, td:last-child': {
                            borderRadius: 0
                        }
                    }
                },
                '&-container': {
                    borderStartStartRadius: tableRadius,
                    borderStartEndRadius: tableRadius,
                    'table > thead > tr:first-child': {
                        '> *:first-child': {
                            borderStartStartRadius: tableRadius
                        },
                        '> *:last-child': {
                            borderStartEndRadius: tableRadius
                        }
                    }
                },
                '&-footer': {
                    borderRadius: `0 0 ${(0, $4g3I0.unit)(tableRadius)} ${(0, $4g3I0.unit)(tableRadius)}`
                }
            }
        }
    };
};
var $cdeed8320eec20e2$export$2e2bcd8739ae039 = $cdeed8320eec20e2$var$genRadiusStyle;


const $bff371e3a2f8ca86$var$genStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper-rtl`]: {
            direction: 'rtl',
            table: {
                direction: 'rtl'
            },
            [`${componentCls}-pagination-left`]: {
                justifyContent: 'flex-end'
            },
            [`${componentCls}-pagination-right`]: {
                justifyContent: 'flex-start'
            },
            [`${componentCls}-row-expand-icon`]: {
                float: 'right',
                '&::after': {
                    transform: 'rotate(-90deg)'
                },
                '&-collapsed::before': {
                    transform: 'rotate(180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                }
            },
            [`${componentCls}-container`]: {
                '&::before': {
                    insetInlineStart: 'unset',
                    insetInlineEnd: 0
                },
                '&::after': {
                    insetInlineStart: 0,
                    insetInlineEnd: 'unset'
                },
                [`${componentCls}-row-indent`]: {
                    float: 'right'
                }
            }
        }
    };
};
var $bff371e3a2f8ca86$export$2e2bcd8739ae039 = $bff371e3a2f8ca86$var$genStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $cf00aa976c6fdbfa$var$genSelectionStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, fontSizeIcon: fontSizeIcon, padding: padding, paddingXS: paddingXS, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor, tableSelectionColumnWidth: tableSelectionColumnWidth, tableSelectedRowBg: tableSelectedRowBg, tableSelectedRowHoverBg: tableSelectedRowHoverBg, tableRowHoverBg: tableRowHoverBg, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Selections ==========================
            [`${componentCls}-selection-col`]: {
                width: tableSelectionColumnWidth,
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
                }
            },
            [`${componentCls}-bordered ${componentCls}-selection-col`]: {
                width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
                }
            },
            [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS,
                textAlign: 'center',
                [`${antCls}-radio-wrapper`]: {
                    marginInlineEnd: 0
                }
            },
            [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
                zIndex: calc(token.zIndexTableFixed).add(1).equal({
                    unit: false
                })
            },
            [`table tr th${componentCls}-selection-column::after`]: {
                backgroundColor: 'transparent !important'
            },
            [`${componentCls}-selection`]: {
                position: 'relative',
                display: 'inline-flex',
                flexDirection: 'column'
            },
            [`${componentCls}-selection-extra`]: {
                position: 'absolute',
                top: 0,
                zIndex: 1,
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                marginInlineStart: '100%',
                paddingInlineStart: (0, $4g3I0.unit)(calc(tablePaddingHorizontal).div(4).equal()),
                [iconCls]: {
                    color: headerIconColor,
                    fontSize: fontSizeIcon,
                    verticalAlign: 'baseline',
                    '&:hover': {
                        color: headerIconHoverColor
                    }
                }
            },
            // ============================= Rows =============================
            [`${componentCls}-tbody`]: {
                [`${componentCls}-row`]: {
                    [`&${componentCls}-row-selected`]: {
                        [`> ${componentCls}-cell`]: {
                            background: tableSelectedRowBg,
                            '&-row-hover': {
                                background: tableSelectedRowHoverBg
                            }
                        }
                    },
                    [`> ${componentCls}-cell-row-hover`]: {
                        background: tableRowHoverBg
                    }
                }
            }
        }
    };
};
var $cf00aa976c6fdbfa$export$2e2bcd8739ae039 = $cf00aa976c6fdbfa$var$genSelectionStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $a43182240b7d4e46$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, tableExpandColumnWidth: tableExpandColumnWidth, calc: calc } = token;
    const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize)=>({
            [`${componentCls}${componentCls}-${size}`]: {
                fontSize: fontSize,
                [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
                    padding: `${(0, $4g3I0.unit)(paddingVertical)} ${(0, $4g3I0.unit)(paddingHorizontal)}`
                },
                [`${componentCls}-filter-trigger`]: {
                    marginInlineEnd: (0, $4g3I0.unit)(calc(paddingHorizontal).div(2).mul(-1).equal())
                },
                [`${componentCls}-expanded-row-fixed`]: {
                    margin: `${(0, $4g3I0.unit)(calc(paddingVertical).mul(-1).equal())} ${(0, $4g3I0.unit)(calc(paddingHorizontal).mul(-1).equal())}`
                },
                [`${componentCls}-tbody`]: {
                    // ========================= Nest Table ===========================
                    [`${componentCls}-wrapper:only-child ${componentCls}`]: {
                        marginBlock: (0, $4g3I0.unit)(calc(paddingVertical).mul(-1).equal()),
                        marginInline: `${(0, $4g3I0.unit)(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${(0, $4g3I0.unit)(calc(paddingHorizontal).mul(-1).equal())}`
                    }
                },
                // https://github.com/ant-design/ant-design/issues/35167
                [`${componentCls}-selection-extra`]: {
                    paddingInlineStart: (0, $4g3I0.unit)(calc(paddingHorizontal).div(4).equal())
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, getSizeStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle)), getSizeStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall))
    };
};
var $a43182240b7d4e46$export$2e2bcd8739ae039 = $a43182240b7d4e46$var$genSizeStyle;


const $80d110a9a80e6bd8$var$genSorterStyle = (token)=>{
    const { componentCls: componentCls, marginXXS: marginXXS, fontSizeIcon: fontSizeIcon, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
                outline: 'none',
                cursor: 'pointer',
                // why left 0s? Avoid column header move with transition when left is changed
                // https://github.com/ant-design/ant-design/issues/50588
                transition: `all ${token.motionDurationSlow}, left 0s`,
                '&:hover': {
                    background: token.tableHeaderSortHoverBg,
                    '&::before': {
                        backgroundColor: 'transparent !important'
                    }
                },
                '&:focus-visible': {
                    color: token.colorPrimary
                },
                // https://github.com/ant-design/ant-design/issues/30969
                [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
                    background: token.tableFixedHeaderSortActiveBg
                }
            },
            [`${componentCls}-thead th${componentCls}-column-sort`]: {
                background: token.tableHeaderSortBg,
                '&::before': {
                    backgroundColor: 'transparent !important'
                }
            },
            [`td${componentCls}-column-sort`]: {
                background: token.tableBodySortBg
            },
            [`${componentCls}-column-title`]: {
                position: 'relative',
                zIndex: 1,
                flex: 1
            },
            [`${componentCls}-column-sorters`]: {
                display: 'flex',
                flex: 'auto',
                alignItems: 'center',
                justifyContent: 'space-between',
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    content: '""'
                }
            },
            [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
                '&::after': {
                    content: 'none'
                }
            },
            [`${componentCls}-column-sorter`]: {
                marginInlineStart: marginXXS,
                color: headerIconColor,
                fontSize: 0,
                transition: `color ${token.motionDurationSlow}`,
                '&-inner': {
                    display: 'inline-flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                },
                '&-up, &-down': {
                    fontSize: fontSizeIcon,
                    '&.active': {
                        color: token.colorPrimary
                    }
                },
                [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
                    marginTop: '-0.3em'
                }
            },
            [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
                color: headerIconHoverColor
            }
        }
    };
};
var $80d110a9a80e6bd8$export$2e2bcd8739ae039 = $80d110a9a80e6bd8$var$genSorterStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $6eda256b15bd8b30$var$genStickyStyle = (token)=>{
    const { componentCls: componentCls, opacityLoading: opacityLoading, tableScrollThumbBg: tableScrollThumbBg, tableScrollThumbBgHover: tableScrollThumbBgHover, tableScrollThumbSize: tableScrollThumbSize, tableScrollBg: tableScrollBg, zIndexTableSticky: zIndexTableSticky, stickyScrollBarBorderRadius: stickyScrollBarBorderRadius, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor } = token;
    const tableBorder = `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-sticky`]: {
                '&-holder': {
                    position: 'sticky',
                    zIndex: zIndexTableSticky,
                    background: token.colorBgContainer
                },
                '&-scroll': {
                    position: 'sticky',
                    bottom: 0,
                    height: `${(0, $4g3I0.unit)(tableScrollThumbSize)} !important`,
                    zIndex: zIndexTableSticky,
                    display: 'flex',
                    alignItems: 'center',
                    background: tableScrollBg,
                    borderTop: tableBorder,
                    opacity: opacityLoading,
                    '&:hover': {
                        transformOrigin: 'center bottom'
                    },
                    // fake scrollbar style of sticky
                    '&-bar': {
                        height: tableScrollThumbSize,
                        backgroundColor: tableScrollThumbBg,
                        borderRadius: stickyScrollBarBorderRadius,
                        transition: `all ${token.motionDurationSlow}, transform none`,
                        position: 'absolute',
                        bottom: 0,
                        '&:hover, &-active': {
                            backgroundColor: tableScrollThumbBgHover
                        }
                    }
                }
            }
        }
    };
};
var $6eda256b15bd8b30$export$2e2bcd8739ae039 = $6eda256b15bd8b30$var$genStickyStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $422b7a321de886d3$var$genSummaryStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $4g3I0.unit)(lineWidth)} ${token.lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-summary`]: {
                position: 'relative',
                zIndex: token.zIndexTableFixed,
                background: token.tableBg,
                '> tr': {
                    '> th, > td': {
                        borderBottom: tableBorder
                    }
                }
            },
            [`div${componentCls}-summary`]: {
                boxShadow: `0 ${(0, $4g3I0.unit)(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
            }
        }
    };
};
var $422b7a321de886d3$export$2e2bcd8739ae039 = $422b7a321de886d3$var$genSummaryStyle;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
const $71f6b62222c66dcd$var$genVirtualStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const rowCellCls = `${componentCls}-expanded-row-cell`;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Row ==========================
            [`${componentCls}-tbody-virtual`]: {
                [`${componentCls}-tbody-virtual-holder-inner`]: {
                    [`
            & > ${componentCls}-row, 
            & > div:not(${componentCls}-row) > ${componentCls}-row
          `]: {
                        display: 'flex',
                        boxSizing: 'border-box',
                        width: '100%'
                    }
                },
                [`${componentCls}-cell`]: {
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid}`
                },
                [`${componentCls}-expanded-row`]: {
                    [`${rowCellCls}${rowCellCls}-fixed`]: {
                        position: 'sticky',
                        insetInlineStart: 0,
                        overflow: 'hidden',
                        width: `calc(var(--virtual-width) - ${(0, $4g3I0.unit)(lineWidth)})`,
                        borderInlineEnd: 'none'
                    }
                }
            },
            // ======================== Border =========================
            [`${componentCls}-bordered`]: {
                [`${componentCls}-tbody-virtual`]: {
                    '&:after': {
                        content: '""',
                        insetInline: 0,
                        bottom: 0,
                        borderBottom: tableBorder,
                        position: 'absolute'
                    },
                    [`${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        [`&${componentCls}-cell-fix-right-first:before`]: {
                            content: '""',
                            position: 'absolute',
                            insetBlock: 0,
                            insetInlineStart: calc(lineWidth).mul(-1).equal(),
                            borderInlineStart: tableBorder
                        }
                    }
                },
                // Empty placeholder
                [`&${componentCls}-virtual`]: {
                    [`${componentCls}-placeholder ${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        borderBottom: tableBorder
                    }
                }
            }
        }
    };
};
var $71f6b62222c66dcd$export$2e2bcd8739ae039 = $71f6b62222c66dcd$var$genVirtualStyle;


const $c540b79996d85f51$var$genTableStyle = (token)=>{
    const { componentCls: componentCls, fontWeightStrong: fontWeightStrong, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandColumnWidth: tableExpandColumnWidth, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableFontSize: tableFontSize, tableBg: tableBg, tableRadius: tableRadius, tableHeaderTextColor: tableHeaderTextColor, motionDurationMid: motionDurationMid, tableHeaderBg: tableHeaderBg, tableHeaderCellSplitColor: tableHeaderCellSplitColor, tableFooterTextColor: tableFooterTextColor, tableFooterBg: tableFooterBg, calc: calc } = token;
    const tableBorder = `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({
            clear: 'both',
            maxWidth: '100%'
        }, (0, $134f73cf3485ce91$export$8c467e8859fdef13)()), {
            [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                fontSize: tableFontSize,
                background: tableBg,
                borderRadius: `${(0, $4g3I0.unit)(tableRadius)} ${(0, $4g3I0.unit)(tableRadius)} 0 0`,
                // https://github.com/ant-design/ant-design/issues/47486
                scrollbarColor: `${token.tableScrollThumbBg} ${token.tableScrollBg}`
            }),
            // https://github.com/ant-design/ant-design/issues/17611
            table: {
                width: '100%',
                textAlign: 'start',
                borderRadius: `${(0, $4g3I0.unit)(tableRadius)} ${(0, $4g3I0.unit)(tableRadius)} 0 0`,
                borderCollapse: 'separate',
                borderSpacing: 0
            },
            // ============================= Cell ==============================
            [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
                position: 'relative',
                padding: `${(0, $4g3I0.unit)(tablePaddingVertical)} ${(0, $4g3I0.unit)(tablePaddingHorizontal)}`,
                overflowWrap: 'break-word'
            },
            // ============================ Title =============================
            [`${componentCls}-title`]: {
                padding: `${(0, $4g3I0.unit)(tablePaddingVertical)} ${(0, $4g3I0.unit)(tablePaddingHorizontal)}`
            },
            // ============================ Header ============================
            [`${componentCls}-thead`]: {
                [`
          > tr > th,
          > tr > td
        `]: {
                    position: 'relative',
                    color: tableHeaderTextColor,
                    fontWeight: fontWeightStrong,
                    textAlign: 'start',
                    background: tableHeaderBg,
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid} ease`,
                    "&[colspan]:not([colspan='1'])": {
                        textAlign: 'center'
                    },
                    [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineEnd: 0,
                        width: 1,
                        height: '1.6em',
                        backgroundColor: tableHeaderCellSplitColor,
                        transform: 'translateY(-50%)',
                        transition: `background-color ${motionDurationMid}`,
                        content: '""'
                    }
                },
                '> tr:not(:last-child) > th[colspan]': {
                    borderBottom: 0
                }
            },
            // ============================ Body ============================
            [`${componentCls}-tbody`]: {
                '> tr': {
                    '> th, > td': {
                        transition: `background ${motionDurationMid}, border-color ${motionDurationMid}`,
                        borderBottom: tableBorder,
                        // ========================= Nest Table ===========================
                        [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
                            [componentCls]: {
                                marginBlock: (0, $4g3I0.unit)(calc(tablePaddingVertical).mul(-1).equal()),
                                marginInline: `${(0, $4g3I0.unit)(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${(0, $4g3I0.unit)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                                [`${componentCls}-tbody > tr:last-child > td`]: {
                                    borderBottomWidth: 0,
                                    '&:first-child, &:last-child': {
                                        borderRadius: 0
                                    }
                                }
                            }
                        }
                    },
                    '> th': {
                        position: 'relative',
                        color: tableHeaderTextColor,
                        fontWeight: fontWeightStrong,
                        textAlign: 'start',
                        background: tableHeaderBg,
                        borderBottom: tableBorder,
                        transition: `background ${motionDurationMid} ease`
                    }
                }
            },
            // ============================ Footer ============================
            [`${componentCls}-footer`]: {
                padding: `${(0, $4g3I0.unit)(tablePaddingVertical)} ${(0, $4g3I0.unit)(tablePaddingHorizontal)}`,
                color: tableFooterTextColor,
                background: tableFooterBg
            }
        })
    };
};
const $c540b79996d85f51$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillAlter: colorFillAlter, colorBgContainer: colorBgContainer, colorTextHeading: colorTextHeading, colorFillSecondary: colorFillSecondary, colorFillContent: colorFillContent, controlItemBgActive: controlItemBgActive, controlItemBgActiveHover: controlItemBgActiveHover, padding: padding, paddingSM: paddingSM, paddingXS: paddingXS, colorBorderSecondary: colorBorderSecondary, borderRadiusLG: borderRadiusLG, controlHeight: controlHeight, colorTextPlaceholder: colorTextPlaceholder, fontSize: fontSize, fontSizeSM: fontSizeSM, lineHeight: lineHeight, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, opacityLoading: opacityLoading, controlInteractiveSize: controlInteractiveSize } = token;
    const colorFillSecondarySolid = new (0, $6xABB.FastColor)(colorFillSecondary).onBackground(colorBgContainer).toHexString();
    const colorFillContentSolid = new (0, $6xABB.FastColor)(colorFillContent).onBackground(colorBgContainer).toHexString();
    const colorFillAlterSolid = new (0, $6xABB.FastColor)(colorFillAlter).onBackground(colorBgContainer).toHexString();
    const baseColorAction = new (0, $6xABB.FastColor)(colorIcon);
    const baseColorActionHover = new (0, $6xABB.FastColor)(colorIconHover);
    const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
    const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
    return {
        headerBg: colorFillAlterSolid,
        headerColor: colorTextHeading,
        headerSortActiveBg: colorFillSecondarySolid,
        headerSortHoverBg: colorFillContentSolid,
        bodySortBg: colorFillAlterSolid,
        rowHoverBg: colorFillAlterSolid,
        rowSelectedBg: controlItemBgActive,
        rowSelectedHoverBg: controlItemBgActiveHover,
        rowExpandedBg: colorFillAlter,
        cellPaddingBlock: padding,
        cellPaddingInline: padding,
        cellPaddingBlockMD: paddingSM,
        cellPaddingInlineMD: paddingXS,
        cellPaddingBlockSM: paddingXS,
        cellPaddingInlineSM: paddingXS,
        borderColor: colorBorderSecondary,
        headerBorderRadius: borderRadiusLG,
        footerBg: colorFillAlterSolid,
        footerColor: colorTextHeading,
        cellFontSize: fontSize,
        cellFontSizeMD: fontSize,
        cellFontSizeSM: fontSize,
        headerSplitColor: colorBorderSecondary,
        fixedHeaderSortActiveBg: colorFillSecondarySolid,
        headerFilterHoverBg: colorFillContent,
        filterDropdownMenuBg: colorBgContainer,
        filterDropdownBg: colorBgContainer,
        expandIconBg: colorBgContainer,
        selectionColumnWidth: controlHeight,
        stickyScrollBarBg: colorTextPlaceholder,
        stickyScrollBarBorderRadius: 100,
        expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
        headerIconColor: baseColorAction.clone().setA(baseColorAction.a * opacityLoading).toRgbString(),
        headerIconHoverColor: baseColorActionHover.clone().setA(baseColorActionHover.a * opacityLoading).toRgbString(),
        expandIconHalfInner: expandIconHalfInner,
        expandIconSize: expandIconSize,
        expandIconScale: controlInteractiveSize / expandIconSize
    };
};
const $c540b79996d85f51$var$zIndexTableFixed = 2;
var // ============================== Export ==============================
$c540b79996d85f51$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Table', (token)=>{
    const { colorTextHeading: colorTextHeading, colorSplit: colorSplit, colorBgContainer: colorBgContainer, controlInteractiveSize: checkboxSize, headerBg: headerBg, headerColor: headerColor, headerSortActiveBg: headerSortActiveBg, headerSortHoverBg: headerSortHoverBg, bodySortBg: bodySortBg, rowHoverBg: rowHoverBg, rowSelectedBg: rowSelectedBg, rowSelectedHoverBg: rowSelectedHoverBg, rowExpandedBg: rowExpandedBg, cellPaddingBlock: cellPaddingBlock, cellPaddingInline: cellPaddingInline, cellPaddingBlockMD: cellPaddingBlockMD, cellPaddingInlineMD: cellPaddingInlineMD, cellPaddingBlockSM: cellPaddingBlockSM, cellPaddingInlineSM: cellPaddingInlineSM, borderColor: borderColor, footerBg: footerBg, footerColor: footerColor, headerBorderRadius: headerBorderRadius, cellFontSize: cellFontSize, cellFontSizeMD: cellFontSizeMD, cellFontSizeSM: cellFontSizeSM, headerSplitColor: headerSplitColor, fixedHeaderSortActiveBg: fixedHeaderSortActiveBg, headerFilterHoverBg: headerFilterHoverBg, filterDropdownBg: filterDropdownBg, expandIconBg: expandIconBg, selectionColumnWidth: selectionColumnWidth, stickyScrollBarBg: stickyScrollBarBg, calc: calc } = token;
    const tableToken = (0, $8APUt.merge)(token, {
        tableFontSize: cellFontSize,
        tableBg: colorBgContainer,
        tableRadius: headerBorderRadius,
        tablePaddingVertical: cellPaddingBlock,
        tablePaddingHorizontal: cellPaddingInline,
        tablePaddingVerticalMiddle: cellPaddingBlockMD,
        tablePaddingHorizontalMiddle: cellPaddingInlineMD,
        tablePaddingVerticalSmall: cellPaddingBlockSM,
        tablePaddingHorizontalSmall: cellPaddingInlineSM,
        tableBorderColor: borderColor,
        tableHeaderTextColor: headerColor,
        tableHeaderBg: headerBg,
        tableFooterTextColor: footerColor,
        tableFooterBg: footerBg,
        tableHeaderCellSplitColor: headerSplitColor,
        tableHeaderSortBg: headerSortActiveBg,
        tableHeaderSortHoverBg: headerSortHoverBg,
        tableBodySortBg: bodySortBg,
        tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
        tableHeaderFilterActiveBg: headerFilterHoverBg,
        tableFilterDropdownBg: filterDropdownBg,
        tableRowHoverBg: rowHoverBg,
        tableSelectedRowBg: rowSelectedBg,
        tableSelectedRowHoverBg: rowSelectedHoverBg,
        zIndexTableFixed: $c540b79996d85f51$var$zIndexTableFixed,
        zIndexTableSticky: calc($c540b79996d85f51$var$zIndexTableFixed).add(1).equal({
            unit: false
        }),
        tableFontSizeMiddle: cellFontSizeMD,
        tableFontSizeSmall: cellFontSizeSM,
        tableSelectionColumnWidth: selectionColumnWidth,
        tableExpandIconBg: expandIconBg,
        tableExpandColumnWidth: calc(checkboxSize).add(calc(token.padding).mul(2)).equal(),
        tableExpandedRowBg: rowExpandedBg,
        // Dropdown
        tableFilterDropdownWidth: 120,
        tableFilterDropdownHeight: 264,
        tableFilterDropdownSearchWidth: 140,
        // Virtual Scroll Bar
        tableScrollThumbSize: 8,
        // Mac scroll bar size
        tableScrollThumbBg: stickyScrollBarBg,
        tableScrollThumbBgHover: colorTextHeading,
        tableScrollBg: colorSplit
    });
    return [
        $c540b79996d85f51$var$genTableStyle(tableToken),
        (0, $2a68319ae38dab87$export$2e2bcd8739ae039)(tableToken),
        (0, $422b7a321de886d3$export$2e2bcd8739ae039)(tableToken),
        (0, $80d110a9a80e6bd8$export$2e2bcd8739ae039)(tableToken),
        (0, $ce26a01df1568ae6$export$2e2bcd8739ae039)(tableToken),
        (0, $a73afda141209644$export$2e2bcd8739ae039)(tableToken),
        (0, $cdeed8320eec20e2$export$2e2bcd8739ae039)(tableToken),
        (0, $3628de15f7dbe14d$export$2e2bcd8739ae039)(tableToken),
        (0, $422b7a321de886d3$export$2e2bcd8739ae039)(tableToken),
        (0, $536a2890f0438d8e$export$2e2bcd8739ae039)(tableToken),
        (0, $cf00aa976c6fdbfa$export$2e2bcd8739ae039)(tableToken),
        (0, $f11f28dea42c31ff$export$2e2bcd8739ae039)(tableToken),
        (0, $6eda256b15bd8b30$export$2e2bcd8739ae039)(tableToken),
        (0, $9f96bf57ad8c109c$export$2e2bcd8739ae039)(tableToken),
        (0, $a43182240b7d4e46$export$2e2bcd8739ae039)(tableToken),
        (0, $bff371e3a2f8ca86$export$2e2bcd8739ae039)(tableToken),
        (0, $71f6b62222c66dcd$export$2e2bcd8739ae039)(tableToken)
    ];
}, $c540b79996d85f51$export$9ca1be8807fe0675, {
    unitless: {
        expandIconScale: true
    }
});


"use client";
const $349bc8582f06179e$var$EMPTY_LIST = [];
const $349bc8582f06179e$var$InternalTable = (props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, bordered: bordered, dropdownPrefixCls: customizeDropdownPrefixCls, dataSource: dataSource, pagination: pagination, rowSelection: rowSelection, rowKey: rowKey = 'key', rowClassName: rowClassName, columns: columns, children: children, childrenColumnName: legacyChildrenColumnName, onChange: onChange, getPopupContainer: getPopupContainer, loading: loading, expandIcon: expandIcon, expandable: expandable, expandedRowRender: expandedRowRender, expandIconColumnIndex: expandIconColumnIndex, indentSize: indentSize, scroll: scroll, sortDirections: sortDirections, locale: locale, showSorterTooltip: showSorterTooltip = {
        target: 'full-header'
    }, virtual: virtual } = props;
    const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Table');
    warning(!(typeof rowKey === 'function' && rowKey.length > 1), 'usage', '`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.');
    const baseColumns = $jMaZ8.useMemo(()=>columns || (0, $7831dce2cc3196b6$export$d87a97eba44e0f9c)(children), [
        columns,
        children
    ]);
    const needResponsive = $jMaZ8.useMemo(()=>baseColumns.some((col)=>col.responsive), [
        baseColumns
    ]);
    const screens = (0, $2bc364d47e670ed8$export$2e2bcd8739ae039)(needResponsive);
    const mergedColumns = $jMaZ8.useMemo(()=>{
        const matched = new Set(Object.keys(screens).filter((m)=>screens[m]));
        return baseColumns.filter((c)=>!c.responsive || c.responsive.some((r)=>matched.has(r)));
    }, [
        baseColumns,
        screens
    ]);
    const tableProps = (0, $hvG6u.default)(props, [
        'className',
        'style',
        'columns'
    ]);
    const { locale: contextLocale = (0, $44fbc0e8f4cce6cb$export$2e2bcd8739ae039), direction: direction, table: table, renderEmpty: renderEmpty, getPrefixCls: getPrefixCls, getPopupContainer: getContextPopupContainer } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customizeSize);
    const tableLocale = Object.assign(Object.assign({}, contextLocale.Table), locale);
    const rawData = dataSource || $349bc8582f06179e$var$EMPTY_LIST;
    const prefixCls = getPrefixCls('table', customizePrefixCls);
    const dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
    const [, token] = (0, $5a87977658f50271$export$2e2bcd8739ae039)();
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c540b79996d85f51$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedExpandable = Object.assign(Object.assign({
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex
    }, expandable), {
        expandIcon: (_a = expandable === null || expandable === void 0 ? void 0 : expandable.expandIcon) !== null && _a !== void 0 ? _a : (_b = table === null || table === void 0 ? void 0 : table.expandable) === null || _b === void 0 ? void 0 : _b.expandIcon
    });
    const { childrenColumnName: childrenColumnName = 'children' } = mergedExpandable;
    const expandType = $jMaZ8.useMemo(()=>{
        if (rawData.some((item)=>item === null || item === void 0 ? void 0 : item[childrenColumnName])) return 'nest';
        if (expandedRowRender || (expandable === null || expandable === void 0 ? void 0 : expandable.expandedRowRender)) return 'row';
        return null;
    }, [
        rawData
    ]);
    const internalRefs = {
        body: $jMaZ8.useRef(null)
    };
    // ============================ Width =============================
    const getContainerWidth = (0, $778958d59a247c34$export$2e2bcd8739ae039)(prefixCls);
    // ============================= Refs =============================
    const rootRef = $jMaZ8.useRef(null);
    const tblRef = $jMaZ8.useRef(null);
    (0, $dc80ff031dcc2ebe$export$2e2bcd8739ae039)(ref, ()=>Object.assign(Object.assign({}, tblRef.current), {
            nativeElement: rootRef.current
        }));
    // ============================ RowKey ============================
    const getRowKey = $jMaZ8.useMemo(()=>{
        if (typeof rowKey === 'function') return rowKey;
        return (record)=>record === null || record === void 0 ? void 0 : record[rowKey];
    }, [
        rowKey
    ]);
    const [getRecordByKey] = (0, $07f6cd84730d57db$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey);
    // ============================ Events =============================
    const changeEventInfo = {};
    const triggerOnChange = function(info, action) {
        let reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _a, _b, _c, _d;
        const changeInfo = Object.assign(Object.assign({}, changeEventInfo), info);
        if (reset) {
            (_a = changeEventInfo.resetPagination) === null || _a === void 0 || _a.call(changeEventInfo);
            // Reset event param
            if ((_b = changeInfo.pagination) === null || _b === void 0 ? void 0 : _b.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination) (_c = pagination.onChange) === null || _c === void 0 || _c.call(pagination, 1, (_d = changeInfo.pagination) === null || _d === void 0 ? void 0 : _d.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) (0, $72cb4fa9ea0303f1$export$2e2bcd8739ae039)(0, {
            getContainer: ()=>internalRefs.body.current
        });
        onChange === null || onChange === void 0 || onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $d1c35acf386da2d6$export$37643bb40f4c1c56)((0, $47cf5b169f7da1ff$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    const onSorterChange = (sorter, sorterStates)=>{
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, 'sort', false);
    };
    const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = (0, $47cf5b169f7da1ff$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            'ascend',
            'descend'
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip
    });
    const sortedData = $jMaZ8.useMemo(()=>(0, $47cf5b169f7da1ff$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName), [
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    const onFilterChange = (filters, filterStates)=>{
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, 'filter', true);
    };
    const [transformFilterColumns, filterStates, filters] = (0, $d1c35acf386da2d6$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(rootClassName, rootCls)
    });
    const mergedData = (0, $d1c35acf386da2d6$export$37643bb40f4c1c56)(sortedData, filterStates, childrenColumnName);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    const columnTitleProps = $jMaZ8.useMemo(()=>{
        const mergedFilters = {};
        Object.keys(filters).forEach((filterKey)=>{
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return Object.assign(Object.assign({}, sorterTitleProps), {
            filters: mergedFilters
        });
    }, [
        sorterTitleProps,
        filters
    ]);
    const [transformTitleColumns] = (0, $7083d7a47d925f49$export$2e2bcd8739ae039)(columnTitleProps);
    // ========================== Pagination ==========================
    const onPaginationChange = (current, pageSize)=>{
        triggerOnChange({
            pagination: Object.assign(Object.assign({}, changeEventInfo.pagination), {
                current: current,
                pageSize: pageSize
            })
        }, 'paginate');
    };
    const [mergedPagination, resetPagination] = (0, $3d80be9dd5919e84$export$2e2bcd8739ae039)(mergedData.length, onPaginationChange, pagination);
    changeEventInfo.pagination = pagination === false ? {} : (0, $3d80be9dd5919e84$export$27eceeed7bf0f4c2)(mergedPagination, pagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    const pageData = $jMaZ8.useMemo(()=>{
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        const { current: current = 1, total: total, pageSize: pageSize = (0, $3d80be9dd5919e84$export$5716e8bcb003888d) } = mergedPagination;
        warning(current > 0, 'usage', '`current` should be positive number.');
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) {
                warning(false, 'usage', '`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode.');
                return mergedData.slice((current - 1) * pageSize, current * pageSize);
            }
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.current,
        mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize,
        mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total
    ]);
    // ========================== Selections ==========================
    const [transformSelectionColumns, selectedKeySet] = (0, $c2848e6016c49c74$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer || getContextPopupContainer
    }, rowSelection);
    const internalRowClassName = (record, index, indent)=>{
        let mergedRowClassName;
        if (typeof rowClassName === 'function') mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(rowClassName(record, index, indent));
        else mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(rowClassName);
        return (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index))
        }, mergedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `rc-table`, this can be removed when refactor with `rc-table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $1858097c912c7aac$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== 'number') mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
    // ============================ Render ============================
    const transformColumns = $jMaZ8.useCallback((innerColumns)=>transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    let topPaginationNode;
    let bottomPaginationNode;
    if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
        let paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
        const renderPagination = (position)=>/*#__PURE__*/ $jMaZ8.createElement((0, $029f538dfd4a9bcd$export$2e2bcd8739ae039), Object.assign({}, mergedPagination, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-pagination ${prefixCls}-pagination-${position}`, mergedPagination.className),
                size: paginationSize
            }));
        const defaultPosition = direction === 'rtl' ? 'left' : 'right';
        const { position: position } = mergedPagination;
        if (position !== null && Array.isArray(position)) {
            const topPos = position.find((p)=>p.includes('top'));
            const bottomPos = position.find((p)=>p.includes('bottom'));
            const isDisable = position.every((p)=>`${p}` === 'none');
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination(defaultPosition);
            if (topPos) topPaginationNode = renderPagination(topPos.toLowerCase().replace('top', ''));
            if (bottomPos) bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace('bottom', ''));
        } else bottomPaginationNode = renderPagination(defaultPosition);
    }
    // >>>>>>>>> Spinning
    let spinProps;
    if (typeof loading === 'boolean') spinProps = {
        spinning: loading
    };
    else if (typeof loading === 'object') spinProps = Object.assign({
        spinning: true
    }, loading);
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(cssVarCls, rootCls, `${prefixCls}-wrapper`, table === null || table === void 0 ? void 0 : table.className, {
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId);
    const mergedStyle = Object.assign(Object.assign({}, table === null || table === void 0 ? void 0 : table.style), style);
    const emptyText = typeof (locale === null || locale === void 0 ? void 0 : locale.emptyText) !== 'undefined' ? locale.emptyText : (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Table')) || /*#__PURE__*/ $jMaZ8.createElement((0, $4de21af32a83dbc2$export$2e2bcd8739ae039), {
        componentName: "Table"
    });
    // ========================== Render ==========================
    const TableComponent = virtual ? (0, $caaad36872016bf4$export$2e2bcd8739ae039) : (0, $314cb6087d63a68b$export$2e2bcd8739ae039);
    // >>> Virtual Table props. We set height here since it will affect height collection
    const virtualProps = {};
    const listItemHeight = $jMaZ8.useMemo(()=>{
        const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, padding: padding, paddingXS: paddingXS, paddingSM: paddingSM } = token;
        const fontHeight = Math.floor(fontSize * lineHeight);
        switch(mergedSize){
            case 'middle':
                return paddingSM * 2 + fontHeight + lineWidth;
            case 'small':
                return paddingXS * 2 + fontHeight + lineWidth;
            default:
                return padding * 2 + fontHeight + lineWidth;
        }
    }, [
        token,
        mergedSize
    ]);
    if (virtual) virtualProps.listItemHeight = listItemHeight;
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: rootRef,
        className: wrapperClassNames,
        style: mergedStyle
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), Object.assign({
        spinning: false
    }, spinProps), topPaginationNode, /*#__PURE__*/ $jMaZ8.createElement(TableComponent, Object.assign({}, virtualProps, tableProps, {
        ref: tblRef,
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
            [`${prefixCls}-middle`]: mergedSize === 'middle',
            [`${prefixCls}-small`]: mergedSize === 'small',
            [`${prefixCls}-bordered`]: bordered,
            [`${prefixCls}-empty`]: rawData.length === 0
        }, cssVarCls, rootCls, hashId),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: emptyText,
        // Internal
        internalHooks: (0, $f40867b2b1b9b23f$export$91b75cf262680225),
        internalRefs: internalRefs,
        transformColumns: transformColumns,
        getContainerWidth: getContainerWidth
    })), bottomPaginationNode)));
};
var $349bc8582f06179e$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.forwardRef($349bc8582f06179e$var$InternalTable);


"use client";
const $b587e7915550ffac$var$Table = (props, ref)=>{
    const renderTimesRef = $jMaZ8.useRef(0);
    renderTimesRef.current += 1;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $349bc8582f06179e$export$2e2bcd8739ae039), Object.assign({}, props, {
        ref: ref,
        _renderTimes: renderTimesRef.current
    }));
};
const $b587e7915550ffac$var$ForwardTable = /*#__PURE__*/ $jMaZ8.forwardRef($b587e7915550ffac$var$Table);
$b587e7915550ffac$var$ForwardTable.SELECTION_COLUMN = (0, $c2848e6016c49c74$export$ed10248435b8f218);
$b587e7915550ffac$var$ForwardTable.EXPAND_COLUMN = (0, $f40867b2b1b9b23f$export$e1053575ddfcb301);
$b587e7915550ffac$var$ForwardTable.SELECTION_ALL = (0, $c2848e6016c49c74$export$14159cd9e2a500c8);
$b587e7915550ffac$var$ForwardTable.SELECTION_INVERT = (0, $c2848e6016c49c74$export$625c4f68eaaf8cfd);
$b587e7915550ffac$var$ForwardTable.SELECTION_NONE = (0, $c2848e6016c49c74$export$c1a725540f5a63bd);
$b587e7915550ffac$var$ForwardTable.Column = (0, $69ba96c61af3bb29$export$2e2bcd8739ae039);
$b587e7915550ffac$var$ForwardTable.ColumnGroup = (0, $c9d3c072e2604d00$export$2e2bcd8739ae039);
$b587e7915550ffac$var$ForwardTable.Summary = (0, $b404adcf0f7cd921$export$d605f3af09eef683);
$b587e7915550ffac$var$ForwardTable.displayName = 'Table';
var $b587e7915550ffac$export$2e2bcd8739ae039 = $b587e7915550ffac$var$ForwardTable;


"use client";
var $0c81d311e7fde9b8$export$2e2bcd8739ae039 = (0, $b587e7915550ffac$export$2e2bcd8739ae039);


var $fb2727a70b78a71d$export$b1b07211686a04d0;
var $fb2727a70b78a71d$export$c2e79b64b0a9746b;
var $fb2727a70b78a71d$export$8a8237989e2ce9a5;
var $fb2727a70b78a71d$export$3210a79c026cb1a8;
var $fb2727a70b78a71d$export$12d45ee5c2161b75;
var $fb2727a70b78a71d$export$2f6f961c6d3131fc;
var $fb2727a70b78a71d$export$b1c67c41ddd97f48;
var $fb2727a70b78a71d$export$3d93d26753cc2206;
var $fb2727a70b78a71d$export$55bf69dbc9a8960b;
var $fb2727a70b78a71d$export$b5fe45dc16a0a865;
var $fb2727a70b78a71d$export$79a7ae941014e260;
$fb2727a70b78a71d$export$b1b07211686a04d0 = "projectExports_d5c254";
$fb2727a70b78a71d$export$c2e79b64b0a9746b = "legendAndDelete_d5c254";
$fb2727a70b78a71d$export$8a8237989e2ce9a5 = "deleteWrapper_d5c254";
$fb2727a70b78a71d$export$3210a79c026cb1a8 = "deleteBtn_d5c254";
$fb2727a70b78a71d$export$12d45ee5c2161b75 = "deleteIcon_d5c254";
$fb2727a70b78a71d$export$2f6f961c6d3131fc = "legendAlert_d5c254";
$fb2727a70b78a71d$export$b1c67c41ddd97f48 = "projectExportsList_d5c254";
$fb2727a70b78a71d$export$3d93d26753cc2206 = "iconWaiting_d5c254";
$fb2727a70b78a71d$export$55bf69dbc9a8960b = "iconDone_d5c254";
$fb2727a70b78a71d$export$b5fe45dc16a0a865 = "iconFailed_d5c254";
$fb2727a70b78a71d$export$79a7ae941014e260 = "cancelIcon_d5c254";




var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $884463bc00ab5b70$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
var $884463bc00ab5b70$export$2e2bcd8739ae039 = $884463bc00ab5b70$var$CheckCircleOutlined;



var $5f87f9a2c863bb2b$var$CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $884463bc00ab5b70$export$2e2bcd8739ae039)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY5OSAzNTNoLTQ2LjljLTEwLjIgMC0xOS45IDQuOS0yNS45IDEzLjNMNDY5IDU4NC4zbC03MS4yLTk4LjhjLTYtOC4zLTE1LjYtMTMuMy0yNS45LTEzLjNIMzI1Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjQuNiAxNzIuOGEzMS44IDMxLjggMCAwMDUxLjcgMGwyMTAuNi0yOTJjMy45LTUuMy4xLTEyLjctNi40LTEyLjd6IiAvPjxwYXRoIGQ9Ik01MTIgNjRDMjY0LjYgNjQgNjQgMjY0LjYgNjQgNTEyczIwMC42IDQ0OCA0NDggNDQ4IDQ0OC0yMDAuNiA0NDgtNDQ4Uzc1OS40IDY0IDUxMiA2NHptMCA4MjBjLTIwNS40IDAtMzcyLTE2Ni42LTM3Mi0zNzJzMTY2LjYtMzcyIDM3Mi0zNzIgMzcyIDE2Ni42IDM3MiAzNzItMTY2LjYgMzcyLTM3MiAzNzJ6IiAvPjwvc3ZnPg==) */ var $5f87f9a2c863bb2b$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($5f87f9a2c863bb2b$var$CheckCircleOutlined);
$5f87f9a2c863bb2b$var$RefIcon.displayName = 'CheckCircleOutlined';
var $5f87f9a2c863bb2b$export$2e2bcd8739ae039 = $5f87f9a2c863bb2b$var$RefIcon;


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $85dca82b78b7b2bd$var$ClockCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    },
    "name": "clock-circle",
    "theme": "outlined"
};
var $85dca82b78b7b2bd$export$2e2bcd8739ae039 = $85dca82b78b7b2bd$var$ClockCircleOutlined;



var $c7af7e168f42c58b$var$ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $85dca82b78b7b2bd$export$2e2bcd8739ae039)
    }));
};
/**![clock-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTY4Ni43IDYzOC42TDU0NC4xIDUzNS41VjI4OGMwLTQuNC0zLjYtOC04LThINDg4Yy00LjQgMC04IDMuNi04IDh2Mjc1LjRjMCAyLjYgMS4yIDUgMy4zIDYuNWwxNjUuNCAxMjAuNmMzLjYgMi42IDguNiAxLjggMTEuMi0xLjdsMjguNi0zOWMyLjYtMy43IDEuOC04LjctMS44LTExLjJ6IiAvPjwvc3ZnPg==) */ var $c7af7e168f42c58b$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($c7af7e168f42c58b$var$ClockCircleOutlined);
$c7af7e168f42c58b$var$RefIcon.displayName = 'ClockCircleOutlined';
var $c7af7e168f42c58b$export$2e2bcd8739ae039 = $c7af7e168f42c58b$var$RefIcon;


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $dbcbfe04cc42284b$var$CloseCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "outlined"
};
var $dbcbfe04cc42284b$export$2e2bcd8739ae039 = $dbcbfe04cc42284b$var$CloseCircleOutlined;



var $5e96652daa81d146$var$CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $dbcbfe04cc42284b$export$2e2bcd8739ae039)
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMCA3NmMtMjA1LjQgMC0zNzIgMTY2LjYtMzcyIDM3MnMxNjYuNiAzNzIgMzcyIDM3MiAzNzItMTY2LjYgMzcyLTM3Mi0xNjYuNi0zNzItMzcyLTM3MnptMTI4LjAxIDE5OC44M2MuMDMgMCAuMDUuMDEuMDkuMDZsNDUuMDIgNDUuMDFhLjIuMiAwIDAxLjA1LjA5LjEyLjEyIDAgMDEwIC4wN2MwIC4wMi0uMDEuMDQtLjA1LjA4TDU1Ny4yNSA1MTJsMTI3Ljg3IDEyNy44NmEuMjcuMjcgMCAwMS4wNS4wNnYuMDJhLjEyLjEyIDAgMDEwIC4wN2MwIC4wMy0uMDEuMDUtLjA1LjA5bC00NS4wMiA0NS4wMmEuMi4yIDAgMDEtLjA5LjA1LjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDEtLjA4LS4wNUw1MTIgNTU3LjI1IDM4NC4xNCA2ODUuMTJjLS4wNC4wNC0uMDYuMDUtLjA4LjA1YS4xMi4xMiAwIDAxLS4wNyAwYy0uMDMgMC0uMDUtLjAxLS4wOS0uMDVsLTQ1LjAyLTQ1LjAyYS4yLjIgMCAwMS0uMDUtLjA5LjEyLjEyIDAgMDEwLS4wN2MwLS4wMi4wMS0uMDQuMDYtLjA4TDQ2Ni43NSA1MTIgMzM4Ljg4IDM4NC4xNGEuMjcuMjcgMCAwMS0uMDUtLjA2bC0uMDEtLjAyYS4xMi4xMiAwIDAxMC0uMDdjMC0uMDMuMDEtLjA1LjA1LS4wOWw0NS4wMi00NS4wMmEuMi4yIDAgMDEuMDktLjA1LjEyLjEyIDAgMDEuMDcgMGMuMDIgMCAuMDQuMDEuMDguMDZMNTEyIDQ2Ni43NWwxMjcuODYtMTI3Ljg2Yy4wNC0uMDUuMDYtLjA2LjA4LS4wNmEuMTIuMTIgMCAwMS4wNyAweiIgLz48L3N2Zz4=) */ var $5e96652daa81d146$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($5e96652daa81d146$var$CloseCircleOutlined);
$5e96652daa81d146$var$RefIcon.displayName = 'CloseCircleOutlined';
var $5e96652daa81d146$export$2e2bcd8739ae039 = $5e96652daa81d146$var$RefIcon;


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $dce8ce1941e5c0f4$var$SoundOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344z"
                }
            }
        ]
    },
    "name": "sound",
    "theme": "outlined"
};
var $dce8ce1941e5c0f4$export$2e2bcd8739ae039 = $dce8ce1941e5c0f4$var$SoundOutlined;



var $6828f0a716a30b6e$var$SoundOutlined = function SoundOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $dce8ce1941e5c0f4$export$2e2bcd8739ae039)
    }));
};
/**![sound](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYyNS45IDExNWMtNS45IDAtMTEuOSAxLjYtMTcuNCA1LjNMMjU0IDM1Mkg5MGMtOC44IDAtMTYgNy4yLTE2IDE2djI4OGMwIDguOCA3LjIgMTYgMTYgMTZoMTY0bDM1NC41IDIzMS43YzUuNSAzLjYgMTEuNiA1LjMgMTcuNCA1LjMgMTYuNyAwIDMyLjEtMTMuMyAzMi4xLTMyLjFWMTQ3LjFjMC0xOC44LTE1LjQtMzIuMS0zMi4xLTMyLjF6TTU4NiA4MDNMMjkzLjQgNjExLjdsLTE4LTExLjdIMTQ2VjQyNGgxMjkuNGwxNy45LTExLjdMNTg2IDIyMXY1ODJ6bTM0OC0zMjdIODA2Yy04LjggMC0xNiA3LjItMTYgMTZ2NDBjMCA4LjggNy4yIDE2IDE2IDE2aDEyOGM4LjggMCAxNi03LjIgMTYtMTZ2LTQwYzAtOC44LTcuMi0xNi0xNi0xNnptLTQxLjkgMjYxLjhsLTExMC4zLTYzLjdhMTUuOSAxNS45IDAgMDAtMjEuNyA1LjlsLTE5LjkgMzQuNWMtNC40IDcuNi0xLjggMTcuNCA1LjggMjEuOEw4NTYuMyA4MDBhMTUuOSAxNS45IDAgMDAyMS43LTUuOWwxOS45LTM0LjVjNC40LTcuNiAxLjctMTcuNC01LjgtMjEuOHpNNzYwIDM0NGExNS45IDE1LjkgMCAwMDIxLjcgNS45TDg5MiAyODYuMmM3LjYtNC40IDEwLjItMTQuMiA1LjgtMjEuOEw4NzggMjMwYTE1LjkgMTUuOSAwIDAwLTIxLjctNS45TDc0NiAyODcuOGExNS45OSAxNS45OSAwIDAwLTUuOCAyMS44TDc2MCAzNDR6IiAvPjwvc3ZnPg==) */ var $6828f0a716a30b6e$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($6828f0a716a30b6e$var$SoundOutlined);
$6828f0a716a30b6e$var$RefIcon.displayName = 'SoundOutlined';
var $6828f0a716a30b6e$export$2e2bcd8739ae039 = $6828f0a716a30b6e$var$RefIcon;


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $9152642e15fe2531$var$StopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"
                }
            }
        ]
    },
    "name": "stop",
    "theme": "outlined"
};
var $9152642e15fe2531$export$2e2bcd8739ae039 = $9152642e15fe2531$var$StopOutlined;



var $7679f148da293b3c$var$StopOutlined = function StopOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $9152642e15fe2531$export$2e2bcd8739ae039)
    }));
};
/**![stop](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MiAwLTg5IDMxLjMtMTcwLjggODMuNS0yMzQuOGw1MjMuMyA1MjMuM0M2ODIuOCA4NTIuNyA2MDEgODg0IDUxMiA4ODR6bTI4OC41LTEzNy4yTDI3Ny4yIDIyMy41QzM0MS4yIDE3MS4zIDQyMyAxNDAgNTEyIDE0MGMyMDUuNCAwIDM3MiAxNjYuNiAzNzIgMzcyIDAgODktMzEuMyAxNzAuOC04My41IDIzNC44eiIgLz48L3N2Zz4=) */ var $7679f148da293b3c$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($7679f148da293b3c$var$StopOutlined);
$7679f148da293b3c$var$RefIcon.displayName = 'StopOutlined';
var $7679f148da293b3c$export$2e2bcd8739ae039 = $7679f148da293b3c$var$RefIcon;




var $jzGiR = parcelRequire("jzGiR");

var $jMaZ8 = parcelRequire("jMaZ8");





const $a746d728be9a3387$export$c742923ea4ac4c1c = (status)=>{
    switch(status){
        case (0, $b522cf181e75e62d$export$602981314f6adf1a).WAITING:
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c7af7e168f42c58b$export$2e2bcd8739ae039), {
                className: $fb2727a70b78a71d$export$3d93d26753cc2206
            });
        case (0, $b522cf181e75e62d$export$602981314f6adf1a).IN_PROGRESS:
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                small: true,
                notFlex: true
            });
        case (0, $b522cf181e75e62d$export$602981314f6adf1a).DONE:
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5f87f9a2c863bb2b$export$2e2bcd8739ae039), {
                className: $fb2727a70b78a71d$export$55bf69dbc9a8960b
            });
        case (0, $b522cf181e75e62d$export$602981314f6adf1a).FAILED:
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5e96652daa81d146$export$2e2bcd8739ae039), {
                className: $fb2727a70b78a71d$export$b5fe45dc16a0a865
            });
        default:
            return null;
    }
};
const $a746d728be9a3387$var$getActionBtn = (exp, download, cancel, deletingExportIds)=>{
    const isDeleting = deletingExportIds.includes(exp.id);
    if (exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).DONE) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
        onClick: ()=>download(exp.projectId, exp.id),
        loading: isDeleting,
        disabled: isDeleting,
        children: !isDeleting && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3b2623359dc2ca06$export$2e2bcd8739ae039), {})
    });
    else if (exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).WAITING || exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).IN_PROGRESS) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
        onClick: ()=>cancel(exp.projectId, exp.id),
        loading: isDeleting,
        disabled: isDeleting,
        children: !isDeleting && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $7679f148da293b3c$export$2e2bcd8739ae039), {
            className: $fb2727a70b78a71d$export$79a7ae941014e260
        })
    });
    return null;
};
function $a746d728be9a3387$export$2e2bcd8739ae039({ exports: exports, cancel: cancel, download: download, deleteExportsProps: deleteExportsProps, deletingExportIds: deletingExportIds }) {
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    // Data used by the table
    const data = (0, $jMaZ8.useMemo)(()=>exports.map((exp)=>({
                key: exp.id,
                status: $a746d728be9a3387$export$c742923ea4ac4c1c(exp.exportStatus),
                type: t(`exportType_${exp.exportType}`),
                projectName: exp.projectName,
                author: exp.author,
                createdAt: (0, (/*@__PURE__*/$parcel$interopDefault($jzGiR)))(exp.createdAt).format("L HH:mm"),
                completedAt: exp.completedAt ? (0, (/*@__PURE__*/$parcel$interopDefault($jzGiR)))(exp.completedAt).format("L HH:mm") : "",
                duration: exp.completedAt ? (0, $7ff84a88030acb67$export$21f7a88e2aa3d4f5)(exp.createdAt, exp.completedAt) : "",
                includeAudio: exp.config.include_audio ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6828f0a716a30b6e$export$2e2bcd8739ae039), {}) : null,
                config: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                            children: exp.config.coloration.custom ? t("project.existing.index.syllableComponent.custom") : ""
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                            children: exp.config.coloration.phoneme ? t("project.existing.index.syllableComponent.phonemes") : ""
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                            children: exp.config.coloration.syllable ? t("project.existing.index.syllableComponent.syllables") : ""
                        })
                    ]
                }),
                action: $a746d728be9a3387$var$getActionBtn(exp, download, cancel, deletingExportIds)
            })), [
        cancel,
        download,
        exports,
        deletingExportIds,
        t
    ]);
    // Rows selection logic
    const [selectedRowKeys, setSelectedRowKeys] = (0, $jMaZ8.useState)([]);
    const rowSelection = (0, $jMaZ8.useMemo)(()=>({
            selectedRowKeys: selectedRowKeys,
            onChange: setSelectedRowKeys
        }), [
        selectedRowKeys
    ]);
    const hasSelected = selectedRowKeys.length > 0;
    const deleteExports = (0, $jMaZ8.useCallback)(async ()=>{
        await deleteExportsProps(selectedRowKeys);
        setSelectedRowKeys([]);
    }, [
        deleteExportsProps,
        selectedRowKeys
    ]);
    return {
        data: data,
        rowSelection: rowSelection,
        hasSelected: hasSelected,
        deleteExports: deleteExports
    };
}



function $e8ef3aebcbd5c1b6$export$2e2bcd8739ae039({ exports: exports, cancel: cancel, download: download, deleteExports: deleteExportsProps, deleteLoading: deleteLoading, deletingExportIds: deletingExportIds, hideTopLegend: hideTopLegend }) {
    const { data: data, rowSelection: rowSelection, hasSelected: hasSelected, deleteExports: deleteExports } = (0, $a746d728be9a3387$export$2e2bcd8739ae039)({
        exports: exports,
        cancel: cancel,
        download: download,
        deleteExportsProps: deleteExportsProps,
        deletingExportIds: deletingExportIds
    });
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    const columns = (0, $jMaZ8.useMemo)(()=>{
        return [
            {
                title: t("tableExportsColumnStatus"),
                dataIndex: "status",
                width: 50
            },
            {
                title: t("tableExportsColumnType"),
                dataIndex: "type",
                width: 30
            },
            {
                title: t("tableExportsColumnProjectName"),
                dataIndex: "projectName",
                width: 180
            },
            {
                title: t("tableExportsColumnAuthor"),
                dataIndex: "author",
                width: 160
            },
            {
                title: t("tableExportsColumnCreatedAt"),
                dataIndex: "createdAt",
                width: 100
            },
            {
                title: t("tableExportsColumnCompletedAt"),
                dataIndex: "completedAt",
                width: 100
            },
            {
                title: t("tableExportsColumnDuration"),
                dataIndex: "duration",
                width: 60
            },
            {
                title: t("tableExportsColumnIncludeAudio"),
                dataIndex: "includeAudio",
                width: 40
            },
            {
                title: t("tableExportsColumnConfig"),
                dataIndex: "config",
                className: "cell-config",
                width: 40
            },
            {
                title: t("tableExportsColumnAction"),
                dataIndex: "action",
                width: 40
            }
        ];
    }, [
        t
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $fb2727a70b78a71d$export$b1b07211686a04d0,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $fb2727a70b78a71d$export$c2e79b64b0a9746b,
                children: [
                    !!data.length && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        className: $fb2727a70b78a71d$export$8a8237989e2ce9a5,
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                type: "primary",
                                disabled: !hasSelected || deleteLoading,
                                className: $fb2727a70b78a71d$export$3210a79c026cb1a8,
                                onClick: deleteExports,
                                loading: deleteLoading,
                                children: !deleteLoading && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $add96a083ff0f53e$export$2e2bcd8739ae039), {
                                    className: $fb2727a70b78a71d$export$12d45ee5c2161b75
                                })
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                                style: {
                                    marginLeft: 8
                                },
                                children: hasSelected ? `(${rowSelection.selectedRowKeys.length})` : ""
                            })
                        ]
                    }),
                    !hideTopLegend && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3b184c50062b0fa2$export$2e2bcd8739ae039), {
                        className: $fb2727a70b78a71d$export$2f6f961c6d3131fc,
                        message: t("tableExportsRetentionInfo"),
                        type: "info",
                        showIcon: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $fb2727a70b78a71d$export$b1c67c41ddd97f48,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0c81d311e7fde9b8$export$2e2bcd8739ae039), {
                    rowSelection: rowSelection,
                    columns: columns,
                    dataSource: data,
                    pagination: {
                        position: [
                            "topRight"
                        ]
                    }
                })
            })
        ]
    });
}


function $b599403e7316dbe1$export$2e2bcd8739ae039({ useProjectExportsHook: useProjectExportsHook }) {
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e8ef3aebcbd5c1b6$export$2e2bcd8739ae039), {
        exports: useProjectExportsHook.exports,
        cancel: useProjectExportsHook.cancelExport,
        download: useProjectExportsHook.downloadExport,
        deleteExports: useProjectExportsHook.deleteExports,
        deleteLoading: useProjectExportsHook.deleteLoading,
        deletingExportIds: useProjectExportsHook.deletingExportIds
    });
}



parcelRequire("jMaZ8");

var $d1e811e2a44b0648$export$e8e78c978b129247;
$d1e811e2a44b0648$export$e8e78c978b129247 = "root_397f1e";



var $jMaZ8 = parcelRequire("jMaZ8");



var $62LIg = parcelRequire("62LIg");


const $63226ce6fa1cb7bd$export$41f03b13e119f6ab = (exports)=>{
    const copy = (0, $62LIg.cloneDeep)(exports);
    copy.sort((a, b)=>b.createdAt < a.createdAt ? -1 : 1);
    return copy;
};
const $63226ce6fa1cb7bd$export$6c6d914109c00c09 = (exports, shouldFilterDoneIfOld)=>{
    const copy = (0, $62LIg.cloneDeep)(exports);
    return !shouldFilterDoneIfOld ? copy : copy.filter((exp)=>exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).DONE ? !(0, $7ff84a88030acb67$export$ac8be1d0bc279ee4)(exp.completedAt) : true);
};
const $63226ce6fa1cb7bd$export$834506b9c4e9137 = (exports, projectId)=>{
    const copy = (0, $62LIg.cloneDeep)(exports);
    return !projectId ? [
        ...copy
    ] : copy.filter((p)=>p.projectId === projectId);
};
const $63226ce6fa1cb7bd$export$2b37e90936117f39 = (exports, search = "")=>{
    const copy = (0, $62LIg.cloneDeep)(exports);
    return copy.filter((p)=>{
        const s = search.toLowerCase().trim();
        if (!s) return true;
        return p.projectName.toLowerCase().includes(s) || p.projectAuthor.toLowerCase().includes(s) || p.exportType.toLowerCase().includes(s) || p.author.toLowerCase().includes(s) || p.filename?.toLowerCase()?.includes(s);
    });
};


function $8a33cee9d25774bf$export$2e2bcd8739ae039(projectId, search = "") {
    const shouldFilterDoneIfOld = !projectId; // Filter only on globla export tab
    /**
   * Data
   */ const { data: { exports: exports } = {
        exports: []
    } } = (0, $d7188398173686a1$export$32c546a13f0abf25)();
    const [getExportDownloadLink] = (0, $d7188398173686a1$export$b77d745274cc19d1)();
    const [deleteExport, { loading: deleteLoading }] = (0, $d7188398173686a1$export$1136e9e8becca14)();
    const [deletingExportIds, setDeletingExportIds] = (0, $jMaZ8.useState)([]);
    const filteredExports = (0, $jMaZ8.useMemo)(()=>{
        const exp1 = (0, $63226ce6fa1cb7bd$export$41f03b13e119f6ab)(exports); // Sort, more recent first
        const exp2 = (0, $63226ce6fa1cb7bd$export$6c6d914109c00c09)(exp1, shouldFilterDoneIfOld); // Filter less than 24h if DONE (only in global view)
        const exp3 = (0, $63226ce6fa1cb7bd$export$834506b9c4e9137)(exp2, projectId); // Filters only if not global view
        const exp4 = (0, $63226ce6fa1cb7bd$export$2b37e90936117f39)(exp3, search);
        return exp4;
    }, [
        exports,
        projectId,
        shouldFilterDoneIfOld,
        search
    ]);
    const processing = (0, $jMaZ8.useMemo)(()=>{
        const count = exports.reduce((count, exp)=>{
            const isProcessing = exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).WAITING || exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).IN_PROGRESS;
            return isProcessing ? count + 1 : count;
        }, 0);
        const processingExports = exports.filter((exp)=>exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).WAITING || exp.exportStatus === (0, $b522cf181e75e62d$export$602981314f6adf1a).IN_PROGRESS);
        return {
            count: count,
            exports: processingExports
        };
    }, [
        exports
    ]);
    /**
   * Handlers
   */ const cancelExport = (0, $jMaZ8.useCallback)(async (projectId, exportId)=>{
        try {
            setDeletingExportIds([
                exportId
            ]);
            await deleteExport({
                variables: {
                    exports: [
                        {
                            exportId: exportId,
                            projectId: projectId
                        }
                    ]
                }
            });
        } catch (e) {
            console.error(e);
        } finally{
            setDeletingExportIds([]);
        }
    }, [
        deleteExport
    ]);
    // Get download URL and download
    const downloadExport = (0, $jMaZ8.useCallback)(async (projectId, exportId)=>{
        // Fetch the download URL
        const res = await getExportDownloadLink({
            variables: {
                projectId: projectId,
                exportId: exportId
            }
        });
        const downloadURL = res.data?.exportDownloadUrl;
        if (downloadURL) {
            // Download the file
            const link = document.createElement("a");
            link.href = downloadURL;
            link.click();
        }
    }, [
        getExportDownloadLink
    ]);
    const deleteExports = (0, $jMaZ8.useCallback)(async (exportIds)=>{
        try {
            const exportsMap = exportIds.map((exportId)=>({
                    exportId: exportId,
                    projectId: exports.find((exp)=>exp.id === exportId)?.projectId
                }));
            setDeletingExportIds(exportIds);
            await deleteExport({
                variables: {
                    exports: exportsMap
                }
            });
        } catch (e) {
            console.error(e);
        } finally{
            setDeletingExportIds([]);
        }
    }, [
        deleteExport,
        exports
    ]);
    return {
        // Data
        exports: filteredExports,
        processing: processing,
        cancelExport: // Handlers
        cancelExport,
        downloadExport: downloadExport,
        deleteExports: deleteExports,
        deleteLoading: // State
        deleteLoading,
        deletingExportIds: deletingExportIds
    };
}



function $af793f000cc48ead$export$2e2bcd8739ae039({ projectId: projectId, open: open, onDismiss: onDismiss }) {
    const { exports: exports, cancelExport: cancelExport, downloadExport: downloadExport, deleteExports: deleteExports, deleteLoading: deleteLoading, deletingExportIds: deletingExportIds } = (0, $8a33cee9d25774bf$export$2e2bcd8739ae039)(projectId);
    const projectName = exports.find((exp)=>exp.projectId === projectId)?.projectName;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        className: $d1e811e2a44b0648$export$e8e78c978b129247,
        title: projectName,
        centered: true,
        open: open,
        onOk: onDismiss,
        onCancel: onDismiss,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e8ef3aebcbd5c1b6$export$2e2bcd8739ae039), {
            exports: exports,
            cancel: cancelExport,
            download: downloadExport,
            deleteExports: deleteExports,
            deleteLoading: deleteLoading,
            deletingExportIds: deletingExportIds,
            hideTopLegend: true
        })
    });
}





var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
var $330da04ae9854df6$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $330da04ae9854df6$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $330da04ae9854df6$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $330da04ae9854df6$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $330da04ae9854df6$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $330da04ae9854df6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $330da04ae9854df6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $330da04ae9854df6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $330da04ae9854df6$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $330da04ae9854df6$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $330da04ae9854df6$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $330da04ae9854df6$var$root = $330da04ae9854df6$var$freeGlobal || $330da04ae9854df6$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $330da04ae9854df6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $330da04ae9854df6$var$objectToString = $330da04ae9854df6$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $330da04ae9854df6$var$nativeMax = Math.max, $330da04ae9854df6$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $330da04ae9854df6$var$now = function() {
    return $330da04ae9854df6$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $330da04ae9854df6$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($330da04ae9854df6$var$FUNC_ERROR_TEXT);
    wait = $330da04ae9854df6$var$toNumber(wait) || 0;
    if ($330da04ae9854df6$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $330da04ae9854df6$var$nativeMax($330da04ae9854df6$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $330da04ae9854df6$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $330da04ae9854df6$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($330da04ae9854df6$var$now());
    }
    function debounced() {
        var time = $330da04ae9854df6$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $330da04ae9854df6$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $330da04ae9854df6$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $330da04ae9854df6$var$isSymbol(value) {
    return typeof value == 'symbol' || $330da04ae9854df6$var$isObjectLike(value) && $330da04ae9854df6$var$objectToString.call(value) == $330da04ae9854df6$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $330da04ae9854df6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($330da04ae9854df6$var$isSymbol(value)) return $330da04ae9854df6$var$NAN;
    if ($330da04ae9854df6$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $330da04ae9854df6$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($330da04ae9854df6$var$reTrim, '');
    var isBinary = $330da04ae9854df6$var$reIsBinary.test(value);
    return isBinary || $330da04ae9854df6$var$reIsOctal.test(value) ? $330da04ae9854df6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $330da04ae9854df6$var$reIsBadHex.test(value) ? $330da04ae9854df6$var$NAN : +value;
}
$330da04ae9854df6$exports = $330da04ae9854df6$var$debounce;


// src/useBoolean/useBoolean.ts
function $ffc4c777120a72ab$export$c32275ecbd12948f(defaultValue = false) {
    if (typeof defaultValue !== "boolean") throw new Error("defaultValue must be `true` or `false`");
    const [value, setValue] = (0, $jMaZ8.useState)(defaultValue);
    const setTrue = (0, $jMaZ8.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $jMaZ8.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $jMaZ8.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $ffc4c777120a72ab$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $jMaZ8.useLayoutEffect) : (0, $jMaZ8.useEffect);
// src/useEventListener/useEventListener.ts
function $ffc4c777120a72ab$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $jMaZ8.useRef)(handler);
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $ffc4c777120a72ab$export$5139c081cbc6c8bb(handler) {
    $ffc4c777120a72ab$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $ffc4c777120a72ab$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $jMaZ8.useState)(null);
    const copy = (0, $jMaZ8.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $ffc4c777120a72ab$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $jMaZ8.useState)(initialValue ?? 0);
    const increment = (0, $jMaZ8.useCallback)(()=>{
        setCount((x)=>x + 1);
    }, []);
    const decrement = (0, $jMaZ8.useCallback)(()=>{
        setCount((x)=>x - 1);
    }, []);
    const reset = (0, $jMaZ8.useCallback)(()=>{
        setCount(initialValue ?? 0);
    }, [
        initialValue
    ]);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $ffc4c777120a72ab$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $jMaZ8.useRef)(callback);
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $ffc4c777120a72ab$export$8103f7eb37e19f7b({ countStart: countStart, countStop: countStop = 0, intervalMs: intervalMs = 1e3, isIncrement: isIncrement = false }) {
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $ffc4c777120a72ab$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $ffc4c777120a72ab$export$c32275ecbd12948f(false);
    const resetCountdown = (0, $jMaZ8.useCallback)(()=>{
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    const countdownCallback = (0, $jMaZ8.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $ffc4c777120a72ab$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $ffc4c777120a72ab$export$ee5b5d04074a389e(fn) {
    const ref = (0, $jMaZ8.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $jMaZ8.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $ffc4c777120a72ab$var$IS_SERVER = typeof window === "undefined";
function $ffc4c777120a72ab$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $jMaZ8.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $jMaZ8.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $jMaZ8.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($ffc4c777120a72ab$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $jMaZ8.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $ffc4c777120a72ab$export$ee5b5d04074a389e((value)=>{
        if ($ffc4c777120a72ab$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $ffc4c777120a72ab$export$ee5b5d04074a389e(()=>{
        if ($ffc4c777120a72ab$var$IS_SERVER) console.warn(`Tried removing localStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.localStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("local-storage", {
            key: key
        }));
    });
    (0, $jMaZ8.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $jMaZ8.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $ffc4c777120a72ab$export$7080b3e976bc91ab("storage", handleStorageChange);
    $ffc4c777120a72ab$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
var $ffc4c777120a72ab$var$IS_SERVER2 = typeof window === "undefined";
function $ffc4c777120a72ab$export$32d5543ab307c01(query, { defaultValue: defaultValue = false, initializeWithValue: initializeWithValue = true } = {}) {
    const getMatches = (query2)=>{
        if ($ffc4c777120a72ab$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $jMaZ8.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $ffc4c777120a72ab$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $ffc4c777120a72ab$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $ffc4c777120a72ab$export$4673cbff94e146e2(options = {}) {
    const { defaultValue: defaultValue, localStorageKey: localStorageKey = $ffc4c777120a72ab$var$LOCAL_STORAGE_KEY, initializeWithValue: initializeWithValue = true } = options;
    const isDarkOS = $ffc4c777120a72ab$export$32d5543ab307c01($ffc4c777120a72ab$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $ffc4c777120a72ab$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $ffc4c777120a72ab$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $jMaZ8.useRef)(func);
    funcRef.current = func;
    (0, $jMaZ8.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $ffc4c777120a72ab$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $jMaZ8.useRef)();
    $ffc4c777120a72ab$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $jMaZ8.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($330da04ae9854df6$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($330da04ae9854df6$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $ffc4c777120a72ab$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $jMaZ8.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $jMaZ8.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $ffc4c777120a72ab$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $ffc4c777120a72ab$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $jMaZ8.useRef)(null);
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $ffc4c777120a72ab$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $ffc4c777120a72ab$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $jMaZ8.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $ffc4c777120a72ab$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $ffc4c777120a72ab$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $ffc4c777120a72ab$export$a7395f9832c00176({ threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = (0, $jMaZ8.useState)(null);
    const [state, setState] = (0, $jMaZ8.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $jMaZ8.useRef)();
    callbackRef.current = onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $jMaZ8.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $jMaZ8.useRef)(null);
    (0, $jMaZ8.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    const result = [
        setRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $ffc4c777120a72ab$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $jMaZ8.useState)(false);
    (0, $jMaZ8.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $ffc4c777120a72ab$export$80c2a3957bcb42ea() {
    const isMounted = (0, $jMaZ8.useRef)(false);
    (0, $jMaZ8.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $jMaZ8.useCallback)(()=>isMounted.current, []);
}
function $ffc4c777120a72ab$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $jMaZ8.useState)(new Map(initialState));
    const actions = {
        set: (0, $jMaZ8.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $jMaZ8.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $jMaZ8.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $jMaZ8.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $ffc4c777120a72ab$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
    $ffc4c777120a72ab$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.filter((r)=>Boolean(r.current)).every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    }, void 0, eventListenerOptions);
}
var $ffc4c777120a72ab$var$IS_SERVER3 = typeof window === "undefined";
function $ffc4c777120a72ab$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($ffc4c777120a72ab$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $jMaZ8.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $jMaZ8.useCallback)(()=>{
        if ($ffc4c777120a72ab$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $jMaZ8.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $jMaZ8.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $jMaZ8.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $ffc4c777120a72ab$export$7080b3e976bc91ab("storage", handleStorageChange);
    $ffc4c777120a72ab$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $ffc4c777120a72ab$var$initialSize = {
    width: void 0,
    height: void 0
};
function $ffc4c777120a72ab$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $jMaZ8.useState)($ffc4c777120a72ab$var$initialSize);
    const isMounted = $ffc4c777120a72ab$export$80c2a3957bcb42ea();
    const previousSize = (0, $jMaZ8.useRef)({
        ...$ffc4c777120a72ab$var$initialSize
    });
    const onResize = (0, $jMaZ8.useRef)(void 0);
    onResize.current = options.onResize;
    (0, $jMaZ8.useEffect)(()=>{
        if (!ref.current) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $ffc4c777120a72ab$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $ffc4c777120a72ab$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $ffc4c777120a72ab$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $ffc4c777120a72ab$var$IS_SERVER4 = typeof window === "undefined";
function $ffc4c777120a72ab$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($ffc4c777120a72ab$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($ffc4c777120a72ab$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $jMaZ8.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $ffc4c777120a72ab$export$40ae01be0011c1e6(setScreen, options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = options.debounceDelay ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $ffc4c777120a72ab$export$7080b3e976bc91ab("resize", handleSize);
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $ffc4c777120a72ab$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $ffc4c777120a72ab$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $ffc4c777120a72ab$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $jMaZ8.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $ffc4c777120a72ab$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $jMaZ8.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $ffc4c777120a72ab$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $ffc4c777120a72ab$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $ffc4c777120a72ab$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $ffc4c777120a72ab$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $ffc4c777120a72ab$var$IS_SERVER5 = typeof window === "undefined";
function $ffc4c777120a72ab$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $jMaZ8.useState)(false);
    const target = (0, $jMaZ8.useRef)(null);
    const originalStyle = (0, $jMaZ8.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        if ($ffc4c777120a72ab$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $ffc4c777120a72ab$var$IS_SERVER6 = typeof window === "undefined";
function $ffc4c777120a72ab$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $jMaZ8.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $jMaZ8.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $jMaZ8.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($ffc4c777120a72ab$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $jMaZ8.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $ffc4c777120a72ab$export$ee5b5d04074a389e((value)=>{
        if ($ffc4c777120a72ab$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $ffc4c777120a72ab$export$ee5b5d04074a389e(()=>{
        if ($ffc4c777120a72ab$var$IS_SERVER6) console.warn(`Tried removing sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.sessionStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("session-storage", {
            key: key
        }));
    });
    (0, $jMaZ8.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $jMaZ8.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $ffc4c777120a72ab$export$7080b3e976bc91ab("storage", handleStorageChange);
    $ffc4c777120a72ab$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
function $ffc4c777120a72ab$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $jMaZ8.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $jMaZ8.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $jMaZ8.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $jMaZ8.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $jMaZ8.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $ffc4c777120a72ab$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $ffc4c777120a72ab$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $ffc4c777120a72ab$export$ec561688e440eda6({ defaultValue: defaultValue = "system", localStorageKey: localStorageKey = $ffc4c777120a72ab$var$LOCAL_STORAGE_KEY2, initializeWithValue: initializeWithValue = true } = {}) {
    const isDarkOS = $ffc4c777120a72ab$export$32d5543ab307c01($ffc4c777120a72ab$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $ffc4c777120a72ab$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $ffc4c777120a72ab$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $jMaZ8.useRef)(callback);
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $ffc4c777120a72ab$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $jMaZ8.useState)(!!defaultValue);
    const toggle = (0, $jMaZ8.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $ffc4c777120a72ab$var$IS_SERVER7 = typeof window === "undefined";
function $ffc4c777120a72ab$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($ffc4c777120a72ab$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $jMaZ8.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $ffc4c777120a72ab$export$40ae01be0011c1e6(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $ffc4c777120a72ab$export$7080b3e976bc91ab("resize", handleSize);
    $ffc4c777120a72ab$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}





const $5f28b74f6646476d$var$REFRESH_INTERVAL = 5000; // ms
function $5f28b74f6646476d$export$2e2bcd8739ae039({ _export: _export }) {
    const [duration, setDuration] = (0, $jMaZ8.useState)((0, $7ff84a88030acb67$export$21f7a88e2aa3d4f5)(_export.createdAt));
    (0, $ffc4c777120a72ab$export$f4b266cd2aae9cb1)(()=>{
        setDuration((0, $7ff84a88030acb67$export$21f7a88e2aa3d4f5)(_export.createdAt));
    }, $5f28b74f6646476d$var$REFRESH_INTERVAL);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $8937beb26988c737$export$3015c6563dc2df33,
        children: [
            (0, $a746d728be9a3387$export$c742923ea4ac4c1c)(_export.exportStatus),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("p", {
                className: $8937beb26988c737$export$d7d0a8179707aa27,
                children: [
                    _export.projectName,
                    " - ",
                    _export.author,
                    " - ",
                    _export.author,
                    " - (",
                    duration,
                    ")"
                ]
            })
        ]
    });
}



var $jMaZ8 = parcelRequire("jMaZ8");

const $93ed502a924f5874$export$143208cda651e06e = (variables)=>(0, $56ed5432ec247a44$export$368b4214baeb914c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      subscription SubToProjectForHomepage($archivedProjects: Boolean) {
        projects(archivedProjects: $archivedProjects) {
          id
          name
          author
          kind
          createdAt
          EAN: ean
          userBasedAccess
          importStatus
          kind
          config {
            id
            narrationWordsCountLimit
            locale
          }
          status
          preparationProgress
          isNarrationComplete
          isDoingAudioResync
          customColorationConfig
          roles {
            id
            userRole
            userTask
            userId
            projectId
          }
        }
      }
    `, {
        variables: variables
    });


function $d1416364d497ca76$export$2e2bcd8739ae039({ filterString: filterString, archivedProjects: archivedProjects }) {
    const { loading: loading, error: error, data: data } = (0, $93ed502a924f5874$export$143208cda651e06e)({
        archivedProjects: !!archivedProjects
    });
    const projects = (0, $jMaZ8.useMemo)(()=>{
        const projects = data?.projects || [];
        const isSubStr = (reference, subString)=>reference.toUpperCase().indexOf(subString.toUpperCase()) > -1;
        return projects.filter((p)=>isSubStr(p.name, filterString) || isSubStr(p.author, filterString));
    }, [
        data,
        filterString
    ]);
    return {
        projects: projects,
        loading: loading,
        error: error
    };
}




var $jMaZ8 = parcelRequire("jMaZ8");






var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $3b5827d2ab17188b$var$ExclamationCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "outlined"
};
var $3b5827d2ab17188b$export$2e2bcd8739ae039 = $3b5827d2ab17188b$var$ExclamationCircleOutlined;



var $e3697a614e1cfe37$var$ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $3b5827d2ab17188b$export$2e2bcd8739ae039)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTQ2NCA2ODhhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem0yNC0xMTJoNDhjNC40IDAgOC0zLjYgOC04VjI5NmMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MjcyYzAgNC40IDMuNiA4IDggOHoiIC8+PC9zdmc+) */ var $e3697a614e1cfe37$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($e3697a614e1cfe37$var$ExclamationCircleOutlined);
$e3697a614e1cfe37$var$RefIcon.displayName = 'ExclamationCircleOutlined';
var $e3697a614e1cfe37$export$2e2bcd8739ae039 = $e3697a614e1cfe37$var$RefIcon;



function $3b4740a038de966f$export$2e2bcd8739ae039({ setModalExport: setModalExport, setModalEdit: setModalEdit, exportNarrationI18nKey: exportNarrationI18nKey }) {
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [applyDeleteProject] = (0, $d7188398173686a1$export$2fc6744ec4c31d26)();
    const [exportProject] = (0, $d7188398173686a1$export$8b0fb4ff6360f2a7)();
    const [launchProjectReSync] = (0, $d7188398173686a1$export$7a505514d2ae74cb)();
    const [isInvitingToProject, setIsInvitingToProject] = (0, $jMaZ8.useState)("");
    const [isRevokingToProject, setIsRevokingToProject] = (0, $jMaZ8.useState)("");
    const [exportsProjectId, setExportsProjectId] = (0, $jMaZ8.useState)("");
    const projectMethods = (0, $jMaZ8.useMemo)(()=>({
            open: (projectId)=>navigate("/editor/books/edit/" + projectId),
            delete: async (projectId)=>{
                (0, $f57978dfa9715a4c$export$2e2bcd8739ae039).confirm({
                    title: t("warning"),
                    icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e3697a614e1cfe37$export$2e2bcd8739ae039), {}),
                    content: t("modalConfirmDelete"),
                    okText: t("validate"),
                    cancelText: t("cancel"),
                    onOk: ()=>applyDeleteProject({
                            variables: {
                                id: projectId
                            }
                        }),
                    okButtonProps: {
                        danger: true
                    }
                });
            },
            invite: setIsInvitingToProject,
            revoke: setIsRevokingToProject,
            edit: setModalEdit,
            export: (projectId, name, isEPubExport = false)=>setModalExport({
                    projectId: projectId,
                    name: name,
                    isEPubExport: isEPubExport
                }),
            exportNarration: async (projectId)=>{
                try {
                    (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).info({
                        message: t(`${exportNarrationI18nKey}.message`)
                    });
                    await exportProject({
                        variables: {
                            projectId: projectId,
                            exportType: (0, $b522cf181e75e62d$export$7e829f6ef9a7acbf).NARRATION,
                            exportConfig: {
                                coloration: (0, $7ff84a88030acb67$export$b7679d1806cb064d)([]),
                                includeAudio: true
                            }
                        }
                    });
                } catch (e) {
                    (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                        message: t(`${exportNarrationI18nKey}.errorNotification`)
                    });
                }
            },
            viewExports: (projectId)=>{
                setExportsProjectId(projectId);
            },
            resync: (projectId)=>{
                (0, $f57978dfa9715a4c$export$2e2bcd8739ae039).confirm({
                    title: t("warning"),
                    icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e3697a614e1cfe37$export$2e2bcd8739ae039), {}),
                    content: t("modalConfirmReSync"),
                    okText: t("validate"),
                    cancelText: t("cancel"),
                    onOk: ()=>launchProjectReSync({
                            variables: {
                                projectId: projectId
                            }
                        }),
                    okButtonProps: {
                        danger: true
                    }
                });
            }
        }), [
        setModalEdit,
        history,
        applyDeleteProject,
        setModalExport,
        t,
        exportNarrationI18nKey,
        exportProject,
        launchProjectReSync
    ]);
    return {
        projectMethods: projectMethods,
        isInvitingToProject: isInvitingToProject,
        isRevokingToProject: isRevokingToProject,
        setIsRevokingToProject: setIsRevokingToProject,
        setIsInvitingToProject: setIsInvitingToProject,
        exportsProjectId: exportsProjectId,
        setExportsProjectId: setExportsProjectId
    };
}



parcelRequire("jMaZ8");

"use client";
var $448bee343edef0e9$export$2e2bcd8739ae039 = (0, $f6b871da920d79b3$export$2e2bcd8739ae039);





var $cf24d28313c17d75$exports = {};

$parcel$export($cf24d28313c17d75$exports, "header", () => $cf24d28313c17d75$export$38e42c68cf43b5d4, (v) => $cf24d28313c17d75$export$38e42c68cf43b5d4 = v);
$parcel$export($cf24d28313c17d75$exports, "tooltipContent", () => $cf24d28313c17d75$export$2cb4ac289f7843e5, (v) => $cf24d28313c17d75$export$2cb4ac289f7843e5 = v);
$parcel$export($cf24d28313c17d75$exports, "version", () => $cf24d28313c17d75$export$83d89fbfd8236492, (v) => $cf24d28313c17d75$export$83d89fbfd8236492 = v);
$parcel$export($cf24d28313c17d75$exports, "userFirstLetterWrapper", () => $cf24d28313c17d75$export$1d733b8e99641072, (v) => $cf24d28313c17d75$export$1d733b8e99641072 = v);
$parcel$export($cf24d28313c17d75$exports, "userFirstLetter", () => $cf24d28313c17d75$export$ab1107743aa4affb, (v) => $cf24d28313c17d75$export$ab1107743aa4affb = v);
var $cf24d28313c17d75$export$38e42c68cf43b5d4;
var $cf24d28313c17d75$export$2cb4ac289f7843e5;
var $cf24d28313c17d75$export$83d89fbfd8236492;
var $cf24d28313c17d75$export$1d733b8e99641072;
var $cf24d28313c17d75$export$ab1107743aa4affb;
$cf24d28313c17d75$export$38e42c68cf43b5d4 = "header_b33b83";
$cf24d28313c17d75$export$2cb4ac289f7843e5 = "tooltipContent_b33b83";
$cf24d28313c17d75$export$83d89fbfd8236492 = "version_b33b83";
$cf24d28313c17d75$export$1d733b8e99641072 = "userFirstLetterWrapper_b33b83";
$cf24d28313c17d75$export$ab1107743aa4affb = "userFirstLetter_b33b83";



const $1e5e48008bccdb82$var$version = "2026-09-15-1f8e149-1789459108176";
function $1e5e48008bccdb82$export$2e2bcd8739ae039({ openPanel: openPanel }) {
    const identity = (0, $dc10a25720c6edc8$export$a2347e5c24cde9c8)();
    const userFirstLetter = identity.user_profile.display_name.slice(0, 1);
    const metaRes = (0, $d7188398173686a1$export$3fb9275d3845bd5a)();
    const serverVersion = metaRes.data?.meta.serverVersion || "";
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039).Header, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).header,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).tooltipContent,
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).version,
                                            children: "app :"
                                        }),
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).version,
                                            children: [
                                                "v",
                                                $1e5e48008bccdb82$var$version
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).version,
                                            children: "server :"
                                        }),
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).version,
                                            children: [
                                                "v",
                                                serverVersion
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $76220dd1f6646070$export$2e2bcd8739ae039), {})
                        })
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).userFirstLetterWrapper,
                            onClick: openPanel,
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cf24d28313c17d75$exports))).userFirstLetter,
                                    children: userFirstLetter
                                }),
                                " "
                            ]
                        })
                    })
                })
            ]
        })
    });
}






var $jMaZ8 = parcelRequire("jMaZ8");


function $ae7820b380858460$export$2e2bcd8739ae039({ projectId: projectId, close: close }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [email, setEmail] = (0, $jMaZ8.useState)("");
    const [revokeAccessToProject] = (0, $d7188398173686a1$export$62bfc57284147717)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        centered: true,
        width: "56.66em",
        title: t("revokeUserAccess"),
        open: projectId !== "",
        onCancel: close,
        footer: null,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
            name: "basic",
            initialValues: {
                remember: true
            },
            onFinish: ()=>{
                revokeAccessToProject({
                    variables: {
                        projectId: projectId,
                        userId: email
                    }
                });
                close();
            },
            layout: "vertical",
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t("userEmail"),
                    name: "name",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        value: email,
                        onChange: (e)=>setEmail(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        margin: 0
                    },
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            disabled: email.length === 0,
                            htmlType: "submit",
                            shape: "round",
                            children: t("revokeUserAccess")
                        })
                    })
                })
            ]
        })
    }, projectId);
}


const $1fb40d341a46cac4$var$antIcon = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), {
    style: {
        fontSize: 24
    },
    spin: true
});
const $1fb40d341a46cac4$var$i18nKey = "library.index";
const $1fb40d341a46cac4$var$ProjectsPage = ()=>{
    // i18n
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const defaultI18nKey = `${$1fb40d341a46cac4$var$i18nKey}.default`;
    const exportNarrationI18nKey = `${defaultI18nKey}.exportNarration`;
    const projectI18nKey = `${defaultI18nKey}.project`;
    const navBarI18nKey = `${defaultI18nKey}.navBar`;
    const errorMessage = t(`${navBarI18nKey}.errorMessage`);
    // Misc
    const [filterString, setFilterString] = (0, $jMaZ8.useState)("");
    const { isUserPanelOpened: isUserPanelOpened, openPanel: openPanel, closePanel: closePanel } = (0, $3f292fa78e121485$export$bb9c6c1faf7ea682)();
    const ref = (0, $jMaZ8.useRef)(null);
    // Modal logic
    const [modalNew, setModalNew] = (0, $jMaZ8.useState)(false);
    const [modalEdit, setModalEdit] = (0, $jMaZ8.useState)("");
    const [modalExport, setModalExport] = (0, $jMaZ8.useState)(null);
    // Data hook
    const { projects: projects, loading: loading, error: error } = (0, $d1416364d497ca76$export$2e2bcd8739ae039)({
        filterString: filterString
    });
    const { projects: archivedProjects, loading: archivedLoading, error: archivedError } = (0, $d1416364d497ca76$export$2e2bcd8739ae039)({
        filterString: filterString,
        archivedProjects: true
    });
    // Project methods hook
    const { projectMethods: projectMethods, isInvitingToProject: isInvitingToProject, setIsInvitingToProject: setIsInvitingToProject, setIsRevokingToProject: setIsRevokingToProject, isRevokingToProject: isRevokingToProject, exportsProjectId: exportsProjectId, setExportsProjectId: setExportsProjectId } = (0, $3b4740a038de966f$export$2e2bcd8739ae039)({
        history: history,
        setModalExport: setModalExport,
        setModalEdit: setModalEdit,
        exportNarrationI18nKey: exportNarrationI18nKey
    });
    // Project exports hook
    const useProjectExportsHook = (0, $8a33cee9d25774bf$export$2e2bcd8739ae039)(undefined, filterString);
    const { processing: exportsProcessing } = useProjectExportsHook;
    // Role hook
    const isProjectAdministrator = (0, $dc10a25720c6edc8$export$1b39bc9d16fffc4d)();
    const tabItems = (0, $jMaZ8.useMemo)(()=>{
        return [
            (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                key: "1",
                label: t(`${navBarI18nKey}.tabTitle`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                    children: loading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), {
                        indicator: $1fb40d341a46cac4$var$antIcon
                    }) : error ? errorMessage : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $8937beb26988c737$export$39babdfab504f3da,
                        children: (isProjectAdministrator ? [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ffbeb343de2a9b01$export$2e2bcd8739ae039), {
                                i18nKey: $1fb40d341a46cac4$var$i18nKey,
                                onClick: setModalNew
                            }, "new project")
                        ] : []).concat(projects.map((p)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $631e36d5f79400e2$export$2e2bcd8739ae039), {
                                project: p,
                                projectMethods: projectMethods
                            }, p.id)))
                    })
                })
            }),
            ...isProjectAdministrator ? [
                (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                    key: "2",
                    label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                                children: t(`${exportNarrationI18nKey}.exportsTabLabel`)
                            }),
                            !!exportsProcessing.count && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c5aa6d63acebb2d0$export$2e2bcd8739ae039), {
                                destroyTooltipOnHide: true,
                                placement: "bottom",
                                content: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                                    children: exportsProcessing.exports.map((exp)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5f28b74f6646476d$export$2e2bcd8739ae039), {
                                            _export: exp
                                        }, exp.id))
                                }),
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                                    className: $8937beb26988c737$export$b31780c78f6e4eb9,
                                    children: [
                                        " ",
                                        "(",
                                        exportsProcessing.count,
                                        ")"
                                    ]
                                })
                            })
                        ]
                    }),
                    children: loading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), {
                        indicator: $1fb40d341a46cac4$var$antIcon
                    }) : error ? errorMessage : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b599403e7316dbe1$export$2e2bcd8739ae039), {
                        useProjectExportsHook: useProjectExportsHook
                    })
                }),
                (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                    key: "3",
                    label: t("tabArchivesLabel"),
                    children: archivedLoading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), {
                        indicator: $1fb40d341a46cac4$var$antIcon
                    }) : error ? archivedError?.message : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                        children: [
                            !archivedProjects?.length && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2e81825c370cda5d$export$2e2bcd8739ae039), {
                                description: t("tabArchivesNoResult")
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                className: $8937beb26988c737$export$39babdfab504f3da,
                                children: archivedProjects.map((p)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $631e36d5f79400e2$export$2e2bcd8739ae039), {
                                        project: p,
                                        projectMethods: projectMethods
                                    }, p.id))
                            })
                        ]
                    })
                })
            ] : []
        ];
    }, [
        archivedError?.message,
        archivedLoading,
        archivedProjects,
        error,
        errorMessage,
        exportNarrationI18nKey,
        exportsProcessing.count,
        exportsProcessing.exports,
        isProjectAdministrator,
        loading,
        navBarI18nKey,
        projectMethods,
        projects,
        t,
        useProjectExportsHook
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f97820cb6d9a09fc$export$2e2bcd8739ae039), {
                projectId: isInvitingToProject,
                close: ()=>setIsInvitingToProject("")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ae7820b380858460$export$2e2bcd8739ae039), {
                projectId: isRevokingToProject,
                close: ()=>setIsRevokingToProject("")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $686f8972f7d4409a$export$2e2bcd8739ae039), {
                name: modalExport?.name,
                id: modalExport?.projectId,
                isEPubExport: modalExport?.isEPubExport,
                onExit: ()=>setModalExport(null)
            }),
            modalNew ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f1a5fd6446a4180c$export$2e2bcd8739ae039), {
                onSuccess: ()=>{
                    (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).info({
                        message: t(`${projectI18nKey}.successMessage`)
                    });
                    setModalNew(false);
                },
                onError: (val)=>{
                    if (val instanceof Error) {
                        const jsonBlob = new Blob([
                            val.message
                        ], {
                            type: "application/json"
                        });
                        const url = URL.createObjectURL(jsonBlob);
                        (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                            message: t(`${projectI18nKey}.errorMessage`),
                            description: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("a", {
                                href: url,
                                children: t("downloadErrorReport")
                            })
                        });
                    }
                    setModalNew(false);
                },
                container: ref.current || undefined,
                setIsOpen: setModalNew
            }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {}),
            modalEdit !== "" && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ef17d3091b920205$export$2e2bcd8739ae039), {
                projectId: modalEdit,
                validate: ()=>setModalEdit(""),
                cancel: ()=>setModalEdit(""),
                reference: ref
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $a3bb6174129512e9$export$2e2bcd8739ae039), {
                className: $8937beb26988c737$export$e8e78c978b129247,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e5e48008bccdb82$export$2e2bcd8739ae039), {
                        openPanel: openPanel
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039).Content, {
                        className: $8937beb26988c737$export$a7db06668cad9adb,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3d078c5b7a14a8e5$export$2e2bcd8739ae039), {
                            tabBarExtraContent: {
                                left: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h1", {
                                    className: $8937beb26988c737$export$b1ba3b667808f37f,
                                    children: t(`${navBarI18nKey}.title`)
                                }),
                                right: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6c59170a575a71c0$export$2e2bcd8739ae039), {
                                    onChange: setFilterString
                                })
                            },
                            className: $8937beb26988c737$export$39f5674517ec0000,
                            defaultActiveKey: "1",
                            onChange: ()=>{},
                            items: tabItems
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3f292fa78e121485$export$d02877a6a1957b9b), {
                closePanel: closePanel,
                isUserPanelOpened: isUserPanelOpened
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $af793f000cc48ead$export$2e2bcd8739ae039), {
                projectId: exportsProjectId,
                open: !!exportsProjectId,
                onDismiss: ()=>setExportsProjectId("")
            })
        ]
    });
};
var $1fb40d341a46cac4$export$2e2bcd8739ae039 = $1fb40d341a46cac4$var$ProjectsPage;


var $d5c94297b9de8dd4$export$882461b6382ed46c;
var $d5c94297b9de8dd4$export$757ceba2d55c277e;
'use strict';

var $6UWRi = parcelRequire("6UWRi");
var $d5c94297b9de8dd4$var$i = $6UWRi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$d5c94297b9de8dd4$export$882461b6382ed46c = function(c, o) {
    $d5c94297b9de8dd4$var$i.usingClientEntryPoint = true;
    try {
        return $6UWRi.createRoot(c, o);
    } finally{
        $d5c94297b9de8dd4$var$i.usingClientEntryPoint = false;
    }
};
$d5c94297b9de8dd4$export$757ceba2d55c277e = function(c, h, o) {
    $d5c94297b9de8dd4$var$i.usingClientEntryPoint = true;
    try {
        return $6UWRi.hydrateRoot(c, h, o);
    } finally{
        $d5c94297b9de8dd4$var$i.usingClientEntryPoint = false;
    }
};


/* eslint-disable react/display-name */ 



var $jMaZ8 = parcelRequire("jMaZ8");


parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
var $4cd667fc4254eafa$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
var $4cd667fc4254eafa$var$envHasBigInt64Array = typeof BigInt64Array !== 'undefined';
$4cd667fc4254eafa$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            for (i of a.entries())if (!equal(i[1], b.get(i[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


function $5e59f7a018e7ea3d$export$5cae361ad82dce8b(value) {
    const ref = (0, $jMaZ8.useRef)();
    (0, $jMaZ8.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}
function $5e59f7a018e7ea3d$export$e01bc50e52e53f78(reducer, initialState, storageKey) {
    const init = (0, $jMaZ8.useCallback)(()=>{
        const stringState = localStorage.getItem(storageKey);
        if (stringState) try {
            return JSON.parse(stringState);
        } catch (error) {
            return initialState;
        }
        else return initialState;
    }, [
        initialState,
        storageKey
    ]);
    const [state, dispatch] = (0, $jMaZ8.useReducer)(reducer, initialState, init);
    const prevState = $5e59f7a018e7ea3d$export$5cae361ad82dce8b(state);
    (0, $jMaZ8.useEffect)(()=>{
        const stateEqual = (0, (/*@__PURE__*/$parcel$interopDefault($4cd667fc4254eafa$exports)))(prevState, state);
        if (!stateEqual) {
            const stringifiedState = JSON.stringify(state);
            localStorage.setItem(storageKey, stringifiedState);
        }
    }, [
        prevState,
        state,
        storageKey
    ]);
    const store = (0, $jMaZ8.useMemo)(()=>({
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return store;
}


const $5268dc96f888c70d$export$67a2fa17d0497bd1 = 1;
const $5268dc96f888c70d$export$86880b4b2e1a2384 = "MOBIDYS_SLIDER_FONT_SIZE";



const $bd641e0beaa46452$export$d4c72bab9d6cc13a = {
    value: (0, $5268dc96f888c70d$export$67a2fa17d0497bd1)
};
function $bd641e0beaa46452$export$2e2bcd8739ae039(_state, action) {
    switch(action.type){
        case "FONT_SIZE_CHANGED":
            return {
                value: action.value
            };
        default:
            throw new Error(`Action ${action.type} not handled`);
    }
}


const $a4507719465753c1$var$SliderFontSizeContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);
const $a4507719465753c1$export$318bad5a1fb16ff = ({ children: children })=>{
    const store = (0, $5e59f7a018e7ea3d$export$e01bc50e52e53f78)((0, $bd641e0beaa46452$export$2e2bcd8739ae039), (0, $bd641e0beaa46452$export$d4c72bab9d6cc13a), (0, $5268dc96f888c70d$export$86880b4b2e1a2384));
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($a4507719465753c1$var$SliderFontSizeContext.Provider, {
        value: store,
        children: children
    });
};
const $a4507719465753c1$var$useSliderFontSizeStoreContext = ()=>{
    const context = (0, $jMaZ8.useContext)($a4507719465753c1$var$SliderFontSizeContext);
    if (!context) throw new Error("SliderFontSizeContext must be used within a SliderFontSizeProvider");
    return context;
};
const $a4507719465753c1$export$97e1252eeb182290 = ()=>{
    const { state: { value: value }, dispatch: dispatch } = $a4507719465753c1$var$useSliderFontSizeStoreContext();
    return {
        value: value,
        onChange: (val)=>dispatch({
                type: "FONT_SIZE_CHANGED",
                value: val
            })
    };
};




var $jMaZ8 = parcelRequire("jMaZ8");
function $64440fdf5e210924$export$df67168c104ba0e3(pages) {
    let inheritedName = "";
    const headers = new Map();
    for (const page of pages){
        if (page.partName) inheritedName = page.partName;
        headers.set(page.id, {
            page: page,
            partName: inheritedName
        });
    }
    return headers;
}




parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");
/* eslint-disable react/display-name */ 

var $jMaZ8 = parcelRequire("jMaZ8");

var $9434db2d28cdae1f$exports = {};
var $1e4908e5fd78bfb9$exports = {};
var $3644d76fe4e76010$exports = {};

var $3644d76fe4e76010$var$defineProperty = function() {
    try {
        var func = $2557930d4046fd55$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$3644d76fe4e76010$exports = $3644d76fe4e76010$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1e4908e5fd78bfb9$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $3644d76fe4e76010$exports) $3644d76fe4e76010$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$1e4908e5fd78bfb9$exports = $1e4908e5fd78bfb9$var$baseAssignValue;


var $c82336d735c1248a$exports = {};
var $0e2c443e827cb5cd$exports = {};
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $0e2c443e827cb5cd$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
$0e2c443e827cb5cd$exports = $0e2c443e827cb5cd$var$arrayAggregator;


var $8cdac18e8c311a2f$exports = {};
var $9e8248f5533c399d$exports = {};
var $da0f56d4a63de30c$exports = {};
var $5ff68075474e5062$exports = {};
var $aab6a9d9852d524e$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $aab6a9d9852d524e$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$aab6a9d9852d524e$exports = $aab6a9d9852d524e$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $5ff68075474e5062$var$baseFor = $aab6a9d9852d524e$exports();
$5ff68075474e5062$exports = $5ff68075474e5062$var$baseFor;


var $06a04a70bff2418a$exports = {};
var $085017973388a086$exports = {};
var $52a253717d9115e5$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $52a253717d9115e5$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$52a253717d9115e5$exports = $52a253717d9115e5$var$baseTimes;


var $76d785abafd312a1$exports = {};
var $d8e6a2a3844d6752$exports = {};

var $5847935c01696b8f$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5847935c01696b8f$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$5847935c01696b8f$exports = $5847935c01696b8f$var$isObjectLike;


/** `Object#toString` result references. */ var $d8e6a2a3844d6752$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $d8e6a2a3844d6752$var$baseIsArguments(value) {
    return $5847935c01696b8f$exports(value) && $1b700ed35fbf4a25$exports(value) == $d8e6a2a3844d6752$var$argsTag;
}
$d8e6a2a3844d6752$exports = $d8e6a2a3844d6752$var$baseIsArguments;



/** Used for built-in method references. */ var $76d785abafd312a1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76d785abafd312a1$var$hasOwnProperty = $76d785abafd312a1$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $76d785abafd312a1$var$propertyIsEnumerable = $76d785abafd312a1$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $76d785abafd312a1$var$isArguments = $d8e6a2a3844d6752$exports(function() {
    return arguments;
}()) ? $d8e6a2a3844d6752$exports : function(value) {
    return $5847935c01696b8f$exports(value) && $76d785abafd312a1$var$hasOwnProperty.call(value, 'callee') && !$76d785abafd312a1$var$propertyIsEnumerable.call(value, 'callee');
};
$76d785abafd312a1$exports = $76d785abafd312a1$var$isArguments;


var $c9f5bcc2161d3be9$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c9f5bcc2161d3be9$var$isArray = Array.isArray;
$c9f5bcc2161d3be9$exports = $c9f5bcc2161d3be9$var$isArray;



var $3hsAy = parcelRequire("3hsAy");
var $e09f7c085d509244$exports = {};
/** Used as references for various `Number` constants. */ var $e09f7c085d509244$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $e09f7c085d509244$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e09f7c085d509244$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $e09f7c085d509244$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $e09f7c085d509244$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$e09f7c085d509244$exports = $e09f7c085d509244$var$isIndex;


var $c8a0ef8053582682$exports = {};
var $d285b5430464a2a1$exports = {};

var $2c33f94764a3f267$exports = {};
/** Used as references for various `Number` constants. */ var $2c33f94764a3f267$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $2c33f94764a3f267$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $2c33f94764a3f267$var$MAX_SAFE_INTEGER;
}
$2c33f94764a3f267$exports = $2c33f94764a3f267$var$isLength;



/** `Object#toString` result references. */ var $d285b5430464a2a1$var$argsTag = '[object Arguments]', $d285b5430464a2a1$var$arrayTag = '[object Array]', $d285b5430464a2a1$var$boolTag = '[object Boolean]', $d285b5430464a2a1$var$dateTag = '[object Date]', $d285b5430464a2a1$var$errorTag = '[object Error]', $d285b5430464a2a1$var$funcTag = '[object Function]', $d285b5430464a2a1$var$mapTag = '[object Map]', $d285b5430464a2a1$var$numberTag = '[object Number]', $d285b5430464a2a1$var$objectTag = '[object Object]', $d285b5430464a2a1$var$regexpTag = '[object RegExp]', $d285b5430464a2a1$var$setTag = '[object Set]', $d285b5430464a2a1$var$stringTag = '[object String]', $d285b5430464a2a1$var$weakMapTag = '[object WeakMap]';
var $d285b5430464a2a1$var$arrayBufferTag = '[object ArrayBuffer]', $d285b5430464a2a1$var$dataViewTag = '[object DataView]', $d285b5430464a2a1$var$float32Tag = '[object Float32Array]', $d285b5430464a2a1$var$float64Tag = '[object Float64Array]', $d285b5430464a2a1$var$int8Tag = '[object Int8Array]', $d285b5430464a2a1$var$int16Tag = '[object Int16Array]', $d285b5430464a2a1$var$int32Tag = '[object Int32Array]', $d285b5430464a2a1$var$uint8Tag = '[object Uint8Array]', $d285b5430464a2a1$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d285b5430464a2a1$var$uint16Tag = '[object Uint16Array]', $d285b5430464a2a1$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $d285b5430464a2a1$var$typedArrayTags = {};
$d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$float32Tag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$float64Tag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$int8Tag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$int16Tag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$int32Tag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$uint8Tag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$uint8ClampedTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$uint16Tag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$uint32Tag] = true;
$d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$argsTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$arrayTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$arrayBufferTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$boolTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$dataViewTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$dateTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$errorTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$funcTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$mapTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$numberTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$objectTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$regexpTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$setTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$stringTag] = $d285b5430464a2a1$var$typedArrayTags[$d285b5430464a2a1$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $d285b5430464a2a1$var$baseIsTypedArray(value) {
    return $5847935c01696b8f$exports(value) && $2c33f94764a3f267$exports(value.length) && !!$d285b5430464a2a1$var$typedArrayTags[$1b700ed35fbf4a25$exports(value)];
}
$d285b5430464a2a1$exports = $d285b5430464a2a1$var$baseIsTypedArray;


var $75cf5f71f4fff21d$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $75cf5f71f4fff21d$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$75cf5f71f4fff21d$exports = $75cf5f71f4fff21d$var$baseUnary;



var $6Zhl9 = parcelRequire("6Zhl9");
/* Node.js helper references. */ var $c8a0ef8053582682$var$nodeIsTypedArray = $6Zhl9 && $6Zhl9.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $c8a0ef8053582682$var$isTypedArray = $c8a0ef8053582682$var$nodeIsTypedArray ? $75cf5f71f4fff21d$exports($c8a0ef8053582682$var$nodeIsTypedArray) : $d285b5430464a2a1$exports;
$c8a0ef8053582682$exports = $c8a0ef8053582682$var$isTypedArray;


/** Used for built-in method references. */ var $085017973388a086$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $085017973388a086$var$hasOwnProperty = $085017973388a086$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $085017973388a086$var$arrayLikeKeys(value, inherited) {
    var isArr = $c9f5bcc2161d3be9$exports(value), isArg = !isArr && $76d785abafd312a1$exports(value), isBuff = !isArr && !isArg && $3hsAy(value), isType = !isArr && !isArg && !isBuff && $c8a0ef8053582682$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $52a253717d9115e5$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $085017973388a086$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $e09f7c085d509244$exports(key, length)))) result.push(key);
    return result;
}
$085017973388a086$exports = $085017973388a086$var$arrayLikeKeys;


var $c9af7c238e10dcf7$exports = {};
var $7f86b9f1bab219d3$exports = {};
/** Used for built-in method references. */ var $7f86b9f1bab219d3$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $7f86b9f1bab219d3$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $7f86b9f1bab219d3$var$objectProto;
    return value === proto;
}
$7f86b9f1bab219d3$exports = $7f86b9f1bab219d3$var$isPrototype;


var $56f0c2d27a9bd096$exports = {};
var $b6decef72bcea9e6$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $b6decef72bcea9e6$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$b6decef72bcea9e6$exports = $b6decef72bcea9e6$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $56f0c2d27a9bd096$var$nativeKeys = $b6decef72bcea9e6$exports(Object.keys, Object);
$56f0c2d27a9bd096$exports = $56f0c2d27a9bd096$var$nativeKeys;


/** Used for built-in method references. */ var $c9af7c238e10dcf7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c9af7c238e10dcf7$var$hasOwnProperty = $c9af7c238e10dcf7$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c9af7c238e10dcf7$var$baseKeys(object) {
    if (!$7f86b9f1bab219d3$exports(object)) return $56f0c2d27a9bd096$exports(object);
    var result = [];
    for(var key in Object(object))if ($c9af7c238e10dcf7$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$c9af7c238e10dcf7$exports = $c9af7c238e10dcf7$var$baseKeys;


var $99dfaef4aa54c66a$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $99dfaef4aa54c66a$var$isArrayLike(value) {
    return value != null && $2c33f94764a3f267$exports(value.length) && !$6429a69be43b682f$exports(value);
}
$99dfaef4aa54c66a$exports = $99dfaef4aa54c66a$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $06a04a70bff2418a$var$keys(object) {
    return $99dfaef4aa54c66a$exports(object) ? $085017973388a086$exports(object) : $c9af7c238e10dcf7$exports(object);
}
$06a04a70bff2418a$exports = $06a04a70bff2418a$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $da0f56d4a63de30c$var$baseForOwn(object, iteratee) {
    return object && $5ff68075474e5062$exports(object, iteratee, $06a04a70bff2418a$exports);
}
$da0f56d4a63de30c$exports = $da0f56d4a63de30c$var$baseForOwn;


var $91fd9377500626b3$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $91fd9377500626b3$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$99dfaef4aa54c66a$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$91fd9377500626b3$exports = $91fd9377500626b3$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $9e8248f5533c399d$var$baseEach = $91fd9377500626b3$exports($da0f56d4a63de30c$exports);
$9e8248f5533c399d$exports = $9e8248f5533c399d$var$baseEach;


/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8cdac18e8c311a2f$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $9e8248f5533c399d$exports(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
$8cdac18e8c311a2f$exports = $8cdac18e8c311a2f$var$baseAggregator;


var $bc9fff09c27fbf1b$exports = {};
var $8cb859fa5ae5ffb0$exports = {};
var $359a00d73e9ceaf5$exports = {};
var $ec90c43cd2c305de$exports = {};

var $c61dceaf75fa48a2$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $c61dceaf75fa48a2$var$stackClear() {
    this.__data__ = new $1a6c88d37ef028db$exports;
    this.size = 0;
}
$c61dceaf75fa48a2$exports = $c61dceaf75fa48a2$var$stackClear;


var $816bef0054901bc2$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $816bef0054901bc2$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$816bef0054901bc2$exports = $816bef0054901bc2$var$stackDelete;


var $d97715bc51d3e2d1$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d97715bc51d3e2d1$var$stackGet(key) {
    return this.__data__.get(key);
}
$d97715bc51d3e2d1$exports = $d97715bc51d3e2d1$var$stackGet;


var $1e65b67dd08babc8$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1e65b67dd08babc8$var$stackHas(key) {
    return this.__data__.has(key);
}
$1e65b67dd08babc8$exports = $1e65b67dd08babc8$var$stackHas;


var $50e93056cc2fec5c$exports = {};



/** Used as the size to enable large array optimizations. */ var $50e93056cc2fec5c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $50e93056cc2fec5c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $1a6c88d37ef028db$exports) {
        var pairs = data.__data__;
        if (!$a003860332099d58$exports || pairs.length < $50e93056cc2fec5c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $ee1caf719581867c$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$50e93056cc2fec5c$exports = $50e93056cc2fec5c$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ec90c43cd2c305de$var$Stack(entries) {
    var data = this.__data__ = new $1a6c88d37ef028db$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$ec90c43cd2c305de$var$Stack.prototype.clear = $c61dceaf75fa48a2$exports;
$ec90c43cd2c305de$var$Stack.prototype['delete'] = $816bef0054901bc2$exports;
$ec90c43cd2c305de$var$Stack.prototype.get = $d97715bc51d3e2d1$exports;
$ec90c43cd2c305de$var$Stack.prototype.has = $1e65b67dd08babc8$exports;
$ec90c43cd2c305de$var$Stack.prototype.set = $50e93056cc2fec5c$exports;
$ec90c43cd2c305de$exports = $ec90c43cd2c305de$var$Stack;


var $1335e78ddbd3448a$exports = {};
var $61f71fe51be227a4$exports = {};

var $b22a76981fa86ff9$exports = {};

var $2809606483fb9fa3$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $2809606483fb9fa3$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$2809606483fb9fa3$exports = $2809606483fb9fa3$var$arraySome;



/** Used to compose bitmasks for value comparisons. */ var $b22a76981fa86ff9$var$COMPARE_PARTIAL_FLAG = 1, $b22a76981fa86ff9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $b22a76981fa86ff9$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b22a76981fa86ff9$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $b22a76981fa86ff9$var$COMPARE_UNORDERED_FLAG ? new $28a88767a5e44757$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$2809606483fb9fa3$exports(other, function(othValue, othIndex) {
                if (!$c70e9634df58d16c$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$b22a76981fa86ff9$exports = $b22a76981fa86ff9$var$equalArrays;


var $dcf8676d662b324a$exports = {};

var $7b88d89db83d53d1$exports = {};

var $18oEd = parcelRequire("18oEd");
/** Built-in value references. */ var $7b88d89db83d53d1$var$Uint8Array = $18oEd.Uint8Array;
$7b88d89db83d53d1$exports = $7b88d89db83d53d1$var$Uint8Array;




var $d9dbc89b4dd56152$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $d9dbc89b4dd56152$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$d9dbc89b4dd56152$exports = $d9dbc89b4dd56152$var$mapToArray;



/** Used to compose bitmasks for value comparisons. */ var $dcf8676d662b324a$var$COMPARE_PARTIAL_FLAG = 1, $dcf8676d662b324a$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $dcf8676d662b324a$var$boolTag = '[object Boolean]', $dcf8676d662b324a$var$dateTag = '[object Date]', $dcf8676d662b324a$var$errorTag = '[object Error]', $dcf8676d662b324a$var$mapTag = '[object Map]', $dcf8676d662b324a$var$numberTag = '[object Number]', $dcf8676d662b324a$var$regexpTag = '[object RegExp]', $dcf8676d662b324a$var$setTag = '[object Set]', $dcf8676d662b324a$var$stringTag = '[object String]', $dcf8676d662b324a$var$symbolTag = '[object Symbol]';
var $dcf8676d662b324a$var$arrayBufferTag = '[object ArrayBuffer]', $dcf8676d662b324a$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $dcf8676d662b324a$var$symbolProto = $c85b8cdc6635697c$exports ? $c85b8cdc6635697c$exports.prototype : undefined, $dcf8676d662b324a$var$symbolValueOf = $dcf8676d662b324a$var$symbolProto ? $dcf8676d662b324a$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $dcf8676d662b324a$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $dcf8676d662b324a$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $dcf8676d662b324a$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $7b88d89db83d53d1$exports(object), new $7b88d89db83d53d1$exports(other))) return false;
            return true;
        case $dcf8676d662b324a$var$boolTag:
        case $dcf8676d662b324a$var$dateTag:
        case $dcf8676d662b324a$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $e69790e273490122$exports(+object, +other);
        case $dcf8676d662b324a$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $dcf8676d662b324a$var$regexpTag:
        case $dcf8676d662b324a$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $dcf8676d662b324a$var$mapTag:
            var convert = $d9dbc89b4dd56152$exports;
        case $dcf8676d662b324a$var$setTag:
            var isPartial = bitmask & $dcf8676d662b324a$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $f7f2e53818a50d3e$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $dcf8676d662b324a$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $b22a76981fa86ff9$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $dcf8676d662b324a$var$symbolTag:
            if ($dcf8676d662b324a$var$symbolValueOf) return $dcf8676d662b324a$var$symbolValueOf.call(object) == $dcf8676d662b324a$var$symbolValueOf.call(other);
    }
    return false;
}
$dcf8676d662b324a$exports = $dcf8676d662b324a$var$equalByTag;


var $d91bd148fa12acf9$exports = {};
var $01c9bab8fda2563a$exports = {};
var $9af4df8030c14ed7$exports = {};
var $32dbfccbf4ac6a36$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $32dbfccbf4ac6a36$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$32dbfccbf4ac6a36$exports = $32dbfccbf4ac6a36$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9af4df8030c14ed7$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $c9f5bcc2161d3be9$exports(object) ? result : $32dbfccbf4ac6a36$exports(result, symbolsFunc(object));
}
$9af4df8030c14ed7$exports = $9af4df8030c14ed7$var$baseGetAllKeys;


var $9198e882f6868e87$exports = {};
var $b92515a48941b368$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $b92515a48941b368$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$b92515a48941b368$exports = $b92515a48941b368$var$arrayFilter;


var $0d7a067bc36b1917$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $0d7a067bc36b1917$var$stubArray() {
    return [];
}
$0d7a067bc36b1917$exports = $0d7a067bc36b1917$var$stubArray;


/** Used for built-in method references. */ var $9198e882f6868e87$var$objectProto = Object.prototype;
/** Built-in value references. */ var $9198e882f6868e87$var$propertyIsEnumerable = $9198e882f6868e87$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9198e882f6868e87$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $9198e882f6868e87$var$getSymbols = !$9198e882f6868e87$var$nativeGetSymbols ? $0d7a067bc36b1917$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $b92515a48941b368$exports($9198e882f6868e87$var$nativeGetSymbols(object), function(symbol) {
        return $9198e882f6868e87$var$propertyIsEnumerable.call(object, symbol);
    });
};
$9198e882f6868e87$exports = $9198e882f6868e87$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $01c9bab8fda2563a$var$getAllKeys(object) {
    return $9af4df8030c14ed7$exports(object, $06a04a70bff2418a$exports, $9198e882f6868e87$exports);
}
$01c9bab8fda2563a$exports = $01c9bab8fda2563a$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $d91bd148fa12acf9$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $d91bd148fa12acf9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d91bd148fa12acf9$var$hasOwnProperty = $d91bd148fa12acf9$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d91bd148fa12acf9$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d91bd148fa12acf9$var$COMPARE_PARTIAL_FLAG, objProps = $01c9bab8fda2563a$exports(object), objLength = objProps.length, othProps = $01c9bab8fda2563a$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $d91bd148fa12acf9$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$d91bd148fa12acf9$exports = $d91bd148fa12acf9$var$equalObjects;


var $4580452c1c90ae62$exports = {};
var $081452921d02c028$exports = {};


var $18oEd = parcelRequire("18oEd");
/* Built-in method references that are verified to be native. */ var $081452921d02c028$var$DataView = $2557930d4046fd55$exports($18oEd, 'DataView');
$081452921d02c028$exports = $081452921d02c028$var$DataView;



var $ce76d1f999be9360$exports = {};


var $18oEd = parcelRequire("18oEd");
/* Built-in method references that are verified to be native. */ var $ce76d1f999be9360$var$Promise = $2557930d4046fd55$exports($18oEd, 'Promise');
$ce76d1f999be9360$exports = $ce76d1f999be9360$var$Promise;



var $c62426c97c91b05a$exports = {};


var $18oEd = parcelRequire("18oEd");
/* Built-in method references that are verified to be native. */ var $c62426c97c91b05a$var$WeakMap = $2557930d4046fd55$exports($18oEd, 'WeakMap');
$c62426c97c91b05a$exports = $c62426c97c91b05a$var$WeakMap;




/** `Object#toString` result references. */ var $4580452c1c90ae62$var$mapTag = '[object Map]', $4580452c1c90ae62$var$objectTag = '[object Object]', $4580452c1c90ae62$var$promiseTag = '[object Promise]', $4580452c1c90ae62$var$setTag = '[object Set]', $4580452c1c90ae62$var$weakMapTag = '[object WeakMap]';
var $4580452c1c90ae62$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $4580452c1c90ae62$var$dataViewCtorString = $d2076c87afa1d039$exports($081452921d02c028$exports), $4580452c1c90ae62$var$mapCtorString = $d2076c87afa1d039$exports($a003860332099d58$exports), $4580452c1c90ae62$var$promiseCtorString = $d2076c87afa1d039$exports($ce76d1f999be9360$exports), $4580452c1c90ae62$var$setCtorString = $d2076c87afa1d039$exports($60f38456f3e305c8$exports), $4580452c1c90ae62$var$weakMapCtorString = $d2076c87afa1d039$exports($c62426c97c91b05a$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $4580452c1c90ae62$var$getTag = $1b700ed35fbf4a25$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($081452921d02c028$exports && $4580452c1c90ae62$var$getTag(new $081452921d02c028$exports(new ArrayBuffer(1))) != $4580452c1c90ae62$var$dataViewTag || $a003860332099d58$exports && $4580452c1c90ae62$var$getTag(new $a003860332099d58$exports) != $4580452c1c90ae62$var$mapTag || $ce76d1f999be9360$exports && $4580452c1c90ae62$var$getTag($ce76d1f999be9360$exports.resolve()) != $4580452c1c90ae62$var$promiseTag || $60f38456f3e305c8$exports && $4580452c1c90ae62$var$getTag(new $60f38456f3e305c8$exports) != $4580452c1c90ae62$var$setTag || $c62426c97c91b05a$exports && $4580452c1c90ae62$var$getTag(new $c62426c97c91b05a$exports) != $4580452c1c90ae62$var$weakMapTag) $4580452c1c90ae62$var$getTag = function(value) {
    var result = $1b700ed35fbf4a25$exports(value), Ctor = result == $4580452c1c90ae62$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $d2076c87afa1d039$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $4580452c1c90ae62$var$dataViewCtorString:
            return $4580452c1c90ae62$var$dataViewTag;
        case $4580452c1c90ae62$var$mapCtorString:
            return $4580452c1c90ae62$var$mapTag;
        case $4580452c1c90ae62$var$promiseCtorString:
            return $4580452c1c90ae62$var$promiseTag;
        case $4580452c1c90ae62$var$setCtorString:
            return $4580452c1c90ae62$var$setTag;
        case $4580452c1c90ae62$var$weakMapCtorString:
            return $4580452c1c90ae62$var$weakMapTag;
    }
    return result;
};
$4580452c1c90ae62$exports = $4580452c1c90ae62$var$getTag;




var $3hsAy = parcelRequire("3hsAy");

/** Used to compose bitmasks for value comparisons. */ var $61f71fe51be227a4$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $61f71fe51be227a4$var$argsTag = '[object Arguments]', $61f71fe51be227a4$var$arrayTag = '[object Array]', $61f71fe51be227a4$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $61f71fe51be227a4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $61f71fe51be227a4$var$hasOwnProperty = $61f71fe51be227a4$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $61f71fe51be227a4$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $c9f5bcc2161d3be9$exports(object), othIsArr = $c9f5bcc2161d3be9$exports(other), objTag = objIsArr ? $61f71fe51be227a4$var$arrayTag : $4580452c1c90ae62$exports(object), othTag = othIsArr ? $61f71fe51be227a4$var$arrayTag : $4580452c1c90ae62$exports(other);
    objTag = objTag == $61f71fe51be227a4$var$argsTag ? $61f71fe51be227a4$var$objectTag : objTag;
    othTag = othTag == $61f71fe51be227a4$var$argsTag ? $61f71fe51be227a4$var$objectTag : othTag;
    var objIsObj = objTag == $61f71fe51be227a4$var$objectTag, othIsObj = othTag == $61f71fe51be227a4$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $3hsAy(object)) {
        if (!$3hsAy(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $ec90c43cd2c305de$exports);
        return objIsArr || $c8a0ef8053582682$exports(object) ? $b22a76981fa86ff9$exports(object, other, bitmask, customizer, equalFunc, stack) : $dcf8676d662b324a$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $61f71fe51be227a4$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $61f71fe51be227a4$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $61f71fe51be227a4$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $ec90c43cd2c305de$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $ec90c43cd2c305de$exports);
    return $d91bd148fa12acf9$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$61f71fe51be227a4$exports = $61f71fe51be227a4$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $1335e78ddbd3448a$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5847935c01696b8f$exports(value) && !$5847935c01696b8f$exports(other)) return value !== value && other !== other;
    return $61f71fe51be227a4$exports(value, other, bitmask, customizer, $1335e78ddbd3448a$var$baseIsEqual, stack);
}
$1335e78ddbd3448a$exports = $1335e78ddbd3448a$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $359a00d73e9ceaf5$var$COMPARE_PARTIAL_FLAG = 1, $359a00d73e9ceaf5$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $359a00d73e9ceaf5$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $ec90c43cd2c305de$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $1335e78ddbd3448a$exports(srcValue, objValue, $359a00d73e9ceaf5$var$COMPARE_PARTIAL_FLAG | $359a00d73e9ceaf5$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$359a00d73e9ceaf5$exports = $359a00d73e9ceaf5$var$baseIsMatch;


var $b9eec6852ec2d85f$exports = {};
var $f7d129b454fd8c27$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $f7d129b454fd8c27$var$isStrictComparable(value) {
    return value === value && !$b638b78429ec3695$exports(value);
}
$f7d129b454fd8c27$exports = $f7d129b454fd8c27$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $b9eec6852ec2d85f$var$getMatchData(object) {
    var result = $06a04a70bff2418a$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $f7d129b454fd8c27$exports(value)
        ];
    }
    return result;
}
$b9eec6852ec2d85f$exports = $b9eec6852ec2d85f$var$getMatchData;


var $093e0125db5c49dc$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $093e0125db5c49dc$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$093e0125db5c49dc$exports = $093e0125db5c49dc$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $8cb859fa5ae5ffb0$var$baseMatches(source) {
    var matchData = $b9eec6852ec2d85f$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $093e0125db5c49dc$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $359a00d73e9ceaf5$exports(object, source, matchData);
    };
}
$8cb859fa5ae5ffb0$exports = $8cb859fa5ae5ffb0$var$baseMatches;


var $a1dfa489251c0dd9$exports = {};

var $52b64e25f364ee68$exports = {};
var $1d4de24e9e446d20$exports = {};
var $e21e6dfe0f2be87f$exports = {};

var $fbe7ec708d73e153$exports = {};

var $7f7a0faba76ae5db$exports = {};


/** `Object#toString` result references. */ var $7f7a0faba76ae5db$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7f7a0faba76ae5db$var$isSymbol(value) {
    return typeof value == 'symbol' || $5847935c01696b8f$exports(value) && $1b700ed35fbf4a25$exports(value) == $7f7a0faba76ae5db$var$symbolTag;
}
$7f7a0faba76ae5db$exports = $7f7a0faba76ae5db$var$isSymbol;


/** Used to match property names within property paths. */ var $fbe7ec708d73e153$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $fbe7ec708d73e153$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $fbe7ec708d73e153$var$isKey(value, object) {
    if ($c9f5bcc2161d3be9$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $7f7a0faba76ae5db$exports(value)) return true;
    return $fbe7ec708d73e153$var$reIsPlainProp.test(value) || !$fbe7ec708d73e153$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$fbe7ec708d73e153$exports = $fbe7ec708d73e153$var$isKey;


var $7642298b895b0bb4$exports = {};
var $f0eff021553c0dec$exports = {};
var $13b1fce1f81e5e8b$exports = {};

/** Error message constants. */ var $13b1fce1f81e5e8b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $13b1fce1f81e5e8b$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($13b1fce1f81e5e8b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($13b1fce1f81e5e8b$var$memoize.Cache || $ee1caf719581867c$exports);
    return memoized;
}
// Expose `MapCache`.
$13b1fce1f81e5e8b$var$memoize.Cache = $ee1caf719581867c$exports;
$13b1fce1f81e5e8b$exports = $13b1fce1f81e5e8b$var$memoize;


/** Used as the maximum memoize cache size. */ var $f0eff021553c0dec$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $f0eff021553c0dec$var$memoizeCapped(func) {
    var result = $13b1fce1f81e5e8b$exports(func, function(key) {
        if (cache.size === $f0eff021553c0dec$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$f0eff021553c0dec$exports = $f0eff021553c0dec$var$memoizeCapped;


/** Used to match property names within property paths. */ var $7642298b895b0bb4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $7642298b895b0bb4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7642298b895b0bb4$var$stringToPath = $f0eff021553c0dec$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($7642298b895b0bb4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($7642298b895b0bb4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$7642298b895b0bb4$exports = $7642298b895b0bb4$var$stringToPath;


var $a3274ffb9a703883$exports = {};
var $3804de93733abb0e$exports = {};

var $764b803f831d4d18$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $764b803f831d4d18$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$764b803f831d4d18$exports = $764b803f831d4d18$var$arrayMap;




/** Used as references for various `Number` constants. */ var $3804de93733abb0e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3804de93733abb0e$var$symbolProto = $c85b8cdc6635697c$exports ? $c85b8cdc6635697c$exports.prototype : undefined, $3804de93733abb0e$var$symbolToString = $3804de93733abb0e$var$symbolProto ? $3804de93733abb0e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3804de93733abb0e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($c9f5bcc2161d3be9$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $764b803f831d4d18$exports(value, $3804de93733abb0e$var$baseToString) + '';
    if ($7f7a0faba76ae5db$exports(value)) return $3804de93733abb0e$var$symbolToString ? $3804de93733abb0e$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3804de93733abb0e$var$INFINITY ? '-0' : result;
}
$3804de93733abb0e$exports = $3804de93733abb0e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a3274ffb9a703883$var$toString(value) {
    return value == null ? '' : $3804de93733abb0e$exports(value);
}
$a3274ffb9a703883$exports = $a3274ffb9a703883$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $e21e6dfe0f2be87f$var$castPath(value, object) {
    if ($c9f5bcc2161d3be9$exports(value)) return value;
    return $fbe7ec708d73e153$exports(value, object) ? [
        value
    ] : $7642298b895b0bb4$exports($a3274ffb9a703883$exports(value));
}
$e21e6dfe0f2be87f$exports = $e21e6dfe0f2be87f$var$castPath;


var $9b3ad767854ea0b6$exports = {};

/** Used as references for various `Number` constants. */ var $9b3ad767854ea0b6$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $9b3ad767854ea0b6$var$toKey(value) {
    if (typeof value == 'string' || $7f7a0faba76ae5db$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$9b3ad767854ea0b6$var$INFINITY ? '-0' : result;
}
$9b3ad767854ea0b6$exports = $9b3ad767854ea0b6$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $1d4de24e9e446d20$var$baseGet(object, path) {
    path = $e21e6dfe0f2be87f$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$9b3ad767854ea0b6$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$1d4de24e9e446d20$exports = $1d4de24e9e446d20$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $52b64e25f364ee68$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $1d4de24e9e446d20$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$52b64e25f364ee68$exports = $52b64e25f364ee68$var$get;


var $16c0cede4694b0f4$exports = {};
var $39ea333931a246f2$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $39ea333931a246f2$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$39ea333931a246f2$exports = $39ea333931a246f2$var$baseHasIn;


var $3f9936464cd580dc$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $3f9936464cd580dc$var$hasPath(object, path, hasFunc) {
    path = $e21e6dfe0f2be87f$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $9b3ad767854ea0b6$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $2c33f94764a3f267$exports(length) && $e09f7c085d509244$exports(key, length) && ($c9f5bcc2161d3be9$exports(object) || $76d785abafd312a1$exports(object));
}
$3f9936464cd580dc$exports = $3f9936464cd580dc$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $16c0cede4694b0f4$var$hasIn(object, path) {
    return object != null && $3f9936464cd580dc$exports(object, path, $39ea333931a246f2$exports);
}
$16c0cede4694b0f4$exports = $16c0cede4694b0f4$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $a1dfa489251c0dd9$var$COMPARE_PARTIAL_FLAG = 1, $a1dfa489251c0dd9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $a1dfa489251c0dd9$var$baseMatchesProperty(path, srcValue) {
    if ($fbe7ec708d73e153$exports(path) && $f7d129b454fd8c27$exports(srcValue)) return $093e0125db5c49dc$exports($9b3ad767854ea0b6$exports(path), srcValue);
    return function(object) {
        var objValue = $52b64e25f364ee68$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $16c0cede4694b0f4$exports(object, path) : $1335e78ddbd3448a$exports(srcValue, objValue, $a1dfa489251c0dd9$var$COMPARE_PARTIAL_FLAG | $a1dfa489251c0dd9$var$COMPARE_UNORDERED_FLAG);
    };
}
$a1dfa489251c0dd9$exports = $a1dfa489251c0dd9$var$baseMatchesProperty;


var $f5fea155e1b2237f$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $f5fea155e1b2237f$var$identity(value) {
    return value;
}
$f5fea155e1b2237f$exports = $f5fea155e1b2237f$var$identity;



var $53eeaeb383d50c43$exports = {};
var $195c874fad078e3a$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $195c874fad078e3a$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$195c874fad078e3a$exports = $195c874fad078e3a$var$baseProperty;


var $6a38952166ae4362$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $6a38952166ae4362$var$basePropertyDeep(path) {
    return function(object) {
        return $1d4de24e9e446d20$exports(object, path);
    };
}
$6a38952166ae4362$exports = $6a38952166ae4362$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $53eeaeb383d50c43$var$property(path) {
    return $fbe7ec708d73e153$exports(path) ? $195c874fad078e3a$exports($9b3ad767854ea0b6$exports(path)) : $6a38952166ae4362$exports(path);
}
$53eeaeb383d50c43$exports = $53eeaeb383d50c43$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $bc9fff09c27fbf1b$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $f5fea155e1b2237f$exports;
    if (typeof value == 'object') return $c9f5bcc2161d3be9$exports(value) ? $a1dfa489251c0dd9$exports(value[0], value[1]) : $8cb859fa5ae5ffb0$exports(value);
    return $53eeaeb383d50c43$exports(value);
}
$bc9fff09c27fbf1b$exports = $bc9fff09c27fbf1b$var$baseIteratee;



/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $c82336d735c1248a$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $c9f5bcc2161d3be9$exports(collection) ? $0e2c443e827cb5cd$exports : $8cdac18e8c311a2f$exports, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $bc9fff09c27fbf1b$exports(iteratee, 2), accumulator);
    };
}
$c82336d735c1248a$exports = $c82336d735c1248a$var$createAggregator;


/** Used for built-in method references. */ var $9434db2d28cdae1f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9434db2d28cdae1f$var$hasOwnProperty = $9434db2d28cdae1f$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $9434db2d28cdae1f$var$groupBy = $c82336d735c1248a$exports(function(result, value, key) {
    if ($9434db2d28cdae1f$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1e4908e5fd78bfb9$exports(result, key, [
        value
    ]);
});
$9434db2d28cdae1f$exports = $9434db2d28cdae1f$var$groupBy;


/** Alternation belongs to the page's text order, never React's render order. */ function $a5d78ca886c67c28$export$b34a898f52165358(rheses) {
    let lastId;
    let count = 0;
    const parity = new Map();
    for (const rhese of rheses)for (const letter of rhese.letters){
        if (!letter.syllableId) continue;
        if (letter.syllableId !== lastId) {
            count++;
            lastId = letter.syllableId;
        }
        parity.set(letter.absoluteTextPosition, count % 2 === 0);
    }
    return parity;
}


function $33cabd4ced3b2678$export$b4a5b1e32ebf0937(previous, next) {
    if (previous === next) return true;
    if (previous.length !== next.length) return false;
    return previous.every((a, index)=>{
        const b = next[index];
        const aKinds = a.kind, bKinds = b.kind;
        return a === b || a.char === b.char && a.position === b.position && a.id === b.id && a.isMute === b.isMute && a.phoneme === b.phoneme && a.customColoration === b.customColoration && a.cssClasses === b.cssClasses && a.syllableId != null === (b.syllableId != null) && (aKinds === bKinds || !!aKinds && !!bKinds && aKinds.length === bKinds.length && aKinds.every((kind, i)=>kind === bKinds[i]));
    });
}




function $93ac5f630bcb3f8f$export$b0914984cd524b3f(rhese, definition) {
    const first = rhese.letters[0];
    const last = rhese.letters[rhese.letters.length - 1];
    const anchor = definition.anchors[0];
    // Converted letters are contiguous UTF-16 positions, including partial pages.
    return !!first && !!anchor && anchor.utf16Size > 0 && first.absoluteTextPosition < anchor.utf16Start + anchor.utf16Size && last.absoluteTextPosition >= anchor.utf16Start;
}
function $93ac5f630bcb3f8f$export$f6ed7268d35f438() {
    let previous = new Map();
    return (rheses, definitions, definitionMode)=>{
        const parity = (0, $a5d78ca886c67c28$export$b34a898f52165358)(rheses);
        const next = new Map();
        for (const rhese of rheses)next.set(rhese.id, (0, $21ee05de57855177$export$fff6e3d78cde73a4)(previous.get(rhese.id), {
            letterParity: rhese.letters.map((letter)=>parity.get(letter.absoluteTextPosition)),
            definitions: definitionMode ? definitions.filter((definition)=>$93ac5f630bcb3f8f$export$b0914984cd524b3f(rhese, definition)) : []
        }));
        previous = next;
        return next;
    };
}



var $giSak = parcelRequire("giSak");





var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $e8a59ef395ec5278$var$ArrowUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"
                }
            }
        ]
    },
    "name": "arrow-up",
    "theme": "outlined"
};
var $e8a59ef395ec5278$export$2e2bcd8739ae039 = $e8a59ef395ec5278$var$ArrowUpOutlined;



var $b81bb3718bd35328$var$ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $e8a59ef395ec5278$export$2e2bcd8739ae039)
    }));
};
/**![arrow-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2OCA1NDUuNUw1MzYuMSAxNjNhMzEuOTYgMzEuOTYgMCAwMC00OC4zIDBMMTU2IDU0NS41YTcuOTcgNy45NyAwIDAwNiAxMy4yaDgxYzQuNiAwIDktMiAxMi4xLTUuNUw0NzQgMzAwLjlWODY0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWMzAwLjlsMjE4LjkgMjUyLjNjMyAzLjUgNy40IDUuNSAxMi4xIDUuNWg4MWM2LjggMCAxMC41LTggNi0xMy4yeiIgLz48L3N2Zz4=) */ var $b81bb3718bd35328$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($b81bb3718bd35328$var$ArrowUpOutlined);
$b81bb3718bd35328$var$RefIcon.displayName = 'ArrowUpOutlined';
var $b81bb3718bd35328$export$2e2bcd8739ae039 = $b81bb3718bd35328$var$RefIcon;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");
// export this package's api

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");


var $jLTp6 = parcelRequire("jLTp6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
var $8d70f21511217ec4$var$DrawerContext = /*#__PURE__*/ $jMaZ8.createContext(null);
var $8d70f21511217ec4$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $jMaZ8.createContext({});
var $8d70f21511217ec4$export$2e2bcd8739ae039 = $8d70f21511217ec4$var$DrawerContext;



var $eq8kl = parcelRequire("eq8kl");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $lsVqZ = parcelRequire("lsVqZ");



var $jMaZ8 = parcelRequire("jMaZ8");


var $hH60s = parcelRequire("hH60s");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");



var $1cfGC = parcelRequire("1cfGC");
var $9f33024bcf424bb8$var$_excluded = [
    "prefixCls",
    "className",
    "containerRef"
];
var $9f33024bcf424bb8$var$DrawerPanel = function DrawerPanel(props) {
    var prefixCls = props.prefixCls, className = props.className, containerRef = props.containerRef, restProps = (0, $4b02Q.default)(props, $9f33024bcf424bb8$var$_excluded);
    var _React$useContext = $jMaZ8.useContext((0, $8d70f21511217ec4$export$ee4e38b469b6f5d1)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $1cfGC.useComposeRef)(panelRef, containerRef);
    // =============================== Render ===============================
    return /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content"), className),
        role: "dialog",
        ref: mergedRef
    }, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
        aria: true
    }), {
        "aria-modal": "true"
    }, restProps));
};
$9f33024bcf424bb8$var$DrawerPanel.displayName = 'DrawerPanel';
var $9f33024bcf424bb8$export$2e2bcd8739ae039 = $9f33024bcf424bb8$var$DrawerPanel;



var $2bFmQ = parcelRequire("2bFmQ");

var $h9ujZ = parcelRequire("h9ujZ");
function $5b917947479fef4b$export$efeadb1af96d0a6d(value) {
    if (typeof value === 'string' && String(Number(value)) === value) {
        (0, $2bFmQ.default)(false, 'Invalid value type of `width` or `height` which should be number type instead.');
        return Number(value);
    }
    return value;
}
function $5b917947479fef4b$export$e77176dc71180add(props) {
    (0, $2bFmQ.default)(!('wrapperClassName' in props), "'wrapperClassName' is removed. Please use 'rootClassName' instead.");
    (0, $2bFmQ.default)((0, $h9ujZ.default)() || !props.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}


var $49088bfa706b2e74$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none',
    position: 'absolute'
};
function $49088bfa706b2e74$var$DrawerPopup(props, ref) {
    var _ref, _pushConfig$distance, _pushConfig;
    var prefixCls = props.prefixCls, open = props.open, placement = props.placement, inline = props.inline, push = props.push, forceRender = props.forceRender, autoFocus = props.autoFocus, keyboard = props.keyboard, drawerClassNames = props.classNames, rootClassName = props.rootClassName, rootStyle = props.rootStyle, zIndex = props.zIndex, className = props.className, id = props.id, style = props.style, motion = props.motion, width = props.width, height = props.height, children = props.children, mask = props.mask, maskClosable = props.maskClosable, maskMotion = props.maskMotion, maskClassName = props.maskClassName, maskStyle = props.maskStyle, afterOpenChange = props.afterOpenChange, onClose = props.onClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, styles = props.styles, drawerRender = props.drawerRender;
    // ================================ Refs ================================
    var panelRef = $jMaZ8.useRef();
    var sentinelStartRef = $jMaZ8.useRef();
    var sentinelEndRef = $jMaZ8.useRef();
    $jMaZ8.useImperativeHandle(ref, function() {
        return panelRef.current;
    });
    var onPanelKeyDown = function onPanelKeyDown(event) {
        var keyCode = event.keyCode, shiftKey = event.shiftKey;
        switch(keyCode){
            // Tab active
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).TAB:
                if (keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).TAB) {
                    if (!shiftKey && document.activeElement === sentinelEndRef.current) {
                        var _sentinelStartRef$cur;
                        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                            preventScroll: true
                        });
                    } else if (shiftKey && document.activeElement === sentinelStartRef.current) {
                        var _sentinelEndRef$curre;
                        (_sentinelEndRef$curre = sentinelEndRef.current) === null || _sentinelEndRef$curre === void 0 || _sentinelEndRef$curre.focus({
                            preventScroll: true
                        });
                    }
                }
                break;
            // Close
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC:
                if (onClose && keyboard) {
                    event.stopPropagation();
                    onClose(event);
                }
                break;
        }
    };
    // ========================== Control ===========================
    // Auto Focus
    $jMaZ8.useEffect(function() {
        if (open && autoFocus) {
            var _panelRef$current;
            (_panelRef$current = panelRef.current) === null || _panelRef$current === void 0 || _panelRef$current.focus({
                preventScroll: true
            });
        }
    }, [
        open
    ]);
    // ============================ Push ============================
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), pushed = _React$useState2[0], setPushed = _React$useState2[1];
    var parentContext = $jMaZ8.useContext((0, $8d70f21511217ec4$export$2e2bcd8739ae039));
    // Merge push distance
    var pushConfig;
    if (typeof push === 'boolean') pushConfig = push ? {} : {
        distance: 0
    };
    else pushConfig = push || {};
    var pushDistance = (_ref = (_pushConfig$distance = (_pushConfig = pushConfig) === null || _pushConfig === void 0 ? void 0 : _pushConfig.distance) !== null && _pushConfig$distance !== void 0 ? _pushConfig$distance : parentContext === null || parentContext === void 0 ? void 0 : parentContext.pushDistance) !== null && _ref !== void 0 ? _ref : 180;
    var mergedContext = $jMaZ8.useMemo(function() {
        return {
            pushDistance: pushDistance,
            push: function push() {
                setPushed(true);
            },
            pull: function pull() {
                setPushed(false);
            }
        };
    }, [
        pushDistance
    ]);
    // ========================= ScrollLock =========================
    // Tell parent to push
    $jMaZ8.useEffect(function() {
        if (open) {
            var _parentContext$push;
            parentContext === null || parentContext === void 0 || (_parentContext$push = parentContext.push) === null || _parentContext$push === void 0 || _parentContext$push.call(parentContext);
        } else {
            var _parentContext$pull;
            parentContext === null || parentContext === void 0 || (_parentContext$pull = parentContext.pull) === null || _parentContext$pull === void 0 || _parentContext$pull.call(parentContext);
        }
    }, [
        open
    ]);
    // Clean up
    $jMaZ8.useEffect(function() {
        return function() {
            var _parentContext$pull2;
            parentContext === null || parentContext === void 0 || (_parentContext$pull2 = parentContext.pull) === null || _parentContext$pull2 === void 0 || _parentContext$pull2.call(parentContext);
        };
    }, []);
    // ============================ Mask ============================
    var maskNode = mask && /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), (0, $hH60s.default)({
        key: "mask"
    }, maskMotion, {
        visible: open
    }), function(_ref2, maskRef) {
        var motionMaskClassName = _ref2.className, motionMaskStyle = _ref2.style;
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-mask"), motionMaskClassName, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.mask, maskClassName),
            style: (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, motionMaskStyle), maskStyle), styles === null || styles === void 0 ? void 0 : styles.mask),
            onClick: maskClosable && open ? onClose : undefined,
            ref: maskRef
        });
    });
    // =========================== Panel ============================
    var motionProps = typeof motion === 'function' ? motion(placement) : motion;
    var wrapperStyle = {};
    if (pushed && pushDistance) switch(placement){
        case 'top':
            wrapperStyle.transform = "translateY(".concat(pushDistance, "px)");
            break;
        case 'bottom':
            wrapperStyle.transform = "translateY(".concat(-pushDistance, "px)");
            break;
        case 'left':
            wrapperStyle.transform = "translateX(".concat(pushDistance, "px)");
            break;
        default:
            wrapperStyle.transform = "translateX(".concat(-pushDistance, "px)");
            break;
    }
    if (placement === 'left' || placement === 'right') wrapperStyle.width = (0, $5b917947479fef4b$export$efeadb1af96d0a6d)(width);
    else wrapperStyle.height = (0, $5b917947479fef4b$export$efeadb1af96d0a6d)(height);
    var eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    var panelNode = /*#__PURE__*/ $jMaZ8.createElement((0, $lsVqZ.default), (0, $hH60s.default)({
        key: "panel"
    }, motionProps, {
        visible: open,
        forceRender: forceRender,
        onVisibleChanged: function onVisibleChanged(nextVisible) {
            afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
        },
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-content-wrapper-hidden")
    }), function(_ref3, motionRef) {
        var motionClassName = _ref3.className, motionStyle = _ref3.style;
        var content = /*#__PURE__*/ $jMaZ8.createElement((0, $9f33024bcf424bb8$export$2e2bcd8739ae039), (0, $hH60s.default)({
            id: id,
            containerRef: motionRef,
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.content),
            style: (0, $8u3qN.default)((0, $8u3qN.default)({}, style), styles === null || styles === void 0 ? void 0 : styles.content)
        }, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
            aria: true
        }), eventHandlers), children);
        return /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-content-wrapper"), drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.wrapper, motionClassName),
            style: (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, wrapperStyle), motionStyle), styles === null || styles === void 0 ? void 0 : styles.wrapper)
        }, (0, $d4c090a6558ff028$export$2e2bcd8739ae039)(props, {
            data: true
        })), drawerRender ? drawerRender(content) : content);
    });
    // =========================== Render ===========================
    var containerStyle = (0, $8u3qN.default)({}, rootStyle);
    if (zIndex) containerStyle.zIndex = zIndex;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $8d70f21511217ec4$export$2e2bcd8739ae039).Provider, {
        value: mergedContext
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, "".concat(prefixCls, "-").concat(placement), rootClassName, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-open"), open), "".concat(prefixCls, "-inline"), inline)),
        style: containerStyle,
        tabIndex: -1,
        ref: panelRef,
        onKeyDown: onPanelKeyDown
    }, maskNode, /*#__PURE__*/ $jMaZ8.createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $49088bfa706b2e74$var$sentinelStyle,
        "aria-hidden": "true",
        "data-sentinel": "start"
    }), panelNode, /*#__PURE__*/ $jMaZ8.createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $49088bfa706b2e74$var$sentinelStyle,
        "aria-hidden": "true",
        "data-sentinel": "end"
    })));
}
var $49088bfa706b2e74$var$RefDrawerPopup = /*#__PURE__*/ $jMaZ8.forwardRef($49088bfa706b2e74$var$DrawerPopup);
$49088bfa706b2e74$var$RefDrawerPopup.displayName = 'DrawerPopup';
var $49088bfa706b2e74$export$2e2bcd8739ae039 = $49088bfa706b2e74$var$RefDrawerPopup;



var $ecdbfc2214b90dc2$var$Drawer = function Drawer(props) {
    var _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-drawer' : _props$prefixCls, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$width = props.width, width = _props$width === void 0 ? 378 : _props$width, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getContainer = props.getContainer, forceRender = props.forceRender, afterOpenChange = props.afterOpenChange, destroyOnClose = props.destroyOnClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, panelRef = props.panelRef;
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    (0, $5b917947479fef4b$export$e77176dc71180add)(props);
    // ============================= Open =============================
    var _React$useState3 = $jMaZ8.useState(false), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), mounted = _React$useState4[0], setMounted = _React$useState4[1];
    (0, $jLTp6.default)(function() {
        setMounted(true);
    }, []);
    var mergedOpen = mounted ? open : false;
    // ============================ Focus =============================
    var popupRef = $jMaZ8.useRef();
    var lastActiveRef = $jMaZ8.useRef();
    (0, $jLTp6.default)(function() {
        if (mergedOpen) lastActiveRef.current = document.activeElement;
    }, [
        mergedOpen
    ]);
    // ============================= Open =============================
    var internalAfterOpenChange = function internalAfterOpenChange(nextVisible) {
        var _popupRef$current;
        setAnimatedVisible(nextVisible);
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
        if (!nextVisible && lastActiveRef.current && !((_popupRef$current = popupRef.current) !== null && _popupRef$current !== void 0 && _popupRef$current.contains(lastActiveRef.current))) {
            var _lastActiveRef$curren;
            (_lastActiveRef$curren = lastActiveRef.current) === null || _lastActiveRef$curren === void 0 || _lastActiveRef$curren.focus({
                preventScroll: true
            });
        }
    };
    // =========================== Context ============================
    var refContext = $jMaZ8.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    // ============================ Render ============================
    if (!forceRender && !animatedVisible && !mergedOpen && destroyOnClose) return null;
    var eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    var drawerPopupProps = (0, $8u3qN.default)((0, $8u3qN.default)({}, props), {}, {
        open: mergedOpen,
        prefixCls: prefixCls,
        placement: placement,
        autoFocus: autoFocus,
        keyboard: keyboard,
        width: width,
        mask: mask,
        maskClosable: maskClosable,
        inline: getContainer === false,
        afterOpenChange: internalAfterOpenChange,
        ref: popupRef
    }, eventHandlers);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $8d70f21511217ec4$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $11a2eab5458a1b52$export$2e2bcd8739ae039), {
        open: mergedOpen || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: mask && (mergedOpen || animatedVisible)
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $49088bfa706b2e74$export$2e2bcd8739ae039), drawerPopupProps)));
};
$ecdbfc2214b90dc2$var$Drawer.displayName = 'Drawer';
var $ecdbfc2214b90dc2$export$2e2bcd8739ae039 = $ecdbfc2214b90dc2$var$Drawer;


var $bfca6a67b3fd49ce$export$2e2bcd8739ae039 = (0, $ecdbfc2214b90dc2$export$2e2bcd8739ae039);










var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");



"use client";
const $888584a465bea61d$var$DrawerPanel = (props)=>{
    var _a, _b;
    const { prefixCls: prefixCls, title: title, footer: footer, extra: extra, loading: loading, onClose: onClose, headerStyle: headerStyle, bodyStyle: bodyStyle, footerStyle: footerStyle, children: children, classNames: drawerClassNames, styles: drawerStyles } = props;
    const { drawer: drawerContext } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const customCloseIconRender = $jMaZ8.useCallback((icon)=>/*#__PURE__*/ $jMaZ8.createElement("button", {
            type: "button",
            onClick: onClose,
            "aria-label": "Close",
            className: `${prefixCls}-close`
        }, icon), [
        onClose
    ]);
    const [mergedClosable, mergedCloseIcon] = (0, $547f96b25a48e540$export$2e2bcd8739ae039)((0, $547f96b25a48e540$export$51ad9c30389f050b)(props), (0, $547f96b25a48e540$export$51ad9c30389f050b)(drawerContext), {
        closable: true,
        closeIconRender: customCloseIconRender
    });
    const headerNode = $jMaZ8.useMemo(()=>{
        var _a, _b;
        if (!title && !mergedClosable) return null;
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            style: Object.assign(Object.assign(Object.assign({}, (_a = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.styles) === null || _a === void 0 ? void 0 : _a.header), headerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.header),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-header`, {
                [`${prefixCls}-header-close-only`]: mergedClosable && !title && !extra
            }, (_b = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.classNames) === null || _b === void 0 ? void 0 : _b.header, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.header)
        }, /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-header-title`
        }, mergedCloseIcon, title && /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-title`
        }, title)), extra && /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${prefixCls}-extra`
        }, extra));
    }, [
        mergedClosable,
        mergedCloseIcon,
        extra,
        headerStyle,
        prefixCls,
        title
    ]);
    const footerNode = $jMaZ8.useMemo(()=>{
        var _a, _b;
        if (!footer) return null;
        const footerClassName = `${prefixCls}-footer`;
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(footerClassName, (_a = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.classNames) === null || _a === void 0 ? void 0 : _a.footer, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.footer),
            style: Object.assign(Object.assign(Object.assign({}, (_b = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.styles) === null || _b === void 0 ? void 0 : _b.footer), footerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.footer)
        }, footer);
    }, [
        footer,
        footerStyle,
        prefixCls
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, headerNode, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-body`, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.body, (_a = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.classNames) === null || _a === void 0 ? void 0 : _a.body),
        style: Object.assign(Object.assign(Object.assign({}, (_b = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.styles) === null || _b === void 0 ? void 0 : _b.body), bodyStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.body)
    }, loading ? /*#__PURE__*/ $jMaZ8.createElement((0, $069691000a77b0e1$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 5
        },
        className: `${prefixCls}-body-skeleton`
    }) : children), footerNode);
};
var $888584a465bea61d$export$2e2bcd8739ae039 = $888584a465bea61d$var$DrawerPanel;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $bc791131973b26e1$var$getMoveTranslate = (direction)=>{
    const value = '100%';
    return ({
        left: `translateX(-${value})`,
        right: `translateX(${value})`,
        top: `translateY(-${value})`,
        bottom: `translateY(${value})`
    })[direction];
};
const $bc791131973b26e1$var$getEnterLeaveStyle = (startStyle, endStyle)=>({
        '&-enter, &-appear': Object.assign(Object.assign({}, startStyle), {
            '&-active': endStyle
        }),
        '&-leave': Object.assign(Object.assign({}, endStyle), {
            '&-active': startStyle
        })
    });
const $bc791131973b26e1$var$getFadeStyle = (from, duration)=>Object.assign({
        '&-enter, &-appear, &-leave': {
            '&-start': {
                transition: 'none'
            },
            '&-active': {
                transition: `all ${duration}`
            }
        }
    }, $bc791131973b26e1$var$getEnterLeaveStyle({
        opacity: from
    }, {
        opacity: 1
    }));
const $bc791131973b26e1$var$getPanelMotionStyles = (direction, duration)=>[
        $bc791131973b26e1$var$getFadeStyle(0.7, duration),
        $bc791131973b26e1$var$getEnterLeaveStyle({
            transform: $bc791131973b26e1$var$getMoveTranslate(direction)
        }, {
            transform: 'none'
        })
    ];
const $bc791131973b26e1$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return {
        [componentCls]: {
            // ======================== Mask ========================
            [`${componentCls}-mask-motion`]: $bc791131973b26e1$var$getFadeStyle(0, motionDurationSlow),
            // ======================= Panel ========================
            [`${componentCls}-panel-motion`]: [
                'left',
                'right',
                'top',
                'bottom'
            ].reduce((obj, direction)=>Object.assign(Object.assign({}, obj), {
                    [`&-${direction}`]: $bc791131973b26e1$var$getPanelMotionStyles(direction, motionDurationSlow)
                }), {})
        }
    };
};
var $bc791131973b26e1$export$2e2bcd8739ae039 = $bc791131973b26e1$var$genMotionStyle;


// =============================== Base ===============================
const $2273e1b859f32cae$var$genDrawerStyle = (token)=>{
    const { borderRadiusSM: borderRadiusSM, componentCls: componentCls, zIndexPopup: zIndexPopup, colorBgMask: colorBgMask, colorBgElevated: colorBgElevated, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, paddingXS: paddingXS, padding: padding, paddingLG: paddingLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, lineWidth: lineWidth, lineType: lineType, colorSplit: colorSplit, marginXS: marginXS, colorIcon: colorIcon, colorIconHover: colorIconHover, colorBgTextHover: colorBgTextHover, colorBgTextActive: colorBgTextActive, colorText: colorText, fontWeightStrong: fontWeightStrong, footerPaddingBlock: footerPaddingBlock, footerPaddingInline: footerPaddingInline, calc: calc } = token;
    const wrapperCls = `${componentCls}-content-wrapper`;
    return {
        [componentCls]: {
            position: 'fixed',
            inset: 0,
            zIndex: zIndexPopup,
            pointerEvents: 'none',
            color: colorText,
            '&-pure': {
                position: 'relative',
                background: colorBgElevated,
                display: 'flex',
                flexDirection: 'column',
                [`&${componentCls}-left`]: {
                    boxShadow: token.boxShadowDrawerLeft
                },
                [`&${componentCls}-right`]: {
                    boxShadow: token.boxShadowDrawerRight
                },
                [`&${componentCls}-top`]: {
                    boxShadow: token.boxShadowDrawerUp
                },
                [`&${componentCls}-bottom`]: {
                    boxShadow: token.boxShadowDrawerDown
                }
            },
            '&-inline': {
                position: 'absolute'
            },
            // ====================== Mask ======================
            [`${componentCls}-mask`]: {
                position: 'absolute',
                inset: 0,
                zIndex: zIndexPopup,
                background: colorBgMask,
                pointerEvents: 'auto'
            },
            // ==================== Content =====================
            [wrapperCls]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                maxWidth: '100vw',
                transition: `all ${motionDurationSlow}`,
                '&-hidden': {
                    display: 'none'
                }
            },
            // Placement
            [`&-left > ${wrapperCls}`]: {
                top: 0,
                bottom: 0,
                left: {
                    _skip_check_: true,
                    value: 0
                },
                boxShadow: token.boxShadowDrawerLeft
            },
            [`&-right > ${wrapperCls}`]: {
                top: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                bottom: 0,
                boxShadow: token.boxShadowDrawerRight
            },
            [`&-top > ${wrapperCls}`]: {
                top: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerUp
            },
            [`&-bottom > ${wrapperCls}`]: {
                bottom: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerDown
            },
            [`${componentCls}-content`]: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                overflow: 'auto',
                background: colorBgElevated,
                pointerEvents: 'auto'
            },
            // Header
            [`${componentCls}-header`]: {
                display: 'flex',
                flex: 0,
                alignItems: 'center',
                padding: `${(0, $4g3I0.unit)(padding)} ${(0, $4g3I0.unit)(paddingLG)}`,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG,
                borderBottom: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${colorSplit}`,
                '&-title': {
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center',
                    minWidth: 0,
                    minHeight: 0
                }
            },
            [`${componentCls}-extra`]: {
                flex: 'none'
            },
            [`${componentCls}-close`]: Object.assign({
                display: 'inline-flex',
                width: calc(fontSizeLG).add(paddingXS).equal(),
                height: calc(fontSizeLG).add(paddingXS).equal(),
                borderRadius: borderRadiusSM,
                justifyContent: 'center',
                alignItems: 'center',
                marginInlineEnd: marginXS,
                color: colorIcon,
                fontWeight: fontWeightStrong,
                fontSize: fontSizeLG,
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                textDecoration: 'none',
                background: 'transparent',
                border: 0,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`,
                textRendering: 'auto',
                '&:hover': {
                    color: colorIconHover,
                    backgroundColor: colorBgTextHover,
                    textDecoration: 'none'
                },
                '&:active': {
                    backgroundColor: colorBgTextActive
                }
            }, (0, $134f73cf3485ce91$export$a44db842bcb28231)(token)),
            [`${componentCls}-title`]: {
                flex: 1,
                margin: 0,
                fontWeight: token.fontWeightStrong,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG
            },
            // Body
            [`${componentCls}-body`]: {
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                padding: paddingLG,
                overflow: 'auto',
                [`${componentCls}-body-skeleton`]: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                }
            },
            // Footer
            [`${componentCls}-footer`]: {
                flexShrink: 0,
                padding: `${(0, $4g3I0.unit)(footerPaddingBlock)} ${(0, $4g3I0.unit)(footerPaddingInline)}`,
                borderTop: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${colorSplit}`
            },
            // ====================== RTL =======================
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
const $2273e1b859f32cae$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase,
        footerPaddingBlock: token.paddingXS,
        footerPaddingInline: token.padding
    });
var // ============================== Export ==============================
$2273e1b859f32cae$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Drawer', (token)=>{
    const drawerToken = (0, $8APUt.merge)(token, {});
    return [
        $2273e1b859f32cae$var$genDrawerStyle(drawerToken),
        (0, $bc791131973b26e1$export$2e2bcd8739ae039)(drawerToken)
    ];
}, $2273e1b859f32cae$export$9ca1be8807fe0675);


"use client";
var $d88f1f9a11889bfa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d88f1f9a11889bfa$var$_SizeTypes = [
    'default',
    'large'
];
const $d88f1f9a11889bfa$var$defaultPushState = {
    distance: 180
};
const $d88f1f9a11889bfa$var$Drawer = (props)=>{
    var _a;
    const { rootClassName: rootClassName, width: width, height: height, size: size = 'default', mask: mask = true, push: push = $d88f1f9a11889bfa$var$defaultPushState, open: open, afterOpenChange: afterOpenChange, onClose: onClose, prefixCls: customizePrefixCls, getContainer: customizeGetContainer, style: style, className: className, visible: // Deprecated
    visible, afterVisibleChange: afterVisibleChange, maskStyle: maskStyle, drawerStyle: drawerStyle, contentWrapperStyle: contentWrapperStyle } = props, rest = $d88f1f9a11889bfa$var$__rest(props, [
        "rootClassName",
        "width",
        "height",
        "size",
        "mask",
        "push",
        "open",
        "afterOpenChange",
        "onClose",
        "prefixCls",
        "getContainer",
        "style",
        "className",
        "visible",
        "afterVisibleChange",
        "maskStyle",
        "drawerStyle",
        "contentWrapperStyle"
    ]);
    const { getPopupContainer: getPopupContainer, getPrefixCls: getPrefixCls, direction: direction, drawer: drawer } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('drawer', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2273e1b859f32cae$export$2e2bcd8739ae039)(prefixCls);
    const getContainer = // 有可能为 false，所以不能直接判断
    customizeGetContainer === undefined && getPopupContainer ? ()=>getPopupContainer(document.body) : customizeGetContainer;
    const drawerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        'no-mask': !mask,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, rootClassName, hashId, cssVarCls);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Drawer');
        [
            [
                'visible',
                'open'
            ],
            [
                'afterVisibleChange',
                'afterOpenChange'
            ],
            [
                'headerStyle',
                'styles.header'
            ],
            [
                'bodyStyle',
                'styles.body'
            ],
            [
                'footerStyle',
                'styles.footer'
            ],
            [
                'contentWrapperStyle',
                'styles.wrapper'
            ],
            [
                'maskStyle',
                'styles.mask'
            ],
            [
                'drawerStyle',
                'styles.content'
            ]
        ].forEach((_ref)=>{
            let [deprecatedName, newName] = _ref;
            warning.deprecated(!(deprecatedName in props), deprecatedName, newName);
        });
        if (getContainer !== undefined && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.position) === 'absolute') warning(false, 'breaking', '`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.');
    }
    // ============================ Size ============================
    const mergedWidth = $jMaZ8.useMemo(()=>width !== null && width !== void 0 ? width : size === 'large' ? 736 : 378, [
        width,
        size
    ]);
    const mergedHeight = $jMaZ8.useMemo(()=>height !== null && height !== void 0 ? height : size === 'large' ? 736 : 378, [
        height,
        size
    ]);
    // =========================== Motion ===========================
    const maskMotion = {
        motionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(prefixCls, 'mask-motion'),
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        motionDeadline: 500
    };
    const panelMotion = (motionPlacement)=>({
            motionName: (0, $230791b6f61cb981$export$27c72201b1d09951)(prefixCls, `panel-motion-${motionPlacement}`),
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            motionDeadline: 500
        });
    // ============================ Refs ============================
    // Select `ant-drawer-content` by `panelRef`
    const panelRef = (0, $75e1b8460fa96589$export$94ab53417567be34)();
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $5f1c4f12ab1f6aec$export$3e7906d4075187a4)('Drawer', rest.zIndex);
    // =========================== Render ===========================
    const { classNames: propClassNames = {}, styles: propStyles = {} } = rest;
    const { classNames: contextClassNames = {}, styles: contextStyles = {} } = drawer || {};
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $215be6e5138b7346$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $bfca6a67b3fd49ce$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        onClose: onClose,
        maskMotion: maskMotion,
        motion: panelMotion
    }, rest, {
        classNames: {
            mask: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(propClassNames.mask, contextClassNames.mask),
            content: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(propClassNames.content, contextClassNames.content),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(propClassNames.wrapper, contextClassNames.wrapper)
        },
        styles: {
            mask: Object.assign(Object.assign(Object.assign({}, propStyles.mask), maskStyle), contextStyles.mask),
            content: Object.assign(Object.assign(Object.assign({}, propStyles.content), drawerStyle), contextStyles.content),
            wrapper: Object.assign(Object.assign(Object.assign({}, propStyles.wrapper), contentWrapperStyle), contextStyles.wrapper)
        },
        open: open !== null && open !== void 0 ? open : visible,
        mask: mask,
        push: push,
        width: mergedWidth,
        height: mergedHeight,
        style: Object.assign(Object.assign({}, drawer === null || drawer === void 0 ? void 0 : drawer.style), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(drawer === null || drawer === void 0 ? void 0 : drawer.className, className),
        rootClassName: drawerClassName,
        getContainer: getContainer,
        afterOpenChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        panelRef: panelRef,
        zIndex: zIndex
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $888584a465bea61d$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls
    }, rest, {
        onClose: onClose
    }))))));
};
/** @private Internal Component. Do not use in your production. */ const $d88f1f9a11889bfa$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, placement: placement = 'right' } = props, restProps = $d88f1f9a11889bfa$var$__rest(props, [
        "prefixCls",
        "style",
        "className",
        "placement"
    ]);
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('drawer', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2273e1b859f32cae$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-pure`, `${prefixCls}-${placement}`, hashId, cssVarCls, className);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: cls,
        style: style
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $888584a465bea61d$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls
    }, restProps))));
};
$d88f1f9a11889bfa$var$Drawer._InternalPanelDoNotUseOrYouWillBeFired = $d88f1f9a11889bfa$var$PurePanel;
$d88f1f9a11889bfa$var$Drawer.displayName = 'Drawer';
var $d88f1f9a11889bfa$export$2e2bcd8739ae039 = $d88f1f9a11889bfa$var$Drawer;


var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");










var $jMaZ8 = parcelRequire("jMaZ8");
const $134ef67889c8961e$export$52411773e0d6f15d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext({});
const $134ef67889c8961e$export$a3183b990150745c = $134ef67889c8961e$export$52411773e0d6f15d.Consumer;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");




"use client";
var $91548e5978ac360c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $91548e5978ac360c$export$b08a9033b36413fb = (_a)=>{
    var { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description } = _a, others = $91548e5978ac360c$var$__rest(_a, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    const { getPrefixCls: getPrefixCls } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-item-meta`, className);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: `${prefixCls}-item-meta-content`
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("h4", {
        className: `${prefixCls}-item-meta-title`
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: `${prefixCls}-item-meta-description`
    }, description));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", Object.assign({}, others, {
        className: classString
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
        className: `${prefixCls}-item-meta-avatar`
    }, avatar), (title || description) && content);
};
const $91548e5978ac360c$var$InternalItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, children: children, actions: actions, extra: extra, styles: styles, className: className, classNames: customizeClassNames, colStyle: colStyle } = props, others = $91548e5978ac360c$var$__rest(props, [
        "prefixCls",
        "children",
        "actions",
        "extra",
        "styles",
        "className",
        "classNames",
        "colStyle"
    ]);
    const { grid: grid, itemLayout: itemLayout } = (0, $jMaZ8.useContext)((0, $134ef67889c8961e$export$52411773e0d6f15d));
    const { getPrefixCls: getPrefixCls, list: list } = (0, $jMaZ8.useContext)((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const moduleClass = (moduleName)=>{
        var _a, _b;
        return (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.classNames) === null || _b === void 0 ? void 0 : _b[moduleName], customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames[moduleName]);
    };
    const moduleStyle = (moduleName)=>{
        var _a, _b;
        return Object.assign(Object.assign({}, (_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b[moduleName]), styles === null || styles === void 0 ? void 0 : styles[moduleName]);
    };
    const isItemContainsTextNodeAndNotSingular = ()=>{
        let result = false;
        (0, $jMaZ8.Children).forEach(children, (element)=>{
            if (typeof element === 'string') result = true;
        });
        return result && (0, $jMaZ8.Children).count(children) > 1;
    };
    const isFlexMode = ()=>{
        if (itemLayout === 'vertical') return !!extra;
        return !isItemContainsTextNodeAndNotSingular();
    };
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const actionsContent = actions && actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-item-action`, moduleClass('actions')),
        key: "actions",
        style: moduleStyle('actions')
    }, actions.map((action, i)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("li", {
            key: `${prefixCls}-item-action-${i}`
        }, action, i !== actions.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("em", {
            className: `${prefixCls}-item-action-split`
        }))));
    const Element = grid ? 'div' : 'li';
    const itemChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement(Element, Object.assign({}, others, !grid ? {
        ref: ref
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-item`, {
            [`${prefixCls}-item-no-flex`]: !isFlexMode()
        }, className)
    }), itemLayout === 'vertical' && extra ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
            className: `${prefixCls}-item-main`,
            key: "content"
        }, children, actionsContent),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-item-extra`, moduleClass('extra')),
            key: "extra",
            style: moduleStyle('extra')
        }, extra)
    ] : [
        children,
        actionsContent,
        (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(extra, {
            key: 'extra'
        })
    ]);
    return grid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $f6b871da920d79b3$export$2e2bcd8739ae039), {
        ref: ref,
        flex: 1,
        style: colStyle
    }, itemChildren) : itemChildren;
});
const $91548e5978ac360c$var$Item = $91548e5978ac360c$var$InternalItem;
$91548e5978ac360c$var$Item.Meta = $91548e5978ac360c$export$b08a9033b36413fb;
var $91548e5978ac360c$export$2e2bcd8739ae039 = $91548e5978ac360c$var$Item;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
const $6abf375742f72df2$var$genBorderedStyle = (token)=>{
    const { listBorderedCls: listBorderedCls, componentCls: componentCls, paddingLG: paddingLG, margin: margin, itemPaddingSM: itemPaddingSM, itemPaddingLG: itemPaddingLG, marginLG: marginLG, borderRadiusLG: borderRadiusLG } = token;
    return {
        [listBorderedCls]: {
            border: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: borderRadiusLG,
            [`${componentCls}-header,${componentCls}-footer,${componentCls}-item`]: {
                paddingInline: paddingLG
            },
            [`${componentCls}-pagination`]: {
                margin: `${(0, $4g3I0.unit)(margin)} ${(0, $4g3I0.unit)(marginLG)}`
            }
        },
        [`${listBorderedCls}${componentCls}-sm`]: {
            [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
                padding: itemPaddingSM
            }
        },
        [`${listBorderedCls}${componentCls}-lg`]: {
            [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
                padding: itemPaddingLG
            }
        }
    };
};
const $6abf375742f72df2$var$genResponsiveStyle = (token)=>{
    const { componentCls: componentCls, screenSM: screenSM, screenMD: screenMD, marginLG: marginLG, marginSM: marginSM, margin: margin } = token;
    return {
        [`@media screen and (max-width:${screenMD}px)`]: {
            [componentCls]: {
                [`${componentCls}-item`]: {
                    [`${componentCls}-item-action`]: {
                        marginInlineStart: marginLG
                    }
                }
            },
            [`${componentCls}-vertical`]: {
                [`${componentCls}-item`]: {
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: marginLG
                    }
                }
            }
        },
        [`@media screen and (max-width: ${screenSM}px)`]: {
            [componentCls]: {
                [`${componentCls}-item`]: {
                    flexWrap: 'wrap',
                    [`${componentCls}-action`]: {
                        marginInlineStart: marginSM
                    }
                }
            },
            [`${componentCls}-vertical`]: {
                [`${componentCls}-item`]: {
                    flexWrap: 'wrap-reverse',
                    [`${componentCls}-item-main`]: {
                        minWidth: token.contentWidth
                    },
                    [`${componentCls}-item-extra`]: {
                        margin: `auto auto ${(0, $4g3I0.unit)(margin)}`
                    }
                }
            }
        }
    };
};
// =============================== Base ===============================
const $6abf375742f72df2$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlHeight: controlHeight, minHeight: minHeight, paddingSM: paddingSM, marginLG: marginLG, padding: padding, itemPadding: itemPadding, colorPrimary: colorPrimary, itemPaddingSM: itemPaddingSM, itemPaddingLG: itemPaddingLG, paddingXS: paddingXS, margin: margin, colorText: colorText, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, headerBg: headerBg, footerBg: footerBg, emptyTextPadding: emptyTextPadding, metaMarginBottom: metaMarginBottom, avatarMarginRight: avatarMarginRight, titleMarginBottom: titleMarginBottom, descriptionFontSize: descriptionFontSize } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'relative',
            '*': {
                outline: 'none'
            },
            [`${componentCls}-header`]: {
                background: headerBg
            },
            [`${componentCls}-footer`]: {
                background: footerBg
            },
            [`${componentCls}-header, ${componentCls}-footer`]: {
                paddingBlock: paddingSM
            },
            [`${componentCls}-pagination`]: {
                marginBlockStart: marginLG,
                // https://github.com/ant-design/ant-design/issues/20037
                [`${antCls}-pagination-options`]: {
                    textAlign: 'start'
                }
            },
            [`${componentCls}-spin`]: {
                minHeight: minHeight,
                textAlign: 'center'
            },
            [`${componentCls}-items`]: {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            [`${componentCls}-item`]: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: itemPadding,
                color: colorText,
                [`${componentCls}-item-meta`]: {
                    display: 'flex',
                    flex: 1,
                    alignItems: 'flex-start',
                    maxWidth: '100%',
                    [`${componentCls}-item-meta-avatar`]: {
                        marginInlineEnd: avatarMarginRight
                    },
                    [`${componentCls}-item-meta-content`]: {
                        flex: '1 0',
                        width: 0,
                        color: colorText
                    },
                    [`${componentCls}-item-meta-title`]: {
                        margin: `0 0 ${(0, $4g3I0.unit)(token.marginXXS)} 0`,
                        color: colorText,
                        fontSize: token.fontSize,
                        lineHeight: token.lineHeight,
                        '> a': {
                            color: colorText,
                            transition: `all ${motionDurationSlow}`,
                            '&:hover': {
                                color: colorPrimary
                            }
                        }
                    },
                    [`${componentCls}-item-meta-description`]: {
                        color: colorTextDescription,
                        fontSize: descriptionFontSize,
                        lineHeight: token.lineHeight
                    }
                },
                [`${componentCls}-item-action`]: {
                    flex: '0 0 auto',
                    marginInlineStart: token.marginXXL,
                    padding: 0,
                    fontSize: 0,
                    listStyle: 'none',
                    '& > li': {
                        position: 'relative',
                        display: 'inline-block',
                        padding: `0 ${(0, $4g3I0.unit)(paddingXS)}`,
                        color: colorTextDescription,
                        fontSize: token.fontSize,
                        lineHeight: token.lineHeight,
                        textAlign: 'center',
                        '&:first-child': {
                            paddingInlineStart: 0
                        }
                    },
                    [`${componentCls}-item-action-split`]: {
                        position: 'absolute',
                        insetBlockStart: '50%',
                        insetInlineEnd: 0,
                        width: lineWidth,
                        height: token.calc(token.fontHeight).sub(token.calc(token.marginXXS).mul(2)).equal(),
                        transform: 'translateY(-50%)',
                        backgroundColor: token.colorSplit
                    }
                }
            },
            [`${componentCls}-empty`]: {
                padding: `${(0, $4g3I0.unit)(padding)} 0`,
                color: colorTextDescription,
                fontSize: token.fontSizeSM,
                textAlign: 'center'
            },
            [`${componentCls}-empty-text`]: {
                padding: emptyTextPadding,
                color: token.colorTextDisabled,
                fontSize: token.fontSize,
                textAlign: 'center'
            },
            // ============================ without flex ============================
            [`${componentCls}-item-no-flex`]: {
                display: 'block'
            }
        }),
        [`${componentCls}-grid ${antCls}-col > ${componentCls}-item`]: {
            display: 'block',
            maxWidth: '100%',
            marginBlockEnd: margin,
            paddingBlock: 0,
            borderBlockEnd: 'none'
        },
        [`${componentCls}-vertical ${componentCls}-item`]: {
            alignItems: 'initial',
            [`${componentCls}-item-main`]: {
                display: 'block',
                flex: 1
            },
            [`${componentCls}-item-extra`]: {
                marginInlineStart: marginLG
            },
            [`${componentCls}-item-meta`]: {
                marginBlockEnd: metaMarginBottom,
                [`${componentCls}-item-meta-title`]: {
                    marginBlockStart: 0,
                    marginBlockEnd: titleMarginBottom,
                    color: colorText,
                    fontSize: token.fontSizeLG,
                    lineHeight: token.lineHeightLG
                }
            },
            [`${componentCls}-item-action`]: {
                marginBlockStart: padding,
                marginInlineStart: 'auto',
                '> li': {
                    padding: `0 ${(0, $4g3I0.unit)(padding)}`,
                    '&:first-child': {
                        paddingInlineStart: 0
                    }
                }
            }
        },
        [`${componentCls}-split ${componentCls}-item`]: {
            borderBlockEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
            '&:last-child': {
                borderBlockEnd: 'none'
            }
        },
        [`${componentCls}-split ${componentCls}-header`]: {
            borderBlockEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-split${componentCls}-empty ${componentCls}-footer`]: {
            borderTop: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-loading ${componentCls}-spin-nested-loading`]: {
            minHeight: controlHeight
        },
        [`${componentCls}-split${componentCls}-something-after-last-item ${antCls}-spin-container > ${componentCls}-items > ${componentCls}-item:last-child`]: {
            borderBlockEnd: `${(0, $4g3I0.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-lg ${componentCls}-item`]: {
            padding: itemPaddingLG
        },
        [`${componentCls}-sm ${componentCls}-item`]: {
            padding: itemPaddingSM
        },
        // Horizontal
        [`${componentCls}:not(${componentCls}-vertical)`]: {
            [`${componentCls}-item-no-flex`]: {
                [`${componentCls}-item-action`]: {
                    float: 'right'
                }
            }
        }
    };
};
const $6abf375742f72df2$export$9ca1be8807fe0675 = (token)=>({
        contentWidth: 220,
        itemPadding: `${(0, $4g3I0.unit)(token.paddingContentVertical)} 0`,
        itemPaddingSM: `${(0, $4g3I0.unit)(token.paddingContentVerticalSM)} ${(0, $4g3I0.unit)(token.paddingContentHorizontal)}`,
        itemPaddingLG: `${(0, $4g3I0.unit)(token.paddingContentVerticalLG)} ${(0, $4g3I0.unit)(token.paddingContentHorizontalLG)}`,
        headerBg: 'transparent',
        footerBg: 'transparent',
        emptyTextPadding: token.padding,
        metaMarginBottom: token.padding,
        avatarMarginRight: token.padding,
        titleMarginBottom: token.paddingSM,
        descriptionFontSize: token.fontSize
    });
var // ============================== Export ==============================
$6abf375742f72df2$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('List', (token)=>{
    const listToken = (0, $8APUt.merge)(token, {
        listBorderedCls: `${token.componentCls}-bordered`,
        minHeight: token.controlHeightLG
    });
    return [
        $6abf375742f72df2$var$genBaseStyle(listToken),
        $6abf375742f72df2$var$genBorderedStyle(listToken),
        $6abf375742f72df2$var$genResponsiveStyle(listToken)
    ];
}, $6abf375742f72df2$export$9ca1be8807fe0675);


"use client";
var $8d359122623b990d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $8d359122623b990d$var$InternalList(_a, ref) {
    var { pagination: pagination = false, prefixCls: customizePrefixCls, bordered: bordered = false, split: split = true, className: className, rootClassName: rootClassName, style: style, children: children, itemLayout: itemLayout, loadMore: loadMore, grid: grid, dataSource: dataSource = [], size: customizeSize, header: header, footer: footer, loading: loading = false, rowKey: rowKey, renderItem: renderItem, locale: locale } = _a, rest = $8d359122623b990d$var$__rest(_a, [
        "pagination",
        "prefixCls",
        "bordered",
        "split",
        "className",
        "rootClassName",
        "style",
        "children",
        "itemLayout",
        "loadMore",
        "grid",
        "dataSource",
        "size",
        "header",
        "footer",
        "loading",
        "rowKey",
        "renderItem",
        "locale"
    ]);
    const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
    const [paginationCurrent, setPaginationCurrent] = $jMaZ8.useState(paginationObj.defaultCurrent || 1);
    const [paginationSize, setPaginationSize] = $jMaZ8.useState(paginationObj.defaultPageSize || 10);
    const { getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: direction, list: list } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const defaultPaginationProps = {
        current: 1,
        total: 0
    };
    const triggerPaginationEvent = (eventName)=>(page, pageSize)=>{
            var _a;
            setPaginationCurrent(page);
            setPaginationSize(pageSize);
            if (pagination) (_a = pagination === null || pagination === void 0 ? void 0 : pagination[eventName]) === null || _a === void 0 || _a.call(pagination, page, pageSize);
        };
    const onPaginationChange = triggerPaginationEvent('onChange');
    const onPaginationShowSizeChange = triggerPaginationEvent('onShowSizeChange');
    const renderInnerItem = (item, index)=>{
        if (!renderItem) return null;
        let key;
        if (typeof rowKey === 'function') key = rowKey(item);
        else if (rowKey) key = item[rowKey];
        else key = item.key;
        if (!key) key = `list-item-${index}`;
        return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, {
            key: key
        }, renderItem(item, index));
    };
    const isSomethingAfterLastItem = ()=>!!(loadMore || pagination || footer);
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6abf375742f72df2$export$2e2bcd8739ae039)(prefixCls);
    let loadingProp = loading;
    if (typeof loadingProp === 'boolean') loadingProp = {
        spinning: loadingProp
    };
    const isLoading = !!(loadingProp === null || loadingProp === void 0 ? void 0 : loadingProp.spinning);
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)(customizeSize);
    // large => lg
    // small => sm
    let sizeCls = '';
    switch(mergedSize){
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        default:
            break;
    }
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, {
        [`${prefixCls}-vertical`]: itemLayout === 'vertical',
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-split`]: split,
        [`${prefixCls}-bordered`]: bordered,
        [`${prefixCls}-loading`]: isLoading,
        [`${prefixCls}-grid`]: !!grid,
        [`${prefixCls}-something-after-last-item`]: isSomethingAfterLastItem(),
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, list === null || list === void 0 ? void 0 : list.className, className, rootClassName, hashId, cssVarCls);
    const paginationProps = (0, $d74635dfa3f27b0f$export$2e2bcd8739ae039)(defaultPaginationProps, {
        total: dataSource.length,
        current: paginationCurrent,
        pageSize: paginationSize
    }, pagination || {});
    const largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
    if (paginationProps.current > largestPage) paginationProps.current = largestPage;
    const paginationContent = pagination && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-pagination`)
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $029f538dfd4a9bcd$export$2e2bcd8739ae039), Object.assign({
        align: "end"
    }, paginationProps, {
        onChange: onPaginationChange,
        onShowSizeChange: onPaginationShowSizeChange
    })));
    let splitDataSource = (0, $fvBso.default)(dataSource);
    if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) splitDataSource = (0, $fvBso.default)(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
    const needResponsive = Object.keys(grid || {}).some((key)=>[
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'xxl'
        ].includes(key));
    const screens = (0, $2bc364d47e670ed8$export$2e2bcd8739ae039)(needResponsive);
    const currentBreakpoint = $jMaZ8.useMemo(()=>{
        for(let i = 0; i < (0, $85a8a338db7581cb$export$74c1bf8296b1541f).length; i += 1){
            const breakpoint = (0, $85a8a338db7581cb$export$74c1bf8296b1541f)[i];
            if (screens[breakpoint]) return breakpoint;
        }
        return undefined;
    }, [
        screens
    ]);
    const colStyle = $jMaZ8.useMemo(()=>{
        if (!grid) return undefined;
        const columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;
        if (columnCount) return {
            width: `${100 / columnCount}%`,
            maxWidth: `${100 / columnCount}%`
        };
    }, [
        JSON.stringify(grid),
        currentBreakpoint
    ]);
    let childrenContent = isLoading && /*#__PURE__*/ $jMaZ8.createElement("div", {
        style: {
            minHeight: 53
        }
    });
    if (splitDataSource.length > 0) {
        const items = splitDataSource.map((item, index)=>renderInnerItem(item, index));
        childrenContent = grid ? /*#__PURE__*/ $jMaZ8.createElement((0, $d1e533474e668570$export$2e2bcd8739ae039), {
            gutter: grid.gutter
        }, $jMaZ8.Children.map(items, (child)=>/*#__PURE__*/ $jMaZ8.createElement("div", {
                key: child === null || child === void 0 ? void 0 : child.key,
                style: colStyle
            }, child))) : /*#__PURE__*/ $jMaZ8.createElement("ul", {
            className: `${prefixCls}-items`
        }, items);
    } else if (!children && !isLoading) childrenContent = /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-empty-text`
    }, (locale === null || locale === void 0 ? void 0 : locale.emptyText) || (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('List')) || /*#__PURE__*/ $jMaZ8.createElement((0, $4de21af32a83dbc2$export$2e2bcd8739ae039), {
        componentName: "List"
    }));
    const paginationPosition = paginationProps.position || 'bottom';
    const contextValue = $jMaZ8.useMemo(()=>({
            grid: grid,
            itemLayout: itemLayout
        }), [
        JSON.stringify(grid),
        itemLayout
    ]);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement((0, $134ef67889c8961e$export$52411773e0d6f15d).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        ref: ref,
        style: Object.assign(Object.assign({}, list === null || list === void 0 ? void 0 : list.style), style),
        className: classString
    }, rest), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-header`
    }, header), /*#__PURE__*/ $jMaZ8.createElement((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), Object.assign({}, loadingProp), childrenContent, children), footer && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-footer`
    }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent)));
}
const $8d359122623b990d$var$ListWithForwardRef = /*#__PURE__*/ $jMaZ8.forwardRef($8d359122623b990d$var$InternalList);
$8d359122623b990d$var$ListWithForwardRef.displayName = 'List';
const $8d359122623b990d$var$List = $8d359122623b990d$var$ListWithForwardRef;
$8d359122623b990d$var$List.Item = (0, $91548e5978ac360c$export$2e2bcd8739ae039);
var $8d359122623b990d$export$2e2bcd8739ae039 = $8d359122623b990d$var$List;


var $fb69b898e7d2ce83$export$e8e78c978b129247;
var $fb69b898e7d2ce83$export$d76128d007d19019;
var $fb69b898e7d2ce83$export$9ed2cb8ad852077a;
var $fb69b898e7d2ce83$export$aaf36426b5008f7a;
var $fb69b898e7d2ce83$export$f2120bbfa5450bd2;
var $fb69b898e7d2ce83$export$209bc1d5cae595bb;
var $fb69b898e7d2ce83$export$22fa394f3ba39578;
$fb69b898e7d2ce83$export$e8e78c978b129247 = "root_a7ccd3";
$fb69b898e7d2ce83$export$d76128d007d19019 = "search_a7ccd3";
$fb69b898e7d2ce83$export$9ed2cb8ad852077a = "dropDownMenu_a7ccd3";
$fb69b898e7d2ce83$export$aaf36426b5008f7a = "result_a7ccd3";
$fb69b898e7d2ce83$export$f2120bbfa5450bd2 = "arrow_a7ccd3";
$fb69b898e7d2ce83$export$209bc1d5cae595bb = "nbResults_a7ccd3";
$fb69b898e7d2ce83$export$22fa394f3ba39578 = "pagination_a7ccd3";





var $jMaZ8 = parcelRequire("jMaZ8");

class $3c7dbeb2a1039f02$export$f9942b7fbbaad25e {
    root;
    publish;
    pages;
    pending;
    applyingScroll;
    lastScrollTop;
    generation;
    frame;
    current;
    observer;
    resizeObserver;
    constructor(root, publish){
        this.root = root;
        this.publish = publish;
        this.pages = [];
        this.applyingScroll = false;
        this.generation = 0;
        this.frame = 0;
        this.requestPage = (number)=>{
            if (!Number.isInteger(number) || !this.pages.some((p)=>p.pageNumber === number)) return false;
            this.cancelTracking();
            this.generation++;
            this.pending = number;
            this.flush();
            return true;
        };
        this./** Capture intent before an async edit; later user actions supersede it. */ beginNavigation = ()=>{
            const generation = ++this.generation;
            this.pending = undefined;
            return (target)=>{
                if (generation !== this.generation) return;
                this.cancelTracking();
                this.pending = target;
                this.flush();
            };
        };
        this.recordCurrentPage = (number)=>{
            if (!this.pages.some((p)=>p.pageNumber === number)) return;
            this.cancelTracking();
            this.generation++;
            this.pending = undefined;
            this.lastScrollTop = this.root.scrollTop;
            this.schedule();
        };
        this.onScroll = ()=>{
            if (this.applyingScroll || this.root.scrollTop === this.lastScrollTop) return;
            this.lastScrollTop = this.root.scrollTop;
            this.cancelPendingNavigation();
            this.schedule();
        };
        this.schedule = ()=>{
            if (this.frame) return;
            this.frame = requestAnimationFrame(()=>{
                this.frame = 0;
                const bounds = this.root.getBoundingClientRect();
                const top = bounds.top + this.root.clientTop;
                const bottom = top + this.root.clientHeight;
                const left = bounds.left + this.root.clientLeft;
                const right = left + this.root.clientWidth;
                const first = Array.from(this.root.querySelectorAll(".pageContent")).find((element)=>{
                    const rect = element.getBoundingClientRect();
                    return rect.height > 0 && rect.width > 0 && rect.top >= top - 0.5 && rect.bottom <= bottom + 0.5 && rect.left >= left - 0.5 && rect.right <= right + 0.5;
                });
                if (first) this.commit(Number(first.id.slice(5)));
            });
        };
        this.cancelPendingNavigation = ()=>{
            this.generation++;
            this.pending = undefined;
        };
        this.scrollbar = (event)=>{
            const bounds = this.root.getBoundingClientRect();
            if (event.target === this.root && event.clientX >= bounds.left + this.root.clientWidth) this.cancelPendingNavigation();
        };
        this.keyboard = (event)=>{
            if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey) return;
            const target = event.target;
            if (target?.closest("input, textarea, select, button, [contenteditable=true], [role=spinbutton], [role=slider]")) return;
            if (target !== document.body && target !== document.documentElement && !this.root.contains(target)) return;
            if ([
                "ArrowUp",
                "ArrowDown",
                "PageUp",
                "PageDown",
                "Home",
                "End",
                " "
            ].includes(event.key)) this.cancelPendingNavigation();
        };
        this.lastScrollTop = root.scrollTop;
        root.addEventListener("scroll", this.onScroll, {
            passive: true
        });
        root.addEventListener("wheel", this.cancelPendingNavigation, {
            passive: true
        });
        root.addEventListener("touchmove", this.cancelPendingNavigation, {
            passive: true
        });
        root.addEventListener("pointerdown", this.scrollbar);
        document.addEventListener("keydown", this.keyboard);
        this.observer = new MutationObserver(()=>{
            if (this.pending !== undefined) this.flush();
        });
        this.observer.observe(root, {
            childList: true,
            subtree: true
        });
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(root);
    }
    setPages(pages) {
        this.pages = pages;
        if (this.current !== undefined && !pages.some((p)=>p.pageNumber === this.current)) this.schedule();
        this.flush();
    }
    requestPage;
    beginNavigation;
    recordCurrentPage;
    commit(number) {
        const url = new URL(window.location.href);
        if (url.searchParams.get("displayedPageNumber") !== String(number)) {
            url.searchParams.set("displayedPageNumber", String(number));
            window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
        }
        if (this.current !== number) {
            this.current = number;
            this.publish(number);
        }
    }
    flush() {
        const target = this.pending;
        if (target === undefined) return;
        const page = this.pages.find((p)=>typeof target === "number" ? p.pageNumber === target : p.start === target.start && p.stringVersion === target.stringVersion);
        if (!page) return;
        const element = this.root.querySelector(`#page-${page.pageNumber}`);
        if (!element) return;
        // Consume before scrolling: layout/observer callbacks cannot replay the command.
        this.pending = undefined;
        this.cancelTracking();
        this.commit(page.pageNumber);
        const top = this.root.scrollTop + element.getBoundingClientRect().top - this.root.getBoundingClientRect().top - this.root.clientTop;
        this.applyingScroll = true;
        try {
            this.root.scrollTo({
                top: top,
                behavior: "instant"
            });
        } finally{
            // Remember the actual destination, including browser clamping at the last page.
            // The resulting scroll event is redundant; any subsequent movement is tracked.
            this.lastScrollTop = this.root.scrollTop;
            this.applyingScroll = false;
        }
    }
    cancelTracking() {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
    }
    onScroll;
    schedule;
    cancelPendingNavigation;
    scrollbar;
    keyboard;
    destroy() {
        this.generation++;
        this.pending = undefined;
        this.cancelTracking();
        this.observer.disconnect();
        this.resizeObserver.disconnect();
        this.root.removeEventListener("scroll", this.onScroll);
        this.root.removeEventListener("wheel", this.cancelPendingNavigation);
        this.root.removeEventListener("touchmove", this.cancelPendingNavigation);
        this.root.removeEventListener("pointerdown", this.scrollbar);
        document.removeEventListener("keydown", this.keyboard);
    }
}


const $e7692b166c91b9dc$var$NavigationContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(null);
const $e7692b166c91b9dc$var$CurrentPageContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(1);
function $e7692b166c91b9dc$export$445f1ca11ac13070({ pages: pages, children: children }) {
    const controller = (0, $jMaZ8.useRef)(null);
    const [currentPage, setCurrentPage] = (0, $jMaZ8.useState)(pages[0]?.pageNumber || 1);
    const location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    const latestPages = (0, $jMaZ8.useRef)(pages);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        latestPages.current = pages;
    }, [
        pages
    ]);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        const root = document.getElementById("project-root");
        if (!root) return;
        const navigation = new (0, $3c7dbeb2a1039f02$export$f9942b7fbbaad25e)(root, setCurrentPage);
        controller.current = navigation;
        navigation.setPages(latestPages.current);
        return ()=>{
            navigation.destroy();
            controller.current = null;
        };
    }, []);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        controller.current?.setPages(pages);
    }, [
        pages
    ]);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        const number = Number(new URLSearchParams(location.search).get("displayedPageNumber"));
        const navigation = controller.current;
        if (navigation && !navigation.requestPage(number)) navigation.requestPage(latestPages.current[0]?.pageNumber);
    // A mode can change the gaps between identical paper sizes. Restore the URL
    // page once per route transition; passive replaceState never enters this effect.
    }, [
        location.key,
        location.pathname,
        location.search
    ]);
    const commands = (0, $jMaZ8.useMemo)(()=>({
            requestPage: (number)=>controller.current?.requestPage(number) ?? false,
            recordCurrentPage: (number)=>controller.current?.recordCurrentPage(number),
            beginNavigation: ()=>controller.current?.beginNavigation() ?? (()=>{})
        }), []);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($e7692b166c91b9dc$var$NavigationContext.Provider, {
        value: commands,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($e7692b166c91b9dc$var$CurrentPageContext.Provider, {
            value: currentPage,
            children: children
        })
    });
}
function $e7692b166c91b9dc$export$fcd3a1f8b6eba71f() {
    const navigation = (0, $jMaZ8.useContext)($e7692b166c91b9dc$var$NavigationContext);
    if (!navigation) throw new Error("Page navigation requires PageNavigationProvider");
    return navigation;
}
const $e7692b166c91b9dc$export$6faff8ed5e305ed3 = ()=>(0, $jMaZ8.useContext)($e7692b166c91b9dc$var$CurrentPageContext);





const $cea0c4b5b7f554ff$var$SEARCH_MODES = {
    STRING: "string",
    ID: "id"
};
const $cea0c4b5b7f554ff$var$DEFAULT_SEARCH = {
    isOpen: false,
    searchString: "",
    searchMode: "string",
    results: []
};
const $cea0c4b5b7f554ff$export$abe847132b142195 = /*#__PURE__*/ (0, $jMaZ8.createContext)($cea0c4b5b7f554ff$var$DEFAULT_SEARCH);
function $cea0c4b5b7f554ff$export$d60636bdb7719d36(bookId) {
    const [search, dispatch] = (0, $jMaZ8.useReducer)((state, command)=>{
        switch(command.id){
            case "SET_SEARCH_STRING":
                return {
                    ...state,
                    searchString: command.payload
                };
            case "SET_SEARCH_MODE":
                return {
                    ...state,
                    searchMode: command.payload
                };
            case "OPEN":
                return {
                    ...state,
                    isOpen: true
                };
            case "CLOSE":
                return {
                    ...state,
                    isOpen: false
                };
            case "TOGGLE":
                return {
                    ...state,
                    isOpen: !state.isOpen
                };
            default:
                return state;
        }
    }, $cea0c4b5b7f554ff$var$DEFAULT_SEARCH);
    const [query, setQuery] = (0, $jMaZ8.useState)("");
    (0, $jMaZ8.useEffect)(()=>{
        const timer = setTimeout(()=>setQuery(search.searchString), 300);
        return ()=>clearTimeout(timer);
    }, [
        search.searchString
    ]);
    const { data: data, loading: loading } = (0, $d7188398173686a1$export$6f854643897373ca)({
        query: query,
        mode: search.searchMode === "id" ? (0, $b522cf181e75e62d$export$e228d3e230353c).ID : (0, $b522cf181e75e62d$export$e228d3e230353c).CONTENT,
        projectId: bookId
    });
    const results = (0, $jMaZ8.useMemo)(()=>[
            ...data?.searchForRheses?.results || []
        ].sort((a, b)=>a.pageNumber - b.pageNumber), [
        data
    ]);
    const send = (0, $jMaZ8.useMemo)(()=>({
            setSearchMode: (payload)=>dispatch({
                    id: "SET_SEARCH_MODE",
                    payload: payload
                }),
            setSearchString: (payload)=>dispatch({
                    id: "SET_SEARCH_STRING",
                    payload: payload
                }),
            toggle: ()=>dispatch({
                    id: "TOGGLE"
                }),
            open: ()=>dispatch({
                    id: "OPEN"
                }),
            close: ()=>dispatch({
                    id: "CLOSE"
                })
        }), []);
    const state = (0, $jMaZ8.useMemo)(()=>({
            ...search,
            results: search.isOpen ? results : $cea0c4b5b7f554ff$var$DEFAULT_SEARCH.results
        }), [
        search,
        results
    ]);
    return {
        state: state,
        send: send,
        results: results,
        loading: loading,
        total: data?.searchForRheses.totalMatchNumber ?? 0
    };
}
const $cea0c4b5b7f554ff$var$getSearchModeLabel = (searchMode, translation)=>{
    if (searchMode === "id") return translation.id;
    return translation.text;
};
function $cea0c4b5b7f554ff$export$2e2bcd8739ae039({ isOpen: isOpen, close: close, setSearchMode: setSearchMode, searchMode: searchMode, results: results, loading: loading, totalElements: totalElements, textQuery: textQuery, setTextQuery: setTextQuery }) {
    const [page, setPage] = (0, $jMaZ8.useState)(1);
    const [inputRef, setInputRef] = (0, $jMaZ8.useState)(null);
    const { requestPage: requestPage } = (0, $e7692b166c91b9dc$export$fcd3a1f8b6eba71f)();
    const getSearchModeLabelTranslate = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.search.getSearchModeLabel");
    const nbResultTranslate = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.search.nbResults");
    (0, $jMaZ8.useEffect)(()=>inputRef?.focus(), [
        inputRef
    ]);
    const searchModeLabel = (0, $jMaZ8.useMemo)(()=>$cea0c4b5b7f554ff$var$getSearchModeLabel(searchMode, getSearchModeLabelTranslate), [
        searchMode,
        getSearchModeLabelTranslate
    ]);
    const updateQuery = (0, $jMaZ8.useCallback)((e)=>{
        setTextQuery(e.target.value);
        setPage(1);
    }, [
        setTextQuery
    ]);
    const renderDropdownContent = (0, $jMaZ8.useCallback)(()=>{
        const items = [
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "1",
                label: $cea0c4b5b7f554ff$var$getSearchModeLabel($cea0c4b5b7f554ff$var$SEARCH_MODES.STRING, getSearchModeLabelTranslate),
                onClick: ()=>setSearchMode("string")
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "2",
                label: $cea0c4b5b7f554ff$var$getSearchModeLabel($cea0c4b5b7f554ff$var$SEARCH_MODES.ID, getSearchModeLabelTranslate),
                onClick: ()=>setSearchMode("id")
            })
        ];
        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
            className: $fb69b898e7d2ce83$export$9ed2cb8ad852077a,
            items: items
        });
    }, [
        getSearchModeLabelTranslate,
        setSearchMode
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $d88f1f9a11889bfa$export$2e2bcd8739ae039), {
        title: "Recherche",
        placement: "right",
        styles: {
            body: {
                padding: 0,
                display: "flex",
                flexDirection: "column"
            }
        },
        className: $fb69b898e7d2ce83$export$e8e78c978b129247,
        open: isOpen,
        closable: true,
        onClose: ()=>{
            close();
        },
        mask: false,
        width: "35em",
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8d359122623b990d$export$2e2bcd8739ae039), {
                style: {
                    flex: 1,
                    overflowY: "auto"
                },
                size: "large",
                dataSource: results.slice((page - 1) * 20, page * 20),
                loading: loading,
                header: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                    className: $fb69b898e7d2ce83$export$d76128d007d19019,
                    justify: "center",
                    align: "middle",
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                            style: {
                                textAlign: "center",
                                fontSize: "1.2em"
                            },
                            span: 2,
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $7707703e157f8963$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                            span: 16,
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                                ref: setInputRef,
                                value: textQuery,
                                onChange: updateQuery
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                            span: 6,
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
                                dropdownRender: renderDropdownContent,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                    children: [
                                        searchModeLabel,
                                        " ",
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $159430c34bfeb8bb$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            })
                        })
                    ]
                }),
                renderItem: (result)=>{
                    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $8d359122623b990d$export$2e2bcd8739ae039).Item, {
                        onClick: ()=>{
                            requestPage(result.pageNumber);
                        },
                        className: $fb69b898e7d2ce83$export$aaf36426b5008f7a,
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                                children: result.pageNumber
                            }),
                            result.content,
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b81bb3718bd35328$export$2e2bcd8739ae039), {
                                    className: $fb69b898e7d2ce83$export$f2120bbfa5450bd2
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $029f538dfd4a9bcd$export$2e2bcd8739ae039), {
                className: $fb69b898e7d2ce83$export$22fa394f3ba39578,
                onChange: setPage,
                current: page,
                total: totalElements,
                pageSize: 20,
                hideOnSinglePage: true,
                responsive: true,
                showSizeChanger: false,
                size: "small"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                className: $fb69b898e7d2ce83$export$209bc1d5cae595bb,
                children: loading ? nbResultTranslate.loading : `${results.length} ${results.length > 1 ? nbResultTranslate.results : nbResultTranslate.result}`
            })
        ]
    });
}




function $05bb51f2864c5e9e$export$260c6f51d52cfbfe(str) {
    // eslint-disable-next-line
    return str.match(/[\\\.\(\)\[\]\{\}\"\'\`’\-\—\–,;:\/\!\?\¿\¡\$\*\«\»\£\$\µ\+\€\=\&\~]/);
}
function $05bb51f2864c5e9e$export$840dda5a492e049a(str) {
    return str.match(/\s/);
}



const $d0ce5078a897d2dc$export$8a6c4548816286b7 = /*#__PURE__*/ (0, $jMaZ8.createContext)(0);
const $d0ce5078a897d2dc$var$i18nKey = "project.existing.bookRenderer.paraghapLabel";
const $d0ce5078a897d2dc$var$ParagrapLabel = {
    CENTRE: `${$d0ce5078a897d2dc$var$i18nKey}.center`,
    CITATION: `${$d0ce5078a897d2dc$var$i18nKey}.citation`,
    COURRIER: `${$d0ce5078a897d2dc$var$i18nKey}.mail`,
    DIALOGUE: `${$d0ce5078a897d2dc$var$i18nKey}.dialogue`,
    DIDASCALIE: `${$d0ce5078a897d2dc$var$i18nKey}.didascalie`,
    DROITE: `${$d0ce5078a897d2dc$var$i18nKey}.right`,
    EMAIL: `${$d0ce5078a897d2dc$var$i18nKey}.email`,
    ESPACE: `${$d0ce5078a897d2dc$var$i18nKey}.space`,
    GRAS: `${$d0ce5078a897d2dc$var$i18nKey}.bold`,
    INTRO: `${$d0ce5078a897d2dc$var$i18nKey}.intro`,
    NORMAL: `${$d0ce5078a897d2dc$var$i18nKey}.normal`,
    NOTE: `${$d0ce5078a897d2dc$var$i18nKey}.note`,
    RESUME: `${$d0ce5078a897d2dc$var$i18nKey}.r\xe9sum\xe9`,
    TEXTO: `${$d0ce5078a897d2dc$var$i18nKey}.text`,
    TITRE_1: `${$d0ce5078a897d2dc$var$i18nKey}.title1`,
    TITRE_2: `${$d0ce5078a897d2dc$var$i18nKey}.title2`,
    TITRE_3: `${$d0ce5078a897d2dc$var$i18nKey}.title3`,
    TITRE_4: `${$d0ce5078a897d2dc$var$i18nKey}.title4`,
    TITRE_5: `${$d0ce5078a897d2dc$var$i18nKey}.title5`,
    TITRE_6: `${$d0ce5078a897d2dc$var$i18nKey}.title6`,
    TITRE1: `${$d0ce5078a897d2dc$var$i18nKey}.title1`,
    TITRE2: `${$d0ce5078a897d2dc$var$i18nKey}.title2`,
    TITRE3: `${$d0ce5078a897d2dc$var$i18nKey}.title3`,
    TITRE4: `${$d0ce5078a897d2dc$var$i18nKey}.title4`,
    TITRE5: `${$d0ce5078a897d2dc$var$i18nKey}.title5`,
    TITRE6: `${$d0ce5078a897d2dc$var$i18nKey}.title6`,
    VERS: `${$d0ce5078a897d2dc$var$i18nKey}.vers`,
    LIST_ORDERED: `${$d0ce5078a897d2dc$var$i18nKey}.listOrdered`,
    LIST_UNORDERED: `${$d0ce5078a897d2dc$var$i18nKey}.listUnordered`,
    LIST_DEFINITION: `${$d0ce5078a897d2dc$var$i18nKey}.listDefinition`
};
const $d0ce5078a897d2dc$export$23af037c2adc3847 = (val)=>val?.groups && val?.definition;
const $d0ce5078a897d2dc$var$convertRhese = (rhese, definitions, parity, definitionMode)=>{
    const rheseDefinitions = definitionMode ? definitions.filter((definition)=>(0, $93ac5f630bcb3f8f$export$b0914984cd524b3f)(rhese, definition)) : [];
    let lettersGroups = rhese.letters.map((letter, index)=>{
        return {
            isEven: parity[index],
            letters: [
                letter
            ]
        };
    });
    const result = [];
    const orderedDefinitions = [
        ...rheseDefinitions
    ];
    orderedDefinitions.sort((a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start);
    let currentDefinition = orderedDefinitions.shift();
    let currentGroup = [];
    for (let lettersGroup of lettersGroups){
        let letter = lettersGroup.letters[0];
        if (currentDefinition && letter.absoluteTextPosition >= currentDefinition.anchors[0].utf16Start && letter.absoluteTextPosition < currentDefinition.anchors[0].utf16Start + currentDefinition.anchors[0].utf16Size) {
            if ($d0ce5078a897d2dc$export$23af037c2adc3847(currentGroup) && currentGroup.definition.data.id === currentDefinition.data.id) currentGroup.groups.push({
                isEven: lettersGroup.isEven,
                letters: [
                    letter
                ],
                definitionOccurence: currentGroup.groups[0].definitionOccurence
            });
            else {
                result.push(currentGroup);
                currentGroup = {
                    definition: currentDefinition,
                    groups: [
                        lettersGroup
                    ]
                };
            }
            if (letter.absoluteTextPosition === currentDefinition.anchors[0].utf16Start + currentDefinition.anchors[0].utf16Size - 1) currentDefinition = orderedDefinitions.shift();
        } else if ($d0ce5078a897d2dc$export$23af037c2adc3847(currentGroup)) {
            result.push(currentGroup);
            currentGroup = [
                lettersGroup
            ];
        } else currentGroup.push(lettersGroup);
    }
    if (result[result.length - 1] !== currentGroup) result.push(currentGroup);
    return result.flat();
};
const $d0ce5078a897d2dc$var$RenderLetter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function RenderLetter({ letter: letter, i: i, evenOdd: evenOdd, isPunctuation: isPunctuation, hasSyllable: hasSyllable, enableCustomCssTooltip: enableCustomCssTooltip, highlightSpaces: highlightSpaces = false }) {
    let phoneme = "";
    if (letter.phoneme && !letter.isMute) phoneme = "phoneme " + letter.phoneme;
    let customColoration = "";
    if (letter.customColoration) customColoration = "customColoration color" + letter.customColoration;
    const tagProps = {
        "data-index": i,
        "data-id": letter.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(isPunctuation ? [
            "ponctuation",
            "circleContainerTooltipClasses",
            letter.kind?.filter((k)=>(0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).CITATION === k)
        ] : [
            "letter",
            "circleContainerTooltipClasses",
            ...highlightSpaces && (letter.char === " " || letter.char === "\xa0") ? [
                "highlightedSpace"
            ] : [],
            evenOdd,
            phoneme,
            customColoration,
            letter.kind,
            {
                muet: letter.isMute,
                insecable: letter.char === "\xa0",
                syllable: hasSyllable
            }
        ])
    };
    let Tag;
    if (letter.kind?.includes((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).EXPOSANT)) Tag = "sup";
    else if (letter.kind?.includes((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).INDICE)) Tag = "sub";
    else Tag = "span";
    if (!enableCustomCssTooltip || !letter.cssClasses) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(Tag, {
        ...tagProps,
        children: letter.char
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
        title: letter.cssClasses,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(Tag, {
            ...tagProps,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    letter.char,
                    !!letter.cssClasses && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                        className: "circleTooltipClasses"
                    })
                ]
            })
        })
    });
});
const $d0ce5078a897d2dc$var$isEvenOdd = (bool)=>{
    let isEven = "";
    if (bool === true) isEven = "pair";
    if (bool === false) isEven = "impair";
    return isEven;
};
const $d0ce5078a897d2dc$var$RenderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function RenderText({ groupedLetters: groupedLetters, letters: letters, letterParity: letterParity, enableCustomCssTooltip: enableCustomCssTooltip, highlightSpaces: highlightSpaces }) {
    let counter = 0;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $jMaZ8.Fragment), {
        children: !groupedLetters ? letters.map((letter, i)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d0ce5078a897d2dc$var$RenderLetter, {
                letter: letter,
                i: i,
                evenOdd: $d0ce5078a897d2dc$var$isEvenOdd(letterParity[i]),
                isPunctuation: !!(0, $05bb51f2864c5e9e$export$260c6f51d52cfbfe)(letter.char),
                hasSyllable: letter.syllableId !== undefined && letter.syllableId !== null,
                enableCustomCssTooltip: enableCustomCssTooltip,
                highlightSpaces: highlightSpaces
            }, letter.position)) : groupedLetters.map((lettersGroup)=>{
            if ($d0ce5078a897d2dc$export$23af037c2adc3847(lettersGroup)) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                title: lettersGroup.definition.data.description || lettersGroup.definition.data.imageName,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                    className: `definition ${lettersGroup.definition.data.kind.toLowerCase()}`,
                    children: lettersGroup.groups.reduce((acc, val)=>{
                        const res = val.letters.map((letter)=>{
                            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d0ce5078a897d2dc$var$RenderLetter, {
                                enableCustomCssTooltip: enableCustomCssTooltip,
                                letter: letter,
                                i: counter++,
                                evenOdd: $d0ce5078a897d2dc$var$isEvenOdd(val.isEven),
                                isPunctuation: !!(0, $05bb51f2864c5e9e$export$260c6f51d52cfbfe)(letter.char),
                                hasSyllable: letter.syllableId !== undefined && letter.syllableId !== null
                            }, letter.position);
                        });
                        acc = acc.concat(res);
                        return acc;
                    }, [])
                })
            }, `definition-${lettersGroup.groups[0].letters[0].position}`);
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $jMaZ8.Fragment), {
                children: lettersGroup.letters.map((letter)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d0ce5078a897d2dc$var$RenderLetter, {
                        letter: letter,
                        i: counter++,
                        evenOdd: $d0ce5078a897d2dc$var$isEvenOdd(lettersGroup.isEven),
                        isPunctuation: !!(0, $05bb51f2864c5e9e$export$260c6f51d52cfbfe)(letter.char),
                        hasSyllable: letter.syllableId !== undefined && letter.syllableId !== null,
                        enableCustomCssTooltip: enableCustomCssTooltip,
                        highlightSpaces: highlightSpaces
                    }, letter.position))
            }, lettersGroup.letters[0].position);
        })
    });
}, (previous, next)=>previous.enableCustomCssTooltip === next.enableCustomCssTooltip && previous.highlightSpaces === next.highlightSpaces && previous.groupedLetters === next.groupedLetters && previous.letterParity === next.letterParity && (0, $33cabd4ced3b2678$export$b4a5b1e32ebf0937)(previous.letters, next.letters));
const $d0ce5078a897d2dc$export$8eeee60730c609c5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(({ children: rhese, activeStart: activeStart, activeEnd: activeEnd, active: active, rheseProps: rheseProps, index: index, definitions: definitions, parity: parity, letterParity: letterParity, definitionMode: definitionMode = false, spaceIfNeeded: spaceIfNeeded, isSearchResult: isSearchResult, enableCustomCssTooltip: enableCustomCssTooltip, highlightSpaces: highlightSpaces })=>{
    const isOdd = index === 0 || index / 10 % 2 === 0;
    const onMouseUp = (0, $jMaZ8.useCallback)(()=>{
        if (!rheseProps || !rheseProps.onMouseUp) return;
        rheseProps.onMouseUp(rhese);
    }, [
        rhese,
        rheseProps
    ]);
    const onMouseDown = (0, $jMaZ8.useCallback)(()=>{
        if (!rheseProps || !rheseProps.onMouseDown) return;
        rheseProps.onMouseDown(rhese);
    }, [
        rhese,
        rheseProps
    ]);
    let warningLevel = "";
    const len = rhese.letters.length;
    if (len >= 31) warningLevel = "warningLight";
    if (len >= 36) warningLevel = "warning";
    if (len >= 40) warningLevel = "warningStrong";
    const props = {
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        key: rhese.id,
        id: "r" + index,
        "data-id": rhese.id,
        "data-absolute-position": rhese.letters[0]?.absoluteTextPosition,
        className: `
            rhese
            ${isOdd ? "rhese1" : "rhese2"}
            ${activeStart ? "activeStart" : ""} 
            ${activeEnd ? "activeEnd" : ""}
            ${active ? "active" : ""}
            ${highlightSpaces ? "borderGreen" : ""}
            ${warningLevel}
          `
    };
    const resolvedParity = (0, $jMaZ8.useMemo)(()=>{
        if (letterParity) return letterParity;
        const map = parity || (0, $a5d78ca886c67c28$export$b34a898f52165358)([
            rhese
        ]);
        return rhese.letters.map((letter)=>map.get(letter.absoluteTextPosition));
    }, [
        letterParity,
        parity,
        rhese
    ]);
    const convertedRhese = (0, $jMaZ8.useMemo)(()=>definitionMode ? $d0ce5078a897d2dc$var$convertRhese(rhese, definitions, resolvedParity, true) : null, [
        rhese,
        definitions,
        resolvedParity,
        definitionMode
    ]);
    const content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
        className: `rheseWrapper ${isSearchResult ? "isSearchResult" : ""}`,
        "data-rhese-length": len,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                ...props,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                        className: "rheseNumber",
                        children: index
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d0ce5078a897d2dc$var$RenderText, {
                        groupedLetters: convertedRhese,
                        letters: rhese.letters,
                        letterParity: resolvedParity,
                        enableCustomCssTooltip: enableCustomCssTooltip,
                        highlightSpaces: highlightSpaces
                    })
                ]
            }),
            spaceIfNeeded
        ]
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $jMaZ8.Fragment), {
        children: [
            content,
            rhese.lineBreakAfter && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                children: [
                    "\u21B2",
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("br", {
                        className: "lineBreak"
                    })
                ]
            })
        ]
    });
});
const $d0ce5078a897d2dc$var$RenderRoot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(({ rhese: rhese, definitions: definitions, letterParity: letterParity, definitionMode: definitionMode, enableCustomCssTooltip: enableCustomCssTooltip, rheseCounter: rheseCounter, activeStart: activeStart, activeEnd: activeEnd, active: active, rheseProps: rheseProps, selectedSeparator: selectedSeparator, addSpaceAfter: addSpaceAfter, rheseWrapper: rheseWrapper, isSearchResult: isSearchResult, highlightSpaces: highlightSpaces })=>{
    const spaceIfNeeded = addSpaceAfter ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
        className: "space",
        children: "\xa0"
    }) : null;
    const wrapper = rheseWrapper || ((_, renderedRhese)=>renderedRhese);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $jMaZ8.Fragment), {
        children: wrapper(rhese, /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d0ce5078a897d2dc$export$8eeee60730c609c5, {
            isSearchResult: isSearchResult,
            definitions: definitions,
            letterParity: letterParity,
            definitionMode: definitionMode,
            index: rheseCounter,
            activeStart: activeStart,
            activeEnd: activeEnd,
            active: active,
            rheseProps: rheseProps,
            selectedSeparator: selectedSeparator,
            spaceIfNeeded: spaceIfNeeded,
            enableCustomCssTooltip: enableCustomCssTooltip,
            highlightSpaces: highlightSpaces,
            children: rhese
        }))
    });
});
const $d0ce5078a897d2dc$var$isParagraph = (p)=>p.type === "paragraph";
function $d0ce5078a897d2dc$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function RenderBook({ children: pageMetadata, startRhese: startRhese, endRhese: endRhese, selectedRhesesIds: selectedRhesesIds, selectedSeparator: selectedSeparator, rheseProps: rheseProps, enableParagraphTooltip: enableParagraphTooltip = false, rheseWrapper: rheseWrapper, rheseOffset: rheseOffset = 0, paragraphWrapper: paragraphWrapper, projectId: projectId, highlightSpaces: highlightSpaces }) {
        // const rheseOffset = useContext(RheseOffset);
        let rheseCounter = rheseOffset;
        let paragraphCounter = 0;
        const location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
        const definitionMode = location.pathname.includes("definition");
        const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
        const convert = (0, $jMaZ8.useMemo)(()=>(0, $d6f8296a78132fd9$export$5fe27e00e1af1887)(), []);
        const present = (0, $jMaZ8.useMemo)(()=>(0, $93ac5f630bcb3f8f$export$f6ed7268d35f438)(), []);
        const { rheses: convertedRheses, paragraphs: convertedParagraphs } = (0, $jMaZ8.useMemo)(()=>convert(projectId, pageMetadata), [
            pageMetadata,
            projectId,
            convert
        ]);
        const paragraphsMap = (0, $jMaZ8.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($9434db2d28cdae1f$exports)))(convertedRheses, "paragraphId"), [
            convertedRheses
        ]);
        const presentations = (0, $jMaZ8.useMemo)(()=>present(convertedRheses, pageMetadata.definition, definitionMode), [
            convertedRheses,
            pageMetadata.definition,
            definitionMode,
            present
        ]);
        const paragraphById = (0, $jMaZ8.useMemo)(()=>new Map(convertedParagraphs.map((p)=>[
                    p.id,
                    p
                ])), [
            convertedParagraphs
        ]);
        const contentWithParagraphs = (0, $jMaZ8.useMemo)(()=>{
            const seen = new Set();
            const content = [];
            for (const rhese of convertedRheses){
                if (rhese.paragraphId === undefined) content.push(rhese);
                else if (!seen.has(rhese.paragraphId)) {
                    seen.add(rhese.paragraphId);
                    const paragraph = paragraphById.get(rhese.paragraphId);
                    content.push({
                        type: "paragraph",
                        tagName: paragraph?.tag || "",
                        id: rhese.paragraphId,
                        rheses: paragraphsMap[rhese.paragraphId]
                    });
                }
            }
            return content;
        }, [
            paragraphById,
            paragraphsMap,
            convertedRheses
        ]);
        const { results: searchResults } = (0, $jMaZ8.useContext)((0, $cea0c4b5b7f554ff$export$abe847132b142195));
        const searchIds = (0, $jMaZ8.useMemo)(()=>new Set(searchResults.map((result)=>result.rhese.data.id)), [
            searchResults
        ]);
        const selectedIds = (0, $jMaZ8.useMemo)(()=>new Set(selectedRhesesIds), [
            selectedRhesesIds
        ]);
        const renderer = {
            rhese: (rhese)=>{
                const activeStart = rhese.id === startRhese?.id;
                const activeEnd = rhese.id === endRhese?.id;
                const active = selectedIds.has(rhese.id);
                const isSearchResult = searchIds.has(rhese.id);
                return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d0ce5078a897d2dc$var$RenderRoot, {
                    isSearchResult: isSearchResult,
                    rheseWrapper: rheseWrapper,
                    rheseCounter: rheseCounter += 10,
                    rhese: rhese,
                    definitions: presentations.get(rhese.id).definitions,
                    letterParity: presentations.get(rhese.id).letterParity,
                    enableCustomCssTooltip: (0, $7ff84a88030acb67$export$d79de1c00ff6430)(location.pathname),
                    definitionMode: definitionMode,
                    activeStart: activeStart,
                    activeEnd: activeEnd,
                    active: active,
                    addSpaceAfter: true,
                    selectedSeparator: selectedSeparator,
                    rheseProps: rheseProps,
                    highlightSpaces: !!highlightSpaces
                }, rhese.id);
            },
            paragraph: (p)=>{
                const paragrapheKind = paragraphById.get(p.id)?.kind;
                paragraphCounter += 1;
                const labelKey = paragrapheKind || "NORMAL";
                const content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                    id: `p${paragraphCounter}`,
                    "data-toto": `${p.id}`,
                    className: `paragraph ${paragrapheKind}`,
                    children: p.rheses.map((rhese)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $jMaZ8.Fragment), {
                            children: renderer.rhese(rhese)
                        }, rhese.id))
                });
                return enableParagraphTooltip ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                        children: [
                            t($d0ce5078a897d2dc$var$ParagrapLabel[labelKey]),
                            p.tagName ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("br", {}),
                                    p.tagName
                                ]
                            }) : null
                        ]
                    }),
                    placement: "right",
                    children: content
                }) : content;
            }
        };
        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
            children: contentWithParagraphs.map((content, i)=>{
                if ($d0ce5078a897d2dc$var$isParagraph(content)) {
                    const paragraph = renderer.paragraph(content);
                    const Wrapper = paragraphWrapper?.component;
                    const props = paragraphWrapper?.props;
                    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $jMaZ8.Fragment), {
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: Wrapper && props ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(Wrapper, {
                                ...props,
                                paragraphId: content.id,
                                isLastParagraph: i === contentWithParagraphs.length - 1,
                                children: paragraph
                            }) : paragraph
                        })
                    }, content.id);
                }
            })
        });
    });
}


var $d94013632bb34cec$export$e8e78c978b129247;
$d94013632bb34cec$export$e8e78c978b129247 = "root_fbf696";




var $f13071a53a0d1da4$export$448e4850cad7c7b0;
var $f13071a53a0d1da4$export$a943aa9a0fca3f0b;
var $f13071a53a0d1da4$export$e8e78c978b129247;
var $f13071a53a0d1da4$export$2a82ddc22e8c7fbb;
var $f13071a53a0d1da4$export$757af9f96ca62b21;
var $f13071a53a0d1da4$export$6700685ff6fd559c;
var $f13071a53a0d1da4$export$a7db06668cad9adb;
var $f13071a53a0d1da4$export$ac052f74bbc68e2d;
var $f13071a53a0d1da4$export$ed705ffc52cf13c6;
var $f13071a53a0d1da4$export$5b1c922c81430b65;
var $f13071a53a0d1da4$export$376d36288d105ef8;
var $f13071a53a0d1da4$export$ae9a281c4379b144;
$f13071a53a0d1da4$export$448e4850cad7c7b0 = "h1_77d7ff";
$f13071a53a0d1da4$export$a943aa9a0fca3f0b = "h2_77d7ff";
$f13071a53a0d1da4$export$e8e78c978b129247 = "root_77d7ff";
$f13071a53a0d1da4$export$2a82ddc22e8c7fbb = "contentWrapper_77d7ff";
$f13071a53a0d1da4$export$757af9f96ca62b21 = "a4Wrapper_77d7ff";
$f13071a53a0d1da4$export$6700685ff6fd559c = "overflowChecker_77d7ff";
$f13071a53a0d1da4$export$a7db06668cad9adb = "content_77d7ff";
$f13071a53a0d1da4$export$ac052f74bbc68e2d = "topBar_77d7ff";
$f13071a53a0d1da4$export$ed705ffc52cf13c6 = "totalPageNumber_77d7ff";
$f13071a53a0d1da4$export$5b1c922c81430b65 = "pageNumber_77d7ff";
$f13071a53a0d1da4$export$376d36288d105ef8 = "chapterName_77d7ff";
$f13071a53a0d1da4$export$ae9a281c4379b144 = "showMore_77d7ff";



var $jMaZ8 = parcelRequire("jMaZ8");


const $f9ad6d9d9a78d084$var$PageContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);
const $f9ad6d9d9a78d084$export$9c25024bdfe755f7 = ()=>{
    const context = (0, $jMaZ8.useContext)($f9ad6d9d9a78d084$var$PageContext);
    if (!context) {
        // Needed to avoid throwing error on components when these are being removed from the dom "too slowly"
        console.error("usePageContext must be used within a PageContentLoader");
        // throw new Error("usePageContext must be used within a PageContentLoader");
        return {};
    }
    return context;
};
function $f9ad6d9d9a78d084$export$3dd58bf9bf579bba({ page: page, component: ChildComponent, pageId: pageId, props: props, projectId: projectId, loadMore: loadMore, pageSizeFactor: pageSizeFactor = 2 }) {
    const { loading: loading, data: data } = (0, $d7188398173686a1$export$b977c921ca1d39c)({
        projectId: projectId,
        pageId: page.id,
        pageSizeFactor: pageSizeFactor
    });
    const rheses = (0, $jMaZ8.useMemo)(()=>data?.extendedPage?.rhese || [], [
        data?.extendedPage?.rhese
    ]);
    const paragraphs = (0, $jMaZ8.useMemo)(()=>data?.extendedPage?.paragraph || [], [
        data?.extendedPage?.paragraph
    ]);
    const images = (0, $jMaZ8.useMemo)(()=>data?.extendedPage?.paragraph?.flatMap((p)=>p.data?.images) || [], [
        data?.extendedPage?.paragraph
    ]);
    const hasMoreToLoad = !!data?.extendedPage && data.extendedPage.textContent.length < data.extendedPage.page.anchors[0].utf16Size;
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    if (loading) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $de3c5dab5cbf9179$export$7f7cbe89f1eacd2), {});
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)($f9ad6d9d9a78d084$var$PageContext.Provider, {
        value: data,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(ChildComponent, {
                ...props,
                rheses: rheses,
                paragraphs: paragraphs,
                images: images,
                page: page,
                pageId: pageId,
                projectId: projectId,
                loading: loading
            }),
            hasMoreToLoad && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("button", {
                className: $f13071a53a0d1da4$export$ae9a281c4379b144,
                onClick: loadMore,
                children: t("project.a4Page.showMore")
            })
        ]
    });
}



var $jMaZ8 = parcelRequire("jMaZ8");
const $9a1b5d9b85264433$export$2ff026368446039c = (allPages)=>{
    const { extendedPage: extendedPage } = (0, $f9ad6d9d9a78d084$export$9c25024bdfe755f7)();
    const page = (0, $jMaZ8.useMemo)(()=>{
        const foundPage = allPages.find((p)=>p.id === extendedPage?.page.data.id);
        if (!foundPage) // This is not a blocking error in some cases
        console.error("Page not found");
        return foundPage;
    }, [
        extendedPage,
        allPages
    ]);
    return {
        page: page,
        pageMetadata: extendedPage
    };
};


function $634ada8300777bb4$export$2e2bcd8739ae039({ projectId: projectId, allPages: allPages }) {
    const { pageMetadata: pageMetadata } = (0, $9a1b5d9b85264433$export$2ff026368446039c)(allPages);
    const contentEditableRef = (0, $jMaZ8.useRef)(null);
    const RenderBook = (0, $jMaZ8.useMemo)(()=>(0, $d0ce5078a897d2dc$export$2e2bcd8739ae039)(), []);
    (0, $jMaZ8.useEffect)(()=>{
        const noop = (e)=>{
            e.preventDefault();
            return false;
        };
        const contentEditableRefCurrent = contentEditableRef.current;
        contentEditableRefCurrent?.addEventListener("cut", noop, false);
        contentEditableRefCurrent?.addEventListener("paste", noop, false);
        contentEditableRefCurrent?.addEventListener("keydown", noop, false);
        contentEditableRefCurrent?.addEventListener("dragenter", noop, false);
        contentEditableRefCurrent?.addEventListener("dragleave", noop, false);
        contentEditableRefCurrent?.addEventListener("dragover", noop, false);
        contentEditableRefCurrent?.addEventListener("drop", noop, false);
        return ()=>{
            contentEditableRefCurrent?.removeEventListener("cut", noop);
            contentEditableRefCurrent?.removeEventListener("paste", noop);
            contentEditableRefCurrent?.removeEventListener("keydown", noop);
            contentEditableRefCurrent?.removeEventListener("dragenter", noop);
            contentEditableRefCurrent?.removeEventListener("dragleave", noop);
            contentEditableRefCurrent?.removeEventListener("dragover", noop);
            contentEditableRefCurrent?.removeEventListener("drop", noop);
        };
    }, [
        contentEditableRef
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $d94013632bb34cec$export$e8e78c978b129247,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(RenderBook, {
            projectId: projectId,
            children: pageMetadata
        })
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $0978c3db74557c93$var$UpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    "name": "up",
    "theme": "outlined"
};
var $0978c3db74557c93$export$2e2bcd8739ae039 = $0978c3db74557c93$var$UpOutlined;



var $03ce425ee205cd8c$var$UpOutlined = function UpOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $0978c3db74557c93$export$2e2bcd8739ae039)
    }));
};
/**![up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5MC41IDc1NS4zTDUzNy45IDI2OS4yYy0xMi44LTE3LjYtMzktMTcuNi01MS43IDBMMTMzLjUgNzU1LjNBOCA4IDAgMDAxNDAgNzY4aDc1YzUuMSAwIDkuOS0yLjUgMTIuOS02LjZMNTEyIDM2OS44bDI4NC4xIDM5MS42YzMgNC4xIDcuOCA2LjYgMTIuOSA2LjZoNzVjNi41IDAgMTAuMy03LjQgNi41LTEyLjd6IiAvPjwvc3ZnPg==) */ var $03ce425ee205cd8c$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($03ce425ee205cd8c$var$UpOutlined);
$03ce425ee205cd8c$var$RefIcon.displayName = 'UpOutlined';
var $03ce425ee205cd8c$export$2e2bcd8739ae039 = $03ce425ee205cd8c$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $1Esi2 = parcelRequire("1Esi2");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");
/* eslint-disable max-classes-per-file */ 
var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");
function $533f2472ab8c966e$export$d5c7b2f63580e8f5() {
    return typeof BigInt === 'function';
}


function $4173df58bd33d0e9$export$dd1bc94b04021eeb(value) {
    return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function $4173df58bd33d0e9$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith('-');
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, '$1')// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, '')// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, '');
    if (str.startsWith('.')) str = "0".concat(str);
    var trimStr = str || '0';
    var splitNumber = trimStr.split('.');
    var integerStr = splitNumber[0] || '0';
    var decimalStr = splitNumber[1] || '0';
    if (integerStr === '0' && decimalStr === '0') negative = false;
    var negativeStr = negative ? '-' : '';
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $4173df58bd33d0e9$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes('e');
}
function $4173df58bd33d0e9$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($4173df58bd33d0e9$export$ee6c12ef7f6d8b32(number)) {
        var precision = Number(numStr.slice(numStr.indexOf('e-') + 2));
        var decimalMatch = numStr.match(/\.(\d+)/);
        if (decimalMatch !== null && decimalMatch !== void 0 && decimalMatch[1]) precision += decimalMatch[1].length;
        return precision;
    }
    return numStr.includes('.') && $4173df58bd33d0e9$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf('.') - 1 : 0;
}
function $4173df58bd33d0e9$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($4173df58bd33d0e9$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $533f2472ab8c966e$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $533f2472ab8c966e$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        numStr = number.toFixed($4173df58bd33d0e9$export$2e56483e4ad90ee6(numStr));
    }
    return $4173df58bd33d0e9$export$5be79a0015c5ab12(numStr).fullStr;
}
function $4173df58bd33d0e9$export$b3d198e17b370bec(num) {
    if (typeof num === 'number') return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}


var $a0c49beee3ffe6ef$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** BigInt will convert `0009` to `9`. We need record the len of decimal */ function BigIntDecimal(value) {
        (0, $klxbl.default)(this, BigIntDecimal);
        (0, $eq8kl.default)(this, "origin", '');
        (0, $eq8kl.default)(this, "negative", void 0);
        (0, $eq8kl.default)(this, "integer", void 0);
        (0, $eq8kl.default)(this, "decimal", void 0);
        (0, $eq8kl.default)(this, "decimalLen", void 0);
        (0, $eq8kl.default)(this, "empty", void 0);
        (0, $eq8kl.default)(this, "nan", void 0);
        if ((0, $4173df58bd33d0e9$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === '-' || Number.isNaN(value)) {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $4173df58bd33d0e9$export$ee6c12ef7f6d8b32)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === 'string' ? mergedValue : (0, $4173df58bd33d0e9$export$fdc98affa95a4322)(mergedValue);
        if ((0, $4173df58bd33d0e9$export$b3d198e17b370bec)(mergedValue)) {
            var trimRet = (0, $4173df58bd33d0e9$export$5be79a0015c5ab12)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split('.');
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || '0';
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $9O7LJ.default)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? '-' : '';
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, '0');
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, '0'));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "cal",
            value: function cal(offset, calculator, calDecimalLen) {
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
                var nextDecimalLength = calDecimalLen(maxDecimalLength);
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $4173df58bd33d0e9$export$5be79a0015c5ab12)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, '0'));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                return this.cal(offset, function(num1, num2) {
                    return num1 + num2;
                }, function(len) {
                    return len;
                });
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = new BigIntDecimal(value);
                if (this.isInvalidate() || target.isInvalidate()) return new BigIntDecimal(NaN);
                return this.cal(target, function(num1, num2) {
                    return num1 * num2;
                }, function(len) {
                    return len * 2;
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, $4173df58bd33d0e9$export$5be79a0015c5ab12)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();



var $klxbl = parcelRequire("klxbl");

var $9O7LJ = parcelRequire("9O7LJ");

var $eq8kl = parcelRequire("eq8kl");

/**
 * We can remove this when IE not support anymore
 */ var $6a9e4deedfc11f7a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $klxbl.default)(this, NumberDecimal);
        (0, $eq8kl.default)(this, "origin", '');
        (0, $eq8kl.default)(this, "number", void 0);
        (0, $eq8kl.default)(this, "empty", void 0);
        if ((0, $4173df58bd33d0e9$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $9O7LJ.default)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $4173df58bd33d0e9$export$2e56483e4ad90ee6)(this.number), (0, $4173df58bd33d0e9$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = Number(value);
                if (this.isInvalidate() || Number.isNaN(target)) return new NumberDecimal(NaN);
                var number = this.number * target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $4173df58bd33d0e9$export$2e56483e4ad90ee6)(this.number), (0, $4173df58bd33d0e9$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, $4173df58bd33d0e9$export$fdc98affa95a4322)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();




function $b1954095092e8bf0$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $533f2472ab8c966e$export$d5c7b2f63580e8f5)()) return new (0, $a0c49beee3ffe6ef$export$2e2bcd8739ae039)(value);
    return new (0, $6a9e4deedfc11f7a$export$2e2bcd8739ae039)(value);
}
function $b1954095092e8bf0$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === '') return '';
    var _trimNumber = (0, $4173df58bd33d0e9$export$5be79a0015c5ab12)(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $b1954095092e8bf0$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat('0'.repeat(precision)).concat(10 - advancedNum));
            return $b1954095092e8bf0$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, '0').slice(0, precision));
    }
    if (precisionDecimalStr === '.0') return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}



var $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039 = (0, $b1954095092e8bf0$export$2e2bcd8739ae039);



var $giSak = parcelRequire("giSak");
parcelRequire("29zSp");
var $lCJre = parcelRequire("lCJre");

var $jLTp6 = parcelRequire("jLTp6");
/**
 * Proxy object if environment supported
 */ function $362f285bc57cac42$export$2e2bcd8739ae039(obj, extendProps) {
    if (typeof Proxy !== 'undefined' && obj) return new Proxy(obj, {
        get: function get(target, prop) {
            if (extendProps[prop]) return extendProps[prop];
            // Proxy origin property
            var originProp = target[prop];
            return typeof originProp === 'function' ? originProp.bind(target) : originProp;
        }
    });
    return obj;
}



var $1cfGC = parcelRequire("1cfGC");

var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");

var $2bFmQ = parcelRequire("2bFmQ");
function $3370772a782feb67$export$2e2bcd8739ae039(input, focused) {
    var selectionRef = (0, $jMaZ8.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            var start = input.selectionStart, end = input.selectionEnd, value = input.value;
            var beforeTxt = value.substring(0, start);
            var afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            var value = input.value;
            var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
            var startPos = value.length;
            if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else {
                var beforeLastChar = beforeTxt[start - 1];
                var newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $2bFmQ.default)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}



var $hH60s = parcelRequire("hH60s");

var $eq8kl = parcelRequire("eq8kl");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");


var $jLTp6 = parcelRequire("jLTp6");
/**
 * Hook to detect if the user is on a mobile device
 * Notice that this hook will only detect the device type in effect, so it will always be false in server side
 */ var $2a16faf6a8aeb676$var$useMobile = function useMobile() {
    var _useState = (0, $jMaZ8.useState)(false), _useState2 = (0, $3fkx6.default)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $jLTp6.default)(function() {
        setMobile((0, $e5dc72d643143115$export$2e2bcd8739ae039)());
    }, []);
    return mobile;
};
var $2a16faf6a8aeb676$export$2e2bcd8739ae039 = $2a16faf6a8aeb676$var$useMobile;



var $aZxvk = parcelRequire("aZxvk");
/**
 * When click and hold on a button - the speed of auto changing the value.
 */ var $64cc10bc37285efb$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ var $64cc10bc37285efb$var$STEP_DELAY = 600;
function $64cc10bc37285efb$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
    // ======================== Step ========================
    var stepTimeoutRef = $jMaZ8.useRef();
    var frameIds = $jMaZ8.useRef([]);
    var onStepRef = $jMaZ8.useRef();
    onStepRef.current = onStep;
    var onStopStep = function onStopStep() {
        clearTimeout(stepTimeoutRef.current);
    };
    // We will interval update step when hold mouse down
    var onStepMouseDown = function onStepMouseDown(e, up) {
        e.preventDefault();
        onStopStep();
        onStepRef.current(up);
        // Loop step for interval
        function loopStep() {
            onStepRef.current(up);
            stepTimeoutRef.current = setTimeout(loopStep, $64cc10bc37285efb$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $64cc10bc37285efb$var$STEP_DELAY);
    };
    $jMaZ8.useEffect(function() {
        return function() {
            onStopStep();
            frameIds.current.forEach(function(id) {
                return (0, $aZxvk.default).cancel(id);
            });
        };
    }, []);
    // ======================= Render =======================
    var isMobile = (0, $2a16faf6a8aeb676$export$2e2bcd8739ae039)();
    if (isMobile) return null;
    var handlerClassName = "".concat(prefixCls, "-handler");
    var upClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(handlerClassName, "".concat(handlerClassName, "-up"), (0, $eq8kl.default)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
    var downClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(handlerClassName, "".concat(handlerClassName, "-down"), (0, $eq8kl.default)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
    // fix: https://github.com/ant-design/ant-design/issues/43088
    // In Safari, When we fire onmousedown and onmouseup events in quick succession, 
    // there may be a problem that the onmouseup events are executed first, 
    // resulting in a disordered program execution.
    // So, we need to use requestAnimationFrame to ensure that the onmouseup event is executed after the onmousedown event.
    var safeOnStopStep = function safeOnStopStep() {
        return frameIds.current.push((0, $aZxvk.default)(onStopStep));
    };
    var sharedHandlerProps = {
        unselectable: 'on',
        role: 'button',
        onMouseUp: safeOnStopStep,
        onMouseLeave: safeOnStopStep
    };
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(handlerClassName, "-wrap")
    }, /*#__PURE__*/ $jMaZ8.createElement("span", (0, $hH60s.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, true);
        },
        "aria-label": "Increase Value",
        "aria-disabled": upDisabled,
        className: upClassName
    }), upNode || /*#__PURE__*/ $jMaZ8.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-up-inner")
    })), /*#__PURE__*/ $jMaZ8.createElement("span", (0, $hH60s.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, false);
        },
        "aria-label": "Decrease Value",
        "aria-disabled": downDisabled,
        className: downClassName
    }), downNode || /*#__PURE__*/ $jMaZ8.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-down-inner")
    })));
}



function $453e56dfe555eb74$export$d2883c6c6307c415(step) {
    var stepStr = typeof step === 'number' ? (0, $4173df58bd33d0e9$export$fdc98affa95a4322)(step) : (0, $4173df58bd33d0e9$export$5be79a0015c5ab12)(step).fullStr;
    var hasPoint = stepStr.includes('.');
    if (!hasPoint) return step + '0';
    return (0, $4173df58bd33d0e9$export$5be79a0015c5ab12)(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}



var $lULOl = parcelRequire("lULOl");

var $jMaZ8 = parcelRequire("jMaZ8");

var $aZxvk = parcelRequire("aZxvk");
var /**
 * Always trigger latest once when call multiple time
 */ $32dae1b30c4688e0$export$2e2bcd8739ae039 = function() {
    var idRef = (0, $jMaZ8.useRef)(0);
    var cleanUp = function cleanUp() {
        (0, $aZxvk.default).cancel(idRef.current);
    };
    (0, $jMaZ8.useEffect)(function() {
        return cleanUp;
    }, []);
    return function(callback) {
        cleanUp();
        idRef.current = (0, $aZxvk.default)(function() {
            callback();
        });
    };
};


var $a57d8112f2510291$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "min",
    "max",
    "step",
    "defaultValue",
    "value",
    "disabled",
    "readOnly",
    "upHandler",
    "downHandler",
    "keyboard",
    "changeOnWheel",
    "controls",
    "classNames",
    "stringMode",
    "parser",
    "formatter",
    "precision",
    "decimalSeparator",
    "onChange",
    "onInput",
    "onPressEnter",
    "onStep",
    "changeOnBlur",
    "domRef"
], $a57d8112f2510291$var$_excluded2 = [
    "disabled",
    "style",
    "prefixCls",
    "value",
    "prefix",
    "suffix",
    "addonBefore",
    "addonAfter",
    "className",
    "classNames"
];
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ var $a57d8112f2510291$var$getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
var $a57d8112f2510291$var$getDecimalIfValidate = function getDecimalIfValidate(value) {
    var decimal = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(value);
    return decimal.isInvalidate() ? null : decimal;
};
var $a57d8112f2510291$var$InternalInputNumber = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, _props$changeOnWheel = props.changeOnWheel, changeOnWheel = _props$changeOnWheel === void 0 ? false : _props$changeOnWheel, _props$controls = props.controls, controls = _props$controls === void 0 ? true : _props$controls, classNames = props.classNames, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, _props$changeOnBlur = props.changeOnBlur, changeOnBlur = _props$changeOnBlur === void 0 ? true : _props$changeOnBlur, domRef = props.domRef, inputProps = (0, $4b02Q.default)(props, $a57d8112f2510291$var$_excluded);
    var inputClassName = "".concat(prefixCls, "-input");
    var inputRef = $jMaZ8.useRef(null);
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
    var userTypingRef = $jMaZ8.useRef(false);
    var compositionRef = $jMaZ8.useRef(false);
    var shiftKeyRef = $jMaZ8.useRef(false);
    // ============================ Value =============================
    // Real value control
    var _React$useState3 = $jMaZ8.useState(function() {
        return (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(value !== null && value !== void 0 ? value : defaultValue);
    }), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ var getPrecision = $jMaZ8.useCallback(function(numStr, userTyping) {
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $4173df58bd33d0e9$export$2e56483e4ad90ee6)(numStr), (0, $4173df58bd33d0e9$export$2e56483e4ad90ee6)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    var mergedParser = $jMaZ8.useCallback(function(num) {
        var numStr = String(num);
        if (parser) return parser(numStr);
        var parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, '.');
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, '');
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    var inputValueRef = $jMaZ8.useRef('');
    var mergedFormatter = $jMaZ8.useCallback(function(number, userTyping) {
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        var str = typeof number === 'number' ? (0, $4173df58bd33d0e9$export$fdc98affa95a4322)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            var mergedPrecision = getPrecision(str, userTyping);
            if ((0, $4173df58bd33d0e9$export$b3d198e17b370bec)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                var separatorStr = decimalSeparator || '.';
                str = (0, $b1954095092e8bf0$export$a81f732198733497)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ var _React$useState5 = $jMaZ8.useState(function() {
        var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
        if (decimalValue.isInvalidate() && [
            'string',
            'number'
        ].includes((0, $1Esi2.default)(initValue))) return Number.isNaN(initValue) ? '' : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    }), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    var maxDecimal = $jMaZ8.useMemo(function() {
        return $a57d8112f2510291$var$getDecimalIfValidate(max);
    }, [
        max,
        precision
    ]);
    var minDecimal = $jMaZ8.useMemo(function() {
        return $a57d8112f2510291$var$getDecimalIfValidate(min);
    }, [
        min,
        precision
    ]);
    var upDisabled = $jMaZ8.useMemo(function() {
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    var downDisabled = $jMaZ8.useMemo(function() {
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    var _useCursor = (0, $3370772a782feb67$export$2e2bcd8739ae039)(inputRef.current, focus), _useCursor2 = (0, $3fkx6.default)(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ var getRangeValue = function getRangeValue(target) {
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ var isInRange = function isInRange(target) {
        return !getRangeValue(target);
    };
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
        var updateValue = newValue;
        var isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            var numStr = updateValue.toString();
            var mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)((0, $b1954095092e8bf0$export$a81f732198733497)(numStr, '.', mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)((0, $b1954095092e8bf0$export$a81f732198733497)(numStr, '.', mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : $a57d8112f2510291$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    var onNextPromise = (0, $32dae1b30c4688e0$export$2e2bcd8739ae039)();
    // >>> Collect input value
    var collectInputValue = function collectInputValue(inputStr) {
        recordCursor();
        // Update inputValue in case input can not parse as number
        // Refresh ref value immediately since it may used by formatter
        inputValueRef.current = inputStr;
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            var finalValue = mergedParser(inputStr);
            var finalDecimal = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want to handle something after onChange
        onInput === null || onInput === void 0 || onInput(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(function() {
            var nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, '.');
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    var onCompositionStart = function onCompositionStart() {
        compositionRef.current = true;
    };
    var onCompositionEnd = function onCompositionEnd() {
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    var onInternalInput = function onInternalInput(e) {
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    var onInternalStep = function onInternalStep(up) {
        var _inputRef$current;
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may be caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        var stepDecimal = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(shiftKeyRef.current ? (0, $453e56dfe555eb74$export$d2883c6c6307c415)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        var target = (decimalValue || (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(0)).add(stepDecimal.toString());
        var updatedValue = triggerValueUpdate(target, false);
        onStep === null || onStep === void 0 || onStep($a57d8112f2510291$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $453e56dfe555eb74$export$d2883c6c6307c415)(step) : step,
            type: up ? 'up' : 'down'
        });
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    };
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed.
   * This will always flush input value for update.
   * If it's invalidate, will fallback to last validate value.
   */ var flushInputValue = function flushInputValue(userTyping) {
        var parsedValue = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(mergedParser(inputValue));
        var formatValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = triggerValueUpdate(decimalValue, userTyping);
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    var onBeforeInput = function onBeforeInput() {
        userTypingRef.current = true;
    };
    var onKeyDown = function onKeyDown(event) {
        var key = event.key, shiftKey = event.shiftKey;
        userTypingRef.current = true;
        shiftKeyRef.current = shiftKey;
        if (key === 'Enter') {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            'Up',
            'ArrowUp',
            'Down',
            'ArrowDown'
        ].includes(key)) {
            onInternalStep(key === 'Up' || key === 'ArrowUp');
            event.preventDefault();
        }
    };
    var onKeyUp = function onKeyUp() {
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    $jMaZ8.useEffect(function() {
        if (changeOnWheel && focus) {
            var onWheel = function onWheel(event) {
                // moving mouse wheel rises wheel event with deltaY < 0
                // scroll value grows from top to bottom, as screen Y coordinate
                onInternalStep(event.deltaY < 0);
                event.preventDefault();
            };
            var input = inputRef.current;
            if (input) {
                // React onWheel is passive and we can't preventDefault() in it.
                // That's why we should subscribe with DOM listener
                // https://stackoverflow.com/questions/63663025/react-onwheel-handler-cant-preventdefault-because-its-a-passive-event-listenev
                input.addEventListener('wheel', onWheel, {
                    passive: false
                });
                return function() {
                    return input.removeEventListener('wheel', onWheel);
                };
            }
        }
    });
    // >>> Focus & Blur
    var onBlur = function onBlur() {
        if (changeOnBlur) flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // ========================== Controlled ==========================
    // Input by precision & formatter
    (0, $jLTp6.useLayoutUpdateEffect)(function() {
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision,
        formatter
    ]);
    // Input by value
    (0, $jLTp6.useLayoutUpdateEffect)(function() {
        var newValue = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(value);
        setDecimalValue(newValue);
        var currentParsedValue = (0, $b2dd1b7c3d04c5a7$export$2e2bcd8739ae039)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $jLTp6.useLayoutUpdateEffect)(function() {
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: domRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-focused"), focus), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-readonly"), readOnly), "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue))),
        style: style,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, controls && /*#__PURE__*/ $jMaZ8.createElement((0, $64cc10bc37285efb$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        upNode: upHandler,
        downNode: downHandler,
        upDisabled: upDisabled,
        downDisabled: downDisabled,
        onStep: onInternalStep
    }), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(inputClassName, "-wrap")
    }, /*#__PURE__*/ $jMaZ8.createElement("input", (0, $hH60s.default)({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step
    }, inputProps, {
        ref: (0, $1cfGC.composeRef)(inputRef, ref),
        className: inputClassName,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }))));
});
var $a57d8112f2510291$var$InputNumber = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var disabled = props.disabled, style = props.style, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input-number' : _props$prefixCls, value = props.value, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, classNames = props.classNames, rest = (0, $4b02Q.default)(props, $a57d8112f2510291$var$_excluded2);
    var holderRef = $jMaZ8.useRef(null);
    var inputNumberDomRef = $jMaZ8.useRef(null);
    var inputFocusRef = $jMaZ8.useRef(null);
    var focus = function focus(option) {
        if (inputFocusRef.current) (0, $lULOl.triggerFocus)(inputFocusRef.current, option);
    };
    $jMaZ8.useImperativeHandle(ref, function() {
        return (0, $362f285bc57cac42$export$2e2bcd8739ae039)(inputFocusRef.current, {
            focus: focus,
            nativeElement: holderRef.current.nativeElement || inputNumberDomRef.current
        });
    });
    return /*#__PURE__*/ $jMaZ8.createElement((0, $lCJre.default), {
        className: className,
        triggerFocus: focus,
        prefixCls: prefixCls,
        value: value,
        disabled: disabled,
        style: style,
        prefix: prefix,
        suffix: suffix,
        addonAfter: addonAfter,
        addonBefore: addonBefore,
        classNames: classNames,
        components: {
            affixWrapper: 'div',
            groupWrapper: 'div',
            wrapper: 'div',
            groupAddon: 'div'
        },
        ref: holderRef
    }, /*#__PURE__*/ $jMaZ8.createElement($a57d8112f2510291$var$InternalInputNumber, (0, $hH60s.default)({
        prefixCls: prefixCls,
        disabled: disabled,
        ref: inputFocusRef,
        domRef: inputNumberDomRef,
        className: classNames === null || classNames === void 0 ? void 0 : classNames.input
    }, rest)));
});
$a57d8112f2510291$var$InputNumber.displayName = 'InputNumber';
var $a57d8112f2510291$export$2e2bcd8739ae039 = $a57d8112f2510291$var$InputNumber;


var $d241836c8bf6673b$export$2e2bcd8739ae039 = (0, $a57d8112f2510291$export$2e2bcd8739ae039);












parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");




parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

const $20e1ee4651e2587c$export$9ca1be8807fe0675 = (token)=>{
    var _a;
    const handleVisible = (_a = token.handleVisible) !== null && _a !== void 0 ? _a : 'auto';
    const handleWidth = token.controlHeightSM - token.lineWidth * 2;
    return Object.assign(Object.assign({}, (0, $10e799cdff4a390c$export$bd8b682992bc9781)(token)), {
        controlWidth: 90,
        handleWidth: handleWidth,
        handleFontSize: token.fontSize / 2,
        handleVisible: handleVisible,
        handleActiveBg: token.colorFillAlter,
        handleBg: token.colorBgContainer,
        filledHandleBg: new (0, $6xABB.FastColor)(token.colorFillSecondary).onBackground(token.colorBgContainer).toHexString(),
        handleHoverColor: token.colorPrimary,
        handleBorderColor: token.colorBorder,
        handleOpacity: handleVisible === true ? 1 : 0,
        handleVisibleWidth: handleVisible === true ? handleWidth : 0
    });
};


const $a110fe667f7d5dcc$export$b6107fb2af1bfc36 = (_ref, size)=>{
    let { componentCls: componentCls, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG } = _ref;
    const borderRadius = size === 'lg' ? borderRadiusLG : borderRadiusSM;
    return {
        [`&-${size}`]: {
            [`${componentCls}-handler-wrap`]: {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            [`${componentCls}-handler-up`]: {
                borderStartEndRadius: borderRadius
            },
            [`${componentCls}-handler-down`]: {
                borderEndEndRadius: borderRadius
            }
        }
    };
};
const $a110fe667f7d5dcc$var$genInputNumberStyles = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, borderRadius: borderRadius, inputFontSizeSM: inputFontSizeSM, inputFontSizeLG: inputFontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, colorError: colorError, paddingInlineSM: paddingInlineSM, paddingBlockSM: paddingBlockSM, paddingBlockLG: paddingBlockLG, paddingInlineLG: paddingInlineLG, colorTextDescription: colorTextDescription, motionDurationMid: motionDurationMid, handleHoverColor: handleHoverColor, handleOpacity: handleOpacity, paddingInline: paddingInline, paddingBlock: paddingBlock, handleBg: handleBg, handleActiveBg: handleActiveBg, colorTextDisabled: colorTextDisabled, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, controlWidth: controlWidth, handleBorderColor: handleBorderColor, filledHandleBg: filledHandleBg, lineHeightLG: lineHeightLG, calc: calc } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), (0, $47d23157ef40b741$export$8c9a381315f3ebcd)(token)), {
                display: 'inline-block',
                width: controlWidth,
                margin: 0,
                padding: 0,
                borderRadius: borderRadius
            }), (0, $e02010b1a8d4cc87$export$53795bafd774ce02)(token, {
                [`${componentCls}-handler-wrap`]: {
                    background: handleBg,
                    [`${componentCls}-handler-down`]: {
                        borderBlockStart: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${handleBorderColor}`
                    }
                }
            })), (0, $e02010b1a8d4cc87$export$b8365cd7e6671d79)(token, {
                [`${componentCls}-handler-wrap`]: {
                    background: filledHandleBg,
                    [`${componentCls}-handler-down`]: {
                        borderBlockStart: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${handleBorderColor}`
                    }
                },
                '&:focus-within': {
                    [`${componentCls}-handler-wrap`]: {
                        background: handleBg
                    }
                }
            })), (0, $e02010b1a8d4cc87$export$b6de5da7f39edfcb)(token)), {
                '&-rtl': {
                    direction: 'rtl',
                    [`${componentCls}-input`]: {
                        direction: 'rtl'
                    }
                },
                '&-lg': {
                    padding: 0,
                    fontSize: inputFontSizeLG,
                    lineHeight: lineHeightLG,
                    borderRadius: borderRadiusLG,
                    [`input${componentCls}-input`]: {
                        height: calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal(),
                        padding: `${(0, $4g3I0.unit)(paddingBlockLG)} ${(0, $4g3I0.unit)(paddingInlineLG)}`
                    }
                },
                '&-sm': {
                    padding: 0,
                    fontSize: inputFontSizeSM,
                    borderRadius: borderRadiusSM,
                    [`input${componentCls}-input`]: {
                        height: calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal(),
                        padding: `${(0, $4g3I0.unit)(paddingBlockSM)} ${(0, $4g3I0.unit)(paddingInlineSM)}`
                    }
                },
                // ===================== Out Of Range =====================
                '&-out-of-range': {
                    [`${componentCls}-input-wrap`]: {
                        input: {
                            color: colorError
                        }
                    }
                },
                // Style for input-group: input with label, with button or dropdown...
                '&-group': Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), (0, $47d23157ef40b741$export$ffe8b2a9bd2e5cfe)(token)), {
                    '&-wrapper': Object.assign(Object.assign(Object.assign({
                        display: 'inline-block',
                        textAlign: 'start',
                        verticalAlign: 'top',
                        [`${componentCls}-affix-wrapper`]: {
                            width: '100%'
                        },
                        // Size
                        '&-lg': {
                            [`${componentCls}-group-addon`]: {
                                borderRadius: borderRadiusLG,
                                fontSize: token.fontSizeLG
                            }
                        },
                        '&-sm': {
                            [`${componentCls}-group-addon`]: {
                                borderRadius: borderRadiusSM
                            }
                        }
                    }, (0, $e02010b1a8d4cc87$export$8f88f32c046ff727)(token)), (0, $e02010b1a8d4cc87$export$542c0fce51b1d515)(token)), {
                        // Fix the issue of using icons in Space Compact mode
                        // https://github.com/ant-design/ant-design/issues/45764
                        [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                            [`${componentCls}, ${componentCls}-group-addon`]: {
                                borderRadius: 0
                            }
                        },
                        [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                            [`${componentCls}, ${componentCls}-group-addon`]: {
                                borderStartEndRadius: 0,
                                borderEndEndRadius: 0
                            }
                        },
                        [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                            [`${componentCls}, ${componentCls}-group-addon`]: {
                                borderStartStartRadius: 0,
                                borderEndStartRadius: 0
                            }
                        }
                    })
                }),
                [`&-disabled ${componentCls}-input`]: {
                    cursor: 'not-allowed'
                },
                [componentCls]: {
                    '&-input': Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
                        width: '100%',
                        padding: `${(0, $4g3I0.unit)(paddingBlock)} ${(0, $4g3I0.unit)(paddingInline)}`,
                        textAlign: 'start',
                        backgroundColor: 'transparent',
                        border: 0,
                        borderRadius: borderRadius,
                        outline: 0,
                        transition: `all ${motionDurationMid} linear`,
                        appearance: 'textfield',
                        fontSize: 'inherit'
                    }), (0, $47d23157ef40b741$export$92095d0f4c77bd56)(token.colorTextPlaceholder)), {
                        '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
                            margin: 0,
                            webkitAppearance: 'none',
                            appearance: 'none'
                        }
                    })
                },
                [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
                    width: token.handleWidth,
                    opacity: 1
                }
            })
        },
        // Handler
        {
            [componentCls]: Object.assign(Object.assign(Object.assign({
                [`${componentCls}-handler-wrap`]: {
                    position: 'absolute',
                    insetBlockStart: 0,
                    insetInlineEnd: 0,
                    width: token.handleVisibleWidth,
                    opacity: handleOpacity,
                    height: '100%',
                    borderStartStartRadius: 0,
                    borderStartEndRadius: borderRadius,
                    borderEndEndRadius: borderRadius,
                    borderEndStartRadius: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    transition: `all ${motionDurationMid}`,
                    overflow: 'hidden',
                    // Fix input number inside Menu makes icon too large
                    // We arise the selector priority by nest selector here
                    // https://github.com/ant-design/ant-design/issues/14367
                    [`${componentCls}-handler`]: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 'auto',
                        height: '40%',
                        [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
                            marginInlineEnd: 0,
                            fontSize: token.handleFontSize
                        }
                    }
                },
                [`${componentCls}-handler`]: {
                    height: '50%',
                    overflow: 'hidden',
                    color: colorTextDescription,
                    fontWeight: 'bold',
                    lineHeight: 0,
                    textAlign: 'center',
                    cursor: 'pointer',
                    borderInlineStart: `${(0, $4g3I0.unit)(lineWidth)} ${lineType} ${handleBorderColor}`,
                    transition: `all ${motionDurationMid} linear`,
                    '&:active': {
                        background: handleActiveBg
                    },
                    // Hover
                    '&:hover': {
                        height: `60%`,
                        [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
                            color: handleHoverColor
                        }
                    },
                    '&-up-inner, &-down-inner': Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$171ccda7bc085e59)()), {
                        color: colorTextDescription,
                        transition: `all ${motionDurationMid} linear`,
                        userSelect: 'none'
                    })
                },
                [`${componentCls}-handler-up`]: {
                    borderStartEndRadius: borderRadius
                },
                [`${componentCls}-handler-down`]: {
                    borderEndEndRadius: borderRadius
                }
            }, $a110fe667f7d5dcc$export$b6107fb2af1bfc36(token, 'lg')), $a110fe667f7d5dcc$export$b6107fb2af1bfc36(token, 'sm')), {
                // Disabled
                '&-disabled, &-readonly': {
                    [`${componentCls}-handler-wrap`]: {
                        display: 'none'
                    },
                    [`${componentCls}-input`]: {
                        color: 'inherit'
                    }
                },
                [`
          ${componentCls}-handler-up-disabled,
          ${componentCls}-handler-down-disabled
        `]: {
                    cursor: 'not-allowed'
                },
                [`
          ${componentCls}-handler-up-disabled:hover &-handler-up-inner,
          ${componentCls}-handler-down-disabled:hover &-handler-down-inner
        `]: {
                    color: colorTextDisabled
                }
            })
        }
    ];
};
const $a110fe667f7d5dcc$var$genAffixWrapperStyles = (token)=>{
    const { componentCls: componentCls, paddingBlock: paddingBlock, paddingInline: paddingInline, inputAffixPadding: inputAffixPadding, controlWidth: controlWidth, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, paddingInlineLG: paddingInlineLG, paddingInlineSM: paddingInlineSM, paddingBlockLG: paddingBlockLG, paddingBlockSM: paddingBlockSM, motionDurationMid: motionDurationMid } = token;
    return {
        [`${componentCls}-affix-wrapper`]: Object.assign(Object.assign({
            [`input${componentCls}-input`]: {
                padding: `${(0, $4g3I0.unit)(paddingBlock)} 0`
            }
        }, (0, $47d23157ef40b741$export$8c9a381315f3ebcd)(token)), {
            // or number handler will cover form status
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            width: controlWidth,
            padding: 0,
            paddingInlineStart: paddingInline,
            '&-lg': {
                borderRadius: borderRadiusLG,
                paddingInlineStart: paddingInlineLG,
                [`input${componentCls}-input`]: {
                    padding: `${(0, $4g3I0.unit)(paddingBlockLG)} 0`
                }
            },
            '&-sm': {
                borderRadius: borderRadiusSM,
                paddingInlineStart: paddingInlineSM,
                [`input${componentCls}-input`]: {
                    padding: `${(0, $4g3I0.unit)(paddingBlockSM)} 0`
                }
            },
            [`&:not(${componentCls}-disabled):hover`]: {
                zIndex: 1
            },
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`&-disabled > ${componentCls}-disabled`]: {
                background: 'transparent'
            },
            [`> div${componentCls}`]: {
                width: '100%',
                border: 'none',
                outline: 'none',
                [`&${componentCls}-focused`]: {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [`${componentCls}-handler-wrap`]: {
                zIndex: 2
            },
            [componentCls]: {
                position: 'static',
                color: 'inherit',
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    pointerEvents: 'none'
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    insetBlockStart: 0,
                    insetInlineEnd: 0,
                    height: '100%',
                    marginInlineEnd: paddingInline,
                    marginInlineStart: inputAffixPadding,
                    transition: `margin ${motionDurationMid}`
                }
            },
            [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
                width: token.handleWidth,
                opacity: 1
            },
            [`&:not(${componentCls}-affix-wrapper-without-controls):hover ${componentCls}-suffix`]: {
                marginInlineEnd: token.calc(token.handleWidth).add(paddingInline).equal()
            }
        })
    };
};
var $a110fe667f7d5dcc$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('InputNumber', (token)=>{
    const inputNumberToken = (0, $8APUt.merge)(token, (0, $10e799cdff4a390c$export$a157d95850191a12)(token));
    return [
        $a110fe667f7d5dcc$var$genInputNumberStyles(inputNumberToken),
        $a110fe667f7d5dcc$var$genAffixWrapperStyles(inputNumberToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $2bdaa96870b686b7$export$b1208b23589b4b73)(inputNumberToken)
    ];
}, (0, $20e1ee4651e2587c$export$9ca1be8807fe0675), {
    unitless: {
        handleOpacity: true
    }
});


"use client";
var $ae109c92c4bd559f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ae109c92c4bd559f$var$InputNumber = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    {
        const typeWarning = (0, $e55cfce129297019$export$cf977aa92c751e61)('InputNumber');
        typeWarning.deprecated(!('bordered' in props), 'bordered', 'variant');
        typeWarning(!(props.type === 'number' && props.changeOnWheel), 'usage', 'When `type=number` is used together with `changeOnWheel`, changeOnWheel may not work properly. Please delete `type=number` if it is not necessary.');
    }
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const inputRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, ()=>inputRef.current);
    const { className: className, rootClassName: rootClassName, size: customizeSize, disabled: customDisabled, prefixCls: customizePrefixCls, addonBefore: addonBefore, addonAfter: addonAfter, prefix: prefix, suffix: suffix, bordered: bordered, readOnly: readOnly, status: customStatus, controls: controls, variant: customVariant } = props, others = $ae109c92c4bd559f$var$__rest(props, [
        "className",
        "rootClassName",
        "size",
        "disabled",
        "prefixCls",
        "addonBefore",
        "addonAfter",
        "prefix",
        "suffix",
        "bordered",
        "readOnly",
        "status",
        "controls",
        "variant"
    ]);
    const prefixCls = getPrefixCls('input-number', customizePrefixCls);
    // Style
    const rootCls = (0, $aecc7c07ac00a064$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $a110fe667f7d5dcc$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $b481086641a221d4$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    let upIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $03ce425ee205cd8c$export$2e2bcd8739ae039), {
        className: `${prefixCls}-handler-up-inner`
    });
    let downIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $159430c34bfeb8bb$export$2e2bcd8739ae039), {
        className: `${prefixCls}-handler-down-inner`
    });
    const controlsTemp = typeof controls === 'boolean' ? controls : undefined;
    if (typeof controls === 'object') {
        upIcon = typeof controls.upIcon === 'undefined' ? upIcon : /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: `${prefixCls}-handler-up-inner`
        }, controls.upIcon);
        downIcon = typeof controls.downIcon === 'undefined' ? downIcon : /*#__PURE__*/ $jMaZ8.createElement("span", {
            className: `${prefixCls}-handler-down-inner`
        }, controls.downIcon);
    }
    const { hasFeedback: hasFeedback, status: contextStatus, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $jMaZ8.useContext((0, $ee23d3c241510852$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $8d2ac7a62116451d$export$314e193082d7ba49)(contextStatus, customStatus);
    const mergedSize = (0, $ddebbaa055df4f38$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = $jMaZ8.useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const [variant, enableVariantCls] = (0, $6883392ce3b89ee5$export$2e2bcd8739ae039)('inputNumber', customVariant, bordered);
    const suffixNode = hasFeedback && /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, feedbackIcon);
    const inputNumberClass = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, hashId);
    const wrapperClassName = `${prefixCls}-group`;
    const element = /*#__PURE__*/ $jMaZ8.createElement((0, $d241836c8bf6673b$export$2e2bcd8739ae039), Object.assign({
        ref: inputRef,
        disabled: mergedDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(cssVarCls, rootCls, className, rootClassName, compactItemClassnames),
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp,
        prefix: prefix,
        suffix: suffixNode || suffix,
        addonBefore: addonBefore && /*#__PURE__*/ $jMaZ8.createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ $jMaZ8.createElement((0, $1f8ddc944c83959d$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            input: inputNumberClass,
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $8d2ac7a62116451d$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-without-controls`]: controls === false
            }, hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${wrapperClassName}-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $8d2ac7a62116451d$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    }, others));
    return wrapCSSVar(element);
});
const $ae109c92c4bd559f$var$TypedInputNumber = $ae109c92c4bd559f$var$InputNumber;
/** @private Internal Component. Do not use in your production. */ const $ae109c92c4bd559f$var$PureInputNumber = (props)=>/*#__PURE__*/ $jMaZ8.createElement((0, $cf928c204584b9b8$export$2e2bcd8739ae039), {
        theme: {
            components: {
                InputNumber: {
                    handleVisible: true
                }
            }
        }
    }, /*#__PURE__*/ $jMaZ8.createElement($ae109c92c4bd559f$var$InputNumber, Object.assign({}, props)));
$ae109c92c4bd559f$var$TypedInputNumber.displayName = 'InputNumber';
$ae109c92c4bd559f$var$TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = $ae109c92c4bd559f$var$PureInputNumber;
var $ae109c92c4bd559f$export$2e2bcd8739ae039 = $ae109c92c4bd559f$var$TypedInputNumber;



var $jMaZ8 = parcelRequire("jMaZ8");

var $57c9cb049f914779$exports = {};

$parcel$export($57c9cb049f914779$exports, "existingContainer", () => $57c9cb049f914779$export$d60039a9e6aa939e, (v) => $57c9cb049f914779$export$d60039a9e6aa939e = v);
$parcel$export($57c9cb049f914779$exports, "pageBar", () => $57c9cb049f914779$export$a1c41f1f4b6677ac, (v) => $57c9cb049f914779$export$a1c41f1f4b6677ac = v);
$parcel$export($57c9cb049f914779$exports, "addingMute", () => $57c9cb049f914779$export$54b4b77045e2d1d9, (v) => $57c9cb049f914779$export$54b4b77045e2d1d9 = v);
$parcel$export($57c9cb049f914779$exports, "fontSize", () => $57c9cb049f914779$export$85e3c3ca0c6fb93, (v) => $57c9cb049f914779$export$85e3c3ca0c6fb93 = v);
$parcel$export($57c9cb049f914779$exports, "goToPage", () => $57c9cb049f914779$export$2030325fa3271ef7, (v) => $57c9cb049f914779$export$2030325fa3271ef7 = v);
$parcel$export($57c9cb049f914779$exports, "bookIcon", () => $57c9cb049f914779$export$73acc798a0ce22c5, (v) => $57c9cb049f914779$export$73acc798a0ce22c5 = v);
$parcel$export($57c9cb049f914779$exports, "popoverGoTo", () => $57c9cb049f914779$export$62f7b0332d17833f, (v) => $57c9cb049f914779$export$62f7b0332d17833f = v);
$parcel$export($57c9cb049f914779$exports, "popoverGoToSpanCount", () => $57c9cb049f914779$export$c9eb802655067bbc, (v) => $57c9cb049f914779$export$c9eb802655067bbc = v);
var $57c9cb049f914779$export$d60039a9e6aa939e;
var $57c9cb049f914779$export$a1c41f1f4b6677ac;
var $57c9cb049f914779$export$54b4b77045e2d1d9;
var $57c9cb049f914779$export$85e3c3ca0c6fb93;
var $57c9cb049f914779$export$2030325fa3271ef7;
var $57c9cb049f914779$export$73acc798a0ce22c5;
var $57c9cb049f914779$export$62f7b0332d17833f;
var $57c9cb049f914779$export$c9eb802655067bbc;
$57c9cb049f914779$export$d60039a9e6aa939e = "existingContainer_10bbf2";
$57c9cb049f914779$export$a1c41f1f4b6677ac = "pageBar_10bbf2";
$57c9cb049f914779$export$54b4b77045e2d1d9 = "addingMute_10bbf2";
$57c9cb049f914779$export$85e3c3ca0c6fb93 = "fontSize_10bbf2";
$57c9cb049f914779$export$2030325fa3271ef7 = "goToPage_10bbf2";
$57c9cb049f914779$export$73acc798a0ce22c5 = "bookIcon_10bbf2";
$57c9cb049f914779$export$62f7b0332d17833f = "popoverGoTo_10bbf2";
$57c9cb049f914779$export$c9eb802655067bbc = "popoverGoToSpanCount_10bbf2";



parcelRequire("jMaZ8");
const $a36947445bd4d615$var$SvgMerge = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.25em",
        height: "1.25em",
        viewBox: "0 0 15 15",
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M437.789 221.443a3.775 3.775 0 0 0-5.21 0l-2.778 2.785a3.635 3.635 0 0 0-.826 1.292 3.478 3.478 0 0 0-1.257.8l-2.778 2.78a3.688 3.688 0 1 0 5.21 5.222l2.778-2.785a3.61 3.61 0 0 1 2.083-2.088l2.779-2.784a3.707 3.707 0 0 0 0-5.222Zm-7.467 5.272a2.2 2.2 0 0 1 2.207 2.212c0 .031-.008.06-.009.092a2.159 2.159 0 0 1-2.321-2.181c0-.037.01-.074.012-.111.037-.003.074-.012.111-.012Zm-1.215 6.563a2.268 2.268 0 0 1-3.125 0 2.226 2.226 0 0 1 0-3.133l2.778-2.784.017-.014a3.6 3.6 0 0 0 3.122 3.13l-.014.017Zm7.639-7.658-2.778 2.784-.017.014a3.648 3.648 0 0 0-1.025-2.1 3.594 3.594 0 0 0-2.122-1c.014-.015.024-.031.038-.046l2.778-2.784a2.213 2.213 0 0 1 3.125 3.133Z",
            transform: "translate(-423.864 -220.4)",
            style: {
                fill: "#5b6077"
            }
        })
    });
var $a36947445bd4d615$export$2e2bcd8739ae039 = $a36947445bd4d615$var$SvgMerge;



parcelRequire("jMaZ8");
const $57df5e8a6b46598e$var$SvgMutepage = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1.25em",
        viewBox: "0 0 12.17 15",
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "m491.933 342.772-.009-.032a.684.684 0 0 0-.039-.184.25.25 0 0 0-.017-.042.61.61 0 0 0-.11-.173l-3.819-3.8a.647.647 0 0 0-.187-.125.554.554 0 0 0-.06-.023.63.63 0 0 0-.168-.033l-7.1-.009a.658.658 0 0 0-.657.657V352.7a.658.658 0 0 0 .657.657h10.855a.658.658 0 0 0 .657-.657Zm-3.8-.64v-1.539l1.548 1.539Zm-7.056-2.458h5.741v3.118a.658.658 0 0 0 .657.657h3.141v8.6h-9.54Z",
            transform: "translate(-479.764 -338.357)",
            style: {
                fill: "#5b6079"
            }
        })
    });
var $57df5e8a6b46598e$export$2e2bcd8739ae039 = $57df5e8a6b46598e$var$SvgMutepage;


function $826ede1070330fc2$export$2e2bcd8739ae039({ mergePages: mergePages, addMutePages: addMutePages, pageId: pageId, isLast: isLast, mutePagesAfter: mutePagesAfter, pageNumber: pageNumber, displayedTotalPageNumber: displayedTotalPageNumber }) {
    const [isAddingMute, setIsAddingMute] = (0, $jMaZ8.useState)(false);
    const [mutePageNumber, setMutePageNumber] = (0, $jMaZ8.useState)(mutePagesAfter);
    const applyAddMutePages = (0, $jMaZ8.useCallback)(async (pageId, mutePageNumber)=>{
        await addMutePages(pageId, mutePageNumber);
        setIsAddingMute(false);
    }, [
        addMutePages
    ]);
    let content;
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.existing.index.pageBar";
    if (isAddingMute) content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($57c9cb049f914779$exports))).addingMute,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ae109c92c4bd559f$export$2e2bcd8739ae039), {
                        size: "small",
                        defaultValue: mutePageNumber,
                        onChange: (e)=>setMutePageNumber(Number(e)),
                        onPressEnter: ()=>applyAddMutePages(pageId, mutePageNumber)
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                        children: t(`${i18nKey}.mutePage`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: mutePageNumber <= 0,
                        onClick: ()=>{
                            if (mutePageNumber <= 0) return;
                            applyAddMutePages(pageId, mutePageNumber);
                        },
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c1c1d6d80357382d$export$2e2bcd8739ae039), {
                            style: {
                                color: "#61C374"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setIsAddingMute(false);
                        },
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $15b3ead07edba509$export$2e2bcd8739ae039), {
                            style: {
                                color: "#353A52"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            applyAddMutePages(pageId, 0);
                        },
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $add96a083ff0f53e$export$2e2bcd8739ae039), {
                            style: {
                                color: "#E33636"
                            }
                        })
                    })
                ]
            })
        ]
    });
    else if (mutePagesAfter > 0) content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($57c9cb049f914779$exports))).addingMute,
        onClick: ()=>setIsAddingMute(true),
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ae109c92c4bd559f$export$2e2bcd8739ae039), {
                        size: "small",
                        disabled: true,
                        defaultValue: mutePagesAfter
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                        children: t(`${i18nKey}.mutePage`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                        children: pageNumber + 1
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                        children: "->"
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                        children: pageNumber + mutePageNumber
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                        children: [
                            "/",
                            displayedTotalPageNumber
                        ]
                    })
                ]
            })
        ]
    });
    else content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("button", {
                disabled: isLast,
                onClick: ()=>mergePages(pageId),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a36947445bd4d615$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("button", {
                onClick: ()=>setIsAddingMute(true),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $57df5e8a6b46598e$export$2e2bcd8739ae039), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($57c9cb049f914779$exports))).pageBar,
        style: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: content
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
var $6b98a0a92a846b6b$var$__defProp = Object.defineProperty;
var $6b98a0a92a846b6b$var$__defNormalProp = (obj, key, value)=>key in obj ? $6b98a0a92a846b6b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6b98a0a92a846b6b$var$__publicField = (obj, key, value)=>$6b98a0a92a846b6b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $6b98a0a92a846b6b$var$observerMap = /* @__PURE__ */ new Map();
var $6b98a0a92a846b6b$var$RootIds = /* @__PURE__ */ new WeakMap();
var $6b98a0a92a846b6b$var$rootId = 0;
var $6b98a0a92a846b6b$var$unsupportedValue = void 0;
function $6b98a0a92a846b6b$export$2ef3a60ee1f37bec(inView) {
    $6b98a0a92a846b6b$var$unsupportedValue = inView;
}
function $6b98a0a92a846b6b$var$getRootId(root) {
    if (!root) return "0";
    if ($6b98a0a92a846b6b$var$RootIds.has(root)) return $6b98a0a92a846b6b$var$RootIds.get(root);
    $6b98a0a92a846b6b$var$rootId += 1;
    $6b98a0a92a846b6b$var$RootIds.set(root, $6b98a0a92a846b6b$var$rootId.toString());
    return $6b98a0a92a846b6b$var$RootIds.get(root);
}
function $6b98a0a92a846b6b$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $6b98a0a92a846b6b$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $6b98a0a92a846b6b$var$createObserver(options) {
    const id = $6b98a0a92a846b6b$var$optionsToId(options);
    let instance = $6b98a0a92a846b6b$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $6b98a0a92a846b6b$var$observerMap.set(id, instance);
    }
    return instance;
}
function $6b98a0a92a846b6b$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $6b98a0a92a846b6b$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $6b98a0a92a846b6b$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $6b98a0a92a846b6b$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $6b98a0a92a846b6b$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $6b98a0a92a846b6b$export$a62107ca74432f44 = class extends $jMaZ8.Component {
    constructor(props){
        super(props);
        $6b98a0a92a846b6b$var$__publicField(this, "node", null);
        $6b98a0a92a846b6b$var$__publicField(this, "_unobserveCb", null);
        $6b98a0a92a846b6b$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $6b98a0a92a846b6b$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$6b98a0a92a846b6b$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $6b98a0a92a846b6b$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $jMaZ8.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $6b98a0a92a846b6b$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $jMaZ8.useState(null);
    const callback = $jMaZ8.useRef(onChange);
    const [state, setState] = $jMaZ8.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $jMaZ8.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $6b98a0a92a846b6b$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $jMaZ8.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map




var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");


function $5b38bec19e3a4e47$export$81b3a8efdffa1495() {
    const { recordCurrentPage: recordCurrentPage } = (0, $e7692b166c91b9dc$export$fcd3a1f8b6eba71f)();
    return (0, $jMaZ8.useCallback)((number)=>recordCurrentPage(Number(number)), [
        recordCurrentPage
    ]);
}
function $5b38bec19e3a4e47$export$9209709357e72876(projectId, skip = false) {
    const { loading: loading, data: data, error: error } = (0, $d7188398173686a1$export$c62fb8c9967915fd)({
        variables: {
            projectId: projectId
        },
        skip: skip
    });
    const pages = (0, $jMaZ8.useMemo)(()=>data?.pages || [], [
        data
    ]);
    return {
        pages: pages,
        loading: loading,
        error: error
    };
}
const $5b38bec19e3a4e47$var$ProjectContext = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createContext(null);
const $5b38bec19e3a4e47$export$477397cba250e9af = $5b38bec19e3a4e47$var$ProjectContext.Provider;
const $5b38bec19e3a4e47$export$8f31c2503e1efa93 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext($5b38bec19e3a4e47$var$ProjectContext);
    if (!context) throw new Error("useProjectContext must be used within a ProjectProvider");
    return context;
};
function $5b38bec19e3a4e47$export$51b1383ef8844a7({ projectId: projectId, withInfo: withInfo = false, withPages: withPages = false, withAudioInfo: withAudioInfo = false }) {
    const { data: book, loading: bookLoading } = (0, $d7188398173686a1$export$6ed06f11bf137590)({
        id: projectId,
        withInfo: withInfo,
        withAudioInfo: withAudioInfo
    });
    const { pages: pages, loading: pagesLoading } = $5b38bec19e3a4e47$export$9209709357e72876(projectId, !withPages);
    return {
        project: book?.project[0],
        pages: pages,
        bookLoading: bookLoading,
        pagesLoading: pagesLoading
    };
}



var $c9f377a2e70f774c$exports = {};

var $8ce6df2981fa53a1$exports = {};

var $18oEd = parcelRequire("18oEd");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $8ce6df2981fa53a1$var$now = function() {
    return $18oEd.Date.now();
};
$8ce6df2981fa53a1$exports = $8ce6df2981fa53a1$var$now;


var $4092711f2b7c5ca2$exports = {};
var $3752e65bec72d31b$exports = {};
var $308476b1fa245a97$exports = {};
/** Used to match a single whitespace character. */ var $308476b1fa245a97$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $308476b1fa245a97$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $308476b1fa245a97$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$308476b1fa245a97$exports = $308476b1fa245a97$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3752e65bec72d31b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3752e65bec72d31b$var$baseTrim(string) {
    return string ? string.slice(0, $308476b1fa245a97$exports(string) + 1).replace($3752e65bec72d31b$var$reTrimStart, '') : string;
}
$3752e65bec72d31b$exports = $3752e65bec72d31b$var$baseTrim;




/** Used as references for various `Number` constants. */ var $4092711f2b7c5ca2$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $4092711f2b7c5ca2$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4092711f2b7c5ca2$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4092711f2b7c5ca2$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4092711f2b7c5ca2$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4092711f2b7c5ca2$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($7f7a0faba76ae5db$exports(value)) return $4092711f2b7c5ca2$var$NAN;
    if ($b638b78429ec3695$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $b638b78429ec3695$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $3752e65bec72d31b$exports(value);
    var isBinary = $4092711f2b7c5ca2$var$reIsBinary.test(value);
    return isBinary || $4092711f2b7c5ca2$var$reIsOctal.test(value) ? $4092711f2b7c5ca2$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4092711f2b7c5ca2$var$reIsBadHex.test(value) ? $4092711f2b7c5ca2$var$NAN : +value;
}
$4092711f2b7c5ca2$exports = $4092711f2b7c5ca2$var$toNumber;


/** Error message constants. */ var $c9f377a2e70f774c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c9f377a2e70f774c$var$nativeMax = Math.max, $c9f377a2e70f774c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $c9f377a2e70f774c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($c9f377a2e70f774c$var$FUNC_ERROR_TEXT);
    wait = $4092711f2b7c5ca2$exports(wait) || 0;
    if ($b638b78429ec3695$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $c9f377a2e70f774c$var$nativeMax($4092711f2b7c5ca2$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $c9f377a2e70f774c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $8ce6df2981fa53a1$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($8ce6df2981fa53a1$exports());
    }
    function debounced() {
        var time = $8ce6df2981fa53a1$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$c9f377a2e70f774c$exports = $c9f377a2e70f774c$var$debounce;






const $ebe95e6be1c275b4$var$i18nKey = "project.a4Page";
const $ebe95e6be1c275b4$var$TopBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function TopBar({ projectId: projectId, pageId: pageId, displayedPageNumber: displayedPageNumber, displayedTotalPageNumber: displayedTotalPageNumber, mutePagesAfter: mutePagesAfter, partName: partName, readOnly: readOnly = false }) {
    const [applyUpdatePage] = (0, $8933335d77e3c41a$export$8505a611e1f1e0e1)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [currentInputValue, setCurrentInputValue] = (0, $jMaZ8.useState)(partName);
    const latest = (0, $jMaZ8.useRef)({
        applyUpdatePage: applyUpdatePage,
        mutePagesAfter: mutePagesAfter
    });
    const dirty = (0, $jMaZ8.useRef)(false);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        latest.current = {
            applyUpdatePage: applyUpdatePage,
            mutePagesAfter: mutePagesAfter
        };
    }, [
        applyUpdatePage,
        mutePagesAfter
    ]);
    const debouncedChangeHandler = (0, $jMaZ8.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($c9f377a2e70f774c$exports)))((value)=>{
            const { applyUpdatePage: save, mutePagesAfter: currentMutePagesAfter } = latest.current;
            if (currentMutePagesAfter === undefined) return;
            dirty.current = false;
            save({
                variables: {
                    partname: value,
                    pageId: pageId,
                    projectId: projectId,
                    mutePagesAfter: currentMutePagesAfter
                }
            });
        }, 1000), [
        pageId,
        projectId
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (!dirty.current) setCurrentInputValue(partName);
    }, [
        partName
    ]);
    // A mode transition must not discard the user's last keystrokes.
    (0, $jMaZ8.useEffect)(()=>()=>{
            debouncedChangeHandler.flush();
            debouncedChangeHandler.cancel();
        }, [
        debouncedChangeHandler
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $f13071a53a0d1da4$export$ac052f74bbc68e2d,
        id: pageId,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                readOnly: readOnly,
                style: {
                    width: "83%"
                },
                className: $f13071a53a0d1da4$export$376d36288d105ef8,
                placeholder: t(`${$ebe95e6be1c275b4$var$i18nKey}.placeholder`),
                value: currentInputValue || undefined,
                onChange: (e)=>{
                    const value = e.target.value;
                    dirty.current = true;
                    setCurrentInputValue(value);
                    debouncedChangeHandler(value);
                }
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                style: {
                    width: "9%"
                },
                className: $f13071a53a0d1da4$export$ed705ffc52cf13c6,
                children: [
                    displayedPageNumber,
                    "/",
                    displayedTotalPageNumber
                ]
            })
        ]
    });
});
const $ebe95e6be1c275b4$var$Comp = ({ children: children, displayedTotalPageNumber: displayedTotalPageNumber, displayedPageNumber: displayedPageNumber, loadMore: loadMore, hasMoreToLoad: hasMoreToLoad, loadingMore: loadingMore, pageId: pageId, innerRef: innerRef })=>{
    const { project: project, pages: pages, pageHeaders: pageHeaders } = (0, $5b38bec19e3a4e47$export$8f31c2503e1efa93)();
    const headers = (0, $jMaZ8.useMemo)(()=>pageHeaders || (0, $64440fdf5e210924$export$df67168c104ba0e3)(pages), [
        pageHeaders,
        pages
    ]);
    const header = headers.get(pageId);
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $f13071a53a0d1da4$export$e8e78c978b129247,
        ref: innerRef,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("main", {
            id: "page-" + displayedPageNumber,
            className: $f13071a53a0d1da4$export$2a82ddc22e8c7fbb + " pageContent",
            style: {
                display: "flex"
            },
            lang: project.config.locale,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($ebe95e6be1c275b4$var$TopBar, {
                    pageId: pageId,
                    mutePagesAfter: header?.page.mutePagesAfter,
                    partName: header?.partName || "",
                    displayedPageNumber: displayedPageNumber,
                    displayedTotalPageNumber: displayedTotalPageNumber,
                    projectId: project.id,
                    readOnly: project?.kind === (0, $b522cf181e75e62d$export$878945baaa13398a).HTML_TEMPLATE
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        style: {
                            height: "100%",
                            minHeight: "72em",
                            paddingBottom: "3em"
                        },
                        className: $f13071a53a0d1da4$export$757af9f96ca62b21,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            className: $f13071a53a0d1da4$export$a7db06668cad9adb,
                            children: children
                        })
                    })
                }),
                loadingMore ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {}) : hasMoreToLoad ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    className: $f13071a53a0d1da4$export$ae9a281c4379b144,
                    onClick: loadMore,
                    children: t(`${$ebe95e6be1c275b4$var$i18nKey}.showMore`)
                }) : null
            ]
        })
    });
};
var $ebe95e6be1c275b4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo($ebe95e6be1c275b4$var$Comp);


function $7a51c699fd568a46$export$2e2bcd8739ae039(props) {
    const render = (0, $jMaZ8.useCallback)(({ inView: inView, ref: ref })=>{
        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ebe95e6be1c275b4$export$2e2bcd8739ae039), {
            innerRef: ref,
            pageId: props.pageId,
            displayedPageNumber: props.displayedPageNumber,
            displayedTotalPageNumber: props.displayedTotalPageNumber,
            loadMore: props.loadMore,
            hasMoreToLoad: props.hasMoreToLoad,
            loadingMore: props.loadingMore,
            children: inView ? props.children : []
        });
    }, [
        props.children,
        props.displayedPageNumber,
        props.displayedTotalPageNumber,
        props.hasMoreToLoad,
        props.loadMore,
        props.loadingMore,
        props.pageId
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6b98a0a92a846b6b$export$a62107ca74432f44), {
        children: render
    });
}



function $5397f42de219fe1e$var$RenderChild({ page: page, props: renderChildProps, isLast: isLast, component: Component, addMutePages: addMutePages, mergePages: mergePages }) {
    const [pageSizeFactor, setPageSizeFactor] = (0, $jMaZ8.useState)(1);
    let optionalPageBar = undefined;
    if (mergePages && addMutePages && !renderChildProps.lockPageStructure) optionalPageBar = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $826ede1070330fc2$export$2e2bcd8739ae039), {
        displayedTotalPageNumber: page.lastPageNumber,
        pageNumber: page.pageNumber,
        mutePagesAfter: page.mutePagesAfter,
        mergePages: mergePages,
        addMutePages: addMutePages,
        isLast: isLast,
        pageId: page.id
    });
    const loadMore = (0, $jMaZ8.useCallback)(()=>{
        setPageSizeFactor((factor)=>factor + 1);
    }, []);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $jMaZ8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $7a51c699fd568a46$export$2e2bcd8739ae039), {
                pageId: page.id,
                displayedPageNumber: page.pageNumber,
                displayedTotalPageNumber: page.lastPageNumber,
                scrollBoxSelector: "#project-root",
                loadMore: loadMore,
                hasMoreToLoad: false,
                loadingMore: false,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f9ad6d9d9a78d084$export$3dd58bf9bf579bba), {
                    page: page,
                    pageId: page.id,
                    props: renderChildProps,
                    projectId: renderChildProps.projectId,
                    component: Component,
                    loadMore: loadMore,
                    pageSizeFactor: pageSizeFactor
                })
            }),
            optionalPageBar
        ]
    }, page.id);
}
const $5397f42de219fe1e$var$MemoizedRenderChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo($5397f42de219fe1e$var$RenderChild);
const $5397f42de219fe1e$export$9e9dcf6268a0a1fc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function SplitContent({ children: children = [], component: Component, props: splitProps, mergePages: mergePages, addMutePages: addMutePages, pageMetadata: pageMetadata }) {
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            rowGap: "2em",
            padding: "2em 0",
            paddingBottom: "10em"
        },
        children: children.map((page, i)=>{
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($5397f42de219fe1e$var$MemoizedRenderChild, {
                pageMetadata: pageMetadata,
                page: page,
                isLast: i === children.length - 1,
                props: splitProps,
                component: Component,
                mergePages: mergePages,
                addMutePages: addMutePages
            }, page.id);
        })
    });
});


const $a1b03ac3acc3cf95$export$2de1e9fc98bcbeb2 = ({ projectId: projectId, allPages: allPages })=>{
    const pageProps = {
        projectId: projectId,
        allPages: allPages
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5397f42de219fe1e$export$9e9dcf6268a0a1fc), {
        component: (0, $634ada8300777bb4$export$2e2bcd8739ae039),
        props: pageProps,
        children: allPages
    });
};







parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $fvBso = parcelRequire("fvBso");

var $1Esi2 = parcelRequire("1Esi2");

var $3fkx6 = parcelRequire("3fkx6");

var $giSak = parcelRequire("giSak");

var $ktS49 = parcelRequire("ktS49");

var $eGh7a = parcelRequire("eGh7a");

var $9O5K3 = parcelRequire("9O5K3");

var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $3fkx6 = parcelRequire("3fkx6");

var $4b02Q = parcelRequire("4b02Q");

var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");
function $86c6a16f577b5d84$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $86c6a16f577b5d84$export$a41628415415e6e(direction, value, min, max) {
    var offset = $86c6a16f577b5d84$export$622cea445a1c5b7d(value, min, max);
    var positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateX(50%)';
            break;
        case 'btt':
            positionStyle.bottom = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateY(50%)';
            break;
        case 'ttb':
            positionStyle.top = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateY(-50%)';
            break;
        default:
            positionStyle.left = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateX(-50%)';
            break;
    }
    return positionStyle;
}
function $86c6a16f577b5d84$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}



var $hH60s = parcelRequire("hH60s");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $4b02Q = parcelRequire("4b02Q");

var $giSak = parcelRequire("giSak");


var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
var $bafdd5aebb82a2bb$var$SliderContext = /*#__PURE__*/ $jMaZ8.createContext({
    min: 0,
    max: 0,
    direction: 'ltr',
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true,
    styles: {},
    classNames: {}
});
var $bafdd5aebb82a2bb$export$2e2bcd8739ae039 = $bafdd5aebb82a2bb$var$SliderContext;
var $bafdd5aebb82a2bb$export$e508d6f1a100e5dd = /*#__PURE__*/ $jMaZ8.createContext({});



var $aa6ffc4fc0c306b7$var$_excluded = [
    "prefixCls",
    "value",
    "valueIndex",
    "onStartMove",
    "onDelete",
    "style",
    "render",
    "dragging",
    "draggingDelete",
    "onOffsetChange",
    "onChangeComplete",
    "onFocus",
    "onMouseEnter"
];
var $aa6ffc4fc0c306b7$var$Handle = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, value = props.value, valueIndex = props.valueIndex, onStartMove = props.onStartMove, onDelete = props.onDelete, style = props.style, render = props.render, dragging = props.dragging, draggingDelete = props.draggingDelete, onOffsetChange = props.onOffsetChange, onChangeComplete = props.onChangeComplete, onFocus = props.onFocus, onMouseEnter = props.onMouseEnter, restProps = (0, $4b02Q.default)(props, $aa6ffc4fc0c306b7$var$_excluded);
    var _React$useContext = $jMaZ8.useContext((0, $bafdd5aebb82a2bb$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, disabled = _React$useContext.disabled, keyboard = _React$useContext.keyboard, range = _React$useContext.range, tabIndex = _React$useContext.tabIndex, ariaLabelForHandle = _React$useContext.ariaLabelForHandle, ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle, ariaRequired = _React$useContext.ariaRequired, ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle, styles = _React$useContext.styles, classNames = _React$useContext.classNames;
    var handlePrefixCls = "".concat(prefixCls, "-handle");
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled) onStartMove(e, valueIndex);
    };
    var onInternalFocus = function onInternalFocus(e) {
        onFocus === null || onFocus === void 0 || onFocus(e, valueIndex);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(e) {
        onMouseEnter(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    var onKeyDown = function onKeyDown(e) {
        if (!disabled && keyboard) {
            var offset = null;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).LEFT:
                    offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
                    break;
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
                    break;
                // Up is plus
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP:
                    offset = direction !== 'ttb' ? 1 : -1;
                    break;
                // Down is minus
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== 'ttb' ? -1 : 1;
                    break;
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).HOME:
                    offset = 'min';
                    break;
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).END:
                    offset = 'max';
                    break;
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).BACKSPACE:
                case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DELETE:
                    onDelete(valueIndex);
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    var handleKeyUp = function handleKeyUp(e) {
        switch(e.which || e.keyCode){
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).LEFT:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).RIGHT:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).UP:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).DOWN:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).HOME:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).END:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).PAGE_UP:
            case (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).PAGE_DOWN:
                onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete();
                break;
        }
    };
    // ============================ Offset ============================
    var positionStyle = (0, $86c6a16f577b5d84$export$a41628415415e6e)(direction, value, min, max);
    // ============================ Render ============================
    var divProps = {};
    if (valueIndex !== null) {
        var _getIndex;
        divProps = {
            tabIndex: disabled ? null : (0, $86c6a16f577b5d84$export$ddfa24987dade61b)(tabIndex, valueIndex),
            role: 'slider',
            'aria-valuemin': min,
            'aria-valuemax': max,
            'aria-valuenow': value,
            'aria-disabled': disabled,
            'aria-label': (0, $86c6a16f577b5d84$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
            'aria-labelledby': (0, $86c6a16f577b5d84$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
            'aria-required': (0, $86c6a16f577b5d84$export$ddfa24987dade61b)(ariaRequired, valueIndex),
            'aria-valuetext': (_getIndex = (0, $86c6a16f577b5d84$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value),
            'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
            onMouseDown: onInternalStartMove,
            onTouchStart: onInternalStartMove,
            onFocus: onInternalFocus,
            onMouseEnter: onInternalMouseEnter,
            onKeyDown: onKeyDown,
            onKeyUp: handleKeyUp
        };
    }
    var handleNode = /*#__PURE__*/ $jMaZ8.createElement("div", (0, $hH60s.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(handlePrefixCls, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), valueIndex !== null && range), "".concat(handlePrefixCls, "-dragging"), dragging), "".concat(handlePrefixCls, "-dragging-delete"), draggingDelete), classNames.handle),
        style: (0, $8u3qN.default)((0, $8u3qN.default)((0, $8u3qN.default)({}, positionStyle), style), styles.handle)
    }, divProps, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging,
        draggingDelete: draggingDelete
    });
    return handleNode;
});
$aa6ffc4fc0c306b7$var$Handle.displayName = 'Handle';
var $aa6ffc4fc0c306b7$export$2e2bcd8739ae039 = $aa6ffc4fc0c306b7$var$Handle;


var $7dce36e7c2cc936a$var$_excluded = [
    "prefixCls",
    "style",
    "onStartMove",
    "onOffsetChange",
    "values",
    "handleRender",
    "activeHandleRender",
    "draggingIndex",
    "draggingDelete",
    "onFocus"
];
var $7dce36e7c2cc936a$var$Handles = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, onStartMove = props.onStartMove, onOffsetChange = props.onOffsetChange, values = props.values, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, draggingIndex = props.draggingIndex, draggingDelete = props.draggingDelete, onFocus = props.onFocus, restProps = (0, $4b02Q.default)(props, $7dce36e7c2cc936a$var$_excluded);
    var handlesRef = $jMaZ8.useRef({});
    // =========================== Active ===========================
    var _React$useState = $jMaZ8.useState(false), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), activeVisible = _React$useState2[0], setActiveVisible = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(-1), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), activeIndex = _React$useState4[0], setActiveIndex = _React$useState4[1];
    var onActive = function onActive(index) {
        setActiveIndex(index);
        setActiveVisible(true);
    };
    var onHandleFocus = function onHandleFocus(e, index) {
        onActive(index);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var onHandleMouseEnter = function onHandleMouseEnter(e, index) {
        onActive(index);
    };
    // =========================== Render ===========================
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            focus: function focus(index) {
                var _handlesRef$current$i;
                (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
            },
            hideHelp: function hideHelp() {
                (0, $6UWRi.flushSync)(function() {
                    setActiveVisible(false);
                });
            }
        };
    });
    // =========================== Render ===========================
    // Handle Props
    var handleProps = (0, $8u3qN.default)({
        prefixCls: prefixCls,
        onStartMove: onStartMove,
        onOffsetChange: onOffsetChange,
        render: handleRender,
        onFocus: onHandleFocus,
        onMouseEnter: onHandleMouseEnter
    }, restProps);
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, values.map(function(value, index) {
        var dragging = draggingIndex === index;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $aa6ffc4fc0c306b7$export$2e2bcd8739ae039), (0, $hH60s.default)({
            ref: function ref(node) {
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: dragging,
            draggingDelete: dragging && draggingDelete,
            style: (0, $86c6a16f577b5d84$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index
        }, handleProps));
    }), activeHandleRender && activeVisible && /*#__PURE__*/ $jMaZ8.createElement((0, $aa6ffc4fc0c306b7$export$2e2bcd8739ae039), (0, $hH60s.default)({
        key: "a11y"
    }, handleProps, {
        value: values[activeIndex],
        valueIndex: null,
        dragging: draggingIndex !== -1,
        draggingDelete: draggingDelete,
        render: activeHandleRender,
        style: {
            pointerEvents: 'none'
        },
        tabIndex: null,
        "aria-hidden": true
    })));
});
$7dce36e7c2cc936a$var$Handles.displayName = 'Handles';
var $7dce36e7c2cc936a$export$2e2bcd8739ae039 = $7dce36e7c2cc936a$var$Handles;



var $jMaZ8 = parcelRequire("jMaZ8");

var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");


var $2a48fa86de5abcce$var$Mark = function Mark(props) {
    var prefixCls = props.prefixCls, style = props.style, children = props.children, value = props.value, _onClick = props.onClick;
    var _React$useContext = $jMaZ8.useContext((0, $bafdd5aebb82a2bb$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd, included = _React$useContext.included;
    var textCls = "".concat(prefixCls, "-text");
    // ============================ Offset ============================
    var positionStyle = (0, $86c6a16f577b5d84$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(textCls, (0, $eq8kl.default)({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, positionStyle), style),
        onMouseDown: function onMouseDown(e) {
            e.stopPropagation();
        },
        onClick: function onClick() {
            _onClick(value);
        }
    }, children);
};
var $2a48fa86de5abcce$export$2e2bcd8739ae039 = $2a48fa86de5abcce$var$Mark;


var $ad2cce72cef2555c$var$Marks = function Marks(props) {
    var prefixCls = props.prefixCls, marks = props.marks, onClick = props.onClick;
    var markPrefixCls = "".concat(prefixCls, "-mark");
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: markPrefixCls
    }, marks.map(function(_ref) {
        var value = _ref.value, style = _ref.style, label = _ref.label;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $2a48fa86de5abcce$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label);
    }));
};
var $ad2cce72cef2555c$export$2e2bcd8739ae039 = $ad2cce72cef2555c$var$Marks;



var $jMaZ8 = parcelRequire("jMaZ8");


var $eq8kl = parcelRequire("eq8kl");

var $8u3qN = parcelRequire("8u3qN");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");


var $62687198f8246e92$var$Dot = function Dot(props) {
    var prefixCls = props.prefixCls, value = props.value, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $jMaZ8.useContext((0, $bafdd5aebb82a2bb$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, included = _React$useContext.included, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd;
    var dotClassName = "".concat(prefixCls, "-dot");
    var active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    var mergedStyle = (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $86c6a16f577b5d84$export$a41628415415e6e)(direction, value, min, max)), typeof style === 'function' ? style(value) : style);
    if (active) mergedStyle = (0, $8u3qN.default)((0, $8u3qN.default)({}, mergedStyle), typeof activeStyle === 'function' ? activeStyle(value) : activeStyle);
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(dotClassName, (0, $eq8kl.default)({}, "".concat(dotClassName, "-active"), active)),
        style: mergedStyle
    });
};
var $62687198f8246e92$export$2e2bcd8739ae039 = $62687198f8246e92$var$Dot;


var $1926171644992f7a$var$Steps = function Steps(props) {
    var prefixCls = props.prefixCls, marks = props.marks, dots = props.dots, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $jMaZ8.useContext((0, $bafdd5aebb82a2bb$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, step = _React$useContext.step;
    var stepDots = $jMaZ8.useMemo(function() {
        var dotSet = new Set();
        // Add marks
        marks.forEach(function(mark) {
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            var current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, stepDots.map(function(dotValue) {
        return /*#__PURE__*/ $jMaZ8.createElement((0, $62687198f8246e92$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        });
    }));
};
var $1926171644992f7a$export$2e2bcd8739ae039 = $1926171644992f7a$var$Steps;



var $8u3qN = parcelRequire("8u3qN");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");



var $8u3qN = parcelRequire("8u3qN");

var $eq8kl = parcelRequire("eq8kl");

var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");


var $7a29ae86ebe740b5$var$Track = function Track(props) {
    var prefixCls = props.prefixCls, style = props.style, start = props.start, end = props.end, index = props.index, onStartMove = props.onStartMove, replaceCls = props.replaceCls;
    var _React$useContext = $jMaZ8.useContext((0, $bafdd5aebb82a2bb$export$2e2bcd8739ae039)), direction = _React$useContext.direction, min = _React$useContext.min, max = _React$useContext.max, disabled = _React$useContext.disabled, range = _React$useContext.range, classNames = _React$useContext.classNames;
    var trackPrefixCls = "".concat(prefixCls, "-track");
    var offsetStart = (0, $86c6a16f577b5d84$export$622cea445a1c5b7d)(start, min, max);
    var offsetEnd = (0, $86c6a16f577b5d84$export$622cea445a1c5b7d)(end, min, max);
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    var positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case 'btt':
            positionStyle.bottom = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case 'ttb':
            positionStyle.top = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        default:
            positionStyle.left = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
    }
    var className = replaceCls || (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(trackPrefixCls, (0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(trackPrefixCls, "-").concat(index + 1), index !== null && range), "".concat(prefixCls, "-track-draggable"), onStartMove), classNames.track);
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: className,
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
};
var $7a29ae86ebe740b5$export$2e2bcd8739ae039 = $7a29ae86ebe740b5$var$Track;


var $5af377e990f2a09f$var$Tracks = function Tracks(props) {
    var prefixCls = props.prefixCls, style = props.style, values = props.values, startPoint = props.startPoint, onStartMove = props.onStartMove;
    var _React$useContext = $jMaZ8.useContext((0, $bafdd5aebb82a2bb$export$2e2bcd8739ae039)), included = _React$useContext.included, range = _React$useContext.range, min = _React$useContext.min, styles = _React$useContext.styles, classNames = _React$useContext.classNames;
    // =========================== List ===========================
    var trackList = $jMaZ8.useMemo(function() {
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
            var endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        var list = [];
        for(var i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    if (!included) return null;
    // ========================== Render ==========================
    var tracksNode = trackList !== null && trackList !== void 0 && trackList.length && (classNames.tracks || styles.tracks) ? /*#__PURE__*/ $jMaZ8.createElement((0, $7a29ae86ebe740b5$export$2e2bcd8739ae039), {
        index: null,
        prefixCls: prefixCls,
        start: trackList[0].start,
        end: trackList[trackList.length - 1].end,
        replaceCls: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(classNames.tracks, "".concat(prefixCls, "-tracks")),
        style: styles.tracks
    }) : null;
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, tracksNode, trackList.map(function(_ref, index) {
        var start = _ref.start, end = _ref.end;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $7a29ae86ebe740b5$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: (0, $8u3qN.default)((0, $8u3qN.default)({}, (0, $86c6a16f577b5d84$export$ddfa24987dade61b)(style, index)), styles.track),
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        });
    }));
};
var $5af377e990f2a09f$export$2e2bcd8739ae039 = $5af377e990f2a09f$var$Tracks;




var $fvBso = parcelRequire("fvBso");

var $3fkx6 = parcelRequire("3fkx6");

var $jMaZ8 = parcelRequire("jMaZ8");

var $ktS49 = parcelRequire("ktS49");

var $jLTp6 = parcelRequire("jLTp6");

/** Drag to delete offset. It's a user experience number for dragging out */ var $cf1dace4e66e1e2f$var$REMOVE_DIST = 130;
function $cf1dace4e66e1e2f$var$getPosition(e) {
    var obj = 'targetTouches' in e ? e.targetTouches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $cf1dace4e66e1e2f$var$useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount) {
    var _React$useState = $jMaZ8.useState(null), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), draggingValue = _React$useState2[0], setDraggingValue = _React$useState2[1];
    var _React$useState3 = $jMaZ8.useState(-1), _React$useState4 = (0, $3fkx6.default)(_React$useState3, 2), draggingIndex = _React$useState4[0], setDraggingIndex = _React$useState4[1];
    var _React$useState5 = $jMaZ8.useState(false), _React$useState6 = (0, $3fkx6.default)(_React$useState5, 2), draggingDelete = _React$useState6[0], setDraggingDelete = _React$useState6[1];
    var _React$useState7 = $jMaZ8.useState(rawValues), _React$useState8 = (0, $3fkx6.default)(_React$useState7, 2), cacheValues = _React$useState8[0], setCacheValues = _React$useState8[1];
    var _React$useState9 = $jMaZ8.useState(rawValues), _React$useState10 = (0, $3fkx6.default)(_React$useState9, 2), originValues = _React$useState10[0], setOriginValues = _React$useState10[1];
    var mouseMoveEventRef = $jMaZ8.useRef(null);
    var mouseUpEventRef = $jMaZ8.useRef(null);
    var touchEventTargetRef = $jMaZ8.useRef(null);
    var _React$useContext = $jMaZ8.useContext((0, $bafdd5aebb82a2bb$export$e508d6f1a100e5dd)), onDragStart = _React$useContext.onDragStart, onDragChange = _React$useContext.onDragChange;
    (0, $jLTp6.default)(function() {
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    $jMaZ8.useEffect(function() {
        return function() {
            document.removeEventListener('mousemove', mouseMoveEventRef.current);
            document.removeEventListener('mouseup', mouseUpEventRef.current);
            if (touchEventTargetRef.current) {
                touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
        };
    }, []);
    var flushValues = function flushValues(nextValues, nextValue, deleteMark) {
        // Perf: Only update state when value changed
        if (nextValue !== undefined) setDraggingValue(nextValue);
        setCacheValues(nextValues);
        var changeValues = nextValues;
        if (deleteMark) changeValues = nextValues.filter(function(_, i) {
            return i !== draggingIndex;
        });
        triggerChange(changeValues);
        if (onDragChange) onDragChange({
            rawValues: nextValues,
            deleteIndex: deleteMark ? draggingIndex : -1,
            draggingIndex: draggingIndex,
            draggingValue: nextValue
        });
    };
    var updateCacheValue = (0, $ktS49.default)(function(valueIndex, offsetPercent, deleteMark) {
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            var startValue = originValues[0];
            var endValue = originValues[originValues.length - 1];
            var maxStartOffset = min - startValue;
            var maxEndOffset = max - endValue;
            // Get valid offset
            var offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            var formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            var cloneCacheValues = originValues.map(function(val) {
                return val + offset;
            });
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            var offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            var cloneValues = (0, $fvBso.default)(cacheValues);
            cloneValues[valueIndex] = originValues[valueIndex];
            var next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
            flushValues(next.values, next.value, deleteMark);
        }
    });
    var onStartMove = function onStartMove(e, valueIndex, startValues) {
        e.stopPropagation();
        // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
        var initialValues = startValues || rawValues;
        var originValue = initialValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(initialValues);
        setCacheValues(initialValues);
        setDraggingDelete(false);
        var _getPosition = $cf1dace4e66e1e2f$var$getPosition(e), startX = _getPosition.pageX, startY = _getPosition.pageY;
        // We declare it here since closure can't get outer latest value
        var deleteMark = false;
        // Internal trigger event
        if (onDragStart) onDragStart({
            rawValues: initialValues,
            draggingIndex: valueIndex,
            draggingValue: originValue
        });
        // Moving
        var onMouseMove = function onMouseMove(event) {
            event.preventDefault();
            var _getPosition2 = $cf1dace4e66e1e2f$var$getPosition(event), moveX = _getPosition2.pageX, moveY = _getPosition2.pageY;
            var offsetX = moveX - startX;
            var offsetY = moveY - startY;
            var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
            var offSetPercent;
            var removeDist;
            switch(direction){
                case 'btt':
                    offSetPercent = -offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'ttb':
                    offSetPercent = offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'rtl':
                    offSetPercent = -offsetX / width;
                    removeDist = offsetY;
                    break;
                default:
                    offSetPercent = offsetX / width;
                    removeDist = offsetY;
            }
            // Check if need mark remove
            deleteMark = editable ? Math.abs(removeDist) > $cf1dace4e66e1e2f$var$REMOVE_DIST && minCount < cacheValues.length : false;
            setDraggingDelete(deleteMark);
            updateCacheValue(valueIndex, offSetPercent, deleteMark);
        };
        // End
        var onMouseUp = function onMouseUp(event) {
            event.preventDefault();
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('mousemove', onMouseMove);
            if (touchEventTargetRef.current) {
                touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            touchEventTargetRef.current = null;
            finishChange(deleteMark);
            setDraggingIndex(-1);
            setDraggingDelete(false);
        };
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('mousemove', onMouseMove);
        e.currentTarget.addEventListener('touchend', onMouseUp);
        e.currentTarget.addEventListener('touchmove', onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
        touchEventTargetRef.current = e.currentTarget;
    };
    // Only return cache value when it mapping with rawValues
    var returnValues = $jMaZ8.useMemo(function() {
        var sourceValues = (0, $fvBso.default)(rawValues).sort(function(a, b) {
            return a - b;
        });
        var targetValues = (0, $fvBso.default)(cacheValues).sort(function(a, b) {
            return a - b;
        });
        var counts = {};
        targetValues.forEach(function(val) {
            counts[val] = (counts[val] || 0) + 1;
        });
        sourceValues.forEach(function(val) {
            counts[val] = (counts[val] || 0) - 1;
        });
        var maxDiffCount = editable ? 1 : 0;
        var diffCount = Object.values(counts).reduce(function(prev, next) {
            return prev + Math.abs(next);
        }, 0);
        return diffCount <= maxDiffCount ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues,
        editable
    ]);
    return [
        draggingIndex,
        draggingValue,
        draggingDelete,
        returnValues,
        onStartMove
    ];
}
var $cf1dace4e66e1e2f$export$2e2bcd8739ae039 = $cf1dace4e66e1e2f$var$useDrag;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");
function $8f62490f7ac791dd$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable) {
    var formatRangeValue = $jMaZ8.useCallback(function(val) {
        return Math.max(min, Math.min(max, val));
    }, [
        min,
        max
    ]);
    var formatStepValue = $jMaZ8.useCallback(function(val) {
        if (step !== null) {
            var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            var getDecimal = function getDecimal(num) {
                return (String(num).split('.')[1] || '').length;
            };
            var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            var fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    var formatValue = $jMaZ8.useCallback(function(val) {
        var formatNextValue = formatRangeValue(val);
        // List align values
        var alignValues = markList.map(function(mark) {
            return mark.value;
        });
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        var closeValue = alignValues[0];
        var closeDist = max - min;
        alignValues.forEach(function(alignValue) {
            var dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    var offsetValue = function offsetValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        if (typeof offset === 'number') {
            var nextValue;
            var originValue = values[valueIndex];
            // Only used for `dist` mode
            var targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            var potentialValues = [];
            markList.forEach(function(mark) {
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            var sign = offset > 0 ? 1 : -1;
            if (mode === 'unit') potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter(function(val) {
                return val !== null;
            })// Remove reverse value
            .filter(function(val) {
                return offset < 0 ? val <= originValue : val >= originValue;
            });
            if (mode === 'unit') // `unit` mode can not contain itself
            potentialValues = potentialValues.filter(function(val) {
                return val !== originValue;
            });
            var compareValue = mode === 'unit' ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            var valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach(function(potentialValue) {
                var dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === 'dist') return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                var cloneValues = (0, $fvBso.default)(values);
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === 'min') return min;
        else if (offset === 'max') return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        var originValue = values[valueIndex];
        var nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    var needPush = function needPush(dist) {
        return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
    };
    // Values
    var offsetValues = function offsetValues(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        var nextValues = values.map(formatValue);
        var originValue = nextValues[valueIndex];
        var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            var pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === 'number' || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(var i = valueIndex + 1; i < nextValues.length; i += 1){
                var changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed){
                    var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
                    nextValues[i] = _offsetChangedValue.value;
                    changed = _offsetChangedValue.changed;
                }
            }
            // Start values
            for(var _i = valueIndex; _i > 0; _i -= 1){
                var _changed = true;
                while(needPush(nextValues[_i] - nextValues[_i - 1]) && _changed){
                    var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
                    nextValues[_i - 1] = _offsetChangedValue2.value;
                    _changed = _offsetChangedValue2.changed;
                }
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1){
                var _changed2 = true;
                while(needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2){
                    var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
                    nextValues[_i2 - 1] = _offsetChangedValue3.value;
                    _changed2 = _offsetChangedValue3.changed;
                }
            }
            // Start to End
            for(var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1){
                var _changed3 = true;
                while(needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3){
                    var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
                    nextValues[_i3 + 1] = _offsetChangedValue4.value;
                    _changed3 = _offsetChangedValue4.changed;
                }
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}



var $2bFmQ = parcelRequire("2bFmQ");

var $jMaZ8 = parcelRequire("jMaZ8");
function $25308caafb788f0c$export$2e2bcd8739ae039(range) {
    return (0, $jMaZ8.useMemo)(function() {
        if (range === true || !range) return [
            !!range,
            false,
            false,
            0
        ];
        var editable = range.editable, draggableTrack = range.draggableTrack, minCount = range.minCount, maxCount = range.maxCount;
        (0, $2bFmQ.warning)(!editable || !draggableTrack, '`editable` can not work with `draggableTrack`.');
        return [
            true,
            editable,
            !editable && draggableTrack,
            minCount || 0,
            maxCount
        ];
    }, [
        range
    ]);
}


/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */ var $e9d370c0ea1ab7a3$var$Slider = /*#__PURE__*/ $jMaZ8.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-slider' : _props$prefixCls, className = props.className, style = props.style, classNames = props.classNames, styles = props.styles, id = props.id, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, autoFocus = props.autoFocus, onFocus = props.onFocus, onBlur = props.onBlur, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, value = props.value, defaultValue = props.defaultValue, range = props.range, count = props.count, onChange = props.onChange, onBeforeChange = props.onBeforeChange, onAfterChange = props.onAfterChange, onChangeComplete = props.onChangeComplete, _props$allowCross = props.allowCross, allowCross = _props$allowCross === void 0 ? true : _props$allowCross, _props$pushable = props.pushable, pushable = _props$pushable === void 0 ? false : _props$pushable, reverse = props.reverse, vertical = props.vertical, _props$included = props.included, included = _props$included === void 0 ? true : _props$included, startPoint = props.startPoint, trackStyle = props.trackStyle, handleStyle = props.handleStyle, railStyle = props.railStyle, dotStyle = props.dotStyle, activeDotStyle = props.activeDotStyle, marks = props.marks, dots = props.dots, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, track = props.track, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, ariaLabelForHandle = props.ariaLabelForHandle, ariaLabelledByForHandle = props.ariaLabelledByForHandle, ariaRequired = props.ariaRequired, ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
    var handlesRef = $jMaZ8.useRef(null);
    var containerRef = $jMaZ8.useRef(null);
    var direction = $jMaZ8.useMemo(function() {
        if (vertical) return reverse ? 'ttb' : 'btt';
        return reverse ? 'rtl' : 'ltr';
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    var _useRange = (0, $25308caafb788f0c$export$2e2bcd8739ae039)(range), _useRange2 = (0, $3fkx6.default)(_useRange, 5), rangeEnabled = _useRange2[0], rangeEditable = _useRange2[1], rangeDraggableTrack = _useRange2[2], minCount = _useRange2[3], maxCount = _useRange2[4];
    var mergedMin = $jMaZ8.useMemo(function() {
        return isFinite(min) ? min : 0;
    }, [
        min
    ]);
    var mergedMax = $jMaZ8.useMemo(function() {
        return isFinite(max) ? max : 100;
    }, [
        max
    ]);
    // ============================= Step =============================
    var mergedStep = $jMaZ8.useMemo(function() {
        return step !== null && step <= 0 ? 1 : step;
    }, [
        step
    ]);
    // ============================= Push =============================
    var mergedPush = $jMaZ8.useMemo(function() {
        if (typeof pushable === 'boolean') return pushable ? mergedStep : false;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    var markList = $jMaZ8.useMemo(function() {
        return Object.keys(marks || {}).map(function(key) {
            var mark = marks[key];
            var markObj = {
                value: Number(key)
            };
            if (mark && (0, $1Esi2.default)(mark) === 'object' && !/*#__PURE__*/ $jMaZ8.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(function(_ref) {
            var label = _ref.label;
            return label || typeof label === 'number';
        }).sort(function(a, b) {
            return a.value - b.value;
        });
    }, [
        marks
    ]);
    // ============================ Format ============================
    var _useOffset = (0, $8f62490f7ac791dd$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush), _useOffset2 = (0, $3fkx6.default)(_useOffset, 2), formatValue = _useOffset2[0], offsetValues = _useOffset2[1];
    // ============================ Values ============================
    var _useMergedState = (0, $eGh7a.default)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $3fkx6.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var rawValues = $jMaZ8.useMemo(function() {
        var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        var _valueList = (0, $3fkx6.default)(valueList, 1), _valueList$ = _valueList[0], val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
        var returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (rangeEnabled) {
            returnValues = (0, $fvBso.default)(valueList);
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                var pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount){
                    var _returnValues;
                    returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
                }
            }
            returnValues.sort(function(a, b) {
                return a - b;
            });
        }
        // Align in range
        returnValues.forEach(function(val, index) {
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        rangeEnabled,
        mergedMin,
        count,
        formatValue
    ]);
    // =========================== onChange ===========================
    var getTriggerValue = function getTriggerValue(triggerValues) {
        return rangeEnabled ? triggerValues : triggerValues[0];
    };
    var triggerChange = (0, $ktS49.default)(function(nextValues) {
        // Order first
        var cloneNextValues = (0, $fvBso.default)(nextValues).sort(function(a, b) {
            return a - b;
        });
        // Trigger event if needed
        if (onChange && !(0, $9O5K3.default)(cloneNextValues, rawValues, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    });
    var finishChange = (0, $ktS49.default)(function(draggingDelete) {
        // Trigger from `useDrag` will tell if it's a delete action
        if (draggingDelete) handlesRef.current.hideHelp();
        var finishValue = getTriggerValue(rawValues);
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(finishValue);
        (0, $2bFmQ.default)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(finishValue);
    });
    var onDelete = function onDelete(index) {
        if (disabled || !rangeEditable || rawValues.length <= minCount) return;
        var cloneNextValues = (0, $fvBso.default)(rawValues);
        cloneNextValues.splice(index, 1);
        onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
        triggerChange(cloneNextValues);
        var nextFocusIndex = Math.max(0, index - 1);
        handlesRef.current.hideHelp();
        handlesRef.current.focus(nextFocusIndex);
    };
    var _useDrag = (0, $cf1dace4e66e1e2f$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, rangeEditable, minCount), _useDrag2 = (0, $3fkx6.default)(_useDrag, 5), draggingIndex = _useDrag2[0], draggingValue = _useDrag2[1], draggingDelete = _useDrag2[2], cacheValues = _useDrag2[3], onStartDrag = _useDrag2[4];
    /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */ var changeToCloseValue = function changeToCloseValue(newValue, e) {
        if (!disabled) {
            // Create new values
            var cloneNextValues = (0, $fvBso.default)(rawValues);
            var valueIndex = 0;
            var valueBeforeIndex = 0; // Record the index which value < newValue
            var valueDist = mergedMax - mergedMin;
            rawValues.forEach(function(val, index) {
                var dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
                if (val < newValue) valueBeforeIndex = index;
            });
            var focusIndex = valueIndex;
            if (rangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
                cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
                focusIndex = valueBeforeIndex + 1;
            } else cloneNextValues[valueIndex] = newValue;
            // Fill value to match default 2 (only when `rawValues` is empty)
            if (rangeEnabled && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            var nextValue = getTriggerValue(cloneNextValues);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(nextValue);
            triggerChange(cloneNextValues);
            if (e) {
                var _document$activeEleme, _document$activeEleme2;
                (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
                handlesRef.current.focus(focusIndex);
                onStartDrag(e, focusIndex, cloneNextValues);
            } else {
                // https://github.com/ant-design/ant-design/issues/49997
                onAfterChange === null || onAfterChange === void 0 || onAfterChange(nextValue);
                (0, $2bFmQ.default)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
                onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(nextValue);
            }
        }
    };
    // ============================ Click =============================
    var onSliderMouseDown = function onSliderMouseDown(e) {
        e.preventDefault();
        var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height, left = _containerRef$current.left, top = _containerRef$current.top, bottom = _containerRef$current.bottom, right = _containerRef$current.right;
        var clientX = e.clientX, clientY = e.clientY;
        var percent;
        switch(direction){
            case 'btt':
                percent = (bottom - clientY) / height;
                break;
            case 'ttb':
                percent = (clientY - top) / height;
                break;
            case 'rtl':
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        var nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue), e);
    };
    // =========================== Keyboard ===========================
    var _React$useState = $jMaZ8.useState(null), _React$useState2 = (0, $3fkx6.default)(_React$useState, 2), keyboardValue = _React$useState2[0], setKeyboardValue = _React$useState2[1];
    var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
        if (!disabled) {
            var next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
            triggerChange(next.values);
            setKeyboardValue(next.value);
        }
    };
    $jMaZ8.useEffect(function() {
        if (keyboardValue !== null) {
            var valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    var mergedDraggableTrack = $jMaZ8.useMemo(function() {
        if (rangeDraggableTrack && mergedStep === null) {
            (0, $2bFmQ.default)(false, '`draggableTrack` is not supported when `step` is `null`.');
            return false;
        }
        return rangeDraggableTrack;
    }, [
        rangeDraggableTrack,
        mergedStep
    ]);
    var onStartMove = (0, $ktS49.default)(function(e, valueIndex) {
        onStartDrag(e, valueIndex);
        onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
    });
    // Auto focus for updated handle
    var dragging = draggingIndex !== -1;
    $jMaZ8.useEffect(function() {
        if (!dragging) {
            var valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    var sortedCacheValues = $jMaZ8.useMemo(function() {
        return (0, $fvBso.default)(cacheValues).sort(function(a, b) {
            return a - b;
        });
    }, [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    var _React$useMemo = $jMaZ8.useMemo(function() {
        if (!rangeEnabled) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        rangeEnabled,
        mergedMin
    ]), _React$useMemo2 = (0, $3fkx6.default)(_React$useMemo, 2), includedStart = _React$useMemo2[0], includedEnd = _React$useMemo2[1];
    // ============================= Refs =============================
    $jMaZ8.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                handlesRef.current.focus(0);
            },
            blur: function blur() {
                var _containerRef$current2;
                var _document = document, activeElement = _document.activeElement;
                if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(activeElement)) activeElement === null || activeElement === void 0 || activeElement.blur();
            }
        };
    });
    // ========================== Auto Focus ==========================
    $jMaZ8.useEffect(function() {
        if (autoFocus) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    var context = $jMaZ8.useMemo(function() {
        return {
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            keyboard: keyboard,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: rangeEnabled,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaRequired: ariaRequired,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
            styles: styles || {},
            classNames: classNames || {}
        };
    }, [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        rangeEnabled,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaRequired,
        ariaValueTextFormatterForHandle,
        styles,
        classNames
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $jMaZ8.createElement((0, $bafdd5aebb82a2bb$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, className, (0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)((0, $eq8kl.default)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-vertical"), vertical), "".concat(prefixCls, "-horizontal"), !vertical), "".concat(prefixCls, "-with-marks"), markList.length)),
        style: style,
        onMouseDown: onSliderMouseDown,
        id: id
    }, /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))("".concat(prefixCls, "-rail"), classNames === null || classNames === void 0 ? void 0 : classNames.rail),
        style: (0, $8u3qN.default)((0, $8u3qN.default)({}, railStyle), styles === null || styles === void 0 ? void 0 : styles.rail)
    }), track !== false && /*#__PURE__*/ $jMaZ8.createElement((0, $5af377e990f2a09f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: rawValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : undefined
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $1926171644992f7a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $7dce36e7c2cc936a$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        draggingDelete: draggingDelete,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: finishChange,
        onDelete: rangeEditable ? onDelete : undefined
    }), /*#__PURE__*/ $jMaZ8.createElement((0, $ad2cce72cef2555c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
$e9d370c0ea1ab7a3$var$Slider.displayName = 'Slider';
var $e9d370c0ea1ab7a3$export$2e2bcd8739ae039 = $e9d370c0ea1ab7a3$var$Slider;



var $b4b1c00b9c835f66$export$2e2bcd8739ae039 = (0, $e9d370c0ea1ab7a3$export$2e2bcd8739ae039);



var $aZxvk = parcelRequire("aZxvk");




var $jMaZ8 = parcelRequire("jMaZ8");
/** @private Internal context. Do not use in your production. */ const $9a5de0f3fc141591$var$SliderInternalContext = /*#__PURE__*/ (0, $jMaZ8.createContext)({});
var $9a5de0f3fc141591$export$2e2bcd8739ae039 = $9a5de0f3fc141591$var$SliderInternalContext;



var $jMaZ8 = parcelRequire("jMaZ8");

var $aZxvk = parcelRequire("aZxvk");

var $1cfGC = parcelRequire("1cfGC");

"use client";
const $eab36eac712f5797$var$SliderTooltip = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { open: open, draggingDelete: draggingDelete } = props;
    const innerRef = (0, $jMaZ8.useRef)(null);
    const mergedOpen = open && !draggingDelete;
    const rafRef = (0, $jMaZ8.useRef)(null);
    function cancelKeepAlign() {
        (0, $aZxvk.default).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, $aZxvk.default)(()=>{
            var _a;
            (_a = innerRef.current) === null || _a === void 0 || _a.forceAlign();
            rafRef.current = null;
        });
    }
    $jMaZ8.useEffect(()=>{
        if (mergedOpen) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        mergedOpen,
        props.title
    ]);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $1cfGC.composeRef)(innerRef, ref)
    }, props, {
        open: mergedOpen
    }));
});
$eab36eac712f5797$var$SliderTooltip.displayName = 'SliderTooltip';
var $eab36eac712f5797$export$2e2bcd8739ae039 = $eab36eac712f5797$var$SliderTooltip;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("ks6TL");
var $6xABB = parcelRequire("6xABB");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// =============================== Base ===============================
const $5e43b51e27332d22$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlSize: controlSize, dotSize: dotSize, marginFull: marginFull, marginPart: marginPart, colorFillContentHover: colorFillContentHover, handleColorDisabled: handleColorDisabled, calc: calc, handleSize: handleSize, handleSizeHover: handleSizeHover, handleActiveColor: handleActiveColor, handleActiveOutlineColor: handleActiveOutlineColor, handleLineWidth: handleLineWidth, handleLineWidthHover: handleLineWidthHover, motionDurationMid: motionDurationMid } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            position: 'relative',
            height: controlSize,
            margin: `${(0, $4g3I0.unit)(marginPart)} ${(0, $4g3I0.unit)(marginFull)}`,
            padding: 0,
            cursor: 'pointer',
            touchAction: 'none',
            '&-vertical': {
                margin: `${(0, $4g3I0.unit)(marginFull)} ${(0, $4g3I0.unit)(marginPart)}`
            },
            [`${componentCls}-rail`]: {
                position: 'absolute',
                backgroundColor: token.railBg,
                borderRadius: token.borderRadiusXS,
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track,${componentCls}-tracks`]: {
                position: 'absolute',
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track`]: {
                backgroundColor: token.trackBg,
                borderRadius: token.borderRadiusXS
            },
            [`${componentCls}-track-draggable`]: {
                boxSizing: 'content-box',
                backgroundClip: 'content-box',
                border: 'solid rgba(0,0,0,0)'
            },
            '&:hover': {
                [`${componentCls}-rail`]: {
                    backgroundColor: token.railHoverBg
                },
                [`${componentCls}-track`]: {
                    backgroundColor: token.trackHoverBg
                },
                [`${componentCls}-dot`]: {
                    borderColor: colorFillContentHover
                },
                [`${componentCls}-handle::after`]: {
                    boxShadow: `0 0 0 ${(0, $4g3I0.unit)(handleLineWidth)} ${token.colorPrimaryBorderHover}`
                },
                [`${componentCls}-dot-active`]: {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`${componentCls}-handle`]: {
                position: 'absolute',
                width: handleSize,
                height: handleSize,
                outline: 'none',
                userSelect: 'none',
                // Dragging status
                '&-dragging-delete': {
                    opacity: 0
                },
                // 扩大选区
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
                    insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
                    width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    backgroundColor: 'transparent'
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: handleSize,
                    height: handleSize,
                    backgroundColor: token.colorBgElevated,
                    boxShadow: `0 0 0 ${(0, $4g3I0.unit)(handleLineWidth)} ${token.handleColor}`,
                    outline: `0px solid transparent`,
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition: `
            inset-inline-start ${motionDurationMid},
            inset-block-start ${motionDurationMid},
            width ${motionDurationMid},
            height ${motionDurationMid},
            box-shadow ${motionDurationMid},
            outline ${motionDurationMid}
          `
                },
                '&:hover, &:active, &:focus': {
                    '&::before': {
                        insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
                        height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
                    },
                    '&::after': {
                        boxShadow: `0 0 0 ${(0, $4g3I0.unit)(handleLineWidthHover)} ${handleActiveColor}`,
                        outline: `6px solid ${handleActiveOutlineColor}`,
                        width: handleSizeHover,
                        height: handleSizeHover,
                        insetInlineStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal(),
                        insetBlockStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal()
                    }
                }
            },
            [`&-lock ${componentCls}-handle`]: {
                '&::before, &::after': {
                    transition: 'none'
                }
            },
            [`${componentCls}-mark`]: {
                position: 'absolute',
                fontSize: token.fontSize
            },
            [`${componentCls}-mark-text`]: {
                position: 'absolute',
                display: 'inline-block',
                color: token.colorTextDescription,
                textAlign: 'center',
                wordBreak: 'keep-all',
                cursor: 'pointer',
                userSelect: 'none',
                '&-active': {
                    color: token.colorText
                }
            },
            [`${componentCls}-step`]: {
                position: 'absolute',
                background: 'transparent',
                pointerEvents: 'none'
            },
            [`${componentCls}-dot`]: {
                position: 'absolute',
                width: dotSize,
                height: dotSize,
                backgroundColor: token.colorBgElevated,
                border: `${(0, $4g3I0.unit)(handleLineWidth)} solid ${token.dotBorderColor}`,
                borderRadius: '50%',
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                pointerEvents: 'auto',
                '&-active': {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`&${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [`${componentCls}-rail`]: {
                    backgroundColor: `${token.railBg} !important`
                },
                [`${componentCls}-track`]: {
                    backgroundColor: `${token.trackBgDisabled} !important`
                },
                [`
          ${componentCls}-dot
        `]: {
                    backgroundColor: token.colorBgElevated,
                    borderColor: token.trackBgDisabled,
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                },
                [`${componentCls}-handle::after`]: {
                    backgroundColor: token.colorBgElevated,
                    cursor: 'not-allowed',
                    width: handleSize,
                    height: handleSize,
                    boxShadow: `0 0 0 ${(0, $4g3I0.unit)(handleLineWidth)} ${handleColorDisabled}`,
                    insetInlineStart: 0,
                    insetBlockStart: 0
                },
                [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
                    cursor: `not-allowed !important`
                }
            },
            [`&-tooltip ${antCls}-tooltip-inner`]: {
                minWidth: 'unset'
            }
        })
    };
};
// ============================ Horizontal ============================
const $5e43b51e27332d22$var$genDirectionStyle = (token, horizontal)=>{
    const { componentCls: componentCls, railSize: railSize, handleSize: handleSize, dotSize: dotSize, marginFull: marginFull, calc: calc } = token;
    const railPadding = horizontal ? 'paddingBlock' : 'paddingInline';
    const full = horizontal ? 'width' : 'height';
    const part = horizontal ? 'height' : 'width';
    const handlePos = horizontal ? 'insetBlockStart' : 'insetInlineStart';
    const markInset = horizontal ? 'top' : 'insetInlineStart';
    const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
    const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
    const draggableBorder = horizontal ? {
        borderWidth: `${(0, $4g3I0.unit)(draggableBorderSize)} 0`,
        transform: `translateY(${(0, $4g3I0.unit)(calc(draggableBorderSize).mul(-1).equal())})`
    } : {
        borderWidth: `0 ${(0, $4g3I0.unit)(draggableBorderSize)}`,
        transform: `translateX(${(0, $4g3I0.unit)(token.calc(draggableBorderSize).mul(-1).equal())})`
    };
    return {
        [railPadding]: railSize,
        [part]: calc(railSize).mul(3).equal(),
        [`${componentCls}-rail`]: {
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-track,${componentCls}-tracks`]: {
            [part]: railSize
        },
        [`${componentCls}-track-draggable`]: Object.assign({}, draggableBorder),
        [`${componentCls}-handle`]: {
            [handlePos]: handlePosSize
        },
        [`${componentCls}-mark`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            // https://github.com/ant-design/ant-design/issues/43731
            [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
            [full]: '100%'
        },
        [`${componentCls}-step`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            [markInset]: railSize,
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-dot`]: {
            position: 'absolute',
            [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
        }
    };
};
// ============================ Horizontal ============================
const $5e43b51e27332d22$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, marginPartWithMark: marginPartWithMark } = token;
    return {
        [`${componentCls}-horizontal`]: Object.assign(Object.assign({}, $5e43b51e27332d22$var$genDirectionStyle(token, true)), {
            [`&${componentCls}-with-marks`]: {
                marginBottom: marginPartWithMark
            }
        })
    };
};
// ============================= Vertical =============================
const $5e43b51e27332d22$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-vertical`]: Object.assign(Object.assign({}, $5e43b51e27332d22$var$genDirectionStyle(token, false)), {
            height: '100%'
        })
    };
};
const $5e43b51e27332d22$export$9ca1be8807fe0675 = (token)=>{
    // Handle line width is always width-er 1px
    const increaseHandleWidth = 1;
    const controlSize = token.controlHeightLG / 4;
    const controlSizeHover = token.controlHeightSM / 2;
    const handleLineWidth = token.lineWidth + increaseHandleWidth;
    const handleLineWidthHover = token.lineWidth + increaseHandleWidth * 1.5;
    const handleActiveColor = token.colorPrimary;
    const handleActiveOutlineColor = new (0, $6xABB.FastColor)(handleActiveColor).setA(0.2).toRgbString();
    return {
        controlSize: controlSize,
        railSize: 4,
        handleSize: controlSize,
        handleSizeHover: controlSizeHover,
        dotSize: 8,
        handleLineWidth: handleLineWidth,
        handleLineWidthHover: handleLineWidthHover,
        railBg: token.colorFillTertiary,
        railHoverBg: token.colorFillSecondary,
        trackBg: token.colorPrimaryBorder,
        trackHoverBg: token.colorPrimaryBorderHover,
        handleColor: token.colorPrimaryBorder,
        handleActiveColor: handleActiveColor,
        handleActiveOutlineColor: handleActiveOutlineColor,
        handleColorDisabled: new (0, $6xABB.FastColor)(token.colorTextDisabled).onBackground(token.colorBgContainer).toHexString(),
        dotBorderColor: token.colorBorderSecondary,
        dotActiveBorderColor: token.colorPrimaryBorder,
        trackBgDisabled: token.colorBgContainerDisabled
    };
};
var $5e43b51e27332d22$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Slider', (token)=>{
    const sliderToken = (0, $8APUt.merge)(token, {
        marginPart: token.calc(token.controlHeight).sub(token.controlSize).div(2).equal(),
        marginFull: token.calc(token.controlSize).div(2).equal(),
        marginPartWithMark: token.calc(token.controlHeightLG).sub(token.controlSize).equal()
    });
    return [
        $5e43b51e27332d22$var$genBaseStyle(sliderToken),
        $5e43b51e27332d22$var$genHorizontalStyle(sliderToken),
        $5e43b51e27332d22$var$genVerticalStyle(sliderToken)
    ];
}, $5e43b51e27332d22$export$9ca1be8807fe0675);



var $jMaZ8 = parcelRequire("jMaZ8");

var $aZxvk = parcelRequire("aZxvk");
function $4da49c549fe6b501$export$2e2bcd8739ae039() {
    const [state, setState] = $jMaZ8.useState(false);
    const rafRef = $jMaZ8.useRef(null);
    const cleanup = ()=>{
        (0, $aZxvk.default).cancel(rafRef.current);
    };
    const setDelayState = (nextState)=>{
        cleanup();
        if (nextState) setState(nextState);
        else rafRef.current = (0, $aZxvk.default)(()=>{
            setState(nextState);
        });
    };
    $jMaZ8.useEffect(()=>cleanup, []);
    return [
        state,
        setDelayState
    ];
}


"use client";
var $bb290b37c61d241a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $bb290b37c61d241a$var$getTipFormatter(tipFormatter, legacyTipFormatter) {
    if (tipFormatter || tipFormatter === null) return tipFormatter;
    if (legacyTipFormatter || legacyTipFormatter === null) return legacyTipFormatter;
    return (val)=>typeof val === 'number' ? val.toString() : '';
}
const $bb290b37c61d241a$var$Slider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).forwardRef((props, ref)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { prefixCls: customizePrefixCls, range: range, className: className, rootClassName: rootClassName, style: style, disabled: disabled, // Deprecated Props
    tooltipPrefixCls: legacyTooltipPrefixCls, tipFormatter: legacyTipFormatter, tooltipVisible: legacyTooltipVisible, getTooltipPopupContainer: legacyGetTooltipPopupContainer, tooltipPlacement: legacyTooltipPlacement, tooltip: tooltip = {}, onChangeComplete: onChangeComplete, classNames: sliderClassNames, styles: styles } = props, restProps = $bb290b37c61d241a$var$__rest(props, [
        "prefixCls",
        "range",
        "className",
        "rootClassName",
        "style",
        "disabled",
        "tooltipPrefixCls",
        "tipFormatter",
        "tooltipVisible",
        "getTooltipPopupContainer",
        "tooltipPlacement",
        "tooltip",
        "onChangeComplete",
        "classNames",
        "styles"
    ]);
    const { vertical: vertical } = props;
    const { direction: contextDirection, slider: slider, getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer } = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $fb8ef783ef39e103$export$2e2bcd8739ae039));
    const mergedDisabled = disabled !== null && disabled !== void 0 ? disabled : contextDisabled;
    // ============================= Context ==============================
    const { handleRender: contextHandleRender, direction: internalContextDirection } = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useContext((0, $9a5de0f3fc141591$export$2e2bcd8739ae039));
    const mergedDirection = internalContextDirection || contextDirection;
    const isRTL = mergedDirection === 'rtl';
    // =============================== Open ===============================
    const [hoverOpen, setHoverOpen] = (0, $4da49c549fe6b501$export$2e2bcd8739ae039)();
    const [focusOpen, setFocusOpen] = (0, $4da49c549fe6b501$export$2e2bcd8739ae039)();
    const tooltipProps = Object.assign({}, tooltip);
    const { open: tooltipOpen, placement: tooltipPlacement, getPopupContainer: getTooltipPopupContainer, prefixCls: customizeTooltipPrefixCls, formatter: tipFormatter } = tooltipProps;
    const lockOpen = tooltipOpen !== null && tooltipOpen !== void 0 ? tooltipOpen : legacyTooltipVisible;
    const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
    const mergedTipFormatter = $bb290b37c61d241a$var$getTipFormatter(tipFormatter, legacyTipFormatter);
    // ============================= Change ==============================
    const [dragging, setDragging] = (0, $4da49c549fe6b501$export$2e2bcd8739ae039)();
    const onInternalChangeComplete = (nextValues)=>{
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(nextValues);
        setDragging(false);
    };
    // ============================ Placement ============================
    const getTooltipPlacement = (placement, vert)=>{
        if (placement) return placement;
        if (!vert) return 'top';
        return isRTL ? 'left' : 'right';
    };
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('slider', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $5e43b51e27332d22$export$2e2bcd8739ae039)(prefixCls);
    const rootClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(className, slider === null || slider === void 0 ? void 0 : slider.className, (_a = slider === null || slider === void 0 ? void 0 : slider.classNames) === null || _a === void 0 ? void 0 : _a.root, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.root, rootClassName, {
        [`${prefixCls}-rtl`]: isRTL,
        [`${prefixCls}-lock`]: dragging
    }, hashId, cssVarCls);
    // make reverse default on rtl direction
    if (isRTL && !restProps.vertical) restProps.reverse = !restProps.reverse;
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Slider');
        [
            [
                'tooltipPrefixCls',
                'prefixCls'
            ],
            [
                'getTooltipPopupContainer',
                'getPopupContainer'
            ],
            [
                'tipFormatter',
                'formatter'
            ],
            [
                'tooltipPlacement',
                'placement'
            ],
            [
                'tooltipVisible',
                'open'
            ]
        ].forEach((_ref)=>{
            let [deprecatedName, newName] = _ref;
            warning.deprecated(!(deprecatedName in props), deprecatedName, `tooltip.${newName}`);
        });
    }
    // ============================== Handle ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(()=>{
        const onMouseUp = ()=>{
            // Delay for 1 frame to make the click to enable hide tooltip
            // even when the handle is focused
            (0, $aZxvk.default)(()=>{
                setFocusOpen(false);
            }, 1);
        };
        document.addEventListener('mouseup', onMouseUp);
        return ()=>{
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);
    const useActiveTooltipHandle = range && !lockOpen;
    const handleRender = contextHandleRender || ((node, info)=>{
        const { index: index } = info;
        const nodeProps = node.props;
        function proxyEvent(eventName, event, triggerRestPropsEvent) {
            var _a, _b, _c, _d;
            if (triggerRestPropsEvent) (_b = (_a = restProps)[eventName]) === null || _b === void 0 || _b.call(_a, event);
            (_d = (_c = nodeProps)[eventName]) === null || _d === void 0 || _d.call(_c, event);
        }
        const passedProps = Object.assign(Object.assign({}, nodeProps), {
            onMouseEnter: (e)=>{
                setHoverOpen(true);
                proxyEvent('onMouseEnter', e);
            },
            onMouseLeave: (e)=>{
                setHoverOpen(false);
                proxyEvent('onMouseLeave', e);
            },
            onMouseDown: (e)=>{
                setFocusOpen(true);
                setDragging(true);
                proxyEvent('onMouseDown', e);
            },
            onFocus: (e)=>{
                var _a;
                setFocusOpen(true);
                (_a = restProps.onFocus) === null || _a === void 0 || _a.call(restProps, e);
                proxyEvent('onFocus', e, true);
            },
            onBlur: (e)=>{
                var _a;
                setFocusOpen(false);
                (_a = restProps.onBlur) === null || _a === void 0 || _a.call(restProps, e);
                proxyEvent('onBlur', e, true);
            }
        });
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(node, passedProps);
        const open = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
        // Wrap on handle with Tooltip when is single mode or multiple with all show tooltip
        if (!useActiveTooltipHandle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $eab36eac712f5797$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
            open: open,
            placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
            key: index,
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer
        }), cloneNode);
        return cloneNode;
    });
    // ========================== Active Handle ===========================
    const activeHandleRender = useActiveTooltipHandle ? (handle, info)=>{
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).cloneElement(handle, {
            style: Object.assign(Object.assign({}, handle.props.style), {
                visibility: 'hidden'
            })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $eab36eac712f5797$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
            open: mergedTipFormatter !== null && activeOpen,
            placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
            key: "tooltip",
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer,
            draggingDelete: info.draggingDelete
        }), cloneNode);
    } : undefined;
    // ============================== Render ==============================
    const rootStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, (_b = slider === null || slider === void 0 ? void 0 : slider.styles) === null || _b === void 0 ? void 0 : _b.root), slider === null || slider === void 0 ? void 0 : slider.style), styles === null || styles === void 0 ? void 0 : styles.root), style);
    const mergedTracks = Object.assign(Object.assign({}, (_c = slider === null || slider === void 0 ? void 0 : slider.styles) === null || _c === void 0 ? void 0 : _c.tracks), styles === null || styles === void 0 ? void 0 : styles.tracks);
    const mergedTracksClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_d = slider === null || slider === void 0 ? void 0 : slider.classNames) === null || _d === void 0 ? void 0 : _d.tracks, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.tracks);
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).createElement((0, $b4b1c00b9c835f66$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        classNames: Object.assign({
            handle: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_e = slider === null || slider === void 0 ? void 0 : slider.classNames) === null || _e === void 0 ? void 0 : _e.handle, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.handle),
            rail: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_f = slider === null || slider === void 0 ? void 0 : slider.classNames) === null || _f === void 0 ? void 0 : _f.rail, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.rail),
            track: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((_g = slider === null || slider === void 0 ? void 0 : slider.classNames) === null || _g === void 0 ? void 0 : _g.track, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.track)
        }, mergedTracksClassNames ? {
            tracks: mergedTracksClassNames
        } : {}),
        styles: Object.assign({
            handle: Object.assign(Object.assign({}, (_h = slider === null || slider === void 0 ? void 0 : slider.styles) === null || _h === void 0 ? void 0 : _h.handle), styles === null || styles === void 0 ? void 0 : styles.handle),
            rail: Object.assign(Object.assign({}, (_j = slider === null || slider === void 0 ? void 0 : slider.styles) === null || _j === void 0 ? void 0 : _j.rail), styles === null || styles === void 0 ? void 0 : styles.rail),
            track: Object.assign(Object.assign({}, (_k = slider === null || slider === void 0 ? void 0 : slider.styles) === null || _k === void 0 ? void 0 : _k.track), styles === null || styles === void 0 ? void 0 : styles.track)
        }, Object.keys(mergedTracks).length ? {
            tracks: mergedTracks
        } : {}),
        step: restProps.step,
        range: range,
        className: rootClassNames,
        style: rootStyle,
        disabled: mergedDisabled,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: onInternalChangeComplete
    })));
});
$bb290b37c61d241a$var$Slider.displayName = 'Slider';
var $bb290b37c61d241a$export$2e2bcd8739ae039 = $bb290b37c61d241a$var$Slider;



const $8e411226cda9588c$var$sliderOptions = {
    min: 0.9,
    max: 1.3,
    step: 0.01,
    style: {
        width: "8em"
    },
    tooltip: {
        formatter: (n)=>((n || 0) * 100).toFixed(0) + "%"
    },
    marks: {
        "0.9": {
            style: {
                color: "black"
            },
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                style: {
                    fontSize: "1em",
                    lineHeight: "2em"
                },
                children: "a"
            })
        },
        "1.3": {
            style: {
                color: "black"
            },
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                style: {
                    fontSize: "2em",
                    lineHeight: "1em"
                },
                children: "a"
            })
        }
    }
};
const $8e411226cda9588c$var$SliderFontSize = ({ style: style })=>{
    const { value: value, onChange: onChange } = (0, $a4507719465753c1$export$97e1252eeb182290)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("menu", {
        className: style,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $bb290b37c61d241a$export$2e2bcd8739ae039), {
            onChange: onChange,
            value: value,
            ...$8e411226cda9588c$var$sliderOptions
        })
    });
};
var $8e411226cda9588c$export$2e2bcd8739ae039 = $8e411226cda9588c$var$SliderFontSize;




parcelRequire("jMaZ8");


parcelRequire("jMaZ8");
function $44590071a26e5872$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        style: {
            flex: 1,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: children
    });
}



var $jMaZ8 = parcelRequire("jMaZ8");




var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $3ce8fa7811b74f28$var$WarningFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "filled"
};
var $3ce8fa7811b74f28$export$2e2bcd8739ae039 = $3ce8fa7811b74f28$var$WarningFilled;



var $c6f88845f165fa3d$var$WarningFilled = function WarningFilled(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $3ce8fa7811b74f28$export$2e2bcd8739ae039)
    }));
};
/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1NS43IDg1NmwtNDE2LTcyMGMtNi4yLTEwLjctMTYuOS0xNi0yNy43LTE2cy0yMS42IDUuMy0yNy43IDE2bC00MTYgNzIwQzU2IDg3Ny40IDcxLjQgOTA0IDk2IDkwNGg4MzJjMjQuNiAwIDQwLTI2LjYgMjcuNy00OHpNNDgwIDQxNmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djE4NGMwIDQuNC0zLjYgOC04IDhoLTQ4Yy00LjQgMC04LTMuNi04LThWNDE2em0zMiAzNTJhNDguMDEgNDguMDEgMCAwMTAtOTYgNDguMDEgNDguMDEgMCAwMTAgOTZ6IiAvPjwvc3ZnPg==) */ var $c6f88845f165fa3d$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($c6f88845f165fa3d$var$WarningFilled);
$c6f88845f165fa3d$var$RefIcon.displayName = 'WarningFilled';
var $c6f88845f165fa3d$export$2e2bcd8739ae039 = $c6f88845f165fa3d$var$RefIcon;



var $giSak = parcelRequire("giSak");



var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $1043d67c2ba755ed$var$NoFound = ()=>/*#__PURE__*/ $jMaZ8.createElement("svg", {
        width: "252",
        height: "294"
    }, /*#__PURE__*/ $jMaZ8.createElement("title", null, "No Found"), /*#__PURE__*/ $jMaZ8.createElement("defs", null, /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M0 .387h251.772v251.772H0z"
    })), /*#__PURE__*/ $jMaZ8.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $jMaZ8.createElement("g", {
        transform: "translate(0 .012)"
    }, /*#__PURE__*/ $jMaZ8.createElement("mask", {
        fill: "#fff"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
        fill: "#E4EBF7",
        mask: "url(#b)"
    })), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
        stroke: "#FFF",
        strokeWidth: "2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
        stroke: "#FFF",
        strokeWidth: "2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
        stroke: "#FFF",
        strokeWidth: "2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        stroke: "#FFF",
        strokeWidth: "2",
        d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
        fill: "#1677ff"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
        fill: "#FFB594"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
        fill: "#CBD1D1"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
        fill: "#2B0849"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
        fill: "#A4AABA"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
        fill: "#CBD1D1"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
        fill: "#2B0849"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
        fill: "#A4AABA"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
        fill: "#7BB2F9"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
        stroke: "#648BD8",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M107.275 222.1s2.773-1.11 6.102-3.884",
        stroke: "#648BD8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
        stroke: "#648BD8",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
        fill: "#192064"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
        fill: "#192064"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
        stroke: "#648BD8",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
        fill: "#520038"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
        fill: "#552950"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        stroke: "#DB836E",
        strokeWidth: "1.118",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M110.846 74.481s1.79-.716 2.506.537",
        stroke: "#5C2552",
        strokeWidth: "1.118",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
        stroke: "#DB836E",
        strokeWidth: "1.118",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M103.287 72.93s1.83 1.113 4.137.954",
        stroke: "#5C2552",
        strokeWidth: "1.118",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
        stroke: "#DB836E",
        strokeWidth: "1.118",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
        stroke: "#E4EBF7",
        strokeWidth: "1.101",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
        stroke: "#E4EBF7",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M119.306 107.329s.452 4.366-2.127 32.062",
        stroke: "#E4EBF7",
        strokeWidth: "1.101",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
        fill: "#F2D7AD"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
        fill: "#F4D19D"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
        fill: "#F2D7AD"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        fill: "#CC9B6E",
        d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
        fill: "#F4D19D"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        fill: "#CC9B6E",
        d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        fill: "#CC9B6E",
        d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
        stroke: "#DB836E",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
        stroke: "#DB836E",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
        stroke: "#DB836E",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
        fill: "#5BA02E"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
        fill: "#92C110"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
        fill: "#F2D7AD"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M88.979 89.48s7.776 5.384 16.6 2.842",
        stroke: "#E4EBF7",
        strokeWidth: "1.101",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));
var $1043d67c2ba755ed$export$2e2bcd8739ae039 = $1043d67c2ba755ed$var$NoFound;



var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $1a1ef2c0858f52bd$var$ServerError = ()=>/*#__PURE__*/ $jMaZ8.createElement("svg", {
        width: "254",
        height: "294"
    }, /*#__PURE__*/ $jMaZ8.createElement("title", null, "Server Error"), /*#__PURE__*/ $jMaZ8.createElement("defs", null, /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M0 .335h253.49v253.49H0z"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M0 293.665h253.49V.401H0z"
    })), /*#__PURE__*/ $jMaZ8.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $jMaZ8.createElement("g", {
        transform: "translate(0 .067)"
    }, /*#__PURE__*/ $jMaZ8.createElement("mask", {
        fill: "#fff"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
        fill: "#E4EBF7",
        mask: "url(#b)"
    })), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
        stroke: "#FFF",
        strokeWidth: "2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
        fill: "#FF603B"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
        fill: "#FFB594"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
        fill: "#FFB594"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
        fill: "#520038"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
        fill: "#552950"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        stroke: "#DB836E",
        strokeWidth: "1.063",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M99.926 73.284s1.8-.72 2.52.54",
        stroke: "#5C2552",
        strokeWidth: "1.117",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
        stroke: "#DB836E",
        strokeWidth: "1.117",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M92.326 71.724s1.84 1.12 4.16.96",
        stroke: "#5C2552",
        strokeWidth: "1.117",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
        stroke: "#DB836E",
        strokeWidth: "1.063",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
        stroke: "#E4EBF7",
        strokeWidth: "1.136",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
        stroke: "#E4EBF7",
        strokeWidth: "1.085",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
        fill: "#CBD1D1"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
        fill: "#2B0849"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
        fill: "#A4AABA"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
        fill: "#CBD1D1"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
        fill: "#2B0849"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
        fill: "#A4AABA"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
        fill: "#7BB2F9"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
        stroke: "#648BD8",
        strokeWidth: "1.085",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M96.973 219.373s2.882-1.153 6.34-4.034",
        stroke: "#648BD8",
        strokeWidth: "1.032",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
        stroke: "#648BD8",
        strokeWidth: "1.085",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
        fill: "#192064"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
        fill: "#192064"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
        stroke: "#648BD8",
        strokeWidth: "1.085",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
        stroke: "#E4EBF7",
        strokeWidth: "1.085",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
        stroke: "#DB836E",
        strokeWidth: ".774",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
        stroke: "#E59788",
        strokeWidth: ".774",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
        stroke: "#E59788",
        strokeWidth: ".774",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M109.278 112.533s3.38-3.613 7.575-4.662",
        stroke: "#E4EBF7",
        strokeWidth: "1.085",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M107.375 123.006s9.697-2.745 11.445-.88",
        stroke: "#E59788",
        strokeWidth: ".774",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
        stroke: "#BFCDDD",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
        fill: "#A3B4C6"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
        fill: "#A3B4C6"
    }), /*#__PURE__*/ $jMaZ8.createElement("mask", {
        fill: "#fff"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        fill: "#A3B4C6",
        mask: "url(#d)",
        d: "M154.098 190.096h70.513v-84.617h-70.513z"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
        fill: "#BFCDDD",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
        fill: "#FFF",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
        fill: "#BFCDDD",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
        stroke: "#7C90A5",
        strokeWidth: "1.124",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
        fill: "#FFF",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
        fill: "#BFCDDD",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M177.259 207.217v11.52M201.05 207.217v11.52",
        stroke: "#A3B4C6",
        strokeWidth: "1.124",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
        fill: "#5BA02E",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
        fill: "#92C110",
        mask: "url(#d)"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
        fill: "#F2D7AD",
        mask: "url(#d)"
    })));
var $1a1ef2c0858f52bd$export$2e2bcd8739ae039 = $1a1ef2c0858f52bd$var$ServerError;


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");
parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// ============================== Styles ==============================
const $a39300e69f367eb2$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, lineHeightHeading3: lineHeightHeading3, iconCls: iconCls, padding: padding, paddingXL: paddingXL, paddingXS: paddingXS, paddingLG: paddingLG, marginXS: marginXS, lineHeight: lineHeight } = token;
    return {
        // Result
        [componentCls]: {
            padding: `${(0, $4g3I0.unit)(token.calc(paddingLG).mul(2).equal())} ${(0, $4g3I0.unit)(paddingXL)}`,
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // Exception Status image
        [`${componentCls} ${componentCls}-image`]: {
            width: token.imageWidth,
            height: token.imageHeight,
            margin: 'auto'
        },
        [`${componentCls} ${componentCls}-icon`]: {
            marginBottom: paddingLG,
            textAlign: 'center',
            [`& > ${iconCls}`]: {
                fontSize: token.iconFontSize
            }
        },
        [`${componentCls} ${componentCls}-title`]: {
            color: token.colorTextHeading,
            fontSize: token.titleFontSize,
            lineHeight: lineHeightHeading3,
            marginBlock: marginXS,
            textAlign: 'center'
        },
        [`${componentCls} ${componentCls}-subtitle`]: {
            color: token.colorTextDescription,
            fontSize: token.subtitleFontSize,
            lineHeight: lineHeight,
            textAlign: 'center'
        },
        [`${componentCls} ${componentCls}-content`]: {
            marginTop: paddingLG,
            padding: `${(0, $4g3I0.unit)(paddingLG)} ${(0, $4g3I0.unit)(token.calc(padding).mul(2.5).equal())}`,
            backgroundColor: token.colorFillAlter
        },
        [`${componentCls} ${componentCls}-extra`]: {
            margin: token.extraMargin,
            textAlign: 'center',
            '& > *': {
                marginInlineEnd: paddingXS,
                '&:last-child': {
                    marginInlineEnd: 0
                }
            }
        }
    };
};
const $a39300e69f367eb2$var$genStatusIconStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls } = token;
    return {
        [`${componentCls}-success ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultSuccessIconColor
        },
        [`${componentCls}-error ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultErrorIconColor
        },
        [`${componentCls}-info ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultInfoIconColor
        },
        [`${componentCls}-warning ${componentCls}-icon > ${iconCls}`]: {
            color: token.resultWarningIconColor
        }
    };
};
const $a39300e69f367eb2$var$genResultStyle = (token)=>[
        $a39300e69f367eb2$var$genBaseStyle(token),
        $a39300e69f367eb2$var$genStatusIconStyle(token)
    ];
const $a39300e69f367eb2$var$getStyle = (token)=>$a39300e69f367eb2$var$genResultStyle(token);
const $a39300e69f367eb2$export$9ca1be8807fe0675 = (token)=>({
        titleFontSize: token.fontSizeHeading3,
        subtitleFontSize: token.fontSize,
        iconFontSize: token.fontSizeHeading3 * 3,
        extraMargin: `${token.paddingLG}px 0 0 0`
    });
var $a39300e69f367eb2$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Result', (token)=>{
    const resultInfoIconColor = token.colorInfo;
    const resultErrorIconColor = token.colorError;
    const resultSuccessIconColor = token.colorSuccess;
    const resultWarningIconColor = token.colorWarning;
    const resultToken = (0, $8APUt.merge)(token, {
        resultInfoIconColor: resultInfoIconColor,
        resultErrorIconColor: resultErrorIconColor,
        resultSuccessIconColor: resultSuccessIconColor,
        resultWarningIconColor: resultWarningIconColor,
        imageWidth: 250,
        imageHeight: 295
    });
    return [
        $a39300e69f367eb2$var$getStyle(resultToken)
    ];
}, $a39300e69f367eb2$export$9ca1be8807fe0675);



var $jMaZ8 = parcelRequire("jMaZ8");
"use client";
const $354cb0207741701c$var$Unauthorized = ()=>/*#__PURE__*/ $jMaZ8.createElement("svg", {
        width: "251",
        height: "294"
    }, /*#__PURE__*/ $jMaZ8.createElement("title", null, "Unauthorized"), /*#__PURE__*/ $jMaZ8.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
        fill: "#E4EBF7"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
        stroke: "#FFF",
        strokeWidth: "2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
        stroke: "#FFF",
        strokeWidth: "2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
        stroke: "#FFF",
        strokeWidth: "2"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        stroke: "#FFF",
        strokeWidth: "2",
        d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
        fill: "#A26EF4"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
        fill: "#5BA02E"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
        fill: "#92C110"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
        fill: "#F2D7AD"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
        fill: "#FFB594"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M78.18 94.656s.911 7.41-4.914 13.078",
        stroke: "#E4EBF7",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
        stroke: "#E4EBF7",
        strokeWidth: ".932",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
        fill: "#FFB594"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
        fill: "#5C2552"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        stroke: "#DB836E",
        strokeWidth: "1.145",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
        fill: "#552950"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M91.132 86.786s5.269 4.957 12.679 2.327",
        stroke: "#DB836E",
        strokeWidth: "1.145",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
        fill: "#DB836E"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
        stroke: "#5C2552",
        strokeWidth: "1.526",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
        stroke: "#DB836E",
        strokeWidth: "1.145",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
        stroke: "#E4EBF7",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
        stroke: "#E4EBF7",
        strokeWidth: "1.114",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M128.31 87.934s3.013 4.121 4.06 11.785",
        stroke: "#E4EBF7",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
        stroke: "#DB836E",
        strokeWidth: ".795",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
        fill: "#FFC6A0"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M130.532 85.488s4.588 5.757 11.619 6.214",
        stroke: "#DB836E",
        strokeWidth: ".75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M121.708 105.73s-.393 8.564-1.34 13.612",
        stroke: "#E4EBF7",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
        stroke: "#648BD8",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
        fill: "#CBD1D1"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
        fill: "#2B0849"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
        fill: "#A4AABA"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
        fill: "#CBD1D1"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
        fill: "#2B0849"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
        fill: "#A4AABA"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
        fill: "#7BB2F9"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
        stroke: "#648BD8",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M108.459 220.905s2.759-1.104 6.07-3.863",
        stroke: "#648BD8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
        stroke: "#648BD8",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
        fill: "#192064"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
        fill: "#FFF"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
        fill: "#192064"
    }), /*#__PURE__*/ $jMaZ8.createElement("path", {
        d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
        stroke: "#648BD8",
        strokeWidth: "1.051",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));
var $354cb0207741701c$export$2e2bcd8739ae039 = $354cb0207741701c$var$Unauthorized;


"use client";
const $4a1bb561fc98ba0c$export$e75cf43d5d0a9444 = {
    success: (0, $0c6fc91d0a76dd61$export$2e2bcd8739ae039),
    error: (0, $93361570ffc8bbe1$export$2e2bcd8739ae039),
    info: (0, $5244cb05538dbe0c$export$2e2bcd8739ae039),
    warning: (0, $c6f88845f165fa3d$export$2e2bcd8739ae039)
};
const $4a1bb561fc98ba0c$export$14ba5e3dd65c935a = {
    '404': (0, $1043d67c2ba755ed$export$2e2bcd8739ae039),
    '500': (0, $1a1ef2c0858f52bd$export$2e2bcd8739ae039),
    '403': (0, $354cb0207741701c$export$2e2bcd8739ae039)
};
// ExceptionImageMap keys
const $4a1bb561fc98ba0c$var$ExceptionStatus = Object.keys($4a1bb561fc98ba0c$export$14ba5e3dd65c935a);
const $4a1bb561fc98ba0c$var$Icon = (_ref)=>{
    let { prefixCls: prefixCls, icon: icon, status: status } = _ref;
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-icon`);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Result');
        warning(!(typeof icon === 'string' && icon.length > 2), 'breaking', `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`);
    }
    if ($4a1bb561fc98ba0c$var$ExceptionStatus.includes(`${status}`)) {
        const SVGComponent = $4a1bb561fc98ba0c$export$14ba5e3dd65c935a[status];
        return /*#__PURE__*/ $jMaZ8.createElement("div", {
            className: `${className} ${prefixCls}-image`
        }, /*#__PURE__*/ $jMaZ8.createElement(SVGComponent, null));
    }
    const iconNode = /*#__PURE__*/ $jMaZ8.createElement($4a1bb561fc98ba0c$export$e75cf43d5d0a9444[status]);
    if (icon === null || icon === false) return null;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: className
    }, icon || iconNode);
};
const $4a1bb561fc98ba0c$var$Extra = (_ref2)=>{
    let { prefixCls: prefixCls, extra: extra } = _ref2;
    if (!extra) return null;
    return /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-extra`
    }, extra);
};
const $4a1bb561fc98ba0c$var$Result = (_ref3)=>{
    let { prefixCls: customizePrefixCls, className: customizeClassName, rootClassName: rootClassName, subTitle: subTitle, title: title, style: style, children: children, status: status = 'info', icon: icon, extra: extra } = _ref3;
    const { getPrefixCls: getPrefixCls, direction: direction, result: result } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('result', customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $a39300e69f367eb2$export$2e2bcd8739ae039)(prefixCls);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-${status}`, customizeClassName, result === null || result === void 0 ? void 0 : result.className, rootClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.style), style);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: className,
        style: mergedStyle
    }, /*#__PURE__*/ $jMaZ8.createElement($4a1bb561fc98ba0c$var$Icon, {
        prefixCls: prefixCls,
        status: status,
        icon: icon
    }), /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-title`
    }, title), subTitle && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-subtitle`
    }, subTitle), /*#__PURE__*/ $jMaZ8.createElement($4a1bb561fc98ba0c$var$Extra, {
        prefixCls: prefixCls,
        extra: extra
    }), children && /*#__PURE__*/ $jMaZ8.createElement("div", {
        className: `${prefixCls}-content`
    }, children)));
};
$4a1bb561fc98ba0c$var$Result.PRESENTED_IMAGE_403 = $4a1bb561fc98ba0c$export$14ba5e3dd65c935a['403'];
$4a1bb561fc98ba0c$var$Result.PRESENTED_IMAGE_404 = $4a1bb561fc98ba0c$export$14ba5e3dd65c935a['404'];
$4a1bb561fc98ba0c$var$Result.PRESENTED_IMAGE_500 = $4a1bb561fc98ba0c$export$14ba5e3dd65c935a['500'];
$4a1bb561fc98ba0c$var$Result.displayName = 'Result';
var $4a1bb561fc98ba0c$export$2e2bcd8739ae039 = $4a1bb561fc98ba0c$var$Result;




function $b48f64e003f2eb7e$var$ImportOverviewRedirect() {
    const { bookId: bookId } = (0, $5c84a101a4932c49$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$444b3ab0cb9aec40), {
        to: `/editor/books/edit/${bookId}/overview`
    });
}
function $b48f64e003f2eb7e$export$2e2bcd8739ae039({ failed: failed, notImportedYet: notImportedYet, loading: loading }) {
    const nvaigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const t = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.importStatus");
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$3565eb3d00ca5a74), {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$e7b0ac011bb776c6), {
                    path: "/editor/books/edit/:bookId",
                    Component: $b48f64e003f2eb7e$var$ImportOverviewRedirect
                })
            }),
            failed && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $44590071a26e5872$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4a1bb561fc98ba0c$export$2e2bcd8739ae039), {
                    status: "500",
                    title: t.failed.title,
                    subTitle: t.failed.message,
                    extra: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        onClick: ()=>nvaigate("/"),
                        children: t.failed.action
                    })
                })
            }),
            notImportedYet && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $44590071a26e5872$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4a1bb561fc98ba0c$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $de3c5dab5cbf9179$export$7f7cbe89f1eacd2), {}),
                    title: t.inProgress.title,
                    subTitle: t.inProgress.message,
                    extra: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        onClick: ()=>nvaigate("/"),
                        children: t.inProgress.action
                    })
                })
            }),
            loading && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4a1bb561fc98ba0c$export$2e2bcd8739ae039), {
                        style: {
                            height: "100%",
                            paddingTop: "25%"
                        },
                        icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $de3c5dab5cbf9179$export$7f7cbe89f1eacd2), {}),
                        title: t.loading.title,
                        subTitle: t.loading.message,
                        extra: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            onClick: ()=>nvaigate("/"),
                            children: t.inProgress.action
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $de3c5dab5cbf9179$export$7f7cbe89f1eacd2), {})
                ]
            })
        ]
    });
}



/** Resolve current UTF-16 positions from the rhèse anchor and local letter index. */ function $75cb39c0d60bf319$export$dfe068021b69e8a4(node) {
    const element = node?.nodeType === 1 ? node : node?.parentElement;
    const letter = element?.closest(".letter,.ponctuation");
    const start = letter?.closest(".rhese")?.dataset.absolutePosition;
    const index = letter?.dataset.index;
    if (start === undefined || index === undefined) return undefined;
    const position = Number(start) + Number(index);
    return Number.isFinite(position) ? position : undefined;
}



var $jMaZ8 = parcelRequire("jMaZ8");


var $2a7535a2ddfb4c89$export$e8e78c978b129247;
var $2a7535a2ddfb4c89$export$f59a34a515108e87;
var $2a7535a2ddfb4c89$export$61b3ec0eac9cf83;
var $2a7535a2ddfb4c89$export$2e0b248dcb906f5a;
var $2a7535a2ddfb4c89$export$dcb338dde686ac99;
var $2a7535a2ddfb4c89$export$3cbeddca5d4cf2c6;
var $2a7535a2ddfb4c89$export$4681eb3349f427c7;
$2a7535a2ddfb4c89$export$e8e78c978b129247 = "root_c0a364";
$2a7535a2ddfb4c89$export$f59a34a515108e87 = "customRheseWrapper_c0a364";
$2a7535a2ddfb4c89$export$61b3ec0eac9cf83 = "editRhese_c0a364";
$2a7535a2ddfb4c89$export$2e0b248dcb906f5a = "btnBar_c0a364";
$2a7535a2ddfb4c89$export$dcb338dde686ac99 = "clonedRheseSyllable_c0a364";
$2a7535a2ddfb4c89$export$3cbeddca5d4cf2c6 = "clonedRhesePhoneme_c0a364";
$2a7535a2ddfb4c89$export$4681eb3349f427c7 = "clonedRheseDefinition_c0a364";












var $jMaZ8 = parcelRequire("jMaZ8");

const $b475e6138875e356$var$CONTROL_KEY = "Control";
const $b475e6138875e356$export$6b1e75a5561fc59c = ()=>{
    const updateDisplayedPageNumber = (0, $5b38bec19e3a4e47$export$81b3a8efdffa1495)();
    const [selectedTextPosition, setSelectedTextPosition] = (0, $jMaZ8.useState)({
        start: 0,
        size: 0
    });
    const [pressingControl, setPressingControl] = (0, $jMaZ8.useState)(false);
    const reset = (0, $jMaZ8.useCallback)(()=>{
        setSelectedTextPosition({
            start: 0,
            size: 0
        });
        window.getSelection()?.removeAllRanges();
    }, []);
    const saveSelection = (0, $jMaZ8.useCallback)(()=>{
        const selection = window.getSelection();
        if (!selection) return reset();
        let { focusNode: focusNode } = selection;
        // Replace url pageNumber to the one of the selection
        // Get the first parent with pageContent class
        const pageContent = focusNode?.parentElement?.closest(".pageContent");
        // Get page number
        const pageId = pageContent?.getAttribute?.("id")?.split("-")[1];
        if (pageId && pageId !== (new URLSearchParams(window.location.search).get("displayedPageNumber") || "")) updateDisplayedPageNumber(pageId);
        if (selection.toString().length === 0) {
            setSelectedTextPosition({
                start: ((0, $75cb39c0d60bf319$export$dfe068021b69e8a4)(focusNode) ?? 0) - (1 - selection?.anchorOffset),
                size: 0
            });
            return;
        }
        const pageLetters = focusNode?.parentElement?.closest('[id^="page-"]')?.querySelectorAll(".letter,.ponctuation");
        if (!pageLetters) return reset();
        const selectedLetters = [];
        for (const letter of pageLetters){
            if (!selection.containsNode(letter.childNodes[0] || letter, false)) continue;
            const position = (0, $75cb39c0d60bf319$export$dfe068021b69e8a4)(letter);
            if (position === undefined) throw new Error("Selected letter has no text position");
            selectedLetters.push(position);
        }
        selectedLetters.sort((a, b)=>a - b);
        if (selectedLetters.length === 0) {
            setSelectedTextPosition({
                start: (0, $75cb39c0d60bf319$export$dfe068021b69e8a4)(focusNode) ?? 0,
                size: 0
            });
            return;
        }
        const selectedPosition = {
            start: selectedLetters[0],
            size: selectedLetters[selectedLetters.length - 1] - selectedLetters[0] + 1
        };
        setSelectedTextPosition(selectedPosition);
    }, [
        reset,
        updateDisplayedPageNumber
    ]);
    // Save control pressed state
    (0, $jMaZ8.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === $b475e6138875e356$var$CONTROL_KEY) setPressingControl(true);
        };
        const handleKeyUp = (e)=>{
            if (e.key === $b475e6138875e356$var$CONTROL_KEY) setPressingControl(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    });
    return {
        selectedTextPosition: selectedTextPosition,
        saveSelection: saveSelection,
        reset: reset,
        pressingControl: pressingControl
    };
};





var $jMaZ8 = parcelRequire("jMaZ8");




var $cf14d593c82702d6$exports = {};
/*!

 diff v7.0.0

BSD 3-Clause License

Copyright (c) 2009-2015, Kevin Decker <kpdecker@gmail.com>
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this
   list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice,
   this list of conditions and the following disclaimer in the documentation
   and/or other materials provided with the distribution.

3. Neither the name of the copyright holder nor the names of its
   contributors may be used to endorse or promote products derived from
   this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

@license
*/ (function(global, factory) {
    factory($cf14d593c82702d6$exports);
})($cf14d593c82702d6$exports, function(exports) {
    'use strict';
    function Diff() {}
    Diff.prototype = {
        diff: function diff(oldString, newString) {
            var _options$timeout;
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var callback = options.callback;
            if (typeof options === 'function') {
                callback = options;
                options = {};
            }
            var self = this;
            function done(value) {
                value = self.postProcess(value, options);
                if (callback) {
                    setTimeout(function() {
                        callback(value);
                    }, 0);
                    return true;
                } else return value;
            }
            // Allow subclasses to massage the input prior to running
            oldString = this.castInput(oldString, options);
            newString = this.castInput(newString, options);
            oldString = this.removeEmpty(this.tokenize(oldString, options));
            newString = this.removeEmpty(this.tokenize(newString, options));
            var newLen = newString.length, oldLen = oldString.length;
            var editLength = 1;
            var maxEditLength = newLen + oldLen;
            if (options.maxEditLength != null) maxEditLength = Math.min(maxEditLength, options.maxEditLength);
            var maxExecutionTime = (_options$timeout = options.timeout) !== null && _options$timeout !== void 0 ? _options$timeout : Infinity;
            var abortAfterTimestamp = Date.now() + maxExecutionTime;
            var bestPath = [
                {
                    oldPos: -1,
                    lastComponent: undefined
                }
            ];
            // Seed editLength = 0, i.e. the content starts with the same values
            var newPos = this.extractCommon(bestPath[0], newString, oldString, 0, options);
            if (bestPath[0].oldPos + 1 >= oldLen && newPos + 1 >= newLen) // Identity per the equality and tokenizer
            return done(buildValues(self, bestPath[0].lastComponent, newString, oldString, self.useLongestToken));
            // Once we hit the right edge of the edit graph on some diagonal k, we can
            // definitely reach the end of the edit graph in no more than k edits, so
            // there's no point in considering any moves to diagonal k+1 any more (from
            // which we're guaranteed to need at least k+1 more edits).
            // Similarly, once we've reached the bottom of the edit graph, there's no
            // point considering moves to lower diagonals.
            // We record this fact by setting minDiagonalToConsider and
            // maxDiagonalToConsider to some finite value once we've hit the edge of
            // the edit graph.
            // This optimization is not faithful to the original algorithm presented in
            // Myers's paper, which instead pointlessly extends D-paths off the end of
            // the edit graph - see page 7 of Myers's paper which notes this point
            // explicitly and illustrates it with a diagram. This has major performance
            // implications for some common scenarios. For instance, to compute a diff
            // where the new text simply appends d characters on the end of the
            // original text of length n, the true Myers algorithm will take O(n+d^2)
            // time while this optimization needs only O(n+d) time.
            var minDiagonalToConsider = -Infinity, maxDiagonalToConsider = Infinity;
            // Main worker method. checks all permutations of a given edit length for acceptance.
            function execEditLength() {
                for(var diagonalPath = Math.max(minDiagonalToConsider, -editLength); diagonalPath <= Math.min(maxDiagonalToConsider, editLength); diagonalPath += 2){
                    var basePath = void 0;
                    var removePath = bestPath[diagonalPath - 1], addPath = bestPath[diagonalPath + 1];
                    if (removePath) // No one else is going to attempt to use this value, clear it
                    bestPath[diagonalPath - 1] = undefined;
                    var canAdd = false;
                    if (addPath) {
                        // what newPos will be after we do an insertion:
                        var addPathNewPos = addPath.oldPos - diagonalPath;
                        canAdd = addPath && 0 <= addPathNewPos && addPathNewPos < newLen;
                    }
                    var canRemove = removePath && removePath.oldPos + 1 < oldLen;
                    if (!canAdd && !canRemove) {
                        // If this path is a terminal then prune
                        bestPath[diagonalPath] = undefined;
                        continue;
                    }
                    // Select the diagonal that we want to branch from. We select the prior
                    // path whose position in the old string is the farthest from the origin
                    // and does not pass the bounds of the diff graph
                    if (!canRemove || canAdd && removePath.oldPos < addPath.oldPos) basePath = self.addToPath(addPath, true, false, 0, options);
                    else basePath = self.addToPath(removePath, false, true, 1, options);
                    newPos = self.extractCommon(basePath, newString, oldString, diagonalPath, options);
                    if (basePath.oldPos + 1 >= oldLen && newPos + 1 >= newLen) // If we have hit the end of both strings, then we are done
                    return done(buildValues(self, basePath.lastComponent, newString, oldString, self.useLongestToken));
                    else {
                        bestPath[diagonalPath] = basePath;
                        if (basePath.oldPos + 1 >= oldLen) maxDiagonalToConsider = Math.min(maxDiagonalToConsider, diagonalPath - 1);
                        if (newPos + 1 >= newLen) minDiagonalToConsider = Math.max(minDiagonalToConsider, diagonalPath + 1);
                    }
                }
                editLength++;
            }
            // Performs the length of edit iteration. Is a bit fugly as this has to support the
            // sync and async mode which is never fun. Loops over execEditLength until a value
            // is produced, or until the edit length exceeds options.maxEditLength (if given),
            // in which case it will return undefined.
            if (callback) (function exec() {
                setTimeout(function() {
                    if (editLength > maxEditLength || Date.now() > abortAfterTimestamp) return callback();
                    if (!execEditLength()) exec();
                }, 0);
            })();
            else while(editLength <= maxEditLength && Date.now() <= abortAfterTimestamp){
                var ret = execEditLength();
                if (ret) return ret;
            }
        },
        addToPath: function addToPath(path, added, removed, oldPosInc, options) {
            var last = path.lastComponent;
            if (last && !options.oneChangePerToken && last.added === added && last.removed === removed) return {
                oldPos: path.oldPos + oldPosInc,
                lastComponent: {
                    count: last.count + 1,
                    added: added,
                    removed: removed,
                    previousComponent: last.previousComponent
                }
            };
            else return {
                oldPos: path.oldPos + oldPosInc,
                lastComponent: {
                    count: 1,
                    added: added,
                    removed: removed,
                    previousComponent: last
                }
            };
        },
        extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath, options) {
            var newLen = newString.length, oldLen = oldString.length, oldPos = basePath.oldPos, newPos = oldPos - diagonalPath, commonCount = 0;
            while(newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(oldString[oldPos + 1], newString[newPos + 1], options)){
                newPos++;
                oldPos++;
                commonCount++;
                if (options.oneChangePerToken) basePath.lastComponent = {
                    count: 1,
                    previousComponent: basePath.lastComponent,
                    added: false,
                    removed: false
                };
            }
            if (commonCount && !options.oneChangePerToken) basePath.lastComponent = {
                count: commonCount,
                previousComponent: basePath.lastComponent,
                added: false,
                removed: false
            };
            basePath.oldPos = oldPos;
            return newPos;
        },
        equals: function equals(left, right, options) {
            if (options.comparator) return options.comparator(left, right);
            else return left === right || options.ignoreCase && left.toLowerCase() === right.toLowerCase();
        },
        removeEmpty: function removeEmpty(array) {
            var ret = [];
            for(var i = 0; i < array.length; i++)if (array[i]) ret.push(array[i]);
            return ret;
        },
        castInput: function castInput(value) {
            return value;
        },
        tokenize: function tokenize(value) {
            return Array.from(value);
        },
        join: function join(chars) {
            return chars.join('');
        },
        postProcess: function postProcess(changeObjects) {
            return changeObjects;
        }
    };
    function buildValues(diff, lastComponent, newString, oldString, useLongestToken) {
        // First we convert our linked list of components in reverse order to an
        // array in the right order:
        var components = [];
        var nextComponent;
        while(lastComponent){
            components.push(lastComponent);
            nextComponent = lastComponent.previousComponent;
            delete lastComponent.previousComponent;
            lastComponent = nextComponent;
        }
        components.reverse();
        var componentPos = 0, componentLen = components.length, newPos = 0, oldPos = 0;
        for(; componentPos < componentLen; componentPos++){
            var component = components[componentPos];
            if (!component.removed) {
                if (!component.added && useLongestToken) {
                    var value = newString.slice(newPos, newPos + component.count);
                    value = value.map(function(value, i) {
                        var oldValue = oldString[oldPos + i];
                        return oldValue.length > value.length ? oldValue : value;
                    });
                    component.value = diff.join(value);
                } else component.value = diff.join(newString.slice(newPos, newPos + component.count));
                newPos += component.count;
                // Common case
                if (!component.added) oldPos += component.count;
            } else {
                component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
                oldPos += component.count;
            }
        }
        return components;
    }
    var characterDiff = new Diff();
    function diffChars(oldStr, newStr, options) {
        return characterDiff.diff(oldStr, newStr, options);
    }
    function longestCommonPrefix(str1, str2) {
        var i;
        for(i = 0; i < str1.length && i < str2.length; i++){
            if (str1[i] != str2[i]) return str1.slice(0, i);
        }
        return str1.slice(0, i);
    }
    function longestCommonSuffix(str1, str2) {
        var i;
        // Unlike longestCommonPrefix, we need a special case to handle all scenarios
        // where we return the empty string since str1.slice(-0) will return the
        // entire string.
        if (!str1 || !str2 || str1[str1.length - 1] != str2[str2.length - 1]) return '';
        for(i = 0; i < str1.length && i < str2.length; i++){
            if (str1[str1.length - (i + 1)] != str2[str2.length - (i + 1)]) return str1.slice(-i);
        }
        return str1.slice(-i);
    }
    function replacePrefix(string, oldPrefix, newPrefix) {
        if (string.slice(0, oldPrefix.length) != oldPrefix) throw Error("string ".concat(JSON.stringify(string), " doesn't start with prefix ").concat(JSON.stringify(oldPrefix), "; this is a bug"));
        return newPrefix + string.slice(oldPrefix.length);
    }
    function replaceSuffix(string, oldSuffix, newSuffix) {
        if (!oldSuffix) return string + newSuffix;
        if (string.slice(-oldSuffix.length) != oldSuffix) throw Error("string ".concat(JSON.stringify(string), " doesn't end with suffix ").concat(JSON.stringify(oldSuffix), "; this is a bug"));
        return string.slice(0, -oldSuffix.length) + newSuffix;
    }
    function removePrefix(string, oldPrefix) {
        return replacePrefix(string, oldPrefix, '');
    }
    function removeSuffix(string, oldSuffix) {
        return replaceSuffix(string, oldSuffix, '');
    }
    function maximumOverlap(string1, string2) {
        return string2.slice(0, overlapCount(string1, string2));
    }
    // Nicked from https://stackoverflow.com/a/60422853/1709587
    function overlapCount(a, b) {
        // Deal with cases where the strings differ in length
        var startA = 0;
        if (a.length > b.length) startA = a.length - b.length;
        var endB = b.length;
        if (a.length < b.length) endB = a.length;
        // Create a back-reference for each index
        //   that should be followed in case of a mismatch.
        //   We only need B to make these references:
        var map = Array(endB);
        var k = 0; // Index that lags behind j
        map[0] = 0;
        for(var j = 1; j < endB; j++){
            if (b[j] == b[k]) map[j] = map[k]; // skip over the same character (optional optimisation)
            else map[j] = k;
            while(k > 0 && b[j] != b[k])k = map[k];
            if (b[j] == b[k]) k++;
        }
        // Phase 2: use these references while iterating over A
        k = 0;
        for(var i = startA; i < a.length; i++){
            while(k > 0 && a[i] != b[k])k = map[k];
            if (a[i] == b[k]) k++;
        }
        return k;
    }
    /**
   * Returns true if the string consistently uses Windows line endings.
   */ function hasOnlyWinLineEndings(string) {
        return string.includes('\r\n') && !string.startsWith('\n') && !string.match(/[^\r]\n/);
    }
    /**
   * Returns true if the string consistently uses Unix line endings.
   */ function hasOnlyUnixLineEndings(string) {
        return !string.includes('\r\n') && string.includes('\n');
    }
    // Based on https://en.wikipedia.org/wiki/Latin_script_in_Unicode
    //
    // Ranges and exceptions:
    // Latin-1 Supplement, 0080–00FF
    //  - U+00D7  × Multiplication sign
    //  - U+00F7  ÷ Division sign
    // Latin Extended-A, 0100–017F
    // Latin Extended-B, 0180–024F
    // IPA Extensions, 0250–02AF
    // Spacing Modifier Letters, 02B0–02FF
    //  - U+02C7  ˇ &#711;  Caron
    //  - U+02D8  ˘ &#728;  Breve
    //  - U+02D9  ˙ &#729;  Dot Above
    //  - U+02DA  ˚ &#730;  Ring Above
    //  - U+02DB  ˛ &#731;  Ogonek
    //  - U+02DC  ˜ &#732;  Small Tilde
    //  - U+02DD  ˝ &#733;  Double Acute Accent
    // Latin Extended Additional, 1E00–1EFF
    var extendedWordChars = "a-zA-Z0-9_\\u{C0}-\\u{FF}\\u{D8}-\\u{F6}\\u{F8}-\\u{2C6}\\u{2C8}-\\u{2D7}\\u{2DE}-\\u{2FF}\\u{1E00}-\\u{1EFF}";
    // Each token is one of the following:
    // - A punctuation mark plus the surrounding whitespace
    // - A word plus the surrounding whitespace
    // - Pure whitespace (but only in the special case where this the entire text
    //   is just whitespace)
    //
    // We have to include surrounding whitespace in the tokens because the two
    // alternative approaches produce horribly broken results:
    // * If we just discard the whitespace, we can't fully reproduce the original
    //   text from the sequence of tokens and any attempt to render the diff will
    //   get the whitespace wrong.
    // * If we have separate tokens for whitespace, then in a typical text every
    //   second token will be a single space character. But this often results in
    //   the optimal diff between two texts being a perverse one that preserves
    //   the spaces between words but deletes and reinserts actual common words.
    //   See https://github.com/kpdecker/jsdiff/issues/160#issuecomment-1866099640
    //   for an example.
    //
    // Keeping the surrounding whitespace of course has implications for .equals
    // and .join, not just .tokenize.
    // This regex does NOT fully implement the tokenization rules described above.
    // Instead, it gives runs of whitespace their own "token". The tokenize method
    // then handles stitching whitespace tokens onto adjacent word or punctuation
    // tokens.
    var tokenizeIncludingWhitespace = new RegExp("[".concat(extendedWordChars, "]+|\\s+|[^").concat(extendedWordChars, "]"), 'ug');
    var wordDiff = new Diff();
    wordDiff.equals = function(left, right, options) {
        if (options.ignoreCase) {
            left = left.toLowerCase();
            right = right.toLowerCase();
        }
        return left.trim() === right.trim();
    };
    wordDiff.tokenize = function(value) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var parts;
        if (options.intlSegmenter) {
            if (options.intlSegmenter.resolvedOptions().granularity != 'word') throw new Error('The segmenter passed must have a granularity of "word"');
            parts = Array.from(options.intlSegmenter.segment(value), function(segment) {
                return segment.segment;
            });
        } else parts = value.match(tokenizeIncludingWhitespace) || [];
        var tokens = [];
        var prevPart = null;
        parts.forEach(function(part) {
            if (/\s/.test(part)) {
                if (prevPart == null) tokens.push(part);
                else tokens.push(tokens.pop() + part);
            } else if (/\s/.test(prevPart)) {
                if (tokens[tokens.length - 1] == prevPart) tokens.push(tokens.pop() + part);
                else tokens.push(prevPart + part);
            } else tokens.push(part);
            prevPart = part;
        });
        return tokens;
    };
    wordDiff.join = function(tokens) {
        // Tokens being joined here will always have appeared consecutively in the
        // same text, so we can simply strip off the leading whitespace from all the
        // tokens except the first (and except any whitespace-only tokens - but such
        // a token will always be the first and only token anyway) and then join them
        // and the whitespace around words and punctuation will end up correct.
        return tokens.map(function(token, i) {
            if (i == 0) return token;
            else return token.replace(/^\s+/, '');
        }).join('');
    };
    wordDiff.postProcess = function(changes, options) {
        if (!changes || options.oneChangePerToken) return changes;
        var lastKeep = null;
        // Change objects representing any insertion or deletion since the last
        // "keep" change object. There can be at most one of each.
        var insertion = null;
        var deletion = null;
        changes.forEach(function(change) {
            if (change.added) insertion = change;
            else if (change.removed) deletion = change;
            else {
                if (insertion || deletion) // May be false at start of text
                dedupeWhitespaceInChangeObjects(lastKeep, deletion, insertion, change);
                lastKeep = change;
                insertion = null;
                deletion = null;
            }
        });
        if (insertion || deletion) dedupeWhitespaceInChangeObjects(lastKeep, deletion, insertion, null);
        return changes;
    };
    function diffWords(oldStr, newStr, options) {
        // This option has never been documented and never will be (it's clearer to
        // just call `diffWordsWithSpace` directly if you need that behavior), but
        // has existed in jsdiff for a long time, so we retain support for it here
        // for the sake of backwards compatibility.
        if ((options === null || options === void 0 ? void 0 : options.ignoreWhitespace) != null && !options.ignoreWhitespace) return diffWordsWithSpace(oldStr, newStr, options);
        return wordDiff.diff(oldStr, newStr, options);
    }
    function dedupeWhitespaceInChangeObjects(startKeep, deletion, insertion, endKeep) {
        // Before returning, we tidy up the leading and trailing whitespace of the
        // change objects to eliminate cases where trailing whitespace in one object
        // is repeated as leading whitespace in the next.
        // Below are examples of the outcomes we want here to explain the code.
        // I=insert, K=keep, D=delete
        // 1. diffing 'foo bar baz' vs 'foo baz'
        //    Prior to cleanup, we have K:'foo ' D:' bar ' K:' baz'
        //    After cleanup, we want:   K:'foo ' D:'bar ' K:'baz'
        //
        // 2. Diffing 'foo bar baz' vs 'foo qux baz'
        //    Prior to cleanup, we have K:'foo ' D:' bar ' I:' qux ' K:' baz'
        //    After cleanup, we want K:'foo ' D:'bar' I:'qux' K:' baz'
        //
        // 3. Diffing 'foo\nbar baz' vs 'foo baz'
        //    Prior to cleanup, we have K:'foo ' D:'\nbar ' K:' baz'
        //    After cleanup, we want K'foo' D:'\nbar' K:' baz'
        //
        // 4. Diffing 'foo baz' vs 'foo\nbar baz'
        //    Prior to cleanup, we have K:'foo\n' I:'\nbar ' K:' baz'
        //    After cleanup, we ideally want K'foo' I:'\nbar' K:' baz'
        //    but don't actually manage this currently (the pre-cleanup change
        //    objects don't contain enough information to make it possible).
        //
        // 5. Diffing 'foo   bar baz' vs 'foo  baz'
        //    Prior to cleanup, we have K:'foo  ' D:'   bar ' K:'  baz'
        //    After cleanup, we want K:'foo  ' D:' bar ' K:'baz'
        //
        // Our handling is unavoidably imperfect in the case where there's a single
        // indel between keeps and the whitespace has changed. For instance, consider
        // diffing 'foo\tbar\nbaz' vs 'foo baz'. Unless we create an extra change
        // object to represent the insertion of the space character (which isn't even
        // a token), we have no way to avoid losing information about the texts'
        // original whitespace in the result we return. Still, we do our best to
        // output something that will look sensible if we e.g. print it with
        // insertions in green and deletions in red.
        // Between two "keep" change objects (or before the first or after the last
        // change object), we can have either:
        // * A "delete" followed by an "insert"
        // * Just an "insert"
        // * Just a "delete"
        // We handle the three cases separately.
        if (deletion && insertion) {
            var oldWsPrefix = deletion.value.match(/^\s*/)[0];
            var oldWsSuffix = deletion.value.match(/\s*$/)[0];
            var newWsPrefix = insertion.value.match(/^\s*/)[0];
            var newWsSuffix = insertion.value.match(/\s*$/)[0];
            if (startKeep) {
                var commonWsPrefix = longestCommonPrefix(oldWsPrefix, newWsPrefix);
                startKeep.value = replaceSuffix(startKeep.value, newWsPrefix, commonWsPrefix);
                deletion.value = removePrefix(deletion.value, commonWsPrefix);
                insertion.value = removePrefix(insertion.value, commonWsPrefix);
            }
            if (endKeep) {
                var commonWsSuffix = longestCommonSuffix(oldWsSuffix, newWsSuffix);
                endKeep.value = replacePrefix(endKeep.value, newWsSuffix, commonWsSuffix);
                deletion.value = removeSuffix(deletion.value, commonWsSuffix);
                insertion.value = removeSuffix(insertion.value, commonWsSuffix);
            }
        } else if (insertion) {
            // The whitespaces all reflect what was in the new text rather than
            // the old, so we essentially have no information about whitespace
            // insertion or deletion. We just want to dedupe the whitespace.
            // We do that by having each change object keep its trailing
            // whitespace and deleting duplicate leading whitespace where
            // present.
            if (startKeep) insertion.value = insertion.value.replace(/^\s*/, '');
            if (endKeep) endKeep.value = endKeep.value.replace(/^\s*/, '');
        // otherwise we've got a deletion and no insertion
        } else if (startKeep && endKeep) {
            var newWsFull = endKeep.value.match(/^\s*/)[0], delWsStart = deletion.value.match(/^\s*/)[0], delWsEnd = deletion.value.match(/\s*$/)[0];
            // Any whitespace that comes straight after startKeep in both the old and
            // new texts, assign to startKeep and remove from the deletion.
            var newWsStart = longestCommonPrefix(newWsFull, delWsStart);
            deletion.value = removePrefix(deletion.value, newWsStart);
            // Any whitespace that comes straight before endKeep in both the old and
            // new texts, and hasn't already been assigned to startKeep, assign to
            // endKeep and remove from the deletion.
            var newWsEnd = longestCommonSuffix(removePrefix(newWsFull, newWsStart), delWsEnd);
            deletion.value = removeSuffix(deletion.value, newWsEnd);
            endKeep.value = replacePrefix(endKeep.value, newWsFull, newWsEnd);
            // If there's any whitespace from the new text that HASN'T already been
            // assigned, assign it to the start:
            startKeep.value = replaceSuffix(startKeep.value, newWsFull, newWsFull.slice(0, newWsFull.length - newWsEnd.length));
        } else if (endKeep) {
            // We are at the start of the text. Preserve all the whitespace on
            // endKeep, and just remove whitespace from the end of deletion to the
            // extent that it overlaps with the start of endKeep.
            var endKeepWsPrefix = endKeep.value.match(/^\s*/)[0];
            var deletionWsSuffix = deletion.value.match(/\s*$/)[0];
            var overlap = maximumOverlap(deletionWsSuffix, endKeepWsPrefix);
            deletion.value = removeSuffix(deletion.value, overlap);
        } else if (startKeep) {
            // We are at the END of the text. Preserve all the whitespace on
            // startKeep, and just remove whitespace from the start of deletion to
            // the extent that it overlaps with the end of startKeep.
            var startKeepWsSuffix = startKeep.value.match(/\s*$/)[0];
            var deletionWsPrefix = deletion.value.match(/^\s*/)[0];
            var _overlap = maximumOverlap(startKeepWsSuffix, deletionWsPrefix);
            deletion.value = removePrefix(deletion.value, _overlap);
        }
    }
    var wordWithSpaceDiff = new Diff();
    wordWithSpaceDiff.tokenize = function(value) {
        // Slightly different to the tokenizeIncludingWhitespace regex used above in
        // that this one treats each individual newline as a distinct tokens, rather
        // than merging them into other surrounding whitespace. This was requested
        // in https://github.com/kpdecker/jsdiff/issues/180 &
        //    https://github.com/kpdecker/jsdiff/issues/211
        var regex = new RegExp("(\\r?\\n)|[".concat(extendedWordChars, "]+|[^\\S\\n\\r]+|[^").concat(extendedWordChars, "]"), 'ug');
        return value.match(regex) || [];
    };
    function diffWordsWithSpace(oldStr, newStr, options) {
        return wordWithSpaceDiff.diff(oldStr, newStr, options);
    }
    function generateOptions(options, defaults) {
        if (typeof options === 'function') defaults.callback = options;
        else if (options) {
            for(var name in options)/* istanbul ignore else */ if (options.hasOwnProperty(name)) defaults[name] = options[name];
        }
        return defaults;
    }
    var lineDiff = new Diff();
    lineDiff.tokenize = function(value, options) {
        if (options.stripTrailingCr) // remove one \r before \n to match GNU diff's --strip-trailing-cr behavior
        value = value.replace(/\r\n/g, '\n');
        var retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/);
        // Ignore the final empty token that occurs if the string ends with a new line
        if (!linesAndNewlines[linesAndNewlines.length - 1]) linesAndNewlines.pop();
        // Merge the content and line separators into single tokens
        for(var i = 0; i < linesAndNewlines.length; i++){
            var line = linesAndNewlines[i];
            if (i % 2 && !options.newlineIsToken) retLines[retLines.length - 1] += line;
            else retLines.push(line);
        }
        return retLines;
    };
    lineDiff.equals = function(left, right, options) {
        // If we're ignoring whitespace, we need to normalise lines by stripping
        // whitespace before checking equality. (This has an annoying interaction
        // with newlineIsToken that requires special handling: if newlines get their
        // own token, then we DON'T want to trim the *newline* tokens down to empty
        // strings, since this would cause us to treat whitespace-only line content
        // as equal to a separator between lines, which would be weird and
        // inconsistent with the documented behavior of the options.)
        if (options.ignoreWhitespace) {
            if (!options.newlineIsToken || !left.includes('\n')) left = left.trim();
            if (!options.newlineIsToken || !right.includes('\n')) right = right.trim();
        } else if (options.ignoreNewlineAtEof && !options.newlineIsToken) {
            if (left.endsWith('\n')) left = left.slice(0, -1);
            if (right.endsWith('\n')) right = right.slice(0, -1);
        }
        return Diff.prototype.equals.call(this, left, right, options);
    };
    function diffLines(oldStr, newStr, callback) {
        return lineDiff.diff(oldStr, newStr, callback);
    }
    // Kept for backwards compatibility. This is a rather arbitrary wrapper method
    // that just calls `diffLines` with `ignoreWhitespace: true`. It's confusing to
    // have two ways to do exactly the same thing in the API, so we no longer
    // document this one (library users should explicitly use `diffLines` with
    // `ignoreWhitespace: true` instead) but we keep it around to maintain
    // compatibility with code that used old versions.
    function diffTrimmedLines(oldStr, newStr, callback) {
        var options = generateOptions(callback, {
            ignoreWhitespace: true
        });
        return lineDiff.diff(oldStr, newStr, options);
    }
    var sentenceDiff = new Diff();
    sentenceDiff.tokenize = function(value) {
        return value.split(/(\S.+?[.!?])(?=\s+|$)/);
    };
    function diffSentences(oldStr, newStr, callback) {
        return sentenceDiff.diff(oldStr, newStr, callback);
    }
    var cssDiff = new Diff();
    cssDiff.tokenize = function(value) {
        return value.split(/([{}:;,]|\s+)/);
    };
    function diffCss(oldStr, newStr, callback) {
        return cssDiff.diff(oldStr, newStr, callback);
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var jsonDiff = new Diff();
    // Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
    // dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
    jsonDiff.useLongestToken = true;
    jsonDiff.tokenize = lineDiff.tokenize;
    jsonDiff.castInput = function(value, options) {
        var undefinedReplacement = options.undefinedReplacement, _options$stringifyRep = options.stringifyReplacer, stringifyReplacer = _options$stringifyRep === void 0 ? function(k, v) {
            return typeof v === 'undefined' ? undefinedReplacement : v;
        } : _options$stringifyRep;
        return typeof value === 'string' ? value : JSON.stringify(canonicalize(value, null, null, stringifyReplacer), stringifyReplacer, '  ');
    };
    jsonDiff.equals = function(left, right, options) {
        return Diff.prototype.equals.call(jsonDiff, left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'), options);
    };
    function diffJson(oldObj, newObj, options) {
        return jsonDiff.diff(oldObj, newObj, options);
    }
    // This function handles the presence of circular references by bailing out when encountering an
    // object that is already on the "stack" of items being processed. Accepts an optional replacer
    function canonicalize(obj, stack, replacementStack, replacer, key) {
        stack = stack || [];
        replacementStack = replacementStack || [];
        if (replacer) obj = replacer(key, obj);
        var i;
        for(i = 0; i < stack.length; i += 1){
            if (stack[i] === obj) return replacementStack[i];
        }
        var canonicalizedObj;
        if ('[object Array]' === Object.prototype.toString.call(obj)) {
            stack.push(obj);
            canonicalizedObj = new Array(obj.length);
            replacementStack.push(canonicalizedObj);
            for(i = 0; i < obj.length; i += 1)canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack, replacer, key);
            stack.pop();
            replacementStack.pop();
            return canonicalizedObj;
        }
        if (obj && obj.toJSON) obj = obj.toJSON();
        if (_typeof(obj) === 'object' && obj !== null) {
            stack.push(obj);
            canonicalizedObj = {};
            replacementStack.push(canonicalizedObj);
            var sortedKeys = [], _key;
            for(_key in obj)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(obj, _key)) sortedKeys.push(_key);
            sortedKeys.sort();
            for(i = 0; i < sortedKeys.length; i += 1){
                _key = sortedKeys[i];
                canonicalizedObj[_key] = canonicalize(obj[_key], stack, replacementStack, replacer, _key);
            }
            stack.pop();
            replacementStack.pop();
        } else canonicalizedObj = obj;
        return canonicalizedObj;
    }
    var arrayDiff = new Diff();
    arrayDiff.tokenize = function(value) {
        return value.slice();
    };
    arrayDiff.join = arrayDiff.removeEmpty = function(value) {
        return value;
    };
    function diffArrays(oldArr, newArr, callback) {
        return arrayDiff.diff(oldArr, newArr, callback);
    }
    function unixToWin(patch) {
        if (Array.isArray(patch)) return patch.map(unixToWin);
        return _objectSpread2(_objectSpread2({}, patch), {}, {
            hunks: patch.hunks.map(function(hunk) {
                return _objectSpread2(_objectSpread2({}, hunk), {}, {
                    lines: hunk.lines.map(function(line, i) {
                        var _hunk$lines;
                        return line.startsWith('\\') || line.endsWith('\r') || (_hunk$lines = hunk.lines[i + 1]) !== null && _hunk$lines !== void 0 && _hunk$lines.startsWith('\\') ? line : line + '\r';
                    })
                });
            })
        });
    }
    function winToUnix(patch) {
        if (Array.isArray(patch)) return patch.map(winToUnix);
        return _objectSpread2(_objectSpread2({}, patch), {}, {
            hunks: patch.hunks.map(function(hunk) {
                return _objectSpread2(_objectSpread2({}, hunk), {}, {
                    lines: hunk.lines.map(function(line) {
                        return line.endsWith('\r') ? line.substring(0, line.length - 1) : line;
                    })
                });
            })
        });
    }
    /**
   * Returns true if the patch consistently uses Unix line endings (or only involves one line and has
   * no line endings).
   */ function isUnix(patch) {
        if (!Array.isArray(patch)) patch = [
            patch
        ];
        return !patch.some(function(index) {
            return index.hunks.some(function(hunk) {
                return hunk.lines.some(function(line) {
                    return !line.startsWith('\\') && line.endsWith('\r');
                });
            });
        });
    }
    /**
   * Returns true if the patch uses Windows line endings and only Windows line endings.
   */ function isWin(patch) {
        if (!Array.isArray(patch)) patch = [
            patch
        ];
        return patch.some(function(index) {
            return index.hunks.some(function(hunk) {
                return hunk.lines.some(function(line) {
                    return line.endsWith('\r');
                });
            });
        }) && patch.every(function(index) {
            return index.hunks.every(function(hunk) {
                return hunk.lines.every(function(line, i) {
                    var _hunk$lines2;
                    return line.startsWith('\\') || line.endsWith('\r') || ((_hunk$lines2 = hunk.lines[i + 1]) === null || _hunk$lines2 === void 0 ? void 0 : _hunk$lines2.startsWith('\\'));
                });
            });
        });
    }
    function parsePatch(uniDiff) {
        var diffstr = uniDiff.split(/\n/), list = [], i = 0;
        function parseIndex() {
            var index = {};
            list.push(index);
            // Parse diff metadata
            while(i < diffstr.length){
                var line = diffstr[i];
                // File header found, end parsing diff metadata
                if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) break;
                // Diff index
                var header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
                if (header) index.index = header[1];
                i++;
            }
            // Parse file headers if they are defined. Unified diff requires them, but
            // there's no technical issues to have an isolated hunk without file header
            parseFileHeader(index);
            parseFileHeader(index);
            // Parse hunks
            index.hunks = [];
            while(i < diffstr.length){
                var _line = diffstr[i];
                if (/^(Index:\s|diff\s|\-\-\-\s|\+\+\+\s|===================================================================)/.test(_line)) break;
                else if (/^@@/.test(_line)) index.hunks.push(parseHunk());
                else if (_line) throw new Error('Unknown line ' + (i + 1) + ' ' + JSON.stringify(_line));
                else i++;
            }
        }
        // Parses the --- and +++ headers, if none are found, no lines
        // are consumed.
        function parseFileHeader(index) {
            var fileHeader = /^(---|\+\+\+)\s+(.*)\r?$/.exec(diffstr[i]);
            if (fileHeader) {
                var keyPrefix = fileHeader[1] === '---' ? 'old' : 'new';
                var data = fileHeader[2].split('\t', 2);
                var fileName = data[0].replace(/\\\\/g, '\\');
                if (/^".*"$/.test(fileName)) fileName = fileName.substr(1, fileName.length - 2);
                index[keyPrefix + 'FileName'] = fileName;
                index[keyPrefix + 'Header'] = (data[1] || '').trim();
                i++;
            }
        }
        // Parses a hunk
        // This assumes that we are at the start of a hunk.
        function parseHunk() {
            var chunkHeaderIndex = i, chunkHeaderLine = diffstr[i++], chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);
            var hunk = {
                oldStart: +chunkHeader[1],
                oldLines: typeof chunkHeader[2] === 'undefined' ? 1 : +chunkHeader[2],
                newStart: +chunkHeader[3],
                newLines: typeof chunkHeader[4] === 'undefined' ? 1 : +chunkHeader[4],
                lines: []
            };
            // Unified Diff Format quirk: If the chunk size is 0,
            // the first number is one lower than one would expect.
            // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
            if (hunk.oldLines === 0) hunk.oldStart += 1;
            if (hunk.newLines === 0) hunk.newStart += 1;
            var addCount = 0, removeCount = 0;
            for(; i < diffstr.length && (removeCount < hunk.oldLines || addCount < hunk.newLines || (_diffstr$i = diffstr[i]) !== null && _diffstr$i !== void 0 && _diffstr$i.startsWith('\\')); i++){
                var _diffstr$i;
                var operation = diffstr[i].length == 0 && i != diffstr.length - 1 ? ' ' : diffstr[i][0];
                if (operation === '+' || operation === '-' || operation === ' ' || operation === '\\') {
                    hunk.lines.push(diffstr[i]);
                    if (operation === '+') addCount++;
                    else if (operation === '-') removeCount++;
                    else if (operation === ' ') {
                        addCount++;
                        removeCount++;
                    }
                } else throw new Error("Hunk at line ".concat(chunkHeaderIndex + 1, " contained invalid line ").concat(diffstr[i]));
            }
            // Handle the empty block count case
            if (!addCount && hunk.newLines === 1) hunk.newLines = 0;
            if (!removeCount && hunk.oldLines === 1) hunk.oldLines = 0;
            // Perform sanity checking
            if (addCount !== hunk.newLines) throw new Error('Added line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
            if (removeCount !== hunk.oldLines) throw new Error('Removed line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
            return hunk;
        }
        while(i < diffstr.length)parseIndex();
        return list;
    }
    // Iterator that traverses in the range of [min, max], stepping
    // by distance from a given start position. I.e. for [0, 4], with
    // start of 2, this will iterate 2, 3, 1, 4, 0.
    function distanceIterator(start, minLine, maxLine) {
        var wantForward = true, backwardExhausted = false, forwardExhausted = false, localOffset = 1;
        return function iterator() {
            if (wantForward && !forwardExhausted) {
                if (backwardExhausted) localOffset++;
                else wantForward = false;
                // Check if trying to fit beyond text length, and if not, check it fits
                // after offset location (or desired location on first iteration)
                if (start + localOffset <= maxLine) return start + localOffset;
                forwardExhausted = true;
            }
            if (!backwardExhausted) {
                if (!forwardExhausted) wantForward = true;
                // Check if trying to fit before text beginning, and if not, check it fits
                // before offset location
                if (minLine <= start - localOffset) return start - localOffset++;
                backwardExhausted = true;
                return iterator();
            }
        // We tried to fit hunk before text beginning and beyond text length, then
        // hunk can't fit on the text. Return undefined
        };
    }
    function applyPatch(source, uniDiff) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (typeof uniDiff === 'string') uniDiff = parsePatch(uniDiff);
        if (Array.isArray(uniDiff)) {
            if (uniDiff.length > 1) throw new Error('applyPatch only works with a single input.');
            uniDiff = uniDiff[0];
        }
        if (options.autoConvertLineEndings || options.autoConvertLineEndings == null) {
            if (hasOnlyWinLineEndings(source) && isUnix(uniDiff)) uniDiff = unixToWin(uniDiff);
            else if (hasOnlyUnixLineEndings(source) && isWin(uniDiff)) uniDiff = winToUnix(uniDiff);
        }
        // Apply the diff to the input
        var lines = source.split('\n'), hunks = uniDiff.hunks, compareLine = options.compareLine || function(lineNumber, line, operation, patchContent) {
            return line === patchContent;
        }, fuzzFactor = options.fuzzFactor || 0, minLine = 0;
        if (fuzzFactor < 0 || !Number.isInteger(fuzzFactor)) throw new Error('fuzzFactor must be a non-negative integer');
        // Special case for empty patch.
        if (!hunks.length) return source;
        // Before anything else, handle EOFNL insertion/removal. If the patch tells us to make a change
        // to the EOFNL that is redundant/impossible - i.e. to remove a newline that's not there, or add a
        // newline that already exists - then we either return false and fail to apply the patch (if
        // fuzzFactor is 0) or simply ignore the problem and do nothing (if fuzzFactor is >0).
        // If we do need to remove/add a newline at EOF, this will always be in the final hunk:
        var prevLine = '', removeEOFNL = false, addEOFNL = false;
        for(var i = 0; i < hunks[hunks.length - 1].lines.length; i++){
            var line = hunks[hunks.length - 1].lines[i];
            if (line[0] == '\\') {
                if (prevLine[0] == '+') removeEOFNL = true;
                else if (prevLine[0] == '-') addEOFNL = true;
            }
            prevLine = line;
        }
        if (removeEOFNL) {
            if (addEOFNL) {
                // This means the final line gets changed but doesn't have a trailing newline in either the
                // original or patched version. In that case, we do nothing if fuzzFactor > 0, and if
                // fuzzFactor is 0, we simply validate that the source file has no trailing newline.
                if (!fuzzFactor && lines[lines.length - 1] == '') return false;
            } else if (lines[lines.length - 1] == '') lines.pop();
            else if (!fuzzFactor) return false;
        } else if (addEOFNL) {
            if (lines[lines.length - 1] != '') lines.push('');
            else if (!fuzzFactor) return false;
        }
        /**
     * Checks if the hunk can be made to fit at the provided location with at most `maxErrors`
     * insertions, substitutions, or deletions, while ensuring also that:
     * - lines deleted in the hunk match exactly, and
     * - wherever an insertion operation or block of insertion operations appears in the hunk, the
     *   immediately preceding and following lines of context match exactly
     *
     * `toPos` should be set such that lines[toPos] is meant to match hunkLines[0].
     *
     * If the hunk can be applied, returns an object with properties `oldLineLastI` and
     * `replacementLines`. Otherwise, returns null.
     */ function applyHunk(hunkLines, toPos, maxErrors) {
            var hunkLinesI = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var lastContextLineMatched = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
            var patchedLines = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
            var patchedLinesLength = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
            var nConsecutiveOldContextLines = 0;
            var nextContextLineMustMatch = false;
            for(; hunkLinesI < hunkLines.length; hunkLinesI++){
                var hunkLine = hunkLines[hunkLinesI], operation = hunkLine.length > 0 ? hunkLine[0] : ' ', content = hunkLine.length > 0 ? hunkLine.substr(1) : hunkLine;
                if (operation === '-') {
                    if (compareLine(toPos + 1, lines[toPos], operation, content)) {
                        toPos++;
                        nConsecutiveOldContextLines = 0;
                    } else {
                        if (!maxErrors || lines[toPos] == null) return null;
                        patchedLines[patchedLinesLength] = lines[toPos];
                        return applyHunk(hunkLines, toPos + 1, maxErrors - 1, hunkLinesI, false, patchedLines, patchedLinesLength + 1);
                    }
                }
                if (operation === '+') {
                    if (!lastContextLineMatched) return null;
                    patchedLines[patchedLinesLength] = content;
                    patchedLinesLength++;
                    nConsecutiveOldContextLines = 0;
                    nextContextLineMustMatch = true;
                }
                if (operation === ' ') {
                    nConsecutiveOldContextLines++;
                    patchedLines[patchedLinesLength] = lines[toPos];
                    if (compareLine(toPos + 1, lines[toPos], operation, content)) {
                        patchedLinesLength++;
                        lastContextLineMatched = true;
                        nextContextLineMustMatch = false;
                        toPos++;
                    } else {
                        if (nextContextLineMustMatch || !maxErrors) return null;
                        // Consider 3 possibilities in sequence:
                        // 1. lines contains a *substitution* not included in the patch context, or
                        // 2. lines contains an *insertion* not included in the patch context, or
                        // 3. lines contains a *deletion* not included in the patch context
                        // The first two options are of course only possible if the line from lines is non-null -
                        // i.e. only option 3 is possible if we've overrun the end of the old file.
                        return lines[toPos] && (applyHunk(hunkLines, toPos + 1, maxErrors - 1, hunkLinesI + 1, false, patchedLines, patchedLinesLength + 1) || applyHunk(hunkLines, toPos + 1, maxErrors - 1, hunkLinesI, false, patchedLines, patchedLinesLength + 1)) || applyHunk(hunkLines, toPos, maxErrors - 1, hunkLinesI + 1, false, patchedLines, patchedLinesLength);
                    }
                }
            }
            // Before returning, trim any unmodified context lines off the end of patchedLines and reduce
            // toPos (and thus oldLineLastI) accordingly. This allows later hunks to be applied to a region
            // that starts in this hunk's trailing context.
            patchedLinesLength -= nConsecutiveOldContextLines;
            toPos -= nConsecutiveOldContextLines;
            patchedLines.length = patchedLinesLength;
            return {
                patchedLines: patchedLines,
                oldLineLastI: toPos - 1
            };
        }
        var resultLines = [];
        // Search best fit offsets for each hunk based on the previous ones
        var prevHunkOffset = 0;
        for(var _i = 0; _i < hunks.length; _i++){
            var hunk = hunks[_i];
            var hunkResult = void 0;
            var maxLine = lines.length - hunk.oldLines + fuzzFactor;
            var toPos = void 0;
            for(var maxErrors = 0; maxErrors <= fuzzFactor; maxErrors++){
                toPos = hunk.oldStart + prevHunkOffset - 1;
                var iterator = distanceIterator(toPos, minLine, maxLine);
                for(; toPos !== undefined; toPos = iterator()){
                    hunkResult = applyHunk(hunk.lines, toPos, maxErrors);
                    if (hunkResult) break;
                }
                if (hunkResult) break;
            }
            if (!hunkResult) return false;
            // Copy everything from the end of where we applied the last hunk to the start of this hunk
            for(var _i2 = minLine; _i2 < toPos; _i2++)resultLines.push(lines[_i2]);
            // Add the lines produced by applying the hunk:
            for(var _i3 = 0; _i3 < hunkResult.patchedLines.length; _i3++){
                var _line = hunkResult.patchedLines[_i3];
                resultLines.push(_line);
            }
            // Set lower text limit to end of the current hunk, so next ones don't try
            // to fit over already patched text
            minLine = hunkResult.oldLineLastI + 1;
            // Note the offset between where the patch said the hunk should've applied and where we
            // applied it, so we can adjust future hunks accordingly:
            prevHunkOffset = toPos + 1 - hunk.oldStart;
        }
        // Copy over the rest of the lines from the old text
        for(var _i4 = minLine; _i4 < lines.length; _i4++)resultLines.push(lines[_i4]);
        return resultLines.join('\n');
    }
    // Wrapper that supports multiple file patches via callbacks.
    function applyPatches(uniDiff, options) {
        if (typeof uniDiff === 'string') uniDiff = parsePatch(uniDiff);
        var currentIndex = 0;
        function processIndex() {
            var index = uniDiff[currentIndex++];
            if (!index) return options.complete();
            options.loadFile(index, function(err, data) {
                if (err) return options.complete(err);
                var updatedContent = applyPatch(data, index, options);
                options.patched(index, updatedContent, function(err) {
                    if (err) return options.complete(err);
                    processIndex();
                });
            });
        }
        processIndex();
    }
    function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
        if (!options) options = {};
        if (typeof options === 'function') options = {
            callback: options
        };
        if (typeof options.context === 'undefined') options.context = 4;
        if (options.newlineIsToken) throw new Error('newlineIsToken may not be used with patch-generation functions, only with diffing functions');
        if (!options.callback) return diffLinesResultToPatch(diffLines(oldStr, newStr, options));
        else {
            var _options = options, _callback = _options.callback;
            diffLines(oldStr, newStr, _objectSpread2(_objectSpread2({}, options), {}, {
                callback: function callback(diff) {
                    var patch = diffLinesResultToPatch(diff);
                    _callback(patch);
                }
            }));
        }
        function diffLinesResultToPatch(diff) {
            // STEP 1: Build up the patch with no "\ No newline at end of file" lines and with the arrays
            //         of lines containing trailing newline characters. We'll tidy up later...
            if (!diff) return;
            diff.push({
                value: '',
                lines: []
            }); // Append an empty value to make cleanup easier
            function contextLines(lines) {
                return lines.map(function(entry) {
                    return ' ' + entry;
                });
            }
            var hunks = [];
            var oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
            var _loop = function _loop() {
                var current = diff[i], lines = current.lines || splitLines(current.value);
                current.lines = lines;
                if (current.added || current.removed) {
                    var _curRange;
                    // If we have previous context, start with that
                    if (!oldRangeStart) {
                        var prev = diff[i - 1];
                        oldRangeStart = oldLine;
                        newRangeStart = newLine;
                        if (prev) {
                            curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
                            oldRangeStart -= curRange.length;
                            newRangeStart -= curRange.length;
                        }
                    }
                    // Output our changes
                    (_curRange = curRange).push.apply(_curRange, _toConsumableArray(lines.map(function(entry) {
                        return (current.added ? '+' : '-') + entry;
                    })));
                    // Track the updated file position
                    if (current.added) newLine += lines.length;
                    else oldLine += lines.length;
                } else {
                    // Identical context lines. Track line changes
                    if (oldRangeStart) {
                        // Close out any changes that have been output (or join overlapping)
                        if (lines.length <= options.context * 2 && i < diff.length - 2) {
                            var _curRange2;
                            // Overlapping
                            (_curRange2 = curRange).push.apply(_curRange2, _toConsumableArray(contextLines(lines)));
                        } else {
                            var _curRange3;
                            // end the range and output
                            var contextSize = Math.min(lines.length, options.context);
                            (_curRange3 = curRange).push.apply(_curRange3, _toConsumableArray(contextLines(lines.slice(0, contextSize))));
                            var _hunk = {
                                oldStart: oldRangeStart,
                                oldLines: oldLine - oldRangeStart + contextSize,
                                newStart: newRangeStart,
                                newLines: newLine - newRangeStart + contextSize,
                                lines: curRange
                            };
                            hunks.push(_hunk);
                            oldRangeStart = 0;
                            newRangeStart = 0;
                            curRange = [];
                        }
                    }
                    oldLine += lines.length;
                    newLine += lines.length;
                }
            };
            for(var i = 0; i < diff.length; i++)_loop();
            // Step 2: eliminate the trailing `\n` from each line of each hunk, and, where needed, add
            //         "\ No newline at end of file".
            for(var _i = 0, _hunks = hunks; _i < _hunks.length; _i++){
                var hunk = _hunks[_i];
                for(var _i2 = 0; _i2 < hunk.lines.length; _i2++)if (hunk.lines[_i2].endsWith('\n')) hunk.lines[_i2] = hunk.lines[_i2].slice(0, -1);
                else {
                    hunk.lines.splice(_i2 + 1, 0, '\\ No newline at end of file');
                    _i2++; // Skip the line we just added, then continue iterating
                }
            }
            return {
                oldFileName: oldFileName,
                newFileName: newFileName,
                oldHeader: oldHeader,
                newHeader: newHeader,
                hunks: hunks
            };
        }
    }
    function formatPatch(diff) {
        if (Array.isArray(diff)) return diff.map(formatPatch).join('\n');
        var ret = [];
        if (diff.oldFileName == diff.newFileName) ret.push('Index: ' + diff.oldFileName);
        ret.push('===================================================================');
        ret.push('--- ' + diff.oldFileName + (typeof diff.oldHeader === 'undefined' ? '' : '\t' + diff.oldHeader));
        ret.push('+++ ' + diff.newFileName + (typeof diff.newHeader === 'undefined' ? '' : '\t' + diff.newHeader));
        for(var i = 0; i < diff.hunks.length; i++){
            var hunk = diff.hunks[i];
            // Unified Diff Format quirk: If the chunk size is 0,
            // the first number is one lower than one would expect.
            // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
            if (hunk.oldLines === 0) hunk.oldStart -= 1;
            if (hunk.newLines === 0) hunk.newStart -= 1;
            ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
            ret.push.apply(ret, hunk.lines);
        }
        return ret.join('\n') + '\n';
    }
    function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
        var _options2;
        if (typeof options === 'function') options = {
            callback: options
        };
        if (!((_options2 = options) !== null && _options2 !== void 0 && _options2.callback)) {
            var patchObj = structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);
            if (!patchObj) return;
            return formatPatch(patchObj);
        } else {
            var _options3 = options, _callback2 = _options3.callback;
            structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, _objectSpread2(_objectSpread2({}, options), {}, {
                callback: function callback(patchObj) {
                    if (!patchObj) _callback2();
                    else _callback2(formatPatch(patchObj));
                }
            }));
        }
    }
    function createPatch(fileName, oldStr, newStr, oldHeader, newHeader, options) {
        return createTwoFilesPatch(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
    }
    /**
   * Split `text` into an array of lines, including the trailing newline character (where present)
   */ function splitLines(text) {
        var hasTrailingNl = text.endsWith('\n');
        var result = text.split('\n').map(function(line) {
            return line + '\n';
        });
        if (hasTrailingNl) result.pop();
        else result.push(result.pop().slice(0, -1));
        return result;
    }
    function arrayEqual(a, b) {
        if (a.length !== b.length) return false;
        return arrayStartsWith(a, b);
    }
    function arrayStartsWith(array, start) {
        if (start.length > array.length) return false;
        for(var i = 0; i < start.length; i++){
            if (start[i] !== array[i]) return false;
        }
        return true;
    }
    function calcLineCount(hunk) {
        var _calcOldNewLineCount = calcOldNewLineCount(hunk.lines), oldLines = _calcOldNewLineCount.oldLines, newLines = _calcOldNewLineCount.newLines;
        if (oldLines !== undefined) hunk.oldLines = oldLines;
        else delete hunk.oldLines;
        if (newLines !== undefined) hunk.newLines = newLines;
        else delete hunk.newLines;
    }
    function merge(mine, theirs, base) {
        mine = loadPatch(mine, base);
        theirs = loadPatch(theirs, base);
        var ret = {};
        // For index we just let it pass through as it doesn't have any necessary meaning.
        // Leaving sanity checks on this to the API consumer that may know more about the
        // meaning in their own context.
        if (mine.index || theirs.index) ret.index = mine.index || theirs.index;
        if (mine.newFileName || theirs.newFileName) {
            if (!fileNameChanged(mine)) {
                // No header or no change in ours, use theirs (and ours if theirs does not exist)
                ret.oldFileName = theirs.oldFileName || mine.oldFileName;
                ret.newFileName = theirs.newFileName || mine.newFileName;
                ret.oldHeader = theirs.oldHeader || mine.oldHeader;
                ret.newHeader = theirs.newHeader || mine.newHeader;
            } else if (!fileNameChanged(theirs)) {
                // No header or no change in theirs, use ours
                ret.oldFileName = mine.oldFileName;
                ret.newFileName = mine.newFileName;
                ret.oldHeader = mine.oldHeader;
                ret.newHeader = mine.newHeader;
            } else {
                // Both changed... figure it out
                ret.oldFileName = selectField(ret, mine.oldFileName, theirs.oldFileName);
                ret.newFileName = selectField(ret, mine.newFileName, theirs.newFileName);
                ret.oldHeader = selectField(ret, mine.oldHeader, theirs.oldHeader);
                ret.newHeader = selectField(ret, mine.newHeader, theirs.newHeader);
            }
        }
        ret.hunks = [];
        var mineIndex = 0, theirsIndex = 0, mineOffset = 0, theirsOffset = 0;
        while(mineIndex < mine.hunks.length || theirsIndex < theirs.hunks.length){
            var mineCurrent = mine.hunks[mineIndex] || {
                oldStart: Infinity
            }, theirsCurrent = theirs.hunks[theirsIndex] || {
                oldStart: Infinity
            };
            if (hunkBefore(mineCurrent, theirsCurrent)) {
                // This patch does not overlap with any of the others, yay.
                ret.hunks.push(cloneHunk(mineCurrent, mineOffset));
                mineIndex++;
                theirsOffset += mineCurrent.newLines - mineCurrent.oldLines;
            } else if (hunkBefore(theirsCurrent, mineCurrent)) {
                // This patch does not overlap with any of the others, yay.
                ret.hunks.push(cloneHunk(theirsCurrent, theirsOffset));
                theirsIndex++;
                mineOffset += theirsCurrent.newLines - theirsCurrent.oldLines;
            } else {
                // Overlap, merge as best we can
                var mergedHunk = {
                    oldStart: Math.min(mineCurrent.oldStart, theirsCurrent.oldStart),
                    oldLines: 0,
                    newStart: Math.min(mineCurrent.newStart + mineOffset, theirsCurrent.oldStart + theirsOffset),
                    newLines: 0,
                    lines: []
                };
                mergeLines(mergedHunk, mineCurrent.oldStart, mineCurrent.lines, theirsCurrent.oldStart, theirsCurrent.lines);
                theirsIndex++;
                mineIndex++;
                ret.hunks.push(mergedHunk);
            }
        }
        return ret;
    }
    function loadPatch(param, base) {
        if (typeof param === 'string') {
            if (/^@@/m.test(param) || /^Index:/m.test(param)) return parsePatch(param)[0];
            if (!base) throw new Error('Must provide a base reference or pass in a patch');
            return structuredPatch(undefined, undefined, base, param);
        }
        return param;
    }
    function fileNameChanged(patch) {
        return patch.newFileName && patch.newFileName !== patch.oldFileName;
    }
    function selectField(index, mine, theirs) {
        if (mine === theirs) return mine;
        else {
            index.conflict = true;
            return {
                mine: mine,
                theirs: theirs
            };
        }
    }
    function hunkBefore(test, check) {
        return test.oldStart < check.oldStart && test.oldStart + test.oldLines < check.oldStart;
    }
    function cloneHunk(hunk, offset) {
        return {
            oldStart: hunk.oldStart,
            oldLines: hunk.oldLines,
            newStart: hunk.newStart + offset,
            newLines: hunk.newLines,
            lines: hunk.lines
        };
    }
    function mergeLines(hunk, mineOffset, mineLines, theirOffset, theirLines) {
        // This will generally result in a conflicted hunk, but there are cases where the context
        // is the only overlap where we can successfully merge the content here.
        var mine = {
            offset: mineOffset,
            lines: mineLines,
            index: 0
        }, their = {
            offset: theirOffset,
            lines: theirLines,
            index: 0
        };
        // Handle any leading content
        insertLeading(hunk, mine, their);
        insertLeading(hunk, their, mine);
        // Now in the overlap content. Scan through and select the best changes from each.
        while(mine.index < mine.lines.length && their.index < their.lines.length){
            var mineCurrent = mine.lines[mine.index], theirCurrent = their.lines[their.index];
            if ((mineCurrent[0] === '-' || mineCurrent[0] === '+') && (theirCurrent[0] === '-' || theirCurrent[0] === '+')) // Both modified ...
            mutualChange(hunk, mine, their);
            else if (mineCurrent[0] === '+' && theirCurrent[0] === ' ') {
                var _hunk$lines;
                // Mine inserted
                (_hunk$lines = hunk.lines).push.apply(_hunk$lines, _toConsumableArray(collectChange(mine)));
            } else if (theirCurrent[0] === '+' && mineCurrent[0] === ' ') {
                var _hunk$lines2;
                // Theirs inserted
                (_hunk$lines2 = hunk.lines).push.apply(_hunk$lines2, _toConsumableArray(collectChange(their)));
            } else if (mineCurrent[0] === '-' && theirCurrent[0] === ' ') // Mine removed or edited
            removal(hunk, mine, their);
            else if (theirCurrent[0] === '-' && mineCurrent[0] === ' ') // Their removed or edited
            removal(hunk, their, mine, true);
            else if (mineCurrent === theirCurrent) {
                // Context identity
                hunk.lines.push(mineCurrent);
                mine.index++;
                their.index++;
            } else // Context mismatch
            conflict(hunk, collectChange(mine), collectChange(their));
        }
        // Now push anything that may be remaining
        insertTrailing(hunk, mine);
        insertTrailing(hunk, their);
        calcLineCount(hunk);
    }
    function mutualChange(hunk, mine, their) {
        var myChanges = collectChange(mine), theirChanges = collectChange(their);
        if (allRemoves(myChanges) && allRemoves(theirChanges)) {
            // Special case for remove changes that are supersets of one another
            if (arrayStartsWith(myChanges, theirChanges) && skipRemoveSuperset(their, myChanges, myChanges.length - theirChanges.length)) {
                var _hunk$lines3;
                (_hunk$lines3 = hunk.lines).push.apply(_hunk$lines3, _toConsumableArray(myChanges));
                return;
            } else if (arrayStartsWith(theirChanges, myChanges) && skipRemoveSuperset(mine, theirChanges, theirChanges.length - myChanges.length)) {
                var _hunk$lines4;
                (_hunk$lines4 = hunk.lines).push.apply(_hunk$lines4, _toConsumableArray(theirChanges));
                return;
            }
        } else if (arrayEqual(myChanges, theirChanges)) {
            var _hunk$lines5;
            (_hunk$lines5 = hunk.lines).push.apply(_hunk$lines5, _toConsumableArray(myChanges));
            return;
        }
        conflict(hunk, myChanges, theirChanges);
    }
    function removal(hunk, mine, their, swap) {
        var myChanges = collectChange(mine), theirChanges = collectContext(their, myChanges);
        if (theirChanges.merged) {
            var _hunk$lines6;
            (_hunk$lines6 = hunk.lines).push.apply(_hunk$lines6, _toConsumableArray(theirChanges.merged));
        } else conflict(hunk, swap ? theirChanges : myChanges, swap ? myChanges : theirChanges);
    }
    function conflict(hunk, mine, their) {
        hunk.conflict = true;
        hunk.lines.push({
            conflict: true,
            mine: mine,
            theirs: their
        });
    }
    function insertLeading(hunk, insert, their) {
        while(insert.offset < their.offset && insert.index < insert.lines.length){
            var line = insert.lines[insert.index++];
            hunk.lines.push(line);
            insert.offset++;
        }
    }
    function insertTrailing(hunk, insert) {
        while(insert.index < insert.lines.length){
            var line = insert.lines[insert.index++];
            hunk.lines.push(line);
        }
    }
    function collectChange(state) {
        var ret = [], operation = state.lines[state.index][0];
        while(state.index < state.lines.length){
            var line = state.lines[state.index];
            // Group additions that are immediately after subtractions and treat them as one "atomic" modify change.
            if (operation === '-' && line[0] === '+') operation = '+';
            if (operation === line[0]) {
                ret.push(line);
                state.index++;
            } else break;
        }
        return ret;
    }
    function collectContext(state, matchChanges) {
        var changes = [], merged = [], matchIndex = 0, contextChanges = false, conflicted = false;
        while(matchIndex < matchChanges.length && state.index < state.lines.length){
            var change = state.lines[state.index], match = matchChanges[matchIndex];
            // Once we've hit our add, then we are done
            if (match[0] === '+') break;
            contextChanges = contextChanges || change[0] !== ' ';
            merged.push(match);
            matchIndex++;
            // Consume any additions in the other block as a conflict to attempt
            // to pull in the remaining context after this
            if (change[0] === '+') {
                conflicted = true;
                while(change[0] === '+'){
                    changes.push(change);
                    change = state.lines[++state.index];
                }
            }
            if (match.substr(1) === change.substr(1)) {
                changes.push(change);
                state.index++;
            } else conflicted = true;
        }
        if ((matchChanges[matchIndex] || '')[0] === '+' && contextChanges) conflicted = true;
        if (conflicted) return changes;
        while(matchIndex < matchChanges.length)merged.push(matchChanges[matchIndex++]);
        return {
            merged: merged,
            changes: changes
        };
    }
    function allRemoves(changes) {
        return changes.reduce(function(prev, change) {
            return prev && change[0] === '-';
        }, true);
    }
    function skipRemoveSuperset(state, removeChanges, delta) {
        for(var i = 0; i < delta; i++){
            var changeContent = removeChanges[removeChanges.length - delta + i].substr(1);
            if (state.lines[state.index + i] !== ' ' + changeContent) return false;
        }
        state.index += delta;
        return true;
    }
    function calcOldNewLineCount(lines) {
        var oldLines = 0;
        var newLines = 0;
        lines.forEach(function(line) {
            if (typeof line !== 'string') {
                var myCount = calcOldNewLineCount(line.mine);
                var theirCount = calcOldNewLineCount(line.theirs);
                if (oldLines !== undefined) {
                    if (myCount.oldLines === theirCount.oldLines) oldLines += myCount.oldLines;
                    else oldLines = undefined;
                }
                if (newLines !== undefined) {
                    if (myCount.newLines === theirCount.newLines) newLines += myCount.newLines;
                    else newLines = undefined;
                }
            } else {
                if (newLines !== undefined && (line[0] === '+' || line[0] === ' ')) newLines++;
                if (oldLines !== undefined && (line[0] === '-' || line[0] === ' ')) oldLines++;
            }
        });
        return {
            oldLines: oldLines,
            newLines: newLines
        };
    }
    function reversePatch(structuredPatch) {
        if (Array.isArray(structuredPatch)) return structuredPatch.map(reversePatch).reverse();
        return _objectSpread2(_objectSpread2({}, structuredPatch), {}, {
            oldFileName: structuredPatch.newFileName,
            oldHeader: structuredPatch.newHeader,
            newFileName: structuredPatch.oldFileName,
            newHeader: structuredPatch.oldHeader,
            hunks: structuredPatch.hunks.map(function(hunk) {
                return {
                    oldLines: hunk.newLines,
                    oldStart: hunk.newStart,
                    newLines: hunk.oldLines,
                    newStart: hunk.oldStart,
                    lines: hunk.lines.map(function(l) {
                        if (l.startsWith('-')) return "+".concat(l.slice(1));
                        if (l.startsWith('+')) return "-".concat(l.slice(1));
                        return l;
                    })
                };
            })
        });
    }
    // See: http://code.google.com/p/google-diff-match-patch/wiki/API
    function convertChangesToDMP(changes) {
        var ret = [], change, operation;
        for(var i = 0; i < changes.length; i++){
            change = changes[i];
            if (change.added) operation = 1;
            else if (change.removed) operation = -1;
            else operation = 0;
            ret.push([
                operation,
                change.value
            ]);
        }
        return ret;
    }
    function convertChangesToXML(changes) {
        var ret = [];
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            if (change.added) ret.push('<ins>');
            else if (change.removed) ret.push('<del>');
            ret.push(escapeHTML(change.value));
            if (change.added) ret.push('</ins>');
            else if (change.removed) ret.push('</del>');
        }
        return ret.join('');
    }
    function escapeHTML(s) {
        var n = s;
        n = n.replace(/&/g, '&amp;');
        n = n.replace(/</g, '&lt;');
        n = n.replace(/>/g, '&gt;');
        n = n.replace(/"/g, '&quot;');
        return n;
    }
    exports.Diff = Diff;
    exports.applyPatch = applyPatch;
    exports.applyPatches = applyPatches;
    exports.canonicalize = canonicalize;
    exports.convertChangesToDMP = convertChangesToDMP;
    exports.convertChangesToXML = convertChangesToXML;
    exports.createPatch = createPatch;
    exports.createTwoFilesPatch = createTwoFilesPatch;
    exports.diffArrays = diffArrays;
    exports.diffChars = diffChars;
    exports.diffCss = diffCss;
    exports.diffJson = diffJson;
    exports.diffLines = diffLines;
    exports.diffSentences = diffSentences;
    exports.diffTrimmedLines = diffTrimmedLines;
    exports.diffWords = diffWords;
    exports.diffWordsWithSpace = diffWordsWithSpace;
    exports.formatPatch = formatPatch;
    exports.merge = merge;
    exports.parsePatch = parsePatch;
    exports.reversePatch = reversePatch;
    exports.structuredPatch = structuredPatch;
});


const $fa31b2d9fcff7cf6$export$483961d936959a56 = (prevText, nextText, startOffset)=>{
    const diff = $cf14d593c82702d6$exports.diffChars(prevText, nextText);
    let operations = [];
    let position = 0;
    diff.forEach((part)=>{
        if (part.added) operations.push({
            insert: {
                text: part.value,
                utf16Start: startOffset + position,
                anchor: position === 0 ? (0, $b522cf181e75e62d$export$eb2f7ec705c266a5).AFTER_INDEX : (0, $b522cf181e75e62d$export$eb2f7ec705c266a5).BEFORE_INDEX
            }
        });
        else if (part.removed) operations.push({
            delete: {
                utf16Start: startOffset + position,
                utf16Size: part.count
            }
        });
        if (!part.removed) position += part.count;
    });
    return operations;
};
const $fa31b2d9fcff7cf6$export$5505edc76a3c688d = (pageMetadata, selectedPosition)=>{
    if (selectedPosition.size !== 0) return false;
    const previousChar = pageMetadata.textContent.substring(selectedPosition.start - (pageMetadata.page.anchors[0]?.utf16Start || 0), selectedPosition.start - (pageMetadata.page.anchors[0]?.utf16Start || 0) + 1);
    const nextChar = pageMetadata.textContent.substring(selectedPosition.start - (pageMetadata.page.anchors[0]?.utf16Start || 0) + selectedPosition.size + 1, selectedPosition.start - (pageMetadata.page.anchors[0]?.utf16Start || 0) + selectedPosition.size + 2);
    return previousChar === " " || previousChar === "\xa0" || nextChar === " " || nextChar === "\xa0";
};







var $jMaZ8 = parcelRequire("jMaZ8");

var $c014478c0bec8df8$exports = {};

$parcel$export($c014478c0bec8df8$exports, "root", () => $c014478c0bec8df8$export$e8e78c978b129247, (v) => $c014478c0bec8df8$export$e8e78c978b129247 = v);
$parcel$export($c014478c0bec8df8$exports, "syllables", () => $c014478c0bec8df8$export$f25b91aaf35fce4a, (v) => $c014478c0bec8df8$export$f25b91aaf35fce4a = v);
$parcel$export($c014478c0bec8df8$exports, "phonemes", () => $c014478c0bec8df8$export$55b1534fada2667c, (v) => $c014478c0bec8df8$export$55b1534fada2667c = v);
$parcel$export($c014478c0bec8df8$exports, "mode", () => $c014478c0bec8df8$export$549ff81930776885, (v) => $c014478c0bec8df8$export$549ff81930776885 = v);
var $c014478c0bec8df8$export$e8e78c978b129247;
var $c014478c0bec8df8$export$f25b91aaf35fce4a;
var $c014478c0bec8df8$export$55b1534fada2667c;
var $c014478c0bec8df8$export$549ff81930776885;
$c014478c0bec8df8$export$e8e78c978b129247 = "root_b7fdae";
$c014478c0bec8df8$export$f25b91aaf35fce4a = "syllables_b7fdae";
$c014478c0bec8df8$export$55b1534fada2667c = "phonemes_b7fdae";
$c014478c0bec8df8$export$549ff81930776885 = "mode_b7fdae";







const $b9c8707a3d5ef653$export$70d6cece79127a8 = (selectedTextPosition, removeSyllable, merge, mute, unmute, translation)=>{
    const isDisabled = selectedTextPosition.size === 0;
    const items = [
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "creat",
            label: translation.creat,
            disabled: isDisabled,
            onClick: selectedTextPosition.size ? ()=>{
                if (!isDisabled) merge(selectedTextPosition);
            } : undefined
        }),
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "transformMute",
            label: translation.transformMute,
            disabled: isDisabled,
            onClick: selectedTextPosition.size ? ()=>{
                if (!isDisabled) mute(selectedTextPosition);
            } : undefined
        }),
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "transformNoMute",
            label: translation.transformNoMute,
            disabled: isDisabled,
            onClick: selectedTextPosition.size ? ()=>{
                if (!isDisabled) unmute(selectedTextPosition);
            } : undefined
        }),
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "ignore",
            label: translation.ignore,
            danger: true,
            disabled: isDisabled,
            onClick: selectedTextPosition.size ? ()=>{
                if (!isDisabled) removeSyllable(selectedTextPosition);
            } : undefined
        })
    ];
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
        items: items
    });
};
const $b9c8707a3d5ef653$export$5c0fe5a0ba77e605 = (selectedTextPosition, removePhoneme, assignPhoneme, mute, unmute, translation)=>{
    const isDisabled = !selectedTextPosition.size;
    const items = [
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "s1",
            label: translation.title,
            disabled: isDisabled,
            children: [
                (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                    key: "s1-1",
                    label: translation.vowel,
                    onClick: ()=>{
                        if (!isDisabled) assignPhoneme(selectedTextPosition, "VOWEL");
                    }
                }),
                (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                    key: "s1-2",
                    label: translation.consonant,
                    onClick: ()=>{
                        if (!isDisabled) assignPhoneme(selectedTextPosition, "CONSONANT");
                    }
                }),
                (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                    key: "s1-3",
                    label: translation.complex,
                    onClick: ()=>{
                        if (!isDisabled) assignPhoneme(selectedTextPosition, "COMPLEX");
                    }
                })
            ]
        }),
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "2",
            label: translation.transformMute,
            disabled: isDisabled,
            onClick: ()=>{
                if (!isDisabled) mute(selectedTextPosition);
            }
        }),
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "3",
            label: translation.transformNoMute,
            disabled: isDisabled,
            onClick: ()=>{
                if (!isDisabled) unmute(selectedTextPosition);
            }
        }),
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "4",
            danger: true,
            label: translation.ignore,
            disabled: isDisabled,
            onClick: ()=>{
                if (!isDisabled) removePhoneme(selectedTextPosition);
            }
        })
    ];
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
        items: items
    });
};
const $b9c8707a3d5ef653$export$830cc812c144c6bb = (selectedTextPosition, removeCustomColor, assignCustomColor, customColors, translation)=>{
    const isDisabled = !selectedTextPosition.size;
    const items = [
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "s1",
            label: translation.assignCustomColor,
            disabled: isDisabled,
            children: customColors.sort((a, b)=>a.label.localeCompare(b.label)).map((customColor)=>(0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                    key: customColor.key,
                    label: customColor.label,
                    onClick: ()=>{
                        if (!isDisabled) assignCustomColor(selectedTextPosition, {
                            customColorationKey: customColor.key
                        });
                    }
                }))
        }),
        (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "2",
            label: translation.removeCustomColor,
            disabled: isDisabled,
            onClick: ()=>{
                if (!isDisabled) removeCustomColor(selectedTextPosition);
            }
        })
    ];
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
        items: items
    });
};
function $b9c8707a3d5ef653$export$2e2bcd8739ae039({ merge: merge, mute: mute, unmute: unmute, removeSyllable: removeSyllable, mode: mode, removePhoneme: removePhoneme, assignPhoneme: assignPhoneme, removeCustomColor: removeCustomColor, assignCustomColor: assignCustomColor, customColors: customColors, projectId: projectId, allPages: allPages }) {
    const { pageMetadata: pageMetadata } = (0, $9a1b5d9b85264433$export$2ff026368446039c)(allPages);
    const contentEditableRef = (0, $jMaZ8.useRef)(null);
    const RenderBook = (0, $jMaZ8.useMemo)(()=>(0, $d0ce5078a897d2dc$export$2e2bcd8739ae039)(), []);
    const { selectedTextPosition: selectedTextPosition, reset: reset, saveSelection: saveSelection } = (0, $b475e6138875e356$export$6b1e75a5561fc59c)();
    const buildSyllableMenuTranslation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.syllable.buildSyllableMenu");
    const buildPhonemeMenuTranslation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.syllable.buildPhonemeMenu");
    const buildCustomColorsMenuTranslation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.syllable.buildCustomColorsMenu");
    (0, $jMaZ8.useEffect)(()=>{
        const noop = (e)=>{
            e.preventDefault();
            return false;
        };
        const contentEditableRefCurrent = contentEditableRef.current;
        contentEditableRefCurrent?.addEventListener("cut", noop, false);
        contentEditableRefCurrent?.addEventListener("paste", noop, false);
        contentEditableRefCurrent?.addEventListener("keydown", noop, false);
        contentEditableRefCurrent?.addEventListener("dragenter", noop, false);
        contentEditableRefCurrent?.addEventListener("dragleave", noop, false);
        contentEditableRefCurrent?.addEventListener("dragover", noop, false);
        contentEditableRefCurrent?.addEventListener("drop", noop, false);
        return ()=>{
            contentEditableRefCurrent?.removeEventListener("cut", noop);
            contentEditableRefCurrent?.removeEventListener("paste", noop);
            contentEditableRefCurrent?.removeEventListener("keydown", noop);
            contentEditableRefCurrent?.removeEventListener("dragenter", noop);
            contentEditableRefCurrent?.removeEventListener("dragleave", noop);
            contentEditableRefCurrent?.removeEventListener("dragover", noop);
            contentEditableRefCurrent?.removeEventListener("drop", noop);
        };
    }, [
        contentEditableRef
    ]);
    const renderDropdownContent = (0, $jMaZ8.useCallback)(()=>{
        if (mode === "syllables") return $b9c8707a3d5ef653$export$70d6cece79127a8(selectedTextPosition, removeSyllable, merge, mute, unmute, buildSyllableMenuTranslation);
        if (mode === "phonemes") return $b9c8707a3d5ef653$export$5c0fe5a0ba77e605(selectedTextPosition, removePhoneme, assignPhoneme, mute, unmute, buildPhonemeMenuTranslation);
        return $b9c8707a3d5ef653$export$830cc812c144c6bb(selectedTextPosition, removeCustomColor, assignCustomColor, customColors, buildCustomColorsMenuTranslation);
    }, [
        mode,
        selectedTextPosition,
        removeCustomColor,
        assignCustomColor,
        customColors,
        buildCustomColorsMenuTranslation,
        removeSyllable,
        merge,
        mute,
        unmute,
        buildSyllableMenuTranslation,
        removePhoneme,
        assignPhoneme,
        buildPhonemeMenuTranslation
    ]);
    const { onMouseUp: onMouseUp, onMouseDown: onMouseDown } = (0, $jMaZ8.useMemo)(()=>{
        return {
            onMouseUp: saveSelection,
            onMouseDown: (e)=>e.button === 0 && reset()
        };
    }, [
        reset,
        saveSelection
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
        trigger: [
            "contextMenu"
        ],
        dropdownRender: renderDropdownContent,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            className: $c014478c0bec8df8$exports.root.concat(" ", $c014478c0bec8df8$exports[mode]),
            ref: contentEditableRef,
            contentEditable: "true",
            suppressContentEditableWarning: true,
            onMouseUp: onMouseUp,
            onMouseDown: onMouseDown,
            children: [
                mode === "custom" && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("style", {
                    children: `
        .${$c014478c0bec8df8$exports.root} .rhese {
          padding: 0.12em 0;
        }
        ${customColors.map((customColor)=>`
            .${$c014478c0bec8df8$exports.root} .rhese .customColoration.color${customColor.key} {
            color: ${customColor.color};
          }
          `).join("\n")}
      `
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(RenderBook, {
                    projectId: projectId,
                    children: pageMetadata
                })
            ]
        })
    });
}





const $d76877bf3de2dd32$var$EditRhese = ({ rhese: rhese, onCancel: onCancel, editRhese: editRhese, onOk: onOk, pageMetadata: pageMetadata, open: open, projectId: projectId })=>{
    const [step, setStep] = (0, $jMaZ8.useState)(1);
    const [applyDeleteSyllableFromPosition] = (0, $2cbc1e4bffc4bf21$export$c6f584713ec549a2)();
    const [applyCreateSyllableFromPosition] = (0, $2cbc1e4bffc4bf21$export$7cab5666971b1572)();
    const [applySetMuteFromPosition] = (0, $b7be8974895307ad$export$c01896a7be4e05e6)();
    const [applyUnsetMuteFromPosition] = (0, $b7be8974895307ad$export$26d1265de1014c07)();
    const [applySetPhonemeFromPosition] = (0, $5ca13b1bb5133f96$export$aab3867090efe064)();
    const [applyUnsetPhonemeFromPosition] = (0, $5ca13b1bb5133f96$export$138d955481de2f64)();
    const contentEditableRef = (0, $jMaZ8.useRef)(null);
    const convertedRhese = (0, $jMaZ8.useMemo)(()=>{
        const convertedPageContent = (0, $d6f8296a78132fd9$export$90646acbacb76625)("123", pageMetadata);
        return convertedPageContent.rheses.find((r)=>r.id === rhese.data.id);
    }, [
        pageMetadata,
        rhese
    ]);
    const title = (0, $jMaZ8.useMemo)(()=>{
        if (step === 2) return "Corriger les syllabes";
        if (step === 3) return "Corriger les phon\xe8mes";
        if (step === 4) return "Attention !";
        return "\xc9diter la rhese";
    }, [
        step
    ]);
    const { selectedTextPosition: selectedTextPosition, saveSelection: saveSelection } = (0, $b475e6138875e356$export$6b1e75a5561fc59c)();
    (0, $jMaZ8.useEffect)(()=>{
        const noop = (e)=>{
            e.preventDefault();
            return false;
        };
        const contentEditableRefCurrent = contentEditableRef.current;
        contentEditableRefCurrent?.addEventListener("cut", noop, false);
        contentEditableRefCurrent?.addEventListener("paste", noop, false);
        contentEditableRefCurrent?.addEventListener("keydown", noop, false);
        contentEditableRefCurrent?.addEventListener("dragenter", noop, false);
        contentEditableRefCurrent?.addEventListener("dragleave", noop, false);
        contentEditableRefCurrent?.addEventListener("dragover", noop, false);
        contentEditableRefCurrent?.addEventListener("drop", noop, false);
        return ()=>{
            contentEditableRefCurrent?.removeEventListener("cut", noop);
            contentEditableRefCurrent?.removeEventListener("paste", noop);
            contentEditableRefCurrent?.removeEventListener("keydown", noop);
            contentEditableRefCurrent?.removeEventListener("dragenter", noop);
            contentEditableRefCurrent?.removeEventListener("dragleave", noop);
            contentEditableRefCurrent?.removeEventListener("dragover", noop);
            contentEditableRefCurrent?.removeEventListener("drop", noop);
        };
    }, [
        contentEditableRef
    ]);
    /* STEP 1: EDIT RHESE */ const [newRheseContent, setNewRheseContent] = (0, $jMaZ8.useState)(()=>(0, $7ff84a88030acb67$export$4596341c772d96c7)(rhese, pageMetadata) || "");
    const handleChange = (0, $jMaZ8.useCallback)((event)=>{
        const newString = event.target instanceof HTMLInputElement && event.target.value;
        if (newString === false) return;
        setNewRheseContent(newString);
        return;
    }, []);
    const submit = (0, $jMaZ8.useCallback)(async ()=>{
        const prevText = (0, $7ff84a88030acb67$export$4596341c772d96c7)(rhese, pageMetadata);
        if (prevText === newRheseContent || !prevText) {
            onCancel();
            return;
        }
        await editRhese((0, $fa31b2d9fcff7cf6$export$483961d936959a56)(prevText, newRheseContent, rhese.anchors[0].utf16Start), newRheseContent.length);
        setStep(step + 1);
    }, [
        editRhese,
        newRheseContent,
        onCancel,
        pageMetadata,
        rhese,
        step
    ]);
    /* Mute functions */ const mute = (0, $jMaZ8.useCallback)(async (selectedTextPosition)=>{
        applySetMuteFromPosition({
            variables: {
                projectId: projectId,
                stringVersion: pageMetadata.page.anchors[0].stringVersion,
                start: selectedTextPosition.start,
                size: selectedTextPosition.size
            }
        });
    }, [
        applySetMuteFromPosition,
        pageMetadata?.page.anchors,
        projectId
    ]);
    const unmute = (0, $jMaZ8.useCallback)(async (selectedTextPosition)=>{
        applyUnsetMuteFromPosition({
            variables: {
                projectId: projectId,
                stringVersion: pageMetadata.page.anchors[0].stringVersion,
                start: selectedTextPosition.start,
                size: selectedTextPosition.size
            }
        });
    }, [
        applyUnsetMuteFromPosition,
        pageMetadata?.page.anchors,
        projectId
    ]);
    /* STEP 2: EDIT SYLLABLE */ const buildSyllableMenuTranslation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.syllable.buildSyllableMenu");
    const renderDropdownContentSyllable = (0, $jMaZ8.useCallback)(()=>(0, $b9c8707a3d5ef653$export$70d6cece79127a8)(selectedTextPosition, (selectedTextPosition)=>{
            applyDeleteSyllableFromPosition({
                variables: {
                    projectId: projectId,
                    stringVersion: pageMetadata.page.anchors[0].stringVersion,
                    start: selectedTextPosition.start,
                    size: selectedTextPosition.size
                }
            });
        }, (selectedTextPosition)=>{
            applyCreateSyllableFromPosition({
                variables: {
                    projectId: projectId,
                    stringVersion: pageMetadata.page.anchors[0].stringVersion,
                    start: selectedTextPosition.start,
                    size: selectedTextPosition.size
                }
            });
        }, mute, unmute, buildSyllableMenuTranslation), [
        applyCreateSyllableFromPosition,
        applyDeleteSyllableFromPosition,
        buildSyllableMenuTranslation,
        mute,
        pageMetadata.page.anchors,
        projectId,
        selectedTextPosition,
        unmute
    ]);
    /* STEP 3: EDIT PHONEME */ const buildPhonemeMenuMenuTranslation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.syllable.buildPhonemeMenu");
    const renderDropdownContentPhoneme = (0, $jMaZ8.useCallback)(()=>(0, $b9c8707a3d5ef653$export$5c0fe5a0ba77e605)(selectedTextPosition, (selectedTextPosition)=>{
            applyUnsetPhonemeFromPosition({
                variables: {
                    projectId: projectId,
                    stringVersion: pageMetadata.page.anchors[0].stringVersion,
                    start: selectedTextPosition.start,
                    size: selectedTextPosition.size
                }
            });
        }, (selectedTextPosition, phoneme)=>{
            applySetPhonemeFromPosition({
                variables: {
                    projectId: projectId,
                    stringVersion: pageMetadata.page.anchors[0].stringVersion,
                    start: selectedTextPosition.start,
                    size: selectedTextPosition.size,
                    kind: phoneme
                }
            });
        }, mute, unmute, buildPhonemeMenuMenuTranslation), [
        applySetPhonemeFromPosition,
        applyUnsetPhonemeFromPosition,
        buildPhonemeMenuMenuTranslation,
        mute,
        pageMetadata.page.anchors,
        projectId,
        selectedTextPosition,
        unmute
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        className: $2a7535a2ddfb4c89$export$61b3ec0eac9cf83,
        title: title,
        open: open,
        footer: null,
        onCancel: onCancel,
        children: [
            step === 1 && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        onChange: handleChange,
                        type: "text",
                        value: newRheseContent
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $2a7535a2ddfb4c89$export$2e0b248dcb906f5a,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            shape: "round",
                            onClick: submit,
                            children: "Continuer"
                        })
                    })
                ]
            }),
            step === 2 && !!convertedRhese && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
                        trigger: [
                            "contextMenu"
                        ],
                        dropdownRender: renderDropdownContentSyllable,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            className: $2a7535a2ddfb4c89$export$dcb338dde686ac99,
                            onMouseUp: saveSelection,
                            ref: contentEditableRef,
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                id: `page-${pageMetadata.page.data.pageNumber.pageNumber}`,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d0ce5078a897d2dc$export$8eeee60730c609c5), {
                                    isSearchResult: false,
                                    definitions: [],
                                    index: 0,
                                    activeStart: false,
                                    activeEnd: false,
                                    active: false,
                                    spaceIfNeeded: null,
                                    enableCustomCssTooltip: false,
                                    highlightSpaces: false,
                                    children: convertedRhese
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $2a7535a2ddfb4c89$export$2e0b248dcb906f5a,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            shape: "round",
                            onClick: ()=>setStep(step + 1),
                            children: "Continuer"
                        })
                    })
                ]
            }),
            step === 3 && !!convertedRhese && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
                        trigger: [
                            "contextMenu"
                        ],
                        dropdownRender: renderDropdownContentPhoneme,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            className: $2a7535a2ddfb4c89$export$3cbeddca5d4cf2c6,
                            onMouseUp: saveSelection,
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                id: `page-${pageMetadata.page.data.pageNumber.pageNumber}`,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d0ce5078a897d2dc$export$8eeee60730c609c5), {
                                    isSearchResult: false,
                                    definitions: [],
                                    index: 0,
                                    activeStart: false,
                                    activeEnd: false,
                                    active: false,
                                    spaceIfNeeded: null,
                                    enableCustomCssTooltip: false,
                                    highlightSpaces: false,
                                    children: convertedRhese
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $2a7535a2ddfb4c89$export$2e0b248dcb906f5a,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            htmlType: "submit",
                            shape: "round",
                            onClick: onOk,
                            children: "Valider"
                        })
                    })
                ]
            })
        ]
    });
};
var $d76877bf3de2dd32$export$2e2bcd8739ae039 = $d76877bf3de2dd32$var$EditRhese;





var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");

function $8510a1073180dcbc$export$8ca4588a3a9b81e9({ root: root, revision: revision }) {
    const id = (0, $jMaZ8.useId)();
    const [anchor, setAnchor] = (0, $jMaZ8.useState)(null);
    const tooltip = (0, $jMaZ8.useRef)(null);
    const refresh = (0, $jMaZ8.useRef)(()=>{});
    (0, $jMaZ8.useLayoutEffect)(()=>{
        const page = root.current;
        if (!page) return;
        const scrollRoot = page.closest("#project-root");
        let active = null;
        let hovered = null;
        let focused = null;
        let dismissed = null;
        let describedControl = null;
        let timer;
        let frame = 0;
        const find = (target, fromControl = false)=>{
            if (!(target instanceof Element) || !page.contains(target)) return null;
            const node = target.closest("[data-rhese-length]");
            return node || (fromControl ? target.closest("button[data-rhese-edit-id]")?.parentElement?.querySelector("[data-rhese-length]") || null : null);
        };
        const popupContains = (target)=>active && target instanceof Node && !!document.getElementById(id)?.closest(".ant-tooltip")?.contains(target);
        const describe = (node, add)=>{
            const ids = new Set((node.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean));
            if (add) ids.add(id);
            else ids.delete(id);
            if (ids.size) node.setAttribute("aria-describedby", [
                ...ids
            ].join(" "));
            else node.removeAttribute("aria-describedby");
        };
        const hide = ()=>{
            clearTimeout(timer);
            observer.disconnect();
            if (active) describe(active, false);
            if (describedControl) describe(describedControl, false);
            describedControl = null;
            active = null;
            setAnchor(null);
        };
        const update = ()=>{
            if (!active) return;
            if (!active.isConnected || !page.contains(active)) {
                hide();
                return;
            }
            const r = active.getBoundingClientRect();
            const clip = scrollRoot?.getBoundingClientRect();
            if (r.bottom <= Math.max(0, clip?.top || 0) || r.top >= Math.min(innerHeight, clip?.bottom ?? innerHeight) || r.right <= 0 || r.left >= innerWidth) {
                hide();
                return;
            }
            const next = {
                node: active,
                length: active.dataset.rheseLength || "0",
                left: r.left,
                top: r.top,
                width: r.width,
                height: r.height
            };
            setAnchor((old)=>old && old.node === next.node && old.length === next.length && old.left === next.left && old.top === next.top && old.width === next.width && old.height === next.height ? old : next);
        };
        const reposition = ()=>{
            if (active && !frame) frame = requestAnimationFrame(()=>{
                frame = 0;
                update();
            });
        };
        const observer = new ResizeObserver(reposition);
        const show = (node)=>{
            if (describedControl) describe(describedControl, false);
            describedControl = find(document.activeElement, true) === node ? document.activeElement?.closest("button[data-rhese-edit-id]") || null : null;
            if (describedControl) describe(describedControl, true);
            if (active !== node) {
                if (active) describe(active, false);
                observer.disconnect();
                active = node;
                describe(node, true);
                observer.observe(node);
                observer.observe(page);
            }
            update();
        };
        const choose = (node, delay = 100)=>{
            clearTimeout(timer);
            if (dismissed && hovered !== dismissed && focused !== dismissed) dismissed = null;
            if (node === active || node && node === dismissed) return;
            timer = setTimeout(()=>node ? show(node) : hide(), delay);
        };
        const over = (event)=>{
            hovered = find(event.target);
            choose(hovered || focused);
        };
        const out = (event)=>{
            if (popupContains(event.relatedTarget)) {
                clearTimeout(timer);
                return;
            }
            hovered = find(event.relatedTarget);
            choose(hovered || focused);
        };
        const popupOver = (event)=>{
            if (popupContains(event.target)) clearTimeout(timer);
        };
        const popupOut = (event)=>{
            if (popupContains(event.target)) out(event);
        };
        const focus = (event)=>{
            focused = find(event.target, true);
            if (focused && focused === active) show(focused);
            else choose(focused || hovered, 0);
        };
        const blur = (event)=>{
            if (describedControl) describe(describedControl, false);
            describedControl = null;
            focused = find(event.relatedTarget, true);
            choose(focused || hovered, 0);
        };
        const escape = (event)=>{
            if (event.key === "Escape") {
                dismissed = active;
                hide();
            }
        };
        page.addEventListener("pointerover", over);
        page.addEventListener("pointerout", out);
        page.addEventListener("focusin", focus);
        page.addEventListener("focusout", blur);
        document.addEventListener("pointerover", popupOver);
        document.addEventListener("pointerout", popupOut);
        document.addEventListener("keydown", escape);
        document.addEventListener("scroll", reposition, true);
        window.addEventListener("resize", reposition);
        refresh.current = update;
        return ()=>{
            clearTimeout(timer);
            cancelAnimationFrame(frame);
            observer.disconnect();
            if (active) describe(active, false);
            if (describedControl) describe(describedControl, false);
            refresh.current = ()=>{};
            page.removeEventListener("pointerover", over);
            page.removeEventListener("pointerout", out);
            page.removeEventListener("focusin", focus);
            page.removeEventListener("focusout", blur);
            document.removeEventListener("pointerover", popupOver);
            document.removeEventListener("pointerout", popupOut);
            document.removeEventListener("keydown", escape);
            document.removeEventListener("scroll", reposition, true);
            window.removeEventListener("resize", reposition);
        };
    }, [
        id,
        root
    ]);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        refresh.current();
    }, [
        revision
    ]);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        if (anchor) tooltip.current?.forceAlign();
    }, [
        anchor
    ]);
    // Keep the proxy outside contentEditable: it must never enter selections or copied text.
    return /*#__PURE__*/ (0, $6UWRi.createPortal)(/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
        ref: tooltip,
        id: id,
        title: `${anchor?.length || 0} charact.`,
        open: !!anchor,
        trigger: [],
        placement: "right",
        fresh: true,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
            "data-rhese-tooltip-anchor": "",
            "aria-hidden": "true",
            style: {
                position: "fixed",
                pointerEvents: "none",
                left: anchor?.left || 0,
                top: anchor?.top || 0,
                width: anchor?.width || 0,
                height: anchor?.height || 0
            }
        })
    }), document.body);
}


const $fb5003559adbbfb5$var$RheseEditButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function RheseEditButton({ rheseId: rheseId, label: label, onEdit: onEdit }) {
    const handleClick = (0, $jMaZ8.useCallback)(()=>onEdit(rheseId), [
        onEdit,
        rheseId
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
        "data-rhese-edit-id": rheseId,
        onClick: handleClick,
        children: label
    });
});
function $fb5003559adbbfb5$var$RhesesRenderer({ projectId: projectId, allPages: allPages }) {
    const { page: page, pageMetadata: pageMetadata } = (0, $9a1b5d9b85264433$export$2ff026368446039c)(allPages);
    const [applyUpdateTextContent] = (0, $d7188398173686a1$export$36fbd2350d26e8f6)();
    const [applyCreateRheseFromPosition] = (0, $e52adb0de4892d08$export$e59ea096342e1f51)();
    const updateDisplayedPageNumber = (0, $5b38bec19e3a4e47$export$81b3a8efdffa1495)();
    const mergeRheses = (0, $jMaZ8.useCallback)(async (rheses)=>{
        if (!page) return;
        // Add a space between the rheses
        const operations = [];
        for(let i = 0; i < rheses.length - 1; i++)operations.push({
            insert: {
                text: " ",
                utf16Start: rheses[i].anchors[0].utf16Start + rheses[i].anchors[0].utf16Size + i
            }
        });
        const { data: { updateTextContent: newStringVersion } } = await applyUpdateTextContent({
            variables: {
                projectId: projectId,
                stringVersion: page.stringVersion,
                operations: operations
            }
        });
        await applyCreateRheseFromPosition({
            variables: {
                projectId: projectId,
                stringVersion: newStringVersion,
                start: rheses[0].anchors[0].utf16Start,
                size: rheses[rheses.length - 1].anchors[0].utf16Start + rheses[rheses.length - 1].anchors[0].utf16Size - rheses[0].anchors[0].utf16Start + operations.length,
                ignoreTextForAudioSync: rheses[0].data.ignoreTextForAudioSync,
                lineBreakAfter: rheses[rheses.length - 1].data.lineBreakAfter
            }
        });
    }, [
        page,
        applyUpdateTextContent,
        projectId,
        applyCreateRheseFromPosition
    ]);
    const splitRhese = (0, $jMaZ8.useCallback)(async (rheses, selectedTextPosition)=>{
        if (selectedTextPosition.size === 0 || !page) return;
        const operations = [];
        const characterBeforeAnchor = pageMetadata.textContent.substring(selectedTextPosition.start - (page?.start || 0) - 1, selectedTextPosition.start - (page?.start || 0));
        const characterAfterAnchor = pageMetadata.textContent.substring(selectedTextPosition.start - (page?.start || 0), selectedTextPosition.start - (page?.start || 0) + 1);
        const characterBeforeFocus = pageMetadata.textContent.substring(selectedTextPosition.start - (page?.start || 0) + selectedTextPosition.size - 1, selectedTextPosition.start - (page?.start || 0) + selectedTextPosition.size);
        const characterAfterFocus = pageMetadata.textContent.substring(selectedTextPosition.start - (page?.start || 0) + selectedTextPosition.size, selectedTextPosition.start - (page?.start || 0) + selectedTextPosition.size + 1);
        let sizeOffset = 0;
        let startOffset = 0;
        if (characterBeforeAnchor === " " || characterBeforeAnchor === "\xa0") {
            operations.push({
                delete: {
                    utf16Start: selectedTextPosition.start - 1,
                    utf16Size: 1
                }
            });
            startOffset -= 1;
        }
        if (characterAfterAnchor === " " || characterAfterAnchor === "\xa0") {
            operations.push({
                delete: {
                    utf16Start: selectedTextPosition.start,
                    utf16Size: 1
                }
            });
            sizeOffset -= 1;
        }
        if (characterBeforeFocus === " " || characterBeforeFocus === "\xa0") {
            operations.push({
                delete: {
                    utf16Start: selectedTextPosition.start + startOffset + selectedTextPosition.size - 1 + sizeOffset,
                    utf16Size: 1
                }
            });
            sizeOffset -= 1;
        }
        if ((characterAfterFocus === " " || characterAfterFocus === "\xa0") && selectedTextPosition.start + selectedTextPosition.size < rheses[rheses.length - 1].anchors[0].utf16Start + rheses[rheses.length - 1].anchors[0].utf16Size) operations.push({
            delete: {
                utf16Start: selectedTextPosition.start + startOffset + selectedTextPosition.size + sizeOffset,
                utf16Size: 1
            }
        });
        let newStringVersion = page.stringVersion;
        if (operations.length) {
            const { data: { updateTextContent: updateTextContent } } = await applyUpdateTextContent({
                variables: {
                    projectId: projectId,
                    stringVersion: page.stringVersion,
                    operations: operations
                }
            });
            newStringVersion = updateTextContent;
        }
        await applyCreateRheseFromPosition({
            variables: {
                projectId: projectId,
                stringVersion: newStringVersion,
                start: selectedTextPosition.start + startOffset,
                size: selectedTextPosition.size + sizeOffset,
                ignoreTextForAudioSync: rheses[0].data.ignoreTextForAudioSync,
                lineBreakAfter: rheses[rheses.length - 1].data.lineBreakAfter
            }
        });
    }, [
        page,
        pageMetadata?.textContent,
        applyCreateRheseFromPosition,
        projectId,
        applyUpdateTextContent
    ]);
    const contentEditableRef = (0, $jMaZ8.useRef)(null);
    const [rheseToEdit, setRheseToEdit] = (0, $jMaZ8.useState)();
    const isContentAdministrator = (0, $dc10a25720c6edc8$export$1b39bc9d16fffc4d)();
    const canEditProjectContent = (0, $jMaZ8.useCallback)((rhese)=>{
        // Admin can always edit
        if (isContentAdministrator) return true;
        // Non-admin can edit if the rhese doesn't have associated audio
        const hasAudio = Boolean(rhese.audioRecordingId);
        return !hasAudio;
    }, [
        isContentAdministrator
    ]);
    const replaceRhese = (0, $jMaZ8.useCallback)(async (operations, newRheseSize)=>{
        if (!rheseToEdit) return;
        const rheseStart = rheseToEdit.anchors[0].utf16Start;
        // Find in operation if there is an insert at rhese start
        const insertOpAtRheseStart = operations.find((operation)=>operation.insert?.utf16Start === rheseStart);
        if (!page) return;
        const { data: { updateTextContent: newStringVersion } } = await applyUpdateTextContent({
            variables: {
                projectId: projectId,
                stringVersion: page.stringVersion,
                operations: operations
            }
        });
        if (insertOpAtRheseStart) await applyCreateRheseFromPosition({
            variables: {
                projectId: projectId,
                stringVersion: newStringVersion,
                start: rheseStart,
                size: newRheseSize,
                ignoreTextForAudioSync: rheseToEdit?.data.ignoreTextForAudioSync || false,
                lineBreakAfter: rheseToEdit?.data.lineBreakAfter || false
            }
        });
    }, [
        rheseToEdit,
        page,
        applyUpdateTextContent,
        projectId,
        applyCreateRheseFromPosition
    ]);
    const RenderBook = (0, $jMaZ8.useMemo)(()=>(0, $d0ce5078a897d2dc$export$2e2bcd8739ae039)(), []);
    const { selectedTextPosition: selectedTextPosition, saveSelection: saveSelection, pressingControl: pressingControl } = (0, $b475e6138875e356$export$6b1e75a5561fc59c)();
    (0, $jMaZ8.useEffect)(()=>{
        const noop = (e)=>{
            e.preventDefault();
            return false;
        };
        const ref = contentEditableRef.current;
        ref?.addEventListener("cut", noop, false);
        ref?.addEventListener("paste", noop, false);
        ref?.addEventListener("keydown", noop, false);
        ref?.addEventListener("dragenter", noop, false);
        ref?.addEventListener("dragleave", noop, false);
        ref?.addEventListener("dragover", noop, false);
        ref?.addEventListener("drop", noop, false);
        return ()=>{
            ref?.removeEventListener("cut", noop);
            ref?.removeEventListener("paste", noop);
            ref?.removeEventListener("keydown", noop);
            ref?.removeEventListener("dragenter", noop);
            ref?.removeEventListener("dragleave", noop);
            ref?.removeEventListener("dragover", noop);
            ref?.removeEventListener("drop", noop);
        };
    }, [
        contentEditableRef
    ]);
    const translation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.rhese.index.rhesesRenderer");
    const renderDropdownContent = (0, $jMaZ8.useCallback)(()=>{
        const selectedRheses = (0, $7ff84a88030acb67$export$f5d4c9ebc7847d5)(pageMetadata.rhese, selectedTextPosition);
        const oneRheseOnly = selectedRheses.length === 1;
        const noTextSelected = selectedTextPosition.size === 0;
        const noSpaceClose = (0, $fa31b2d9fcff7cf6$export$5505edc76a3c688d)(pageMetadata, selectedTextPosition);
        // Get a value indicating if only one paragraph is selected, by checking if the selection starts and ends in the same paragraph
        const onlyOneParagraphSelected = !!pageMetadata.paragraph.find((paragraph)=>paragraph.anchors[0].utf16Start <= selectedTextPosition.start && paragraph.anchors[0].utf16Start + paragraph.anchors[0].utf16Size >= selectedTextPosition.start + selectedTextPosition.size);
        const selectedText = pageMetadata.textContent.substring(selectedTextPosition.start - (page?.start || 0), selectedTextPosition.start - (page?.start || 0) + selectedTextPosition.size);
        const isOnlySpaces = selectedText.split("").every((0, $05bb51f2864c5e9e$export$840dda5a492e049a));
        const isMergeDisabled = !onlyOneParagraphSelected || selectedRheses.length < 2;
        const isNewDisabled = !oneRheseOnly || noTextSelected || isOnlySpaces;
        const isSplitDisabled = !oneRheseOnly || !noTextSelected || !noSpaceClose;
        const items = [
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "1",
                label: translation.menu.merge,
                disabled: isMergeDisabled,
                onClick: ()=>mergeRheses(selectedRheses)
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "2",
                label: translation.menu.creat,
                disabled: isNewDisabled,
                onClick: ()=>splitRhese(selectedRheses, selectedTextPosition)
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "3",
                label: translation.menu.split,
                disabled: isSplitDisabled,
                onClick: ()=>splitRhese(selectedRheses, {
                        start: selectedTextPosition.start + 1,
                        size: selectedRheses[0].anchors[0].utf16Start + selectedRheses[0].anchors[0].utf16Size - (selectedTextPosition.start + 1)
                    })
            })
        ];
        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
            items: items
        });
    }, [
        pageMetadata,
        selectedTextPosition,
        page?.start,
        translation.menu.merge,
        translation.menu.creat,
        translation.menu.split,
        mergeRheses,
        splitRhese
    ]);
    const handleClick = (0, $jMaZ8.useCallback)(()=>{
        if (pressingControl) {
            // Replace url pageNumber to the one of the selection
            if (pageMetadata.page.data.pageNumber.pageNumber !== parseInt(new URLSearchParams(window.location.search).get("displayedPageNumber") || "")) updateDisplayedPageNumber(pageMetadata.page.data.pageNumber.pageNumber.toString());
            // Fast mode enabled, getting selection
            const selection = window.getSelection();
            if (!selection || selection.toString().length > 0) return;
            const { focusNode: focusNode, focusOffset: focusOffset } = selection;
            if (!focusNode || !focusOffset) return;
            const start = ((0, $75cb39c0d60bf319$export$dfe068021b69e8a4)(focusNode) ?? 0) - (1 - selection?.anchorOffset);
            // If the start is at the end of a rhese, merge it with the next one
            const rheseStart = pageMetadata.rhese.findIndex((rhese)=>rhese.anchors[0].utf16Start + rhese.anchors[0].utf16Size === start + 1);
            if (rheseStart > -1) {
                // Check if the position is not at the end of a paragraph
                const paragraphStart = pageMetadata.paragraph.findIndex((paragraph)=>paragraph.anchors[0].utf16Start === start);
                if (paragraphStart > -1) return;
                const startRhese = pageMetadata.rhese[rheseStart];
                const endRhese = pageMetadata.rhese[rheseStart + 1];
                if (startRhese && endRhese) {
                    mergeRheses([
                        startRhese,
                        endRhese
                    ]);
                    return;
                }
            } else {
                const spaceClose = (0, $fa31b2d9fcff7cf6$export$5505edc76a3c688d)(pageMetadata, {
                    start: start,
                    size: 0
                });
                if (!spaceClose) return;
                const selectedRhese = (0, $7ff84a88030acb67$export$f5d4c9ebc7847d5)(pageMetadata.rhese, {
                    start: start,
                    size: 0
                })?.[0];
                if (!selectedRhese) return;
                splitRhese([
                    selectedRhese
                ], {
                    start: start + 1,
                    size: selectedRhese.anchors[0].utf16Start + selectedRhese.anchors[0].utf16Size - start - 1
                });
                return;
            }
        } else // Fast mode disabled, saving selection
        saveSelection();
    }, [
        updateDisplayedPageNumber,
        mergeRheses,
        pageMetadata,
        pressingControl,
        saveSelection,
        splitRhese
    ]);
    const pageNumber = pageMetadata.page.data.pageNumber.pageNumber;
    const rheses = pageMetadata.rhese;
    const currentRheses = (0, $jMaZ8.useRef)(rheses);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        // Buttons resolve current anchors without rerendering when book offsets shift.
        currentRheses.current = rheses;
    }, [
        rheses
    ]);
    const editRheseById = (0, $jMaZ8.useCallback)((id)=>{
        if (pageNumber !== parseInt(new URLSearchParams(window.location.search).get("displayedPageNumber") || "")) updateDisplayedPageNumber(pageNumber.toString());
        setRheseToEdit(currentRheses.current.find((rhese)=>rhese.data.id === id));
    }, [
        pageNumber,
        updateDisplayedPageNumber
    ]);
    const renderRheseWrapper = (0, $jMaZ8.useCallback)((rhese, renderedRhese)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
            className: $2a7535a2ddfb4c89$export$f59a34a515108e87,
            children: [
                renderedRhese,
                canEditProjectContent(rhese) && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($fb5003559adbbfb5$var$RheseEditButton, {
                    rheseId: rhese.id,
                    label: translation.edit,
                    onEdit: editRheseById
                })
            ]
        }), [
        canEditProjectContent,
        translation.edit,
        editRheseById
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            rheseToEdit && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d76877bf3de2dd32$export$2e2bcd8739ae039), {
                editRhese: replaceRhese,
                onOk: ()=>setRheseToEdit(undefined),
                onCancel: ()=>setRheseToEdit(undefined),
                rhese: rheseToEdit,
                pageMetadata: pageMetadata,
                open: !!rheseToEdit,
                projectId: projectId
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
                trigger: pressingControl ? [] : [
                    "contextMenu"
                ],
                dropdownRender: renderDropdownContent,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    ref: contentEditableRef,
                    contentEditable: "true",
                    suppressContentEditableWarning: true,
                    onContextMenu: saveSelection,
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(RenderBook, {
                        rheseWrapper: renderRheseWrapper,
                        rheseOffset: pageMetadata.nbOfRheses * 10,
                        highlightSpaces: pressingControl,
                        projectId: projectId,
                        children: pageMetadata
                    })
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8510a1073180dcbc$export$8ca4588a3a9b81e9), {
                root: contentEditableRef,
                revision: pageMetadata
            })
        ]
    });
}
function $fb5003559adbbfb5$export$9daac14717550217({ allPages: allPages, projectId: projectId }) {
    const pageProps = {
        projectId: projectId,
        allPages: allPages
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039).Content, {
            className: $2a7535a2ddfb4c89$export$e8e78c978b129247,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5397f42de219fe1e$export$9e9dcf6268a0a1fc), {
                component: $fb5003559adbbfb5$var$RhesesRenderer,
                // onVisibilityChange={onVisibilityChange}
                // @ts-ignore
                props: pageProps,
                children: allPages
            })
        })
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");




const $00a275f0e01c6c26$var$RadioButton = (0, $41c1392b19ea6316$export$2e2bcd8739ae039).Button;
function $00a275f0e01c6c26$export$2e2bcd8739ae039({ componentProps: componentProps, pages: pages, projectId: projectId }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.existing.index.syllableComponent";
    const [mode, setMode] = (0, $jMaZ8.useState)("syllables");
    const pageProps = {
        ...componentProps,
        mode: mode,
        projectId: projectId
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: "12em",
                    left: "8em",
                    zIndex: 999
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $41c1392b19ea6316$export$2e2bcd8739ae039).Group, {
                    className: "clorationMode",
                    value: mode,
                    onChange: (e)=>setMode(e.target.value),
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($00a275f0e01c6c26$var$RadioButton, {
                            value: "syllables",
                            children: t(`${i18nKey}.syllables`)
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($00a275f0e01c6c26$var$RadioButton, {
                            value: "phonemes",
                            children: t(`${i18nKey}.phonemes`)
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($00a275f0e01c6c26$var$RadioButton, {
                            value: "custom",
                            children: t(`${i18nKey}.custom`)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5397f42de219fe1e$export$9e9dcf6268a0a1fc), {
                component: (0, $b9c8707a3d5ef653$export$2e2bcd8739ae039),
                props: pageProps,
                children: pages
            })
        ]
    });
}



function $0eba25cd82c101bd$export$6fcda684b3097527({ allPages: allPages, project: project }) {
    const projectId = project.id;
    const stringVersion = allPages[0]?.stringVersion;
    const [applyCreateSyllableFromPosition] = (0, $2cbc1e4bffc4bf21$export$7cab5666971b1572)();
    const [applyDeleteSyllableFromPosition] = (0, $2cbc1e4bffc4bf21$export$c6f584713ec549a2)();
    const [applySetMutedFromPosition] = (0, $b7be8974895307ad$export$c01896a7be4e05e6)();
    const [applyUnsetMuteFromPosition] = (0, $b7be8974895307ad$export$26d1265de1014c07)();
    const [applySetPhonemeFromPosition] = (0, $5ca13b1bb5133f96$export$aab3867090efe064)();
    const [applyUnsetPhonemeFromPosition] = (0, $5ca13b1bb5133f96$export$138d955481de2f64)();
    const [applyCreateColorationFromPosition] = (0, $96e5d4252dd15814$export$7f84d260e59d12c)();
    const [applyDeleteColorationFromPosition] = (0, $96e5d4252dd15814$export$c9aaf87a298c13ed)();
    const removePhoneme = (0, $jMaZ8.useCallback)((selectedTextPosition)=>applyUnsetPhonemeFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion
            }
        }), [
        applyUnsetPhonemeFromPosition,
        projectId,
        stringVersion
    ]);
    const assignPhoneme = (0, $jMaZ8.useCallback)((selectedTextPosition, phoneme)=>applySetPhonemeFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion,
                kind: phoneme
            }
        }), [
        applySetPhonemeFromPosition,
        projectId,
        stringVersion
    ]);
    const removeCustomColor = (0, $jMaZ8.useCallback)((selectedTextPosition)=>applyDeleteColorationFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion
            }
        }), [
        applyDeleteColorationFromPosition,
        projectId,
        stringVersion
    ]);
    const assignCustomColor = (0, $jMaZ8.useCallback)((selectedTextPosition, coloration)=>applyCreateColorationFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion,
                newColoration: coloration
            }
        }), [
        applyCreateColorationFromPosition,
        projectId,
        stringVersion
    ]);
    const removeSyllable = (0, $jMaZ8.useCallback)(async (selectedTextPosition)=>{
        await applyDeleteSyllableFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion
            }
        });
    }, [
        applyDeleteSyllableFromPosition,
        projectId,
        stringVersion
    ]);
    const mergeSyllables = (0, $jMaZ8.useCallback)(async (selectedTextPosition)=>{
        await applyCreateSyllableFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion
            }
        });
    }, [
        applyCreateSyllableFromPosition,
        projectId,
        stringVersion
    ]);
    const muteLetters = (0, $jMaZ8.useCallback)((selectedTextPosition)=>{
        applySetMutedFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion
            }
        });
    }, [
        applySetMutedFromPosition,
        projectId,
        stringVersion
    ]);
    const unmuteLetters = (0, $jMaZ8.useCallback)((selectedTextPosition)=>{
        applyUnsetMuteFromPosition({
            variables: {
                projectId: projectId,
                size: selectedTextPosition.size,
                start: selectedTextPosition.start,
                stringVersion: stringVersion
            }
        });
    }, [
        applyUnsetMuteFromPosition,
        projectId,
        stringVersion
    ]);
    const customColors = Object.entries(project.customColorationConfig || {}).map(([key, value])=>({
            key: key,
            ...JSON.parse(value)
        }));
    const componentProps = {
        removeSyllable: removeSyllable,
        merge: mergeSyllables,
        mute: muteLetters,
        unmute: unmuteLetters,
        removePhoneme: removePhoneme,
        assignPhoneme: assignPhoneme,
        customColors: customColors,
        removeCustomColor: removeCustomColor,
        assignCustomColor: assignCustomColor,
        projectId: projectId,
        allPages: allPages
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $00a275f0e01c6c26$export$2e2bcd8739ae039), {
        componentProps: componentProps,
        pages: allPages,
        projectId: projectId
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

var $6UWRi = parcelRequire("6UWRi");


var $4eba5171ee8e84ca$export$3dea766d36a8935f;
var $4eba5171ee8e84ca$export$5410109d39b7da80;
var $4eba5171ee8e84ca$export$96e4b36520c26a2c;
var $4eba5171ee8e84ca$export$e8e78c978b129247;
var $4eba5171ee8e84ca$export$4cf852c2fa054f5c;
var $4eba5171ee8e84ca$export$31eb53bd5b582a97;
var $4eba5171ee8e84ca$export$852111b71425329;
$4eba5171ee8e84ca$export$3dea766d36a8935f = "filter_f19d45";
$4eba5171ee8e84ca$export$5410109d39b7da80 = "selectedFilter_f19d45";
$4eba5171ee8e84ca$export$96e4b36520c26a2c = "modal_f19d45";
$4eba5171ee8e84ca$export$e8e78c978b129247 = "root_f19d45";
$4eba5171ee8e84ca$export$4cf852c2fa054f5c = "definitionActions_f19d45";
$4eba5171ee8e84ca$export$31eb53bd5b582a97 = "action_f19d45";
$4eba5171ee8e84ca$export$852111b71425329 = "radioWrapper_f19d45";









const $76db2ecb3c5913bc$var$RadioButton = (0, $41c1392b19ea6316$export$2e2bcd8739ae039).Button;
const $76db2ecb3c5913bc$var$RenderBook = (0, $d0ce5078a897d2dc$export$2e2bcd8739ae039)();
const $76db2ecb3c5913bc$export$dfa24e52e7d45163 = (selectedDefinition, hasMultipleDefinitions, deleteDefinition, updateSelectedDefinition, translation, setModalMode)=>{
    const items = [];
    if (selectedDefinition) {
        items.push((0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "modifies",
            label: translation.modifies,
            onClick: ()=>{
                updateSelectedDefinition(selectedDefinition);
                setModalMode("update");
            }
        }));
        items.push((0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
            key: "dissociate",
            label: translation.dissociate,
            onClick: ()=>{
                deleteDefinition(selectedDefinition.insertOrder);
            },
            danger: true
        }));
    }
    if (!selectedDefinition) items.push((0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
        key: "add",
        label: translation.add,
        onClick: ()=>{
            setModalMode("create");
        },
        disabled: hasMultipleDefinitions
    }));
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
        items: items
    });
};
const $76db2ecb3c5913bc$export$21ffdb4df27b2bee = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo((props)=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($76db2ecb3c5913bc$export$7c6e2c02157bb7d2, {
        ...props
    });
});
const $76db2ecb3c5913bc$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(({ deleteDefinition: deleteDefinition, updateSelectedDefinition: updateSelectedDefinition, translation: translation, setModalMode: setModalMode, projectId: projectId, modalMode: modalMode, selectedDefinition: selectedDefinitionProp, updateDefinition: updateDefinition, createDefinition: createDefinition, reset: reset })=>{
    // @ts-ignore
    const { extendedPage: pageMetadata } = (0, $f9ad6d9d9a78d084$export$9c25024bdfe755f7)();
    const isContentAdmin = (0, $dc10a25720c6edc8$export$1b39bc9d16fffc4d)();
    const isEditor = (0, $dc10a25720c6edc8$export$5fe256569ad95d29)();
    const contentEditableRef = (0, $jMaZ8.useRef)(null);
    const [definitionKindFilter, setDefinitionKindFilter] = (0, $jMaZ8.useState)("ALL");
    const [selectedDefinition, setSelectedDefinition] = (0, $jMaZ8.useState)(null);
    const [selectionHasMultipleDefinitions, setSelectionHasMultipleDefinitions] = (0, $jMaZ8.useState)(false);
    const { selectedTextPosition: selectedTextPosition, saveSelection: saveSelection, reset: resetSelection } = (0, $b475e6138875e356$export$6b1e75a5561fc59c)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.existing.editingMode.definition.content";
    // Check if this page owns the currently selected definition
    const thisPageOwnsDefinition = (0, $jMaZ8.useMemo)(()=>{
        if (modalMode !== "update" || !selectedDefinitionProp) return false;
        return pageMetadata?.definition?.some((d)=>d.data.id === selectedDefinitionProp.id);
    }, [
        modalMode,
        selectedDefinitionProp,
        pageMetadata
    ]);
    // Check if this page has an active text selection for create mode
    const thisPageHasSelection = (0, $jMaZ8.useMemo)(()=>{
        if (modalMode !== "create") return false;
        return selectedTextPosition.size > 0;
    }, [
        modalMode,
        selectedTextPosition.size
    ]);
    const objectTranslationDefinitionModal = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.definition.definitionModal");
    const validateDefinition = (0, $jMaZ8.useCallback)((value, kind, imageName)=>{
        if (modalMode === "update" && selectedDefinitionProp) {
            const found = pageMetadata.definition.find((d)=>d.data.id === selectedDefinitionProp.id);
            if (found) updateDefinition(found, kind, value, imageName);
        } else if (selectedTextPosition.size > 0) createDefinition(selectedTextPosition.start, selectedTextPosition.size, kind, value, imageName);
        reset();
    }, [
        modalMode,
        selectedDefinitionProp,
        pageMetadata,
        updateDefinition,
        createDefinition,
        selectedTextPosition,
        reset
    ]);
    // Render modal via portal when this page owns the definition being edited OR has selection for create
    const modalPortal = (0, $jMaZ8.useMemo)(()=>{
        if (!pageMetadata) return null;
        const selection = pageMetadata.textContent.substring(selectedTextPosition.start - pageMetadata.page.anchors[0].utf16Start, selectedTextPosition.start - pageMetadata.page.anchors[0].utf16Start + selectedTextPosition.size);
        if (modalMode === "update" && thisPageOwnsDefinition && selectedDefinitionProp) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6UWRi))).createPortal(/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($76db2ecb3c5913bc$export$60094acc87b5934c, {
            mode: "update",
            selection: selection,
            onCancel: reset,
            onValidate: validateDefinition,
            loadedDefinition: selectedDefinitionProp.definition || "",
            loadedDefinitionImageName: selectedDefinitionProp.imageName || "",
            loadedDefinitionKind: selectedDefinitionProp.kind,
            translation: objectTranslationDefinitionModal
        }), document.body);
        if (modalMode === "create" && thisPageHasSelection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6UWRi))).createPortal(/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($76db2ecb3c5913bc$export$60094acc87b5934c, {
            mode: "create",
            selection: selection,
            onCancel: reset,
            onValidate: validateDefinition,
            translation: objectTranslationDefinitionModal
        }), document.body);
        return null;
    }, [
        modalMode,
        thisPageOwnsDefinition,
        thisPageHasSelection,
        pageMetadata,
        selectedTextPosition,
        selectedDefinitionProp,
        reset,
        updateDefinition,
        createDefinition,
        objectTranslationDefinitionModal,
        validateDefinition
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        const noop = (e)=>{
            e.preventDefault();
            return false;
        };
        const ref = contentEditableRef.current;
        ref?.addEventListener("cut", noop, false);
        ref?.addEventListener("paste", noop, false);
        ref?.addEventListener("keydown", noop, false);
        ref?.addEventListener("dragenter", noop, false);
        ref?.addEventListener("dragleave", noop, false);
        ref?.addEventListener("dragover", noop, false);
        ref?.addEventListener("drop", noop, false);
        return ()=>{
            ref?.removeEventListener("cut", noop);
            ref?.removeEventListener("paste", noop);
            ref?.removeEventListener("keydown", noop);
            ref?.removeEventListener("dragenter", noop);
            ref?.removeEventListener("dragleave", noop);
            ref?.removeEventListener("dragover", noop);
            ref?.removeEventListener("drop", noop);
        };
    }, [
        contentEditableRef
    ]);
    const renderDropdownContent = (0, $jMaZ8.useCallback)(()=>$76db2ecb3c5913bc$export$dfa24e52e7d45163(selectedDefinition, selectionHasMultipleDefinitions, deleteDefinition, updateSelectedDefinition, translation, setModalMode), [
        selectedDefinition,
        selectionHasMultipleDefinitions,
        deleteDefinition,
        updateSelectedDefinition,
        translation,
        setModalMode
    ]);
    // Save selection on mouse up and reset selection on mouse down
    const { onMouseUp: onMouseUp, onMouseDown: onMouseDown } = (0, $jMaZ8.useMemo)(()=>{
        return {
            onMouseUp: saveSelection,
            onMouseDown: (e)=>{
                e.button === 0 && resetSelection();
            }
        };
    }, [
        saveSelection,
        resetSelection
    ]);
    // Update selectedDefinition when selectedTextPosition changes
    (0, $jMaZ8.useEffect)(()=>{
        if (selectedTextPosition.size > 0) {
            // Use selectedTextPosition to find the selected definitions
            const selectedDefinitions = pageMetadata.definition.filter((definition)=>definition.anchors[0].utf16Start >= selectedTextPosition.start && definition.anchors[0].utf16Start + definition.anchors[0].utf16Size <= selectedTextPosition.start + selectedTextPosition.size);
            const multipleDefinitions = selectedDefinitions.length > 1;
            setSelectionHasMultipleDefinitions(multipleDefinitions);
            if (multipleDefinitions) return setSelectedDefinition(null);
            if (selectedDefinitions.length === 1) return setSelectedDefinition({
                id: selectedDefinitions[0].data.id,
                definition: selectedDefinitions[0].data.description,
                kind: selectedDefinitions[0].data.kind,
                imageName: selectedDefinitions[0].data.imageName,
                insertOrder: selectedDefinitions[0].anchors[0].insertOrder
            });
        }
        setSelectionHasMultipleDefinitions(false);
        setSelectedDefinition(null);
    }, [
        pageMetadata,
        selectedTextPosition
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $jMaZ8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
                trigger: [
                    "contextMenu"
                ],
                dropdownRender: renderDropdownContent,
                disabled: !(isContentAdmin || isEditor),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    className: definitionKindFilter.toLowerCase(),
                    ref: contentEditableRef,
                    contentEditable: "true",
                    suppressContentEditableWarning: true,
                    onMouseUp: onMouseUp,
                    onMouseDown: onMouseDown,
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($76db2ecb3c5913bc$var$RenderBook, {
                        projectId: projectId,
                        children: pageMetadata
                    })
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                style: {
                    position: "absolute",
                    top: "20%",
                    right: 0,
                    padding: 0,
                    width: "15vw"
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "1em",
                        position: "relative",
                        alignItems: "end"
                    },
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            onClick: ()=>setDefinitionKindFilter("ALL"),
                            className: $4eba5171ee8e84ca$export$3dea766d36a8935f.concat(" ", definitionKindFilter === "ALL" && $4eba5171ee8e84ca$export$5410109d39b7da80 || ""),
                            children: t(`${i18nKey}.all`)
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            onClick: ()=>setDefinitionKindFilter((0, $b522cf181e75e62d$export$2b5d0c623adb8e14).EXPLICIT),
                            className: $4eba5171ee8e84ca$export$3dea766d36a8935f.concat(" ", definitionKindFilter === (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).EXPLICIT && $4eba5171ee8e84ca$export$5410109d39b7da80 || ""),
                            children: t(`${i18nKey}.explicit`)
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            onClick: ()=>setDefinitionKindFilter((0, $b522cf181e75e62d$export$2b5d0c623adb8e14).IMPLICIT),
                            className: $4eba5171ee8e84ca$export$3dea766d36a8935f.concat(" ", definitionKindFilter === (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).IMPLICIT && $4eba5171ee8e84ca$export$5410109d39b7da80 || ""),
                            children: t(`${i18nKey}.implicit`)
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            onClick: ()=>setDefinitionKindFilter((0, $b522cf181e75e62d$export$2b5d0c623adb8e14).NDBP),
                            className: $4eba5171ee8e84ca$export$3dea766d36a8935f.concat(" ", definitionKindFilter === (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).NDBP && $4eba5171ee8e84ca$export$5410109d39b7da80 || ""),
                            children: t(`${i18nKey}.foot_note`)
                        })
                    ]
                })
            }),
            modalPortal
        ]
    });
});
const $76db2ecb3c5913bc$export$60094acc87b5934c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function({ onValidate: onValidate, onCancel: onCancel, selection: selection, loadedDefinition: loadedDefinition, loadedDefinitionKind: loadedDefinitionKind, loadedDefinitionImageName: loadedDefinitionImageName, mode: mode, translation: translation }) {
    const [definition, setDefinition] = (0, $jMaZ8.useState)(loadedDefinition || "");
    const [imageName, setImageName] = (0, $jMaZ8.useState)(loadedDefinitionImageName || "");
    const [definitionKind, setDefinitionKind] = (0, $jMaZ8.useState)(loadedDefinitionKind || $76db2ecb3c5913bc$var$DEFAULT_DEFINITION_KIND);
    const radioGroupRef = (0, $jMaZ8.useRef)(null);
    (0, $jMaZ8.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            if (radioGroupRef.current) radioGroupRef.current.focus();
        }, 100);
        return ()=>clearTimeout(timeout);
    }, []);
    const handleDefinition = (0, $jMaZ8.useCallback)((e)=>setDefinition(e.target.value), []);
    const handleImageName = (0, $jMaZ8.useCallback)((e)=>setImageName(e.target.value), []);
    const title = selection;
    const message = (0, $jMaZ8.useMemo)(()=>{
        // if (mode === "assign") {
        //   return translation.message.assign;
        // }
        if (mode === "update") return translation.message.update;
        return translation.message.create;
    }, [
        mode,
        translation
    ]);
    const labelStyle = {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flex: 1,
        fontSize: "1em",
        fontWeight: "normal"
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        centered: true,
        width: "56.66em",
        title: title,
        className: $4eba5171ee8e84ca$export$96e4b36520c26a2c,
        open: true,
        onCancel: onCancel,
        footer: null,
        getContainer: ()=>document.body,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                ref: radioGroupRef,
                tabIndex: 0,
                onKeyDown: (e)=>{
                    e.key;
                },
                className: $4eba5171ee8e84ca$export$852111b71425329,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $41c1392b19ea6316$export$2e2bcd8739ae039).Group, {
                    // disabled={mode === "assign"}
                    style: {
                        display: "flex",
                        fontSize: "1.25em"
                    },
                    value: definitionKind,
                    onChange: (e)=>setDefinitionKind(e.target.value),
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($76db2ecb3c5913bc$var$RadioButton, {
                            style: labelStyle,
                            value: (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).EXPLICIT,
                            children: translation.radioButton.explicit
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($76db2ecb3c5913bc$var$RadioButton, {
                            style: labelStyle,
                            value: (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).IMPLICIT,
                            children: translation.radioButton.implicit
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($76db2ecb3c5913bc$var$RadioButton, {
                            style: labelStyle,
                            value: (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).NDBP,
                            children: translation.radioButton.foot_note
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039).TextArea, {
                // disabled={mode === "assign"}
                placeholder: translation.textArea.placeholder,
                defaultValue: definition,
                onChange: handleDefinition
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                // disabled={mode === "assign"}
                placeholder: translation.imageName.placeholder,
                defaultValue: imageName,
                onChange: handleImageName
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                justify: "center",
                className: $4eba5171ee8e84ca$export$4cf852c2fa054f5c,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    shape: "round",
                    onClick: ()=>onValidate(definition, definitionKind, imageName),
                    style: {
                        color: "#61C374",
                        borderColor: "#61C374"
                    },
                    className: $4eba5171ee8e84ca$export$31eb53bd5b582a97,
                    children: message
                })
            })
        ]
    });
});
const $76db2ecb3c5913bc$var$DEFAULT_DEFINITION_KIND = (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).EXPLICIT;
var $76db2ecb3c5913bc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(function Definition({ pages: pages, projectId: projectId, createDefinition: remoteCreateDefinition, updateDefinition: updateDefinition, deleteDefinition: deleteDefinition }) {
    const [modalMode, setModalMode] = (0, $jMaZ8.useState)(null);
    const [selectedDefinition, setSelectedDefinition] = (0, $jMaZ8.useState)(null);
    const reset = (0, $jMaZ8.useCallback)(()=>{
        setSelectedDefinition(null);
        setModalMode(null);
    }, []);
    const objectTranslationMenu = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.definition.buildDefinitionMenu");
    const props = (0, $jMaZ8.useMemo)(()=>({
            dissociateFromDefinition: deleteDefinition,
            updateSelectedDefinition: setSelectedDefinition,
            translation: objectTranslationMenu,
            setModalMode: setModalMode,
            projectId: projectId,
            deleteDefinition: deleteDefinition,
            modalMode: modalMode,
            selectedDefinition: selectedDefinition,
            updateDefinition: updateDefinition,
            createDefinition: remoteCreateDefinition,
            reset: reset
        }), [
        deleteDefinition,
        objectTranslationMenu,
        projectId,
        modalMode,
        selectedDefinition,
        updateDefinition,
        remoteCreateDefinition,
        reset
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039).Content, {
            className: $4eba5171ee8e84ca$export$e8e78c978b129247,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5397f42de219fe1e$export$9e9dcf6268a0a1fc), {
                component: $76db2ecb3c5913bc$export$21ffdb4df27b2bee,
                props: props,
                children: pages
            })
        })
    });
});





function $73056f7e41feae93$export$2e2bcd8739ae039({ allPages: allPages, projectId: projectId }) {
    const { project: project } = (0, $5b38bec19e3a4e47$export$8f31c2503e1efa93)();
    const [applyCreateDefinition] = (0, $9fbd80a2d225d843$export$5769bc41ec22ace9)();
    const [applyUpdateDefinition] = (0, $9fbd80a2d225d843$export$1df4105d6bb9fdbe)();
    const [applyDeleteDefinition] = (0, $9fbd80a2d225d843$export$43806d2937c65c73)();
    const createDefinition = (0, $jMaZ8.useCallback)((start, size, kind, definition, imageName)=>{
        applyCreateDefinition({
            variables: {
                kind: kind,
                description: definition,
                projectId: projectId,
                start: start,
                size: size,
                stringVersion: project.stringVersion,
                imageName: imageName
            }
        });
    }, [
        applyCreateDefinition,
        projectId,
        project.stringVersion
    ]);
    const updateDefinition = (0, $jMaZ8.useCallback)((definition, kind, description, imageName)=>{
        applyUpdateDefinition({
            variables: {
                projectId: projectId,
                definitionId: definition.data.id,
                kind: kind,
                description: description,
                imageName: imageName,
                audioFile: definition.data.audioFile,
                audioReviewComment: definition.data.audioReviewComment || "",
                audioReviewStatus: definition.data.audioReviewStatus || (0, $b522cf181e75e62d$export$221b784fada1dd4a).VALID
            }
        });
    }, [
        applyUpdateDefinition,
        projectId
    ]);
    const deleteDefinitionMemoized = (0, $jMaZ8.useCallback)((insertOrder)=>applyDeleteDefinition({
            variables: {
                stringVersion: project.stringVersion,
                projectId: projectId,
                insertOrder: insertOrder
            }
        }), [
        applyDeleteDefinition,
        project.stringVersion,
        projectId
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $76db2ecb3c5913bc$export$2e2bcd8739ae039), {
        projectId: projectId,
        createDefinition: createDefinition,
        updateDefinition: updateDefinition,
        deleteDefinition: deleteDefinitionMemoized,
        pages: allPages
    });
}


const $46106f6fa4537524$export$d370f4b3e279b438 = {
    base: "/editor/*",
    bookBase: "/editor/books/edit/:bookId/*",
    format: "/editor/books/edit/:bookId/format/*",
    syllable: "/editor/books/edit/:bookId/syllable/*",
    rhese: "/editor/books/edit/:bookId/rhese/*",
    narration: "/editor/books/edit/:bookId/narration/*",
    definition: "/editor/books/edit/:bookId/definition/*",
    overview: (bookId)=>`/editor/books/edit/${bookId}/overview`
};





var $jMaZ8 = parcelRequire("jMaZ8");




parcelRequire("jMaZ8");
const $cf82b825f0a6453e$var$SvgGoTo = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: ".95em",
        viewBox: "0 0 6.718 6.38",
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("g", {
            "data-name": "Icn / GoTo",
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                "data-name": "Trac\\xE9 409",
                d: "M6.545 1.994 4.633.158a.564.564 0 1 0-.782.814l.975.937C.596 2.296.012 5.697.006 5.733a.563.563 0 0 0 .468.641.554.554 0 0 0 .09.007.566.566 0 0 0 .557-.473A3.777 3.777 0 0 1 4.65 3.063l-.8.767a.564.564 0 0 0 .782.813l1.912-1.836a.565.565 0 0 0 0-.814Z"
            })
        })
    });
var $cf82b825f0a6453e$export$2e2bcd8739ae039 = $cf82b825f0a6453e$var$SvgGoTo;



parcelRequire("jMaZ8");
const $5ea60811ae202b3d$var$SvgBook = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        "data-name": "Icn/Naviguer",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: ".99em",
        viewBox: "0 0 12 11.36",
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            "data-name": "Trac\\xE9 365",
            d: "M6.536 11.363H5.471a7.929 7.929 0 0 0-.277-.767 1.594 1.594 0 0 0-1.526-.955c-1-.009-2 0-3.005 0H.001V.023h.955c.694 0 1.389.028 2.08-.007A3.455 3.455 0 0 1 6.01 1.157C6.952-.027 8.244-.021 9.554.018c.8.024 1.608 0 2.447 0v9.618H8.836c-1.47-.001-1.856.283-2.3 1.727Zm-1.141-2.43c0-2.075.022-4.039-.012-6a1.466 1.466 0 0 0-1.112-1.528 24.219 24.219 0 0 0-3.069-.188v7.12c1.393.198 2.83-.289 4.192.593Zm5.4-.6V1.321a1.379 1.379 0 0 0-.256-.058c-.674-.006-1.348-.018-2.022-.007a1.774 1.774 0 0 0-1.922 1.956c-.005 1.734 0 3.468 0 5.2 0 .142.018.284.032.493 1.335-.855 2.771-.372 4.172-.572Z",
            fill: "#fff"
        })
    });
var $5ea60811ae202b3d$export$2e2bcd8739ae039 = $5ea60811ae202b3d$var$SvgBook;


function $2981c9ae42b3c89b$export$2e2bcd8739ae039({ totalPageNumber: totalPageNumber }) {
    const { requestPage: requestPage } = (0, $e7692b166c91b9dc$export$fcd3a1f8b6eba71f)();
    const currentPage = (0, $e7692b166c91b9dc$export$6faff8ed5e305ed3)();
    const [pageNumber, setPageNumber] = (0, $jMaZ8.useState)(currentPage);
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.existing.index.goToPage";
    const [isOpen, setIsOpen] = (0, $jMaZ8.useState)(false);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c5aa6d63acebb2d0$export$2e2bcd8739ae039), {
        trigger: "hover",
        open: isOpen,
        onOpenChange: (open)=>{
            if (open) setPageNumber(currentPage);
            setIsOpen(open);
        },
        placement: "bottom",
        className: $57c9cb049f914779$export$2030325fa3271ef7,
        title: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
            style: {
                fontSize: "1.2em",
                padding: "0.6em 1.2em",
                textAlign: "center"
            },
            children: t(`${i18nKey}.nav`)
        }),
        content: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            className: $57c9cb049f914779$export$62f7b0332d17833f,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ae109c92c4bd559f$export$2e2bcd8739ae039), {
                    "aria-label": t(`${i18nKey}.nav`),
                    size: "middle",
                    value: pageNumber,
                    onChange: (value)=>setPageNumber(value === null ? null : Number(value))
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                    className: $57c9cb049f914779$export$c9eb802655067bbc,
                    children: [
                        "/ ",
                        totalPageNumber
                    ]
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        if (pageNumber !== null) requestPage(pageNumber);
                    },
                    children: [
                        t(`${i18nKey}.validation`),
                        " ",
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $cf82b825f0a6453e$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
            "aria-label": t(`${i18nKey}.nav`),
            className: $57c9cb049f914779$export$73acc798a0ce22c5,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5ea60811ae202b3d$export$2e2bcd8739ae039), {})
        })
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");

var $99168dc4b045ed3a$export$e8e78c978b129247;
var $99168dc4b045ed3a$export$8db427562d9df161;
var $99168dc4b045ed3a$export$adcaeedbcaef61ad;
var $99168dc4b045ed3a$export$56a7b65538036bea;
var $99168dc4b045ed3a$export$b481748e0e5d3cfc;
var $99168dc4b045ed3a$export$9180e26504a27e9d;
var $99168dc4b045ed3a$export$5c452ff88e35e47d;
var $99168dc4b045ed3a$export$eabcd2c8791e7bf4;
var $99168dc4b045ed3a$export$3481c78889e8fbe8;
var $99168dc4b045ed3a$export$79ffe56a765070d2;
var $99168dc4b045ed3a$export$1822828d790e23ee;
var $99168dc4b045ed3a$export$60053a0c71e173be;
var $99168dc4b045ed3a$export$f1d985ef2ac6d781;
var $99168dc4b045ed3a$export$ab565c6e2fc23106;
$99168dc4b045ed3a$export$e8e78c978b129247 = "root_a2a3cc";
$99168dc4b045ed3a$export$8db427562d9df161 = "lettersCount_a2a3cc";
$99168dc4b045ed3a$export$adcaeedbcaef61ad = "segmentationInfo_a2a3cc";
$99168dc4b045ed3a$export$56a7b65538036bea = "side_a2a3cc";
$99168dc4b045ed3a$export$b481748e0e5d3cfc = "sideMenu_a2a3cc";
$99168dc4b045ed3a$export$9180e26504a27e9d = "dropZone_a2a3cc";
$99168dc4b045ed3a$export$5c452ff88e35e47d = "image_a2a3cc";
$99168dc4b045ed3a$export$eabcd2c8791e7bf4 = "left_a2a3cc";
$99168dc4b045ed3a$export$3481c78889e8fbe8 = "center_a2a3cc";
$99168dc4b045ed3a$export$79ffe56a765070d2 = "right_a2a3cc";
$99168dc4b045ed3a$export$1822828d790e23ee = "delete_a2a3cc";
$99168dc4b045ed3a$export$60053a0c71e173be = "dialogueWrapper_a2a3cc";
$99168dc4b045ed3a$export$f1d985ef2ac6d781 = "dialogue_a2a3cc";
$99168dc4b045ed3a$export$ab565c6e2fc23106 = "dialogueButton_a2a3cc";






parcelRequire("jMaZ8");



parcelRequire("jMaZ8");
const $f613cfd7d2a10a5e$var$SvgImg = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.23em",
        height: "1em",
        viewBox: "0 0 16 13",
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M50 770a1.982 1.982 0 0 0-.041-.4 2.04 2.04 0 0 0-.11-.356c-.014-.032-.032-.062-.047-.093a1.992 1.992 0 0 0-.126-.232c-.022-.034-.047-.065-.071-.1a2.176 2.176 0 0 0-.156-.189 2.5 2.5 0 0 0-.09-.088 2.1 2.1 0 0 0-.186-.153l-.1-.073a2.213 2.213 0 0 0-.215-.117c-.037-.017-.074-.037-.112-.052a1.962 1.962 0 0 0-.254-.079c-.035-.009-.069-.021-.1-.028A2 2 0 0 0 48 768H36a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 1.955-1.585A2.028 2.028 0 0 0 50 779Zm-3.5 2a1 1 0 1 1-1-1 1 1 0 0 1 1 1ZM36 780a1 1 0 0 1-1-1v-2.706l2.815-2.649a1 1 0 0 1 1.371 0l2.877 2.708.752-.708a1 1 0 0 1 1.371 0l4.4 4.143A.98.98 0 0 1 48 780Z",
            transform: "translate(-34 -768)",
            style: {
                fill: "#575b72"
            }
        })
    });
var $f613cfd7d2a10a5e$export$2e2bcd8739ae039 = $f613cfd7d2a10a5e$var$SvgImg;



// eslint-disable-next-line react/display-name
const $5d51cea93389c70b$var$SideMenu = ({ handleLettersKindAssignation: handleLettersKindAssignation, setIsDraggingImage: setIsDraggingImage, handleImageCreation: handleImageCreation, isDraggingImage: isDraggingImage, sideMenuClassName: sideMenuClassName, targetParagraph: targetParagraph })=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: sideMenuClassName,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("menu", {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            placement: "left",
                            title: "Gras",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                onClick: ()=>handleLettersKindAssignation((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).GRAS),
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("b", {
                                    children: "B"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            placement: "left",
                            title: "Italique",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                onClick: ()=>handleLettersKindAssignation((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).ITALIQUE),
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("i", {
                                    children: "I"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            placement: "left",
                            title: "Majuscule",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                onClick: ()=>handleLettersKindAssignation((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MAJUSCULE),
                                children: "TT"
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            placement: "left",
                            title: "Minuscule",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                onClick: ()=>handleLettersKindAssignation((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MINUSCULE),
                                children: "tt"
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            placement: "left",
                            title: "Exposant",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                onClick: ()=>handleLettersKindAssignation((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).EXPOSANT),
                                children: [
                                    "T",
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("sup", {
                                        children: "1"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            placement: "left",
                            title: "Indice",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                onClick: ()=>handleLettersKindAssignation((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).INDICE),
                                children: [
                                    "T",
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("sub", {
                                        children: "1"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            placement: "left",
                            title: "Citation",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                onClick: ()=>handleLettersKindAssignation((0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).CITATION),
                                children: "\u275D\u275E"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: sideMenuClassName,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("menu", {
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                        placement: "left",
                        title: "Ajouter une image",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                            onDragStart: ()=>setIsDraggingImage(true),
                            onDragEnd: ()=>{
                                setIsDraggingImage(false);
                                handleImageCreation();
                            },
                            animate: isDraggingImage ? {
                                opacity: targetParagraph !== null ? 1 : 0.3
                            } : {
                                x: 0,
                                y: 0,
                                opacity: 1
                            },
                            drag: true,
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f613cfd7d2a10a5e$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        ]
    });
};
var $5d51cea93389c70b$export$2e2bcd8739ae039 = $5d51cea93389c70b$var$SideMenu;






var $jMaZ8 = parcelRequire("jMaZ8");






var $jMaZ8 = parcelRequire("jMaZ8");


parcelRequire("jMaZ8");






const $e526ff45238c9126$var$imageKindToString = (kind)=>{
    if (kind === (0, $b522cf181e75e62d$export$b890e9c15247e0b3).NORMAL) return "project.existing.editingMode.formatting.default.form.radioButton.normal";
    return "project.existing.editingMode.formatting.default.form.radioButton.popup";
};
const $e526ff45238c9126$var$Image = ({ id: id, fileName: fileName, description: description, kind: kind, position: position, figcaption: figcaption, editImage: editImage, deleteImage: deleteImage })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        onClick: ()=>editImage({
                id: id,
                fileName: fileName,
                description: description,
                kind: kind,
                position: position,
                figcaption: figcaption
            }),
        whileHover: "hover",
        variants: {
            hover: {
                scale: 1.05
            }
        },
        id: id,
        className: $99168dc4b045ed3a$export$5c452ff88e35e47d,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $99168dc4b045ed3a$export$eabcd2c8791e7bf4,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f613cfd7d2a10a5e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        children: t(`${$e526ff45238c9126$var$imageKindToString(kind)}`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $99168dc4b045ed3a$export$3481c78889e8fbe8,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        children: fileName
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        children: figcaption
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $99168dc4b045ed3a$export$79ffe56a765070d2,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $add96a083ff0f53e$export$2e2bcd8739ae039), {
                    className: $99168dc4b045ed3a$export$1822828d790e23ee,
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        deleteImage(id);
                    }
                })
            })
        ]
    });
};
var $e526ff45238c9126$export$2e2bcd8739ae039 = $e526ff45238c9126$var$Image;







const $aa126bb602dd7e3b$var$DropZone = ({ onMouseEnter: onMouseEnter })=>{
    const [isHover, setIsHover] = (0, $jMaZ8.useState)(false);
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.existing.editingMode.formatting";
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        onMouseEnter: ()=>{
            setIsHover(true);
            onMouseEnter();
        },
        onMouseLeave: ()=>setIsHover(false),
        className: $99168dc4b045ed3a$export$9180e26504a27e9d,
        layout: true,
        style: {
            width: "100%",
            height: isHover ? "5em" : "0"
        },
        animate: isHover ? "hover" : "initial",
        initial: "initial",
        transition: {
            bounce: 0
        },
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
            variants: {
                hover: {
                    opacity: "1"
                }
            },
            initial: {
                opacity: "0"
            },
            transition: {
                bounce: 0
            },
            children: t(`${i18nKey}.dropZone`)
        })
    });
};
const $aa126bb602dd7e3b$var$DialogueWrapper = ({ children: children, openDialoguePictureModal: openDialoguePictureModal, hasSpeaker: hasSpeaker })=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        whileHover: "hover",
        className: $99168dc4b045ed3a$export$60053a0c71e173be,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                animate: hasSpeaker ? "hover" : undefined,
                className: $99168dc4b045ed3a$export$f1d985ef2ac6d781,
                variants: {
                    hover: {
                        opacity: 1
                    }
                },
                initial: {
                    opacity: 0
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    onClickCapture: openDialoguePictureModal,
                    className: $99168dc4b045ed3a$export$ab565c6e2fc23106,
                    shape: "circle",
                    icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f613cfd7d2a10a5e$export$2e2bcd8739ae039), {})
                })
            }),
            children
        ]
    });
};
const $aa126bb602dd7e3b$var$ParagraphWrapper = ({ isLastParagraph: isLastParagraph, paragraphId: paragraphId, children: children, isDraggingImage: isDraggingImage, setTargetParagraph: setTargetParagraph, setPosition: setPosition, deleteImage: deleteImage, editImage: editImage, openDialogueSpeakerModal: openDialogueSpeakerModal, paragraphs: paragraphs })=>{
    const paragraph = (0, $jMaZ8.useMemo)(()=>paragraphs.find((p)=>p.data.id === paragraphId), [
        paragraphId,
        paragraphs
    ]);
    if (!paragraph) // We don't want to throw an error because paragraphs and rheses cant be desync for a short amount of time
    return null;
    const isDialogue = paragraph.data.kind === (0, $b522cf181e75e62d$export$e5be9b5f8a520e95).DIALOGUE;
    const imageBefore = paragraph.data.images?.find((i)=>i.position === (0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).BEFORE);
    const imageAfter = paragraph.data.images?.find((i)=>i.position === (0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).AFTER);
    let content;
    if (isDraggingImage) content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        onMouseEnter: ()=>{
            setTargetParagraph(paragraphId);
        },
        onMouseLeave: ()=>{
            setTargetParagraph(null);
        },
        children: [
            !imageBefore && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($aa126bb602dd7e3b$var$DropZone, {
                onMouseEnter: ()=>setPosition((0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).BEFORE)
            }),
            children,
            !imageAfter && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($aa126bb602dd7e3b$var$DropZone, {
                onMouseEnter: ()=>setPosition((0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).AFTER)
            })
        ]
    });
    else content = children;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            imageBefore ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e526ff45238c9126$export$2e2bcd8739ae039), {
                deleteImage: deleteImage,
                editImage: editImage,
                description: imageBefore.description || "",
                id: imageBefore.id,
                position: (0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).BEFORE,
                fileName: imageBefore.fileName,
                kind: imageBefore.kind,
                figcaption: imageBefore.figcaption
            }, imageBefore.id) : null,
            isDialogue ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($aa126bb602dd7e3b$var$DialogueWrapper, {
                hasSpeaker: paragraph.data.speaker?.id !== null,
                openDialoguePictureModal: ()=>openDialogueSpeakerModal({
                        speakerId: paragraph.data.speaker?.id,
                        paragraphId: paragraph.data.id
                    }),
                children: content
            }) : content,
            imageAfter ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e526ff45238c9126$export$2e2bcd8739ae039), {
                deleteImage: deleteImage,
                editImage: editImage,
                description: imageAfter.description || "",
                id: imageAfter.id,
                position: (0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).AFTER,
                fileName: imageAfter.fileName,
                kind: imageAfter.kind,
                figcaption: imageAfter.figcaption
            }, imageAfter.id) : null
        ]
    });
};
var $aa126bb602dd7e3b$export$2e2bcd8739ae039 = $aa126bb602dd7e3b$var$ParagraphWrapper;





var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $a6yuN = parcelRequire("a6yuN");

var $hvG6u = parcelRequire("hvG6u");





"use client";
const { Option: $0411e9f3c4d3691b$var$Option } = (0, $71df08955277779f$export$2e2bcd8739ae039);
function $0411e9f3c4d3691b$var$isSelectOptionOrSelectOptGroup(child) {
    return (child === null || child === void 0 ? void 0 : child.type) && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
const $0411e9f3c4d3691b$var$AutoComplete = (props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, className: className, popupClassName: popupClassName, dropdownClassName: dropdownClassName, children: children, dataSource: dataSource } = props;
    const childNodes = (0, $a6yuN.default)(children);
    // ============================= Input =============================
    let customizeInput;
    if (childNodes.length === 1 && /*#__PURE__*/ $jMaZ8.isValidElement(childNodes[0]) && !$0411e9f3c4d3691b$var$isSelectOptionOrSelectOptGroup(childNodes[0])) [customizeInput] = childNodes;
    const getInputElement = customizeInput ? ()=>customizeInput : undefined;
    // ============================ Options ============================
    let optionChildren;
    // [Legacy] convert `children` or `dataSource` into option children
    if (childNodes.length && $0411e9f3c4d3691b$var$isSelectOptionOrSelectOptGroup(childNodes[0])) optionChildren = children;
    else optionChildren = dataSource ? dataSource.map((item)=>{
        if (/*#__PURE__*/ $jMaZ8.isValidElement(item)) return item;
        switch(typeof item){
            case 'string':
                return /*#__PURE__*/ $jMaZ8.createElement($0411e9f3c4d3691b$var$Option, {
                    key: item,
                    value: item
                }, item);
            case 'object':
                {
                    const { value: optionValue } = item;
                    return /*#__PURE__*/ $jMaZ8.createElement($0411e9f3c4d3691b$var$Option, {
                        key: optionValue,
                        value: optionValue
                    }, item.text);
                }
            default:
                return undefined;
        }
    }) : [];
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('AutoComplete');
        warning.deprecated(!('dataSource' in props), 'dataSource', 'options');
        warning(!customizeInput || !('size' in props), 'usage', 'You need to control style self instead of setting `size` when using customize input.');
        warning.deprecated(!dropdownClassName, 'dropdownClassName', 'popupClassName');
    }
    const { getPrefixCls: getPrefixCls } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    // ============================ zIndex ============================
    const [zIndex] = (0, $5f1c4f12ab1f6aec$export$3e7906d4075187a4)('SelectLike', (_a = props.dropdownStyle) === null || _a === void 0 ? void 0 : _a.zIndex);
    return /*#__PURE__*/ $jMaZ8.createElement((0, $71df08955277779f$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        suffixIcon: null
    }, (0, $hvG6u.default)(props, [
        'dataSource',
        'dropdownClassName'
    ]), {
        prefixCls: prefixCls,
        popupClassName: popupClassName || dropdownClassName,
        dropdownStyle: Object.assign(Object.assign({}, props.dropdownStyle), {
            zIndex: zIndex
        }),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-auto-complete`, className),
        mode: (0, $71df08955277779f$export$2e2bcd8739ae039).SECRET_COMBOBOX_MODE_DO_NOT_USE,
        getInputElement: // Internal api
        getInputElement
    }), optionChildren);
};
const $0411e9f3c4d3691b$var$RefAutoComplete = /*#__PURE__*/ $jMaZ8.forwardRef($0411e9f3c4d3691b$var$AutoComplete);
// We don't care debug panel
/* istanbul ignore next */ const $0411e9f3c4d3691b$var$PurePanel = (0, $122b6ffb60331d40$export$2e2bcd8739ae039)($0411e9f3c4d3691b$var$RefAutoComplete, 'dropdownAlign', (props)=>(0, $hvG6u.default)(props, [
        'visible'
    ]));
$0411e9f3c4d3691b$var$RefAutoComplete.Option = $0411e9f3c4d3691b$var$Option;
$0411e9f3c4d3691b$var$RefAutoComplete._InternalPanelDoNotUseOrYouWillBeFired = $0411e9f3c4d3691b$var$PurePanel;
$0411e9f3c4d3691b$var$RefAutoComplete.displayName = 'AutoComplete';
var $0411e9f3c4d3691b$export$2e2bcd8739ae039 = $0411e9f3c4d3691b$var$RefAutoComplete;


var $57579d4d83a7c6db$exports = {};
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $57579d4d83a7c6db$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $57579d4d83a7c6db$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty($57579d4d83a7c6db$exports, "__esModule", {
    value: true
});
Object.defineProperty($57579d4d83a7c6db$exports, "List", {
    enumerable: true,
    get: function() {
        return $57579d4d83a7c6db$var$_rcFieldForm.List;
    }
});
$57579d4d83a7c6db$exports.default = void 0;
Object.defineProperty($57579d4d83a7c6db$exports, "useForm", {
    enumerable: true,
    get: function() {
        return $57579d4d83a7c6db$var$_useForm.default;
    }
});
Object.defineProperty($57579d4d83a7c6db$exports, "useWatch", {
    enumerable: true,
    get: function() {
        return $57579d4d83a7c6db$var$_rcFieldForm.useWatch;
    }
});

var $57579d4d83a7c6db$var$React = $57579d4d83a7c6db$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $57579d4d83a7c6db$var$_classnames = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("giSak")));

var $57579d4d83a7c6db$var$_rcFieldForm = $57579d4d83a7c6db$require$_interopRequireWildcard((parcelRequire("6wVix")));

var $bv7tF = parcelRequire("bv7tF");

var $57579d4d83a7c6db$var$_DisabledContext = $57579d4d83a7c6db$require$_interopRequireWildcard((parcelRequire("8zNsY")));

var $57579d4d83a7c6db$var$_useCSSVarCls = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("39NP9")));

var $57579d4d83a7c6db$var$_useSize = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("jRzZI")));

var $57579d4d83a7c6db$var$_SizeContext = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("7hz7I")));

var $6htaW = parcelRequire("6htaW");

var $57579d4d83a7c6db$var$_useForm = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("jR3c7")));

var $57579d4d83a7c6db$var$_useFormWarning = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("5oPNh")));

var $57579d4d83a7c6db$var$_style = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("fU12E")));

var $57579d4d83a7c6db$var$_validateMessagesContext = $57579d4d83a7c6db$require$_interopRequireDefault((parcelRequire("eoEJS")));
var $57579d4d83a7c6db$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $57579d4d83a7c6db$var$InternalForm = (props, ref)=>{
    const contextDisabled = $57579d4d83a7c6db$var$React.useContext($57579d4d83a7c6db$var$_DisabledContext.default);
    const { getPrefixCls: getPrefixCls, direction: direction, form: contextForm } = $57579d4d83a7c6db$var$React.useContext($bv7tF.ConfigContext);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, hideRequiredMark: hideRequiredMark, layout: layout = 'horizontal', scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant } = props, restFormProps = $57579d4d83a7c6db$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "size",
        "disabled",
        "form",
        "colon",
        "labelAlign",
        "labelWrap",
        "labelCol",
        "wrapperCol",
        "hideRequiredMark",
        "layout",
        "scrollToFirstError",
        "requiredMark",
        "onFinishFailed",
        "name",
        "style",
        "feedbackIcons",
        "variant"
    ]);
    const mergedSize = (0, $57579d4d83a7c6db$var$_useSize.default)(size);
    const contextValidateMessages = $57579d4d83a7c6db$var$React.useContext($57579d4d83a7c6db$var$_validateMessagesContext.default);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $57579d4d83a7c6db$var$_useFormWarning.default)(props);
    const mergedRequiredMark = $57579d4d83a7c6db$var$React.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (hideRequiredMark) return false;
        if (contextForm && contextForm.requiredMark !== undefined) return contextForm.requiredMark;
        return true;
    }, [
        hideRequiredMark,
        requiredMark,
        contextForm
    ]);
    const mergedColon = colon !== null && colon !== void 0 ? colon : contextForm === null || contextForm === void 0 ? void 0 : contextForm.colon;
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $57579d4d83a7c6db$var$_useCSSVarCls.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $57579d4d83a7c6db$var$_style.default)(prefixCls, rootCls);
    const formClassName = (0, $57579d4d83a7c6db$var$_classnames.default)(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, cssVarCls, rootCls, hashId, contextForm === null || contextForm === void 0 ? void 0 : contextForm.className, className, rootClassName);
    const [wrapForm] = (0, $57579d4d83a7c6db$var$_useForm.default)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $57579d4d83a7c6db$var$React.useMemo(()=>({
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            vertical: layout === 'vertical',
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons
        }), [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons
    ]);
    const nativeElementRef = $57579d4d83a7c6db$var$React.useRef(null);
    $57579d4d83a7c6db$var$React.useImperativeHandle(ref, ()=>{
        var _a;
        return Object.assign(Object.assign({}, wrapForm), {
            nativeElement: (_a = nativeElementRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
        });
    });
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: 'nearest'
            };
            if (typeof options === 'object') defaultScrollToFirstError = Object.assign(Object.assign({}, defaultScrollToFirstError), options);
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
            if (defaultScrollToFirstError.focus) wrapForm.focusField(fieldName);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed === null || onFinishFailed === void 0 || onFinishFailed(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextForm && contextForm.scrollToFirstError !== undefined) scrollToField(contextForm.scrollToFirstError, fieldName);
        }
    };
    return wrapCSSVar(/*#__PURE__*/ $57579d4d83a7c6db$var$React.createElement($6htaW.VariantContext.Provider, {
        value: variant
    }, /*#__PURE__*/ $57579d4d83a7c6db$var$React.createElement($57579d4d83a7c6db$var$_DisabledContext.DisabledContextProvider, {
        disabled: disabled
    }, /*#__PURE__*/ $57579d4d83a7c6db$var$React.createElement($57579d4d83a7c6db$var$_SizeContext.default.Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $57579d4d83a7c6db$var$React.createElement($6htaW.FormProvider, {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $57579d4d83a7c6db$var$React.createElement($6htaW.FormContext.Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $57579d4d83a7c6db$var$React.createElement($57579d4d83a7c6db$var$_rcFieldForm.default, Object.assign({
        id: name
    }, restFormProps, {
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: Object.assign(Object.assign({}, contextForm === null || contextForm === void 0 ? void 0 : contextForm.style), style),
        className: formClassName
    }))))))));
};
const $57579d4d83a7c6db$var$Form = /*#__PURE__*/ $57579d4d83a7c6db$var$React.forwardRef($57579d4d83a7c6db$var$InternalForm);
$57579d4d83a7c6db$var$Form.displayName = 'Form';
var $57579d4d83a7c6db$var$_default = $57579d4d83a7c6db$exports.default = $57579d4d83a7c6db$var$Form;




var $6c31dc02db06870c$exports = {};
var $89ab77aae736cfe1$exports = {};
var $df73af73e437fb47$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $df73af73e437fb47$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$df73af73e437fb47$exports = $df73af73e437fb47$var$arrayReduce;


var $594575e1f3db76a9$exports = {};
var $bf2be69a6fca49fd$exports = {};
var $dfe7fe630bb20ffd$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dfe7fe630bb20ffd$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dfe7fe630bb20ffd$exports = $dfe7fe630bb20ffd$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $bf2be69a6fca49fd$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $bf2be69a6fca49fd$var$deburrLetter = $dfe7fe630bb20ffd$exports($bf2be69a6fca49fd$var$deburredLetters);
$bf2be69a6fca49fd$exports = $bf2be69a6fca49fd$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $594575e1f3db76a9$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $594575e1f3db76a9$var$rsComboMarksRange = '\\u0300-\\u036f', $594575e1f3db76a9$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $594575e1f3db76a9$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $594575e1f3db76a9$var$rsComboRange = $594575e1f3db76a9$var$rsComboMarksRange + $594575e1f3db76a9$var$reComboHalfMarksRange + $594575e1f3db76a9$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $594575e1f3db76a9$var$rsCombo = '[' + $594575e1f3db76a9$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $594575e1f3db76a9$var$reComboMark = RegExp($594575e1f3db76a9$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $594575e1f3db76a9$var$deburr(string) {
    string = $a3274ffb9a703883$exports(string);
    return string && string.replace($594575e1f3db76a9$var$reLatin, $bf2be69a6fca49fd$exports).replace($594575e1f3db76a9$var$reComboMark, '');
}
$594575e1f3db76a9$exports = $594575e1f3db76a9$var$deburr;


var $53ff94fb73b0764c$exports = {};
var $739ba16fdc8ab4d9$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $739ba16fdc8ab4d9$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $739ba16fdc8ab4d9$var$asciiWords(string) {
    return string.match($739ba16fdc8ab4d9$var$reAsciiWord) || [];
}
$739ba16fdc8ab4d9$exports = $739ba16fdc8ab4d9$var$asciiWords;


var $587929cf184e0177$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $587929cf184e0177$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $587929cf184e0177$var$hasUnicodeWord(string) {
    return $587929cf184e0177$var$reHasUnicodeWord.test(string);
}
$587929cf184e0177$exports = $587929cf184e0177$var$hasUnicodeWord;



var $105a3ee96b15d517$exports = {};
/** Used to compose unicode character classes. */ var $105a3ee96b15d517$var$rsAstralRange = '\\ud800-\\udfff', $105a3ee96b15d517$var$rsComboMarksRange = '\\u0300-\\u036f', $105a3ee96b15d517$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $105a3ee96b15d517$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $105a3ee96b15d517$var$rsComboRange = $105a3ee96b15d517$var$rsComboMarksRange + $105a3ee96b15d517$var$reComboHalfMarksRange + $105a3ee96b15d517$var$rsComboSymbolsRange, $105a3ee96b15d517$var$rsDingbatRange = '\\u2700-\\u27bf', $105a3ee96b15d517$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $105a3ee96b15d517$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $105a3ee96b15d517$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $105a3ee96b15d517$var$rsPunctuationRange = '\\u2000-\\u206f', $105a3ee96b15d517$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $105a3ee96b15d517$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $105a3ee96b15d517$var$rsVarRange = '\\ufe0e\\ufe0f', $105a3ee96b15d517$var$rsBreakRange = $105a3ee96b15d517$var$rsMathOpRange + $105a3ee96b15d517$var$rsNonCharRange + $105a3ee96b15d517$var$rsPunctuationRange + $105a3ee96b15d517$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $105a3ee96b15d517$var$rsApos = "['\u2019]", $105a3ee96b15d517$var$rsBreak = '[' + $105a3ee96b15d517$var$rsBreakRange + ']', $105a3ee96b15d517$var$rsCombo = '[' + $105a3ee96b15d517$var$rsComboRange + ']', $105a3ee96b15d517$var$rsDigits = '\\d+', $105a3ee96b15d517$var$rsDingbat = '[' + $105a3ee96b15d517$var$rsDingbatRange + ']', $105a3ee96b15d517$var$rsLower = '[' + $105a3ee96b15d517$var$rsLowerRange + ']', $105a3ee96b15d517$var$rsMisc = '[^' + $105a3ee96b15d517$var$rsAstralRange + $105a3ee96b15d517$var$rsBreakRange + $105a3ee96b15d517$var$rsDigits + $105a3ee96b15d517$var$rsDingbatRange + $105a3ee96b15d517$var$rsLowerRange + $105a3ee96b15d517$var$rsUpperRange + ']', $105a3ee96b15d517$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $105a3ee96b15d517$var$rsModifier = '(?:' + $105a3ee96b15d517$var$rsCombo + '|' + $105a3ee96b15d517$var$rsFitz + ')', $105a3ee96b15d517$var$rsNonAstral = '[^' + $105a3ee96b15d517$var$rsAstralRange + ']', $105a3ee96b15d517$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $105a3ee96b15d517$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $105a3ee96b15d517$var$rsUpper = '[' + $105a3ee96b15d517$var$rsUpperRange + ']', $105a3ee96b15d517$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $105a3ee96b15d517$var$rsMiscLower = '(?:' + $105a3ee96b15d517$var$rsLower + '|' + $105a3ee96b15d517$var$rsMisc + ')', $105a3ee96b15d517$var$rsMiscUpper = '(?:' + $105a3ee96b15d517$var$rsUpper + '|' + $105a3ee96b15d517$var$rsMisc + ')', $105a3ee96b15d517$var$rsOptContrLower = '(?:' + $105a3ee96b15d517$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $105a3ee96b15d517$var$rsOptContrUpper = '(?:' + $105a3ee96b15d517$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $105a3ee96b15d517$var$reOptMod = $105a3ee96b15d517$var$rsModifier + '?', $105a3ee96b15d517$var$rsOptVar = '[' + $105a3ee96b15d517$var$rsVarRange + ']?', $105a3ee96b15d517$var$rsOptJoin = '(?:' + $105a3ee96b15d517$var$rsZWJ + '(?:' + [
    $105a3ee96b15d517$var$rsNonAstral,
    $105a3ee96b15d517$var$rsRegional,
    $105a3ee96b15d517$var$rsSurrPair
].join('|') + ')' + $105a3ee96b15d517$var$rsOptVar + $105a3ee96b15d517$var$reOptMod + ')*', $105a3ee96b15d517$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $105a3ee96b15d517$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $105a3ee96b15d517$var$rsSeq = $105a3ee96b15d517$var$rsOptVar + $105a3ee96b15d517$var$reOptMod + $105a3ee96b15d517$var$rsOptJoin, $105a3ee96b15d517$var$rsEmoji = '(?:' + [
    $105a3ee96b15d517$var$rsDingbat,
    $105a3ee96b15d517$var$rsRegional,
    $105a3ee96b15d517$var$rsSurrPair
].join('|') + ')' + $105a3ee96b15d517$var$rsSeq;
/** Used to match complex or compound words. */ var $105a3ee96b15d517$var$reUnicodeWord = RegExp([
    $105a3ee96b15d517$var$rsUpper + '?' + $105a3ee96b15d517$var$rsLower + '+' + $105a3ee96b15d517$var$rsOptContrLower + '(?=' + [
        $105a3ee96b15d517$var$rsBreak,
        $105a3ee96b15d517$var$rsUpper,
        '$'
    ].join('|') + ')',
    $105a3ee96b15d517$var$rsMiscUpper + '+' + $105a3ee96b15d517$var$rsOptContrUpper + '(?=' + [
        $105a3ee96b15d517$var$rsBreak,
        $105a3ee96b15d517$var$rsUpper + $105a3ee96b15d517$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $105a3ee96b15d517$var$rsUpper + '?' + $105a3ee96b15d517$var$rsMiscLower + '+' + $105a3ee96b15d517$var$rsOptContrLower,
    $105a3ee96b15d517$var$rsUpper + '+' + $105a3ee96b15d517$var$rsOptContrUpper,
    $105a3ee96b15d517$var$rsOrdUpper,
    $105a3ee96b15d517$var$rsOrdLower,
    $105a3ee96b15d517$var$rsDigits,
    $105a3ee96b15d517$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $105a3ee96b15d517$var$unicodeWords(string) {
    return string.match($105a3ee96b15d517$var$reUnicodeWord) || [];
}
$105a3ee96b15d517$exports = $105a3ee96b15d517$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $53ff94fb73b0764c$var$words(string, pattern, guard) {
    string = $a3274ffb9a703883$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $587929cf184e0177$exports(string) ? $105a3ee96b15d517$exports(string) : $739ba16fdc8ab4d9$exports(string);
    return string.match(pattern) || [];
}
$53ff94fb73b0764c$exports = $53ff94fb73b0764c$var$words;


/** Used to compose unicode capture groups. */ var $89ab77aae736cfe1$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $89ab77aae736cfe1$var$reApos = RegExp($89ab77aae736cfe1$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $89ab77aae736cfe1$var$createCompounder(callback) {
    return function(string) {
        return $df73af73e437fb47$exports($53ff94fb73b0764c$exports($594575e1f3db76a9$exports(string).replace($89ab77aae736cfe1$var$reApos, '')), callback, '');
    };
}
$89ab77aae736cfe1$exports = $89ab77aae736cfe1$var$createCompounder;


var $833165055791fdfb$exports = {};
var $85bfb4a44463a867$exports = {};
var $a5bf659da9f68a00$exports = {};
var $51d81b89e92d09fa$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $51d81b89e92d09fa$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$51d81b89e92d09fa$exports = $51d81b89e92d09fa$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a5bf659da9f68a00$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $51d81b89e92d09fa$exports(array, start, end);
}
$a5bf659da9f68a00$exports = $a5bf659da9f68a00$var$castSlice;


var $57655b7d9dde6e4f$exports = {};
/** Used to compose unicode character classes. */ var $57655b7d9dde6e4f$var$rsAstralRange = '\\ud800-\\udfff', $57655b7d9dde6e4f$var$rsComboMarksRange = '\\u0300-\\u036f', $57655b7d9dde6e4f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $57655b7d9dde6e4f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $57655b7d9dde6e4f$var$rsComboRange = $57655b7d9dde6e4f$var$rsComboMarksRange + $57655b7d9dde6e4f$var$reComboHalfMarksRange + $57655b7d9dde6e4f$var$rsComboSymbolsRange, $57655b7d9dde6e4f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $57655b7d9dde6e4f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $57655b7d9dde6e4f$var$reHasUnicode = RegExp('[' + $57655b7d9dde6e4f$var$rsZWJ + $57655b7d9dde6e4f$var$rsAstralRange + $57655b7d9dde6e4f$var$rsComboRange + $57655b7d9dde6e4f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $57655b7d9dde6e4f$var$hasUnicode(string) {
    return $57655b7d9dde6e4f$var$reHasUnicode.test(string);
}
$57655b7d9dde6e4f$exports = $57655b7d9dde6e4f$var$hasUnicode;


var $c9066faacf797881$exports = {};
var $0f5c085ef9e03d30$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0f5c085ef9e03d30$var$asciiToArray(string) {
    return string.split('');
}
$0f5c085ef9e03d30$exports = $0f5c085ef9e03d30$var$asciiToArray;



var $7879b422d021c486$exports = {};
/** Used to compose unicode character classes. */ var $7879b422d021c486$var$rsAstralRange = '\\ud800-\\udfff', $7879b422d021c486$var$rsComboMarksRange = '\\u0300-\\u036f', $7879b422d021c486$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7879b422d021c486$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7879b422d021c486$var$rsComboRange = $7879b422d021c486$var$rsComboMarksRange + $7879b422d021c486$var$reComboHalfMarksRange + $7879b422d021c486$var$rsComboSymbolsRange, $7879b422d021c486$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7879b422d021c486$var$rsAstral = '[' + $7879b422d021c486$var$rsAstralRange + ']', $7879b422d021c486$var$rsCombo = '[' + $7879b422d021c486$var$rsComboRange + ']', $7879b422d021c486$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7879b422d021c486$var$rsModifier = '(?:' + $7879b422d021c486$var$rsCombo + '|' + $7879b422d021c486$var$rsFitz + ')', $7879b422d021c486$var$rsNonAstral = '[^' + $7879b422d021c486$var$rsAstralRange + ']', $7879b422d021c486$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7879b422d021c486$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7879b422d021c486$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7879b422d021c486$var$reOptMod = $7879b422d021c486$var$rsModifier + '?', $7879b422d021c486$var$rsOptVar = '[' + $7879b422d021c486$var$rsVarRange + ']?', $7879b422d021c486$var$rsOptJoin = '(?:' + $7879b422d021c486$var$rsZWJ + '(?:' + [
    $7879b422d021c486$var$rsNonAstral,
    $7879b422d021c486$var$rsRegional,
    $7879b422d021c486$var$rsSurrPair
].join('|') + ')' + $7879b422d021c486$var$rsOptVar + $7879b422d021c486$var$reOptMod + ')*', $7879b422d021c486$var$rsSeq = $7879b422d021c486$var$rsOptVar + $7879b422d021c486$var$reOptMod + $7879b422d021c486$var$rsOptJoin, $7879b422d021c486$var$rsSymbol = '(?:' + [
    $7879b422d021c486$var$rsNonAstral + $7879b422d021c486$var$rsCombo + '?',
    $7879b422d021c486$var$rsCombo,
    $7879b422d021c486$var$rsRegional,
    $7879b422d021c486$var$rsSurrPair,
    $7879b422d021c486$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7879b422d021c486$var$reUnicode = RegExp($7879b422d021c486$var$rsFitz + '(?=' + $7879b422d021c486$var$rsFitz + ')|' + $7879b422d021c486$var$rsSymbol + $7879b422d021c486$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7879b422d021c486$var$unicodeToArray(string) {
    return string.match($7879b422d021c486$var$reUnicode) || [];
}
$7879b422d021c486$exports = $7879b422d021c486$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c9066faacf797881$var$stringToArray(string) {
    return $57655b7d9dde6e4f$exports(string) ? $7879b422d021c486$exports(string) : $0f5c085ef9e03d30$exports(string);
}
$c9066faacf797881$exports = $c9066faacf797881$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $85bfb4a44463a867$var$createCaseFirst(methodName) {
    return function(string) {
        string = $a3274ffb9a703883$exports(string);
        var strSymbols = $57655b7d9dde6e4f$exports(string) ? $c9066faacf797881$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $a5bf659da9f68a00$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$85bfb4a44463a867$exports = $85bfb4a44463a867$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $833165055791fdfb$var$upperFirst = $85bfb4a44463a867$exports('toUpperCase');
$833165055791fdfb$exports = $833165055791fdfb$var$upperFirst;


/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var $6c31dc02db06870c$var$startCase = $89ab77aae736cfe1$exports(function(result, word, index) {
    return result + (index ? ' ' : '') + $833165055791fdfb$exports(word);
});
$6c31dc02db06870c$exports = $6c31dc02db06870c$var$startCase;


const $c4ad876759b73a13$var$DialoguePicture = ({ isVisible: isVisible, projectId: projectId, paragraphId: paragraphId, speakerId: speakerId, onExit: onExit, speakers: speakers })=>{
    const options = speakers.map((s)=>({
            value: s.name,
            key: s.id
        }));
    const defaultSpeaker = (0, $jMaZ8.useMemo)(()=>speakers.find((s)=>s.id === speakerId), [
        speakers,
        speakerId
    ]);
    const i18nKeyForm = "project.existing.editingMode.formatting.associateToSpeaker";
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [applyLinkDialogueToSpeaker] = (0, $d7188398173686a1$export$88a53f86701e9c60)();
    const [applyUnlinkDialogueAndSpeaker] = (0, $d7188398173686a1$export$e247a83015ffe6ce)();
    const [form] = (0, $57579d4d83a7c6db$exports.useForm)();
    const key = paragraphId + (defaultSpeaker?.name || "");
    (0, $jMaZ8.useEffect)(()=>form.resetFields(), [
        form,
        isVisible
    ]);
    const hasError = form.getFieldsError().map((e)=>e.errors).flat().length !== 0;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        title: t(`${i18nKeyForm}.title`),
        open: isVisible,
        onCancel: ()=>{
            onExit();
        },
        footer: false,
        children: [
            isVisible && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
                initialValues: {
                    name: defaultSpeaker?.name
                },
                form: form,
                onFinish: ({ name: name })=>{
                    const existingSpeaker = speakers.find((s)=>s.name === name);
                    if (existingSpeaker) applyLinkDialogueToSpeaker({
                        variables: {
                            speakerId: existingSpeaker.id,
                            paragraphId: paragraphId,
                            projectId: projectId
                        }
                    });
                    else applyLinkDialogueToSpeaker({
                        variables: {
                            speakerName: name,
                            paragraphId: paragraphId,
                            projectId: projectId
                        }
                    });
                    onExit();
                },
                layout: "vertical",
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                        style: {
                            padding: "0 7em"
                        },
                        label: t(`${i18nKeyForm}.name`),
                        normalize: (v)=>(0, (/*@__PURE__*/$parcel$interopDefault($6c31dc02db06870c$exports)))(v.toLowerCase()).replace(/\s/, ""),
                        rules: [
                            ()=>({
                                    validator: async (_, value)=>{
                                        if (value.toLowerCase().match(/^\w+$/)) return;
                                        throw new Error(t(`${i18nKeyForm}.alphaNumError`));
                                    }
                                })
                        ],
                        name: "name",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0411e9f3c4d3691b$export$2e2bcd8739ae039), {
                            options: options
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                        style: {
                            margin: 0,
                            marginTop: "2em"
                        },
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                            justify: "center",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                disabled: hasError,
                                htmlType: "submit",
                                shape: "round",
                                children: t("project.existing.editingMode.formatting.default.form.validation")
                            })
                        })
                    })
                ]
            }, key),
            defaultSpeaker && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                justify: "center",
                style: {
                    paddingTop: "2em"
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        applyUnlinkDialogueAndSpeaker({
                            variables: {
                                paragraphId: paragraphId,
                                projectId: projectId
                            }
                        });
                        onExit();
                    },
                    shape: "round",
                    size: "small",
                    danger: true,
                    children: t(`${i18nKeyForm}.dissociate`)
                })
            })
        ]
    });
};
var $c4ad876759b73a13$export$2e2bcd8739ae039 = $c4ad876759b73a13$var$DialoguePicture;




var $jMaZ8 = parcelRequire("jMaZ8");






const $d8ba62a4c17fa394$var$i18nKeyForm = "project.existing.editingMode.formatting.default.form";
const $d8ba62a4c17fa394$var$RadioButton = (0, $41c1392b19ea6316$export$2e2bcd8739ae039).Button;
const $d8ba62a4c17fa394$var$stringOrEmptyString = (str)=>typeof str === "string" && str.trim() !== "" ? str : "";
const $d8ba62a4c17fa394$var$ModalEditImage = ({ isEditingImage: isEditingImage, setIsEditingImage: setIsEditingImage, form: form, projectId: projectId })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [apolloUpdateImage] = (0, $d7188398173686a1$export$41519f342d0f82fe)();
    const applyUpdateImage = (0, $jMaZ8.useCallback)((image)=>{
        apolloUpdateImage({
            variables: {
                imageId: image.id,
                fileName: (0, $7ff84a88030acb67$export$d4bc33f48b610b3b)(image.fileName),
                kind: image.kind,
                position: image.position,
                description: $d8ba62a4c17fa394$var$stringOrEmptyString(image.description),
                figcaption: $d8ba62a4c17fa394$var$stringOrEmptyString(image.figcaption),
                projectId: projectId
            }
        });
        setIsEditingImage({
            open: false,
            id: image.id,
            fileName: (0, $7ff84a88030acb67$export$d4bc33f48b610b3b)(image.fileName),
            description: $d8ba62a4c17fa394$var$stringOrEmptyString(image.description),
            figcaption: $d8ba62a4c17fa394$var$stringOrEmptyString(image.figcaption),
            kind: image.kind
        });
    }, [
        apolloUpdateImage,
        setIsEditingImage,
        projectId
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        open: isEditingImage.open,
        footer: false,
        onCancel: ()=>setIsEditingImage({
                ...isEditingImage,
                open: false
            }),
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
            name: t(`${$d8ba62a4c17fa394$var$i18nKeyForm}.name`),
            onFinish: ({ fileName: fileName, kind: kind, description: description, figcaption: figcaption })=>{
                const updatedImage = {
                    fileName: fileName || isEditingImage.fileName,
                    kind: kind || isEditingImage.kind,
                    description: description,
                    figcaption: figcaption
                };
                applyUpdateImage({
                    ...isEditingImage,
                    ...updatedImage
                });
            },
            layout: "vertical",
            form: form,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t(`${$d8ba62a4c17fa394$var$i18nKeyForm}.imageNaming.label`),
                    initialValue: isEditingImage.fileName,
                    name: "fileName",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t(`${$d8ba62a4c17fa394$var$i18nKeyForm}.imageDescription.label`),
                    initialValue: isEditingImage.description,
                    name: "description",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        padding: "0 7em"
                    },
                    label: t(`${$d8ba62a4c17fa394$var$i18nKeyForm}.figcaption.label`),
                    initialValue: isEditingImage.figcaption,
                    name: "figcaption",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        margin: 0
                    },
                    name: "kind",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $41c1392b19ea6316$export$2e2bcd8739ae039).Group, {
                            style: {
                                display: "flex",
                                fontSize: "1.25em"
                            },
                            defaultValue: isEditingImage.kind,
                            optionType: "button",
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d8ba62a4c17fa394$var$RadioButton, {
                                    style: (0, $b317fad54680d391$export$391303d1dd654373),
                                    value: (0, $b522cf181e75e62d$export$b890e9c15247e0b3).NORMAL,
                                    children: t(`${$d8ba62a4c17fa394$var$i18nKeyForm}.radioButton.normal`)
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d8ba62a4c17fa394$var$RadioButton, {
                                    style: (0, $b317fad54680d391$export$391303d1dd654373),
                                    value: (0, $b522cf181e75e62d$export$b890e9c15247e0b3).POPUP,
                                    children: t(`${$d8ba62a4c17fa394$var$i18nKeyForm}.radioButton.popup`)
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                    style: {
                        margin: 0,
                        marginTop: "2em"
                    },
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            htmlType: "submit",
                            shape: "round",
                            children: t(`${$d8ba62a4c17fa394$var$i18nKeyForm}.validation`)
                        })
                    })
                })
            ]
        }, isEditingImage.id)
    });
};
var $d8ba62a4c17fa394$export$2e2bcd8739ae039 = $d8ba62a4c17fa394$var$ModalEditImage;




var $jMaZ8 = parcelRequire("jMaZ8");




parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $76ff10f1f8afe124$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $76ff10f1f8afe124$export$2e2bcd8739ae039 = $76ff10f1f8afe124$var$EditOutlined;



var $5453b18558c87ec6$var$EditOutlined = function EditOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $76ff10f1f8afe124$export$2e2bcd8739ae039)
    }));
};
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ var $5453b18558c87ec6$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($5453b18558c87ec6$var$EditOutlined);
$5453b18558c87ec6$var$RefIcon.displayName = 'EditOutlined';
var $5453b18558c87ec6$export$2e2bcd8739ae039 = $5453b18558c87ec6$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $bAXx0 = parcelRequire("bAXx0");

var $a6yuN = parcelRequire("a6yuN");

var $jLTp6 = parcelRequire("jLTp6");

var $eGh7a = parcelRequire("eGh7a");

var $hvG6u = parcelRequire("hvG6u");

var $1cfGC = parcelRequire("1cfGC");





var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $1eb31dd610f11d67$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $1eb31dd610f11d67$export$2e2bcd8739ae039 = $1eb31dd610f11d67$var$EnterOutlined;



var $07be3cc522ddf8a8$var$EnterOutlined = function EnterOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $1eb31dd610f11d67$export$2e2bcd8739ae039)
    }));
};
/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ var $07be3cc522ddf8a8$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($07be3cc522ddf8a8$var$EnterOutlined);
$07be3cc522ddf8a8$var$RefIcon.displayName = 'EnterOutlined';
var $07be3cc522ddf8a8$export$2e2bcd8739ae039 = $07be3cc522ddf8a8$var$RefIcon;



var $giSak = parcelRequire("giSak");





/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/ parcelRequire("1T8KD");
var $lvl2c = parcelRequire("lvl2c");
parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

const $44f8fd2066363aac$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $44f8fd2066363aac$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $44f8fd2066363aac$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $44f8fd2066363aac$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        'a&, a': Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$9a16e7694a707ab4)(token)), {
            userSelect: 'text',
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:active, &:hover': {
                    color: token.colorTextDisabled
                },
                '&:active': {
                    pointerEvents: 'none'
                }
            }
        })
    };
};
const $44f8fd2066363aac$export$977383a86f45014b = (token)=>({
        code: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.2em 0.1em',
            fontSize: '85%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3
        },
        kbd: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.15em 0.1em',
            fontSize: '90%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.06)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $lvl2c.gold)[2]
        },
        'u, ins': {
            textDecoration: 'underline',
            textDecorationSkipInk: 'auto'
        },
        's, del': {
            textDecoration: 'line-through'
        },
        strong: {
            fontWeight: 600
        },
        // list
        'ul, ol': {
            marginInline: 0,
            marginBlock: '0 1em',
            padding: 0,
            li: {
                marginInline: '20px 0',
                marginBlock: 0,
                paddingInline: '4px 0',
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: 'circle',
            ul: {
                listStyleType: 'disc'
            }
        },
        ol: {
            listStyleType: 'decimal'
        },
        // pre & block
        'pre, blockquote': {
            margin: '1em 0'
        },
        pre: {
            padding: '0.4em 0.6em',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: 'inline',
                margin: 0,
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit',
                background: 'transparent',
                border: 0
            }
        },
        blockquote: {
            paddingInline: '0.6em 0',
            paddingBlock: 0,
            borderInlineStart: '4px solid rgba(100, 100, 100, 0.2)',
            opacity: 0.85
        }
    });
const $44f8fd2066363aac$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        '&-edit-content': {
            position: 'relative',
            'div&': {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                marginTop: token.calc(inputShift).mul(-1).equal(),
                marginBottom: `calc(1em - ${(0, $4g3I0.unit)(inputShift)})`
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: 'absolute',
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorTextDescription,
                // default style
                fontWeight: 'normal',
                fontSize: token.fontSize,
                fontStyle: 'normal',
                pointerEvents: 'none'
            },
            textarea: {
                margin: '0!important',
                // Fix Editable Textarea flash in Firefox
                MozTransition: 'none',
                height: '1em'
            }
        }
    };
};
const $44f8fd2066363aac$export$34755446404037a5 = (token)=>({
        [`${token.componentCls}-copy-success`]: {
            [`
    &,
    &:hover,
    &:focus`]: {
                color: token.colorSuccess
            }
        },
        [`${token.componentCls}-copy-icon-only`]: {
            marginInlineStart: 0
        }
    });
const $44f8fd2066363aac$export$d9556a50eba3003b = ()=>({
        [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
            display: 'inline-block',
            maxWidth: '100%'
        },
        '&-ellipsis-single-line': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // https://blog.csdn.net/iefreer/article/details/50421025
            'a&, span&': {
                verticalAlign: 'bottom'
            },
            '> code': {
                paddingBlock: 0,
                maxWidth: 'calc(100% - 1.2em)',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: 'content-box'
            }
        },
        '&-ellipsis-multiple-line': {
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical'
        }
    });


const $c41c7a9ef87563b2$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
            color: token.colorText,
            wordBreak: 'break-word',
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success`]: {
                color: token.colorSuccess
            },
            [`&${componentCls}-warning`]: {
                color: token.colorWarning
            },
            [`&${componentCls}-danger`]: {
                color: token.colorError,
                'a&:active, a&:focus': {
                    color: token.colorErrorActive
                },
                'a&:hover': {
                    color: token.colorErrorHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                userSelect: 'none'
            },
            [`
        div&,
        p
      `]: {
                marginBottom: '1em'
            }
        }, (0, $44f8fd2066363aac$export$83146cf7d1bec659)(token)), {
            [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
                marginTop: titleMarginTop
            },
            [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
                [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
                    marginTop: titleMarginTop
                }
            }
        }), (0, $44f8fd2066363aac$export$977383a86f45014b)(token)), (0, $44f8fd2066363aac$export$566f4066c7caac18)(token)), {
            // Operation
            [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$9a16e7694a707ab4)(token)), {
                marginInlineStart: token.marginXXS
            })
        }), (0, $44f8fd2066363aac$export$2667badb03518972)(token)), (0, $44f8fd2066363aac$export$34755446404037a5)(token)), (0, $44f8fd2066363aac$export$d9556a50eba3003b)()), {
            '&-rtl': {
                direction: 'rtl'
            }
        })
    };
};
const $c41c7a9ef87563b2$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: '1.2em',
        titleMarginBottom: '0.5em'
    });
var // ============================== Export ==============================
$c41c7a9ef87563b2$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Typography', (token)=>[
        $c41c7a9ef87563b2$var$genTypographyStyle(token)
    ], $c41c7a9ef87563b2$export$9ca1be8807fe0675);


"use client";
const $43e48181c3672947$var$Editable = (props)=>{
    const { prefixCls: prefixCls, 'aria-label': ariaLabel, className: className, style: style, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $jMaZ8.createElement((0, $07be3cc522ddf8a8$export$2e2bcd8739ae039), null) } = props;
    const ref = $jMaZ8.useRef(null);
    const inComposition = $jMaZ8.useRef(false);
    const lastKeyCode = $jMaZ8.useRef(null);
    const [current, setCurrent] = $jMaZ8.useState(value);
    $jMaZ8.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $jMaZ8.useEffect(()=>{
        var _a;
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = (_ref)=>{
        let { target: target } = _ref;
        setCurrent(target.value.replace(/[\n\r]/g, ''));
    };
    const onCompositionStart = ()=>{
        inComposition.current = true;
    };
    const onCompositionEnd = ()=>{
        inComposition.current = false;
    };
    const onKeyDown = (_ref2)=>{
        let { keyCode: keyCode } = _ref2;
        // We don't record keyCode when IME is using
        if (inComposition.current) return;
        lastKeyCode.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = (_ref3)=>{
        let { keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey } = _ref3;
        // Check if it's a real key
        if (lastKeyCode.current !== keyCode || inComposition.current || ctrlKey || altKey || metaKey || shiftKey) return;
        if (keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ENTER) {
            confirmChange();
            onEnd === null || onEnd === void 0 || onEnd();
        } else if (keyCode === (0, $0d32d7154f3e80e4$export$2e2bcd8739ae039).ESC) onCancel();
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c41c7a9ef87563b2$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${component}`]: !!component
    }, className, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $jMaZ8.createElement((0, $c701e4577fe78359$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $e4daa5bbe3988c87$export$e530037191fcd5d7)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null));
};
var $43e48181c3672947$export$2e2bcd8739ae039 = $43e48181c3672947$var$Editable;



var $jMaZ8 = parcelRequire("jMaZ8");
var $d0046c4cfefaff34$exports = {};
"use strict";
var $86f9bc0fdf63f370$exports = {};
$86f9bc0fdf63f370$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $d0046c4cfefaff34$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $d0046c4cfefaff34$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $d0046c4cfefaff34$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $d0046c4cfefaff34$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $86f9bc0fdf63f370$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $d0046c4cfefaff34$var$clipboardToIE11Formatting[options.format] || $d0046c4cfefaff34$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $d0046c4cfefaff34$var$format("message" in options ? options.message : $d0046c4cfefaff34$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$d0046c4cfefaff34$exports = $d0046c4cfefaff34$var$copy;



var $ktS49 = parcelRequire("ktS49");
function $1ae7dfb0146a6bb5$export$2e2bcd8739ae039(candidate) {
    let skipEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (skipEmpty && (candidate === undefined || candidate === null)) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}


var $bbd0c2e0aed23239$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $bbd0c2e0aed23239$var$useCopyClick = (_ref)=>{
    let { copyConfig: copyConfig, children: children } = _ref;
    const [copied, setCopied] = $jMaZ8.useState(false);
    const [copyLoading, setCopyLoading] = $jMaZ8.useState(false);
    const copyIdRef = $jMaZ8.useRef(null);
    const cleanCopyId = ()=>{
        if (copyIdRef.current) clearTimeout(copyIdRef.current);
    };
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    $jMaZ8.useEffect(()=>cleanCopyId, []);
    // Keep copy action up to date
    const onClick = (0, $ktS49.default)((e)=>$bbd0c2e0aed23239$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            e === null || e === void 0 || e.preventDefault();
            e === null || e === void 0 || e.stopPropagation();
            setCopyLoading(true);
            try {
                const text = typeof copyConfig.text === 'function' ? yield copyConfig.text() : copyConfig.text;
                (0, (/*@__PURE__*/$parcel$interopDefault($d0046c4cfefaff34$exports)))(text || (0, $1ae7dfb0146a6bb5$export$2e2bcd8739ae039)(children, true).join('') || '', copyOptions);
                setCopyLoading(false);
                setCopied(true);
                // Trigger tips update
                cleanCopyId();
                copyIdRef.current = setTimeout(()=>{
                    setCopied(false);
                }, 3000);
                (_a = copyConfig.onCopy) === null || _a === void 0 || _a.call(copyConfig, e);
            } catch (error) {
                setCopyLoading(false);
                throw error;
            }
        }));
    return {
        copied: copied,
        copyLoading: copyLoading,
        onClick: onClick
    };
};
var $bbd0c2e0aed23239$export$2e2bcd8739ae039 = $bbd0c2e0aed23239$var$useCopyClick;



var $jMaZ8 = parcelRequire("jMaZ8");
function $119801a2f29ddb90$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $jMaZ8.useMemo(()=>{
        const support = !!propConfig;
        return [
            support,
            Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === 'object' ? propConfig : null)
        ];
    }, [
        propConfig
    ]);
}



var $jMaZ8 = parcelRequire("jMaZ8");
const $c36d532a0f9cdbb8$var$usePrevious = (value)=>{
    const ref = (0, $jMaZ8.useRef)(undefined);
    (0, $jMaZ8.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $c36d532a0f9cdbb8$export$2e2bcd8739ae039 = $c36d532a0f9cdbb8$var$usePrevious;



var $jMaZ8 = parcelRequire("jMaZ8");
const $fe605010d962a9ba$var$useTooltipProps = (tooltip, editConfigText, children)=>(0, $jMaZ8.useMemo)(()=>{
        if (tooltip === true) return {
            title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
        };
        if (/*#__PURE__*/ (0, $jMaZ8.isValidElement)(tooltip)) return {
            title: tooltip
        };
        if (typeof tooltip === 'object') return Object.assign({
            title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
        }, tooltip);
        return {
            title: tooltip
        };
    }, [
        tooltip,
        editConfigText,
        children
    ]);
var $fe605010d962a9ba$export$2e2bcd8739ae039 = $fe605010d962a9ba$var$useTooltipProps;



var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $1cfGC = parcelRequire("1cfGC");



"use client";
var $ee2753f92a8062af$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ee2753f92a8062af$var$Typography = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, component: Component = 'article', className: className, rootClassName: rootClassName, setContentRef: setContentRef, children: children, direction: typographyDirection, style: style } = props, restProps = $ee2753f92a8062af$var$__rest(props, [
        "prefixCls",
        "component",
        "className",
        "rootClassName",
        "setContentRef",
        "children",
        "direction",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, direction: contextDirection, typography: typography } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
    const mergedRef = setContentRef ? (0, $1cfGC.composeRef)(ref, setContentRef) : ref;
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Typography');
        warning.deprecated(!setContentRef, 'setContentRef', 'ref');
    }
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c41c7a9ef87563b2$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, typography === null || typography === void 0 ? void 0 : typography.className, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, typography === null || typography === void 0 ? void 0 : typography.style), style);
    return wrapCSSVar(/*#__PURE__*/ // @ts-expect-error: Expression produces a union type that is too complex to represent.
    $jMaZ8.createElement(Component, Object.assign({
        className: componentClassName,
        style: mergedStyle,
        ref: mergedRef
    }, restProps), children));
});
$ee2753f92a8062af$var$Typography.displayName = 'Typography';
var $ee2753f92a8062af$export$2e2bcd8739ae039 = $ee2753f92a8062af$var$Typography;



var $jMaZ8 = parcelRequire("jMaZ8");


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $f1e31446ebfa7026$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $f1e31446ebfa7026$export$2e2bcd8739ae039 = $f1e31446ebfa7026$var$CopyOutlined;



var $4a34820ea22e88d2$var$CopyOutlined = function CopyOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $f1e31446ebfa7026$export$2e2bcd8739ae039)
    }));
};
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ var $4a34820ea22e88d2$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($4a34820ea22e88d2$var$CopyOutlined);
$4a34820ea22e88d2$var$RefIcon.displayName = 'CopyOutlined';
var $4a34820ea22e88d2$export$2e2bcd8739ae039 = $4a34820ea22e88d2$var$RefIcon;




var $giSak = parcelRequire("giSak");

function $faa117f60997c90c$export$effcdbd76139450(val) {
    if (val === false) return [
        false,
        false
    ];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $faa117f60997c90c$export$3f778c4e796a1f9c(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $faa117f60997c90c$export$5714fcf57d9d6988(ele) {
    // Create a new div to get the size
    const childDiv = document.createElement('em');
    ele.appendChild(childDiv);
    childDiv.className = 'ant-typography-css-ellipsis-content-measure';
    const rect = ele.getBoundingClientRect();
    const childRect = childDiv.getBoundingClientRect();
    // Reset
    ele.removeChild(childDiv);
    // Range checker
    return(// Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right || // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom);
}
const $faa117f60997c90c$export$a748c1acb7702f51 = (val)=>[
        'string',
        'number'
    ].includes(typeof val);


"use client";
const $ffcc6c22ad40b4fb$var$CopyBtn = (_ref)=>{
    let { prefixCls: prefixCls, copied: copied, locale: locale, iconOnly: iconOnly, tooltips: tooltips, icon: icon, tabIndex: tabIndex, onCopy: onCopy, loading: btnLoading } = _ref;
    const tooltipNodes = (0, $faa117f60997c90c$export$effcdbd76139450)(tooltips);
    const iconNodes = (0, $faa117f60997c90c$export$effcdbd76139450)(icon);
    const { copied: copiedText, copy: copyText } = locale !== null && locale !== void 0 ? locale : {};
    const systemStr = copied ? copiedText : copyText;
    const copyTitle = (0, $faa117f60997c90c$export$3f778c4e796a1f9c)(tooltipNodes[copied ? 1 : 0], systemStr);
    const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
        title: copyTitle
    }, /*#__PURE__*/ $jMaZ8.createElement("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(`${prefixCls}-copy`, {
            [`${prefixCls}-copy-success`]: copied,
            [`${prefixCls}-copy-icon-only`]: iconOnly
        }),
        onClick: onCopy,
        "aria-label": ariaLabel,
        tabIndex: tabIndex
    }, copied ? (0, $faa117f60997c90c$export$3f778c4e796a1f9c)(iconNodes[1], /*#__PURE__*/ $jMaZ8.createElement((0, $c1c1d6d80357382d$export$2e2bcd8739ae039), null), true) : (0, $faa117f60997c90c$export$3f778c4e796a1f9c)(iconNodes[0], btnLoading ? /*#__PURE__*/ $jMaZ8.createElement((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $jMaZ8.createElement((0, $4a34820ea22e88d2$export$2e2bcd8739ae039), null), true)));
};
var $ffcc6c22ad40b4fb$export$2e2bcd8739ae039 = $ffcc6c22ad40b4fb$var$CopyBtn;



var $fvBso = parcelRequire("fvBso");

var $jMaZ8 = parcelRequire("jMaZ8");

var $a6yuN = parcelRequire("a6yuN");

var $jLTp6 = parcelRequire("jLTp6");

"use client";
const $3924c9547f0235c0$var$MeasureText = /*#__PURE__*/ $jMaZ8.forwardRef((_ref, ref)=>{
    let { style: style, children: children } = _ref;
    const spanRef = $jMaZ8.useRef(null);
    $jMaZ8.useImperativeHandle(ref, ()=>({
            isExceed: ()=>{
                const span = spanRef.current;
                return span.scrollHeight > span.clientHeight;
            },
            getHeight: ()=>spanRef.current.clientHeight
        }));
    return /*#__PURE__*/ $jMaZ8.createElement("span", {
        "aria-hidden": true,
        ref: spanRef,
        style: Object.assign({
            position: 'fixed',
            display: 'block',
            left: 0,
            top: 0,
            pointerEvents: 'none',
            backgroundColor: 'rgba(255, 0, 0, 0.65)'
        }, style)
    }, children);
});
const $3924c9547f0235c0$var$getNodesLen = (nodeList)=>nodeList.reduce((totalLen, node)=>totalLen + ((0, $faa117f60997c90c$export$a748c1acb7702f51)(node) ? String(node).length : 1), 0);
function $3924c9547f0235c0$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = (0, $faa117f60997c90c$export$a748c1acb7702f51)(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const $3924c9547f0235c0$var$STATUS_MEASURE_NONE = 0;
const $3924c9547f0235c0$var$STATUS_MEASURE_PREPARE = 1;
const $3924c9547f0235c0$var$STATUS_MEASURE_START = 2;
const $3924c9547f0235c0$var$STATUS_MEASURE_NEED_ELLIPSIS = 3;
const $3924c9547f0235c0$var$STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const $3924c9547f0235c0$var$lineClipStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
};
function $3924c9547f0235c0$export$2e2bcd8739ae039(props) {
    const { enableMeasure: enableMeasure, width: width, text: text, children: children, rows: rows, expanded: expanded, miscDeps: miscDeps, onEllipsis: onEllipsis } = props;
    const nodeList = $jMaZ8.useMemo(()=>(0, $a6yuN.default)(text), [
        text
    ]);
    const nodeLen = $jMaZ8.useMemo(()=>$3924c9547f0235c0$var$getNodesLen(nodeList), [
        text
    ]);
    // ========================= Full Content =========================
    // Used for measure only, which means it's always render as no need ellipsis
    const fullContent = $jMaZ8.useMemo(()=>children(nodeList, false), [
        text
    ]);
    // ========================= Cut Content ==========================
    const [ellipsisCutIndex, setEllipsisCutIndex] = $jMaZ8.useState(null);
    const cutMidRef = $jMaZ8.useRef(null);
    // ========================= NeedEllipsis =========================
    const measureWhiteSpaceRef = $jMaZ8.useRef(null);
    const needEllipsisRef = $jMaZ8.useRef(null);
    // Measure for `rows-1` height, to avoid operation exceed the line height
    const descRowsEllipsisRef = $jMaZ8.useRef(null);
    const symbolRowEllipsisRef = $jMaZ8.useRef(null);
    const [canEllipsis, setCanEllipsis] = $jMaZ8.useState(false);
    const [needEllipsis, setNeedEllipsis] = $jMaZ8.useState($3924c9547f0235c0$var$STATUS_MEASURE_NONE);
    const [ellipsisHeight, setEllipsisHeight] = $jMaZ8.useState(0);
    const [parentWhiteSpace, setParentWhiteSpace] = $jMaZ8.useState(null);
    // Trigger start measure
    (0, $jLTp6.default)(()=>{
        if (enableMeasure && width && nodeLen) setNeedEllipsis($3924c9547f0235c0$var$STATUS_MEASURE_PREPARE);
        else setNeedEllipsis($3924c9547f0235c0$var$STATUS_MEASURE_NONE);
    }, [
        width,
        text,
        rows,
        enableMeasure,
        nodeList
    ]);
    // Measure process
    (0, $jLTp6.default)(()=>{
        var _a, _b, _c, _d;
        if (needEllipsis === $3924c9547f0235c0$var$STATUS_MEASURE_PREPARE) {
            setNeedEllipsis($3924c9547f0235c0$var$STATUS_MEASURE_START);
            // Parent ref `white-space`
            const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
            setParentWhiteSpace(nextWhiteSpace);
        } else if (needEllipsis === $3924c9547f0235c0$var$STATUS_MEASURE_START) {
            const isOverflow = !!((_a = needEllipsisRef.current) === null || _a === void 0 ? void 0 : _a.isExceed());
            setNeedEllipsis(isOverflow ? $3924c9547f0235c0$var$STATUS_MEASURE_NEED_ELLIPSIS : $3924c9547f0235c0$var$STATUS_MEASURE_NO_NEED_ELLIPSIS);
            setEllipsisCutIndex(isOverflow ? [
                0,
                nodeLen
            ] : null);
            setCanEllipsis(isOverflow);
            // Get the basic height of ellipsis rows
            const baseRowsEllipsisHeight = ((_b = needEllipsisRef.current) === null || _b === void 0 ? void 0 : _b.getHeight()) || 0;
            // Get the height of `rows - 1` + symbol height
            const descRowsEllipsisHeight = rows === 1 ? 0 : ((_c = descRowsEllipsisRef.current) === null || _c === void 0 ? void 0 : _c.getHeight()) || 0;
            const symbolRowEllipsisHeight = ((_d = symbolRowEllipsisRef.current) === null || _d === void 0 ? void 0 : _d.getHeight()) || 0;
            const maxRowsHeight = Math.max(baseRowsEllipsisHeight, // height of rows with ellipsis
            descRowsEllipsisHeight + symbolRowEllipsisHeight);
            setEllipsisHeight(maxRowsHeight + 1);
            onEllipsis(isOverflow);
        }
    }, [
        needEllipsis
    ]);
    // ========================= Cut Measure ==========================
    const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
    (0, $jLTp6.default)(()=>{
        var _a;
        const [minIndex, maxIndex] = ellipsisCutIndex || [
            0,
            0
        ];
        if (minIndex !== maxIndex) {
            const midHeight = ((_a = cutMidRef.current) === null || _a === void 0 ? void 0 : _a.getHeight()) || 0;
            const isOverflow = midHeight > ellipsisHeight;
            let targetMidIndex = cutMidIndex;
            if (maxIndex - minIndex === 1) targetMidIndex = isOverflow ? minIndex : maxIndex;
            setEllipsisCutIndex(isOverflow ? [
                minIndex,
                targetMidIndex
            ] : [
                targetMidIndex,
                maxIndex
            ]);
        }
    }, [
        ellipsisCutIndex,
        cutMidIndex
    ]);
    // ========================= Text Content =========================
    const finalContent = $jMaZ8.useMemo(()=>{
        // Skip everything if `enableMeasure` is disabled
        if (!enableMeasure) return children(nodeList, false);
        if (needEllipsis !== $3924c9547f0235c0$var$STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
            const content = children(nodeList, false);
            // Limit the max line count to avoid scrollbar blink unless no need ellipsis
            // https://github.com/ant-design/ant-design/issues/42958
            if ([
                $3924c9547f0235c0$var$STATUS_MEASURE_NO_NEED_ELLIPSIS,
                $3924c9547f0235c0$var$STATUS_MEASURE_NONE
            ].includes(needEllipsis)) return content;
            return /*#__PURE__*/ $jMaZ8.createElement("span", {
                style: Object.assign(Object.assign({}, $3924c9547f0235c0$var$lineClipStyle), {
                    WebkitLineClamp: rows
                })
            }, content);
        }
        return children(expanded ? nodeList : $3924c9547f0235c0$var$sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
    }, [
        expanded,
        needEllipsis,
        ellipsisCutIndex,
        nodeList
    ].concat((0, $fvBso.default)(miscDeps)));
    // ============================ Render ============================
    const measureStyle = {
        width: width,
        margin: 0,
        padding: 0,
        whiteSpace: parentWhiteSpace === 'nowrap' ? 'normal' : 'inherit'
    };
    return /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, finalContent, needEllipsis === $3924c9547f0235c0$var$STATUS_MEASURE_START && /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, /*#__PURE__*/ $jMaZ8.createElement($3924c9547f0235c0$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $3924c9547f0235c0$var$lineClipStyle), {
            WebkitLineClamp: rows
        }),
        ref: needEllipsisRef
    }, fullContent), /*#__PURE__*/ $jMaZ8.createElement($3924c9547f0235c0$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $3924c9547f0235c0$var$lineClipStyle), {
            WebkitLineClamp: rows - 1
        }),
        ref: descRowsEllipsisRef
    }, fullContent), /*#__PURE__*/ $jMaZ8.createElement($3924c9547f0235c0$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $3924c9547f0235c0$var$lineClipStyle), {
            WebkitLineClamp: 1
        }),
        ref: symbolRowEllipsisRef
    }, children([], true))), needEllipsis === $3924c9547f0235c0$var$STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /*#__PURE__*/ $jMaZ8.createElement($3924c9547f0235c0$var$MeasureText, {
        style: Object.assign(Object.assign({}, measureStyle), {
            top: 400
        }),
        ref: cutMidRef
    }, children($3924c9547f0235c0$var$sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === $3924c9547f0235c0$var$STATUS_MEASURE_PREPARE && /*#__PURE__*/ $jMaZ8.createElement("span", {
        style: {
            whiteSpace: 'inherit'
        },
        ref: measureWhiteSpaceRef
    }));
}



var $jMaZ8 = parcelRequire("jMaZ8");

"use client";
const $dbc2110e91fe17e3$var$EllipsisTooltip = (_ref)=>{
    let { enableEllipsis: enableEllipsis, isEllipsis: isEllipsis, children: children, tooltipProps: tooltipProps } = _ref;
    if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enableEllipsis) return children;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), Object.assign({
        open: isEllipsis ? undefined : false
    }, tooltipProps), children);
};
$dbc2110e91fe17e3$var$EllipsisTooltip.displayName = 'EllipsisTooltip';
var $dbc2110e91fe17e3$export$2e2bcd8739ae039 = $dbc2110e91fe17e3$var$EllipsisTooltip;



"use client";
var $975d4a95dbc2cbd9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $975d4a95dbc2cbd9$var$wrapperDecorations(_ref, content) {
    let { mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic } = _ref;
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $jMaZ8.createElement(tag, {}, currentContent);
    }
    wrap('strong', strong);
    wrap('u', underline);
    wrap('del', del);
    wrap('code', code);
    wrap('mark', mark);
    wrap('kbd', keyboard);
    wrap('i', italic);
    return currentContent;
}
const $975d4a95dbc2cbd9$var$ELLIPSIS_STR = '...';
const $975d4a95dbc2cbd9$var$Base = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, className: className, style: style, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, component: component, title: title } = props, restProps = $975d4a95dbc2cbd9$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "type",
        "disabled",
        "children",
        "ellipsis",
        "editable",
        "copyable",
        "component",
        "title"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const [textLocale] = (0, $e878be222e86ee4b$export$2e2bcd8739ae039)('Text');
    const typographyRef = $jMaZ8.useRef(null);
    const editIconRef = $jMaZ8.useRef(null);
    // ============================ MISC ============================
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    const textProps = (0, $hvG6u.default)(restProps, [
        'mark',
        'code',
        'delete',
        'underline',
        'strong',
        'keyboard',
        'italic'
    ]);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $119801a2f29ddb90$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $eGh7a.default)(false, {
        value: editConfig.editing
    });
    const { triggerType: triggerType = [
        'icon'
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        var _a;
        if (edit) (_a = editConfig.onStart) === null || _a === void 0 || _a.call(editConfig);
        setEditing(edit);
    };
    // Focus edit icon when back
    const prevEditing = (0, $c36d532a0f9cdbb8$export$2e2bcd8739ae039)(editing);
    (0, $jLTp6.default)(()=>{
        var _a;
        if (!editing && prevEditing) (_a = editIconRef.current) === null || _a === void 0 || _a.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e === null || e === void 0 || e.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        var _a;
        (_a = editConfig.onChange) === null || _a === void 0 || _a.call(editConfig, value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        var _a;
        (_a = editConfig.onCancel) === null || _a === void 0 || _a.call(editConfig);
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $119801a2f29ddb90$export$2e2bcd8739ae039)(copyable);
    const { copied: copied, copyLoading: copyLoading, onClick: onCopyClick } = (0, $bbd0c2e0aed23239$export$2e2bcd8739ae039)({
        copyConfig: copyConfig,
        children: children
    });
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $jMaZ8.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $jMaZ8.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $jMaZ8.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $jMaZ8.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $jMaZ8.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $119801a2f29ddb90$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false,
        symbol: (isExpanded)=>isExpanded ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
    });
    const [expanded, setExpanded] = (0, $eGh7a.default)(ellipsisConfig.defaultExpanded || false, {
        value: ellipsisConfig.expanded
    });
    const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === 'collapsible');
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $jMaZ8.useMemo(()=>// Disable ellipsis
        mergedEnableEllipsis && // Provide suffix
        (ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy), [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $jLTp6.default)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $cf512cb263ad7ac0$export$d616d7831008e86c)('webkitLineClamp'));
            setIsTextOverflowSupport((0, $cf512cb263ad7ac0$export$d616d7831008e86c)('textOverflow'));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const [cssEllipsis, setCssEllipsis] = $jMaZ8.useState(mergedEnableEllipsis);
    const canUseCssEllipsis = $jMaZ8.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    // We use effect to change from css ellipsis to js ellipsis.
    // To make SSR still can see the ellipsis.
    (0, $jLTp6.default)(()=>{
        setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
    }, [
        canUseCssEllipsis,
        mergedEnableEllipsis
    ]);
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e, info)=>{
        var _a;
        setExpanded(info.expanded);
        (_a = ellipsisConfig.onExpand) === null || _a === void 0 || _a.call(ellipsisConfig, e, info);
    };
    const [ellipsisWidth, setEllipsisWidth] = $jMaZ8.useState(0);
    const onResize = (_ref2)=>{
        let { offsetWidth: offsetWidth } = _ref2;
        setEllipsisWidth(offsetWidth);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        var _a;
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) (_a = ellipsisConfig.onEllipsis) === null || _a === void 0 || _a.call(ellipsisConfig, jsEllipsis);
    };
    // >>>>> Native ellipsis
    $jMaZ8.useEffect(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && cssEllipsis && textEle) {
            const currentEllipsis = (0, $faa117f60997c90c$export$5714fcf57d9d6988)(textEle);
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        cssEllipsis,
        children,
        cssLineClamp,
        isNativeVisible,
        ellipsisWidth
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $jMaZ8.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === 'undefined' || !textEle || !cssEllipsis || !mergedEnableEllipsis) return;
        /* eslint-disable-next-line compat/compat */ const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        cssEllipsis,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    const tooltipProps = (0, $fe605010d962a9ba$export$2e2bcd8739ae039)(ellipsisConfig.tooltip, editConfig.text, children);
    const topAriaLabel = $jMaZ8.useMemo(()=>{
        if (!enableEllipsis || cssEllipsis) return undefined;
        return [
            editConfig.text,
            children,
            title,
            tooltipProps.title
        ].find((0, $faa117f60997c90c$export$a748c1acb7702f51));
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $jMaZ8.createElement((0, $43e48181c3672947$export$2e2bcd8739ae039), {
        value: (_a = editConfig.text) !== null && _a !== void 0 ? _a : typeof children === 'string' ? children : '',
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        return expandable ? /*#__PURE__*/ $jMaZ8.createElement("button", {
            type: "button",
            key: "expand",
            className: `${prefixCls}-${expanded ? 'collapse' : 'expand'}`,
            onClick: (e)=>onExpandClick(e, {
                    expanded: !expanded
                }),
            "aria-label": expanded ? textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
        }, typeof symbol === 'function' ? symbol(expanded) : symbol) : null;
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip, tabIndex: tabIndex } = editConfig;
        const editTitle = (0, $a6yuN.default)(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
        const ariaLabel = typeof editTitle === 'string' ? editTitle : '';
        return triggerType.includes('icon') ? /*#__PURE__*/ $jMaZ8.createElement((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? '' : editTitle
        }, /*#__PURE__*/ $jMaZ8.createElement("button", {
            type: "button",
            ref: editIconRef,
            className: `${prefixCls}-edit`,
            onClick: onEditClick,
            "aria-label": ariaLabel,
            tabIndex: tabIndex
        }, icon || /*#__PURE__*/ $jMaZ8.createElement((0, $5453b18558c87ec6$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return null;
        return /*#__PURE__*/ $jMaZ8.createElement((0, $ffcc6c22ad40b4fb$export$2e2bcd8739ae039), Object.assign({
            key: "copy"
        }, copyConfig, {
            prefixCls: prefixCls,
            copied: copied,
            locale: textLocale,
            onCopy: onCopyClick,
            loading: copyLoading,
            iconOnly: children === null || children === undefined
        }));
    };
    const renderOperations = (canEllipsis)=>[
            canEllipsis && renderExpand(),
            renderEdit(),
            renderCopy()
        ];
    const renderEllipsis = (canEllipsis)=>[
            canEllipsis && !expanded && /*#__PURE__*/ $jMaZ8.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $975d4a95dbc2cbd9$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(canEllipsis)
        ];
    return /*#__PURE__*/ $jMaZ8.createElement((0, $bAXx0.default), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $jMaZ8.createElement((0, $dbc2110e91fe17e3$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enableEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis
        }, /*#__PURE__*/ $jMaZ8.createElement((0, $ee2753f92a8062af$export$2e2bcd8739ae039), Object.assign({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
            }, className),
            prefixCls: customizePrefixCls,
            style: Object.assign(Object.assign({}, style), {
                WebkitLineClamp: cssLineClamp ? rows : undefined
            }),
            component: component,
            ref: (0, $1cfGC.composeRef)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes('text') ? onEditClick : undefined,
            "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
            title: title
        }, textProps), /*#__PURE__*/ $jMaZ8.createElement((0, $3924c9547f0235c0$export$2e2bcd8739ae039), {
            enableMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            onEllipsis: onJsEllipsis,
            expanded: expanded,
            miscDeps: [
                copied,
                expanded,
                copyLoading,
                enableEdit,
                enableCopy,
                textLocale
            ]
        }, (node, canEllipsis)=>$975d4a95dbc2cbd9$var$wrapperDecorations(props, /*#__PURE__*/ $jMaZ8.createElement($jMaZ8.Fragment, null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? /*#__PURE__*/ $jMaZ8.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, node) : node, renderEllipsis(canEllipsis)))))));
});
var $975d4a95dbc2cbd9$export$2e2bcd8739ae039 = $975d4a95dbc2cbd9$var$Base;


"use client";
var $c86757dd0b8c7596$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c86757dd0b8c7596$var$Link = /*#__PURE__*/ $jMaZ8.forwardRef((_a, ref)=>{
    var { ellipsis: ellipsis, rel: rel } = _a, restProps = $c86757dd0b8c7596$var$__rest(_a, [
        "ellipsis",
        "rel"
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Typography.Link');
        warning(typeof ellipsis !== 'object', 'usage', '`ellipsis` only supports boolean value.');
    }
    const mergedProps = Object.assign(Object.assign({}, restProps), {
        rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel
    });
    // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    delete mergedProps.navigate;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $975d4a95dbc2cbd9$export$2e2bcd8739ae039), Object.assign({}, mergedProps, {
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }));
});
var $c86757dd0b8c7596$export$2e2bcd8739ae039 = $c86757dd0b8c7596$var$Link;



var $jMaZ8 = parcelRequire("jMaZ8");

"use client";
const $104073fa5f465db5$var$Paragraph = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>/*#__PURE__*/ $jMaZ8.createElement((0, $975d4a95dbc2cbd9$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, props, {
        component: "div"
    })));
var $104073fa5f465db5$export$2e2bcd8739ae039 = $104073fa5f465db5$var$Paragraph;



var $jMaZ8 = parcelRequire("jMaZ8");

var $hvG6u = parcelRequire("hvG6u");


"use client";
var $86f7dad6d8478b1e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $86f7dad6d8478b1e$var$Text = (_a, ref)=>{
    var { ellipsis: ellipsis } = _a, restProps = $86f7dad6d8478b1e$var$__rest(_a, [
        "ellipsis"
    ]);
    const mergedEllipsis = $jMaZ8.useMemo(()=>{
        if (ellipsis && typeof ellipsis === 'object') return (0, $hvG6u.default)(ellipsis, [
            'expandable',
            'rows'
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Typography.Text');
        warning(typeof ellipsis !== 'object' || !ellipsis || !('expandable' in ellipsis) && !('rows' in ellipsis), 'usage', '`ellipsis` do not support `expandable` or `rows` props.');
    }
    return /*#__PURE__*/ $jMaZ8.createElement((0, $975d4a95dbc2cbd9$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        ellipsis: mergedEllipsis,
        component: "span"
    }));
};
var $86f7dad6d8478b1e$export$2e2bcd8739ae039 = /*#__PURE__*/ $jMaZ8.forwardRef($86f7dad6d8478b1e$var$Text);



var $jMaZ8 = parcelRequire("jMaZ8");


"use client";
var $9dd934104d61bf3f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9dd934104d61bf3f$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $9dd934104d61bf3f$var$Title = /*#__PURE__*/ $jMaZ8.forwardRef((props, ref)=>{
    const { level: level = 1 } = props, restProps = $9dd934104d61bf3f$var$__rest(props, [
        "level"
    ]);
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Typography.Title');
        warning($9dd934104d61bf3f$var$TITLE_ELE_LIST.includes(level), 'usage', 'Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.');
    }
    const component = $9dd934104d61bf3f$var$TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
    return /*#__PURE__*/ $jMaZ8.createElement((0, $975d4a95dbc2cbd9$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        component: component
    }));
});
var $9dd934104d61bf3f$export$2e2bcd8739ae039 = $9dd934104d61bf3f$var$Title;



"use client";
const $862be0e46f705052$var$Typography = (0, $ee2753f92a8062af$export$2e2bcd8739ae039);
$862be0e46f705052$var$Typography.Text = (0, $86f7dad6d8478b1e$export$2e2bcd8739ae039);
$862be0e46f705052$var$Typography.Link = (0, $c86757dd0b8c7596$export$2e2bcd8739ae039);
$862be0e46f705052$var$Typography.Title = (0, $9dd934104d61bf3f$export$2e2bcd8739ae039);
$862be0e46f705052$var$Typography.Paragraph = (0, $104073fa5f465db5$export$2e2bcd8739ae039);
var $862be0e46f705052$export$2e2bcd8739ae039 = $862be0e46f705052$var$Typography;



var $jMaZ8 = parcelRequire("jMaZ8");

function $1dace08efa18ba3d$var$selectedClasses(selection, metadata) {
    const end = selection.start + selection.size;
    const ranges = [];
    for (const item of metadata){
        // CSS rendering currently uses the first anchor of each metadata item.
        const anchor = item.anchors[0];
        if (!anchor) continue;
        const start = Math.max(selection.start, anchor.utf16Start);
        const rangeEnd = Math.min(end, anchor.utf16Start + anchor.utf16Size);
        if (start < rangeEnd) ranges.push({
            start: start,
            end: rangeEnd,
            value: item.data.customCssClasses || ""
        });
    }
    const boundaries = [
        ...new Set([
            selection.start,
            end,
            ...ranges.flatMap((range)=>[
                    range.start,
                    range.end
                ])
        ])
    ].sort((a, b)=>a - b);
    // Match the renderer's first-annotation precedence, including unannotated gaps.
    return new Set(boundaries.slice(0, -1).map((start)=>ranges.find((range)=>range.start <= start && start < range.end)?.value || ""));
}
const $1dace08efa18ba3d$export$ecd86f294f437206 = (selection, metadata)=>$1dace08efa18ba3d$var$selectedClasses(selection, metadata).size > 1;
const $1dace08efa18ba3d$export$e2cb4ec37ba0f94c = (selection, metadata = [])=>{
    const classes = $1dace08efa18ba3d$var$selectedClasses(selection, metadata);
    return classes.size === 1 ? classes.values().next().value || "" : "";
};



const $0e06fc3a26947244$export$33ffd74ebf07f060 = ({ setVisibility: setVisibility, selectedTextPosition: selectedTextPosition = {
    start: 0,
    size: 0
}, classesMetadata: classesMetadata, projectId: projectId, stringVersion: stringVersion })=>{
    /**
   * State
   */ const [value, setValue] = (0, $jMaZ8.useState)(()=>(0, $1dace08efa18ba3d$export$e2cb4ec37ba0f94c)(selectedTextPosition, classesMetadata));
    const isOverrideWarning = (0, $1dace08efa18ba3d$export$ecd86f294f437206)(selectedTextPosition, classesMetadata);
    const pending = (0, $jMaZ8.useRef)(false);
    const mounted = (0, $jMaZ8.useRef)(true);
    (0, $jMaZ8.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const strings = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.formatting.modalCustomCss");
    /**
   * Methods
   */ const close = (0, $jMaZ8.useCallback)(()=>setVisibility(false), [
        setVisibility
    ]);
    /**
   * Requests
   */ const [applyCreateCssFromPosition, { loading: createCssLoading, error: error }] = (0, $ad0ed8da91693c22$export$a3f78d789c52e062)();
    /**
   * Handlers
   */ const onChange = (0, $jMaZ8.useCallback)((event)=>{
        // @ts-ignore // TODO LOIC CHECK
        setValue(event.target.value);
    }, []);
    const onCancel = (0, $jMaZ8.useCallback)(()=>{
        close();
        setValue("");
    }, [
        close
    ]);
    const onOk = (0, $jMaZ8.useCallback)(async ()=>{
        if (pending.current) return;
        pending.current = true;
        try {
            await applyCreateCssFromPosition({
                variables: {
                    projectId: projectId,
                    start: selectedTextPosition.start,
                    size: selectedTextPosition.size,
                    stringVersion: stringVersion,
                    newCss: {
                        customCssClasses: value?.trim()
                    }
                }
            });
            if (mounted.current) close();
        } catch  {
            // Apollo exposes the error below; keep this draft open for retry.
            return;
        } finally{
            pending.current = false;
        }
    }, [
        applyCreateCssFromPosition,
        projectId,
        selectedTextPosition.start,
        selectedTextPosition.size,
        stringVersion,
        value,
        close
    ]);
    return {
        inputValue: value,
        onInputChange: onChange,
        onOk: onOk,
        onCancel: onCancel,
        strings: strings,
        isOverrideWarning: isOverrideWarning,
        loading: createCssLoading,
        error: error?.message
    };
};


const { Text: $cac470ecf076c60f$var$Text } = (0, $862be0e46f705052$export$2e2bcd8739ae039);
const $cac470ecf076c60f$var$CustomClassesDraft = ({ setVisibility: setVisibility, selectedTextPosition: selectedTextPosition, classesMetadata: classesMetadata, projectId: projectId, stringVersion: stringVersion })=>{
    const { inputValue: inputValue, onInputChange: onInputChange, onOk: onOk, onCancel: onCancel, strings: strings, isOverrideWarning: isOverrideWarning, loading: loading, error: error } = (0, $0e06fc3a26947244$export$33ffd74ebf07f060)({
        setVisibility: setVisibility,
        selectedTextPosition: selectedTextPosition,
        classesMetadata: classesMetadata,
        projectId: projectId,
        stringVersion: stringVersion
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
        open: true,
        onCancel: onCancel,
        onOk: onOk,
        title: strings.title,
        okText: strings.modalOkLabel,
        okButtonProps: {
            disabled: loading
        },
        children: [
            error && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                role: "alert",
                children: error
            }),
            isOverrideWarning && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($cac470ecf076c60f$var$Text, {
                        type: "warning",
                        strong: false,
                        style: {
                            fontWeight: 400
                        },
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                            children: strings.ovverideWarning
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                value: inputValue,
                onChange: onInputChange,
                onPressEnter: (event)=>{
                    if (!event.nativeEvent.isComposing) onOk();
                },
                placeholder: strings.inputPlaceholder,
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true
            })
        ]
    });
};
function $cac470ecf076c60f$export$2e2bcd8739ae039(props) {
    return props.isVisible ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($cac470ecf076c60f$var$CustomClassesDraft, {
        ...props
    }, `${props.projectId}:${props.selectedTextPosition.start}:${props.selectedTextPosition.size}`) : null;
}





const $f89a9e4a59b8b9a2$var$ActionMenu = ({ projectId: projectId, textContent: textContent, page: page, pageMetadata: pageMetadata, selectedRhesesIds: selectedRhesesIds, selectedTextPosition: selectedTextPosition, createParagraph: createParagraph, addSeparator: addSeparator, setLineBreakAfterRhese: setLineBreakAfterRhese, setSelectedRhesesContent: setSelectedRhesesContent, setIsSegmentationHovered: setIsSegmentationHovered, applySetNonbreakingSpace: applySetNonbreakingSpace, setDropdownVisibleChange: setDropdownVisibleChange })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const { data: projectsData } = (0, $d7188398173686a1$export$6ed06f11bf137590)({
        id: projectId,
        withInfo: false,
        withAudioInfo: false
    });
    const paragraphTags = (0, $jMaZ8.useMemo)(()=>{
        if (projectsData === undefined) return [];
        const project = projectsData.project.find((p)=>p.id === projectId);
        return project?.paragraphTags || [];
    }, [
        projectsData,
        projectId
    ]);
    const [applyCreateParagraphFromPosition] = (0, $e2392b9a58ad59e5$export$7837f15a2af453fd)();
    // const [applyCreateCssFromPosition] = useCreateCssFromPosition();
    const [applyDeleteCssFromPosition] = (0, $ad0ed8da91693c22$export$c78059e5858d0847)();
    const [removeClassesLoading, setRemoveClassesLoading] = (0, $jMaZ8.useState)(false);
    const disabledIfSeveralRheses = selectedRhesesIds.length !== 1;
    const selectedRheseId = selectedRhesesIds[0];
    const selectedRhese = pageMetadata.rhese.find(({ data: { id: id } })=>id === selectedRheseId);
    const selectedText = textContent.substring(selectedTextPosition.start - page.start, selectedTextPosition.start - page.start + selectedTextPosition.size);
    const isOnlyOneLetterSelected = selectedTextPosition.size === 1;
    const isSpace = selectedText === " ";
    const isNonbreakingSpace = selectedText === "\xa0";
    const selectedParagraphs = {
        starting: [],
        ending: [],
        included: [],
        wrapping: []
    };
    const paragraphsTagIds = [];
    pageMetadata.paragraph.map((p)=>{
        // If paragraph is wrapping the selection
        if (p.anchors[0].utf16Start <= selectedTextPosition.start && p.anchors[0].utf16Start + p.anchors[0].utf16Size >= selectedTextPosition.start + selectedTextPosition.size) {
            selectedParagraphs.wrapping.push(p);
            if (p.data.tag) paragraphsTagIds.push(p.data.tag);
        }
        if (p.anchors[0].utf16Start >= selectedTextPosition.start && p.anchors[0].utf16Start <= selectedTextPosition.start + selectedTextPosition.size) {
            // paragraph starts in selection
            if (p.anchors[0].utf16Start + p.anchors[0].utf16Size >= selectedTextPosition.start && p.anchors[0].utf16Start + p.anchors[0].utf16Size <= selectedTextPosition.start + selectedTextPosition.size) {
                // paragraph ends in selection
                selectedParagraphs.included.push(p);
                if (p.data.tag) paragraphsTagIds.push(p.data.tag);
            } else {
                // paragraph ends after selection
                selectedParagraphs.starting.push(p);
                if (p.data.tag) paragraphsTagIds.push(p.data.tag);
            }
        } else // paragraph starts before selection
        if (p.anchors[0].utf16Start + p.anchors[0].utf16Size >= selectedTextPosition.start && p.anchors[0].utf16Start + p.anchors[0].utf16Size <= selectedTextPosition.start + selectedTextPosition.size) {
            // paragraph ends in selection
            selectedParagraphs.ending.push(p);
            if (p.data.tag) paragraphsTagIds.push(p.data.tag);
        }
    });
    const paragraphTagId = paragraphsTagIds?.length === 1 ? paragraphsTagIds[0] : undefined;
    const menuTranslation = (0, $19ed0b6abada9941$export$a6484047d53fa2be)("project.existing.editingMode.formatting.menu");
    const closeDropdown = (0, $jMaZ8.useCallback)(()=>setDropdownVisibleChange(false), [
        setDropdownVisibleChange
    ]);
    const onAddClassesActionClick = (0, $jMaZ8.useCallback)(()=>{
        closeDropdown();
        setCustomClassesActionVisible(true);
    }, [
        closeDropdown
    ]);
    const onRemoveClassesActionClick = (0, $jMaZ8.useCallback)(async ()=>{
        setRemoveClassesLoading(true);
        try {
            await applyDeleteCssFromPosition({
                variables: {
                    projectId: projectId,
                    stringVersion: page.stringVersion,
                    size: selectedTextPosition.size,
                    start: selectedTextPosition.start
                }
            });
        } finally{
            setRemoveClassesLoading(false);
        }
    }, [
        applyDeleteCssFromPosition,
        selectedTextPosition,
        projectId,
        page,
        setRemoveClassesLoading
    ]);
    const [customClassesActionVisible, setCustomClassesActionVisible] = (0, $jMaZ8.useState)(false);
    const items = (0, $jMaZ8.useMemo)(()=>{
        return [
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "s1",
                label: menuTranslation.subMenuTitleTransformsTitle,
                disabled: selectedTextPosition.size === 0,
                children: [
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "1-1",
                        label: menuTranslation.titre_1,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).TITRE_1, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "1-2",
                        label: menuTranslation.titre_2,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).TITRE_2, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "1-3",
                        label: menuTranslation.titre_3,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).TITRE_3, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "1-4",
                        label: menuTranslation.titre_4,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).TITRE_4, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "1-5",
                        label: menuTranslation.titre_5,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).TITRE_5, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "1-6",
                        label: menuTranslation.titre_6,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).TITRE_6, paragraphTagId);
                            closeDropdown();
                        }
                    })
                ]
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "s2",
                label: menuTranslation.subMenuTitleAlign,
                disabled: selectedTextPosition.size === 0,
                children: [
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "2-1",
                        label: menuTranslation.space,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).ESPACE, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "2-2",
                        label: menuTranslation.center,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).CENTRE, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "2-3",
                        label: menuTranslation.right,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).DROITE, paragraphTagId);
                            closeDropdown();
                        }
                    })
                ]
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "s3",
                label: menuTranslation.subMenuTitleTransformsParagraph,
                disabled: selectedTextPosition.size === 0,
                children: [
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "3-1",
                        label: menuTranslation.normal,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).NORMAL, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "3-2",
                        label: menuTranslation.dialogue,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).DIALOGUE, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "3-3",
                        label: menuTranslation.intro,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).INTRO, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "3-4",
                        label: menuTranslation.resume,
                        onClick: ()=>{
                            createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).RESUME, paragraphTagId);
                            closeDropdown();
                        }
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "3-s4",
                        label: menuTranslation.subMenuList,
                        disabled: selectedTextPosition.size === 0,
                        children: [
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s4-1",
                                label: menuTranslation.listUnordered,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).LIST_UNORDERED, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s4-2",
                                label: menuTranslation.listOrdered,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).LIST_ORDERED, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s4-3",
                                label: menuTranslation.listDefinition,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).LIST_DEFINITION, paragraphTagId);
                                    closeDropdown();
                                }
                            })
                        ]
                    }),
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "3-s5",
                        label: menuTranslation.subMenuTitleException,
                        disabled: selectedTextPosition.size === 0,
                        children: [
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-1",
                                label: menuTranslation.email,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).EMAIL, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-2",
                                label: menuTranslation.citation,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).CITATION, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-3",
                                label: menuTranslation.vers,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).VERS, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-4",
                                label: menuTranslation.bold,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).GRAS, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-5",
                                label: menuTranslation.text,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).TEXTO, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-6",
                                label: menuTranslation.didascalie,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).DIDASCALIE, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-7",
                                label: menuTranslation.mail,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).COURRIER, paragraphTagId);
                                    closeDropdown();
                                }
                            }),
                            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                                key: "3-s5-8",
                                label: menuTranslation.note,
                                onClick: ()=>{
                                    createParagraph((0, $b522cf181e75e62d$export$e5be9b5f8a520e95).NOTE, paragraphTagId);
                                    closeDropdown();
                                }
                            })
                        ]
                    })
                ]
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "s4",
                label: menuTranslation.rheseAction,
                disabled: disabledIfSeveralRheses,
                onMouseEnter: ()=>setIsSegmentationHovered(true),
                onMouseLeave: ()=>setIsSegmentationHovered(false),
                onClick: ()=>{
                    const rheseId = selectedRhesesIds[0];
                    addSeparator(rheseId);
                    closeDropdown();
                }
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "addClasses",
                label: menuTranslation.addClassesAction,
                disabled: !selectedRhese && !selectedTextPosition.size,
                onClick: onAddClassesActionClick
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "removeClasses",
                label: removeClassesLoading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                    small: true,
                    style: {
                        justifyContent: "flex-start",
                        marginTop: "0.8em"
                    }
                }) : menuTranslation.removeClassesAction,
                disabled: !selectedRhese && !selectedTextPosition.size,
                onClick: onRemoveClassesActionClick
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "7",
                label: isSpace ? `${menuTranslation.spaceAction.unbreakable}` : `${menuTranslation.spaceAction.normal}`,
                disabled: !isOnlyOneLetterSelected || !isSpace && !isNonbreakingSpace,
                onClick: ()=>{
                    if (selectedTextPosition.size === 1) {
                        applySetNonbreakingSpace(isSpace);
                        closeDropdown();
                    }
                }
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "8",
                label: selectedRhese?.data.lineBreakAfter ? `${menuTranslation?.lineSuppression?.normal}` : `${menuTranslation?.lineSuppression?.afterRhese}`,
                disabled: disabledIfSeveralRheses || !selectedRhese,
                onClick: ()=>{
                    if (selectedRhese) {
                        setLineBreakAfterRhese(selectedRhese, !selectedRhese.data.lineBreakAfter);
                        closeDropdown();
                    }
                }
            }),
            (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                key: "s9",
                label: t("tagTheParagraph"),
                disabled: !selectedRhese && !selectedTextPosition.size,
                children: [
                    (0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                        key: "remove",
                        label: t("removeTagFromParagraph"),
                        disabled: !(paragraphsTagIds.length === 1),
                        onClick: ()=>{
                            const selectedParagraph = selectedParagraphs.wrapping[0] || selectedParagraphs.included[0];
                            applyCreateParagraphFromPosition({
                                variables: {
                                    stringVersion: page.stringVersion,
                                    projectId: projectId,
                                    size: selectedParagraph.anchors[0].utf16Size,
                                    start: selectedParagraph.anchors[0].utf16Start,
                                    kind: selectedParagraph.data.kind
                                }
                            });
                            closeDropdown();
                        }
                    }),
                    ...[
                        ...paragraphTags
                    ].sort((a, b)=>a.createdAt - b.createdAt).map((tag)=>(0, $eee5699dd95ae9ac$export$b9a8494deef5900b)({
                            key: tag?.id,
                            label: tag?.name,
                            onClick: ()=>{
                                const selectedParagraph = selectedParagraphs.wrapping[0] || selectedParagraphs.included[0];
                                applyCreateParagraphFromPosition({
                                    variables: {
                                        stringVersion: page.stringVersion,
                                        projectId: projectId,
                                        size: selectedParagraph.anchors[0].utf16Size,
                                        start: selectedParagraph.anchors[0].utf16Start,
                                        kind: selectedParagraph.data.kind,
                                        paragraphTagId: tag?.id
                                    }
                                });
                                closeDropdown();
                            }
                        }))
                ]
            })
        ];
    }, [
        menuTranslation.subMenuTitleTransformsTitle,
        menuTranslation.titre_1,
        menuTranslation.titre_2,
        menuTranslation.titre_3,
        menuTranslation.titre_4,
        menuTranslation.titre_5,
        menuTranslation.titre_6,
        menuTranslation.subMenuTitleAlign,
        menuTranslation.space,
        menuTranslation.center,
        menuTranslation.right,
        menuTranslation.subMenuTitleTransformsParagraph,
        menuTranslation.normal,
        menuTranslation.dialogue,
        menuTranslation.intro,
        menuTranslation.resume,
        menuTranslation.subMenuList,
        menuTranslation.listUnordered,
        menuTranslation.listOrdered,
        menuTranslation.listDefinition,
        menuTranslation.subMenuTitleException,
        menuTranslation.email,
        menuTranslation.citation,
        menuTranslation.vers,
        menuTranslation.bold,
        menuTranslation.text,
        menuTranslation.didascalie,
        menuTranslation.mail,
        menuTranslation.note,
        menuTranslation.rheseAction,
        menuTranslation.addClassesAction,
        menuTranslation.removeClassesAction,
        menuTranslation.spaceAction.unbreakable,
        menuTranslation.spaceAction.normal,
        menuTranslation?.lineSuppression?.normal,
        menuTranslation?.lineSuppression?.afterRhese,
        selectedTextPosition.size,
        disabledIfSeveralRheses,
        selectedRhese,
        onAddClassesActionClick,
        removeClassesLoading,
        onRemoveClassesActionClick,
        isSpace,
        isOnlyOneLetterSelected,
        isNonbreakingSpace,
        t,
        paragraphsTagIds.length,
        paragraphTags,
        createParagraph,
        paragraphTagId,
        closeDropdown,
        setIsSegmentationHovered,
        selectedRhesesIds,
        addSeparator,
        page.pageNumber,
        page.stringVersion,
        applySetNonbreakingSpace,
        setLineBreakAfterRhese,
        selectedParagraphs.wrapping,
        selectedParagraphs.included,
        applyCreateParagraphFromPosition,
        projectId
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1417d0c85becb5c$export$2e2bcd8739ae039), {
                onClick: ()=>setSelectedRhesesContent([]),
                selectable: false,
                items: items
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $cac470ecf076c60f$export$2e2bcd8739ae039), {
                isVisible: customClassesActionVisible,
                setVisibility: setCustomClassesActionVisible,
                selectedTextPosition: selectedTextPosition,
                projectId: projectId,
                classesMetadata: pageMetadata.customCss,
                stringVersion: page.stringVersion
            })
        ]
    });
};
var $f89a9e4a59b8b9a2$export$2e2bcd8739ae039 = $f89a9e4a59b8b9a2$var$ActionMenu;





const $dc1e310e25673e39$export$14af8e7fc017bb56 = ({ isDraggingImage: isDraggingImage, setLineBreakAfterRhese: setLineBreakAfterRhese, setTargetParagraph: setTargetParagraph, setPosition: setPosition, onTextSelectionChange: onTextSelectionChange, projectId: projectId, speakers: speakers, allPages: allPages })=>{
    const [applyCreatePage] = (0, $8933335d77e3c41a$export$53b07caf7d6ad3c4)();
    const [applyUpdatePage] = (0, $8933335d77e3c41a$export$8505a611e1f1e0e1)();
    const [applyCreateParagraphFromPosition] = (0, $e2392b9a58ad59e5$export$7837f15a2af453fd)();
    const [applyUpdateTextContent] = (0, $d7188398173686a1$export$36fbd2350d26e8f6)();
    const updateDisplayedPageNumber = (0, $5b38bec19e3a4e47$export$81b3a8efdffa1495)();
    const { beginNavigation: beginNavigation } = (0, $e7692b166c91b9dc$export$fcd3a1f8b6eba71f)();
    const { page: page, pageMetadata: pageMetadata } = (0, $9a1b5d9b85264433$export$2ff026368446039c)(allPages);
    const rheses = pageMetadata?.rhese;
    const paragraphs = pageMetadata?.paragraph;
    const createPage = (0, $jMaZ8.useCallback)(async (lastRheseId)=>{
        const rhese = pageMetadata.rhese.find((r)=>r.data.id === lastRheseId);
        if (!rhese) return;
        const currentPage = allPages.find((page)=>page.id === pageMetadata.page.data.id);
        if (!currentPage) throw new Error("Could not retrieve current page in pages list");
        const start = rhese.anchors[0].utf16Start + rhese.anchors[0].utf16Size;
        const end = pageMetadata.page.anchors[0].utf16Start + pageMetadata.page.anchors[0].utf16Size;
        const size = end - start;
        const stringVersion = pageMetadata.page.anchors[0].stringVersion;
        // Reserve intent before the mutation; a later navigation cancels completion.
        const navigateToCreatedPage = beginNavigation();
        // Creating a new page after the current one
        const result = await applyCreatePage({
            variables: {
                projectId: projectId,
                stringVersion: stringVersion,
                start: start,
                size: size,
                partname: "",
                mutePagesAfter: currentPage.mutePagesAfter
            }
        });
        if (!result.data?.createPageFromPosition) return;
        // Update the current page to remove the mutePagesAfter (it has been moved to the new page)
        await applyUpdatePage({
            variables: {
                projectId: projectId,
                pageId: pageMetadata.page.data.id,
                mutePagesAfter: 0,
                partname: currentPage.partName || ""
            }
        });
        navigateToCreatedPage({
            start: start,
            stringVersion: stringVersion
        });
    }, [
        beginNavigation,
        allPages,
        applyCreatePage,
        applyUpdatePage,
        pageMetadata?.page.anchors,
        pageMetadata?.page.data.id,
        pageMetadata?.rhese,
        projectId
    ]);
    const [applyDeleteImage] = (0, $d7188398173686a1$export$5b3f3a485ee1a285)();
    const [form] = (0, $c0d3168732410fde$export$2e2bcd8739ae039).useForm();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const ref = (0, $jMaZ8.useRef)(null);
    const [isEditingDialogueSpeaker, setIsEditingDialogueSpeaker] = (0, $jMaZ8.useState)(false);
    const [isEditingImage, setIsEditingImage] = (0, $jMaZ8.useState)({
        open: false
    });
    const deleteImage = (0, $jMaZ8.useCallback)((imageId)=>applyDeleteImage({
            variables: {
                imageId: imageId,
                projectId: projectId
            }
        }), [
        applyDeleteImage,
        projectId
    ]);
    const contentEditableRef = (0, $jMaZ8.useRef)(null);
    const RenderBook = (0, $jMaZ8.useMemo)(()=>(0, $d0ce5078a897d2dc$export$2e2bcd8739ae039)(), []);
    const [selectedRhesesContent, setSelectedRhesesContent] = (0, $jMaZ8.useState)([]);
    const [selectedTextPosition, setSelectedTextPosition] = (0, $jMaZ8.useState)({
        start: 0,
        size: 0
    });
    const [isSegmentationHovered, setIsSegmentationHovered] = (0, $jMaZ8.useState)(false);
    const selectedRhesesIds = (0, $jMaZ8.useMemo)(()=>selectedRhesesContent.map(({ rheseId: rheseId })=>rheseId), [
        selectedRhesesContent
    ]);
    const latestPage = (0, $jMaZ8.useRef)(pageMetadata);
    (0, $jMaZ8.useLayoutEffect)(()=>{
        latestPage.current = pageMetadata;
    }, [
        pageMetadata
    ]);
    const getPageMetadata = (0, $jMaZ8.useCallback)(()=>latestPage.current, []);
    const updateSelectedTextPosition = (0, $jMaZ8.useCallback)((position)=>{
        setSelectedTextPosition(position);
        onTextSelectionChange(position, getPageMetadata);
    }, [
        onTextSelectionChange,
        getPageMetadata
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        const noop = (e)=>{
            e.preventDefault();
            return false;
        };
        const ref = contentEditableRef.current;
        ref?.addEventListener("cut", noop, false);
        ref?.addEventListener("paste", noop, false);
        ref?.addEventListener("keydown", noop, false);
        ref?.addEventListener("dragenter", noop, false);
        ref?.addEventListener("dragleave", noop, false);
        ref?.addEventListener("dragover", noop, false);
        ref?.addEventListener("drop", noop, false);
        return ()=>{
            ref?.removeEventListener("cut", noop);
            ref?.removeEventListener("paste", noop);
            ref?.removeEventListener("keydown", noop);
            ref?.removeEventListener("dragenter", noop);
            ref?.removeEventListener("dragleave", noop);
            ref?.removeEventListener("dragover", noop);
            ref?.removeEventListener("drop", noop);
        };
    }, [
        contentEditableRef
    ]);
    const resetWindowSelection = (0, $jMaZ8.useCallback)(()=>{
        window.getSelection()?.removeAllRanges();
        updateSelectedTextPosition({
            start: 0,
            size: 0
        });
    }, [
        updateSelectedTextPosition
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (selectedRhesesIds.length > 1) resetWindowSelection();
    }, [
        resetWindowSelection,
        selectedRhesesIds
    ]);
    const saveSelection = (0, $jMaZ8.useCallback)((ev)=>{
        // Replace url pageNumber to the one of the selection
        if (pageMetadata.page.data.pageNumber.pageNumber !== parseInt(new URLSearchParams(window.location.search).get("displayedPageNumber") || "")) updateDisplayedPageNumber(pageMetadata.page.data.pageNumber.pageNumber.toString());
        if (ev.target instanceof HTMLElement && !ref.current?.contains(ev.target)) return;
        const isRightClick = ev.nativeEvent instanceof MouseEvent && ev.nativeEvent.button;
        if (isRightClick === 2) return;
        const selection = window.getSelection();
        if (!selection) return resetWindowSelection();
        let { focusNode: focusNode } = selection;
        const endingRhese = focusNode?.parentElement?.closest(".rhese");
        // If the selection is made by a click on a rhese, select the rhese
        if (selection.getRangeAt(0).toString() === "" && selection?.toString() !== "\xa0" && endingRhese instanceof HTMLElement && endingRhese.dataset.id) {
            const rheseData = rheses.find(({ data: { id: id } })=>id === endingRhese?.getAttribute("data-id"));
            if (!rheseData) return;
            updateSelectedTextPosition({
                start: rheseData?.anchors[0].utf16Start,
                size: rheseData?.anchors[0].utf16Size
            });
            return setSelectedRhesesContent([
                {
                    rheseId: endingRhese.dataset.id,
                    lettersId: []
                }
            ]);
        }
        if (selection.toString().length === 0) {
            updateSelectedTextPosition({
                start: (0, $75cb39c0d60bf319$export$dfe068021b69e8a4)(focusNode) ?? 0,
                size: 0
            });
            if (endingRhese instanceof HTMLElement && endingRhese.dataset.id) setSelectedRhesesContent([
                {
                    rheseId: endingRhese.dataset.id,
                    lettersId: []
                }
            ]);
            return;
        }
        const pageLetters = focusNode?.parentElement?.closest('[id^="page-"]')?.querySelectorAll(".letter,.ponctuation");
        if (!pageLetters) return resetWindowSelection();
        const selectedLetters = [];
        for (const letter of pageLetters){
            if (!selection.containsNode(letter.childNodes[0] || letter, false)) continue;
            const position = (0, $75cb39c0d60bf319$export$dfe068021b69e8a4)(letter);
            if (position === undefined) throw new Error("Selected letter has no text position");
            selectedLetters.push(position);
        }
        selectedLetters.sort((a, b)=>a - b);
        if (selectedLetters.length === 0) {
            updateSelectedTextPosition({
                start: (0, $75cb39c0d60bf319$export$dfe068021b69e8a4)(focusNode) ?? 0,
                size: 0
            });
            return;
        }
        const selectedPosition = {
            start: selectedLetters[0],
            size: selectedLetters[selectedLetters.length - 1] - selectedLetters[0] + 1
        };
        updateSelectedTextPosition(selectedPosition);
        setSelectedRhesesContent((previous)=>previous.length ? [] : previous);
    }, [
        pageMetadata?.page.data.pageNumber.pageNumber,
        resetWindowSelection,
        rheses,
        updateSelectedTextPosition,
        updateDisplayedPageNumber
    ]);
    (0, $jMaZ8.useEffect)(()=>form.resetFields(), [
        form,
        isEditingImage
    ]);
    const [dropdownVisible, setDropdownVisibleChange] = (0, $jMaZ8.useState)(false);
    const createParagraph = (0, $jMaZ8.useCallback)(async (kind, tag)=>{
        // Get the start of the rheses that include the selection start
        const startingRhese = rheses.find(({ anchors: anchors })=>anchors[0].utf16Start <= selectedTextPosition.start && anchors[0].utf16Start + anchors[0].utf16Size > selectedTextPosition.start);
        if (!startingRhese) return;
        // Get the end of the rheses that include the selection end
        const endingRhese = rheses.find(({ anchors: anchors })=>anchors[0].utf16Start < selectedTextPosition.start + selectedTextPosition.size && anchors[0].utf16Start + anchors[0].utf16Size >= selectedTextPosition.start + selectedTextPosition.size);
        if (!endingRhese) return;
        const fullSize = endingRhese.anchors[0].utf16Start + endingRhese.anchors[0].utf16Size - startingRhese.anchors[0].utf16Start;
        await applyCreateParagraphFromPosition({
            variables: {
                projectId: projectId,
                stringVersion: pageMetadata.page.anchors[0].stringVersion,
                start: startingRhese.anchors[0].utf16Start,
                size: fullSize,
                kind: kind,
                ...tag?.id ? {
                    paragraphTagId: tag?.id
                } : {}
            }
        });
    }, [
        applyCreateParagraphFromPosition,
        pageMetadata?.page.anchors,
        projectId,
        rheses,
        selectedTextPosition.size,
        selectedTextPosition.start
    ]);
    const handleNonBreakingSpace = (0, $jMaZ8.useCallback)(async (isNonBreakingSpace)=>{
        const operations = [
            {
                delete: {
                    utf16Start: selectedTextPosition.start,
                    utf16Size: 1
                }
            },
            {
                insert: {
                    utf16Start: selectedTextPosition.start,
                    text: isNonBreakingSpace ? "\xa0" : " "
                }
            }
        ];
        await applyUpdateTextContent({
            variables: {
                projectId: projectId,
                stringVersion: pageMetadata.page.anchors[0].stringVersion,
                operations: operations
            }
        });
    }, [
        applyUpdateTextContent,
        pageMetadata?.page.anchors,
        projectId,
        selectedTextPosition.start
    ]);
    const renderDropdownContent = (0, $jMaZ8.useCallback)(()=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f89a9e4a59b8b9a2$export$2e2bcd8739ae039), {
            textContent: pageMetadata.textContent,
            projectId: projectId,
            page: page,
            pageMetadata: pageMetadata,
            applySetNonbreakingSpace: handleNonBreakingSpace,
            selectedRhesesIds: selectedRhesesIds,
            selectedTextPosition: selectedTextPosition,
            createParagraph: createParagraph,
            addSeparator: createPage,
            setLineBreakAfterRhese: setLineBreakAfterRhese,
            setSelectedRhesesContent: setSelectedRhesesContent,
            setIsSegmentationHovered: setIsSegmentationHovered,
            setDropdownVisibleChange: setDropdownVisibleChange
        }), [
        pageMetadata,
        projectId,
        page,
        handleNonBreakingSpace,
        selectedRhesesIds,
        selectedTextPosition,
        createParagraph,
        createPage,
        setLineBreakAfterRhese
    ]);
    const editImage = (0, $jMaZ8.useCallback)((img)=>setIsEditingImage({
            ...img,
            open: true
        }), []);
    const paragraphWrapper = (0, $jMaZ8.useMemo)(()=>({
            component: (0, $aa126bb602dd7e3b$export$2e2bcd8739ae039),
            props: {
                isDraggingImage: isDraggingImage,
                setTargetParagraph: setTargetParagraph,
                setPosition: setPosition,
                deleteImage: deleteImage,
                editImage: editImage,
                openDialogueSpeakerModal: setIsEditingDialogueSpeaker,
                paragraphs: paragraphs
            }
        }), [
        isDraggingImage,
        setTargetParagraph,
        setPosition,
        deleteImage,
        editImage,
        paragraphs
    ]);
    if (!pageMetadata) return null;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $jMaZ8.Fragment), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            ref: ref,
            onSelect: saveSelection,
            className: $99168dc4b045ed3a$export$e8e78c978b129247.concat(" ", isSegmentationHovered ? $99168dc4b045ed3a$export$adcaeedbcaef61ad : ""),
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d8ba62a4c17fa394$export$2e2bcd8739ae039), {
                    form: form,
                    isEditingImage: isEditingImage,
                    setIsEditingImage: setIsEditingImage,
                    projectId: projectId
                }, `modal-edit-image-${isEditingImage.open ? isEditingImage.id : "closed"}`),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c4ad876759b73a13$export$2e2bcd8739ae039), {
                    projectId: projectId,
                    isVisible: !!isEditingDialogueSpeaker,
                    paragraphId: isEditingDialogueSpeaker.paragraphId,
                    speakerId: isEditingDialogueSpeaker.speakerId,
                    onExit: ()=>setIsEditingDialogueSpeaker(false),
                    speakers: speakers
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    className: $99168dc4b045ed3a$export$8db427562d9df161,
                    children: t("project.existing.editingMode.formatting.lettersCount.result", {
                        lettersCount: selectedTextPosition.size
                    })
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
                    trigger: [
                        "contextMenu"
                    ],
                    onOpenChange: setDropdownVisibleChange,
                    open: dropdownVisible,
                    dropdownRender: renderDropdownContent,
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        ref: contentEditableRef,
                        contentEditable: "true",
                        suppressContentEditableWarning: true,
                        className: "formating-container",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(RenderBook, {
                            paragraphWrapper: paragraphWrapper,
                            enableParagraphTooltip: true,
                            selectedRhesesIds: selectedRhesesIds,
                            projectId: projectId,
                            children: pageMetadata
                        })
                    })
                })
            ]
        })
    });
};
var $dc1e310e25673e39$export$2e2bcd8739ae039 = $dc1e310e25673e39$export$14af8e7fc017bb56;



var $jMaZ8 = parcelRequire("jMaZ8");



/** Metadata anchors are half-open UTF-16 ranges and may overlap. */ function $aa08dbcbd1f63b4f$export$1285f05fc3a653e0(metadata, position) {
    const end = position.start + position.size;
    let coveredUntil = position.start;
    const anchors = metadata.flatMap((item)=>item.anchors).sort((a, b)=>a.utf16Start - b.utf16Start);
    for (const anchor of anchors){
        if (coveredUntil >= end) return false;
        if (anchor.utf16Start > coveredUntil) return true;
        coveredUntil = Math.max(coveredUntil, anchor.utf16Start + anchor.utf16Size);
    }
    return coveredUntil < end;
}


const $e914d830306dc703$var$useHandleLettersKindAssignation = (position, projectId, getPageMetadata)=>{
    const [applySetBoldFromPosition] = (0, $e2820f429b7bf591$export$56909a63dceee5e4)();
    const [applyUnsetBoldFromPosition] = (0, $e2820f429b7bf591$export$dfbb23234410ac77)();
    const [applySetCaseFromPosition] = (0, $be8ad9aee629aa88$export$c96008beafa95673)();
    const [applyUnsetCaseFromPosition] = (0, $be8ad9aee629aa88$export$c556b62d366b9791)();
    const [applySetMuteFromPosition] = (0, $b7be8974895307ad$export$c01896a7be4e05e6)();
    const [applyUnsetMuteFromPosition] = (0, $b7be8974895307ad$export$26d1265de1014c07)();
    const [applySetItalicizationFromPosition] = (0, $37e93270a3b556ee$export$4dbcd7c069fb54cc)();
    const [applyUnsetItalicizationFromPosition] = (0, $37e93270a3b556ee$export$d99cb86ed19031f9)();
    const [applySetCitationFromPosition] = (0, $40cac082394d74a9$export$9a8b01557946754d)();
    const [applyUnsetCitationFromPosition] = (0, $40cac082394d74a9$export$11ba112db18dde8d)();
    const [applySetScriptNotationFromPosition] = (0, $90450104ba9a679e$export$9dac96c6d6d500cb)();
    const [applyUnsetScriptNotationFromPosition] = (0, $90450104ba9a679e$export$efaaf054478af590)();
    const handleLettersKindAssignation = (0, $jMaZ8.useCallback)((kind)=>{
        const pageMetadata = getPageMetadata();
        if (position.size === 0 || !pageMetadata) return;
        let hasOneWithoutKindInSelection = false;
        // Calculate if all letters currently selected have the kind
        switch(kind){
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).GRAS:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textWeight, position);
                break;
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).ITALIQUE:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textItalicization, position);
                break;
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).CITATION:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textCitation, position);
                break;
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MAJUSCULE:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textCase.filter((m)=>m.data.textCase === (0, $b522cf181e75e62d$export$6b9f2d1513b0c4f2).UPPER), position);
                break;
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MINUSCULE:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textCase.filter((m)=>m.data.textCase === (0, $b522cf181e75e62d$export$6b9f2d1513b0c4f2).LOWER), position);
                break;
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MUTE:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textMuted, position);
                break;
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).INDICE:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textScriptNotation.filter((m)=>m.data.textScriptNotation === (0, $b522cf181e75e62d$export$7e93c17f45cd53fa).SUBSCRIPT), position);
                break;
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).EXPOSANT:
                hasOneWithoutKindInSelection = (0, $aa08dbcbd1f63b4f$export$1285f05fc3a653e0)(pageMetadata.textScriptNotation.filter((m)=>m.data.textScriptNotation === (0, $b522cf181e75e62d$export$7e93c17f45cd53fa).SUPERSCRIPT), position);
                break;
        }
        switch(kind){
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).GRAS:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetBoldFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
                // Remove kind
                return applyUnsetBoldFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).ITALIQUE:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetItalicizationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
                // Remove kind
                return applyUnsetItalicizationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).CITATION:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetCitationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
                // Remove kind
                return applyUnsetCitationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MAJUSCULE:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetCaseFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        kind: (0, $b522cf181e75e62d$export$6b9f2d1513b0c4f2).UPPER
                    }
                });
                // Remove kind
                return applyUnsetCaseFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        kind: (0, $b522cf181e75e62d$export$6b9f2d1513b0c4f2).UPPER
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MINUSCULE:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetCaseFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        kind: (0, $b522cf181e75e62d$export$6b9f2d1513b0c4f2).LOWER
                    }
                });
                // Remove kind
                return applyUnsetCaseFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        kind: (0, $b522cf181e75e62d$export$6b9f2d1513b0c4f2).LOWER
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).EXPOSANT:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetScriptNotationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        scriptNotation: (0, $b522cf181e75e62d$export$7e93c17f45cd53fa).SUPERSCRIPT
                    }
                });
                // Remove kind
                return applyUnsetScriptNotationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        scriptNotation: (0, $b522cf181e75e62d$export$7e93c17f45cd53fa).SUPERSCRIPT
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).INDICE:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetScriptNotationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        scriptNotation: (0, $b522cf181e75e62d$export$7e93c17f45cd53fa).SUBSCRIPT
                    }
                });
                // Remove kind
                return applyUnsetScriptNotationFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size,
                        scriptNotation: (0, $b522cf181e75e62d$export$7e93c17f45cd53fa).SUBSCRIPT
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).MUTE:
                if (hasOneWithoutKindInSelection) // Set kind
                return applySetMuteFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
                // Remove kind
                return applyUnsetMuteFromPosition({
                    variables: {
                        projectId: projectId,
                        stringVersion: pageMetadata?.page?.anchors[0].stringVersion,
                        start: position.start,
                        size: position.size
                    }
                });
            case (0, $d6f8296a78132fd9$export$29e1e7edbd5033fa).DEFAULT:
            default:
                return;
        }
    }, [
        position,
        getPageMetadata,
        applyUnsetBoldFromPosition,
        projectId,
        applySetBoldFromPosition,
        applyUnsetItalicizationFromPosition,
        applySetItalicizationFromPosition,
        applyUnsetCitationFromPosition,
        applySetCitationFromPosition,
        applyUnsetCaseFromPosition,
        applySetCaseFromPosition,
        applyUnsetScriptNotationFromPosition,
        applySetScriptNotationFromPosition,
        applyUnsetMuteFromPosition,
        applySetMuteFromPosition
    ]);
    return {
        handleLettersKindAssignation: handleLettersKindAssignation
    };
};
var $e914d830306dc703$export$2e2bcd8739ae039 = $e914d830306dc703$var$useHandleLettersKindAssignation;




const $b317fad54680d391$var$RadioButton = (0, $41c1392b19ea6316$export$2e2bcd8739ae039).Button;
const $b317fad54680d391$export$391303d1dd654373 = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
const $b317fad54680d391$export$3cff511efadf1dd2 = ({ allPages: allPages, projectId: projectId, lockPageStructure: lockPageStructure, speakers: speakers })=>{
    const [applyCreatePage] = (0, $8933335d77e3c41a$export$53b07caf7d6ad3c4)();
    const [applyUpdatePage] = (0, $8933335d77e3c41a$export$8505a611e1f1e0e1)();
    const [applyUpdateRhese] = (0, $e52adb0de4892d08$export$2c38ec863e79ad20)();
    const [applyAssignToNewParagraph] = (0, $d7188398173686a1$export$9b0a4863a3214cf6)();
    const [applyAddImage] = (0, $d7188398173686a1$export$5c3e97cd89776abf)();
    const [form] = (0, $c0d3168732410fde$export$2e2bcd8739ae039).useForm();
    const [targetParagraph, setTargetParagraph] = (0, $jMaZ8.useState)(null);
    const [selectedTextPosition, setSelectedTextPosition] = (0, $jMaZ8.useState)({
        start: 0,
        size: 0
    });
    const selectedPage = (0, $jMaZ8.useRef)(()=>null);
    const getSelectedPage = (0, $jMaZ8.useCallback)(()=>selectedPage.current(), []);
    const updateDisplayedPageNumber = (0, $5b38bec19e3a4e47$export$81b3a8efdffa1495)();
    const { handleLettersKindAssignation: handleLettersKindAssignation } = (0, $e914d830306dc703$export$2e2bcd8739ae039)(selectedTextPosition, projectId, getSelectedPage);
    const assignRhesesToParagraph = (0, $jMaZ8.useCallback)((rheseIds, paragraphKind, paragraphTagId)=>{
        applyAssignToNewParagraph({
            variables: {
                paragraphKind: paragraphKind,
                rheses: rheseIds,
                projectId: projectId,
                paragraphTagId: paragraphTagId
            }
        });
    }, [
        applyAssignToNewParagraph,
        projectId
    ]);
    const [isDraggingImage, setIsDraggingImage] = (0, $jMaZ8.useState)(false);
    const [isModalVisible, setIsModalVisible] = (0, $jMaZ8.useState)(false);
    const [name, setName] = (0, $jMaZ8.useState)("");
    const [description, setDescription] = (0, $jMaZ8.useState)("");
    const [figcaption, setFigcaption] = (0, $jMaZ8.useState)("");
    const [imageKind, setImageKind] = (0, $jMaZ8.useState)((0, $b522cf181e75e62d$export$b890e9c15247e0b3).NORMAL);
    const imagePosition = (0, $jMaZ8.useRef)((0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).BEFORE);
    const setImagePosition = (0, $jMaZ8.useCallback)((position)=>{
        imagePosition.current = position;
    }, []);
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.existing.editingMode.formatting.default";
    const clear = (0, $jMaZ8.useCallback)(()=>{
        setName("");
        setDescription("");
        setFigcaption("");
        setImageKind((0, $b522cf181e75e62d$export$b890e9c15247e0b3).NORMAL);
        setImagePosition((0, $b522cf181e75e62d$export$a1ccd8e6c4b447b2).BEFORE);
        setTargetParagraph(null);
        form.resetFields();
    }, [
        form
    ]);
    const showModal = (0, $jMaZ8.useCallback)(()=>{
        setIsModalVisible(true);
    }, []);
    const handleOk = (0, $jMaZ8.useCallback)(()=>{
        setIsModalVisible(false);
        if (targetParagraph !== null) applyAddImage({
            variables: {
                projectId: projectId,
                paragraphId: targetParagraph,
                kind: imageKind,
                position: imagePosition.current,
                fileName: (0, $7ff84a88030acb67$export$d4bc33f48b610b3b)(name),
                description: description,
                figcaption: figcaption
            }
        });
        clear();
    }, [
        targetParagraph,
        clear,
        applyAddImage,
        projectId,
        imageKind,
        imagePosition,
        name,
        description,
        figcaption
    ]);
    const handleCancel = ()=>{
        setIsModalVisible(false);
        clear();
    };
    const handleImageCreation = (0, $jMaZ8.useCallback)(()=>{
        if (!targetParagraph) return;
        showModal();
    }, [
        showModal,
        targetParagraph
    ]);
    const onTextSelectionChange = (0, $jMaZ8.useCallback)((selectedPosition, getPageMetadata)=>{
        setSelectedTextPosition((previous)=>previous.start === selectedPosition.start && previous.size === selectedPosition.size ? previous : selectedPosition);
        selectedPage.current = getPageMetadata;
    }, []);
    const handleMutePageAfter = (0, $jMaZ8.useCallback)(async (id, mutePages)=>{
        const page = allPages.find((page)=>page.id === id);
        if (!page) throw new Error("Could not retrieve page in pages list");
        await applyUpdatePage({
            variables: {
                projectId: projectId,
                pageId: id,
                mutePagesAfter: mutePages,
                partname: page.partName || ""
            }
        });
    }, [
        allPages,
        applyUpdatePage,
        projectId
    ]);
    const handleMergePages = (0, $jMaZ8.useCallback)(async (pageId)=>{
        const currentPage = allPages.find((page)=>page.id === pageId);
        if (!currentPage) throw new Error("Could not retrieve current page in pages list");
        const nextPage = allPages.find((page)=>page.pageNumber === currentPage?.pageNumber + 1);
        if (!nextPage) throw new Error("Could not retrieve next page in pages list");
        updateDisplayedPageNumber(currentPage.pageNumber.toString());
        await applyCreatePage({
            variables: {
                projectId: projectId,
                stringVersion: currentPage.stringVersion,
                start: currentPage.start,
                size: nextPage.start + nextPage.size - currentPage.start,
                mutePagesAfter: nextPage.mutePagesAfter,
                partname: currentPage.partName
            }
        });
    }, [
        allPages,
        applyCreatePage,
        projectId,
        updateDisplayedPageNumber
    ]);
    const handleSetLineBreakAfterRhese = (0, $jMaZ8.useCallback)(async (previousRhese, lineBreak)=>{
        applyUpdateRhese({
            variables: {
                projectId: projectId,
                rheseId: previousRhese.data.id,
                lineBreakAfter: lineBreak,
                ignoreTextForAudioSync: previousRhese.data.ignoreTextForAudioSync
            }
        });
    }, [
        applyUpdateRhese,
        projectId
    ]);
    const pageProps = (0, $jMaZ8.useMemo)(()=>({
            onTextSelectionChange: onTextSelectionChange,
            setTargetParagraph: setTargetParagraph,
            isDraggingImage: isDraggingImage,
            setPosition: setImagePosition,
            assignRhesesToParagraph: assignRhesesToParagraph,
            lockPageStructure: lockPageStructure,
            setLineBreakAfterRhese: handleSetLineBreakAfterRhese,
            projectId: projectId,
            speakers: speakers,
            allPages: allPages
        }), [
        onTextSelectionChange,
        isDraggingImage,
        assignRhesesToParagraph,
        lockPageStructure,
        handleSetLineBreakAfterRhese,
        projectId,
        speakers,
        allPages
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
                title: t(`${i18nKey}.modal.title`),
                open: isModalVisible,
                onOk: handleOk,
                onCancel: handleCancel,
                footer: null,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $c0d3168732410fde$export$2e2bcd8739ae039), {
                    name: "basic",
                    onFinish: handleOk,
                    layout: "vertical",
                    form: form,
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                            style: {
                                padding: "0 7em"
                            },
                            label: t(`${i18nKey}.form.imageNaming.label`),
                            name: "name",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                                value: name,
                                onChange: (e)=>setName(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                            style: {
                                padding: "0 7em"
                            },
                            label: t(`${i18nKey}.form.imageDescription.label`),
                            name: "description",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                                value: description,
                                onChange: (e)=>setDescription(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                            style: {
                                padding: "0 7em"
                            },
                            label: t(`${i18nKey}.form.figcaption.label`),
                            name: "figcaption",
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                                value: figcaption,
                                onChange: (e)=>setFigcaption(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                            style: {
                                margin: 0
                            },
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                                justify: "center",
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $41c1392b19ea6316$export$2e2bcd8739ae039).Group, {
                                    value: imageKind,
                                    style: {
                                        display: "flex",
                                        fontSize: "1.25em"
                                    },
                                    onChange: (e)=>setImageKind(e.target.value === (0, $b522cf181e75e62d$export$b890e9c15247e0b3).NORMAL ? (0, $b522cf181e75e62d$export$b890e9c15247e0b3).NORMAL : (0, $b522cf181e75e62d$export$b890e9c15247e0b3).POPUP),
                                    optionType: "button",
                                    children: [
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($b317fad54680d391$var$RadioButton, {
                                            style: $b317fad54680d391$export$391303d1dd654373,
                                            value: (0, $b522cf181e75e62d$export$b890e9c15247e0b3).NORMAL,
                                            children: t(`${i18nKey}.form.radioButton.normal`)
                                        }),
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($b317fad54680d391$var$RadioButton, {
                                            style: $b317fad54680d391$export$391303d1dd654373,
                                            value: (0, $b522cf181e75e62d$export$b890e9c15247e0b3).POPUP,
                                            children: t(`${i18nKey}.form.radioButton.popup`)
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c0d3168732410fde$export$2e2bcd8739ae039).Item, {
                            style: {
                                margin: 0,
                                marginTop: "2em"
                            },
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                                justify: "center",
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                    disabled: name.length === 0,
                                    htmlType: "submit",
                                    shape: "round",
                                    children: t(`${i18nKey}.form.validation`)
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5397f42de219fe1e$export$9e9dcf6268a0a1fc), {
                mergePages: handleMergePages,
                addMutePages: handleMutePageAfter,
                props: pageProps,
                component: (0, $dc1e310e25673e39$export$2e2bcd8739ae039),
                children: allPages
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $99168dc4b045ed3a$export$56a7b65538036bea,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5d51cea93389c70b$export$2e2bcd8739ae039), {
                    handleLettersKindAssignation: handleLettersKindAssignation,
                    sideMenuClassName: $99168dc4b045ed3a$export$b481748e0e5d3cfc,
                    setIsDraggingImage: setIsDraggingImage,
                    isDraggingImage: isDraggingImage,
                    handleImageCreation: handleImageCreation,
                    targetParagraph: targetParagraph
                })
            })
        ]
    });
};


const $e7deeceb4b214229$var$EditingRouter = ({ projectId: projectId, loading: loading, pages: pages })=>{
    const { loading: projectsLoading, data: projectsData } = (0, $d7188398173686a1$export$6ed06f11bf137590)({
        id: projectId,
        withInfo: false,
        withAudioInfo: false
    });
    const project = projectsData?.project?.find((p)=>p.id === projectId);
    const location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    const shouldDisplayFontResizer = !location.pathname.match(/narration/);
    const { value: fontSize } = (0, $a4507719465753c1$export$97e1252eeb182290)();
    const matchesFormat = (0, $5c84a101a4932c49$export$6c330e8992e8a295)((0, $46106f6fa4537524$export$d370f4b3e279b438).format);
    const matchesRhese = (0, $5c84a101a4932c49$export$6c330e8992e8a295)((0, $46106f6fa4537524$export$d370f4b3e279b438).rhese);
    const matchesSyllable = (0, $5c84a101a4932c49$export$6c330e8992e8a295)((0, $46106f6fa4537524$export$d370f4b3e279b438).syllable);
    const matchesDefinition = (0, $5c84a101a4932c49$export$6c330e8992e8a295)((0, $46106f6fa4537524$export$d370f4b3e279b438).definition);
    const matchesOverview = (0, $5c84a101a4932c49$export$6c330e8992e8a295)((0, $46106f6fa4537524$export$d370f4b3e279b438).overview(projectId));
    const lockPageStructure = project?.kind === (0, $b522cf181e75e62d$export$878945baaa13398a).HTML_TEMPLATE;
    const matchesNarration = (0, $5c84a101a4932c49$export$6c330e8992e8a295)((0, $46106f6fa4537524$export$d370f4b3e279b438).narration);
    const pageHeaders = (0, $jMaZ8.useMemo)(()=>(0, $64440fdf5e210924$export$df67168c104ba0e3)(pages), [
        pages
    ]);
    const projectContext = (0, $jMaZ8.useMemo)(()=>project ? {
            project: project,
            pages: pages,
            pageHeaders: pageHeaders
        } : null, [
        project,
        pages,
        pageHeaders
    ]);
    if (project?.importStatus === (0, $b522cf181e75e62d$export$cf6fc7defa80d203).FAILED) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b48f64e003f2eb7e$export$2e2bcd8739ae039), {
        failed: true
    });
    if (project?.importStatus === (0, $b522cf181e75e62d$export$cf6fc7defa80d203).WAITING_FOR_CONTENT || project?.importStatus === (0, $b522cf181e75e62d$export$cf6fc7defa80d203).IMPORTING_CONTENT) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b48f64e003f2eb7e$export$2e2bcd8739ae039), {
        notImportedYet: true
    });
    if (!project || loading || projectsLoading) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b48f64e003f2eb7e$export$2e2bcd8739ae039), {
        loading: true
    });
    const paginatedComponent = (()=>{
        if (matchesFormat) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b317fad54680d391$export$3cff511efadf1dd2), {
            projectId: projectId,
            lockPageStructure: lockPageStructure,
            allPages: pages,
            speakers: project.speakers || []
        });
        if (matchesRhese) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $fb5003559adbbfb5$export$9daac14717550217), {
            projectId: projectId,
            allPages: pages
        });
        if (matchesSyllable) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0eba25cd82c101bd$export$6fcda684b3097527), {
            project: project,
            allPages: pages
        });
        if (matchesDefinition) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $73056f7e41feae93$export$2e2bcd8739ae039), {
            projectId: projectId,
            allPages: pages
        });
        if (matchesOverview) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a1b03ac3acc3cf95$export$2de1e9fc98bcbeb2), {
            projectId: projectId,
            allPages: pages
        });
        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$444b3ab0cb9aec40), {
            replace: true,
            to: {
                pathname: (0, $46106f6fa4537524$export$d370f4b3e279b438).overview(projectId),
                search: location.search,
                hash: location.hash
            }
        });
    })();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $5b38bec19e3a4e47$export$477397cba250e9af), {
        value: projectContext,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                style: {
                    fontSize: `${fontSize}em`
                },
                className: $57c9cb049f914779$export$d60039a9e6aa939e,
                spellCheck: false,
                children: paginatedComponent
            }),
            !matchesNarration ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2981c9ae42b3c89b$export$2e2bcd8739ae039), {
                totalPageNumber: pages?.[0]?.lastPageNumber
            }) : null,
            shouldDisplayFontResizer && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8e411226cda9588c$export$2e2bcd8739ae039), {
                style: $57c9cb049f914779$export$85e3c3ca0c6fb93
            })
        ]
    });
};
var $e7deeceb4b214229$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo($e7deeceb4b214229$var$EditingRouter);


const $a365bb214cadc66e$var$EditingRouterProvider = (props)=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a4507719465753c1$export$318bad5a1fb16ff), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e7deeceb4b214229$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
var $a365bb214cadc66e$export$2e2bcd8739ae039 = $a365bb214cadc66e$var$EditingRouterProvider;




var $jMaZ8 = parcelRequire("jMaZ8");


var $7c482fd6f1ef0110$export$38e42c68cf43b5d4;
var $7c482fd6f1ef0110$export$39f5674517ec0000;
var $7c482fd6f1ef0110$export$80e4b313e5e6b30d;
var $7c482fd6f1ef0110$export$db3c28d99448dcff;
var $7c482fd6f1ef0110$export$d76128d007d19019;
var $7c482fd6f1ef0110$export$cc74dcc53cfce4eb;
$7c482fd6f1ef0110$export$38e42c68cf43b5d4 = "header_fa18b1";
$7c482fd6f1ef0110$export$39f5674517ec0000 = "tabs_fa18b1";
$7c482fd6f1ef0110$export$80e4b313e5e6b30d = "nav_fa18b1";
$7c482fd6f1ef0110$export$db3c28d99448dcff = "logo_fa18b1";
$7c482fd6f1ef0110$export$d76128d007d19019 = "search_fa18b1";
$7c482fd6f1ef0110$export$cc74dcc53cfce4eb = "wrapper_fa18b1";



parcelRequire("jMaZ8");
const $5f0712d9dc470fa0$var$SvgApercu = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 31.146,
        height: 17,
        ...props,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("style", {
                    children: ".Apercu_svg__a{fill:#5b6079}"
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                className: "Apercu_svg__a",
                d: "M30.889 8.98a.925.925 0 0 0 0-1.281c-1.856-1.953-7.944-7.7-15.315-7.7S2.114 5.745.258 7.699a.925.925 0 0 0 0 1.281c1.856 1.953 7.944 7.7 15.316 7.7s13.459-5.747 15.315-7.7Zm-15.272 4.476a5.159 5.159 0 1 1 5.159-5.16 5.159 5.159 0 0 1-5.16 5.16Z"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("circle", {
                className: "Apercu_svg__a",
                cx: 3,
                cy: 3,
                r: 3,
                transform: "translate(12.6 5.097)"
            })
        ]
    });
var $5f0712d9dc470fa0$export$2e2bcd8739ae039 = $5f0712d9dc470fa0$var$SvgApercu;



parcelRequire("jMaZ8");
const $1128bd624ab2fd7f$var$SvgRhesage = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26.5,
        height: 13,
        ...props,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("style", {
                    children: ".Rhesage_svg__a,.Rhesage_svg__b{fill:#5b6079}.Rhesage_svg__b{opacity:.5}"
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                className: "Rhesage_svg__a",
                width: 15.779,
                height: 2.818,
                rx: 0.2,
                transform: "translate(10.721 10.182)"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                className: "Rhesage_svg__b",
                width: 9.017,
                height: 2.818,
                rx: 0.2,
                transform: "translate(0 10.182)"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                className: "Rhesage_svg__a",
                width: 7.326,
                height: 2.818,
                rx: 0.2,
                transform: "translate(19.174 5.091)"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                className: "Rhesage_svg__b",
                width: 9.017,
                height: 2.818,
                rx: 0.2,
                transform: "translate(8.46 5.091)"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                className: "Rhesage_svg__a",
                width: 6.762,
                height: 2.818,
                rx: 0.2,
                transform: "translate(0 5.091)"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                className: "Rhesage_svg__b",
                width: 11.271,
                height: 2.818,
                rx: 0.2,
                transform: "translate(15.229)"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                className: "Rhesage_svg__a",
                width: 13.525,
                height: 2.818,
                rx: 0.2
            })
        ]
    });
var $1128bd624ab2fd7f$export$2e2bcd8739ae039 = $1128bd624ab2fd7f$var$SvgRhesage;



parcelRequire("jMaZ8");
const $aefd243f9e158011$var$SvgMiseEnPage = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14.956,
        height: 16.22,
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M257.164 243.873h-13.092a.932.932 0 0 0-.932.932v2.741a.932.932 0 1 0 1.864 0v-1.809h4.682v12.491h-.665a.932.932 0 1 0 0 1.864h3.192a.932.932 0 0 0 0-1.864h-.664v-12.491h4.681v1.809a.932.932 0 1 0 1.864 0v-2.741a.932.932 0 0 0-.93-.932Z",
            transform: "translate(-243.14 -243.873)",
            style: {
                fill: "#5b6079"
            }
        })
    });
var $aefd243f9e158011$export$2e2bcd8739ae039 = $aefd243f9e158011$var$SvgMiseEnPage;



parcelRequire("jMaZ8");
const $2f068923fce3cc12$var$SvgDefinitions = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25.633,
        height: 21.585,
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M648.409 146.076c-7.079 0-12.816 4.281-12.816 9.56 0 3.643 2.732 6.809 6.749 8.423l.03.544.141 2.623a.472.472 0 0 0 .507.434.466.466 0 0 0 .193-.058l2.266-1.329 1.893-1.111c.342.021.688.035 1.038.035 7.079 0 12.816-4.281 12.816-9.561s-5.738-9.56-12.817-9.56ZM644.3 157.1a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm4.519 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.498 1.5Zm4.519 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.498 1.5Z",
            transform: "translate(-635.593 -146.076)",
            style: {
                fill: "#5b6079"
            }
        })
    });
var $2f068923fce3cc12$export$2e2bcd8739ae039 = $2f068923fce3cc12$var$SvgDefinitions;



parcelRequire("jMaZ8");
const $358bf2bb0ff56460$var$SvgDialogues = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 31.551,
        height: 21.586,
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M573.59 147.848a13.842 13.842 0 0 0-5.044.93c-1-2.442-4.045-4.217-7.646-4.217-4.417 0-8 2.671-8 5.965 0 2.273 1.7 4.248 4.211 5.255l.018.339.088 1.637a.294.294 0 0 0 .318.27.279.279 0 0 0 .119-.036l1.414-.829 1.181-.693c.213.013.43.022.648.022a10.559 10.559 0 0 0 1.849-.166c.263 4.3 5.007 7.731 10.84 7.731.3 0 .6-.012.88-.029l1.6.942 1.921 1.127a.391.391 0 0 0 .163.049.4.4 0 0 0 .431-.368l.12-2.224.025-.461c3.406-1.367 5.721-4.052 5.721-7.14.007-4.475-4.857-8.104-10.857-8.104Zm-14.973 3.834a.822.822 0 1 1 .822-.822.821.821 0 0 1-.822.822Zm5.076-1.643a.822.822 0 1 1-.822.822.822.822 0 0 1 .821-.822Zm-2.538 1.643a.822.822 0 1 1 .822-.822.821.821 0 0 1-.823.822Zm9.24 5.479a1.1 1.1 0 1 1 1.1-1.1 1.094 1.094 0 0 1-1.1 1.1Zm3.287 0a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.1Zm3.286 0a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.1Z",
            transform: "translate(-552.903 -144.561)",
            style: {
                fill: "#5b6079"
            }
        })
    });
var $358bf2bb0ff56460$export$2e2bcd8739ae039 = $358bf2bb0ff56460$var$SvgDialogues;



parcelRequire("jMaZ8");
const $73693f7406aa3821$var$SvgSyllabation = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 39.211,
        height: 16.682,
        ...props,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("style", {
                    children: ".Syllabation_svg__a,.Syllabation_svg__b{fill:#5b6079}.Syllabation_svg__a{opacity:.5;isolation:isolate}"
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                className: "Syllabation_svg__a",
                d: "M20.077 12.69v1.891a20.407 20.407 0 0 0 17.965 0V12.69a24.971 24.971 0 0 1-17.965 0ZM32.342 8.052l1.952-.3a1.436 1.436 0 0 0 .505.862 1.711 1.711 0 0 0 1.067.294 1.926 1.926 0 0 0 1.135-.277.619.619 0 0 0 .257-.519.51.51 0 0 0-.139-.368 1.538 1.538 0 0 0-.651-.256 10.49 10.49 0 0 1-2.984-.949 1.894 1.894 0 0 1-.873-1.655 2.038 2.038 0 0 1 .755-1.606 3.521 3.521 0 0 1 2.341-.652 4.086 4.086 0 0 1 2.243.492 2.514 2.514 0 0 1 1.011 1.454l-1.834.339a1.141 1.141 0 0 0-.447-.657 1.635 1.635 0 0 0-.939-.229 2.111 2.111 0 0 0-1.1.215.461.461 0 0 0-.222.394.431.431 0 0 0 .195.354 7.244 7.244 0 0 0 1.818.547 5.421 5.421 0 0 1 2.17.866 1.8 1.8 0 0 1 .61 1.448 2.219 2.219 0 0 1-.845 1.738 3.736 3.736 0 0 1-2.5.728 4.1 4.1 0 0 1-2.379-.61 2.807 2.807 0 0 1-1.146-1.653ZM29.417 10.152v-1.1a2.844 2.844 0 0 1-1.056.929 2.971 2.971 0 0 1-1.382.339 2.7 2.7 0 0 1-1.33-.325 1.923 1.923 0 0 1-.851-.914 4.075 4.075 0 0 1-.263-1.628V2.799h1.945v3.379a9.382 9.382 0 0 0 .107 1.9 1.04 1.04 0 0 0 .392.554 1.206 1.206 0 0 0 .72.2 1.531 1.531 0 0 0 .893-.274 1.391 1.391 0 0 0 .54-.678 7.894 7.894 0 0 0 .145-1.985v-3.1h1.946v7.355ZM23.438 2.797v1.551h-1.333v2.964a7.4 7.4 0 0 0 .038 1.049.426.426 0 0 0 .174.246.549.549 0 0 0 .329.1 2.535 2.535 0 0 0 .782-.187l.166 1.51a3.875 3.875 0 0 1-1.538.291 2.434 2.434 0 0 1-.949-.177 1.379 1.379 0 0 1-.619-.457 1.785 1.785 0 0 1-.274-.758 9.308 9.308 0 0 1-.063-1.371V4.351h-.893V2.8h.893V1.339L22.104.203v2.6Z"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                className: "Syllabation_svg__b",
                d: "M.221 12.69v1.891a20.408 20.408 0 0 0 17.965 0V12.69a24.97 24.97 0 0 1-17.965 0ZM11.165 6.371a3.977 3.977 0 0 1 .478-1.877 3.28 3.28 0 0 1 1.354-1.385 4.019 4.019 0 0 1 1.956-.478 3.675 3.675 0 0 1 2.736 1.085 3.744 3.744 0 0 1 1.066 2.738 3.789 3.789 0 0 1-1.076 2.766 3.637 3.637 0 0 1-2.712 1.1 4.271 4.271 0 0 1-1.928-.457 3.14 3.14 0 0 1-1.4-1.34 4.464 4.464 0 0 1-.474-2.152Zm1.995.1a2.438 2.438 0 0 0 .519 1.677 1.7 1.7 0 0 0 2.559 0 2.477 2.477 0 0 0 .516-1.69 2.427 2.427 0 0 0-.516-1.662 1.7 1.7 0 0 0-2.559 0 2.433 2.433 0 0 0-.519 1.679ZM0 10.152V0h3.068L4.91 6.925 6.732 0h3.074v10.152h-1.9V2.16L5.89 10.152H3.912L1.904 2.16v7.992Z"
            })
        ]
    });
var $73693f7406aa3821$export$2e2bcd8739ae039 = $73693f7406aa3821$var$SvgSyllabation;



parcelRequire("jMaZ8");
const $23142ffe47fff107$var$SvgLogoFrog = (props)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.123em",
        height: "1.08em",
        viewBox: "0 0 22.463 21.614",
        ...props,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M36.152 226.278a4.87 4.87 0 0 1-.152-2.517 2.36 2.36 0 0 1 3.045-1.311 2.528 2.528 0 0 1 1.544 2.982c-.444 1.459-1.078 2.876-1.417 4.356a6.439 6.439 0 0 0 .169 2.685A1.809 1.809 0 0 0 41.418 234a2.738 2.738 0 0 0 2.263-2.283 12.511 12.511 0 0 1 .465-2.538 2.278 2.278 0 0 1 2.622-1.438 2.541 2.541 0 0 1 2.051 1.988 2.456 2.456 0 0 1-1.142 2.516 2.951 2.951 0 0 1-.93.465c-1.861.36-2.453 1.776-2.9 3.341a49.4 49.4 0 0 1-1.649 5.286c-1.1 2.686-2.664 3.193-5.265 1.9a23.3 23.3 0 0 1-2.559-1.438 3.394 3.394 0 0 0-3.742-.275 2.826 2.826 0 0 1-2.813.233 2.564 2.564 0 0 1-1.163-3.383 2.4 2.4 0 0 1 3.235-1.1c.677.338 1.226.931 1.9 1.29a2.066 2.066 0 0 0 1.5.36 1.845 1.845 0 0 0 .74-1.353c.212-2.347-.972-3.912-3.447-4.694-1.121-.36-2.178-.8-2.495-2.136a2.436 2.436 0 0 1 4.462-1.861c.317.571.4 1.268.677 1.861a13.063 13.063 0 0 0 1.374 2.643 1.8 1.8 0 0 0 1.544.529c.38-.106.719-.8.846-1.29a10.264 10.264 0 0 0 .148-1.988 23.138 23.138 0 0 0-.988-4.357Z",
            transform: "translate(-26.406 -222.3)",
            style: {
                fill: "#5b6079"
            }
        })
    });
var $23142ffe47fff107$export$2e2bcd8739ae039 = $23142ffe47fff107$var$SvgLogoFrog;









var $jMaZ8 = parcelRequire("jMaZ8");


var $6c81d73a7221ec93$export$d11afefa28acd161;
var $6c81d73a7221ec93$export$cd4622fd46db32c7;
var $6c81d73a7221ec93$export$908ffd203f34ac22;
var $6c81d73a7221ec93$export$4bdbf921f0c0fd8c;
var $6c81d73a7221ec93$export$a8ff84c12d48cfa6;
var $6c81d73a7221ec93$export$571b02044ddb2ab3;
var $6c81d73a7221ec93$export$39f5674517ec0000;
var $6c81d73a7221ec93$export$cc74dcc53cfce4eb;
var $6c81d73a7221ec93$export$35d34bc0ed591a92;
var $6c81d73a7221ec93$export$d0c9705ad8865b5b;
var $6c81d73a7221ec93$export$14e796685e2eb676;
var $6c81d73a7221ec93$export$8810e945d522ffb1;
var $6c81d73a7221ec93$export$e506a1d27d1eaa20;
var $6c81d73a7221ec93$export$3ebae31328f22dc5;
var $6c81d73a7221ec93$export$7977293121aae9f8;
var $6c81d73a7221ec93$export$504d7abb21fa8c9;
var $6c81d73a7221ec93$export$b56dc0f160585b86;
var $6c81d73a7221ec93$export$e656ceb6fa117c2d;
var $6c81d73a7221ec93$export$e16d8520af44a096;
var $6c81d73a7221ec93$export$e8c9778bf415dd08;
var $6c81d73a7221ec93$export$c811345782c7e053;
var $6c81d73a7221ec93$export$140fd7bd1291a3e4;
$6c81d73a7221ec93$export$d11afefa28acd161 = "panelWrapper_874c04";
$6c81d73a7221ec93$export$cd4622fd46db32c7 = "transparentBackground_874c04";
$6c81d73a7221ec93$export$908ffd203f34ac22 = "projectPanel_874c04";
$6c81d73a7221ec93$export$4bdbf921f0c0fd8c = "cover_874c04";
$6c81d73a7221ec93$export$a8ff84c12d48cfa6 = "name_874c04";
$6c81d73a7221ec93$export$571b02044ddb2ab3 = "author_874c04";
$6c81d73a7221ec93$export$39f5674517ec0000 = "tabs_874c04";
$6c81d73a7221ec93$export$cc74dcc53cfce4eb = "wrapper_874c04";
$6c81d73a7221ec93$export$35d34bc0ed591a92 = "step_874c04";
$6c81d73a7221ec93$export$d0c9705ad8865b5b = "reloadButton_874c04";
$6c81d73a7221ec93$export$14e796685e2eb676 = "projectStatus_874c04";
$6c81d73a7221ec93$export$8810e945d522ffb1 = "infos_874c04";
$6c81d73a7221ec93$export$e506a1d27d1eaa20 = "config_874c04";
$6c81d73a7221ec93$export$3ebae31328f22dc5 = "checklist_874c04";
$6c81d73a7221ec93$export$7977293121aae9f8 = "userAccess_874c04";
$6c81d73a7221ec93$export$504d7abb21fa8c9 = "progress_874c04";
$6c81d73a7221ec93$export$b56dc0f160585b86 = "radio_874c04";
$6c81d73a7221ec93$export$e656ceb6fa117c2d = "customColorConfig_874c04";
$6c81d73a7221ec93$export$e16d8520af44a096 = "add_874c04";
$6c81d73a7221ec93$export$e8c9778bf415dd08 = "divider_874c04";
$6c81d73a7221ec93$export$c811345782c7e053 = "badgeStatus_874c04";
$6c81d73a7221ec93$export$140fd7bd1291a3e4 = "spinnerContainer_874c04";






var $jMaZ8 = parcelRequire("jMaZ8");




parcelRequire("jMaZ8");


function $127ea07f7e4c11ee$export$2e2bcd8739ae039({ project: project }) {
    const { info: info } = project;
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.actionBar.projectInfo";
    const paragraphKinds = [
        ...new Set(info.usedParagraphsKinds)
    ];
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $6c81d73a7221ec93$export$8810e945d522ffb1,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h4", {
                children: t(`${i18nKey}.title`)
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                children: [
                    t(`${i18nKey}.description`),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("li", {
                                children: [
                                    t(`${i18nKey}.charsNumber`),
                                    " ",
                                    info.charsNumber
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("li", {
                                children: [
                                    t(`${i18nKey}.defsNumber`),
                                    " ",
                                    info.defsNumber
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("li", {
                                children: [
                                    t(`${i18nKey}.imagesNumber`),
                                    " ",
                                    info.imagesNumber
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("li", {
                                children: [
                                    t(`${i18nKey}.pageNumber`),
                                    " ",
                                    info.pageNumber
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("li", {
                                children: [
                                    t(`${i18nKey}.rhesesNumber`),
                                    " ",
                                    info.rhesesNumber
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("li", {
                                children: [
                                    t(`${i18nKey}.wordsNumber`),
                                    " ",
                                    info.wordsNumber
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                children: [
                    t(`${i18nKey}.listTitle`),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("ul", {
                        children: paragraphKinds.map((kind)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("li", {
                                children: kind
                            }, kind))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                children: [
                    t("customCssClassesUsed"),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("ul", {
                        children: [
                            ...new Set(info.usedCustomCssClasses || [])
                        ].map((className)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("li", {
                                children: className
                            }, className))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("a", {
                download: `${project.name}_KPI.csv`,
                href: `data:application/octet-stream;charset=utf-16le;base64,${btoa(`
              Nombre de caract\xe8res        | ${info.charsNumber}
              Nombre de d\xe9finitions       | ${info.defsNumber}
              Nombre d'images             | ${info.imagesNumber}
              Nombre de pages             | ${info.pageNumber}
              Nombre de rh\xe8ses            | ${info.rhesesNumber}
              Nombre de mots              | ${info.wordsNumber}
              Types de paragraphes        | ${info.usedParagraphsKinds.join(",")}
              Classes CSS personnalis\xe9es  | ${(info.usedCustomCssClasses || []).join(",")}
            `)}`,
                children: t(`${i18nKey}.export`)
            })
        ]
    });
}



parcelRequire("jMaZ8");



function $b0659728937442e4$export$2e2bcd8739ae039({ userBasedAccess: userBasedAccess, roles: roles, projectId: projectId }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.actionBar.userAccess";
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $6c81d73a7221ec93$export$7977293121aae9f8,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h4", {
                children: t(`${i18nKey}.title`)
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $13cde3d375487e0f$export$b33b29ea893e70e1), {
                userBasedAccess: userBasedAccess,
                roles: roles,
                projectId: projectId
            })
        ]
    });
}





var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");


parcelRequire("gedkv");
var $4g3I0 = parcelRequire("4g3I0");

parcelRequire("a1kuN");
var $8APUt = parcelRequire("8APUt");
// ============================== Shared ==============================
const $973c9b0bddfd8f32$var$genSharedDividerStyle = (token)=>{
    const { componentCls: componentCls, sizePaddingEdgeHorizontal: sizePaddingEdgeHorizontal, colorSplit: colorSplit, lineWidth: lineWidth, textPaddingInline: textPaddingInline, orientationMargin: orientationMargin, verticalMarginInline: verticalMarginInline } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $134f73cf3485ce91$export$23997c3e44cc1c59)(token)), {
            borderBlockStart: `${(0, $4g3I0.unit)(lineWidth)} solid ${colorSplit}`,
            // vertical
            '&-vertical': {
                position: 'relative',
                top: '-0.06em',
                display: 'inline-block',
                height: '0.9em',
                marginInline: verticalMarginInline,
                marginBlock: 0,
                verticalAlign: 'middle',
                borderTop: 0,
                borderInlineStart: `${(0, $4g3I0.unit)(lineWidth)} solid ${colorSplit}`
            },
            '&-horizontal': {
                display: 'flex',
                clear: 'both',
                width: '100%',
                minWidth: '100%',
                // Fix https://github.com/ant-design/ant-design/issues/10914
                margin: `${(0, $4g3I0.unit)(token.dividerHorizontalGutterMargin)} 0`
            },
            [`&-horizontal${componentCls}-with-text`]: {
                display: 'flex',
                alignItems: 'center',
                margin: `${(0, $4g3I0.unit)(token.dividerHorizontalWithTextGutterMargin)} 0`,
                color: token.colorTextHeading,
                fontWeight: 500,
                fontSize: token.fontSizeLG,
                whiteSpace: 'nowrap',
                textAlign: 'center',
                borderBlockStart: `0 ${colorSplit}`,
                '&::before, &::after': {
                    position: 'relative',
                    width: '50%',
                    borderBlockStart: `${(0, $4g3I0.unit)(lineWidth)} solid transparent`,
                    // Chrome not accept `inherit` in `border-top`
                    borderBlockStartColor: 'inherit',
                    borderBlockEnd: 0,
                    transform: 'translateY(50%)',
                    content: "''"
                }
            },
            [`&-horizontal${componentCls}-with-text-left`]: {
                '&::before': {
                    width: `calc(${orientationMargin} * 100%)`
                },
                '&::after': {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                }
            },
            [`&-horizontal${componentCls}-with-text-right`]: {
                '&::before': {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                },
                '&::after': {
                    width: `calc(${orientationMargin} * 100%)`
                }
            },
            [`${componentCls}-inner-text`]: {
                display: 'inline-block',
                paddingBlock: 0,
                paddingInline: textPaddingInline
            },
            '&-dashed': {
                background: 'none',
                borderColor: colorSplit,
                borderStyle: 'dashed',
                borderWidth: `${(0, $4g3I0.unit)(lineWidth)} 0 0`
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
                '&::before, &::after': {
                    borderStyle: 'dashed none none'
                }
            },
            [`&-vertical${componentCls}-dashed`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            '&-dotted': {
                background: 'none',
                borderColor: colorSplit,
                borderStyle: 'dotted',
                borderWidth: `${(0, $4g3I0.unit)(lineWidth)} 0 0`
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dotted`]: {
                '&::before, &::after': {
                    borderStyle: 'dotted none none'
                }
            },
            [`&-vertical${componentCls}-dotted`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            [`&-plain${componentCls}-with-text`]: {
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.fontSize
            },
            [`&-horizontal${componentCls}-with-text-left${componentCls}-no-default-orientation-margin-left`]: {
                '&::before': {
                    width: 0
                },
                '&::after': {
                    width: '100%'
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineStart: sizePaddingEdgeHorizontal
                }
            },
            [`&-horizontal${componentCls}-with-text-right${componentCls}-no-default-orientation-margin-right`]: {
                '&::before': {
                    width: '100%'
                },
                '&::after': {
                    width: 0
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineEnd: sizePaddingEdgeHorizontal
                }
            }
        })
    };
};
const $973c9b0bddfd8f32$export$9ca1be8807fe0675 = (token)=>({
        textPaddingInline: '1em',
        orientationMargin: 0.05,
        verticalMarginInline: token.marginXS
    });
var // ============================== Export ==============================
$973c9b0bddfd8f32$export$2e2bcd8739ae039 = (0, $263539dacc5f409d$export$51ec95de45185b42)('Divider', (token)=>{
    const dividerToken = (0, $8APUt.merge)(token, {
        dividerHorizontalWithTextGutterMargin: token.margin,
        dividerHorizontalGutterMargin: token.marginLG,
        sizePaddingEdgeHorizontal: 0
    });
    return [
        $973c9b0bddfd8f32$var$genSharedDividerStyle(dividerToken)
    ];
}, $973c9b0bddfd8f32$export$9ca1be8807fe0675, {
    unitless: {
        orientationMargin: true
    }
});


"use client";
var $c473702f98ad3dd9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c473702f98ad3dd9$var$Divider = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, divider: divider } = $jMaZ8.useContext((0, $3613812083e7312f$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = 'horizontal', orientation: orientation = 'center', orientationMargin: orientationMargin, className: className, rootClassName: rootClassName, children: children, dashed: dashed, variant: variant = 'solid', plain: plain, style: style } = props, restProps = $c473702f98ad3dd9$var$__rest(props, [
        "prefixCls",
        "type",
        "orientation",
        "orientationMargin",
        "className",
        "rootClassName",
        "children",
        "dashed",
        "variant",
        "plain",
        "style"
    ]);
    const prefixCls = getPrefixCls('divider', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $973c9b0bddfd8f32$export$2e2bcd8739ae039)(prefixCls);
    const hasChildren = !!children;
    const hasCustomMarginLeft = orientation === 'left' && orientationMargin != null;
    const hasCustomMarginRight = orientation === 'right' && orientationMargin != null;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(prefixCls, divider === null || divider === void 0 ? void 0 : divider.className, hashId, cssVarCls, `${prefixCls}-${type}`, {
        [`${prefixCls}-with-text`]: hasChildren,
        [`${prefixCls}-with-text-${orientation}`]: hasChildren,
        [`${prefixCls}-dashed`]: !!dashed,
        [`${prefixCls}-${variant}`]: variant !== 'solid',
        [`${prefixCls}-plain`]: !!plain,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-no-default-orientation-margin-left`]: hasCustomMarginLeft,
        [`${prefixCls}-no-default-orientation-margin-right`]: hasCustomMarginRight
    }, className, rootClassName);
    const memoizedOrientationMargin = $jMaZ8.useMemo(()=>{
        if (typeof orientationMargin === 'number') return orientationMargin;
        if (/^\d+$/.test(orientationMargin)) return Number(orientationMargin);
        return orientationMargin;
    }, [
        orientationMargin
    ]);
    const innerStyle = Object.assign(Object.assign({}, hasCustomMarginLeft && {
        marginLeft: memoizedOrientationMargin
    }), hasCustomMarginRight && {
        marginRight: memoizedOrientationMargin
    });
    {
        const warning = (0, $e55cfce129297019$export$cf977aa92c751e61)('Divider');
        warning(!children || type !== 'vertical', 'usage', '`children` not working in `vertical` mode.');
    }
    return wrapCSSVar(/*#__PURE__*/ $jMaZ8.createElement("div", Object.assign({
        className: classString,
        style: Object.assign(Object.assign({}, divider === null || divider === void 0 ? void 0 : divider.style), style)
    }, restProps, {
        role: "separator"
    }), children && type !== 'vertical' && /*#__PURE__*/ $jMaZ8.createElement("span", {
        className: `${prefixCls}-inner-text`,
        style: innerStyle
    }, children)));
};
$c473702f98ad3dd9$var$Divider.displayName = 'Divider';
var $c473702f98ad3dd9$export$2e2bcd8739ae039 = $c473702f98ad3dd9$var$Divider;




var $jMaZ8 = parcelRequire("jMaZ8");
const $af78a76abbde456f$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $af78a76abbde456f$export$2e2bcd8739ae039 = {
    randomUUID: $af78a76abbde456f$var$randomUUID
};


let $1b6af31542c430ce$var$getRandomValues;
const $1b6af31542c430ce$var$rnds8 = new Uint8Array(16);
function $1b6af31542c430ce$export$2e2bcd8739ae039() {
    if (!$1b6af31542c430ce$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $1b6af31542c430ce$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $1b6af31542c430ce$var$getRandomValues($1b6af31542c430ce$var$rnds8);
}


var $146929a952cb6878$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $9cc6fff70fcf2ead$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $146929a952cb6878$export$2e2bcd8739ae039).test(uuid);
}
var $9cc6fff70fcf2ead$export$2e2bcd8739ae039 = $9cc6fff70fcf2ead$var$validate;


const $00c22f9ad9f5fedf$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$00c22f9ad9f5fedf$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $00c22f9ad9f5fedf$export$8fb373d660548968(arr, offset = 0) {
    return ($00c22f9ad9f5fedf$var$byteToHex[arr[offset + 0]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 1]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 2]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 3]] + '-' + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 4]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 5]] + '-' + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 6]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 7]] + '-' + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 8]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 9]] + '-' + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 10]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 11]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 12]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 13]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 14]] + $00c22f9ad9f5fedf$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $00c22f9ad9f5fedf$var$stringify(arr, offset = 0) {
    const uuid = $00c22f9ad9f5fedf$export$8fb373d660548968(arr, offset);
    if (!(0, $9cc6fff70fcf2ead$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $00c22f9ad9f5fedf$export$2e2bcd8739ae039 = $00c22f9ad9f5fedf$var$stringify;


function $882198a336e32ba0$var$v4(options, buf, offset) {
    if ((0, $af78a76abbde456f$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $af78a76abbde456f$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $1b6af31542c430ce$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $00c22f9ad9f5fedf$export$8fb373d660548968)(rnds);
}
var $882198a336e32ba0$export$2e2bcd8739ae039 = $882198a336e32ba0$var$v4;





function $bef37b9d8980e338$export$2e2bcd8739ae039({ project: project }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const { customColorationConfig: customColorationConfig, paragraphTags: paragraphTags } = project;
    const [customColors, setCustomColors] = (0, $jMaZ8.useState)(()=>Object.entries(customColorationConfig).map(([key, value])=>({
                key: key,
                ...JSON.parse(value)
            })));
    const [applyUpdateCustomColorationConfig] = (0, $d7188398173686a1$export$53a9d6d5a12acdec)();
    const debouncedUpdateCustomColorationConfig = (0, $jMaZ8.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($c9f377a2e70f774c$exports)))(applyUpdateCustomColorationConfig, 500), [
        applyUpdateCustomColorationConfig
    ]);
    const [applyUpsertParagraphTag] = (0, $d7188398173686a1$export$a62de4ae2d356ef)();
    const [applyDeleteParagraphTag] = (0, $d7188398173686a1$export$48fa4428c82e8a98)();
    const [localTags, setLocalTags] = (0, $jMaZ8.useState)(paragraphTags);
    (0, $jMaZ8.useEffect)(()=>{
        setLocalTags([
            ...paragraphTags
        ].sort((a, b)=>a.createdAt - b.createdAt));
    }, [
        paragraphTags
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        debouncedUpdateCustomColorationConfig({
            variables: {
                id: project.id,
                customColorationConfig: customColors.reduce((acc, { key: key, color: color, label: label })=>{
                    if (color === "" || label === "") return acc;
                    acc[key] = {
                        color: color,
                        label: label
                    };
                    return acc;
                }, {})
            }
        });
    }, [
        customColors,
        debouncedUpdateCustomColorationConfig,
        project.id
    ]);
    const debouncedUpdateTag = (0, $jMaZ8.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($c9f377a2e70f774c$exports)))((tagId, tagName)=>{
            applyUpsertParagraphTag({
                variables: {
                    tagId: tagId,
                    tagName: tagName,
                    projectId: project.id
                }
            });
        }, 1000), [
        project.id,
        applyUpsertParagraphTag
    ]);
    (0, $jMaZ8.useEffect)(()=>()=>{
            debouncedUpdateTag.flush();
            debouncedUpdateTag.cancel();
            debouncedUpdateCustomColorationConfig.flush();
            debouncedUpdateCustomColorationConfig.cancel();
        }, [
        debouncedUpdateTag,
        debouncedUpdateCustomColorationConfig
    ]);
    const createTag = (0, $jMaZ8.useCallback)(async ()=>{
        await applyUpsertParagraphTag({
            variables: {
                tagName: "",
                projectId: project.id
            }
        });
    }, [
        applyUpsertParagraphTag,
        project.id
    ]);
    const updateTag = (0, $jMaZ8.useCallback)((tagId)=>({ target: { value: tagName } })=>{
            debouncedUpdateTag(tagId, tagName);
            setLocalTags((tags)=>tags.map((tag)=>{
                    if (tag.id === tagId) return {
                        ...tag,
                        name: tagName
                    };
                    return tag;
                }));
        }, [
        debouncedUpdateTag
    ]);
    const deleteTag = (0, $jMaZ8.useCallback)((tagId)=>()=>{
            applyDeleteParagraphTag({
                variables: {
                    tagId: tagId
                }
            });
        }, [
        applyDeleteParagraphTag
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $6c81d73a7221ec93$export$e506a1d27d1eaa20,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h4", {
                children: t("project.actionBar.config.title")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h3", {
                children: t("project.actionBar.config.customColoration.title")
            }),
            customColors.map(({ key: key, color: color, label: label })=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    className: $6c81d73a7221ec93$export$e656ceb6fa117c2d,
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            onClick: ()=>setCustomColors(customColors.map((c)=>c.key === key ? null : c).filter((o)=>!!o)),
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $add96a083ff0f53e$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                            value: label,
                            onChange: (e)=>{
                                const { value: label } = e.target;
                                setCustomColors(customColors.map((color)=>{
                                    if (key === color.key) return {
                                        ...color,
                                        label: label
                                    };
                                    return color;
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                            type: "color",
                            value: color,
                            onChange: (e)=>{
                                const { value: value } = e.target;
                                setCustomColors(customColors.map((color)=>{
                                    if (key === color.key) return {
                                        ...color,
                                        color: value
                                    };
                                    return color;
                                }));
                            }
                        })
                    ]
                }, key)),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                className: $6c81d73a7221ec93$export$e16d8520af44a096,
                onClick: ()=>setCustomColors(customColors.concat({
                        key: (0, $882198a336e32ba0$export$2e2bcd8739ae039)(),
                        label: "",
                        color: "#000000"
                    })),
                children: t("project.actionBar.config.customColoration.add")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c473702f98ad3dd9$export$2e2bcd8739ae039), {
                className: $6c81d73a7221ec93$export$e8c9778bf415dd08
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h3", {
                children: t("project.actionBar.config.customParagraphTag.title")
            }),
            localTags.map((tag)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    className: $6c81d73a7221ec93$export$e656ceb6fa117c2d,
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            onClick: deleteTag(tag.id),
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $add96a083ff0f53e$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                            value: tag.name,
                            onChange: updateTag(tag.id)
                        })
                    ]
                }, tag.id)),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                className: $6c81d73a7221ec93$export$e16d8520af44a096,
                onClick: createTag,
                children: t("project.actionBar.config.customParagraphTag.add")
            })
        ]
    });
}



parcelRequire("jMaZ8");

parcelRequire("jMaZ8");
var $f5377c853303629e$export$35d34bc0ed591a92;
var $f5377c853303629e$export$2ba01fb71ed41cb6;
var $f5377c853303629e$export$4bf4c7161ad6503e;
var $f5377c853303629e$export$9a9b59e08de24cef;
var $f5377c853303629e$export$b1bc8081da8c9e77;
var $f5377c853303629e$export$e8c9778bf415dd08;
var $f5377c853303629e$export$3f816c58b8ef2dc;
var $f5377c853303629e$export$2612087cf48ded35;
var $f5377c853303629e$export$2cedfd664bb3bd01;
var $f5377c853303629e$export$a2f4ab193af00c50;
var $f5377c853303629e$export$18bdcad4c5128f5a;
var $f5377c853303629e$export$6653e9553d4513a1;
var $f5377c853303629e$export$1ccfc900367530a2;
var $f5377c853303629e$export$34e0f9847d4c02dd;
var $f5377c853303629e$export$5e830f5ba038cc3c;
$f5377c853303629e$export$35d34bc0ed591a92 = "step_7db6a7";
$f5377c853303629e$export$2ba01fb71ed41cb6 = "button_7db6a7";
$f5377c853303629e$export$4bf4c7161ad6503e = "legendAndButton_7db6a7";
$f5377c853303629e$export$9a9b59e08de24cef = "legend_7db6a7";
$f5377c853303629e$export$b1bc8081da8c9e77 = "complete_7db6a7";
$f5377c853303629e$export$e8c9778bf415dd08 = "divider_7db6a7";
$f5377c853303629e$export$3f816c58b8ef2dc = "narrationState_7db6a7";
$f5377c853303629e$export$2612087cf48ded35 = "progressContainer_7db6a7";
$f5377c853303629e$export$2cedfd664bb3bd01 = "textContainer_7db6a7";
$f5377c853303629e$export$a2f4ab193af00c50 = "progressTitle_7db6a7";
$f5377c853303629e$export$18bdcad4c5128f5a = "iconChecked_7db6a7";
$f5377c853303629e$export$6653e9553d4513a1 = "progressBarLegend_7db6a7";
$f5377c853303629e$export$1ccfc900367530a2 = "buttonMarkBookAsDone_7db6a7";
$f5377c853303629e$export$34e0f9847d4c02dd = "container_7db6a7";
$f5377c853303629e$export$5e830f5ba038cc3c = "stepBookCompleted_7db6a7";




parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");




const { Text: $edfcab29e5a18ee2$var$Text } = (0, $862be0e46f705052$export$2e2bcd8739ae039);
function $edfcab29e5a18ee2$export$2e2bcd8739ae039({ preparationProgress: preparationProgress, markAsReadyForNarration: markAsReadyForNarration, completePreparation: completePreparation }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $f5377c853303629e$export$4bf4c7161ad6503e,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($edfcab29e5a18ee2$var$Text, {
                        className: $f5377c853303629e$export$9a9b59e08de24cef,
                        type: "secondary",
                        children: preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).READY_FOR_NARRATION || preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE ? t("project.actionBar.progress.prepared.legendTasksForNarrationComplete") : t("project.actionBar.progress.preparing.legendReadyToNarrate")
                    }),
                    preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).NOT_READY ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        className: $f5377c853303629e$export$2ba01fb71ed41cb6,
                        onClick: markAsReadyForNarration,
                        type: "primary",
                        children: t("project.actionBar.progress.preparing.buttonReadyToNarrate")
                    }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($f5377c853303629e$export$2ba01fb71ed41cb6, $f5377c853303629e$export$b1bc8081da8c9e77),
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5f87f9a2c863bb2b$export$2e2bcd8739ae039), {}),
                        children: t("project.actionBar.progress.prepared.buttonReadyToNarrate")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $f5377c853303629e$export$4bf4c7161ad6503e,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($edfcab29e5a18ee2$var$Text, {
                        className: $f5377c853303629e$export$9a9b59e08de24cef,
                        type: "secondary",
                        children: preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE ? t("project.actionBar.progress.prepared.legendPreparationComplete") : t("project.actionBar.progress.preparing.legendPreparationComplete")
                    }),
                    preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        type: "primary",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($f5377c853303629e$export$2ba01fb71ed41cb6, $f5377c853303629e$export$b1bc8081da8c9e77),
                        onClick: undefined,
                        icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5f87f9a2c863bb2b$export$2e2bcd8739ae039), {}),
                        children: t("project.actionBar.progress.prepared.buttonPreparationComplete")
                    }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        type: "primary",
                        className: $f5377c853303629e$export$2ba01fb71ed41cb6,
                        onClick: completePreparation,
                        disabled: preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).NOT_READY,
                        children: t("project.actionBar.progress.preparing.buttonPreparationComplete")
                    })
                ]
            })
        ]
    });
}


function $acffaefffefb2582$export$2e2bcd8739ae039({ markAsReadyForNarration: markAsReadyForNarration, preparationProgress: preparationProgress }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $f5377c853303629e$export$35d34bc0ed591a92,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h4", {
                children: t("project.actionBar.progress.preparing.title")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $edfcab29e5a18ee2$export$2e2bcd8739ae039), {
                markAsReadyForNarration: markAsReadyForNarration,
                preparationProgress: preparationProgress
            })
        ]
    });
}




parcelRequire("jMaZ8");




parcelRequire("jMaZ8");




parcelRequire("jMaZ8");



const $805f5b10e83e708d$export$8f45430ccf837300 = {
    UNFOCUSED_REGION: "rgba(0, 40, 0, 0.1)",
    FOCUSED_REGION: "rgba(0, 0, 255, 0.3)",
    UNFOCUSED_HANDLE: "black",
    FOCUSED_HANDLE: "red",
    OUTSIDE_REGIONS: "rgba(0,0,0,0)",
    BLUE_GREY: "#353a52",
    GREEN: "#61c374",
    ORANGE: "#E66525",
    GREY_DISABLED: "#c5c5c5"
};


const { Text: $b9fe0f939c11df9e$var$Text } = (0, $862be0e46f705052$export$2e2bcd8739ae039);
function $b9fe0f939c11df9e$export$2e2bcd8739ae039({ title: title, legend: legend, percent: percent }) {
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $f5377c853303629e$export$2612087cf48ded35,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $f5377c853303629e$export$2cedfd664bb3bd01,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($b9fe0f939c11df9e$var$Text, {
                        className: $f5377c853303629e$export$a2f4ab193af00c50,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        children: [
                            percent === 100 && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5f87f9a2c863bb2b$export$2e2bcd8739ae039), {
                                className: $f5377c853303629e$export$18bdcad4c5128f5a
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($b9fe0f939c11df9e$var$Text, {
                                className: $f5377c853303629e$export$6653e9553d4513a1,
                                type: "secondary",
                                children: legend
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $eef464bb94d68b8c$export$2e2bcd8739ae039), {
                percent: percent,
                strokeColor: (0, $805f5b10e83e708d$export$8f45430ccf837300).BLUE_GREY,
                showInfo: false,
                strokeWidth: 3
            })
        ]
    });
}



var $giSak = parcelRequire("giSak");

// This function is to test whether a variable is null, undefined or an ampty string.
const $1abea94550147a73$export$dd1bc94b04021eeb = (val)=>val === undefined || val == null || val.length <= 0;
const $1abea94550147a73$export$360dc50351b2b778 = (n, precision = 1)=>Math.round(n * Math.pow(10, precision)) / Math.pow(10, precision);



function $633bd8176e03053f$export$2e2bcd8739ae039({ stats: stats, preparationProgress: preparationProgress, isNarrationComplete: isNarrationComplete, completeNarration: completeNarration, finalComplete: finalComplete }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const { pages: pages, definitions: definitions, proofListening: proofListening, fixes: fixes, canValidate: canValidate } = stats;
    const canMarkAsCompleted = isNarrationComplete && preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $f5377c853303629e$export$3f816c58b8ef2dc,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b9fe0f939c11df9e$export$2e2bcd8739ae039), {
                title: t("project.actionBar.progress.narration.narratedPages"),
                legend: `${pages.narrated}/${pages.total}`,
                percent: pages.progress
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b9fe0f939c11df9e$export$2e2bcd8739ae039), {
                title: t("project.actionBar.progress.narration.narratedDefinitions"),
                legend: `${definitions.narrated}/${definitions.total}`,
                percent: definitions.progress
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b9fe0f939c11df9e$export$2e2bcd8739ae039), {
                title: t("project.actionBar.progress.narration.proofListening"),
                legend: `${(0, $1abea94550147a73$export$360dc50351b2b778)(proofListening.progress, 0)}%`,
                percent: proofListening.progress
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b9fe0f939c11df9e$export$2e2bcd8739ae039), {
                title: t("project.actionBar.progress.narration.remainingCorrections"),
                legend: fixes.remaining.toString(),
                percent: fixes.remaining ? 0 : 100
            }),
            !isNarrationComplete ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($f5377c853303629e$export$2ba01fb71ed41cb6, $f5377c853303629e$export$1ccfc900367530a2),
                type: "primary",
                disabled: !canValidate,
                onClick: completeNarration,
                children: t("project.actionBar.progress.narration.markNarrationDone")
            }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($f5377c853303629e$export$2ba01fb71ed41cb6, $f5377c853303629e$export$1ccfc900367530a2, $f5377c853303629e$export$b1bc8081da8c9e77),
                type: "primary",
                disabled: !canValidate,
                onClick: undefined,
                icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5f87f9a2c863bb2b$export$2e2bcd8739ae039), {}),
                children: t("project.actionBar.progress.narration.narrationDone")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($f5377c853303629e$export$2ba01fb71ed41cb6, $f5377c853303629e$export$1ccfc900367530a2),
                type: "primary",
                disabled: !canMarkAsCompleted,
                onClick: finalComplete,
                children: t("project.actionBar.progress.preparationAndNarration.markBookComplete")
            })
        ]
    });
}



const $1ad7bdbe1a070289$var$getTitleKey = (isNarrationComplete, preparationProgress)=>{
    if (isNarrationComplete && preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE) return "project.actionBar.progress.title_state_narrationAndFixComplete";
    if (isNarrationComplete) return "project.actionBar.progress.title_state_narrationComplete";
    return "project.actionBar.progress.title_state_narration";
};
function $1ad7bdbe1a070289$export$2e2bcd8739ae039({ preparationProgress: preparationProgress, isNarrationComplete: isNarrationComplete, completePreparation: completePreparation, completeNarration: completeNarration, finalComplete: finalComplete, stats: stats }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $f5377c853303629e$export$35d34bc0ed591a92,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h4", {
                children: t($1ad7bdbe1a070289$var$getTitleKey(isNarrationComplete, preparationProgress))
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $f5377c853303629e$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h5", {
                                children: t("project.actionBar.progress.narration.title")
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $633bd8176e03053f$export$2e2bcd8739ae039), {
                                stats: stats,
                                preparationProgress: preparationProgress,
                                isNarrationComplete: isNarrationComplete,
                                completeNarration: completeNarration,
                                finalComplete: finalComplete
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $f5377c853303629e$export$e8c9778bf415dd08,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h5", {
                                children: t("project.actionBar.progress.preparing.title")
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $edfcab29e5a18ee2$export$2e2bcd8739ae039), {
                                preparationProgress: preparationProgress,
                                completePreparation: completePreparation
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("jMaZ8");





var $giSak = parcelRequire("giSak");
const { Text: $06e7204a8ac4e48e$var$Text } = (0, $862be0e46f705052$export$2e2bcd8739ae039);
function $06e7204a8ac4e48e$export$2e2bcd8739ae039({ archiveProject: archiveProject }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($6c81d73a7221ec93$export$504d7abb21fa8c9, $f5377c853303629e$export$5e830f5ba038cc3c),
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h4", {
                children: t("project.actionBar.progress.title_state_bookCompleted")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $f5377c853303629e$export$4bf4c7161ad6503e,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($06e7204a8ac4e48e$var$Text, {
                        className: $f5377c853303629e$export$9a9b59e08de24cef,
                        type: "secondary",
                        children: t("project.actionBar.progress.bookCompleted.legend")
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($06e7204a8ac4e48e$var$Text, {
                        className: $f5377c853303629e$export$9a9b59e08de24cef,
                        type: "secondary",
                        children: t("project.actionBar.progress.bookCompleted.legendBis")
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        className: $f5377c853303629e$export$2ba01fb71ed41cb6,
                        onClick: archiveProject,
                        children: t("project.actionBar.progress.bookCompleted.button")
                    })
                ]
            })
        ]
    });
}





parcelRequire("jMaZ8");



function $49a4c9440ce4232a$export$2e2bcd8739ae039({ unarchiveProject: unarchiveProject }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $f5377c853303629e$export$35d34bc0ed591a92,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h4", {
                children: t("project.actionBar.progress.archived.title")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $f5377c853303629e$export$34e0f9847d4c02dd,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    className: $f5377c853303629e$export$2ba01fb71ed41cb6,
                    onClick: unarchiveProject,
                    type: "primary",
                    children: t("project.actionBar.progress.archived.buttonUnarchive")
                })
            })
        ]
    });
}


const $59b29390377f63b6$var$defaultProject = {
    preparationProgress: undefined,
    status: undefined,
    isNarrationComplete: false
};
function $59b29390377f63b6$export$2e2bcd8739ae039({ projectProgressHook: projectProgressHook }) {
    const { project: project, markAsReadyForNarration: markAsReadyForNarration, completePreparation: completePreparation, completeNarration: completeNarration, finalComplete: finalComplete, archiveProject: archiveProject, unarchiveProject: unarchiveProject, isLoading: isLoading, stats: stats } = projectProgressHook;
    const { preparationProgress: preparationProgress, status: status, isNarrationComplete: isNarrationComplete } = project || $59b29390377f63b6$var$defaultProject;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $6c81d73a7221ec93$export$504d7abb21fa8c9,
        children: [
            preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).NOT_READY && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $acffaefffefb2582$export$2e2bcd8739ae039), {
                preparationProgress: preparationProgress,
                markAsReadyForNarration: markAsReadyForNarration
            }),
            (preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).READY_FOR_NARRATION || preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE) && status !== (0, $b522cf181e75e62d$export$d38212884f7bc925).COMPLETE && status !== (0, $b522cf181e75e62d$export$d38212884f7bc925).ARCHIVED && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1ad7bdbe1a070289$export$2e2bcd8739ae039), {
                stats: stats,
                preparationProgress: preparationProgress,
                isNarrationComplete: isNarrationComplete,
                completePreparation: completePreparation,
                completeNarration: completeNarration,
                finalComplete: finalComplete
            }),
            status === (0, $b522cf181e75e62d$export$d38212884f7bc925).COMPLETE && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $06e7204a8ac4e48e$export$2e2bcd8739ae039), {
                archiveProject: archiveProject
            }),
            status === (0, $b522cf181e75e62d$export$d38212884f7bc925).ARCHIVED && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $49a4c9440ce4232a$export$2e2bcd8739ae039), {
                unarchiveProject: unarchiveProject
            }),
            isLoading && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $6c81d73a7221ec93$export$140fd7bd1291a3e4,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {})
            })
        ]
    });
}



var $8bca6d352727cbab$var$TabsEnum = /*#__PURE__*/ function($8bca6d352727cbab$var$TabsEnum) {
    $8bca6d352727cbab$var$TabsEnum["Informations"] = "Informations";
    $8bca6d352727cbab$var$TabsEnum["Checklist"] = "Checklist";
    $8bca6d352727cbab$var$TabsEnum["Access"] = "Access";
    $8bca6d352727cbab$var$TabsEnum["Config"] = "Config";
    $8bca6d352727cbab$var$TabsEnum["Progress"] = "Progress";
    return $8bca6d352727cbab$var$TabsEnum;
}($8bca6d352727cbab$var$TabsEnum || {});
function $8bca6d352727cbab$export$2e2bcd8739ae039({ project: project, projectProgressHook: projectProgressHook }) {
    const [currentTab, setCurrentTab] = (0, $jMaZ8.useState)("Informations");
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.actionBar.projectTabs";
    const tabItems = (0, $jMaZ8.useMemo)(()=>[
            (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                key: "Informations",
                label: t(`${i18nKey}.info`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $127ea07f7e4c11ee$export$2e2bcd8739ae039), {
                    project: project
                })
            }),
            (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                key: "Access",
                label: t(`${i18nKey}.access`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b0659728937442e4$export$2e2bcd8739ae039), {
                    userBasedAccess: project.userBasedAccess || [],
                    roles: project.roles,
                    projectId: project.id
                })
            }),
            (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                key: "Config",
                label: t(`${i18nKey}.config`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $bef37b9d8980e338$export$2e2bcd8739ae039), {
                    project: project
                })
            }),
            (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                key: "Progress",
                label: t(`${i18nKey}.progress`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $59b29390377f63b6$export$2e2bcd8739ae039), {
                    project: project,
                    projectProgressHook: projectProgressHook
                })
            })
        ], [
        project,
        projectProgressHook,
        t
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3d078c5b7a14a8e5$export$2e2bcd8739ae039), {
        className: $6c81d73a7221ec93$export$39f5674517ec0000,
        activeKey: currentTab,
        tabPosition: "left",
        onChange: (key)=>setCurrentTab(key),
        items: tabItems
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");




var $jMaZ8 = parcelRequire("jMaZ8");
const $0b9fbc459d0327d6$var$getPagesNarrationProgress = (rhesesAudioInfo)=>{
    const gpByPageId = (0, (/*@__PURE__*/$parcel$interopDefault($9434db2d28cdae1f$exports)))(rhesesAudioInfo, "pageId");
    let narrated = 0;
    let notNarrated = 0;
    Object.keys(gpByPageId).map((pageId)=>{
        const pageItems = gpByPageId[pageId];
        const isPageNarrated = !pageItems.find((item)=>item.count > 0 && item.withAudio === false);
        if (isPageNarrated) narrated++;
        else notNarrated++;
    });
    const pagesCount = notNarrated + narrated;
    return {
        narrated: narrated,
        notNarrated: notNarrated,
        progress: pagesCount === 0 ? 0 : narrated / pagesCount * 100,
        total: pagesCount
    };
};
const $0b9fbc459d0327d6$var$getDefinitionsProgress = (definitionsAudioInfo)=>{
    const gpBy = (0, (/*@__PURE__*/$parcel$interopDefault($9434db2d28cdae1f$exports)))(definitionsAudioInfo, "withAudio");
    let narrated = 0;
    let notNarrated = 0;
    gpBy?.true?.forEach((definitions)=>{
        narrated += definitions.count;
    });
    gpBy?.false?.forEach((definitions)=>{
        notNarrated += definitions.count;
    });
    const definitionsCount = notNarrated + narrated;
    return {
        narrated: narrated,
        notNarrated: notNarrated,
        progress: definitionsCount === 0 ? 100 : narrated / definitionsCount * 100,
        total: definitionsCount
    };
};
const $0b9fbc459d0327d6$var$getProofListeningProgress = (rhesesAudioInfo, definitionsAudioInfo)=>{
    /**
   * Rheses
   */ const rhesesGpBy = (0, (/*@__PURE__*/$parcel$interopDefault($9434db2d28cdae1f$exports)))(rhesesAudioInfo, "withReview");
    let rhesesReviewed = 0;
    let rhesesNotReviewed = 0;
    rhesesGpBy?.true?.forEach((rheses)=>{
        rhesesReviewed += rheses.count;
    });
    rhesesGpBy?.false?.forEach((rheses)=>{
        rhesesNotReviewed += rheses.count;
    });
    /**
   * Definitions
   */ const definitionsGpBy = (0, (/*@__PURE__*/$parcel$interopDefault($9434db2d28cdae1f$exports)))(definitionsAudioInfo, "withReview");
    let definitionsReviewed = 0;
    let definitionsNotReviewed = 0;
    definitionsGpBy?.true?.forEach((definitions)=>{
        definitionsReviewed += definitions.count;
    });
    definitionsGpBy?.false?.forEach((definitions)=>{
        definitionsNotReviewed += definitions.count;
    });
    /**
   * Merge
   */ const reviewed = rhesesReviewed + definitionsReviewed;
    const notReviewed = rhesesNotReviewed + definitionsNotReviewed;
    const total = reviewed + notReviewed;
    return {
        reviewed: reviewed,
        notReviewed: notReviewed,
        progress: reviewed / total * 100,
        total: total
    };
};
const $0b9fbc459d0327d6$var$getRemainingFixes = (rhesesAudioInfo, definitionsAudioInfo)=>{
    /**
   * Rheses
   */ const rhesesGpBy = (0, (/*@__PURE__*/$parcel$interopDefault($9434db2d28cdae1f$exports)))(rhesesAudioInfo, "withReview");
    let rhesesReviewsNotValid = 0;
    rhesesGpBy?.true?.forEach((rheses)=>{
        if (!rheses.isReviewValid) rhesesReviewsNotValid += rheses.count;
    });
    /**
   * Definitions
   */ const definitionsGpBy = (0, (/*@__PURE__*/$parcel$interopDefault($9434db2d28cdae1f$exports)))(definitionsAudioInfo, "withReview");
    let definitionsReviewsNotValid = 0;
    definitionsGpBy?.true?.forEach((definitions)=>{
        if (!definitions.isReviewValid) definitionsReviewsNotValid += definitions.count;
    });
    return {
        remaining: rhesesReviewsNotValid + definitionsReviewsNotValid
    };
};
function $0b9fbc459d0327d6$export$2e2bcd8739ae039(project) {
    const stats = (0, $jMaZ8.useMemo)(()=>{
        if (!project) return {
            canValidate: false,
            pages: {
                narrated: 0,
                notNarrated: 0,
                progress: 0,
                total: 0
            },
            definitions: {
                narrated: 0,
                notNarrated: 0,
                progress: 0,
                total: 0
            },
            proofListening: {
                reviewed: 0,
                notReviewed: 0,
                progress: 0,
                total: 0
            },
            fixes: {
                remaining: 0
            }
        };
        const { rhesesAudioInfo: rhesesAudioInfo, definitionsAudioInfo: definitionsAudioInfo } = project;
        const stats = {
            pages: $0b9fbc459d0327d6$var$getPagesNarrationProgress(rhesesAudioInfo),
            definitions: $0b9fbc459d0327d6$var$getDefinitionsProgress(definitionsAudioInfo),
            proofListening: $0b9fbc459d0327d6$var$getProofListeningProgress(rhesesAudioInfo, definitionsAudioInfo),
            fixes: $0b9fbc459d0327d6$var$getRemainingFixes(rhesesAudioInfo, definitionsAudioInfo)
        };
        return {
            canValidate: stats.pages.progress === 100 && stats.proofListening.progress === 100 && stats.definitions.progress === 100 && stats.fixes.remaining === 0,
            ...stats
        };
    }, [
        project
    ]);
    return {
        ...stats
    };
}


const $9c7a17af38f526bc$export$c79dce2205daa75e = (project)=>project?.isDoingAudioResync;
const $9c7a17af38f526bc$var$defaultProject = {
    id: null,
    status: "",
    preparationProgress: "",
    isNarrationComplete: false
};
function $9c7a17af38f526bc$export$2e2bcd8739ae039(project) {
    const [setProjectAsComplete] = (0, $d7188398173686a1$export$a079f68e1f5fb526)();
    const [setProjectAsArchived] = (0, $d7188398173686a1$export$6c32ad121c90a9db)();
    const [setRestoreProject] = (0, $d7188398173686a1$export$5d6e3f8cef10142b)();
    const [updateProjectPreparationProgress] = (0, $d7188398173686a1$export$cf9e011719de80d1)();
    const [updateProjectNarrationCompleteness] = (0, $d7188398173686a1$export$dbf72e488731955d)();
    const { preparationProgress: preparationProgress, status: status, isNarrationComplete: isNarrationComplete } = project || $9c7a17af38f526bc$var$defaultProject;
    const [isLoading, setIsLoading] = (0, $jMaZ8.useState)(false);
    /**
   * Methods to update "status" or "preparationProgress"
   */ const markAsReadyForNarration = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            await updateProjectPreparationProgress({
                variables: {
                    projectId: project?.id,
                    preparationProgress: (0, $b522cf181e75e62d$export$3f684fc5c7851f91).READY_FOR_NARRATION
                }
            });
        } catch (e) {
            console.error("markAsReadyForNarration error", e);
        } finally{
            setIsLoading(false);
        }
    }, [
        project?.id,
        updateProjectPreparationProgress
    ]);
    const completePreparation = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            await updateProjectPreparationProgress({
                variables: {
                    projectId: project?.id,
                    preparationProgress: (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE
                }
            });
        } catch (e) {
            console.error("completePreparation error", e);
        } finally{
            setIsLoading(false);
        }
    }, [
        project?.id,
        updateProjectPreparationProgress
    ]);
    const completeNarration = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            await updateProjectNarrationCompleteness({
                variables: {
                    projectId: project?.id,
                    isNarrationComplete: true
                }
            });
        } catch (e) {
            console.error("completeNarration error", e);
        } finally{
            setIsLoading(false);
        }
    }, [
        project?.id,
        updateProjectNarrationCompleteness
    ]);
    const finalComplete = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            await setProjectAsComplete({
                variables: {
                    projectId: project?.id
                }
            });
        } catch (e) {
            console.error("finalComplete error", e);
        } finally{
            setIsLoading(false);
        }
    }, [
        project?.id,
        setProjectAsComplete
    ]);
    const archiveProject = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            await setProjectAsArchived({
                variables: {
                    projectId: project?.id
                }
            });
        } catch (e) {
            console.error("archiveProject error", e);
        } finally{
            setIsLoading(false);
        }
    }, [
        project,
        setProjectAsArchived
    ]);
    const unarchiveProject = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            await setRestoreProject({
                variables: {
                    projectId: project?.id
                }
            });
        } catch (e) {
            console.error("archiveProject error", e);
        } finally{
            setIsLoading(false);
        }
    }, [
        project,
        setRestoreProject
    ]);
    /**
   * Get the label status
   */ const bookStatusLabel = (0, $jMaZ8.useMemo)(()=>{
        if (project && $9c7a17af38f526bc$export$c79dce2205daa75e(project)) return "RESYNC";
        else if (status === (0, $b522cf181e75e62d$export$d38212884f7bc925).COMPLETE || status === (0, $b522cf181e75e62d$export$d38212884f7bc925).ARCHIVED) {
            if (status === (0, $b522cf181e75e62d$export$d38212884f7bc925).COMPLETE) return "COMPLETE_BOOK";
            return status;
        } else if (isNarrationComplete && preparationProgress !== (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE) return "NARRATION_COMPLETE";
        else if (!isNarrationComplete && preparationProgress !== (0, $b522cf181e75e62d$export$3f684fc5c7851f91).NOT_READY) return "READY_FOR_NARRATION";
        else if (preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).NOT_READY || preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).READY_FOR_NARRATION || preparationProgress === (0, $b522cf181e75e62d$export$3f684fc5c7851f91).COMPLETE) return preparationProgress;
        return "";
    }, [
        status,
        preparationProgress,
        isNarrationComplete,
        project
    ]);
    /**
   * Stats
   */ const stats = (0, $0b9fbc459d0327d6$export$2e2bcd8739ae039)(project);
    return {
        project: project,
        markAsReadyForNarration: markAsReadyForNarration,
        completePreparation: completePreparation,
        completeNarration: completeNarration,
        finalComplete: finalComplete,
        archiveProject: archiveProject,
        unarchiveProject: unarchiveProject,
        bookStatusLabel: bookStatusLabel,
        isLoading: isLoading,
        stats: stats
    };
}





const $18be123e5a631dc8$var$panelVariants = {
    visible: {
        opacity: 1,
        y: "0%"
    },
    hidden: {
        opacity: 0,
        y: "100%"
    }
};
const $18be123e5a631dc8$var$bgVariants = {
    visible: {
        opacity: 1
    },
    hidden: {
        opacity: 0
    }
};
function $18be123e5a631dc8$export$2e2bcd8739ae039({ isVisible: isVisible, projectId: projectId, close: close }) {
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const { loading: loading, data: data } = (0, $d7188398173686a1$export$6ed06f11bf137590)({
        id: projectId,
        withInfo: true,
        withAudioInfo: true
    }, {
        skip: !isVisible
    });
    const project = (0, $jMaZ8.useMemo)(()=>data?.project && data?.project[0], [
        data?.project
    ]);
    const projectRef = (0, $jMaZ8.useRef)(project);
    (0, $jMaZ8.useEffect)(()=>{
        if (project) projectRef.current = project;
    }, [
        project
    ]);
    const [applyRemoveProjectFromCache] = (0, $d7188398173686a1$export$1fb87fa1fa7c9269)();
    const isAdmin = (0, $dc10a25720c6edc8$export$99a5e4bc80d231ca)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const lastLoadedProject = (0, $jMaZ8.useMemo)(()=>project || projectRef.current, [
        project
    ]);
    const projectProgressHook = (0, $9c7a17af38f526bc$export$2e2bcd8739ae039)(lastLoadedProject);
    const { bookStatusLabel: bookStatusLabel } = projectProgressHook;
    const shouldShowSpinner = (0, $jMaZ8.useMemo)(()=>{
        if (projectRef.current) return false;
        if (!project) return true;
        if (loading) return true;
        return false;
    }, [
        loading,
        project
    ]);
    const reload = (0, $jMaZ8.useCallback)(async ()=>{
        await applyRemoveProjectFromCache({
            variables: {
                projectId: projectId
            }
        });
        navigate(0);
    }, [
        applyRemoveProjectFromCache,
        projectId,
        navigate
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        className: $6c81d73a7221ec93$export$d11afefa28acd161,
        initial: "hidden",
        animate: isVisible ? "visible" : "hidden",
        style: {
            pointerEvents: isVisible ? "initial" : "none"
        },
        transition: {
            bounce: 0,
            delay: 0.2
        },
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                className: $6c81d73a7221ec93$export$cd4622fd46db32c7,
                onClick: close,
                variants: $18be123e5a631dc8$var$bgVariants,
                transition: {
                    bounce: 0,
                    delay: 0
                }
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                transition: {
                    bounce: 0,
                    delay: 0,
                    duration: 0.2
                },
                variants: $18be123e5a631dc8$var$panelVariants,
                className: $6c81d73a7221ec93$export$908ffd203f34ac22,
                children: [
                    shouldShowSpinner && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $de3c5dab5cbf9179$export$7f7cbe89f1eacd2), {
                        style: {
                            width: "100%"
                        }
                    }),
                    !shouldShowSpinner && lastLoadedProject && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                className: $6c81d73a7221ec93$export$4bdbf921f0c0fd8c,
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h3", {
                                        className: $6c81d73a7221ec93$export$a8ff84c12d48cfa6,
                                        children: lastLoadedProject.name
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                        className: $6c81d73a7221ec93$export$571b02044ddb2ab3,
                                        children: lastLoadedProject.author
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $978012cac829448d$export$2e2bcd8739ae039), {
                                        className: $6c81d73a7221ec93$export$c811345782c7e053,
                                        bookStatusLabel: bookStatusLabel
                                    }),
                                    isAdmin && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                        shape: "round",
                                        onClick: reload,
                                        className: $6c81d73a7221ec93$export$d0c9705ad8865b5b,
                                        children: t("reload.project")
                                    })
                                ]
                            }),
                            isVisible && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8bca6d352727cbab$export$2e2bcd8739ae039), {
                                project: lastLoadedProject,
                                projectProgressHook: projectProgressHook
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



const { Header: $a3e12b6d8e85d828$var$Header } = (0, $a3bb6174129512e9$export$2e2bcd8739ae039);
function $a3e12b6d8e85d828$export$2e2bcd8739ae039({ projectId: projectId, toggleSearch: toggleSearch, toggleEdition: toggleEdition }) {
    const { project: project, bookLoading: loading } = (0, $5b38bec19e3a4e47$export$51b1383ef8844a7)({
        projectId: projectId
    });
    const location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const ref = (0, $jMaZ8.useRef)(null);
    const [isPanelOpen, setIsPanelOpen] = (0, $jMaZ8.useState)(false);
    const lastPart = (location.pathname.match(/[^/]*$/) || [
        ""
    ])[0];
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const i18nKey = "project.actionBar.default.tabPaneTitle";
    const navigateToTab = (tabPath)=>{
        navigate({
            pathname: window.location.pathname.replace(/[^/]*$/, tabPath),
            search: window.location.search,
            hash: window.location.hash
        });
    };
    if (!loading && !project) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$444b3ab0cb9aec40), {
        to: "/"
    });
    if (!project) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $7c482fd6f1ef0110$export$cc74dcc53cfce4eb,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($a3e12b6d8e85d828$var$Header, {
            id: $7c482fd6f1ef0110$export$38e42c68cf43b5d4,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $de3c5dab5cbf9179$export$7f7cbe89f1eacd2), {})
        })
    });
    const tabItems = [
        (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
            key: "1",
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                getPopupContainer: ()=>ref.current || document.body,
                title: t(`${i18nKey}.preview`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5f0712d9dc470fa0$export$2e2bcd8739ae039), {})
            })
        }),
        (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
            key: "2",
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                getPopupContainer: ()=>ref.current || document.body,
                title: t(`${i18nKey}.rhese`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1128bd624ab2fd7f$export$2e2bcd8739ae039), {})
            })
        }),
        (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
            key: "3",
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                getPopupContainer: ()=>ref.current || document.body,
                title: t(`${i18nKey}.formatting`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $aefd243f9e158011$export$2e2bcd8739ae039), {})
            })
        }),
        (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
            key: "4",
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                getPopupContainer: ()=>ref.current || document.body,
                title: t(`${i18nKey}.definitions`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2f068923fce3cc12$export$2e2bcd8739ae039), {})
            })
        }),
        (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
            key: "5",
            disabled: true,
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                getPopupContainer: ()=>ref.current || document.body,
                title: t(`${i18nKey}.dialogues`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $358bf2bb0ff56460$export$2e2bcd8739ae039), {
                    style: {
                        opacity: 0.5
                    }
                })
            })
        }),
        (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
            key: "6",
            label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                getPopupContainer: ()=>ref.current || document.body,
                title: t(`${i18nKey}.syllables`),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $73693f7406aa3821$export$2e2bcd8739ae039), {})
            })
        })
    ];
    const content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("nav", {
                className: $7c482fd6f1ef0110$export$80e4b313e5e6b30d,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $54720e62f7bfcab9$export$a6c7ac8248d6e38a), {
                        className: $7c482fd6f1ef0110$export$db3c28d99448dcff,
                        to: "/",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $23142ffe47fff107$export$2e2bcd8739ae039), {})
                    }),
                    ">",
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("button", {
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsPanelOpen(!isPanelOpen);
                        },
                        children: project.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                ref: ref,
                style: {
                    position: "absolute",
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3d078c5b7a14a8e5$export$2e2bcd8739ae039), {
                defaultActiveKey: (0, $faf74e6dbebab232$export$a0dca76daac4ca4c)[lastPart] || "1",
                tabPosition: "bottom",
                id: $7c482fd6f1ef0110$export$39f5674517ec0000,
                onChange: (key)=>{
                    switch(key){
                        case "1":
                            return navigateToTab("overview");
                        case "2":
                            return navigateToTab("rhese");
                        case "3":
                            return navigateToTab("format");
                        case "4":
                            return navigateToTab("definition");
                        case "5":
                            return navigateToTab("dialogue");
                        case "6":
                            return navigateToTab("syllable");
                        case "7":
                            return navigateToTab("narration");
                    }
                },
                centered: true,
                items: tabItems
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $7c482fd6f1ef0110$export$d76128d007d19019,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        onClick: toggleEdition,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5453b18558c87ec6$export$2e2bcd8739ae039), {
                            style: {
                                fontSize: "2em"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        onClick: toggleSearch,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $7707703e157f8963$export$2e2bcd8739ae039), {
                            style: {
                                fontSize: "2em"
                            }
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $7c482fd6f1ef0110$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $18be123e5a631dc8$export$2e2bcd8739ae039), {
                projectId: projectId,
                close: ()=>setIsPanelOpen(false),
                isVisible: isPanelOpen
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($a3e12b6d8e85d828$var$Header, {
                id: $7c482fd6f1ef0110$export$38e42c68cf43b5d4,
                children: content
            })
        ]
    });
}










var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $9d17f6382988d542$var$ClearOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6a25.95 25.95 0 0025.6 30.4h723c1.5 0 3-.1 4.4-.4a25.88 25.88 0 0021.2-30zM204 390h272V182h72v208h272v104H204V390zm468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z"
                }
            }
        ]
    },
    "name": "clear",
    "theme": "outlined"
};
var $9d17f6382988d542$export$2e2bcd8739ae039 = $9d17f6382988d542$var$ClearOutlined;



var $c67bdf6a1df26e5d$var$ClearOutlined = function ClearOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $9d17f6382988d542$export$2e2bcd8739ae039)
    }));
};
/**![clear](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik04OTkuMSA4NjkuNmwtNTMtMzA1LjZIODY0YzE0LjQgMCAyNi0xMS42IDI2LTI2VjM0NmMwLTE0LjQtMTEuNi0yNi0yNi0yNkg2MThWMTM4YzAtMTQuNC0xMS42LTI2LTI2LTI2SDQzMmMtMTQuNCAwLTI2IDExLjYtMjYgMjZ2MTgySDE2MGMtMTQuNCAwLTI2IDExLjYtMjYgMjZ2MTkyYzAgMTQuNCAxMS42IDI2IDI2IDI2aDE3LjlsLTUzIDMwNS42YTI1Ljk1IDI1Ljk1IDAgMDAyNS42IDMwLjRoNzIzYzEuNSAwIDMtLjEgNC40LS40YTI1Ljg4IDI1Ljg4IDAgMDAyMS4yLTMwek0yMDQgMzkwaDI3MlYxODJoNzJ2MjA4aDI3MnYxMDRIMjA0VjM5MHptNDY4IDQ0MFY2NzRjMC00LjQtMy42LTgtOC04aC00OGMtNC40IDAtOCAzLjYtOCA4djE1Nkg0MTZWNjc0YzAtNC40LTMuNi04LTgtOGgtNDhjLTQuNCAwLTggMy42LTggOHYxNTZIMjAyLjhsNDUuMS0yNjBINzc2bDQ1LjEgMjYwSDY3MnoiIC8+PC9zdmc+) */ var $c67bdf6a1df26e5d$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($c67bdf6a1df26e5d$var$ClearOutlined);
$c67bdf6a1df26e5d$var$RefIcon.displayName = 'ClearOutlined';
var $c67bdf6a1df26e5d$export$2e2bcd8739ae039 = $c67bdf6a1df26e5d$var$RefIcon;



var $4917b6015e9e7869$export$e8e78c978b129247;
var $4917b6015e9e7869$export$d76128d007d19019;
var $4917b6015e9e7869$export$b7e3ae3d7c15e42e;
var $4917b6015e9e7869$export$9ed2cb8ad852077a;
var $4917b6015e9e7869$export$aaf36426b5008f7a;
var $4917b6015e9e7869$export$f2120bbfa5450bd2;
var $4917b6015e9e7869$export$209bc1d5cae595bb;
var $4917b6015e9e7869$export$22fa394f3ba39578;
$4917b6015e9e7869$export$e8e78c978b129247 = "root_b1db93";
$4917b6015e9e7869$export$d76128d007d19019 = "search_b1db93";
$4917b6015e9e7869$export$b7e3ae3d7c15e42e = "input_b1db93";
$4917b6015e9e7869$export$9ed2cb8ad852077a = "dropDownMenu_b1db93";
$4917b6015e9e7869$export$aaf36426b5008f7a = "result_b1db93";
$4917b6015e9e7869$export$f2120bbfa5450bd2 = "arrow_b1db93";
$4917b6015e9e7869$export$209bc1d5cae595bb = "nbResults_b1db93";
$4917b6015e9e7869$export$22fa394f3ba39578 = "pagination_b1db93";







// Default state
const $87d97067f2ac1dd4$var$DEFAULT_TEXT_UNIT_EXTRACTION = {
    isOpen: false,
    pattern: "",
    caseSensitive: false,
    projectId: "",
    activeTab: "syllables",
    syllables: {
        results: []
    },
    phonemes: {
        results: []
    }
};
const $87d97067f2ac1dd4$export$19b89dea279f24a3 = /*#__PURE__*/ (0, $jMaZ8.createContext)($87d97067f2ac1dd4$var$DEFAULT_TEXT_UNIT_EXTRACTION);
function $87d97067f2ac1dd4$export$77ba80419c89ded7(initialProjectId = "") {
    const [textUnitExtraction, sendTextUnitExtraction] = (0, $jMaZ8.useReducer)((state, command)=>{
        if (command.id === "SET_SYLLABLE_RESULTS") return {
            ...state,
            syllables: {
                ...state.syllables,
                results: command.payload
            }
        };
        if (command.id === "SET_PHONEME_RESULTS") return {
            ...state,
            phonemes: {
                ...state.phonemes,
                results: command.payload
            }
        };
        if (command.id === "SET_PATTERN") return {
            ...state,
            pattern: command.payload
        };
        if (command.id === "SET_CASE_SENSITIVE") return {
            ...state,
            caseSensitive: command.payload
        };
        if (command.id === "SET_PROJECT_ID") return {
            ...state,
            projectId: command.payload
        };
        if (command.id === "SET_ACTIVE_TAB") return {
            ...state,
            activeTab: command.payload
        };
        if (command.id === "OPEN") return {
            ...state,
            isOpen: true
        };
        if (command.id === "CLOSE") return {
            ...state,
            isOpen: false
        };
        return state;
    }, {
        ...$87d97067f2ac1dd4$var$DEFAULT_TEXT_UNIT_EXTRACTION,
        projectId: initialProjectId
    });
    const send = (0, $jMaZ8.useMemo)(()=>{
        const commands = {
            setCaseSensitive: (caseSensitive)=>sendTextUnitExtraction({
                    id: "SET_CASE_SENSITIVE",
                    payload: caseSensitive
                }),
            toggle: ()=>{
                textUnitExtraction.isOpen ? commands.close() : commands.open();
            },
            setSyllableResults: (results)=>sendTextUnitExtraction({
                    id: "SET_SYLLABLE_RESULTS",
                    payload: results
                }),
            setPhonemeResults: (results)=>sendTextUnitExtraction({
                    id: "SET_PHONEME_RESULTS",
                    payload: results
                }),
            setActiveTab: (tab)=>sendTextUnitExtraction({
                    id: "SET_ACTIVE_TAB",
                    payload: tab
                }),
            open: ()=>sendTextUnitExtraction({
                    id: "OPEN"
                }),
            close: ()=>sendTextUnitExtraction({
                    id: "CLOSE"
                }),
            setPattern: (pattern)=>sendTextUnitExtraction({
                    id: "SET_PATTERN",
                    payload: pattern
                }),
            setProjectId: (projectId)=>sendTextUnitExtraction({
                    id: "SET_PROJECT_ID",
                    payload: projectId
                })
        };
        return commands;
    }, [
        textUnitExtraction,
        sendTextUnitExtraction
    ]);
    return {
        state: textUnitExtraction,
        send: send
    };
}
const $87d97067f2ac1dd4$var$TextUnitExtractor = ({ isOpen: isOpen, close: close, projectId: projectId, onSyllableClick: onSyllableClick, onPhonemeClick: onPhonemeClick, stringVersion: stringVersion, initialTab: initialTab = "syllables" })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [activeTab, setActiveTab] = (0, $jMaZ8.useState)(initialTab);
    const [page, setPage] = (0, $jMaZ8.useState)(1);
    const [patternQuery, setPatternQuery] = (0, $jMaZ8.useState)("");
    const [caseSensitive, setCaseSensitive] = (0, $jMaZ8.useState)(false);
    const [submitted, setSubmitted] = (0, $jMaZ8.useState)(null);
    const [applyingToAll, setApplyingToAll] = (0, $jMaZ8.useState)(false);
    // Tab change handler
    const handleTabChange = (key)=>{
        setActiveTab(key);
        setPage(1);
    };
    const handleCaseSensitiveToggle = (0, $jMaZ8.useCallback)((checked)=>{
        setCaseSensitive(checked);
    }, []);
    const handleItemClick = (0, $jMaZ8.useCallback)((item)=>{
        if (activeTab === "syllables" && onSyllableClick) onSyllableClick(item);
        else if (activeTab === "phonemes" && onPhonemeClick) onPhonemeClick(item);
    }, [
        activeTab,
        onSyllableClick,
        onPhonemeClick
    ]);
    const shouldExecuteQuery = !!submitted && submitted.pattern === patternQuery && submitted.caseSensitive === caseSensitive && submitted.projectId === projectId && submitted.tab === activeTab;
    const debouncedPattern = submitted?.pattern || "";
    const debouncedCaseSensitive = submitted?.caseSensitive || false;
    const debouncedProjectId = projectId;
    // Use the GraphQL hooks with skip parameter to prevent automatic execution
    const { data: syllableData, loading: syllableLoading } = (0, $2cbc1e4bffc4bf21$export$60c7652d84285238)({
        projectId: debouncedProjectId,
        pattern: debouncedPattern,
        caseSensitive: debouncedCaseSensitive
    }, {
        skip: !shouldExecuteQuery || !debouncedPattern.trim() || activeTab !== "syllables"
    });
    const { data: phonemeData, loading: phonemeLoading } = (0, $5ca13b1bb5133f96$export$c2654da6314599e4)({
        projectId: debouncedProjectId,
        pattern: debouncedPattern,
        caseSensitive: debouncedCaseSensitive
    }, {
        skip: !shouldExecuteQuery || !debouncedPattern.trim() || activeTab !== "phonemes"
    });
    // Hooks for syllable operations
    const [createSyllable, { loading: creatingLoading }] = (0, $2cbc1e4bffc4bf21$export$7cab5666971b1572)();
    const [deleteSyllable, { loading: deletingLoading }] = (0, $2cbc1e4bffc4bf21$export$c6f584713ec549a2)();
    // Hooks for phoneme operations
    const [setPhoneme, { loading: settingPhonemeLoading }] = (0, $5ca13b1bb5133f96$export$aab3867090efe064)();
    const [unsetPhoneme, { loading: unsettingPhonemeLoading }] = (0, $5ca13b1bb5133f96$export$138d955481de2f64)();
    const [setMute, { loading: settingMuteLoading }] = (0, $b7be8974895307ad$export$c01896a7be4e05e6)();
    const [unsetMute, { loading: unsettingMuteLoading }] = (0, $b7be8974895307ad$export$26d1265de1014c07)();
    const updatePattern = (0, $jMaZ8.useCallback)((e)=>setPatternQuery(e.target.value), [
        setPatternQuery
    ]);
    const handleSearch = (0, $jMaZ8.useCallback)(()=>{
        if (patternQuery.trim()) {
            setPage(1);
            setSubmitted({
                pattern: patternQuery,
                caseSensitive: caseSensitive,
                projectId: projectId,
                tab: activeTab
            });
        }
    }, [
        patternQuery,
        caseSensitive,
        projectId,
        activeTab
    ]);
    const clearPattern = (0, $jMaZ8.useCallback)(()=>{
        setPatternQuery("");
        setSubmitted(null);
    }, []);
    const syllableResults = (0, $jMaZ8.useMemo)(()=>{
        if (!syllableData?.extractSyllablesWithRegex) return [];
        return [
            ...syllableData.extractSyllablesWithRegex
        ];
    }, [
        syllableData
    ]);
    const phonemeResults = (0, $jMaZ8.useMemo)(()=>{
        if (!phonemeData?.extractPhonemesWithRegex) return [];
        return [
            ...phonemeData.extractPhonemesWithRegex
        ];
    }, [
        phonemeData
    ]);
    const results = activeTab === "syllables" ? syllableResults : phonemeResults;
    const loading = activeTab === "syllables" ? syllableLoading : phonemeLoading;
    const totalElements = results.length;
    const handleApplyToAll = (0, $jMaZ8.useCallback)(async ()=>{
        if (!results.length || !projectId) return;
        setApplyingToAll(true);
        const messageKey = `applying-${activeTab}`;
        (0, $cff19b71ca14530c$export$2e2bcd8739ae039).loading({
            content: t(`project.${activeTab}.applyingToAll`),
            key: messageKey,
            duration: 0
        });
        try {
            if (activeTab === "syllables") // Process syllables
            for (const syllable of results){
                const size = syllable.endUtf16 - syllable.startUtf16;
                if (syllable.removeSyllable) await deleteSyllable({
                    variables: {
                        projectId: projectId,
                        start: syllable.startUtf16,
                        size: size,
                        stringVersion: stringVersion
                    }
                });
                else await createSyllable({
                    variables: {
                        projectId: projectId,
                        start: syllable.startUtf16,
                        size: size,
                        stringVersion: stringVersion
                    }
                });
            }
            else // Process phonemes
            for (const phoneme of results){
                const size = phoneme.endUtf16 - phoneme.startUtf16;
                // Handle the action based on what we need to do
                if (phoneme.muting === "MUTE") // Apply muting
                await setMute({
                    variables: {
                        projectId: projectId,
                        start: phoneme.startUtf16,
                        size: size,
                        stringVersion: stringVersion
                    }
                });
                else if (phoneme.muting === "UNMUTE") // Remove muting
                await unsetMute({
                    variables: {
                        projectId: projectId,
                        start: phoneme.startUtf16,
                        size: size,
                        stringVersion: stringVersion
                    }
                });
                else // Apply phoneme actions (add/remove)
                if (phoneme.removePhoneme) await unsetPhoneme({
                    variables: {
                        projectId: projectId,
                        start: phoneme.startUtf16,
                        size: size,
                        stringVersion: stringVersion
                    }
                });
                else await setPhoneme({
                    variables: {
                        projectId: projectId,
                        start: phoneme.startUtf16,
                        size: size,
                        stringVersion: stringVersion,
                        kind: phoneme.phonemeKind
                    }
                });
            }
            (0, $cff19b71ca14530c$export$2e2bcd8739ae039).success({
                content: t(`project.${activeTab}.applyingToAllSuccess`, {
                    [`${activeTab}Count`]: results.length
                }),
                key: messageKey,
                duration: 3
            });
        } catch (error) {
            console.error(`Error applying ${activeTab}:`, error);
            (0, $cff19b71ca14530c$export$2e2bcd8739ae039).error({
                content: t(`project.${activeTab}.applyError`),
                key: messageKey,
                duration: 3
            });
        } finally{
            setApplyingToAll(false);
        }
    }, [
        activeTab,
        results,
        projectId,
        createSyllable,
        deleteSyllable,
        setPhoneme,
        unsetPhoneme,
        setMute,
        unsetMute,
        stringVersion,
        t
    ]);
    // Helper function to determine if the Apply button should be disabled
    const isApplyButtonDisabled = (0, $jMaZ8.useMemo)(()=>{
        if (!results.length) return true;
        if (activeTab === "syllables") return creatingLoading || deletingLoading;
        else return settingPhonemeLoading || unsettingPhonemeLoading || settingMuteLoading || unsettingMuteLoading;
    }, [
        activeTab,
        results,
        creatingLoading,
        deletingLoading,
        settingPhonemeLoading,
        unsettingPhonemeLoading,
        settingMuteLoading,
        unsettingMuteLoading
    ]);
    // Get the correct placeholder text based on active tab
    const getPlaceholderText = ()=>{
        if (activeTab === "syllables") return "(?<Syllable1>Lou)(?<Syllable2>is) (?<Nothing1>XVI)";
        else return "(?<Consonant1>L)(?<Complex1>ou)(?<Vowel1>i)(?<Mute1>s) (?<Nothing1>XVI)";
    };
    // Render item based on the active tab
    const renderItem = (item)=>{
        if (activeTab === "syllables") {
            const syllable = item;
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8d359122623b990d$export$2e2bcd8739ae039).Item, {
                onClick: ()=>handleItemClick(syllable),
                className: $4917b6015e9e7869$export$aaf36426b5008f7a,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("strong", {
                                children: syllable.text
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: syllable.context
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("small", {
                                children: syllable.removeSyllable ? t("project.syllables.remove") : t("project.syllables.add")
                            })
                        })
                    ]
                })
            });
        } else {
            const phoneme = item;
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8d359122623b990d$export$2e2bcd8739ae039).Item, {
                onClick: ()=>handleItemClick(phoneme),
                className: $4917b6015e9e7869$export$aaf36426b5008f7a,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("strong", {
                                children: phoneme.text
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: phoneme.context
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("small", {
                                children: phoneme.muting === "MUTE" ? t("project.phonemes.mute") : phoneme.muting === "UNMUTE" ? t("project.phonemes.unmute") : phoneme.removePhoneme ? t("project.phonemes.remove") : `${t("project.phonemes.add")} - ${phoneme.phonemeKind}`
                            })
                        })
                    ]
                })
            });
        }
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $d88f1f9a11889bfa$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3d078c5b7a14a8e5$export$2e2bcd8739ae039), {
            activeKey: activeTab,
            onChange: handleTabChange,
            items: [
                {
                    key: "syllables",
                    label: t("project.syllables.title")
                },
                {
                    key: "phonemes",
                    label: t("project.phonemes.title")
                }
            ]
        }),
        placement: "right",
        styles: {
            body: {
                padding: 0,
                display: "flex",
                flexDirection: "column"
            },
            footer: {
                padding: "10px 16px",
                textAlign: "right"
            }
        },
        className: $4917b6015e9e7869$export$e8e78c978b129247,
        open: isOpen,
        closable: true,
        onClose: ()=>{
            setSubmitted(null);
            setPatternQuery("");
            setCaseSensitive(false);
            close();
        },
        mask: false,
        width: "55em",
        footer: results.length > 0 ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
            type: "primary",
            onClick: handleApplyToAll,
            loading: applyingToAll,
            disabled: isApplyButtonDisabled,
            children: t(`project.${activeTab}.applyToAll`)
        }) : null,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8d359122623b990d$export$2e2bcd8739ae039), {
                style: {
                    flex: 1,
                    overflowY: "auto"
                },
                size: "large",
                dataSource: results.slice((page - 1) * 20, page * 20),
                loading: loading,
                locale: {
                    emptyText: shouldExecuteQuery && !loading && patternQuery.trim() ? t(`project.${activeTab}.noResults`) : t(`project.${activeTab}.helpText`)
                },
                header: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                        className: $4917b6015e9e7869$export$d76128d007d19019,
                        justify: "center",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                                style: {
                                    textAlign: "center",
                                    fontSize: "1.2em"
                                },
                                span: 2,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $7707703e157f8963$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                                span: 17,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c701e4577fe78359$export$2e2bcd8739ae039), {
                                            style: {
                                                padding: "0.25em"
                                            },
                                            value: patternQuery,
                                            onChange: updatePattern,
                                            placeholder: getPlaceholderText(),
                                            onKeyDown: (e)=>{
                                                if (e.nativeEvent.isComposing) return;
                                                if (e.key === "Enter" && patternQuery.trim()) handleSearch();
                                            }
                                        }),
                                        patternQuery && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c67bdf6a1df26e5d$export$2e2bcd8739ae039), {
                                            style: {
                                                position: "absolute",
                                                right: "8px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer"
                                            },
                                            onClick: clearPattern
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                                span: 2,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                                    title: t(`project.${activeTab}.caseSensitivity`),
                                    children: [
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                                            style: {
                                                marginRight: "8px"
                                            },
                                            children: "Aa"
                                        }),
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b968d364906a5d60$export$2e2bcd8739ae039), {
                                            checked: caseSensitive,
                                            onChange: handleCaseSensitiveToggle,
                                            size: "small"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $448bee343edef0e9$export$2e2bcd8739ae039), {
                                span: 3,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    disabled: !patternQuery.trim(),
                                    onClick: handleSearch,
                                    loading: loading,
                                    children: t(`project.${activeTab}.searchButton`)
                                })
                            })
                        ]
                    })
                }),
                renderItem: renderItem
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $029f538dfd4a9bcd$export$2e2bcd8739ae039), {
                className: $4917b6015e9e7869$export$22fa394f3ba39578,
                onChange: setPage,
                current: page,
                total: totalElements,
                pageSize: 20,
                hideOnSinglePage: true,
                responsive: true,
                showSizeChanger: false,
                size: "small"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                className: $4917b6015e9e7869$export$209bc1d5cae595bb,
                children: loading ? t(`project.${activeTab}.loading`) : `${results.length} ${results.length !== 1 ? t(`project.${activeTab}.results`) : t(`project.${activeTab}.result`)}`
            })
        ]
    });
};
var $87d97067f2ac1dd4$export$2e2bcd8739ae039 = $87d97067f2ac1dd4$var$TextUnitExtractor;



const { Content: $de3c5dab5cbf9179$var$Content } = (0, $a3bb6174129512e9$export$2e2bcd8739ae039);
const $de3c5dab5cbf9179$export$7f7cbe89f1eacd2 = ({ style: style })=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        style: {
            ...style,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), {})
    });
var $de3c5dab5cbf9179$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo(()=>{
    const matchesBookEdit = (0, $5c84a101a4932c49$export$6c330e8992e8a295)("/editor/books/edit/:bookId/*");
    const { bookId: bookId } = (0, $5c84a101a4932c49$export$99eaa27ddbbb95ef)();
    if (!bookId) throw new Error("No bookId provided");
    const isContentAdmin = (0, $dc10a25720c6edc8$export$1b39bc9d16fffc4d)();
    const search = (0, $cea0c4b5b7f554ff$export$d60636bdb7719d36)(bookId);
    const { data: data, loading: isProjectLoading } = (0, $d7188398173686a1$export$6ed06f11bf137590)({
        id: bookId,
        withAudioInfo: false,
        withInfo: false
    });
    const [isExtractorOpen, setIsExtractorOpen] = (0, $jMaZ8.useState)(false);
    const [lastPathSegment, setLastPathSegment] = (0, $jMaZ8.useState)("");
    const [isRegexEnabled, setIsRegexEnabled] = (0, $jMaZ8.useState)(()=>{
        return localStorage.getItem("regex-tool-enabled") === "true";
    });
    // Check for enableRegex URL param on mount
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        if (params.get("enableRegex") === "true") {
            localStorage.setItem("regex-tool-enabled", "true");
            setIsRegexEnabled(true);
            params.delete("enableRegex");
            const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}`;
            window.history.replaceState(window.history.state, "", newUrl + window.location.hash);
        }
    }, []);
    // Determine which tab to open based on path
    (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useEffect(()=>{
        if (matchesBookEdit) {
            const pathSegments = window.location.pathname.split("/");
            const lastSegment = pathSegments[pathSegments.length - 1];
            setLastPathSegment(lastSegment);
        }
    }, [
        matchesBookEdit
    ]);
    // Determine initial tab based on path
    const getInitialTab = ()=>{
        if (lastPathSegment === "syllable") return "syllables";
        else if (lastPathSegment === "phoneme") return "phonemes";
        return "syllables"; // Default
    };
    const handleSyllableClick = (syllable)=>{
        // Handle syllable click
        console.log("Syllable clicked:", syllable);
    };
    const handlePhonemeClick = (phoneme)=>{
        // Handle phoneme click
        console.log("Phoneme clicked:", phoneme);
    };
    const project = data?.project[0];
    const { pages: pages, loading: loading } = (0, $5b38bec19e3a4e47$export$9209709357e72876)(bookId, isProjectLoading || project?.importStatus !== "DONE");
    if (project?.importStatus === (0, $b522cf181e75e62d$export$cf6fc7defa80d203).FAILED) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b48f64e003f2eb7e$export$2e2bcd8739ae039), {
        failed: true
    });
    if (project?.importStatus === (0, $b522cf181e75e62d$export$cf6fc7defa80d203).WAITING_FOR_CONTENT || project?.importStatus === (0, $b522cf181e75e62d$export$cf6fc7defa80d203).IMPORTING_CONTENT) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b48f64e003f2eb7e$export$2e2bcd8739ae039), {
        notImportedYet: true
    });
    if (!project || loading || isProjectLoading) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b48f64e003f2eb7e$export$2e2bcd8739ae039), {
        loading: true
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e7692b166c91b9dc$export$445f1ca11ac13070), {
        pages: pages,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $cea0c4b5b7f554ff$export$abe847132b142195).Provider, {
            value: search.state,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039), {
                    id: "project-root",
                    style: {
                        overflow: "auto"
                    },
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($de3c5dab5cbf9179$var$Content, {
                        className: "site-layout-background",
                        style: {
                            margin: 0,
                            flex: 1
                        },
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a365bb214cadc66e$export$2e2bcd8739ae039), {
                            pages: pages,
                            loading: loading,
                            projectId: bookId
                        })
                    })
                }),
                !!pages.length && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $cea0c4b5b7f554ff$export$2e2bcd8739ae039), {
                            pages: pages,
                            bookId: bookId,
                            searchMode: search.state.searchMode,
                            setSearchMode: search.send.setSearchMode,
                            isOpen: search.state.isOpen,
                            close: search.send.close,
                            results: search.results,
                            loading: search.loading,
                            totalElements: search.total,
                            textQuery: search.state.searchString,
                            setTextQuery: search.send.setSearchString
                        }),
                        matchesBookEdit && (isContentAdmin || isRegexEnabled) ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $87d97067f2ac1dd4$export$2e2bcd8739ae039), {
                            projectId: bookId,
                            stringVersion: project.stringVersion,
                            isOpen: isExtractorOpen,
                            close: ()=>setIsExtractorOpen(false),
                            onSyllableClick: handleSyllableClick,
                            onPhonemeClick: handlePhonemeClick,
                            initialTab: getInitialTab()
                        }) : null,
                        matchesBookEdit ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3e12b6d8e85d828$export$2e2bcd8739ae039), {
                            loading: loading,
                            projectId: bookId,
                            isSearchOpen: search.state.isOpen,
                            toggleEdition: ()=>setIsExtractorOpen((isOpen)=>!isOpen),
                            toggleSearch: search.send.toggle
                        }) : null
                    ]
                })
            ]
        })
    }, bookId);
});








function $05b293d3f2411513$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}








var $3251f4f9c1be355c$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $3251f4f9c1be355c$export$a89c95c098ac2a58 = Object.freeze({});
function $3251f4f9c1be355c$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $3251f4f9c1be355c$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $83bbfab21ea3efd5$export$8ee0fc9ee280b4ee)(node)) throw new Error("Invalid AST Node: ".concat((0, $c26b043c89ca158f$export$2e2bcd8739ae039)(node), "."));
            var visitFn = $3251f4f9c1be355c$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $3251f4f9c1be355c$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $83bbfab21ea3efd5$export$8ee0fc9ee280b4ee)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $3251f4f9c1be355c$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $3251f4f9c1be355c$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $3251f4f9c1be355c$export$a89c95c098ac2a58) skipping[i] = $3251f4f9c1be355c$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $3251f4f9c1be355c$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $3251f4f9c1be355c$export$a89c95c098ac2a58) skipping[i] = $3251f4f9c1be355c$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $3251f4f9c1be355c$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}


function $db291b697516dcdb$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(85, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fragments.length === 1, 86, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $fcf1ddc4ac014517$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $db291b697516dcdb$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $db291b697516dcdb$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fragment, 87, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}
function $db291b697516dcdb$export$5b84f3d7865d4e49(document) {
    var isUnmasked = true;
    (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            isUnmasked = !!node.directives && node.directives.some(function(directive) {
                return directive.name.value === "unmask";
            });
            if (!isUnmasked) return 0, $3251f4f9c1be355c$export$a89c95c098ac2a58;
        }
    });
    return isUnmasked;
}




var $55d10b943a98270e$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $55d10b943a98270e$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $55d10b943a98270e$var$sortingMap = new (0, $b8955c60f2fefc81$export$5b4f745137d91413)((0, $2d6dd17bfab74a36$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $6d39cfba9615c908$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $55d10b943a98270e$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $55d10b943a98270e$var$sortingMap;
$55d10b943a98270e$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $55d10b943a98270e$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($55d10b943a98270e$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $55d10b943a98270e$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $55d10b943a98270e$var$sortingMap.get(sortedKey) || keys;
                $55d10b943a98270e$var$sortingMap.set(unsortedKey, sortedKeys);
                $55d10b943a98270e$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $55d10b943a98270e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $727ebff7ca61d150$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $727ebff7ca61d150$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $727ebff7ca61d150$export$540432d49fcec6c9(value) {
    return (0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $727ebff7ca61d150$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $727ebff7ca61d150$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $727ebff7ca61d150$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $727ebff7ca61d150$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $727ebff7ca61d150$var$isVariable(value) {
    return value.kind === "Variable";
}
function $727ebff7ca61d150$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $727ebff7ca61d150$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $727ebff7ca61d150$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $727ebff7ca61d150$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $727ebff7ca61d150$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($727ebff7ca61d150$var$isIntValue(value) || $727ebff7ca61d150$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($727ebff7ca61d150$var$isBooleanValue(value) || $727ebff7ca61d150$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($727ebff7ca61d150$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $727ebff7ca61d150$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($727ebff7ca61d150$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($727ebff7ca61d150$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $727ebff7ca61d150$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($727ebff7ca61d150$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($727ebff7ca61d150$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(96, name.value, value.kind);
}
function $727ebff7ca61d150$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $727ebff7ca61d150$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $727ebff7ca61d150$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $727ebff7ca61d150$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $727ebff7ca61d150$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $727ebff7ca61d150$var$storeKeyNameStringify = (0, $55d10b943a98270e$export$88a0ad9b6f961b51);
var $727ebff7ca61d150$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($727ebff7ca61d150$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $727ebff7ca61d150$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($727ebff7ca61d150$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($727ebff7ca61d150$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $727ebff7ca61d150$var$storeKeyNameStringify;
        $727ebff7ca61d150$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $727ebff7ca61d150$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $727ebff7ca61d150$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $727ebff7ca61d150$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $727ebff7ca61d150$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($727ebff7ca61d150$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$727ebff7ca61d150$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $727ebff7ca61d150$export$cf7bf7e4f289cc26(result, (0, $db291b697516dcdb$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $727ebff7ca61d150$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $727ebff7ca61d150$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $9295a06ae2914616$export$a7d0d8111d2386df(doc) {
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(doc && doc.kind === "Document", 88);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(89, definition.kind);
        return definition;
    });
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(operations.length <= 1, 90, operations.length);
    return doc;
}
function $9295a06ae2914616$export$7a5b1fa979d2c158(doc) {
    $9295a06ae2914616$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $9295a06ae2914616$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $9295a06ae2914616$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $9295a06ae2914616$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $9295a06ae2914616$export$7a5b1fa979d2c158(doc);
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 91);
    return queryDef;
}
function $9295a06ae2914616$export$772111caef41b3f5(doc) {
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(doc.kind === "Document", 92);
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(doc.definitions.length <= 1, 93);
    var fragmentDef = doc.definitions[0];
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 94);
    return fragmentDef;
}
function $9295a06ae2914616$export$f431198736b7f96d(queryDoc) {
    $9295a06ae2914616$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(95);
}
function $9295a06ae2914616$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $727ebff7ca61d150$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $3d5daeeacc64b7f5$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $9295a06ae2914616$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $9b913a927dc83a30$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(46, key);
    }
    return operation;
}


function $0b78640641df936b$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
}
function $0b78640641df936b$var$toLink(handler) {
    return typeof handler === "function" ? new $0b78640641df936b$export$2fed3d61f740bc7f(handler) : handler;
}
function $0b78640641df936b$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $0b78640641df936b$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($0b78640641df936b$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $0b78640641df936b$var$toLink(left);
        var rightLink = $0b78640641df936b$var$toLink(right || new ApolloLink($0b78640641df936b$var$passthrough));
        var ret;
        if ($0b78640641df936b$var$isTerminating(leftLink) && $0b78640641df936b$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $05b293d3f2411513$export$f29bedd62f56fcb2)(operation.context, (0, $3d5daeeacc64b7f5$export$4f3f7df1b558c729)((0, $9b913a927dc83a30$export$a92a48117d546c9)(operation)))) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $0b78640641df936b$var$toLink(first);
        if ($0b78640641df936b$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(38, firstLink);
            return firstLink;
        }
        var nextLink = $0b78640641df936b$var$toLink(second);
        var ret;
        if ($0b78640641df936b$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
            }) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
            }) || (0, $0777c100e78b6582$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($0b78640641df936b$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(39);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $efb291821d4d3ba4$export$51396ec711da548b = (0, $0b78640641df936b$export$2fed3d61f740bc7f).execute;










function $fc097d395bed33b7$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $fc097d395bed33b7$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(evaledValue !== void 0, 78, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $fc097d395bed33b7$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $fc097d395bed33b7$export$528b5e7d8ba07fbf = function(names, root) {
    return $fc097d395bed33b7$export$2dafb573e282fe8d(names, root, false);
};
var $fc097d395bed33b7$export$ad1b63b26c1a9b76 = function(names, root) {
    return $fc097d395bed33b7$export$2dafb573e282fe8d(names, root, true);
};
function $fc097d395bed33b7$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $3251f4f9c1be355c$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $fc097d395bed33b7$export$8d1e9e5bbfa5d09a(document) {
    return document && $fc097d395bed33b7$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $fc097d395bed33b7$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $fc097d395bed33b7$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$fc097d395bed33b7$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 79, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 80, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 81, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}
function $fc097d395bed33b7$export$d6913ace4214003(fragment) {
    var _a, _b;
    var directive = (_a = fragment.directives) === null || _a === void 0 ? void 0 : _a.find(function(_a) {
        var name = _a.name;
        return name.value === "unmask";
    });
    if (!directive) return "mask";
    var modeArg = (_b = directive.arguments) === null || _b === void 0 ? void 0 : _b.find(function(_a) {
        var name = _a.name;
        return name.value === "mode";
    });
    if (globalThis.__DEV__ !== false) {
        if (modeArg) {
            if (modeArg.value.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).VARIABLE) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(82);
            else if (modeArg.value.kind !== (0, $38005e35e9207b1b$export$a84bdc57c5122798).STRING) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(83);
            else if (modeArg.value.value !== "migrate") globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(84, modeArg.value.value);
        }
    }
    if (modeArg && "value" in modeArg.value && modeArg.value.value === "migrate") return "migrate";
    return "unmask";
}








var $4c1e2a8713312ae6$var$TYPENAME_FIELD = {
    kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $4c1e2a8713312ae6$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_SPREAD && $4c1e2a8713312ae6$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $4c1e2a8713312ae6$var$nullIfDocIsEmpty(doc) {
    return $4c1e2a8713312ae6$var$isEmpty((0, $9295a06ae2914616$export$7a5b1fa979d2c158)(doc) || (0, $9295a06ae2914616$export$772111caef41b3f5)(doc), (0, $db291b697516dcdb$export$193789b4c8246dd4)((0, $9295a06ae2914616$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $4c1e2a8713312ae6$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $4c1e2a8713312ae6$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $4c1e2a8713312ae6$export$e5ae0530da5fe96c(directives, doc) {
    (0, $9295a06ae2914616$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $4c1e2a8713312ae6$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $4c1e2a8713312ae6$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).error(97);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $4c1e2a8713312ae6$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $70621a0f16abefe5$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $4c1e2a8713312ae6$var$nullIfDocIsEmpty((0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $4c1e2a8713312ae6$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $727ebff7ca61d150$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $727ebff7ca61d150$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)([], selections, true), [
                        $4c1e2a8713312ae6$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $4c1e2a8713312ae6$var$TYPENAME_FIELD;
    }
});
var $4c1e2a8713312ae6$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(98);
        }
        return willRemove;
    }
};
function $4c1e2a8713312ae6$export$74985f3324559867(doc) {
    return $4c1e2a8713312ae6$export$e5ae0530da5fe96c([
        $4c1e2a8713312ae6$var$connectionRemoveConfig
    ], (0, $9295a06ae2914616$export$a7d0d8111d2386df)(doc));
}
function $4c1e2a8713312ae6$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $4c1e2a8713312ae6$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $4c1e2a8713312ae6$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $727ebff7ca61d150$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($4c1e2a8713312ae6$var$getDirectiveMatcher(directives)) || nestedCheck && $4c1e2a8713312ae6$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $4c1e2a8713312ae6$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $4c1e2a8713312ae6$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $4c1e2a8713312ae6$var$getArgumentMatcher(config);
    return $4c1e2a8713312ae6$var$nullIfDocIsEmpty((0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $4c1e2a8713312ae6$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $4c1e2a8713312ae6$var$nullIfDocIsEmpty((0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $4c1e2a8713312ae6$export$57c368c23873f32b(document) {
    var definition = (0, $9295a06ae2914616$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $4c1e2a8713312ae6$export$8eae69e876ee321e(document) {
    (0, $9295a06ae2914616$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $4c1e2a8713312ae6$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}
function $4c1e2a8713312ae6$export$b6125cad5877ac5e(document) {
    (0, $9295a06ae2914616$export$a7d0d8111d2386df)(document);
    return (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            var _a;
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if ((_a = node.directives) === null || _a === void 0 ? void 0 : _a.some(function(directive) {
                return directive.name.value === "unmask";
            })) return;
            return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, node), {
                directives: (0, $fcf1ddc4ac014517$export$1216008129fb82ed)((0, $fcf1ddc4ac014517$export$1216008129fb82ed)([], node.directives || [], true), [
                    {
                        kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).DIRECTIVE,
                        name: {
                            kind: (0, $38005e35e9207b1b$export$a84bdc57c5122798).NAME,
                            value: "nonreactive"
                        }
                    }
                ], false)
            });
        }
    });
}



var $bd31788b1042191d$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $13e6b16068d1c6dc$export$3991762405098ea)(42, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $29abe2e86da2cea7$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $0eed55d7343f210e$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $059a5cfe654ec9b2$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $72d024d8344a7591$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $f9739a8b16192c83$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $72d024d8344a7591$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $13eeb389d1e25827$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $72d024d8344a7591$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $d4d8415306de9b89$var$isNodeResponse(value) {
    return !!value.body;
}
function $d4d8415306de9b89$var$isReadableStream(value) {
    return !!value.getReader;
}
function $d4d8415306de9b89$var$isAsyncIterableIterator(value) {
    return !!((0, $72d024d8344a7591$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $d4d8415306de9b89$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $d4d8415306de9b89$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $d4d8415306de9b89$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $d4d8415306de9b89$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($d4d8415306de9b89$var$isNodeResponse(response)) body = response.body;
    if ($d4d8415306de9b89$var$isAsyncIterableIterator(body)) return (0, $0eed55d7343f210e$export$2e2bcd8739ae039)(body);
    if ($d4d8415306de9b89$var$isReadableStream(body)) return (0, $13eeb389d1e25827$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($d4d8415306de9b89$var$isStreamableBlob(body)) return (0, $13eeb389d1e25827$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($d4d8415306de9b89$var$isBlob(body)) return (0, $f9739a8b16192c83$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($d4d8415306de9b89$var$isNodeReadableStream(body)) return (0, $059a5cfe654ec9b2$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $07da33255951b08c$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};







var $e535ffd0d6e4bf3a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e535ffd0d6e4bf3a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e535ffd0d6e4bf3a$export$160070228be94b08(sources);
}
function $e535ffd0d6e4bf3a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $e535ffd0d6e4bf3a$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $e535ffd0d6e4bf3a$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $e535ffd0d6e4bf3a$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $e535ffd0d6e4bf3a$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $28bb6a3d2161c7ef$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(source) && (0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($e535ffd0d6e4bf3a$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $fcf1ddc4ac014517$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $50488ee97abe3132$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $50488ee97abe3132$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $50488ee97abe3132$export$f90dc0a3531b8b83(value) {
    return $50488ee97abe3132$export$879767c5cdf33cb3(value) || $50488ee97abe3132$export$6c17a45d8c64ff02(value);
}
function $50488ee97abe3132$export$3f32b6369f408f33(value) {
    return (0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value) && "payload" in value;
}
function $50488ee97abe3132$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $e535ffd0d6e4bf3a$export$509e11c221f576c0)();
    if ($50488ee97abe3132$export$879767c5cdf33cb3(result) && (0, $70621a0f16abefe5$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $4f81982927ffa9f6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $4f81982927ffa9f6$export$ccb60864026baf09(response, nextValue) {
    return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $d4d8415306de9b89$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $4f81982927ffa9f6$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $4f81982927ffa9f6$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $50488ee97abe3132$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $9b257430d46c4ca9$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $4f81982927ffa9f6$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $4f81982927ffa9f6$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $07da33255951b08c$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $4f81982927ffa9f6$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $4f81982927ffa9f6$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $4f81982927ffa9f6$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$4f81982927ffa9f6$var$hasOwnProperty.call(result, "data") && !$4f81982927ffa9f6$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $07da33255951b08c$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $40bd245c861fe387$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(40);
};





function $8bb16823473c68c2$export$c2d084dc44961371(ast) {
    return (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(ast, {
        leave: $8bb16823473c68c2$var$printDocASTReducer
    });
}
var $8bb16823473c68c2$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $8bb16823473c68c2$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $8bb16823473c68c2$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $8bb16823473c68c2$var$wrap('(', $8bb16823473c68c2$var$join(node.variableDefinitions, ', '), ')');
        var directives = $8bb16823473c68c2$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $8bb16823473c68c2$var$join([
            op,
            $8bb16823473c68c2$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $8bb16823473c68c2$var$wrap(' = ', defaultValue) + $8bb16823473c68c2$var$wrap(' ', $8bb16823473c68c2$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $8bb16823473c68c2$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $8bb16823473c68c2$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $8bb16823473c68c2$var$wrap('(', $8bb16823473c68c2$var$join(args, ', '), ')');
        if (argsLine.length > $8bb16823473c68c2$var$MAX_LINE_LENGTH) argsLine = prefix + $8bb16823473c68c2$var$wrap('(\n', $8bb16823473c68c2$var$indent($8bb16823473c68c2$var$join(args, '\n')), '\n)');
        return $8bb16823473c68c2$var$join([
            argsLine,
            $8bb16823473c68c2$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $8bb16823473c68c2$var$wrap(' ', $8bb16823473c68c2$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $8bb16823473c68c2$var$join([
            '...',
            $8bb16823473c68c2$var$wrap('on ', typeCondition),
            $8bb16823473c68c2$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($8bb16823473c68c2$var$wrap('(', $8bb16823473c68c2$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($8bb16823473c68c2$var$wrap('', $8bb16823473c68c2$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $a09f77d2f3f4bca5$export$adb6ca997eeb1f45)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $8bb16823473c68c2$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $8bb16823473c68c2$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $8bb16823473c68c2$var$wrap('(', $8bb16823473c68c2$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $8bb16823473c68c2$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $8bb16823473c68c2$var$join([
            'schema',
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $8bb16823473c68c2$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $8bb16823473c68c2$var$join([
            'scalar',
            name,
            $8bb16823473c68c2$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $8bb16823473c68c2$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $8bb16823473c68c2$var$join([
            'type',
            name,
            $8bb16823473c68c2$var$wrap('implements ', $8bb16823473c68c2$var$join(interfaces, ' & ')),
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $8bb16823473c68c2$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($8bb16823473c68c2$var$hasMultilineItems(args) ? $8bb16823473c68c2$var$wrap('(\n', $8bb16823473c68c2$var$indent($8bb16823473c68c2$var$join(args, '\n')), '\n)') : $8bb16823473c68c2$var$wrap('(', $8bb16823473c68c2$var$join(args, ', '), ')')) + ': ' + type + $8bb16823473c68c2$var$wrap(' ', $8bb16823473c68c2$var$join(directives, ' '));
    }),
    InputValueDefinition: $8bb16823473c68c2$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $8bb16823473c68c2$var$join([
            name + ': ' + type,
            $8bb16823473c68c2$var$wrap('= ', defaultValue),
            $8bb16823473c68c2$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $8bb16823473c68c2$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $8bb16823473c68c2$var$join([
            'interface',
            name,
            $8bb16823473c68c2$var$wrap('implements ', $8bb16823473c68c2$var$join(interfaces, ' & ')),
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $8bb16823473c68c2$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $8bb16823473c68c2$var$join([
            'union',
            name,
            $8bb16823473c68c2$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $8bb16823473c68c2$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $8bb16823473c68c2$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $8bb16823473c68c2$var$join([
            'enum',
            name,
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $8bb16823473c68c2$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $8bb16823473c68c2$var$join([
            name,
            $8bb16823473c68c2$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $8bb16823473c68c2$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $8bb16823473c68c2$var$join([
            'input',
            name,
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $8bb16823473c68c2$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($8bb16823473c68c2$var$hasMultilineItems(args) ? $8bb16823473c68c2$var$wrap('(\n', $8bb16823473c68c2$var$indent($8bb16823473c68c2$var$join(args, '\n')), '\n)') : $8bb16823473c68c2$var$wrap('(', $8bb16823473c68c2$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $8bb16823473c68c2$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $8bb16823473c68c2$var$join([
            'extend schema',
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $8bb16823473c68c2$var$join([
            'extend scalar',
            name,
            $8bb16823473c68c2$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $8bb16823473c68c2$var$join([
            'extend type',
            name,
            $8bb16823473c68c2$var$wrap('implements ', $8bb16823473c68c2$var$join(interfaces, ' & ')),
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $8bb16823473c68c2$var$join([
            'extend interface',
            name,
            $8bb16823473c68c2$var$wrap('implements ', $8bb16823473c68c2$var$join(interfaces, ' & ')),
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $8bb16823473c68c2$var$join([
            'extend union',
            name,
            $8bb16823473c68c2$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $8bb16823473c68c2$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $8bb16823473c68c2$var$join([
            'extend enum',
            name,
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $8bb16823473c68c2$var$join([
            'extend input',
            name,
            $8bb16823473c68c2$var$join(directives, ' '),
            $8bb16823473c68c2$var$block(fields)
        ], ' ');
    }
};
function $8bb16823473c68c2$var$addDescription(cb) {
    return function(node) {
        return $8bb16823473c68c2$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $8bb16823473c68c2$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $8bb16823473c68c2$var$block(array) {
    return $8bb16823473c68c2$var$wrap('{\n', $8bb16823473c68c2$var$indent($8bb16823473c68c2$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $8bb16823473c68c2$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $8bb16823473c68c2$var$indent(str) {
    return $8bb16823473c68c2$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $8bb16823473c68c2$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $8bb16823473c68c2$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($8bb16823473c68c2$var$isMultiline);
}




var $71b2db41ea98f453$var$printCache;
var $71b2db41ea98f453$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $71b2db41ea98f453$var$printCache.get(ast);
    if (!result) {
        result = (0, $8bb16823473c68c2$export$c2d084dc44961371)(ast);
        $71b2db41ea98f453$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $71b2db41ea98f453$var$printCache = new (0, $b8955c60f2fefc81$export$8dbad6f439bb2331)((0, $2d6dd17bfab74a36$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$71b2db41ea98f453$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $6d39cfba9615c908$export$a8fcd406d9e37621)("print", function() {
    return $71b2db41ea98f453$var$printCache ? $71b2db41ea98f453$var$printCache.size : 0;
});


var $f2f989cfe4c76a1b$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $f2f989cfe4c76a1b$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $f2f989cfe4c76a1b$var$defaultOptions = {
    method: "POST"
};
var $f2f989cfe4c76a1b$export$dd86f00dc866e75d = {
    http: $f2f989cfe4c76a1b$var$defaultHttpOptions,
    headers: $f2f989cfe4c76a1b$var$defaultHeaders,
    options: $f2f989cfe4c76a1b$var$defaultOptions
};
var $f2f989cfe4c76a1b$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $f2f989cfe4c76a1b$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $f2f989cfe4c76a1b$export$12d90ccf75844275.apply(void 0, (0, $fcf1ddc4ac014517$export$1216008129fb82ed)([
        operation,
        $f2f989cfe4c76a1b$export$e88934976ca4fd65
    ], configs, false));
}
function $f2f989cfe4c76a1b$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $f2f989cfe4c76a1b$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $71b2db41ea98f453$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $f2f989cfe4c76a1b$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $9ec9ec95c2332e07$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $bd31788b1042191d$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $bd31788b1042191d$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $e6244bf3b11f108d$export$de246493ae27fe3f(variables, query) {
    var result = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $6b0a620c90747834$export$4fd972edbe7450d3(errorValue) {
    return new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $7a991a0a8ebca984$var$backupFetch = (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $7a991a0a8ebca984$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $f2f989cfe4c76a1b$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $40bd245c861fe387$export$8423f0cd3773115e)(preferredFetch || $7a991a0a8ebca984$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $0b78640641df936b$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $29abe2e86da2cea7$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $fc097d395bed33b7$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $4c1e2a8713312ae6$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $6b0a620c90747834$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $f2f989cfe4c76a1b$export$12d90ccf75844275)(operation, print, (0, $f2f989cfe4c76a1b$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $e6244bf3b11f108d$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $9295a06ae2914616$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $fc097d395bed33b7$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(41);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $9ec9ec95c2332e07$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $6b0a620c90747834$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $bd31788b1042191d$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $6b0a620c90747834$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $380cee6c2d84dbc1$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $7a991a0a8ebca984$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $4f81982927ffa9f6$export$ccb60864026baf09)(response, observerNext);
                else return (0, $4f81982927ffa9f6$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $4f81982927ffa9f6$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};


var $2bf3f639f4de5702$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $7a991a0a8ebca984$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $0b78640641df936b$export$2fed3d61f740bc7f));







function $0a25504e1b93079e$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



function $d0917683e8dc491d$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $7dcc1fa19fb8a534$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $0777c100e78b6582$export$77cea355fa80b5f4)
        });
    }
    if ((0, $72d024d8344a7591$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}


function $76f58a4c82f1ce58$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $76f58a4c82f1ce58$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $d0917683e8dc491d$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $d0917683e8dc491d$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $d0917683e8dc491d$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($76f58a4c82f1ce58$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.error(reason);
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(sources)
        ];
        if ($76f58a4c82f1ce58$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $0777c100e78b6582$export$77cea355fa80b5f4));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $7dcc1fa19fb8a534$export$33c8bd820eece9b2)($76f58a4c82f1ce58$export$ae0cf2ec7a6fa78e);

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $e274f6efb59a47ab$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $e274f6efb59a47ab$var$forEach, slice: $e274f6efb59a47ab$var$slice } = Array.prototype;
const { hasOwnProperty: $e274f6efb59a47ab$var$hasOwnProperty } = Object.prototype;
class $e274f6efb59a47ab$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $e274f6efb59a47ab$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $e274f6efb59a47ab$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $e274f6efb59a47ab$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($e274f6efb59a47ab$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($e274f6efb59a47ab$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $e274f6efb59a47ab$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $e274f6efb59a47ab$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $e274f6efb59a47ab$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}








// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $e60b99a95fa3ca06$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $e60b99a95fa3ca06$var$MISSING_VALUE = {};
let $e60b99a95fa3ca06$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $e60b99a95fa3ca06$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e60b99a95fa3ca06$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $e60b99a95fa3ca06$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $e60b99a95fa3ca06$var$MISSING_VALUE) break;
                if (context !== $e60b99a95fa3ca06$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e60b99a95fa3ca06$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e60b99a95fa3ca06$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e60b99a95fa3ca06$var$currentContext.slots[this.id] = $e60b99a95fa3ca06$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $e60b99a95fa3ca06$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $e60b99a95fa3ca06$var$currentContext;
            $e60b99a95fa3ca06$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e60b99a95fa3ca06$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $e60b99a95fa3ca06$var$currentContext;
            return function() {
                const saved = $e60b99a95fa3ca06$var$currentContext;
                try {
                    $e60b99a95fa3ca06$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e60b99a95fa3ca06$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e60b99a95fa3ca06$var$currentContext) {
                const saved = $e60b99a95fa3ca06$var$currentContext;
                try {
                    $e60b99a95fa3ca06$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e60b99a95fa3ca06$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $e60b99a95fa3ca06$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $e60b99a95fa3ca06$var$globalKey = "@wry/context:Slot";
const $e60b99a95fa3ca06$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$e60b99a95fa3ca06$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$e60b99a95fa3ca06$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $e60b99a95fa3ca06$var$globalHost = $e60b99a95fa3ca06$var$host;
const $e60b99a95fa3ca06$export$8c6ed5c666ac1360 = $e60b99a95fa3ca06$var$globalHost[$e60b99a95fa3ca06$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$e60b99a95fa3ca06$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($e60b99a95fa3ca06$var$globalHost, $e60b99a95fa3ca06$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($e60b99a95fa3ca06$var$makeSlotClass());


const { bind: $a72a4772c916621b$export$2385a24977818dd0, noContext: $a72a4772c916621b$export$9fa6f2e300a97f8 } = (0, $e60b99a95fa3ca06$export$8c6ed5c666ac1360);
function $a72a4772c916621b$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($a72a4772c916621b$export$2385a24977818dd0(callback), delay);
}
function $a72a4772c916621b$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $a72a4772c916621b$export$2385a24977818dd0(gen.next);
        const boundThrow = $a72a4772c916621b$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($a72a4772c916621b$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $a72a4772c916621b$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $a72a4772c916621b$var$wrappedFibers = [];
function $a72a4772c916621b$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($a72a4772c916621b$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $a72a4772c916621b$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $a72a4772c916621b$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $394bb0cffb8d8e41$export$11fa9682b6ba79b1 = new (0, $e60b99a95fa3ca06$export$8c6ed5c666ac1360)();
function $394bb0cffb8d8e41$export$d906efd39458576(fn) {
    return $394bb0cffb8d8e41$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $99b9fbae53bc19a7$export$5a15a386532a5ea4 } = Object.prototype;
const $99b9fbae53bc19a7$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $99b9fbae53bc19a7$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $e504db6f9469b1b7$var$emptySetPool = [];
const $e504db6f9469b1b7$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $e504db6f9469b1b7$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $e504db6f9469b1b7$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $e504db6f9469b1b7$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $e504db6f9469b1b7$var$valueCopy(value) {
    return value.slice(0);
}
class $e504db6f9469b1b7$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$e504db6f9469b1b7$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$e504db6f9469b1b7$var$mightBeDirty(this)) {
            $e504db6f9469b1b7$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $e504db6f9469b1b7$var$assert(!this.recomputing, "already recomputing");
        $e504db6f9469b1b7$var$rememberParent(this);
        return $e504db6f9469b1b7$var$mightBeDirty(this) ? $e504db6f9469b1b7$var$reallyRecompute(this, args) : $e504db6f9469b1b7$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $e504db6f9469b1b7$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $99b9fbae53bc19a7$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $e504db6f9469b1b7$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $e504db6f9469b1b7$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $e504db6f9469b1b7$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $e504db6f9469b1b7$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $99b9fbae53bc19a7$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $e504db6f9469b1b7$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$e504db6f9469b1b7$export$3bb977b3ba9d3b59.count = 0;
function $e504db6f9469b1b7$var$rememberParent(child) {
    const parent = (0, $394bb0cffb8d8e41$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($e504db6f9469b1b7$var$mightBeDirty(child)) $e504db6f9469b1b7$var$reportDirtyChild(parent, child);
        else $e504db6f9469b1b7$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $e504db6f9469b1b7$var$reallyRecompute(entry, args) {
    $e504db6f9469b1b7$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $394bb0cffb8d8e41$export$11fa9682b6ba79b1).withValue(entry, $e504db6f9469b1b7$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($e504db6f9469b1b7$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $e504db6f9469b1b7$var$setClean(entry);
    return $e504db6f9469b1b7$var$valueGet(entry.value);
}
function $e504db6f9469b1b7$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $e504db6f9469b1b7$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$e504db6f9469b1b7$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $e504db6f9469b1b7$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $e504db6f9469b1b7$var$setClean(entry) {
    entry.dirty = false;
    if ($e504db6f9469b1b7$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $e504db6f9469b1b7$var$reportClean(entry);
}
function $e504db6f9469b1b7$var$reportDirty(child) {
    $e504db6f9469b1b7$var$eachParent(child, $e504db6f9469b1b7$var$reportDirtyChild);
}
function $e504db6f9469b1b7$var$reportClean(child) {
    $e504db6f9469b1b7$var$eachParent(child, $e504db6f9469b1b7$var$reportCleanChild);
}
function $e504db6f9469b1b7$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $99b9fbae53bc19a7$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $e504db6f9469b1b7$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $e504db6f9469b1b7$var$assert(parent.childValues.has(child));
    $e504db6f9469b1b7$var$assert($e504db6f9469b1b7$var$mightBeDirty(child));
    const parentWasClean = !$e504db6f9469b1b7$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $e504db6f9469b1b7$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $e504db6f9469b1b7$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $e504db6f9469b1b7$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $e504db6f9469b1b7$var$assert(parent.childValues.has(child));
    $e504db6f9469b1b7$var$assert(!$e504db6f9469b1b7$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $e504db6f9469b1b7$var$valueCopy(child.value));
    else if (!$e504db6f9469b1b7$var$valueIs(childValue, child.value)) parent.setDirty();
    $e504db6f9469b1b7$var$removeDirtyChild(parent, child);
    if ($e504db6f9469b1b7$var$mightBeDirty(parent)) return;
    $e504db6f9469b1b7$var$reportClean(parent);
}
function $e504db6f9469b1b7$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($e504db6f9469b1b7$var$emptySetPool.length < $e504db6f9469b1b7$var$POOL_TARGET_SIZE) $e504db6f9469b1b7$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $e504db6f9469b1b7$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $e504db6f9469b1b7$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $e504db6f9469b1b7$var$assert(parent.dirtyChildren === null);
}
function $e504db6f9469b1b7$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $e504db6f9469b1b7$var$removeDirtyChild(parent, child);
}
function $e504db6f9469b1b7$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $99b9fbae53bc19a7$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $a7994dc4f2f4cd86$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $a7994dc4f2f4cd86$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $394bb0cffb8d8e41$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $99b9fbae53bc19a7$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $99b9fbae53bc19a7$export$5a15a386532a5ea4).call($a7994dc4f2f4cd86$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $99b9fbae53bc19a7$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $99b9fbae53bc19a7$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $73374cfa1af253e0$var$defaultKeyTrie;
function $73374cfa1af253e0$export$cd3144f8dd136006(...args) {
    const trie = $73374cfa1af253e0$var$defaultKeyTrie || ($73374cfa1af253e0$var$defaultKeyTrie = new (0, $e274f6efb59a47ab$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $73374cfa1af253e0$var$caches = new Set();
function $73374cfa1af253e0$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $73374cfa1af253e0$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $197ae32819081743$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $e504db6f9469b1b7$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $73374cfa1af253e0$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $394bb0cffb8d8e41$export$11fa9682b6ba79b1).hasValue()) {
            $73374cfa1af253e0$var$caches.forEach((cache)=>cache.clean());
            $73374cfa1af253e0$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



function $e2bd674d09ef3503$var$identity(document) {
    return document;
}
var $e2bd674d09ef3503$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $72d024d8344a7591$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($e2bd674d09ef3503$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $e274f6efb59a47ab$export$73571c50d0f2507e)((0, $72d024d8344a7591$export$772fbc04a0ad4ce9));
            this.performWork = (0, $73374cfa1af253e0$export$4997ffc0176396a6)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(Array.isArray(cacheKeys), 77);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $2d6dd17bfab74a36$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $41d8f6344e8a4837$export$87b462129af3b7d4)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $9295a06ae2914616$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();



function $917228a3adf47af9$export$b4df399e879e53ab(result) {
    var errors = $917228a3adf47af9$export$a163557155188b6e(result);
    return (0, $70621a0f16abefe5$export$d307f5934e447d0e)(errors);
}
function $917228a3adf47af9$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $70621a0f16abefe5$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $50488ee97abe3132$export$879767c5cdf33cb3)(result) && (0, $70621a0f16abefe5$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}









var $d97db3fc2836d8df$var$toString = Object.prototype.toString;
function $d97db3fc2836d8df$export$629a2bd3f5a49ecc(value) {
    return $d97db3fc2836d8df$var$cloneDeepHelper(value);
}
function $d97db3fc2836d8df$var$cloneDeepHelper(val, seen) {
    switch($d97db3fc2836d8df$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $d97db3fc2836d8df$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $d97db3fc2836d8df$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

function $1943d9330200122d$export$7ff41c6e01127226(promise) {
    promise.catch(function() {});
    return promise;
}






function $83dadce9b12b2e7d$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(_b, [
        "data"
    ]);
    return (0, $dc3b7a513585078b$export$2e2bcd8739ae039)(aRest, bRest) && $83dadce9b12b2e7d$var$equalBySelectionSet((0, $9295a06ae2914616$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $db291b697516dcdb$export$193789b4c8246dd4)((0, $9295a06ae2914616$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $83dadce9b12b2e7d$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $fc097d395bed33b7$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($83dadce9b12b2e7d$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $727ebff7ca61d150$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $727ebff7ca61d150$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $dc3b7a513585078b$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$83dadce9b12b2e7d$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $83dadce9b12b2e7d$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $db291b697516dcdb$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($83dadce9b12b2e7d$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $83dadce9b12b2e7d$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $83dadce9b12b2e7d$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($83dadce9b12b2e7d$var$directiveIsNonreactive);
}
function $83dadce9b12b2e7d$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}


var $47fe3f121f69c402$var$assign = Object.assign, $47fe3f121f69c402$var$hasOwnProperty = Object.hasOwnProperty;
var $47fe3f121f69c402$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $47fe3f121f69c402$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(_this.maskResult(last.result));
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $47fe3f121f69c402$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        _this.subscribeToMore = _this.subscribeToMore.bind(_this);
        _this.maskResult = _this.maskResult.bind(_this);
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $9295a06ae2914616$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentFullResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $65cb694a13dd958e$export$bd096ddbd246c79c).ready;
        var result = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $65cb694a13dd958e$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $47fe3f121f69c402$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $dc3b7a513585078b$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $47fe3f121f69c402$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        return this.maskResult(this.getCurrentFullResult(saveAsLastResult));
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var documentInfo = this.queryManager.getDocumentInfo(this.query);
        var dataMasking = this.queryManager.dataMasking;
        var query = dataMasking ? documentInfo.nonReactiveQuery : this.query;
        var resultIsDifferent = dataMasking || documentInfo.hasNonreactiveDirective ? !(0, $83dadce9b12b2e7d$export$5e40714c5ad44445)(query, this.last.result, newResult, this.variables) : !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $dc3b7a513585078b$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $47fe3f121f69c402$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $9295a06ae2914616$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(21, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $65cb694a13dd958e$export$bd096ddbd246c79c).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        var updateQuery = fetchMoreOptions === null || fetchMoreOptions === void 0 ? void 0 : fetchMoreOptions.updateQuery;
        var isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(updateQuery, 22);
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $65cb694a13dd958e$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            if (isCached) // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                var lastResult = _this.getLast("result");
                var data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
                _this.reportResult((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, lastResult), {
                    data: data
                }), _this.variables);
            }
            return _this.maskResult(fetchMoreResult);
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !updatedQuerySet.has(_this.query)) $47fe3f121f69c402$export$419171d60552792a(_this);
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).error(23, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $3f2db0b032f9aed0$export$8e16b83750b44988)(this.options, newOptions || {});
        $47fe3f121f69c402$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $dc3b7a513585078b$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $65cb694a13dd958e$export$bd096ddbd246c79c).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval || !this.hasObservers()) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(pollInterval, 24);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $65cb694a13dd958e$export$37509604341a3464)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $65cb694a13dd958e$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $d97db3fc2836d8df$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $3f2db0b032f9aed0$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $47fe3f121f69c402$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            (options.fetchPolicy === oldFetchPolicy || // A `nextFetchPolicy` function has even higher priority, though,
            // so in that case `applyNextFetchPolicy` must be called.
            typeof options.nextFetchPolicy === "function")) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $47fe3f121f69c402$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $dc3b7a513585078b$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $dc3b7a513585078b$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    // Coming from `getResultsFromLink`, `error` here should always be an `ApolloError`.
                    // However, calling `concast.cancel` can inject another type of error, so we have to
                    // wrap it again here.
                    if (!(0, $9b257430d46c4ca9$export$17f5e6bd290bb15d)(error)) error = new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
                        networkError: error
                    });
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return (0, $1943d9330200122d$export$7ff41c6e01127226)(this.reobserveAsConcast(newOptions, newNetworkStatus).promise.then(this.maskResult));
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $d0917683e8dc491d$export$9f6c99ae166dbeca)(this.observers, "next", this.maskResult(result));
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $65cb694a13dd958e$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $d0917683e8dc491d$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    ObservableQuery.prototype.maskResult = function(result) {
        return result && "data" in result ? (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result), {
            data: this.queryManager.maskOperation({
                document: this.query,
                data: result.data,
                fetchPolicy: this.options.fetchPolicy,
                id: this.queryId
            })
        }) : result;
    };
    return ObservableQuery;
}((0, $0777c100e78b6582$export$77cea355fa80b5f4));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $7dcc1fa19fb8a534$export$33c8bd820eece9b2)($47fe3f121f69c402$export$6c1b56eac59c9584);
function $47fe3f121f69c402$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(currentFetchPolicy, context) {
            // Replace this nextFetchPolicy function in the options object with the
            // original this.options.nextFetchPolicy value.
            this.nextFetchPolicy = nextFetchPolicy;
            // If the original nextFetchPolicy value was a function, give it a
            // chance to decide what happens here.
            if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
            // Otherwise go back to the original this.options.fetchPolicy.
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $47fe3f121f69c402$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).error(25, error.message, error.stack);
}
function $47fe3f121f69c402$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).debug(26, missing);
}
function $47fe3f121f69c402$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}








var $bafd5dc1a15fbaa9$var$destructiveMethodCounts = new ((0, $72d024d8344a7591$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $bafd5dc1a15fbaa9$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $bafd5dc1a15fbaa9$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($bafd5dc1a15fbaa9$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
function $bafd5dc1a15fbaa9$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $bafd5dc1a15fbaa9$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$bafd5dc1a15fbaa9$var$destructiveMethodCounts.has(cache)) {
            $bafd5dc1a15fbaa9$var$destructiveMethodCounts.set(cache, 0);
            $bafd5dc1a15fbaa9$var$wrapDestructiveCacheMethod(cache, "evict");
            $bafd5dc1a15fbaa9$var$wrapDestructiveCacheMethod(cache, "modify");
            $bafd5dc1a15fbaa9$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $65cb694a13dd958e$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $65cb694a13dd958e$export$bd096ddbd246c79c).loading && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).setVariables;
        if (!(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $bafd5dc1a15fbaa9$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $dc3b7a513585078b$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we are trying to deliver an incomplete cache result, we avoid
        // reporting it if the query has errored, otherwise we let the broadcast try
        // and repair the partial result by refetching the query. This check avoids
        // a situation where a query that errors and another succeeds with
        // overlapping data does not report the partial data result to the errored
        // query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && ((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.getLastError())) return;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                oq["observe"]();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                (0, $47fe3f121f69c402$export$419171d60552792a)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $bafd5dc1a15fbaa9$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $65cb694a13dd958e$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $bafd5dc1a15fbaa9$var$destructiveMethodCounts.get(this.cache) && (0, $dc3b7a513585078b$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $dc3b7a513585078b$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $e535ffd0d6e4bf3a$export$509e11c221f576c0)();
        var graphQLErrors = (0, $70621a0f16abefe5$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0, $70621a0f16abefe5$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $50488ee97abe3132$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($bafd5dc1a15fbaa9$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $bafd5dc1a15fbaa9$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $dc3b7a513585078b$export$411ce8e5a71e3069)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $bafd5dc1a15fbaa9$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $917228a3adf47af9$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}







var $19008d4ddcbad49f$export$dadc3b13206cb3ad = (0, $72d024d8344a7591$export$772fbc04a0ad4ce9) ? WeakMap : Map;
var $19008d4ddcbad49f$export$de8324a23c9fae9a = (0, $72d024d8344a7591$export$7293b8a0b474028d) ? WeakSet : Set;
var $19008d4ddcbad49f$export$2ddf8815a8abe8b = new (0, $e60b99a95fa3ca06$export$8c6ed5c666ac1360)();
var $19008d4ddcbad49f$var$issuedWarning = false;
function $19008d4ddcbad49f$export$f21dbf49e2bec78b() {
    if (!$19008d4ddcbad49f$var$issuedWarning) {
        $19008d4ddcbad49f$var$issuedWarning = true;
        globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(52);
    }
}








function $02fe49e4b8ae97f9$export$d4ee6fea56447c82(data, selectionSet, context) {
    return (0, $19008d4ddcbad49f$export$2ddf8815a8abe8b).withValue(true, function() {
        var masked = $02fe49e4b8ae97f9$var$maskSelectionSet(data, selectionSet, context, false);
        if (Object.isFrozen(data)) (0, $051c3a1fe8fb825e$export$7f9c177735b71f18)(masked);
        return masked;
    });
}
function $02fe49e4b8ae97f9$var$getMutableTarget(data, mutableTargets) {
    if (mutableTargets.has(data)) return mutableTargets.get(data);
    var mutableTarget = Array.isArray(data) ? [] : Object.create(null);
    mutableTargets.set(data, mutableTarget);
    return mutableTarget;
}
function $02fe49e4b8ae97f9$var$maskSelectionSet(data, selectionSet, context, migration, path) {
    var _a;
    var knownChanged = context.knownChanged;
    var memo = $02fe49e4b8ae97f9$var$getMutableTarget(data, context.mutableTargets);
    if (Array.isArray(data)) {
        for(var _i = 0, _b = Array.from(data.entries()); _i < _b.length; _i++){
            var _c = _b[_i], index = _c[0], item = _c[1];
            if (item === null) {
                memo[index] = null;
                continue;
            }
            var masked = $02fe49e4b8ae97f9$var$maskSelectionSet(item, selectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", "[").concat(index, "]") : void 0);
            if (knownChanged.has(masked)) knownChanged.add(memo);
            memo[index] = masked;
        }
        return knownChanged.has(memo) ? memo : data;
    }
    for(var _d = 0, _e = selectionSet.selections; _d < _e.length; _d++){
        var selection = _e[_d];
        var value = void 0;
        // we later want to add acessor warnings to the final result
        // so we need a new object to add the accessor warning to
        if (migration) knownChanged.add(memo);
        if (selection.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FIELD) {
            var keyName = (0, $727ebff7ca61d150$export$7d1ad22471852218)(selection);
            var childSelectionSet = selection.selectionSet;
            value = memo[keyName] || data[keyName];
            if (value === void 0) continue;
            if (childSelectionSet && value !== null) {
                var masked = $02fe49e4b8ae97f9$var$maskSelectionSet(data[keyName], childSelectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", ".").concat(keyName) : void 0);
                if (knownChanged.has(masked)) value = masked;
            }
            if (!(globalThis.__DEV__ !== false)) memo[keyName] = value;
            if (globalThis.__DEV__ !== false) {
                if (migration && keyName !== "__typename" && // either the field is not present in the memo object
                // or it has a `get` descriptor, not a `value` descriptor
                // => it is a warning accessor and we can overwrite it
                // with another accessor
                !((_a = Object.getOwnPropertyDescriptor(memo, keyName)) === null || _a === void 0 ? void 0 : _a.value)) Object.defineProperty(memo, keyName, $02fe49e4b8ae97f9$var$getAccessorWarningDescriptor(keyName, value, path || "", context.operationName, context.operationType));
                else {
                    delete memo[keyName];
                    memo[keyName] = value;
                }
            }
        }
        if (selection.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).INLINE_FRAGMENT && (!selection.typeCondition || context.cache.fragmentMatches(selection, data.__typename))) value = $02fe49e4b8ae97f9$var$maskSelectionSet(data, selection.selectionSet, context, migration, path);
        if (selection.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_SPREAD) {
            var fragmentName = selection.name.value;
            var fragment = context.fragmentMap[fragmentName] || (context.fragmentMap[fragmentName] = context.cache.lookupFragment(fragmentName));
            (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fragment, 47, fragmentName);
            var mode = (0, $fc097d395bed33b7$export$d6913ace4214003)(selection);
            if (mode !== "mask") value = $02fe49e4b8ae97f9$var$maskSelectionSet(data, fragment.selectionSet, context, mode === "migrate", path);
        }
        if (knownChanged.has(value)) knownChanged.add(memo);
    }
    if ("__typename" in data && !("__typename" in memo)) memo.__typename = data.__typename;
    // This check prevents cases where masked fields may accidentally be
    // returned as part of this object when the fragment also selects
    // additional fields from the same child selection.
    if (Object.keys(memo).length !== Object.keys(data).length) knownChanged.add(memo);
    return knownChanged.has(memo) ? memo : data;
}
function $02fe49e4b8ae97f9$var$getAccessorWarningDescriptor(fieldName, value, path, operationName, operationType) {
    var getValue = function() {
        if ((0, $19008d4ddcbad49f$export$2ddf8815a8abe8b).getValue()) return value;
        globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(48, operationName ? "".concat(operationType, " '").concat(operationName, "'") : "anonymous ".concat(operationType), "".concat(path, ".").concat(fieldName).replace(/^\./, ""));
        getValue = function() {
            return value;
        };
        return value;
    };
    return {
        get: function() {
            return getValue();
        },
        set: function(newValue) {
            getValue = function() {
                return newValue;
            };
        },
        enumerable: true,
        configurable: true
    };
}



function $7c6a9e719f605031$export$adbebb59d1aeea97(data, document, cache, fragmentName) {
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $19008d4ddcbad49f$export$f21dbf49e2bec78b)();
        return data;
    }
    var fragments = document.definitions.filter(function(node) {
        return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
    });
    if (typeof fragmentName === "undefined") {
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fragments.length === 1, 49, fragments.length);
        fragmentName = fragments[0].name.value;
    }
    var fragment = fragments.find(function(fragment) {
        return fragment.name.value === fragmentName;
    });
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!!fragment, 50, fragmentName);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    if ((0, $dc3b7a513585078b$export$2e2bcd8739ae039)(data, {})) // Return early and skip the masking algorithm if we don't have any data
    // yet. This can happen when cache.diff returns an empty object which is
    // used from watchFragment.
    return data;
    return (0, $02fe49e4b8ae97f9$export$d4ee6fea56447c82)(data, fragment.selectionSet, {
        operationType: "fragment",
        operationName: fragment.name.value,
        fragmentMap: (0, $db291b697516dcdb$export$193789b4c8246dd4)((0, $9295a06ae2914616$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $19008d4ddcbad49f$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $19008d4ddcbad49f$export$de8324a23c9fae9a)()
    });
}





function $031495f9de4fbb25$export$74a61e4252a4a2ef(data, document, cache) {
    var _a;
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $19008d4ddcbad49f$export$f21dbf49e2bec78b)();
        return data;
    }
    var definition = (0, $9295a06ae2914616$export$7a5b1fa979d2c158)(document);
    (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(definition, 51);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    return (0, $02fe49e4b8ae97f9$export$d4ee6fea56447c82)(data, definition.selectionSet, {
        operationType: definition.operation,
        operationName: (_a = definition.name) === null || _a === void 0 ? void 0 : _a.value,
        fragmentMap: (0, $db291b697516dcdb$export$193789b4c8246dd4)((0, $9295a06ae2914616$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $19008d4ddcbad49f$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $19008d4ddcbad49f$export$de8324a23c9fae9a)()
    });
}


var $b6b210c1f92924fc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b6b210c1f92924fc$var$IGNORE = Object.create(null);
var $b6b210c1f92924fc$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(options) {
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $b8955c60f2fefc81$export$8dbad6f439bb2331)((0, $2d6dd17bfab74a36$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $e274f6efb59a47ab$export$73571c50d0f2507e)(false);
        this.noCacheWarningsByQueryId = new Set();
        var defaultDocumentTransform = new (0, $e2bd674d09ef3503$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = options.cache;
        this.link = options.link;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientAwareness = options.clientAwareness;
        this.localState = options.localState;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        this.dataMasking = options.dataMasking;
        var documentTransform = options.documentTransform;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || Object.create(null);
        if (this.onBroadcast = options.onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $13e6b16068d1c6dc$export$3991762405098ea)(27));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(mutation, 28);
                        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 29);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $0a25504e1b93079e$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, {}, false), function(result) {
                                    if ((0, $917228a3adf47af9$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $917228a3adf47af9$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $917228a3adf47af9$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, storeResult), {
                                            data: self.maskOperation({
                                                document: mutation,
                                                data: storeResult.data,
                                                fetchPolicy: fetchPolicy,
                                                id: mutationId
                                            })
                                        }));
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $9b257430d46c4ca9$export$26a337512320b8c6) ? err : new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $bafd5dc1a15fbaa9$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $50488ee97abe3132$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $50488ee97abe3132$export$879767c5cdf33cb3)(result) && (0, $70621a0f16abefe5$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $50488ee97abe3132$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$b6b210c1f92924fc$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $9295a06ae2914616$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $50488ee97abe3132$export$f90dc0a3531b8b83)(result) || (0, $50488ee97abe3132$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $b6b210c1f92924fc$var$IGNORE
        }) : optimisticResponse;
        if (data === $b6b210c1f92924fc$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $fc097d395bed33b7$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $fc097d395bed33b7$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                nonReactiveQuery: (0, $4c1e2a8713312ae6$export$b6125cad5877ac5e)(document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $4c1e2a8713312ae6$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    },
                    {
                        name: "unmask"
                    }
                ], document),
                defaultVars: (0, $9295a06ae2914616$export$84c19026e616569e)((0, $9295a06ae2914616$export$7a5b1fa979d2c158)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $bafd5dc1a15fbaa9$export$79a6120a39c90b6a)(this);
        var observable = new (0, $47fe3f121f69c402$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(options.query, 30);
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(options.query.kind === "Document", 31);
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!options.returnPartialData, 32);
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!options.pollInterval, 33);
        var query = this.transform(options.query);
        return this.fetchQuery(queryId, (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            query: query
        })).then(function(result) {
            return result && (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result), {
                data: _this.maskOperation({
                    document: query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: queryId
                })
            });
        }).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $13e6b16068d1c6dc$export$3991762405098ea)(34));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNames = new Map();
        var queryNamesAndQueryStrings = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") {
                queryNames.set(desc, desc);
                queryNamesAndQueryStrings.set(desc, false);
            } else if ((0, $727ebff7ca61d150$export$540432d49fcec6c9)(desc)) {
                var queryString = (0, $71b2db41ea98f453$export$c2d084dc44961371)(_this.transform(desc));
                queryNames.set(queryString, (0, $9295a06ae2914616$export$41bca9dc6871dd4e)(desc));
                queryNamesAndQueryStrings.set(queryString, false);
            } else if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndQueryStrings.has(queryName) || document && queryNamesAndQueryStrings.has((0, $71b2db41ea98f453$export$c2d084dc44961371)(document))) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndQueryStrings.set(queryName, true);
                    if (document) queryNamesAndQueryStrings.set((0, $71b2db41ea98f453$export$c2d084dc44961371)(document), true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $78235a8d3a48b5b8$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $47fe3f121f69c402$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndQueryStrings.size) queryNamesAndQueryStrings.forEach(function(included, nameOrQueryString) {
            if (!included) {
                var queryName = queryNames.get(nameOrQueryString);
                if (queryName) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(35, queryName);
                else globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(36);
            }
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(options) {
        var _this = this;
        var query = options.query, variables = options.variables;
        var fetchPolicy = options.fetchPolicy, _a = options.errorPolicy, errorPolicy = _a === void 0 ? "none" : _a, _b = options.context, context = _b === void 0 ? {} : _b, _c = options.extensions, extensions = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, extensions).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $bafd5dc1a15fbaa9$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $917228a3adf47af9$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $9b257430d46c4ca9$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $9b257430d46c4ca9$export$4995664c1b49842e];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $9b257430d46c4ca9$export$26a337512320b8c6)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, extensions, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $9295a06ae2914616$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                })),
                extensions: extensions
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $71b2db41ea98f453$export$c2d084dc44961371)(serverQuery);
                var varJson_1 = (0, $55d10b943a98270e$export$88a0ad9b6f961b51)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new (0, $76f58a4c82f1ce58$export$ae0cf2ec7a6fa78e)([
                        (0, $efb291821d4d3ba4$export$51396ec711da548b)(link, operation)
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function() {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $76f58a4c82f1ce58$export$ae0cf2ec7a6fa78e)([
                (0, $efb291821d4d3ba4$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $76f58a4c82f1ce58$export$ae0cf2ec7a6fa78e)([
                (0, $0777c100e78b6582$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $0a25504e1b93079e$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $0a25504e1b93079e$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $917228a3adf47af9$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            var errorPolicy = options.errorPolicy;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $65cb694a13dd958e$export$bd096ddbd246c79c).ready
            };
            // In the case we start multiple network requests simulatenously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors && errorPolicy === "none") aqr.data = void 0;
            if (hasErrors && errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $9b257430d46c4ca9$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $9b257430d46c4ca9$export$26a337512320b8c6)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $65cb694a13dd958e$export$bd096ddbd246c79c).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $76f58a4c82f1ce58$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $76f58a4c82f1ce58$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $78235a8d3a48b5b8$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $bafd5dc1a15fbaa9$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset(); // Force info.getDiff() to read from cache.
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.maskOperation = function(options) {
        var _a, _b, _c;
        var document = options.document, data = options.data;
        if (globalThis.__DEV__ !== false) {
            var fetchPolicy = options.fetchPolicy, id = options.id;
            var operationType = (_a = (0, $9295a06ae2914616$export$7a5b1fa979d2c158)(document)) === null || _a === void 0 ? void 0 : _a.operation;
            var operationId = ((_b = operationType === null || operationType === void 0 ? void 0 : operationType[0]) !== null && _b !== void 0 ? _b : "o") + id;
            if (this.dataMasking && fetchPolicy === "no-cache" && !(0, $db291b697516dcdb$export$5b84f3d7865d4e49)(document) && !this.noCacheWarningsByQueryId.has(operationId)) {
                this.noCacheWarningsByQueryId.add(operationId);
                globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(37, (_c = (0, $9295a06ae2914616$export$41bca9dc6871dd4e)(document)) !== null && _c !== void 0 ? _c : "Unnamed ".concat(operationType !== null && operationType !== void 0 ? operationType : "operation"));
            }
        }
        return this.dataMasking ? (0, $031495f9de4fbb25$export$74a61e4252a4a2ef)(data, document, this.cache) : data;
    };
    QueryManager.prototype.maskFragment = function(options) {
        var data = options.data, fragment = options.fragment, fragmentName = options.fragmentName;
        return this.dataMasking ? (0, $7c6a9e719f605031$export$adbebb59d1aeea97)(data, fragment, this.cache, fragmentName) : data;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $65cb694a13dd958e$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(data, {})) (0, $47fe3f121f69c402$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $0777c100e78b6582$export$77cea355fa80b5f4).of((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $65cb694a13dd958e$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $65cb694a13dd958e$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $65cb694a13dd958e$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $bafd5dc1a15fbaa9$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





function $5ac78f1effd2d4db$export$e7ecd7c16613ccfd(node) {
    return $5ac78f1effd2d4db$export$4cedd8740794bd78(node) || $5ac78f1effd2d4db$export$b05c7141ec7770ba(node) || $5ac78f1effd2d4db$export$fbc18e88163d676d(node);
}
function $5ac78f1effd2d4db$export$4cedd8740794bd78(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $5ac78f1effd2d4db$export$65772b71e1d017ba(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FIELD || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $5ac78f1effd2d4db$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).INT || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FLOAT || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).STRING || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).NULL || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).ENUM || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).LIST || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OBJECT;
}
function $5ac78f1effd2d4db$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $5ac78f1effd2d4db$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCHEMA_DEFINITION || $5ac78f1effd2d4db$export$a3584bba04f5bfe0(node) || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $5ac78f1effd2d4db$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $5ac78f1effd2d4db$export$fbc18e88163d676d(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCHEMA_EXTENSION || $5ac78f1effd2d4db$export$d7907721b241e11f(node);
}
function $5ac78f1effd2d4db$export$d7907721b241e11f(node) {
    return node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}




var $6c2bfb7bad941e2f$export$ac9723609f5c76c2 = new (0, $e60b99a95fa3ca06$export$8c6ed5c666ac1360)();
var $6c2bfb7bad941e2f$var$cacheInfoMap = new WeakMap();
function $6c2bfb7bad941e2f$var$getCacheInfo(cache) {
    var info = $6c2bfb7bad941e2f$var$cacheInfoMap.get(cache);
    if (!info) $6c2bfb7bad941e2f$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $a7994dc4f2f4cd86$export$c723b7eff9d8f870)()
    });
    return info;
}
function $6c2bfb7bad941e2f$export$cbe12faed7725318(cache) {
    $6c2bfb7bad941e2f$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $6c2bfb7bad941e2f$export$f342bdd61b3e9412(cache) {
    $6c2bfb7bad941e2f$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $6c2bfb7bad941e2f$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $6c2bfb7bad941e2f$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $6c2bfb7bad941e2f$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $6c2bfb7bad941e2f$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $6c2bfb7bad941e2f$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $6c2bfb7bad941e2f$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $6c2bfb7bad941e2f$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $987a2d64a4217f98$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $e535ffd0d6e4bf3a$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $e535ffd0d6e4bf3a$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $fc097d395bed33b7$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $4c1e2a8713312ae6$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $3251f4f9c1be355c$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $4c1e2a8713312ae6$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $9295a06ae2914616$export$f431198736b7f96d)(document);
                fragments = (0, $9295a06ae2914616$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $db291b697516dcdb$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $fc097d395bed33b7$export$3dc388a5f013b4a5)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $727ebff7ca61d150$export$fb56ad75dd311c12)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $727ebff7ca61d150$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $727ebff7ca61d150$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fragment, 19, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $e535ffd0d6e4bf3a$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $fcf1ddc4ac014517$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fcf1ddc4ac014517$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $727ebff7ca61d150$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $6c2bfb7bad941e2f$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $727ebff7ca61d150$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $3251f4f9c1be355c$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $5ac78f1effd2d4db$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(fragment, 20, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $5ac78f1effd2d4db$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();




var $d7836991bbce1d27$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */ var $d7836991bbce1d27$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        var _a;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(16);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _b = options.ssrMode, ssrMode = _b === void 0 ? false : _b, _c = options.ssrForceFetchDelay, ssrForceFetchDelay = _c === void 0 ? 0 : _c, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = options.connectToDevTools, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version, devtools = options.devtools, dataMasking = options.dataMasking;
        var link = options.link;
        if (!link) link = uri ? new (0, $2bf3f639f4de5702$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $0b78640641df936b$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        this.devtoolsConfig = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, devtools), {
            enabled: (_a = devtools === null || devtools === void 0 ? void 0 : devtools.enabled) !== null && _a !== void 0 ? _a : connectToDevTools
        });
        if (this.devtoolsConfig.enabled === undefined) this.devtoolsConfig.enabled = globalThis.__DEV__ !== false;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $23ecff8bd5ab6c93$export$83d89fbfd8236492);
        this.localState = new (0, $987a2d64a4217f98$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $b6b210c1f92924fc$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            dataMasking: !!dataMasking,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (this.devtoolsConfig.enabled) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "undefined") return;
        var windowWithDevTools = window;
        var devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$d7836991bbce1d27$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $d7836991bbce1d27$var$hasSuggestedDevtools = true;
            if (window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol)) setTimeout(function() {
                if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $35685e6ff291993f$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $35685e6ff291993f$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 17);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $35685e6ff291993f$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        var _this = this;
        var id = this.queryManager.generateQueryId();
        return this.queryManager.startGraphQLSubscription(options).map(function(result) {
            return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, result), {
                data: _this.queryManager.maskOperation({
                    document: options.query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: id
                })
            });
        });
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */ ApolloClient.prototype.watchFragment = function(options) {
        var _a;
        return this.cache.watchFragment((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), (_a = {}, _a[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, _a)));
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $efb291821d4d3ba4$export$51396ec711da548b)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).debug(18, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $d7836991bbce1d27$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $6d39cfba9615c908$export$dfdba94ce46d2ea5);


var $6c08b0a93cf04345$export$6788812c4e6611e6 = (0, $0b78640641df936b$export$2fed3d61f740bc7f).from;














var $bb9a26128f354978$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $73374cfa1af253e0$export$4997ffc0176396a6)((0, $db291b697516dcdb$export$abbf37c7cf644e41), {
            max: (0, $2d6dd17bfab74a36$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $41d8f6344e8a4837$export$87b462129af3b7d4)
        });
    }
    // Function used to lookup a fragment when a fragment definition is not part
    // of the GraphQL document. This is useful for caches, such as InMemoryCache,
    // that register fragments ahead of time so they can be referenced by name.
    ApolloCache.prototype.lookupFragment = function(fragmentName) {
        return null;
    };
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    /** {@inheritDoc @apollo/client!ApolloClient#watchFragment:member(1)} */ ApolloCache.prototype.watchFragment = function(options) {
        var _this = this;
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, otherOptions = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(options, [
            "fragment",
            "fragmentName",
            "from",
            "optimistic"
        ]);
        var query = this.getFragmentDoc(fragment, fragmentName);
        // While our TypeScript types do not allow for `undefined` as a valid
        // `from`, its possible `useFragment` gives us an `undefined` since it
        // calls` cache.identify` and provides that value to `from`. We are
        // adding this fix here however to ensure those using plain JavaScript
        // and using `cache.identify` themselves will avoid seeing the obscure
        // warning.
        var id = typeof from === "undefined" || typeof from === "string" ? from : this.identify(from);
        var dataMasking = !!options[Symbol.for("apollo.dataMasking")];
        if (globalThis.__DEV__ !== false) {
            var actualFragmentName = fragmentName || (0, $9295a06ae2914616$export$772111caef41b3f5)(fragment).name.value;
            if (!id) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(1, actualFragmentName);
        }
        var diffOptions = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, otherOptions), {
            returnPartialData: true,
            id: id,
            query: query,
            optimistic: optimistic
        });
        var latestDiff;
        return new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(function(observer) {
            return _this.watch((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, diffOptions), {
                immediate: true,
                callback: function(diff) {
                    var data = dataMasking ? (0, $7c6a9e719f605031$export$adbebb59d1aeea97)(diff.result, fragment, _this, fragmentName) : diff.result;
                    if (// Always ensure we deliver the first result
                    latestDiff && (0, $83dadce9b12b2e7d$export$5e40714c5ad44445)(query, {
                        data: latestDiff.result
                    }, {
                        data: data
                    }, // TODO: Fix the type on WatchFragmentOptions so that TVars
                    // extends OperationVariables
                    options.variables)) return;
                    var result = {
                        data: data,
                        complete: !!diff.complete
                    };
                    if (diff.missing) result.missing = (0, $e535ffd0d6e4bf3a$export$160070228be94b08)(diff.missing.map(function(error) {
                        return error.missing;
                    }));
                    latestDiff = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, diff), {
                        result: data
                    });
                    observer.next(result);
                }
            }));
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $bb9a26128f354978$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $6d39cfba9615c908$export$e7ed438e82606689);



var $e8ca867f3b80d8dd$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);















var $37503e9c21335171$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $37503e9c21335171$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $37503e9c21335171$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$37503e9c21335171$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$37503e9c21335171$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($37503e9c21335171$export$b931b78cbb3caf86(id) && !$37503e9c21335171$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$37503e9c21335171$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $37503e9c21335171$var$defaultConfig = {
    dataIdFromObject: $37503e9c21335171$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $37503e9c21335171$export$fa542f9ee3f7f4e2(config) {
    return (0, $3f2db0b032f9aed0$export$8e16b83750b44988)($37503e9c21335171$var$defaultConfig, config);
}
function $37503e9c21335171$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $37503e9c21335171$var$defaultConfig.canonizeResults : value;
}
function $37503e9c21335171$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $727ebff7ca61d150$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $37503e9c21335171$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $37503e9c21335171$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($37503e9c21335171$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $37503e9c21335171$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(result)) return (0, $70621a0f16abefe5$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $37503e9c21335171$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $727ebff7ca61d150$export$fb56ad75dd311c12)(field) && (0, $fc097d395bed33b7$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $727ebff7ca61d150$export$7d1ad22471852218)(field);
            return $37503e9c21335171$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $37503e9c21335171$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $37503e9c21335171$export$4f39afca21bd938e(value) {
    return (0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value) && !(0, $727ebff7ca61d150$export$fa99cac1c0883c47)(value) && !(0, $70621a0f16abefe5$export$43bee75e5e14138e)(value);
}
function $37503e9c21335171$export$b874a818f7a2fa6d() {
    return new (0, $e535ffd0d6e4bf3a$export$509e11c221f576c0)();
}
function $37503e9c21335171$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $db291b697516dcdb$export$193789b4c8246dd4)((0, $9295a06ae2914616$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


var $c1ead16c607d54ca$var$DELETE = Object.create(null);
var $c1ead16c607d54ca$var$delModifier = function() {
    return $c1ead16c607d54ca$var$DELETE;
};
var $c1ead16c607d54ca$var$INVALIDATE = Object.create(null);
var $c1ead16c607d54ca$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $051c3a1fe8fb825e$export$7f9c177735b71f18)((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $727ebff7ca61d150$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $727ebff7ca61d150$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $727ebff7ca61d150$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $c1ead16c607d54ca$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $c1ead16c607d54ca$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(typeof dataId === "string", 2);
        var merged = new (0, $e535ffd0d6e4bf3a$export$509e11c221f576c0)($c1ead16c607d54ca$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $37503e9c21335171$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $c1ead16c607d54ca$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $c1ead16c607d54ca$var$DELETE,
                INVALIDATE: $c1ead16c607d54ca$var$INVALIDATE,
                isReference: (0, $727ebff7ca61d150$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $727ebff7ca61d150$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $37503e9c21335171$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $c1ead16c607d54ca$var$delModifier ? $c1ead16c607d54ca$var$DELETE : modify((0, $051c3a1fe8fb825e$export$7f9c177735b71f18)(fieldValue), (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $c1ead16c607d54ca$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $c1ead16c607d54ca$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(3, ref);
                                        return true;
                                    }
                                };
                                if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(4, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $c1ead16c607d54ca$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $c1ead16c607d54ca$var$delModifier, _a) : $c1ead16c607d54ca$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $c1ead16c607d54ca$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $c1ead16c607d54ca$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $c1ead16c607d54ca$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $c1ead16c607d54ca$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $a7994dc4f2f4cd86$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $e274f6efb59a47ab$export$73571c50d0f2507e)((0, $72d024d8344a7591$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($c1ead16c607d54ca$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $37503e9c21335171$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($c1ead16c607d54ca$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($c1ead16c607d54ca$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $c1ead16c607d54ca$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $c1ead16c607d54ca$export$f8068a30967ddc18(store, entityId) {
    if ($c1ead16c607d54ca$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $c1ead16c607d54ca$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $c1ead16c607d54ca$var$Stump(_this);
            _this.storageTrie = new (0, $e274f6efb59a47ab$export$73571c50d0f2507e)((0, $72d024d8344a7591$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($c1ead16c607d54ca$export$cb507f57054c7321 || ($c1ead16c607d54ca$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $c1ead16c607d54ca$var$Layer = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($c1ead16c607d54ca$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $c1ead16c607d54ca$var$Stump = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $c1ead16c607d54ca$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($c1ead16c607d54ca$var$Layer);
function $c1ead16c607d54ca$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $dc3b7a513585078b$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $c1ead16c607d54ca$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $c1ead16c607d54ca$export$cb507f57054c7321 && store.group.caching);
}








function $c76e0ae41fc6585e$var$shallowCopy(value) {
    if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value)) return (0, $70621a0f16abefe5$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $c76e0ae41fc6585e$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $72d024d8344a7591$export$7293b8a0b474028d) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $e274f6efb59a47ab$export$73571c50d0f2507e)((0, $72d024d8344a7591$export$772fbc04a0ad4ce9));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value)) {
            var copy = $c76e0ae41fc6585e$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();


function $f37f602827e67249$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $f37f602827e67249$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $72d024d8344a7591$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $3f2db0b032f9aed0$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $37503e9c21335171$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $c76e0ae41fc6585e$export$c2e7fdd82233f4a4)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $73374cfa1af253e0$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $f37f602827e67249$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $c1ead16c607d54ca$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $2d6dd17bfab74a36$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $f37f602827e67249$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $c1ead16c607d54ca$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $727ebff7ca61d150$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $73374cfa1af253e0$export$4997ffc0176396a6)(function(options) {
            (0, $c1ead16c607d54ca$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $2d6dd17bfab74a36$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $c1ead16c607d54ca$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $c76e0ae41fc6585e$export$c2e7fdd82233f4a4)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, (0, $9295a06ae2914616$export$84c19026e616569e)((0, $9295a06ae2914616$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $727ebff7ca61d150$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $9295a06ae2914616$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $55d10b943a98270e$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $37503e9c21335171$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $e8ca867f3b80d8dd$export$257c68286583b0f9)($f37f602827e67249$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $c1ead16c607d54ca$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $e535ffd0d6e4bf3a$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $fc097d395bed33b7$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $727ebff7ca61d150$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $727ebff7ca61d150$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $4c1e2a8713312ae6$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $727ebff7ca61d150$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $db291b697516dcdb$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(10, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $e535ffd0d6e4bf3a$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $051c3a1fe8fb825e$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $e535ffd0d6e4bf3a$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $727ebff7ca61d150$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $f37f602827e67249$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $f37f602827e67249$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $f37f602827e67249$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value)) {
                (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!(0, $727ebff7ca61d150$export$fa99cac1c0883c47)(value), 11, (0, $37503e9c21335171$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

















// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $b48caf6f8999bbe3$var$specifierInfoCache = Object.create(null);
function $b48caf6f8999bbe3$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $b48caf6f8999bbe3$var$specifierInfoCache[cacheKey] || ($b48caf6f8999bbe3$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $b48caf6f8999bbe3$export$f1953a0407594d2c(specifier) {
    var info = $b48caf6f8999bbe3$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $b48caf6f8999bbe3$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $b48caf6f8999bbe3$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $b48caf6f8999bbe3$export$e8f64f7a025887d3(object, schemaKeyPath, $b48caf6f8999bbe3$var$extractKey);
            (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(extracted !== void 0, 5, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $b48caf6f8999bbe3$export$550737ee0cc371ac(specifier) {
    var info = $b48caf6f8999bbe3$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $b48caf6f8999bbe3$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $70621a0f16abefe5$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $727ebff7ca61d150$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $b48caf6f8999bbe3$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $b48caf6f8999bbe3$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $b48caf6f8999bbe3$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $b48caf6f8999bbe3$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $e535ffd0d6e4bf3a$export$509e11c221f576c0)();
    return $b48caf6f8999bbe3$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $b48caf6f8999bbe3$export$eca459f173e85801(spec) {
    var info = $b48caf6f8999bbe3$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(s)) {
                $b48caf6f8999bbe3$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $70621a0f16abefe5$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $b48caf6f8999bbe3$var$extractKey(object, key) {
    return object[key];
}
function $b48caf6f8999bbe3$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $b48caf6f8999bbe3$var$extractKey;
    return $b48caf6f8999bbe3$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $70621a0f16abefe5$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $b48caf6f8999bbe3$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(value)) {
        if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(value)) return value.map($b48caf6f8999bbe3$var$normalize);
        return $b48caf6f8999bbe3$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $b48caf6f8999bbe3$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}



function $7e60976a77e6c112$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $727ebff7ca61d150$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $7e60976a77e6c112$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $7e60976a77e6c112$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $7e60976a77e6c112$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $7e60976a77e6c112$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $7e60976a77e6c112$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $37503e9c21335171$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $7e60976a77e6c112$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        (0, $19008d4ddcbad49f$export$2ddf8815a8abe8b).withValue(true, function() {
            while(keyFn){
                var specifierOrId = keyFn((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, object), storeObject), context);
                if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $b48caf6f8999bbe3$export$f1953a0407594d2c)(specifierOrId);
                else {
                    id = specifierOrId;
                    break;
                }
            }
        });
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $7e60976a77e6c112$var$mergeTrueFn : merge === false ? $7e60976a77e6c112$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $7e60976a77e6c112$var$nullKeyFieldsFn : (0, $70621a0f16abefe5$export$43bee75e5e14138e)(keyFields) ? (0, $b48caf6f8999bbe3$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $7e60976a77e6c112$var$simpleKeyArgsFn : (0, $70621a0f16abefe5$export$43bee75e5e14138e)(keyArgs) ? (0, $b48caf6f8999bbe3$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $7e60976a77e6c112$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(!old || old === which, 6, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $37503e9c21335171$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $fcf1ddc4ac014517$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(7, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $37503e9c21335171$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $7e60976a77e6c112$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $b48caf6f8999bbe3$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $727ebff7ca61d150$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $727ebff7ca61d150$export$3cdb6c178b88cabe)(fieldName, $7e60976a77e6c112$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $37503e9c21335171$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $37503e9c21335171$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $7e60976a77e6c112$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $6c2bfb7bad941e2f$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $7e60976a77e6c112$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $7e60976a77e6c112$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $7e60976a77e6c112$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $7e60976a77e6c112$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $7e60976a77e6c112$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $37503e9c21335171$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $7e60976a77e6c112$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $727ebff7ca61d150$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($7e60976a77e6c112$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $7e60976a77e6c112$var$makeMergeObjectsFunction(context.store)
    };
}
function $7e60976a77e6c112$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(8, (0, $b155c7d2c29bed03$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $7e60976a77e6c112$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(existing) || (0, $70621a0f16abefe5$export$43bee75e5e14138e)(incoming)) throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(9);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(existing) && (0, $28bb6a3d2161c7ef$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(existing) && (0, $37503e9c21335171$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $37503e9c21335171$export$4f39afca21bd938e)(existing) && (0, $727ebff7ca61d150$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $37503e9c21335171$export$4f39afca21bd938e)(existing) && (0, $37503e9c21335171$export$4f39afca21bd938e)(incoming)) return (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $d1e8af97c7c75b13$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $d1e8af97c7c75b13$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $9295a06ae2914616$export$7a5b1fa979d2c158)(query);
        var merger = (0, $37503e9c21335171$export$b874a818f7a2fa6d)();
        variables = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, (0, $9295a06ae2914616$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $55d10b943a98270e$export$88a0ad9b6f961b51)(variables)
        }, (0, $37503e9c21335171$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $727ebff7ca61d150$export$fa99cac1c0883c47)(ref)) throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(12, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $727ebff7ca61d150$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $37503e9c21335171$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $d1e8af97c7c75b13$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $727ebff7ca61d150$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $7e60976a77e6c112$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $727ebff7ca61d150$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $d1e8af97c7c75b13$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $d1e8af97c7c75b13$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(incomingValue) || (0, $37503e9c21335171$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $d1e8af97c7c75b13$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $4c1e2a8713312ae6$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).error(13, (0, $727ebff7ca61d150$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $727ebff7ca61d150$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $d1e8af97c7c75b13$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $d1e8af97c7c75b13$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $d97db3fc2836d8df$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $70621a0f16abefe5$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $d1e8af97c7c75b13$var$getChildMergeTree(mergeTree, i));
            $d1e8af97c7c75b13$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $727ebff7ca61d150$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $e274f6efb59a47ab$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $fc097d395bed33b7$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $70621a0f16abefe5$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $727ebff7ca61d150$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $727ebff7ca61d150$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $d1e8af97c7c75b13$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $db291b697516dcdb$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $38005e35e9207b1b$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $13e6b16068d1c6dc$export$3991762405098ea)(14, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $d1e8af97c7c75b13$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $727ebff7ca61d150$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $70621a0f16abefe5$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(existing) || (0, $37503e9c21335171$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $727ebff7ca61d150$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $70621a0f16abefe5$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $13e6b16068d1c6dc$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $70621a0f16abefe5$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $d1e8af97c7c75b13$var$emptyMergeTreePool = [];
function $d1e8af97c7c75b13$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $d1e8af97c7c75b13$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $d1e8af97c7c75b13$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $d1e8af97c7c75b13$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $d1e8af97c7c75b13$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $d1e8af97c7c75b13$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $d1e8af97c7c75b13$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $d1e8af97c7c75b13$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $d1e8af97c7c75b13$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $d1e8af97c7c75b13$var$mergeTreeIsEmpty(childTree)) {
        $d1e8af97c7c75b13$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $d1e8af97c7c75b13$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $d1e8af97c7c75b13$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $dc3b7a513585078b$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $37503e9c21335171$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($d1e8af97c7c75b13$var$warnings.has(typeDotName)) return;
    $d1e8af97c7c75b13$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $70621a0f16abefe5$export$43bee75e5e14138e)(existing) && !(0, $70621a0f16abefe5$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(15, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, existing), (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, incoming));
}







var $62017acf35ccf2aa$export$467265324939f47f = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $e2bd674d09ef3503$export$f887060e48e5dc1b)((0, $4c1e2a8713312ae6$export$43b332f87950a467));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $6c2bfb7bad941e2f$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.config = (0, $37503e9c21335171$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $7e60976a77e6c112$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $c1ead16c607d54ca$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $d1e8af97c7c75b13$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $f37f602827e67249$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $37503e9c21335171$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $73374cfa1af253e0$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $2d6dd17bfab74a36$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $c1ead16c607d54ca$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $55d10b943a98270e$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $e8ca867f3b80d8dd$export$257c68286583b0f9)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $6c2bfb7bad941e2f$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $6c2bfb7bad941e2f$export$cbe12faed7725318)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, $55d10b943a98270e$export$88a0ad9b6f961b51).reset();
        (0, $71b2db41ea98f453$export$c2d084dc44961371).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $727ebff7ca61d150$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $13e6b16068d1c6dc$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $37503e9c21335171$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $55d10b943a98270e$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $6c2bfb7bad941e2f$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)((0, $fcf1ddc4ac014517$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.fragmentMatches = function(fragment, typename) {
        return this.policies.fragmentMatches(fragment, typename);
    };
    InMemoryCache.prototype.lookupFragment = function(fragmentName) {
        var _a;
        return ((_a = this.config.fragments) === null || _a === void 0 ? void 0 : _a.lookup(fragmentName)) || null;
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $dc3b7a513585078b$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $bb9a26128f354978$export$5fc74f25506aa9c));
if (globalThis.__DEV__ !== false) $62017acf35ccf2aa$export$467265324939f47f.prototype.getMemoryInternals = (0, $6d39cfba9615c908$export$e95a5a2210e62466);



var $1348d703e55ea145$exports = {};
"use strict";
var $1348d703e55ea145$var$__assign = $1348d703e55ea145$exports && $1348d703e55ea145$exports.__assign || function() {
    $1348d703e55ea145$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1348d703e55ea145$var$__assign.apply(this, arguments);
};
var $1348d703e55ea145$var$__awaiter = $1348d703e55ea145$exports && $1348d703e55ea145$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1348d703e55ea145$var$__generator = $1348d703e55ea145$exports && $1348d703e55ea145$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1348d703e55ea145$var$__spreadArrays = $1348d703e55ea145$exports && $1348d703e55ea145$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($1348d703e55ea145$exports, "__esModule", {
    value: true
});
$1348d703e55ea145$exports.SubscriptionClient = void 0;
var $1348d703e55ea145$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : {};
var $1348d703e55ea145$var$NativeWebSocket = $1348d703e55ea145$var$_global.WebSocket || $1348d703e55ea145$var$_global.MozWebSocket;
var $03bcd8576ab2b77a$exports = {};
/**
 * Expose `Backoff`.
 */ $03bcd8576ab2b77a$exports = $03bcd8576ab2b77a$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $03bcd8576ab2b77a$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $03bcd8576ab2b77a$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $03bcd8576ab2b77a$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $03bcd8576ab2b77a$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $03bcd8576ab2b77a$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $03bcd8576ab2b77a$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};


var $cb3175b72a6f5d4f$exports = {};
'use strict';
var $cb3175b72a6f5d4f$var$has = Object.prototype.hasOwnProperty, $cb3175b72a6f5d4f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $cb3175b72a6f5d4f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $cb3175b72a6f5d4f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $cb3175b72a6f5d4f$var$Events().__proto__) $cb3175b72a6f5d4f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $cb3175b72a6f5d4f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $cb3175b72a6f5d4f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $cb3175b72a6f5d4f$var$EE(fn, context || emitter, once), evt = $cb3175b72a6f5d4f$var$prefix ? $cb3175b72a6f5d4f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $cb3175b72a6f5d4f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $cb3175b72a6f5d4f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $cb3175b72a6f5d4f$var$EventEmitter() {
    this._events = new $cb3175b72a6f5d4f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($cb3175b72a6f5d4f$var$has.call(events, name)) names.push($cb3175b72a6f5d4f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $cb3175b72a6f5d4f$var$prefix ? $cb3175b72a6f5d4f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $cb3175b72a6f5d4f$var$prefix ? $cb3175b72a6f5d4f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $cb3175b72a6f5d4f$var$prefix ? $cb3175b72a6f5d4f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $cb3175b72a6f5d4f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $cb3175b72a6f5d4f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $cb3175b72a6f5d4f$var$prefix ? $cb3175b72a6f5d4f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $cb3175b72a6f5d4f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $cb3175b72a6f5d4f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $cb3175b72a6f5d4f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cb3175b72a6f5d4f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $cb3175b72a6f5d4f$var$prefix ? $cb3175b72a6f5d4f$var$prefix + event : event;
        if (this._events[evt]) $cb3175b72a6f5d4f$var$clearEvent(this, evt);
    } else {
        this._events = new $cb3175b72a6f5d4f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$cb3175b72a6f5d4f$var$EventEmitter.prototype.off = $cb3175b72a6f5d4f$var$EventEmitter.prototype.removeListener;
$cb3175b72a6f5d4f$var$EventEmitter.prototype.addListener = $cb3175b72a6f5d4f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$cb3175b72a6f5d4f$var$EventEmitter.prefixed = $cb3175b72a6f5d4f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$cb3175b72a6f5d4f$var$EventEmitter.EventEmitter = $cb3175b72a6f5d4f$var$EventEmitter;
$cb3175b72a6f5d4f$exports = $cb3175b72a6f5d4f$var$EventEmitter;


var $e979d586dbe8becb$exports = {};
"use strict";
Object.defineProperty($e979d586dbe8becb$exports, "__esModule", {
    value: true
});
function $e979d586dbe8becb$var$isString(value) {
    return typeof value === 'string';
}
$e979d586dbe8becb$exports.default = $e979d586dbe8becb$var$isString;


var $2309589a9730eed4$exports = {};
"use strict";
Object.defineProperty($2309589a9730eed4$exports, "__esModule", {
    value: true
});
function $2309589a9730eed4$var$isObject(value) {
    return value !== null && typeof value === 'object';
}
$2309589a9730eed4$exports.default = $2309589a9730eed4$var$isObject;


var $3db5e85b9440c82b$exports = {};
"use strict";
Object.defineProperty($3db5e85b9440c82b$exports, "__esModule", {
    value: true
});
$3db5e85b9440c82b$exports.print = $3db5e85b9440c82b$var$print;
var $f4a303077e54529b$exports = {};
"use strict";
Object.defineProperty($f4a303077e54529b$exports, "__esModule", {
    value: true
});
$f4a303077e54529b$exports.visit = $f4a303077e54529b$var$visit;
$f4a303077e54529b$exports.visitInParallel = $f4a303077e54529b$var$visitInParallel;
$f4a303077e54529b$exports.getVisitFn = $f4a303077e54529b$var$getVisitFn;
$f4a303077e54529b$exports.BREAK = $f4a303077e54529b$exports.QueryDocumentKeys = void 0;

var $f4a303077e54529b$var$_inspect = $f4a303077e54529b$var$_interopRequireDefault((parcelRequire("kO5DT")));
var $9f378b13c850a846$exports = {};
"use strict";
Object.defineProperty($9f378b13c850a846$exports, "__esModule", {
    value: true
});
$9f378b13c850a846$exports.isNode = $9f378b13c850a846$var$isNode;
$9f378b13c850a846$exports.Token = $9f378b13c850a846$exports.Location = void 0;

var $9f378b13c850a846$var$_defineInspect = $9f378b13c850a846$var$_interopRequireDefault((parcelRequire("hXIc6")));
function $9f378b13c850a846$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var $9f378b13c850a846$var$Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
$9f378b13c850a846$exports.Location = $9f378b13c850a846$var$Location;
(0, $9f378b13c850a846$var$_defineInspect.default)($9f378b13c850a846$var$Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ var $9f378b13c850a846$var$Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
$9f378b13c850a846$exports.Token = $9f378b13c850a846$var$Token;
(0, $9f378b13c850a846$var$_defineInspect.default)($9f378b13c850a846$var$Token);
/**
 * @internal
 */ function $9f378b13c850a846$var$isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 


function $f4a303077e54529b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f4a303077e54529b$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
$f4a303077e54529b$exports.QueryDocumentKeys = $f4a303077e54529b$var$QueryDocumentKeys;
var $f4a303077e54529b$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ $f4a303077e54529b$exports.BREAK = $f4a303077e54529b$var$BREAK;
function $f4a303077e54529b$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f4a303077e54529b$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $9f378b13c850a846$exports.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $f4a303077e54529b$var$_inspect.default)(node), "."));
            var visitFn = $f4a303077e54529b$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $f4a303077e54529b$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $9f378b13c850a846$exports.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $f4a303077e54529b$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $f4a303077e54529b$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $f4a303077e54529b$var$BREAK) skipping[i] = $f4a303077e54529b$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $f4a303077e54529b$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $f4a303077e54529b$var$BREAK) skipping[i] = $f4a303077e54529b$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $f4a303077e54529b$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}


var $c702c34fb911b31a$exports = {};
"use strict";
Object.defineProperty($c702c34fb911b31a$exports, "__esModule", {
    value: true
});
$c702c34fb911b31a$exports.dedentBlockStringValue = $c702c34fb911b31a$var$dedentBlockStringValue;
$c702c34fb911b31a$exports.getBlockStringIndentation = $c702c34fb911b31a$var$getBlockStringIndentation;
$c702c34fb911b31a$exports.printBlockString = $c702c34fb911b31a$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $c702c34fb911b31a$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $c702c34fb911b31a$var$getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $c702c34fb911b31a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $c702c34fb911b31a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $c702c34fb911b31a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
/**
 * @internal
 */ function $c702c34fb911b31a$var$getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $c702c34fb911b31a$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $3db5e85b9440c82b$var$print(ast) {
    return (0, $f4a303077e54529b$exports.visit)(ast, {
        leave: $3db5e85b9440c82b$var$printDocASTReducer
    });
}
var $3db5e85b9440c82b$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $3db5e85b9440c82b$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $3db5e85b9440c82b$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $3db5e85b9440c82b$var$wrap('(', $3db5e85b9440c82b$var$join(node.variableDefinitions, ', '), ')');
        var directives = $3db5e85b9440c82b$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $3db5e85b9440c82b$var$join([
            op,
            $3db5e85b9440c82b$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $3db5e85b9440c82b$var$wrap(' = ', defaultValue) + $3db5e85b9440c82b$var$wrap(' ', $3db5e85b9440c82b$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $3db5e85b9440c82b$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $3db5e85b9440c82b$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $3db5e85b9440c82b$var$wrap('(', $3db5e85b9440c82b$var$join(args, ', '), ')');
        if (argsLine.length > $3db5e85b9440c82b$var$MAX_LINE_LENGTH) argsLine = prefix + $3db5e85b9440c82b$var$wrap('(\n', $3db5e85b9440c82b$var$indent($3db5e85b9440c82b$var$join(args, '\n')), '\n)');
        return $3db5e85b9440c82b$var$join([
            argsLine,
            $3db5e85b9440c82b$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $3db5e85b9440c82b$var$wrap(' ', $3db5e85b9440c82b$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $3db5e85b9440c82b$var$join([
            '...',
            $3db5e85b9440c82b$var$wrap('on ', typeCondition),
            $3db5e85b9440c82b$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($3db5e85b9440c82b$var$wrap('(', $3db5e85b9440c82b$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($3db5e85b9440c82b$var$wrap('', $3db5e85b9440c82b$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $c702c34fb911b31a$exports.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $3db5e85b9440c82b$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $3db5e85b9440c82b$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $3db5e85b9440c82b$var$wrap('(', $3db5e85b9440c82b$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $3db5e85b9440c82b$var$join([
            'schema',
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $3db5e85b9440c82b$var$join([
            'scalar',
            name,
            $3db5e85b9440c82b$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $3db5e85b9440c82b$var$join([
            'type',
            name,
            $3db5e85b9440c82b$var$wrap('implements ', $3db5e85b9440c82b$var$join(interfaces, ' & ')),
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($3db5e85b9440c82b$var$hasMultilineItems(args) ? $3db5e85b9440c82b$var$wrap('(\n', $3db5e85b9440c82b$var$indent($3db5e85b9440c82b$var$join(args, '\n')), '\n)') : $3db5e85b9440c82b$var$wrap('(', $3db5e85b9440c82b$var$join(args, ', '), ')')) + ': ' + type + $3db5e85b9440c82b$var$wrap(' ', $3db5e85b9440c82b$var$join(directives, ' '));
    }),
    InputValueDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $3db5e85b9440c82b$var$join([
            name + ': ' + type,
            $3db5e85b9440c82b$var$wrap('= ', defaultValue),
            $3db5e85b9440c82b$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $3db5e85b9440c82b$var$join([
            'interface',
            name,
            $3db5e85b9440c82b$var$wrap('implements ', $3db5e85b9440c82b$var$join(interfaces, ' & ')),
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $3db5e85b9440c82b$var$join([
            'union',
            name,
            $3db5e85b9440c82b$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $3db5e85b9440c82b$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $3db5e85b9440c82b$var$join([
            'enum',
            name,
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $3db5e85b9440c82b$var$join([
            name,
            $3db5e85b9440c82b$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $3db5e85b9440c82b$var$join([
            'input',
            name,
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $3db5e85b9440c82b$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($3db5e85b9440c82b$var$hasMultilineItems(args) ? $3db5e85b9440c82b$var$wrap('(\n', $3db5e85b9440c82b$var$indent($3db5e85b9440c82b$var$join(args, '\n')), '\n)') : $3db5e85b9440c82b$var$wrap('(', $3db5e85b9440c82b$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $3db5e85b9440c82b$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $3db5e85b9440c82b$var$join([
            'extend schema',
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $3db5e85b9440c82b$var$join([
            'extend scalar',
            name,
            $3db5e85b9440c82b$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $3db5e85b9440c82b$var$join([
            'extend type',
            name,
            $3db5e85b9440c82b$var$wrap('implements ', $3db5e85b9440c82b$var$join(interfaces, ' & ')),
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $3db5e85b9440c82b$var$join([
            'extend interface',
            name,
            $3db5e85b9440c82b$var$wrap('implements ', $3db5e85b9440c82b$var$join(interfaces, ' & ')),
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $3db5e85b9440c82b$var$join([
            'extend union',
            name,
            $3db5e85b9440c82b$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $3db5e85b9440c82b$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $3db5e85b9440c82b$var$join([
            'extend enum',
            name,
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $3db5e85b9440c82b$var$join([
            'extend input',
            name,
            $3db5e85b9440c82b$var$join(directives, ' '),
            $3db5e85b9440c82b$var$block(fields)
        ], ' ');
    }
};
function $3db5e85b9440c82b$var$addDescription(cb) {
    return function(node) {
        return $3db5e85b9440c82b$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $3db5e85b9440c82b$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $3db5e85b9440c82b$var$block(array) {
    return $3db5e85b9440c82b$var$wrap('{\n', $3db5e85b9440c82b$var$indent($3db5e85b9440c82b$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $3db5e85b9440c82b$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $3db5e85b9440c82b$var$indent(str) {
    return $3db5e85b9440c82b$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $3db5e85b9440c82b$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $3db5e85b9440c82b$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($3db5e85b9440c82b$var$isMultiline);
}


var $d357e4ab4e41bd05$exports = {};
"use strict";
Object.defineProperty($d357e4ab4e41bd05$exports, "__esModule", {
    value: true
});
$d357e4ab4e41bd05$exports.getOperationAST = $d357e4ab4e41bd05$var$getOperationAST;
var $90fed8910563e79d$exports = {};
"use strict";
Object.defineProperty($90fed8910563e79d$exports, "__esModule", {
    value: true
});
$90fed8910563e79d$exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $90fed8910563e79d$var$Kind = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ $90fed8910563e79d$exports.Kind = $90fed8910563e79d$var$Kind;


/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */ function $d357e4ab4e41bd05$var$getOperationAST(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === $90fed8910563e79d$exports.Kind.OPERATION_DEFINITION) {
            var _definition$name;
            if (operationName == null) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
        }
    }
    return operation;
}



var $lTpS5 = parcelRequire("lTpS5");
var $a266bcef370d9326$exports = {};
"use strict";
Object.defineProperty($a266bcef370d9326$exports, "__esModule", {
    value: true
});
$a266bcef370d9326$exports.GRAPHQL_SUBSCRIPTIONS = $a266bcef370d9326$exports.GRAPHQL_WS = void 0;
var $a266bcef370d9326$var$GRAPHQL_WS = 'graphql-ws';
$a266bcef370d9326$exports.GRAPHQL_WS = $a266bcef370d9326$var$GRAPHQL_WS;
var $a266bcef370d9326$var$GRAPHQL_SUBSCRIPTIONS = 'graphql-subscriptions';
$a266bcef370d9326$exports.GRAPHQL_SUBSCRIPTIONS = $a266bcef370d9326$var$GRAPHQL_SUBSCRIPTIONS;


var $7508bb8e3d2873d7$exports = {};
"use strict";
Object.defineProperty($7508bb8e3d2873d7$exports, "__esModule", {
    value: true
});
$7508bb8e3d2873d7$exports.WS_TIMEOUT = $7508bb8e3d2873d7$exports.MIN_WS_TIMEOUT = void 0;
var $7508bb8e3d2873d7$var$MIN_WS_TIMEOUT = 1000;
$7508bb8e3d2873d7$exports.MIN_WS_TIMEOUT = $7508bb8e3d2873d7$var$MIN_WS_TIMEOUT;
var $7508bb8e3d2873d7$var$WS_TIMEOUT = 30000;
$7508bb8e3d2873d7$exports.WS_TIMEOUT = $7508bb8e3d2873d7$var$WS_TIMEOUT;


var $6a08d8af77638ae4$exports = {};
"use strict";
Object.defineProperty($6a08d8af77638ae4$exports, "__esModule", {
    value: true
});
var $6a08d8af77638ae4$var$MessageTypes = function() {
    function MessageTypes() {
        throw new Error('Static Class');
    }
    MessageTypes.GQL_CONNECTION_INIT = 'connection_init';
    MessageTypes.GQL_CONNECTION_ACK = 'connection_ack';
    MessageTypes.GQL_CONNECTION_ERROR = 'connection_error';
    MessageTypes.GQL_CONNECTION_KEEP_ALIVE = 'ka';
    MessageTypes.GQL_CONNECTION_TERMINATE = 'connection_terminate';
    MessageTypes.GQL_START = 'start';
    MessageTypes.GQL_DATA = 'data';
    MessageTypes.GQL_ERROR = 'error';
    MessageTypes.GQL_COMPLETE = 'complete';
    MessageTypes.GQL_STOP = 'stop';
    MessageTypes.SUBSCRIPTION_START = 'subscription_start';
    MessageTypes.SUBSCRIPTION_DATA = 'subscription_data';
    MessageTypes.SUBSCRIPTION_SUCCESS = 'subscription_success';
    MessageTypes.SUBSCRIPTION_FAIL = 'subscription_fail';
    MessageTypes.SUBSCRIPTION_END = 'subscription_end';
    MessageTypes.INIT = 'init';
    MessageTypes.INIT_SUCCESS = 'init_success';
    MessageTypes.INIT_FAIL = 'init_fail';
    MessageTypes.KEEP_ALIVE = 'keepalive';
    return MessageTypes;
}();
$6a08d8af77638ae4$exports.default = $6a08d8af77638ae4$var$MessageTypes;


var $1348d703e55ea145$var$SubscriptionClient = function() {
    function SubscriptionClient(url, options, webSocketImpl, webSocketProtocols) {
        var _a = options || {}, _b = _a.connectionCallback, connectionCallback = _b === void 0 ? undefined : _b, _c = _a.connectionParams, connectionParams = _c === void 0 ? {} : _c, _d = _a.minTimeout, minTimeout = _d === void 0 ? $7508bb8e3d2873d7$exports.MIN_WS_TIMEOUT : _d, _e = _a.timeout, timeout = _e === void 0 ? $7508bb8e3d2873d7$exports.WS_TIMEOUT : _e, _f = _a.reconnect, reconnect = _f === void 0 ? false : _f, _g = _a.reconnectionAttempts, reconnectionAttempts = _g === void 0 ? Infinity : _g, _h = _a.lazy, lazy = _h === void 0 ? false : _h, _j = _a.inactivityTimeout, inactivityTimeout = _j === void 0 ? 0 : _j, _k = _a.wsOptionArguments, wsOptionArguments = _k === void 0 ? [] : _k;
        this.wsImpl = webSocketImpl || $1348d703e55ea145$var$NativeWebSocket;
        if (!this.wsImpl) throw new Error('Unable to find native implementation, or alternative implementation for WebSocket!');
        this.wsProtocols = webSocketProtocols || $a266bcef370d9326$exports.GRAPHQL_WS;
        this.connectionCallback = connectionCallback;
        this.url = url;
        this.operations = {};
        this.nextOperationId = 0;
        this.minWsTimeout = minTimeout;
        this.wsTimeout = timeout;
        this.unsentMessagesQueue = [];
        this.reconnect = reconnect;
        this.reconnecting = false;
        this.reconnectionAttempts = reconnectionAttempts;
        this.lazy = !!lazy;
        this.inactivityTimeout = inactivityTimeout;
        this.closedByUser = false;
        this.backoff = new $03bcd8576ab2b77a$exports({
            jitter: 0.5
        });
        this.eventEmitter = new $cb3175b72a6f5d4f$exports.EventEmitter();
        this.middlewares = [];
        this.client = null;
        this.maxConnectTimeGenerator = this.createMaxConnectTimeGenerator();
        this.connectionParams = this.getConnectionParams(connectionParams);
        this.wsOptionArguments = wsOptionArguments;
        if (!this.lazy) this.connect();
    }
    Object.defineProperty(SubscriptionClient.prototype, "status", {
        get: function() {
            if (this.client === null) return this.wsImpl.CLOSED;
            return this.client.readyState;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionClient.prototype.close = function(isForced, closedByUser) {
        if (isForced === void 0) isForced = true;
        if (closedByUser === void 0) closedByUser = true;
        this.clearInactivityTimeout();
        if (this.client !== null) {
            this.closedByUser = closedByUser;
            if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, $6a08d8af77638ae4$exports.default.GQL_CONNECTION_TERMINATE, null);
            }
            this.client.close();
            this.client.onopen = null;
            this.client.onclose = null;
            this.client.onerror = null;
            this.client.onmessage = null;
            this.client = null;
            this.eventEmitter.emit('disconnected');
            if (!isForced) this.tryReconnect();
        }
    };
    SubscriptionClient.prototype.request = function(request) {
        var _a;
        var getObserver = this.getObserver.bind(this);
        var executeOperation = this.executeOperation.bind(this);
        var unsubscribe = this.unsubscribe.bind(this);
        var opId;
        this.clearInactivityTimeout();
        return _a = {}, _a[$lTpS5.default] = function() {
            return this;
        }, _a.subscribe = function(observerOrNext, onError, onComplete) {
            var observer = getObserver(observerOrNext, onError, onComplete);
            opId = executeOperation(request, function(error, result) {
                if (error === null && result === null) {
                    if (observer.complete) observer.complete();
                } else if (error) {
                    if (observer.error) observer.error(error[0]);
                } else if (observer.next) observer.next(result);
            });
            return {
                unsubscribe: function() {
                    if (opId) {
                        unsubscribe(opId);
                        opId = null;
                    }
                }
            };
        }, _a;
    };
    SubscriptionClient.prototype.on = function(eventName, callback, context) {
        var handler = this.eventEmitter.on(eventName, callback, context);
        return function() {
            handler.off(eventName, callback, context);
        };
    };
    SubscriptionClient.prototype.onConnected = function(callback, context) {
        return this.on('connected', callback, context);
    };
    SubscriptionClient.prototype.onConnecting = function(callback, context) {
        return this.on('connecting', callback, context);
    };
    SubscriptionClient.prototype.onDisconnected = function(callback, context) {
        return this.on('disconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnected = function(callback, context) {
        return this.on('reconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnecting = function(callback, context) {
        return this.on('reconnecting', callback, context);
    };
    SubscriptionClient.prototype.onError = function(callback, context) {
        return this.on('error', callback, context);
    };
    SubscriptionClient.prototype.unsubscribeAll = function() {
        var _this = this;
        Object.keys(this.operations).forEach(function(subId) {
            _this.unsubscribe(subId);
        });
    };
    SubscriptionClient.prototype.applyMiddlewares = function(options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var queue = function(funcs, scope) {
                var next = function(error) {
                    if (error) reject(error);
                    else if (funcs.length > 0) {
                        var f = funcs.shift();
                        if (f) f.applyMiddleware.apply(scope, [
                            options,
                            next
                        ]);
                    } else resolve(options);
                };
                next();
            };
            queue($1348d703e55ea145$var$__spreadArrays(_this.middlewares), _this);
        });
    };
    SubscriptionClient.prototype.use = function(middlewares) {
        var _this = this;
        middlewares.map(function(middleware) {
            if (typeof middleware.applyMiddleware === 'function') _this.middlewares.push(middleware);
            else throw new Error('Middleware must implement the applyMiddleware function.');
        });
        return this;
    };
    SubscriptionClient.prototype.getConnectionParams = function(connectionParams) {
        return function() {
            return new Promise(function(resolve, reject) {
                if (typeof connectionParams === 'function') try {
                    return resolve(connectionParams.call(null));
                } catch (error) {
                    return reject(error);
                }
                resolve(connectionParams);
            });
        };
    };
    SubscriptionClient.prototype.executeOperation = function(options, handler) {
        var _this = this;
        if (this.client === null) this.connect();
        var opId = this.generateOperationId();
        this.operations[opId] = {
            options: options,
            handler: handler
        };
        this.applyMiddlewares(options).then(function(processedOptions) {
            _this.checkOperationOptions(processedOptions, handler);
            if (_this.operations[opId]) {
                _this.operations[opId] = {
                    options: processedOptions,
                    handler: handler
                };
                _this.sendMessage(opId, $6a08d8af77638ae4$exports.default.GQL_START, processedOptions);
            }
        }).catch(function(error) {
            _this.unsubscribe(opId);
            handler(_this.formatErrors(error));
        });
        return opId;
    };
    SubscriptionClient.prototype.getObserver = function(observerOrNext, error, complete) {
        if (typeof observerOrNext === 'function') return {
            next: function(v) {
                return observerOrNext(v);
            },
            error: function(e) {
                return error && error(e);
            },
            complete: function() {
                return complete && complete();
            }
        };
        return observerOrNext;
    };
    SubscriptionClient.prototype.createMaxConnectTimeGenerator = function() {
        var minValue = this.minWsTimeout;
        var maxValue = this.wsTimeout;
        return new $03bcd8576ab2b77a$exports({
            min: minValue,
            max: maxValue,
            factor: 1.2
        });
    };
    SubscriptionClient.prototype.clearCheckConnectionInterval = function() {
        if (this.checkConnectionIntervalId) {
            clearInterval(this.checkConnectionIntervalId);
            this.checkConnectionIntervalId = null;
        }
    };
    SubscriptionClient.prototype.clearMaxConnectTimeout = function() {
        if (this.maxConnectTimeoutId) {
            clearTimeout(this.maxConnectTimeoutId);
            this.maxConnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearTryReconnectTimeout = function() {
        if (this.tryReconnectTimeoutId) {
            clearTimeout(this.tryReconnectTimeoutId);
            this.tryReconnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearInactivityTimeout = function() {
        if (this.inactivityTimeoutId) {
            clearTimeout(this.inactivityTimeoutId);
            this.inactivityTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.setInactivityTimeout = function() {
        var _this = this;
        if (this.inactivityTimeout > 0 && Object.keys(this.operations).length === 0) this.inactivityTimeoutId = setTimeout(function() {
            if (Object.keys(_this.operations).length === 0) _this.close();
        }, this.inactivityTimeout);
    };
    SubscriptionClient.prototype.checkOperationOptions = function(options, handler) {
        var query = options.query, variables = options.variables, operationName = options.operationName;
        if (!query) throw new Error('Must provide a query.');
        if (!handler) throw new Error('Must provide an handler.');
        if (!$e979d586dbe8becb$exports.default(query) && !$d357e4ab4e41bd05$exports.getOperationAST(query, operationName) || operationName && !$e979d586dbe8becb$exports.default(operationName) || variables && !$2309589a9730eed4$exports.default(variables)) throw new Error("Incorrect option types. query must be a string or a document,`operationName` must be a string, and `variables` must be an object.");
    };
    SubscriptionClient.prototype.buildMessage = function(id, type, payload) {
        var payloadToReturn = payload && payload.query ? $1348d703e55ea145$var$__assign($1348d703e55ea145$var$__assign({}, payload), {
            query: typeof payload.query === 'string' ? payload.query : $3db5e85b9440c82b$exports.print(payload.query)
        }) : payload;
        return {
            id: id,
            type: type,
            payload: payloadToReturn
        };
    };
    SubscriptionClient.prototype.formatErrors = function(errors) {
        if (Array.isArray(errors)) return errors;
        if (errors && errors.errors) return this.formatErrors(errors.errors);
        if (errors && errors.message) return [
            errors
        ];
        return [
            {
                name: 'FormatedError',
                message: 'Unknown error',
                originalError: errors
            }
        ];
    };
    SubscriptionClient.prototype.sendMessage = function(id, type, payload) {
        this.sendMessageRaw(this.buildMessage(id, type, payload));
    };
    SubscriptionClient.prototype.sendMessageRaw = function(message) {
        switch(this.status){
            case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                try {
                    JSON.parse(serializedMessage);
                } catch (e) {
                    this.eventEmitter.emit('error', new Error("Message must be JSON-serializable. Got: " + message));
                }
                this.client.send(serializedMessage);
                break;
            case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;
            default:
                if (!this.reconnecting) this.eventEmitter.emit('error', new Error("A message was not sent because socket is not connected, is closing or is already closed. Message was: " + JSON.stringify(message)));
        }
    };
    SubscriptionClient.prototype.generateOperationId = function() {
        return String(++this.nextOperationId);
    };
    SubscriptionClient.prototype.tryReconnect = function() {
        var _this = this;
        if (!this.reconnect || this.backoff.attempts >= this.reconnectionAttempts) return;
        if (!this.reconnecting) {
            Object.keys(this.operations).forEach(function(key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, $6a08d8af77638ae4$exports.default.GQL_START, _this.operations[key].options));
            });
            this.reconnecting = true;
        }
        this.clearTryReconnectTimeout();
        var delay = this.backoff.duration();
        this.tryReconnectTimeoutId = setTimeout(function() {
            _this.connect();
        }, delay);
    };
    SubscriptionClient.prototype.flushUnsentMessagesQueue = function() {
        var _this = this;
        this.unsentMessagesQueue.forEach(function(message) {
            _this.sendMessageRaw(message);
        });
        this.unsentMessagesQueue = [];
    };
    SubscriptionClient.prototype.checkConnection = function() {
        if (this.wasKeepAliveReceived) {
            this.wasKeepAliveReceived = false;
            return;
        }
        if (!this.reconnecting) this.close(false, true);
    };
    SubscriptionClient.prototype.checkMaxConnectTimeout = function() {
        var _this = this;
        this.clearMaxConnectTimeout();
        this.maxConnectTimeoutId = setTimeout(function() {
            if (_this.status !== _this.wsImpl.OPEN) {
                _this.reconnecting = true;
                _this.close(false, true);
            }
        }, this.maxConnectTimeGenerator.duration());
    };
    SubscriptionClient.prototype.connect = function() {
        var _a;
        var _this = this;
        this.client = new ((_a = this.wsImpl).bind.apply(_a, $1348d703e55ea145$var$__spreadArrays([
            void 0,
            this.url,
            this.wsProtocols
        ], this.wsOptionArguments)))();
        this.checkMaxConnectTimeout();
        this.client.onopen = function() {
            return $1348d703e55ea145$var$__awaiter(_this, void 0, void 0, function() {
                var connectionParams, error_1;
                return $1348d703e55ea145$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(this.status === this.wsImpl.OPEN)) return [
                                3,
                                4
                            ];
                            this.clearMaxConnectTimeout();
                            this.closedByUser = false;
                            this.eventEmitter.emit(this.reconnecting ? 'reconnecting' : 'connecting');
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                this.connectionParams()
                            ];
                        case 2:
                            connectionParams = _a.sent();
                            this.sendMessage(undefined, $6a08d8af77638ae4$exports.default.GQL_CONNECTION_INIT, connectionParams);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error_1 = _a.sent();
                            this.sendMessage(undefined, $6a08d8af77638ae4$exports.default.GQL_CONNECTION_ERROR, error_1);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        this.client.onclose = function() {
            if (!_this.closedByUser) _this.close(false, false);
        };
        this.client.onerror = function(err) {
            _this.eventEmitter.emit('error', err);
        };
        this.client.onmessage = function(_a) {
            var data = _a.data;
            _this.processReceivedData(data);
        };
    };
    SubscriptionClient.prototype.processReceivedData = function(receivedData) {
        var parsedMessage;
        var opId;
        try {
            parsedMessage = JSON.parse(receivedData);
            opId = parsedMessage.id;
        } catch (e) {
            throw new Error("Message must be JSON-parseable. Got: " + receivedData);
        }
        if ([
            $6a08d8af77638ae4$exports.default.GQL_DATA,
            $6a08d8af77638ae4$exports.default.GQL_COMPLETE,
            $6a08d8af77638ae4$exports.default.GQL_ERROR
        ].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
            this.unsubscribe(opId);
            return;
        }
        switch(parsedMessage.type){
            case $6a08d8af77638ae4$exports.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) this.connectionCallback(parsedMessage.payload);
                break;
            case $6a08d8af77638ae4$exports.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? 'reconnected' : 'connected', parsedMessage.payload);
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();
                if (this.connectionCallback) this.connectionCallback();
                break;
            case $6a08d8af77638ae4$exports.default.GQL_COMPLETE:
                var handler = this.operations[opId].handler;
                delete this.operations[opId];
                handler.call(this, null, null);
                break;
            case $6a08d8af77638ae4$exports.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;
            case $6a08d8af77638ae4$exports.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : $1348d703e55ea145$var$__assign($1348d703e55ea145$var$__assign({}, parsedMessage.payload), {
                    errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;
            case $6a08d8af77638ae4$exports.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === 'undefined';
                this.wasKeepAliveReceived = true;
                if (firstKA) this.checkConnection();
                if (this.checkConnectionIntervalId) {
                    clearInterval(this.checkConnectionIntervalId);
                    this.checkConnection();
                }
                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), this.wsTimeout);
                break;
            default:
                throw new Error('Invalid message type!');
        }
    };
    SubscriptionClient.prototype.unsubscribe = function(opId) {
        if (this.operations[opId]) {
            delete this.operations[opId];
            this.setInactivityTimeout();
            this.sendMessage(opId, $6a08d8af77638ae4$exports.default.GQL_STOP, undefined);
        }
    };
    return SubscriptionClient;
}();
$1348d703e55ea145$exports.SubscriptionClient = $1348d703e55ea145$var$SubscriptionClient;



var $292600f6711f8cd7$export$c6ec1f112bd949a0 = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(WebSocketLink, _super);
    function WebSocketLink(paramsOrClient) {
        var _this = _super.call(this) || this;
        if (paramsOrClient instanceof (0, $1348d703e55ea145$exports.SubscriptionClient)) _this.subscriptionClient = paramsOrClient;
        else _this.subscriptionClient = new (0, $1348d703e55ea145$exports.SubscriptionClient)(paramsOrClient.uri, paramsOrClient.options, paramsOrClient.webSocketImpl);
        return _this;
    }
    WebSocketLink.prototype.request = function(operation) {
        return this.subscriptionClient.request(operation);
    };
    return WebSocketLink;
}((0, $0b78640641df936b$export$2fed3d61f740bc7f));






function $871c35ae3d0aaf19$export$2288787135a8f66e(errorHandler) {
    return new (0, $0b78640641df936b$export$2fed3d61f740bc7f)(function(operation, forward) {
        return new (0, $0777c100e78b6582$export$77cea355fa80b5f4)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) retriedResult = errorHandler({
                            graphQLErrors: result.errors,
                            response: result,
                            operation: operation,
                            forward: forward
                        });
                        else if ((0, $9b257430d46c4ca9$export$345f95cc6b6b9b0b)(result)) retriedResult = errorHandler({
                            protocolErrors: result.extensions[0, $9b257430d46c4ca9$export$4995664c1b49842e],
                            response: result,
                            operation: operation,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            //Network errors can return GraphQL errors on for example a 403
                            graphQLErrors: networkError && networkError.result && networkError.result.errors || void 0,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        // disable the previous sub from calling complete on observable
                        // if retry is in flight.
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $871c35ae3d0aaf19$export$d2c8415987899609 = /** @class */ function(_super) {
    (0, $fcf1ddc4ac014517$export$a8ba968b8961cb8a)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $871c35ae3d0aaf19$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $0b78640641df936b$export$2fed3d61f740bc7f));




var $9fef5c4d3453c190$export$8612ca2f25aa4a29 = /*#__PURE__*/ function($9fef5c4d3453c190$export$8612ca2f25aa4a29) {
    $9fef5c4d3453c190$export$8612ca2f25aa4a29["CANNOT_UPDATE_RHESE_CONTENT"] = "CANNOT_UPDATE_RHESE_CONTENT";
    $9fef5c4d3453c190$export$8612ca2f25aa4a29["CANNOT_FIND_PAGE"] = "CANNOT_FIND_PAGE";
    return $9fef5c4d3453c190$export$8612ca2f25aa4a29;
}({});
const $9fef5c4d3453c190$var$displayServerError = ()=>(0, $19ed0b6abada9941$export$d73ee8ef04f5226a).then((t)=>(0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
            message: t("serverHasSentError").toString(),
            description: t("errorHasBeenSentToTechStaff").toString(),
            placement: "topRight"
        }));
const $9fef5c4d3453c190$var$errorLink = (0, $871c35ae3d0aaf19$export$2288787135a8f66e)(({ networkError: networkError, graphQLErrors: graphQLErrors })=>{
    if (networkError) $9fef5c4d3453c190$var$displayServerError();
    else if (graphQLErrors) {
        graphQLErrors = graphQLErrors.filter((e)=>e.extensions === undefined || e.extensions?.code !== "NOT_FOUND");
        const { unhandledErrors: unhandledErrors, handledErrors: handledErrors } = graphQLErrors.reduce((acc, e)=>{
            if (typeof e.extensions?.code === "string" && Object.values($9fef5c4d3453c190$export$8612ca2f25aa4a29).includes(e.extensions.code)) return {
                ...acc,
                handledErrors: acc.handledErrors.concat(e)
            };
            return {
                ...acc,
                unhandledErrors: acc.unhandledErrors.concat(e)
            };
        }, {
            unhandledErrors: [],
            handledErrors: []
        });
        handledErrors.forEach((e)=>{
            if (e.extensions?.code === "CANNOT_UPDATE_RHESE_CONTENT") (0, $19ed0b6abada9941$export$d73ee8ef04f5226a).then((t)=>{
                (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).warning({
                    message: t("GQLError.cannotUpdateRheseContent.message").toString(),
                    description: t("GQLError.cannotUpdateRheseContent.description").toString(),
                    placement: "topRight"
                });
            });
        });
        if (unhandledErrors.length === 0) return;
        $9fef5c4d3453c190$var$displayServerError();
    }
});
var $9fef5c4d3453c190$export$2e2bcd8739ae039 = (supabaseClient)=>{
    const getToken = async ()=>{
        const accessToken = (await supabaseClient.auth.getSession()).data.session?.access_token;
        return `Bearer ${accessToken}`;
    };
    const uri = "https://test.api.frogeditor.mobidys.com/graphql".replace("https", "wss").replace("http", "ws").replace("/graphql", "/subscriptions");
    const wsLink = new (0, $292600f6711f8cd7$export$c6ec1f112bd949a0)({
        uri: uri,
        options: {
            reconnect: true,
            timeout: 30000,
            connectionParams: async ()=>({
                    authorization: await getToken()
                })
        }
    });
    return new (0, $d7836991bbce1d27$export$13f5a5f0f1dbab88)({
        queryDeduplication: false,
        link: (0, $6c08b0a93cf04345$export$6788812c4e6611e6)([
            $9fef5c4d3453c190$var$errorLink,
            wsLink
        ]),
        cache: new (0, $62017acf35ccf2aa$export$467265324939f47f)({
            addTypename: true,
            typePolicies: {
                SqlxRhese: {
                    fields: {
                        letters: {
                            merge (_, incoming) {
                                return [
                                    ...incoming
                                ];
                            }
                        }
                    }
                }
            }
        })
    });
};



parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

var $a2a5cdaf5dc2076e$export$448e4850cad7c7b0;
var $a2a5cdaf5dc2076e$export$a943aa9a0fca3f0b;
var $a2a5cdaf5dc2076e$export$e8e78c978b129247;
var $a2a5cdaf5dc2076e$export$39f5674517ec0000;
var $a2a5cdaf5dc2076e$export$1d733b8e99641072;
var $a2a5cdaf5dc2076e$export$ab1107743aa4affb;
var $a2a5cdaf5dc2076e$export$fb184b623420d9be;
var $a2a5cdaf5dc2076e$export$b1e5508a851be14d;
var $a2a5cdaf5dc2076e$export$a7db06668cad9adb;
var $a2a5cdaf5dc2076e$export$b1ba3b667808f37f;
var $a2a5cdaf5dc2076e$export$39babdfab504f3da;
$a2a5cdaf5dc2076e$export$448e4850cad7c7b0 = "h1_84b0db";
$a2a5cdaf5dc2076e$export$a943aa9a0fca3f0b = "h2_84b0db";
$a2a5cdaf5dc2076e$export$e8e78c978b129247 = "root_84b0db";
$a2a5cdaf5dc2076e$export$39f5674517ec0000 = "tabs_84b0db";
$a2a5cdaf5dc2076e$export$1d733b8e99641072 = "userFirstLetterWrapper_84b0db";
$a2a5cdaf5dc2076e$export$ab1107743aa4affb = "userFirstLetter_84b0db";
$a2a5cdaf5dc2076e$export$fb184b623420d9be = "title_84b0db";
$a2a5cdaf5dc2076e$export$b1e5508a851be14d = "menu_84b0db";
$a2a5cdaf5dc2076e$export$a7db06668cad9adb = "content_84b0db";
$a2a5cdaf5dc2076e$export$b1ba3b667808f37f = "libraryTitle_84b0db";
$a2a5cdaf5dc2076e$export$39babdfab504f3da = "projects_84b0db";








parcelRequire("jMaZ8");


var $giSak = parcelRequire("giSak");
var $4d4109e7026d0a9f$export$448e4850cad7c7b0;
var $4d4109e7026d0a9f$export$a943aa9a0fca3f0b;
var $4d4109e7026d0a9f$export$ab03b6763ed7026f;
var $4d4109e7026d0a9f$export$87ae8b1388ae34a6;
var $4d4109e7026d0a9f$export$4aebd143f31d0c0d;
$4d4109e7026d0a9f$export$448e4850cad7c7b0 = "h1_19b898";
$4d4109e7026d0a9f$export$a943aa9a0fca3f0b = "h2_19b898";
$4d4109e7026d0a9f$export$ab03b6763ed7026f = "project_19b898";
$4d4109e7026d0a9f$export$87ae8b1388ae34a6 = "isInReSync_19b898";
$4d4109e7026d0a9f$export$4aebd143f31d0c0d = "badge_19b898";





function $2aab5048fe6841a9$export$2e2bcd8739ae039({ project: project, openProject: openProject }) {
    const bookStatusLabel = (0, $e51a454b0f0e45e8$export$a83bdb74b02481c)(project);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
        disabled: project.isDoingAudioResync,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
            onClick: project.isDoingAudioResync ? undefined : ()=>openProject(project.id),
            initial: {
                backgroundColor: "rgba(91, 96, 121, 0.7)"
            },
            whileHover: {
                backgroundColor: "rgba(91, 96, 121, 1)"
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($4d4109e7026d0a9f$export$ab03b6763ed7026f, {
                [$4d4109e7026d0a9f$export$87ae8b1388ae34a6]: project.isDoingAudioResync
            }),
            children: [
                project.name,
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $978012cac829448d$export$2e2bcd8739ae039), {
                    className: $4d4109e7026d0a9f$export$4aebd143f31d0c0d,
                    bookStatusLabel: bookStatusLabel,
                    small: true
                })
            ]
        })
    });
}




const $101fbd50b3c571ef$var$antIcon = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d05b96ef0838a5b9$export$2e2bcd8739ae039), {
    style: {
        fontSize: 24
    },
    spin: true
});
const $101fbd50b3c571ef$var$i18nKey = "library.index";
const $101fbd50b3c571ef$var$defaultI18nKey = `${$101fbd50b3c571ef$var$i18nKey}.default`;
const $101fbd50b3c571ef$var$navBarI18nKey = `${$101fbd50b3c571ef$var$defaultI18nKey}.navBar`;
const $101fbd50b3c571ef$var$BookList = ({ openProject: openProject })=>{
    const { loading: loading, error: error, data: data } = (0, $93ed502a924f5874$export$143208cda651e06e)({
        archivedProjects: false
    });
    const [filterString, setFilterString] = (0, $jMaZ8.useState)("");
    const projects = (0, $jMaZ8.useMemo)(()=>{
        const projects = data?.projects || [];
        const isSubStr = (reference, subString)=>reference.toUpperCase().indexOf(subString.toUpperCase()) > -1;
        return projects.filter((p)=>isSubStr(p.name, filterString) || isSubStr(p.author, filterString));
    }, [
        data,
        filterString
    ]);
    const { isUserPanelOpened: isUserPanelOpened, openPanel: openPanel, closePanel: closePanel } = (0, $3f292fa78e121485$export$bb9c6c1faf7ea682)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const errorMessage = t(`${$101fbd50b3c571ef$var$navBarI18nKey}.errorMessage`);
    const tabItems = (0, $jMaZ8.useMemo)(()=>[
            (0, $eee5699dd95ae9ac$export$772d7324ba568e6e)({
                key: "1",
                label: t(`${$101fbd50b3c571ef$var$navBarI18nKey}.tabTitle`),
                children: loading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $dee5cc896ba0ca8a$export$2e2bcd8739ae039), {
                    indicator: $101fbd50b3c571ef$var$antIcon
                }) : error ? errorMessage : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    className: $a2a5cdaf5dc2076e$export$39babdfab504f3da,
                    children: projects.map((p)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2aab5048fe6841a9$export$2e2bcd8739ae039), {
                            project: p,
                            openProject: openProject
                        }, p.id))
                })
            })
        ], [
        error,
        errorMessage,
        loading,
        openProject,
        projects,
        t
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $a3bb6174129512e9$export$2e2bcd8739ae039), {
                className: $a2a5cdaf5dc2076e$export$e8e78c978b129247,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e5e48008bccdb82$export$2e2bcd8739ae039), {
                        openPanel: openPanel
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039).Content, {
                        className: $a2a5cdaf5dc2076e$export$a7db06668cad9adb,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3d078c5b7a14a8e5$export$2e2bcd8739ae039), {
                            className: $a2a5cdaf5dc2076e$export$39f5674517ec0000,
                            tabBarExtraContent: {
                                left: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h1", {
                                    className: $a2a5cdaf5dc2076e$export$b1ba3b667808f37f,
                                    children: t("audioLibrarty")
                                }),
                                right: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6c59170a575a71c0$export$2e2bcd8739ae039), {
                                    onChange: setFilterString
                                })
                            },
                            items: tabItems
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3f292fa78e121485$export$d02877a6a1957b9b), {
                closePanel: closePanel,
                isUserPanelOpened: isUserPanelOpened
            })
        ]
    });
};
var $101fbd50b3c571ef$export$2e2bcd8739ae039 = $101fbd50b3c571ef$var$BookList;


var $0aa20f8ed043ca82$export$4747ecd4af462f81;
var $0aa20f8ed043ca82$export$10a36f6e0d490183;
$0aa20f8ed043ca82$export$4747ecd4af462f81 = "homeContainer_e8e069";
$0aa20f8ed043ca82$export$10a36f6e0d490183 = "narrationAppContainer_e8e069";




const $b66d17011c8d0dbf$export$e67d647a98e917a3 = ()=>{
    const { isUserPanelOpened: isUserPanelOpened, closePanel: closePanel } = (0, $3f292fa78e121485$export$bb9c6c1faf7ea682)();
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const openProject = (projectId)=>{
        navigate("/audio/library/edit/" + projectId + "/1", {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $0aa20f8ed043ca82$export$10a36f6e0d490183,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3f292fa78e121485$export$d02877a6a1957b9b), {
                closePanel: closePanel,
                isUserPanelOpened: isUserPanelOpened
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $0aa20f8ed043ca82$export$4747ecd4af462f81,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $101fbd50b3c571ef$export$2e2bcd8739ae039), {
                    openProject: openProject
                })
            })
        ]
    });
};




var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

parcelRequire("jMaZ8");

const $786bf8f1d7cd6f44$export$51acff60f35f47a5 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                d: "M17.4844 14.3438C18.2969 14.3438 19.1406 14.4219 20.0156 14.5781V16.0781C19.3906 15.9219 18.5469 15.8438 17.4844 15.8438C15.6094 15.8438 14.1094 16.1719 12.9844 16.8281V15.1406C14.1719 14.6094 15.6719 14.3438 17.4844 14.3438ZM12.9844 12.4688C14.2656 11.9375 15.7656 11.6719 17.4844 11.6719C18.3281 11.6719 19.1719 11.75 20.0156 11.9062V13.4062C19.3906 13.25 18.5469 13.1719 17.4844 13.1719C15.6094 13.1719 14.1094 13.5 12.9844 14.1562V12.4688ZM17.4844 10.5C15.5781 10.5 14.0781 10.8281 12.9844 11.4844V9.84375C14.2344 9.28125 15.7344 9 17.4844 9C18.2656 9 19.1094 9.07812 20.0156 9.23438V10.7812C19.2656 10.5938 18.4219 10.5 17.4844 10.5ZM21 18.5156V6.98438C19.9375 6.67187 18.7656 6.51562 17.4844 6.51562C15.4531 6.51562 13.625 7.01563 12 8.01562V19.5C13.625 18.5 15.4531 18 17.4844 18C18.7031 18 19.875 18.1719 21 18.5156ZM17.4844 4.5C19.8594 4.5 21.7031 5 23.0156 6V20.5781C23.0156 20.7031 22.9531 20.8281 22.8281 20.9531C22.7031 21.0469 22.5938 21.0938 22.5 21.0938C22.4062 21.0938 22.3281 21.0781 22.2656 21.0469C20.9844 20.3594 19.3906 20.0156 17.4844 20.0156C15.4531 20.0156 13.625 20.5156 12 21.5156C10.6562 20.5156 8.82812 20.0156 6.51562 20.0156C4.85938 20.0156 3.26562 20.3594 1.73438 21.0469L1.5 21.1406C1.375 21.1406 1.25 21.0938 1.125 21C1.03125 20.9062 0.984375 20.7969 0.984375 20.6719V6C2.32812 5 4.15625 4.5 6.46875 4.5C8.8125 4.5 10.6562 5 12 6C13.3438 5 15.1719 4.5 17.4844 4.5Z",
                fill: "white"
            })
        })
    });
};




parcelRequire("jMaZ8");

const $81af65a839e3ccf4$var$BackArrow = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: ()=>onClick(undefined),
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                d: "M20.0156 11.0156V12.9844H8.01562L13.5 18.5156L12.0938 19.9219L4.17188 12L12.0938 4.07812L13.5 5.48438L8.01562 11.0156H20.0156Z",
                fill: "white"
            })
        })
    });
};
var $81af65a839e3ccf4$export$2e2bcd8739ae039 = $81af65a839e3ccf4$var$BackArrow;





var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");


parcelRequire("jMaZ8");


var $d8401afee0dc69d1$export$70ef72b3047e3d3f = /*#__PURE__*/ function($d8401afee0dc69d1$export$70ef72b3047e3d3f) {
    $d8401afee0dc69d1$export$70ef72b3047e3d3f["off"] = "off";
    $d8401afee0dc69d1$export$70ef72b3047e3d3f["with"] = "with";
    $d8401afee0dc69d1$export$70ef72b3047e3d3f["without"] = "without";
    return $d8401afee0dc69d1$export$70ef72b3047e3d3f;
}({});
var $d8401afee0dc69d1$export$f83a24887689bc4c = /*#__PURE__*/ function($d8401afee0dc69d1$export$f83a24887689bc4c) {
    $d8401afee0dc69d1$export$f83a24887689bc4c["with"] = "with";
    $d8401afee0dc69d1$export$f83a24887689bc4c["without"] = "without";
    return $d8401afee0dc69d1$export$f83a24887689bc4c;
}({});
function $d8401afee0dc69d1$export$2e2bcd8739ae039({ className: className, state: state, toggle: toggle, label: label }) {
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                children: label
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                        checked: state === "with",
                        onChange: ()=>toggle("with"),
                        children: t("filterLabelWith")
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                        checked: state === "without",
                        onChange: ()=>toggle("without"),
                        children: t("filterLabelWithout")
                    })
                ]
            })
        ]
    });
}


const $b47bb55ac9cb2e54$var$useFilterOnComments = (groupedRhesesAudioInfo)=>{
    const { state: selectedRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    const [state, setState] = (0, $jMaZ8.useState)((0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off);
    const toggle = (0, $jMaZ8.useCallback)((option)=>{
        setState((prevValue)=>{
            if (option === (0, $d8401afee0dc69d1$export$f83a24887689bc4c).with) return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with;
            return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without;
        });
    }, []);
    const applyField = (0, $jMaZ8.useCallback)((pages)=>{
        return pages.map((page)=>{
            const withInvalidReview = groupedRhesesAudioInfo[page.id]?.find((group)=>group.withAudio === true && group.withReview === true && group.isReviewValid === false);
            return {
                ...page,
                issuesCount: withInvalidReview?.count || 0
            };
        });
    }, [
        groupedRhesesAudioInfo
    ]);
    const filter = (0, $jMaZ8.useCallback)((pages)=>{
        if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off) return pages;
        return pages.filter((page)=>{
            const withInvalidReview = groupedRhesesAudioInfo[page.id]?.find((group)=>group.withAudio === true && group.withReview === true && group.isReviewValid === false);
            if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with) return (withInvalidReview?.count || 0) > 0;
            return withInvalidReview?.count === 0;
        });
    }, [
        groupedRhesesAudioInfo,
        state
    ]);
    return {
        state: state,
        toggle: toggle,
        show: selectedRole !== (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Editor,
        filter: filter,
        applyField: applyField
    };
};
var $b47bb55ac9cb2e54$export$2e2bcd8739ae039 = $b47bb55ac9cb2e54$var$useFilterOnComments;




var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $614ac48fdaecbe6e$var$AudioOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z"
                }
            }
        ]
    },
    "name": "audio",
    "theme": "outlined"
};
var $614ac48fdaecbe6e$export$2e2bcd8739ae039 = $614ac48fdaecbe6e$var$AudioOutlined;



var $6d91fa0144a5983b$var$AudioOutlined = function AudioOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $614ac48fdaecbe6e$export$2e2bcd8739ae039)
    }));
};
/**![audio](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MiA0NTRjMC00LjQtMy42LTgtOC04aC02MGMtNC40IDAtOCAzLjYtOCA4IDAgMTQwLjMtMTEzLjcgMjU0LTI1NCAyNTRTMjU4IDU5NC4zIDI1OCA0NTRjMC00LjQtMy42LTgtOC04aC02MGMtNC40IDAtOCAzLjYtOCA4IDAgMTY4LjcgMTI2LjYgMzA3LjkgMjkwIDMyNy42Vjg4NEgzMjYuN2MtMTMuNyAwLTI0LjcgMTQuMy0yNC43IDMydjM2YzAgNC40IDIuOCA4IDYuMiA4aDQwNy42YzMuNCAwIDYuMi0zLjYgNi4yLTh2LTM2YzAtMTcuNy0xMS0zMi0yNC43LTMySDU0OFY3ODIuMWMxNjUuMy0xOCAyOTQtMTU4IDI5NC0zMjguMXpNNTEyIDYyNGM5My45IDAgMTcwLTc1LjIgMTcwLTE2OFYyMzJjMC05Mi44LTc2LjEtMTY4LTE3MC0xNjhzLTE3MCA3NS4yLTE3MCAxNjh2MjI0YzAgOTIuOCA3Ni4xIDE2OCAxNzAgMTY4em0tOTQtMzkyYzAtNTAuNiA0MS45LTkyIDk0LTkyczk0IDQxLjQgOTQgOTJ2MjI0YzAgNTAuNi00MS45IDkyLTk0IDkycy05NC00MS40LTk0LTkyVjIzMnoiIC8+PC9zdmc+) */ var $6d91fa0144a5983b$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($6d91fa0144a5983b$var$AudioOutlined);
$6d91fa0144a5983b$var$RefIcon.displayName = 'AudioOutlined';
var $6d91fa0144a5983b$export$2e2bcd8739ae039 = $6d91fa0144a5983b$var$RefIcon;


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $b5dd006f66abd591$var$RedoOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z"
                }
            }
        ]
    },
    "name": "redo",
    "theme": "outlined"
};
var $b5dd006f66abd591$export$2e2bcd8739ae039 = $b5dd006f66abd591$var$RedoOutlined;



var $aa885aab97026e4f$var$RedoOutlined = function RedoOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $b5dd006f66abd591$export$2e2bcd8739ae039)
    }));
};
/**![redo](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc1OC4yIDgzOS4xQzg1MS44IDc2NS45IDkxMiA2NTEuOSA5MTIgNTIzLjkgOTEyIDMwMyA3MzMuNSAxMjQuMyA1MTIuNiAxMjQgMjkxLjQgMTIzLjcgMTEyIDMwMi44IDExMiA1MjMuOWMwIDEyNS4yIDU3LjUgMjM2LjkgMTQ3LjYgMzEwLjIgMy41IDIuOCA4LjYgMi4yIDExLjQtMS4zbDM5LjQtNTAuNWMyLjctMy40IDIuMS04LjMtMS4yLTExLjEtOC4xLTYuNi0xNS45LTEzLjctMjMuNC0yMS4yYTMxOC42NCAzMTguNjQgMCAwMS02OC42LTEwMS43QzIwMC40IDYwOSAxOTIgNTY3LjEgMTkyIDUyMy45czguNC04NS4xIDI1LjEtMTI0LjVjMTYuMS0zOC4xIDM5LjItNzIuMyA2OC42LTEwMS43IDI5LjQtMjkuNCA2My42LTUyLjUgMTAxLjctNjguNkM0MjYuOSAyMTIuNCA0NjguOCAyMDQgNTEyIDIwNHM4NS4xIDguNCAxMjQuNSAyNS4xYzM4LjEgMTYuMSA3Mi4zIDM5LjIgMTAxLjcgNjguNiAyOS40IDI5LjQgNTIuNSA2My42IDY4LjYgMTAxLjcgMTYuNyAzOS40IDI1LjEgODEuMyAyNS4xIDEyNC41cy04LjQgODUuMS0yNS4xIDEyNC41YTMxOC42NCAzMTguNjQgMCAwMS02OC42IDEwMS43Yy05LjMgOS4zLTE5LjEgMTgtMjkuMyAyNkw2NjguMiA3MjRhOCA4IDAgMDAtMTQuMSAzbC0zOS42IDE2Mi4yYy0xLjIgNSAyLjYgOS45IDcuNyA5LjlsMTY3IC44YzYuNyAwIDEwLjUtNy43IDYuMy0xMi45bC0zNy4zLTQ3Ljl6IiAvPjwvc3ZnPg==) */ var $aa885aab97026e4f$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($aa885aab97026e4f$var$RedoOutlined);
$aa885aab97026e4f$var$RefIcon.displayName = 'RedoOutlined';
var $aa885aab97026e4f$export$2e2bcd8739ae039 = $aa885aab97026e4f$var$RefIcon;



var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");


var $bc12e8bca3b35739$export$ea095142f6817690;
var $bc12e8bca3b35739$export$286cfe960578fd3b;
var $bc12e8bca3b35739$export$82462a21aead86ed;
var $bc12e8bca3b35739$export$5f5e7a910495f292;
var $bc12e8bca3b35739$export$a03d06b72497596b;
var $bc12e8bca3b35739$export$d79264f26953ec1;
var $bc12e8bca3b35739$export$aa81cc4ace62f60a;
var $bc12e8bca3b35739$export$73920f18ca706874;
var $bc12e8bca3b35739$export$75c4be3c725a026b;
var $bc12e8bca3b35739$export$952af3258ed45903;
var $bc12e8bca3b35739$export$8027b0307179fc17;
var $bc12e8bca3b35739$export$4df8d4373bc60300;
var $bc12e8bca3b35739$export$8687ffcdea58e000;
var $bc12e8bca3b35739$export$641374ffb95bc399;
var $bc12e8bca3b35739$export$7f953ae6a8b63b25;
var $bc12e8bca3b35739$export$aa47f9d1410832b0;
var $bc12e8bca3b35739$export$54372d01d1d0caec;
var $bc12e8bca3b35739$export$eb7baebc3baa4d97;
$bc12e8bca3b35739$export$ea095142f6817690 = "bookPanelHeader_544cf9";
$bc12e8bca3b35739$export$286cfe960578fd3b = "bookPanelHeaderTitle_544cf9";
$bc12e8bca3b35739$export$82462a21aead86ed = "filters_544cf9";
$bc12e8bca3b35739$export$5f5e7a910495f292 = "filterCheckboxContainer_544cf9";
$bc12e8bca3b35739$export$a03d06b72497596b = "pageTabContainer_544cf9";
$bc12e8bca3b35739$export$d79264f26953ec1 = "definitions_544cf9";
$bc12e8bca3b35739$export$aa81cc4ace62f60a = "rightIcon_544cf9";
$bc12e8bca3b35739$export$73920f18ca706874 = "hidden_544cf9";
$bc12e8bca3b35739$export$75c4be3c725a026b = "researchInputContainer_544cf9";
$bc12e8bca3b35739$export$952af3258ed45903 = "searchInput_544cf9";
$bc12e8bca3b35739$export$8027b0307179fc17 = "bookPanelPageContainer_544cf9";
$bc12e8bca3b35739$export$4df8d4373bc60300 = "drawer_544cf9";
$bc12e8bca3b35739$export$8687ffcdea58e000 = "searchIcon_544cf9";
$bc12e8bca3b35739$export$641374ffb95bc399 = "spinner_544cf9";
$bc12e8bca3b35739$export$7f953ae6a8b63b25 = "searchTabs_544cf9";
$bc12e8bca3b35739$export$aa47f9d1410832b0 = "textSearchResult_544cf9";
$bc12e8bca3b35739$export$54372d01d1d0caec = "textSearchResultPage_544cf9";
$bc12e8bca3b35739$export$eb7baebc3baa4d97 = "textSearchResultContent_544cf9";


const $b5d000a215963277$export$76dee46ffaa0a681 = ({ pageNumber: pageNumber, bookId: bookId, disabled: disabled, hasIssues: hasIssues, audioComplete: audioComplete, renarrated: renarrated })=>{
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const onClick = (0, $jMaZ8.useCallback)(()=>{
        if (disabled) return;
        navigate(`/audio/library/edit/${bookId}/${pageNumber}`);
    }, [
        bookId,
        disabled,
        history,
        pageNumber
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            className: $bc12e8bca3b35739$export$a03d06b72497596b,
            "data-disabled": disabled,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    children: `Page ${pageNumber}`
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6d91fa0144a5983b$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($bc12e8bca3b35739$export$aa81cc4ace62f60a, {
                                [$bc12e8bca3b35739$export$73920f18ca706874]: !audioComplete
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $aa885aab97026e4f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($bc12e8bca3b35739$export$aa81cc4ace62f60a, {
                                [$bc12e8bca3b35739$export$73920f18ca706874]: !renarrated
                            })
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e3697a614e1cfe37$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($bc12e8bca3b35739$export$aa81cc4ace62f60a, {
                                [$bc12e8bca3b35739$export$73920f18ca706874]: !hasIssues
                            })
                        })
                    ]
                })
            ]
        })
    });
};







var $62LIg = parcelRequire("62LIg");

var $jMaZ8 = parcelRequire("jMaZ8");


function $e99b2e23ef1d0a25$export$2e2bcd8739ae039(groupedRhesesAudioInfo) {
    const { state: selectedRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    const [state, setState] = (0, $jMaZ8.useState)((0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off);
    const toggle = (0, $jMaZ8.useCallback)((option)=>{
        setState((prevValue)=>{
            // If click on the with option
            if (option === (0, $d8401afee0dc69d1$export$f83a24887689bc4c).with) return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with;
            // If click on the without option
            return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without;
        });
    }, []);
    const applyField = (0, $jMaZ8.useCallback)((pages)=>{
        return pages.map((page)=>{
            const audioIncomplete = groupedRhesesAudioInfo[page.id]?.find((group)=>group.withAudio === false);
            return {
                ...page,
                fullyRecorded: !((audioIncomplete?.count || 0) > 0)
            };
        });
    }, [
        groupedRhesesAudioInfo
    ]);
    const filter = (0, $jMaZ8.useCallback)((pages)=>{
        if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off) return pages;
        return pages.filter((page)=>{
            const audioIncomplete = groupedRhesesAudioInfo[page.id]?.find((group)=>group.withAudio === false);
            if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without) return (audioIncomplete?.count || 0) > 0;
            if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with) return audioIncomplete?.count === 0;
            return true;
        });
    }, [
        groupedRhesesAudioInfo,
        state
    ]);
    return {
        state: state,
        toggle: toggle,
        show: selectedRole !== (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Editor,
        filter: filter,
        applyField: applyField
    };
}



var $jMaZ8 = parcelRequire("jMaZ8");


function $0da3e7ecf2e7d5aa$export$2e2bcd8739ae039(groupedRhesesAudioInfo) {
    const { state: selectedRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    const [state, setState] = (0, $jMaZ8.useState)((0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off);
    const toggle = (0, $jMaZ8.useCallback)((option)=>{
        setState((prevValue)=>{
            if (option === (0, $d8401afee0dc69d1$export$f83a24887689bc4c).with) return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with;
            return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without;
        });
    }, []);
    const applyField = (0, $jMaZ8.useCallback)((pages)=>{
        return pages.map((page)=>{
            const renarrated = groupedRhesesAudioInfo[page.id]?.find((group)=>group.isReviewReNarrated === true);
            return {
                ...page,
                renarratedCount: renarrated?.count || 0
            };
        });
    }, [
        groupedRhesesAudioInfo
    ]);
    const filter = (0, $jMaZ8.useCallback)((pages)=>{
        if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off) return pages;
        return pages.filter((page)=>{
            const renarrated = groupedRhesesAudioInfo[page.id]?.find((group)=>group.isReviewReNarrated === true);
            if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with) return (renarrated?.count || 0) > 0;
            return renarrated?.count === 0;
        });
    }, [
        groupedRhesesAudioInfo,
        state
    ]);
    return {
        state: state,
        toggle: toggle,
        show: selectedRole !== (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Editor,
        filter: filter,
        applyField: applyField
    };
}



var $jMaZ8 = parcelRequire("jMaZ8");


function $0df7b0ae07340dc4$export$2e2bcd8739ae039(groupedRhesesAudioInfo) {
    const { state: selectedRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    const [state, setState] = (0, $jMaZ8.useState)((0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off);
    const toggle = (0, $jMaZ8.useCallback)((option)=>{
        setState((prevValue)=>{
            // If click on the with option
            if (option === (0, $d8401afee0dc69d1$export$f83a24887689bc4c).with) return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with;
            // If click on the without option
            return prevValue === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without ? (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off : (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).without;
        });
    }, []);
    const applyField = (0, $jMaZ8.useCallback)((pages)=>{
        return pages.map((page)=>{
            const audioIncomplete = groupedRhesesAudioInfo[page.id]?.find((group)=>group.withAudio === false);
            return {
                ...page,
                fullyRecorded: !((audioIncomplete?.count || 0) > 0)
            };
        });
    }, [
        groupedRhesesAudioInfo
    ]);
    const filter = (0, $jMaZ8.useCallback)((pages)=>{
        if (state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).off) return pages;
        const res = pages.filter((page)=>{
            const withData = groupedRhesesAudioInfo[page.id]?.some((group)=>group.pageContainingAudioNotSyncedWithText) ?? false;
            return state === (0, $d8401afee0dc69d1$export$70ef72b3047e3d3f).with ? withData : !withData;
        });
        console.log({
            res: res
        });
        return res;
    }, [
        groupedRhesesAudioInfo,
        state
    ]);
    return {
        state: state,
        toggle: toggle,
        show: selectedRole !== (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Editor,
        filter: filter,
        applyField: applyField
    };
}





const $a526294a9ec12bca$var$mergeGroupedAudioInfo = (rheses, definitions)=>{
    const merged = {};
    const rhesesIds = Object.keys(rheses);
    const definitionsIds = Object.keys(definitions);
    const uniqueIds = [
        ...new Set([
            ...rhesesIds,
            ...definitionsIds
        ])
    ];
    uniqueIds.forEach((id)=>{
        const rhesesAudioInfo = rheses[id];
        const definitionsAudioInfo = definitions[id];
        if (rhesesAudioInfo && definitionsAudioInfo) {
            merged[id] = [];
            rhesesAudioInfo.forEach((rheseAudioInfo)=>{
                const definitionAudioInfo = definitionsAudioInfo.find((d)=>d.isReviewReNarrated === rheseAudioInfo.isReviewReNarrated && d.isReviewValid === rheseAudioInfo.isReviewValid && d.withAudio === rheseAudioInfo.withAudio && d.withReview === rheseAudioInfo.withReview);
                merged[id].push({
                    ...rheseAudioInfo,
                    count: (definitionAudioInfo?.count || 0) + (rheseAudioInfo.count || 0)
                });
            });
        } else if (!rhesesAudioInfo) merged[id] = definitionsAudioInfo;
        else merged[id] = rhesesAudioInfo;
    });
    return merged;
};
const $a526294a9ec12bca$export$cbab88fe7217324b = ({ isPanelOpen: isPanelOpen, bookId: bookId, onClose: onClose, bookRhesesAudioInfo: bookRhesesAudioInfo, bookDefinitionsAudioInfo: bookDefinitionsAudioInfo, allPages: allPages, loading: loading })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    /**
   * Data
   */ const { state: selectedRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    const isProofListener = selectedRole === (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).ProofListener;
    const [textFilter, setTextFilter] = (0, $jMaZ8.useState)("");
    const groupedDefinitionsAudioInfo = (0, $62LIg.groupBy)(bookDefinitionsAudioInfo, "pageId");
    const groupedRhesesAudioInfo = (0, $62LIg.groupBy)(bookRhesesAudioInfo, "pageId");
    const groupedAudioInfos = $a526294a9ec12bca$var$mergeGroupedAudioInfo(groupedRhesesAudioInfo, groupedDefinitionsAudioInfo);
    /**
   * Filter based on pages comments
   */ const { show: showFilterOnComments, state: filteredOnCommentsState, toggle: toggleFilterOnComments, filter: filterOnComments, applyField: applyIssuesCount } = (0, $b47bb55ac9cb2e54$export$2e2bcd8739ae039)(groupedAudioInfos);
    /**
   * Filter based on pages comments
   */ const { show: showFilterOnAudio, state: filteredOnAudioState, toggle: toggleFilterOnAudio, filter: filterOnAudio, applyField: applyFullyRecorded } = (0, $e99b2e23ef1d0a25$export$2e2bcd8739ae039)(groupedAudioInfos);
    /**
   * Filter based on "renarrated" status
   */ const { show: showFilterOnRenarrated, state: filteredOnRenarratedState, toggle: toggleFilterOnRenarrated, filter: filterOnRenarrated, applyField: applyRenarratedCount } = (0, $0da3e7ecf2e7d5aa$export$2e2bcd8739ae039)(groupedAudioInfos);
    /**
   * Filter based on "renarrated" status
   */ const { show: showFilterOnNotAudioSynced, state: filteredOnNotAudioSyncedState, toggle: toggleFilterOnNotAudioSynced, filter: filterOnNotAudioSynced } = (0, $0df7b0ae07340dc4$export$2e2bcd8739ae039)(groupedAudioInfos);
    /**
   * Search and filters
   */ const [searchTab, setSearchTab] = (0, $jMaZ8.useState)("page");
    const [textSearchQuery, setTextSearchQuery] = (0, $jMaZ8.useState)("");
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const { data: textSearchData, loading: textSearchLoading } = (0, $d7188398173686a1$export$6f854643897373ca)({
        projectId: bookId,
        query: textSearchQuery,
        mode: (0, $b522cf181e75e62d$export$e228d3e230353c).CONTENT
    });
    const textSearchResults = (0, $jMaZ8.useMemo)(()=>{
        if (!textSearchData?.searchForRheses?.results) return [];
        return [
            ...textSearchData.searchForRheses.results
        ].sort((a, b)=>a.pageNumber - b.pageNumber);
    }, [
        textSearchData
    ]);
    const handleTextSearchResultClick = (0, $jMaZ8.useCallback)((pageNumber)=>{
        navigate(`/audio/library/edit/${bookId}/${pageNumber}`);
    }, [
        navigate,
        bookId
    ]);
    const filteredPages = (0, $jMaZ8.useMemo)(()=>{
        let _filteredPages = allPages.filter((page)=>{
            return page.pageNumber.toString().includes(textFilter);
        });
        // Filters
        _filteredPages = filterOnComments(_filteredPages);
        _filteredPages = filterOnAudio(_filteredPages);
        _filteredPages = filterOnRenarrated(_filteredPages);
        _filteredPages = filterOnNotAudioSynced(_filteredPages);
        // Fields
        _filteredPages = applyIssuesCount(_filteredPages);
        _filteredPages = applyFullyRecorded(_filteredPages);
        _filteredPages = applyRenarratedCount(_filteredPages);
        return _filteredPages;
    }, [
        allPages,
        filterOnComments,
        filterOnAudio,
        filterOnRenarrated,
        applyFullyRecorded,
        applyIssuesCount,
        applyRenarratedCount,
        textFilter
    ]);
    /**
   * Handlers
   */ const handlePageFilterChange = (0, $jMaZ8.useCallback)((e)=>setTextFilter(e.target.value), []);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d88f1f9a11889bfa$export$2e2bcd8739ae039), {
        closable: false,
        placement: "right",
        open: isPanelOpen,
        onClose: onClose,
        className: $bc12e8bca3b35739$export$4df8d4373bc60300,
        children: loading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
            className: $bc12e8bca3b35739$export$641374ffb95bc399,
            small: true
        }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3d078c5b7a14a8e5$export$2e2bcd8739ae039), {
                activeKey: searchTab,
                onChange: (key)=>setSearchTab(key),
                className: $bc12e8bca3b35739$export$7f953ae6a8b63b25,
                items: [
                    {
                        key: "page",
                        label: "Pages",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    className: $bc12e8bca3b35739$export$ea095142f6817690,
                                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                        className: $bc12e8bca3b35739$export$75c4be3c725a026b,
                                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                                            // eslint-disable-next-line jsx-a11y/no-autofocus
                                            autoFocus: true,
                                            onChange: handlePageFilterChange,
                                            className: $bc12e8bca3b35739$export$952af3258ed45903,
                                            value: textFilter
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                    className: $bc12e8bca3b35739$export$82462a21aead86ed,
                                    children: [
                                        showFilterOnComments && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d8401afee0dc69d1$export$2e2bcd8739ae039), {
                                            className: $bc12e8bca3b35739$export$5f5e7a910495f292,
                                            state: filteredOnCommentsState,
                                            toggle: toggleFilterOnComments,
                                            label: t("filterWithIssues")
                                        }),
                                        showFilterOnAudio && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d8401afee0dc69d1$export$2e2bcd8739ae039), {
                                            className: $bc12e8bca3b35739$export$5f5e7a910495f292,
                                            state: filteredOnAudioState,
                                            toggle: toggleFilterOnAudio,
                                            label: t("filterAudioComplete")
                                        }),
                                        showFilterOnRenarrated && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d8401afee0dc69d1$export$2e2bcd8739ae039), {
                                            className: $bc12e8bca3b35739$export$5f5e7a910495f292,
                                            state: filteredOnRenarratedState,
                                            toggle: toggleFilterOnRenarrated,
                                            label: t("filterRenarrated")
                                        }),
                                        showFilterOnNotAudioSynced && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d8401afee0dc69d1$export$2e2bcd8739ae039), {
                                            className: $bc12e8bca3b35739$export$5f5e7a910495f292,
                                            state: filteredOnNotAudioSyncedState,
                                            toggle: toggleFilterOnNotAudioSynced,
                                            label: t("filterNotAudioSynced")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    className: $bc12e8bca3b35739$export$8027b0307179fc17,
                                    children: filteredPages.map(({ pageNumber: pageNumber, fullyRecorded: fullyRecorded, issuesCount: issuesCount, renarratedCount: renarratedCount })=>{
                                        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b5d000a215963277$export$76dee46ffaa0a681), {
                                            pageNumber: pageNumber,
                                            bookId: bookId,
                                            disabled: isProofListener ? !fullyRecorded : false,
                                            hasIssues: issuesCount > 0,
                                            audioComplete: fullyRecorded,
                                            renarrated: renarratedCount > 0
                                        }, pageNumber);
                                    })
                                })
                            ]
                        })
                    },
                    {
                        key: "text",
                        label: "Texte",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    className: $bc12e8bca3b35739$export$ea095142f6817690,
                                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                        className: $bc12e8bca3b35739$export$75c4be3c725a026b,
                                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                                            // eslint-disable-next-line jsx-a11y/no-autofocus
                                            autoFocus: true,
                                            onChange: (e)=>setTextSearchQuery(e.target.value),
                                            className: $bc12e8bca3b35739$export$952af3258ed45903,
                                            value: textSearchQuery,
                                            placeholder: t("searchPlaceholder") || "Rechercher..."
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    className: $bc12e8bca3b35739$export$8027b0307179fc17,
                                    children: textSearchLoading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                                        className: $bc12e8bca3b35739$export$641374ffb95bc399,
                                        small: true
                                    }) : textSearchResults.map((result)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                            className: $bc12e8bca3b35739$export$aa47f9d1410832b0,
                                            onClick: ()=>handleTextSearchResultClick(result.pageNumber),
                                            children: [
                                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                                                    className: $bc12e8bca3b35739$export$54372d01d1d0caec,
                                                    children: result.pageNumber
                                                }),
                                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                                                    className: $bc12e8bca3b35739$export$eb7baebc3baa4d97,
                                                    children: result.content
                                                })
                                            ]
                                        }, result.rhese.data.id))
                                })
                            ]
                        })
                    }
                ]
            })
        })
    });
};


var $08c9bb30140977c8$export$9e480c717d0e2daa;
var $08c9bb30140977c8$export$c16c630f7be9a365;
var $08c9bb30140977c8$export$3d0bc00a171f3329;
var $08c9bb30140977c8$export$5d559278e17df9c5;
var $08c9bb30140977c8$export$ab1107743aa4affb;
var $08c9bb30140977c8$export$995244700419ecaa;
var $08c9bb30140977c8$export$1f22e2e0afc9f037;
var $08c9bb30140977c8$export$2e929abd04b4c3e4;
var $08c9bb30140977c8$export$15c60d712917cee6;
var $08c9bb30140977c8$export$c7fa571845043fc2;
var $08c9bb30140977c8$export$33f479386c8904cd;
var $08c9bb30140977c8$export$22fa394f3ba39578;
var $08c9bb30140977c8$export$73920f18ca706874;
var $08c9bb30140977c8$export$643a55a4429f0dc6;
var $08c9bb30140977c8$export$db34926ef76b3f9b;
$08c9bb30140977c8$export$9e480c717d0e2daa = "headerHomeContainer_47b3c7";
$08c9bb30140977c8$export$c16c630f7be9a365 = "headerBookContainer_47b3c7";
$08c9bb30140977c8$export$3d0bc00a171f3329 = "headerTitleContainer_47b3c7";
$08c9bb30140977c8$export$5d559278e17df9c5 = "userMenu_47b3c7";
$08c9bb30140977c8$export$ab1107743aa4affb = "userFirstLetter_47b3c7";
$08c9bb30140977c8$export$995244700419ecaa = "emailInHeader_47b3c7";
$08c9bb30140977c8$export$1f22e2e0afc9f037 = "logoutButton_47b3c7";
$08c9bb30140977c8$export$2e929abd04b4c3e4 = "bookInfo_47b3c7";
$08c9bb30140977c8$export$15c60d712917cee6 = "headerTitle_47b3c7";
$08c9bb30140977c8$export$c7fa571845043fc2 = "headerAuthor_47b3c7";
$08c9bb30140977c8$export$33f479386c8904cd = "paginationBar_47b3c7";
$08c9bb30140977c8$export$22fa394f3ba39578 = "pagination_47b3c7";
$08c9bb30140977c8$export$73920f18ca706874 = "hidden_47b3c7";
$08c9bb30140977c8$export$643a55a4429f0dc6 = "halfHidden_47b3c7";
$08c9bb30140977c8$export$db34926ef76b3f9b = "headerSpinner_47b3c7";



var $giSak = parcelRequire("giSak");


const $e8331f7a0c96cb57$var$HeaderBook = ({ bookInfoFromUrl: bookInfoFromUrl, book: book, loading: loading, page: page, allPages: allPages })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [isBookPanelOpen, setIsBookPanelOpen] = (0, $jMaZ8.useState)(false);
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const loaded = !!book && !loading;
    const handelGoBack = (0, $jMaZ8.useCallback)(()=>navigate("/audio/library"), []);
    const handelOnClose = (0, $jMaZ8.useCallback)(()=>setIsBookPanelOpen(false), []);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $08c9bb30140977c8$export$c16c630f7be9a365,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        className: $08c9bb30140977c8$export$3d0bc00a171f3329,
                        children: [
                            loaded && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $81af65a839e3ccf4$export$2e2bcd8739ae039), {
                                onClick: handelGoBack
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                className: $08c9bb30140977c8$export$2e929abd04b4c3e4,
                                children: loaded ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                            className: $08c9bb30140977c8$export$15c60d712917cee6,
                                            children: book.name
                                        }),
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                            className: $08c9bb30140977c8$export$c7fa571845043fc2,
                                            children: book.author
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                    style: {
                                        position: "relative",
                                        marginTop: "2em"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($08c9bb30140977c8$export$15c60d712917cee6, $08c9bb30140977c8$export$73920f18ca706874),
                                            children: "Loading"
                                        }),
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($08c9bb30140977c8$export$c7fa571845043fc2, $08c9bb30140977c8$export$73920f18ca706874),
                                            children: "Loading"
                                        }),
                                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                                            small: true,
                                            className: $08c9bb30140977c8$export$db34926ef76b3f9b
                                        })
                                    ]
                                })
                            }),
                            loaded && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $786bf8f1d7cd6f44$export$51acff60f35f47a5), {
                                onClick: ()=>{
                                    setIsBookPanelOpen(true);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        className: $08c9bb30140977c8$export$33f479386c8904cd,
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($08c9bb30140977c8$export$22fa394f3ba39578, {
                                    [$08c9bb30140977c8$export$643a55a4429f0dc6]: !loaded
                                }),
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    children: `${t("page")} ${page?.pageNumber || "?"}`
                                })
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))({
                                    [$08c9bb30140977c8$export$643a55a4429f0dc6]: !loaded || !book.totalPageNumber
                                }),
                                children: `${t("on")} ${page?.lastPageNumber || "?"}`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a526294a9ec12bca$export$cbab88fe7217324b), {
                isPanelOpen: isBookPanelOpen,
                bookId: bookInfoFromUrl.bookId,
                onClose: handelOnClose,
                bookRhesesAudioInfo: book?.rhesesAudioInfo,
                bookDefinitionsAudioInfo: book?.definitionsAudioInfo,
                allPages: allPages,
                loading: loading
            })
        ]
    });
};
var $e8331f7a0c96cb57$export$2e2bcd8739ae039 = $e8331f7a0c96cb57$var$HeaderBook;



var $jMaZ8 = parcelRequire("jMaZ8");

function $fdbf17c07662ad3d$export$2e2bcd8739ae039(currentPageId, bookInfoFromUrl, pages) {
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const goBack = (0, $jMaZ8.useCallback)(()=>navigate(-1), [
        navigate
    ]);
    const [previousPage, nextPage] = (0, $jMaZ8.useMemo)(()=>{
        if (!pages?.length) return [];
        const idx = pages.findIndex((page)=>page.id === currentPageId);
        return [
            pages[idx - 1]?.pageNumber,
            pages[idx + 1]?.pageNumber
        ];
    }, [
        pages,
        currentPageId
    ]);
    const nav = (0, $jMaZ8.useMemo)(()=>{
        const navTo = (pageNumber)=>{
            if (typeof pageNumber !== "number") return;
            navigate(`/audio/library/edit/${bookInfoFromUrl.bookId}/${pageNumber}`);
        };
        return {
            prev: {
                canNavigate: previousPage !== undefined,
                navigate: ()=>navTo(previousPage)
            },
            next: {
                canNavigate: nextPage !== undefined,
                navigate: ()=>navTo(nextPage)
            }
        };
    }, [
        previousPage,
        nextPage,
        navigate,
        bookInfoFromUrl.bookId
    ]);
    return {
        goBack: goBack,
        nav: nav
    };
}






var $0a79a9616af44e21$export$b2c1506c6ba891d6;
$0a79a9616af44e21$export$b2c1506c6ba891d6 = "pageContent_cc117c";




parcelRequire("jMaZ8");


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $600c5adb4f7f053f$var$SyncOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z"
                }
            }
        ]
    },
    "name": "sync",
    "theme": "outlined"
};
var $600c5adb4f7f053f$export$2e2bcd8739ae039 = $600c5adb4f7f053f$var$SyncOutlined;



var $e2eef79cc660167e$var$SyncOutlined = function SyncOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $600c5adb4f7f053f$export$2e2bcd8739ae039)
    }));
};
/**![sync](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE2OCA1MDQuMmMxLTQzLjcgMTAtODYuMSAyNi45LTEyNiAxNy4zLTQxIDQyLjEtNzcuNyA3My43LTEwOS40UzMzNyAyMTIuMyAzNzggMTk1YzQyLjQtMTcuOSA4Ny40LTI3IDEzMy45LTI3czkxLjUgOS4xIDEzMy44IDI3QTM0MS41IDM0MS41IDAgMDE3NTUgMjY4LjhjOS45IDkuOSAxOS4yIDIwLjQgMjcuOCAzMS40bC02MC4yIDQ3YTggOCAwIDAwMyAxNC4xbDE3NS43IDQzYzUgMS4yIDkuOS0yLjYgOS45LTcuN2wuOC0xODAuOWMwLTYuNy03LjctMTAuNS0xMi45LTYuM2wtNTYuNCA0NC4xQzc2NS44IDE1NS4xIDY0Ni4yIDkyIDUxMS44IDkyIDI4Mi43IDkyIDk2LjMgMjc1LjYgOTIgNTAzLjhhOCA4IDAgMDA4IDguMmg2MGM0LjQgMCA3LjktMy41IDgtNy44em03NTYgNy44aC02MGMtNC40IDAtNy45IDMuNS04IDcuOC0xIDQzLjctMTAgODYuMS0yNi45IDEyNi0xNy4zIDQxLTQyLjEgNzcuOC03My43IDEwOS40QTM0Mi40NSAzNDIuNDUgMCAwMTUxMi4xIDg1NmEzNDIuMjQgMzQyLjI0IDAgMDEtMjQzLjItMTAwLjhjLTkuOS05LjktMTkuMi0yMC40LTI3LjgtMzEuNGw2MC4yLTQ3YTggOCAwIDAwLTMtMTQuMWwtMTc1LjctNDNjLTUtMS4yLTkuOSAyLjYtOS45IDcuN2wtLjcgMTgxYzAgNi43IDcuNyAxMC41IDEyLjkgNi4zbDU2LjQtNDQuMUMyNTguMiA4NjguOSAzNzcuOCA5MzIgNTEyLjIgOTMyYzIyOS4yIDAgNDE1LjUtMTgzLjcgNDE5LjgtNDExLjhhOCA4IDAgMDAtOC04LjJ6IiAvPjwvc3ZnPg==) */ var $e2eef79cc660167e$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($e2eef79cc660167e$var$SyncOutlined);
$e2eef79cc660167e$var$RefIcon.displayName = 'SyncOutlined';
var $e2eef79cc660167e$export$2e2bcd8739ae039 = $e2eef79cc660167e$var$RefIcon;


var $cb794c1e150b07a2$export$4ee41876978d12aa;
$cb794c1e150b07a2$export$4ee41876978d12aa = "resyncOverlay_1ea007";


function $74369faf6b911a8d$export$2e2bcd8739ae039() {
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $cb794c1e150b07a2$export$4ee41876978d12aa,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h2", {
                children: t("overlayReSync")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e2eef79cc660167e$export$2e2bcd8739ae039), {
                spin: true
            })
        ]
    });
}



parcelRequire("jMaZ8");


parcelRequire("jMaZ8");





var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");




const $651ac2e042bd2c5e$export$3749e9e8883dd1ea = (0, $f013a28d70124837$export$72e4926bf8358653)`
  query audioRecordingQuery($filename: UUID) {
    audioRecording(filename: $filename) {
      presignedUrl {
        filename
        getUrl
        putUrl
      }
    }
  }
`; // IMPORTANT BUG NOTE
 // DO NOT USE useLazyQuery in parallel, it's buggy: see : https://github.com/apollographql/apollo-client/issues/9755
 // export const useGetRecordingPresignedUrls = () => {
 //   return useLazyQuery<AudioRecording, AudioRecordingVariables>(
 //     gql`
 //       query audioRecording($filename: UUID) {
 //         audioRecording(filename: $filename) {
 //           presignedUrl {
 //             filename
 //             getUrl
 //             putUrl
 //           }
 //         }
 //       }
 //     `,
 //   );
 // };



parcelRequire("jMaZ8");
var // eslint-disable-next-line react/display-name
$6d8cb2556af0168b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M21 10.2679C22.3333 11.0377 22.3333 12.9623 21 13.7321L9 20.6603C7.66667 21.4301 6 20.4678 6 18.9282L6 5.0718C6 3.5322 7.66667 2.56995 9 3.33975L21 10.2679Z",
            fill: "#E66525"
        })
    });


var $5c2d3cdd96b7835a$export$e8e78c978b129247;
var $5c2d3cdd96b7835a$export$17aca76bf89ef49e;
var $5c2d3cdd96b7835a$export$89c7cdb43f08ba45;
var $5c2d3cdd96b7835a$export$c2e65443ea38786;
var $5c2d3cdd96b7835a$export$e324594224ef24da;
var $5c2d3cdd96b7835a$export$c4a79ec0e91224d1;
var $5c2d3cdd96b7835a$export$f16b8a82b5b3b0df;
var $5c2d3cdd96b7835a$export$b3f5e57879cbdea7;
var $5c2d3cdd96b7835a$export$b0d8a4ba496e2be;
var $5c2d3cdd96b7835a$export$6562daabb7d75820;
var $5c2d3cdd96b7835a$export$896c3927874d3a3f;
var $5c2d3cdd96b7835a$export$864af25a7f7e70fe;
var $5c2d3cdd96b7835a$export$2e2992790a6f69a8;
var $5c2d3cdd96b7835a$export$a7db06668cad9adb;
var $5c2d3cdd96b7835a$export$d89dc70d9d82cb3b;
var $5c2d3cdd96b7835a$export$d04d442d31aabc67;
var $5c2d3cdd96b7835a$export$f150c56d95417c69;
var $5c2d3cdd96b7835a$export$9a66a8c66d2abe0d;
var $5c2d3cdd96b7835a$export$36821f9ffb9a4d56;
var $5c2d3cdd96b7835a$export$d0c2ff82f0790e53;
var $5c2d3cdd96b7835a$export$4a34f930e789283c;
var $5c2d3cdd96b7835a$export$fb184b623420d9be;
var $5c2d3cdd96b7835a$export$7b388ca536128c6d;
var $5c2d3cdd96b7835a$export$cc1adf6fb659c762;
var $5c2d3cdd96b7835a$export$73e4574fc43cf3a2;
var $5c2d3cdd96b7835a$export$78c1a67d0944270;
var $5c2d3cdd96b7835a$export$1f7a5d2e5a3de51f;
var $5c2d3cdd96b7835a$export$6e2c273eb6371f2e;
var $5c2d3cdd96b7835a$export$ce5d78961483d611;
$5c2d3cdd96b7835a$export$e8e78c978b129247 = "root_fcd1b4";
$5c2d3cdd96b7835a$export$17aca76bf89ef49e = "noResult_fcd1b4";
$5c2d3cdd96b7835a$export$89c7cdb43f08ba45 = "noResultTitle_fcd1b4";
$5c2d3cdd96b7835a$export$c2e65443ea38786 = "setStatusBar_fcd1b4";
$5c2d3cdd96b7835a$export$e324594224ef24da = "actions_fcd1b4";
$5c2d3cdd96b7835a$export$c4a79ec0e91224d1 = "paragraphs_fcd1b4";
$5c2d3cdd96b7835a$export$f16b8a82b5b3b0df = "audioPlayer_fcd1b4";
$5c2d3cdd96b7835a$export$b3f5e57879cbdea7 = "speedControlsContainer_fcd1b4";
$5c2d3cdd96b7835a$export$b0d8a4ba496e2be = "speedControls_fcd1b4";
$5c2d3cdd96b7835a$export$6562daabb7d75820 = "buttonsRow_fcd1b4";
$5c2d3cdd96b7835a$export$896c3927874d3a3f = "playPause_fcd1b4";
$5c2d3cdd96b7835a$export$864af25a7f7e70fe = "rhese_fcd1b4";
$5c2d3cdd96b7835a$export$2e2992790a6f69a8 = "anchor_fcd1b4";
$5c2d3cdd96b7835a$export$a7db06668cad9adb = "content_fcd1b4";
$5c2d3cdd96b7835a$export$d89dc70d9d82cb3b = "rheseContainer_fcd1b4";
$5c2d3cdd96b7835a$export$d04d442d31aabc67 = "rheseAudioDuration_fcd1b4";
$5c2d3cdd96b7835a$export$f150c56d95417c69 = "playRhese_fcd1b4";
$5c2d3cdd96b7835a$export$9a66a8c66d2abe0d = "silentIndicator_fcd1b4";
$5c2d3cdd96b7835a$export$36821f9ffb9a4d56 = "fakeBtn_fcd1b4";
$5c2d3cdd96b7835a$export$d0c2ff82f0790e53 = "stopIcon_fcd1b4";
$5c2d3cdd96b7835a$export$4a34f930e789283c = "comment_fcd1b4";
$5c2d3cdd96b7835a$export$fb184b623420d9be = "title_fcd1b4";
$5c2d3cdd96b7835a$export$7b388ca536128c6d = "inputs_fcd1b4";
$5c2d3cdd96b7835a$export$cc1adf6fb659c762 = "controls_fcd1b4";
$5c2d3cdd96b7835a$export$73e4574fc43cf3a2 = "playButton_fcd1b4";
$5c2d3cdd96b7835a$export$78c1a67d0944270 = "audioReview_fcd1b4";
$5c2d3cdd96b7835a$export$1f7a5d2e5a3de51f = "pageNav_fcd1b4";
$5c2d3cdd96b7835a$export$6e2c273eb6371f2e = "statusSelector_fcd1b4";
$5c2d3cdd96b7835a$export$ce5d78961483d611 = "iconIgnoredFromSynchro_fcd1b4";



parcelRequire("jMaZ8");




const { Option: $a6ea860e715f186d$var$Option } = (0, $71df08955277779f$export$2e2bcd8739ae039);
const $a6ea860e715f186d$var$orderedOptionsKeys = [
    (0, $b522cf181e75e62d$export$221b784fada1dd4a).BAD_SPEECH,
    (0, $b522cf181e75e62d$export$221b784fada1dd4a).RECORDING,
    (0, $b522cf181e75e62d$export$221b784fada1dd4a).BAD_TEXT,
    (0, $b522cf181e75e62d$export$221b784fada1dd4a).BAD_TEXT_AND_NARRATION,
    (0, $b522cf181e75e62d$export$221b784fada1dd4a).RENARRATED,
    (0, $b522cf181e75e62d$export$221b784fada1dd4a).VALID
];
const $a6ea860e715f186d$var$StatusSelector = ({ status: status, onChange: onChange })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $71df08955277779f$export$2e2bcd8739ae039), {
        className: $5c2d3cdd96b7835a$export$6e2c273eb6371f2e,
        value: status,
        placeholder: t("select_recorgind_issue_type"),
        onChange: onChange,
        children: $a6ea860e715f186d$var$orderedOptionsKeys.map((key)=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($a6ea860e715f186d$var$Option, {
                value: key,
                disabled: key === (0, $b522cf181e75e62d$export$221b784fada1dd4a).RENARRATED,
                children: t(`audioReview.${key.toLowerCase()}`)
            }, key))
    });
};
var $a6ea860e715f186d$export$2e2bcd8739ae039 = $a6ea860e715f186d$var$StatusSelector;




var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $9a4780e204bfc64e$var$CommentOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zm-280 0c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M894 345a343.92 343.92 0 00-189-130v.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l.8 132.6c0 3.2.5 6.4 1.5 9.4a31.95 31.95 0 0040.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-.5.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102zm505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-.2-.1A367.31 367.31 0 00729 676c76.4-105.3 88.8-237.6 44.4-350.4l.6.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            }
        ]
    },
    "name": "comment",
    "theme": "outlined"
};
var $9a4780e204bfc64e$export$2e2bcd8739ae039 = $9a4780e204bfc64e$var$CommentOutlined;



var $2656a709c727a23f$var$CommentOutlined = function CommentOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $9a4780e204bfc64e$export$2e2bcd8739ae039)
    }));
};
/**![comment](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik01NzMgNDIxYy0yMy4xIDAtNDEgMTcuOS00MSA0MHMxNy45IDQwIDQxIDQwYzIxLjEgMCAzOS0xNy45IDM5LTQwcy0xNy45LTQwLTM5LTQwem0tMjgwIDBjLTIzLjEgMC00MSAxNy45LTQxIDQwczE3LjkgNDAgNDEgNDBjMjEuMSAwIDM5LTE3LjkgMzktNDBzLTE3LjktNDAtMzktNDB6IiAvPjxwYXRoIGQ9Ik04OTQgMzQ1YTM0My45MiAzNDMuOTIgMCAwMC0xODktMTMwdi4xYy0xNy4xLTE5LTM2LjQtMzYuNS01OC01Mi4xLTE2My43LTExOS0zOTMuNS04Mi43LTUxMyA4MS05Ni4zIDEzMy05Mi4yIDMxMS45IDYgNDM5bC44IDEzMi42YzAgMy4yLjUgNi40IDEuNSA5LjRhMzEuOTUgMzEuOTUgMCAwMDQwLjEgMjAuOUwzMDkgODA2YzMzLjUgMTEuOSA2OC4xIDE4LjcgMTAyLjUgMjAuNmwtLjUuNGM4OS4xIDY0LjkgMjA1LjkgODQuNCAzMTMgNDlsMTI3LjEgNDEuNGMzLjIgMSA2LjUgMS42IDkuOSAxLjYgMTcuNyAwIDMyLTE0LjMgMzItMzJWNzUzYzg4LjEtMTE5LjYgOTAuNC0yODQuOSAxLTQwOHpNMzIzIDczNWwtMTItNS05OSAzMS0xLTEwNC04LTljLTg0LjYtMTAzLjItOTAuMi0yNTEuOS0xMS0zNjEgOTYuNC0xMzIuMiAyODEuMi0xNjEuNCA0MTMtNjYgMTMyLjIgOTYuMSAxNjEuNSAyODAuNiA2NiA0MTItODAuMSAxMDkuOS0yMjMuNSAxNTAuNS0zNDggMTAyem01MDUtMTdsLTggMTAgMSAxMDQtOTgtMzMtMTIgNWMtNTYgMjAuOC0xMTUuNyAyMi41LTE3MSA3bC0uMi0uMUEzNjcuMzEgMzY3LjMxIDAgMDA3MjkgNjc2Yzc2LjQtMTA1LjMgODguOC0yMzcuNiA0NC40LTM1MC40bC42LjRjMjMgMTYuNSA0NC4xIDM3LjEgNjIgNjIgNzIuNiA5OS42IDY4LjUgMjM1LjItOCAzMzB6IiAvPjxwYXRoIGQ9Ik00MzMgNDIxYy0yMy4xIDAtNDEgMTcuOS00MSA0MHMxNy45IDQwIDQxIDQwYzIxLjEgMCAzOS0xNy45IDM5LTQwcy0xNy45LTQwLTM5LTQweiIgLz48L3N2Zz4=) */ var $2656a709c727a23f$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($2656a709c727a23f$var$CommentOutlined);
$2656a709c727a23f$var$RefIcon.displayName = 'CommentOutlined';
var $2656a709c727a23f$export$2e2bcd8739ae039 = $2656a709c727a23f$var$RefIcon;


var $ebc66aea182f48d4$exports = {};
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $ebc66aea182f48d4$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $ebc66aea182f48d4$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty($ebc66aea182f48d4$exports, "__esModule", {
    value: true
});
$ebc66aea182f48d4$exports.default = void 0;

var $ebc66aea182f48d4$var$_react = $ebc66aea182f48d4$require$_interopRequireWildcard((parcelRequire("jMaZ8")));
var $ebc66aea182f48d4$var$React = $ebc66aea182f48d4$var$_react;

var $ebc66aea182f48d4$var$_classnames = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("giSak")));

var $ebc66aea182f48d4$var$_rcTextarea = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("7NxHX")));

var $ebc66aea182f48d4$var$_getAllowClear = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("i4vhP")));
var $65032f73cd151874$exports = {};
"use strict";

var $4d0me = parcelRequire("4d0me");
var $65032f73cd151874$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty($65032f73cd151874$exports, "__esModule", {
    value: true
});
$65032f73cd151874$exports.getMergedStatus = void 0;
$65032f73cd151874$exports.getStatusClassNames = $65032f73cd151874$var$getStatusClassNames;

var $65032f73cd151874$var$_classnames = $65032f73cd151874$require$_interopRequireDefault((parcelRequire("giSak")));
const $65032f73cd151874$var$_InputStatuses = [
    'warning',
    'error',
    ''
];
function $65032f73cd151874$var$getStatusClassNames(prefixCls, status, hasFeedback) {
    return (0, $65032f73cd151874$var$_classnames.default)({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
}
const $65032f73cd151874$var$getMergedStatus = (contextStatus, customStatus)=>customStatus || contextStatus;
$65032f73cd151874$exports.getMergedStatus = $65032f73cd151874$var$getMergedStatus;



var $dw0yD = parcelRequire("dw0yD");

var $bv7tF = parcelRequire("bv7tF");

var $ebc66aea182f48d4$var$_DisabledContext = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("8zNsY")));

var $ebc66aea182f48d4$var$_useCSSVarCls = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("39NP9")));

var $ebc66aea182f48d4$var$_useSize = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("jRzZI")));

var $6htaW = parcelRequire("6htaW");

var $ebc66aea182f48d4$var$_useVariants = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("cYCF3")));
var $352789f2733b769b$exports = {};
"use strict";
"use client";

var $4d0me = parcelRequire("4d0me");
var $352789f2733b769b$require$_interopRequireDefault = $4d0me.default;

var $ffW2x = parcelRequire("ffW2x");
var $352789f2733b769b$require$_interopRequireWildcard = $ffW2x.default;
Object.defineProperty($352789f2733b769b$exports, "__esModule", {
    value: true
});
$352789f2733b769b$exports.default = void 0;
Object.defineProperty($352789f2733b769b$exports, "triggerFocus", {
    enumerable: true,
    get: function() {
        return $969e2951a45760a4$exports.triggerFocus;
    }
});

var $352789f2733b769b$var$_react = $352789f2733b769b$require$_interopRequireWildcard((parcelRequire("jMaZ8")));

var $352789f2733b769b$var$_classnames = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("giSak")));

var $352789f2733b769b$var$_rcInput = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("29zSp")));
var $969e2951a45760a4$exports = {};
"use strict";
Object.defineProperty($969e2951a45760a4$exports, "__esModule", {
    value: true
});
$969e2951a45760a4$exports.hasAddon = $969e2951a45760a4$var$hasAddon;
$969e2951a45760a4$exports.hasPrefixSuffix = $969e2951a45760a4$var$hasPrefixSuffix;
$969e2951a45760a4$exports.resolveOnChange = $969e2951a45760a4$var$resolveOnChange;
$969e2951a45760a4$exports.triggerFocus = $969e2951a45760a4$var$triggerFocus;
function $969e2951a45760a4$var$hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $969e2951a45760a4$var$hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $969e2951a45760a4$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    var currentTarget = target.cloneNode(true);
    // click clear icon
    var newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = function() {
        target.setSelectionRange.apply(target, arguments);
    };
    return newEvent;
}
function $969e2951a45760a4$var$resolveOnChange(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $969e2951a45760a4$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $969e2951a45760a4$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}
function $969e2951a45760a4$var$triggerFocus(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}


var $dada94e52ff77f4c$exports = {};
"use strict";

var $4d0me = parcelRequire("4d0me");
var $dada94e52ff77f4c$require$_interopRequireDefault = $4d0me.default;
Object.defineProperty($dada94e52ff77f4c$exports, "__esModule", {
    value: true
});
$dada94e52ff77f4c$exports.useComposeRef = $dada94e52ff77f4c$exports.supportRef = $dada94e52ff77f4c$exports.supportNodeRef = $dada94e52ff77f4c$exports.getNodeRef = $dada94e52ff77f4c$exports.fillRef = $dada94e52ff77f4c$exports.composeRef = void 0;

var $dada94e52ff77f4c$var$_typeof2 = $dada94e52ff77f4c$require$_interopRequireDefault((parcelRequire("cEcQP")));

var $jMaZ8 = parcelRequire("jMaZ8");

var $39k9r = parcelRequire("39k9r");

var $dada94e52ff77f4c$var$_useMemo = $dada94e52ff77f4c$require$_interopRequireDefault((parcelRequire("1C33x")));

var $dada94e52ff77f4c$var$_isFragment = $dada94e52ff77f4c$require$_interopRequireDefault((parcelRequire("fGVpj")));
var $dada94e52ff77f4c$var$fillRef = $dada94e52ff77f4c$exports.fillRef = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $dada94e52ff77f4c$var$_typeof2.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
/**
 * Merge refs into one ref function to support ref passing.
 */ var $dada94e52ff77f4c$var$composeRef = $dada94e52ff77f4c$exports.composeRef = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $dada94e52ff77f4c$var$fillRef(ref, node);
        });
    };
};
var $dada94e52ff77f4c$var$useComposeRef = $dada94e52ff77f4c$exports.useComposeRef = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $dada94e52ff77f4c$var$_useMemo.default)(function() {
        return $dada94e52ff77f4c$var$composeRef.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $dada94e52ff77f4c$var$supportRef = $dada94e52ff77f4c$exports.supportRef = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($dada94e52ff77f4c$var$isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) return true;
    var type = (0, $39k9r.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== $39k9r.ForwardRef) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== $39k9r.ForwardRef) return false;
    return true;
};
function $dada94e52ff77f4c$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $jMaZ8.isValidElement)(node) && !(0, $dada94e52ff77f4c$var$_isFragment.default)(node);
}
var $dada94e52ff77f4c$var$supportNodeRef = $dada94e52ff77f4c$exports.supportNodeRef = function supportNodeRef(node) {
    return $dada94e52ff77f4c$var$isReactElement(node) && $dada94e52ff77f4c$var$supportRef(node);
};
/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */ var $dada94e52ff77f4c$var$getNodeRef = $dada94e52ff77f4c$exports.getNodeRef = function getNodeRef(node) {
    if (node && $dada94e52ff77f4c$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};



var $352789f2733b769b$var$_ContextIsolator = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("8Jb6G")));

var $352789f2733b769b$var$_getAllowClear = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("i4vhP")));


var $dw0yD = parcelRequire("dw0yD");

var $bv7tF = parcelRequire("bv7tF");

var $352789f2733b769b$var$_DisabledContext = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("8zNsY")));

var $352789f2733b769b$var$_useCSSVarCls = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("39NP9")));

var $352789f2733b769b$var$_useSize = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("jRzZI")));

var $6htaW = parcelRequire("6htaW");

var $352789f2733b769b$var$_useVariants = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("cYCF3")));

var $e3K18 = parcelRequire("e3K18");

var $352789f2733b769b$var$_useRemovePasswordTimeout = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("aJ2F9")));

var $352789f2733b769b$var$_style = $352789f2733b769b$require$_interopRequireDefault((parcelRequire("ee5oX")));
var $06d86925f00be666$exports = {};
"use strict";
Object.defineProperty($06d86925f00be666$exports, "__esModule", {
    value: true
});
$06d86925f00be666$exports.hasPrefixSuffix = $06d86925f00be666$var$hasPrefixSuffix;
function $06d86925f00be666$var$hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


var $352789f2733b769b$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $352789f2733b769b$var$Input = /*#__PURE__*/ (0, $352789f2733b769b$var$_react.forwardRef)((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classes, variant: customVariant } = props, rest = $352789f2733b769b$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "style",
        "styles",
        "rootClassName",
        "onChange",
        "classNames",
        "variant"
    ]);
    {
        const { deprecated: deprecated } = (0, $dw0yD.devUseWarning)('Input');
        deprecated(!('bordered' in props), 'bordered', 'variant');
    }
    const { getPrefixCls: getPrefixCls, direction: direction, input: input } = $352789f2733b769b$var$_react.default.useContext($bv7tF.ConfigContext);
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $352789f2733b769b$var$_react.useRef)(null);
    // Style
    const rootCls = (0, $352789f2733b769b$var$_useCSSVarCls.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $352789f2733b769b$var$_style.default)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $e3K18.useCompactItemContext)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $352789f2733b769b$var$_useSize.default)((ctx)=>{
        var _a;
        return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = $352789f2733b769b$var$_react.default.useContext($352789f2733b769b$var$_DisabledContext.default);
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $352789f2733b769b$var$_react.useContext)($6htaW.FormItemInputContext);
    const mergedStatus = (0, $65032f73cd151874$exports.getMergedStatus)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $06d86925f00be666$exports.hasPrefixSuffix)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $352789f2733b769b$var$_react.useRef)(inputHasPrefixSuffix);
    {
        const warning = (0, $dw0yD.devUseWarning)('Input');
        (0, $352789f2733b769b$var$_react.useEffect)(()=>{
            var _a;
            if (inputHasPrefixSuffix && !prevHasPrefixSuffix.current) warning(document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input), 'usage', `When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ`);
            prevHasPrefixSuffix.current = inputHasPrefixSuffix;
        }, [
            inputHasPrefixSuffix
        ]);
    }
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $352789f2733b769b$var$_useRemovePasswordTimeout.default)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ $352789f2733b769b$var$_react.default.createElement($352789f2733b769b$var$_react.default.Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $352789f2733b769b$var$_getAllowClear.default)(allowClear !== null && allowClear !== void 0 ? allowClear : input === null || input === void 0 ? void 0 : input.allowClear);
    const [variant, enableVariantCls] = (0, $352789f2733b769b$var$_useVariants.default)('input', customVariant, bordered);
    return wrapCSSVar(/*#__PURE__*/ $352789f2733b769b$var$_react.default.createElement($352789f2733b769b$var$_rcInput.default, Object.assign({
        ref: (0, $dada94e52ff77f4c$exports.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.style), style),
        styles: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.styles), styles),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, $352789f2733b769b$var$_classnames.default)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, input === null || input === void 0 ? void 0 : input.className),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ $352789f2733b769b$var$_react.default.createElement($352789f2733b769b$var$_ContextIsolator.default, {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ $352789f2733b769b$var$_react.default.createElement($352789f2733b769b$var$_ContextIsolator.default, {
            form: true,
            space: true
        }, addonAfter),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), input === null || input === void 0 ? void 0 : input.classNames), {
            input: (0, $352789f2733b769b$var$_classnames.default)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, classes === null || classes === void 0 ? void 0 : classes.input, (_a = input === null || input === void 0 ? void 0 : input.classNames) === null || _a === void 0 ? void 0 : _a.input, hashId),
            variant: (0, $352789f2733b769b$var$_classnames.default)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $65032f73cd151874$exports.getStatusClassNames)(prefixCls, mergedStatus)),
            affixWrapper: (0, $352789f2733b769b$var$_classnames.default)({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, $352789f2733b769b$var$_classnames.default)({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, $352789f2733b769b$var$_classnames.default)({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $65032f73cd151874$exports.getStatusClassNames)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        })
    })));
});
$352789f2733b769b$var$Input.displayName = 'Input';
var $352789f2733b769b$var$_default = $352789f2733b769b$exports.default = $352789f2733b769b$var$Input;



var $ebc66aea182f48d4$var$_style = $ebc66aea182f48d4$require$_interopRequireDefault((parcelRequire("ee5oX")));
var $ebc66aea182f48d4$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ebc66aea182f48d4$var$TextArea = /*#__PURE__*/ (0, $ebc66aea182f48d4$var$_react.forwardRef)((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classes, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant } = props, rest = $ebc66aea182f48d4$var$__rest(props, [
        "prefixCls",
        "bordered",
        "size",
        "disabled",
        "status",
        "allowClear",
        "classNames",
        "rootClassName",
        "className",
        "style",
        "styles",
        "variant"
    ]);
    {
        const { deprecated: deprecated } = (0, $dw0yD.devUseWarning)('TextArea');
        deprecated(!('bordered' in props), 'bordered', 'variant');
    }
    const { getPrefixCls: getPrefixCls, direction: direction, textArea: textArea } = $ebc66aea182f48d4$var$React.useContext($bv7tF.ConfigContext);
    // ===================== Size =====================
    const mergedSize = (0, $ebc66aea182f48d4$var$_useSize.default)(customizeSize);
    // ===================== Disabled =====================
    const disabled = $ebc66aea182f48d4$var$React.useContext($ebc66aea182f48d4$var$_DisabledContext.default);
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $ebc66aea182f48d4$var$React.useContext($6htaW.FormItemInputContext);
    const mergedStatus = (0, $65032f73cd151874$exports.getMergedStatus)(contextStatus, customStatus);
    // ===================== Ref =====================
    const innerRef = $ebc66aea182f48d4$var$React.useRef(null);
    $ebc66aea182f48d4$var$React.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: (option)=>{
                var _a, _b;
                (0, $352789f2733b769b$exports.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: ()=>{
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ===================== Style =====================
    const rootCls = (0, $ebc66aea182f48d4$var$_useCSSVarCls.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ebc66aea182f48d4$var$_style.default)(prefixCls, rootCls);
    const [variant, enableVariantCls] = (0, $ebc66aea182f48d4$var$_useVariants.default)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $ebc66aea182f48d4$var$_getAllowClear.default)(allowClear !== null && allowClear !== void 0 ? allowClear : textArea === null || textArea === void 0 ? void 0 : textArea.allowClear);
    return wrapCSSVar(/*#__PURE__*/ $ebc66aea182f48d4$var$React.createElement($ebc66aea182f48d4$var$_rcTextarea.default, Object.assign({
        autoComplete: textArea === null || textArea === void 0 ? void 0 : textArea.autoComplete
    }, rest, {
        style: Object.assign(Object.assign({}, textArea === null || textArea === void 0 ? void 0 : textArea.style), style),
        styles: Object.assign(Object.assign({}, textArea === null || textArea === void 0 ? void 0 : textArea.styles), styles),
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, $ebc66aea182f48d4$var$_classnames.default)(cssVarCls, rootCls, className, rootClassName, textArea === null || textArea === void 0 ? void 0 : textArea.className),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), textArea === null || textArea === void 0 ? void 0 : textArea.classNames), {
            textarea: (0, $ebc66aea182f48d4$var$_classnames.default)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, (_a = textArea === null || textArea === void 0 ? void 0 : textArea.classNames) === null || _a === void 0 ? void 0 : _a.textarea),
            variant: (0, $ebc66aea182f48d4$var$_classnames.default)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $65032f73cd151874$exports.getStatusClassNames)(prefixCls, mergedStatus)),
            affixWrapper: (0, $ebc66aea182f48d4$var$_classnames.default)(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: props.showCount || ((_b = props.count) === null || _b === void 0 ? void 0 : _b.show)
            }, hashId)
        }),
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $ebc66aea182f48d4$var$React.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        ref: innerRef
    })));
});
var $ebc66aea182f48d4$var$_default = $ebc66aea182f48d4$exports.default = $ebc66aea182f48d4$var$TextArea;



var $826750d731c2bd71$exports = {};

$parcel$export($826750d731c2bd71$exports, "root", () => $826750d731c2bd71$export$e8e78c978b129247, (v) => $826750d731c2bd71$export$e8e78c978b129247 = v);
$parcel$export($826750d731c2bd71$exports, "readOnly", () => $826750d731c2bd71$export$b2cbc93d4da94977, (v) => $826750d731c2bd71$export$b2cbc93d4da94977 = v);
var $826750d731c2bd71$export$e8e78c978b129247;
var $826750d731c2bd71$export$b2cbc93d4da94977;
$826750d731c2bd71$export$e8e78c978b129247 = "root_465f71";
$826750d731c2bd71$export$b2cbc93d4da94977 = "readOnly_465f71";



var $giSak = parcelRequire("giSak");
function $85fd5c2d0a15e0bc$export$2e2bcd8739ae039({ value: value, readOnly: readOnly, modalProps: modalProps = {}, onChange: onChange, placeholder: placeholder, isModalsOpen: isModalsOpen, showModal: showModal, hideModal: hideModal, canConfirm: canConfirm }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const isControlled = typeof isModalsOpen === "boolean";
    const [_isOpen, setIsOpen] = (0, $jMaZ8.useState)(false);
    const _showModal = (0, $jMaZ8.useCallback)(()=>{
        if (isControlled && showModal) showModal();
        else setIsOpen(true);
    }, [
        isControlled,
        showModal
    ]);
    const _hideModal = (0, $jMaZ8.useCallback)(()=>{
        if (isControlled && hideModal) hideModal();
        else setIsOpen(false);
    }, [
        hideModal,
        isControlled
    ]);
    if (!value && readOnly) return null;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                shape: "circle",
                onClick: _showModal,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2656a709c727a23f$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
                title: t("audioReview.commentName"),
                open: isControlled ? isModalsOpen : _isOpen,
                footer: readOnly ? false : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            onClick: modalProps.onCancel || hideModal,
                            shape: "round",
                            children: t("cancel")
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                            onClick: modalProps.onOk,
                            shape: "round",
                            type: "primary",
                            disabled: !canConfirm,
                            children: t("audioReview.comment")
                        })
                    ]
                }),
                onCancel: _hideModal,
                okButtonProps: {
                    autoFocus: false
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((0, (/*@__PURE__*/$parcel$interopDefault($826750d731c2bd71$exports))).root, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($826750d731c2bd71$exports))).readOnly]: !!readOnly
                }),
                destroyOnClose: true,
                ...modalProps,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebc66aea182f48d4$exports))), {
                    value: value,
                    placeholder: placeholder,
                    onChange: onChange,
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus: !readOnly,
                    readOnly: readOnly,
                    onFocus: (e)=>{
                        // Hack that allows to be at the end of the content when auto-focusing the input
                        const { value: value } = e.target;
                        e.target.value = "";
                        e.target.value = value;
                    },
                    autoSize: readOnly
                })
            })
        ]
    });
}



function $e448ce0666ee897e$export$2e2bcd8739ae039({ onValidate: onValidate, defaultValue: defaultValue }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [text, setText] = (0, $jMaZ8.useState)(defaultValue || "");
    const previusDefaultValue = (0, $7ff84a88030acb67$export$5cae361ad82dce8b)(defaultValue);
    const [isModalsOpen, setIsModalOpen] = (0, $jMaZ8.useState)(false);
    const showModal = (0, $jMaZ8.useCallback)(()=>setIsModalOpen(true), []);
    const hideModal = (0, $jMaZ8.useCallback)(()=>setIsModalOpen(false), []);
    const onConfirm = (0, $jMaZ8.useCallback)(()=>{
        onValidate(text);
        hideModal();
    }, [
        onValidate,
        text,
        hideModal
    ]);
    const onChange = (0, $jMaZ8.useCallback)((e)=>{
        setText(e.target.value);
    }, []);
    (0, $jMaZ8.useEffect)(()=>{
        if (defaultValue !== previusDefaultValue) setText(defaultValue || "");
    }, [
        defaultValue,
        previusDefaultValue
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $85fd5c2d0a15e0bc$export$2e2bcd8739ae039), {
        value: text,
        canConfirm: defaultValue !== text,
        isModalsOpen: isModalsOpen,
        showModal: showModal,
        hideModal: hideModal,
        modalProps: {
            okText: t("audioReview.comment"),
            onOk: onConfirm,
            onCancel: hideModal
        },
        onChange: onChange,
        placeholder: t("audioReview.typeYourComment")
    });
}



parcelRequire("jMaZ8");
const $16ef8f19fd336cbb$var$StopIconSvg = ({ className: className, style: style, fill: fill = "#E33636" })=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        className: className,
        style: style,
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
            x: "4.5",
            y: "4",
            width: "16",
            height: "16",
            rx: "2",
            fill: fill
        })
    });
};
var $16ef8f19fd336cbb$export$2e2bcd8739ae039 = $16ef8f19fd336cbb$var$StopIconSvg;


/**
 * Note: this component uses the styles comming
 * from "../../ProofListening/ to look like a rhese.
 */ const $3b372a1714c0396c$var$DefinitionItemForProofListening = ({ children: children, definition: definition, filename: filename, onPlayEnded: onPlayEnded, updateComment: updateComment, updateStatus: updateStatus })=>{
    const { audioReviewStatus: audioReviewStatus, audioReviewComment: audioReviewComment, id: id } = definition.data;
    // Get the audio url
    const { data: data } = (0, $7fa797a3751877df$export$dd0a697e1782aedd)((0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea), {
        variables: {
            filename: filename || undefined
        },
        fetchPolicy: "no-cache",
        nextFetchPolicy: "no-cache"
    });
    const audioUrl = data?.audioRecording?.presignedUrl?.getUrl;
    // Instanciate the audio element
    const audio = (0, $jMaZ8.useMemo)(()=>new Audio(), []);
    const [isPlaying, setIsPlaying] = (0, $jMaZ8.useState)(false);
    /**
   * Handlers
   */ const play = (0, $jMaZ8.useCallback)((e)=>{
        e.stopPropagation();
        if (!audioUrl) return;
        audio.src = audioUrl;
        audio.play();
        setIsPlaying(true);
        audio.onended = ()=>{
            onPlayEnded(definition);
            setIsPlaying(false);
        };
    }, [
        audio,
        definition,
        audioUrl,
        onPlayEnded
    ]);
    const stop = (0, $jMaZ8.useCallback)((e)=>{
        e.stopPropagation();
        if (!audioUrl) return;
        e.stopPropagation();
        audio.pause();
        setIsPlaying(false);
    }, [
        audio,
        audioUrl
    ]);
    const _updateComment = (0, $jMaZ8.useCallback)((comment)=>updateComment({
            definition: definition,
            comment: comment
        }), [
        updateComment,
        definition
    ]);
    const _updateStatus = (0, $jMaZ8.useCallback)((status)=>updateStatus({
            definition: definition,
            status: status
        }), [
        updateStatus,
        definition
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        className: $5c2d3cdd96b7835a$export$d89dc70d9d82cb3b,
        whileHover: "hover",
        initial: {
            opacity: 0.65
        },
        variants: {
            hover: {
                opacity: 1
            }
        },
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: `${$5c2d3cdd96b7835a$export$864af25a7f7e70fe}`,
                "data-definition-id": id,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $5c2d3cdd96b7835a$export$a7db06668cad9adb,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        onClick: (e)=>e.stopPropagation(),
                        className: $5c2d3cdd96b7835a$export$78c1a67d0944270,
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: audioReviewComment ? 1 : 0.3
                                },
                                animate: {
                                    opacity: audioReviewComment ? 1 : 0.3
                                },
                                variants: {
                                    hover: {
                                        opacity: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e448ce0666ee897e$export$2e2bcd8739ae039), {
                                    defaultValue: audioReviewComment,
                                    onValidate: _updateComment
                                })
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a6ea860e715f186d$export$2e2bcd8739ae039), {
                                status: audioReviewStatus,
                                onChange: _updateStatus
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                className: $5c2d3cdd96b7835a$export$f150c56d95417c69,
                initial: {
                    opacity: 0
                },
                variants: {
                    hover: {
                        opacity: 1
                    }
                },
                children: !isPlaying ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    disabled: !filename,
                    shape: "round",
                    onClick: play,
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6d8cb2556af0168b$export$2e2bcd8739ae039), {})
                }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    disabled: !filename,
                    shape: "round",
                    onClick: stop,
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $16ef8f19fd336cbb$export$2e2bcd8739ae039), {
                        className: $5c2d3cdd96b7835a$export$d0c2ff82f0790e53
                    })
                })
            })
        ]
    });
};
var $3b372a1714c0396c$export$2e2bcd8739ae039 = $3b372a1714c0396c$var$DefinitionItemForProofListening;


var $3dcb4ef3e10c6148$exports = {};

$parcel$export($3dcb4ef3e10c6148$exports, "definitions", () => $3dcb4ef3e10c6148$export$d79264f26953ec1, (v) => $3dcb4ef3e10c6148$export$d79264f26953ec1 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "definitionsProofListener", () => $3dcb4ef3e10c6148$export$16b90599ca18073, (v) => $3dcb4ef3e10c6148$export$16b90599ca18073 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "definitionWrapper", () => $3dcb4ef3e10c6148$export$3163d15610b9dd02, (v) => $3dcb4ef3e10c6148$export$3163d15610b9dd02 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "definition", () => $3dcb4ef3e10c6148$export$69f215ed977cdb73, (v) => $3dcb4ef3e10c6148$export$69f215ed977cdb73 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "definitionLabel", () => $3dcb4ef3e10c6148$export$af6a2524edcacf61, (v) => $3dcb4ef3e10c6148$export$af6a2524edcacf61 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "recorder", () => $3dcb4ef3e10c6148$export$feea6ee10cb6b591, (v) => $3dcb4ef3e10c6148$export$feea6ee10cb6b591 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "recordButton", () => $3dcb4ef3e10c6148$export$798f46a04cd68bd1, (v) => $3dcb4ef3e10c6148$export$798f46a04cd68bd1 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "playButton", () => $3dcb4ef3e10c6148$export$73e4574fc43cf3a2, (v) => $3dcb4ef3e10c6148$export$73e4574fc43cf3a2 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "stopIcon", () => $3dcb4ef3e10c6148$export$d0c2ff82f0790e53, (v) => $3dcb4ef3e10c6148$export$d0c2ff82f0790e53 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "recordSpinner", () => $3dcb4ef3e10c6148$export$e03b3a4f405ef95c, (v) => $3dcb4ef3e10c6148$export$e03b3a4f405ef95c = v);
$parcel$export($3dcb4ef3e10c6148$exports, "definitionActions", () => $3dcb4ef3e10c6148$export$4cf852c2fa054f5c, (v) => $3dcb4ef3e10c6148$export$4cf852c2fa054f5c = v);
$parcel$export($3dcb4ef3e10c6148$exports, "audioDropInput", () => $3dcb4ef3e10c6148$export$e53b0f07dd67a460, (v) => $3dcb4ef3e10c6148$export$e53b0f07dd67a460 = v);
$parcel$export($3dcb4ef3e10c6148$exports, "uploadIcon", () => $3dcb4ef3e10c6148$export$e789e90053a546bb, (v) => $3dcb4ef3e10c6148$export$e789e90053a546bb = v);
var $3dcb4ef3e10c6148$export$d79264f26953ec1;
var $3dcb4ef3e10c6148$export$16b90599ca18073;
var $3dcb4ef3e10c6148$export$3163d15610b9dd02;
var $3dcb4ef3e10c6148$export$69f215ed977cdb73;
var $3dcb4ef3e10c6148$export$af6a2524edcacf61;
var $3dcb4ef3e10c6148$export$feea6ee10cb6b591;
var $3dcb4ef3e10c6148$export$798f46a04cd68bd1;
var $3dcb4ef3e10c6148$export$73e4574fc43cf3a2;
var $3dcb4ef3e10c6148$export$d0c2ff82f0790e53;
var $3dcb4ef3e10c6148$export$e03b3a4f405ef95c;
var $3dcb4ef3e10c6148$export$4cf852c2fa054f5c;
var $3dcb4ef3e10c6148$export$e53b0f07dd67a460;
var $3dcb4ef3e10c6148$export$e789e90053a546bb;
$3dcb4ef3e10c6148$export$d79264f26953ec1 = "definitions_e6ba48";
$3dcb4ef3e10c6148$export$16b90599ca18073 = "definitionsProofListener_e6ba48";
$3dcb4ef3e10c6148$export$3163d15610b9dd02 = "definitionWrapper_e6ba48";
$3dcb4ef3e10c6148$export$69f215ed977cdb73 = "definition_e6ba48";
$3dcb4ef3e10c6148$export$af6a2524edcacf61 = "definitionLabel_e6ba48";
$3dcb4ef3e10c6148$export$feea6ee10cb6b591 = "recorder_e6ba48";
$3dcb4ef3e10c6148$export$798f46a04cd68bd1 = "recordButton_e6ba48";
$3dcb4ef3e10c6148$export$73e4574fc43cf3a2 = "playButton_e6ba48";
$3dcb4ef3e10c6148$export$d0c2ff82f0790e53 = "stopIcon_e6ba48";
$3dcb4ef3e10c6148$export$e03b3a4f405ef95c = "recordSpinner_e6ba48";
$3dcb4ef3e10c6148$export$4cf852c2fa054f5c = "definitionActions_e6ba48";
$3dcb4ef3e10c6148$export$e53b0f07dd67a460 = "audioDropInput_e6ba48";
$3dcb4ef3e10c6148$export$e789e90053a546bb = "uploadIcon_e6ba48";





var $giSak = parcelRequire("giSak");
const $0b13d0bb8c94e6c6$export$fe634e6163c837a4 = (definition, pageMetadata)=>{
    const definitionStart = definition.anchors[0].utf16Start;
    const definitionEnd = definition.anchors[0].utf16Start + definition.anchors[0].utf16Size;
    const pageStart = pageMetadata.page.anchors[0].utf16Start;
    // Get the text of the definition
    let textDefinition = pageMetadata.textContent.slice(definitionStart - pageStart, definitionEnd - pageStart);
    // Add the spaces between each rheses
    pageMetadata.rhese.reverse().forEach((rhese)=>{
        const rheseEnd = rhese.anchors[0].utf16Start + rhese.anchors[0].utf16Size;
        if (rheseEnd > definitionStart && rheseEnd < definitionEnd) textDefinition = `${textDefinition.slice(0, rheseEnd - definitionStart)} ${textDefinition.slice(rheseEnd - definitionStart)}`;
    });
    return textDefinition;
};
const $0b13d0bb8c94e6c6$var$DefinitionsListening = ({ definitions: definitions, projectId: projectId, pageMetadata: pageMetadata })=>{
    const [applyUpdateDefinition] = (0, $9fbd80a2d225d843$export$1df4105d6bb9fdbe)();
    const handleUpdateDefinition = (0, $jMaZ8.useCallback)(async ({ definition: definition, status: status, comment: comment })=>{
        applyUpdateDefinition({
            variables: {
                projectId: projectId,
                definitionId: definition.data.id,
                audioFile: definition.data.audioFile || "",
                audioReviewStatus: status || definition.data.audioReviewStatus || (0, $b522cf181e75e62d$export$221b784fada1dd4a).VALID,
                audioReviewComment: comment || definition.data.audioReviewComment || "",
                description: definition.data.description,
                kind: definition.data.kind
            }
        });
    }, [
        applyUpdateDefinition,
        projectId
    ]);
    const onPlayEnded = (0, $jMaZ8.useCallback)(async (definition)=>{
        // Set the definition status to "valid" if no already set
        if (!definition.data.audioReviewStatus) await handleUpdateDefinition({
            definition: definition,
            status: (0, $b522cf181e75e62d$export$221b784fada1dd4a).VALID
        });
    }, [
        handleUpdateDefinition
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))($3dcb4ef3e10c6148$export$d79264f26953ec1, $3dcb4ef3e10c6148$export$16b90599ca18073),
        children: definitions.map((definition)=>{
            const textDefinition = $0b13d0bb8c94e6c6$export$fe634e6163c837a4(definition, pageMetadata);
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3b372a1714c0396c$export$2e2bcd8739ae039), {
                filename: definition.data.audioFile,
                definition: definition,
                onPlayEnded: onPlayEnded,
                updateComment: handleUpdateDefinition,
                updateStatus: handleUpdateDefinition,
                children: `${textDefinition}: ${definition.data.description}`
            }, definition.data.id);
        })
    });
};
var $0b13d0bb8c94e6c6$export$2e2bcd8739ae039 = $0b13d0bb8c94e6c6$var$DefinitionsListening;




var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");










parcelRequire("jMaZ8");

var $985cfeb3bb5be65e$export$78c1a67d0944270;
$985cfeb3bb5be65e$export$78c1a67d0944270 = "audioReview_fa677f";



function $80792b450d48ee77$export$2e2bcd8739ae039({ audioReviewStatus: audioReviewStatus, comment: comment }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $85fd5c2d0a15e0bc$export$2e2bcd8739ae039), {
                value: comment,
                readOnly: true
            }),
            audioReviewStatus && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                className: $985cfeb3bb5be65e$export$78c1a67d0944270,
                children: t(`audioReview.${audioReviewStatus.toLowerCase()}`)
            })
        ]
    });
}


const $cf464d5afe8d4bad$var$DefinitionItem = ({ children: children, onPressStart: onPressStart, onPressEnd: onPressEnd, definitionId: definitionId, filename: filename, loading: loading, audioReviewComment: audioReviewComment, audioReviewStatus: audioReviewStatus })=>{
    const [pressed, setPressed] = (0, $jMaZ8.useState)(false);
    const { data: data } = (0, $7fa797a3751877df$export$dd0a697e1782aedd)((0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea), {
        variables: {
            filename: filename || undefined
        },
        fetchPolicy: "no-cache",
        nextFetchPolicy: "no-cache"
    });
    const { getUrl: getUrl, putUrl: putUrl, filename: generatedFilename } = (0, $jMaZ8.useMemo)(()=>{
        const res = data?.audioRecording?.presignedUrl;
        if (res) return res;
        return {
            getUrl: null,
            putUrl: null,
            filename: null
        };
    }, [
        data
    ]);
    const handleOnPressStart = (0, $jMaZ8.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (loading || pressed) return;
        setPressed(true);
        onPressStart();
    }, [
        onPressStart,
        loading,
        pressed
    ]);
    const handleOnPressEnd = (0, $jMaZ8.useCallback)(()=>{
        if (!pressed) return;
        setPressed(false);
        onPressEnd(definitionId, putUrl, filename || generatedFilename);
    }, [
        pressed,
        onPressEnd,
        definitionId,
        putUrl,
        generatedFilename,
        filename
    ]);
    const audio = (0, $jMaZ8.useMemo)(()=>new Audio(), []);
    const [isPlaying, setIsPlaying] = (0, $jMaZ8.useState)(false);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        className: $3dcb4ef3e10c6148$export$feea6ee10cb6b591,
        onMouseLeave: handleOnPressEnd,
        whileHover: "hover",
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                className: $3dcb4ef3e10c6148$export$af6a2524edcacf61,
                children: children
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $80792b450d48ee77$export$2e2bcd8739ae039), {
                comment: audioReviewComment,
                audioReviewStatus: audioReviewStatus
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                className: $3dcb4ef3e10c6148$export$4cf852c2fa054f5c,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        onPointerDown: handleOnPressStart,
                        onPointerUp: handleOnPressEnd,
                        onPointerLeave: handleOnPressEnd,
                        className: $3dcb4ef3e10c6148$export$798f46a04cd68bd1,
                        shape: "circle",
                        disabled: loading || isPlaying,
                        children: pressed ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                            animate: {
                                scale: [
                                    1,
                                    0.25,
                                    1
                                ]
                            },
                            style: {
                                background: "red",
                                width: "1.5em",
                                height: "1.5em",
                                borderRadius: "100%"
                            },
                            transition: {
                                duration: 1,
                                ease: "easeInOut",
                                repeat: Infinity,
                                times: [
                                    0,
                                    0.2,
                                    0.5,
                                    0.8,
                                    1
                                ]
                            }
                        }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                            children: loading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                                className: $3dcb4ef3e10c6148$export$e03b3a4f405ef95c,
                                small: true
                            }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6d91fa0144a5983b$export$2e2bcd8739ae039), {})
                        })
                    }),
                    !isPlaying ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !filename,
                        onMouseDown: async (e)=>{
                            e.stopPropagation();
                            if (!getUrl) return;
                            audio.src = `${getUrl}&cache-fix=${Math.random()}`;
                            audio.play();
                            setIsPlaying(true);
                            audio.onended = function() {
                                setIsPlaying(false);
                            };
                        },
                        className: $3dcb4ef3e10c6148$export$798f46a04cd68bd1,
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6d8cb2556af0168b$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !filename,
                        onMouseDown: async (e)=>{
                            e.stopPropagation();
                            audio.pause();
                            setIsPlaying(false);
                        },
                        className: $3dcb4ef3e10c6148$export$798f46a04cd68bd1,
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $16ef8f19fd336cbb$export$2e2bcd8739ae039), {
                            className: $3dcb4ef3e10c6148$export$d0c2ff82f0790e53
                        })
                    })
                ]
            })
        ]
    });
};
var $cf464d5afe8d4bad$export$2e2bcd8739ae039 = $cf464d5afe8d4bad$var$DefinitionItem;





var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $c8672a79aab172fb$var$CloudUploadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    },
    "name": "cloud-upload",
    "theme": "outlined"
};
var $c8672a79aab172fb$export$2e2bcd8739ae039 = $c8672a79aab172fb$var$CloudUploadOutlined;



var $4d83eb74197459d9$var$CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $c8672a79aab172fb$export$2e2bcd8739ae039)
    }));
};
/**![cloud-upload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxOC4zIDQ1OWE4IDggMCAwMC0xMi42IDBsLTExMiAxNDEuN2E3Ljk4IDcuOTggMCAwMDYuMyAxMi45aDczLjlWODU2YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWNjEzLjdINjI0YzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDUxOC4zIDQ1OXoiIC8+PHBhdGggZD0iTTgxMS40IDM2Ni43Qzc2NS42IDI0NS45IDY0OC45IDE2MCA1MTIuMiAxNjBTMjU4LjggMjQ1LjggMjEzIDM2Ni42QzEyNy4zIDM4OS4xIDY0IDQ2Ny4yIDY0IDU2MGMwIDExMC41IDg5LjUgMjAwIDE5OS45IDIwMEgzMDRjNC40IDAgOC0zLjYgOC04di02MGMwLTQuNC0zLjYtOC04LThoLTQwLjFjLTMzLjcgMC02NS40LTEzLjQtODktMzcuNy0yMy41LTI0LjItMzYtNTYuOC0zNC45LTkwLjYuOS0yNi40IDkuOS01MS4yIDI2LjItNzIuMSAxNi43LTIxLjMgNDAuMS0zNi44IDY2LjEtNDMuN2wzNy45LTkuOSAxMy45LTM2LjZjOC42LTIyLjggMjAuNi00NC4xIDM1LjctNjMuNGEyNDUuNiAyNDUuNiAwIDAxNTIuNC00OS45YzQxLjEtMjguOSA4OS41LTQ0LjIgMTQwLTQ0LjJzOTguOSAxNS4zIDE0MCA0NC4yYzE5LjkgMTQgMzcuNSAzMC44IDUyLjQgNDkuOSAxNS4xIDE5LjMgMjcuMSA0MC43IDM1LjcgNjMuNGwxMy44IDM2LjUgMzcuOCAxMEM4NDYuMSA0NTQuNSA4ODQgNTAzLjggODg0IDU2MGMwIDMzLjEtMTIuOSA2NC4zLTM2LjMgODcuN2ExMjMuMDcgMTIzLjA3IDAgMDEtODcuNiAzNi4zSDcyMGMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg0MC4xQzg3MC41IDc2MCA5NjAgNjcwLjUgOTYwIDU2MGMwLTkyLjctNjMuMS0xNzAuNy0xNDguNi0xOTMuM3oiIC8+PC9zdmc+) */ var $4d83eb74197459d9$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($4d83eb74197459d9$var$CloudUploadOutlined);
$4d83eb74197459d9$var$RefIcon.displayName = 'CloudUploadOutlined';
var $4d83eb74197459d9$export$2e2bcd8739ae039 = $4d83eb74197459d9$var$RefIcon;




var $giSak = parcelRequire("giSak");

var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

const { Dragger: $ee083726a7ff6a08$var$Dragger } = (0, $d4ae1c238156c9e2$export$2e2bcd8739ae039);
function $ee083726a7ff6a08$export$2e2bcd8739ae039({ onFileSelected: onFileSelected, children: children }) {
    const onFileDroppedOrSelected = (0, $jMaZ8.useCallback)((e)=>{
        const { file: file } = e;
        if (file) onFileSelected(file);
    }, [
        onFileSelected
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($ee083726a7ff6a08$var$Dragger, {
        className: "dragger",
        name: "file",
        multiple: false,
        onChange: onFileDroppedOrSelected,
        // fileList=[] will prevent from displaying the files dropped
        fileList: [],
        customRequest: ()=>null,
        children: children
    });
}




function $3c5738838d28db4a$export$2e2bcd8739ae039({ definitionId: definitionId, loading: loading, sendFile: sendFile, filename: filename, style: style }) {
    const client = (0, $2937cd197ec1708e$export$eb9a56e7a29e494)();
    const getUploadOptions = (0, $jMaZ8.useCallback)(async ()=>{
        const { data: data } = await client.query({
            query: (0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea),
            variables: {
                filename: filename || undefined
            },
            fetchPolicy: "no-cache"
        });
        const res = data?.audioRecording?.presignedUrl;
        if (!res) return {
            getUrl: null,
            putUrl: null,
            filename: null
        };
        return res;
    }, [
        client,
        filename
    ]);
    const onFileSelected = (0, $jMaZ8.useCallback)(async (file)=>{
        const { putUrl: putUrl, filename: generatedFilename } = await getUploadOptions();
        sendFile(definitionId, putUrl, filename || generatedFilename, file);
    }, [
        definitionId,
        filename,
        sendFile,
        getUploadOptions
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))(style.audioDropInput, {
            [style.audioDropInputActive]: loading
        }),
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ee083726a7ff6a08$export$2e2bcd8739ae039), {
            onFileSelected: onFileSelected,
            children: loading ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                small: true
            }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4d83eb74197459d9$export$2e2bcd8739ae039), {
                className: style.uploadIcon
            })
        })
    });
}



var $jMaZ8 = parcelRequire("jMaZ8");


const $dd40d0b485b64a74$var$MAX_FILE_SIZE_IN_MIB = 15;
const $dd40d0b485b64a74$var$EXTENSIONS_ALLOWED = [
    "mp3",
    "ogg",
    "wav"
];
const $dd40d0b485b64a74$var$control = {
    size: (file)=>{
        if (!file.size) return false;
        const sizeInMiB = file.size / 1024 / 1024;
        return sizeInMiB <= $dd40d0b485b64a74$var$MAX_FILE_SIZE_IN_MIB;
    },
    extension: (file)=>{
        const strArr = file.name.split(".");
        const extension = strArr[strArr.length - 1];
        return $dd40d0b485b64a74$var$EXTENSIONS_ALLOWED.includes(extension);
    }
};
function $dd40d0b485b64a74$export$2e2bcd8739ae039({ setDefinitionAudioFile: setDefinitionAudioFile }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [isUploading, setIsUploading] = (0, $jMaZ8.useState)(false);
    const uploadFile = (0, $jMaZ8.useCallback)(async (definitionId, putUrl, filename, file)=>{
        if (!file?.name) {
            console.warn("uploadFile stopped, no file provided");
            return;
        }
        if (isUploading) {
            console.warn("uploadFile stopped, alread uploading");
            return;
        }
        // Control extension
        if (!$dd40d0b485b64a74$var$control.extension(file)) {
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                message: `${t("definitionAudioUploadErrorExtension")}: ${$dd40d0b485b64a74$var$EXTENSIONS_ALLOWED.join(", ")}`
            });
            return;
        }
        // Control size
        if (!$dd40d0b485b64a74$var$control.size(file)) {
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                message: `${t("definitionAudioUploadErrorSize")} ${$dd40d0b485b64a74$var$MAX_FILE_SIZE_IN_MIB} MB`
            });
            return;
        }
        // Upload the file
        try {
            setIsUploading(true);
            await fetch(putUrl, {
                method: "PUT",
                body: file.originFileObj
            });
            await setDefinitionAudioFile(definitionId, filename);
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).success({
                message: t("definitionAudioUploadSuccess")
            });
        } catch (e) {
            console.warn("useUploadFile error", e);
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                message: `${t("definitionAudioUploadError")}: ${e?.message || ""}`
            });
        } finally{
            setIsUploading(false);
        }
    }, [
        isUploading,
        setDefinitionAudioFile,
        t
    ]);
    return {
        uploadFile: uploadFile,
        isUploading: isUploading
    };
}



var $jMaZ8 = parcelRequire("jMaZ8");


function $adbda01c8a2d9f98$export$2e2bcd8739ae039({ setDefinitionAudioFile: setDefinitionAudioFile, microphone: microphone }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [isUploading, setIsUploading] = (0, $jMaZ8.useState)(false);
    const uploadRecordedFile = (0, $jMaZ8.useCallback)(async (definitionId, putUrl, filename)=>{
        try {
            setIsUploading(true);
            if (!microphone) return;
            microphone.stop().then(async (blob)=>{
                await fetch(putUrl, {
                    method: "PUT",
                    body: blob
                });
                await setDefinitionAudioFile(definitionId, filename);
            });
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).success({
                message: t("definitionRecordedAudioUploadSuccess")
            });
        } catch (e) {
            console.error("useUploadRecordedFile error", e);
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                message: `${t("definitionRecordedAudioUploadError")}: ${e?.message || ""}`
            });
        } finally{
            setIsUploading(false);
        }
    }, [
        microphone,
        setDefinitionAudioFile,
        t
    ]);
    return {
        uploadRecordedFile: uploadRecordedFile,
        isUploading: isUploading
    };
}





const $bd717038298ccdcf$var$defaultAsyncState = {
    loading: true,
    data: null,
    error: null
};
const $bd717038298ccdcf$var$useAsync = (promise)=>{
    const [state, setState] = (0, $jMaZ8.useState)($bd717038298ccdcf$var$defaultAsyncState);
    (0, $jMaZ8.useEffect)(()=>{
        setState($bd717038298ccdcf$var$defaultAsyncState);
        promise.then((data)=>setState((state)=>({
                    ...state,
                    data: data,
                    loading: false
                }))).catch((error)=>setState((state)=>({
                    ...state,
                    error: error,
                    loading: false
                })));
    }, [
        promise
    ]);
    return state;
};
const $bd717038298ccdcf$var$getMicrophone = async ()=>{
    const stream = await navigator.mediaDevices.getUserMedia({
        audio: true
    });
    const mediaRecorder = new MediaRecorder(stream);
    return {
        start: ()=>{
            mediaRecorder.start();
        },
        stop: ()=>{
            return new Promise((resolve, reject)=>{
                mediaRecorder.ondataavailable = (e)=>{
                    const blob = new Blob([
                        e.data
                    ], {
                        type: "audio/ogg; codecs=opus"
                    });
                    resolve(blob);
                };
                mediaRecorder.onerror = (e)=>{
                    reject(e);
                };
                mediaRecorder.stop();
            });
        }
    };
};
const $bd717038298ccdcf$var$DefinitionsRecording = ({ definitions: definitions, projectId: projectId, pageMetadata: pageMetadata })=>{
    const { error: error, loading: microphoneLoading, data: microphone } = $bd717038298ccdcf$var$useAsync((0, $jMaZ8.useMemo)($bd717038298ccdcf$var$getMicrophone, []));
    const [applyUpdateDefinition] = (0, $9fbd80a2d225d843$export$1df4105d6bb9fdbe)();
    const handleSetDefinitionAudioFile = (0, $jMaZ8.useCallback)(async (definitionId, filename)=>{
        const currentDefinition = definitions.find((d)=>d.data.id === definitionId);
        if (!currentDefinition) return;
        const currentStatus = currentDefinition.data.audioReviewStatus;
        applyUpdateDefinition({
            variables: {
                projectId: projectId,
                definitionId: definitionId,
                audioFile: filename,
                audioReviewStatus: currentStatus !== null ? (0, $b522cf181e75e62d$export$221b784fada1dd4a).RENARRATED : undefined,
                audioReviewComment: currentDefinition.data.audioReviewComment ?? "",
                description: currentDefinition.data.description ?? "",
                kind: currentDefinition.data.kind
            }
        });
    }, [
        applyUpdateDefinition,
        definitions,
        projectId
    ]);
    const { uploadRecordedFile: uploadRecordedFile, isUploading: isRecordingIsUploading } = (0, $adbda01c8a2d9f98$export$2e2bcd8739ae039)({
        setDefinitionAudioFile: handleSetDefinitionAudioFile,
        microphone: microphone
    });
    const { uploadFile: uploadFile, isUploading: isUploading } = (0, $dd40d0b485b64a74$export$2e2bcd8739ae039)({
        setDefinitionAudioFile: handleSetDefinitionAudioFile
    });
    if (error) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
        children: "Error - Could not get microphone"
    });
    if (microphoneLoading || !microphone) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
        children: "Please share your mike"
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $3dcb4ef3e10c6148$exports.definitions,
        children: definitions.map((definition)=>{
            const textDefinition = (0, $0b13d0bb8c94e6c6$export$fe634e6163c837a4)(definition, pageMetadata);
            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $3dcb4ef3e10c6148$exports.definitionWrapper,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $3dcb4ef3e10c6148$exports.definition,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $cf464d5afe8d4bad$export$2e2bcd8739ae039), {
                            filename: definition.data.audioFile,
                            definitionId: definition.data.id,
                            onPressStart: microphone.start,
                            onPressEnd: uploadRecordedFile,
                            loading: isRecordingIsUploading || isUploading,
                            audioReviewStatus: definition.data.audioReviewStatus,
                            audioReviewComment: definition.data.audioReviewComment,
                            children: `${textDefinition}: ${definition.data.description}`
                        }, definition.data.id)
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3c5738838d28db4a$export$2e2bcd8739ae039), {
                        definitionId: definition.data.id,
                        sendFile: uploadFile,
                        filename: definition.data.audioFile,
                        loading: isRecordingIsUploading || isUploading,
                        style: $3dcb4ef3e10c6148$exports
                    })
                ]
            }, definition.data.id);
        })
    });
};
var $bd717038298ccdcf$export$2e2bcd8739ae039 = $bd717038298ccdcf$var$DefinitionsRecording;



const $727abf2d5c541723$export$72f9ca7a3ec3fbb1 = ({ selectedRole: selectedRole, projectId: projectId, pageMetadata: pageMetadata })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    if (!pageMetadata) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {});
    const definitions = pageMetadata?.definition;
    const definitionsExceptImplicit = definitions.filter((d)=>d.data.kind !== (0, $b522cf181e75e62d$export$2b5d0c623adb8e14).IMPLICIT);
    if (definitionsExceptImplicit.length === 0) return null;
    const Component = selectedRole === (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Narrator ? (0, $bd717038298ccdcf$export$2e2bcd8739ae039) : (0, $0b13d0bb8c94e6c6$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h1", {
                children: t("definitions")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)(Component, {
                definitions: definitionsExceptImplicit,
                projectId: projectId,
                pageMetadata: pageMetadata
            })
        ]
    });
};




var $jMaZ8 = parcelRequire("jMaZ8");
var $270000ccc6a4c315$exports = {};
$270000ccc6a4c315$exports = JSON.parse("{\"settings\":{\"open\":false,\"echoCancellation\":true,\"noiseSuppression\":true,\"autoGainControl\":true,\"gainValue\":1,\"deviceId\":\"\",\"recordingDevices\":[]}}");


const $1a2eafac683bf600$export$467db5b0e535c7c7 = (state, key)=>{
    const item = localStorage.getItem(key);
    // console.log('Getting from local: ', state, key, item);
    return item ? JSON.parse(item) : state;
};
const $1a2eafac683bf600$export$39e405328955262f = (state, key)=>{
    // console.log('Saving to local: ', state, key);
    localStorage.setItem(key, JSON.stringify(state));
};



var $f0bcee3215553c55$export$2e2bcd8739ae039 = (state, { type: type, payload: payload, log: log = false })=>{
    switch(type){
        case "settings":
            {
                const finalState = {
                    ...state
                };
                finalState.settings = {
                    ...finalState.settings,
                    ...payload
                };
                (0, $1a2eafac683bf600$export$39e405328955262f)(finalState, (0, $a28ed92ce3433278$export$bc117d78095d5795));
                if (log) console.log("New state: ", finalState);
                return finalState;
            }
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};



const $a28ed92ce3433278$export$bc117d78095d5795 = "misc";
const $a28ed92ce3433278$var$MiscStateContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);
const $a28ed92ce3433278$var$MiscDispatchContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);
const $a28ed92ce3433278$export$6a0e37d37d3c52e1 = ({ children: children })=>{
    const [state, dispatch] = (0, $jMaZ8.useReducer)((0, $f0bcee3215553c55$export$2e2bcd8739ae039), (0, $1a2eafac683bf600$export$467db5b0e535c7c7)((0, (/*@__PURE__*/$parcel$interopDefault($270000ccc6a4c315$exports))), $a28ed92ce3433278$export$bc117d78095d5795));
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($a28ed92ce3433278$var$MiscStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($a28ed92ce3433278$var$MiscDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const $a28ed92ce3433278$export$cfefc721859a90dc = ()=>{
    const context = (0, $jMaZ8.useContext)($a28ed92ce3433278$var$MiscStateContext);
    if (context === undefined) throw new Error("useMiscState must be used within a MiscProvider");
    return context || (0, (/*@__PURE__*/$parcel$interopDefault($270000ccc6a4c315$exports)));
};
const $a28ed92ce3433278$export$ad60e1176d7e03c6 = ()=>{
    const context = (0, $jMaZ8.useContext)($a28ed92ce3433278$var$MiscDispatchContext);
    if (context === undefined) throw new Error("useMiscDispatch must be used within a MiscProvider");
    return context;
};







var $jMaZ8 = parcelRequire("jMaZ8");
var $221fa0e9c5426c27$exports = {};

$221fa0e9c5426c27$exports = (parcelRequire("dTWGV"));




var $jMaZ8 = parcelRequire("jMaZ8");
const $853afc9c866096af$var$audioAnalyzerContextObj = {
    errorMessage: undefined,
    setErrorMessage: ()=>{},
    selectedRheses: [],
    recordedRheses: [],
    updateRecordedRheses: ()=>{},
    clearRecordedRheses: ()=>{},
    sendRecordedRhesesToDatabase: ()=>{},
    uploadAudioFileToDatabase: async ()=>{}
};
const $853afc9c866096af$var$AudioAnalyzerContext = (0, $jMaZ8.createContext)($853afc9c866096af$var$audioAnalyzerContextObj);
var $853afc9c866096af$export$2e2bcd8739ae039 = $853afc9c866096af$var$AudioAnalyzerContext;



const $e8bb2b3cd09bc02a$export$c6ba9f5ab68498b1 = (0, $f013a28d70124837$export$72e4926bf8358653)`
  mutation addAudioRecording($addRecording: AddAudioRecording!) {
    addAudioRecording(addRecording: $addRecording)
  }
`;



const $ee48877aa300de5a$export$95e8c3fdd1a52149 = (setProjectPages, projectPages, setCurrentProjectPage, currentProjectPage, dataPages)=>{
    if (dataPages) {
        if (!currentProjectPage && !projectPages) {
            const pages = dataPages.sort((a, b)=>a.pageNumber - b.pageNumber);
            setProjectPages({
                pages: pages
            });
            setCurrentProjectPage(pages[0]);
        }
    } else throw new Error("Ce livre n'a aucune page.");
};




var $jMaZ8 = parcelRequire("jMaZ8");
var $afea19b0beb20f93$exports = {};
"use strict";
var $3bf9b99d2c309a2d$exports = {};
function $3bf9b99d2c309a2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$3bf9b99d2c309a2d$exports = $3bf9b99d2c309a2d$var$_interopRequireDefault;


Object.defineProperty($afea19b0beb20f93$exports, "__esModule", {
    value: !0
}), $afea19b0beb20f93$exports.default = $afea19b0beb20f93$var$getBlobDuration;

var $afea19b0beb20f93$var$_regenerator = $3bf9b99d2c309a2d$exports((parcelRequire("gwAXn")));

var $afea19b0beb20f93$var$_asyncToGenerator2 = $3bf9b99d2c309a2d$exports((parcelRequire("9R0na")));
function $afea19b0beb20f93$var$getBlobDuration(e) {
    return $afea19b0beb20f93$var$_getBlobDuration.apply(this, arguments);
}
function $afea19b0beb20f93$var$_getBlobDuration() {
    return ($afea19b0beb20f93$var$_getBlobDuration = (0, $afea19b0beb20f93$var$_asyncToGenerator2.default)($afea19b0beb20f93$var$_regenerator.default.mark(function e(r) {
        var t, n;
        return $afea19b0beb20f93$var$_regenerator.default.wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    return t = document.createElement("video"), n = new Promise(function(e, r) {
                        t.addEventListener("loadedmetadata", function() {
                            t.duration === 1 / 0 ? (t.currentTime = Number.MAX_SAFE_INTEGER, t.ontimeupdate = function() {
                                t.ontimeupdate = null, e(t.duration), t.currentTime = 0;
                            }) : e(t.duration);
                        }), t.onerror = function(e) {
                            return r(e.target.error);
                        };
                    }), t.src = "string" == typeof r || r instanceof String ? r : window.URL.createObjectURL(r), e.abrupt("return", n);
                case 4:
                case "end":
                    return e.stop();
            }
        }, e);
    }))).apply(this, arguments);
}




var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $47e6b16feaed2f2b$var$SettingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "setting",
    "theme": "outlined"
};
var $47e6b16feaed2f2b$export$2e2bcd8739ae039 = $47e6b16feaed2f2b$var$SettingOutlined;



var $2ef56a8cdfe789a0$var$SettingOutlined = function SettingOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $47e6b16feaed2f2b$export$2e2bcd8739ae039)
    }));
};
/**![setting](data:image/svg+xml;base64,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) */ var $2ef56a8cdfe789a0$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($2ef56a8cdfe789a0$var$SettingOutlined);
$2ef56a8cdfe789a0$var$RefIcon.displayName = 'SettingOutlined';
var $2ef56a8cdfe789a0$export$2e2bcd8739ae039 = $2ef56a8cdfe789a0$var$RefIcon;





var $9590818f8fc21bff$export$dc57ddd528b7443f;
var $9590818f8fc21bff$export$5be823818bca052c;
var $9590818f8fc21bff$export$9de69ea6e6df80dc;
var $9590818f8fc21bff$export$2fecd014fa08d1c5;
var $9590818f8fc21bff$export$ee523178d6343bbc;
var $9590818f8fc21bff$export$c6192015a54f3a84;
var $9590818f8fc21bff$export$eb2519434b38aa09;
var $9590818f8fc21bff$export$4caf0eb42dd80d92;
var $9590818f8fc21bff$export$cc74dcc53cfce4eb;
var $9590818f8fc21bff$export$2ba01fb71ed41cb6;
var $9590818f8fc21bff$export$4ededb8e5b56a6fb;
var $9590818f8fc21bff$export$1b277e29acf90a;
var $9590818f8fc21bff$export$bbea856fdb3e3c5f;
var $9590818f8fc21bff$export$2ce94baca1de8453;
$9590818f8fc21bff$export$dc57ddd528b7443f = "buttonContainer_ebbefc";
$9590818f8fc21bff$export$5be823818bca052c = "recorderInstructionContainer_ebbefc";
$9590818f8fc21bff$export$9de69ea6e6df80dc = "recorderInstruction_ebbefc";
$9590818f8fc21bff$export$2fecd014fa08d1c5 = "recorderContainer_ebbefc";
$9590818f8fc21bff$export$ee523178d6343bbc = "rowOne_ebbefc";
$9590818f8fc21bff$export$c6192015a54f3a84 = "recorderSwitchContainer_ebbefc";
$9590818f8fc21bff$export$eb2519434b38aa09 = "recorderSwitchContainerIcon_ebbefc";
$9590818f8fc21bff$export$4caf0eb42dd80d92 = "recordingArea_ebbefc";
$9590818f8fc21bff$export$cc74dcc53cfce4eb = "wrapper_ebbefc";
$9590818f8fc21bff$export$2ba01fb71ed41cb6 = "button_ebbefc";
$9590818f8fc21bff$export$4ededb8e5b56a6fb = "cancelButton_ebbefc";
$9590818f8fc21bff$export$1b277e29acf90a = "validationContainer_ebbefc";
$9590818f8fc21bff$export$bbea856fdb3e3c5f = "buttons_ebbefc";
$9590818f8fc21bff$export$2ce94baca1de8453 = "settingsButton_ebbefc";






var $jMaZ8 = parcelRequire("jMaZ8");


const $5354b6ba7e07deff$var$RecorderButton = ({ audioRecorderState: audioRecorderState, fileUploadMode: fileUploadMode, onClick: onClick, disabled: disabled })=>{
    const [recordButtonState, setRecordButtonState] = (0, $jMaZ8.useState)((0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).idle);
    (0, $jMaZ8.useEffect)(()=>{
        if (audioRecorderState === (0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).recording) setRecordButtonState((0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).recording);
        else if (audioRecorderState === (0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).idle) setRecordButtonState((0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).idle);
        return ()=>{};
    }, [
        audioRecorderState
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            recordButtonState === (0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).recording && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                style: {
                    height: "4em",
                    width: "4em",
                    padding: "1em"
                },
                disabled: disabled,
                onClick: onClick,
                shape: "circle",
                icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $16ef8f19fd336cbb$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: "4em"
                    }
                })
            }),
            recordButtonState === (0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).idle && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                style: {
                    height: "4em",
                    width: "4em",
                    padding: "1em"
                },
                disabled: disabled,
                onMouseUp: ()=>setTimeout(onClick, 50),
                shape: "circle",
                icon: fileUploadMode ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4d83eb74197459d9$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: "2em"
                    }
                }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6d91fa0144a5983b$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: "2em"
                    }
                })
            })
        ]
    });
};
var $5354b6ba7e07deff$export$2e2bcd8739ae039 = $5354b6ba7e07deff$var$RecorderButton;




var $jMaZ8 = parcelRequire("jMaZ8");


parcelRequire("jMaZ8");
const $67a2e4e677f8d0d2$export$f876267f05b9bab9 = ()=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        width: "12",
        height: "10",
        viewBox: "0 0 12 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M12 1.65625L4 9.65625L0.34375 6L1.28125 5.0625L4 7.78125L11.0625 0.71875L12 1.65625Z",
            fill: "#61C374"
        })
    });
};



var $f4273ef862629423$export$ed0593cc79980d38;
var $f4273ef862629423$export$8ea9144cd573b3e9;
$f4273ef862629423$export$ed0593cc79980d38 = "validationButtonText_c32987";
$f4273ef862629423$export$8ea9144cd573b3e9 = "validationButtonContainer_c32987";


const $fd09a81e02049569$export$c0b22b0d2837545a = ({ recordPaths: recordPaths, onStart: onStart = ()=>{}, onEnd: onEnd = ()=>{} })=>{
    const { sendRecordedRhesesToDatabase: sendRecordedRhesesToDatabase } = (0, $jMaZ8.useContext)((0, $853afc9c866096af$export$2e2bcd8739ae039));
    const handleClick = async ()=>{
        onStart();
        const recordPath = Array.isArray(recordPaths) ? recordPaths[recordPaths.length - 1] : recordPaths;
        let blob = await fetch(recordPath).then((result)=>result.blob());
        await sendRecordedRhesesToDatabase(blob);
        onEnd();
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            className: $f4273ef862629423$export$8ea9144cd573b3e9,
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    "data-testid": "validate-button",
                    className: $f4273ef862629423$export$ed0593cc79980d38,
                    children: "Valider l\u2019enregistrement"
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $67a2e4e677f8d0d2$export$f876267f05b9bab9), {})
            ]
        })
    });
};





var $jMaZ8 = parcelRequire("jMaZ8");

const $b16d8c466a1c2f3a$var$modifyGain = (stream, gainValue)=>{
    const ctx = new AudioContext();
    const src = ctx.createMediaStreamSource(stream);
    const dst = ctx.createMediaStreamDestination();
    const gainNode = ctx.createGain();
    gainNode.gain.value = gainValue;
    // @ts-ignore
    [
        src,
        gainNode,
        dst
    ].reduce((a, b)=>a && a.connect(b));
    return dst.stream;
};
const $b16d8c466a1c2f3a$export$75af6b43202b4fc9 = ()=>{
    const { settings: settings } = (0, $a28ed92ce3433278$export$cfefc721859a90dc)();
    const [isRecording, setIsRecording] = (0, $jMaZ8.useState)(false);
    const [stream, setStream] = (0, $jMaZ8.useState)();
    const [error, setError] = (0, $jMaZ8.useState)();
    const [recordingDevices, setRecordingDevices] = (0, $jMaZ8.useState)([]);
    const [mediaRecorder, setMediaRecorder] = (0, $jMaZ8.useState)();
    (0, $jMaZ8.useEffect)(()=>{
        (async function() {
            try {
                const mediaSettings = {
                    echoCancellation: settings?.echoCancellation || false,
                    noiseSuppression: settings?.noiseSuppression || false,
                    autoGainControl: settings?.autoGainControl || false,
                    deviceId: settings?.deviceId || undefined
                };
                const s = await navigator.mediaDevices.getUserMedia({
                    audio: mediaSettings
                });
                const devicesList = await navigator.mediaDevices.enumerateDevices();
                setRecordingDevices(devicesList);
                setStream(s);
            } catch (error) {
                setError(error);
            }
        })();
    }, [
        settings
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (stream) setMediaRecorder(new MediaRecorder($b16d8c466a1c2f3a$var$modifyGain(stream, settings?.gainValue || 1)));
    }, [
        stream,
        settings
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (!mediaRecorder) return;
        mediaRecorder.onstop = ()=>setIsRecording(false);
        return ()=>{
            mediaRecorder?.stream.getTracks().forEach((track)=>track.stop());
        };
    }, [
        mediaRecorder
    ]);
    const { start: start, stop: stop } = (0, $jMaZ8.useMemo)(()=>({
            start: ()=>{
                setIsRecording(true);
                mediaRecorder?.start();
            },
            stop: ()=>{
                setIsRecording(false);
                mediaRecorder?.stop();
            }
        }), [
        mediaRecorder
    ]);
    return {
        start: start,
        stop: stop,
        error: error,
        recorder: mediaRecorder,
        recordingDevices: recordingDevices,
        isRecording: isRecording
    };
};



const $48bc4a3fb3911b76$var$REGION_MIN_DURATION = 0.5;
var $48bc4a3fb3911b76$export$ae29a78eda7c4d2f = /*#__PURE__*/ function($48bc4a3fb3911b76$export$ae29a78eda7c4d2f) {
    $48bc4a3fb3911b76$export$ae29a78eda7c4d2f["idle"] = "idle";
    $48bc4a3fb3911b76$export$ae29a78eda7c4d2f["recording"] = "recording";
    $48bc4a3fb3911b76$export$ae29a78eda7c4d2f["playing"] = "playing";
    $48bc4a3fb3911b76$export$ae29a78eda7c4d2f["rhesesRecorder"] = "rhesesRecorder";
    return $48bc4a3fb3911b76$export$ae29a78eda7c4d2f;
}({});
const $48bc4a3fb3911b76$var$FILE_UPLOAD_MODE = "FILE_UPLOAD_MODE";
const $48bc4a3fb3911b76$var$modeStorage = {
    get: ()=>localStorage.getItem($48bc4a3fb3911b76$var$FILE_UPLOAD_MODE) === "true",
    set: (fileUploadMode)=>localStorage.setItem($48bc4a3fb3911b76$var$FILE_UPLOAD_MODE, fileUploadMode ? "true" : "false")
};
const $48bc4a3fb3911b76$var$AudioRecorder = ({ audioRecorderState: audioRecorderState, setAudioRecorderState: setAudioRecorderState, selectAllRheses: selectAllRheses, nextPage: nextPage, previousPage: previousPage })=>{
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage, selectedRheses: selectedRheses, updateRecordedRheses: updateRecordedRheses, recordedRheses: recordedRheses, clearRecordedRheses: clearRecordedRheses, uploadAudioFileToDatabase: uploadAudioFileToDatabase } = (0, $jMaZ8.useContext)((0, $853afc9c866096af$export$2e2bcd8739ae039));
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const { settings: settings } = (0, $a28ed92ce3433278$export$cfefc721859a90dc)();
    const miscDispatch = (0, $a28ed92ce3433278$export$ad60e1176d7e03c6)();
    const { isRecording: isRecording, stop: stop, start: start, recorder: recorder, recordingDevices: recordingDevices } = (0, $b16d8c466a1c2f3a$export$75af6b43202b4fc9)();
    const [uploadRef, setUploadRef] = (0, $jMaZ8.useState)(null);
    const [sendingToServer, setSendingToServer] = (0, $jMaZ8.useState)(false);
    const [recordPaths, setRecordPaths] = (0, $jMaZ8.useState)(undefined);
    const [isUploading, setIsUploading] = (0, $jMaZ8.useState)(false);
    const [fileUploadMode, setFileUploadMode] = (0, $jMaZ8.useState)($48bc4a3fb3911b76$var$modeStorage.get());
    (0, $jMaZ8.useEffect)(()=>{
        if (!recorder) return;
        recorder.ondataavailable = async (e)=>{
            const duration = await (0, (/*@__PURE__*/$parcel$interopDefault($afea19b0beb20f93$exports)))(e.data);
            const trackMinDuration = selectedRheses.length * $48bc4a3fb3911b76$var$REGION_MIN_DURATION;
            if (duration < trackMinDuration) {
                setErrorMessage(`La piste enregistr\xe9e doit durer au minimum ${trackMinDuration} secondes, or votre enregistrement dure ${(duration - 0.01).toFixed(2)} secondes.`);
                return;
            }
            // Add the current record to the records' list.
            // globalThis is not defined
            // eslint-disable-next-line no-undef
            setRecordPaths(globalThis.URL.createObjectURL(e.data));
            // If there is any previous error message
            if (!(0, $1abea94550147a73$export$dd1bc94b04021eeb)(errorMessage)) // Let's delete it.
            setErrorMessage(undefined);
            updateRecordedRheses();
        };
    });
    (0, $jMaZ8.useEffect)(()=>{
        if (fileUploadMode) selectAllRheses();
    }, [
        fileUploadMode,
        selectAllRheses
    ]);
    (0, $jMaZ8.useEffect)(()=>$48bc4a3fb3911b76$var$modeStorage.set(fileUploadMode), [
        fileUploadMode
    ]);
    const stopRecording = (0, $jMaZ8.useCallback)(()=>{
        stop();
    }, [
        stop
    ]);
    const onRecord = ()=>{
        if (isRecording) return stopRecording();
        if (isUploading) return;
        if (fileUploadMode.valueOf()) return uploadRef?.click();
        return start();
    };
    const playAudio = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!recordPaths) return;
        const audio = new Audio(recordPaths);
        audio.play();
    };
    const uploadFile = async (event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (!event.currentTarget.files?.[0]) return;
        var file = event.currentTarget.files[0];
        setIsUploading(true);
        try {
            await uploadAudioFileToDatabase(file, selectedRheses);
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).success({
                message: "le fichier audio a \xe9t\xe9 trait\xe9 avec succ\xe8s.",
                placement: "topRight"
            });
        } catch (error) {
            (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).error({
                message: "Error while uploading audio file",
                description: error?.toString() || "",
                placement: "topRight"
            });
            console.error("Error while uploading audio file - " + error);
        } finally{
            setIsUploading(false);
        }
    };
    (0, $jMaZ8.useEffect)(()=>{
        if (isRecording) setAudioRecorderState("recording");
        else if (recordedRheses.length > 0) setAudioRecorderState("rhesesRecorder");
        else setAudioRecorderState("idle");
        return ()=>{};
    }, [
        isRecording,
        recordedRheses,
        setAudioRecorderState
    ]);
    const handleCancel = ()=>{
        clearRecordedRheses();
        setRecordPaths(undefined);
        setAudioRecorderState("idle");
    };
    const onSettingsChange = (0, $jMaZ8.useCallback)(async (e)=>{
        if (typeof e === "string") {
            miscDispatch({
                type: "settings",
                payload: {
                    deviceId: e
                }
            });
            return;
        }
        switch(e?.target?.name){
            case "open":
                miscDispatch({
                    type: "settings",
                    payload: {
                        open: !settings?.open
                    }
                });
                break;
            case "gainValue":
                miscDispatch({
                    type: "settings",
                    payload: {
                        gainValue: parseFloat(e.target.value?.toString() || "1") / 10
                    }
                });
                break;
            case "echo":
                miscDispatch({
                    type: "settings",
                    payload: {
                        echoCancellation: !settings?.echoCancellation
                    }
                });
                break;
            case "noise":
                miscDispatch({
                    type: "settings",
                    payload: {
                        noiseSuppression: !settings?.noiseSuppression
                    }
                });
                break;
            case "gain":
                miscDispatch({
                    type: "settings",
                    payload: {
                        autoGainControl: !settings?.autoGainControl
                    }
                });
                break;
            default:
                console.log("Default: ", e);
                return;
        }
    }, [
        miscDispatch,
        settings
    ]);
    const handleSettingsModal = (0, $jMaZ8.useCallback)(()=>{
        onSettingsChange({
            target: {
                name: "open"
            }
        });
    }, [
        onSettingsChange
    ]);
    const onGainControlChange = (0, $jMaZ8.useCallback)((newValue)=>{
        onSettingsChange({
            target: {
                value: newValue,
                name: "gainValue"
            }
        });
    }, [
        onSettingsChange
    ]);
    const isValidatingRecording = audioRecorderState === "rhesesRecorder" && !sendingToServer;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
                open: settings?.open,
                closable: false,
                title: "Options audio",
                // onCancel={this.handleSettingsModal(false)}
                // cancelText="Annuler"
                footer: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        onClick: handleSettingsModal,
                        children: "Fermer"
                    }, "back")
                ],
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        height: 200,
                        justifyContent: "space-evenly",
                        paddingLeft: "2rem",
                        paddingRight: "2rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                            name: "echo",
                            checked: settings?.echoCancellation,
                            onClick: onSettingsChange,
                            children: t("recording.echoReduction")
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                            name: "noise",
                            checked: settings?.noiseSuppression,
                            onClick: onSettingsChange,
                            style: {
                                marginLeft: 0
                            },
                            children: t("recording.noiseCancelling")
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1e51c82e25088207$export$2e2bcd8739ae039), {
                            name: "gain",
                            checked: settings?.autoGainControl,
                            onClick: onSettingsChange,
                            style: {
                                marginLeft: 0
                            },
                            children: t("recording.automaticGainControl")
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                            style: {
                                fontStyle: "1.25rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    style: {
                                        marginBottom: "0.2rem",
                                        marginTop: "1rem"
                                    },
                                    children: "Gain"
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $bb290b37c61d241a$export$2e2bcd8739ae039), {
                                    min: 1,
                                    max: 10,
                                    value: settings?.gainValue && settings?.gainValue * 10 || 10,
                                    onChange: onGainControlChange
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                            style: {
                                fontStyle: "1.25rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                    style: {
                                        marginBottom: "0.2rem",
                                        marginTop: "1rem"
                                    },
                                    children: "Microphone"
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $71df08955277779f$export$2e2bcd8739ae039), {
                                    defaultValue: settings?.deviceId,
                                    onChange: onSettingsChange,
                                    style: {
                                        width: "100%"
                                    },
                                    children: recordingDevices?.[0]?.label ? recordingDevices?.map((d)=>{
                                        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $71df08955277779f$export$2e2bcd8739ae039).Option, {
                                            children: d.label
                                        }, d.label);
                                    }) : null
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $9590818f8fc21bff$export$cc74dcc53cfce4eb,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        className: $9590818f8fc21bff$export$2fecd014fa08d1c5,
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                className: $9590818f8fc21bff$export$c6192015a54f3a84,
                                children: [
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6d91fa0144a5983b$export$2e2bcd8739ae039), {
                                        className: $9590818f8fc21bff$export$eb2519434b38aa09
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b968d364906a5d60$export$2e2bcd8739ae039), {
                                        checked: fileUploadMode,
                                        onChange: (args)=>setFileUploadMode(args.valueOf()),
                                        size: "small" // TODO antd: only "small" allow the switch to display
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4d83eb74197459d9$export$2e2bcd8739ae039), {
                                        className: $9590818f8fc21bff$export$eb2519434b38aa09
                                    }),
                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                        className: $9590818f8fc21bff$export$2ce94baca1de8453,
                                        onClick: handleSettingsModal,
                                        icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2ef56a8cdfe789a0$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            !isValidatingRecording && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                disabled: !previousPage.canNavigate,
                                onClick: previousPage.navigate,
                                type: "primary",
                                shape: "circle",
                                icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d4dfb236e126b509$export$2e2bcd8739ae039), {}),
                                className: $9590818f8fc21bff$export$ee523178d6343bbc
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                className: $9590818f8fc21bff$export$4caf0eb42dd80d92.concat(" ", $9590818f8fc21bff$export$ee523178d6343bbc),
                                children: [
                                    sendingToServer && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $de3c5dab5cbf9179$export$7f7cbe89f1eacd2), {}),
                                    isValidatingRecording && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                        className: $9590818f8fc21bff$export$1b277e29acf90a,
                                        children: [
                                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                                                className: $9590818f8fc21bff$export$bbea856fdb3e3c5f,
                                                children: [
                                                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
                                                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                                                            className: $9590818f8fc21bff$export$4ededb8e5b56a6fb,
                                                            onClick: handleCancel,
                                                            children: t("cancel")
                                                        })
                                                    }),
                                                    recordPaths && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $fd09a81e02049569$export$c0b22b0d2837545a), {
                                                        recordPaths: recordPaths,
                                                        onStart: ()=>setSendingToServer(true),
                                                        onEnd: ()=>setSendingToServer(false)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("a", {
                                                href: "",
                                                onClick: playAudio,
                                                children: t("listenToTheRecording")
                                            })
                                        ]
                                    }),
                                    audioRecorderState !== "rhesesRecorder" && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5354b6ba7e07deff$export$2e2bcd8739ae039), {
                                        disabled: isUploading || selectedRheses.length === 0,
                                        audioRecorderState: audioRecorderState,
                                        fileUploadMode: fileUploadMode,
                                        onClick: onRecord
                                    })
                                ]
                            }),
                            !isValidatingRecording && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                disabled: !nextPage.canNavigate,
                                onClick: nextPage.navigate,
                                type: "primary",
                                shape: "circle",
                                icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $467563d24654b2cc$export$2e2bcd8739ae039), {}),
                                className: $9590818f8fc21bff$export$ee523178d6343bbc
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("input", {
                        type: "file",
                        id: "audioFile",
                        ref: (ref)=>setUploadRef(ref),
                        onChange: uploadFile,
                        style: {
                            display: "none"
                        },
                        accept: "audio/*"
                    })
                ]
            })
        ]
    });
};
var $48bc4a3fb3911b76$export$2e2bcd8739ae039 = $48bc4a3fb3911b76$var$AudioRecorder;





var $jMaZ8 = parcelRequire("jMaZ8");



var $jMaZ8 = parcelRequire("jMaZ8");
/**
 * @module LRUCache
 */ 
var $0yIMy = parcelRequire("0yIMy");
const $5659bd20b49379fb$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $5659bd20b49379fb$var$warned = new Set();
/* c8 ignore start */ const $5659bd20b49379fb$var$PROCESS = typeof $0yIMy === 'object' && !!$0yIMy ? $0yIMy : {};
/* c8 ignore start */ const $5659bd20b49379fb$var$emitWarning = (msg, type, code, fn)=>{
    typeof $5659bd20b49379fb$var$PROCESS.emitWarning === 'function' ? $5659bd20b49379fb$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $5659bd20b49379fb$var$AC = globalThis.AbortController;
let $5659bd20b49379fb$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $5659bd20b49379fb$var$AC === 'undefined') {
    //@ts-ignore
    $5659bd20b49379fb$var$AS = class AbortSignal {
        onabort;
        _onabort = [];
        reason;
        aborted = false;
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
    };
    //@ts-ignore
    $5659bd20b49379fb$var$AC = class AbortController {
        constructor(){
            warnACPolyfill();
        }
        signal = new $5659bd20b49379fb$var$AS();
        abort(reason) {
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            this.signal.onabort?.(reason);
        }
    };
    let printACPolyfillWarning = $5659bd20b49379fb$var$PROCESS.env?.LRU_CACHE_IGNORE_AC_WARNING !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $5659bd20b49379fb$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $5659bd20b49379fb$var$shouldWarn = (code)=>!$5659bd20b49379fb$var$warned.has(code);
const $5659bd20b49379fb$var$TYPE = Symbol('type');
const $5659bd20b49379fb$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $5659bd20b49379fb$var$getUintArray = (max)=>!$5659bd20b49379fb$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $5659bd20b49379fb$var$ZeroArray : null;
/* c8 ignore stop */ class $5659bd20b49379fb$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $5659bd20b49379fb$var$Stack {
    heap;
    length;
    // private constructor
    static #constructing = false;
    static create(max) {
        const HeapCls = $5659bd20b49379fb$var$getUintArray(max);
        if (!HeapCls) return [];
        $5659bd20b49379fb$var$Stack.#constructing = true;
        const s = new $5659bd20b49379fb$var$Stack(max, HeapCls);
        $5659bd20b49379fb$var$Stack.#constructing = false;
        return s;
    }
    constructor(max, HeapCls){
        /* c8 ignore start */ if (!$5659bd20b49379fb$var$Stack.#constructing) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
}
class $5659bd20b49379fb$export$182500e6725aad9a {
    // options that cannot be changed without disaster
    #max;
    #maxSize;
    #dispose;
    #disposeAfter;
    #fetchMethod;
    #memoMethod;
    /**
     * {@link LRUCache.OptionsBase.ttl}
     */ ttl;
    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ ttlResolution;
    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ ttlAutopurge;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ updateAgeOnGet;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ updateAgeOnHas;
    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ allowStale;
    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ noDisposeOnSet;
    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ noUpdateTTL;
    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ maxEntrySize;
    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ sizeCalculation;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ noDeleteOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ noDeleteOnStaleGet;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ allowStaleOnFetchAbort;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ allowStaleOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ ignoreFetchAbort;
    // computed properties
    #size;
    #calculatedSize;
    #keyMap;
    #keyList;
    #valList;
    #next;
    #prev;
    #head;
    #tail;
    #free;
    #disposed;
    #sizes;
    #starts;
    #ttls;
    #hasDispose;
    #hasFetchMethod;
    #hasDisposeAfter;
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: c.#starts,
            ttls: c.#ttls,
            sizes: c.#sizes,
            keyMap: c.#keyMap,
            keyList: c.#keyList,
            valList: c.#valList,
            next: c.#next,
            prev: c.#prev,
            get head () {
                return c.#head;
            },
            get tail () {
                return c.#tail;
            },
            free: c.#free,
            // methods
            isBackgroundFetch: (p)=>c.#isBackgroundFetch(p),
            backgroundFetch: (k, index, options, context)=>c.#backgroundFetch(k, index, options, context),
            moveToTail: (index)=>c.#moveToTail(index),
            indexes: (options)=>c.#indexes(options),
            rindexes: (options)=>c.#rindexes(options),
            isStale: (index)=>c.#isStale(index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return this.#max;
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return this.#maxSize;
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return this.#calculatedSize;
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return this.#size;
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return this.#fetchMethod;
    }
    get memoMethod() {
        return this.#memoMethod;
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return this.#dispose;
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return this.#disposeAfter;
    }
    constructor(options){
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$5659bd20b49379fb$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $5659bd20b49379fb$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        this.#max = max;
        this.#maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.#maxSize;
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!this.#maxSize && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        this.#memoMethod = memoMethod;
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        this.#fetchMethod = fetchMethod;
        this.#hasFetchMethod = !!fetchMethod;
        this.#keyMap = new Map();
        this.#keyList = new Array(max).fill(undefined);
        this.#valList = new Array(max).fill(undefined);
        this.#next = new UintArray(max);
        this.#prev = new UintArray(max);
        this.#head = 0;
        this.#tail = 0;
        this.#free = $5659bd20b49379fb$var$Stack.create(max);
        this.#size = 0;
        this.#calculatedSize = 0;
        if (typeof dispose === 'function') this.#dispose = dispose;
        if (typeof disposeAfter === 'function') {
            this.#disposeAfter = disposeAfter;
            this.#disposed = [];
        } else {
            this.#disposeAfter = undefined;
            this.#disposed = undefined;
        }
        this.#hasDispose = !!this.#dispose;
        this.#hasDisposeAfter = !!this.#disposeAfter;
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.#maxSize !== 0) {
                if (!$5659bd20b49379fb$var$isPosInt(this.#maxSize)) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$5659bd20b49379fb$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            this.#initializeSizeTracking();
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $5659bd20b49379fb$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$5659bd20b49379fb$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            this.#initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.#max === 0 && this.ttl === 0 && this.#maxSize === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !this.#max && !this.#maxSize) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($5659bd20b49379fb$var$shouldWarn(code)) {
                $5659bd20b49379fb$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $5659bd20b49379fb$var$emitWarning(msg, 'UnboundedCacheWarning', code, $5659bd20b49379fb$export$182500e6725aad9a);
            }
        }
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return this.#keyMap.has(key) ? Infinity : 0;
    }
    #initializeTTLTracking() {
        const ttls = new $5659bd20b49379fb$var$ZeroArray(this.#max);
        const starts = new $5659bd20b49379fb$var$ZeroArray(this.#max);
        this.#ttls = ttls;
        this.#starts = starts;
        this.#setItemTTL = (index, ttl, start = $5659bd20b49379fb$var$perf.now())=>{
            starts[index] = ttl !== 0 ? start : 0;
            ttls[index] = ttl;
            if (ttl !== 0 && this.ttlAutopurge) {
                const t = setTimeout(()=>{
                    if (this.#isStale(index)) this.#delete(this.#keyList[index], 'expire');
                }, ttl + 1);
                // unref() not supported on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
        };
        this.#updateItemAge = (index)=>{
            starts[index] = ttls[index] !== 0 ? $5659bd20b49379fb$var$perf.now() : 0;
        };
        this.#statusTTL = (status, index)=>{
            if (ttls[index]) {
                const ttl = ttls[index];
                const start = starts[index];
                /* c8 ignore next */ if (!ttl || !start) return;
                status.ttl = ttl;
                status.start = start;
                status.now = cachedNow || getNow();
                const age = status.now - start;
                status.remainingTTL = ttl - age;
            }
        };
        // debounce calls to perf.now() to 1s so we're not hitting
        // that costly call repeatedly.
        let cachedNow = 0;
        const getNow = ()=>{
            const n = $5659bd20b49379fb$var$perf.now();
            if (this.ttlResolution > 0) {
                cachedNow = n;
                const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
                // not available on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
            return n;
        };
        this.getRemainingTTL = (key)=>{
            const index = this.#keyMap.get(key);
            if (index === undefined) return 0;
            const ttl = ttls[index];
            const start = starts[index];
            if (!ttl || !start) return Infinity;
            const age = (cachedNow || getNow()) - start;
            return ttl - age;
        };
        this.#isStale = (index)=>{
            const s = starts[index];
            const t = ttls[index];
            return !!t && !!s && (cachedNow || getNow()) - s > t;
        };
    }
    // conditionally set private methods related to TTL
    #updateItemAge = ()=>{};
    #statusTTL = ()=>{};
    #setItemTTL = ()=>{};
    /* c8 ignore stop */ #isStale = ()=>false;
    #initializeSizeTracking() {
        const sizes = new $5659bd20b49379fb$var$ZeroArray(this.#max);
        this.#calculatedSize = 0;
        this.#sizes = sizes;
        this.#removeItemSize = (index)=>{
            this.#calculatedSize -= sizes[index];
            sizes[index] = 0;
        };
        this.#requireSize = (k, v, size, sizeCalculation)=>{
            // provisionally accept background fetches.
            // actual value size will be checked when they return.
            if (this.#isBackgroundFetch(v)) return 0;
            if (!$5659bd20b49379fb$var$isPosInt(size)) {
                if (sizeCalculation) {
                    if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                    size = sizeCalculation(v, k);
                    if (!$5659bd20b49379fb$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
                } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
            }
            return size;
        };
        this.#addItemSize = (index, size, status)=>{
            sizes[index] = size;
            if (this.#maxSize) {
                const maxSize = this.#maxSize - sizes[index];
                while(this.#calculatedSize > maxSize)this.#evict(true);
            }
            this.#calculatedSize += sizes[index];
            if (status) {
                status.entrySize = size;
                status.totalCalculatedSize = this.#calculatedSize;
            }
        };
    }
    #removeItemSize = (_i)=>{};
    #addItemSize = (_i, _s, _st)=>{};
    #requireSize = (_k, _v, size, sizeCalculation)=>{
        if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
        return 0;
    };
    *#indexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#tail;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#head) break;
            else i = this.#prev[i];
        }
    }
    *#rindexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#head;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#tail) break;
            else i = this.#next[i];
        }
    }
    #isValidIndex(index) {
        return index !== undefined && this.#keyMap.get(this.#keyList[index]) === index;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of this.#indexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of this.#rindexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of this.#indexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of this.#rindexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ [Symbol.toStringTag] = 'LRUCache';
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, this.#keyList[i], this)) return this.get(this.#keyList[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of this.#rindexes({
            allowStale: true
        }))if (this.#isStale(i)) {
            this.#delete(this.#keyList[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = this.#keyMap.get(key);
        if (i === undefined) return undefined;
        const v = this.#valList[i];
        const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if (this.#ttls && this.#starts) {
            const ttl = this.#ttls[i];
            const start = this.#starts[i];
            if (ttl && start) {
                const remain = ttl - ($5659bd20b49379fb$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if (this.#sizes) entry.size = this.#sizes[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of this.#indexes({
            allowStale: true
        })){
            const key = this.#keyList[i];
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if (this.#ttls && this.#starts) {
                entry.ttl = this.#ttls[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $5659bd20b49379fb$var$perf.now() - this.#starts[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if (this.#sizes) entry.size = this.#sizes[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $5659bd20b49379fb$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = this.#requireSize(k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            this.#delete(k, 'set');
            return this;
        }
        let index = this.#size === 0 ? undefined : this.#keyMap.get(k);
        if (index === undefined) {
            // addition
            index = this.#size === 0 ? this.#tail : this.#free.length !== 0 ? this.#free.pop() : this.#size === this.#max ? this.#evict(false) : this.#size;
            this.#keyList[index] = k;
            this.#valList[index] = v;
            this.#keyMap.set(k, index);
            this.#next[this.#tail] = index;
            this.#prev[index] = this.#tail;
            this.#tail = index;
            this.#size++;
            this.#addItemSize(index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            this.#moveToTail(index);
            const oldVal = this.#valList[index];
            if (v !== oldVal) {
                if (this.#hasFetchMethod && this.#isBackgroundFetch(oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        if (this.#hasDispose) this.#dispose?.(s, k, 'set');
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    if (this.#hasDispose) this.#dispose?.(oldVal, k, 'set');
                    if (this.#hasDisposeAfter) this.#disposed?.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                this.#removeItemSize(index);
                this.#addItemSize(index, size, status);
                this.#valList[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && this.#isBackgroundFetch(oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !this.#ttls) this.#initializeTTLTracking();
        if (this.#ttls) {
            if (!noUpdateTTL) this.#setItemTTL(index, ttl, start);
            if (status) this.#statusTTL(status, index);
        }
        if (!noDisposeOnSet && this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        try {
            while(this.#size){
                const val = this.#valList[this.#head];
                this.#evict(true);
                if (this.#isBackgroundFetch(val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if (this.#hasDisposeAfter && this.#disposed) {
                const dt = this.#disposed;
                let task;
                while(task = dt?.shift())this.#disposeAfter?.(...task);
            }
        }
    }
    #evict(free) {
        const head = this.#head;
        const k = this.#keyList[head];
        const v = this.#valList[head];
        if (this.#hasFetchMethod && this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('evicted'));
        else if (this.#hasDispose || this.#hasDisposeAfter) {
            if (this.#hasDispose) this.#dispose?.(v, k, 'evict');
            if (this.#hasDisposeAfter) this.#disposed?.push([
                v,
                k,
                'evict'
            ]);
        }
        this.#removeItemSize(head);
        // if we aren't about to use the index, then null these out
        if (free) {
            this.#keyList[head] = undefined;
            this.#valList[head] = undefined;
            this.#free.push(head);
        }
        if (this.#size === 1) {
            this.#head = this.#tail = 0;
            this.#free.length = 0;
        } else this.#head = this.#next[head];
        this.#keyMap.delete(k);
        this.#size--;
        return head;
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v) && v.__staleWhileFetching === undefined) return false;
            if (!this.#isStale(index)) {
                if (updateAgeOnHas) this.#updateItemAge(index);
                if (status) {
                    status.has = 'hit';
                    this.#statusTTL(status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                this.#statusTTL(status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = this.#keyMap.get(k);
        if (index === undefined || !allowStale && this.#isStale(index)) return;
        const v = this.#valList[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
    }
    #backgroundFetch(k, index, options, context) {
        const v = index === undefined ? undefined : this.#valList[index];
        if (this.#isBackgroundFetch(v)) return v;
        const ac = new $5659bd20b49379fb$var$AC();
        const { signal: signal } = options;
        // when/if our AC signals, then stop listening to theirs.
        signal?.addEventListener('abort', ()=>ac.abort(signal.reason), {
            signal: ac.signal
        });
        const fetchOpts = {
            signal: ac.signal,
            options: options,
            context: context
        };
        const cb = (v, updateCache = false)=>{
            const { aborted: aborted } = ac.signal;
            const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
            if (options.status) {
                if (aborted && !updateCache) {
                    options.status.fetchAborted = true;
                    options.status.fetchError = ac.signal.reason;
                    if (ignoreAbort) options.status.fetchAbortIgnored = true;
                } else options.status.fetchResolved = true;
            }
            if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
            // either we didn't abort, and are still here, or we did, and ignored
            const bf = p;
            if (this.#valList[index] === p) {
                if (v === undefined) {
                    if (bf.__staleWhileFetching) this.#valList[index] = bf.__staleWhileFetching;
                    else this.#delete(k, 'fetch');
                } else {
                    if (options.status) options.status.fetchUpdated = true;
                    this.set(k, v, fetchOpts.options);
                }
            }
            return v;
        };
        const eb = (er)=>{
            if (options.status) {
                options.status.fetchRejected = true;
                options.status.fetchError = er;
            }
            return fetchFail(er);
        };
        const fetchFail = (er)=>{
            const { aborted: aborted } = ac.signal;
            const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
            const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
            const noDelete = allowStale || options.noDeleteOnFetchRejection;
            const bf = p;
            if (this.#valList[index] === p) {
                // if we allow stale on fetch rejections, then we need to ensure that
                // the stale value is not removed from the cache when the fetch fails.
                const del = !noDelete || bf.__staleWhileFetching === undefined;
                if (del) this.#delete(k, 'fetch');
                else if (!allowStaleAborted) // still replace the *promise* with the stale value,
                // since we are done with the promise at this point.
                // leave it untouched if we're still waiting for an
                // aborted background fetch that hasn't yet returned.
                this.#valList[index] = bf.__staleWhileFetching;
            }
            if (allowStale) {
                if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
                return bf.__staleWhileFetching;
            } else if (bf.__returned === bf) throw er;
        };
        const pcall = (res, rej)=>{
            const fmp = this.#fetchMethod?.(k, v, fetchOpts);
            if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
            // ignored, we go until we finish, regardless.
            // defer check until we are actually aborting,
            // so fetchMethod can override.
            ac.signal.addEventListener('abort', ()=>{
                if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                    res(undefined);
                    // when it eventually resolves, update the cache.
                    if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
                }
            });
        };
        if (options.status) options.status.fetchDispatched = true;
        const p = new Promise(pcall).then(cb, eb);
        const bf = Object.assign(p, {
            __abortController: ac,
            __staleWhileFetching: v,
            __returned: undefined
        });
        if (index === undefined) {
            // internal, don't expose status.
            this.set(k, bf, {
                ...fetchOpts.options,
                status: undefined
            });
            index = this.#keyMap.get(k);
        } else this.#valList[index] = bf;
        return bf;
    }
    #isBackgroundFetch(p) {
        if (!this.#hasFetchMethod) return false;
        const b = p;
        return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $5659bd20b49379fb$var$AC;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!this.#hasFetchMethod) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = this.#keyMap.get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = this.#backgroundFetch(k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = this.#isStale(index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                if (status) this.#statusTTL(status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = this.#backgroundFetch(k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = this.#memoMethod;
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh, ...options } = memoOptions;
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const value = this.#valList[index];
            const fetching = this.#isBackgroundFetch(value);
            if (status) this.#statusTTL(status, index);
            if (this.#isStale(index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) this.#delete(k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    #connect(p, n) {
        this.#prev[n] = p;
        this.#next[p] = n;
    }
    #moveToTail(index) {
        // if tail already, nothing to do
        // if head, move head to next[index]
        // else
        //   move next[prev[index]] to next[index] (head has no prev)
        //   move prev[next[index]] to prev[index]
        // prev[index] = tail
        // next[tail] = index
        // tail = index
        if (index !== this.#tail) {
            if (index === this.#head) this.#head = this.#next[index];
            else this.#connect(this.#prev[index], this.#next[index]);
            this.#connect(this.#tail, index);
            this.#tail = index;
        }
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return this.#delete(k, 'delete');
    }
    #delete(k, reason) {
        let deleted = false;
        if (this.#size !== 0) {
            const index = this.#keyMap.get(k);
            if (index !== undefined) {
                deleted = true;
                if (this.#size === 1) this.#clear(reason);
                else {
                    this.#removeItemSize(index);
                    const v = this.#valList[index];
                    if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
                    else if (this.#hasDispose || this.#hasDisposeAfter) {
                        if (this.#hasDispose) this.#dispose?.(v, k, reason);
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            v,
                            k,
                            reason
                        ]);
                    }
                    this.#keyMap.delete(k);
                    this.#keyList[index] = undefined;
                    this.#valList[index] = undefined;
                    if (index === this.#tail) this.#tail = this.#prev[index];
                    else if (index === this.#head) this.#head = this.#next[index];
                    else {
                        const pi = this.#prev[index];
                        this.#next[pi] = this.#next[index];
                        const ni = this.#next[index];
                        this.#prev[ni] = this.#prev[index];
                    }
                    this.#size--;
                    this.#free.push(index);
                }
            }
        }
        if (this.#hasDisposeAfter && this.#disposed?.length) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return deleted;
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return this.#clear('delete');
    }
    #clear(reason) {
        for (const index of this.#rindexes({
            allowStale: true
        })){
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
            else {
                const k = this.#keyList[index];
                if (this.#hasDispose) this.#dispose?.(v, k, reason);
                if (this.#hasDisposeAfter) this.#disposed?.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
        this.#keyMap.clear();
        this.#valList.fill(undefined);
        this.#keyList.fill(undefined);
        if (this.#ttls && this.#starts) {
            this.#ttls.fill(0);
            this.#starts.fill(0);
        }
        if (this.#sizes) this.#sizes.fill(0);
        this.#head = 0;
        this.#tail = 0;
        this.#free.length = 0;
        this.#calculatedSize = 0;
        this.#size = 0;
        if (this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
    }
}








var $62LIg = parcelRequire("62LIg");
const $8ca13888d5d57880$export$50488aa19a0f9066 = (audioRhese, round)=>{
    if (!audioRhese) return {
        duration: 0,
        start: null,
        end: null,
        startOffset: null,
        endOffset: null,
        isCropped: false
    };
    let { start: start, end: end } = audioRhese.data.audioInfo || {};
    const { humanStart: humanStart, humanEnd: humanEnd } = audioRhese.data.audioInfo || {};
    const hasHumanStart = (0, $62LIg.isNumber)(humanStart);
    const hasHumanEnd = (0, $62LIg.isNumber)(humanEnd);
    if (hasHumanStart) start = humanStart;
    if (hasHumanEnd) end = humanEnd;
    if (!(0, $62LIg.isNumber)(start) || !(0, $62LIg.isNumber)(end)) return {
        duration: 0,
        start: null,
        end: null,
        startOffset: null,
        endOffset: null,
        isCropped: false
    };
    // If the audio is cropped
    if (hasHumanStart || hasHumanEnd) {
        let startOffset = null;
        let endOffset = null;
        let duration = 0;
        // Determine startOffset
        if (hasHumanStart) startOffset = (0, $1abea94550147a73$export$360dc50351b2b778)(humanStart - start, 2);
        // Determine endOffset
        if (hasHumanEnd) endOffset = (0, $1abea94550147a73$export$360dc50351b2b778)(humanEnd - end, 2);
        // Determine duration
        if (hasHumanStart && hasHumanEnd) duration = humanEnd - humanStart;
        else if (!hasHumanEnd && hasHumanStart) duration = end - humanStart;
        else if (hasHumanEnd) duration = humanEnd - start;
        return {
            duration: (0, $1abea94550147a73$export$360dc50351b2b778)(duration, 2),
            start: (0, $1abea94550147a73$export$360dc50351b2b778)(start, 2),
            end: (0, $1abea94550147a73$export$360dc50351b2b778)(end, 2),
            startOffset: startOffset,
            endOffset: endOffset,
            isCropped: true
        };
    } else {
        const duration = end - start;
        return {
            duration: round ? (0, $1abea94550147a73$export$360dc50351b2b778)(duration, round) : duration,
            start: (0, $1abea94550147a73$export$360dc50351b2b778)(start, 2),
            end: (0, $1abea94550147a73$export$360dc50351b2b778)(end, 2),
            startOffset: null,
            endOffset: null,
            isCropped: false
        };
    }
};
const $8ca13888d5d57880$export$694f1528163076f2 = (audioInfo)=>{
    if (!audioInfo) return false;
    return audioInfo?.humanStart !== -1 && audioInfo?.humanStart !== null && audioInfo?.humanStart !== undefined;
};
const $8ca13888d5d57880$export$e06df784e30438a7 = (audioInfo)=>{
    if (!audioInfo) return false;
    return audioInfo?.humanEnd !== -1 && audioInfo?.humanEnd !== null && audioInfo?.humanStart !== undefined;
};


const $da283d5b98d33135$export$b1cbf64eeaa0d47e = (currentRheseId, rhesesWithRecording, loadedFiles)=>{
    const recording = rhesesWithRecording.find((r)=>r.data.id === currentRheseId).data.audioRecording;
    if (!recording) throw new Error("No recording found");
    return loadedFiles.find((file)=>file.filename === recording.fileUuid).url;
};
const $da283d5b98d33135$export$363751161ac18838 = (audioRheseData)=>{
    if (!audioRheseData) return [
        0,
        0
    ];
    const start = (0, $8ca13888d5d57880$export$694f1528163076f2)(audioRheseData) ? audioRheseData.humanStart : audioRheseData.start;
    const end = (0, $8ca13888d5d57880$export$e06df784e30438a7)(audioRheseData) ? audioRheseData.humanEnd : audioRheseData.end;
    const realStart = start ? (0, $1abea94550147a73$export$360dc50351b2b778)(start, 2) : 0;
    const realEnd = end ? (0, $1abea94550147a73$export$360dc50351b2b778)(end, 2) : 0;
    return [
        realStart,
        realEnd
    ];
};


const $7daea8149cc7f006$var$audioCtx = new AudioContext();
const $7daea8149cc7f006$var$gainNode = $7daea8149cc7f006$var$audioCtx.createGain();
$7daea8149cc7f006$var$gainNode.connect($7daea8149cc7f006$var$audioCtx.destination);
const $7daea8149cc7f006$var$audioCache = new (0, $5659bd20b49379fb$export$182500e6725aad9a)({
    max: 50
});
const $7daea8149cc7f006$var$presignCache = new (0, $5659bd20b49379fb$export$182500e6725aad9a)({
    max: 15
});
const $7daea8149cc7f006$export$885f104b8ec14062 = ({ rhese: rhese })=>{
    const fileUuid = rhese.data.audioRecording?.fileUuid;
    const [getData] = (0, $6aa6af800883504c$export$fd83eea6ecd2d8fa)((0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea), {
        variables: {
            filename: rhese.data.audioRecording?.fileUuid
        },
        fetchPolicy: "cache-and-network"
    });
    const [presignedUrl, setPresignedUrl] = (0, $jMaZ8.useState)(undefined);
    (0, $jMaZ8.useEffect)(()=>{
        if (!fileUuid) return;
        if ($7daea8149cc7f006$var$presignCache.get(fileUuid) !== undefined) {
            setPresignedUrl($7daea8149cc7f006$var$presignCache.get(fileUuid));
            return;
        }
        const future = $7daea8149cc7f006$var$presignCache.set(fileUuid, getData().then(({ data: data })=>data?.audioRecording.presignedUrl.getUrl)).get(fileUuid);
        setPresignedUrl(future);
    }, [
        fileUuid,
        getData
    ]);
    const isContentAdmin = (0, $dc10a25720c6edc8$export$1b39bc9d16fffc4d)();
    const [isPlaying, setIsPlaying] = (0, $jMaZ8.useState)(false);
    const handleClick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const [start, end] = (0, $da283d5b98d33135$export$363751161ac18838)(rhese.data.audioInfo);
        if (typeof end !== "number" || typeof start !== "number") return;
        if (isPlaying) return;
        if (!fileUuid) return;
        const presignedGetUrl = await presignedUrl;
        if (!presignedGetUrl) return;
        $7daea8149cc7f006$var$gainNode.gain.setValueAtTime(0.3, $7daea8149cc7f006$var$audioCtx.currentTime);
        if (!$7daea8149cc7f006$var$audioCache.has(fileUuid)) {
            const resp = await fetch(presignedGetUrl, {
                mode: "cors"
            });
            const buffer = await $7daea8149cc7f006$var$audioCtx.decodeAudioData(await resp.arrayBuffer());
            $7daea8149cc7f006$var$audioCache.set(fileUuid, buffer);
        }
        const audioSource = $7daea8149cc7f006$var$audioCtx.createBufferSource();
        audioSource.connect($7daea8149cc7f006$var$gainNode);
        audioSource.buffer = $7daea8149cc7f006$var$audioCache.get(fileUuid);
        audioSource.start($7daea8149cc7f006$var$audioCtx.currentTime, start, end - start);
        audioSource.onended = ()=>{
            setIsPlaying(false);
        };
        $7daea8149cc7f006$var$gainNode.gain.exponentialRampToValueAtTime(1, $7daea8149cc7f006$var$audioCtx.currentTime + 0.2);
    };
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $692b578090014f71$export$a0a862a22f0658d6), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            children: [
                isContentAdmin && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                    style: {
                        color: rhese.data.audioInfo?.speechConfidence > 0.8 ? "#61c374" : rhese.data.audioInfo?.speechConfidence < 0.5 ? "#e33636" : "#e66525",
                        fontSize: "18px",
                        verticalAlign: "2px",
                        marginRight: "15px"
                    },
                    children: [
                        "Reco: ",
                        rhese.data.audioInfo?.speechConfidence?.toFixed(2)
                    ]
                }),
                isContentAdmin && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("span", {
                    style: {
                        color: rhese.data.audioInfo?.confidence > 0.8 ? "#61c374" : rhese.data.audioInfo?.confidence < 0.5 ? "#e33636" : "#e66525",
                        fontSize: "18px",
                        verticalAlign: "2px",
                        marginRight: "5px"
                    },
                    children: [
                        "Match: ",
                        rhese.data.audioInfo?.confidence?.toFixed(2)
                    ]
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
                    onClick: handleClick,
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
                        d: "M12.9844 6H9.98438V11.4844C9.98438 12.1719 9.73438 12.7656 9.23438 13.2656C8.76562 13.7656 8.1875 14.0156 7.5 14.0156C6.8125 14.0156 6.21875 13.7656 5.71875 13.2656C5.25 12.7656 5.01562 12.1719 5.01562 11.4844C5.01562 10.7969 5.25 10.2188 5.71875 9.75C6.21875 9.25 6.8125 9 7.5 9C8.0625 9 8.5625 9.17188 9 9.51562V3.98438H12.9844V6ZM15.9844 0H2.01562C1.45312 0 0.96875 0.203125 0.5625 0.609375C0.1875 0.984375 0 1.45312 0 2.01562V15.9844C0 16.5469 0.1875 17.0312 0.5625 17.4375C0.96875 17.8125 1.45312 18 2.01562 18H15.9844C16.5469 18 17.0156 17.8125 17.3906 17.4375C17.7969 17.0312 18 16.5469 18 15.9844V2.01562C18 1.45312 17.7969 0.984375 17.3906 0.609375C17.0156 0.203125 16.5469 0 15.9844 0Z",
                        fill: "#6AA5EB"
                    })
                })
            ]
        })
    });
};


var $9bb06851955bb570$export$9aba72b49859255a;
var $9bb06851955bb570$export$d89dc70d9d82cb3b;
var $9bb06851955bb570$export$659b05ac803be9ff;
var $9bb06851955bb570$export$41371ff1e2e74fbb;
var $9bb06851955bb570$export$be69ea624d82a314;
var $9bb06851955bb570$export$864af25a7f7e70fe;
var $9bb06851955bb570$export$b2cc475f39b4b522;
var $9bb06851955bb570$export$5e2f617ae845fb63;
var $9bb06851955bb570$export$ce5d78961483d611;
$9bb06851955bb570$export$9aba72b49859255a = "rheseRoot_9e3ba8";
$9bb06851955bb570$export$d89dc70d9d82cb3b = "rheseContainer_9e3ba8";
$9bb06851955bb570$export$659b05ac803be9ff = "rheseWhite_9e3ba8";
$9bb06851955bb570$export$41371ff1e2e74fbb = "rheseGrey_9e3ba8";
$9bb06851955bb570$export$be69ea624d82a314 = "checkboxContainer_9e3ba8";
$9bb06851955bb570$export$864af25a7f7e70fe = "rhese_9e3ba8";
$9bb06851955bb570$export$b2cc475f39b4b522 = "selectedIcon_9e3ba8";
$9bb06851955bb570$export$5e2f617ae845fb63 = "selectionStart_9e3ba8";
$9bb06851955bb570$export$ce5d78961483d611 = "iconIgnoredFromSynchro_9e3ba8";




var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $1103f585913812da$var$ApiOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 01-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z"
                }
            }
        ]
    },
    "name": "api",
    "theme": "outlined"
};
var $1103f585913812da$export$2e2bcd8739ae039 = $1103f585913812da$var$ApiOutlined;



var $3188cd1e60a390d5$var$ApiOutlined = function ApiOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $1103f585913812da$export$2e2bcd8739ae039)
    }));
};
/**![api](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxNy43IDE0OC44bC00Mi40LTQyLjRjLTEuNi0xLjYtMy42LTIuMy01LjctMi4zcy00LjEuOC01LjcgMi4zbC03Ni4xIDc2LjFhMTk5LjI3IDE5OS4yNyAwIDAwLTExMi4xLTM0LjNjLTUxLjIgMC0xMDIuNCAxOS41LTE0MS41IDU4LjZMNDMyLjMgMzA4LjdhOC4wMyA4LjAzIDAgMDAwIDExLjNMNzA0IDU5MS43YzEuNiAxLjYgMy42IDIuMyA1LjcgMi4zIDIgMCA0LjEtLjggNS43LTIuM2wxMDEuOS0xMDEuOWM2OC45LTY5IDc3LTE3NS43IDI0LjMtMjUzLjVsNzYuMS03Ni4xYzMuMS0zLjIgMy4xLTguMyAwLTExLjR6TTc2OS4xIDQ0MS43bC01OS40IDU5LjQtMTg2LjgtMTg2LjggNTkuNC01OS40YzI0LjktMjQuOSA1OC4xLTM4LjcgOTMuNC0zOC43IDM1LjMgMCA2OC40IDEzLjcgOTMuNCAzOC43IDI0LjkgMjQuOSAzOC43IDU4LjEgMzguNyA5My40IDAgMzUuMy0xMy44IDY4LjQtMzguNyA5My40em0tMTkwLjIgMTA1YTguMDMgOC4wMyAwIDAwLTExLjMgMEw1MDEgNjEzLjMgNDEwLjcgNTIzbDY2LjctNjYuN2MzLjEtMy4xIDMuMS04LjIgMC0xMS4zTDQ0MSA0MDguNmE4LjAzIDguMDMgMCAwMC0xMS4zIDBMMzYzIDQ3NS4zbC00My00M2E3Ljg1IDcuODUgMCAwMC01LjctMi4zYy0yIDAtNC4xLjgtNS43IDIuM0wyMDYuOCA1MzQuMmMtNjguOSA2OS03NyAxNzUuNy0yNC4zIDI1My41bC03Ni4xIDc2LjFhOC4wMyA4LjAzIDAgMDAwIDExLjNsNDIuNCA0Mi40YzEuNiAxLjYgMy42IDIuMyA1LjcgMi4zczQuMS0uOCA1LjctMi4zbDc2LjEtNzYuMWMzMy43IDIyLjkgNzIuOSAzNC4zIDExMi4xIDM0LjMgNTEuMiAwIDEwMi40LTE5LjUgMTQxLjUtNTguNmwxMDEuOS0xMDEuOWMzLjEtMy4xIDMuMS04LjIgMC0xMS4zbC00My00MyA2Ni43LTY2LjdjMy4xLTMuMSAzLjEtOC4yIDAtMTEuM2wtMzYuNi0zNi4yek00NDEuNyA3NjkuMWExMzEuMzIgMTMxLjMyIDAgMDEtOTMuNCAzOC43Yy0zNS4zIDAtNjguNC0xMy43LTkzLjQtMzguN2ExMzEuMzIgMTMxLjMyIDAgMDEtMzguNy05My40YzAtMzUuMyAxMy43LTY4LjQgMzguNy05My40bDU5LjQtNTkuNCAxODYuOCAxODYuOC01OS40IDU5LjR6IiAvPjwvc3ZnPg==) */ var $3188cd1e60a390d5$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($3188cd1e60a390d5$var$ApiOutlined);
$3188cd1e60a390d5$var$RefIcon.displayName = 'ApiOutlined';
var $3188cd1e60a390d5$export$2e2bcd8739ae039 = $3188cd1e60a390d5$var$RefIcon;


var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $e9ad0f9b8342d5b5$var$WarningOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "outlined"
};
var $e9ad0f9b8342d5b5$export$2e2bcd8739ae039 = $e9ad0f9b8342d5b5$var$WarningOutlined;



var $63746ae55fe002a5$var$WarningOutlined = function WarningOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $e9ad0f9b8342d5b5$export$2e2bcd8739ae039)
    }));
};
/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ2NCA3MjBhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem0xNi0zMDR2MTg0YzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDE2YzAtNC40LTMuNi04LTgtOGgtNDhjLTQuNCAwLTggMy42LTggOHptNDc1LjcgNDQwbC00MTYtNzIwYy02LjItMTAuNy0xNi45LTE2LTI3LjctMTZzLTIxLjYgNS4zLTI3LjcgMTZsLTQxNiA3MjBDNTYgODc3LjQgNzEuNCA5MDQgOTYgOTA0aDgzMmMyNC42IDAgNDAtMjYuNiAyNy43LTQ4em0tNzgzLjUtMjcuOUw1MTIgMjM5LjlsMzM5LjggNTg4LjJIMTcyLjJ6IiAvPjwvc3ZnPg==) */ var $63746ae55fe002a5$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($63746ae55fe002a5$var$WarningOutlined);
$63746ae55fe002a5$var$RefIcon.displayName = 'WarningOutlined';
var $63746ae55fe002a5$export$2e2bcd8739ae039 = $63746ae55fe002a5$var$RefIcon;






var $jMaZ8 = parcelRequire("jMaZ8");

var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $a570b4f7e55db337$var$AudioMutedOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M682 455V311l-76 76v68c-.1 50.7-42 92.1-94 92a95.8 95.8 0 01-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54a334.01 334.01 0 00179 81v102H326c-13.9 0-24.9 14.3-25 32v36c.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zm13.1-377.7l-43.5-41.9a8 8 0 00-11.2.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7.4 13.3 1.2 19.8l-68 68A252.33 252.33 0 01258 454c-.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137a8.03 8.03 0 000 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l.1-.1c3.1-3.2 3-8.3-.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z"
                }
            }
        ]
    },
    "name": "audio-muted",
    "theme": "outlined"
};
var $a570b4f7e55db337$export$2e2bcd8739ae039 = $a570b4f7e55db337$var$AudioMutedOutlined;



var $54e16f52b3ebe339$var$AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $a570b4f7e55db337$export$2e2bcd8739ae039)
    }));
};
/**![audio-muted](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik02ODIgNDU1VjMxMWwtNzYgNzZ2NjhjLS4xIDUwLjctNDIgOTIuMS05NCA5MmE5NS44IDk1LjggMCAwMS01Mi0xNWwtNTQgNTVjMjkuMSAyMi40IDY1LjkgMzYgMTA2IDM2IDkzLjggMCAxNzAtNzUuMSAxNzAtMTY4eiIgLz48cGF0aCBkPSJNODMzIDQ0NmgtNjBjLTQuNCAwLTggMy42LTggOCAwIDE0MC4zLTExMy43IDI1NC0yNTQgMjU0LTYzIDAtMTIwLjctMjMtMTY1LTYxbC01NCA1NGEzMzQuMDEgMzM0LjAxIDAgMDAxNzkgODF2MTAySDMyNmMtMTMuOSAwLTI0LjkgMTQuMy0yNSAzMnYzNmMuMSA0LjQgMi45IDggNiA4aDQwOGMzLjIgMCA2LTMuNiA2LTh2LTM2YzAtMTcuNy0xMS0zMi0yNS0zMkg1NDdWNzgyYzE2NS4zLTE3LjkgMjk0LTE1Ny45IDI5NC0zMjggMC00LjQtMy42LTgtOC04em0xMy4xLTM3Ny43bC00My41LTQxLjlhOCA4IDAgMDAtMTEuMi4xbC0xMjkgMTI5QzYzNC4zIDEwMS4yIDU3NyA2NCA1MTEgNjRjLTkzLjkgMC0xNzAgNzUuMy0xNzAgMTY4djIyNGMwIDYuNy40IDEzLjMgMS4yIDE5LjhsLTY4IDY4QTI1Mi4zMyAyNTIuMzMgMCAwMTI1OCA0NTRjLS4yLTQuNC0zLjgtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDggMCA1MyAxMi41IDEwMyAzNC42IDE0Ny40bC0xMzcgMTM3YTguMDMgOC4wMyAwIDAwMCAxMS4zbDQyLjcgNDIuN2MzLjEgMy4xIDguMiAzLjEgMTEuMyAwTDg0Ni4yIDc5LjhsLjEtLjFjMy4xLTMuMiAzLTguMy0uMi0xMS40ek00MTcgNDAxVjIzMmMwLTUwLjYgNDEuOS05MiA5NC05MiA0NiAwIDg0LjEgMzIuMyA5Mi4zIDc0LjdMNDE3IDQwMXoiIC8+PC9zdmc+) */ var $54e16f52b3ebe339$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($54e16f52b3ebe339$var$AudioMutedOutlined);
$54e16f52b3ebe339$var$RefIcon.displayName = 'AudioMutedOutlined';
var $54e16f52b3ebe339$export$2e2bcd8739ae039 = $54e16f52b3ebe339$var$RefIcon;





function $fbfe34140d19a63b$export$2e2bcd8739ae039(projectId, rhese) {
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    const [loading, setLoading] = (0, $jMaZ8.useState)(false);
    const [applyUpdateRhese] = (0, $e52adb0de4892d08$export$2c38ec863e79ad20)();
    /**
   * Requests
   */ const setIgnore = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            setLoading(true);
            await applyUpdateRhese({
                variables: {
                    rheseId: rhese.id,
                    projectId: projectId,
                    lineBreakAfter: rhese.lineBreakAfter,
                    ignoreTextForAudioSync: true
                }
            });
            setLoading(false);
        } catch (e) {
            console.error("useSkipSynchro", e);
        }
    }, [
        applyUpdateRhese,
        projectId,
        rhese?.id,
        rhese.lineBreakAfter
    ]);
    const unignore = (0, $jMaZ8.useCallback)(async (e)=>{
        if (e?.stopPropagation) e?.stopPropagation(); // prevent rhese selection
        try {
            setLoading(true);
            await applyUpdateRhese({
                variables: {
                    rheseId: rhese.id,
                    projectId: projectId,
                    lineBreakAfter: rhese.lineBreakAfter,
                    ignoreTextForAudioSync: false
                }
            });
            setLoading(false);
        } catch (e) {
            console.error("useSkipSynchro", e);
        }
    }, [
        applyUpdateRhese,
        projectId,
        rhese?.id,
        rhese.lineBreakAfter
    ]);
    /**
   * Modal confirm
   */ const [isModal, setIsModal] = (0, $jMaZ8.useState)(false);
    const modalConfirmUnskip = (0, $jMaZ8.useCallback)(()=>{
        (0, $f57978dfa9715a4c$export$2e2bcd8739ae039).confirm({
            open: isModal,
            onOk: unignore,
            onCancel: ()=>setIsModal(false),
            title: t("rheseUseSyncroDialogTitle"),
            okText: t("rheseUseSyncroDialogOk"),
            cancelText: t("rheseUseSyncroDialogCancel")
        });
    }, [
        isModal,
        t,
        unignore
    ]);
    /**
   * Righ-click rhese menu
   */ const contextMenuItems = (0, $jMaZ8.useMemo)(()=>rhese?.ignoreTextForAudioSync ? [
            {
                label: t("rheseUseSyncroMenuItemLabel"),
                key: "unskipSynchro",
                icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6d91fa0144a5983b$export$2e2bcd8739ae039), {})
            }
        ] : [
            {
                label: t("rheseIgnoreSyncroMenuItemLabel"),
                key: "skipSynchro",
                icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $54e16f52b3ebe339$export$2e2bcd8739ae039), {})
            }
        ], [
        rhese?.ignoreTextForAudioSync,
        t
    ]);
    const onItemMenuSelected = (0, $jMaZ8.useCallback)((key)=>{
        if (key == "unskipSynchro") modalConfirmUnskip();
        else setIgnore();
    }, [
        modalConfirmUnskip,
        setIgnore
    ]);
    return {
        unignore: unignore,
        loading: loading,
        contextMenuItems: contextMenuItems,
        onItemMenuSelected: onItemMenuSelected
    };
}




const $d05ccb3c866c00e6$var$getRheseStyle = (index)=>{
    if (index % 2 === 0) return $9bb06851955bb570$export$659b05ac803be9ff;
    else return $9bb06851955bb570$export$41371ff1e2e74fbb;
};
const $d05ccb3c866c00e6$export$3559173430e91698 = ({ rhese: rhese, onClick: onClick, index: index, isSelected: isSelected, isSelectionStart: isSelectionStart, projectId: projectId, pageMetadata: pageMetadata, inProgress: inProgress })=>{
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    const rhesesStyle = $d05ccb3c866c00e6$var$getRheseStyle(index);
    const syncStatus = rhese.data.audioRecording?.syncStatus;
    const hasFailed = syncStatus === (0, $b522cf181e75e62d$export$f67d996d1aa82fbb).FAILED;
    const hasSucceeded = syncStatus === (0, $b522cf181e75e62d$export$f67d996d1aa82fbb).SUCCEEDED;
    const isWaiting = syncStatus === (0, $b522cf181e75e62d$export$f67d996d1aa82fbb).TO_DO;
    const { contextMenuItems: contextMenuItems, onItemMenuSelected: onItemMenuSelected, loading: loadingIgnoreOrUse } = (0, $fbfe34140d19a63b$export$2e2bcd8739ae039)(projectId, rhese.data);
    const _onClick = (0, $jMaZ8.useCallback)(()=>onClick(rhese.data.id), [
        onClick,
        rhese.data.id
    ]);
    const onMenuItemClick = (0, $jMaZ8.useCallback)((data)=>onItemMenuSelected(data.key), [
        onItemMenuSelected
    ]);
    const menuProps = (0, $jMaZ8.useMemo)(()=>({
            items: contextMenuItems,
            onClick: onMenuItemClick
        }), [
        contextMenuItems,
        onMenuItemClick
    ]);
    const text = pageMetadata.textContent.substring(rhese.anchors[0].utf16Start - pageMetadata.page.anchors[0].utf16Start, rhese.anchors[0].utf16Start + rhese.anchors[0].utf16Size - pageMetadata.page.anchors[0].utf16Start);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $693847f5969d2a03$export$2e2bcd8739ae039), {
        menu: menuProps,
        trigger: [
            "contextMenu"
        ],
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
            className: $9bb06851955bb570$export$9aba72b49859255a,
            onClick: _onClick,
            children: [
                isSelectionStart && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    className: $9bb06851955bb570$export$5e2f617ae845fb63
                }),
                isSelected && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c1c1d6d80357382d$export$2e2bcd8739ae039), {
                    className: $9bb06851955bb570$export$b2cc475f39b4b522
                }),
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                    className: `${$9bb06851955bb570$export$d89dc70d9d82cb3b} ${rhesesStyle}`,
                    "aria-selected": isSelected,
                    "data-rhese-id": rhese.data.id,
                    children: [
                        rhese.data.ignoreTextForAudioSync && (loadingIgnoreOrUse ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                            small: true,
                            style: {
                                marginRight: "1.2em"
                            }
                        }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                            title: t("rheseIconSyncroTooltip"),
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3188cd1e60a390d5$export$2e2bcd8739ae039), {
                                className: $9bb06851955bb570$export$ce5d78961483d611,
                                onClick: ()=>null
                            })
                        })),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                            className: $9bb06851955bb570$export$864af25a7f7e70fe,
                            children: text
                        }, rhese.data.id),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $80792b450d48ee77$export$2e2bcd8739ae039), {
                            comment: rhese.data.audioInfo?.comment,
                            audioReviewStatus: rhese.data.audioInfo?.status
                        }),
                        rhese.data.audioInfo?.id && hasSucceeded && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $7daea8149cc7f006$export$885f104b8ec14062), {
                                rhese: rhese
                            })
                        }),
                        (isWaiting || inProgress) && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                            style: {
                                marginLeft: "1em"
                            }
                        }),
                        hasFailed && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $63746ae55fe002a5$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        })
    }, index);
};



var $jMaZ8 = parcelRequire("jMaZ8");
var $6860e5e78d555971$export$2cedfd664bb3bd01;
var $6860e5e78d555971$export$bf497e8e00cd4351;
var $6860e5e78d555971$export$9c206ddddb32a9b;
var $6860e5e78d555971$export$fe412c270a34f415;
var $6860e5e78d555971$export$aed21f84271344a6;
$6860e5e78d555971$export$2cedfd664bb3bd01 = "textContainer_960840";
$6860e5e78d555971$export$bf497e8e00cd4351 = "textToRead_960840";
$6860e5e78d555971$export$9c206ddddb32a9b = "paragraph_960840";
$6860e5e78d555971$export$fe412c270a34f415 = "unselect_960840";
$6860e5e78d555971$export$aed21f84271344a6 = "toggleRheseSilence_960840";



var $62LIg = parcelRequire("62LIg");
const $e367478e4d4f6e9d$var$TextToRead = ({ pageMetadata: pageMetadata, selectedRheses: selectedRheses, addSelectedRhese: addSelectedRhese, selectionStartId: selectionStartId, projectId: projectId, savingAudio: savingAudio })=>{
    const unselectAll = (0, $jMaZ8.useCallback)(addSelectedRhese, [
        addSelectedRhese
    ]);
    const handleSelection = (0, $jMaZ8.useCallback)((rheseId)=>{
        const isSelected = selectedRheses.find((r)=>r.data.id === rheseId);
        const rhese = pageMetadata.rhese.find((r)=>r.data.id === rheseId);
        if (isSelected) unselectAll();
        addSelectedRhese(rhese.data.id);
    }, [
        pageMetadata?.rhese,
        selectedRheses,
        addSelectedRhese,
        unselectAll
    ]);
    if (!pageMetadata) return null;
    const groupedRheses = (0, $62LIg.groupBy)(pageMetadata.rhese, "paragraphId");
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $6860e5e78d555971$export$bf497e8e00cd4351,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
            className: $6860e5e78d555971$export$2cedfd664bb3bd01,
            children: Object.entries(groupedRheses).map(([key, rheses])=>{
                return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    className: $6860e5e78d555971$export$9c206ddddb32a9b,
                    children: rheses.sort((a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start).map((rhese, index)=>{
                        const isSelected = selectedRheses.includes(rhese);
                        const isSelectionStart = rhese.data.id === selectionStartId && !isSelected;
                        return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d05ccb3c866c00e6$export$3559173430e91698), {
                            isSelectionStart: isSelectionStart,
                            onClick: handleSelection,
                            isSelected: isSelected,
                            rhese: rhese,
                            index: index,
                            projectId: projectId,
                            pageMetadata: pageMetadata,
                            inProgress: isSelected && savingAudio
                        }, rhese.data.id);
                    })
                }, key);
            })
        })
    });
};
var $e367478e4d4f6e9d$export$2e2bcd8739ae039 = $e367478e4d4f6e9d$var$TextToRead;



const $32e8535e3fa895fd$export$71ce45fad9494338 = (rheses)=>{
    const [selection, select] = (0, $jMaZ8.useReducer)((selection, rheseId)=>{
        if (!rheseId) return [
            undefined,
            undefined
        ];
        const [first, second] = selection;
        if (!first) return [
            rheseId,
            undefined
        ];
        if (first && second) return [
            rheseId,
            undefined
        ];
        return [
            first,
            rheseId
        ];
    }, [
        undefined,
        undefined
    ]);
    const [startIndex, endIndex] = (0, $jMaZ8.useMemo)(()=>{
        if (!rheses) return [
            undefined,
            undefined
        ];
        const [start, end] = selection;
        const startIndex = rheses.findIndex((r)=>r.data.id === start);
        const endIndex = rheses.findIndex((r)=>r.data.id === end);
        return endIndex > startIndex ? [
            startIndex,
            endIndex
        ] : [
            endIndex,
            startIndex
        ];
    }, [
        selection,
        rheses
    ]);
    const selectedRheses = (0, $jMaZ8.useMemo)(()=>{
        if (startIndex === undefined || rheses === null) return [];
        if (endIndex === undefined) return [
            rheses[startIndex]
        ];
        return rheses.slice(startIndex, endIndex + 1).sort((a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start);
    }, [
        startIndex,
        endIndex,
        rheses
    ]);
    return [
        selectedRheses,
        select,
        selection[0]
    ];
};
const $32e8535e3fa895fd$export$94f3d6ad91399920 = ({ bookInfoFromUrl: bookInfoFromUrl, currentPageId: currentPageId, scrollRef: scrollRef, pages: pages, pageMetadata: pageMetadata })=>{
    const navigate = (0, $5c84a101a4932c49$export$9770f232ac06a008)();
    const client = (0, $2937cd197ec1708e$export$eb9a56e7a29e494)();
    const [previousPage, nextPage] = (0, $jMaZ8.useMemo)(()=>{
        if (!pages.length) return [];
        const idx = pages.findIndex((page)=>page.id === currentPageId);
        return [
            pages[idx - 1]?.pageNumber,
            pages[idx + 1]?.pageNumber
        ];
    }, [
        pages,
        currentPageId
    ]);
    const initErrorMessageValue = (0, $jMaZ8.useMemo)(()=>undefined, []);
    const [errorMessage, setErrorMessage] = (0, $jMaZ8.useState)(initErrorMessageValue);
    const [recordedRheses, setRecordedRheses] = (0, $jMaZ8.useState)([]);
    const [currentProjectPage, setCurrentProjectPage] = (0, $jMaZ8.useState)();
    const [projectPages, setProjectPages] = (0, $jMaZ8.useState)();
    const [audioRecorderState, setAudioRecorderState] = (0, $jMaZ8.useState)((0, $48bc4a3fb3911b76$export$ae29a78eda7c4d2f).idle);
    const [selectedRheses, select, selectionAnchor] = $32e8535e3fa895fd$export$71ce45fad9494338(pageMetadata.rhese);
    const [savingAudio, setSavingAudio] = (0, $jMaZ8.useState)(false);
    if (pages) (0, $ee48877aa300de5a$export$95e8c3fdd1a52149)(setProjectPages, projectPages, setCurrentProjectPage, currentProjectPage, pages);
    const selectAllRheses = (0, $jMaZ8.useCallback)(()=>{
        // Deselect all rheses then select from first to last
        const first = pageMetadata.rhese?.[0]?.data.id;
        const last = pageMetadata.rhese?.[pageMetadata.rhese?.length - 1]?.data.id;
        select(undefined);
        select(first);
        select(last);
    }, [
        select,
        pageMetadata.rhese
    ]);
    const clearRecordedRheses = ()=>{
        setRecordedRheses([]);
    };
    const updateRecordedRheses = ()=>{
        if (!selectedRheses) return;
        if (recordedRheses) {
            const newRecordedRheses = [
                ...recordedRheses,
                ...selectedRheses
            ];
            setRecordedRheses(newRecordedRheses.sort((a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start));
        } else setRecordedRheses(selectedRheses.sort((a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start));
    };
    const getStorageURLData = async ()=>{
        try {
            const { data: storageOrDownloadUrl } = await client.query({
                query: (0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea),
                fetchPolicy: "network-only"
            });
            return storageOrDownloadUrl;
        } catch (error) {
            if (error instanceof Error) throw new Error(error.message);
            else throw new Error("Impossible to get the storage or download url");
        }
    };
    const getDownloadURLData = async (filename)=>{
        try {
            const { data: storageOrDownloadUrl } = await client.query({
                query: (0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea),
                fetchPolicy: "network-only",
                variables: {
                    filename: filename
                }
            });
            return storageOrDownloadUrl;
        } catch (error) {
            if (error instanceof Error) throw new Error(error.message);
            else throw new Error("Impossible to get the storage or download url");
        }
    };
    const sendRecordedRhesesToDatabase = async (blob)=>{
        try {
            setSavingAudio(true);
            const storageUrlData = await getStorageURLData();
            const response = await fetch(storageUrlData.audioRecording.presignedUrl.putUrl, {
                method: "PUT",
                body: blob
            });
            if (response.ok) {
                const downloadURLData = await getDownloadURLData(storageUrlData.audioRecording.presignedUrl.filename);
                await client.mutate({
                    mutation: (0, $e8bb2b3cd09bc02a$export$c6ba9f5ab68498b1),
                    fetchPolicy: "network-only",
                    variables: {
                        addRecording: {
                            projectId: bookInfoFromUrl.bookId,
                            fileUuid: downloadURLData.audioRecording.presignedUrl.filename,
                            audioRheses: recordedRheses.map((rhese)=>({
                                    rheseId: rhese.data.id
                                }))
                        }
                    }
                });
                select(undefined);
                clearRecordedRheses();
                setSavingAudio(false);
            }
        } catch (error) {
            setSavingAudio(false);
            throw new Error("L'enregistrement audio n'a pas \xe9t\xe9 enregistr\xe9 pour cause de probl\xe8me technique (communication serveur).");
        }
    };
    const uploadAudioFileToDatabase = async (file, rheses)=>{
        const storageUrlData = await getStorageURLData();
        await new Promise((r)=>setTimeout(()=>r(), 2000));
        const response = await fetch(storageUrlData.audioRecording.presignedUrl.putUrl, {
            method: "PUT",
            body: file
        });
        if (response.ok) {
            const downloadURLData = await getDownloadURLData(storageUrlData.audioRecording.presignedUrl.filename);
            await client.mutate({
                mutation: (0, $e8bb2b3cd09bc02a$export$c6ba9f5ab68498b1),
                fetchPolicy: "network-only",
                variables: {
                    addRecording: {
                        projectId: bookInfoFromUrl.bookId,
                        fileUuid: downloadURLData.audioRecording.presignedUrl.filename,
                        audioRheses: rheses.map((rhese)=>({
                                rheseId: rhese.data.id
                            }))
                    }
                }
            });
        }
    };
    if (!pageMetadata || !selectedRheses) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
        grow: true
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $853afc9c866096af$export$2e2bcd8739ae039).Provider, {
        value: {
            errorMessage: errorMessage,
            setErrorMessage: setErrorMessage,
            selectedRheses: selectedRheses,
            recordedRheses: recordedRheses,
            updateRecordedRheses: updateRecordedRheses,
            clearRecordedRheses: clearRecordedRheses,
            sendRecordedRhesesToDatabase: sendRecordedRhesesToDatabase,
            uploadAudioFileToDatabase: uploadAudioFileToDatabase
        },
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($221fa0e9c5426c27$exports))), {
                useWindow: false,
                hasMore: false,
                loadMore: ()=>{},
                getScrollParent: ()=>scrollRef?.current,
                pageStart: 0,
                threshold: 10,
                loader: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $jMaZ8.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                            small: true
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("br", {})
                    ]
                }, 0),
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e367478e4d4f6e9d$export$2e2bcd8739ae039), {
                    selectedRheses: selectedRheses,
                    selectionStartId: selectionAnchor,
                    addSelectedRhese: select,
                    projectId: bookInfoFromUrl.bookId,
                    pageMetadata: pageMetadata,
                    savingAudio: savingAudio
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $48bc4a3fb3911b76$export$2e2bcd8739ae039), {
                audioRecorderState: audioRecorderState,
                setAudioRecorderState: setAudioRecorderState,
                selectAllRheses: selectAllRheses,
                previousPage: {
                    canNavigate: previousPage !== undefined,
                    navigate: ()=>typeof previousPage === "number" && navigate(`/audio/library/edit/${bookInfoFromUrl.bookId}/${previousPage}`)
                },
                nextPage: {
                    canNavigate: nextPage !== undefined,
                    navigate: ()=>typeof nextPage === "number" && navigate(`/audio/library/edit/${bookInfoFromUrl.bookId}/${nextPage}`)
                }
            })
        ]
    });
};


const $252746cd6583956c$var$NarratorContent = ({ currentPageId: currentPageId, bookId: bookId, bookInfoFromUrl: bookInfoFromUrl, scrollRef: scrollRef, pages: pages, selectedRole: selectedRole, title: title })=>{
    // @ts-ignore
    const { extendedPage: pageMetadata } = (0, $f9ad6d9d9a78d084$export$9c25024bdfe755f7)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $727abf2d5c541723$export$72f9ca7a3ec3fbb1), {
                pageId: currentPageId,
                projectId: bookId,
                selectedRole: selectedRole,
                pageMetadata: pageMetadata
            }),
            title,
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a28ed92ce3433278$export$6a0e37d37d3c52e1), {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $32e8535e3fa895fd$export$94f3d6ad91399920), {
                    bookInfoFromUrl: bookInfoFromUrl,
                    currentPageId: currentPageId,
                    scrollRef: scrollRef,
                    pages: pages,
                    pageMetadata: pageMetadata
                }, bookInfoFromUrl.currentPage)
            })
        ]
    });
};
var $252746cd6583956c$export$2e2bcd8739ae039 = $252746cd6583956c$var$NarratorContent;





var $jMaZ8 = parcelRequire("jMaZ8");





var $jMaZ8 = parcelRequire("jMaZ8");


const $861562afdbad1429$export$2eb58638a4193c9b = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation AddAudioReview(
        $projectId: UUID!
        $rheseId: UUID!
        $status: AudioReviewStatus!
        $comment: String
      ) {
        addAudioReview(
          projectId: $projectId
          review: { rheseId: $rheseId, status: $status, comment: $comment }
        )
      }
    `);
const $861562afdbad1429$export$e94bfdb192d5d7d6 = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation UpdateAudioReview(
        $status: AudioReviewStatus!
        $comment: String
        $projectId: UUID!
        $reviewId: UUID!
      ) {
        updateAudioReview(
          status: $status
          comment: $comment
          projectId: $projectId
          reviewId: $reviewId
        )
      }
    `);
const $861562afdbad1429$export$1628ef81009f7ccf = ()=>(0, $fed59b56f9be1d6c$export$609860bf8b0084c)((0, $f013a28d70124837$export$72e4926bf8358653)`
      mutation DeleteAudioReviews($rheseIds: [UUID!]!, $projectId: UUID!) {
        deleteAudioReviews(rheseIds: $rheseIds, projectId: $projectId)
      }
    `);




var $jMaZ8 = parcelRequire("jMaZ8");


var $62LIg = parcelRequire("62LIg");







var $jMaZ8 = parcelRequire("jMaZ8");








var $jMaZ8 = parcelRequire("jMaZ8");


const $87f3bc3ef500e2a7$var$ResetSelectionStatusBtn = ({ resetSelectionStatus: resetSelectionStatus })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const [modalVisible, setModalVisible] = (0, $jMaZ8.useState)(false);
    const showModal = (0, $jMaZ8.useCallback)(()=>{
        setModalVisible(true);
    }, []);
    const hideModal = (0, $jMaZ8.useCallback)(()=>{
        setModalVisible(false);
    }, []);
    const onValidate = (0, $jMaZ8.useCallback)(()=>{
        resetSelectionStatus();
        hideModal();
    }, [
        resetSelectionStatus,
        hideModal
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                danger: true,
                shape: "round",
                onClick: showModal,
                children: t("audioReview.resetStatusBtn")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
                title: t("audioReview.resetStatusModalTitle"),
                open: modalVisible,
                onOk: onValidate,
                onCancel: hideModal,
                okText: t("audioReview.resetStatusModalBtn"),
                cancelText: t("cancel"),
                children: t("audioReview.resetStatusModalText")
            })
        ]
    });
};
var $87f3bc3ef500e2a7$export$2e2bcd8739ae039 = $87f3bc3ef500e2a7$var$ResetSelectionStatusBtn;




var $jMaZ8 = parcelRequire("jMaZ8");








parcelRequire("jMaZ8");

function $271ab9cb7ddc7c14$export$2e2bcd8739ae039({ fill: fill = (0, $805f5b10e83e708d$export$8f45430ccf837300).ORANGE }) {
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("path", {
            d: "M21 10.2679C22.3333 11.0377 22.3333 12.9623 21 13.7321L9 20.6603C7.66667 21.4301 6 20.4678 6 18.9282L6 5.0718C6 3.5322 7.66667 2.56995 9 3.33975L21 10.2679Z",
            fill: fill
        })
    });
}






var $jMaZ8 = parcelRequire("jMaZ8");




var $jMaZ8 = parcelRequire("jMaZ8");




var $jMaZ8 = parcelRequire("jMaZ8");

function $687fa3f0b9644934$export$2e2bcd8739ae039(audioContext, recording) {
    const [buffer, setBuffer] = (0, $jMaZ8.useState)(null);
    const { data: data } = (0, $7fa797a3751877df$export$dd0a697e1782aedd)((0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea), {
        variables: {
            filename: recording?.fileUuid
        },
        fetchPolicy: "network-only",
        skip: !recording
    });
    (0, $jMaZ8.useEffect)(()=>{
        if (data && data.audioRecording.presignedUrl.getUrl) fetch(data.audioRecording.presignedUrl.getUrl, {
            mode: "cors"
        }).then((res)=>res.arrayBuffer()).then((audioData)=>audioContext.decodeAudioData(audioData)).then((buffer)=>{
            setBuffer(buffer);
        });
    }, [
        audioContext,
        data
    ]);
    return buffer;
}
const $687fa3f0b9644934$export$9f3a03c3a88b5d01 = (audioContext, buffer)=>{
    const audioSource = audioContext.createBufferSource();
    audioSource.buffer = buffer;
    audioSource.connect(audioContext.destination);
    return audioSource;
};




var $jMaZ8 = parcelRequire("jMaZ8");


const $2f3cf3b571dec6ea$var$AUDIO_SLIDER_STEP = 0.01; // in seconds
function $2f3cf3b571dec6ea$export$2e2bcd8739ae039({ originalStart: originalStart, originalEnd: originalEnd, defaultStart: defaultStart, defaultEnd: defaultEnd, setStartOffset: setStartOffset, setEndOffset: setEndOffset, additionalTimeBefore: additionalTimeBefore, additionalTimeAfter: additionalTimeAfter, lastInputStartOffset: lastInputStartOffset, lastInputEndOffset: lastInputEndOffset }) {
    const [initialStartHandled, setInitialStartHandled] = (0, $jMaZ8.useState)(false);
    const [initialEndHandled, setInitialEndHandled] = (0, $jMaZ8.useState)(false);
    // const [prevStartOffset, setPrevStartOffset] = useState(startOffset);
    /**
   * Slider values
   */ const [start, setStart] = (0, $jMaZ8.useState)(defaultStart);
    const [end, setEnd] = (0, $jMaZ8.useState)(defaultEnd);
    const [newMin, setNewMin] = (0, $jMaZ8.useState)(originalStart); // TODO
    const [newMax, setNewMax] = (0, $jMaZ8.useState)(originalEnd);
    /**
   * Slider handlers
   */ const onChange = (0, $jMaZ8.useCallback)((value)=>{
        const _start = (0, $1abea94550147a73$export$360dc50351b2b778)(value[0], 2);
        const _end = (0, $1abea94550147a73$export$360dc50351b2b778)(value[1], 2);
        // Internal state only
        setStart(_start);
        setEnd(_end);
        // Update value
        const _startOffset = (0, $1abea94550147a73$export$360dc50351b2b778)(_start - originalStart, 2);
        const _endOffset = (0, $1abea94550147a73$export$360dc50351b2b778)(_end - originalEnd, 2);
        setStartOffset(_startOffset);
        setEndOffset(_endOffset);
    }, [
        originalEnd,
        originalStart,
        setEndOffset,
        setStartOffset
    ]);
    /**
   * newMin logic
   */ // Effect: update "newMin" when "additionalTimeBefore" changes
    (0, $jMaZ8.useEffect)(()=>{
        const _newMin = (0, $1abea94550147a73$export$360dc50351b2b778)(originalStart - additionalTimeBefore, 2);
        setNewMin(_newMin);
    }, [
        additionalTimeBefore,
        originalStart
    ]);
    // Effect: "newMin" has changed, and is higher than the start value
    (0, $jMaZ8.useEffect)(()=>{
        if (start < newMin) {
            if (!initialStartHandled && defaultStart !== originalStart) // Don't update values in this case. Required to not overide initial values
            setInitialStartHandled(true);
            else {
                setStart(newMin);
                setStartOffset(additionalTimeBefore);
            }
        }
    }, [
        additionalTimeBefore,
        setStartOffset,
        start,
        newMin,
        initialStartHandled,
        defaultStart,
        originalStart
    ]);
    /**
   * newMax logic
   */ // Effect: update "newMax" when "additionalTimeAfter" changes
    (0, $jMaZ8.useEffect)(()=>{
        const _newMax = (0, $1abea94550147a73$export$360dc50351b2b778)(originalEnd + additionalTimeAfter, 2);
        setNewMax(_newMax);
    }, [
        additionalTimeAfter,
        originalEnd
    ]);
    // Effect: "newMax" has changed, and is lower than the end value
    (0, $jMaZ8.useEffect)(()=>{
        if (end > newMax) {
            if (!initialEndHandled && defaultEnd !== originalEnd) // Don't update values in this case. Required to not overide initial values
            setInitialEndHandled(true);
            else {
                setEnd(newMax);
                setEndOffset(additionalTimeAfter);
            }
        }
    }, [
        end,
        newMax,
        additionalTimeAfter,
        setEndOffset,
        initialEndHandled,
        defaultEnd,
        originalEnd
    ]);
    /**
   * Slider marks
   */ const marks = (0, $jMaZ8.useMemo)(()=>{
        const _marks = {
            [originalStart]: "Start",
            [originalEnd]: "End"
        };
        if (newMin < originalStart) _marks[newMin] = `-${(0, $1abea94550147a73$export$360dc50351b2b778)(originalStart - newMin, 2)}s`;
        if (newMax > originalEnd) _marks[newMax] = `+${(0, $1abea94550147a73$export$360dc50351b2b778)(newMax - originalEnd, 2)}s`;
        return _marks;
    }, [
        originalStart,
        originalEnd,
        newMin,
        newMax
    ]);
    /**
   * Stay sync if inputs change
   */ const [prevLastInputStartOffset, setPrevLastInputStartOffset] = (0, $jMaZ8.useState)(lastInputStartOffset);
    const [prevLastInputEndOffset, setPrevLastInputEndOffset] = (0, $jMaZ8.useState)(lastInputEndOffset);
    (0, $jMaZ8.useEffect)(()=>{
        // Start
        if (lastInputStartOffset !== undefined) {
            if (lastInputStartOffset !== prevLastInputStartOffset) {
                const _start = (0, $1abea94550147a73$export$360dc50351b2b778)(originalStart + lastInputStartOffset, 2);
                setStart(_start);
            }
            setPrevLastInputStartOffset(lastInputStartOffset);
        }
        // End
        if (lastInputEndOffset !== undefined) {
            if (lastInputEndOffset !== prevLastInputEndOffset) {
                const _end = (0, $1abea94550147a73$export$360dc50351b2b778)(originalEnd - lastInputEndOffset, 2);
                setEnd(_end);
            }
            setPrevLastInputEndOffset(lastInputEndOffset);
        }
    }, [
        lastInputStartOffset,
        prevLastInputStartOffset,
        originalStart,
        originalEnd,
        lastInputEndOffset,
        prevLastInputEndOffset,
        defaultEnd
    ]);
    /**
   * Effect to fix a tooltip bug
   * Bug: is tooltip's "open" option is set to true from start, the tooltip will have a bad position, preventing from grabbing the dots easily
   */ const [showTooltip, setShowTooltip] = (0, $jMaZ8.useState)(false);
    (0, $jMaZ8.useEffect)(()=>{
        setTimeout(()=>{
            setShowTooltip(true);
        }, 350);
    }, []);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $bb290b37c61d241a$export$2e2bcd8739ae039), {
        min: newMin,
        max: newMax,
        value: [
            start,
            end
        ],
        step: $2f3cf3b571dec6ea$var$AUDIO_SLIDER_STEP,
        onChange: onChange,
        range: {
            draggableTrack: true
        },
        tooltip: {
            formatter: (value)=>value?.toFixed(2),
            open: showTooltip
        },
        marks: marks
    }, `${newMin}-${newMax}`);
}




var $jMaZ8 = parcelRequire("jMaZ8");



var $d9b8e6a04aa7d331$export$e8e78c978b129247;
var $d9b8e6a04aa7d331$export$602c633f774cc3ba;
var $d9b8e6a04aa7d331$export$2ba01fb71ed41cb6;
var $d9b8e6a04aa7d331$export$1ca1ec8b29a4ce27;
$d9b8e6a04aa7d331$export$e8e78c978b129247 = "root_8b6166";
$d9b8e6a04aa7d331$export$602c633f774cc3ba = "subContainer_8b6166";
$d9b8e6a04aa7d331$export$2ba01fb71ed41cb6 = "button_8b6166";
$d9b8e6a04aa7d331$export$1ca1ec8b29a4ce27 = "icon_8b6166";



function $f905586a4fe1bb14$export$2e2bcd8739ae039({ playInfoDuration: playInfoDuration, playInfoEnd: playInfoEnd, fullAudioDuration: fullAudioDuration, minOffsetStart: minOffsetStart, hasMaxOffsetEnd: hasMaxOffsetEnd, additionalTimeBefore: additionalTimeBefore, additionalTimeAfter: additionalTimeAfter, setAdditionalTimeBefore: setAdditionalTimeBefore, setAdditionalTimeAfter: setAdditionalTimeAfter, sliderDefaultValues: sliderDefaultValues }) {
    const canDecrementTimeBefore = minOffsetStart !== 0 && -minOffsetStart > additionalTimeBefore;
    const canIncrementTimeBefore = additionalTimeBefore !== 0;
    const canDecrementTimeAfter = additionalTimeAfter !== 0;
    const canIncrementTimeAfter = hasMaxOffsetEnd && fullAudioDuration ? fullAudioDuration > playInfoEnd : false;
    const updateAdditionalTimeBefore = (0, $jMaZ8.useCallback)((type)=>()=>{
            if (!fullAudioDuration) return;
            const step = (0, $77f1e7c43da53f17$export$278f9aed9ac4cd51);
            if (type === "decrement") {
                const canDecrementOneStep = -additionalTimeBefore - step > minOffsetStart;
                if (canDecrementOneStep) setAdditionalTimeBefore((time)=>time + step);
                else {
                    const remainingTimeToAdd = (0, $1abea94550147a73$export$360dc50351b2b778)(-minOffsetStart - additionalTimeBefore, 2);
                    setAdditionalTimeBefore((time)=>time + remainingTimeToAdd);
                }
            } else {
                const canIncrementOneStep = additionalTimeBefore > step;
                if (canIncrementOneStep) setAdditionalTimeBefore((time)=>time - step);
                else {
                    const remainingTimeToAdd = (0, $1abea94550147a73$export$360dc50351b2b778)(step - (step - additionalTimeBefore), 2);
                    setAdditionalTimeBefore((time)=>time - remainingTimeToAdd);
                }
            }
        }, [
        fullAudioDuration,
        additionalTimeBefore,
        minOffsetStart,
        setAdditionalTimeBefore
    ]);
    const updateAdditionalTimeAfter = (0, $jMaZ8.useCallback)((type)=>()=>{
            if (!fullAudioDuration) return;
            const step = (0, $77f1e7c43da53f17$export$278f9aed9ac4cd51);
            const currentDuration = playInfoDuration + additionalTimeAfter;
            if (type === "decrement") {
                const canDecreaseOneStep = additionalTimeAfter - step >= 0;
                if (canDecreaseOneStep) setAdditionalTimeAfter((time)=>(0, $1abea94550147a73$export$360dc50351b2b778)(time - step, 2));
                else {
                    const remaining = (0, $1abea94550147a73$export$360dc50351b2b778)(currentDuration - (sliderDefaultValues.end - sliderDefaultValues.start), 2);
                    setAdditionalTimeAfter((time)=>(0, $1abea94550147a73$export$360dc50351b2b778)(time - remaining, 2));
                }
            } else {
                const canExtendOneStep = currentDuration + step < fullAudioDuration;
                if (!canExtendOneStep) {
                    const remaining = (0, $1abea94550147a73$export$360dc50351b2b778)(fullAudioDuration - currentDuration, 2);
                    setAdditionalTimeAfter((time)=>(0, $1abea94550147a73$export$360dc50351b2b778)(time + remaining, 2));
                } else setAdditionalTimeAfter((time)=>(0, $1abea94550147a73$export$360dc50351b2b778)(time + step, 2));
            }
        }, [
        fullAudioDuration,
        playInfoDuration,
        additionalTimeAfter,
        setAdditionalTimeAfter,
        sliderDefaultValues
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
        className: $d9b8e6a04aa7d331$export$e8e78c978b129247,
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $d9b8e6a04aa7d331$export$602c633f774cc3ba,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !canDecrementTimeBefore,
                        onClick: updateAdditionalTimeBefore("decrement"),
                        className: $d9b8e6a04aa7d331$export$2ba01fb71ed41cb6,
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6e46ad2dd0f7d813$export$2e2bcd8739ae039), {
                            className: $d9b8e6a04aa7d331$export$1ca1ec8b29a4ce27
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !canIncrementTimeBefore,
                        onClick: updateAdditionalTimeBefore("increment"),
                        className: $d9b8e6a04aa7d331$export$2ba01fb71ed41cb6,
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1199127efb84781f$export$2e2bcd8739ae039), {
                            className: $d9b8e6a04aa7d331$export$1ca1ec8b29a4ce27
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $d9b8e6a04aa7d331$export$602c633f774cc3ba,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !canDecrementTimeAfter,
                        onClick: updateAdditionalTimeAfter("decrement"),
                        className: $d9b8e6a04aa7d331$export$2ba01fb71ed41cb6,
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $6e46ad2dd0f7d813$export$2e2bcd8739ae039), {
                            className: $d9b8e6a04aa7d331$export$1ca1ec8b29a4ce27
                        })
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !canIncrementTimeAfter,
                        onClick: updateAdditionalTimeAfter("increment"),
                        className: $d9b8e6a04aa7d331$export$2ba01fb71ed41cb6,
                        shape: "circle",
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $1199127efb84781f$export$2e2bcd8739ae039), {
                            className: $d9b8e6a04aa7d331$export$1ca1ec8b29a4ce27
                        })
                    })
                ]
            })
        ]
    });
}


var $3dde5b55d2091270$export$a7db06668cad9adb;
var $3dde5b55d2091270$export$755d7ed31a25e0fb;
var $3dde5b55d2091270$export$12badc1a4c058bdf;
var $3dde5b55d2091270$export$b7e3ae3d7c15e42e;
var $3dde5b55d2091270$export$e9d537d9770bf7d7;
var $3dde5b55d2091270$export$1f34108aa9eb96ab;
var $3dde5b55d2091270$export$2b8348e3a05ebc92;
var $3dde5b55d2091270$export$795623e8105ba10a;
var $3dde5b55d2091270$export$a7f6f0e4ac9fde68;
var $3dde5b55d2091270$export$33c318ca909f6b6;
$3dde5b55d2091270$export$a7db06668cad9adb = "content_1688eb";
$3dde5b55d2091270$export$755d7ed31a25e0fb = "sliderContainer_1688eb";
$3dde5b55d2091270$export$12badc1a4c058bdf = "inputRow_1688eb";
$3dde5b55d2091270$export$b7e3ae3d7c15e42e = "input_1688eb";
$3dde5b55d2091270$export$e9d537d9770bf7d7 = "durationAndPlayBtn_1688eb";
$3dde5b55d2091270$export$1f34108aa9eb96ab = "duration_1688eb";
$3dde5b55d2091270$export$2b8348e3a05ebc92 = "listenButton_1688eb";
$3dde5b55d2091270$export$795623e8105ba10a = "actionBar_1688eb";
$3dde5b55d2091270$export$a7f6f0e4ac9fde68 = "buttonReset_1688eb";
$3dde5b55d2091270$export$33c318ca909f6b6 = "extender_1688eb";





const $77f1e7c43da53f17$export$278f9aed9ac4cd51 = 1; // in seconds
// Shortcut to round numbers
const $77f1e7c43da53f17$var$r = (n)=>(0, $1abea94550147a73$export$360dc50351b2b778)(n || 0, 2);
const $77f1e7c43da53f17$var$findCloserStep = (type, value)=>{
    const val = value ? $77f1e7c43da53f17$var$r(value) : undefined;
    if (val === 0 || val === undefined) return 0;
    if (type === "start" && val > 0) return 0;
    if (type === "end" && val < 0) return 0;
    let currentStep = $77f1e7c43da53f17$export$278f9aed9ac4cd51;
    while(currentStep % val >= 1)currentStep += $77f1e7c43da53f17$export$278f9aed9ac4cd51;
    return currentStep;
};
function $77f1e7c43da53f17$var$getOffsets(info, defaultStartOffset, defaultEndOffset) {
    const offsets = {
        start: defaultStartOffset,
        end: defaultEndOffset
    };
    if (typeof info?.humanStart === "number" && typeof info?.start === "number") offsets.start = info.humanStart - info.start;
    if (typeof info?.humanEnd === "number" && typeof info?.end === "number") offsets.end = info.humanEnd - info.end;
    return offsets;
}
function $77f1e7c43da53f17$export$2e2bcd8739ae039({ recording: recording, projectId: projectId, info: info, onDone: onDone, defaultStartOffset: defaultStartOffset, defaultEndOffset: defaultEndOffset }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const offsets = (0, $jMaZ8.useMemo)(()=>$77f1e7c43da53f17$var$getOffsets(info, defaultStartOffset, defaultEndOffset), [
        info,
        defaultStartOffset,
        defaultEndOffset
    ]);
    const [startOffset, setStartOffset] = (0, $jMaZ8.useState)(offsets.start || undefined);
    const [endOffset, setEndOffset] = (0, $jMaZ8.useState)(offsets.end || undefined);
    const audioContext = (0, $jMaZ8.useMemo)(()=>new AudioContext(), []);
    const buffer = (0, $687fa3f0b9644934$export$2e2bcd8739ae039)(audioContext, recording);
    const audioSource = (0, $687fa3f0b9644934$export$9f3a03c3a88b5d01)(audioContext, buffer);
    const [applyUpdateAudioRhese] = (0, $d7188398173686a1$export$d9548d661fab1b01)();
    /**
   * Shorthands
   */ const { minOffsetStart: minOffsetStart, maxOffsetStart: maxOffsetStart, minOffsetEnd: minOffsetEnd, maxOffsetEnd: maxOffsetEnd } = (0, $jMaZ8.useMemo)(()=>{
        const { buffer: buffer } = audioSource;
        if (!buffer || !info) return {
            minOffsetStart: 0,
            maxOffsetStart: 0,
            minOffsetEnd: 0,
            maxOffsetEnd: 0
        };
        return {
            minOffsetStart: $77f1e7c43da53f17$var$r(-(info.start || 0)),
            maxOffsetStart: $77f1e7c43da53f17$var$r(buffer.duration - (info.start || 0)),
            minOffsetEnd: $77f1e7c43da53f17$var$r(-(info.end || 0)),
            maxOffsetEnd: $77f1e7c43da53f17$var$r(buffer.duration - (info.end || 0))
        };
    }, [
        audioSource,
        info
    ]);
    const playInfoStart = $77f1e7c43da53f17$var$r((info?.start || 0) + (startOffset || 0));
    const playInfoEnd = $77f1e7c43da53f17$var$r((info?.end || 0) + (endOffset || 0));
    const playInfoDuration = $77f1e7c43da53f17$var$r(playInfoEnd - playInfoStart);
    const isDurationInvalid = playInfoDuration < 0;
    const fullAudioDuration = $77f1e7c43da53f17$var$r(buffer?.duration);
    /**
   * Handlers
   */ const play = (0, $jMaZ8.useCallback)((offset, duration)=>{
        if (duration <= 0) return;
        const audioSource = (0, $687fa3f0b9644934$export$9f3a03c3a88b5d01)(audioContext, buffer);
        audioSource.start(0, offset, duration);
    }, [
        audioContext,
        buffer
    ]);
    const validate = (0, $jMaZ8.useCallback)(()=>{
        applyUpdateAudioRhese({
            variables: {
                projectId: projectId,
                audioRheseId: info.id,
                humanStart: playInfoStart,
                humanEnd: playInfoEnd
            }
        });
        onDone();
    }, [
        applyUpdateAudioRhese,
        projectId,
        info.id,
        playInfoStart,
        playInfoEnd,
        onDone
    ]);
    const onReset = (0, $jMaZ8.useCallback)(()=>{
        applyUpdateAudioRhese({
            variables: {
                projectId: projectId,
                audioRheseId: info.id,
                humanStart: null,
                humanEnd: null
            }
        });
        onDone();
    }, [
        applyUpdateAudioRhese,
        info.id,
        onDone,
        projectId
    ]);
    /**
   * Slider
   */ const sliderDefaultValues = (0, $jMaZ8.useMemo)(()=>{
        let sliderStart = info?.start || 0;
        let sliderEnd = info?.end || 0;
        if (typeof info?.humanStart === "number" && info.humanStart !== -1) sliderStart = info.humanStart;
        if (typeof info?.humanEnd === "number" && info.humanEnd !== -1) sliderEnd = info.humanEnd;
        return {
            start: $77f1e7c43da53f17$var$r(sliderStart),
            end: $77f1e7c43da53f17$var$r(sliderEnd)
        };
    }, [
        info
    ]);
    // Additional time before.after start/end extremities
    const [additionalTimeBefore, setAdditionalTimeBefore] = (0, $jMaZ8.useState)($77f1e7c43da53f17$var$findCloserStep("start", startOffset));
    const [additionalTimeAfter, setAdditionalTimeAfter] = (0, $jMaZ8.useState)($77f1e7c43da53f17$var$findCloserStep("end", endOffset));
    /**
   * Inputs
   */ const onInputChange = (0, $jMaZ8.useCallback)((type)=>(e)=>{
            let value = Number(e.target.value);
            if (type === "start") {
                if (value < -additionalTimeBefore) {
                    setStartOffset(-additionalTimeBefore);
                    return;
                }
                if (value < minOffsetStart) value = minOffsetStart;
                if (value > maxOffsetStart) value = maxOffsetStart;
                const val = $77f1e7c43da53f17$var$r(value);
                setLastInputStartOffset(val);
                setStartOffset(val);
            } else {
                if (value > additionalTimeAfter) {
                    setEndOffset(additionalTimeAfter);
                    return;
                }
                if (value < minOffsetEnd) value = minOffsetEnd;
                if (value > maxOffsetEnd) value = maxOffsetEnd;
                const val = $77f1e7c43da53f17$var$r(value);
                setLastInputEndOffset(-val);
                setEndOffset(val);
            }
        }, [
        maxOffsetEnd,
        maxOffsetStart,
        minOffsetEnd,
        minOffsetStart,
        additionalTimeBefore,
        additionalTimeAfter
    ]);
    // Needed to sync the slider after input changed manually
    const [lastInputStartOffset, setLastInputStartOffset] = (0, $jMaZ8.useState)(startOffset);
    const [lastInputEndOffset, setLastInputEndOffset] = (0, $jMaZ8.useState)(startOffset);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $3dde5b55d2091270$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $3dde5b55d2091270$export$755d7ed31a25e0fb,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2f3cf3b571dec6ea$export$2e2bcd8739ae039), {
                        defaultStart: sliderDefaultValues.start,
                        defaultEnd: sliderDefaultValues.end,
                        originalStart: $77f1e7c43da53f17$var$r(info?.start),
                        originalEnd: $77f1e7c43da53f17$var$r(info?.end),
                        additionalTimeBefore: additionalTimeBefore,
                        additionalTimeAfter: additionalTimeAfter,
                        setStartOffset: setStartOffset,
                        setEndOffset: setEndOffset,
                        lastInputStartOffset: lastInputStartOffset,
                        lastInputEndOffset: lastInputEndOffset
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f905586a4fe1bb14$export$2e2bcd8739ae039), {
                        playInfoEnd: playInfoEnd,
                        playInfoDuration: playInfoDuration,
                        fullAudioDuration: fullAudioDuration,
                        minOffsetStart: minOffsetStart,
                        hasMaxOffsetEnd: !!maxOffsetEnd,
                        additionalTimeBefore: additionalTimeBefore,
                        additionalTimeAfter: additionalTimeAfter,
                        setAdditionalTimeBefore: setAdditionalTimeBefore,
                        setAdditionalTimeAfter: setAdditionalTimeAfter,
                        sliderDefaultValues: sliderDefaultValues
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $f8244435bdab5821$export$2e2bcd8739ae039), {
                className: $3dde5b55d2091270$export$12badc1a4c058bdf,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        className: $3dde5b55d2091270$export$b7e3ae3d7c15e42e,
                        // "0" value will prevent from typing negative values
                        // @ts-expect-error
                        value: startOffset !== 0 && startOffset !== undefined ? $77f1e7c43da53f17$var$r(startOffset) : null,
                        onChange: onInputChange("start"),
                        step: 0.05,
                        type: "number",
                        placeholder: t("startOffset")
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        className: $3dde5b55d2091270$export$e9d537d9770bf7d7,
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                                className: $3dde5b55d2091270$export$1f34108aa9eb96ab,
                                children: `${playInfoDuration.toFixed(2)} s`
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                disabled: isDurationInvalid,
                                onClick: ()=>play(playInfoStart, playInfoDuration),
                                className: $3dde5b55d2091270$export$2b8348e3a05ebc92,
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $271ab9cb7ddc7c14$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $33ddf20ce3e4db52$export$2e2bcd8739ae039), {
                        className: $3dde5b55d2091270$export$b7e3ae3d7c15e42e,
                        // "0" value will prevent from typing negative values
                        // @ts-expect-error
                        value: endOffset !== 0 && endOffset !== undefined ? $77f1e7c43da53f17$var$r(endOffset) : null,
                        onChange: onInputChange("end"),
                        step: 0.05,
                        type: "number",
                        placeholder: t("endOffset")
                    })
                ]
            }),
            isDurationInvalid && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                children: t("offsetConfigIsInvalid")
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $3dde5b55d2091270$export$795623e8105ba10a,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        shape: "round",
                        onClick: onDone,
                        children: t("cancel")
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $3dde5b55d2091270$export$33c318ca909f6b6
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        shape: "round",
                        onClick: onReset,
                        className: $3dde5b55d2091270$export$a7f6f0e4ac9fde68,
                        children: t("reset")
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        onClick: validate,
                        disabled: isDurationInvalid,
                        type: "primary",
                        shape: "round",
                        children: t("apply")
                    })
                ]
            })
        ]
    });
}




var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");
var $82634d27f391dd58$export$2e2bcd8739ae039 = (0, $jMaZ8.useLayoutEffect);



var $jMaZ8 = parcelRequire("jMaZ8");
function $8f032c4781985836$export$2e2bcd8739ae039(fn) {
    var ref = $jMaZ8.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}


var $02871aea04ef26e7$exports = {};
'use strict';

$02871aea04ef26e7$exports = (parcelRequire("fgROT"));


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $d673ecfaee2e9387$export$18ce0697a983be9b = function() {
    $d673ecfaee2e9387$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d673ecfaee2e9387$export$18ce0697a983be9b.apply(this, arguments);
};
function $d673ecfaee2e9387$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d673ecfaee2e9387$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d673ecfaee2e9387$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d673ecfaee2e9387$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}


var $ced0358ebd8555c7$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($ced0358ebd8555c7$export$1385d81a6c6bbcd4 || ($ced0358ebd8555c7$export$1385d81a6c6bbcd4 = {}));
var $ced0358ebd8555c7$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($ced0358ebd8555c7$export$79f5baa747fbdd45 || ($ced0358ebd8555c7$export$79f5baa747fbdd45 = {}));



var $170ac7d10b246030$export$b060f3cec92ef5c9 = '.';
var $170ac7d10b246030$export$505a390a702f4a23 = {};
var $170ac7d10b246030$export$656461011b562379 = 'xstate.guard';
var $170ac7d10b246030$export$31935b4577455331 = '';





var $9d349e867592e6e3$export$b3571188c770cc5a = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Start;
var $9d349e867592e6e3$export$fa6813432f753b0d = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Stop;
var $9d349e867592e6e3$export$66313c302b2ea154 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Raise;
var $9d349e867592e6e3$export$89db4734f6c919c4 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Send;
var $9d349e867592e6e3$export$70b61ad426ddbe54 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Cancel;
var $9d349e867592e6e3$export$9477ceca5dcd796a = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).NullEvent;
var $9d349e867592e6e3$export$e6e34fd1f2686227 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Assign;
var $9d349e867592e6e3$export$742acabee3dd6465 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).After;
var $9d349e867592e6e3$export$de2557b5933c9ac6 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).DoneState;
var $9d349e867592e6e3$export$bef1f36f5486a6a3 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Log;
var $9d349e867592e6e3$export$2cd8252107eb640b = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Init;
var $9d349e867592e6e3$export$468cda29b159ee5d = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Invoke;
var $9d349e867592e6e3$export$aca059ee6fbf94e8 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).ErrorExecution;
var $9d349e867592e6e3$export$503a23d0e5cd1226 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).ErrorPlatform;
var $9d349e867592e6e3$export$a3bc9b8ed74fc = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).ErrorCustom;
var $9d349e867592e6e3$export$722fbec263ad908a = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Update;
var $9d349e867592e6e3$export$7877a478dd30fd3d = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Choose;
var $9d349e867592e6e3$export$48ec4a2b1cfc6557 = (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Pure;



var $d8de3fe873bcabc2$export$9b5f2e1c20ef6571 = false;


var $1acd3d55d84916d2$var$_a;
function $1acd3d55d84916d2$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $1acd3d55d84916d2$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $170ac7d10b246030$export$b060f3cec92ef5c9);
    var parentStateValue = $1acd3d55d84916d2$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $1acd3d55d84916d2$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($1acd3d55d84916d2$export$844ec244b1367d54(childStateValue)) {
        if ($1acd3d55d84916d2$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($1acd3d55d84916d2$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $1acd3d55d84916d2$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $1acd3d55d84916d2$export$7193fc8c8cd445e9(event) {
    try {
        return $1acd3d55d84916d2$export$844ec244b1367d54(event) || typeof event === 'number' ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error('Events must be strings or objects with a string event.type property.');
    }
}
function $1acd3d55d84916d2$export$e303144c5506946a(action) {
    try {
        return $1acd3d55d84916d2$export$844ec244b1367d54(action) || typeof action === 'number' ? "".concat(action) : $1acd3d55d84916d2$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error('Actions must be strings or objects with a string action.type property.');
    }
}
function $1acd3d55d84916d2$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($1acd3d55d84916d2$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $1acd3d55d84916d2$export$e080e3931a079c9b(state) {
    return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function $1acd3d55d84916d2$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($1acd3d55d84916d2$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($1acd3d55d84916d2$export$43bee75e5e14138e(stateValue)) return $1acd3d55d84916d2$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== 'string') return stateValue;
    var statePath = $1acd3d55d84916d2$export$304cde62ecda7af8(stateValue, delimiter);
    return $1acd3d55d84916d2$export$f2ee84fc53c45e74(statePath);
}
function $1acd3d55d84916d2$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $1acd3d55d84916d2$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $1acd3d55d84916d2$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $1acd3d55d84916d2$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $1acd3d55d84916d2$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $1acd3d55d84916d2$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($1acd3d55d84916d2$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $1acd3d55d84916d2$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $1acd3d55d84916d2$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $1acd3d55d84916d2$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $1acd3d55d84916d2$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(array), false));
}
function $1acd3d55d84916d2$export$2c0b6b2f4faf21e1(value) {
    if ($1acd3d55d84916d2$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $1acd3d55d84916d2$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $1acd3d55d84916d2$export$2c0b6b2f4faf21e1(value);
}
function $1acd3d55d84916d2$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($1acd3d55d84916d2$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($1acd3d55d84916d2$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $1acd3d55d84916d2$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $1acd3d55d84916d2$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($1acd3d55d84916d2$export$f6e2535fb5126e54(value) || typeof value === 'object') && $1acd3d55d84916d2$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $1acd3d55d84916d2$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}
function $1acd3d55d84916d2$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $d673ecfaee2e9387$export$8d051b38c9118094)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $1acd3d55d84916d2$export$3737909a0074eb1(hist, stateValue) {
    return $1acd3d55d84916d2$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($1acd3d55d84916d2$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $1acd3d55d84916d2$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $1acd3d55d84916d2$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $1acd3d55d84916d2$export$3737909a0074eb1(hist, stateValue)
    };
}
function $1acd3d55d84916d2$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) $1acd3d55d84916d2$export$c106dd0671a0fc2d(!!context, 'Attempting to update undefined context');
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($1acd3d55d84916d2$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $1acd3d55d84916d2$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $1acd3d55d84916d2$export$c106dd0671a0fc2d = function() {};
if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) $1acd3d55d84916d2$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $1acd3d55d84916d2$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $1acd3d55d84916d2$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $1acd3d55d84916d2$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $1acd3d55d84916d2$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($1acd3d55d84916d2$export$844ec244b1367d54(condition)) return {
        type: (0, $170ac7d10b246030$export$656461011b562379),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($1acd3d55d84916d2$export$f6e2535fb5126e54(condition)) return {
        type: (0, $170ac7d10b246030$export$656461011b562379),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $1acd3d55d84916d2$export$5cd057a6046189f9(value) {
    try {
        return 'subscribe' in value && $1acd3d55d84916d2$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $1acd3d55d84916d2$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $1acd3d55d84916d2$export$a6273dafbee7f61e = ($1acd3d55d84916d2$var$_a = {}, $1acd3d55d84916d2$var$_a[$1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
    return this;
}, $1acd3d55d84916d2$var$_a[Symbol.observable] = function() {
    return this;
}, $1acd3d55d84916d2$var$_a);
function $1acd3d55d84916d2$export$2163e7903738b5df(value) {
    return !!value && '__xstatenode' in value;
}
function $1acd3d55d84916d2$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === 'function';
}
var $1acd3d55d84916d2$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $1acd3d55d84916d2$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($1acd3d55d84916d2$export$844ec244b1367d54(event) || typeof event === 'number') return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
        type: event
    }, payload);
    return event;
}
function $1acd3d55d84916d2$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$1acd3d55d84916d2$export$844ec244b1367d54(event) && '$$type' in event && event.$$type === 'scxml') return event;
    var eventObject = $1acd3d55d84916d2$export$5a4ea50826a01d14(event);
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
        name: eventObject.type,
        data: eventObject,
        $$type: 'scxml',
        type: 'external'
    }, scxmlEvent);
}
function $1acd3d55d84916d2$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $1acd3d55d84916d2$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $1acd3d55d84916d2$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $1acd3d55d84916d2$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $170ac7d10b246030$export$31935b4577455331)) return undefined;
    return $1acd3d55d84916d2$export$45b10814cc054894(target);
}
function $1acd3d55d84916d2$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $1acd3d55d84916d2$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $170ac7d10b246030$export$656461011b562379)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $1acd3d55d84916d2$export$436e852aa2feda95(src) {
    if (typeof src === 'string') return {
        type: src
    };
    return src;
}
function $1acd3d55d84916d2$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === 'object';
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $1acd3d55d84916d2$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $1acd3d55d84916d2$export$37dc2eda56cb25a5(action) {
    return (action.type === (0, $9d349e867592e6e3$export$66313c302b2ea154) || action.type === (0, $9d349e867592e6e3$export$89db4734f6c919c4) && action.to === (0, $ced0358ebd8555c7$export$79f5baa747fbdd45).Internal) && typeof action.delay !== 'number';
}




var $14e4d0cc3d7f7a29$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === 'atomic' || stateNode.type === 'final';
};
function $14e4d0cc3d7f7a29$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $14e4d0cc3d7f7a29$export$f8cf48ee793b41be(stateNode) {
    return $14e4d0cc3d7f7a29$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== 'history';
    });
}
function $14e4d0cc3d7f7a29$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($14e4d0cc3d7f7a29$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $1acd3d55d84916d2$export$bffa455ba8c619a6)($14e4d0cc3d7f7a29$export$f8cf48ee793b41be(stateNode).map($14e4d0cc3d7f7a29$export$3de19bba299e3801)));
}
function $14e4d0cc3d7f7a29$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $14e4d0cc3d7f7a29$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $14e4d0cc3d7f7a29$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === 'parallel') try {
                    for(var _e = (e_3 = void 0, (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)($14e4d0cc3d7f7a29$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $14e4d0cc3d7f7a29$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($14e4d0cc3d7f7a29$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $14e4d0cc3d7f7a29$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $14e4d0cc3d7f7a29$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $14e4d0cc3d7f7a29$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $14e4d0cc3d7f7a29$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $14e4d0cc3d7f7a29$var$getValueFromAdj(rootNode, $14e4d0cc3d7f7a29$export$b837d8c2d0189d63(config));
}
function $14e4d0cc3d7f7a29$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $14e4d0cc3d7f7a29$export$c661ab6895e3ed73(configuration) {
    return (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(new Set((0, $1acd3d55d84916d2$export$bffa455ba8c619a6)((0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $14e4d0cc3d7f7a29$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === 'compound') return $14e4d0cc3d7f7a29$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === 'final' && $14e4d0cc3d7f7a29$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === 'parallel') return $14e4d0cc3d7f7a29$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $14e4d0cc3d7f7a29$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $14e4d0cc3d7f7a29$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $14e4d0cc3d7f7a29$export$5301196121335ca0(configuration) {
    return new Set((0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(configuration.map(function(sn) {
        return sn.tags;
    })));
}







var $a9a38c9455eb1d63$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $1acd3d55d84916d2$export$eaf22249b410f633)({
    type: (0, $9d349e867592e6e3$export$2cd8252107eb640b)
});
function $a9a38c9455eb1d63$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $a9a38c9455eb1d63$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(action) || typeof action === 'number') {
        var exec = $a9a38c9455eb1d63$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $a9a38c9455eb1d63$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(exec)) actionObject = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $a9a38c9455eb1d63$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $1acd3d55d84916d2$export$43bee75e5e14138e)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $a9a38c9455eb1d63$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $a9a38c9455eb1d63$export$e81fdd8937d44864(action) {
    var actionObject = $a9a38c9455eb1d63$export$b38b66cc2da3ede7(action);
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
        id: (0, $1acd3d55d84916d2$export$844ec244b1367d54)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $a9a38c9455eb1d63$export$66313c302b2ea154(event, options) {
    return {
        type: (0, $9d349e867592e6e3$export$66313c302b2ea154),
        event: typeof event === 'function' ? event : (0, $1acd3d55d84916d2$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $a9a38c9455eb1d63$export$ed3daf8e935ede01(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, $1acd3d55d84916d2$export$eaf22249b410f633)((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, action), {
        type: (0, $9d349e867592e6e3$export$66313c302b2ea154),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $a9a38c9455eb1d63$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $9d349e867592e6e3$export$89db4734f6c919c4),
        event: (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(event) ? event : (0, $1acd3d55d84916d2$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(event) ? event.name : (0, $1acd3d55d84916d2$export$7193fc8c8cd445e9)(event)
    };
}
function $a9a38c9455eb1d63$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $1acd3d55d84916d2$export$eaf22249b410f633)((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $a9a38c9455eb1d63$export$408d8d51fa351f53(event, options) {
    return $a9a38c9455eb1d63$export$89db4734f6c919c4(event, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, options), {
        to: (0, $ced0358ebd8555c7$export$79f5baa747fbdd45).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $a9a38c9455eb1d63$export$daa976aaff721e41(actor, event, options) {
    return $a9a38c9455eb1d63$export$89db4734f6c919c4(event, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $a9a38c9455eb1d63$export$7f8b724299523eb6() {
    return $a9a38c9455eb1d63$export$408d8d51fa351f53((0, $9d349e867592e6e3$export$722fbec263ad908a));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $a9a38c9455eb1d63$export$72b816ae90496f19(event, options) {
    return $a9a38c9455eb1d63$export$89db4734f6c919c4(event, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $a9a38c9455eb1d63$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $a9a38c9455eb1d63$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $a9a38c9455eb1d63$var$defaultLogExpr;
    return {
        type: (0, $9d349e867592e6e3$export$bef1f36f5486a6a3),
        label: label,
        expr: expr
    };
}
var $a9a38c9455eb1d63$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, action), {
        value: (0, $1acd3d55d84916d2$export$844ec244b1367d54)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $a9a38c9455eb1d63$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $9d349e867592e6e3$export$70b61ad426ddbe54),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $a9a38c9455eb1d63$export$b3571188c770cc5a(activity) {
    var activityDef = $a9a38c9455eb1d63$export$e81fdd8937d44864(activity);
    return {
        type: (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $a9a38c9455eb1d63$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(actorRef) ? actorRef : $a9a38c9455eb1d63$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Stop,
        activity: activity,
        exec: undefined
    };
}
function $a9a38c9455eb1d63$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === 'string' ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $a9a38c9455eb1d63$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $9d349e867592e6e3$export$e6e34fd1f2686227),
        assignment: assignment
    };
};
function $a9a38c9455eb1d63$export$6e816592f80fc079(action) {
    return typeof action === 'object' && 'type' in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $a9a38c9455eb1d63$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : '';
    return "".concat((0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $a9a38c9455eb1d63$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $a9a38c9455eb1d63$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $a9a38c9455eb1d63$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $a9a38c9455eb1d63$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $a9a38c9455eb1d63$export$eb147b7589db8e8a(target, options) {
    if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571) && (!target || typeof target === 'function')) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === 'function' ? originalTarget_1.apply(void 0, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $a9a38c9455eb1d63$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $a9a38c9455eb1d63$export$f514678a4137c4d6(errorData, options) {
    return $a9a38c9455eb1d63$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $9d349e867592e6e3$export$a3bc9b8ed74fc),
            data: (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, options), {
        to: (0, $ced0358ebd8555c7$export$79f5baa747fbdd45).Parent
    }));
}
function $a9a38c9455eb1d63$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Choose,
        conds: conds
    };
}
var $a9a38c9455eb1d63$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, $9d349e867592e6e3$export$e6e34fd1f2686227)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $a9a38c9455eb1d63$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $a9a38c9455eb1d63$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $1acd3d55d84916d2$export$d84706064a6e6c1c)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $9d349e867592e6e3$export$66313c302b2ea154:
                var raisedAction = $a9a38c9455eb1d63$export$ed3daf8e935ede01(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === 'number') predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, $9d349e867592e6e3$export$89db4734f6c919c4:
                var sendAction = $a9a38c9455eb1d63$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(!(0, $1acd3d55d84916d2$export$844ec244b1367d54)(configuredDelay) || typeof sendAction.delay === 'number', "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, $ced0358ebd8555c7$export$79f5baa747fbdd45).Internal) {
                    if (blockType === 'entry') deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, $9d349e867592e6e3$export$bef1f36f5486a6a3:
                var resolved = $a9a38c9455eb1d63$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $9d349e867592e6e3$export$7877a478dd30fd3d:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $1acd3d55d84916d2$export$b0f5a08e0ca47933)(condition.cond, machine.options.guards);
                    return !guard || (0, $1acd3d55d84916d2$export$91646ab912d254e8)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $d673ecfaee2e9387$export$8d051b38c9118094)($a9a38c9455eb1d63$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $a9a38c9455eb1d63$export$aa68691f32e6c459((0, $1acd3d55d84916d2$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $9d349e867592e6e3$export$48ec4a2b1cfc6557:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $d673ecfaee2e9387$export$8d051b38c9118094)($a9a38c9455eb1d63$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $a9a38c9455eb1d63$export$aa68691f32e6c459((0, $1acd3d55d84916d2$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $9d349e867592e6e3$export$fa6813432f753b0d:
                var resolved = $a9a38c9455eb1d63$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $9d349e867592e6e3$export$e6e34fd1f2686227:
                updatedContext = (0, $1acd3d55d84916d2$export$d84706064a6e6c1c)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $a9a38c9455eb1d63$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([
                                preservedContexts[contextIndex_1]
                            ], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}



function $93a7122c7e43444e$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(a) || (0, $1acd3d55d84916d2$export$844ec244b1367d54)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $93a7122c7e43444e$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $93a7122c7e43444e$export$4c86eb6450eda77a(state) {
    if (typeof state !== 'object' || state === null) return false;
    return 'value' in state && '_event' in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $93a7122c7e43444e$export$e5d60a6bbabd36f = $93a7122c7e43444e$export$4c86eb6450eda77a;
function $93a7122c7e43444e$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $93a7122c7e43444e$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $170ac7d10b246030$export$505a390a702f4a23);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $170ac7d10b246030$export$505a390a702f4a23);
        this.meta = (0, $14e4d0cc3d7f7a29$export$c47913ca32a5c6f7)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, 'nextEvents', {
            get: function() {
                return (0, $14e4d0cc3d7f7a29$export$c661ab6895e3ed73)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $a9a38c9455eb1d63$export$163c566c60ed2ec9);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $a9a38c9455eb1d63$export$163c566c60ed2ec9);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = '.';
        if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $d673ecfaee2e9387$export$3c9a16f847548506)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $1acd3d55d84916d2$export$2870710bf0eac88e)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();







var $a99c055c2a33b4b4$var$defaultOptions = {
    deferEvents: false
};
var $a99c055c2a33b4b4$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, $a99c055c2a33b4b4$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error('Event queue should be empty when it is not processing events');
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();




/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $f98f0276adb79254$var$serviceStack = [];
var $f98f0276adb79254$export$abe1e183e22e10ad = function(service, fn) {
    $f98f0276adb79254$var$serviceStack.push(service);
    var result = fn(service);
    $f98f0276adb79254$var$serviceStack.pop();
    return result;
};
var $f98f0276adb79254$export$e11e6a155c5c4d9d = function(fn) {
    return fn($f98f0276adb79254$var$serviceStack[$f98f0276adb79254$var$serviceStack.length - 1]);
};


function $5520c5ffd3a671cd$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $5520c5ffd3a671cd$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $1acd3d55d84916d2$export$436e852aa2feda95)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $1acd3d55d84916d2$export$e756e60189cc2351)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $5520c5ffd3a671cd$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $5520c5ffd3a671cd$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $5520c5ffd3a671cd$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $5520c5ffd3a671cd$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $1acd3d55d84916d2$export$2163e7903738b5df)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $f98f0276adb79254$export$abe1e183e22e10ad)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $5520c5ffd3a671cd$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === 'function';
    } catch (e) {
        return false;
    }
}
function $5520c5ffd3a671cd$export$b0f989039dc164f9(item) {
    return $5520c5ffd3a671cd$export$e769f6913f14f1b7(item) && 'id' in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $5520c5ffd3a671cd$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: 'anonymous',
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a), actorRefLike);
}


var $354d996f0fbf0814$var$children = /*#__PURE__*/ new Map();
var $354d996f0fbf0814$var$sessionIdIndex = 0;
var $354d996f0fbf0814$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($354d996f0fbf0814$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $354d996f0fbf0814$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $354d996f0fbf0814$var$children.get(id);
    },
    free: function(id) {
        $354d996f0fbf0814$var$children.delete(id);
    }
};



function $a51bbcc4a46e1984$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
}
function $a51bbcc4a46e1984$var$getDevTools() {
    var global = $a51bbcc4a46e1984$export$a4e55266d2135a7f();
    if (global && '__xstate__' in global) return global.__xstate__;
    return undefined;
}
function $a51bbcc4a46e1984$export$4d7a7d14704ebc13(service) {
    if (!$a51bbcc4a46e1984$export$a4e55266d2135a7f()) return;
    var devTools = $a51bbcc4a46e1984$var$getDevTools();
    if (devTools) devTools.register(service);
}






/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $9a09b5faf3311edb$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $9a09b5faf3311edb$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: 'pending'
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case 'fulfill':
                    parent === null || parent === void 0 || parent.send((0, $a9a38c9455eb1d63$export$c105e588793f70b4)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: 'fulfilled'
                    };
                case 'reject':
                    parent === null || parent === void 0 || parent.send((0, $a9a38c9455eb1d63$export$a3bc9b8ed74fc)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: 'rejected'
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: 'fulfill',
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: 'reject',
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $9a09b5faf3311edb$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $5520c5ffd3a671cd$export$ccadea5f6b9e9b4e)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $1acd3d55d84916d2$export$75b67481063f2f98)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || 'anonymous',
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}


var $30e2e977433e6273$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $30e2e977433e6273$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($30e2e977433e6273$export$7a567c9c5088a551 || ($30e2e977433e6273$export$7a567c9c5088a551 = {}));
var $30e2e977433e6273$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $30e2e977433e6273$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $1acd3d55d84916d2$export$43bee75e5e14138e)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $1acd3d55d84916d2$export$eaf22249b410f633)((0, $1acd3d55d84916d2$export$5a4ea50826a01d14)(event1, payload));
            if (_this.status === $30e2e977433e6273$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $30e2e977433e6273$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $ced0358ebd8555c7$export$79f5baa747fbdd45).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $1acd3d55d84916d2$export$844ec244b1367d54)(to) ? to === (0, $ced0358ebd8555c7$export$79f5baa747fbdd45).Internal ? _this : _this.children.get(to) || (0, $354d996f0fbf0814$export$4bb7493d241fd8a5).get(to) : (0, $1acd3d55d84916d2$export$e769f6913f14f1b7)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ('machine' in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $30e2e977433e6273$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, event1), {
                        name: event1.name === (0, $9d349e867592e6e3$export$a3bc9b8ed74fc) ? "".concat((0, $a9a38c9455eb1d63$export$a3bc9b8ed74fc)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $a9a38c9455eb1d63$export$c7e5ca927bd4567)(action.type, actionFunctionMap);
            var exec = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: 'xstate.error',
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $9d349e867592e6e3$export$66313c302b2ea154:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, $9d349e867592e6e3$export$89db4734f6c919c4:
                    var sendAction = action;
                    if (typeof sendAction.delay === 'number') {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $a9a38c9455eb1d63$export$163c566c60ed2ec9));
                    else _this.send(sendAction._event);
                    break;
                case 0, $9d349e867592e6e3$export$70b61ad426ddbe54:
                    _this.cancel(action.sendId);
                    break;
                case 0, $9d349e867592e6e3$export$b3571188c770cc5a:
                    if (_this.status !== $30e2e977433e6273$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $ced0358ebd8555c7$export$1385d81a6c6bbcd4).Invoke) {
                        var invokeSource = (0, $1acd3d55d84916d2$export$436e852aa2feda95)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(!('forward' in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $1acd3d55d84916d2$export$e756e60189cc2351)(data, context, _event) : undefined;
                        if (typeof serviceCreator === 'string') // TODO: warn
                        return;
                        var source = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $1acd3d55d84916d2$export$2163e7903738b5df)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $9d349e867592e6e3$export$fa6813432f753b0d:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $9d349e867592e6e3$export$bef1f36f5486a6a3:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $a99c055c2a33b4b4$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $354d996f0fbf0814$export$4bb7493d241fd8a5).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $f98f0276adb79254$export$abe1e183e22e10ad)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(this.status !== $30e2e977433e6273$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $a9a38c9455eb1d63$export$163c566c60ed2ec9)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === 'final' && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $1acd3d55d84916d2$export$e756e60189cc2351)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, $a9a38c9455eb1d63$export$c105e588793f70b4)(this.id, doneData);
            try {
                for(var _l = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, $354d996f0fbf0814$export$4bb7493d241fd8a5).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $30e2e977433e6273$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $1acd3d55d84916d2$export$75b67481063f2f98)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $30e2e977433e6273$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $30e2e977433e6273$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === $30e2e977433e6273$export$7a567c9c5088a551.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $30e2e977433e6273$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $354d996f0fbf0814$export$4bb7493d241fd8a5).register(this.sessionId, this);
        this.initialized = true;
        this.status = $30e2e977433e6273$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $f98f0276adb79254$export$abe1e183e22e10ad)(this, function() {
            return (0, $93a7122c7e43444e$export$4c86eb6450eda77a)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $93a7122c7e43444e$export$7254cc27399e90bd).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $a9a38c9455eb1d63$export$163c566c60ed2ec9));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $30e2e977433e6273$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $a99c055c2a33b4b4$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            var _a;
            if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) return;
             // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $1acd3d55d84916d2$export$eaf22249b410f633)({
                type: 'xstate.stop'
            });
            var nextState = (0, $f98f0276adb79254$export$abe1e183e22e10ad)(_this, function() {
                var exitActions = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)((0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $a9a38c9455eb1d63$export$aa68691f32e6c459)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $d673ecfaee2e9387$export$8d051b38c9118094)((0, $a9a38c9455eb1d63$export$b8b9e7ba5b8c7b3e)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: 'exit',
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $93a7122c7e43444e$export$7254cc27399e90bd)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, $1acd3d55d84916d2$export$37dc2eda56cb25a5)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $354d996f0fbf0814$export$4bb7493d241fd8a5).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $30e2e977433e6273$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
        } else if (this.status !== $30e2e977433e6273$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $1acd3d55d84916d2$export$eaf22249b410f633)(event_1);
                _this.forward(_event);
                nextState = (0, $f98f0276adb79254$export$abe1e183e22e10ad)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $93a7122c7e43444e$export$e42513ad58964418)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $1acd3d55d84916d2$export$eaf22249b410f633)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $1acd3d55d84916d2$export$eaf22249b410f633)(event1);
        if (_event.name.indexOf((0, $9d349e867592e6e3$export$503a23d0e5cd1226)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $9d349e867592e6e3$export$503a23d0e5cd1226)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $f98f0276adb79254$export$abe1e183e22e10ad)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ('to' in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $30e2e977433e6273$export$7a567c9c5088a551.Running) return (0, $5520c5ffd3a671cd$export$59bcb51d8e40ed48)(entity, name);
        if ((0, $1acd3d55d84916d2$export$ae936b9d47e5870e)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $5520c5ffd3a671cd$export$b0f989039dc164f9)(entity)) return this.spawnActor(entity, name);
        else if ((0, $1acd3d55d84916d2$export$5cd057a6046189f9)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $1acd3d55d84916d2$export$2163e7903738b5df)(entity)) return this.spawnMachine(entity, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, options), {
            id: name
        }));
        else if ((0, $1acd3d55d84916d2$export$42749ebe1e7fdef7)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, $30e2e977433e6273$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $9d349e867592e6e3$export$722fbec263ad908a), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $1acd3d55d84916d2$export$eaf22249b410f633)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $9a09b5faf3311edb$export$cc3859917b3feaf8)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $1acd3d55d84916d2$export$eaf22249b410f633)((0, $a9a38c9455eb1d63$export$c105e588793f70b4)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $a9a38c9455eb1d63$export$a3bc9b8ed74fc)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $1acd3d55d84916d2$export$eaf22249b410f633)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $1acd3d55d84916d2$export$b240b9b7a78b5f3e)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $1acd3d55d84916d2$export$75b67481063f2f98)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $1acd3d55d84916d2$export$eaf22249b410f633)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $a9a38c9455eb1d63$export$a3bc9b8ed74fc)(id, err));
        }
        if ((0, $1acd3d55d84916d2$export$ae936b9d47e5870e)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $1acd3d55d84916d2$export$75b67481063f2f98)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $1acd3d55d84916d2$export$eaf22249b410f633)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $1acd3d55d84916d2$export$eaf22249b410f633)((0, $a9a38c9455eb1d63$export$a3bc9b8ed74fc)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $1acd3d55d84916d2$export$eaf22249b410f633)((0, $a9a38c9455eb1d63$export$c105e588793f70b4)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $a51bbcc4a46e1984$export$a4e55266d2135a7f)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $a51bbcc4a46e1984$export$4d7a7d14704ebc13)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $1acd3d55d84916d2$export$c45ebe72e3b2885] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $30e2e977433e6273$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $30e2e977433e6273$export$67beed298888a38b;
    return Interpreter;
}();
var $30e2e977433e6273$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(nameOrOptions)) return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, $30e2e977433e6273$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, $30e2e977433e6273$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $1acd3d55d84916d2$export$8b15d37bc3f197d4)()
    }), nameOrOptions);
};
function $30e2e977433e6273$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $30e2e977433e6273$var$resolveSpawnOptions(nameOrOptions);
    return (0, $f98f0276adb79254$export$e11e6a155c5c4d9d)(function(service) {
        if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) {
            var isLazyEntity = (0, $1acd3d55d84916d2$export$2163e7903738b5df)(entity) || (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(entity);
            (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(!!service || isLazyEntity, "Attempted to spawn an Actor (ID: \"".concat((0, $1acd3d55d84916d2$export$2163e7903738b5df)(entity) ? entity.id : 'undefined', "\") outside of a service. This will have no effect."));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $5520c5ffd3a671cd$export$59bcb51d8e40ed48)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $30e2e977433e6273$export$67beed298888a38b(machine, options) {
    var interpreter = new $30e2e977433e6273$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}


var $0eabf6dc1e3c4a39$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0eabf6dc1e3c4a39$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $0eabf6dc1e3c4a39$export$b29f828819edca8d(items, predicate) {
    var e_1, _a;
    var _b = $0eabf6dc1e3c4a39$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $0eabf6dc1e3c4a39$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $0eabf6dc1e3c4a39$export$2b6ccfda635c9803(service) {
    return service.status !== 0 ? service.getSnapshot() : service.machine.initialState;
}
// From https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
function $0eabf6dc1e3c4a39$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $0eabf6dc1e3c4a39$export$d36bdfa510afb180(objA, objB) {
    if ($0eabf6dc1e3c4a39$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$0eabf6dc1e3c4a39$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $0eabf6dc1e3c4a39$export$ab21a1e7bed2882e(actor) {
    return 'state' in actor && 'machine' in actor;
}
function $0eabf6dc1e3c4a39$export$3496c38320247757(service, prevState, nextState) {
    if (service.status === (0, $30e2e977433e6273$export$7a567c9c5088a551).NotStarted) return true;
    // Only change the current state if:
    // - the incoming state is the "live" initial state (since it might have new actors)
    // - OR the incoming state actually changed.
    //
    // The "live" initial state will have .changed === undefined.
    var initialStateChanged = nextState.changed === undefined && (Object.keys(nextState.children).length > 0 || typeof prevState.changed === 'boolean');
    return !(nextState.changed || initialStateChanged);
}


function $739bd1b89b2e3318$var$identity(a) {
    return a;
}
function $739bd1b89b2e3318$export$656eb38a7c1ce0b6(actorRef) {
    return 'state' in actorRef;
}
function $739bd1b89b2e3318$var$isDeferredActor(actorRef) {
    return 'deferred' in actorRef;
}
function $739bd1b89b2e3318$var$defaultGetSnapshot(actorRef) {
    return 'getSnapshot' in actorRef ? (0, $0eabf6dc1e3c4a39$export$ab21a1e7bed2882e)(actorRef) ? (0, $0eabf6dc1e3c4a39$export$2b6ccfda635c9803)(actorRef) : actorRef.getSnapshot() : $739bd1b89b2e3318$export$656eb38a7c1ce0b6(actorRef) ? actorRef.state : undefined;
}
function $739bd1b89b2e3318$export$25c4ab29592aabd9(actorRef, getSnapshot) {
    if (getSnapshot === void 0) getSnapshot = $739bd1b89b2e3318$var$defaultGetSnapshot;
    var actorRefRef = (0, $jMaZ8.useRef)(actorRef);
    var deferredEventsRef = (0, $jMaZ8.useRef)([]);
    var subscribe = (0, $jMaZ8.useCallback)(function(handleStoreChange) {
        var unsubscribe = actorRef.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actorRef
    ]);
    var boundGetSnapshot = (0, $jMaZ8.useCallback)(function() {
        return getSnapshot(actorRef);
    }, [
        actorRef,
        getSnapshot
    ]);
    var isEqual = (0, $jMaZ8.useCallback)(function(prevState, nextState) {
        if ((0, $0eabf6dc1e3c4a39$export$ab21a1e7bed2882e)(actorRef)) return (0, $0eabf6dc1e3c4a39$export$3496c38320247757)(actorRef, prevState, nextState);
        return prevState === nextState;
    }, [
        actorRef
    ]);
    var storeSnapshot = (0, $02871aea04ef26e7$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, $739bd1b89b2e3318$var$identity, isEqual);
    var send = (0, $8f032c4781985836$export$2e2bcd8739ae039)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var event = args[0];
            if (args.length > 1) console.warn("Unexpected payload: ".concat(JSON.stringify(args[1]), ". Only a single event object can be sent to actor send() functions."));
            var currentActorRef = actorRefRef.current;
            // If the previous actor is a deferred actor,
            // queue the events so that they can be replayed
            // on the non-deferred actor.
            if ($739bd1b89b2e3318$var$isDeferredActor(currentActorRef) && currentActorRef.deferred) deferredEventsRef.current.push(event);
            else currentActorRef.send(event);
        };
    });
    (0, $82634d27f391dd58$export$2e2bcd8739ae039)(function() {
        actorRefRef.current = actorRef;
        // Dequeue deferred events from the previous deferred actorRef
        while(deferredEventsRef.current.length > 0){
            var deferredEvent = deferredEventsRef.current.shift();
            actorRef.send(deferredEvent);
        }
    }, [
        actorRef
    ]);
    return [
        storeSnapshot,
        send
    ];
}



var $jMaZ8 = parcelRequire("jMaZ8");


var $jMaZ8 = parcelRequire("jMaZ8");

var $jMaZ8 = parcelRequire("jMaZ8");



var $e2c092b90dab4701$var$__assign = undefined && undefined.__assign || function() {
    $e2c092b90dab4701$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e2c092b90dab4701$var$__assign.apply(this, arguments);
};
var $e2c092b90dab4701$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e2c092b90dab4701$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $e2c092b90dab4701$export$d09836c9e303db57(getMachine, options) {
    var machine = (0, $8f032c4781985836$export$2e2bcd8739ae039)(function() {
        return typeof getMachine === 'function' ? getMachine() : getMachine;
    });
    if (typeof getMachine !== 'function') {
        var _a = $e2c092b90dab4701$var$__read((0, $jMaZ8.useState)(machine), 1), initialMachine = _a[0];
        if (getMachine !== initialMachine) console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
    }
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $e2c092b90dab4701$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $8f032c4781985836$export$2e2bcd8739ae039)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return $e2c092b90dab4701$var$__assign($e2c092b90dab4701$var$__assign({}, machine.context), context);
        });
        return (0, $30e2e977433e6273$export$67beed298888a38b)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $82634d27f391dd58$export$2e2bcd8739ae039)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function $e2c092b90dab4701$export$d9e9b060fbbae528(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $e2c092b90dab4701$var$__read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = $e2c092b90dab4701$export$d09836c9e303db57(getMachine, options);
    (0, $jMaZ8.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, $1acd3d55d84916d2$export$75b67481063f2f98)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $jMaZ8.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $93a7122c7e43444e$export$7254cc27399e90bd).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $30e2e977433e6273$export$7a567c9c5088a551).NotStarted;
        };
    }, []);
    return service;
}



















function $af89e792fcfae55f$export$436e852aa2feda95(src) {
    if (typeof src === 'string') {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $af89e792fcfae55f$export$4c73f685ba879446(invokeConfig) {
    return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
        type: (0, $9d349e867592e6e3$export$468cda29b159ee5d)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $d673ecfaee2e9387$export$3c9a16f847548506)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, invokeDef), {
                type: (0, $9d349e867592e6e3$export$468cda29b159ee5d),
                src: $af89e792fcfae55f$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}


var $bb400e050b767460$var$NULL_EVENT = '';
var $bb400e050b767460$var$STATE_IDENTIFIER = '#';
var $bb400e050b767460$var$WILDCARD = '*';
var $bb400e050b767460$var$EMPTY_OBJECT = {};
var $bb400e050b767460$var$isStateId = function(str) {
    return str[0] === $bb400e050b767460$var$STATE_IDENTIFIER;
};
var $bb400e050b767460$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $bb400e050b767460$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !('cond' in transition) && !('in' in transition) && ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(transition.target) || (0, $1acd3d55d84916d2$export$2163e7903738b5df)(transition.target));
    });
    var eventText = event === $bb400e050b767460$var$NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
    (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $bb400e050b767460$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = 'context' in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($bb400e050b767460$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $170ac7d10b246030$export$b060f3cec92ef5c9));
        this.id = this.config.id || (0, $d673ecfaee2e9387$export$1216008129fb82ed)([
            this.machine.key
        ], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $1acd3d55d84916d2$export$825e789796ab7275)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $bb400e050b767460$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)((0, $14e4d0cc3d7f7a29$export$ad3d2e38d4deaf6d)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $bb400e050b767460$var$NULL_EVENT;
        }) : $bb400e050b767460$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $1acd3d55d84916d2$export$45b10814cc054894)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $a9a38c9455eb1d63$export$b38b66cc2da3ede7)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $1acd3d55d84916d2$export$45b10814cc054894)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $a9a38c9455eb1d63$export$b38b66cc2da3ede7)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === 'final' ? this.config.data : undefined;
        this.invoke = (0, $1acd3d55d84916d2$export$45b10814cc054894)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $1acd3d55d84916d2$export$2163e7903738b5df)(invokeConfig)) {
                var invokeId = (0, $1acd3d55d84916d2$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $af89e792fcfae55f$export$4c73f685ba879446)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $1acd3d55d84916d2$export$107b54c5097f9157)(_this.id, i);
                return (0, $af89e792fcfae55f$export$4c73f685ba879446)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $1acd3d55d84916d2$export$2163e7903738b5df)(invokeConfig.src) || (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $1acd3d55d84916d2$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $af89e792fcfae55f$export$4c73f685ba879446)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $af89e792fcfae55f$export$4c73f685ba879446)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({
                    id: (0, $1acd3d55d84916d2$export$107b54c5097f9157)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $1acd3d55d84916d2$export$45b10814cc054894)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $a9a38c9455eb1d63$export$e81fdd8937d44864)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $1acd3d55d84916d2$export$45b10814cc054894)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $14e4d0cc3d7f7a29$export$3de19bba299e3801)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, actions), options.actions),
            activities: (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, activities), options.activities),
            guards: (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, guards), options.guards),
            services: (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, services), options.services),
            delays: (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $1acd3d55d84916d2$export$825e789796ab7275)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $bb400e050b767460$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $bb400e050b767460$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $1acd3d55d84916d2$export$f6e2535fb5126e54)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $a9a38c9455eb1d63$export$742acabee3dd6465)(delayRef, _this.id);
            _this.onEntry.push((0, $a9a38c9455eb1d63$export$89db4734f6c919c4)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $a9a38c9455eb1d63$export$70b61ad426ddbe54)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $1acd3d55d84916d2$export$43bee75e5e14138e)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, transition), {
                event: eventType
            });
        }) : (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $1acd3d55d84916d2$export$844ec244b1367d54)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $1acd3d55d84916d2$export$45b10814cc054894)(resolvedTransition).map(function(transition) {
                return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $93a7122c7e43444e$export$7254cc27399e90bd) ? state.value : (0, $1acd3d55d84916d2$export$fb3aecd1d93744e3)(state, this.delimiter);
        if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)((0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $1acd3d55d84916d2$export$7193fc8c8cd445e9)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $93a7122c7e43444e$export$7254cc27399e90bd) ? state : (0, $93a7122c7e43444e$export$7254cc27399e90bd).create(state);
        var configuration = Array.from((0, $14e4d0cc3d7f7a29$export$3de01744a82b21a4)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $93a7122c7e43444e$export$7254cc27399e90bd)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $14e4d0cc3d7f7a29$export$cf3d5dae927fcf63)(configuration, this),
            tags: (0, $14e4d0cc3d7f7a29$export$5301196121335ca0)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $1acd3d55d84916d2$export$eaf22249b410f633)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $1acd3d55d84916d2$export$844ec244b1367d54)(stateIn) && $bb400e050b767460$var$isStateId(stateIn) ? state.matches((0, $1acd3d55d84916d2$export$fb3aecd1d93744e3)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $1acd3d55d84916d2$export$2870710bf0eac88e)((0, $1acd3d55d84916d2$export$fb3aecd1d93744e3)(stateIn, this.delimiter), (0, $1acd3d55d84916d2$export$bb654e07daaf8c3a)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $1acd3d55d84916d2$export$91646ab912d254e8)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, $14e4d0cc3d7f7a29$export$3de01744a82b21a4)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, $14e4d0cc3d7f7a29$export$a4f4bb6b1453fff5)(prevConfig, sn) || (0, $14e4d0cc3d7f7a29$export$a4f4bb6b1453fff5)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $14e4d0cc3d7f7a29$export$a4f4bb6b1453fff5)(resolvedConfig, sn) || (0, $14e4d0cc3d7f7a29$export$a4f4bb6b1453fff5)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== 'final') return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $a9a38c9455eb1d63$export$3df11c9c20e7b288)(sn.id, sn.doneData), (0, $a9a38c9455eb1d63$export$3df11c9c20e7b288)(parent.id, sn.doneData ? (0, $1acd3d55d84916d2$export$e756e60189cc2351)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === 'parallel') {
                if ((0, $14e4d0cc3d7f7a29$export$f8cf48ee793b41be)(grandparent).every(function(parentNode) {
                    return (0, $14e4d0cc3d7f7a29$export$cf3d5dae927fcf63)(transition.configuration, parentNode);
                })) events.push((0, $a9a38c9455eb1d63$export$3df11c9c20e7b288)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $a9a38c9455eb1d63$export$b3571188c770cc5a)(activity);
            });
            return {
                type: 'entry',
                actions: (0, $a9a38c9455eb1d63$export$aa68691f32e6c459)(predictableExec ? (0, $d673ecfaee2e9387$export$1216008129fb82ed)((0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(entryActions), false), (0, $d673ecfaee2e9387$export$8d051b38c9118094)(invokeActions), false) : (0, $d673ecfaee2e9387$export$1216008129fb82ed)((0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(invokeActions), false), (0, $d673ecfaee2e9387$export$8d051b38c9118094)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: 'state_done',
            actions: doneEvents.map(function(event) {
                return (0, $a9a38c9455eb1d63$export$66313c302b2ea154)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: 'exit',
                actions: (0, $a9a38c9455eb1d63$export$aa68691f32e6c459)((0, $d673ecfaee2e9387$export$1216008129fb82ed)((0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(stateNode.onExit), false), (0, $d673ecfaee2e9387$export$8d051b38c9118094)(stateNode.activities.map(function(activity) {
                    return (0, $a9a38c9455eb1d63$export$fa6813432f753b0d)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: 'transition',
            actions: (0, $a9a38c9455eb1d63$export$aa68691f32e6c459)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $a9a38c9455eb1d63$export$aa68691f32e6c459)((0, $1acd3d55d84916d2$export$bffa455ba8c619a6)((0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, $1acd3d55d84916d2$export$37dc2eda56cb25a5)(action);
            });
            return actions.concat({
                type: 'stop',
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $1acd3d55d84916d2$export$eaf22249b410f633)(event);
        var currentState;
        if (state instanceof (0, $93a7122c7e43444e$export$7254cc27399e90bd)) currentState = context === undefined ? state : this.resolveState((0, $93a7122c7e43444e$export$7254cc27399e90bd).from(state, context));
        else {
            var resolvedStateValue = (0, $1acd3d55d84916d2$export$844ec244b1367d54)(state) ? this.resolve((0, $1acd3d55d84916d2$export$f2ee84fc53c45e74)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $93a7122c7e43444e$export$7254cc27399e90bd).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571) && _event.name === $bb400e050b767460$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($bb400e050b767460$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $1acd3d55d84916d2$export$479b1b8942fd0b8d)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $14e4d0cc3d7f7a29$export$3de01744a82b21a4)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $14e4d0cc3d7f7a29$export$3de01744a82b21a4)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $a9a38c9455eb1d63$export$163c566c60ed2ec9);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $14e4d0cc3d7f7a29$export$cf3d5dae927fcf63)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $14e4d0cc3d7f7a29$export$bf7199a9ebcb84a9)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, $9d349e867592e6e3$export$b3571188c770cc5a)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $9d349e867592e6e3$export$fa6813432f753b0d)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, $d673ecfaee2e9387$export$8d051b38c9118094)((0, $a9a38c9455eb1d63$export$b8b9e7ba5b8c7b3e)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, $d673ecfaee2e9387$export$8d051b38c9118094)((0, $1acd3d55d84916d2$export$b29f828819edca8d)(resolvedActions, (0, $1acd3d55d84916d2$export$37dc2eda56cb25a5)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $9d349e867592e6e3$export$b3571188c770cc5a) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $9d349e867592e6e3$export$468cda29b159ee5d);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $5520c5ffd3a671cd$export$78b4a98dcb5ac328)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, currentState.children) : {});
        var nextState = new (0, $93a7122c7e43444e$export$7254cc27399e90bd)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $1acd3d55d84916d2$export$240d7cdd99ccb95a)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $14e4d0cc3d7f7a29$export$5301196121335ca0)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $9d349e867592e6e3$export$722fbec263ad908a) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $bb400e050b767460$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $9d349e867592e6e3$export$9477ceca5dcd796a)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $93a7122c7e43444e$export$3a6d15eeb5fb214c)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($bb400e050b767460$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $bb400e050b767460$var$isStateId(stateId) ? stateId.slice($bb400e050b767460$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === 'string' && $bb400e050b767460$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $1acd3d55d84916d2$export$304cde62ecda7af8)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $bb400e050b767460$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case 'parallel':
                return (0, $1acd3d55d84916d2$export$825e789796ab7275)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $bb400e050b767460$var$EMPTY_OBJECT;
                });
            case 'compound':
                if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $1acd3d55d84916d2$export$825e789796ab7275)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $bb400e050b767460$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $bb400e050b767460$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($bb400e050b767460$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($bb400e050b767460$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $1acd3d55d84916d2$export$304cde62ecda7af8)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === 'parallel') initialStateValue = (0, $1acd3d55d84916d2$export$2d4204fe9b34204e)(this.states, function(state) {
                return state.initialStateValue || $bb400e050b767460$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === 'history');
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $14e4d0cc3d7f7a29$export$335db82b86111fd1)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === 'history') {
                var historyConfig = this.config;
                if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(historyConfig.target)) target = $bb400e050b767460$var$isStateId(historyConfig.target) ? (0, $1acd3d55d84916d2$export$f2ee84fc53c45e74)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $14e4d0cc3d7f7a29$export$335db82b86111fd1)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === 'compound' && !this.initial) {
                if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $1acd3d55d84916d2$export$a2618e9e89698dd6)(this.initialStateValue);
            return (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $d673ecfaee2e9387$export$8d051b38c9118094)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === 'history') return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $1acd3d55d84916d2$export$2d4204fe9b34204e)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $1acd3d55d84916d2$export$844ec244b1367d54)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== 'history') return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)((0, $1acd3d55d84916d2$export$a2618e9e89698dd6)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $1acd3d55d84916d2$export$314d0a1a7c835392)(parent.path, 'states')(historyValue).current;
        if ((0, $1acd3d55d84916d2$export$844ec244b1367d54)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)((0, $1acd3d55d84916d2$export$a2618e9e89698dd6)(subHistoryValue).map(function(subStatePath) {
            return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $1acd3d55d84916d2$export$844ec244b1367d54)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $1acd3d55d84916d2$export$2a4fe5c3c80e3288)(transitionConfig.target);
        var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $1acd3d55d84916d2$export$844ec244b1367d54)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, transitionConfig), {
            actions: (0, $a9a38c9455eb1d63$export$aa68691f32e6c459)((0, $1acd3d55d84916d2$export$45b10814cc054894)(transitionConfig.actions)),
            cond: (0, $1acd3d55d84916d2$export$b0f5a08e0ca47933)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $d673ecfaee2e9387$export$18ce0697a983be9b)((0, $d673ecfaee2e9387$export$18ce0697a983be9b)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $bb400e050b767460$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $d673ecfaee2e9387$export$3c9a16f847548506)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571) && key === $bb400e050b767460$var$NULL_EVENT) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
                var transitionConfigArray = (0, $1acd3d55d84916d2$export$3822a36ea084a4d5)(key, strictTransitionConfigs_1[key]);
                if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) $bb400e050b767460$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $1acd3d55d84916d2$export$3822a36ea084a4d5)($bb400e050b767460$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $1acd3d55d84916d2$export$3822a36ea084a4d5)('', this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $1acd3d55d84916d2$export$3822a36ea084a4d5)(String((0, $a9a38c9455eb1d63$export$3df11c9c20e7b288)(this.id)), this.config.onDone) : [];
        if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571)) (0, $1acd3d55d84916d2$export$c106dd0671a0fc2d)(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
        var invokeConfig = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)((0, $1acd3d55d84916d2$export$3822a36ea084a4d5)(String((0, $a9a38c9455eb1d63$export$c105e588793f70b4)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)((0, $1acd3d55d84916d2$export$3822a36ea084a4d5)(String((0, $a9a38c9455eb1d63$export$a3bc9b8ed74fc)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $1acd3d55d84916d2$export$bffa455ba8c619a6)((0, $d673ecfaee2e9387$export$1216008129fb82ed)((0, $d673ecfaee2e9387$export$1216008129fb82ed)((0, $d673ecfaee2e9387$export$1216008129fb82ed)((0, $d673ecfaee2e9387$export$1216008129fb82ed)([], (0, $d673ecfaee2e9387$export$8d051b38c9118094)(doneConfig), false), (0, $d673ecfaee2e9387$export$8d051b38c9118094)(invokeConfig), false), (0, $d673ecfaee2e9387$export$8d051b38c9118094)(onConfig), false), (0, $d673ecfaee2e9387$export$8d051b38c9118094)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $1acd3d55d84916d2$export$45b10814cc054894)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $d673ecfaee2e9387$export$19a8beecd37a4c45)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();



var $459aec9d6c563a19$var$warned = false;
function $459aec9d6c563a19$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $bb400e050b767460$export$342f24f5edd47b1)(config, options, initialContext);
}
function $459aec9d6c563a19$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $d8de3fe873bcabc2$export$9b5f2e1c20ef6571) && !('predictableActionArguments' in config) && !$459aec9d6c563a19$var$warned) {
        $459aec9d6c563a19$var$warned = true;
        console.warn('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html');
    }
    return new (0, $bb400e050b767460$export$342f24f5edd47b1)(config, options);
}










var $9c5de0376eae7f00$export$e6e34fd1f2686227 = (0, $a9a38c9455eb1d63$export$e6e34fd1f2686227), $9c5de0376eae7f00$export$70b61ad426ddbe54 = (0, $a9a38c9455eb1d63$export$70b61ad426ddbe54), $9c5de0376eae7f00$export$89db4734f6c919c4 = (0, $a9a38c9455eb1d63$export$89db4734f6c919c4), $9c5de0376eae7f00$export$daa976aaff721e41 = (0, $a9a38c9455eb1d63$export$daa976aaff721e41), $9c5de0376eae7f00$export$408d8d51fa351f53 = (0, $a9a38c9455eb1d63$export$408d8d51fa351f53), $9c5de0376eae7f00$export$7f8b724299523eb6 = (0, $a9a38c9455eb1d63$export$7f8b724299523eb6), $9c5de0376eae7f00$export$eb147b7589db8e8a = (0, $a9a38c9455eb1d63$export$eb147b7589db8e8a), $9c5de0376eae7f00$export$c105e588793f70b4 = (0, $a9a38c9455eb1d63$export$c105e588793f70b4), $9c5de0376eae7f00$export$66313c302b2ea154 = (0, $a9a38c9455eb1d63$export$66313c302b2ea154), $9c5de0376eae7f00$export$bef1f36f5486a6a3 = (0, $a9a38c9455eb1d63$export$bef1f36f5486a6a3), $9c5de0376eae7f00$export$48ec4a2b1cfc6557 = (0, $a9a38c9455eb1d63$export$48ec4a2b1cfc6557), $9c5de0376eae7f00$export$7877a478dd30fd3d = (0, $a9a38c9455eb1d63$export$7877a478dd30fd3d), $9c5de0376eae7f00$export$fa6813432f753b0d = (0, $a9a38c9455eb1d63$export$fa6813432f753b0d);


var $102fbd6db630465b$exports = {};
'use strict';
Object.defineProperty($102fbd6db630465b$exports, '__esModule', {
    value: true
});
var $45f2cc28951a3066$exports = {};
'use strict';
Object.defineProperty($45f2cc28951a3066$exports, '__esModule', {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ $45f2cc28951a3066$exports.__assign = function() {
    $45f2cc28951a3066$exports.__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $45f2cc28951a3066$exports.__assign.apply(this, arguments);
};
function $45f2cc28951a3066$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $45f2cc28951a3066$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $45f2cc28951a3066$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $45f2cc28951a3066$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
$45f2cc28951a3066$exports.__read = $45f2cc28951a3066$var$__read;
$45f2cc28951a3066$exports.__rest = $45f2cc28951a3066$var$__rest;
$45f2cc28951a3066$exports.__spreadArray = $45f2cc28951a3066$var$__spreadArray;
$45f2cc28951a3066$exports.__values = $45f2cc28951a3066$var$__values;


var $69dbe76788062148$exports = {};
'use strict';
Object.defineProperty($69dbe76788062148$exports, '__esModule', {
    value: true
});
$69dbe76788062148$exports.ActionTypes = void 0;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($69dbe76788062148$exports.ActionTypes || ($69dbe76788062148$exports.ActionTypes = {}));
$69dbe76788062148$exports.SpecialTargets = void 0;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($69dbe76788062148$exports.SpecialTargets || ($69dbe76788062148$exports.SpecialTargets = {}));


var $8cfb856a6c58ceb2$exports = {};
'use strict';
Object.defineProperty($8cfb856a6c58ceb2$exports, '__esModule', {
    value: true
});

var $8cfb856a6c58ceb2$var$start = $69dbe76788062148$exports.ActionTypes.Start;
var $8cfb856a6c58ceb2$var$stop = $69dbe76788062148$exports.ActionTypes.Stop;
var $8cfb856a6c58ceb2$var$raise = $69dbe76788062148$exports.ActionTypes.Raise;
var $8cfb856a6c58ceb2$var$send = $69dbe76788062148$exports.ActionTypes.Send;
var $8cfb856a6c58ceb2$var$cancel = $69dbe76788062148$exports.ActionTypes.Cancel;
var $8cfb856a6c58ceb2$var$nullEvent = $69dbe76788062148$exports.ActionTypes.NullEvent;
var $8cfb856a6c58ceb2$var$assign = $69dbe76788062148$exports.ActionTypes.Assign;
var $8cfb856a6c58ceb2$var$after = $69dbe76788062148$exports.ActionTypes.After;
var $8cfb856a6c58ceb2$var$doneState = $69dbe76788062148$exports.ActionTypes.DoneState;
var $8cfb856a6c58ceb2$var$log = $69dbe76788062148$exports.ActionTypes.Log;
var $8cfb856a6c58ceb2$var$init = $69dbe76788062148$exports.ActionTypes.Init;
var $8cfb856a6c58ceb2$var$invoke = $69dbe76788062148$exports.ActionTypes.Invoke;
var $8cfb856a6c58ceb2$var$errorExecution = $69dbe76788062148$exports.ActionTypes.ErrorExecution;
var $8cfb856a6c58ceb2$var$errorPlatform = $69dbe76788062148$exports.ActionTypes.ErrorPlatform;
var $8cfb856a6c58ceb2$var$error = $69dbe76788062148$exports.ActionTypes.ErrorCustom;
var $8cfb856a6c58ceb2$var$update = $69dbe76788062148$exports.ActionTypes.Update;
var $8cfb856a6c58ceb2$var$choose = $69dbe76788062148$exports.ActionTypes.Choose;
var $8cfb856a6c58ceb2$var$pure = $69dbe76788062148$exports.ActionTypes.Pure;
$8cfb856a6c58ceb2$exports.after = $8cfb856a6c58ceb2$var$after;
$8cfb856a6c58ceb2$exports.assign = $8cfb856a6c58ceb2$var$assign;
$8cfb856a6c58ceb2$exports.cancel = $8cfb856a6c58ceb2$var$cancel;
$8cfb856a6c58ceb2$exports.choose = $8cfb856a6c58ceb2$var$choose;
$8cfb856a6c58ceb2$exports.doneState = $8cfb856a6c58ceb2$var$doneState;
$8cfb856a6c58ceb2$exports.error = $8cfb856a6c58ceb2$var$error;
$8cfb856a6c58ceb2$exports.errorExecution = $8cfb856a6c58ceb2$var$errorExecution;
$8cfb856a6c58ceb2$exports.errorPlatform = $8cfb856a6c58ceb2$var$errorPlatform;
$8cfb856a6c58ceb2$exports.init = $8cfb856a6c58ceb2$var$init;
$8cfb856a6c58ceb2$exports.invoke = $8cfb856a6c58ceb2$var$invoke;
$8cfb856a6c58ceb2$exports.log = $8cfb856a6c58ceb2$var$log;
$8cfb856a6c58ceb2$exports.nullEvent = $8cfb856a6c58ceb2$var$nullEvent;
$8cfb856a6c58ceb2$exports.pure = $8cfb856a6c58ceb2$var$pure;
$8cfb856a6c58ceb2$exports.raise = $8cfb856a6c58ceb2$var$raise;
$8cfb856a6c58ceb2$exports.send = $8cfb856a6c58ceb2$var$send;
$8cfb856a6c58ceb2$exports.start = $8cfb856a6c58ceb2$var$start;
$8cfb856a6c58ceb2$exports.stop = $8cfb856a6c58ceb2$var$stop;
$8cfb856a6c58ceb2$exports.update = $8cfb856a6c58ceb2$var$update;


var $7660b420d0d64aff$exports = {};
'use strict';
Object.defineProperty($7660b420d0d64aff$exports, '__esModule', {
    value: true
});



var $f1ad9b0d40067b84$exports = {};
'use strict';
Object.defineProperty($f1ad9b0d40067b84$exports, '__esModule', {
    value: true
});
var $f1ad9b0d40067b84$var$STATE_DELIMITER = '.';
var $f1ad9b0d40067b84$var$EMPTY_ACTIVITY_MAP = {};
var $f1ad9b0d40067b84$var$DEFAULT_GUARD_TYPE = 'xstate.guard';
var $f1ad9b0d40067b84$var$TARGETLESS_KEY = '';
$f1ad9b0d40067b84$exports.DEFAULT_GUARD_TYPE = $f1ad9b0d40067b84$var$DEFAULT_GUARD_TYPE;
$f1ad9b0d40067b84$exports.EMPTY_ACTIVITY_MAP = $f1ad9b0d40067b84$var$EMPTY_ACTIVITY_MAP;
$f1ad9b0d40067b84$exports.STATE_DELIMITER = $f1ad9b0d40067b84$var$STATE_DELIMITER;
$f1ad9b0d40067b84$exports.TARGETLESS_KEY = $f1ad9b0d40067b84$var$TARGETLESS_KEY;


var $6d03ab5332d93c91$exports = {};
'use strict';
Object.defineProperty($6d03ab5332d93c91$exports, '__esModule', {
    value: true
});
var $6d03ab5332d93c91$var$IS_PRODUCTION = false;
$6d03ab5332d93c91$exports.IS_PRODUCTION = $6d03ab5332d93c91$var$IS_PRODUCTION;


var $7660b420d0d64aff$var$_a;
function $7660b420d0d64aff$var$keys(value) {
    return Object.keys(value);
}
function $7660b420d0d64aff$var$matchesState(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = $f1ad9b0d40067b84$exports.STATE_DELIMITER;
    var parentStateValue = $7660b420d0d64aff$var$toStateValue(parentStateId, delimiter);
    var childStateValue = $7660b420d0d64aff$var$toStateValue(childStateId, delimiter);
    if ($7660b420d0d64aff$var$isString(childStateValue)) {
        if ($7660b420d0d64aff$var$isString(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($7660b420d0d64aff$var$isString(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $7660b420d0d64aff$var$matchesState(parentStateValue[key], childStateValue[key]);
    });
}
function $7660b420d0d64aff$var$getEventType(event) {
    try {
        return $7660b420d0d64aff$var$isString(event) || typeof event === 'number' ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error('Events must be strings or objects with a string event.type property.');
    }
}
function $7660b420d0d64aff$var$getActionType(action) {
    try {
        return $7660b420d0d64aff$var$isString(action) || typeof action === 'number' ? "".concat(action) : $7660b420d0d64aff$var$isFunction(action) ? action.name : action.type;
    } catch (e) {
        throw new Error('Actions must be strings or objects with a string action.type property.');
    }
}
function $7660b420d0d64aff$var$toStatePath(stateId, delimiter) {
    try {
        if ($7660b420d0d64aff$var$isArray(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $7660b420d0d64aff$var$isStateLike(state) {
    return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function $7660b420d0d64aff$var$toStateValue(stateValue, delimiter) {
    if ($7660b420d0d64aff$var$isStateLike(stateValue)) return stateValue.value;
    if ($7660b420d0d64aff$var$isArray(stateValue)) return $7660b420d0d64aff$var$pathToStateValue(stateValue);
    if (typeof stateValue !== 'string') return stateValue;
    var statePath = $7660b420d0d64aff$var$toStatePath(stateValue, delimiter);
    return $7660b420d0d64aff$var$pathToStateValue(statePath);
}
function $7660b420d0d64aff$var$pathToStateValue(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $7660b420d0d64aff$var$mapValues(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $7660b420d0d64aff$var$mapFilterValues(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = $45f2cc28951a3066$exports.__values(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $7660b420d0d64aff$var$path = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = $45f2cc28951a3066$exports.__values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $7660b420d0d64aff$var$nestedPath(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = $45f2cc28951a3066$exports.__values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $7660b420d0d64aff$var$toStatePaths(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($7660b420d0d64aff$var$isString(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $7660b420d0d64aff$var$flatten(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $7660b420d0d64aff$var$toStatePaths(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $7660b420d0d64aff$var$pathsToStateValue(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = $45f2cc28951a3066$exports.__values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $7660b420d0d64aff$var$flatten(array) {
    var _a;
    return (_a = []).concat.apply(_a, $45f2cc28951a3066$exports.__spreadArray([], $45f2cc28951a3066$exports.__read(array), false));
}
function $7660b420d0d64aff$var$toArrayStrict(value) {
    if ($7660b420d0d64aff$var$isArray(value)) return value;
    return [
        value
    ];
}
function $7660b420d0d64aff$var$toArray(value) {
    if (value === undefined) return [];
    return $7660b420d0d64aff$var$toArrayStrict(value);
}
function $7660b420d0d64aff$var$mapContext(mapper, context, _event) {
    var e_5, _a;
    if ($7660b420d0d64aff$var$isFunction(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = $45f2cc28951a3066$exports.__values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($7660b420d0d64aff$var$isFunction(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $7660b420d0d64aff$var$isBuiltInEvent(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $7660b420d0d64aff$var$isPromiseLike(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($7660b420d0d64aff$var$isFunction(value) || typeof value === 'object') && $7660b420d0d64aff$var$isFunction(value.then)) return true;
    return false;
}
function $7660b420d0d64aff$var$isBehavior(value) {
    return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}
function $7660b420d0d64aff$var$partition(items, predicate) {
    var e_6, _a;
    var _b = $45f2cc28951a3066$exports.__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $45f2cc28951a3066$exports.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $7660b420d0d64aff$var$updateHistoryStates(hist, stateValue) {
    return $7660b420d0d64aff$var$mapValues(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($7660b420d0d64aff$var$isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $7660b420d0d64aff$var$updateHistoryStates(subHist, subStateValue)
        };
    });
}
function $7660b420d0d64aff$var$updateHistoryValue(hist, stateValue) {
    return {
        current: stateValue,
        states: $7660b420d0d64aff$var$updateHistoryStates(hist, stateValue)
    };
}
function $7660b420d0d64aff$var$updateContext(context, _event, assignActions, state) {
    if (!$6d03ab5332d93c91$exports.IS_PRODUCTION) $7660b420d0d64aff$exports.warn(!!context, 'Attempting to update undefined context');
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($7660b420d0d64aff$var$isFunction(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = $45f2cc28951a3066$exports.__values(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $7660b420d0d64aff$var$isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
$7660b420d0d64aff$exports.warn = function() {};
if (!$6d03ab5332d93c91$exports.IS_PRODUCTION) $7660b420d0d64aff$exports.warn = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $7660b420d0d64aff$var$isArray(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $7660b420d0d64aff$var$isFunction(value) {
    return typeof value === 'function';
}
function $7660b420d0d64aff$var$isString(value) {
    return typeof value === 'string';
}
function $7660b420d0d64aff$var$toGuard(condition, guardMap) {
    if (!condition) return undefined;
    if ($7660b420d0d64aff$var$isString(condition)) return {
        type: $f1ad9b0d40067b84$exports.DEFAULT_GUARD_TYPE,
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($7660b420d0d64aff$var$isFunction(condition)) return {
        type: $f1ad9b0d40067b84$exports.DEFAULT_GUARD_TYPE,
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $7660b420d0d64aff$var$isObservable(value) {
    try {
        return 'subscribe' in value && $7660b420d0d64aff$var$isFunction(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $7660b420d0d64aff$var$symbolObservable = /*#__PURE__*/ function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $7660b420d0d64aff$var$interopSymbols = ($7660b420d0d64aff$var$_a = {}, $7660b420d0d64aff$var$_a[$7660b420d0d64aff$var$symbolObservable] = function() {
    return this;
}, $7660b420d0d64aff$var$_a[Symbol.observable] = function() {
    return this;
}, $7660b420d0d64aff$var$_a);
function $7660b420d0d64aff$var$isMachine(value) {
    return !!value && '__xstatenode' in value;
}
function $7660b420d0d64aff$var$isActor(value) {
    return !!value && typeof value.send === 'function';
}
var $7660b420d0d64aff$var$uniqueId = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $7660b420d0d64aff$var$toEventObject(event, payload // id?: TEvent['type']
) {
    if ($7660b420d0d64aff$var$isString(event) || typeof event === 'number') return $45f2cc28951a3066$exports.__assign({
        type: event
    }, payload);
    return event;
}
function $7660b420d0d64aff$var$toSCXMLEvent(event, scxmlEvent) {
    if (!$7660b420d0d64aff$var$isString(event) && '$$type' in event && event.$$type === 'scxml') return event;
    var eventObject = $7660b420d0d64aff$var$toEventObject(event);
    return $45f2cc28951a3066$exports.__assign({
        name: eventObject.type,
        data: eventObject,
        $$type: 'scxml',
        type: 'external'
    }, scxmlEvent);
}
function $7660b420d0d64aff$var$toTransitionConfigArray(event, configLike) {
    var transitions = $7660b420d0d64aff$var$toArrayStrict(configLike).map(function(transitionLike) {
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $7660b420d0d64aff$var$isMachine(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $7660b420d0d64aff$var$normalizeTarget(target) {
    if (target === undefined || target === $f1ad9b0d40067b84$exports.TARGETLESS_KEY) return undefined;
    return $7660b420d0d64aff$var$toArray(target);
}
function $7660b420d0d64aff$var$reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
    if (!$6d03ab5332d93c91$exports.IS_PRODUCTION) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $7660b420d0d64aff$var$evaluateGuard(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === $f1ad9b0d40067b84$exports.DEFAULT_GUARD_TYPE) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $7660b420d0d64aff$var$toInvokeSource(src) {
    if (typeof src === 'string') return {
        type: src
    };
    return src;
}
function $7660b420d0d64aff$var$toObserver(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === 'object';
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $7660b420d0d64aff$var$createInvokeId(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $7660b420d0d64aff$var$isRaisableAction(action) {
    return (action.type === $8cfb856a6c58ceb2$exports.raise || action.type === $8cfb856a6c58ceb2$exports.send && action.to === $69dbe76788062148$exports.SpecialTargets.Internal) && typeof action.delay !== 'number';
}
$7660b420d0d64aff$exports.createInvokeId = $7660b420d0d64aff$var$createInvokeId;
$7660b420d0d64aff$exports.evaluateGuard = $7660b420d0d64aff$var$evaluateGuard;
$7660b420d0d64aff$exports.flatten = $7660b420d0d64aff$var$flatten;
$7660b420d0d64aff$exports.getActionType = $7660b420d0d64aff$var$getActionType;
$7660b420d0d64aff$exports.getEventType = $7660b420d0d64aff$var$getEventType;
$7660b420d0d64aff$exports.interopSymbols = $7660b420d0d64aff$var$interopSymbols;
$7660b420d0d64aff$exports.isActor = $7660b420d0d64aff$var$isActor;
$7660b420d0d64aff$exports.isArray = $7660b420d0d64aff$var$isArray;
$7660b420d0d64aff$exports.isBehavior = $7660b420d0d64aff$var$isBehavior;
$7660b420d0d64aff$exports.isBuiltInEvent = $7660b420d0d64aff$var$isBuiltInEvent;
$7660b420d0d64aff$exports.isFunction = $7660b420d0d64aff$var$isFunction;
$7660b420d0d64aff$exports.isMachine = $7660b420d0d64aff$var$isMachine;
$7660b420d0d64aff$exports.isObservable = $7660b420d0d64aff$var$isObservable;
$7660b420d0d64aff$exports.isPromiseLike = $7660b420d0d64aff$var$isPromiseLike;
$7660b420d0d64aff$exports.isRaisableAction = $7660b420d0d64aff$var$isRaisableAction;
$7660b420d0d64aff$exports.isStateLike = $7660b420d0d64aff$var$isStateLike;
$7660b420d0d64aff$exports.isString = $7660b420d0d64aff$var$isString;
$7660b420d0d64aff$exports.keys = $7660b420d0d64aff$var$keys;
$7660b420d0d64aff$exports.mapContext = $7660b420d0d64aff$var$mapContext;
$7660b420d0d64aff$exports.mapFilterValues = $7660b420d0d64aff$var$mapFilterValues;
$7660b420d0d64aff$exports.mapValues = $7660b420d0d64aff$var$mapValues;
$7660b420d0d64aff$exports.matchesState = $7660b420d0d64aff$var$matchesState;
$7660b420d0d64aff$exports.nestedPath = $7660b420d0d64aff$var$nestedPath;
$7660b420d0d64aff$exports.normalizeTarget = $7660b420d0d64aff$var$normalizeTarget;
$7660b420d0d64aff$exports.partition = $7660b420d0d64aff$var$partition;
$7660b420d0d64aff$exports.path = $7660b420d0d64aff$var$path;
$7660b420d0d64aff$exports.pathToStateValue = $7660b420d0d64aff$var$pathToStateValue;
$7660b420d0d64aff$exports.pathsToStateValue = $7660b420d0d64aff$var$pathsToStateValue;
$7660b420d0d64aff$exports.reportUnhandledExceptionOnInvocation = $7660b420d0d64aff$var$reportUnhandledExceptionOnInvocation;
$7660b420d0d64aff$exports.symbolObservable = $7660b420d0d64aff$var$symbolObservable;
$7660b420d0d64aff$exports.toArray = $7660b420d0d64aff$var$toArray;
$7660b420d0d64aff$exports.toArrayStrict = $7660b420d0d64aff$var$toArrayStrict;
$7660b420d0d64aff$exports.toEventObject = $7660b420d0d64aff$var$toEventObject;
$7660b420d0d64aff$exports.toGuard = $7660b420d0d64aff$var$toGuard;
$7660b420d0d64aff$exports.toInvokeSource = $7660b420d0d64aff$var$toInvokeSource;
$7660b420d0d64aff$exports.toObserver = $7660b420d0d64aff$var$toObserver;
$7660b420d0d64aff$exports.toSCXMLEvent = $7660b420d0d64aff$var$toSCXMLEvent;
$7660b420d0d64aff$exports.toStatePath = $7660b420d0d64aff$var$toStatePath;
$7660b420d0d64aff$exports.toStatePaths = $7660b420d0d64aff$var$toStatePaths;
$7660b420d0d64aff$exports.toStateValue = $7660b420d0d64aff$var$toStateValue;
$7660b420d0d64aff$exports.toTransitionConfigArray = $7660b420d0d64aff$var$toTransitionConfigArray;
$7660b420d0d64aff$exports.uniqueId = $7660b420d0d64aff$var$uniqueId;
$7660b420d0d64aff$exports.updateContext = $7660b420d0d64aff$var$updateContext;
$7660b420d0d64aff$exports.updateHistoryStates = $7660b420d0d64aff$var$updateHistoryStates;
$7660b420d0d64aff$exports.updateHistoryValue = $7660b420d0d64aff$var$updateHistoryValue;



var $102fbd6db630465b$var$initEvent = /*#__PURE__*/ $7660b420d0d64aff$exports.toSCXMLEvent({
    type: $8cfb856a6c58ceb2$exports.init
});
function $102fbd6db630465b$var$getActionFunction(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $102fbd6db630465b$var$toActionObject(action, actionFunctionMap) {
    var actionObject;
    if ($7660b420d0d64aff$exports.isString(action) || typeof action === 'number') {
        var exec = $102fbd6db630465b$var$getActionFunction(action, actionFunctionMap);
        if ($7660b420d0d64aff$exports.isFunction(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ($7660b420d0d64aff$exports.isFunction(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $102fbd6db630465b$var$getActionFunction(action.type, actionFunctionMap);
        if ($7660b420d0d64aff$exports.isFunction(exec)) actionObject = $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $102fbd6db630465b$var$toActionObjects = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = $7660b420d0d64aff$exports.isArray(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $102fbd6db630465b$var$toActionObject(subAction, actionFunctionMap);
    });
};
function $102fbd6db630465b$var$toActivityDefinition(action) {
    var actionObject = $102fbd6db630465b$var$toActionObject(action);
    return $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({
        id: $7660b420d0d64aff$exports.isString(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $102fbd6db630465b$var$raise(event, options) {
    return {
        type: $8cfb856a6c58ceb2$exports.raise,
        event: typeof event === 'function' ? event : $7660b420d0d64aff$exports.toEventObject(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $102fbd6db630465b$var$resolveRaise(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = $7660b420d0d64aff$exports.toSCXMLEvent($7660b420d0d64aff$exports.isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ($7660b420d0d64aff$exports.isString(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = $7660b420d0d64aff$exports.isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = $7660b420d0d64aff$exports.isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, action), {
        type: $8cfb856a6c58ceb2$exports.raise,
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $102fbd6db630465b$var$send(event, options) {
    return {
        to: options ? options.to : undefined,
        type: $8cfb856a6c58ceb2$exports.send,
        event: $7660b420d0d64aff$exports.isFunction(event) ? event : $7660b420d0d64aff$exports.toEventObject(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : $7660b420d0d64aff$exports.isFunction(event) ? event.name : $7660b420d0d64aff$exports.getEventType(event)
    };
}
function $102fbd6db630465b$var$resolveSend(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = $7660b420d0d64aff$exports.toSCXMLEvent($7660b420d0d64aff$exports.isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ($7660b420d0d64aff$exports.isString(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = $7660b420d0d64aff$exports.isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = $7660b420d0d64aff$exports.isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = $7660b420d0d64aff$exports.isFunction(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $102fbd6db630465b$var$sendParent(event, options) {
    return $102fbd6db630465b$var$send(event, $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, options), {
        to: $69dbe76788062148$exports.SpecialTargets.Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $102fbd6db630465b$var$sendTo(actor, event, options) {
    return $102fbd6db630465b$var$send(event, $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $102fbd6db630465b$var$sendUpdate() {
    return $102fbd6db630465b$var$sendParent($8cfb856a6c58ceb2$exports.update);
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $102fbd6db630465b$var$respond(event, options) {
    return $102fbd6db630465b$var$send(event, $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $102fbd6db630465b$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $102fbd6db630465b$var$log(expr, label) {
    if (expr === void 0) expr = $102fbd6db630465b$var$defaultLogExpr;
    return {
        type: $8cfb856a6c58ceb2$exports.log,
        label: label,
        expr: expr
    };
}
var $102fbd6db630465b$var$resolveLog = function(action, ctx, _event) {
    return $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, action), {
        value: $7660b420d0d64aff$exports.isString(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $102fbd6db630465b$var$cancel = function(sendId) {
    return {
        type: $8cfb856a6c58ceb2$exports.cancel,
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $102fbd6db630465b$var$start(activity) {
    var activityDef = $102fbd6db630465b$var$toActivityDefinition(activity);
    return {
        type: $69dbe76788062148$exports.ActionTypes.Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $102fbd6db630465b$var$stop(actorRef) {
    var activity = $7660b420d0d64aff$exports.isFunction(actorRef) ? actorRef : $102fbd6db630465b$var$toActivityDefinition(actorRef);
    return {
        type: $69dbe76788062148$exports.ActionTypes.Stop,
        activity: activity,
        exec: undefined
    };
}
function $102fbd6db630465b$var$resolveStop(action, context, _event) {
    var actorRefOrString = $7660b420d0d64aff$exports.isFunction(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === 'string' ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: $69dbe76788062148$exports.ActionTypes.Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $102fbd6db630465b$var$assign = function(assignment) {
    return {
        type: $8cfb856a6c58ceb2$exports.assign,
        assignment: assignment
    };
};
function $102fbd6db630465b$var$isActionObject(action) {
    return typeof action === 'object' && 'type' in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $102fbd6db630465b$var$after(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : '';
    return "".concat($69dbe76788062148$exports.ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $102fbd6db630465b$var$done(id, data) {
    var type = "".concat($69dbe76788062148$exports.ActionTypes.DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $102fbd6db630465b$var$doneInvoke(id, data) {
    var type = "".concat($69dbe76788062148$exports.ActionTypes.DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $102fbd6db630465b$var$error(id, data) {
    var type = "".concat($69dbe76788062148$exports.ActionTypes.ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $102fbd6db630465b$var$pure(getActions) {
    return {
        type: $69dbe76788062148$exports.ActionTypes.Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $102fbd6db630465b$var$forwardTo(target, options) {
    if (!$6d03ab5332d93c91$exports.IS_PRODUCTION && (!target || typeof target === 'function')) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === 'function' ? originalTarget_1.apply(void 0, $45f2cc28951a3066$exports.__spreadArray([], $45f2cc28951a3066$exports.__read(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $102fbd6db630465b$var$send(function(_, event) {
        return event;
    }, $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $102fbd6db630465b$var$escalate(errorData, options) {
    return $102fbd6db630465b$var$sendParent(function(context, event, meta) {
        return {
            type: $8cfb856a6c58ceb2$exports.error,
            data: $7660b420d0d64aff$exports.isFunction(errorData) ? errorData(context, event, meta) : errorData
        };
    }, $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, options), {
        to: $69dbe76788062148$exports.SpecialTargets.Parent
    }));
}
function $102fbd6db630465b$var$choose(conds) {
    return {
        type: $69dbe76788062148$exports.ActionTypes.Choose,
        conds: conds
    };
}
var $102fbd6db630465b$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = $45f2cc28951a3066$exports.__values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === $8cfb856a6c58ceb2$exports.assign) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $102fbd6db630465b$var$resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $102fbd6db630465b$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? $7660b420d0d64aff$exports.updateContext(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case $8cfb856a6c58ceb2$exports.raise:
                var raisedAction = $102fbd6db630465b$var$resolveRaise(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === 'number') predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case $8cfb856a6c58ceb2$exports.send:
                var sendAction = $102fbd6db630465b$var$resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!$6d03ab5332d93c91$exports.IS_PRODUCTION) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    $7660b420d0d64aff$exports.warn(!$7660b420d0d64aff$exports.isString(configuredDelay) || typeof sendAction.delay === 'number', "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== $69dbe76788062148$exports.SpecialTargets.Internal) {
                    if (blockType === 'entry') deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case $8cfb856a6c58ceb2$exports.log:
                var resolved = $102fbd6db630465b$var$resolveLog(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case $8cfb856a6c58ceb2$exports.choose:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = $7660b420d0d64aff$exports.toGuard(condition.cond, machine.options.guards);
                    return !guard || $7660b420d0d64aff$exports.evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = $45f2cc28951a3066$exports.__read($102fbd6db630465b$var$resolveActions(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $102fbd6db630465b$var$toActionObjects($7660b420d0d64aff$exports.toArray(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case $8cfb856a6c58ceb2$exports.pure:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = $45f2cc28951a3066$exports.__read($102fbd6db630465b$var$resolveActions(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $102fbd6db630465b$var$toActionObjects($7660b420d0d64aff$exports.toArray(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case $8cfb856a6c58ceb2$exports.stop:
                var resolved = $102fbd6db630465b$var$resolveStop(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case $8cfb856a6c58ceb2$exports.assign:
                updatedContext = $7660b420d0d64aff$exports.updateContext(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $102fbd6db630465b$var$toActionObject(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = $45f2cc28951a3066$exports.__assign($45f2cc28951a3066$exports.__assign({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, $45f2cc28951a3066$exports.__spreadArray([
                                preservedContexts[contextIndex_1]
                            ], $45f2cc28951a3066$exports.__read(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = $45f2cc28951a3066$exports.__values(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = $7660b420d0d64aff$exports.flatten(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}
$102fbd6db630465b$exports.actionTypes = $8cfb856a6c58ceb2$exports;
$102fbd6db630465b$exports.after = $102fbd6db630465b$var$after;
$102fbd6db630465b$exports.assign = $102fbd6db630465b$var$assign;
$102fbd6db630465b$exports.cancel = $102fbd6db630465b$var$cancel;
$102fbd6db630465b$exports.choose = $102fbd6db630465b$var$choose;
$102fbd6db630465b$exports.done = $102fbd6db630465b$var$done;
$102fbd6db630465b$exports.doneInvoke = $102fbd6db630465b$var$doneInvoke;
$102fbd6db630465b$exports.error = $102fbd6db630465b$var$error;
$102fbd6db630465b$exports.escalate = $102fbd6db630465b$var$escalate;
$102fbd6db630465b$exports.forwardTo = $102fbd6db630465b$var$forwardTo;
$102fbd6db630465b$exports.getActionFunction = $102fbd6db630465b$var$getActionFunction;
$102fbd6db630465b$exports.initEvent = $102fbd6db630465b$var$initEvent;
$102fbd6db630465b$exports.isActionObject = $102fbd6db630465b$var$isActionObject;
$102fbd6db630465b$exports.log = $102fbd6db630465b$var$log;
$102fbd6db630465b$exports.pure = $102fbd6db630465b$var$pure;
$102fbd6db630465b$exports.raise = $102fbd6db630465b$var$raise;
$102fbd6db630465b$exports.resolveActions = $102fbd6db630465b$var$resolveActions;
$102fbd6db630465b$exports.resolveLog = $102fbd6db630465b$var$resolveLog;
$102fbd6db630465b$exports.resolveRaise = $102fbd6db630465b$var$resolveRaise;
$102fbd6db630465b$exports.resolveSend = $102fbd6db630465b$var$resolveSend;
$102fbd6db630465b$exports.resolveStop = $102fbd6db630465b$var$resolveStop;
$102fbd6db630465b$exports.respond = $102fbd6db630465b$var$respond;
$102fbd6db630465b$exports.send = $102fbd6db630465b$var$send;
$102fbd6db630465b$exports.sendParent = $102fbd6db630465b$var$sendParent;
$102fbd6db630465b$exports.sendTo = $102fbd6db630465b$var$sendTo;
$102fbd6db630465b$exports.sendUpdate = $102fbd6db630465b$var$sendUpdate;
$102fbd6db630465b$exports.start = $102fbd6db630465b$var$start;
$102fbd6db630465b$exports.stop = $102fbd6db630465b$var$stop;
$102fbd6db630465b$exports.toActionObject = $102fbd6db630465b$var$toActionObject;
$102fbd6db630465b$exports.toActionObjects = $102fbd6db630465b$var$toActionObjects;
$102fbd6db630465b$exports.toActivityDefinition = $102fbd6db630465b$var$toActivityDefinition;





const $e17cb201b9c0bc3c$var$getNow = ()=>Date.now();
const $e17cb201b9c0bc3c$export$bafb50f232c27e2f = /** @xstate-layout N4IgpgJg5mDOIC5QEECuECWB7ABABQBsBDATzACcBiAYQK1jAG0AGAXUVAAd6MAXbAHYcQAD0QBOAKwBmAHTiAjJIUB2AGwKATNPHNpAFgA0IEogAczWczXNmK8fZtr9Z-QF83xtJlyFSFSgAlODBeFnYkEG5YPkFhMQRNJVllZRVJTTUVTPE1aWNTBH1LZikFVX0FcXEzcUr3TxBvbHxiMioAeQEcABksIggcAFksciY2YWjYrCFIhI1ZBTVcqTUzbNqVfJNEAFpNZk1ZHUcNZn1JKX0Gr3QWv3bZAEkAOSeAFSfkHso+gZxgrAsKhyABjODhSY8fgzeJ7LRHOySSRqTSSdKlKQFRBohSyMzSaQo5jIsyXNFmDy3HytfzkWSBACiyAAIgBNSgPHC8AAWGFgOHIPJCkMiUxhs1ACXKzDx0gUZk0FmY63RmhU2IQ0iyi0qNUkthUemklMazV8bQoDOZ7NkAHVkB9XgBxTltUVcaFxOaIJTXfEo9ZqZHlaSaTSalFydHOMyK6pxzRUpp3C1062stmyPA9ZBsl2coioBgeqJe2E+xJKySyVEaRUWOpojU7BBbaN6Nb6bLdlUKZPm2mPJmZ7O5-MvV3BIig4WDRkCCCl8XeqW+mxmeThzT6VEqfSZRWaypyBSEpVrcr2VwD1NDq0j205vMFgASREXBDAQ4ARjOANYAkQvDftQPIfjAy7lpKoi+hY+iyPohL7j25RaGYkYGIhVxkr26gqCot40g8D42lmz4Ts69qOp8k44AAYh0gQ4CyyDvMglAQDMYCyBgAgAG5YP+PGDiR9KPuR44utRTp0YxzGsexCB8YJoLAYI4RQTEEpwggWiSJumg1GYqiKGSKiuJqCjWDWVRqPZBwIhoSZmneYkZk+UmTjJtHOgxTEsWxHEUOQoyyJwxC8AAZqMAC2siiZa4lkWOL7eQ6sl+fJgVKSpWBqRKmkTGK0G6QR4jHHGlTnCS0hbJImriDo8jla42g6LiRH3ElHmSWlVEZb5-nMcgACqLJPB0ODvFNADK7GBO8nHcbxAlCSJbk9RJqWUT5LrDTgY0TVNM04PNyCLcpa0FRpbBadMMHSnGeJVNutQuFIDWttZFnHCiSR1d2RpqF1abDilFHSYN+3ZUdk3TXNC1LSFYURcBMXkPFiXpttkPpTRMMBXDJ2Ixd7xXap6kzEVESetpq6wW2lSLFUrjrKGChIVZnNHDU1wHsoSjIi51LdTjENjbNjIskEcCoLF4y02W9MVmuVa-cswb2T9tVfYU1QqMc1g7lo4g7nGhGucRPWMoEgRMbLvDkCQ906ZWBKGzu5xZBYBGHBhrbdnI9hGhiJo7vZkig-e9I9B0rL7cgs1S+8s2UPRRAYAQIKK1CKuPYgYZqLWbWmVIBEKJqBKWNZwa1JzWRm-2Vti48ccJ3RScp2nGdZznjAKErK6q4zwZ4vuRfrNc1jOFX0g1zZ8pm5clQiym1vpu3E2d8njKp7IW8Fq7DMJHGiGSMU3bEuGFkRq2O6G2sdS5HoLjXlHLdg1ah8793B-x9vV0A8h6lUrFkI4S8zYP2RHkO+hR5TjwMvqBwFkUSW1Fl-WOADE6733j-IBmgQH510nVGsMgDiKE5pcBws9A7OFkOkBBQs7IXBuOvVu39sG-z3rNWQ9E97UFfAWLiAgeJ5WEglTam8uF+S7jwvhAihGTgpvlKmAgaZ5werpAksgkgKjqjULsTVIzZFrHo-Quh0jqAVNHdy+DDq4N4fw94giCwo3pGjaKcVJEbzbjIhxf9nGuOUXlG61M7rFTploysyI5BEmqHkOMuhcgtkKC4Wy6QyS1X0noDwjQBBYAgHAYQ2N2iaLdmrXYqgSjpH+uiA01Q9Z7G7Ihc4z10RGkbKaDBMdnhvE+N8cpJ89hmysAackBImr1TUFZZQ+IDCKgRAeWBbDSmkUzEMke0parHAVEqWwqpsipJxPYWseo8j2ByJzWxW0UrQ0nJsgueklBHBUFUEkBIdBEmuMeBwupNhmy2LuXIH8enuVxl5Z0jzdKhgqokm+Bp1h1CMK2J+iELLnAIkaUo6Qbni1HHjAaBM5IBUUsgaFlZyjrFrOHdUiL7A-NbIoBCDgLDhgbAcG8n9ekQv6jtRO41JoUrVqoHUeg3k-RkPPJUjVZQtQsKobItgNDSDxeDAlkK9okpGoKkmZ0kbCsZi84u9gqgyF0LubU2xCjWRkH9VESp+adlVdy8FEtRpSxZIahICL8RJANNcWJZ4q55DGSqOoqQGlrzWfSagcdPXet9EsBCFwdzFG1EsJwVcSg2DsA4F+sYXVgptnbJiiaECTJSA4dEKpzWc0jE1fEQMTTLCqNUcQarOEd1kY48tRJdFUoMWYIx88UXwIIromQpRjTqHDEoTtWDu0BPkfg8tZ4Krdm0NM2tMhjxbAYQ4JEehFS7mDAu-+S65H7yCUoqFJViGVkJCa2ougDLhikIca1iAa3HCBnYC4tg515LcEAA */ (0, $459aec9d6c563a19$export$aaa7fa18f8e9b2e8)({
    tsTypes: {},
    id: "Audio Player",
    initial: "INITIAL",
    states: {
        INITIAL: {
            on: {
                "Load Resources": {
                    target: "LOADING ASSETS",
                    actions: "Set resources in context"
                }
            }
        },
        READY: {
            initial: "WAITING",
            states: {
                WAITING: {
                    entry: [
                        "Select rhese to play",
                        "Play rhese if needed"
                    ],
                    on: {
                        Play: {
                            target: "PLAYING"
                        }
                    }
                },
                PLAYING: {
                    entry: [
                        "Play audio"
                    ],
                    exit: [
                        "Pause audio",
                        "Cancel delay",
                        "Rhese Played"
                    ],
                    on: {
                        Pause: {
                            target: "PAUSED"
                        },
                        "Reached End": {
                            target: "WAITING"
                        },
                        "Handle Playback Rate Change": {
                            target: "PLAYING",
                            internal: true,
                            actions: [
                                "Cancel delay"
                            ]
                        }
                    },
                    states: {
                        "WAITING FOR DATA": {
                            invoke: {
                                src: "Attach audio ready listener",
                                onDone: "WAITING FOR AUDIO TO START",
                                onError: {
                                    target: "#Audio Player.ERROR"
                                }
                            }
                        },
                        "PLAYING AUDIO": {
                            entry: [
                                "Send 'Reached End' when done playing"
                            ]
                        },
                        "WAITING FOR AUDIO TO START": {
                            invoke: {
                                src: "Call async play on audio element",
                                onDone: "PLAYING AUDIO",
                                onError: {
                                    target: "#Audio Player.ERROR"
                                }
                            }
                        }
                    },
                    initial: "WAITING FOR DATA"
                },
                PAUSED: {
                    on: {
                        Resume: {
                            target: "PLAYING"
                        }
                    }
                }
            },
            on: {
                "Play this rhese": {
                    target: "READY.WAITING",
                    internal: false
                }
            }
        },
        CLOSED: {},
        ERROR: {
            on: {
                Retry: "LOADING ASSETS"
            }
        },
        "LOADING ASSETS": {
            states: {
                LOADING: {
                    always: [
                        {
                            target: "#Audio Player.INITIAL",
                            cond: "There is no audio"
                        },
                        {
                            target: "#Audio Player.READY",
                            cond: "All files are loaded"
                        },
                        "FETCHING"
                    ]
                },
                FETCHING: {
                    invoke: {
                        src: "Run fetch Assets",
                        onDone: {
                            target: "LOADING",
                            actions: "Fetching Done"
                        },
                        onError: {
                            actions: "Fetching Error",
                            target: "FETCHING",
                            internal: true
                        }
                    }
                }
            },
            initial: "LOADING",
            on: {
                Failure: [
                    {
                        cond: "Network Error",
                        target: "LOADING ASSETS",
                        internal: true
                    },
                    "ERROR"
                ]
            }
        }
    },
    schema: {
        context: {},
        events: {},
        services: {}
    },
    context: {
        resourcesToLoad: [],
        loadedFiles: [],
        fetchingErrorMessage: "",
        audioElement: null,
        rhesesWithRecording: [],
        currentRheseId: null,
        successfulyPlayedRhese: null
    },
    predictableActionArguments: true,
    preserveActionOrder: true,
    on: {
        Close: ".CLOSED",
        Reset: {
            target: ".INITIAL",
            actions: "Execute Reset Callback"
        },
        "On Load More": {
            // target: "LOADING ASSETS",
            actions: "Update resources in context"
        }
    }
}, {
    guards: {
        "All files are loaded": (context)=>{
            const isFilenameInLoadedFile = (resourceName)=>context.loadedFiles.find((file)=>file.filename === resourceName);
            return context.resourcesToLoad.every(isFilenameInLoadedFile);
        },
        "There is no audio": (context)=>context.resourcesToLoad.length === 0,
        "Network Error": ()=>false
    },
    actions: {
        "Select rhese to play": (0, $9c5de0376eae7f00$export$e6e34fd1f2686227)({
            successfulyPlayedRhese: (context, event)=>event.type === "Reached End" ? context.currentRheseId : null,
            currentRheseId: (context, event)=>{
                if (event.type === "Reached End") {
                    const nextRheseIndex = $e17cb201b9c0bc3c$var$getOrderedRheses(context.rhesesWithRecording).findIndex((rhese)=>rhese.data.id === context.currentRheseId) + 1;
                    const nextRhese = context.rhesesWithRecording[nextRheseIndex];
                    if (nextRhese) return nextRhese.data.id;
                    return context.currentRheseId;
                } else if (event.type === "Play this rhese") return event.rheseId;
                else if (context.currentRheseId) // Note: could happen after  an audio cropping, which will trigger a data change.
                // In this case we want to keep the same focused rhese
                return context.currentRheseId;
                else return $e17cb201b9c0bc3c$var$getOrderedRheses(context.rhesesWithRecording)[0].data.id;
            }
        }),
        "Set resources in context": (0, $9c5de0376eae7f00$export$e6e34fd1f2686227)((_context, event)=>({
                resourcesToLoad: [
                    ...new Set(event.audioRecordings.map((recording)=>recording.fileUuid))
                ],
                rhesesWithRecording: event.rhesesWithPos,
                audioElement: event.audioElement
            })),
        "Update resources in context": (0, $9c5de0376eae7f00$export$e6e34fd1f2686227)((_context, event)=>({
                rhesesWithRecording: event.rhesesWithPos
            })),
        "Play rhese if needed": (0, $9c5de0376eae7f00$export$89db4734f6c919c4)((_context, event)=>{
            const shouldPlay = event.type === "Reached End" && event.shouldPlayNext || event.type === "Play this rhese";
            return {
                type: shouldPlay ? "Play" : ""
            };
        }),
        "Fetching Done": (0, $9c5de0376eae7f00$export$e6e34fd1f2686227)((context, event)=>{
            return {
                loadedFiles: [
                    ...context.loadedFiles,
                    ...event.data.files
                ]
            };
        }),
        "Play audio": (context, event)=>{
            const audioElement = context.audioElement;
            if (!audioElement) throw new Error("'Play audio' triggered, but audioElement is not defined");
            audioElement.muted = false;
            const audioRhese = context.rhesesWithRecording.find((r)=>r.data.id === context.currentRheseId);
            const [realStart, realEnd] = (0, $da283d5b98d33135$export$363751161ac18838)(audioRhese.data.audioInfo);
            if (event.type === "Play") {
                if (!context.currentRheseId) // Todo use https://xstate.js.org/docs/guides/typescript.html#typestates
                // But it is not supported in v4 but should be fixed in v5
                throw new Error("Should never be null");
                // needed to reset playback rate, changing src will reset playbackRate info
                let playbackRate = audioElement.playbackRate;
                // "src" attribute
                let src = (0, $da283d5b98d33135$export$b1cbf64eeaa0d47e)(context.currentRheseId, context.rhesesWithRecording, context.loadedFiles);
                src += `#t=${realStart},${realEnd}`; // Note: perf optimization
                audioElement.src = src;
                audioElement.preload = "auto";
                audioElement.playbackRate = playbackRate;
                audioElement.dataset.rheseId = context.currentRheseId; // needed to be able to know when the audioElement is about a new rhese (Note: audio's src can remain the same for different rheses)
                audioElement.currentTime = realStart; // Begin at the right time
            }
        },
        "Send 'Reached End' when done playing": (0, $9c5de0376eae7f00$export$89db4734f6c919c4)((context)=>{
            const isLastRhese = $e17cb201b9c0bc3c$var$getOrderedRheses(context.rhesesWithRecording)[context.rhesesWithRecording.length - 1].data.id === context.currentRheseId;
            return {
                type: "Reached End",
                shouldPlayNext: !isLastRhese,
                currentRheseId: context.currentRheseId
            };
        }, {
            delay: (context)=>{
                // We send Play message with a "end" with a delay to stop the audio at the right time
                if (!context.audioElement) throw "'Select next rhese'>'delay' tiggered, but audioElement is not defined";
                const audioRhese = context.rhesesWithRecording.find((r)=>r.data.id === context.currentRheseId);
                let [realStart, realEnd] = (0, $da283d5b98d33135$export$363751161ac18838)(audioRhese.data.audioInfo);
                const playbackRate = context.audioElement.playbackRate;
                const currentTime = context.audioElement.currentTime;
                const diff = currentTime - realStart;
                const realStartWithOffset = realStart + diff;
                const durationInMs = (realEnd - realStartWithOffset) * 1000;
                return durationInMs * (1 / playbackRate);
            },
            id: "Delay as much as audio duration in ms"
        }),
        "Pause audio": (context)=>{
            if (!context.audioElement) throw new Error("Pause audio error");
            context.audioElement.muted = true; // TODO Loic : keep or not ?
            context.audioElement.pause();
        },
        "Cancel delay": (0, $102fbd6db630465b$exports.cancel)("Delay as much as audio duration in ms"),
        "Fetching Error": (0, $9c5de0376eae7f00$export$e6e34fd1f2686227)({
            fetchingErrorMessage: (_context, event)=>{
                let message = "An error occured";
                if (event.data instanceof Error) message = event.data.message;
                return message;
            }
        }),
        "Execute Reset Callback": (_context, event)=>{
            event.callback?.();
        },
        "Rhese Played": ()=>{}
    },
    services: {
        "Run fetch Assets": async (context)=>{
            const { resourcesToLoad: resourcesToLoad, loadedFiles: loadedFiles } = context;
            // Fetch only the new audios
            const filteredResourcesToLoad = resourcesToLoad.filter((r)=>!loadedFiles.find((f)=>f.filename === r));
            const jobs = filteredResourcesToLoad.map(async (filename)=>{
                const { data: data } = await (0, $59a312a0f31003ae$export$388e0302ca0d9a41).query({
                    query: (0, $651ac2e042bd2c5e$export$3749e9e8883dd1ea),
                    variables: {
                        filename: filename
                    }
                });
                return {
                    filename: filename,
                    getUrl: data?.audioRecording?.presignedUrl?.getUrl
                };
            });
            const filenamesWithUrls = await Promise.all(jobs);
            const _jobs = filenamesWithUrls.map(async ({ filename: filename, getUrl: getUrl })=>{
                const data = await fetch(getUrl);
                const blob = await data.blob();
                return {
                    filename: filename,
                    blob: blob,
                    url: URL.createObjectURL(blob)
                };
            });
            const files = await Promise.all(_jobs);
            return {
                files: files
            };
        },
        "Attach audio ready listener": (context, event)=>new Promise((resolve, reject)=>{
                const { audioElement: audioElement } = context;
                if (!audioElement) return reject(new Error("Attach audio ready listener doesn't have audioElement"));
                if (event.type === "Resume" || event.type === "Handle Playback Rate Change") return resolve({
                    latency: 0
                });
                const beforeStartDate = $e17cb201b9c0bc3c$var$getNow();
                const MAX_TIMEOUT_IN_MS = 500;
                let alreadyCleared = false;
                const onLoadData = ()=>{
                    if (audioElement.readyState >= 4) {
                        const onReadyDate = $e17cb201b9c0bc3c$var$getNow();
                        const latency = onReadyDate - beforeStartDate;
                        clearSideEffects();
                        resolve({
                            latency: latency
                        });
                    }
                };
                const onError = (e)=>{
                    clearSideEffects();
                    return reject(new Error("Audio  addEventListener error", e));
                };
                const clearSideEffects = ()=>{
                    if (alreadyCleared) return;
                    alreadyCleared = true;
                    clearTimeout(timeoutId);
                    audioElement.removeEventListener("loadeddata", onLoadData);
                    audioElement.removeEventListener("error", onError);
                };
                audioElement.addEventListener("loadeddata", onLoadData);
                audioElement.addEventListener("error", onError);
                const timeoutId = setTimeout(()=>{
                    const shouldResolve = !alreadyCleared;
                    clearSideEffects();
                    if (shouldResolve) resolve({
                        latency: MAX_TIMEOUT_IN_MS
                    });
                }, MAX_TIMEOUT_IN_MS);
            }),
        "Call async play on audio element": (context)=>{
            return new Promise((resolve, reject)=>{
                const start = performance.now();
                const { audioElement: audioElement } = context;
                if (!(audioElement instanceof HTMLAudioElement)) return reject("Audio element undefined");
                audioElement.onplaying = ()=>{
                    const end = performance.now();
                    resolve({
                        latency: end - start
                    });
                    return;
                };
                audioElement.onerror = reject;
                if (audioElement.paused) audioElement.play();
            });
        }
    }
});
const $e17cb201b9c0bc3c$var$getOrderedRheses = (rheses)=>rheses.sort((a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start);



const $007e357d1699952e$var$initialAudioPlayerService = (0, $30e2e977433e6273$export$67beed298888a38b)((0, $e17cb201b9c0bc3c$export$bafb50f232c27e2f));
const $007e357d1699952e$export$60389e05c30a25 = /*#__PURE__*/ (0, $jMaZ8.createContext)({
    audioPlayerService: $007e357d1699952e$var$initialAudioPlayerService
});
function $007e357d1699952e$export$2e2bcd8739ae039(props) {
    const audioPlayerService = (0, $e2c092b90dab4701$export$d9e9b060fbbae528)((0, $e17cb201b9c0bc3c$export$bafb50f232c27e2f));
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($007e357d1699952e$export$60389e05c30a25.Provider, {
        value: {
            audioPlayerService: props.service ?? audioPlayerService
        },
        children: props.children
    });
}


function $61adf8e840ec0489$export$2e2bcd8739ae039() {
    const { audioPlayerService: audioPlayerService } = (0, $jMaZ8.useContext)((0, $007e357d1699952e$export$60389e05c30a25));
    const [state, send] = (0, $739bd1b89b2e3318$export$25c4ab29592aabd9)(audioPlayerService);
    const isLoadingRessources = state.matches("LOADING ASSETS");
    const isWaiting = state.matches("READY.WAITING");
    const isPaused = state.matches("READY.PAUSED");
    const isPlaying = state.matches("READY.PLAYING");
    const togglePlay = (0, $jMaZ8.useCallback)(()=>{
        if (isWaiting) send({
            type: "Play"
        });
        if (isPaused) send({
            type: "Resume"
        });
        if (isPlaying) send({
            type: "Pause"
        });
    }, [
        isPaused,
        isPlaying,
        isWaiting,
        send
    ]);
    return {
        isInitializing: state.matches("INITIAL"),
        state: state,
        send: send,
        isLoadingRessources: // shortcuts
        isLoadingRessources,
        isPaused: isWaiting || isPaused,
        isPlaying: isPlaying,
        isWaiting: isWaiting,
        togglePlay: togglePlay,
        currentRheseId: state.context.currentRheseId
    };
}


function $ab8c729b33cca8b3$export$2e2bcd8739ae039({ projectId: projectId, recording: recording, info: info, defaultStartOffset: defaultStartOffset, defaultEndOffset: defaultEndOffset }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const audioPlayerMachine = (0, $61adf8e840ec0489$export$2e2bcd8739ae039)();
    const [isOpen, setIsOpen] = (0, $jMaZ8.useState)(false);
    const showModal = (0, $jMaZ8.useCallback)(()=>setIsOpen(true), []);
    const hideModal = (0, $jMaZ8.useCallback)(()=>setIsOpen(false), []);
    const onDone = (0, $jMaZ8.useCallback)(()=>{
        hideModal();
    }, [
        hideModal
    ]);
    (0, $jMaZ8.useEffect)(()=>{
        if (isOpen) audioPlayerMachine.send({
            type: "Pause"
        });
    // Only "isOpen" in deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                shape: "circle",
                onClick: showModal,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5453b18558c87ec6$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f57978dfa9715a4c$export$2e2bcd8739ae039), {
                title: t("audioOffset"),
                open: isOpen,
                footer: null,
                onCancel: hideModal,
                // NOTE: "maskClosable" is need to avoid modal closing when dropping the slider drag outside of the modal
                maskClosable: false,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $77f1e7c43da53f17$export$2e2bcd8739ae039), {
                    projectId: projectId,
                    recording: recording,
                    info: info,
                    onDone: onDone,
                    defaultStartOffset: defaultStartOffset,
                    defaultEndOffset: defaultEndOffset
                })
            }, isOpen.toString())
        ]
    });
}





parcelRequire("jMaZ8");
var // eslint-disable-next-line react/display-name
$01a009a0bdcfd97e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                x: "5.5",
                y: "4",
                width: "5",
                height: "16",
                rx: "2.5",
                fill: "#E66525"
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("rect", {
                x: "13.5",
                y: "4",
                width: "5",
                height: "16",
                rx: "2.5",
                fill: "#E66525"
            })
        ]
    });


const $b96cc6b8576a6d0a$var$Rhese = ({ rhese: rhese, playRhese: playRhese, setRefRheseToPlay: setRefRheseToPlay, selectionAnchor: selectionAnchor, setSelectedRhese: setSelectedRhese, selectedRheses: selectedRheses, resetSelection: resetSelection, isCurrentRhese: isCurrentRhese, isPlaying: isPlaying, projectId: projectId, pageMetadata: pageMetadata })=>{
    const [t] = (0, $2dea202f423e126f$export$9fc83ad70ead8663)();
    const [updateAudioReview] = (0, $861562afdbad1429$export$e94bfdb192d5d7d6)();
    const [createAudioReview] = (0, $861562afdbad1429$export$2eb58638a4193c9b)();
    const audioInfo = rhese.data.audioInfo;
    const recording = rhese.data.audioRecording;
    const { duration: duration, startOffset: startOffset, endOffset: endOffset, isCropped: isCropped } = (0, $8ca13888d5d57880$export$50488aa19a0f9066)(rhese, 1);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
        whileHover: "hover",
        className: $5c2d3cdd96b7835a$export$d89dc70d9d82cb3b,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                "data-rhese-id": rhese.data.id,
                ref: (ref)=>isCurrentRhese && setRefRheseToPlay(ref),
                "data-rhese-to-play": isCurrentRhese ? "true" : "false",
                "data-selected": selectedRheses?.find((r)=>r.data.id === rhese.data.id) ? "true" : "false",
                onClick: (e)=>{
                    e.stopPropagation();
                    setSelectedRhese(rhese.data.id);
                },
                className: `${$5c2d3cdd96b7835a$export$864af25a7f7e70fe}`,
                children: [
                    selectionAnchor && selectionAnchor === rhese.data.id && selectedRheses?.length === 0 && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $5c2d3cdd96b7835a$export$2e2992790a6f69a8
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        className: $5c2d3cdd96b7835a$export$a7db06668cad9adb,
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                            children: [
                                rhese.data.ignoreTextForAudioSync && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
                                    title: t("rheseIconSyncroTooltip"),
                                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3188cd1e60a390d5$export$2e2bcd8739ae039), {
                                        className: $5c2d3cdd96b7835a$export$ce5d78961483d611
                                    })
                                }),
                                pageMetadata?.textContent.substring(rhese.anchors[0].utf16Start - pageMetadata?.page.anchors[0].utf16Start, rhese.anchors[0].utf16Start + rhese.anchors[0].utf16Size - pageMetadata?.page.anchors[0].utf16Start)
                            ]
                        })
                    }),
                    audioInfo && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                        onClick: (e)=>e.stopPropagation(),
                        className: $5c2d3cdd96b7835a$export$78c1a67d0944270,
                        children: [
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("p", {
                                className: $5c2d3cdd96b7835a$export$d04d442d31aabc67,
                                children: [
                                    duration?.toFixed(2),
                                    "s"
                                ]
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: isCropped ? 1 : 0.3
                                },
                                variants: {
                                    hover: {
                                        opacity: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ab8c729b33cca8b3$export$2e2bcd8739ae039), {
                                    info: audioInfo,
                                    projectId: projectId,
                                    recording: recording,
                                    defaultStartOffset: startOffset,
                                    defaultEndOffset: endOffset
                                })
                            }, isCropped.toString()),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: audioInfo.comment ? 1 : 0.3
                                },
                                animate: {
                                    opacity: audioInfo.comment ? 1 : 0.3
                                },
                                variants: {
                                    hover: {
                                        opacity: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e448ce0666ee897e$export$2e2bcd8739ae039), {
                                    defaultValue: audioInfo.comment,
                                    onValidate: (comment)=>audioInfo.reviewId ? updateAudioReview({
                                            variables: {
                                                projectId: projectId,
                                                reviewId: audioInfo.reviewId,
                                                status: audioInfo.status || (0, $b522cf181e75e62d$export$221b784fada1dd4a).VALID,
                                                comment: comment
                                            }
                                        }) : createAudioReview({
                                            variables: {
                                                projectId: projectId,
                                                rheseId: rhese.data.id,
                                                status: audioInfo.status || (0, $b522cf181e75e62d$export$221b784fada1dd4a).VALID,
                                                comment: comment
                                            }
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a6ea860e715f186d$export$2e2bcd8739ae039), {
                                status: audioInfo.status,
                                onChange: (status)=>{
                                    audioInfo.reviewId ? updateAudioReview({
                                        variables: {
                                            projectId: projectId,
                                            reviewId: audioInfo.reviewId,
                                            status: status,
                                            comment: audioInfo.comment
                                        }
                                    }) : createAudioReview({
                                        variables: {
                                            projectId: projectId,
                                            rheseId: rhese.data.id,
                                            status: status,
                                            comment: audioInfo.comment
                                        }
                                    });
                                    resetSelection();
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                className: $5c2d3cdd96b7835a$export$f150c56d95417c69,
                initial: {
                    opacity: 0
                },
                variants: {
                    hover: {
                        opacity: 1
                    }
                },
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                    shape: "round",
                    onClick: playRhese(rhese),
                    disabled: !recording?.fileUuid,
                    children: isPlaying ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $01a009a0bdcfd97e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $271ab9cb7ddc7c14$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
};
var $b96cc6b8576a6d0a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jMaZ8.memo)($b96cc6b8576a6d0a$var$Rhese, (prevProps, nextProps)=>{
    const oneOfSelectedRheseIsMe = prevProps.selectedRheses?.find((r)=>r.data.id === prevProps.rhese.data.id);
    const oneOfSelectedRheseIsMeNext = nextProps.selectedRheses?.find((r)=>r.data.id === nextProps.rhese.data.id);
    const previousRheseData = JSON.stringify(prevProps.rhese.data);
    const nextRheseData = JSON.stringify(nextProps.rhese.data);
    const previousTextContent = prevProps.pageMetadata?.textContent;
    const nextTextContent = nextProps.pageMetadata?.textContent;
    return prevProps.isCurrentRhese === nextProps.isCurrentRhese && prevProps.isPlaying === nextProps.isPlaying && oneOfSelectedRheseIsMe === oneOfSelectedRheseIsMeNext && previousRheseData === nextRheseData && previousTextContent === nextTextContent;
});



const $2b82b64551ddcb76$var$Rheses = ({ selectionAnchor: selectionAnchor, groupedRheses: groupedRheses, setSelectedRhese: setSelectedRhese, selectedRheses: selectedRheses, resetSelection: resetSelection, resetSelectionStatus: resetSelectionStatus, currentRheseId: currentRheseId, isPlaying: isPlaying, isWaiting: isWaiting, projectId: projectId, pageMetadata: pageMetadata })=>{
    const audioPlayerMachine = (0, $61adf8e840ec0489$export$2e2bcd8739ae039)();
    const onPlayRhesePressed = (0, $jMaZ8.useCallback)((rhese)=>()=>{
            if (rhese.id === currentRheseId && isPlaying) audioPlayerMachine.send({
                type: "Pause"
            });
            else if (rhese.data.id === currentRheseId && !isPlaying && !isWaiting) audioPlayerMachine.send({
                type: "Resume"
            });
            else audioPlayerMachine.send({
                type: "Play this rhese",
                rheseId: rhese.data.id
            });
        }, [
        audioPlayerMachine,
        currentRheseId,
        isPlaying,
        isWaiting
    ]);
    const [updateAudioReview] = (0, $861562afdbad1429$export$e94bfdb192d5d7d6)();
    const [addAudioReview] = (0, $861562afdbad1429$export$2eb58638a4193c9b)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    // Scroll logic
    const [refRheseToPlay, setRefRheseToPlay] = (0, $jMaZ8.useState)(null);
    (0, $jMaZ8.useEffect)(()=>{
        refRheseToPlay?.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }, [
        refRheseToPlay
    ]);
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $8043386845b9e569$export$3ae376d12526dd6f), {
                exitBeforeEnter: true,
                children: selectedRheses && selectedRheses.length > 0 && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $0ad12ec738f3c09f$export$e25e478948902b8b).div, {
                    initial: {
                        y: "150%"
                    },
                    exit: {
                        y: "150%"
                    },
                    animate: {
                        y: "0%"
                    },
                    transition: {
                        bounce: 0
                    },
                    className: $5c2d3cdd96b7835a$export$c2e65443ea38786,
                    children: [
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("span", {
                            children: t("audioReview.addAReviewToSelectedRheses")
                        }),
                        /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                            className: $5c2d3cdd96b7835a$export$e324594224ef24da,
                            children: [
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                                    shape: "round",
                                    onClick: resetSelection,
                                    children: t("cancel")
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $87f3bc3ef500e2a7$export$2e2bcd8739ae039), {
                                    resetSelectionStatus: resetSelectionStatus
                                }),
                                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a6ea860e715f186d$export$2e2bcd8739ae039), {
                                    onChange: (status)=>{
                                        selectedRheses.forEach((rhese)=>{
                                            if (rhese.data.audioInfo?.status === status) return;
                                            if (rhese.data.audioInfo?.status && rhese.data.audioInfo.reviewId) updateAudioReview({
                                                variables: {
                                                    projectId: projectId,
                                                    reviewId: rhese.data.audioInfo.reviewId,
                                                    status: status
                                                }
                                            });
                                            else addAudioReview({
                                                variables: {
                                                    projectId: projectId,
                                                    rheseId: rhese.data.id,
                                                    status: status
                                                }
                                            });
                                        });
                                        resetSelection();
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $5c2d3cdd96b7835a$export$c4a79ec0e91224d1,
                onClick: resetSelection,
                children: groupedRheses.map(({ rheses: rheses, paragraphId: paragraphId })=>{
                    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                        children: rheses.sort((a, b)=>a.anchors[0].utf16Start - b.anchors[0].utf16Start).map((rhese)=>{
                            return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b96cc6b8576a6d0a$export$2e2bcd8739ae039), {
                                projectId: projectId,
                                rhese: rhese,
                                playRhese: onPlayRhesePressed,
                                setRefRheseToPlay: setRefRheseToPlay,
                                selectionAnchor: selectionAnchor,
                                setSelectedRhese: setSelectedRhese,
                                selectedRheses: selectedRheses,
                                resetSelection: resetSelection,
                                isCurrentRhese: currentRheseId === rhese.data.id,
                                isPlaying: isPlaying && currentRheseId === rhese.data.id,
                                pageMetadata: pageMetadata
                            }, rhese.data.id);
                        })
                    }, paragraphId);
                })
            })
        ]
    });
};
var $2b82b64551ddcb76$export$2e2bcd8739ae039 = $2b82b64551ddcb76$var$Rheses;





var $jMaZ8 = parcelRequire("jMaZ8");









var $jMaZ8 = parcelRequire("jMaZ8");

const $dca027b4f5b04797$export$42ac28ad808e4540 = 1;
const $dca027b4f5b04797$export$86880b4b2e1a2384 = "MOBIDYS_AUDIO_PLAER_SPEED";
const $dca027b4f5b04797$export$61d78128ec09fe9e = [
    0.8,
    1.2
];
const $dca027b4f5b04797$export$c58c626e1f1c956f = 0.01;
const $dca027b4f5b04797$export$d6d635b5aefba05b = [
    0.8,
    0.9,
    1,
    1.1,
    1.2
];



const $106ba64b219a7604$export$d4c72bab9d6cc13a = {
    speed: (0, $dca027b4f5b04797$export$42ac28ad808e4540)
};
function $106ba64b219a7604$export$2e2bcd8739ae039(_state, action) {
    switch(action.type){
        case "SPEED_CHANGED":
            return {
                speed: action.value
            };
        default:
            throw new Error(`Action ${action.type} not handled`);
    }
}


const $d1aae9a57a309882$var$SpeedControlsContext = /*#__PURE__*/ (0, $jMaZ8.createContext)(undefined);
const $d1aae9a57a309882$export$78236ac4690545dc = ({ children: children })=>{
    const store = (0, $5e59f7a018e7ea3d$export$e01bc50e52e53f78)((0, $106ba64b219a7604$export$2e2bcd8739ae039), (0, $106ba64b219a7604$export$d4c72bab9d6cc13a), (0, $dca027b4f5b04797$export$86880b4b2e1a2384));
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($d1aae9a57a309882$var$SpeedControlsContext.Provider, {
        value: store,
        children: children
    });
};
const $d1aae9a57a309882$export$f0db995d9f98de3d = ()=>{
    const context = (0, $jMaZ8.useContext)($d1aae9a57a309882$var$SpeedControlsContext);
    if (!context) throw new Error("SpeedControlsContext must be used within a SpeedControlsProvider");
    return context;
};



var $jMaZ8 = parcelRequire("jMaZ8");
const $58a5df70f3e19767$var$useSpeed = (audioElement, speed, onChange = ()=>{})=>{
    const currentRheseId = audioElement.dataset.rheseId;
    (0, $jMaZ8.useEffect)(()=>{
        audioElement.playbackRate = speed;
        onChange(speed);
    }, [
        audioElement,
        currentRheseId,
        onChange,
        speed
    ]);
};
var $58a5df70f3e19767$export$2e2bcd8739ae039 = $58a5df70f3e19767$var$useSpeed;




var $jMaZ8 = parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $71ab248f0fe6d17c$exports = {};

$parcel$export($71ab248f0fe6d17c$exports, "popover", () => $71ab248f0fe6d17c$export$899efff2d0433d49, (v) => $71ab248f0fe6d17c$export$899efff2d0433d49 = v);
$parcel$export($71ab248f0fe6d17c$exports, "content", () => $71ab248f0fe6d17c$export$a7db06668cad9adb, (v) => $71ab248f0fe6d17c$export$a7db06668cad9adb = v);
$parcel$export($71ab248f0fe6d17c$exports, "popoverButton", () => $71ab248f0fe6d17c$export$98a1f56f3690a316, (v) => $71ab248f0fe6d17c$export$98a1f56f3690a316 = v);
$parcel$export($71ab248f0fe6d17c$exports, "speedIcon", () => $71ab248f0fe6d17c$export$bf22c319fb022e3c, (v) => $71ab248f0fe6d17c$export$bf22c319fb022e3c = v);
var $71ab248f0fe6d17c$export$899efff2d0433d49;
var $71ab248f0fe6d17c$export$a7db06668cad9adb;
var $71ab248f0fe6d17c$export$98a1f56f3690a316;
var $71ab248f0fe6d17c$export$bf22c319fb022e3c;
$71ab248f0fe6d17c$export$899efff2d0433d49 = "popover_0bdf41";
$71ab248f0fe6d17c$export$a7db06668cad9adb = "content_0bdf41";
$71ab248f0fe6d17c$export$98a1f56f3690a316 = "popoverButton_0bdf41";
$71ab248f0fe6d17c$export$bf22c319fb022e3c = "speedIcon_0bdf41";



var $hH60s = parcelRequire("hH60s");

var $jMaZ8 = parcelRequire("jMaZ8");
// This icon file is generated automatically.
var $0ce9dea30bf5895e$var$FieldTimeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7a321 321 0 01-44.5 55.7 317.17 317.17 0 01-101.3 68.3c-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3a321 321 0 0144.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8a9.18 9.18 0 00-8.2-13.3z"
                }
            }
        ]
    },
    "name": "field-time",
    "theme": "outlined"
};
var $0ce9dea30bf5895e$export$2e2bcd8739ae039 = $0ce9dea30bf5895e$var$FieldTimeOutlined;



var $5ee1b4965ffdde1c$var$FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
    return /*#__PURE__*/ $jMaZ8.createElement((0, $21cff4a9cafa1819$export$2e2bcd8739ae039), (0, $hH60s.default)({}, props, {
        ref: ref,
        icon: (0, $0ce9dea30bf5895e$export$2e2bcd8739ae039)
    }));
};
/**![field-time](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik05NDUgNDEySDY4OWMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgyNTZjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LTh6TTgxMSA1NDhINjg5Yy00LjQgMC04IDMuNi04IDh2NDhjMCA0LjQgMy42IDggOCA4aDEyMmM0LjQgMCA4LTMuNiA4LTh2LTQ4YzAtNC40LTMuNi04LTgtOHpNNDc3LjMgMzIyLjVINDM0Yy02LjIgMC0xMS4yIDUtMTEuMiAxMS4ydjI0OGMwIDMuNiAxLjcgNi45IDQuNiA5bDE0OC45IDEwOC42YzUgMy42IDEyIDIuNiAxNS42LTIuNGwyNS43LTM1LjF2LS4xYzMuNi01IDIuNS0xMi0yLjUtMTUuNmwtMTI2LjctOTEuNlYzMzMuN2MuMS02LjItNS0xMS4yLTExLjEtMTEuMnoiIC8+PHBhdGggZD0iTTgwNC44IDY3My45SDc0N2MtNS42IDAtMTAuOSAyLjktMTMuOSA3LjdhMzIxIDMyMSAwIDAxLTQ0LjUgNTUuNyAzMTcuMTcgMzE3LjE3IDAgMDEtMTAxLjMgNjguM2MtMzkuMyAxNi42LTgxIDI1LTEyNCAyNS00My4xIDAtODQuOC04LjQtMTI0LTI1LTM3LjktMTYtNzItMzktMTAxLjMtNjguM3MtNTIuMy02My40LTY4LjMtMTAxLjNjLTE2LjYtMzkuMi0yNS04MC45LTI1LTEyNCAwLTQzLjEgOC40LTg0LjcgMjUtMTI0IDE2LTM3LjkgMzktNzIgNjguMy0xMDEuMyAyOS4zLTI5LjMgNjMuNC01Mi4zIDEwMS4zLTY4LjMgMzkuMi0xNi42IDgxLTI1IDEyNC0yNSA0My4xIDAgODQuOCA4LjQgMTI0IDI1IDM3LjkgMTYgNzIgMzkgMTAxLjMgNjguM2EzMjEgMzIxIDAgMDE0NC41IDU1LjdjMyA0LjggOC4zIDcuNyAxMy45IDcuN2g1Ny44YzYuOSAwIDExLjMtNy4yIDguMi0xMy4zLTY1LjItMTI5LjctMTk3LjQtMjE0LTM0NS0yMTUuNy0yMTYuMS0yLjctMzk1LjYgMTc0LjItMzk2IDM5MC4xQzcxLjYgNzI3LjUgMjQ2LjkgOTAzIDQ2My4yIDkwM2MxNDkuNSAwIDI4My45LTg0LjYgMzQ5LjgtMjE1LjhhOS4xOCA5LjE4IDAgMDAtOC4yLTEzLjN6IiAvPjwvc3ZnPg==) */ var $5ee1b4965ffdde1c$var$RefIcon = /*#__PURE__*/ $jMaZ8.forwardRef($5ee1b4965ffdde1c$var$FieldTimeOutlined);
$5ee1b4965ffdde1c$var$RefIcon.displayName = 'FieldTimeOutlined';
var $5ee1b4965ffdde1c$export$2e2bcd8739ae039 = $5ee1b4965ffdde1c$var$RefIcon;




const $ea6e9b5215020695$var$markStyle = {
    marginTop: "4px"
};
const $ea6e9b5215020695$var$SpeedControls = ({ className: className })=>{
    const { state: { speed: speed }, dispatch: dispatch } = (0, $d1aae9a57a309882$export$f0db995d9f98de3d)();
    const onChange = (0, $jMaZ8.useCallback)((value)=>{
        dispatch({
            type: "SPEED_CHANGED",
            value: value
        });
    }, [
        dispatch
    ]);
    const marks = (0, $jMaZ8.useMemo)(()=>{
        const _marks = {};
        (0, $dca027b4f5b04797$export$d6d635b5aefba05b).forEach((mark)=>{
            _marks[mark] = {
                style: $ea6e9b5215020695$var$markStyle,
                label: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("strong", {
                    children: mark
                })
            };
        });
        return _marks;
    }, []);
    const Content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($71ab248f0fe6d17c$exports))).content,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $bb290b37c61d241a$export$2e2bcd8739ae039), {
            value: speed * 100 / 100,
            onChange: onChange,
            min: (0, $dca027b4f5b04797$export$61d78128ec09fe9e)[0],
            max: (0, $dca027b4f5b04797$export$61d78128ec09fe9e)[1],
            step: (0, $dca027b4f5b04797$export$c58c626e1f1c956f),
            tooltip: {
                open: false
            },
            marks: marks,
            included: false,
            trackStyle: {
                backgroundColor: "transparent"
            }
        })
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $c5aa6d63acebb2d0$export$2e2bcd8739ae039), {
        content: Content,
        trigger: "hover",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($71ab248f0fe6d17c$exports))).popover,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((0, (/*@__PURE__*/$parcel$interopDefault($71ab248f0fe6d17c$exports))).popoverButton, className),
            children: [
                /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5ee1b4965ffdde1c$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($71ab248f0fe6d17c$exports))).speedIcon
                }),
                speed !== 1 && ` ${speed}`
            ]
        })
    });
};
var $ea6e9b5215020695$export$2e2bcd8739ae039 = $ea6e9b5215020695$var$SpeedControls;


function $e08dc24cba3b9699$export$2e2bcd8739ae039({ previousPage: previousPage, nextPage: nextPage, audioElement: audioElement }) {
    const audioPlayerMachine = (0, $61adf8e840ec0489$export$2e2bcd8739ae039)();
    const { send: send, togglePlay: togglePlay, isLoadingRessources: isLoading, isPaused: isMachinePaused, isInitializing: isInitializing } = audioPlayerMachine;
    // Speed
    const { state: { speed: speed } } = (0, $d1aae9a57a309882$export$f0db995d9f98de3d)();
    const handleMachineRateChange = (0, $jMaZ8.useCallback)(()=>{
        send({
            type: "Handle Playback Rate Change"
        });
    }, [
        send
    ]);
    (0, $58a5df70f3e19767$export$2e2bcd8739ae039)(audioElement, speed, handleMachineRateChange);
    // Button comp
    const buttonContent = (0, $jMaZ8.useMemo)(()=>{
        if (isLoading) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {});
        return isMachinePaused === false ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $01a009a0bdcfd97e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $271ab9cb7ddc7c14$export$2e2bcd8739ae039), {});
    }, [
        isLoading,
        isMachinePaused
    ]);
    if (isInitializing) return null;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $5c2d3cdd96b7835a$export$f16b8a82b5b3b0df,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                className: $5c2d3cdd96b7835a$export$b3f5e57879cbdea7,
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ea6e9b5215020695$export$2e2bcd8739ae039), {
                    className: $5c2d3cdd96b7835a$export$b0d8a4ba496e2be
                })
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
                className: $5c2d3cdd96b7835a$export$6562daabb7d75820,
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !previousPage.canNavigate,
                        onClick: previousPage.navigate,
                        type: "primary",
                        shape: "circle",
                        icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d4dfb236e126b509$export$2e2bcd8739ae039), {}),
                        className: $5c2d3cdd96b7835a$export$1f7a5d2e5a3de51f
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: isLoading,
                        shape: "round",
                        className: $5c2d3cdd96b7835a$export$896c3927874d3a3f,
                        onClick: togglePlay,
                        children: buttonContent
                    }),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                        disabled: !nextPage.canNavigate,
                        onClick: nextPage.navigate,
                        type: "primary",
                        shape: "circle",
                        icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $467563d24654b2cc$export$2e2bcd8739ae039), {}),
                        className: $5c2d3cdd96b7835a$export$1f7a5d2e5a3de51f
                    })
                ]
            })
        ]
    });
}







const $ef40bdcc03ab4b52$var$alertDataHasChanged = (0, (/*@__PURE__*/$parcel$interopDefault($62LIg))).throttle((message)=>{
    (0, $f3ffaa2f307cbe47$export$2e2bcd8739ae039).info({
        message: message
    });
}, 10000, {
    leading: true,
    trailing: false
});
function $ef40bdcc03ab4b52$export$2e2bcd8739ae039({ bookInfoFromUrl: bookInfoFromUrl, currentPageId: currentPageId, title: title, scrollRef: scrollRef, maybeAddAudioReview: maybeAddAudioReview, pageMetadata: pageMetadata, allPages: allPages }) {
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    const fullyRecorded = (0, $jMaZ8.useMemo)(()=>{
        return pageMetadata.rhese.every((r)=>!!r.data.audioRecording);
    }, [
        pageMetadata
    ]);
    const isAdmin = (0, $dc10a25720c6edc8$export$99a5e4bc80d231ca)();
    const groupedRheses = (0, $jMaZ8.useMemo)(()=>{
        const map = new Map(pageMetadata.paragraph.map((p)=>[
                p.data.id,
                p
            ]));
        return Array.from(map.values()).map((p)=>{
            return {
                paragraphId: p.data.id,
                rheses: pageMetadata.rhese.filter((r)=>r.anchors[0].utf16Start >= p.anchors[0].utf16Start && r.anchors[0].utf16Start + r.anchors[0].utf16Size <= p.anchors[0].utf16Start + p.anchors[0].utf16Size)
            };
        });
    }, [
        pageMetadata.paragraph,
        pageMetadata.rhese
    ]);
    /**
   * Nav
   */ const { nav: nav } = (0, $fdbf17c07662ad3d$export$2e2bcd8739ae039)(currentPageId, bookInfoFromUrl, allPages);
    /**
   * Requests
   */ const [deleteAudioReviews] = (0, $861562afdbad1429$export$1628ef81009f7ccf)();
    const [selectedRheses, select, selectionAnchor] = (0, $32e8535e3fa895fd$export$71ce45fad9494338)(pageMetadata.rhese || null);
    /**
   * Selection Logic
   */ const resetSelection = (0, $jMaZ8.useCallback)(()=>{
        select(undefined);
    }, [
        select
    ]);
    const resetSelectionStatus = (0, $jMaZ8.useCallback)(async ()=>{
        try {
            const rheseIds = selectedRheses.map((r)=>r.data.id);
            await deleteAudioReviews({
                variables: {
                    rheseIds: rheseIds,
                    projectId: bookInfoFromUrl.bookId
                }
            });
            resetSelection();
        } catch (e) {
            console.error("resetSelectionStatus error: ", e);
        }
    }, [
        selectedRheses,
        deleteAudioReviews,
        bookInfoFromUrl.bookId,
        resetSelection
    ]);
    const audioRecordings = (0, $jMaZ8.useMemo)(()=>{
        return pageMetadata.rhese.map((r)=>r.data.audioRecording).filter((o)=>!!o);
    }, [
        pageMetadata
    ]);
    const machine = (0, $61adf8e840ec0489$export$2e2bcd8739ae039)();
    (0, $jMaZ8.useEffect)(()=>{
        if (machine.state.context.successfulyPlayedRhese) maybeAddAudioReview(machine.state.context.successfulyPlayedRhese);
    }, [
        machine.state.context.successfulyPlayedRhese
    ]);
    const [audioElement] = (0, $jMaZ8.useState)(new Audio());
    const audioInfo = pageMetadata.rhese.filter((r)=>!!r.data.audioRecording?.fileUuid).map((v)=>v.data.audioInfo).filter((v)=>v !== null).map(({ start: start, end: end, humanEnd: humanEnd, humanStart: humanStart })=>({
            start: start,
            end: end,
            humanEnd: humanEnd,
            humanStart: humanStart
        }));
    const previousAudioInfo = (0, $7ff84a88030acb67$export$5cae361ad82dce8b)(audioInfo);
    const previousAudioRecodings = (0, $7ff84a88030acb67$export$5cae361ad82dce8b)(audioRecordings);
    // On mount: load resources
    const messageDataChanged = t("proofListeningDataChanged");
    (0, $jMaZ8.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($62LIg))).isEqual(previousAudioRecodings, audioRecordings) && (0, (/*@__PURE__*/$parcel$interopDefault($62LIg))).isEqual(audioInfo, previousAudioInfo)) return;
        machine.send([
            {
                type: "Reset",
                callback: ()=>{
                    const isPlaying = machine.state.matches("READY.PLAYING");
                    const isPaused = machine.state.matches("READY.PAUSED");
                    const pristine = !isPlaying && !isPaused;
                    if (!pristine) $ef40bdcc03ab4b52$var$alertDataHasChanged(messageDataChanged);
                }
            },
            {
                type: "Load Resources",
                audioRecordings: audioRecordings,
                rhesesWithPos: pageMetadata.rhese.filter((r)=>!!r.data.audioRecording?.fileUuid),
                audioElement: audioElement
            }
        ]);
        return ()=>{};
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        previousAudioRecodings,
        audioRecordings
    ]);
    // "On load more" effect (pagination)
    (0, $jMaZ8.useEffect)(()=>{
        machine.send({
            type: "On Load More",
            audioRecordings: audioRecordings,
            rhesesWithPos: pageMetadata.rhese.filter((r)=>!!r.data.audioRecording?.fileUuid)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        groupedRheses.flat().length
    ]);
    if (!fullyRecorded && !isAdmin) throw new Error("Cannot load proof listening if some audio is missing");
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        className: $5c2d3cdd96b7835a$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                children: [
                    !fullyRecorded && isAdmin && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $3b184c50062b0fa2$export$2e2bcd8739ae039), {
                        showIcon: true,
                        type: "warning",
                        message: t("proofListening.pageOnlyAccessibleToAdmin"),
                        style: {
                            marginBottom: "1em"
                        }
                    }),
                    title,
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($221fa0e9c5426c27$exports))), {
                        useWindow: false,
                        getScrollParent: ()=>scrollRef?.current,
                        pageStart: 0,
                        loadMore: ()=>{},
                        hasMore: false,
                        loader: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                            style: {
                                marginTop: "-70px",
                                marginBottom: "120px"
                            },
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                                small: true
                            })
                        }, 0),
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $2b82b64551ddcb76$export$2e2bcd8739ae039), {
                            groupedRheses: groupedRheses,
                            selectedRheses: selectedRheses,
                            selectionAnchor: selectionAnchor,
                            setSelectedRhese: select,
                            resetSelection: ()=>select(undefined),
                            resetSelectionStatus: resetSelectionStatus,
                            currentRheseId: machine.currentRheseId,
                            isPlaying: machine.isPlaying,
                            isWaiting: machine.isWaiting,
                            projectId: bookInfoFromUrl.bookId,
                            pageMetadata: pageMetadata
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $d1aae9a57a309882$export$78236ac4690545dc), {
                children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e08dc24cba3b9699$export$2e2bcd8739ae039), {
                    previousPage: nav.prev,
                    nextPage: nav.next,
                    audioElement: audioElement
                })
            })
        ]
    });
}



function $0a37c8b9240afa12$export$2e2bcd8739ae039({ bookInfoFromUrl: bookInfoFromUrl, currentPageId: currentPageId, title: title, scrollRef: scrollRef, allPages: allPages, pageMetadata: pageMetadata }) {
    /**
   * Handlers
   */ const [addAudioReview] = (0, $861562afdbad1429$export$2eb58638a4193c9b)();
    const maybeAddAudioReview = (0, $jMaZ8.useCallback)((rheseId)=>{
        const hasReview = pageMetadata.rhese.find((r)=>r.data.id === rheseId)?.data.audioInfo?.status;
        const skipAutomaticReview = !!hasReview;
        if (skipAutomaticReview) return;
        addAudioReview({
            variables: {
                projectId: bookInfoFromUrl.bookId,
                rheseId: rheseId,
                status: (0, $b522cf181e75e62d$export$221b784fada1dd4a).VALID
            }
        });
    }, [
        addAudioReview,
        bookInfoFromUrl.bookId,
        pageMetadata?.rhese
    ]);
    /**
   * Loading state
   */ return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $007e357d1699952e$export$2e2bcd8739ae039), {
        children: !!pageMetadata && /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ef40bdcc03ab4b52$export$2e2bcd8739ae039), {
            title: title,
            scrollRef: scrollRef,
            bookInfoFromUrl: bookInfoFromUrl,
            currentPageId: currentPageId,
            maybeAddAudioReview: maybeAddAudioReview,
            allPages: allPages,
            pageMetadata: pageMetadata
        })
    });
}






const $ba4d7dfd7de06c03$var$ProofListenerContent = ({ currentPageId: currentPageId, bookId: bookId, bookInfoFromUrl: bookInfoFromUrl, scrollRef: scrollRef, pages: pages, selectedRole: selectedRole, title: title, goBack: goBack })=>{
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    // @ts-ignore
    const { extendedPage: pageMetadata } = (0, $f9ad6d9d9a78d084$export$9c25024bdfe755f7)();
    const isAdmin = (0, $dc10a25720c6edc8$export$99a5e4bc80d231ca)();
    const fullyRecorded = (0, $jMaZ8.useMemo)(()=>{
        return pageMetadata?.rhese.every((r)=>!!r.data.audioRecording);
    }, [
        pageMetadata
    ]);
    if (!fullyRecorded && !isAdmin) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $44590071a26e5872$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4a1bb561fc98ba0c$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $54e16f52b3ebe339$export$2e2bcd8739ae039), {}),
            title: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("p", {
                children: t("proofListening.pageNotFullyRecordedTitle")
            }),
            extra: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $db1677af4d8cff50$export$2e2bcd8739ae039), {
                onClick: goBack,
                children: t("proofListening.pageNotFullyRecordedButtonLabel")
            })
        })
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $727abf2d5c541723$export$72f9ca7a3ec3fbb1), {
                pageId: currentPageId,
                projectId: bookId,
                selectedRole: selectedRole,
                pageMetadata: pageMetadata
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $0a37c8b9240afa12$export$2e2bcd8739ae039), {
                bookInfoFromUrl: bookInfoFromUrl,
                currentPageId: currentPageId,
                title: title,
                scrollRef: scrollRef,
                allPages: pages,
                pageMetadata: pageMetadata
            }, bookInfoFromUrl.currentPage)
        ]
    });
};
var $ba4d7dfd7de06c03$export$2e2bcd8739ae039 = $ba4d7dfd7de06c03$var$ProofListenerContent;



const $9dc35701287406a2$var$Wrapper = ({ content: content, scrollRef: scrollRef })=>{
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        className: $0a79a9616af44e21$export$b2c1506c6ba891d6,
        ref: scrollRef,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
            children: content
        })
    });
};
const $9dc35701287406a2$var$audioUrlPattern = /^\/audio\/library\/edit\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/(\d+)$/;
const $9dc35701287406a2$export$4ddd8ce88eb81634 = ()=>{
    const { bookId: bookId, page: currentPage } = (0, $5c84a101a4932c49$export$99eaa27ddbbb95ef)();
    const location = (0, $5c84a101a4932c49$export$45d76561a5302f2b)();
    const { state: selectedRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    const isNarrator = selectedRole === (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Narrator;
    const isProofListener = selectedRole === (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).ProofListener;
    const isAdmin = (0, $dc10a25720c6edc8$export$99a5e4bc80d231ca)();
    const [t] = (0, $19ed0b6abada9941$export$3f3caade1c12f8c9)();
    if (!bookId || !currentPage) throw new Error("bookId and page parameters are mandatory");
    const bookInfoFromUrl = {
        bookId: bookId,
        currentPage: currentPage
    };
    const { project: project, pages: pages, bookLoading: bookLoading, pagesLoading: pagesLoading } = (0, $5b38bec19e3a4e47$export$51b1383ef8844a7)({
        projectId: bookId,
        withPages: true,
        withInfo: true,
        withAudioInfo: location.pathname.match($9dc35701287406a2$var$audioUrlPattern) !== null
    });
    const currentPageId = (0, $jMaZ8.useMemo)(()=>pages.find((page)=>page.pageNumber === Number(currentPage))?.id, [
        pages,
        currentPage
    ]);
    const page = (0, $jMaZ8.useMemo)(()=>pages.find((page)=>page.pageNumber === Number(currentPage)), [
        pages,
        currentPage
    ]);
    const { goBack: goBack } = (0, $fdbf17c07662ad3d$export$2e2bcd8739ae039)(currentPageId || undefined, bookInfoFromUrl, pages);
    const scrollRef = (0, $jMaZ8.useRef)(null); // Needed for the pagination's load-more
    const isLoading = bookLoading || pagesLoading;
    const hasData = !(currentPageId === null) && project && pages;
    const noResult = pages.length === 0;
    const isInReSync = project?.isDoingAudioResync;
    if (isLoading && !hasData) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
        grow: true
    });
    if (noResult) return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $4a1bb561fc98ba0c$export$2e2bcd8739ae039), {});
    const title = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("h1", {
        children: t("rheses")
    });
    let content = null;
    if (hasData && isNarrator) content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $252746cd6583956c$export$2e2bcd8739ae039), {
        currentPageId: currentPageId,
        bookId: bookId,
        bookInfoFromUrl: bookInfoFromUrl,
        scrollRef: scrollRef,
        pages: pages,
        selectedRole: selectedRole,
        title: title
    });
    else if (hasData && (isProofListener || isAdmin)) content = /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $ba4d7dfd7de06c03$export$2e2bcd8739ae039), {
        currentPageId: currentPageId,
        bookId: bookId,
        bookInfoFromUrl: bookInfoFromUrl,
        scrollRef: scrollRef,
        pages: pages,
        selectedRole: selectedRole,
        title: title,
        goBack: goBack
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $954e0e3ebeee9f2b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $e8331f7a0c96cb57$export$2e2bcd8739ae039), {
                bookInfoFromUrl: bookInfoFromUrl,
                book: project,
                loading: !hasData,
                page: page || null,
                allPages: pages
            }),
            hasData && page ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5b38bec19e3a4e47$export$477397cba250e9af), {
                value: {
                    project: project,
                    pages: pages
                },
                children: isInReSync ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $74369faf6b911a8d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $f9ad6d9d9a78d084$export$3dd58bf9bf579bba), {
                        pageId: page?.id,
                        projectId: project?.id,
                        page: page,
                        props: {
                            scrollRef: scrollRef,
                            content: content || /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $954e0e3ebeee9f2b$exports.Fragment), {})
                        },
                        component: $9dc35701287406a2$var$Wrapper
                    })
                })
            }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $421913d54e9e15b2$export$7f7cbe89f1eacd2), {
                grow: true
            })
        ]
    });
};
const $9dc35701287406a2$export$7eefade6254200ed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).memo($9dc35701287406a2$export$4ddd8ce88eb81634);




parcelRequire("jMaZ8");

var $giSak = parcelRequire("giSak");

var $15aede84e13439e8$exports = {};

$parcel$export($15aede84e13439e8$exports, "container", () => $15aede84e13439e8$export$34e0f9847d4c02dd, (v) => $15aede84e13439e8$export$34e0f9847d4c02dd = v);
$parcel$export($15aede84e13439e8$exports, "development", () => $15aede84e13439e8$export$7f52bbed0c1a13ff, (v) => $15aede84e13439e8$export$7f52bbed0c1a13ff = v);
$parcel$export($15aede84e13439e8$exports, "test", () => $15aede84e13439e8$export$e0969da9b8fb378d, (v) => $15aede84e13439e8$export$e0969da9b8fb378d = v);
var $15aede84e13439e8$export$34e0f9847d4c02dd;
var $15aede84e13439e8$export$7f52bbed0c1a13ff;
var $15aede84e13439e8$export$e0969da9b8fb378d;
$15aede84e13439e8$export$34e0f9847d4c02dd = "container_763b4f";
$15aede84e13439e8$export$7f52bbed0c1a13ff = "development_763b4f";
$15aede84e13439e8$export$e0969da9b8fb378d = "test_763b4f";


/**
 * Display a banner onl on TEDEVELOPMENTST and TEST env
 */ var $b985f7c67fdd56a2$var$EnvEnum = /*#__PURE__*/ function($b985f7c67fdd56a2$var$EnvEnum) {
    $b985f7c67fdd56a2$var$EnvEnum["DEVELOPMENT"] = "DEVELOPMENT";
    $b985f7c67fdd56a2$var$EnvEnum["TEST"] = "TEST";
    $b985f7c67fdd56a2$var$EnvEnum["PRODUCTION"] = "PRODUCTION";
    return $b985f7c67fdd56a2$var$EnvEnum;
}($b985f7c67fdd56a2$var$EnvEnum || {});
const $b985f7c67fdd56a2$export$d83c88e8fa34151c = "TEST";
const $b985f7c67fdd56a2$var$SHOW_ENV_BANNER = true;
function $b985f7c67fdd56a2$export$2e2bcd8739ae039() {
    if ($b985f7c67fdd56a2$export$d83c88e8fa34151c === "PRODUCTION" || !$b985f7c67fdd56a2$var$SHOW_ENV_BANNER) return null;
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b4ff9094bcb218d9$export$2e2bcd8739ae039), {
        placement: "right",
        title: $b985f7c67fdd56a2$export$d83c88e8fa34151c,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($giSak)))((0, (/*@__PURE__*/$parcel$interopDefault($15aede84e13439e8$exports))).container, (0, (/*@__PURE__*/$parcel$interopDefault($15aede84e13439e8$exports)))[$b985f7c67fdd56a2$export$d83c88e8fa34151c.toLowerCase()])
        })
    });
}




const $59a312a0f31003ae$export$388e0302ca0d9a41 = (0, $9fef5c4d3453c190$export$2e2bcd8739ae039)((0, $b5c1938aaa3155db$export$7dc0a3a835d48dae));
const $59a312a0f31003ae$var$RoutesWithRole = ()=>{
    const roleReducer = (0, $dc10a25720c6edc8$export$3f70b501c7cbbe80)();
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $dc10a25720c6edc8$export$d0f896e57fc7ea90), {
        value: roleReducer,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($59a312a0f31003ae$var$ProtectedRoutes, {})
    });
};
const $59a312a0f31003ae$var$ProtectedRoutes = ()=>{
    const { state: selectedRole } = (0, $dc10a25720c6edc8$export$3e35f158de1d4201)();
    (0, $dc10a25720c6edc8$export$8400415b0da2579)(selectedRole);
    const redirectTo = selectedRole === (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Editor ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$444b3ab0cb9aec40), {
        to: "/editor/library",
        replace: true
    }) : selectedRole === (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).Narrator || selectedRole === (0, $dc10a25720c6edc8$export$2b6a455aeb488ed6).ProofListener ? /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$444b3ab0cb9aec40), {
        to: "/audio/library",
        replace: true
    }) : /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$444b3ab0cb9aec40), {
        to: "/error",
        replace: true
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $5c84a101a4932c49$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$e7b0ac011bb776c6), {
                path: "/",
                element: redirectTo
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$e7b0ac011bb776c6), {
                path: "/editor/books/edit/:bookId/*",
                Component: (0, $de3c5dab5cbf9179$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$e7b0ac011bb776c6), {
                path: "/editor/library",
                Component: (0, $1fb40d341a46cac4$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$e7b0ac011bb776c6), {
                path: "/audio/library",
                Component: (0, $b66d17011c8d0dbf$export$e67d647a98e917a3)
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$e7b0ac011bb776c6), {
                path: "/audio/library/edit/:bookId/:page/*",
                Component: (0, $9dc35701287406a2$export$7eefade6254200ed)
            }),
            /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $5c84a101a4932c49$export$e7b0ac011bb776c6), {
                path: "/error",
                element: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
                    children: "Error"
                })
            })
        ]
    });
};
const $59a312a0f31003ae$var$EntryPoint = ()=>{
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($jMaZ8))).useState("waiting");
    if (status === "waiting") return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex"
        },
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $74b43854045dae71$export$9370f0117bf9debc), {
            siteKey: "0x4AAAAAABiVUA9NPprspHV-",
            onError: ()=>setStatus("error"),
            onExpire: ()=>setStatus("expired"),
            onSuccess: ()=>setStatus("solved")
        })
    });
    if (status === "error" || status === "expired") return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)("div", {
        children: "Error loading the application. Please try again later."
    });
    console.log({
        status: status
    });
    return /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a89d690244472cec$export$c16b04c8a9956446), {
        client: $59a312a0f31003ae$export$388e0302ca0d9a41,
        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $54720e62f7bfcab9$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsxs)((0, $cf928c204584b9b8$export$2e2bcd8739ae039), {
                theme: (0, $eee5699dd95ae9ac$export$e7937c04a326b18a),
                children: [
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b985f7c67fdd56a2$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $a3bb6174129512e9$export$2e2bcd8739ae039), {
                        style: {
                            height: "100vh"
                        },
                        children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)((0, $b5c1938aaa3155db$export$dc3279e47fe4b31c), {
                            children: /*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($59a312a0f31003ae$var$RoutesWithRole, {})
                        })
                    })
                ]
            })
        })
    });
};
const $59a312a0f31003ae$var$mount = ()=>(0, $d5c94297b9de8dd4$export$882461b6382ed46c)(document.getElementById("app")).render(/*#__PURE__*/ (0, $954e0e3ebeee9f2b$exports.jsx)($59a312a0f31003ae$var$EntryPoint, {}));
if (document.readyState === "complete") $59a312a0f31003ae$var$mount();
else window.addEventListener("load", $59a312a0f31003ae$var$mount, {
    once: true
});


//# sourceMappingURL=index.2da373d9.js.map
